import "./maplibre-gl-worker.e684a0d5.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9cd2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9cd2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $dca0ddb82b882518$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(559));
    }
}
var $dca0ddb82b882518$var$searchTarget = null, $dca0ddb82b882518$var$searchBoundary = null;
function $dca0ddb82b882518$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($dca0ddb82b882518$var$searchTarget = child, !0) : !1;
}
function $dca0ddb82b882518$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($dca0ddb82b882518$var$searchBoundary = child, !1) : child === target ? (null !== $dca0ddb82b882518$var$searchBoundary && ($dca0ddb82b882518$var$searchTarget = child), !0) : !1;
}
function $dca0ddb82b882518$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($dca0ddb82b882518$var$HostTransitionContext._currentValue = stateHook.memoizedState, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber));
    stateHook = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalLoadPendingKey = "__reactLoad$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
function $dca0ddb82b882518$var$clearPendingLoadOnNode(node) {
    node[$dca0ddb82b882518$var$internalLoadPendingKey] = void 0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
function $dca0ddb82b882518$var$pushMutationContext() {
    var prev = $dca0ddb82b882518$var$viewTransitionMutationContext;
    $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
    return prev;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(element.value)) : $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName), $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$SubmitEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    submitter: 0
}), $dca0ddb82b882518$var$SyntheticSubmitEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$SubmitEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_474) {
            var $dca0ddb82b882518$var$element$jscomp$inline_475 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_475.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = $dca0ddb82b882518$var$isSupported$jscomp$inline_474;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$globalClientIdCounter$1 = 0;
function $dca0ddb82b882518$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $dca0ddb82b882518$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $dca0ddb82b882518$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $dca0ddb82b882518$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $dca0ddb82b882518$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $dca0ddb82b882518$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $dca0ddb82b882518$var$getClassNameByType(defaultClass);
    eventClass = $dca0ddb82b882518$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $dca0ddb82b882518$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE:
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $dca0ddb82b882518$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $dca0ddb82b882518$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $dca0ddb82b882518$var$entangledTransitionTypes = null;
function $dca0ddb82b882518$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && ($dca0ddb82b882518$var$entangledTransitionTypes = null, null !== $dca0ddb82b882518$var$currentEntangledListeners)) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    if (null !== $dca0ddb82b882518$var$entangledTransitionTypes) for(var root$28 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$28;)$dca0ddb82b882518$var$queueTransitionTypes(root$28, $dca0ddb82b882518$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$29;)$dca0ddb82b882518$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $dca0ddb82b882518$var$currentEntangledLane) {
            root$29 = $dca0ddb82b882518$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $dca0ddb82b882518$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $dca0ddb82b882518$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushSuspenseListContext(fiber, newContext) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newContext);
}
function $dca0ddb82b882518$var$popSuspenseListContext(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
}
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && 0 !== ($dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1);
    $dca0ddb82b882518$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$70);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 106) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$73 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$73, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffectEvent: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack());
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            if (null === $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) {
                nextProps = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
                $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $dca0ddb82b882518$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $dca0ddb82b882518$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER;
        return $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
    }
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($dca0ddb82b882518$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $dca0ddb82b882518$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($dca0ddb82b882518$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $dca0ddb82b882518$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
        $dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(suspenseInstance.nextSibling);
    $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
    $dca0ddb82b882518$var$isHydrating = !0;
    $dca0ddb82b882518$var$hydrationErrors = null;
    $dca0ddb82b882518$var$rootOrSingletonContext = !1;
    null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $dca0ddb82b882518$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($dca0ddb82b882518$var$reverseChildren(current), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $dca0ddb82b882518$var$reverseChildren(current)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $dca0ddb82b882518$var$reverseChildren(workInProgress));
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $dca0ddb82b882518$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (workInProgress.stateNode = $dca0ddb82b882518$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $dca0ddb82b882518$var$maySuspendCommit(type, newProps) : $dca0ddb82b882518$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $dca0ddb82b882518$var$now();
                current.sibling = null;
                nextResource = $dca0ddb82b882518$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, workInProgress), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, renderLanes), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = workInProgress));
                $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $dca0ddb82b882518$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $dca0ddb82b882518$var$FragmentInstance(current);
                        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $dca0ddb82b882518$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $dca0ddb82b882518$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1)), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$shouldStartViewTransition = !1, $dca0ddb82b882518$var$appearingViewTransitions = null;
function $dca0ddb82b882518$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $dca0ddb82b882518$var$shouldStartViewTransition = !0;
}
var $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
function $dca0ddb82b882518$var$pushViewTransitionCancelableScope() {
    var prevChildren = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
    $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
function $dca0ddb82b882518$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
    return $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $dca0ddb82b882518$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $dca0ddb82b882518$var$measureInstance(instance).view && (inViewport = !0);
            $dca0ddb82b882518$var$shouldStartViewTransition = !0;
            $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? name : name + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $dca0ddb82b882518$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
}
function $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $dca0ddb82b882518$var$appearingViewTransitions && 0 !== $dca0ddb82b882518$var$appearingViewTransitions.size) {
        var pairs = $dca0ddb82b882518$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $dca0ddb82b882518$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $dca0ddb82b882518$var$appearingViewTransitions ? $dca0ddb82b882518$var$appearingViewTransitions.get(name) : void 0, className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$appearingViewTransitions.delete(name), $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onExit) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$dca0ddb82b882518$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
}
function $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, changedParent.stateNode);
            props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $dca0ddb82b882518$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $dca0ddb82b882518$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
}
function $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $dca0ddb82b882518$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$dca0ddb82b882518$var$viewTransitionHostInstanceIdx], nextMeasurement = $dca0ddb82b882518$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $dca0ddb82b882518$var$viewTransitionCancelableChildren && ($dca0ddb82b882518$var$viewTransitionCancelableChildren = []), $dca0ddb82b882518$var$viewTransitionCancelableChildren.push(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($dca0ddb82b882518$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
            name = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$viewTransitionContextChanged = !1, $dca0ddb82b882518$var$inUpdateViewTransition = !1, $dca0ddb82b882518$var$rootViewTransitionAffected = !1, $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $dca0ddb82b882518$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $dca0ddb82b882518$var$nextEffect;){
        root = $dca0ddb82b882518$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $dca0ddb82b882518$var$nextEffect = JSCompiler_temp) : (committedLanes && $dca0ddb82b882518$var$commitNestedViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $dca0ddb82b882518$var$appearingViewTransitions = null;
}
function $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $dca0ddb82b882518$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $dca0ddb82b882518$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $dca0ddb82b882518$var$nextEffect = current;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = fiber.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                current = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = current;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$dca0ddb82b882518$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($dca0ddb82b882518$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $dca0ddb82b882518$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$dca0ddb82b882518$var$internalHoistableMarker] || current[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                            $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                    $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(root, ""), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            $dca0ddb82b882518$var$tagCaches = null;
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            current = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext && $dca0ddb82b882518$var$inUpdateViewTransition && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionMutationContext = current;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, lanes = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, current = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, $dca0ddb82b882518$var$offscreenSubtreeIsHidden = ii || $dca0ddb82b882518$var$offscreenSubtreeIsHidden, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = root, $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $dca0ddb82b882518$var$offscreenSubtreeIsHidden = lanes, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = current), !ii && $dca0ddb82b882518$var$offscreenDirectParentIsHidden || $dca0ddb82b882518$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $dca0ddb82b882518$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $dca0ddb82b882518$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $dca0ddb82b882518$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $dca0ddb82b882518$var$inUpdateViewTransition = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($dca0ddb82b882518$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $dca0ddb82b882518$var$_enabled = !0, fiber.reset(), $dca0ddb82b882518$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $dca0ddb82b882518$var$measureNestedViewTransitions(parentFiber, !1);
}
function $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $dca0ddb82b882518$var$rootViewTransitionNameCanceled = $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$dca0ddb82b882518$var$viewTransitionContextChanged && !$dca0ddb82b882518$var$rootViewTransitionAffected) {
                finishedWork = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $dca0ddb82b882518$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !0;
            }
            $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1) : $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            oldName = $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $dca0ddb82b882518$var$getViewTransitionName(props, state);
            state = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, state);
            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0, root = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $dca0ddb82b882518$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($dca0ddb82b882518$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $dca0ddb82b882518$var$viewTransitionCancelableChildren), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName);
            $dca0ddb82b882518$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable($dca0ddb82b882518$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $dca0ddb82b882518$var$restoreNestedViewTransitions(parentFiber);
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $dca0ddb82b882518$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $dca0ddb82b882518$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(flags.child, !0), $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $dca0ddb82b882518$var$appearingViewTransitions && ($dca0ddb82b882518$var$appearingViewTransitions = new Map());
                $dca0ddb82b882518$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$pendingViewTransition = null, $dca0ddb82b882518$var$pendingViewTransitionEvents = null, $dca0ddb82b882518$var$pendingTransitionTypes = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $dca0ddb82b882518$var$createViewTransitionInstance($dca0ddb82b882518$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $dca0ddb82b882518$var$pendingViewTransitionEvents && ($dca0ddb82b882518$var$pendingViewTransitionEvents = []);
        $dca0ddb82b882518$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$completeRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        }, $dca0ddb82b882518$var$appearingViewTransitions = null, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $dca0ddb82b882518$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0, subtreeFlags = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($dca0ddb82b882518$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $dca0ddb82b882518$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$getEntangledLanes(root, lanes);
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $dca0ddb82b882518$var$hydrationParentFiber && ($dca0ddb82b882518$var$isHydrating ? ($dca0ddb82b882518$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($dca0ddb82b882518$var$nextHydratableInstance = fiber.stateNode)) : ($dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0));
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $dca0ddb82b882518$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($dca0ddb82b882518$var$pendingTransitionTypes = $dca0ddb82b882518$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($dca0ddb82b882518$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $dca0ddb82b882518$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $dca0ddb82b882518$var$ReactSharedInternals.T;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        updatedLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        try {
            $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $dca0ddb82b882518$var$executionContext = suspendedRetryLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = updatedLanes, $dca0ddb82b882518$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $dca0ddb82b882518$var$pendingEffectsStatus = 1;
    $dca0ddb82b882518$var$shouldStartViewTransition ? $dca0ddb82b882518$var$pendingViewTransition = $dca0ddb82b882518$var$startViewTransition(suspendedState, root.containerInfo, $dca0ddb82b882518$var$pendingTransitionTypes, $dca0ddb82b882518$var$flushMutationEffects, $dca0ddb82b882518$var$flushLayoutEffects, $dca0ddb82b882518$var$flushAfterMutationEffects, $dca0ddb82b882518$var$flushSpawnedWork, $dca0ddb82b882518$var$flushPassiveEffects, $dca0ddb82b882518$var$reportViewTransitionError, null, null) : ($dca0ddb82b882518$var$flushMutationEffects(), $dca0ddb82b882518$var$flushLayoutEffects(), $dca0ddb82b882518$var$flushSpawnedWork());
}
function $dca0ddb82b882518$var$reportViewTransitionError(error) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus) {
        var onRecoverableError = $dca0ddb82b882518$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $dca0ddb82b882518$var$flushAfterMutationEffects() {
    3 === $dca0ddb82b882518$var$pendingEffectsStatus && ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber($dca0ddb82b882518$var$pendingFinishedWork, $dca0ddb82b882518$var$pendingEffectsRoot), $dca0ddb82b882518$var$pendingEffectsStatus = 4);
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$inUpdateViewTransition = $dca0ddb82b882518$var$rootViewTransitionAffected = !1;
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $dca0ddb82b882518$var$selectionInformation;
                var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var committedViewTransition = $dca0ddb82b882518$var$pendingViewTransition;
        $dca0ddb82b882518$var$pendingViewTransition = null;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            passiveSubtreeMask = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $dca0ddb82b882518$var$pendingViewTransitionEvents;
        onRecoverableError = $dca0ddb82b882518$var$pendingTransitionTypes;
        $dca0ddb82b882518$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($dca0ddb82b882518$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null);
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    null !== $dca0ddb82b882518$var$pendingViewTransition && ($dca0ddb82b882518$var$pendingViewTransition.skipTransition(), $dca0ddb82b882518$var$pendingViewTransition = null);
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) ? $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$190, root$190 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL(actionProp);
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1667 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1667 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1667++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1668 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1667], $dca0ddb82b882518$var$domEventName$jscomp$inline_1669 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1668.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1669, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $dca0ddb82b882518$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $dca0ddb82b882518$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $dca0ddb82b882518$var$getParent) : null;
                        null !== reactName && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $dca0ddb82b882518$var$emptyProps = {};
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$dca0ddb82b882518$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$dca0ddb82b882518$var$internalPropsKey] = props;
    $dca0ddb82b882518$var$setInitialProperties(rootContainerInstance, type, props);
    $dca0ddb82b882518$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $dca0ddb82b882518$var$scheduleTimeout, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $dca0ddb82b882518$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $dca0ddb82b882518$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, instance);
}
function $dca0ddb82b882518$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $dca0ddb82b882518$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $dca0ddb82b882518$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $dca0ddb82b882518$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($dca0ddb82b882518$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $dca0ddb82b882518$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($dca0ddb82b882518$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $dca0ddb82b882518$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $dca0ddb82b882518$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $dca0ddb82b882518$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("old", name),
        new: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("new", name)
    };
}
function $dca0ddb82b882518$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $dca0ddb82b882518$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $dca0ddb82b882518$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $dca0ddb82b882518$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $dca0ddb82b882518$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $dca0ddb82b882518$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $dca0ddb82b882518$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $dca0ddb82b882518$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $dca0ddb82b882518$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $dca0ddb82b882518$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $dca0ddb82b882518$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber);
    return $dca0ddb82b882518$var$setFocusIfFocusable(fiber, focusOptions);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$dca0ddb82b882518$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $dca0ddb82b882518$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $dca0ddb82b882518$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$observeChild, observer, void 0, void 0);
};
function $dca0ddb82b882518$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $dca0ddb82b882518$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $dca0ddb82b882518$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $dca0ddb82b882518$var$pendingIntersectionUnobserves = [], $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
function $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $dca0ddb82b882518$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $dca0ddb82b882518$var$intersectionUnobserveScheduled || ($dca0ddb82b882518$var$intersectionUnobserveScheduled = !0, $dca0ddb82b882518$var$requestPostPaintCallback(function() {
        $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
        var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves;
        $dca0ddb82b882518$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $dca0ddb82b882518$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $dca0ddb82b882518$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[0]);
    result = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $dca0ddb82b882518$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchBoundary = $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $dca0ddb82b882518$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(566));
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
            $dca0ddb82b882518$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), $dca0ddb82b882518$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $dca0ddb82b882518$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $dca0ddb82b882518$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    $dca0ddb82b882518$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $dca0ddb82b882518$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $dca0ddb82b882518$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $dca0ddb82b882518$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $dca0ddb82b882518$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $dca0ddb82b882518$var$requestPostPaintCallback(callback) {
    $dca0ddb82b882518$var$localRequestAnimationFrame(function() {
        $dca0ddb82b882518$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $dca0ddb82b882518$var$setProp(instance, type, propKey, null, $dca0ddb82b882518$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $dca0ddb82b882518$var$noop$1 && (instance.onclick = null);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
function $dca0ddb82b882518$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!($dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $dca0ddb82b882518$var$clearPendingLoadOnNode(instance);
            });
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$268 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $dca0ddb82b882518$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, styles$268)), $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$dca0ddb82b882518$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $dca0ddb82b882518$var$clearPendingLoadOnNode.bind(null, key), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $dca0ddb82b882518$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$274)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $dca0ddb82b882518$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $dca0ddb82b882518$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $dca0ddb82b882518$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
function $dca0ddb82b882518$var$onUnsuspendImg() {
    this.imgCount--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $acw62.version;
if ("19.3.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.3.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2587.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2587.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2587.inject($dca0ddb82b882518$var$internals$jscomp$inline_2586), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.3.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $72b03fdf46effee2$export$8cdaa4703948c5e9, (v) => $72b03fdf46effee2$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $72b03fdf46effee2$export$87c99536b1b8cdd8, (v) => $72b03fdf46effee2$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$8cdaa4703948c5e9;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$87c99536b1b8cdd8;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$startTransition(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
}
function $72b03fdf46effee2$var$addTransitionType(type) {
    var transition = $72b03fdf46effee2$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $72b03fdf46effee2$var$startTransition($72b03fdf46effee2$var$addTransitionType.bind(null, type));
}
var $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$8cdaa4703948c5e9 = $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$87c99536b1b8cdd8 = $72b03fdf46effee2$var$addTransitionType;
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = $72b03fdf46effee2$var$startTransition;
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.3.0";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $4433d39f12c5883f$export$3f2684e5d7cb1006, (v) => $4433d39f12c5883f$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$3f2684e5d7cb1006;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY ? $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.3.0";

});



parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("8JYDX", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
// Main parser class
var $acb166200129f66e$exports = {};

$parcel$export($acb166200129f66e$exports, "isString", () => $acb166200129f66e$export$844ec244b1367d54);
$parcel$export($acb166200129f66e$exports, "has", () => $acb166200129f66e$export$a4f4bb6b1453fff5);
$parcel$export($acb166200129f66e$exports, "assign", () => $acb166200129f66e$export$e6e34fd1f2686227);
$parcel$export($acb166200129f66e$exports, "arrayReplaceAt", () => $acb166200129f66e$export$f78478f71955b6bc);
$parcel$export($acb166200129f66e$exports, "isValidEntityCode", () => $acb166200129f66e$export$644a8f5b13b2a36d);
$parcel$export($acb166200129f66e$exports, "fromCodePoint", () => $acb166200129f66e$export$73bfc63873071f74);
$parcel$export($acb166200129f66e$exports, "unescapeMd", () => $acb166200129f66e$export$5ccde1ea0c14bb03);
$parcel$export($acb166200129f66e$exports, "unescapeAll", () => $acb166200129f66e$export$db8a17c6655f7e2c);
$parcel$export($acb166200129f66e$exports, "escapeHtml", () => $acb166200129f66e$export$4cf11838cdc2a8a8);
$parcel$export($acb166200129f66e$exports, "escapeRE", () => $acb166200129f66e$export$bc616c8f7dc20d5d);
$parcel$export($acb166200129f66e$exports, "isSpace", () => $acb166200129f66e$export$1d5ccafae59b4926);
$parcel$export($acb166200129f66e$exports, "isWhiteSpace", () => $acb166200129f66e$export$3c52dd84024ae72c);
$parcel$export($acb166200129f66e$exports, "isPunctChar", () => $acb166200129f66e$export$4888a643af800fc1);
$parcel$export($acb166200129f66e$exports, "isPunctCharCode", () => $acb166200129f66e$export$f7c6e5cbbcca3b75);
$parcel$export($acb166200129f66e$exports, "isMdAsciiPunct", () => $acb166200129f66e$export$829a0d33ae4e744);
$parcel$export($acb166200129f66e$exports, "normalizeReference", () => $acb166200129f66e$export$20ef46802c8744b);
$parcel$export($acb166200129f66e$exports, "asciiTrim", () => $acb166200129f66e$export$9b7b141b1a3c4d78);
$parcel$export($acb166200129f66e$exports, "lib", () => $acb166200129f66e$export$16c08b91f883959a);
// Utilities
//
var $cfe8e16a3976eb73$exports = {};

$parcel$export($cfe8e16a3976eb73$exports, "decode", () => $0d34e69e6f2a0359$export$2e2bcd8739ae039);
$parcel$export($cfe8e16a3976eb73$exports, "encode", () => $a16db32880174ee4$export$2e2bcd8739ae039);
$parcel$export($cfe8e16a3976eb73$exports, "format", () => $555640cbd60e2fdc$export$2e2bcd8739ae039);
$parcel$export($cfe8e16a3976eb73$exports, "parse", () => $544ec39afc7ce01f$export$2e2bcd8739ae039);
/* eslint-disable no-bitwise */ const $0d34e69e6f2a0359$var$decodeCache = {};
function $0d34e69e6f2a0359$var$getDecodeCache(exclude) {
    let cache = $0d34e69e6f2a0359$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $0d34e69e6f2a0359$var$decodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(let i = 0; i < exclude.length; i++){
        const ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $0d34e69e6f2a0359$var$decode(string, exclude) {
    if (typeof exclude !== 'string') exclude = $0d34e69e6f2a0359$var$decode.defaultChars;
    const cache = $0d34e69e6f2a0359$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        let result = '';
        for(let i = 0, l = seq.length; i < l; i += 3){
            const b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    const chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    const chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                const b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    let chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$0d34e69e6f2a0359$var$decode.defaultChars = ';/?:@&=+$,#';
$0d34e69e6f2a0359$var$decode.componentChars = '';
var $0d34e69e6f2a0359$export$2e2bcd8739ae039 = $0d34e69e6f2a0359$var$decode;


const $a16db32880174ee4$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $a16db32880174ee4$var$getEncodeCache(exclude) {
    let cache = $a16db32880174ee4$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $a16db32880174ee4$var$encodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(let i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $a16db32880174ee4$var$encode(string, exclude, keepEscaped) {
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $a16db32880174ee4$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    const cache = $a16db32880174ee4$var$getEncodeCache(exclude);
    let result = '';
    for(let i = 0, l = string.length; i < l; i++){
        const code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                const nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$a16db32880174ee4$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$a16db32880174ee4$var$encode.componentChars = "-_.!~*'()";
var $a16db32880174ee4$export$2e2bcd8739ae039 = $a16db32880174ee4$var$encode;


function $555640cbd60e2fdc$export$2e2bcd8739ae039(url) {
    let result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
}


// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $544ec39afc7ce01f$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
const $544ec39afc7ce01f$var$protocolPattern = /^([a-z0-9.+-]+:)/i;
const $544ec39afc7ce01f$var$portPattern = /:[0-9]*$/;
// Special case for a simple path URL
/* eslint-disable-next-line no-useless-escape */ const $544ec39afc7ce01f$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/;
// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
const $544ec39afc7ce01f$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
];
// RFC 2396: characters not allowed for various reasons.
const $544ec39afc7ce01f$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($544ec39afc7ce01f$var$delims);
// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
const $544ec39afc7ce01f$var$autoEscape = [
    '\''
].concat($544ec39afc7ce01f$var$unwise);
// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
const $544ec39afc7ce01f$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($544ec39afc7ce01f$var$autoEscape);
const $544ec39afc7ce01f$var$hostEndingChars = [
    '/',
    '?',
    '#'
];
const $544ec39afc7ce01f$var$hostnameMaxLen = 255;
const $544ec39afc7ce01f$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
const $544ec39afc7ce01f$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
// protocols that can allow "unsafe" and "unwise" chars.
// protocols that never have a hostname.
const $544ec39afc7ce01f$var$hostlessProtocol = {
    javascript: true,
    'javascript:': true
};
// protocols that always contain a // bit.
const $544ec39afc7ce01f$var$slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
function $544ec39afc7ce01f$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $544ec39afc7ce01f$var$Url) return url;
    const u = new $544ec39afc7ce01f$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$544ec39afc7ce01f$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    let lowerProto, hec, slashes;
    let rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        const simplePath = $544ec39afc7ce01f$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    let proto = $544ec39afc7ce01f$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    /* eslint-disable-next-line no-useless-escape */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $544ec39afc7ce01f$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$544ec39afc7ce01f$var$hostlessProtocol[proto] && (slashes || proto && !$544ec39afc7ce01f$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        let hostEnd = -1;
        for(let i = 0; i < $544ec39afc7ce01f$var$hostEndingChars.length; i++){
            hec = rest.indexOf($544ec39afc7ce01f$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        let auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(let i = 0; i < $544ec39afc7ce01f$var$nonHostChars.length; i++){
            hec = rest.indexOf($544ec39afc7ce01f$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        const host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        const ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            const hostparts = this.hostname.split(/\./);
            for(let i = 0, l = hostparts.length; i < l; i++){
                const part = hostparts[i];
                if (!part) continue;
                if (!part.match($544ec39afc7ce01f$var$hostnamePartPattern)) {
                    let newpart = '';
                    for(let j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($544ec39afc7ce01f$var$hostnamePartPattern)) {
                        const validParts = hostparts.slice(0, i);
                        const notHost = hostparts.slice(i + 1);
                        const bit = part.match($544ec39afc7ce01f$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $544ec39afc7ce01f$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    const hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    const qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($544ec39afc7ce01f$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$544ec39afc7ce01f$var$Url.prototype.parseHost = function(host) {
    let port = $544ec39afc7ce01f$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
var $544ec39afc7ce01f$export$2e2bcd8739ae039 = $544ec39afc7ce01f$var$urlParse;




var $d55a0620136dd6aa$exports = {};

$parcel$export($d55a0620136dd6aa$exports, "Any", () => $cbc832af4f488565$export$2e2bcd8739ae039);
$parcel$export($d55a0620136dd6aa$exports, "Cc", () => $c23f5f283a1bf321$export$2e2bcd8739ae039);
$parcel$export($d55a0620136dd6aa$exports, "Cf", () => $8b025739c405fffe$export$2e2bcd8739ae039);
$parcel$export($d55a0620136dd6aa$exports, "P", () => $e24366eb89af439c$export$2e2bcd8739ae039);
$parcel$export($d55a0620136dd6aa$exports, "S", () => $add59bdd531def5c$export$2e2bcd8739ae039);
$parcel$export($d55a0620136dd6aa$exports, "Z", () => $df20dc3bfc54166a$export$2e2bcd8739ae039);
var $cbc832af4f488565$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;


var $c23f5f283a1bf321$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;


var $8b025739c405fffe$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;


var $e24366eb89af439c$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;


var $add59bdd531def5c$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;


var $df20dc3bfc54166a$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;




// Generated using scripts/write-decode-map.ts
var $99a99fa061c6495f$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));


// Generated using scripts/write-decode-map.ts
var $7a01dba917e4352e$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));


// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $48466cfbfe7abca9$var$_a;
const $48466cfbfe7abca9$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $48466cfbfe7abca9$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($48466cfbfe7abca9$var$_a = String.fromCodePoint) !== null && $48466cfbfe7abca9$var$_a !== void 0 ? $48466cfbfe7abca9$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $48466cfbfe7abca9$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $48466cfbfe7abca9$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $48466cfbfe7abca9$export$2e2bcd8739ae039(codePoint) {
    return $48466cfbfe7abca9$export$73bfc63873071f74($48466cfbfe7abca9$export$b978ab756102108a(codePoint));
}


var $bfba20002d453b69$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($bfba20002d453b69$var$CharCodes || ($bfba20002d453b69$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $bfba20002d453b69$var$TO_LOWER_BIT = 32;
var $bfba20002d453b69$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($bfba20002d453b69$export$6a4325c613e0faec || ($bfba20002d453b69$export$6a4325c613e0faec = {}));
function $bfba20002d453b69$var$isNumber(code) {
    return code >= $bfba20002d453b69$var$CharCodes.ZERO && code <= $bfba20002d453b69$var$CharCodes.NINE;
}
function $bfba20002d453b69$var$isHexadecimalCharacter(code) {
    return code >= $bfba20002d453b69$var$CharCodes.UPPER_A && code <= $bfba20002d453b69$var$CharCodes.UPPER_F || code >= $bfba20002d453b69$var$CharCodes.LOWER_A && code <= $bfba20002d453b69$var$CharCodes.LOWER_F;
}
function $bfba20002d453b69$var$isAsciiAlphaNumeric(code) {
    return code >= $bfba20002d453b69$var$CharCodes.UPPER_A && code <= $bfba20002d453b69$var$CharCodes.UPPER_Z || code >= $bfba20002d453b69$var$CharCodes.LOWER_A && code <= $bfba20002d453b69$var$CharCodes.LOWER_Z || $bfba20002d453b69$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $bfba20002d453b69$var$isEntityInAttributeInvalidEnd(code) {
    return code === $bfba20002d453b69$var$CharCodes.EQUALS || $bfba20002d453b69$var$isAsciiAlphaNumeric(code);
}
var $bfba20002d453b69$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($bfba20002d453b69$var$EntityDecoderState || ($bfba20002d453b69$var$EntityDecoderState = {}));
var $bfba20002d453b69$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($bfba20002d453b69$export$8c8f129ce60f53c || ($bfba20002d453b69$export$8c8f129ce60f53c = {}));
class $bfba20002d453b69$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $bfba20002d453b69$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $bfba20002d453b69$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $bfba20002d453b69$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $bfba20002d453b69$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $bfba20002d453b69$var$CharCodes.NUM) {
                    this.state = $bfba20002d453b69$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $bfba20002d453b69$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $bfba20002d453b69$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $bfba20002d453b69$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $bfba20002d453b69$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $bfba20002d453b69$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $bfba20002d453b69$var$TO_LOWER_BIT) === $bfba20002d453b69$var$CharCodes.LOWER_X) {
            this.state = $bfba20002d453b69$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $bfba20002d453b69$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($bfba20002d453b69$var$isNumber(char) || $bfba20002d453b69$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($bfba20002d453b69$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $bfba20002d453b69$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $bfba20002d453b69$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $48466cfbfe7abca9$export$b978ab756102108a)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $bfba20002d453b69$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $bfba20002d453b69$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $bfba20002d453b69$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $bfba20002d453b69$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $bfba20002d453b69$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $bfba20002d453b69$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $bfba20002d453b69$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $bfba20002d453b69$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $bfba20002d453b69$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$bfba20002d453b69$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $bfba20002d453b69$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $bfba20002d453b69$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $bfba20002d453b69$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $bfba20002d453b69$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $bfba20002d453b69$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $bfba20002d453b69$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $bfba20002d453b69$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $bfba20002d453b69$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $48466cfbfe7abca9$export$73bfc63873071f74)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $bfba20002d453b69$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $bfba20002d453b69$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $bfba20002d453b69$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $bfba20002d453b69$var$htmlDecoder = $bfba20002d453b69$var$getDecoder((0, $99a99fa061c6495f$export$2e2bcd8739ae039));
const $bfba20002d453b69$var$xmlDecoder = $bfba20002d453b69$var$getDecoder((0, $7a01dba917e4352e$export$2e2bcd8739ae039));
function $bfba20002d453b69$export$f045cb747ce77a19(str, mode = $bfba20002d453b69$export$8c8f129ce60f53c.Legacy) {
    return $bfba20002d453b69$var$htmlDecoder(str, mode);
}
function $bfba20002d453b69$export$49f5e8089adb006a(str) {
    return $bfba20002d453b69$var$htmlDecoder(str, $bfba20002d453b69$export$8c8f129ce60f53c.Attribute);
}
function $bfba20002d453b69$export$da52f4371b3f37de(str) {
    return $bfba20002d453b69$var$htmlDecoder(str, $bfba20002d453b69$export$8c8f129ce60f53c.Strict);
}
function $bfba20002d453b69$export$88e3b9643a8bd06e(str) {
    return $bfba20002d453b69$var$xmlDecoder(str, $bfba20002d453b69$export$8c8f129ce60f53c.Strict);
}


// Generated using scripts/write-encode-map.ts
function $c38466786e15a6f1$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$c38466786e15a6f1$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $c38466786e15a6f1$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $c38466786e15a6f1$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $c38466786e15a6f1$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $c38466786e15a6f1$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));


const $cb72e16de943c83b$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $cb72e16de943c83b$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $cb72e16de943c83b$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $cb72e16de943c83b$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $cb72e16de943c83b$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $cb72e16de943c83b$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$cb72e16de943c83b$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $cb72e16de943c83b$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $cb72e16de943c83b$export$4e7f196112fea3c5 = $cb72e16de943c83b$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $cb72e16de943c83b$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $cb72e16de943c83b$export$9e081872deefdcb0 = $cb72e16de943c83b$var$getEscaper(/[&<>'"]/g, $cb72e16de943c83b$var$xmlCodeMap);
const $cb72e16de943c83b$export$30330f3d5eb70e11 = $cb72e16de943c83b$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $cb72e16de943c83b$export$96e6fc3a139b2555 = $cb72e16de943c83b$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));


const $1514002e2552be2e$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $1514002e2552be2e$export$f9d6449b9af28dc1(data) {
    return $1514002e2552be2e$var$encodeHTMLTrieRe($1514002e2552be2e$var$htmlReplacer, data);
}
function $1514002e2552be2e$export$e6e86c76506f1190(data) {
    return $1514002e2552be2e$var$encodeHTMLTrieRe((0, $cb72e16de943c83b$export$5699810ce3244ab8), data);
}
function $1514002e2552be2e$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $c38466786e15a6f1$export$2e2bcd8739ae039).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $cb72e16de943c83b$export$e02688b8085d016b)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}



var $81d939112055885e$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($81d939112055885e$export$b8c86583d9718b50 || ($81d939112055885e$export$b8c86583d9718b50 = {}));
var $81d939112055885e$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($81d939112055885e$export$1851b20d614eb756 || ($81d939112055885e$export$1851b20d614eb756 = {}));
function $81d939112055885e$export$2f872c0f2117be69(data, options = $81d939112055885e$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $81d939112055885e$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $bfba20002d453b69$export$f045cb747ce77a19)(data, mode);
    }
    return (0, $bfba20002d453b69$export$88e3b9643a8bd06e)(data);
}
function $81d939112055885e$export$c94669f4c7d36be4(data, options = $81d939112055885e$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $bfba20002d453b69$export$8c8f129ce60f53c).Strict;
    return $81d939112055885e$export$2f872c0f2117be69(data, opts);
}
function $81d939112055885e$export$c564cdbbe6da493(data, options = $81d939112055885e$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $81d939112055885e$export$1851b20d614eb756.UTF8) return (0, $cb72e16de943c83b$export$9e081872deefdcb0)(data);
    if (opts.mode === $81d939112055885e$export$1851b20d614eb756.Attribute) return (0, $cb72e16de943c83b$export$30330f3d5eb70e11)(data);
    if (opts.mode === $81d939112055885e$export$1851b20d614eb756.Text) return (0, $cb72e16de943c83b$export$96e6fc3a139b2555)(data);
    if (opts.level === $81d939112055885e$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $81d939112055885e$export$1851b20d614eb756.ASCII) return (0, $1514002e2552be2e$export$e6e86c76506f1190)(data);
        return (0, $1514002e2552be2e$export$f9d6449b9af28dc1)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $cb72e16de943c83b$export$18855ec5be97da16)(data);
}


function $acb166200129f66e$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $acb166200129f66e$export$844ec244b1367d54(obj) {
    return $acb166200129f66e$var$_class(obj) === '[object String]';
}
const $acb166200129f66e$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $acb166200129f66e$export$a4f4bb6b1453fff5(object, key) {
    return $acb166200129f66e$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $acb166200129f66e$export$e6e34fd1f2686227(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $acb166200129f66e$export$f78478f71955b6bc(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
function $acb166200129f66e$export$644a8f5b13b2a36d(c) {
    // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $acb166200129f66e$export$73bfc63873071f74(c) {
    /* eslint no-bitwise:0 */ if (c > 0xffff) {
        c -= 0x10000;
        const surrogate1 = 0xd800 + (c >> 10);
        const surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
const $acb166200129f66e$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g;
const $acb166200129f66e$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
const $acb166200129f66e$var$UNESCAPE_ALL_RE = new RegExp($acb166200129f66e$var$UNESCAPE_MD_RE.source + '|' + $acb166200129f66e$var$ENTITY_RE.source, 'gi');
const $acb166200129f66e$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function $acb166200129f66e$var$replaceEntityPattern(match, name) {
    if (name.charCodeAt(0) === 0x23 /* # */  && $acb166200129f66e$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        const code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($acb166200129f66e$export$644a8f5b13b2a36d(code)) return $acb166200129f66e$export$73bfc63873071f74(code);
        return match;
    }
    const decoded = (0, $bfba20002d453b69$export$f045cb747ce77a19)(match);
    if (decoded !== match) return decoded;
    return match;
}
function $acb166200129f66e$export$5ccde1ea0c14bb03(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($acb166200129f66e$var$UNESCAPE_MD_RE, '$1');
}
function $acb166200129f66e$export$db8a17c6655f7e2c(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($acb166200129f66e$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $acb166200129f66e$var$replaceEntityPattern(match, entity);
    });
}
const $acb166200129f66e$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
const $acb166200129f66e$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const $acb166200129f66e$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $acb166200129f66e$var$replaceUnsafeChar(ch) {
    return $acb166200129f66e$var$HTML_REPLACEMENTS[ch];
}
function $acb166200129f66e$export$4cf11838cdc2a8a8(str) {
    if ($acb166200129f66e$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($acb166200129f66e$var$HTML_ESCAPE_REPLACE_RE, $acb166200129f66e$var$replaceUnsafeChar);
    return str;
}
const $acb166200129f66e$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $acb166200129f66e$export$bc616c8f7dc20d5d(str) {
    return str.replace($acb166200129f66e$var$REGEXP_ESCAPE_RE, '\\$&');
}
function $acb166200129f66e$export$1d5ccafae59b4926(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $acb166200129f66e$export$3c52dd84024ae72c(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}
// Currently without astral characters support.
function $acb166200129f66e$export$4888a643af800fc1(ch) {
    return $e24366eb89af439c$export$2e2bcd8739ae039.test(ch) || $add59bdd531def5c$export$2e2bcd8739ae039.test(ch);
}
function $acb166200129f66e$export$f7c6e5cbbcca3b75(code) {
    return $acb166200129f66e$export$4888a643af800fc1($acb166200129f66e$export$73bfc63873071f74(code));
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $acb166200129f66e$export$829a0d33ae4e744(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $acb166200129f66e$export$20ef46802c8744b(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") /* c8 ignore next 2 */ str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
function $acb166200129f66e$var$isAsciiTrimmable(c) {
    return c === 0x20 || c === 0x09 || c === 0x0a || c === 0x0d;
}
// "Light" .trim() for blocks (headers, paragraphs), where unicode spaces
// should be preserved.
function $acb166200129f66e$export$9b7b141b1a3c4d78(str) {
    let start = 0;
    for(; start < str.length; start++){
        if (!$acb166200129f66e$var$isAsciiTrimmable(str.charCodeAt(start))) break;
    }
    let end = str.length - 1;
    for(; end >= start; end--){
        if (!$acb166200129f66e$var$isAsciiTrimmable(str.charCodeAt(end))) break;
    }
    return str.slice(start, end + 1);
}
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
const $acb166200129f66e$export$16c08b91f883959a = {
    mdurl: $cfe8e16a3976eb73$exports,
    ucmicro: $d55a0620136dd6aa$exports
};


var $99119f957fdc25f6$exports = {};

$parcel$export($99119f957fdc25f6$exports, "parseLinkLabel", () => $abd2f48303995751$export$2e2bcd8739ae039);
$parcel$export($99119f957fdc25f6$exports, "parseLinkDestination", () => $edde6865825d92e7$export$2e2bcd8739ae039);
$parcel$export($99119f957fdc25f6$exports, "parseLinkTitle", () => $f1d3017a5ae96057$export$2e2bcd8739ae039);
// Just a shortcut for bulk export
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
function $abd2f48303995751$export$2e2bcd8739ae039(state, start, disableNested) {
    let level, found, marker, prevPos;
    const max = state.posMax;
    const oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    let labelEnd = -1;
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
}


// Parse link destination
//

function $edde6865825d92e7$export$2e2bcd8739ae039(str, start, max) {
    let code;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = (0, $acb166200129f66e$export$db8a17c6655f7e2c)(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    let level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) {
                pos++;
                continue;
            }
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = (0, $acb166200129f66e$export$db8a17c6655f7e2c)(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
}


// Parse link title
//

function $f1d3017a5ae96057$export$2e2bcd8739ae039(str, start, max, prev_state) {
    let code;
    let pos = start;
    const state = {
        // if `true`, this is a valid link title
        ok: false,
        // if `true`, this link can be continued on the next line
        can_continue: false,
        // if `ok`, it's the position of the first character after the closing marker
        pos: 0,
        // if `ok`, it's the unescaped title
        str: '',
        // expected closing marker character code
        marker: 0
    };
    if (prev_state) {
        // this is a continuation of a previous parseLinkTitle call on the next line,
        // used in reference links only
        state.str = prev_state.str;
        state.marker = prev_state.marker;
    } else {
        if (pos >= max) return state;
        let marker = str.charCodeAt(pos);
        if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return state;
        start++;
        pos++;
        // if opening marker is "(", switch it to closing marker ")"
        if (marker === 0x28) marker = 0x29;
        state.marker = marker;
    }
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === state.marker) {
            state.pos = pos + 1;
            state.str += (0, $acb166200129f66e$export$db8a17c6655f7e2c)(str.slice(start, pos));
            state.ok = true;
            return state;
        } else if (code === 0x28 /* ( */  && state.marker === 0x29 /* ) */ ) return state;
        else if (code === 0x5C /* \ */  && pos + 1 < max) pos++;
        pos++;
    }
    // no closing marker found, but this link title may continue on the next line (for references)
    state.can_continue = true;
    state.str += (0, $acb166200129f66e$export$db8a17c6655f7e2c)(str.slice(start, pos));
    return state;
}




/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 
const $1aad198f750e42d7$var$default_rules = {};
$1aad198f750e42d7$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(token.content) + '</code>';
};
$1aad198f750e42d7$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(tokens[idx].content) + '</code></pre>\n';
};
$1aad198f750e42d7$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    const info = token.info ? (0, $acb166200129f66e$export$db8a17c6655f7e2c)(token.info).trim() : '';
    let langName = '';
    let langAttrs = '';
    if (info) {
        const arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    let highlighted;
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(token.content);
    else highlighted = (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        const i = token.attrIndex('class');
        const tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        const tmpToken = {
            attrs: tmpAttrs
        };
        return `<pre><code${slf.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
    }
    return `<pre><code${slf.renderAttrs(token)}>${highlighted}</code></pre>\n`;
};
$1aad198f750e42d7$var$default_rules.image = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$1aad198f750e42d7$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$1aad198f750e42d7$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$1aad198f750e42d7$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(tokens[idx].content);
};
$1aad198f750e42d7$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$1aad198f750e42d7$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $1aad198f750e42d7$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs)
   * for more details and examples.
   **/ this.rules = (0, $acb166200129f66e$export$e6e34fd1f2686227)({}, $1aad198f750e42d7$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $1aad198f750e42d7$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    let i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(token.attrs[i][0]) + '="' + (0, $acb166200129f66e$export$4cf11838cdc2a8a8)(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $1aad198f750e42d7$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    const token = tokens[idx];
    let result = '';
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    let needLf = false;
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                const nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $1aad198f750e42d7$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $1aad198f750e42d7$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    let result = '';
    for(let i = 0, len = tokens.length; i < len; i++)switch(tokens[i].type){
        case 'text':
            result += tokens[i].content;
            break;
        case 'image':
            result += this.renderInlineAsText(tokens[i].children, options, env);
            break;
        case 'html_inline':
        case 'html_block':
            result += tokens[i].content;
            break;
        case 'softbreak':
        case 'hardbreak':
            result += '\n';
            break;
        default:
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $1aad198f750e42d7$var$Renderer.prototype.render = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
var $1aad198f750e42d7$export$2e2bcd8739ae039 = $1aad198f750e42d7$var$Renderer;


/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ /**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ /**
 * new Ruler()
 **/ function $41ea3ea6c70806b8$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
// Helper methods, should not be used directly
// Find rule index by name
//
$41ea3ea6c70806b8$var$Ruler.prototype.__find__ = function(name) {
    for(let i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$41ea3ea6c70806b8$var$Ruler.prototype.__compile__ = function() {
    const self = this;
    const chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.at = function(name, fn, options) {
    const index = this.__find__(name);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    const index = this.__find__(beforeName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    const index = this.__find__(afterName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.push = function(ruleName, fn, options) {
    const opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and enable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and disable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
var $41ea3ea6c70806b8$export$2e2bcd8739ae039 = $41ea3ea6c70806b8$var$Ruler;


// Core state object
//
// Token class
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $59ac17e6d91b036a$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $59ac17e6d91b036a$var$Token.prototype.attrIndex = function attrIndex(name) {
    if (!this.attrs) return -1;
    const attrs = this.attrs;
    for(let i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $59ac17e6d91b036a$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $59ac17e6d91b036a$var$Token.prototype.attrSet = function attrSet(name, value) {
    const idx = this.attrIndex(name);
    const attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $59ac17e6d91b036a$var$Token.prototype.attrGet = function attrGet(name) {
    const idx = this.attrIndex(name);
    let value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $59ac17e6d91b036a$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    const idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
var $59ac17e6d91b036a$export$2e2bcd8739ae039 = $59ac17e6d91b036a$var$Token;


function $8993a444d7ae3c83$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md // link to parser instance
    ;
}
// re-export Token class to use in core rules
$8993a444d7ae3c83$var$StateCore.prototype.Token = (0, $59ac17e6d91b036a$export$2e2bcd8739ae039);
var $8993a444d7ae3c83$export$2e2bcd8739ae039 = $8993a444d7ae3c83$var$StateCore;


// Normalize input string
// https://spec.commonmark.org/0.29/#line-ending
const $5203c6838a32c344$var$NEWLINES_RE = /\r\n?|\n/g;
const $5203c6838a32c344$var$NULL_RE = /\0/g;
function $5203c6838a32c344$export$2e2bcd8739ae039(state) {
    let str;
    // Normalize newlines
    str = state.src.replace($5203c6838a32c344$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($5203c6838a32c344$var$NULL_RE, '\uFFFD');
    state.src = str;
}


function $cd7698881deefc7d$export$2e2bcd8739ae039(state) {
    let token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
}


function $196eb58ba8a882c3$export$2e2bcd8739ae039(state) {
    const tokens = state.tokens;
    // Parse inlines
    for(let i = 0, l = tokens.length; i < l; i++){
        const tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
}


// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
function $e017aabd93d74ca7$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $e017aabd93d74ca7$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $e017aabd93d74ca7$export$2e2bcd8739ae039(state) {
    const blockTokens = state.tokens;
    if (!state.md.options.linkify) return;
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        const tokens = blockTokens[j].children;
        const replacements = [];
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($e017aabd93d74ca7$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($e017aabd93d74ca7$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = state.md.linkify.match(text);
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(let ln = 0; ln < links.length; ln++){
                    const url = links[ln].url;
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    const token_o = new state.Token('link_open', 'a', 1);
                    token_o.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token_o.level = level++;
                    token_o.markup = 'linkify';
                    token_o.info = 'auto';
                    nodes.push(token_o);
                    const token_t = new state.Token('text', '', 0);
                    token_t.content = urlText;
                    token_t.level = level;
                    nodes.push(token_t);
                    const token_c = new state.Token('link_close', 'a', -1);
                    token_c.level = --level;
                    token_c.markup = 'linkify';
                    token_c.info = 'auto';
                    nodes.push(token_c);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                replacements.push({
                    index: i,
                    nodes: nodes
                });
            }
        }
        if (replacements.length > 0) {
            let newTokensLength = tokens.length;
            for (const replacement of replacements)newTokensLength += replacement.nodes.length - 1;
            const newTokens = new Array(newTokensLength);
            let replacementIndex = 0;
            let newTokenIndex = 0;
            replacements.reverse();
            for(let i = 0; i < tokens.length; i++){
                const replacement = replacements[replacementIndex];
                if (replacement?.index === i) {
                    for (const node of replacement.nodes)newTokens[newTokenIndex++] = node;
                    replacementIndex++;
                } else newTokens[newTokenIndex++] = tokens[i];
            }
            blockTokens[j].children = newTokens;
        }
    }
}


// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
const $71faf318b045012d$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
const $71faf318b045012d$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
const $71faf318b045012d$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
const $71faf318b045012d$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $71faf318b045012d$var$replaceFn(match, name) {
    return $71faf318b045012d$var$SCOPED_ABBR[name.toLowerCase()];
}
function $71faf318b045012d$var$replace_scoped(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($71faf318b045012d$var$SCOPED_ABBR_RE, $71faf318b045012d$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $71faf318b045012d$var$replace_rare(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($71faf318b045012d$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $71faf318b045012d$export$2e2bcd8739ae039(state) {
    let blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($71faf318b045012d$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $71faf318b045012d$var$replace_scoped(state.tokens[blkIdx].children);
        if ($71faf318b045012d$var$RARE_RE.test(state.tokens[blkIdx].content)) $71faf318b045012d$var$replace_rare(state.tokens[blkIdx].children);
    }
}


// Convert straight quotation marks to typographic ones
//

const $18c84f826c38cf40$var$QUOTE_TEST_RE = /['"]/;
const $18c84f826c38cf40$var$QUOTE_RE = /['"]/g;
const $18c84f826c38cf40$var$APOSTROPHE = '\u2019' /* ’ */ ;
// Caps memory on malicious input
const $18c84f826c38cf40$var$MAX_OPENERS = 1000;
function $18c84f826c38cf40$var$truncateStack(stack, heads, length) {
    while(stack.length > length){
        const item = stack.pop();
        if (item.isSingleQuote) heads.single = item.prevSameQuoteIdx;
        else heads.double = item.prevSameQuoteIdx;
    }
}
function $18c84f826c38cf40$var$addReplacement(replacements, tokenIdx, pos, ch) {
    if (!replacements[tokenIdx]) replacements[tokenIdx] = [];
    replacements[tokenIdx].push({
        pos: pos,
        ch: ch
    });
}
function $18c84f826c38cf40$var$applyReplacements(str, replacements) {
    let result = '';
    let lastPos = 0;
    replacements.sort((a, b)=>a.pos - b.pos);
    for(let i = 0; i < replacements.length; i++){
        const replacement = replacements[i];
        result += str.slice(lastPos, replacement.pos) + replacement.ch;
        lastPos = replacement.pos + 1;
    }
    return result + str.slice(lastPos);
}
function $18c84f826c38cf40$var$process_inlines(tokens, state) {
    let j;
    const stack = [];
    // stack indexes of topmost openers of each type (-1 if none)
    const heads = {
        single: -1,
        double: -1
    };
    // token index -> list of replacements in the original token content
    const replacements = {};
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        $18c84f826c38cf40$var$truncateStack(stack, heads, j + 1);
        if (token.type !== 'text') continue;
        const text = token.content;
        let pos = 0;
        const max = text.length;
        /* eslint no-labels:0,block-scoped-var:0 */ OUTER: while(pos < max){
            $18c84f826c38cf40$var$QUOTE_RE.lastIndex = pos;
            const t = $18c84f826c38cf40$var$QUOTE_RE.exec(text);
            if (!t) break;
            let canOpen = true;
            let canClose = true;
            pos = t.index + 1;
            const isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            let lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            let nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            const isLastPunctChar = (0, $acb166200129f66e$export$829a0d33ae4e744)(lastChar) || (0, $acb166200129f66e$export$f7c6e5cbbcca3b75)(lastChar);
            const isNextPunctChar = (0, $acb166200129f66e$export$829a0d33ae4e744)(nextChar) || (0, $acb166200129f66e$export$f7c6e5cbbcca3b75)(nextChar);
            const isLastWhiteSpace = (0, $acb166200129f66e$export$3c52dd84024ae72c)(lastChar);
            const isNextWhiteSpace = (0, $acb166200129f66e$export$3c52dd84024ae72c)(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) $18c84f826c38cf40$var$addReplacement(replacements, i, t.index, $18c84f826c38cf40$var$APOSTROPHE);
                continue;
            }
            if (canClose) {
                // Stack levels never decrease, so an opener of this type below
                // the current level means there is no match
                j = isSingle ? heads.single : heads.double;
                if (j >= 0 && stack[j].level === thisLevel) {
                    const item = stack[j];
                    let openQuote;
                    let closeQuote;
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    $18c84f826c38cf40$var$addReplacement(replacements, i, t.index, closeQuote);
                    $18c84f826c38cf40$var$addReplacement(replacements, item.tokenIdx, item.contentPos, openQuote);
                    $18c84f826c38cf40$var$truncateStack(stack, heads, j);
                    continue OUTER;
                }
            }
            if (canOpen) {
                if (stack.length >= $18c84f826c38cf40$var$MAX_OPENERS) return;
                stack.push({
                    tokenIdx: i,
                    contentPos: t.index,
                    isSingleQuote: isSingle,
                    level: thisLevel,
                    // stack index of the previous opener of the same quote type, -1 if none
                    prevSameQuoteIdx: isSingle ? heads.single : heads.double
                });
                if (isSingle) heads.single = stack.length - 1;
                else heads.double = stack.length - 1;
            } else if (canClose && isSingle) $18c84f826c38cf40$var$addReplacement(replacements, i, t.index, $18c84f826c38cf40$var$APOSTROPHE);
        }
    }
    Object.keys(replacements).forEach(function(tokenIdx) {
        tokens[tokenIdx].content = $18c84f826c38cf40$var$applyReplacements(tokens[tokenIdx].content, replacements[tokenIdx]);
    });
}
function $18c84f826c38cf40$export$2e2bcd8739ae039(state) {
    /* eslint max-depth:0 */ if (!state.md.options.typographer) return;
    for(let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$18c84f826c38cf40$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $18c84f826c38cf40$var$process_inlines(state.tokens[blkIdx].children, state);
    }
}


// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
function $7a6cf0d0aa696419$export$2e2bcd8739ae039(state) {
    let curr, last;
    const blockTokens = state.tokens;
    const l = blockTokens.length;
    for(let j = 0; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        const tokens = blockTokens[j].children;
        const max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
}


const $1dbd8732bf2ea1e5$var$_rules = [
    [
        'normalize',
        (0, $5203c6838a32c344$export$2e2bcd8739ae039)
    ],
    [
        'block',
        (0, $cd7698881deefc7d$export$2e2bcd8739ae039)
    ],
    [
        'inline',
        (0, $196eb58ba8a882c3$export$2e2bcd8739ae039)
    ],
    [
        'linkify',
        (0, $e017aabd93d74ca7$export$2e2bcd8739ae039)
    ],
    [
        'replacements',
        (0, $71faf318b045012d$export$2e2bcd8739ae039)
    ],
    [
        'smartquotes',
        (0, $18c84f826c38cf40$export$2e2bcd8739ae039)
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (0, $7a6cf0d0aa696419$export$2e2bcd8739ae039)
    ]
];
/**
 * new Core()
 **/ function $1dbd8732bf2ea1e5$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new (0, $41ea3ea6c70806b8$export$2e2bcd8739ae039)();
    for(let i = 0; i < $1dbd8732bf2ea1e5$var$_rules.length; i++)this.ruler.push($1dbd8732bf2ea1e5$var$_rules[i][0], $1dbd8732bf2ea1e5$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $1dbd8732bf2ea1e5$var$Core.prototype.process = function(state) {
    const rules = this.ruler.getRules('');
    for(let i = 0, l = rules.length; i < l; i++)rules[i](state);
};
$1dbd8732bf2ea1e5$var$Core.prototype.State = (0, $8993a444d7ae3c83$export$2e2bcd8739ae039);
var $1dbd8732bf2ea1e5$export$2e2bcd8739ae039 = $1dbd8732bf2ea1e5$var$Core;


/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 
// Parser state class


function $ad2420667aa7c8e8$var$StateBlock(src, md, env, tokens) {
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = [] // line begin offsets for fast jumps
    ;
    this.eMarks = [] // line end offsets for fast jumps
    ;
    this.tShift = [] // offsets of the first non-space characters (tabs not expanded)
    ;
    this.sCount = [] // indents for each line (tabs expanded)
    ;
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.blkIndent = 0;
    this.line = 0 // line index in src
    ;
    this.lineMax = 0 // lines count
    ;
    this.tight = false // loose/tight mode for lists
    ;
    this.ddIndent = -1 // indent of the current dd block (-1 if there isn't any)
    ;
    this.listIndent = -1 // indent of the current list block (-1 if there isn't any)
    ;
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // Create caches
    // Generate markers.
    const s = this.src;
    for(let start = 0, pos = 0, indent = 0, offset = 0, len = s.length, indent_found = false; pos < len; pos++){
        const ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ((0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1 // don't count last fake line
    ;
}
// Push new token to "stream".
//
$ad2420667aa7c8e8$var$StateBlock.prototype.push = function(type, tag, nesting) {
    const token = new (0, $59ac17e6d91b036a$export$2e2bcd8739ae039)(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level-- // closing tag
    ;
    token.level = this.level;
    if (nesting > 0) this.level++ // opening tag
    ;
    this.tokens.push(token);
    return token;
};
$ad2420667aa7c8e8$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$ad2420667aa7c8e8$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(let max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$ad2420667aa7c8e8$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(let max = this.src.length; pos < max; pos++){
        const ch = this.src.charCodeAt(pos);
        if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$ad2420667aa7c8e8$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$ad2420667aa7c8e8$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(let max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$ad2420667aa7c8e8$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$ad2420667aa7c8e8$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    if (begin >= end) return '';
    const queue = new Array(end - begin);
    for(let i = 0, line = begin; line < end; line++, i++){
        let lineIndent = 0;
        const lineStart = this.bMarks[line];
        let first = lineStart;
        let last;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            const ch = this.src.charCodeAt(first);
            if ((0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$ad2420667aa7c8e8$var$StateBlock.prototype.Token = (0, $59ac17e6d91b036a$export$2e2bcd8739ae039);
var $ad2420667aa7c8e8$export$2e2bcd8739ae039 = $ad2420667aa7c8e8$var$StateBlock;


// GFM table, https://github.github.com/gfm/#tables-extension-

// Limit the amount of empty autocompleted cells in a table,
// see https://github.com/markdown-it/markdown-it/issues/1000,
//
// Both pulldown-cmark and commonmark-hs limit the number of cells this way to ~200k.
// We set it to 65k, which can expand user input by a factor of x370
// (256x256 square is 1.8kB expanded into 650kB).
const $2ef92aecf350006a$var$MAX_AUTOCOMPLETED_CELLS = 0x10000;
function $2ef92aecf350006a$var$getLine(state, line) {
    const pos = state.bMarks[line] + state.tShift[line];
    const max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $2ef92aecf350006a$var$escapedSplit(str) {
    const result = [];
    const max = str.length;
    let pos = 0;
    let ch = str.charCodeAt(pos);
    let isEscaped = false;
    let lastPos = 0;
    let current = '';
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
function $2ef92aecf350006a$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    let nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    let pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    const firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    const secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !(0, $acb166200129f66e$export$1d5ccafae59b4926)(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && (0, $acb166200129f66e$export$1d5ccafae59b4926)(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        const ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) return false;
        pos++;
    }
    let lineText = $2ef92aecf350006a$var$getLine(state, startLine + 1);
    let columns = lineText.split('|');
    const aligns = [];
    for(let i = 0; i < columns.length; i++){
        const t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $2ef92aecf350006a$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $2ef92aecf350006a$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    const columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    const oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const token_to = state.push('table_open', 'table', 1);
    const tableLines = [
        startLine,
        0
    ];
    token_to.map = tableLines;
    const token_tho = state.push('thead_open', 'thead', 1);
    token_tho.map = [
        startLine,
        startLine + 1
    ];
    const token_htro = state.push('tr_open', 'tr', 1);
    token_htro.map = [
        startLine,
        startLine + 1
    ];
    for(let i = 0; i < columns.length; i++){
        const token_ho = state.push('th_open', 'th', 1);
        if (aligns[i]) token_ho.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        const token_il = state.push('inline', '', 0);
        token_il.content = columns[i].trim();
        token_il.children = [];
        state.push('th_close', 'th', -1);
    }
    state.push('tr_close', 'tr', -1);
    state.push('thead_close', 'thead', -1);
    let tbodyLines;
    let autocompletedCells = 0;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $2ef92aecf350006a$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $2ef92aecf350006a$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        // note: autocomplete count can be negative if user specifies more columns than header,
        // but that does not affect intended use (which is limiting expansion)
        autocompletedCells += columnCount - columns.length;
        if (autocompletedCells > $2ef92aecf350006a$var$MAX_AUTOCOMPLETED_CELLS) break;
        if (nextLine === startLine + 2) {
            const token_tbo = state.push('tbody_open', 'tbody', 1);
            token_tbo.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        const token_tro = state.push('tr_open', 'tr', 1);
        token_tro.map = [
            nextLine,
            nextLine + 1
        ];
        for(let i = 0; i < columnCount; i++){
            const token_tdo = state.push('td_open', 'td', 1);
            if (aligns[i]) token_tdo.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            const token_il = state.push('inline', '', 0);
            token_il.content = columns[i] ? columns[i].trim() : '';
            token_il.children = [];
            state.push('td_close', 'td', -1);
        }
        state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
}


// Code block (4 spaces padded)
function $319716b5135e5657$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    let nextLine = startLine + 1;
    let last = nextLine;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    const token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
}


// fences (``` lang, ~~~ lang)
function $96fff8032daf3c7b$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    const marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    let mem = pos;
    pos = state.skipChars(pos, marker);
    let len = pos - mem;
    if (len < 3) return false;
    const markup = state.src.slice(mem, pos);
    const params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    let nextLine = startLine;
    let haveEndMarker = false;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    const token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
}


// Block quotes

function $56f381d401e94dfa$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    const oldLineMax = state.lineMax;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    const oldBMarks = [];
    const oldBSCount = [];
    const oldSCount = [];
    const oldTShift = [];
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const oldParentType = state.parentType;
    state.parentType = 'blockquote';
    let lastLineEmpty = false;
    let nextLine;
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        const isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            let initial = state.sCount[nextLine] + 1;
            let spaceAfterMarker;
            let adjustTab;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            let offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                const ch = state.src.charCodeAt(pos);
                if ((0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    const oldIndent = state.blkIndent;
    state.blkIndent = 0;
    const token_o = state.push('blockquote_open', 'blockquote', 1);
    token_o.markup = '>';
    const lines = [
        startLine,
        0
    ];
    token_o.map = lines;
    state.md.block.tokenize(state, startLine, nextLine);
    const token_c = state.push('blockquote_close', 'blockquote', -1);
    token_c.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(let i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
}


// Horizontal rule

function $bd654477b14b4267$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    const max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    let cnt = 1;
    while(pos < max){
        const ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    const token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
}


// Lists

// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $3b7cbf7838646e8a$var$skipBulletListMarker(state, startLine) {
    const max = state.eMarks[startLine];
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        const ch = state.src.charCodeAt(pos);
        if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $3b7cbf7838646e8a$var$skipOrderedListMarker(state, startLine) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    let pos = start;
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    let ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $3b7cbf7838646e8a$var$markTightParagraphs(state, idx) {
    const level = state.level + 2;
    for(let i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
function $3b7cbf7838646e8a$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let max, pos, start, token;
    let nextLine = startLine;
    let tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    let isTerminatingParagraph = false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    let isOrdered;
    let markerValue;
    let posAfterMarker;
    if ((posAfterMarker = $3b7cbf7838646e8a$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $3b7cbf7838646e8a$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    const listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    const listLines = [
        nextLine,
        0
    ];
    token.map = listLines;
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    let prevEmptyEnd = false;
    const terminatorRules = state.md.block.ruler.getRules('list');
    const oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        let offset = initial;
        while(pos < max){
            const ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        const contentStart = pos;
        let indentAfterMarker;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        const indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        const itemLines = [
            nextLine,
            0
        ];
        token.map = itemLines;
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        const oldTight = state.tight;
        const oldTShift = state.tShift[nextLine];
        const oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        const oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $3b7cbf7838646e8a$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $3b7cbf7838646e8a$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $3b7cbf7838646e8a$var$markTightParagraphs(state, listTokIdx);
    return true;
}



function $dc5cd5db6853c1d8$export$2e2bcd8739ae039(state, startLine, _endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    let nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    function getNextLine(nextLine) {
        const endLine = state.lineMax;
        if (nextLine >= endLine || state.isEmpty(nextLine)) // empty line or end of input
        return null;
        let isContinuation = false;
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) isContinuation = true;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) isContinuation = true;
        if (!isContinuation) {
            const terminatorRules = state.md.block.ruler.getRules('reference');
            const oldParentType = state.parentType;
            state.parentType = 'reference';
            // Some tags can terminate paragraph without empty line.
            let terminate = false;
            for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            state.parentType = oldParentType;
            if (terminate) // terminated by another block
            return null;
        }
        const pos = state.bMarks[nextLine] + state.tShift[nextLine];
        const max = state.eMarks[nextLine];
        // max + 1 explicitly includes the newline
        return state.src.slice(pos, max + 1);
    }
    let str = state.src.slice(pos, max + 1);
    max = str.length;
    let labelEnd = -1;
    for(pos = 1; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) {
                const lineContent = getNextLine(nextLine);
                if (lineContent !== null) {
                    str += lineContent;
                    max = str.length;
                    nextLine++;
                }
            }
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!destRes.ok) return false;
    const href = state.md.normalizeLink(destRes.str);
    if (!state.md.validateLink(href)) return false;
    pos = destRes.pos;
    // save cursor state, we could require to rollback later
    const destEndPos = pos;
    const destEndLineNo = nextLine;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    const start = pos;
    for(; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    let titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
    while(titleRes.can_continue){
        const lineContent = getNextLine(nextLine);
        if (lineContent === null) break;
        str += lineContent;
        pos = max;
        max = str.length;
        nextLine++;
        titleRes = state.md.helpers.parseLinkTitle(str, pos, max, titleRes);
    }
    let title;
    if (pos < max && start !== pos && titleRes.ok) {
        title = titleRes.str;
        pos = titleRes.pos;
    } else {
        title = '';
        pos = destEndPos;
        nextLine = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        const ch = str.charCodeAt(pos);
        if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            nextLine = destEndLineNo;
            while(pos < max){
                const ch = str.charCodeAt(pos);
                if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    const label = (0, $acb166200129f66e$export$20ef46802c8744b)(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /* istanbul ignore if */ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.line = nextLine;
    return true;
}


// HTML block
// List of valid html blocks names, according to commonmark spec
// https://spec.commonmark.org/0.30/#html-blocks
var $8955e68447e3f9db$export$2e2bcd8739ae039 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];


// Regexps to match html elements
const $08e6c33d10f51cc6$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
const $08e6c33d10f51cc6$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
const $08e6c33d10f51cc6$var$single_quoted = "'[^']*'";
const $08e6c33d10f51cc6$var$double_quoted = '"[^"]*"';
const $08e6c33d10f51cc6$var$attr_value = '(?:' + $08e6c33d10f51cc6$var$unquoted + '|' + $08e6c33d10f51cc6$var$single_quoted + '|' + $08e6c33d10f51cc6$var$double_quoted + ')';
const $08e6c33d10f51cc6$var$attribute = '(?:\\s+' + $08e6c33d10f51cc6$var$attr_name + '(?:\\s*=\\s*' + $08e6c33d10f51cc6$var$attr_value + ')?)';
const $08e6c33d10f51cc6$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $08e6c33d10f51cc6$var$attribute + '*\\s*\\/?>';
const $08e6c33d10f51cc6$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
const $08e6c33d10f51cc6$var$comment = '<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->';
const $08e6c33d10f51cc6$var$processing = '<[?][\\s\\S]*?[?]>';
const $08e6c33d10f51cc6$var$declaration = '<![A-Za-z][^>]*>';
const $08e6c33d10f51cc6$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
const $08e6c33d10f51cc6$export$6db61d2c3a16e419 = new RegExp('^(?:' + $08e6c33d10f51cc6$var$open_tag + '|' + $08e6c33d10f51cc6$var$close_tag + '|' + $08e6c33d10f51cc6$var$comment + '|' + $08e6c33d10f51cc6$var$processing + '|' + $08e6c33d10f51cc6$var$declaration + '|' + $08e6c33d10f51cc6$var$cdata + ')');
const $08e6c33d10f51cc6$export$cd48660d06f74639 = new RegExp('^(?:' + $08e6c33d10f51cc6$var$open_tag + '|' + $08e6c33d10f51cc6$var$close_tag + ')');


// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
const $d9386c6e85fc1b48$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Za-z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + (0, $8955e68447e3f9db$export$2e2bcd8739ae039).join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp((0, $08e6c33d10f51cc6$export$cd48660d06f74639).source + '\\s*$'),
        /^$/,
        false
    ]
];
function $d9386c6e85fc1b48$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    let lineText = state.src.slice(pos, max);
    let i = 0;
    for(; i < $d9386c6e85fc1b48$var$HTML_SEQUENCES.length; i++){
        if ($d9386c6e85fc1b48$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $d9386c6e85fc1b48$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $d9386c6e85fc1b48$var$HTML_SEQUENCES[i][2];
    let nextLine = startLine + 1;
    // Block types 6 and 7 (the only ones whose end condition is a blank line)
    // have `/^$/` as their closing regexp. For all other types (1-5, e.g.
    // `<!--` comments), a blank line is regular content and must not terminate
    // the block - it ends only when its closing sequence is found.
    const endsOnBlankLine = $d9386c6e85fc1b48$var$HTML_SEQUENCES[i][1].test('');
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$d9386c6e85fc1b48$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) {
            // An outdented blank line shouldn't end a block that doesn't end on a
            // blank line (e.g. a `<!--` comment inside a list item). Such blocks
            // must continue until their closing sequence regardless of indent.
            if (endsOnBlankLine || !state.isEmpty(nextLine)) break;
        }
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($d9386c6e85fc1b48$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    const token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
}


// heading (#, ##, ...)

function $dd7f552fbefa4306$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    let level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    const tmp = state.skipCharsBack(max, 0x23, pos) // #
    ;
    if (tmp > pos && (0, $acb166200129f66e$export$1d5ccafae59b4926)(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = '########'.slice(0, level);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = (0, $acb166200129f66e$export$9b7b141b1a3c4d78)(state.src.slice(pos, max));
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = '########'.slice(0, level);
    return true;
}


// lheading (---, ===)

function $acb81d8044351f9f$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph' // use paragraph to match terminatorRules
    ;
    // jump line-by-line until empty one or EOF
    let level = 0;
    let marker;
    let nextLine = startLine + 1;
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            let pos = state.bMarks[nextLine] + state.tShift[nextLine];
            const max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) {
        // Didn't find valid underline
        state.parentType = oldParentType;
        return false;
    }
    const content = (0, $acb166200129f66e$export$9b7b141b1a3c4d78)(state.getLines(startLine, nextLine, state.blkIndent, false));
    state.line = nextLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = String.fromCharCode(marker);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line - 1
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
}


// Paragraph

function $d374391f851a68ad$export$2e2bcd8739ae039(state, startLine, endLine) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const oldParentType = state.parentType;
    let nextLine = startLine + 1;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = (0, $acb166200129f66e$export$9b7b141b1a3c4d78)(state.getLines(startLine, nextLine, state.blkIndent, false));
    state.line = nextLine;
    const token_o = state.push('paragraph_open', 'p', 1);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
}


const $3349c57a2e9a47a9$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (0, $2ef92aecf350006a$export$2e2bcd8739ae039),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (0, $319716b5135e5657$export$2e2bcd8739ae039)
    ],
    [
        'fence',
        (0, $96fff8032daf3c7b$export$2e2bcd8739ae039),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (0, $56f381d401e94dfa$export$2e2bcd8739ae039),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (0, $bd654477b14b4267$export$2e2bcd8739ae039),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (0, $3b7cbf7838646e8a$export$2e2bcd8739ae039),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (0, $dc5cd5db6853c1d8$export$2e2bcd8739ae039)
    ],
    [
        'html_block',
        (0, $d9386c6e85fc1b48$export$2e2bcd8739ae039),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (0, $dd7f552fbefa4306$export$2e2bcd8739ae039),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (0, $acb81d8044351f9f$export$2e2bcd8739ae039)
    ],
    [
        'paragraph',
        (0, $d374391f851a68ad$export$2e2bcd8739ae039)
    ]
];
/**
 * new ParserBlock()
 **/ function $3349c57a2e9a47a9$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new (0, $41ea3ea6c70806b8$export$2e2bcd8739ae039)();
    for(let i = 0; i < $3349c57a2e9a47a9$var$_rules.length; i++)this.ruler.push($3349c57a2e9a47a9$var$_rules[i][0], $3349c57a2e9a47a9$var$_rules[i][1], {
        alt: ($3349c57a2e9a47a9$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$3349c57a2e9a47a9$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    let line = startLine;
    let hasEmptyLines = false;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        const prevLine = state.line;
        let ok = false;
        for(let i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $3349c57a2e9a47a9$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    if (!src) return;
    const state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
$3349c57a2e9a47a9$var$ParserBlock.prototype.State = (0, $ad2420667aa7c8e8$export$2e2bcd8739ae039);
var $3349c57a2e9a47a9$export$2e2bcd8739ae039 = $3349c57a2e9a47a9$var$ParserBlock;


/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 
// Inline parser state


function $78766ebe20d230e1$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$78766ebe20d230e1$var$StateInline.prototype.pushPending = function() {
    const token = new (0, $59ac17e6d91b036a$export$2e2bcd8739ae039)('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$78766ebe20d230e1$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    const token = new (0, $59ac17e6d91b036a$export$2e2bcd8739ae039)(type, tag, nesting);
    let token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$78766ebe20d230e1$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    const max = this.posMax;
    const marker = this.src.charCodeAt(start);
    // Astral characters below are combined manually, because .codePointAt()
    // does not guarantee numeric type output. And we don't wish JIT cache issues.
    // The broken surrogate pairs are evaluated as U+FFFD to prevent possible
    // crashes.
    let lastChar;
    if (start === 0) // treat beginning of the line as a whitespace
    lastChar = 0x20;
    else if (start === 1) {
        lastChar = this.src.charCodeAt(0);
        if ((lastChar & 0xF800) === 0xD800) lastChar = 0xFFFD;
    } else {
        lastChar = this.src.charCodeAt(start - 1);
        if ((lastChar & 0xFC00) === 0xDC00) {
            // low surrogate => add high one, replace broken pair with U+FFFD
            const highSurr = this.src.charCodeAt(start - 2);
            lastChar = (highSurr & 0xFC00) === 0xD800 ? 0x10000 + (highSurr - 0xD800 << 10) + (lastChar - 0xDC00) : 0xFFFD;
        } else if ((lastChar & 0xFC00) === 0xD800) lastChar = 0xFFFD;
    }
    let pos = start;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    const count = pos - start;
    // treat end of the line as a whitespace
    let nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    if ((nextChar & 0xFC00) === 0xD800) {
        // high surrogate => add low one, replace broken pair with U+FFFD
        const lowSurr = this.src.charCodeAt(pos + 1);
        nextChar = (lowSurr & 0xFC00) === 0xDC00 ? 0x10000 + (nextChar - 0xD800 << 10) + (lowSurr - 0xDC00) : 0xFFFD;
    } else if ((nextChar & 0xFC00) === 0xDC00) nextChar = 0xFFFD;
    const isLastPunctChar = (0, $acb166200129f66e$export$829a0d33ae4e744)(lastChar) || (0, $acb166200129f66e$export$f7c6e5cbbcca3b75)(lastChar);
    const isNextPunctChar = (0, $acb166200129f66e$export$829a0d33ae4e744)(nextChar) || (0, $acb166200129f66e$export$f7c6e5cbbcca3b75)(nextChar);
    const isLastWhiteSpace = (0, $acb166200129f66e$export$3c52dd84024ae72c)(lastChar);
    const isNextWhiteSpace = (0, $acb166200129f66e$export$3c52dd84024ae72c)(nextChar);
    const left_flanking = !isNextWhiteSpace && (!isNextPunctChar || isLastWhiteSpace || isLastPunctChar);
    const right_flanking = !isLastWhiteSpace && (!isLastPunctChar || isNextWhiteSpace || isNextPunctChar);
    const can_open = left_flanking && (canSplitWord || !right_flanking || isLastPunctChar);
    const can_close = right_flanking && (canSplitWord || !left_flanking || isNextPunctChar);
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$78766ebe20d230e1$var$StateInline.prototype.Token = (0, $59ac17e6d91b036a$export$2e2bcd8739ae039);
var $78766ebe20d230e1$export$2e2bcd8739ae039 = $78766ebe20d230e1$var$StateInline;


// Skip text characters for text token, place those to pending buffer
// and increment current pos
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $52dad52dbdb68874$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
function $52dad52dbdb68874$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    while(pos < state.posMax && !$52dad52dbdb68874$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
} // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParserInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
}; */ 


// Early process links like https://example.org/ to have priority
// over emphasis, etc.
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
function $d922190b2670a68c$var$isAsciiAlpha(code) {
    return code >= 0x41 && code <= 0x5A || code >= 0x61 && code <= 0x7A;
}
function $d922190b2670a68c$var$isSchemeChar(code) {
    return code >= 0x41 && code <= 0x5A || code >= 0x61 && code <= 0x7A || code >= 0x30 && code <= 0x39 || code === 0x2B || code === 0x2D || code === 0x2E;
}
function $d922190b2670a68c$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    const pos = state.pos;
    const max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    // Search backwards for the scheme, but no more than 10 characters, the length
    // of the pending string, or the length of the source prefix.
    // Use state.src instead of state.pending because it is faster to access.
    const protoMin = pos - Math.min(10, state.pending.length, pos);
    let protoStart = pos;
    while(protoStart > protoMin && $d922190b2670a68c$var$isSchemeChar(state.src.charCodeAt(protoStart - 1)))protoStart--;
    if (protoStart === pos || !$d922190b2670a68c$var$isAsciiAlpha(state.src.charCodeAt(protoStart))) return false;
    const protoLength = pos - protoStart;
    const link = state.md.linkify.matchAtStart(state.src.slice(protoStart));
    if (!link) return false;
    let url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= protoLength) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    // do manual backsearch to avoid perf issues with regex /\*+$/ on "****...****a".
    let urlEnd = url.length;
    while(urlEnd > 0 && url.charCodeAt(urlEnd - 1) === 0x2A /* * */ )urlEnd--;
    if (urlEnd !== url.length) url = url.slice(0, urlEnd);
    const fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -protoLength);
        const token_o = state.push('link_open', 'a', 1);
        token_o.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token_o.markup = 'linkify';
        token_o.info = 'auto';
        const token_t = state.push('text', '', 0);
        token_t.content = state.md.normalizeLinkText(url);
        const token_c = state.push('link_close', 'a', -1);
        token_c.markup = 'linkify';
        token_c.info = 'auto';
    }
    state.pos += url.length - protoLength;
    return true;
}


// Proceess '\n'

function $4da0439b0e5b89ea$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    const max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                let ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && (0, $acb166200129f66e$export$1d5ccafae59b4926)(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
}


// Process escaped chars and hardbreaks

const $b91dce80827c08a1$var$ESCAPED = [];
for(let i = 0; i < 256; i++)$b91dce80827c08a1$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $b91dce80827c08a1$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
function $b91dce80827c08a1$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    let ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    // '\' before a space is a literal backslash. Don't consume the space, so a
    // trailing two-space hard line break is still detected by the newline rule.
    if (ch1 === 0x20) {
        if (!silent) {
            const token = state.push('text_special', '', 0);
            token.content = '\\';
            token.markup = '\\';
            token.info = 'escape';
        }
        state.pos = pos;
        return true;
    }
    let escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        const ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    const origStr = '\\' + escapedStr;
    if (!silent) {
        const token = state.push('text_special', '', 0);
        if (ch1 < 256 && $b91dce80827c08a1$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
}


// Parse backticks
function $b39c44d4094d07d3$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    const start = pos;
    pos++;
    const max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    const marker = state.src.slice(start, pos);
    const openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    let matchEnd = pos;
    let matchStart;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        const closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                const token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
}


// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $c4e44d3b61071958$var$strikethrough_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    const scanned = state.scanDelims(state.pos, true);
    let len = scanned.length;
    const ch = String.fromCharCode(marker);
    if (len < 2) return false;
    let token;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(let i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $c4e44d3b61071958$var$postProcess(state, delimiters) {
    let token;
    const loneMarkers = [];
    const max = delimiters.length;
    for(let i = 0; i < max; i++){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        const i = loneMarkers.pop();
        let j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $c4e44d3b61071958$var$strikethrough_postProcess(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $c4e44d3b61071958$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $c4e44d3b61071958$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $c4e44d3b61071958$export$2e2bcd8739ae039 = {
    tokenize: $c4e44d3b61071958$var$strikethrough_tokenize,
    postProcess: $c4e44d3b61071958$var$strikethrough_postProcess
};


// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $354922e1ef651ea3$var$emphasis_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    const scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(let i = 0; i < scanned.length; i++){
        const token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            marker: // Char code of the starting marker (number).
            //
            marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $354922e1ef651ea3$var$postProcess(state, delimiters) {
    const max = delimiters.length;
    for(let i = max - 1; i >= 0; i--){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        const ch = String.fromCharCode(startDelim.marker);
        const token_o = state.tokens[startDelim.token];
        token_o.type = isStrong ? 'strong_open' : 'em_open';
        token_o.tag = isStrong ? 'strong' : 'em';
        token_o.nesting = 1;
        token_o.markup = isStrong ? ch + ch : ch;
        token_o.content = '';
        const token_c = state.tokens[endDelim.token];
        token_c.type = isStrong ? 'strong_close' : 'em_close';
        token_c.tag = isStrong ? 'strong' : 'em';
        token_c.nesting = -1;
        token_c.markup = isStrong ? ch + ch : ch;
        token_c.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $354922e1ef651ea3$var$emphasis_post_process(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $354922e1ef651ea3$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $354922e1ef651ea3$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $354922e1ef651ea3$export$2e2bcd8739ae039 = {
    tokenize: $354922e1ef651ea3$var$emphasis_tokenize,
    postProcess: $354922e1ef651ea3$var$emphasis_post_process
};


// Process [link](<to> "stuff")

function $019ddf5760813e0c$export$2e2bcd8739ae039(state, silent) {
    let code, label, res, ref;
    let href = '';
    let title = '';
    let start = state.pos;
    let parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    const oldPos = state.pos;
    const max = state.posMax;
    const labelStart = state.pos + 1;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    let pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $acb166200129f66e$export$20ef46802c8744b)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        const token_o = state.push('link_open', 'a', 1);
        const attrs = [
            [
                'href',
                href
            ]
        ];
        token_o.attrs = attrs;
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}


// Process ![image](<src> "title")

function $f2e767ae90fa58fa$export$2e2bcd8739ae039(state, silent) {
    let code, content, label, pos, ref, res, title, start;
    let href = '';
    const oldPos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    const labelStart = state.pos + 2;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $acb166200129f66e$export$1d5ccafae59b4926)(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $acb166200129f66e$export$20ef46802c8744b)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        const tokens = [];
        state.md.inline.parse(content, state.md, state.env, tokens);
        const token = state.push('image', 'img', 0);
        const attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.attrs = attrs;
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}


// Process autolinks '<protocol:...>'
/* eslint max-len:0 */ const $38fe1de13dbca06b$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
/* eslint-disable-next-line no-control-regex */ const $38fe1de13dbca06b$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function $38fe1de13dbca06b$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    const start = state.pos;
    const max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        const ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    const url = state.src.slice(start + 1, pos);
    if ($38fe1de13dbca06b$var$AUTOLINK_RE.test(url)) {
        const fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($38fe1de13dbca06b$var$EMAIL_RE.test(url)) {
        const fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
}


// Process html tags

function $c398d6df9e0474f7$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $c398d6df9e0474f7$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $c398d6df9e0474f7$var$isLetter(ch) {
    /* eslint no-bitwise:0 */ const lc = ch | 0x20 // to lower case
    ;
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
function $c398d6df9e0474f7$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.html) return false;
    // Check start
    const max = state.posMax;
    const pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    const ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$c398d6df9e0474f7$var$isLetter(ch)) return false;
    const match = state.src.slice(pos).match((0, $08e6c33d10f51cc6$export$6db61d2c3a16e419));
    if (!match) return false;
    if (!silent) {
        const token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($c398d6df9e0474f7$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($c398d6df9e0474f7$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
}


// Process html entity - &#123;, &#xAF;, &quot;, ...


const $2605af2f776ac07c$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
const $2605af2f776ac07c$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
function $2605af2f776ac07c$export$2e2bcd8739ae039(state, silent) {
    const pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    const ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        const match = state.src.slice(pos).match($2605af2f776ac07c$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                const code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                const token = state.push('text_special', '', 0);
                token.content = (0, $acb166200129f66e$export$644a8f5b13b2a36d)(code) ? (0, $acb166200129f66e$export$73bfc63873071f74)(code) : (0, $acb166200129f66e$export$73bfc63873071f74)(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        const match = state.src.slice(pos).match($2605af2f776ac07c$var$NAMED_RE);
        if (match) {
            const decoded = (0, $bfba20002d453b69$export$da52f4371b3f37de)(match[0]);
            if (decoded !== match[0]) {
                if (!silent) {
                    const token = state.push('text_special', '', 0);
                    token.content = decoded;
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
}


// For each opening emphasis-like marker find a matching closing one
//
function $86b620d722e5f8d3$var$processDelimiters(delimiters) {
    const openersBottom = {};
    const max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    let headerIdx = 0;
    let lastTokenIdx = -2 // needs any value lower than -1
    ;
    const jumps = [];
    for(let closerIdx = 0; closerIdx < max; closerIdx++){
        const closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        /* eslint-disable-next-line no-prototype-builtins */ if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        let openerIdx = headerIdx - jumps[headerIdx] - 1;
        let newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            const opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                let isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
function $86b620d722e5f8d3$export$2e2bcd8739ae039(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $86b620d722e5f8d3$var$processDelimiters(state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $86b620d722e5f8d3$var$processDelimiters(tokens_meta[curr].delimiters);
}


// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
function $657f3da74a75df34$export$2e2bcd8739ae039(state) {
    let curr, last;
    let level = 0;
    const tokens = state.tokens;
    const max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level-- // closing tag
        ;
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++ // opening tag
        ;
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
}


// Parser rules
const $086c870d02d0d269$var$_rules = [
    [
        'text',
        (0, $52dad52dbdb68874$export$2e2bcd8739ae039)
    ],
    [
        'linkify',
        (0, $d922190b2670a68c$export$2e2bcd8739ae039)
    ],
    [
        'newline',
        (0, $4da0439b0e5b89ea$export$2e2bcd8739ae039)
    ],
    [
        'escape',
        (0, $b91dce80827c08a1$export$2e2bcd8739ae039)
    ],
    [
        'backticks',
        (0, $b39c44d4094d07d3$export$2e2bcd8739ae039)
    ],
    [
        'strikethrough',
        (0, $c4e44d3b61071958$export$2e2bcd8739ae039).tokenize
    ],
    [
        'emphasis',
        (0, $354922e1ef651ea3$export$2e2bcd8739ae039).tokenize
    ],
    [
        'link',
        (0, $019ddf5760813e0c$export$2e2bcd8739ae039)
    ],
    [
        'image',
        (0, $f2e767ae90fa58fa$export$2e2bcd8739ae039)
    ],
    [
        'autolink',
        (0, $38fe1de13dbca06b$export$2e2bcd8739ae039)
    ],
    [
        'html_inline',
        (0, $c398d6df9e0474f7$export$2e2bcd8739ae039)
    ],
    [
        'entity',
        (0, $2605af2f776ac07c$export$2e2bcd8739ae039)
    ]
];
// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
const $086c870d02d0d269$var$_rules2 = [
    [
        'balance_pairs',
        (0, $86b620d722e5f8d3$export$2e2bcd8739ae039)
    ],
    [
        'strikethrough',
        (0, $c4e44d3b61071958$export$2e2bcd8739ae039).postProcess
    ],
    [
        'emphasis',
        (0, $354922e1ef651ea3$export$2e2bcd8739ae039).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (0, $657f3da74a75df34$export$2e2bcd8739ae039)
    ]
];
/**
 * new ParserInline()
 **/ function $086c870d02d0d269$var$ParserInline() {
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new (0, $41ea3ea6c70806b8$export$2e2bcd8739ae039)();
    for(let i = 0; i < $086c870d02d0d269$var$_rules.length; i++)this.ruler.push($086c870d02d0d269$var$_rules[i][0], $086c870d02d0d269$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new (0, $41ea3ea6c70806b8$export$2e2bcd8739ae039)();
    for(let i = 0; i < $086c870d02d0d269$var$_rules2.length; i++)this.ruler2.push($086c870d02d0d269$var$_rules2[i][0], $086c870d02d0d269$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$086c870d02d0d269$var$ParserInline.prototype.skipToken = function(state) {
    const pos = state.pos;
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    const cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    let ok = false;
    if (state.level < maxNesting) for(let i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$086c870d02d0d269$var$ParserInline.prototype.tokenize = function(state) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const end = state.posMax;
    const maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        const prevPos = state.pos;
        let ok = false;
        if (state.level < maxNesting) for(let i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $086c870d02d0d269$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    const state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    const rules = this.ruler2.getRules('');
    const len = rules.length;
    for(let i = 0; i < len; i++)rules[i](state);
};
$086c870d02d0d269$var$ParserInline.prototype.State = (0, $78766ebe20d230e1$export$2e2bcd8739ae039);
var $086c870d02d0d269$export$2e2bcd8739ae039 = $086c870d02d0d269$var$ParserInline;



function $8395954499c294bc$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $cbc832af4f488565$export$2e2bcd8739ae039).source;
    re.src_Cc = (0, $c23f5f283a1bf321$export$2e2bcd8739ae039).source;
    re.src_Z = (0, $df20dc3bfc54166a$export$2e2bcd8739ae039).source;
    re.src_P = (0, $e24366eb89af439c$export$2e2bcd8739ae039).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = `(?:(?!${text_separators}|${re.src_ZPCc})${re.src_Any})`;
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    // Length is capped to exclude possible rescans till the end and avoid O(n^2)
    // DoS. No standard limit, just take something reasonable.
    re.src_auth = `(?:(?:(?!${re.src_ZCc}|[@/\\[\\]()]).){1,50}@)?`;
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = `(?=$|${text_separators}|${re.src_ZPCc})` + `(?!${opts['---'] ? '-(?!--)|' : '-|'}_|:\\d|\\.-|\\.(?!$|${re.src_ZPCc}))`;
    re.src_path = "(?:[/?#](?:" + `(?!${re.src_ZCc}|${text_separators}|[()[\\]{}.,"'?!\\-;]).|` + `\\[(?:(?!${re.src_ZCc}|\\]).)*\\]|` + `\\((?:(?!${re.src_ZCc}|[)]).)*\\)|` + `\\{(?:(?!${re.src_ZCc}|[}]).)*\\}|` + `\\"(?:(?!${re.src_ZCc}|["]).)+\\"|` + `\\'(?:(?!${re.src_ZCc}|[']).)+\\'|` + // allow `I'm_king` if no pair found
    `\\'(?=${re.src_pseudo_letter}|[-])|` + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.{2,}[a-zA-Z0-9%/&]|' + `\\.(?!${re.src_ZCc}|[.]|$)|` + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + // allow `,,,` in paths
    `,(?!${re.src_ZCc}|$)|` + // allow `;` if not followed by space-like char
    `;(?!${re.src_ZCc}|$)|` + // allow `!!!` in paths, but not at the end
    `\\!+(?!${re.src_ZCc}|[!]|$)|` + `\\?(?!${re.src_ZCc}|[?]|$)` + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    // Max name length capped to 64 chars (RFC 5321). This also prevents O(n^2)
    // rescans to the end on inputs like `mailto:mailto:...`
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]{0,63}';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + `${re.src_pseudo_letter}{1,63}` + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + `(?:${re.src_pseudo_letter})` + '|' + `(?:${re.src_pseudo_letter}(?:-|${re.src_pseudo_letter}){0,61}${re.src_pseudo_letter})` + ')';
    re.src_host = '(?:' + // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
    `(?:(?:(?:${re.src_domain})\\.)*${re.src_domain})` + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + `(?:(?:(?:${re.src_domain})\\.)+(?:%TLDS%))` + ')';
    re.tpl_host_no_ip_fuzzy = `(?:(?:(?:${re.src_domain})\\.)+(?:%TLDS%))`;
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = `localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:${re.src_ZPCc}|>|$))`;
    re.tpl_email_fuzzy = `(^|${text_separators}|"|\\(|${re.src_ZCc})` + `(${re.src_email_name}@${re.tpl_host_fuzzy_strict})`;
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    `(^|(?![.:/\\-_@])(?:[$+<=>^\`|\uff5c]|${re.src_ZPCc}))` + `((?![$+<=>^\`|\uff5c])${re.tpl_host_port_fuzzy_strict}${re.src_path})`;
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    `(^|(?![.:/\\-_@])(?:[$+<=>^\`|\uff5c]|${re.src_ZPCc}))` + `((?![$+<=>^\`|\uff5c])${re.tpl_host_port_no_ip_fuzzy_strict}${re.src_path})`;
    return re;
}


//
// Helpers
//
// Merge objects
//
function $fdfb0b45a2ba540e$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $fdfb0b45a2ba540e$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $fdfb0b45a2ba540e$var$isString(obj) {
    return $fdfb0b45a2ba540e$var$_class(obj) === '[object String]';
}
function $fdfb0b45a2ba540e$var$isObject(obj) {
    return $fdfb0b45a2ba540e$var$_class(obj) === '[object Object]';
}
function $fdfb0b45a2ba540e$var$isRegExp(obj) {
    return $fdfb0b45a2ba540e$var$_class(obj) === '[object RegExp]';
}
function $fdfb0b45a2ba540e$var$isFunction(obj) {
    return $fdfb0b45a2ba540e$var$_class(obj) === '[object Function]';
}
function $fdfb0b45a2ba540e$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
//
const $fdfb0b45a2ba540e$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $fdfb0b45a2ba540e$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $fdfb0b45a2ba540e$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $fdfb0b45a2ba540e$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp(`^\\/\\/${self.re.src_auth}${self.re.src_host_port_strict}${self.re.src_path}`, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            `(?:localhost|(?:(?:${self.re.src_domain})\\.)+${self.re.src_domain_root})` + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp(`^${self.re.src_email_name}@${self.re.src_host_strict}`, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
const $fdfb0b45a2ba540e$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $fdfb0b45a2ba540e$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
function $fdfb0b45a2ba540e$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $fdfb0b45a2ba540e$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $fdfb0b45a2ba540e$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $8395954499c294bc$export$2e2bcd8739ae039)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($fdfb0b45a2ba540e$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.email_fuzzy_global = RegExp(untpl(re.tpl_email_fuzzy), 'ig');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_fuzzy_global = RegExp(untpl(re.tpl_link_fuzzy), 'ig');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.link_no_ip_fuzzy_global = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'ig');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {} // Reset compiled data
    ;
    function schemaError(name, val) {
        throw new Error(`(LinkifyIt) Invalid schema "${name}": ${val}`);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($fdfb0b45a2ba540e$var$isObject(val)) {
            if ($fdfb0b45a2ba540e$var$isRegExp(val.validate)) compiled.validate = $fdfb0b45a2ba540e$var$createValidator(val.validate);
            else if ($fdfb0b45a2ba540e$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($fdfb0b45a2ba540e$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $fdfb0b45a2ba540e$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($fdfb0b45a2ba540e$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $fdfb0b45a2ba540e$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($fdfb0b45a2ba540e$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp(`(^|(?!_)(?:[><\uff5c]|${re.src_ZPCc}))(${slist})`, 'i');
    self.re.schema_search = RegExp(`(^|(?!_)(?:[><\uff5c]|${re.src_ZPCc}))(${slist})`, 'ig');
    self.re.schema_at_start = RegExp(`^${self.re.schema_search.source}`, 'i');
    self.re.pretest = RegExp(`(${self.re.schema_test.source})|(${self.re.host_fuzzy_test.source})|@`, 'i');
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $fdfb0b45a2ba540e$var$Match(text, schema, index, lastIndex) {
    const raw = text.slice(index, lastIndex);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = schema.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = index;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = lastIndex;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = raw;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = raw;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = raw;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $fdfb0b45a2ba540e$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $fdfb0b45a2ba540e$var$LinkifyIt)) return new $fdfb0b45a2ba540e$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($fdfb0b45a2ba540e$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $fdfb0b45a2ba540e$var$assign({}, $fdfb0b45a2ba540e$var$defaultOptions, options);
    this.__schemas__ = $fdfb0b45a2ba540e$var$assign({}, $fdfb0b45a2ba540e$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $fdfb0b45a2ba540e$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $fdfb0b45a2ba540e$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $fdfb0b45a2ba540e$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $fdfb0b45a2ba540e$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.test = function test(text) {
    if (!text.length) return false;
    let m, re;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            if (this.testSchemaAt(text, m[2], re.lastIndex)) return true;
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) // guess schemaless links
    {
        if (text.search(this.re.host_fuzzy_test) >= 0) {
            if (text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy) !== null) return true;
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) // guess schemaless emails
    {
        if (text.indexOf('@') >= 0) {
            // We can't skip this check, because this cases are possible:
            // 192.168.1.1@gmail.com, my.in@example.com
            if (text.match(this.re.email_fuzzy) !== null) return true;
        }
    }
    return false;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    const type_schemed = [];
    const type_fuzzy_link = [];
    const type_fuzzy_email = [];
    let m, len, re;
    function choose(a, b) {
        if (!a) return b;
        if (!b) return a;
        if (a.index !== b.index) return a.index < b.index ? a : b;
        return a.lastIndex >= b.lastIndex ? a : b;
    }
    if (!text.length) return null;
    // scan for links with schema
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) type_schemed.push({
                schema: m[2],
                index: m.index + m[1].length,
                lastIndex: m.index + m[0].length + len
            });
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        re = this.__opts__.fuzzyIP ? this.re.link_fuzzy_global : this.re.link_no_ip_fuzzy_global;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null)type_fuzzy_link.push({
            schema: '',
            index: m.index + m[1].length,
            lastIndex: m.index + m[0].length
        });
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        re = this.re.email_fuzzy_global;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null)type_fuzzy_email.push({
            schema: 'mailto:',
            index: m.index + m[1].length,
            lastIndex: m.index + m[0].length
        });
    }
    const indexes = [
        0,
        0,
        0
    ];
    let lastIndex = 0;
    for(;;){
        const candidates = [
            type_schemed[indexes[0]],
            type_fuzzy_email[indexes[1]],
            type_fuzzy_link[indexes[2]]
        ];
        const candidate = choose(choose(candidates[0], candidates[1]), candidates[2]);
        if (!candidate) break;
        if (candidate === candidates[0]) indexes[0]++;
        else if (candidate === candidates[1]) indexes[1]++;
        else indexes[2]++;
        if (candidate.index < lastIndex) continue;
        const match = new $fdfb0b45a2ba540e$var$Match(text, candidate.schema, candidate.index, candidate.lastIndex);
        this.__compiled__[match.schema].normalize(match, this);
        result.push(match);
        lastIndex = candidate.lastIndex;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    const match = new $fdfb0b45a2ba540e$var$Match(text, m[2], m.index + m[1].length, m.index + m[0].length + len);
    this.__compiled__[match.schema].normalize(match, this);
    return match;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $fdfb0b45a2ba540e$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $fdfb0b45a2ba540e$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = `http://${match.url}`;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = `mailto:${match.url}`;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $fdfb0b45a2ba540e$export$2e2bcd8739ae039 = $fdfb0b45a2ba540e$var$LinkifyIt;



'use strict';
/** Highest positive signed 32-bit float value */ const $cc1c99c5745bccf3$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $cc1c99c5745bccf3$var$base = 36;
const $cc1c99c5745bccf3$var$tMin = 1;
const $cc1c99c5745bccf3$var$tMax = 26;
const $cc1c99c5745bccf3$var$skew = 38;
const $cc1c99c5745bccf3$var$damp = 700;
const $cc1c99c5745bccf3$var$initialBias = 72;
const $cc1c99c5745bccf3$var$initialN = 128; // 0x80
const $cc1c99c5745bccf3$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $cc1c99c5745bccf3$var$regexPunycode = /^xn--/;
const $cc1c99c5745bccf3$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $cc1c99c5745bccf3$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $cc1c99c5745bccf3$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $cc1c99c5745bccf3$var$baseMinusTMin = $cc1c99c5745bccf3$var$base - $cc1c99c5745bccf3$var$tMin;
const $cc1c99c5745bccf3$var$floor = Math.floor;
const $cc1c99c5745bccf3$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $cc1c99c5745bccf3$var$error(type) {
    throw new RangeError($cc1c99c5745bccf3$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $cc1c99c5745bccf3$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $cc1c99c5745bccf3$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($cc1c99c5745bccf3$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $cc1c99c5745bccf3$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $cc1c99c5745bccf3$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $cc1c99c5745bccf3$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $cc1c99c5745bccf3$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $cc1c99c5745bccf3$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $cc1c99c5745bccf3$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $cc1c99c5745bccf3$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $cc1c99c5745bccf3$var$floor(delta / $cc1c99c5745bccf3$var$damp) : delta >> 1;
    delta += $cc1c99c5745bccf3$var$floor(delta / numPoints);
    for(; delta > $cc1c99c5745bccf3$var$baseMinusTMin * $cc1c99c5745bccf3$var$tMax >> 1; k += $cc1c99c5745bccf3$var$base)delta = $cc1c99c5745bccf3$var$floor(delta / $cc1c99c5745bccf3$var$baseMinusTMin);
    return $cc1c99c5745bccf3$var$floor(k + ($cc1c99c5745bccf3$var$baseMinusTMin + 1) * delta / (delta + $cc1c99c5745bccf3$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $cc1c99c5745bccf3$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $cc1c99c5745bccf3$var$initialN;
    let bias = $cc1c99c5745bccf3$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($cc1c99c5745bccf3$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $cc1c99c5745bccf3$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $cc1c99c5745bccf3$var$base;; k += $cc1c99c5745bccf3$var$base){
            if (index >= inputLength) $cc1c99c5745bccf3$var$error('invalid-input');
            const digit = $cc1c99c5745bccf3$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $cc1c99c5745bccf3$var$base) $cc1c99c5745bccf3$var$error('invalid-input');
            if (digit > $cc1c99c5745bccf3$var$floor(($cc1c99c5745bccf3$var$maxInt - i) / w)) $cc1c99c5745bccf3$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $cc1c99c5745bccf3$var$tMin : k >= bias + $cc1c99c5745bccf3$var$tMax ? $cc1c99c5745bccf3$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $cc1c99c5745bccf3$var$base - t;
            if (w > $cc1c99c5745bccf3$var$floor($cc1c99c5745bccf3$var$maxInt / baseMinusT)) $cc1c99c5745bccf3$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $cc1c99c5745bccf3$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($cc1c99c5745bccf3$var$floor(i / out) > $cc1c99c5745bccf3$var$maxInt - n) $cc1c99c5745bccf3$var$error('overflow');
        n += $cc1c99c5745bccf3$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $cc1c99c5745bccf3$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $cc1c99c5745bccf3$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $cc1c99c5745bccf3$var$initialN;
    let delta = 0;
    let bias = $cc1c99c5745bccf3$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($cc1c99c5745bccf3$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($cc1c99c5745bccf3$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $cc1c99c5745bccf3$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $cc1c99c5745bccf3$var$floor(($cc1c99c5745bccf3$var$maxInt - delta) / handledCPCountPlusOne)) $cc1c99c5745bccf3$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $cc1c99c5745bccf3$var$maxInt) $cc1c99c5745bccf3$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $cc1c99c5745bccf3$var$base;; k += $cc1c99c5745bccf3$var$base){
                    const t = k <= bias ? $cc1c99c5745bccf3$var$tMin : k >= bias + $cc1c99c5745bccf3$var$tMax ? $cc1c99c5745bccf3$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $cc1c99c5745bccf3$var$base - t;
                    output.push($cc1c99c5745bccf3$var$stringFromCharCode($cc1c99c5745bccf3$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $cc1c99c5745bccf3$var$floor(qMinusT / baseMinusT);
                }
                output.push($cc1c99c5745bccf3$var$stringFromCharCode($cc1c99c5745bccf3$var$digitToBasic(q, 0)));
                bias = $cc1c99c5745bccf3$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $cc1c99c5745bccf3$export$110c810e8727e62b = function(input) {
    return $cc1c99c5745bccf3$var$mapDomain(input, function(string) {
        return $cc1c99c5745bccf3$var$regexPunycode.test(string) ? $cc1c99c5745bccf3$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $cc1c99c5745bccf3$export$69111c4ea6e0c4a0 = function(input) {
    return $cc1c99c5745bccf3$var$mapDomain(input, function(string) {
        return $cc1c99c5745bccf3$var$regexNonASCII.test(string) ? 'xn--' + $cc1c99c5745bccf3$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $cc1c99c5745bccf3$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $cc1c99c5745bccf3$export$c1700176c90f250f,
        'encode': $cc1c99c5745bccf3$export$f999239d9b149395
    },
    'decode': $cc1c99c5745bccf3$export$2f872c0f2117be69,
    'encode': $cc1c99c5745bccf3$export$c564cdbbe6da493,
    'toASCII': $cc1c99c5745bccf3$export$69111c4ea6e0c4a0,
    'toUnicode': $cc1c99c5745bccf3$export$110c810e8727e62b
};
var $cc1c99c5745bccf3$export$2e2bcd8739ae039 = $cc1c99c5745bccf3$var$punycode;


// markdown-it default options
var $3fe4a7f778f0f36e$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};


// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
var $d8eecf2af6991231$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};


// Commonmark default options
var $b06235d334be6c3f$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: true,
        // Use '/' to close single tags (<br />)
        xhtmlOut: true,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};


const $0d15360f132ce1e2$var$config = {
    default: (0, $3fe4a7f778f0f36e$export$2e2bcd8739ae039),
    zero: (0, $d8eecf2af6991231$export$2e2bcd8739ae039),
    commonmark: (0, $b06235d334be6c3f$export$2e2bcd8739ae039)
};
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
const $0d15360f132ce1e2$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
const $0d15360f132ce1e2$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $0d15360f132ce1e2$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    const str = url.trim().toLowerCase();
    return $0d15360f132ce1e2$var$BAD_PROTO_RE.test(str) ? $0d15360f132ce1e2$var$GOOD_DATA_RE.test(str) : true;
}
const $0d15360f132ce1e2$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $0d15360f132ce1e2$var$normalizeLink(url) {
    const parsed = $544ec39afc7ce01f$export$2e2bcd8739ae039(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $0d15360f132ce1e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $cc1c99c5745bccf3$export$2e2bcd8739ae039).toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $a16db32880174ee4$export$2e2bcd8739ae039($555640cbd60e2fdc$export$2e2bcd8739ae039(parsed));
}
function $0d15360f132ce1e2$var$normalizeLinkText(url) {
    const parsed = $544ec39afc7ce01f$export$2e2bcd8739ae039(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $0d15360f132ce1e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $cc1c99c5745bccf3$export$2e2bcd8739ae039).toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $0d34e69e6f2a0359$export$2e2bcd8739ae039($555640cbd60e2fdc$export$2e2bcd8739ae039(parsed), $0d34e69e6f2a0359$export$2e2bcd8739ae039.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.mjs) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.mjs) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.mjs) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.mjs) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>` or `<code>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre><code class="hljs">' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre><code class="hljs">' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $0d15360f132ce1e2$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $0d15360f132ce1e2$var$MarkdownIt)) return new $0d15360f132ce1e2$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$acb166200129f66e$exports.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new (0, $086c870d02d0d269$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new (0, $3349c57a2e9a47a9$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new (0, $1dbd8732bf2ea1e5$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs).
   **/ this.renderer = new (0, $1aad198f750e42d7$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.mjs)
   * rule.
   **/ this.linkify = new (0, $fdfb0b45a2ba540e$export$2e2bcd8739ae039)();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $0d15360f132ce1e2$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $0d15360f132ce1e2$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $0d15360f132ce1e2$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.mjs).
   **/ this.utils = $acb166200129f66e$exports;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $acb166200129f66e$exports.assign({}, $99119f957fdc25f6$exports);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer: true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.set = function(options) {
    $acb166200129f66e$exports.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.configure = function(presets) {
    const self = this;
    if ($acb166200129f66e$exports.isString(presets)) {
        const presetName = presets;
        presets = $0d15360f132ce1e2$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    const args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    const state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.parseInline = function(src, env) {
    const state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
var $0d15360f132ce1e2$export$2e2bcd8739ae039 = $0d15360f132ce1e2$var$MarkdownIt;





var $d9716ee0dfd0c27d$exports = {};
$d9716ee0dfd0c27d$exports = JSON.parse('{"LogbookApp_version_major":"1.1","RecordingClockWarning_title":"Recording time warning","RecordingClockWarning_acknowledge":"Acknowledge","RecordingClockWarning_system":"The computer clock is unreliable. Recording continues using GPS time.","RecordingClockWarning_gps":"The GPS clock is unreliable. Recording continues using the computer clock.","RecordingClockWarning_paused":"No reliable time source is available. Automatic recording and new current-time entries are paused until GPS or the computer clock recovers. Historical entries can still be edited.","Layout":"","Layout_documentation":"DOCUMENTATION","Layout_support":"Support","OpenServerDialog_title":"Open LOGBOOK Cloud","OpenServerDialog_opening":"Opening LOGBOOK Cloud...","OpenServerDialog_failed":"LOGBOOK Cloud could not be opened. Check your connection and allow pop-up windows, then try again.","OpenServerDialog_close":"Close","OpenServerDialog_retry":"Try again","AboutView":"","AboutView_title":"About LOGBOOK","AboutView_version":"Version","AboutView_website":"Website","AboutView_support":"Support","AboutView_copyright":"Copyright \xa9 2026 by Trimutic UG","AboutView_uploadAppData":"Upload App data to Support","AboutView_uploadAppDataUploading":"Uploading\u2026","AboutView_uploadAppDataSuccess":"App data uploaded","AboutView_uploadAppDataError":"Failed to upload app data","AccountView":"","AccountView_cancel":"Cancel","AccountView_cancel_plan":"Cancel plan","AccountView_currency":"Currency","AccountView_currency_EUR":"Euro (\u20AC)","AccountView_currency_USD":"US Dollar ($)","AccountView_duration":"Duration","AccountView_duration_5":"5 days","AccountView_duration_30":"monthly\xa0billing, monthly\xa0cancelable","AccountView_duration_120":"4 months","AccountView_duration_365":"annual\xa0billing, annually\xa0cancelable","AccountView_duration_30_iap":"monthly\xa0billing, auto-renews unless\xa0canceled","AccountView_feature_active_ships":"Active Ships: {amount}","AccountView_feature_active_users":"Active Users: {amount}","AccountView_feature_active_tenders":"Active Tenders: {amount}","AccountView_feature_support_1":"Standard Support","AccountView_feature_support_10":"Pro-Support","AccountView_feature_support_100":"Master Support","AccountView_feature_unlimited":"Unlimited","AccountView_pay":"Confirm recurring payment of {price}","AccountView_pay_cancel":"Cancel","AccountView_pay_processing":"Processing payment...","AccountView_payment_information":"Payment information","AccountView_payment_title":"{plan} subscription for {price}","AccountView_plans":"Our subscription plans","AccountView_plans_iPad":"Your LOGBOOK subscription","AccountView_plan_captain":"LOGBOOK Captain","AccountView_plan_master_captain":"LOGBOOK Master Captain","AccountView_plan_skipper":"LOGBOOK Skipper","AccountView_plan_trial":"LOGBOOK Trial","AccountView_price_duration_5":"5 days","AccountView_price_duration_30":"month","AccountView_price_duration_365":"year","AccountView_price_free":"Free","AccountView_price_EUR":"{price} \u20AC per {duration}","AccountView_price_USD":"${price} per {duration}","AccountView_price_native":"{price} per {duration}","AccountView_price_or_monthly":" or ","AccountView_select_plan":"Select plan","AccountView_subscribe":"Subscribe","AccountView_subscribe_api":"Subscribe","AccountView_time_left":"{days} days left","AccountView_renews_in":"Renews in {days} days","AccountView_cancelled_ends":"Cancelled \u2014 access ends in {days} days","AccountView_apple_cancel_info_title":"Manage your subscription","AccountView_apple_cancel_info_message":"This subscription was purchased through the App Store, so it must be managed there. On your iPhone or iPad, open Settings, tap your name, then Subscriptions, select LOGBOOK and cancel it there. Your access stays active until the end of the current billing period.","AccountView_taxes":"Taxes included","AccountView_terms_of_use":"Terms of Use","AccountView_privacy_policy":"Privacy Policy","AccountView_restore_purchases":"Restore Purchases","AccountView_restore_purchases_running":"Restoring\u2026","AccountView_restore_nothing_title":"No purchases found","AccountView_restore_nothing_message":"There is no active subscription on this Apple ID to restore.","AccountView_restore_claim_title":"Move subscription","AccountView_restore_claim_message":"This Apple ID\'s subscription is currently linked to \u201C{account}\u201D. Move it to \u201C{current}\u201D? \u201C{account}\u201D will lose access.","AccountView_restore_claim_confirm":"Move it here","AccountView_restore_claim_cancel":"Keep it there","AccountView_linked_to_other_account":"This Apple ID\'s subscription is linked to the Logbook account \u201C{account}\u201D.","AccountView_linked_to_other_account_hint":"Use Restore Purchases to move it to this account, or pay by card on the web.","AccountView_title":"Account Settings","AccountView_total":"Total due","AccountSettingsView_alert_no_internet_title":"No internet connection available","AccountSettingsView_alert_no_internet_text":"An internet connection is required to change account settings.","AccountSettingsView_error_passwordInvalid":"Entered password does not match the current one.","AccountSettingsView_error_passwordConfirmationMismatch":"Password confirmation does not match password.","AccountSettingsView_error_Not Found":"Not found","AccountSettingsView_error_accountUserSelfAction":"You can\'t change, deactivate, or remove your own account access.","AccountSettingsView_error_accountUserLastAdmin":"The account must keep at least one active admin.","AccountSettingsView_error_account_user_action_failed":"Something went wrong. Please try again.","AccountSettingsView_error_account_update_failed":"Something went wrong. Please try again.","AccountSettingsView_change_password":"Change password","AccountSettingsView_confirm_new_password":"New password confirmation","AccountSettingsView_current_password":"Current password","AccountSettingsView_new_password":"New password","AccountSettingsView_import_ship":"Import from LogbookSuite","AccountSettingsView_import_trips":"Import Passages for \\"{name}\\" from LogbookSuite","AccountSettingsView_new_ship":"Start with a new Ship","AccountSettingsView_select_ship":"Select from your Ships","AccountSettingsView_select_shared_ship":"Select from shared Ships","AccountSettingsView_deselect_ship":"Close Ship","AccountSettingsView_add_new_ship":"Add new Ship","AccountSettingsView_users_list":"List of all users in your account","AccountSettingsView_tab_ships":"Your Ships","AccountSettingsView_tab_subscription":"Your Subscription","AccountSettingsView_tab_users":"Your Users","AccountSettingsView_ship_open_here_notice":"Close the LOGBOOK you already have open on this device to select another ship.","AccountSettingsView_companion_reconnect_notice":"The connection to your Primary LOGBOOK was lost \u2014 its address on this network may have changed. Connect again to continue.","AccountSettingsView_ship_close_companion":"Disconnect LOGBOOK Companion","AccountSettingsView_ship_close_confirm":"Close LOGBOOK","AccountSettingsView_ship_logbook":"View LOGBOOK for \\"{name}\\"","AccountSettingsView_account_data":"Your account data","AccountSettingsView_account_edit_cancel":"Cancel","AccountSettingsView_account_edit_save":"Save","AccountSettingsView_account_login":"Login name (email)","AccountSettingsView_account_name":"Account name","AccountSettingsView_account_settings":"Account Settings","AccountSettingsView_account_user_level":"Permissions","AccountSettingsView_account_user_level_admin":"Admin","AccountSettingsView_account_user_level_user":"User","AccountSettingsView_account_user_level_disabled":"Deactivated","AccountSettingsView_deactivate_user":"Deactivate","AccountSettingsView_reactivate_user":"Reactivate","AccountSettingsView_remove_user":"Remove","AccountSettingsView_user_deactivate_confirm_title":"Deactivate user","AccountSettingsView_user_deactivate_confirm_message":"This user still has access to a ship on this account. Do you really want to deactivate their account?","AccountSettingsView_user_deactivate_confirm_accept":"Deactivate","AccountSettingsView_user_deactivate_confirm_cancel":"Cancel","AccountSettingsView_user_remove_confirm_title":"Remove user","AccountSettingsView_user_remove_confirm_message":"This user still has access to a ship on this account. Do you really want to remove them from the account? This cannot be undone.","AccountSettingsView_user_remove_confirm_accept":"Remove","AccountSettingsView_user_remove_confirm_cancel":"Cancel","AccountSettingsView_change_plan":"Change your plan","AccountSettingsView_customer_name":"Name","AccountSettingsView_edit_account":"Edit account","AccountSettingsView_remove_account":"Remove account","AccountSettingsView_plan":"Your current plan","AccountSettingsView_plans":"LOGBOOK Plans","AccountSettingsView_subscription":"Your Subscription","AccountSettingsView_user_account":"Account","AccountSettingsView_user_name":"Name","AccountSettingsView_user_email":"Email","AccountSettingsView_user_shortname":"Short name","AccountSettingsView_user_status":"Status","AccountSettingsView_user_status_active":"Active","AccountSettingsView_user_status_invited":"Invited","AccountSettingsView_user_permissions":"Permissions","AccountSettingsView_current_ship":"Your current ship is {name}","AccountSettingsView_no_current_ship":"No ship is selected","AccountSettingsView_valid_until":"Valid until","AccountSettingsView_trial_days_remaining":"Trial days remaining","AccountSettingsView_trial_days_value":"{days} days","AccountSettingsView_user_crew_role":"Crew role","AccountSettingsView_ship_user_crew_role_crew":"Crew","AccountSettingsView_ship_user_crew_role_none":"None","AccountSettingsView_ship_user_crew_role_owner":"Account holder","AccountSettingsView_ship_user_crew_role_skipper":"Skipper","AccountSettingsView_ship_user_level":"Permissions","AccountSettingsView_ship_user_level_primary":"Primary","AccountSettingsView_ship_user_level_editAll":"View and edit all","AccountSettingsView_ship_user_level_editCurrent":"View and edit current voyage","AccountSettingsView_ship_user_level_viewAll":"View all","AccountSettingsView_ship_user_level_viewCurrent":"View current voyage","AccountSettingsView_ship_user_level_none":"None","AppDisconnectedView":"","AppDisconnectedView_connection_overlay_reload":"Reload","AppDisconnectedView_connection_overlay_reloading":"Reloading \u2026","AppDisconnectedView_connection_overlay_title":"Connection interrupted","AppDisconnectedView_disconnect_companion":"Disconnect LOGBOOK Companion","AppHeaderView":"","AppOverlayContentView":"","AppOverlayContentView_cancel":"Cancel","AppOverlayContentView_connect_logbook":"Connect with Primary LOGBOOK","AppOverlayContentView_connect_logbook_title":"Connect with Primary LOGBOOK for \\"{name}\\"","AppOverlayContentView_connect_logbook_failed":"Failed to connect with Primary LOGBOOK","AppOverlayContentView_connect_logbook_connecting":"Connecting with the Primary LOGBOOK for \\"{name}\\"\u2026","AppOverlayContentView_connect_logbook_connecting_short":"Connecting\u2026","AppOverlayContentView_connect_logbook_timeout":"Could not reach \\"{name}\\" automatically \u2014 enter its address","AppOverlayContentView_connect_logbook_not_discovered":"\u201C{name}\u201D isn\u2019t visible on this network. Check that both devices use the same Wi-Fi, or enter its address below.","AppOverlayContentView_connect_logbook_ambiguous":"More than one device is offering \u201C{name}\u201D. Enter the address of the one you want to connect to.","AppOverlayContentView_connect_logbook_unresolved":"\u201C{name}\u201D was found, but its address could not be determined. Enter it below.","AppOverlayContentView_connect_logbook_unreachable":"No answer from \u201C{name}\u201D at {address}. Check the address, and that both devices are on the same network.","AppOverlayContentView_connect_logbook_refused":"\u201C{name}\u201D refused the connection. Make sure this device\u2019s user has access to that logbook.","AppOverlayContentView_connect_logbook_not_claimed":"\u201C{name}\u201D isn\u2019t open on its Primary LOGBOOK right now. Open it there, then try again.","AppOverlayContentView_connect_logbook_not_accessible":"You don\u2019t have access to \u201C{name}\u201D.","AppOverlayContentView_connect_logbook_address_invalid":"Enter the address as host:port, for example 192.168.1.20:18092.","AppOverlayContentView_connect_logbook_own_device":"\u201C{name}\u201D is this device\u2019s own logbook \u2014 open it instead of connecting to it.","AppOverlayContentView_connect_logbook_outdated_title":"This app is out of date","AppOverlayContentView_connect_logbook_outdated":"The Primary LOGBOOK for \\"{name}\\" runs a newer version than this device. Update LOGBOOK here to connect.","AppOverlayContentView_connect_logbook_outdated_version":"This device runs version {version}.","AppOverlayContentView_connect_logbook_outdated_appstore":"Please update LOGBOOK in the App Store.","AppOverlayContentView_connect_logbook_outdated_playstore":"Please update LOGBOOK in the Play Store.","AppOverlayContentView_connect_logbook_outdated_download":"Download the latest version","AppOverlayContentView_connection":"Enter the IP and port of the Primary LOGBOOK to establish a connection. Use the format \\"IP:Port\\", e.g. \\"192.168.0.100:8000\\".","AppOverlayContentView_connection_host":"Host","AppOverlayContentView_connection_port":"Port","AppOverlayContentView_disconnect_logbook":"Disconnect Primary LOGBOOK","AppOverlayContentView_disconnect_ship":"Disconnect Ship","AppOverlayContentView_disconnect_ship_title":"Disconnect the Ship from LOGBOOK Cloud","AppOverlayContentView_import_reset":"Reset all imported data","AppOverlayContentView_import_reset_confirm_title":"Reset all imported data?","AppOverlayContentView_import_reset_confirm_text":"This will permanently delete all imported passages. This action cannot be undone.","AppOverlayContentView_import_reset_confirm_no":"Cancel","AppOverlayContentView_import_reset_confirm_yes":"Yes, reset","AppOverlayContentView_import_resetting":"Resetting\u2026","AppOverlayContentView_import_ship_cancel":"Cancel","AppOverlayContentView_import_ship_choose":"Choose file","AppOverlayContentView_import_ship_title":"Import from Logbook Suite","AppOverlayContentView_import_trips":"Import from Logbook Suite","AppOverlayContentView_import_status_in_progress":"Import in progress since {time}","AppOverlayContentView_import_status_complete":"Import completed on {date}","AppOverlayContentView_import_status_failed":"Previous import attempt failed. Please try again or contact support for assistance.","AppOverlayContentView_options_cruises":"Total Voyages in LOGBOOK:","AppOverlayContentView_options_days":"Total Days in LOGBOOK:","AppOverlayContentView_options_first_day":"First day in LOGBOOK:","AppOverlayContentView_options_last_day":"Last day in LOGBOOK:","AppOverlayContentView_options_trips":"Total Passages in LOGBOOK:","AppOverlayContentView_options_ship":"Options for \\"{name}\\"","AppOverlayContentView_options_ship_title":"Info on the Ship","AppOverlayContentView_options_update":"Last Synchronization:","AppOverlayContentView_logout_confirm":"Logout","AppOverlayContentView_logout_confirm_cancel":"Cancel","AppOverlayContentView_logout_confirm_title":"Confirm Logout","AppOverlayContentView_remove_account_cancel":"Cancel","AppOverlayContentView_remove_account_confirm":"Confirm","AppOverlayContentView_remove_account_confirm_title":"Account removal","AppOverlayContentView_session_expired_dismiss":"Continue without syncing","AppOverlayContentView_session_expired_email":"Email","AppOverlayContentView_session_expired_failed":"Login failed. Please check your email and password and try again.","AppOverlayContentView_session_expired_failed_request":"The login could not be sent. Please check your internet connection and try again.","AppOverlayContentView_session_expired_login":"Log in","AppOverlayContentView_session_expired_login_loading":"Logging in\u2026","AppOverlayContentView_session_expired_password":"Password","AppOverlayContentView_session_expired_title":"Login required","AppOverlayContentView_ship_close_confirm":"Confirm Close LOGBOOK","AppOverlayContentView_ship_close_confirm_cancel":"Cancel","AppOverlayContentView_ship_close_confirm_closing":"Closing LOGBOOK\u2026","AppOverlayContentView_ship_close_confirm_title":"Confirm Ship close","AppOverlayContentView_ship_close_failed":"Could not close LOGBOOK. Check your internet connection and try again.","AppOverlayContentView_ship_close_failed_offline":"LOGBOOK could not be closed because this device is offline. Check your internet connection and try again, or close it locally only.","AppOverlayContentView_ship_close_failed_server":"LOGBOOK could not be closed because the LOGBOOK Cloud is temporarily unavailable. Please try again in a moment.","AppOverlayContentView_ship_force_close":"Force close locally","AppOverlayContentView_ship_force_close_confirm":"Confirm force close","AppOverlayContentView_ship_view_ships_cloud":"View Ships list in Cloud","AppOverlayContentView_ships_cloud":"View Ships list in Cloud","AppOverlayContentView_user_settings":"User Settings","AppOverlayContentView_ship_not_closed_title":"Disconnect Primary LOGBOOK \\"{name}\\" from LOGBOOK Cloud","AppOverlayContentView_ship_open_title":"The Primary LOGBOOK for \\"{name}\\" is already open","AppOverlayContentView_read_more":"Read more","ChangeLogView_change_log":"Change Log","ChangeLogView_download":"Download","ChangeLogView_change_welcome":"Welcome to LOGBOOK App Version {version}!","ChangeLogView_change_fixed_info":"Here you will find information on all changes made. The Change Log window will be shown at each reload of the App if there are new changes.","ChangeLogView_new_version_available":"New update available for Download","ChangeLogView_title":"What\'s new in LOGBOOK","Component_ToggleSwitch":"","Component_ToggleSwitch_off":"OFF","Component_ToggleSwitch_on":"ON","CruiseCalendarView":"","CruiseCalendarView_actions_print":"Print","CruiseCalendarView_focus":"Focus","CruiseCalendarView_start_ship":"Open the new ship in the LOGBOOK app","CruiseCalendarView_open_in_cloud":"Open in Cloud","CruiseCalendarView_untitled_cruise":"Untitled voyage","CruiseEditView_title":"Name of the voyage","CruiseView":"","CruiseView_actions_print":"Print","CruiseView_empty":"Create a passage to continue","CruiseView_menu_labels":"Filter","CruiseView_menu_toggle_labels_off":"Labels off","CruiseView_menu_toggle_labels_on":"Labels on","CruiseView_tab_cruise":"Voyage","CruiseView_tab_stats":"Statistics","CruiseView_tab_track":"Track","CruiseView_tab_print":"Print","CruiseView_print_cruise":"Print this voyage","CruiseView_untitled_cruise":"Untitled voyage","DayEditView":"","DayEditView_comment":"Comment","DayEditView_crew":"Crew","DayEditView_end_location":"End location","DayEditView_passengers":"Passengers","DayEditView_skipper":"Skipper","DayEditView_start_location":"Start location","DayEditView_status_day":"Day","DayEditView_status_overnight":"Overnight","DayEditView_sunrise":"Sunrise","DayEditView_sunset":"Sunset","DayEditView_timezone":"Timezone","DayEditView_other_skipper":"New skipper","DayEditView_other_crew":"New person","DayEditView_save_error_generic":"Not saved. Please try again.","DayEditView_details_last_edited_by":"Last edited by {name}","DayEditView_details_last_edited":"Last edited","DayHeaderView":"","DayHeaderView_today":"Today","DayHeaderView_nextDay":"Next day","DayHeaderView_yesterday":"Yesterday","DayView":"","DayView_logs_empty":"No logs yet","DayView_logs_empty_past":"No logs","DayView_tab_day":"Day","DayView_tab_stats":"Statistics","DayView_tab_track":"Track","DayView_tab_watches":"Watch plan","DayView_tab_weather":"Weather","DayView_tab_weather_forecast":"Weather forecast","DayView_tab_journal":"Journal","DayView_tab_technical":"Technical","DayView_tab_print":"Print","DayView_print_days":"Print all days of this passage","DayView_print_day":"Print this day","DayWatchView":"","DayWatchView_groups_title":"Groups for Watches","DayWatchView_add_group":"Add Group","DayWatchView_groups_name":"Watch Group Name","DayWatchView_groups_people":"Crew Members","DayWatchView_shifts_title":"Watch plan","DayWatchView_shifts_hour":"Hour","DayWatchView_shifts_duration":"Duration (h)","DayWatchView_shifts_group":"Watch Group","DayWatchView_shifts_group_undefined":"*Choose*","DayWatchView_add_shift":"Add Watch Shift","DayWatchView_reset_shifts":"Reset Watch Shifts","DayWatchView_shifts_unit_hour":"h","EditHistory":"","EditHistory_title":"History of changes","EditHistory_field":"Field","EditHistory_previous":"Previous","EditHistory_new":"New","EditHistory_changed":"Changed","EditHistory_entry_meta":"{date} by {name}","FocusView":"","FocusView_actions_add_cruise":"Voyage","FocusView_actions_add_trip":"Passage","FocusView_actions_complete_cruise":"Voyage","FocusView_actions_complete_trip":"Passage","FocusView_actions_print":"Print","FocusView_start_trip":"Start Passage","FocusView_cancel":"Cancel","FocusView_close":"Close","FocusView_confirm":"Continue","FocusView_confirm_cruise_title":"Start new Voyage","FocusView_confirm_trip_title":"Start new Passage","FocusView_set_timezone":"Set timezone","FocusView_tile_new_trip":"Starting a new Passage","FocusView_timezone":"Timezone set for the passage","FocusView_current_time":"Calcuated current time","FocusView_subscription_expired":"Subscription ended","FocusView_trial_expired":"Trial phase ended","FocusView_view_plans":"View subscription plans","GraphView":"","GraphView_graph_pressure":"Pressure","GraphView_graph_temperature":"Temperature","GraphView_graph_windDirection":"Wind direction","GraphView_graph_windDirection_unit":"{direction}\xb0","GraphView_graph_windSpeed":"Wind speed","GraphView_no_data":"No data","InstrumentsView":"","InstrumentsView_compass_title":"Compass","InstrumentsView_compass_title_magnetic":"Compass (mag.)","InstrumentsView_compass_title_true":"Compass (true)","InstrumentsView_course_title":"Course","InstrumentsView_depth_title":"Depth","InstrumentsView_depth_title_DBK":"Below Keel","InstrumentsView_depth_title_DBS":"Below Surface","InstrumentsView_depth_title_DBT":"Below Transponder","InstrumentsView_depth_title_DPT":"Water","InstrumentsView_engine_title_single":"Engine","InstrumentsView_engine_title_multiple":"Engines","InstrumentsView_nmea_lost_title":"NMEA connection lost","InstrumentsView_speed_title":"Speed","InstrumentsView_wind_title":"Wind","InstrumentsView_wind_title_apparent":"Apparent","InstrumentsView_wind_title_true":"True","InstrumentsView_wind_title_trueRelative":"True (rel.)","InstrumentsView_wind_side_port":"P","InstrumentsView_wind_side_starboard":"SB","LogEnvironmentView":"","LogEnvironmentView_current_direction_speed":"Current: Direction | Speed","LogEnvironmentView_pressure":"Pressure","LogEnvironmentView_save_error_fields":"Not saved \u2014 not allowed: {fields}","LogEnvironmentView_save_error_generic":"Not saved. Please try again.","LogEnvironmentView_seastate":"Seastate","LogEnvironmentView_seastate_undefined":" ","LogEnvironmentView_seastate_":" ","LogEnvironmentView_seastate_0":"0 Calm (glassy)","LogEnvironmentView_seastate_1":"1 Calm (rippled) < 0.1m","LogEnvironmentView_seastate_2":"2 Smooth (wavelets) < 0.5m","LogEnvironmentView_seastate_3":"3 Slight < 1.25m","LogEnvironmentView_seastate_4":"4 Moderate < 2.5m","LogEnvironmentView_seastate_5":"5 Rough < 4m","LogEnvironmentView_seastate_6":"6 Very rough < 6m","LogEnvironmentView_seastate_7":"7 High < 9m","LogEnvironmentView_seastate_8":"8 Very high < 14m","LogEnvironmentView_seastate_9":"9 Phenomenal > 14m","LogEnvironmentView_seastate_10":"Confused sea swell","LogEnvironmentView_other":"New seastate","LogEnvironmentView_current_direction_undefined":" ","LogEnvironmentView_current_direction_":" ","LogEnvironmentView_current_direction_0":"0\xb0","LogEnvironmentView_current_direction_1":"90\xb0","LogEnvironmentView_current_direction_2":"180\xb0","LogEnvironmentView_current_direction_3":"270\xb0","LogEnvironmentView_other_direction":"Other direction","LogEnvironmentView_weather_":"   ","LogEnvironmentView_weather_field":"Weather","LogEnvironmentView_weather_1":"clear sky","LogEnvironmentView_weather_2":"fine","LogEnvironmentView_weather_3":"half cloud","LogEnvironmentView_weather_4":"cloudy","LogEnvironmentView_weather_5":"overcast","LogEnvironmentView_weather_6":"drizzle","LogEnvironmentView_weather_7":"moderate rain","LogEnvironmentView_weather_8":"heavy rain","LogEnvironmentView_weather_9":"shower of rain","LogEnvironmentView_weather_10":"haze","LogEnvironmentView_weather_11":"mist","LogEnvironmentView_weather_12":"fog","LogEnvironmentView_weather_13":"sleet","LogEnvironmentView_weather_14":"hail","LogEnvironmentView_weather_15":"thunderstorm","LogEnvironmentView_weather_16":"snow","LogEnvironmentView_weather_temp_rel_humidity":"Weather | Temp. | Rel. Humidity","LogEnvironmentView_weather_temp":"Air Temnperature","LogEnvironmentView_weather_rel_humidity":"Relative Humidity","LogEnvironmentView_wind_direction_speed":"Wind: Direction | Speed","LogNavigationView":"","LogNavigationView_comment":"Comment","LogNavigationView_course":"Course","LogNavigationView_course_to_wind":"Course to wind","LogNavigationView_point_of_sail_noGo":"Head to wind","LogNavigationView_point_of_sail_closeHauled":"Close-hauled","LogNavigationView_point_of_sail_beamReach":"Beam reach","LogNavigationView_point_of_sail_broadReach":"Broad reach","LogNavigationView_point_of_sail_running":"Running","LogNavigationView_wind_side_port":"P","LogNavigationView_wind_side_starboard":"SB","LogNavigationView_depth":"Depth","LogNavigationView_distance":"Distance","LogNavigationView_engine":"Engine","LogNavigationView_engines":"Engines","LogNavigationView_engine_name":"Engine {name}","LogNavigationView_heading":"Heading","LogNavigationView_location":"Location during stop","LogNavigationView_log":"Log","LogNavigationView_position":"Position: Lat | Lon","LogNavigationView_sails":"Sails","LogNavigationView_sog":"SOG","LogNavigationView_status":"Status","LogNavigationView_status_anchor":"At anchor","LogNavigationView_status_buoy":"At buoy","LogNavigationView_status_drifting":"Drifting","LogNavigationView_status_inmotion":"In motion","LogNavigationView_status_none":"None","LogNavigationView_status_offboard":"Offboard","LogNavigationView_status_onboard":"Onboard","LogNavigationView_status_port":"In port","LogNavigationView_status_lock":"Lock","LogNavigationView_status_bunkering":"Fuel station","LogNavigationView_status_bridge":"Bridge","LogNavigationView_status_waiting":"Waiting","LogNavigationView_stw":"STW","LogNavigationView_time":"Time","LogNavigationView_time_utc":"UTC","LogNavigationView_created":"Log entry created at","LogNavigationView_updated":"Log entry updated at","LogNavigationView_engine_rpms":"Engine RPM","LogNavigationView_save_error_fields":"Not saved \u2014 not allowed: {fields}","LogNavigationView_save_error_generic":"Not saved. Please try again.","LogWatchView":"","LogWatchView_watch":"Watch","LogWatchView_watch_comment":"Watch Comment","LogWatchView_save_error_generic":"Not saved. Please try again.","LogView":"","LogView_details_created_by":"Created by {name}","LogView_details_updated_at":"Last update at {date}","LogView_details_last_edited_by":"Last edited by {name}","LogView_details_last_edited":"Last edited","LogView_label_auto":"auto","LogView_label_default":"default","LogView_label_manual":"manual","LogView_label_nmea":"nmea","LogView_log_alert":"Alert {status}: {type} {info}","LogView_log_alert_info_anchorDepth":"- {depth}","LogView_log_alert_info_anchorDrift":"- drifted {distance} from anchor point","LogView_log_alert_info_pressure":"- {action} by {delta} in {interval}","LogView_log_alert_info_pressure_drop":"dropped","LogView_log_alert_info_pressure_raise":"increased","LogView_log_alert_anchorDrift":"Anchor drift","LogView_log_alert_depth":"Depth","LogView_log_alert_lights":"Visual signals","LogView_log_alert_lostPosition":"Lost position","LogView_log_alert_manOverboard":"Man overboard","LogView_log_alert_message":"Message","LogView_log_alert_pressure":"Pressure","LogView_log_alert_test":"Test","LogView_log_alert_wind":"Wind","LogView_log_alert_start":"Alert {alert} is {status}","LogView_log_alert_triggered":"{alert} alert triggered","LogView_log_alert_anchorDrift_detail":"{transition}: {problem}","LogView_log_alert_depth_detail":"{transition}: {problem}","LogView_log_alert_lostPosition_detail":"{transition}: {problem}","LogView_log_alert_manOverboard_detail":"{transition}: {problem}","LogView_log_alert_message_detail":"{transition}: {problem}","LogView_log_alert_lostPosition_disconnected":"NMEA disconnected","LogView_log_alert_lostPosition_stale":"position data is stale","LogView_log_alert_lostPosition_jump":"implausible position jump","LogView_log_alert_lostPosition_invalidFix":"invalid GPS fix","LogView_log_alert_manOverboard_emitterActivated":"MOB beacon activated","LogView_log_alert_manOverboard_manualButtonActivated":"MOB button activated","LogView_log_alert_manOverboard_manual":"manually triggered","LogView_log_alert_manOverboard_unknown":"MOB signal received","LogView_log_alert_lights_detail":"{recorded} -> {recommended}: {transition}.","LogView_log_alert_escalated":"{alert} alert escalated","LogView_log_alert_escalated_by":"{alert} alert escalated to the skipper by {name}","LogView_log_alert_snoozed":"{alert} alert snoozed","LogView_log_alert_snoozed_by":"{alert} alert snoozed by {name}","LogView_log_alert_acknowledged":"{alert} alert acknowledged","LogView_log_alert_acknowledged_by":"{alert} alert acknowledged by {name}","LogView_log_alert_cleared":"{alert} alert cleared","LogView_log_alert_cleared_by":"{alert} alert cleared by {name}","LogView_log_alert_resolved":"{alert} alert resolved","LogView_log_alert_status_acknowledged":"Acknowledged","LogView_log_alert_status_alarm":"Alarm","LogView_log_alert_status_ignored":"Ignored","LogView_log_alert_status_ok":"OK","LogView_log_alert_status_resolved":"Resolved","LogView_log_alert_status_warning":"Warning","LogView_log_alert_type_anchorDepth":"Anchor depth","LogView_log_alert_type_anchorDrift":"Anchor drift","LogView_log_alert_type_pressure":"Pressure","LogView_log_auto_interval":"Automatic entry after {duration}","LogView_log_change_add_crew":"Added to Crew: {name}","LogView_log_change_add_passengers":"Added to Passengers: {name}","LogView_log_change_add_skipper":"Added to Skipper: {name}","LogView_log_change_remove_crew":"Removed from Crew: {name}","LogView_log_change_remove_passengers":"Removed from Passengers: {name}","LogView_log_change_remove_skipper":"Removed from Skipper: {name}","LogView_log_course_change":"Change of course","LogView_log_course_change_active":"Course changed by {angle} {side} over {duration} to {course}","LogView_log_course_change_end":"Course changed by {angle} {side} over {duration} from {course}","LogView_log_course_change_side_port":"to port","LogView_log_course_change_side_starboard":"to starboard","LogView_log_course_change_started":"Course change started","LogView_log_engine_start":"Started engine","LogView_log_engine_start_name":"Started engine {name}","LogView_log_engine_start_idle":"Started engine idling","LogView_log_engine_start_idle_name":"Started engine {name} idling","LogView_log_engine_stop":"Stopped engine","LogView_log_engine_stop_name":"Stopped engine {name}","LogView_log_engine_stop_duration":"Stopped engine after {duration}","LogView_log_engine_stop_duration_name":"Stopped engine {name} after {duration}","LogView_log_engine_stop_distance":"Stopped engine after {duration} ({distance})","LogView_log_engine_stop_distance_name":"Stopped engine {name} after {duration} ({distance})","LogView_log_engine_idle":"Engine idling","LogView_log_engine_idle_name":"Engine {name} idling","LogView_log_engine_load":"Engine under load","LogView_log_engine_load_name":"Engine {name} under load","LogView_log_engine_load_duration":"Engine under load after {duration}","LogView_log_engine_load_duration_name":"Engine {name} under load after {duration}","LogView_log_engine_missing":"Engine information missing, presumed stopped","LogView_log_engine_missing_name":"Engine {name} information missing, presumed stopped","LogView_log_engine_missing_duration":"Engine information missing, presumed stopped after {duration}","LogView_log_engine_missing_duration_name":"Engine {name} information missing, presumed stopped after {duration}","LogView_log_engine_missing_distance":"Engine information missing, presumed stopped after {duration} ({distance})","LogView_log_engine_missing_distance_name":"Engine {name} information missing, presumed stopped after {duration} ({distance})","LogView_log_propulsion_off":"Under sail, no engine running","LogView_log_propulsion_off_noSails":"No engine running","LogView_log_engine_missing_hint_castOff":"Engine entry missing since casting off?","LogView_log_engine_missing_hint_anchorUp":"Engine entry missing since weighing anchor?","LogView_log_engine_missing_hint_motorVessel":"Engine entry missing since getting underway?","LogView_log_generator_start":"Started generator {number}","LogView_log_generator_stop":"Stopped generator {number}","LogView_log_lighting":"Lighting set to {lighting}","LogView_log_lighting_none":"No lights shown","LogView_log_monitor_start":"Started monitor {monitor}","LogView_log_monitor_stop":"Stopped monitor {monitor}","LogView_log_monitor_anchor":"Anchor Alarm","LogView_log_monitor_depth":"Depth watch","LogView_log_navigation_status_start":"Navigation started","LogView_log_navigation_status_stop":"Navigation stopped","LogView_log_nmea_connection_resume":"Resumed NMEA connection for Navigation data","LogView_log_nmea_connection_stop":"Lost NMEA connection for Navigation data","LogView_log_nmea_connection_start":"Started NMEA connection for","LogView_log_nmea_connection_user_stop":"Closed NMEA connection for Navigation data","LogView_log_pause_start":"Start of pause","LogView_log_pause_stop":"End of pause","LogView_log_pause_stop_duration":"End of pause after {duration}","LogView_log_pause_stop_status":"{status} ended","LogView_log_pause_stop_status_duration":"{status} ended after {duration}","LogView_log_status_anchor":"At anchor","LogView_log_status_bunkering":"At fuel station","LogView_log_status_buoy":"At buoy","LogView_log_status_drifting":"Drifting","LogView_log_status_inmotion":"In motion","LogView_log_status_offboard":"Offboard","LogView_log_status_onboard":"Onboard","LogView_log_status_port":"In port","LogView_log_status_lock":"In lock","LogView_log_status_bridge":"At bridge","LogView_log_status_waiting":"Waiting","LogView_log_status_location":"{status}: {location}","LogView_log_stop":"Stopped for {stop}","LogView_log_stop_location":"Stopped for {stop} at {location}","LogView_log_stop_type_endOfDay":"end of day","LogView_log_stop_type_stopover":"stopover","LogView_log_sail_down":"{sail} down","LogView_log_sail_up":"{sail} up","LogView_nmea_auto_course_change_entries":"Course change entries","LogView_nmea_auto_entries":"Auto entries","LogView_nmea_pending":"Log","LogView_provisional_cancel_discard":"Discard entry","LogView_provisional_cancel_error":"The entry could not be discarded. Please try again.","LogView_provisional_cancel_keep":"Keep","LogView_provisional_cancel_message_courseChange":"Discard this course change? No entry will be recorded for this manoeuvre.","LogView_provisional_cancel_message_speedChange":"Discard this pause? No entry will be recorded and the ship stays under way.","LogView_provisional_cancel_title_courseChange":"Discard course change","LogView_provisional_cancel_title_speedChange":"Discard pause","LogView_tab_environment":"Environment","LogView_tab_navigation":"Navigation","LogView_tab_watch":"Watch","LoginView":"","LoginView_error_confirmation_failed":"Email confirmation failed. If the account was previously activated you can use the Forgot password function below.","LoginView_error_failed":"Login failed. Please verify your email and password and try again.","LoginView_error_failed_request":"Login failed. Please verify your internet connection and try again.","LoginView_error_native_login_failed":"Sign in could not be completed. Please return to the app and try again.","LoginView_local_login_required":"Open LOGBOOK on this device to sign in. Primary sign-in is only available on this device\'s local app.","LoginView_companion_handoff_failed":"The companion connection could not be completed. Open LOGBOOK on this device and reconnect from your ship list.","LoginView_companion_handoff_pending":"Connecting to the primary LOGBOOK...","LoginView_error_native_login_invalid":"Sign in cannot continue because the app callback is missing or invalid.","LoginView_error_signup_failed":"Signup failed.","LoginView_error_signupEmailAlreadyExists":"Signup failed. Email address is already in use.","LoginView_error_signupAccountAlreadyExists":"Signup failed. Account with the same name already exists.","LoginView_error_signupNameInvalid":"Please enter your name (at least 3 characters).","LoginView_error_signupEmailInvalid":"Please enter a valid email address.","LoginView_error_signupPasswordInvalid":"Password must be at least 3 characters long.","LoginView_error_invitation_accept_failed":"Accepting the invitation failed. Please make sure you are logged in with the account the invitation was sent to and try again.","LoginView_forgot_password":"Password recovery","LoginView_forgot_password_complete":"Password changed. You can now login to your account using the new password.","LoginView_forgot_password_email":"Please enter the email address of your account to start the password recovery process.","LoginView_forgot_password_email_sent":"If an account exists for this email address, you will receive an email with the next steps.","LoginView_forgot_password_new_password":"Please enter a new password to complete the password recovery.","LoginView_error_reset_failed":"Password recovery failed. Please try again.","LoginView_error_reset_failed_request":"Password recovery failed. Please verify your internet connection and try again.","LoginView_form_back_to_login":"Return to login","LoginView_form_name":"Name","LoginView_form_email":"Email","LoginView_form_new_password":"New password","LoginView_form_new_password_confirmation":"New password confirmation","LoginView_form_password":"Password","LoginView_form_submit":"Login","LoginView_form_submit_forgot_password":"Reset","LoginView_form_submit_forgot_password_loading":"Resetting\u2026","LoginView_form_submit_login":"Login","LoginView_form_submit_login_loading":"Logging in\u2026","LoginView_form_submit_signup":"Signup","LoginView_form_forgot_password":"Forgot\xa0password?","LoginView_form_account_name":"Account name","LoginView_reset_app_title":"Reset App","LoginView_reset_app_cancel":"Cancel","LoginView_reset_app_action":"Start reset","LoginView_welcome":"Welcome to LOGBOOK.","LoginView_signup_link_unavailable":"The signup link could not be loaded. Please try again.","LoginView_signup_link_retry":"Try again","LoginView_login":"You already have an account? Just login to LOGBOOK.","LoginView_login_email":"Login with your email and password.","LoginView_native_sign_in_loading":"Signing in\u2026","LoginView_native_sign_in_fallback":"Sign in with Safari","LoginView_native_sign_in_or":"or","LoginView_signup":"You are new to LOGBOOK? Just signup for LOGBOOK.","LoginView_signup_email":"Signup with your email and a password.","LoginView_invitation_use_other_account":"Use other account","LoginView_invitation_accept":"Accept invitation","LoginView_footer_about":"About us","LoginView_footer_help":"Help","LoginView_footer_language":"Language","LoginView_footer_reset_app":"Reset App","Menu":"","Menu_ship":"Ship","Menu_account":"Account","MenuAccount":"","MenuAccount_account_settings":"Account\xa0Settings","MenuAccount_remove_account":"Remove account","MenuAccount_close_companion":"Disconnect Companion","MenuAccount_open_cloud":"To LOGBOOK\xa0Cloud","MenuAccount_account_settings_app":"To LOGBOOK\xa0App","MenuAccount_logout":"Logout","MenuAccount_switch_user":"Switch User","MenuAccount_return_to_own_user":"Return to {name}","MenuAccount_user_settings":"User\xa0Settings","MenuHelp":"","MenuHelp_about":"About\xa0LOGBOOK","MenuHelp_change_log":"Change Log","MenuHelp_contact_support":"Contact\xa0support","MenuHelp_documentation":"Documentation","MenuHelp_help":"Help","MenuHelp_support":"Support Page","MenuHelp_qanda":"Questions & Answers","MenuHelp_demo":"Interactive Demos","MenuHelp_title":"Help","MenuAlerts":"","MenuAlerts_title":"Alerts","MenuNMEA":"","MenuNMEA_connection":"NMEA connection","MenuNMEA_last_update":"Last update: {timestamp}","MenuNMEA_recording":"Automatic logging","MenuNMEA_settings":"Settings","MenuNMEA_title":"NMEA","MenuShip":"","MenuShip_close":"Close LOGBOOK {name}","MenuShip_logout":"Logout from \\"{name}\\"","MenuShip_data_name":"{name} Ship data","MenuShip_new":"New Ship","MenuShip_settings_name":"{name} Settings","MenuShip_select":"Select Ship","MenuShip_view_cloud":"View \\"{name}\\" in Cloud","MenuShip_view_ships":"View Ships list","MenuSync":"","MenuSync_internet_status":"Internet\xa0connection","MenuSync_last_update":"Last update: {timestamp}","MenuSync_status":"Sync status","MenuSync_title":"Sync","MenuSync_resync":"Reconnect","MenuSync_relogin":"Log in again","NMEAConfigurationView":"","NMEAConfigurationView_blank":"\xa0","NMEAConfigurationView_and":"and","NMEAConfigurationView_banner_start_setup":"Start NMEA setup","NMEAConfigurationView_banner_text":"NMEA Connection is not enabled.","NMEAConfigurationView_cancel":"Cancel","NMEAConfigurationView_checks":"Available NMEA data:","NMEAConfigurationView_check_air_pressure":"Air pressure","NMEAConfigurationView_check_air_humidity":"Humidity","NMEAConfigurationView_check_air_temperature":"Air temperature","NMEAConfigurationView_check_depth":"Depth","NMEAConfigurationView_check_engine":"Engine RPM","NMEAConfigurationView_check_engine_1":"Engine #1 RPM","NMEAConfigurationView_check_engine_2":"Engine #2 RPM","NMEAConfigurationView_check_engine_3":"Engine #3 RPM","NMEAConfigurationView_check_engine_4":"Engine #4 RPM","NMEAConfigurationView_check_engine_5":"Engine #5 RPM","NMEAConfigurationView_check_engine_ids":"Active Engine IDs: {ids}","NMEAConfigurationView_check_engine_ids_none":"none","NMEAConfigurationView_check_navigation_course":"Heading","NMEAConfigurationView_check_navigation_gps":"GPS position","NMEAConfigurationView_check_navigation_log":"Distance through water","NMEAConfigurationView_check_navigation_sog":"Speed over ground","NMEAConfigurationView_check_utc":"UTC","NMEAConfigurationView_check_water_temperature":"Water temperature","NMEAConfigurationView_check_native_gps":"Internal GPS position","NMEAConfigurationView_check_native_air_pressure":"Internal air pressure","NMEAConfigurationView_check_wind":"Wind (speed and direction)","NMEAConfigurationView_connection_device":"Device","NMEAConfigurationView_connection_host":"Address","NMEAConfigurationView_connection_port":"Port","NMEAConfigurationView_connection_type":"NMEA connection type","NMEAConfigurationView_connection_type_bluetooth":"Bluetooth (unsupported)","NMEAConfigurationView_connection_type_gps":"Built-in GPS","NMEAConfigurationView_connection_type_tcp":"TCP","NMEAConfigurationView_connection_type_udp":"UDP","NMEAConfigurationView_connection_type_usb":"USB","NMEAConfigurationView_connect":"Test Connection","NMEAConfigurationView_connecting":"Connecting...","NMEAConfigurationView_capture":"Send NMEA Data to Support","NMEAConfigurationView_capture_sending":"Sending...","NMEAConfigurationView_capture_success":"Sent","NMEAConfigurationView_capture_error":"Sending failed","NMEAConfigurationView_capture_hint":"Sends a short recording of the raw data received from your instruments, so support can analyze connection problems.","NMEAConfigurationView_complete":"Complete","NMEAConfigurationView_error_invalidUrl":"Error: Invalid URL","NMEAConfigurationView_error_connectionFailed":"Error: Connection failed","NMEAConfigurationView_error_disconnected":"Error: NMEA is not connected","NMEAConfigurationView_error_failedToOpen":"Error: Failed to open device","NMEAConfigurationView_error_subscriptionExpired":"Error: Subscription expired","NMEAConfigurationView_error_unsupportedSchema":"Error: Unsupported Protocol","NMEAConfigurationView_reconnect":"Reconnect","NMEAConfigurationView_reset":"Reset","NMEAConfigurationView_step_conditions":"Conditions","NMEAConfigurationView_step_connection":"Connection","NMEAConfigurationView_step_native":"Internal sensors","NMEAConfigurationView_step_test_data":"Test and Data","NMEAConfigurationView_title":"NMEA Settings","NMEAConfigurationView_read_more":"Read more","NMEAConfigurationView_condition_entry":"Conditions for automatic log entries","NMEAConfigurationView_condition_interval":"Regular entries every ","NMEAConfigurationView_condition_interval_3600":"60 min ","NMEAConfigurationView_condition_interval_1800":"30 min ","NMEAConfigurationView_condition_start_stop":"Condition for Start/Stop entry","NMEAConfigurationView_condition_anchor_start_stop":"Different setting when at anchor or buoy","NMEAConfigurationView_condition_anchor_no_status_change":"No status change when speed is","NMEAConfigurationView_condition_anchor_depth_alerts":"Anchor & Depth Alerts","NMEAConfigurationView_condition_anchor_drift_warning":"Anchor drift warning (nm)","NMEAConfigurationView_condition_anchor_drift_alarm":"Anchor drift alarm (nm)","NMEAConfigurationView_condition_depth_warning":"Depth warning","NMEAConfigurationView_condition_depth_alarm":"Depth alarm","NMEAConfigurationView_condition_stop":"Stop entry when speed is","NMEAConfigurationView_condition_start":"Start entry when speed is","NMEAConfigurationView_condition_course":"Entry on course change when ","NMEAConfigurationView_condition_course_change":"course change is","NMEAConfigurationView_condition_course_speed":"speed is","NMEAConfigurationView_condition_native_gps":"Use internal GPS","NMEAConfigurationView_condition_native_pressure":"Use internal air pressure sensor","NMEAConfigurationView_condition_engine_idle_rpm":"If engine is running with less than idle speed (rpm): count time and distance as \\"under sails\\".","NMEAConfigurationView_condition_engine_idle_rpm_value":"idle speed (rpm)","NMEAConfigurationView_condition_engine_detection":"Engine detection (rpm)","NMEAConfigurationView_condition_engine_start":"Engine running when rpm is","NMEAConfigurationView_condition_engine_stop":"Engine off when rpm is","NMEAConfigurationView_error_engine_rpm_order":"Error: Engine off rpm must be below engine running rpm","NMEAConfigurationView_error_engine_idle_rpm":"Error: Idle speed must be above engine running rpm","NoteView":"","NoteView_planning":"Voyage plan","NoteView_crew":"Crew","NoteView_day":"Day","NoteView_file_field_drag_drop":"Attach files to this note.","NoteView_attachment_remove_confirm":"Do you really want to remove this attachment?","NoteView_attachment_remove_title":"Remove attachment","NoteView_attachment_remove_accept":"Remove","NoteView_attachment_remove_cancel":"Cancel","NoteView_attachment_remove_error":"Could not remove the attachment. Please try again.","NoteView_journal":"Journal","NoteView_note_created_by":"Created by {name}","NoteView_note_parent_day":"Day: {date}","NoteView_note_parent_trip":"Passage: {name}","NoteView_other":"Other","NoteView_technical":"Technical","NoteView_type":"Type","NoteView_weather":"Weather forecast","NoteView_show_notes":"Show {count} {type} notes","NoteView_watch":"Watch plan","NoteView_note_add_new":"Add new note","NoteView_note_journal_title":"Journal entry title","NoteView_note_journal_note":"Journal text","NoteView_note_planning_date":"Date","NoteView_note_planning_title":"Location","NoteView_note_planning_note":"Comment","NoteView_note_technical_title":"Technical note title","NoteView_note_technical_note":"Technical note","NoteView_note_parent_type_day":"day","NoteView_note_parent_type_trip":"passage","NoteView_note_weather_title":"Source","NoteView_note_weather_date":"Date and time","NoteView_note_weather_note":"Weather forecast","NoteView_note_weather_note_extra":"Weather conditions","PrintHeaderView":"","PrintHeaderView_title":"LOGBOOK {view} \u2013 {ship}","PrintHeaderView_print_1":"Voyage Overview","PrintHeaderView_print_2":"Selected Passages","PrintHeaderView_print_3":"Selected Days","PrintHeaderView_print_4":"Ship data","PrintHeaderView_motor":"Motor vessel","PrintHeaderView_sailing":"Sailing vessel","PrintSettingsView":"","PrintSettingsView_title":"Print Settings","PrintSettingsView_button":"Print","PrintSettingsView_cancel":"Cancel","PrintSettingsView_overview":"Print Overview","PrintSettingsView_overview_all":"Print all Voyages in LOGBOOK","PrintSettingsView_overview_year":"Select a year","PrintSettingsView_overview_cruises":"Print Overview of Voyages","PrintSettingsView_cruise":"Print Voyage","PrintSettingsView_cruise_current":"Print all data of the Voyage followed by a list of all Passages","PrintSettingsView_cruise_summary":"Voyage data and list of Passages","PrintSettingsView_cruise_details":"Voyage details","PrintSettingsView_ship":"Print Ship Data","PrintSettingsView_ship_short":"Main Ship Data","PrintSettingsView_ship_details":"Detailed Ship Data","PrintSettingsView_user_list":"Print all People for this Ship","PrintSettingsView_trip":"Passages","PrintSettingsView_trips":"Print Passages","PrintSettingsView_trips_all":"Print all Passages of the Voyage","PrintSettingsView_trips_selected":"Select a Passage to print","PrintSettingsView_timeline":"Timeline","PrintSettingsView_trips_summary":"Print all data of the Passages and","PrintSettingsView_trips_summary_details":"a list of Days with Details","PrintSettingsView_trips_summary_short":"a short list of Days","PrintSettingsView_trips_details":"Passage details","PrintSettingsView_journal_list":"Print all Journal entries (Passages and Days)","PrintSettingsView_technical_list":"Print all Technical entries (Passages and Days)","PrintSettingsView_days":"Print Days","PrintSettingsView_days_select":"Select a single Day","PrintSettingsView_days_trip_select":"Print all Days of selected Passage","PrintSettingsView_days_text":"Print data of the Day: tabs Day and Statistics plus the tabs chosen below:","PrintSettingsView_thumbnails":" (incl. image thumbnails)","PrintSettingsView_entries":"Also append Log Entries to each Day","PrintSettingsView_edits":"Include all edits to Log Entries and on the tap for the Day","PrintSettingsView_entries_summary":"Summary (list of Log Entries)","PrintSettingsView_entries_details":"Detailed Log Entries","PrintSettingsView_entries_day_select":"Select a Day","PrintSettingsView_entries_trip_select":"Select a Passage for printing Days from","PrintSettingsView_evaluations":"Print Evaluations","PrintSettingsView_journal":"Journal entries with photos","PrintSettingsView_tacks":"Tracks","PrintSettingsView_technical":"Technical documentation with photos","PrintSettingsView_authorities":"Evaluation for authorities","PrintSettingsView_authorities_day":"Manual entries for the day","PrintSettingsView_authorities_log":"Log entries","PrintView":"","PrintView_print_action":"Print","PrintView_print_cancel":"Cancel","PrintView_cruise":"Voyage","PrintView_cruise_statistics":"Statistics of the Voyage","PrintView_trip":"Passage","PrintView_trips":"Passage","PrintView_trip_list":"List of Passages","PrintView_trip_statistics":"Statistics of the Passage","PrintView_day":"Logbook Data for","PrintView_day_list":"List of Days in the Passage","PrintView_day_maindata":"Main data of the Day","PrintView_day_statistics":"Statistics of the Day","PrintView_date":"Date","PrintView_from_date":"From","PrintView_until_date":"until","PrintView_from_loc":"Traveling from","PrintView_to_loc":"to","PrintView_time_total":"Time","PrintView_distance_total":"Distance","PrintView_technical_notes":"Technical Notes","PrintView_watch_groups":"Watch Groups","PrintView_watch_shifts":"Watch Shifts","PrintView_note_technical":"Technical Note","PrintView_list_technical":"List of all Technical Notes","PrintView_note_journal":"Journal Entry","PrintView_list_journal":"List of all Journal Entries","PrintView_note_watch":"Watch","PrintView_note_planning":"Voyage Plan","PrintView_note_weather":"Weather Forecast","PrintView_log_entries":"Log Entries","SearchView":"","SearchView_token_ship":"Ship","SearchView_token_type":"Type","SearchView_type_cruise":"Voyage","SearchView_type_day":"Day","SearchView_type_log":"Log","SearchView_type_note":"Note","SearchView_type_trip":"Passage","ShipImportView":"","ShipImportView_cancel":"Cancel","ShipImportView_file_field_drag_drop":"Select LogbookSuite export file","ShipImportView_open":"View Ship","ShipImportView_status_complete":"Complete","ShipImportView_status_failed":"Failed. Please try again or contact support for assistance.","ShipImportView_status_error":"Fehler: {error}","ShipImportView_status_processing":"Processing","ShipImportView_status_pending":"Preparing to import","ShipImportView_status_uploading":"Uploading","ShipImportView_title":"Import Ship data","ShipImportView_title_ship":"Import passages into {ship}","ShipSettingsView_settings":"Settings","ShipSettingsView_ship_settings":"Ship Settings","ShipSettingsView_tab_units":"Settings for units","ShipSettingsView_tab_ship_user":"All People","ShipSettingsView_tab_lists":"Settings for lists","ShipSettingsView_tab_settings":"Settings","ShipSettingsView_tab_companions":"Companions","ShipSettingsView_more_info":"Learn more","ShipSettingsView_read_more":"Read more","ShipSettingsView_add_user":"Person","ShipSettingsView_cancel":"Cancel","ShipSettingsView_save":"Add Person","ShipSettingsView_timezone":"Timezone","ShipSettingsView_timezone_title":"Manual Setup of the Timezone","ShipSettingsView_timezone_manual":"Set Timezone manually","ShipSettingsView_current_time":"Current Time","ShipSettingsView_log_offset_title":"Offset for Value from Log Transducer","ShipSettingsView_log_offset":"Log Offset (nm)","ShipSettingsView_rpm_title":"Keep manually entered RPM","ShipSettingsView_rpm_keep_manual":"Carry over RPM to next log entry","ShipSettingsView_lights_title":"Visual signals reminder","ShipSettingsView_lights_enable":"Remind me about the visual signals","ShipSettingsView_lights_sailing":"Lights carried when sailing","ShipSettingsView_lights_sailing_runningLights":"Separate running lights","ShipSettingsView_lights_sailing_triColor":"Masthead tri-colour light","ShipSettingsView_lights_lead":"Day / night boundary","ShipSettingsView_lights_lead_civil":"Civil twilight (recommended)","ShipSettingsView_lights_lead_official":"Sunset / sunrise","ShipSettingsView_lights_motoring_cone":"Remind me to hoist the motoring cone","ShipSettingsView_edit_permissiveness_title":"Editing permissiveness","ShipSettingsView_edit_permissiveness_level":"Editing level","ShipSettingsView_edit_permissiveness_level_default":"Default (strict)","ShipSettingsView_edit_permissiveness_level_extended":"Extended","ShipSettingsView_edit_permissiveness_level_unrestricted":"Unrestricted","ShipSettingsView_socket":"Address of the Primary LOGBOOK","ShipSettingsView_socket_text":"Use this address to connect a Companion to the Primary LOGBOOK","ShipSettingsView_connected_companions":"Connected companions","ShipSettingsView_companion_host":"Host","ShipSettingsView_companion_user":"User","ShipSettingsView_companions_loading":"Loading connected companions\u2026","ShipSettingsView_companions_empty":"No companions are currently connected.","ShipSettingsView_companions_error":"Could not load connected companions. Retrying\u2026","ShipSettingsView_disconnect_companion":"Disconnect","ShipSettingsView_disconnect_companion_label":"Disconnect {user} at {host}","ShipSettingsView_disconnect_companion_title":"Disconnect companion?","ShipSettingsView_disconnect_companion_text":"This companion will need to reconnect manually. The user\'s ship permissions and other devices will not change.","ShipSettingsView_disconnect_companion_error":"Could not disconnect this companion. Please try again.","ShipSettingsView_units":"Settings for units","ShipSettingsView_comment_":"*Choose or enter*","ShipSettingsView_seaState_":"*Choose or enter*","ShipSettingsView_comment_anchor_down":"Anchor down","ShipSettingsView_comment_anchor_up":"Anchor up","ShipSettingsView_comment_engine_started":"Engine started","ShipSettingsView_comment_engine_stopped":"Engine stopped","ShipSettingsView_comment_sails_set":"Sails setup","ShipSettingsView_comment_sails_dropped":"Sails dropped","ShipSettingsView_add_seaState":"Add sea state","ShipSettingsView_add_comment":"Add comment","ShipSettingsView_seaState_waves":"Waves","ShipSettingsView_seaState_swell":"Swell","ShipSettingsView_seaState_cross_sea":"Cross sea","ShipSettingsView_seaState_calm":"Calm sea","ShipSettingsView_seaState_rough":"Rough sea","ShipSettingsView_currency":"Currency","ShipSettingsView_distance":"Distance","ShipSettingsView_length":"Length","ShipSettingsView_power":"Power","ShipSettingsView_pressure":"Pressure","ShipSettingsView_speed":"Speed","ShipSettingsView_surface":"Surface","ShipSettingsView_temperature":"Temperature","ShipSettingsView_volume":"Volume","ShipSettingsView_weight":"Weight","ShipSettingsView_wind":"Wind","ShipSettingsView_current":"Current","ShipSettingsView_unit_currency":"Currency","ShipSettingsView_unit_bar":"bar","ShipSettingsView_unit_celsius":"\xb0C","ShipSettingsView_unit_cm":"cm","ShipSettingsView_unit_fahrenheit":"\xb0F","ShipSettingsView_unit_foot":"foot","ShipSettingsView_unit_gal":"gal","ShipSettingsView_unit_inch":"inch","ShipSettingsView_unit_kg":"kg","ShipSettingsView_unit_km":"km","ShipSettingsView_unit_kmh":"km/h","ShipSettingsView_unit_kn":"kn","ShipSettingsView_unit_kw":"kw","ShipSettingsView_unit_kwh":"kwh","ShipSettingsView_unit_hp":"hp","ShipSettingsView_unit_l":"l","ShipSettingsView_unit_m3":"m\xb3","ShipSettingsView_unit_cuft":"cuft","ShipSettingsView_unit_mps":"m/s","ShipSettingsView_unit_m":"m","ShipSettingsView_unit_m2":"m\xb2","ShipSettingsView_unit_miles":"miles","ShipSettingsView_unit_mph":"mph","ShipSettingsView_unit_nm":"nm","ShipSettingsView_unit_lb":"lb","ShipSettingsView_unit_ft":"ft","ShipSettingsView_unit_in":"in","ShipSettingsView_unit_sqft":"sqft","ShipSettingsView_unit_psi":"psi","ShipSettingsView_unit_sqyd":"sqyd","ShipSettingsView_unit_tons":"to","ShipSettingsView_unit_yard":"yard","ShipSettingsView_unit_hpa":"hPa","ShipSettingsView_unit_undefined":"*Choose or enter*","ShipSettingsView_other":"Enter other","ShipSettingsView_unit_eur":"\u20AC","ShipSettingsView_unit_usd":"$","ShipSettingsView_unit_gbp":"\xa3","ShipSettingsView_unit_aud":"AU$","ShipSettingsView_unit_nzd":"NZ$","ShipSettingsView_unit_chf":"CHF","ShipSettingsView_unit_sek":"SEK","ShipSettingsView_unit_nok":"NOK","ShipSettingsView_unit_dkk":"DKK","ShipSettingsView_unit_jpy":"\xa5","ShipSettingsView_user_crew_role":"Crew role","ShipSettingsView_ship_user_crew_role_crew":"Crew","ShipSettingsView_ship_user_crew_role_none":"None","ShipSettingsView_ship_user_crew_role_owner":"Account holder","ShipSettingsView_ship_user_crew_role_skipper":"Skipper","ShipSettingsView_user_email":"Email","ShipSettingsView_language":"Language","ShipSettingsView_lang_en":"English","ShipSettingsView_lang_de":"Deutsch","ShipSettingsView_lang_fr":"Fran\xe7ais","ShipSettingsView_user_name":"Name","ShipSettingsView_user_shortname":"Short name","ShipSettingsView_user_account":"Account","ShipSettingsView_user_active":"Activate","ShipSettingsView_user_inactive":"Deactivate","ShipSettingsView_user_invite":"Invite","ShipSettingsView_user_invite_title":"Invite Ship user to LOGBOOK","ShipSettingsView_user_reactivate":"Reactivate","ShipSettingsView_remove_user":"Remove","ShipSettingsView_user_deactivate_confirm_title":"Deactivate user","ShipSettingsView_user_deactivate_confirm_message":"Do you really want to deactivate this user\'s access to the ship? If they have no other ship access on this account, their account will be deactivated as well.","ShipSettingsView_user_deactivate_confirm_accept":"Deactivate","ShipSettingsView_user_deactivate_confirm_cancel":"Cancel","ShipSettingsView_user_remove_confirm_title":"Remove user","ShipSettingsView_user_remove_confirm_message":"Do you really want to remove this user from the ship? This cannot be undone.","ShipSettingsView_user_remove_confirm_accept":"Remove","ShipSettingsView_user_remove_confirm_cancel":"Cancel","ShipSettingsView_ship_user_level":"Permissions","ShipSettingsView_ship_user_level_primary":"Primary","ShipSettingsView_ship_user_level_editAll":"View and edit all","ShipSettingsView_ship_user_level_editCurrent":"View and edit current voyage","ShipSettingsView_ship_user_level_viewAll":"View all","ShipSettingsView_ship_user_level_viewCurrent":"View current voyage","ShipSettingsView_ship_user_level_none":"None","ShipSettingsView_user_status":"Status","ShipSettingsView_user_status_active":"Active","ShipSettingsView_user_status_invited":"Invited","ShipSettingsView_user_status_undefined":" ","ShipSettingsView_user_add_user":"Add person","ShipSettingsView_add_user_with_permissions":"Add person with permissions for LOGBOOK","ShipSettingsView_add_user_without_permissions":"Add person without permissons","ShipSettingsView_users_with_level":"Ship users with permissions for LOGBOOK","ShipSettingsView_users_without_level":"Persons without permissions","ShipContentView":"","ShipContentView_back":"Back","ShipDataView":"","ShipDataView_blank":"  ","ShipDataView_":"*Choose*","ShipDataView_add":"Add","ShipDataView_ship_data":"Ship data","ShipDataView_file_field_drag_drop":"Insert photos of your ship here.","ShipDataView_general":"General Ship Data","ShipDataView_choose":"*Choose or enter* ","ShipDataView_other":"Enter other","ShipDataView_tab_general":"General","ShipDataView_tab_details":"Details","ShipDataView_tab_technic":"Technic","ShipDataView_tab_sailing":"Sailing","ShipDataView_tab_equipment":"Equipment","ShipDataView_tab_ship_user":"All persons","ShipDataView_tab_units":"Units","ShipDataView_callsign":"Callsign","ShipDataView_imo":"IMO","ShipDataView_mmsi":"MMSI","ShipDataView_name":"Name","ShipDataView_reg_number":"Registration number","ShipDataView_hin":"HIN","ShipDataView_flag":"Flag","ShipDataView_home_port":"Home port","ShipDataView_yacht_club":"Yacht club","ShipDataView_yacht_club_address":"Address","ShipDataView_model_name":"Model name","ShipDataView_year":"Year build","ShipDataView_yachtbuilder":"Yacht builder","ShipDataView_designer":"Designer","ShipDataView_construction":"Overall construction","ShipDataView_build_number":"Build number","ShipDataView_cel":"CEL category","ShipDataView_cel_persons":"for persons","ShipDataView_ship_foto":"Ship photo","ShipDataView_inside":"Living area","ShipDataView_berth_no":"No. berth total","ShipDataView_berth_single_no":"No. single berth","ShipDataView_berth_double_no":"No. double berth","ShipDataView_berth_extra_no":"No. extra berth","ShipDataView_cabins_no":"No. cabins","ShipDataView_bath_no":"No. bathrooms","ShipDataView_saloon":"Saloon","ShipDataView_pantry":"Pantry","ShipDataView_cabins":"Cabins","ShipDataView_cockpit":"Cockpit","ShipDataView_owner":"Owner","ShipDataView_owner_name":"Name","ShipDataView_owner_address":"Address","ShipDataView_owner_phone":"Phone","ShipDataView_owner_email":"Email","ShipDataView_shape":"Shape","ShipDataView_monohull":"Monohull","ShipDataView_catamaran":"Catamaran","ShipDataView_trimaran":"Trimaran","ShipDataView_sailing-sloop":"Sailboat sloop","ShipDataView_sailing-ketch":"Sailboat ketch","ShipDataView_sailing-classic":"Sailboat classic","ShipDataView_sailing-cat":"Sailboat catamaran","ShipDataView_sailing-tri":"Sailboat trimaran","ShipDataView_sailing-longkeeler":"Sailboat longkeeler","ShipDataView_motor-boat":"Motorboat","ShipDataView_motor-cat":"Motor catamaran","ShipDataView_motor-tri":"Motor trimaran","ShipDataView_motor-yacht":"Motor yacht","ShipDataView_motor-superyacht":"Motor superyacht","ShipDataView_special_features":"Special features","ShipDataView_vessel_type":"Vessel type","ShipDataView_dimensions":"Dimensions","ShipDataView_height":"A: Height","ShipDataView_draft":"B: Draft","ShipDataView_length_waterline":"C: Length waterline","ShipDataView_length_hull":"D: Length of hull","ShipDataView_length":"E: Length over all","ShipDataView_beam":"Beam","ShipDataView_hull_material":"Material of the hull","ShipDataView_hull_color":"Color of the hull","ShipDataView_masts_no":"No. of masts","ShipDataView_rig":"Shape of the rig","ShipDataView_sail_area_total":"Sail area","ShipDataView_comment":"Comment","ShipDataView_displacement":"Displacement","ShipDataView_keel_weight":"Keel weight","ShipDataView_keel_material":"Keel material","ShipDataView_ballast_percentage":"Ballast percentage","ShipDataView_keel_shape":"Keel shape","ShipDataView_keel_weight_percent":"Keel weight %","ShipDataView_mast_rig":"Mast, rig and deck equipment","ShipDataView_rig_elements":"Rig elements","ShipDataView_rig_element":"Rig element","ShipDataView_rig_mast":"Mast","ShipDataView_rig_main_mast":"Main mast","ShipDataView_rig_stay":"Toppstag","ShipDataView_rig_mizzen_mast":"Mizzen mast","ShipDataView_rig_forestay":"Forestay","ShipDataView_rig_jib_stay":"Jib stay","ShipDataView_rig_backstay":"Backstay","ShipDataView_rig_runner":"Runner","ShipDataView_rig_baby_stay":"Baby stay","ShipDataView_rig_kicker":"Kicker","ShipDataView_rig_vang":"Vang","ShipDataView_rig_winch":"Winch","ShipDataView_rig_":"*Choose or enter* ","ShipDataView_rig_null":"*Choose or enter* ","ShipDataView_unit_m":"m","ShipDataView_unit_cm":"cm","ShipDataView_unit_inch":"inch","ShipDataView_unit_foot":"foot","ShipDataView_unit_yard":"yard","ShipDataView_unit_nm":"nm","ShipDataView_unit_m2":"m\xb2","ShipDataView_unit_square_foot":"sqft","ShipDataView_unit_square_yard":"sqyd","ShipDataView_unit_pound":"lb","ShipDataView_unit_kg":"kg","ShipDataView_unit_tons":"to","ShipDataView_unit_knots":"kn","ShipDataView_unit_m_per_second":"m/s","ShipDataView_unit_km_per_hour":"km/h","ShipDataView_unit_kWh":"kWh","ShipDataView_unit_kw":"kW","ShipDataView_unit_hp":"hp","ShipDataView_unit_l":"l","ShipDataView_unit_gal":"gal","ShipDataView_unit_liter":"l","ShipDataView_unit_gallon":"gal","ShipDataView_unit_celsius":"\xb0C","ShipDataView_unit_fahrenheit":"\xb0F","ShipDataView_other_equipment":"Other equipment","ShipDataView_other_equipment_text":"Enter here all other equipment of the ship that could not be entered in the other areas, such as information on the dinghy etc.","ShipDataView_add_engine":"Add engine","ShipDataView_add_generator":"Add generator","ShipDataView_add_sail":"Add sail","ShipDataView_add_insurance":"Add insurance","ShipDataView_add_anchor":"Add anchor","ShipDataView_add_tank":"Add tank","ShipDataView_add_steeringsystem":"Add steering system","ShipDataView_add_other_equipment":"Add other equipment","ShipDataView_add_rig":"Add rig equipment","ShipDataView_nautical_add_device":"Add device","ShipDataView_safety_add_device":"Add equipment","ShipDataView_electric_add_device":"Add device","ShipDataView_insurance":"Insurance","ShipDataView_insurances":"Insurances","ShipDataView_insurance_":"*Choose or enter* ","ShipDataView_insurance_null":"*Choose or enter* ","ShipDataView_insurance_undefined":"*Choose or enter* ","ShipDataView_insurance_company":"Insurance company","ShipDataView_insurance_number":"Insurance number","ShipDataView_insurance_type":"Type of insurance","ShipDataView_insurance_hull":"Hull","ShipDataView_insurance_liability":"Liability","ShipDataView_insurance_accident":"Accident","ShipDataView_engines":"Engines","ShipDataView_engine":"Engine","ShipDataView_engine#":"No.","ShipDataView_engine_nmea_number":"NMEA","ShipDataView_engine_short_name":"Name (max. 10 char.)","ShipDataView_engine_":"*Choose or enter* ","ShipDataView_engine_undefined":"*Choose or enter* ","ShipDataView_engine_null":"*Choose or enter* ","ShipDataView_engine_outboard":"Outboard","ShipDataView_engine_saildrive":"Saildrive","ShipDataView_engine_shaftdrive":"Shaft drive","ShipDataView_engine_z_drive":"Z drive","ShipDataView_engine_pod_drive":"Pod drive","ShipDataView_engine_jet_drive":"Jet drive","ShipDataView_generator_":"*Choose or enter* ","ShipDataView_generator_undefined":"*Choose or enter* ","ShipDataView_generator_null":"*Choose or enter* ","ShipDataView_generator":"Generator","ShipDataView_generators":"Generators","ShipDataView_generator_power_generator":"Power generator","ShipDataView_generator_warm_water":"Warm water","ShipDataView_generator_watermaker":"Watermaker","ShipDataView_generator_heating":"Heating","ShipDataView_generator_air_conditioning":"Air conditioning","ShipDataView_fuel_":"*Choose or enter* ","ShipDataView_fuel_null":"*Choose or enter* ","ShipDataView_fuel_undefined":"*Choose or enter* ","ShipDataView_fuel_type":"Fuel","ShipDataView_fuel_diesel":"Diesel","ShipDataView_fuel_petrol":"Petrol","ShipDataView_fuel_gas":"Gas","ShipDataView_fuel_electricity":"Electricity","ShipDataView_drive_type_engine_null":"*Choose or enter* ","ShipDataView_number":"Number","ShipDataView_manufacturer":"Manufacturer","ShipDataView_model":"Model","ShipDataView_serial_number":"Serial number","ShipDataView_power":"Power","ShipDataView_drive_type":"Drive type","ShipDataView_propeller_type":"Propeller type","ShipDataView_steering_null":"*Choose or enter* ","ShipDataView_steering_systems":"Steering systems","ShipDataView_steering_system_main":"Main steering system","ShipDataView_steering_":"*Choose or enter* ","ShipDataView_steering_type":"Steering type","ShipDataView_rudder_no":"No. of rudders","ShipDataView_rudder_shape":"Shape","ShipDataView_rudder_drive":"Rudder drive","ShipDataView_steering_bow_thruster":"Bow thruster","ShipDataView_steering_stern_thruster":"Stern thruster","ShipDataView_steering_self_steering":"Self steering","ShipDataView_steering_windvane":"Windvane","ShipDataView_steering_trimtab":"Trim-tab","ShipDataView_steering_autopilot":"Autopilot","ShipDataView_tanks":"Tanks","ShipDataView_tanks_unit":"tanks: \u2211 ","ShipDataView_tank":"Type of tank","ShipDataView_tank_":"*Choose or enter* ","ShipDataView_tank_undefined":"*Choose or enter* ","ShipDataView_tank_null":"*Choose or enter* ","ShipDataView_tank_fuel":"Fuel","ShipDataView_tank_water":"Fresh water","ShipDataView_tank_gray":"Gray water","ShipDataView_tank_waste":"Waste water","ShipDataView_tank_gas":"Gas","ShipDataView_tank_fuel_daytank":"Fuel day tank","ShipDataView_tank_size":"Size","ShipDataView_tank_comment":"Comment","ShipDataView_no":"number","ShipDataView_tank_fuel_no":"Fuel: no. | \u2211 size","ShipDataView_tank_water_no":"Fresh water: no. | \u2211 size","ShipDataView_tank_gray_no":"Gray water: no. | \u2211 size","ShipDataView_tank_waste_no":"Waste water:no. | \u2211 size","ShipDataView_tank_gas_no":"Gas: no. | \u2211 size","ShipDataView_anchors":"Anchors","ShipDataView_anchor_type":"Anchor type","ShipDataView_anchor_":"*Choose or enter* ","ShipDataView_anchor_null":"*Choose or enter* ","ShipDataView_anchor_weight":"Weight","ShipDataView_anchor_location":"Place of installation","ShipDataView_bow":"bow","ShipDataView_stern":"stern","ShipDataView_variable":"variable","ShipDataView_anchor_chain":"Length and type of chain","ShipDataView_anchor_chain_lead":"Chain lead","ShipDataView_anchor_windlass":"Anchor windlass","ShipDataView_anchor_windless_drive":"Drive","ShipDataView_anchor_windless_manfacturer":"Manufacturer","ShipDataView_anchor_spade":"Spade anchor","ShipDataView_anchor_fishermans":"Fisherman\'s anchor","ShipDataView_anchor_plough":"CQR/plough anchor","ShipDataView_anchor_danforth":"Danforth","ShipDataView_anchor_rollerbar":"Roller bar anchor","ShipDataView_manual":"manual","ShipDataView_electric":"electric","ShipDataView_watermaker":"Watermaker","ShipDataView_batteries":"Batteries","ShipDataView_batterie":"Batterie","ShipDataView_capacity":"Capacity","ShipDataView_electrics":"Electrics","ShipDataView_date_purchase":"Date of purchase","ShipDataView_charger":"Charger","ShipDataView_inverter":"Inverter","ShipDataView_hot_water_boiler":"Hot water boiler","ShipDataView_size":"Size","ShipDataView_size_height":"Size/height","ShipDataView_place_installation":"Place of installation","ShipDataView_date_installation":"Date of installation","ShipDataView_devices":"Devices","ShipDataView_device":"Device","ShipDataView_sails":"Sails","ShipDataView_sail":"Sail","ShipDataView_sail_":"*Choose or enter* ","ShipDataView_sail_null":"*Choose or enter* ","ShipDataView_sail_size":"Size","ShipDataView_sail_type":"Set on","ShipDataView_sail_reefs_no":"No. of reefs","ShipDataView_sail_mast":"Mast","ShipDataView_sail_forestay":"Forestay","ShipDataView_sail_mizzen":"Mizzen","ShipDataView_sail_mainsail":"Mainsail","ShipDataView_sail_spinnaker":"Spinnaker","ShipDataView_sail_genoa":"Genoa","ShipDataView_sail_jib":"Jib","ShipDataView_sail_working_jib":"Working jib","ShipDataView_sail_strom_jib":"Storm jib","ShipDataView_sail_mizzen_staysail":"Mizzen staysail","ShipDataView_sail_code0":"Code 0","ShipDataView_sail_gennaker":"Gennaker","ShipDataView_sail_try":"Try sail","ShipDataView_sail_storm_jib":"Storm jib","ShipDataView_sail_parasailor":"Parasailor","ShipDataView_sail_0":"None","ShipDataView_sail_1":"1","ShipDataView_sail_2":"2","ShipDataView_sail_3":"3","ShipDataView_sail_reef_1":"Reef 1","ShipDataView_sail_reef_2":"Reef 2","ShipDataView_sail_reef_3":"Reef 3","ShipDataView_sail_reef":"{sail} - {reef}","ShipDataView_device_":"*Choose or enter* ","ShipDataView_device_undefined":"*Choose or enter* ","ShipDataView_device_nautical_":"*Choose or enter* ","ShipDataView_device_electric_":"*Choose or enter* ","ShipDataView_device_safety_":"*Choose or enter* ","ShipDataView_device_nautical_null":"*Choose or enter* ","ShipDataView_device_electric_null":"*Choose or enter* ","ShipDataView_device_safety_null":"*Choose or enter* ","ShipDataView_nautical_equipment":"Nautical equipment","ShipDataView_safety_equipment":"Safety equipment","ShipDataView_electric_equipment":"Electric equipment","ShipDataView_device_nautical_analogue_compass":"Analogue compass","ShipDataView_device_nautical_gyro_compass":"Gyro compass","ShipDataView_device_nautical_fluxgate_compass":"Fluxgate compass","ShipDataView_device_nautical_satellite_compass":"Satellite compass","ShipDataView_device_nautical_chart_plotter":"Chart plotter","ShipDataView_device_nautical_gps":"GPS","ShipDataView_device_nautical_ais":"AIS transponder","ShipDataView_device_nautical_radio":"Radio","ShipDataView_device_nautical_antenna":"Antenna","ShipDataView_device_nautical_radar":"Radar","ShipDataView_device_nautical_wind_gauge":"Wind gauge","ShipDataView_device_nautical_autopilot":"Autopilot","ShipDataView_device_nautical_display_instruments":"Display instruments","ShipDataView_device_nautical_fuel_gauge":"Fuel gauge","ShipDataView_device_nautical_battery_controller":"Battery controller","ShipDataView_device_nautical_hour_meter":"Hour meter","ShipDataView_device_nautical_tachometer":"Tachometer","ShipDataView_device_nautical_logger":"Logger","ShipDataView_device_nautical_sounder":"Sounder","ShipDataView_device_nautical_air_temperature":"Air temperature","ShipDataView_device_nautical_barometer":"Barometer","ShipDataView_device_nautical_humidity":"Humidity","ShipDataView_device_nautical_weather_receiver":"Weather receiver","ShipDataView_device_nautical_nmea_gateway":"NMEA gateway","ShipDataView_device_nautical_nmea_motor_adapter":"NMEA motor adapter","ShipDataView_device_electric_battery":"Battery","ShipDataView_device_electric_inverter":"Inverter","ShipDataView_device_electric_charger":"Charger","ShipDataView_device_electric_solar_panel":"Solar panel","ShipDataView_device_electric_wind_generator":"Wind generator","ShipDataView_device_electric_watermaker":"Watermaker","ShipDataView_device_safety_fire_extinguisher":"Fire extinguisher","ShipDataView_device_safety_liferaft":"Liferaft","ShipDataView_device_safety_lifejacket":"Lifejacket","ShipDataView_device_safety_lifebelt":"Lifebelt","ShipDataView_device_safety_lifeline":"Lifeline","ShipDataView_device_safety_spare_propeller":"Spare propeller","ShipDataView_device_safety_emergency_tiller":"Emergency tiller","ShipDataView_device_safety_bilge_pump_manual":"Manual bilge pump","ShipDataView_device_safety_bilge_pump_electric":"Electric bilge pump","ShipDataView_device_safety_shroud_cutter":"Shroud cutter","ShipDataView_device_safety_radar_reflector":"Radar reflector","ShipDataView_device_safety_first_aid":"First Aid","ShipDataView_device_safety_fire_blanket":"Fire blanket","ShipDataView_device_safety_dinghy":"Dinghy ","ShipDataView_device_safety_dinghy_motor":"Motor for dinghy","ShipDataView_device_safety_handheld_radio":"Handheld radio","ShipDataView_device_safety_epirb":"Epirb","ShipDataView_all_users":"All persons for crew etc.","ShipEditView":"","ShipEditView_name":"Name of the ship","ShipEditView_name_min":"Name of the ship (min 3 characters)","ShipEditView_title_edit":"Ship data for {ship}","ShipEditView_title_new":"Create new Ship","ShipEditView_type":"Vessel type","ShipEditView_type_motor":"Motor vessel","ShipEditView_type_sailing":"Sailing vessel","ShipEditView_engines":"No. of Engines","ShipEditView_generators":"No. of Generators","ShipEditView_create":"Create Ship","ShipEditView_cancel":"Cancel","ShipEditView_choose":"Choose","ShipEditView_print":"Print Ship data","ShipSelectView":"","ShipSelectView_companion":"C","ShipSelectView_view_logbook":"View","ShipSelectView_selecting":"Selecting...","ShipSelectView_options":"Options","ShipSelectView_nearby":"Found on your network","ShipSelectView_nearby_hint":"This ship is being advertised on your current network.","ShipSelectView_unavailable_no_permission":"You do not have permission to open this ship as the Primary LOGBOOK.","ShipSelectView_unavailable_import_in_progress":"An import is still running for this ship.","ShipSyncStatusView":"","ShipSyncStatusView_close":"Close","ShipSyncStatusView_retry":"Try again","ShipSyncStatusView_title":"Synchronization with LOGBOOK Cloud","ShipUserSelect":"","ShipUserSelect_add_user":"Add Person","ShipUserSelect_dialog_add_new_user":"Add new Person","ShipUserSelect_dialog_add_user":"Add new Person","ShipUserSelect_dialog_add_user_name":"Name","ShipUserSelect_dialog_add_user_shortname":"Short name","ShipUserSelect_dialog_cancel":"Cancel","ShipUserSelect_loading":"Loading\u2026","ShipUserSelect_no_users":"No people available","ShipUserSelect_select_additional_user":"+","ShipUserSelect_select_user":"Select Person","ShipView":"","ShipView_add_cruise":"Voyage","ShipView_add_ship":"Ship","ShipView_empty_select":"Select a ship first.","ShipView_import_trips_title":"Import older Passages from LogbookSuite","ShipView_import_trips_choose":"Choose file","ShipView_import_trips_cancel":"Cancel","ShipView_menu_action_title":"New","ShipView_menu_NMEA":"NMEA","ShipView_menu_now":"Focus","ShipView_menu_search":"Search","ShipView_nmea_recording_disconnected":"NMEA disconnected","ShipView_nmea_recording_error":"NMEA recording error:","ShipView_nmea_recording_error_disconnected":"NMEA recording error: NMEA not connected","ShipView_overlay_dismiss":"OK","ShipView_overlay_missing_cruise":"Can not start recording without an active passage and voyage. Create a voyage first.","ShipView_overlay_missing_trip":"Can not start recording without an active passage. Create a passage first.","ShipView_ship_data":"Ship data","ShipView_ship_settings":"Settings","ShipView_sync_initialSyncInProgress":"Running initial sync","ShipView_sync_settings":"Settings","ShipView_sync_uninitialized":"Preparing to sync","ShipView_resync_cancel":"Cancel","ShipView_resync_confirm_cancel":"Back","ShipView_resync_confirm_execute":"Confirm","ShipView_resync_title":"Reset disconnected connection","ShipView_resync_reset_local":"Use local data","ShipView_resync_reset_cloud":"Use Cloud data","ShipView_resync_last_sync":"This device last synchronised","ShipView_resync_cloud_updated":"LOGBOOK Cloud last updated","ShipView_resync_status_failed":"The LOGBOOK Cloud could not be reached, so the connection status is unknown. Check your internet connection and try again.","ShipView_resync_permission_required":"Your cloud account no longer has Primary permission for this ship. Synchronisation and recovery require that permission. Ask the ship owner to restore it, then retry synchronisation. Keep this ship open to preserve unsynchronised local changes; releasing the cloud connection alone will not restore permission.","ShipView_resync_claimed_here":"The LOGBOOK Cloud still recognises this device as the Primary. A reset cannot run while that connection is active. Retry synchronisation first. If a reset is still needed, close the ship in the LOGBOOK Cloud, then reopen this dialog and choose which data to keep. Keep the ship open in this app until recovery is complete to preserve unsynchronised local changes.","ShipView_resync_reset_failed":"The connection could not be restored. Please try again.","ShipView_resync_reset_claimed":"The cloud refused recovery. Your permission or the ship\'s connection may have changed. Go back to check the current status before trying again.","ShipView_read_more":"Read more","StatsView":"","StatsView_days_run":"Day\'s run","StatsView_distance_total":"Total distance","StatsView_distance_under_engine":"Distance under Engine","StatsView_distance_under_engine_name":"{name}","StatsView_distance_under_sails":"Distance under sails","StatsView_duration_under_engine":"Time under Engine","StatsView_duration_under_engine_name":"{name}","StatsView_duration_under_sails":"Time under sails","StatsView_speed":"Average speed","StatsView_time_total":"Time total","StatsView_time_total_paused_cruising":"Time: Total | Paused | Cruising","StatsView_update":"Recalculate","TrackView":"","TrackView_no_track":"No track available","TripEditView":"","TripEditView_cancel":"Cancel","TripEditView_current_time":"Current time","TripEditView_dialog_title":"Create Passage","TripEditView_start":"Start Passage","TripEditView_timezone":"Timezone","TripEditView_title":"Name of the passage","TripView":"","TripView_tab_crew":"Crew","TripView_tab_stats":"Statistics","TripView_tab_track":"Track","TripView_tab_trip":"Passage","TripView_tab_weather":"Weather","TripView_tab_print":"Print","TripView_untitled_trip":"Untitled passage","TripView_print_all":"Print all passages of this voyage","TripView_print_trip":"Print this passage","UserAdviceAlertView":"","UserAdviceAlertView_alert_acknowledged":"Acknowledged","UserAdviceAlertView_alert_alarm":"Alarm","UserAdviceAlertView_alert_anchorDrift":"Anchor drift","UserAdviceAlertView_alert_anchorDrift_short":"Drift","UserAdviceAlertView_alert_default":"Unknown","UserAdviceAlertView_alert_depth":"Depth","UserAdviceAlertView_alert_depth_short":"Depth","UserAdviceAlertView_alert_ignored":"Ignored","UserAdviceAlertView_alert_lostPosition":"Lost position","UserAdviceAlertView_alert_lostPosition_short":"Position","UserAdviceAlertView_alert_message":"Message","UserAdviceAlertView_alert_message_short":"Message","UserAdviceAlertView_alert_ok":"OK","UserAdviceAlertView_alert_pressure":"Pressure","UserAdviceAlertView_alert_pressure_short":"Pressure","UserAdviceAlertView_alert_resolved":"Resolved","UserAdviceAlertView_alert_test":"Test","UserAdviceAlertView_alert_test_short":"Test","UserAdviceAlertView_alert_warning":"Warning","UserAdviceAlertView_alert_wind":"Wind","UserAdviceAlertView_alert_wind_short":"Wind","UserAdviceAlertView_alert_lights":"Visual signals","UserAdviceAlertView_alert_lights_short":"Lights","UserAdviceAlertView_alert_manOverboard":"Man overboard","UserAdviceAlertView_alert_manOverboard_short":"MOB","UserAdviceAlertView_state_snoozed":"Snoozed","UserAdviceAlertView_state_acknowledged":"Acknowledged","UserAdviceAlertView_state_audible":"Sounding","UserAdviceAlertView_close":"Close","UserAdviceAlertView_record":"I set {lighting}","UserAdviceAlertView_cancel":"Cancel","UserAdviceAlertView_settings":"Settings","UserAdviceAlertView_submit":"Set status: {state}","UserAdviceAlertView_submit_none":"Choose an action","UserAdviceAlertView_state_snooze":"Snoozed","UserAdviceAlertView_state_acknowledge":"Acknowledged","UserAdviceAlertView_state_clear":"Cleared","UserAdviceAlertView_state_record":"Recorded","UserAdviceAlertView_explain_snooze":"Silences the alert for a few minutes. It stays open and returns if the situation persists.","UserAdviceAlertView_explain_acknowledge":"Marks the alert as seen and stops it sounding. It stays open until the situation resolves.","UserAdviceAlertView_explain_clear":"Closes the alert. Use this once the situation has actually been dealt with.","UserAdviceAlertView_explain_record":"Records the recommended lighting in the log. The reminder closes by itself once the lighting matches.","UserAdviceAlertView_clear_denied":"Only the skipper or the crew on watch can clear this alert.","UserAdviceAlertView_clear_confirm_message":"This closes the alert for everyone on board, whether or not the situation still holds. Only clear it once it has actually been dealt with.","UserAdviceAlertView_clear_confirm":"Clear the alert","UserAdviceAlertView_clear_confirm_cancel":"Back","UserAdviceAlertView_escalate":"Escalate to skipper","UserAdviceAlertView_state_escalate":"Escalated to skipper","UserAdviceAlertView_explain_escalate":"Alerts the skipper now instead of waiting for the alarm to escalate by itself. This also undoes an acknowledgement or snooze, so the alarm reaches them.","UserAdviceAlertView_skip":"Skip","UserAdviceAlertView_acknowledge":"Acknowledge","UserAdviceAlertView_clear":"Clear","UserAdviceAlertView_snooze":"Snooze","UserAdviceAlertView_title":"Alert {name} - {level}","UserAdviceAlertView_error":"The action could not be completed. Please try again.","UserAdviceAlertView_read_more":"Read more","UserAdviceAnchorMonitorView":"","UserAdviceAnchorMonitorView_cancel":"Cancel","UserAdviceAnchorMonitorView_disable":"Disable","UserAdviceAnchorMonitorView_enable":"Enable alarm","UserAdviceAnchorMonitorView_title_inactive":"Anchor Alarm Off","UserAdviceAnchorMonitorView_title_active":"Anchor Alarm On","UserAdviceAnchorMonitorView_title_short":"Anchor Alarm","UserAdviceAnchorMonitorView_method":"Method","UserAdviceAnchorMonitorView_method_fixedRadius":"Fixed radius","UserAdviceAnchorMonitorView_method_rodeScope":"Rode / scope","UserAdviceAnchorMonitorView_method_sector":"Swing sector","UserAdviceAnchorMonitorView_warning":"Warning","UserAdviceAnchorMonitorView_alarm":"Alarm","UserAdviceAnchorMonitorView_rode":"Rode","UserAdviceAnchorMonitorView_depth":"Depth","UserAdviceAnchorMonitorView_boatLength":"Boat length","UserAdviceAnchorMonitorView_bearingFrom":"From bearing","UserAdviceAnchorMonitorView_bearingTo":"To bearing","UserAdviceAnchorMonitorView_recenter":"Recenter","UserAdviceAnchorMonitorView_save":"Save","UserAdviceAnchorMonitorView_snooze":"Snooze","UserAdviceAnchorMonitorView_acknowledge":"Acknowledge","UserAdviceAnchorMonitorView_clear":"Clear","UserAdviceAnchorMonitorView_keepAlive":"Keep alerting in background","UserAdviceAnchorMonitorView_depthWarning":"Depth warning","UserAdviceAnchorMonitorView_depthAlarm":"Depth alarm","UserAdviceAnchorMonitorView_error":"The anchor watch could not be updated. Please try again.","UserAdviceAnchorMonitorView_error_noPosition":"The anchor alarm needs the current position to set its centre, and there is no position right now. Connect an NMEA GPS source (or enable the device GPS) and try again.","UserAdviceAnchorMonitorView_error_gpsPrecision":"The current position is not precise enough for the anchor alarm. It needs a high-precision GPS source; the device GPS alone is too coarse to measure the swing circle.","UserAdviceAnchorMonitorView_error_noDay":"The anchor alarm can only be started once the day has begun and a first position has been recorded. Your settings have been saved; start the anchor alarm again once the logbook is recording.","UserAdviceAnchorMonitorView_read_more":"Read more","UserAdviceEngineMissingView":"","UserAdviceEngineMissingView_title_short":"Engine?","UserAdviceEngineMissingView_title_castOff":"Engine entry missing?","UserAdviceEngineMissingView_title_anchorUp":"Engine entry missing?","UserAdviceEngineMissingView_title_motorVessel":"Engine entry missing?","UserAdviceEngineMissingView_text_castOff":"You cast off with no engine recorded. Was the engine running?","UserAdviceEngineMissingView_text_anchorUp":"You got under way with no engine recorded. Was the engine running?","UserAdviceEngineMissingView_text_motorVessel":"You are under way with no engine recorded. Was the engine running?","UserAdviceEngineMissingView_all_engines":"All engines","UserAdviceEngineMissingView_since_trigger":"Since {time}","UserAdviceEngineMissingView_since_now":"From now","UserAdviceEngineMissingView_started":"Engine was running","UserAdviceEngineMissingView_sailing":"No, we\'re sailing","UserAdviceEngineMissingView_sailing_noSails":"No engine running","UserAdviceEngineMissingView_cancel":"Cancel","UserAdviceDepthWatchView":"","UserAdviceDepthWatchView_cancel":"Cancel","UserAdviceDepthWatchView_disable":"Disable","UserAdviceDepthWatchView_enable":"Enable alarm","UserAdviceDepthWatchView_title_inactive":"Depth Alarm Off","UserAdviceDepthWatchView_title_active":"Depth Alarm On","UserAdviceDepthWatchView_title_short":"Depth Alarm","UserAdviceDepthWatchView_snooze":"Snooze","UserAdviceDepthWatchView_acknowledge":"Acknowledge","UserAdviceDepthWatchView_clear":"Clear","UserAdviceDepthWatchView_text":"Changing these values updates your ship\'s depth alert settings.","UserAdviceDepthWatchView_save":"Save","UserAdviceDepthWatchView_save_error":"The depth alert settings could not be saved. Please try again.","UserAdviceDepthWatchView_error":"The depth watch could not be updated. Please try again.","UserAdviceLightsReminderView":"","UserAdviceLightsReminderView_title":"Visual signals","UserAdviceLightsReminderView_title_active":"Visual signals Reminder On","UserAdviceLightsReminderView_title_inactive":"Visual signals Reminder Off","UserAdviceManualShipStatusView":"","UserAdviceManualShipStatusView_title_active":"Manual status until {time}","UserAdviceManualShipStatusView_title_short":"Manual status","UserAdviceManualShipStatusView_text":"The automatic status changes are switched off. Set the ship status yourself in the log menu \u2014 no entry is made automatically while this is on.","UserAdviceManualShipStatusView_remaining":"Ends at {time}, in about {minutes} minutes \u2014 or at the day change, whichever comes first.","UserAdviceManualShipStatusView_extend":"Extend","UserAdviceManualShipStatusView_cancel":"End now","UserAdviceManualShipStatusView_close":"Close","UserAdviceManualShipStatusView_error":"The manual status mode could not be updated. Please try again.","UserAdviceStopView":"","UserAdviceStopView_cancel":"Cancel","UserAdviceStopView_text":"Document the stop. End of day pauses automatic recording until the ship moves again; Stopover keeps recording active.","UserAdviceStopView_text_fixed_status":"Add End of day or Stopover without changing the current ship status. End of day pauses automatic recording until the ship moves again; Stopover keeps recording active.","UserAdviceStopView_end_location":"Location","UserAdviceStopView_end_of_day":"End of day","UserAdviceStopView_manual_engine_entries":"Also turned off engine(s)?","UserAdviceStopView_manual_engine_entries_text":"Enabling this option will also create a final entry for engine operation","UserAdviceStopView_final_entry":"Create final entry","UserAdviceStopView_save":"Save","UserAdviceStopView_status_anchor":"Anchorage","UserAdviceStopView_status_buoy":"Buoy","UserAdviceStopView_status_port":"Harbor","UserAdviceStopView_status_drifting":"Drifting","UserAdviceStopView_stopover":"Stopover","UserAdviceStopView_status_lock":"Lock","UserAdviceStopView_status_bunkering":"Fuel station","UserAdviceStopView_status_bridge":"Bridge","UserAdviceStopView_status_waiting":"Waiting","UserAdviceStopView_stop_engines":"Create entry for stopped engine(s)","UserAdviceStopView_stop_type":"Stop type","UserAdviceStopView_title":"Stopped","UserAdviceStopView_title_duration":"Stopped for {duration}","UserAdviceStopView_title_short":"Stopped","UserAdviceRow_collapse":"Show less","UserAdviceRow_expand":"Show all advices","UserSettingsView":"","UserSettingsView_lang_en":"English","UserSettingsView_lang_de":"Deutsch","UserSettingsView_lang_fr":"Fran\xe7ais","UserSettingsView_theme_dark":"Dark","UserSettingsView_theme_light":"Classic","UserSettingsView_theme_night":"Night","UserSettingsView_theme_cloud":"Cloud","UserSettingsView_language":"Language","UserSettingsView_theme":"Theme","UserSwitchView":"","UserSwitchView_title":"Switch User","UserSwitchView_empty":"No other crew members are recorded for today.","Mailer_trial_started_subject":"Your LOGBOOK Trial has started","Mailer_trial_2daysleft_subject":"Your LOGBOOK Trial is ending soon","Mailer_trial_expired_subject":"Your LOGBOOK Trial phase has expired","Mailer_subscription_expired_subject":"Your LOGBOOK subscription has expired","LogButton":"","LogButton_status":"Status","LogButton_engines":"Engines","LogButton_generators":"Generators","LogButton_lighting":"Lighting","LogButton_lighting_none":"No lights","LogButton_lighting_triColorLights":"Tri-colour light","LogButton_lighting_anchorBall":"Anchor ball","LogButton_lighting_anchorLight":"Anchor light","LogButton_lighting_sailingRunningLights":"Sailing lights","LogButton_lighting_motoringRunningLights":"Motoring lights","LogButton_lighting_navigationLights":"Navigation lights","LogButton_lighting_motoringCone":"Motoring cone","LogButton_sails":"Sails","LogButton_sails_confirm":"Save sails","LogButton_sail_group_main":"Main","LogButton_sail_group_foresail":"Foresail","LogButton_sail_group_spinnaker":"Spinnaker","LogButton_sail_group_mizzen":"Mizzen","LogButton_send_alert":"Send alert","LogButton_man_overboard":"Man overboard","LogButton_man_overboard_confirm_title":"Man overboard","LogButton_man_overboard_confirm_message":"This will immediately alert the entire crew that someone has gone overboard. Only confirm if this is real.","LogButton_man_overboard_confirm":"Trigger alert","LogButton_man_overboard_cancel":"Cancel","LogButton_man_overboard_error":"Could not trigger the man-overboard alert.","LogButton_manual_status":"Manual status","LogButton_manual_status_active":"Manual status on \u2014 switch off","SendAlertDialog":"","SendAlertDialog_title":"Send alert","SendAlertDialog_users":"Crew members","SendAlertDialog_add_user":"Add crew member","SendAlertDialog_groups":"Watch groups","SendAlertDialog_add_group":"Add watch group","SendAlertDialog_message":"Message","SendAlertDialog_severity":"Severity","SendAlertDialog_severity_warning":"Warning","SendAlertDialog_severity_alarm":"Alarm","SendAlertDialog_loudness":"Loudness","SendAlertDialog_loudness_audible":"Audible alarm","SendAlertDialog_loudness_notificationOnly":"Notification only","SendAlertDialog_error":"The alert could not be sent. Please try again.","SendAlertDialog_cancel":"Cancel","SendAlertDialog_send":"Send","CatalogUserAdviceButton":"","CatalogUserAdviceButton_notice":"Anchor watch active","CatalogUserAdviceButton_warning":"Wind picking up","CatalogUserAdviceButton_alarm":"Man overboard!","CatalogUserAdviceButton_short":"MOB","CatalogUserAdviceButton_record":"Record anchor light","CatalogUserAdviceButton_primary-action":"Visual signals","CatalogUserAdviceButton_primary-action-denied":"Visual signals","CatalogUserAdviceRow":"","CatalogUserAdviceRow_manOverboard":"Man overboard","CatalogUserAdviceRow_manOverboard_short":"MOB","CatalogUserAdviceRow_anchorDrift":"Anchor drift","CatalogUserAdviceRow_anchorDrift_short":"Drift","CatalogUserAdviceRow_depth":"Depth Alarm On","CatalogUserAdviceRow_depth_short":"Depth Alarm","CatalogUserAdviceRow_lostPosition":"Lost position","CatalogUserAdviceRow_lostPosition_short":"Position","CatalogUserAdviceRow_wind":"Wind warning","CatalogUserAdviceRow_wind_short":"Wind","CatalogUserAdviceRow_stop":"Stopped for 0:12:04","CatalogUserAdviceRow_stop_short":"Stopped","":""}');


var $151b0f051dad138e$exports = {};
$151b0f051dad138e$exports = JSON.parse('{"LogbookApp_version_major":"1.1","RecordingClockWarning_title":"Warnung zur Aufzeichnungszeit","RecordingClockWarning_acknowledge":"Best\xe4tigen","RecordingClockWarning_system":"Die Computeruhr ist unzuverl\xe4ssig. Die Aufzeichnung wird mit der GPS-Zeit fortgesetzt.","RecordingClockWarning_gps":"Die GPS-Uhr ist unzuverl\xe4ssig. Die Aufzeichnung wird mit der Computerzeit fortgesetzt.","RecordingClockWarning_paused":"Keine zuverl\xe4ssige Zeitquelle verf\xfcgbar. Automatische Aufzeichnung und neue Eintr\xe4ge zur aktuellen Zeit sind pausiert, bis GPS oder Computeruhr wieder zuverl\xe4ssig sind. Fr\xfchere Eintr\xe4ge k\xf6nnen weiterhin bearbeitet werden.","Layout":"","Layout_documentation":"DOKUMENTATION","Layout_support":"Support","OpenServerDialog_title":"LOGBOOK Cloud \xf6ffnen","OpenServerDialog_opening":"LOGBOOK Cloud wird ge\xf6ffnet...","OpenServerDialog_failed":"LOGBOOK Cloud konnte nicht ge\xf6ffnet werden. Pr\xfcfe die Verbindung und erlaube Pop-up-Fenster. Versuche es dann erneut.","OpenServerDialog_close":"Schlie\xdfen","OpenServerDialog_retry":"Erneut versuchen","AboutView":"","AboutView_title":"\xdcber LOGBOOK","AboutView_version":"Version","AboutView_website":"Website","AboutView_support":"Support","AboutView_copyright":"Copyright \xa9 2026 by Trimutic UG","AboutView_uploadAppData":"App-Daten an Support hochladen","AboutView_uploadAppDataUploading":"Wird hochgeladen\u2026","AboutView_uploadAppDataSuccess":"App-Daten hochgeladen","AboutView_uploadAppDataError":"App-Daten konnten nicht hochgeladen werden","AccountView":"","AccountView_cancel":"Abbrechen","AccountView_cancel_plan":"Abo k\xfcndigen","AccountView_currency":"W\xe4hrung","AccountView_currency_EUR":"Euro (\u20AC)","AccountView_currency_USD":"US Dollar ($)","AccountView_duration":"Laufzeit","AccountView_duration_5":"5 Tage","AccountView_duration_30":"monatliche\xa0Abbuchung, monatlich\xa0k\xfcndbar","AccountView_duration_120":"4 Monate","AccountView_duration_365":"j\xe4hrliche\xa0Abbuchung, j\xe4hrlich\xa0k\xfcndbar","AccountView_duration_30_iap":"monatliche\xa0Abbuchung, verl\xe4ngert sich\xa0automatisch, sofern nicht\xa0gek\xfcndigt","AccountView_feature_active_ships":"Aktive Schiffe: {amount}","AccountView_feature_active_users":"Aktive Benutzer: {amount}","AccountView_feature_active_tenders":"Aktive Tender: {amount}","AccountView_feature_support_1":"Standard-Support","AccountView_feature_support_10":"Pro-Support","AccountView_feature_support_100":"Master-Support","AccountView_feature_unlimited":"Unbegrenzt","AccountView_pay":"Wiederkehrende Zahlung von {price} best\xe4tigen","AccountView_pay_cancel":"Abbrechen","AccountView_pay_processing":"Zahlung wird verarbeitet...","AccountView_payment_information":"Zahlungsinformationen","AccountView_payment_title":"{plan} Abonnement f\xfcr {price}","AccountView_plans":"Unsere Abonnement-Pl\xe4ne","AccountView_plans_iPad":"Dein Abo f\xfcr LOGBOOK","AccountView_plan_captain":"LOGBOOK Captain","AccountView_plan_master_captain":"LOGBOOK Master Captain","AccountView_plan_skipper":"LOGBOOK Skipper","AccountView_plan_trial":"LOGBOOK Trial","AccountView_price_duration_5":"5 Tage","AccountView_price_duration_30":"Monat","AccountView_price_duration_365":"Jahr","AccountView_price_free":"Kostenlos","AccountView_price_EUR":"{price} \u20AC pro {duration}","AccountView_price_USD":"${price} pro {duration}","AccountView_price_native":"{price} pro {duration}","AccountView_price_or_monthly":" oder ","AccountView_select_plan":"Plan ausw\xe4hlen","AccountView_subscribe":"Abonnieren","AccountView_subscribe_api":"Abonnieren","AccountView_time_left":"Noch {days} Tage","AccountView_renews_in":"Verl\xe4ngert sich in {days} Tagen","AccountView_cancelled_ends":"Gek\xfcndigt \u2014 Zugang endet in {days} Tagen","AccountView_apple_cancel_info_title":"Abo verwalten","AccountView_apple_cancel_info_message":"Dieses Abo wurde \xfcber den App Store abgeschlossen und muss dort verwaltet werden. \xd6ffne auf deinem iPhone oder iPad die Einstellungen, tippe auf deinen Namen, dann auf Abonnements, w\xe4hle LOGBOOK und k\xfcndige es dort. Dein Zugang bleibt bis zum Ende des aktuellen Abrechnungszeitraums aktiv.","AccountView_taxes":"Inkl. Steuern","AccountView_terms_of_use":"Nutzungsbedingungen","AccountView_privacy_policy":"Datenschutzerkl\xe4rung","AccountView_restore_purchases":"K\xe4ufe wiederherstellen","AccountView_restore_purchases_running":"Wird wiederhergestellt \u2026","AccountView_restore_nothing_title":"Keine K\xe4ufe gefunden","AccountView_restore_nothing_message":"Auf dieser Apple-ID gibt es kein aktives Abo, das wiederhergestellt werden kann.","AccountView_restore_claim_title":"Abo verschieben","AccountView_restore_claim_message":"Das Abo dieser Apple-ID ist derzeit mit \u201E{account}\u201C verkn\xfcpft. Zu \u201E{current}\u201C verschieben? \u201E{account}\u201C verliert dadurch den Zugriff.","AccountView_restore_claim_confirm":"Hierher verschieben","AccountView_restore_claim_cancel":"Dort belassen","AccountView_linked_to_other_account":"Das Abo dieser Apple-ID ist mit dem LOGBOOK-Konto \u201E{account}\u201C verkn\xfcpft.","AccountView_linked_to_other_account_hint":"Verschiebe es \xfcber \u201EK\xe4ufe wiederherstellen\u201C in dieses Konto, oder zahle im Web per Karte.","AccountView_title":"Account-Einstellungen","AccountView_total":"Gesamtbetrag","AccountSettingsView_alert_no_internet_title":"Keine Internet-Verbindung verf\xfcgbar","AccountSettingsView_alert_no_internet_text":"Eine Internet-Verbindung ist erforderlich, um die Account-Einstellungen zu \xe4ndern.","AccountSettingsView_error_passwordInvalid":"Das Passwort stimmt nicht mit dem aktuellen \xfcberein.","AccountSettingsView_error_passwordConfirmationMismatch":"Passwortbest\xe4tigung stimmt nicht mit dem Passwort \xfcberein.","AccountSettingsView_error_Not Found":"Nicht gefunden","AccountSettingsView_error_accountUserSelfAction":"Du kannst deine eigenen Berechtigungen nicht \xe4ndern, deaktivieren oder entfernen.","AccountSettingsView_error_accountUserLastAdmin":"Der Account muss mindestens einen aktiven Admin haben.","AccountSettingsView_error_account_user_action_failed":"Etwas ist schiefgelaufen. Bitte versuche es erneut.","AccountSettingsView_error_account_update_failed":"Etwas ist schiefgelaufen. Bitte versuche es erneut.","AccountSettingsView_change_password":"Passwort \xe4ndern","AccountSettingsView_confirm_new_password":"Neue Passwort best\xe4tigen","AccountSettingsView_current_password":"Aktuelles Passwort","AccountSettingsView_new_password":"Neues Passwort","AccountSettingsView_import_ship":"Aus LogbookSuite importieren","AccountSettingsView_import_trips":"Etappen f\xfcr \\"{name}\\" aus LogbookSuite importieren","AccountSettingsView_new_ship":"Mit einem neuen Schiff beginnen","AccountSettingsView_select_ship":"Aus deinen Schiffen ausw\xe4hlen","AccountSettingsView_select_shared_ship":"Aus geteilten Schiffen ausw\xe4hlen","AccountSettingsView_deselect_ship":"Schiff schlie\xdfen","AccountSettingsView_add_new_ship":"Neues Schiff hinzuf\xfcgen","AccountSettingsView_users_list":"Liste aller User in deinem Account","AccountSettingsView_tab_ships":"Deine Schiffe","AccountSettingsView_tab_subscription":"Dein Abonnement","AccountSettingsView_tab_users":"Deine User","AccountSettingsView_ship_open_here_notice":"Schlie\xdfe das auf diesem Ger\xe4t ge\xf6ffnete LOGBOOK, um ein anderes Schiff auszuw\xe4hlen.","AccountSettingsView_companion_reconnect_notice":"Die Verbindung zum Primary LOGBOOK wurde unterbrochen \u2014 seine Adresse in diesem Netzwerk hat sich m\xf6glicherweise ge\xe4ndert. Verbinde dich erneut, um fortzufahren.","AccountSettingsView_ship_close_companion":"LOGBOOK Companion trennen","AccountSettingsView_ship_close_confirm":"LOGBOOK schlie\xdfen","AccountSettingsView_ship_logbook":"LOGBOOK f\xfcr \\"{name}\\" anzeigen","AccountSettingsView_account_data":"Deine Account-Daten","AccountSettingsView_account_edit_cancel":"Abbrechen","AccountSettingsView_account_edit_save":"Speichern","AccountSettingsView_account_login":"Anmeldename (E-Mail)","AccountSettingsView_account_name":"Account Name","AccountSettingsView_account_settings":"Account-Einstellungen","AccountSettingsView_account_user_level":"Berechtigungen","AccountSettingsView_account_user_level_admin":"Admin","AccountSettingsView_account_user_level_user":"User","AccountSettingsView_account_user_level_disabled":"Deaktiviert","AccountSettingsView_deactivate_user":"Deaktivieren","AccountSettingsView_reactivate_user":"Reaktivieren","AccountSettingsView_remove_user":"Entfernen","AccountSettingsView_user_deactivate_confirm_title":"User deaktivieren","AccountSettingsView_user_deactivate_confirm_message":"Dieser User hat noch Zugriff auf ein Schiff in diesem Account. M\xf6chtest du seinen Account wirklich deaktivieren?","AccountSettingsView_user_deactivate_confirm_accept":"Deaktivieren","AccountSettingsView_user_deactivate_confirm_cancel":"Abbrechen","AccountSettingsView_user_remove_confirm_title":"User entfernen","AccountSettingsView_user_remove_confirm_message":"Dieser User hat noch Zugriff auf ein Schiff in diesem Account. M\xf6chtest du ihn wirklich aus dem Account entfernen? Dies kann nicht r\xfcckg\xe4ngig gemacht werden.","AccountSettingsView_user_remove_confirm_accept":"Entfernen","AccountSettingsView_user_remove_confirm_cancel":"Abbrechen","AccountSettingsView_change_plan":"Plan \xe4ndern","AccountSettingsView_customer_name":"Name","AccountSettingsView_edit_account":"Account bearbeiten","AccountSettingsView_remove_account":"Account l\xf6schen","AccountSettingsView_plan":"Dein aktueller Plan","AccountSettingsView_plans":"LOGBOOK Pl\xe4ne","AccountSettingsView_subscription":"Dein Abonnement","AccountSettingsView_user_account":"Account","AccountSettingsView_user_name":"Name","AccountSettingsView_user_email":"E-Mail","AccountSettingsView_user_shortname":"Kurzname","AccountSettingsView_user_status":"Status","AccountSettingsView_user_status_active":"Aktiv","AccountSettingsView_user_status_invited":"Eingeladen","AccountSettingsView_user_permissions":"Berechtigungen","AccountSettingsView_current_ship":"Dein aktuelles Schiff ist {name}","AccountSettingsView_no_current_ship":"Kein Schiff ausgew\xe4hlt","AccountSettingsView_valid_until":"G\xfcltig bis","AccountSettingsView_trial_days_remaining":"Verbleibende Trial-Tage","AccountSettingsView_trial_days_value":"{days} Tage","AccountSettingsView_user_crew_role":"Crew-Rolle","AccountSettingsView_ship_user_crew_role_crew":"Crew","AccountSettingsView_ship_user_crew_role_none":"Keine","AccountSettingsView_ship_user_crew_role_owner":"Account-Inhaber","AccountSettingsView_ship_user_crew_role_skipper":"Skipper","AccountSettingsView_ship_user_level":"Berechtigungen","AccountSettingsView_ship_user_level_primary":"Prim\xe4r","AccountSettingsView_ship_user_level_editAll":"Alles ansehen und bearbeiten","AccountSettingsView_ship_user_level_editCurrent":"Aktuellen T\xf6rn ansehen und bearbeiten","AccountSettingsView_ship_user_level_viewAll":"Alles ansehen","AccountSettingsView_ship_user_level_viewCurrent":"Aktuellen T\xf6rn ansehen","AccountSettingsView_ship_user_level_none":"Keine","AppDisconnectedView":"","AppDisconnectedView_connection_overlay_reload":"Neu laden","AppDisconnectedView_connection_overlay_reloading":"Wird neu geladen \u2026","AppDisconnectedView_connection_overlay_title":"Verbindung unterbrochen","AppDisconnectedView_disconnect_companion":"LOGBOOK Companion trennen","AppHeaderView":"","AppOverlayContentView":"","AppOverlayContentView_cancel":"Abbrechen","AppOverlayContentView_connect_logbook":"Mit Primary LOGBOOK verbinden","AppOverlayContentView_connect_logbook_title":"Mit Primary LOGBOOK von \\"{name}\\" verbinden","AppOverlayContentView_connect_logbook_failed":"Verbindung mit Primary LOGBOOK fehlgeschlagen","AppOverlayContentView_connect_logbook_connecting":"Verbindung mit dem Primary LOGBOOK f\xfcr \\"{name}\\" wird hergestellt\u2026","AppOverlayContentView_connect_logbook_connecting_short":"Verbinden\u2026","AppOverlayContentView_connect_logbook_timeout":"\\"{name}\\" konnte nicht automatisch erreicht werden \u2014 bitte Adresse eingeben","AppOverlayContentView_connect_logbook_not_discovered":"\u201E{name}\u201C ist in diesem Netzwerk nicht sichtbar. Pr\xfcfe, ob beide Ger\xe4te im selben WLAN sind, oder gib die Adresse unten ein.","AppOverlayContentView_connect_logbook_ambiguous":"Mehrere Ger\xe4te bieten \u201E{name}\u201C an. Gib die Adresse des gew\xfcnschten Ger\xe4ts ein.","AppOverlayContentView_connect_logbook_unresolved":"\u201E{name}\u201C wurde gefunden, aber die Adresse konnte nicht ermittelt werden. Bitte unten eingeben.","AppOverlayContentView_connect_logbook_unreachable":"Keine Antwort von \u201E{name}\u201C unter {address}. Pr\xfcfe die Adresse und ob beide Ger\xe4te im selben Netzwerk sind.","AppOverlayContentView_connect_logbook_refused":"\u201E{name}\u201C hat die Verbindung abgelehnt. Stelle sicher, dass der Benutzer dieses Ger\xe4ts Zugriff auf das Logbuch hat.","AppOverlayContentView_connect_logbook_not_claimed":"\u201E{name}\u201C ist derzeit nicht auf dem Primary LOGBOOK ge\xf6ffnet. \xd6ffne es dort und versuche es erneut.","AppOverlayContentView_connect_logbook_not_accessible":"Du hast keinen Zugriff auf \u201E{name}\u201C.","AppOverlayContentView_connect_logbook_address_invalid":"Gib die Adresse als host:port an, zum Beispiel 192.168.1.20:18092.","AppOverlayContentView_connect_logbook_own_device":"\u201E{name}\u201C ist das eigene Logbuch dieses Ger\xe4ts \u2014 \xf6ffne es, statt dich zu verbinden.","AppOverlayContentView_connect_logbook_outdated_title":"Diese App ist nicht aktuell","AppOverlayContentView_connect_logbook_outdated":"Das Primary LOGBOOK von \\"{name}\\" verwendet eine neuere Version als dieses Ger\xe4t. Aktualisiere LOGBOOK hier, um eine Verbindung herzustellen.","AppOverlayContentView_connect_logbook_outdated_version":"Dieses Ger\xe4t verwendet Version {version}.","AppOverlayContentView_connect_logbook_outdated_appstore":"Bitte aktualisiere LOGBOOK im App Store.","AppOverlayContentView_connect_logbook_outdated_playstore":"Bitte aktualisiere LOGBOOK im Play Store.","AppOverlayContentView_connect_logbook_outdated_download":"Neueste Version herunterladen","AppOverlayContentView_connection":"Trage hier die IP und den Port des Primary LOGBOOK ein, um eine Verbindung herzustellen. Verwende die Form \\"IP:Port\\", z.B. \\"192.168.0.100:8000\\".","AppOverlayContentView_connection_host":"Host","AppOverlayContentView_connection_port":"Port","AppOverlayContentView_disconnect_logbook":"Primary LOGBOOK trennen","AppOverlayContentView_disconnect_ship":"Schiff trennen","AppOverlayContentView_disconnect_ship_title":"Schiff von LOGBOOK Cloud trennen","AppOverlayContentView_import_reset":"Alle importierten Daten zur\xfccksetzen","AppOverlayContentView_import_reset_confirm_title":"Alle importierten Daten zur\xfccksetzen?","AppOverlayContentView_import_reset_confirm_text":"Alle importierten T\xf6rns werden dauerhaft gel\xf6scht. Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.","AppOverlayContentView_import_reset_confirm_no":"Abbrechen","AppOverlayContentView_import_reset_confirm_yes":"Ja, zur\xfccksetzen","AppOverlayContentView_import_resetting":"Wird zur\xfcckgesetzt\u2026","AppOverlayContentView_import_ship_cancel":"Abbrechen","AppOverlayContentView_import_ship_choose":"Datei ausw\xe4hlen","AppOverlayContentView_import_ship_title":"Aus Logbook Suite importieren","AppOverlayContentView_import_trips":"Import aus Logbook Suite","AppOverlayContentView_import_status_in_progress":"Import l\xe4uft seit {time}","AppOverlayContentView_import_status_complete":"Import abgeschlossen am {date}","AppOverlayContentView_import_status_failed":"Vorheriger Importversuch fehlgeschlagen. Bitte versuche es erneut oder kontaktiere den Support.","AppOverlayContentView_options_cruises":"T\xf6rns insgesamt in LOGBOOK:","AppOverlayContentView_options_days":"Tage insgesamt in LOGBOOK:","AppOverlayContentView_options_first_day":"Erster Tag in LOGBOOK:","AppOverlayContentView_options_last_day":"Letzter Tag in LOGBOOK:","AppOverlayContentView_options_trips":"Etappen insgesamt in LOGBOOK:","AppOverlayContentView_options_ship":"Optionen f\xfcr \\"{name}\\"","AppOverlayContentView_options_ship_title":"Info zum Schiff","AppOverlayContentView_options_update":"Letzte Synchronisation:","AppOverlayContentView_logout_confirm":"Ausloggen","AppOverlayContentView_logout_confirm_cancel":"Abbrechen","AppOverlayContentView_logout_confirm_title":"Logout best\xe4tigen","AppOverlayContentView_remove_account_cancel":"Abbrechen","AppOverlayContentView_remove_account_confirm":"Best\xe4tigen","AppOverlayContentView_remove_account_confirm_title":"Account l\xf6schen","AppOverlayContentView_session_expired_dismiss":"Ohne Synchronisation weiterarbeiten","AppOverlayContentView_session_expired_email":"E-Mail","AppOverlayContentView_session_expired_failed":"Login fehlgeschlagen. Bitte pr\xfcfe E-Mail und Passwort und versuche es erneut.","AppOverlayContentView_session_expired_failed_request":"Der Login konnte nicht gesendet werden. Bitte pr\xfcfe die Internetverbindung und versuche es erneut.","AppOverlayContentView_session_expired_login":"Einloggen","AppOverlayContentView_session_expired_login_loading":"Login l\xe4uft\u2026","AppOverlayContentView_session_expired_password":"Passwort","AppOverlayContentView_session_expired_title":"Login erforderlich","AppOverlayContentView_ship_close_confirm":"Schlie\xdfen von LOGBOOK best\xe4tigen","AppOverlayContentView_ship_close_confirm_cancel":"Abbrechen","AppOverlayContentView_ship_close_confirm_closing":"LOGBOOK wird geschlossen\u2026","AppOverlayContentView_ship_close_confirm_title":"Schlie\xdfen des Schiffs best\xe4tigen","AppOverlayContentView_ship_close_failed":"LOGBOOK konnte nicht geschlossen werden. Pr\xfcfe die Internetverbindung und versuche es erneut.","AppOverlayContentView_ship_close_failed_offline":"LOGBOOK konnte nicht geschlossen werden, weil dieses Ger\xe4t offline ist. Pr\xfcfe die Internetverbindung und versuche es erneut, oder schlie\xdfe nur lokal.","AppOverlayContentView_ship_close_failed_server":"LOGBOOK konnte nicht geschlossen werden, weil die LOGBOOK Cloud vor\xfcbergehend nicht erreichbar ist. Bitte versuche es gleich noch einmal.","AppOverlayContentView_ship_force_close":"Nur lokal schlie\xdfen","AppOverlayContentView_ship_force_close_confirm":"Lokales Schlie\xdfen best\xe4tigen","AppOverlayContentView_ship_view_ships_cloud":"Schiffsliste in Cloud anzeigen","AppOverlayContentView_ships_cloud":"Schiffsliste in Cloud anzeigen","AppOverlayContentView_user_settings":"User-Einstellungen","AppOverlayContentView_ship_not_closed_title":"Primary LOGBOOK \\"{name}\\" von der LOGBOOK Cloud trennen","AppOverlayContentView_ship_open_title":"Das Primary LOGBOOK f\xfcr \\"{name}\\" ist schon ge\xf6ffnet","AppOverlayContentView_read_more":"Weiterlesen","ChangeLogView_change_log":"\xc4nderungsprotokoll","ChangeLogView_download":"Herunterladen","ChangeLogView_change_welcome":"Willkommen zur LOGBOOK App Version {version}!","ChangeLogView_change_fixed_info":"Hier findest du Informationen zu allen vorgenommenen \xc4nderungen. Das \xc4nderungsprotokoll-Fenster wird bei jedem Neuladen der App angezeigt, wenn neue \xc4nderungen vorliegen.","ChangeLogView_new_version_available":"Neues Update zum Download verf\xfcgbar","ChangeLogView_title":"Was ist neu in LOGBOOK","Component_ToggleSwitch":"","Component_ToggleSwitch_off":"AUS","Component_ToggleSwitch_on":"EIN","CruiseCalendarView":"","CruiseCalendarView_actions_print":"Drucken","CruiseCalendarView_focus":"Fokus","CruiseCalendarView_start_ship":"Das neue Schiff in der LOGBOOK-App \xf6ffnen","CruiseCalendarView_open_in_cloud":"In Cloud \xf6ffnen","CruiseCalendarView_untitled_cruise":"T\xf6rn ohne Namen","CruiseEditView_title":"Name des T\xf6rns","CruiseView":"","CruiseView_actions_print":"Drucken","CruiseView_empty":"Etappe erstellen, um fortzufahren","CruiseView_menu_labels":"Filter","CruiseView_menu_toggle_labels_off":"Labels aus","CruiseView_menu_toggle_labels_on":"Labels ein","CruiseView_tab_cruise":"T\xf6rn","CruiseView_tab_stats":"Statistik","CruiseView_tab_track":"Track","CruiseView_tab_print":"Drucken","CruiseView_print_cruise":"Diesen T\xf6rn drucken","CruiseView_untitled_cruise":"T\xf6rn ohne Namen","DayEditView":"","DayEditView_comment":"Bemerkung","DayEditView_crew":"Crew","DayEditView_end_location":"Zielort","DayEditView_passengers":"Passagiere","DayEditView_skipper":"Skipper","DayEditView_start_location":"Startort","DayEditView_status_day":"Tag","DayEditView_status_overnight":"\xdcbernachtung","DayEditView_sunrise":"Sonnenaufgang","DayEditView_sunset":"Sonnenuntergang","DayEditView_timezone":"Zeitzone","DayEditView_other_skipper":"Neuer Skipper","DayEditView_other_crew":"Neue Person","DayEditView_save_error_generic":"Nicht gespeichert. Bitte erneut versuchen.","DayEditView_details_last_edited_by":"Zuletzt bearbeitet von {name}","DayEditView_details_last_edited":"Zuletzt bearbeitet","DayHeaderView":"","DayHeaderView_today":"Heute","DayHeaderView_nextDay":"N\xe4chster Tag","DayHeaderView_yesterday":"Gestern","DayView":"","DayView_logs_empty":"Noch keine Log-Eintr\xe4ge","DayView_logs_empty_past":"Keine Log-Eintr\xe4ge","DayView_tab_day":"Tag","DayView_tab_stats":"Statistik","DayView_tab_track":"Track","DayView_tab_watches":"Wachplan","DayView_tab_weather":"Wetter","DayView_tab_weather_forecast":"Wettervorhersage","DayView_tab_journal":"Journal","DayView_tab_technical":"Technik","DayView_tab_print":"Drucken","DayView_print_days":"Alle Tage dieser Etappe drucken","DayView_print_day":"Diesen Tag drucken","DayWatchView":"","DayWatchView_groups_title":"Gruppen f\xfcr Wachen","DayWatchView_add_group":"Gruppe hinzuf\xfcgen","DayWatchView_groups_name":"Wachgruppen-Name","DayWatchView_groups_people":"Crew-Mitglieder","DayWatchView_shifts_title":"Wachplan","DayWatchView_shifts_hour":"Stunde","DayWatchView_shifts_duration":"Dauer (h)","DayWatchView_shifts_group":"Wachgruppe","DayWatchView_shifts_group_undefined":"*Ausw\xe4hlen*","DayWatchView_add_shift":"Wachschicht hinzuf\xfcgen","DayWatchView_reset_shifts":"Wachschichten zur\xfccksetzen","DayWatchView_shifts_unit_hour":"h","EditHistory":"","EditHistory_title":"Verlauf der \xc4nderungen","EditHistory_field":"Feld","EditHistory_previous":"Vorher","EditHistory_new":"Neu","EditHistory_changed":"Ge\xe4ndert","EditHistory_entry_meta":"{date} von {name}","FocusView":"","FocusView_actions_add_cruise":"T\xf6rn","FocusView_actions_add_trip":"Etappe","FocusView_actions_complete_cruise":"T\xf6rn","FocusView_actions_complete_trip":"Etappe","FocusView_actions_print":"Drucken","FocusView_start_trip":"Etappe starten","FocusView_cancel":"Abbrechen","FocusView_close":"Schlie\xdfen","FocusView_confirm":"Fortfahren","FocusView_confirm_cruise_title":"Neuen T\xf6rn starten","FocusView_confirm_trip_title":"Neue Etappe starten","FocusView_set_timezone":"Zeitzone festlegen","FocusView_tile_new_trip":"Eine neue Etappe starten","FocusView_timezone":"Zeitzone f\xfcr die Etappe festgelegt","FocusView_current_time":"Berechnete aktuelle Zeit","FocusView_subscription_expired":"Abonnement abgelaufen","FocusView_trial_expired":"Trial-Phase abgelaufen","FocusView_view_plans":"Abonnement-Pl\xe4ne anzeigen","GraphView":"","GraphView_graph_pressure":"Luftdruck","GraphView_graph_temperature":"Temperatur","GraphView_graph_windDirection":"Windrichtung","GraphView_graph_windDirection_unit":"{direction}\xb0","GraphView_graph_windSpeed":"Windgeschwindigkeit","GraphView_no_data":"Keine Daten","InstrumentsView":"","InstrumentsView_compass_title":"Kompass","InstrumentsView_compass_title_magnetic":"Kompass (mag.)","InstrumentsView_compass_title_true":"Kompass (wahr)","InstrumentsView_course_title":"Kurs","InstrumentsView_depth_title":"Tiefe","InstrumentsView_depth_title_DBK":"Unter Kiel","InstrumentsView_depth_title_DBS":"Unter Oberfl\xe4che","InstrumentsView_depth_title_DBT":"Unter Geber","InstrumentsView_depth_title_DPT":"Wasser","InstrumentsView_engine_title_single":"Motor","InstrumentsView_engine_title_multiple":"Motoren","InstrumentsView_nmea_lost_title":"NMEA-Verbindung verloren","InstrumentsView_speed_title":"Geschw.","InstrumentsView_wind_title":"Wind","InstrumentsView_wind_title_apparent":"Scheinbar","InstrumentsView_wind_title_true":"Wahr","InstrumentsView_wind_title_trueRelative":"Wahr (rel.)","InstrumentsView_wind_side_port":"Bb","InstrumentsView_wind_side_starboard":"Stb","LogEnvironmentView":"","LogEnvironmentView_current_direction_speed":"Str\xf6mung: Richtung | Geschwind.","LogEnvironmentView_pressure":"Luftdruck","LogEnvironmentView_save_error_fields":"Nicht gespeichert \u2014 nicht erlaubt: {fields}","LogEnvironmentView_save_error_generic":"Nicht gespeichert. Bitte erneut versuchen.","LogEnvironmentView_seastate":"Seegang","LogEnvironmentView_seastate_undefined":" ","LogEnvironmentView_seastate_":" ","LogEnvironmentView_seastate_0":"0 Ruhig (spiegelglatt)","LogEnvironmentView_seastate_1":"1 Ruhig (gekr\xe4uselt) < 0,1m","LogEnvironmentView_seastate_2":"2 Glatt (kleine Wellen) < 0,5m","LogEnvironmentView_seastate_3":"3 Leicht < 1,25m","LogEnvironmentView_seastate_4":"4 M\xe4\xdfig < 2,5m","LogEnvironmentView_seastate_5":"5 Rau < 4m","LogEnvironmentView_seastate_6":"6 Sehr rau < 6m","LogEnvironmentView_seastate_7":"7 Hoch < 9m","LogEnvironmentView_seastate_8":"8 Sehr hoch < 14m","LogEnvironmentView_seastate_9":"9 Ph\xe4nomenal > 14m","LogEnvironmentView_seastate_10":"Verwirrter Seegang","LogEnvironmentView_other":"Neuer Seegang","LogEnvironmentView_current_direction_undefined":" ","LogEnvironmentView_current_direction_":" ","LogEnvironmentView_current_direction_0":"0\xb0","LogEnvironmentView_current_direction_1":"90\xb0","LogEnvironmentView_current_direction_2":"180\xb0","LogEnvironmentView_current_direction_3":"270\xb0","LogEnvironmentView_other_direction":"Andere Richtung","LogEnvironmentView_weather_":"   ","LogEnvironmentView_weather_field":"Wetter","LogEnvironmentView_weather_1":"klarer Himmel","LogEnvironmentView_weather_2":"sch\xf6n","LogEnvironmentView_weather_3":"halb bew\xf6lkt","LogEnvironmentView_weather_4":"bew\xf6lkt","LogEnvironmentView_weather_5":"bedeckt","LogEnvironmentView_weather_6":"Nieselregen","LogEnvironmentView_weather_7":"m\xe4\xdfiger Regen","LogEnvironmentView_weather_8":"starker Regen","LogEnvironmentView_weather_9":"Regenschauer","LogEnvironmentView_weather_10":"Diesig","LogEnvironmentView_weather_11":"Nebel","LogEnvironmentView_weather_12":"Dunst","LogEnvironmentView_weather_13":"Schneeregen","LogEnvironmentView_weather_14":"Hagel","LogEnvironmentView_weather_15":"Gewitter","LogEnvironmentView_weather_16":"Schnee","LogEnvironmentView_weather_temp_rel_humidity":"Wetter | Temp. | Rel. Luftfeuchtigkeit","LogEnvironmentView_weather_temp":"Lufttemperatur","LogEnvironmentView_weather_rel_humidity":"Relative Luftfeuchtigkeit","LogEnvironmentView_wind_direction_speed":"Wind: Richtung | Geschwindigkeit","LogNavigationView":"","LogNavigationView_comment":"Bemerkung","LogNavigationView_course":"Kurs","LogNavigationView_course_to_wind":"Kurs zum Wind","LogNavigationView_point_of_sail_noGo":"Im Wind","LogNavigationView_point_of_sail_closeHauled":"Am Wind","LogNavigationView_point_of_sail_beamReach":"Halbwind","LogNavigationView_point_of_sail_broadReach":"Raum","LogNavigationView_point_of_sail_running":"Vorwind","LogNavigationView_wind_side_port":"Bb","LogNavigationView_wind_side_starboard":"Stb","LogNavigationView_depth":"Tiefe","LogNavigationView_distance":"Distanz","LogNavigationView_engine":"Motor","LogNavigationView_engines":"Motoren","LogNavigationView_engine_name":"Motor {name}","LogNavigationView_heading":"Heading","LogNavigationView_location":"Ort w\xe4hrend Stopp","LogNavigationView_log":"Log","LogNavigationView_position":"Position: Lat | Lon","LogNavigationView_sails":"Segel","LogNavigationView_sog":"SOG","LogNavigationView_status":"Status","LogNavigationView_status_anchor":"Vor Anker","LogNavigationView_status_buoy":"An Boje","LogNavigationView_status_drifting":"Treibend","LogNavigationView_status_inmotion":"In Fahrt","LogNavigationView_status_none":"Keine","LogNavigationView_status_offboard":"Von Bord","LogNavigationView_status_onboard":"An Bord","LogNavigationView_status_port":"Im Hafen","LogNavigationView_status_lock":"Schleuse","LogNavigationView_status_bunkering":"Tankstelle","LogNavigationView_status_bridge":"Br\xfccke","LogNavigationView_status_waiting":"Wartend","LogNavigationView_stw":"STW","LogNavigationView_time":"Zeit","LogNavigationView_time_utc":"UTC","LogNavigationView_created":"Log-Eintrag erstellt um","LogNavigationView_updated":"Log-Eintrag aktualisiert um","LogNavigationView_engine_rpms":"Motordrehzahl","LogNavigationView_save_error_fields":"Nicht gespeichert \u2014 nicht erlaubt: {fields}","LogNavigationView_save_error_generic":"Nicht gespeichert. Bitte erneut versuchen.","LogWatchView":"","LogWatchView_watch":"Wache","LogWatchView_watch_comment":"Wach-Bemerkung","LogWatchView_save_error_generic":"Nicht gespeichert. Bitte erneut versuchen.","LogView":"","LogView_details_created_by":"Erstellt von {name}","LogView_details_updated_at":"Zuletzt aktualisiert am {date}","LogView_details_last_edited_by":"Zuletzt bearbeitet von {name}","LogView_details_last_edited":"Zuletzt bearbeitet","LogView_label_auto":"auto","LogView_label_default":"standard","LogView_label_manual":"manuell","LogView_label_nmea":"nmea","LogView_log_alert":"Alarm {status}: {type} {info}","LogView_log_alert_info_anchorDepth":"- {depth}","LogView_log_alert_info_anchorDrift":"- {distance} vom Ankerpunkt abgetrieben","LogView_log_alert_info_pressure":"- {action} um {delta} in {interval}","LogView_log_alert_info_pressure_drop":"gesunken","LogView_log_alert_info_pressure_raise":"gestiegen","LogView_log_alert_anchorDrift":"Ankerdrift","LogView_log_alert_depth":"Tiefe","LogView_log_alert_lights":"Sichtzeichen","LogView_log_alert_lostPosition":"Position verloren","LogView_log_alert_manOverboard":"Mann \xfcber Bord","LogView_log_alert_message":"Nachricht","LogView_log_alert_pressure":"Luftdruck","LogView_log_alert_test":"Test","LogView_log_alert_wind":"Wind","LogView_log_alert_start":"Alarm {alert} ist {status}","LogView_log_alert_triggered":"Alarm {alert} ausgel\xf6st","LogView_log_alert_anchorDrift_detail":"{transition}: {problem}","LogView_log_alert_depth_detail":"{transition}: {problem}","LogView_log_alert_lostPosition_detail":"{transition}: {problem}","LogView_log_alert_manOverboard_detail":"{transition}: {problem}","LogView_log_alert_message_detail":"{transition}: {problem}","LogView_log_alert_lostPosition_disconnected":"NMEA-Verbindung getrennt","LogView_log_alert_lostPosition_stale":"Positionsdaten sind veraltet","LogView_log_alert_lostPosition_jump":"unplausibler Positionssprung","LogView_log_alert_lostPosition_invalidFix":"ung\xfcltiger GPS-Fix","LogView_log_alert_manOverboard_emitterActivated":"MOB-Sender aktiviert","LogView_log_alert_manOverboard_manualButtonActivated":"MOB-Taste aktiviert","LogView_log_alert_manOverboard_manual":"manuell ausgel\xf6st","LogView_log_alert_manOverboard_unknown":"MOB-Signal empfangen","LogView_log_alert_lights_detail":"{recorded} -> {recommended}: {transition}.","LogView_log_alert_escalated":"Alarm {alert} eskaliert","LogView_log_alert_escalated_by":"Alarm {alert} von {name} an den Skipper eskaliert","LogView_log_alert_snoozed":"Alarm {alert} geschlummert","LogView_log_alert_snoozed_by":"Alarm {alert} von {name} geschlummert","LogView_log_alert_acknowledged":"Alarm {alert} best\xe4tigt","LogView_log_alert_acknowledged_by":"Alarm {alert} von {name} best\xe4tigt","LogView_log_alert_cleared":"Alarm {alert} gel\xf6scht","LogView_log_alert_cleared_by":"Alarm {alert} von {name} gel\xf6scht","LogView_log_alert_resolved":"Alarm {alert} beendet","LogView_log_alert_status_acknowledged":"Best\xe4tigt","LogView_log_alert_status_alarm":"Alarm","LogView_log_alert_status_ignored":"Ignoriert","LogView_log_alert_status_ok":"OK","LogView_log_alert_status_resolved":"Behoben","LogView_log_alert_status_warning":"Warnung","LogView_log_alert_type_anchorDepth":"Ankertiefe","LogView_log_alert_type_anchorDrift":"Ankerdrift","LogView_log_alert_type_pressure":"Luftdruck","LogView_log_auto_interval":"Automatischer Eintrag nach {duration}","LogView_log_change_add_crew":"Zur Crew hinzugef\xfcgt: {name}","LogView_log_change_add_passengers":"Zu Passagieren hinzugef\xfcgt: {name}","LogView_log_change_add_skipper":"Zu Skipper hinzugef\xfcgt: {name}","LogView_log_change_remove_crew":"Aus Crew entfernt: {name}","LogView_log_change_remove_passengers":"Aus Passagieren entfernt: {name}","LogView_log_change_remove_skipper":"Aus Skipper entfernt: {name}","LogView_log_course_change":"Kurs\xe4nderung","LogView_log_course_change_active":"Kurs\xe4nderung um {angle} {side} in {duration} auf {course}","LogView_log_course_change_end":"Kurs\xe4nderung um {angle} {side} in {duration} von {course}","LogView_log_course_change_side_port":"nach Backbord","LogView_log_course_change_side_starboard":"nach Steuerbord","LogView_log_course_change_started":"Kurs\xe4nderung begonnen","LogView_log_engine_start":"Motor gestartet","LogView_log_engine_start_name":"Motor {name} gestartet","LogView_log_engine_start_idle":"Motor im Leerlauf gestartet","LogView_log_engine_start_idle_name":"Motor {name} im Leerlauf gestartet","LogView_log_engine_stop":"Motor gestoppt","LogView_log_engine_stop_name":"Motor {name} gestoppt","LogView_log_engine_stop_duration":"Motor gestoppt nach {duration}","LogView_log_engine_stop_duration_name":"Motor {name} gestoppt nach {duration}","LogView_log_engine_stop_distance":"Motor gestoppt nach {duration} ({distance})","LogView_log_engine_stop_distance_name":"Motor {name} gestoppt nach {duration} ({distance})","LogView_log_engine_idle":"Motor im Leerlauf","LogView_log_engine_idle_name":"Motor {name} im Leerlauf","LogView_log_engine_load":"Motor unter Last","LogView_log_engine_load_name":"Motor {name} unter Last","LogView_log_engine_load_duration":"Motor unter Last nach {duration}","LogView_log_engine_load_duration_name":"Motor {name} unter Last nach {duration}","LogView_log_engine_missing":"Motorinformationen fehlen, vermutlich gestoppt","LogView_log_engine_missing_name":"Motor {name} Informationen fehlen, vermutlich gestoppt","LogView_log_engine_missing_duration":"Motorinformationen fehlen, vermutlich gestoppt nach {duration}","LogView_log_engine_missing_duration_name":"Motor {name} Informationen fehlen, vermutlich gestoppt nach {duration}","LogView_log_engine_missing_distance":"Motorinformationen fehlen, vermutlich gestoppt nach {duration} ({distance})","LogView_log_engine_missing_distance_name":"Motor {name} Informationen fehlen, vermutlich gestoppt nach {duration} ({distance})","LogView_log_propulsion_off":"Unter Segeln, kein Motor in Betrieb","LogView_log_propulsion_off_noSails":"Kein Motor in Betrieb","LogView_log_engine_missing_hint_castOff":"Fehlt ein Motoreintrag seit dem Ablegen?","LogView_log_engine_missing_hint_anchorUp":"Fehlt ein Motoreintrag seit dem Ankerlichten?","LogView_log_engine_missing_hint_motorVessel":"Fehlt ein Motoreintrag seit der Abfahrt?","LogView_log_generator_start":"Generator {number} gestartet","LogView_log_generator_stop":"Generator {number} gestoppt","LogView_log_lighting":"Sichtzeichen auf {lighting} gesetzt","LogView_log_lighting_none":"Keine Sichtzeichen gef\xfchrt","LogView_log_monitor_start":"Monitor {monitor} gestartet","LogView_log_monitor_stop":"Monitor {monitor} gestoppt","LogView_log_monitor_anchor":"Anker-Alarm","LogView_log_monitor_depth":"Tiefenwache","LogView_log_navigation_status_start":"Navigation gestartet","LogView_log_navigation_status_stop":"Navigation gestoppt","LogView_log_nmea_connection_resume":"NMEA-Verbindung f\xfcr Navigationsdaten wiederhergestellt","LogView_log_nmea_connection_stop":"NMEA-Verbindung f\xfcr Navigationsdaten verloren","LogView_log_nmea_connection_start":"NMEA-Verbindung gestartet f\xfcr","LogView_log_nmea_connection_user_stop":"NMEA-Verbindung f\xfcr Navigationsdaten geschlossen","LogView_log_pause_start":"Beginn der Pause","LogView_log_pause_stop":"Ende der Pause","LogView_log_pause_stop_duration":"Ende der Pause nach {duration}","LogView_log_pause_stop_status":"{status} beendet","LogView_log_pause_stop_status_duration":"{status} beendet nach {duration}","LogView_log_status_anchor":"Vor Anker","LogView_log_status_bunkering":"An der Tankstelle","LogView_log_status_buoy":"An Boje","LogView_log_status_drifting":"Treibend","LogView_log_status_inmotion":"In Fahrt","LogView_log_status_offboard":"Von Bord","LogView_log_status_onboard":"An Bord","LogView_log_status_port":"Im Hafen","LogView_log_status_lock":"In Schleuse","LogView_log_status_bridge":"An der Br\xfccke","LogView_log_status_waiting":"Wartend","LogView_log_status_location":"{status}: {location}","LogView_log_stop":"Angehalten f\xfcr {stop}","LogView_log_stop_location":"Angehalten f\xfcr {stop} bei {location}","LogView_log_stop_type_endOfDay":"Tagesende","LogView_log_stop_type_stopover":"Zwischenstopp","LogView_log_sail_down":"{sail} geborgen","LogView_log_sail_up":"{sail} gesetzt","LogView_nmea_auto_course_change_entries":"Kurs\xe4nderungseintr\xe4ge","LogView_nmea_auto_entries":"Auto-Eintr\xe4ge","LogView_nmea_pending":"Log","LogView_provisional_cancel_discard":"Eintrag verwerfen","LogView_provisional_cancel_error":"Der Eintrag konnte nicht verworfen werden. Bitte erneut versuchen.","LogView_provisional_cancel_keep":"Behalten","LogView_provisional_cancel_message_courseChange":"Diese Kurs\xe4nderung verwerfen? F\xfcr dieses Man\xf6ver wird kein Eintrag aufgezeichnet.","LogView_provisional_cancel_message_speedChange":"Diese Pause verwerfen? Es wird kein Eintrag aufgezeichnet und das Schiff bleibt in Fahrt.","LogView_provisional_cancel_title_courseChange":"Kurs\xe4nderung verwerfen","LogView_provisional_cancel_title_speedChange":"Pause verwerfen","LogView_tab_environment":"Umgebung","LogView_tab_navigation":"Navigation","LogView_tab_watch":"Wache","LoginView":"","LoginView_error_confirmation_failed":"E-Mail-Best\xe4tigung fehlgeschlagen. Wenn das Konto zuvor aktiviert wurde, kannst du die Funktion \'Passwort vergessen\' unten verwenden.","LoginView_error_failed":"Login fehlgeschlagen. Bitte \xfcberpr\xfcfe deine E-Mail und dein Passwort und versuche es erneut.","LoginView_error_failed_request":"Login fehlgeschlagen. Bitte \xfcberpr\xfcfe deine Internet-Verbindung und versuche es erneut.","LoginView_error_native_login_failed":"Die Anmeldung konnte nicht abgeschlossen werden. Bitte kehre zur App zur\xfcck und versuche es erneut.","LoginView_local_login_required":"\xd6ffne LOGBOOK auf diesem Ger\xe4t, um dich anzumelden. Die Primary-Anmeldung ist nur in der lokalen App dieses Ger\xe4ts m\xf6glich.","LoginView_companion_handoff_failed":"Die Companion-Verbindung konnte nicht hergestellt werden. \xd6ffne LOGBOOK auf diesem Ger\xe4t und verbinde dich erneut \xfcber deine Schiffsliste.","LoginView_companion_handoff_pending":"Verbindung zum Primary LOGBOOK wird hergestellt...","LoginView_error_native_login_invalid":"Die Anmeldung kann nicht fortgesetzt werden, weil der App-R\xfcckruf fehlt oder ung\xfcltig ist.","LoginView_error_signup_failed":"Registrierung fehlgeschlagen.","LoginView_error_signupEmailAlreadyExists":"Registrierung fehlgeschlagen. E-Mail-Adresse wird bereits verwendet.","LoginView_error_signupAccountAlreadyExists":"Registrierung fehlgeschlagen. Ein Account mit diesem Namen existiert bereits.","LoginView_error_signupNameInvalid":"Bitte gib deinen Namen ein (mindestens 3 Zeichen).","LoginView_error_signupEmailInvalid":"Bitte gib eine g\xfcltige E-Mail-Adresse ein.","LoginView_error_signupPasswordInvalid":"Das Passwort muss mindestens 3 Zeichen lang sein.","LoginView_error_invitation_accept_failed":"Annahme der Einladung fehlgeschlagen. Bitte stelle sicher, dass du mit dem Account angemeldet bist, an den die Einladung gesendet wurde, und versuche es erneut.","LoginView_forgot_password":"Passwort vergessen","LoginView_forgot_password_complete":"Passwort ge\xe4ndert. Du kannst dich nun mit dem neuen Passwort anmelden.","LoginView_forgot_password_email":"Bitte gib die E-Mail-Adresse deines Kontos ein, um die Wiederherstellung des Passworts zu starten.","LoginView_forgot_password_email_sent":"Wenn ein Konto f\xfcr diese E-Mail-Adresse existiert, erh\xe4ltst du eine E-Mail mit den n\xe4chsten Schritten.","LoginView_forgot_password_new_password":"Bitte gib ein neues Passwort ein, um die Wiederherstellung des Passworts abzuschlie\xdfen.","LoginView_error_reset_failed":"Wiederherstellung des Passworts fehlgeschlagen. Bitte versuche es erneut.","LoginView_error_reset_failed_request":"Wiederherstellung des Passworts fehlgeschlagen. Bitte \xfcberpr\xfcfe deine Internetverbindung und versuche es erneut.","LoginView_form_back_to_login":"Zur\xfcck zum Login","LoginView_form_name":"Name","LoginView_form_email":"E-Mail","LoginView_form_new_password":"Neues Passwort","LoginView_form_new_password_confirmation":"Neue Passwortbest\xe4tigung","LoginView_form_password":"Passwort","LoginView_form_submit":"Login","LoginView_form_submit_forgot_password":"Zur\xfccksetzen","LoginView_form_submit_forgot_password_loading":"Zur\xfccksetzen\u2026","LoginView_form_submit_login":"Login","LoginView_form_submit_login_loading":"Login\u2026","LoginView_form_submit_signup":"Registrieren","LoginView_form_forgot_password":"Passwort\xa0vergessen?","LoginView_form_account_name":"Account-Name","LoginView_reset_app_title":"App zur\xfccksetzen","LoginView_reset_app_cancel":"Abbrechen","LoginView_reset_app_action":"Zur\xfccksetzen starten","LoginView_welcome":"Willkommen bei LOGBOOK.","LoginView_signup_link_unavailable":"Der Link zur Registrierung konnte nicht geladen werden. Bitte versuche es erneut.","LoginView_signup_link_retry":"Erneut versuchen","LoginView_login":"Du hast bereits einen Account? Melde dich einfach bei LOGBOOK an.","LoginView_login_email":"Melde dich mit deiner E-Mail und dem Passwort an.","LoginView_native_sign_in_loading":"Anmeldung l\xe4uft\u2026","LoginView_native_sign_in_fallback":"Mit Safari anmelden","LoginView_native_sign_in_or":"oder","LoginView_signup":"Du bist neu bei LOGBOOK? Registriere dich einfach f\xfcr LOGBOOK.","LoginView_signup_email":"Registriere dich mit deiner E-Mail und einem Passwort.","LoginView_invitation_use_other_account":"Anderen Account verwenden","LoginView_invitation_accept":"Einladung annehmen","LoginView_footer_about":"\xdcber uns","LoginView_footer_help":"Hilfe","LoginView_footer_language":"Sprache","LoginView_footer_reset_app":"App zur\xfccksetzen","Menu":"","Menu_ship":"Schiff","Menu_account":"Account","MenuAccount":"","MenuAccount_account_settings":"Account-Einstellungen","MenuAccount_remove_account":"Account l\xf6schen","MenuAccount_close_companion":"Companion trennen","MenuAccount_open_cloud":"Zur LOGBOOK-Cloud","MenuAccount_account_settings_app":"Zur LOGBOOK-App","MenuAccount_logout":"Abmelden","MenuAccount_switch_user":"User wechseln","MenuAccount_return_to_own_user":"Zur\xfcck zu {name}","MenuAccount_user_settings":"User-Einstellungen","MenuHelp":"","MenuHelp_about":"\xdcber\xa0LOGBOOK","MenuHelp_change_log":"\xc4nderungsprotokoll","MenuHelp_contact_support":"Support\xa0kontaktieren","MenuHelp_documentation":"Dokumentation","MenuHelp_help":"Hilfe","MenuHelp_support":"Support-Seite","MenuHelp_qanda":"Tipps","MenuHelp_demo":"Interaktive Demos","MenuHelp_title":"Hilfe","MenuAlerts":"","MenuAlerts_title":"Alarme","MenuNMEA":"","MenuNMEA_connection":"NMEA-Verbindung","MenuNMEA_last_update":"Letzte Aktualisierung: {timestamp}","MenuNMEA_recording":"Automatisches Loggen","MenuNMEA_settings":"Einstellungen","MenuNMEA_title":"NMEA","MenuShip":"","MenuShip_close":"LOGBOOK {name} schlie\xdfen","MenuShip_logout":"Von \\"{name}\\" abmelden","MenuShip_data_name":"{name} Schiffsdaten","MenuShip_new":"Neues Schiff","MenuShip_settings_name":"{name} Einstellungen","MenuShip_select":"Schiff ausw\xe4hlen","MenuShip_view_cloud":"\\"{name}\\" in Cloud anzeigen","MenuShip_view_ships":"Schiffsliste anzeigen","MenuSync":"","MenuSync_internet_status":"Internet-Verbindung","MenuSync_last_update":"Letzte Aktualisierung: {timestamp}","MenuSync_status":"Sync-Status","MenuSync_title":"Sync","MenuSync_resync":"Verbindung wiederherstellen","MenuSync_relogin":"Erneut einloggen","NMEAConfigurationView":"","NMEAConfigurationView_blank":"\xa0","NMEAConfigurationView_and":"und","NMEAConfigurationView_banner_start_setup":"NMEA-Einrichtung starten","NMEAConfigurationView_banner_text":"NMEA-Verbindung ist nicht aktiviert.","NMEAConfigurationView_cancel":"Abbrechen","NMEAConfigurationView_checks":"Verf\xfcgbare NMEA-Daten:","NMEAConfigurationView_check_air_pressure":"Luftdruck","NMEAConfigurationView_check_air_humidity":"Luftfeuchtigkeit","NMEAConfigurationView_check_air_temperature":"Lufttemperatur","NMEAConfigurationView_check_depth":"Tiefe","NMEAConfigurationView_check_engine":"Motor-Drehzahl","NMEAConfigurationView_check_engine_1":"Motor-Drehzahl #1","NMEAConfigurationView_check_engine_2":"Motor-Drehzahl #2","NMEAConfigurationView_check_engine_3":"Motor-Drehzahl #3","NMEAConfigurationView_check_engine_4":"Motor-Drehzahl #4","NMEAConfigurationView_check_engine_5":"Motor-Drehzahl #5","NMEAConfigurationView_check_engine_ids":"Empfangene Motor IDs: {ids}","NMEAConfigurationView_check_engine_ids_none":"keine","NMEAConfigurationView_check_navigation_course":"Heading","NMEAConfigurationView_check_navigation_gps":"GPS-Position","NMEAConfigurationView_check_navigation_log":"Distanz durchs Wasser","NMEAConfigurationView_check_navigation_sog":"Geschwindigkeit \xfcber Grund","NMEAConfigurationView_check_utc":"UTC","NMEAConfigurationView_check_water_temperature":"Wassertemperatur","NMEAConfigurationView_check_native_gps":"Interne GPS-Position","NMEAConfigurationView_check_native_air_pressure":"Interner Luftdruck","NMEAConfigurationView_check_wind":"Wind (Geschwind. und Richtung)","NMEAConfigurationView_connection_device":"Ger\xe4t","NMEAConfigurationView_connection_host":"Adresse","NMEAConfigurationView_connection_port":"Port","NMEAConfigurationView_connection_type":"NMEA-Verbindungstyp","NMEAConfigurationView_connection_type_bluetooth":"Bluetooth (nicht unterst\xfctzt)","NMEAConfigurationView_connection_type_gps":"Internes GPS","NMEAConfigurationView_connection_type_tcp":"TCP","NMEAConfigurationView_connection_type_udp":"UDP","NMEAConfigurationView_connection_type_usb":"USB","NMEAConfigurationView_connect":"Verbindung testen","NMEAConfigurationView_connecting":"Verbinde...","NMEAConfigurationView_capture":"NMEA-Daten an Support senden","NMEAConfigurationView_capture_sending":"Wird gesendet...","NMEAConfigurationView_capture_success":"Gesendet","NMEAConfigurationView_capture_error":"Senden fehlgeschlagen","NMEAConfigurationView_capture_hint":"Sendet eine kurze Aufzeichnung der Rohdaten deiner Instrumente, damit der Support Verbindungsprobleme analysieren kann.","NMEAConfigurationView_complete":"Abschlie\xdfen","NMEAConfigurationView_error_invalidUrl":"Fehler: Ung\xfcltige URL","NMEAConfigurationView_error_connectionFailed":"Fehler: Verbindung fehlgeschlagen","NMEAConfigurationView_error_disconnected":"Fehler: NMEA ist nicht verbunden","NMEAConfigurationView_error_failedToOpen":"Fehler: Ger\xe4t konnte nicht ge\xf6ffnet werden","NMEAConfigurationView_error_subscriptionExpired":"Fehler: Abonnement abgelaufen","NMEAConfigurationView_error_unsupportedSchema":"Fehler: Nicht unterst\xfctztes Protokoll","NMEAConfigurationView_reconnect":"Neu verbinden","NMEAConfigurationView_reset":"Zur\xfccksetzen","NMEAConfigurationView_step_conditions":"Bedingungen","NMEAConfigurationView_step_connection":"Verbindung","NMEAConfigurationView_step_native":"Interne Sensoren","NMEAConfigurationView_step_test_data":"Test und Daten","NMEAConfigurationView_title":"NMEA-Einstellungen","NMEAConfigurationView_read_more":"Mehr lesen","NMEAConfigurationView_condition_entry":"Bedingungen f\xfcr automatische Logbucheintr\xe4ge","NMEAConfigurationView_condition_interval":"Regelm\xe4\xdfige Eintr\xe4ge alle ","NMEAConfigurationView_condition_interval_3600":"60 min ","NMEAConfigurationView_condition_interval_1800":"30 min ","NMEAConfigurationView_condition_start_stop":"Bedingung f\xfcr Start/Stopp-Eintrag","NMEAConfigurationView_condition_anchor_start_stop":"Anderer Wert f\xfcr Anker oder Boje","NMEAConfigurationView_condition_anchor_no_status_change":"Keine Status\xe4nderung, wenn Geschwindigkeit","NMEAConfigurationView_condition_anchor_depth_alerts":"Anker- & Tiefenalarme","NMEAConfigurationView_condition_anchor_drift_warning":"Ankerdrift-Warnung (sm)","NMEAConfigurationView_condition_anchor_drift_alarm":"Ankerdrift-Alarm (sm)","NMEAConfigurationView_condition_depth_warning":"Tiefenwarnung","NMEAConfigurationView_condition_depth_alarm":"Tiefenalarm","NMEAConfigurationView_condition_stop":"Stopp-Eintrag wenn Geschwindigkeit","NMEAConfigurationView_condition_start":"Start-Eintrag wenn Geschwindigkeit ","NMEAConfigurationView_condition_course":"Eintrag bei Kurs\xe4nderung wenn ","NMEAConfigurationView_condition_course_change":"Kurs\xe4nderung","NMEAConfigurationView_condition_course_speed":"Geschwindigkeit","NMEAConfigurationView_condition_native_gps":"Internes GPS verwenden","NMEAConfigurationView_condition_native_pressure":"Internen Luftdrucksensor verwenden","NMEAConfigurationView_condition_engine_idle_rpm":"Wenn der Motor mit weniger als der Leerlaufdrehzahl (U/min) l\xe4uft: Zeit und Entfernung als \\"unter Segeln\\" auswerten.","NMEAConfigurationView_condition_engine_idle_rpm_value":"Leerlaufdrehzahl (U/min)","NMEAConfigurationView_condition_engine_detection":"Motorerkennung (U/min)","NMEAConfigurationView_condition_engine_start":"Motor l\xe4uft, wenn Drehzahl \xfcber","NMEAConfigurationView_condition_engine_stop":"Motor aus, wenn Drehzahl unter","NMEAConfigurationView_error_engine_rpm_order":"Fehler: Drehzahl \\"Motor aus\\" muss unter \\"Motor l\xe4uft\\" liegen","NMEAConfigurationView_error_engine_idle_rpm":"Fehler: Leerlaufdrehzahl muss \xfcber \\"Motor l\xe4uft\\" liegen","NoteView":"","NoteView_planning":"T\xf6rnplan","NoteView_crew":"Crew","NoteView_day":"Tag","NoteView_file_field_drag_drop":"Dateien an diese Notiz anh\xe4ngen.","NoteView_attachment_remove_confirm":"M\xf6chtest du diesen Anhang wirklich entfernen?","NoteView_attachment_remove_title":"Anhang entfernen","NoteView_attachment_remove_accept":"Entfernen","NoteView_attachment_remove_cancel":"Abbrechen","NoteView_attachment_remove_error":"Anhang konnte nicht entfernt werden. Bitte versuche es erneut.","NoteView_journal":"Journal","NoteView_note_created_by":"Erstellt von {name}","NoteView_note_parent_day":"Tag: {date}","NoteView_note_parent_trip":"Etappe: {name}","NoteView_other":"Andere","NoteView_technical":"Technisch","NoteView_type":"Typ","NoteView_weather":"Wettervorhersage","NoteView_show_notes":"{count} {type}-Notizen anzeigen","NoteView_watch":"Wachplan","NoteView_note_add_new":"Neue Notiz hinzuf\xfcgen","NoteView_note_journal_title":"Journal-Eintragstitel","NoteView_note_journal_note":"Journal-Text","NoteView_note_planning_date":"Datum","NoteView_note_planning_title":"Ort","NoteView_note_planning_note":"Bemerkung","NoteView_note_technical_title":"Technischer Notiztitel","NoteView_note_technical_note":"Technische Notiz","NoteView_note_parent_type_day":"Tag","NoteView_note_parent_type_trip":"Etappe","NoteView_note_weather_title":"Quelle","NoteView_note_weather_date":"Datum und Zeit","NoteView_note_weather_note":"Wettervorhersage","NoteView_note_weather_note_extra":"Wetterbedingungen","PrintHeaderView":"","PrintHeaderView_title":"LOGBOOK {view} \u2013 {ship}","PrintHeaderView_print_1":"T\xf6rn\xfcbersicht","PrintHeaderView_print_2":"Ausgew\xe4hlte Etappen","PrintHeaderView_print_3":"Ausgew\xe4hlte Tage","PrintHeaderView_print_4":"Schiffsdaten","PrintHeaderView_motor":"Motorschiff","PrintHeaderView_sailing":"Segelschiff","PrintSettingsView":"","PrintSettingsView_title":"Druckeinstellungen","PrintSettingsView_button":"Drucken","PrintSettingsView_cancel":"Abbrechen","PrintSettingsView_overview":"\xdcbersicht drucken","PrintSettingsView_overview_all":"Alle T\xf6rns in LOGBOOK drucken","PrintSettingsView_overview_year":"Jahr ausw\xe4hlen","PrintSettingsView_overview_cruises":"\xdcbersicht der T\xf6rns drucken","PrintSettingsView_cruise":"T\xf6rn drucken","PrintSettingsView_cruise_current":"Alle Daten des T\xf6rns gefolgt von einer Liste aller Etappen drucken","PrintSettingsView_cruise_summary":"T\xf6rndaten und Liste der Etappen","PrintSettingsView_cruise_details":"T\xf6rndetails","PrintSettingsView_ship":"Schiffsdaten drucken","PrintSettingsView_ship_short":"Hauptschiffsdaten","PrintSettingsView_ship_details":"Detaillierte Schiffsdaten","PrintSettingsView_user_list":"Alle Personen f\xfcr dieses Schiff drucken","PrintSettingsView_trip":"Etappen","PrintSettingsView_trips":"Etappen drucken","PrintSettingsView_trips_all":"Alle Etappen des T\xf6rns drucken","PrintSettingsView_trips_selected":"Etappe zum Drucken ausw\xe4hlen","PrintSettingsView_timeline":"Timeline","PrintSettingsView_trips_summary":"Alle Daten der Etappen drucken und","PrintSettingsView_trips_summary_details":"eine Liste der Tage mit Details","PrintSettingsView_trips_summary_short":"eine kurze Liste der Tage","PrintSettingsView_trips_details":"Etappen-Details","PrintSettingsView_journal_list":"Alle Journal-Eintr\xe4ge drucken (Etappen und Tage)","PrintSettingsView_technical_list":"Alle technischen Eintr\xe4ge drucken (Etappen und Tage)","PrintSettingsView_days":"Tage drucken","PrintSettingsView_days_select":"Einzelnen Tag ausw\xe4hlen","PrintSettingsView_days_trip_select":"Alle Tage der ausgew\xe4hlten Etappe drucken","PrintSettingsView_days_text":"Daten des Tages drucken: Reiter Tag und Statistik plus die unten gew\xe4hlten Reiter:","PrintSettingsView_thumbnails":" (inkl. Bild-Miniaturansichten)","PrintSettingsView_entries":"Log-Eintr\xe4ge auch an jeden Tag anh\xe4ngen","PrintSettingsView_edits":"Alle \xc4nderungen an Log-Eintr\xe4gen und auf der Karte Tag ausgeben","PrintSettingsView_entries_summary":"Zusammenfassung (Liste der Log-Eintr\xe4ge)","PrintSettingsView_entries_details":"Detaillierte Log-Eintr\xe4ge","PrintSettingsView_entries_day_select":"Tag ausw\xe4hlen","PrintSettingsView_entries_trip_select":"Etappe zum Drucken von Tagen ausw\xe4hlen","PrintSettingsView_evaluations":"Auswertungen drucken","PrintSettingsView_journal":"Journal-Eintr\xe4ge mit Fotos","PrintSettingsView_tacks":"Tracks","PrintSettingsView_technical":"Technische Dokumentation mit Fotos","PrintSettingsView_authorities":"Auswertung f\xfcr Beh\xf6rden","PrintSettingsView_authorities_day":"Manuelle Eintr\xe4ge f\xfcr den Tag","PrintSettingsView_authorities_log":"Log-Eintr\xe4ge","PrintView":"","PrintView_print_action":"Drucken","PrintView_print_cancel":"Abbrechen","PrintView_cruise":"T\xf6rn","PrintView_cruise_statistics":"Statistik des T\xf6rns","PrintView_trip":"Etappe","PrintView_trips":"Etappen","PrintView_trip_list":"Liste der Etappen","PrintView_trip_statistics":"Statistik der Etappe","PrintView_day":"Logbuchdaten f\xfcr","PrintView_day_list":"Liste der Tage in der Etappe","PrintView_day_maindata":"Hauptdaten des Tages","PrintView_day_statistics":"Statistik des Tages","PrintView_date":"Datum","PrintView_from_date":"Von","PrintView_until_date":"bis","PrintView_from_loc":"T\xf6rn von","PrintView_to_loc":"nach","PrintView_time_total":"Zeit","PrintView_distance_total":"Distanz","PrintView_technical_notes":"Technische Notizen","PrintView_watch_groups":"Wachgruppen","PrintView_watch_shifts":"Wachschichten","PrintView_note_technical":"Technische Notiz","PrintView_list_technical":"Liste aller technischen Notizen","PrintView_note_journal":"Journal-Eintrag","PrintView_list_journal":"Liste aller Journal-Eintr\xe4ge","PrintView_note_watch":"Wache","PrintView_note_planning":"T\xf6rnplan","PrintView_note_weather":"Wettervorhersage","PrintView_log_entries":"Log-Eintr\xe4ge","SearchView":"","SearchView_token_ship":"Schiff","SearchView_token_type":"Typ","SearchView_type_cruise":"T\xf6rn","SearchView_type_day":"Tag","SearchView_type_log":"Log","SearchView_type_note":"Notiz","SearchView_type_trip":"Etappe","ShipImportView":"","ShipImportView_cancel":"Abbrechen","ShipImportView_file_field_drag_drop":"W\xe4hle die Exportdatei aus LogbookSuite aus","ShipImportView_open":"Schiff anzeigen","ShipImportView_status_complete":"Abgeschlossen","ShipImportView_status_failed":"Fehlgeschlagen. Bitte versuche es erneut oder kontaktiere den Support.","ShipImportView_status_error":"Fehler: {error}","ShipImportView_status_processing":"In Bearbeitung","ShipImportView_status_pending":"Vorbereitung zum Import","ShipImportView_status_uploading":"Hochladen","ShipImportView_title":"Schiffsdaten importieren","ShipImportView_title_ship":"Etappen in {ship} importieren","ShipSettingsView_settings":"Einstellungen","ShipSettingsView_ship_settings":"Schiffseinstellungen","ShipSettingsView_tab_units":"Einstellungen f\xfcr Einheiten","ShipSettingsView_tab_ship_user":"Alle Personen","ShipSettingsView_tab_lists":"Einstellungen f\xfcr Listen","ShipSettingsView_tab_settings":"Einstellungen","ShipSettingsView_tab_companions":"Companions","ShipSettingsView_more_info":"Mehr erfahren","ShipSettingsView_read_more":"Weiterlesen","ShipSettingsView_add_user":"Person","ShipSettingsView_cancel":"Abbrechen","ShipSettingsView_save":"Hinzuf\xfcgen","ShipSettingsView_timezone":"Zeitzone","ShipSettingsView_timezone_title":"Manuelle Einrichtung der Zeitzone","ShipSettingsView_timezone_manual":"Zeitzone manuell einstellen","ShipSettingsView_current_time":"Aktuelle Zeit","ShipSettingsView_log_offset_title":"Offset f\xfcr Wert aus der Logge","ShipSettingsView_log_offset":"Log-Offset (nm)","ShipSettingsView_rpm_title":"Manuell eingegebene Drehzahl \xfcbernehmen","ShipSettingsView_rpm_keep_manual":"Drehzahl in den n\xe4chsten Logeintrag \xfcbernehmen","ShipSettingsView_lights_title":"Erinnerung an die Sichtzeichen","ShipSettingsView_lights_enable":"An die Sichtzeichen erinnern","ShipSettingsView_lights_sailing":"Lichter unter Segeln","ShipSettingsView_lights_sailing_runningLights":"Getrennte Positionslichter","ShipSettingsView_lights_sailing_triColor":"Dreifarbenlaterne im Masttop","ShipSettingsView_lights_lead":"Tag-/Nachtgrenze","ShipSettingsView_lights_lead_civil":"B\xfcrgerliche D\xe4mmerung (empfohlen)","ShipSettingsView_lights_lead_official":"Sonnenuntergang / Sonnenaufgang","ShipSettingsView_lights_motoring_cone":"An das Setzen des Motorkegels erinnern","ShipSettingsView_edit_permissiveness_title":"Bearbeitungsfreigabe","ShipSettingsView_edit_permissiveness_level":"Bearbeitungsstufe","ShipSettingsView_edit_permissiveness_level_default":"Standard (streng)","ShipSettingsView_edit_permissiveness_level_extended":"Erweitert","ShipSettingsView_edit_permissiveness_level_unrestricted":"Uneingeschr\xe4nkt","ShipSettingsView_socket":"Adresse des Primary LOGBOOK","ShipSettingsView_socket_text":"Verwende diese Adresse f\xfcr die Verbindung eines Companions mit dem Primary LOGBOOK","ShipSettingsView_connected_companions":"Verbundene Companions","ShipSettingsView_companion_host":"Host","ShipSettingsView_companion_user":"Benutzer","ShipSettingsView_companions_loading":"Verbundene Companions werden geladen\u2026","ShipSettingsView_companions_empty":"Derzeit sind keine Companions verbunden.","ShipSettingsView_companions_error":"Verbundene Companions konnten nicht geladen werden. Erneuter Versuch\u2026","ShipSettingsView_disconnect_companion":"Trennen","ShipSettingsView_disconnect_companion_label":"{user} auf {host} trennen","ShipSettingsView_disconnect_companion_title":"Companion trennen?","ShipSettingsView_disconnect_companion_text":"Dieser Companion muss anschlie\xdfend manuell erneut verbunden werden. Die Schiffsberechtigungen des Benutzers und andere Ger\xe4te bleiben unver\xe4ndert.","ShipSettingsView_disconnect_companion_error":"Dieser Companion konnte nicht getrennt werden. Bitte erneut versuchen.","ShipSettingsView_units":"Einstellungen f\xfcr Einheiten","ShipSettingsView_comment_":"*W\xe4hlen/eingeben*","ShipSettingsView_seaState_":"*W\xe4hlen/eingeben*","ShipSettingsView_comment_anchor_down":"Anker f\xe4llt","ShipSettingsView_comment_anchor_up":"Anker auf","ShipSettingsView_comment_engine_started":"Motor gestartet","ShipSettingsView_comment_engine_stopped":"Motor gestoppt","ShipSettingsView_comment_sails_set":"Segel gesetzt","ShipSettingsView_comment_sails_dropped":"Segel geborgen","ShipSettingsView_add_seaState":"Seegang hinzuf\xfcgen","ShipSettingsView_add_comment":"Bemerkung hinzuf\xfcgen","ShipSettingsView_seaState_waves":"Wellen","ShipSettingsView_seaState_swell":"D\xfcnung","ShipSettingsView_seaState_cross_sea":"Kreuzsee","ShipSettingsView_seaState_calm":"Ruhige See","ShipSettingsView_seaState_rough":"Raue See","ShipSettingsView_currency":"W\xe4hrung","ShipSettingsView_distance":"Distanz","ShipSettingsView_length":"L\xe4nge","ShipSettingsView_power":"Leistung","ShipSettingsView_pressure":"Druck","ShipSettingsView_speed":"Geschwindigkeit","ShipSettingsView_surface":"Fl\xe4che","ShipSettingsView_temperature":"Temperatur","ShipSettingsView_volume":"Volumen","ShipSettingsView_weight":"Gewicht","ShipSettingsView_wind":"Wind","ShipSettingsView_current":"Str\xf6mung","ShipSettingsView_unit_currency":"W\xe4hrung","ShipSettingsView_unit_bar":"bar","ShipSettingsView_unit_celsius":"\xb0C","ShipSettingsView_unit_cm":"cm","ShipSettingsView_unit_fahrenheit":"\xb0F","ShipSettingsView_unit_foot":"Fu\xdf","ShipSettingsView_unit_gal":"gal","ShipSettingsView_unit_inch":"Zoll","ShipSettingsView_unit_kg":"kg","ShipSettingsView_unit_km":"km","ShipSettingsView_unit_kmh":"km/h","ShipSettingsView_unit_kn":"kn","ShipSettingsView_unit_kw":"kw","ShipSettingsView_unit_kwh":"kwh","ShipSettingsView_unit_hp":"PS","ShipSettingsView_unit_l":"l","ShipSettingsView_unit_m3":"m\xb3","ShipSettingsView_unit_cuft":"cuft","ShipSettingsView_unit_mps":"m/s","ShipSettingsView_unit_m":"m","ShipSettingsView_unit_m2":"m\xb2","ShipSettingsView_unit_miles":"Meilen","ShipSettingsView_unit_mph":"mph","ShipSettingsView_unit_nm":"sm","ShipSettingsView_unit_lb":"lb","ShipSettingsView_unit_ft":"ft","ShipSettingsView_unit_in":"in","ShipSettingsView_unit_sqft":"sqft","ShipSettingsView_unit_psi":"psi","ShipSettingsView_unit_sqyd":"sqyd","ShipSettingsView_unit_tons":"to","ShipSettingsView_unit_yard":"Yard","ShipSettingsView_unit_hpa":"hPa","ShipSettingsView_unit_undefined":"*W\xe4hlen/eingeben*","ShipSettingsView_other":"Anderes eingeben","ShipSettingsView_unit_eur":"\u20AC","ShipSettingsView_unit_usd":"$","ShipSettingsView_unit_gbp":"\xa3","ShipSettingsView_unit_aud":"AU$","ShipSettingsView_unit_nzd":"NZ$","ShipSettingsView_unit_chf":"CHF","ShipSettingsView_unit_sek":"SEK","ShipSettingsView_unit_nok":"NOK","ShipSettingsView_unit_dkk":"DKK","ShipSettingsView_unit_jpy":"\xa5","ShipSettingsView_user_crew_role":"Crew-Rolle","ShipSettingsView_ship_user_crew_role_crew":"Crew","ShipSettingsView_ship_user_crew_role_none":"Keine","ShipSettingsView_ship_user_crew_role_owner":"Account-Inhaber","ShipSettingsView_ship_user_crew_role_skipper":"Skipper","ShipSettingsView_user_email":"E-Mail","ShipSettingsView_language":"Sprache","ShipSettingsView_lang_en":"Englisch","ShipSettingsView_lang_de":"Deutsch","ShipSettingsView_lang_fr":"Franz\xf6sisch","ShipSettingsView_user_name":"Name","ShipSettingsView_user_shortname":"Kurzname","ShipSettingsView_user_account":"Account","ShipSettingsView_user_active":"Aktivieren","ShipSettingsView_user_inactive":"Deaktivieren","ShipSettingsView_user_invite":"Einladen","ShipSettingsView_user_invite_title":"Schiffs-User zu LOGBOOK einladen","ShipSettingsView_user_reactivate":"Reaktivieren","ShipSettingsView_remove_user":"Entfernen","ShipSettingsView_user_deactivate_confirm_title":"User deaktivieren","ShipSettingsView_user_deactivate_confirm_message":"M\xf6chtest du den Zugriff dieses Users auf das Schiff wirklich deaktivieren? Falls er keinen anderen Schiffszugriff auf diesem Account hat, wird auch sein Account deaktiviert.","ShipSettingsView_user_deactivate_confirm_accept":"Deaktivieren","ShipSettingsView_user_deactivate_confirm_cancel":"Abbrechen","ShipSettingsView_user_remove_confirm_title":"User entfernen","ShipSettingsView_user_remove_confirm_message":"M\xf6chtest du diesen User wirklich vom Schiff entfernen? Dies kann nicht r\xfcckg\xe4ngig gemacht werden.","ShipSettingsView_user_remove_confirm_accept":"Entfernen","ShipSettingsView_user_remove_confirm_cancel":"Abbrechen","ShipSettingsView_ship_user_level":"Berechtigungen","ShipSettingsView_ship_user_level_primary":"Prim\xe4r","ShipSettingsView_ship_user_level_editAll":"Alles ansehen und bearbeiten","ShipSettingsView_ship_user_level_editCurrent":"Aktuellen T\xf6rn ansehen und bearbeiten","ShipSettingsView_ship_user_level_viewAll":"Alles ansehen","ShipSettingsView_ship_user_level_viewCurrent":"Aktuellen T\xf6rn ansehen","ShipSettingsView_ship_user_level_none":"Keine","ShipSettingsView_user_status":"Status","ShipSettingsView_user_status_active":"Aktiv","ShipSettingsView_user_status_invited":"Eingeladen","ShipSettingsView_user_status_undefined":" ","ShipSettingsView_user_add_user":"Person hinzuf\xfcgen","ShipSettingsView_add_user_with_permissions":"Person mit Zugriffsrechten f\xfcr LOGBOOK hinzuf\xfcgen","ShipSettingsView_add_user_without_permissions":"Person ohne Zugriffsrechte hinzuf\xfcgen","ShipSettingsView_users_with_level":"Schiffs-User mit Zugriffsrechten f\xfcr LOGBOOK","ShipSettingsView_users_without_level":"Personen ohne Zugriffsrechte","ShipContentView":"","ShipContentView_back":"Zur\xfcck","ShipDataView":"","ShipDataView_blank":"  ","ShipDataView_":"*Ausw\xe4hlen*","ShipDataView_add":"Hinzuf\xfcgen","ShipDataView_ship_data":"Schiffsdaten","ShipDataView_file_field_drag_drop":"F\xfcge hier Fotos deines Schiffs ein.","ShipDataView_general":"Allgemeine Schiffsdaten","ShipDataView_choose":"*W\xe4hlen/eingeben* ","ShipDataView_other":"Anderes eingeben","ShipDataView_tab_general":"Allgemein","ShipDataView_tab_details":"Details","ShipDataView_tab_technic":"Technik","ShipDataView_tab_sailing":"Segeln","ShipDataView_tab_equipment":"Ausr\xfcstung","ShipDataView_tab_ship_user":"Alle Personen","ShipDataView_tab_units":"Einheiten","ShipDataView_callsign":"Rufzeichen","ShipDataView_imo":"IMO","ShipDataView_mmsi":"MMSI","ShipDataView_name":"Name","ShipDataView_reg_number":"Registrierungsnummer","ShipDataView_hin":"HIN","ShipDataView_flag":"Flagge","ShipDataView_home_port":"Heimathafen","ShipDataView_yacht_club":"Yachtclub","ShipDataView_yacht_club_address":"Adresse","ShipDataView_model_name":"Modellname","ShipDataView_year":"Baujahr","ShipDataView_yachtbuilder":"Werft","ShipDataView_designer":"Designer","ShipDataView_construction":"Gesamtkonstruktion","ShipDataView_build_number":"Baunummer","ShipDataView_cel":"CEL-Kategorie","ShipDataView_cel_persons":"f\xfcr Personen","ShipDataView_ship_foto":"Schiffsfoto","ShipDataView_inside":"Wohnbereich","ShipDataView_berth_no":"Anz. Kojen gesamt","ShipDataView_berth_single_no":"Anz. Einzelkojen","ShipDataView_berth_double_no":"Anz. Doppelkojen","ShipDataView_berth_extra_no":"Anz. Zusatzkojen","ShipDataView_cabins_no":"Anz. Kabinen","ShipDataView_bath_no":"Anz. B\xe4der","ShipDataView_saloon":"Salon","ShipDataView_pantry":"Pantry","ShipDataView_cabins":"Kabinen","ShipDataView_cockpit":"Cockpit","ShipDataView_owner":"Eigner","ShipDataView_owner_name":"Name","ShipDataView_owner_address":"Adresse","ShipDataView_owner_phone":"Telefon","ShipDataView_owner_email":"E-Mail","ShipDataView_shape":"Form","ShipDataView_monohull":"Einrumpf","ShipDataView_catamaran":"Katamaran","ShipDataView_trimaran":"Trimaran","ShipDataView_sailing-sloop":"Segelboot Slup","ShipDataView_sailing-ketch":"Segelboot Ketsch","ShipDataView_sailing-classic":"Segelboot klassisch","ShipDataView_sailing-cat":"Segelboot Katamaran","ShipDataView_sailing-tri":"Segelboot Trimaran","ShipDataView_sailing-longkeeler":"Segelboot Langkieler","ShipDataView_motor-boat":"Motorboot","ShipDataView_motor-cat":"Motor-Katamaran","ShipDataView_motor-tri":"Motor-Trimaran","ShipDataView_motor-yacht":"Motoryacht","ShipDataView_motor-superyacht":"Motor-Superyacht","ShipDataView_special_features":"Besonderheiten","ShipDataView_vessel_type":"Schiffstyp","ShipDataView_dimensions":"Abmessungen","ShipDataView_height":"A: H\xf6he","ShipDataView_draft":"B: Tiefgang","ShipDataView_length_waterline":"C: L\xe4nge Wasserlinie","ShipDataView_length_hull":"D: L\xe4nge Rumpf","ShipDataView_length":"E: L\xe4nge \xfcber alles","ShipDataView_beam":"Breite","ShipDataView_hull_material":"Material des Rumpfs","ShipDataView_hull_color":"Farbe des Rumpfs","ShipDataView_masts_no":"Anz. der Masten","ShipDataView_rig":"Form der Takelage","ShipDataView_sail_area_total":"Segelfl\xe4che","ShipDataView_comment":"Bemerkung","ShipDataView_displacement":"Verdr\xe4ngung","ShipDataView_keel_weight":"Kielgewicht","ShipDataView_keel_material":"Kielmaterial","ShipDataView_ballast_percentage":"Ballastprozentsatz","ShipDataView_keel_shape":"Kielform","ShipDataView_keel_weight_percent":"Kielgewicht %","ShipDataView_mast_rig":"Mast, Rigg und Deckausr\xfcstung","ShipDataView_rig_elements":"Rigg-Elemente","ShipDataView_rig_element":"Rigg-Element","ShipDataView_rig_mast":"Mast","ShipDataView_rig_main_mast":"Gro\xdfmast","ShipDataView_rig_stay":"Toppstag","ShipDataView_rig_mizzen_mast":"Besanmast","ShipDataView_rig_forestay":"Vorstag","ShipDataView_rig_jib_stay":"Kl\xfcverstag","ShipDataView_rig_backstay":"Achterstag","ShipDataView_rig_runner":"Runner","ShipDataView_rig_baby_stay":"Babystag","ShipDataView_rig_kicker":"Kicker","ShipDataView_rig_vang":"Vang","ShipDataView_rig_winch":"Winsch","ShipDataView_rig_":"*W\xe4hlen/eingeben* ","ShipDataView_rig_null":"*W\xe4hlen/eingeben* ","ShipDataView_unit_m":"m","ShipDataView_unit_cm":"cm","ShipDataView_unit_inch":"inch","ShipDataView_unit_foot":"foot","ShipDataView_unit_yard":"yard","ShipDataView_unit_nm":"sm","ShipDataView_unit_m2":"m\xb2","ShipDataView_unit_square_foot":"sqft","ShipDataView_unit_square_yard":"sqyd","ShipDataView_unit_pound":"lb","ShipDataView_unit_kg":"kg","ShipDataView_unit_tons":"t","ShipDataView_unit_knots":"kn","ShipDataView_unit_m_per_second":"m/s","ShipDataView_unit_km_per_hour":"km/h","ShipDataView_unit_kWh":"kWh","ShipDataView_unit_kw":"kW","ShipDataView_unit_hp":"PS","ShipDataView_unit_l":"l","ShipDataView_unit_gal":"gal","ShipDataView_unit_liter":"l","ShipDataView_unit_gallon":"gal","ShipDataView_unit_celsius":"\xb0C","ShipDataView_unit_fahrenheit":"\xb0F","ShipDataView_other_equipment":"Sonstige Ausr\xfcstung","ShipDataView_other_equipment_text":"Gebe hier alle sonstige Ausr\xfcstung des Schiffes ein, die in den anderen Bereichen nicht eingegeben werden konnte, wie z.B. Angaben zum Beiboot etc.","ShipDataView_add_engine":"Motor hinzuf\xfcgen","ShipDataView_add_generator":"Generator hinzuf\xfcgen","ShipDataView_add_sail":"Segel hinzuf\xfcgen","ShipDataView_add_insurance":"Versicherung hinzuf\xfcgen","ShipDataView_add_anchor":"Anker hinzuf\xfcgen","ShipDataView_add_tank":"Tank hinzuf\xfcgen","ShipDataView_add_steeringsystem":"Steuersystem hinzuf\xfcgen","ShipDataView_add_other_equipment":"Sonstige Ausr\xfcstung hinzuf\xfcgen","ShipDataView_add_rig":"Rigg-Ausr\xfcstung hinzuf\xfcgen","ShipDataView_nautical_add_device":"Ger\xe4t hinzuf\xfcgen","ShipDataView_safety_add_device":"Ausr\xfcstung hinzuf\xfcgen","ShipDataView_electric_add_device":"Ger\xe4t hinzuf\xfcgen","ShipDataView_insurance":"Versicherung","ShipDataView_insurances":"Versicherungen","ShipDataView_insurance_":"*W\xe4hlen/eingeben* ","ShipDataView_insurance_null":"*W\xe4hlen/eingeben* ","ShipDataView_insurance_undefined":"*W\xe4hlen/eingeben* ","ShipDataView_insurance_company":"Versicherungsgesellschaft","ShipDataView_insurance_number":"Versicherungsnummer","ShipDataView_insurance_type":"Art der Versicherung","ShipDataView_insurance_hull":"Kasko","ShipDataView_insurance_liability":"Haftpflicht","ShipDataView_insurance_accident":"Unfall","ShipDataView_engines":"Motoren","ShipDataView_engine":"Motor","ShipDataView_engine#":"Nr.","ShipDataView_engine_nmea_number":"NMEA","ShipDataView_engine_short_name":"Name (max. 10 Zeichen)","ShipDataView_engine_":"*W\xe4hlen/eingeben* ","ShipDataView_engine_undefined":"*W\xe4hlen/eingeben* ","ShipDataView_engine_null":"*W\xe4hlen/eingeben* ","ShipDataView_engine_outboard":"Au\xdfenborder","ShipDataView_engine_saildrive":"Saildrive","ShipDataView_engine_shaftdrive":"Wellenantrieb","ShipDataView_engine_z_drive":"Z-Antrieb","ShipDataView_engine_pod_drive":"Pod-Antrieb","ShipDataView_engine_jet_drive":"Jet-Antrieb","ShipDataView_generator_":"*W\xe4hlen/eingeben* ","ShipDataView_generator_undefined":"*W\xe4hlen/eingeben* ","ShipDataView_generator_null":"*W\xe4hlen/eingeben* ","ShipDataView_generator":"Generator","ShipDataView_generators":"Generatoren","ShipDataView_generator_power_generator":"Stromgenerator","ShipDataView_generator_warm_water":"Warmwasser","ShipDataView_generator_watermaker":"Wasserentsalzung","ShipDataView_generator_heating":"Heizung","ShipDataView_generator_air_conditioning":"Klimaanlage","ShipDataView_fuel_":"*W\xe4hlen/eingeben* ","ShipDataView_fuel_null":"*W\xe4hlen/eingeben* ","ShipDataView_fuel_undefined":"*W\xe4hlen/eingeben* ","ShipDataView_fuel_type":"Treibstoff","ShipDataView_fuel_diesel":"Diesel","ShipDataView_fuel_petrol":"Benzin","ShipDataView_fuel_gas":"Gas","ShipDataView_fuel_electricity":"Elektrizit\xe4t","ShipDataView_drive_type_engine_null":"*W\xe4hlen/eingeben* ","ShipDataView_number":"Nummer","ShipDataView_manufacturer":"Hersteller","ShipDataView_model":"Modell","ShipDataView_serial_number":"Seriennummer","ShipDataView_power":"Leistung","ShipDataView_drive_type":"Antriebsart","ShipDataView_propeller_type":"Propellertyp","ShipDataView_steering_null":"*W\xe4hlen/eingeben* ","ShipDataView_steering_systems":"Steuersysteme","ShipDataView_steering_system_main":"Hauptsteuersystem","ShipDataView_steering_":"*W\xe4hlen/eingeben* ","ShipDataView_steering_type":"Steuerungstyp","ShipDataView_rudder_no":"Anzahl Ruder","ShipDataView_rudder_shape":"Form","ShipDataView_rudder_drive":"Ruderantrieb","ShipDataView_steering_bow_thruster":"Bugstrahlruder","ShipDataView_steering_stern_thruster":"Heckstrahlruder","ShipDataView_steering_self_steering":"Windfahnensteuerung","ShipDataView_steering_windvane":"Windfahne","ShipDataView_steering_trimtab":"Trimm-Ruder","ShipDataView_steering_autopilot":"Autopilot","ShipDataView_tanks":"Tanks","ShipDataView_tanks_unit":"Tanks: \u2211 ","ShipDataView_tank":"Tankart","ShipDataView_tank_":"*W\xe4hlen/eingeben* ","ShipDataView_tank_undefined":"*W\xe4hlen/eingeben* ","ShipDataView_tank_null":"*W\xe4hlen/eingeben* ","ShipDataView_tank_fuel":"Treibstoff","ShipDataView_tank_water":"Frischwasser","ShipDataView_tank_gray":"Grauwasser","ShipDataView_tank_waste":"Abwasser","ShipDataView_tank_gas":"Gas","ShipDataView_tank_fuel_daytank":"Treibstoff-Tagestank","ShipDataView_tank_size":"Gr\xf6\xdfe","ShipDataView_tank_comment":"Kommentar","ShipDataView_no":"Anzahl","ShipDataView_tank_fuel_no":"Treibstoff: Anz. | \u2211 Gr\xf6\xdfe","ShipDataView_tank_water_no":"Frischwasser: Anz. | \u2211 Gr\xf6\xdfe","ShipDataView_tank_gray_no":"Grauwasser: Anz. | \u2211 Gr\xf6\xdfe","ShipDataView_tank_waste_no":"Abwasser: Anz. | \u2211 Gr\xf6\xdfe","ShipDataView_tank_gas_no":"Gas: Anz. | \u2211 Gr\xf6\xdfe","ShipDataView_anchors":"Anker","ShipDataView_anchor_type":"Ankertyp","ShipDataView_anchor_":"*W\xe4hlen/eingeben* ","ShipDataView_anchor_null":"*W\xe4hlen/eingeben* ","ShipDataView_anchor_weight":"Gewicht","ShipDataView_anchor_location":"Einbauort","ShipDataView_bow":"Bug","ShipDataView_stern":"Heck","ShipDataView_variable":"variabel","ShipDataView_anchor_chain":"L\xe4nge und Art der Kette","ShipDataView_anchor_chain_lead":"Kettenlauf","ShipDataView_anchor_windlass":"Ankerwinde","ShipDataView_anchor_windless_drive":"Antrieb","ShipDataView_anchor_windless_manfacturer":"Hersteller","ShipDataView_anchor_spade":"Spaten-Anker","ShipDataView_anchor_fishermans":"Stockanker","ShipDataView_anchor_plough":"CQR/Pflugschar-Anker","ShipDataView_anchor_danforth":"Danforth","ShipDataView_anchor_rollerbar":"Rollenbar-Anker","ShipDataView_manual":"manuell","ShipDataView_electric":"elektrisch","ShipDataView_watermaker":"Wasserentsalzung","ShipDataView_batteries":"Batterien","ShipDataView_batterie":"Batterie","ShipDataView_capacity":"Kapazit\xe4t","ShipDataView_electrics":"Elektrik","ShipDataView_date_purchase":"Kaufdatum","ShipDataView_charger":"Ladeger\xe4t","ShipDataView_inverter":"Wechselrichter","ShipDataView_hot_water_boiler":"Warmwasserboiler","ShipDataView_size":"Gr\xf6\xdfe","ShipDataView_size_height":"Gr\xf6\xdfe/H\xf6he","ShipDataView_place_installation":"Einbauort","ShipDataView_date_installation":"Einbaudatum","ShipDataView_devices":"Ger\xe4te","ShipDataView_device":"Ger\xe4t","ShipDataView_sails":"Segel","ShipDataView_sail":"Segel","ShipDataView_sail_":"*W\xe4hlen/eingeben* ","ShipDataView_sail_null":"*W\xe4hlen/eingeben* ","ShipDataView_sail_size":"Gr\xf6\xdfe","ShipDataView_sail_type":"Gesetzt auf","ShipDataView_sail_reefs_no":"Anzahl Reffs","ShipDataView_sail_mast":"Mast","ShipDataView_sail_forestay":"Vorstag","ShipDataView_sail_mizzen":"Besan","ShipDataView_sail_mainsail":"Gro\xdfsegel","ShipDataView_sail_spinnaker":"Spinnaker","ShipDataView_sail_genoa":"Genua","ShipDataView_sail_jib":"Fock","ShipDataView_sail_working_jib":"Arbeitsfock","ShipDataView_sail_strom_jib":"Sturmfock","ShipDataView_sail_mizzen_staysail":"Besanstag","ShipDataView_sail_code0":"Code 0","ShipDataView_sail_gennaker":"Gennaker","ShipDataView_sail_try":"Trysegel","ShipDataView_sail_storm_jib":"Sturmfock","ShipDataView_sail_parasailor":"Parasailor","ShipDataView_sail_0":"Keine","ShipDataView_sail_1":"1","ShipDataView_sail_2":"2","ShipDataView_sail_3":"3","ShipDataView_sail_reef_1":"Reff 1","ShipDataView_sail_reef_2":"Reff 2","ShipDataView_sail_reef_3":"Reff 3","ShipDataView_sail_reef":"{sail} - {reef}","ShipDataView_device_":"*W\xe4hlen/eingeben* ","ShipDataView_device_undefined":"*W\xe4hlen/eingeben* ","ShipDataView_device_nautical_":"*W\xe4hlen/eingeben* ","ShipDataView_device_electric_":"*W\xe4hlen/eingeben* ","ShipDataView_device_safety_":"*W\xe4hlen/eingeben* ","ShipDataView_device_nautical_null":"*W\xe4hlen/eingeben* ","ShipDataView_device_electric_null":"*W\xe4hlen/eingeben* ","ShipDataView_device_safety_null":"*W\xe4hlen/eingeben* ","ShipDataView_nautical_equipment":"Nautische Ausr\xfcstung","ShipDataView_safety_equipment":"Sicherheitsausr\xfcstung","ShipDataView_electric_equipment":"Elektrische Ausr\xfcstung","ShipDataView_device_nautical_analogue_compass":"Analoger Kompass","ShipDataView_device_nautical_gyro_compass":"Kreiselkompass","ShipDataView_device_nautical_fluxgate_compass":"Fluxgate-Kompass","ShipDataView_device_nautical_satellite_compass":"Satelliten-Kompass","ShipDataView_device_nautical_chart_plotter":"Kartenplotter","ShipDataView_device_nautical_gps":"GPS","ShipDataView_device_nautical_ais":"AIS-Transponder","ShipDataView_device_nautical_radio":"Funkger\xe4t","ShipDataView_device_nautical_antenna":"Antenne","ShipDataView_device_nautical_radar":"Radar","ShipDataView_device_nautical_wind_gauge":"Windmesser","ShipDataView_device_nautical_autopilot":"Autopilot","ShipDataView_device_nautical_display_instruments":"Anzeige-Instrumente","ShipDataView_device_nautical_fuel_gauge":"Treibstoffanzeige","ShipDataView_device_nautical_battery_controller":"Batteriekontroller","ShipDataView_device_nautical_hour_meter":"Betriebsstundenz\xe4hler","ShipDataView_device_nautical_tachometer":"Drehzahlmesser","ShipDataView_device_nautical_logger":"Logger","ShipDataView_device_nautical_sounder":"Echolot","ShipDataView_device_nautical_air_temperature":"Lufttemperatur","ShipDataView_device_nautical_barometer":"Barometer","ShipDataView_device_nautical_humidity":"Luftfeuchtigkeit","ShipDataView_device_nautical_weather_receiver":"Wetterempf\xe4nger","ShipDataView_device_nautical_nmea_gateway":"NMEA-Gateway","ShipDataView_device_nautical_nmea_motor_adapter":"NMEA-Motoradapter","ShipDataView_device_electric_battery":"Batterie","ShipDataView_device_electric_inverter":"Wechselrichter","ShipDataView_device_electric_charger":"Ladeger\xe4t","ShipDataView_device_electric_solar_panel":"Solarpanel","ShipDataView_device_electric_wind_generator":"Windgenerator","ShipDataView_device_electric_watermaker":"Wasserentsalzung","ShipDataView_device_safety_fire_extinguisher":"Feuerl\xf6scher","ShipDataView_device_safety_liferaft":"Rettungsinsel","ShipDataView_device_safety_lifejacket":"Rettungsweste","ShipDataView_device_safety_lifebelt":"Rettungsring","ShipDataView_device_safety_lifeline":"Rettungsleine","ShipDataView_device_safety_spare_propeller":"Ersatzpropeller","ShipDataView_device_safety_emergency_tiller":"Notpinne","ShipDataView_device_safety_bilge_pump_manual":"Handbilgepumpe","ShipDataView_device_safety_bilge_pump_electric":"Elektrische Bilgepumpe","ShipDataView_device_safety_shroud_cutter":"Wantenschneider","ShipDataView_device_safety_radar_reflector":"Radarreflektor","ShipDataView_device_safety_first_aid":"Erste Hilfe","ShipDataView_device_safety_fire_blanket":"Feuerl\xf6schdecke","ShipDataView_device_safety_dinghy":"Beiboot ","ShipDataView_device_safety_dinghy_motor":"Motor f\xfcr Beiboot","ShipDataView_device_safety_handheld_radio":"Handfunkger\xe4t","ShipDataView_device_safety_epirb":"Epirb","ShipDataView_all_users":"Alle Personen f\xfcr Crew usw.","ShipEditView":"","ShipEditView_name":"Name des Schiffes","ShipEditView_name_min":"Name des Schiffes (mindestens 3 Zeichen)","ShipEditView_title_edit":"Schiffsdaten f\xfcr {ship}","ShipEditView_title_new":"Neues Schiff erstellen","ShipEditView_type":"Schiffstyp","ShipEditView_type_motor":"Motorschiff","ShipEditView_type_sailing":"Segelschiff","ShipEditView_engines":"Anzahl Motoren","ShipEditView_generators":"Anzahl Generatoren","ShipEditView_create":"Schiff erstellen","ShipEditView_cancel":"Abbrechen","ShipEditView_choose":"Ausw\xe4hlen","ShipEditView_print":"Schiffsdaten drucken","ShipSelectView":"","ShipSelectView_companion":"C","ShipSelectView_view_logbook":"Anzeigen","ShipSelectView_selecting":"Wird ausgew\xe4hlt...","ShipSelectView_options":"Optionen","ShipSelectView_nearby":"Im Netzwerk gefunden","ShipSelectView_nearby_hint":"Dieses Schiff wird in deinem aktuellen Netzwerk angeboten.","ShipSelectView_unavailable_no_permission":"Du hast keine Berechtigung, dieses Schiff als Primary LOGBOOK zu \xf6ffnen.","ShipSelectView_unavailable_import_in_progress":"F\xfcr dieses Schiff l\xe4uft noch ein Import.","ShipSyncStatusView":"","ShipSyncStatusView_close":"Schlie\xdfen","ShipSyncStatusView_retry":"Erneut versuchen","ShipSyncStatusView_title":"Synchronisation mit LOGBOOK Cloud","ShipUserSelect":"","ShipUserSelect_add_user":"Person hinzuf\xfcgen","ShipUserSelect_dialog_add_new_user":"Neue Person hinzuf\xfcgen","ShipUserSelect_dialog_add_user":"Neue Person hinzuf\xfcgen","ShipUserSelect_dialog_add_user_name":"Name","ShipUserSelect_dialog_add_user_shortname":"Kurzname","ShipUserSelect_dialog_cancel":"Abbrechen","ShipUserSelect_loading":"Wird geladen\u2026","ShipUserSelect_no_users":"Keine Personen verf\xfcgbar","ShipUserSelect_select_additional_user":"+","ShipUserSelect_select_user":"Person ausw\xe4hlen","ShipView":"","ShipView_add_cruise":"T\xf6rn","ShipView_add_ship":"Schiff","ShipView_empty_select":"W\xe4hle zuerst ein Schiff aus.","ShipView_import_trips_title":"\xc4ltere Etappen aus LogbookSuite importieren","ShipView_import_trips_choose":"Datei ausw\xe4hlen","ShipView_import_trips_cancel":"Abbrechen","ShipView_menu_action_title":"Neu","ShipView_menu_NMEA":"NMEA","ShipView_menu_now":"Fokus","ShipView_menu_search":"Suchen","ShipView_nmea_recording_disconnected":"NMEA getrennt","ShipView_nmea_recording_error":"NMEA-Aufzeichnungsfehler:","ShipView_nmea_recording_error_disconnected":"NMEA-Aufzeichnungsfehler: NMEA nicht verbunden","ShipView_overlay_dismiss":"OK","ShipView_overlay_missing_cruise":"Aufzeichnung kann nicht ohne aktiven T\xf6rn und aktive Etappe gestartet werden. Erstelle zuerst einen T\xf6rn.","ShipView_overlay_missing_trip":"Aufzeichnung kann nicht ohne aktive Etappe gestartet werden. Erstelle zuerst eine Etappe.","ShipView_ship_data":"Schiffsdaten","ShipView_ship_settings":"Einstellungen","ShipView_sync_initialSyncInProgress":"Initiale Synchronisation l\xe4uft","ShipView_sync_settings":"Einstellungen","ShipView_sync_uninitialized":"Vorbereitung zur Synchronisation","ShipView_resync_cancel":"Abbrechen","ShipView_resync_confirm_cancel":"Zur\xfcck","ShipView_resync_confirm_execute":"Best\xe4tigen","ShipView_resync_title":"Unterbrochene Verbindung wiederherstellen","ShipView_resync_reset_local":"Lokale Daten verwenden","ShipView_resync_reset_cloud":"Cloud-Daten verwenden","ShipView_resync_last_sync":"Dieses Ger\xe4t zuletzt synchronisiert","ShipView_resync_cloud_updated":"LOGBOOK Cloud zuletzt aktualisiert","ShipView_resync_status_failed":"Die LOGBOOK Cloud konnte nicht erreicht werden, daher ist der Verbindungsstatus unbekannt. Pr\xfcfe die Internetverbindung und versuche es erneut.","ShipView_resync_permission_required":"Dein Cloud-Konto hat f\xfcr dieses Schiff keine Primary-Berechtigung mehr. Synchronisierung und Wiederherstellung ben\xf6tigen diese Berechtigung. Bitte den Schiffseigner, sie wiederherzustellen, und versuche dann erneut zu synchronisieren. Lass das Schiff ge\xf6ffnet, um nicht synchronisierte lokale \xc4nderungen zu erhalten; das Schlie\xdfen der Cloud-Verbindung allein stellt die Berechtigung nicht wieder her.","ShipView_resync_claimed_here":"Die LOGBOOK Cloud erkennt dieses Ger\xe4t weiterhin als Primary. Solange diese Verbindung aktiv ist, ist kein Zur\xfccksetzen m\xf6glich. Versuche zuerst erneut zu synchronisieren. Falls ein Zur\xfccksetzen weiterhin n\xf6tig ist, schlie\xdfe das Schiff in der LOGBOOK Cloud, \xf6ffne diesen Dialog erneut und w\xe4hle die Daten, die du behalten m\xf6chtest. Lass das Schiff in dieser App bis zum Abschluss der Wiederherstellung ge\xf6ffnet, um nicht synchronisierte lokale \xc4nderungen zu erhalten.","ShipView_resync_reset_failed":"Die Verbindung konnte nicht wiederhergestellt werden. Bitte versuche es erneut.","ShipView_resync_reset_claimed":"Die Cloud hat die Wiederherstellung abgelehnt. Deine Berechtigung oder die Verbindung des Schiffs hat sich m\xf6glicherweise ge\xe4ndert. Gehe zur\xfcck und pr\xfcfe den aktuellen Status, bevor du es erneut versuchst.","ShipView_read_more":"Weiterlesen","StatsView":"","StatsView_days_run":"Tagesetmal","StatsView_distance_total":"Gesamtdistanz","StatsView_distance_under_engine":"Distanz unter Motor","StatsView_distance_under_engine_name":"{name}","StatsView_distance_under_sails":"Distanz unter Segeln","StatsView_duration_under_engine":"Zeit unter Motor","StatsView_duration_under_engine_name":"{name}","StatsView_duration_under_sails":"Zeit unter Segeln","StatsView_speed":"\xd8-Geschwindigkeit","StatsView_time_total":"Gesamtzeit","StatsView_time_total_paused_cruising":"Zeit: Gesamt | Pausen | Unterwegs","StatsView_update":"Neu berechnen","TrackView":"","TrackView_no_track":"Kein Track verf\xfcgbar","TripEditView":"","TripEditView_cancel":"Abbrechen","TripEditView_current_time":"Aktuelle Zeit","TripEditView_dialog_title":"Etappe erstellen","TripEditView_start":"Etappe starten","TripEditView_timezone":"Zeitzone","TripEditView_title":"Name der Etappe","TripView":"","TripView_tab_crew":"Crew","TripView_tab_stats":"Statistik","TripView_tab_track":"Track","TripView_tab_trip":"Etappe","TripView_tab_weather":"Wetter","TripView_tab_print":"Drucken","TripView_untitled_trip":"Etappe ohne Namen","TripView_print_all":"Alle Etappen dieses T\xf6rns drucken","TripView_print_trip":"Diese Etappe drucken","UserAdviceAlertView":"","UserAdviceAlertView_alert_acknowledged":"Best\xe4tigt","UserAdviceAlertView_alert_alarm":"Alarm","UserAdviceAlertView_alert_anchorDrift":"Ankerdrift","UserAdviceAlertView_alert_anchorDrift_short":"Drift","UserAdviceAlertView_alert_default":"Unbekannt","UserAdviceAlertView_alert_depth":"Tiefe","UserAdviceAlertView_alert_depth_short":"Tiefe","UserAdviceAlertView_alert_ignored":"Ignoriert","UserAdviceAlertView_alert_lostPosition":"Position verloren","UserAdviceAlertView_alert_lostPosition_short":"Position","UserAdviceAlertView_alert_message":"Nachricht","UserAdviceAlertView_alert_message_short":"Nachricht","UserAdviceAlertView_alert_ok":"OK","UserAdviceAlertView_alert_pressure":"Luftdruck","UserAdviceAlertView_alert_pressure_short":"Luftdruck","UserAdviceAlertView_alert_resolved":"Behoben","UserAdviceAlertView_alert_test":"Test","UserAdviceAlertView_alert_test_short":"Test","UserAdviceAlertView_alert_warning":"Warnung","UserAdviceAlertView_alert_wind":"Wind","UserAdviceAlertView_alert_wind_short":"Wind","UserAdviceAlertView_alert_lights":"Sichtzeichen","UserAdviceAlertView_alert_lights_short":"Lichter","UserAdviceAlertView_alert_manOverboard":"Mann \xfcber Bord","UserAdviceAlertView_alert_manOverboard_short":"MOB","UserAdviceAlertView_state_snoozed":"Geschlummert","UserAdviceAlertView_state_acknowledged":"Best\xe4tigt","UserAdviceAlertView_state_audible":"Klingelt","UserAdviceAlertView_close":"Schlie\xdfen","UserAdviceAlertView_record":"Ich habe {lighting} gesetzt","UserAdviceAlertView_cancel":"Abbrechen","UserAdviceAlertView_settings":"Einstellungen","UserAdviceAlertView_submit":"Status setzen: {state}","UserAdviceAlertView_submit_none":"Aktion w\xe4hlen","UserAdviceAlertView_state_snooze":"Geschlummert","UserAdviceAlertView_state_acknowledge":"Best\xe4tigt","UserAdviceAlertView_state_clear":"Gel\xf6scht","UserAdviceAlertView_state_record":"Eingetragen","UserAdviceAlertView_explain_snooze":"Schaltet den Alarm f\xfcr einige Minuten stumm. Er bleibt offen und meldet sich erneut, wenn die Situation anh\xe4lt.","UserAdviceAlertView_explain_acknowledge":"Markiert den Alarm als gesehen und beendet den Ton. Er bleibt offen, bis sich die Situation kl\xe4rt.","UserAdviceAlertView_explain_clear":"Beendet den Alarm. Nur verwenden, wenn die Situation tats\xe4chlich behoben ist.","UserAdviceAlertView_explain_record":"Tr\xe4gt die empfohlenen Sichtzeichen ins Logbuch ein. Die Erinnerung schlie\xdft sich von selbst, sobald die Sichtzeichen passt.","UserAdviceAlertView_clear_denied":"Nur der Skipper oder die wachhabende Crew kann diesen Alarm l\xf6schen.","UserAdviceAlertView_clear_confirm_message":"Beendet den Alarm f\xfcr alle an Bord \u2013 unabh\xe4ngig davon, ob die Situation noch besteht. Erst l\xf6schen, wenn sie tats\xe4chlich behoben ist.","UserAdviceAlertView_clear_confirm":"Alarm l\xf6schen","UserAdviceAlertView_clear_confirm_cancel":"Zur\xfcck","UserAdviceAlertView_escalate":"An Skipper eskalieren","UserAdviceAlertView_state_escalate":"An Skipper eskaliert","UserAdviceAlertView_explain_escalate":"Alarmiert den Skipper sofort, statt auf die automatische Eskalation zu warten. Eine Best\xe4tigung oder ein Schlummern wird dabei aufgehoben, damit der Alarm ihn erreicht.","UserAdviceAlertView_skip":"\xdcberspringen","UserAdviceAlertView_acknowledge":"Best\xe4tigen","UserAdviceAlertView_clear":"L\xf6schen","UserAdviceAlertView_snooze":"Schlummern","UserAdviceAlertView_title":"Alarm {name} - {level}","UserAdviceAlertView_error":"Die Aktion konnte nicht ausgef\xfchrt werden. Bitte versuche es erneut.","UserAdviceAlertView_read_more":"Mehr anzeigen","UserAdviceAnchorMonitorView":"","UserAdviceAnchorMonitorView_cancel":"Abbrechen","UserAdviceAnchorMonitorView_disable":"Deaktivieren","UserAdviceAnchorMonitorView_enable":"Alarm aktivieren","UserAdviceAnchorMonitorView_title_inactive":"Ankeralarm aus","UserAdviceAnchorMonitorView_title_active":"Ankeralarm an","UserAdviceAnchorMonitorView_title_short":"Ankeralarm","UserAdviceAnchorMonitorView_method":"Methode","UserAdviceAnchorMonitorView_method_fixedRadius":"Fester Radius","UserAdviceAnchorMonitorView_method_rodeScope":"Kette / Scope","UserAdviceAnchorMonitorView_method_sector":"Schwojsektor","UserAdviceAnchorMonitorView_warning":"Warnung","UserAdviceAnchorMonitorView_alarm":"Alarm","UserAdviceAnchorMonitorView_rode":"Kette","UserAdviceAnchorMonitorView_depth":"Tiefe","UserAdviceAnchorMonitorView_boatLength":"Schiffsl\xe4nge","UserAdviceAnchorMonitorView_bearingFrom":"Von Peilung","UserAdviceAnchorMonitorView_bearingTo":"Bis Peilung","UserAdviceAnchorMonitorView_recenter":"Neu zentrieren","UserAdviceAnchorMonitorView_save":"Speichern","UserAdviceAnchorMonitorView_snooze":"Schlummern","UserAdviceAnchorMonitorView_acknowledge":"Best\xe4tigen","UserAdviceAnchorMonitorView_clear":"L\xf6schen","UserAdviceAnchorMonitorView_keepAlive":"Im Hintergrund warnen","UserAdviceAnchorMonitorView_depthWarning":"Tiefenwarnung","UserAdviceAnchorMonitorView_depthAlarm":"Tiefenalarm","UserAdviceAnchorMonitorView_error":"Der Ankeralarm konnte nicht aktualisiert werden. Bitte versuche es erneut.","UserAdviceAnchorMonitorView_error_noPosition":"Der Ankeralarm braucht die aktuelle Position als Mittelpunkt, und im Moment liegt keine Position vor. Verbinde eine NMEA-GPS-Quelle (oder aktiviere das Ger\xe4te-GPS) und versuche es erneut.","UserAdviceAnchorMonitorView_error_gpsPrecision":"Die aktuelle Position ist f\xfcr den Ankeralarm nicht genau genug. Er braucht eine hochgenaue GPS-Quelle; das Ger\xe4te-GPS allein ist zu ungenau, um den Schwojkreis zu messen.","UserAdviceAnchorMonitorView_error_noDay":"Der Ankeralarm kann erst gestartet werden, wenn der Tag begonnen hat und eine erste Position aufgezeichnet wurde. Deine Einstellungen wurden gespeichert; starte den Ankeralarm erneut, sobald das Logbuch aufzeichnet.","UserAdviceAnchorMonitorView_read_more":"Mehr anzeigen","UserAdviceEngineMissingView":"","UserAdviceEngineMissingView_title_short":"Motor?","UserAdviceEngineMissingView_title_castOff":"Motoreintrag fehlt?","UserAdviceEngineMissingView_title_anchorUp":"Motoreintrag fehlt?","UserAdviceEngineMissingView_title_motorVessel":"Motoreintrag fehlt?","UserAdviceEngineMissingView_text_castOff":"Beim Ablegen wurde kein Motor erfasst. Lief der Motor?","UserAdviceEngineMissingView_text_anchorUp":"Beim Ankerauf wurde kein Motor erfasst. Lief der Motor?","UserAdviceEngineMissingView_text_motorVessel":"Das Schiff ist in Fahrt, ohne dass ein Motor erfasst wurde. Lief der Motor?","UserAdviceEngineMissingView_all_engines":"Alle Motoren","UserAdviceEngineMissingView_since_trigger":"Seit {time}","UserAdviceEngineMissingView_since_now":"Ab jetzt","UserAdviceEngineMissingView_started":"Motor lief","UserAdviceEngineMissingView_sailing":"Nein, wir segeln","UserAdviceEngineMissingView_sailing_noSails":"Kein Motor in Betrieb","UserAdviceEngineMissingView_cancel":"Abbrechen","UserAdviceDepthWatchView":"","UserAdviceDepthWatchView_cancel":"Abbrechen","UserAdviceDepthWatchView_disable":"Deaktivieren","UserAdviceDepthWatchView_enable":"Alarm aktivieren","UserAdviceDepthWatchView_title_inactive":"Tiefenalarm aus","UserAdviceDepthWatchView_title_active":"Tiefenalarm an","UserAdviceDepthWatchView_title_short":"Tiefenalarm","UserAdviceDepthWatchView_snooze":"Schlummern","UserAdviceDepthWatchView_acknowledge":"Best\xe4tigen","UserAdviceDepthWatchView_clear":"L\xf6schen","UserAdviceDepthWatchView_text":"Aktualisiere die Tiefenalarm-Schwellenwerte des Schiffs, die f\xfcr jede Tiefen\xfcberwachung gelten.","UserAdviceDepthWatchView_save":"Speichern","UserAdviceDepthWatchView_save_error":"Die Tiefenalarm-Einstellungen konnten nicht gespeichert werden. Bitte versuche es erneut.","UserAdviceDepthWatchView_error":"Der Tiefenalarm konnte nicht aktualisiert werden. Bitte versuche es erneut.","UserAdviceLightsReminderView":"","UserAdviceLightsReminderView_title":"Sichtzeichen","UserAdviceLightsReminderView_title_active":"Sichtzeichen-Erinnerung an","UserAdviceLightsReminderView_title_inactive":"Sichtzeichen-Erinnerung aus","UserAdviceManualShipStatusView":"","UserAdviceManualShipStatusView_title_active":"Manueller Status bis {time}","UserAdviceManualShipStatusView_title_short":"Manueller Status","UserAdviceManualShipStatusView_text":"Die automatischen Statuswechsel sind abgeschaltet. Setze den Schiffsstatus selbst im Log-Men\xfc \u2014 solange der manuelle Statusmodus aktiv ist, wird kein automatischer Log-Eintrag erzeugt.","UserAdviceManualShipStatusView_remaining":"Endet um {time}, in etwa {minutes} Minuten \u2014 oder beim Tageswechsel, je nachdem was zuerst eintritt.","UserAdviceManualShipStatusView_extend":"Verl\xe4ngern","UserAdviceManualShipStatusView_cancel":"Jetzt beenden","UserAdviceManualShipStatusView_close":"Schlie\xdfen","UserAdviceManualShipStatusView_error":"Der manuelle Statusmodus konnte nicht aktualisiert werden. Bitte versuche es erneut.","UserAdviceStopView":"","UserAdviceStopView_cancel":"Abbrechen","UserAdviceStopView_text":"Dokumentiere den Stopp. Tagesende pausiert die automatische Aufzeichnung, bis sich das Schiff wieder bewegt; beim Zwischenstopp bleibt sie aktiv.","UserAdviceStopView_text_fixed_status":"Erg\xe4nze Tagesende oder Zwischenstopp, ohne den aktuellen Schiffsstatus zu \xe4ndern. Tagesende pausiert die automatische Aufzeichnung, bis sich das Schiff wieder bewegt; beim Zwischenstopp bleibt sie aktiv.","UserAdviceStopView_end_location":"Ort","UserAdviceStopView_end_of_day":"Tagesende","UserAdviceStopView_manual_engine_entries":"Auch Motor(en) ausgeschaltet?","UserAdviceStopView_manual_engine_entries_text":"Mit dem Aktivieren dieser Option wird gleichzeitig auch ein Endeintrag f\xfcr den Motorbetrieb erstellt","UserAdviceStopView_final_entry":"Endeintrag erstellen","UserAdviceStopView_save":"Speichern","UserAdviceStopView_status_anchor":"Ankerplatz","UserAdviceStopView_status_buoy":"Boje","UserAdviceStopView_status_port":"Hafen","UserAdviceStopView_status_drifting":"Driften","UserAdviceStopView_stopover":"Zwischenstopp","UserAdviceStopView_status_lock":"Schleuse","UserAdviceStopView_status_bunkering":"Tankstelle","UserAdviceStopView_status_bridge":"Br\xfccke","UserAdviceStopView_status_waiting":"Warten","UserAdviceStopView_stop_engines":"Eintrag f\xfcr Motor(en) ausgeschaltet erstellen","UserAdviceStopView_stop_type":"Stopptyp","UserAdviceStopView_title":"Gestoppt","UserAdviceStopView_title_duration":"Gestoppt seit {duration}","UserAdviceStopView_title_short":"Gestoppt","UserAdviceRow_collapse":"Weniger anzeigen","UserAdviceRow_expand":"Alle Hinweise anzeigen","UserSettingsView":"","UserSettingsView_lang_en":"Englisch","UserSettingsView_lang_de":"Deutsch","UserSettingsView_lang_fr":"Franz\xf6sisch","UserSettingsView_theme_dark":"Dunkel","UserSettingsView_theme_light":"Classic","UserSettingsView_theme_night":"Nacht","UserSettingsView_theme_cloud":"Cloud","UserSettingsView_language":"Sprache","UserSettingsView_theme":"Farbschema","UserSwitchView":"","UserSwitchView_title":"User wechseln","UserSwitchView_empty":"F\xfcr heute sind keine weiteren Crewmitglieder eingetragen.","Mailer_trial_started_subject":"Dein LOGBOOK Trial wurde gestartet","Mailer_trial_2daysleft_subject":"Deine LOGBOOK Trial-Phase endet bald","Mailer_trial_expired_subject":"Deine LOGBOOK Trial-Phase ist beendet","Mailer_subscription_expired_subject":"Dein LOGBOOK Abo ist abgelaufen","LogButton":"","LogButton_status":"Status","LogButton_engines":"Motoren","LogButton_generators":"Generatoren","LogButton_lighting":"Sichtzeichen","LogButton_lighting_none":"Keine Sichtzeichen","LogButton_lighting_triColorLights":"Dreifarbenlaterne","LogButton_lighting_anchorBall":"Ankerball","LogButton_lighting_anchorLight":"Ankerlicht","LogButton_lighting_sailingRunningLights":"Lichter unter Segeln","LogButton_lighting_motoringRunningLights":"Lichter unter Maschine","LogButton_lighting_navigationLights":"Navigationslichter","LogButton_lighting_motoringCone":"Motorkegel","LogButton_sails":"Segel","LogButton_sails_confirm":"Segel speichern","LogButton_sail_group_main":"Gro\xdf","LogButton_sail_group_foresail":"Vorsegel","LogButton_sail_group_spinnaker":"Spinnaker","LogButton_sail_group_mizzen":"Besan","LogButton_send_alert":"Alarm senden","LogButton_man_overboard":"Mann \xfcber Bord","LogButton_man_overboard_confirm_title":"Mann \xfcber Bord","LogButton_man_overboard_confirm_message":"Dies alarmiert sofort die gesamte Crew, dass eine Person \xfcber Bord gegangen ist. Bitte nur best\xe4tigen, wenn dies real ist.","LogButton_man_overboard_confirm":"Alarm ausl\xf6sen","LogButton_man_overboard_cancel":"Abbrechen","LogButton_man_overboard_error":"Der Mann-\xfcber-Bord-Alarm konnte nicht ausgel\xf6st werden.","LogButton_manual_status":"Manueller Status","LogButton_manual_status_active":"Manueller Status an \u2014 ausschalten","SendAlertDialog":"","SendAlertDialog_title":"Alarm senden","SendAlertDialog_users":"Crew-Mitglieder","SendAlertDialog_add_user":"Crew-Mitglied hinzuf\xfcgen","SendAlertDialog_groups":"Wachgruppen","SendAlertDialog_add_group":"Wachgruppe hinzuf\xfcgen","SendAlertDialog_message":"Nachricht","SendAlertDialog_severity":"Schweregrad","SendAlertDialog_severity_warning":"Warnung","SendAlertDialog_severity_alarm":"Alarm","SendAlertDialog_loudness":"Lautst\xe4rke","SendAlertDialog_loudness_audible":"Akustischer Alarm","SendAlertDialog_loudness_notificationOnly":"Nur Benachrichtigung","SendAlertDialog_error":"Der Alarm konnte nicht gesendet werden. Bitte versuche es erneut.","SendAlertDialog_cancel":"Abbrechen","SendAlertDialog_send":"Senden","CatalogUserAdviceButton":"","CatalogUserAdviceButton_notice":"Ankerwache aktiv","CatalogUserAdviceButton_warning":"Wind nimmt zu","CatalogUserAdviceButton_alarm":"Mann \xfcber Bord!","CatalogUserAdviceButton_short":"MOB","CatalogUserAdviceButton_record":"Ankerlicht eintragen","CatalogUserAdviceButton_primary-action":"Sichtzeichen","CatalogUserAdviceButton_primary-action-denied":"Sichtzeichen","CatalogUserAdviceRow":"","CatalogUserAdviceRow_manOverboard":"Mann \xfcber Bord","CatalogUserAdviceRow_manOverboard_short":"MOB","CatalogUserAdviceRow_anchorDrift":"Ankerdrift","CatalogUserAdviceRow_anchorDrift_short":"Drift","CatalogUserAdviceRow_depth":"Tiefenalarm an","CatalogUserAdviceRow_depth_short":"Tiefenalarm","CatalogUserAdviceRow_lostPosition":"Position verloren","CatalogUserAdviceRow_lostPosition_short":"Position","CatalogUserAdviceRow_wind":"Windwarnung","CatalogUserAdviceRow_wind_short":"Wind","CatalogUserAdviceRow_stop":"Gestoppt seit 0:12:04","CatalogUserAdviceRow_stop_short":"Gestoppt","":""}');


var $d10198c4b537855c$exports = {};
$d10198c4b537855c$exports = JSON.parse('{"LogbookApp_version_major":"1.1","RecordingClockWarning_title":"Avertissement sur l\u2019heure d\u2019enregistrement","RecordingClockWarning_acknowledge":"Compris","RecordingClockWarning_system":"L\u2019horloge de l\u2019ordinateur n\u2019est pas fiable. L\u2019enregistrement continue avec l\u2019heure GPS.","RecordingClockWarning_gps":"L\u2019horloge GPS n\u2019est pas fiable. L\u2019enregistrement continue avec l\u2019heure de l\u2019ordinateur.","RecordingClockWarning_paused":"Aucune source horaire fiable n\u2019est disponible. L\u2019enregistrement automatique et les nouvelles entr\xe9es \xe0 l\u2019heure actuelle sont suspendus jusqu\u2019au r\xe9tablissement du GPS ou de l\u2019horloge de l\u2019ordinateur. Les anciennes entr\xe9es restent modifiables.","Layout":"","Layout_documentation":"DOCUMENTATION","Layout_support":"Assistance","OpenServerDialog_title":"Ouvrir LOGBOOK Cloud","OpenServerDialog_opening":"Ouverture de LOGBOOK Cloud...","OpenServerDialog_failed":"Impossible d\'ouvrir LOGBOOK Cloud. V\xe9rifiez votre connexion et autorisez les fen\xeatres contextuelles, puis r\xe9essayez.","OpenServerDialog_close":"Fermer","OpenServerDialog_retry":"R\xe9essayer","AboutView":"","AboutView_title":"\xc0 propos de LOGBOOK","AboutView_version":"Version","AboutView_website":"Site Web","AboutView_support":"Assistance","AboutView_copyright":"Copyright \xa9 2026 par Trimutic UG","AboutView_uploadAppData":"T\xe9l\xe9verser les donn\xe9es de l\'application au support","AboutView_uploadAppDataUploading":"T\xe9l\xe9versement en cours\u2026","AboutView_uploadAppDataSuccess":"Donn\xe9es de l\'application t\xe9l\xe9vers\xe9es","AboutView_uploadAppDataError":"\xc9chec du t\xe9l\xe9versement des donn\xe9es de l\'application","AccountView":"","AccountView_cancel":"Annuler","AccountView_cancel_plan":"Annuler l\'abonnement","AccountView_currency":"Devise","AccountView_currency_EUR":"Euro (\u20AC)","AccountView_currency_USD":"Dollar US ($)","AccountView_duration":"Dur\xe9e","AccountView_duration_5":"5 jours","AccountView_duration_30":"facturation\xa0mensuelle, r\xe9siliable\xa0mensuellement","AccountView_duration_120":"4 mois","AccountView_duration_365":"facturation\xa0annuelle, r\xe9siliable\xa0annuellement","AccountView_duration_30_iap":"facturation\xa0mensuelle, renouvellement automatique sauf\xa0annulation","AccountView_feature_active_ships":"Navires actifs : {amount}","AccountView_feature_active_users":"Utilisateurs actifs : {amount}","AccountView_feature_active_tenders":"Annexes actives : {amount}","AccountView_feature_support_1":"Assistance Standard","AccountView_feature_support_10":"Assistance Pro","AccountView_feature_support_100":"Assistance Master","AccountView_feature_unlimited":"Illimit\xe9","AccountView_pay":"Confirmer le paiement r\xe9current de {price}","AccountView_pay_cancel":"Annuler","AccountView_pay_processing":"Traitement du paiement\u2026","AccountView_payment_information":"Informations de paiement","AccountView_payment_title":"Abonnement {plan} pour {price}","AccountView_plans":"Nos abonnements","AccountView_plans_iPad":"Votre abonnement LOGBOOK","AccountView_plan_captain":"LOGBOOK Captain","AccountView_plan_master_captain":"LOGBOOK Master Captain","AccountView_plan_skipper":"LOGBOOK Skipper","AccountView_plan_trial":"LOGBOOK Trial","AccountView_price_duration_5":"5 jours","AccountView_price_duration_30":"mois","AccountView_price_duration_365":"ann\xe9e","AccountView_price_free":"Gratuit","AccountView_price_EUR":"{price} \u20AC par {duration}","AccountView_price_USD":"{price} $ par {duration}","AccountView_price_native":"{price} par {duration}","AccountView_price_or_monthly":" ou ","AccountView_select_plan":"S\xe9lectionner un forfait","AccountView_subscribe":"S\'abonner","AccountView_subscribe_api":"S\'abonner","AccountView_time_left":"{days} jours restants","AccountView_renews_in":"Renouvellement dans {days} jours","AccountView_cancelled_ends":"Annul\xe9 \u2014 acc\xe8s jusqu\'\xe0 la fin dans {days} jours","AccountView_apple_cancel_info_title":"G\xe9rer votre abonnement","AccountView_apple_cancel_info_message":"Cet abonnement a \xe9t\xe9 souscrit via l\'App Store et doit donc y \xeatre g\xe9r\xe9. Sur votre iPhone ou iPad, ouvrez R\xe9glages, touchez votre nom, puis Abonnements, s\xe9lectionnez LOGBOOK et annulez-le \xe0 cet endroit. Votre acc\xe8s reste actif jusqu\'\xe0 la fin de la p\xe9riode de facturation en cours.","AccountView_taxes":"Taxes incluses","AccountView_terms_of_use":"Conditions d\'utilisation","AccountView_privacy_policy":"Politique de confidentialit\xe9","AccountView_restore_purchases":"Restaurer les achats","AccountView_restore_purchases_running":"Restauration\u2026","AccountView_restore_nothing_title":"Aucun achat trouv\xe9","AccountView_restore_nothing_message":"Aucun abonnement actif \xe0 restaurer sur cet identifiant Apple.","AccountView_restore_claim_title":"D\xe9placer l\'abonnement","AccountView_restore_claim_message":"L\'abonnement de cet identifiant Apple est actuellement li\xe9 \xe0 \xab\xa0{account}\xa0\xbb. Le d\xe9placer vers \xab\xa0{current}\xa0\xbb\xa0? \xab\xa0{account}\xa0\xbb perdra l\'acc\xe8s.","AccountView_restore_claim_confirm":"D\xe9placer ici","AccountView_restore_claim_cancel":"Le laisser l\xe0","AccountView_linked_to_other_account":"L\'abonnement de cet identifiant Apple est li\xe9 au compte LOGBOOK \xab\xa0{account}\xa0\xbb.","AccountView_linked_to_other_account_hint":"Utilisez \xab\xa0Restaurer les achats\xa0\xbb pour le d\xe9placer vers ce compte, ou payez par carte sur le web.","AccountView_title":"Param\xe8tres du compte","AccountView_total":"Total d\xfb","AccountSettingsView_alert_no_internet_title":"Aucune connexion Internet disponible","AccountSettingsView_alert_no_internet_text":"Une connexion Internet est requise pour modifier les param\xe8tres du compte.","AccountSettingsView_error_passwordInvalid":"Le mot de passe saisi ne correspond pas au mot de passe actuel.","AccountSettingsView_error_passwordConfirmationMismatch":"La confirmation du mot de passe ne correspond pas au mot de passe.","AccountSettingsView_error_Not Found":"Non trouv\xe9","AccountSettingsView_error_accountUserSelfAction":"Vous ne pouvez pas modifier, d\xe9sactiver ou supprimer votre propre acc\xe8s.","AccountSettingsView_error_accountUserLastAdmin":"Le compte doit conserver au moins un administrateur actif.","AccountSettingsView_error_account_user_action_failed":"Une erreur s\'est produite. Veuillez r\xe9essayer.","AccountSettingsView_error_account_update_failed":"Une erreur s\'est produite. Veuillez r\xe9essayer.","AccountSettingsView_change_password":"Modifier le mot de passe","AccountSettingsView_confirm_new_password":"Confirmation du nouveau mot de passe","AccountSettingsView_current_password":"Mot de passe actuel","AccountSettingsView_new_password":"Nouveau mot de passe","AccountSettingsView_import_ship":"Importer depuis LogbookSuite","AccountSettingsView_import_trips":"Importer les trajets pour \\"{name}\\" depuis LogbookSuite","AccountSettingsView_new_ship":"Commencer avec un nouveau navire","AccountSettingsView_select_ship":"S\xe9lectionner parmi vos navires","AccountSettingsView_select_shared_ship":"S\xe9lectionner parmi les navires partag\xe9s","AccountSettingsView_deselect_ship":"Fermer le navire","AccountSettingsView_add_new_ship":"Ajouter un nouveau navire","AccountSettingsView_users_list":"Liste de tous les utilisateurs de votre compte","AccountSettingsView_tab_ships":"Vos navires","AccountSettingsView_tab_subscription":"Votre abonnement","AccountSettingsView_tab_users":"Vos utilisateurs","AccountSettingsView_ship_open_here_notice":"Fermez le LOGBOOK d\xe9j\xe0 ouvert sur cet appareil pour s\xe9lectionner un autre navire.","AccountSettingsView_companion_reconnect_notice":"La connexion au LOGBOOK Primary a \xe9t\xe9 perdue \u2014 son adresse sur ce r\xe9seau a peut-\xeatre chang\xe9. Reconnectez-vous pour continuer.","AccountSettingsView_ship_close_companion":"D\xe9connecter LOGBOOK Companion","AccountSettingsView_ship_close_confirm":"Fermer LOGBOOK","AccountSettingsView_ship_logbook":"Afficher le LOGBOOK pour \\"{name}\\"","AccountSettingsView_account_data":"Donn\xe9es de votre compte","AccountSettingsView_account_edit_cancel":"Annuler","AccountSettingsView_account_edit_save":"Enregistrer","AccountSettingsView_account_login":"Identifiant (e-mail)","AccountSettingsView_account_name":"Nom du compte","AccountSettingsView_account_settings":"Param\xe8tres du compte","AccountSettingsView_account_user_level":"Autorisations","AccountSettingsView_account_user_level_admin":"Admin","AccountSettingsView_account_user_level_user":"Utilisateur","AccountSettingsView_account_user_level_disabled":"D\xe9sactiv\xe9","AccountSettingsView_deactivate_user":"D\xe9sactiver","AccountSettingsView_reactivate_user":"R\xe9activer","AccountSettingsView_remove_user":"Supprimer","AccountSettingsView_user_deactivate_confirm_title":"D\xe9sactiver l\'utilisateur","AccountSettingsView_user_deactivate_confirm_message":"Cet utilisateur a encore acc\xe8s \xe0 un navire de ce compte. Voulez-vous vraiment d\xe9sactiver son compte ?","AccountSettingsView_user_deactivate_confirm_accept":"D\xe9sactiver","AccountSettingsView_user_deactivate_confirm_cancel":"Annuler","AccountSettingsView_user_remove_confirm_title":"Supprimer l\'utilisateur","AccountSettingsView_user_remove_confirm_message":"Cet utilisateur a encore acc\xe8s \xe0 un navire de ce compte. Voulez-vous vraiment le supprimer du compte ? Cette action est irr\xe9versible.","AccountSettingsView_user_remove_confirm_accept":"Supprimer","AccountSettingsView_user_remove_confirm_cancel":"Annuler","AccountSettingsView_change_plan":"Modifier votre forfait","AccountSettingsView_customer_name":"Nom","AccountSettingsView_edit_account":"Modifier le compte","AccountSettingsView_remove_account":"Supprimer le compte","AccountSettingsView_plan":"Votre forfait actuel","AccountSettingsView_plans":"Forfaits LOGBOOK","AccountSettingsView_subscription":"Votre abonnement","AccountSettingsView_user_account":"Compte","AccountSettingsView_user_name":"Nom","AccountSettingsView_user_email":"E-mail","AccountSettingsView_user_shortname":"Nom court","AccountSettingsView_user_status":"Statut","AccountSettingsView_user_status_active":"Actif","AccountSettingsView_user_status_invited":"Invit\xe9","AccountSettingsView_user_permissions":"Autorisations","AccountSettingsView_current_ship":"Votre navire actuel est {name}","AccountSettingsView_no_current_ship":"Aucun navire s\xe9lectionn\xe9","AccountSettingsView_valid_until":"Valide jusqu\'au","AccountSettingsView_trial_days_remaining":"Jours d\'essai restants","AccountSettingsView_trial_days_value":"{days} jours","AccountSettingsView_user_crew_role":"R\xf4le d\'\xe9quipage","AccountSettingsView_ship_user_crew_role_crew":"\xc9quipage","AccountSettingsView_ship_user_crew_role_none":"Aucun","AccountSettingsView_ship_user_crew_role_owner":"Titulaire du compte","AccountSettingsView_ship_user_crew_role_skipper":"Capitaine","AccountSettingsView_ship_user_level":"Autorisations","AccountSettingsView_ship_user_level_primary":"Primary","AccountSettingsView_ship_user_level_editAll":"Voir et modifier tout","AccountSettingsView_ship_user_level_editCurrent":"Voir et modifier le voyage actuel","AccountSettingsView_ship_user_level_viewAll":"Voir tout","AccountSettingsView_ship_user_level_viewCurrent":"Voir le voyage actuel","AccountSettingsView_ship_user_level_none":"Aucun","AppDisconnectedView":"","AppDisconnectedView_connection_overlay_reload":"Recharger","AppDisconnectedView_connection_overlay_reloading":"Rechargement \u2026","AppDisconnectedView_connection_overlay_title":"Connexion interrompue","AppDisconnectedView_disconnect_companion":"D\xe9connecter LOGBOOK Companion","AppHeaderView":"","AppOverlayContentView":"","AppOverlayContentView_cancel":"Annuler","AppOverlayContentView_connect_logbook":"Connecter avec le LOGBOOK Primary","AppOverlayContentView_connect_logbook_title":"Connecter avec le LOGBOOK Primary pour \\"{name}\\"","AppOverlayContentView_connect_logbook_failed":"\xc9chec de la connexion avec le LOGBOOK Primary","AppOverlayContentView_connect_logbook_connecting":"Connexion au LOGBOOK Primary de \\"{name}\\"\u2026","AppOverlayContentView_connect_logbook_connecting_short":"Connexion\u2026","AppOverlayContentView_connect_logbook_timeout":"Impossible de joindre \\"{name}\\" automatiquement \u2014 saisissez son adresse","AppOverlayContentView_connect_logbook_not_discovered":"\xab {name} \xbb n\u2019est pas visible sur ce r\xe9seau. V\xe9rifiez que les deux appareils utilisent le m\xeame Wi-Fi, ou saisissez son adresse ci-dessous.","AppOverlayContentView_connect_logbook_ambiguous":"Plusieurs appareils proposent \xab {name} \xbb. Saisissez l\u2019adresse de celui auquel vous souhaitez vous connecter.","AppOverlayContentView_connect_logbook_unresolved":"\xab {name} \xbb a \xe9t\xe9 trouv\xe9, mais son adresse n\u2019a pas pu \xeatre d\xe9termin\xe9e. Saisissez-la ci-dessous.","AppOverlayContentView_connect_logbook_unreachable":"Aucune r\xe9ponse de \xab {name} \xbb \xe0 l\u2019adresse {address}. V\xe9rifiez l\u2019adresse et que les deux appareils sont sur le m\xeame r\xe9seau.","AppOverlayContentView_connect_logbook_refused":"\xab {name} \xbb a refus\xe9 la connexion. Assurez-vous que l\u2019utilisateur de cet appareil a acc\xe8s \xe0 ce journal de bord.","AppOverlayContentView_connect_logbook_not_claimed":"\xab\xa0{name}\xa0\xbb n\u2019est pas ouvert sur le LOGBOOK Primary actuellement. Ouvrez-le l\xe0-bas, puis r\xe9essayez.","AppOverlayContentView_connect_logbook_not_accessible":"Vous n\u2019avez pas acc\xe8s \xe0 \xab {name} \xbb.","AppOverlayContentView_connect_logbook_address_invalid":"Saisissez l\u2019adresse sous la forme h\xf4te:port, par exemple 192.168.1.20:18092.","AppOverlayContentView_connect_logbook_own_device":"\xab {name} \xbb est le journal de bord de cet appareil \u2014 ouvrez-le au lieu de vous y connecter.","AppOverlayContentView_connect_logbook_outdated_title":"Cette application n\'est pas \xe0 jour","AppOverlayContentView_connect_logbook_outdated":"Le LOGBOOK Primary de \\"{name}\\" utilise une version plus r\xe9cente que cet appareil. Mettez LOGBOOK \xe0 jour ici pour vous connecter.","AppOverlayContentView_connect_logbook_outdated_version":"Cet appareil utilise la version {version}.","AppOverlayContentView_connect_logbook_outdated_appstore":"Veuillez mettre LOGBOOK \xe0 jour dans l\'App Store.","AppOverlayContentView_connect_logbook_outdated_playstore":"Veuillez mettre LOGBOOK \xe0 jour dans le Play Store.","AppOverlayContentView_connect_logbook_outdated_download":"T\xe9l\xe9charger la derni\xe8re version","AppOverlayContentView_connection":"Entrez l\'IP et le port du LOGBOOK Primary pour \xe9tablir une connexion. Utilisez le format \\"IP:Port\\", par ex. \\"192.168.0.100:8000\\".","AppOverlayContentView_connection_host":"H\xf4te","AppOverlayContentView_connection_port":"Port","AppOverlayContentView_disconnect_logbook":"D\xe9connecter le LOGBOOK Primary","AppOverlayContentView_disconnect_ship":"D\xe9connecter le navire","AppOverlayContentView_disconnect_ship_title":"D\xe9connecter le navire du LOGBOOK Cloud","AppOverlayContentView_import_reset":"R\xe9initialiser toutes les donn\xe9es import\xe9es","AppOverlayContentView_import_reset_confirm_title":"R\xe9initialiser toutes les donn\xe9es import\xe9es ?","AppOverlayContentView_import_reset_confirm_text":"Cela supprimera d\xe9finitivement tous les trajets import\xe9s. Cette action ne peut pas \xeatre annul\xe9e.","AppOverlayContentView_import_reset_confirm_no":"Annuler","AppOverlayContentView_import_reset_confirm_yes":"Oui, r\xe9initialiser","AppOverlayContentView_import_resetting":"R\xe9initialisation\u2026","AppOverlayContentView_import_ship_cancel":"Annuler","AppOverlayContentView_import_ship_choose":"Choisir un fichier","AppOverlayContentView_import_ship_title":"Importer depuis Logbook Suite","AppOverlayContentView_import_trips":"Importer depuis Logbook Suite","AppOverlayContentView_import_status_in_progress":"Importation en cours depuis {time}","AppOverlayContentView_import_status_complete":"Importation termin\xe9e le {date}","AppOverlayContentView_import_status_failed":"La tentative d\'importation pr\xe9c\xe9dente a \xe9chou\xe9. Veuillez r\xe9essayer ou contacter l\'assistance pour obtenir de l\'aide.","AppOverlayContentView_options_cruises":"Total des voyages dans LOGBOOK :","AppOverlayContentView_options_days":"Total des jours dans le LOGBOOK :","AppOverlayContentView_options_first_day":"Premier jour dans le LOGBOOK :","AppOverlayContentView_options_last_day":"Dernier jour dans le LOGBOOK :","AppOverlayContentView_options_trips":"Total des trajets dans le LOGBOOK :","AppOverlayContentView_options_ship":"Options pour \\"{name}\\"","AppOverlayContentView_options_ship_title":"Informations sur le navire","AppOverlayContentView_options_update":"Derni\xe8re synchronisation :","AppOverlayContentView_logout_confirm":"D\xe9connexion","AppOverlayContentView_logout_confirm_cancel":"Annuler","AppOverlayContentView_logout_confirm_title":"Confirmer la d\xe9connexion","AppOverlayContentView_remove_account_cancel":"Annuler","AppOverlayContentView_remove_account_confirm":"Confirmer","AppOverlayContentView_remove_account_confirm_title":"Suppression du compte","AppOverlayContentView_session_expired_dismiss":"Continuer sans synchronisation","AppOverlayContentView_session_expired_email":"E-mail","AppOverlayContentView_session_expired_failed":"\xc9chec de la connexion. V\xe9rifiez votre e-mail et votre mot de passe, puis r\xe9essayez.","AppOverlayContentView_session_expired_failed_request":"La connexion n\'a pas pu \xeatre envoy\xe9e. V\xe9rifiez votre connexion Internet et r\xe9essayez.","AppOverlayContentView_session_expired_login":"Se connecter","AppOverlayContentView_session_expired_login_loading":"Connexion en cours\u2026","AppOverlayContentView_session_expired_password":"Mot de passe","AppOverlayContentView_session_expired_title":"Connexion requise","AppOverlayContentView_ship_close_confirm":"Confirmer la fermeture de LOGBOOK","AppOverlayContentView_ship_close_confirm_cancel":"Annuler","AppOverlayContentView_ship_close_confirm_closing":"Fermeture de LOGBOOK\u2026","AppOverlayContentView_ship_close_confirm_title":"Confirmer la fermeture du navire","AppOverlayContentView_ship_close_failed":"Impossible de fermer LOGBOOK. V\xe9rifiez votre connexion Internet et r\xe9essayez.","AppOverlayContentView_ship_close_failed_offline":"LOGBOOK n\'a pas pu \xeatre ferm\xe9 car cet appareil est hors ligne. V\xe9rifiez votre connexion Internet et r\xe9essayez, ou fermez-le uniquement en local.","AppOverlayContentView_ship_close_failed_server":"LOGBOOK n\'a pas pu \xeatre ferm\xe9 car le LOGBOOK Cloud est temporairement indisponible. Veuillez r\xe9essayer dans un instant.","AppOverlayContentView_ship_force_close":"Forcer la fermeture locale","AppOverlayContentView_ship_force_close_confirm":"Confirmer la fermeture locale","AppOverlayContentView_ship_view_ships_cloud":"Afficher la liste des navires dans le Cloud","AppOverlayContentView_ships_cloud":"Afficher la liste des navires dans le Cloud","AppOverlayContentView_user_settings":"Param\xe8tres utilisateur","AppOverlayContentView_ship_not_closed_title":"D\xe9connecter le LOGBOOK Primary \\"{name}\\" du LOGBOOK Cloud","AppOverlayContentView_ship_open_title":"Le LOGBOOK Primary pour \\"{name}\\" est d\xe9j\xe0 ouvert","AppOverlayContentView_read_more":"En savoir plus","ChangeLogView_change_log":"Journal des modifications","ChangeLogView_download":"T\xe9l\xe9charger","ChangeLogView_change_welcome":"Bienvenue dans LOGBOOK App Version {version} !","ChangeLogView_change_fixed_info":"Vous trouverez ici des informations sur toutes les modifications apport\xe9es. La fen\xeatre du journal des modifications sera affich\xe9e \xe0 chaque chargement de l\'application s\'il y a de nouvelles modifications.","ChangeLogView_new_version_available":"Nouvelle mise \xe0 jour disponible au t\xe9l\xe9chargement","ChangeLogView_title":"Nouveaut\xe9s dans LOGBOOK","Component_ToggleSwitch":"","Component_ToggleSwitch_off":"OFF","Component_ToggleSwitch_on":"ON","CruiseCalendarView":"","CruiseCalendarView_actions_print":"Imprimer","CruiseCalendarView_focus":"Focus","CruiseCalendarView_start_ship":"Ouvrir le nouveau navire dans l\'application LOGBOOK","CruiseCalendarView_open_in_cloud":"Ouvrir dans le Cloud","CruiseCalendarView_untitled_cruise":"Voyage sans titre","CruiseEditView_title":"Nom du voyage","CruiseView":"","CruiseView_actions_print":"Imprimer","CruiseView_empty":"Cr\xe9er un trajet pour continuer","CruiseView_menu_labels":"Filtrer","CruiseView_menu_toggle_labels_off":"\xc9tiquettes d\xe9sactiv\xe9es","CruiseView_menu_toggle_labels_on":"\xc9tiquettes activ\xe9es","CruiseView_tab_cruise":"Voyage","CruiseView_tab_stats":"Statistiques","CruiseView_tab_track":"Trace","CruiseView_tab_print":"Imprimer","CruiseView_print_cruise":"Imprimer ce voyage","CruiseView_untitled_cruise":"Voyage sans titre","DayEditView":"","DayEditView_comment":"Commentaire","DayEditView_crew":"\xc9quipage","DayEditView_end_location":"Lieu de fin","DayEditView_passengers":"Passagers","DayEditView_skipper":"Capitaine","DayEditView_start_location":"Lieu de d\xe9part","DayEditView_status_day":"Jour","DayEditView_status_overnight":"Nuit","DayEditView_sunrise":"Lever du soleil","DayEditView_sunset":"Coucher du soleil","DayEditView_timezone":"Fuseau horaire","DayEditView_other_skipper":"Nouveau capitaine","DayEditView_other_crew":"Nouvelle personne","DayEditView_save_error_generic":"Non enregistr\xe9. Veuillez r\xe9essayer.","DayEditView_details_last_edited_by":"Derni\xe8re modification par {name}","DayEditView_details_last_edited":"Derni\xe8re modification","DayHeaderView":"","DayHeaderView_today":"Aujourd\'hui","DayHeaderView_nextDay":"Jour suivant","DayHeaderView_yesterday":"Hier","DayView":"","DayView_logs_empty":"Aucun enregistrement pour le moment","DayView_logs_empty_past":"Aucun enregistrement","DayView_tab_day":"Jour","DayView_tab_stats":"Statistiques","DayView_tab_track":"Parcours","DayView_tab_watches":"Plan de quart","DayView_tab_weather":"M\xe9t\xe9o","DayView_tab_weather_forecast":"Pr\xe9visions m\xe9t\xe9o","DayView_tab_journal":"Journal","DayView_tab_technical":"Technique","DayView_tab_print":"Imprimer","DayView_print_days":"Imprimer tous les jours de ce trajet","DayView_print_day":"Imprimer ce jour","DayWatchView":"","DayWatchView_groups_title":"Groupes de quarts","DayWatchView_add_group":"Ajouter un groupe","DayWatchView_groups_name":"Nom du groupe de quart","DayWatchView_groups_people":"Membres d\'\xe9quipage","DayWatchView_shifts_title":"Plan de quart","DayWatchView_shifts_hour":"Heure","DayWatchView_shifts_duration":"Dur\xe9e (h)","DayWatchView_shifts_group":"Groupe de quart","DayWatchView_shifts_group_undefined":"*Choisir*","DayWatchView_add_shift":"Ajouter un quart","DayWatchView_reset_shifts":"R\xe9initialiser les quarts","DayWatchView_shifts_unit_hour":"h","EditHistory":"","EditHistory_title":"Historique des modifications","EditHistory_field":"Champ","EditHistory_previous":"Avant","EditHistory_new":"Apr\xe8s","EditHistory_changed":"Modifi\xe9","EditHistory_entry_meta":"{date} par {name}","FocusView":"","FocusView_actions_add_cruise":"Voyage","FocusView_actions_add_trip":"Trajet","FocusView_actions_complete_cruise":"Voyage","FocusView_actions_complete_trip":"Trajet","FocusView_actions_print":"Imprimer","FocusView_start_trip":"Commencer le trajet","FocusView_cancel":"Annuler","FocusView_close":"Fermer","FocusView_confirm":"Continuer","FocusView_confirm_cruise_title":"Commencer un nouveau voyage","FocusView_confirm_trip_title":"Commencer un nouveau trajet","FocusView_set_timezone":"D\xe9finir le fuseau horaire","FocusView_tile_new_trip":"D\xe9marrage d\'un nouveau trajet","FocusView_timezone":"Fuseau horaire d\xe9fini pour le trajet","FocusView_current_time":"Heure actuelle calcul\xe9e","FocusView_subscription_expired":"Abonnement expir\xe9","FocusView_trial_expired":"Phase d\'essai termin\xe9e","FocusView_view_plans":"Voir les abonnements","GraphView":"","GraphView_graph_pressure":"Pression","GraphView_graph_temperature":"Temp\xe9rature","GraphView_graph_windDirection":"Direction du vent","GraphView_graph_windDirection_unit":"{direction}\xb0","GraphView_graph_windSpeed":"Vitesse du vent","GraphView_no_data":"Aucune donn\xe9e","InstrumentsView":"","InstrumentsView_compass_title":"Compas","InstrumentsView_compass_title_magnetic":"Compas (mag.)","InstrumentsView_compass_title_true":"Compas (vrai)","InstrumentsView_course_title":"Route","InstrumentsView_depth_title":"Profondeur","InstrumentsView_depth_title_DBK":"Sous la quille","InstrumentsView_depth_title_DBS":"Sous la surface","InstrumentsView_depth_title_DBT":"Sous le transducteur","InstrumentsView_depth_title_DPT":"Eau","InstrumentsView_engine_title_single":"Moteur","InstrumentsView_engine_title_multiple":"Moteurs","InstrumentsView_nmea_lost_title":"Connexion NMEA perdue","InstrumentsView_speed_title":"Vitesse","InstrumentsView_wind_title":"Vent","InstrumentsView_wind_title_apparent":"Apparent","InstrumentsView_wind_title_true":"Vrai","InstrumentsView_wind_title_trueRelative":"Vrai (rel.)","InstrumentsView_wind_side_port":"Bab","InstrumentsView_wind_side_starboard":"Trib","LogEnvironmentView":"","LogEnvironmentView_current_direction_speed":"Courant : Direction | Vitesse","LogEnvironmentView_pressure":"Pression","LogEnvironmentView_save_error_fields":"Non enregistr\xe9 \u2014 non autoris\xe9 : {fields}","LogEnvironmentView_save_error_generic":"Non enregistr\xe9. Veuillez r\xe9essayer.","LogEnvironmentView_seastate":"Condition (mer)","LogEnvironmentView_seastate_undefined":" ","LogEnvironmentView_seastate_":" ","LogEnvironmentView_seastate_0":"0 Calme (miroir)","LogEnvironmentView_seastate_1":"1 Calme (rid\xe9e) < 0,1m","LogEnvironmentView_seastate_2":"2 Belle (vaguelettes) < 0,5m","LogEnvironmentView_seastate_3":"3 Peu agit\xe9e < 1,25m","LogEnvironmentView_seastate_4":"4 Agit\xe9e < 2,5m","LogEnvironmentView_seastate_5":"5 Forte < 4m","LogEnvironmentView_seastate_6":"6 Tr\xe8s forte < 6m","LogEnvironmentView_seastate_7":"7 Grosse < 9m","LogEnvironmentView_seastate_8":"8 Tr\xe8s grosse < 14m","LogEnvironmentView_seastate_9":"9 \xc9norme > 14m","LogEnvironmentView_seastate_10":"Houle marine irr\xe9guli\xe8re","LogEnvironmentView_other":"Nouvelle condition (mer)","LogEnvironmentView_current_direction_undefined":" ","LogEnvironmentView_current_direction_":" ","LogEnvironmentView_current_direction_0":"0\xb0","LogEnvironmentView_current_direction_1":"90\xb0","LogEnvironmentView_current_direction_2":"180\xb0","LogEnvironmentView_current_direction_3":"270\xb0","LogEnvironmentView_other_direction":"Autre direction","LogEnvironmentView_weather_":"   ","LogEnvironmentView_weather_field":"M\xe9t\xe9o","LogEnvironmentView_weather_1":"ciel d\xe9gag\xe9","LogEnvironmentView_weather_2":"beau temps","LogEnvironmentView_weather_3":"partiellement nuageux","LogEnvironmentView_weather_4":"nuageux","LogEnvironmentView_weather_5":"couvert","LogEnvironmentView_weather_6":"bruine","LogEnvironmentView_weather_7":"pluie mod\xe9r\xe9e","LogEnvironmentView_weather_8":"forte pluie","LogEnvironmentView_weather_9":"averse","LogEnvironmentView_weather_10":"brume","LogEnvironmentView_weather_11":"brouillard l\xe9ger","LogEnvironmentView_weather_12":"brouillard","LogEnvironmentView_weather_13":"gr\xe9sil","LogEnvironmentView_weather_14":"gr\xeale","LogEnvironmentView_weather_15":"orage","LogEnvironmentView_weather_16":"neige","LogEnvironmentView_weather_temp_rel_humidity":"M\xe9t\xe9o | Temp. | Humidit\xe9 rel.","LogEnvironmentView_weather_temp":"Temp\xe9rature de l\'air","LogEnvironmentView_weather_rel_humidity":"Humidit\xe9 relative","LogEnvironmentView_wind_direction_speed":"Vent : Direction | Vitesse","LogNavigationView":"","LogNavigationView_comment":"Commentaire","LogNavigationView_course":"Route","LogNavigationView_course_to_wind":"Cap au vent","LogNavigationView_point_of_sail_noGo":"Vent debout","LogNavigationView_point_of_sail_closeHauled":"Pr\xe8s","LogNavigationView_point_of_sail_beamReach":"Travers","LogNavigationView_point_of_sail_broadReach":"Largue","LogNavigationView_point_of_sail_running":"Vent arri\xe8re","LogNavigationView_wind_side_port":"Bab","LogNavigationView_wind_side_starboard":"Trib","LogNavigationView_depth":"Profondeur","LogNavigationView_distance":"Distance","LogNavigationView_engine":"Moteur","LogNavigationView_engines":"Moteurs","LogNavigationView_engine_name":"Moteur {name}","LogNavigationView_heading":"Cap","LogNavigationView_location":"Emplacement pendant l\'arr\xeat","LogNavigationView_log":"Loch","LogNavigationView_position":"Position : Lat | Lon","LogNavigationView_sails":"Voiles","LogNavigationView_sog":"SOG","LogNavigationView_status":"Statut","LogNavigationView_status_anchor":"Au mouillage","LogNavigationView_status_buoy":"\xc0 la bou\xe9e","LogNavigationView_status_drifting":"\xc0 la d\xe9rive","LogNavigationView_status_inmotion":"En mouvement","LogNavigationView_status_none":"Aucun","LogNavigationView_status_offboard":"\xc0 terre","LogNavigationView_status_onboard":"\xc0 bord","LogNavigationView_status_port":"Au port","LogNavigationView_status_lock":"\xc9cluse","LogNavigationView_status_bunkering":"Station de carburant","LogNavigationView_status_bridge":"Pont","LogNavigationView_status_waiting":"En attente","LogNavigationView_stw":"STW","LogNavigationView_time":"Heure","LogNavigationView_time_utc":"UTC","LogNavigationView_created":"Entr\xe9e log cr\xe9\xe9e \xe0","LogNavigationView_updated":"Entr\xe9e log mise \xe0 jour \xe0","LogNavigationView_engine_rpms":"R\xe9gime moteur","LogNavigationView_save_error_fields":"Non enregistr\xe9 \u2014 non autoris\xe9 : {fields}","LogNavigationView_save_error_generic":"Non enregistr\xe9. Veuillez r\xe9essayer.","LogWatchView":"","LogWatchView_watch":"Quart","LogWatchView_watch_comment":"Commentaire de quart","LogWatchView_save_error_generic":"Non enregistr\xe9. Veuillez r\xe9essayer.","LogView":"","LogView_details_created_by":"Cr\xe9\xe9 par {name}","LogView_details_updated_at":"Derni\xe8re mise \xe0 jour le {date}","LogView_details_last_edited_by":"Derni\xe8re modification par {name}","LogView_details_last_edited":"Derni\xe8re modification","LogView_label_auto":"auto","LogView_label_default":"d\xe9faut","LogView_label_manual":"manuel","LogView_label_nmea":"nmea","LogView_log_alert":"Alerte {status} : {type} {info}","LogView_log_alert_info_anchorDepth":"- {depth}","LogView_log_alert_info_anchorDrift":"- d\xe9riv\xe9 de {distance} du point de mouillage","LogView_log_alert_info_pressure":"- {action} de {delta} en {interval}","LogView_log_alert_info_pressure_drop":"chut\xe9e","LogView_log_alert_info_pressure_raise":"augment\xe9e","LogView_log_alert_anchorDrift":"D\xe9rive du mouillage","LogView_log_alert_depth":"Profondeur","LogView_log_alert_lights":"Feux de navigation","LogView_log_alert_lostPosition":"Position perdue","LogView_log_alert_manOverboard":"Homme \xe0 la mer","LogView_log_alert_message":"Message","LogView_log_alert_pressure":"Pression","LogView_log_alert_test":"Test","LogView_log_alert_wind":"Vent","LogView_log_alert_start":"L\'alerte {alert} est {status}","LogView_log_alert_triggered":"Alerte {alert} d\xe9clench\xe9e","LogView_log_alert_anchorDrift_detail":"{transition} : {problem}","LogView_log_alert_depth_detail":"{transition} : {problem}","LogView_log_alert_lostPosition_detail":"{transition} : {problem}","LogView_log_alert_manOverboard_detail":"{transition} : {problem}","LogView_log_alert_message_detail":"{transition} : {problem}","LogView_log_alert_lostPosition_disconnected":"NMEA d\xe9connect\xe9","LogView_log_alert_lostPosition_stale":"donn\xe9es de position p\xe9rim\xe9es","LogView_log_alert_lostPosition_jump":"saut de position improbable","LogView_log_alert_lostPosition_invalidFix":"position GPS invalide","LogView_log_alert_manOverboard_emitterActivated":"balise MOB activ\xe9e","LogView_log_alert_manOverboard_manualButtonActivated":"bouton MOB activ\xe9","LogView_log_alert_manOverboard_manual":"d\xe9clench\xe9e manuellement","LogView_log_alert_manOverboard_unknown":"signal MOB re\xe7u","LogView_log_alert_lights_detail":"{recorded} -> {recommended}: {transition}.","LogView_log_alert_escalated":"Alerte {alert} escalad\xe9e","LogView_log_alert_escalated_by":"Alerte {alert} escalad\xe9e au skipper par {name}","LogView_log_alert_snoozed":"Alerte {alert} mise en veille","LogView_log_alert_snoozed_by":"Alerte {alert} mise en veille par {name}","LogView_log_alert_acknowledged":"Alerte {alert} acquitt\xe9e","LogView_log_alert_acknowledged_by":"Alerte {alert} acquitt\xe9e par {name}","LogView_log_alert_cleared":"Alerte {alert} effac\xe9e","LogView_log_alert_cleared_by":"Alerte {alert} effac\xe9e par {name}","LogView_log_alert_resolved":"Alerte {alert} r\xe9solue","LogView_log_alert_status_acknowledged":"Acquitt\xe9e","LogView_log_alert_status_alarm":"Alarme","LogView_log_alert_status_ignored":"Ignor\xe9e","LogView_log_alert_status_ok":"OK","LogView_log_alert_status_resolved":"R\xe9solue","LogView_log_alert_status_warning":"Avertissement","LogView_log_alert_type_anchorDepth":"Profondeur au mouillage","LogView_log_alert_type_anchorDrift":"D\xe9rive du mouillage","LogView_log_alert_type_pressure":"Pression","LogView_log_auto_interval":"Entr\xe9e automatique apr\xe8s {duration}","LogView_log_change_add_crew":"Ajout\xe9 \xe0 l\'\xe9quipage : {name}","LogView_log_change_add_passengers":"Ajout\xe9 aux passagers : {name}","LogView_log_change_add_skipper":"Ajout\xe9 au capitaine : {name}","LogView_log_change_remove_crew":"Retir\xe9 de l\'\xe9quipage : {name}","LogView_log_change_remove_passengers":"Retir\xe9 des passagers : {name}","LogView_log_change_remove_skipper":"Retir\xe9 du capitaine : {name}","LogView_log_course_change":"Changement de route","LogView_log_course_change_active":"Changement de route de {angle} {side} en {duration} vers {course}","LogView_log_course_change_end":"Changement de route de {angle} {side} en {duration} depuis {course}","LogView_log_course_change_side_port":"\xe0 b\xe2bord","LogView_log_course_change_side_starboard":"\xe0 tribord","LogView_log_course_change_started":"Changement de route commenc\xe9","LogView_log_engine_start":"Moteur d\xe9marr\xe9","LogView_log_engine_start_name":"Moteur {name} d\xe9marr\xe9","LogView_log_engine_start_idle":"Moteur d\xe9marr\xe9 au ralenti","LogView_log_engine_start_idle_name":"Moteur {name} d\xe9marr\xe9 au ralenti","LogView_log_engine_stop":"Moteur arr\xeat\xe9","LogView_log_engine_stop_name":"Moteur {name} arr\xeat\xe9","LogView_log_engine_stop_duration":"Moteur arr\xeat\xe9 apr\xe8s {duration}","LogView_log_engine_stop_duration_name":"Moteur {name} arr\xeat\xe9 apr\xe8s {duration}","LogView_log_engine_stop_distance":"Moteur arr\xeat\xe9 apr\xe8s {duration} ({distance})","LogView_log_engine_stop_distance_name":"Moteur {name} arr\xeat\xe9 apr\xe8s {duration} ({distance})","LogView_log_engine_idle":"Moteur au ralenti","LogView_log_engine_idle_name":"Moteur {name} au ralenti","LogView_log_engine_load":"Moteur en charge","LogView_log_engine_load_name":"Moteur {name} en charge","LogView_log_engine_load_duration":"Moteur en charge apr\xe8s {duration}","LogView_log_engine_load_duration_name":"Moteur {name} en charge apr\xe8s {duration}","LogView_log_engine_missing":"Informations moteur manquantes, pr\xe9sum\xe9 arr\xeat\xe9","LogView_log_engine_missing_name":"Informations moteur {name} manquantes, pr\xe9sum\xe9 arr\xeat\xe9","LogView_log_engine_missing_duration":"Informations moteur manquantes, pr\xe9sum\xe9 arr\xeat\xe9 apr\xe8s {duration}","LogView_log_engine_missing_duration_name":"Informations moteur {name} manquantes, pr\xe9sum\xe9 arr\xeat\xe9 apr\xe8s {duration}","LogView_log_engine_missing_distance":"Informations moteur manquantes, pr\xe9sum\xe9 arr\xeat\xe9 apr\xe8s {duration} ({distance})","LogView_log_engine_missing_distance_name":"Informations moteur {name} manquantes, pr\xe9sum\xe9 arr\xeat\xe9 apr\xe8s {duration} ({distance})","LogView_log_propulsion_off":"Sous voiles, aucun moteur en marche","LogView_log_propulsion_off_noSails":"Aucun moteur en marche","LogView_log_engine_missing_hint_castOff":"Entr\xe9e moteur manquante depuis l\'appareillage ?","LogView_log_engine_missing_hint_anchorUp":"Entr\xe9e moteur manquante depuis le levage de l\'ancre ?","LogView_log_engine_missing_hint_motorVessel":"Entr\xe9e moteur manquante depuis le d\xe9part ?","LogView_log_generator_start":"G\xe9n\xe9rateur {number} d\xe9marr\xe9","LogView_log_generator_stop":"G\xe9n\xe9rateur {number} arr\xeat\xe9","LogView_log_lighting":"Feux r\xe9gl\xe9s sur {lighting}","LogView_log_lighting_none":"Aucun feu affich\xe9","LogView_log_monitor_start":"Surveillance {monitor} d\xe9marr\xe9e","LogView_log_monitor_stop":"Surveillance {monitor} arr\xeat\xe9e","LogView_log_monitor_anchor":"Alarme de mouillage","LogView_log_monitor_depth":"de la profondeur","LogView_log_navigation_status_start":"Navigation commenc\xe9e","LogView_log_navigation_status_stop":"Navigation arr\xeat\xe9e","LogView_log_nmea_connection_resume":"Connexion NMEA r\xe9tablie pour les donn\xe9es de navigation","LogView_log_nmea_connection_stop":"Connexion NMEA perdue pour les donn\xe9es de navigation","LogView_log_nmea_connection_start":"Connexion NMEA d\xe9marr\xe9e pour","LogView_log_nmea_connection_user_stop":"Connexion NMEA ferm\xe9e pour les donn\xe9es de navigation","LogView_log_pause_start":"D\xe9but de la pause","LogView_log_pause_stop":"Fin de la pause","LogView_log_pause_stop_duration":"Fin de la pause apr\xe8s {duration}","LogView_log_pause_stop_status":"{status} termin\xe9","LogView_log_pause_stop_status_duration":"{status} termin\xe9 apr\xe8s {duration}","LogView_log_status_anchor":"Au mouillage","LogView_log_status_bunkering":"\xc0 la station-service","LogView_log_status_buoy":"\xc0 la bou\xe9e","LogView_log_status_drifting":"\xc0 la d\xe9rive","LogView_log_status_inmotion":"En mouvement","LogView_log_status_offboard":"\xc0 terre","LogView_log_status_onboard":"\xc0 bord","LogView_log_status_port":"Au port","LogView_log_status_lock":"Dans l\'\xe9cluse","LogView_log_status_bridge":"Au pont","LogView_log_status_waiting":"En attente","LogView_log_status_location":"{status} : {location}","LogView_log_stop":"Arr\xeat pour {stop}","LogView_log_stop_location":"Arr\xeat pour {stop} \xe0 {location}","LogView_log_stop_type_endOfDay":"fin de journ\xe9e","LogView_log_stop_type_stopover":"escale","LogView_log_sail_down":"{sail} affal\xe9e","LogView_log_sail_up":"{sail} hiss\xe9e","LogView_nmea_auto_course_change_entries":"Entr\xe9es de changement de route","LogView_nmea_auto_entries":"Entr\xe9es automatiques","LogView_nmea_pending":"Log","LogView_provisional_cancel_discard":"Supprimer l\'entr\xe9e","LogView_provisional_cancel_error":"L\'entr\xe9e n\'a pas pu \xeatre supprim\xe9e. Veuillez r\xe9essayer.","LogView_provisional_cancel_keep":"Conserver","LogView_provisional_cancel_message_courseChange":"Supprimer ce changement de route ? Aucune entr\xe9e ne sera enregistr\xe9e pour cette man\u0153uvre.","LogView_provisional_cancel_message_speedChange":"Supprimer cette pause ? Aucune entr\xe9e ne sera enregistr\xe9e et le navire reste en route.","LogView_provisional_cancel_title_courseChange":"Supprimer le changement de route","LogView_provisional_cancel_title_speedChange":"Supprimer la pause","LogView_tab_environment":"Environnement","LogView_tab_navigation":"Navigation","LogView_tab_watch":"Quart","LoginView":"","LoginView_error_confirmation_failed":"La confirmation de l\'e-mail a \xe9chou\xe9. Si le compte a \xe9t\xe9 pr\xe9c\xe9demment activ\xe9, vous pouvez utiliser la fonction Mot de passe oubli\xe9 ci-dessous.","LoginView_error_failed":"La connexion a \xe9chou\xe9. Veuillez v\xe9rifier votre e-mail et votre mot de passe et r\xe9essayer.","LoginView_error_failed_request":"La connexion a \xe9chou\xe9. Veuillez v\xe9rifier votre connexion Internet et r\xe9essayer.","LoginView_error_native_login_failed":"La connexion n\'a pas pu \xeatre finalis\xe9e. Veuillez revenir dans l\'application et r\xe9essayer.","LoginView_local_login_required":"Ouvrez LOGBOOK sur cet appareil pour vous connecter. La connexion Primary est uniquement disponible dans l\'application locale de cet appareil.","LoginView_companion_handoff_failed":"La connexion Companion n\'a pas pu \xeatre \xe9tablie. Ouvrez LOGBOOK sur cet appareil et reconnectez-vous depuis votre liste de bateaux.","LoginView_companion_handoff_pending":"Connexion au LOGBOOK Primary...","LoginView_error_native_login_invalid":"La connexion ne peut pas continuer, car le rappel de l\'application est absent ou non valide.","LoginView_error_signup_failed":"L\'inscription a \xe9chou\xe9.","LoginView_error_signupEmailAlreadyExists":"L\'inscription a \xe9chou\xe9. L\'adresse e-mail est d\xe9j\xe0 utilis\xe9e.","LoginView_error_signupAccountAlreadyExists":"L\'inscription a \xe9chou\xe9. Un compte avec le m\xeame nom existe d\xe9j\xe0.","LoginView_error_signupNameInvalid":"Merci de saisir votre nom (au moins 3 caract\xe8res).","LoginView_error_signupEmailInvalid":"Merci de saisir une adresse e-mail valide.","LoginView_error_signupPasswordInvalid":"Le mot de passe doit contenir au moins 3 caract\xe8res.","LoginView_error_invitation_accept_failed":"L\'acceptation de l\'invitation a \xe9chou\xe9. Veuillez vous assurer que vous \xeates connect\xe9 avec le compte auquel l\'invitation a \xe9t\xe9 envoy\xe9e, puis r\xe9essayez.","LoginView_forgot_password":"R\xe9cup\xe9ration du mot de passe","LoginView_forgot_password_complete":"Mot de passe modifi\xe9. Vous pouvez maintenant vous connecter \xe0 votre compte en utilisant le nouveau mot de passe.","LoginView_forgot_password_email":"Veuillez entrer l\'adresse e-mail de votre compte pour d\xe9marrer le processus de r\xe9cup\xe9ration du mot de passe.","LoginView_forgot_password_email_sent":"Si un compte existe pour cette adresse e-mail, vous recevrez un e-mail avec les prochaines \xe9tapes.","LoginView_forgot_password_new_password":"Veuillez entrer un nouveau mot de passe pour terminer la r\xe9cup\xe9ration du mot de passe.","LoginView_error_reset_failed":"La r\xe9cup\xe9ration du mot de passe a \xe9chou\xe9. Veuillez r\xe9essayer.","LoginView_error_reset_failed_request":"La r\xe9cup\xe9ration du mot de passe a \xe9chou\xe9. Veuillez v\xe9rifier votre connexion Internet et r\xe9essayer.","LoginView_form_back_to_login":"Retour \xe0 la page de connexion","LoginView_form_name":"Nom","LoginView_form_email":"E-mail","LoginView_form_new_password":"Nouveau mot de passe","LoginView_form_new_password_confirmation":"Confirmation du nouveau mot de passe","LoginView_form_password":"Mot de passe","LoginView_form_submit":"Connexion","LoginView_form_submit_forgot_password":"R\xe9initialiser","LoginView_form_submit_forgot_password_loading":"R\xe9initialisation\u2026","LoginView_form_submit_login":"Connexion","LoginView_form_submit_login_loading":"Connexion en cours\u2026","LoginView_form_submit_signup":"S\'inscrire","LoginView_form_forgot_password":"Mot de passe\xa0oubli\xe9 ?","LoginView_form_account_name":"Nom du compte","LoginView_reset_app_title":"R\xe9initialiser l\'application","LoginView_reset_app_cancel":"Annuler","LoginView_reset_app_action":"D\xe9marrer la r\xe9initialisation","LoginView_welcome":"Bienvenue sur LOGBOOK.","LoginView_signup_link_unavailable":"Le lien d\'inscription n\'a pas pu \xeatre charg\xe9. Veuillez r\xe9essayer.","LoginView_signup_link_retry":"R\xe9essayer","LoginView_login":"Vous avez d\xe9j\xe0 un compte ? Connectez-vous simplement \xe0 LOGBOOK.","LoginView_login_email":"Connectez-vous avec votre e-mail et votre mot de passe.","LoginView_native_sign_in_loading":"Connexion\u2026","LoginView_native_sign_in_fallback":"Se connecter avec Safari","LoginView_native_sign_in_or":"ou","LoginView_signup":"Vous \xeates nouveau sur LOGBOOK ? Inscrivez-vous simplement pour LOGBOOK.","LoginView_signup_email":"Inscrivez-vous avec votre e-mail et un mot de passe.","LoginView_invitation_use_other_account":"Utiliser un autre compte","LoginView_invitation_accept":"Accepter l\'invitation","LoginView_footer_about":"\xc0 propos de nous","LoginView_footer_help":"Aide","LoginView_footer_language":"Langue","LoginView_footer_reset_app":"R\xe9initialiser l\'application","Menu":"","Menu_ship":"Navire","Menu_account":"Compte","MenuAccount":"","MenuAccount_account_settings":"Param\xe8tres\xa0du compte","MenuAccount_remove_account":"Supprimer le compte","MenuAccount_close_companion":"D\xe9connecter le Companion","MenuAccount_open_cloud":"Vers LOGBOOK\xa0Cloud","MenuAccount_account_settings_app":"Vers l\'application\xa0LOGBOOK","MenuAccount_logout":"D\xe9connexion","MenuAccount_switch_user":"Changer d\'utilisateur","MenuAccount_return_to_own_user":"Retour \xe0 {name}","MenuAccount_user_settings":"Param\xe8tres\xa0utilisateur","MenuHelp":"","MenuHelp_about":"\xc0 propos\xa0de LOGBOOK","MenuHelp_change_log":"Journal des modifications","MenuHelp_contact_support":"Contacter\xa0l\'assistance","MenuHelp_documentation":"Documentation","MenuHelp_help":"Aide","MenuHelp_support":"Page d\'assistance","MenuHelp_qanda":"Questions et r\xe9ponses","MenuHelp_demo":"D\xe9mos interactives","MenuHelp_title":"Aide","MenuAlerts":"","MenuAlerts_title":"Alertes","MenuNMEA":"","MenuNMEA_connection":"Connexion NMEA","MenuNMEA_last_update":"Derni\xe8re mise \xe0 jour : {timestamp}","MenuNMEA_recording":"Enregistrement automatique","MenuNMEA_settings":"Param\xe8tres","MenuNMEA_title":"NMEA","MenuShip":"","MenuShip_close":"Fermer LOGBOOK {name}","MenuShip_logout":"D\xe9connexion de \\"{name}\\"","MenuShip_data_name":"Donn\xe9es du navire {name}","MenuShip_new":"Nouveau navire","MenuShip_settings_name":"Param\xe8tres de {name}","MenuShip_select":"S\xe9lectionner un navire","MenuShip_view_cloud":"Voir \\"{name}\\" dans le Cloud","MenuShip_view_ships":"Voir la liste des navires","MenuSync":"","MenuSync_internet_status":"Connexion\xa0Internet","MenuSync_last_update":"Derni\xe8re mise \xe0 jour : {timestamp}","MenuSync_status":"\xc9tat de synchronisation","MenuSync_title":"Sync","MenuSync_resync":"Reconnecter","MenuSync_relogin":"Se reconnecter","NMEAConfigurationView":"","NMEAConfigurationView_blank":"\xa0","NMEAConfigurationView_and":"et","NMEAConfigurationView_banner_start_setup":"D\xe9marrer la configuration NMEA","NMEAConfigurationView_banner_text":"La connexion NMEA n\'est pas activ\xe9e.","NMEAConfigurationView_cancel":"Annuler","NMEAConfigurationView_checks":"Donn\xe9es NMEA disponibles :","NMEAConfigurationView_check_air_pressure":"Pression atmosph\xe9rique","NMEAConfigurationView_check_air_humidity":"Humidit\xe9","NMEAConfigurationView_check_air_temperature":"Temp\xe9rature de l\'air","NMEAConfigurationView_check_depth":"Profondeur","NMEAConfigurationView_check_engine":"R\xe9gime moteur","NMEAConfigurationView_check_engine_1":"R\xe9gime moteur #1","NMEAConfigurationView_check_engine_2":"R\xe9gime moteur #2","NMEAConfigurationView_check_engine_3":"R\xe9gime moteur #3","NMEAConfigurationView_check_engine_4":"R\xe9gime moteur #4","NMEAConfigurationView_check_engine_5":"R\xe9gime moteur #5","NMEAConfigurationView_check_engine_ids":"ID moteurs actifs : {ids}","NMEAConfigurationView_check_engine_ids_none":"aucun","NMEAConfigurationView_check_navigation_course":"Cap","NMEAConfigurationView_check_navigation_gps":"Position GPS","NMEAConfigurationView_check_navigation_log":"Distance dans l\'eau","NMEAConfigurationView_check_navigation_sog":"Vitesse sur le fond","NMEAConfigurationView_check_utc":"UTC","NMEAConfigurationView_check_water_temperature":"Temp\xe9rature de l\'eau","NMEAConfigurationView_check_native_gps":"Position GPS interne","NMEAConfigurationView_check_native_air_pressure":"Pression atmosph\xe9rique interne","NMEAConfigurationView_check_wind":"Vent (vitesse et direction)","NMEAConfigurationView_connection_device":"Appareil","NMEAConfigurationView_connection_host":"Adresse","NMEAConfigurationView_connection_port":"Port","NMEAConfigurationView_connection_type":"Type de connexion NMEA","NMEAConfigurationView_connection_type_bluetooth":"Bluetooth (non pris en charge)","NMEAConfigurationView_connection_type_gps":"GPS int\xe9gr\xe9","NMEAConfigurationView_connection_type_tcp":"TCP","NMEAConfigurationView_connection_type_udp":"UDP","NMEAConfigurationView_connection_type_usb":"USB","NMEAConfigurationView_connect":"Tester la connexion","NMEAConfigurationView_connecting":"Connexion\u2026","NMEAConfigurationView_capture":"Envoyer les donn\xe9es NMEA au support","NMEAConfigurationView_capture_sending":"Envoi...","NMEAConfigurationView_capture_success":"Envoy\xe9","NMEAConfigurationView_capture_error":"\xc9chec de l\u2019envoi","NMEAConfigurationView_capture_hint":"Envoie un court enregistrement des donn\xe9es brutes re\xe7ues de vos instruments, afin que le support puisse analyser les probl\xe8mes de connexion.","NMEAConfigurationView_complete":"Termin\xe9","NMEAConfigurationView_error_invalidUrl":"Erreur : URL invalide","NMEAConfigurationView_error_connectionFailed":"Erreur : \xc9chec de la connexion","NMEAConfigurationView_error_disconnected":"Erreur : NMEA n\'est pas connect\xe9","NMEAConfigurationView_error_failedToOpen":"Erreur : \xc9chec de l\'ouverture de l\'appareil","NMEAConfigurationView_error_subscriptionExpired":"Erreur : Abonnement expir\xe9","NMEAConfigurationView_error_unsupportedSchema":"Erreur : Protocole non pris en charge","NMEAConfigurationView_reconnect":"Reconnecter","NMEAConfigurationView_reset":"R\xe9initialiser","NMEAConfigurationView_step_conditions":"Conditions","NMEAConfigurationView_step_connection":"Connexion","NMEAConfigurationView_step_native":"Capteurs internes","NMEAConfigurationView_step_test_data":"Test et donn\xe9es","NMEAConfigurationView_title":"Param\xe8tres NMEA","NMEAConfigurationView_read_more":"En savoir plus","NMEAConfigurationView_condition_entry":"Conditions pour les entr\xe9es automatiques du journal","NMEAConfigurationView_condition_interval":"Entr\xe9es r\xe9guli\xe8res toutes les ","NMEAConfigurationView_condition_interval_3600":"60 min ","NMEAConfigurationView_condition_interval_1800":"30 min ","NMEAConfigurationView_condition_start_stop":"Condition pour l\'entr\xe9e de d\xe9part/arr\xeat","NMEAConfigurationView_condition_anchor_start_stop":"Param\xe8tre diff\xe9rent \xe0 l\'ancre ou \xe0 la bou\xe9e","NMEAConfigurationView_condition_anchor_no_status_change":"Aucun changement de statut si la vitesse est","NMEAConfigurationView_condition_anchor_depth_alerts":"Alertes d\'ancre et de profondeur","NMEAConfigurationView_condition_anchor_drift_warning":"Avertissement de d\xe9rive d\'ancre (nm)","NMEAConfigurationView_condition_anchor_drift_alarm":"Alarme de d\xe9rive d\'ancre (nm)","NMEAConfigurationView_condition_depth_warning":"Avertissement de profondeur","NMEAConfigurationView_condition_depth_alarm":"Alarme de profondeur","NMEAConfigurationView_condition_stop":"Entr\xe9e d\'arr\xeat si vitesse","NMEAConfigurationView_condition_start":"Entr\xe9e de d\xe9part si vitesse","NMEAConfigurationView_condition_course":"Entr\xe9e lors d\'un changement de route lorsque ","NMEAConfigurationView_condition_course_change":"changement de cap","NMEAConfigurationView_condition_course_speed":"vitesse","NMEAConfigurationView_condition_native_gps":"Utiliser le GPS interne","NMEAConfigurationView_condition_native_pressure":"Utiliser le capteur de pression atmosph\xe9rique interne","NMEAConfigurationView_condition_engine_idle_rpm":"Si le moteur fonctionne \xe0 moins que le r\xe9gime au ralenti (tr/min) : compter le temps et la distance comme \\"sous voile\\".","NMEAConfigurationView_condition_engine_idle_rpm_value":"R\xe9gime au ralenti (tr/min)","NMEAConfigurationView_condition_engine_detection":"D\xe9tection du moteur (tr/min)","NMEAConfigurationView_condition_engine_start":"Moteur en marche lorsque le r\xe9gime d\xe9passe","NMEAConfigurationView_condition_engine_stop":"Moteur arr\xeat\xe9 lorsque le r\xe9gime est en dessous de","NMEAConfigurationView_error_engine_rpm_order":"Erreur : le r\xe9gime \\"moteur arr\xeat\xe9\\" doit \xeatre inf\xe9rieur au r\xe9gime \\"moteur en marche\\"","NMEAConfigurationView_error_engine_idle_rpm":"Erreur : le r\xe9gime au ralenti doit \xeatre sup\xe9rieur au r\xe9gime \\"moteur en marche\\"","NoteView":"","NoteView_planning":"Plan de voyage","NoteView_crew":"\xc9quipage","NoteView_day":"Jour","NoteView_file_field_drag_drop":"Joindre des fichiers \xe0 cette note.","NoteView_attachment_remove_confirm":"Voulez-vous vraiment supprimer cette pi\xe8ce jointe ?","NoteView_attachment_remove_title":"Supprimer la pi\xe8ce jointe","NoteView_attachment_remove_accept":"Supprimer","NoteView_attachment_remove_cancel":"Annuler","NoteView_attachment_remove_error":"Impossible de supprimer la pi\xe8ce jointe. Veuillez r\xe9essayer.","NoteView_journal":"Journal","NoteView_note_created_by":"Cr\xe9\xe9 par {name}","NoteView_note_parent_day":"Jour : {date}","NoteView_note_parent_trip":"Trajet : {name}","NoteView_other":"Autre","NoteView_technical":"Technique","NoteView_type":"Type","NoteView_weather":"Pr\xe9visions m\xe9t\xe9o","NoteView_show_notes":"Afficher {count} notes {type}","NoteView_watch":"Plan de quart","NoteView_note_add_new":"Ajouter une nouvelle note","NoteView_note_journal_title":"Titre de l\'entr\xe9e de journal","NoteView_note_journal_note":"Texte du journal","NoteView_note_planning_date":"Date","NoteView_note_planning_title":"Emplacement","NoteView_note_planning_note":"Commentaire","NoteView_note_technical_title":"Titre de la note technique","NoteView_note_technical_note":"Note technique","NoteView_note_parent_type_day":"jour","NoteView_note_parent_type_trip":"trajet","NoteView_note_weather_title":"Source","NoteView_note_weather_date":"Date et heure","NoteView_note_weather_note":"Pr\xe9visions m\xe9t\xe9o","NoteView_note_weather_note_extra":"Conditions m\xe9t\xe9o","PrintHeaderView":"","PrintHeaderView_title":"LOGBOOK {view} \u2013 {ship}","PrintHeaderView_print_1":"Vue d\'ensemble du voyage","PrintHeaderView_print_2":"Trajets s\xe9lectionn\xe9s","PrintHeaderView_print_3":"Jours s\xe9lectionn\xe9s","PrintHeaderView_print_4":"Donn\xe9es du navire","PrintHeaderView_motor":"Navire \xe0 moteur","PrintHeaderView_sailing":"Voilier","PrintSettingsView":"","PrintSettingsView_title":"Param\xe8tres d\'impression","PrintSettingsView_button":"Imprimer","PrintSettingsView_cancel":"Annuler","PrintSettingsView_overview":"Aper\xe7u de l\'impression","PrintSettingsView_overview_all":"Imprimer tous les voyages dans LOGBOOK","PrintSettingsView_overview_year":"S\xe9lectionner une ann\xe9e","PrintSettingsView_overview_cruises":"Imprimer l\'aper\xe7u des voyages","PrintSettingsView_cruise":"Imprimer le voyage","PrintSettingsView_cruise_current":"Imprimer toutes les donn\xe9es du voyage suivies d\'une liste de tous les trajets","PrintSettingsView_cruise_summary":"Donn\xe9es du voyage et liste des trajets","PrintSettingsView_cruise_details":"D\xe9tails du voyage","PrintSettingsView_ship":"Imprimer les donn\xe9es du navire","PrintSettingsView_ship_short":"Donn\xe9es principales du navire","PrintSettingsView_ship_details":"Donn\xe9es d\xe9taill\xe9es du navire","PrintSettingsView_user_list":"Imprimer toutes les personnes pour ce navire","PrintSettingsView_trip":"Trajets","PrintSettingsView_trips":"Imprimer les trajets","PrintSettingsView_trips_all":"Imprimer tous les trajets du voyage","PrintSettingsView_trips_selected":"S\xe9lectionner un trajet \xe0 imprimer","PrintSettingsView_timeline":"Chronologie","PrintSettingsView_trips_summary":"Imprimer toutes les donn\xe9es des trajets et","PrintSettingsView_trips_summary_details":"une liste de jours avec d\xe9tails","PrintSettingsView_trips_summary_short":"une liste courte de jours","PrintSettingsView_trips_details":"D\xe9tails du trajet","PrintSettingsView_journal_list":"Imprimer toutes les entr\xe9es de journal (trajets et jours)","PrintSettingsView_technical_list":"Imprimer toutes les entr\xe9es techniques (trajets et jours)","PrintSettingsView_days":"Imprimer les jours","PrintSettingsView_days_select":"S\xe9lectionner un seul jour","PrintSettingsView_days_trip_select":"Imprimer tous les jours du trajet s\xe9lectionn\xe9","PrintSettingsView_days_text":"Imprimer les donn\xe9es du jour : onglets Jour et Statistiques plus les onglets choisis ci-dessous :","PrintSettingsView_thumbnails":" (y compris les miniatures d\'images)","PrintSettingsView_entries":"Ajouter \xe9galement les entr\xe9es log chaque jour","PrintSettingsView_edits":"Inclure toutes les modifications des entr\xe9es log et sur l\'onglet du jour","PrintSettingsView_entries_summary":"R\xe9sum\xe9 (liste des entr\xe9es log)","PrintSettingsView_entries_details":"Entr\xe9es log d\xe9taill\xe9es","PrintSettingsView_entries_day_select":"S\xe9lectionner un jour","PrintSettingsView_entries_trip_select":"S\xe9lectionner un trajet pour imprimer les jours","PrintSettingsView_evaluations":"Imprimer les \xe9valuations","PrintSettingsView_journal":"Entr\xe9es de journal avec photos","PrintSettingsView_tacks":"Traces","PrintSettingsView_technical":"Documentation technique avec photos","PrintSettingsView_authorities":"\xc9valuation pour les autorit\xe9s","PrintSettingsView_authorities_day":"Entr\xe9es manuelles pour la journ\xe9e","PrintSettingsView_authorities_log":"Entr\xe9es log","PrintView":"","PrintView_print_action":"Imprimer","PrintView_print_cancel":"Annuler","PrintView_cruise":"Voyage","PrintView_cruise_statistics":"Statistiques du voyage","PrintView_trip":"Trajet","PrintView_trips":"Trajet","PrintView_trip_list":"Liste des trajets","PrintView_trip_statistics":"Statistiques du trajet","PrintView_day":"Donn\xe9es du journal de bord pour","PrintView_day_list":"Liste des jours dans le trajet","PrintView_day_maindata":"Donn\xe9es principales du jour","PrintView_day_statistics":"Statistiques du jour","PrintView_date":"Date","PrintView_from_date":"Du","PrintView_until_date":"jusqu\'au","PrintView_from_loc":"En provenance de","PrintView_to_loc":"vers","PrintView_time_total":"Dur\xe9e","PrintView_distance_total":"Distance","PrintView_technical_notes":"Notes techniques","PrintView_watch_groups":"Groupes de quart","PrintView_watch_shifts":"Quarts","PrintView_note_technical":"Note technique","PrintView_list_technical":"Liste de toutes les notes techniques","PrintView_note_journal":"Entr\xe9e de journal","PrintView_list_journal":"Liste de toutes les entr\xe9es de journal","PrintView_note_watch":"Quart","PrintView_note_planning":"Plan de voyage","PrintView_note_weather":"Pr\xe9visions m\xe9t\xe9o","PrintView_log_entries":"Entr\xe9es de journal","SearchView":"","SearchView_token_ship":"Navire","SearchView_token_type":"Type","SearchView_type_cruise":"Voyage","SearchView_type_day":"Jour","SearchView_type_log":"Log","SearchView_type_note":"Note","SearchView_type_trip":"Trajet","ShipImportView":"","ShipImportView_cancel":"Annuler","ShipImportView_file_field_drag_drop":"S\xe9lectionner le fichier d\'exportation LogbookSuite","ShipImportView_open":"Voir le navire","ShipImportView_status_complete":"Termin\xe9","ShipImportView_status_failed":"\xc9chec. Veuillez r\xe9essayer ou contacter l\'assistance pour obtenir de l\'aide.","ShipImportView_status_error":"Erreur : {error}","ShipImportView_status_processing":"Traitement en cours","ShipImportView_status_pending":"Pr\xe9paration de l\'importation","ShipImportView_status_uploading":"T\xe9l\xe9chargement","ShipImportView_title":"Importer les donn\xe9es du navire","ShipImportView_title_ship":"Importer les trajets dans {ship}","ShipSettingsView_settings":"Param\xe8tres","ShipSettingsView_ship_settings":"Param\xe8tres du navire","ShipSettingsView_tab_units":"Param\xe8tres des unit\xe9s","ShipSettingsView_tab_ship_user":"Toutes les personnes","ShipSettingsView_tab_lists":"Param\xe8tres des listes","ShipSettingsView_tab_settings":"Param\xe8tres","ShipSettingsView_tab_companions":"Companions","ShipSettingsView_more_info":"En savoir plus","ShipSettingsView_read_more":"En savoir plus","ShipSettingsView_add_user":"Personne","ShipSettingsView_cancel":"Annuler","ShipSettingsView_save":"Ajouter une personne","ShipSettingsView_timezone":"Fuseau horaire","ShipSettingsView_timezone_title":"Configuration manuelle du fuseau horaire","ShipSettingsView_timezone_manual":"D\xe9finir le fuseau horaire manuellement","ShipSettingsView_current_time":"Heure actuelle","ShipSettingsView_log_offset_title":"D\xe9calage pour la valeur du transducteur de loch","ShipSettingsView_log_offset":"D\xe9calage du loch (nm)","ShipSettingsView_rpm_title":"Conserver le RPM saisi manuellement","ShipSettingsView_rpm_keep_manual":"Reporter le RPM \xe0 la prochaine entr\xe9e de journal","ShipSettingsView_lights_title":"Rappel des signaux visuels","ShipSettingsView_lights_enable":"Me rappeler les signaux visuels","ShipSettingsView_lights_sailing":"Feux port\xe9s \xe0 la voile","ShipSettingsView_lights_sailing_runningLights":"Feux de navigation s\xe9par\xe9s","ShipSettingsView_lights_sailing_triColor":"Feu tricolore en t\xeate de m\xe2t","ShipSettingsView_lights_lead":"Limite jour / nuit","ShipSettingsView_lights_lead_civil":"Cr\xe9puscule civil (recommand\xe9)","ShipSettingsView_lights_lead_official":"Coucher / lever du soleil","ShipSettingsView_lights_motoring_cone":"Me rappeler de hisser le c\xf4ne de moteur","ShipSettingsView_edit_permissiveness_title":"Permissivit\xe9 d\'\xe9dition","ShipSettingsView_edit_permissiveness_level":"Niveau d\'\xe9dition","ShipSettingsView_edit_permissiveness_level_default":"Par d\xe9faut (strict)","ShipSettingsView_edit_permissiveness_level_extended":"\xc9tendu","ShipSettingsView_edit_permissiveness_level_unrestricted":"Illimit\xe9","ShipSettingsView_socket":"Adresse du LOGBOOK Primary","ShipSettingsView_socket_text":"Utilisez cette adresse pour connecter un Companion au LOGBOOK Primary","ShipSettingsView_connected_companions":"Companions connect\xe9s","ShipSettingsView_companion_host":"H\xf4te","ShipSettingsView_companion_user":"Utilisateur","ShipSettingsView_companions_loading":"Chargement des Companions connect\xe9s\u2026","ShipSettingsView_companions_empty":"Aucun Companion n\u2019est actuellement connect\xe9.","ShipSettingsView_companions_error":"Impossible de charger les Companions connect\xe9s. Nouvelle tentative\u2026","ShipSettingsView_disconnect_companion":"D\xe9connecter","ShipSettingsView_disconnect_companion_label":"D\xe9connecter {user} sur {host}","ShipSettingsView_disconnect_companion_title":"D\xe9connecter le Companion ?","ShipSettingsView_disconnect_companion_text":"Ce Companion devra \xeatre reconnect\xe9 manuellement. Les autorisations de l\u2019utilisateur sur le bateau et les autres appareils resteront inchang\xe9s.","ShipSettingsView_disconnect_companion_error":"Impossible de d\xe9connecter ce Companion. Veuillez r\xe9essayer.","ShipSettingsView_units":"Param\xe8tres des unit\xe9s","ShipSettingsView_comment_":"*Choisir ou entrer*","ShipSettingsView_seaState_":"*Choisir ou entrer*","ShipSettingsView_comment_anchor_down":"Ancre mouill\xe9e","ShipSettingsView_comment_anchor_up":"Ancre lev\xe9e","ShipSettingsView_comment_engine_started":"Moteur d\xe9marr\xe9","ShipSettingsView_comment_engine_stopped":"Moteur arr\xeat\xe9","ShipSettingsView_comment_sails_set":"Voiles hiss\xe9e","ShipSettingsView_comment_sails_dropped":"Voiles affal\xe9es","ShipSettingsView_add_seaState":"Ajouter \xe9tat de la mer","ShipSettingsView_add_comment":"Ajouter un commentaire","ShipSettingsView_seaState_waves":"Vagues","ShipSettingsView_seaState_swell":"Houle","ShipSettingsView_seaState_cross_sea":"Mer crois\xe9e","ShipSettingsView_seaState_calm":"Mer calme","ShipSettingsView_seaState_rough":"Mer agit\xe9e","ShipSettingsView_currency":"Devise","ShipSettingsView_distance":"Distance","ShipSettingsView_length":"Longueur","ShipSettingsView_power":"Puissance","ShipSettingsView_pressure":"Pression","ShipSettingsView_speed":"Vitesse","ShipSettingsView_surface":"Surface","ShipSettingsView_temperature":"Temp\xe9rature","ShipSettingsView_volume":"Volume","ShipSettingsView_weight":"Poids","ShipSettingsView_wind":"Vent","ShipSettingsView_current":"Courant","ShipSettingsView_unit_currency":"Devise","ShipSettingsView_unit_bar":"bar","ShipSettingsView_unit_celsius":"\xb0C","ShipSettingsView_unit_cm":"cm","ShipSettingsView_unit_fahrenheit":"\xb0F","ShipSettingsView_unit_foot":"pied","ShipSettingsView_unit_gal":"gal","ShipSettingsView_unit_inch":"pouce","ShipSettingsView_unit_kg":"kg","ShipSettingsView_unit_km":"km","ShipSettingsView_unit_kmh":"km/h","ShipSettingsView_unit_kn":"kn","ShipSettingsView_unit_kw":"kw","ShipSettingsView_unit_kwh":"kwh","ShipSettingsView_unit_hp":"hp","ShipSettingsView_unit_l":"l","ShipSettingsView_unit_m3":"m\xb3","ShipSettingsView_unit_cuft":"cuft","ShipSettingsView_unit_mps":"m/s","ShipSettingsView_unit_m":"m","ShipSettingsView_unit_m2":"m\xb2","ShipSettingsView_unit_miles":"miles","ShipSettingsView_unit_mph":"mph","ShipSettingsView_unit_nm":"nm","ShipSettingsView_unit_lb":"lb","ShipSettingsView_unit_ft":"ft","ShipSettingsView_unit_in":"in","ShipSettingsView_unit_sqft":"sqft","ShipSettingsView_unit_psi":"psi","ShipSettingsView_unit_sqyd":"sqyd","ShipSettingsView_unit_tons":"to","ShipSettingsView_unit_yard":"yard","ShipSettingsView_unit_hpa":"hPa","ShipSettingsView_unit_undefined":"*Choisir ou entrer*","ShipSettingsView_other":"Entrer autre","ShipSettingsView_unit_eur":"\u20AC","ShipSettingsView_unit_usd":"$","ShipSettingsView_unit_gbp":"\xa3","ShipSettingsView_unit_aud":"AU$","ShipSettingsView_unit_nzd":"NZ$","ShipSettingsView_unit_chf":"CHF","ShipSettingsView_unit_sek":"SEK","ShipSettingsView_unit_nok":"NOK","ShipSettingsView_unit_dkk":"DKK","ShipSettingsView_unit_jpy":"\xa5","ShipSettingsView_user_crew_role":"R\xf4le d\'\xe9quipage","ShipSettingsView_ship_user_crew_role_crew":"\xc9quipage","ShipSettingsView_ship_user_crew_role_none":"Aucun","ShipSettingsView_ship_user_crew_role_owner":"Titulaire du compte","ShipSettingsView_ship_user_crew_role_skipper":"Capitaine","ShipSettingsView_user_email":"E-mail","ShipSettingsView_language":"Langue","ShipSettingsView_lang_en":"English","ShipSettingsView_lang_de":"Deutsch","ShipSettingsView_lang_fr":"Fran\xe7ais","ShipSettingsView_user_name":"Nom","ShipSettingsView_user_shortname":"Nom court","ShipSettingsView_user_account":"Compte","ShipSettingsView_user_active":"Activer","ShipSettingsView_user_inactive":"D\xe9sactiver","ShipSettingsView_user_invite":"Inviter","ShipSettingsView_user_invite_title":"Inviter un utilisateur du navire \xe0 LOGBOOK","ShipSettingsView_user_reactivate":"R\xe9activer","ShipSettingsView_remove_user":"Supprimer","ShipSettingsView_user_deactivate_confirm_title":"D\xe9sactiver l\'utilisateur","ShipSettingsView_user_deactivate_confirm_message":"Voulez-vous vraiment d\xe9sactiver l\'acc\xe8s de cet utilisateur au navire ? S\'il n\'a plus d\'autre acc\xe8s \xe0 un navire sur ce compte, son compte sera \xe9galement d\xe9sactiv\xe9.","ShipSettingsView_user_deactivate_confirm_accept":"D\xe9sactiver","ShipSettingsView_user_deactivate_confirm_cancel":"Annuler","ShipSettingsView_user_remove_confirm_title":"Supprimer l\'utilisateur","ShipSettingsView_user_remove_confirm_message":"Voulez-vous vraiment supprimer cet utilisateur du navire ? Cette action est irr\xe9versible.","ShipSettingsView_user_remove_confirm_accept":"Supprimer","ShipSettingsView_user_remove_confirm_cancel":"Annuler","ShipSettingsView_ship_user_level":"Autorisations","ShipSettingsView_ship_user_level_primary":"Primary","ShipSettingsView_ship_user_level_editAll":"Voir et modifier tout","ShipSettingsView_ship_user_level_editCurrent":"Voir et modifier le voyage actuel","ShipSettingsView_ship_user_level_viewAll":"Voir tout","ShipSettingsView_ship_user_level_viewCurrent":"Voir le voyage actuel","ShipSettingsView_ship_user_level_none":"Aucun","ShipSettingsView_user_status":"Statut","ShipSettingsView_user_status_active":"Actif","ShipSettingsView_user_status_invited":"Invit\xe9","ShipSettingsView_user_status_undefined":" ","ShipSettingsView_user_add_user":"Ajouter une personne","ShipSettingsView_add_user_with_permissions":"Ajouter une personne avec des autorisations pour LOGBOOK","ShipSettingsView_add_user_without_permissions":"Ajouter une personne sans autorisations","ShipSettingsView_users_with_level":"Utilisateurs du navire avec des autorisations pour LOGBOOK","ShipSettingsView_users_without_level":"Personnes sans autorisations","ShipContentView":"","ShipContentView_back":"Retour","ShipDataView":"","ShipDataView_blank":"  ","ShipDataView_":"*Choisir*","ShipDataView_add":"Ajouter","ShipDataView_ship_data":"Donn\xe9es du navire","ShipDataView_file_field_drag_drop":"Ins\xe9rez ici les photos de votre navire.","ShipDataView_general":"Donn\xe9es g\xe9n\xe9rales du navire","ShipDataView_choose":"*Choisir ou entrer* ","ShipDataView_other":"Entrer autre","ShipDataView_tab_general":"G\xe9n\xe9ral","ShipDataView_tab_details":"D\xe9tails","ShipDataView_tab_technic":"Technique","ShipDataView_tab_sailing":"Navigation \xe0 voile","ShipDataView_tab_equipment":"\xc9quipement","ShipDataView_tab_ship_user":"Toutes les personnes","ShipDataView_tab_units":"Unit\xe9s","ShipDataView_callsign":"Indicatif","ShipDataView_imo":"IMO","ShipDataView_mmsi":"MMSI","ShipDataView_name":"Nom","ShipDataView_reg_number":"Num\xe9ro d\'immatriculation","ShipDataView_hin":"HIN","ShipDataView_flag":"Pavillon","ShipDataView_home_port":"Port d\'attache","ShipDataView_yacht_club":"Club nautique","ShipDataView_yacht_club_address":"Adresse","ShipDataView_model_name":"Nom du mod\xe8le","ShipDataView_year":"Ann\xe9e","ShipDataView_yachtbuilder":"Constructeur","ShipDataView_designer":"Architecte","ShipDataView_construction":"Construction g\xe9n\xe9rale","ShipDataView_build_number":"Num\xe9ro de construction","ShipDataView_cel":"Cat\xe9gorie CEL","ShipDataView_cel_persons":"pour personnes","ShipDataView_ship_foto":"Photo du navire","ShipDataView_inside":"Espace de vie","ShipDataView_berth_no":"Nb total de couchettes","ShipDataView_berth_single_no":"Nb de couchettes simples","ShipDataView_berth_double_no":"Nb de couchettes doubles","ShipDataView_berth_extra_no":"Nb de couchettes suppl\xe9mentaires","ShipDataView_cabins_no":"Nb de cabines","ShipDataView_bath_no":"Nb de salles de bain","ShipDataView_saloon":"Salon","ShipDataView_pantry":"Cuisine","ShipDataView_cabins":"Cabines","ShipDataView_cockpit":"Cockpit","ShipDataView_owner":"Propri\xe9taire","ShipDataView_owner_name":"Nom","ShipDataView_owner_address":"Adresse","ShipDataView_owner_phone":"T\xe9l\xe9phone","ShipDataView_owner_email":"E-mail","ShipDataView_shape":"Forme","ShipDataView_monohull":"Monocoque","ShipDataView_catamaran":"Catamaran","ShipDataView_trimaran":"Trimaran","ShipDataView_sailing-sloop":"Voilier sloop","ShipDataView_sailing-ketch":"Voilier ketch","ShipDataView_sailing-classic":"Voilier classique","ShipDataView_sailing-cat":"Voilier catamaran","ShipDataView_sailing-tri":"Voilier trimaran","ShipDataView_sailing-longkeeler":"Voilier longue quille","ShipDataView_motor-boat":"Bateau \xe0 moteur","ShipDataView_motor-cat":"Catamaran \xe0 moteur","ShipDataView_motor-tri":"Trimaran \xe0 moteur","ShipDataView_motor-yacht":"Yacht \xe0 moteur","ShipDataView_motor-superyacht":"Superyacht \xe0 moteur","ShipDataView_special_features":"Caract\xe9ristiques sp\xe9ciales","ShipDataView_vessel_type":"Type de navire","ShipDataView_dimensions":"Dimensions","ShipDataView_height":"A : Hauteur","ShipDataView_draft":"B : Tirant d\'eau","ShipDataView_length_waterline":"C : Longueur \xe0 la flottaison","ShipDataView_length_hull":"D : Longueur de coque","ShipDataView_length":"E : Longueur hors tout","ShipDataView_beam":"Largeur","ShipDataView_hull_material":"Mat\xe9riau de la coque","ShipDataView_hull_color":"Couleur de la coque","ShipDataView_masts_no":"Nombre de m\xe2ts","ShipDataView_rig":"Forme du gr\xe9ement","ShipDataView_sail_area_total":"Surface de voilure","ShipDataView_comment":"Commentaire","ShipDataView_displacement":"D\xe9placement","ShipDataView_keel_weight":"Poids de la quille","ShipDataView_keel_material":"Mat\xe9riau de la quille","ShipDataView_ballast_percentage":"Pourcentage de ballast","ShipDataView_keel_shape":"Forme de la quille","ShipDataView_keel_weight_percent":"Poids de la quille %","ShipDataView_mast_rig":"M\xe2t, gr\xe9ement et \xe9quipement de pont","ShipDataView_rig_elements":"\xc9l\xe9ments du gr\xe9ement","ShipDataView_rig_element":"\xc9l\xe9ment du gr\xe9ement","ShipDataView_rig_mast":"M\xe2t","ShipDataView_rig_main_mast":"Grand m\xe2t","ShipDataView_rig_stay":"\xc9tai de fl\xe8che","ShipDataView_rig_mizzen_mast":"M\xe2t d\'artimon","ShipDataView_rig_forestay":"\xc9tai avant","ShipDataView_rig_jib_stay":"\xc9tai de foc","ShipDataView_rig_backstay":"Pataras","ShipDataView_rig_runner":"Pataras mobile","ShipDataView_rig_baby_stay":"Baby stay","ShipDataView_rig_kicker":"Hale-bas","ShipDataView_rig_vang":"Vang","ShipDataView_rig_winch":"Winch","ShipDataView_rig_":"*Choisir ou entrer* ","ShipDataView_rig_null":"*Choisir ou entrer* ","ShipDataView_unit_m":"m","ShipDataView_unit_cm":"cm","ShipDataView_unit_inch":"pouce","ShipDataView_unit_foot":"pied","ShipDataView_unit_yard":"yard","ShipDataView_unit_nm":"nm","ShipDataView_unit_m2":"m\xb2","ShipDataView_unit_square_foot":"sqft","ShipDataView_unit_square_yard":"sqyd","ShipDataView_unit_pound":"lb","ShipDataView_unit_kg":"kg","ShipDataView_unit_tons":"to","ShipDataView_unit_knots":"kn","ShipDataView_unit_m_per_second":"m/s","ShipDataView_unit_km_per_hour":"km/h","ShipDataView_unit_kWh":"kWh","ShipDataView_unit_kw":"kW","ShipDataView_unit_hp":"hp","ShipDataView_unit_l":"l","ShipDataView_unit_gal":"gal","ShipDataView_unit_liter":"l","ShipDataView_unit_gallon":"gal","ShipDataView_unit_celsius":"\xb0C","ShipDataView_unit_fahrenheit":"\xb0F","ShipDataView_other_equipment":"Autre \xe9quipement","ShipDataView_other_equipment_text":"Entrez ici tout autre \xe9quipement du navire qui n\'a pas pu \xeatre saisi dans les autres zones, comme les informations sur l\'annexe, etc.","ShipDataView_add_engine":"Ajouter un moteur","ShipDataView_add_generator":"Ajouter un g\xe9n\xe9rateur","ShipDataView_add_sail":"Ajouter une voile","ShipDataView_add_insurance":"Ajouter une assurance","ShipDataView_add_anchor":"Ajouter une ancre","ShipDataView_add_tank":"Ajouter un r\xe9servoir","ShipDataView_add_steeringsystem":"Ajouter un syst\xe8me de direction","ShipDataView_add_other_equipment":"Ajouter un autre \xe9quipement","ShipDataView_add_rig":"Ajouter un \xe9quipement de gr\xe9ement","ShipDataView_nautical_add_device":"Ajouter un appareil","ShipDataView_safety_add_device":"Ajouter un \xe9quipement","ShipDataView_electric_add_device":"Ajouter un appareil","ShipDataView_insurance":"Assurance","ShipDataView_insurances":"Assurances","ShipDataView_insurance_":"*Choisir ou entrer* ","ShipDataView_insurance_null":"*Choisir ou entrer* ","ShipDataView_insurance_undefined":"*Choisir ou entrer* ","ShipDataView_insurance_company":"Compagnie d\'assurance","ShipDataView_insurance_number":"Num\xe9ro d\'assurance","ShipDataView_insurance_type":"Type d\'assurance","ShipDataView_insurance_hull":"Coque","ShipDataView_insurance_liability":"Responsabilit\xe9 civile","ShipDataView_insurance_accident":"Accident","ShipDataView_engines":"Moteurs","ShipDataView_engine":"Moteur","ShipDataView_engine#":"N\xb0","ShipDataView_engine_nmea_number":"NMEA","ShipDataView_engine_short_name":"Nom (max. 10 car.)","ShipDataView_engine_":"*Choisir ou entrer* ","ShipDataView_engine_undefined":"*Choisir ou entrer* ","ShipDataView_engine_null":"*Choisir ou entrer* ","ShipDataView_engine_outboard":"Hors-bord","ShipDataView_engine_saildrive":"Saildrive","ShipDataView_engine_shaftdrive":"Arbre d\'h\xe9lice","ShipDataView_engine_z_drive":"Z-drive","ShipDataView_engine_pod_drive":"Pod drive","ShipDataView_engine_jet_drive":"Jet drive","ShipDataView_generator_":"*Choisir ou entrer* ","ShipDataView_generator_undefined":"*Choisir ou entrer* ","ShipDataView_generator_null":"*Choisir ou entrer* ","ShipDataView_generator":"G\xe9n\xe9rateur","ShipDataView_generators":"G\xe9n\xe9rateurs","ShipDataView_generator_power_generator":"G\xe9n\xe9rateur \xe9lectrique","ShipDataView_generator_warm_water":"Eau chaude","ShipDataView_generator_watermaker":"Dessalinisateur","ShipDataView_generator_heating":"Chauffage","ShipDataView_generator_air_conditioning":"Climatisation","ShipDataView_fuel_":"*Choisir ou entrer* ","ShipDataView_fuel_null":"*Choisir ou entrer* ","ShipDataView_fuel_undefined":"*Choisir ou entrer* ","ShipDataView_fuel_type":"Carburant","ShipDataView_fuel_diesel":"Diesel","ShipDataView_fuel_petrol":"Essence","ShipDataView_fuel_gas":"Gaz","ShipDataView_fuel_electricity":"\xc9lectricit\xe9","ShipDataView_drive_type_engine_null":"*Choisir ou entrer* ","ShipDataView_number":"Num\xe9ro","ShipDataView_manufacturer":"Fabricant","ShipDataView_model":"Mod\xe8le","ShipDataView_serial_number":"Num\xe9ro de s\xe9rie","ShipDataView_power":"Puissance","ShipDataView_drive_type":"Type de propulsion","ShipDataView_propeller_type":"Type d\'h\xe9lice","ShipDataView_steering_null":"*Choisir ou entrer* ","ShipDataView_steering_systems":"Syst\xe8mes de direction","ShipDataView_steering_system_main":"Syst\xe8me de direction principal","ShipDataView_steering_":"*Choisir ou entrer* ","ShipDataView_steering_type":"Type de direction","ShipDataView_rudder_no":"Nombre de safrans","ShipDataView_rudder_shape":"Forme","ShipDataView_rudder_drive":"Commande de safran","ShipDataView_steering_bow_thruster":"Propulseur d\'\xe9trave","ShipDataView_steering_stern_thruster":"Propulseur de poupe","ShipDataView_steering_self_steering":"R\xe9gulateur d\'allure","ShipDataView_steering_windvane":"Girouette","ShipDataView_steering_trimtab":"Trim-tab","ShipDataView_steering_autopilot":"Pilote automatique","ShipDataView_tanks":"R\xe9servoirs","ShipDataView_tanks_unit":"r\xe9servoirs : \u2211 ","ShipDataView_tank":"Type de r\xe9servoir","ShipDataView_tank_":"*Choisir ou entrer* ","ShipDataView_tank_undefined":"*Choisir ou entrer* ","ShipDataView_tank_null":"*Choisir ou entrer* ","ShipDataView_tank_fuel":"Carburant","ShipDataView_tank_water":"Eau douce","ShipDataView_tank_gray":"Eaux grises","ShipDataView_tank_waste":"Eaux us\xe9es","ShipDataView_tank_gas":"Gaz","ShipDataView_tank_fuel_daytank":"R\xe9servoir journalier de carburant","ShipDataView_tank_size":"Capacit\xe9","ShipDataView_tank_comment":"Commentaire","ShipDataView_no":"nombre","ShipDataView_tank_fuel_no":"Carburant : nbre | \u2211 capacit\xe9","ShipDataView_tank_water_no":"Eau douce : nbre | \u2211 capacit\xe9","ShipDataView_tank_gray_no":"Eaux grises : nbre | \u2211 capacit\xe9","ShipDataView_tank_waste_no":"Eaux us\xe9es : nbre | \u2211 capacit\xe9","ShipDataView_tank_gas_no":"Gaz : nbre | \u2211 capacit\xe9","ShipDataView_anchors":"Ancres","ShipDataView_anchor_type":"Type d\'ancre","ShipDataView_anchor_":"*Choisir ou entrer* ","ShipDataView_anchor_null":"*Choisir ou entrer* ","ShipDataView_anchor_weight":"Poids","ShipDataView_anchor_location":"Lieu d\'installation","ShipDataView_bow":"proue","ShipDataView_stern":"poupe","ShipDataView_variable":"variable","ShipDataView_anchor_chain":"Longueur et type de cha\xeene","ShipDataView_anchor_chain_lead":"Guidage de cha\xeene","ShipDataView_anchor_windlass":"Guindeau","ShipDataView_anchor_windless_drive":"Propulsion","ShipDataView_anchor_windless_manfacturer":"Fabricant","ShipDataView_anchor_spade":"Ancre Spade","ShipDataView_anchor_fishermans":"Ancre de marine","ShipDataView_anchor_plough":"Ancre CQR/charrue","ShipDataView_anchor_danforth":"Ancre Danforth","ShipDataView_anchor_rollerbar":"Ancre \xe0 barre rotative","ShipDataView_manual":"manuel","ShipDataView_electric":"\xe9lectrique","ShipDataView_watermaker":"Dessalinisateur","ShipDataView_batteries":"Batteries","ShipDataView_batterie":"Batterie","ShipDataView_capacity":"Capacit\xe9","ShipDataView_electrics":"\xc9lectricit\xe9","ShipDataView_date_purchase":"Date d\'achat","ShipDataView_charger":"Chargeur","ShipDataView_inverter":"Onduleur","ShipDataView_hot_water_boiler":"Chauffe-eau","ShipDataView_size":"Taille","ShipDataView_size_height":"Taille/hauteur","ShipDataView_place_installation":"Lieu d\'installation","ShipDataView_date_installation":"Date d\'installation","ShipDataView_devices":"Appareils","ShipDataView_device":"Appareil","ShipDataView_sails":"Voiles","ShipDataView_sail":"Voile","ShipDataView_sail_":"*Choisir ou entrer* ","ShipDataView_sail_null":"*Choisir ou entrer* ","ShipDataView_sail_size":"Taille","ShipDataView_sail_type":"\xc9tablie sur","ShipDataView_sail_reefs_no":"Nombre de ris","ShipDataView_sail_mast":"M\xe2t","ShipDataView_sail_forestay":"\xc9tai avant","ShipDataView_sail_mizzen":"Artimon","ShipDataView_sail_mainsail":"Grand-voile","ShipDataView_sail_spinnaker":"Spinnaker","ShipDataView_sail_genoa":"G\xe9nois","ShipDataView_sail_jib":"Foc","ShipDataView_sail_working_jib":"Foc de travail","ShipDataView_sail_strom_jib":"Tourmenin","ShipDataView_sail_mizzen_staysail":"Voile d\'\xe9tai d\'artimon","ShipDataView_sail_code0":"Code 0","ShipDataView_sail_gennaker":"Gennaker","ShipDataView_sail_try":"Voile de cape","ShipDataView_sail_storm_jib":"Tourmenin","ShipDataView_sail_parasailor":"Parasailor","ShipDataView_sail_0":"Aucun","ShipDataView_sail_1":"1","ShipDataView_sail_2":"2","ShipDataView_sail_3":"3","ShipDataView_sail_reef_1":"Ris 1","ShipDataView_sail_reef_2":"Ris 2","ShipDataView_sail_reef_3":"Ris 3","ShipDataView_sail_reef":"{sail} - {reef}","ShipDataView_device_":"*Choisir ou entrer* ","ShipDataView_device_undefined":"*Choisir ou entrer* ","ShipDataView_device_nautical_":"*Choisir ou entrer* ","ShipDataView_device_electric_":"*Choisir ou entrer* ","ShipDataView_device_safety_":"*Choisir ou entrer* ","ShipDataView_device_nautical_null":"*Choisir ou entrer* ","ShipDataView_device_electric_null":"*Choisir ou entrer* ","ShipDataView_device_safety_null":"*Choisir ou entrer* ","ShipDataView_nautical_equipment":"\xc9quipement nautique","ShipDataView_safety_equipment":"\xc9quipement de s\xe9curit\xe9","ShipDataView_electric_equipment":"\xc9quipement \xe9lectrique","ShipDataView_device_nautical_analogue_compass":"Compas analogique","ShipDataView_device_nautical_gyro_compass":"Compas gyroscopique","ShipDataView_device_nautical_fluxgate_compass":"Compas fluxgate","ShipDataView_device_nautical_satellite_compass":"Compas satellite","ShipDataView_device_nautical_chart_plotter":"Traceur de cartes","ShipDataView_device_nautical_gps":"GPS","ShipDataView_device_nautical_ais":"Transpondeur AIS","ShipDataView_device_nautical_radio":"Radio","ShipDataView_device_nautical_antenna":"Antenne","ShipDataView_device_nautical_radar":"Radar","ShipDataView_device_nautical_wind_gauge":"An\xe9mom\xe8tre","ShipDataView_device_nautical_autopilot":"Pilote automatique","ShipDataView_device_nautical_display_instruments":"Instruments d\'affichage","ShipDataView_device_nautical_fuel_gauge":"Jauge de carburant","ShipDataView_device_nautical_battery_controller":"Contr\xf4leur de batterie","ShipDataView_device_nautical_hour_meter":"Compte-heures","ShipDataView_device_nautical_tachometer":"Tachym\xe8tre","ShipDataView_device_nautical_logger":"Loch","ShipDataView_device_nautical_sounder":"Sondeur","ShipDataView_device_nautical_air_temperature":"Temp\xe9rature de l\'air","ShipDataView_device_nautical_barometer":"Barom\xe8tre","ShipDataView_device_nautical_humidity":"Humidit\xe9","ShipDataView_device_nautical_weather_receiver":"R\xe9cepteur m\xe9t\xe9o","ShipDataView_device_nautical_nmea_gateway":"Passerelle NMEA","ShipDataView_device_nautical_nmea_motor_adapter":"Adaptateur moteur NMEA","ShipDataView_device_electric_battery":"Batterie","ShipDataView_device_electric_inverter":"Onduleur","ShipDataView_device_electric_charger":"Chargeur","ShipDataView_device_electric_solar_panel":"Panneau solaire","ShipDataView_device_electric_wind_generator":"\xc9olienne","ShipDataView_device_electric_watermaker":"Dessalinisateur","ShipDataView_device_safety_fire_extinguisher":"Extincteur","ShipDataView_device_safety_liferaft":"Radeau de sauvetage","ShipDataView_device_safety_lifejacket":"Gilet de sauvetage","ShipDataView_device_safety_lifebelt":"Bou\xe9e de sauvetage","ShipDataView_device_safety_lifeline":"Ligne de vie","ShipDataView_device_safety_spare_propeller":"H\xe9lice de rechange","ShipDataView_device_safety_emergency_tiller":"Barre de secours","ShipDataView_device_safety_bilge_pump_manual":"Pompe de cale manuelle","ShipDataView_device_safety_bilge_pump_electric":"Pompe de cale \xe9lectrique","ShipDataView_device_safety_shroud_cutter":"Coupe-haubans","ShipDataView_device_safety_radar_reflector":"R\xe9flecteur radar","ShipDataView_device_safety_first_aid":"Premiers secours","ShipDataView_device_safety_fire_blanket":"Couverture anti-feu","ShipDataView_device_safety_dinghy":"Annexe","ShipDataView_device_safety_dinghy_motor":"Moteur pour annexe","ShipDataView_device_safety_handheld_radio":"Radio portable","ShipDataView_device_safety_epirb":"Balise de d\xe9tresse EPIRB","ShipDataView_all_users":"Toutes les personnes pour l\'\xe9quipage, etc.","ShipEditView":"","ShipEditView_name":"Nom du navire","ShipEditView_name_min":"Nom du navire (min 3 caract\xe8res)","ShipEditView_title_edit":"Donn\xe9es du navire pour {ship}","ShipEditView_title_new":"Cr\xe9er un nouveau navire","ShipEditView_type":"Type de navire","ShipEditView_type_motor":"Navire \xe0 moteur","ShipEditView_type_sailing":"Voilier","ShipEditView_engines":"Nombre de moteurs","ShipEditView_generators":"Nombre de g\xe9n\xe9rateurs","ShipEditView_create":"Cr\xe9er un navire","ShipEditView_cancel":"Annuler","ShipEditView_choose":"Choisir","ShipEditView_print":"Imprimer les donn\xe9es du navire","ShipSelectView":"","ShipSelectView_companion":"C","ShipSelectView_view_logbook":"Voir","ShipSelectView_selecting":"S\xe9lection en cours...","ShipSelectView_options":"Options","ShipSelectView_nearby":"Trouv\xe9 sur votre r\xe9seau","ShipSelectView_nearby_hint":"Ce navire est annonc\xe9 sur votre r\xe9seau actuel.","ShipSelectView_unavailable_no_permission":"Vous n\'avez pas l\'autorisation d\'ouvrir ce navire comme LOGBOOK Primary.","ShipSelectView_unavailable_import_in_progress":"Un import est encore en cours pour ce navire.","ShipSyncStatusView":"","ShipSyncStatusView_close":"Fermer","ShipSyncStatusView_retry":"R\xe9essayer","ShipSyncStatusView_title":"Synchronisation avec LOGBOOK Cloud","ShipUserSelect":"","ShipUserSelect_add_user":"Ajouter une personne","ShipUserSelect_dialog_add_new_user":"Ajouter une nouvelle personne","ShipUserSelect_dialog_add_user":"Ajouter une nouvelle personne","ShipUserSelect_dialog_add_user_name":"Nom","ShipUserSelect_dialog_add_user_shortname":"Nom court","ShipUserSelect_dialog_cancel":"Annuler","ShipUserSelect_loading":"Chargement\u2026","ShipUserSelect_no_users":"Aucune personne disponible","ShipUserSelect_select_additional_user":"+","ShipUserSelect_select_user":"S\xe9lectionner","ShipView":"","ShipView_add_cruise":"Voyage","ShipView_add_ship":"Navire","ShipView_empty_select":"S\xe9lectionnez d\'abord un navire.","ShipView_import_trips_title":"Importer les anciens trajets depuis LogbookSuite","ShipView_import_trips_choose":"Choisir un fichier","ShipView_import_trips_cancel":"Annuler","ShipView_menu_action_title":"Nouveau","ShipView_menu_NMEA":"NMEA","ShipView_menu_now":"Focus","ShipView_menu_search":"Rechercher","ShipView_nmea_recording_disconnected":"NMEA d\xe9connect\xe9","ShipView_nmea_recording_error":"Erreur d\'enregistrement NMEA :","ShipView_nmea_recording_error_disconnected":"Erreur d\'enregistrement NMEA : NMEA non connect\xe9","ShipView_overlay_dismiss":"OK","ShipView_overlay_missing_cruise":"Impossible de d\xe9marrer l\'enregistrement sans un trajet et un voyage actifs. Cr\xe9ez d\'abord un voyage.","ShipView_overlay_missing_trip":"Impossible de d\xe9marrer l\'enregistrement sans un trajet actif. Cr\xe9ez d\'abord un trajet.","ShipView_ship_data":"Donn\xe9es du navire","ShipView_ship_settings":"Param\xe8tres","ShipView_sync_initialSyncInProgress":"Synchronisation initiale en cours","ShipView_sync_settings":"Param\xe8tres","ShipView_sync_uninitialized":"Pr\xe9paration de la synchronisation","ShipView_resync_cancel":"Annuler","ShipView_resync_confirm_cancel":"Retour","ShipView_resync_confirm_execute":"Confirmer","ShipView_resync_title":"R\xe9initialiser la connexion d\xe9connect\xe9e","ShipView_resync_reset_local":"Utiliser les donn\xe9es locales","ShipView_resync_reset_cloud":"Utiliser les donn\xe9es du Cloud","ShipView_resync_last_sync":"Derni\xe8re synchronisation de cet appareil","ShipView_resync_cloud_updated":"Derni\xe8re mise \xe0 jour du LOGBOOK Cloud","ShipView_resync_status_failed":"Le LOGBOOK Cloud n\'a pas pu \xeatre contact\xe9, l\'\xe9tat de la connexion est donc inconnu. V\xe9rifiez votre connexion Internet et r\xe9essayez.","ShipView_resync_permission_required":"Votre compte cloud ne dispose plus de l\'autorisation Primary pour ce navire. La synchronisation et la r\xe9cup\xe9ration n\xe9cessitent cette autorisation. Demandez au propri\xe9taire du navire de la r\xe9tablir, puis r\xe9essayez la synchronisation. Gardez le navire ouvert pour pr\xe9server les modifications locales non synchronis\xe9es ; fermer la connexion cloud ne r\xe9tablit pas l\'autorisation.","ShipView_resync_claimed_here":"Le LOGBOOK Cloud reconna\xeet toujours cet appareil comme Primary. Une r\xe9initialisation est impossible tant que cette connexion est active. R\xe9essayez d\'abord la synchronisation. Si une r\xe9initialisation reste n\xe9cessaire, fermez le navire dans le LOGBOOK Cloud, puis rouvrez cette fen\xeatre et choisissez les donn\xe9es \xe0 conserver. Gardez le navire ouvert dans cette application jusqu\'\xe0 la fin de la r\xe9cup\xe9ration pour pr\xe9server les modifications locales non synchronis\xe9es.","ShipView_resync_reset_failed":"La connexion n\'a pas pu \xeatre r\xe9tablie. Veuillez r\xe9essayer.","ShipView_resync_reset_claimed":"Le cloud a refus\xe9 la r\xe9cup\xe9ration. Votre autorisation ou la connexion du navire a peut-\xeatre chang\xe9. Revenez en arri\xe8re pour v\xe9rifier l\'\xe9tat actuel avant de r\xe9essayer.","ShipView_read_more":"En savoir plus","StatsView":"","StatsView_days_run":"Distance du jour","StatsView_distance_total":"Distance totale","StatsView_distance_under_engine":"Distance au moteur","StatsView_distance_under_engine_name":"{name}","StatsView_distance_under_sails":"Distance \xe0 la voile","StatsView_duration_under_engine":"Temps au moteur","StatsView_duration_under_engine_name":"{name}","StatsView_duration_under_sails":"Temps \xe0 la voile","StatsView_speed":"Vitesse moyenne","StatsView_time_total":"Temps total","StatsView_time_total_paused_cruising":"Temps : Total | Pause | Navigation","StatsView_update":"Recalculer","TrackView":"","TrackView_no_track":"Aucune trace disponible","TripEditView":"","TripEditView_cancel":"Annuler","TripEditView_current_time":"Heure actuelle","TripEditView_dialog_title":"Cr\xe9er un trajet","TripEditView_start":"Commencer le trajet","TripEditView_timezone":"Fuseau horaire","TripEditView_title":"Nom du trajet","TripView":"","TripView_tab_crew":"\xc9quipage","TripView_tab_stats":"Statistiques","TripView_tab_track":"Trace","TripView_tab_trip":"Trajet","TripView_tab_weather":"M\xe9t\xe9o","TripView_tab_print":"Imprimer","TripView_untitled_trip":"Trajet sans titre","TripView_print_all":"Imprimer tous les trajets de ce voyage","TripView_print_trip":"Imprimer ce trajet","UserAdviceAlertView":"","UserAdviceAlertView_alert_acknowledged":"Acquitt\xe9e","UserAdviceAlertView_alert_alarm":"Alarme","UserAdviceAlertView_alert_anchorDrift":"D\xe9rive du mouillage","UserAdviceAlertView_alert_anchorDrift_short":"D\xe9rive","UserAdviceAlertView_alert_default":"Statut inconnu","UserAdviceAlertView_alert_depth":"Profondeur","UserAdviceAlertView_alert_depth_short":"Profondeur","UserAdviceAlertView_alert_ignored":"Ignor\xe9e","UserAdviceAlertView_alert_lostPosition":"Position perdue","UserAdviceAlertView_alert_lostPosition_short":"Position","UserAdviceAlertView_alert_message":"Message","UserAdviceAlertView_alert_message_short":"Message","UserAdviceAlertView_alert_ok":"OK","UserAdviceAlertView_alert_pressure":"Pression","UserAdviceAlertView_alert_pressure_short":"Pression","UserAdviceAlertView_alert_resolved":"R\xe9solue","UserAdviceAlertView_alert_test":"Test","UserAdviceAlertView_alert_test_short":"Test","UserAdviceAlertView_alert_warning":"Avertissement","UserAdviceAlertView_alert_wind":"Vent","UserAdviceAlertView_alert_wind_short":"Vent","UserAdviceAlertView_alert_lights":"Signaux visuels","UserAdviceAlertView_alert_lights_short":"Feux","UserAdviceAlertView_alert_manOverboard":"Homme \xe0 la mer","UserAdviceAlertView_alert_manOverboard_short":"MOB","UserAdviceAlertView_state_snoozed":"En veille","UserAdviceAlertView_state_acknowledged":"Acquitt\xe9e","UserAdviceAlertView_state_audible":"Sonore","UserAdviceAlertView_close":"Fermer","UserAdviceAlertView_record":"J\u2019ai r\xe9gl\xe9 {lighting}","UserAdviceAlertView_cancel":"Annuler","UserAdviceAlertView_settings":"R\xe9glages","UserAdviceAlertView_submit":"D\xe9finir le statut : {state}","UserAdviceAlertView_submit_none":"Choisissez une action","UserAdviceAlertView_state_snooze":"Report\xe9","UserAdviceAlertView_state_acknowledge":"Acquitt\xe9","UserAdviceAlertView_state_clear":"Effac\xe9","UserAdviceAlertView_state_record":"Enregistr\xe9","UserAdviceAlertView_explain_snooze":"Met l\'alerte en sourdine quelques minutes. Elle reste ouverte et revient si la situation persiste.","UserAdviceAlertView_explain_acknowledge":"Marque l\'alerte comme vue et coupe le son. Elle reste ouverte jusqu\'\xe0 ce que la situation se r\xe9solve.","UserAdviceAlertView_explain_clear":"Ferme l\'alerte. \xc0 utiliser une fois la situation r\xe9ellement trait\xe9e.","UserAdviceAlertView_explain_record":"Enregistre les feux recommand\xe9s dans le journal. Le rappel se ferme de lui-m\xeame d\xe8s que les feux correspondent.","UserAdviceAlertView_clear_denied":"Seul le skipper ou l\'\xe9quipage de quart peut effacer cette alerte.","UserAdviceAlertView_clear_confirm_message":"Cela ferme l\'alerte pour tout l\'\xe9quipage, que la situation persiste ou non. \xc0 n\'effacer qu\'une fois qu\'elle a r\xe9ellement \xe9t\xe9 trait\xe9e.","UserAdviceAlertView_clear_confirm":"Effacer l\'alerte","UserAdviceAlertView_clear_confirm_cancel":"Retour","UserAdviceAlertView_escalate":"Escalader au skipper","UserAdviceAlertView_state_escalate":"Escalad\xe9 au skipper","UserAdviceAlertView_explain_escalate":"Alerte le skipper imm\xe9diatement au lieu d\'attendre l\'escalade automatique. Cela annule aussi un acquittement ou un report, afin que l\'alarme lui parvienne.","UserAdviceAlertView_skip":"Ignorer","UserAdviceAlertView_acknowledge":"Acquitter","UserAdviceAlertView_clear":"Effacer","UserAdviceAlertView_snooze":"Reporter","UserAdviceAlertView_title":"Alerte {name} - {level}","UserAdviceAlertView_error":"L\'action n\'a pas pu \xeatre effectu\xe9e. Veuillez r\xe9essayer.","UserAdviceAlertView_read_more":"En savoir plus","UserAdviceAnchorMonitorView":"","UserAdviceAnchorMonitorView_cancel":"Annuler","UserAdviceAnchorMonitorView_disable":"D\xe9sactiver","UserAdviceAnchorMonitorView_enable":"Activer l\'alarme","UserAdviceAnchorMonitorView_title_inactive":"Alarme de mouillage d\xe9sactiv\xe9e","UserAdviceAnchorMonitorView_title_active":"Alarme de mouillage activ\xe9e","UserAdviceAnchorMonitorView_title_short":"Mouillage","UserAdviceAnchorMonitorView_method":"M\xe9thode","UserAdviceAnchorMonitorView_method_fixedRadius":"Rayon fixe","UserAdviceAnchorMonitorView_method_rodeScope":"Mouillage / tou\xe9e","UserAdviceAnchorMonitorView_method_sector":"Secteur d\'\xe9vitage","UserAdviceAnchorMonitorView_warning":"Avertissement","UserAdviceAnchorMonitorView_alarm":"Alarme","UserAdviceAnchorMonitorView_rode":"Mouillage","UserAdviceAnchorMonitorView_depth":"Profondeur","UserAdviceAnchorMonitorView_boatLength":"Longueur du bateau","UserAdviceAnchorMonitorView_bearingFrom":"Du rel\xe8vement","UserAdviceAnchorMonitorView_bearingTo":"Au rel\xe8vement","UserAdviceAnchorMonitorView_recenter":"Recentrer","UserAdviceAnchorMonitorView_save":"Enregistrer","UserAdviceAnchorMonitorView_snooze":"Reporter","UserAdviceAnchorMonitorView_acknowledge":"Acquitter","UserAdviceAnchorMonitorView_clear":"Effacer","UserAdviceAnchorMonitorView_keepAlive":"Alerter en arri\xe8re-plan","UserAdviceAnchorMonitorView_depthWarning":"Avertissement de profondeur","UserAdviceAnchorMonitorView_depthAlarm":"Alarme de profondeur","UserAdviceAnchorMonitorView_error":"L\'alarme de mouillage n\'a pas pu \xeatre mise \xe0 jour. Veuillez r\xe9essayer.","UserAdviceAnchorMonitorView_error_noPosition":"L\'alarme de mouillage a besoin de la position actuelle comme centre, et aucune position n\'est disponible pour le moment. Connectez une source GPS NMEA (ou activez le GPS de l\'appareil) puis r\xe9essayez.","UserAdviceAnchorMonitorView_error_gpsPrecision":"La position actuelle n\'est pas assez pr\xe9cise pour l\'alarme de mouillage. Elle n\xe9cessite une source GPS de haute pr\xe9cision ; le GPS de l\'appareil seul est trop impr\xe9cis pour mesurer le cercle d\'\xe9vitage.","UserAdviceAnchorMonitorView_error_noDay":"L\'alarme de mouillage ne peut d\xe9marrer qu\'une fois la journ\xe9e commenc\xe9e et une premi\xe8re position enregistr\xe9e. Vos r\xe9glages ont \xe9t\xe9 enregistr\xe9s ; relancez l\'alarme de mouillage d\xe8s que le journal enregistre.","UserAdviceAnchorMonitorView_read_more":"En savoir plus","UserAdviceEngineMissingView":"","UserAdviceEngineMissingView_title_short":"Moteur ?","UserAdviceEngineMissingView_title_castOff":"Entr\xe9e moteur manquante ?","UserAdviceEngineMissingView_title_anchorUp":"Entr\xe9e moteur manquante ?","UserAdviceEngineMissingView_title_motorVessel":"Entr\xe9e moteur manquante ?","UserAdviceEngineMissingView_text_castOff":"Vous avez appareill\xe9 sans moteur enregistr\xe9. Le moteur tournait-il ?","UserAdviceEngineMissingView_text_anchorUp":"Vous avez appareill\xe9 sans moteur enregistr\xe9. Le moteur tournait-il ?","UserAdviceEngineMissingView_text_motorVessel":"Le navire fait route sans moteur enregistr\xe9. Le moteur tournait-il ?","UserAdviceEngineMissingView_all_engines":"Tous les moteurs","UserAdviceEngineMissingView_since_trigger":"Depuis {time}","UserAdviceEngineMissingView_since_now":"\xc0 partir de maintenant","UserAdviceEngineMissingView_started":"Le moteur tournait","UserAdviceEngineMissingView_sailing":"Non, nous naviguons \xe0 la voile","UserAdviceEngineMissingView_sailing_noSails":"Aucun moteur en marche","UserAdviceEngineMissingView_cancel":"Annuler","UserAdviceDepthWatchView":"","UserAdviceDepthWatchView_cancel":"Annuler","UserAdviceDepthWatchView_disable":"D\xe9sactiver","UserAdviceDepthWatchView_enable":"Activer l\'alarme","UserAdviceDepthWatchView_title_inactive":"Alarme de profondeur d\xe9sactiv\xe9e","UserAdviceDepthWatchView_title_active":"Alarme de profondeur activ\xe9e","UserAdviceDepthWatchView_title_short":"Profondeur","UserAdviceDepthWatchView_snooze":"Reporter","UserAdviceDepthWatchView_acknowledge":"Acquitter","UserAdviceDepthWatchView_clear":"Effacer","UserAdviceDepthWatchView_text":"Mettre \xe0 jour les seuils d\'alerte de profondeur du navire, utilis\xe9s par chaque surveillance de profondeur.","UserAdviceDepthWatchView_save":"Enregistrer","UserAdviceDepthWatchView_save_error":"Les r\xe9glages de l\'alarme de profondeur n\'ont pas pu \xeatre enregistr\xe9s. Veuillez r\xe9essayer.","UserAdviceDepthWatchView_error":"L\'alarme de profondeur n\'a pas pu \xeatre mise \xe0 jour. Veuillez r\xe9essayer.","UserAdviceLightsReminderView":"","UserAdviceLightsReminderView_title":"Signaux visuels","UserAdviceLightsReminderView_title_active":"Rappel des signaux visuels activ\xe9","UserAdviceLightsReminderView_title_inactive":"Rappel des signaux visuels d\xe9sactiv\xe9","UserAdviceManualShipStatusView":"","UserAdviceManualShipStatusView_title_active":"Statut manuel jusqu\'\xe0 {time}","UserAdviceManualShipStatusView_title_short":"Statut manuel","UserAdviceManualShipStatusView_text":"Les changements de statut automatiques sont d\xe9sactiv\xe9s. D\xe9finissez vous-m\xeame le statut du navire dans le menu du journal \u2014 tant que ce mode est actif, aucune entr\xe9e n\'est cr\xe9\xe9e automatiquement.","UserAdviceManualShipStatusView_remaining":"Se termine \xe0 {time}, dans environ {minutes} minutes \u2014 ou au changement de jour, selon ce qui arrive en premier.","UserAdviceManualShipStatusView_extend":"Prolonger","UserAdviceManualShipStatusView_cancel":"Terminer maintenant","UserAdviceManualShipStatusView_close":"Fermer","UserAdviceManualShipStatusView_error":"Le mode statut manuel n\'a pas pu \xeatre mis \xe0 jour. Veuillez r\xe9essayer.","UserAdviceStopView":"","UserAdviceStopView_cancel":"Annuler","UserAdviceStopView_text":"Documentez l\'arr\xeat. Fin de journ\xe9e suspend l\'enregistrement automatique jusqu\'\xe0 ce que le navire reparte ; Escale le maintient actif.","UserAdviceStopView_text_fixed_status":"Ajoutez Fin de journ\xe9e ou Escale sans modifier le statut actuel du navire. Fin de journ\xe9e suspend l\'enregistrement automatique jusqu\'\xe0 ce que le navire reparte ; Escale le maintient actif.","UserAdviceStopView_end_location":"Emplacement","UserAdviceStopView_end_of_day":"Fin de journ\xe9e","UserAdviceStopView_manual_engine_entries":"\xc9galement arr\xeat\xe9 le(s) moteur(s) ?","UserAdviceStopView_manual_engine_entries_text":"L\'activation de cette option cr\xe9era \xe9galement une entr\xe9e finale pour le fonctionnement du moteur","UserAdviceStopView_final_entry":"Cr\xe9er une entr\xe9e finale","UserAdviceStopView_save":"Enregistrer","UserAdviceStopView_status_anchor":"Mouillage","UserAdviceStopView_status_buoy":"Bou\xe9e","UserAdviceStopView_status_port":"Port","UserAdviceStopView_status_drifting":"\xc0 la d\xe9rive","UserAdviceStopView_stopover":"Escale","UserAdviceStopView_status_lock":"\xc9cluse","UserAdviceStopView_status_bunkering":"Station de carburant","UserAdviceStopView_status_bridge":"Pont","UserAdviceStopView_status_waiting":"Attente","UserAdviceStopView_stop_engines":"Cr\xe9er une entr\xe9e pour le(s) moteur(s) arr\xeat\xe9(s)","UserAdviceStopView_stop_type":"Type d\'arr\xeat","UserAdviceStopView_title":"Arr\xeat\xe9","UserAdviceStopView_title_duration":"Arr\xeat\xe9 pendant {duration}","UserAdviceStopView_title_short":"Arr\xeat\xe9","UserAdviceRow_collapse":"Afficher moins","UserAdviceRow_expand":"Afficher tous les avis","UserSettingsView":"","UserSettingsView_lang_en":"English","UserSettingsView_lang_de":"Deutsch","UserSettingsView_lang_fr":"Fran\xe7ais","UserSettingsView_theme_dark":"Sombre","UserSettingsView_theme_light":"Classique","UserSettingsView_theme_night":"Nuit","UserSettingsView_theme_cloud":"Cloud","UserSettingsView_language":"Langue","UserSettingsView_theme":"Th\xe8me","UserSwitchView":"","UserSwitchView_title":"Changer d\'utilisateur","UserSwitchView_empty":"Aucun autre membre d\'\xe9quipage n\'est enregistr\xe9 pour aujourd\'hui.","Mailer_trial_started_subject":"Votre p\xe9riode d\'essai LOGBOOK a commenc\xe9","Mailer_trial_2daysleft_subject":"Votre p\xe9riode d\'essai LOGBOOK se termine bient\xf4t","Mailer_trial_expired_subject":"Votre p\xe9riode d\'essai LOGBOOK a expir\xe9","Mailer_subscription_expired_subject":"Votre abonnement LOGBOOK a expir\xe9","LogButton":"","LogButton_status":"Statut","LogButton_engines":"Moteurs","LogButton_generators":"G\xe9n\xe9rateurs","LogButton_lighting":"Feux","LogButton_lighting_none":"Aucun feu","LogButton_lighting_triColorLights":"Feu tricolore","LogButton_lighting_anchorBall":"Boule de mouillage","LogButton_lighting_anchorLight":"Feu de mouillage","LogButton_lighting_sailingRunningLights":"Feux de navigation \xe0 la voile","LogButton_lighting_motoringRunningLights":"Feux de navigation au moteur","LogButton_lighting_navigationLights":"Feux de navigation","LogButton_lighting_motoringCone":"C\xf4ne de moteur","LogButton_sails":"Voiles","LogButton_sails_confirm":"Enregistrer les voiles","LogButton_sail_group_main":"Grand-voile","LogButton_sail_group_foresail":"Voile d\'avant","LogButton_sail_group_spinnaker":"Spinnaker","LogButton_sail_group_mizzen":"Artimon","LogButton_send_alert":"Envoyer une alerte","LogButton_man_overboard":"Homme \xe0 la mer","LogButton_man_overboard_confirm_title":"Homme \xe0 la mer","LogButton_man_overboard_confirm_message":"Ceci alertera imm\xe9diatement tout l\'\xe9quipage qu\'une personne est pass\xe9e par-dessus bord. Ne confirmez que si c\'est r\xe9el.","LogButton_man_overboard_confirm":"D\xe9clencher l\'alerte","LogButton_man_overboard_cancel":"Annuler","LogButton_man_overboard_error":"Impossible de d\xe9clencher l\'alerte homme \xe0 la mer.","LogButton_manual_status":"Statut manuel","LogButton_manual_status_active":"Statut manuel activ\xe9 \u2014 d\xe9sactiver","SendAlertDialog":"","SendAlertDialog_title":"Envoyer une alerte","SendAlertDialog_users":"Membres d\'\xe9quipage","SendAlertDialog_add_user":"Ajouter un membre d\'\xe9quipage","SendAlertDialog_groups":"Groupes de quart","SendAlertDialog_add_group":"Ajouter un groupe de quart","SendAlertDialog_message":"Message","SendAlertDialog_severity":"Gravit\xe9","SendAlertDialog_severity_warning":"Avertissement","SendAlertDialog_severity_alarm":"Alarme","SendAlertDialog_loudness":"Volume","SendAlertDialog_loudness_audible":"Alarme sonore","SendAlertDialog_loudness_notificationOnly":"Notification seule","SendAlertDialog_error":"L\'alerte n\'a pas pu \xeatre envoy\xe9e. Veuillez r\xe9essayer.","SendAlertDialog_cancel":"Annuler","SendAlertDialog_send":"Envoyer","CatalogUserAdviceButton":"","CatalogUserAdviceButton_notice":"Veille d\'ancre active","CatalogUserAdviceButton_warning":"Le vent se l\xe8ve","CatalogUserAdviceButton_alarm":"Homme \xe0 la mer !","CatalogUserAdviceButton_short":"MOB","CatalogUserAdviceButton_record":"Enregistrer le feu de mouillage","CatalogUserAdviceButton_primary-action":"Signaux visuels","CatalogUserAdviceButton_primary-action-denied":"Signaux visuels","CatalogUserAdviceRow":"","CatalogUserAdviceRow_manOverboard":"Homme \xe0 la mer","CatalogUserAdviceRow_manOverboard_short":"MOB","CatalogUserAdviceRow_anchorDrift":"D\xe9rive du mouillage","CatalogUserAdviceRow_anchorDrift_short":"D\xe9rive","CatalogUserAdviceRow_depth":"Alarme de profondeur activ\xe9e","CatalogUserAdviceRow_depth_short":"Profondeur","CatalogUserAdviceRow_lostPosition":"Position perdue","CatalogUserAdviceRow_lostPosition_short":"Position","CatalogUserAdviceRow_wind":"Alerte de vent","CatalogUserAdviceRow_wind_short":"Vent","CatalogUserAdviceRow_stop":"Arr\xeat\xe9 pendant 0:12:04","CatalogUserAdviceRow_stop_short":"Arr\xeat\xe9","":""}');


function $6d103d423c562944$export$f5bf8d096973061c(template, values) {
    return template.replace(/\{([^{}]+)\}/g, function(token, key) {
        return Object.hasOwn(values, key) ? String(values[key]) : token;
    });
}
function $6d103d423c562944$export$9bdef8dfc722a565(preferred, available, fallback) {
    var _a;
    var _loop_1 = function(language) {
        var exact = available.find(function(candidate) {
            return candidate === language;
        });
        if (exact) return {
            value: exact
        };
        var base = language.split("-")[0];
        var compatible = available.find(function(candidate) {
            return candidate.split("-")[0] === base;
        });
        if (compatible) return {
            value: compatible
        };
    };
    for(var _i = 0, preferred_1 = preferred; _i < preferred_1.length; _i++){
        var language = preferred_1[_i];
        var state_1 = _loop_1(language);
        if (typeof state_1 === "object") return state_1.value;
    }
    return available.includes(fallback) ? fallback : (_a = available[0]) !== null && _a !== void 0 ? _a : fallback;
}
function $6d103d423c562944$export$5a1a8430df9521e(key, options) {
    var _a, _b, _c, _d, _e;
    var available = Object.keys(options.dictionaries);
    var language = $6d103d423c562944$export$9bdef8dfc722a565([
        options.language
    ], available, options.fallbackLanguage);
    return (_e = (_d = (_b = (_a = options.dictionaries[language]) === null || _a === void 0 ? void 0 : _a[key]) !== null && _b !== void 0 ? _b : (_c = options.dictionaries[options.fallbackLanguage]) === null || _c === void 0 ? void 0 : _c[key]) !== null && _d !== void 0 ? _d : options.missing) !== null && _e !== void 0 ? _e : key;
}


var $78b9bea2ad5f8ca1$exports = {};
$78b9bea2ad5f8ca1$exports = {
    "alert": {
        "anchorDrift": {
            "alarm": "The ship has moved **{distance}** from the anchoring position.",
            "warning": "The ship has moved **{distance}** from the anchoring position."
        },
        "depth": {
            "alarm": "The current water depth is only **{depth}**.",
            "warning": "The current water depth is only **{depth}**."
        },
        "lights": {
            "warning": "The recommended lighting is **{recommended}**, but **{recorded}** is currently recorded."
        },
        "lostPosition": {
            "disconnected": "The connection to the position source has been lost.",
            "invalidFix": "The position source reports that its GPS fix is invalid.",
            "jump": "The position source is reporting implausible positions. They are being ignored.",
            "stale": "No position fixes have been received for some time."
        },
        "manOverboard": {
            "emitterActivated": "A man-overboard emitter has been activated. Immediate all-hands response required.",
            "manualButtonActivated": "A man-overboard emitter's manual button has been activated. Immediate all-hands response required.",
            "manual": "A crew member has manually triggered a man-overboard alert. Immediate all-hands response required.",
            "unknown": "A man-overboard signal has been received. Immediate all-hands response required."
        }
    },
    "anchorMonitor": {
        "explanation": {
            "fixedRadius": "Alerts you when the ship drifts beyond a fixed distance from the anchor position, measured directly as a radius in meters.\n\nUse this method when you already know how much swing room you have \u2014 for example, in a crowded anchorage where you've judged the safe distance to neighbouring boats or the shore yourself.",
            "rodeScope": "Calculates the expected swing radius from your anchor rode length, the water depth, and your boat's length, instead of a fixed distance you enter yourself.\n\nUse this method when you want LOGBOOK to work out a sensible radius for you based on how much rode you've let out \u2014 it adapts automatically as the tide changes the depth.",
            "sector": "Watches a directional bearing sector instead of a full circle, so drift within an expected swing arc stays quiet while drift outside it triggers an alert.\n\nUse this method in a narrow channel or river anchorage, where swinging along the current is normal but drifting sideways towards a bank or another vessel is not."
        }
    },
    "changeLog": {
        "2026-09-30": 'Version 1.1 adds many new useful features to LOGBOOK\n\nNew Features\n* Manual ship status \u2013 to prevent unwanted \u201Cpause\u201D entries (automatically enabled for "Bridge" and \u201CWaiting\u201D statuses)\n* Anchor watch with warning and alarm\n* Depth monitoring with warning and alarm\n* Notifications regarding visual signals required per COLREG\n* Manual engine entries: Notification of missing entry for \u201CEngine On\u201D (can be set retroactively)\n* Warning in case of problems with NMEA data\n* Man overboard alarm\n* History of changes \u2013 for even greater evidentiary reliability\n* Idle RPM for engines adjustable \u2013 idle operation is marked and does not count as travel under engine power\n\nImprovements\n* Even more functions for manual log entries now selectable directly in the Log menu\n* Manual engine entries: RPM can be added retroactively in Focus mode\n* Crew members, etc., can only be edited for the current day and the following day\n* Connecting Companions via Bonjour is possible for additional configurations\n* Improvements to the login dialog with more clear error messages\n* Extensive internal optimizations that make the app even faster and more reliable\n\nBug Fixes\n* Many major and minor optimizations and bug fixes',
        "2026-08-14": "Here are the new features in the 2026-08-14 update:\n\nNew Features\n* For completed days and days without log entries, entries can now be added retrospectively to the Weather Forecast, Journal, and Technical cards.\n* Support for internal GPS on Android\n* Warning when GPS fails\n* Quick selection of sails in the Log button menu\n* On Android devices, the Primary LOGBOOK now continues to run when the app is in the background\n* Display of sunrise and sunset times on the Day data sheet\n* New options Bridge and Waiting for stopovers and ship state\n* Separate speed setting for triggering the start entry at anchor and at buoy, to avoid unnecessary entries when swinging\n* Functions for uploading data to support\n\nImprovements\n* New design of NMEA and Sync buttons \u2013 current status more clearly visible\n* Log button menu now opens upwards to avoid unnecessary scrolling\n* GPS errors or excessive position deviations (e.g., caused by GPS jamming) are ignored\n* On small screens, the Stop button now only appears with an icon and can be expanded with the Expand button\n* When changing the reef stage of a sail, the previous reef stage is automatically removed\n* Improvements in the connection from Companion to Primary, support for Bonjour\n* Improved text for changes to crew, skipper, etc.\n* System-generated log entries (e.g., during data loss) now only appear once\n\nBug Fixes\n* Time zone is now correctly detected on Windows even when the system is not set to English as the language\n* Possible errors in statistics that could occur with manual engine entries are automatically corrected with the update\n* System-generated duplicate log entries are automatically removed with the update\n* Android: images can now be uploaded\n* Many major and minor optimizations and bug fixes.",
        "2026-07-15": "Here are the new features in the 2026-07-15 update:\n \n New Features\n * For manual engine entries (where NMEA data does not include engine RPM), you can now enable a setting so that the manually entered RPM is automatically carried over to the next log entry. This is helpful during trips with a constant RPM. This option can be enabled in the **Ship settings** on the **Settings** tab.\n\n Improvements\n * Improvements and bug fixes to the statistics, particularly regarding the calculation of total time and total distance.\n\n Bug Fixes\n * Many major and minor optimizations and bug fixes.",
        "2026-07-05": "Here are the new features in the 2026-07-05 update:\n\nNew Features\n* French is now available as an additional language for the user interface.\n* New, multifunctional, context-sensitive Log button next to the current log row for quickly adding various types of entries.\n* Images in notes (journal, etc.) can now be deleted.\n* An offset for the distance value from the log can be set in the ship settings (e.g., if the log does not display the correct total miles of the ship).\n\nImprovements\n* Various additional explanations and guidance in the user interface\n* Access rights and crew role of the account owner are now fixed to avoid problems with lost access rights.\n* When multiple additions are made to a log entry, all changes are now listed in the comment.\n* Extensive optimizations to the LOGBOOK Cloud and communication between LOGBOOK Cloud and LOGBOOK App\n\nBug Fixes\n* When no engine data is available in NMEA, the engine buttons are now displayed immediately.\n* Fixed an issue where 500 rpm was entered for manual engine data after a data interruption.\n* Heading and wind are now correctly evaluated even when only relative data is present in NMEA.\n* Fixed an issue where negative times were displayed in statistics.",
        "2026-06-11": "The 2026-06-11 update brings many improvements and bug fixes:\n\nNew Features\n* Support for iPhone as a companion device.\n* Evaluation of additional NMEA data sets for heading, wind, air temperature, and air pressure.\n\nImprovements\n* When multiple additions are made to an entry (e.g., engine off and sails set), they are now fully listed in the comment.\n* Logging out of the Primary LOGBOOK is now only possible together with closing the Primary LOGBOOK.\n* Optimized user guidance through improved hints, recommendations, and warnings.\n\nBug Fixes\n* NMEA test now correctly detects when there are values from the log.\n* Fixed an issue where the wrong day status was displayed on the day card.\n* Fixed an issue where incorrect crew changes were logged after the device went into sleep mode.\n* Fixed an issue where an incorrect engine speed was recorded after an NMEA connection interruption.\n* Further optimizations and bug fixes in the statistics.",
        "2026-05-30": "Here are the new features in the 2026-05-30 update:\n\nNew Features\n* LOGBOOK can now be used on board with multiple devices simultaneously. In this first stage, the login is done on all devices with the same account. See the documentation at <a href=\"https://logbook.yachts/site/en/documentation/#h1_devices\" target=\"_blank\">**Multiple Devices**</a>.\n\nBug Fixes\n* Fixed an issue where images occasionally extended beyond the print area when printing.\n* Fixed an issue where the wrong date was displayed in western time zones.\n* The current day now always shows the correct date and no longer shows January 1st, even if there are no entries.\n* Changes in the next day's data sheet are not logged.\n* Fixed an issue where changes in the crew were logged even though the crew was not changed.\n* Fixed an issue where manual engine entries after an NMEA connection interruption recorded an engine speed.\n* When stopping, the correct duration now appears directly on the stop button.\n* Fixed an issue where the distance and duration were counted twice during the day's statistic.\n* iPad: Fixed a white screen when switching from Cloud to App within the app.",
        "2026-05-20": "Here are the new features in the 2026-05-20 update:\n\nNew Features\n* Added NMEA connection via UDP.\n* Track data is continuously calculated and regularly synchronized, not just at the end of the day.\n* For days when there is no track, the missing track is automatically generated when recalculating the statistics (button on the map statistics).\n* For manual engine entries, the stop dialog offers an option to automatically create entries for **Engine off** as well.\n\nImprovements\n* Damping in the detection of pauses. This should prevent false pauses at low speeds or due to GPS inaccuracies, as well as incorrect endings of pauses during short-term ship movements or GPS errors.\n* The **calculation of total time** starts when the ship departs and ends with the last entry when the ship is no longer moving. Entries not related to the trip at the beginning and end are no longer considered.\n\nBug Fixes\n* Fixed an issue where after restarting navigation on the same day, the distance started from 0 again.",
        "2026-05-12": "Here are the new features in the 2026-05-12 update:\n\nNew Features\n* iPad: The LOGBOOK app continues to run in the background and continues to create log entries when the app is not in the foreground.\n* iPad: Photos can now be taken directly from the app and inserted into the logbook entries.\n* iPad: Support for **external GPS devices** connected via **Bluetooth** or cable\n* New **Reset** function in case the connection of the cloud to the Primary LOGBOOK was accidentally disconnected (indicated by the red marker on the sync button)\n\nImprovements\n* iPad: Layout issues after returning from the background fixed\n* Server: Improvements in the calculation of statistics",
        "2026-05-05": 'The update 2026-05-05 fixes a few issues:\n\n* Fixed an issue with the integrated GPS of the iPad, which could lead to incorrect pause entries at very low speeds.\n* Fixed an issue where a disabled NMEA connection was automatically activated when the app was brought to the foreground on the iPad.\n* Fixed an issue where log entries and the log row were not displayed correctly when changing the window size (e.g., by rotating the tablet).\n* Fixed incorrect field format in the ship data on the **Equipment** tab.\n* Various minor layout optimizations\n* Various minor bug fixes\n\nIf you are using the internal GPS for data reception, you can find important information in our tip <a href="https://logbook.yachts/site/en/support/#ipadgps" target="_blank">**\xbbUsing LOGBOOK with the internal GPS of the iPad\xab**</a>.',
        "2026-04-27": "The update 2026-04-27 brings a whole range of improvements and bug fixes. \nThis includes further optimizations of the layout for different screen sizes as well as error handling when importing from Logbook Suite.",
        "2026-04-14": "Here's the first, smaller update. Here's what we've improved:\n\n* Optimized layout for medium screens such as tablets in portrait mode (768px to 1023px)\n* Print button now works on iPad\n* Improvements when importing from Logbook Suite\n* Various minor bug fixes",
        "2026-04-04": "Welcome to LOGBOOK \u2013 the innovative logbook software for sailors and motorboat enthusiasts.\n\nThis is version 1.0. In the future, you will find information about new features and improvements here after each update."
    },
    "connection": {
        "interrupted": "The connection to the application was interrupted. \n\nIf the connection does not recover automatically, please try restarting the App.",
        "recovered": "The connection to the application was restored. \n\nPlease reload to continue using the App."
    },
    "currentView": {
        "firstTrip": "**A new passage is being started** \n\nPlease check the **timezone** that is set for this passage. \n\nThe timezone is automatically set to the system timezone of the Primary Device. To change the timezone, you must change the system timezone of the Primary Device **before** starting the passage. \n\nIf the Primary Device system has not correctly transmitted the timezone to LOGBOOK, you can manually change the timezone in the **Ship Settings** on the **Settings** tab. This must also be done **before** starting the passage.\n\n**Please note:** Once the passage is started here, the timezone is fixed.",
        "demoWillStart": "**Note:** With the start of the first passage, you also start your 5-day trial phase.",
        "confirmationDialog": {
            "cruise": {
                "allowed": "Starting a new voyage terminates the current voyage.\n\nAre you sure you want to stop and terminate the current voyage?\n\n**Please note**: NMEA recording will be stopped.",
                "deniedInMotion": "Starting a new voyage is not possible because the ship is in motion.",
                "deniedBlankExists": "Starting a new voyage is not possible because there is already an empty voyage that has not yet been started."
            },
            "trip": {
                "allowed": "Starting a new passage terminates the current passage.\n\nAre you sure you want to stop and terminate the current passage?\n\n**Please note**: NMEA recording will be stopped.",
                "deniedInMotion": "Starting a new passage is not possible because the ship is in motion.",
                "deniedBlankExists": "Starting a new passage is not possible because there is already an empty passage that has not yet been started."
            }
        }
    },
    "importShip": {
        "text": "How to import your logbooks from **Logbook Suite** into **LOGBOOK**:\n\n**Step 1:** In Logbook Suite, use the **Export for LOGBOOK** function (available in Logbook Suite Manager version 2.6 and later) via the **More \u2026** button to export all logbooks you created for your ship.\n\n**Step 2:** In LOGBOOK, create a new ship with the same name. Close the dialog displayed after creation to view your account settings in the LOGBOOK Cloud. (Skip this step if you've already created the ship. Make sure the ship is closed in both the Cloud and the app before proceeding to Step 3.)\n\n**Step 3:** Your new ship now appears in the list. Select **Options** for the ship you want to import into, then choose **Import from LogbookSuite**. Follow the instructions. (The import function is only available when the ship's LOGBOOK is not open.)\n\n**Step 4:** In the LOGBOOK app, start a new voyage before beginning or continuing data recording with LOGBOOK.\n    "
    },
    "importTrips": {
        "text": "Import logbooks created with **Logbook Suite** for your ship **{name}** into **LOGBOOK**. Select the file created by the Logbook Suite export tool with the following name: ***[Ship Name]_LOGBOOK_export.logbook***\n\nIf your imported logbook contains ship data not yet recorded in LOGBOOK, the data from Logbook Suite will be imported. Ship data already entered in LOGBOOK will not be overwritten.\n\n**Important Note:** The import process may take some time, especially if you have a large logbook. Please be patient and do not interrupt the process.\n\n**Attention:** After import, you must start a **new voyage** before starting or continuing data recording in LOGBOOK."
    },
    "login": {
        "welcomeCloud": "Log in or create your account and start keeping your ship's logbook with LOGBOOK. \n\nYou can try LOGBOOK for free and create entries for 5 days.",
        "welcomeApp": "Login to the LOGBOOK app.\n\nIf you don't have an account yet, you can create one [here](logbook:signup).",
        "welcomeAppiPad": "Login to the **LOGBOOK for Yachts** app for iOS.\n\nIf you don't have an account yet, you can create one [here](logbook:signup).",
        "signupSuccess": "Your account was created.\n\nWe sent an email to your account for activation. Please follow the link in the Email to proceed.",
        "invitation": "{inviter} has invited you and would like to give you access to his LOGBOOK for **{ship}**. \n\nIf you already have an account for LOGBOOK, just log in to your account. \n\nIf you are not yet registered with LOGBOOK, please sign up here to create your free account. You will then be logged in directly.\n\nAfter logging in, your LOGBOOK account will be connected to {inviter}'s LOGBOOK account. Then, log in to the LOGBOOK app. In the ship list in your account settings, **{ship}** will appear under **Select from shared ships**, and you can directly connect as a companion to the LOGBOOK for {ship}.",
        "invitationLoggedIn": "{inviter} has invited you and would like to give you access to his LOGBOOK for **{ship}**. \n\nBy **Accept invitation**, you confirm the invitation. Then, log in to the LOGBOOK app. In the ship list in your account settings, **{ship}** will appear under **Select from shared ships**, and you can directly connect as a companion to the LOGBOOK for {ship}.\n\nBy **Use other account**, you can also select or create another account to gain access to the LOGBOOK for {ship}.",
        "resetAppWarning": "If you have problems starting the app or opening a ship, you can reset the LOGBOOK app with this function.\n\nAll data stored on the device will be deleted. All data that has been uploaded from the LOGBOOK app to the LOGBOOK Cloud and stored there will be retained.\n\nAfter resetting, you must reopen the LOGBOOK app and log in with your account. When opening your ship, the LOGBOOK app will then load all data from the LOGBOOK Cloud again.\n\n**Important!** Only perform the LOGBOOK app reset when you have an internet connection.\n\nAre you sure you want to reset the app?",
        "resetAppComplete": "The LOGBOOK app reset is complete.\n\nIf the LOGBOOK app was not automatically closed, you must manually close (kill) it through the operating system and restart it."
    },
    "logout": {
        "logoutWithInternet": "**Warning \u2013 Primary LOGBOOK for {name} open**\n\nThe **Primary LOGBOOK {name}** is still open in the app. Logging out will close the Primary LOGBOOK. To reopen the Primary LOGBOOK, an internet connection is required.   ",
        "logoutWithoutInternet": "**Logout not possible \u2013 no internet connection** \n\nAn internet connection is required to log out. Please check your connection and try again."
    },
    "nmeaSettings": {
        "connectionTypeNative": "To use the **internal GPS**, select the **Built-in GPS** option under **NMEA connection type**. On the **Test and Data** card, GPS reception via the built-in GPS is displayed separately.\n\nAn **external GPS device** connected via **Bluetooth** or **cable** to the iPad behaves the same way as the internal GPS. Therefore, for the external GPS device, also select the **Built-in GPS** connection type.\n\nAdditional available **internal sensors**, such as an **internal barometer**, can be activated independently of the built-in GPS on the **Internal Sensors** card.",
        "connectionTypeNativeWarning": "**Important note**\n\nTo avoid incorrect entries when using the internal GPS, before taking the iPad off the ship, either disconnect the NMEA connection or close the Primary LOGBOOK of your ship via the menu command.\n\nPlease note that an internet connection is required both for closing the ship and for reopening it."
    },
    "noteText": {
        "uninitialized": "**Synchronization initializing**\n\nPlease wait. This can take a few minutes.",
        "failed": "Synchronization failed. Retrying soon.",
        "initialSyncFailed": "Initial synchronization failed. Retrying soon.",
        "initialSyncInProgress": "**Initial synchronization started**\n\nPlease wait. This can take a few minutes.",
        "dataWaiting": "Waiting to synchronize.",
        "inProgress": "**Synchronization in progress** \n\nPlease wait. This can take a few minutes.",
        "current": "Fully synchronized.",
        "disconnected": "**Connection to the LOGBOOK Cloud lost**\n\nThis device is no longer registered as the Primary LOGBOOK, so synchronization has stopped.\n\nUse **Reconnect** in the **Sync** menu to restore the connection. You will be asked whether the data on this device or the data in the LOGBOOK Cloud should be kept.",
        "transition": "**Preparing your data**\n\nExisting entries are being updated for this version. Please wait, this can take a few minutes.",
        "resync": "Data from your device is being uploaded to the LOGBOOK Cloud.",
        "newShip": "**Important note** \n\nThe **vessel type** and the **number of engines** can not be changed after the ship has been created.",
        "shipOpen": "The **Primary LOGBOOK** for **{name}** is already open on another device.\n\n**Case 1 - You are on board the ship**\n\nMake sure your device is connected to the **ship's internal network**.\nThen enter the address of the Primary LOGBOOK here to establish a connection. Use the format **IP:Port**, e.g., 192.168.0.100:8000. You can find the address in the Primary LOGBOOK in the **Ship Settings** under **Companions**.",
        "shipOpen2": "** **\n\n**Case 2 - No ship's internal network available or you are not on board the ship**\n\nYou can always view the last synchronized state of the logbook in the **LOGBOOK Cloud**.\n\n** **\n\n**Case 3 - You want to open the logbook as Primary LOGBOOK on this device**\n\nIf necessary, you can use **Disconnect Primary LOGBOOK** to forcibly disconnect the connection between the Primary LOGBOOK and the LOGBOOK Cloud. ",
        "shipNotClosed": "Use this function only if you are sure that the Primary LOGBOOK must be disconnected from the LOGBOOK Cloud \u2013 for example, because the Primary Device is defective or for other reasons access to the Primary Device is no longer possible.\n\nAll data recorded after disconnecting from the Primary LOGBOOK will not be synchronized and may be lost.\n    \n- Use the button below to switch to the ship list in the LOGBOOK Cloud.\n\n- Open the **Options** dialog with the **Options** button (the button shows a different color for the affected ship). You can now disconnect the ship via this dialog.\n\nAfter a short wait, the Primary LOGBOOK of the ship can be reopened. If necessary, you can refresh the view with the refresh button. Reopening can take several minutes as the LOGBOOK app must retrieve all data from the LOGBOOK Cloud.",
        "shipOpenCompanion": "Enter the address of the Primary LOGBOOK here to establish a connection. \n\nUse the format **IP:Port**, e.g., **192.168.0.100:8000**. \n\nYou can find the address in the Primary LOGBOOK in the ship settings on the **Companions** card.",
        "shipsSmartphone": "LOGBOOK can only be used as a Companion on a smartphone and therefore offers limited functionality.\n\nOnly ships whose Primary LOGBOOK is already running on another device can be selected. For the Companion connection, your smartphone must be on the same network as the Primary Device.",
        "selectShip": "Selecting ship on LOGBOOK cloud.",
        "selectShipFailed": "Selection of ship failed on LOGBOOK cloud.\n\nPlease try again in a few minutes.",
        "limitActiveShipsReached": "You have reached your limit of active ships. \n\nTo select another ship you must first close the currently open ship on LOGBOOK cloud.",
        "startShip": '<strong>Your ship "{name}" has been created \u2013 Now switch to LOGBOOK app</strong>\n\nYour new ship has been successfully created and is now displayed here in the **LOGBOOK cloud**. \n\nIf you want, you can directly enter more ship data here in the LOGBOOK cloud. To do this, select the menu item **{name} Ship Data** from the menu <strong>{name}</strong>. \n\nNext, the first voyage and the first passage need to be prepared. To do this, open your new ship in the **LOGBOOK app**. If you have not yet installed the LOGBOOK app, you can find the download links here: <a href="https://logbook.yachts/site/en/download" target="_blank">Download LOGBOOK app</a>.  \n\nOnce the first voyage and the first passage have been created, they will also be displayed here in the LOGBOOK cloud. ',
        "firstLogin": '**Welcome to LOGBOOK** \u2013 the innovative logbook software \n\n**Your account has been successfully created.**\n\n<li>Now create your <strong>first ship</strong> \u2026</li>\n<li>\u2026 set up the <strong>NMEA connection</strong> \u2026</li>\n<li>\u2026 and you\'re <strong>ready for your first passage</strong> with LOGBOOK.</li>\n\nDetailed instructions can be found in the <a href="https://logbook.yachts/site/en/documentation/#h1_quickstart" target="_blank">QuickStart</a> and in the <a href="https://logbook.yachts/site/en/demos" target="_blank">Interactive Demos</a>.',
        "firstLoginCloud": "If you have not yet installed the LOGBOOK app, you can find the download links here: <a href=\"https://logbook.yachts/site/en/download\" target=\"_blank\">Download LOGBOOK app</a>.  "
    },
    "sessionExpired": {
        "text": "**Login required \u2013 no connection to the LOGBOOK Cloud**\n\nThe LOGBOOK Cloud no longer accepts this device's login. Nothing has been lost: your ship stays open and everything you log is saved on this device.\n\nUntil you log in again, no data is synced to the Cloud and no other device sees your entries."
    },
    "shipClose": {
        "text": "Are your sure you want to close the Primary LOGBOOK for the ship named **{name}**?\n\n**This will stop data recording and disconnect from NMEA.**\n\nPlease also note: You will need an **Internet connection** if you want to get back to this ship later!",
        "internet": "**Closing the ship is not possible \u2013 no Internet connection**\n\nInternet connection is needed to close the ship. Please check your connection and try again.",
        "forceWarning": "**Force close only on this device?**\n\nThis closes **{name}** locally without synchronizing. The ship remains claimed in the LOGBOOK Cloud and must be closed manually there before it can be opened again.\n\nUnsynced local data remains stored on this device.",
        "keepOpen": "**Tip:**\n<p>We recommend keeping the <strong>Primary LOGBOOK open</strong> throughout the entire voyage. <br>\nAfter the end of the day, you can simply close the app. <br>\nKeep the <strong>Primary LOGBOOK open</strong> and <strong>do not log out</strong>. The data recording will then be interrupted, but the status of the Primary LOGBOOK will be retained. <br>\nAfter restarting the app, the Primary LOGBOOK is immediately available.</p>",
        "noSync": "Synchronization with the LOGBOOK Cloud has failed because this LOGBOOK is no longer registered as the Primary LOGBOOK in the LOGBOOK Cloud.\n\nIf you close the ship, all changes that have not yet been saved to the LOGBOOK Cloud will be lost.\n\nYou can try to restore the connection to the LOGBOOK Cloud using **Reconnect** from the **Sync** menu, synchronize the data, and then close the ship."
    },
    "shipInfo": {
        "disconnect": "Are your sure you want to disconnect the Primary LOGBOOK for the ship named **{name}**?\n\n**This will stop any synchronization of this logbook  with the LOGBOOK Cloud.**\n\nPlease also note:\n\nIn case that the Primary LOGBOOK on the ship doesn't have Internet connection, all data that are recorded after disconnecting will not be synchronized and may be lost.",
        "resync": "The Primary LOGBOOK for your ship **{name}** is no longer connected to the LOGBOOK Cloud. To restore this connection, the data must be synchronized again.\n\nEither the data on the device or the data in the LOGBOOK Cloud will be reset. Then this device will be set up as the **Primary LOGBOOK** for **{name}**. Finally, the data will be synchronized between the Primary LOGBOOK and the LOGBOOK Cloud.\n\n**Warning!**\n\nThis function is intended for emergency use only. Only execute it on the device that is set up as the **Primary LOGBOOK** for **{name}**. If the Primary LOGBOOK is actually set up on a different device, the data recorded with that device may be lost.\n\n* First, check whether the data here in the LOGBOOK app or in the LOGBOOK Cloud is more recent.\n\n* Then decide whether you want to keep the data here in the LOGBOOK app or the data in the LOGBOOK Cloud as the current data.\n\n* Select the appropriate button to start the process.",
        "resyncUnavailable": "The reset of the LOGBOOK for your ship **{name}** could not be completed because a device is still connected to the ship in the LOGBOOK Cloud.\n\n**Important:** First, check whether the Primary LOGBOOK is currently running on another device. If so, start the process from that other device and follow the steps there.\n\nTo proceed here, disconnect this device in the LOGBOOK Cloud:\n\n* Switch to the LOGBOOK Cloud using the **To LOGBOOK Cloud** command from the **Account** menu.\n* In the LOGBOOK Cloud, the **Options** button next to your ship is highlighted in blue.\n* In the options, select **Disconnect Ship**.\n* Switch back to the LOGBOOK app.\n* Open the dialog to restore synchronization again. Now you can choose which data you want to keep.",
        "resync_reset_local_confirm": "**Do you really want to use local data?**\n\nThis action will reset the cloud data.\n\nThis action cannot be undone and will lead to the loss of all data that is stored in the LOGBOOK Cloud and not present on this device.",
        "resync_reset_cloud_confirm": "**Do you really want to use cloud data?**\n\nThis action will reset the local data.\n\nThis action cannot be undone and will lead to the loss of all data that is stored only on this device and not present in the LOGBOOK Cloud."
    },
    "shipSetting": {
        "utc": "**Important note**   \n\n**Please note that the timezone for the ship's time is fixed for the entire passage once it has started.** Any changes here will not affect an already started passage.",
        "utc_info": "LOGBOOK generally sets the ship's time to the system time of the Primary Device. \n\nIn some cases, the system of the Primary Device may not correctly transmit the timezone to LOGBOOK. In this case, you have the option to manually set the timezone for the ship's time.",
        "log_offset": "If your log transducer has been replaced and the previous log value could not be transferred, enter the old value here as an offset. It will be automatically added to the new measurements, ensuring that the total distance of your ship is correctly continued.",
        "keep_rpm": "If there is no engine data available via NMEA, you can enable this option to automatically carry over the RPM value you entered manually to the next log entry. This is useful when the engine speed does not change between entries.",
        "lights": "When enabled, LOGBOOK quietly reminds you in a button on the current log row whenever the visual signals recorded for the ship do not match what COLREGS recommends for the current propulsion state and time of day. \n\nIt never sounds an alarm \u2014 recording the matching visual signals dismisses the reminder. \n\nConfigure which lights your ship carries when sailing, whether the day/night boundary follows civil twilight or sunset/sunrise, and whether the optional motoring cone should be reminded about.",
        "edit_permissiveness": "Controls how permissive editing a log or day entry is once it has been recorded. This affects every existing and future entry as soon as it is changed \u2014 it is not limited to entries created afterwards.\n\n**Default (strict)** \u2014 today's behavior. A value that was supplied live by NMEA (e.g. heading, depth, engine RPM, log, pressure, temperature, humidity, wind, course, speed over ground) stays locked until you manually correct it, and can only be edited within a short time after it was recorded.\n\nManual engine RPM is an exception to the time restriction: it can be entered or corrected on earlier entries too. RPM that is still protected as NMEA-supplied remains locked.\n\n**Extended** \u2014 lifts the time restriction, so NMEA-supplied values can still be corrected later, but values that haven't been manually corrected yet remain protected.\n\n**Unrestricted** \u2014 removes all of this protection. Every value, including ones supplied live by NMEA, can be edited at any time. **Use this with care:** it removes the safeguard that shows a value was recorded automatically from a sensor rather than entered or changed by hand, which can matter for the evidentiary value of your logbook.\n\nA handful of fields (e.g. distance) are always calculated and can never be edited directly, at any level."
    },
    "planDescriptions": {
        "captain": "Annual subscription for professionals, ship length under 24 m",
        "master_captain": "Annual subscription for professionals, ship length from 24 m",
        "skipper": "Monthly or annual subscription for private skippers",
        "skipper_inApp": "Monthly subscription for private skippers \u2013 in-app purchase",
        "trial": "5 Days Free Trial"
    },
    "subscription": {
        "checkoutComplete": "Purchase successful.",
        "checkoutProcessing": "Completing your purchase...",
        "subscriptionMessage": "Pick a plan.\n\nNo matter which device you purchase this subscription from, you can use LOGBOOK with all supported devices simultaneously or alternately (macOS, Windows, Android, and iOS). The subscription is not tied to a specific platform.",
        "subscriptionMessageiPad": "Subscribe to keep using LOGBOOK with full functionality after your trial ends.\n\nOnce the 5 free days are over, you can only view and print your saved data \u2014 no further entries or edits are possible.\n\nThe monthly subscription **LOGBOOK Skipper** is particularly suitable for private skippers who prefer or exclusively want to keep their logbook on the iPad. The subscription renews automatically and can be canceled at the end of each term.\n\nThis subscription may also be used on other platforms, simultaneously or alternately.",
        "demo1Day": "**Trial phase ends in one day**\n\nYou still have one day to test LOGBOOK for free and create entries.\n\nAfter that, you can seamlessly continue with a subscription and keep your logbook going without interruption.",
        "demo2Days": "**Trial phase ends in 2 days**\n\nYou can still create entries in LOGBOOK for free for 2 more days.\n\nAfter that, you can seamlessly continue with a subscription and keep your logbook going without interruption.",
        "demoEnded": "**Trial phase ended**\n\nYour demo phase is over. With a subscription, you can now continue your logbook. We'll keep your test data stored in the LOGBOOK Cloud for another 6 months.",
        "demoToday": "**Trial phase ends today**\n\nYou can still create entries in LOGBOOK for free today.\n\nAfter that, the trial phase ends. With a subscription, you can continue your logbook at any time.",
        "demoStarted": "**Trial phase started**\n\nYour trial phase started with your first entry in LOGBOOK. \n\nYou can now create logbook entries for a total of **5 days**.",
        "subscription7Days": "**Subscription ends in a few days**\n\nYour subscription will expire soon. Don't worry \u2013 the renewal will be automatic, so you can continue using your logbook without interruption.\n\nIf you want to adjust your subscription, you can do so at any time.",
        "subscriptionExpired": "**Subscription expired**\n\nYour subscription has expired. But don't worry \u2013 all your data will remain securely stored in the LOGBOOK Cloud for another 2 years.\n\nRenew your subscription now to continue your logbook.",
        "subscriptionToday": "**Subscription ends today**\n\nYour subscription expires today. Renew it now to continue using your logbook.",
        "removeAccount": "Confirm account removal.\n\nThis will permanently delete the \"{account}\" account and the \"{user}\" user.\n\nYou will lose access to all ships, voyages, passages, and logbook entries associated with this account.",
        "removeAccountDone": "Your account \"{account}\" and the user \"{user}\" in LOGBOOK has been successfully deleted."
    },
    "mailer": {
        "footer": '---\n\n![TRIMUTIC \u2013 THE LOGBOOK COMPANY](https://trimutic.com/media/trimutic_komplett-black.png "logo")\n\n[TRIMUTIC](https://trimutic.com) | [LOGBOOK](https://logbook.yachts) | [Privacy](https://logbook.yachts/site/en/privacy) | [About us](https://logbook.yachts/site/en/about)\n\n{reason}',
        "templates": {
            "signupConfirmation": {
                "subject": "Welcome to LOGBOOK - Confirm your email",
                "footer": "This email was sent because you created an account with LOGBOOK on our website.\nIf you didn't create an account with LOGBOOK, you can safely ignore this email.",
                "body": "Hello {name},\n\nWelcome to LOGBOOK - Confirm your email\n\nTo get started, please confirm your email address by clicking the button below:\n\n[Confirm your Email Address]({confirmation_link} \"button\")\n\nThis helps us ensure your account is secure and that you can receive important updates about your logbook.\nIf the button above doesn't work, copy and paste this link into your browser:\n\n{confirmation_link}\n\nThis confirmation link will expire in 24 hours.\nIf you didn't create an account with LOGBOOK, you can safely ignore this email.\n\nBest regards,\n**The LOGBOOK Team**"
            },
            "signupWelcome": {
                "subject": "Welcome to LOGBOOK",
                "footer": "You're receiving this email because you signed up for LOGBOOK.",
                "body": 'Hello {name},\n\nWelcome to LOGBOOK!\n\nYour email address has been successfully confirmed! \uD83C\uDF89\\\nYour account is now activated and ready to use.\n\n**What\'s next?**\n\nGet started right away with your digital logbook!\\\nWith the free **LOGBOOK Trial**, you can create logbook entries for free on a total of **5 days**. The 5 days start with your first log entry.\n\n**Here\'s how to get started:**\n\n1. **Download the LOGBOOK app** and log in with your credentials.\n\n   [Download app](https://logbook.yachts/site/en/download "button")\n\n2. **Create your first ship** and your first logbook entry \u2013 completely free.\n\n3. **Find support to get started:**\n\n   - Step-by-step guide in the [Quickstart](https://logbook.yachts/site/en/docs/quickstart/)\n   - Explore playfully with our [interactive demos](https://logbook.yachts/site/en/demos/)\n   - Complete overview in the [Documentation](https://logbook.yachts/site/en/docs)\n\n4. **Tips & Help:**\n\n   - Practical tricks on our [Support page](https://logbook.yachts/site/en/docs/support/#tips).\n   - Direct help via the **Help** menu in the app or by email at contact@trimutic.com \u2013 we\'ll respond as quickly as possible!\n\n---\n\n**Do you like LOGBOOK?**\\\nThen secure a subscription now and keep your logbook permanently and without interruption.\n\n[More info about subscriptions](https://logbook.yachts/site/en/prices "button")\n\n[Subscribe now](https://logbook.yachts/app/account/subscription "button")\n\n**Note:** Unfortunately, on iOS it\'s not possible to select the subscription directly from your account settings in the app. On the iPad, you need to log into your account in a web browser (e.g., Safari) \u2013 outside the app. The **Subscribe now** button will then take you to the subscription selection.\n\nIf you have any questions or problems, our [Support Team](https://logbook.yachts/site/en/support) is happy to help.\n\nBest regards,\\\n**The LOGBOOK Team**'
            },
            "invited": {
                "subject": "Welcome to LOGBOOK",
                "footer": "This email was sent because you have been invited to join LOGBOOK.\nIf you do not wish to accept the invitation, you can simply ignore this email.",
                "body": 'Hello {name},\n\n{account_holder} has invited you to LOGBOOK so you can access the logbook aboard the **{ship_name}**.\n\nClick this button to accept the invitation:\n\n[Accept invitation]({invitation_link} "button")\n\nThis button will take you to the LOGBOOK signup and login page.\n\n**Either log in \u2026**\nIf you already have a LOGBOOK account, you can log in using it. Your name email address {email} are already filled in. However, you can also log in using a different email address.\n\n**\u2026 or sign up and create an account**\nIf you don\u2019t have an account at LOGBOOK yet, you can sign up for LOGBOOK for free.\nAll you need is your name, email address, and a password.\nYour email address {email} is already pre-filled so you can sign up without having to verify it again.\nEnter your name, set a password and then click on **Sign Up**.\n\nIf the button above doesn\'t work, copy the following link and paste it into your browser:\n\n{invitation_link}\n\nThis invitation link expires in 24 hours.\n\nWhen you sign up for LOGBOOK, you will automatically be subscribed to our occasional newsletter, which keeps you informed about the latest news from LOGBOOK. You can unsubscribe from this newsletter at any time.\n\nWith best regards,\n**The LOGBOOK team**'
            },
            "passwordReset": {
                "subject": "LOGBOOK - Forgot password",
                "footer": "This email was sent because you submitted a forgotten password request in the LOGBOOK login dialog.\nIf you did not submit a request, you can ignore this email.",
                "body": "Hello {name},\n\nForgot your password?\n\nNo problem! Click the button below to start the password reset process.\n\n[Reset Password]({reset_link} \"button\")\n\nYou can then set a new password in the login dialog.\n\nIf you do remember your password, you can ignore this email and try to log in again.\n\nBest regards,\n**The LOGBOOK Team**"
            },
            "betaInvite": {
                "subject": "Welcome to beta test of LOGBOOK",
                "footer": "You are receiving this email because you signed up as a beta tester for LOGBOOK.",
                "body": 'Hello {name},\n\nWelcome to the **LOGBOOK** beta test! Thank you for taking the time to test our software under real conditions. Your feedback helps us prepare LOGBOOK for productive use on board.\n\nAt the beginning of the beta test, LOGBOOK is available for Windows, macOS and iOS (iPad). Soon we will also include Android in the beta test program.\n\n**What is the role of a beta tester?**\n\nAs a beta tester, you get access to a version that is already functional but may still contain errors. Your tasks include:\n\n-   Testing the features in real operation\n-   Reporting errors (bugs)\n-   Feedback on usability, comprehensibility, and user-friendliness\n-   Suggestions for improvements and new features\n-   Feedback on whether the software meets your expectations\n\nPost your error reports, comments, and ideas in our beta testing forum, which we have set up on Discord. With this link, you can access both the forum and the chat: [**Join the LOGBOOK community**](https://discord.gg/nTztPF9jKE). (On the iPad, the link works with the Discord app, not with the browser.)\n\nYou can also reach us by email at contact@trimutic.com.\n\n**We will post important information and tips in the forum to help you test and use LOGBOOK.\nSo please be sure to register!**\n\nWe appreciate all feedback \u2014 brief or detailed, positive or critical. The more honest, the better.\n\n**How does the beta test work?**\n\nUse LOGBOOK directly on your next trip and report your experiences to us at contact@trimutic.com or through the contact form. Feel free to include screenshots.\n\nDuring the beta test phase, we will continue to improve LOGBOOK, incorporate feedback from our beta testers, and add some new features.\nTherefore, we will provide **updates** more frequently.\nYou will automatically receive information about whether an update is available when starting the app or through the **Changelog** menu item in the **Help** menu (internet connection required in both cases).\n\nWe would like to ask you to install updates promptly. This is the only way to ensure that you are really testing with the latest version.\n\n**What do you need to do next?**\n\n1.  Sign up as a beta tester for LOGBOOK.\n\n[Beta Tester Sign-up](https://logbook.yachts/app/signup/beta "button")\n\nIf you want to register with LOGBOOK using **Safari**, you must in ensure with this first version that no fields are filled in automatically.\nSo, please type in your name and email address manually; do not select any suggestions. Your entries will still be saved in your system.\nOr use a different browser for registration, such as Google Chrome or Microsoft Edge.\n\n2. Download and install the LOGBOOK app on your primary device, i.e., the device with which you want to receive the NMEA data.\n\n    [Download App](https://logbook.yachts/site/en/download "button")\n\n    If you signed up for the test on the **iPad**, you will receive an email from TestFlight in addition to this email.\n\n    **TestFlight** is Apple\'s tool for running and testing unreleased apps on the iPad. Install the **TestFlight** app ([Install TestFlight](https://testflight.apple.com/a)). You can then load LOGBOOK into TestFlight using the **View in TestFlight** button (in the email) and install it on your iPad.\n\n    After that, LOGBOOK can be launched like any other app.\n\n3. Start the app and log in to the user account you created in step 1.\n4. Create your first ship, connect the app to NMEA, and start your logbook (see also our [Quickstart](https://logbook.yachts/site/en/docs/quickstart/)).\n5. Discover all features and possibilities \u2013 and test the app under real conditions.\n\n**Your Contact to LOGBOOK Support**\n\nYou can reach our support within the app through the **Contact Support** function in the **Help** menu (contact form) or by **email** at contact@trimutic.com. We will help you quickly and easily.\n\nOur regular support hours are Monday to Friday from 9:00 AM to 6:00 PM (CET). In many cases, you can also reach us outside these hours and on weekends.\n\n**Documentation**\n\nYou can find all important information and instructions in our comprehensive [online documentation](https://logbook.yachts/site/en/docs/intro).\n\nFor a quick start, we recommend our [Quickstart]( https://logbook.yachts/site/en/docs/quickstart/).\n\nFair winds and always a hand\'s breadth of water under the keel!\n**From your LOGBOOK Team**'
            },
            "subscriptionWelcomeSkipper": {
                "subject": "Your \u201CLOGBOOK Skipper\u201D subscription has been activated.",
                "footer": "You are receiving this email because you registered with LOGBOOK.",
                "body": "Hello {name},\n\nCongratulations and welcome aboard!\n\nYou have successfully subscribed to **LOGBOOK Skipper**. We are delighted to welcome you to our community and wish you much enjoyment and success with your digital logbook.\n\n**What should you do next?**\n\n1.  Install the LOGBOOK app on your primary device, i.e., the device with which you want to receive NMEA data. You can find download links [here](https://logbook.yachts/site/en/download).\n2.  Start the app and log in to your user account.\n3.  Create your first vessel, connect the app to the NMEA, and start your logbook (see also our [Quickstart](https://logbook.yachts/site/en/docs/quickstart/)).\n4.  Discover all features and possibilities \u2013 if you have any questions, our support team will be happy to help.\n\nAnd if you've already tested LOGBOOK, you can simply continue with the logbook you started as a test.\n\n**Your Support Access:**\n\nWith the **LOGBOOK Skipper** subscription, you can reach our support within the app via the **Contact function** in the Help menu or by **email** at contact@trimutic.com. We'll help you quickly and easily.\n\nOur regular support hours are Monday to Friday from 9:00 AM to 6:00 PM (CET). In many cases, you can also reach us outside these hours and on weekends.\n\n**Documentation:**\n\nYou can find all important information and instructions in our comprehensive [online documentation](https://logbook.yachts/site/en/docs/intro).\n\nFor a quick start, we recommend our [Quickstart](https://logbook.yachts/site/en/docs/quickstart/).\n\nFair winds and following seas!\n**Your LOGBOOK Team**"
            },
            "subscriptionWelcomeCaptain": {
                "subject": "Your \u201CLOGBOOK Captain\u201D subscription has been activated.",
                "footer": "You are receiving this email because you registered with LOGBOOK.",
                "body": "Hello {name},\n\nCongratulations and welcome aboard!\n\nYou have successfully subscribed to **LOGBOOK Captain**. We are delighted to welcome you to our community and wish you much enjoyment and success with your digital logbook.\n\n**What should you do next?**\n\n1.  Install the LOGBOOK app on your primary device, i.e., the device with which you want to receive NMEA data. You can find download links [here](https://logbook.yachts/site/en/download).\n2.  Start the app and log in to your user account.\n3.  Create your first vessel, connect the app to the NMEA, and start your logbook (see also our [Quickstart](https://logbook.yachts/site/en/docs/quickstart/)).\n4.  Discover all features and possibilities \u2013 if you have any questions, our support team will be happy to help.\n\nAnd if you've already tested LOGBOOK, you can simply continue with the logbook you started as a test.\n\n**Your Support Access:**\n\nWith the **LOGBOOK Captain** subscription, you can reach our support directly from the app via the **Contact Support** menu item in the Help menu or by **email** at [contact@trimutic.com](mailto:contact@trimutic.com). We'll help you quickly and easily.\n\nWith the **Pro Support** included in your subscription, you also have the option to contact our support by phone or via WhatsApp. The exclusive phone number for Pro Support is **[+49 211 93659134](tel:4921193659134)**.\n\nUse this [**link**](https://wa.me/message/MNUAAKYACQU5A1) to connect with our Pro WhatsApp support channel. As a Captain subscriber, we offer you the opportunity to contact our support team via this channel through WhatsApp:\n\nOur regular support hours are Monday to Friday from 9:00 AM to 6:00 PM (CET). In many cases, you can also reach us outside these hours and on weekends.\n\n**Documentation:**\n\nYou can find all important information and instructions in our comprehensive [online documentation](https://logbook.yachts/site/en/docs/intro).\n\nFor a quick start, we recommend our [Quickstart](https://logbook.yachts/site/en/docs/quickstart/).\n\nFair winds and following seas!\n**Your LOGBOOK Team**"
            },
            "subscriptionWelcomeMasterCaptain": {
                "subject": "Your \u201CLOGBOOK Master Captain\u201D subscription has been activated.",
                "footer": "You are receiving this email because you registered with LOGBOOK.",
                "body": "Hello {name},\n\nCongratulations and welcome aboard!\n\nYou have successfully subscribed to **LOGBOOK Master Captain**. We are delighted to welcome you to our community and wish you much enjoyment and success with your digital logbook.\n\n**What should you do next?**\n\n1.  Install the LOGBOOK app on your primary device, i.e., the device with which you want to receive NMEA data. You can find download links [here](https://logbook.yachts/site/en/download).\n2.  Start the app and log in to your user account.\n3.  Create your first vessel, connect the app to the NMEA, and start your logbook (see also our [Quickstart](https://logbook.yachts/site/en/docs/quickstart/)).\n4.  Discover all features and possibilities \u2013 if you have any questions, our support team will be happy to help.\n\nAnd if you've already tested LOGBOOK, you can simply continue with the logbook you started as a test.\n\n**Your Support Access:**\n\nWith the **LOGBOOK Master Captain** subscription, you can reach our support directly from the app via the **Contact Support** menu item in the Help menu or by **email** at [contact@trimutic.com](mailto:contact@trimutic.com). We'll help you quickly and easily.\n\nWith the **Pro Support** included in your subscription, you also have the option to contact our support by phone or via WhatsApp. The exclusive phone number for Pro Support is **[+49 211 93659134](tel:4921193659134)**.\n\nUse this [**link**](https://wa.me/message/MNUAAKYACQU5A1) to connect with our Pro WhatsApp support channel. As a Master Captain subscriber, we offer you the opportunity to contact our support team via this channel through WhatsApp:\n\nPlease let us know, when you will need our onboarding support.\n\nOur regular support hours are Monday to Friday from 9:00 AM to 6:00 PM (CET). In many cases, you can also reach us outside these hours and on weekends.\n\n**Documentation:**\n\nYou can find all important information and instructions in our comprehensive [online documentation](https://logbook.yachts/site/en/docs/intro).\n\nFor a quick start, we recommend our [Quickstart](https://logbook.yachts/site/en/docs/quickstart/).\n\nFair winds and following seas!\n**Your LOGBOOK Team**"
            },
            "trialStarted": {
                "subject": "Your LOGBOOK Trial has started",
                "footer": "You're receiving this email because you signed up for LOGBOOK.",
                "body": 'Hello {name},\n\nCongratulations and welcome aboard!\n\nYou have just started the 5-day demo phase of LOGBOOK. You can now create logbook entries for free on a total of **5 days**.\n\n-   **Find support to get started:**\n\n-   Step-by-step guide in the [Quickstart](https://logbook.yachts/site/en/docs/quickstart/)\n-   Explore playfully with our [interactive demos](https://logbook.yachts/site/en/demos/)\n-   Complete overview in the [Documentation](https://logbook.yachts/site/en/docs)\n\n-   **Tips & Help:**\n\n-   Practical tricks on our [Support page](https://logbook.yachts/site/en/docs/support/#tips).\n-   Direct help via the **Help** menu in the app or by email at contact@trimutic.com \u2013 we\'ll respond as quickly as possible!\n---\n**Do you like LOGBOOK?**\nThen secure a subscription now and keep your logbook permanently and without interruption.\n\n[More info about subscriptions](https://logbook.yachts/site/en/prices "button")\n\n[Subscribe now](https://logbook.yachts/app/account/subscription "button")\n\n**Note:** Unfortunately, on iOS it\'s not possible to select the subscription directly from your account settings in the app. On the iPad, you need to log into your account in a web browser (e.g., Safari) \u2013 outside the app. The **Subscribe now** button will then take you to the subscription selection.\n\nIf you have any questions or problems, our [Support Team](https://logbook.yachts/site/en/support) is happy to help.\n\nBest regards,\n**The LOGBOOK Team**'
            },
            "trialExpiring": {
                "subject": "Your LOGBOOK Trial is ending soon",
                "footer": "You're receiving this email because you signed up for LOGBOOK.",
                "body": 'Hello {name},\n\nThere is only one more day left until the 5-day LOGBOOK trial phase will end.\n\n**Do you like LOGBOOK?**\nThen secure a subscription now and keep your logbook permanently and without interruption.\n\n[More info about subscriptions](https://logbook.yachts/site/en/prices "button")\n\n[Subscribe now](https://logbook.yachts/app/account/subscription "button")\n\n**Note:** Unfortunately, on iOS it\'s not possible to select the subscription directly from your account settings in the app. On the iPad, you need to log into your account in a web browser (e.g., Safari) \u2013 outside the app. The **Subscribe now** button will then take you to the subscription selection.\n\nIf you have any questions or problems, our [Support Team](https://logbook.yachts/site/en/support) is happy to help.\n\nBest regards,\n**The LOGBOOK Team**'
            },
            "trialExpired": {
                "subject": "Your LOGBOOK Trial phase has expired",
                "footer": "You're receiving this email because you signed up for LOGBOOK.",
                "body": 'Hello {name},\n\nYour LOGBOOK trial phase has expired. We will keep your test data in the LOGBOOK cloud for 6 more months.\n\n**Do you like LOGBOOK?**\nThen secure a subscription now and keep your logbook permanently and without interruption.\n\n[More info about subscriptions](https://logbook.yachts/site/en/prices "button")\n\n[Subscribe now](https://logbook.yachts/app/account/subscription "button")\n\n**Note:** Unfortunately, on iOS it\'s not possible to select the subscription directly from your account settings in the app. On the iPad, you need to log into your account in a web browser (e.g., Safari) \u2013 outside the app. The **Subscribe now** button will then take you to the subscription selection.\n\nIf you have any questions or problems, our [Support Team](https://logbook.yachts/site/en/support) is happy to help.\n\nBest regards,\n**The LOGBOOK Team**'
            },
            "contact": {
                "subject": "LOGBOOK - We Received Your Message",
                "footer": "This email was sent because you submitted a contact form on our website.\nIf you did not submit this form, please contact us immediately.",
                "body": "Hello {name},\n\nWe've received your message and our customer service team will get back to you as soon as possible.\n\n### Your Inquiry Details\n\n**Email:** {email}\n\n**Type of Inquiry:** {topic}\n\n**Your Question:**\n\n{request}\n\nThis email confirms we've received your message. We typically respond within 1-2 business days.\n\nIf you have any urgent questions in the meantime, feel free to reach out to us by reply to this email.\n\nBest regards,\n**The LOGBOOK Customer Service Team**"
            },
            "betaContact": {
                "subject": "LOGBOOK Beta Testing - Thank You",
                "footer": "This email was sent because you signed up for the LOGBOOK beta testing program.\nIf you did not sign up, please disregard this email.",
                "body": "Hello {name},\n\nThank you for your interest in helping us test LOGBOOK!\nWe're excited to have you on board as one of our beta testers.\n\n### Your Registration Details\n\n**Email:** {email}\n\n**Operating System:** {system}\n\n**Current Logbook Suite User:** {logbooksuite}\n\n**Details about your vessel, NMEA connectivity, and your planned trips for early 2026:**\n{request}\n\n### What Happens Next?\n\n1.  **Review Process:** Our team will carefully review your application and vessel details.\n2.  **Information:** We'll contact you with more details of the beta program.\n3.  **Beta Access:** As tester you will receive download links and setup instructions.\n4.  **Testing Period:** You'll have the opportunity to test LOGBOOK during your planned trips in early 2026.\n\nWe're particularly interested in testing LOGBOOK with various vessel configurations and NMEA connectivity setups, so your input will be invaluable in making LOGBOOK the best digital logbook solution available.\n\nIf you have any questions in the meantime, please don't hesitate to reach out to us.\n\nFair winds and following seas,\n**The LOGBOOK Team**"
            }
        }
    }
};


var $c704c9b2c9549272$exports = {};
$c704c9b2c9549272$exports = {
    "alert": {
        "anchorDrift": {
            "alarm": "Das Schiff hat sich **{distance}** von der Ankerposition entfernt.",
            "warning": "Das Schiff hat sich **{distance}** von der Ankerposition entfernt."
        },
        "depth": {
            "alarm": "Die aktuelle Wassertiefe betr\xe4gt nur **{depth}**.",
            "warning": "Die aktuelle Wassertiefe betr\xe4gt nur **{depth}**."
        },
        "lights": {
            "warning": "Empfohlen ist **{recommended}**, eingetragen ist derzeit jedoch **{recorded}**."
        },
        "lostPosition": {
            "disconnected": "Die Verbindung zur Positionsquelle wurde unterbrochen.",
            "invalidFix": "Die Positionsquelle meldet, dass ihr GPS-Fix ung\xfcltig ist.",
            "jump": "Die Positionsquelle meldet unplausible Positionen. Sie werden ignoriert.",
            "stale": "Es wurden seit einiger Zeit keine Positionsdaten mehr empfangen."
        },
        "manOverboard": {
            "emitterActivated": "Ein Mann-\xfcber-Bord-Sender wurde aktiviert. Sofortige Reaktion der gesamten Crew erforderlich.",
            "manualButtonActivated": "Der manuelle Ausl\xf6ser eines Mann-\xfcber-Bord-Senders wurde aktiviert. Sofortige Reaktion der gesamten Crew erforderlich.",
            "manual": "Ein Crewmitglied hat manuell einen Mann-\xfcber-Bord-Alarm ausgel\xf6st. Sofortige Reaktion der gesamten Crew erforderlich.",
            "unknown": "Ein Mann-\xfcber-Bord-Signal wurde empfangen. Sofortige Reaktion der gesamten Crew erforderlich."
        }
    },
    "anchorMonitor": {
        "explanation": {
            "fixedRadius": "Warnt dich, wenn sich das Schiff weiter als ein fest eingestellter Abstand von der Ankerposition entfernt, angegeben direkt als Radius in Metern.\n\nNutze diese Methode, wenn du bereits wei\xdft, wie viel Schwojraum du hast \u2014 zum Beispiel in einem belegten Ankerplatz, an dem du den sicheren Abstand zu Nachbarbooten oder zum Ufer selbst abgesch\xe4tzt hast.",
            "rodeScope": "Berechnet den erwarteten Schwojradius aus der L\xe4nge deiner Ankerkette bzw. -leine, der Wassertiefe und der L\xe4nge deines Bootes, statt eines von dir selbst eingegebenen festen Abstands.\n\nNutze diese Methode, wenn LOGBOOK f\xfcr dich einen sinnvollen Radius anhand der ausgebrachten Kettenl\xe4nge berechnen soll \u2014 er passt sich automatisch an, wenn sich die Tiefe durch die Gezeiten \xe4ndert.",
            "sector": "\xdcberwacht einen gerichteten Peilungssektor statt eines vollen Kreises, sodass das Schwojen innerhalb des erwarteten Bogens ruhig bleibt, w\xe4hrend ein Abtreiben au\xdferhalb davon einen Alarm ausl\xf6st.\n\nNutze diese Methode in einer engen Fahrrinne oder einem Flussankerplatz, wo ein Schwojen entlang der Str\xf6mung normal ist, ein seitliches Abtreiben zum Ufer oder zu einem anderen Fahrzeug jedoch nicht."
        }
    },
    "changeLog": {
        "2026-09-30": 'Die Version 1.1 erg\xe4nzt LOGBOOK um viele neue n\xfctzliche Funktionen\n\nNeue Funktionen\n* Manueller Schiffsstatus - um unerw\xfcnschte Pausen-Eintr\xe4ge zu verhindern (automatisch aktiv bei Status "Br\xfccke" und "Wartend")\n* Ankerwache mit Warnung und Alarm\n* \xdcberwachung der Tiefe mit Warnung und Alarm\n* Hinweise auf laut KVR erforderlich Sichtzeichen\n* Manuelle Motor-Eintr\xe4ge: Hinweis auf fehlenden Eintrag f\xfcr "Motor an" (kann r\xfcckwirkend gesetzt werden)\n* Warnung bei Problemen mit den NMEA-Daten\n* Mann \xfcber Bord Alarm\n* Historie der \xc4nderungen \u2013 f\xfcr eine noch erweiterte Beweissicherheit\n* Leerlauf-Drehzahl f\xfcr Motoren einstellbar \u2013 Betrieb im Leerlauf wird gekennzeichnet und gilt nicht als Fahrt unter Motor\n\nVerbesserungen\n* Noch mehr Funktionen f\xfcr manuelle Log-Eintr\xe4ge direkt im Log-Men\xfc ausw\xe4hlbar\n* Manuelle Motor-Eintr\xe4ge: Drehzahl kann im Fokus-Modus nachgetragen werden\n* Personen in Crew etc. k\xf6nnen nur am aktuellen Tag und f\xfcr den n\xe4chsten Tag bearbeitet werden\n* Verbindung von Companions \xfcber Bonjour f\xfcr weitere Konstellationen m\xf6glich\n* Verbesserungen am Login-Dialog mit erweiterten Fehlermeldungen\n* Umfangreiche interne Optimierungen, die die App noch schneller und zuverl\xe4ssiger machen\n\nFehlerkorrekturen\n* Viele gr\xf6\xdfere und kleinere Optimierungen und Bug-Fixes.',
        "2026-08-14": "Das sind unsere Neuerungen im Update 2026-08-14:\n\nNeue Funktionen\n* Bei abgeschlossenen Tagen und Tagen ohne Log-Eintrag k\xf6nnen nachtr\xe4glich Eintr\xe4ge auf den Karten Wettervorhersage, Journal und Technisch gemacht werden.\n* Unterst\xfctzung des internen GPS unter Android\n* Warnung wenn das GPS ausf\xe4llt\n* Schnellauswahl der Segel im Men\xfc des Log-Buttons\n* Auf Android-Ger\xe4ten l\xe4uft das Primary LOGBOOK jetzt auch weiter, wenn sich die App im Hintergrund befindet\n* Anzeige der Uhrzeiten des Sonnenaufgangs und Sonnenuntergangs auf dem Tag-Datenblatt\n* Neue Optionen Br\xfccke und Warten bei Zwischenstopp und Schiffsstatus\n* Separate Einstellung der Geschwindigkeit f\xfcr das Ausl\xf6sen des Starteintrags am Anker und an Boje, um unn\xf6tige Eintr\xe4ge beim Schwojen zu vermeiden\n* Funktionen f\xfcr den Upload von Daten an den Support\n\nVerbesserungen\n* Neues Design der Buttons NMEA und Sync \u2013 aktueller Status besser erkennbar\n* Men\xfc des Log-Buttons \xf6ffnet jetzt nach oben, um unn\xf6tiges Scrollen zu vermeiden\n* GPS-Fehler oder zu gro\xdfe Abweichungen bei der Position (u.a. durch GPS-Jamming verursacht) werden ignoriert\n* Bei kleinen Screens erscheint der Stopp-Button nur noch mit einem Icon und kann durch den Expand-Button vergr\xf6\xdfert werden\n* Beim Wechseln der Reff-Stufe eines Segels, wird vorherige Reff-Stufe automatisch entfernt\n* Verbesserungen bei der Verbindung von Companion zum Primary, Unterst\xfctzung von Bonjour\n* Verbesserter Text bei \xc4nderungen an Crew, Skipper etc.\n* Vom System erstellte Log-Eintr\xe4ge (z.B. bei Datenausfall) erscheinen nur noch einmal\n\nFehlerkorrekturen\n* Zeitzone wird jetzt unter Windows auch richtig erkannt, wenn das System nicht auf Englisch als Sprache eingestellt ist\n* M\xf6gliche Fehler in der Statistik, die bei manuellen Motoreintr\xe4gen entstehen konnten, werden mit dem Update automatisch korrigiert\n* Vom System erstellte mehrfache Log-Eintr\xe4ge werden mit dem Update automatisch entfernt\n* Android: Bilder k\xf6nnen jetzt auch hochgeladen werden\n* Viele gr\xf6\xdfere und kleinere Optimierungen und Bug-Fixes.",
        "2026-07-15": "Das sind unsere Neuerungen im Update 2026-07-15:\n\nNeue Funktionen\n* Bei manuellen Motoreintr\xe4gen (NMEA enth\xe4lt keine Motordrehzahl) l\xe4sst es sich jetzt aktivieren, dass die manuell eingetragene Drehzahl automatisch in den n\xe4chsten Log-Eintrag \xfcbernommen wird. Das ist hilfreich bei Fahrten mit gleichbleibender Drehzahl. Die Option kann in den Schiffseinstellungen auf der Karte **Einstellungen** aktiviert werden.\n\nVerbesserungen\n* Verbesserungen und Fehlerkorrekturen bei der Statistik, insbesondere bei der Berechnung der Gesamtzeit und der Gesamtstrecke.\n\nFehlerkorrekturen\n* Viele gr\xf6\xdfere und kleinere Optimierungen und Bug-Fixes.   ",
        "2026-07-05": "Das sind unsere Neuerungen im Update 2026-07-05:\n\nNeue Funktionen\n* Franz\xf6sisch steht als zus\xe4tzliche Sprache f\xfcr das User-Interface zur Auswahl. \n* Neuer, multifunktionaler, kontextabh\xe4ngiger Log-Button neben der Log-Zeile f\xfcr das schnelle Hinzuf\xfcgen der unterschiedlichsten Eintragsarten.\n* In den Notes (Journal etc.) k\xf6nnen jetzt Bilder gel\xf6scht werden.\n* F\xfcr den Distanz-Wert aus der Logge kann in den Schiffseinstellungen ein Offset vorgegeben werden (z.B. wenn die Logge nicht die korrekten Gesamtmeilen des Schiffs anzeigt).\n\nVerbesserungen\n* Diverse zus\xe4tzliche Erl\xe4uterungen und Hilfestellungen im User-Interface\n* Zugriffsrechte und Crew-Rolle des Account-Inhabers sind jetzt fixiert, um Probleme mit verlorenen Zugriffsrechten zu vermeiden.\n* Bei mehreren Erg\xe4nzungen im Log-Eintrag werden jetzt alle \xc4nderungen im Kommentar gelistet.\n* Umfangreiche Optimierungen an der LOGBOOK-Cloud und der Kommunikation zwischen LOGBOOK-Cloud und LOGBOOK-App\n\nFehlerkorrekturen\n* Wenn keine Motor-Daten im NMEA vorhanden sind, werden die Motorbuttons jetzt sofort angezeigt.\n* Fehler behoben, dass bei manuellen Motor-Daten nach einer Datenunterbrechung 500 rpm eingetragen wurde.\n* Heading und Wind werden jetzt auch richtig ausgewertet, wenn nur relative Daten im NMEA enthalten sind.\n* Fehler behoben, dass es in der Statistic negative Zeiten angezeigt wurden.",
        "2026-06-11": "Das Update 2026-06-11 bringt viele Verbesserungen und Fehlerbehebungen:\n\nNeue Funktionen\n* Unterst\xfctzung f\xfcr das iPhone als Companion-Device.\n* Auswertung zus\xe4tzlicher NMEA-Datens\xe4tze f\xfcr Heading, Wind, Lufttemperatur und Luftdruck.\n\nVerbesserungen\n* Wenn mehrere Erg\xe4nzungen zu einem Eintrag hinzugef\xfcgt werden (z.B. Motor aus und Segel gesetzt), werden sie jetzt vollst\xe4ndig im Kommentar aufgelistet.\n* Der Logout vom Primary LOGBOOK ist jetzt nur noch zusammen mit dem Schlie\xdfen des Primary LOGBOOK m\xf6glich.\n* Optimierte Benutzerf\xfchrung durch verbesserte Hinweise, Empfehlungen und Warnungen.\n\nFehlerkorrekturen\n* NMEA-Test erkennt jetzt richtig, wenn es Werte aus der Logge gibt.\n* Fehler behoben, dass auf der Karte **Tag** ein falscher Tag-Status angezeigt wurde.\n* Fehler behoben, dass nach dem Ruhezustand des Devices fehlerhafte Crew-\xc4nderungen protokolliert wurden.\n* Fehler behoben, dass nach einer Unterbrechung der NMEA-Verbindung eine falsche Motordrehzahl eingetragen wurde.\n* Weitere Optimierungen und Fehlerbehebungen bei der Statistik.",
        "2026-05-30": 'Das sind unsere Neuerungen im Update 2026-05-30:\n\nNeue Funktionen\n* LOGBOOK kann nun an Bord mit mehreren Ger\xe4ten gleichzeitig verwendet werden. Dabei erfolgt in dieser ersten Stufe die Anmeldung auf allen Ger\xe4ten mit demselben Account. Siehe hierzu in der Dokumentation unter <a href="https://logbook.yachts/site/de/documentation/#h1_devices" target="_blank">**Mehrere Devices**</a>.\n\nFehlerkorrekturen\n* Fehler behoben, dass beim Drucken vereinzelt Bilder \xfcber den Druckbereich hinaus ragten.\n* Fehler behoben, dass bei westlichen Zeitzonen das falsche Datum angezeigt wurde.\n* Der aktuelle Tag zeigt jetzt immer das korrekte Datum und nicht mehr den 1. Januar an, auch wenn noch keine Eintr\xe4ge vorhanden sind.\n* \xc4nderungen im Tag-Datenblatt des n\xe4chsten Tages werden nicht protokolliert.\n* Fehler behoben, dass \xc4nderungen in der Crew protokolliert wurden, obwohl die Crew nicht ge\xe4ndert wurde.\n* Fehler behoben, dass bei manuellen Motoreintr\xe4gen nach einer Unterbrechung der NMEA-Verbindung eine Motordrehzahl eingetragen wurden.\n* Beim Stoppen erscheint jetzt direkt die richtige Dauer im Stopp-Button. \n* Fehler behoben, dass bei der Tages-Statistik die Zeit und Distanz doppelt gez\xe4hlt wurde.\n* iPad: Wei\xdfe Seite beim Wechsel von Cloud in App innerhalb der App behoben.',
        "2026-05-20": "Das sind unsere Neuerungen im Update 2026-05-20:\n\nNeue Funktionen\n* NMEA-Verbindung \xfcber UDP erg\xe4nzt.\n* Trackdaten werden laufend berechnet und regelm\xe4\xdfig synchronisiert, nicht erst nach dem Ende des Tages.\n* F\xfcr Tage, an denen es keinen Track gibt, wird der fehlende Track beim Neuberechnen der Statistiken (Button auf der Karte Statistik) automatisch generiert.\n* Bei manuellen Motoreintr\xe4gen bietet der Stopp-Dialog eine Option, um auch die Eintr\xe4ge f\xfcr **Motor aus** automatisch erstellen zu lassen.\n\nVerbesserungen\n* D\xe4mpfung bei der Erkennung von Pausen. Damit sollten falsche Pausen bei langsamer Fahrt oder bei Ungenauigkeiten im GPS sowie fehlerhafte Beendigungen von Pausen bei kurzfristigen Schiffsbewegungen oder GPS-Fehlern vermieden werden.\n* Die **Berechnung der Gesamtzeit** beginnt mit dem Losfahren und endet mit dem letzten Eintrag, ab dem das Schiff keine Fahrt mehr gemacht hat. Nicht die Fahrt betreffende Eintr\xe4ge zu Beginn und nach dem Ende werden nicht mehr ber\xfccksichtigt.\n\nFehlerkorrekturen\n* Fehler behoben, dass nach dem Neustart der Navigation am selben Tag die Distanz wieder bei 0 begann.",
        "2026-05-12": "Das sind unsere Neuerungen im Update 2026-05-12:\n\nNeue Funktionen\n* iPad: Die LOGBOOK-App l\xe4uft auch im Hintergrund weiter und erstellt weiterhin Logbucheintr\xe4ge, wenn die App nicht im Vordergrund ist. \n* iPad: Fotos k\xf6nnen jetzt direkt aus der App aufgenommen und in die Logbucheintr\xe4ge eingef\xfcgt werden.\n* iPad: Unterst\xfctzung von \xfcber **Bluetooth** oder per Kabel angeschlossenen **externen GPS-Ger\xe4ten**\n* Neue Funktion f\xfcr **Reset**, falls Verbindung der Cloud zum Primary LOGBOOK versehentlicht getrennt wurde (erkennbar am roten Marker auf dem Sync-Button)\n\nVerbesserungen\n* iPad: Layout-Fehler nach der R\xfcckkehr aus dem Hintergrund behoben\n* Server: Verbesserung bei der Berechnung der Statistiken",
        "2026-05-05": 'Das Update 2026-05-05 behebt ein paar Fehler:\n\n* Problem mit dem intergrierten GPS des iPad behoben, das bei sehr geringen Geschwindigkeiten zu falschen Pausen-Eintr\xe4gen f\xfchren konnte.\n* Problem behoben, dass eine deaktivierte NMEA-Verbindung automatisch aktiviert wurde, wenn die App auf dem iPad aus dem Hintergrund geholt wurde.\n* Fehler behoben, dass beim \xc4ndern der Fenstergr\xf6\xdfe (z.B. durch Drehen des Tablets) die Log-Eintr\xe4ge und die Log-Zeile nicht korrekt angezeigt wurden\n* Fehlerhaftes Feldformat bei den Schiffsdaten auf der Karte **Ausr\xfcstung** behoben.\n* Diverse kleinere Optimierungen am Layout \n* Diverse kleinere Bugfixes\n\nWenn du f\xfcr den Datenempfang das interne GPS verwendest, findest du wichtige Infos in unserem Tipp <a href="https://logbook.yachts/site/de/support/#ipadgps" target="_blank">**\xbbLOGBOOK mit dem internen GPS des iPad verwenden\xab**</a>.',
        "2026-04-27": "Das Update 2026-04-27 bringt eine ganze Reihe von Verbesserungen und Fehlerbehebungen. \nDazu geh\xf6ren weitere Optimierungen des Layouts f\xfcr unterschiedliche Bildschirmgr\xf6\xdfen sowie Fehlerbehandlung beim Import aus Logbook Suite.",
        "2026-04-14": "Hier kommt schon das erste, kleinere Update. Folgendes haben wir verbessert:\n\n* Optimiertes Layout f\xfcr mittlere Screens wie beispielsweise Tablet im Hochformat (768px bis 1023px) \n* Drucken-Button funktioniert jetzt auch auf dem iPad\n* Verbesserungen beim Import aus Logbook Suite\n* Diverse kleinere Bugfixes",
        "2026-04-04": "Willkommen bei LOGBOOK \u2013 die innovative Logbuch-Software f\xfcr Segler und Motorbootfahrer.\n\nDies ist die Version 1.0. In Zukunft wirst du an dieser Stelle nach jedem Update Informationen \xfcber neue Funktionen und Verbesserungen finden."
    },
    "connection": {
        "interrupted": "Die Verbindung zur Anwendung wurde unterbrochen. \n\nWenn sich die Verbindung nicht automatisch wiederherstellt, versuche bitte, die App neu zu starten.",
        "recovered": "Die Verbindung zur Anwendung wurde wiederhergestellt. \n\nBitte lade neu, um die App weiter zu verwenden."
    },
    "currentView": {
        "firstTrip": "**Eine neue Etappe wird gestartet** \n\nBitte \xfcberpr\xfcfe die **Zeitzone**, die f\xfcr diese Etappe eingestellt ist. \n\nDie Zeitzone wird automatisch auf die Systemzeitzone des Primary Device eingestellt. Um die Zeitzone zu \xe4ndern, musst du die Systemzeitzone des Primary Device **vor** dem Start der Etappe \xe4ndern. \n\nSollte das System des Primary Device die Zeitzone nicht korrekt an LOGBOOK \xfcbermittelt haben, kannst du die Zeitzone in den **Schiffs-Einstellungen** auf der Karte **Einstellungen** manuell \xe4ndern. Auch dies muss **vor** dem Start der Etappe geschehen.\n\n**Bitte beachte:** Sobald die Etappe hier gestartet wird, ist die Zeitzone festgelegt.",
        "demoWillStart": "**Hinweis:** Mit dem Start der ersten Etappe startest du auch deine 5-t\xe4gige Trial-Phase. ",
        "confirmationDialog": {
            "cruise": {
                "allowed": "Das Starten eines neuen T\xf6rns beendet den aktuellen T\xf6rn.\n\nBist du sicher, dass du den aktuellen T\xf6rn stoppen und abschlie\xdfen m\xf6chtest?\n\n**Bitte beachte**: Die NMEA-Aufzeichnung wird gestoppt.",
                "deniedInMotion": "Das Starten eines neuen T\xf6rns ist nicht m\xf6glich, da das Schiff in Fahrt ist.",
                "deniedBlankExists": "Das Starten eines neuen T\xf6rns ist nicht m\xf6glich, da es bereits einen leeren, noch nicht gestarteten T\xf6rn gibt."
            },
            "trip": {
                "allowed": "Das Starten einer neuen Etappe beendet die aktuelle Etappe.\n\nBist du sicher, dass du die aktuelle Etappe stoppen und abschlie\xdfen m\xf6chtest?\n\n**Bitte beachte**: Die NMEA-Aufzeichnung wird gestoppt.",
                "deniedInMotion": "Das Starten einer neuen Etappe ist nicht m\xf6glich, da das Schiff in Fahrt ist.",
                "deniedBlankExists": "Das Starten einer neuen Etappe ist nicht m\xf6glich, da es bereits eine leere, noch nicht gestartete Etappe gibt."
            }
        }
    },
    "importShip": {
        "text": "So importierst du deine Logb\xfccher aus **Logbook Suite** in **LOGBOOK**:\n\n**Schritt 1:** Gehe zuerst zu Logbook Suite und exportiere mit der Funktion **Export f\xfcr LOGBOOK** (im Logbook Suite Manager ab Version 2.6) **Button Mehr \u2026** alle Logb\xfccher, die du f\xfcr dein Schiff erstellt hattest. \n\n**Schritt 2:** Lege in LOGBOOK ein neues Schiff mit demselben Namen an. Schlie\xdfe den nach dem Erstellen angezeigten Dialog, um die Account-Einstellungen in der LOGBOOK Cloud anzuzeigen. (Dieser Schritt entf\xe4llt, falls du das Schiff bereits erstellt hast. Stelle sicher, dass das Schiff weder in der Cloud noch in der App ge\xf6ffnet ist, bevor du mit Schritt 3 fortf\xe4hrst.) \n\n**Schritt 3:** Dein neues Schiff erscheint jetzt in der Liste. W\xe4hle f\xfcr das Schiff, in das Logb\xfccher importiert werden sollen, **Optionen** und dann **Aus LogbookSuite importieren**. Folge den weiteren Anweisungen. (Die Importfunktion steht nur zur Auswahl, wenn das LOGBOOK des Schiffs nicht ge\xf6ffnet ist.)    \n\n**Schritt 4:** Starte in der LOGBOOK-App einen neuen T\xf6rn, bevor du die Datenerfassung mit LOGBOOK beginnst oder fortsetzt.\n    "
    },
    "importTrips": {
        "text": "Importiere Logb\xfccher, die mit **Logbook Suite** f\xfcr dein Schiff **{name}** erstellt wurden, in **LOGBOOK**. W\xe4hle die mit dem Export-Tool von Logbook Suite erstellte Datei aus, die den folgenden Namen hat: ***[Name des Schiffs]_LOGBOOK_export.logbook***\n\nFalls in deinem importierten Logbuch Schiffsdaten enthalten sind, die noch nicht mit LOGBOOK erfasst wurden, werden die Daten aus Logbook Suite \xfcbernommen. Bereits in LOGBOOK eingetragene Schiffsdaten werden nicht \xfcberschrieben.\n\n**Wichtiger Hinweis:** Der Importvorgang kann einige Zeit in Anspruch nehmen, insbesondere wenn du ein gro\xdfes Logbuch hast. Bitte sei geduldig und unterbreche den Vorgang nicht.   \n\n**Achtung:** Nach dem Import musst du unbedingt einen **neuen T\xf6rn starten**, bevor du die Datenerfassung in LOGBOOK startest oder fortsetzt."
    },
    "login": {
        "welcomeCloud": "Melde dich an oder erstelle deinen Account und f\xfchre dein Schiffs-Logbuch mit LOGBOOK. \n\nDu kannst LOGBOOK kostenlos testen und Eintr\xe4ge f\xfcr 5 Tage erstellen.",
        "welcomeApp": "Melde dich in der LOGBOOK-App an.\n\nWenn du noch keinen Account hast, kannst du ihn [hier](logbook:signup) erstellen.",
        "welcomeAppiPad": "Melde dich in der **LOGBOOK for Yachts** App f\xfcr iOS an.\n\nWenn du noch keinen Account hast, kannst du ihn [hier](logbook:signup) erstellen.",
        "signupSuccess": "Dein Account wurde erstellt.\n\nWir haben eine E-Mail zur Aktivierung an deine E-Mail-Adresse gesendet. Bitte folge dem Link in der E-Mail, um fortzufahren.",
        "invitation": "{inviter} hat dich eingeladen und m\xf6chte dir Zugriff auf sein LOGBOOK f\xfcr **{ship}** geben. \n\nWenn du bereits einen Account f\xfcr LOGBOOK eingerichtet hast, melde dich einfach bei deinem Account an. \n\nWenn du noch nicht bei LOGBOOK registriert bist, registriere dich bitte hier, um deinen kostenlosen Account zu erstellen. Du wirst dann direkt angemeldet.\n\nNach der Anmeldung ist dein LOGBOOK-Account mit dem LOGBOOK-Account von {inviter} verbunden. Logge dich anschlie\xdfend in die LOGBOOK-App ein. In der Schiffsliste in deinen Account-Einstellungen erscheint **{ship}** unter **Aus geteilten Schiffen ausw\xe4hlen** und du kannst dich direkt als Companion mit dem LOGBOOK f\xfcr {ship} verbinden.",
        "invitationLoggedIn": "{inviter} hat dich eingeladen und m\xf6chte dir Zugriff auf sein LOGBOOK f\xfcr **{ship}** geben. \n\nMit **Einladung annehmen** best\xe4tigst du die Einladung. Logge dich anschlie\xdfend in die LOGBOOK-App ein.In der Schiffsliste in deinen Account-Einstellungen erscheint **{ship}** unter **Aus geteilten Schiffen ausw\xe4hlen** und du kannst dich direkt als Companion mit dem LOGBOOK f\xfcr {ship} verbinden.\n\nMit **Anderen Account verwenden** kannst du auch einen anderen Account ausw\xe4hlen oder erstellen, um Zugriff auf das LOGBOOK f\xfcr {ship} zu erhalten.",
        "resetAppWarning": "Falls es Probleme beim Starten der App oder beim \xd6ffnen eines Schiffs gibt, kannst du die LOGBOOK-App mit dieser Funktion zur\xfccksetzen. \n\nDabei werden alle Daten, die auf dem Ger\xe4t gespeichert sind, gel\xf6scht. Alle Daten, die von der LOGBOOK-App in die LOGBOOK-Cloud geladen wurden und dort gespeichert sind, bleiben erhalten. \n\nNach dem Zur\xfccksetzen musst du die LOGBOOK-App neu \xf6ffnen und dich mit deinem Account anmelden. Beim \xd6ffnen deines Schiffs l\xe4dt die LOGBOOK-App dann wieder alle Daten aus der LOGBOOK-Cloud.    \n\n**Wichtig!** F\xfchre das Zur\xfccksetzen der LOGBOOK-App nur aus, wenn du eine Internetverbindung hast.\n\nBist du sicher, dass du die App zur\xfccksetzen m\xf6chtest?",
        "resetAppComplete": "Das Zur\xfccksetzen der LOGBOOK-App ist abgeschlossen. \n\nFalls die LOGBOOK-App nicht automatisch beendet wurde, musst du sie manuell \xfcber das Betriebssystem schlie\xdfen (killen) und erneut starten."
    },
    "logout": {
        "logoutWithInternet": "**Warnung \u2013 Primary LOGBOOK f\xfcr {name} ge\xf6ffnet**\n\nIn der App ist noch das **Primary LOGBOOK {name}** ge\xf6ffnet. Mit dem Logout wird das Primary LOGBOOK geschlossen. Um das Primary LOGBOOK wieder zu \xf6ffnen, ist eine Internet-Verbindung erforderlich. ",
        "logoutWithoutInternet": "**Logout nicht m\xf6glich \u2013 keine Internet-Verbindung** \n\nF\xfcr das Ausloggen wird eine Internet-Verbindung ben\xf6tigt. Bitte \xfcberpr\xfcfe deine Verbindung und versuche es erneut."
    },
    "nmeaSettings": {
        "connectionTypeNative": "Um das **interne GPS** zu verwenden, w\xe4hle unter **NMEA-Verbindungstyp** die Option **Internes GPS**. Auf der Karte **Test und Daten** wird der GPS-Empfang \xfcber das interne GPS separat angezeigt.\n\nEin **externes GPS-Ger\xe4t**, das \xfcber **Bluetooth** oder per **Kabel** an das iPad angeschlossen ist, verh\xe4lt sich genauso wie das interne GPS. W\xe4hle also f\xfcr das externe GPS-Ger\xe4t ebenfalls den Verbindungstyp **Internes GPS**.\n\nWeitere verf\xfcgbare **interne Sensoren** wie beispielsweise ein **internes Barometer** k\xf6nnen unabh\xe4ngig von der Verwendung des internen GPS auf der Karte **Interne Sensoren** aktiviert werden. ",
        "connectionTypeNativeWarning": "**Wichtiger Hinweis**\n\nBei Verwendung des internen GPS solltest du, um falsche Eintr\xe4ge zu vermeiden, bevor du das iPad von Bord des Schiffs nimmst entweder die NMEA-Verbindung trennen oder das Primary LOGBOOK deines Schiffs \xfcber den Men\xfcbefehl schlie\xdfen.\n\nBitte beachte aber, dass sowohl f\xfcr das Schlie\xdfen des Schiffs als auch f\xfcr das erneute \xd6ffnen eine Internet-Verbindung erforderlich ist."
    },
    "noteText": {
        "uninitialized": "**Synchronisation wird initialisiert**\n\nBitte warte. Dies kann einige Minuten dauern.",
        "failed": "Synchronisation fehlgeschlagen. Wird in K\xfcrze erneut versucht.",
        "initialSyncFailed": "Erste Synchronisation fehlgeschlagen. Wird in K\xfcrze erneut versucht.",
        "initialSyncInProgress": "**Erste Synchronisation gestartet**\n\nBitte warte. Dies kann einige Minuten dauern.",
        "dataWaiting": "Warten auf Synchronisation.",
        "inProgress": "**Synchronisation l\xe4uft** \n\nBitte warte. Dies kann einige Minuten dauern.",
        "current": "Vollst\xe4ndig synchronisiert.",
        "disconnected": "**Verbindung zur LOGBOOK-Cloud verloren**\n\nDieses Ger\xe4t ist nicht mehr als Primary LOGBOOK registriert, daher wurde die Synchronisation gestoppt.\n\nStelle die Verbindung \xfcber **Verbindung wiederherstellen** im Men\xfc **Sync** wieder her. Du wirst gefragt, ob die Daten auf diesem Ger\xe4t oder die Daten in der LOGBOOK-Cloud behalten werden sollen.",
        "transition": "**Daten werden vorbereitet**\n\nVorhandene Eintr\xe4ge werden f\xfcr diese Version aktualisiert. Bitte warte, dies kann einige Minuten dauern.",
        "resync": "Daten aus deinem Device werden in die LOGBOOK-Cloud hochgeladen.",
        "newShip": "**Wichtiger Hinweis** \n\nDer **Schiffstyp** und die **Anzahl der Motoren** k\xf6nnen nach der Erstellung des Schiffs nicht mehr ge\xe4ndert werden.",
        "shipOpen": "Das **Primary LOGBOOK** f\xfcr **{name}** ist bereits auf einem anderen Device ge\xf6ffnet. \n\n**Fall 1 - Du bist an Bord des Schiffs**\n\nStelle sicher, dass dein Device mit dem **schiffsinternen Netzwerk** verbunden ist. \nTrage dann hier die Adresse des Primary LOGBOOK ein, um eine Verbindung herzustellen. Verwende die Form **IP:Port**, z.B. 192.168.0.100:8000. Du findest die Adresse im Primary LOGBOOK in den **Schiffseinstellungen** unter **Companions**.",
        "shipOpen2": "** **\n\n**Fall 2 - Kein schiffsinternes Netzwerk vorhanden oder du befindest dich nicht an Bord des Schiffs**\n\nDann kannst du dir jederzeit den zuletzt synchronisierten Stand des Logbuchs in der **LOGBOOK-Cloud** ansehen.\n\n** **\n\n**Fall 3 - Du m\xf6chtest das Logbuch als Primary LOGBOOK auf diesem Device \xf6ffnen**\n\nFalls n\xf6tig, kann du mit **Primary LOGBOOK trennen**, die Verbindung zwischen dem Primary LOGBOOK und der LOGBOOK-Cloud zwangsweise trennen. ",
        "shipNotClosed": "Verwende diese Funktion nur, wenn du sicher bist, dass das Primary LOGBOOK von der LOGBOOK-Cloud getrennt werden muss \u2013 beispielsweise, weil das Primary Device defekt ist oder aus anderen Gr\xfcnden kein Zugriff mehr auf das Primary Device m\xf6glich ist. \n\nAlle Daten, die nach dem Trennen vom Primary LOGBOOK aufgezeichnet werden, werden nicht synchronisiert und k\xf6nnen verloren gehen.\n    \n- Wechsle mit dem Button unten zur Schiffsliste in der LOGBOOK-Cloud.\n\n- \xd6ffne mit dem Button **Optionen** den gleichnamigen Dialog (der Button erscheint bei dem betroffenen Schiff in einer anderen Farbe). \xdcber diesen kannst du nun das Schiff trennen.\n\nNach einer kurzen Wartezeit l\xe4sst sich das Primary LOGBOOK des Schiffs dann wieder \xf6ffnen. Ggf. kannst du die Ansicht mit dem Refresh-Button aktualisieren. Das erneute \xd6ffnen kann einige Minuten dauern, da die LOGBOOK-App alle Daten aus der LOGBOOK-Cloud abrufen muss.",
        "shipOpenCompanion": "Trage hier die Adresse des Primary LOGBOOK ein, um eine Verbindung herzustellen. \n\nVerwende die Form **IP:Port**, z.B. **192.168.0.100:8000**. \n\nDu findest die Adresse im Primary LOGBOOK in den Schiffseinstellungen unter **Companions**.",
        "shipsSmartphone": "LOGBOOK kann auf dem Smartphone nur als Companion verwendet werden und bietet daher eine eingeschr\xe4nkte Funktionalit\xe4t.\n\nAusw\xe4hlbar sind nur Schiffe, deren Primary LOGBOOK bereits auf einem anderen Device l\xe4uft. F\xfcr die Companion-Verbindung muss sich dein Smartphone im selben Netzwerk wie das Primary Device befinden.",
        "selectShip": "Schiff wird in der LOGBOOK-Cloud ausgew\xe4hlt.",
        "selectShipFailed": "Auswahl des Schiffs in der LOGBOOK-Cloud fehlgeschlagen.\n\nBitte versuche es in ein paar Minuten erneut.",
        "limitActiveShipsReached": "Du hast dein Limit an aktiven Schiffen erreicht.\n\nUm ein anderes Schiff auszuw\xe4hlen, musst du zuerst das aktuell ge\xf6ffnete Schiff in der LOGBOOK-Cloud schlie\xdfen.",
        "startShip": '<strong>Dein Schiff "{name}" wurde erstellt \u2013 Wechsel nun zur LOGBOOK-App</strong>\n\nDein neues Schiff wurde erfolgreich erstellt und wird jetzt hier in der **LOGBOOK-Cloud** angezeigt. \n\nWenn du willst, kannst du direkt hier in der LOGBOOK-Cloud weitere Schiffsdaten eintragen. W\xe4hle daf\xfcr den Men\xfcpunkt **{name} Schiffsdaten** aus dem Men\xfc <strong>{name}</strong>. \n\nAls n\xe4chstes m\xfcssen der erste T\xf6rn und die erste Etappe vorbereitet werden. \xd6ffne daf\xfcr dein neues Schiff in der **LOGBOOK-App**. Falls du die LOGBOOK-App noch nicht installiert hast, findest du die Download-Links hier: <a href="https://logbook.yachts/site/de/download" target="_blank">Download LOGBOOK-App</a>.  \n\nSobald der erste T\xf6rn und die erste Etappe erstellt wurden, werden sie auch hier in der LOGBOOK-Cloud angezeigt. ',
        "firstLogin": '**Willkommen bei LOGBOOK** \u2013 die innovative Logbuch-Software \n\n**Dein Account wurde erfolgreich erstellt.**\n\n<li>Lege jetzt dein <strong>erstes Schiff</strong> an \u2026</li>\n<li>\u2026 richte die <strong>NMEA-Verbindung</strong> ein \u2026</li>\n<li>\u2026 und schon bist du <strong>startklar f\xfcr deine erste Fahrt</strong> mit LOGBOOK.</li>\n\nAusf\xfchrliche Anleitungen findest du im <a href="https://logbook.yachts/site/de/documentation/#h1_quickstart" target="_blank">QuickStart</a> und in den <a href="https://logbook.yachts/site/de/demos" target="_blank">interaktiven Demos</a>.',
        "firstLoginCloud": "Falls du die LOGBOOK-App noch nicht installiert hast, findest du die Download-Links hier: <a href=\"https://logbook.yachts/site/de/download\" target=\"_blank\">Download LOGBOOK-App</a>.  "
    },
    "sessionExpired": {
        "text": "**Login erforderlich \u2013 keine Verbindung zur LOGBOOK Cloud**\n\nDie LOGBOOK Cloud akzeptiert den Login dieses Ger\xe4ts nicht mehr. Es ist nichts verloren gegangen: Dein Schiff bleibt ge\xf6ffnet und alle Eintr\xe4ge werden auf diesem Ger\xe4t gespeichert.\n\nBis zum erneuten Einloggen werden keine Daten in die Cloud synchronisiert und andere Ger\xe4te sehen deine Eintr\xe4ge nicht."
    },
    "shipClose": {
        "text": "Bist du sicher, dass du das Primary LOGBOOK des Schiffs **{name}** schlie\xdfen m\xf6chtest?\n\n**Dies beendet die Aufzeichnung und trennt die Verbindung zum NMEA.**\n\nBitte beachte auch: Du ben\xf6tigst eine **Internet-Verbindung**, wenn du sp\xe4ter zu diesem Schiff zur\xfcckkehren m\xf6chtest!",
        "internet": "**Schlie\xdfen des Schiffs nicht m\xf6glich \u2013 keine Internet-Verbindung**\n\nF\xfcr das Schlie\xdfen des Schiffs wird eine Internet-Verbindung ben\xf6tigt. Bitte \xfcberpr\xfcfe deine Verbindung und versuche es erneut.",
        "forceWarning": "**Nur auf diesem Ger\xe4t schlie\xdfen?**\n\nDadurch wird **{name}** lokal ohne Synchronisierung geschlossen. Das Schiff bleibt in der LOGBOOK Cloud beansprucht und muss dort manuell geschlossen werden, bevor es wieder ge\xf6ffnet werden kann.\n\nNicht synchronisierte lokale Daten bleiben auf diesem Ger\xe4t gespeichert.",
        "keepOpen": "**Tipp:**\n<p>Wir empfehlen, das <strong>Primary LOGBOOK</strong> w\xe4hrend des gesamten T\xf6rns <strong>ge\xf6ffnet zu lassen</strong>. <br>\nAm Ende des Tages kannst du die App einfach beenden. <br>\nLass das <strong>Primary LOGBOOK ge\xf6ffnet</strong> und <strong>logge dich nicht aus</strong>. Der Datenempfang wird dann unterbrochen, der Status des <strong>Primary LOGBOOK</strong> bleibt aber erhalten. <br>\nNach dem erneuten Starten der App ist das <strong>Primary LOGBOOK</strong> sofort wieder verf\xfcgbar.</p>",
        "noSync": "Die Synchronisation mit der LOGBOOK-Cloud ist fehlgeschlagen, da dieses LOGBOOK nicht mehr in der LOGBOOK-Cloud als Primary LOGBOOK registriert ist.\n\nWenn du das Schiff schlie\xdft, gehen alle \xc4nderungen verloren, die noch nicht in der LOGBOOK Cloud gespeichert wurden.\n\nMit **Verbindung wiederherstellen** aus dem Men\xfc **Sync** kannst du ggf. die Verbindung zur LOGBOOK Cloud wiederherstellen, um die Daten zu synchronisieren und dann das Schiff zu schlie\xdfen."
    },
    "shipInfo": {
        "disconnect": "Bist du sicher, dass du das Primary LOGBOOK f\xfcr das Schiff **{name}** trennen m\xf6chtest?\n\n**Dies stoppt jede Synchronisation dieses Logbuchs mit der LOGBOOK-Cloud.**\n\nBitte beachte auch:\n\nFalls das Primary LOGBOOK auf dem Schiff keine Internet-Verbindung hat, werden alle Daten, die nach dem Trennen aufgezeichnet werden, nicht synchronisiert und k\xf6nnen verloren gehen.",
        "resync": "Das Primary LOGBOOK deines Schiffs **{name}** ist nicht mehr mit der LOGBOOK-Cloud verbunden. Um diese Verbindung wiederherzustellen, m\xfcssen die Daten erneut synchronisiert werden. \n\nDabei werden entweder die Daten auf dem Device oder die Daten in der LOGBOOK-Cloud zur\xfcckgesetzt. Anschlie\xdfend wird dieses Device als **Primary LOGBOOK** f\xfcr **{name}** eingerichtet. Zuletzt werden die Daten zwischen dem Primary LOGBOOK und der LOGBOOK-Cloud synchronisiert. \n\n**Achtung!** \n\nDiese Funktion ist nur f\xfcr den \xe4u\xdfersten Notfall gedacht. F\xfchre sie nur auf dem Device aus, das als **Primary LOGBOOK** f\xfcr **{name}** eingerichtet ist. Falls das Primary LOGBOOK eigentlich auf einem anderen Device eingerichtet ist, gehen die mit diesem Device erfassten Daten ggf. verloren.\n\n* Pr\xfcfe zuerst, ob die Daten hier in der LOGBOOK-App oder in der LOGBOOK-Cloud neuer sind.\n\n* Entscheide dann, ob du die Daten hier in der LOGBOOK-App oder die Daten in der LOGBOOK-Cloud als aktuelle Daten behalten m\xf6chtest.\n\n* W\xe4hle zum Starten des Vorgangs den passenden Button.",
        "resyncUnavailable": "Das Zur\xfccksetzen des LOGBOOK deines Schiffs **{name}** konnte nicht ausgef\xfchrt werden, da in der LOGBOOK-Cloud noch ein Device mit dem Schiff verbunden ist.\n\n**Wichtig:** Pr\xfcfe zuerst, ob das Primary LOGBOOK aktuell auf einem anderen Device l\xe4uft. Falls ja, starte den Vorgang von diesem anderen Device aus und f\xfchre die Schritte dort durch.\n\nUm hier fortzufahren, trenne die Verbindung zu diesem Device in der LOGBOOK-Cloud:\n\n* Wechsel mit dem Befehl **Zur LOGBOOK Cloud** aus dem **Account**-Men\xfc in die LOGBOOK-Cloud.\n* In der LOGBOOK-Cloud ist der Button **Optionen** neben deinem Schiff blau hervorgehoben. \n* W\xe4hle in den Optionen **Schiff trennen**. \n* Wechsel zur\xfcck in die LOGBOOK-App. \n* \xd6ffne erneut den Dialog zum Wiederherstellen der Synchronisierung. Nun kannst du w\xe4hlen, welche Daten du behalten m\xf6chtest.",
        "resync_reset_local_confirm": "**M\xf6chtest du wirklich die lokalen Daten verwenden?**\n\nDiese Aktion setzt die Cloud-Daten zur\xfcck. \n\nDiese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden und f\xfchrt zum Verlust aller Daten, die nur in der LOGBOOK-Cloud gespeichert und nicht auf diesem Device vorhanden sind.",
        "resync_reset_cloud_confirm": "**M\xf6chtest du wirklich die Cloud-Daten verwenden?**\n\nDiese Aktion setzt die lokalen Daten zur\xfcck.\n\nDiese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden und f\xfchrt zum Verlust aller Daten, die nur auf diesem Device gespeichert und nicht in der LOGBOOK-Cloud vorhanden sind."
    },
    "shipSetting": {
        "utc": "**Wichtiger Hinweis** \n\n**Bitte beachte, dass die Zeitzone f\xfcr die Bordzeit nach dem Starten der Etappe f\xfcr die gesamte Etappe unver\xe4nderlich ist.** Eine \xc4nderung hier hat keine Auswirkung auf eine bereits gestartete Etappe.",
        "utc_info": "Grunds\xe4tzlich setzt LOGBOOK die Bordzeit auf die Systemzeit des Primary Device. \n\nIn Einzelf\xe4llen kann es vorkommen, dass das System des Primary Devices die Zeitzone nicht korrekt an LOGBOOK \xfcbermittelt. In diesem Fall hast du hier die M\xf6glichkeit, die Zeitzone f\xfcr die Bordzeit manuell einzustellen.",
        "log_offset": "Wurde deine Logge ausgetauscht und konnte der bisherige Loggewert nicht \xfcbernommen werden? Dann trage hier den alten Wert als Offset ein. Er wird automatisch zu den neuen Messwerten addiert, damit die Gesamtstrecke deines Schiffs korrekt weitergef\xfchrt wird.",
        "keep_rpm": "Wenn keine Motordaten \xfcber NMEA verf\xfcgbar sind, kannst du diese Option aktivieren, damit der manuell eingegebene Drehzahlwert automatisch in den n\xe4chsten Logeintrag \xfcbernommen wird. Das ist hilfreich, wenn sich die Motordrehzahl zwischen den Eintr\xe4gen nicht \xe4ndert.",
        "lights": "Wenn aktiviert, erinnert dich LOGBOOK dezent mit einem Hinweis in der Log-Zeile, sobald die f\xfcr das Schiff eingetragene Sichtzeichen nicht dem von den KVR empfohlenen f\xfcr den aktuellen Fahrzustand und die Tageszeit entspricht.\n\nEs wird nie ein Alarm ausgel\xf6st \u2014 das Eintragen der passenden Sichtzeichen schlie\xdft den Hinweis. \n\nLege fest, welche Lichter dein Schiff unter Segeln f\xfchrt, ob die Tag-/Nachtgrenze der b\xfcrgerlichen D\xe4mmerung oder dem Sonnenunter-/aufgang folgt und ob an den Motorkegel erinnert werden soll.",
        "edit_permissiveness": "Legt fest, wie freiz\xfcgig das Bearbeiten eines Log- oder Tageseintrags nach dem Speichern ist. Dies wirkt sich auf jeden bestehenden und zuk\xfcnftigen Eintrag aus, sobald die Einstellung ge\xe4ndert wird \u2014 nicht nur auf danach neu angelegte Eintr\xe4ge.\n\n**Standard (streng)** \u2014 das heutige Verhalten. Ein Wert, der live per NMEA geliefert wurde (z. B. Kurs, Tiefe, Motordrehzahl, Logge, Luftdruck, Temperatur, Luftfeuchtigkeit, Wind, Kurs \xfcber Grund, Fahrt \xfcber Grund), bleibt gesperrt, bis du ihn manuell korrigierst, und ist nur kurz nach der Aufzeichnung bearbeitbar.\n\nManuelle Motordrehzahlen sind von der Zeitbeschr\xe4nkung ausgenommen: Sie k\xf6nnen auch in fr\xfcheren Eintr\xe4gen eingegeben oder korrigiert werden. Noch als NMEA-Daten gesch\xfctzte Drehzahlen bleiben gesperrt.\n\n**Erweitert** \u2014 hebt die Zeitbeschr\xe4nkung auf, sodass per NMEA gelieferte Werte auch sp\xe4ter noch korrigiert werden k\xf6nnen. Werte, die noch nicht manuell korrigiert wurden, bleiben aber weiterhin gesch\xfctzt.\n\n**Uneingeschr\xe4nkt** \u2014 entfernt diesen Schutz vollst\xe4ndig. Jeder Wert, auch ein live per NMEA gelieferter, kann jederzeit bearbeitet werden. **Bitte mit Bedacht verwenden:** Dadurch entf\xe4llt der Hinweis, dass ein Wert automatisch von einem Sensor stammt statt manuell eingegeben oder ge\xe4ndert wurde \u2014 das kann f\xfcr den Beweiswert deines Logbuchs relevant sein.\n\nEinige Felder (z. B. die Distanz) werden immer automatisch berechnet und k\xf6nnen auf keiner Stufe direkt bearbeitet werden."
    },
    "planDescriptions": {
        "captain": "Jahresabo f\xfcr Profis, Schiffsl\xe4nge unter 24 m",
        "master_captain": "Jahresabo f\xfcr Profis, Schiffsl\xe4nge ab 24 m",
        "skipper": "Monats- oder Jahresabo f\xfcr private Skipper",
        "skipper_inApp": "Monatsabo f\xfcr private Skipper \u2013 in-App-Kauf",
        "trial": "5 Tage testen"
    },
    "subscription": {
        "checkoutComplete": "Kauf erfolgreich abgeschlossen.",
        "checkoutProcessing": "Kauf wird abgeschlossen...",
        "subscriptionMessage": "W\xe4hle den Plan aus, der am besten zu dir passt.\n\nEgal von welchem Ger\xe4t aus du dieses Abo erwirbst, kannst du LOGBOOK mit allen unterst\xfctzten Ger\xe4ten gleichzeitig oder wechselweise verwenden (macOS, Windows, Android und iOS). Das Abo ist nicht an eine Plattform gebunden.",
        "subscriptionMessageiPad": "Schlie\xdfe ein Abo ab, um LOGBOOK nach Ende der Testphase weiter mit vollem Funktionsumfang verwenden zu k\xf6nnen.\n\nNach Ablauf der 5 kostenlosen Tage kannst du deine gespeicherten Daten nur noch ansehen und drucken. Es sind keine weiteren Eintr\xe4ge oder Bearbeitungen m\xf6glich.\n\nDas Monats-Abo **LOGBOOK Skipper** eignet sich besonders f\xfcr private Skipper, die ihr Logbuch bevorzugt oder ausschlie\xdflich auf dem iPad f\xfchren m\xf6chten. Das Abo verl\xe4ngert sich automatisch und ist jeweils zum Ablauf der Laufzeit k\xfcndbar.\n\nDieses Abo kann auch auf anderen Plattformen verwendet werden, gleichzeitig oder wechselweise.",
        "demo1Day": "**Trial-Phase endet in einem Tag**\n\nDu hast noch einen Tag Zeit, LOGBOOK kostenlos zu testen und Eintr\xe4ge zu erstellen.\n\nDanach kannst du mit einem Abo nahtlos weitermachen und dein Logbuch ohne Unterbrechung fortf\xfchren.",
        "demo2Days": "**Trial-Phase endet in 2 Tagen**\n\nDu kannst noch an 2 weiteren Tagen kostenlos Eintr\xe4ge in LOGBOOK erstellen. \n\nDanach kannst du mit einem Abo nahtlos weitermachen und dein Logbuch ohne Unterbrechung fortf\xfchren.",
        "demoEnded": "**Trial-Phase beendet**\n\nDeine Trial-Phase ist vorbei. Mit einem Abo kannst du dein Logbuch jetzt weiterf\xfchren. Deine Testdaten speichern wir noch 6 Monate in der LOGBOOK-Cloud f\xfcr dich.",
        "demoToday": "**Trial-Phase endet heute**\n\nDu kannst noch heute kostenlos Eintr\xe4ge in LOGBOOK erstellen. \n\nDanach endet die Trial-Phase. Mit einem Abo kannst du dein Logbuch jederzeit weiterf\xfchren.",
        "demoStarted": "**Trial-Phase gestartet**\n\nMit deinem ersten Eintrag in LOGBOOK hat deine Trial-Phase begonnen. \n\nDu kannst jetzt an insgesamt **5 Tagen** Logbuch-Eintr\xe4ge erstellen.",
        "subscription7Days": "**Abo endet in wenigen Tagen**\n\nDein Abo l\xe4uft bald aus. Keine Sorge \u2013 die Verl\xe4ngerung erfolgt automatisch, damit du dein Logbuch ohne Unterbrechung weiterf\xfchren kannst.\n\nFalls du dein Abo anpassen m\xf6chtest, kannst du das jederzeit tun.",
        "subscriptionExpired": "**Abo abgelaufen**\n\nDein Abo ist abgelaufen. Aber keine Sorge \u2013 alle deine Daten bleiben noch 2 Jahre sicher in der LOGBOOK-Cloud gespeichert.\n\nVerl\xe4ngere jetzt dein Abo, um dein Logbuch weiterzuf\xfchren.",
        "subscriptionToday": "**Abo endet heute**\n\nDein Abo l\xe4uft heute aus. Verl\xe4ngere es jetzt, um dein Logbuch weiterhin nutzen zu k\xf6nnen.",
        "removeAccount": 'Best\xe4tige das L\xf6schen deines Accounts.\n\nMit dieser Best\xe4tigung werden das Konto "{account}" und der Benutzer "{user}" dauerhaft gel\xf6scht. \n\nDu verlierst den Zugriff auf alle Schiffe, T\xf6rns, Etappen und Logbucheintr\xe4ge, die mit diesem Konto verbunden sind.',
        "removeAccountDone": 'Dein Account Konto "{account}" und der Benutzer "{user}" bei LOGBOOK wurde erfolgreich gel\xf6scht.'
    },
    "mailer": {
        "footer": '---\n\n![TRIMUTIC \u2013 THE LOGBOOK COMPANY](https://trimutic.com/media/trimutic_komplett-black.png "logo")\n\n[TRIMUTIC](https://trimutic.com) | [LOGBOOK](https://logbook.yachts) | [Datenschutz](https://logbook.yachts/site/de/privacy) | [\xdcber uns](https://logbook.yachts/site/de/about)\n\n{reason}',
        "templates": {
            "signupConfirmation": {
                "subject": "Willkommen bei LOGBOOK \u2013 Best\xe4tige deine E-Mail",
                "footer": "Diese E-Mail wurde gesendet, weil du ein Konto f\xfcr LOGBOOK auf unserer Website erstellt hast.\nWenn du kein Konto f\xfcr LOGBOOK erstellt hast, kannst du diese E-Mail ignorieren.",
                "body": 'Hallo {name},\n\nWillkommen bei LOGBOOK - Best\xe4tige deine E-Mail\n\nKlicke auf die Schaltfl\xe4che, um deine E-Mail-Adresse zu best\xe4tigen:\n\n[E-Mail-Adresse best\xe4tigen]({confirmation_link} "button")\n\nDies hilft uns sicherzustellen, dass dein Konto sicher ist und du wichtige Updates \xfcber dein Logbuch erhalten kannst.\nWenn die Schaltfl\xe4che oben nicht funktioniert, kopiere diesen Link und f\xfcge ihn in deinen Browser ein:\n\n{confirmation_link}\n\nDieser Best\xe4tigungslink l\xe4uft in 24 Stunden ab.\nWenn du kein Konto bei LOGBOOK erstellt hast, kannst du diese E-Mail ignorieren.\n\nMit freundlichen Gr\xfc\xdfen,\n**Das LOGBOOK-Team**'
            },
            "signupWelcome": {
                "subject": "Willkommen bei LOGBOOK",
                "footer": "Du erh\xe4ltst diese E-Mail, weil du dich bei LOGBOOK registriert hast.",
                "body": 'Hallo {name},\n\nWillkommen bei LOGBOOK!\n\nDeine E-Mail-Adresse wurde erfolgreich best\xe4tigt! \uD83C\uDF89\\\nDein Account ist jetzt aktiviert und einsatzbereit.\n\n**Und jetzt?**\n\nStarte direkt durch mit deinem digitalen Logbuch!\\\nMit der kostenlosen **LOGBOOK Trial** kannst du an insgesamt **5 Tagen** kostenlos Logbuch-Eintr\xe4ge erstellen. Die 5 Tage beginnen mit deinem ersten Log-Eintrag.\n\n**So geht\'s los:**\n\n1. **Lade die LOGBOOK-App herunter** und melde dich mit deinen Zugangsdaten an.\n\n   [App herunterladen](https://logbook.yachts/site/de/download "button")\n\n2. **Erstelle kostenlos dein erstes Schiff** und deinen ersten Logbuch-Eintrag \u2013 komplett kostenlos.\n\n3. **Finde Unterst\xfctzung beim Start:**\n\n   - Schritt-f\xfcr-Schritt-Anleitung im [Quickstart](https://logbook.yachts/site/de/docs/quickstart/)\n   - Spielerisch erkunden mit unseren [interaktiven Demos](https://logbook.yachts/site/de/demos/)\n   - Vollst\xe4ndiger \xdcberblick in der [Dokumentation](https://logbook.yachts/site/de/docs)\n\n4. **Tipps & Hilfe:**\n\n   - Praktische Tricks auf unserer [Support-Seite](https://logbook.yachts/site/de/docs/support/#tips).\n   - Direkte Hilfe \xfcber das Men\xfc **Hilfe** in der App oder Per E-Mail an contact@trimutic.com \u2013 wir antworten schnellstm\xf6glich!\n\n---\n\n**Gef\xe4llt dir LOGBOOK?**\\\nDann sichere dir jetzt ein Abo und f\xfchre dein Logbuch dauerhaft und ohne Unterbrechung.\n\n[Mehr Infos zu den Abos](https://logbook.yachts/site/de/prices "button")\n\n[Jetzt Abo buchen](https://logbook.yachts/app/account/subscription "button")\n\n**Hinweis:** Leider ist es unter iOS nicht m\xf6glich, das Abo direkt aus deinen Account-Einstellungen heraus auszuw\xe4hlen. Auf dem iPad musst du dich daf\xfcr im Webbrowser (z.B. in Safari) \u2013 au\xdferhalb der App \u2013 in dein Konto einloggen. Der Button **Jetzt Abo buchen** f\xfchrt dich dann zur Abo-Auswahl.\n\nBei Fragen oder Problemen steht dir unser [Support-Team](https://logbook.yachts/site/de/support) gerne zur Verf\xfcgung.\n\nMit freundlichen Gr\xfc\xdfen,\\\n**Das LOGBOOK-Team**'
            },
            "invited": {
                "subject": "Willkommen bei LOGBOOK",
                "footer": "Diese E-Mail wurde gesendet, weil du zu LOGBOOK eingeladen wurdest.\nWenn du die Einladung nicht annehmen willst, kannst du diese E-Mail ignorieren.",
                "body": 'Hallo {name},\n\n{account_holder} hat dich zu LOGBOOK eingeladen, damit du an Bord der **{ship_name}** Zugriff auf das Logbuch bekommst.\n\nKlicke, um die Einladung anzunehmen, auf diesen Button:\n\n[Einladung annehmen]({invitation_link} "button")\n\nDer Button f\xfchrt dich zur Registrierung und Anmeldung bei LOGBOOK.\n\n**Entweder einloggen \u2026**\nWenn du bereits einen Account bei LOGBOOK hast, kannst du dich \xfcber diesen einloggen.\nDeine E-Mail-Adresse {email} ist bereits ausgef\xfcllt. Du kannst dich aber auch \xfcber eine andere E-Mail-Adresse einloggen.\n\n**... oder registrieren und Account erstellen**\nSolltest du noch keinen Account haben, kannst du dich kostenlos bei LOGBOOK registrieren.\nDaf\xfcr werden nur dein Name, deine E-Mail-Adresse und ein Passwort ben\xf6tigt.\nDeine E-Mail-Adresse {email} ist bereits fest eingetragen, damit du dich ohne weitere Verifizierungen registrieren kannst.\nTrage deinen Namen ein, lege ein Passwort fest und klicke dann auf **Registrieren**.\n\nWenn die Schaltfl\xe4che oben nicht funktioniert, kopiere den folgenden Link und f\xfcge ihn in deinen Browser ein:\n\n{invitation_link}\n\nDieser Einladungslink l\xe4uft in 24 Stunden ab.\n\nMit der Registierung bei LOGBOOK bist du automatisch zum unregelm\xe4\xdfig erscheinenden Newsletter angemeldet, der dich \xfcber Neuheiten bei LOGBOOK informiert. Du kannst dich jederzeit wieder von diesem Newsletter abmelden.\n\nMit freundlichen Gr\xfc\xdfen,\n**Das LOGBOOK-Team**'
            },
            "passwordReset": {
                "subject": "LOGBOOK - Passwort vergessen",
                "footer": "Diese E-Mail wurde gesendet, weil du im Login-Dialog von LOGBOOK eine Passwort-Vergessen Anfrage gestellt hast.\nWenn du keine Anfrage gestellt hast, kannst du diese E-Mail ignorieren.",
                "body": 'Hallo {name},\n\nDu hast dein Passwort vergessen?\n\nKein Problem. Klicke auf den Button, um dein Passwort zur\xfcck zu setzen.\n\n[Passwort zur\xfccksetzen]({reset_link} "button")\n\nAnschlie\xdfend kannst du im Login-Dialog ein neues Passwort vergeben.\n\nSolltest du dich doch wieder an dein Passwort erinnern, kannst du diese E-Mail ignorieren und erneut versuchen, dich anzumelden.\n\nMit freundlichen Gr\xfc\xdfen,\n**Das LOGBOOK-Team**'
            },
            "betaInvite": {
                "subject": "Willkommen beim Beta-Test von LOGBOOK",
                "footer": "Du erh\xe4ltst diese E-Mail, weil du dich als Beta-Tester f\xfcr LOGBOOK gemeldet hast.",
                "body": 'Hallo {name},\n\nHerzlich willkommen beim Beta-Test von **LOGBOOK**! Vielen Dank, dass du dir Zeit nimmst, unsere Software unter realen Bedingungen zu testen. Durch dein Feedback hilfst du uns, LOGBOOK f\xfcr den produktiven Einsatz an Bord vorzubereiten.\n\nZu Beginn des Beta-Tests steht LOGBOOK f\xfcr Windows, macOS und ios (iPad) zur Verf\xfcgung. In K\xfcrze werden wir auch Android ins Beta-Test-Programm aufnehmen.\n\n**Was ist die Aufgabe eines Beta-Testers?**\n\nAls Beta-Tester bekommst du Zugriff auf eine Version, die bereits funktionsf\xe4hig ist, aber noch Fehler enthalten kann. Deine Aufgaben dabei sind:\n\n-   Testen der Funktionen im realen Betrieb\n-   Meldung von Fehlern (Bugs)\n-   Hinweise zu Bedienung, Verst\xe4ndlichkeit und Nutzerfreundlichkeit\n-   Vorschl\xe4ge f\xfcr Verbesserungen und neue Funktionen\n-   R\xfcckmeldung, ob die Software deine Erwartungen erf\xfcllt\n\nPoste deine Fehlermeldungen, Kommentare und Ideen in unserem Betatest-Forum, das wir \xfcber Discord eingerichtet haben. Mit diesem Link bekommst du Zugang zum Forum und zum Chat: [**Anmelden bei LOGBOOK community**](https://discord.gg/nTztPF9jKE). (Auf dem iPad funktioniert der Link mit der App Discord, nicht mit dem Browser.)\nDu erreichst uns auch per E-Mail an contact@trimutic.com.\n\n**Im Forum posten wir auch wichtige Hinweise und Tipps, die dir beim Testen und beim Einsatz von LOGBOOK helfen. Als bitte unbedingt anmelden!**\n\nWir freuen uns \xfcber jedes Feedback \u2014 kurz oder ausf\xfchrlich, positiv oder kritisch. Je ehrlicher, desto besser.\n\n**Wie l\xe4uft der Beta-Test ab?**\n\nSetze LOGBOOK direkt bei deinem n\xe4chsten Trip ein und berichte uns an contact@trimutic.com oder \xfcber das Kontaktformular von deinen Erfahrungen. F\xfcge auch gerne Screenshots bei.\n\nW\xe4hrend der Beta-Test-Phase werden wir LOGBOOK weiter verbessern, die Anmerkungen unserer Beta-Tester einflie\xdfen lassen und auch noch einige neue Funktionen hinzuf\xfcgen.\nDeshalb werden wir h\xe4ufiger **Updates** bereitstellen.\nEine Info, ob ein Update verf\xfcgbar ist, erh\xe4ltst du automatisch beim Starten der App oder mit dem Men\xfcpunkt **\xc4nderungsprotokoll** aus dem Men\xfc **Hilfe** (in beiden F\xe4llen Internet-Verbindung vorausgesetzt).\n\nWir m\xf6chten dich bitten, Updates zeitnah auszuf\xfchren. Nur so ist sichergestellt, dass du wirklich mit der aktuellsten Version testest.\n\n**Was musst du als N\xe4chstes tun?**\n\n1.  Melde dich als Beta-Tester bei LOGBOOK an.\n\n[Anmeldung als Beta-Tester](https://logbook.yachts/app/signup/beta "button")\n\nWenn du dich mit **Safari** bei LOGBOOK registrieren m\xf6chtest, musst du unbedingt darauf achten, dass aktuell noch kein Feld mit der automatischen Ausf\xfcllhlife ausgef\xfcllt werden darf.\nAlso, bitte Namen und E-Mail manuell eintippen, keine Vorschl\xe4ge ausw\xe4hlen. Deine Eingaben werden trotzdem in deinem System gespeichert.\nOder verwende f\xfcr die Registrierung einen anderen Browser wie beispielsweise Google Chrome oder Microsoft Edge.\n\n2. Lade und installiere die LOGBOOK-App auf deinem prim\xe4ren Device, also dem Device, mit dem du die NMEA-Daten empfangen willst.\n\n    [Download App](https://logbook.yachts/site/de/download "button")\n\n    Wenn du dich f\xfcr den Test auf dem **iPad** angemeldet hast, erh\xe4ltst du zus\xe4tzlich zu dieser E-Mail auch eine E-Mail mit dem Absender TestFlight.\n\n    **TestFlight** ist das Tool von Apple, mit dem sich nicht ver\xf6ffentlichte Apps auf dem iPad ausf\xfchren und testen lassen. Installiere die App **TestFlight** ([Install TestFlight](https://testflight.apple.com/a)). Anschlie\xdfend kannst du LOGBOOK mit dem Button **View in TestFlight** (in der E-Mail) in TestFlight laden und auf deinem iPad installieren.\n\n    Danach l\xe4sst sich LOGBOOK wie jede andere App starten.\n\n3. Starte die App und logge dich in dein in Schritt 1 erstelltes Benutzerkonto ein.\n4. Lege dein erstes Schiff an, verbinde die App mit dem NMEA und starte dein Logbuch (siehe auch in unserem [Quickstart](https://logbook.yachts/site/de/docs/quickstart/)).\n5. Entdecke alle Funktionen und M\xf6glichkeiten \u2013 und teste die App unter realen Bedingungen.\n\n**Dein Kontakt zum LOGBOOK-Support**\n\nDu erreichst du unseren Support innerhalb der App \xfcber die Funktion **Support kontaktieren** im Men\xfc **Hilfe** (Kontaktformular) oder per **E-Mail** an contact@trimutic.com. Wir helfen dir schnell und unkompliziert weiter.\n\nUnsere regul\xe4ren Supportzeiten sind montags bis freitags von 9:00 bis 18:00 Uhr (MEZ). In vielen F\xe4llen erreichst du uns auch au\xdferhalb dieser Zeiten und am Wochenende.\n\n**Dokumentation**\n\nAlle wichtigen Infos und Anleitungen findest du in unserer umfangreichen [Online-Dokumentation](https://logbook.yachts/site/de/docs/intro).\n\nF\xfcr einen schnellen Einstieg empfehlen wir dir unseren [Quickstart]( https://logbook.yachts/site/de/docs/quickstart/).\n\nGute Fahrt und immer eine Handbreit Wasser unter dem Kiel!\n**W\xfcnscht dir dein LOGBOOK-Team**'
            },
            "subscriptionWelcomeSkipper": {
                "subject": "Dein Abo \"LOGBOOK Skipper\" ist aktiviert",
                "footer": "Du erh\xe4ltst diese E-Mail, weil du dich bei LOGBOOK registriert hast.",
                "body": "Hallo {name},\n\nHerzlichen Gl\xfcckwunsch und willkommen an Bord!\n\nDu hast erfolgreich das Abo **LOGBOOK Skipper** abgeschlossen. Wir freuen uns, dich in unserer Community zu begr\xfc\xdfen und w\xfcnschen dir viel Spa\xdf und Erfolg mit deinem digitalen Logbuch.\n\n**Was musst du als N\xe4chstes tun?**\n\n1.  Installiere die LOGBOOK-App auf deinem prim\xe4ren Device, also dem Device, mit dem du die NMEA-Daten empfangen willst. Download-Links findest du [hier](https://logbook.yachts/site/de/download).\n2.  Starte die App und logge dich in dein Benutzerkonto ein.\n3.  Lege dein erstes Schiff an, verbinde die App mit dem NMEA und starte dein Logbuch (siehe auch in unserem [Quickstart](https://logbook.yachts/site/de/docs/quickstart/)).\n4.  Entdecke alle Funktionen und M\xf6glichkeiten \u2013 bei Fragen hilft dir unser Support gerne weiter.\n\nUnd falls du LOGBOOK bereits getestet hattest, kannst du einfach mit dem bereits als Test begonnen Logbuch fortfahren.\n\n**Dein Support-Zugang:**\n\nMit dem Abo **LOGBOOK Skipper** erreichst du unseren Support innerhalb der App \xfcber die **Kontaktfunktion** im Men\xfc Hilfe oder per **E-Mail** an contact@trimutic.com. Wir helfen dir schnell und unkompliziert weiter.\n\nUnsere regul\xe4ren Supportzeiten sind montags bis freitags von 9:00 bis 18:00 Uhr (MEZ). In vielen F\xe4llen erreichst du uns auch au\xdferhalb dieser Zeiten und am Wochenende.\n\n**Dokumentation:**\n\nAlle wichtigen Infos und Anleitungen findest du in unserer umfangreichen [Online-Dokumentation](https://logbook.yachts/site/de/docs/intro).\n\nF\xfcr einen schnellen Einstieg empfehlen wir dir unseren [Quickstart]( https://logbook.yachts/site/de/docs/quickstart/).\n\nGute Fahrt und immer eine Handbreit Wasser unter dem Kiel!\n**W\xfcnscht dir dein LOGBOOK-Team**"
            },
            "subscriptionWelcomeCaptain": {
                "subject": "Dein Abo \"LOGBOOK Captain\" ist aktiviert",
                "footer": "Du erh\xe4ltst diese E-Mail, weil du dich bei LOGBOOK registriert hast.",
                "body": "Hallo {name},\n\nHerzlichen Gl\xfcckwunsch und willkommen an Bord!\n\nDu hast erfolgreich das Abo **LOGBOOK Captain** abgeschlossen. Wir freuen uns, dich in unserer Community zu begr\xfc\xdfen und w\xfcnschen dir viel Spa\xdf und Erfolg mit deinem digitalen Logbuch.\n\n**Was musst du als N\xe4chstes tun?**\n\n1.  Installiere die LOGBOOK-App auf deinem prim\xe4ren Device, also dem Device, mit dem du die NMEA-Daten empfangen willst. Download-Links findest du [hier](https://logbook.yachts/site/de/download).\n2.  Starte die App und logge dich in dein Benutzerkonto ein.\n3.  Lege dein erstes Schiff an, verbinde die App mit dem NMEA und starte dein Logbuch (siehe auch in unserem [Quickstart](https://logbook.yachts/site/de/docs/quickstart/)).\n4.  Entdecke alle Funktionen und M\xf6glichkeiten \u2013 bei Fragen hilft dir unser Support gerne weiter.\n\nUnd falls du LOGBOOK bereits getestet hattest, kannst du einfach mit dem bereits als Test begonnen Logbuch fortfahren.\n\n**Dein Support-Zugang:**\n\nMit dem Abo **LOGBOOK Captain** erreichst du unseren Support direkt aus der App \xfcber den Men\xfcpunkt **Support kontaktieren** im Men\xfc Hilfe oder per **E-Mail** an [contact@trimutic.com](mailto:contact@trimutic.com). Wir helfen dir schnell und unkompliziert weiter.\n\nMit dem in deinem Abo enthaltenen **Pro-Support** hast du auch die M\xf6glichkeit, unseren Support per Telefon oder per WhatsApp zu kontaktieren. Die exklusive Telefonnummer des Pro-Supports lautet **[+49 211 93659134](tel: 4921193659134)**.\n\nVerwende diesen [**Link**](https://wa.me/message/MNUAAKYACQU5A1), um dich mit unserem Pro-WhatsApp-Support-Kanal zu verbinden. Als Captain-Abonnent bieten wir dir die M\xf6glichkeit, \xfcber diesen Kanal per WhatsApp Kontakt mit unserem Support-Team aufzunehmen:\n\nUnsere regul\xe4ren Supportzeiten sind montags bis freitags von 9:00 bis 18:00 Uhr (MEZ). In vielen F\xe4llen erreichst du uns auch au\xdferhalb dieser Zeiten und am Wochenende.\n\n**Dokumentation:**\n\nAlle wichtigen Infos und Anleitungen findest du in unserer umfangreichen [Online-Dokumentation](https://logbook.yachts/site/de/docs/intro).\n\nF\xfcr einen schnellen Einstieg empfehlen wir dir unseren [Quickstart]( https://logbook.yachts/site/de/docs/quickstart/).\n\nGute Fahrt und immer eine Handbreit Wasser unter dem Kiel!\n**W\xfcnscht dir dein LOGBOOK-Team**"
            },
            "subscriptionWelcomeMasterCaptain": {
                "subject": "Dein Abo \"LOGBOOK Master Captain\" ist aktiviert",
                "footer": "Du erh\xe4ltst diese E-Mail, weil du dich bei LOGBOOK registriert hast.",
                "body": "Hallo {name},\n\nHerzlichen Gl\xfcckwunsch und willkommen an Bord!\n\nDu hast erfolgreich das Abo **LOGBOOK Master Captain** abgeschlossen. Wir freuen uns, dich in unserer Community zu begr\xfc\xdfen und w\xfcnschen dir viel Spa\xdf und Erfolg mit deinem digitalen Logbuch.\n\n**Was musst du als N\xe4chstes tun?**\n\n1.  Installiere die LOGBOOK-App auf deinem prim\xe4ren Device, also dem Device, mit dem du die NMEA-Daten empfangen willst. Download-Links findest du [hier](https://logbook.yachts/site/de/download).\n2.  Starte die App und logge dich in dein Benutzerkonto ein.\n3.  Lege dein erstes Schiff an, verbinde die App mit dem NMEA und starte dein Logbuch (siehe auch in unserem [Quickstart](https://logbook.yachts/site/de/docs/quickstart/)).\n4.  Entdecke alle Funktionen und M\xf6glichkeiten \u2013 bei Fragen hilft dir unser Support gerne weiter.\n\nUnd falls du LOGBOOK bereits getestet hattest, kannst du einfach mit dem bereits als Test begonnen Logbuch fortfahren.\n\n**Dein Support-Zugang:**\n\nMit dem Abo **LOGBOOK Master Captain** erreichst du unseren Support direkt aus der App \xfcber den Men\xfcpunkt **Support kontaktieren** im Men\xfc Hilfe oder per **E-Mail** an [contact@trimutic.com](mailto:contact@trimutic.com). Wir helfen dir schnell und unkompliziert weiter.\n\nMit dem in deinem Abo enthaltenen **Pro-Support** hast du auch die M\xf6glichkeit, unseren Support per Telefon oder per WhatsApp zu kontaktieren. Die exklusive Telefonnummer des Pro-Supports lautet **[+49 211 93659134](tel: 4921193659134)**.\n\nVerwende diesen [**Link**](https://wa.me/message/MNUAAKYACQU5A1), um dich mit unserem Pro-WhatsApp-Support-Kanal zu verbinden. Als Master-Captain-Abonnent bieten wir dir die M\xf6glichkeit, \xfcber diesen Kanal per WhatsApp Kontakt mit unserem Support-Team aufzunehmen:\n\nBitte teile uns mit, wann du unsere Unterst\xfctzung beim Onboarding ben\xf6tigst.\n\nUnsere regul\xe4ren Supportzeiten sind montags bis freitags von 9:00 bis 18:00 Uhr (MEZ). In vielen F\xe4llen erreichst du uns auch au\xdferhalb dieser Zeiten und am Wochenende.\n\n**Dokumentation:**\n\nAlle wichtigen Infos und Anleitungen findest du in unserer umfangreichen [Online-Dokumentation](https://logbook.yachts/site/de/docs/intro).\n\nF\xfcr einen schnellen Einstieg empfehlen wir dir unseren [Quickstart]( https://logbook.yachts/site/de/docs/quickstart/).\n\nGute Fahrt und immer eine Handbreit Wasser unter dem Kiel!\n**W\xfcnscht dir dein LOGBOOK-Team**"
            },
            "trialStarted": {
                "subject": "Dein LOGBOOK Trial wurde gestartet",
                "footer": "Du erh\xe4ltst diese E-Mail, weil du dich bei LOGBOOK registriert hast.",
                "body": 'Hallo {name},\n\nHerzlichen Gl\xfcckwunsch und willkommen an Bord!\n\nDu hast gerade die 5-t\xe4gige Demophase von LOGBOOK gestartet. An insgesamt **5 Tagen** kannst du jetzt kostenlos Logbuch-Eintr\xe4ge erstellen.\n\n-   **Finde Unterst\xfctzung beim Start:**\n\n-   Schritt-f\xfcr-Schritt-Anleitung im [Quickstart](https://logbook.yachts/site/de/docs/quickstart/)\n-   Spielerisch erkunden mit unseren [interaktiven Demos](https://logbook.yachts/site/de/demos/)\n-   Vollst\xe4ndiger \xdcberblick in der [Dokumentation](https://logbook.yachts/site/de/docs)\n\n-   **Tipps & Hilfe:**\n\n-   Praktische Tricks auf unserer [Support-Seite](https://logbook.yachts/site/de/docs/support/#tips).\n-   Direkte Hilfe \xfcber das Men\xfc **Hilfe** in der App oder Per E-Mail an contact@trimutic.com \u2013 wir antworten schnellstm\xf6glich!\n---\n**Gef\xe4llt dir LOGBOOK?**\nDann sichere dir jetzt ein Abo und f\xfchre dein Logbuch dauerhaft und ohne Unterbrechung.\n\n[Mehr Infos zu den Abos](https://logbook.yachts/site/de/prices "button")\n\n[Jetzt Abo buchen](https://logbook.yachts/app/account/subscription "button")\n\n**Hinweis:** Leider ist es unter iOS nicht m\xf6glich, das Abo direkt aus deinen Account-Einstellungen heraus auszuw\xe4hlen. Auf dem iPad musst du dich daf\xfcr im Webbrowser (z.B. in Safari) \u2013 au\xdferhalb der App \u2013 in dein Konto einloggen. Der Button **Jetzt Abo buchen** f\xfchrt dich dann zur Abo-Auswahl.\n\nBei Fragen oder Problemen steht dir unser [Support-Team](https://logbook.yachts/site/de/support) gerne zur Verf\xfcgung.\n\nGute Fahrt und immer eine Handbreit Wasser unter dem Kiel!\n**W\xfcnscht dir dein LOGBOOK-Team**'
            },
            "trialExpiring": {
                "subject": "Deine LOGBOOK Trial-Phase endet bald",
                "footer": "Du erh\xe4ltst diese E-Mail, weil du dich bei LOGBOOK registriert hast.",
                "body": 'Hallo {name},\n\nEs bleibt nur noch ein Tag, bis die f\xfcnft\xe4gige Testphase von LOGBOOK endet.\n\n**Gef\xe4llt dir LOGBOOK?**\nDann sichere dir jetzt ein Abo und f\xfchre dein Logbuch dauerhaft und ohne Unterbrechung.\n\n[Mehr Infos zu den Abos](https://logbook.yachts/site/de/prices "button")\n\n[Jetzt Abo buchen](https://logbook.yachts/app/account/subscription "button")\n\n**Hinweis:** Leider ist es unter iOS nicht m\xf6glich, das Abo direkt aus deinen Account-Einstellungen heraus auszuw\xe4hlen. Auf dem iPad musst du dich daf\xfcr im Webbrowser (z.B. in Safari) \u2013 au\xdferhalb der App \u2013 in dein Konto einloggen. Der Button **Direkt zu den Abos** f\xfchrt dich dann zur Abo-Auswahl.\n\nBei Fragen oder Problemen steht dir unser [Support-Team](https://logbook.yachts/site/de/support) gerne zur Verf\xfcgung.\n\nGute Fahrt und immer eine Handbreit Wasser unter dem Kiel!\n**W\xfcnscht dir dein LOGBOOK-Team**'
            },
            "trialExpired": {
                "subject": "Deine LOGBOOK Trial-Phase ist beendet",
                "footer": "Du erh\xe4ltst diese E-Mail, weil du dich bei LOGBOOK registriert hast.",
                "body": 'Hallo {name},\n\nDeine LOGBOOK Trial-Phase ist beendet. Deine Testdaten speichern wir noch 6 Monate in der LOGBOOK-Cloud f\xfcr dich.\n\n**Gef\xe4llt dir LOGBOOK?**\nDann sichere dir jetzt ein Abo und f\xfchre dein Logbuch dauerhaft und ohne Unterbrechung.\n\n[Mehr Infos zu den Abos](https://logbook.yachts/site/de/prices "button")\n\n[Jetzt Abo buchen](https://logbook.yachts/app/account/subscription "button")\n\n**Hinweis:** Leider ist es unter iOS nicht m\xf6glich, das Abo direkt aus deinen Account-Einstellungen heraus auszuw\xe4hlen. Auf dem iPad musst du dich daf\xfcr im Webbrowser (z.B. in Safari) \u2013 au\xdferhalb der App \u2013 in dein Konto einloggen. Der Button **Direkt zu den Abos** f\xfchrt dich dann zur Abo-Auswahl.\n\nBei Fragen oder Problemen steht dir unser [Support-Team](https://logbook.yachts/site/de/support) gerne zur Verf\xfcgung.\n\nGute Fahrt und immer eine Handbreit Wasser unter dem Kiel!\n**W\xfcnscht dir dein LOGBOOK-Team**'
            },
            "contact": {
                "subject": "LOGBOOK - Wir haben deine Nachricht erhalten",
                "footer": "Diese E-Mail wurde gesendet, weil du ein Kontaktformular auf unserer Website ausgef\xfcllt hast.\nFalls du dieses Formular nicht ausgef\xfcllt hast, kontaktiere uns bitte umgehend.",
                "body": "Hallo {name},\n\nWir haben deine Nachricht erhalten und unser Kundenservice-Team wird sich so schnell wie m\xf6glich bei dir melden.\n\n### Details deiner Anfrage\n\n**E-Mail:** {email}\n\n**Art der Anfrage:** {topic}\n\n**Deine Frage:**\n\n{request}\n\nDiese E-Mail best\xe4tigt, dass wir deine Nachricht erhalten haben. In der Regel antworten wir innerhalb von 1-2 Werktagen.\n\nWenn du in der Zwischenzeit dringende Fragen hast, kannst du uns gerne per Antwort auf diese E-Mail kontaktieren.\n\nMit freundlichen Gr\xfc\xdfen,\n**Dein LOGBOOK Kundenservice-Team**"
            },
            "betaContact": {
                "subject": "LOGBOOK Beta Testing - Danke",
                "footer": "Diese E-Mail wurde gesendet, weil du dich f\xfcr das LOGBOOK Beta-Testing-Programm angemeldet hast.\nFalls du dich nicht angemeldet hast, ignoriere bitte diese E-Mail.",
                "body": "Hallo {name},\n\nVielen Dank f\xfcr dein Interesse, uns beim Testen von LOGBOOK zu unterst\xfctzen!\nWir freuen uns sehr, dich als einen unserer Beta-Tester an Bord zu haben.\n\n### Deine Registrierungsdaten\n\n**E-Mail:** {email}\n\n**Betriebssystem:** {system}\n\n**Aktueller Logbook Suite Nutzer:** {logbooksuite}\n\n**Details zu deinem Schiff, NMEA-Anbindung und deinen geplanten Reisen f\xfcr Anfang 2026:**\n{request}\n\n### Wie geht es weiter?\n\n1.  **Pr\xfcfungsprozess:** Unser Team wird deine Infos und die Details zu deinem Schiff pr\xfcfen.\n2.  **Informationen:** Wir senden dir in K\xfcrze weitere Details zum Beta-Programm.\n3.  **Beta-Zugang:** Als Tester erh\xe4lst du Download-Links und Setup-Anleitungen.\n4.  **Testphase:** Du wirst die M\xf6glichkeit haben, LOGBOOK w\xe4hrend deiner f\xfcr Anfang 2026 geplanten Reisen zu testen.\n\nWir m\xf6chten LOGBOOK mit verschiedenen Schiffskonfigurationen und NMEA-Verbindungs-Setups testen. Daher wird dein Feedback von unsch\xe4tzbarem Wert sein, um LOGBOOK zur besten digitalen Logbuch-L\xf6sung zu machen.\n\nFalls du in der Zwischenzeit Fragen hast, z\xf6gere bitte nicht, dich bei uns zu melden.\n\nStets eine Handbreit Wasser unterm Kiel,\n**Das LOGBOOK Team**"
            }
        }
    }
};


var $773869f697d3f41b$exports = {};
$773869f697d3f41b$exports = {
    "alert": {
        "anchorDrift": {
            "alarm": "Le navire s'est d\xe9plac\xe9 de **{distance}** depuis la position de mouillage.",
            "warning": "Le navire s'est d\xe9plac\xe9 de **{distance}** depuis la position de mouillage."
        },
        "depth": {
            "alarm": "La profondeur actuelle de l'eau n'est que de **{depth}**.",
            "warning": "La profondeur actuelle de l'eau n'est que de **{depth}**."
        },
        "lights": {
            "warning": "Les feux recommand\xe9s sont **{recommended}**, mais **{recorded}** est actuellement enregistr\xe9."
        },
        "lostPosition": {
            "disconnected": "La connexion \xe0 la source de position a \xe9t\xe9 perdue.",
            "invalidFix": "La source de position signale que sa position GPS n'est pas valide.",
            "jump": "La source de position signale des positions invraisemblables. Elles sont ignor\xe9es.",
            "stale": "Aucune position n'a \xe9t\xe9 re\xe7ue depuis un certain temps."
        },
        "manOverboard": {
            "emitterActivated": "Un \xe9metteur homme \xe0 la mer a \xe9t\xe9 activ\xe9. R\xe9action imm\xe9diate de tout l'\xe9quipage requise.",
            "manualButtonActivated": "Le bouton manuel d'un \xe9metteur homme \xe0 la mer a \xe9t\xe9 activ\xe9. R\xe9action imm\xe9diate de tout l'\xe9quipage requise.",
            "manual": "Un membre de l'\xe9quipage a d\xe9clench\xe9 manuellement une alerte homme \xe0 la mer. R\xe9action imm\xe9diate de tout l'\xe9quipage requise.",
            "unknown": "Un signal homme \xe0 la mer a \xe9t\xe9 re\xe7u. R\xe9action imm\xe9diate de tout l'\xe9quipage requise."
        }
    },
    "anchorMonitor": {
        "explanation": {
            "fixedRadius": "Vous alerte lorsque le navire s'\xe9loigne au-del\xe0 d'une distance fixe de la position d'ancrage, indiqu\xe9e directement comme un rayon en m\xe8tres.\n\nUtilisez cette m\xe9thode lorsque vous savez d\xe9j\xe0 de combien d'espace de giration vous disposez \u2014 par exemple dans un mouillage encombr\xe9 o\xf9 vous avez estim\xe9 vous-m\xeame la distance de s\xe9curit\xe9 par rapport aux bateaux voisins ou au rivage.",
            "rodeScope": "Calcule le rayon de giration attendu \xe0 partir de la longueur de votre cha\xeene ou ligne d'ancre, de la profondeur d'eau et de la longueur de votre navire, plut\xf4t qu'une distance fixe que vous saisissez vous-m\xeame.\n\nUtilisez cette m\xe9thode lorsque vous voulez que LOGBOOK calcule pour vous un rayon pertinent en fonction de la longueur de cha\xeene fil\xe9e \u2014 il s'adapte automatiquement lorsque la mar\xe9e modifie la profondeur.",
            "sector": "Surveille un secteur de rel\xe8vement directionnel plut\xf4t qu'un cercle complet, de sorte qu'une giration dans l'arc attendu reste silencieuse tandis qu'une d\xe9rive en dehors de celui-ci d\xe9clenche une alerte.\n\nUtilisez cette m\xe9thode dans un chenal \xe9troit ou un mouillage fluvial, o\xf9 la giration selon le courant est normale, mais o\xf9 une d\xe9rive lat\xe9rale vers une rive ou un autre navire ne l'est pas."
        }
    },
    "changeLog": {
        "2026-09-30": "La version 1.1 apporte de nombreuses nouvelles fonctionnalit\xe9s utiles \xe0 LOGBOOK\n\nNouvelles fonctionnalit\xe9s\n* Statut manuel du navire \u2013 pour \xe9viter les entr\xe9es \xab pause \xbb ind\xe9sirables (activ\xe9 automatiquement pour les statuts \xab Pont \xbb et \xab En attente \xbb)\n* Veille au mouillage avec avertissement et alarme\n* Surveillance de la profondeur avec avertissement et alarme\n* Notifications concernant les signaux visuels requis par le R\xe8glement international pour la s\xe9curit\xe9 de la navigation maritime (COLREG)\n* Entr\xe9es manuelles relatives au moteur : notification en cas d\u2019entr\xe9e manquante pour \xab Moteur en marche \xbb (peut \xeatre d\xe9finie r\xe9troactivement)\n* Avertissement en cas de probl\xe8mes avec les donn\xe9es NMEA\n* Alarme \xab homme \xe0 la mer \xbb\n* Historique des modifications \u2013 pour une fiabilit\xe9 encore plus grande des preuves\n* R\xe9gime de ralenti des moteurs r\xe9glable \u2013 le fonctionnement au ralenti est signal\xe9 et n\u2019est pas comptabilis\xe9 comme un d\xe9placement sous la puissance du moteur\n\nAm\xe9liorations\n* Encore plus de fonctions pour les saisies manuelles dans le journal, d\xe9sormais s\xe9lectionnables directement dans le menu \xab Journal \xbb\n* Saisies manuelles des donn\xe9es moteur : le r\xe9gime peut \xeatre ajout\xe9 r\xe9troactivement en mode \xab Focus \xbb\n* Les membres d\u2019\xe9quipage, etc., ne peuvent \xeatre modifi\xe9s que pour la journ\xe9e en cours et la journ\xe9e suivante\n* La connexion \xe0 des appareils Companion via Bonjour est possible pour des configurations suppl\xe9mentaires\n* Am\xe9liorations apport\xe9es \xe0 la bo\xeete de dialogue de connexion avec des messages d\u2019erreur plus clairs\n* Optimisations internes approfondies qui rendent l\u2019application encore plus rapide et plus fiable\n\nCorrections de bugs\n* Nombreuses optimisations majeures et mineures ainsi que corrections de bugs",
        "2026-08-14": "Voici les nouvelles fonctionnalit\xe9s de la mise \xe0 jour du 2026-08-14 :\n\nNouvelles fonctionnalit\xe9s\n* Pour les jours termin\xe9s et les jours sans entr\xe9es de journal, des entr\xe9es peuvent d\xe9sormais \xeatre ajout\xe9es r\xe9trospectivement aux cartes Pr\xe9visions m\xe9t\xe9o, Journal et Technique.\n* Prise en charge du GPS interne sur Android\n* Avertissement en cas de d\xe9faillance du GPS\n* S\xe9lection rapide des voiles dans le menu du bouton Log\n* Sur les appareils Android, le Primary LOGBOOK continue d\xe9sormais de fonctionner lorsque l'application est en arri\xe8re-plan\n* Affichage des heures de lever et de coucher du soleil sur la feuille de donn\xe9es du jour\n* Nouvelles options Pont et En attente pour les escales und de l'\xe9tat du navire\n* R\xe9glage de vitesse s\xe9par\xe9 pour d\xe9clencher l'entr\xe9e de d\xe9part au mouillage et \xe0 la bou\xe9e, pour \xe9viter les entr\xe9es inutiles lors du mouvement de giration\n* Fonctions pour le t\xe9l\xe9chargement de donn\xe9es vers le support\n\nAm\xe9liorations\n* Nouveau design des boutons NMEA et Sync \u2013 \xe9tat actuel plus clairement visible\n* Le menu du bouton Log s'ouvre d\xe9sormais vers le haut pour \xe9viter le d\xe9filement inutile\n* Les erreurs GPS ou les \xe9carts de position excessifs (par exemple, caus\xe9s par le brouillage GPS) sont ignor\xe9s\n* Sur les petits \xe9crans, le bouton Stop n'appara\xeet d\xe9sormais qu'avec une ic\xf4ne et peut \xeatre agrandi avec le bouton D\xe9velopper\n* Lors du changement de la prise de ris d'une voile, la prise de ris pr\xe9c\xe9dente est automatiquement supprim\xe9e\n* Am\xe9liorations de la connexion de Companion \xe0 Primary, prise en charge de Bonjour\n* Texte am\xe9lior\xe9 pour les changements d'\xe9quipage, de skipper, etc.\n* Les entr\xe9es de journal g\xe9n\xe9r\xe9es par le syst\xe8me (par exemple, lors de pertes de donn\xe9es) n'apparaissent d\xe9sormais qu'une seule fois\n\nCorrections de bugs\n* Le fuseau horaire est d\xe9sormais correctement d\xe9tect\xe9 sur Windows m\xeame lorsque le syst\xe8me n'est pas configur\xe9 en anglais comme langue\n* Les erreurs possibles dans les statistiques qui pouvaient survenir avec les entr\xe9es moteur manuelles sont automatiquement corrig\xe9es avec la mise \xe0 jour\n* Les entr\xe9es de journal en double g\xe9n\xe9r\xe9es par le syst\xe8me sont automatiquement supprim\xe9es avec la mise \xe0 jour\n* Android : les images peuvent d\xe9sormais \xeatre t\xe9l\xe9charg\xe9es\n* Nombreuses optimisations et corrections de bugs, majeures et mineures.",
        "2026-07-15": "Voici les nouvelles fonctionnalit\xe9s de la mise \xe0 jour du 2026-07-15 :\n\nNouvelles fonctionnalit\xe9s\n* Pour les entr\xe9es manuelles concernant le moteur (NMEA ne contient pas de donn\xe9es sur le r\xe9gime moteur), il est d\xe9sormais possible d'activer une option permettant de transf\xe9rer automatiquement le r\xe9gime saisi manuellement vers l'entr\xe9e suivante du journal de bord. Cela s'av\xe8re utile lors de trajets \xe0 r\xe9gime constant. Cette option peut \xeatre activ\xe9e dans les **Param\xe8tres du bateau**, sous l'onglet **Param\xe8tres** de la carte.\n\nAm\xe9liorations\n* Am\xe9liorations et corrections de bugs au niveau des statistiques, notamment dans le calcul de la dur\xe9e totale et de la distance totale.\n\nCorrections de bugs\n* Nombreuses optimisations et corrections de bugs, majeures et mineures.",
        "2026-07-05": "Voici les nouvelles fonctionnalit\xe9s de la mise \xe0 jour du 2026-07-05 :\n\nNouvelles fonctionnalit\xe9s\n* Le fran\xe7ais est d\xe9sormais disponible comme langue suppl\xe9mentaire pour l'interface utilisateur.\n* Nouveau bouton de Log multifonctionnel et contextuel \xe0 c\xf4t\xe9 de la ligne de log actuelle pour ajouter rapidement diff\xe9rents types d'entr\xe9es.\n* Les images dans les notes (journal, etc.) peuvent maintenant \xeatre supprim\xe9es.\n* Un d\xe9calage pour la valeur de distance du loch peut \xeatre d\xe9fini dans les param\xe8tres du navire (par exemple, si le loch n'affiche pas les miles totales correctes du navire).\n\nAm\xe9liorations\n* Diverses explications et conseils suppl\xe9mentaires dans l'interface utilisateur\n* Les droits d'acc\xe8s et le r\xf4le d'\xe9quipage du propri\xe9taire du compte sont d\xe9sormais fix\xe9s pour \xe9viter les probl\xe8mes de perte de droits d'acc\xe8s.\n* Lorsque plusieurs ajouts sont effectu\xe9s sur une entr\xe9e du journal, toutes les modifications sont d\xe9sormais list\xe9es dans le commentaire.\n* Optimisations importantes du LOGBOOK Cloud et de la communication entre LOGBOOK Cloud et l'application LOGBOOK\n\nCorrections de bugs\n* Lorsqu'aucune donn\xe9e moteur n'est disponible dans NMEA, les boutons moteur sont d\xe9sormais affich\xe9s imm\xe9diatement.\n* Correction d'un probl\xe8me o\xf9 500 tr/min \xe9taient saisis pour les donn\xe9es moteur manuelles apr\xe8s une interruption de donn\xe9es.\n* Le cap et le vent sont d\xe9sormais correctement \xe9valu\xe9s m\xeame lorsque seules des donn\xe9es relatives sont pr\xe9sentes dans NMEA.\n* Correction d'un probl\xe8me o\xf9 des temps n\xe9gatifs \xe9taient affich\xe9s dans les statistiques.",
        "2026-06-11": "La mise \xe0 jour du 2026-06-11 apporte de nombreuses am\xe9liorations et corrections de bugs :\n\nNouvelles fonctionnalit\xe9s\n* Prise en charge de l'iPhone comme appareil companion.\n* \xc9valuation d'ensembles de donn\xe9es NMEA suppl\xe9mentaires pour le cap, le vent, la temp\xe9rature de l'air et la pression atmosph\xe9rique.\n\nAm\xe9liorations\n* Lorsque plusieurs ajouts sont effectu\xe9s sur une entr\xe9e (par exemple, moteur arr\xeat\xe9 et voiles \xe9tablies), ils sont d\xe9sormais enti\xe8rement list\xe9s dans le commentaire.\n* La d\xe9connexion du LOGBOOK Primary n'est d\xe9sormais possible qu'en m\xeame temps que la fermeture du LOGBOOK Primary.\n* Aide utilisateur optimis\xe9e gr\xe2ce \xe0 des conseils, recommandations et avertissements am\xe9lior\xe9s.\n\nCorrections de bugs\n* Le test NMEA d\xe9tecte d\xe9sormais correctement lorsqu'il y a des valeurs du loch.\n* Correction d'un probl\xe8me o\xf9 le mauvais statut du jour \xe9tait affich\xe9 sur la carte du jour.\n* Correction d'un probl\xe8me o\xf9 des changements d'\xe9quipage incorrects \xe9taient enregistr\xe9s apr\xe8s que l'appareil soit pass\xe9 en mode veille.\n* Correction d'un probl\xe8me o\xf9 un r\xe9gime moteur incorrect \xe9tait enregistr\xe9 apr\xe8s une interruption de la connexion NMEA.\n* Optimisations suppl\xe9mentaires et corrections de bugs dans les statistiques.",
        "2026-05-30": "Voici les nouvelles fonctionnalit\xe9s de la mise \xe0 jour du 2026-05-30 :\n\nNouvelles fonctionnalit\xe9s\n* LOGBOOK peut d\xe9sormais \xeatre utilis\xe9 \xe0 bord avec plusieurs appareils simultan\xe9ment. La connexion se fait sur tous les appareils avec le m\xeame compte. Voir la documentation sur <a href=\"https://logbook.yachts/site/en/documentation/#h1_devices\" target=\"_blank\">**Multiple Devices**</a>.\n\nCorrections de bugs\n* Correction d'un probl\xe8me o\xf9 les images d\xe9passaient occasionnellement de la zone d'impression lors de l'impression.\n* Correction d'un probl\xe8me o\xf9 la mauvaise date \xe9tait affich\xe9e dans les fuseaux horaires occidentaux.\n* Le jour actuel affiche d\xe9sormais toujours la bonne date et n'affiche plus le 1er janvier, m\xeame s'il n'y a pas d'entr\xe9es.\n* Les changements dans la feuille de donn\xe9es du jour suivant ne sont pas enregistr\xe9s.\n* Correction d'un probl\xe8me o\xf9 les changements dans l'\xe9quipage \xe9taient enregistr\xe9s m\xeame si l'\xe9quipage n'avait pas \xe9t\xe9 modifi\xe9.\n* Correction d'un probl\xe8me o\xf9 les entr\xe9es moteur manuelles apr\xe8s une interruption de connexion NMEA enregistraient un r\xe9gime moteur.\n* Lors de l'arr\xeat, la dur\xe9e correcte appara\xeet d\xe9sormais directement sur le bouton d'arr\xeat.\n* Correction d'un probl\xe8me o\xf9 la distance et la dur\xe9e \xe9taient compt\xe9es deux fois dans les statistiques du jour.\n* iPad : Correction d'un \xe9cran blanc lors du passage du Cloud \xe0 l'App au sein de l'application.",
        "2026-05-20": "Voici les nouvelles fonctionnalit\xe9s de la mise \xe0 jour du 2026-05-20 :\n\nNouvelles fonctionnalit\xe9s\n* Ajout de la connexion NMEA via UDP.\n* Les donn\xe9es de trace sont calcul\xe9es en continu et synchronis\xe9es r\xe9guli\xe8rement, pas seulement \xe0 la fin de la journ\xe9e.\n* Pour les jours o\xf9 il n'y a pas de trace, la trace manquante est automatiquement g\xe9n\xe9r\xe9e lors du recalcul des statistiques (bouton sur les statistiques de la carte).\n* Pour les entr\xe9es moteur manuelles, le dialogue d'arr\xeat offre une option pour cr\xe9er automatiquement des entr\xe9es pour **Moteur arr\xeat\xe9** \xe9galement.\n\nAm\xe9liorations\n* Changement dans la d\xe9tection des pauses. Cela devrait \xe9viter les fausses pauses \xe0 basse vitesse ou en raison d'inexactitudes GPS, ainsi que les fins de pause incorrectes lors de mouvements de navire \xe0 court terme ou d'erreurs GPS.\n* Le **calcul du temps total** commence lorsque le navire part et se termine avec la derni\xe8re entr\xe9e lorsque le navire ne bouge plus. Les entr\xe9es non li\xe9es au trajet au d\xe9but et \xe0 la fin ne sont plus prises en compte.\n\nCorrections de bugs\n* Correction d'un probl\xe8me o\xf9 apr\xe8s le red\xe9marrage de la navigation le m\xeame jour, la distance recommen\xe7ait \xe0 0.",
        "2026-05-12": "Voici les nouvelles fonctionnalit\xe9s de la mise \xe0 jour du 2026-05-12 :\n\nNouvelles fonctionnalit\xe9s\n* iPad : L'application LOGBOOK continue de fonctionner en arri\xe8re-plan et continue de cr\xe9er des entr\xe9es log lorsque l'application n'est pas au premier plan.\n* iPad : Les photos peuvent d\xe9sormais \xeatre prises directement depuis l'application et ins\xe9r\xe9es dans les entr\xe9es du journal de bord.\n* iPad : Prise en charge des **appareils GPS externes** connect\xe9s via **Bluetooth** ou c\xe2ble\n* Nouvelle fonction **R\xe9initialiser** au cas o\xf9 la connexion du cloud au LOGBOOK Primary serait accidentellement d\xe9connect\xe9e (indiqu\xe9e par le marqueur rouge sur le bouton de synchronisation)\n\nAm\xe9liorations\n* iPad : Probl\xe8mes de mise en page apr\xe8s le retour de l'arri\xe8re-plan corrig\xe9s\n* Serveur : Am\xe9liorations dans le calcul des statistiques",
        "2026-05-05": "La mise \xe0 jour 2026-05-05 corrige quelques probl\xe8mes :\n\n* Correction d'un probl\xe8me avec le GPS int\xe9gr\xe9 de l'iPad, qui pouvait conduire \xe0 des entr\xe9es de pause incorrectes \xe0 tr\xe8s basse vitesse.\n* Correction d'un probl\xe8me o\xf9 une connexion NMEA d\xe9sactiv\xe9e \xe9tait automatiquement activ\xe9e lorsque l'application \xe9tait mise au premier plan sur l'iPad.\n* Correction d'un probl\xe8me o\xf9 les entr\xe9es log et la ligne de log n'\xe9taient pas affich\xe9es correctement lors du changement de taille de fen\xeatre (par exemple, en tournant la tablette).\n* Correction du format de champ incorrect dans les donn\xe9es du navire sur l'onglet **\xc9quipement**.\n* Diverses optimisations mineures de mise en page\n* Diverses corrections mineures de bugs\n\nSi vous utilisez le GPS interne pour la r\xe9ception de donn\xe9es, vous pouvez trouver des informations importantes dans notre conseil <a href=\"https://logbook.yachts/site/en/support/#ipadgps\" target=\"_blank\">**\xbbUtiliser LOGBOOK avec le GPS interne de l'iPad\xab**</a>.",
        "2026-04-27": "La mise \xe0 jour 2026-04-27 apporte toute une s\xe9rie d'am\xe9liorations et de corrections de bugs.\nCela inclut des optimisations suppl\xe9mentaires de la mise en page pour diff\xe9rentes tailles d'\xe9cran ainsi que la gestion des erreurs lors de l'importation depuis Logbook Suite.",
        "2026-04-14": "Voil\xe0 la premi\xe8re mise \xe0 jour mineure. Voici ce que nous avons am\xe9lior\xe9 :\n\n* Mise en page optimis\xe9e pour les \xe9crans moyens tels que les tablettes en mode portrait (768px \xe0 1023px)\n* Le bouton d'impression fonctionne maintenant sur iPad\n* Am\xe9liorations lors de l'importation depuis Logbook Suite\n* Diverses corrections de bugs mineures",
        "2026-04-04": "Bienvenue sur LOGBOOK \u2013 le logiciel de journal de bord innovant pour les navigateurs et les passionn\xe9s de bateaux \xe0 moteur.\n\nIl s'agit de la version 1.0. \xc0 l'avenir, vous trouverez ici des informations sur les nouvelles fonctionnalit\xe9s et am\xe9liorations apr\xe8s chaque mise \xe0 jour."
    },
    "connection": {
        "interrupted": "La connexion \xe0 l'application a \xe9t\xe9 interrompue.\n\nSi la connexion ne se r\xe9tablit pas automatiquement, veuillez essayer de red\xe9marrer l'application.",
        "recovered": "La connexion \xe0 l'application a \xe9t\xe9 r\xe9tablie.\n\nVeuillez recharger pour continuer \xe0 utiliser l'application."
    },
    "currentView": {
        "firstTrip": "**Un nouveau trajet est en cours de d\xe9marrage**\n\nVeuillez v\xe9rifier le **fuseau horaire** d\xe9fini pour ce trajet.\n\nLe fuseau horaire est automatiquement d\xe9fini sur le fuseau horaire syst\xe8me de l'appareil Primary. Pour modifier le fuseau horaire, vous devez changer le fuseau horaire syst\xe8me de l'appareil primary **avant** de commencer le trajet.\n\nSi le syst\xe8me de l'appareil primary n'a pas correctement transmis le fuseau horaire \xe0 LOGBOOK, vous pouvez modifier manuellement le fuseau horaire dans les **Param\xe8tres du navire** sur l'onglet **Param\xe8tres**. Cela doit \xe9galement \xeatre fait **avant** de commencer le trajet.\n\n**Veuillez noter :** Une fois le trajet commenc\xe9 ici, le fuseau horaire est fixe.",
        "demoWillStart": "**Remarque :** Avec le d\xe9but du premier trajet, vous commencez \xe9galement votre phase d'essai de 5 jours.",
        "confirmationDialog": {
            "cruise": {
                "allowed": "Commencer un nouveau voyage met fin au voyage actuel.\n\n\xcates-vous s\xfbr de vouloir arr\xeater et terminer le voyage actuel ?\n\n**Veuillez noter** : L'enregistrement NMEA sera arr\xeat\xe9.",
                "deniedInMotion": "Commencer un nouveau voyage n'est pas possible car le navire est en mouvement.",
                "deniedBlankExists": "Commencer un nouveau voyage n'est pas possible car il existe d\xe9j\xe0 un voyage vide qui n'a pas encore \xe9t\xe9 commenc\xe9."
            },
            "trip": {
                "allowed": "Commencer un nouveau trajet met fin au trajet actuel.\n\n\xcates-vous s\xfbr de vouloir arr\xeater et terminer le trajet actuel ?\n\n**Veuillez noter** : L'enregistrement NMEA sera arr\xeat\xe9.",
                "deniedInMotion": "Commencer un nouveau trajet n'est pas possible car le navire est en mouvement.",
                "deniedBlankExists": "Commencer un nouveau trajet n'est pas possible car il existe d\xe9j\xe0 un trajet vide qui n'a pas encore \xe9t\xe9 commenc\xe9."
            }
        }
    },
    "importShip": {
        "text": "Comment importer vos journaux de bord depuis **Logbook Suite** vers **LOGBOOK** :\n\n**\xc9tape 1 :** Dans Logbook Suite, utilisez la fonction **Exporter pour LOGBOOK** (disponible dans Logbook Suite Manager version 2.6 et ult\xe9rieure) via le bouton **Plus \u2026** pour exporter tous les journaux de bord que vous avez cr\xe9\xe9s pour votre navire.\n\n**\xc9tape 2 :** Dans LOGBOOK, cr\xe9ez un nouveau navire avec le m\xeame nom. Fermez la bo\xeete de dialogue affich\xe9e apr\xe8s la cr\xe9ation pour afficher vos param\xe8tres de compte dans le LOGBOOK Cloud. (Ignorez cette \xe9tape si vous avez d\xe9j\xe0 cr\xe9\xe9 le navire. Assurez-vous que le navire est ferm\xe9 \xe0 la fois dans le Cloud et dans l'application avant de passer \xe0 l'\xe9tape 3.)\n\n**\xc9tape 3 :** Votre nouveau navire appara\xeet maintenant dans la liste. S\xe9lectionnez **Options** pour le navire dans lequel vous souhaitez importer, puis choisissez **Importer depuis LogbookSuite**. Suivez les instructions. (La fonction d'importation n'est disponible que lorsque le LOGBOOK du navire n'est pas ouvert.)\n\n**\xc9tape 4 :** Dans l'application LOGBOOK, commencez un nouveau voyage avant de d\xe9buter ou de poursuivre l'enregistrement de donn\xe9es avec LOGBOOK."
    },
    "importTrips": {
        "text": "Importez les journaux de bord cr\xe9\xe9s avec **Logbook Suite** pour votre navire **{name}** dans **LOGBOOK**. S\xe9lectionnez le fichier cr\xe9\xe9 par l'outil d'exportation de Logbook Suite avec le nom suivant : ***[Nom du navire]_LOGBOOK_export.logbook***\n\nSi votre journal de bord import\xe9 contient des donn\xe9es de navire pas encore enregistr\xe9es dans LOGBOOK, les donn\xe9es de Logbook Suite seront import\xe9es. Les donn\xe9es de navire d\xe9j\xe0 saisies dans LOGBOOK ne seront pas \xe9cras\xe9es.\n\n**Remarque importante :** Le processus d'importation peut prendre du temps, surtout si vous avez un grand journal de bord. Veuillez \xeatre patient et ne pas interrompre le processus.\n\n**Attention :** Apr\xe8s l'importation, vous devez commencer un **nouveau voyage** avant de commencer ou de poursuivre l'enregistrement de donn\xe9es dans LOGBOOK."
    },
    "login": {
        "welcomeCloud": "Connectez-vous ou cr\xe9ez votre compte et commencez \xe0 tenir le journal de bord de votre navire avec LOGBOOK.\n\nVous pouvez essayer LOGBOOK gratuitement et cr\xe9er des entr\xe9es pendant 5 jours.",
        "welcomeApp": "Connexion \xe0 l'application LOGBOOK.\n\nSi vous n'avez pas encore de compte, vous pouvez en cr\xe9er un [ici](logbook:signup).",
        "welcomeAppiPad": "Connexion \xe0 l'application **LOGBOOK for Yachts** pour iOS.\n\nSi vous n'avez pas encore de compte, vous pouvez en cr\xe9er un [ici](logbook:signup).",
        "signupSuccess": "Votre compte a \xe9t\xe9 cr\xe9\xe9.\n\nNous vous avons envoy\xe9 un e-mail pour activation. Veuillez cliquer sur le lien dans l'e-mail pour continuer.",
        "invitation": "{inviter} vous a invit\xe9 et souhaite vous donner acc\xe8s \xe0 son LOGBOOK pour **{ship}**.\n\nSi vous avez d\xe9j\xe0 un compte pour LOGBOOK, connectez-vous simplement \xe0 votre compte.\n\nSi vous n'\xeates pas encore inscrit sur LOGBOOK, veuillez vous inscrire ici pour cr\xe9er votre compte gratuit. Vous serez ensuite connect\xe9 directement.\n\nApr\xe8s la connexion, votre compte LOGBOOK sera connect\xe9 au compte LOGBOOK de {inviter}. Ensuite, connectez-vous \xe0 l'application LOGBOOK. Dans la liste des navires dans vos param\xe8tres de compte, **{ship}** appara\xeetra sous **S\xe9lectionner parmi les navires partag\xe9s**, et vous pourrez vous connecter directement en tant que companion au LOGBOOK pour {ship}.",
        "invitationLoggedIn": "{inviter} vous a invit\xe9 et souhaite vous donner acc\xe8s \xe0 son LOGBOOK pour **{ship}**.\n\nEn cliquant sur **Accepter l'invitation**, vous confirmez l'invitation. Ensuite, connectez-vous \xe0 l'application LOGBOOK. Dans la liste des navires dans vos param\xe8tres de compte, **{ship}** appara\xeetra sous **S\xe9lectionner parmi les navires partag\xe9s**, et vous pourrez vous connecter directement en tant que companion au LOGBOOK pour {ship}.\n\nEn cliquant sur **Utiliser un autre compte**, vous pouvez \xe9galement s\xe9lectionner ou cr\xe9er un autre compte pour acc\xe9der au LOGBOOK pour {ship}.",
        "resetAppWarning": "Si vous rencontrez des probl\xe8mes pour d\xe9marrer l'application ou ouvrir un navire, vous pouvez r\xe9initialiser l'application LOGBOOK avec cette fonction.\n\nToutes les donn\xe9es stock\xe9es sur l'appareil seront supprim\xe9es. Toutes les donn\xe9es qui ont \xe9t\xe9 t\xe9l\xe9charg\xe9es depuis l'application LOGBOOK vers le LOGBOOK Cloud, et qui y sont stock\xe9es, seront conserv\xe9es.\n\nApr\xe8s la r\xe9initialisation, vous devez rouvrir l'application LOGBOOK et vous connecter avec votre compte. Lors de l'ouverture de votre navire, l'application LOGBOOK chargera alors \xe0 nouveau toutes les donn\xe9es depuis le LOGBOOK Cloud.\n\n**Important !** N'effectuez la r\xe9initialisation de l'application LOGBOOK que lorsque vous avez une connexion Internet.\n\n\xcates-vous s\xfbr de vouloir r\xe9initialiser l'application ?",
        "resetAppComplete": "La r\xe9initialisation de l'application LOGBOOK est termin\xe9e.\n\nSi l'application LOGBOOK n'a pas \xe9t\xe9 automatiquement ferm\xe9e, vous devez la fermer manuellement (kill) via le syst\xe8me d'exploitation et la red\xe9marrer."
    },
    "logout": {
        "logoutWithInternet": "**Avertissement \u2013 LOGBOOK Primary pour {name} ouvert**\n\nLe **LOGBOOK Primary {name}** est toujours ouvert dans l'application. La d\xe9connexion fermera le LOGBOOK Primary. Pour rouvrir le LOGBOOK Primary, une connexion Internet est requise.",
        "logoutWithoutInternet": "**D\xe9connexion impossible \u2013 pas de connexion Internet**\n\nUne connexion Internet est requise pour se d\xe9connecter. Veuillez v\xe9rifier votre connexion et r\xe9essayer."
    },
    "nmeaSettings": {
        "connectionTypeNative": "Pour utiliser le **GPS interne**, s\xe9lectionnez l'option **GPS int\xe9gr\xe9** sous **Type de connexion NMEA**. Sur la carte **Test et donn\xe9es**, la r\xe9ception GPS via le GPS int\xe9gr\xe9 est affich\xe9e s\xe9par\xe9ment.\n\nUn **appareil GPS externe** connect\xe9 via **Bluetooth** ou **c\xe2ble** \xe0 l'iPad se comporte de la m\xeame mani\xe8re que le GPS interne. Par cons\xe9quent, pour l'appareil GPS externe, s\xe9lectionnez \xe9galement le type de connexion **GPS int\xe9gr\xe9**.\n\nLes **capteurs internes** suppl\xe9mentaires disponibles, tels qu'un **barom\xe8tre interne**, peuvent \xeatre activ\xe9s ind\xe9pendamment du GPS int\xe9gr\xe9 sur la carte **Capteurs internes**.",
        "connectionTypeNativeWarning": "**Remarque importante**\n\nPour \xe9viter les entr\xe9es incorrectes lors de l'utilisation du GPS interne, avant de retirer l'iPad du navire, d\xe9connectez la connexion NMEA ou fermez le LOGBOOK Primary de votre navire via la commande de menu.\n\nVeuillez noter qu'une connexion Internet est requise \xe0 la fois pour fermer le navire et pour le rouvrir."
    },
    "noteText": {
        "uninitialized": "**Initialisation de la synchronisation**\n\nVeuillez patienter. Cela peut prendre quelques minutes.",
        "failed": "La synchronisation a \xe9chou\xe9. Nouvelle tentative prochainement.",
        "initialSyncFailed": "La synchronisation initiale a \xe9chou\xe9. Nouvelle tentative prochainement.",
        "initialSyncInProgress": "**Synchronisation initiale d\xe9marr\xe9e**\n\nVeuillez patienter. Cela peut prendre quelques minutes.",
        "dataWaiting": "En attente de synchronisation.",
        "inProgress": "**Synchronisation en cours**\n\nVeuillez patienter. Cela peut prendre quelques minutes.",
        "current": "Enti\xe8rement synchronis\xe9.",
        "disconnected": "**Connexion au LOGBOOK Cloud perdue**\n\nCet appareil n'est plus enregistr\xe9 comme LOGBOOK principal, la synchronisation est donc arr\xeat\xe9e.\n\nUtilisez **Reconnecter** dans le menu **Sync** pour r\xe9tablir la connexion. Il vous sera demand\xe9 si les donn\xe9es de cet appareil ou celles du LOGBOOK Cloud doivent \xeatre conserv\xe9es.",
        "transition": "**Pr\xe9paration de vos donn\xe9es**\n\nLes entr\xe9es existantes sont mises \xe0 jour pour cette version. Veuillez patienter, cela peut prendre quelques minutes.",
        "resync": "Les donn\xe9es de votre appareil sont en cours de t\xe9l\xe9chargement vers le LOGBOOK Cloud.",
        "newShip": "**Remarque importante**\n\nLe **type de navire** et le **nombre de moteurs** ne peuvent pas \xeatre modifi\xe9s apr\xe8s la cr\xe9ation du navire.",
        "shipOpen": "Le **LOGBOOK Primary** pour **{name}** est d\xe9j\xe0 ouvert sur un autre appareil.\n\n**Cas 1 - Vous \xeates \xe0 bord du navire**\n\nAssurez-vous que votre appareil est connect\xe9 au **r\xe9seau interne du navire**.\nEntrez ensuite l'adresse du LOGBOOK Primary ici pour \xe9tablir une connexion. Utilisez le format **IP:Port**, par exemple 192.168.0.100:8000. Vous pouvez trouver l'adresse dans le LOGBOOK Primary dans les **Param\xe8tres du navire** sous **Companions**.",
        "shipOpen2": "** **\n\n**Cas 2 - Aucun r\xe9seau interne de navire disponible ou vous n'\xeates pas \xe0 bord du navire**\n\nVous pouvez toujours consulter le dernier \xe9tat synchronis\xe9 du journal de bord dans le **LOGBOOK Cloud**.\n\n** **\n\n**Cas 3 - Vous souhaitez ouvrir le journal de bord en tant que LOGBOOK Primary sur cet appareil**\n\nSi n\xe9cessaire, vous pouvez utiliser **D\xe9connecter le LOGBOOK Primary** pour d\xe9connecter de force la connexion entre le LOGBOOK Primary et le LOGBOOK Cloud.",
        "shipNotClosed": "Utilisez cette fonction uniquement si vous \xeates s\xfbr que le LOGBOOK Primary doit \xeatre d\xe9connect\xe9 du LOGBOOK Cloud \u2013 par exemple, parce que l'appareil primary est d\xe9fectueux ou pour d'autres raisons l'acc\xe8s \xe0 l'appareil primary n'est plus possible.\n\nToutes les donn\xe9es enregistr\xe9es apr\xe8s la d\xe9connexion du LOGBOOK Primary ne seront pas synchronis\xe9es et peuvent \xeatre perdues.\n\n- Utilisez le bouton ci-dessous pour passer \xe0 la liste des navires dans le LOGBOOK Cloud.\n\n- Ouvrez le dialogue **Options** avec le bouton **Options** (le bouton affiche une couleur diff\xe9rente pour le navire concern\xe9). Vous pouvez maintenant d\xe9connecter le navire via ce dialogue.\n\nApr\xe8s une courte attente, le LOGBOOK Primary du navire peut \xeatre rouvert. Si n\xe9cessaire, vous pouvez actualiser la vue avec le bouton d'actualisation. La r\xe9ouverture peut prendre plusieurs minutes car l'application LOGBOOK doit r\xe9cup\xe9rer toutes les donn\xe9es du LOGBOOK Cloud.",
        "shipOpenCompanion": "Entrez l'adresse du LOGBOOK Primary ici pour \xe9tablir une connexion.\n\nUtilisez le format **IP:Port**, par exemple **192.168.0.100:8000**.\n\nVous pouvez trouver l'adresse dans le LOGBOOK Primary dans les param\xe8tres du navire sur la carte **Companions**.",
        "shipsSmartphone": "LOGBOOK ne peut \xeatre utilis\xe9 que comme Companion sur un smartphone et offre donc des fonctionnalit\xe9s limit\xe9es.\n\nSeuls les navires dont le LOGBOOK Primary est d\xe9j\xe0 en cours d'ex\xe9cution sur un autre appareil peuvent \xeatre s\xe9lectionn\xe9s. Pour la connexion Companion, votre smartphone doit \xeatre sur le m\xeame r\xe9seau que l'appareil primary.",
        "selectShip": "S\xe9lection du navire sur le cloud LOGBOOK.",
        "selectShipFailed": "La s\xe9lection du navire a \xe9chou\xe9 sur le cloud LOGBOOK.\n\nVeuillez r\xe9essayer dans quelques minutes.",
        "limitActiveShipsReached": "Vous avez atteint votre limite de navires actifs.\n\nPour s\xe9lectionner un autre navire, vous devez d'abord fermer le navire actuellement ouvert sur le cloud LOGBOOK.",
        "startShip": "<strong>Votre navire \"{name}\" a \xe9t\xe9 cr\xe9\xe9 \u2013 Passez maintenant \xe0 l'application LOGBOOK</strong>\n\nVotre nouveau navire a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s et est maintenant affich\xe9 ici dans le **cloud LOGBOOK**.\n\nSi vous le souhaitez, vous pouvez directement saisir plus de donn\xe9es de navire ici dans le cloud LOGBOOK. Pour cela, s\xe9lectionnez l'\xe9l\xe9ment de menu **Donn\xe9es du navire {name}** dans le menu <strong>{name}</strong>.\n\nEnsuite, le premier voyage et le premier trajet doivent \xeatre pr\xe9par\xe9s. Pour cela, ouvrez votre nouveau navire dans l'**application LOGBOOK**. Si vous n'avez pas encore install\xe9 l'application LOGBOOK, vous pouvez trouver les liens de t\xe9l\xe9chargement ici : <a href=\"https://logbook.yachts/site/en/download\" target=\"_blank\">T\xe9l\xe9charger l'application LOGBOOK</a>.\n\nUne fois le premier voyage et le premier trajet cr\xe9\xe9s, ils seront \xe9galement affich\xe9s ici dans le cloud LOGBOOK.",
        "firstLogin": '**Bienvenue sur LOGBOOK** \u2013 le logiciel de journal de bord innovant\n\n**Votre compte a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s.**\n\n<li>Cr\xe9ez maintenant votre <strong>premier navire</strong> \u2026</li>\n<li>\u2026 configurez la <strong>connexion NMEA</strong> \u2026</li>\n<li>\u2026 et vous \xeates <strong>pr\xeat pour votre premier trajet</strong> avec LOGBOOK.</li>\n\nDes instructions d\xe9taill\xe9es se trouvent dans le <a href="https://logbook.yachts/site/en/documentation/#h1_quickstart" target="_blank">QuickStart</a> et dans les <a href="https://logbook.yachts/site/en/demos" target="_blank">D\xe9mos interactives</a>.',
        "firstLoginCloud": 'Si vous n\'avez pas encore install\xe9 l\'application LOGBOOK, vous pouvez trouver les liens de t\xe9l\xe9chargement ici : <a href="https://logbook.yachts/site/en/download" target="_blank">T\xe9l\xe9charger l\'application LOGBOOK</a>.'
    },
    "sessionExpired": {
        "text": "**Connexion requise \u2013 aucune liaison avec le LOGBOOK Cloud**\n\nLe LOGBOOK Cloud n'accepte plus la connexion de cet appareil. Rien n'est perdu : votre navire reste ouvert et tout ce que vous enregistrez est conserv\xe9 sur cet appareil.\n\nTant que vous ne vous reconnectez pas, aucune donn\xe9e n'est synchronis\xe9e avec le Cloud et aucun autre appareil ne voit vos saisies."
    },
    "shipClose": {
        "text": "\xcates-vous s\xfbr de vouloir fermer le LOGBOOK Primary pour le navire nomm\xe9 **{name}** ?\n\n**Cela arr\xeatera l'enregistrement des donn\xe9es et se d\xe9connectera du NMEA.**\n\nVeuillez \xe9galement noter : Vous aurez besoin d'une **connexion Internet** si vous souhaitez revenir \xe0 ce navire plus tard !",
        "internet": "**Fermeture du navire impossible \u2013 pas de connexion Internet**\n\nUne connexion Internet est n\xe9cessaire pour fermer le navire. Veuillez v\xe9rifier votre connexion et r\xe9essayer.",
        "forceWarning": "**Forcer la fermeture uniquement sur cet appareil ?**\n\nCette action ferme **{name}** localement sans synchronisation. Le navire reste revendiqu\xe9 dans le LOGBOOK Cloud et doit y \xeatre ferm\xe9 manuellement avant de pouvoir \xeatre rouvert.\n\nLes donn\xe9es locales non synchronis\xe9es restent stock\xe9es sur cet appareil.",
        "keepOpen": "**Conseil :**\n<p>Nous recommandons de garder le <strong>LOGBOOK Primary ouvert</strong> pendant tout le voyage. <br>\nApr\xe8s la fin de la journ\xe9e, vous pouvez simplement fermer l'application. <br>\nGardez le <strong>LOGBOOK Primary ouvert</strong> et <strong>ne vous d\xe9connectez pas</strong>. L'enregistrement des donn\xe9es sera alors interrompu, mais le statut du LOGBOOK Primary sera conserv\xe9. <br>\nApr\xe8s le red\xe9marrage de l'application, le LOGBOOK Primary est imm\xe9diatement disponible.</p>",
        "noSync": "La synchronisation avec le LOGBOOK Cloud a \xe9chou\xe9 car ce LOGBOOK n'est plus enregistr\xe9 en tant que LOGBOOK Primary dans le LOGBOOK Cloud.\n\nSi vous fermez le navire, toutes les modifications qui n'ont pas encore \xe9t\xe9 enregistr\xe9es dans le LOGBOOK Cloud seront perdues.\n\nVous pouvez essayer de restaurer la connexion au LOGBOOK Cloud en utilisant **Reconnecter** dans le menu **Sync**, synchroniser les donn\xe9es, puis fermer le navire."
    },
    "shipInfo": {
        "disconnect": "\xcates-vous s\xfbr de vouloir d\xe9connecter le LOGBOOK Primary pour le navire nomm\xe9 **{name}** ?\n\n**Cela arr\xeatera toute synchronisation de ce journal de bord avec le LOGBOOK Cloud.**\n\nVeuillez \xe9galement noter :\n\nSi le LOGBOOK Primary sur le navire n'a pas de connexion Internet, toutes les donn\xe9es enregistr\xe9es apr\xe8s la d\xe9connexion ne seront pas synchronis\xe9es et peuvent \xeatre perdues.",
        "resync": "Le LOGBOOK Primary pour votre navire **{name}** n'est plus connect\xe9 au LOGBOOK Cloud. Pour restaurer cette connexion, les donn\xe9es doivent \xeatre synchronis\xe9es \xe0 nouveau.\n\nSoit les donn\xe9es sur l'appareil, soit les donn\xe9es dans le LOGBOOK Cloud seront r\xe9initialis\xe9es. Ensuite, cet appareil sera configur\xe9 comme **LOGBOOK Primary** pour **{name}**. Enfin, les donn\xe9es seront synchronis\xe9es entre le LOGBOOK Primary et le LOGBOOK Cloud.\n\n**Avertissement !**\n\nCette fonction est destin\xe9e \xe0 un usage d'urgence uniquement. Ne l'ex\xe9cutez que sur l'appareil configur\xe9 comme **LOGBOOK Primary** pour **{name}**. Si le LOGBOOK Primary est effectivement configur\xe9 sur un appareil diff\xe9rent, les donn\xe9es enregistr\xe9es avec cet appareil peuvent \xeatre perdues.\n\n* V\xe9rifiez d'abord si les donn\xe9es ici dans l'application LOGBOOK ou dans le LOGBOOK Cloud sont plus r\xe9centes.\n\n* D\xe9cidez ensuite si vous souhaitez conserver les donn\xe9es ici dans l'application LOGBOOK ou les donn\xe9es dans le LOGBOOK Cloud comme donn\xe9es actuelles.\n\n* S\xe9lectionnez le bouton appropri\xe9 pour d\xe9marrer le processus.",
        "resyncUnavailable": "La r\xe9initialisation du LOGBOOK pour votre navire **{name}** n'a pas pu \xeatre compl\xe9t\xe9e car un appareil est toujours connect\xe9 au navire dans le LOGBOOK Cloud.\n\n**Important :** V\xe9rifiez d'abord si le LOGBOOK Primary est actuellement en cours d'ex\xe9cution sur un autre appareil. Si c'est le cas, d\xe9marrez le processus depuis cet autre appareil et suivez les \xe9tapes l\xe0-bas.\n\nPour proc\xe9der ici, d\xe9connectez cet appareil dans le LOGBOOK Cloud :\n\n* Passez au LOGBOOK Cloud en utilisant la commande **Vers LOGBOOK Cloud** dans le menu **Compte**.\n* Dans le LOGBOOK Cloud, le bouton **Options** \xe0 c\xf4t\xe9 de votre navire est surlign\xe9 en bleu.\n* Dans les options, s\xe9lectionnez **D\xe9connecter le navire**.\n* Revenez \xe0 l'application LOGBOOK.\n* Ouvrez \xe0 nouveau le dialogue pour restaurer la synchronisation. Vous pouvez maintenant choisir quelles donn\xe9es vous souhaitez conserver.",
        "resync_reset_local_confirm": "**Voulez-vous vraiment utiliser les donn\xe9es locales ?**\n\nCette action r\xe9initialisera les donn\xe9es du cloud.\n\nCette action ne peut pas \xeatre annul\xe9e et entra\xeenera la perte de toutes les donn\xe9es stock\xe9es dans le LOGBOOK Cloud et non pr\xe9sentes sur cet appareil.",
        "resync_reset_cloud_confirm": "**Voulez-vous vraiment utiliser les donn\xe9es du cloud ?**\n\nCette action r\xe9initialisera les donn\xe9es locales.\n\nCette action ne peut pas \xeatre annul\xe9e et entra\xeenera la perte de toutes les donn\xe9es stock\xe9es uniquement sur cet appareil et non pr\xe9sentes dans le LOGBOOK Cloud."
    },
    "shipSetting": {
        "utc": "**Remarque importante**\n\n**Veuillez noter que le fuseau horaire pour l'heure du navire est fixe pour l'ensemble du trajet une fois qu'il a commenc\xe9.** Toute modification ici n'affectera pas un trajet d\xe9j\xe0 commenc\xe9.",
        "utc_info": "LOGBOOK d\xe9finit g\xe9n\xe9ralement l'heure du navire sur l'heure syst\xe8me de l'appareil primary.\n\n Dans certains cas, le syst\xe8me de l'appareil primary peut ne pas transmettre correctement le fuseau horaire \xe0 LOGBOOK. Dans ce cas, vous avez la possibilit\xe9 de d\xe9finir manuellement le fuseau horaire pour l'heure du navire.",
        "log_offset": "Si votre transducteur de loch a \xe9t\xe9 remplac\xe9 et que la valeur de loch pr\xe9c\xe9dente n'a pas pu \xeatre transf\xe9r\xe9e, entrez l'ancienne valeur ici comme d\xe9calage. Elle sera automatiquement ajout\xe9e aux nouvelles mesures, garantissant que la distance totale de votre navire est correctement continu\xe9e.",
        "keep_rpm": "Si aucune donn\xe9e moteur n'est disponible via NMEA, vous pouvez activer cette option pour reporter automatiquement la valeur de RPM que vous avez saisie manuellement dans la prochaine entr\xe9e de journal. Cela est utile lorsque la vitesse du moteur ne change pas entre les entr\xe9es.",
        "lights": "Lorsqu'elle est activ\xe9e, LOGBOOK vous rappelle discr\xe8tement, dans un bouton sur la ligne de journal actuelle, d\xe8s que les signaux visuels enregistr\xe9s pour le navire ne correspondent pas \xe0 ce que le RIPAM recommande pour l'\xe9tat de propulsion et l'heure actuels.\n\nAucune alarme n'est jamais d\xe9clench\xe9e \u2014 enregistrer les signaux visuels correspondants ferme le rappel. \n\nConfigurez les feux que votre navire porte \xe0 la voile, si la limite jour/nuit suit le cr\xe9puscule civil ou le coucher/lever du soleil, et si le c\xf4ne de moteur optionnel doit faire l'objet d'un rappel.",
        "edit_permissiveness": "Contr\xf4le la permissivit\xe9 de la modification d'une entr\xe9e de journal ou de jour une fois enregistr\xe9e. Cela affecte chaque entr\xe9e existante et future d\xe8s que le r\xe9glage est modifi\xe9 \u2014 pas seulement les entr\xe9es cr\xe9\xe9es par la suite.\n\n**Par d\xe9faut (strict)** \u2014 le comportement actuel. Une valeur fournie en direct par NMEA (par ex. cap, profondeur, r\xe9gime moteur, loch, pression, temp\xe9rature, humidit\xe9, vent, cap et vitesse fond) reste verrouill\xe9e jusqu'\xe0 ce que vous la corrigiez manuellement, et n'est modifiable que peu de temps apr\xe8s son enregistrement.\n\nLe r\xe9gime moteur saisi manuellement fait exception \xe0 la restriction de temps : il peut aussi \xeatre saisi ou corrig\xe9 dans les entr\xe9es ant\xe9rieures. Les valeurs encore prot\xe9g\xe9es comme donn\xe9es NMEA restent verrouill\xe9es.\n\n**\xc9tendu** \u2014 supprime la restriction de temps, de sorte que les valeurs fournies par NMEA peuvent encore \xeatre corrig\xe9es plus tard, mais les valeurs qui n'ont pas encore \xe9t\xe9 corrig\xe9es manuellement restent prot\xe9g\xe9es.\n\n**Illimit\xe9** \u2014 supprime enti\xe8rement cette protection. Chaque valeur, y compris celles fournies en direct par NMEA, peut \xeatre modifi\xe9e \xe0 tout moment. **\xc0 utiliser avec pr\xe9caution :** cela supprime l'indication qu'une valeur a \xe9t\xe9 enregistr\xe9e automatiquement par un capteur plut\xf4t que saisie ou modifi\xe9e manuellement, ce qui peut avoir de l'importance pour la valeur probante de votre journal de bord.\n\nCertains champs (par ex. la distance) sont toujours calcul\xe9s automatiquement et ne peuvent jamais \xeatre modifi\xe9s directement, quel que soit le niveau."
    },
    "planDescriptions": {
        "captain": "Abonnement annuel pour professionnels, longueur de navire inf\xe9rieure \xe0 24 m",
        "master_captain": "Abonnement annuel pour professionnels, longueur de navire \xe0 partir de 24 m",
        "skipper": "Abonnement mensuel ou annuel pour capitaines priv\xe9s",
        "skipper_inApp": "Abonnement mensuel pour capitaines priv\xe9s \u2013 achat int\xe9gr\xe9",
        "trial": "Essai gratuit de 5 jours"
    },
    "subscription": {
        "checkoutComplete": "Achat r\xe9ussi.",
        "checkoutProcessing": "Finalisation de votre achat...",
        "subscriptionMessage": "Choisissez un forfait.\n\nQuel que soit l'appareil \xe0 partir duquel vous achetez cet abonnement, vous pouvez utiliser LOGBOOK avec tous les appareils pris en charge simultan\xe9ment ou alternativement (macOS, Windows, Android et iOS). L'abonnement n'est pas li\xe9 \xe0 une plateforme sp\xe9cifique.",
        "subscriptionMessageiPad": "Abonnez-vous pour continuer \xe0 utiliser LOGBOOK avec toutes ses fonctionnalit\xe9s apr\xe8s la fin de votre p\xe9riode d'essai.\n\nUne fois les 5 jours gratuits \xe9coul\xe9s, vous pouvez seulement consulter et imprimer vos donn\xe9es enregistr\xe9es. Aucune nouvelle saisie ni modification n'est possible.\n\nL'abonnement mensuel **LOGBOOK Skipper** est particuli\xe8rement adapt\xe9 aux capitaines priv\xe9s qui souhaitent tenir leur journal de bord de pr\xe9f\xe9rence ou exclusivement sur l'iPad. L'abonnement se renouvelle automatiquement et peut \xeatre annul\xe9 \xe0 la fin de chaque p\xe9riode.\n\nCet abonnement peut \xe9galement \xeatre utilis\xe9 sur d'autres plateformes, simultan\xe9ment ou alternativement.",
        "demo1Day": "**La phase d'essai se termine dans un jour**\n\nIl vous reste encore un jour pour tester LOGBOOK gratuitement et cr\xe9er des entr\xe9es.\n\nApr\xe8s cela, vous pouvez continuer sans interruption avec un abonnement et poursuivre votre journal de bord.",
        "demo2Days": "**La phase d'essai se termine dans 2 jours**\n\nVous pouvez encore cr\xe9er des entr\xe9es dans LOGBOOK gratuitement pendant 2 jours suppl\xe9mentaires.\n\nApr\xe8s cela, vous pouvez continuer sans interruption avec un abonnement et poursuivre votre journal de bord.",
        "demoEnded": "**Phase d'essai termin\xe9e**\n\nVotre phase de d'essai est termin\xe9e. Avec un abonnement, vous pouvez maintenant poursuivre votre journal de bord. Nous conserverons vos donn\xe9es de test stock\xe9es dans le LOGBOOK Cloud pendant encore 6 mois.",
        "demoToday": "**La phase d'essai se termine aujourd'hui**\n\nVous pouvez encore cr\xe9er des entr\xe9es dans LOGBOOK gratuitement aujourd'hui.\n\nApr\xe8s cela, la phase d'essai se termine. Avec un abonnement, vous pouvez poursuivre votre journal de bord \xe0 tout moment.",
        "demoStarted": "**Phase d'essai d\xe9marr\xe9e**\n\nVotre phase d'essai a commenc\xe9 avec votre premi\xe8re entr\xe9e dans LOGBOOK.\n\nVous pouvez maintenant cr\xe9er des entr\xe9es de journal de bord pendant un total de **5 jours**.",
        "subscription7Days": "**L'abonnement se termine dans quelques jours**\n\nVotre abonnement expirera bient\xf4t. Ne vous inqui\xe9tez pas \u2013 le renouvellement sera automatique, vous pouvez donc continuer \xe0 utiliser votre journal de bord sans interruption.\n\nSi vous souhaitez ajuster votre abonnement, vous pouvez le faire \xe0 tout moment.",
        "subscriptionExpired": "**Abonnement expir\xe9**\n\nVotre abonnement a expir\xe9. Mais ne vous inqui\xe9tez pas \u2013 toutes vos donn\xe9es resteront stock\xe9es en toute s\xe9curit\xe9 dans le LOGBOOK Cloud pendant encore 2 ans.\n\nRenouvelez votre abonnement maintenant pour continuer votre journal de bord.",
        "subscriptionToday": "**L'abonnement se termine aujourd'hui**\n\nVotre abonnement expire aujourd'hui. Renouvelez-le maintenant pour continuer \xe0 utiliser votre journal de bord.",
        "removeAccount": 'Confirmez la suppression du compte.\n\nCela supprimera d\xe9finitivement le compte "{account}" et l\'utilisateur "{user}".\n\nVous perdrez l\'acc\xe8s \xe0 tous les navires, voyages, trajets et entr\xe9es de journal de bord associ\xe9s \xe0 ce compte.',
        "removeAccountDone": 'Votre compte "{account}" et l\'utilisateur "{user}" dans LOGBOOK ont \xe9t\xe9 supprim\xe9s avec succ\xe8s.'
    },
    "mailer": {
        "footer": "",
        "templates": {
            "signupConfirmation": {
                "subject": "",
                "footer": "",
                "body": ""
            },
            "signupWelcome": {
                "subject": "",
                "footer": "",
                "body": ""
            },
            "invited": {
                "subject": "",
                "footer": "",
                "body": ""
            },
            "passwordReset": {
                "subject": "",
                "footer": "",
                "body": ""
            },
            "betaInvite": {
                "subject": "",
                "footer": "",
                "body": ""
            },
            "subscriptionWelcomeSkipper": {
                "subject": "",
                "footer": "",
                "body": ""
            },
            "subscriptionWelcomeCaptain": {
                "subject": "",
                "footer": "",
                "body": ""
            },
            "subscriptionWelcomeMasterCaptain": {
                "subject": "",
                "footer": "",
                "body": ""
            },
            "trialStarted": {
                "subject": "",
                "footer": "",
                "body": ""
            },
            "trialExpiring": {
                "subject": "",
                "footer": "",
                "body": ""
            },
            "trialExpired": {
                "subject": "",
                "footer": "",
                "body": ""
            },
            "contact": {
                "subject": "",
                "footer": "",
                "body": ""
            },
            "betaContact": {
                "subject": "",
                "footer": "",
                "body": ""
            }
        }
    }
};


const $0258f51bf6f9f9d6$export$716a56fcc9fe5dff = (text, replace)=>{
    const values = Object.fromEntries(Object.entries(replace !== null && replace !== void 0 ? replace : {}).filter(([, value])=>value !== undefined && value !== null));
    return (0, $6d103d423c562944$export$f5bf8d096973061c)(text, values);
};
const $0258f51bf6f9f9d6$export$b6fc69901997e05 = {
    // The languages the app ships translations for. Mirrors
    // `LogbookLanguage.supported` (Sources/LogbookFoundation/Language.swift), the
    // Apple bundles' `CFBundleLocalizations`, the appx `<Resource Language>`
    // entries and Android's `locales_config.xml` — adding a language means
    // touching all of them.
    Supported: [
        "en",
        "de",
        "fr"
    ],
    Fallback: "en",
    Languages: {
        en: (0, (/*@__PURE__*/$parcel$interopDefault($d9716ee0dfd0c27d$exports))),
        de: (0, (/*@__PURE__*/$parcel$interopDefault($151b0f051dad138e$exports))),
        fr: (0, (/*@__PURE__*/$parcel$interopDefault($d10198c4b537855c$exports)))
    },
    Messages: {
        en: $78b9bea2ad5f8ca1$exports,
        de: $c704c9b2c9549272$exports,
        fr: $773869f697d3f41b$exports
    },
    // Resolves a list of locale identifiers (BCP-47 `de-DE`, or Java's `de_DE`) to
    // a language we can serve, or `undefined` when none of them is supported.
    //
    // Walks the list in order and takes the first entry whose *base* subtag is
    // supported, so a device set to Italian with German second gets German rather
    // than the English fallback. The Swift counterpart is
    // `LogbookLanguage.resolve`; both exist because the native shells resolve
    // before injecting, and the web app re-validates whatever arrives.
    resolve: function(preferred) {
        const unsupported = "__unsupported__";
        const resolved = (0, $6d103d423c562944$export$9bdef8dfc722a565)(preferred.filter((tag)=>tag !== undefined).map((tag)=>tag.trim().replace("_", "-").toLowerCase()), [
            ...$0258f51bf6f9f9d6$export$b6fc69901997e05.Supported,
            unsupported
        ], unsupported);
        return resolved === unsupported ? undefined : resolved;
    },
    t: function(language, text, replace) {
        return $0258f51bf6f9f9d6$export$716a56fcc9fe5dff((0, $6d103d423c562944$export$5a1a8430df9521e)(text, {
            language: language,
            fallbackLanguage: $0258f51bf6f9f9d6$export$b6fc69901997e05.Fallback,
            dictionaries: $0258f51bf6f9f9d6$export$b6fc69901997e05.Languages,
            missing: text
        }), replace);
    }
};


function $2e799dc50d0acd79$export$ce4ab0c55987d1ff(names) {
    return names.filter((n)=>n).flatMap((n)=>n).join(" ");
}
function $2e799dc50d0acd79$export$2ab9a8f9f1186f14(defaultValue, ...values) {
    for (const v of values){
        if (v != undefined) return v;
    }
    return defaultValue;
}


var $e2082abdfcafc000$exports = {};
$e2082abdfcafc000$exports = {
    "demo": {
        "concept": {
            "title": "LOGBOOK Concept",
            "start1": "LOGBOOK Concept",
            "start2": "A logbook is a chronological report about the **positions of a ship during a voyage** \u2013 the ship\u2019s movement and the events on board in space and time.",
            "timelineOverview": "In LOGBOOK, the ship time is displayed in the form of a **Timeline**. \nThe timeline is a continuous **vertical timeline** that runs **from top to bottom**.",
            "timelineYears_title": "LOGBOOK Concept: Overview Timeline",
            "timelineYears": "The timeline begins in the **first year** for which there is an entry and extends to the end of the **current year**. All of your **voyages** are arranged along this timeline.",
            "timelineYears2_title": "LOGBOOK Concept: Overview Timeline   ",
            "timelineYears2": "Instead of the confusing page-turning between times of day in analog logbooks, there is intuitive **scrolling** and **zooming** in the digital timeline.",
            "timelineYears3_title": "LOGBOOK Concept: Overview Timeline",
            "timelineYears3": "In **Overview mode**, the timeline displays **years** and **months**. Each month is indicated by a small line.\nAs soon as there are log entries for a year, the timeline is stretched for that year.  ",
            "timelineYears4_title": "LOGBOOK Concept: Overview Timeline    ",
            "timelineYears4": "To the right of the timeline, **voyages** appear with name and time period, and the relevant **time period** is marked in color on the timeline.",
            "timelineVoyageClick_title": "LOGBOOK Concept: Overview Timeline  ",
            "timelineVoyageClick": "By **clicking on a voyage**, LOGBOOK switches from overview mode to displaying the selected voyage. ",
            "timelineVoyage1_title": "LOGBOOK Concept: Voyage View   ",
            "timelineVoyage1": "LOGBOOK zooms into the timeline and shows only a section of the entire timeline, ranging from the **first to the last day** of the selected **voyage**. ",
            "timelineVoyage2_title": "LOGBOOK Concept: Voyage View   ",
            "timelineVoyage2": "Each **voyage** can contain a number of **passages** where each passage can contain a number of **days**. All days are listed along the timeline in chronological order.",
            "timelineVoyage3_title": "LOGBOOK Concept: Voyage View  ",
            "timelineVoyage3": "The button to the left of the voyage name shows and hides the **voyage's data sheet**. ",
            "timelineVoyage4_title": "LOGBOOK Concept: Voyage View   ",
            "timelineVoyage4": "The data sheet contains multiple cards. On the **Voyage** card, the voyage can be given a name. ",
            "timelineVoyage5_title": "LOGBOOK Concept: Voyage View   ",
            "timelineVoyage5": "The **Statistics** card provides a summary and analysis of the voyage.",
            "timelineVoyage6_title": "LOGBOOK Concept: Voyage View   ",
            "timelineVoyage6": "The **Track** card shows the track of the entire voyage on a nautical chart. On the **Voyage plan** card, there is the opportunity to plan the course of the voyage in advance.",
            "timelineVoyage7_title": "LOGBOOK Concept: Voyage View   ",
            "timelineVoyage7": "The **button on the top right** of the voyage area brings you back to the overview timeline. ",
            "timelineVoyage8_title": "LOGBOOK Concept: Voyage View   ",
            "timelineVoyage8": "And the button on the left closes the dataview of the voyage.",
            "timelineVoyage9_title": "LOGBOOK Concept: Voyage View   ",
            "timelineVoyage9": "Directly below the voyage area begins the first **passage** of the voyage. ",
            "timelinePassage1_title": "LOGBOOK Concept: The Passage ",
            "timelinePassage1": "All **days of the passage** are displayed along the timeline. The period during which the ship was underway on the respective day is highlighted in color on the timeline. \n\nThe lines divide the day into 4-hour sections.",
            "timelinePassage2_title": "LOGBOOK Concept: The Passage ",
            "timelinePassage2": "Clicking the arrow to the left of the name displays the **passage's data sheet** with multiple cards with data, settings, and displays. \nHere you can see the **Statistics** card with a summary and analysis of the passage.",
            "timelinePassage3_title": "LOGBOOK Concept: The Passage ",
            "timelinePassage3": "Clicking on the **date of a day** opens the day.",
            "timelineDay1_title": "LOGBOOK Concept: The Day",
            "timelineDay1": "It receives a **color-highlighted header** and all **log entries** recorded during the day are listed along the timeline, which is further stretched in this area.",
            "timelineDay2_title": "LOGBOOK Concept: The Day",
            "timelineDay2": "**Each hour of the day** is marked by a **line**, each 4 hours are somewhat longer, and for 0:00 h and 12:00 h even longer. This makes it easy to see at a glance how the **log entries** are distributed throughout the day.",
            "timelineDay3_title": "LOGBOOK Concept: The Day",
            "timelineDay3": "The  arrow in the colored header displays the **day's data sheet** with various cards instead of the list of **log entries**.",
            "timelineDay4_title": "LOGBOOK Concept: The Day",
            "timelineDay4": "The card **Day** allows to enter information on the day, like persons in the crew, when starting and arriving and more.",
            "timelineDay5_title": "LOGBOOK Concept: The Day",
            "timelineDay5": "Some of the cards like **Statistics**, **Track** and **Weather** show evaluations \u2026",
            "timelineDay6_title": "LOGBOOK Concept: The Day",
            "timelineDay6": "\u2026 others like **Journal** and **Technic** allow to enter individual text and photos.",
            "timelineDay7_title": "LOGBOOK Concept: The Day",
            "timelineDay7": "By closing the day's data sheet with the toogle button on the top right of the data sheet ..., ",
            "timelineLog1_title": "LOGBOOK Concept: The Log Entry",
            "timelineLog1": "\u2026 you return to the list with all **log entries** of the day, the smallest unit in LOGBOOK. ",
            "timelineLog2_title": "LOGBOOK Concept: The Log Entry",
            "timelineLog2": "The **log entry** contains NMEA data and additional information relating to a specific point in time.",
            "timelineLog3_title": "LOGBOOK Concept: The Log Entry",
            "timelineLog3": "Clicking on a **log entry** displays the **log entry's data sheet**.",
            "timelineLog4_title": "LOGBOOK Concept: The Log Entry",
            "timelineLog4": "The selected **log entry** shows a **color-highlighted header**. On the **log entry's data sheet**, the **automatically captured data** is displayed and for the current log entry additional data can be entered.",
            "timelineLog5_title": "LOGBOOK Concept: The Log Entry",
            "timelineLog5": "Which fields contain not editable, automatically entered data and which fields allow **manual data entry** depends on the **data present in the NMEA**.   ",
            "final1_title": "LOGBOOK \u2013 Your companion at sea",
            "final1": "**LOGBOOK** is your faithful companion on every voyage \u2013 always by your side, from the first log entry to the last.\n\n**LOGBOOK** accompanies you through every passage, every day at sea, and keeps your ship's story alive.",
            "final2_title": "Learn more about LOGBOOK",
            "final2": "Check out our other screencasts and learn more about the use of **LOGBOOK** in daily practice. (More screencasts coming soon.)"
        },
        "quickstart": {
            "title": "LOGBOOK QuickStart \u2013 One time Preparations ",
            "start": "This quickstart will help you to **get started with LOGBOOK** in just a few steps. It is a shortend version of the **QuickStart Guide** in our documentation. For more detailed instructions and tips, please check out this.",
            "start1_title": "Login  ",
            "start1": "**Login** to your account in the **LOGBOOK cloud** at \n\n**https://logbook.yachts/app**.",
            "start2_title": "Login",
            "start2": "You are now logged in your personal **Account settings**. ",
            "start3_title": "Initial Setup (one-time only)",
            "start3": "Before you can keep your first logbook with LOGBOOK, two steps are required (one-time only): \n\n1 -  **Create a ship**.\n\n2 -  **Establish and analyze the connection to the ship's NMEA** or to the device's integrated GPS.",
            "createShip_title": "Create a ship",
            "createShip": "First, LOGBOOK needs some information about your **ship** that affects the basic configuration of the logbook. Therefore, when starting LOGBOOK for the first time, the **Create new Ship** view is displayed.\n\nEnter the **ship's name** here, select the **ship type** (sailboat/motorboat), and set the **number of engines**.",
            "createShip2_title": "Create a ship",
            "createShip2": "Then close the view with the **Create Ship** button. Closing is only possible when all three fields are filled in.",
            "createShip3_title": "Create a ship",
            "createShip3": "Use the link in the bottom of the text to switch to the **LOGBOOK app**.",
            "createShip4_title": "Create a ship",
            "createShip4": "In the LOGBOOK app, you now see the **Overview timeline** for your ship. \n\nIn the **Ship section** the ship type and ship name as well as some buttons are displayed. All additional information about the ship can be entered at any time later in the **Ship data** view.\n\nIn this demo the MMSI and call sign had been already entered.",
            "connectNMEA_title": "Set Up NMEA Connection",
            "connectNMEA": "First, **turn on** your NMEA network or GPS and **connect your device** to the NMEA network/GPS. ",
            "connectNMEA2_title": "Set Up NMEA Connection",
            "connectNMEA2": "The device, which is connected to the NMEA, is called the **Primary Device** with the **Primary LOGBOOK**. The Primary LOGBOOK is the main logbook that receives the NMEA data and creates log entries. ",
            "connectNMEA3_title": "Set Up NMEA Connection",
            "connectNMEA3": 'Now choose **Settings** from the menu of the **NMEA** button (on the right in the Ship section). If no connection has been set up yet, the button shows a red marker <span style="color: var(--red); font-size: 1.5em;">\u25A1</span>.   ',
            "connectNMEA4_title": "Set Up NMEA Connection",
            "connectNMEA4": "On the first card of the dialog go to **NMEA connection type** and select which protocol or connection type connects the NMEA network to your device (**USB** or WiFi/Ethernet with **TCP**). \n\nIf you can choose how to connect your NMEA to your device: TCP is better than USB.  ",
            "connectNMEA5_title": "Set Up NMEA Connection",
            "connectNMEA5": "Then make the settings in the additional fields displayed for the connection type (Address, Port, etc.). You can find the required data in the documentation of the gateway, multiplexer, or plotter. For **USB** the available devices are listed under **Device**.\n\nIf your device has an **internal GPS**, there will be an extra option.",
            "connectNMEA6_title": "Test Connection",
            "connectNMEA6": "Use the button **Test Connection** to switch to the next card of the dialog and start testing the connection.",
            "connectNMEA7_title": "Test Connection",
            "connectNMEA7": "LOGBOOK starts **data recording** via the connection set on the first card of the dialog. It may take a moment until the **first data is received**. ",
            "connectNMEA8_title": "Test Connection",
            "connectNMEA8": "If at least **UTC** and **GPS position** show a green dot on the **Test and Data** card, you can close the dialog with **Complete**.  ",
            "connectNMEA9_title": "Test Connection",
            "connectNMEA9": 'The green, unfilled marker <span style="color: var(--green); font-size: 1.5em;">\u25A1</span> in the **NMEA button** as well as the orange dot  <span style="color: var(--orange); font-size: 1.5em; vertical-align: bottom;">\u25CF</span> for **Automatic logging** menu entry show that the connection to the NMEA network is established and **data is being received**, but no regular automatic log entries are being created yet.  \n\nNow the one-time preparations are completed and you are ready to start your **first passage** and to keep your first logbook with LOGBOOK.  ',
            "final2_title": "Learn more about LOGBOOK",
            "final2": "Check out our other screencasts and learn more about the use of **LOGBOOK** in daily practice. (More screencasts coming soon.) "
        },
        "quickstartVoyage": {
            "startVoyage_title": "LOGBOOK QuickStart \u2013 Start Your First Passage",
            "startVoyage": "This quickstart will show you how to **record your first passage** with LOGBOOK. It is a shortend version of the **QuickStart Guide** in our documentation. For more detailed instructions and tips, please check out this.",
            "startPassage_title": "Start Passage",
            "startPassage": "Switch to the **focus view** with the **Focus button** at the top in the **Ship section** or with the **Focus button** in the timeline. The focus view is the view for editing during sailing. Entries in the day's **data sheet Day** and in **log entries** can only be made while in focus view.        ",
            "startPassage2_title": "Start Passage",
            "startPassage2": "When starting LOGBOOK for the first time, a **first voyage** and a **first passage** are already prepared so that you can start data recording as quickly as possible.   ",
            "startPassage3_title": "Start Passage",
            "startPassage3": "LOGBOOK automatically uses the system timezone of the **Primary Device** as the **ship timezone**. If you want to use a different timezone for the passage, you can set it in the **Ship settings**. For guidance, the associated **current ship time** is also displayed here in addition to the timezone. ",
            "startPassage4_title": "Start Passage",
            "startPassage4": "Enter a name for the passage and start the passage with the **Start Passage** button. ",
            "startPassage5_title": "Start Passage",
            "startPassage5": "In the **focus view**, the screen display focuses on the **current day** and the **log row**, the colored highlighted row directly below the last log entry. The log row displays the **values currently read from the NMEA**. ",
            "dayData_title": "Enter Data for the Day",
            "dayData": "Before setting off, you should enter some important data on the **day data sheet** on the **Day** card. These are the **start location**, the **skipper**, and the persons in the **crew** and **passengers**, if applicable. The persons must be entered on the current day because they are relevant to the evidence.  ",
            "dayData2_title": "Enter Data for the Day",
            "dayData2": "For **Skipper**, **Crew** and **Passengers** you can select persons from your list of all persons. With a new, empty logbook, the person list is still empty. However, persons can be easily **created during input** using the **Add Person** entry at the top of the selection list. ",
            "engine1_title": "Departing",
            "engine1": "Start your engines. If your NMEA contains **engine data**, LOGBOOK automatically detects when an engine is turned on or off and creates a log entry for this event. The status of the engine is displayed in the log entry with the engine buttons.  ",
            "engine2_title": "Departing",
            "engine2": "The second engine is now running.    ",
            "departing_title": "Departing",
            "departing": "LOGBOOK now **captures and analyzes NMEA data** every 30 seconds. As soon as the **ship starts moving**, LOGBOOK automatically creates the **first log entry** and the ship status displayed to the left of the timeline changes to **<span class=\"LogbookIcon-status-inmotion\"></span> In motion**. ",
            "departing2_title": "Departing",
            "departing2": 'After departure, the **NMEA menu button** is filled and green and the **Automatic logging** menu entry shows a green dot <span style="color: var(--green); font-size: 1.5em;">\u25CF</span>. This means that automatic log entries are now active. ',
            "logEntries2_title": "Automatic Data recording",
            "logEntries2": "During sailing, LOGBOOK creates a **log entry** **every full** or **half hour** (depending on the selected setting). LOGBOOK detects whether the ship is **moving or not** and **automatically creates an entry** both when departing and when stopping. ",
            "entry_30min_title": "Automatic Data recording",
            "entry_30min": "During sailing, LOGBOOK creates a **log entry** **every full** or **half hour** (depending on the selected setting).",
            "manualEntry_title": "Manual Log Entries",
            "manualEntry": "Regardless of the conditions selected in the **NMEA settings** dialog on the **Conditions** card for automatic log entries, a log entry can be triggered **manually** at any time with the **+ Log button** to the **left of the log row**. A click on the button creates a log entry with the **current NMEA data** and the **current ship status**. ",
            "manualEntry1a_title": "Manual Log Entries",
            "manualEntry1a": "For manual log entries with commonly used options, click the **arrow button** to open the menu.",
            "manualEntry1b_title": "Manual Log Entries",
            "manualEntry1b": "The menu shows various options for manual log entries. **Manual log entries** are useful, for example, when **sails** are set or taken down or when an **observation** is to be recorded.",
            "sail_entry1_title": "Manual Log Entries",
            "sail_entry1": "Select the **Mainsail** button to document setting the mainsail.",
            "sail_entry2_title": "Manual Log Entries \u2013 Sails",
            "sail_entry2": "After selecting **Mainsail**, the **Save sails** button appears. If needed you can select a foresail too. Click it to save the sails changes and create the log entry.",
            "sail_entry3_title": "Manual Log Entries",
            "sail_entry3": "**Mainsail** and **Genoa** had been set.  \n\nThe **comment text** in the header of the log entry is generated automatically based on the selected sails.",
            "selectSail2_title": "Manual Log Entries \u2013 Sails",
            "selectSail2": "Click **Save sails** to confirm the sail selection and create the log entry.",
            "selectSail3_title": "Manual Log Entries \u2013 Sails",
            "selectSail3": "The sail changes are being saved...",
            "selectSail4_title": "Manual Log Entries",
            "selectSail4": "The sail change has been recorded. The log entry shows which sails were set.",
            "logEntries3_title": "Automatic Data recording",
            "logEntries3": "If the NMEA data contains **engine data**, an entry is also created each time an **engine is turned on or off**. ",
            "logEntries4_title": "Additions to Log Entries",
            "logEntries4": "To supplement a log entry, click on the entry's row. The possible information is divided across **3 cards**. Fields with automatically captured data cannot be edited. Editable fields are easily recognized by the highlighting of the field area. Automatic log entries can be supplemented for **a maximum of 60 minutes** as long as there is no new automatic log entry.",
            "logEntries5_title": "Additions to Log Entries",
            "logEntries5": "In addition to the data automatically captured via NMEA, each log entry can also contain some information that is not included in the NMEA, for example, changes to the **sails**, and a **comment** as well as **weather observations**. All this you be must enter manually. ",
            "logEntries6_title": "Additions to Log Entries",
            "logEntries6": "On the **Environment** card you can document observations of **weather**, **sea state** and **currents**, **air temperature** and more. ",
            "logEntries7_title": "Automatic Log Entries",
            "logEntries7": "If activated in the **NMEA settings** dialog on the **Conditions** card, LOGBOOK will automatically create log entries for course changes. ",
            "manualEntry3_title": "Manual Log Entry for Engine Status",
            "manualEntry3": "If the NMEA does not contain **engine data**, a **manual log entry** should be created when an **engine is turned on or off**. Use the **engine buttons** in the menu of the **Log button** to change the status of the engine and create a **manual log entry**. The icon on the button shows the **current engine status** and is green when the engine is one.       ",
            "manualEntry4_title": "Manual Log Entry for Engine Status",
            "manualEntry4": "In the manual log entry, the **RPM** can then also be entered for each engine. ",
            "logEntries8_title": "Automatic Log Entries",
            "logEntries8": "Enjoy sailing while LOGBOOK **automatically** creates **log entries** for you. Whenever needed or desired, you can add **additional information** or make **manual log entries**.",
            "endDay_title": "End of Day",
            "endDay": "Whenever the ship has not been moving for a certain period of time, a **stop button** appears in the log row.            ",
            "endDay2_title": "End of Day",
            "endDay2": "The **stop button** opens a dialog in which you can record the stop as an intermediate stop or end sailing and thus the day. \n  ",
            "endDay3_title": "End of Day",
            "endDay3": "To end the day, select the **End of day** option. Then enter the name of your **current location**. Choose whether you are **anchoring**, in a **harbor**, etc.  ",
            "endDay4_title": "End of Day",
            "endDay4": "After closing the dialog, the symbol for the **selected ship status** is displayed in the log entry's row. LOGBOOK changes the **ship status** of the log entry that was automatically **created when stopping**. This gives you the opportunity to record details for this entry later.          ",
            "endDay5_title": "End of Day",
            "endDay5": "With the selection of **End of day**, the LOGBOOK day is ended. LOGBOOK **deactivates the automatic log entries** and you can now, if desired, turn off your NMEA network and close the LOGBOOK app. Then **turning off data recording** is documented in a **log entry** (without NMEA data).           ",
            "endDay6_title": "End of Day",
            "endDay6": "If **data recording is turned off**, NMEA menu button gets an orange border. The Automatic logging menu option is disabled. ",
            "endDay7_title": "End of Day",
            "endDay7": "If you keep the **NMEA connection alive** and you later or on next day start sailing again, LOGBOOK will **recognize** and document the **departure** again and automatically create log entries as before. With connection alive the NMEA button shows a green border but the Automatic logging menu item is disabled.   ",
            "nextDay_title": "The Next Day",
            "nextDay": "The new day is already prepared. On the **Day card**, everything is filled in as it was on the previous day, and the **Start location** is the destination of the previous day. If necessary, you can still make changes to the crew, etc.   ",
            "nextDay2_title": "The Next Day",
            "nextDay2": "On next day all is ready for starting. Whether you had closed and reopened the LOGBOOK app or it was open the whole time, if the **NMEA data source** is **turned on**, you can immediately continue with the **log entries** for the new day.   ",
            "nextDay3_title": "The Next Day",
            "nextDay3": "LOGBOOK **automatically reconnects** to the **NMEA** after closing the app and/or turning off the NMEA data source and regularly searches for NMEA data. As soon as the connection can be re-established, the **NMEA button shows green** again. \n\nIf the button's marker remains orange, you must activate the **NMEA connection toggle switch** from the **NMEA menu** again.   ",
            "nextDay4_title": "The Next Day",
            "nextDay4": "And as soon as the **ship starts moving** again, **automatic log entries** are started, and at the end of the sailing, the necessary steps to end the day and automatic log entries can be performed again in the **stop dialog**.   ",
            "final2_title": "Learn more about LOGBOOK",
            "final2": "Check out our other screencasts and learn more about the use of **LOGBOOK** in daily practice. (More screencasts coming soon.) "
        }
    },
    "ui": {
        "previous": "Previous",
        "next": "Next",
        "start_image": "/demo/Title-Concept.svg",
        "start_solo_image": "/demo/Start.svg",
        "quickstartChapter": "QuickStart - Preparations",
        "quickstartChapter2": "QuickStart - First Passsage"
    }
};


var $b08946e50be3ef07$exports = {};
$b08946e50be3ef07$exports = {
    "demo": {
        "concept": {
            "title": "LOGBOOK Konzept",
            "start1": "LOGBOOK Konzept",
            "start2": "Ein Logbuch ist ein chronologischer Bericht \xfcber die **Positionen eines Schiffes w\xe4hrend eines T\xf6rns** \u2013 die Bewegung des Schiffes und die Ereignisse an Bord in Raum und Zeit.",
            "timelineOverview": "In LOGBOOK wird die Schiffszeit in Form einer **Timeline** dargestellt.\nDie Timeline ist eine durchgehende **vertikale Timeline**, die **von oben nach unten** verl\xe4uft.",
            "timelineYears_title": "LOGBOOK Konzept: \xdcbersichtsmodus",
            "timelineYears": "Die Timeline beginnt im **ersten Jahr**, f\xfcr das ein Eintrag vorhanden ist, und reicht bis zum Ende des **aktuellen Jahres**. Alle **T\xf6rns** sind entlang dieser Timeline angeordnet.",
            "timelineYears2_title": "LOGBOOK Konzept: \xdcbersichtsmodus",
            "timelineYears2": "Anstatt verwirrenden Bl\xe4tterns zwischen Tageszeiten in analogen Logb\xfcchern gibt es im digitalen Logbuch intuitives **Scrollen** und **Zoomen**.",
            "timelineYears3_title": "LOGBOOK Konzept: \xdcbersichtsmodus",
            "timelineYears3": "Im **\xdcbersichtsmodus** zeigt die Timeline **Jahre** und **Monate** an. Jeder Monat wird durch eine kleine Linie gekennzeichnet.\nSobald f\xfcr ein Jahr Log-Eintr\xe4ge vorhanden sind, wird die Timeline f\xfcr dieses Jahr gestreckt.",
            "timelineYears4_title": "LOGBOOK Konzept: \xdcbersichtsmodus",
            "timelineYears4": "Rechts neben der Timeline erscheinen **T\xf6rns** mit Name und Zeitraum, und der betreffende **Zeitraum** ist farblich auf der Timeline markiert.",
            "timelineVoyageClick_title": "LOGBOOK Konzept: \xdcbersichtsmodus  ",
            "timelineVoyageClick": "Durch **Klicken auf einen T\xf6rn** wechselt LOGBOOK vom \xdcbersichtsmodus zur Darstellung der ausgew\xe4hlten T\xf6rns.",
            "timelineVoyage1_title": "LOGBOOK Konzept: T\xf6rn-Ansicht",
            "timelineVoyage1": "LOGBOOK zoomt in die Timeline und zeigt nur einen Ausschnitt der gesamten Timeline, der vom **ersten bis zum letzten Tag** des ausgew\xe4hlten **T\xf6rns** reicht.",
            "timelineVoyage2_title": "LOGBOOK Konzept: T\xf6rn-Ansicht",
            "timelineVoyage2": "Jeder **T\xf6rn** kann eine Reihe von **Etappen** enthalten, wobei jede Etappe eine Reihe von **Tagen** enthalten kann. Alle Tage sind chronologisch entlang der Timeline aufgelistet.",
            "timelineVoyage3_title": "LOGBOOK Konzept: T\xf6rn-Ansicht",
            "timelineVoyage3": "der Button links neben dem Namen des T\xf6rns zeigt das **Datenblatt des T\xf6rns** an und blendet es wieder aus.",
            "timelineVoyage4_title": "LOGBOOK Konzept: T\xf6rn-Ansicht",
            "timelineVoyage4": "Das Datenblatt enth\xe4lt mehrere Karten. Auf der Karte **T\xf6rn** kann dem T\xf6rn ein Name gegeben werden.",
            "timelineVoyage5_title": "LOGBOOK Konzept: T\xf6rn-Ansicht",
            "timelineVoyage5": "Die Karte **Statistik** bietet eine Zusammenfassung und Auswertung des T\xf6rns.",
            "timelineVoyage6_title": "LOGBOOK Konzept: T\xf6rn-Ansicht",
            "timelineVoyage6": "Die Karte **Track** zeigt den Track des gesamten T\xf6rns auf einer Seekarte. Auf der Karte **T\xf6rnplan** besteht die M\xf6glichkeit, den Verlauf des T\xf6rns im Voraus zu planen.",
            "timelineVoyage7_title": "LOGBOOK Konzept: T\xf6rn-Ansicht",
            "timelineVoyage7": "Die **Schaltfl\xe4che oben rechts** im T\xf6rn-Bereich f\xfchrt zur\xfcck zum \xdcbersichtsmodus.",
            "timelineVoyage8_title": "LOGBOOK Konzept: T\xf6rn-Ansicht",
            "timelineVoyage8": "Und die Schaltfl\xe4che links schlie\xdft die Datenansicht des T\xf6rns.",
            "timelineVoyage9_title": "LOGBOOK Konzept: T\xf6rn-Ansicht",
            "timelineVoyage9": "Direkt unterhalb des T\xf6rn-Bereichs beginnt die erste **Etappe** des T\xf6rns.",
            "timelinePassage1_title": "LOGBOOK Konzept: Die Etappe",
            "timelinePassage1": "Alle **Tage der Etappe** werden entlang der Timeline angezeigt. Der Zeitraum, in dem das Schiff am jeweiligen Tag unterwegs war, ist farblich auf der Timeline hervorgehoben.\n\nDie Linien unterteilen den Tag in 4-Stunden-Abschnitte.",
            "timelinePassage2_title": "LOGBOOK Konzept: Die Etappe",
            "timelinePassage2": "Ein Klick auf den Pfeil links neben dem Namen zeigt das **Datenblatt der Etappe** mit mehreren Karten mit Daten, Einstellungen und Anzeigen.\nHier ist die Karte **Statistik** mit einer Zusammenfassung und Auswertung der Etappe zu sehen.",
            "timelinePassage3_title": "LOGBOOK Konzept: Die Etappe",
            "timelinePassage3": "Ein Klick auf das **Datum eines Tages** \xf6ffnet den Tag.",
            "timelineDay1_title": "LOGBOOK Konzept: Der Tag",
            "timelineDay1": "Er erh\xe4lt einen **farblich hervorgehobenen Header** und alle w\xe4hrend des Tages aufgezeichneten **Log-Eintr\xe4ge** werden entlang der Timeline aufgelistet, die in diesem Bereich weiter gestreckt wird.",
            "timelineDay2_title": "LOGBOOK Konzept: Der Tag",
            "timelineDay2": "**Jede Stunde des Tages** ist durch eine **Linie** markiert, alle 4 Stunden etwas l\xe4nger, und f\xfcr 0:00 Uhr und 12:00 Uhr noch l\xe4nger. So l\xe4sst sich auf einen Blick erkennen, wie die **Log-Eintr\xe4ge** \xfcber den Tag verteilt sind.",
            "timelineDay3_title": "LOGBOOK Konzept: Der Tag",
            "timelineDay3": "Der Pfeil im farbigen Header blendet anstelle der Liste der **Log-Eintr\xe4ge** das **Datenblatt des Tages** mit verschiedenen Karten ein.",
            "timelineDay4_title": "LOGBOOK Konzept: Der Tag",
            "timelineDay4": "Die Karte **Tag** erm\xf6glicht die Eingabe von Informationen zum Tag, wie z.B. Crewmitglieder, Abfahrts- und Ankunftszeiten und mehr.",
            "timelineDay5_title": "LOGBOOK Konzept: Der Tag",
            "timelineDay5": "Einige Karten wie **Statistik**, **Track** und **Wetter** zeigen Auswertungen \u2026",
            "timelineDay6_title": "LOGBOOK Konzept: Der Tag",
            "timelineDay6": "\u2026 andere wie **Journal** und **Technik** erm\xf6glichen die Eingabe von individuellem Text und Fotos.",
            "timelineDay7_title": "LOGBOOK Konzept: Der Tag",
            "timelineDay7": "Schlie\xdfen des Datenblatts des Tages mit der Umschaltfl\xe4che oben rechts im Datenblatt \u2026,",
            "timelineLog1_title": "LOGBOOK Konzept: Der Log-Eintrag",
            "timelineLog1": "\u2026 f\xfchrt zur Liste aller **Log-Eintr\xe4ge** des Tages zur\xfcck, der kleinsten Einheit in LOGBOOK.",
            "timelineLog2_title": "LOGBOOK Konzept: Der Log-Eintrag",
            "timelineLog2": "Der **Log-Eintrag** enth\xe4lt NMEA-Daten und zus\xe4tzliche Informationen zu einem bestimmten Zeitpunkt.",
            "timelineLog3_title": "LOGBOOK Konzept: Der Log-Eintrag",
            "timelineLog3": "Ein Klick auf einen **Log-Eintrag** zeigt das **Datenblatt des Log-Eintrags** an.",
            "timelineLog4_title": "LOGBOOK Konzept: Der Log-Eintrag",
            "timelineLog4": "Der ausgew\xe4hlte **Log-Eintrag** zeigt einen **farblich hervorgehobenen Header**. Im **Datenblatt des Log-Eintrags** werden die **automatisch erfassten Daten** angezeigt und beim aktuellen Log-Eintrag k\xf6nnen weitere Daten eingegeben werden.",
            "timelineLog5_title": "LOGBOOK Konzept: Der Log-Eintrag",
            "timelineLog5": "Welche Felder nicht bearbeitbare, automatisch eingetragene Daten enthalten und welche Felder **manuelle Dateneingabe** erlauben, h\xe4ngt von den **im NMEA vorhandenen Daten** ab.",
            "final1_title": "LOGBOOK \u2013 Dein Begleiter auf See",
            "final1": "**LOGBOOK** ist dein treuer Begleiter auf jedem T\xf6rn \u2013 immer an deiner Seite, vom ersten Log-Eintrag bis zum letzten.\n\n**LOGBOOK** begleitet dich durch jede Etappe, jeden Tag auf See, und h\xe4lt die Geschichte deines Schiffes lebendig.",
            "final2_title": "Erfahre mehr \xfcber **LOGBOOK**",
            "final2": "Schaue dir unsere weiteren Screencasts an und erfahre mehr \xfcber den Einsatz von **LOGBOOK** in der t\xe4glichen Praxis. (Weitere Screencasts sind in K\xfcrze verf\xfcgbar.)"
        },
        "quickstart": {
            "title": "LOGBOOK QuickStart \u2013 Einmalige Vorbereitungen ",
            "start": "Dieser QuickStart hilft dir, **in wenigen Schritten mit LOGBOOK zu starten**. Es ist eine gek\xfcrzte Version des **QuickStart-Leitfadens** in unserer Dokumentation. F\xfcr detailliertere Anleitungen und Tipps schau dir diese bitte an.",
            "start1_title": "Login  ",
            "start1": "**Melde dich** in deinem Account in der **LOGBOOK Cloud** an unter \n\n**https://logbook.yachts/app**.",
            "start2_title": "Login",
            "start2": "Du bist jetzt in deinen pers\xf6nlichen **Account-Einstellungen**. ",
            "start3_title": "Ersteinrichtung (einmalig)",
            "start3": "Bevor du dein erstes Logbuch mit LOGBOOK f\xfchren kannst, sind zwei Schritte erforderlich (einmalig): \n\n1 -  **Ein Schiff erstellen**.\n\n2 -  **Die Verbindung zum NMEA des Schiffes** oder zum integrierten GPS des Devices herstellen und analysieren.",
            "createShip_title": "Schiff erstellen",
            "createShip": "Zuerst ben\xf6tigt LOGBOOK einige Informationen \xfcber dein **Schiff**, die die Grundkonfiguration des Logbuches beeinflussen. Daher wird beim ersten Start von LOGBOOK die Ansicht **Neues Schiff erstellen** angezeigt.\n\nGib hier den **Schiffsnamen** ein, w\xe4hle den **Schiffstyp** (Segelboot/Motorboot) und lege die **Anzahl der Motoren** fest.",
            "createShip2_title": "Schiff erstellen",
            "createShip2": "Schlie\xdfe dann die Ansicht mit der Schaltfl\xe4che **Schiff erstellen**. Das Schlie\xdfen ist nur m\xf6glich, wenn alle drei Felder ausgef\xfcllt sind.",
            "createShip3_title": "Schiff erstellen",
            "createShip3": "Verwende den Link unten im Text, um zur **LOGBOOK-App** zu wechseln.",
            "createShip4_title": "Schiff erstellen",
            "createShip4": "In der LOGBOOK-App siehst du nun die **\xdcbersichts-Timeline** f\xfcr dein Schiff. \n\nIm **Schiffbereich** werden der Schiffstyp und der Schiffsname sowie einige Schaltfl\xe4chen angezeigt. Alle zus\xe4tzlichen Informationen \xfcber das Schiff k\xf6nnen jederzeit sp\xe4ter in der Ansicht **Schiffsdaten** eingegeben werden.\n\nIn dieser Demo wurden MMSI und Rufzeichen bereits eingegeben.",
            "connectNMEA_title": "NMEA-Verbindung einrichten",
            "connectNMEA": "Schalte zun\xe4chst dein **NMEA-Netzwerk** oder GPS ein und **verbinde dein Device** mit dem NMEA-Netzwerk/GPS. ",
            "connectNMEA2_title": "NMEA-Verbindung einrichten",
            "connectNMEA2": "Das Device, das mit dem NMEA verbunden ist, wird als **Primary Device** mit dem **Primary LOGBOOK** bezeichnet. Das Primary LOGBOOK ist das Hauptlogbuch, das die NMEA-Daten empf\xe4ngt und Log-Eintr\xe4ge erstellt. ",
            "connectNMEA3_title": "NMEA-Verbindung einrichten",
            "connectNMEA3": 'W\xe4hle nun **Einstellungen** aus dem Men\xfc der **NMEA**-Schaltfl\xe4che (rechts im Schiffbereich). Wenn noch keine Verbindung eingerichtet wurde, zeigt die Schaltfl\xe4che einen roten Marker <span style="color: var(--red); font-size: 1.5em;">\u25A1</span>.   ',
            "connectNMEA4_title": "NMEA-Verbindung einrichten",
            "connectNMEA4": "Gehe auf der ersten Karte des Dialogs zu **NMEA-Verbindungstyp** und w\xe4hle aus, welches Protokoll oder welcher Verbindungstyp das NMEA-Netzwerk mit deinem Device verbindet (**USB** oder WiFi/Ethernet mit **TCP**). \n\nWenn du w\xe4hlen kannst, wie du dein NMEA mit deinem Device verbindest: TCP ist besser als USB.  ",
            "connectNMEA5_title": "NMEA-Verbindung einrichten",
            "connectNMEA5": "Nimm dann die Einstellungen in den zus\xe4tzlichen Feldern vor, die f\xfcr den Verbindungstyp angezeigt werden (Adresse, Port usw.). Die erforderlichen Daten findest du in der Dokumentation des Gateways, Multiplexers oder Plotters. F\xfcr **USB** werden die verf\xfcgbaren Ger\xe4te unter **Ger\xe4te** aufgelistet.\n\nWenn dein Device ein **integriertes GPS** hat, gibt es eine zus\xe4tzliche Option.",
            "connectNMEA6_title": "Verbindung testen",
            "connectNMEA6": "Verwende die Schaltfl\xe4che **Verbindung testen**, um zur n\xe4chsten Karte des Dialogs zu wechseln und den Test der Verbindung zu starten. ",
            "connectNMEA7_title": "Verbindung testen",
            "connectNMEA7": "LOGBOOK startet den **Datenabruf** \xfcber die auf der ersten Karte des Dialogs eingestellte Verbindung. Es kann einen Moment dauern, bis die **ersten Daten empfangen** werden. ",
            "connectNMEA8_title": "Verbindung testen",
            "connectNMEA8": "Wenn mindestens **UTC** und **GPS-Position** einen gr\xfcnen Punkt auf der Karte **Test und Daten** zeigen, kannst du den Dialog mit **Abschlie\xdfen** schlie\xdfen.  ",
            "connectNMEA9_title": "Verbindung testen",
            "connectNMEA9": 'Der gr\xfcne, nicht ausgef\xfcllte Marker <span style="color: var(--green); font-size: 1.5em;">\u25A1</span> im **NMEA Button** sowie der orange Punkt  <span style="color: var(--orange); font-size: 1.5em; vertical-align: bottom;">\u25CF</span> beim Men\xfceintrag **Automatisches Loggen** zeigen, dass die Verbindung zum NMEA-Netzwerk hergestellt ist und **Daten empfangen werden**, aber noch keine regelm\xe4\xdfigen automatischen Log-Eintr\xe4ge erstellt werden.  \n\nNun sind die einmaligen Vorbereitungen abgeschlossen und du bist bereit, deine **erste Fahrt** zu starten und dein erstes Logbuch mit LOGBOOK zu f\xfchren.  ',
            "final2_title": "Erfahre mehr \xfcber **LOGBOOK**",
            "final2": "Schaue dir unsere weiteren Screencasts an und erfahre mehr \xfcber den Einsatz von **LOGBOOK** in der t\xe4glichen Praxis. (Weitere Screencasts sind in K\xfcrze verf\xfcgbar.)"
        },
        "quickstartVoyage": {
            "startVoyage_title": "LOGBOOK QuickStart \u2013 Starte deine erste Fahrt",
            "startVoyage": "Dieser QuickStart zeigt dir, wie du deine **erste Fahrt** mit LOGBOOK aufzeichnest. Es ist eine gek\xfcrzte Version des **QuickStart-Leitfadens** in unserer Dokumentation. F\xfcr detailliertere Anleitungen und Tipps schau dir diese bitte an.",
            "startPassage_title": "Fahrt starten",
            "startPassage": "Wechsle mit dem **Fokus-Button** oben im **Schiffbereich** oder mit dem **Fokus-Button** in der Timeline zur **Fokusansicht**. Die Fokusansicht ist die Ansicht f\xfcr die Bearbeitung w\xe4hrend der Fahrt. Eintr\xe4ge im Datenblatt **Tag** und in den **Log-Eintr\xe4gen** k\xf6nnen nur in der Fokusansicht vorgenommen werden.        ",
            "startPassage2_title": "Fahrt starten",
            "startPassage2": "Beim ersten Start von LOGBOOK sind bereits eine **erster T\xf6rn** und eine **erste Etappe** vorbereitet, damit du so schnell wie m\xf6glich mit der Datenaufzeichnung beginnen kannst.   ",
            "startPassage3_title": "Fahrt starten",
            "startPassage3": "LOGBOOK verwendet f\xfcr die Zeitzone der **Bordzeit** automatisch die Systemzeitzone des **Primary Device**. Wenn du f\xfcr die Fahrt eine andere Zeitzone verwenden m\xf6chtest, kannst du diese in den **Schiffseinstellungen** festlegen. Zur Orientierung wird hier zus\xe4tzlich zur Zeitzone auch die zugeh\xf6rige **aktuelle Schiffszeit** angezeigt. ",
            "startPassage4_title": "Fahrt starten",
            "startPassage4": "Gib einen Namen f\xfcr die Etappe ein und starte die Etappe mit der Schaltfl\xe4che **Etappe starten**. ",
            "startPassage5_title": "Fahrt starten",
            "startPassage5": "In der **Fokusansicht** konzentriert sich die Bildschirmanzeige auf den **aktuellen Tag** und die **Log-Zeile**, die farbig hervorgehobene Zeile direkt unter dem letzten Log-Eintrag. Die Log-Zeile zeigt die **aktuell aus dem NMEA gelesenen Werte** an. ",
            "dayData_title": "Daten f\xfcr den Tag eingeben",
            "dayData": "Vor dem Ablegen solltest du einige wichtige Daten auf dem **Datenblatt Tag** auf der Karte **Tag** eingeben. Dies sind der **Startort**, der **Skipper** und die Personen in der **Crew** und die **Passagiere**, falls zutreffend. Die Personen m\xfcssen am aktuellen Tag eingetragen werden, da sie f\xfcr die Nachweisf\xfchrung relevant sind.  ",
            "dayData2_title": "Daten f\xfcr den Tag eingeben",
            "dayData2": "F\xfcr **Skipper**, **Crew** und **Passagiere** kannst du Personen aus deiner Liste aller Personen ausw\xe4hlen. Bei einem neuen, leeren Logbuch ist die Personenliste noch leer. Personen k\xf6nnen jedoch w\xe4hrend der Eingabe einfach **erstellt werden**, indem der Eintrag **Person hinzuf\xfcgen** oben in der Auswahlliste verwendet wird. ",
            "engine1_title": "Ablegen",
            "engine1": "Starte deine Motoren. Wenn dein NMEA **Motordaten** enth\xe4lt, erkennt LOGBOOK automatisch, wann ein Motor ein- oder ausgeschaltet wird, und erstellt einen Log-Eintrag f\xfcr dieses Ereignis. Der Status des Motors wird im Log-Eintrag mit den Motor-Schaltfl\xe4chen angezeigt.  ",
            "engine2_title": "Ablegen",
            "engine2": "Der zweite Motor l\xe4uft nun.    ",
            "departing_title": "Ablegen",
            "departing": 'LOGBOOK **erfasst und analysiert nun alle 30 Sekunden NMEA-Daten**. Sobald sich das **Schiff in Bewegung setzt**, erstellt LOGBOOK automatisch den **ersten Log-Eintrag** und der links von der Timeline angezeigte Schiffsstatus \xe4ndert sich auf **<span class="LogbookIcon-status-inmotion"></span> In Fahrt**. ',
            "departing2_title": "Ablegen",
            "departing2": 'Nach dem Ablegen ist der **NMEA-Button** gr\xfcner gef\xfcllt und der Men\xfceintrag **Automatisches Loggen** zeigt einen gr\xfcnen Punkt <span style="color: var(--green); font-size: 1.5em;">\u25CF</span>. Das bedeutet, dass die automatischen Log-Eintr\xe4ge jetzt aktiv sind. ',
            "logEntries2_title": "Automatisches Loggen",
            "logEntries2": "W\xe4hrend der Fahrt erstellt LOGBOOK **jede volle** oder **halbe Stunde** einen **Log-Eintrag** (je nach ausgew\xe4hlter Einstellung). LOGBOOK erkennt, ob sich das Schiff **bewegt oder nicht** und **erstellt automatisch einen Eintrag** sowohl beim Ablegen als auch beim Stoppen. ",
            "entry_30min_title": "Automatisches Loggen",
            "entry_30min": "W\xe4hrend der Fahrt erstellt LOGBOOK **jede volle** oder **halbe Stunde** einen **Log-Eintrag** (je nach ausgew\xe4hlter Einstellung).",
            "manualEntry_title": "Manuelle Log-Eintr\xe4ge",
            "manualEntry": "Unabh\xe4ngig von den im Dialog **NMEA-Einstellungen** auf der Karte **Bedingungen** ausgew\xe4hlten Bedingungen f\xfcr automatische Log-Eintr\xe4ge kann jederzeit mit dem **+ Log-Button** **links von der Log-Zeile** ein Log-Eintrag **manuell** ausgel\xf6st werden. Ein Klick auf den Button erstellt einen Log-Eintrag mit den **aktuellen NMEA-Daten** und dem **aktuellen Schiffsstatus**.",
            "manualEntry1a_title": "Manuelle Log-Eintr\xe4ge",
            "manualEntry1a": "F\xfcr manuelle Log-Eintr\xe4ge mit h\xe4ufig verwendeten Optionen klicken Sie auf den **Pfeil-Button**, um das Men\xfc zu \xf6ffnen.",
            "manualEntry1b_title": "Manuelle Log-Eintr\xe4ge",
            "manualEntry1b": "Das Men\xfc zeigt verschiedene Optionen f\xfcr manuelle Log-Eintr\xe4ge. **Manuelle Log-Eintr\xe4ge** sind beispielsweise n\xfctzlich, wenn **Segel** gesetzt oder geborgen werden oder wenn eine **Beobachtung** notiert werden soll.",
            "sail_entry1_title": "Manuelle Log-Eintr\xe4ge",
            "sail_entry1": "W\xe4hlen Sie den **Gro\xdfsegel**-Button, um das Setzen des Gro\xdfsegels zu dokumentieren.",
            "sail_entry2_title": "Manuelle Log-Eintr\xe4ge \u2013 Segel",
            "sail_entry2": "Nach der Auswahl von **Gro\xdfsegel** erscheint der Button **Segel speichern**. Klicken Sie darauf, um die Segel\xe4nderung zu speichern und den Log-Eintrag zu erstellen.",
            "sail_entry3_title": "Manuelle Log-Eintr\xe4ge",
            "sail_entry3": "**Gro\xdfsegel** und **Genua** wurden gesetzt.  \n\nDer **Kommentartext** in der Kopfzeile des Log-Eintrags wird automatisch basierend auf den ausgew\xe4hlten Segeln generiert.",
            "selectSail2_title": "Manuelle Log-Eintr\xe4ge \u2013 Segel",
            "selectSail2": "Klicken Sie auf **Segel speichern**, um die Segelauswahl zu best\xe4tigen und den Log-Eintrag zu erstellen.",
            "selectSail3_title": "Manuelle Log-Eintr\xe4ge \u2013 Segel",
            "selectSail3": "Die Segel\xe4nderungen werden gespeichert...",
            "selectSail4_title": "Manuelle Log-Eintr\xe4ge",
            "selectSail4": "Die Segel\xe4nderung wurde aufgezeichnet. Der Log-Eintrag zeigt, welche Segel gesetzt wurden.",
            "logEntries3_title": "Automatisches Loggen",
            "logEntries3": "Wenn die NMEA-Daten **Motordaten** enthalten, wird auch jedes Mal ein Eintrag erstellt, wenn ein **Motor ein- oder ausgeschaltet** wird. ",
            "logEntries4_title": "Erg\xe4nzungen in den Log-Eintr\xe4gen",
            "logEntries4": "Um einen Log-Eintrag zu erg\xe4nzen, klicke auf die Zeile des Eintrags. Die m\xf6glichen Informationen sind auf **3 Karten** verteilt. Felder mit automatisch erfassten Daten k\xf6nnen nicht bearbeitet werden. Bearbeitbare Felder sind leicht an der Hervorhebung des Feldbereichs zu erkennen. Automatische Log-Eintr\xe4ge k\xf6nnen **maximal 60 Minuten lang** erg\xe4nzt werden, solange es keinen neuen automatischen Log-Eintrag gibt.",
            "logEntries5_title": "Erg\xe4nzungen in den Log-Eintr\xe4gen",
            "logEntries5": "Zus\xe4tzlich zu den automatisch \xfcber NMEA erfassten Daten kann jeder Log-Eintrag auch einige Informationen enthalten, die nicht im NMEA enthalten sind, zum Beispiel \xc4nderungen an den **Segeln** und ein **Kommentar** sowie **Wetterbeobachtungen**. All dies musst du manuell eingeben. ",
            "logEntries6_title": "Erg\xe4nzungen in den Log-Eintr\xe4gen",
            "logEntries6": "Auf der Karte **Umgebung** kannst du Beobachtungen zu **Wetter**, **Seegang** und **Str\xf6mungen**, **Lufttemperatur** und mehr dokumentieren. ",
            "logEntries7_title": "Automatisches Loggen",
            "logEntries7": "Wenn im Dialog **NMEA-Einstellungen** auf der Karte **Bedingungen** aktiviert, erstellt LOGBOOK automatisch Log-Eintr\xe4ge f\xfcr Kurs\xe4nderungen. ",
            "manualEntry3_title": "Manueller Log-Eintrag f\xfcr Motorstatus",
            "manualEntry3": "Wenn das NMEA keine **Motordaten** enth\xe4lt, sollte immer ein **manueller Log-Eintrag** erstellt werden, wenn ein **Motor ein- oder ausgeschaltet** wird. Verwende die **Motor-Schaltfl\xe4chen** in der Log-Zeile, um den Status des Motors zu \xe4ndern und einen **manuellen Log-Eintrag** zu erstellen. Das Symbol auf der Schaltfl\xe4che zeigt den **aktuellen Motorstatus** an.       ",
            "manualEntry4_title": "Manueller Log-Eintrag f\xfcr Motorstatus",
            "manualEntry4": "Im manuellen Log-Eintrag k\xf6nnen dann auch die **Drehzahlen** f\xfcr jeden Motor eingegeben werden. ",
            "logEntries8_title": "Automatisches Loggen",
            "logEntries8": "Genie\xdfe das Segeln, w\xe4hrend LOGBOOK **automatisch Log-Eintr\xe4ge** f\xfcr dich erstellt. Wann immer erforderlich oder gew\xfcnscht, kannst du **zus\xe4tzliche Informationen** hinzuf\xfcgen oder **manuelle Log-Eintr\xe4ge** erstellen.",
            "endDay_title": "Tagesende",
            "endDay": "Immer wenn sich das Schiff f\xfcr eine bestimmte Zeit nicht bewegt hat, erscheint in der Log-Zeile der **Stopp-Button**.            ",
            "endDay2_title": "Tagesende",
            "endDay2": "Der **Stopp-Button** \xf6ffnet einen Dialog, in dem du den Stopp als Zwischenstopp aufzeichnen oder die Fahrt und damit den Tag beenden kannst. \n  ",
            "endDay3_title": "Tagesende",
            "endDay3": "Um den Tag zu beenden, w\xe4hle die Option **Tagesende**. Gib dann den Namen deines **aktuellen Standorts** ein. W\xe4hle aus, ob du am **Ankerplatz** liegst, im **Hafen** bist usw.  ",
            "endDay4_title": "Tagesende",
            "endDay4": "Nach dem Schlie\xdfen des Dialogs wird das Symbol f\xfcr den **ausgew\xe4hlten Schiffsstatus** in der Zeile des Log-Eintrags angezeigt. LOGBOOK \xe4ndert den **Schiffsstatus** des Log-Eintrags, der automatisch **beim Stoppen erstellt** wurde. Dies gibt dir die M\xf6glichkeit, Details f\xfcr diesen Eintrag sp\xe4ter zu erfassen.          ",
            "endDay5_title": "Tagesende",
            "endDay5": "Mit der Auswahl von **Tagesende** wird der LOGBOOK-Tag beendet. LOGBOOK **deaktiviert die automatischen Log-Eintr\xe4ge** und du kannst jetzt, wenn gew\xfcnscht, dein NMEA-Netzwerk ausschalten und die LOGBOOK-App schlie\xdfen. Dann wird das **Ausschalten der Datenaufzeichnung** in einem **Log-Eintrag** dokumentiert (ohne NMEA-Daten).           ",
            "endDay6_title": "Tagesende",
            "endDay6": 'Wenn die **Datenaufzeichnung ausgeschaltet ist**, zeigen der Men\xfcpunkt **NMEA-Verbindung** und auch der NMEA-Button einen orange Marker <span style="color: var(--orange); font-size: 1.5em;">\u25CF</span>, der Marker auf dem Men\xfc-Button ist orange und nicht ausgef\xfcllt <span style="color: var(--orange); font-size: 1.5em;">\u25A1</span>. Die Option Automatisches Loggen ist deaktiviert. ',
            "endDay7_title": "Tagesende",
            "endDay7": "Wenn du die **NMEA-Verbindung aktiv** h\xe4ltst und sp\xe4ter oder am n\xe4chsten Tag wieder losf\xe4hrst, wird LOGBOOK das **Ablegen erkennen** und dokumentieren und automatisch wieder Log-Eintr\xe4ge erstellen wie zuvor.   ",
            "nextDay_title": "Der n\xe4chste Tag",
            "nextDay": "Der neue Tag ist bereits vorbereitet. Auf der Karte **Tag** ist alles so ausgef\xfcllt wie am Vortag, und der **Startort** ist das Ziel des Vortags. Bei Bedarf kannst du noch \xc4nderungen an der Crew usw. vornehmen.   ",
            "nextDay2_title": "Der n\xe4chste Tag",
            "nextDay2": "Am n\xe4chsten Tag ist alles zum Starten bereit. Egal, ob du die LOGBOOK-App geschlossen und wieder ge\xf6ffnet hast oder sie die ganze Zeit ge\xf6ffnet war, wenn die **NMEA-Datenquelle** **eingeschaltet** ist, kannst du sofort mit den **Log-Eintr\xe4gen** f\xfcr den neuen Tag fortfahren.   ",
            "nextDay3_title": "Der n\xe4chste Tag",
            "nextDay3": "LOGBOOK **verbindet sich automatisch wieder** mit dem **NMEA** nach dem Schlie\xdfen der App und/oder dem Ausschalten der NMEA-Datenquelle und sucht regelm\xe4\xdfig nach NMEA-Daten. Sobald die Verbindung wiederhergestellt werden kann, **zeigt der NMEA-Button wieder gr\xfcn** an. \n\nWenn der Marker der Schaltfl\xe4che orange bleibt, musst du den **NMEA-Verbindungsschalter** aus dem **NMEA-Men\xfc** erneut aktivieren.   ",
            "nextDay4_title": "Der n\xe4chste Tag",
            "nextDay4": "Und sobald sich das **Schiff wieder in Bewegung setzt**, werden **automatische Log-Eintr\xe4ge** gestartet, und am Ende der Fahrt k\xf6nnen die erforderlichen Schritte zum Beenden des Tages und der automatischen Log-Eintr\xe4ge erneut im **Stopp-Dialog** durchgef\xfchrt werden.   ",
            "final2_title": "Erfahre mehr \xfcber LOGBOOK",
            "final2": "Schaue dir unsere weiteren Screencasts an und erfahre mehr \xfcber den Einsatz von **LOGBOOK** in der t\xe4glichen Praxis. (Weitere Screencasts sind in K\xfcrze verf\xfcgbar.) "
        }
    },
    "ui": {
        "previous": "Zur\xfcck",
        "next": "Weiter",
        "start_image": "/demo/Title-Concept-de.svg",
        "start_solo_image": "/demo/Start.svg",
        "quickstartChapter": "QuickStart \u2013 Vorbereitungen",
        "quickstartChapter2": "QuickStart \u2013 Erste Fahrt  "
    }
};


const $c7447bc87504efd0$var$enDemos = (0, (/*@__PURE__*/$parcel$interopDefault($e2082abdfcafc000$exports)));
const $c7447bc87504efd0$var$deDemos = (0, (/*@__PURE__*/$parcel$interopDefault($b08946e50be3ef07$exports)));
const $c7447bc87504efd0$export$5c05d8d94c8024d2 = {
    en: $c7447bc87504efd0$var$enDemos,
    de: $c7447bc87504efd0$var$deDemos
};
function $c7447bc87504efd0$export$4c288ea8cff73213({ className: className, html: html, message: message, replace: replace }) {
    const app = (0, $6f69f4dcc7c84750$export$56752c5ff04def75)();
    const text = (0, $acw62.useMemo)(()=>{
        var _a;
        const messages = (_a = $c7447bc87504efd0$export$5c05d8d94c8024d2[app.language]) !== null && _a !== void 0 ? _a : $c7447bc87504efd0$var$enDemos;
        const md = (0, $0d15360f132ce1e2$export$2e2bcd8739ae039)({
            html: html || false
        });
        const text = (0, $0258f51bf6f9f9d6$export$716a56fcc9fe5dff)(message(messages) || "", replace);
        return md.render(text);
    }, [
        message,
        app.language
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "LocalizedMessage",
            className
        ]),
        dangerouslySetInnerHTML: {
            __html: text
        }
    });
}




var $acw62 = parcelRequire("acw62");



function $667899fc5cd22b1e$export$d96a8827a60d6b69({ children: children, className: className, onClick: onClick, style: style }) {
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "block",
            className
        ]),
        onClick: onClick,
        style: style,
        children: children
    });
}
function $667899fc5cd22b1e$export$a4fff7f2f85c4c81({ children: children, className: className, onClick: onClick, style: style }) {
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "block-container",
            className
        ]),
        onClick: onClick,
        style: style,
        children: children
    });
}
function $667899fc5cd22b1e$export$e49d898ce5e9f43c({ blank: blank, children: children, className: className, label: label, labelAfter: labelAfter, labelFor: labelFor, onClick: onClick, style: style }) {
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "block-field",
            blank && "blank",
            className
        ]),
        onClick: onClick,
        style: style,
        children: [
            label != undefined && !labelAfter && (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: labelFor,
                children: label
            }),
            children,
            label != undefined && labelAfter && (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: labelFor,
                children: label
            })
        ]
    });
}
function $667899fc5cd22b1e$export$cdb648f0ec854d27({ children: children, className: className, style: style }) {
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "block-field-inputs",
            className
        ]),
        style: style,
        children: children
    });
}
function $667899fc5cd22b1e$export$102e37fb1731abbd({ className: className, divider: divider, style: style }) {
    return (0, $7b02d682eb115277$exports.jsx)("span", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "block-field-inputs-divider",
            className
        ]),
        style: style,
        children: divider || "|"
    });
}
function $667899fc5cd22b1e$export$87a9101957b76b24({ actions: actions, children: children, className: className, style: style }) {
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "block-row",
            className,
            actions && "block-row-actions"
        ]),
        style: style,
        children: children
    });
}




var $acw62 = parcelRequire("acw62");




var $8efd2cc0c4df4afb$export$57136dcf80d0dc11;
(function(LogbookIcons) {
    LogbookIcons["Wifi"] = "wifi";
    LogbookIcons["Weather9"] = "weather-9";
    LogbookIcons["Weather8"] = "weather-8";
    LogbookIcons["Weather7"] = "weather-7";
    LogbookIcons["Weather6"] = "weather-6";
    LogbookIcons["Weather5"] = "weather-5";
    LogbookIcons["Weather4"] = "weather-4";
    LogbookIcons["Weather3"] = "weather-3";
    LogbookIcons["Weather2"] = "weather-2";
    LogbookIcons["Weather16"] = "weather-16";
    LogbookIcons["Weather15"] = "weather-15";
    LogbookIcons["Weather14"] = "weather-14";
    LogbookIcons["Weather13"] = "weather-13";
    LogbookIcons["Weather12"] = "weather-12";
    LogbookIcons["Weather11"] = "weather-11";
    LogbookIcons["Weather10"] = "weather-10";
    LogbookIcons["Weather1"] = "weather-1";
    LogbookIcons["Watch"] = "watch";
    LogbookIcons["User"] = "user";
    LogbookIcons["Usb"] = "usb";
    LogbookIcons["Trip"] = "trip";
    LogbookIcons["Trash"] = "trash";
    LogbookIcons["Track"] = "track";
    LogbookIcons["Toggle"] = "toggle";
    LogbookIcons["ToggleOn"] = "toggle-on";
    LogbookIcons["StatusWaiting"] = "status-waiting";
    LogbookIcons["StatusPort"] = "status-port";
    LogbookIcons["StatusOnboard"] = "status-onboard";
    LogbookIcons["StatusOffboard"] = "status-offboard";
    LogbookIcons["StatusLock"] = "status-lock";
    LogbookIcons["StatusInmotion"] = "status-inmotion";
    LogbookIcons["StatusDrifting"] = "status-drifting";
    LogbookIcons["StatusBuoy"] = "status-buoy";
    LogbookIcons["StatusBunkering"] = "status-bunkering";
    LogbookIcons["StatusBridge"] = "status-bridge";
    LogbookIcons["StatusAnchor"] = "status-anchor";
    LogbookIcons["Stats"] = "stats";
    LogbookIcons["Sounding"] = "sounding";
    LogbookIcons["Settings"] = "settings";
    LogbookIcons["Search"] = "search";
    LogbookIcons["SailsUp"] = "sails-up";
    LogbookIcons["SailsDown"] = "sails-down";
    LogbookIcons["SailsChange"] = "sails-change";
    LogbookIcons["SailingVessel"] = "sailing-vessel";
    LogbookIcons["SailingVesselLarge"] = "sailing-vessel-large";
    LogbookIcons["Refresh"] = "refresh";
    LogbookIcons["Print"] = "print";
    LogbookIcons["Plus"] = "plus";
    LogbookIcons["On2"] = "on2";
    LogbookIcons["On1"] = "on1";
    LogbookIcons["On"] = "on";
    LogbookIcons["Off2"] = "off2";
    LogbookIcons["Off1"] = "off1";
    LogbookIcons["Off"] = "off";
    LogbookIcons["Note"] = "note";
    LogbookIcons["NoteWeatherReport"] = "note-weather-report";
    LogbookIcons["NoteWeatherForecast"] = "note-weather-forecast";
    LogbookIcons["NoteTechnical"] = "note-technical";
    LogbookIcons["NoteJournal"] = "note-journal";
    LogbookIcons["NoteCruisePlan"] = "note-cruise-plan";
    LogbookIcons["NoCloud"] = "no-cloud";
    LogbookIcons["Navigation"] = "navigation";
    LogbookIcons["NavigationLevel3"] = "navigation-level-3";
    LogbookIcons["NavigationLevel2"] = "navigation-level-2";
    LogbookIcons["NavigationLevel1"] = "navigation-level-1";
    LogbookIcons["NavigationLevel0"] = "navigation-level-0";
    LogbookIcons["MotorVessel"] = "motor-vessel";
    LogbookIcons["MoonWaxing"] = "moon-waxing";
    LogbookIcons["MoonWaning"] = "moon-waning";
    LogbookIcons["MoonNew"] = "moon-new";
    LogbookIcons["MoonFull"] = "moon-full";
    LogbookIcons["Lights"] = "lights";
    LogbookIcons["LightingTricolor"] = "lighting-tricolor";
    LogbookIcons["LightingSailingRunning"] = "lighting-sailing-running";
    LogbookIcons["LightingNone"] = "lighting-none";
    LogbookIcons["LightingMotoringRunning"] = "lighting-motoring-running";
    LogbookIcons["LightingMotoringCone"] = "lighting-motoring-cone";
    LogbookIcons["LightingAnchorLight"] = "lighting-anchor-light";
    LogbookIcons["LightingAnchorBall"] = "lighting-anchor-ball";
    LogbookIcons["Graph"] = "graph";
    LogbookIcons["Gps"] = "gps";
    LogbookIcons["GpsUnfilled"] = "gps-unfilled";
    LogbookIcons["GenWater"] = "gen-water";
    LogbookIcons["GenPower"] = "gen-power";
    LogbookIcons["GenHeater"] = "gen-heater";
    LogbookIcons["GenAc"] = "gen-ac";
    LogbookIcons["EyeOn"] = "eye-on";
    LogbookIcons["EyeOff"] = "eye-off";
    LogbookIcons["Environment"] = "environment";
    LogbookIcons["Enter"] = "enter";
    LogbookIcons["Edit"] = "edit";
    LogbookIcons["Day"] = "day";
    LogbookIcons["Cruise"] = "cruise";
    LogbookIcons["Copy"] = "copy";
    LogbookIcons["Compass"] = "compass";
    LogbookIcons["CompassFilled"] = "compass-filled";
    LogbookIcons["Companion"] = "companion";
    LogbookIcons["Cloud"] = "cloud";
    LogbookIcons["Close"] = "close";
    LogbookIcons["CircleLarge"] = "circle-large";
    LogbookIcons["CircleHalfLarge"] = "circle-half-large";
    LogbookIcons["CircleFilledLarge"] = "circle-filled-large";
    LogbookIcons["Checklist"] = "checklist";
    LogbookIcons["Box"] = "box";
    LogbookIcons["BoxFilled"] = "box-filled";
    LogbookIcons["Bluetooth"] = "bluetooth";
    LogbookIcons["ArrowsUp"] = "arrows-up";
    LogbookIcons["ArrowsRight"] = "arrows-right";
    LogbookIcons["ArrowsLeft"] = "arrows-left";
    LogbookIcons["ArrowsDown"] = "arrows-down";
    LogbookIcons["ArrowUp"] = "arrow-up";
    LogbookIcons["ArrowRight"] = "arrow-right";
    LogbookIcons["ArrowLeft"] = "arrow-left";
    LogbookIcons["ArrowDown"] = "arrow-down";
    LogbookIcons["Alert"] = "alert";
    LogbookIcons["AdviceWind"] = "advice-wind";
    LogbookIcons["AdviceTest"] = "advice-test";
    LogbookIcons["AdviceStop"] = "advice-stop";
    LogbookIcons["AdvicePressure"] = "advice-pressure";
    LogbookIcons["AdviceMessage"] = "advice-message";
    LogbookIcons["AdviceManualShipStatus"] = "advice-manual-ship-status";
    LogbookIcons["AdviceManOverboard"] = "advice-man-overboard";
    LogbookIcons["AdviceLostPosition"] = "advice-lost-position";
    LogbookIcons["AdviceLights"] = "advice-lights";
    LogbookIcons["AdviceDepth"] = "advice-depth";
    LogbookIcons["AdviceAnchor"] = "advice-anchor";
    LogbookIcons["AdviceAnchorDrift"] = "advice-anchor-drift";
    LogbookIcons["Account"] = "account";
})($8efd2cc0c4df4afb$export$57136dcf80d0dc11 || ($8efd2cc0c4df4afb$export$57136dcf80d0dc11 = {}));
const $8efd2cc0c4df4afb$export$39fd61838b6941a4 = {
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Wifi]: "61697",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather9]: "61698",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather8]: "61699",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather7]: "61700",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather6]: "61701",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather5]: "61702",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather4]: "61703",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather3]: "61704",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather2]: "61705",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather16]: "61706",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather15]: "61707",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather14]: "61708",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather13]: "61709",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather12]: "61710",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather11]: "61711",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather10]: "61712",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Weather1]: "61713",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Watch]: "61714",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.User]: "61715",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Usb]: "61716",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Trip]: "61717",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Trash]: "61718",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Track]: "61719",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Toggle]: "61720",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.ToggleOn]: "61721",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.StatusWaiting]: "61722",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.StatusPort]: "61723",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.StatusOnboard]: "61724",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.StatusOffboard]: "61725",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.StatusLock]: "61726",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.StatusInmotion]: "61727",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.StatusDrifting]: "61728",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.StatusBuoy]: "61729",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.StatusBunkering]: "61730",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.StatusBridge]: "61731",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.StatusAnchor]: "61732",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Stats]: "61733",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Sounding]: "61734",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Settings]: "61735",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Search]: "61736",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.SailsUp]: "61737",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.SailsDown]: "61738",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.SailsChange]: "61739",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.SailingVessel]: "61740",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.SailingVesselLarge]: "61741",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Refresh]: "61742",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Print]: "61743",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Plus]: "61744",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.On2]: "61745",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.On1]: "61746",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.On]: "61747",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Off2]: "61748",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Off1]: "61749",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Off]: "61750",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Note]: "61751",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.NoteWeatherReport]: "61752",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.NoteWeatherForecast]: "61753",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.NoteTechnical]: "61754",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.NoteJournal]: "61755",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.NoteCruisePlan]: "61756",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.NoCloud]: "61757",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Navigation]: "61758",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.NavigationLevel3]: "61759",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.NavigationLevel2]: "61760",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.NavigationLevel1]: "61761",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.NavigationLevel0]: "61762",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.MotorVessel]: "61763",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.MoonWaxing]: "61764",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.MoonWaning]: "61765",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.MoonNew]: "61766",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.MoonFull]: "61767",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Lights]: "61768",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.LightingTricolor]: "61769",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.LightingSailingRunning]: "61770",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.LightingNone]: "61771",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.LightingMotoringRunning]: "61772",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.LightingMotoringCone]: "61773",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.LightingAnchorLight]: "61774",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.LightingAnchorBall]: "61775",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Graph]: "61776",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Gps]: "61777",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.GpsUnfilled]: "61778",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.GenWater]: "61779",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.GenPower]: "61780",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.GenHeater]: "61781",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.GenAc]: "61782",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.EyeOn]: "61783",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.EyeOff]: "61784",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Environment]: "61785",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Enter]: "61786",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Edit]: "61787",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Day]: "61788",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Cruise]: "61789",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Copy]: "61790",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Compass]: "61791",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.CompassFilled]: "61792",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Companion]: "61793",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Cloud]: "61794",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Close]: "61795",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.CircleLarge]: "61796",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.CircleHalfLarge]: "61797",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.CircleFilledLarge]: "61798",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Checklist]: "61799",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Box]: "61800",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.BoxFilled]: "61801",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Bluetooth]: "61802",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.ArrowsUp]: "61803",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.ArrowsRight]: "61804",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.ArrowsLeft]: "61805",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.ArrowsDown]: "61806",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.ArrowUp]: "61807",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.ArrowRight]: "61808",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.ArrowLeft]: "61809",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.ArrowDown]: "61810",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Alert]: "61811",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.AdviceWind]: "61812",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.AdviceTest]: "61813",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.AdviceStop]: "61814",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.AdvicePressure]: "61815",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.AdviceMessage]: "61816",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.AdviceManualShipStatus]: "61817",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.AdviceManOverboard]: "61818",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.AdviceLostPosition]: "61819",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.AdviceLights]: "61820",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.AdviceDepth]: "61821",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.AdviceAnchor]: "61822",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.AdviceAnchorDrift]: "61823",
    [$8efd2cc0c4df4afb$export$57136dcf80d0dc11.Account]: "61824"
};



const $16b96ad8b17ffac4$export$4f13f83fd8bb1dac = (0, $8efd2cc0c4df4afb$export$57136dcf80d0dc11);
function $16b96ad8b17ffac4$export$f04a61298a47a40f({ className: className, icon: icon, onClick: onClick, title: title, text: text }) {
    return (0, $7b02d682eb115277$exports.jsx)("span", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            `LogbookIcon LogbookIcon-${icon}`,
            className,
            onClick && "action"
        ]),
        onClick: onClick,
        title: title,
        children: text
    });
}
function $16b96ad8b17ffac4$export$c85e7476b28a68d3() {
    const style = document.createElement("style");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const icons = (0, $8efd2cc0c4df4afb$export$57136dcf80d0dc11);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const cps = (0, $8efd2cc0c4df4afb$export$39fd61838b6941a4);
    for(const i in icons){
        const n = icons[i];
        const cp = cps[n];
        style.innerHTML += `.LogbookIcon-${n}:before { content: "\\${parseInt(cp).toString(16)}"; } `;
    }
    document.head.appendChild(style);
}


function $d2ed8a69fa699d6a$export$de65de8213222d10({ className: className, icon: icon, iconClassName: iconClassName, onClick: onClick }) {
    const _clickCalllback = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (onClick) onClick();
    };
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "CloseButton",
            className
        ]),
        onClick: onClick,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
            className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                "button",
                iconClassName
            ]),
            icon: icon || (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Close
        })
    });
}


function $cb0532ed9be7da24$export$666a1c84dcdd038f() {}
function $cb0532ed9be7da24$export$c6fdb837b070b4ff({ children: children, className: className, closeBackground: closeBackground, containerClassName: containerClassName, closeCallback: closeCallback, hideBackground: hideBackground, hideClose: hideClose, style: style, title: title }) {
    const onClick = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (closeCallback) closeCallback(false);
    }, [
        closeCallback
    ]);
    // A dialog should never affect its container: stop every click inside the overlay
    // (title, body content, inputs, buttons) from bubbling up to ancestor click handlers,
    // regardless of whether it is otherwise handled.
    const stopPropagation = (0, $acw62.useCallback)((e)=>{
        e.stopPropagation();
    }, []);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "Overlay-container",
            containerClassName
        ]),
        onClick: stopPropagation,
        children: [
            !hideBackground && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Overlay-background",
                onClick: closeBackground == true ? onClick : undefined
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                    "Overlay-content",
                    style,
                    className
                ]),
                children: [
                    title && (0, $7b02d682eb115277$exports.jsx)($cb0532ed9be7da24$export$fe53879cede8fc3, {
                        closeCallback: closeCallback,
                        hideClose: hideClose,
                        title: title
                    }),
                    children
                ]
            })
        ]
    });
}
function $cb0532ed9be7da24$export$fe53879cede8fc3({ closeCallback: closeCallback, hideClose: hideClose, style: style, title: title }) {
    const onClick = (0, $acw62.useCallback)(()=>{
        if (closeCallback) closeCallback(false);
    }, [
        closeCallback
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "Overlay-title",
            style
        ]),
        children: [
            !hideClose && closeCallback && (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                onClick: onClick
            }),
            (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "Overlay-title-text",
                children: title
            })
        ]
    });
}



const $2af575fa192771dd$var$SceneMessageKey = (scene)=>{
    switch(scene){
        case "concept":
            return "concept";
        case "quickstart":
            return "quickstart";
        case "quickstart-voyage":
            return "quickstartVoyage";
    }
    return "concept";
};
const $2af575fa192771dd$export$f8e6723ee47ab34a = {
    // Maps a scene id to its key in the localized `demo` messages object.
    messageKey: $2af575fa192771dd$var$SceneMessageKey,
    // Resolves the message bundle for a language, falling back to English.
    localization (language) {
        var _a;
        return (_a = (0, $c7447bc87504efd0$export$5c05d8d94c8024d2)[language]) !== null && _a !== void 0 ? _a : (0, $c7447bc87504efd0$export$5c05d8d94c8024d2).en;
    },
    // Frame title: prefer the frame's own `<name>_title` message, else the scene title.
    title (loc, scene, frameName) {
        const sceneMessages = loc.demo[$2af575fa192771dd$var$SceneMessageKey(scene)];
        const frameTitle = sceneMessages[frameName + "_title"];
        return frameTitle || sceneMessages["title"];
    },
    // Previous/next button labels, each falling back to the English label.
    uiLabels (loc) {
        var _a, _b, _c, _d;
        return {
            previous: (_b = (_a = loc.ui) === null || _a === void 0 ? void 0 : _a.previous) !== null && _b !== void 0 ? _b : (0, $c7447bc87504efd0$export$5c05d8d94c8024d2).en.ui.previous,
            next: (_d = (_c = loc.ui) === null || _c === void 0 ? void 0 : _c.next) !== null && _d !== void 0 ? _d : (0, $c7447bc87504efd0$export$5c05d8d94c8024d2).en.ui.next
        };
    },
    // Frame navigation, clamped to the [0, length - 1] range.
    nextIndex (frame, length) {
        return Math.min(frame + 1, length - 1);
    },
    previousIndex (frame) {
        return Math.max(frame - 1, 0);
    },
    finalHighlights (frameName, highlightBoxes) {
        if (frameName !== "timelineVoyageClick" || highlightBoxes.length <= 1) return highlightBoxes;
        const minTop = Math.min(...highlightBoxes.map((box)=>box.top - box.height / 2));
        const maxBottom = Math.max(...highlightBoxes.map((box)=>box.top + box.height / 2));
        const minLeft = Math.min(...highlightBoxes.map((box)=>box.left - box.width / 2));
        const maxRight = Math.max(...highlightBoxes.map((box)=>box.left + box.width / 2));
        const totalWidth = maxRight - minLeft;
        const totalHeight = maxBottom - minTop;
        return [
            {
                top: minTop + totalHeight / 2,
                left: minLeft + totalWidth / 2,
                width: totalWidth,
                height: totalHeight
            }
        ];
    },
    // Resolves a frame's content node. Throws when the frame names a content key
    // that the scene's content registry does not provide; renders the mapped node
    // otherwise (and nothing when the frame has no content).
    frameNode (content, frame) {
        if (frame.content && !content[frame.content]) throw new Error(`Content for frame ${frame.name} not found: ${frame.content}`);
        return frame.content && (0, $7b02d682eb115277$exports.jsx)("div", {
            children: content[frame.content](frame)
        }, frame.content);
    }
};
function $2af575fa192771dd$export$38af1803e3442a7f({ content: content, frames: frames, scene: scene, initialFrame: initialFrame, onClose: _onClose }) {
    var _a, _b;
    const [frame, setFrame] = (0, $acw62.useState)(initialFrame !== null && initialFrame !== void 0 ? initialFrame : 0);
    const [overlayVisible, setOverlayVisible] = (0, $acw62.useState)(false);
    const actionRef = (0, $acw62.useRef)(null);
    const actionInnerRef = (0, $acw62.useRef)(null);
    const pointerRef = (0, $acw62.useRef)(null);
    const pointerUpRef = (0, $acw62.useRef)(null);
    const scrollPositionRef = (0, $acw62.useRef)(0);
    const [highlights, setHighlights] = (0, $acw62.useState)([]);
    const [highlightOpacity, setHighlightOpacity] = (0, $acw62.useState)(0);
    const [highlightTransition, setHighlightTransition] = (0, $acw62.useState)("none");
    const app = (0, $6f69f4dcc7c84750$export$56752c5ff04def75)();
    const currentFrame = (0, $acw62.useMemo)(()=>{
        return frames[frame];
    }, [
        frame,
        frames
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c;
        // Don't show highlight border if show-pointer animation is active
        const hasPointerAnimation = ((_a = currentFrame.animations) === null || _a === void 0 ? void 0 : _a.includes("show-pointer")) || ((_b = currentFrame.animations) === null || _b === void 0 ? void 0 : _b.includes("show-pointer-up"));
        if ((_c = currentFrame === null || currentFrame === void 0 ? void 0 : currentFrame.contentOptions) === null || _c === void 0 ? void 0 : _c.theme) document.documentElement.setAttribute("data-theme", currentFrame.contentOptions.theme);
        if (currentFrame.highlight && !hasPointerAnimation) {
            // Reset to invisible with no transition
            setHighlightOpacity(0);
            setHighlightTransition("none");
            setHighlights([]);
            const timeouts = [];
            // Step 1: Calculate and render highlights (invisible, no transition)
            const calculateTimeout = setTimeout(()=>{
                const elements = document.querySelectorAll(currentFrame.highlight);
                if (elements.length > 0) {
                    const highlightBoxes = Array.from(elements).map((element)=>{
                        const rect = element.getBoundingClientRect();
                        const top = rect.top + window.scrollY;
                        const left = rect.left + window.scrollX;
                        const width = rect.width;
                        const height = rect.height;
                        // Add vertical padding for specific scenes
                        const verticalPadding = currentFrame.name === "departing" || currentFrame.name === "manualEntry3" || currentFrame.name === "endDay" || currentFrame.name === "endDay4" ? 10 : 0;
                        const centerX = left + width / 2;
                        const centerY = top + height / 2;
                        return {
                            top: centerY,
                            left: centerX,
                            width: width,
                            height: height + verticalPadding * 2
                        };
                    });
                    const finalHighlights = $2af575fa192771dd$export$f8e6723ee47ab34a.finalHighlights(currentFrame.name, highlightBoxes);
                    setHighlights(finalHighlights);
                    // Step 2: Add transition after highlights are rendered
                    const transitionTimeout = setTimeout(()=>{
                        setHighlightTransition("opacity 1000ms ease-in-out");
                        // Step 3: Change opacity to trigger the transition
                        const fadeTimeout = setTimeout(()=>{
                            setHighlightOpacity(1);
                        }, 50); // Small delay to ensure transition is applied first
                        timeouts.push(fadeTimeout);
                    }, 100); // Wait 100ms before starting fade
                    timeouts.push(transitionTimeout);
                } else setHighlights([]);
            }, 100); // Wait for DOM
            timeouts.push(calculateTimeout);
            return ()=>{
                timeouts.forEach((t)=>clearTimeout(t));
            };
        } else {
            setHighlights([]);
            setHighlightOpacity(0);
            setHighlightTransition("none");
            return undefined;
        }
    }, [
        currentFrame
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!currentFrame.animations) {
            setOverlayVisible(true);
            return;
        }
        const hasAutoShow = currentFrame.animations.includes("auto-show-overlay");
        if (hasAutoShow) {
            setOverlayVisible(false);
            const showTimeout = setTimeout(()=>{
                setOverlayVisible(true);
            }, 80);
            return ()=>clearTimeout(showTimeout);
        } else setOverlayVisible(true);
        return;
    }, [
        currentFrame
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!currentFrame.animations) {
            if (pointerRef.current) pointerRef.current.style.display = "none";
            if (pointerUpRef.current) pointerUpRef.current.style.display = "none";
            return;
        }
        const clear = [];
        const hasPointer = currentFrame.animations.includes("show-pointer");
        const hasPointerUp = currentFrame.animations.includes("show-pointer-up");
        if (!hasPointer && pointerRef.current) pointerRef.current.style.display = "none";
        if (!hasPointerUp && pointerUpRef.current) pointerUpRef.current.style.display = "none";
        for (const animation of currentFrame.animations)switch(animation){
            case "scroll-to-highlight":
                if (currentFrame.highlight) {
                    const highlightSelector = currentFrame.highlight;
                    const timeout = setTimeout(()=>{
                        const element = document.querySelector(highlightSelector);
                        if (element) element.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });
                    }, 200); // Wait for DOM to update and render LogView
                    clear.push(()=>clearTimeout(timeout));
                }
                break;
            case "scroll-highlight-top":
                if (currentFrame.highlight) {
                    const element = document.querySelector(currentFrame.highlight);
                    if (element) {
                        const rect = element.getBoundingClientRect();
                        const absoluteTop = rect.top + window.scrollY;
                        // Account for the header offset (104px margin-top on .ShipView)
                        const headerOffset = 104;
                        window.scrollTo({
                            top: absoluteTop - headerOffset,
                            behavior: "smooth"
                        });
                    }
                }
                break;
            case "scroll-highlight-top-slow":
                if (currentFrame.highlight) {
                    const element = document.querySelector(currentFrame.highlight);
                    if (element) {
                        const rect = element.getBoundingClientRect();
                        const absoluteTop = rect.top + window.scrollY;
                        const headerOffset = 104;
                        const targetScroll = absoluteTop - headerOffset;
                        const startScroll = window.scrollY;
                        const distance = targetScroll - startScroll;
                        const duration = 2000; // 2 seconds for slower scroll
                        const startTime = performance.now();
                        const animateScroll = (currentTime)=>{
                            const elapsed = currentTime - startTime;
                            const progress = Math.min(elapsed / duration, 1);
                            // Ease in-out function for smooth animation
                            const easeProgress = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
                            window.scrollTo(0, startScroll + distance * easeProgress);
                            if (progress < 1) requestAnimationFrame(animateScroll);
                        };
                        requestAnimationFrame(animateScroll);
                    }
                }
                break;
            case "scroll-to-top":
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
                break;
            case "scroll-to-bottom":
                {
                    const bottom = document.documentElement.scrollHeight - window.innerHeight;
                    window.scrollTo({
                        top: bottom,
                        behavior: "smooth"
                    });
                    break;
                }
            case "scroll-to-nextday":
                {
                    const nextDayTimeout = setTimeout(()=>{
                        const dayViews = document.querySelectorAll(".DayView");
                        if (dayViews.length > 1) {
                            const nextDay = dayViews[1]; // Second DayView is tomorrow
                            const rect = nextDay.getBoundingClientRect();
                            const absoluteTop = rect.top + window.scrollY;
                            const headerOffset = 104;
                            const targetScroll = absoluteTop - headerOffset;
                            window.scrollTo({
                                top: targetScroll,
                                behavior: "smooth"
                            });
                            // Store the target scroll position immediately
                            scrollPositionRef.current = targetScroll;
                        }
                    }, 300); // Wait for log details to open
                    clear.push(()=>clearTimeout(nextDayTimeout));
                    break;
                }
            case "keep-on-nextday":
                // Restore scroll position after DOM has fully updated
                // Small delay to ensure React has finished rendering new content
                {
                    const restoreTimeout = setTimeout(()=>{
                        if (scrollPositionRef.current > 0) window.scrollTo({
                            top: scrollPositionRef.current,
                            behavior: "auto"
                        });
                    }, 50);
                    clear.push(()=>clearTimeout(restoreTimeout));
                    break;
                }
            case "scroll-to-logrow":
                {
                    const logRow = document.querySelector(".DayView-logs-log");
                    if (logRow) {
                        const rect = logRow.getBoundingClientRect();
                        const absoluteTop = rect.top + window.scrollY;
                        const headerOffset = 600; // header minus 2x log entry height to position closer to bottom
                        window.scrollTo({
                            top: absoluteTop - headerOffset,
                            behavior: "smooth"
                        });
                    }
                    break;
                }
            case "scroll-up-down":
                {
                    const interval = setInterval(()=>{
                        window.scrollBy(0, Math.sin(Date.now() / 500) * 5);
                    }, 20);
                    clear.push(()=>clearInterval(interval));
                    break;
                }
            case "show-action-click":
                if (currentFrame.action) {
                    // Hide indicators initially
                    if (actionRef.current && actionInnerRef.current) {
                        actionRef.current.style.opacity = "0";
                        actionInnerRef.current.style.opacity = "0";
                    }
                    const clickTimeout = setTimeout(()=>{
                        const element = document.querySelector(currentFrame.action.selector);
                        if (element && actionRef.current && actionInnerRef.current) {
                            const rect = element.getBoundingClientRect();
                            const centerX = rect.left + window.scrollX + rect.width / 2;
                            const centerY = rect.top + window.scrollY + rect.height / 2;
                            const circleRadius = 16; // Half of 32px circle diameter
                            actionRef.current.style.top = `${centerY - circleRadius - 2}px`;
                            actionRef.current.style.left = `${centerX - circleRadius - 2}px`;
                            actionRef.current.style.opacity = "1";
                            actionInnerRef.current.style.top = `${centerY - circleRadius - 2}px`;
                            actionInnerRef.current.style.left = `${centerX - circleRadius - 2}px`;
                            actionInnerRef.current.style.opacity = "1";
                            // Execute the actual click after showing the indicator
                            setTimeout(()=>{
                                if (element instanceof HTMLElement) element.click();
                            }, 500); // Click after indicator is visible
                        }
                    }, 300); // Wait for scroll and DOM updates
                    clear.push(()=>clearTimeout(clickTimeout));
                }
                break;
            case "show-action-click-once":
                if (currentFrame.action) {
                    // Hide indicators initially
                    if (actionRef.current && actionInnerRef.current) {
                        actionRef.current.style.opacity = "0";
                        actionInnerRef.current.style.opacity = "0";
                    }
                    const clickOnceTimeout = setTimeout(()=>{
                        const element = document.querySelector(currentFrame.action.selector);
                        if (element && actionRef.current && actionInnerRef.current) {
                            const rect = element.getBoundingClientRect();
                            const centerX = rect.left + window.scrollX + rect.width / 2;
                            const centerY = rect.top + window.scrollY + rect.height / 2;
                            const circleRadius = 16; // Half of 32px circle diameter
                            actionRef.current.style.top = `${centerY - circleRadius - 2}px`;
                            actionRef.current.style.left = `${centerX - circleRadius - 2}px`;
                            actionRef.current.style.opacity = "1";
                            actionInnerRef.current.style.top = `${centerY - circleRadius - 2}px`;
                            actionInnerRef.current.style.left = `${centerX - circleRadius - 2}px`;
                            actionInnerRef.current.style.opacity = "1";
                            // Execute the actual click after showing the indicator
                            setTimeout(()=>{
                                if (element instanceof HTMLElement) element.click();
                                // Fade out the indicator after click
                                setTimeout(()=>{
                                    if (actionRef.current && actionInnerRef.current) {
                                        actionRef.current.style.transition = "opacity 300ms ease-out";
                                        actionInnerRef.current.style.transition = "opacity 300ms ease-out";
                                        actionRef.current.style.opacity = "0";
                                        actionInnerRef.current.style.opacity = "0";
                                        // Stop the CSS animation
                                        actionInnerRef.current.style.animation = "none";
                                    }
                                }, 100); // Small delay after click before fade out
                            }, 500); // Click after indicator is visible
                        }
                    }, 300); // Wait for scroll and DOM updates
                    clear.push(()=>clearTimeout(clickOnceTimeout));
                }
                break;
            case "show-pointer":
                if (currentFrame.highlight && pointerRef.current) {
                    const element = document.querySelector(currentFrame.highlight);
                    if (element) {
                        const rect = element.getBoundingClientRect();
                        let centerX = rect.left + window.scrollX + rect.width / 2;
                        // Special positioning for endDay scene - move 50% to the left
                        if (currentFrame.name === "endDay") centerX = centerX - rect.width / 3.2;
                        const topY = rect.top + window.scrollY;
                        pointerRef.current.style.top = `${topY - 140}px`; // 100px line + 40px space
                        pointerRef.current.style.left = `${centerX}px`;
                        pointerRef.current.style.display = "block";
                    }
                }
                break;
            case "show-pointer-up":
                if (currentFrame.highlight && pointerUpRef.current) {
                    const element = document.querySelector(currentFrame.highlight);
                    if (element) {
                        const rect = element.getBoundingClientRect();
                        const centerX = rect.left + window.scrollX + rect.width / 2;
                        const bottomY = rect.bottom + window.scrollY;
                        pointerUpRef.current.style.top = `${bottomY}px`;
                        pointerUpRef.current.style.left = `${centerX}px`;
                        pointerUpRef.current.style.display = "block";
                    }
                }
                break;
            case "auto-show-overlay":
                {
                    const timeout = setTimeout(()=>{
                        nextFrame();
                    }, 2000);
                    clear.push(()=>clearTimeout(timeout));
                    break;
                }
            default:
                break;
        }
        if (clear.length > 0) return ()=>{
            for (const c of clear)c();
        };
        return undefined;
    }, [
        currentFrame.animations,
        actionRef === null || actionRef === void 0 ? void 0 : actionRef.current,
        currentFrame.action
    ]);
    const previousFrame = (0, $acw62.useCallback)(()=>{
        setFrame((prev)=>$2af575fa192771dd$export$f8e6723ee47ab34a.previousIndex(prev));
    }, [
        frame
    ]);
    const nextFrame = (0, $acw62.useCallback)(()=>{
        setFrame((prev)=>$2af575fa192771dd$export$f8e6723ee47ab34a.nextIndex(prev, frames.length));
    }, [
        frame,
        frames
    ]);
    const title = (0, $acw62.useMemo)(()=>{
        const loc = $2af575fa192771dd$export$f8e6723ee47ab34a.localization(app.language);
        return $2af575fa192771dd$export$f8e6723ee47ab34a.title(loc, scene, currentFrame.name);
    }, [
        currentFrame,
        scene,
        app.language
    ]);
    const uiLabels = (0, $acw62.useMemo)(()=>{
        return $2af575fa192771dd$export$f8e6723ee47ab34a.uiLabels($2af575fa192771dd$export$f8e6723ee47ab34a.localization(app.language));
    }, [
        app.language
    ]);
    const frameContent = (0, $acw62.useMemo)(()=>{
        return $2af575fa192771dd$export$f8e6723ee47ab34a.frameNode(content, currentFrame);
    }, [
        currentFrame,
        content
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Scene",
        "data-scene": scene,
        "data-frame": currentFrame.name,
        children: [
            highlights.map((highlight, index)=>(0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "Scene-highlight",
                    style: {
                        top: `${highlight.top}px`,
                        left: `${highlight.left}px`,
                        width: `${highlight.width}px`,
                        height: `${highlight.height}px`,
                        transform: "translate(-50%, -50%)",
                        opacity: highlightOpacity,
                        transition: highlightTransition
                    }
                }, `${currentFrame.name}-${index}`)),
            currentFrame.action && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `Scene-action-indicator action-${currentFrame.action.action}`,
                        ref: actionRef
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `Scene-action-indicator-inner action-${currentFrame.action.action}`,
                        ref: actionInnerRef
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("svg", {
                className: "Scene-pointer",
                ref: pointerRef,
                style: {
                    display: "none"
                },
                width: "32",
                height: "120",
                viewBox: "0 0 32 120",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M 16 0 L 16 100 M 6 90 L 16 100 L 26 90",
                    stroke: "red",
                    strokeWidth: "4",
                    fill: "none",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("svg", {
                className: "Scene-pointer-up",
                ref: pointerUpRef,
                style: {
                    display: "none"
                },
                width: "32",
                height: "120",
                viewBox: "0 0 32 120",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M 16 120 L 16 20 M 6 30 L 16 20 L 26 30",
                    stroke: "red",
                    strokeWidth: "4",
                    fill: "none",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `Scene-content ${((_a = currentFrame.animations) === null || _a === void 0 ? void 0 : _a.includes("fade-out-content")) ? "content-fade-out" : ""}${((_b = currentFrame.animations) === null || _b === void 0 ? void 0 : _b.includes("fade-in-content")) ? " content-fade-in" : ""}`,
                children: frameContent
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
                title: title,
                hideClose: true,
                className: `${currentFrame.overlayPosition ? `position-${currentFrame.overlayPosition}` : ""} ${overlayVisible ? "fade-in" : "hidden"}`,
                containerClassName: "Scene-overlay",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    className: "Overlay-body",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $c7447bc87504efd0$export$4c288ea8cff73213), {
                                    html: true,
                                    message: (m)=>m.demo[$2af575fa192771dd$var$SceneMessageKey(scene)][currentFrame.name]
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            actions: true,
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button",
                                        onClick: previousFrame,
                                        disabled: frame == 0,
                                        children: uiLabels.previous
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button",
                                        onClick: nextFrame,
                                        disabled: frame >= frames.length - 1,
                                        children: uiLabels.next
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


// @generated by TypeGen from LogbookModel/Account.swift - DO NOT EDIT
var $7cd0ad1ebf7aa273$export$e22b0e185bbfaf0d;
(function(IAccountPaymentSystem) {
    IAccountPaymentSystem[IAccountPaymentSystem["none"] = 0] = "none";
    IAccountPaymentSystem[IAccountPaymentSystem["stripe"] = 1] = "stripe";
    IAccountPaymentSystem[IAccountPaymentSystem["apple"] = 2] = "apple";
    IAccountPaymentSystem[IAccountPaymentSystem["gift"] = 3] = "gift";
})($7cd0ad1ebf7aa273$export$e22b0e185bbfaf0d || ($7cd0ad1ebf7aa273$export$e22b0e185bbfaf0d = {}));
var $7cd0ad1ebf7aa273$export$774ee01ad57ee88;
(function(IAccountSubscriptionInterval) {
    IAccountSubscriptionInterval[IAccountSubscriptionInterval["monthly"] = 0] = "monthly";
    IAccountSubscriptionInterval[IAccountSubscriptionInterval["yearly"] = 1] = "yearly";
    IAccountSubscriptionInterval[IAccountSubscriptionInterval["quarterly"] = 2] = "quarterly";
})($7cd0ad1ebf7aa273$export$774ee01ad57ee88 || ($7cd0ad1ebf7aa273$export$774ee01ad57ee88 = {}));
var $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e;
(function(IAccountSubscriptionStatus) {
    IAccountSubscriptionStatus[IAccountSubscriptionStatus["inactive"] = 0] = "inactive";
    IAccountSubscriptionStatus[IAccountSubscriptionStatus["trial1DayLeft"] = 1] = "trial1DayLeft";
    IAccountSubscriptionStatus[IAccountSubscriptionStatus["trial2DaysLeft"] = 2] = "trial2DaysLeft";
    IAccountSubscriptionStatus[IAccountSubscriptionStatus["trial3DaysLeft"] = 3] = "trial3DaysLeft";
    IAccountSubscriptionStatus[IAccountSubscriptionStatus["trial4DaysLeft"] = 4] = "trial4DaysLeft";
    IAccountSubscriptionStatus[IAccountSubscriptionStatus["trial5DaysLeft"] = 5] = "trial5DaysLeft";
    IAccountSubscriptionStatus[IAccountSubscriptionStatus["trialStarted"] = 7] = "trialStarted";
    IAccountSubscriptionStatus[IAccountSubscriptionStatus["trialExpired"] = 8] = "trialExpired";
    IAccountSubscriptionStatus[IAccountSubscriptionStatus["active"] = 10] = "active";
    IAccountSubscriptionStatus[IAccountSubscriptionStatus["cancelled"] = 11] = "cancelled";
})($7cd0ad1ebf7aa273$export$4373e6d4d88fe91e || ($7cd0ad1ebf7aa273$export$4373e6d4d88fe91e = {}));


// @generated by TypeGen from LogbookModel/AccountUser.swift - DO NOT EDIT
var $0b2bdaa8112b7188$export$103b1fca92a0adba;
(function(IAccountUserLevel) {
    IAccountUserLevel[IAccountUserLevel["disabled"] = 0] = "disabled";
    IAccountUserLevel[IAccountUserLevel["user"] = 1] = "user";
    IAccountUserLevel[IAccountUserLevel["admin"] = 100] = "admin";
})($0b2bdaa8112b7188$export$103b1fca92a0adba || ($0b2bdaa8112b7188$export$103b1fca92a0adba = {}));


// @generated by TypeGen from LogbookServer/AccountApi.swift - DO NOT EDIT

var $2c91e54697470636$export$30054237d608271c;
(function(IAccountUserStatus) {
    IAccountUserStatus["invited"] = "invited";
    IAccountUserStatus["active"] = "active";
})($2c91e54697470636$export$30054237d608271c || ($2c91e54697470636$export$30054237d608271c = {}));
const $2c91e54697470636$export$490f933b78311834 = {
    "DELETE /api/account": {
        permission: {
            account: (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin
        }
    },
    "DELETE /api/account/users/:userId": {
        permission: {
            account: (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin
        }
    },
    "GET /api/account/plan": {
        permission: {
            account: (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).user
        }
    },
    "GET /api/account/plans": {
        permission: {
            session: true
        }
    },
    "GET /api/account/users": {
        permission: {
            account: (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin
        }
    },
    "GET /api/signup/invitation/:token": {
        permission: {}
    },
    "POST /api/account": {
        permission: {}
    },
    "POST /api/search": {
        permission: {
            account: (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).user
        }
    },
    "POST /api/signup/confirm-email/:token": {
        permission: {}
    },
    "POST /api/signup/invitation/:token": {
        permission: {}
    },
    "PUT /api/account/user": {
        permission: {
            session: true
        }
    },
    "PUT /api/account/user/language": {
        permission: {
            session: true
        }
    },
    "PUT /api/account/user/password": {
        permission: {
            session: true
        }
    },
    "PUT /api/account/users/:userId": {
        permission: {
            account: (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin
        }
    }
};


// @generated by TypeGen from LogbookApi/ApiRuntime - DO NOT EDIT
class $fdaad42f27f85e26$export$969ca842d6b32a82 extends Error {
    constructor(key, target, allowed){
        super(`Route ${key} is not available on target "${target}" (allowed: ${allowed.join(", ")})`);
        this.key = key;
        this.target = target;
        this.allowed = allowed;
        this.name = "ApiTargetError";
    }
}
function $fdaad42f27f85e26$export$a016fea3e6717bac(client, key, allowed) {
    if (!allowed.includes(client.target)) throw new $fdaad42f27f85e26$export$969ca842d6b32a82(key, client.target, allowed);
}


// @generated by TypeGen from LogbookModel/Status/AlertStatus.swift - DO NOT EDIT
var $ed9e79f0f649608a$export$15ffcea16bb3f96a;
(function(IAlertLostPositionReason) {
    IAlertLostPositionReason["disconnected"] = "disconnected";
    IAlertLostPositionReason["stale"] = "stale";
    IAlertLostPositionReason["jump"] = "jump";
    IAlertLostPositionReason["invalidFix"] = "invalidFix";
})($ed9e79f0f649608a$export$15ffcea16bb3f96a || ($ed9e79f0f649608a$export$15ffcea16bb3f96a = {}));
var $ed9e79f0f649608a$export$c01da1d04a9f8514;
(function(IAlertManOverboardStatus) {
    IAlertManOverboardStatus["emitterActivated"] = "emitterActivated";
    IAlertManOverboardStatus["manualButtonActivated"] = "manualButtonActivated";
    IAlertManOverboardStatus["manual"] = "manual";
    IAlertManOverboardStatus["unknown"] = "unknown";
})($ed9e79f0f649608a$export$c01da1d04a9f8514 || ($ed9e79f0f649608a$export$c01da1d04a9f8514 = {}));
var $ed9e79f0f649608a$export$63ce30087a699ab4;
(function(IAlertStatus) {
    IAlertStatus[IAlertStatus["ok"] = 0] = "ok";
    IAlertStatus[IAlertStatus["resolved"] = 1] = "resolved";
    IAlertStatus[IAlertStatus["ignored"] = 2] = "ignored";
    IAlertStatus[IAlertStatus["acknowledged"] = 3] = "acknowledged";
    IAlertStatus[IAlertStatus["warning"] = 4] = "warning";
    IAlertStatus[IAlertStatus["alarm"] = 5] = "alarm";
})($ed9e79f0f649608a$export$63ce30087a699ab4 || ($ed9e79f0f649608a$export$63ce30087a699ab4 = {}));
var $ed9e79f0f649608a$export$5ebaef48f8647867;
(function(IAlertStatusType) {
    IAlertStatusType["anchorDrift"] = "anchorDrift";
    IAlertStatusType["depth"] = "depth";
    IAlertStatusType["lights"] = "lights";
    IAlertStatusType["pressure"] = "pressure";
    IAlertStatusType["wind"] = "wind";
    IAlertStatusType["lostPosition"] = "lostPosition";
    IAlertStatusType["message"] = "message";
    IAlertStatusType["manOverboard"] = "manOverboard";
    IAlertStatusType["test"] = "test";
})($ed9e79f0f649608a$export$5ebaef48f8647867 || ($ed9e79f0f649608a$export$5ebaef48f8647867 = {}));
var $ed9e79f0f649608a$export$af54f16728d968fd;
(function(IAlertStatusPhase) {
    IAlertStatusPhase[IAlertStatusPhase["notice"] = 0] = "notice";
    IAlertStatusPhase[IAlertStatusPhase["watch"] = 1] = "watch";
    IAlertStatusPhase[IAlertStatusPhase["skipper"] = 2] = "skipper";
    IAlertStatusPhase[IAlertStatusPhase["allHands"] = 3] = "allHands";
})($ed9e79f0f649608a$export$af54f16728d968fd || ($ed9e79f0f649608a$export$af54f16728d968fd = {}));


// @generated by TypeGen from LogbookModel/Status/AlertEngineModel.swift - DO NOT EDIT
var $62c07736c3fbb91c$export$3258e89f1be8b566;
(function(IAlertLoudness) {
    IAlertLoudness[IAlertLoudness["notificationOnly"] = 0] = "notificationOnly";
    IAlertLoudness[IAlertLoudness["audible"] = 1] = "audible";
})($62c07736c3fbb91c$export$3258e89f1be8b566 || ($62c07736c3fbb91c$export$3258e89f1be8b566 = {}));


// Brand a raw broadcast/fetched `ILog` as the current log. Returns a fresh object so the
// source (which a caller may still treat as a plain committed log) is never mutated.
function $64ef1e949dc20123$export$6ffbf5ab2b061183(log) {
    return Object.assign(Object.assign({}, log), {
        kind: "current"
    });
}
function $64ef1e949dc20123$export$77dcd5c071d480a1(log) {
    return Object.assign(Object.assign({}, log), {
        kind: "provisional"
    });
}
function $64ef1e949dc20123$export$e9f6ca2670bbbf60(log) {
    return "kind" in log ? log.kind : "committed";
}


// @generated by TypeGen from LogbookApi/CruiseApi.swift - DO NOT EDIT
// @generated by TypeGen from LogbookModel/ShipUser.swift - DO NOT EDIT
var $dc7739d612f0c536$export$1e4ade51a6368243;
(function(IShipUserCrewRole) {
    IShipUserCrewRole[IShipUserCrewRole["none"] = 0] = "none";
    IShipUserCrewRole[IShipUserCrewRole["crew"] = 10] = "crew";
    IShipUserCrewRole[IShipUserCrewRole["skipper"] = 20] = "skipper";
    IShipUserCrewRole[IShipUserCrewRole["owner"] = 100] = "owner";
})($dc7739d612f0c536$export$1e4ade51a6368243 || ($dc7739d612f0c536$export$1e4ade51a6368243 = {}));
var $dc7739d612f0c536$export$fe876bf720d558fa;
(function(IShipUserLevel) {
    IShipUserLevel[IShipUserLevel["none"] = 0] = "none";
    IShipUserLevel[IShipUserLevel["viewCurrent"] = 1] = "viewCurrent";
    IShipUserLevel[IShipUserLevel["viewAll"] = 2] = "viewAll";
    IShipUserLevel[IShipUserLevel["editCurrent"] = 10] = "editCurrent";
    IShipUserLevel[IShipUserLevel["editAll"] = 11] = "editAll";
    IShipUserLevel[IShipUserLevel["primary"] = 100] = "primary";
})($dc7739d612f0c536$export$fe876bf720d558fa || ($dc7739d612f0c536$export$fe876bf720d558fa = {}));
var $dc7739d612f0c536$export$f6281b7393722b1c;
(function(IShipUserStatus) {
    IShipUserStatus["active"] = "active";
    IShipUserStatus["invited"] = "invited";
})($dc7739d612f0c536$export$f6281b7393722b1c || ($dc7739d612f0c536$export$f6281b7393722b1c = {}));
const $dc7739d612f0c536$export$f384e68d1adf1ff = {
    parse (r) {
        return Object.assign(Object.assign({}, r), {
            dataParsed: r.data != null ? JSON.parse(r.data) : {}
        });
    }
};



const $2dcee90bb6b8bb26$export$a1e48b75e05b4ebd = {
    "GET /api/ship/cruise": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "GET /api/ships/:shipId/cruises": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll
        }
    },
    "GET /api/ships/:shipId/cruises/:cruiseId": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll
        }
    },
    "POST /api/ship/cruise": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "PUT /api/ships/:shipId/cruises/:cruiseId": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "PUT /api/ships/:shipId/cruises/:cruiseId/calculate": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    }
};
class $2dcee90bb6b8bb26$export$91670ad32f536684 {
    constructor(client){
        this.client = client;
        this.cruises = {
            canCreate: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ship/cruise", $2dcee90bb6b8bb26$export$a1e48b75e05b4ebd["GET /api/ship/cruise"].targets);
                        return this.client.call("GET /api/ship/cruise", a);
                    },
                    url: ()=>this.client.url("GET /api/ship/cruise", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent;
                    }
                }),
            list: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/cruises", $2dcee90bb6b8bb26$export$a1e48b75e05b4ebd["GET /api/ships/:shipId/cruises"].targets);
                        return this.client.call("GET /api/ships/:shipId/cruises", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/cruises", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll;
                    }
                }),
            get: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/cruises/:cruiseId", $2dcee90bb6b8bb26$export$a1e48b75e05b4ebd["GET /api/ships/:shipId/cruises/:cruiseId"].targets);
                        return this.client.call("GET /api/ships/:shipId/cruises/:cruiseId", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/cruises/:cruiseId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll;
                    }
                }),
            create: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/cruise", $2dcee90bb6b8bb26$export$a1e48b75e05b4ebd["POST /api/ship/cruise"].targets);
                        return this.client.call("POST /api/ship/cruise", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/cruise", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/cruises/:cruiseId", $2dcee90bb6b8bb26$export$a1e48b75e05b4ebd["PUT /api/ships/:shipId/cruises/:cruiseId"].targets);
                        return this.client.call("PUT /api/ships/:shipId/cruises/:cruiseId", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/cruises/:cruiseId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            calculate: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/cruises/:cruiseId/calculate", $2dcee90bb6b8bb26$export$a1e48b75e05b4ebd["PUT /api/ships/:shipId/cruises/:cruiseId/calculate"].targets);
                        return this.client.call("PUT /api/ships/:shipId/cruises/:cruiseId/calculate", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/cruises/:cruiseId/calculate", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/TripApi.swift - DO NOT EDIT


const $84aa1a3b4df5a78b$export$920243c74818b6ea = {
    "GET /api/ship/trip": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "GET /api/ships/:shipId/cruises/:cruiseId/trips": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll
        }
    },
    "GET /api/ships/:shipId/trips/:tripId": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll
        }
    },
    "POST /api/ship/trip": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "PUT /api/ships/:shipId/trips/:tripId": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "PUT /api/ships/:shipId/trips/:tripId/calculate": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    }
};
class $84aa1a3b4df5a78b$export$5e13e029a186945f {
    constructor(client){
        this.client = client;
        this.trips = {
            canCreate: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ship/trip", $84aa1a3b4df5a78b$export$920243c74818b6ea["GET /api/ship/trip"].targets);
                        return this.client.call("GET /api/ship/trip", a);
                    },
                    url: ()=>this.client.url("GET /api/ship/trip", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent;
                    }
                }),
            list: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/cruises/:cruiseId/trips", $84aa1a3b4df5a78b$export$920243c74818b6ea["GET /api/ships/:shipId/cruises/:cruiseId/trips"].targets);
                        return this.client.call("GET /api/ships/:shipId/cruises/:cruiseId/trips", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/cruises/:cruiseId/trips", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll;
                    }
                }),
            get: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/trips/:tripId", $84aa1a3b4df5a78b$export$920243c74818b6ea["GET /api/ships/:shipId/trips/:tripId"].targets);
                        return this.client.call("GET /api/ships/:shipId/trips/:tripId", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/trips/:tripId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll;
                    }
                }),
            create: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/trip", $84aa1a3b4df5a78b$export$920243c74818b6ea["POST /api/ship/trip"].targets);
                        return this.client.call("POST /api/ship/trip", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/trip", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/trips/:tripId", $84aa1a3b4df5a78b$export$920243c74818b6ea["PUT /api/ships/:shipId/trips/:tripId"].targets);
                        return this.client.call("PUT /api/ships/:shipId/trips/:tripId", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/trips/:tripId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            calculate: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/trips/:tripId/calculate", $84aa1a3b4df5a78b$export$920243c74818b6ea["PUT /api/ships/:shipId/trips/:tripId/calculate"].targets);
                        return this.client.call("PUT /api/ships/:shipId/trips/:tripId/calculate", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/trips/:tripId/calculate", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/ShipApi.swift - DO NOT EDIT


const $0e416c62c0063d32$export$8293355b0d8c54d1 = {
    "DELETE /api/ships/:shipId/companions/:companionId": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "DELETE /api/ships/:shipId/import": {
        targets: [
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "DELETE /api/ships/:shipId/local": {
        targets: [
            "app"
        ],
        permission: {
            session: true
        }
    },
    "GET /api/ship/companion": {
        targets: [
            "app"
        ],
        permission: {}
    },
    "GET /api/ship/resync/status": {
        targets: [
            "app"
        ],
        permission: {
            session: true
        }
    },
    "GET /api/ships": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            session: true
        }
    },
    "GET /api/ships/:shipId": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "GET /api/ships/:shipId/attachments": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            session: true
        }
    },
    "GET /api/ships/:shipId/autocomplete/:field": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "GET /api/ships/:shipId/companions": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "GET /api/ships/:shipId/local/resolve": {
        targets: [
            "app"
        ],
        permission: {
            session: true
        }
    },
    "GET /api/ships/local": {
        targets: [
            "app"
        ],
        permission: {
            session: true
        }
    },
    "GET /ships/:shipId/attachments/:attachmentId/download": {
        targets: [
            "app"
        ],
        permission: {}
    },
    "POST /api/ship": {
        targets: [
            "app"
        ],
        permission: {
            session: true
        }
    },
    "POST /api/ship/reset/cloud": {
        targets: [
            "app"
        ],
        permission: {
            session: true
        }
    },
    "POST /api/ship/reset/local": {
        targets: [
            "app"
        ],
        permission: {
            session: true
        }
    },
    "POST /api/ship/start": {
        targets: [
            "app"
        ],
        permission: {}
    },
    "POST /api/ships": {
        targets: [
            "server"
        ],
        permission: {
            session: true
        }
    },
    "POST /api/ships/:shipId/import": {
        targets: [
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "POST /api/ships/:shipId/local": {
        targets: [
            "app"
        ],
        permission: {
            session: true
        }
    },
    "POST /api/ships/:shipId/local/handoff": {
        targets: [
            "app"
        ],
        permission: {
            session: true
        }
    },
    "PUT /api/ships/:shipId": {
        targets: [
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    }
};
class $0e416c62c0063d32$export$eb8488c4912a1dad {
    constructor(client){
        this.client = client;
        this.ships = {
            disconnectCompanion: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "DELETE /api/ships/:shipId/companions/:companionId", $0e416c62c0063d32$export$8293355b0d8c54d1["DELETE /api/ships/:shipId/companions/:companionId"].targets);
                        return this.client.call("DELETE /api/ships/:shipId/companions/:companionId", a);
                    },
                    url: ()=>this.client.url("DELETE /api/ships/:shipId/companions/:companionId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                }),
            deleteImport: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "DELETE /api/ships/:shipId/import", $0e416c62c0063d32$export$8293355b0d8c54d1["DELETE /api/ships/:shipId/import"].targets);
                        return this.client.call("DELETE /api/ships/:shipId/import", a);
                    },
                    url: ()=>this.client.url("DELETE /api/ships/:shipId/import", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                }),
            disconnectLocal: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "DELETE /api/ships/:shipId/local", $0e416c62c0063d32$export$8293355b0d8c54d1["DELETE /api/ships/:shipId/local"].targets);
                        return this.client.call("DELETE /api/ships/:shipId/local", a);
                    },
                    url: ()=>this.client.url("DELETE /api/ships/:shipId/local", a),
                    available: (user)=>user != null
                }),
            companion: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ship/companion", $0e416c62c0063d32$export$8293355b0d8c54d1["GET /api/ship/companion"].targets);
                        return this.client.call("GET /api/ship/companion", a);
                    },
                    url: ()=>this.client.url("GET /api/ship/companion", a),
                    available: (_user)=>true
                }),
            resyncStatus: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ship/resync/status", $0e416c62c0063d32$export$8293355b0d8c54d1["GET /api/ship/resync/status"].targets);
                        return this.client.call("GET /api/ship/resync/status", a);
                    },
                    url: ()=>this.client.url("GET /api/ship/resync/status", a),
                    available: (user)=>user != null
                }),
            list: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships", $0e416c62c0063d32$export$8293355b0d8c54d1["GET /api/ships"].targets);
                        return this.client.call("GET /api/ships", a);
                    },
                    url: ()=>this.client.url("GET /api/ships", a),
                    available: (user)=>user != null
                }),
            get: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId", $0e416c62c0063d32$export$8293355b0d8c54d1["GET /api/ships/:shipId"].targets);
                        return this.client.call("GET /api/ships/:shipId", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent;
                    }
                }),
            attachments: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/attachments", $0e416c62c0063d32$export$8293355b0d8c54d1["GET /api/ships/:shipId/attachments"].targets);
                        return this.client.call("GET /api/ships/:shipId/attachments", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/attachments", a),
                    available: (user)=>user != null
                }),
            autocomplete: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/autocomplete/:field", $0e416c62c0063d32$export$8293355b0d8c54d1["GET /api/ships/:shipId/autocomplete/:field"].targets);
                        return this.client.call("GET /api/ships/:shipId/autocomplete/:field", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/autocomplete/:field", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent;
                    }
                }),
            companions: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/companions", $0e416c62c0063d32$export$8293355b0d8c54d1["GET /api/ships/:shipId/companions"].targets);
                        return this.client.call("GET /api/ships/:shipId/companions", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/companions", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                }),
            resolveLocal: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/local/resolve", $0e416c62c0063d32$export$8293355b0d8c54d1["GET /api/ships/:shipId/local/resolve"].targets);
                        return this.client.call("GET /api/ships/:shipId/local/resolve", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/local/resolve", a),
                    available: (user)=>user != null
                }),
            local: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/local", $0e416c62c0063d32$export$8293355b0d8c54d1["GET /api/ships/local"].targets);
                        return this.client.call("GET /api/ships/local", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/local", a),
                    available: (user)=>user != null
                }),
            attachmentDownload: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /ships/:shipId/attachments/:attachmentId/download", $0e416c62c0063d32$export$8293355b0d8c54d1["GET /ships/:shipId/attachments/:attachmentId/download"].targets);
                        return this.client.call("GET /ships/:shipId/attachments/:attachmentId/download", a);
                    },
                    url: ()=>this.client.url("GET /ships/:shipId/attachments/:attachmentId/download", a),
                    available: (_user)=>true
                }),
            selectApp: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship", $0e416c62c0063d32$export$8293355b0d8c54d1["POST /api/ship"].targets);
                        return this.client.call("POST /api/ship", a);
                    },
                    url: ()=>this.client.url("POST /api/ship", a),
                    available: (user)=>user != null
                }),
            resetCloud: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/reset/cloud", $0e416c62c0063d32$export$8293355b0d8c54d1["POST /api/ship/reset/cloud"].targets);
                        return this.client.call("POST /api/ship/reset/cloud", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/reset/cloud", a),
                    available: (user)=>user != null
                }),
            resetLocal: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/reset/local", $0e416c62c0063d32$export$8293355b0d8c54d1["POST /api/ship/reset/local"].targets);
                        return this.client.call("POST /api/ship/reset/local", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/reset/local", a),
                    available: (user)=>user != null
                }),
            start: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/start", $0e416c62c0063d32$export$8293355b0d8c54d1["POST /api/ship/start"].targets);
                        return this.client.call("POST /api/ship/start", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/start", a),
                    available: (_user)=>true
                }),
            create: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ships", $0e416c62c0063d32$export$8293355b0d8c54d1["POST /api/ships"].targets);
                        return this.client.call("POST /api/ships", a);
                    },
                    url: ()=>this.client.url("POST /api/ships", a),
                    available: (user)=>user != null
                }),
            import: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ships/:shipId/import", $0e416c62c0063d32$export$8293355b0d8c54d1["POST /api/ships/:shipId/import"].targets);
                        return this.client.call("POST /api/ships/:shipId/import", a);
                    },
                    url: ()=>this.client.url("POST /api/ships/:shipId/import", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                }),
            connectLocal: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ships/:shipId/local", $0e416c62c0063d32$export$8293355b0d8c54d1["POST /api/ships/:shipId/local"].targets);
                        return this.client.call("POST /api/ships/:shipId/local", a);
                    },
                    url: ()=>this.client.url("POST /api/ships/:shipId/local", a),
                    available: (user)=>user != null
                }),
            prepareHandoff: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ships/:shipId/local/handoff", $0e416c62c0063d32$export$8293355b0d8c54d1["POST /api/ships/:shipId/local/handoff"].targets);
                        return this.client.call("POST /api/ships/:shipId/local/handoff", a);
                    },
                    url: ()=>this.client.url("POST /api/ships/:shipId/local/handoff", a),
                    available: (user)=>user != null
                }),
            select: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId", $0e416c62c0063d32$export$8293355b0d8c54d1["PUT /api/ships/:shipId"].targets);
                        return this.client.call("PUT /api/ships/:shipId", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/UserApi.swift - DO NOT EDIT


const $3901b1e83708ce40$export$be4bb3563942abd6 = {
    "DELETE /api/ships/:shipId/users/:userId": {
        targets: [
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "GET /api/ships/invitation/:token": {
        targets: [
            "server"
        ],
        permission: {}
    },
    "POST /api/ships/:shipId/users": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "POST /api/ships/invitation/:token": {
        targets: [
            "server"
        ],
        permission: {
            session: true
        }
    },
    "PUT /api/ships/:shipId/users/:userId": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    }
};
class $3901b1e83708ce40$export$2a63ac7615f78125 {
    constructor(client){
        this.client = client;
        this.shipUsers = {
            delete: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "DELETE /api/ships/:shipId/users/:userId", $3901b1e83708ce40$export$be4bb3563942abd6["DELETE /api/ships/:shipId/users/:userId"].targets);
                        return this.client.call("DELETE /api/ships/:shipId/users/:userId", a);
                    },
                    url: ()=>this.client.url("DELETE /api/ships/:shipId/users/:userId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                }),
            invitation: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/invitation/:token", $3901b1e83708ce40$export$be4bb3563942abd6["GET /api/ships/invitation/:token"].targets);
                        return this.client.call("GET /api/ships/invitation/:token", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/invitation/:token", a),
                    available: (_user)=>true
                }),
            create: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ships/:shipId/users", $3901b1e83708ce40$export$be4bb3563942abd6["POST /api/ships/:shipId/users"].targets);
                        return this.client.call("POST /api/ships/:shipId/users", a);
                    },
                    url: ()=>this.client.url("POST /api/ships/:shipId/users", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                }),
            acceptInvitation: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ships/invitation/:token", $3901b1e83708ce40$export$be4bb3563942abd6["POST /api/ships/invitation/:token"].targets);
                        return this.client.call("POST /api/ships/invitation/:token", a);
                    },
                    url: ()=>this.client.url("POST /api/ships/invitation/:token", a),
                    available: (user)=>user != null
                }),
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/users/:userId", $3901b1e83708ce40$export$be4bb3563942abd6["PUT /api/ships/:shipId/users/:userId"].targets);
                        return this.client.call("PUT /api/ships/:shipId/users/:userId", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/users/:userId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/AccountApi.swift - DO NOT EDIT


const $dc589cd4dc573fd3$export$7874c0753e1fe90f = {
    "DELETE /api/account": {
        targets: [
            "server"
        ],
        permission: {
            account: (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin
        }
    },
    "DELETE /api/account/users/:userId": {
        targets: [
            "server"
        ],
        permission: {
            account: (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin
        }
    },
    "GET /api/account/plan": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            account: (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).user
        }
    },
    "GET /api/account/plans": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            session: true
        }
    },
    "GET /api/account/users": {
        targets: [
            "server"
        ],
        permission: {
            account: (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin
        }
    },
    "GET /api/signup/invitation/:token": {
        targets: [
            "server"
        ],
        permission: {}
    },
    "POST /api/account": {
        targets: [
            "server"
        ],
        permission: {}
    },
    "POST /api/search": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            account: (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).user
        }
    },
    "POST /api/signup/confirm-email/:token": {
        targets: [
            "server"
        ],
        permission: {}
    },
    "POST /api/signup/invitation/:token": {
        targets: [
            "server"
        ],
        permission: {}
    },
    "PUT /api/account/user": {
        targets: [
            "server"
        ],
        permission: {
            session: true
        }
    },
    "PUT /api/account/user/language": {
        targets: [
            "server"
        ],
        permission: {
            session: true
        }
    },
    "PUT /api/account/user/password": {
        targets: [
            "server"
        ],
        permission: {
            session: true
        }
    },
    "PUT /api/account/users/:userId": {
        targets: [
            "server"
        ],
        permission: {
            account: (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin
        }
    }
};
class $dc589cd4dc573fd3$export$eb6287b13c4e068b {
    constructor(client){
        this.client = client;
        this.account = {
            delete: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "DELETE /api/account", $dc589cd4dc573fd3$export$7874c0753e1fe90f["DELETE /api/account"].targets);
                        return this.client.call("DELETE /api/account", a);
                    },
                    url: ()=>this.client.url("DELETE /api/account", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.accountLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin;
                    }
                }),
            removeUser: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "DELETE /api/account/users/:userId", $dc589cd4dc573fd3$export$7874c0753e1fe90f["DELETE /api/account/users/:userId"].targets);
                        return this.client.call("DELETE /api/account/users/:userId", a);
                    },
                    url: ()=>this.client.url("DELETE /api/account/users/:userId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.accountLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin;
                    }
                }),
            plan: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/account/plan", $dc589cd4dc573fd3$export$7874c0753e1fe90f["GET /api/account/plan"].targets);
                        return this.client.call("GET /api/account/plan", a);
                    },
                    url: ()=>this.client.url("GET /api/account/plan", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.accountLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).user;
                    }
                }),
            plans: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/account/plans", $dc589cd4dc573fd3$export$7874c0753e1fe90f["GET /api/account/plans"].targets);
                        return this.client.call("GET /api/account/plans", a);
                    },
                    url: ()=>this.client.url("GET /api/account/plans", a),
                    available: (user)=>user != null
                }),
            users: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/account/users", $dc589cd4dc573fd3$export$7874c0753e1fe90f["GET /api/account/users"].targets);
                        return this.client.call("GET /api/account/users", a);
                    },
                    url: ()=>this.client.url("GET /api/account/users", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.accountLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin;
                    }
                }),
            create: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/account", $dc589cd4dc573fd3$export$7874c0753e1fe90f["POST /api/account"].targets);
                        return this.client.call("POST /api/account", a);
                    },
                    url: ()=>this.client.url("POST /api/account", a),
                    available: (_user)=>true
                }),
            search: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/search", $dc589cd4dc573fd3$export$7874c0753e1fe90f["POST /api/search"].targets);
                        return this.client.call("POST /api/search", a);
                    },
                    url: ()=>this.client.url("POST /api/search", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.accountLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).user;
                    }
                }),
            updateUser: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/account/user", $dc589cd4dc573fd3$export$7874c0753e1fe90f["PUT /api/account/user"].targets);
                        return this.client.call("PUT /api/account/user", a);
                    },
                    url: ()=>this.client.url("PUT /api/account/user", a),
                    available: (user)=>user != null
                }),
            updateLanguage: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/account/user/language", $dc589cd4dc573fd3$export$7874c0753e1fe90f["PUT /api/account/user/language"].targets);
                        return this.client.call("PUT /api/account/user/language", a);
                    },
                    url: ()=>this.client.url("PUT /api/account/user/language", a),
                    available: (user)=>user != null
                }),
            updatePassword: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/account/user/password", $dc589cd4dc573fd3$export$7874c0753e1fe90f["PUT /api/account/user/password"].targets);
                        return this.client.call("PUT /api/account/user/password", a);
                    },
                    url: ()=>this.client.url("PUT /api/account/user/password", a),
                    available: (user)=>user != null
                }),
            updateUserLevel: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/account/users/:userId", $dc589cd4dc573fd3$export$7874c0753e1fe90f["PUT /api/account/users/:userId"].targets);
                        return this.client.call("PUT /api/account/users/:userId", a);
                    },
                    url: ()=>this.client.url("PUT /api/account/users/:userId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.accountLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin;
                    }
                })
        };
        this.signup = {
            invitation: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/signup/invitation/:token", $dc589cd4dc573fd3$export$7874c0753e1fe90f["GET /api/signup/invitation/:token"].targets);
                        return this.client.call("GET /api/signup/invitation/:token", a);
                    },
                    url: ()=>this.client.url("GET /api/signup/invitation/:token", a),
                    available: (_user)=>true
                }),
            confirmEmail: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/signup/confirm-email/:token", $dc589cd4dc573fd3$export$7874c0753e1fe90f["POST /api/signup/confirm-email/:token"].targets);
                        return this.client.call("POST /api/signup/confirm-email/:token", a);
                    },
                    url: ()=>this.client.url("POST /api/signup/confirm-email/:token", a),
                    available: (_user)=>true
                }),
            acceptInvitation: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/signup/invitation/:token", $dc589cd4dc573fd3$export$7874c0753e1fe90f["POST /api/signup/invitation/:token"].targets);
                        return this.client.call("POST /api/signup/invitation/:token", a);
                    },
                    url: ()=>this.client.url("POST /api/signup/invitation/:token", a),
                    available: (_user)=>true
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/NMEAApi - DO NOT EDIT


const $ae9d2fa06c9a6333$export$8a22b60464699e70 = {
    "DELETE /api/nmea": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "DELETE /api/nmea/baro": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "GET /api/nmea": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "POST /api/nmea": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "PUT /api/nmea": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "PUT /api/nmea/baro": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    }
};
class $ae9d2fa06c9a6333$export$a708238267c47186 {
    constructor(client){
        this.client = client;
        this.nmea = {
            disconnect: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "DELETE /api/nmea", $ae9d2fa06c9a6333$export$8a22b60464699e70["DELETE /api/nmea"].targets);
                        return this.client.call("DELETE /api/nmea", a);
                    },
                    url: ()=>this.client.url("DELETE /api/nmea", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                }),
            disableBaro: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "DELETE /api/nmea/baro", $ae9d2fa06c9a6333$export$8a22b60464699e70["DELETE /api/nmea/baro"].targets);
                        return this.client.call("DELETE /api/nmea/baro", a);
                    },
                    url: ()=>this.client.url("DELETE /api/nmea/baro", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                }),
            get: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/nmea", $ae9d2fa06c9a6333$export$8a22b60464699e70["GET /api/nmea"].targets);
                        return this.client.call("GET /api/nmea", a);
                    },
                    url: ()=>this.client.url("GET /api/nmea", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                }),
            connect: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/nmea", $ae9d2fa06c9a6333$export$8a22b60464699e70["POST /api/nmea"].targets);
                        return this.client.call("POST /api/nmea", a);
                    },
                    url: ()=>this.client.url("POST /api/nmea", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                }),
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/nmea", $ae9d2fa06c9a6333$export$8a22b60464699e70["PUT /api/nmea"].targets);
                        return this.client.call("PUT /api/nmea", a);
                    },
                    url: ()=>this.client.url("PUT /api/nmea", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                }),
            enableBaro: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/nmea/baro", $ae9d2fa06c9a6333$export$8a22b60464699e70["PUT /api/nmea/baro"].targets);
                        return this.client.call("PUT /api/nmea/baro", a);
                    },
                    url: ()=>this.client.url("PUT /api/nmea/baro", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/SettingsApi.swift - DO NOT EDIT


const $82aa55b43aca7932$export$c74615d25f919844 = {
    "PUT /api/ships/:shipId/data": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "PUT /api/ships/:shipId/settings": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    }
};
class $82aa55b43aca7932$export$598162aac93aa171 {
    constructor(client){
        this.client = client;
        this.settings = {
            updateData: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/data", $82aa55b43aca7932$export$c74615d25f919844["PUT /api/ships/:shipId/data"].targets);
                        return this.client.call("PUT /api/ships/:shipId/data", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/data", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                }),
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/settings", $82aa55b43aca7932$export$c74615d25f919844["PUT /api/ships/:shipId/settings"].targets);
                        return this.client.call("PUT /api/ships/:shipId/settings", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/settings", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/DayApi.swift - DO NOT EDIT


const $1f13b14b44a36115$export$54d1560ac861af7b = {
    "GET /api/ships/:shipId/trips/:tripId/days": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll
        }
    },
    "POST /api/ships/:shipId/trips/:tripId/days": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "PUT /api/ships/:shipId/days/:dayId": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "PUT /api/ships/:shipId/days/:dayId/calculate": {
        targets: [
            "app"
        ],
        permission: {
            session: true
        }
    }
};
class $1f13b14b44a36115$export$e5256e709c1d1a05 {
    constructor(client){
        this.client = client;
        this.days = {
            list: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/trips/:tripId/days", $1f13b14b44a36115$export$54d1560ac861af7b["GET /api/ships/:shipId/trips/:tripId/days"].targets);
                        return this.client.call("GET /api/ships/:shipId/trips/:tripId/days", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/trips/:tripId/days", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll;
                    }
                }),
            create: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ships/:shipId/trips/:tripId/days", $1f13b14b44a36115$export$54d1560ac861af7b["POST /api/ships/:shipId/trips/:tripId/days"].targets);
                        return this.client.call("POST /api/ships/:shipId/trips/:tripId/days", a);
                    },
                    url: ()=>this.client.url("POST /api/ships/:shipId/trips/:tripId/days", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/days/:dayId", $1f13b14b44a36115$export$54d1560ac861af7b["PUT /api/ships/:shipId/days/:dayId"].targets);
                        return this.client.call("PUT /api/ships/:shipId/days/:dayId", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/days/:dayId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            calculate: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/days/:dayId/calculate", $1f13b14b44a36115$export$54d1560ac861af7b["PUT /api/ships/:shipId/days/:dayId/calculate"].targets);
                        return this.client.call("PUT /api/ships/:shipId/days/:dayId/calculate", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/days/:dayId/calculate", a),
                    available: (user)=>user != null
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/LogApi - DO NOT EDIT


const $199ead3c99f138be$export$de8b794e43cc4d9b = {
    "GET /api/ships/:shipId/days/:dayId/logs": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll
        }
    },
    "PUT /api/ships/:shipId/logs/:logId": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "PUT /api/ships/:shipId/logs/:logId/engine": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "PUT /api/ships/:shipId/logs/:logId/sails": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    }
};
class $199ead3c99f138be$export$89c3ec6dea3c6061 {
    constructor(client){
        this.client = client;
        this.logs = {
            list: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/days/:dayId/logs", $199ead3c99f138be$export$de8b794e43cc4d9b["GET /api/ships/:shipId/days/:dayId/logs"].targets);
                        return this.client.call("GET /api/ships/:shipId/days/:dayId/logs", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/days/:dayId/logs", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll;
                    }
                }),
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/logs/:logId", $199ead3c99f138be$export$de8b794e43cc4d9b["PUT /api/ships/:shipId/logs/:logId"].targets);
                        return this.client.call("PUT /api/ships/:shipId/logs/:logId", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/logs/:logId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            updateEngine: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/logs/:logId/engine", $199ead3c99f138be$export$de8b794e43cc4d9b["PUT /api/ships/:shipId/logs/:logId/engine"].targets);
                        return this.client.call("PUT /api/ships/:shipId/logs/:logId/engine", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/logs/:logId/engine", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            updateSails: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/logs/:logId/sails", $199ead3c99f138be$export$de8b794e43cc4d9b["PUT /api/ships/:shipId/logs/:logId/sails"].targets);
                        return this.client.call("PUT /api/ships/:shipId/logs/:logId/sails", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/logs/:logId/sails", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/TrackApi - DO NOT EDIT


const $655725c259161537$export$4ec5224ebfdb6ab1 = {
    "GET /api/ships/:shipId/cruises/:cruiseId/track": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll
        }
    },
    "GET /api/ships/:shipId/days/:dayId/track": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll
        }
    },
    "GET /api/ships/:shipId/trips/:tripId/track": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll
        }
    }
};
class $655725c259161537$export$2f8f7bdb7e386612 {
    constructor(client){
        this.client = client;
        this.tracks = {
            cruise: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/cruises/:cruiseId/track", $655725c259161537$export$4ec5224ebfdb6ab1["GET /api/ships/:shipId/cruises/:cruiseId/track"].targets);
                        return this.client.call("GET /api/ships/:shipId/cruises/:cruiseId/track", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/cruises/:cruiseId/track", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll;
                    }
                }),
            day: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/days/:dayId/track", $655725c259161537$export$4ec5224ebfdb6ab1["GET /api/ships/:shipId/days/:dayId/track"].targets);
                        return this.client.call("GET /api/ships/:shipId/days/:dayId/track", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/days/:dayId/track", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll;
                    }
                }),
            trip: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ships/:shipId/trips/:tripId/track", $655725c259161537$export$4ec5224ebfdb6ab1["GET /api/ships/:shipId/trips/:tripId/track"].targets);
                        return this.client.call("GET /api/ships/:shipId/trips/:tripId/track", a);
                    },
                    url: ()=>this.client.url("GET /api/ships/:shipId/trips/:tripId/track", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/CurrentLogApi - DO NOT EDIT


const $c6e2761c15be5353$export$c7b105587fc2f7a7 = {
    "GET /api/ship/current": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "GET /api/ship/current/day": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "POST /api/ship/current/engine": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ship/current/engineHint": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ship/current/lighting": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ship/current/log": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ship/current/provisional/cancel": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ship/current/sails": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ship/current/stop": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    }
};
class $c6e2761c15be5353$export$a90af23008f0d8fa {
    constructor(client){
        this.client = client;
        this.current = {
            get: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ship/current", $c6e2761c15be5353$export$c7b105587fc2f7a7["GET /api/ship/current"].targets);
                        return this.client.call("GET /api/ship/current", a);
                    },
                    url: ()=>this.client.url("GET /api/ship/current", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent;
                    }
                }),
            day: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/ship/current/day", $c6e2761c15be5353$export$c7b105587fc2f7a7["GET /api/ship/current/day"].targets);
                        return this.client.call("GET /api/ship/current/day", a);
                    },
                    url: ()=>this.client.url("GET /api/ship/current/day", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent;
                    }
                }),
            engine: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/current/engine", $c6e2761c15be5353$export$c7b105587fc2f7a7["POST /api/ship/current/engine"].targets);
                        return this.client.call("POST /api/ship/current/engine", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/current/engine", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            engineHint: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/current/engineHint", $c6e2761c15be5353$export$c7b105587fc2f7a7["POST /api/ship/current/engineHint"].targets);
                        return this.client.call("POST /api/ship/current/engineHint", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/current/engineHint", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            lighting: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/current/lighting", $c6e2761c15be5353$export$c7b105587fc2f7a7["POST /api/ship/current/lighting"].targets);
                        return this.client.call("POST /api/ship/current/lighting", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/current/lighting", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            log: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/current/log", $c6e2761c15be5353$export$c7b105587fc2f7a7["POST /api/ship/current/log"].targets);
                        return this.client.call("POST /api/ship/current/log", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/current/log", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            cancelProvisional: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/current/provisional/cancel", $c6e2761c15be5353$export$c7b105587fc2f7a7["POST /api/ship/current/provisional/cancel"].targets);
                        return this.client.call("POST /api/ship/current/provisional/cancel", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/current/provisional/cancel", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            sails: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/current/sails", $c6e2761c15be5353$export$c7b105587fc2f7a7["POST /api/ship/current/sails"].targets);
                        return this.client.call("POST /api/ship/current/sails", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/current/sails", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            stop: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/current/stop", $c6e2761c15be5353$export$c7b105587fc2f7a7["POST /api/ship/current/stop"].targets);
                        return this.client.call("POST /api/ship/current/stop", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/current/stop", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/SyncableApi - DO NOT EDIT


const $fcacc2feb92f961f$export$7338a897f65996f9 = {
    "POST /api/sync/retry": {
        targets: [
            "app"
        ],
        permission: {
            session: true
        }
    },
    "PUT /api/sync": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    }
};
class $fcacc2feb92f961f$export$a022e2bb09fa7733 {
    constructor(client){
        this.client = client;
        this.sync = {
            retry: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/sync/retry", $fcacc2feb92f961f$export$7338a897f65996f9["POST /api/sync/retry"].targets);
                        return this.client.call("POST /api/sync/retry", a);
                    },
                    url: ()=>this.client.url("POST /api/sync/retry", a),
                    available: (user)=>user != null
                }),
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/sync", $fcacc2feb92f961f$export$7338a897f65996f9["PUT /api/sync"].targets);
                        return this.client.call("PUT /api/sync", a);
                    },
                    url: ()=>this.client.url("PUT /api/sync", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/NoteApi.swift - DO NOT EDIT


const $5ad0742384a42800$export$d4f31aadb9b8c2da = {
    "DELETE /api/ships/:shipId/notes/:noteId/attachments/:attachmentId": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "GET /ships/:shipId/notes/:noteId/attachments/:attachmentId/download": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "POST /api/ships/:shipId/cruises/:cruiseId/notes": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ships/:shipId/days/:dayId/notes": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ships/:shipId/notes/:noteId/attachment": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "POST /api/ships/:shipId/trips/:tripId/notes": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "PUT /api/ships/:shipId/notes/:noteId": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    }
};
class $5ad0742384a42800$export$5cea990fb3a4e5e9 {
    constructor(client){
        this.client = client;
        this.noteAttachments = {
            delete: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "DELETE /api/ships/:shipId/notes/:noteId/attachments/:attachmentId", $5ad0742384a42800$export$d4f31aadb9b8c2da["DELETE /api/ships/:shipId/notes/:noteId/attachments/:attachmentId"].targets);
                        return this.client.call("DELETE /api/ships/:shipId/notes/:noteId/attachments/:attachmentId", a);
                    },
                    url: ()=>this.client.url("DELETE /api/ships/:shipId/notes/:noteId/attachments/:attachmentId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            download: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /ships/:shipId/notes/:noteId/attachments/:attachmentId/download", $5ad0742384a42800$export$d4f31aadb9b8c2da["GET /ships/:shipId/notes/:noteId/attachments/:attachmentId/download"].targets);
                        return this.client.call("GET /ships/:shipId/notes/:noteId/attachments/:attachmentId/download", a);
                    },
                    url: ()=>this.client.url("GET /ships/:shipId/notes/:noteId/attachments/:attachmentId/download", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent;
                    }
                }),
            create: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ships/:shipId/notes/:noteId/attachment", $5ad0742384a42800$export$d4f31aadb9b8c2da["POST /api/ships/:shipId/notes/:noteId/attachment"].targets);
                        return this.client.call("POST /api/ships/:shipId/notes/:noteId/attachment", a);
                    },
                    url: ()=>this.client.url("POST /api/ships/:shipId/notes/:noteId/attachment", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                })
        };
        this.notes = {
            createForCruise: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ships/:shipId/cruises/:cruiseId/notes", $5ad0742384a42800$export$d4f31aadb9b8c2da["POST /api/ships/:shipId/cruises/:cruiseId/notes"].targets);
                        return this.client.call("POST /api/ships/:shipId/cruises/:cruiseId/notes", a);
                    },
                    url: ()=>this.client.url("POST /api/ships/:shipId/cruises/:cruiseId/notes", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            createForDay: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ships/:shipId/days/:dayId/notes", $5ad0742384a42800$export$d4f31aadb9b8c2da["POST /api/ships/:shipId/days/:dayId/notes"].targets);
                        return this.client.call("POST /api/ships/:shipId/days/:dayId/notes", a);
                    },
                    url: ()=>this.client.url("POST /api/ships/:shipId/days/:dayId/notes", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            createForTrip: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ships/:shipId/trips/:tripId/notes", $5ad0742384a42800$export$d4f31aadb9b8c2da["POST /api/ships/:shipId/trips/:tripId/notes"].targets);
                        return this.client.call("POST /api/ships/:shipId/trips/:tripId/notes", a);
                    },
                    url: ()=>this.client.url("POST /api/ships/:shipId/trips/:tripId/notes", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                }),
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ships/:shipId/notes/:noteId", $5ad0742384a42800$export$d4f31aadb9b8c2da["PUT /api/ships/:shipId/notes/:noteId"].targets);
                        return this.client.call("PUT /api/ships/:shipId/notes/:noteId", a);
                    },
                    url: ()=>this.client.url("PUT /api/ships/:shipId/notes/:noteId", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel(a.params.shipId)) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/DeviceDebugTraceApi - DO NOT EDIT


const $8c52e5243d6ffa2a$export$c4ee1631138a6a4c = {
    "POST /api/debug/database": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "POST /api/debug/log": {
        targets: [
            "app"
        ],
        permission: {}
    },
    "POST /api/debug/nmea": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "POST /api/debug/upload": {
        targets: [
            "app"
        ],
        permission: {}
    }
};
class $8c52e5243d6ffa2a$export$6f8605d66cd2f9d5 {
    constructor(client){
        this.client = client;
        this.debugDatabase = {
            upload: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/debug/database", $8c52e5243d6ffa2a$export$c4ee1631138a6a4c["POST /api/debug/database"].targets);
                        return this.client.call("POST /api/debug/database", a);
                    },
                    url: ()=>this.client.url("POST /api/debug/database", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent;
                    }
                })
        };
        this.debugLog = {
            upload: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/debug/log", $8c52e5243d6ffa2a$export$c4ee1631138a6a4c["POST /api/debug/log"].targets);
                        return this.client.call("POST /api/debug/log", a);
                    },
                    url: ()=>this.client.url("POST /api/debug/log", a),
                    available: (_user)=>true
                })
        };
        this.debugNmea = {
            upload: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/debug/nmea", $8c52e5243d6ffa2a$export$c4ee1631138a6a4c["POST /api/debug/nmea"].targets);
                        return this.client.call("POST /api/debug/nmea", a);
                    },
                    url: ()=>this.client.url("POST /api/debug/nmea", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary;
                    }
                })
        };
        this.debugUpload = {
            upload: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/debug/upload", $8c52e5243d6ffa2a$export$c4ee1631138a6a4c["POST /api/debug/upload"].targets);
                        return this.client.call("POST /api/debug/upload", a);
                    },
                    url: ()=>this.client.url("POST /api/debug/upload", a),
                    available: (_user)=>true
                })
        };
    }
}


// @generated by TypeGen from LogbookApp/DeviceDebugTraceApi.swift - DO NOT EDIT

var $d2421efc1f8d10b6$export$9a1863151e19d74d;
(function(IDebugDatabaseKind) {
    IDebugDatabaseKind["ship"] = "ship";
    IDebugDatabaseKind["app"] = "app";
})($d2421efc1f8d10b6$export$9a1863151e19d74d || ($d2421efc1f8d10b6$export$9a1863151e19d74d = {}));
const $d2421efc1f8d10b6$export$245a65b2643c82e9 = {
    "POST /api/debug/database": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "POST /api/debug/log": {
        permission: {}
    },
    "POST /api/debug/nmea": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary
        }
    },
    "POST /api/debug/upload": {
        permission: {}
    }
};


// @generated by TypeGen from LogbookApi/Session.swift - DO NOT EDIT

const $6e7887a8bef248ec$export$17bcaaf3434f61ce = {
    "DELETE /api/session": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            session: true
        }
    },
    "GET /api/session": {
        targets: [
            "app",
            "server"
        ],
        permission: {}
    },
    "POST /api/session": {
        targets: [
            "app",
            "server"
        ],
        permission: {}
    },
    "POST /api/session/exchange": {
        targets: [
            "app",
            "server"
        ],
        permission: {}
    },
    "POST /api/session/handoff": {
        targets: [
            "app",
            "server"
        ],
        permission: {
            session: true
        }
    },
    "POST /api/session/reset": {
        targets: [
            "server"
        ],
        permission: {}
    },
    "POST /api/session/restore": {
        targets: [
            "app"
        ],
        permission: {}
    },
    "PUT /api/session/reset/:token": {
        targets: [
            "server"
        ],
        permission: {}
    }
};
class $6e7887a8bef248ec$export$1fb4852a55678982 {
    constructor(client){
        this.client = client;
        this.session = {
            delete: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "DELETE /api/session", $6e7887a8bef248ec$export$17bcaaf3434f61ce["DELETE /api/session"].targets);
                        return this.client.call("DELETE /api/session", a);
                    },
                    url: ()=>this.client.url("DELETE /api/session", a),
                    available: (user)=>user != null
                }),
            get: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/session", $6e7887a8bef248ec$export$17bcaaf3434f61ce["GET /api/session"].targets);
                        return this.client.call("GET /api/session", a);
                    },
                    url: ()=>this.client.url("GET /api/session", a),
                    available: (_user)=>true
                }),
            create: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/session", $6e7887a8bef248ec$export$17bcaaf3434f61ce["POST /api/session"].targets);
                        return this.client.call("POST /api/session", a);
                    },
                    url: ()=>this.client.url("POST /api/session", a),
                    available: (_user)=>true
                }),
            exchange: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/session/exchange", $6e7887a8bef248ec$export$17bcaaf3434f61ce["POST /api/session/exchange"].targets);
                        return this.client.call("POST /api/session/exchange", a);
                    },
                    url: ()=>this.client.url("POST /api/session/exchange", a),
                    available: (_user)=>true
                }),
            handoff: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/session/handoff", $6e7887a8bef248ec$export$17bcaaf3434f61ce["POST /api/session/handoff"].targets);
                        return this.client.call("POST /api/session/handoff", a);
                    },
                    url: ()=>this.client.url("POST /api/session/handoff", a),
                    available: (user)=>user != null
                }),
            forgotPassword: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/session/reset", $6e7887a8bef248ec$export$17bcaaf3434f61ce["POST /api/session/reset"].targets);
                        return this.client.call("POST /api/session/reset", a);
                    },
                    url: ()=>this.client.url("POST /api/session/reset", a),
                    available: (_user)=>true
                }),
            restore: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/session/restore", $6e7887a8bef248ec$export$17bcaaf3434f61ce["POST /api/session/restore"].targets);
                        return this.client.call("POST /api/session/restore", a);
                    },
                    url: ()=>this.client.url("POST /api/session/restore", a),
                    available: (_user)=>true
                }),
            resetPassword: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/session/reset/:token", $6e7887a8bef248ec$export$17bcaaf3434f61ce["PUT /api/session/reset/:token"].targets);
                        return this.client.call("PUT /api/session/reset/:token", a);
                    },
                    url: ()=>this.client.url("PUT /api/session/reset/:token", a),
                    available: (_user)=>true
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/Stripe - DO NOT EDIT

const $746245e03b78b773$export$14e1ec05a6d6c856 = {
    "POST /api/account/checkout": {
        targets: [
            "server"
        ],
        permission: {
            session: true
        }
    },
    "POST /api/account/checkout/complete/:sessionId": {
        targets: [
            "server"
        ],
        permission: {
            session: true
        }
    },
    "PUT /api/account/plan": {
        targets: [
            "server"
        ],
        permission: {
            session: true
        }
    }
};
class $746245e03b78b773$export$3c7919ca4c48cda4 {
    constructor(client){
        this.client = client;
        this.account = {
            checkout: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/account/checkout", $746245e03b78b773$export$14e1ec05a6d6c856["POST /api/account/checkout"].targets);
                        return this.client.call("POST /api/account/checkout", a);
                    },
                    url: ()=>this.client.url("POST /api/account/checkout", a),
                    available: (user)=>user != null
                }),
            checkoutComplete: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/account/checkout/complete/:sessionId", $746245e03b78b773$export$14e1ec05a6d6c856["POST /api/account/checkout/complete/:sessionId"].targets);
                        return this.client.call("POST /api/account/checkout/complete/:sessionId", a);
                    },
                    url: ()=>this.client.url("POST /api/account/checkout/complete/:sessionId", a),
                    available: (user)=>user != null
                }),
            updatePlan: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/account/plan", $746245e03b78b773$export$14e1ec05a6d6c856["PUT /api/account/plan"].targets);
                        return this.client.call("PUT /api/account/plan", a);
                    },
                    url: ()=>this.client.url("PUT /api/account/plan", a),
                    available: (user)=>user != null
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/Routes - DO NOT EDIT

const $5094ab6cf9038f1f$export$e1f0d30774c04247 = {
    "GET /api/release": {
        targets: [
            "app"
        ],
        permission: {}
    },
    "GET /api/server": {
        targets: [
            "app"
        ],
        permission: {}
    },
    "GET /api/status": {
        targets: [
            "app"
        ],
        permission: {}
    },
    "POST /api/reset": {
        targets: [
            "app"
        ],
        permission: {}
    }
};
class $5094ab6cf9038f1f$export$3565eb3d00ca5a74 {
    constructor(client){
        this.client = client;
        this.release = {
            get: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/release", $5094ab6cf9038f1f$export$e1f0d30774c04247["GET /api/release"].targets);
                        return this.client.call("GET /api/release", a);
                    },
                    url: ()=>this.client.url("GET /api/release", a),
                    available: (_user)=>true
                })
        };
        this.server = {
            get: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/server", $5094ab6cf9038f1f$export$e1f0d30774c04247["GET /api/server"].targets);
                        return this.client.call("GET /api/server", a);
                    },
                    url: ()=>this.client.url("GET /api/server", a),
                    available: (_user)=>true
                })
        };
        this.status = {
            get: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "GET /api/status", $5094ab6cf9038f1f$export$e1f0d30774c04247["GET /api/status"].targets);
                        return this.client.call("GET /api/status", a);
                    },
                    url: ()=>this.client.url("GET /api/status", a),
                    available: (_user)=>true
                })
        };
        this.app = {
            reset: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/reset", $5094ab6cf9038f1f$export$e1f0d30774c04247["POST /api/reset"].targets);
                        return this.client.call("POST /api/reset", a);
                    },
                    url: ()=>this.client.url("POST /api/reset", a),
                    available: (_user)=>true
                })
        };
    }
}


// @generated by TypeGen from LogbookApp/CurrentLogApi.swift - DO NOT EDIT

var $fdf69f1b178295ac$export$a06f4ac7b989b94c;
(function(ICreateStatus) {
    ICreateStatus["allowed"] = "allowed";
    ICreateStatus["deniedInMotion"] = "deniedInMotion";
    ICreateStatus["deniedBlankExists"] = "deniedBlankExists";
})($fdf69f1b178295ac$export$a06f4ac7b989b94c || ($fdf69f1b178295ac$export$a06f4ac7b989b94c = {}));
const $fdf69f1b178295ac$export$5e011c317e92ef36 = {
    "GET /api/ship/current": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "GET /api/ship/current/day": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "POST /api/ship/current/engine": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ship/current/engineHint": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ship/current/lighting": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ship/current/log": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ship/current/provisional/cancel": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ship/current/sails": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    },
    "POST /api/ship/current/stop": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    }
};


// @generated by TypeGen from LogbookApp/EngineMissingApi.swift - DO NOT EDIT
var $00a37f738d2ad7ac$export$9bea942779b9814b;
(function(IEngineHintAnswer) {
    IEngineHintAnswer["started"] = "started";
    IEngineHintAnswer["sailing"] = "sailing";
})($00a37f738d2ad7ac$export$9bea942779b9814b || ($00a37f738d2ad7ac$export$9bea942779b9814b = {}));
var $00a37f738d2ad7ac$export$113f730d88151ffc;
(function(IEngineHintSince) {
    IEngineHintSince["trigger"] = "trigger";
    IEngineHintSince["now"] = "now";
})($00a37f738d2ad7ac$export$113f730d88151ffc || ($00a37f738d2ad7ac$export$113f730d88151ffc = {}));


// @generated by TypeGen from LogbookModel/Settings/SailGroup.swift - DO NOT EDIT
var $f07dcbbb3dc0e21a$export$856d661fe7159535;
(function(ISailGroup) {
    ISailGroup["main"] = "main";
    ISailGroup["foresail"] = "foresail";
    ISailGroup["spinnaker"] = "spinnaker";
    ISailGroup["mizzen"] = "mizzen";
})($f07dcbbb3dc0e21a$export$856d661fe7159535 || ($f07dcbbb3dc0e21a$export$856d661fe7159535 = {}));
var $f07dcbbb3dc0e21a$export$4fa0525679448902;
(function(ISailName) {
    ISailName["mainsail"] = "mainsail";
    ISailName["genoa"] = "genoa";
    ISailName["jib"] = "jib";
    ISailName["workingJib"] = "working_jib";
    ISailName["stromJib"] = "strom_jib";
    ISailName["spinnaker"] = "spinnaker";
    ISailName["gennaker"] = "gennaker";
    ISailName["code0"] = "code0";
    ISailName["parasailor"] = "parasailor";
    ISailName["mizzen"] = "mizzen";
    ISailName["mizzenStaysail"] = "mizzen_staysail";
    ISailName["trysail"] = "try";
})($f07dcbbb3dc0e21a$export$4fa0525679448902 || ($f07dcbbb3dc0e21a$export$4fa0525679448902 = {}));
var $f07dcbbb3dc0e21a$export$6451a41b34444a54;
(function(ISailType) {
    ISailType["forestay"] = "forestay";
    ISailType["mast"] = "mast";
    ISailType["mizzen"] = "mizzen";
})($f07dcbbb3dc0e21a$export$6451a41b34444a54 || ($f07dcbbb3dc0e21a$export$6451a41b34444a54 = {}));


// @generated by TypeGen from LogbookModel/Day.swift - DO NOT EDIT
const $50f4daf09d2513a4$export$7a9a31a911eb9a20 = {
    parse (r) {
        return Object.assign(Object.assign({}, r), {
            dataParsed: r.data != null ? JSON.parse(r.data) : {}
        });
    }
};


// @generated by TypeGen from LogbookModel/DataRecord.swift - DO NOT EDIT
var $baa0a7d3b8a147b0$export$32931d5e5df2499a;
(function(IDataRecordCategory) {
    IDataRecordCategory["test"] = "test";
    IDataRecordCategory["generator"] = "generator";
    IDataRecordCategory["dataTransition"] = "dataTransition";
})($baa0a7d3b8a147b0$export$32931d5e5df2499a || ($baa0a7d3b8a147b0$export$32931d5e5df2499a = {}));
var $baa0a7d3b8a147b0$export$aafba9e363be7407;
(function(IDataRecordSource) {
    IDataRecordSource[IDataRecordSource["manual"] = 1] = "manual";
    IDataRecordSource[IDataRecordSource["n2k"] = 2] = "n2k";
    IDataRecordSource[IDataRecordSource["imported"] = 3] = "imported";
    IDataRecordSource[IDataRecordSource["simulator"] = 4] = "simulator";
})($baa0a7d3b8a147b0$export$aafba9e363be7407 || ($baa0a7d3b8a147b0$export$aafba9e363be7407 = {}));
var $baa0a7d3b8a147b0$export$777bcf2989ecc4e7;
(function(IDataRecordType) {
    IDataRecordType["state"] = "state";
    IDataRecordType["reading"] = "reading";
})($baa0a7d3b8a147b0$export$777bcf2989ecc4e7 || ($baa0a7d3b8a147b0$export$777bcf2989ecc4e7 = {}));


// @generated by TypeGen from LogbookModel/Generator/GeneratorRunStatus.swift - DO NOT EDIT
var $8e1217d38d458c2d$export$618db430c77c2d4b;
(function(IGeneratorRawState) {
    IGeneratorRawState[IGeneratorRawState["preheating"] = 0] = "preheating";
    IGeneratorRawState[IGeneratorRawState["startDelay"] = 1] = "startDelay";
    IGeneratorRawState[IGeneratorRawState["cranking"] = 2] = "cranking";
    IGeneratorRawState[IGeneratorRawState["starterCooling"] = 3] = "starterCooling";
    IGeneratorRawState[IGeneratorRawState["warmingUp"] = 4] = "warmingUp";
    IGeneratorRawState[IGeneratorRawState["coolingDown"] = 5] = "coolingDown";
    IGeneratorRawState[IGeneratorRawState["spinningUp"] = 6] = "spinningUp";
    IGeneratorRawState[IGeneratorRawState["shutdownBypass"] = 7] = "shutdownBypass";
    IGeneratorRawState[IGeneratorRawState["stopping"] = 8] = "stopping";
    IGeneratorRawState[IGeneratorRawState["running"] = 9] = "running";
    IGeneratorRawState[IGeneratorRawState["stopped"] = 10] = "stopped";
    IGeneratorRawState[IGeneratorRawState["crankDelay"] = 11] = "crankDelay";
})($8e1217d38d458c2d$export$618db430c77c2d4b || ($8e1217d38d458c2d$export$618db430c77c2d4b = {}));
var $8e1217d38d458c2d$export$709312b2c55da786;
(function(IGeneratorRunState) {
    IGeneratorRunState["off"] = "off";
    IGeneratorRunState["starting"] = "starting";
    IGeneratorRunState["running"] = "running";
    IGeneratorRunState["stopping"] = "stopping";
})($8e1217d38d458c2d$export$709312b2c55da786 || ($8e1217d38d458c2d$export$709312b2c55da786 = {}));
var $8e1217d38d458c2d$export$c7f8b0af884c4c2;
(function(IGeneratorStatus) {
    IGeneratorStatus[IGeneratorStatus["off"] = 0] = "off";
    IGeneratorStatus[IGeneratorStatus["starting"] = 1] = "starting";
    IGeneratorStatus[IGeneratorStatus["running"] = 2] = "running";
    IGeneratorStatus[IGeneratorStatus["stopping"] = 3] = "stopping";
})($8e1217d38d458c2d$export$c7f8b0af884c4c2 || ($8e1217d38d458c2d$export$c7f8b0af884c4c2 = {}));


// @generated by TypeGen from LogbookModel/Day/DayWatch.swift - DO NOT EDIT
var $4ccb8ce47c65bb30$export$6e6224a0a88eefa2;
(function(IDayWatchType) {
    IDayWatchType["manual"] = "manual";
})($4ccb8ce47c65bb30$export$6e6224a0a88eefa2 || ($4ccb8ce47c65bb30$export$6e6224a0a88eefa2 = {}));


// @generated by TypeGen from LogbookModel/Device.swift - DO NOT EDIT
var $a305f23d74ba2477$export$1bb716a75f36d7d7;
(function(IDeviceOS) {
    IDeviceOS["macOS"] = "macOS";
    IDeviceOS["windows"] = "windows";
    IDeviceOS["iOS"] = "iOS";
    IDeviceOS["iPadOS"] = "iPadOS";
    IDeviceOS["androidTablet"] = "androidTablet";
    IDeviceOS["androidPhone"] = "androidPhone";
    IDeviceOS["linux"] = "linux";
    IDeviceOS["logbookBox"] = "logbookBox";
    IDeviceOS["unknown"] = "unknown";
})($a305f23d74ba2477$export$1bb716a75f36d7d7 || ($a305f23d74ba2477$export$1bb716a75f36d7d7 = {}));
var $a305f23d74ba2477$export$2f94d3b57507fc97;
(function(IDeviceType) {
    IDeviceType[IDeviceType["primary"] = 0] = "primary";
    IDeviceType[IDeviceType["pc"] = 1] = "pc";
    IDeviceType[IDeviceType["tablet"] = 2] = "tablet";
    IDeviceType[IDeviceType["mobile"] = 3] = "mobile";
})($a305f23d74ba2477$export$2f94d3b57507fc97 || ($a305f23d74ba2477$export$2f94d3b57507fc97 = {}));


// @generated by TypeGen from LogbookModel/Direction.swift - DO NOT EDIT
var $d65fa70bc7dd0ccc$export$c58ae385f8dc0dfe;
(function(IDirection) {
    IDirection["none"] = "\u00D8";
    IDirection["N"] = "N";
    IDirection["NNE"] = "NNE";
    IDirection["NE"] = "NE";
    IDirection["ENE"] = "ENE";
    IDirection["E"] = "E";
    IDirection["ESE"] = "ESE";
    IDirection["SE"] = "SE";
    IDirection["SSE"] = "SSE";
    IDirection["S"] = "S";
    IDirection["SSW"] = "SSW";
    IDirection["SW"] = "SW";
    IDirection["WSW"] = "WSW";
    IDirection["W"] = "W";
    IDirection["WNW"] = "WNW";
    IDirection["NW"] = "NW";
    IDirection["NNW"] = "NNW";
})($d65fa70bc7dd0ccc$export$c58ae385f8dc0dfe || ($d65fa70bc7dd0ccc$export$c58ae385f8dc0dfe = {}));


// @generated by TypeGen from LogbookModel/Engine.swift - DO NOT EDIT
var $74f14fd1f5a4aba1$export$473ad021744069e1;
(function(IEngineState) {
    IEngineState["running"] = "running";
    IEngineState["started"] = "started";
    IEngineState["stopped"] = "stopped";
})($74f14fd1f5a4aba1$export$473ad021744069e1 || ($74f14fd1f5a4aba1$export$473ad021744069e1 = {}));


// @generated by TypeGen from LogbookModel/Lighting.swift - DO NOT EDIT
var $3bedadb68df9862e$export$966979137e3fd0b5;
(function(ILogLighting) {
    ILogLighting[ILogLighting["none"] = 0] = "none";
    ILogLighting[ILogLighting["triColorLights"] = 1] = "triColorLights";
    ILogLighting[ILogLighting["anchorBall"] = 2] = "anchorBall";
    ILogLighting[ILogLighting["anchorLight"] = 3] = "anchorLight";
    ILogLighting[ILogLighting["sailingRunningLights"] = 4] = "sailingRunningLights";
    ILogLighting[ILogLighting["motoringRunningLights"] = 5] = "motoringRunningLights";
    ILogLighting[ILogLighting["motoringCone"] = 6] = "motoringCone";
})($3bedadb68df9862e$export$966979137e3fd0b5 || ($3bedadb68df9862e$export$966979137e3fd0b5 = {}));
var $3bedadb68df9862e$export$caacc4cb23d7ffa3;
(function(ISailingLightsMode) {
    ISailingLightsMode[ISailingLightsMode["runningLights"] = 0] = "runningLights";
    ISailingLightsMode[ISailingLightsMode["triColor"] = 1] = "triColor";
})($3bedadb68df9862e$export$caacc4cb23d7ffa3 || ($3bedadb68df9862e$export$caacc4cb23d7ffa3 = {}));


// @generated by TypeGen from LogbookModel/Log.swift - DO NOT EDIT
const $1746073b9b284418$export$ce30dbb46644d06c = {
    parse (r) {
        return Object.assign(Object.assign({}, r), {
            dataParsed: r.data != null ? JSON.parse(r.data) : {}
        });
    }
};


// @generated by TypeGen from LogbookModel/Log/LogMetadata.swift - DO NOT EDIT
var $c931aad0bd934103$export$7d62c436da3e5e14;
(function(IEngineMissingReason) {
    IEngineMissingReason["castOff"] = "castOff";
    IEngineMissingReason["anchorUp"] = "anchorUp";
    IEngineMissingReason["motorVessel"] = "motorVessel";
})($c931aad0bd934103$export$7d62c436da3e5e14 || ($c931aad0bd934103$export$7d62c436da3e5e14 = {}));
var $c931aad0bd934103$export$5e38c559d81a2b46;
(function(ILogAlertAction) {
    ILogAlertAction["triggered"] = "triggered";
    ILogAlertAction["escalated"] = "escalated";
    ILogAlertAction["snoozed"] = "snoozed";
    ILogAlertAction["acknowledged"] = "acknowledged";
    ILogAlertAction["cleared"] = "cleared";
    ILogAlertAction["resolved"] = "resolved";
})($c931aad0bd934103$export$5e38c559d81a2b46 || ($c931aad0bd934103$export$5e38c559d81a2b46 = {}));
var $c931aad0bd934103$export$d9de83d1fc77d7c4;
(function(ILogAutoType) {
    ILogAutoType["none"] = "none";
    ILogAutoType["courseChange"] = "courseChange";
    ILogAutoType["engine"] = "engine";
    ILogAutoType["engineRunState"] = "engineRunState";
    ILogAutoType["interval"] = "interval";
    ILogAutoType["monitor"] = "monitor";
    ILogAutoType["navigationStatus"] = "navigationStatus";
    ILogAutoType["nmeaConnection"] = "nmeaConnection";
    ILogAutoType["shipStatus"] = "shipStatus";
    ILogAutoType["stop"] = "stop";
    ILogAutoType["speedChange"] = "speedChange";
    ILogAutoType["lighting"] = "lighting";
    ILogAutoType["propulsion"] = "propulsion";
    ILogAutoType["engineMissing"] = "engineMissing";
    ILogAutoType["dataRecord"] = "dataRecord";
    ILogAutoType["alert"] = "alert";
})($c931aad0bd934103$export$d9de83d1fc77d7c4 || ($c931aad0bd934103$export$d9de83d1fc77d7c4 = {}));
var $c931aad0bd934103$export$da30b091b7382d5a;
(function(ILogChangeAction) {
    ILogChangeAction["add"] = "add";
    ILogChangeAction["remove"] = "remove";
})($c931aad0bd934103$export$da30b091b7382d5a || ($c931aad0bd934103$export$da30b091b7382d5a = {}));
var $c931aad0bd934103$export$a05a8a0b4c257163;
(function(ILogChangeType) {
    ILogChangeType["crew"] = "crew";
    ILogChangeType["passengers"] = "passengers";
    ILogChangeType["skipper"] = "skipper";
})($c931aad0bd934103$export$a05a8a0b4c257163 || ($c931aad0bd934103$export$a05a8a0b4c257163 = {}));
var $c931aad0bd934103$export$d1a2165e37e7311c;
(function(ILogCourseChangePhase) {
    ILogCourseChangePhase["active"] = "active";
    ILogCourseChangePhase["begin"] = "begin";
    ILogCourseChangePhase["end"] = "end";
})($c931aad0bd934103$export$d1a2165e37e7311c || ($c931aad0bd934103$export$d1a2165e37e7311c = {}));
var $c931aad0bd934103$export$c50f5cf960171685;
(function(ILogOnOff) {
    ILogOnOff["on"] = "on";
    ILogOnOff["off"] = "off";
    ILogOnOff["missing"] = "missing";
})($c931aad0bd934103$export$c50f5cf960171685 || ($c931aad0bd934103$export$c50f5cf960171685 = {}));
var $c931aad0bd934103$export$656e514f2ad451fa;
(function(ILogSpeedChange) {
    ILogSpeedChange["start"] = "start";
    ILogSpeedChange["stop"] = "stop";
})($c931aad0bd934103$export$656e514f2ad451fa || ($c931aad0bd934103$export$656e514f2ad451fa = {}));
var $c931aad0bd934103$export$2b2f7f32699a98f9;
(function(ILogStopType) {
    ILogStopType["endOfDay"] = "endOfDay";
    ILogStopType["stopover"] = "stopover";
})($c931aad0bd934103$export$2b2f7f32699a98f9 || ($c931aad0bd934103$export$2b2f7f32699a98f9 = {}));


// @generated by TypeGen from LogbookModel/Status/MonitorStatus.swift - DO NOT EDIT
var $3c48bffca65c360b$export$e31825d410fdad81;
(function(IAnchorWatchMethod) {
    IAnchorWatchMethod["fixedRadius"] = "fixedRadius";
    IAnchorWatchMethod["rodeScope"] = "rodeScope";
    IAnchorWatchMethod["sector"] = "sector";
})($3c48bffca65c360b$export$e31825d410fdad81 || ($3c48bffca65c360b$export$e31825d410fdad81 = {}));
var $3c48bffca65c360b$export$2ff82625ed03cf18;
(function(IMonitorStatusType) {
    IMonitorStatusType[IMonitorStatusType["anchor"] = 1] = "anchor";
    IMonitorStatusType[IMonitorStatusType["depth"] = 2] = "depth";
})($3c48bffca65c360b$export$2ff82625ed03cf18 || ($3c48bffca65c360b$export$2ff82625ed03cf18 = {}));


// @generated by TypeGen from LogbookApi/AlertApi - DO NOT EDIT


const $d4eccb73927932bb$export$8ba8039f5b7f8902 = {
    "POST /api/ship/alert/manOverboard": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "POST /api/ship/alert/message": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "POST /api/ship/alert/receipt/:alertName": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "PUT /api/ship/alert/:alertName": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    }
};
class $d4eccb73927932bb$export$4c70e389659ec851 {
    constructor(client){
        this.client = client;
        this.alert = {
            manOverboard: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/alert/manOverboard", $d4eccb73927932bb$export$8ba8039f5b7f8902["POST /api/ship/alert/manOverboard"].targets);
                        return this.client.call("POST /api/ship/alert/manOverboard", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/alert/manOverboard", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent;
                    }
                }),
            message: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/alert/message", $d4eccb73927932bb$export$8ba8039f5b7f8902["POST /api/ship/alert/message"].targets);
                        return this.client.call("POST /api/ship/alert/message", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/alert/message", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent;
                    }
                }),
            receipt: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "POST /api/ship/alert/receipt/:alertName", $d4eccb73927932bb$export$8ba8039f5b7f8902["POST /api/ship/alert/receipt/:alertName"].targets);
                        return this.client.call("POST /api/ship/alert/receipt/:alertName", a);
                    },
                    url: ()=>this.client.url("POST /api/ship/alert/receipt/:alertName", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent;
                    }
                }),
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ship/alert/:alertName", $d4eccb73927932bb$export$8ba8039f5b7f8902["PUT /api/ship/alert/:alertName"].targets);
                        return this.client.call("PUT /api/ship/alert/:alertName", a);
                    },
                    url: ()=>this.client.url("PUT /api/ship/alert/:alertName", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApp/AlertApi.swift - DO NOT EDIT

var $a521756eb7208261$export$196d6ee34f2568f2;
(function(IAlertCommandAction) {
    IAlertCommandAction["snooze"] = "snooze";
    IAlertCommandAction["acknowledge"] = "acknowledge";
    IAlertCommandAction["clear"] = "clear";
    IAlertCommandAction["escalate"] = "escalate";
})($a521756eb7208261$export$196d6ee34f2568f2 || ($a521756eb7208261$export$196d6ee34f2568f2 = {}));
const $a521756eb7208261$export$f6ee02eeeaebbaff = {
    "POST /api/ship/alert/manOverboard": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "POST /api/ship/alert/message": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "POST /api/ship/alert/receipt/:alertName": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    },
    "PUT /api/ship/alert/:alertName": {
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent
        }
    }
};


// @generated by TypeGen from LogbookApi/AnchorWatchApi - DO NOT EDIT


const $282be9ff941c7364$export$3ca752285b85e70d = {
    "PUT /api/ship/anchor/watch": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    }
};
class $282be9ff941c7364$export$d7dfee902fc47737 {
    constructor(client){
        this.client = client;
        this.anchorWatch = {
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ship/anchor/watch", $282be9ff941c7364$export$3ca752285b85e70d["PUT /api/ship/anchor/watch"].targets);
                        return this.client.call("PUT /api/ship/anchor/watch", a);
                    },
                    url: ()=>this.client.url("PUT /api/ship/anchor/watch", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/DepthWatchApi - DO NOT EDIT


const $2c05d4376a8922ad$export$848cb0ac9a37b11e = {
    "PUT /api/ship/depth/watch": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    }
};
class $2c05d4376a8922ad$export$d9fa3cf6dbf05747 {
    constructor(client){
        this.client = client;
        this.depthWatch = {
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ship/depth/watch", $2c05d4376a8922ad$export$848cb0ac9a37b11e["PUT /api/ship/depth/watch"].targets);
                        return this.client.call("PUT /api/ship/depth/watch", a);
                    },
                    url: ()=>this.client.url("PUT /api/ship/depth/watch", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                })
        };
    }
}


// @generated by TypeGen from LogbookApi/ManualShipStatusApi - DO NOT EDIT


const $de4d1766f08a9636$export$368884d97b85c72c = {
    "PUT /api/ship/status/manual": {
        targets: [
            "app"
        ],
        permission: {
            ship: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent
        }
    }
};
class $de4d1766f08a9636$export$c9e2730ca8b48804 {
    constructor(client){
        this.client = client;
        this.manualShipStatus = {
            update: (a)=>({
                    call: ()=>{
                        (0, $fdaad42f27f85e26$export$a016fea3e6717bac)(this.client, "PUT /api/ship/status/manual", $de4d1766f08a9636$export$368884d97b85c72c["PUT /api/ship/status/manual"].targets);
                        return this.client.call("PUT /api/ship/status/manual", a);
                    },
                    url: ()=>this.client.url("PUT /api/ship/status/manual", a),
                    available: (user)=>{
                        var _a;
                        return user != null && ((_a = user.shipLevel()) !== null && _a !== void 0 ? _a : -1) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
                    }
                })
        };
    }
}


// @generated by TypeGen from NMEA/NMEAEntry.swift - DO NOT EDIT
var $b75415c6faae2236$export$a4218654c54ef670;
(function(INMEADepthType) {
    INMEADepthType["belowKeel"] = "DBK";
    INMEADepthType["belowSurface"] = "DBS";
    INMEADepthType["belowTransducer"] = "DBT";
    INMEADepthType["water"] = "DPT";
})($b75415c6faae2236$export$a4218654c54ef670 || ($b75415c6faae2236$export$a4218654c54ef670 = {}));
var $b75415c6faae2236$export$4dca3857b133ad4e;
(function(INMEAHeadingType) {
    INMEAHeadingType["overGround"] = "VTG";
    INMEAHeadingType["overWater"] = "VHW";
    INMEAHeadingType["headingTrue"] = "HDT";
    INMEAHeadingType["headingMagnetic"] = "HDM";
    INMEAHeadingType["headingMagnetic2"] = "HDG";
})($b75415c6faae2236$export$4dca3857b133ad4e || ($b75415c6faae2236$export$4dca3857b133ad4e = {}));
var $b75415c6faae2236$export$de7878d8063d52cb;
(function(INMEASource) {
    INMEASource[INMEASource["nmea"] = 1] = "nmea";
    INMEASource[INMEASource["native"] = 2] = "native";
})($b75415c6faae2236$export$de7878d8063d52cb || ($b75415c6faae2236$export$de7878d8063d52cb = {}));
var $b75415c6faae2236$export$f9ee2074361b96f5;
(function(INMEAWindReference) {
    INMEAWindReference["apparent"] = "apparent";
    INMEAWindReference["trueBoat"] = "trueBoat";
    INMEAWindReference["trueDirection"] = "trueDirection";
})($b75415c6faae2236$export$f9ee2074361b96f5 || ($b75415c6faae2236$export$f9ee2074361b96f5 = {}));


// @generated by TypeGen from NMEA/N2K/N2KEntry.swift - DO NOT EDIT
var $f9b025f8b929ad7f$export$7b4f9f8aead5b03c;
(function(IN2KPGN) {
    IN2KPGN[IN2KPGN["position"] = 129025] = "position";
    IN2KPGN[IN2KPGN["courseSpeed"] = 129026] = "courseSpeed";
    IN2KPGN[IN2KPGN["vesselHeading"] = 127250] = "vesselHeading";
    IN2KPGN[IN2KPGN["windData"] = 130306] = "windData";
    IN2KPGN[IN2KPGN["waterDepth"] = 128267] = "waterDepth";
    IN2KPGN[IN2KPGN["engineRapid"] = 127488] = "engineRapid";
    IN2KPGN[IN2KPGN["speed"] = 128259] = "speed";
    IN2KPGN[IN2KPGN["systemTime"] = 126992] = "systemTime";
    IN2KPGN[IN2KPGN["fluidLevel"] = 127505] = "fluidLevel";
    IN2KPGN[IN2KPGN["humidity"] = 130313] = "humidity";
    IN2KPGN[IN2KPGN["actualPressure"] = 130314] = "actualPressure";
    IN2KPGN[IN2KPGN["temperatureExtended"] = 130316] = "temperatureExtended";
    IN2KPGN[IN2KPGN["manOverboard"] = 127233] = "manOverboard";
    IN2KPGN[IN2KPGN["distanceLog"] = 128275] = "distanceLog";
    IN2KPGN[IN2KPGN["aisClassAPosition"] = 129038] = "aisClassAPosition";
    IN2KPGN[IN2KPGN["aisClassBPosition"] = 129039] = "aisClassBPosition";
    IN2KPGN[IN2KPGN["batteryStatus"] = 127508] = "batteryStatus";
    IN2KPGN[IN2KPGN["batteryDC"] = 127506] = "batteryDC";
    IN2KPGN[IN2KPGN["batteryConfiguration"] = 127513] = "batteryConfiguration";
    IN2KPGN[IN2KPGN["chargerStatus"] = 127507] = "chargerStatus";
    IN2KPGN[IN2KPGN["switchBankStatus"] = 127501] = "switchBankStatus";
    IN2KPGN[IN2KPGN["engineDynamic"] = 127489] = "engineDynamic";
    IN2KPGN[IN2KPGN["crossTrackError"] = 129283] = "crossTrackError";
    IN2KPGN[IN2KPGN["navigationData"] = 129284] = "navigationData";
    IN2KPGN[IN2KPGN["routeWaypointInformation"] = 129285] = "routeWaypointInformation";
    IN2KPGN[IN2KPGN["routeWaypointService"] = 130074] = "routeWaypointService";
    IN2KPGN[IN2KPGN["gnssPosition"] = 129029] = "gnssPosition";
    IN2KPGN[IN2KPGN["gnssDOPs"] = 129539] = "gnssDOPs";
    IN2KPGN[IN2KPGN["gnssSatellitesInView"] = 129540] = "gnssSatellitesInView";
    IN2KPGN[IN2KPGN["windlassOperatingStatus"] = 128777] = "windlassOperatingStatus";
    IN2KPGN[IN2KPGN["windlassMonitoringStatus"] = 128778] = "windlassMonitoringStatus";
    IN2KPGN[IN2KPGN["agsConfiguration"] = 127512] = "agsConfiguration";
    IN2KPGN[IN2KPGN["agsStatus"] = 127514] = "agsStatus";
    IN2KPGN[IN2KPGN["engineStatic"] = 127498] = "engineStatic";
    IN2KPGN[IN2KPGN["aisClassAStatic"] = 129794] = "aisClassAStatic";
    IN2KPGN[IN2KPGN["aisClassBStaticPartA"] = 129809] = "aisClassBStaticPartA";
    IN2KPGN[IN2KPGN["aisClassBStaticPartB"] = 129810] = "aisClassBStaticPartB";
    IN2KPGN[IN2KPGN["aisSarAircraftPosition"] = 129798] = "aisSarAircraftPosition";
    IN2KPGN[IN2KPGN["aisAddressedSafetyMessage"] = 129801] = "aisAddressedSafetyMessage";
    IN2KPGN[IN2KPGN["aisSafetyBroadcastMessage"] = 129802] = "aisSafetyBroadcastMessage";
    IN2KPGN[IN2KPGN["dscCallInformation"] = 129808] = "dscCallInformation";
    IN2KPGN[IN2KPGN["alert"] = 126983] = "alert";
    IN2KPGN[IN2KPGN["alertResponse"] = 126984] = "alertResponse";
    IN2KPGN[IN2KPGN["alertText"] = 126985] = "alertText";
    IN2KPGN[IN2KPGN["alertConfiguration"] = 126986] = "alertConfiguration";
    IN2KPGN[IN2KPGN["alertThreshold"] = 126987] = "alertThreshold";
    IN2KPGN[IN2KPGN["alertValue"] = 126988] = "alertValue";
    IN2KPGN[IN2KPGN["headingTrackControl"] = 127237] = "headingTrackControl";
    IN2KPGN[IN2KPGN["rudder"] = 127245] = "rudder";
    IN2KPGN[IN2KPGN["tripParametersVessel"] = 127496] = "tripParametersVessel";
    IN2KPGN[IN2KPGN["tripParametersEngine"] = 127497] = "tripParametersEngine";
    IN2KPGN[IN2KPGN["inverterStatus"] = 127509] = "inverterStatus";
    IN2KPGN[IN2KPGN["inverterConfiguration"] = 127511] = "inverterConfiguration";
    IN2KPGN[IN2KPGN["thrusterMotorStatus"] = 128008] = "thrusterMotorStatus";
    IN2KPGN[IN2KPGN["rateOfTurn"] = 127251] = "rateOfTurn";
    IN2KPGN[IN2KPGN["transmissionDynamic"] = 127493] = "transmissionDynamic";
})($f9b025f8b929ad7f$export$7b4f9f8aead5b03c || ($f9b025f8b929ad7f$export$7b4f9f8aead5b03c = {}));


// @generated by TypeGen from NMEA/N2K/N2KLookups.swift - DO NOT EDIT
var $c65f9b00cea21320$export$6f31d7cb678bbef2;
(function(IN2KAGSGeneratingState) {
    IN2KAGSGeneratingState[IN2KAGSGeneratingState["preheating"] = 0] = "preheating";
    IN2KAGSGeneratingState[IN2KAGSGeneratingState["startDelay"] = 1] = "startDelay";
    IN2KAGSGeneratingState[IN2KAGSGeneratingState["cranking"] = 2] = "cranking";
    IN2KAGSGeneratingState[IN2KAGSGeneratingState["starterCooling"] = 3] = "starterCooling";
    IN2KAGSGeneratingState[IN2KAGSGeneratingState["warmingUp"] = 4] = "warmingUp";
    IN2KAGSGeneratingState[IN2KAGSGeneratingState["coolingDown"] = 5] = "coolingDown";
    IN2KAGSGeneratingState[IN2KAGSGeneratingState["spinningUp"] = 6] = "spinningUp";
    IN2KAGSGeneratingState[IN2KAGSGeneratingState["shutdownBypass"] = 7] = "shutdownBypass";
    IN2KAGSGeneratingState[IN2KAGSGeneratingState["stopping"] = 8] = "stopping";
    IN2KAGSGeneratingState[IN2KAGSGeneratingState["running"] = 9] = "running";
    IN2KAGSGeneratingState[IN2KAGSGeneratingState["stopped"] = 10] = "stopped";
    IN2KAGSGeneratingState[IN2KAGSGeneratingState["crankDelay"] = 11] = "crankDelay";
})($c65f9b00cea21320$export$6f31d7cb678bbef2 || ($c65f9b00cea21320$export$6f31d7cb678bbef2 = {}));
var $c65f9b00cea21320$export$30ff269c488a3da1;
(function(IN2KAGSMode) {
    IN2KAGSMode[IN2KAGSMode["off"] = 0] = "off";
    IN2KAGSMode[IN2KAGSMode["on"] = 1] = "on";
    IN2KAGSMode[IN2KAGSMode["automatic"] = 2] = "automatic";
})($c65f9b00cea21320$export$30ff269c488a3da1 || ($c65f9b00cea21320$export$30ff269c488a3da1 = {}));
var $c65f9b00cea21320$export$6d4ac31b27f1ab68;
(function(IN2KAGSOffReason) {
    IN2KAGSOffReason[IN2KAGSOffReason["notOff"] = 0] = "notOff";
    IN2KAGSOffReason[IN2KAGSOffReason["dcVoltageHigh"] = 1] = "dcVoltageHigh";
    IN2KAGSOffReason[IN2KAGSOffReason["batteryStateOfChargeHigh"] = 2] = "batteryStateOfChargeHigh";
    IN2KAGSOffReason[IN2KAGSOffReason["acCurrentLow"] = 3] = "acCurrentLow";
    IN2KAGSOffReason[IN2KAGSOffReason["contactOpened"] = 4] = "contactOpened";
    IN2KAGSOffReason[IN2KAGSOffReason["reachedAbsorption"] = 5] = "reachedAbsorption";
    IN2KAGSOffReason[IN2KAGSOffReason["reachedFloat"] = 6] = "reachedFloat";
    IN2KAGSOffReason[IN2KAGSOffReason["manualOff"] = 7] = "manualOff";
    IN2KAGSOffReason[IN2KAGSOffReason["maxRunTime"] = 8] = "maxRunTime";
    IN2KAGSOffReason[IN2KAGSOffReason["maxAutoCycle"] = 9] = "maxAutoCycle";
    IN2KAGSOffReason[IN2KAGSOffReason["exerciseDone"] = 10] = "exerciseDone";
    IN2KAGSOffReason[IN2KAGSOffReason["quietTime"] = 11] = "quietTime";
    IN2KAGSOffReason[IN2KAGSOffReason["externalOffViaAGS"] = 12] = "externalOffViaAGS";
    IN2KAGSOffReason[IN2KAGSOffReason["safeMode"] = 13] = "safeMode";
    IN2KAGSOffReason[IN2KAGSOffReason["externalOffViaGenerator"] = 14] = "externalOffViaGenerator";
    IN2KAGSOffReason[IN2KAGSOffReason["externalShutdown"] = 15] = "externalShutdown";
    IN2KAGSOffReason[IN2KAGSOffReason["autoOff"] = 16] = "autoOff";
    IN2KAGSOffReason[IN2KAGSOffReason["fault"] = 17] = "fault";
    IN2KAGSOffReason[IN2KAGSOffReason["unableToStart"] = 18] = "unableToStart";
})($c65f9b00cea21320$export$6d4ac31b27f1ab68 || ($c65f9b00cea21320$export$6d4ac31b27f1ab68 = {}));
var $c65f9b00cea21320$export$3b2fd09f258ce2ad;
(function(IN2KAGSOnReason) {
    IN2KAGSOnReason[IN2KAGSOnReason["notOn"] = 0] = "notOn";
    IN2KAGSOnReason[IN2KAGSOnReason["dcVoltageLow"] = 1] = "dcVoltageLow";
    IN2KAGSOnReason[IN2KAGSOnReason["batteryStateOfChargeLow"] = 2] = "batteryStateOfChargeLow";
    IN2KAGSOnReason[IN2KAGSOnReason["acCurrentHigh"] = 3] = "acCurrentHigh";
    IN2KAGSOnReason[IN2KAGSOnReason["contactClosed"] = 4] = "contactClosed";
    IN2KAGSOnReason[IN2KAGSOnReason["manualOn"] = 5] = "manualOn";
    IN2KAGSOnReason[IN2KAGSOnReason["exercise"] = 6] = "exercise";
    IN2KAGSOnReason[IN2KAGSOnReason["nonQuietTime"] = 7] = "nonQuietTime";
    IN2KAGSOnReason[IN2KAGSOnReason["externalOnViaAGS"] = 8] = "externalOnViaAGS";
    IN2KAGSOnReason[IN2KAGSOnReason["externalOnViaGenerator"] = 9] = "externalOnViaGenerator";
    IN2KAGSOnReason[IN2KAGSOnReason["unableToStop"] = 10] = "unableToStop";
})($c65f9b00cea21320$export$3b2fd09f258ce2ad || ($c65f9b00cea21320$export$3b2fd09f258ce2ad = {}));
var $c65f9b00cea21320$export$3ae5e871a6ec0f2;
(function(IN2KAGSOperatingState) {
    IN2KAGSOperatingState[IN2KAGSOperatingState["quietTime"] = 0] = "quietTime";
    IN2KAGSOperatingState[IN2KAGSOperatingState["autoOn"] = 1] = "autoOn";
    IN2KAGSOperatingState[IN2KAGSOperatingState["autoOff"] = 2] = "autoOff";
    IN2KAGSOperatingState[IN2KAGSOperatingState["manualOn"] = 3] = "manualOn";
    IN2KAGSOperatingState[IN2KAGSOperatingState["manualOff"] = 4] = "manualOff";
    IN2KAGSOperatingState[IN2KAGSOperatingState["generatorShutdown"] = 5] = "generatorShutdown";
    IN2KAGSOperatingState[IN2KAGSOperatingState["externalShutdown"] = 6] = "externalShutdown";
    IN2KAGSOperatingState[IN2KAGSOperatingState["fault"] = 7] = "fault";
    IN2KAGSOperatingState[IN2KAGSOperatingState["suspend"] = 8] = "suspend";
    IN2KAGSOperatingState[IN2KAGSOperatingState["notOperating"] = 9] = "notOperating";
})($c65f9b00cea21320$export$3ae5e871a6ec0f2 || ($c65f9b00cea21320$export$3ae5e871a6ec0f2 = {}));
var $c65f9b00cea21320$export$290621ddbaaf9987;
(function(IN2KAlertCategory) {
    IN2KAlertCategory[IN2KAlertCategory["navigational"] = 0] = "navigational";
    IN2KAlertCategory[IN2KAlertCategory["technical"] = 1] = "technical";
})($c65f9b00cea21320$export$290621ddbaaf9987 || ($c65f9b00cea21320$export$290621ddbaaf9987 = {}));
var $c65f9b00cea21320$export$af1d448e82ac7530;
(function(IN2KAlertResponseCommand) {
    IN2KAlertResponseCommand[IN2KAlertResponseCommand["acknowledge"] = 0] = "acknowledge";
    IN2KAlertResponseCommand[IN2KAlertResponseCommand["temporarySilence"] = 1] = "temporarySilence";
    IN2KAlertResponseCommand[IN2KAlertResponseCommand["testCommandOff"] = 2] = "testCommandOff";
    IN2KAlertResponseCommand[IN2KAlertResponseCommand["testCommandOn"] = 3] = "testCommandOn";
})($c65f9b00cea21320$export$af1d448e82ac7530 || ($c65f9b00cea21320$export$af1d448e82ac7530 = {}));
var $c65f9b00cea21320$export$884e6983d5c81877;
(function(IN2KAlertState) {
    IN2KAlertState[IN2KAlertState["disabled"] = 0] = "disabled";
    IN2KAlertState[IN2KAlertState["normal"] = 1] = "normal";
    IN2KAlertState[IN2KAlertState["active"] = 2] = "active";
    IN2KAlertState[IN2KAlertState["silenced"] = 3] = "silenced";
    IN2KAlertState[IN2KAlertState["acknowledged"] = 4] = "acknowledged";
    IN2KAlertState[IN2KAlertState["awaitingAcknowledge"] = 5] = "awaitingAcknowledge";
})($c65f9b00cea21320$export$884e6983d5c81877 || ($c65f9b00cea21320$export$884e6983d5c81877 = {}));
var $c65f9b00cea21320$export$c54d790a4ea30b4d;
(function(IN2KAlertThresholdStatus) {
    IN2KAlertThresholdStatus[IN2KAlertThresholdStatus["normal"] = 0] = "normal";
    IN2KAlertThresholdStatus[IN2KAlertThresholdStatus["thresholdExceeded"] = 1] = "thresholdExceeded";
    IN2KAlertThresholdStatus[IN2KAlertThresholdStatus["extremeThresholdExceeded"] = 2] = "extremeThresholdExceeded";
    IN2KAlertThresholdStatus[IN2KAlertThresholdStatus["lowThresholdExceeded"] = 3] = "lowThresholdExceeded";
    IN2KAlertThresholdStatus[IN2KAlertThresholdStatus["acknowledged"] = 4] = "acknowledged";
    IN2KAlertThresholdStatus[IN2KAlertThresholdStatus["awaitingAcknowledge"] = 5] = "awaitingAcknowledge";
})($c65f9b00cea21320$export$c54d790a4ea30b4d || ($c65f9b00cea21320$export$c54d790a4ea30b4d = {}));
var $c65f9b00cea21320$export$e52d8b0df3ec05b4;
(function(IN2KAlertTriggerCondition) {
    IN2KAlertTriggerCondition[IN2KAlertTriggerCondition["manual"] = 0] = "manual";
    IN2KAlertTriggerCondition[IN2KAlertTriggerCondition["auto"] = 1] = "auto";
    IN2KAlertTriggerCondition[IN2KAlertTriggerCondition["test"] = 2] = "test";
    IN2KAlertTriggerCondition[IN2KAlertTriggerCondition["disabled"] = 3] = "disabled";
})($c65f9b00cea21320$export$e52d8b0df3ec05b4 || ($c65f9b00cea21320$export$e52d8b0df3ec05b4 = {}));
var $c65f9b00cea21320$export$c8deabcbd7011b2;
(function(IN2KAlertType) {
    IN2KAlertType[IN2KAlertType["emergencyAlarm"] = 1] = "emergencyAlarm";
    IN2KAlertType[IN2KAlertType["alarm"] = 2] = "alarm";
    IN2KAlertType[IN2KAlertType["warning"] = 5] = "warning";
    IN2KAlertType[IN2KAlertType["caution"] = 8] = "caution";
})($c65f9b00cea21320$export$c8deabcbd7011b2 || ($c65f9b00cea21320$export$c8deabcbd7011b2 = {}));
var $c65f9b00cea21320$export$bd32a2e0ebb821de;
(function(IN2KBatteryChemistry) {
    IN2KBatteryChemistry[IN2KBatteryChemistry["leadAcid"] = 0] = "leadAcid";
    IN2KBatteryChemistry[IN2KBatteryChemistry["lithium"] = 1] = "lithium";
    IN2KBatteryChemistry[IN2KBatteryChemistry["nickelCadmium"] = 2] = "nickelCadmium";
    IN2KBatteryChemistry[IN2KBatteryChemistry["zincOxide"] = 3] = "zincOxide";
    IN2KBatteryChemistry[IN2KBatteryChemistry["nickelMetalHydride"] = 4] = "nickelMetalHydride";
})($c65f9b00cea21320$export$bd32a2e0ebb821de || ($c65f9b00cea21320$export$bd32a2e0ebb821de = {}));
var $c65f9b00cea21320$export$f42412e6caf2192;
(function(IN2KBatteryNominalVoltage) {
    IN2KBatteryNominalVoltage[IN2KBatteryNominalVoltage["v6"] = 0] = "v6";
    IN2KBatteryNominalVoltage[IN2KBatteryNominalVoltage["v12"] = 1] = "v12";
    IN2KBatteryNominalVoltage[IN2KBatteryNominalVoltage["v24"] = 2] = "v24";
    IN2KBatteryNominalVoltage[IN2KBatteryNominalVoltage["v32"] = 3] = "v32";
    IN2KBatteryNominalVoltage[IN2KBatteryNominalVoltage["v36"] = 4] = "v36";
    IN2KBatteryNominalVoltage[IN2KBatteryNominalVoltage["v42"] = 5] = "v42";
    IN2KBatteryNominalVoltage[IN2KBatteryNominalVoltage["v48"] = 6] = "v48";
})($c65f9b00cea21320$export$f42412e6caf2192 || ($c65f9b00cea21320$export$f42412e6caf2192 = {}));
var $c65f9b00cea21320$export$c16ab10b9ca3cc1e;
(function(IN2KBatteryType) {
    IN2KBatteryType[IN2KBatteryType["flooded"] = 0] = "flooded";
    IN2KBatteryType[IN2KBatteryType["gel"] = 1] = "gel";
    IN2KBatteryType[IN2KBatteryType["agm"] = 2] = "agm";
})($c65f9b00cea21320$export$c16ab10b9ca3cc1e || ($c65f9b00cea21320$export$c16ab10b9ca3cc1e = {}));
var $c65f9b00cea21320$export$56f1064cad7c0d30;
(function(IN2KChargerMode) {
    IN2KChargerMode[IN2KChargerMode["standalone"] = 0] = "standalone";
    IN2KChargerMode[IN2KChargerMode["primary"] = 1] = "primary";
    IN2KChargerMode[IN2KChargerMode["secondary"] = 2] = "secondary";
    IN2KChargerMode[IN2KChargerMode["echo"] = 3] = "echo";
})($c65f9b00cea21320$export$56f1064cad7c0d30 || ($c65f9b00cea21320$export$56f1064cad7c0d30 = {}));
var $c65f9b00cea21320$export$6f337e8e4ee9764d;
(function(IN2KChargerState) {
    IN2KChargerState[IN2KChargerState["notCharging"] = 0] = "notCharging";
    IN2KChargerState[IN2KChargerState["bulk"] = 1] = "bulk";
    IN2KChargerState[IN2KChargerState["absorption"] = 2] = "absorption";
    IN2KChargerState[IN2KChargerState["overcharge"] = 3] = "overcharge";
    IN2KChargerState[IN2KChargerState["equalise"] = 4] = "equalise";
    IN2KChargerState[IN2KChargerState["float"] = 5] = "float";
    IN2KChargerState[IN2KChargerState["noFloat"] = 6] = "noFloat";
    IN2KChargerState[IN2KChargerState["constantVI"] = 7] = "constantVI";
    IN2KChargerState[IN2KChargerState["disabled"] = 8] = "disabled";
    IN2KChargerState[IN2KChargerState["fault"] = 9] = "fault";
})($c65f9b00cea21320$export$6f337e8e4ee9764d || ($c65f9b00cea21320$export$6f337e8e4ee9764d = {}));
var $c65f9b00cea21320$export$a1acea362ba816b5;
(function(IN2KDCType) {
    IN2KDCType[IN2KDCType["battery"] = 0] = "battery";
    IN2KDCType[IN2KDCType["alternator"] = 1] = "alternator";
    IN2KDCType[IN2KDCType["converter"] = 2] = "converter";
    IN2KDCType[IN2KDCType["solarCell"] = 3] = "solarCell";
    IN2KDCType[IN2KDCType["windGenerator"] = 4] = "windGenerator";
})($c65f9b00cea21320$export$a1acea362ba816b5 || ($c65f9b00cea21320$export$a1acea362ba816b5 = {}));
var $c65f9b00cea21320$export$d49091bebf53db13;
(function(IN2KDSCCategory) {
    IN2KDSCCategory[IN2KDSCCategory["routine"] = 100] = "routine";
    IN2KDSCCategory[IN2KDSCCategory["safety"] = 108] = "safety";
    IN2KDSCCategory[IN2KDSCCategory["urgency"] = 110] = "urgency";
    IN2KDSCCategory[IN2KDSCCategory["distress"] = 112] = "distress";
})($c65f9b00cea21320$export$d49091bebf53db13 || ($c65f9b00cea21320$export$d49091bebf53db13 = {}));
var $c65f9b00cea21320$export$8c43bf3ee56a4ccb;
(function(IN2KDirectionReference) {
    IN2KDirectionReference[IN2KDirectionReference["trueNorth"] = 0] = "trueNorth";
    IN2KDirectionReference[IN2KDirectionReference["magnetic"] = 1] = "magnetic";
    IN2KDirectionReference[IN2KDirectionReference["error"] = 2] = "error";
})($c65f9b00cea21320$export$8c43bf3ee56a4ccb || ($c65f9b00cea21320$export$8c43bf3ee56a4ccb = {}));
var $c65f9b00cea21320$export$f36a655c666f623a;
(function(IN2KDockingStatus) {
    IN2KDockingStatus[IN2KDockingStatus["notDocked"] = 0] = "notDocked";
    IN2KDockingStatus[IN2KDockingStatus["fullyDocked"] = 1] = "fullyDocked";
})($c65f9b00cea21320$export$f36a655c666f623a || ($c65f9b00cea21320$export$f36a655c666f623a = {}));
var $c65f9b00cea21320$export$35d21118ca698ee4;
(function(IN2KGearStatus) {
    IN2KGearStatus[IN2KGearStatus["forward"] = 0] = "forward";
    IN2KGearStatus[IN2KGearStatus["neutral"] = 1] = "neutral";
    IN2KGearStatus[IN2KGearStatus["reverse"] = 2] = "reverse";
})($c65f9b00cea21320$export$35d21118ca698ee4 || ($c65f9b00cea21320$export$35d21118ca698ee4 = {}));
var $c65f9b00cea21320$export$8428428ae2ecaa5c;
(function(IN2KInverterMode) {
    IN2KInverterMode[IN2KInverterMode["standalone"] = 0] = "standalone";
    IN2KInverterMode[IN2KInverterMode["seriesMaster"] = 1] = "seriesMaster";
    IN2KInverterMode[IN2KInverterMode["seriesSlave"] = 2] = "seriesSlave";
    IN2KInverterMode[IN2KInverterMode["parallelMaster"] = 3] = "parallelMaster";
    IN2KInverterMode[IN2KInverterMode["parallelSlave"] = 4] = "parallelSlave";
})($c65f9b00cea21320$export$8428428ae2ecaa5c || ($c65f9b00cea21320$export$8428428ae2ecaa5c = {}));
var $c65f9b00cea21320$export$d615bc2c9f7b584;
(function(IN2KInverterState) {
    IN2KInverterState[IN2KInverterState["invert"] = 0] = "invert";
    IN2KInverterState[IN2KInverterState["acPassthru"] = 1] = "acPassthru";
    IN2KInverterState[IN2KInverterState["loadSense"] = 2] = "loadSense";
    IN2KInverterState[IN2KInverterState["fault"] = 3] = "fault";
    IN2KInverterState[IN2KInverterState["disabled"] = 4] = "disabled";
})($c65f9b00cea21320$export$d615bc2c9f7b584 || ($c65f9b00cea21320$export$d615bc2c9f7b584 = {}));
var $c65f9b00cea21320$export$101ebbdde2af3705;
(function(IN2KOffOn) {
    IN2KOffOn[IN2KOffOn["off"] = 0] = "off";
    IN2KOffOn[IN2KOffOn["on"] = 1] = "on";
})($c65f9b00cea21320$export$101ebbdde2af3705 || ($c65f9b00cea21320$export$101ebbdde2af3705 = {}));
var $c65f9b00cea21320$export$99e845c5040038b;
(function(IN2KRodeType) {
    IN2KRodeType[IN2KRodeType["chain"] = 0] = "chain";
    IN2KRodeType[IN2KRodeType["rope"] = 1] = "rope";
})($c65f9b00cea21320$export$99e845c5040038b || ($c65f9b00cea21320$export$99e845c5040038b = {}));
var $c65f9b00cea21320$export$cc467dfe46840446;
(function(IN2KRudderDirection) {
    IN2KRudderDirection[IN2KRudderDirection["noOrder"] = 0] = "noOrder";
    IN2KRudderDirection[IN2KRudderDirection["moveToStarboard"] = 1] = "moveToStarboard";
    IN2KRudderDirection[IN2KRudderDirection["moveToPort"] = 2] = "moveToPort";
})($c65f9b00cea21320$export$cc467dfe46840446 || ($c65f9b00cea21320$export$cc467dfe46840446 = {}));
var $c65f9b00cea21320$export$cd357f50a38e74d3;
(function(IN2KSteeringMode) {
    IN2KSteeringMode[IN2KSteeringMode["mainSteering"] = 0] = "mainSteering";
    IN2KSteeringMode[IN2KSteeringMode["nonFollowUpDevice"] = 1] = "nonFollowUpDevice";
    IN2KSteeringMode[IN2KSteeringMode["followUpDevice"] = 2] = "followUpDevice";
    IN2KSteeringMode[IN2KSteeringMode["headingControlStandalone"] = 3] = "headingControlStandalone";
    IN2KSteeringMode[IN2KSteeringMode["headingControl"] = 4] = "headingControl";
    IN2KSteeringMode[IN2KSteeringMode["trackControl"] = 5] = "trackControl";
})($c65f9b00cea21320$export$cd357f50a38e74d3 || ($c65f9b00cea21320$export$cd357f50a38e74d3 = {}));
var $c65f9b00cea21320$export$c35ae7f667618cc9;
(function(IN2KTankType) {
    IN2KTankType[IN2KTankType["fuel"] = 0] = "fuel";
    IN2KTankType[IN2KTankType["water"] = 1] = "water";
    IN2KTankType[IN2KTankType["grayWater"] = 2] = "grayWater";
    IN2KTankType[IN2KTankType["liveWell"] = 3] = "liveWell";
    IN2KTankType[IN2KTankType["oil"] = 4] = "oil";
    IN2KTankType[IN2KTankType["blackWater"] = 5] = "blackWater";
})($c65f9b00cea21320$export$c35ae7f667618cc9 || ($c65f9b00cea21320$export$c35ae7f667618cc9 = {}));
var $c65f9b00cea21320$export$77793431e298fca5;
(function(IN2KTurnMode) {
    IN2KTurnMode[IN2KTurnMode["rudderLimitControlled"] = 0] = "rudderLimitControlled";
    IN2KTurnMode[IN2KTurnMode["turnRateControlled"] = 1] = "turnRateControlled";
    IN2KTurnMode[IN2KTurnMode["radiusControlled"] = 2] = "radiusControlled";
})($c65f9b00cea21320$export$77793431e298fca5 || ($c65f9b00cea21320$export$77793431e298fca5 = {}));
var $c65f9b00cea21320$export$449e1375fc239f79;
(function(IN2KWindReference) {
    IN2KWindReference[IN2KWindReference["trueNorth"] = 0] = "trueNorth";
    IN2KWindReference[IN2KWindReference["magneticNorth"] = 1] = "magneticNorth";
    IN2KWindReference[IN2KWindReference["apparent"] = 2] = "apparent";
    IN2KWindReference[IN2KWindReference["trueBoat"] = 3] = "trueBoat";
    IN2KWindReference[IN2KWindReference["trueWater"] = 4] = "trueWater";
})($c65f9b00cea21320$export$449e1375fc239f79 || ($c65f9b00cea21320$export$449e1375fc239f79 = {}));
var $c65f9b00cea21320$export$2719c51b72d79ae1;
(function(IN2KWindlassDirection) {
    IN2KWindlassDirection[IN2KWindlassDirection["off"] = 0] = "off";
    IN2KWindlassDirection[IN2KWindlassDirection["down"] = 1] = "down";
    IN2KWindlassDirection[IN2KWindlassDirection["up"] = 2] = "up";
})($c65f9b00cea21320$export$2719c51b72d79ae1 || ($c65f9b00cea21320$export$2719c51b72d79ae1 = {}));
var $c65f9b00cea21320$export$de5daa2d5082b64a;
(function(IN2KWindlassMotion) {
    IN2KWindlassMotion[IN2KWindlassMotion["stopped"] = 0] = "stopped";
    IN2KWindlassMotion[IN2KWindlassMotion["deploying"] = 1] = "deploying";
    IN2KWindlassMotion[IN2KWindlassMotion["retrieving"] = 2] = "retrieving";
})($c65f9b00cea21320$export$de5daa2d5082b64a || ($c65f9b00cea21320$export$de5daa2d5082b64a = {}));
var $c65f9b00cea21320$export$31aa1f3aeb8dfc2;
(function(IN2KYesNo) {
    IN2KYesNo[IN2KYesNo["no"] = 0] = "no";
    IN2KYesNo[IN2KYesNo["yes"] = 1] = "yes";
})($c65f9b00cea21320$export$31aa1f3aeb8dfc2 || ($c65f9b00cea21320$export$31aa1f3aeb8dfc2 = {}));


// @generated by TypeGen from LogbookApp/AppState.swift - DO NOT EDIT
var $21a3d4ed29e876cd$export$419cd0b0d913ff49;
(function(ILogbookNMEAProtocol) {
    ILogbookNMEAProtocol["tcp"] = "tcp";
    ILogbookNMEAProtocol["udp"] = "udp";
    ILogbookNMEAProtocol["bluetooth"] = "bluetooth";
    ILogbookNMEAProtocol["usb"] = "usb";
    ILogbookNMEAProtocol["gps"] = "gps";
})($21a3d4ed29e876cd$export$419cd0b0d913ff49 || ($21a3d4ed29e876cd$export$419cd0b0d913ff49 = {}));


// @generated by TypeGen from LogbookModel/Note.swift - DO NOT EDIT
var $7a517a6ccb68a7e7$export$71c27e2dc62bcf10;
(function(INoteType) {
    INoteType[INoteType["journal"] = 1] = "journal";
    INoteType[INoteType["technical"] = 2] = "technical";
    INoteType[INoteType["weather"] = 3] = "weather";
    INoteType[INoteType["watchplan"] = 4] = "watchplan";
    INoteType[INoteType["crew"] = 10] = "crew";
    INoteType[INoteType["watch"] = 11] = "watch";
    INoteType[INoteType["planning"] = 20] = "planning";
})($7a517a6ccb68a7e7$export$71c27e2dc62bcf10 || ($7a517a6ccb68a7e7$export$71c27e2dc62bcf10 = {}));
const $7a517a6ccb68a7e7$export$6c88bf799aca3d2b = {
    parse (r) {
        return Object.assign(Object.assign({}, r), {
            dataParsed: r.data != null ? JSON.parse(r.data) : {}
        });
    }
};


var $d460697aab603bc5$export$5daa50148070bda5;
(function(INoteParentType) {
    INoteParentType["cruise"] = "cruise";
    INoteParentType["day"] = "day";
    INoteParentType["trip"] = "trip";
})($d460697aab603bc5$export$5daa50148070bda5 || ($d460697aab603bc5$export$5daa50148070bda5 = {}));


// @generated by TypeGen from LogbookModel/Session.swift - DO NOT EDIT
var $a8c48887e141e972$export$f571599f3262a44a;
(function(ILogbookSessionClient) {
    ILogbookSessionClient["app"] = "app";
    ILogbookSessionClient["cloud"] = "cloud";
})($a8c48887e141e972$export$f571599f3262a44a || ($a8c48887e141e972$export$f571599f3262a44a = {}));
var $a8c48887e141e972$export$9fd99c4c3c179cff;
(function(ILogbookSessionType) {
    ILogbookSessionType["cloud"] = "cloud";
    ILogbookSessionType["primary"] = "primary";
    ILogbookSessionType["local"] = "local";
})($a8c48887e141e972$export$9fd99c4c3c179cff || ($a8c48887e141e972$export$9fd99c4c3c179cff = {}));


// @generated by TypeGen from LogbookModel/Ship/ShipMetadata.swift - DO NOT EDIT
var $ef756702f3923ebb$export$bd5fd2a78082695e;
(function(IShipImportStatus) {
    IShipImportStatus["complete"] = "complete";
    IShipImportStatus["pending"] = "pending";
    IShipImportStatus["processing"] = "processing";
    IShipImportStatus["failed"] = "failed";
})($ef756702f3923ebb$export$bd5fd2a78082695e || ($ef756702f3923ebb$export$bd5fd2a78082695e = {}));



// @generated by TypeGen from LogbookModel/Ship.swift - DO NOT EDIT
var $3d4dfb4b3a9d38e4$export$2852e62327382ca8;
(function(IShipVesselType) {
    IShipVesselType[IShipVesselType["undefined"] = 0] = "undefined";
    IShipVesselType[IShipVesselType["motor"] = 1] = "motor";
    IShipVesselType[IShipVesselType["sailing"] = 2] = "sailing";
})($3d4dfb4b3a9d38e4$export$2852e62327382ca8 || ($3d4dfb4b3a9d38e4$export$2852e62327382ca8 = {}));
const $3d4dfb4b3a9d38e4$export$7930c61d9b464618 = {
    parse (r) {
        return Object.assign(Object.assign({}, r), {
            dataParsed: r.data != null ? JSON.parse(r.data) : {}
        });
    }
};


// @generated by TypeGen from LogbookModel/Status.swift - DO NOT EDIT
var $d0f8aae9e6f7e80f$export$d03236bd7c374ce6;
(function(IStatusType) {
    IStatusType[IStatusType["ship"] = 1] = "ship";
    IStatusType[IStatusType["nmea"] = 2] = "nmea";
    IStatusType[IStatusType["engine"] = 3] = "engine";
    IStatusType[IStatusType["sails"] = 4] = "sails";
    IStatusType[IStatusType["lighting"] = 5] = "lighting";
    IStatusType[IStatusType["alert"] = 6] = "alert";
    IStatusType[IStatusType["generator"] = 7] = "generator";
    IStatusType[IStatusType["monitor"] = 8] = "monitor";
    IStatusType[IStatusType["dataRecord"] = 9] = "dataRecord";
    IStatusType[IStatusType["nmeaConnection"] = 10] = "nmeaConnection";
    IStatusType[IStatusType["manualShipStatus"] = 11] = "manualShipStatus";
    IStatusType[IStatusType["test"] = 100] = "test";
})($d0f8aae9e6f7e80f$export$d03236bd7c374ce6 || ($d0f8aae9e6f7e80f$export$d03236bd7c374ce6 = {}));
const $d0f8aae9e6f7e80f$export$96e9906d6d93a972 = {
    parse (r) {
        return Object.assign(Object.assign({}, r), {
            dataParsed: r.data != null ? JSON.parse(r.data) : {}
        });
    }
};


// @generated by TypeGen from LogbookModel/Status/ShipStatus.swift - DO NOT EDIT
var $58e03ea0c4d227bb$export$a923b2e0216c55ec;
(function(IShipStatus) {
    IShipStatus[IShipStatus["none"] = -1] = "none";
    IShipStatus[IShipStatus["inmotion"] = 0] = "inmotion";
    IShipStatus[IShipStatus["drifting"] = 1] = "drifting";
    IShipStatus[IShipStatus["port"] = 2] = "port";
    IShipStatus[IShipStatus["anchor"] = 3] = "anchor";
    IShipStatus[IShipStatus["buoy"] = 4] = "buoy";
    IShipStatus[IShipStatus["bunkering"] = 5] = "bunkering";
    IShipStatus[IShipStatus["lock"] = 6] = "lock";
    IShipStatus[IShipStatus["bridge"] = 7] = "bridge";
    IShipStatus[IShipStatus["waiting"] = 8] = "waiting";
})($58e03ea0c4d227bb$export$a923b2e0216c55ec || ($58e03ea0c4d227bb$export$a923b2e0216c55ec = {}));


// @generated by TypeGen from LogbookModel/Status/EngineStatus.swift - DO NOT EDIT
var $7045b0c2c870ef8a$export$e0db0830eb9f13ff;
(function(IEngineStatus) {
    IEngineStatus[IEngineStatus["off"] = 0] = "off";
    IEngineStatus[IEngineStatus["running"] = 1] = "running";
    IEngineStatus[IEngineStatus["idle"] = 2] = "idle";
})($7045b0c2c870ef8a$export$e0db0830eb9f13ff || ($7045b0c2c870ef8a$export$e0db0830eb9f13ff = {}));


// @generated by TypeGen from LogbookApp/AppStatus.swift - DO NOT EDIT
var $2a692caa93051c23$export$c1d9595bd9dd489e;
(function(ILogbookAppInternetStatus) {
    ILogbookAppInternetStatus["connected"] = "connected";
    ILogbookAppInternetStatus["failed"] = "failed";
})($2a692caa93051c23$export$c1d9595bd9dd489e || ($2a692caa93051c23$export$c1d9595bd9dd489e = {}));
var $2a692caa93051c23$export$e12d1a3b018307ad;
(function(ILogbookAppNMEAConnectionStatus) {
    ILogbookAppNMEAConnectionStatus["connected"] = "connected";
    ILogbookAppNMEAConnectionStatus["connectionFailed"] = "connectionFailed";
    ILogbookAppNMEAConnectionStatus["connectPending"] = "connectPending";
    ILogbookAppNMEAConnectionStatus["disconnected"] = "disconnected";
    ILogbookAppNMEAConnectionStatus["notConfigured"] = "notConfigured";
    ILogbookAppNMEAConnectionStatus["waitingForData"] = "waitingForData";
    ILogbookAppNMEAConnectionStatus["verifyingConnection"] = "verifyingConnection";
})($2a692caa93051c23$export$e12d1a3b018307ad || ($2a692caa93051c23$export$e12d1a3b018307ad = {}));
var $2a692caa93051c23$export$f38883ffc2a1d5cb;
(function(ILogbookSyncStatus) {
    ILogbookSyncStatus["uninitialized"] = "uninitialized";
    ILogbookSyncStatus["failed"] = "failed";
    ILogbookSyncStatus["initialSyncFailed"] = "initialSyncFailed";
    ILogbookSyncStatus["initialSyncInProgress"] = "initialSyncInProgress";
    ILogbookSyncStatus["dataWaiting"] = "dataWaiting";
    ILogbookSyncStatus["inProgress"] = "inProgress";
    ILogbookSyncStatus["current"] = "current";
    ILogbookSyncStatus["paused"] = "paused";
    ILogbookSyncStatus["selectShip"] = "selectShip";
    ILogbookSyncStatus["selectShipFailed"] = "selectShipFailed";
    ILogbookSyncStatus["disconnected"] = "disconnected";
    ILogbookSyncStatus["resync"] = "resync";
    ILogbookSyncStatus["transition"] = "transition";
    ILogbookSyncStatus["sessionExpired"] = "sessionExpired";
})($2a692caa93051c23$export$f38883ffc2a1d5cb || ($2a692caa93051c23$export$f38883ffc2a1d5cb = {}));


// @generated by TypeGen from LogbookNavigation/StatelessNavigation.swift - DO NOT EDIT
var $ecb722ec4ee6c8d2$export$852477b5f0e5324c;
(function(INavigationRecordingStatus) {
    INavigationRecordingStatus["recording"] = "recording";
    INavigationRecordingStatus["paused"] = "paused";
    INavigationRecordingStatus["stopped"] = "stopped";
})($ecb722ec4ee6c8d2$export$852477b5f0e5324c || ($ecb722ec4ee6c8d2$export$852477b5f0e5324c = {}));


// Frontend-only app-status types with no Swift backing (re-homed from the former
// hand-written AppStatus/AppNMEAStatus mirrors during the #627 TypeGen migration).
var $01179e25910e972d$export$ab585c2fd9190e3d;
(function(INMEAStatusMode) {
    INMEAStatusMode["recordingAutoEntries"] = "recordingAutoEntries";
    INMEAStatusMode["recording"] = "recording";
    INMEAStatusMode["notRecording"] = "notRecording";
})($01179e25910e972d$export$ab585c2fd9190e3d || ($01179e25910e972d$export$ab585c2fd9190e3d = {}));


// @generated by TypeGen from LogbookModel/StoredCalculation.swift - DO NOT EDIT
var $0e9fc80557c7dff1$export$2bc642d888abd6fb;
(function(IStoredCalculationSource) {
    IStoredCalculationSource[IStoredCalculationSource["day"] = 1] = "day";
    IStoredCalculationSource[IStoredCalculationSource["trip"] = 2] = "trip";
    IStoredCalculationSource[IStoredCalculationSource["cruise"] = 3] = "cruise";
    IStoredCalculationSource[IStoredCalculationSource["log"] = 4] = "log";
    IStoredCalculationSource[IStoredCalculationSource["status"] = 5] = "status";
    IStoredCalculationSource[IStoredCalculationSource["ship"] = 6] = "ship";
    IStoredCalculationSource[IStoredCalculationSource["test"] = 100] = "test";
})($0e9fc80557c7dff1$export$2bc642d888abd6fb || ($0e9fc80557c7dff1$export$2bc642d888abd6fb = {}));
const $0e9fc80557c7dff1$export$9e1e43c7c8d1b652 = {
    parse (r) {
        return Object.assign(Object.assign({}, r), {
            dataParsed: r.data != null ? JSON.parse(r.data) : {}
        });
    }
};


// @generated by TypeGen from LogbookModel/Track.swift - DO NOT EDIT
var $74ddf98d45710879$export$a9ec73fef5890395;
(function(ITrackType) {
    ITrackType[ITrackType["track"] = 0] = "track";
    ITrackType[ITrackType["anchor"] = 1] = "anchor";
    ITrackType[ITrackType["ais"] = 2] = "ais";
})($74ddf98d45710879$export$a9ec73fef5890395 || ($74ddf98d45710879$export$a9ec73fef5890395 = {}));


// @generated by TypeGen from LogbookModel/Weather.swift - DO NOT EDIT
var $71e8e61ce57bd992$export$40f41d7af1b23b92;
(function(ILogWeather) {
    ILogWeather[ILogWeather["clearSky"] = 1] = "clearSky";
    ILogWeather[ILogWeather["fine"] = 2] = "fine";
    ILogWeather[ILogWeather["halfCloud"] = 3] = "halfCloud";
    ILogWeather[ILogWeather["cloudy"] = 4] = "cloudy";
    ILogWeather[ILogWeather["overcast"] = 5] = "overcast";
    ILogWeather[ILogWeather["drizzle"] = 6] = "drizzle";
    ILogWeather[ILogWeather["moderateRain"] = 7] = "moderateRain";
    ILogWeather[ILogWeather["heavyRain"] = 8] = "heavyRain";
    ILogWeather[ILogWeather["showerOfRain"] = 9] = "showerOfRain";
    ILogWeather[ILogWeather["haze"] = 10] = "haze";
    ILogWeather[ILogWeather["mist"] = 11] = "mist";
    ILogWeather[ILogWeather["fog"] = 12] = "fog";
    ILogWeather[ILogWeather["sleet"] = 13] = "sleet";
    ILogWeather[ILogWeather["hail"] = 14] = "hail";
    ILogWeather[ILogWeather["thunderstorm"] = 15] = "thunderstorm";
    ILogWeather[ILogWeather["snow"] = 16] = "snow";
})($71e8e61ce57bd992$export$40f41d7af1b23b92 || ($71e8e61ce57bd992$export$40f41d7af1b23b92 = {}));


// @generated by TypeGen from LogbookModel/Settings.swift - DO NOT EDIT
var $bdd927c6c90fec0d$export$10bc32ab3a8a0f49;
(function(ISettingsType) {
    ISettingsType[ISettingsType["account"] = 1] = "account";
    ISettingsType[ISettingsType["user"] = 2] = "user";
    ISettingsType[ISettingsType["ship"] = 3] = "ship";
    ISettingsType[ISettingsType["shipData"] = 4] = "shipData";
    ISettingsType[ISettingsType["test"] = 100] = "test";
})($bdd927c6c90fec0d$export$10bc32ab3a8a0f49 || ($bdd927c6c90fec0d$export$10bc32ab3a8a0f49 = {}));
const $bdd927c6c90fec0d$export$c72f6eaae7b9adff = {
    parse (r) {
        return Object.assign(Object.assign({}, r), {
            dataParsed: r.data != null ? JSON.parse(r.data) : {}
        });
    }
};


// @generated by TypeGen from LogbookModel/Settings/ShipSettings.swift - DO NOT EDIT
var $7bbbb4844e018774$export$42da589e9ff495e5;
(function(ILightsReminderLead) {
    ILightsReminderLead[ILightsReminderLead["official"] = 0] = "official";
    ILightsReminderLead[ILightsReminderLead["civil"] = 1] = "civil";
})($7bbbb4844e018774$export$42da589e9ff495e5 || ($7bbbb4844e018774$export$42da589e9ff495e5 = {}));
var $7bbbb4844e018774$export$a10906fe7aaac3b8;
(function(IUnitCurrency) {
    IUnitCurrency["eur"] = "eur";
    IUnitCurrency["usd"] = "usd";
    IUnitCurrency["gbp"] = "gbp";
    IUnitCurrency["jpy"] = "jpy";
    IUnitCurrency["aud"] = "aud";
    IUnitCurrency["nzd"] = "nzd";
    IUnitCurrency["chf"] = "chf";
    IUnitCurrency["sek"] = "sek";
    IUnitCurrency["nok"] = "nok";
    IUnitCurrency["dkk"] = "dkk";
})($7bbbb4844e018774$export$a10906fe7aaac3b8 || ($7bbbb4844e018774$export$a10906fe7aaac3b8 = {}));
var $7bbbb4844e018774$export$f3cf4596788fb90f;
(function(IUnitCurrent) {
    IUnitCurrent["kn"] = "kn";
    IUnitCurrent["kmh"] = "kmh";
})($7bbbb4844e018774$export$f3cf4596788fb90f || ($7bbbb4844e018774$export$f3cf4596788fb90f = {}));
var $7bbbb4844e018774$export$67282d4eef50b63;
(function(IUnitDistance) {
    IUnitDistance["nm"] = "nm";
    IUnitDistance["miles"] = "miles";
    IUnitDistance["km"] = "km";
})($7bbbb4844e018774$export$67282d4eef50b63 || ($7bbbb4844e018774$export$67282d4eef50b63 = {}));
var $7bbbb4844e018774$export$4e14a41e7458b586;
(function(IUnitLength) {
    IUnitLength["m"] = "m";
    IUnitLength["cm"] = "cm";
    IUnitLength["ft"] = "ft";
    IUnitLength["inch"] = "inch";
    IUnitLength["yard"] = "yard";
})($7bbbb4844e018774$export$4e14a41e7458b586 || ($7bbbb4844e018774$export$4e14a41e7458b586 = {}));
var $7bbbb4844e018774$export$b9afc54769e2ce7d;
(function(IUnitPower) {
    IUnitPower["kw"] = "kw";
    IUnitPower["hp"] = "hp";
})($7bbbb4844e018774$export$b9afc54769e2ce7d || ($7bbbb4844e018774$export$b9afc54769e2ce7d = {}));
var $7bbbb4844e018774$export$d2fec679848e7245;
(function(IUnitPressure) {
    IUnitPressure["hpa"] = "hPa";
    IUnitPressure["bar"] = "bar";
    IUnitPressure["psi"] = "psi";
})($7bbbb4844e018774$export$d2fec679848e7245 || ($7bbbb4844e018774$export$d2fec679848e7245 = {}));
var $7bbbb4844e018774$export$ea429959941181e6;
(function(IUnitSpeed) {
    IUnitSpeed["kn"] = "kn";
    IUnitSpeed["kmh"] = "kmh";
    IUnitSpeed["mph"] = "mph";
})($7bbbb4844e018774$export$ea429959941181e6 || ($7bbbb4844e018774$export$ea429959941181e6 = {}));
var $7bbbb4844e018774$export$9914f13c18a9e8e2;
(function(IUnitSurface) {
    IUnitSurface["m2"] = "m2";
    IUnitSurface["sqft"] = "sqft";
    IUnitSurface["sqyd"] = "sqyd";
})($7bbbb4844e018774$export$9914f13c18a9e8e2 || ($7bbbb4844e018774$export$9914f13c18a9e8e2 = {}));
var $7bbbb4844e018774$export$ee8ffdd108a6d394;
(function(IUnitTemperature) {
    IUnitTemperature["celsius"] = "celsius";
    IUnitTemperature["fahrenheit"] = "fahrenheit";
})($7bbbb4844e018774$export$ee8ffdd108a6d394 || ($7bbbb4844e018774$export$ee8ffdd108a6d394 = {}));
var $7bbbb4844e018774$export$662bb6c25c72292;
(function(IUnitVolume) {
    IUnitVolume["l"] = "l";
    IUnitVolume["gal"] = "gal";
    IUnitVolume["m3"] = "m3";
    IUnitVolume["cuft"] = "cuft";
})($7bbbb4844e018774$export$662bb6c25c72292 || ($7bbbb4844e018774$export$662bb6c25c72292 = {}));
var $7bbbb4844e018774$export$577a7cb5ce16402e;
(function(IUnitWeight) {
    IUnitWeight["kg"] = "kg";
    IUnitWeight["lb"] = "lb";
    IUnitWeight["tons"] = "tons";
})($7bbbb4844e018774$export$577a7cb5ce16402e || ($7bbbb4844e018774$export$577a7cb5ce16402e = {}));
var $7bbbb4844e018774$export$4358b71b4c92dc0d;
(function(IUnitWind) {
    IUnitWind["kn"] = "kn";
    IUnitWind["mps"] = "mps";
    IUnitWind["kmh"] = "kmh";
})($7bbbb4844e018774$export$4358b71b4c92dc0d || ($7bbbb4844e018774$export$4358b71b4c92dc0d = {}));


// Frontend-only settings residue with no Swift source (kept hand-written).

const $1b996d42088c0aac$export$5de13be7a3ac8b6e = {
    length: (0, $7bbbb4844e018774$export$4e14a41e7458b586).m,
    weight: (0, $7bbbb4844e018774$export$577a7cb5ce16402e).kg,
    speed: (0, $7bbbb4844e018774$export$ea429959941181e6).kn,
    temperature: (0, $7bbbb4844e018774$export$ee8ffdd108a6d394).celsius,
    volume: (0, $7bbbb4844e018774$export$662bb6c25c72292).l,
    surface: (0, $7bbbb4844e018774$export$9914f13c18a9e8e2).m2,
    currency: (0, $7bbbb4844e018774$export$a10906fe7aaac3b8).eur,
    distance: (0, $7bbbb4844e018774$export$67282d4eef50b63).nm,
    power: (0, $7bbbb4844e018774$export$b9afc54769e2ce7d).kw,
    wind: (0, $7bbbb4844e018774$export$4358b71b4c92dc0d).kn,
    pressure: (0, $7bbbb4844e018774$export$d2fec679848e7245).hpa,
    current: (0, $7bbbb4844e018774$export$f3cf4596788fb90f).kn
};


// @generated by TypeGen from LogbookModel/EditPermissiveness.swift - DO NOT EDIT
var $8cadfca9ff813a6b$export$c29fa95cc336234d;
(function(IDayEditableField) {
    IDayEditableField["comment"] = "comment";
    IDayEditableField["crew"] = "crew";
    IDayEditableField["endLocation"] = "endLocation";
    IDayEditableField["passengers"] = "passengers";
    IDayEditableField["skipper"] = "skipper";
    IDayEditableField["startLocation"] = "startLocation";
})($8cadfca9ff813a6b$export$c29fa95cc336234d || ($8cadfca9ff813a6b$export$c29fa95cc336234d = {}));
var $8cadfca9ff813a6b$export$c686a6b62750a1a2;
(function(IEditPermissivenessLevel) {
    IEditPermissivenessLevel["strict"] = "strict";
    IEditPermissivenessLevel["extended"] = "extended";
    IEditPermissivenessLevel["unrestricted"] = "unrestricted";
})($8cadfca9ff813a6b$export$c686a6b62750a1a2 || ($8cadfca9ff813a6b$export$c686a6b62750a1a2 = {}));
var $8cadfca9ff813a6b$export$e1325bf74d86b103;
(function(ILogEditableField) {
    ILogEditableField["comment"] = "comment";
    ILogEditableField["course"] = "course";
    ILogEditableField["currentDirection"] = "currentDirection";
    ILogEditableField["currentSpeed"] = "currentSpeed";
    ILogEditableField["depth"] = "depth";
    ILogEditableField["distance"] = "distance";
    ILogEditableField["engineRpms"] = "engineRpms";
    ILogEditableField["heading"] = "heading";
    ILogEditableField["humidity"] = "humidity";
    ILogEditableField["location"] = "location";
    ILogEditableField["log"] = "log";
    ILogEditableField["pressure"] = "pressure";
    ILogEditableField["seaState"] = "seaState";
    ILogEditableField["sog"] = "sog";
    ILogEditableField["stw"] = "stw";
    ILogEditableField["temperature"] = "temperature";
    ILogEditableField["watch"] = "watch";
    ILogEditableField["watchComment"] = "watchComment";
    ILogEditableField["weather"] = "weather";
    ILogEditableField["windDirection"] = "windDirection";
    ILogEditableField["windSpeed"] = "windSpeed";
})($8cadfca9ff813a6b$export$e1325bf74d86b103 || ($8cadfca9ff813a6b$export$e1325bf74d86b103 = {}));
var $8cadfca9ff813a6b$export$19114abfe69433ac;
(function(ILogFieldEditability) {
    ILogFieldEditability["always"] = "always";
    ILogFieldEditability["nmeaCapable"] = "nmeaCapable";
    ILogFieldEditability["locked"] = "locked";
})($8cadfca9ff813a6b$export$19114abfe69433ac || ($8cadfca9ff813a6b$export$19114abfe69433ac = {}));


// @generated by TypeGen from LogbookModel/AuditLogEdit.swift - DO NOT EDIT
var $1e7307a9deb5d870$export$7a8d48a427db5d28;
(function(IAuditLogEditOrigin) {
    IAuditLogEditOrigin["manual"] = "manual";
    IAuditLogEditOrigin["nmea"] = "nmea";
    IAuditLogEditOrigin["system"] = "system";
})($1e7307a9deb5d870$export$7a8d48a427db5d28 || ($1e7307a9deb5d870$export$7a8d48a427db5d28 = {}));
var $1e7307a9deb5d870$export$6322af8f4e594d6e;
(function(IAuditLogEditSource) {
    IAuditLogEditSource[IAuditLogEditSource["log"] = 1] = "log";
    IAuditLogEditSource[IAuditLogEditSource["day"] = 2] = "day";
    IAuditLogEditSource[IAuditLogEditSource["status"] = 3] = "status";
    IAuditLogEditSource[IAuditLogEditSource["test"] = 100] = "test";
})($1e7307a9deb5d870$export$6322af8f4e594d6e || ($1e7307a9deb5d870$export$6322af8f4e594d6e = {}));


// @generated by TypeGen from LogbookModel/User.swift - DO NOT EDIT
var $d7e17f9058b5631e$export$9e11552336c87dd5;
(function(IUserAuthenticationType) {
    IUserAuthenticationType[IUserAuthenticationType["none"] = 0] = "none";
    IUserAuthenticationType[IUserAuthenticationType["invited"] = 1] = "invited";
    IUserAuthenticationType[IUserAuthenticationType["password"] = 2] = "password";
    IUserAuthenticationType[IUserAuthenticationType["apple"] = 3] = "apple";
    IUserAuthenticationType[IUserAuthenticationType["google"] = 4] = "google";
    IUserAuthenticationType[IUserAuthenticationType["client"] = 10] = "client";
})($d7e17f9058b5631e$export$9e11552336c87dd5 || ($d7e17f9058b5631e$export$9e11552336c87dd5 = {}));




const $91325a4554765f0c$var$d = new Date().toISOString();
function $91325a4554765f0c$export$d2d39d1adcc883a2(date) {
    return (date.getTime() - new Date(Date.UTC(2001, 0, 1)).getTime()) / 86400000;
}
function $91325a4554765f0c$var$parseDuration(timeStr) {
    const parts = timeStr.split(":").map(Number);
    if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
    else if (parts.length === 2) return parts[0] * 3600 + parts[1] * 60;
    return 0;
}
function $91325a4554765f0c$export$37bdcf3caafe9737(fullData = true) {
    const ship = {
        id: 1,
        accountId: 1,
        createdAt: $91325a4554765f0c$var$d,
        updatedAt: $91325a4554765f0c$var$d,
        engineCount: 2,
        name: "Lipoza",
        vesselType: (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).sailing,
        shipData: {
            name: "Lipoza",
            engineCount: 2,
            vesselType: (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).sailing,
            mmsi: "211234567",
            callsign: "DF1234",
            engines: [
                {
                    id: "1",
                    number: 1,
                    nmeaNumber: 1,
                    engineShortName: "Starboard",
                    name: "Starboard",
                    type: "inboard",
                    fuelType: "diesel"
                },
                {
                    id: "2",
                    number: 2,
                    nmeaNumber: 2,
                    engineShortName: "Portside",
                    name: "Portside",
                    type: "inboard",
                    fuelType: "diesel"
                }
            ],
            sails: [
                {
                    id: "mainsail",
                    sail: "mainsail",
                    sailType: "mast",
                    reefNo: 3
                },
                {
                    id: "parasailor",
                    sail: "parasailor",
                    sailType: "forestay",
                    reefNo: 0
                }
            ]
        }
    };
    const data = {
        account: {
            id: 1,
            createdAt: $91325a4554765f0c$var$d,
            updatedAt: $91325a4554765f0c$var$d,
            accountSubscriptionPlanId: 1,
            name: "Test Account",
            slug: "test-account",
            metadata: "{}",
            subscriptionStatus: 1
        },
        cruises: [
            {
                id: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "",
                startedAt: undefined,
                completedAt: undefined,
                data: "{}"
            }
        ],
        days: [
            {
                id: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 1,
                tripId: 1,
                data: "{}",
                day: 0,
                timezone: 0,
                startLocation: "",
                endLocation: "",
                calculated: {
                    duration: 0,
                    sog: 0,
                    distance: 0,
                    dayStatusButton: "none",
                    dayStatus: "none",
                    nightStatusButton: "none",
                    nightStatus: "none"
                }
            }
        ],
        logs: [],
        statuses: [],
        session: {
            id: "deadbeef",
            authorized: true,
            accountId: 1,
            userId: 1
        },
        ship: ship,
        ships: [
            ship
        ],
        settings: [
            {
                id: 1,
                accountId: 1,
                shipId: ship.id,
                userId: 0,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                settingType: (0, $bdd927c6c90fec0d$export$10bc32ab3a8a0f49).shipData,
                data: JSON.stringify(ship.shipData)
            }
        ],
        shipUsers: [
            {
                id: 1,
                accountId: 1,
                shipId: 1,
                userId: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                active: 1,
                name: "Captain John",
                shortname: "John",
                email: "john@example.com",
                shipUserLevel: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary,
                shipUserCrewRole: (0, $dc7739d612f0c536$export$1e4ade51a6368243).skipper,
                data: "{}"
            },
            {
                id: 2,
                accountId: 1,
                shipId: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                active: 1,
                name: "Sarah Miller",
                shortname: "Sarah",
                email: "sarah@example.com",
                shipUserLevel: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent,
                shipUserCrewRole: (0, $dc7739d612f0c536$export$1e4ade51a6368243).crew,
                data: "{}"
            }
        ],
        tracks: [],
        trips: [
            {
                id: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 1,
                title: "",
                timezone: 0,
                startedAt: undefined,
                completedAt: undefined,
                data: "{}"
            }
        ],
        user: {
            id: 1,
            createdAt: $91325a4554765f0c$var$d,
            updatedAt: $91325a4554765f0c$var$d,
            authenticationType: 0,
            name: "DemoUser",
            email: "testuser@example.com",
            shortname: "DemoUser"
        }
    };
    if (fullData) return Object.assign(data, {
        cruises: [
            {
                id: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "Mediterranean Sea 1",
                startedAt: new Date(Date.UTC(2023, 5, 9)).toISOString(),
                completedAt: new Date(Date.UTC(2023, 5, 9)).toISOString(),
                data: "{}"
            },
            {
                id: 2,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "Mediterranean Sea 2",
                startedAt: new Date(Date.UTC(2023, 7, 12)).toISOString(),
                completedAt: new Date(Date.UTC(2023, 9, 5)).toISOString(),
                data: "{}"
            },
            {
                id: 3,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "To Canary Islands",
                startedAt: new Date(Date.UTC(2023, 9, 9)).toISOString(),
                completedAt: new Date(Date.UTC(2023, 11, 7)).toISOString(),
                data: "{}"
            },
            {
                id: 4,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "Canary Islands 2024 - 1",
                startedAt: new Date(Date.UTC(2024, 0, 9)).toISOString(),
                completedAt: new Date(Date.UTC(2024, 1, 13)).toISOString(),
                data: "{}"
            },
            {
                id: 5,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "Canary Islands 2024 - 2",
                startedAt: new Date(Date.UTC(2024, 2, 27)).toISOString(),
                completedAt: new Date(Date.UTC(2024, 3, 25)).toISOString(),
                data: "{}"
            },
            {
                id: 6,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "Canary Islands 2024 - 3",
                startedAt: new Date(Date.UTC(2024, 7, 9)).toISOString(),
                completedAt: new Date(Date.UTC(2024, 8, 25)).toISOString(),
                data: "{}"
            },
            {
                id: 7,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "Canary Islands 2025",
                startedAt: new Date(Date.UTC(2025, 1, 18)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 4, 20)).toISOString(),
                data: "{}"
            },
            {
                id: 8,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "Back to Mediterranean Sea",
                startedAt: new Date(Date.UTC(2025, 4, 29)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 5, 19)).toISOString(),
                data: "{}"
            },
            // used for timeline and day view in demo
            {
                id: 9,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "Mediterranean Sea",
                startedAt: new Date(Date.UTC(2025, 5, 24)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 9, 16)).toISOString(),
                data: "{}",
                calculated: {
                    distance: 1186,
                    distanceUnderEngine: 148,
                    distanceUnderSails: 1038,
                    duration: $91325a4554765f0c$var$parseDuration("634:18"),
                    durationCruising: $91325a4554765f0c$var$parseDuration("509:56"),
                    durationPaused: $91325a4554765f0c$var$parseDuration("124:22"),
                    durationUnderEngine: $91325a4554765f0c$var$parseDuration("149:38"),
                    durationUnderSails: $91325a4554765f0c$var$parseDuration("634:19"),
                    engines: [
                        {
                            number: 1,
                            distance: 109.4,
                            duration: $91325a4554765f0c$var$parseDuration("131:34")
                        },
                        {
                            number: 2,
                            distance: 111.8,
                            duration: $91325a4554765f0c$var$parseDuration("634:19")
                        }
                    ],
                    sog: 2.33
                }
            },
            {
                id: 10,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "To Canary Islands",
                startedAt: new Date(Date.UTC(2025, 9, 17)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 9, 23)).toISOString(),
                data: "{}"
            },
            {
                id: 11,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "To Cap Verdes",
                startedAt: new Date(Date.UTC(2025, 10, 25)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 11, 8)).toISOString(),
                data: "{}"
            },
            {
                id: 12,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "To Caribbean",
                startedAt: new Date(Date.UTC(2025, 11, 9)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 11, 21)).toISOString(),
                data: "{}"
            },
            {
                id: 13,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "Caribbean",
                startedAt: new Date(Date.UTC(2025, 11, 22)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 11, 31)).toISOString(),
                data: "{}"
            },
            {
                id: 14,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                title: "Caribbean 2026",
                startedAt: new Date(Date.UTC(2026, 0, 1)).toISOString(),
                data: "{}"
            }
        ],
        days: [
            // this are the days for the trip used in the timeline and day view demo
            {
                id: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                data: "{}",
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 5, 24))),
                timezone: 2,
                comment: "Start of the passage to Ibiza",
                startLocation: "Malaga",
                endLocation: "Playa la Caletta",
                calculated: {
                    duration: $91325a4554765f0c$var$parseDuration("1:02"),
                    sog: 0.5,
                    distance: 0.5
                }
            },
            {
                id: 2,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                data: "{}",
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 5, 25))),
                timezone: 2,
                startLocation: "Playa la Caletta",
                endLocation: "Cala de Canuela",
                calculated: {
                    duration: $91325a4554765f0c$var$parseDuration("19:44"),
                    sog: 0.9,
                    distance: 17.6
                }
            },
            {
                id: 3,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                data: "{}",
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 5, 26))),
                timezone: 2,
                startLocation: "Cala de Canuela",
                endLocation: "Ensenada de San Miguel",
                calculated: {
                    duration: $91325a4554765f0c$var$parseDuration("9:53"),
                    sog: 2.8,
                    distance: 27.5
                }
            },
            // this day is used for the day view demo
            {
                id: 6,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 5, 27))),
                timezone: 7200,
                startLocation: "Ensenada de San Miguel",
                endLocation: "Fondeadero del morron",
                skipper: 1,
                crew: [
                    1,
                    2
                ],
                passengers: [],
                comment: "Nice sailing day with good wind conditions",
                calculated: {
                    dayStatusButton: "inmotion",
                    dayStatus: "inmotion",
                    daysRun: 71.7,
                    distance: 19.8,
                    distanceUnderEngine: 1.2,
                    distanceUnderSails: 18.7,
                    duration: $91325a4554765f0c$var$parseDuration("6:38"),
                    durationCruising: $91325a4554765f0c$var$parseDuration("6:38"),
                    durationPaused: 0,
                    durationUnderEngine: $91325a4554765f0c$var$parseDuration("1:20"),
                    durationUnderSails: $91325a4554765f0c$var$parseDuration("5:49"),
                    engines: [
                        {
                            number: 1,
                            distance: 2.1,
                            duration: $91325a4554765f0c$var$parseDuration("1:20")
                        },
                        {
                            number: 2,
                            distance: 1.2,
                            duration: $91325a4554765f0c$var$parseDuration("0:46")
                        }
                    ],
                    sog: 3.0,
                    sunrise: new Date(Date.UTC(2025, 5, 27, 4, 22)).toISOString(),
                    sunset: new Date(Date.UTC(2025, 5, 27, 19, 12)).toISOString()
                }
            },
            {
                id: 7,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                data: "{}",
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 5, 28))),
                timezone: 2,
                startLocation: "Fondeadero del morron",
                endLocation: "Ensenada de la Fuente",
                calculated: {
                    duration: $91325a4554765f0c$var$parseDuration("13:22"),
                    sog: 2.2,
                    distance: 28.9
                }
            },
            {
                id: 8,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                data: "{}",
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 5, 29))),
                timezone: 2,
                startLocation: "Ensenada de la Fuente",
                endLocation: "Cabo de Palos",
                calculated: {
                    duration: $91325a4554765f0c$var$parseDuration("9:21:38"),
                    sog: 2.8,
                    distance: 26.5
                }
            },
            // this day has a note (Journal) but no log entries -- the #1137 "note on an
            // otherwise blank day" scenario, once the deferred day+note creation completes
            {
                id: 9,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                data: "{}",
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 5, 30))),
                timezone: 2
            },
            // no day rows at all for 7/1-7/6 -- #1137's fillDayGaps synthesizes 6 (>5)
            // consecutive blank/gap DayViews here, used by the "with-days" catalog fixture
            {
                id: 13,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                data: "{}",
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 6, 7))),
                timezone: 2,
                comment: "Arrived at Ibiza",
                startLocation: "Cabo de Palos",
                endLocation: "Isla de Tabarca",
                calculated: {
                    duration: $91325a4554765f0c$var$parseDuration("15:35"),
                    sog: 1.3,
                    distance: 21.0
                }
            },
            // this are days for trip 2
            {
                id: 16,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 2,
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 6, 8))),
                timezone: 2,
                startLocation: "Cala Sa Caixota",
                endLocation: "Cala Porroig",
                calculated: {
                    duration: $91325a4554765f0c$var$parseDuration("2:40"),
                    sog: 0.1,
                    distance: 0.4
                }
            },
            {
                id: 17,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 2,
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 6, 9))),
                timezone: 2,
                startLocation: "Cala Porroig",
                endLocation: "El Pelblet de Torrent",
                calculated: {
                    duration: $91325a4554765f0c$var$parseDuration("11:34"),
                    sog: 1.3,
                    distance: 12.7
                }
            },
            {
                id: 18,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 2,
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 6, 10))),
                timezone: 2,
                startLocation: "El Pelblet de Torrent",
                endLocation: "Platja Cala Nova",
                calculated: {
                    duration: $91325a4554765f0c$var$parseDuration("4:46"),
                    sog: 2.7,
                    distance: 12.8
                }
            },
            {
                id: 19,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 10,
                tripId: 2,
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 6, 11))),
                timezone: 2
            },
            {
                id: 20,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 2,
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 6, 12))),
                timezone: 2
            },
            {
                id: 21,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 2,
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 6, 13))),
                timezone: 2
            },
            {
                id: 22,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 2,
                day: $91325a4554765f0c$export$d2d39d1adcc883a2(new Date(Date.UTC(2025, 6, 14))),
                timezone: 2
            }
        ],
        logs: [
            {
                id: 0,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 41580,
                timeUtc: 34380,
                timezone: 7200,
                comment: "Start of pause",
                sog: 0,
                course: 301,
                distance: 0.0,
                engineRpms: [
                    0,
                    0,
                    0
                ]
            },
            {
                id: 11,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 41580,
                timeUtc: 34380,
                timezone: 7200,
                comment: "Started engine #1",
                sog: 0,
                course: 301,
                distance: 0.0,
                engineRpms: [
                    0,
                    1800,
                    0
                ]
            },
            {
                id: 12,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 41940,
                timeUtc: 34740,
                timezone: 7200,
                comment: "Anchor up",
                sog: 0.3,
                course: 360,
                distance: 0.0,
                engineRpms: [
                    0,
                    1800,
                    0
                ]
            },
            {
                id: 13,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 42000,
                timeUtc: 34800,
                timezone: 7200,
                comment: "End of pause after 0:07",
                sog: 0.3,
                course: 360,
                distance: 0.0,
                engineRpms: [
                    0,
                    1800,
                    0
                ]
            },
            {
                id: 14,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 42060,
                timeUtc: 34860,
                timezone: 7200,
                comment: "Course change 167\xb0",
                sog: 0.9,
                course: 193,
                distance: 0.1,
                engineRpms: [
                    0,
                    1800,
                    0
                ]
            },
            {
                id: 15,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 42060,
                timeUtc: 34860,
                timezone: 7200,
                comment: "Started engine #2",
                sog: 0.9,
                course: 193,
                distance: 0.1,
                engineRpms: [
                    0,
                    1800,
                    1800
                ]
            },
            {
                id: 16,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 42180,
                timeUtc: 34980,
                timezone: 7200,
                comment: "Course change 62\xb0",
                sog: 1.7,
                course: 131,
                distance: 0.1,
                engineRpms: [
                    0,
                    1800,
                    1800
                ]
            },
            {
                id: 17,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 42240,
                timeUtc: 35040,
                timezone: 7200,
                comment: "Mainsail + Parasailor up",
                sog: 2.0,
                course: 132,
                distance: 0.1,
                engineRpms: [
                    0,
                    1800,
                    1800
                ]
            },
            {
                id: 18,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 42300,
                timeUtc: 35100,
                timezone: 7200,
                comment: "Stopped engine #2 after 0:04 (0.1 nm)",
                sog: 2.3,
                course: 118,
                distance: 0.2,
                engineRpms: [
                    0,
                    1800,
                    0
                ]
            },
            {
                id: 19,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 42900,
                timeUtc: 35700,
                timezone: 7200,
                comment: "Started engine #2",
                sog: 2.2,
                course: 143,
                distance: 0.5,
                engineRpms: [
                    0,
                    1800,
                    1800
                ]
            },
            {
                id: 20,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 43020,
                timeUtc: 35820,
                timezone: 7200,
                comment: "Stopped engine #2 after 0:02 (0.1 nm)",
                sog: 2.7,
                course: 142,
                distance: 0.6,
                engineRpms: [
                    0,
                    1800,
                    0
                ]
            },
            {
                id: 21,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 43200,
                timeUtc: 36000,
                timezone: 7200,
                comment: "Automatic entry after 1:00",
                sog: 2.9,
                course: 128,
                distance: 0.8,
                engineRpms: [
                    0,
                    1800,
                    0
                ]
            },
            {
                id: 22,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 43620,
                timeUtc: 36420,
                timezone: 7200,
                comment: "Stopped engine #1 after 0:34 (1.0 nm)",
                sog: 1.5,
                course: 119,
                distance: 1.0,
                engineRpms: [
                    0,
                    0,
                    0
                ]
            },
            {
                id: 23,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 46800,
                timeUtc: 39600,
                timezone: 7200,
                comment: "Automatic entry after 1:00",
                sog: 2.8,
                stw: 2.5,
                course: 75,
                heading: 40,
                distance: 3.5,
                lat: 36.852,
                lng: -1.952,
                depth: 25.1,
                log: 25812,
                engineRpms: [
                    0,
                    0,
                    0
                ],
                windDirection: 203,
                windSpeed: 10,
                pressure: 1015.1,
                weather: (0, $71e8e61ce57bd992$export$40f41d7af1b23b92).clearSky,
                temperature: 24,
                seaState: "calm"
            },
            {
                id: 24,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 50400,
                timeUtc: 43200,
                timezone: 7200,
                comment: "Automatic entry after 1:00",
                sog: 3.2,
                course: 86,
                distance: 6.8,
                engineRpms: [
                    0,
                    0,
                    0
                ]
            },
            {
                id: 25,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 54000,
                timeUtc: 46800,
                timezone: 7200,
                comment: "Automatic entry after 1:00",
                sog: 2.9,
                course: 88,
                distance: 9.7,
                engineRpms: [
                    0,
                    0,
                    0
                ]
            },
            {
                id: 26,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 57600,
                timeUtc: 50400,
                timezone: 7200,
                comment: "Automatic entry after 1:00",
                sog: 2.7,
                course: 84,
                distance: 12.4,
                engineRpms: [
                    0,
                    0,
                    0
                ]
            },
            {
                id: 27,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 61200,
                timeUtc: 54000,
                timezone: 7200,
                comment: "Automatic entry after 1:00",
                sog: 3.9,
                course: 84,
                distance: 16.4,
                engineRpms: [
                    0,
                    0,
                    0
                ]
            },
            {
                id: 28,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 63300,
                timeUtc: 56100,
                timezone: 7200,
                comment: "Started engine #1",
                sog: 4.1,
                course: 53,
                distance: 18.7,
                engineRpms: [
                    0,
                    1800,
                    0
                ]
            },
            {
                id: 29,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 63300,
                timeUtc: 56100,
                timezone: 7200,
                comment: "Started engine #2",
                sog: 4.1,
                course: 53,
                distance: 18.7,
                engineRpms: [
                    0,
                    1800,
                    1800
                ]
            },
            {
                id: 30,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 63300,
                timeUtc: 56100,
                timezone: 7200,
                comment: "Mainsail + Parasailor down",
                sog: 4.1,
                course: 53,
                distance: 18.7,
                engineRpms: [
                    0,
                    1800,
                    1800
                ]
            },
            {
                id: 31,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 63900,
                timeUtc: 56700,
                timezone: 7200,
                comment: "Course change 59\xb0",
                sog: 3.6,
                course: 353,
                distance: 19.3,
                engineRpms: [
                    0,
                    1800,
                    1800
                ]
            },
            {
                id: 32,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 64140,
                timeUtc: 56940,
                timezone: 7200,
                comment: "Course change 66\xb0",
                sog: 2.3,
                course: 287,
                distance: 19.4,
                engineRpms: [
                    0,
                    1800,
                    1800
                ]
            },
            {
                id: 33,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 64800,
                timeUtc: 57600,
                timezone: 7200,
                comment: "Automatic entry after 1:00",
                sog: 1.6,
                course: 59,
                distance: 19.7,
                engineRpms: [
                    0,
                    1800,
                    1800
                ]
            },
            {
                id: 34,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 65100,
                timeUtc: 57900,
                timezone: 7200,
                comment: "Anchor down at Fondeadero del morron",
                sog: 0.8,
                course: 329,
                distance: 19.8,
                engineRpms: [
                    0,
                    1800,
                    1800
                ]
            },
            {
                id: 35,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 65340,
                timeUtc: 58140,
                timezone: 7200,
                comment: "Start of pause",
                sog: 0.4,
                course: 212,
                distance: 19.8,
                engineRpms: [
                    0,
                    1800,
                    1800
                ]
            },
            {
                id: 36,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 65460,
                timeUtc: 58260,
                timezone: 7200,
                comment: "Stopped engine #1 after 0:46 (1.1 nm)",
                sog: 0.1,
                course: 261,
                distance: 19.8,
                engineRpms: [
                    0,
                    0,
                    1800
                ]
            },
            {
                id: 37,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                time: 65460,
                timeUtc: 58260,
                timezone: 7200,
                comment: "Stopped engine #2 after 0:46 (1.1 nm)",
                sog: 0.1,
                course: 261,
                distance: 19.8,
                engineRpms: [
                    0,
                    0,
                    0
                ]
            }
        ],
        statuses: [
            // Day 6 statuses - anchored overnight before departure
            {
                id: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                startLogId: 0,
                endLogId: 13,
                statusType: (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship,
                value: (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).anchor,
                data: JSON.stringify({
                    location: "Ensenada de San Miguel"
                })
            },
            // In motion during the day
            {
                id: 2,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                startLogId: 13,
                endLogId: 35,
                statusType: (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship,
                value: (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).inmotion,
                data: "{}"
            },
            // At anchor overnight after arrival
            {
                id: 3,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                startLogId: 35,
                statusType: (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship,
                value: (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).anchor,
                data: JSON.stringify({
                    location: "Fondeadero del morron"
                })
            },
            // Sails - Mainsail and Parasailor up from log 17 to 30
            {
                id: 4,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                startLogId: 17,
                endLogId: 30,
                statusType: (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).sails,
                name: "mainsail",
                value: 0,
                data: "{}"
            },
            {
                id: 5,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                dayId: 6,
                startLogId: 17,
                endLogId: 30,
                statusType: (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).sails,
                name: "parasailor",
                value: 0,
                data: "{}"
            }
        ],
        trips: [
            // this trip is used for data
            {
                id: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                title: "Andalusia to Ibiza",
                data: "{}",
                startedAt: new Date(Date.UTC(2025, 5, 24)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 6, 7)).toISOString(),
                timezone: 7200,
                calculated: {
                    daysLogbook: 9,
                    daysTotal: 14,
                    distance: 203.8,
                    distanceUnderEngine: 26.7,
                    distanceUnderSails: 177.1,
                    duration: $91325a4554765f0c$var$parseDuration("111:29"),
                    durationCruising: $91325a4554765f0c$var$parseDuration("110:25"),
                    durationPaused: $91325a4554765f0c$var$parseDuration("1:04"),
                    durationUnderEngine: $91325a4554765f0c$var$parseDuration("11:33"),
                    durationUnderSails: $91325a4554765f0c$var$parseDuration("98:52"),
                    engines: [
                        {
                            number: 1,
                            distance: 23.5,
                            duration: $91325a4554765f0c$var$parseDuration("9:59")
                        },
                        {
                            number: 2,
                            distance: 26.7,
                            duration: $91325a4554765f0c$var$parseDuration("11:25")
                        }
                    ],
                    sog: 2.11,
                    startLocation: "Malaga",
                    endLocation: "Cala Sa Caixota"
                }
            },
            {
                id: 2,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                title: "Ibiza to Marseille",
                startedAt: new Date(Date.UTC(2025, 6, 8)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 7, 21)).toISOString(),
                timezone: 7200,
                calculated: {
                    endLocation: "Pointe de Figuerolles",
                    startLocation: "Cala Sa Caixota"
                }
            },
            {
                id: 103,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                title: "Marseille",
                startedAt: new Date(Date.UTC(2025, 7, 22)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 7, 27)).toISOString(),
                timezone: 7200,
                endLocation: "near Marseille",
                startLocation: "Pointe de Figuerolles"
            },
            {
                id: 104,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                title: "Marseille to Illetas",
                startedAt: new Date(Date.UTC(2025, 7, 28)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 8, 6)).toISOString(),
                timezone: 7200,
                endLocation: "Illetas",
                startLocation: "near Marseille"
            },
            {
                id: 105,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                title: "Illetas to Formentera",
                startedAt: new Date(Date.UTC(2025, 8, 9)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 8, 20)).toISOString(),
                timezone: 7200,
                endLocation: "Formentera",
                startLocation: "Illetas"
            },
            {
                id: 106,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                title: "Formentera to Alicante",
                startedAt: new Date(Date.UTC(2025, 8, 22)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 8, 24)).toISOString(),
                timezone: 7200,
                endLocation: "Alcante",
                startLocation: "Formentera"
            },
            {
                id: 107,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                title: "Alicante to La Puebla del Rio",
                startedAt: new Date(Date.UTC(2025, 8, 25)).toISOString(),
                completedAt: new Date(Date.UTC(2025, 9, 16)).toISOString(),
                timezone: 7200,
                endLocation: "La Puebla del Rio",
                startLocation: "Alicante"
            }
        ],
        notes: [
            {
                id: 1,
                dayId: 6,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                data: "{}",
                noteType: (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).journal,
                title: "Perfect Sailing to Fondeadero del morron",
                note: "What an amazing day on the water! We left Ensenada de San Miguel early in the morning with a steady 15-knot breeze from the northeast. The conditions were perfect for sailing.\rWe had the mainsail and parasailor up for most of the journey, making excellent progress. Only needed to run the engine briefly for few minutes when leaving the anchorage. The sea state was calm with gentle 1-meter swells, and visibility was excellent all day.",
                date: new Date(Date.UTC(2025, 5, 27)).toISOString()
            },
            // #1137 -- a note on a day with no log entries at all (day 9 has no logs/route),
            // the deferred day+note creation scenario for the "with-days" catalog fixture
            {
                id: 2,
                dayId: 9,
                accountId: 1,
                shipId: 1,
                cruiseId: 9,
                tripId: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                data: "{}",
                noteType: (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).journal,
                title: "Resting at anchor",
                note: "Stayed at anchor all day to wait out the forecasted swell -- no need to log a passage today, so no route or log entries, just this note.",
                date: new Date(Date.UTC(2025, 5, 30)).toISOString()
            }
        ],
        attachments: [
            {
                id: 1,
                noteId: 1,
                accountId: 1,
                shipId: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                data: "{}",
                fileName: "dolphins-bow-wave",
                fileType: "jpg",
                contentType: "image/jpeg",
                checksum: "abc123",
                size: 245680,
                useUrl: true,
                url: "/demo/dolphins.jpg"
            },
            {
                id: 2,
                noteId: 1,
                accountId: 1,
                shipId: 1,
                createdAt: $91325a4554765f0c$var$d,
                updatedAt: $91325a4554765f0c$var$d,
                data: "{}",
                fileName: "sunset-anchorage",
                fileType: "jpg",
                contentType: "image/jpeg",
                checksum: "def456",
                size: 312450,
                useUrl: true,
                url: "/demo/sunset.jpg"
            }
        ]
    });
    return data;
}



const $0ffce56d54de6ef8$var$d = new Date().toISOString();
const $0ffce56d54de6ef8$export$ed6db8ac961f262d = new Date(Date.UTC(2026, 2, 29, 12, 41, 0)); // Month is 0-indexed, so 2 = March
const $0ffce56d54de6ef8$export$83e7587865f4b4e4 = 7200; // UTC+2 in seconds
function $0ffce56d54de6ef8$export$d2d39d1adcc883a2(date) {
    return Math.floor((date.getTime() - new Date(Date.UTC(2001, 0, 1)).getTime()) / 86400000);
}
function $0ffce56d54de6ef8$export$54a89be6af0881dc(date) {
    // Calculate seconds since midnight (UTC)
    const todayMidnightUTC = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    const timeUtc = Math.floor((date.valueOf() - todayMidnightUTC.valueOf()) / 1000);
    const timezone = $0ffce56d54de6ef8$export$83e7587865f4b4e4;
    const time = timeUtc + timezone;
    return {
        time: time,
        timeUtc: timeUtc,
        timezone: timezone
    };
}
function $0ffce56d54de6ef8$export$87cdd402beca8f45(overrides) {
    var _a, _b, _c, _d;
    const logTime = (overrides === null || overrides === void 0 ? void 0 : overrides.time) || $0ffce56d54de6ef8$export$ed6db8ac961f262d;
    const { time: time, timeUtc: timeUtc, timezone: timezone } = $0ffce56d54de6ef8$export$54a89be6af0881dc(logTime);
    return Object.assign(Object.assign({
        // id 0 marks a pending/unsaved log — matches the live current log the app
        // sends (Log(id: 0, …)), which always carries a data payload.
        id: 0,
        cruiseId: 1,
        tripId: 1,
        dayId: (_a = overrides === null || overrides === void 0 ? void 0 : overrides.dayId) !== null && _a !== void 0 ? _a : 1,
        accountId: 1,
        shipId: 1,
        createdAt: logTime.toISOString(),
        updatedAt: logTime.toISOString(),
        time: time,
        timeUtc: timeUtc,
        timezone: timezone,
        labels: (overrides === null || overrides === void 0 ? void 0 : overrides.labels) || [
            "current"
        ],
        sog: (_b = overrides === null || overrides === void 0 ? void 0 : overrides.sog) !== null && _b !== void 0 ? _b : 0,
        course: (_c = overrides === null || overrides === void 0 ? void 0 : overrides.course) !== null && _c !== void 0 ? _c : 57,
        distance: (_d = overrides === null || overrides === void 0 ? void 0 : overrides.distance) !== null && _d !== void 0 ? _d : 0,
        data: (overrides === null || overrides === void 0 ? void 0 : overrides.data) ? JSON.stringify(overrides.data) : "{}"
    }, (overrides === null || overrides === void 0 ? void 0 : overrides.engineRpms) && {
        engineRpms: overrides.engineRpms
    }), (overrides === null || overrides === void 0 ? void 0 : overrides.comment) !== undefined && {
        comment: overrides.comment
    });
}
// Predefined logs for common demo scenarios
// Each log has a specific purpose in the QuickStart demo flow
const $0ffce56d54de6ef8$var$PREDEFINED_LOGS = {
    1: {
        // Engine 1 start - 14:54 local time
        time: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)),
        sog: 0,
        course: 57,
        distance: 0,
        comment: "Started engine #1",
        engineRpms: [
            0,
            1200,
            0
        ],
        labels: [
            "auto",
            "engine"
        ],
        data: {
            autoType: "engineChange",
            engine: "1",
            engineOn: true
        }
    },
    2: {
        // Engine 2 start - 14:54 local time
        time: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)),
        sog: 0,
        course: 25,
        distance: 0,
        comment: "Started engine #2",
        engineRpms: [
            0,
            1200,
            1200
        ],
        labels: [
            "auto",
            "engine"
        ],
        data: {
            autoType: "engineChange",
            engine: "2",
            engineOn: true
        }
    },
    3: {
        // Started - boat in motion - 14:55 local time
        time: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)),
        sog: 5.7,
        course: 186,
        distance: 0,
        comment: "End of pause",
        engineRpms: [
            0,
            1200,
            1200
        ],
        labels: [
            "manual"
        ]
    },
    4: {
        time: new Date(Date.UTC(2026, 2, 29, 13, 0, 0)),
        sog: 5.7,
        course: 186,
        distance: 0.4,
        comment: "Automatic entry after 1:00",
        engineRpms: [
            0,
            1200,
            1200
        ],
        labels: [
            "manual"
        ]
    },
    5: {
        time: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
        sog: 5.7,
        stw: 5.7,
        course: 186,
        heading: 186,
        distance: 0.8,
        log: 25812,
        depth: 35.6,
        comment: "",
        engineRpms: [
            0,
            1200,
            1200
        ],
        labels: [
            "manual"
        ]
    },
    6: {
        time: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
        sog: 5.7,
        course: 186,
        distance: 0.9,
        comment: "Stopped engine #1 after 0:10 (0.9 nm)",
        engineRpms: [
            0,
            0,
            1200
        ],
        labels: [
            "manual"
        ]
    },
    7: {
        time: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
        sog: 5.7,
        course: 186,
        distance: 0.9,
        windDirection: 310,
        windSpeed: 15.5,
        pressure: 1013.5,
        temperature: 25,
        comment: "Stopped engine #2 after 0:10 (0.9 nm)",
        engineRpms: [
            0,
            0,
            0
        ],
        labels: [
            "manual"
        ]
    },
    8: {
        time: new Date(Date.UTC(2026, 2, 29, 13, 16, 0)),
        sog: 8.6,
        course: 126,
        distance: 2.3,
        comment: "Change of course of 060\xb0",
        engineRpms: [
            0,
            0,
            0
        ],
        labels: [
            "manual"
        ]
    },
    9: {
        time: new Date(Date.UTC(2026, 2, 29, 13, 25, 0)),
        sog: 7.1,
        course: 199,
        distance: 3.6,
        comment: "Change of course of 073\xb0",
        engineRpms: [
            0,
            0,
            0
        ],
        labels: [
            "manual"
        ]
    },
    10: {
        time: new Date(Date.UTC(2026, 2, 29, 14, 0, 0)),
        sog: 7.1,
        course: 199,
        distance: 7.7,
        comment: "Automatic entry after 1:00",
        engineRpms: [
            0,
            0,
            0
        ],
        labels: [
            "manual"
        ]
    },
    11: {
        time: new Date(Date.UTC(2026, 2, 29, 15, 0, 0)),
        sog: 7.1,
        course: 199,
        distance: 14.8,
        comment: "Automatic entry after 1:00",
        engineRpms: [
            0,
            0,
            0
        ],
        labels: [
            "manual"
        ]
    },
    12: {
        time: new Date(Date.UTC(2026, 2, 29, 16, 0, 0)),
        sog: 7.1,
        course: 199,
        distance: 21.9,
        comment: "Automatic entry after 1:00",
        engineRpms: [
            0,
            0,
            0
        ],
        labels: [
            "manual"
        ]
    },
    13: {
        time: new Date(Date.UTC(2026, 2, 29, 16, 8, 0)),
        sog: 7.1,
        course: 133,
        distance: 22.8,
        comment: "Change of course of 066\xb0",
        engineRpms: [
            0,
            0,
            0
        ],
        labels: [
            "manual"
        ]
    },
    14: {
        time: new Date(Date.UTC(2026, 2, 29, 16, 12, 0)),
        sog: 7.1,
        course: 133,
        distance: 23.4,
        comment: "Genoa down",
        engineRpms: [
            0,
            0,
            0
        ],
        labels: [
            "manual"
        ]
    },
    15: {
        time: new Date(Date.UTC(2026, 2, 29, 16, 13, 0)),
        sog: 7.1,
        course: 133,
        distance: 23.4,
        comment: "Started engine #2",
        engineRpms: [
            0,
            0,
            1200
        ],
        labels: [
            "manual"
        ]
    },
    16: {
        time: new Date(Date.UTC(2026, 2, 29, 16, 13, 0)),
        sog: 7.1,
        course: 133,
        distance: 23.4,
        comment: "Mainsail down",
        engineRpms: [
            0,
            0,
            1200
        ],
        labels: [
            "manual"
        ]
    },
    17: {
        time: new Date(Date.UTC(2026, 2, 29, 16, 13, 0)),
        sog: 7.1,
        course: 133,
        distance: 23.4,
        comment: "Started engine #1",
        engineRpms: [
            0,
            1200,
            1200
        ],
        labels: [
            "manual"
        ]
    },
    18: {
        time: new Date(Date.UTC(2026, 2, 29, 16, 17, 0)),
        sog: 0.0,
        course: 133,
        distance: 23.7,
        comment: "Start of pause",
        engineRpms: [
            0,
            1200,
            1200
        ],
        labels: [
            "manual"
        ]
    },
    19: {
        time: new Date(Date.UTC(2026, 2, 29, 16, 19, 0)),
        sog: 0.0,
        course: 133,
        distance: 23.7,
        comment: "Stopped engine #1 after 0:06 (0.2 nm)",
        engineRpms: [
            0,
            0,
            1200
        ],
        labels: [
            "manual"
        ]
    },
    20: {
        time: new Date(Date.UTC(2026, 2, 29, 16, 19, 0)),
        sog: 0.0,
        course: 133,
        distance: 23.7,
        comment: "Stopped engine #2 after 0:06 (0.2 nm)",
        engineRpms: [
            0,
            0,
            0
        ],
        labels: [
            "manual"
        ]
    },
    21: {
        // Engine 1 start - 14:54 local time
        time: new Date(Date.UTC(2026, 2, 30, 7, 25, 0)),
        sog: 0,
        course: 25,
        distance: 0,
        comment: "Started engine #1",
        engineRpms: [
            0,
            1200,
            0
        ],
        labels: [
            "auto",
            "engine"
        ],
        data: {
            autoType: "engineChange",
            engine: "1",
            engineOn: true
        }
    },
    22: {
        // Engine 2 start - 14:54 local time
        time: new Date(Date.UTC(2026, 2, 30, 7, 25, 0)),
        sog: 0,
        course: 25,
        distance: 0,
        comment: "Started engine #2",
        engineRpms: [
            0,
            1200,
            1200
        ],
        labels: [
            "auto",
            "engine"
        ],
        data: {
            autoType: "engineChange",
            engine: "2",
            engineOn: true
        }
    },
    23: {
        // Started - boat in motion - 14:55 local time
        time: new Date(Date.UTC(2026, 2, 30, 12, 55, 0)),
        sog: 5.7,
        course: 25,
        distance: 0,
        comment: "End of pause",
        engineRpms: [
            0,
            1200,
            1200
        ],
        labels: [
            "manual"
        ]
    }
};
function $0ffce56d54de6ef8$export$e74067d77aa0409d(logId, overrides) {
    var _a, _b, _c, _d;
    // Merge predefined log with overrides
    const predefined = $0ffce56d54de6ef8$var$PREDEFINED_LOGS[logId] || {};
    const merged = Object.assign(Object.assign({}, predefined), overrides);
    const logTime = merged.time || $0ffce56d54de6ef8$export$ed6db8ac961f262d;
    const { time: time, timeUtc: timeUtc, timezone: timezone } = $0ffce56d54de6ef8$export$54a89be6af0881dc(logTime);
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        id: logId,
        cruiseId: 1,
        tripId: 1,
        dayId: (_a = merged.dayId) !== null && _a !== void 0 ? _a : 1,
        accountId: 1,
        shipId: 1,
        createdAt: logTime.toISOString(),
        updatedAt: logTime.toISOString(),
        time: time,
        timeUtc: timeUtc,
        timezone: timezone,
        labels: merged.labels || [
            "auto"
        ],
        sog: (_b = merged.sog) !== null && _b !== void 0 ? _b : 0,
        course: (_c = merged.course) !== null && _c !== void 0 ? _c : 57,
        distance: (_d = merged.distance) !== null && _d !== void 0 ? _d : 0
    }, merged.stw !== undefined && {
        stw: merged.stw
    }), merged.heading !== undefined && {
        heading: merged.heading
    }), merged.log !== undefined && {
        log: merged.log
    }), merged.depth !== undefined && {
        depth: merged.depth
    }), merged.windDirection !== undefined && {
        windDirection: merged.windDirection
    }), merged.windSpeed !== undefined && {
        windSpeed: merged.windSpeed
    }), merged.pressure !== undefined && {
        pressure: merged.pressure
    }), merged.weather !== undefined && {
        weather: merged.weather
    }), merged.temperature !== undefined && {
        temperature: merged.temperature
    }), merged.seaState !== undefined && {
        seaState: merged.seaState
    }), merged.comment && {
        comment: merged.comment
    }), merged.engineRpms && {
        engineRpms: merged.engineRpms
    }), {
        data: merged.data ? JSON.stringify(merged.data) : "{}"
    }), merged.lat !== undefined && {
        lat: merged.lat
    }), merged.lng !== undefined && {
        lng: merged.lng
    });
}
function $0ffce56d54de6ef8$export$30985b286938a5b(logIds, overrides) {
    return logIds.map((id)=>$0ffce56d54de6ef8$export$e74067d77aa0409d(id, overrides === null || overrides === void 0 ? void 0 : overrides[id]));
}
function $0ffce56d54de6ef8$export$d2be2311c14adaf4() {
    const timestamp = $0ffce56d54de6ef8$export$ed6db8ac961f262d.toISOString();
    return [
        {
            id: 1,
            accountId: 1,
            shipId: 1,
            userId: 1,
            createdAt: timestamp,
            updatedAt: timestamp,
            active: 1,
            name: "Lucas Martin",
            shortname: "Lucas",
            email: "lucas@example.com",
            shipUserLevel: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary,
            shipUserCrewRole: (0, $dc7739d612f0c536$export$1e4ade51a6368243).skipper,
            data: "{}"
        },
        {
            id: 2,
            accountId: 1,
            shipId: 1,
            userId: 2,
            createdAt: timestamp,
            updatedAt: timestamp,
            active: 1,
            name: "Thomas Schmidt",
            shortname: "Tom",
            email: "tom@example.com",
            shipUserLevel: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editAll,
            shipUserCrewRole: (0, $dc7739d612f0c536$export$1e4ade51a6368243).crew,
            data: "{}"
        },
        {
            id: 3,
            accountId: 1,
            shipId: 1,
            userId: 3,
            createdAt: timestamp,
            updatedAt: timestamp,
            active: 1,
            name: "Lisa Weber",
            shortname: "Lisa",
            email: "lisa@example.com",
            shipUserLevel: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editAll,
            shipUserCrewRole: (0, $dc7739d612f0c536$export$1e4ade51a6368243).crew,
            data: "{}"
        },
        {
            id: 4,
            accountId: 1,
            shipId: 1,
            userId: 4,
            createdAt: timestamp,
            updatedAt: timestamp,
            active: 1,
            name: "Emma Morgan",
            shortname: "Emma",
            email: "emma@example.com",
            shipUserLevel: (0, $dc7739d612f0c536$export$fe876bf720d558fa).editAll,
            shipUserCrewRole: (0, $dc7739d612f0c536$export$1e4ade51a6368243).crew,
            data: "{}"
        }
    ];
}
function $0ffce56d54de6ef8$export$b69f506abaf8b7d5() {
    const ship = {
        id: 1,
        accountId: 1,
        createdAt: $0ffce56d54de6ef8$var$d,
        updatedAt: $0ffce56d54de6ef8$var$d,
        engineCount: 2,
        name: "Lipoza",
        vesselType: (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).sailing,
        shipData: {
            name: "Lipoza",
            engineCount: 2,
            vesselType: (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).sailing,
            mmsi: "211234567",
            callsign: "DF1234",
            engines: [
                {
                    id: "1",
                    number: 1,
                    nmeaNumber: 1,
                    engineShortName: "Starboard",
                    name: "Starboard",
                    type: "inboard",
                    fuelType: "diesel"
                },
                {
                    id: "2",
                    number: 2,
                    nmeaNumber: 2,
                    engineShortName: "Portside",
                    name: "Portside",
                    type: "inboard",
                    fuelType: "diesel"
                }
            ],
            sails: [
                {
                    id: "mainsail",
                    sail: "mainsail",
                    sailType: "mast",
                    reefNo: 3
                },
                {
                    id: "genoa",
                    sail: "genoa",
                    sailType: "forestay",
                    reefNo: 0
                }
            ]
        },
        shipUsers: [
            {
                userId: 1,
                level: 100,
                crewRole: "skipper"
            }
        ]
    };
    const currentDay = $0ffce56d54de6ef8$export$d2d39d1adcc883a2($0ffce56d54de6ef8$export$ed6db8ac961f262d);
    const { timezone: timezone } = $0ffce56d54de6ef8$export$54a89be6af0881dc($0ffce56d54de6ef8$export$ed6db8ac961f262d);
    const data = {
        account: {
            id: 1,
            createdAt: $0ffce56d54de6ef8$var$d,
            updatedAt: $0ffce56d54de6ef8$var$d,
            accountSubscriptionPlanId: 1,
            name: "Test Account",
            slug: "test-account",
            metadata: "{}",
            subscriptionStatus: 1
        },
        cruises: [
            {
                id: 1,
                createdAt: $0ffce56d54de6ef8$var$d,
                updatedAt: $0ffce56d54de6ef8$var$d,
                accountId: 1,
                shipId: 1,
                title: "",
                startedAt: undefined,
                completedAt: undefined,
                data: "{}"
            }
        ],
        days: [
            {
                id: 1,
                cruiseId: 1,
                tripId: 1,
                accountId: 1,
                shipId: 1,
                createdAt: $0ffce56d54de6ef8$var$d,
                updatedAt: $0ffce56d54de6ef8$var$d,
                day: currentDay,
                timezone: timezone,
                data: "{}"
            }
        ],
        logs: [],
        notes: [],
        attachments: [],
        session: {
            id: "deadbeef",
            authorized: true,
            accountId: 1,
            userId: 1
        },
        ship: ship,
        ships: [
            ship
        ],
        shipUsers: [
            {
                id: 1,
                accountId: 1,
                shipId: 1,
                userId: 1,
                createdAt: $0ffce56d54de6ef8$var$d,
                updatedAt: $0ffce56d54de6ef8$var$d,
                active: 1,
                name: "Lucas Martin",
                shortname: "Lucas",
                email: "skipper@example.com",
                shipUserLevel: (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary,
                shipUserCrewRole: (0, $dc7739d612f0c536$export$1e4ade51a6368243).skipper,
                data: "{}"
            }
        ],
        statuses: [],
        tracks: [],
        trips: [
            {
                id: 1,
                accountId: 1,
                shipId: 1,
                cruiseId: 1,
                createdAt: $0ffce56d54de6ef8$var$d,
                updatedAt: $0ffce56d54de6ef8$var$d,
                title: "",
                startedAt: undefined,
                completedAt: undefined,
                timezone: timezone,
                data: "{}"
            }
        ],
        user: {
            id: 1,
            createdAt: $0ffce56d54de6ef8$var$d,
            updatedAt: $0ffce56d54de6ef8$var$d,
            authenticationType: 0,
            name: "DemoUser",
            email: "testuser@example.com",
            shortname: "DemoUser"
        },
        users: [
            {
                id: 1,
                accountId: 1,
                createdAt: $0ffce56d54de6ef8$var$d,
                updatedAt: $0ffce56d54de6ef8$var$d,
                authenticationType: 0,
                name: "Lucas Martin",
                email: "lucas@example.com",
                shortname: "LucasMarti"
            },
            {
                id: 2,
                accountId: 1,
                createdAt: $0ffce56d54de6ef8$var$d,
                updatedAt: $0ffce56d54de6ef8$var$d,
                authenticationType: 0,
                name: "Thomas Schmidt",
                email: "tom@example.com",
                shortname: "ThomasSchm"
            },
            {
                id: 3,
                accountId: 1,
                createdAt: $0ffce56d54de6ef8$var$d,
                updatedAt: $0ffce56d54de6ef8$var$d,
                authenticationType: 0,
                name: "Lisa Weber",
                email: "lisa@example.com",
                shortname: "LisaWeber"
            },
            {
                id: 4,
                accountId: 1,
                createdAt: $0ffce56d54de6ef8$var$d,
                updatedAt: $0ffce56d54de6ef8$var$d,
                authenticationType: 0,
                name: "Emma Morgan",
                email: "emma@example.com",
                shortname: "EmmaMorgan"
            }
        ],
        weatherTimeseries: []
    };
    return data;
}




var $acw62 = parcelRequire("acw62");

function $a668bc461693ca0f$export$2c7715ad65b06796(template, params) {
    return template.replace(/:([A-Za-z0-9_]+)/g, function(_match, name) {
        if (!Object.hasOwn(params, name)) throw new Error("Missing route parameter: ".concat(name));
        return encodeURIComponent(String(params[name]));
    });
}
function $a668bc461693ca0f$export$307fe3fd7a7bd211(query) {
    if (!query) return "";
    var parts = [];
    for(var _i = 0, _a = Object.entries(query); _i < _a.length; _i++){
        var _b = _a[_i], name = _b[0], value = _b[1];
        var values = Array.isArray(value) ? value : [
            value
        ];
        for(var _c = 0, values_1 = values; _c < values_1.length; _c++){
            var item = values_1[_c];
            if (item === undefined) continue;
            parts.push("".concat(encodeURIComponent(name), "=").concat(encodeURIComponent(item === null ? "" : String(item))));
        }
    }
    return parts.join("&");
}
function $a668bc461693ca0f$export$8fa1eaeb4700701e(path, query) {
    var serialized = $a668bc461693ca0f$export$307fe3fd7a7bd211(query);
    if (!serialized) return path;
    return "".concat(path).concat(path.includes("?") ? "&" : "?").concat(serialized);
}
function $a668bc461693ca0f$export$30c665ad8a3d6000(key, args) {
    var _a;
    var separator = key.indexOf(" ");
    if (separator <= 0 || separator === key.length - 1) throw new Error("Invalid generated route key: ".concat(key));
    var method = key.slice(0, separator);
    var path = $a668bc461693ca0f$export$2c7715ad65b06796(key.slice(separator + 1), (_a = args.params) !== null && _a !== void 0 ? _a : {});
    return {
        method: method,
        path: path,
        request: method.toUpperCase() === "GET" ? args.query : args.body
    };
}
function $a668bc461693ca0f$export$a6a4897c83fcef2e(key, args) {
    var route = $a668bc461693ca0f$export$30c665ad8a3d6000(key, args);
    return $a668bc461693ca0f$export$8fa1eaeb4700701e(route.path, args.query);
}
function $a668bc461693ca0f$export$ccbb4bbc18e1f082(key, args) {
    return $a668bc461693ca0f$export$30c665ad8a3d6000(key, args);
}
function $a668bc461693ca0f$export$3aff26c134954d44(options) {
    return {
        target: options.target,
        call: function(key, rawArgs) {
            var _a, _b;
            var resolved = $a668bc461693ca0f$export$ccbb4bbc18e1f082(key, rawArgs);
            var path = options.requestPath(resolved.path);
            var body = (_b = (_a = options.requestBody) === null || _a === void 0 ? void 0 : _a.call(options, resolved.request)) !== null && _b !== void 0 ? _b : {
                request: resolved.request
            };
            var request = body.request;
            return body.file === undefined ? options.call(resolved.method, path, request) : options.call(resolved.method, path, request, body.file);
        },
        url: function(key, rawArgs) {
            var _a, _b, _c;
            var args = rawArgs;
            var resolved = $a668bc461693ca0f$export$ccbb4bbc18e1f082(key, args);
            var query = resolved.method.toUpperCase() === "GET" ? (_c = (_a = options.urlQuery) === null || _a === void 0 ? void 0 : _a.call(options, (_b = args.query) !== null && _b !== void 0 ? _b : {})) !== null && _c !== void 0 ? _c : args.query : undefined;
            return $a668bc461693ca0f$export$8fa1eaeb4700701e(resolved.path, query);
        }
    };
}


var $f21b0ce903cacac0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f21b0ce903cacac0$var$__assign = undefined && undefined.__assign || function() {
    $f21b0ce903cacac0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f21b0ce903cacac0$var$__assign.apply(this, arguments);
};
var $f21b0ce903cacac0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f21b0ce903cacac0$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f21b0ce903cacac0$export$34421c09961aeaa3 = /** @class */ function(_super) {
    $f21b0ce903cacac0$var$__extends(HttpStatusError, _super);
    function HttpStatusError(status, body, response) {
        var _this = _super.call(this, "HTTP request failed with status ".concat(status)) || this;
        _this.status = status;
        _this.body = body;
        _this.response = response;
        _this.name = "HttpStatusError";
        Object.setPrototypeOf(_this, HttpStatusError.prototype);
        return _this;
    }
    return HttpStatusError;
}(Error);
function $f21b0ce903cacac0$export$c3792535cb9f34af(options) {
    var _a, _b, _c;
    var resolveUrl = (_a = options.resolveUrl) !== null && _a !== void 0 ? _a : function(path) {
        return path;
    };
    var createFormData = (_b = options.createFormData) !== null && _b !== void 0 ? _b : function() {
        return new FormData();
    };
    var parseResponse = (_c = options.parseResponse) !== null && _c !== void 0 ? _c : function(response) {
        return response.json();
    };
    return {
        request: function(request) {
            return $f21b0ce903cacac0$var$__awaiter(this, void 0, Promise, function() {
                var path, url, context, providedHeaders, resolvedHeaders, _a, headers, body, formData, response, errorBody, _b;
                var _c;
                return $f21b0ce903cacac0$var$__generator(this, function(_d) {
                    switch(_d.label){
                        case 0:
                            if (request.body !== undefined && request.multipart !== undefined) throw new Error("HTTP requests cannot contain both JSON and multipart bodies");
                            path = (0, $a668bc461693ca0f$export$8fa1eaeb4700701e)(request.path, request.query);
                            url = resolveUrl(path, request);
                            context = $f21b0ce903cacac0$var$__assign($f21b0ce903cacac0$var$__assign({}, request), {
                                url: url
                            });
                            providedHeaders = (_c = options.headers) === null || _c === void 0 ? void 0 : _c.call(options, context);
                            if (!(providedHeaders instanceof Promise)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                providedHeaders
                            ];
                        case 1:
                            _a = _d.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _a = providedHeaders;
                            _d.label = 3;
                        case 3:
                            resolvedHeaders = _a;
                            headers = new Headers(resolvedHeaders);
                            if (!headers.has("Accept")) headers.set("Accept", "application/json");
                            if (request.headers) new Headers(request.headers).forEach(function(value, name) {
                                return headers.set(name, value);
                            });
                            if (request.multipart !== undefined) {
                                formData = createFormData();
                                $f21b0ce903cacac0$var$appendMultipartFields(formData, request.multipart);
                                body = formData;
                            } else if (request.body !== undefined) {
                                if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json");
                                body = JSON.stringify(request.body);
                            }
                            return [
                                4 /*yield*/ ,
                                options.fetch(url, {
                                    method: request.method,
                                    headers: headers,
                                    body: body
                                })
                            ];
                        case 4:
                            response = _d.sent();
                            if (!response.ok) return [
                                3 /*break*/ ,
                                6
                            ];
                            return [
                                4 /*yield*/ ,
                                parseResponse(response)
                            ];
                        case 5:
                            return [
                                2 /*return*/ ,
                                _d.sent()
                            ];
                        case 6:
                            _d.trys.push([
                                6,
                                8,
                                ,
                                9
                            ]);
                            return [
                                4 /*yield*/ ,
                                parseResponse(response)
                            ];
                        case 7:
                            errorBody = _d.sent();
                            return [
                                3 /*break*/ ,
                                9
                            ];
                        case 8:
                            _b = _d.sent();
                            errorBody = undefined;
                            return [
                                3 /*break*/ ,
                                9
                            ];
                        case 9:
                            throw new $f21b0ce903cacac0$export$34421c09961aeaa3(response.status, errorBody, response);
                    }
                });
            });
        }
    };
}
function $f21b0ce903cacac0$var$appendMultipartFields(formData, fields) {
    for(var _i = 0, _a = Object.entries(fields); _i < _a.length; _i++){
        var _b = _a[_i], name = _b[0], value = _b[1];
        if (value === undefined) continue;
        if ($f21b0ce903cacac0$var$isMultipartFile(value)) {
            if (value.filename === undefined) formData.append(name, value.value);
            else formData.append(name, value.value, value.filename);
        } else if (value instanceof Blob) formData.append(name, value);
        else formData.append(name, value === null ? "" : String(value));
    }
}
function $f21b0ce903cacac0$var$isMultipartFile(value) {
    return typeof value === "object" && value !== null && "value" in value && value.value instanceof Blob;
}


function $bbedd69b602ce93d$export$c417d7049a9c9658(options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var timers = (_a = options.timers) !== null && _a !== void 0 ? _a : {
        setTimeout: function(callback, delay) {
            return globalThis.setTimeout(callback, delay);
        },
        clearTimeout: function(timer) {
            return globalThis.clearTimeout(timer);
        }
    };
    var reconnectDelay = (_b = options.reconnectDelay) !== null && _b !== void 0 ? _b : 1000;
    var channelSubscriptionDelay = (_c = options.channelSubscriptionDelay) !== null && _c !== void 0 ? _c : 0;
    var socketOpenState = (_d = options.socketOpenState) !== null && _d !== void 0 ? _d : 1;
    var parseMessage = (_e = options.parseMessage) !== null && _e !== void 0 ? _e : $bbedd69b602ce93d$var$defaultParseMessage;
    var parseData = (_f = options.parseData) !== null && _f !== void 0 ? _f : $bbedd69b602ce93d$var$defaultParseData;
    var serializeMessage = (_g = options.serializeMessage) !== null && _g !== void 0 ? _g : JSON.stringify;
    var createChannelMessage = (_h = options.createChannelMessage) !== null && _h !== void 0 ? _h : $bbedd69b602ce93d$var$defaultChannelMessage;
    var selectCursor = (_j = options.selectCursor) !== null && _j !== void 0 ? _j : function(message) {
        return message.id;
    };
    var advanceCursor = (_k = options.advanceCursor) !== null && _k !== void 0 ? _k : $bbedd69b602ce93d$var$defaultAdvanceCursor;
    var controlType = (_l = options.controlType) !== null && _l !== void 0 ? _l : "control";
    var running = false;
    var currentSocket;
    var cursor = options.initialCursor;
    var reconnectAttempt = 0;
    var reconnectTimer;
    var channelTimer;
    var nextSubscriptionId = 1;
    var sentChannels = new Set();
    var channels = new Set();
    var subscriptions = new Map();
    var connectionCallbacks = new Set();
    var client = {
        connect: function() {
            running = true;
            if (!currentSocket && reconnectTimer === undefined) openSocket();
        },
        disconnect: function() {
            running = false;
            clearReconnectTimer();
            clearChannelTimer();
            var socket = currentSocket;
            currentSocket = undefined;
            sentChannels = new Set();
            if (socket) {
                socket.close();
                emitConnection({
                    connected: false,
                    event: "disconnect",
                    socket: socket
                });
            }
        },
        socket: function() {
            return currentSocket;
        },
        resumeCursor: function() {
            return cursor;
        },
        setResumeCursor: function(nextCursor) {
            cursor = nextCursor;
        },
        subscribe: function(type, callback) {
            var _a;
            var id = nextSubscriptionId++;
            var callbacks = (_a = subscriptions.get(type)) !== null && _a !== void 0 ? _a : new Map();
            callbacks.set(id, callback);
            subscriptions.set(type, callbacks);
            return id;
        },
        unsubscribe: function(type, id) {
            var callbacks = subscriptions.get(type);
            callbacks === null || callbacks === void 0 || callbacks.delete(id);
            if ((callbacks === null || callbacks === void 0 ? void 0 : callbacks.size) === 0) subscriptions.delete(type);
        },
        trigger: function(type, data, event, message) {
            var _a, _b;
            if (message === void 0) message = {
                type: type,
                event: event,
                data: data
            };
            for(var _i = 0, _c = Array.from((_b = (_a = subscriptions.get(type)) === null || _a === void 0 ? void 0 : _a.values()) !== null && _b !== void 0 ? _b : []); _i < _c.length; _i++){
                var callback = _c[_i];
                callback(data, type, event, message);
            }
        },
        subscribeChannel: function(channel) {
            if (channels.has(channel)) return;
            channels.add(channel);
            sendChannelSubscription(channel, false);
        },
        unsubscribeChannel: function(channel) {
            if (!channels.delete(channel)) return;
            if ((currentSocket === null || currentSocket === void 0 ? void 0 : currentSocket.readyState) === socketOpenState) currentSocket.send(serializeMessage(createChannelMessage({
                action: "unsubscribe",
                channel: channel,
                resume: false
            })));
            sentChannels.delete(channel);
        },
        onConnection: function(callback) {
            connectionCallbacks.add(callback);
            return function() {
                return connectionCallbacks.delete(callback);
            };
        }
    };
    function openSocket() {
        if (!running || currentSocket) return;
        var resuming = cursor !== undefined;
        var url = options.createUrl({
            cursor: cursor,
            resuming: resuming
        });
        if (!url) return;
        var socket = options.createSocket(url);
        currentSocket = socket;
        sentChannels = new Set();
        var isCurrent = function() {
            return currentSocket === socket;
        };
        var fail = function() {
            if (!running || !isCurrent()) return;
            clearChannelTimer();
            currentSocket = undefined;
            sentChannels = new Set();
            emitConnection({
                connected: false,
                event: "disconnect",
                socket: socket
            });
            var attempt = ++reconnectAttempt;
            var delay = typeof reconnectDelay === "function" ? reconnectDelay(attempt) : reconnectDelay;
            reconnectTimer = timers.setTimeout(function() {
                reconnectTimer = undefined;
                openSocket();
            }, delay);
        };
        socket.onopen = function() {
            if (!isCurrent()) {
                socket.close();
                return;
            }
            reconnectAttempt = 0;
            emitConnection({
                connected: true,
                event: "connect",
                socket: socket
            });
            var subscribeChannels = function() {
                channelTimer = undefined;
                if (!isCurrent()) return;
                for(var _i = 0, _a = Array.from(channels); _i < _a.length; _i++){
                    var channel = _a[_i];
                    sendChannelSubscription(channel, resuming);
                }
            };
            if (channelSubscriptionDelay > 0) channelTimer = timers.setTimeout(subscribeChannels, channelSubscriptionDelay);
            else subscribeChannels();
        };
        socket.onmessage = function(event) {
            var _a, _b, _c, _d;
            if (!isCurrent()) return;
            var message = parseMessage(event.data);
            var nextCursor = selectCursor(message);
            if (nextCursor !== undefined) cursor = advanceCursor(cursor, nextCursor);
            if (message.type === controlType) {
                (_a = options.onControl) === null || _a === void 0 || _a.call(options, message);
                return;
            }
            if (!message.type || !message.event || message.data === undefined) return;
            var data = parseData(message.data, message);
            (_b = options.onMessage) === null || _b === void 0 || _b.call(options, message, data);
            for(var _i = 0, _e = Array.from((_d = (_c = subscriptions.get(message.type)) === null || _c === void 0 ? void 0 : _c.values()) !== null && _d !== void 0 ? _d : []); _i < _e.length; _i++){
                var callback = _e[_i];
                callback(data, message.type, message.event, message);
            }
        };
        socket.onerror = fail;
        socket.onclose = fail;
    }
    function sendChannelSubscription(channel, resume) {
        if (sentChannels.has(channel) || (currentSocket === null || currentSocket === void 0 ? void 0 : currentSocket.readyState) !== socketOpenState) return;
        currentSocket.send(serializeMessage(createChannelMessage({
            action: "subscribe",
            channel: channel,
            resume: resume
        })));
        sentChannels.add(channel);
    }
    function emitConnection(event) {
        var _a;
        (_a = options.onConnection) === null || _a === void 0 || _a.call(options, event);
        for(var _i = 0, _b = Array.from(connectionCallbacks); _i < _b.length; _i++){
            var callback = _b[_i];
            callback(event);
        }
    }
    function clearReconnectTimer() {
        if (reconnectTimer === undefined) return;
        timers.clearTimeout(reconnectTimer);
        reconnectTimer = undefined;
    }
    function clearChannelTimer() {
        if (channelTimer === undefined) return;
        timers.clearTimeout(channelTimer);
        channelTimer = undefined;
    }
    return client;
}
function $bbedd69b602ce93d$var$defaultParseMessage(data) {
    return JSON.parse(String(data));
}
function $bbedd69b602ce93d$var$defaultParseData(data) {
    return typeof data === "string" ? JSON.parse(data) : data;
}
function $bbedd69b602ce93d$var$defaultAdvanceCursor(current, next) {
    if (typeof current === "number" && typeof next === "number") return Math.max(current, next);
    return next;
}
function $bbedd69b602ce93d$var$defaultChannelMessage(context) {
    return context.action === "subscribe" ? {
        event: "subscribe",
        channel: context.channel,
        type: "channel",
        resume: context.resume
    } : {
        event: "unsubscribe",
        channel: context.channel,
        type: "channel"
    };
}


function $bf04d690697739ae$var$safelyRead(key, storage) {
    var _a;
    if (!storage) return undefined;
    try {
        return (_a = storage.getItem(key)) !== null && _a !== void 0 ? _a : undefined;
    } catch (_b) {
        return undefined;
    }
}
function $bf04d690697739ae$export$dda73877cb166cd3(key, options) {
    var _a;
    if (options === void 0) options = {};
    return (_a = $bf04d690697739ae$var$safelyRead(key, options.storage)) !== null && _a !== void 0 ? _a : options.fallback;
}
function $bf04d690697739ae$export$347fd215c36b10be(key, options) {
    if (options === void 0) options = {};
    var value = $bf04d690697739ae$var$safelyRead(key, options.storage);
    if (value === undefined || value.trim() === "") return options.fallback;
    var number = Number(value);
    return Number.isFinite(number) ? number : options.fallback;
}


function $2b75519151ca9024$export$3f685a6e8b195eac(key) {
    return (0, $bf04d690697739ae$export$dda73877cb166cd3)(key, {
        storage: localStorage
    }) || undefined;
}
function $2b75519151ca9024$export$8bf6241f4c41c4e0(key) {
    const stored = $2b75519151ca9024$export$3f685a6e8b195eac(key);
    if (stored) {
        const id = parseInt(stored);
        if (!isNaN(id)) return id;
    }
    return undefined;
}


function $b30c71ecc182311a$var$defaultBridgeExposureHost() {
    return globalThis;
}
function $b30c71ecc182311a$export$a1275a5d257b987c(options) {
    var _a, _b;
    var host = (_a = options.host) !== null && _a !== void 0 ? _a : $b30c71ecc182311a$var$defaultBridgeExposureHost();
    var exposeAs = (_b = options.exposeAs) !== null && _b !== void 0 ? _b : "ab";
    var installed;
    return {
        install: function() {
            var connection = options.connect();
            Object.defineProperty(host, exposeAs, {
                configurable: true,
                value: connection.bridge,
                writable: true
            });
            installed = connection;
            return connection;
        },
        current: function() {
            return installed;
        },
        manifest: function(manifestID) {
            return (installed === null || installed === void 0 ? void 0 : installed.kind) === "manifest" && installed.manifestID === manifestID ? installed.bridge : undefined;
        }
    };
}


// @generated by TypeGen from Bridge/NativeBridge - DO NOT EDIT
var $235969546b90e185$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $235969546b90e185$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $235969546b90e185$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $235969546b90e185$export$d2d8f8ec998eaf33(manifestID, name) {
    return {
        name: name
    };
}
function $235969546b90e185$export$e8caa2704e7ebdee(manifestID, name) {
    return {
        name: name
    };
}
function $235969546b90e185$export$eddb9065490e75cb(manifestID, bridge) {
    return {
        manifestID: manifestID,
        values: bridge.values,
        post: function(request) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            return $235969546b90e185$var$__awaiter(this, void 0, Promise, function() {
                var _a, payload, options;
                return $235969546b90e185$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _a = args, payload = _a[0], options = _a[1];
                            return [
                                4 /*yield*/ ,
                                bridge.post(request.name, payload, options)
                            ];
                        case 1:
                            _b.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        call: function(request) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            return $235969546b90e185$var$__awaiter(this, void 0, Promise, function() {
                var _a, payload, options;
                return $235969546b90e185$var$__generator(this, function(_b) {
                    _a = args, payload = _a[0], options = _a[1];
                    return [
                        2 /*return*/ ,
                        bridge.call(request.name, payload, options)
                    ];
                });
            });
        },
        on: function(name, handler) {
            return bridge.on(name, handler);
        },
        supports: function(request) {
            return bridge.supports(request.name);
        },
        capability: function(capability) {
            return bridge.capability(capability.name);
        }
    };
}
var $235969546b90e185$export$e623ed7fba33fffa = /** @class */ function(_super) {
    $235969546b90e185$var$__extends(UnsupportedBridgeMessageError, _super);
    function UnsupportedBridgeMessageError(name) {
        var _this = _super.call(this, "Unsupported bridge message: ".concat(name)) || this;
        _this.name = "UnsupportedBridgeMessageError";
        return _this;
    }
    return UnsupportedBridgeMessageError;
}(Error);
var $235969546b90e185$export$a28c6274aaa35069 = 1;
var $235969546b90e185$var$BRIDGE_ENVELOPE_KINDS = [
    "request",
    "reply",
    "event",
    "cancellation",
    "error"
];
/**
 * A surrogate code unit with no partner.
 *
 * JavaScript strings are UTF-16 and can hold one; UTF-8, and therefore every
 * Swift `String`, cannot. `JSON.parse` accepts `"\uD800"` happily, so without
 * this check a page can build a message the native side is structurally unable
 * to receive.
 */ var $235969546b90e185$var$LONE_SURROGATE = /[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/;
/**
 * Whether a value cannot survive the trip to the native side.
 *
 * Two ways that happens, and both are silent rather than loud. An unpaired
 * surrogate has no UTF-8 form. A non-finite number has no JSON form at all:
 * `JSON.parse("1e309")` yields `Infinity`, and `JSON.stringify(Infinity)`
 * yields `null`, so a payload carrying one arrives as a different message than
 * the one that was sent.
 *
 * Refused here, at the sender, because a page that never sends what the other
 * side cannot receive fails with a clear reason instead of an opaque refusal
 * from across the boundary.
 */ function $235969546b90e185$var$isUnrepresentable(value) {
    if (typeof value === "string") return $235969546b90e185$var$LONE_SURROGATE.test(value);
    if (typeof value === "number") return !Number.isFinite(value);
    if (Array.isArray(value)) return value.some($235969546b90e185$var$isUnrepresentable);
    if (typeof value === "object" && value !== null) return Object.entries(value).some(function(_a) {
        var key = _a[0], nested = _a[1];
        return $235969546b90e185$var$LONE_SURROGATE.test(key) || $235969546b90e185$var$isUnrepresentable(nested);
    });
    return false;
}
function $235969546b90e185$export$1700ac5276e33bee(value) {
    if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
    var candidate = value;
    // `typeof true === "boolean"`, so a boolean cannot pass as a version here.
    // The Swift side needs an explicit check for the same case, because
    // Foundation bridges an NSNumber holding 0 or 1 to Bool.
    if (candidate.version !== $235969546b90e185$export$a28c6274aaa35069) return false;
    if (typeof candidate.kind !== "string" || !$235969546b90e185$var$BRIDGE_ENVELOPE_KINDS.includes(candidate.kind)) return false;
    if (typeof candidate.name !== "string" || candidate.name.length === 0) return false;
    if ("id" in candidate && candidate.id !== undefined) {
        if (typeof candidate.id !== "string" || candidate.id.length === 0) return false;
    }
    return !$235969546b90e185$var$isUnrepresentable(candidate);
}
var $235969546b90e185$export$a7f333e73e2c6552 = /** @class */ function() {
    function BridgeClient(transport, configuration) {
        if (configuration === void 0) configuration = {};
        var _this = this;
        var _a, _b, _c, _d;
        this.transport = transport;
        this.handlers = new Map();
        this.pendingCalls = new Map();
        this.disposed = false;
        this.supported = new Set((_a = configuration.supported) !== null && _a !== void 0 ? _a : []);
        this.capabilities = (_b = configuration.capabilities) !== null && _b !== void 0 ? _b : {};
        this.values = (_c = configuration.values) !== null && _c !== void 0 ? _c : {};
        this.timeoutMilliseconds = (_d = configuration.timeoutMilliseconds) !== null && _d !== void 0 ? _d : 10000;
        this.stopEvents = transport.onEvent(function(envelope) {
            return _this.receive(envelope);
        });
    }
    BridgeClient.prototype.dispose = function() {
        if (this.disposed) return;
        this.disposed = true;
        for(var _i = 0, _a = this.pendingCalls.keys(); _i < _a.length; _i++){
            var id = _a[_i];
            this.rejectCall(id, new Error("Bridge client is disposed"));
        }
        this.handlers.clear();
        this.stopEvents();
    };
    BridgeClient.prototype.supports = function(name) {
        return this.supported.has(name);
    };
    BridgeClient.prototype.capability = function(name) {
        var _a;
        return (_a = this.capabilities[name]) !== null && _a !== void 0 ? _a : "unsupported";
    };
    BridgeClient.prototype.post = function(name, payload, options) {
        return $235969546b90e185$var$__awaiter(this, void 0, Promise, function() {
            return $235969546b90e185$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.call(name, payload, options)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BridgeClient.prototype.call = function(name_1, payload_1) {
        return $235969546b90e185$var$__awaiter(this, arguments, Promise, function(name, payload, options) {
            var timeoutMilliseconds, signal, id, request, reply;
            var _this = this;
            if (options === void 0) options = {};
            return $235969546b90e185$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.disposed) throw new Error("Bridge client is disposed");
                        if (!this.supports(name)) throw new $235969546b90e185$export$e623ed7fba33fffa(name);
                        timeoutMilliseconds = options.timeoutMilliseconds === undefined ? this.timeoutMilliseconds : options.timeoutMilliseconds;
                        if (timeoutMilliseconds !== null && (typeof timeoutMilliseconds !== "number" || !Number.isFinite(timeoutMilliseconds) || timeoutMilliseconds < 0)) throw new TypeError("timeoutMilliseconds must be a finite nonnegative number or null");
                        signal = options.signal;
                        if (signal === null || signal === void 0 ? void 0 : signal.aborted) throw new DOMException("Bridge call '".concat(name, "' was cancelled"), "AbortError");
                        id = globalThis.crypto.randomUUID();
                        request = {
                            version: 1,
                            kind: "request",
                            name: name,
                            id: id,
                            payload: payload
                        };
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                var timer;
                                var abortListener = function() {
                                    _this.cancelCall(id, name);
                                };
                                _this.pendingCalls.set(id, {
                                    resolve: resolve,
                                    reject: reject,
                                    cleanup: function() {
                                        if (timer !== undefined) clearTimeout(timer);
                                        signal === null || signal === void 0 || signal.removeEventListener("abort", abortListener);
                                    }
                                });
                                if (timeoutMilliseconds !== null) {
                                    var scheduleTimeout_1 = function(remaining) {
                                        // Larger delays overflow the platform's signed 32-bit timer.
                                        var delay = Math.min(remaining, 2147483647);
                                        timer = setTimeout(function() {
                                            if (remaining > delay) scheduleTimeout_1(remaining - delay);
                                            else _this.rejectCall(id, new Error("Bridge call '".concat(name, "' timed out")));
                                        }, delay);
                                    };
                                    scheduleTimeout_1(timeoutMilliseconds);
                                }
                                signal === null || signal === void 0 || signal.addEventListener("abort", abortListener, {
                                    once: true
                                });
                                try {
                                    _this.trackReply(id, _this.transport.send(request));
                                } catch (error) {
                                    _this.rejectCall(id, error);
                                }
                            })
                        ];
                    case 1:
                        reply = _a.sent();
                        if (reply.version !== 1 || reply.kind !== "reply" || reply.name !== name || reply.id !== id) throw new Error("Invalid bridge reply for '".concat(name, "'"));
                        return [
                            2 /*return*/ ,
                            reply.payload
                        ];
                }
            });
        });
    };
    BridgeClient.prototype.takePendingCall = function(id) {
        var pending = this.pendingCalls.get(id);
        this.pendingCalls.delete(id);
        pending === null || pending === void 0 || pending.cleanup();
        return pending;
    };
    BridgeClient.prototype.rejectCall = function(id, error) {
        var _a;
        (_a = this.takePendingCall(id)) === null || _a === void 0 || _a.reject(error);
    };
    BridgeClient.prototype.trackReply = function(id, reply) {
        var _this = this;
        // A never-settling transport must not retain the consumer's settlement callbacks.
        reply.then(function(envelope) {
            var _a;
            return (_a = _this.takePendingCall(id)) === null || _a === void 0 ? void 0 : _a.resolve(envelope);
        }, function(error) {
            return _this.rejectCall(id, error);
        });
    };
    BridgeClient.prototype.cancelCall = function(id, name) {
        return $235969546b90e185$var$__awaiter(this, void 0, Promise, function() {
            var error_1;
            var _a, _b;
            return $235969546b90e185$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (_b = (_a = this.transport).cancel) === null || _b === void 0 ? void 0 : _b.call(_a, id)
                        ];
                    case 1:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_1 = _c.sent();
                        this.rejectCall(id, error_1);
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        this.rejectCall(id, new DOMException("Bridge call '".concat(name, "' was cancelled"), "AbortError"));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BridgeClient.prototype.on = function(name, handler) {
        var _this = this;
        var _a;
        var handlers = (_a = this.handlers.get(name)) !== null && _a !== void 0 ? _a : new Set();
        handlers.add(handler);
        this.handlers.set(name, handlers);
        return function() {
            handlers.delete(handler);
            if (handlers.size === 0) _this.handlers.delete(name);
        };
    };
    BridgeClient.prototype.receive = function(envelope) {
        var _a;
        if (envelope.version !== 1 || envelope.kind !== "event") return;
        for(var _i = 0, _b = Array.from((_a = this.handlers.get(envelope.name)) !== null && _a !== void 0 ? _a : []); _i < _b.length; _i++){
            var handler = _b[_i];
            handler(envelope.payload);
        }
    };
    return BridgeClient;
}();
function $235969546b90e185$export$27232abdbffb8d10(logger) {
    var _this = this;
    if (logger === void 0) logger = console;
    var unsupported = function(name) {
        return $235969546b90e185$var$__awaiter(_this, void 0, Promise, function() {
            var error;
            return $235969546b90e185$var$__generator(this, function(_a) {
                error = new $235969546b90e185$export$e623ed7fba33fffa(name);
                logger.error(error.message);
                throw error;
            });
        });
    };
    return {
        values: {},
        post: unsupported,
        call: unsupported,
        on: function() {
            return function() {};
        },
        supports: function() {
            return false;
        },
        capability: function() {
            return "unsupported";
        }
    };
}
function $235969546b90e185$export$6bd9fc5eb870e619(host, logger) {
    if (host === void 0) host = globalThis;
    if (logger === void 0) logger = console;
    var installed = host.__appbase;
    if (!installed) return $235969546b90e185$export$27232abdbffb8d10(logger);
    return new $235969546b90e185$export$a7f333e73e2c6552(installed.transport, installed.configuration);
}
function $235969546b90e185$export$5351af3d40dabb1e(host, logger) {
    if (host === void 0) host = globalThis;
    if (logger === void 0) logger = console;
    var installed = host.__appbase;
    var bridge = $235969546b90e185$export$6bd9fc5eb870e619(host, logger);
    if (!installed) return {
        kind: "null",
        bridge: bridge
    };
    var manifestID = installed.configuration.manifestID;
    if (manifestID) return {
        kind: "manifest",
        manifestID: manifestID,
        bridge: bridge
    };
    return {
        kind: "raw",
        bridge: bridge
    };
}


const $66f5dcc94b7caf35$export$3c407b8d2fec6bfe = {
    appStyles: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.android.next", "appStyles"),
    deviceLanguage: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.android.next", "deviceLanguage"),
    log: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.android.next", "log"),
    showNotification: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.android.next", "showNotification"),
    playAlarm: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.android.next", "playAlarm"),
    stopAlarm: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.android.next", "stopAlarm"),
    printAction: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.android.next", "printAction")
};
const $66f5dcc94b7caf35$export$62dd60989a865594 = {};
function $66f5dcc94b7caf35$var$connectAndroidBridgeManifest(connection) {
    return Object.assign(Object.assign({}, connection), {
        manifestID: "logbook.android.next",
        bridge: (0, $235969546b90e185$export$eddb9065490e75cb)("logbook.android.next", connection.bridge)
    });
}
const $66f5dcc94b7caf35$export$e49c602bb1bbcf94 = {
    appStyles: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.apple", "appStyles"),
    deviceLanguage: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.apple", "deviceLanguage"),
    log: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.apple", "log"),
    showNotification: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.apple", "showNotification"),
    playAlarm: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.apple", "playAlarm"),
    stopAlarm: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.apple", "stopAlarm"),
    nativeSignIn: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.apple", "nativeSignIn"),
    printAction: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.apple", "printAction"),
    setNetworkKeepAlive: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.apple", "setNetworkKeepAlive"),
    "webView.openURL": (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.apple", "webView.openURL")
};
const $66f5dcc94b7caf35$export$d6a341c00a57f686 = {
    nativeSignIn: (0, $235969546b90e185$export$e8caa2704e7ebdee)("logbook.apple", "nativeSignIn"),
    "webView.urlNavigation.overlay": (0, $235969546b90e185$export$e8caa2704e7ebdee)("logbook.apple", "webView.urlNavigation.overlay"),
    "webView.urlNavigation.acknowledged": (0, $235969546b90e185$export$e8caa2704e7ebdee)("logbook.apple", "webView.urlNavigation.acknowledged")
};
function $66f5dcc94b7caf35$var$connectAppleBridgeManifest(connection) {
    return Object.assign(Object.assign({}, connection), {
        manifestID: "logbook.apple",
        bridge: (0, $235969546b90e185$export$eddb9065490e75cb)("logbook.apple", connection.bridge)
    });
}
const $66f5dcc94b7caf35$export$23d136c600f6619 = {
    appStyles: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.windows.next", "appStyles"),
    deviceLanguage: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.windows.next", "deviceLanguage"),
    log: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.windows.next", "log"),
    showNotification: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.windows.next", "showNotification"),
    playAlarm: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.windows.next", "playAlarm"),
    stopAlarm: (0, $235969546b90e185$export$d2d8f8ec998eaf33)("logbook.windows.next", "stopAlarm")
};
const $66f5dcc94b7caf35$export$ccf0be340c7fb2b3 = {};
function $66f5dcc94b7caf35$var$connectWindowsBridgeManifest(connection) {
    return Object.assign(Object.assign({}, connection), {
        manifestID: "logbook.windows.next",
        bridge: (0, $235969546b90e185$export$eddb9065490e75cb)("logbook.windows.next", connection.bridge)
    });
}
function $66f5dcc94b7caf35$export$35c072419819c18f(...args) {
    const connection = (0, $235969546b90e185$export$5351af3d40dabb1e)(...args);
    if (connection.kind !== "manifest") return connection;
    switch(connection.manifestID){
        case "logbook.android.next":
            return $66f5dcc94b7caf35$var$connectAndroidBridgeManifest(connection);
        case "logbook.apple":
            return $66f5dcc94b7caf35$var$connectAppleBridgeManifest(connection);
        case "logbook.windows.next":
            return $66f5dcc94b7caf35$var$connectWindowsBridgeManifest(connection);
        default:
            return {
                kind: "unknown",
                manifestID: connection.manifestID,
                bridge: connection.bridge
            };
    }
}


const $c212c8339ff2b280$var$bridgeInstaller = (0, $b30c71ecc182311a$export$a1275a5d257b987c)({
    connect: ()=>(0, $66f5dcc94b7caf35$export$35c072419819c18f)(window),
    host: window
});
function $c212c8339ff2b280$export$acf03d28f196f0c2(host = window) {
    if (host === window) return $c212c8339ff2b280$var$bridgeInstaller.install();
    return (0, $b30c71ecc182311a$export$a1275a5d257b987c)({
        connect: ()=>(0, $66f5dcc94b7caf35$export$35c072419819c18f)(host),
        host: host
    }).install();
}
function $c212c8339ff2b280$export$541d7d27655bf721() {
    return $c212c8339ff2b280$var$bridgeInstaller.manifest("logbook.apple");
}
function $c212c8339ff2b280$export$87211f39344503e8() {
    return $c212c8339ff2b280$var$bridgeInstaller.manifest("logbook.android.next");
}
function $c212c8339ff2b280$export$e33e30708fc6be8() {
    return $c212c8339ff2b280$var$bridgeInstaller.manifest("logbook.windows.next");
}
function $c212c8339ff2b280$export$84e93f8ddbebc33c(name, host = globalThis) {
    var _a;
    if (host === globalThis && ((_a = $c212c8339ff2b280$var$bridgeInstaller.current()) === null || _a === void 0 ? void 0 : _a.kind) === "manifest") return undefined;
    const bridge = host.ab;
    return (bridge === null || bridge === void 0 ? void 0 : bridge.supports(name)) ? bridge : undefined;
}



var $b21e9d1d7d451579$var$__assign = undefined && undefined.__assign || function() {
    $b21e9d1d7d451579$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b21e9d1d7d451579$var$__assign.apply(this, arguments);
};
var $b21e9d1d7d451579$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $b21e9d1d7d451579$export$8a0bf1eafa288f88 = [
    "debug",
    "info",
    "warn",
    "error",
    "silent"
];
var $b21e9d1d7d451579$var$LEVEL_THRESHOLD = {
    debug: 10,
    info: 20,
    warn: 30,
    error: 40,
    silent: Number.POSITIVE_INFINITY
};
function $b21e9d1d7d451579$var$isLogLevel(value) {
    return $b21e9d1d7d451579$export$8a0bf1eafa288f88.includes(value);
}
function $b21e9d1d7d451579$export$84794c89fefb0e74(options) {
    var _a, _b;
    if (options.explicit) return options.explicit;
    var stored = options.storageKey ? (0, $bf04d690697739ae$export$dda73877cb166cd3)(options.storageKey, {
        storage: options.storage
    }) : undefined;
    if ($b21e9d1d7d451579$var$isLogLevel(stored)) return stored;
    var environment = options.environmentKey ? (_a = options.environment) === null || _a === void 0 ? void 0 : _a[options.environmentKey] : undefined;
    return $b21e9d1d7d451579$var$isLogLevel(environment) ? environment : (_b = options.defaultLevel) !== null && _b !== void 0 ? _b : "info";
}
function $b21e9d1d7d451579$export$3d5a4279fc0c0ee1(value) {
    var seen = new WeakSet();
    var serialized = JSON.stringify(value, function(_key, current) {
        if (typeof current === "bigint") return current.toString();
        if (typeof current === "object" && current !== null) {
            if (seen.has(current)) return "[Circular]";
            seen.add(current);
        }
        if (current instanceof Error) return {
            name: current.name,
            message: current.message,
            stack: current.stack
        };
        return current;
    });
    return serialized !== null && serialized !== void 0 ? serialized : String(value);
}
function $b21e9d1d7d451579$export$fe2e61603b61130d(options) {
    var _a, _b;
    if (options === void 0) options = {};
    var level = $b21e9d1d7d451579$export$84794c89fefb0e74({
        explicit: options.level,
        environment: options.environment,
        environmentKey: options.environmentKey,
        storage: options.storage,
        storageKey: options.storageKey,
        defaultLevel: options.defaultLevel
    });
    var category = (_a = options.category) !== null && _a !== void 0 ? _a : "app";
    var consoleSink = (_b = options.console) !== null && _b !== void 0 ? _b : null;
    var write = function(method, message, values) {
        var _a;
        if ($b21e9d1d7d451579$var$LEVEL_THRESHOLD[method] < $b21e9d1d7d451579$var$LEVEL_THRESHOLD[level]) return;
        consoleSink === null || consoleSink === void 0 || consoleSink[method].apply(consoleSink, $b21e9d1d7d451579$var$__spreadArray([
            "[".concat(category, "]"),
            message
        ], values, false));
        (_a = options.nativeSink) === null || _a === void 0 || _a.call(options, {
            level: method,
            category: category,
            message: message,
            values: values,
            serialized: $b21e9d1d7d451579$export$3d5a4279fc0c0ee1({
                message: message,
                values: values
            })
        });
    };
    return {
        debug: function(message) {
            var values = [];
            for(var _i = 1; _i < arguments.length; _i++)values[_i - 1] = arguments[_i];
            return write("debug", message, values);
        },
        info: function(message) {
            var values = [];
            for(var _i = 1; _i < arguments.length; _i++)values[_i - 1] = arguments[_i];
            return write("info", message, values);
        },
        warn: function(message) {
            var values = [];
            for(var _i = 1; _i < arguments.length; _i++)values[_i - 1] = arguments[_i];
            return write("warn", message, values);
        },
        error: function(message) {
            var values = [];
            for(var _i = 1; _i < arguments.length; _i++)values[_i - 1] = arguments[_i];
            return write("error", message, values);
        },
        child: function(childCategory) {
            return $b21e9d1d7d451579$export$fe2e61603b61130d($b21e9d1d7d451579$var$__assign($b21e9d1d7d451579$var$__assign({}, options), {
                category: "".concat(category, ":").concat(childCategory),
                level: level
            }));
        }
    };
}



var $ea493e883ca706d4$var$_a, $ea493e883ca706d4$var$_b, $ea493e883ca706d4$var$_c;
const $ea493e883ca706d4$export$10369954900e6465 = Symbol("logbook.native");
// Ordered by increasing severity; `none` disables all output.
const $ea493e883ca706d4$var$RANK = {
    trace: 0,
    debug: 1,
    info: 2,
    notice: 3,
    warning: 4,
    error: 5,
    critical: 6,
    none: 7
};
// Which console method each level is routed to when it passes the threshold.
const $ea493e883ca706d4$var$CONSOLE_METHOD = {
    trace: "debug",
    debug: "debug",
    info: "info",
    notice: "info",
    warning: "warn",
    error: "error",
    critical: "error"
};
const $ea493e883ca706d4$var$STORAGE_KEY = "logbook:logLevel";
const $ea493e883ca706d4$export$97d4c6871900dcac = "debug";
function $ea493e883ca706d4$var$safeStringify(value) {
    if (typeof value === "string") return value;
    try {
        return (0, $b21e9d1d7d451579$export$3d5a4279fc0c0ee1)(value);
    } catch (_a) {
        return String(value);
    }
}
function $ea493e883ca706d4$var$postToNative(prefix, level, args) {
    var _a, _b, _c;
    try {
        const text = args.map($ea493e883ca706d4$var$safeStringify).join(" ");
        const fullText = prefix ? `${prefix} ${text}` : text;
        const apple = (0, $c212c8339ff2b280$export$541d7d27655bf721)();
        if (apple === null || apple === void 0 ? void 0 : apple.supports((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).log)) {
            apple.post((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).log, {
                level: level,
                message: fullText
            }).catch(()=>{});
            return;
        }
        const android = (0, $c212c8339ff2b280$export$87211f39344503e8)();
        if (android === null || android === void 0 ? void 0 : android.supports((0, $66f5dcc94b7caf35$export$3c407b8d2fec6bfe).log)) {
            android.post((0, $66f5dcc94b7caf35$export$3c407b8d2fec6bfe).log, {
                level: level,
                message: fullText
            }).catch(()=>{});
            return;
        }
        const windows = (0, $c212c8339ff2b280$export$e33e30708fc6be8)();
        if (windows === null || windows === void 0 ? void 0 : windows.supports((0, $66f5dcc94b7caf35$export$23d136c600f6619).log)) {
            windows.post((0, $66f5dcc94b7caf35$export$23d136c600f6619).log, {
                level: level,
                message: fullText
            }).catch(()=>{});
            return;
        }
        const unified = (0, $c212c8339ff2b280$export$84e93f8ddbebc33c)("log");
        if (unified) {
            unified.post("log", {
                level: level,
                message: fullText
            }).catch(()=>{});
            return;
        }
        const bridge = globalThis;
        const log = (_b = (_a = bridge.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.log;
        if (log) {
            log.postMessage(JSON.stringify({
                level: level,
                message: fullText
            }));
            return;
        }
        if ((_c = bridge.chrome) === null || _c === void 0 ? void 0 : _c.webview) {
            bridge.chrome.webview.postMessage(JSON.stringify({
                type: "log",
                level: level,
                message: fullText
            }));
            return;
        }
        if (bridge.__logbookLog) {
            bridge.__logbookLog.log(level, fullText);
            return;
        }
    } catch (_d) {
    // Native bridge unavailable or postMessage threw — ignore.
    }
}
function $ea493e883ca706d4$var$isLogLevel(value) {
    return typeof value === "string" && value in $ea493e883ca706d4$var$RANK;
}
function $ea493e883ca706d4$var$readStoredLevel() {
    var _a;
    try {
        const store = globalThis.localStorage;
        const value = (_a = store === null || store === void 0 ? void 0 : store.getItem) === null || _a === void 0 ? void 0 : _a.call(store, $ea493e883ca706d4$var$STORAGE_KEY);
        if ($ea493e883ca706d4$var$isLogLevel(value)) return value;
    } catch (_b) {
    // localStorage may be unavailable (SSR, disabled cookies) — ignore.
    }
    return undefined;
}
function $ea493e883ca706d4$export$e3e3b14012c7698c(env) {
    var _a;
    const level = (_a = env.LOG_LEVEL) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    if ($ea493e883ca706d4$var$isLogLevel(level)) return level;
    if (env.VERBOSE === "2") return "debug";
    if (env.VERBOSE) return "info";
    return undefined;
}
function $ea493e883ca706d4$var$readEnvLevel() {
    try {
        const env = undefined;
        if (env) return $ea493e883ca706d4$export$e3e3b14012c7698c(env);
    } catch (_a) {
    // `process` is not defined in some browser bundles — ignore.
    }
    return undefined;
}
let $ea493e883ca706d4$var$currentLevel = ($ea493e883ca706d4$var$_b = ($ea493e883ca706d4$var$_a = $ea493e883ca706d4$var$readStoredLevel()) !== null && $ea493e883ca706d4$var$_a !== void 0 ? $ea493e883ca706d4$var$_a : $ea493e883ca706d4$var$readEnvLevel()) !== null && $ea493e883ca706d4$var$_b !== void 0 ? $ea493e883ca706d4$var$_b : $ea493e883ca706d4$export$97d4c6871900dcac;
function $ea493e883ca706d4$export$12dbaabc76fb091a() {
    return $ea493e883ca706d4$var$currentLevel;
}
function $ea493e883ca706d4$export$c622e99c0ce7b1c9(level) {
    var _a, _b;
    if (!$ea493e883ca706d4$var$isLogLevel(level)) {
        // Use console.warn directly so the guidance is always visible.
        console.warn(`[logbook] invalid log level "${level}". Valid levels: ${Object.keys($ea493e883ca706d4$var$RANK).join(", ")}`);
        return $ea493e883ca706d4$var$currentLevel;
    }
    $ea493e883ca706d4$var$currentLevel = level;
    try {
        (_b = (_a = globalThis.localStorage) === null || _a === void 0 ? void 0 : _a.setItem) === null || _b === void 0 || _b.call(_a, $ea493e883ca706d4$var$STORAGE_KEY, level);
    } catch (_c) {
    // Persisting is best-effort.
    }
    // Confirmation is intentionally unconditional so the developer sees it.
    console.log(`[logbook] log level set to "${level}" (persisted in localStorage["${$ea493e883ca706d4$var$STORAGE_KEY}"]).`);
    return $ea493e883ca706d4$var$currentLevel;
}
class $ea493e883ca706d4$export$efa9a398d6368992 {
    constructor(category){
        this.category = category;
    }
    // Returns a logger that prefixes messages with a (possibly nested) category.
    child(category) {
        return new $ea493e883ca706d4$export$efa9a398d6368992(this.category ? `${this.category}.${category}` : category);
    }
    isEnabled(level) {
        return $ea493e883ca706d4$var$RANK[level] >= $ea493e883ca706d4$var$RANK[$ea493e883ca706d4$var$currentLevel];
    }
    // Logs ONLY to the native bridge (never the console) and ignores the console
    // level. Used internally by `emit` to mirror console output to native (with
    // the log's own level), and available directly for native-only diagnostics --
    // those default to the "info" level, since there's no console call to derive
    // one from.
    native(...args) {
        this.postNative("info", args);
    }
    postNative(level, args) {
        $ea493e883ca706d4$var$postToNative(this.category ? `[${this.category}]` : undefined, level, args);
    }
    emit(level, args) {
        // A trailing NATIVE sentinel forces the message to native even when the
        // level would suppress it (console output still respects the level).
        let forceNative = false;
        if (args.length > 0 && args[args.length - 1] === $ea493e883ca706d4$export$10369954900e6465) {
            forceNative = true;
            args = args.slice(0, -1);
        }
        const enabled = $ea493e883ca706d4$var$RANK[level] >= $ea493e883ca706d4$var$RANK[$ea493e883ca706d4$var$currentLevel];
        if (enabled) {
            const method = $ea493e883ca706d4$var$CONSOLE_METHOD[level];
            if (this.category) console[method](`[${this.category}]`, ...args);
            else console[method](...args);
        }
        // By default native mirrors the console (only forwards what the level would
        // log); the NATIVE sentinel forces it through regardless. Either way the
        // native envelope carries this call's own level, not the "info" default
        // `native()` uses when called directly.
        if (enabled || forceNative) this.postNative(level, args);
    }
    trace(...args) {
        this.emit("trace", args);
    }
    debug(...args) {
        this.emit("debug", args);
    }
    info(...args) {
        this.emit("info", args);
    }
    notice(...args) {
        this.emit("notice", args);
    }
    warning(...args) {
        this.emit("warning", args);
    }
    error(...args) {
        this.emit("error", args);
    }
    critical(...args) {
        this.emit("critical", args);
    }
}
const $ea493e883ca706d4$export$af88d00dbe7f521 = new $ea493e883ca706d4$export$efa9a398d6368992();
function $ea493e883ca706d4$export$fe2e61603b61130d(category) {
    return new $ea493e883ca706d4$export$efa9a398d6368992(category);
}
function $ea493e883ca706d4$export$9de129cb03ba998c(values) {
    if (!values || typeof values !== "object" || Array.isArray(values)) return [];
    return Object.keys(values).sort();
}
// Expose runtime controls on the global object so they can be driven from the
// browser devtools console (e.g. `logbook.setLogLevel("debug")`).
try {
    const globals = globalThis;
    globals.logbook = Object.assign(Object.assign({}, ($ea493e883ca706d4$var$_c = globals.logbook) !== null && $ea493e883ca706d4$var$_c !== void 0 ? $ea493e883ca706d4$var$_c : {}), {
        logger: $ea493e883ca706d4$export$af88d00dbe7f521,
        createLogger: $ea493e883ca706d4$export$fe2e61603b61130d,
        getLogLevel: $ea493e883ca706d4$export$12dbaabc76fb091a,
        setLogLevel: $ea493e883ca706d4$export$c622e99c0ce7b1c9,
        levels: Object.keys($ea493e883ca706d4$var$RANK)
    });
} catch (_d) {
// Ignore environments without a writable global.
}


// @generated by TypeGen from LogbookApi/Subscriptions - DO NOT EDIT
const $1bedde6805bf6e79$export$f55210826850c514 = {
    Account: {
        type: "Account"
    },
    AccountUser: {
        type: "AccountUser"
    },
    AppStatus: {
        type: "AppStatus"
    },
    Cruise: {
        type: "Cruise"
    },
    DataRecord: {
        type: "DataRecord"
    },
    Day: {
        type: "Day"
    },
    LocalShip: {
        type: "LocalShip"
    },
    Log: {
        type: "Log"
    },
    Note: {
        type: "Note"
    },
    NoteAttachment: {
        type: "NoteAttachment"
    },
    Settings: {
        type: "Settings"
    },
    Ship: {
        type: "Ship"
    },
    ShipUser: {
        type: "ShipUser"
    },
    Status: {
        type: "Status"
    },
    StoredCalculation: {
        type: "StoredCalculation"
    },
    Track: {
        type: "Track"
    },
    Trip: {
        type: "Trip"
    },
    User: {
        type: "User"
    },
    currentLog: {
        type: "Log/Current"
    },
    dayNavigation: {
        type: "Day/Navigation"
    },
    provisionalLog: {
        type: "Log/Provisional"
    },
    shipClose: {
        type: "Ship/Close"
    },
    storedCalculationCruise: {
        type: "StoredCalculation/Cruise"
    },
    storedCalculationDay: {
        type: "StoredCalculation/Day"
    },
    storedCalculationLog: {
        type: "StoredCalculation/Log"
    },
    storedCalculationShip: {
        type: "StoredCalculation/Ship"
    },
    storedCalculationStatus: {
        type: "StoredCalculation/Status"
    },
    storedCalculationTest: {
        type: "StoredCalculation/Test"
    },
    storedCalculationTrip: {
        type: "StoredCalculation/Trip"
    }
};
function $1bedde6805bf6e79$export$4b39a51ae1e6775e(id) {
    return `account:${id}`;
}
function $1bedde6805bf6e79$export$8776ac2d8c1066b3(id) {
    return `ship:${id}`;
}
const $1bedde6805bf6e79$export$88a78fd7c08c17e6 = {
    path: "/api/stream",
    token: "token",
    since: "since"
};


function $62b5d19f2b3ee711$var$isHttpStatusError(error) {
    if (error instanceof (0, $f21b0ce903cacac0$export$34421c09961aeaa3)) return true;
    if (error == null || typeof error != "object") return false;
    const value = error;
    return value.name == "HttpStatusError" && typeof value.status == "number";
}
class $62b5d19f2b3ee711$export$1f2bb630327ac4b6 {
    static setActingShipUserId(id) {
        $62b5d19f2b3ee711$export$1f2bb630327ac4b6.actingShipUserId = id;
    }
    constructor(session){
        this.disconnected = false;
        this.streamTimeout = 1000;
        this.session = session || (0, $2b75519151ca9024$export$3f685a6e8b195eac)("logbook-session");
        this.http = (0, $f21b0ce903cacac0$export$c3792535cb9f34af)({
            fetch: (input, init)=>window.fetch(input, init),
            resolveUrl: (path)=>`/api/${path}`,
            headers: ()=>{
                const headers = new Headers();
                if (this.session) headers.set("Authorization", `token ${this.session}`);
                if ($62b5d19f2b3ee711$export$1f2bb630327ac4b6.actingShipUserId != undefined) headers.set("X-Acting-Ship-User-Id", String($62b5d19f2b3ee711$export$1f2bb630327ac4b6.actingShipUserId));
                return headers;
            }
        });
        this.realtime = (0, $bbedd69b602ce93d$export$c417d7049a9c9658)({
            createUrl: ({ cursor: cursor, resuming: resuming })=>{
                if (!this.session) return undefined;
                const proto = document.location.protocol == "https:" ? "wss:" : "ws:";
                return proto + document.location.host + (0, $1bedde6805bf6e79$export$88a78fd7c08c17e6).path + "?" + (0, $1bedde6805bf6e79$export$88a78fd7c08c17e6).token + "=" + encodeURIComponent(this.session) + (resuming ? "&" + (0, $1bedde6805bf6e79$export$88a78fd7c08c17e6).since + "=" + cursor : "");
            },
            createSocket: (url)=>new window.WebSocket(url),
            reconnectDelay: ()=>this.streamTimeout,
            channelSubscriptionDelay: 100,
            socketOpenState: WebSocket.OPEN,
            initialCursor: undefined,
            parseData: (data)=>JSON.parse(String(data)),
            onControl: (message)=>{
                if (message.event == "replay-incomplete") window.location.reload();
                else if (message.event == "companion-disconnected") {
                    this.endSession();
                    this.trigger("CompanionDisconnected", {}, message.event);
                }
            },
            onConnection: ({ connected: connected })=>{
                this.disconnected = !connected;
                this.realtime.trigger("socket", connected, connected ? "connect" : "disconnect");
            }
        });
    }
    get socket() {
        return this.realtime.socket();
    }
    get maxId() {
        var _a;
        return (_a = this.realtime.resumeCursor()) !== null && _a !== void 0 ? _a : 0;
    }
    set maxId(value) {
        this.realtime.setResumeCursor(value > 0 ? value : undefined);
    }
    async call(method, action, props, file) {
        try {
            return await this.http.request({
                method: method,
                path: action,
                query: method == "GET" && props ? Object.fromEntries(Object.entries(props).map(([key, value])=>[
                        key,
                        value ? value : ""
                    ])) : undefined,
                body: method != "GET" && !file ? props : undefined,
                multipart: file ? {
                    attachment: {
                        value: file,
                        filename: file.name
                    }
                } : undefined
            });
        } catch (error) {
            if (!$62b5d19f2b3ee711$var$isHttpStatusError(error)) throw error;
            const data = error.body != null && typeof error.body == "object" ? Object.assign({}, error.body) : {};
            data.httpStatus = error.status;
            throw data;
        }
    }
    stream(timeout = 1000) {
        this.streamTimeout = timeout;
        this.disconnected = false;
        this.realtime.connect();
    }
    endSession() {
        this.session = undefined;
        this.disconnected = true;
        this.realtime.disconnect();
    }
    subscribeChannel(channel) {
        this.realtime.subscribeChannel(channel);
    }
    unsubscribeChannel(channel) {
        this.realtime.unsubscribeChannel(channel);
    }
    subscribe(type, callback) {
        return this.realtime.subscribe(type, (data, subscriptionType, event)=>{
            const reportError = (error)=>{
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Realtime update failed", {
                    type: subscriptionType,
                    event: event
                }, error);
            };
            try {
                Promise.resolve(callback(data, subscriptionType, event)).catch(reportError);
            } catch (error) {
                reportError(error);
            }
        });
    }
    trigger(type, data, info) {
        this.realtime.trigger(type, data, info);
    }
    unsubscribe(type, id) {
        this.realtime.unsubscribe(type, id);
    }
    subscribeSocket(callback) {
        return this.subscribe("socket", (connected, _type, event)=>callback(connected, event));
    }
    unsubscribeSocket(id) {
        this.unsubscribe("socket", id);
    }
}


// Hand-written transport that backs the generated typed REST client.
//
// The generated resource classes (e.g. `class CruiseApi`) call
// `ApiClient.call(key, args)` with a `"METHOD /api/path/:param"` endpoint key and a
// typed `{ params, query?, body? }` bag. This adapter turns that back into logbook's
// stringly-typed `Client.call(method, action, props?)`:
//   - splits the key into HTTP method + path template,
//   - substitutes `:params` from `args.params`,
//   - drops the leading `/api/` that `Client.call` re-adds, and
//   - forwards `query` (GET) or `body` (otherwise) as the props bag.
// It stays a thin delegate so the pre-migration `Client.call` wire contract — and the
// tests pinned to it — hold unchanged after a resource moves onto the typed client.
//
// It also implements `.url(key, args)`: the same `:param` substitution, but returning
// the route's own path (keeping its `/api/…` API prefix or bare `/ships/…/download`
// file-route prefix, plus any query) so consumers can embed a route URL — e.g. an
// attachment `<img src>` — without issuing a request.


function $be0017b4bd97ce4b$export$8744222f7aa763e1(target, session) {
    return (0, $a668bc461693ca0f$export$3aff26c134954d44)({
        target: target,
        call (method, action, props, file) {
            const client = new (0, $62b5d19f2b3ee711$export$1f2bb630327ac4b6)(session);
            if (file !== undefined) return client.call(method, action, props !== null && props !== void 0 ? props : {}, file);
            return props === undefined ? client.call(method, action) : client.call(method, action, props);
        },
        requestPath: (path)=>path.startsWith("/api/") ? path.slice(5) : path.replace(/^\//, ""),
        requestBody: (body)=>{
            const { props: props, file: file } = $be0017b4bd97ce4b$var$splitFile(body);
            return {
                request: props,
                file: file
            };
        }
    });
}
function $be0017b4bd97ce4b$export$f370f529bb92f476(key, args) {
    const { method: method, path: path, request: request } = (0, $a668bc461693ca0f$export$ccbb4bbc18e1f082)(key, args);
    const action = path.startsWith("/api/") ? path.slice(5) : path.replace(/^\//, "");
    if (method === "GET") return {
        method: method,
        action: action,
        props: request
    };
    // A multipart route folds its file into `body`; split it out so the transport can
    // send it as `FormData` (4th arg) with the remaining scalar fields as props.
    const { props: props, file: file } = $be0017b4bd97ce4b$var$splitFile(request);
    return {
        method: method,
        action: action,
        props: props,
        file: file
    };
}
function $be0017b4bd97ce4b$var$splitFile(body) {
    if (body === undefined) return {};
    const props = {};
    let file;
    for (const [name, value] of Object.entries(body))if (value instanceof File) file = value;
    else props[name] = value;
    return {
        props: props,
        file: file
    };
}


// Wraps a strongly-typed formatter body (operating on a precise value type `T`) as a
// `CompositeFormatter` -- runtime-guards `unknown` down to `T` first, rendering "–"
// if the guard fails or the value is undefined/null (matching `FieldFormat`'s shared
// dash convention for a missing value), so the formatter body itself never needs an
// `unknown`/type-assertion escape.
var $d0a54cefbcc25c10$var$__assign = undefined && undefined.__assign || function() {
    $d0a54cefbcc25c10$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d0a54cefbcc25c10$var$__assign.apply(this, arguments);
};
function $d0a54cefbcc25c10$export$dc42b0b00b389e2e(value) {
    if (value === null || value === undefined) return "";
    if (value instanceof Date) return value.toISOString();
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
}
function $d0a54cefbcc25c10$export$18fadbe56dfcb1a1(handlers) {
    return function(kind, value) {
        var handler = handlers[kind];
        if (!handler) throw new Error("Unknown format kind: ".concat(kind));
        return handler(value);
    };
}
function $d0a54cefbcc25c10$export$de84f905cb631ae1(value, path) {
    var current = value;
    for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
        var segment = path_1[_i];
        if (current === null || typeof current !== "object") return undefined;
        current = current[segment];
    }
    return current;
}
function $d0a54cefbcc25c10$export$3ae94a2503e890a1(referenceSeconds, options) {
    var date = new Date(options.referenceDate.getTime() + referenceSeconds * 1000);
    return new Intl.DateTimeFormat(options.locale, options.options).format(date);
}
function $d0a54cefbcc25c10$export$3203edd9e5edd663(referenceSeconds, options) {
    var date = new Date(options.referenceDate.getTime() + referenceSeconds * 1000);
    return new Intl.DateTimeFormat(options.locale, $d0a54cefbcc25c10$var$__assign({
        hour: "numeric",
        minute: "2-digit"
    }, options.options)).format(date);
}
function $d0a54cefbcc25c10$export$f5dd818bff069720(value, locale, options) {
    return new Intl.NumberFormat(locale, options).format(value);
}


function $14a8bda8b42de2c4$export$2f84fdd660581d7f(guard, formatter) {
    return (value)=>value == undefined || !guard(value) ? "\u2013" : formatter(value);
}
function $14a8bda8b42de2c4$export$6d11197b6687e2cb(entry, value, formatFn) {
    if (typeof entry === "string") return value == undefined ? "\u2013" : formatFn(entry, value);
    return entry(value);
}
function $14a8bda8b42de2c4$export$63afb81dba78b33e(value) {
    if (typeof value == "number") return new Date(value);
    return new Date(Date.parse(value));
}
function $14a8bda8b42de2c4$export$a612b85af1fcec81(value) {
    if (typeof value == "number") return value;
    return parseInt(value);
}
function $14a8bda8b42de2c4$export$fd5517c955416894(value) {
    if (typeof value == "number") return value;
    return parseFloat(value);
}
const $14a8bda8b42de2c4$export$4334e0aa46d23a16 = Date.UTC(2001, 0, 1);
const $14a8bda8b42de2c4$export$93514d28bd18d75a = {
    "angle": function(value) {
        const angle = $14a8bda8b42de2c4$export$fd5517c955416894(value);
        if (isNaN(angle)) return "";
        return `${angle.toFixed(0)}\xb0`;
    },
    "course": function(value) {
        const course = $14a8bda8b42de2c4$export$fd5517c955416894(value);
        if (isNaN(course)) return "";
        return `${course.toFixed(0).padStart(3, "0")}\xb0`;
    },
    "date": function(date) {
        return $14a8bda8b42de2c4$export$63afb81dba78b33e(date).toLocaleDateString(navigator.language, {
            month: "long",
            day: "numeric",
            year: "numeric",
            timeZone: "UTC"
        });
    },
    "dateCompact": function(date) {
        return $14a8bda8b42de2c4$export$63afb81dba78b33e(date).toLocaleDateString(navigator.language, {
            month: "short",
            day: "numeric",
            year: "numeric",
            timeZone: "UTC"
        });
    },
    "dateAndTime": function(date) {
        return $14a8bda8b42de2c4$export$63afb81dba78b33e(date).toLocaleString(navigator.language, {
            dateStyle: "full",
            timeStyle: "short"
        });
    },
    "dateInYear": function(date) {
        return $14a8bda8b42de2c4$export$63afb81dba78b33e(date).toLocaleDateString(navigator.language, {
            month: "numeric",
            day: "numeric",
            weekday: "short",
            timeZone: "UTC"
        });
    },
    "dateTime": function(date) {
        return $14a8bda8b42de2c4$export$63afb81dba78b33e(date).toLocaleTimeString(navigator.language, {
            timeStyle: "short"
        });
    },
    "durationHours": function(value) {
        const durationHours = $14a8bda8b42de2c4$export$a612b85af1fcec81(value);
        if (isNaN(durationHours)) return "";
        return `${durationHours.toFixed(0)} h`;
    },
    "distance": function(value) {
        const distance = $14a8bda8b42de2c4$export$fd5517c955416894(value);
        if (isNaN(distance)) return "";
        if (distance >= 1000) return `${distance.toFixed(0)} nm`;
        return `${distance.toFixed(1)} nm`;
    },
    "depth": function(value) {
        const distance = $14a8bda8b42de2c4$export$fd5517c955416894(value);
        if (isNaN(distance)) return "";
        return `${distance.toFixed(1)} m`;
    },
    "gps-lat": function(value) {
        const lat = $14a8bda8b42de2c4$export$fd5517c955416894(value);
        if (isNaN(lat)) return "";
        return `${(lat < 0 ? lat * -1 : lat).toFixed(3)}\xb0 ${lat >= 0 ? "N" : "S"}`;
    },
    "gps-lng": function(value) {
        const lng = $14a8bda8b42de2c4$export$fd5517c955416894(value);
        if (isNaN(lng)) return "";
        return `${(lng < 0 ? lng * -1 : lng).toFixed(3)}\xb0 ${lng >= 0 ? "E" : "W"}`;
    },
    "meters": function(value) {
        const meters = $14a8bda8b42de2c4$export$fd5517c955416894(value);
        if (isNaN(meters)) return "";
        return `${meters.toFixed(1)} m`;
    },
    "percentage": function(value) {
        const percentage = $14a8bda8b42de2c4$export$fd5517c955416894(value);
        if (isNaN(percentage)) return "";
        return `${percentage.toFixed(0)} %`;
    },
    "pluralize": function(n) {
        return $14a8bda8b42de2c4$export$a612b85af1fcec81(n) != 1 ? "s" : "";
    },
    "pressure": function(n) {
        const pressure = $14a8bda8b42de2c4$export$fd5517c955416894(n);
        if (isNaN(pressure)) return "";
        return `${Math.abs(pressure).toFixed(1)} hPa`;
    },
    "rpm": function(n) {
        const rpm = $14a8bda8b42de2c4$export$fd5517c955416894(n);
        if (isNaN(rpm)) return "";
        return `${Math.abs(rpm).toFixed(0)} rpm`;
    },
    "speed": function(value) {
        const speed = $14a8bda8b42de2c4$export$fd5517c955416894(value);
        if (isNaN(speed)) return "";
        return `${speed.toFixed(1)} kn`;
    },
    "temperature": function(value) {
        const temperature = $14a8bda8b42de2c4$export$fd5517c955416894(value);
        if (isNaN(temperature)) return "";
        return `${temperature.toFixed(0)} \xb0C`;
    },
    // Plain-string passthrough (issue #529) -- for fields (e.g. Trip/Cruise's `title`)
    // that need the shared "–"-for-missing convention but no unit/locale formatting.
    "text": function(value) {
        return typeof value === "string" ? value : String(value);
    },
    "time": function(time) {
        const hour = $14a8bda8b42de2c4$export$a612b85af1fcec81(time) / 3600;
        return `${Math.floor(hour)}:${Math.floor(hour * 60 % 60).toFixed(0).padStart(2, "0")}`;
    },
    "timeh": function(time) {
        const hour = $14a8bda8b42de2c4$export$a612b85af1fcec81(time) / 3600;
        return `${Math.floor(hour)}:${Math.floor(hour * 60 % 60).toFixed(0).padStart(2, "0")} h`;
    },
    "timeUtc": function(time) {
        const d = new Date($14a8bda8b42de2c4$export$4334e0aa46d23a16 + $14a8bda8b42de2c4$export$a612b85af1fcec81(time) * 1000);
        return `${d.getUTCHours()}:${d.getUTCMinutes().toFixed(0).padStart(2, "0")}`;
    },
    "timezone": function(timezone) {
        const offset = $14a8bda8b42de2c4$export$a612b85af1fcec81(timezone);
        if (offset == 0) return "UTC";
        // Format from the magnitude: formatting the signed offset used to floor
        // -9.5 h to -10 and drop the (negative) minutes, so -9:30 read as "UTC-10"
        // and -3:30 as "UTC-4" (#1821).
        const magnitude = Math.abs(offset);
        const hours = Math.floor(magnitude / 3600);
        const minutes = Math.round(magnitude % 3600 / 60);
        return `UTC${offset > 0 ? "+" : "-"}${hours}${minutes > 0 ? `:${minutes.toString().padStart(2, "0")}` : ""}`;
    },
    "timeAgoDate": function(date) {
        const rtf1 = new Intl.RelativeTimeFormat("en", {
            style: "short"
        });
        const d = $14a8bda8b42de2c4$export$63afb81dba78b33e(date);
        let t = (new Date().valueOf() - d.valueOf()) / 1000;
        if (t < 60) return rtf1.format(-Math.floor(t), "seconds");
        t /= 60;
        if (t < 60) return rtf1.format(-Math.floor(t), "minutes");
        t /= 60;
        if (t < 24) return rtf1.format(-Math.floor(t), "hours");
        return $14a8bda8b42de2c4$export$93514d28bd18d75a.date(date);
    }
};
function $14a8bda8b42de2c4$export$d9468344d3651243(format, value) {
    if (value == undefined || value == null) return "";
    const formatter = $14a8bda8b42de2c4$export$93514d28bd18d75a[format];
    if (formatter) return formatter(value);
    return (0, $d0a54cefbcc25c10$export$dc42b0b00b389e2e)(value);
}




// AppOverlayContentView moved into Views/App/OverlayContentView.tsx. This thin re-export
// barrel keeps the original `./AppOverlayContentView` import path working for the many
// hub-external importers (menu components, AboutView, ShipSyncStatusView, ShipSelectView,
// the Account settings views) that import it outside the AppView hub.


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $736b3300c1bfc0c7$export$63e8bf8ba447cd7a(name) {
    var Context = (0, $acw62.createContext)(undefined);
    Context.displayName = name;
    return {
        Context: Context,
        useDependencies: function() {
            var dependencies = (0, $acw62.useContext)(Context);
            if (dependencies === undefined) throw new Error("".concat(name, " provider is missing"));
            return dependencies;
        }
    };
}



var $acw62 = parcelRequire("acw62");

function $9ee99da17e54efd8$export$5b4310eab721f4c(a, b) {
    var _a, _b, _c, _d;
    const byTime = a.timeUtc - b.timeUtc;
    if (byTime != 0) return byTime;
    const aCommitted = ((_a = a.id) !== null && _a !== void 0 ? _a : 0) > 0;
    const bCommitted = ((_b = b.id) !== null && _b !== void 0 ? _b : 0) > 0;
    if (aCommitted != bCommitted) return aCommitted ? -1 : 1;
    return aCommitted ? ((_c = a.id) !== null && _c !== void 0 ? _c : 0) - ((_d = b.id) !== null && _d !== void 0 ? _d : 0) : 0;
}


const $5ba8962d09b05c4a$export$b531eccea6f91101 = {
    updateData (data, object, resetFields) {
        if (data.findIndex((d)=>d.id == object.id) >= 0) return data.map((d)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
            if (d["deletedAt"] != undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
            return null;
            if (d.id == object.id) {
                if (resetFields) for (const field of resetFields)// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
                d[field] = object[field];
                return Object.assign(d, object);
            }
            return d;
        }).filter(Boolean);
        // Return a NEW array rather than mutating `data` in place: every call site does
        // `setState(updateData(state, obj))`, and React's Object.is bail-out would
        // otherwise see the same reference and silently skip the re-render -- the new
        // entity would then only appear after a reload (#1137's blank-day-note report).
        return [
            ...data,
            object
        ];
    },
    /**
     * Upsert/remove a provisional (in-progress, uncommitted) model in a map keyed by a
     * stable `key` (its `metadata.provisionalKey`). Provisional models all share id 0, so
     * they can't merge by id like `updateData` — the key identifies which entry a live
     * `update` replaces or a `delete` removes. Returns a new map (pure).
     */ updateProvisional (map, key, object, info) {
        if (!key) return map;
        const next = Object.assign({}, map);
        if (info == "delete") delete next[key];
        else next[key] = object;
        return next;
    },
    /**
     * Fold provisional models into a committed list, always sorted by `timeUtc`.
     * Committed auto-logs (e.g. a course change) are back-dated to the moment the
     * maneuver began, but arrive on the live channel after later entries and are
     * appended to the end of the list — so the merged timeline must be re-sorted by
     * time, not insertion/creation order, whether or not provisional entries exist.
     */ mergeProvisional (data, provisional) {
        const merged = provisional.length < 1 ? data : [
            ...data,
            ...provisional
        ];
        return merged.toSorted((0, $9ee99da17e54efd8$export$5b4310eab721f4c));
    },
    dataWithCalculations (data, calculations, notes, attachments, id) {
        if (calculations) data = data.map((o)=>{
            const calculated = calculations.find((e)=>e.id == o.id);
            o.calculated = calculated === null || calculated === void 0 ? void 0 : calculated.values;
            o.calculationVersion = calculated === null || calculated === void 0 ? void 0 : calculated.version;
            return o;
        });
        if (notes && id) data = data.map((o)=>{
            let dataNotes = notes.filter((n)=>{
                const i = id(n);
                return i && i == o.id;
            });
            if (attachments) dataNotes = dataNotes.map((n)=>{
                n.attachments = attachments.filter((a)=>a.noteId == n.id);
                return n;
            });
            o.notes = dataNotes;
            return o;
        });
        return data;
    },
    /**
     * Merge a live stored-calculation broadcast's parsed payload onto a calculated
     * model, pairing `.calculated` with `.calculationVersion` the same way
     * `dataWithCalculations` pairs them on initial load. Mutates `target` in place
     * (mirroring `updateData`'s merge style) and returns it so callers can chain into
     * `updateData`/`setState` at the call site. Without pairing the version too, a
     * newer-shaped broadcast payload would be merged under the model's OLD version, so
     * a version-aware reader (e.g. `StatsView`'s placeholder guard) can't detect the
     * mismatch and renders the new payload as if it still had the old shape (#1122).
     */ applyStoredCalculation (target, parsed) {
        target.calculated = parsed.dataParsed;
        target.calculationVersion = parsed.version;
        return target;
    },
    deleteSession (api) {
        return new (0, $6e7887a8bef248ec$export$1fb4852a55678982)(api).session.delete({
            params: {}
        }).call();
    },
    selectShip (api, shipId, close, force = false) {
        const body = force ? {
            shipId: shipId,
            close: close,
            force: true
        } : {
            shipId: shipId,
            close: close
        };
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.selectApp({
            params: {},
            body: body
        }).call();
    },
    loadStatus (api) {
        return new (0, $5094ab6cf9038f1f$export$3565eb3d00ca5a74)(api).status.get({
            params: {}
        }).call();
    },
    loadCurrent (api) {
        return new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.get({
            params: {}
        }).call();
    },
    loadServer (api) {
        return new (0, $5094ab6cf9038f1f$export$3565eb3d00ca5a74)(api).server.get({
            params: {}
        }).call();
    },
    loadSession (api) {
        return new (0, $6e7887a8bef248ec$export$1fb4852a55678982)(api).session.get({
            params: {}
        }).call();
    },
    // Ask the backend to restore the device's primary session from server-side
    // ClientData after a localStorage wipe. The backend hard-gates this to the
    // loopback peer, so a companion can never obtain the primary token.
    restoreSession (api) {
        return new (0, $6e7887a8bef248ec$export$1fb4852a55678982)(api).session.restore({
            params: {}
        }).call();
    }
};




const $b57fb2219af67c07$export$1fb4852a55678982 = {
    isLoopbackHost (host) {
        return host === "localhost" || host === "127.0.0.1" || host === "[::1]";
    },
    isCompanionRoute (path) {
        return /^\/app\/ships\/\d+\/companion\/[^/]+\/?$/.test(path);
    },
    localReturnURL (value) {
        if (!value) return undefined;
        if (value === "logbook://app/account") return value;
        try {
            const url = new URL(value);
            if ((url.protocol === "http:" || url.protocol === "https:") && this.isLoopbackHost(url.hostname) && !url.username && !url.password && url.pathname === "/app/account" && !url.search && !url.hash) return url.href;
        } catch (_a) {
        // Untrusted navigation input is not a usable return destination.
        }
        return undefined;
    },
    beginCompanion (shipId) {
        localStorage.setItem("logbook-companion", shipId.toString());
    },
    clearCompanion (shipId) {
        if ((0, $2b75519151ca9024$export$8bf6241f4c41c4e0)("logbook-companion") === shipId) {
            localStorage.removeItem("logbook-companion");
            if ((0, $2b75519151ca9024$export$8bf6241f4c41c4e0)("logbook-ship") === shipId) localStorage.removeItem("logbook-ship");
        }
    },
    streamInterval (isPrimary) {
        return isPrimary ? 1000 : 10000;
    },
    // Whether a failed session load is a definitive answer ("this session is over")
    // or something to come back from. ONLY an auth rejection ends the session:
    // `GET /api/session` (`Sources/LogbookApp/Session.swift`) answers 401 for a
    // token it doesn't know, and everything else it can emit is a state the app
    // can still recover from -- notably the 503 it returns while the account row
    // it needs hasn't been synced into the local DB yet.
    //
    // Previously *every* 4xx logged the user out, which meant a 404 (which that
    // route used to return for exactly that not-ready-yet case) silently dropped a
    // perfectly valid stored token and dumped the user back on the login screen
    // (#1300).
    // Whether a failed ship load is worth another attempt (#1279). Selecting a ship
    // runs `newInstance(shipId:reset: true)` -> `native.resetDB()`, which deletes and
    // re-downloads the local ship DB; requests landing in that window cannot be
    // answered yet. The app reports that as 503 (and, if the schema has not been
    // recreated yet, a request can still surface a raw DB error as a 500), while the
    // pre-#1279 build answered 401 for the same race -- so all of those retry.
    //
    // A NETWORK-level failure retries too, and this is the common case rather than the
    // exotic one: selecting a ship RESTARTS the app instance (`POST /api/ship` ->
    // "start instance" in `LogbookApp.swift`), which drops every in-flight connection.
    // WebKit reports that as `TypeError: Load failed` -- an error with no `httpStatus`
    // at all -- so treating "no status" as unrecognisable gave up instantly on a
    // request that failed only because the server was mid-restart, one it would have
    // answered a second later. Captured from a real run: three instance restarts in
    // 30s, and the app never recovered from the first dropped request (#1279).
    //
    // A 404 retries too, for the same reason the session load already does (#1300).
    // The readiness gate answers 503 while `syncStatus` is `.selectShip` or
    // `.initialSyncInProgress`, but that clears when the SYNC finishes -- and the
    // `ships` row is a separate row that can still be absent for a moment afterwards,
    // so a request landing in that sliver gets an ordinary "no such ship". Captured on
    // one instance four milliseconds apart: `GET /api/ships/6` -> serviceUnavailable,
    // then `GET /api/ships/6` -> notFound. Giving up on the second stranded the app on
    // the account route with the ship never opening.
    //
    // A 403 still gives up: that is an answer about permission, which re-asking cannot
    // change. So does a status present but not a number -- a malformed response rather
    // than a transient one. Retrying is bounded (5 attempts, ~15s) and non-destructive,
    // so a genuinely missing ship still ends up at the ship list, just a few seconds
    // later, while a ship that was moments from being ready now opens.
    classifyShipLoadFailure (error) {
        const status = error === null || error === void 0 ? void 0 : error.httpStatus;
        if (status === undefined) return "retry";
        if (status === 401 || status === 404) return "retry";
        return typeof status == "number" && status >= 500 ? "retry" : "giveUp";
    },
    classifySessionLoadFailure (error) {
        const status = error === null || error === void 0 ? void 0 : error.httpStatus;
        return status === 401 || status === 403 ? "logout" : "retry";
    },
    // Whether the app's own sync status says the local ship DB is still being
    // (re)populated, so a retryable ship-load failure means "not yet" rather than
    // "not working". These are exactly the two statuses
    // `LogbookApp.localDataUnavailable()` answers 503 for.
    //
    // The bounded ship-load budget above (5 attempts, ~15s) was sized for the short
    // races AROUND a ship select, not for the initial sync itself: that downloads a
    // whole ship and routinely runs for minutes, with every request answered 503 for
    // its entire duration. Spending the budget on it meant selecting a ship gave up
    // and dropped the user on `/app/account` while the sync went on to finish
    // normally. An attempt made in this window is therefore excused rather than
    // spent -- the budget stays intact for once the sync is over.
    //
    // `initialSyncFailed` deliberately does NOT wait: it is a real, settled outcome
    // that must surface at the ship list where the user can act on it, not a state
    // to sit on indefinitely. Nor does an unreadable status (the app was mid-restart),
    // which is precisely what the bounded budget is for.
    shipLoadWaitsForSync (status) {
        return status == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).selectShip || status == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).initialSyncInProgress;
    },
    // How long before the next ship-load attempt. `undefined` means the attempt is
    // waiting on the sync (see above): those are unbounded, so they poll at a steady
    // cadence instead of doubling away into being minutes late noticing a sync that
    // has long finished. Budgeted attempts keep the escalating backoff.
    shipLoadRetryDelay (attempt) {
        return attempt == undefined ? 3000 : 1000 * Math.pow(2, attempt);
    },
    // The app's launch route (`/app/launch`) is the only place a wiped
    // localStorage session is restored from the server. The native clients always
    // load it over loopback (localhost), and the backend independently hard-gates
    // restore to the loopback peer, so this is a UX gate, not the security
    // boundary. Matches `/app/launch` (and a bare `/launch`) with any trailing
    // slash, but NOT the `/app/ships/:id/launch` (launchShip) route.
    isLaunchRoute (pathname) {
        const path = pathname.replace(/\/+$/, "");
        return path == "/launch" || path.endsWith("/app/launch");
    },
    // Whether to attempt a server-side session restore: only on the launch route,
    // only for a device app session (never a cloud session), and only when the
    // localStorage token is actually missing (a present token loads normally).
    shouldRestore (pathname, cloudSession) {
        return !cloudSession && !(0, $2b75519151ca9024$export$3f685a6e8b195eac)("logbook-session") && this.isLaunchRoute(pathname);
    },
    clearSession () {
        localStorage.removeItem("logbook-session");
        localStorage.removeItem("logbook-ship");
        // A companion device's pairing (`ShipSelectView.tsx`'s `connectCompanion`)
        // sets this key on connect but nothing ever cleared it again -- a companion
        // that logged out and was later relaunched (`AppView.tsx`'s `/launch`-route
        // effect, the native app's boot path) would silently snap back into the
        // stale companion ship. See `Tests/E2E/companion-disconnect.spec.ts`.
        localStorage.removeItem("logbook-companion");
    },
    resolveLogoutRedirect (isLocalSession) {
        const restoreId = (0, $2b75519151ca9024$export$3f685a6e8b195eac)("logbook-session-restore");
        if (restoreId) {
            localStorage.removeItem("logbook-session-restore");
            localStorage.setItem("logbook-session", restoreId);
            return {
                action: "reload"
            };
        }
        // A revoked token can fail on initial load, before its session type is known.
        if (isLocalSession !== false) {
            const returnUrl = this.localReturnURL((0, $2b75519151ca9024$export$3f685a6e8b195eac)("logbook-session-return"));
            if (returnUrl) // `logbook-companion`/`logbook-ship` were set on the COMPANION
            // device's own origin (`ShipSelectView.tsx`/`OverlayContentView.tsx`'s
            // pairing flow), but this logout is running on the PRIMARY's origin
            // (the companion browser is a thin client of the primary while
            // paired -- see `Tests/E2E/companion-disconnect.spec.ts`), so
            // `clearSession()` above cannot reach those keys: they live in a
            // different origin's localStorage. Tag the cross-origin redirect so
            // the companion's own origin can clear its own stale keys once it
            // lands there (see `AppView.tsx`'s handling of this param) --
            // otherwise a later native relaunch would silently try to re-pair
            // with a connection that was just explicitly disconnected
            // (`logbook-companion`), and the stale `logbook-ship`/`app.shipId`
            // would leave the "current ship" block and `ShipSelectView`'s
            // `alreadyOpened` row both rendering for the same ship (#1098).
            return {
                action: "redirect",
                url: `${returnUrl}?companion_disconnected=1`
            };
        }
        return {
            action: "none"
        };
    },
    // Persists a newly authorized session. Takes the session's OWN type rather than
    // a pre-computed boolean: `App.tsx` used to pass its current `sessionType` React
    // state here, which is `undefined` until the first login resolves, so the very
    // first login after any app start was persisted as non-primary -- removing
    // `logbook-ship`, returning no shipId, and running the socket at the companion's
    // 10s cadence until the session reload repaired it. Deriving it here removes the
    // chance of passing the app's *previous* type by mistake (#1279).
    persistSession (socket, session, type) {
        const isPrimary = type == (0, $a8c48887e141e972$export$9fd99c4c3c179cff).primary;
        localStorage.removeItem("logbook-ship");
        if (session.id) {
            localStorage.setItem("logbook-session", session.id);
            socket.session = session.id;
        } else socket.session = undefined;
        let shipId = undefined;
        if (isPrimary) {
            shipId = session.shipId;
            if (session.shipId) localStorage.setItem("logbook-ship", session.shipId.toString());
        }
        socket.stream(this.streamInterval(isPrimary));
        return {
            shipId: shipId
        };
    },
    persistShipId (shipId, close) {
        if (close) localStorage.removeItem("logbook-ship");
        else localStorage.setItem("logbook-ship", shipId.toString());
    }
};





// Single source of truth for runtime-platform detection in the web app.
//
// The two device axes -- **form factor** and **platform** -- are reported by the
// native shell. Historically they arrived fused together in `appStyles`, a list
// of CSS class tokens, and this module existed to pick the platform back out of
// them. That was always the wrong carrier: "styles" is a fact about Logbook's
// presentation, not about the device, and the tokens were the only encoding of
// two facts nothing else modelled cleanly.
//
// #1376 (tracker #1362) inverts it. The shell reports `formFactor` and `platform` directly
// (app-base's `Device`, @mutle's decision), and the app derives its own style
// tokens from them via `deriveAppStyles`. Sniffing `appStyles` remains as the
// fallback while the shipped shells are unmigrated -- coexistence is by message,
// so both paths stay live and the legacy one stays primary until a shell moves.
//
// Every platform check in the app should go through the `Platform` object rather
// than testing `appStyles.includes(...)` directly, so there is one consistent
// code path for iOS, Android and the desktop shells:
//
//   Platform.isIOS(app)   // boolean
//   Platform.of(app)      // "web" | "ios" | "android" | "windows" | "mac"
//   FormFactor.of(app)    // "desktop" | "tablet" | "mobile" | undefined
function $df835dcae9a50887$export$72d1b0f8f5aa07c4(options) {
    var _a, _b, _c, _d, _e;
    var separator = (_a = options.legacySeparator) !== null && _a !== void 0 ? _a : "-";
    var _f = (_c = (_b = options.legacyToken) === null || _b === void 0 ? void 0 : _b.split(separator, 2)) !== null && _c !== void 0 ? _c : [], legacyPlatform = _f[0], legacyFormFactor = _f[1];
    return {
        platform: (_d = options.platform) !== null && _d !== void 0 ? _d : legacyPlatform,
        formFactor: (_e = options.formFactor) !== null && _e !== void 0 ? _e : legacyFormFactor
    };
}


const $fe1fa5963413bede$var$PLATFORM_NAMES = [
    "ios",
    "android",
    "windows",
    "mac"
];
const $fe1fa5963413bede$var$FORM_FACTOR_NAMES = [
    "desktop",
    "tablet",
    "mobile"
];
function $fe1fa5963413bede$var$of(app) {
    // A shell that reports the axis is the authority on it, so the reported value
    // wins over the tokens. Values outside this vocabulary -- `LogbookDeviceAxes`
    // also reports `linux`, `logbookBox` and `unknown` -- collapse to "web", which
    // is both the plain-browser answer and what token-sniffing already did by
    // falling through.
    const resolved = (0, $df835dcae9a50887$export$72d1b0f8f5aa07c4)({
        platform: app.platform,
        formFactor: app.formFactor
    });
    if (resolved.platform !== undefined) return $fe1fa5963413bede$var$PLATFORM_NAMES.includes(resolved.platform) ? resolved.platform : "web";
    for (const name of $fe1fa5963413bede$var$PLATFORM_NAMES){
        if (app.appStyles.includes(name)) return name;
    }
    return "web";
}
function $fe1fa5963413bede$var$formFactorOf(app) {
    // Unlike `platform`, an unrecognised value is not collapsed to a default --
    // there is no sensible "some other form factor", so an unknown one is reported
    // as "no answer" rather than silently becoming a desktop.
    const resolved = (0, $df835dcae9a50887$export$72d1b0f8f5aa07c4)({
        platform: app.platform,
        formFactor: app.formFactor
    });
    if (resolved.formFactor !== undefined) return $fe1fa5963413bede$var$FORM_FACTOR_NAMES.includes(resolved.formFactor) ? resolved.formFactor : undefined;
    return $fe1fa5963413bede$var$FORM_FACTOR_NAMES.find((name)=>app.appStyles.includes(name));
}
function $fe1fa5963413bede$export$b196bb1915de953c(axes) {
    const formFactor = axes.formFactor;
    const platform = axes.platform;
    if (formFactor === undefined || platform === undefined || platform === "web") return [
        "default"
    ];
    return [
        formFactor,
        platform
    ];
}
const $fe1fa5963413bede$export$2dffd0b5373a4389 = {
    of: $fe1fa5963413bede$var$of,
    isIOS: (app)=>$fe1fa5963413bede$var$of(app) === "ios",
    isAndroid: (app)=>$fe1fa5963413bede$var$of(app) === "android",
    isWindows: (app)=>$fe1fa5963413bede$var$of(app) === "windows",
    isMac: (app)=>$fe1fa5963413bede$var$of(app) === "mac",
    // A native desktop/mobile shell (anything other than a plain browser / cloud
    // session).
    isNativeApp: (app)=>$fe1fa5963413bede$var$of(app) !== "web"
};
const $fe1fa5963413bede$export$12fcff10999ef289 = {
    of: $fe1fa5963413bede$var$formFactorOf,
    isDesktop: (app)=>$fe1fa5963413bede$var$formFactorOf(app) === "desktop",
    isTablet: (app)=>$fe1fa5963413bede$var$formFactorOf(app) === "tablet",
    isMobile: (app)=>$fe1fa5963413bede$var$formFactorOf(app) === "mobile"
};






// @generated by TypeGen from AppBaseWebView/URLNavigation.swift - DO NOT EDIT
var $51c71dc838084316$export$aa07a8181e362940;
(function(IURLNavigationDestination) {
    IURLNavigationDestination["external"] = "external";
    IURLNavigationDestination["overlay"] = "overlay";
})($51c71dc838084316$export$aa07a8181e362940 || ($51c71dc838084316$export$aa07a8181e362940 = {}));



var $eaba38323cd2cc8c$exports = {};
$eaba38323cd2cc8c$exports = import.meta.resolve("7wYh0");


// Shared plumbing for the three App Store entitlement bridges. Returns undefined when
// there is no native bridge (a browser session), so callers can treat the whole feature
// as unavailable rather than showing a failed action.
async function $413160cb4953a8b8$var$postAppStoreMessage(name) {
    const bridge = (0, $c212c8339ff2b280$export$84e93f8ddbebc33c)(name);
    if (bridge) try {
        return await bridge.call(name);
    } catch (err) {
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug(`${name} bridge error`, err);
        return {
            outcome: "none"
        };
    }
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[name]) try {
        const response = await window.webkit.messageHandlers[name].postMessage(name);
        return response;
    } catch (err) {
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug(`${name} bridge error`, err);
        return {
            outcome: "none"
        };
    }
    return undefined;
}
function $413160cb4953a8b8$var$postBridgeMessage(name, payload) {
    const bridge = (0, $c212c8339ff2b280$export$84e93f8ddbebc33c)(name);
    if (!bridge) return false;
    const posted = payload === undefined ? bridge.post(name) : bridge.post(name, payload);
    posted.catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug(`${name} bridge error`, err));
    return true;
}
function $413160cb4953a8b8$var$availableAppleNativeSignInBridge() {
    const bridge = (0, $c212c8339ff2b280$export$541d7d27655bf721)();
    return (bridge === null || bridge === void 0 ? void 0 : bridge.supports((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).nativeSignIn)) && bridge.capability((0, $66f5dcc94b7caf35$export$d6a341c00a57f686).nativeSignIn) === "available" ? bridge : undefined;
}
const $413160cb4953a8b8$var$browserAlarms = {};
const $413160cb4953a8b8$var$browserNativeSignInPath = "/api/session/native-sign-in/browser";
const $413160cb4953a8b8$var$browserNativeSignInMessage = "logbook-native-sign-in";
function $413160cb4953a8b8$var$nativeSignInState() {
    const bytes = crypto.getRandomValues(new Uint8Array(32));
    return Array.from(bytes, (byte)=>byte.toString(16).padStart(2, "0")).join("");
}
async function $413160cb4953a8b8$var$startBrowserNativeSignIn() {
    const popup = window.open("", "logbook-native-sign-in", "popup,width=520,height=720");
    if (!popup) return undefined;
    const state = $413160cb4953a8b8$var$nativeSignInState();
    try {
        const start = await fetch(`${$413160cb4953a8b8$var$browserNativeSignInPath}/start`, {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                state: state,
                origin: window.location.origin
            })
        });
        if (!start.ok) {
            popup.close();
            return undefined;
        }
        const config = await start.json();
        popup.location.href = config.loginUrl;
        return await new Promise((resolve)=>{
            const timeout = window.setTimeout(()=>finish(undefined), 130000);
            const finish = (response)=>{
                window.clearTimeout(timeout);
                window.removeEventListener("message", receive);
                popup.close();
                resolve(response);
            };
            const receive = async (event)=>{
                const message = event.data;
                if (event.source !== popup || event.origin !== config.callbackOrigin || (message === null || message === void 0 ? void 0 : message.type) !== $413160cb4953a8b8$var$browserNativeSignInMessage || message.state !== state || !message.code) return;
                window.removeEventListener("message", receive);
                try {
                    const exchange = await fetch(`${$413160cb4953a8b8$var$browserNativeSignInPath}/exchange`, {
                        method: "POST",
                        headers: {
                            "Accept": "application/json",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            code: message.code,
                            state: state
                        })
                    });
                    finish(exchange.ok ? await exchange.json() : undefined);
                } catch (err) {
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("browser nativeSignIn exchange error", err);
                    finish(undefined);
                }
            };
            window.addEventListener("message", receive);
        });
    } catch (err) {
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("browser nativeSignIn error", err);
        popup.close();
        return undefined;
    }
}
function $413160cb4953a8b8$var$startBrowserAlarm(id) {
    if ($413160cb4953a8b8$var$browserAlarms[id]) return;
    if (typeof Audio === "undefined") return;
    try {
        const audio = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($eaba38323cd2cc8c$exports))));
        audio.loop = true;
        $413160cb4953a8b8$var$browserAlarms[id] = audio;
        audio.play().catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("browser alarm play blocked", err));
    } catch (err) {
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("browser alarm error", err);
    }
}
function $413160cb4953a8b8$var$stopBrowserAlarm(id) {
    const audio = $413160cb4953a8b8$var$browserAlarms[id];
    if (audio) {
        try {
            audio.pause();
            audio.currentTime = 0;
        } catch (/* already stopped */ _a) {}
        delete $413160cb4953a8b8$var$browserAlarms[id];
    }
}
/**
 * Thin wrapper around the native shell bridges (iOS/Mac `webkit`, Windows
 * WebView2 `chrome.webview`, Android `__logbookNotifications`/`__logbookPrint`).
 * Isolated from React so the notification / alarm / restart / app-styles / print
 * handshakes have a single home; each method is a safe no-op (or plain-browser
 * fallback) when no native bridge is present.
 */ function $413160cb4953a8b8$var$printableDocumentHTML() {
    var _a;
    const documentElement = document.documentElement.cloneNode(true);
    let head = documentElement.querySelector("head");
    if (!head) {
        head = document.createElement("head");
        documentElement.prepend(head);
    }
    const base = (_a = head.querySelector("base")) !== null && _a !== void 0 ? _a : document.createElement("base");
    base.setAttribute("href", `${window.location.origin}/`);
    head.prepend(base);
    return documentElement.outerHTML;
}
const $413160cb4953a8b8$export$7bbc682b75e8aad4 = {
    hasAppleManifest () {
        return (0, $c212c8339ff2b280$export$541d7d27655bf721)() !== undefined;
    },
    async openAppleURL (url) {
        const bridge = (0, $c212c8339ff2b280$export$541d7d27655bf721)();
        if (!(bridge === null || bridge === void 0 ? void 0 : bridge.supports((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94)["webView.openURL"])) || bridge.capability((0, $66f5dcc94b7caf35$export$d6a341c00a57f686)["webView.urlNavigation.acknowledged"]) !== "available") throw new Error("Acknowledged native URL opening is unavailable");
        await bridge.call((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94)["webView.openURL"], {
            url: url,
            destination: (0, $51c71dc838084316$export$aa07a8181e362940).overlay
        });
    },
    /**
     * Triggers the platform's print flow for the currently rendered printable content,
     * using the advertised native print bridge, then legacy handlers or browser printing.
     * Native replies arrive when the user finishes the print flow, not when it opens.
     */ print (app) {
        const title = document.title || undefined;
        const legacyFallback = ()=>{
            var _a, _b;
            if (((_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.printAction) && (0, $fe1fa5963413bede$export$2dffd0b5373a4389).isIOS(app)) window.webkit.messageHandlers.printAction.postMessage("");
            else if (window.__logbookPrint) window.__logbookPrint.print();
            else print();
        };
        const apple = (0, $c212c8339ff2b280$export$541d7d27655bf721)();
        if (apple === null || apple === void 0 ? void 0 : apple.supports((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).printAction)) {
            apple.post((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).printAction, {
                content: "",
                title: title
            }, {
                timeoutMilliseconds: null
            }).catch((err)=>{
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("printAction bridge error", err);
            });
            return;
        }
        const payload = {
            // Android prints in a detached WebView. The explicit base keeps the
            // current app and print stylesheets resolvable from the local server.
            content: $413160cb4953a8b8$var$printableDocumentHTML(),
            title: title
        };
        const android = (0, $c212c8339ff2b280$export$87211f39344503e8)();
        if (android === null || android === void 0 ? void 0 : android.supports((0, $66f5dcc94b7caf35$export$3c407b8d2fec6bfe).printAction)) {
            android.post((0, $66f5dcc94b7caf35$export$3c407b8d2fec6bfe).printAction, payload, {
                timeoutMilliseconds: null
            }).catch((err)=>{
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("printAction bridge error", err);
            });
            return;
        }
        const bridge = (0, $c212c8339ff2b280$export$84e93f8ddbebc33c)("printAction");
        if (bridge) {
            bridge.post("printAction", payload, {
                timeoutMilliseconds: null
            }).catch((err)=>{
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("printAction bridge error", err);
            });
            return;
        }
        legacyFallback();
    },
    showNativeNotification (id, title, body) {
        var _a, _b, _c;
        try {
            const apple = (0, $c212c8339ff2b280$export$541d7d27655bf721)();
            if (apple === null || apple === void 0 ? void 0 : apple.supports((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).showNotification)) {
                apple.post((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).showNotification, {
                    id: id,
                    title: title,
                    body: body
                }).catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("showNotification bridge error", err));
                return;
            }
            const android = (0, $c212c8339ff2b280$export$87211f39344503e8)();
            if (android === null || android === void 0 ? void 0 : android.supports((0, $66f5dcc94b7caf35$export$3c407b8d2fec6bfe).showNotification)) {
                android.post((0, $66f5dcc94b7caf35$export$3c407b8d2fec6bfe).showNotification, {
                    id: id,
                    title: title,
                    body: body
                }).catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("showNotification bridge error", err));
                return;
            }
            const windows = (0, $c212c8339ff2b280$export$e33e30708fc6be8)();
            if (windows === null || windows === void 0 ? void 0 : windows.supports((0, $66f5dcc94b7caf35$export$23d136c600f6619).showNotification)) {
                windows.post((0, $66f5dcc94b7caf35$export$23d136c600f6619).showNotification, {
                    id: id,
                    title: title,
                    body: body
                }).catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("showNotification bridge error", err));
                return;
            }
            if ($413160cb4953a8b8$var$postBridgeMessage("showNotification", {
                id: id,
                title: title,
                body: body
            })) return;
            if ((_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.showNotification) window.webkit.messageHandlers.showNotification.postMessage(JSON.stringify({
                id: id,
                title: title,
                body: body
            }));
            else if ((_c = window.chrome) === null || _c === void 0 ? void 0 : _c.webview) window.chrome.webview.postMessage(JSON.stringify({
                type: "showNotification",
                id: id,
                title: title,
                body: body
            }));
            else if (window.__logbookNotifications) window.__logbookNotifications.show(id, title, body);
            else if (typeof Notification !== "undefined" && Notification.permission === "granted") // Plain browser: a best-effort Web Notification.
            new Notification(title, {
                body: body,
                tag: id
            });
        } catch (err) {
            // `String(err)` rather than the error object: Logger's `safeStringify` runs
            // JSON.stringify, and an Error has no enumerable own properties, so it would
            // serialize to "{}" and the message would be lost on the way to native.
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("showNativeNotification error", String(err));
        }
    },
    /**
     * Start the looping audible alarm for alert `id` on whichever native shell is
     * hosting us, falling back to a WebAudio beep in a plain browser. Idempotent.
     */ playAlarm (id) {
        var _a, _b, _c;
        try {
            const apple = (0, $c212c8339ff2b280$export$541d7d27655bf721)();
            if (apple === null || apple === void 0 ? void 0 : apple.supports((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).playAlarm)) {
                apple.post((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).playAlarm, {
                    id: id
                }).catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("playAlarm bridge error", err));
                return;
            }
            const android = (0, $c212c8339ff2b280$export$87211f39344503e8)();
            if (android === null || android === void 0 ? void 0 : android.supports((0, $66f5dcc94b7caf35$export$3c407b8d2fec6bfe).playAlarm)) {
                android.post((0, $66f5dcc94b7caf35$export$3c407b8d2fec6bfe).playAlarm, {
                    id: id
                }).catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("playAlarm bridge error", err));
                return;
            }
            const windows = (0, $c212c8339ff2b280$export$e33e30708fc6be8)();
            if (windows === null || windows === void 0 ? void 0 : windows.supports((0, $66f5dcc94b7caf35$export$23d136c600f6619).playAlarm)) {
                windows.post((0, $66f5dcc94b7caf35$export$23d136c600f6619).playAlarm, {
                    id: id
                }).catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("playAlarm bridge error", err));
                return;
            }
            if ($413160cb4953a8b8$var$postBridgeMessage("playAlarm", {
                id: id
            })) return;
            if ((_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.playAlarm) window.webkit.messageHandlers.playAlarm.postMessage(JSON.stringify({
                id: id
            }));
            else if ((_c = window.chrome) === null || _c === void 0 ? void 0 : _c.webview) window.chrome.webview.postMessage(JSON.stringify({
                type: "playAlarm",
                id: id
            }));
            else if (window.__logbookNotifications) window.__logbookNotifications.playAlarm(id);
            else $413160cb4953a8b8$var$startBrowserAlarm(id);
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("playAlarm error", err);
        }
    },
    /** Stop the audible alarm for alert `id` (ack / snooze / clear / resolve). */ stopAlarm (id) {
        var _a, _b, _c;
        try {
            const apple = (0, $c212c8339ff2b280$export$541d7d27655bf721)();
            if (apple === null || apple === void 0 ? void 0 : apple.supports((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).stopAlarm)) {
                apple.post((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).stopAlarm, {
                    id: id
                }).catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("stopAlarm bridge error", err));
                return;
            }
            const android = (0, $c212c8339ff2b280$export$87211f39344503e8)();
            if (android === null || android === void 0 ? void 0 : android.supports((0, $66f5dcc94b7caf35$export$3c407b8d2fec6bfe).stopAlarm)) {
                android.post((0, $66f5dcc94b7caf35$export$3c407b8d2fec6bfe).stopAlarm, {
                    id: id
                }).catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("stopAlarm bridge error", err));
                return;
            }
            const windows = (0, $c212c8339ff2b280$export$e33e30708fc6be8)();
            if (windows === null || windows === void 0 ? void 0 : windows.supports((0, $66f5dcc94b7caf35$export$23d136c600f6619).stopAlarm)) {
                windows.post((0, $66f5dcc94b7caf35$export$23d136c600f6619).stopAlarm, {
                    id: id
                }).catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("stopAlarm bridge error", err));
                return;
            }
            if ($413160cb4953a8b8$var$postBridgeMessage("stopAlarm", {
                id: id
            })) return;
            if ((_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.stopAlarm) window.webkit.messageHandlers.stopAlarm.postMessage(JSON.stringify({
                id: id
            }));
            else if ((_c = window.chrome) === null || _c === void 0 ? void 0 : _c.webview) window.chrome.webview.postMessage(JSON.stringify({
                type: "stopAlarm",
                id: id
            }));
            else if (window.__logbookNotifications) window.__logbookNotifications.stopAlarm(id);
            else $413160cb4953a8b8$var$stopBrowserAlarm(id);
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("stopAlarm error", err);
        }
    },
    /**
     * Toggle the native background **network keep-alive** for a companion device so a
     * backgrounded / locked crew phone stays resident on the LAN and keeps receiving the
     * alert fan-out (and can sound the alarm). Decoupled from `nativeNMEAGPS`: keep-alive
     * only keeps the app alive; NMEA-GPS additionally publishes the location fixes.
     * Real on iOS; Android is already covered by the always-on foreground service, and
     * Mac/Windows are not suspended the same way, so those shells no-op. Safe no-op in a
     * plain browser or when the hosting shell registers no handler.
     */ setNetworkKeepAlive (active) {
        var _a, _b, _c;
        try {
            const apple = (0, $c212c8339ff2b280$export$541d7d27655bf721)();
            if (apple === null || apple === void 0 ? void 0 : apple.supports((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).setNetworkKeepAlive)) {
                apple.post((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).setNetworkKeepAlive, {
                    active: active
                }).catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("setNetworkKeepAlive bridge error", err));
                return;
            }
            if ($413160cb4953a8b8$var$postBridgeMessage("setNetworkKeepAlive", {
                active: active
            })) return;
            if ((_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.setNetworkKeepAlive) window.webkit.messageHandlers.setNetworkKeepAlive.postMessage(JSON.stringify({
                active: active
            }));
            else if ((_c = window.chrome) === null || _c === void 0 ? void 0 : _c.webview) window.chrome.webview.postMessage(JSON.stringify({
                type: "setNetworkKeepAlive",
                active: active
            }));
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("setNetworkKeepAlive error", err);
        }
    },
    async restartNative () {
        var _a, _b;
        const bridge = (0, $c212c8339ff2b280$export$84e93f8ddbebc33c)("restart");
        if (bridge) try {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("restarting native");
            const response = await bridge.call("restart");
            const restarted = response == true;
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("native restart succeeded", restarted);
            return restarted;
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("bridge restart error", err);
            return false;
        }
        try {
            if ((_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.restart) {
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("restarting native");
                const response = await window.webkit.messageHandlers.restart.postMessage("restart");
                // The outcome, never the response itself: these payloads can carry a session
                // id and an email (see CredentialLogging.test.ts, #1273).
                const restarted = response == true;
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("native restart succeeded", restarted);
                return restarted;
            }
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("webkit restart error", err);
        }
        return false;
    },
    // Resolves the app-style overrides for the current runtime, in priority order:
    //   0. `window.ab`, when the shell exposes the `appStyles` message -- the one
    //      transport, from which the pair is DERIVED from the two device axes
    //      rather than delivered as a list (#1376),
    //   1. the iOS/Mac `webkit` bridge (async reply),
    //   2. the `window.__appStyles` global injected before page scripts by the
    //      Windows shell (WebView2 AddScriptToExecuteOnDocumentCreated),
    //   3. the Android `__logbookAppStyles` JS interface (JSON array string),
    //   4. a legacy `navigator.userAgent` Android sniff as a fallback,
    // returning `undefined` in a plain browser (leave the caller's default in place).
    //
    // Paths 1-4 are untouched and remain the only live ones until a shell exposes
    // the bridge, which is what "coexistence by message" means in practice.
    async loadAppStyles () {
        const apple = (0, $c212c8339ff2b280$export$541d7d27655bf721)();
        if (apple === null || apple === void 0 ? void 0 : apple.supports((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).appStyles)) {
            const { formFactor: formFactor, platform: platform } = apple.values;
            const styles = (0, $fe1fa5963413bede$export$b196bb1915de953c)({
                formFactor: formFactor,
                platform: platform
            });
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("loaded AppStyles from the Apple bridge", styles);
            return styles;
        }
        const android = (0, $c212c8339ff2b280$export$87211f39344503e8)();
        if (android === null || android === void 0 ? void 0 : android.supports((0, $66f5dcc94b7caf35$export$3c407b8d2fec6bfe).appStyles)) {
            const { formFactor: formFactor, platform: platform } = android.values;
            const styles = (0, $fe1fa5963413bede$export$b196bb1915de953c)({
                formFactor: formFactor,
                platform: platform
            });
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("loaded AppStyles from the Android bridge", styles);
            return styles;
        }
        const windows = (0, $c212c8339ff2b280$export$e33e30708fc6be8)();
        if (windows === null || windows === void 0 ? void 0 : windows.supports((0, $66f5dcc94b7caf35$export$23d136c600f6619).appStyles)) {
            const { formFactor: formFactor, platform: platform } = windows.values;
            const styles = (0, $fe1fa5963413bede$export$b196bb1915de953c)({
                formFactor: formFactor,
                platform: platform
            });
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("loaded AppStyles from the Windows bridge", styles);
            return styles;
        }
        const ab = (0, $c212c8339ff2b280$export$84e93f8ddbebc33c)("appStyles");
        if (ab) {
            // Both axes or nothing: half an answer is not an answer, and inventing the
            // missing half is the mistake `appStyles` made in the first place.
            const formFactor = ab.values.formFactor;
            const platform = ab.values.platform;
            if (typeof formFactor === "string" && typeof platform === "string") {
                const styles = (0, $fe1fa5963413bede$export$b196bb1915de953c)({
                    formFactor: formFactor,
                    platform: platform
                });
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("loaded AppStyles from the bridge", styles);
                return styles;
            }
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("bridge exposes appStyles but reported no device axes");
        }
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.appStyles) try {
            const response = await window.webkit.messageHandlers.appStyles.postMessage("appStyles");
            const styles = response;
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("loaded AppStyles", styles);
            return styles;
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("webkit error", err);
            return undefined;
        }
        else if (Array.isArray(window.__appStyles)) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("loaded AppStyles from global", window.__appStyles);
            return window.__appStyles;
        } else if (window.__logbookAppStyles && typeof window.__logbookAppStyles.value === "function") try {
            const styles = JSON.parse(window.__logbookAppStyles.value());
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("loaded AppStyles from native interface", styles);
            return styles;
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("native appStyles interface error", err);
            return undefined;
        }
        else if (navigator.userAgent.toLowerCase().indexOf("android") >= 0) return [
            "android"
        ];
        return undefined;
    },
    // The device's UI language, resolved to one the app has translations for, or
    // `undefined` when the device asks for nothing we can serve.
    //
    // Read synchronously from the generated Apple/Android/Windows manifest
    // value (matching `formFactor`/`platform`) or, for the not-yet-migrated
    // legacy shells, the `window.__logbookDeviceLanguage` global published
    // before page scripts run. Unlike `loadAppStyles`, this must be available
    // at the first paint or the user sees a frame of English.
    //
    // A plain browser or cloud session has no shell, so `navigator.languages`
    // decides. Whatever the source, the value is re-resolved here rather than
    // trusted, so a raw platform tag (`de-CH`) or an unsupported language can
    // never reach the `Localization.Languages` lookup.
    deviceLanguage () {
        var _a;
        const apple = (0, $c212c8339ff2b280$export$541d7d27655bf721)();
        if (apple === null || apple === void 0 ? void 0 : apple.supports((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).deviceLanguage)) return (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).resolve([
            apple.values.deviceLanguage
        ]);
        const android = (0, $c212c8339ff2b280$export$87211f39344503e8)();
        if (android === null || android === void 0 ? void 0 : android.supports((0, $66f5dcc94b7caf35$export$3c407b8d2fec6bfe).deviceLanguage)) return (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).resolve([
            android.values.deviceLanguage
        ]);
        const windows = (0, $c212c8339ff2b280$export$e33e30708fc6be8)();
        if (windows === null || windows === void 0 ? void 0 : windows.supports((0, $66f5dcc94b7caf35$export$23d136c600f6619).deviceLanguage)) return (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).resolve([
            windows.values.deviceLanguage
        ]);
        const native = window.__logbookDeviceLanguage;
        if (typeof native === "string") return (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).resolve([
            native
        ]);
        if (native && typeof native.value === "function") try {
            return (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).resolve([
                native.value()
            ]);
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("native deviceLanguage interface error", err);
            return undefined;
        }
        return (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).resolve(Array.from((_a = navigator.languages) !== null && _a !== void 0 ? _a : []));
    },
    // Fetches the native "skipper" IAP subscription's price for display in the app's own
    // purchase flow (App Store guideline 3.1.2(c) requires the billed amount to be shown
    // in the app, not only in the system StoreKit sheet). The iOS bridge resolves this via
    // StoreKit's `Product.displayPrice`, which is already formatted/localized for the
    // user's App Store storefront -- so no local per-currency price table is needed here.
    //
    // `storefront` (an ISO 3166-1 alpha-3 country code, e.g. "USA"/"DEU") is what actually
    // decides the billing currency, and the bridge reports it even when the price lookup
    // failed -- so the caller can still pick the right fallback currency instead of
    // guessing from the device language, which is wrong for anyone whose App Store region
    // differs from their language.
    //
    // Returns undefined (a safe no-op for the caller, which falls back to its default)
    // when there is no bridge, or the native call fails.
    async loadIAPProductInfo () {
        const bridge = (0, $c212c8339ff2b280$export$84e93f8ddbebc33c)("iapProductInfo");
        if (bridge) try {
            return await bridge.call("iapProductInfo");
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("iapProductInfo bridge error", err);
            return undefined;
        }
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iapProductInfo) try {
            const response = await window.webkit.messageHandlers.iapProductInfo.postMessage("iapProductInfo");
            return response;
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("iapProductInfo bridge error", err);
            return undefined;
        }
        return undefined;
    },
    // Reconcile the entitlements the device already holds with the signed-in account,
    // without touching the App Store (no `AppStore.sync()`, so no sign-in prompt). Used to
    // find out, on opening the subscription page, whether this Apple ID's subscription is
    // already linked to a *different* Logbook account — in which case buying again is
    // impossible (Apple never sells the same auto-renewing product twice to one Apple ID)
    // and the page must explain that instead of offering Subscribe.
    async loadAppStoreEntitlementState () {
        return $413160cb4953a8b8$var$postAppStoreMessage("appStoreEntitlementState");
    },
    // App Store guideline 3.1.1: an explicit, user-initiated restore. Re-fetches the Apple
    // ID's transaction history natively and re-posts every entitlement to the server,
    // reporting what happened so the caller can react (restored, nothing found, or held by
    // another Logbook account).
    async restorePurchases () {
        return $413160cb4953a8b8$var$postAppStoreMessage("restorePurchases");
    },
    // Move a subscription held by another Logbook account to the one signed in now. Only
    // called after the user confirms, since the other account loses access.
    async claimAppStoreSubscription () {
        return $413160cb4953a8b8$var$postAppStoreMessage("claimSubscription");
    },
    performIAP (plan, token) {
        var _a, _b, _c;
        if ($413160cb4953a8b8$var$postBridgeMessage("performIAP", {
            plan: plan,
            token: token
        })) return;
        (_c = (_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.performIAP) === null || _c === void 0 || _c.postMessage(JSON.stringify({
            plan: plan,
            token: token
        }));
    },
    manageSubscriptions () {
        var _a, _b, _c;
        if ($413160cb4953a8b8$var$postBridgeMessage("manageSubscriptions")) return;
        (_c = (_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.manageSubscriptions) === null || _c === void 0 || _c.postMessage("manageSubscriptions");
    },
    async startNativeSignIn () {
        const apple = $413160cb4953a8b8$var$availableAppleNativeSignInBridge();
        if (apple) try {
            // Safari owns this interactive lifetime, not the bridge's RPC deadline.
            return await apple.call((0, $66f5dcc94b7caf35$export$e49c602bb1bbcf94).nativeSignIn, undefined, {
                timeoutMilliseconds: null
            });
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("nativeSignIn bridge error", err);
            return undefined;
        }
        const bridge = (0, $c212c8339ff2b280$export$84e93f8ddbebc33c)("nativeSignIn");
        if (bridge) try {
            return await bridge.call("nativeSignIn", undefined, {
                timeoutMilliseconds: null
            });
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("nativeSignIn bridge error", err);
            return undefined;
        }
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeSignIn) try {
            const response = await window.webkit.messageHandlers.nativeSignIn.postMessage("nativeSignIn");
            return response;
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("nativeSignIn bridge error", err);
            return undefined;
        }
        return $413160cb4953a8b8$var$startBrowserNativeSignIn();
    },
    async nativeSignInAvailable () {
        var _a, _b;
        if ($413160cb4953a8b8$var$availableAppleNativeSignInBridge()) return true;
        if ((0, $c212c8339ff2b280$export$84e93f8ddbebc33c)("nativeSignIn")) return true;
        if ((_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.nativeSignIn) return true;
        try {
            const response = await fetch($413160cb4953a8b8$var$browserNativeSignInPath, {
                method: "GET",
                headers: {
                    "Accept": "application/json"
                }
            });
            if (!response.ok) return false;
            const config = await response.json();
            return config.enabled === true;
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("browser nativeSignIn availability error", err);
            return false;
        }
    },
    hasNativeSignIn () {
        var _a, _b;
        return !!$413160cb4953a8b8$var$availableAppleNativeSignInBridge() || !!(0, $c212c8339ff2b280$export$84e93f8ddbebc33c)("nativeSignIn") || !!((_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.nativeSignIn);
    }
};





function $541a350025917a42$export$9e000f2ff091482(account) {
    if (!account) return false;
    switch(account.subscriptionStatus){
        case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trialExpired:
            return true;
        case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).cancelled:
            return !account.nextBillingAt || Date.parse(account.nextBillingAt).valueOf() <= new Date().valueOf();
        default:
            return false;
    }
}
function $541a350025917a42$export$f79dc7b36c17c0ec(app) {
    if (app.cloudSession()) return (0, $2b75519151ca9024$export$3f685a6e8b195eac)("logbook-inapp") === "true";
    return (0, $fe1fa5963413bede$export$2dffd0b5373a4389).isIOS(app);
}
function $541a350025917a42$export$750abdcba4148280(app) {
    return app.cloudSession() || (0, $fe1fa5963413bede$export$2dffd0b5373a4389).isIOS(app);
}
function $541a350025917a42$export$f56551a957daaf31(path) {
    const hashIndex = path.indexOf("#");
    const hash = hashIndex >= 0 ? path.slice(hashIndex) : "";
    const base = hashIndex >= 0 ? path.slice(0, hashIndex) : path;
    if (/(?:^|[?&])inapp=true(?:&|$)/.test(base)) return path;
    const separator = base.includes("?") ? "&" : "?";
    return `${base}${separator}inapp=true${hash}`;
}


function $f73c59e6f36e52da$export$7e3547f81f4d8512(host, path, inApp) {
    const base = new URL(host);
    if (![
        "http:",
        "https:"
    ].includes(base.protocol) || base.username || base.password) throw new Error("Invalid server host");
    const appPath = `${base.pathname.replace(/\/+$/, "")}/app/`;
    const destination = new URL(path, new URL(appPath, base));
    if (destination.origin !== base.origin || !destination.pathname.startsWith(appPath)) throw new Error("Invalid server app path");
    destination.search = [
        base.search.slice(1),
        destination.search.slice(1)
    ].filter(Boolean).join("&");
    destination.hash || (destination.hash = base.hash);
    return inApp ? (0, $541a350025917a42$export$f56551a957daaf31)(destination.href) : destination.href;
}


async function $424672e608e19fa2$export$7be7ee3ecebdaec9(loadURL) {
    const popup = window.open("", "_blank");
    if (!popup) throw new Error("The browser blocked the cloud window");
    try {
        popup.opener = null;
        const url = await loadURL();
        if (popup.closed) throw new Error("The cloud window was closed before navigation");
        popup.location.href = url;
    } catch (error) {
        popup.close();
        throw error;
    }
}



var $acw62 = parcelRequire("acw62");
function $2c21554be1f22721$var$defaultBrowserHistoryHost() {
    return globalThis;
}
function $2c21554be1f22721$var$normalizeBasePath(basePath) {
    if (basePath === "" || basePath === "/") return "";
    return "/".concat(basePath.replace(/^\/+|\/+$/g, ""));
}
function $2c21554be1f22721$var$normalizePath(path) {
    return path.replace(/^\/+|\/+$/g, "");
}
function $2c21554be1f22721$var$routeFromPathname(pathname, basePath) {
    if (basePath === "") return $2c21554be1f22721$var$normalizePath(pathname);
    if (pathname === basePath || pathname === "".concat(basePath, "/")) return "";
    var prefix = "".concat(basePath, "/");
    return pathname.startsWith(prefix) ? $2c21554be1f22721$var$normalizePath(pathname.slice(prefix.length)) : "";
}
function $2c21554be1f22721$var$urlForRoute(path, basePath) {
    var normalized = $2c21554be1f22721$var$normalizePath(path);
    if (basePath === "") return normalized === "" ? "/" : "/".concat(normalized);
    return normalized === "" ? "".concat(basePath, "/") : "".concat(basePath, "/").concat(normalized);
}
function $2c21554be1f22721$export$719fc203c4e16dee(options) {
    var _a, _b;
    if (options === void 0) options = {};
    var host = (_a = options.host) !== null && _a !== void 0 ? _a : $2c21554be1f22721$var$defaultBrowserHistoryHost();
    var basePath = $2c21554be1f22721$var$normalizeBasePath((_b = options.basePath) !== null && _b !== void 0 ? _b : "");
    var listeners = new Set();
    var notify = function() {
        var path = $2c21554be1f22721$var$routeFromPathname(host.location.pathname, basePath);
        for(var _i = 0, _a = Array.from(listeners); _i < _a.length; _i++){
            var listener = _a[_i];
            listener(path);
        }
    };
    return {
        read: function() {
            return $2c21554be1f22721$var$routeFromPathname(host.location.pathname, basePath);
        },
        navigate: function(path, navigateOptions) {
            var _a, _b, _c, _d;
            if (navigateOptions === void 0) navigateOptions = {};
            var normalizedPath = $2c21554be1f22721$var$normalizePath(path);
            var url = $2c21554be1f22721$var$urlForRoute(normalizedPath, basePath);
            var replace = (_a = navigateOptions.replace) !== null && _a !== void 0 ? _a : false;
            if (replace) host.history.replaceState((_b = navigateOptions.state) !== null && _b !== void 0 ? _b : {}, "", url);
            else host.history.pushState((_c = navigateOptions.state) !== null && _c !== void 0 ? _c : {}, "", url);
            (_d = options.onNavigate) === null || _d === void 0 || _d.call(options, {
                path: normalizedPath,
                url: url,
                replace: replace
            });
            notify();
            return url;
        },
        subscribe: function(listener) {
            if (listeners.size === 0) host.addEventListener("popstate", notify);
            listeners.add(listener);
            return function() {
                listeners.delete(listener);
                if (listeners.size === 0) host.removeEventListener("popstate", notify);
            };
        }
    };
}


var $37879d0e39841979$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $37879d0e39841979$export$7c42f1177a9c311;
(function(RouteParamType) {
    RouteParamType["number"] = "number";
    RouteParamType["route"] = "route";
    RouteParamType["string"] = "string";
})($37879d0e39841979$export$7c42f1177a9c311 || ($37879d0e39841979$export$7c42f1177a9c311 = {}));
var $37879d0e39841979$export$d0835527648063e7 = /** @class */ function() {
    function RouteParams(values) {
        this.values = values;
    }
    RouteParams.prototype.requireInt = function(key) {
        var value = this.values[key];
        if (typeof value !== "number") throw new Error("Required route param ".concat(key, " is not a number: ").concat(value));
        return value;
    };
    RouteParams.prototype.requireString = function(key) {
        var value = this.values[key];
        if (typeof value !== "string") throw new Error("Required route param ".concat(key, " is not a string: ").concat(value));
        return value;
    };
    RouteParams.prototype.requireRoute = function(key) {
        var value = this.values[key];
        if (!Array.isArray(value)) throw new Error("Required route param ".concat(key, " is not a route: ").concat(value));
        return value;
    };
    return RouteParams;
}();
function $37879d0e39841979$var$routeSegments(route) {
    if (typeof route !== "string") return route;
    var normalized = route.replace(/^\/+|\/+$/g, "");
    return normalized === "" ? [] : normalized.split("/");
}
function $37879d0e39841979$var$parsedParam(value, type, remaining) {
    switch(type){
        case $37879d0e39841979$export$7c42f1177a9c311.number:
            if (!/^-?\d+$/.test(value)) return undefined;
            var number = Number(value);
            return Number.isSafeInteger(number) ? number : undefined;
        case $37879d0e39841979$export$7c42f1177a9c311.route:
            return remaining;
        case $37879d0e39841979$export$7c42f1177a9c311.string:
        case undefined:
            return value;
    }
}
function $37879d0e39841979$export$b4ee0d6794375c82(route, definition) {
    var _a;
    var segments = $37879d0e39841979$var$routeSegments(route);
    var result = {};
    if (definition.path.length === 0) return segments.length === 0 ? result : undefined;
    for(var index = 0; index < definition.path.length; index += 1){
        var expected = definition.path[index];
        var actual = segments[index];
        if (expected.startsWith("*")) {
            result[expected.slice(1)] = actual === undefined ? [
                ""
            ] : segments.slice(index);
            return result;
        }
        if (expected.startsWith(":")) {
            if (actual === undefined) return undefined;
            var name = expected.slice(1);
            var type = (_a = definition.params) === null || _a === void 0 ? void 0 : _a[name];
            var value = $37879d0e39841979$var$parsedParam(actual, type, segments.slice(index));
            if (value === undefined) return undefined;
            result[name] = value;
            if (type === $37879d0e39841979$export$7c42f1177a9c311.route) return result;
            continue;
        }
        if (expected !== actual) return undefined;
    }
    return segments.length === definition.path.length ? result : undefined;
}
function $37879d0e39841979$export$b7654b4155f1192a(route, definitions, handlers) {
    for(var _i = 0, _a = Object.keys(definitions); _i < _a.length; _i++){
        var name = _a[_i];
        var params = $37879d0e39841979$export$b4ee0d6794375c82(route, definitions[name]);
        var handler = handlers[name];
        if (params === undefined || handler === undefined) continue;
        var result = handler(new $37879d0e39841979$export$d0835527648063e7(params));
        if (result !== undefined) return {
            name: name,
            params: params,
            result: result
        };
    }
    throw new Error("No route matched: ".concat($37879d0e39841979$var$routeSegments(route).join("/")));
}
function $37879d0e39841979$export$da93289c03d00750(segment, params) {
    var _a;
    if (params === void 0) params = {};
    if (segment.startsWith(":")) {
        var name = segment.slice(1);
        var value = params[name];
        if (value === undefined) throw new Error("Missing route param ".concat(name));
        return Array.isArray(value) ? value.join("/") : String(value);
    }
    if (segment.startsWith("*")) {
        var value = (_a = params[segment.slice(1)]) !== null && _a !== void 0 ? _a : "";
        return Array.isArray(value) ? value.join("/") : String(value);
    }
    return segment;
}
function $37879d0e39841979$export$806c7760c5cd29b3(definitions, updateRoute, options) {
    if (options === void 0) options = {};
    return function(name, params, replace) {
        var _a;
        var definition = definitions[name];
        if (definition === undefined) return false;
        var segments = $37879d0e39841979$var$__spreadArray($37879d0e39841979$var$__spreadArray([], options.prefix ? [
            options.prefix
        ] : [], true), ((_a = definition.navigate) !== null && _a !== void 0 ? _a : definition.path).map(function(segment) {
            return $37879d0e39841979$export$da93289c03d00750(segment, params);
        }), true);
        updateRoute(segments.filter(function(segment) {
            return segment !== "";
        }).join("/"), replace);
        return true;
    };
}



const $2472f3c19d716da0$var$appHistory = (0, $2c21554be1f22721$export$719fc203c4e16dee)({
    basePath: "/app",
    onNavigate: ({ url: url })=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("navigate", url)
});
function $2472f3c19d716da0$export$d279116694714bd1(listener) {
    return $2472f3c19d716da0$var$appHistory.subscribe((path)=>listener(path ? `/app/${path}` : "/app/"));
}
function $2472f3c19d716da0$export$6462bdfc589180f8(customRoot) {
    const root = customRoot !== null && customRoot !== void 0 ? customRoot : $2472f3c19d716da0$var$appHistory.read();
    return {
        route: root.length === 0 ? [] : root.split("/")
    };
}
function $2472f3c19d716da0$export$8384939689d442cc(path, replace) {
    return $2472f3c19d716da0$var$appHistory.navigate(path, {
        replace: replace
    });
}
class $2472f3c19d716da0$export$2f0830dcc7971fd0 {
    constructor(params){
        this.params = params;
    }
    requireInt(key) {
        return new (0, $37879d0e39841979$export$d0835527648063e7)(this.params).requireInt(key);
    }
    requireString(key) {
        return new (0, $37879d0e39841979$export$d0835527648063e7)(this.params).requireString(key);
    }
    requireRoute(key) {
        return [
            ...new (0, $37879d0e39841979$export$d0835527648063e7)(this.params).requireRoute(key)
        ];
    }
}
class $2472f3c19d716da0$export$55185c17a0fcbe46 {
    constructor(route, definitions, routes){
        this.definitions = definitions;
        this.route = route;
        this.routeParams = {};
        routes(this);
        if (this.result == undefined) throw new Error(`No route matched: ${this.route.route.join("/")}, default route handler is missing.`);
    }
    on(name, handler) {
        const definition = this.definitions[name];
        if (this.result != undefined || definition == undefined) return;
        const params = (0, $37879d0e39841979$export$b4ee0d6794375c82)(this.route.route, definition);
        if (params) {
            const mutableParams = Object.fromEntries(Object.entries(params).map(([key, value])=>[
                    key,
                    Array.isArray(value) ? [
                        ...value
                    ] : value
                ]));
            this.result = handler(new $2472f3c19d716da0$export$2f0830dcc7971fd0(mutableParams));
            this.routeName = name;
            this.routeParams = mutableParams;
        }
    }
    match(definition) {
        const params = (0, $37879d0e39841979$export$b4ee0d6794375c82)(this.route.route, definition);
        return params ? Object.fromEntries(Object.entries(params).map(([key, value])=>[
                key,
                Array.isArray(value) ? [
                    ...value
                ] : value
            ])) : undefined;
    }
    matchSegment(definition, n) {
        return (0, $37879d0e39841979$export$b4ee0d6794375c82)(this.route.route.slice(n), Object.assign(Object.assign({}, definition), {
            path: definition.path.slice(n)
        }));
    }
    static navigate(definitions, updateRoute, prefix, _replace) {
        const navigate = (0, $37879d0e39841979$export$806c7760c5cd29b3)(definitions, updateRoute, {
            prefix: prefix
        });
        return (name, params, replace)=>navigate(name, params, replace);
    }
    static pathSegment(segment, params) {
        return (0, $37879d0e39841979$export$da93289c03d00750)(segment, params);
    }
}
function $2472f3c19d716da0$export$9a302a45f65d0572(route, definitions, routes) {
    return (0, $acw62.useMemo)(()=>{
        const router = new $2472f3c19d716da0$export$55185c17a0fcbe46(route, definitions, routes);
        if (router.result == undefined || router.routeName == undefined) throw new Error(`No route matched: ${route.route.join("/")}, default route handler is missing.`);
        return [
            router.result,
            router.routeName,
            router.routeParams
        ];
    }, [
        route,
        definitions,
        routes
    ]);
}



var $0a17c1987d52b4df$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $0a17c1987d52b4df$export$37dcbeab8ae08bef(value) {
    if (!value) return [];
    return Array.from(new Set(value.split(/[\s,]+/).map(function(feature) {
        return feature.trim();
    }).filter(Boolean)));
}
function $0a17c1987d52b4df$var$readStorageFeatures(options) {
    if (!options.storage || !options.storageKey) return [];
    try {
        return $0a17c1987d52b4df$export$37dcbeab8ae08bef(options.storage.getItem(options.storageKey));
    } catch (_a) {
        return [];
    }
}
function $0a17c1987d52b4df$var$readQueryFeatures(options) {
    if (!options.query || !options.queryKey) return [];
    var params = typeof options.query === "string" ? new URLSearchParams(options.query.startsWith("?") ? options.query.slice(1) : options.query) : options.query;
    return params.getAll(options.queryKey).flatMap($0a17c1987d52b4df$export$37dcbeab8ae08bef);
}
function $0a17c1987d52b4df$export$748123bcbd9079d5(options) {
    var _a, _b, _c;
    var known = new Set(options.known);
    var enabled = new Set(options.wildcard ? options.known : []);
    for(var _i = 0, _d = $0a17c1987d52b4df$var$__spreadArray($0a17c1987d52b4df$var$__spreadArray($0a17c1987d52b4df$var$__spreadArray($0a17c1987d52b4df$var$__spreadArray([], (_a = options.explicit) !== null && _a !== void 0 ? _a : [], true), (_b = options.alwaysOn) !== null && _b !== void 0 ? _b : [], true), $0a17c1987d52b4df$var$readStorageFeatures(options), true), $0a17c1987d52b4df$var$readQueryFeatures(options), true); _i < _d.length; _i++){
        var feature = _d[_i];
        if (known.has(feature)) enabled.add(feature);
    }
    for(var _e = 0, _f = (_c = options.excluded) !== null && _c !== void 0 ? _c : []; _e < _f.length; _e++){
        var feature = _f[_e];
        enabled.delete(feature);
    }
    return enabled;
}


// General, product-agnostic client-side feature flags. Every flag defaults to
// OFF -- there is no built-in list of "known" flags here, any caller can pass
// an arbitrary flag name -- so new code can ship dark behind a flag without a
// server change. A flag turns on via either a developer-only override (the
// `logbook-features` localStorage key or a `?features=` query param, both
// accepting a comma/whitespace separated list of flag names) or the
// `ALWAYS_ON_FEATURES` code-level list below, which ships to everyone. This is
// wired into `App.hasFeature` (see App.tsx), which ORs it with the
// server-driven `features` array.
//
// Separately, `resolveFeature` also honors `SERVER_WILDCARD_FEATURE`: a
// server-driven wildcard the dev/CI/simulator `App` shell (`bin/ab run App`)
// sends when its `ALL_FEATURES` env var is set, or a real native shell sends
// when its own opt-in env var is set (`LOGBOOK_ALL_FEATURES` on iOS/Mac, e.g.
// via `Config/MacDebug.xcconfig` for a development build -- see
// `LogbookNativeAppFeature.allFeatures` in Sources/LogbookApp/NativeApp.swift).
// When present in the server `features` array, it turns every flag on except
// those listed in `WILDCARD_EXCLUDED_FEATURES` below.
//
// The dev `App` shell can also inject one or more SPECIFIC flags BY NAME into
// the server `features` array via its `FEATURES=` env var (comma/whitespace
// separated), e.g. `FEATURES=experimental-view bin/ab run App` -- see
// `LogbookNativeApp.extraFeatures` / `LogbookApp.sessionFeatures`. A by-name
// server feature is honored by `resolveFeature` directly (the last clause
// below), so -- unlike the wildcard -- it CAN turn on a
// `WILDCARD_EXCLUDED_FEATURES` flag by name. This is the CLI/server-side way to
// exercise an in-progress excluded flag in a running app.
const $e32f189306d11372$var$STORAGE_KEY = "logbook-features";
const $e32f189306d11372$var$QUERY_PARAM = "features";
const $e32f189306d11372$export$c0824dba04582e50 = "all-features";
const $e32f189306d11372$export$15991836bcae6082 = [];
const $e32f189306d11372$export$cbe3bf3fd9bb6962 = [];
function $e32f189306d11372$var$splitFeatureOverrides(features) {
    const enabled = [];
    const disabled = [];
    for (const feature of features)if (feature.startsWith("-") && feature.length > 1) disabled.push(feature.slice(1));
    else enabled.push(feature);
    return {
        enabled: enabled,
        disabled: disabled
    };
}
function $e32f189306d11372$var$clientFeatureOverrides() {
    const features = [
        ...(0, $0a17c1987d52b4df$export$37dcbeab8ae08bef)((0, $2b75519151ca9024$export$3f685a6e8b195eac)($e32f189306d11372$var$STORAGE_KEY)),
        ...typeof window !== "undefined" && window.location ? new URLSearchParams(window.location.search).getAll($e32f189306d11372$var$QUERY_PARAM).flatMap((0, $0a17c1987d52b4df$export$37dcbeab8ae08bef)) : []
    ];
    return $e32f189306d11372$var$splitFeatureOverrides(features);
}
// Recomputed on every call rather than cached, since the localStorage/query
// overrides are only ever read by developers and may change within a session
// (e.g. a developer toggling `logbook-features` in devtools).
function $e32f189306d11372$var$clientFeatures() {
    const overrides = $e32f189306d11372$var$clientFeatureOverrides();
    return (0, $0a17c1987d52b4df$export$748123bcbd9079d5)({
        known: [
            ...$e32f189306d11372$export$15991836bcae6082,
            ...overrides.enabled,
            ...overrides.disabled
        ],
        explicit: overrides.enabled,
        alwaysOn: $e32f189306d11372$export$15991836bcae6082,
        excluded: overrides.disabled
    });
}
function $e32f189306d11372$export$d742a1ac3d1b029d(feature) {
    return $e32f189306d11372$var$clientFeatures().has(feature);
}
function $e32f189306d11372$export$10af58e6fc210ef8(serverFeatures, feature) {
    const server = $e32f189306d11372$var$splitFeatureOverrides(serverFeatures !== null && serverFeatures !== void 0 ? serverFeatures : []);
    const client = $e32f189306d11372$var$clientFeatureOverrides();
    const disabled = [
        ...server.disabled,
        ...client.disabled
    ];
    const explicit = (0, $0a17c1987d52b4df$export$748123bcbd9079d5)({
        known: [
            feature
        ],
        explicit: [
            ...server.enabled,
            ...client.enabled
        ],
        alwaysOn: $e32f189306d11372$export$15991836bcae6082,
        excluded: disabled
    }).has(feature);
    if (explicit) return true;
    return !disabled.includes(feature) && server.enabled.includes($e32f189306d11372$export$c0824dba04582e50) && !$e32f189306d11372$export$cbe3bf3fd9bb6962.includes(feature);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $8c1387b8259a816a$var$__assign = undefined && undefined.__assign || function() {
    $8c1387b8259a816a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8c1387b8259a816a$var$__assign.apply(this, arguments);
};
var $8c1387b8259a816a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8c1387b8259a816a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $8c1387b8259a816a$export$511b18851e72b74a(subscribe, callback, dependencies) {
    if (dependencies === void 0) dependencies = [];
    var latestCallback = (0, $acw62.useRef)(callback);
    (0, $acw62.useLayoutEffect)(function() {
        latestCallback.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(function() {
        var unsubscribe = subscribe(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return latestCallback.current.apply(latestCallback, args);
        });
        return typeof unsubscribe === "function" ? unsubscribe : undefined;
    }, dependencies);
}
function $8c1387b8259a816a$export$b772e9ad161cd3e0(options) {
    var _a;
    var multiplier = (_a = options.multiplier) !== null && _a !== void 0 ? _a : 2;
    return function(attempt) {
        return Math.min(options.initialMilliseconds * Math.pow(multiplier, attempt), options.maximumMilliseconds);
    };
}
function $8c1387b8259a816a$var$defaultScheduler(callback, delayMilliseconds) {
    var timer = globalThis.setTimeout(callback, delayMilliseconds);
    return function() {
        return globalThis.clearTimeout(timer);
    };
}
function $8c1387b8259a816a$export$76a5b983303c2f5e(options) {
    var _this = this;
    var _a, _b;
    var latestOptions = (0, $acw62.useRef)(options);
    latestOptions.current = options;
    var _c = (0, $acw62.useState)({
        attempt: 0,
        loading: (_a = options.enabled) !== null && _a !== void 0 ? _a : true
    }), state = _c[0], setState = _c[1];
    (0, $acw62.useEffect)(function() {
        if (latestOptions.current.enabled === false) {
            setState(function(previous) {
                return $8c1387b8259a816a$var$__assign($8c1387b8259a816a$var$__assign({}, previous), {
                    loading: false
                });
            });
            return;
        }
        var controller = new AbortController();
        var cancelled = false;
        var settled = false;
        var cancelScheduled;
        var activeAttempt = 0;
        var run = function(attempt) {
            return $8c1387b8259a816a$var$__awaiter(_this, void 0, Promise, function() {
                var context, value, error_1, classification, delay, schedule;
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                return $8c1387b8259a816a$var$__generator(this, function(_l) {
                    switch(_l.label){
                        case 0:
                            activeAttempt = attempt;
                            context = {
                                attempt: attempt,
                                signal: controller.signal
                            };
                            setState(function(previous) {
                                return {
                                    attempt: attempt,
                                    loading: true,
                                    value: previous.value,
                                    error: undefined
                                };
                            });
                            _l.label = 1;
                        case 1:
                            _l.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                latestOptions.current.load(context)
                            ];
                        case 2:
                            value = _l.sent();
                            if (cancelled) return [
                                2 /*return*/ 
                            ];
                            (_b = (_a = latestOptions.current).onSuccess) === null || _b === void 0 || _b.call(_a, value, context);
                            settled = true;
                            setState({
                                attempt: attempt,
                                loading: false,
                                value: value,
                                error: undefined
                            });
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            error_1 = _l.sent();
                            if (cancelled) return [
                                2 /*return*/ 
                            ];
                            classification = latestOptions.current.classify(error_1, context);
                            if (classification === "cancel") {
                                cancelled = true;
                                settled = true;
                                controller.abort();
                                (_d = (_c = latestOptions.current).onCancellation) === null || _d === void 0 || _d.call(_c, context);
                                setState({
                                    attempt: attempt,
                                    loading: false,
                                    error: error_1
                                });
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            if (classification === "fail") {
                                settled = true;
                                (_f = (_e = latestOptions.current).onFailure) === null || _f === void 0 || _f.call(_e, error_1, context);
                                setState({
                                    attempt: attempt,
                                    loading: false,
                                    error: error_1
                                });
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            delay = (_j = (_h = (_g = latestOptions.current).backoff) === null || _h === void 0 ? void 0 : _h.call(_g, attempt, error_1)) !== null && _j !== void 0 ? _j : 0;
                            schedule = (_k = latestOptions.current.schedule) !== null && _k !== void 0 ? _k : $8c1387b8259a816a$var$defaultScheduler;
                            cancelScheduled = schedule(function() {
                                cancelScheduled = undefined;
                                run(attempt + 1);
                            }, delay);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        run(0);
        return function() {
            var _a, _b;
            if (cancelled || settled) return;
            cancelled = true;
            cancelScheduled === null || cancelScheduled === void 0 || cancelScheduled();
            controller.abort();
            (_b = (_a = latestOptions.current).onCancellation) === null || _b === void 0 || _b.call(_a, {
                attempt: activeAttempt,
                signal: controller.signal
            });
        };
    }, (_b = options.dependencies) !== null && _b !== void 0 ? _b : []);
    return state;
}



// Coalescing for socket-driven React updates (#1813).
//
// React 19 throws error #185 ("Maximum update depth exceeded") from *any*
// `setState` once 50 consecutive commits have each landed while another update
// was already queued. `commitRootImpl` keeps that counter:
//
//   0 !== (committedLanes & 4194218) && 0 !== (root.pendingLanes & 42)
//     ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, …)
//     : (nestedUpdateCount = 0);
//
// It resets on the first commit that lands with an empty queue — so the counter
// only accumulates while updates keep arriving *during* React's own render and
// commit window. A live websocket feed does exactly that: after the display has
// slept (or the window has been backgrounded), the browser delivers the buffered
// backlog as one dense burst, each message calling `setState` straight from
// `onmessage`. Fifty-one such commits in a row and the *next* update from
// anywhere throws — which is why the reported stack in #1813 is an innocent
// `AppStatus` handler rather than whatever was actually looping.
//
// React 18 did not have this failure mode: its equivalent check was
// `remainingLanes === SyncLane`, ignoring the default lane that ordinary async
// socket updates use. React 19 broadened the mask to `42`
// (Sync | InputContinuous | Default), so normal live-data churn now counts.
//
// The fix is to stop dispatching one React update per message. A coalescer
// buffers the burst and flushes once from a plain macrotask, which has two
// effects: N messages become one commit, and that commit is scheduled from an
// idle task rather than from inside React's render window, so it lands with an
// empty queue and *resets* the counter instead of advancing it.
function $45a151b8ba325293$export$4b6d2f412bf6117(run) {
    let handle;
    const fire = ()=>{
        handle = undefined;
        run();
    };
    return {
        schedule () {
            if (handle !== undefined) return;
            handle = setTimeout(fire, 0);
        },
        cancel () {
            if (handle === undefined) return;
            clearTimeout(handle);
            handle = undefined;
        },
        flush () {
            if (handle === undefined) return;
            clearTimeout(handle);
            fire();
        }
    };
}
function $45a151b8ba325293$export$d321c1cb8221632(a, b) {
    if (a === b) return true;
    if (a === undefined || b === undefined || a === null || b === null) return false;
    try {
        return JSON.stringify(a) === JSON.stringify(b);
    } catch (_a) {
        return false;
    }
}






var $acw62 = parcelRequire("acw62");




function $2114181ec2376095$export$fc66bbfc16f14a1e(app) {
    const { socket: socket, apiClient: apiClient, session: session, sessionType: sessionType } = app;
    const logout = (0, $acw62.useRef)(app.logout);
    logout.current = app.logout;
    (0, $acw62.useEffect)(()=>{
        if (sessionType !== (0, $a8c48887e141e972$export$9fd99c4c3c179cff).local || !(session === null || session === void 0 ? void 0 : session.authorized)) return;
        let disposed = false;
        let ended = false;
        let checking = false;
        const end = ()=>{
            if (disposed || ended) return;
            ended = true;
            socket.endSession();
            logout.current(false).catch((error)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Companion logout failed", error));
        };
        const check = async (connected)=>{
            if (connected || checking || ended || !socket.session) return;
            checking = true;
            const token = socket.session;
            try {
                const response = await (0, $5ba8962d09b05c4a$export$b531eccea6f91101).loadSession(apiClient);
                if (!disposed && token === socket.session && !response.session.authorized) end();
            } catch (error) {
                if (!disposed && token === socket.session) {
                    if ((0, $b57fb2219af67c07$export$1fb4852a55678982).classifySessionLoadFailure(error) === "logout") end();
                    else (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("Companion session check failed", error);
                }
            } finally{
                checking = false;
            }
        };
        const control = socket.subscribe("CompanionDisconnected", end);
        // A sleeping companion can miss the control message; authenticate again after
        // each failed socket attempt, without treating a network outage as revocation.
        const connection = socket.subscribeSocket((connected)=>{
            check(connected);
        });
        if (!socket.session) end();
        else if (socket.disconnected) check(false);
        return ()=>{
            disposed = true;
            socket.unsubscribe("CompanionDisconnected", control);
            socket.unsubscribeSocket(connection);
        };
    }, [
        socket,
        apiClient,
        session === null || session === void 0 ? void 0 : session.authorized,
        session === null || session === void 0 ? void 0 : session.id,
        sessionType
    ]);
}







// The language the app opens in, resolved once at mount. Precedence, highest
// first:
//
//   1. `logbook-language` in localStorage — whatever is stored wins,
//   2. the device language reported by the native shell (or `navigator` in a
//      browser / cloud session),
//   3. "en".
//
// A detected language is written to localStorage straight away, which is what
// makes it stick: @mutle decided the device language is locked in at first
// launch rather than re-read on every launch, so after the first run the stored
// value is the only source and a later device-language change does not move the
// app. Clearing localStorage deliberately re-syncs from the device.
//
// This runs in the `useState` initialiser rather than an effect on purpose —
// resolving after mount would repaint the whole UI, flashing English first.
// `Native.deviceLanguage` reads a global the shells inject before any page
// script runs, so it is available this early.
//
// Note that a *stored* value is used as-is, including "en": a user who picked
// English on a German device must not be pushed back to German.
function $534676d4dce85d2d$var$launchLanguage() {
    const stored = (0, $2b75519151ca9024$export$3f685a6e8b195eac)("logbook-language");
    if (stored) {
        document.documentElement.setAttribute("lang", stored);
        return stored;
    }
    const device = (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).deviceLanguage();
    if (device) {
        localStorage.setItem("logbook-language", device);
        document.documentElement.setAttribute("lang", device);
        return device;
    }
    // Nothing was decided — don't persist the fallback, so a device that is later
    // switched to a language we serve still gets to be detected.
    document.documentElement.setAttribute("lang", (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).Fallback);
    return (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).Fallback;
}
function $534676d4dce85d2d$export$9973955de2bf96cf() {
    const [lang, setLang] = (0, $acw62.useState)($534676d4dce85d2d$var$launchLanguage());
    const [accountSessionResponse, setAccountSessionResponse] = (0, $acw62.useState)(undefined);
    const [appStyles, setAppStyles] = (0, $acw62.useState)([
        "default"
    ]);
    const [current, setCurrent] = (0, $acw62.useState)(undefined);
    const [features, setFeatures] = (0, $acw62.useState)(undefined);
    const [location, setLocation] = (0, $acw62.useState)(window.location.pathname);
    const [n, setN] = (0, $acw62.useState)(0);
    const [session, setSession] = (0, $acw62.useState)(undefined);
    const [sessionType, setSessionType] = (0, $acw62.useState)(undefined);
    const urlParams = new URLSearchParams(window.location.search);
    const forceAccountView = urlParams.get("account") === "true";
    const [shipId, setShipId] = (0, $acw62.useState)(forceAccountView ? undefined : (0, $2b75519151ca9024$export$8bf6241f4c41c4e0)("logbook-ship"));
    const [status, setStatus] = (0, $acw62.useState)(undefined);
    const [socket, _setSocket] = (0, $acw62.useState)(new (0, $62b5d19f2b3ee711$export$1f2bb630327ac4b6)());
    const [theme, setTheme] = (0, $acw62.useState)((0, $2b75519151ca9024$export$3f685a6e8b195eac)("logbook-theme"));
    const [user, setUser] = (0, $acw62.useState)(undefined);
    return {
        lang: lang,
        setLang: setLang,
        accountSessionResponse: accountSessionResponse,
        setAccountSessionResponse: setAccountSessionResponse,
        appStyles: appStyles,
        setAppStyles: setAppStyles,
        current: current,
        setCurrent: setCurrent,
        features: features,
        setFeatures: setFeatures,
        location: location,
        setLocation: setLocation,
        n: n,
        setN: setN,
        session: session,
        setSession: setSession,
        sessionType: sessionType,
        setSessionType: setSessionType,
        shipId: shipId,
        setShipId: setShipId,
        status: status,
        setStatus: setStatus,
        socket: socket,
        theme: theme,
        setTheme: setTheme,
        user: user,
        setUser: setUser
    };
}
function $534676d4dce85d2d$export$d44906bd7696f00d(app, state) {
    (0, $2114181ec2376095$export$fc66bbfc16f14a1e)(app);
    const { lang: lang, n: n, session: session, sessionType: sessionType, shipId: shipId, status: status, socket: socket, setSession: setSession, setSessionType: setSessionType, setShipId: setShipId, setAccountSessionResponse: setAccountSessionResponse, setUser: setUser, setFeatures: setFeatures, setTheme: setTheme, setStatus: setStatus, setN: setN, setAppStyles: setAppStyles, setLocation: setLocation, setLang: setLang } = state;
    const updateStatus = (0, $acw62.useCallback)(async ()=>{
        if (!session || !session.authorized) return;
        if (app.cloudSession() || status && status.server) return;
        const newStatus = await app.updateStatus();
        if (newStatus) {
            newStatus.date = new Date().getTime();
            setStatus(newStatus);
            app.status = newStatus;
        }
    }, [
        session,
        status
    ]);
    // `AppStatus` and `Day` broadcasts are the app's two highest-frequency socket
    // updates, and both used to dispatch a React update straight from `onmessage`.
    // A backlog burst — what the browser delivers when the display wakes or the tab
    // comes back to the foreground — therefore became a long run of commits that
    // each landed with the next message already queued, which is precisely what
    // drives React 19's nested-update counter to the #185 throw (see `Coalesce.ts`
    // for the mechanism and #1813 for the report). Buffering the burst and flushing
    // once from a macrotask collapses it into a single commit that lands with an
    // empty queue, resetting the counter rather than advancing it.
    const pendingStatus = (0, $acw62.useRef)(undefined);
    const statusCoalescer = (0, $acw62.useMemo)(()=>(0, $45a151b8ba325293$export$4b6d2f412bf6117)(()=>{
            const next = pendingStatus.current;
            pendingStatus.current = undefined;
            if (next == undefined) return;
            setStatus(next);
        }), [
        setStatus
    ]);
    (0, $acw62.useEffect)(()=>()=>statusCoalescer.cancel(), [
        statusCoalescer
    ]);
    const statusSubscription = (0, $acw62.useCallback)((status, _type)=>{
        // `app.status` is read directly (outside React) by callers that must see the
        // newest value immediately, so it is still assigned synchronously.
        const previous = app.status;
        app.status = status;
        // A moored boat re-broadcasts an unchanged status indefinitely; storing it
        // again would replace the `app` memo's identity and re-render the whole tree
        // for no visible change.
        if ((0, $45a151b8ba325293$export$d321c1cb8221632)(previous, status)) return;
        pendingStatus.current = status;
        statusCoalescer.schedule();
    }, [
        app,
        statusCoalescer
    ]);
    (0, $8c1387b8259a816a$export$511b18851e72b74a)((listener)=>{
        const id = app.socket.subscribe("AppStatus", listener);
        return ()=>app.socket.unsubscribe("AppStatus", id);
    }, statusSubscription, [
        app.socket
    ]);
    // Refresh `current` whenever a `Day` broadcast arrives. The handler is kept in a
    // ref (updated every render) so the single subscription below always invokes the
    // CURRENT-render app's `updateCurrent`, which closes over the live session/shipId.
    //
    // Bugfix (#769): this was previously a render-body `app.socket.subscribe("Day", …)`
    // with a `useCallback([])` handler that captured the render-0 app — whose
    // `updateCurrent` early-returns on the initial undefined session — so Day
    // broadcasts never refreshed `current`. It also re-subscribed (accumulating ids
    // per `Client.subscribe`) on every render. Subscribing once in an effect with a
    // latest-handler ref both fixes the stale capture and removes that leak.
    // Coalesced for the same reason as the status handler above: a backlog of `Day`
    // broadcasts used to fire one `updateCurrent()` refetch — and so one state
    // update — per message. The coalescer reads `app` through a ref so it stays
    // stable across the `app` memo's identity churn; recreating it per render would
    // let the cleanup below cancel a scheduled refetch before it ran.
    const appRef = (0, $acw62.useRef)(app);
    appRef.current = app;
    const currentCoalescer = (0, $acw62.useMemo)(()=>(0, $45a151b8ba325293$export$4b6d2f412bf6117)(()=>{
            appRef.current.updateCurrent();
        }), []);
    (0, $acw62.useEffect)(()=>()=>currentCoalescer.cancel(), [
        currentCoalescer
    ]);
    (0, $8c1387b8259a816a$export$511b18851e72b74a)((listener)=>{
        const id = app.socket.subscribe("Day", listener);
        return ()=>app.socket.unsubscribe("Day", id);
    }, ()=>{
        currentCoalescer.schedule();
    }, [
        app.socket
    ]);
    (0, $acw62.useEffect)(()=>{
        document.documentElement.setAttribute("lang", lang);
    }, [
        lang
    ]);
    (0, $acw62.useEffect)(()=>{
        if (session != undefined) return;
        if (!app.cloudSession() && (0, $b57fb2219af67c07$export$1fb4852a55678982).isCompanionRoute(window.location.pathname)) {
            // Render the handoff without authenticating (or logging out) the origin's old token.
            setSession({
                authorized: false
            });
            return;
        }
        // The guard above is evaluated when this effect RUNS; `superseded` is what
        // re-checks it when the request RESOLVES. Between the two, a session can be
        // established by another path -- most commonly the user logging in through
        // the form while the boot-time load is still outstanding, which is routine
        // because the app answers `/api/session` with 401 until its local DB is
        // ready and a ship select restarts the instance.
        //
        // Without this, that stale rejection reached the catch below and called
        // `app.logout(false)`, wiping the session that had just succeeded and
        // bouncing the user back to the login page. Seen in a full E2E run of
        // `nmea-live-0183.spec.ts`: the server logged `ship selected 8` while the
        // browser sat on `/app/signup`, having logged itself out.
        //
        // The success path is guarded too: applying a stale session/account/user on
        // top of a newer one is the same bug in a quieter form.
        let superseded = false;
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("loading session", (0, $ea493e883ca706d4$export$10369954900e6465));
        const load = async ()=>{
            var _a;
            // If localStorage lost the session (e.g. wiped by an app update) but the
            // device still holds its primary session server-side, restore it on the
            // launch route so the user isn't forced to log in again. Transient failures
            // must reach the retry handler, not an unauthenticated load that logs out.
            if ((0, $b57fb2219af67c07$export$1fb4852a55678982).shouldRestore(window.location.pathname, app.cloudSession())) {
                const restored = await (0, $5ba8962d09b05c4a$export$b531eccea6f91101).restoreSession(app.apiClient);
                if (superseded) {
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("session restore superseded, discarding", (0, $ea493e883ca706d4$export$10369954900e6465));
                    return;
                }
                if (restored && restored.session && restored.session.authorized && restored.session.id) {
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("restored session", (0, $ea493e883ca706d4$export$10369954900e6465));
                    (0, $b57fb2219af67c07$export$1fb4852a55678982).persistSession(socket, restored.session, restored.type);
                }
            }
            const data = await (0, $5ba8962d09b05c4a$export$b531eccea6f91101).loadSession(app.apiClient);
            if (!data || !data.session) // The generated type declares `session` as non-optional, so this is a
            // defensive guard -- but it used to be an `if` with no `else`, which
            // left `session` undefined AND `n` untouched. The effect's [session, n]
            // deps therefore never changed, it never re-ran, and the app rested on
            // <Loading /> forever with no retry, no logout and nothing logged; even
            // a reload didn't help (#1300). Throw so the empty case takes the same
            // escalating-backoff retry as a transient failure.
            throw new Error("session load resolved without a session");
            if (superseded) {
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("session load superseded, discarding", (0, $ea493e883ca706d4$export$10369954900e6465));
                return;
            }
            setSessionType(data.type);
            setSession(data.session);
            setAccountSessionResponse(data);
            setUser(data.user);
            setFeatures(data.features || []);
            // Apply the user's persisted language (cloud sessions store it
            // server-side). Primary/local sessions have no stored language, so the
            // localStorage value chosen at init is kept.
            if ((_a = data.user) === null || _a === void 0 ? void 0 : _a.language) {
                setLang(data.user.language);
                localStorage.setItem("logbook-language", data.user.language);
            }
            // Force cloud theme when in cloud session
            if (data.type == (0, $a8c48887e141e972$export$9fd99c4c3c179cff).cloud) {
                const cloudTheme = "cloud";
                setTheme(cloudTheme);
                localStorage.setItem("logbook-theme", cloudTheme);
                document.documentElement.setAttribute("data-theme", cloudTheme);
            }
            // #1043: a passive app reload/restart (as opposed to the manual
            // ship-select click, which already persists this via `setShipId`)
            // must resume a previously-open ship automatically. `session.get`
            // already returns the primary session's `shipId`; apply it here so
            // React state + localStorage reflect it without a second reload.
            // Only ever set — never clear — so this doesn't stomp a companion's
            // own `logbook-ship` (set independently via `connectLocal`, which
            // this device's own primary session never gets to see).
            if (data.type == (0, $a8c48887e141e972$export$9fd99c4c3c179cff).primary && data.session.shipId != undefined) {
                (0, $b57fb2219af67c07$export$1fb4852a55678982).persistShipId(data.session.shipId);
                setShipId(data.session.shipId);
            }
            socket.stream(data.type == "primary" ? 1000 : 10000);
            app.updateCurrent();
            updateStatus();
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("loaded session");
        };
        load().catch((error)=>{
            // A genuinely invalid/expired session responds HTTP 200 with
            // `authorized: false` (handled in the success branch above), so reaching
            // this catch means the load itself failed -- or resolved without a
            // session, which the branch above turns into a throw so it lands here too.
            // Only a real auth rejection (401/403) ends the session; everything else
            // -- a total network failure (no HTTP response, e.g. the server
            // unreachable mid-deploy), a 5xx from the app/proxy, and the 503 the app
            // returns while its local DB isn't ready yet -- keeps the user signed in
            // and retries.
            if (superseded) {
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("session load failed but was superseded, ignoring", error, (0, $ea493e883ca706d4$export$10369954900e6465));
                return;
            }
            if ((0, $b57fb2219af67c07$export$1fb4852a55678982).classifySessionLoadFailure(error) == "logout") {
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("session load failed (definitive), logging out", error, (0, $ea493e883ca706d4$export$10369954900e6465));
                app.logout(false);
                return;
            }
            // Retry with an escalating backoff — quick first (250ms) then doubling up
            // to a 10s cap — and never clear the stored token, just like the
            // WebSocket layer reconnects instead of giving up. `session` stays
            // undefined so the app keeps showing its <Loading /> state until a later
            // attempt succeeds.
            const delay = (0, $8c1387b8259a816a$export$b772e9ad161cd3e0)({
                initialMilliseconds: 250,
                maximumMilliseconds: 10000
            })(n);
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("session load failed, retrying", error, (0, $ea493e883ca706d4$export$10369954900e6465));
            window.setTimeout(()=>{
                if (superseded) return;
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("retrying session load", (0, $ea493e883ca706d4$export$10369954900e6465));
                setN(n + 1);
            }, delay);
        });
        return ()=>{
            superseded = true;
        };
    }, [
        session,
        n
    ]);
    (0, $acw62.useEffect)(()=>{
        const load = async ()=>{
            if (shipId && sessionType) {
                updateStatus();
                app.updateCurrent();
            }
        };
        load().catch(console.error);
    }, [
        shipId,
        sessionType
    ]);
    (0, $acw62.useEffect)(()=>{
        const load = async ()=>{
            const styles = await (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).loadAppStyles();
            if (styles) {
                app.appStyles = styles;
                setAppStyles(styles);
            }
        };
        load().catch(console.error);
        if (document.location.search.indexOf("inapp=true") >= 0) {
            localStorage.setItem("logbook-inapp", "true");
            window.history.replaceState({}, "", window.location.pathname);
        }
    }, []);
    (0, $8c1387b8259a816a$export$511b18851e72b74a)((0, $2472f3c19d716da0$export$d279116694714bd1), setLocation, []);
}




function $dd0c245c4eefac88$export$669f6ea7d267feaf({ page: page } = {}) {
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: page ? "Loading Loading-page" : "Loading",
        children: "Loading..."
    });
}





function $4505d62785317e3b$export$b143682c58b4e0ac({ pending: pending, onClose: onClose, onRetry: onRetry, t: t }) {
    return (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        className: "OpenServerDialog",
        containerClassName: "OpenServerDialog-layer",
        style: pending ? undefined : "alarm",
        title: t("title"),
        hideClose: pending,
        closeCallback: pending ? undefined : onClose,
        closeBackground: !pending,
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "Overlay-body",
            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: pending ? (0, $7b02d682eb115277$exports.jsx)("div", {
                            role: "status",
                            children: t("opening")
                        }) : (0, $7b02d682eb115277$exports.jsx)("div", {
                            role: "alert",
                            children: t("failed")
                        })
                    }),
                    !pending && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        actions: true,
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button",
                                    onClick: onClose,
                                    children: t("close")
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button default",
                                    onClick: onRetry,
                                    children: t("retry")
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}







var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
const $97ac05743b787a86$var$cruiseContext = (0, $736b3300c1bfc0c7$export$63e8bf8ba447cd7a)("CruiseContext");
const $97ac05743b787a86$export$3b6211c622665b21 = $97ac05743b787a86$var$cruiseContext.Context;
const $97ac05743b787a86$export$135b8b9ecdd62154 = ()=>(0, $acw62.useContext)($97ac05743b787a86$export$3b6211c622665b21);
const $97ac05743b787a86$var$dayContext = (0, $736b3300c1bfc0c7$export$63e8bf8ba447cd7a)("DayContext");
const $97ac05743b787a86$export$a09925a4bc6c3c0c = $97ac05743b787a86$var$dayContext.Context;
const $97ac05743b787a86$export$95d65094202e15e7 = ()=>(0, $acw62.useContext)($97ac05743b787a86$export$a09925a4bc6c3c0c);
const $97ac05743b787a86$var$logContext = (0, $736b3300c1bfc0c7$export$63e8bf8ba447cd7a)("LogContext");
const $97ac05743b787a86$export$2d8b280ec4cad22c = $97ac05743b787a86$var$logContext.Context;
const $97ac05743b787a86$export$f4f9faa631770428 = ()=>(0, $acw62.useContext)($97ac05743b787a86$export$2d8b280ec4cad22c);
const $97ac05743b787a86$var$shipContext = (0, $736b3300c1bfc0c7$export$63e8bf8ba447cd7a)("ShipContext");
const $97ac05743b787a86$export$74bc7108ae339b7 = $97ac05743b787a86$var$shipContext.Context;
const $97ac05743b787a86$export$251c0204053e076a = ()=>(0, $acw62.useContext)($97ac05743b787a86$export$74bc7108ae339b7);
const $97ac05743b787a86$export$f581995c9f2db6f0 = ()=>$97ac05743b787a86$export$251c0204053e076a().ship;
const $97ac05743b787a86$export$678e2592ec050b6e = ()=>$97ac05743b787a86$export$251c0204053e076a().ship;
const $97ac05743b787a86$var$tripContext = (0, $736b3300c1bfc0c7$export$63e8bf8ba447cd7a)("TripContext");
const $97ac05743b787a86$export$cc476f15536a432b = $97ac05743b787a86$var$tripContext.Context;
const $97ac05743b787a86$export$e205ea882cbd693e = ()=>(0, $acw62.useContext)($97ac05743b787a86$export$cc476f15536a432b);
var $97ac05743b787a86$export$bf37da5ca7e88dda;
(function(ShipDataType) {
    ShipDataType[ShipDataType["short"] = 1] = "short";
    ShipDataType[ShipDataType["details"] = 2] = "details";
})($97ac05743b787a86$export$bf37da5ca7e88dda || ($97ac05743b787a86$export$bf37da5ca7e88dda = {}));
const $97ac05743b787a86$var$printShipViewContext = (0, $736b3300c1bfc0c7$export$63e8bf8ba447cd7a)("PrintShipViewContext");
const $97ac05743b787a86$export$b152308473c555d0 = $97ac05743b787a86$var$printShipViewContext.Context;
const $97ac05743b787a86$export$aa22615308ad52a0 = ()=>(0, $acw62.useContext)($97ac05743b787a86$export$b152308473c555d0);





// What a ship row in the select list offers. Exactly one state per row, and exactly
// one action per state -- this replaces the previous model where `companion` mapped to
// two different click behaviours chosen by the (invisible, volatile) local-discovery
// list, and where `alreadyOpened` rendered a distinct style it could never be clicked
// in (#1279).
var $9afa59e734ffa505$export$84cca2ac982a48b2;
(function(ShipSelectState) {
    // No one holds this ship and I may take it: select it as primary.
    ShipSelectState["openable"] = "openable";
    // THIS device holds the claim token: resume it, never re-pair with it.
    ShipSelectState["openHere"] = "openHere";
    // Another device holds it: connect as a companion, always via the connect dialog.
    ShipSelectState["openElsewhere"] = "openElsewhere";
    // Not actionable right now. Always carries a reason unless the list itself is
    // display-only, so "can't connect right now" never degrades into "nothing happens".
    ShipSelectState["unavailable"] = "unavailable";
})($9afa59e734ffa505$export$84cca2ac982a48b2 || ($9afa59e734ffa505$export$84cca2ac982a48b2 = {}));
var $9afa59e734ffa505$export$582094c3bb9d2b97;
(function(ShipSelectUnavailable) {
    ShipSelectUnavailable["noPermission"] = "noPermission";
    ShipSelectUnavailable["importInProgress"] = "importInProgress";
    // Another ship is already open on THIS device. A device runs one primary logbook at
    // a time and the server refuses a second claim, so the list has to say so before the
    // click instead of letting the user pick a ship and meet a server error.
    ShipSelectUnavailable["shipOpenHere"] = "shipOpenHere";
})($9afa59e734ffa505$export$582094c3bb9d2b97 || ($9afa59e734ffa505$export$582094c3bb9d2b97 = {}));
var $9afa59e734ffa505$export$5aa6b8c8000bf93c;
(function(CompanionConnectPhase) {
    // Automatic attempt in flight: resolve the advertised service, then pair with it.
    CompanionConnectPhase["connecting"] = "connecting";
    // Manual address entry. Reached directly (no automatic route) or as the fallback
    // after the automatic attempt failed or ran past its deadline.
    CompanionConnectPhase["manual"] = "manual";
    // The primary refused this companion for running an older build. Terminal, and
    // deliberately NOT the manual form: no address the user can type changes the
    // outcome, so offering the form would invite them to keep retrying something
    // that cannot work. The only remedy is updating the app, which the view says.
    CompanionConnectPhase["outdated"] = "outdated";
    CompanionConnectPhase["success"] = "success";
    CompanionConnectPhase["cancelled"] = "cancelled";
})($9afa59e734ffa505$export$5aa6b8c8000bf93c || ($9afa59e734ffa505$export$5aa6b8c8000bf93c = {}));
var $9afa59e734ffa505$export$aff75a1270347761;
(function(CompanionConnectError) {
    // The attempt ran past its deadline without answering either way.
    CompanionConnectError["timeout"] = "timeout";
    // Nothing on the network is advertising this ship.
    CompanionConnectError["notDiscovered"] = "notDiscovered";
    // Several devices advertise it, so the fail-closed collision policy refuses to guess.
    CompanionConnectError["ambiguous"] = "ambiguous";
    // Advertised, but no address could be determined for it.
    CompanionConnectError["unresolved"] = "unresolved";
    // An address was known and nothing answered on it.
    CompanionConnectError["unreachable"] = "unreachable";
    // The primary answered and declined to issue a session.
    CompanionConnectError["refused"] = "refused";
    // No primary currently holds this ship, or this device has not synced since one did.
    CompanionConnectError["notClaimed"] = "notClaimed";
    // The signed-in user is not a member of this ship's account.
    CompanionConnectError["notAccessible"] = "notAccessible";
    // A manually entered address was not `host:port`.
    CompanionConnectError["addressInvalid"] = "addressInvalid";
    // This device is the ship's own primary, so there is nothing to pair with (#1279).
    CompanionConnectError["ownDevice"] = "ownDevice";
    // Nothing more specific is known. Kept so no failure path can become silent.
    CompanionConnectError["failed"] = "failed";
})($9afa59e734ffa505$export$aff75a1270347761 || ($9afa59e734ffa505$export$aff75a1270347761 = {}));
var $9afa59e734ffa505$export$e023620e75653f5c;
(function(CompanionResolveReason) {
    CompanionResolveReason["notDiscovered"] = "notDiscovered";
    CompanionResolveReason["ambiguous"] = "ambiguous";
    CompanionResolveReason["unresolved"] = "unresolved";
})($9afa59e734ffa505$export$e023620e75653f5c || ($9afa59e734ffa505$export$e023620e75653f5c = {}));


const $a359a1de1c9c067b$export$6fdd7e23becf9b95 = {
    // Pair with the primary. `address` is omitted for an automatic (Bonjour) attempt and
    // set for a manual one. `attempt` is an opaque id the app-local route re-checks
    // immediately before it persists `local:ship`/`local:session`, so a cancelled,
    // timed-out or superseded attempt can never commit pairing state late (#1279).
    connectLocal (api, shipId, address, attempt) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.connectLocal({
            params: {
                shipId: shipId
            },
            body: {
                address: address,
                attempt: attempt
            }
        }).call();
    },
    async cancelLocal (api, shipId, attempt) {
        await new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.disconnectLocal({
            params: {
                shipId: shipId
            },
            body: {
                attempt: attempt
            }
        }).call();
    },
    prepareHandoff (api, shipId) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.prepareHandoff({
            params: {
                shipId: shipId
            }
        }).call();
    },
    // Resolve the ship's advertised service to a `host:port` WITHOUT pairing. Splitting
    // resolution from the connect is what lets the dialog prefill the manual form even
    // when the subsequent login is slow or never answers. When there is no address the
    // response says WHY, which is what the dialog reports after an automatic attempt
    // falls back (#1388).
    resolveLocal (api, shipId) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.resolveLocal({
            params: {
                shipId: shipId
            }
        }).call();
    }
};
// True while an import is still running. A complete or failed import is finished --
// failed imports must stay openable so the ship can be opened and the import retried.
function $a359a1de1c9c067b$var$importInProgress(ship) {
    var _a;
    const status = (_a = (0, $3d4dfb4b3a9d38e4$export$7930c61d9b464618).parse(ship).dataParsed) === null || _a === void 0 ? void 0 : _a.importStatus;
    return !!status && status != (0, $ef756702f3923ebb$export$bd5fd2a78082695e).complete && status != (0, $ef756702f3923ebb$export$bd5fd2a78082695e).failed;
}
function $a359a1de1c9c067b$export$27e0267f5c02a571(params) {
    var _a;
    const { ship: ship, user: user, ownShipId: ownShipId, nearbyShipIds: nearbyShipIds, primaryFeature: primaryFeature, viewable: viewable } = params;
    // Discovery does not exclude this device's own advertisement: `/api/ships/local`
    // browses the LAN for the account's ships and our own service answers. For the ship
    // THIS device holds, "found on your network" would therefore be a statement about
    // another device made about ourselves -- it rendered next to the logbook the user
    // had just opened here. The badge is only ever about someone else's device.
    const nearby = !!nearbyShipIds && nearbyShipIds.indexOf(ship.id) >= 0 && ownShipId !== ship.id;
    const row = (state, unavailable)=>({
            state: state,
            unavailable: unavailable,
            nearby: nearby
        });
    // Holding a logbook open blocks every OTHER row. The row keeps its own state so it
    // still renders its proper control and icons -- just disabled, with the reason.
    const blockedByOpenShip = ownShipId != undefined && ownShipId !== ship.id;
    const rowBlockedIfOtherOpen = (state)=>({
            state: state,
            blocked: blockedByOpenShip ? (0, $9afa59e734ffa505$export$582094c3bb9d2b97).shipOpenHere : undefined,
            nearby: nearby
        });
    if (viewable === false) return row((0, $9afa59e734ffa505$export$84cca2ac982a48b2).unavailable);
    if ($a359a1de1c9c067b$var$importInProgress(ship)) return row((0, $9afa59e734ffa505$export$84cca2ac982a48b2).unavailable, (0, $9afa59e734ffa505$export$582094c3bb9d2b97).importInProgress);
    // Ownership is checked before the claim token, so the stale-token window resolves to
    // "mine" rather than "someone else's".
    if (ownShipId != undefined && ownShipId === ship.id) return row((0, $9afa59e734ffa505$export$84cca2ac982a48b2).openHere);
    if (ship.clientToken != undefined) // Deliberately not gated on a membership level: the server authorizes the pairing,
    // and the ships list only contains ships this user can already see. A client-side
    // gate here would strand a user whose membership hasn't loaded yet.
    return rowBlockedIfOtherOpen((0, $9afa59e734ffa505$export$84cca2ac982a48b2).openElsewhere);
    if (((_a = user === null || user === void 0 ? void 0 : user.shipUserLevel) !== null && _a !== void 0 ? _a : (0, $dc7739d612f0c536$export$fe876bf720d558fa).none) >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary && primaryFeature === true) return rowBlockedIfOtherOpen((0, $9afa59e734ffa505$export$84cca2ac982a48b2).openable);
    return row((0, $9afa59e734ffa505$export$84cca2ac982a48b2).unavailable, (0, $9afa59e734ffa505$export$582094c3bb9d2b97).noPermission);
}




const $b5c1808b3220ae33$export$ee5d184428ee6ea4 = 4000;
const $b5c1808b3220ae33$export$d26b9c509b67b9bf = 10000;
const $b5c1808b3220ae33$export$89fd5c26bb5c09a8 = 10000;
const $b5c1808b3220ae33$var$disconnectGenerations = new Map();
function $b5c1808b3220ae33$export$ea47b402c0c5f72f(shipId) {
    var _a;
    $b5c1808b3220ae33$var$disconnectGenerations.set(shipId, ((_a = $b5c1808b3220ae33$var$disconnectGenerations.get(shipId)) !== null && _a !== void 0 ? _a : 0) + 1);
}
// A session response only counts as success when it actually carries a session id.
// The previous implementation checked this inline and simply fell through otherwise,
// which is how an authorized-but-session-less response became a silent no-op (#1279).
function $b5c1808b3220ae33$var$connected(response) {
    return !!response && !!response.session && !!response.session.id;
}
// The error name the primary answers with when it refuses a companion running an
// older build (`LogbookApiError.companionVersionOutdated`, served as a 400).
const $b5c1808b3220ae33$var$outdatedError = "companionVersionOutdated";
// Every failure the app-local connect route can name, mapped to the reason the dialog
// shows. Keyed on the error NAME rather than the status: these are all 400s, and
// `notFound`/`unauthorized` deliberately do not appear because they flatten to
// human-readable text on the wire and so cannot identify a cause (#1388).
const $b5c1808b3220ae33$var$connectErrors = {
    companionShipNotAccessible: (0, $9afa59e734ffa505$export$aff75a1270347761).notAccessible,
    companionAddressInvalid: (0, $9afa59e734ffa505$export$aff75a1270347761).addressInvalid,
    companionShipNotFound: (0, $9afa59e734ffa505$export$aff75a1270347761).notDiscovered,
    companionShipNotClaimed: (0, $9afa59e734ffa505$export$aff75a1270347761).notClaimed,
    companionShipUnresolved: (0, $9afa59e734ffa505$export$aff75a1270347761).unresolved,
    companionPrimaryUnreachable: (0, $9afa59e734ffa505$export$aff75a1270347761).unreachable,
    companionRefused: (0, $9afa59e734ffa505$export$aff75a1270347761).refused,
    shipOwnedByThisDevice: (0, $9afa59e734ffa505$export$aff75a1270347761).ownDevice
};
// A resolve failure describes the same ground as some connect failures, so the two
// share the dialog's vocabulary rather than inventing a second one.
const $b5c1808b3220ae33$var$resolveReasons = {
    [(0, $9afa59e734ffa505$export$e023620e75653f5c).notDiscovered]: (0, $9afa59e734ffa505$export$aff75a1270347761).notDiscovered,
    [(0, $9afa59e734ffa505$export$e023620e75653f5c).ambiguous]: (0, $9afa59e734ffa505$export$aff75a1270347761).ambiguous,
    [(0, $9afa59e734ffa505$export$e023620e75653f5c).unresolved]: (0, $9afa59e734ffa505$export$aff75a1270347761).unresolved
};
// The error name carried by a rejected request, when there is one.
function $b5c1808b3220ae33$var$errorName(error) {
    if (!error || typeof error != "object") return undefined;
    const name = error.error;
    return typeof name == "string" ? name : undefined;
}
function $b5c1808b3220ae33$export$17d87a953619a434(error) {
    return $b5c1808b3220ae33$var$errorName(error) === $b5c1808b3220ae33$var$outdatedError;
}
function $b5c1808b3220ae33$export$7311d7722789e66c(error) {
    const name = $b5c1808b3220ae33$var$errorName(error);
    return name ? $b5c1808b3220ae33$var$connectErrors[name] : undefined;
}
function $b5c1808b3220ae33$export$6b1c01c2c473186f(params) {
    var _a, _b, _c;
    const { shipId: shipId, resolve: resolve, connectLocal: connectLocal, onSuccess: onSuccess, onState: onState } = params;
    const timeoutMs = (_a = params.timeoutMs) !== null && _a !== void 0 ? _a : $b5c1808b3220ae33$export$ee5d184428ee6ea4;
    const submitTimeoutMs = (_b = params.submitTimeoutMs) !== null && _b !== void 0 ? _b : $b5c1808b3220ae33$export$d26b9c509b67b9bf;
    const handoffTimeoutMs = (_c = params.handoffTimeoutMs) !== null && _c !== void 0 ? _c : $b5c1808b3220ae33$export$89fd5c26bb5c09a8;
    // Monotonic attempt token. Incremented on cancel and on every new attempt, so a
    // response from a superseded attempt is recognised and dropped rather than applied.
    let attemptId = 0;
    let serverAttemptId = 0;
    const workflowId = Array.from(crypto.getRandomValues(new Uint32Array(4)), (value)=>value.toString(16)).join("-");
    const serverToken = (id)=>`${workflowId}-${id}`;
    let succeeded = false;
    let cancelled = false;
    let generation = $b5c1808b3220ae33$var$disconnectGenerations.get(shipId);
    const isCurrent = (token)=>token === attemptId && generation === $b5c1808b3220ae33$var$disconnectGenerations.get(shipId);
    let resolvedAddress;
    let resolveReason;
    let submittingAttempt;
    const emit = (state)=>onState(state);
    const cancelServer = async (token)=>{
        var _a;
        return (_a = params.cancelLocal) === null || _a === void 0 ? void 0 : _a.call(params, shipId, serverToken(token));
    };
    const cancelExpiredAttempt = (token)=>{
        cancelServer(token).catch((error)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Failed to cancel expired companion pairing", shipId, error));
    };
    const manual = (error)=>emit({
            phase: (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).manual,
            address: resolvedAddress,
            error: error
        });
    // The most specific reason available, in precedence order: what the connect route
    // named, then what resolution reported, then the catch-all. Resolution comes second
    // because a named connect failure describes a later, more decisive step -- but it
    // comes at all because the automatic route usually dies at resolution, where the
    // connect can only report that something generic went wrong (#1388).
    const reasonFor = (error)=>{
        var _a, _b;
        return (_b = (_a = $b5c1808b3220ae33$export$7311d7722789e66c(error)) !== null && _a !== void 0 ? _a : resolveReason ? $b5c1808b3220ae33$var$resolveReasons[resolveReason] : undefined) !== null && _b !== void 0 ? _b : (0, $9afa59e734ffa505$export$aff75a1270347761).failed;
    };
    // Resolves once the attempt finishes or the deadline passes, whichever is first. The
    // request itself is not abortable from here, so the attempt token is what guarantees
    // a late response cannot complete the handoff behind the user's back. The budget is
    // a parameter because the automatic and manual routes deliberately differ (#1388).
    const withDeadline = async (work, ms)=>{
        let timer;
        const deadline = ms > 0 ? new Promise((resolveDeadline)=>{
            timer = setTimeout(()=>resolveDeadline({
                    timedOut: true
                }), ms);
        }) : Promise.resolve({
            timedOut: true
        });
        try {
            return await Promise.race([
                work(()=>clearTimeout(timer)).then((value)=>({
                        timedOut: false,
                        value: value
                    })),
                deadline
            ]);
        } finally{
            clearTimeout(timer);
        }
    };
    const attempt = async (address, attemptToken, finishPairingDeadline)=>{
        let response;
        try {
            response = await connectLocal(shipId, address, serverToken(attemptToken));
        } catch (error) {
            if (!isCurrent(attemptToken)) // Cancelled or superseded while in flight: drop the result entirely.
            return;
            if ($b5c1808b3220ae33$export$17d87a953619a434(error)) {
                // Terminal: settle here rather than rethrowing into the callers' generic
                // catch, which would replace this with the manual form and lose the reason.
                emit({
                    phase: (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).outdated
                });
                return;
            }
            // Classified here rather than rethrown, so the reason survives instead of being
            // flattened by a caller's catch -- which is exactly how eight causes became one
            // message (#1388).
            manual(reasonFor(error));
            return;
        }
        if (!isCurrent(attemptToken)) // Cancelled or superseded while in flight: drop the result entirely.
        return;
        if (!$b5c1808b3220ae33$var$connected(response)) {
            // The primary answered and issued no session. That is a refusal, not a network
            // problem, and used to be indistinguishable from an unreachable address.
            manual((0, $9afa59e734ffa505$export$aff75a1270347761).refused);
            return;
        }
        finishPairingDeadline();
        emit({
            phase: (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).success,
            address: resolvedAddress
        });
        const prepared = await withDeadline(async ()=>{
            var _a;
            return (_a = params.prepareHandoff) === null || _a === void 0 ? void 0 : _a.call(params, shipId);
        }, handoffTimeoutMs);
        if (!isCurrent(attemptToken)) return;
        if (prepared.timedOut) {
            attemptId++;
            manual((0, $9afa59e734ffa505$export$aff75a1270347761).unreachable);
            cancelExpiredAttempt(attemptToken);
            return;
        }
        await onSuccess(shipId, prepared.value);
        succeeded = isCurrent(attemptToken);
    };
    return {
        async start ({ nearby: nearby }) {
            const attemptToken = ++attemptId;
            serverAttemptId = attemptToken;
            generation = $b5c1808b3220ae33$var$disconnectGenerations.get(shipId);
            succeeded = false;
            cancelled = false;
            resolvedAddress = undefined;
            resolveReason = undefined;
            submittingAttempt = undefined;
            if (!nearby) {
                // No unambiguous automatic route. Open the manual form directly -- with no
                // error, since nothing has failed yet.
                manual();
                return;
            }
            emit({
                phase: (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).connecting
            });
            try {
                const { timedOut: timedOut } = await withDeadline(async (finishPairingDeadline)=>{
                    const resolved = await resolve(shipId).catch(()=>undefined);
                    if (!isCurrent(attemptToken)) return;
                    resolvedAddress = resolved === null || resolved === void 0 ? void 0 : resolved.address;
                    resolveReason = resolved === null || resolved === void 0 ? void 0 : resolved.reason;
                    await attempt(resolvedAddress, attemptToken, finishPairingDeadline);
                }, timeoutMs);
                if (timedOut && isCurrent(attemptToken)) {
                    attemptId++;
                    manual((0, $9afa59e734ffa505$export$aff75a1270347761).timeout);
                    cancelExpiredAttempt(attemptToken);
                }
            } catch (error) {
                if (isCurrent(attemptToken)) manual(reasonFor(error));
            }
        },
        async submit (address) {
            if (submittingAttempt != undefined) return;
            const attemptToken = ++attemptId;
            submittingAttempt = attemptToken;
            serverAttemptId = attemptToken;
            generation = $b5c1808b3220ae33$var$disconnectGenerations.get(shipId);
            succeeded = false;
            cancelled = false;
            resolvedAddress = address;
            // A typed address stands on its own: a reason left over from the automatic
            // attempt describes a route the user has already abandoned.
            resolveReason = undefined;
            emit({
                phase: (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).manual,
                address: address,
                submitting: true
            });
            try {
                // No `.catch()` here, deliberately: a rejection must reach the catch below,
                // which is what turns it into a reason on the form. `attempt` classifies
                // connect failures itself, so what surfaces here is the handoff failing.
                const { timedOut: timedOut } = await withDeadline((finishPairingDeadline)=>attempt(address, attemptToken, finishPairingDeadline), submitTimeoutMs);
                if (!isCurrent(attemptToken)) return;
                if (timedOut) {
                    // Supersede the in-flight attempt so its late response cannot commit, exactly
                    // as the automatic route does.
                    attemptId++;
                    manual((0, $9afa59e734ffa505$export$aff75a1270347761).timeout);
                    cancelExpiredAttempt(attemptToken);
                }
            } catch (error) {
                if (isCurrent(attemptToken)) manual(reasonFor(error));
            } finally{
                // Released even on the deadline path: leaving it set would lock the form for
                // the rest of the dialog's life, turning a timeout into a dead end.
                if (submittingAttempt === attemptToken) submittingAttempt = undefined;
            }
        },
        async cancel () {
            const token = serverAttemptId;
            attemptId++;
            succeeded = false;
            submittingAttempt = undefined;
            emit({
                phase: (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).cancelled
            });
            await cancelServer(token);
            cancelled = true;
        },
        async dispose () {
            const token = serverAttemptId;
            attemptId++;
            if (!succeeded && !cancelled) await cancelServer(token);
        }
    };
}




var $acw62 = parcelRequire("acw62");
function $5788501efbf36a87$export$ea8f71083e90600f(defaultValue, initialValue) {
    var _a = (0, $acw62.useState)(initialValue !== null && initialValue !== void 0 ? initialValue : defaultValue), overlay = _a[0], setOverlayValue = _a[1];
    var _b = (0, $acw62.useState)(), overlayOptions = _b[0], setOverlayOptions = _b[1];
    var setOverlay = (0, $acw62.useCallback)(function(value, options) {
        setOverlayValue(value);
        setOverlayOptions(options);
    }, []);
    var resetOverlay = (0, $acw62.useCallback)(function() {
        setOverlayValue(defaultValue);
        setOverlayOptions(undefined);
    }, [
        defaultValue
    ]);
    return [
        overlay,
        overlayOptions,
        setOverlay,
        resetOverlay
    ];
}








// The connection "kit": the shared vocabulary every per-entity connection module
// (the sibling `Connections/<Model>.ts` files) is built on. A `Connection` binds
// one generated schema entity to its typed transport — the REST fetcher (#661),
// the live subscription token(s) (#662), its owner-FK index fields (derived from
// the schema graph #666/#1090), soft-delete field and default sort. This is the
// hand-written map criterion 3 asks for: assembled into a `Record<SchemaEntity,
// Connection>` (see ../Connections.ts) that is exhaustive at the type level (a
// missing entity is a compile error) and validated at runtime by `bindSchema`.
//
// #1707 (tracker #1677) extracted the generic schema/store/connection kernel
// below into app-base's `data/schema` + `data/connection` (a `DataSchema`-
// parameterized engine with no knowledge of Logbook's generated types). This
// module is now the adapter: `LogbookSchema` binds the generic engine to
// Logbook's generated `SchemaEntityTypes`/`SchemaEntityFkFields`, `logbookEdges`
// translates the generated schema graph's `kind`/`canonical` fields into the
// generic engine's single `canonical` flag, and every type/helper below keeps
// its exact prior name and shape so every `Connections/<Model>.ts` module and
// View-level consumer (`EntityFilter<K>`, `entity(...)`, …) is unaffected.
//
// `Connection.fetch` keeps Logbook's concrete generated `ApiClient` (rather
// than the generic engine's own `DataApiClient`) as its client parameter, so a
// per-entity fetcher can keep constructing a generated API class directly
// (`new LogApi(client)`) with no per-file adapter. `entity()` is the one seam
// that bridges the two — see its own comment below.
//
// The `entity()` helper auto-derives `indexes` and `softDelete` from the schema
// graph (via app-base's `buildConnection`) and `live` from the naming-convention
// `Subscription` lookup (Logbook policy, not something the generic engine
// assumes); a per-entity module only spells out what is genuinely bespoke (a
// fetcher, a sort, folds, …). A bare `entity("X")` is therefore a schema-derived
// placeholder (indexes + soft-delete + live token where one exists, no fetcher);
// #1105 (data-layer core, tracker #665) wires `Log` (plus Track/Status) end-to-end and later work fleshes out the
// rest.
// FK fields to index an entity by: every schema edge that targets it, deduped.
// e.g. a Widget owned by both a Project and a Workshop indexes by both FKs.
function $29278580678edd79$export$6e36bbf7bc18dcd9(type, edges) {
    var fields = new Set();
    for(var _i = 0, edges_1 = edges; _i < edges_1.length; _i++){
        var edge = edges_1[_i];
        if (edge.to === type) fields.add(edge.fkField);
    }
    return Array.from(fields);
}
function $29278580678edd79$export$6d0e606268da942c(from, to, edges) {
    var fallback;
    for(var _i = 0, edges_2 = edges; _i < edges_2.length; _i++){
        var edge = edges_2[_i];
        if (edge.from === from && edge.to === to) {
            if (edge.canonical) return edge.fkField;
            fallback !== null && fallback !== void 0 ? fallback : fallback = edge.fkField;
        }
    }
    return fallback;
}


var $bcf0a4ee4a28a2dd$var$__assign = undefined && undefined.__assign || function() {
    $bcf0a4ee4a28a2dd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bcf0a4ee4a28a2dd$var$__assign.apply(this, arguments);
};
function $bcf0a4ee4a28a2dd$export$df392344a67abe9b(rows) {
    if (!rows) return [];
    return Object.entries(rows).flatMap(function(_a) {
        var type = _a[0], slice = _a[1];
        return slice ? [
            [
                type,
                slice
            ]
        ] : [];
    });
}
function $bcf0a4ee4a28a2dd$export$7da07ced8fa2b227(ids) {
    if (!ids) return [];
    return Object.entries(ids).flatMap(function(_a) {
        var type = _a[0], slice = _a[1];
        return slice ? [
            [
                type,
                slice
            ]
        ] : [];
    });
}
function $bcf0a4ee4a28a2dd$export$6ee185c108fef82f(type, descriptor, overrides) {
    var _a;
    if (overrides === void 0) overrides = {};
    return $bcf0a4ee4a28a2dd$var$__assign({
        type: type,
        indexes: (0, $29278580678edd79$export$6e36bbf7bc18dcd9)(type, descriptor.edges),
        softDelete: (_a = descriptor.softDeleteFields) === null || _a === void 0 ? void 0 : _a[type],
        live: []
    }, overrides);
}
function $bcf0a4ee4a28a2dd$export$4741711f07dbb8e7(registry, descriptor) {
    var _a;
    for(var _i = 0, _b = descriptor.edges; _i < _b.length; _i++){
        var edge = _b[_i];
        for(var _c = 0, _d = [
            edge.from,
            edge.to
        ]; _c < _d.length; _c++){
            var type = _d[_c];
            var connection = registry[type];
            if (!connection) throw new Error("validateSchema: no connection for entity \"".concat(type, "\""));
            if (connection.type !== type) throw new Error("validateSchema: connection \"".concat(type, "\" has mismatched type \"").concat(connection.type, "\""));
        }
    }
    for(var _e = 0, _f = descriptor.edges; _e < _f.length; _e++){
        var edge = _f[_e];
        var connection = registry[edge.to];
        if (!connection.indexes.includes(edge.fkField)) throw new Error("validateSchema: entity \"".concat(edge.to, "\" is missing index \"").concat(edge.fkField, "\" (edge from \"").concat(edge.from, "\")"));
    }
    for(var _g = 0, _h = Object.keys(registry); _g < _h.length; _g++){
        var type = _h[_g];
        var declared = registry[type].softDelete;
        var expected = (_a = descriptor.softDeleteFields) === null || _a === void 0 ? void 0 : _a[type];
        if ((declared !== null && declared !== void 0 ? declared : undefined) !== (expected !== null && expected !== void 0 ? expected : undefined)) throw new Error("validateSchema: entity \"".concat(type, "\" soft-delete mismatch (declared=").concat(declared !== null && declared !== void 0 ? declared : "none", ", expected=").concat(expected !== null && expected !== void 0 ? expected : "none", ")"));
    }
    var _loop_1 = function(type) {
        var folds = registry[type].folds;
        if (!folds) return "continue";
        var _loop_2 = function(name, fold) {
            var source = registry[fold.source];
            if (!source) throw new Error("validateSchema: fold \"".concat(type, ".").concat(name, "\" references unknown source entity \"").concat(fold.source, "\""));
            if (!source.indexes.includes(fold.via)) throw new Error("validateSchema: fold \"".concat(type, ".").concat(name, "\" via \"").concat(fold.via, "\" is not an index on \"").concat(fold.source, "\""));
            var edge = descriptor.edges.find(function(e) {
                return e.from === type && e.to === fold.source && e.fkField === fold.via;
            });
            if (!edge) throw new Error("validateSchema: fold \"".concat(type, ".").concat(name, "\" has no schema edge ").concat(type, " -> ").concat(fold.source, " via \"").concat(fold.via, "\""));
        };
        for(var _l = 0, _m = Object.entries(folds); _l < _m.length; _l++){
            var _o = _m[_l], name = _o[0], fold = _o[1];
            _loop_2(name, fold);
        }
    };
    for(var _j = 0, _k = Object.keys(registry); _j < _k.length; _j++){
        var type = _k[_j];
        _loop_1(type);
    }
}



// @generated by TypeGen from LogbookModel/Schema - DO NOT EDIT
const $d020ac6bb9bbb2b1$export$988b2caa0df88d45 = {
    Account: "Account",
    AccountSubscriptionPlan: "AccountSubscriptionPlan",
    AccountSubscriptionPlanFeature: "AccountSubscriptionPlanFeature",
    AccountSubscriptionPlanPricing: "AccountSubscriptionPlanPricing",
    AccountUser: "AccountUser",
    AuditLogEdit: "AuditLogEdit",
    Cruise: "Cruise",
    DataRecord: "DataRecord",
    Day: "Day",
    Log: "Log",
    Note: "Note",
    NoteAttachment: "NoteAttachment",
    Settings: "Settings",
    Ship: "Ship",
    ShipUser: "ShipUser",
    Status: "Status",
    StoredCalculation: "StoredCalculation",
    Track: "Track",
    Trip: "Trip",
    User: "User"
};
const $d020ac6bb9bbb2b1$export$3e48762ecc26ade4 = [
    {
        from: "AccountSubscriptionPlan",
        to: "AccountSubscriptionPlanFeature",
        fkField: "accountSubscriptionPlanId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "AccountSubscriptionPlan",
        to: "AccountSubscriptionPlanPricing",
        fkField: "accountSubscriptionPlanId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Account",
        to: "AccountUser",
        fkField: "accountId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "User",
        to: "AccountUser",
        fkField: "userId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Account",
        to: "AuditLogEdit",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Cruise",
        to: "AuditLogEdit",
        fkField: "cruiseId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Day",
        to: "AuditLogEdit",
        fkField: "dayId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Log",
        to: "AuditLogEdit",
        fkField: "logId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Ship",
        to: "AuditLogEdit",
        fkField: "shipId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "ShipUser",
        to: "AuditLogEdit",
        fkField: "shipUserId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Trip",
        to: "AuditLogEdit",
        fkField: "tripId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Account",
        to: "Cruise",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Ship",
        to: "Cruise",
        fkField: "shipId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Account",
        to: "DataRecord",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Cruise",
        to: "DataRecord",
        fkField: "cruiseId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "DataRecord",
        to: "DataRecord",
        fkField: "parentId",
        optional: true,
        canonical: false,
        kind: "role"
    },
    {
        from: "Day",
        to: "DataRecord",
        fkField: "dayId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Log",
        to: "DataRecord",
        fkField: "logId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Ship",
        to: "DataRecord",
        fkField: "shipId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Status",
        to: "DataRecord",
        fkField: "statusId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Trip",
        to: "DataRecord",
        fkField: "tripId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "User",
        to: "DataRecord",
        fkField: "userId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Account",
        to: "Day",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Cruise",
        to: "Day",
        fkField: "cruiseId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Ship",
        to: "Day",
        fkField: "shipId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Trip",
        to: "Day",
        fkField: "tripId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Account",
        to: "Log",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Cruise",
        to: "Log",
        fkField: "cruiseId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Day",
        to: "Log",
        fkField: "dayId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Ship",
        to: "Log",
        fkField: "shipId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Trip",
        to: "Log",
        fkField: "tripId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "User",
        to: "Log",
        fkField: "userId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Account",
        to: "Note",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Cruise",
        to: "Note",
        fkField: "cruiseId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Day",
        to: "Note",
        fkField: "dayId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Log",
        to: "Note",
        fkField: "logId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Ship",
        to: "Note",
        fkField: "shipId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Trip",
        to: "Note",
        fkField: "tripId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "User",
        to: "Note",
        fkField: "userId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Account",
        to: "NoteAttachment",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Note",
        to: "NoteAttachment",
        fkField: "noteId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Ship",
        to: "NoteAttachment",
        fkField: "shipId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "User",
        to: "NoteAttachment",
        fkField: "userId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Account",
        to: "Settings",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Ship",
        to: "Settings",
        fkField: "shipId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "User",
        to: "Settings",
        fkField: "userId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Account",
        to: "Ship",
        fkField: "accountId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Ship",
        to: "Ship",
        fkField: "tenderToId",
        optional: true,
        canonical: false,
        kind: "role"
    },
    {
        from: "Account",
        to: "ShipUser",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Ship",
        to: "ShipUser",
        fkField: "shipId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "User",
        to: "ShipUser",
        fkField: "userId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Account",
        to: "Status",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Cruise",
        to: "Status",
        fkField: "cruiseId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Day",
        to: "Status",
        fkField: "dayId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Log",
        to: "Status",
        fkField: "endLogId",
        optional: true,
        canonical: false,
        kind: "role"
    },
    {
        from: "Log",
        to: "Status",
        fkField: "startLogId",
        optional: false,
        canonical: false,
        kind: "role"
    },
    {
        from: "Ship",
        to: "Status",
        fkField: "shipId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Trip",
        to: "Status",
        fkField: "tripId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "User",
        to: "Status",
        fkField: "userId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Account",
        to: "StoredCalculation",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Cruise",
        to: "StoredCalculation",
        fkField: "sourceId",
        optional: false,
        canonical: false,
        kind: "polymorphic",
        discriminant: "3"
    },
    {
        from: "Day",
        to: "StoredCalculation",
        fkField: "sourceId",
        optional: false,
        canonical: false,
        kind: "polymorphic",
        discriminant: "1"
    },
    {
        from: "Log",
        to: "StoredCalculation",
        fkField: "sourceId",
        optional: false,
        canonical: false,
        kind: "polymorphic",
        discriminant: "4"
    },
    {
        from: "Ship",
        to: "StoredCalculation",
        fkField: "shipId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Ship",
        to: "StoredCalculation",
        fkField: "sourceId",
        optional: false,
        canonical: false,
        kind: "polymorphic",
        discriminant: "6"
    },
    {
        from: "Status",
        to: "StoredCalculation",
        fkField: "sourceId",
        optional: false,
        canonical: false,
        kind: "polymorphic",
        discriminant: "5"
    },
    {
        from: "Trip",
        to: "StoredCalculation",
        fkField: "sourceId",
        optional: false,
        canonical: false,
        kind: "polymorphic",
        discriminant: "2"
    },
    {
        from: "Account",
        to: "Track",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Cruise",
        to: "Track",
        fkField: "cruiseId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Day",
        to: "Track",
        fkField: "dayId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Ship",
        to: "Track",
        fkField: "shipId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Status",
        to: "Track",
        fkField: "monitorStatusId",
        optional: true,
        canonical: false,
        kind: "role"
    },
    {
        from: "Trip",
        to: "Track",
        fkField: "tripId",
        optional: true,
        canonical: false,
        kind: "index"
    },
    {
        from: "Account",
        to: "Trip",
        fkField: "accountId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Cruise",
        to: "Trip",
        fkField: "cruiseId",
        optional: false,
        canonical: true,
        kind: "owner"
    },
    {
        from: "Ship",
        to: "Trip",
        fkField: "shipId",
        optional: false,
        canonical: false,
        kind: "index"
    },
    {
        from: "Account",
        to: "User",
        fkField: "accountId",
        optional: true,
        canonical: false,
        kind: "owner"
    }
];


const $dce9b2b6397c0cdf$export$53ef2968ade38754 = (0, $d020ac6bb9bbb2b1$export$3e48762ecc26ade4).map((edge)=>({
        from: edge.from,
        to: edge.to,
        fkField: edge.fkField,
        canonical: edge.kind === "owner" || edge.canonical
    }));
const $dce9b2b6397c0cdf$export$e52cbeb16995b2b5 = new Set([
    "Account",
    "AccountUser",
    "DataRecord",
    "Note",
    "NoteAttachment",
    "ShipUser",
    "Status",
    "User"
]);
const $dce9b2b6397c0cdf$var$logbookSoftDeleteFields = Object.fromEntries(Array.from($dce9b2b6397c0cdf$export$e52cbeb16995b2b5, (type)=>[
        type,
        "deletedAt"
    ]));
const $dce9b2b6397c0cdf$export$eda54e0dfd836989 = {
    edges: $dce9b2b6397c0cdf$export$53ef2968ade38754,
    softDeleteFields: $dce9b2b6397c0cdf$var$logbookSoftDeleteFields
};
function $dce9b2b6397c0cdf$export$df392344a67abe9b(rows) {
    return (0, $bcf0a4ee4a28a2dd$export$df392344a67abe9b)(rows);
}
function $dce9b2b6397c0cdf$export$7da07ced8fa2b227(ids) {
    return (0, $bcf0a4ee4a28a2dd$export$7da07ced8fa2b227)(ids);
}
function $dce9b2b6397c0cdf$export$6e36bbf7bc18dcd9(type) {
    return (0, $29278580678edd79$export$6e36bbf7bc18dcd9)(type, $dce9b2b6397c0cdf$export$53ef2968ade38754);
}
function $dce9b2b6397c0cdf$export$7e1fad0eb118a24f(registry) {
    return registry;
}
function $dce9b2b6397c0cdf$export$4741711f07dbb8e7(registry) {
    (0, $bcf0a4ee4a28a2dd$export$4741711f07dbb8e7)($dce9b2b6397c0cdf$export$7e1fad0eb118a24f(registry), $dce9b2b6397c0cdf$export$eda54e0dfd836989);
}
// The primary live token for an entity, when one exists. `Subscription` is keyed
// by name; the `token.type === type` guard keeps us to the entity's own primary
// token (skipping secondary tokens like `currentLog`) and yields `[]` for the
// four entities with no broadcast (AccountSubscriptionPlan* / AuditLogEdit).
function $dce9b2b6397c0cdf$var$defaultLive(type) {
    const token = (0, $1bedde6805bf6e79$export$f55210826850c514)[type];
    return token && token.type === type ? [
        token
    ] : [];
}
function $dce9b2b6397c0cdf$export$4b5127edceda427d(type, overrides = {}) {
    var _a;
    return (0, $bcf0a4ee4a28a2dd$export$6ee185c108fef82f)(type, $dce9b2b6397c0cdf$export$eda54e0dfd836989, Object.assign(Object.assign({}, overrides), {
        live: (_a = overrides.live) !== null && _a !== void 0 ? _a : $dce9b2b6397c0cdf$var$defaultLive(type)
    }));
}


function $23aa8d5aa29fb8fb$export$15d6c24ad7a4b165(user) {
    return Object.assign(Object.assign({}, user), {
        id: user.userId
    });
}
const $23aa8d5aa29fb8fb$export$76325f8e6fcc7483 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("AccountUser", {
    fetch: (client, { accountId: accountId })=>{
        if (accountId === undefined) return Promise.reject(new Error("AccountUser fetch requires accountId"));
        return new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(client).account.users({
            params: {}
        }).call().then((response)=>{
            const accountUserInfo = Object.fromEntries(response.users.map((info)=>[
                    info.user.id,
                    {
                        status: info.status,
                        hasShipAccess: info.hasShipAccess
                    }
                ]));
            return {
                entities: {
                    AccountUser: response.users.map((info)=>$23aa8d5aa29fb8fb$export$15d6c24ad7a4b165({
                            accountId: accountId,
                            userId: info.user.id,
                            accountLevel: info.level
                        })),
                    User: response.users.map((info)=>{
                        var _a;
                        return Object.assign(Object.assign({}, info.user), {
                            accountId: (_a = info.user.accountId) !== null && _a !== void 0 ? _a : accountId
                        });
                    })
                },
                extras: {
                    accountUserInfo: accountUserInfo
                },
                partial: [
                    "AccountUser",
                    "User"
                ],
                authoritative: {
                    AccountUser: {
                        accountId: accountId
                    },
                    User: {
                        accountId: accountId
                    }
                }
            };
        });
    },
    normalize: $23aa8d5aa29fb8fb$export$15d6c24ad7a4b165
});


function $73eea1fea92cc6a5$export$79764cf71b00e905(response) {
    const { session: session } = response;
    const account = response.account;
    const accountId = session.accountId;
    const userId = session.userId;
    const accountUser = session.authorized && response.type === (0, $a8c48887e141e972$export$9fd99c4c3c179cff).cloud && accountId !== undefined && userId !== undefined && response.accountUserLevel !== undefined ? (0, $23aa8d5aa29fb8fb$export$15d6c24ad7a4b165)({
        accountId: accountId,
        userId: userId,
        accountLevel: response.accountUserLevel
    }) : undefined;
    const accounts = session.authorized && account !== undefined && account.id === accountId ? [
        account
    ] : [];
    return {
        entities: {
            Account: accounts,
            AccountUser: accountUser ? [
                accountUser
            ] : []
        },
        authoritative: accountId === undefined || userId === undefined ? undefined : {
            AccountUser: {
                accountId: accountId,
                userId: userId
            }
        }
    };
}
function $73eea1fea92cc6a5$export$fc07fe94f5a41790(session, type, target) {
    var _a, _b, _c;
    if (!(session === null || session === void 0 ? void 0 : session.authorized)) return `${target}:unauthorized`;
    return [
        target,
        type !== null && type !== void 0 ? type : "unknown",
        (_a = session.id) !== null && _a !== void 0 ? _a : "no-session-id",
        (_b = session.accountId) !== null && _b !== void 0 ? _b : "no-account",
        (_c = session.userId) !== null && _c !== void 0 ? _c : "no-user"
    ].join(":");
}




var $acw62 = parcelRequire("acw62");
var $e526ab01856b39b2$var$useIsomorphicLayoutEffect = typeof window === "undefined" ? (0, $acw62.useEffect) : (0, $acw62.useLayoutEffect);
function $e526ab01856b39b2$export$9ad3e25dc32420c8(client, type, callback) {
    var savedCallback = (0, $acw62.useRef)(callback);
    $e526ab01856b39b2$var$useIsomorphicLayoutEffect(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(function() {
        var token = client.subscribe(type, function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return savedCallback.current.apply(savedCallback, args);
        });
        return function() {
            return client.unsubscribe(type, token);
        };
    }, [
        client,
        type
    ]);
}


function $5f6ddaa19700549d$export$368b4214baeb914c(callback, token) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    (0, $e526ab01856b39b2$export$9ad3e25dc32420c8)(app.socket, token.type, callback);
}
function $5f6ddaa19700549d$export$e614dc9140f7ae71(app, type, data, info) {
    app.socket.trigger(type, data, info || "trigger");
}
function $5f6ddaa19700549d$export$cb4e378d7d3467ee(callback) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    (0, $e526ab01856b39b2$export$9ad3e25dc32420c8)(app.socket, "socket", (connected, _type, event)=>callback(connected, event));
}








var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");




function $09fff092c765f062$export$4c288ea8cff73213({ className: className, html: html, message: message, replace: replace, links: links }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const text = (0, $acw62.useMemo)(()=>{
        var _a;
        const messages = (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).Messages[app.language] || {};
        const md = (0, $0d15360f132ce1e2$export$2e2bcd8739ae039)({
            html: html || false
        });
        const defaultLinkOpen = (_a = md.renderer.rules.link_open) !== null && _a !== void 0 ? _a : (tokens, index, options, _environment, self)=>self.renderToken(tokens, index, options);
        md.renderer.rules.link_open = (tokens, index, options, environment, self)=>{
            var _a, _b;
            const token = tokens[index];
            const name = token.attrGet("href");
            if (name && links && Object.hasOwn(links, name)) {
                const href = links[name];
                if (href !== undefined) {
                    if (!md.validateLink(href)) throw new Error("Invalid localized link destination");
                    token.attrSet("href", href);
                    token.attrSet("target", "_blank");
                    token.attrSet("rel", "noopener noreferrer");
                } else {
                    token.attrs = (_b = (_a = token.attrs) === null || _a === void 0 ? void 0 : _a.filter(([name])=>name !== "href")) !== null && _b !== void 0 ? _b : [];
                    token.attrSet("role", "link");
                    token.attrSet("aria-disabled", "true");
                    token.attrSet("tabindex", "-1");
                }
            }
            return defaultLinkOpen(tokens, index, options, environment, self);
        };
        const text = (0, $0258f51bf6f9f9d6$export$716a56fcc9fe5dff)(message(messages) || "", replace);
        return md.render(text);
    }, [
        message,
        app.language,
        html,
        replace,
        links
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "LocalizedMessage",
            className
        ]),
        dangerouslySetInnerHTML: {
            __html: text
        }
    });
}



function $d0002a37f25cb62c$export$7b903090de9cebe9({ connected: connected }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const [disconnected, setDisconnected] = (0, $acw62.useState)(false);
    // Latched alongside `disconnected`: once the connection has come back at least
    // once, the reload action stays available even if the socket drops again (#558).
    // The socket flaps while the server -- or, on a native device, the shell this
    // very disconnect asked to restart (`AppView`'s socket subscription) -- comes
    // back up: it opens, then closes again a few hundred ms later. A reload gate
    // following that flag live means a user tapping the just-enabled button either
    // taps a button React has already re-rendered as `disabled` (the browser never
    // dispatches the click at all) or has the reload swallowed by a second check
    // inside the handler -- both look exactly like "the button does nothing", while
    // a plain browser refresh always works.
    const [reloadable, setReloadable] = (0, $acw62.useState)(false);
    const [reloading, setReloading] = (0, $acw62.useState)(false);
    const t = app.getT("AppDisconnectedView");
    (0, $acw62.useEffect)(()=>{
        if (!connected) setDisconnected(true);
        else setReloadable(true);
    }, [
        connected
    ]);
    // The reloading state is only feedback for the click -- a real reload takes the
    // whole document with it. If it somehow doesn't take (which is the very failure
    // this issue is about), re-offer the button instead of leaving the user with a
    // permanently disabled one: this overlay has no other way out.
    (0, $acw62.useEffect)(()=>{
        if (!reloading) return;
        const timer = window.setTimeout(()=>setReloading(false), 5000);
        return ()=>window.clearTimeout(timer);
    }, [
        reloading
    ]);
    if (!disconnected || app.cloudSession()) return;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        closeCallback: (0, $cb0532ed9be7da24$export$666a1c84dcdd038f),
        hideClose: true,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$fe53879cede8fc3), {
                style: "alarm",
                title: t("connection_overlay_title")
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                className: "Overlay-body",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                message: (m)=>connected ? m.connection.recovered : m.connection.interrupted
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            actions: true,
                            children: [
                                app.localSession() && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button",
                                        onClick: ()=>{
                                            app.logout(false);
                                        },
                                        children: t("disconnect_companion")
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        disabled: !reloadable || reloading,
                                        className: "button default",
                                        onClick: ()=>{
                                            // Unconditional: the click itself is the user's decision to reload,
                                            // and re-checking the live connection here is what made the button
                                            // dead in the flapping case above. A reload is served over plain
                                            // HTTP and is the guaranteed way out of this overlay.
                                            setReloading(true);
                                            window.location.reload();
                                        },
                                        children: reloading ? t("connection_overlay_reloading") : t("connection_overlay_reload")
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $16a667a1dff2bda2$export$37d3279522fbf5e2;
(function(AppRoutes) {
    AppRoutes["ship"] = "ship";
    AppRoutes["newShip"] = "newShip";
    AppRoutes["launchShip"] = "launchShip";
    AppRoutes["importShip"] = "importShip";
    AppRoutes["accountSettings"] = "accountSettings";
    AppRoutes["accountSubscription"] = "accountSubscription";
    AppRoutes["accountSubscriptionComplete"] = "accountSubscriptionComplete";
    AppRoutes["signup"] = "signup";
    AppRoutes["launch"] = "launch";
    AppRoutes["index"] = "index";
    AppRoutes["unknown"] = "unknown";
})($16a667a1dff2bda2$export$37d3279522fbf5e2 || ($16a667a1dff2bda2$export$37d3279522fbf5e2 = {}));
const $16a667a1dff2bda2$export$1661debf77b71e2c = {
    [$16a667a1dff2bda2$export$37d3279522fbf5e2.newShip]: {
        path: [
            "ships",
            "new"
        ]
    },
    [$16a667a1dff2bda2$export$37d3279522fbf5e2.launchShip]: {
        path: [
            "ships",
            ":shipId",
            "launch"
        ],
        params: {
            shipId: (0, $37879d0e39841979$export$7c42f1177a9c311).number,
            shipRoute: (0, $37879d0e39841979$export$7c42f1177a9c311).route
        }
    },
    [$16a667a1dff2bda2$export$37d3279522fbf5e2.ship]: {
        path: [
            "ships",
            ":shipId",
            "*shipRoute"
        ],
        params: {
            shipId: (0, $37879d0e39841979$export$7c42f1177a9c311).number,
            shipRoute: (0, $37879d0e39841979$export$7c42f1177a9c311).route
        }
    },
    [$16a667a1dff2bda2$export$37d3279522fbf5e2.importShip]: {
        path: [
            "ships",
            "import"
        ]
    },
    [$16a667a1dff2bda2$export$37d3279522fbf5e2.accountSettings]: {
        path: [
            "account"
        ]
    },
    [$16a667a1dff2bda2$export$37d3279522fbf5e2.accountSubscription]: {
        path: [
            "account",
            "subscription"
        ]
    },
    [$16a667a1dff2bda2$export$37d3279522fbf5e2.accountSubscriptionComplete]: {
        path: [
            "account",
            "subscription",
            "complete",
            ":sessionId"
        ],
        params: {
            sessionId: (0, $37879d0e39841979$export$7c42f1177a9c311).string
        }
    },
    [$16a667a1dff2bda2$export$37d3279522fbf5e2.signup]: {
        path: [
            "signup"
        ]
    },
    [$16a667a1dff2bda2$export$37d3279522fbf5e2.launch]: {
        path: [
            "launch"
        ]
    },
    [$16a667a1dff2bda2$export$37d3279522fbf5e2.index]: {
        path: []
    },
    [$16a667a1dff2bda2$export$37d3279522fbf5e2.unknown]: {
        path: [
            "*"
        ],
        navigate: [
            "not_found"
        ]
    }
};




var $acw62 = parcelRequire("acw62");
function $5cdac83ab505705b$export$1a6a959df6aea4fa(name = "ViewContext") {
    const dependencyContext = (0, $736b3300c1bfc0c7$export$63e8bf8ba447cd7a)(name);
    return {
        Context: dependencyContext.Context,
        useGet: ()=>(0, $acw62.useContext)(dependencyContext.Context)
    };
}






const $d96ebf18a3a82ea8$export$62231c592686b3e3 = {
    loadShips (api) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.list({
            params: {}
        }).call();
    },
    closeShip (api, shipId) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.select({
            params: {
                shipId: shipId
            },
            body: {
                close: true
            }
        }).call();
    },
    loadShip (api, shipId) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.get({
            params: {
                shipId: shipId
            }
        }).call();
    },
    // The app's live sync status, or `undefined` when it could not be read. Used by
    // the ship-load retry to tell "the app is still populating the local DB" from "the
    // ship really will not load" -- a distinction only the app itself can make, and one
    // the failure it answers with (503) does not carry.
    //
    // Read live rather than from `app.status`: selecting a ship restarts the app
    // instance, so the socket that pushes status broadcasts is commonly reconnecting
    // during exactly this window, leaving the cached snapshot stale or absent. The
    // status route is ungated (`Routes.swift`) and answers throughout. A failure is
    // absorbed: an unreadable status must never be mistaken for "still syncing", which
    // would wait forever.
    async syncStatus (app) {
        var _a, _b;
        try {
            return (_b = (_a = await app.updateStatus()) === null || _a === void 0 ? void 0 : _a.sync) === null || _b === void 0 ? void 0 : _b.status;
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("sync status read failed", error);
            return undefined;
        }
    },
    // Human-readable device label for display (Settings/About). Delegates platform
    // detection to the single App/Platform helper; cloud/browser sessions have no
    // native device label.
    platform (cloudSession, appStyles) {
        if (cloudSession) return undefined;
        switch((0, $fe1fa5963413bede$export$2dffd0b5373a4389).of({
            appStyles: appStyles
        })){
            case "windows":
                return "Windows";
            case "mac":
                return "macOS";
            case "ios":
                return "iPad";
            case "android":
                return "Android";
            default:
                return undefined;
        }
    },
    requireUserLevel (level, shipUser) {
        const requiredLevel = (0, $dc7739d612f0c536$export$fe876bf720d558fa)[level];
        if (requiredLevel === undefined) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Unknown user level " + level);
            return false;
        }
        if (!shipUser) return requiredLevel <= (0, $dc7739d612f0c536$export$fe876bf720d558fa).none;
        return shipUser.shipUserLevel >= requiredLevel;
    },
    subscriptionExpired (account) {
        return (0, $541a350025917a42$export$9e000f2ff091482)(account);
    },
    // Builds the ApiUser the generated `<Api>.<method>.available(user)` predicates check
    // against. `shipUser` is the currently open ship's crew record (freshest data, keyed by
    // its own `shipId` — NOT `app.shipId`, which is a local/native device binding that a cloud
    // session never populates, e.g. navigating straight to a ship URL); `membership` is the
    // per-ship level list from the ships-list response, used for any OTHER ship id (e.g.
    // account-level ship selector actions). `accountId`/`accountUserLevel` are the current user's
    // own account and their `accountUserLevel` (only ever populated by a cloud session — see
    // SessionResponse.accountUserLevel).
    apiUser (params) {
        return {
            accountLevel (accountId) {
                if (accountId != null && accountId !== params.accountId) return undefined;
                return params.accountUserLevel;
            },
            shipLevel (shipId) {
                var _a, _b, _c, _d, _e;
                const targetShipId = shipId !== null && shipId !== void 0 ? shipId : (_a = params.shipUser) === null || _a === void 0 ? void 0 : _a.shipId;
                if (targetShipId == null) return undefined;
                if (targetShipId === ((_b = params.shipUser) === null || _b === void 0 ? void 0 : _b.shipId)) return (_c = params.shipUser) === null || _c === void 0 ? void 0 : _c.shipUserLevel;
                return (_e = (_d = params.membership) === null || _d === void 0 ? void 0 : _d.find((m)=>m.shipId === targetShipId)) === null || _e === void 0 ? void 0 : _e.shipUserLevel;
            }
        };
    },
    // Combines a route's baseline `.available()` (editCurrent) with the `editAll`
    // escalation the server applies once a record's trip is historical — mirrors the
    // server's own two-step "baseline gate, then editAll if not current" pattern (e.g.
    // DayApi.update, NoteApi's attachment routes). See finding 4 / Phase F, #931: the
    // generated `.available()` alone only ever reflects the baseline editCurrent check.
    availableCurrentOrAll (apiUser, shipId, isCurrentTrip) {
        var _a;
        const requiredLevel = isCurrentTrip ? (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent : (0, $dc7739d612f0c536$export$fe876bf720d558fa).editAll;
        return ((_a = apiUser === null || apiUser === void 0 ? void 0 : apiUser.shipLevel(shipId)) !== null && _a !== void 0 ? _a : -1) >= requiredLevel;
    }
};
const $d96ebf18a3a82ea8$var$appViewContext = (0, $5cdac83ab505705b$export$1a6a959df6aea4fa)();
const $d96ebf18a3a82ea8$export$71e1586407c6a0f3 = $d96ebf18a3a82ea8$var$appViewContext.Context;
const $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b = $d96ebf18a3a82ea8$var$appViewContext.useGet;




var $acw62 = parcelRequire("acw62");








const $e3ce5d157f267f1e$export$ce62d50c977c6769 = {
    loadRelease (api) {
        return new (0, $5094ab6cf9038f1f$export$3565eb3d00ca5a74)(api).release.get({
            params: {}
        }).call();
    },
    // Changelog version keys are date strings; newest first.
    sortedVersions (changeLog) {
        return Object.keys(changeLog).toSorted().toReversed();
    },
    // A newer build exists when the reported available version sorts after the current one.
    newVersionAvailable (currentVersion, availableVersion) {
        return !!(availableVersion && currentVersion && currentVersion < availableVersion);
    },
    // The versions to render: everything when shown externally, otherwise only entries
    // newer than the last version the user has already seen.
    visibleVersions (versions, lastVersion, showExternal) {
        return versions.filter((v)=>!!showExternal || !lastVersion || Date.parse(v) > Date.parse(lastVersion));
    }
};
function $e3ce5d157f267f1e$export$d739bee7a05220bf({ platform: platform, showExternal: showExternal, onCloseExternal: onCloseExternal, changeLog: changeLogProp }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const companion = app.localSession();
    const [availableVersion, setAvailableVersion] = (0, $acw62.useState)(undefined);
    const [show, setShow] = (0, $acw62.useState)(false);
    const dismissed = (0, $acw62.useRef)(false);
    const [lastVersion, _setLastVersion] = (0, $acw62.useState)((0, $2b75519151ca9024$export$3f685a6e8b195eac)("logbook-version"));
    const t = app.getT("ChangeLogView");
    // The changelog is normally sourced from the localization bundle, which grows
    // with every release; callers (e.g. the catalog fixture) can inject a fixed,
    // bounded changelog so their rendering stays deterministic and doesn't drift.
    const changeLog = changeLogProp !== null && changeLogProp !== void 0 ? changeLogProp : (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).Messages[app.language].changeLog;
    const versions = (0, $acw62.useMemo)(()=>$e3ce5d157f267f1e$export$ce62d50c977c6769.sortedVersions(changeLog), []);
    const currentVersion = (0, $acw62.useMemo)(()=>versions[0], [
        versions
    ]);
    const newVersionAvailable = (0, $acw62.useMemo)(()=>$e3ce5d157f267f1e$export$ce62d50c977c6769.newVersionAvailable(currentVersion, availableVersion), [
        availableVersion,
        currentVersion
    ]);
    (0, $acw62.useEffect)(()=>{
        if (app.cloudSession()) return;
        if (!availableVersion) {
            const load = async ()=>{
                const release = await $e3ce5d157f267f1e$export$ce62d50c977c6769.loadRelease(app.apiClient);
                if (release && release.release && release.release.version) {
                    if (platform && release.release.platforms) {
                        const platformInfo = release.release.platforms.find((p)=>p.name === platform);
                        if (platformInfo) {
                            setAvailableVersion(platformInfo.date);
                            return;
                        }
                    }
                    setAvailableVersion(release.release.version);
                }
            };
            load().catch(console.error);
        }
    }, [
        availableVersion,
        platform
    ]);
    (0, $acw62.useEffect)(()=>{
        if (companion || dismissed.current) return;
        if (availableVersion && currentVersion < availableVersion) {
            setShow(true);
            localStorage.setItem("logbook-version", currentVersion);
        } else if (!lastVersion || lastVersion !== currentVersion) {
            setShow(true);
            localStorage.setItem("logbook-version", currentVersion);
        }
    }, [
        companion,
        lastVersion,
        currentVersion,
        availableVersion
    ]);
    (0, $acw62.useEffect)(()=>{
        if (showExternal) setShow(true);
    }, [
        showExternal
    ]);
    const changeLogs = (0, $acw62.useMemo)(()=>{
        return $e3ce5d157f267f1e$export$ce62d50c977c6769.visibleVersions(versions, lastVersion, showExternal).map((v)=>{
            const message = changeLog[v];
            return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)("h4", {
                            children: new Date(Date.parse(v)).toLocaleDateString()
                        })
                    }, `changelog-${v}`),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                            message: ()=>message,
                            html: true
                        })
                    })
                ]
            });
        });
    }, [
        versions,
        showExternal
    ]);
    if (!show) return null;
    const content = (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$fe53879cede8fc3), {
                title: t("change_log"),
                closeCallback: ()=>{
                    dismissed.current = true;
                    setShow(false);
                    if (onCloseExternal) onCloseExternal();
                }
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                className: "Overlay-body ChangeLogView ",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    className: "ChangeLogView-content",
                    children: [
                        newVersionAvailable && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "ChangeLogView-update-notice",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsxs)("a", {
                                    href: `https://logbook.yachts/site/${app.language}/download`,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            className: "ChangeLogView-update-icon",
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Refresh
                                        }),
                                        t("new_version_available", {
                                            version: availableVersion
                                        })
                                    ]
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: t("title")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h5", {
                                children: t("change_welcome", {
                                    version: app.t("LogbookApp_version_major")
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: t("change_fixed_info")
                            })
                        }),
                        changeLogs
                    ]
                })
            })
        ]
    });
    if (!showExternal) return (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        children: content
    });
    return content;
}


// AppHeaderView moved into Views/App/HeaderView.tsx. This thin re-export barrel keeps the
// original `./AppHeaderView` import path working for the demo app (LogbookContentView)
// that imports AppHeaderView outside the AppView hub.


var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $8a8193ceb042f538$export$ba657787b573294a() {
    var _a = (0, $acw62.useState)(), callbacks = _a[0], setCallbacks = _a[1];
    return {
        current: callbacks,
        set: setCallbacks
    };
}
function $8a8193ceb042f538$export$fc24143eb074d761(callbacks, refCallbacks) {
    (0, $acw62.useEffect)(function() {
        if (refCallbacks) {
            var value = callbacks();
            refCallbacks.set(value);
            refCallbacks.current = value;
        }
    }, []);
}






var $07fea78136a1afdb$export$1ec60d8b994d8569;
(function(MenuItemToggleState) {
    MenuItemToggleState[MenuItemToggleState["disabled"] = 1] = "disabled";
    MenuItemToggleState[MenuItemToggleState["on"] = 2] = "on";
    MenuItemToggleState[MenuItemToggleState["off"] = 3] = "off";
})($07fea78136a1afdb$export$1ec60d8b994d8569 || ($07fea78136a1afdb$export$1ec60d8b994d8569 = {}));
const $07fea78136a1afdb$export$2b6ac906eb59b21b = {
    divider: true,
    id: "divider"
};
const $07fea78136a1afdb$export$5b3c8d457d3cb424 = {
    id: ""
};
const $07fea78136a1afdb$export$9abd1e85c2faf332 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $07fea78136a1afdb$export$5ab5dd25b0ac9c41 = {
    menuLeftOffset (menuRight, viewportWidth, rightMargin = 30) {
        const limit = viewportWidth - rightMargin;
        if (menuRight > limit) {
            const overflow = menuRight - limit;
            return `${-overflow}px`;
        }
        return "0";
    },
    visibleItems (items) {
        return (items || []).filter((item)=>item.id != "");
    },
    isToggleOn (toggle) {
        return toggle == $07fea78136a1afdb$export$1ec60d8b994d8569.on;
    },
    isToggleDisabled (toggle) {
        return toggle == $07fea78136a1afdb$export$1ec60d8b994d8569.disabled;
    }
};
function $07fea78136a1afdb$export$d9b273488cd8ce6f({ button: button, buttonClass: buttonClass, callbacks: callbacks, children: children, disabled: disabled, global: global, initOpen: initOpen, items: items, onClick: onClick }) {
    const [selected, setSelected] = (0, $acw62.useState)(initOpen !== null && initOpen !== void 0 ? initOpen : false);
    const menuItemsRef = (0, $acw62.useRef)(null);
    const closeEnclosingMenu = (0, $acw62.useContext)($07fea78136a1afdb$export$9abd1e85c2faf332);
    // Only item activation propagates outwards: dismissing this menu through its own
    // overlay (tapping outside it) just backs out of the submenu, so the enclosing
    // surface has to stay open for another entry to be picked.
    const setItemMenuSelected = (0, $acw62.useCallback)((value)=>{
        setSelected(value);
        if (!value) closeEnclosingMenu === null || closeEnclosingMenu === void 0 || closeEnclosingMenu();
    }, [
        closeEnclosingMenu
    ]);
    (0, $8a8193ceb042f538$export$fc24143eb074d761)(()=>{
        return {
            setSelected: (value)=>{
                setSelected(value);
            }
        };
    }, callbacks);
    (0, $acw62.useEffect)(()=>{
        const updateMenuPosition = ()=>{
            if (selected && menuItemsRef.current) {
                // Measure the unshifted CSS position, not the previous resize's correction.
                menuItemsRef.current.style.left = "";
                const menuRect = menuItemsRef.current.getBoundingClientRect();
                menuItemsRef.current.style.left = $07fea78136a1afdb$export$5ab5dd25b0ac9c41.menuLeftOffset(menuRect.right, window.innerWidth);
            }
        };
        updateMenuPosition();
        // Listen to window resize and orientation changes
        window.addEventListener("resize", updateMenuPosition);
        window.addEventListener("orientationchange", updateMenuPosition);
        return ()=>{
            window.removeEventListener("resize", updateMenuPosition);
            window.removeEventListener("orientationchange", updateMenuPosition);
        };
    }, [
        selected
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Menu",
        children: [
            selected && global && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Menu-overlay",
                onClick: ()=>setSelected(false)
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Menu-items-container",
                children: selected && (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "Menu-items",
                    ref: menuItemsRef,
                    children: children ? children : $07fea78136a1afdb$export$5ab5dd25b0ac9c41.visibleItems(items).map((item, index)=>(0, $7b02d682eb115277$exports.jsx)($07fea78136a1afdb$export$2ce376c2cc3355c8, Object.assign({}, item, {
                            setMenuSelected: item.setMenuSelected || setItemMenuSelected
                        }), `item-${item.id}-${index}`))
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("button", {
                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                    "Menu-button",
                    selected && "selected",
                    buttonClass
                ]),
                disabled: disabled || false,
                onClick: (e)=>{
                    e.preventDefault();
                    if (disabled) return;
                    if (onClick) onClick(!selected);
                    setSelected(!selected);
                },
                children: button
            })
        ]
    });
}
function $07fea78136a1afdb$export$2ce376c2cc3355c8({ children: children, className: className, disabled: disabled, divider: divider, icon: icon, iconClass: iconClass, nonInteractive: nonInteractive, onClick: onClick, render: render, setMenuSelected: setMenuSelected, title: title, toggle: toggle }) {
    if (divider) return (0, $7b02d682eb115277$exports.jsx)($07fea78136a1afdb$export$dc41ded8bb6141d8, {});
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "Menu-item",
            disabled && "disabled",
            nonInteractive && "non-interactive",
            className
        ]),
        onClick: ()=>{
            if (disabled || nonInteractive) return;
            if (onClick && onClick() && setMenuSelected) setMenuSelected(false);
        },
        children: [
            icon && (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                className: iconClass,
                icon: icon
            }),
            title,
            render && render(),
            children,
            toggle && ($07fea78136a1afdb$export$5ab5dd25b0ac9c41.isToggleOn(toggle) ? (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "button-style",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).On1,
                        className: "toggle-button-left"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).On2,
                        className: "toggle-button-right"
                    })
                ]
            }) : (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                    "button-style",
                    $07fea78136a1afdb$export$5ab5dd25b0ac9c41.isToggleDisabled(toggle) && "disabled"
                ]),
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Off1,
                        className: "toggle-button-left"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Off2,
                        className: "toggle-button-right"
                    })
                ]
            }))
        ]
    });
}
function $07fea78136a1afdb$export$dc41ded8bb6141d8() {
    return (0, $7b02d682eb115277$exports.jsx)("hr", {
        className: "Menu-item-divider"
    });
}




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");
function $480db5fef2358c2d$export$1f628e93c0b28291(name) {
    const Context = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
    function useData() {
        const value = (0, $acw62.useContext)(Context);
        if (value === undefined) throw new Error(`useData for "${name}" was called outside its provider -- render the view's data-acquisition component (e.g. via withViewData) above it in the tree.`);
        return value;
    }
    return {
        Context: Context,
        useData: useData
    };
}
function $480db5fef2358c2d$export$ae24a3dd6105e285({ acquire: Acquire, ui: Ui }) {
    return function ViewDataView(props) {
        return (0, $7b02d682eb115277$exports.jsx)(Acquire, Object.assign({}, props, {
            children: (0, $7b02d682eb115277$exports.jsx)(Ui, Object.assign({}, props))
        }));
    };
}




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $872aa31e93f7b7c8$export$4ce6a4869f034b90;
(function(PrintMode) {
    PrintMode[PrintMode["none"] = 0] = "none";
    PrintMode[PrintMode["cruise"] = 1] = "cruise";
    PrintMode[PrintMode["trips"] = 2] = "trips";
    PrintMode[PrintMode["days"] = 3] = "days";
    PrintMode[PrintMode["ship"] = 4] = "ship";
})($872aa31e93f7b7c8$export$4ce6a4869f034b90 || ($872aa31e93f7b7c8$export$4ce6a4869f034b90 = {}));
var $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1;
(function(PrintContentKind) {
    PrintContentKind["none"] = "none";
    PrintContentKind["cruise"] = "cruise";
    PrintContentKind["cruiseFailed"] = "cruiseFailed";
    PrintContentKind["trips"] = "trips";
    PrintContentKind["tripsFailed"] = "tripsFailed";
    PrintContentKind["days"] = "days";
    PrintContentKind["daysFailed"] = "daysFailed";
    PrintContentKind["ship"] = "ship";
})($872aa31e93f7b7c8$export$1e9c6262d4b9a8d1 || ($872aa31e93f7b7c8$export$1e9c6262d4b9a8d1 = {}));
const $872aa31e93f7b7c8$export$f7060dad26921cd6 = "immutable-request-snapshot";
function $872aa31e93f7b7c8$export$4caba1eb391c1000(days) {
    // Zero is the undated next-day planning record, not a calendar date.
    return days.filter((day)=>day.day !== 0);
}
const $872aa31e93f7b7c8$export$2308c06cf1db77db = {
    loadCruise (api, shipId, cruiseId) {
        return new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(api).cruises.get({
            params: {
                shipId: shipId,
                cruiseId: cruiseId
            }
        }).call();
    },
    loadTrips (api, shipId, cruiseId) {
        return new (0, $84aa1a3b4df5a78b$export$5e13e029a186945f)(api).trips.list({
            params: {
                shipId: shipId,
                cruiseId: cruiseId
            }
        }).call();
    },
    loadCruiseTrack (api, shipId, cruiseId) {
        return new (0, $655725c259161537$export$2f8f7bdb7e386612)(api).tracks.cruise({
            params: {
                shipId: shipId,
                cruiseId: cruiseId
            }
        }).call();
    },
    loadTripDays (api, shipId, tripId) {
        return new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(api).days.list({
            params: {
                shipId: shipId,
                tripId: tripId
            }
        }).call();
    },
    loadTripTrack (api, shipId, tripId) {
        return new (0, $655725c259161537$export$2f8f7bdb7e386612)(api).tracks.trip({
            params: {
                shipId: shipId,
                tripId: tripId
            }
        }).call();
    },
    loadDayLogs (api, shipId, dayId) {
        return new (0, $199ead3c99f138be$export$89c3ec6dea3c6061)(api).logs.list({
            params: {
                shipId: shipId,
                dayId: dayId
            }
        }).call();
    },
    loadShipAttachments (api, shipId) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.attachments({
            params: {
                shipId: shipId
            }
        }).call();
    },
    contentKind (printMode, data) {
        if (!data) return $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1.none;
        switch(printMode){
            case $872aa31e93f7b7c8$export$4ce6a4869f034b90.cruise:
                return data.cruise ? $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1.cruise : $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1.cruiseFailed;
            case $872aa31e93f7b7c8$export$4ce6a4869f034b90.trips:
                return data.trips && data.trips.length > 0 ? $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1.trips : $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1.tripsFailed;
            case $872aa31e93f7b7c8$export$4ce6a4869f034b90.days:
                return data.days && $872aa31e93f7b7c8$export$4caba1eb391c1000(data.days).length > 0 ? $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1.days : $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1.daysFailed;
            case $872aa31e93f7b7c8$export$4ce6a4869f034b90.ship:
                return $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1.ship;
            default:
                return $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1.none;
        }
    }
};
var $872aa31e93f7b7c8$export$20c941d241cbcd74;
(function(TripListType) {
    TripListType[TripListType["short"] = 1] = "short";
    TripListType[TripListType["details"] = 2] = "details";
})($872aa31e93f7b7c8$export$20c941d241cbcd74 || ($872aa31e93f7b7c8$export$20c941d241cbcd74 = {}));
var $872aa31e93f7b7c8$export$512aa893c9e7d615;
(function(DayListType) {
    DayListType[DayListType["short"] = 1] = "short";
    DayListType[DayListType["details"] = 2] = "details";
})($872aa31e93f7b7c8$export$512aa893c9e7d615 || ($872aa31e93f7b7c8$export$512aa893c9e7d615 = {}));
const $872aa31e93f7b7c8$var$printViewContext = (0, $5cdac83ab505705b$export$1a6a959df6aea4fa)();
const $872aa31e93f7b7c8$export$ea540162690f0605 = $872aa31e93f7b7c8$var$printViewContext.Context;
const $872aa31e93f7b7c8$export$f3bba5f1f646e703 = $872aa31e93f7b7c8$var$printViewContext.useGet;
const $872aa31e93f7b7c8$export$ea13d8db95f96086 = ()=>{
    const context = (0, $acw62.useContext)($872aa31e93f7b7c8$export$ea540162690f0605);
    return context ? context.data : undefined;
};








function $34b30b1a8e331e95$export$678a3d30f85646bd(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const shipView = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const t = app.getT("PrintHeaderView");
    const vesselType = ship.vesselType === (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).sailing ? t("sailing") : t("motor");
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: "PrintHeaderView",
        children: (0, $7b02d682eb115277$exports.jsx)("h1", {
            children: t("title", {
                view: t(`print_${shipView.printMode}`),
                ship: `${vesselType} ${ship.name}`
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
function $51cc312cf1408924$export$f24bdf120ad0e590() {
    var _a = (0, $acw62.useState)(false), edited = _a[0], setEdited = _a[1];
    var onEdited = (0, $acw62.useCallback)(function() {
        return setEdited(true);
    }, []);
    var resetEdited = (0, $acw62.useCallback)(function() {
        return setEdited(false);
    }, []);
    return [
        edited,
        onEdited,
        resetEdited
    ];
}









const $ee4e6412241ac623$export$bcad3f41ace9b0b5 = {
    loadTrips (api, shipId, cruiseId) {
        return new (0, $84aa1a3b4df5a78b$export$5e13e029a186945f)(api).trips.list({
            params: {
                shipId: shipId,
                cruiseId: cruiseId
            }
        }).call();
    },
    loadDays (api, shipId, tripId) {
        return new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(api).days.list({
            params: {
                shipId: shipId,
                tripId: tripId
            }
        }).call();
    },
    sortTrips (trips) {
        return trips.toSorted((a, b)=>a.id - b.id);
    },
    sortDays (days) {
        return days.toSorted((a, b)=>a.day - b.day);
    },
    initialTripId (sortedTrips, tripId) {
        if (sortedTrips.length === 0) return undefined;
        return tripId !== undefined ? tripId : sortedTrips[0].id;
    },
    parseTripId (value) {
        const tripId = parseInt(value, 10);
        return isNaN(tripId) ? undefined : tripId;
    }
};
function $ee4e6412241ac623$export$b63d5cacf60be47e({ tripId: tripId, onClose: onClose }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const context = (0, $872aa31e93f7b7c8$export$f3bba5f1f646e703)();
    const contextShip = (0, $97ac05743b787a86$export$aa22615308ad52a0)();
    const shipView = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const t = app.getT("PrintSettingsView");
    const td = app.getT("DayView_tab");
    const tp = app.getT("PrintView");
    const { printRoot: printRoot, printMode: printMode } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const [_edited, onEdited, _resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const [_trips, setTrips] = (0, $acw62.useState)(undefined);
    const [selectedTripId, setSelectedTripId] = (0, $acw62.useState)(tripId);
    const [_days, setDays] = (0, $acw62.useState)(undefined);
    const printAction = (0, $acw62.useCallback)(()=>{
        (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).print(app);
    }, [
        app
    ]);
    const cruise = (0, $acw62.useMemo)(()=>{
        return printRoot;
    }, [
        printRoot
    ]);
    (0, $acw62.useEffect)(()=>{
        const load = async ()=>{
            if (!cruise) return;
            const data = await $ee4e6412241ac623$export$bcad3f41ace9b0b5.loadTrips(app.apiClient, ship.id, cruise.id);
            if (data.trips) {
                const sortedTrips = $ee4e6412241ac623$export$bcad3f41ace9b0b5.sortTrips(data.trips);
                setTrips(sortedTrips);
                // Auto-select first trip if available
                const initial = $ee4e6412241ac623$export$bcad3f41ace9b0b5.initialTripId(sortedTrips, tripId);
                if (initial !== undefined) setSelectedTripId(initial);
            }
        };
        load().catch(console.error);
    }, [
        cruise,
        ship
    ]);
    // Load days when a trip is selected
    (0, $acw62.useEffect)(()=>{
        const loadDays = async ()=>{
            if (!selectedTripId) {
                setDays(undefined);
                return;
            }
            const data = await $ee4e6412241ac623$export$bcad3f41ace9b0b5.loadDays(app.apiClient, ship.id, selectedTripId);
            if (data.days) setDays($ee4e6412241ac623$export$bcad3f41ace9b0b5.sortDays(data.days));
        };
        loadDays().catch(console.error);
    }, [
        selectedTripId,
        ship
    ]);
    const _handleTripChange = (0, $acw62.useCallback)((event)=>{
        const tripId = $ee4e6412241ac623$export$bcad3f41ace9b0b5.parseTripId(event.target.value);
        if (tripId !== undefined) setSelectedTripId(tripId);
        onEdited();
    }, [
        onEdited
    ]);
    // const [settings, setSettings] = useState<IPrintSettings | undefined>(undefined);
    // const onEditEvent = useCallback((event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    //   onEdited();
    // }, [onEdited]);
    // const save = useCallback(async (data: FormData, values: EditGroupData) => {
    //   await saveData(values);
    //   resetEdited();
    // }, []);
    const namePrefix = "printSettings";
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "PrintSettingsView ",
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
            className: "",
            hideBackground: true,
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$fe53879cede8fc3), {
                    title: t("title")
                }),
                (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "Overlay-body Overlay-flex",
                    children: [
                        printMode === (0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).cruise && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                            className: "",
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                className: "",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            children: t("cruise")
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-top-level-select",
                                        children: t("cruise_current")
                                    })
                                ]
                            })
                        }),
                        printMode === (0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).trips && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                            className: "",
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                className: "",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            children: t("trips")
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-checkboxes",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("trips_summary"),
                                            labelAfter: true,
                                            labelFor: `trips_summary`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                name: `${namePrefix}.trips_summary`,
                                                checked: context.includeTripData,
                                                onChange: ()=>context.setIncludeTripData(!context.includeTripData)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-radio-button",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("trips_summary_short"),
                                            labelAfter: true,
                                            labelFor: `trips_summary_short`,
                                            className: "bigger",
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "radio",
                                                name: `${namePrefix}.trips_select`,
                                                checked: context.includeTripDayListType == (0, $872aa31e93f7b7c8$export$20c941d241cbcd74).short,
                                                onChange: ()=>context.setIncludeTripDayListType((0, $872aa31e93f7b7c8$export$20c941d241cbcd74).short)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-radio-button block-row-radio-button-last",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("trips_summary_details"),
                                            labelAfter: true,
                                            labelFor: `trips_summary_details`,
                                            className: "bigger",
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "radio",
                                                name: `${namePrefix}.trips_select`,
                                                checked: context.includeTripDayListType == (0, $872aa31e93f7b7c8$export$20c941d241cbcd74).details,
                                                onChange: ()=>context.setIncludeTripDayListType((0, $872aa31e93f7b7c8$export$20c941d241cbcd74).details)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-checkboxes",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("journal_list"),
                                            labelAfter: true,
                                            labelFor: `journal`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                name: `${namePrefix}.journal`,
                                                checked: context.includeJournal,
                                                onChange: ()=>context.setIncludeJournal(!context.includeJournal)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-checkboxes",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("technical_list"),
                                            labelAfter: true,
                                            labelFor: `technical`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                name: `${namePrefix}.technical`,
                                                checked: context.includeTechnical,
                                                onChange: ()=>context.setIncludeTechnical(!context.includeTechnical)
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        printMode === (0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).days && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                            className: "",
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                className: "print-settings-days width-2cols",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            children: t("days")
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        children: t("days_text")
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-checkboxes",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: td("track"),
                                            labelAfter: true,
                                            labelFor: `track`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                name: `${namePrefix}.track`,
                                                checked: context.includeDayTrack,
                                                onChange: ()=>context.setIncludeDayTrack(!context.includeDayTrack)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-checkboxes",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: td("weather_forecast"),
                                            labelAfter: true,
                                            labelFor: `weather_forecast`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                name: `${namePrefix}.weather_forecast`,
                                                checked: context.includeDayForecast,
                                                onChange: ()=>context.setIncludeDayForecast(!context.includeDayForecast)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-checkboxes",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: td("journal") + t("thumbnails"),
                                            labelAfter: true,
                                            labelFor: `journal`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                name: `${namePrefix}.journal`,
                                                checked: context.includeDayJournal,
                                                onChange: ()=>context.setIncludeDayJournal(!context.includeDayJournal)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-checkboxes",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: td("technical") + t("thumbnails"),
                                            labelAfter: true,
                                            labelFor: `technical`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                name: `${namePrefix}.technical`,
                                                checked: context.includeDayTechnical,
                                                onChange: ()=>context.setIncludeDayTechnical(!context.includeDayTechnical)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-checkboxes",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: td("watches"),
                                            labelAfter: true,
                                            labelFor: `watches`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                name: `${namePrefix}.watches`,
                                                checked: context.includeDayWatchplan,
                                                onChange: ()=>context.setIncludeDayWatchplan(!context.includeDayWatchplan)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {}),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-checkboxes",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("entries"),
                                            labelAfter: true,
                                            labelFor: `entries`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                name: `${namePrefix}.entries`,
                                                checked: context.includeLogs,
                                                onChange: ()=>context.setIncludeLogs(!context.includeLogs)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-radio-button bigger",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("entries_summary"),
                                            labelAfter: true,
                                            labelFor: `entries_summary`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "radio",
                                                name: `${namePrefix}.log_options`,
                                                checked: context.includeDayLogListType == (0, $872aa31e93f7b7c8$export$512aa893c9e7d615).short,
                                                onChange: ()=>context.setIncludeDayLogListType((0, $872aa31e93f7b7c8$export$512aa893c9e7d615).short)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-radio-button bigger",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("entries_details"),
                                            labelAfter: true,
                                            labelFor: `entries_details`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "radio",
                                                name: `${namePrefix}.log_options`,
                                                checked: context.includeDayLogListType == (0, $872aa31e93f7b7c8$export$512aa893c9e7d615).details,
                                                onChange: ()=>context.setIncludeDayLogListType((0, $872aa31e93f7b7c8$export$512aa893c9e7d615).details)
                                            })
                                        })
                                    }),
                                    context.includeDayLogListType == (0, $872aa31e93f7b7c8$export$512aa893c9e7d615).details && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-checkboxes",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("edits"),
                                            labelAfter: true,
                                            labelFor: `edits`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                name: `${namePrefix}.edits`,
                                                checked: context.includeEdits,
                                                onChange: ()=>context.setIncludeEdits(!context.includeEdits)
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        printMode === (0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).ship && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                            className: "",
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                className: "print-settings-ship",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            children: t("ship")
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-radio-button",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("ship_short"),
                                            labelAfter: true,
                                            labelFor: `ship_short`,
                                            className: "bigger",
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "radio",
                                                name: `${namePrefix}.ship_select`,
                                                checked: contextShip.includeShipDataType == (0, $97ac05743b787a86$export$bf37da5ca7e88dda).short,
                                                onChange: ()=>contextShip.setIncludeShipDataType((0, $97ac05743b787a86$export$bf37da5ca7e88dda).short)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-radio-button",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("ship_details"),
                                            labelAfter: true,
                                            labelFor: `ship_details`,
                                            className: "bigger",
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "radio",
                                                name: `${namePrefix}.ship_select`,
                                                checked: contextShip.includeShipDataType == (0, $97ac05743b787a86$export$bf37da5ca7e88dda).details,
                                                onChange: ()=>contextShip.setIncludeShipDataType((0, $97ac05743b787a86$export$bf37da5ca7e88dda).details)
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {}),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-checkboxes",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("user_list"),
                                            labelAfter: true,
                                            labelFor: `user_list`,
                                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                name: `${namePrefix}.user_list`,
                                                checked: contextShip.includeUserList,
                                                onChange: ()=>contextShip.setIncludeUserList(!contextShip.includeUserList)
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "button-row",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button",
                                    onClick: ()=>{
                                        shipView.setPrinting((0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).none, undefined);
                                        onClose === null || onClose === void 0 || onClose();
                                    },
                                    children: tp("print_cancel")
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button default",
                                    onClick: ()=>printAction(),
                                    children: tp("print_action")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}







var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $c4349977e33cccc7$export$a080ff44e8067a44(instance, context, container) {
    return Object.freeze({
        instance: instance,
        context: context,
        container: container
    });
}
function $c4349977e33cccc7$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        const elementRef = (0, $acw62.useRef)(undefined);
        if (!elementRef.current) elementRef.current = createElement(props, context);
        return elementRef;
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $acw62.useRef)(undefined);
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0, $acw62.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $acw62.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            updateElement
        ]);
        return elementRef;
    };
}


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
const $cbd94c399cef41ea$export$b8efcc4bff45e15b = 1;
function $cbd94c399cef41ea$export$fb237fa819e17281(map) {
    return Object.freeze({
        __version: $cbd94c399cef41ea$export$b8efcc4bff45e15b,
        map: map
    });
}
function $cbd94c399cef41ea$export$9efaf186a2224858(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const $cbd94c399cef41ea$export$7de1b54b0142048f = (0, $acw62.createContext)(null);
function $cbd94c399cef41ea$export$ea59151b8430a4e9() {
    const context = (0, $acw62.use)($cbd94c399cef41ea$export$7de1b54b0142048f);
    if (context == null) throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    return context;
}


function $b5b5154e09abe911$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $acw62.useImperativeHandle)(forwardedRef, ()=>instance);
        const { children: children } = props;
        return children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cbd94c399cef41ea$export$7de1b54b0142048f), {
            value: context
        }, children);
    }
    return /*#__PURE__*/ (0, $acw62.forwardRef)(ContainerComponent);
}
function $b5b5154e09abe911$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0, $acw62.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $acw62.useImperativeHandle)(forwardedRef, ()=>instance);
        // biome-ignore lint/correctness/useExhaustiveDependencies: update overlay when children change
        (0, $acw62.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $1u0KT.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $acw62.forwardRef)(OverlayComponent);
}
function $b5b5154e09abe911$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance: instance } = useElement(props).current;
        (0, $acw62.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $acw62.forwardRef)(LeafComponent);
}



var $acw62 = parcelRequire("acw62");

function $1b63afa14c569d34$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $cbd94c399cef41ea$export$ea59151b8430a4e9)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $acw62.useRef)(props.position);
        const { position: position } = props;
        (0, $acw62.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $acw62.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}



var $acw62 = parcelRequire("acw62");
function $3ab6965f3c0b8e48$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $acw62.useRef)(attribution);
    (0, $acw62.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}




var $acw62 = parcelRequire("acw62");
function $7099e9dbf72f5596$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $acw62.useRef)(undefined);
    (0, $acw62.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}


function $32d90284a15401c8$export$6ee5d263358f5c0e(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}


function $36464a5b4c62d1dd$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $cbd94c399cef41ea$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $32d90284a15401c8$export$6ee5d263358f5c0e)(props, context), context);
        (0, $3ab6965f3c0b8e48$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $7099e9dbf72f5596$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}




var $acw62 = parcelRequire("acw62");




function $79b51af07cb34fe6$export$cd00a227f8cfb2c2(element, context) {
    (0, $acw62.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $79b51af07cb34fe6$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $cbd94c399cef41ea$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $32d90284a15401c8$export$6ee5d263358f5c0e)(props, context), context);
        (0, $3ab6965f3c0b8e48$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $7099e9dbf72f5596$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        $79b51af07cb34fe6$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}



var $acw62 = parcelRequire("acw62");




function $25da1ed181e98b0a$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $acw62.useRef)(undefined);
    (0, $acw62.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $25da1ed181e98b0a$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $cbd94c399cef41ea$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $32d90284a15401c8$export$6ee5d263358f5c0e)(props, context), context);
        (0, $7099e9dbf72f5596$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        (0, $79b51af07cb34fe6$export$cd00a227f8cfb2c2)(elementRef.current, context);
        $25da1ed181e98b0a$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}


function $26087237d6669ee9$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(createInstance(props), context);
    }
    const useElement = (0, $c4349977e33cccc7$export$2e66ec8a7fb1892f)(createElement);
    const useControl = (0, $1b63afa14c569d34$export$28d24ab3914549cd)(useElement);
    return (0, $b5b5154e09abe911$export$18af5c7a9e9b3664)(useControl);
}
function $26087237d6669ee9$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $c4349977e33cccc7$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $79b51af07cb34fe6$export$73f852c6a5abdefa)(useElement);
    return (0, $b5b5154e09abe911$export$96eac748c3f41e82)(useLayer);
}
function $26087237d6669ee9$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $c4349977e33cccc7$export$2e66ec8a7fb1892f)(createElement);
    const useOverlay = (0, $36464a5b4c62d1dd$export$d5eca53b0accc0e0)(useElement, useLifecycle);
    return (0, $b5b5154e09abe911$export$bc37ddc24ed05446)(useOverlay);
}
function $26087237d6669ee9$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $c4349977e33cccc7$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const usePath = (0, $25da1ed181e98b0a$export$5fea2fe6048fc3db)(useElement);
    return (0, $b5b5154e09abe911$export$96eac748c3f41e82)(usePath);
}
function $26087237d6669ee9$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $c4349977e33cccc7$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $79b51af07cb34fe6$export$73f852c6a5abdefa)(useElement);
    return (0, $b5b5154e09abe911$export$18af5c7a9e9b3664)(useLayer);
}

function $34ab36e170372dbb$export$1a9cf6eabf8106e(layer, props, prevProps) {
    if (props.center !== prevProps.center) layer.setLatLng(props.center);
    if (props.radius != null && props.radius !== prevProps.radius) layer.setRadius(props.radius);
}



var $8JYDX = parcelRequire("8JYDX");
const $e2549461480b0f46$export$c89a927ffc67e6fa = (0, $26087237d6669ee9$export$5e776dbe3c7d2790)(function createCircle({ center: center, children: _c, ...options }, ctx) {
    const circle = new (0, $8JYDX.Circle)(center, options);
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(circle, (0, $cbd94c399cef41ea$export$9efaf186a2224858)(ctx, {
        overlayContainer: circle
    }));
}, (0, $34ab36e170372dbb$export$1a9cf6eabf8106e));



var $8JYDX = parcelRequire("8JYDX");

var $acw62 = parcelRequire("acw62");
function $ee011fc978fcb926$var$MapContainerComponent({ bounds: bounds, boundsOptions: boundsOptions, center: center, children: children, className: className, id: id, placeholder: placeholder, style: style, whenReady: whenReady, zoom: zoom, ...options }, forwardedRef) {
    const [props] = (0, $acw62.useState)({
        className: className,
        id: id,
        style: style
    });
    const [context, setContext] = (0, $acw62.useState)(null);
    const mapInstanceRef = (0, $acw62.useRef)(undefined);
    (0, $acw62.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: ref callback
    const mapRef = (0, $acw62.useCallback)((node)=>{
        if (node !== null && !mapInstanceRef.current) {
            const map = new (0, $8JYDX.Map)(node, options);
            mapInstanceRef.current = map;
            if (center != null && zoom != null) map.setView(center, zoom);
            else if (bounds != null) map.fitBounds(bounds, boundsOptions);
            if (whenReady != null) map.whenReady(whenReady);
            setContext((0, $cbd94c399cef41ea$export$fb237fa819e17281)(map));
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cbd94c399cef41ea$export$7de1b54b0142048f), {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...props,
        ref: mapRef
    }, contents);
}
const $ee011fc978fcb926$export$23f3dfd47374502b = /*#__PURE__*/ (0, $acw62.forwardRef)($ee011fc978fcb926$var$MapContainerComponent);

function $94fa316de2622a09$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}



var $8JYDX = parcelRequire("8JYDX");
const $35109d75658c2839$export$f52ee31d61d0b27b = (0, $26087237d6669ee9$export$4f432c6de5c4ddb8)(function createTileLayer({ url: url, ...options }, context) {
    const layer = new (0, $8JYDX.TileLayer)(url, (0, $32d90284a15401c8$export$6ee5d263358f5c0e)(options, context));
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    (0, $94fa316de2622a09$export$b39104a5f1b9296f)(layer, props, prevProps);
    const { url: url } = props;
    if (url != null && url !== prevProps.url) layer.setUrl(url);
});



var $8JYDX = parcelRequire("8JYDX");
var $8f3afacbde02c2fb$exports = {};
"use strict";
var $8f3afacbde02c2fb$var$__importDefault = $8f3afacbde02c2fb$exports && $8f3afacbde02c2fb$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($8f3afacbde02c2fb$exports, "__esModule", {
    value: true
});


var $8f3afacbde02c2fb$var$leaflet_1 = $8f3afacbde02c2fb$var$__importDefault((parcelRequire("8JYDX")));
L.Control.ScaleNautic = L.Control.Scale.extend({
    options: {
        nautic: false
    },
    _addScales: function(options, className, container) {
        L.Control.Scale.prototype._addScales.call(this, options, className, container);
        L.setOptions(options);
        if (this.options.nautic) this._nScale = L.DomUtil.create('div', className, container);
    },
    _updateScales: function(maxMeters) {
        L.Control.Scale.prototype._updateScales.call(this, maxMeters);
        if (this.options.nautic && maxMeters) this._updateNautic(maxMeters);
    },
    _updateNautic: function(maxMeters) {
        var scale = this._nScale, maxNauticalMiles = maxMeters / 1852, nauticalMiles;
        if (maxMeters >= 1852) nauticalMiles = L.Control.Scale.prototype._getRoundNum.call(this, maxNauticalMiles);
        else nauticalMiles = maxNauticalMiles > 0.1 ? Math.round(maxNauticalMiles * 10) / 10 : Math.round(maxNauticalMiles * 100) / 100;
        scale.style.width = Math.round(this.options.maxWidth * (nauticalMiles / maxNauticalMiles)) - 10 + 'px';
        scale.innerHTML = nauticalMiles + ' nm';
    }
});
L.control.scalenautic = function(options) {
    return new L.Control.ScaleNautic(options);
};


var $8f3afacbde02c2fb$var$createScaleControl = function(props) {
    return new $8f3afacbde02c2fb$var$leaflet_1.default.Control.ScaleNautic(props);
};
$8f3afacbde02c2fb$exports.default = (0, $26087237d6669ee9$export$896a3ef451e396c4)($8f3afacbde02c2fb$var$createScaleControl);





var $8JYDX = parcelRequire("8JYDX");
/* jshint esversion: 6, -W008, -W030, -W083 */ // Generated from src/leaflet-maplibre-gl.mjs. Run `npm run build` to update.

var $8JYDX = parcelRequire("8JYDX");
/**
* MapLibre GL JS
* @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v6.9.1/LICENSE.txt
*/ 
var $1G0Uw = parcelRequire("1G0Uw");
var $4324d99ae8520741$var$Ar = `6.9.1`;
function $4324d99ae8520741$var$jr() {
    var e1 = new (0, $1G0Uw.Pi)(4);
    return (0, $1G0Uw.Pi) != Float32Array && (e1[1] = 0, e1[2] = 0), e1[0] = 1, e1[3] = 1, e1;
}
function $4324d99ae8520741$var$Mr(e1, t) {
    var n = t[0], r = t[1], i = t[2], a = t[3], o = n * a - i * r;
    return o ? (o = 1 / o, e1[0] = a * o, e1[1] = -r * o, e1[2] = -i * o, e1[3] = n * o, e1) : null;
}
function $4324d99ae8520741$var$Nr(e1) {
    return e1[0] * e1[3] - e1[2] * e1[1];
}
function $4324d99ae8520741$var$Pr(e1, t, n) {
    var r = t[0], i = t[1], a = t[2], o = t[3], s = Math.sin(n), c = Math.cos(n);
    return e1[0] = r * c + a * s, e1[1] = i * c + o * s, e1[2] = r * -s + a * c, e1[3] = i * -s + o * c, e1;
}
let $4324d99ae8520741$var$Fr, $4324d99ae8520741$var$Ir, $4324d99ae8520741$var$Lr;
const $4324d99ae8520741$var$Rr = {
    frame (e1, t, n, r) {
        let i = r || window, a = i.requestAnimationFrame((e1)=>{
            o(), t(e1);
        }), { unsubscribe: o } = (0, $1G0Uw.kr)(e1.signal, `abort`, ()=>{
            o(), i.cancelAnimationFrame(a), n(new (0, $1G0Uw.jn)(e1.signal.reason));
        }, !1);
    },
    frameAsync (e1, t) {
        return new Promise((n, r)=>{
            this.frame(e1, n, r, t);
        });
    },
    getImageData (e1, t = 0) {
        return this.getImageCanvasContext(e1).getImageData(-t, -t, e1.width + 2 * t, e1.height + 2 * t);
    },
    getImageCanvasContext (e1) {
        let t;
        if ((0, $1G0Uw.Ii)() && !(0, $1G0Uw.Fi)()) t = new OffscreenCanvas(e1.width, e1.height).getContext(`2d`, {
            willReadFrequently: !0
        });
        else {
            let n = window.document.createElement(`canvas`);
            n.width = e1.width, n.height = e1.height, t = n.getContext(`2d`, {
                willReadFrequently: !0
            });
        }
        if (!t) throw Error(`failed to create canvas 2d context`);
        return t.drawImage(e1, 0, 0, e1.width, e1.height), t;
    },
    resolveURL (e1) {
        return $4324d99ae8520741$var$Fr ||= document.createElement(`a`), $4324d99ae8520741$var$Fr.href = e1, $4324d99ae8520741$var$Fr.href;
    },
    get hardwareConcurrency () {
        return typeof navigator < `u` && navigator.hardwareConcurrency || 4;
    },
    get prefersReducedMotion () {
        return $4324d99ae8520741$var$Lr === void 0 ? matchMedia ? ($4324d99ae8520741$var$Ir ??= matchMedia(`(prefers-reduced-motion: reduce)`), $4324d99ae8520741$var$Ir.matches) : !1 : $4324d99ae8520741$var$Lr;
    },
    set prefersReducedMotion (e){
        $4324d99ae8520741$var$Lr = e;
    }
}, $4324d99ae8520741$var$zr = new class {
    constructor(){
        this._frozenAt = null;
    }
    getCurrentTime() {
        return this._frozenAt === null ? performance.now() : this._frozenAt;
    }
    setNow(e1) {
        this._frozenAt = e1;
    }
    restoreNow() {
        this._frozenAt = null;
    }
    isFrozen() {
        return this._frozenAt !== null;
    }
};
function $4324d99ae8520741$export$461939dd4422153() {
    return $4324d99ae8520741$var$zr.getCurrentTime();
}
function $4324d99ae8520741$export$6b09b4ca4892be7e(e1) {
    $4324d99ae8520741$var$zr.setNow(e1);
}
function $4324d99ae8520741$export$c893a3a0ea8f2422() {
    $4324d99ae8520741$var$zr.restoreNow();
}
function $4324d99ae8520741$export$b034adc12b1cc7ef() {
    return $4324d99ae8520741$var$zr.isFrozen();
}
var $4324d99ae8520741$var$G = class e1 {
    static{
        this.docStyle = typeof window < `u` && window.document?.documentElement.style;
    }
    static{
        this.selectProp = !e1.docStyle || `userSelect` in e1.docStyle ? `userSelect` : `webkitUserSelect`;
    }
    static create(e1, t, n) {
        let r = window.document.createElement(e1);
        return t !== void 0 && (r.className = t), n && n.appendChild(r), r;
    }
    static createNS(e1, t) {
        return window.document.createElementNS(e1, t);
    }
    static disableDrag() {
        e1.docStyle && e1.selectProp && (e1.userSelect = e1.docStyle[e1.selectProp], e1.docStyle[e1.selectProp] = `none`);
    }
    static enableDrag() {
        e1.docStyle && e1.selectProp && (e1.docStyle[e1.selectProp] = e1.userSelect);
    }
    static suppressClickInternal(t) {
        t.preventDefault(), t.stopPropagation(), window.removeEventListener(`click`, e1.suppressClickInternal, !0);
    }
    static suppressClick() {
        window.addEventListener(`click`, e1.suppressClickInternal, !0), window.setTimeout(()=>{
            window.removeEventListener(`click`, e1.suppressClickInternal, !0);
        }, 0);
    }
    static getScale(e1) {
        let t = e1.getBoundingClientRect();
        return {
            x: t.width / e1.offsetWidth || 1,
            y: t.height / e1.offsetHeight || 1,
            boundingClientRect: t
        };
    }
    static getPoint(e1, t, n) {
        let r = t.boundingClientRect;
        return new (0, $1G0Uw.Li)((n.clientX - r.left) / t.x - e1.clientLeft, (n.clientY - r.top) / t.y - e1.clientTop);
    }
    static mousePos(t, n) {
        let r = e1.getScale(t);
        return e1.getPoint(t, r, n);
    }
    static touchPos(t, n) {
        let r = [], i = e1.getScale(t);
        for (let a of n)r.push(e1.getPoint(t, i, a));
        return r;
    }
    static sanitize(t) {
        let n = new DOMParser().parseFromString(t, `text/html`).body || document.createElement(`body`), r = n.querySelectorAll(`script, iframe`);
        for (let e1 of r)e1.remove();
        return e1.clean(n), n.innerHTML;
    }
    static isPossiblyDangerous(e1, t) {
        let n = t.replace(/\s+/g, ``).toLowerCase();
        if ([
            `src`,
            `href`,
            `xlink:href`
        ].includes(e1) && (n.includes(`javascript:`) || n.includes(`data:`)) || e1 === `srcdoc` || e1.startsWith(`on`)) return !0;
    }
    static clean(t) {
        let n = t.children;
        for (let t of n)e1.removeAttributes(t), e1.clean(t);
    }
    static removeAttributes(t) {
        for (let { name: n, value: r } of Array.from(t.attributes))e1.isPossiblyDangerous(n, r) && t.removeAttribute(n);
    }
};
let $4324d99ae8520741$var$Ur;
(function(e1) {
    let t, n, r, i;
    e1.resetRequestQueue = ()=>{
        t = [], n = 0, r = 0, i = {};
    }, e1.addThrottleControl = (e1)=>{
        let t = r++;
        return i[t] = e1, t;
    }, e1.removeThrottleControl = (e1)=>{
        delete i[e1], u();
    };
    let a = ()=>{
        for (let e1 of Object.keys(i))if (i[e1]()) return !0;
        return !1;
    };
    async function s(e1, t, n, r, i = !0, a) {
        let o = await e1.transformRequest(t, n);
        return (0, $1G0Uw.Nn)(r.signal), $4324d99ae8520741$var$Ur.getImage(o, r, i, a);
    }
    e1.transformAndGetImage = s, e1.getImage = (e1, n, r = !0, i)=>new Promise((a, o)=>{
            e1.headers ||= {}, e1.headers.accept = `image/webp,*/*`, (0, $1G0Uw.er)(e1, {
                type: `image`
            });
            let s = {
                abortController: n,
                requestParameters: e1,
                supportImageRefresh: r,
                imageBitmapOptions: i,
                state: `queued`,
                onError: (e1)=>{
                    o(e1);
                },
                onSuccess: (e1)=>{
                    a(e1);
                }
            };
            t.push(s), u();
        });
    let c = (e1, t)=>typeof createImageBitmap == `function` ? (0, $1G0Uw.Rn)(e1, t) : (0, $1G0Uw.Ln)(e1), l = async (e1)=>{
        e1.state = `running`;
        let { requestParameters: t, supportImageRefresh: r, imageBitmapOptions: i, onError: a, onSuccess: o, abortController: s } = e1, l = r === !1 && !i && !(0, $1G0Uw.pr)(self) && !(0, $1G0Uw.On)(t.url) && (!t.headers || Object.keys(t.headers).reduce((e1, t)=>e1 && t === `accept`, !0));
        n++;
        let f = l ? d(t, s) : (0, $1G0Uw.Tn)(t, s);
        try {
            let t = await f;
            delete e1.abortController, e1.state = `completed`, t.data instanceof HTMLImageElement || (0, $1G0Uw.cr)(t.data) ? o(t) : !t.data || t.data.byteLength === 0 ? o({
                data: null,
                cacheControl: t.cacheControl,
                expires: t.expires
            }) : o({
                data: await c(t.data, i),
                cacheControl: t.cacheControl,
                expires: t.expires
            });
        } catch (t) {
            delete e1.abortController, a((0, $1G0Uw.Qn)(t));
        } finally{
            n--, u();
        }
    }, u = ()=>{
        let e1 = a() ? (0, $1G0Uw.An).MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : (0, $1G0Uw.An).MAX_PARALLEL_IMAGE_REQUESTS;
        for(let r = n; r < e1 && t.length > 0; r++){
            let e1 = t.shift();
            if (e1.abortController.signal.aborted) {
                r--;
                continue;
            }
            l(e1);
        }
    }, d = (e1, t)=>new Promise((n, r)=>{
            let i = new Image, a = e1.url, o = e1.credentials;
            o && o === `include` ? i.crossOrigin = `use-credentials` : (o && o === `same-origin` || !(0, $1G0Uw.En)(a)) && (i.crossOrigin = `anonymous`), t.signal.addEventListener(`abort`, ()=>{
                i.src = ``, r(new (0, $1G0Uw.jn)(t.signal.reason));
            }), i.fetchPriority = `high`, i.onload = ()=>{
                i.onerror = i.onload = null, n({
                    data: i
                });
            }, i.onerror = ()=>{
                i.onerror = i.onload = null, !t.signal.aborted && r(Error(`Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
            }, i.src = a;
        });
})($4324d99ae8520741$var$Ur ||= {}), $4324d99ae8520741$var$Ur.resetRequestQueue();
var $4324d99ae8520741$var$Wr = class {
    constructor(e1){
        this._transformRequestFn = e1 ?? null;
    }
    transformRequest(e1, t) {
        return this._transformRequestFn && this._transformRequestFn(e1, t) || {
            url: e1
        };
    }
    setTransformRequest(e1) {
        this._transformRequestFn = e1;
    }
}, $4324d99ae8520741$export$fc21b96c04d10d16 = class extends (0, $1G0Uw._n) {
}, $4324d99ae8520741$export$534b7a2acb0e16da = class extends $4324d99ae8520741$export$fc21b96c04d10d16 {
}, $4324d99ae8520741$export$444e55cd0e2f4f3a = class extends $4324d99ae8520741$export$fc21b96c04d10d16 {
    constructor(e1 = {}){
        super(`style.load`, e1);
    }
}, $4324d99ae8520741$export$49025a11e3fe5bd0 = class extends $4324d99ae8520741$export$fc21b96c04d10d16 {
    constructor(e1, t = {}){
        super(e1, t), this.dataType = `style`;
    }
}, $4324d99ae8520741$export$ae09c661b7a299b2 = class extends $4324d99ae8520741$export$fc21b96c04d10d16 {
    constructor(e1, t = {}){
        super(e1, t), this.dataType = `source`;
    }
}, $4324d99ae8520741$export$83f023c8e5acf676 = class extends $4324d99ae8520741$export$fc21b96c04d10d16 {
    preventDefault() {
        this._defaultPrevented = !0;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(e1, t, n, r = {}){
        n = n instanceof MouseEvent ? n : new MouseEvent(e1, n);
        let i = $4324d99ae8520741$var$G.mousePos(t.getCanvas(), n), a = t.unproject(i);
        super(e1, (0, $1G0Uw.er)({
            point: i,
            lngLat: a,
            originalEvent: n
        }, r)), this._defaultPrevented = !1, this.target = t;
    }
}, $4324d99ae8520741$export$706699378fec3ddd = class extends $4324d99ae8520741$export$fc21b96c04d10d16 {
    preventDefault() {
        this._defaultPrevented = !0;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(e1, t, n){
        let r = e1 === `touchend` ? n.changedTouches : n.touches, i = $4324d99ae8520741$var$G.touchPos(t.getCanvasContainer(), r), a = i.map((e1)=>t.unproject(e1)), o = i.reduce((e1, t, n, r)=>e1.add(t.div(r.length)), new (0, $1G0Uw.Li)(0, 0)), s = t.unproject(o);
        super(e1, {
            points: i,
            point: o,
            lngLats: a,
            lngLat: s,
            originalEvent: n
        }), this._defaultPrevented = !1;
    }
}, $4324d99ae8520741$export$10870e40d23509f = class extends $4324d99ae8520741$export$fc21b96c04d10d16 {
    preventDefault() {
        this._defaultPrevented = !0;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(e1, t){
        super(`wheel`, {
            originalEvent: t
        }), this._defaultPrevented = !1;
    }
}, $4324d99ae8520741$export$702e4d7a848278fa = class extends $4324d99ae8520741$export$fc21b96c04d10d16 {
}, $4324d99ae8520741$export$da1f2ab236a92d66 = class extends $4324d99ae8520741$export$fc21b96c04d10d16 {
    constructor(e1 = {}){
        super(`terrain`, e1);
    }
}, $4324d99ae8520741$export$f966cee55553279 = class extends $4324d99ae8520741$export$fc21b96c04d10d16 {
    constructor(e1 = {}){
        super(`projectiontransition`, e1);
    }
}, $4324d99ae8520741$export$3238995171e25bd5 = class extends $4324d99ae8520741$export$fc21b96c04d10d16 {
}, $4324d99ae8520741$export$14816c15d485a7b9 = class extends $4324d99ae8520741$export$fc21b96c04d10d16 {
    constructor(e1 = {}){
        super(`styleimagemissing`, e1);
    }
};
function $4324d99ae8520741$var$ni(e1, t) {
    let n = {};
    for(let t in e1)t !== `ref` && (n[t] = e1[t]);
    return (0, $1G0Uw.mn).forEach((e1)=>{
        e1 in t && (n[e1] = t[e1]);
    }), n;
}
function $4324d99ae8520741$var$ri(e1) {
    e1 = e1.slice();
    let t = Object.create(null);
    for(let n = 0; n < e1.length; n++)t[e1[n].id] = e1[n];
    for(let n = 0; n < e1.length; n++)`ref` in e1[n] && (e1[n] = $4324d99ae8520741$var$ni(e1[n], t[e1[n].ref]));
    return e1;
}
function $4324d99ae8520741$var$J(e1, t) {
    if (Array.isArray(e1)) {
        if (!Array.isArray(t) || e1.length !== t.length) return !1;
        for(let n = 0; n < e1.length; n++)if (!$4324d99ae8520741$var$J(e1[n], t[n])) return !1;
        return !0;
    }
    if (typeof e1 == `object` && e1 && t !== null) {
        if (typeof t != `object` || Object.keys(e1).length !== Object.keys(t).length) return !1;
        for(let n in e1)if (!$4324d99ae8520741$var$J(e1[n], t[n])) return !1;
        return !0;
    }
    return e1 === t;
}
function $4324d99ae8520741$var$ii(e1, t) {
    e1.push(t);
}
function $4324d99ae8520741$var$ai(e1, t, n) {
    $4324d99ae8520741$var$ii(n, {
        command: `addSource`,
        args: [
            e1,
            t[e1]
        ]
    });
}
function $4324d99ae8520741$var$oi(e1, t, n) {
    $4324d99ae8520741$var$ii(t, {
        command: `removeSource`,
        args: [
            e1
        ]
    }), n[e1] = !0;
}
function $4324d99ae8520741$var$si(e1, t, n, r) {
    $4324d99ae8520741$var$oi(e1, n, r), $4324d99ae8520741$var$ai(e1, t, n);
}
function $4324d99ae8520741$var$ci(e1, t, n) {
    let r;
    for(r in e1[n])if (Object.prototype.hasOwnProperty.call(e1[n], r) && r !== `data` && !$4324d99ae8520741$var$J(e1[n][r], t[n][r])) return !1;
    for(r in t[n])if (Object.prototype.hasOwnProperty.call(t[n], r) && r !== `data` && !$4324d99ae8520741$var$J(e1[n][r], t[n][r])) return !1;
    return !0;
}
function $4324d99ae8520741$var$li(e1, t, n, r) {
    e1 ||= {}, t ||= {};
    let i;
    for(i in e1)Object.prototype.hasOwnProperty.call(e1, i) && (Object.prototype.hasOwnProperty.call(t, i) || $4324d99ae8520741$var$oi(i, n, r));
    for(i in t)Object.prototype.hasOwnProperty.call(t, i) && (Object.prototype.hasOwnProperty.call(e1, i) ? $4324d99ae8520741$var$J(e1[i], t[i]) || (e1[i].type === `geojson` && t[i].type === `geojson` && $4324d99ae8520741$var$ci(e1, t, i) ? $4324d99ae8520741$var$ii(n, {
        command: `setGeoJSONSourceData`,
        args: [
            i,
            t[i].data
        ]
    }) : $4324d99ae8520741$var$si(i, t, n, r)) : $4324d99ae8520741$var$ai(i, t, n));
}
function $4324d99ae8520741$var$ui(e1, t, n, r, i, a) {
    e1 ||= {}, t ||= {};
    for(let o in e1)Object.prototype.hasOwnProperty.call(e1, o) && ($4324d99ae8520741$var$J(e1[o], t[o]) || n.push({
        command: a,
        args: [
            r,
            o,
            t[o],
            i
        ]
    }));
    for(let o in t)Object.prototype.hasOwnProperty.call(t, o) && !Object.prototype.hasOwnProperty.call(e1, o) && ($4324d99ae8520741$var$J(e1[o], t[o]) || n.push({
        command: a,
        args: [
            r,
            o,
            t[o],
            i
        ]
    }));
}
function $4324d99ae8520741$var$di(e1) {
    return e1.id;
}
function $4324d99ae8520741$var$fi(e1, t) {
    return e1[t.id] = t, e1;
}
function $4324d99ae8520741$var$pi(e1, t, n) {
    e1 ||= [], t ||= [];
    let r = e1.map($4324d99ae8520741$var$di), i = t.map($4324d99ae8520741$var$di), a = e1.reduce($4324d99ae8520741$var$fi, {}), o = t.reduce($4324d99ae8520741$var$fi, {}), s = r.slice(), c = Object.create(null), l, u, d, f, p;
    for(let e1 = 0, t = 0; e1 < r.length; e1++)l = r[e1], Object.prototype.hasOwnProperty.call(o, l) ? t++ : ($4324d99ae8520741$var$ii(n, {
        command: `removeLayer`,
        args: [
            l
        ]
    }), s.splice(s.indexOf(l, t), 1));
    for(let e1 = 0, t = 0; e1 < i.length; e1++)l = i[i.length - 1 - e1], s[s.length - 1 - e1] !== l && (Object.prototype.hasOwnProperty.call(a, l) ? ($4324d99ae8520741$var$ii(n, {
        command: `removeLayer`,
        args: [
            l
        ]
    }), s.splice(s.lastIndexOf(l, s.length - t), 1)) : t++, f = s[s.length - e1], $4324d99ae8520741$var$ii(n, {
        command: `addLayer`,
        args: [
            o[l],
            f
        ]
    }), s.splice(s.length - e1, 0, l), c[l] = !0);
    for(let e1 = 0; e1 < i.length; e1++)if (l = i[e1], u = a[l], d = o[l], !(c[l] || $4324d99ae8520741$var$J(u, d))) {
        if (!$4324d99ae8520741$var$J(u.source, d.source) || !$4324d99ae8520741$var$J(u[`source-layer`], d[`source-layer`]) || !$4324d99ae8520741$var$J(u.type, d.type)) {
            $4324d99ae8520741$var$ii(n, {
                command: `removeLayer`,
                args: [
                    l
                ]
            }), f = s[s.lastIndexOf(l) + 1], $4324d99ae8520741$var$ii(n, {
                command: `addLayer`,
                args: [
                    d,
                    f
                ]
            });
            continue;
        }
        for(p in $4324d99ae8520741$var$ui(u.layout, d.layout, n, l, null, `setLayoutProperty`), $4324d99ae8520741$var$ui(u.paint, d.paint, n, l, null, `setPaintProperty`), $4324d99ae8520741$var$J(u.filter, d.filter) || $4324d99ae8520741$var$ii(n, {
            command: `setFilter`,
            args: [
                l,
                d.filter
            ]
        }), (!$4324d99ae8520741$var$J(u.minzoom, d.minzoom) || !$4324d99ae8520741$var$J(u.maxzoom, d.maxzoom)) && $4324d99ae8520741$var$ii(n, {
            command: `setLayerZoomRange`,
            args: [
                l,
                d.minzoom,
                d.maxzoom
            ]
        }), u)Object.prototype.hasOwnProperty.call(u, p) && p !== `layout` && p !== `paint` && p !== `filter` && p !== `metadata` && p !== `minzoom` && p !== `maxzoom` && (p.indexOf(`paint.`) === 0 ? $4324d99ae8520741$var$ui(u[p], d[p], n, l, p.slice(6), `setPaintProperty`) : $4324d99ae8520741$var$J(u[p], d[p]) || $4324d99ae8520741$var$ii(n, {
            command: `setLayerProperty`,
            args: [
                l,
                p,
                d[p]
            ]
        }));
        for(p in d)Object.prototype.hasOwnProperty.call(d, p) && !Object.prototype.hasOwnProperty.call(u, p) && p !== `layout` && p !== `paint` && p !== `filter` && p !== `metadata` && p !== `minzoom` && p !== `maxzoom` && (p.indexOf(`paint.`) === 0 ? $4324d99ae8520741$var$ui(u[p], d[p], n, l, p.slice(6), `setPaintProperty`) : $4324d99ae8520741$var$J(u[p], d[p]) || $4324d99ae8520741$var$ii(n, {
            command: `setLayerProperty`,
            args: [
                l,
                p,
                d[p]
            ]
        }));
    }
}
function $4324d99ae8520741$var$mi(e1, t) {
    if (!e1) return [
        {
            command: `setStyle`,
            args: [
                t
            ]
        }
    ];
    let n = [];
    try {
        if (!$4324d99ae8520741$var$J(e1.version, t.version)) return [
            {
                command: `setStyle`,
                args: [
                    t
                ]
            }
        ];
        $4324d99ae8520741$var$J(e1.center, t.center) || n.push({
            command: `setCenter`,
            args: [
                t.center
            ]
        }), $4324d99ae8520741$var$J(e1.state, t.state) || n.push({
            command: `setGlobalState`,
            args: [
                t.state
            ]
        }), $4324d99ae8520741$var$J(e1.centerAltitude, t.centerAltitude) || n.push({
            command: `setCenterAltitude`,
            args: [
                t.centerAltitude
            ]
        }), $4324d99ae8520741$var$J(e1.zoom, t.zoom) || n.push({
            command: `setZoom`,
            args: [
                t.zoom
            ]
        }), $4324d99ae8520741$var$J(e1.bearing, t.bearing) || n.push({
            command: `setBearing`,
            args: [
                t.bearing
            ]
        }), $4324d99ae8520741$var$J(e1.pitch, t.pitch) || n.push({
            command: `setPitch`,
            args: [
                t.pitch
            ]
        }), $4324d99ae8520741$var$J(e1.roll, t.roll) || n.push({
            command: `setRoll`,
            args: [
                t.roll
            ]
        }), $4324d99ae8520741$var$J(e1.sprite, t.sprite) || n.push({
            command: `setSprite`,
            args: [
                t.sprite
            ]
        }), $4324d99ae8520741$var$J(e1.glyphs, t.glyphs) || n.push({
            command: `setGlyphs`,
            args: [
                t.glyphs
            ]
        }), $4324d99ae8520741$var$J(e1[`font-faces`], t[`font-faces`]) || n.push({
            command: `setFontFaces`,
            args: [
                t[`font-faces`]
            ]
        }), $4324d99ae8520741$var$J(e1.transition, t.transition) || n.push({
            command: `setTransition`,
            args: [
                t.transition
            ]
        }), $4324d99ae8520741$var$J(e1.light, t.light) || n.push({
            command: `setLight`,
            args: [
                t.light
            ]
        }), $4324d99ae8520741$var$J(e1.terrain, t.terrain) || n.push({
            command: `setTerrain`,
            args: [
                t.terrain
            ]
        }), $4324d99ae8520741$var$J(e1.sky, t.sky) || n.push({
            command: `setSky`,
            args: [
                t.sky
            ]
        }), $4324d99ae8520741$var$J(e1.projection, t.projection) || n.push({
            command: `setProjection`,
            args: [
                t.projection
            ]
        });
        let r = {}, i = [];
        $4324d99ae8520741$var$li(e1.sources, t.sources, i, r);
        let a = [];
        e1.layers && e1.layers.forEach((e1)=>{
            `source` in e1 && r[e1.source] ? n.push({
                command: `removeLayer`,
                args: [
                    e1.id
                ]
            }) : a.push(e1);
        }), n = n.concat(i), $4324d99ae8520741$var$pi(a, t.layers, n);
    } catch (e1) {
        console.warn(`Unable to compute style diff:`, e1), n = [
            {
                command: `setStyle`,
                args: [
                    t
                ]
            }
        ];
    }
    return n;
}
function $4324d99ae8520741$var$hi() {
    let e1 = {}, t = (0, $1G0Uw.hn).$version;
    for(let n in (0, $1G0Uw.hn).$root){
        let r = (0, $1G0Uw.hn).$root[n];
        if (r.required) {
            let i = null;
            i = n === `version` ? t : r.type === `array` ? [] : {}, i != null && (e1[n] = i);
        }
    }
    return e1;
}
function $4324d99ae8520741$var$gi(e1) {
    let t = [];
    if (typeof e1 == `string`) t.push({
        id: `default`,
        url: e1
    });
    else if (e1 && e1.length > 0) {
        let n = [];
        for (let { id: r, url: i } of e1){
            let e1 = `${r}${i}`;
            n.includes(e1) || (n.push(e1), t.push({
                id: r,
                url: i
            }));
        }
    }
    return t;
}
function $4324d99ae8520741$var$_i(e1, t, n) {
    try {
        let r = new URL(e1);
        return r.pathname += `${t}${n}`, r.toString();
    } catch  {
        throw Error(`Invalid sprite URL "${e1}", must be absolute. Modify style specification directly or use TransformStyleFunction to correct the issue dynamically`);
    }
}
async function $4324d99ae8520741$var$vi(e1, t, n, r) {
    let i = $4324d99ae8520741$var$gi(e1), a = n > 1 ? `@2x` : ``, o = {}, s = {};
    for (let { id: e1, url: n } of i){
        let i = await t.transformRequest($4324d99ae8520741$var$_i(n, a, `.json`), `SpriteJSON`);
        o[e1] = (0, $1G0Uw.Sn)(i, r);
        let c = await t.transformRequest($4324d99ae8520741$var$_i(n, a, `.png`), `SpriteImage`);
        s[e1] = $4324d99ae8520741$var$Ur.getImage(c, r);
    }
    return await Promise.all([
        ...Object.values(o),
        ...Object.values(s)
    ]), $4324d99ae8520741$var$yi(o, s);
}
async function $4324d99ae8520741$var$yi(e1, t) {
    let n = {};
    for(let r in e1){
        n[r] = {};
        let i = (await t[r]).data;
        if (!i) throw Error(`Could not load sprite image for ${r}: the response is empty`);
        let a = $4324d99ae8520741$var$Rr.getImageCanvasContext(i), o = (await e1[r]).data;
        for(let e1 in o){
            let { width: t, height: i, x: s, y: c, sdf: l, pixelRatio: u, stretchX: d, stretchY: f, content: p, textFitWidth: m, textFitHeight: h } = o[e1], g = {
                width: t,
                height: i,
                x: s,
                y: c,
                context: a
            };
            n[r][e1] = {
                data: null,
                pixelRatio: u,
                sdf: l,
                stretchX: d,
                stretchY: f,
                content: p,
                textFitWidth: m,
                textFitHeight: h,
                spriteData: g
            };
        }
    }
    return n;
}
var $4324d99ae8520741$var$bi = class extends (0, $1G0Uw.vn) {
    constructor(){
        super(), this.images = {}, this.updateVersion = 0, this.loaded = !1, this.requestors = [], this.missingImageResolver = null, this._spriteImagesIds = {}, this._imagesIds = null, this._renderCallbacksDispatchedThisFrame = {};
    }
    destroy() {
        for (let e1 of Object.keys(this.images))this.removeImage(e1);
        this._spriteImagesIds = {};
    }
    isLoaded() {
        return this.loaded;
    }
    setLoaded(e1) {
        if (this.loaded !== e1 && (this.loaded = e1, e1)) {
            for (let { ids: e1, promiseResolve: t } of this.requestors)t(this._getImagesForIds(e1));
            this.requestors = [];
        }
    }
    getImage(e1) {
        let t = this.images[e1];
        if (t && !t.data && t.spriteData) {
            let e1 = t.spriteData;
            t.data = new (0, $1G0Uw.Dt)({
                width: e1.width,
                height: e1.height
            }, e1.context.getImageData(e1.x, e1.y, e1.width, e1.height).data), t.spriteData = null;
        }
        return t;
    }
    addImage(e1, t) {
        if (this.images[e1]) throw Error(`Image id ${e1} already exist, use updateImage instead`);
        this._validate(e1, t) && (this.images[e1] = t, this._imagesIds = null, t.isWebGLImage && this.updateImage(e1, t, !1));
    }
    _validate(e1, t) {
        let n = !0, r = t.data || t.spriteData;
        return this._validateStretch(t.stretchX, r?.width) || (this.fire(new (0, $1G0Uw.gn)(Error(`Image "${e1}" has invalid "stretchX" value`))), n = !1), this._validateStretch(t.stretchY, r?.height) || (this.fire(new (0, $1G0Uw.gn)(Error(`Image "${e1}" has invalid "stretchY" value`))), n = !1), this._validateContent(t.content, t) || (this.fire(new (0, $1G0Uw.gn)(Error(`Image "${e1}" has invalid "content" value`))), n = !1), n;
    }
    _validateStretch(e1, t) {
        if (!e1) return !0;
        let n = 0;
        for (let r of e1){
            if (r[0] < n || r[1] < r[0] || t < r[1]) return !1;
            n = r[1];
        }
        return !0;
    }
    _validateContent(e1, t) {
        if (!e1) return !0;
        if (e1.length !== 4) return !1;
        let n = t.spriteData, r = n?.width || t.data.width, i = n?.height || t.data.height;
        return e1[0] < 0 || r < e1[0] || e1[1] < 0 || i < e1[1] || e1[2] < 0 || r < e1[2] || e1[3] < 0 || i < e1[3] || e1[2] < e1[0] ? !1 : e1[3] >= e1[1];
    }
    updateImage(e1, t, n = !0) {
        let r = this.images[e1];
        if (n) {
            let e1 = r.data || r.spriteData;
            if (e1.width !== t.data.width || e1.height !== t.data.height) throw Error(`size mismatch between old image (${e1.width}x${e1.height}) and new image (${t.data.width}x${t.data.height}).`);
        }
        t.version = (r.version ?? 0) + 1, this.images[e1] = t, this.updateVersion++;
    }
    removeImage(e1) {
        let t = this.images[e1];
        t && (delete this.images[e1], this._imagesIds = null, t.userImage?.onRemove && t.userImage.onRemove());
    }
    listImages() {
        return this._imagesIds ??= Object.keys(this.images), this._imagesIds;
    }
    _getSpriteImageId(e1, t) {
        return e1 === "default" ? t : `${e1}:${t}`;
    }
    setSpriteImages(e1, t) {
        let n = this._spriteImagesIds[e1] ?? [], r = [];
        for(let n in t){
            let i = this._getSpriteImageId(e1, n);
            r.push(i), i in this.images ? this.updateImage(i, t[n], !1) : this.addImage(i, t[n]);
        }
        let i = new Set(r), a = n.filter((e1)=>!i.has(e1));
        for (let e1 of a)this.removeImage(e1);
        return this._spriteImagesIds[e1] = r, {
            loaded: r,
            removed: a
        };
    }
    removeSpriteImages(e1) {
        let t = this._spriteImagesIds[e1] ?? [];
        for (let e1 of t)this.removeImage(e1);
        return delete this._spriteImagesIds[e1], t;
    }
    removeAllSpriteImages() {
        let e1 = Object.values(this._spriteImagesIds).flat();
        for (let t of e1)this.removeImage(t);
        return this._spriteImagesIds = {}, e1;
    }
    setMissingImageResolver(e1) {
        this.missingImageResolver = e1;
    }
    getImages(e1) {
        return new Promise((t, n)=>{
            let r = !0;
            if (!this.isLoaded()) for (let t of e1)this.images[t] || (r = !1);
            this.isLoaded() || r ? t(this._getImagesForIds(e1)) : this.requestors.push({
                ids: e1,
                promiseResolve: t
            });
        });
    }
    async _getImagesForIds(e1) {
        let t = new Set(e1.filter((e1)=>!this.getImage(e1))), n = this.missingImageResolver;
        n && await Promise.allSettled(Array.from(t, (e1)=>n(e1)));
        let r = {};
        for (let n of e1){
            let e1 = this.getImage(n);
            e1 && (t.delete(n), r[n] = {
                data: e1.data.clone(),
                pixelRatio: e1.pixelRatio,
                sdf: e1.sdf,
                version: e1.version,
                stretchX: e1.stretchX,
                stretchY: e1.stretchY,
                content: e1.content,
                textFitWidth: e1.textFitWidth,
                textFitHeight: e1.textFitHeight,
                hasRenderCallback: !!e1.userImage?.render,
                isWebGLImage: e1.isWebGLImage
            });
        }
        for (let e1 of t)this.fire(new $4324d99ae8520741$export$14816c15d485a7b9({
            id: e1
        })), (0, $1G0Uw.Nr)(`Image "${e1}" could not be loaded. Please make sure you have added the image before it is needed with map.addImage(), resolved it with map.setMissingStyleImageResolver(), or included it in a "sprite" property in your style.`);
        return r;
    }
    beginFrame() {
        this._renderCallbacksDispatchedThisFrame = {};
    }
    dispatchRenderCallbacks(e1) {
        for (let t of e1){
            if (this._renderCallbacksDispatchedThisFrame[t]) continue;
            this._renderCallbacksDispatchedThisFrame[t] = !0;
            let e1 = this.getImage(t);
            e1 || (0, $1G0Uw.Nr)(`Image with ID: "${t}" was not found`), (0, $1G0Uw.L)(e1) && this.updateImage(t, e1);
        }
    }
    cloneImages() {
        let e1 = {};
        for(let t in this.images){
            let n = this.images[t];
            e1[t] = {
                ...n,
                data: n.data ? n.data.clone() : null
            };
        }
        return e1;
    }
}, $4324d99ae8520741$var$xi = class {
    constructor(e1){
        this._imageManager = e1, this._entries = {}, this._image = new (0, $1G0Uw.Dt)({
            width: 1,
            height: 1
        }), this._dirty = !0;
    }
    destroy() {
        this._texture &&= (this._texture.destroy(), null), this._entries = {}, this._image = new (0, $1G0Uw.Dt)({
            width: 1,
            height: 1
        }), this._dirty = !0;
    }
    getPixelSize() {
        let { width: e1, height: t } = this._image;
        return {
            width: e1,
            height: t
        };
    }
    getPattern(e1) {
        let t = this._imageManager.getImage(e1);
        if (!t) return null;
        let n = this._entries[e1];
        if (n?.image !== t) {
            let n = {
                w: t.data.width + 2,
                h: t.data.height + 2,
                x: 0,
                y: 0
            };
            this._entries[e1] = {
                bin: n,
                position: new (0, $1G0Uw.P)(n, t),
                image: t
            };
        } else if (n.position.version !== t.version) n.position.version = t.version;
        else return n.position;
        return this._update(), this._entries[e1].position;
    }
    bind(e1) {
        let t = e1.gl;
        this._texture ? this._dirty &&= (this._texture.update(this._image), !1) : (this._texture = new (0, $1G0Uw.xt)(e1, this._image, t.RGBA), this._dirty = !1), this._texture.bind(t.LINEAR, t.CLAMP_TO_EDGE);
    }
    _update() {
        for(let e1 in this._entries)this._imageManager.getImage(e1) || delete this._entries[e1];
        let e1 = [];
        for(let t in this._entries)e1.push(this._entries[t].bin);
        let { w: t, h: n } = (0, $1G0Uw.F)(e1), r = this._image;
        r.resize({
            width: t || 1,
            height: n || 1
        });
        for(let e1 in this._entries){
            let { bin: t } = this._entries[e1], n = t.x + 1, i = t.y + 1, a = this._entries[e1].image.data, o = a.width, s = a.height;
            (0, $1G0Uw.Dt).copy(a, r, {
                x: 0,
                y: 0
            }, {
                x: n,
                y: i
            }, {
                width: o,
                height: s
            }), (0, $1G0Uw.Dt).copy(a, r, {
                x: 0,
                y: s - 1
            }, {
                x: n,
                y: i - 1
            }, {
                width: o,
                height: 1
            }), (0, $1G0Uw.Dt).copy(a, r, {
                x: 0,
                y: 0
            }, {
                x: n,
                y: i + s
            }, {
                width: o,
                height: 1
            }), (0, $1G0Uw.Dt).copy(a, r, {
                x: o - 1,
                y: 0
            }, {
                x: n - 1,
                y: i
            }, {
                width: 1,
                height: s
            }), (0, $1G0Uw.Dt).copy(a, r, {
                x: 0,
                y: 0
            }, {
                x: n + o,
                y: i
            }, {
                width: 1,
                height: s
            });
        }
        this._dirty = !0;
    }
};
const $4324d99ae8520741$var$Si = 1114111, $4324d99ae8520741$var$Ci = {
    start: 0,
    end: $4324d99ae8520741$var$Si
};
let $4324d99ae8520741$var$wi = 0;
function $4324d99ae8520741$var$Ti(e1) {
    let t = /^u\+([0-9a-f]*)(\?+)$/i.exec(e1);
    if (t) {
        let [, e1, n] = t;
        return e1.length + n.length > 6 ? null : $4324d99ae8520741$var$Ei(parseInt(`${e1}${`0`.repeat(n.length)}`, 16), parseInt(`${e1}${`f`.repeat(n.length)}`, 16));
    }
    let n = /^u\+([0-9a-f]{1,6})(?:-([0-9a-f]{1,6}))?$/i.exec(e1);
    if (!n) return null;
    let r = parseInt(n[1], 16);
    return $4324d99ae8520741$var$Ei(r, n[2] === void 0 ? r : parseInt(n[2], 16));
}
function $4324d99ae8520741$var$Ei(e1, t) {
    return e1 > t || e1 > $4324d99ae8520741$var$Si ? null : {
        start: e1,
        end: Math.min(t, $4324d99ae8520741$var$Si)
    };
}
function $4324d99ae8520741$var$Di(e1, t) {
    return e1.ranges.some(({ start: e1, end: n })=>t >= e1 && t <= n);
}
var $4324d99ae8520741$var$Oi = class {
    constructor(e1){
        this.requestManager = e1, this._faces = {}, this._registered = new Set;
    }
    setFontFaces(e1) {
        this._unregisterAll(), this._faces = {};
        for (let [t, n] of Object.entries(e1 ?? {})){
            let e1 = Array.isArray(n) ? n : [
                n
            ];
            this._faces[t] = e1.map((e1)=>this._declareFontFace(t, e1)).filter((e1)=>e1 !== null);
        }
    }
    hasFontFaces() {
        return Object.keys(this._faces).length > 0;
    }
    async getFontFamily(e1, t) {
        for (let n of e1.split(`,`))for (let e1 of this._faces[n.trim()] ?? [])if ($4324d99ae8520741$var$Di(e1, t) && (e1.loaded ??= this._loadFontFace(e1), await e1.loaded)) return e1.family;
        return null;
    }
    _declareFontFace(e1, t) {
        let n = typeof t == `string` ? {
            url: t
        } : t;
        if (typeof n?.url != `string`) return (0, $1G0Uw.Nr)(`Ignoring the font face declared for "${e1}": it has no URL.`), null;
        let r = `maplibre-gl-font-face-${$4324d99ae8520741$var$wi++}`, i = n[`unicode-range`];
        if (!i?.length) return {
            url: n.url,
            ranges: [
                $4324d99ae8520741$var$Ci
            ],
            family: r
        };
        let a = [];
        for (let e1 of i){
            let t = $4324d99ae8520741$var$Ti(e1);
            if (!t) {
                (0, $1G0Uw.Nr)(`Ignoring the unicode range "${e1}" of the font face at ${n.url}: it is not a valid range.`);
                continue;
            }
            a.push(t);
        }
        return a.length ? {
            url: n.url,
            ranges: a,
            family: r
        } : null;
    }
    async _loadFontFace(e1) {
        if (typeof FontFace > `u` || typeof document > `u` || !document.fonts) return (0, $1G0Uw.Nr)(`Ignoring the font face at ${e1.url}: this environment has no CSS Font Loading API.`), !1;
        let t;
        try {
            return t = new FontFace(e1.family, await this._downloadFontFile(e1.url)), Object.values(this._faces).some((t)=>t.includes(e1)) ? (document.fonts.add(t), this._registered.add(t), await t.load(), !0) : !1;
        } catch (n) {
            return t && this._unregister(t), (0, $1G0Uw.Nr)(`Ignoring the font face at ${e1.url}: ${(0, $1G0Uw.Qn)(n).message}`), !1;
        }
    }
    async _downloadFontFile(e1) {
        let t = await this.requestManager.transformRequest(e1, `Glyphs`), n = await (0, $1G0Uw.xn)(t, new AbortController);
        if (!n?.data) throw Error(`the response was empty for the font file at ${e1}`);
        return n.data;
    }
    _unregister(e1) {
        document.fonts?.delete(e1), this._registered.delete(e1);
    }
    _unregisterAll() {
        for (let e1 of this._registered)document.fonts?.delete(e1);
        this._registered.clear();
    }
    destroy() {
        this._unregisterAll(), this._faces = {};
    }
};
const $4324d99ae8520741$var$ki = 0x56bc75e2d63100000, $4324d99ae8520741$var$Ai = new Float64Array(256);
for(let e1 = 0; e1 < 256; e1++){
    let t = .5 - (e1 / 255) ** (1 / 2.2);
    $4324d99ae8520741$var$Ai[e1] = t * Math.abs(t);
}
$4324d99ae8520741$var$Ai[255] = -100000000000000000000;
var $4324d99ae8520741$var$ji = class {
    constructor({ fontSize: e1 = 24, buffer: t = 3, radius: n = 8, cutoff: r = .25, fontFamily: i = `sans-serif`, fontWeight: a = `normal`, fontStyle: o = `normal`, lang: s = null } = {}){
        this.buffer = t, this.radius = n, this.cutoff = r, this.lang = s;
        let c = this.size = e1 + t * 4, l = this._createCanvas(c), u = this.ctx = l.getContext(`2d`, {
            willReadFrequently: !0
        });
        u.font = `${o} ${a} ${e1}px ${i}`, u.textBaseline = `alphabetic`, u.textAlign = `left`, u.fillStyle = `black`, this.gridOuter = new Float64Array(c * c), this.gridInner = new Float64Array(c * c), this.f = new Float64Array(c), this.z = new Float64Array(c + 1), this.v = new Uint16Array(c);
    }
    _createCanvas(e1) {
        if (typeof OffscreenCanvas < `u`) return new OffscreenCanvas(e1, e1);
        let t = document.createElement(`canvas`);
        return t.width = t.height = e1, t;
    }
    draw(e1) {
        let { width: t, actualBoundingBoxAscent: n, actualBoundingBoxDescent: r, actualBoundingBoxLeft: i, actualBoundingBoxRight: a } = this.ctx.measureText(e1), o = Math.ceil(n), s = Math.floor(-i), c = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(a) - s)), l = Math.max(0, Math.min(this.size - this.buffer, o + Math.ceil(r))), u = c + 2 * this.buffer, d = l + 2 * this.buffer, f = Math.max(u * d, 0), p = new Uint8ClampedArray(f), m = {
            data: p,
            width: u,
            height: d,
            glyphWidth: c,
            glyphHeight: l,
            glyphTop: o,
            glyphLeft: s,
            glyphAdvance: t
        };
        if (c === 0 || l === 0) return m;
        let { ctx: h, buffer: g, gridInner: _, gridOuter: v } = this;
        this.lang && (h.lang = this.lang), h.clearRect(g, g, c, l), h.fillText(e1, g - s, g + o);
        let y = h.getImageData(g, g, c, l);
        v.fill($4324d99ae8520741$var$ki, 0, f), _.fill(0, 0, f);
        let b = 3;
        for(let e1 = 0; e1 < l; e1++){
            let t = (e1 + g) * u + g;
            for(let e1 = 0; e1 < c; e1++, b += 4, t++){
                let e1 = y.data[b];
                if (e1 === 0) continue;
                let n = $4324d99ae8520741$var$Ai[e1];
                v[t] = Math.max(0, n), _[t] = Math.max(0, -n);
            }
        }
        $4324d99ae8520741$var$Mi(v, 0, 0, u, d, u, this.f, this.v, this.z);
        let x = Math.min(g, 1);
        $4324d99ae8520741$var$Mi(_, g - x, g - x, c + 2 * x, l + 2 * x, u, this.f, this.v, this.z);
        let S = 255 / this.radius, C = 255 * (1 - this.cutoff);
        for(let e1 = 0; e1 < f; e1++){
            let t = Math.sqrt(v[e1]) - Math.sqrt(_[e1]);
            p[e1] = Math.round(C - S * t);
        }
        return m;
    }
};
function $4324d99ae8520741$var$Mi(e1, t, n, r, i, a, o, s, c) {
    for(let l = t; l < t + r; l++)$4324d99ae8520741$var$Ni(e1, n * a + l, a, i, o, s, c);
    for(let l = n; l < n + i; l++)$4324d99ae8520741$var$Ni(e1, l * a + t, 1, r, o, s, c);
}
function $4324d99ae8520741$var$Ni(e1, t, n, r, i, a, o) {
    a[0] = 0, o[0] = -100000000000000000000, o[1] = $4324d99ae8520741$var$ki, i[0] = e1[t];
    for(let s = 1, c = 0, l = 0; s < r; s++){
        i[s] = e1[t + s * n];
        let r = s * s;
        do {
            let e1 = a[c];
            l = (i[s] - i[e1] + r - e1 * e1) / (s - e1) / 2;
        }while (l <= o[c] && --c > -1);
        c++, a[c] = s, o[c] = l, o[c + 1] = $4324d99ae8520741$var$ki;
    }
    for(let s = 0, c = 0; s < r; s++){
        for(; o[c + 1] < s;)c++;
        let r = a[c], l = s - r;
        e1[t + s * n] = i[r] + l * l;
    }
}
const $4324d99ae8520741$var$Pi = (0, $1G0Uw.hn).layout_symbol[`text-font`].default.join(`,`), $4324d99ae8520741$var$Fi = (e1, t)=>{
    let n = new $4324d99ae8520741$var$ji(e1);
    return n.buffer = t, n;
};
var $4324d99ae8520741$var$Ii = class {
    constructor(e1, t, n, r = $4324d99ae8520741$var$Fi){
        this.requestManager = e1, this.localIdeographFontFamily = t, this.entries = {}, this.lang = n, this.fontFaceManager = new $4324d99ae8520741$var$Oi(e1), this.createRasterizer = r;
    }
    setURL(e1) {
        this.url = e1;
    }
    setFontFaces(e1) {
        this.fontFaceManager.setFontFaces(e1), this.entries = {};
    }
    async getGlyphs(e1) {
        let t = [];
        for(let n in e1)for (let r of e1[n])t.push(this._getAndCacheGlyphsPromise(n, r));
        let n = await Promise.all(t), r = {};
        for (let { stack: e1, id: t, glyph: i } of n)r[e1] ||= {}, r[e1][t] = i && {
            id: i.id,
            bitmap: i.bitmap.clone(),
            metrics: i.metrics
        };
        return r;
    }
    async _getAndCacheGlyphsPromise(e1, t) {
        this.entries[e1] ??= {
            glyphs: {},
            requests: {},
            ranges: {}
        };
        let n = this.entries[e1], r = n.glyphs[t];
        if (r !== void 0) return {
            stack: e1,
            id: t,
            glyph: r
        };
        let i = t.codePointAt(0), a = this.fontFaceManager.hasFontFaces() ? await this.fontFaceManager.getFontFamily(e1, i) : null;
        return a ? (r = n.glyphs[t] = await this._drawGlyph(n, e1, t, a), {
            stack: e1,
            id: t,
            glyph: r
        }) : !this.url || (0, $1G0Uw.B)(t) || this._charUsesLocalIdeographFontFamily(i) ? (r = n.glyphs[t] = await this._drawGlyph(n, e1, t), {
            stack: e1,
            id: t,
            glyph: r
        }) : await this._downloadAndCacheRangePromise(e1, t);
    }
    async _downloadAndCacheRangePromise(e1, t) {
        let n = t.codePointAt(0), r = this.entries[e1], i = Math.floor(n / 256);
        if (r.ranges[i]) return {
            stack: e1,
            id: t,
            glyph: null
        };
        r.requests[i] ||= this._loadGlyphRange(e1, i);
        try {
            let a = await r.requests[i];
            for(let e1 in a)r.glyphs[String.fromCodePoint(+e1)] = a[+e1];
            return r.ranges[i] = !0, {
                stack: e1,
                id: t,
                glyph: a[n] || null
            };
        } catch (a) {
            let o = r.glyphs[t] = await this._drawGlyph(r, e1, t);
            return this._warnOnMissingGlyphRange(o, i, n, (0, $1G0Uw.Qn)(a)), {
                stack: e1,
                id: t,
                glyph: o
            };
        }
    }
    async _loadGlyphRange(e1, t) {
        let n = t * 256, r = n + 255, i = await this.requestManager.transformRequest(this.url.replace(`{fontstack}`, e1).replace(`{range}`, `${n}-${r}`), `Glyphs`), a = await (0, $1G0Uw.xn)(i, new AbortController);
        if (!a?.data) throw Error(`Could not load glyph range. range: ${t}, ${n}-${r}`);
        let o = {};
        for (let e1 of (0, $1G0Uw.R)(a.data))o[e1.id] = e1;
        return o;
    }
    _warnOnMissingGlyphRange(e1, t, n, r) {
        let i = t * 256, a = i + 255, o = n.toString(16).padStart(4, `0`).toUpperCase();
        (0, $1G0Uw.Nr)(`Unable to load glyph range ${t}, ${i}-${a}. Rendering codepoint U+${o} locally instead. ${r}`);
    }
    _charUsesLocalIdeographFontFamily(e1) {
        return !!this.localIdeographFontFamily && (0, $1G0Uw.V)(e1);
    }
    async _drawGlyph(e1, t, n, r) {
        let i = (await this._getTinySDF(e1, t, n, r)).draw(n), a = /^\p{gc=Cf}+$/u.test(n);
        return {
            id: n.codePointAt(0),
            bitmap: new (0, $1G0Uw.Et)({
                width: i.width || 60,
                height: i.height || 60
            }, i.data),
            metrics: {
                width: a ? 0 : i.glyphWidth / 2 || 24,
                height: i.glyphHeight / 2 || 24,
                left: i.glyphLeft / 2 + .5 || 0,
                top: i.glyphTop / 2 - 27.5 || -8,
                advance: a ? 0 : i.glyphAdvance / 2 || 24,
                isDoubleResolution: !0
            }
        };
    }
    _getTinySDF(e1, t, n, r) {
        let i = (0, $1G0Uw.B)(n);
        if (r) {
            let t = i ? `clusterTinySDFs` : `fontFaceTinySDFs`;
            return e1[t] ??= {}, e1[t][r] ||= this._createTinySDF(r, !1, i ? 3 : 1), e1[t][r];
        }
        let a = t === $4324d99ae8520741$var$Pi && this.localIdeographFontFamily !== `` && this._charUsesLocalIdeographFontFamily(n.codePointAt(0)), o = a ? this.localIdeographFontFamily : t;
        if (i) return e1.clusterTinySDFs ??= {}, e1.clusterTinySDFs[o] ||= this._createTinySDF(o, !0, 3), e1.clusterTinySDFs[o];
        let s = a ? `ideographTinySDF` : `tinySDF`;
        return e1[s] ||= this._createTinySDF(o), e1[s];
    }
    async _createTinySDF(e1, t = !0, n = 1) {
        let r = e1 ? e1.split(`,`) : [];
        r.push(`sans-serif`);
        let i = r.map((e1)=>/[-\w]+/.test(e1) ? e1 : `'${CSS.escape(e1)}'`).join(`,`), a = t ? this._fontWeight(r[0]) : void 0, o = t ? this._fontStyle(r[0]) : `normal`;
        if (typeof document < `u` && document.fonts?.load) try {
            await document.fonts.load(`${o} ${a || `normal`} 48px ${i}`);
        } catch (e1) {
            (0, $1G0Uw.Nr)(`Failed to load font "${i}": ${(0, $1G0Uw.Qn)(e1).message}`);
        }
        return this.createRasterizer({
            fontSize: 48,
            buffer: Math.max(6, Math.ceil(48 * (n - 1) / 4)),
            radius: 16,
            cutoff: .25,
            fontFamily: i,
            fontWeight: a,
            fontStyle: o,
            lang: this.lang
        }, 6);
    }
    _fontStyle(e1) {
        return /italic/i.test(e1) ? `italic` : /oblique/i.test(e1) ? `oblique` : `normal`;
    }
    _fontWeight(e1) {
        let t = {
            thin: 100,
            hairline: 100,
            "extra light": 200,
            "ultra light": 200,
            light: 300,
            normal: 400,
            regular: 400,
            medium: 500,
            semibold: 600,
            demibold: 600,
            bold: 700,
            "extra bold": 800,
            "ultra bold": 800,
            black: 900,
            heavy: 900,
            "extra black": 950,
            "ultra black": 950
        }, n;
        for (let [r, i] of Object.entries(t))RegExp(`\\b${r}\\b`, `i`).test(e1) && (n = `${i}`);
        return n;
    }
    destroy() {
        for(let e1 in this.entries){
            let t = this.entries[e1];
            t.tinySDF = null, t.ideographTinySDF = null, t.fontFaceTinySDFs = {}, t.glyphs = {}, t.requests = {}, t.ranges = {};
        }
        this.entries = {}, this.fontFaceManager.destroy();
    }
};
let $4324d99ae8520741$var$Li;
const $4324d99ae8520741$var$Ri = ()=>$4324d99ae8520741$var$Li ||= new (0, $1G0Uw.Qt)({
        anchor: new (0, $1G0Uw.Zt)((0, $1G0Uw.hn).light.anchor, `anchor`),
        position: new (0, $1G0Uw.Zt)((0, $1G0Uw.hn).light.position, `position`),
        color: new (0, $1G0Uw.Zt)((0, $1G0Uw.hn).light.color, `color`),
        intensity: new (0, $1G0Uw.Zt)((0, $1G0Uw.hn).light.intensity, `intensity`)
    });
var $4324d99ae8520741$var$zi = class extends (0, $1G0Uw.vn) {
    constructor(e1, t){
        super(), this._transitionable = new (0, $1G0Uw.$t)($4324d99ae8520741$var$Ri(), `light`, t), this.setLight(e1), this._transitioning = this._transitionable.untransitioned();
    }
    getLight() {
        return this._transitionable.serialize();
    }
    getCartesianPosition() {
        return (0, $1G0Uw.Or)(this.properties.get(`position`));
    }
    setLight(e1, t = {}) {
        this._validate((0, $1G0Uw.on).light, e1, t) || this._transitionable.setValues(e1);
    }
    updateTransitions(e1) {
        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition();
    }
    recalculate(e1) {
        this.properties = this._transitioning.possiblyEvaluate(e1);
    }
    _validate(e1, t, n) {
        return (0, $1G0Uw.an)(this, e1, {
            value: t
        }, n);
    }
};
let $4324d99ae8520741$var$Bi;
const $4324d99ae8520741$var$Vi = ()=>$4324d99ae8520741$var$Bi ||= new (0, $1G0Uw.Qt)({
        "sky-color": new (0, $1G0Uw.Zt)((0, $1G0Uw.hn).sky[`sky-color`], `sky-color`),
        "horizon-color": new (0, $1G0Uw.Zt)((0, $1G0Uw.hn).sky[`horizon-color`], `horizon-color`),
        "fog-color": new (0, $1G0Uw.Zt)((0, $1G0Uw.hn).sky[`fog-color`], `fog-color`),
        "fog-ground-blend": new (0, $1G0Uw.Zt)((0, $1G0Uw.hn).sky[`fog-ground-blend`], `fog-ground-blend`),
        "horizon-fog-blend": new (0, $1G0Uw.Zt)((0, $1G0Uw.hn).sky[`horizon-fog-blend`], `horizon-fog-blend`),
        "sky-horizon-blend": new (0, $1G0Uw.Zt)((0, $1G0Uw.hn).sky[`sky-horizon-blend`], `sky-horizon-blend`),
        "atmosphere-blend": new (0, $1G0Uw.Zt)((0, $1G0Uw.hn).sky[`atmosphere-blend`], `atmosphere-blend`)
    });
var $4324d99ae8520741$var$Hi = class extends (0, $1G0Uw.vn) {
    constructor(e1, t){
        super(), this._transitionable = new (0, $1G0Uw.$t)($4324d99ae8520741$var$Vi(), `sky`, t), this.setSky(e1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new (0, $1G0Uw.en)(0));
    }
    setSky(e1, t = {}) {
        this._validate((0, $1G0Uw.on).sky, e1, t) || (e1 ||= {
            "sky-color": `transparent`,
            "horizon-color": `transparent`,
            "fog-color": `transparent`,
            "fog-ground-blend": 1,
            "atmosphere-blend": 0
        }, this._transitionable.setValues(e1));
    }
    getSky() {
        return this._transitionable.serialize();
    }
    updateTransitions(e1) {
        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition();
    }
    recalculate(e1) {
        this.properties = this._transitioning.possiblyEvaluate(e1);
    }
    _validate(e1, t, n = {}) {
        return (0, $1G0Uw.an)(this, e1, {
            value: t
        }, n);
    }
    calculateFogBlendOpacity(e1) {
        return e1 < 60 ? 0 : e1 < 70 ? (e1 - 60) / 10 : 1;
    }
}, $4324d99ae8520741$var$Ui = class {
    constructor(e1, t){
        this.width = e1, this.height = t, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
    }
    getDash(e1, t) {
        let n = e1.join(`,`) + String(t);
        return this.dashEntry[n] ||= this.addDash(e1, t), this.dashEntry[n];
    }
    getDashRanges(e1, t, n) {
        let r = e1.length % 2 == 1, i = [], a = r ? -e1[e1.length - 1] * n : 0, o = e1[0] * n, s = !0;
        i.push({
            left: a,
            right: o,
            isDash: s,
            zeroLength: e1[0] === 0
        });
        let c = e1[0];
        for(let t = 1; t < e1.length; t++){
            s = !s;
            let r = e1[t];
            a = c * n, c += r, o = c * n, i.push({
                left: a,
                right: o,
                isDash: s,
                zeroLength: r === 0
            });
        }
        return i;
    }
    addRoundDash(e1, t, n) {
        let r = t / 2;
        for(let t = -n; t <= n; t++){
            let i = this.nextRow + n + t, a = this.width * i, o = 0, s = e1[o];
            for(let i = 0; i < this.width; i++){
                i / s.right > 1 && (s = e1[++o]);
                let c = Math.abs(i - s.left), l = Math.abs(i - s.right), u = Math.min(c, l), d, f = t / n * (r + 1);
                if (s.isDash) {
                    let e1 = r - Math.abs(f);
                    d = Math.sqrt(u * u + e1 * e1);
                } else d = r - Math.sqrt(u * u + f * f);
                this.data[a + i] = Math.max(0, Math.min(255, d + 128));
            }
        }
    }
    addRegularDash(e1) {
        for(let t = e1.length - 1; t >= 0; --t){
            let n = e1[t], r = e1[t + 1];
            n.zeroLength ? e1.splice(t, 1) : r?.isDash === n.isDash && (r.left = n.left, e1.splice(t, 1));
        }
        let t = e1[0], n = e1[e1.length - 1];
        t.isDash === n.isDash && (t.left = n.left - this.width, n.right = t.right + this.width);
        let r = this.width * this.nextRow, i = 0, a = e1[i];
        for(let t = 0; t < this.width; t++){
            t / a.right > 1 && (a = e1[++i]);
            let n = Math.abs(t - a.left), o = Math.abs(t - a.right), s = Math.min(n, o), c = a.isDash ? s : -s;
            this.data[r + t] = Math.max(0, Math.min(255, c + 128));
        }
    }
    addDash(e1, t) {
        let n = t ? 7 : 0, r = 2 * n + 1;
        if (this.nextRow + r > this.height) return (0, $1G0Uw.Nr)(`LineAtlas out of space`), null;
        let i = 0;
        for (let t of e1)i += t;
        if (i !== 0) {
            let r = this.width / i, a = this.getDashRanges(e1, this.width, r);
            t ? this.addRoundDash(a, r, n) : this.addRegularDash(a);
        }
        let a = {
            y: this.nextRow + n,
            height: 2 * n,
            width: i
        };
        return this.nextRow += r, this.dirty = !0, a;
    }
    bind(e1) {
        let t = e1.gl;
        this.texture ? (t.bindTexture(t.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, this.width, this.height, t.ALPHA, t.UNSIGNED_BYTE, this.data))) : (this.texture = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this.texture), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texImage2D(t.TEXTURE_2D, 0, t.ALPHA, this.width, this.height, 0, t.ALPHA, t.UNSIGNED_BYTE, this.data));
    }
};
function $4324d99ae8520741$var$Wi(e1) {
    if (!e1) return !1;
    let t = globalThis.location;
    if (!t) return !1;
    try {
        return new URL(e1, t.href).origin !== t.origin;
    } catch  {
        return !1;
    }
}
function $4324d99ae8520741$var$Gi() {
    let e1 = "file:///node_modules/maplibre-gl/dist/maplibre-gl.mjs";
    if (!/^https?:/.test(e1)) return ``;
    let t = e1.endsWith(`-dev.mjs`) ? `maplibre-gl-worker-dev.mjs` : `maplibre-gl-worker.mjs`;
    return new URL(`./${t}`, e1).href;
}
function $4324d99ae8520741$var$Ki(e1, t) {
    if (t) try {
        return new Worker(e1, {
            type: `module`
        });
    } catch (e1) {
        console.warn(`Module worker not supported, falling back to classic worker`, e1);
    }
    return new Worker(e1);
}
async function $4324d99ae8520741$var$qi(e1) {
    let t = await fetch(e1);
    if (!t.ok) throw Error(`Failed to fetch worker script (${t.status}): ${e1}`);
    let n = await t.text(), r = new Blob([
        n
    ], {
        type: `text/javascript`
    });
    return URL.createObjectURL(r);
}
function $4324d99ae8520741$var$Ji(e1) {
    let t = new Blob([
        `import ${JSON.stringify(new URL(e1, "file:///node_modules/maplibre-gl/dist/maplibre-gl.mjs").href)}`
    ], {
        type: `text/javascript`
    });
    return URL.createObjectURL(t);
}
async function $4324d99ae8520741$var$Yi() {
    let e1 = (0, $1G0Uw.An).WORKER_URL || $4324d99ae8520741$var$Gi(), t = !e1?.endsWith(`.cjs`);
    if (!$4324d99ae8520741$var$Wi(e1)) return $4324d99ae8520741$var$Ki(e1, t);
    if (t) {
        let n = $4324d99ae8520741$var$Ji(e1);
        try {
            return $4324d99ae8520741$var$Ki(n, t);
        } finally{
            URL.revokeObjectURL(n);
        }
    }
    let n = await $4324d99ae8520741$var$qi(e1);
    try {
        return $4324d99ae8520741$var$Ki(n, t);
    } finally{
        URL.revokeObjectURL(n);
    }
}
const $4324d99ae8520741$var$Xi = `maplibre_preloaded_worker_pool`;
var $4324d99ae8520741$var$Zi = class e1 {
    constructor(){
        this.active = {}, this.workersPromise = null;
    }
    async acquire(t) {
        if (this.active[t] = !0, !this.workersPromise) {
            let t = [];
            for(; t.length < e1.workerCount;)t.push($4324d99ae8520741$var$Yi());
            this.workersPromise = Promise.all(t);
        }
        return (await this.workersPromise).slice();
    }
    release(e1) {
        if (delete this.active[e1], this.numActive() === 0 && this.workersPromise) {
            let e1 = this.workersPromise;
            this.workersPromise = null, e1.then((e1)=>{
                for (let t of e1)t.terminate();
            });
        }
    }
    isPreloaded() {
        return !!this.active[$4324d99ae8520741$var$Xi];
    }
    numActive() {
        return Object.keys(this.active).length;
    }
};
const $4324d99ae8520741$var$Qi = Math.floor($4324d99ae8520741$var$Rr.hardwareConcurrency / 2);
$4324d99ae8520741$var$Zi.workerCount = (0, $1G0Uw.ur)(globalThis) ? Math.max(Math.min($4324d99ae8520741$var$Qi, 3), 1) : 1;
let $4324d99ae8520741$var$$i;
function $4324d99ae8520741$var$ea() {
    return $4324d99ae8520741$var$$i ||= new $4324d99ae8520741$var$Zi, $4324d99ae8520741$var$$i;
}
function $4324d99ae8520741$export$ea453d9c8cc3d5d2() {
    $4324d99ae8520741$var$ea().acquire($4324d99ae8520741$var$Xi);
}
function $4324d99ae8520741$export$3b8bb46c10ecf86e() {
    let e1 = $4324d99ae8520741$var$$i;
    e1 && (e1.isPreloaded() && e1.numActive() === 1 ? (e1.release($4324d99ae8520741$var$Xi), $4324d99ae8520741$var$$i = null) : console.warn(`Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()`));
}
var $4324d99ae8520741$var$ra = class {
    constructor(e1, t){
        this.workerPool = e1, this.actors = [], this.currentActor = 0, this.id = t, this.removed = !1, this.actorsPromise = this.initActors(t);
    }
    async initActors(e1) {
        let t = await this.workerPool.acquire(e1);
        if (this.removed) return [];
        if (this.actors = t.map((t, n)=>{
            let r = new (0, $1G0Uw.g)(t, e1);
            return r.name = `Worker ${n}`, r;
        }), !this.actors.length) throw Error(`No actors found`);
        return this.actors;
    }
    async broadcast(e1, t) {
        let n = await this.actorsPromise;
        return Promise.all(n.map((n)=>n.sendAsync({
                type: e1,
                data: t
            })));
    }
    async getActor() {
        let e1 = await this.actorsPromise;
        return this.currentActor = (this.currentActor + 1) % e1.length, e1[this.currentActor];
    }
    async waitForInitComplete() {
        this.actors.length === 0 && await this.actorsPromise;
    }
    getReadyActor() {
        return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
    }
    remove(e1 = !0) {
        this.removed = !0;
        for (let e1 of this.actors)e1.remove();
        this.actors = [], e1 && this.workerPool.release(this.id);
    }
    async registerMessageHandler(e1, t) {
        let n = await this.actorsPromise;
        for (let r of n)r.registerMessageHandler(e1, t);
    }
    async unregisterMessageHandler(e1) {
        let t = await this.actorsPromise;
        for (let n of t)n.unregisterMessageHandler(e1);
    }
};
let $4324d99ae8520741$var$ia;
function $4324d99ae8520741$export$6f0c702cbe7d6ed8() {
    return $4324d99ae8520741$var$ia || ($4324d99ae8520741$var$ia = new $4324d99ae8520741$var$ra($4324d99ae8520741$var$ea(), (0, $1G0Uw.bn)), $4324d99ae8520741$var$ia.registerMessageHandler(`GR`, (e1, t, n)=>(0, $1G0Uw.Tn)(t, n))), $4324d99ae8520741$var$ia;
}
function $4324d99ae8520741$var$oa(e1, t) {
    let n = (0, $1G0Uw.vi)();
    return (0, $1G0Uw.ji)(n, n, [
        1,
        1,
        0
    ]), (0, $1G0Uw.Ai)(n, n, [
        e1.width * .5,
        e1.height * .5,
        1
    ]), e1.calculatePosMatrix ? (0, $1G0Uw.wi)(n, n, e1.calculatePosMatrix(t.toUnwrapped())) : n;
}
function $4324d99ae8520741$var$sa(e1, t, n) {
    if (e1) for (let r of e1){
        let e1 = t[r];
        if (e1?.source === n && e1.type === `fill-extrusion`) return !0;
    }
    else for(let e1 in t){
        let r = t[e1];
        if (r.source === n && r.type === `fill-extrusion`) return !0;
    }
    return !1;
}
function $4324d99ae8520741$var$ca(e1, t, n, r, i, a, o) {
    let s = $4324d99ae8520741$var$sa(i?.layers ?? null, t, e1.id), c = a.maxPitchScaleFactor(), l = e1.tilesIn(r, c, s);
    l.sort($4324d99ae8520741$var$da);
    let u = [];
    for (let r of l)u.push({
        wrappedTileID: r.tileID.wrapped().key,
        queryResults: r.tile.queryRenderedFeatures(t, n, e1.getState(), r.queryGeometry, r.cameraQueryGeometry, r.scale, i, a, c, $4324d99ae8520741$var$oa(a, r.tileID), o ? (e1, t)=>o(r.tileID, e1, t) : void 0)
    });
    return $4324d99ae8520741$var$pa($4324d99ae8520741$var$fa(u), e1);
}
function $4324d99ae8520741$var$la(e1, t, n, r, i, a, o) {
    let s = {}, c = a.queryRenderedSymbols(r), l = [];
    for (let e1 of Object.keys(c).map(Number))l.push(o[e1]);
    l.sort($4324d99ae8520741$var$da);
    for (let n of l){
        let r = n.featureIndex.lookupSymbolFeatures(c[n.bucketInstanceId], t, n.bucketIndex, n.sourceLayerIndex, {
            filterSpec: i.filter,
            globalState: i.globalState
        }, i.layers, i.availableImages, e1);
        for(let e1 in r){
            s[e1] ||= [];
            let t = r[e1];
            t.sort((e1, t)=>{
                let r = n.featureSortOrder;
                if (r) {
                    let n = r.indexOf(e1.featureIndex);
                    return r.indexOf(t.featureIndex) - n;
                }
                return t.featureIndex - e1.featureIndex;
            });
            for (let n of t)s[e1].push(n);
        }
    }
    return $4324d99ae8520741$var$ma(s, e1, n);
}
function $4324d99ae8520741$var$ua(e1, t) {
    let n = e1.getRenderableIds().map((t)=>e1.getTileByID(t)), r = [], i = {};
    for (let e1 of n){
        let n = e1.tileID.canonical.key;
        i[n] || (i[n] = !0, e1.querySourceFeatures(r, t));
    }
    return r;
}
function $4324d99ae8520741$var$da(e1, t) {
    let n = e1.tileID, r = t.tileID;
    return n.overscaledZ - r.overscaledZ || n.canonical.y - r.canonical.y || n.wrap - r.wrap || n.canonical.x - r.canonical.x;
}
function $4324d99ae8520741$var$fa(e1) {
    let t = {}, n = {};
    for (let { queryResults: r, wrappedTileID: i } of e1){
        n[i] ||= {};
        let e1 = n[i];
        for(let n in r){
            let i = r[n];
            e1[n] ||= {};
            let a = e1[n];
            t[n] ||= [];
            for (let e1 of i)a[e1.featureIndex] || (a[e1.featureIndex] = !0, t[n].push(e1));
        }
    }
    return t;
}
function $4324d99ae8520741$var$pa(e1, t) {
    for(let n in e1)for (let r of e1[n])$4324d99ae8520741$var$ha(r, t);
    return e1;
}
function $4324d99ae8520741$var$ma(e1, t, n) {
    for(let r in e1)for (let i of e1[r]){
        let e1 = n[t[r].source];
        $4324d99ae8520741$var$ha(i, e1);
    }
    return e1;
}
function $4324d99ae8520741$var$ha(e1, t) {
    let n = e1.feature, r = t.getFeatureState(n.layer[`source-layer`], n.id);
    n.source = n.layer.source, n.layer[`source-layer`] && (n.sourceLayer = n.layer[`source-layer`]), n.state = r;
}
async function $4324d99ae8520741$var$ga(e1, t, n, r) {
    let i = e1;
    if (e1.url ? i = (await (0, $1G0Uw.Sn)(await t.transformRequest(e1.url, `Source`), n)).data : await $4324d99ae8520741$var$Rr.frameAsync(n, r), !i) return null;
    let a = (0, $1G0Uw.yr)((0, $1G0Uw.er)(i, e1), [
        `tiles`,
        `minzoom`,
        `maxzoom`,
        `attribution`,
        `bounds`,
        `scheme`,
        `tileSize`,
        `encoding`
    ]);
    return `vector_layers` in i && i.vector_layers && (a.vectorLayerIds = i.vector_layers.map((e1)=>e1.id)), a;
}
var $4324d99ae8520741$export$266d2884f61535d3 = class e1 {
    constructor(e1, t){
        e1 && (t ? this.setSouthWest(e1).setNorthEast(t) : Array.isArray(e1) && (e1.length === 4 ? this.setSouthWest([
            e1[0],
            e1[1]
        ]).setNorthEast([
            e1[2],
            e1[3]
        ]) : this.setSouthWest(e1[0]).setNorthEast(e1[1])));
    }
    setNorthEast(e1) {
        return this._ne = e1 instanceof (0, $1G0Uw.lt) ? new (0, $1G0Uw.lt)(e1.lng, e1.lat) : (0, $1G0Uw.lt).convert(e1), this;
    }
    setSouthWest(e1) {
        return this._sw = e1 instanceof (0, $1G0Uw.lt) ? new (0, $1G0Uw.lt)(e1.lng, e1.lat) : (0, $1G0Uw.lt).convert(e1), this;
    }
    extend(t) {
        let n = this._sw, r = this._ne, i, a;
        if (t instanceof (0, $1G0Uw.lt)) i = t, a = t;
        else if (t instanceof e1) {
            if (i = t._sw, a = t._ne, !i || !a) return this;
        } else {
            if (Array.isArray(t)) {
                if (t.length === 4 || t.every(Array.isArray)) {
                    let n = t;
                    return this.extend(e1.convert(n));
                }
                {
                    let e1 = t;
                    return this.extend((0, $1G0Uw.lt).convert(e1));
                }
            }
            return t && (`lng` in t || `lon` in t) && `lat` in t ? this.extend((0, $1G0Uw.lt).convert(t)) : this;
        }
        return !n && !r ? (this._sw = new (0, $1G0Uw.lt)(i.lng, i.lat), this._ne = new (0, $1G0Uw.lt)(a.lng, a.lat)) : (n.lng = Math.min(i.lng, n.lng), n.lat = Math.min(i.lat, n.lat), r.lng = Math.max(a.lng, r.lng), r.lat = Math.max(a.lat, r.lat)), this;
    }
    getCenter() {
        return new (0, $1G0Uw.lt)((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
    }
    getSouthWest() {
        return this._sw;
    }
    getNorthEast() {
        return this._ne;
    }
    getNorthWest() {
        return new (0, $1G0Uw.lt)(this.getWest(), this.getNorth());
    }
    getSouthEast() {
        return new (0, $1G0Uw.lt)(this.getEast(), this.getSouth());
    }
    getWest() {
        return this._sw.lng;
    }
    getSouth() {
        return this._sw.lat;
    }
    getEast() {
        return this._ne.lng;
    }
    getNorth() {
        return this._ne.lat;
    }
    toArray() {
        return [
            this._sw.toArray(),
            this._ne.toArray()
        ];
    }
    toString() {
        return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
    }
    isEmpty() {
        return !(this._sw && this._ne);
    }
    contains(e1) {
        let { lng: t, lat: n } = (0, $1G0Uw.lt).convert(e1), r = this._sw.lat <= n && n <= this._ne.lat, i = this._sw.lng <= t && t <= this._ne.lng;
        return this._sw.lng > this._ne.lng && (i = this._sw.lng >= t && t >= this._ne.lng), r && i;
    }
    intersects(t) {
        if (t = e1.convert(t), !(t.getNorth() >= this.getSouth() && t.getSouth() <= this.getNorth())) return !1;
        let n = Math.abs(this.getEast() - this.getWest()), r = Math.abs(t.getEast() - t.getWest());
        if (n >= 360 || r >= 360) return !0;
        let i = (0, $1G0Uw.Pr)(this.getWest(), -180, 180), a = (0, $1G0Uw.Pr)(this.getEast(), -180, 180), o = (0, $1G0Uw.Pr)(t.getWest(), -180, 180), s = (0, $1G0Uw.Pr)(t.getEast(), -180, 180), c = i > a, l = o > s;
        return c && l ? !0 : c ? s >= i || o <= a : l ? a >= o || i <= s : o <= a && s >= i;
    }
    static convert(t) {
        return t instanceof e1 || !t ? t : new e1(t);
    }
    static fromLngLat(t, n = 0) {
        let r = 360 * n / 40075017, i = r / Math.cos(Math.PI / 180 * t.lat);
        return new e1(new (0, $1G0Uw.lt)(t.lng - i, t.lat - r), new (0, $1G0Uw.lt)(t.lng + i, t.lat + r));
    }
    adjustAntiMeridian() {
        let t = new (0, $1G0Uw.lt)(this._sw.lng, this._sw.lat), n = new (0, $1G0Uw.lt)(this._ne.lng, this._ne.lat);
        return t.lng > n.lng ? new e1(t, new (0, $1G0Uw.lt)(n.lng + 360, n.lat)) : new e1(t, n);
    }
}, $4324d99ae8520741$var$va = class {
    constructor(e1, t, n){
        this.bounds = $4324d99ae8520741$export$266d2884f61535d3.convert(this.validateBounds(e1)), this.minzoom = t || 0, this.maxzoom = n || 24;
    }
    validateBounds(e1) {
        return !Array.isArray(e1) || e1.length !== 4 ? [
            -180,
            -90,
            180,
            90
        ] : [
            Math.max(-180, e1[0]),
            Math.max(-90, e1[1]),
            Math.min(180, e1[2]),
            Math.min(90, e1[3])
        ];
    }
    contains(e1) {
        let t = 2 ** e1.z, n = {
            minX: Math.floor((0, $1G0Uw.ot)(this.bounds.getWest()) * t),
            minY: Math.floor((0, $1G0Uw.st)(this.bounds.getNorth()) * t),
            maxX: Math.ceil((0, $1G0Uw.ot)(this.bounds.getEast()) * t),
            maxY: Math.ceil((0, $1G0Uw.st)(this.bounds.getSouth()) * t)
        };
        return e1.x >= n.minX && e1.x < n.maxX && e1.y >= n.minY && e1.y < n.maxY;
    }
}, $4324d99ae8520741$export$5feeb63c172810c5 = class extends (0, $1G0Uw.vn) {
    constructor(e1, t, n, r){
        if (super(), this.id = e1, this.dispatcher = n, this.type = `vector`, this.minzoom = 0, this.maxzoom = 22, this.scheme = `xyz`, this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, (0, $1G0Uw.er)(this, (0, $1G0Uw.yr)(t, [
            `url`,
            `scheme`,
            `tileSize`,
            `promoteId`,
            `encoding`
        ])), this._options = (0, $1G0Uw.er)({
            type: `vector`
        }, t), this._collectResourceTiming = t.collectResourceTiming, this.tileSize !== 512) throw Error(`vector tile sources must have a tileSize of 512`);
        this.setEventedParent(r);
    }
    async load(e1 = !1) {
        this._loaded = !1, this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`dataloading`)), this._tileJSONRequest = new AbortController;
        try {
            let t = await $4324d99ae8520741$var$ga(this._options, this.map._requestManager, this._tileJSONRequest, this.map._ownerWindow);
            this._tileJSONRequest = null, this._loaded = !0, t && ((0, $1G0Uw.er)(this, t), t.bounds && (this.tileBounds = new $4324d99ae8520741$var$va(t.bounds, this.minzoom, this.maxzoom)), this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `metadata`
            })), this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `content`,
                sourceDataChanged: e1
            })));
        } catch (e1) {
            this._tileJSONRequest = null, this._loaded = !0, (0, $1G0Uw.Mn)(e1) || this.fire(new (0, $1G0Uw.gn)((0, $1G0Uw.Qn)(e1)));
        }
    }
    loaded() {
        return this._loaded;
    }
    hasTile(e1) {
        return !this.tileBounds || this.tileBounds.contains(e1.canonical);
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    setSourceProperty(e1) {
        this._tileJSONRequest && this._tileJSONRequest.abort(), e1(), this.load(!0);
    }
    setTiles(e1) {
        return this.setSourceProperty(()=>{
            this.tiles = e1, this._options.tiles = e1;
        }), this;
    }
    setUrl(e1) {
        return this.setSourceProperty(()=>{
            this.url = e1, this._options.url = e1;
        }), this;
    }
    onRemove() {
        this._tileJSONRequest &&= (this._tileJSONRequest.abort(), null);
    }
    serialize() {
        return (0, $1G0Uw.er)({}, this._options);
    }
    async loadTile(e1) {
        let t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), n = {
            request: await this.map._requestManager.transformRequest(t, `Tile`),
            uid: e1.uid,
            tileID: e1.tileID,
            zoom: e1.tileID.overscaledZ,
            tileSize: this.tileSize * e1.tileID.overscaleFactor(),
            type: this.type,
            source: this.id,
            pixelRatio: this.map.getPixelRatio(),
            showCollisionBoxes: this.map.showCollisionBoxes,
            promoteId: this.promoteId,
            subdivisionGranularity: this.map.style.projection.subdivisionGranularity,
            encoding: this.encoding,
            overzoomParameters: await this._getOverzoomParameters(e1),
            etag: e1.etag
        };
        n.request.collectResourceTiming = this._collectResourceTiming, await this.dispatcher.waitForInitComplete();
        let r = `RT`;
        if (!e1.actor || e1.state === `expired`) e1.actor = this.dispatcher.getReadyActor(), r = `LT`;
        else if (e1.state === `loading`) return new Promise((t, n)=>{
            e1.reloadPromise = {
                resolve: t,
                reject: n
            };
        });
        e1.abortController = new AbortController;
        try {
            let t = await e1.actor.sendAsync({
                type: r,
                data: n
            }, e1.abortController);
            if (delete e1.abortController, e1.aborted) return;
            this._afterTileLoadWorkerResponse(e1, t);
            let i = {};
            return t?.etagUnmodified && (i.unmodified = !0), i;
        } catch (t) {
            if (delete e1.abortController, e1.aborted || (0, $1G0Uw.Mn)(t)) return;
            if (t && t.status !== 404) throw t;
            this._afterTileLoadWorkerResponse(e1, null);
        }
    }
    async _getOverzoomParameters(e1) {
        if (e1.tileID.canonical.z <= this.maxzoom || this.map._zoomLevelsToOverscale === void 0) return;
        let t = e1.tileID.scaledTo(this.maxzoom).canonical, n = t.url(this.tiles, this.map.getPixelRatio(), this.scheme);
        return {
            maxZoomTileID: t,
            overzoomRequest: await this.map._requestManager.transformRequest(n, `Tile`)
        };
    }
    _afterTileLoadWorkerResponse(e1, t) {
        if (t?.resourceTiming && (e1.resourceTiming = t.resourceTiming), t && this.map._refreshExpiredTiles && e1.setExpiryData(t), e1.etag = t?.etag, e1.loadVectorData(t, this.map.painter), e1.reloadPromise) {
            let t = e1.reloadPromise;
            e1.reloadPromise = null, this.loadTile(e1).then(t.resolve).catch(t.reject);
        }
    }
    async abortTile(e1) {
        e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.actor && await e1.actor.sendAsync({
            type: `AT`,
            data: {
                uid: e1.uid,
                type: this.type,
                source: this.id
            }
        });
    }
    async unloadTile(e1) {
        e1.unloadVectorData(), e1.actor && await e1.actor.sendAsync({
            type: `RMT`,
            data: {
                uid: e1.uid,
                type: this.type,
                source: this.id
            }
        });
    }
    hasTransition() {
        return !1;
    }
}, $4324d99ae8520741$export$908e4015b805db3c = class extends (0, $1G0Uw.vn) {
    constructor(e1, t, n, r){
        super(), this.id = e1, this.dispatcher = n, this.setEventedParent(r), this.type = `raster`, this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = `xyz`, this.tileSize = 512, this._loaded = !1, this._premultiplyAlpha = !0, this._options = (0, $1G0Uw.er)({
            type: `raster`
        }, t), (0, $1G0Uw.er)(this, (0, $1G0Uw.yr)(t, [
            `url`,
            `scheme`,
            `tileSize`
        ]));
    }
    async load(e1 = !1) {
        this._loaded = !1, this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`dataloading`)), this._tileJSONRequest = new AbortController;
        try {
            let t = await $4324d99ae8520741$var$ga(this._options, this.map._requestManager, this._tileJSONRequest, this.map._ownerWindow);
            this._tileJSONRequest = null, this._loaded = !0, t && ((0, $1G0Uw.er)(this, t), t.bounds && (this.tileBounds = new $4324d99ae8520741$var$va(t.bounds, this.minzoom, this.maxzoom)), this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `metadata`
            })), this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `content`,
                sourceDataChanged: e1
            })));
        } catch (e1) {
            this._tileJSONRequest = null, this._loaded = !0, (0, $1G0Uw.Mn)(e1) || this.fire(new (0, $1G0Uw.gn)((0, $1G0Uw.Qn)(e1)));
        }
    }
    loaded() {
        return this._loaded;
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    onRemove() {
        this._tileJSONRequest &&= (this._tileJSONRequest.abort(), null);
    }
    setSourceProperty(e1) {
        this._tileJSONRequest &&= (this._tileJSONRequest.abort(), null), e1(), this.load(!0);
    }
    setTiles(e1) {
        return this.setSourceProperty(()=>{
            this.tiles = e1, this._options.tiles = e1;
        }), this;
    }
    setUrl(e1) {
        return this.setSourceProperty(()=>{
            this.url = e1, this._options.url = e1;
        }), this;
    }
    serialize() {
        return (0, $1G0Uw.er)({}, this._options);
    }
    setPremultiplyAlpha(e1) {
        return this._premultiplyAlpha === e1 || this.setSourceProperty(()=>{
            this._premultiplyAlpha = e1;
        }), this;
    }
    hasTile(e1) {
        return !this.tileBounds || this.tileBounds.contains(e1.canonical);
    }
    async loadTile(e1) {
        let t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), n = this._premultiplyAlpha, r = n ? void 0 : {
            premultiplyAlpha: `none`
        };
        e1.abortController = new AbortController;
        try {
            let i = await $4324d99ae8520741$var$Ur.transformAndGetImage(this.map._requestManager, t, `Tile`, e1.abortController, this.map._refreshExpiredTiles, r);
            if (delete e1.abortController, e1.aborted) {
                e1.state = `unloaded`;
                return;
            }
            if (i) {
                this.map._refreshExpiredTiles && (i.cacheControl || i.expires) && e1.setExpiryData({
                    cacheControl: i.cacheControl,
                    expires: i.expires
                });
                let t = this.map.painter.context, r = t.gl, a = i.data ?? new (0, $1G0Uw.Dt)({
                    width: 1,
                    height: 1
                }, new Uint8Array(4));
                e1.texture = this.map.painter.getTileTexture(a.width), e1.texture ? e1.texture.update(a, {
                    useMipmap: !0,
                    premultiply: n
                }) : (e1.texture = new (0, $1G0Uw.xt)(t, a, r.RGBA, {
                    useMipmap: !0,
                    premultiply: n
                }), e1.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE, r.LINEAR_MIPMAP_NEAREST)), e1.state = `loaded`;
            }
        } catch (t) {
            if (delete e1.abortController, e1.aborted) e1.state = `unloaded`;
            else if (t) throw e1.state = `errored`, t;
        }
    }
    async abortTile(e1) {
        e1.abortController && (e1.abortController.abort(), delete e1.abortController);
    }
    async unloadTile(e1) {
        e1.texture && this.map.painter.saveTileTexture(e1.texture);
    }
    hasTransition() {
        return !1;
    }
}, $4324d99ae8520741$export$12673e0db63b98e3 = class extends $4324d99ae8520741$export$908e4015b805db3c {
    constructor(e1, t, n, r){
        super(e1, t, n, r), this.type = `raster-dem`, this.maxzoom = 22, this._options = (0, $1G0Uw.er)({
            type: `raster-dem`
        }, t), this.encoding = t.encoding || `mapbox`, this.redFactor = t.redFactor, this.greenFactor = t.greenFactor, this.blueFactor = t.blueFactor, this.baseShift = t.baseShift;
    }
    async loadTile(e1) {
        let t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
        e1.neighboringTiles = this._getNeighboringTiles(e1.tileID), e1.abortController = new AbortController;
        try {
            let n = await $4324d99ae8520741$var$Ur.transformAndGetImage(this.map._requestManager, t, `Tile`, e1.abortController, this.map._refreshExpiredTiles, {
                colorSpaceConversion: `none`
            });
            if (delete e1.abortController, e1.aborted) {
                e1.state = `unloaded`;
                return;
            }
            if (n) {
                if (this.map._refreshExpiredTiles && (n.cacheControl || n.expires) && e1.setExpiryData({
                    cacheControl: n.cacheControl,
                    expires: n.expires
                }), !n.data) {
                    e1.state = `loaded`;
                    return;
                }
                let t = n.data, r = (0, $1G0Uw.cr)(t) && (0, $1G0Uw.Ii)() ? t : await this.readImageNow(t), i = {
                    type: this.type,
                    uid: e1.uid,
                    source: this.id,
                    rawImageData: r,
                    encoding: this.encoding,
                    redFactor: this.redFactor,
                    greenFactor: this.greenFactor,
                    blueFactor: this.blueFactor,
                    baseShift: this.baseShift
                };
                if (e1.actor && e1.state !== `expired` && e1.state !== `reloading`) return;
                await this.dispatcher.waitForInitComplete(), (!e1.actor || e1.state === `expired`) && (e1.actor = this.dispatcher.getReadyActor()), e1.dem = await e1.actor.sendAsync({
                    type: `LDT`,
                    data: i
                }), e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0, e1.needsColorReliefPrepare = !0, e1.state = `loaded`;
            }
        } catch (t) {
            if (delete e1.abortController, e1.aborted) e1.state = `unloaded`;
            else if (t) throw e1.state = `errored`, t;
        }
    }
    async readImageNow(e1) {
        if (typeof VideoFrame < `u` && (0, $1G0Uw.Fi)()) {
            let t = e1.width + 4, n = e1.height + 4;
            try {
                return new (0, $1G0Uw.Dt)({
                    width: t,
                    height: n
                }, await (0, $1G0Uw.Cr)(e1, -2, -2, t, n));
            } catch  {}
        }
        return $4324d99ae8520741$var$Rr.getImageData(e1, 2);
    }
    _getNeighboringTiles(e1) {
        let t = e1.canonical, n = 2 ** t.z, r = (t.x - 1 + n) % n, i = t.x === 0 ? e1.wrap - 1 : e1.wrap, a = (t.x + 1 + n) % n, o = t.x + 1 === n ? e1.wrap + 1 : e1.wrap, s = {};
        return s[new (0, $1G0Uw.d)(e1.overscaledZ, i, t.z, r, t.y).key] = {
            backfilled: !1
        }, s[new (0, $1G0Uw.d)(e1.overscaledZ, o, t.z, a, t.y).key] = {
            backfilled: !1
        }, t.y > 0 && (s[new (0, $1G0Uw.d)(e1.overscaledZ, i, t.z, r, t.y - 1).key] = {
            backfilled: !1
        }, s[new (0, $1G0Uw.d)(e1.overscaledZ, e1.wrap, t.z, t.x, t.y - 1).key] = {
            backfilled: !1
        }, s[new (0, $1G0Uw.d)(e1.overscaledZ, o, t.z, a, t.y - 1).key] = {
            backfilled: !1
        }), t.y + 1 < n && (s[new (0, $1G0Uw.d)(e1.overscaledZ, i, t.z, r, t.y + 1).key] = {
            backfilled: !1
        }, s[new (0, $1G0Uw.d)(e1.overscaledZ, e1.wrap, t.z, t.x, t.y + 1).key] = {
            backfilled: !1
        }, s[new (0, $1G0Uw.d)(e1.overscaledZ, o, t.z, a, t.y + 1).key] = {
            backfilled: !1
        }), s;
    }
    async unloadTile(e1) {
        e1.demTexture && this.map.painter.saveTileTexture(e1.demTexture), e1.fbo && (e1.fbo.destroy(), delete e1.fbo), e1.dem && delete e1.dem, delete e1.neighboringTiles, e1.state = `unloaded`, e1.actor && await e1.actor.sendAsync({
            type: `RDT`,
            data: {
                type: this.type,
                uid: e1.uid,
                source: this.id
            }
        });
    }
};
function $4324d99ae8520741$var$Sa(e1, t) {
    return t ? e1.properties[t] : e1.id;
}
function $4324d99ae8520741$var$Ca(e1, t) {
    let n = new Map;
    if (e1 == null || e1.type == null) return n;
    if (e1.type === `Feature`) {
        let r = $4324d99ae8520741$var$Sa(e1, t);
        return r == null ? void 0 : (n.set(r, e1), n);
    }
    if (e1.type === `FeatureCollection`) {
        let r = new Set;
        for (let i of e1.features){
            let e1 = $4324d99ae8520741$var$Sa(i, t);
            if (e1 == null || r.has(e1)) return;
            r.add(e1), n.set(e1, i);
        }
        return n;
    }
}
function $4324d99ae8520741$var$wa(e1, t, n) {
    let r = [];
    if (t.removeAll) e1.clear();
    else if (t.remove) for (let n of t.remove){
        let t = e1.get(n);
        t && (r.push(t.geometry), e1.delete(n));
    }
    if (t.add) for (let i of t.add){
        let t = $4324d99ae8520741$var$Sa(i, n);
        if (t == null) continue;
        let a = e1.get(t);
        a && r.push(a.geometry), r.push(i.geometry), e1.set(t, i);
    }
    if (t.update) for (let n of t.update){
        let t = e1.get(n.id);
        if (!t) continue;
        let i = !!n.newGeometry, a = n.removeAllProperties || n.removeProperties?.length > 0 || n.addOrUpdateProperties?.length > 0;
        if (!i && !a) continue;
        r.push(t.geometry);
        let o = {
            ...t
        };
        if (e1.set(n.id, o), i && (r.push(n.newGeometry), o.geometry = n.newGeometry), a) {
            if (o.properties = n.removeAllProperties ? {} : {
                ...o.properties || {}
            }, n.removeProperties) for (let e1 of n.removeProperties)delete o.properties[e1];
            if (n.addOrUpdateProperties) for (let { key: e1, value: t } of n.addOrUpdateProperties)o.properties[e1] = t;
        }
    }
    return r;
}
function $4324d99ae8520741$var$Ta(e1, t, n) {
    if (!e1) return t || {};
    if (!t) return e1 || {};
    n && ($4324d99ae8520741$var$Oa(e1.add, n), $4324d99ae8520741$var$Oa(t.add, n));
    let r = $4324d99ae8520741$var$Aa(e1), i = $4324d99ae8520741$var$Aa(t);
    $4324d99ae8520741$var$Ea(r, i);
    let a = {};
    if ((r.removeAll || i.removeAll) && (a.removeAll = !0), a.remove = new Set([
        ...r.remove,
        ...i.remove
    ]), a.add = new Map([
        ...r.add,
        ...i.add
    ]), a.update = new Map([
        ...r.update,
        ...i.update
    ]), a.remove.size && a.add.size) for (let e1 of a.add.keys())a.remove.delete(e1);
    let o = $4324d99ae8520741$var$ja(a);
    return n && $4324d99ae8520741$var$ka(o.add, n), o;
}
function $4324d99ae8520741$var$Ea(e1, t) {
    t.removeAll && (e1.add.clear(), e1.update.clear(), e1.remove.clear(), t.remove.clear());
    for (let n of t.remove)e1.add.delete(n), e1.update.delete(n);
    for (let [n, r] of t.update){
        let i = e1.update.get(n);
        i && (t.update.set(n, $4324d99ae8520741$var$Da(i, r)), e1.update.delete(n));
    }
}
function $4324d99ae8520741$var$Da(e1, t) {
    let n = {
        id: e1.id
    };
    if (t.removeAllProperties && (delete e1.removeProperties, delete e1.addOrUpdateProperties, delete t.removeProperties), t.removeProperties && e1.addOrUpdateProperties) {
        let n = new Set(t.removeProperties);
        e1.addOrUpdateProperties = e1.addOrUpdateProperties.filter((e1)=>!n.has(e1.key));
    }
    return (e1.removeAllProperties || t.removeAllProperties) && (n.removeAllProperties = !0), (e1.removeProperties || t.removeProperties) && (n.removeProperties = [
        ...e1.removeProperties || [],
        ...t.removeProperties || []
    ]), (e1.addOrUpdateProperties || t.addOrUpdateProperties) && (n.addOrUpdateProperties = [
        ...e1.addOrUpdateProperties || [],
        ...t.addOrUpdateProperties || []
    ]), (e1.newGeometry || t.newGeometry) && (n.newGeometry = t.newGeometry || e1.newGeometry), n;
}
function $4324d99ae8520741$var$Oa(e1, t) {
    if (e1) for (let n of e1){
        let e1 = $4324d99ae8520741$var$Sa(n, t);
        e1 != null && (n.id = e1);
    }
}
function $4324d99ae8520741$var$ka(e1, t) {
    if (e1) for (let n of e1)$4324d99ae8520741$var$Sa(n, t) != null && delete n.id;
}
function $4324d99ae8520741$var$Aa(e1) {
    if (!e1) return {};
    let t = {};
    return t.removeAll = e1.removeAll, t.remove = new Set(e1.remove || []), t.add = new Map(e1.add?.map((e1)=>[
            e1.id,
            e1
        ])), t.update = new Map(e1.update?.map((e1)=>[
            e1.id,
            e1
        ])), t;
}
function $4324d99ae8520741$var$ja(e1) {
    let t = {};
    return e1.removeAll && (t.removeAll = e1.removeAll), e1.remove && (t.remove = Array.from(e1.remove)), e1.add && (t.add = Array.from(e1.add.values())), e1.update && (t.update = Array.from(e1.update.values())), t;
}
function $4324d99ae8520741$var$Ma(e1) {
    return !e1 || e1.length === 0 ? [] : typeof e1[0] == `number` ? [
        e1
    ] : e1.flatMap((e1)=>$4324d99ae8520741$var$Ma(e1));
}
function $4324d99ae8520741$var$Na(e1) {
    return e1.type === `GeometryCollection` ? e1.geometries.flatMap((e1)=>$4324d99ae8520741$var$Na(e1)) : $4324d99ae8520741$var$Ma(e1.coordinates);
}
function $4324d99ae8520741$var$Pa(e1) {
    let t = new $4324d99ae8520741$export$266d2884f61535d3, n;
    switch(e1.type){
        case `FeatureCollection`:
            n = e1.features.flatMap((e1)=>$4324d99ae8520741$var$Na(e1.geometry));
            break;
        case `Feature`:
            n = $4324d99ae8520741$var$Na(e1.geometry);
            break;
        default:
            n = $4324d99ae8520741$var$Na(e1);
    }
    if (n.length === 0) return t;
    for (let e1 of n){
        let [n, r] = e1;
        t.extend([
            n,
            r
        ]);
    }
    return t;
}
function $4324d99ae8520741$var$Fa({ x: e1, y: t, z: n }, r = 0) {
    let i = (0, $1G0Uw.at)((e1 - r) / 2 ** n), a = (0, $1G0Uw.it)((t + 1 + r) / 2 ** n), o = (0, $1G0Uw.at)((e1 + 1 + r) / 2 ** n), s = (0, $1G0Uw.it)((t - r) / 2 ** n);
    return new $4324d99ae8520741$export$266d2884f61535d3([
        i,
        a
    ], [
        o,
        s
    ]);
}
var $4324d99ae8520741$export$8a9e6af3bfd58eb9 = class extends (0, $1G0Uw.vn) {
    constructor(e1, t, n, r){
        super(), this.id = e1, this.type = `geojson`, this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._isUpdatingWorker = !1, this._pendingWorkerUpdate = {
            data: t.data
        }, this.actorPromise = n.getActor(), this.setEventedParent(r), this._data = typeof t.data == `string` ? {
            url: t.data
        } : {
            geojson: t.data
        }, this._options = (0, $1G0Uw.er)({}, t), this._collectResourceTiming = t.collectResourceTiming, t.maxzoom !== void 0 && (this.maxzoom = t.maxzoom), t.type && (this.type = t.type), t.attribution && (this.attribution = t.attribution), this.promoteId = t.promoteId, t.clusterMaxZoom !== void 0 && this.maxzoom <= t.clusterMaxZoom && (0, $1G0Uw.Nr)(`The maxzoom value "${this.maxzoom}" is expected to be greater than the clusterMaxZoom value "${t.clusterMaxZoom}".`), this.workerOptions = (0, $1G0Uw.er)({
            source: this.id,
            geojsonVtOptions: {
                buffer: this._pixelsToTileUnits(t.buffer === void 0 ? 128 : t.buffer),
                tolerance: this._pixelsToTileUnits(t.tolerance === void 0 ? .375 : t.tolerance),
                extent: (0, $1G0Uw.Lr),
                maxZoom: this.maxzoom,
                lineMetrics: t.lineMetrics || !1,
                generateId: t.generateId || !1,
                promoteId: typeof t.promoteId == `string` ? t.promoteId : void 0,
                cluster: t.cluster || !1,
                clusterOptions: {
                    maxZoom: this._getClusterMaxZoom(t.clusterMaxZoom),
                    minPoints: Math.max(2, t.clusterMinPoints || 2),
                    extent: (0, $1G0Uw.Lr),
                    radius: this._pixelsToTileUnits(t.clusterRadius || 50),
                    log: !1,
                    generateId: t.generateId || !1
                }
            },
            clusterProperties: t.clusterProperties,
            filter: t.filter
        }, t.workerOptions);
    }
    _hasPendingWorkerUpdate() {
        return this._pendingWorkerUpdate.data !== void 0 || this._pendingWorkerUpdate.diff !== void 0 || this._pendingWorkerUpdate.updateCluster;
    }
    _pixelsToTileUnits(e1) {
        return e1 * ((0, $1G0Uw.Lr) / this.tileSize);
    }
    _tileUnitsToPixels(e1) {
        return e1 / ((0, $1G0Uw.Lr) / this.tileSize);
    }
    _getClusterMaxZoom(e1) {
        let t = e1 ? Math.round(e1) : this.maxzoom - 1;
        return Number.isInteger(e1) || e1 === void 0 || (0, $1G0Uw.Nr)(`Integer expected for option 'clusterMaxZoom': provided value "${e1}" rounded to "${t}"`), t;
    }
    async load() {
        await this._updateWorkerData();
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    setData(e1) {
        return this._data = typeof e1 == `string` ? {
            url: e1
        } : {
            geojson: e1
        }, this._pendingWorkerUpdate = {
            data: e1
        }, this._updateWorkerData();
    }
    updateData(e1) {
        return this._pendingWorkerUpdate.diff = $4324d99ae8520741$var$Ta(this._pendingWorkerUpdate.diff, e1), this._updateWorkerData();
    }
    async getData() {
        return this._data.url && await this.once(`data`), this._data.geojson ? this._data.geojson : {
            type: `FeatureCollection`,
            features: Array.from(this._data.updateable.values())
        };
    }
    async getBounds() {
        return $4324d99ae8520741$var$Pa(await this.getData());
    }
    setClusterOptions(e1) {
        return this.workerOptions.geojsonVtOptions.cluster = e1.cluster, e1.clusterRadius !== void 0 && (this.workerOptions.geojsonVtOptions.clusterOptions.radius = this._pixelsToTileUnits(e1.clusterRadius)), e1.clusterMaxZoom !== void 0 && (this.workerOptions.geojsonVtOptions.clusterOptions.maxZoom = this._getClusterMaxZoom(e1.clusterMaxZoom)), this._pendingWorkerUpdate.updateCluster = !0, this._updateWorkerData();
    }
    getClusterOptions() {
        let { cluster: e1, clusterOptions: t } = this.workerOptions.geojsonVtOptions;
        return {
            cluster: e1,
            clusterMaxZoom: t.maxZoom,
            clusterRadius: this._tileUnitsToPixels(t.radius)
        };
    }
    async getClusterExpansionZoom(e1) {
        return (await this.actorPromise).sendAsync({
            type: `GCEZ`,
            data: {
                type: this.type,
                clusterId: e1,
                source: this.id
            }
        });
    }
    async getClusterChildren(e1) {
        return (await this.actorPromise).sendAsync({
            type: `GCC`,
            data: {
                type: this.type,
                clusterId: e1,
                source: this.id
            }
        });
    }
    async getClusterLeaves(e1, t, n) {
        return (await this.actorPromise).sendAsync({
            type: `GCL`,
            data: {
                type: this.type,
                source: this.id,
                clusterId: e1,
                limit: t,
                offset: n
            }
        });
    }
    async _updateWorkerData() {
        if (this._isUpdatingWorker) return this._updatePromise;
        if (!this._hasPendingWorkerUpdate()) {
            (0, $1G0Uw.Nr)(`No pending worker updates for GeoJSONSource ${this.id}.`);
            return;
        }
        let { data: e1, diff: t, updateCluster: n } = this._pendingWorkerUpdate, r = this._getLoadGeoJSONParameters(e1, t, n);
        e1 === void 0 ? t ? this._pendingWorkerUpdate.diff = void 0 : n && (this._pendingWorkerUpdate.updateCluster = void 0) : this._pendingWorkerUpdate.data = void 0, this._updatePromise = this._dispatchWorkerUpdate(r), await this._updatePromise;
    }
    async _getLoadGeoJSONParameters(e1, t, n) {
        let r = (0, $1G0Uw.er)({
            type: this.type,
            source: this.id
        }, this.workerOptions);
        if (typeof e1 == `string`) return r.request = await this.map._requestManager.transformRequest($4324d99ae8520741$var$Rr.resolveURL(e1), `Source`), r.request.collectResourceTiming = this._collectResourceTiming, r;
        if (e1 !== void 0) return r.data = e1, r;
        if (t) return r.dataDiff = t, r;
        if (n) return r.updateCluster = !0, r;
    }
    async _dispatchWorkerUpdate(e1) {
        this._isUpdatingWorker = !0, this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`dataloading`));
        try {
            let t = await e1, n = await (await this.actorPromise).sendAsync({
                type: `LD`,
                data: t
            });
            if (this._isUpdatingWorker = !1, this._removed || n.abandoned) {
                this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`dataabort`));
                return;
            }
            n.data && (this._data = {
                geojson: n.data
            });
            let r = this._applyDiffToSource(t.dataDiff), i = this._getShouldReloadTileOptions(r), a = {};
            this._applyResourceTiming(a, n), this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
                ...a,
                sourceDataType: `metadata`
            })), this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
                ...a,
                sourceDataType: `content`,
                shouldReloadTileOptions: i
            }));
        } catch (e1) {
            if (this._isUpdatingWorker = !1, this._removed) {
                this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`dataabort`));
                return;
            }
            this.fire(new (0, $1G0Uw.gn)((0, $1G0Uw.Qn)(e1)));
        } finally{
            this._hasPendingWorkerUpdate() && await this._updateWorkerData();
        }
    }
    _applyResourceTiming(e1, t) {
        if (!this._collectResourceTiming) return;
        let n = t.resourceTiming?.[this.id];
        if (!n) return;
        let r = n.slice(0);
        r?.length && (0, $1G0Uw.er)(e1, {
            resourceTiming: r
        });
    }
    _applyDiffToSource(e1) {
        if (!e1) return;
        let t = typeof this.promoteId == `string` ? this.promoteId : void 0;
        if (!this._data.url && !this._data.updateable) {
            let e1 = $4324d99ae8520741$var$Ca(this._data.geojson, t);
            if (!e1) throw Error(`GeoJSONSource "${this.id}": GeoJSON data is not compatible with updateData`);
            this._data = {
                updateable: e1
            };
        }
        if (!this._data.updateable) return;
        let n = $4324d99ae8520741$var$wa(this._data.updateable, e1, t);
        if (!(e1.removeAll || this._options.cluster)) return n;
    }
    _getShouldReloadTileOptions(e1) {
        if (e1) return {
            affectedBounds: e1.filter(Boolean).map((e1)=>$4324d99ae8520741$var$Pa(e1))
        };
    }
    shouldReloadTile(e1, { affectedBounds: t }) {
        if (e1.state === `loading`) return !0;
        if (e1.state === `unloaded`) return !1;
        let { buffer: n, extent: r } = this.workerOptions.geojsonVtOptions, i = $4324d99ae8520741$var$Fa(e1.tileID.canonical, n / r);
        for (let e1 of t)if (i.intersects(e1)) return !0;
        return !1;
    }
    loaded() {
        return !this._isUpdatingWorker && !this._hasPendingWorkerUpdate();
    }
    async loadTile(e1) {
        let t = e1.actor ? `RT` : `LT`;
        e1.actor = await this.actorPromise;
        let n = {
            type: this.type,
            uid: e1.uid,
            tileID: e1.tileID,
            zoom: e1.tileID.overscaledZ,
            maxZoom: this.maxzoom,
            tileSize: this.tileSize,
            source: this.id,
            pixelRatio: this.map.getPixelRatio(),
            showCollisionBoxes: this.map.showCollisionBoxes,
            promoteId: this.promoteId,
            subdivisionGranularity: this.map.style.projection.subdivisionGranularity
        };
        e1.abortController = new AbortController;
        try {
            let r = await (await this.actorPromise).sendAsync({
                type: t,
                data: n
            }, e1.abortController);
            delete e1.abortController, e1.unloadVectorData(), e1.aborted || e1.loadVectorData(r, this.map.painter, t === `RT`);
        } catch (t) {
            if (delete e1.abortController, e1.aborted || (0, $1G0Uw.Mn)(t)) return;
            throw t;
        }
    }
    async abortTile(e1) {
        e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.aborted = !0;
    }
    async unloadTile(e1) {
        e1.unloadVectorData(), await (await this.actorPromise).sendAsync({
            type: `RMT`,
            data: {
                uid: e1.uid,
                type: this.type,
                source: this.id
            }
        });
    }
    onRemove() {
        this._removed = !0, this.actorPromise.then((e1)=>e1.sendAsync({
                type: `RS`,
                data: {
                    type: this.type,
                    source: this.id
                }
            }));
    }
    serialize() {
        return (0, $1G0Uw.er)({}, this._options, {
            type: this.type,
            data: this._data.updateable ? {
                type: `FeatureCollection`,
                features: Array.from(this._data.updateable.values())
            } : this._data.url || this._data.geojson
        });
    }
    hasTransition() {
        return !1;
    }
};
const $4324d99ae8520741$var$La = [
    0,
    0,
    1
], $4324d99ae8520741$var$Ra = (e1, t)=>({
        u_tl_parent: new (0, $1G0Uw.Nt)(e1, t.u_tl_parent),
        u_scale_parent: new (0, $1G0Uw.jt)(e1, t.u_scale_parent),
        u_buffer_scale: new (0, $1G0Uw.jt)(e1, t.u_buffer_scale),
        u_image_warp: new (0, $1G0Uw.Pt)(e1, t.u_image_warp),
        u_fade_t: new (0, $1G0Uw.jt)(e1, t.u_fade_t),
        u_opacity: new (0, $1G0Uw.jt)(e1, t.u_opacity),
        u_image0: new (0, $1G0Uw.Mt)(e1, t.u_image0),
        u_image1: new (0, $1G0Uw.Mt)(e1, t.u_image1),
        u_brightness_low: new (0, $1G0Uw.jt)(e1, t.u_brightness_low),
        u_brightness_high: new (0, $1G0Uw.jt)(e1, t.u_brightness_high),
        u_saturation_factor: new (0, $1G0Uw.jt)(e1, t.u_saturation_factor),
        u_contrast_factor: new (0, $1G0Uw.jt)(e1, t.u_contrast_factor),
        u_spin_weights: new (0, $1G0Uw.Pt)(e1, t.u_spin_weights),
        u_coords_top: new (0, $1G0Uw.Ft)(e1, t.u_coords_top),
        u_coords_bottom: new (0, $1G0Uw.Ft)(e1, t.u_coords_bottom)
    }), $4324d99ae8520741$var$za = (e1, t, n, r, i, a)=>({
        u_tl_parent: e1,
        u_scale_parent: t,
        u_buffer_scale: 1,
        u_image_warp: a,
        u_fade_t: n.mix,
        u_opacity: n.opacity * r.paint.get(`raster-opacity`),
        u_image0: 0,
        u_image1: 1,
        u_brightness_low: r.paint.get(`raster-brightness-min`),
        u_brightness_high: r.paint.get(`raster-brightness-max`),
        u_saturation_factor: $4324d99ae8520741$var$Ha(r.paint.get(`raster-saturation`)),
        u_contrast_factor: $4324d99ae8520741$var$Va(r.paint.get(`raster-contrast`)),
        u_spin_weights: $4324d99ae8520741$var$Ba(r.paint.get(`raster-hue-rotate`)),
        u_coords_top: [
            i[0].x,
            i[0].y,
            i[1].x,
            i[1].y
        ],
        u_coords_bottom: [
            i[3].x,
            i[3].y,
            i[2].x,
            i[2].y
        ]
    });
function $4324d99ae8520741$var$Ba(e1) {
    e1 *= Math.PI / 180;
    let t = Math.sin(e1), n = Math.cos(e1);
    return [
        (2 * n + 1) / 3,
        (-Math.sqrt(3) * t - n + 1) / 3,
        (Math.sqrt(3) * t - n + 1) / 3
    ];
}
function $4324d99ae8520741$var$Va(e1) {
    return e1 > 0 ? 1 / (1 - e1) : 1 + e1;
}
function $4324d99ae8520741$var$Ha(e1) {
    return e1 > 0 ? 1 - 1 / (1.001 - e1) : -e1;
}
var $4324d99ae8520741$var$Ua = class {
    constructor(e1, t, n){
        this.vertexBuffer = e1, this.indexBuffer = t, this.segments = n;
    }
    destroy() {
        this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
    }
};
const $4324d99ae8520741$var$Wa = (0, $1G0Uw.Yt)([
    {
        name: `a_pos`,
        type: `Int16`,
        components: 2
    }
]), $4324d99ae8520741$var$Ga = (0, $1G0Uw.Lr) / 128;
function $4324d99ae8520741$var$Ka(e1, t) {
    let n = $4324d99ae8520741$export$54e626fcf5dbddb3(t, `16bit`), r = (0, $1G0Uw.Gt).deserialize({
        arrayBuffer: n.vertices,
        length: n.vertices.byteLength / 2 / 2
    }), i = (0, $1G0Uw.Jt).deserialize({
        arrayBuffer: n.indices,
        length: n.indices.byteLength / 2 / 3
    });
    return new $4324d99ae8520741$var$Ua(e1.createVertexBuffer(r, $4324d99ae8520741$var$Wa.members), e1.createIndexBuffer(i), (0, $1G0Uw.Bt).simpleSegment(0, 0, r.length, i.length));
}
function $4324d99ae8520741$export$54e626fcf5dbddb3(e1, t) {
    let n = e1.granularity === void 0 ? 1 : Math.max(e1.granularity, 1), r = n + (e1.generateBorders ? 2 : 0), i = n + (e1.extendToNorthPole || e1.generateBorders ? 1 : 0) + (e1.extendToSouthPole || e1.generateBorders ? 1 : 0), a = r + 1, o = i + 1, s = e1.generateBorders ? -1 : 0, c = e1.generateBorders || e1.extendToNorthPole ? -1 : 0, l = n + +!!e1.generateBorders, u = n + (e1.generateBorders || e1.extendToSouthPole ? 1 : 0), d = a * o, f = r * i * 6, p = a * o > 65536;
    if (p && t === `16bit`) throw Error(`Granularity is too large and meshes would not fit inside 16 bit vertex indices.`);
    let m = p || t === `32bit`, h = new Int16Array(d * 2), g = 0;
    for(let t = c; t <= u; t++)for(let r = s; r <= l; r++){
        let i = r / n * (0, $1G0Uw.Lr);
        r === -1 && (i = -$4324d99ae8520741$var$Ga), r === n + 1 && (i = (0, $1G0Uw.Lr) + $4324d99ae8520741$var$Ga);
        let a = t / n * (0, $1G0Uw.Lr);
        t === -1 && (a = e1.extendToNorthPole ? (0, $1G0Uw.ht) : -$4324d99ae8520741$var$Ga), t === n + 1 && (a = e1.extendToSouthPole ? (0, $1G0Uw.gt) : (0, $1G0Uw.Lr) + $4324d99ae8520741$var$Ga), h[g++] = i, h[g++] = a;
    }
    let _ = m ? new Uint32Array(f) : new Uint16Array(f), v = 0;
    for(let e1 = 0; e1 < i; e1++)for(let t = 0; t < r; t++){
        let n = t + e1 * a, r = t + 1 + e1 * a, i = t + (e1 + 1) * a, o = t + 1 + (e1 + 1) * a;
        _[v++] = n, _[v++] = i, _[v++] = r, _[v++] = r, _[v++] = i, _[v++] = o;
    }
    return {
        vertices: h.buffer.slice(0),
        indices: _.buffer.slice(0),
        uses32bitIndices: m
    };
}
var $4324d99ae8520741$export$280e9a68c3ffd919 = class extends (0, $1G0Uw.vn) {
    constructor(e1, t, n, r){
        super(), this.imageWarp = $4324d99ae8520741$var$La, this.flippedWindingOrder = !1, this._warp = `auto`, this._imageDirty = !1, this._subdividedQuad = !1, this._subdividedMesh = null, this.id = e1, this.dispatcher = n, this.coordinates = t.coordinates, this.type = `image`, this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(r), this.options = t;
    }
    async load(e1) {
        if (this.options.url === void 0) {
            this._loaded = !0, this._finishLoading();
            return;
        }
        this._loaded = !1, this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`dataloading`)), this.url = this.options.url, this._abortController = new AbortController;
        try {
            let t = await $4324d99ae8520741$var$Ur.transformAndGetImage(this.map._requestManager, this.url, `Image`, this._abortController);
            this._abortController = null, this._loaded = !0, t?.data ? (this._setImage(t.data), e1 && (this.coordinates = e1), this._finishLoading()) : this.fire(new (0, $1G0Uw.gn)(Error(`Could not load image ${this.url}: the response is empty`)));
        } catch (e1) {
            if ((0, $1G0Uw.Mn)(e1)) return;
            this._abortController = null, this._loaded = !0, this.fire(new (0, $1G0Uw.gn)((0, $1G0Uw.Qn)(e1)));
        }
    }
    loaded() {
        return this._loaded;
    }
    updateImage(e1) {
        return this._abortController &&= (this._abortController.abort(), null), `image` in e1 ? (this._loaded = !0, this._setImage(e1.image), e1.coordinates && (this.coordinates = e1.coordinates), this._finishLoading(), this) : e1.url ? (this.options.url = e1.url, this.load(e1.coordinates), this) : this;
    }
    _setImage(e1) {
        this.image = e1, this._imageDirty = !0;
    }
    getMesh(e1, t) {
        return !this._subdividedQuad || t ? null : (this._subdividedMesh ??= $4324d99ae8520741$var$Ka(e1, {
            granularity: 16
        }), this._subdividedMesh);
    }
    _disposeTexture() {
        this.texture?.destroy(), this.texture = null;
    }
    _finishLoading() {
        this.map && (this.setCoordinates(this.coordinates), this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `metadata`
        })));
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    onRemove() {
        this._abortController &&= (this._abortController.abort(), null), this._disposeTexture(), this._subdividedMesh?.destroy(), this._subdividedMesh = null, this.image = null, this.tiles = {};
    }
    setWarp(e1) {
        return this._warp === e1 ? this : (this._warp = e1, this.tileCoords && this.setCoordinates(this.coordinates), this);
    }
    getWarp() {
        return this._warp;
    }
    setCoordinates(e1) {
        this.coordinates = e1;
        let t = e1.map((0, $1G0Uw.nt).fromLngLat);
        return this.tileID = $4324d99ae8520741$var$Ya(t), this.terrainTileRanges = this._getOverlappingTileRanges(t), this.minzoom = this.maxzoom = this.tileID.z, this.tileCoords = t.map((e1)=>this.tileID.getTilePoint(e1)._round()), this.imageWarp = $4324d99ae8520741$var$Za(this.tileCoords, this._warp), this._subdividedQuad = this.imageWarp[2] > 0 && !$4324d99ae8520741$var$$a(this.tileCoords), this.flippedWindingOrder = $4324d99ae8520741$var$Xa(this.tileCoords), this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `content`
        })), this;
    }
    prepare() {
        if (Object.keys(this.tiles).length === 0 || !this.image) return;
        let e1 = this.map.painter.context, t = e1.gl;
        this.texture ? this._imageDirty && (this.texture.update(this.image), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE)) : (this.texture = new (0, $1G0Uw.xt)(e1, this.image, t.RGBA), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE)), this._imageDirty = !1;
        let n = !1;
        for(let e1 in this.tiles){
            let t = this.tiles[e1];
            t.state !== `loaded` && (t.state = `loaded`, t.texture = this.texture, n = !0);
        }
        n && this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `idle`,
            sourceId: this.id
        }));
    }
    async loadTile(e1) {
        this.tileID?.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}) : e1.state = `errored`;
    }
    serialize() {
        let e1 = {
            type: `image`,
            coordinates: this.coordinates
        };
        return this.options.url !== void 0 && (e1.url = this.options.url), e1;
    }
    hasTransition() {
        return !1;
    }
    _getOverlappingTileRanges(e1) {
        let { minX: t, minY: n, maxX: r, maxY: i } = (0, $1G0Uw.pt).fromPoints(e1), a = {};
        for(let e1 = 0; e1 <= 25; e1++){
            let o = 2 ** e1, s = Math.floor(t * o), c = Math.floor(n * o), l = Math.floor(r * o), u = Math.floor(i * o), d = (s % o + o) % o, f = l % o, p = Math.floor(s / o), m = Math.floor(l / o);
            a[e1] = {
                minWrap: p,
                maxWrap: m,
                minTileXWrapped: d,
                maxTileXWrapped: f,
                minTileY: c,
                maxTileY: u
            };
        }
        return a;
    }
};
function $4324d99ae8520741$var$Ya(e1) {
    let t = (0, $1G0Uw.pt).fromPoints(e1), n = t.width(), r = t.height(), i = Math.max(0, Math.floor(-Math.log(Math.max(n, r)) / Math.LN2)), a = 2 ** i;
    return new (0, $1G0Uw.u)(i, Math.floor((t.minX + t.maxX) / 2 * a), Math.floor((t.minY + t.maxY) / 2 * a));
}
function $4324d99ae8520741$var$Xa(e1) {
    let t = e1[1].x - e1[0].x, n = e1[1].y - e1[0].y, r = e1[2].x - e1[0].x;
    return t * (e1[2].y - e1[0].y) - n * r < 0;
}
function $4324d99ae8520741$var$Za(e1, t) {
    if (t === `flat` || $4324d99ae8520741$var$$a(e1)) return $4324d99ae8520741$var$La;
    let [n, r, i, a] = e1, o = n.x - r.x + i.x - a.x, s = n.y - r.y + i.y - a.y, c = [
        r.x - i.x,
        r.y - i.y,
        a.x - i.x,
        a.y - i.y
    ], [l, u, d, f] = c, p = $4324d99ae8520741$var$Nr(c), m = (o * f - d * s) / p, h = (l * s - o * u) / p, g = [
        1,
        1 + m,
        1 + m + h,
        1 + h
    ], _ = Math.max(...g) / Math.min(...g), v = t === `perspective` ? 0 : $4324d99ae8520741$var$Qa(_);
    return !(_ >= 1 && _ <= 512) || v >= 1 ? $4324d99ae8520741$var$La : [
        m,
        h,
        v
    ];
}
function $4324d99ae8520741$var$Qa(e1) {
    let t = (1 - 4 / e1) / (1 - 4 / 512);
    return Math.max(0, t);
}
function $4324d99ae8520741$var$$a(e1) {
    let [t, n, r, i] = e1;
    return t.x + r.x === n.x + i.x && t.y + r.y === n.y + i.y;
}
var $4324d99ae8520741$export$f3a17123d80000c5 = class extends $4324d99ae8520741$export$280e9a68c3ffd919 {
    constructor(e1, t, n, r){
        super(e1, t, n, r), this._onPlayingHandler = ()=>{
            this.map?.triggerRepaint();
        }, this.roundZoom = !0, this.type = `video`, this.options = t;
    }
    async load() {
        this._loaded = !1;
        let e1 = this.options;
        this.urls = [];
        for (let t of e1.urls)this.urls.push((await this.map._requestManager.transformRequest(t, `Source`)).url);
        try {
            let e1 = await (0, $1G0Uw.wn)(this.urls);
            if (this._loaded = !0, !e1) return;
            this.video = e1, this.video.loop = !0, this.video.addEventListener(`playing`, this._onPlayingHandler), this.map && this.video.play(), this._finishLoading();
        } catch (e1) {
            this.fire(new (0, $1G0Uw.gn)((0, $1G0Uw.Qn)(e1)));
        }
    }
    pause() {
        this.video && this.video.pause();
    }
    play() {
        this.video && this.video.play();
    }
    seek(e1) {
        if (this.video) {
            let t = this.video.seekable;
            e1 < t.start(0) || e1 > t.end(0) ? this.fire(new (0, $1G0Uw.gn)(new (0, $1G0Uw.pn)(`sources.${this.id}`, null, `Playback for this video can be set only between the ${t.start(0)} and ${t.end(0)}-second mark.`))) : this.video.currentTime = e1;
        }
    }
    getVideo() {
        return this.video;
    }
    onAdd(e1) {
        this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
    }
    onRemove() {
        super.onRemove(), this.video && (this.video.removeEventListener(`playing`, this._onPlayingHandler), this.video.pause());
    }
    prepare() {
        if (Object.keys(this.tiles).length === 0 || this.video.readyState < 2) return;
        let e1 = this.map.painter.context, t = e1.gl;
        this.texture ? this.video.paused || (this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE), t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, t.RGBA, t.UNSIGNED_BYTE, this.video)) : (this.texture = new (0, $1G0Uw.xt)(e1, this.video, t.RGBA), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE));
        let n = !1;
        for(let e1 in this.tiles){
            let t = this.tiles[e1];
            t.state !== `loaded` && (t.state = `loaded`, t.texture = this.texture, n = !0);
        }
        n && this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `idle`,
            sourceId: this.id
        }));
    }
    serialize() {
        return {
            type: `video`,
            urls: this.urls,
            coordinates: this.coordinates
        };
    }
    hasTransition() {
        return this.video && !this.video.paused;
    }
}, $4324d99ae8520741$export$ca65ccf5708c6a0c = class extends $4324d99ae8520741$export$280e9a68c3ffd919 {
    constructor(e1, t, n, r){
        super(e1, t, n, r), t.coordinates ? (!Array.isArray(t.coordinates) || t.coordinates.length !== 4 || t.coordinates.some((e1)=>!Array.isArray(e1) || e1.length !== 2 || e1.some((e1)=>typeof e1 != `number`))) && this.fire(new (0, $1G0Uw.gn)(new (0, $1G0Uw.pn)(`sources.${e1}`, null, `"coordinates" property must be an array of 4 longitude/latitude array pairs`))) : this.fire(new (0, $1G0Uw.gn)(new (0, $1G0Uw.pn)(`sources.${e1}`, null, `missing required property "coordinates"`))), t.animate && typeof t.animate != `boolean` && this.fire(new (0, $1G0Uw.gn)(new (0, $1G0Uw.pn)(`sources.${e1}`, null, `optional "animate" property must be a boolean value`))), t.canvas ? typeof t.canvas != `string` && !(t.canvas instanceof HTMLCanvasElement) && this.fire(new (0, $1G0Uw.gn)(new (0, $1G0Uw.pn)(`sources.${e1}`, null, `"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance`))) : this.fire(new (0, $1G0Uw.gn)(new (0, $1G0Uw.pn)(`sources.${e1}`, null, `missing required property "canvas"`))), this.options = t, this.animate = t.animate === void 0 || t.animate;
    }
    async load() {
        if (this._loaded = !0, this.canvas ||= this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions()) {
            this.fire(new (0, $1G0Uw.gn)(Error(`Canvas dimensions cannot be less than or equal to zero.`)));
            return;
        }
        this.play = function() {
            this._playing = !0, this.map.triggerRepaint();
        }, this.pause = function() {
            this._playing &&= (this.prepare(), !1);
        }, this._finishLoading();
    }
    getCanvas() {
        return this.canvas;
    }
    onAdd(e1) {
        this.map = e1, this.load(), this.canvas && this.animate && this.play();
    }
    onRemove() {
        this._playing = !1, super.onRemove();
    }
    prepare() {
        let e1 = !1;
        if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), this._hasInvalidDimensions() || Object.keys(this.tiles).length === 0) return;
        let t = this.map.painter.context, n = t.gl;
        this.texture ? (e1 || this._playing) && this.texture.update(this.canvas, {
            premultiply: !0
        }) : (this.texture = new (0, $1G0Uw.xt)(t, this.canvas, n.RGBA, {
            premultiply: !0
        }), this.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE));
        let r = !1;
        for(let e1 in this.tiles){
            let t = this.tiles[e1];
            t.state !== `loaded` && (t.state = `loaded`, t.texture = this.texture, r = !0);
        }
        r && this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `idle`,
            sourceId: this.id
        }));
    }
    serialize() {
        return {
            type: `canvas`,
            animate: this.animate,
            canvas: this.options.canvas,
            coordinates: this.coordinates
        };
    }
    hasTransition() {
        return this._playing;
    }
    _hasInvalidDimensions() {
        for (let e1 of [
            this.canvas.width,
            this.canvas.height
        ])if (isNaN(e1) || e1 <= 0) return !0;
        return !1;
    }
};
const $4324d99ae8520741$var$no = {}, $4324d99ae8520741$var$ro = (e1, t, n, r)=>{
    let i = new ($4324d99ae8520741$var$io(t.type))(e1, t, n, r);
    if (i.id !== e1) throw Error(`Expected Source id to be ${e1} instead of ${i.id}`);
    return i;
}, $4324d99ae8520741$var$io = (e1)=>{
    switch(e1){
        case `geojson`:
            return $4324d99ae8520741$export$8a9e6af3bfd58eb9;
        case `image`:
            return $4324d99ae8520741$export$280e9a68c3ffd919;
        case `raster`:
            return $4324d99ae8520741$export$908e4015b805db3c;
        case `raster-dem`:
            return $4324d99ae8520741$export$12673e0db63b98e3;
        case `vector`:
            return $4324d99ae8520741$export$5feeb63c172810c5;
        case `video`:
            return $4324d99ae8520741$export$f3a17123d80000c5;
        case `canvas`:
            return $4324d99ae8520741$export$ca65ccf5708c6a0c;
    }
    return $4324d99ae8520741$var$no[e1];
}, $4324d99ae8520741$var$ao = (e1, t)=>{
    $4324d99ae8520741$var$no[e1] = t;
}, $4324d99ae8520741$export$10a8414b48d62ec3 = async (e1, t)=>{
    if ($4324d99ae8520741$var$io(e1)) throw Error(`A source type called "${e1}" already exists.`);
    $4324d99ae8520741$var$ao(e1, t);
};
function $4324d99ae8520741$var$so(e1, t) {
    let n = {};
    if (!t) return n;
    for (let r of e1){
        let e1 = r.layerIds.map((e1)=>t.getLayer(e1)).filter(Boolean);
        if (e1.length !== 0) {
            r.layers = e1, r.stateDependentLayerIds && (r.stateDependentLayers = r.stateDependentLayerIds.map((t)=>e1.filter((e1)=>e1.id === t)[0]));
            for (let t of e1)n[t.id] = r;
        }
    }
    return n;
}
const $4324d99ae8520741$var$co = `RTLPluginLoaded`;
var $4324d99ae8520741$var$lo = class extends (0, $1G0Uw.vn) {
    constructor(...e1){
        super(...e1), this.status = `unavailable`, this.url = null, this.dispatcher = $4324d99ae8520741$export$6f0c702cbe7d6ed8();
    }
    _syncState(e1) {
        return this.status = e1, this.dispatcher.broadcast(`SRPS`, {
            pluginStatus: e1,
            pluginURL: this.url
        }).catch((e1)=>{
            throw this.status = `error`, e1;
        });
    }
    getRTLTextPluginStatus() {
        return this.status;
    }
    clearRTLTextPlugin() {
        this.status = `unavailable`, this.url = null;
    }
    async setRTLTextPlugin(e1, t = !1) {
        if (this.url) throw Error(`setRTLTextPlugin cannot be called multiple times.`);
        if (this.url = $4324d99ae8520741$var$Rr.resolveURL(e1), !this.url) throw Error(`requested url ${e1} is invalid`);
        if (this.status === `unavailable`) {
            if (t) this.status = `deferred`, this._syncState(this.status);
            else return this._requestImport();
        } else if (this.status === `requested`) return this._requestImport();
    }
    async _requestImport() {
        await this._syncState(`loading`), this.status = `loaded`, this.fire(new (0, $1G0Uw._n)($4324d99ae8520741$var$co));
    }
    lazyLoad() {
        this.status === `unavailable` ? this.status = `requested` : this.status === `deferred` && this._requestImport();
    }
};
let $4324d99ae8520741$var$uo = null;
function $4324d99ae8520741$var$fo() {
    return $4324d99ae8520741$var$uo ||= new $4324d99ae8520741$var$lo, $4324d99ae8520741$var$uo;
}
var $4324d99ae8520741$var$po = class {
    constructor(e1, t){
        this.timeAdded = 0, this.fadeEndTime = 0, this.fadeOpacity = 1, this.tileID = e1, this.uid = (0, $1G0Uw.Mr)(), this.uses = 0, this.tileSize = t, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rttObjects = [], this.rttFingerprint = {}, this.expiredRequestCount = 0, this.state = `loading`, this.featureStateRevision = -1;
    }
    isRenderable(e1) {
        return this.hasData() && (!this.fadeEndTime || this.fadingDirection !== 0 || this.fadeOpacity > 0) && (e1 || !this.holdingForSymbolFade());
    }
    setCrossFadeLogic({ fadingRole: e1, fadingDirection: t, fadingParentID: n, fadeEndTime: r }) {
        this.resetFadeLogic(), this.fadingRole = e1, this.fadingDirection = t, this.fadingParentID = n, this.fadeEndTime = r;
    }
    setSelfFadeLogic(e1) {
        this.resetFadeLogic(), this.selfFading = !0, this.fadeEndTime = e1;
    }
    resetFadeLogic() {
        this.fadingRole = null, this.fadingDirection = null, this.fadingParentID = null, this.selfFading = !1, this.timeAdded = $4324d99ae8520741$export$461939dd4422153(), this.fadeEndTime = 0, this.fadeOpacity = 1;
    }
    wasRequested() {
        return this.state === `errored` || this.state === `loaded` || this.state === `reloading`;
    }
    clearTextures(e1) {
        this.demTexture && e1.saveTileTexture(this.demTexture), this.demTexture = null;
    }
    getRTT(e1) {
        return this.rttObjects[e1];
    }
    acquireRTT(e1, t, n) {
        return this.rttObjects[t] = e1.acquireRTT(n);
    }
    releaseRTT(e1) {
        if (this.rttObjects.length !== 0) {
            for (let t of this.rttObjects)t && e1.releaseRTT(t);
            this.rttObjects.length = 0;
        }
    }
    loadVectorData(e1, t, n) {
        if (e1?.etagUnmodified === !0) {
            this.state = `loaded`;
            return;
        }
        if (this.hasData() && this.unloadVectorData(), this.state = `loaded`, !e1) {
            this.collisionBoxArray = new (0, $1G0Uw.Vt);
            return;
        }
        e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex, e1.rawTileData ? (this.latestRawTileData = e1.rawTileData, this.latestEncoding = e1.encoding, this.latestFeatureIndex.rawTileData = e1.rawTileData, this.latestFeatureIndex.encoding = e1.encoding) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData, this.latestFeatureIndex.encoding = this.latestEncoding)), this.collisionBoxArray = e1.collisionBoxArray, this.buckets = $4324d99ae8520741$var$so(e1.buckets, t?.style), this.hasSymbolBuckets = !1;
        for(let e1 in this.buckets){
            let t = this.buckets[e1];
            if (t instanceof (0, $1G0Uw.S)) {
                if (this.hasSymbolBuckets = !0, n) t.justReloaded = !0;
                else break;
            }
        }
        if (this.hasRTLText = !1, this.hasSymbolBuckets) for(let e1 in this.buckets){
            let t = this.buckets[e1];
            if (t instanceof (0, $1G0Uw.S) && t.hasRTLText) {
                this.hasRTLText = !0, $4324d99ae8520741$var$fo().lazyLoad();
                break;
            }
        }
        this.queryPadding = 0;
        for(let e1 in this.buckets){
            let n = this.buckets[e1];
            this.queryPadding = Math.max(this.queryPadding, t.style.getLayer(e1).queryRadius(n));
        }
        e1.imageAtlas && (this.imageAtlas = e1.imageAtlas), e1.glyphAtlasImage && (this.glyphAtlasImage = e1.glyphAtlasImage), this.dashPositions = e1.dashPositions;
    }
    unloadVectorData() {
        for(let e1 in this.buckets)this.buckets[e1].destroy();
        this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.imageAtlas = null, this.dashPositions = null, this.latestFeatureIndex = null, this.state = `unloaded`;
    }
    getBucket(e1) {
        return this.buckets[e1.id];
    }
    upload(e1) {
        for(let t in this.buckets){
            let n = this.buckets[t];
            n.uploadPending() && n.upload(e1);
        }
        let t = e1.gl;
        this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new (0, $1G0Uw.xt)(e1, this.imageAtlas.image, t.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage &&= (this.glyphAtlasTexture = new (0, $1G0Uw.xt)(e1, this.glyphAtlasImage, t.ALPHA), null);
    }
    prepare(e1) {
        this.imageAtlas && this.imageAtlas.patchUpdatedImages(e1, this.imageAtlasTexture);
    }
    queryRenderedFeatures(e1, t, n, r, i, a, o, s, c, l, u) {
        return this.latestFeatureIndex?.rawTileData ? this.latestFeatureIndex.query({
            queryGeometry: r,
            cameraQueryGeometry: i,
            scale: a,
            tileSize: this.tileSize,
            pixelPosMatrix: l,
            transform: s,
            params: o,
            queryPadding: this.queryPadding * c,
            getElevation: u
        }, e1, t, n) : {};
    }
    querySourceFeatures(e1, t) {
        let n = this.latestFeatureIndex;
        if (!n?.rawTileData) return;
        let r = n.loadVTLayers(), i = t?.sourceLayer ? t.sourceLayer : ``, a = r._geojsonTileLayer || r[i];
        if (!a) return;
        let o = (0, $1G0Uw.cn)(t?.filter, `querySourceFeatures[${i}].filter`, t?.globalState), { z: s, x: l, y: u } = this.tileID.canonical, d = {
            z: s,
            x: l,
            y: u
        };
        for(let t = 0; t < a.length; t++){
            let r = a.feature(t);
            if (o.needGeometry) {
                let e1 = (0, $1G0Uw.At)(r, !0);
                if (!o.filter(new (0, $1G0Uw.en)(this.tileID.overscaledZ), e1, this.tileID.canonical)) continue;
            } else if (!o.filter(new (0, $1G0Uw.en)(this.tileID.overscaledZ), r)) continue;
            let f = n.getId(r, i), p = new (0, $1G0Uw.a)(r, s, l, u, f);
            p.tile = d, e1.push(p);
        }
    }
    hasData() {
        return this.state === `loaded` || this.state === `reloading` || this.state === `expired`;
    }
    patternsLoaded() {
        return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
    }
    setExpiryData(e1) {
        let t = this.expirationTime;
        if (e1.cacheControl) {
            let t = (0, $1G0Uw.vr)(e1.cacheControl);
            t[`max-age`] && (this.expirationTime = Date.now() + t[`max-age`] * 1e3);
        } else e1.expires && (this.expirationTime = new Date(e1.expires).getTime());
        if (this.expirationTime) {
            let e1 = Date.now(), n = !1;
            if (this.expirationTime > e1) n = !1;
            else if (!t) n = !0;
            else if (this.expirationTime < t) n = !0;
            else {
                let r = this.expirationTime - t;
                r ? this.expirationTime = e1 + Math.max(r, 3e4) : n = !0;
            }
            n ? (this.expiredRequestCount++, this.state = `expired`) : this.expiredRequestCount = 0;
        }
    }
    getExpiryTimeout() {
        if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - new Date().getTime(), 2 ** 31 - 1);
    }
    setFeatureState(e1, t, n) {
        if (!this.latestFeatureIndex?.rawTileData || Object.keys(e1).length === 0 || this.featureStateRevision === n) return;
        this.featureStateRevision = n;
        let r = this.latestFeatureIndex.loadVTLayers();
        for(let n in this.buckets){
            if (!t.style.hasLayer(n)) continue;
            let i = this.buckets[n], a = i.layers[0].sourceLayer || `_geojsonTileLayer`, o = r[a], s = e1[a];
            if (!o || !s || s.length === 0) continue;
            i.update(s, o, this.imageAtlas?.patternPositions || {}, this.dashPositions || {});
            let c = t?.style?.getLayer(n);
            c && (this.queryPadding = Math.max(this.queryPadding, c.queryRadius(i)));
        }
    }
    holdingForSymbolFade() {
        return this.symbolFadeHoldUntil !== void 0;
    }
    symbolFadeFinished() {
        return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < $4324d99ae8520741$export$461939dd4422153();
    }
    clearSymbolFadeHold() {
        this.symbolFadeHoldUntil = void 0;
    }
    setSymbolHoldDuration(e1) {
        this.symbolFadeHoldUntil = $4324d99ae8520741$export$461939dd4422153() + e1;
    }
    setDependencies(e1, t) {
        let n = {};
        for (let e1 of t)n[e1] = !0;
        this.dependencies[e1] = n;
    }
    hasDependency(e1, t) {
        for (let n of e1){
            let e1 = this.dependencies[n];
            if (e1) {
                for (let n of t)if (e1[n]) return !0;
            }
        }
        return !1;
    }
};
function $4324d99ae8520741$var$mo(e1) {
    let t = [];
    for(let n in e1)t.push({
        id: n,
        state: e1[n]
    });
    return t;
}
var $4324d99ae8520741$var$ho = class {
    constructor(){
        this.state = {}, this.stateChanges = {}, this.deletedStates = {}, this.revision = 0;
    }
    updateState(e1, t, n) {
        let r = String(t);
        if (this.stateChanges[e1] ||= {}, this.stateChanges[e1][r] ||= {}, (0, $1G0Uw.er)(this.stateChanges[e1][r], n), this.deletedStates[e1] === null) {
            this.deletedStates[e1] = {};
            for(let t in this.state[e1])if (t === r) {
                this.deletedStates[e1][r] = {};
                for(let i in this.state[e1][t])n[i] === void 0 && (this.deletedStates[e1][r][i] = null);
            } else this.deletedStates[e1][t] = null;
        } else if (this.deletedStates[e1]?.[r] === null) {
            this.deletedStates[e1][r] = {};
            for(let t in this.state[e1][r])n[t] === void 0 && (this.deletedStates[e1][r][t] = null);
        } else for(let t in n)this.deletedStates[e1]?.[r]?.[t] === null && delete this.deletedStates[e1][r][t];
    }
    removeFeatureState(e1, t, n) {
        if (this.deletedStates[e1] === null) return;
        let r = String(t);
        if (this.deletedStates[e1] ||= {}, n && t !== void 0) this.deletedStates[e1][r] !== null && (this.deletedStates[e1][r] ||= {}, this.deletedStates[e1][r][n] = null);
        else if (t !== void 0) {
            if (this.stateChanges[e1]?.[r]) for(n in this.deletedStates[e1][r] = {}, this.stateChanges[e1][r])this.deletedStates[e1][r][n] = null;
            else this.deletedStates[e1][r] = null;
        } else this.deletedStates[e1] = null;
    }
    getState(e1, t) {
        let n = String(t), r = this.state[e1] || {}, i = this.stateChanges[e1] || {}, a = (0, $1G0Uw.er)({}, r[n], i[n]);
        if (this.deletedStates[e1] === null) return {};
        if (this.deletedStates[e1]) {
            let n = this.deletedStates[e1][t];
            if (n === null) return {};
            for(let e1 in n)delete a[e1];
        }
        return a;
    }
    initializeTileState(e1, t) {
        let n = {};
        for(let e1 in this.state)n[e1] = $4324d99ae8520741$var$mo(this.state[e1]);
        e1.setFeatureState(n, t, this.revision);
    }
    coalesceChanges(e1, t) {
        let n = {};
        for(let e1 in this.stateChanges){
            this.state[e1] ||= {}, n[e1] ||= {};
            for(let t in this.stateChanges[e1])this.state[e1][t] ||= {}, (0, $1G0Uw.er)(this.state[e1][t], this.stateChanges[e1][t]), n[e1][t] = this.state[e1][t];
        }
        for(let e1 in this.deletedStates)if (this.state[e1] ||= {}, n[e1] ||= {}, this.deletedStates[e1] === null) for(let t in this.state[e1])this.state[e1][t] = {}, n[e1][t] = {};
        else for(let t in this.deletedStates[e1]){
            if (this.deletedStates[e1][t] === null) this.state[e1][t] = {};
            else for (let n of Object.keys(this.deletedStates[e1][t]))delete this.state[e1][t][n];
            n[e1][t] = this.state[e1][t];
        }
        if (this.stateChanges = {}, this.deletedStates = {}, Object.keys(n).length === 0) return;
        this.revision++;
        let r = {};
        for(let e1 in n)r[e1] = $4324d99ae8520741$var$mo(n[e1]);
        e1.setFeatureState(r, t, this.revision);
    }
}, $4324d99ae8520741$var$go = class e1 {
    constructor(e1, t){
        this.min = e1, this.max = t, this.center = (0, $1G0Uw.ci)([], (0, $1G0Uw.Xr)([], this.min, this.max), .5);
    }
    quadrant(t) {
        let n = [
            t % 2 == 0,
            t < 2
        ], r = (0, $1G0Uw.Zr)(this.min), i = (0, $1G0Uw.Zr)(this.max);
        for(let e1 = 0; e1 < n.length; e1++)r[e1] = n[e1] ? this.min[e1] : this.center[e1], i[e1] = n[e1] ? this.center[e1] : this.max[e1];
        return i[2] = this.max[2], new e1(r, i);
    }
    distanceX(e1) {
        return Math.max(Math.min(this.max[0], e1[0]), this.min[0]) - e1[0];
    }
    distanceY(e1) {
        return Math.max(Math.min(this.max[1], e1[1]), this.min[1]) - e1[1];
    }
    intersectsFrustum(e1) {
        let t = !0;
        for (let n of e1.planes){
            let e1 = this.intersectsPlane(n);
            if (e1 === 0) return 0;
            e1 === 1 && (t = !1);
        }
        return t ? 2 : e1.aabb.min[0] > this.max[0] || e1.aabb.min[1] > this.max[1] || e1.aabb.min[2] > this.max[2] || e1.aabb.max[0] < this.min[0] || e1.aabb.max[1] < this.min[1] || e1.aabb.max[2] < this.min[2] ? 0 : 1;
    }
    intersectsPlane(e1) {
        let t = e1[3], n = e1[3];
        for(let r = 0; r < 3; r++)e1[r] > 0 ? (t += e1[r] * this.min[r], n += e1[r] * this.max[r]) : (n += e1[r] * this.min[r], t += e1[r] * this.max[r]);
        return t >= 0 ? 2 : n < 0 ? 0 : 1;
    }
}, $4324d99ae8520741$var$_o = class e1 {
    constructor(e1, t, n){
        this.points = e1, this.planes = t, this.aabb = n;
    }
    static fromInvProjectionMatrix(t, n = 1, r = 0, i, a) {
        let o = [
            [
                -1,
                1,
                -1,
                1
            ],
            [
                1,
                1,
                -1,
                1
            ],
            [
                1,
                -1,
                -1,
                1
            ],
            [
                -1,
                -1,
                -1,
                1
            ],
            [
                -1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1
            ],
            [
                1,
                -1,
                1,
                1
            ],
            [
                -1,
                -1,
                1,
                1
            ]
        ], s = a ? [
            [
                6,
                5,
                4
            ],
            [
                0,
                1,
                2
            ],
            [
                0,
                3,
                7
            ],
            [
                2,
                1,
                5
            ],
            [
                3,
                2,
                6
            ],
            [
                0,
                4,
                5
            ]
        ] : [
            [
                0,
                1,
                2
            ],
            [
                6,
                5,
                4
            ],
            [
                0,
                3,
                7
            ],
            [
                2,
                1,
                5
            ],
            [
                3,
                2,
                6
            ],
            [
                0,
                4,
                5
            ]
        ], c = 2 ** r, l = o.map((e1)=>$4324d99ae8520741$var$vo(e1, t, n, c));
        i && $4324d99ae8520741$var$yo(l, s[0], i, a);
        let u = s.map((e1)=>{
            let t = (0, $1G0Uw.ui)([], l[e1[0]], l[e1[1]]), n = (0, $1G0Uw.ui)([], l[e1[2]], l[e1[1]]), r = (0, $1G0Uw.ii)([], (0, $1G0Uw.Qr)([], t, n)), i = -(0, $1G0Uw.ei)(r, l[e1[1]]);
            return r.concat(i);
        }), d = [
            1 / 0,
            1 / 0,
            1 / 0
        ], f = [
            -1 / 0,
            -1 / 0,
            -1 / 0
        ];
        for (let e1 of l)for(let t = 0; t < 3; t++)d[t] = Math.min(d[t], e1[t]), f[t] = Math.max(f[t], e1[t]);
        return new e1(l, u, new $4324d99ae8520741$var$go(d, f));
    }
};
function $4324d99ae8520741$var$vo(e1, t, n, r) {
    let i = (0, $1G0Uw.Yr)([], e1, t), a = 1 / i[3] / n * r;
    return (0, $1G0Uw.qr)(i, i, [
        a,
        a,
        1 / i[3],
        a
    ]);
}
function $4324d99ae8520741$var$yo(e1, t, n, r) {
    let i = r ? 4 : 0, a = r ? 0 : 4, o = 0, s = [], c = [];
    for(let t = 0; t < 4; t++){
        let n = (0, $1G0Uw.ui)([], e1[t + a], e1[t + i]), r = (0, $1G0Uw.ni)(n);
        (0, $1G0Uw.ci)(n, n, 1 / r), s.push(r), c.push(n);
    }
    for(let t = 0; t < 4; t++){
        let r = (0, $1G0Uw.Sr)(e1[t + i], c[t], n);
        o = r !== null && r >= 0 ? Math.max(o, r) : Math.max(o, s[t]);
    }
    let l = $4324d99ae8520741$var$bo(e1, t), u = $4324d99ae8520741$var$xo(n, l);
    if (u !== null) {
        let e1 = u / (0, $1G0Uw.ei)(c[0], l);
        o = Math.min(o, e1);
    }
    for(let t = 0; t < 4; t++){
        let n = Math.min(o, s[t]);
        e1[t + a] = [
            e1[t + i][0] + c[t][0] * n,
            e1[t + i][1] + c[t][1] * n,
            e1[t + i][2] + c[t][2] * n,
            1
        ];
    }
}
function $4324d99ae8520741$var$bo(e1, t) {
    let n = (0, $1G0Uw.ui)([], e1[t[0]], e1[t[1]]), r = (0, $1G0Uw.ui)([], e1[t[2]], e1[t[1]]), i = [
        0,
        0,
        0,
        0
    ];
    return (0, $1G0Uw.ii)(i, (0, $1G0Uw.Qr)([], n, r)), i[3] = -(0, $1G0Uw.ei)(i, e1[t[0]]), i;
}
function $4324d99ae8520741$var$xo(e1, t) {
    let n = (0, $1G0Uw.ti)(e1), r = (0, $1G0Uw.Jr)([], e1, 1 / n), i = (0, $1G0Uw.ui)([], t, (0, $1G0Uw.ci)([], r, (0, $1G0Uw.ei)(t, r))), a = (0, $1G0Uw.ti)(i);
    if (a > 0) {
        let e1 = Math.sqrt(1 - r[3] * r[3]), n = (0, $1G0Uw.ci)([], r, -r[3]), o = (0, $1G0Uw.Xr)([], n, (0, $1G0Uw.ci)([], i, e1 / a));
        return (0, $1G0Uw.br)(t, o);
    }
    return null;
}
function $4324d99ae8520741$var$So(e1, t, n) {
    let r = t.intersectsFrustum(e1);
    if (!n || r === 0) return r;
    let i = t.intersectsPlane(n);
    return i === 0 ? 0 : r === 2 && i === 2 ? 2 : 1;
}
function $4324d99ae8520741$var$Co(e1, t, n) {
    let r = 0, i = (n - t) / 10;
    for(let a = 0; a < 10; a++){
        let o = t + (a + .5) / 10 * (n - t);
        r += i * Math.cos(o) ** +e1;
    }
    return r;
}
function $4324d99ae8520741$var$wo(e1, t) {
    return function(n, r, i, a, o) {
        let s = 2 * ((e1 - 1) / (0, $1G0Uw.Dr)(Math.cos((0, $1G0Uw.Yn)((0, $1G0Uw.Q) - o)) / Math.cos((0, $1G0Uw.Yn)((0, $1G0Uw.Q)))) - 1), c = Math.acos(i / a), l = 2 * $4324d99ae8520741$var$Co(s - 1, 0, (0, $1G0Uw.Yn)(o / 2)), u = Math.min((0, $1G0Uw.Yn)((0, $1G0Uw.Q)), c + (0, $1G0Uw.Yn)(o / 2)), d = Math.min(u, c - (0, $1G0Uw.Yn)(o / 2)), f = $4324d99ae8520741$var$Co(s - 1, d, u), p = Math.atan(r / i), m = Math.hypot(r, i), h = n;
        return h += (0, $1G0Uw.Dr)(a / m / Math.max(.5, Math.cos((0, $1G0Uw.Yn)(o / 2)))), h += s * (0, $1G0Uw.Dr)(Math.cos(p)) / 2, h -= (0, $1G0Uw.Dr)(Math.max(1, f / l / t)) / 2, h;
    };
}
const $4324d99ae8520741$var$To = $4324d99ae8520741$var$wo(9.314, 3);
function $4324d99ae8520741$var$Eo(e1, t) {
    let n = (t.roundZoom ? Math.round : Math.floor)(e1.zoom + (0, $1G0Uw.Dr)(e1.tileSize / t.tileSize));
    return Math.max(0, n);
}
function $4324d99ae8520741$var$Do(e1, t) {
    let n = (0, $1G0Uw.Q) - e1.pitch - e1.fov / 2, r = (0, $1G0Uw.Bn)((15 - n) / 15, 0, 1), i = Math.max(500, t ?? 0);
    return e1.elevation + r * i;
}
function $4324d99ae8520741$var$Oo(e1, t, n) {
    let r = e1.planes[1], i = e1.points.map((e1)=>{
        let i = r[0] * e1[0] + r[1] * e1[1] + r[2] * e1[2] + r[3];
        if (Math.abs(i) > 1e-6) return e1;
        let a = [
            e1[0] - n[0],
            e1[1] - n[1],
            e1[2] - n[2]
        ], o = r[0] * a[0] + r[1] * a[1] + r[2] * a[2];
        if (o >= -0.000000001) return e1;
        let s = t / -o;
        return [
            e1[0] + a[0] * s,
            e1[1] + a[1] * s,
            e1[2] + a[2] * s,
            e1[3]
        ];
    }), a = e1.planes.map((e1, n)=>n === 1 ? [
            e1[0],
            e1[1],
            e1[2],
            e1[3] + t
        ] : e1), o = [
        1 / 0,
        1 / 0,
        1 / 0
    ], s = [
        -1 / 0,
        -1 / 0,
        -1 / 0
    ];
    for (let e1 of i)for(let t = 0; t < 3; t++)o[t] = Math.min(o[t], e1[t]), s[t] = Math.max(s[t], e1[t]);
    return new $4324d99ae8520741$var$_o(i, a, new $4324d99ae8520741$var$go(o, s));
}
function $4324d99ae8520741$var$ko(e1, t) {
    let n = e1.getCameraFrustum(), r = e1.getClippingPlane();
    if (r && t.maxContentElevation > 0) {
        let i = Math.hypot(r[0], r[1], r[2]);
        if (i > 0) {
            let a = 1 + t.maxContentElevation / (0, $1G0Uw.ut), o = (0, $1G0Uw.Bn)(-r[3] / i, -1, 1), s = Math.cos(Math.acos(o) + Math.acos(1 / a));
            r = [
                r[0],
                r[1],
                r[2],
                -s * i
            ], n = $4324d99ae8520741$var$Oo(n, Math.sqrt(a * a - 1), e1.cameraPosition);
        }
    }
    let i = (0, $1G0Uw.Y)(e1), a = (0, $1G0Uw.nt).fromLngLat(e1.center, e1.elevation), o = $4324d99ae8520741$var$Do(e1, t.maxContentElevation), s = e1.getCoveringTilesDetailsProvider(), c = s.allowVariableZoom(e1, t), l = $4324d99ae8520741$var$Eo(e1, t), d = t.minzoom || 0, f = t.maxzoom === void 0 ? e1.maxZoom : t.maxzoom, p = Math.min(Math.max(0, l), f), m = 2 ** p, h = [
        m * i.x,
        m * i.y,
        0
    ], g = [
        m * a.x,
        m * a.y,
        0
    ], _ = Math.hypot(a.x - i.x, a.y - i.y), v = Math.abs(a.z - i.z), y = Math.hypot(_, v), x = (e1)=>({
            zoom: 0,
            x: 0,
            y: 0,
            wrap: e1,
            fullyVisible: !1
        }), S = [], C = [];
    if (e1.renderWorldCopies && s.allowWorldCopies()) for(let e1 = 1; e1 <= 3; e1++)S.push(x(-e1)), S.push(x(e1));
    for(S.push(x(0)); S.length > 0;){
        let u = S.pop(), m = u.x, _ = u.y, x = u.fullyVisible, w = {
            x: m,
            y: _,
            z: u.zoom
        }, T = s.getTileBoundingVolume(w, u.wrap, o, t);
        if (!x) {
            let e1 = $4324d99ae8520741$var$So(n, T, r);
            if (e1 === 0) continue;
            x = e1 === 2;
        }
        let E = s.distanceToTile2d(i.x, i.y, w, T), D = l;
        c && (D = (t.calculateTileZoom || $4324d99ae8520741$var$To)(e1.zoom + (0, $1G0Uw.Dr)(e1.tileSize / t.tileSize), E, v, y, e1.fov)), D = (t.roundZoom ? Math.round : Math.floor)(D), D = Math.max(0, D);
        let O = Math.min(D, f);
        if (u.wrap = s.getWrap(a, w, u.wrap), u.zoom >= O) {
            if (u.zoom < d) continue;
            let e1 = p - u.zoom, n = h[0] - .5 - (m << e1), r = h[1] - .5 - (_ << e1), i = t.reparseOverscaled ? Math.max(u.zoom, D) : u.zoom;
            C.push({
                tileID: new (0, $1G0Uw.d)(u.zoom === f ? i : u.zoom, u.wrap, u.zoom, m, _),
                distanceSq: (0, $1G0Uw.Vr)([
                    g[0] - .5 - m,
                    g[1] - .5 - _
                ]),
                tileDistanceToCamera: Math.sqrt(n * n + r * r)
            });
            continue;
        }
        for(let e1 = 0; e1 < 4; e1++){
            let t = (m << 1) + e1 % 2, n = (_ << 1) + (e1 >> 1), r = u.zoom + 1;
            S.push({
                zoom: r,
                x: t,
                y: n,
                wrap: u.wrap,
                fullyVisible: x
            });
        }
    }
    return C.sort((e1, t)=>e1.distanceSq - t.distanceSq).map((e1)=>e1.tileID);
}
function $4324d99ae8520741$var$Ao(e1) {
    return e1 === `raster` || e1 === `image` || e1 === `video`;
}
function $4324d99ae8520741$var$jo(e1, t, n, r, i, a, o) {
    let s = $4324d99ae8520741$export$461939dd4422153(), c = (0, $1G0Uw.ar)(t);
    for (let l of t){
        let t = e1.getTileById(l.key);
        (t.fadingDirection === 0 || t.fadeOpacity === 0) && t.resetFadeLogic(), !$4324d99ae8520741$var$Mo(e1, t, n, s, r, i, o) && ($4324d99ae8520741$var$No(e1, t, n, s, a, o) || $4324d99ae8520741$var$Fo(t, c, s, o) || t.resetFadeLogic());
    }
}
function $4324d99ae8520741$var$Mo(e1, t, n, r, i, a, o) {
    if (!t.hasData()) return !1;
    let { tileID: s, fadingRole: c, fadingDirection: l, fadingParentID: u } = t;
    if (c === 0 && l === 1 && u) return n[u.key] = u, !0;
    let d = Math.max(s.overscaledZ - i, a);
    for(let i = s.overscaledZ - 1; i >= d; i--){
        let a = s.scaledTo(i), c = e1.getLoadedTile(a);
        if (c) return t.setCrossFadeLogic({
            fadingRole: 0,
            fadingDirection: 1,
            fadingParentID: c.tileID,
            fadeEndTime: r + o
        }), c.setCrossFadeLogic({
            fadingRole: 1,
            fadingDirection: 0,
            fadeEndTime: r + o
        }), n[a.key] = a, !0;
    }
    return !1;
}
function $4324d99ae8520741$var$No(e1, t, n, r, i, a) {
    if (!t.hasData()) return !1;
    let o = t.tileID.children(i), s = $4324d99ae8520741$var$Po(e1, t, o, n, r, i, a);
    if (s) return !0;
    for (let c of o)$4324d99ae8520741$var$Po(e1, t, c.children(i), n, r, i, a) && (s = !0);
    return s;
}
function $4324d99ae8520741$var$Po(e1, t, n, r, i, a, o) {
    if (n[0].overscaledZ >= a) return !1;
    let s = !1;
    for (let a of n){
        let n = e1.getLoadedTile(a);
        if (!n) continue;
        let { fadingRole: c, fadingDirection: l, fadingParentID: u } = n;
        (c !== 0 || l !== 0 || !u) && (n.setCrossFadeLogic({
            fadingRole: 0,
            fadingDirection: 0,
            fadingParentID: t.tileID,
            fadeEndTime: i + o
        }), t.setCrossFadeLogic({
            fadingRole: 1,
            fadingDirection: 1,
            fadeEndTime: i + o
        })), r[a.key] = a, s = !0;
    }
    return s;
}
function $4324d99ae8520741$var$Fo(e1, t, n, r) {
    let i = e1.tileID;
    if (e1.selfFading) return !0;
    if (e1.hasData()) return !1;
    if (t.has(i)) {
        let t = n + r;
        return e1.setSelfFadeLogic(t), !0;
    }
    return !1;
}
function $4324d99ae8520741$var$Io(e1, t) {
    if (t <= 0) return !1;
    let n = $4324d99ae8520741$export$461939dd4422153();
    for (let t of e1.getAllTiles())if (t.fadeEndTime >= n) return !0;
    return !1;
}
function $4324d99ae8520741$var$Lo(e1, t) {
    let n = t.getRenderableIds();
    for (let r of n){
        if (!e1.neighboringTiles?.[r]) continue;
        let n = t.getTileById(r);
        e1.neighboringTiles[r].backfilled || $4324d99ae8520741$var$Ro(e1, n), !n.neighboringTiles?.[e1.tileID.key]?.backfilled && $4324d99ae8520741$var$Ro(n, e1);
    }
}
function $4324d99ae8520741$var$Ro(e1, t) {
    e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0, e1.needsColorReliefPrepare = !0;
    let n = t.tileID.canonical.x - e1.tileID.canonical.x, r = t.tileID.canonical.y - e1.tileID.canonical.y, i = 2 ** e1.tileID.canonical.z, a = t.tileID.key;
    (n !== 0 || r !== 0) && (Math.abs(r) > 1 || (Math.abs(n) > 1 && (Math.abs(n + i) === 1 ? n += i : Math.abs(n - i) === 1 && (n -= i)), t.dem && e1.dem && (e1.dem.backfillBorder(t.dem, n, r), e1.neighboringTiles?.[a] && (e1.neighboringTiles[a].backfilled = !0))));
}
var $4324d99ae8520741$var$zo = class {
    constructor(){
        this._tiles = {};
    }
    handleWrapJump(e1) {
        let t = {};
        for(let n in this._tiles){
            let r = this._tiles[n];
            r.tileID = r.tileID.unwrapTo(r.tileID.wrap + e1), t[r.tileID.key] = r;
        }
        this._tiles = t;
    }
    setFeatureState(e1, t, n) {
        for(let r in this._tiles)this._tiles[r].setFeatureState(e1, t, n);
    }
    getAllTiles() {
        return Object.values(this._tiles);
    }
    getAllIds(e1 = !1) {
        return e1 ? Object.values(this._tiles).map((e1)=>e1.tileID).sort((0, $1G0Uw.m)).map((e1)=>e1.key) : Object.keys(this._tiles);
    }
    getTileById(e1) {
        return this._tiles[e1];
    }
    setTile(e1, t) {
        this._tiles[e1] = t;
    }
    deleteTileById(e1) {
        delete this._tiles[e1];
    }
    getLoadedTile(e1) {
        let t = this.getTileById(e1.key);
        return t?.hasData() ? t : null;
    }
    isIdRenderable(e1, t = !1) {
        return this.getTileById(e1)?.isRenderable(t);
    }
    getRenderableIds(e1 = 0, t) {
        let n = [];
        for (let e1 of this.getAllIds())this.isIdRenderable(e1, t) && n.push(this.getTileById(e1));
        return t ? n.sort((t, n)=>{
            let r = t.tileID, i = n.tileID, a = new (0, $1G0Uw.Li)(r.canonical.x, r.canonical.y)._rotate(-e1), o = new (0, $1G0Uw.Li)(i.canonical.x, i.canonical.y)._rotate(-e1);
            return r.overscaledZ - i.overscaledZ || o.y - a.y || o.x - a.x;
        }).map((e1)=>e1.tileID.key) : n.map((e1)=>e1.tileID).sort((0, $1G0Uw.m)).map((e1)=>e1.key);
    }
}, $4324d99ae8520741$var$Bo = class e1 extends (0, $1G0Uw.vn) {
    static{
        this.maxUnderzooming = 10;
    }
    static{
        this.maxOverzooming = 3;
    }
    constructor(e1, t, n){
        super(), this._maxContentElevationSeen = 0, this.id = e1, this.dispatcher = n, this.on(`data`, (e1)=>{
            this._dataHandler(e1);
        }), this.on(`dataloading`, ()=>{
            this._sourceErrored = !1;
        }), this.on(`error`, ()=>{
            this._sourceErrored = this._source.loaded();
        }), this._source = $4324d99ae8520741$var$ro(e1, t, n, this), this._inViewTiles = new $4324d99ae8520741$var$zo, this._outOfViewCache = new (0, $1G0Uw.n)(0, (e1)=>this._unloadTile(e1)), this._timers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._rasterFadeDuration = 0, this._maxFadingAncestorLevels = 5, this._state = new $4324d99ae8520741$var$ho, this._didEmitContent = !1, this._updated = !1;
    }
    onAdd(e1) {
        this.map = e1, this._maxTileCacheSize = e1 ? e1._maxTileCacheSize : null, this._maxTileCacheZoomLevels = e1 ? e1._maxTileCacheZoomLevels : null, this._source?.onAdd && this._source.onAdd(e1);
    }
    onRemove(e1) {
        for (let e1 of this._inViewTiles.getAllTiles())e1.unloadVectorData();
        this.clearTiles(), this._source?.onRemove && this._source.onRemove(e1), this._inViewTiles = new $4324d99ae8520741$var$zo;
    }
    loaded() {
        if (this._sourceErrored) return !0;
        if (!this._sourceLoaded || !this._source.loaded()) return !1;
        if ((this.used !== void 0 || this.usedForTerrain !== void 0) && !this.used && !this.usedForTerrain) return !0;
        if (!this._updated) return !1;
        for (let e1 of this._inViewTiles.getAllTiles())if (e1.state !== `loaded` && e1.state !== `errored`) return !1;
        return !0;
    }
    getSource() {
        return this._source;
    }
    getState() {
        return this._state;
    }
    pause() {
        this._paused = !0;
    }
    resume() {
        if (!this._paused) return;
        let e1 = this._shouldReloadOnResume;
        this._paused = !1, this._shouldReloadOnResume = !1, e1 && this.reload(), this.transform && this.update(this.transform, this.terrain);
    }
    async _loadTile(e1, t, n, r) {
        try {
            let i = await this._source.loadTile(e1);
            this._tileLoaded(e1, t, n, r, i);
        } catch (t) {
            e1.state = `errored`, t.status === 404 ? this.update(this.transform, this.terrain) : this._source.fire(new (0, $1G0Uw.gn)((0, $1G0Uw.Qn)(t), {
                tile: e1
            }));
        }
    }
    _unloadTile(e1) {
        this._source.unloadTile && this._source.unloadTile(e1);
    }
    _abortTile(e1) {
        this._source.abortTile && this._source.abortTile(e1), this._source.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`dataabort`, {
            tile: e1,
            coord: e1.tileID
        }));
    }
    serialize() {
        return this._source.serialize();
    }
    prepare(e1) {
        this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._inViewTiles, this.map ? this.map.painter : null);
        for (let t of this._inViewTiles.getAllTiles())t.upload(e1), t.prepare(this.map.style.imageManager);
    }
    getIds() {
        return this._inViewTiles.getAllIds(!0);
    }
    getRenderableIds(e1) {
        return this._inViewTiles.getRenderableIds(this.transform?.bearingInRadians, e1);
    }
    hasRenderableParent(e1) {
        let t = e1.overscaledZ - 1;
        if (t >= this._source.minzoom) {
            let n = this.getLoadedTile(e1.scaledTo(t));
            if (n) return this._inViewTiles.isIdRenderable(n.tileID.key);
        }
        return !1;
    }
    reload(e1, t) {
        if (this._paused) {
            this._shouldReloadOnResume = !0;
            return;
        }
        this._outOfViewCache.reset();
        for (let n of this._inViewTiles.getAllIds()){
            let r = this._inViewTiles.getTileById(n);
            (!t || this._source.shouldReloadTile(r, t)) && (e1 ? this._reloadTile(n, r.state === `errored` ? `loading` : `expired`) : r.state !== `errored` && this._reloadTile(n, `reloading`));
        }
    }
    async _reloadTile(e1, t) {
        let n = this._inViewTiles.getTileById(e1);
        if (!n) return;
        let r = n.hasData();
        n.state !== `loading` && (n.state = t), await this._loadTile(n, e1, t, r);
    }
    _tileLoaded(e1, t, n, r, i) {
        r || (e1.timeAdded = $4324d99ae8520741$export$461939dd4422153(), e1.selfFading && (e1.fadeEndTime = e1.timeAdded + this._rasterFadeDuration)), n === `expired` && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(t, e1), !i?.unmodified && (this.getSource().type === `raster-dem` && e1.dem && $4324d99ae8520741$var$Lo(e1, this._inViewTiles), e1.featureStateRevision = -1, this._state.initializeTileState(e1, this.map ? this.map.painter : null), e1.aborted || this._source.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
            tile: e1,
            coord: e1.tileID
        })));
    }
    getTile(e1) {
        return this.getTileByID(e1.key);
    }
    getTileByID(e1) {
        return this._inViewTiles.getTileById(e1);
    }
    _retainLoadedChildren(t, n) {
        let r = this._getLoadedDescendents(n), i = new Set;
        for (let a of n){
            let n = r[a.key];
            if (!n?.length) {
                i.add(a);
                continue;
            }
            let o = a.overscaledZ + e1.maxOverzooming, s = n.filter((e1)=>e1.tileID.overscaledZ <= o);
            if (!s.length) {
                i.add(a);
                continue;
            }
            let c = Math.min(...s.map((e1)=>e1.tileID.overscaledZ)), l = s.filter((e1)=>e1.tileID.overscaledZ === c).map((e1)=>e1.tileID);
            for (let e1 of l)t[e1.key] = e1;
            this._areDescendentsComplete(l, c, a.overscaledZ) || i.add(a);
        }
        return i;
    }
    _getLoadedDescendents(e1) {
        let t = {};
        for (let n of this._inViewTiles.getAllTiles().filter((e1)=>e1.hasData()))for (let r of e1)n.tileID.isChildOf(r) && (t[r.key] ||= [], t[r.key].push(n));
        return t;
    }
    _areDescendentsComplete(e1, t, n) {
        return e1.length === 1 && e1[0].isOverscaled() ? e1[0].overscaledZ === t : 4 ** (t - n) === e1.length;
    }
    getLoadedTile(e1) {
        return this._inViewTiles.getLoadedTile(e1);
    }
    updateCacheSize(e1) {
        let t = (Math.ceil(e1.width / this._source.tileSize) + 1) * (Math.ceil(e1.height / this._source.tileSize) + 1), n = this._maxTileCacheZoomLevels === null ? (0, $1G0Uw.An).MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels, r = Math.floor(t * n), i = typeof this._maxTileCacheSize == `number` ? Math.min(this._maxTileCacheSize, r) : r;
        this._outOfViewCache.setMaxSize(i);
    }
    handleWrapJump(e1) {
        let t = (e1 - (this._prevLng === void 0 ? e1 : this._prevLng)) / 360, n = Math.round(t);
        this._prevLng = e1, n && (this._inViewTiles.handleWrapJump(n), this._resetTileReloadTimers());
    }
    _updateMaxContentElevation() {
        let e1 = this._maxContentElevationSeen, t = this.map?.style?._layers;
        if (!t) return e1;
        let n = this._inViewTiles.getAllTiles();
        for(let r in t){
            let i = t[r];
            if (i.type !== `symbol` || i.source !== this.id || i.isHidden(this.transform.zoom)) continue;
            let a = i;
            if (a.layout) {
                e1 = Math.max(e1, a.layout.get(`symbol-height-offset`).constantOr(0));
                for (let t of n){
                    let n = t.getBucket(i);
                    n && n.maxHeightOffset > e1 && (e1 = n.maxHeightOffset);
                }
            }
        }
        return this._maxContentElevationSeen = e1, e1;
    }
    update(e1, t) {
        if (!this._sourceLoaded || this._paused) return;
        this.transform = e1, this.terrain = t, this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng);
        let n;
        !this.used && !this.usedForTerrain ? n = [] : this._source.tileID ? n = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map((e1)=>new (0, $1G0Uw.d)(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y)) : (n = $4324d99ae8520741$var$ko(e1, {
            tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
            minzoom: this._source.minzoom,
            maxzoom: this._source.type === `vector` && this.map._zoomLevelsToOverscale !== void 0 ? Math.max(this._source.maxzoom, e1.maxZoom - this.map._zoomLevelsToOverscale) : this._source.maxzoom,
            roundZoom: !this.usedForTerrain && this._source.roundZoom,
            reparseOverscaled: this._source.reparseOverscaled,
            terrain: t,
            calculateTileZoom: this._source.calculateTileZoom,
            maxContentElevation: this._updateMaxContentElevation()
        }), this._source.hasTile && (n = n.filter((e1)=>this._source.hasTile(e1)))), this.usedForTerrain && (n = this._addTerrainIdealTiles(n));
        let r = n.length === 0 && !this._updated && this._didEmitContent;
        this._updated = !0, r && this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `idle`,
            sourceId: this.id
        }));
        let i = $4324d99ae8520741$var$Eo(e1, this._source), a = this._updateRetainedTiles(n, i), o = $4324d99ae8520741$var$Ao(this._source.type);
        o && this._rasterFadeDuration > 0 && !t && $4324d99ae8520741$var$jo(this._inViewTiles, n, a, this._maxFadingAncestorLevels, this._source.minzoom, this._source.maxzoom, this._rasterFadeDuration), o ? this._cleanUpRasterTiles(a) : this._cleanUpVectorTiles(a);
    }
    _cleanUpRasterTiles(e1) {
        for (let t of this._inViewTiles.getAllIds())e1[t] || this._removeTile(t);
    }
    _cleanUpVectorTiles(e1) {
        for (let t of this._inViewTiles.getAllIds()){
            let n = this._inViewTiles.getTileById(t);
            if (e1[t]) {
                n.clearSymbolFadeHold();
                continue;
            }
            if (!n.hasSymbolBuckets) {
                this._removeTile(t);
                continue;
            }
            n.holdingForSymbolFade() ? n.symbolFadeFinished() && this._removeTile(t) : n.setSymbolHoldDuration(this.map._fadeDuration);
        }
    }
    _addTerrainIdealTiles(e1) {
        let t = [];
        for (let n of e1)if (n.canonical.z > this._source.minzoom) {
            let e1 = n.scaledTo(n.canonical.z - 1);
            t.push(e1);
            let r = n.scaledTo(Math.max(this._source.minzoom, Math.min(n.canonical.z, 5)));
            t.push(r);
        }
        return e1.concat(t);
    }
    releaseSymbolFadeTiles() {
        for (let e1 of this._inViewTiles.getAllIds())this._inViewTiles.getTileById(e1).holdingForSymbolFade() && this._removeTile(e1);
    }
    _updateRetainedTiles(t, n) {
        let r = new Set;
        for (let e1 of t)this._addTile(e1).hasData() || r.add(e1);
        let i = t.reduce((e1, t)=>(e1[t.key] = t, e1), {}), a = this._retainLoadedChildren(i, r), o = {}, s = Math.max(n - e1.maxUnderzooming, this._source.minzoom);
        for (let e1 of a){
            let t = this._inViewTiles.getTileById(e1.key), n = t?.wasRequested();
            for(let r = e1.overscaledZ - 1; r >= s; --r){
                let a = e1.scaledTo(r);
                if (o[a.key]) break;
                if (o[a.key] = !0, t = this.getTile(a), !t && n && (t = this._addTile(a)), t) {
                    let e1 = t.hasData();
                    if ((e1 || !this.map?.cancelPendingTileRequestsWhileZooming || n) && (i[a.key] = a), n = t.wasRequested(), e1) break;
                }
            }
        }
        return i;
    }
    _addTile(e1) {
        let t = this._inViewTiles.getTileById(e1.key);
        if (t) return t;
        t = this._outOfViewCache.getAndRemove(e1), t && (t.resetFadeLogic(), this._setTileReloadTimer(e1.key, t), t.tileID = e1, this._state.initializeTileState(t, this.map ? this.map.painter : null));
        let n = t;
        return t || (t = new $4324d99ae8520741$var$po(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(t, e1.key, t.state, !1)), t.uses++, this._inViewTiles.setTile(e1.key, t), n || this._source.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`dataloading`, {
            tile: t,
            coord: t.tileID
        })), t;
    }
    _setTileReloadTimer(e1, t) {
        this._clearTileReloadTimer(e1);
        let n = t.getExpiryTimeout();
        if (n) {
            let t = ()=>{
                this._reloadTile(e1, `expired`), delete this._timers[e1];
            };
            this._timers[e1] = setTimeout(t, n);
        }
    }
    _clearTileReloadTimer(e1) {
        let t = this._timers[e1];
        t && (clearTimeout(t), delete this._timers[e1]);
    }
    _resetTileReloadTimers() {
        for(let e1 in this._timers)clearTimeout(this._timers[e1]), delete this._timers[e1];
        for (let e1 of this._inViewTiles.getAllIds()){
            let t = this._inViewTiles.getTileById(e1);
            this._setTileReloadTimer(e1, t);
        }
    }
    refreshTiles(e1) {
        for (let t of this._inViewTiles.getAllIds()){
            let n = this._inViewTiles.getTileById(t);
            (this._inViewTiles.isIdRenderable(t) || n.state == `errored`) && e1.some((e1)=>e1.equals(n.tileID.canonical)) && this._reloadTile(t, `expired`);
        }
    }
    _removeTile(e1) {
        let t = this._inViewTiles.getTileById(e1);
        t && (t.uses--, this._inViewTiles.deleteTileById(e1), this._clearTileReloadTimer(e1), !(t.uses > 0) && (t.hasData() && t.state !== `reloading` ? this._outOfViewCache.add(t.tileID, t, t.getExpiryTimeout()) : (t.aborted = !0, this._abortTile(t), this._unloadTile(t))));
    }
    _dataHandler(e1) {
        if (e1.dataType === `source`) {
            if (e1.sourceDataType === `metadata`) {
                this._sourceLoaded = !0;
                return;
            }
            e1.sourceDataType === `content` && this._sourceLoaded && !this._paused && (this.reload(e1.sourceDataChanged, e1.shouldReloadTileOptions), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
        }
    }
    resetMaxContentElevation() {
        this._maxContentElevationSeen = 0;
    }
    clearTiles() {
        this._shouldReloadOnResume = !1, this._paused = !1, this.resetMaxContentElevation();
        for (let e1 of this._inViewTiles.getAllIds())this._removeTile(e1);
        this._outOfViewCache.reset();
    }
    tilesIn(e1, t, n) {
        let r = [], i = this.transform;
        if (!i) return r;
        let a = i.getCoveringTilesDetailsProvider().allowWorldCopies(), o = n ? i.getCameraQueryGeometry(e1) : e1, s = (e1)=>i.screenPointToMercatorCoordinate(e1, this.terrain), c = this.transformBbox(e1, s, !a), l = this.transformBbox(o, s, !a), u = this.getIds(), d = (0, $1G0Uw.pt).fromPoints(l);
        for (let e1 of u){
            let n = this._inViewTiles.getTileById(e1);
            if (n.holdingForSymbolFade()) continue;
            let o = a ? [
                n.tileID
            ] : [
                n.tileID.unwrapTo(-1),
                n.tileID.unwrapTo(0)
            ], s = 2 ** (i.zoom - n.tileID.overscaledZ), u = t * n.queryPadding * (0, $1G0Uw.Lr) / n.tileSize / s;
            for (let e1 of o){
                let t = d.map((t)=>e1.getTilePoint(new (0, $1G0Uw.nt)(t.x, t.y)));
                if (t.expandBy(u), t.intersects((0, $1G0Uw.ft))) {
                    let t = c.map((t)=>e1.getTilePoint(t)), i = l.map((t)=>e1.getTilePoint(t));
                    r.push({
                        tile: n,
                        tileID: a ? e1 : e1.unwrapTo(0),
                        queryGeometry: t,
                        cameraQueryGeometry: i,
                        scale: s
                    });
                }
            }
        }
        return r;
    }
    transformBbox(e1, t, n) {
        let r = e1.map(t);
        if (n) {
            let n = (0, $1G0Uw.pt).fromPoints(e1);
            n.shrinkBy(Math.min(n.width(), n.height()) * .001);
            let i = n.map(t);
            (0, $1G0Uw.pt).fromPoints(r).covers(i) || (r = r.map((e1)=>e1.x > .5 ? new (0, $1G0Uw.nt)(e1.x - 1, e1.y, e1.z) : e1));
        }
        return r;
    }
    getVisibleCoordinates(e1) {
        let t = this.getRenderableIds(e1).map((e1)=>this._inViewTiles.getTileById(e1).tileID);
        return this.transform && this.transform.populateCache(t), t;
    }
    hasTransition() {
        return this._source.hasTransition() ? !0 : $4324d99ae8520741$var$Ao(this._source.type) && $4324d99ae8520741$var$Io(this._inViewTiles, this._rasterFadeDuration);
    }
    setRasterFadeDuration(e1) {
        this._rasterFadeDuration = e1;
    }
    setFeatureState(e1, t, n) {
        e1 ||= (0, $1G0Uw.s), this._state.updateState(e1, t, n);
    }
    removeFeatureState(e1, t, n) {
        e1 ||= (0, $1G0Uw.s), this._state.removeFeatureState(e1, t, n);
    }
    getFeatureState(e1, t) {
        return e1 ||= (0, $1G0Uw.s), this._state.getState(e1, t);
    }
    setDependencies(e1, t, n) {
        let r = this._inViewTiles.getTileById(e1);
        r && r.setDependencies(t, n);
    }
    reloadTilesForDependencies(e1, t) {
        for (let n of this._inViewTiles.getAllIds())this._inViewTiles.getTileById(n).hasDependency(e1, t) && this._reloadTile(n, `reloading`);
        this._outOfViewCache.filter((n)=>!n.hasDependency(e1, t));
    }
    areTilesLoaded() {
        for (let e1 of this._inViewTiles.getAllTiles())if (e1.state !== `loaded` && e1.state !== `errored`) return !1;
        return !0;
    }
}, $4324d99ae8520741$var$Vo = class {
    constructor(e1, t){
        this.reset(e1, t);
    }
    reset(e1, t) {
        this.points = e1 || [], this._distances = [
            0
        ];
        for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
        this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t || 0, this.length * .5), this.paddedLength = this.length - this.padding * 2;
    }
    lerp(e1) {
        if (this.points.length === 1) return this.points[0];
        e1 = (0, $1G0Uw.Bn)(e1, 0, 1);
        let t = 1, n = this._distances[t], r = e1 * this.paddedLength + this.padding;
        for(; n < r && t < this._distances.length;)n = this._distances[++t];
        let i = t - 1, a = this._distances[i], o = n - a, s = o > 0 ? (r - a) / o : 0;
        return this.points[i].mult(1 - s).add(this.points[t].mult(s));
    }
};
function $4324d99ae8520741$var$Ho(e1, t, n, r, i) {
    return i ? e1 ? e1(t, n) + r : r === 0 ? void 0 : r : r;
}
function $4324d99ae8520741$var$Uo(e1, t) {
    let n = !0;
    return e1 === `always` || (e1 === `never` || t === `never`) && (n = !1), n;
}
var $4324d99ae8520741$var$Wo = class {
    constructor(e1, t, n){
        let r = this.boxCells = [], i = this.circleCells = [];
        this.xCellCount = Math.ceil(e1 / n), this.yCellCount = Math.ceil(t / n);
        for(let e1 = 0; e1 < this.xCellCount * this.yCellCount; e1++)r.push([]), i.push([]);
        this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e1, this.height = t, this.xScale = this.xCellCount / e1, this.yScale = this.yCellCount / t, this.boxUid = 0, this.circleUid = 0;
    }
    keysLength() {
        return this.boxKeys.length + this.circleKeys.length;
    }
    insert(e1, t, n, r, i) {
        this._forEachCell(t, n, r, i, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e1), this.bboxes.push(t), this.bboxes.push(n), this.bboxes.push(r), this.bboxes.push(i);
    }
    insertCircle(e1, t, n, r) {
        this._forEachCell(t - r, n - r, t + r, n + r, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e1), this.circles.push(t), this.circles.push(n), this.circles.push(r);
    }
    _insertBoxCell(e1, t, n, r, i, a) {
        this.boxCells[i].push(a);
    }
    _insertCircleCell(e1, t, n, r, i, a) {
        this.circleCells[i].push(a);
    }
    _query(e1, t, n, r, i, a, o) {
        if (n < 0 || e1 > this.width || r < 0 || t > this.height) return [];
        let s = [];
        if (e1 <= 0 && t <= 0 && this.width <= n && this.height <= r) {
            if (i) return [
                {
                    key: null,
                    x1: e1,
                    y1: t,
                    x2: n,
                    y2: r
                }
            ];
            for(let e1 = 0; e1 < this.boxKeys.length; e1++)s.push({
                key: this.boxKeys[e1],
                x1: this.bboxes[e1 * 4],
                y1: this.bboxes[e1 * 4 + 1],
                x2: this.bboxes[e1 * 4 + 2],
                y2: this.bboxes[e1 * 4 + 3]
            });
            for(let e1 = 0; e1 < this.circleKeys.length; e1++){
                let t = this.circles[e1 * 3], n = this.circles[e1 * 3 + 1], r = this.circles[e1 * 3 + 2];
                s.push({
                    key: this.circleKeys[e1],
                    x1: t - r,
                    y1: n - r,
                    x2: t + r,
                    y2: n + r
                });
            }
        } else {
            let c = {
                hitTest: i,
                overlapMode: a,
                seenUids: {
                    box: {},
                    circle: {}
                }
            };
            this._forEachCell(e1, t, n, r, this._queryCell, s, c, o);
        }
        return s;
    }
    query(e1, t, n, r) {
        return this._query(e1, t, n, r, !1, null);
    }
    hitTest(e1, t, n, r, i, a) {
        return this._query(e1, t, n, r, !0, i, a).length > 0;
    }
    hitTestCircle(e1, t, n, r, i) {
        let a = e1 - n, o = e1 + n, s = t - n, c = t + n;
        if (o < 0 || a > this.width || c < 0 || s > this.height) return !1;
        let l = [], u = {
            hitTest: !0,
            overlapMode: r,
            circle: {
                x: e1,
                y: t,
                radius: n
            },
            seenUids: {
                box: {},
                circle: {}
            }
        };
        return this._forEachCell(a, s, o, c, this._queryCellCircle, l, u, i), l.length > 0;
    }
    _queryCell(e1, t, n, r, i, a, o, s) {
        let { seenUids: c, hitTest: l, overlapMode: u } = o, d = this.boxCells[i], f = 1e-6;
        if (d !== null) {
            let i = this.bboxes;
            for (let o of d)if (!c.box[o]) {
                c.box[o] = !0;
                let d = o * 4, p = this.boxKeys[o];
                if (e1 <= i[d + 2] + f && t <= i[d + 3] + f && n >= i[d + 0] - f && r >= i[d + 1] - f && (!s || s(p)) && (!l || !$4324d99ae8520741$var$Uo(u, p.overlapMode)) && (a.push({
                    key: p,
                    x1: i[d],
                    y1: i[d + 1],
                    x2: i[d + 2],
                    y2: i[d + 3]
                }), l)) return !0;
            }
        }
        let p = this.circleCells[i];
        if (p !== null) {
            let i = this.circles;
            for (let o of p)if (!c.circle[o]) {
                c.circle[o] = !0;
                let d = o * 3, f = this.circleKeys[o];
                if (this._circleAndRectCollide(i[d], i[d + 1], i[d + 2], e1, t, n, r) && (!s || s(f)) && (!l || !$4324d99ae8520741$var$Uo(u, f.overlapMode))) {
                    let e1 = i[d], t = i[d + 1], n = i[d + 2];
                    if (a.push({
                        key: f,
                        x1: e1 - n,
                        y1: t - n,
                        x2: e1 + n,
                        y2: t + n
                    }), l) return !0;
                }
            }
        }
        return !1;
    }
    _queryCellCircle(e1, t, n, r, i, a, o, s) {
        let { circle: c, seenUids: l, overlapMode: u } = o, d = this.boxCells[i];
        if (d !== null) {
            let e1 = this.bboxes;
            for (let t of d)if (!l.box[t]) {
                l.box[t] = !0;
                let n = t * 4, r = this.boxKeys[t];
                if (this._circleAndRectCollide(c.x, c.y, c.radius, e1[n + 0], e1[n + 1], e1[n + 2], e1[n + 3]) && (!s || s(r)) && !$4324d99ae8520741$var$Uo(u, r.overlapMode)) return a.push(!0), !0;
            }
        }
        let f = this.circleCells[i];
        if (f !== null) {
            let e1 = this.circles;
            for (let t of f)if (!l.circle[t]) {
                l.circle[t] = !0;
                let n = t * 3, r = this.circleKeys[t];
                if (this._circlesCollide(e1[n], e1[n + 1], e1[n + 2], c.x, c.y, c.radius) && (!s || s(r)) && !$4324d99ae8520741$var$Uo(u, r.overlapMode)) return a.push(!0), !0;
            }
        }
    }
    _forEachCell(e1, t, n, r, i, a, o, s) {
        let c = this._convertToXCellCoord(e1), l = this._convertToYCellCoord(t), u = this._convertToXCellCoord(n), d = this._convertToYCellCoord(r);
        for(let f = c; f <= u; f++)for(let c = l; c <= d; c++){
            let l = this.xCellCount * c + f;
            if (i.call(this, e1, t, n, r, l, a, o, s)) return;
        }
    }
    _convertToXCellCoord(e1) {
        return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
    }
    _convertToYCellCoord(e1) {
        return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
    }
    _circlesCollide(e1, t, n, r, i, a) {
        let o = r - e1, s = i - t, c = n + a;
        return c * c > o * o + s * s;
    }
    _circleAndRectCollide(e1, t, n, r, i, a, o) {
        let s = (a - r) / 2, c = Math.abs(e1 - (r + s));
        if (c > s + n) return !1;
        let l = (o - i) / 2, u = Math.abs(t - (i + l));
        if (u > l + n) return !1;
        if (c <= s || u <= l) return !0;
        let d = c - s, f = u - l;
        return d * d + f * f <= n * n;
    }
};
function $4324d99ae8520741$var$Go(e1, t) {
    let n = 1 / (t[0] * t[0] + t[1] * t[1] + t[2] * t[2]), r = 1 / (t[8] * t[8] + t[9] * t[9] + t[10] * t[10]), i = t[0] * n, a = t[4] * n, o = t[8] * r, s = t[1] * n, c = t[5] * n, l = t[9] * r, u = t[2] * n, d = t[6] * n, f = t[10] * r;
    e1[0] = i, e1[1] = a, e1[2] = o, e1[4] = s, e1[5] = c, e1[6] = l, e1[8] = u, e1[9] = d, e1[10] = f;
    let p = t[12], m = t[13], h = t[14];
    return e1[12] = -i * p - s * m - u * h, e1[13] = -a * p - c * m - d * h, e1[14] = -o * p - l * m - f * h, e1[3] = 0, e1[7] = 0, e1[11] = 0, e1[15] = 1, e1;
}
function $4324d99ae8520741$var$Ko(e1, t) {
    return e1[0] = 1 / t[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1 / t[5], e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 0, e1[11] = 1 / t[14], e1[12] = 0, e1[13] = 0, e1[14] = -1, e1[15] = t[10] / t[14], e1;
}
function $4324d99ae8520741$var$qo(e1, t) {
    let n = 1 / (t[0] * t[5] - t[1] * t[4]);
    return e1[0] = t[5] * n, e1[1] = -t[1] * n, e1[2] = 0, e1[3] = 0, e1[4] = -t[4] * n, e1[5] = t[0] * n, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1 / t[10], e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1 / t[15], e1;
}
const $4324d99ae8520741$var$Jo = (0, $1G0Uw.vi)();
function $4324d99ae8520741$var$Yo(e1, t, n) {
    let r = (0, $1G0Uw.vi)();
    if (!e1) {
        let { vecSouth: e1, vecEast: n } = $4324d99ae8520741$var$Zo(t), i = $4324d99ae8520741$var$jr();
        i[0] = n[0], i[1] = n[1], i[2] = e1[0], i[3] = e1[1], $4324d99ae8520741$var$Mr(i, i), r[0] = i[0], r[1] = i[1], r[4] = i[2], r[5] = i[3];
    }
    return (0, $1G0Uw.Ai)(r, r, [
        1 / n,
        1 / n,
        1
    ]), r;
}
function $4324d99ae8520741$var$Xo(e1, t, n, r) {
    if (e1) {
        let e1 = (0, $1G0Uw.vi)();
        if (!t) {
            let { vecSouth: t, vecEast: r } = $4324d99ae8520741$var$Zo(n);
            e1[0] = r[0], e1[1] = r[1], e1[4] = t[0], e1[5] = t[1];
        }
        return (0, $1G0Uw.Ai)(e1, e1, [
            r,
            r,
            1
        ]), e1;
    }
    return n.pixelsToClipSpaceMatrix;
}
function $4324d99ae8520741$var$Zo(e1) {
    let t = Math.cos(e1.rollInRadians), n = Math.sin(e1.rollInRadians), r = Math.cos(e1.pitchInRadians), i = Math.cos(e1.bearingInRadians), a = Math.sin(e1.bearingInRadians), o = (0, $1G0Uw.Rr)();
    o[0] = -i * r * n - a * t, o[1] = -a * r * n + i * t;
    let s = (0, $1G0Uw.zr)(o);
    s < 1e-9 ? (0, $1G0Uw.Hr)(o) : (0, $1G0Uw.Br)(o, o, 1 / s);
    let c = (0, $1G0Uw.Rr)();
    c[0] = i * r * t - a * n, c[1] = a * r * t + i * n;
    let l = (0, $1G0Uw.zr)(c);
    return l < 1e-9 ? (0, $1G0Uw.Hr)(c) : (0, $1G0Uw.Br)(c, c, 1 / l), {
        vecEast: c,
        vecSouth: o
    };
}
function $4324d99ae8520741$var$Qo(e1, t, n) {
    return $4324d99ae8520741$var$Ho(e1.getElevation, t, n, e1.heightOffset ?? 0, e1.heightAnchorGround ?? !0);
}
function $4324d99ae8520741$var$$o(e1, t, n, r) {
    let i;
    r == null ? (i = [
        e1,
        t,
        0,
        1
    ], $4324d99ae8520741$var$gs(i, i, n)) : (i = [
        e1,
        t,
        r,
        1
    ], (0, $1G0Uw.Yr)(i, i, n));
    let a = i[3];
    return {
        point: new (0, $1G0Uw.Li)(i[0] / a, i[1] / a),
        signedDistanceFromCamera: a,
        isOccluded: !1
    };
}
function $4324d99ae8520741$var$es(e1, t) {
    return .5 + e1 / t * .5;
}
function $4324d99ae8520741$var$ts(e1, t) {
    return e1.x >= -t[0] && e1.x <= t[0] && e1.y >= -t[1] && e1.y <= t[1];
}
function $4324d99ae8520741$var$ns(e1, t, n, r, a, o, s, c, l, u, d, f, p) {
    let m = n ? e1.textSizeData : e1.iconSizeData, h = (0, $1G0Uw.A)(m, t.transform.zoom), g = [
        256 / t.width * 2 + 1,
        256 / t.height * 2 + 1
    ], _ = n ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
    _.clear();
    let v = e1.lineVertexArray, y = n ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, b = t.transform.width / t.transform.height, x = !1;
    for(let n = 0; n < y.length; n++){
        let i = y.get(n);
        if (i.hidden || i.writingMode === 2 && !x) {
            $4324d99ae8520741$var$hs(i.numGlyphs, _);
            continue;
        }
        x = !1;
        let S = new (0, $1G0Uw.Li)(i.anchorX, i.anchorY), C = {
            getElevation: p,
            pitchedLabelPlaneMatrix: r,
            lineVertexArray: v,
            pitchWithMap: o,
            projectionCache: {
                projections: {},
                offsets: {},
                cachedAnchorPoint: void 0,
                anyProjectionOccluded: !1
            },
            transform: t.transform,
            tileAnchorPoint: S,
            unwrappedTileID: l,
            width: u,
            height: d,
            translation: f
        }, w = $4324d99ae8520741$var$us(i.anchorX, i.anchorY, C);
        if (!$4324d99ae8520741$var$ts(w.point, g)) {
            $4324d99ae8520741$var$hs(i.numGlyphs, _);
            continue;
        }
        let T = w.signedDistanceFromCamera, E = $4324d99ae8520741$var$es(t.transform.cameraToCenterDistance, T), D = (0, $1G0Uw.k)(m, h, i), O = o ? D * t.transform.getPitchedTextCorrection(i.anchorX, i.anchorY, l) / E : D * E, k = $4324d99ae8520741$var$as({
            projectionContext: C,
            pitchedLabelPlaneMatrixInverse: a,
            symbol: i,
            fontSize: O,
            flip: !1,
            keepUpright: s,
            glyphOffsetArray: e1.glyphOffsetArray,
            dynamicLayoutVertexArray: _,
            aspectRatio: b,
            rotateToLine: c
        });
        x = k.useVertical, (k.notEnoughRoom || x || k.needsFlipping && $4324d99ae8520741$var$as({
            projectionContext: C,
            pitchedLabelPlaneMatrixInverse: a,
            symbol: i,
            fontSize: O,
            flip: !0,
            keepUpright: s,
            glyphOffsetArray: e1.glyphOffsetArray,
            dynamicLayoutVertexArray: _,
            aspectRatio: b,
            rotateToLine: c
        }).notEnoughRoom) && $4324d99ae8520741$var$hs(i.numGlyphs, _);
    }
    n ? e1.text.dynamicLayoutVertexBuffer.updateData(_) : e1.icon.dynamicLayoutVertexBuffer.updateData(_);
}
function $4324d99ae8520741$var$rs(e1, t, n, r, i, a, o, s) {
    let c = a.glyphStartIndex + a.numGlyphs, l = a.lineStartIndex, u = a.lineStartIndex + a.lineLength, d = t.getoffsetX(a.glyphStartIndex), f = t.getoffsetX(c - 1), p = $4324d99ae8520741$var$ps(e1 * d, n, r, i, a.segment, l, u, s, o);
    if (!p) return null;
    let m = $4324d99ae8520741$var$ps(e1 * f, n, r, i, a.segment, l, u, s, o);
    return !m || s.projectionCache.anyProjectionOccluded ? null : {
        first: p,
        last: m
    };
}
function $4324d99ae8520741$var$is(e1, t, n, r) {
    return e1 === 1 && Math.abs(n.y - t.y) > Math.abs(n.x - t.x) * r ? {
        useVertical: !0
    } : (e1 === 2 ? t.y < n.y : t.x > n.x) ? {
        needsFlipping: !0
    } : null;
}
function $4324d99ae8520741$var$as(e1) {
    let { projectionContext: t, pitchedLabelPlaneMatrixInverse: n, symbol: r, fontSize: i, flip: a, keepUpright: o, glyphOffsetArray: s, dynamicLayoutVertexArray: c, aspectRatio: l, rotateToLine: u } = e1, d = i / 24, f = r.lineOffsetX * d, m = r.lineOffsetY * d, h;
    if (r.numGlyphs > 1) {
        let e1 = r.glyphStartIndex + r.numGlyphs, i = r.lineStartIndex, c = r.lineStartIndex + r.lineLength, p = $4324d99ae8520741$var$rs(d, s, f, m, a, r, u, t);
        if (!p) return {
            notEnoughRoom: !0
        };
        let g = $4324d99ae8520741$var$ls(p.first.point.x, p.first.point.y, t, n), _ = $4324d99ae8520741$var$ls(p.last.point.x, p.last.point.y, t, n);
        if (o && !a) {
            let e1 = $4324d99ae8520741$var$is(r.writingMode, g, _, l);
            if (e1) return e1;
        }
        h = [
            p.first
        ];
        for(let n = r.glyphStartIndex + 1; n < e1 - 1; n++){
            let e1 = $4324d99ae8520741$var$ps(d * s.getoffsetX(n), f, m, a, r.segment, i, c, t, u);
            if (!e1) return {
                notEnoughRoom: !0
            };
            h.push(e1);
        }
        h.push(p.last);
    } else {
        if (o && !a) {
            let e1 = $4324d99ae8520741$var$cs(t.tileAnchorPoint.x, t.tileAnchorPoint.y, t).point, i = r.lineStartIndex + r.segment + 1, a = new (0, $1G0Uw.Li)(t.lineVertexArray.getx(i), t.lineVertexArray.gety(i)), o = $4324d99ae8520741$var$cs(a.x, a.y, t), s = o.signedDistanceFromCamera > 0 ? o.point : $4324d99ae8520741$var$os(t.tileAnchorPoint, a, e1, 1, t), c = $4324d99ae8520741$var$ls(e1.x, e1.y, t, n), u = $4324d99ae8520741$var$ls(s.x, s.y, t, n), d = $4324d99ae8520741$var$is(r.writingMode, c, u, l);
            if (d) return d;
        }
        let e1 = $4324d99ae8520741$var$ps(d * s.getoffsetX(r.glyphStartIndex), f, m, a, r.segment, r.lineStartIndex, r.lineStartIndex + r.lineLength, t, u);
        if (!e1 || t.projectionCache.anyProjectionOccluded) return {
            notEnoughRoom: !0
        };
        h = [
            e1
        ];
    }
    for (let e1 of h)(0, $1G0Uw.C)(c, e1.point, e1.angle);
    return {};
}
function $4324d99ae8520741$var$os(e1, t, n, r, i) {
    let a = e1.add(e1.sub(t)._unit()), o = $4324d99ae8520741$var$cs(a.x, a.y, i).point, s = n.sub(o);
    return n.add(s._mult(r / s.mag()));
}
function $4324d99ae8520741$var$ss(e1, t, n) {
    let r = t.projectionCache;
    if (r.projections[e1]) return r.projections[e1];
    let i = new (0, $1G0Uw.Li)(t.lineVertexArray.getx(e1), t.lineVertexArray.gety(e1)), a = $4324d99ae8520741$var$cs(i.x, i.y, t);
    if (a.signedDistanceFromCamera > 0) return r.projections[e1] = a.point, r.anyProjectionOccluded ||= a.isOccluded, a.point;
    let o = e1 - n.direction, s = n.distanceFromAnchor === 0 ? t.tileAnchorPoint : new (0, $1G0Uw.Li)(t.lineVertexArray.getx(o), t.lineVertexArray.gety(o)), c = n.absOffsetX - n.distanceFromAnchor + 1;
    return $4324d99ae8520741$var$os(s, i, n.previousVertex, c, t);
}
function $4324d99ae8520741$var$cs(e1, t, n) {
    let r = e1 + n.translation[0], i = t + n.translation[1], a;
    return n.pitchWithMap ? (a = $4324d99ae8520741$var$$o(r, i, n.pitchedLabelPlaneMatrix, $4324d99ae8520741$var$Qo(n, r, i)), a.isOccluded = !1) : (a = n.transform.projectTileCoordinates(r, i, n.unwrappedTileID, $4324d99ae8520741$var$Qo(n, r, i)), a.point.x = (a.point.x * .5 + .5) * n.width, a.point.y = (-a.point.y * .5 + .5) * n.height), a;
}
function $4324d99ae8520741$var$ls(e1, t, n, r) {
    if (n.pitchWithMap) {
        let i = [
            e1,
            t,
            0,
            1
        ];
        (0, $1G0Uw.Yr)(i, i, r);
        let a = i[0] / i[3], o = i[1] / i[3];
        return n.transform.projectTileCoordinates(a, o, n.unwrappedTileID, $4324d99ae8520741$var$Qo(n, a, o)).point;
    }
    return {
        x: e1 / n.width * 2 - 1,
        y: 1 - t / n.height * 2
    };
}
function $4324d99ae8520741$var$us(e1, t, n) {
    return n.transform.projectTileCoordinates(e1, t, n.unwrappedTileID, $4324d99ae8520741$var$Qo(n, e1, t));
}
function $4324d99ae8520741$var$ds(e1, t, n) {
    return e1._unit()._perp()._mult(t * n);
}
function $4324d99ae8520741$var$fs(e1, t, n, r, i, a, o, s, c) {
    if (s.projectionCache.offsets[e1]) return s.projectionCache.offsets[e1];
    let l = n.add(t);
    if (e1 + c.direction < r || e1 + c.direction >= i) return s.projectionCache.offsets[e1] = l, l;
    let u = $4324d99ae8520741$var$ss(e1 + c.direction, s, c), d = $4324d99ae8520741$var$ds(u.sub(n), o, c.direction), f = n.add(d), p = u.add(d);
    return s.projectionCache.offsets[e1] = (0, $1G0Uw.nr)(a, l, f, p) || l, s.projectionCache.offsets[e1];
}
function $4324d99ae8520741$var$ps(e1, t, n, r, i, a, o, s, c) {
    let l = r ? e1 - t : e1 + t, u = l > 0 ? 1 : -1, d = 0;
    r && (u *= -1, d = Math.PI), u < 0 && (d += Math.PI);
    let f = u > 0 ? a + i : a + i + 1, p;
    s.projectionCache.cachedAnchorPoint ? p = s.projectionCache.cachedAnchorPoint : (p = $4324d99ae8520741$var$cs(s.tileAnchorPoint.x, s.tileAnchorPoint.y, s).point, s.projectionCache.cachedAnchorPoint = p);
    let m = p, h = p, g, _, v = 0, y = 0, b = Math.abs(l), x = [], S;
    for(; v + y <= b;){
        if (f += u, f < a || f >= o) return null;
        v += y, h = m, _ = g;
        let e1 = {
            absOffsetX: b,
            direction: u,
            distanceFromAnchor: v,
            previousVertex: h
        };
        if (m = $4324d99ae8520741$var$ss(f, s, e1), n === 0) x.push(h), S = m.sub(h);
        else {
            let t, r = m.sub(h);
            t = r.mag() === 0 ? $4324d99ae8520741$var$ds($4324d99ae8520741$var$ss(f + u, s, e1).sub(m), n, u) : $4324d99ae8520741$var$ds(r, n, u), _ ||= h.add(t), g = $4324d99ae8520741$var$fs(f, t, m, a, o, _, n, s, e1), x.push(_), S = g.sub(_);
        }
        y = S.mag();
    }
    let C = (b - v) / y, w = S._mult(C)._add(_ || h), T = d + Math.atan2(m.y - h.y, m.x - h.x);
    return x.push(w), {
        point: w,
        angle: c ? T : 0,
        path: x
    };
}
const $4324d99ae8520741$var$ms = new Float32Array([
    -1 / 0,
    -1 / 0,
    0,
    -1 / 0,
    -1 / 0,
    0,
    -1 / 0,
    -1 / 0,
    0,
    -1 / 0,
    -1 / 0,
    0
]);
function $4324d99ae8520741$var$hs(e1, t) {
    for(let n = 0; n < e1; n++){
        let e1 = t.length;
        t.resize(e1 + 4), t.float32.set($4324d99ae8520741$var$ms, e1 * 3);
    }
}
function $4324d99ae8520741$var$gs(e1, t, n) {
    let r = t[0], i = t[1];
    return e1[0] = n[0] * r + n[4] * i + n[12], e1[1] = n[1] * r + n[5] * i + n[13], e1[3] = n[3] * r + n[7] * i + n[15], e1;
}
function $4324d99ae8520741$var$_s(e1, t) {
    let n = $4324d99ae8520741$var$Jo;
    return $4324d99ae8520741$var$qo(n, t.pitchedLabelPlaneMatrix), e1.map((e1)=>{
        let r = $4324d99ae8520741$var$$o(e1.x, e1.y, n, $4324d99ae8520741$var$Qo(t, e1.x, e1.y)), i = t.transform.projectTileCoordinates(r.point.x, r.point.y, t.unwrappedTileID, $4324d99ae8520741$var$Qo(t, r.point.x, r.point.y));
        return i.point.x = (i.point.x * .5 + .5) * t.width, i.point.y = (-i.point.y * .5 + .5) * t.height, i;
    });
}
function $4324d99ae8520741$var$vs(e1) {
    let t = 0, n = 0, r = 0, i = 0;
    for(let a = 0; a < e1.length; a++)e1[a].isOccluded ? (r = a + 1, i = 0) : (i++, i > n && (n = i, t = r));
    return e1.slice(t, t + n);
}
var $4324d99ae8520741$var$ys = class {
    constructor(e1, t = new $4324d99ae8520741$var$Wo(e1.width + 200, e1.height + 200, 25), n = new $4324d99ae8520741$var$Wo(e1.width + 200, e1.height + 200, 25)){
        this.transform = e1, this.grid = t, this.ignoredGrid = n, this.pitchFactor = Math.cos(e1.pitch * Math.PI / 180) * e1.cameraToCenterDistance, this.screenRightBoundary = e1.width + 100, this.screenBottomBoundary = e1.height + 100, this.gridRightBoundary = e1.width + 200, this.gridBottomBoundary = e1.height + 200, this.perspectiveRatioCutoff = .6;
    }
    placeCollisionBox(e1, t, n, r, i, a, o, s, c, l, u, d, f = 0, p = !0) {
        let m = e1.anchorPointX + s[0], h = e1.anchorPointY + s[1], g = this.projectAndGetPerspectiveRatio(m, h, i, $4324d99ae8520741$var$Ho(l, m, h, f, p), d), _ = n * g.perspectiveRatio, v;
        if (!a && !o) {
            let t = g.x + (u ? u.x * _ : 0), n = g.y + (u ? u.y * _ : 0);
            v = {
                allPointsOccluded: !1,
                box: [
                    t + e1.x1 * _,
                    n + e1.y1 * _,
                    t + e1.x2 * _,
                    n + e1.y2 * _
                ]
            };
        } else v = this._projectCollisionBox(e1, _, r, i, a, o, s, g, l, u, d, f, p);
        let [y, b, x, S] = v.box, C = a ? v.allPointsOccluded : g.isOccluded, w = C;
        return w ||= g.perspectiveRatio < this.perspectiveRatioCutoff, w ||= !this.isInsideGrid(y, b, x, S), w || t !== `always` && this.grid.hitTest(y, b, x, S, t, c) ? {
            box: [
                y,
                b,
                x,
                S
            ],
            placeable: !1,
            offscreen: !1,
            occluded: C
        } : {
            box: [
                y,
                b,
                x,
                S
            ],
            placeable: !0,
            offscreen: this.isOffscreen(y, b, x, S),
            occluded: C
        };
    }
    placeCollisionCircles(e1, t, n, r, i, a, o, s, c, l, u, d, f, p) {
        let m = [], h = new (0, $1G0Uw.Li)(t.anchorX, t.anchorY), g = this.getPerspectiveRatio(h.x, h.y, a, p?.(h.x, h.y)), _ = (c ? i * this.transform.getPitchedTextCorrection(t.anchorX, t.anchorY, a) / g : i * g) / 24, v = {
            projections: {},
            offsets: {},
            cachedAnchorPoint: void 0,
            anyProjectionOccluded: !1
        }, y = t.lineOffsetX * _, b = t.lineOffsetY * _, x = {
            getElevation: p,
            pitchedLabelPlaneMatrix: o,
            lineVertexArray: n,
            pitchWithMap: c,
            projectionCache: v,
            transform: this.transform,
            tileAnchorPoint: h,
            unwrappedTileID: a,
            width: this.transform.width,
            height: this.transform.height,
            translation: f
        }, S = $4324d99ae8520741$var$rs(_, r, y, b, !1, t, !1, x), C = !1, w = !1, T = !0;
        if (S) {
            let t = u * .5 * g + d, n = new (0, $1G0Uw.Li)(-100, -100), r = new (0, $1G0Uw.Li)(this.screenRightBoundary, this.screenBottomBoundary), i = new $4324d99ae8520741$var$Vo, a = S.first, o = S.last, f = [];
            for(let e1 = a.path.length - 1; e1 >= 1; e1--)f.push(a.path[e1]);
            for(let e1 = 1; e1 < o.path.length; e1++)f.push(o.path[e1]);
            let p = t * 2.5;
            if (c) {
                let e1 = this.projectPathToScreenSpace(f, x);
                f = e1.some((e1)=>e1.signedDistanceFromCamera <= 0) ? [] : e1.map((e1)=>e1.point);
            }
            let h = [];
            if (f.length > 0) {
                let e1 = f[0].clone(), t = f[0].clone();
                for(let n = 1; n < f.length; n++)e1.x = Math.min(e1.x, f[n].x), e1.y = Math.min(e1.y, f[n].y), t.x = Math.max(t.x, f[n].x), t.y = Math.max(t.y, f[n].y);
                h = e1.x >= n.x && t.x <= r.x && e1.y >= n.y && t.y <= r.y ? [
                    f
                ] : t.x < n.x || e1.x > r.x || t.y < n.y || e1.y > r.y ? [] : (0, $1G0Uw.O)([
                    f
                ], n.x, n.y, r.x, r.y);
            }
            for (let n of h){
                i.reset(n, t * .25);
                let r = 0;
                r = i.length <= .5 * t ? 1 : Math.ceil(i.paddedLength / p) + 1;
                for(let n = 0; n < r; n++){
                    let a = n / Math.max(r - 1, 1), o = i.lerp(a), c = o.x + 100, u = o.y + 100;
                    m.push(c, u, t, 0);
                    let d = c - t, f = u - t, p = c + t, h = u + t;
                    if (T &&= this.isOffscreen(d, f, p, h), w ||= this.isInsideGrid(d, f, p, h), e1 !== `always` && this.grid.hitTestCircle(c, u, t, e1, l) && (C = !0, !s)) return {
                        circles: [],
                        offscreen: !1,
                        collisionDetected: C
                    };
                }
            }
        }
        return {
            circles: !s && C || !w || g < this.perspectiveRatioCutoff ? [] : m,
            offscreen: T,
            collisionDetected: C
        };
    }
    projectPathToScreenSpace(e1, t) {
        return $4324d99ae8520741$var$vs($4324d99ae8520741$var$_s(e1, t));
    }
    queryRenderedSymbols(e1) {
        if (e1.length === 0 || this.grid.keysLength() === 0 && this.ignoredGrid.keysLength() === 0) return {};
        let t = [], n = new (0, $1G0Uw.pt);
        for (let r of e1){
            let e1 = new (0, $1G0Uw.Li)(r.x + 100, r.y + 100);
            n.extend(e1), t.push(e1);
        }
        let { minX: r, minY: i, maxX: a, maxY: o } = n, s = this.grid.query(r, i, a, o).concat(this.ignoredGrid.query(r, i, a, o)), c = {}, l = {};
        for (let e1 of s){
            let n = e1.key;
            if (c[n.bucketInstanceId] === void 0 && (c[n.bucketInstanceId] = {}), c[n.bucketInstanceId][n.featureIndex]) continue;
            let r = [
                new (0, $1G0Uw.Li)(e1.x1, e1.y1),
                new (0, $1G0Uw.Li)(e1.x2, e1.y1),
                new (0, $1G0Uw.Li)(e1.x2, e1.y2),
                new (0, $1G0Uw.Li)(e1.x1, e1.y2)
            ];
            (0, $1G0Uw.kt)(t, r) && (c[n.bucketInstanceId][n.featureIndex] = !0, l[n.bucketInstanceId] === void 0 && (l[n.bucketInstanceId] = []), l[n.bucketInstanceId].push(n.featureIndex));
        }
        return l;
    }
    insertCollisionBox(e1, t, n, r, i, a) {
        let o = n ? this.ignoredGrid : this.grid, s = {
            bucketInstanceId: r,
            featureIndex: i,
            collisionGroupID: a,
            overlapMode: t
        };
        o.insert(s, e1[0], e1[1], e1[2], e1[3]);
    }
    insertCollisionCircles(e1, t, n, r, i, a) {
        let o = n ? this.ignoredGrid : this.grid, s = {
            bucketInstanceId: r,
            featureIndex: i,
            collisionGroupID: a,
            overlapMode: t
        };
        for(let t = 0; t < e1.length; t += 4)o.insertCircle(s, e1[t], e1[t + 1], e1[t + 2]);
    }
    projectAndGetPerspectiveRatio(e1, t, n, r, i) {
        if (i) {
            let n;
            r == null ? (n = [
                e1,
                t,
                0,
                1
            ], $4324d99ae8520741$var$gs(n, n, i)) : (n = [
                e1,
                t,
                r,
                1
            ], (0, $1G0Uw.Yr)(n, n, i));
            let a = n[3];
            return {
                x: (n[0] / a + 1) / 2 * this.transform.width + 100,
                y: (-n[1] / a + 1) / 2 * this.transform.height + 100,
                perspectiveRatio: .5 + .5 * (this.transform.cameraToCenterDistance / a),
                isOccluded: !1,
                signedDistanceFromCamera: a
            };
        }
        {
            let i = this.transform.projectTileCoordinates(e1, t, n, r);
            return {
                x: (i.point.x + 1) / 2 * this.transform.width + 100,
                y: (-i.point.y + 1) / 2 * this.transform.height + 100,
                perspectiveRatio: .5 + .5 * (this.transform.cameraToCenterDistance / i.signedDistanceFromCamera),
                isOccluded: i.isOccluded,
                signedDistanceFromCamera: i.signedDistanceFromCamera
            };
        }
    }
    getPerspectiveRatio(e1, t, n, r) {
        let i = this.transform.projectTileCoordinates(e1, t, n, r);
        return .5 + .5 * (this.transform.cameraToCenterDistance / i.signedDistanceFromCamera);
    }
    isOffscreen(e1, t, n, r) {
        return n < 100 || e1 >= this.screenRightBoundary || r < 100 || t > this.screenBottomBoundary;
    }
    isInsideGrid(e1, t, n, r) {
        return n >= 0 && e1 < this.gridRightBoundary && r >= 0 && t < this.gridBottomBoundary;
    }
    getViewportMatrix() {
        let e1 = (0, $1G0Uw.Si)([]);
        return (0, $1G0Uw.ji)(e1, e1, [
            -100,
            -100,
            0
        ]), e1;
    }
    _projectCollisionBox(e1, t, n, r, i, a, o, s, c, l, d, f = 0, p = !0) {
        let m = 1, h = 0, g = 0, _ = 1, v = e1.anchorPointX + o[0], y = e1.anchorPointY + o[1];
        if (a && !i) {
            let e1 = this.projectAndGetPerspectiveRatio(v + 1, y, r, $4324d99ae8520741$var$Ho(c, v + 1, y, f, p), d), t = e1.x - s.x, n = e1.y - s.y, i = Math.atan(n / t) + (t < 0 ? Math.PI : 0), a = Math.sin(i), o = Math.cos(i);
            m = o, h = a, g = -a, _ = o;
        } else if (!a && i) {
            let e1 = $4324d99ae8520741$var$Zo(this.transform);
            m = e1.vecEast[0], h = e1.vecEast[1], g = e1.vecSouth[0], _ = e1.vecSouth[1];
        }
        let b = s.x, x = s.y, S = t;
        if (i && (b = v, x = y, S = 2 ** -(this.transform.zoom - n.overscaledZ), S *= this.transform.getPitchedTextCorrection(v, y, r), !l)) {
            let e1 = s.signedDistanceFromCamera / this.transform.cameraToCenterDistance, t = (0, $1G0Uw.Bn)(.5 + .5 * e1, 0, 4);
            S *= t;
        }
        l && (b += m * l.x * S + g * l.y * S, x += h * l.x * S + _ * l.y * S);
        let C = e1.x1 * S, w = e1.x2 * S, T = (C + w) / 2, E = e1.y1 * S, D = e1.y2 * S, O = (E + D) / 2, k = [
            {
                offsetX: C,
                offsetY: E
            },
            {
                offsetX: T,
                offsetY: E
            },
            {
                offsetX: w,
                offsetY: E
            },
            {
                offsetX: w,
                offsetY: O
            },
            {
                offsetX: w,
                offsetY: D
            },
            {
                offsetX: T,
                offsetY: D
            },
            {
                offsetX: C,
                offsetY: D
            },
            {
                offsetX: C,
                offsetY: O
            }
        ], A = [];
        for (let { offsetX: e1, offsetY: t } of k)A.push(new (0, $1G0Uw.Li)(b + m * e1 + g * t, x + h * e1 + _ * t));
        let j = !1;
        if (i) {
            let e1 = A.map((e1)=>this.projectAndGetPerspectiveRatio(e1.x, e1.y, r, $4324d99ae8520741$var$Ho(c, e1.x, e1.y, f, p), d));
            j = e1.some((e1)=>!e1.isOccluded), A = e1.map((e1)=>new (0, $1G0Uw.Li)(e1.x, e1.y));
        } else j = !0;
        return {
            box: (0, $1G0Uw.rr)(A),
            allPointsOccluded: !j
        };
    }
}, $4324d99ae8520741$var$bs = class {
    constructor(e1, t, n, r){
        this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t : -t))) : r && n ? 1 : 0, this.placed = n;
    }
    isHidden() {
        return this.opacity === 0 && !this.placed;
    }
}, $4324d99ae8520741$var$xs = class {
    constructor(e1, t, n, r, i){
        this.text = new $4324d99ae8520741$var$bs(e1 ? e1.text : null, t, n, i), this.icon = new $4324d99ae8520741$var$bs(e1 ? e1.icon : null, t, r, i);
    }
    isHidden() {
        return this.text.isHidden() && this.icon.isHidden();
    }
}, $4324d99ae8520741$var$Ss = class {
    constructor(e1, t, n){
        this.text = e1, this.icon = t, this.skipFade = n;
    }
}, $4324d99ae8520741$var$Cs = class {
    constructor(e1, t, n, r, i){
        this.bucketInstanceId = e1, this.featureIndex = t, this.sourceLayerIndex = n, this.bucketIndex = r, this.tileID = i;
    }
}, $4324d99ae8520741$var$ws = class {
    constructor(e1){
        this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
    }
    get(e1) {
        if (this.crossSourceCollisions) return {
            ID: 0,
            predicate: null
        };
        if (!this.collisionGroups[e1]) {
            let t = ++this.maxGroupID;
            this.collisionGroups[e1] = {
                ID: t,
                predicate: (e1)=>e1.collisionGroupID === t
            };
        }
        return this.collisionGroups[e1];
    }
};
function $4324d99ae8520741$var$Ts(e1, t, n, r, i) {
    let { horizontalAlign: a, verticalAlign: o } = (0, $1G0Uw.M)(e1), s = -(a - .5) * t, c = -(o - .5) * n;
    return new (0, $1G0Uw.Li)(s + r[0] * i, c + r[1] * i);
}
var $4324d99ae8520741$var$Es = class {
    constructor(e1, t, n, r, i){
        this.transform = e1.clone(), this.terrain = t, this.collisionIndex = new $4324d99ae8520741$var$ys(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = n, this.retainedQueryData = {}, this.collisionGroups = new $4324d99ae8520741$var$ws(r), this.collisionCircleArrays = {}, this.collisionBoxArrays = new Map, this.prevPlacement = i, i && (i.prevPlacement = void 0), this.placedOrientations = {};
    }
    _getTerrainElevationFunc(e1) {
        let t = this.terrain;
        if (t) return (n, r)=>t.getElevation(e1, n, r);
    }
    getBucketParts(e1, t, n, r) {
        let a = n.getBucket(t), o = n.latestFeatureIndex;
        if (!a || !o || t.id !== a.layerIds[0]) return;
        let s = n.collisionBoxArray, c = a.layers[0].layout, l = a.layers[0].paint, u = 2 ** (this.transform.zoom - n.tileID.overscaledZ), d = n.tileSize / (0, $1G0Uw.Lr), f = n.tileID.toUnwrapped(), p = c.get(`text-rotation-alignment`) === `map`, m = (0, $1G0Uw.Ir)(n, 1, this.transform.zoom), h = (0, $1G0Uw.jr)(this.collisionIndex.transform, n, l.get(`text-translate`), l.get(`text-translate-anchor`)), g = (0, $1G0Uw.jr)(this.collisionIndex.transform, n, l.get(`icon-translate`), l.get(`icon-translate-anchor`)), _ = $4324d99ae8520741$var$Yo(p, this.transform, m);
        this.retainedQueryData[a.bucketInstanceId] = new $4324d99ae8520741$var$Cs(a.bucketInstanceId, o, a.sourceLayerIndex, a.index, n.tileID);
        let v = {
            bucket: a,
            layout: c,
            translationText: h,
            translationIcon: g,
            unwrappedTileID: f,
            pitchedLabelPlaneMatrix: _,
            scale: u,
            textPixelRatio: d,
            holdingForFade: n.holdingForSymbolFade(),
            collisionBoxArray: s,
            partiallyEvaluatedTextSize: (0, $1G0Uw.A)(a.textSizeData, this.transform.zoom),
            collisionGroup: this.collisionGroups.get(a.sourceID)
        };
        if (r) for (let t of a.sortKeyRanges){
            let { sortKey: n, symbolInstanceStart: r, symbolInstanceEnd: i } = t;
            e1.push({
                sortKey: n,
                symbolInstanceStart: r,
                symbolInstanceEnd: i,
                parameters: v
            });
        }
        else e1.push({
            symbolInstanceStart: 0,
            symbolInstanceEnd: a.symbolInstances.length,
            parameters: v
        });
    }
    attemptAnchorPlacement(e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x) {
        let C = (0, $1G0Uw.E)[e1.textAnchor], w = [
            e1.textOffset0,
            e1.textOffset1
        ], T = $4324d99ae8520741$var$Ts(C, n, r, w, i), E = this.collisionIndex.placeCollisionBox(t, d, s, c, l, o, a, h, u.predicate, v, T, y, b, x);
        if ((!_ || this.collisionIndex.placeCollisionBox(_, d, s, c, l, o, a, g, u.predicate, v, T, y, b, x).placeable) && E.placeable) {
            let e1;
            if (this.prevPlacement?.variableOffsets[f.crossTileID] && this.prevPlacement?.placements[f.crossTileID]?.text && (e1 = this.prevPlacement.variableOffsets[f.crossTileID].anchor), f.crossTileID === 0) throw Error(`symbolInstance.crossTileID can't be 0`);
            return this.variableOffsets[f.crossTileID] = {
                textOffset: w,
                width: n,
                height: r,
                anchor: C,
                textBoxScale: i,
                prevAnchor: e1
            }, this.markUsedJustification(p, C, f, m), p.allowVerticalPlacement && (this.markUsedOrientation(p, m, f), this.placedOrientations[f.crossTileID] = m), {
                shift: T,
                placedGlyphBoxes: E
            };
        }
    }
    placeLayerBucketPart(e1, t, n) {
        let { bucket: r, layout: i, translationText: a, translationIcon: o, unwrappedTileID: s, pitchedLabelPlaneMatrix: c, textPixelRatio: l, holdingForFade: u, collisionBoxArray: d, partiallyEvaluatedTextSize: f, collisionGroup: p } = e1.parameters, m = i.get(`text-optional`), h = i.get(`icon-optional`), g = (0, $1G0Uw.w)(i, `text-overlap`, `text-allow-overlap`), _ = g === `always`, v = (0, $1G0Uw.w)(i, `icon-overlap`, `icon-allow-overlap`), y = v === `always`, b = i.get(`text-rotation-alignment`) === `map`, x = i.get(`text-pitch-alignment`) === `map`, C = i.get(`icon-text-fit`) !== `none`, w = i.get(`symbol-z-order`) === `viewport-y`, T = i.get(`symbol-height-anchor`) === `ground`, E = _ && (y || !r.hasIconData() || h), D = y && (_ || !r.hasTextData() || m);
        !r.collisionArrays && d && r.deserializeCollisionBoxes(d);
        let O = this.retainedQueryData[r.bucketInstanceId].tileID, k = this._getTerrainElevationFunc(O), A = this.transform.getFastPathSimpleProjectionMatrix(O), j = (e1, d, y)=>{
            if (t[e1.crossTileID]) return;
            if (u) {
                this.placements[e1.crossTileID] = new $4324d99ae8520741$var$Ss(!1, !1, !1);
                return;
            }
            let w = e1.heightOffset, j = !1, M = !1, ee = !0, te = null, ne = {
                box: null,
                placeable: !1,
                offscreen: null,
                occluded: !1
            }, re = {
                box: null,
                placeable: !1,
                offscreen: null
            }, ie = null, ae = null, oe = null, se = 0, ce = 0, le = 0;
            d.textFeatureIndex ? se = d.textFeatureIndex : e1.useRuntimeCollisionCircles && (se = e1.featureIndex), d.verticalTextFeatureIndex && (ce = d.verticalTextFeatureIndex);
            let ue = d.textBox;
            if (ue) {
                let t = (t)=>{
                    let n = 1;
                    if (r.allowVerticalPlacement && !t && this.prevPlacement) {
                        let t = this.prevPlacement.placedOrientations[e1.crossTileID];
                        t && (this.placedOrientations[e1.crossTileID] = t, n = t, this.markUsedOrientation(r, n, e1));
                    }
                    return n;
                }, i = (t, n)=>{
                    if (r.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && d.verticalTextBox) {
                        for (let e1 of r.writingModes)if (e1 === 2 ? (ne = n(), re = ne) : ne = t(), ne?.placeable) break;
                    } else ne = t();
                }, c = e1.textAnchorOffsetStartIndex, u = e1.textAnchorOffsetEndIndex;
                if (u === c) {
                    let n = (t, n)=>{
                        let i = this.collisionIndex.placeCollisionBox(t, g, l, O, s, x, b, a, p.predicate, k, void 0, A, w, T);
                        return i?.placeable && (this.markUsedOrientation(r, n, e1), this.placedOrientations[e1.crossTileID] = n), i;
                    };
                    i(()=>n(ue, 1), ()=>{
                        let t = d.verticalTextBox;
                        return r.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && t ? n(t, 2) : {
                            box: null,
                            offscreen: null
                        };
                    }), t(ne?.placeable);
                } else {
                    let f = (0, $1G0Uw.E)[this.prevPlacement?.variableOffsets[e1.crossTileID]?.anchor], m = (t, i, d)=>{
                        let m = t.x2 - t.x1, h = t.y2 - t.y1, _ = e1.textBoxScale, y = C && v === `never` ? i : null, S = null, E = g === `never` ? 1 : 2, D = `never`;
                        f && E++;
                        for(let n = 0; n < E; n++){
                            for(let n = c; n < u; n++){
                                let i = r.textAnchorOffsets.get(n);
                                if (f && i.textAnchor !== f) continue;
                                let c = this.attemptAnchorPlacement(i, t, m, h, _, b, x, l, O, s, p, D, e1, r, d, a, o, y, k, A, w, T);
                                if (c && (S = c.placedGlyphBoxes, S?.placeable)) return j = !0, te = c.shift, S;
                            }
                            f ? f = null : D = g;
                        }
                        return n && !S && (S = {
                            box: this.collisionIndex.placeCollisionBox(ue, `always`, l, O, s, x, b, a, p.predicate, k, void 0, A, w, T).box,
                            offscreen: !1,
                            placeable: !1,
                            occluded: !1
                        }), S;
                    };
                    i(()=>m(ue, d.iconBox, 1), ()=>{
                        let t = d.verticalTextBox, n = ne?.placeable;
                        return r.allowVerticalPlacement && !n && e1.numVerticalGlyphVertices > 0 && t ? m(t, d.verticalIconBox, 2) : {
                            box: null,
                            occluded: !0,
                            offscreen: null
                        };
                    }), ne && (j = ne.placeable, ee = ne.offscreen);
                    let h = t(ne?.placeable);
                    if (!j && this.prevPlacement) {
                        let t = this.prevPlacement.variableOffsets[e1.crossTileID];
                        t && (this.variableOffsets[e1.crossTileID] = t, this.markUsedJustification(r, t.anchor, e1, h));
                    }
                }
            }
            if (ie = ne, j = ie?.placeable, ee = ie?.offscreen, e1.useRuntimeCollisionCircles && e1.centerJustifiedTextSymbolIndex >= 0) {
                let t = r.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), o = (0, $1G0Uw.k)(r.textSizeData, f, t), l = i.get(`text-padding`), u = e1.collisionCircleDiameter;
                ae = this.collisionIndex.placeCollisionCircles(g, t, r.lineVertexArray, r.glyphOffsetArray, o, s, c, n, x, p.predicate, u, l, a, k), ae.circles.length && ae.collisionDetected && !n && (0, $1G0Uw.Nr)(`Collisions detected, but collision boxes are not shown`), j = _ || ae.circles.length > 0 && !ae.collisionDetected, ee &&= ae.offscreen;
            }
            if (d.iconFeatureIndex && (le = d.iconFeatureIndex), d.iconBox) {
                let e1 = (e1)=>this.collisionIndex.placeCollisionBox(e1, v, l, O, s, x, b, o, p.predicate, k, C && te ? te : void 0, A, w, T);
                re && re.placeable && d.verticalIconBox ? (oe = e1(d.verticalIconBox), M = oe.placeable) : (oe = e1(d.iconBox), M = oe.placeable), ee &&= oe.offscreen;
            }
            let de = m || e1.numHorizontalGlyphVertices === 0 && e1.numVerticalGlyphVertices === 0, fe = h || e1.numIconVertices === 0;
            !de && !fe ? M = j = M && j : fe ? de || (M &&= j) : j = M && j;
            let pe = j && ie.placeable, me = M && oe.placeable;
            if (pe && (re && re.placeable && ce ? this.collisionIndex.insertCollisionBox(ie.box, g, i.get(`text-ignore-placement`), r.bucketInstanceId, ce, p.ID) : this.collisionIndex.insertCollisionBox(ie.box, g, i.get(`text-ignore-placement`), r.bucketInstanceId, se, p.ID)), me && this.collisionIndex.insertCollisionBox(oe.box, v, i.get(`icon-ignore-placement`), r.bucketInstanceId, le, p.ID), ae && j && this.collisionIndex.insertCollisionCircles(ae.circles, g, i.get(`text-ignore-placement`), r.bucketInstanceId, se, p.ID), n && this.storeCollisionData(r.bucketInstanceId, y, d, ie, oe, ae), e1.crossTileID === 0) throw Error(`symbolInstance.crossTileID can't be 0`);
            if (r.bucketInstanceId === 0) throw Error(`bucket.bucketInstanceId can't be 0`);
            let he = (j || E) && !ie?.occluded, ge = (M || D) && !oe?.occluded;
            this.placements[e1.crossTileID] = new $4324d99ae8520741$var$Ss(he, ge, ee || r.justReloaded), t[e1.crossTileID] = !0;
        };
        if (w) {
            if (e1.symbolInstanceStart !== 0) throw Error(`bucket.bucketInstanceId should be 0`);
            let t = r.getSortedSymbolIndexes(-this.transform.bearingInRadians);
            for(let e1 = t.length - 1; e1 >= 0; --e1){
                let n = t[e1];
                j(r.symbolInstances.get(n), r.collisionArrays[n], n);
            }
        } else for(let t = e1.symbolInstanceStart; t < e1.symbolInstanceEnd; t++)j(r.symbolInstances.get(t), r.collisionArrays[t], t);
        r.justReloaded = !1;
    }
    storeCollisionData(e1, t, n, r, i, a) {
        if (n.textBox || n.iconBox) {
            let a;
            this.collisionBoxArrays.has(e1) ? a = this.collisionBoxArrays.get(e1) : (a = new Map, this.collisionBoxArrays.set(e1, a));
            let o;
            a.has(t) ? o = a.get(t) : (o = {
                text: null,
                icon: null
            }, a.set(t, o)), n.textBox && (o.text = r.box), n.iconBox && (o.icon = i.box);
        }
        if (a) {
            let t = this.collisionCircleArrays[e1];
            t === void 0 && (t = this.collisionCircleArrays[e1] = []);
            for(let e1 = 0; e1 < a.circles.length; e1 += 4)t.push(a.circles[e1 + 0] - 100), t.push(a.circles[e1 + 1] - 100), t.push(a.circles[e1 + 2]), t.push(+!!a.collisionDetected);
        }
    }
    markUsedJustification(e1, t, n, r) {
        let i = {
            left: n.leftJustifiedTextSymbolIndex,
            center: n.centerJustifiedTextSymbolIndex,
            right: n.rightJustifiedTextSymbolIndex
        }, a;
        a = r === 2 ? n.verticalPlacedTextSymbolIndex : i[(0, $1G0Uw.T)(t)];
        let o = [
            n.leftJustifiedTextSymbolIndex,
            n.centerJustifiedTextSymbolIndex,
            n.rightJustifiedTextSymbolIndex,
            n.verticalPlacedTextSymbolIndex
        ];
        for (let t of o)t >= 0 && (a >= 0 && t !== a ? e1.text.placedSymbolArray.get(t).crossTileID = 0 : e1.text.placedSymbolArray.get(t).crossTileID = n.crossTileID);
    }
    markUsedOrientation(e1, t, n) {
        let r = t === 1 || t === 3 ? t : 0, i = t === 2 ? t : 0, a = [
            n.leftJustifiedTextSymbolIndex,
            n.centerJustifiedTextSymbolIndex,
            n.rightJustifiedTextSymbolIndex
        ];
        for (let t of a)e1.text.placedSymbolArray.get(t).placedOrientation = r;
        n.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(n.verticalPlacedTextSymbolIndex).placedOrientation = i);
    }
    commit(e1) {
        this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
        let t = this.prevPlacement, n = !1;
        this.prevZoomAdjustment = t ? t.zoomAdjustment(this.transform.zoom) : 0;
        let r = t ? t.symbolFadeChange(e1) : 1, i = t ? t.opacities : {}, a = t ? t.variableOffsets : {}, o = t ? t.placedOrientations : {};
        for(let e1 in this.placements){
            let t = this.placements[e1], a = i[e1];
            a ? (this.opacities[e1] = new $4324d99ae8520741$var$xs(a, r, t.text, t.icon), n ||= t.text !== a.text.placed, n ||= t.icon !== a.icon.placed) : (this.opacities[e1] = new $4324d99ae8520741$var$xs(null, r, t.text, t.icon, t.skipFade), n ||= t.text || t.icon);
        }
        for(let e1 in i){
            let t = i[e1];
            if (!this.opacities[e1]) {
                let i = new $4324d99ae8520741$var$xs(t, r, !1, !1);
                i.isHidden() || (this.opacities[e1] = i, n ||= t.text.placed, n ||= t.icon.placed);
            }
        }
        for(let e1 in a)!this.variableOffsets[e1] && this.opacities[e1] && !this.opacities[e1].isHidden() && (this.variableOffsets[e1] = a[e1]);
        for(let e1 in o)!this.placedOrientations[e1] && this.opacities[e1] && !this.opacities[e1].isHidden() && (this.placedOrientations[e1] = o[e1]);
        if (t && t.lastPlacementChangeTime === void 0) throw Error(`Last placement time for previous placement is not defined`);
        n ? this.lastPlacementChangeTime = e1 : typeof this.lastPlacementChangeTime != `number` && (this.lastPlacementChangeTime = t ? t.lastPlacementChangeTime : e1);
    }
    updateLayerOpacities(e1, t) {
        let n = {};
        for (let r of t){
            let t = r.getBucket(e1);
            t && r.latestFeatureIndex && e1.id === t.layerIds[0] && this.updateBucketOpacities(t, r.tileID, n, r.collisionBoxArray);
        }
    }
    updateBucketOpacities(e1, t, n, r) {
        e1.hasTextData() && (e1.text.opacityVertexArray.clear(), e1.text.hasVisibleVertices = !1), e1.hasIconData() && (e1.icon.opacityVertexArray.clear(), e1.icon.hasVisibleVertices = !1), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
        let i = e1.layers[0], a = i.layout, o = new $4324d99ae8520741$var$xs(null, 0, !1, !1, !0), s = a.get(`text-allow-overlap`), c = a.get(`icon-allow-overlap`), l = i._unevaluatedLayout.hasValue(`text-variable-anchor`) || i._unevaluatedLayout.hasValue(`text-variable-anchor-offset`), u = a.get(`text-rotation-alignment`) === `map`, d = a.get(`text-pitch-alignment`) === `map`, f = a.get(`icon-text-fit`) !== `none`, p = new $4324d99ae8520741$var$xs(null, 0, s && (c || !e1.hasIconData() || a.get(`icon-optional`)), c && (s || !e1.hasTextData() || a.get(`text-optional`)), !0);
        !e1.collisionArrays && r && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(r);
        let m = (e1, t, n)=>{
            for(let r = 0; r < t / 4; r++)e1.opacityVertexArray.emplaceBack(n);
            e1.hasVisibleVertices ||= n !== $4324d99ae8520741$var$Ns;
        }, h = this.collisionBoxArrays.get(e1.bucketInstanceId);
        for(let t = 0; t < e1.symbolInstances.length; t++){
            let r = e1.symbolInstances.get(t), { numHorizontalGlyphVertices: i, numVerticalGlyphVertices: a, crossTileID: s } = r, c = n[s], g = this.opacities[s];
            c ? g = o : g || (g = p, this.opacities[s] = g), n[s] = !0;
            let _ = i > 0 || a > 0, v = r.numIconVertices > 0, y = this.placedOrientations[r.crossTileID], b = y === 2, x = y === 1 || y === 3;
            if (_) {
                let t = $4324d99ae8520741$var$Ms(g.text), n = b ? $4324d99ae8520741$var$Ns : t;
                m(e1.text, i, n);
                let o = x ? $4324d99ae8520741$var$Ns : t;
                m(e1.text, a, o);
                let s = g.text.isHidden(), c = [
                    r.rightJustifiedTextSymbolIndex,
                    r.centerJustifiedTextSymbolIndex,
                    r.leftJustifiedTextSymbolIndex
                ];
                for (let t of c)t >= 0 && (e1.text.placedSymbolArray.get(t).hidden = s || b ? 1 : 0);
                r.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(r.verticalPlacedTextSymbolIndex).hidden = s || x ? 1 : 0);
                let l = this.variableOffsets[r.crossTileID];
                l && this.markUsedJustification(e1, l.anchor, r, y);
                let u = this.placedOrientations[r.crossTileID];
                u && (this.markUsedJustification(e1, `left`, r, u), this.markUsedOrientation(e1, u, r));
            }
            if (v) {
                let t = $4324d99ae8520741$var$Ms(g.icon), n = !(f && r.verticalPlacedIconSymbolIndex && b);
                if (r.placedIconSymbolIndex >= 0) {
                    let i = n ? t : $4324d99ae8520741$var$Ns;
                    m(e1.icon, r.numIconVertices, i), e1.icon.placedSymbolArray.get(r.placedIconSymbolIndex).hidden = g.icon.isHidden();
                }
                if (r.verticalPlacedIconSymbolIndex >= 0) {
                    let i = n ? $4324d99ae8520741$var$Ns : t;
                    m(e1.icon, r.numVerticalIconVertices, i), e1.icon.placedSymbolArray.get(r.verticalPlacedIconSymbolIndex).hidden = g.icon.isHidden();
                }
            }
            let S = h?.has(t) ? h.get(t) : {
                text: null,
                icon: null
            };
            if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                let n = e1.collisionArrays[t];
                if (n) {
                    let t = new (0, $1G0Uw.Li)(0, 0);
                    if (n.textBox || n.verticalTextBox) {
                        let r = !0;
                        if (l) {
                            let e1 = this.variableOffsets[s];
                            e1 ? (t = $4324d99ae8520741$var$Ts(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textBoxScale), u && t._rotate(d ? -this.transform.bearingInRadians : this.transform.bearingInRadians)) : r = !1;
                        }
                        if (n.textBox || n.verticalTextBox) {
                            let i;
                            n.textBox && (i = b), n.verticalTextBox && (i = x), $4324d99ae8520741$var$Ds(e1.textCollisionBox.collisionVertexArray, g.text.placed, !r || i, S.text, t.x, t.y);
                        }
                    }
                    if (n.iconBox || n.verticalIconBox) {
                        let r = !(x || !n.verticalIconBox), i;
                        n.iconBox && (i = r), n.verticalIconBox && (i = !r), $4324d99ae8520741$var$Ds(e1.iconCollisionBox.collisionVertexArray, g.icon.placed, i, S.icon, f ? t.x : 0, f ? t.y : 0);
                    }
                }
            }
        }
        if (e1.sortFeatures(-this.transform.bearingInRadians), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.text.opacityVertexArray.length !== e1.text.layoutVertexArray.length / 4) throw Error(`bucket.text.opacityVertexArray.length (= ${e1.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${e1.text.layoutVertexArray.length}) / 4`);
        if (e1.icon.opacityVertexArray.length !== e1.icon.layoutVertexArray.length / 4) throw Error(`bucket.icon.opacityVertexArray.length (= ${e1.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${e1.icon.layoutVertexArray.length}) / 4`);
        e1.bucketInstanceId in this.collisionCircleArrays && (e1.collisionCircleArray = this.collisionCircleArrays[e1.bucketInstanceId], delete this.collisionCircleArrays[e1.bucketInstanceId]);
    }
    symbolFadeChange(e1) {
        return this.fadeDuration === 0 ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
    }
    zoomAdjustment(e1) {
        return Math.max(0, (this.transform.zoom - e1) / 1.5);
    }
    hasTransitions(e1) {
        return this.stale || e1 - this.lastPlacementChangeTime < this.fadeDuration;
    }
    stillRecent(e1, t) {
        let n = this.zoomAtLastRecencyCheck === t ? 1 - this.zoomAdjustment(t) : 1;
        return this.zoomAtLastRecencyCheck = t, this.commitTime + this.fadeDuration * n > e1;
    }
    setStale() {
        this.stale = !0;
    }
};
function $4324d99ae8520741$var$Ds(e1, t, n, r, i, a) {
    (!r || r.length === 0) && (r = [
        0,
        0,
        0,
        0
    ]);
    let o = r[0] - 100, s = r[1] - 100, c = r[2] - 100, l = r[3] - 100;
    e1.emplaceBack(+!!t, +!!n, i || 0, a || 0, o, s), e1.emplaceBack(+!!t, +!!n, i || 0, a || 0, c, s), e1.emplaceBack(+!!t, +!!n, i || 0, a || 0, c, l), e1.emplaceBack(+!!t, +!!n, i || 0, a || 0, o, l);
}
const $4324d99ae8520741$var$Os = 2 ** 25, $4324d99ae8520741$var$ks = 2 ** 24, $4324d99ae8520741$var$As = 2 ** 17, $4324d99ae8520741$var$js = 2 ** 16;
function $4324d99ae8520741$var$Ms(e1) {
    if (e1.opacity === 0 && !e1.placed) return 0;
    if (e1.opacity === 1 && e1.placed) return 4294967295;
    let t = +!!e1.placed, n = Math.floor(e1.opacity * 127);
    return n * $4324d99ae8520741$var$Os + t * $4324d99ae8520741$var$ks + n * $4324d99ae8520741$var$As + t * $4324d99ae8520741$var$js + n * 512 + t * 256 + n * 2 + t;
}
const $4324d99ae8520741$var$Ns = 0;
var $4324d99ae8520741$var$Ps = class {
    constructor(e1){
        this._sortAcrossTiles = e1.layout.get(`symbol-z-order`) !== `viewport-y` && !e1.layout.get(`symbol-sort-key`).isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
    }
    continuePlacement(e1, t, n, r, i) {
        let a = this._bucketParts;
        for(; this._currentTileIndex < e1.length;){
            let n = e1[this._currentTileIndex];
            if (t.getBucketParts(a, r, n, this._sortAcrossTiles), this._currentTileIndex++, i()) return !0;
        }
        for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, a.sort((e1, t)=>e1.sortKey - t.sortKey)); this._currentPartIndex < a.length;){
            let e1 = a[this._currentPartIndex];
            if (t.placeLayerBucketPart(e1, this._seenCrossTileIDs, n), this._currentPartIndex++, i()) return !0;
        }
        return !1;
    }
}, $4324d99ae8520741$var$Fs = class {
    constructor(e1, t, n, r, i, a, o, s){
        this.placement = new $4324d99ae8520741$var$Es(e1, t, a, o, s), this._currentPlacementIndex = n.length - 1, this._forceFullPlacement = r, this._showCollisionBoxes = i, this._done = !1;
    }
    isDone() {
        return this._done;
    }
    continuePlacement(e1, t, n) {
        let r = $4324d99ae8520741$export$461939dd4422153(), i = ()=>!this._forceFullPlacement && $4324d99ae8520741$export$461939dd4422153() - r > 2;
        for(; this._currentPlacementIndex >= 0;){
            let r = t[e1[this._currentPlacementIndex]], a = this.placement.collisionIndex.transform.zoom;
            if ((0, $1G0Uw.x)(r) && r.layout && (!r.minzoom || r.minzoom <= a) && (!r.maxzoom || r.maxzoom > a)) {
                if (this._inProgressLayer ||= new $4324d99ae8520741$var$Ps(r), this._inProgressLayer.continuePlacement(n[r.source], this.placement, this._showCollisionBoxes, r, i)) return;
                delete this._inProgressLayer;
            }
            this._currentPlacementIndex--;
        }
        this._done = !0;
    }
    commit(e1) {
        return this.placement.commit(e1), this.placement;
    }
};
const $4324d99ae8520741$var$Is = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
], $4324d99ae8520741$var$Ls = new Uint32Array(96);
var $4324d99ae8520741$var$Rs = class e1 {
    static from(t) {
        if (!t || t.byteLength === void 0 || t.buffer) throw Error(`Data must be an instance of ArrayBuffer or SharedArrayBuffer.`);
        let [n, r] = new Uint8Array(t, 0, 2);
        if (n !== 219) throw Error(`Data does not appear to be in a KDBush format.`);
        let i = r >> 4;
        if (i !== 1) throw Error(`Got v${i} data when expected v1.`);
        let a = $4324d99ae8520741$var$Is[r & 15];
        if (!a) throw Error(`Unrecognized array type.`);
        let [o] = new Uint16Array(t, 2, 1), [s] = new Uint32Array(t, 4, 1);
        return new e1(s, o, a, void 0, t);
    }
    constructor(e1, t = 64, n = Float64Array, r = ArrayBuffer, i){
        if (isNaN(e1) || e1 < 0) throw Error(`Unexpected numItems value: ${e1}.`);
        this.numItems = +e1, this.nodeSize = Math.min(Math.max(+t, 2), 65535), this.ArrayType = n, this.IndexArrayType = e1 < 65536 ? Uint16Array : Uint32Array;
        let a = $4324d99ae8520741$var$Is.indexOf(this.ArrayType), o = e1 * 2 * this.ArrayType.BYTES_PER_ELEMENT, s = e1 * this.IndexArrayType.BYTES_PER_ELEMENT, c = (8 - s % 8) % 8;
        if (a < 0) throw Error(`Unexpected typed array class: ${n}.`);
        if (i) this.data = i, this.ids = new this.IndexArrayType(i, 8, e1), this.coords = new n(i, 8 + s + c, e1 * 2), this._pos = e1 * 2, this._finished = !0;
        else {
            let i = this.data = new r(8 + o + s + c);
            this.ids = new this.IndexArrayType(i, 8, e1), this.coords = new n(i, 8 + s + c, e1 * 2), this._pos = 0, this._finished = !1, new Uint8Array(i, 0, 2).set([
                219,
                16 + a
            ]), new Uint16Array(i, 2, 1)[0] = t, new Uint32Array(i, 4, 1)[0] = e1;
        }
    }
    add(e1, t) {
        let n = this._pos >> 1;
        return this.ids[n] = n, this.coords[this._pos++] = e1, this.coords[this._pos++] = t, n;
    }
    finish() {
        let e1 = this._pos >> 1;
        if (e1 !== this.numItems) throw Error(`Added ${e1} items when expected ${this.numItems}.`);
        return $4324d99ae8520741$var$zs(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
    }
    range(e1, t, n, r) {
        if (!this._finished) throw Error(`Data not yet indexed - call index.finish().`);
        let { ids: i, coords: a, nodeSize: o } = this;
        $4324d99ae8520741$var$Ls[0] = 0, $4324d99ae8520741$var$Ls[1] = i.length - 1, $4324d99ae8520741$var$Ls[2] = 0;
        let s = 3, c = [];
        for(; s > 0;){
            let l = $4324d99ae8520741$var$Ls[--s], u = $4324d99ae8520741$var$Ls[--s], d = $4324d99ae8520741$var$Ls[--s];
            if (u - d <= o) {
                for(let o = d; o <= u; o++){
                    let s = a[2 * o], l = a[2 * o + 1];
                    s >= e1 && s <= n && l >= t && l <= r && c.push(i[o]);
                }
                continue;
            }
            let f = d + u >> 1, p = a[2 * f], m = a[2 * f + 1];
            p >= e1 && p <= n && m >= t && m <= r && c.push(i[f]), (l === 0 ? e1 <= p : t <= m) && ($4324d99ae8520741$var$Ls[s++] = d, $4324d99ae8520741$var$Ls[s++] = f - 1, $4324d99ae8520741$var$Ls[s++] = 1 - l), (l === 0 ? n >= p : r >= m) && ($4324d99ae8520741$var$Ls[s++] = f + 1, $4324d99ae8520741$var$Ls[s++] = u, $4324d99ae8520741$var$Ls[s++] = 1 - l);
        }
        return c;
    }
    within(e1, t, n) {
        let r = [];
        return this.withinInto(e1, t, n, r), r;
    }
    withinInto(e1, t, n, r) {
        if (!this._finished) throw Error(`Data not yet indexed - call index.finish().`);
        let { ids: i, coords: a, nodeSize: o } = this;
        $4324d99ae8520741$var$Ls[0] = 0, $4324d99ae8520741$var$Ls[1] = i.length - 1, $4324d99ae8520741$var$Ls[2] = 0;
        let s = 3, c = 0, l = n * n;
        for(; s > 0;){
            let u = $4324d99ae8520741$var$Ls[--s], d = $4324d99ae8520741$var$Ls[--s], f = $4324d99ae8520741$var$Ls[--s];
            if (d - f <= o) {
                for(let n = f; n <= d; n++)$4324d99ae8520741$var$Us(a[2 * n], a[2 * n + 1], e1, t) <= l && (r[c++] = i[n]);
                continue;
            }
            let p = f + d >> 1, m = a[2 * p], h = a[2 * p + 1];
            $4324d99ae8520741$var$Us(m, h, e1, t) <= l && (r[c++] = i[p]), (u === 0 ? e1 - n <= m : t - n <= h) && ($4324d99ae8520741$var$Ls[s++] = f, $4324d99ae8520741$var$Ls[s++] = p - 1, $4324d99ae8520741$var$Ls[s++] = 1 - u), (u === 0 ? e1 + n >= m : t + n >= h) && ($4324d99ae8520741$var$Ls[s++] = p + 1, $4324d99ae8520741$var$Ls[s++] = d, $4324d99ae8520741$var$Ls[s++] = 1 - u);
        }
        return c;
    }
};
function $4324d99ae8520741$var$zs(e1, t, n, r, i, a) {
    if (i - r <= n) return;
    let o = r + i >> 1;
    $4324d99ae8520741$var$Bs(e1, t, o, r, i, a), $4324d99ae8520741$var$zs(e1, t, n, r, o - 1, 1 - a), $4324d99ae8520741$var$zs(e1, t, n, o + 1, i, 1 - a);
}
function $4324d99ae8520741$var$Bs(e1, t, n, r, i, a) {
    for(; i > r;){
        if (i - r > 600) {
            let o = i - r + 1, s = n - r + 1, c = Math.log(o), l = .5 * Math.exp(2 * c / 3), u = .5 * Math.sqrt(c * l * (o - l) / o) * (s - o / 2 < 0 ? -1 : 1);
            $4324d99ae8520741$var$Bs(e1, t, n, Math.max(r, Math.floor(n - s * l / o + u)), Math.min(i, Math.floor(n + (o - s) * l / o + u)), a);
        }
        let o = t[2 * n + a], s = r, c = i;
        for($4324d99ae8520741$var$Vs(e1, t, r, n), t[2 * i + a] > o && $4324d99ae8520741$var$Vs(e1, t, r, i); s < c;){
            for($4324d99ae8520741$var$Vs(e1, t, s, c), s++, c--; t[2 * s + a] < o;)s++;
            for(; t[2 * c + a] > o;)c--;
        }
        t[2 * r + a] === o ? $4324d99ae8520741$var$Vs(e1, t, r, c) : (c++, $4324d99ae8520741$var$Vs(e1, t, c, i)), c <= n && (r = c + 1), n <= c && (i = c - 1);
    }
}
function $4324d99ae8520741$var$Vs(e1, t, n, r) {
    $4324d99ae8520741$var$Hs(e1, n, r), $4324d99ae8520741$var$Hs(t, 2 * n, 2 * r), $4324d99ae8520741$var$Hs(t, 2 * n + 1, 2 * r + 1);
}
function $4324d99ae8520741$var$Hs(e1, t, n) {
    let r = e1[t];
    e1[t] = e1[n], e1[n] = r;
}
function $4324d99ae8520741$var$Us(e1, t, n, r) {
    let i = e1 - n, a = t - r;
    return i * i + a * a;
}
const $4324d99ae8520741$var$Ws = 512 / (0, $1G0Uw.Lr) / 2;
var $4324d99ae8520741$var$Gs = class {
    constructor(e1, t, n){
        this.tileID = e1, this.bucketInstanceId = n, this._symbolsByKey = {};
        let r = new Map;
        for(let e1 = 0; e1 < t.length; e1++){
            let n = t.get(e1), i = n.key, a = r.get(i);
            a ? a.push(n) : r.set(i, [
                n
            ]);
        }
        for (let [e1, t] of r){
            let n = {
                positions: t.map((e1)=>({
                        x: Math.floor(e1.anchorX * $4324d99ae8520741$var$Ws),
                        y: Math.floor(e1.anchorY * $4324d99ae8520741$var$Ws)
                    })),
                crossTileIDs: t.map((e1)=>e1.crossTileID)
            };
            if (n.positions.length > 128) {
                let e1 = new $4324d99ae8520741$var$Rs(n.positions.length, 16, Uint16Array);
                for (let { x: t, y: r } of n.positions)e1.add(t, r);
                e1.finish(), delete n.positions, n.index = e1;
            }
            this._symbolsByKey[e1] = n;
        }
    }
    getScaledCoordinates(e1, t) {
        let { x: n, y: r, z: i } = this.tileID.canonical, { x: a, y: o, z: s } = t.canonical, c = s - i, l = $4324d99ae8520741$var$Ws / 2 ** c, u = (a * (0, $1G0Uw.Lr) + e1.anchorX) * l, d = (o * (0, $1G0Uw.Lr) + e1.anchorY) * l, f = n * (0, $1G0Uw.Lr) * $4324d99ae8520741$var$Ws, p = r * (0, $1G0Uw.Lr) * $4324d99ae8520741$var$Ws;
        return {
            x: Math.floor(u - f),
            y: Math.floor(d - p)
        };
    }
    findMatches(e1, t, n) {
        let r = this.tileID.canonical.z < t.canonical.z ? 1 : 2 ** (this.tileID.canonical.z - t.canonical.z);
        for(let i = 0; i < e1.length; i++){
            let a = e1.get(i);
            if (a.crossTileID) continue;
            let o = this._symbolsByKey[a.key];
            if (!o) continue;
            let s = this.getScaledCoordinates(a, t);
            o.index ? this.findMatchesForIndexedEntry(o, a, s, r, n) : o.positions && this.findMatchesForNonIndexedEntry(o, a, s, r, n);
        }
    }
    findMatchesForIndexedEntry(e1, t, n, r, i) {
        let a = e1.index.range(n.x - r, n.y - r, n.x + r, n.y + r), o = 1 / 0;
        for (let t of a)t < o && !i[e1.crossTileIDs[t]] && (o = t);
        if (o !== 1 / 0) {
            let n = e1.crossTileIDs[o];
            i[n] = !0, t.crossTileID = n;
        }
    }
    findMatchesForNonIndexedEntry(e1, t, n, r, i) {
        for(let a = 0; a < e1.positions.length; a++){
            let o = e1.positions[a], s = e1.crossTileIDs[a];
            if (Math.abs(o.x - n.x) <= r && Math.abs(o.y - n.y) <= r && !i[s]) {
                i[s] = !0, t.crossTileID = s;
                break;
            }
        }
    }
    getCrossTileIDsLists() {
        return Object.values(this._symbolsByKey).map(({ crossTileIDs: e1 })=>e1);
    }
}, $4324d99ae8520741$var$Ks = class {
    constructor(){
        this.maxCrossTileID = 0;
    }
    generate() {
        return ++this.maxCrossTileID;
    }
}, $4324d99ae8520741$var$qs = class {
    constructor(){
        this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
    }
    handleWrapJump(e1) {
        let t = Math.round((e1 - this.lng) / 360);
        if (t !== 0) for(let e1 in this.indexes){
            let n = this.indexes[e1], r = {};
            for(let e1 in n){
                let i = n[e1];
                i.tileID = i.tileID.unwrapTo(i.tileID.wrap + t), r[i.tileID.key] = i;
            }
            this.indexes[e1] = r;
        }
        this.lng = e1;
    }
    addBucket(e1, t, n) {
        if (this.indexes[e1.overscaledZ]?.[e1.key]) {
            if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t.bucketInstanceId) return !1;
            this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
        }
        for(let e1 = 0; e1 < t.symbolInstances.length; e1++){
            let n = t.symbolInstances.get(e1);
            n.crossTileID = 0;
        }
        this.usedCrossTileIDs[e1.overscaledZ] ||= {};
        let r = this.usedCrossTileIDs[e1.overscaledZ];
        for(let n in this.indexes){
            let i = this.indexes[n];
            if (Number(n) > e1.overscaledZ) for(let n in i){
                let a = i[n];
                a.tileID.isChildOf(e1) && a.findMatches(t.symbolInstances, e1, r);
            }
            else {
                let a = i[e1.scaledTo(Number(n)).key];
                a && a.findMatches(t.symbolInstances, e1, r);
            }
        }
        for(let e1 = 0; e1 < t.symbolInstances.length; e1++){
            let i = t.symbolInstances.get(e1);
            i.crossTileID || (i.crossTileID = n.generate(), r[i.crossTileID] = !0);
        }
        return this.indexes[e1.overscaledZ] === void 0 && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new $4324d99ae8520741$var$Gs(e1, t.symbolInstances, t.bucketInstanceId), !0;
    }
    removeBucketCrossTileIDs(e1, t) {
        for (let n of t.getCrossTileIDsLists())for (let t of n)delete this.usedCrossTileIDs[e1][t];
    }
    removeStaleBuckets(e1) {
        let t = !1;
        for(let n in this.indexes){
            let r = this.indexes[n];
            for(let i in r)e1[r[i].bucketInstanceId] || (this.removeBucketCrossTileIDs(n, r[i]), delete r[i], t = !0);
        }
        return t;
    }
}, $4324d99ae8520741$var$Js = class {
    constructor(){
        this.layerIndexes = {}, this.crossTileIDs = new $4324d99ae8520741$var$Ks, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
    }
    addLayer(e1, t, n) {
        let r = this.layerIndexes[e1.id];
        r === void 0 && (r = this.layerIndexes[e1.id] = new $4324d99ae8520741$var$qs);
        let i = !1, a = {};
        r.handleWrapJump(n);
        for (let n of t){
            let t = n.getBucket(e1);
            e1.id === t?.layerIds[0] && (t.bucketInstanceId ||= (this.maxBucketInstanceId += 1, this.maxBucketInstanceId), r.addBucket(n.tileID, t, this.crossTileIDs) && (i = !0), a[t.bucketInstanceId] = !0);
        }
        return r.removeStaleBuckets(a) && (i = !0), i;
    }
    pruneUnusedLayers(e1) {
        let t = {};
        for (let n of e1)t[n] = !0;
        for(let e1 in this.layerIndexes)t[e1] || delete this.layerIndexes[e1];
    }
}, $4324d99ae8520741$var$Ys = `#ifdef GL_ES
precision mediump float;
#else
#if !defined(lowp)
#define lowp
#endif
#if !defined(mediump)
#define mediump
#endif
#if !defined(highp)
#define highp
#endif
#endif
out highp vec4 fragColor;layout(std140) uniform ProjectionUBO {highp mat4 u_projection_matrix;highp mat4 u_projection_fallback_matrix;highp vec4 u_projection_tile_mercator_coords;highp vec4 u_projection_clipping_plane;highp float u_projection_transition;highp int u_projection_clip_antimeridian;};layout(std140) uniform FrameUBO {highp vec2 u_units_to_pixels;highp vec2 u_world_size;highp float u_camera_to_center_distance;highp float u_symbol_fade_change;highp float u_aspect_ratio;highp float u_device_pixel_ratio;highp vec2 u_viewport_size;highp vec2 u_pixel_extrude_scale;highp float u_pitch;};`, $4324d99ae8520741$var$Xs = `#ifdef GL_ES
precision highp float;
#else
#if !defined(lowp)
#define lowp
#endif
#if !defined(mediump)
#define mediump
#endif
#if !defined(highp)
#define highp
#endif
#endif
vec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const uint packedOpacity) {return vec2(float(packedOpacity >> 1u)/127.0,float(packedOpacity & 1u));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0
);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}mat3 rotationMatrixFromAxisAngle(vec3 u,float angle) {float c=cos(angle);float s=sin(angle);float c2=1.0-c;return mat3(u.x*u.x*c2+      c,u.x*u.y*c2-u.z*s,u.x*u.z*c2+u.y*s,u.y*u.x*c2+u.z*s,u.y*u.y*c2+    c,u.y*u.z*c2-u.x*s,u.z*u.x*c2-u.y*s,u.z*u.y*c2+u.x*s,u.z*u.z*c2+    c
);}
#ifdef TERRAIN3D
uniform sampler2D u_terrain;uniform highp sampler2D u_depth;layout(std140) uniform TerrainUBO {highp mat4 u_terrain_matrix;highp vec4 u_terrain_unpack;highp float u_terrain_dim;highp float u_terrain_exaggeration;};
#endif
const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {
#ifdef TERRAIN3D
highp float d=unpack(texture(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));
#else
return 1.0;
#endif
}float calculate_visibility(vec4 pos) {
#ifdef TERRAIN3D
vec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;
#else
return 1.0;
#endif
}float ele(ivec2 pos) {
#ifdef TERRAIN3D
vec4 rgb=(texelFetch(u_terrain,pos,0)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;
#else
return 0.0;
#endif
}float get_elevation(vec2 pos) {
#ifdef TERRAIN3D
#ifdef GLOBE
if ((pos.y <-32767.5) || (pos.y > 32766.5)) {return 0.0;}
#endif
vec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.5;vec2 f=fract(coord);ivec2 c=ivec2(floor(coord));ivec2 hi=textureSize(u_terrain,0)-1;float tl=ele(clamp(c,ivec2(0),hi));float tr=ele(clamp(c+ivec2(1,0),ivec2(0),hi));float bl=ele(clamp(c+ivec2(0,1),ivec2(0),hi));float br=ele(clamp(c+ivec2(1,1),ivec2(0),hi));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;
#else
return 0.0;
#endif
}const float PI=3.141592653589793;
#define PROJECTION_UBO
layout(std140) uniform ProjectionUBO {highp mat4 u_projection_matrix;highp mat4 u_projection_fallback_matrix;highp vec4 u_projection_tile_mercator_coords;highp vec4 u_projection_clipping_plane;highp float u_projection_transition;highp int u_projection_clip_antimeridian;};layout(std140) uniform FrameUBO {highp vec2 u_units_to_pixels;highp vec2 u_world_size;highp float u_camera_to_center_distance;highp float u_symbol_fade_change;highp float u_aspect_ratio;highp float u_device_pixel_ratio;highp vec2 u_viewport_size;highp vec2 u_pixel_extrude_scale;highp float u_pitch;};`, $4324d99ae8520741$var$Zs = `uniform vec4 u_color;uniform float u_opacity;void main() {fragColor=u_color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, $4324d99ae8520741$var$Qs = `layout(location=0) in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}`, $4324d99ae8520741$var$$s = `uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_mix)*u_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, $4324d99ae8520741$var$ec = `uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;layout(location=0) in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;void main() {gl_Position=projectTile(a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}`, $4324d99ae8520741$var$tc = `in vec3 v_data;flat in float v_visibility;
#pragma maplibre: define highp vec4 color
#pragma maplibre: define mediump float radius
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 stroke_color
#pragma maplibre: define mediump float stroke_width
#pragma maplibre: define lowp float stroke_opacity
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump float radius
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 stroke_color
#pragma maplibre: initialize mediump float stroke_width
#pragma maplibre: initialize lowp float stroke_opacity
vec2 extrude=v_data.xy;float extrude_length=length(extrude);float antialiased_blur=v_data.z;float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));fragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);const float epsilon=0.5/255.0;if (fragColor.r < epsilon && fragColor.g < epsilon && fragColor.b < epsilon && fragColor.a < epsilon) {discard;}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, $4324d99ae8520741$var$nc = `uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_globe_extrude_scale;uniform vec2 u_translate;layout(location=0) in ivec2 a_pos;out vec3 v_data;flat out float v_visibility;
#pragma maplibre: define highp vec4 color
#pragma maplibre: define mediump float radius
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 stroke_color
#pragma maplibre: define mediump float stroke_width
#pragma maplibre: define lowp float stroke_opacity
void main(void) {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump float radius
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 stroke_color
#pragma maplibre: initialize mediump float stroke_width
#pragma maplibre: initialize lowp float stroke_opacity
ivec2 pos_raw=a_pos+32768;vec2 extrude=vec2(pos_raw & 7)/7.0*2.0-1.0;vec2 circle_center=vec2(pos_raw >> 3)+u_translate;float ele=get_elevation(circle_center);v_visibility=calculate_visibility(projectTileWithElevation(circle_center,ele));if (u_pitch_with_map) {
#ifdef GLOBE
vec3 center_vector=projectToSphere(circle_center);
#endif
float angle_scale=u_globe_extrude_scale;vec2 corner_position=circle_center;if (u_scale_with_map) {angle_scale*=(radius+stroke_width);corner_position+=extrude*u_extrude_scale*(radius+stroke_width);} else {
#ifdef GLOBE
vec4 projected_center=interpolateProjection(circle_center,center_vector,ele);
#else
vec4 projected_center=projectTileWithElevation(circle_center,ele);
#endif
corner_position+=extrude*u_extrude_scale*(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);angle_scale*=(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);}
#ifdef GLOBE
vec2 angles=extrude*angle_scale;vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(corner_position,corner_vector,ele);
#else
gl_Position=projectTileWithElevation(corner_position,ele);
#endif
} else {gl_Position=projectTileWithElevation(circle_center,ele);if (gl_Position.z/gl_Position.w > 1.0) {gl_Position.xy=vec2(10000.0);}if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}float antialiasblur=-max(1.0/u_device_pixel_ratio/(radius+stroke_width),blur);v_data=vec3(extrude.x,extrude.y,antialiasblur);}`, $4324d99ae8520741$var$rc = `void main() {fragColor=vec4(1.0);}`;
const $4324d99ae8520741$var$ic = {
    prelude: $4324d99ae8520741$var$Y($4324d99ae8520741$var$Ys, $4324d99ae8520741$var$Xs),
    projectionMercator: $4324d99ae8520741$var$Y(`
void clipAntimeridian() {}`, `float projectLineThickness(float tileY) {return 1.0;}float projectCircleRadius(float tileY) {return 1.0;}vec4 projectTile(vec2 p) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);return result;}vec4 projectTile(vec2 p,vec2 rawPos) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);if (rawPos.y <-32767.5 || rawPos.y > 32766.5) {result.z=-10000000.0;}return result;}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_projection_matrix*vec4(posInTile,elevation,1.0);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {return projectTileWithElevation(posInTile,elevation);}`),
    projectionGlobe: $4324d99ae8520741$var$Y(`in highp float v_projection_tile_x;void clipAntimeridian() {if (u_projection_clip_antimeridian !=0 && (v_projection_tile_x < 0.0 || v_projection_tile_x >=8192.0)) {discard;}}`, `#define GLOBE_RADIUS 6371008.8
#ifndef PROJECTION_UBO
uniform highp vec4 u_projection_tile_mercator_coords;uniform highp vec4 u_projection_clipping_plane;uniform highp float u_projection_transition;uniform mat4 u_projection_fallback_matrix;
#endif
out highp float v_projection_tile_x;vec3 globeRotateVector(vec3 vec,vec2 angles) {vec3 axisRight=vec3(vec.z,0.0,-vec.x);vec3 axisUp=cross(axisRight,vec);axisRight=normalize(axisRight);axisUp=normalize(axisUp);vec2 t=tan(angles);return normalize(vec+axisRight*t.x+axisUp*t.y);}mat3 globeGetRotationMatrix(vec3 spherePos) {vec3 axisRight=vec3(spherePos.z,0.0,-spherePos.x);vec3 axisDown=cross(axisRight,spherePos);axisRight=normalize(axisRight);axisDown=normalize(axisDown);return mat3(axisRight,axisDown,spherePos
);}float circumferenceRatioAtTileY(float tileY) {float mercator_pos_y=u_projection_tile_mercator_coords.y+u_projection_tile_mercator_coords.w*tileY;float t=exp(PI-(mercator_pos_y*PI*2.0));return (2.0*t)/(t*t+1.0);}float projectLineThickness(float tileY) {float thickness=1.0/circumferenceRatioAtTileY(tileY);if (u_projection_transition < 0.999) {return mix(1.0,thickness,u_projection_transition);} else {return thickness;}}vec3 projectToSphere(vec2 translatedPos,vec2 rawPos) {vec2 mercator_pos=u_projection_tile_mercator_coords.xy+u_projection_tile_mercator_coords.zw*translatedPos;float spherical_x=mercator_pos.x*PI*2.0+PI;float t=exp(PI-(mercator_pos.y*PI*2.0));float t2=t*t;float denom=t2+1.0;float sin_sy=(t2-1.0)/denom;float cos_sy=(2.0*t)/denom;vec3 pos=vec3(sin(spherical_x)*cos_sy,sin_sy,cos(spherical_x)*cos_sy
);if (rawPos.y <-32767.5) {pos=vec3(0.0,1.0,0.0);}if (rawPos.y > 32766.5) {pos=vec3(0.0,-1.0,0.0);}return pos;}vec3 projectToSphere(vec2 posInTile) {return projectToSphere(posInTile,vec2(0.0,0.0));}float globeComputeClippingZ(vec3 spherePos) {return (1.0-(dot(spherePos,u_projection_clipping_plane.xyz)+u_projection_clipping_plane.w));}vec4 interpolateProjection(vec2 posInTile,vec3 spherePos,float elevation) {v_projection_tile_x=posInTile.x;vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);globePosition.z=globeComputeClippingZ(elevatedPos)*globePosition.w;if (u_projection_transition > 0.999) {return globePosition;}vec4 flatPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);const float z_globeness_threshold=0.2;vec4 result=globePosition;result.z=mix(0.0,globePosition.z,clamp((u_projection_transition-z_globeness_threshold)/(1.0-z_globeness_threshold),0.0,1.0));result.xyw=mix(flatPosition.xyw,globePosition.xyw,u_projection_transition);if ((posInTile.y <-32767.5) || (posInTile.y > 32766.5)) {result=globePosition;const float poles_hidden_anim_percentage=0.02;result.z=mix(globePosition.z,100.0,pow(max((1.0-u_projection_transition)/poles_hidden_anim_percentage,0.0),8.0));}return result;}vec4 interpolateProjectionFor3D(vec2 posInTile,vec3 spherePos,float elevation) {v_projection_tile_x=posInTile.x;vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);if (u_projection_transition > 0.999) {return globePosition;}vec4 fallbackPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);return mix(fallbackPosition,globePosition,u_projection_transition);}vec4 projectTile(vec2 posInTile) {return interpolateProjection(posInTile,projectToSphere(posInTile),0.0);}vec4 projectTile(vec2 posInTile,vec2 rawPos) {return interpolateProjection(posInTile,projectToSphere(posInTile,rawPos),0.0);}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return interpolateProjection(posInTile,projectToSphere(posInTile),elevation);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {vec3 spherePos=projectToSphere(posInTile,posInTile);return interpolateProjectionFor3D(posInTile,spherePos,elevation);}`),
    background: $4324d99ae8520741$var$Y($4324d99ae8520741$var$Zs, $4324d99ae8520741$var$Qs),
    backgroundPattern: $4324d99ae8520741$var$Y($4324d99ae8520741$var$$s, $4324d99ae8520741$var$ec),
    circle: $4324d99ae8520741$var$Y($4324d99ae8520741$var$tc, $4324d99ae8520741$var$nc),
    clippingMask: $4324d99ae8520741$var$Y($4324d99ae8520741$var$rc, `layout(location=0) in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}`),
    heatmap: $4324d99ae8520741$var$Y(`uniform highp float u_intensity;in vec2 v_extrude;
#pragma maplibre: define highp float weight
#define GAUSS_COEF 0.3989422804014327
void main() {
#pragma maplibre: initialize highp float weight
float d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);fragColor=vec4(val,1.0,1.0,1.0);
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;uniform highp float u_globe_extrude_scale;layout(location=0) in ivec2 a_pos;out vec2 v_extrude;
#pragma maplibre: define highp float weight
#pragma maplibre: define mediump float radius
const highp float ZERO=1.0/255.0/16.0;
#define GAUSS_COEF 0.3989422804014327
void main(void) {
#pragma maplibre: initialize highp float weight
#pragma maplibre: initialize mediump float radius
ivec2 pos_raw=a_pos+32768;vec2 unscaled_extrude=vec2(pos_raw & 7)/7.0*2.0-1.0;float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 circle_center=vec2(pos_raw >> 3);
#ifdef GLOBE
vec2 angles=v_extrude*radius*u_globe_extrude_scale;vec3 center_vector=projectToSphere(circle_center);vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(circle_center+extrude,corner_vector,0.0);
#else
gl_Position=projectTileFor3D(circle_center+extrude,get_elevation(circle_center));
#endif
}`),
    heatmapTexture: $4324d99ae8520741$var$Y(`uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));fragColor=color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(0.0);
#endif
}`, `uniform mat4 u_matrix;layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world_size,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}`),
    collisionBox: $4324d99ae8520741$var$Y(`flat in float v_placed;flat in float v_notUsed;void main() {float alpha=0.5;fragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {fragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {fragColor*=.1;}}`, `layout(location=0) in vec2 a_anchor_pos;layout(location=1) in vec2 a_placed;layout(location=2) in vec2 a_box_real;flat out float v_placed;flat out float v_notUsed;void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}`),
    collisionCircle: $4324d99ae8520741$var$Y(`flat in float v_radius;in vec2 v_extrude;flat in float v_collision;void main() {float alpha=0.5;float stroke_radius=0.9;float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);fragColor=color*alpha*opacity_t;}`, `layout(location=0) in vec2 a_pos;layout(location=1) in float a_radius;layout(location=2) in vec2 a_flags;flat out float v_radius;out vec2 v_extrude;flat out float v_collision;void main() {float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_collision=collision;gl_Position=vec4((a_pos/u_viewport_size*2.0-1.0)*vec2(1.0,-1.0),0.0,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}`),
    colorRelief: $4324d99ae8520741$var$Y(`#ifdef GL_ES
precision highp float;
#endif
uniform sampler2D u_image;uniform vec4 u_unpack;uniform sampler2D u_elevation_stops;uniform sampler2D u_color_stops;uniform int u_color_ramp_size;uniform float u_opacity;in vec2 v_pos;float getElevation(vec2 coord) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}float getElevationStop(int stop) {vec4 data=texelFetch(u_elevation_stops,ivec2(stop,0),0)*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {float el=getElevation(v_pos);int r=(u_color_ramp_size-1);int l=0;float el_l=getElevationStop(l);float el_r=getElevationStop(r);while(r-l > 1){int m=(r+l)/2;float el_m=getElevationStop(m);if(el < el_m){r=m;el_r=el_m;}else
{l=m;el_l=el_m;}}float x=(float(l)+(el-el_l)/(el_r-el_l)+0.5)/float(u_color_ramp_size);fragColor=u_opacity*texture(u_color_stops,vec2(x,0));
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_dimension;layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);highp vec2 epsilon=2.0/u_dimension;float scale=(u_dimension.x-4.0)/u_dimension.x;v_pos=(a_pos/8192.0)*scale+epsilon;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}`),
    debug: $4324d99ae8520741$var$Y(`uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);fragColor=mix(u_color,overlay_color,overlay_color.a);}`, `layout(location=0) in vec2 a_pos;out vec2 v_uv;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=projectTileWithElevation(a_pos*u_overlay_scale,get_elevation(a_pos));}`),
    depth: $4324d99ae8520741$var$Y($4324d99ae8520741$var$rc, `layout(location=0) in vec2 a_pos;void main() {
#ifdef GLOBE
gl_Position=projectTileFor3D(a_pos,0.0);
#else
gl_Position=u_projection_matrix*vec4(a_pos,0.0,1.0);
#endif
}`),
    fill: $4324d99ae8520741$var$Y(`#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float opacity
fragColor=color*opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float opacity
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}gl_Position=projectTile(a_pos+u_fill_translate,a_pos);}`),
    fillOutline: $4324d99ae8520741$var$Y(`in vec2 v_pos;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define highp vec4 outline_color
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 outline_color
#pragma maplibre: initialize lowp float opacity
float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=outline_color*(alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;out vec2 v_pos;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define highp vec4 outline_color
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 outline_color
#pragma maplibre: initialize lowp float opacity
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world_size;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
}`),
    fillOutlinePattern: $4324d99ae8520741$var$Y(`uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;uniform bool u_sdf_pattern;in vec2 v_pos_a;in vec2 v_pos_b;in vec2 v_pos;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
void main() {
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);if (u_sdf_pattern) {highp float sdf_edge=(256.0-64.0)/256.0;highp float sdf_gamma_a=max(fwidth(color1.a)*0.5,1.0/255.0/16.0);highp float sdf_gamma_b=max(fwidth(color2.a)*0.5,1.0/255.0/16.0);float sdf_alpha_a=smoothstep(sdf_edge-sdf_gamma_a,sdf_edge+sdf_gamma_a,color1.a);float sdf_alpha_b=smoothstep(sdf_edge-sdf_gamma_b,sdf_edge+sdf_gamma_b,color2.a);fragColor=mix(color*sdf_alpha_a,color*sdf_alpha_b,u_fade)*alpha*opacity;} else {fragColor=mix(color1,color2,u_fade)*alpha*opacity;}
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;out vec2 v_pos;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world_size;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
}`),
    fillPattern: $4324d99ae8520741$var$Y(`#ifdef GL_ES
precision highp float;
#endif
uniform vec2 u_texsize;uniform float u_fade;uniform bool u_sdf_pattern;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
void main() {
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);if (u_sdf_pattern) {highp float sdf_edge=(256.0-64.0)/256.0;highp float sdf_gamma_a=max(fwidth(color1.a)*0.5,1.0/255.0/16.0);highp float sdf_gamma_b=max(fwidth(color2.a)*0.5,1.0/255.0/16.0);float sdf_alpha_a=smoothstep(sdf_edge-sdf_gamma_a,sdf_edge+sdf_gamma_a,color1.a);float sdf_alpha_b=smoothstep(sdf_edge-sdf_gamma_b,sdf_edge+sdf_gamma_b,color2.a);fragColor=mix(color*sdf_alpha_a,color*sdf_alpha_b,u_fade)*opacity;} else {fragColor=mix(color1,color2,u_fade)*opacity;}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;
#pragma maplibre: define lowp float opacity
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}`),
    fillExtrusion: $4324d99ae8520741$var$Y(`in vec4 v_color;void main() {fragColor=v_color;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;layout(location=1) in ivec4 a_normal_ed;
#ifdef TERRAIN3D
layout(location=2) in vec2 a_centroid;
#endif
out vec4 v_color;
#pragma maplibre: define highp float base
#pragma maplibre: define highp float height
#pragma maplibre: define highp vec4 color
void main() {
#pragma maplibre: initialize highp float base
#pragma maplibre: initialize highp float height
#pragma maplibre: initialize highp vec4 color
vec3 normal=vec3(a_normal_ed.xyz);float gradient_base=max(0.0,base);float gradient_height=max(0.0,height);
#ifdef TERRAIN3D
float height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);
#else
float height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;
#endif
base=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=float(a_normal_ed.x & 1);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;
#ifdef GLOBE
vec3 spherePos=projectToSphere(posInTile,a_pos);gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);
#else
gl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);
#endif
float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;vec3 normalForLighting=normal/16384.0;float directional=clamp(dot(normalForLighting,u_lightpos),0.0,1.0);
#ifdef GLOBE
mat3 rotMatrix=globeGetRotationMatrix(spherePos);normalForLighting=rotMatrix*normalForLighting;directional=mix(directional,clamp(dot(normalForLighting,u_lightpos_globe),0.0,1.0),u_projection_transition);
#endif
directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+gradient_base)*pow(gradient_height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}`),
    fillExtrusionPattern: $4324d99ae8520741$var$Y(`uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;in vec4 v_lighting;
#pragma maplibre: define lowp float base
#pragma maplibre: define lowp float height
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float base
#pragma maplibre: initialize lowp float height
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);fragColor=mixedColor*v_lighting;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;layout(location=0) in vec2 a_pos;layout(location=1) in ivec4 a_normal_ed;
#ifdef TERRAIN3D
layout(location=2) in vec2 a_centroid;
#endif
#ifdef GLOBE
out vec3 v_sphere_pos;
#endif
out vec2 v_pos_a;out vec2 v_pos_b;out vec4 v_lighting;
#pragma maplibre: define lowp float base
#pragma maplibre: define lowp float height
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float base
#pragma maplibre: initialize lowp float height
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=vec3(a_normal_ed.xyz);float edgedistance=float(a_normal_ed.w);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;float gradient_base=max(0.0,base);float gradient_height=max(0.0,height);
#ifdef TERRAIN3D
float height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);
#else
float height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;
#endif
base=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=float(a_normal_ed.x & 1);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;
#ifdef GLOBE
vec3 spherePos=projectToSphere(posInTile,a_pos);vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);v_sphere_pos=elevatedPos;gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);
#else
gl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);
#endif
vec2 pos=a_normal_ed.x==1 && a_normal_ed.y==0 && a_normal_ed.z==16384
? a_pos
: vec2(edgedistance,elevation*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+gradient_base)*pow(gradient_height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}`),
    hillshadePrepare: $4324d99ae8520741$var$Y(`#ifdef GL_ES
precision highp float;
#endif
uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(ivec2 texel) {vec4 data=texelFetch(u_image,texel,0)*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {ivec2 pos=ivec2(gl_FragCoord.xy)+ivec2(1);float tileSize=u_dimension.x-4.0;float a=getElevation(pos+ivec2(-1,-1));float b=getElevation(pos+ivec2(0,-1));float c=getElevation(pos+ivec2(1,-1));float d=getElevation(pos+ivec2(-1,0));float e=getElevation(pos);float f=getElevation(pos+ivec2(1,0));float g=getElevation(pos+ivec2(-1,1));float h=getElevation(pos+ivec2(0,1));float i=getElevation(pos+ivec2(1,1));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))*tileSize/pow(2.0,exaggeration+(28.2562-u_zoom));fragColor=clamp(vec4(deriv.x/8.0+0.5,deriv.y/8.0+0.5,1.0,1.0),0.0,1.0);
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform vec2 u_dimension;layout(location=0) in vec2 a_pos;layout(location=1) in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}`),
    hillshade: $4324d99ae8520741$var$Y(`uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform float u_exaggeration;uniform vec4 u_accent;uniform int u_method;uniform float u_altitudes[NUM_ILLUMINATION_SOURCES];uniform float u_azimuths[NUM_ILLUMINATION_SOURCES];uniform vec4 u_shadows[NUM_ILLUMINATION_SOURCES];uniform vec4 u_highlights[NUM_ILLUMINATION_SOURCES];
#define PI 3.141592653589793
#define STANDARD 0
#define COMBINED 1
#define IGOR 2
#define MULTIDIRECTIONAL 3
#define BASIC 4
float get_aspect(vec2 deriv){return deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);}void igor_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float aspect=get_aspect(deriv);float azimuth=u_azimuths[0]+PI;float slope_stength=atan(length(deriv))*2.0/PI;float aspect_strength=1.0-abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);float shadow_strength=slope_stength*aspect_strength;float highlight_strength=slope_stength*(1.0-aspect_strength);fragColor=u_shadows[0]*shadow_strength+u_highlights[0]*highlight_strength;}void standard_hillshade(vec2 deriv){float azimuth=u_azimuths[0]+PI;float slope=atan(0.625*length(deriv));float aspect=get_aspect(deriv);float intensity=u_exaggeration;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadows[0],u_highlights[0],shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);fragColor=accent_color*(1.0-shade_color.a)+shade_color;}void basic_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor=u_highlights[0]*(2.0*shade-1.0);}else
{fragColor=u_shadows[0]*(1.0-2.0*shade);}}void multidirectional_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;fragColor=vec4(0,0,0,0);for(int i=0; i < NUM_ILLUMINATION_SOURCES; i++){float cos_alt=cos(u_altitudes[i]);float sin_alt=sin(u_altitudes[i]);float cos_az=-cos(u_azimuths[i]);float sin_az=-sin(u_azimuths[i]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor+=u_highlights[i]*(2.0*shade-1.0)/float(NUM_ILLUMINATION_SOURCES);}else
{fragColor+=u_shadows[i]*(1.0-2.0*shade)/float(NUM_ILLUMINATION_SOURCES);}}}void combined_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=acos((sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv)));cang=clamp(cang,0.0,PI/2.0);float shade=cang*atan(length(deriv))*4.0/PI/PI;float highlight=(PI/2.0-cang)*atan(length(deriv))*4.0/PI/PI;fragColor=u_shadows[0]*shade+u_highlights[0]*highlight;}void main() {vec2 size=vec2(textureSize(u_image,0));vec2 texturePos=(v_pos*(size-2.0)+1.0)/size;vec4 pixel=texture(u_image,texturePos);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));vec2 deriv=((pixel.rg*8.0)-4.0)/scaleFactor;if (u_method==BASIC) {basic_hillshade(deriv);} else if (u_method==COMBINED) {combined_hillshade(deriv);} else if (u_method==IGOR) {igor_hillshade(deriv);} else if (u_method==MULTIDIRECTIONAL) {multidirectional_hillshade(deriv);} else if (u_method==STANDARD) {standard_hillshade(deriv);} else {standard_hillshade(deriv);}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);v_pos=a_pos/8192.0;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}`),
    line: $4324d99ae8520741$var$Y(`flat in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
clipAntimeridian();float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);fragColor=color*(alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
layout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;out vec2 v_normal;flat out vec2 v_width2;out float v_gamma_scale;out highp float v_linesofar;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float width
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float width
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);v_linesofar=float((a_data.z >> 2u)+a_data.w*64u)*2.0;vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_width2=vec2(outset,inset);}`),
    lineGradient: $4324d99ae8520741$var$Y(`uniform sampler2D u_image;flat in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec2 v_uv;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
clipAntimeridian();float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);fragColor=color*(alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
layout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;layout(location=2) in float a_uv_x;layout(location=3) in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform float u_image_height;out vec2 v_normal;flat out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float width
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float width
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_width2=vec2(outset,inset);}`),
    linePattern: $4324d99ae8520741$var$Y(`#ifdef GL_ES
precision highp float;
#endif
uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;in vec2 v_normal;flat in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;flat in float v_width;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
clipAntimeridian();vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture(u_image,pos_a),texture(u_image,pos_b),u_fade);fragColor=color*alpha*opacity;
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
layout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;out vec2 v_normal;flat out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;flat out float v_width;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define lowp vec4 pattern_from
#pragma maplibre: define lowp vec4 pattern_to
#pragma maplibre: define lowp float pixel_ratio_from
#pragma maplibre: define lowp float pixel_ratio_to
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 pattern_from
#pragma maplibre: initialize mediump vec4 pattern_to
#pragma maplibre: initialize lowp float pixel_ratio_from
#pragma maplibre: initialize lowp float pixel_ratio_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);float a_linesofar=float((a_data.z >> 2u)+a_data.w*64u)*LINE_DISTANCE_SCALE;vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}`),
    lineSDF: $4324d99ae8520741$var$Y(`uniform lowp float u_lineatlas_width;uniform sampler2D u_image;uniform float u_mix;in vec2 v_normal;flat in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define mediump vec4 dasharray_from
#pragma maplibre: define mediump vec4 dasharray_to
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 dasharray_from
#pragma maplibre: initialize mediump vec4 dasharray_to
clipAntimeridian();float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture(u_image,v_tex_a).a;float sdfdist_b=texture(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0/u_device_pixel_ratio)/min(dasharray_from.w,dasharray_to.w);alpha*=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
layout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;flat out vec2 v_width2;out vec2 v_tex_a;out vec2 v_tex_b;out float v_gamma_scale;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define highp vec4 color
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define mediump vec4 dasharray_from
#pragma maplibre: define mediump vec4 dasharray_to
void main() {
#pragma maplibre: initialize highp vec4 color
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 dasharray_from
#pragma maplibre: initialize mediump vec4 dasharray_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);float a_linesofar=float((a_data.z >> 2u)+a_data.w*64u)*LINE_DISTANCE_SCALE;vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
float u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}`),
    lineGradientSDF: $4324d99ae8520741$var$Y(`uniform sampler2D u_image;uniform sampler2D u_image_dash;uniform float u_mix;uniform lowp float u_lineatlas_width;in vec2 v_normal;flat in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;in highp vec2 v_uv;
#ifdef GLOBE
in float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define mediump vec4 dasharray_from
#pragma maplibre: define mediump vec4 dasharray_to
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 dasharray_from
#pragma maplibre: initialize mediump vec4 dasharray_to
clipAntimeridian();float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);float sdfdist_a=texture(u_image_dash,v_tex_a).a;float sdfdist_b=texture(u_image_dash,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0)/min(dasharray_from.w,dasharray_to.w);float dash_alpha=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*dash_alpha*opacity);
#ifdef GLOBE
if (v_depth > 1.0) {discard;}
#endif
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
layout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;layout(location=2) in float a_uv_x;layout(location=3) in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform float u_image_height;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;flat out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;out vec2 v_tex_a;out vec2 v_tex_b;
#ifdef GLOBE
out float v_depth;
#endif
#pragma maplibre: define lowp float blur
#pragma maplibre: define lowp float opacity
#pragma maplibre: define mediump float gapwidth
#pragma maplibre: define lowp float offset
#pragma maplibre: define mediump float width
#pragma maplibre: define lowp float floorwidth
#pragma maplibre: define mediump vec4 dasharray_from
#pragma maplibre: define mediump vec4 dasharray_to
void main() {
#pragma maplibre: initialize lowp float blur
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize mediump float gapwidth
#pragma maplibre: initialize lowp float offset
#pragma maplibre: initialize mediump float width
#pragma maplibre: initialize lowp float floorwidth
#pragma maplibre: initialize mediump vec4 dasharray_from
#pragma maplibre: initialize mediump vec4 dasharray_to
if (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);float a_linesofar=float((a_data.z >> 2u)+a_data.w*64u)*LINE_DISTANCE_SCALE;float texel_height=1.0/u_image_height;float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;
#ifdef GLOBE
v_depth=gl_Position.z/gl_Position.w;
#endif
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
float u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}`),
    layerOpacity: $4324d99ae8520741$var$Y(`uniform sampler2D u_image;uniform float u_opacity;in vec2 v_pos;void main() {fragColor=texture(u_image,v_pos)*u_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(0.0);
#endif
}`, `layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos.x*2.0-1.0,1.0-a_pos.y*2.0,0.0,1.0);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}`),
    raster: $4324d99ae8520741$var$Y(`uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;in vec3 v_pos0;in vec3 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture(u_image0,v_pos0.xy/v_pos0.z);vec4 color1=texture(u_image1,v_pos1.xy/v_pos1.z);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);fragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;uniform vec3 u_image_warp;uniform vec4 u_coords_top;uniform vec4 u_coords_bottom;layout(location=0) in vec2 a_pos;out vec3 v_pos0;out vec3 v_pos1;void main() {vec2 fractionalPos=a_pos/8192.0;vec2 topLeft=u_coords_top.xy;vec2 topRight=u_coords_top.zw;vec2 bottomLeft=u_coords_bottom.xy;vec2 bottomRight=u_coords_bottom.zw;vec2 bilinearPos=mix(mix(topLeft,topRight,fractionalPos.x),mix(bottomLeft,bottomRight,fractionalPos.x),fractionalPos.y);float denominator=dot(u_image_warp.xy,fractionalPos)+1.0;vec2 acrossTop=topRight-topLeft+u_image_warp.x*topRight;vec2 downLeft=bottomLeft-topLeft+u_image_warp.y*bottomLeft;vec2 projectivePos=(acrossTop*fractionalPos.x+downLeft*fractionalPos.y+topLeft)/denominator;vec2 position=mix(projectivePos,bilinearPos,u_image_warp.z);gl_Position=projectTile(position,position);vec2 texturePos=((fractionalPos-0.5)/u_buffer_scale)+0.5;
#ifdef GLOBE
if (a_pos.y <-32767.5) {texturePos.y=0.0;}if (a_pos.y > 32766.5) {texturePos.y=1.0;}
#endif
float perspectiveRatio=mix(1.0/denominator,1.0,u_image_warp.z);v_pos0=vec3(texturePos*perspectiveRatio,perspectiveRatio);vec2 parentPos=(texturePos*u_scale_parent)+u_tl_parent;v_pos1=vec3(parentPos*perspectiveRatio,perspectiveRatio);}`),
    symbolIcon: $4324d99ae8520741$var$Y(`uniform sampler2D u_texture;in vec2 v_tex;flat in float v_total_opacity;void main() {fragColor=texture(u_texture,v_tex)*v_total_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `layout(location=0) in vec4 a_pos_offset;layout(location=1) in uvec4 a_data;layout(location=2) in vec4 a_pixeloffset;layout(location=3) in vec3 a_projected_pos;layout(location=4) in uint a_fade_opacity;layout(location=5) in float a_height_offset;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform bool u_rotate_symbol;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;uniform bool u_is_offset;uniform bool u_height_anchor_ground;out vec2 v_tex;flat out float v_total_opacity;
#pragma maplibre: define lowp float opacity
void main() {
#pragma maplibre: initialize lowp float opacity
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=vec2(a_data.xy);vec2 a_size=vec2(a_data.zw);float a_size_min=float(a_data.z >> 1u);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=a_height_offset+(u_height_anchor_ground ? get_elevation(a_pos) : 0.0);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_symbol_fade_change :-u_symbol_fade_change;float visibility=calculate_visibility(projectedPoint);v_total_opacity=opacity*max(0.0,min(visibility,fade_opacity[0]+fade_change));if (v_total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);if (!u_is_offset) {size*=perspective_ratio;}float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;
#ifdef GLOBE
if(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}
#endif
vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;}`),
    symbolSDF: $4324d99ae8520741$var$Y(`#define SDF_PX 8.0
uniform bool u_is_halo;uniform bool u_is_plain;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform bool u_is_text;in vec2 v_data0;in vec3 v_data1;
#pragma maplibre: define highp vec4 fill_color
#pragma maplibre: define highp vec4 halo_color
#pragma maplibre: define lowp float halo_width
#pragma maplibre: define lowp float halo_blur
void main() {
#pragma maplibre: initialize highp vec4 fill_color
#pragma maplibre: initialize highp vec4 halo_color
#pragma maplibre: initialize lowp float halo_width
#pragma maplibre: initialize lowp float halo_blur
float EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float total_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;lowp float dist=texture(u_texture,tex).a;lowp vec4 color_alpha_out_text,color_alpha_out_halo;if (u_is_plain){highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);color_alpha_out_text=total_opacity*alpha*fill_color;}if (u_is_halo) {float gamma_halo=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);float inner_edge_halo=inner_edge+gamma_halo*gamma_scale;highp float gamma_scaled_halo=gamma_halo*gamma_scale;highp float alpha_halo=smoothstep(inner_edge_halo-gamma_scaled_halo,inner_edge_halo+gamma_scaled_halo,dist);highp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha_halo= min(smoothstep(halo_edge-gamma_scaled_halo,halo_edge+gamma_scaled_halo,dist),1.0-alpha_halo);color_alpha_out_halo=total_opacity*alpha_halo*halo_color;}if (u_is_plain && u_is_halo) {fragColor=color_alpha_out_text+(1.-color_alpha_out_text.a)*color_alpha_out_halo;} else if (u_is_halo){fragColor=color_alpha_out_halo;} else {fragColor=color_alpha_out_text;}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `layout(location=0) in vec4 a_pos_offset;layout(location=1) in uvec4 a_data;layout(location=2) in vec4 a_pixeloffset;layout(location=3) in vec3 a_projected_pos;layout(location=4) in uint a_fade_opacity;layout(location=5) in float a_height_offset;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform bool u_rotate_symbol;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;uniform bool u_is_offset;uniform bool u_height_anchor_ground;out vec2 v_data0;out vec3 v_data1;
#pragma maplibre: define highp vec4 fill_color
#pragma maplibre: define highp vec4 halo_color
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp float halo_width
#pragma maplibre: define lowp float halo_blur
void main() {
#pragma maplibre: initialize highp vec4 fill_color
#pragma maplibre: initialize highp vec4 halo_color
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize lowp float halo_width
#pragma maplibre: initialize lowp float halo_blur
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=vec2(a_data.xy);vec2 a_size=vec2(a_data.zw);float a_size_min=float(a_data.z >> 1u);vec2 a_pxoffset=a_pixeloffset.xy/16.0;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=a_height_offset+(u_height_anchor_ground ? get_elevation(a_pos) : 0.0);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_symbol_fade_change :-u_symbol_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));float total_opacity=opacity*interpolated_fade_opacity;if (total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);if (!u_is_offset) {size*=perspective_ratio;}float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;
#ifdef GLOBE
if(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}
#endif
vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,total_opacity);}`),
    symbolTextAndIcon: $4324d99ae8520741$var$Y(`#define SDF_PX 8.0
#define SDF 1.0
#define ICON 0.0
uniform bool u_is_halo;uniform bool u_is_text;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;in vec4 v_data0;in vec3 v_data1;flat in float v_is_sdf;
#pragma maplibre: define highp vec4 fill_color
#pragma maplibre: define highp vec4 halo_color
#pragma maplibre: define lowp float halo_width
#pragma maplibre: define lowp float halo_blur
void main() {
#pragma maplibre: initialize highp vec4 fill_color
#pragma maplibre: initialize highp vec4 halo_color
#pragma maplibre: initialize lowp float halo_width
#pragma maplibre: initialize lowp float halo_blur
float total_opacity=v_data1[2];if (v_is_sdf==ICON) {vec2 tex_icon=v_data0.zw;fragColor=texture(u_texture_icon,tex_icon)*total_opacity;
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
return;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;lowp float dist=texture(u_texture,tex).a;lowp vec4 color_alpha_out,color_alpha_out_halo;if (u_is_text) {highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);color_alpha_out=fill_color*(alpha*total_opacity);}if (u_is_halo) {highp float gamma_halo=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);lowp float buff_halo=(6.0-halo_width/fontScale)/SDF_PX;highp float gamma_scaled_halo=gamma_halo*gamma_scale;highp float alpha_halo=smoothstep(buff_halo-gamma_scaled_halo,buff_halo+gamma_scaled_halo,dist);color_alpha_out_halo=halo_color*(alpha_halo*total_opacity);}if (u_is_text && u_is_halo) {fragColor=color_alpha_out+(1.-color_alpha_out.a)*color_alpha_out_halo;} else if (u_is_halo) {fragColor=color_alpha_out_halo;} else {fragColor=color_alpha_out;}
#ifdef OVERDRAW_INSPECTOR
fragColor=vec4(1.0);
#endif
}`, `layout(location=0) in vec4 a_pos_offset;layout(location=1) in uvec4 a_data;layout(location=2) in vec3 a_projected_pos;layout(location=3) in uint a_fade_opacity;layout(location=4) in float a_height_offset;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;uniform bool u_is_offset;uniform bool u_height_anchor_ground;out vec4 v_data0;out vec3 v_data1;flat out float v_is_sdf;
#pragma maplibre: define highp vec4 fill_color
#pragma maplibre: define highp vec4 halo_color
#pragma maplibre: define lowp float opacity
#pragma maplibre: define lowp float halo_width
#pragma maplibre: define lowp float halo_blur
void main() {
#pragma maplibre: initialize highp vec4 fill_color
#pragma maplibre: initialize highp vec4 halo_color
#pragma maplibre: initialize lowp float opacity
#pragma maplibre: initialize lowp float halo_width
#pragma maplibre: initialize lowp float halo_blur
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=vec2(a_data.xy);vec2 a_size=vec2(a_data.zw);float a_size_min=float(a_data.z >> 1u);float is_sdf=float(a_data.z & 1u);float ele=a_height_offset+(u_height_anchor_ground ? get_elevation(a_pos) : 0.0);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_symbol_fade_change :-u_symbol_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));float total_opacity=opacity*interpolated_fade_opacity;if (total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);if (!u_is_offset) {size*=perspective_ratio;}float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;
#ifdef GLOBE
if(u_pitch_with_map && !u_is_along_line) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}
#endif
vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec3(gamma_scale,size,total_opacity);v_is_sdf=is_sdf;}`),
    terrain: $4324d99ae8520741$var$Y(`uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;uniform bool u_is_globe_mode;in vec2 v_texture_pos;in float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture(u_texture,vec2(v_texture_pos.x,1.0-v_texture_pos.y));if (!u_is_globe_mode && u_fog_ground_blend_opacity > 0.0 && v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);fragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {fragColor=surface_color;}}`, `layout(location=0) in vec3 a_pos3d;uniform mat4 u_fog_matrix;uniform float u_ele_delta;out vec2 v_texture_pos;out float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}`),
    terrainDepth: $4324d99ae8520741$var$Y(`in float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {fragColor=pack(v_depth);}`, `layout(location=0) in vec3 a_pos3d;uniform float u_ele_delta;out float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);v_depth=gl_Position.z/gl_Position.w;}`),
    atmosphere: $4324d99ae8520741$var$Y(`#ifdef GL_ES
precision highp float;
#endif
in vec3 view_direction;uniform vec3 u_sun_pos;uniform vec3 u_globe_position;uniform float u_globe_radius;uniform float u_atmosphere_blend;/**Shader use from https:*Made some change to adapt to MapLibre Globe geometry*/const float PI=3.141592653589793;const int iSteps=5;const int jSteps=3;/*radius of the planet*/const float EARTH_RADIUS=6371e3;/*radius of the atmosphere*/const float ATMOS_RADIUS=6471e3;vec2 rsi(vec3 r0,vec3 rd,float sr) {float a=dot(rd,rd);float b=2.0*dot(rd,r0);float c=dot(r0,r0)-(sr*sr);float d=(b*b)-4.0*a*c;if (d < 0.0) return vec2(1e5,-1e5);return vec2((-b-sqrt(d))/(2.0*a),(-b+sqrt(d))/(2.0*a));}vec4 atmosphere(vec3 r,vec3 r0,vec3 pSun,float iSun,float rPlanet,float rAtmos,vec3 kRlh,float kMie,float shRlh,float shMie,float g) {pSun=normalize(pSun);r=normalize(r);vec2 p=rsi(r0,r,rAtmos);if (p.x > p.y) {return vec4(0.0,0.0,0.0,1.0);}if (p.x < 0.0) {p.x=0.0;}vec3 pos=r0+r*p.x;vec2 p2=rsi(r0,r,rPlanet);if (p2.x <=p2.y && p2.x > 0.0) {p.y=min(p.y,p2.x);}float iStepSize=(p.y-p.x)/float(iSteps);float iTime=p.x+iStepSize*0.5;vec3 totalRlh=vec3(0,0,0);vec3 totalMie=vec3(0,0,0);float iOdRlh=0.0;float iOdMie=0.0;float mu=dot(r,pSun);float mumu=mu*mu;float gg=g*g;float pRlh=3.0/(16.0*PI)*(1.0+mumu);float pMie=3.0/(8.0*PI)*((1.0-gg)*(mumu+1.0))/(pow(1.0+gg-2.0*mu*g,1.5)*(2.0+gg));for (int i=0; i < iSteps; i++) {vec3 iPos=r0+r*iTime;float iHeight=length(iPos)-rPlanet;float odStepRlh=exp(-iHeight/shRlh)*iStepSize;float odStepMie=exp(-iHeight/shMie)*iStepSize;iOdRlh+=odStepRlh;iOdMie+=odStepMie;float jStepSize=rsi(iPos,pSun,rAtmos).y/float(jSteps);float jTime=jStepSize*0.5;float jOdRlh=0.0;float jOdMie=0.0;for (int j=0; j < jSteps; j++) {vec3 jPos=iPos+pSun*jTime;float jHeight=length(jPos)-rPlanet;jOdRlh+=exp(-jHeight/shRlh)*jStepSize;jOdMie+=exp(-jHeight/shMie)*jStepSize;jTime+=jStepSize;}vec3 attn=exp(-(kMie*(iOdMie+jOdMie)+kRlh*(iOdRlh+jOdRlh)));totalRlh+=odStepRlh*attn;totalMie+=odStepMie*attn;iTime+=iStepSize;}float opacity=exp(-(length(kRlh)*length(totalRlh)+kMie*length(totalMie)));vec3 color=iSun*(pRlh*kRlh*totalRlh+pMie*kMie*totalMie);return vec4(color,opacity);}void main() {vec3 scale_camera_pos=-u_globe_position*EARTH_RADIUS/u_globe_radius;vec4 color=atmosphere(normalize(view_direction),scale_camera_pos,u_sun_pos,22.0,EARTH_RADIUS,ATMOS_RADIUS,vec3(5.5e-6,13.0e-6,22.4e-6),21e-6,8e3,1.2e3,0.758
);color.rgb=1.0-exp(-1.0*color.rgb);color=pow(color,vec4(1.0/2.2));fragColor=vec4(color.rgb,1.0-color.a)*u_atmosphere_blend;}`, `layout(location=0) in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 view_direction;void main() {view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,0.0,1.0);}`),
    sky: $4324d99ae8520741$var$Y(`uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform vec2 u_horizon;uniform vec2 u_horizon_normal;uniform float u_sky_horizon_blend;uniform float u_sky_blend;uniform vec3 u_globe_position;uniform float u_globe_radius;in vec3 v_view_direction;void main() {float x=gl_FragCoord.x;float y=gl_FragCoord.y;float blend=(y-u_horizon.y)*u_horizon_normal.y+(x-u_horizon.x)*u_horizon_normal.x;if (u_sky_blend > 0.0) {vec3 ray=normalize(v_view_direction);float globe_distance=length(u_globe_position);float angle_to_globe_center=acos(clamp(dot(ray,u_globe_position)/globe_distance,-1.0,1.0));float horizon_angle=asin(min(u_globe_radius/globe_distance,1.0));blend=mix(blend,(angle_to_globe_center-horizon_angle)*u_camera_to_center_distance*u_device_pixel_ratio,u_sky_blend);}if (blend > 0.0) {if (blend < u_sky_horizon_blend) {fragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {fragColor=u_sky_color;}}fragColor=mix(fragColor,vec4(vec3(0.0),0.0),u_sky_blend);}`, `layout(location=0) in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 v_view_direction;void main() {v_view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,1.0,1.0);}`)
};
function $4324d99ae8520741$var$Y(e1, t) {
    let n = /#pragma maplibre: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, r = t.match(/in ([\w]+) ([\w]+)/g), i = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), a = t.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), o = a ? a.concat(i) : i, s = r ? r.length : 0, c = {};
    return e1 = e1.replace(n, (e1, t, n, r, i)=>(c[i] = !0, t === `define` ? `
#ifndef HAS_UNIFORM_u_${i}
in ${n} ${r} ${i};
#else
uniform ${n} ${r} u_${i};
#endif
` : `
#ifdef HAS_UNIFORM_u_${i}
    ${n} ${r} ${i} = u_${i};
#endif
`)), t = t.replace(n, (e1, t, n, r, i)=>{
        let a = r === `float` ? `vec2` : `vec4`, o = i.match(/color/) ? `color` : a;
        return c[i] ? t === `define` ? `
#ifndef HAS_UNIFORM_u_${i}
uniform lowp float u_${i}_t;
layout(location = ${s++}) in ${n} ${a} a_${i};
out ${n} ${r} ${i};
#else
uniform ${n} ${r} u_${i};
#endif
` : o === `vec4` ? `
#ifndef HAS_UNIFORM_u_${i}
    ${i} = a_${i};
#else
    ${n} ${r} ${i} = u_${i};
#endif
` : `
#ifndef HAS_UNIFORM_u_${i}
    ${i} = unpack_mix_${o}(a_${i}, u_${i}_t);
#else
    ${n} ${r} ${i} = u_${i};
#endif
` : t === `define` ? `
#ifndef HAS_UNIFORM_u_${i}
uniform lowp float u_${i}_t;
layout(location = ${s++}) in ${n} ${a} a_${i};
#else
uniform ${n} ${r} u_${i};
#endif
` : o === `vec4` ? `
#ifndef HAS_UNIFORM_u_${i}
    ${n} ${r} ${i} = a_${i};
#else
    ${n} ${r} ${i} = u_${i};
#endif
` : `
#ifndef HAS_UNIFORM_u_${i}
    ${n} ${r} ${i} = unpack_mix_${o}(a_${i}, u_${i}_t);
#else
    ${n} ${r} ${i} = u_${i};
#endif
`;
    }), {
        fragmentSource: e1,
        vertexSource: t,
        staticAttributes: r,
        staticUniforms: o
    };
}
const $4324d99ae8520741$var$ac = `#define PROJECTION_MERCATOR`, $4324d99ae8520741$var$oc = `mercator`;
var $4324d99ae8520741$var$sc = class {
    constructor(){
        this._cachedMesh = null;
    }
    get name() {
        return `mercator`;
    }
    get useSubdivision() {
        return !1;
    }
    get shaderVariantName() {
        return $4324d99ae8520741$var$oc;
    }
    get shaderDefine() {
        return $4324d99ae8520741$var$ac;
    }
    get shaderPreludeCode() {
        return $4324d99ae8520741$var$ic.projectionMercator;
    }
    get vertexShaderPreludeCode() {
        return $4324d99ae8520741$var$ic.projectionMercator.vertexSource;
    }
    get subdivisionGranularity() {
        return (0, $1G0Uw.vt).noSubdivision;
    }
    get useGlobeControls() {
        return !1;
    }
    get transitionState() {
        return 0;
    }
    destroy() {}
    getMeshFromTileID(e1, t, n, r, i) {
        if (this._cachedMesh) return this._cachedMesh;
        let a = new (0, $1G0Uw.Gt);
        a.emplaceBack(0, 0), a.emplaceBack((0, $1G0Uw.Lr), 0), a.emplaceBack(0, (0, $1G0Uw.Lr)), a.emplaceBack((0, $1G0Uw.Lr), (0, $1G0Uw.Lr));
        let o = e1.createVertexBuffer(a, $4324d99ae8520741$var$Wa.members), s = (0, $1G0Uw.Bt).simpleSegment(0, 0, 4, 2), c = new (0, $1G0Uw.Jt);
        c.emplaceBack(1, 0, 2), c.emplaceBack(1, 2, 3);
        let l = e1.createIndexBuffer(c);
        return this._cachedMesh = new $4324d99ae8520741$var$Ua(o, l, s), this._cachedMesh;
    }
    recalculate() {}
    hasTransition() {
        return !1;
    }
}, $4324d99ae8520741$export$45cce0bd6c1f342a = class e1 {
    constructor(e1 = 0, t = 0, n = 0, r = 0){
        if (isNaN(e1) || e1 < 0 || isNaN(t) || t < 0 || isNaN(n) || n < 0 || isNaN(r) || r < 0) throw Error(`Invalid value for edge-insets, top, bottom, left and right must all be numbers`);
        this.top = e1, this.bottom = t, this.left = n, this.right = r;
    }
    interpolate(e1, t, n) {
        return t.top != null && e1.top != null && (this.top = (0, $1G0Uw.un).number(e1.top, t.top, n)), t.bottom != null && e1.bottom != null && (this.bottom = (0, $1G0Uw.un).number(e1.bottom, t.bottom, n)), t.left != null && e1.left != null && (this.left = (0, $1G0Uw.un).number(e1.left, t.left, n)), t.right != null && e1.right != null && (this.right = (0, $1G0Uw.un).number(e1.right, t.right, n)), this;
    }
    getCenter(e1, t) {
        let n = (0, $1G0Uw.Bn)((this.left + e1 - this.right) / 2, 0, e1), r = (0, $1G0Uw.Bn)((this.top + t - this.bottom) / 2, 0, t);
        return new (0, $1G0Uw.Li)(n, r);
    }
    equals(e1) {
        return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
    }
    clone() {
        return new e1(this.top, this.bottom, this.left, this.right);
    }
    toJSON() {
        return {
            top: this.top,
            bottom: this.bottom,
            left: this.left,
            right: this.right
        };
    }
};
function $4324d99ae8520741$var$lc(e1, t) {
    if (!e1.renderWorldCopies || e1.lngRange) return;
    let n = t.lng - e1.center.lng;
    t.lng += n > 180 ? -360 : n < -180 ? 360 : 0;
}
function $4324d99ae8520741$var$uc(e1) {
    return Math.max(0, Math.floor(e1));
}
var $4324d99ae8520741$var$dc = class {
    constructor(e1, t){
        this.applyConstrain = (e1, t)=>this._constrainOverride === null ? this._callbacks.defaultConstrain(e1, t) : this._constrainOverride(e1, t), this._callbacks = e1, this._tileSize = 512, this._renderWorldCopies = t?.renderWorldCopies === void 0 || !!t?.renderWorldCopies, this._minZoom = t?.minZoom || 0, this._maxZoom = t?.maxZoom || 22, this._minPitch = t?.minPitch === void 0 || t?.minPitch === null ? 0 : t?.minPitch, this._maxPitch = t?.maxPitch === void 0 || t?.maxPitch === null ? 60 : t?.maxPitch, this._constrainOverride = t?.constrainOverride ?? null, this.setMaxBounds(), this._width = 0, this._height = 0, this._center = new (0, $1G0Uw.lt)(0, 0), this._elevation = 0, this._zoom = 0, this._tileZoom = $4324d99ae8520741$var$uc(this._zoom), this._scale = (0, $1G0Uw.Fr)(this._zoom), this._bearingInRadians = 0, this._fovInRadians = .6435011087932844, this._pitchInRadians = 0, this._rollInRadians = 0, this._unmodified = !0, this._edgeInsets = new $4324d99ae8520741$export$45cce0bd6c1f342a, this._minElevationForCurrentTile = 0, this._autoCalculateNearFarZ = !0;
    }
    apply(e1, t, n) {
        this._constrainOverride = e1.constrainOverride, this._latRange = e1.latRange, this._lngRange = e1.lngRange, this._width = e1.width, this._height = e1.height, this._center = e1.center, this._elevation = e1.elevation, this._minElevationForCurrentTile = e1.minElevationForCurrentTile, this._zoom = e1.zoom, this._tileZoom = $4324d99ae8520741$var$uc(this._zoom), this._scale = (0, $1G0Uw.Fr)(this._zoom), this._bearingInRadians = e1.bearingInRadians, this._fovInRadians = e1.fovInRadians, this._pitchInRadians = e1.pitchInRadians, this._rollInRadians = e1.rollInRadians, this._unmodified = e1.unmodified, this._edgeInsets = new $4324d99ae8520741$export$45cce0bd6c1f342a(e1.padding.top, e1.padding.bottom, e1.padding.left, e1.padding.right), this._minZoom = e1.minZoom, this._maxZoom = e1.maxZoom, this._minPitch = e1.minPitch, this._maxPitch = e1.maxPitch, this._renderWorldCopies = e1.renderWorldCopies, this._cameraToCenterDistance = e1.cameraToCenterDistance, this._nearZ = e1.nearZ, this._farZ = e1.farZ, this._autoCalculateNearFarZ = !n && e1.autoCalculateNearFarZ, t && this.constrainInternal(), this._calcMatrices();
    }
    get pixelsToClipSpaceMatrix() {
        return this._pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._clipSpaceToPixelsMatrix;
    }
    get minElevationForCurrentTile() {
        return this._minElevationForCurrentTile;
    }
    setMinElevationForCurrentTile(e1) {
        this._minElevationForCurrentTile = e1;
    }
    get tileSize() {
        return this._tileSize;
    }
    get tileZoom() {
        return this._tileZoom;
    }
    get scale() {
        return this._scale;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    get bearingInRadians() {
        return this._bearingInRadians;
    }
    get lngRange() {
        return this._lngRange;
    }
    get latRange() {
        return this._latRange;
    }
    get pixelsToGLUnits() {
        return this._pixelsToGLUnits;
    }
    get minZoom() {
        return this._minZoom;
    }
    setMinZoom(e1) {
        if (this._minZoom === e1) return;
        this._minZoom = e1;
        let t = this._unmodified;
        this.setZoom(this.applyConstrain(this._center, this.zoom).zoom), this._unmodified = t;
    }
    get maxZoom() {
        return this._maxZoom;
    }
    setMaxZoom(e1) {
        if (this._maxZoom === e1) return;
        this._maxZoom = e1;
        let t = this._unmodified;
        this.setZoom(this.applyConstrain(this._center, this.zoom).zoom), this._unmodified = t;
    }
    get minPitch() {
        return this._minPitch;
    }
    setMinPitch(e1) {
        if (this._minPitch === e1) return;
        this._minPitch = e1;
        let t = this._unmodified;
        this.setPitch(Math.max(this.pitch, e1)), this._unmodified = t;
    }
    get maxPitch() {
        return this._maxPitch;
    }
    setMaxPitch(e1) {
        if (this._maxPitch === e1) return;
        this._maxPitch = e1;
        let t = this._unmodified;
        this.setPitch(Math.min(this.pitch, e1)), this._unmodified = t;
    }
    get renderWorldCopies() {
        return this._renderWorldCopies;
    }
    setRenderWorldCopies(e1) {
        e1 === void 0 ? e1 = !0 : e1 === null && (e1 = !1), this._renderWorldCopies = e1;
    }
    get constrainOverride() {
        return this._constrainOverride;
    }
    setConstrainOverride(e1) {
        e1 === void 0 && (e1 = null), this._constrainOverride !== e1 && (this._constrainOverride = e1, this.constrainInternal(), this._calcMatrices());
    }
    get worldSize() {
        return this._tileSize * this._scale;
    }
    get centerOffset() {
        return this.centerPoint._sub(this.size._div(2));
    }
    get size() {
        return new (0, $1G0Uw.Li)(this._width, this._height);
    }
    get bearing() {
        return this._bearingInRadians / Math.PI * 180;
    }
    setBearing(e1) {
        let t = (0, $1G0Uw.Pr)(e1, -180, 180) * Math.PI / 180;
        this._bearingInRadians !== t && (this._unmodified = !1, this._bearingInRadians = t, this._calcMatrices(), this._rotationMatrix = $4324d99ae8520741$var$jr(), $4324d99ae8520741$var$Pr(this._rotationMatrix, this._rotationMatrix, -this._bearingInRadians));
    }
    get rotationMatrix() {
        return this._rotationMatrix;
    }
    get pitchInRadians() {
        return this._pitchInRadians;
    }
    get pitch() {
        return this._pitchInRadians / Math.PI * 180;
    }
    setPitch(e1) {
        let t = (0, $1G0Uw.Bn)(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
        this._pitchInRadians !== t && (this._unmodified = !1, this._pitchInRadians = t, this._calcMatrices());
    }
    get rollInRadians() {
        return this._rollInRadians;
    }
    get roll() {
        return this._rollInRadians / Math.PI * 180;
    }
    setRoll(e1) {
        let t = e1 / 180 * Math.PI;
        this._rollInRadians !== t && (this._unmodified = !1, this._rollInRadians = t, this._calcMatrices());
    }
    get fovInRadians() {
        return this._fovInRadians;
    }
    get fov() {
        return (0, $1G0Uw.xr)(this._fovInRadians);
    }
    setFov(e1) {
        e1 = (0, $1G0Uw.Bn)(e1, .1, 150), this.fov !== e1 && (this._unmodified = !1, this._fovInRadians = (0, $1G0Uw.Yn)(e1), this._calcMatrices());
    }
    get zoom() {
        return this._zoom;
    }
    setZoom(e1) {
        let t = this.applyConstrain(this._center, e1).zoom;
        this._zoom !== t && (this._unmodified = !1, this._zoom = t, this._tileZoom = Math.max(0, Math.floor(t)), this._scale = (0, $1G0Uw.Fr)(t), this.constrainInternal(), this._calcMatrices());
    }
    get center() {
        return this._center;
    }
    setCenter(e1) {
        (e1.lat !== this._center.lat || e1.lng !== this._center.lng) && (this._unmodified = !1, this._center = e1, this.constrainInternal(), this._calcMatrices());
    }
    get elevation() {
        return this._elevation;
    }
    setElevation(e1) {
        e1 !== this._elevation && (this._elevation = e1, this.constrainInternal(), this._calcMatrices());
    }
    get padding() {
        return this._edgeInsets.toJSON();
    }
    setPadding(e1) {
        this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
    }
    get centerPoint() {
        return this._edgeInsets.getCenter(this._width, this._height);
    }
    get pixelsPerMeter() {
        return this._pixelPerMeter;
    }
    get unmodified() {
        return this._unmodified;
    }
    get cameraToCenterDistance() {
        return this._cameraToCenterDistance;
    }
    get nearZ() {
        return this._nearZ;
    }
    get farZ() {
        return this._farZ;
    }
    get autoCalculateNearFarZ() {
        return this._autoCalculateNearFarZ;
    }
    overrideNearFarZ(e1, t) {
        this._autoCalculateNearFarZ = !1, this._nearZ = e1, this._farZ = t, this._calcMatrices();
    }
    clearNearFarZOverride() {
        this._autoCalculateNearFarZ = !0, this._calcMatrices();
    }
    isPaddingEqual(e1) {
        return this._edgeInsets.equals(e1);
    }
    interpolatePadding(e1, t, n) {
        this._unmodified = !1, this._edgeInsets.interpolate(e1, t, n), this.constrainInternal(), this._calcMatrices();
    }
    resize(e1, t, n = !0) {
        this._width = e1, this._height = t, n && this.constrainInternal(), this._calcMatrices();
    }
    getMaxBounds() {
        return this._latRange?.length !== 2 || this._lngRange?.length !== 2 ? null : new $4324d99ae8520741$export$266d2884f61535d3([
            this._lngRange[0],
            this._latRange[0]
        ], [
            this._lngRange[1],
            this._latRange[1]
        ]);
    }
    setMaxBounds(e1) {
        e1 ? (this._lngRange = [
            e1.getWest(),
            e1.getEast()
        ], this._latRange = [
            e1.getSouth(),
            e1.getNorth()
        ], this.constrainInternal()) : (this._lngRange = null, this._latRange = [
            -(0, $1G0Uw.Fn),
            (0, $1G0Uw.Fn)
        ]);
    }
    getCameraQueryGeometry(e1, t) {
        if (t.length === 1) return [
            t[0],
            e1
        ];
        {
            let { minX: n, minY: r, maxX: i, maxY: a } = (0, $1G0Uw.pt).fromPoints(t).extend(e1);
            return [
                new (0, $1G0Uw.Li)(n, r),
                new (0, $1G0Uw.Li)(i, r),
                new (0, $1G0Uw.Li)(i, a),
                new (0, $1G0Uw.Li)(n, a),
                new (0, $1G0Uw.Li)(n, r)
            ];
        }
    }
    constrainInternal() {
        if (!this.center || !this._width || !this._height || this._constraining) return;
        this._constraining = !0;
        let e1 = this._unmodified, { center: t, zoom: n } = this.applyConstrain(this.center, this.zoom);
        this.setCenter(t), this.setZoom(n), this._unmodified = e1, this._constraining = !1;
    }
    _calcMatrices() {
        if (this._pixelPerMeter = (0, $1G0Uw.ct)(1, this.center.lat) * this.worldSize, !this._width || !this._height) return;
        this._pixelsToGLUnits = [
            2 / this._width,
            -2 / this._height
        ];
        let e1 = (0, $1G0Uw.Si)(new Float64Array(16));
        (0, $1G0Uw.Ai)(e1, e1, [
            this._width / 2,
            -this._height / 2,
            1
        ]), (0, $1G0Uw.ji)(e1, e1, [
            1,
            -1,
            0
        ]), this._clipSpaceToPixelsMatrix = e1, e1 = (0, $1G0Uw.Si)(new Float64Array(16)), (0, $1G0Uw.Ai)(e1, e1, [
            1,
            -1,
            1
        ]), (0, $1G0Uw.ji)(e1, e1, [
            -1,
            -1,
            0
        ]), (0, $1G0Uw.Ai)(e1, e1, [
            2 / this._width,
            2 / this._height,
            1
        ]), this._pixelsToClipSpaceMatrix = e1;
        let t = this.fovInRadians / 2;
        this._cameraToCenterDistance = .5 / Math.tan(t) * this._height, this._callbacks.calcMatrices();
    }
    calculateCenterFromCameraLngLatAlt(e1, t, n, r) {
        let i = n === void 0 ? this.bearing : n, a = r = r === void 0 ? this.pitch : r, { distanceToCenter: o, clampedElevation: s } = this._distanceToCenterFromAltElevationPitch(t, this.elevation, a), { x: c, y: l } = (0, $1G0Uw.J)(a, i), u = (0, $1G0Uw.nt).fromLngLat(e1, t), d = (0, $1G0Uw.rt)(1, u.y), f, p, m = 0;
        do {
            if (m += 1, m > 10) break;
            p = o / d;
            let e1 = c * p, t = l * p;
            f = new (0, $1G0Uw.nt)(u.x + e1, u.y + t), d = 1 / f.meterInMercatorCoordinateUnits();
        }while (Math.abs(o - p * d) > 1e-12);
        return {
            center: f.toLngLat(),
            elevation: s,
            zoom: (0, $1G0Uw.Dr)(this.height / 2 / Math.tan(this.fovInRadians / 2) / p / this.tileSize)
        };
    }
    recalculateZoomAndCenter(e1) {
        if (this.elevation - e1 === 0) return;
        let t = 1 / this.worldSize, n = (0, $1G0Uw.ct)(1, this.center.lat) * this.worldSize, r = (0, $1G0Uw.nt).fromLngLat(this.center, this.elevation), i = r.x / t, a = r.y / t, o = r.z / t, s = this.pitch, c = this.bearing, { x: l, y: u, z: d } = (0, $1G0Uw.J)(s, c), f = this.cameraToCenterDistance, p = i + f * -l, m = a + f * -u, h = o + f * d, { distanceToCenter: g, clampedElevation: _ } = this._distanceToCenterFromAltElevationPitch(h / n, e1, s), v = g * n, y = p + l * v, x = m + u * v, S = new (0, $1G0Uw.nt)(y * t, x * t, 0).toLngLat(), C = (0, $1G0Uw.ct)(1, S.lat), w = (0, $1G0Uw.Dr)(this.height / 2 / Math.tan(this.fovInRadians / 2) / g / C / this.tileSize);
        this._elevation = _, this._center = S, this.setZoom(w);
    }
    _distanceToCenterFromAltElevationPitch(e1, t, n) {
        let r = -Math.cos((0, $1G0Uw.Yn)(n)), i = e1 - t, a, o = t;
        return r * i >= 0 || Math.abs(r) < .1 ? (a = 1e4, o = e1 + a * r) : a = -i / r, {
            distanceToCenter: a,
            clampedElevation: o
        };
    }
    getCameraPoint() {
        let e1 = this.pitchInRadians, t = Math.tan(e1) * (this.cameraToCenterDistance || 1);
        return this.centerPoint.add(new (0, $1G0Uw.Li)(t * Math.sin(this.rollInRadians), t * Math.cos(this.rollInRadians)));
    }
    getMercatorTileCoordinates(e1) {
        if (!e1) return [
            0,
            0,
            1,
            1
        ];
        let t = e1.canonical.z >= 0 ? 1 << e1.canonical.z : 2 ** e1.canonical.z;
        return [
            e1.canonical.x / t,
            e1.canonical.y / t,
            1 / t / (0, $1G0Uw.Lr),
            1 / t / (0, $1G0Uw.Lr)
        ];
    }
}, $4324d99ae8520741$var$fc = class {
    distanceToTile2d(e1, t, n, r) {
        let i = r, a = i.distanceX([
            e1,
            t
        ]), o = i.distanceY([
            e1,
            t
        ]);
        return Math.hypot(a, o);
    }
    getWrap(e1, t, n) {
        return n;
    }
    getTileBoundingVolume(e1, t, n, r) {
        let i = Math.min(0, n), a = Math.max(0, n);
        if (r?.terrain) {
            let n = new (0, $1G0Uw.d)(e1.z, t, e1.z, e1.x, e1.y), o = r.terrain.getMinMaxElevation(n);
            i = o.minElevation ?? i, a = o.maxElevation ?? a;
        }
        let o = 1 << e1.z;
        return new $4324d99ae8520741$var$go([
            t + e1.x / o,
            e1.y / o,
            i
        ], [
            t + (e1.x + 1) / o,
            (e1.y + 1) / o,
            a
        ]);
    }
    allowVariableZoom(e1, t) {
        let n = e1.fov * (Math.abs(Math.cos(e1.rollInRadians)) * e1.height + Math.abs(Math.sin(e1.rollInRadians)) * e1.width) / e1.height, r = (0, $1G0Uw.Bn)(78.5 - n / 2, 0, 60);
        return !!t.terrain || e1.pitch > r;
    }
    allowWorldCopies() {
        return !0;
    }
    prepareNextFrame() {}
};
const $4324d99ae8520741$var$pc = (0, $1G0Uw.Yt)([
    {
        name: `a_pos3d`,
        type: `Int16`,
        components: 3
    }
]);
var $4324d99ae8520741$var$mc = class extends (0, $1G0Uw.vn) {
    constructor(e1){
        super(), this._lastTilesetChange = $4324d99ae8520741$export$461939dd4422153(), this.tileManager = e1, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.deltaZoom = 1, this.tileSize = e1._source.tileSize * 2 ** this.deltaZoom, e1.usedForTerrain = !0, e1.tileSize = this.tileSize;
    }
    destruct() {
        this.tileManager.usedForTerrain = !1, this.tileManager.tileSize = null, this.releaseAllRTT();
    }
    getSource() {
        return this.tileManager._source;
    }
    update(e1, t) {
        this.tileManager.update(e1, t), this._renderableTilesKeys = [];
        let n = {}, r = !1;
        for (let i of $4324d99ae8520741$var$ko(e1, {
            tileSize: this.tileSize,
            minzoom: this.minzoom,
            maxzoom: this.maxzoom,
            reparseOverscaled: !1,
            terrain: t,
            calculateTileZoom: this.tileManager._source.calculateTileZoom
        }))n[i.key] = !0, this._renderableTilesKeys.push(i.key), this._tiles[i.key] || (i.terrainRttPosMatrix32f = new Float32Array(16), (0, $1G0Uw.Ti)(i.terrainRttPosMatrix32f, 0, (0, $1G0Uw.Lr), (0, $1G0Uw.Lr), 0, 0, 1), this._tiles[i.key] = new $4324d99ae8520741$var$po(i, this.tileSize), this._lastTilesetChange = $4324d99ae8520741$export$461939dd4422153(), r = !0);
        for(let e1 in this._tiles)n[e1] || (this._tiles[e1].releaseRTT(this.tileManager.map.painter), delete this._tiles[e1], r = !0);
        return r;
    }
    releaseRTT(e1) {
        for(let t in this._tiles){
            let n = this._tiles[t];
            (n.tileID.equals(e1) || n.tileID.isChildOf(e1) || e1.isChildOf(n.tileID)) && n.releaseRTT(this.tileManager.map.painter);
        }
    }
    releaseAllRTT() {
        for(let e1 in this._tiles)this._tiles[e1].releaseRTT(this.tileManager.map.painter);
    }
    getRenderableTiles() {
        return this._renderableTilesKeys.map((e1)=>this.getTileByID(e1));
    }
    getTileByID(e1) {
        return this._tiles[e1];
    }
    getTerrainCoords(e1, t) {
        return t ? this._getTerrainCoordsForTileRanges(e1, t) : this._getTerrainCoordsForRegularTile(e1);
    }
    _getTerrainCoordsForRegularTile(e1) {
        let t = {};
        for (let n of this._renderableTilesKeys){
            let r = this._tiles[n].tileID, i = e1.clone(), o = (0, $1G0Uw.Wn)();
            if (r.canonical.equals(e1.canonical)) (0, $1G0Uw.Ti)(o, 0, (0, $1G0Uw.Lr), (0, $1G0Uw.Lr), 0, 0, 1);
            else if (r.canonical.isChildOf(e1.canonical)) {
                let t = r.canonical.z - e1.canonical.z, n = r.canonical.x - (r.canonical.x >> t << t), i = r.canonical.y - (r.canonical.y >> t << t), a = (0, $1G0Uw.Lr) >> t;
                (0, $1G0Uw.Ti)(o, 0, a, a, 0, 0, 1), (0, $1G0Uw.ji)(o, o, [
                    -n * a,
                    -i * a,
                    0
                ]);
            } else if (e1.canonical.isChildOf(r.canonical)) {
                let t = e1.canonical.z - r.canonical.z, n = e1.canonical.x - (e1.canonical.x >> t << t), i = e1.canonical.y - (e1.canonical.y >> t << t), s = (0, $1G0Uw.Lr) >> t;
                (0, $1G0Uw.Ti)(o, 0, (0, $1G0Uw.Lr), (0, $1G0Uw.Lr), 0, 0, 1), (0, $1G0Uw.ji)(o, o, [
                    n * s,
                    i * s,
                    0
                ]), (0, $1G0Uw.Ai)(o, o, [
                    1 / 2 ** t,
                    1 / 2 ** t,
                    0
                ]);
            } else continue;
            i.terrainRttPosMatrix32f = new Float32Array(o), t[n] = i;
        }
        return t;
    }
    _getTerrainCoordsForTileRanges(e1, t) {
        let n = {};
        for (let r of this._renderableTilesKeys){
            let i = this._tiles[r].tileID;
            if (!this._isWithinTileRanges(i, t)) continue;
            let a = e1.clone(), o = (0, $1G0Uw.Wn)();
            if (i.canonical.z === e1.canonical.z) {
                let t = e1.canonical.x - i.canonical.x + e1.wrap * (1 << e1.canonical.z), n = e1.canonical.y - i.canonical.y;
                (0, $1G0Uw.Ti)(o, 0, (0, $1G0Uw.Lr), (0, $1G0Uw.Lr), 0, 0, 1), (0, $1G0Uw.ji)(o, o, [
                    t * (0, $1G0Uw.Lr),
                    n * (0, $1G0Uw.Lr),
                    0
                ]);
            } else if (i.canonical.z > e1.canonical.z) {
                let t = i.canonical.z - e1.canonical.z, n = i.canonical.x - (i.canonical.x >> t << t) + e1.wrap * (1 << i.canonical.z), r = i.canonical.y - (i.canonical.y >> t << t), a = e1.canonical.x - (i.canonical.x >> t), s = e1.canonical.y - (i.canonical.y >> t), c = (0, $1G0Uw.Lr) >> t;
                (0, $1G0Uw.Ti)(o, 0, c, c, 0, 0, 1), (0, $1G0Uw.ji)(o, o, [
                    -n * c + a * (0, $1G0Uw.Lr),
                    -r * c + s * (0, $1G0Uw.Lr),
                    0
                ]);
            } else {
                let t = e1.canonical.z - i.canonical.z, n = e1.canonical.x - (e1.canonical.x >> t << t) + e1.wrap * (1 << e1.canonical.z), r = e1.canonical.y - (e1.canonical.y >> t << t), a = (e1.canonical.x >> t) - i.canonical.x, s = (e1.canonical.y >> t) - i.canonical.y, c = (0, $1G0Uw.Lr) << t;
                (0, $1G0Uw.Ti)(o, 0, c, c, 0, 0, 1), (0, $1G0Uw.ji)(o, o, [
                    n * (0, $1G0Uw.Lr) + a * c,
                    r * (0, $1G0Uw.Lr) + s * c,
                    0
                ]);
            }
            a.terrainRttPosMatrix32f = new Float32Array(o), n[r] = a;
        }
        return n;
    }
    getSourceTile(e1, t) {
        let n = this.tileManager._source, r = e1.overscaledZ - this.deltaZoom;
        if (r > n.maxzoom && (r = n.maxzoom), r < n.minzoom) return;
        this._sourceTileCache[e1.key] ||= e1.scaledTo(r).key;
        let i = this.findTileInCaches(this._sourceTileCache[e1.key]);
        if (!i?.dem && t) for(; r >= n.minzoom && !i?.dem;)i = this.findTileInCaches(e1.scaledTo(r--).key);
        return i;
    }
    findTileInCaches(e1) {
        let t = this.tileManager.getTileByID(e1);
        return t || (t = this.tileManager._outOfViewCache.getByKey(e1), t);
    }
    anyTilesAfterTime(e1 = $4324d99ae8520741$export$461939dd4422153()) {
        return this._lastTilesetChange >= e1;
    }
    _isWithinTileRanges(e1, t) {
        let n = t[e1.canonical.z];
        return !!n && (e1.wrap > n.minWrap || e1.wrap < n.maxWrap || e1.canonical.x >= n.minTileXWrapped && e1.canonical.x <= n.maxTileXWrapped && e1.canonical.y >= n.minTileY && e1.canonical.y <= n.maxTileY);
    }
};
const $4324d99ae8520741$var$hc = (0, $1G0Uw.Lr) * (1 - 1e-12), $4324d99ae8520741$var$gc = -0.5;
var $4324d99ae8520741$var$_c = class {
    constructor(e1, t, n, r = `auto`){
        this._meshCache = {}, this.painter = e1, this.tileManager = new $4324d99ae8520741$var$mc(t), this.options = n, this.exaggeration = typeof n.exaggeration == `number` ? n.exaggeration : 1, this._terrainSkirtLength = r, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = new Map, this._elevationSamplerCache = new Map;
    }
    destroy() {
        this._fbo &&= (this._fbo.destroy(), null), this._fboDepthTexture &&= (this._fboDepthTexture.destroy(), null), this._emptyDemTexture &&= (this._emptyDemTexture.destroy(), null), this._emptyDepthTexture &&= (this._emptyDepthTexture.destroy(), null);
        for(let e1 in this._meshCache)this._meshCache[e1].destroy();
        this._meshCache = {}, this.tileManager.destruct();
    }
    getDEMElevation(e1, t, n, r = (0, $1G0Uw.Lr)) {
        let i = e1.normalizeCoordinates(t, n, r);
        if (!i) return 0;
        let a = this.getElevationSampler(i.tileID);
        return a ? a(i.x, i.y, r) : 0;
    }
    getElevationForLngLatZoom(e1, t) {
        if (!(0, $1G0Uw.h)(t, e1.wrap())) return 0;
        let { tileID: n, mercatorX: r, mercatorY: i } = this._getOverscaledTileIDFromLngLatZoom(e1, t);
        return this.getElevation(n, r % (0, $1G0Uw.Lr), i % (0, $1G0Uw.Lr), (0, $1G0Uw.Lr));
    }
    getElevationForLngLat(e1, t) {
        let n = this.getCoverageIndex();
        if (n) {
            let t = (0, $1G0Uw.nt).fromLngLat(e1), r = $4324d99ae8520741$var$yc(n, this.exaggeration, t.x, t.y);
            if (r.demLoaded) return r.elevation;
        }
        let r = $4324d99ae8520741$var$ko(t, {
            maxzoom: this.tileManager.maxzoom,
            minzoom: this.tileManager.minzoom,
            tileSize: 512,
            terrain: this
        }), i = 0;
        for (let e1 of r)e1.canonical.z > i && (i = Math.min(e1.canonical.z, this.tileManager.maxzoom));
        return this.getElevationForLngLatZoom(e1, i);
    }
    getElevation(e1, t, n, r = (0, $1G0Uw.Lr)) {
        return this.getDEMElevation(e1, t, n, r) * this.exaggeration;
    }
    resetElevationCache() {
        this._elevationSamplerCache.clear(), this._coverageIndex = void 0;
    }
    getCoverageIndex() {
        return this._coverageIndex === void 0 && (this._coverageIndex = this._buildCoverageIndex()), this._coverageIndex;
    }
    _buildCoverageIndex() {
        let e1 = [], t = new Map, n = 0, r = 0;
        for (let i of this.tileManager.getRenderableTiles()){
            if (!i) continue;
            let { canonical: a, wrap: o } = i.tileID;
            e1.includes(a.z) || e1.push(a.z);
            let s = this.getElevationSampler(i.tileID);
            t.set(`${o}/${a.z}/${a.x}/${a.y}`, s);
            let { minElevation: c, maxElevation: l } = this.getMinMaxElevation(i.tileID);
            n = Math.min(n, c ?? 0), r = Math.max(r, l ?? 0);
        }
        return t.size === 0 ? null : (e1.sort((e1, t)=>t - e1), {
            zooms: e1,
            samplerPerTile: t,
            minElevation: n - 10,
            maxElevation: r + 10
        });
    }
    getElevationSampler(e1) {
        let t = e1.key, n = this._elevationSamplerCache.get(t);
        if (n) return n;
        let r = this.tileManager.getSourceTile(e1, !0), i = r?.dem;
        if (!r || !i) return null;
        let a = this._getDEMTileMatrix(e1, r), o = a[0] * i.dim, s = a[5] * i.dim, c = a[12] * i.dim + $4324d99ae8520741$var$gc, l = a[13] * i.dim + $4324d99ae8520741$var$gc, u = (e1, t, n)=>{
            let r = n === 8192 ? 1 : (0, $1G0Uw.Lr) / n;
            return i.sampleBilinear(e1 * r * o + c, t * r * s + l);
        };
        return this._elevationSamplerCache.set(t, u), u;
    }
    _getDEMTileMatrix(e1, t) {
        let n = `${t.tileID.key}/${e1.key}`, r = this._demMatrixCache.get(n);
        if (r) return r;
        let i = e1.canonical.z - t.tileID.canonical.z, a = e1.canonical.x - (e1.canonical.x >> i << i), o = e1.canonical.y - (e1.canonical.y >> i << i), s = (0, $1G0Uw.xi)(new Float64Array(16), [
            1 / ((0, $1G0Uw.Lr) << i),
            1 / ((0, $1G0Uw.Lr) << i),
            0
        ]);
        return (0, $1G0Uw.ji)(s, s, [
            a * (0, $1G0Uw.Lr),
            o * (0, $1G0Uw.Lr),
            0
        ]), this._demMatrixCache.set(n, s), s;
    }
    getTerrainData(e1) {
        if (!this._emptyDemTexture) {
            let e1 = this.painter.context, t = new (0, $1G0Uw.Dt)({
                width: 1,
                height: 1
            }, new Uint8Array(4));
            this._emptyDepthTexture = new (0, $1G0Uw.xt)(e1, t, e1.gl.RGBA, {
                premultiply: !1
            }), this._emptyDemUnpack = [
                0,
                0,
                0,
                0
            ], this._emptyDemTexture = new (0, $1G0Uw.xt)(e1, new (0, $1G0Uw.Dt)({
                width: 1,
                height: 1
            }), e1.gl.RGBA, {
                premultiply: !1
            }), this._emptyDemTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = (0, $1G0Uw.Si)([]);
        }
        let t = this.tileManager.getSourceTile(e1, !0);
        if (t?.dem && (!t.demTexture || t.needsTerrainPrepare)) {
            let e1 = this.painter.context;
            t.demTexture ||= this.painter.getTileTexture(t.dem.stride), t.demTexture ? t.demTexture.update(t.dem.getPixels(), {
                premultiply: !1
            }) : t.demTexture = new (0, $1G0Uw.xt)(e1, t.dem.getPixels(), e1.gl.RGBA, {
                premultiply: !1
            }), t.demTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), t.needsTerrainPrepare = !1;
        }
        let n = t ? this._getDEMTileMatrix(e1, t) : this._emptyDemMatrix;
        return {
            u_depth: 2,
            u_terrain: 3,
            u_terrain_dim: t?.dem?.dim || 1,
            u_terrain_matrix: n,
            u_terrain_unpack: t?.dem?.getUnpackVector() || this._emptyDemUnpack,
            u_terrain_exaggeration: this.exaggeration,
            texture: (t?.demTexture || this._emptyDemTexture).texture,
            depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
            tile: t
        };
    }
    getFramebuffer() {
        let e1 = this.painter, t = e1.width / devicePixelRatio, n = e1.height / devicePixelRatio;
        return this._fbo && (this._fbo.width !== t || this._fbo.height !== n) && (this._fbo.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture), this._fboDepthTexture || (this._fboDepthTexture = new (0, $1G0Uw.xt)(e1.context, {
            width: t,
            height: n,
            data: null
        }, e1.context.gl.RGBA, {
            premultiply: !1
        }), this._fboDepthTexture.bind(e1.context.gl.NEAREST, e1.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = e1.context.createFramebuffer(t, n, !0, !1), this._fbo.depthAttachment.set(e1.context.createRenderbuffer(e1.context.gl.DEPTH_COMPONENT16, t, n))), this._fbo.colorAttachment.set(this._fboDepthTexture.texture), this._fbo;
    }
    depthAtPoint(e1) {
        let t = new Uint8Array(4), n = this.painter.context, r = n.gl;
        return n.bindFramebuffer.set(this.getFramebuffer().framebuffer), r.readPixels(e1.x, this.painter.height / devicePixelRatio - e1.y - 1, 1, 1, r.RGBA, r.UNSIGNED_BYTE, t), n.bindFramebuffer.set(null), (t[0] / 16777216 + t[1] / 65536 + t[2] / 256 + t[3]) / 256;
    }
    getTerrainMesh(e1) {
        let t = this.painter.style.projection?.transitionState > 0, n = t && e1.canonical.y === 0, r = t && e1.canonical.y === (1 << e1.canonical.z) - 1, i = `m_${n ? `n` : ``}_${r ? `s` : ``}`;
        if (this._meshCache[i]) return this._meshCache[i];
        let a = this.painter.context, o = new (0, $1G0Uw.Wt), s = new (0, $1G0Uw.Jt), c = this.meshSize, l = (0, $1G0Uw.Lr) / c, u = c * c;
        for(let e1 = 0; e1 <= c; e1++)for(let t = 0; t <= c; t++)o.emplaceBack(t * l, e1 * l, 0);
        for(let e1 = 0; e1 < u; e1 += c + 1)for(let t = 0; t < c; t++)s.emplaceBack(t + e1, c + t + e1 + 1, c + t + e1 + 2), s.emplaceBack(t + e1, c + t + e1 + 2, t + e1 + 1);
        this._terrainSkirtLength !== `none` && this._buildSkirts(o, s, c, l, n, r);
        let d = new $4324d99ae8520741$var$Ua(a.createVertexBuffer(o, $4324d99ae8520741$var$pc.members), a.createIndexBuffer(s), (0, $1G0Uw.Bt).simpleSegment(0, 0, o.length, s.length));
        return this._meshCache[i] = d, d;
    }
    getSkirtLength(e1) {
        return 2 * Math.PI * (0, $1G0Uw.ut) / 2 ** Math.max(e1, 0) / 5;
    }
    getMinTileElevationForLngLatZoom(e1, t) {
        if (!(0, $1G0Uw.h)(t, e1.wrap())) return 0;
        let { tileID: n } = this._getOverscaledTileIDFromLngLatZoom(e1, t);
        return this.getMinMaxElevation(n).minElevation ?? 0;
    }
    getMinMaxElevation(e1) {
        let t = this.tileManager.getSourceTile(e1, !0), n = {
            minElevation: null,
            maxElevation: null
        };
        return t?.dem && (n.minElevation = t.dem.min * this.exaggeration, n.maxElevation = t.dem.max * this.exaggeration), n;
    }
    _getOverscaledTileIDFromLngLatZoom(e1, t) {
        let n = (0, $1G0Uw.nt).fromLngLat(e1.wrap()), r = (1 << t) * (0, $1G0Uw.Lr), i = n.x * r, a = n.y * r, o = Math.floor(i / (0, $1G0Uw.Lr)), s = Math.floor(a / (0, $1G0Uw.Lr));
        return {
            tileID: new (0, $1G0Uw.d)(t, 0, t, o, s),
            mercatorX: i,
            mercatorY: a
        };
    }
    _buildSkirts(e1, t, n, r, i, a) {
        let o = e1.length, s = o + (n + 1), c = (n + 1) * n, l = i ? (0, $1G0Uw.ht) : 0, u = +!i, d = a ? (0, $1G0Uw.gt) : (0, $1G0Uw.Lr), f = +!a;
        for(let t = 0; t <= n; t++)e1.emplaceBack(t * r, l, u);
        for(let t = 0; t <= n; t++)e1.emplaceBack(t * r, d, f);
        for(let e1 = 0; e1 < n; e1++)t.emplaceBack(c + e1, s + e1, s + e1 + 1), t.emplaceBack(c + e1, s + e1 + 1, c + e1 + 1), t.emplaceBack(0 + e1, o + e1 + 1, o + e1), t.emplaceBack(0 + e1, 0 + e1 + 1, o + e1 + 1);
        let p = e1.length, m = p + (n + 1) * 2;
        for (let t of [
            0,
            1
        ])for(let i = 0; i <= n; i++)for (let n of [
            0,
            1
        ])e1.emplaceBack(t * (0, $1G0Uw.Lr), i * r, n);
        for(let e1 = 0; e1 < n * 2; e1 += 2)t.emplaceBack(p + e1, p + e1 + 1, p + e1 + 3), t.emplaceBack(p + e1, p + e1 + 3, p + e1 + 2), t.emplaceBack(m + e1, m + e1 + 3, m + e1 + 1), t.emplaceBack(m + e1, m + e1 + 2, m + e1 + 3);
    }
};
const $4324d99ae8520741$var$vc = {
    covered: !1,
    demLoaded: !1,
    elevation: 0
};
function $4324d99ae8520741$var$yc(e1, t, n, r) {
    if (r < 0 || r >= 1) return $4324d99ae8520741$var$vc;
    let i = Math.floor(n), a = n - i;
    for (let n of e1.zooms){
        let o = 1 << n, s = a * o, c = r * o, l = Math.floor(s), u = Math.floor(c), d = `${i}/${n}/${l}/${u}`;
        if (!e1.samplerPerTile.has(d)) continue;
        let f = e1.samplerPerTile.get(d);
        return f ? {
            covered: !0,
            demLoaded: !0,
            elevation: f(Math.min((s - l) * (0, $1G0Uw.Lr), $4324d99ae8520741$var$hc), Math.min((c - u) * (0, $1G0Uw.Lr), $4324d99ae8520741$var$hc), (0, $1G0Uw.Lr)) * t
        } : {
            covered: !0,
            demLoaded: !1,
            elevation: 0
        };
    }
    return $4324d99ae8520741$var$vc;
}
function $4324d99ae8520741$var$bc(e1, t) {
    return e1.covered && t <= e1.elevation + 1e-6;
}
function $4324d99ae8520741$var$xc(e1, t, n, r, i) {
    for(let a = 0; a < 40 && r - n > i; a++){
        let i = (n + r) / 2;
        t(e1, i) ? r = i : n = i;
    }
    return {
        lo: n,
        hi: r
    };
}
var $4324d99ae8520741$var$Sc = class t {
    get pixelsToClipSpaceMatrix() {
        return this._helper.pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._helper.clipSpaceToPixelsMatrix;
    }
    get pixelsToGLUnits() {
        return this._helper.pixelsToGLUnits;
    }
    get centerOffset() {
        return this._helper.centerOffset;
    }
    get size() {
        return this._helper.size;
    }
    get rotationMatrix() {
        return this._helper.rotationMatrix;
    }
    get centerPoint() {
        return this._helper.centerPoint;
    }
    get pixelsPerMeter() {
        return this._helper.pixelsPerMeter;
    }
    setMinZoom(e1) {
        this._helper.setMinZoom(e1);
    }
    setMaxZoom(e1) {
        this._helper.setMaxZoom(e1);
    }
    setMinPitch(e1) {
        this._helper.setMinPitch(e1);
    }
    setMaxPitch(e1) {
        this._helper.setMaxPitch(e1);
    }
    setRenderWorldCopies(e1) {
        this._helper.setRenderWorldCopies(e1);
    }
    setBearing(e1) {
        this._helper.setBearing(e1);
    }
    setPitch(e1) {
        this._helper.setPitch(e1);
    }
    setRoll(e1) {
        this._helper.setRoll(e1);
    }
    setFov(e1) {
        this._helper.setFov(e1);
    }
    setZoom(e1) {
        this._helper.setZoom(e1);
    }
    setCenter(e1) {
        this._helper.setCenter(e1);
    }
    setElevation(e1) {
        this._helper.setElevation(e1);
    }
    setMinElevationForCurrentTile(e1) {
        this._helper.setMinElevationForCurrentTile(e1);
    }
    setPadding(e1) {
        this._helper.setPadding(e1);
    }
    interpolatePadding(e1, t, n) {
        this._helper.interpolatePadding(e1, t, n);
    }
    isPaddingEqual(e1) {
        return this._helper.isPaddingEqual(e1);
    }
    resize(e1, t, n = !0) {
        this._helper.resize(e1, t, n);
    }
    getMaxBounds() {
        return this._helper.getMaxBounds();
    }
    setMaxBounds(e1) {
        this._helper.setMaxBounds(e1);
    }
    setConstrainOverride(e1) {
        this._helper.setConstrainOverride(e1);
    }
    overrideNearFarZ(e1, t) {
        this._helper.overrideNearFarZ(e1, t);
    }
    clearNearFarZOverride() {
        this._helper.clearNearFarZOverride();
    }
    getCameraQueryGeometry(e1) {
        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
    }
    get tileSize() {
        return this._helper.tileSize;
    }
    get tileZoom() {
        return this._helper.tileZoom;
    }
    get scale() {
        return this._helper.scale;
    }
    get worldSize() {
        return this._helper.worldSize;
    }
    get width() {
        return this._helper.width;
    }
    get height() {
        return this._helper.height;
    }
    get lngRange() {
        return this._helper.lngRange;
    }
    get latRange() {
        return this._helper.latRange;
    }
    get minZoom() {
        return this._helper.minZoom;
    }
    get maxZoom() {
        return this._helper.maxZoom;
    }
    get zoom() {
        return this._helper.zoom;
    }
    get center() {
        return this._helper.center;
    }
    get minPitch() {
        return this._helper.minPitch;
    }
    get maxPitch() {
        return this._helper.maxPitch;
    }
    get pitch() {
        return this._helper.pitch;
    }
    get pitchInRadians() {
        return this._helper.pitchInRadians;
    }
    get roll() {
        return this._helper.roll;
    }
    get rollInRadians() {
        return this._helper.rollInRadians;
    }
    get bearing() {
        return this._helper.bearing;
    }
    get bearingInRadians() {
        return this._helper.bearingInRadians;
    }
    get fov() {
        return this._helper.fov;
    }
    get fovInRadians() {
        return this._helper.fovInRadians;
    }
    get elevation() {
        return this._helper.elevation;
    }
    get minElevationForCurrentTile() {
        return this._helper.minElevationForCurrentTile;
    }
    get padding() {
        return this._helper.padding;
    }
    get unmodified() {
        return this._helper.unmodified;
    }
    get renderWorldCopies() {
        return this._helper.renderWorldCopies;
    }
    get cameraToCenterDistance() {
        return this._helper.cameraToCenterDistance;
    }
    get constrainOverride() {
        return this._helper.constrainOverride;
    }
    get nearZ() {
        return this._helper.nearZ;
    }
    get farZ() {
        return this._helper.farZ;
    }
    get autoCalculateNearFarZ() {
        return this._helper.autoCalculateNearFarZ;
    }
    setTransitionState(e1) {}
    constructor(t){
        this._posMatrixCache = new Map, this._alignedPosMatrixCache = new Map, this._fogMatrixCacheF32 = new Map, this.defaultConstrain = (t, n)=>{
            n = (0, $1G0Uw.Bn)(+n, this.minZoom, this.maxZoom);
            let r = {
                center: new (0, $1G0Uw.lt)(t.lng, t.lat),
                zoom: n
            }, i = this._helper._lngRange;
            !this._helper._renderWorldCopies && i === null && (i = [
                -179.9999999999,
                180 - 1e-10
            ]);
            let a = this.tileSize * (0, $1G0Uw.Fr)(r.zoom), o = 0, s = a, c = 0, l = a, d = 0, f = 0, { x: p, y: m } = this.size;
            if (this._helper._latRange) {
                let e1 = this._helper._latRange;
                o = (0, $1G0Uw.st)(e1[1]) * a, s = (0, $1G0Uw.st)(e1[0]) * a, s - o < m && (d = m / (s - o));
            }
            i && (c = (0, $1G0Uw.Pr)((0, $1G0Uw.ot)(i[0]) * a, 0, a), l = (0, $1G0Uw.Pr)((0, $1G0Uw.ot)(i[1]) * a, 0, a), l < c && (l += a), l - c < p && (f = p / (l - c)));
            let { x: h, y: g } = (0, $1G0Uw.$)(a, t), _, v, y = Math.max(f || 0, d || 0);
            if (y) {
                let e1 = new (0, $1G0Uw.Li)(f ? (l + c) / 2 : h, d ? (s + o) / 2 : g);
                return r.center = (0, $1G0Uw.tt)(a, e1).wrap(), r.zoom += (0, $1G0Uw.Dr)(y), r;
            }
            if (this._helper._latRange) {
                let e1 = m / 2;
                g - e1 < o && (v = o + e1), g + e1 > s && (v = s - e1);
            }
            if (i) {
                let e1 = (c + l) / 2, t = h;
                this._helper._renderWorldCopies && (t = (0, $1G0Uw.Pr)(h, e1 - a / 2, e1 + a / 2));
                let n = p / 2;
                t - n < c && (_ = c + n), t + n > l && (_ = l - n);
            }
            if (_ !== void 0 || v !== void 0) {
                let e1 = new (0, $1G0Uw.Li)(_ ?? h, v ?? g);
                r.center = (0, $1G0Uw.tt)(a, e1).wrap();
            }
            return r;
        }, this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new $4324d99ae8520741$var$dc({
            calcMatrices: ()=>this._calcMatrices(),
            defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
        }, t), this._coveringTilesDetailsProvider = new $4324d99ae8520741$var$fc;
    }
    clone() {
        let e1 = new t;
        return e1.apply(this, !1), e1;
    }
    apply(e1, t, n) {
        this._helper.apply(e1, t, n);
    }
    get cameraPosition() {
        return this._cameraPosition;
    }
    get projectionMatrix() {
        return this._projectionMatrix;
    }
    get modelViewProjectionMatrix() {
        return this._viewProjMatrix;
    }
    get inverseProjectionMatrix() {
        return this._invProjMatrix;
    }
    get mercatorMatrix() {
        return this._mercatorMatrix;
    }
    getVisibleUnwrappedCoordinates(e1) {
        let t = [
            new (0, $1G0Uw.f)(0, e1)
        ];
        if (this._helper._renderWorldCopies) {
            let n = this.screenPointToMercatorCoordinate(new (0, $1G0Uw.Li)(0, 0)), r = this.screenPointToMercatorCoordinate(new (0, $1G0Uw.Li)(this._helper._width, 0)), i = this.screenPointToMercatorCoordinate(new (0, $1G0Uw.Li)(this._helper._width, this._helper._height)), a = this.screenPointToMercatorCoordinate(new (0, $1G0Uw.Li)(0, this._helper._height)), o = Math.floor(Math.min(n.x, r.x, i.x, a.x)), s = Math.floor(Math.max(n.x, r.x, i.x, a.x));
            for(let n = o - 1; n <= s + 1; n++)n !== 0 && t.push(new (0, $1G0Uw.f)(n, e1));
        }
        return t;
    }
    getCameraFrustum() {
        return $4324d99ae8520741$var$_o.fromInvProjectionMatrix(this._invViewProjMatrix, this.worldSize);
    }
    getClippingPlane() {
        return null;
    }
    getCoveringTilesDetailsProvider() {
        return this._coveringTilesDetailsProvider;
    }
    recalculateZoomAndCenter(e1) {
        let t = this.screenPointToLocation(this.centerPoint, e1), n = e1 ? e1.getElevationForLngLat(t, this) : 0;
        this._helper.recalculateZoomAndCenter(n);
    }
    setLocationAtPoint(e1, t, n = this.elevation) {
        let r = n - this.elevation, i = this.screenPointToMercatorCoordinateAtZ(t, r), a = this.screenPointToMercatorCoordinateAtZ(this.centerPoint, 0), o = (0, $1G0Uw.nt).fromLngLat(e1), s = new (0, $1G0Uw.nt)(o.x - (i.x - a.x), o.y - (i.y - a.y));
        this.setCenter(s?.toLngLat()), this._helper._renderWorldCopies && this.setCenter(this.center.wrap());
    }
    locationToScreenPoint(e1, t) {
        return t ? this.coordinatePoint((0, $1G0Uw.nt).fromLngLat(e1), t.getElevationForLngLat(e1, this), this._pixelMatrix3D) : this.coordinatePoint((0, $1G0Uw.nt).fromLngLat(e1));
    }
    screenPointToLocation(e1, t) {
        return this.screenPointToMercatorCoordinate(e1, t)?.toLngLat();
    }
    screenPointToLocationAtElevation(e1, t) {
        return this.screenPointToMercatorCoordinateAtZ(e1, t - this.elevation)?.toLngLat();
    }
    screenPointToMercatorCoordinate(e1, t) {
        if (t) {
            let n = this.screenTerrainPointToMercatorCoordinate(e1, t);
            if (n != null) return n;
        }
        return this.screenPointToMercatorCoordinateAtZ(e1);
    }
    screenTerrainPointToMercatorCoordinate(e1, t) {
        let n = t.getCoverageIndex();
        if (!n) return null;
        let { near: r, far: i } = this.getRaySegmentFromPixel(e1), a = this.worldSize, o = i[0] - r[0], s = i[1] - r[1], c = i[2] - r[2], l = {
            index: n,
            exaggeration: t.exaggeration,
            near: r,
            dx: o,
            dy: s,
            dz: c,
            worldSize: a
        }, d = 0, f = 1;
        if (c === 0) {
            if (r[2] > n.maxElevation || r[2] < n.minElevation) return null;
        } else {
            let e1 = (n.maxElevation - r[2]) / c, t = (n.minElevation - r[2]) / c;
            if (d = Math.max(d, Math.min(e1, t)), f = Math.min(f, Math.max(e1, t)), d > f) return null;
        }
        let p = Math.hypot(o, s), m = (0, $1G0Uw.Bn)(Math.ceil(p * (f - d) / 4), 1, 512), h = 0, g = !$4324d99ae8520741$var$wc(l, 0);
        for(let e1 = 0; e1 <= m; e1++){
            let t = d + (f - d) * e1 / m;
            if (!g) g = !$4324d99ae8520741$var$wc(l, t);
            else if ($4324d99ae8520741$var$wc(l, t)) {
                let { lo: e1, hi: n } = $4324d99ae8520741$var$xc(l, $4324d99ae8520741$var$wc, h, t, .001 / p), i = $4324d99ae8520741$var$Cc(l, e1), d = $4324d99ae8520741$var$Cc(l, n), f = r[2] + e1 * c - i.elevation, m = r[2] + n * c - d.elevation, g = i.covered && f > m ? (0, $1G0Uw.Bn)(e1 + f * (n - e1) / (f - m), e1, n) : n;
                return new (0, $1G0Uw.nt)((r[0] + g * o) / a, (r[1] + g * s) / a, $4324d99ae8520741$var$Cc(l, g).elevation);
            }
            h = t;
        }
        return null;
    }
    getRaySegmentFromPixel(e1) {
        let t = [
            e1.x,
            e1.y,
            0,
            1
        ], n = [
            e1.x,
            e1.y,
            1,
            1
        ];
        (0, $1G0Uw.Yr)(t, t, this._pixelMatrixInverse), (0, $1G0Uw.Yr)(n, n, this._pixelMatrixInverse);
        let r = t[3], i = n[3], a = this.elevation;
        return {
            near: [
                t[0] / r,
                t[1] / r,
                t[2] / r + a
            ],
            far: [
                n[0] / i,
                n[1] / i,
                n[2] / i + a
            ]
        };
    }
    screenPointToMercatorCoordinateAtZ(e1, t) {
        let n = t || 0, { near: r, far: i } = this.getRaySegmentFromPixel(e1), a = r[2] === i[2] ? 0 : (n + this.elevation - r[2]) / (i[2] - r[2]);
        return new (0, $1G0Uw.nt)((0, $1G0Uw.un).number(r[0], i[0], a) / this.worldSize, (0, $1G0Uw.un).number(r[1], i[1], a) / this.worldSize, n);
    }
    coordinatePoint(e1, t = 0, n = this._pixelMatrix) {
        let r = [
            e1.x * this.worldSize,
            e1.y * this.worldSize,
            t,
            1
        ];
        (0, $1G0Uw.Yr)(r, r, n);
        let i = r[3];
        return i > 0 ? new (0, $1G0Uw.Li)(r[0] / i, r[1] / i) : this._offScreenPointBehindCamera(r[0], r[1], i);
    }
    _offScreenPointBehindCamera(e1, t, n) {
        let r = this.width / 2, i = this.height / 2, a = e1 - r * n, o = t - i * n;
        a === 0 && o === 0 && (o = 1);
        let s = r + this.width, c = i + this.height, l = Math.min(a === 0 ? 1 / 0 : s / Math.abs(a), o === 0 ? 1 / 0 : c / Math.abs(o));
        return new (0, $1G0Uw.Li)(r + a * l, i + o * l);
    }
    getBounds() {
        let e1 = Math.max(0, this._helper._height / 2 - (0, $1G0Uw.Z)(this));
        return new $4324d99ae8520741$export$266d2884f61535d3().extend(this.screenPointToLocation(new (0, $1G0Uw.Li)(0, e1))).extend(this.screenPointToLocation(new (0, $1G0Uw.Li)(this._helper._width, e1))).extend(this.screenPointToLocation(new (0, $1G0Uw.Li)(this._helper._width, this._helper._height))).extend(this.screenPointToLocation(new (0, $1G0Uw.Li)(0, this._helper._height)));
    }
    isPointOnMapSurface(e1, t) {
        return t ? this.screenTerrainPointToMercatorCoordinate(e1, t) != null : e1.y > this.height / 2 - (0, $1G0Uw.Z)(this);
    }
    calculatePosMatrix(e1, t = !1, n = !1) {
        let r = e1.key ?? (0, $1G0Uw.p)(e1.wrap, e1.canonical.z, e1.canonical.z, e1.canonical.x, e1.canonical.y), i = t ? this._alignedPosMatrixCache : this._posMatrixCache;
        if (i.has(r)) {
            let e1 = i.get(r);
            return n ? e1.f32 : e1.f64;
        }
        let a = (0, $1G0Uw.q)(e1, this.worldSize);
        (0, $1G0Uw.wi)(a, t ? this._alignedProjMatrix : this._viewProjMatrix, a);
        let o = {
            f64: a,
            f32: new Float32Array(a)
        };
        return i.set(r, o), n ? o.f32 : o.f64;
    }
    calculateFogMatrix(e1) {
        let t = e1.key, n = this._fogMatrixCacheF32;
        if (n.has(t)) return n.get(t);
        let r = (0, $1G0Uw.q)(e1, this.worldSize);
        return (0, $1G0Uw.wi)(r, this._fogMatrix, r), n.set(t, new Float32Array(r)), n.get(t);
    }
    calculateCenterFromCameraLngLatAlt(e1, t, n, r) {
        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, n, r);
    }
    calculateCameraOptionsFromTo(e1, t, n, r) {
        let i = (0, $1G0Uw.nt).fromLngLat(e1, t), a = (0, $1G0Uw.nt).fromLngLat(n, r), o = a.x - i.x, s = a.y - i.y, c = a.z - i.z, l = Math.hypot(o, s, c);
        if (l === 0) throw Error(`Can't calculate camera options with same From and To`);
        let u = Math.hypot(o, s), d = (0, $1G0Uw.Dr)(this.cameraToCenterDistance / l / this.tileSize), f = (0, $1G0Uw.xr)(Math.atan2(o, -s)), p = (0, $1G0Uw.xr)(Math.acos(u / l));
        return p = c < 0 ? 90 - p : 90 + p, {
            center: a.toLngLat(),
            elevation: r,
            zoom: d,
            pitch: p,
            bearing: f
        };
    }
    _calculateNearFarZIfNeeded(e1, t, n) {
        if (!this._helper.autoCalculateNearFarZ) return;
        let r = Math.min(this.elevation, this.minElevationForCurrentTile, this.getCameraAltitude() - 100), i = e1 - r * this._helper._pixelPerMeter / Math.cos(t), a = r < 0 ? i : e1, o = Math.PI / 2 + this.pitchInRadians, s = (0, $1G0Uw.Yn)(this.fov) * (Math.abs(Math.cos((0, $1G0Uw.Yn)(this.roll))) * this.height + Math.abs(Math.sin((0, $1G0Uw.Yn)(this.roll))) * this.width) / this.height * (.5 + n.y / this.height), c = Math.sin(s) * a / Math.sin((0, $1G0Uw.Bn)(Math.PI - o - s, .01, Math.PI - .01)), l = (0, $1G0Uw.Z)(this), d = Math.atan(l / this._helper.cameraToCenterDistance), f = (0, $1G0Uw.Yn)(90 - (0, $1G0Uw.Q)), p = d > f ? 2 * d * (.5 + n.y / (l * 2)) : f, m = Math.sin(p) * a / Math.sin((0, $1G0Uw.Bn)(Math.PI - o - p, .01, Math.PI - .01)), h = Math.min(c, m);
        this._helper._farZ = (Math.cos(Math.PI / 2 - t) * h + a) * 1.01, this._helper._nearZ = this._helper._height / 50;
    }
    _calcMatrices() {
        let t = this.centerOffset, n = (0, $1G0Uw.$)(this.worldSize, this.center), r = n.x, i = n.y, o = (0, $1G0Uw.Yn)(Math.min(this.pitch, (0, $1G0Uw.Q))), s = Math.max(this._helper.cameraToCenterDistance / 2, this._helper.cameraToCenterDistance + this._helper._elevation * this._helper._pixelPerMeter / Math.cos(o));
        this._calculateNearFarZIfNeeded(s, o, t);
        let c;
        c = new Float64Array(16), (0, $1G0Uw.Ei)(c, this.fovInRadians, this._helper._width / this._helper._height, this._helper._nearZ, this._helper._farZ), this._invProjMatrix = new Float64Array(16), $4324d99ae8520741$var$Ko(this._invProjMatrix, c), c[8] = -t.x * 2 / this._helper._width, c[9] = t.y * 2 / this._helper._height, this._projectionMatrix = (0, $1G0Uw.gi)(c), (0, $1G0Uw.Ai)(c, c, [
            1,
            -1,
            1
        ]), (0, $1G0Uw.ji)(c, c, [
            0,
            0,
            -this._helper.cameraToCenterDistance
        ]), (0, $1G0Uw.ki)(c, c, -this.rollInRadians), (0, $1G0Uw.Di)(c, c, this.pitchInRadians), (0, $1G0Uw.ki)(c, c, -this.bearingInRadians), (0, $1G0Uw.ji)(c, c, [
            -r,
            -i,
            0
        ]), this._mercatorMatrix = (0, $1G0Uw.Ai)([], c, [
            this.worldSize,
            this.worldSize,
            this.worldSize
        ]), (0, $1G0Uw.Ai)(c, c, [
            1,
            1,
            this._helper._pixelPerMeter
        ]), this._pixelMatrix = (0, $1G0Uw.wi)(new Float64Array(16), this.clipSpaceToPixelsMatrix, c), (0, $1G0Uw.ji)(c, c, [
            0,
            0,
            -this.elevation
        ]), this._viewProjMatrix = c, this._invViewProjMatrix = (0, $1G0Uw.Ci)([], c);
        let l = [
            0,
            0,
            -1,
            1
        ];
        (0, $1G0Uw.Yr)(l, l, this._invViewProjMatrix), this._cameraPosition = [
            l[0] / l[3],
            l[1] / l[3],
            l[2] / l[3]
        ], this._fogMatrix = new Float64Array(16), (0, $1G0Uw.Ei)(this._fogMatrix, this.fovInRadians, this.width / this.height, s, this._helper._farZ), this._fogMatrix[8] = -t.x * 2 / this.width, this._fogMatrix[9] = t.y * 2 / this.height, (0, $1G0Uw.Ai)(this._fogMatrix, this._fogMatrix, [
            1,
            -1,
            1
        ]), (0, $1G0Uw.ji)(this._fogMatrix, this._fogMatrix, [
            0,
            0,
            -this.cameraToCenterDistance
        ]), (0, $1G0Uw.ki)(this._fogMatrix, this._fogMatrix, -this.rollInRadians), (0, $1G0Uw.Di)(this._fogMatrix, this._fogMatrix, this.pitchInRadians), (0, $1G0Uw.ki)(this._fogMatrix, this._fogMatrix, -this.bearingInRadians), (0, $1G0Uw.ji)(this._fogMatrix, this._fogMatrix, [
            -r,
            -i,
            0
        ]), (0, $1G0Uw.Ai)(this._fogMatrix, this._fogMatrix, [
            1,
            1,
            this._helper._pixelPerMeter
        ]), (0, $1G0Uw.ji)(this._fogMatrix, this._fogMatrix, [
            0,
            0,
            -this.elevation
        ]), this._pixelMatrix3D = (0, $1G0Uw.wi)(new Float64Array(16), this.clipSpaceToPixelsMatrix, c);
        let u = this._helper._width % 2 / 2, d = this._helper._height % 2 / 2, f = Math.cos(this.bearingInRadians), p = Math.sin(-this.bearingInRadians), h = r - Math.round(r) + f * u + p * d, g = i - Math.round(i) + f * d + p * u, _ = new Float64Array(c);
        if ((0, $1G0Uw.ji)(_, _, [
            h > .5 ? h - 1 : h,
            g > .5 ? g - 1 : g,
            0
        ]), this._alignedProjMatrix = _, c = (0, $1G0Uw.Ci)(new Float64Array(16), this._pixelMatrix), !c) throw Error(`failed to invert matrix`);
        this._pixelMatrixInverse = c, this._clearMatrixCaches();
    }
    _clearMatrixCaches() {
        this._posMatrixCache.clear(), this._alignedPosMatrixCache.clear(), this._fogMatrixCacheF32.clear();
    }
    maxPitchScaleFactor() {
        if (!this._pixelMatrixInverse) return 1;
        let e1 = this.screenPointToMercatorCoordinate(new (0, $1G0Uw.Li)(0, 0)), t = [
            e1.x * this.worldSize,
            e1.y * this.worldSize,
            0,
            1
        ];
        return (0, $1G0Uw.Yr)(t, t, this._pixelMatrix)[3] / this._helper.cameraToCenterDistance;
    }
    getCameraPoint() {
        return this._helper.getCameraPoint();
    }
    getCameraAltitude() {
        return Math.cos(this.pitchInRadians) * this.cameraToCenterDistance / this.pixelsPerMeter + this.elevation;
    }
    getCameraLngLat() {
        let e1 = (0, $1G0Uw.ct)(1, this.center.lat) * this.worldSize, t = this._helper.cameraToCenterDistance / e1;
        return (0, $1G0Uw.X)(this.center, this.elevation, this.pitch, this.bearing, t).toLngLat();
    }
    lngLatToCameraDepth(e1, t) {
        let n = (0, $1G0Uw.nt).fromLngLat(e1), r = [
            n.x * this.worldSize,
            n.y * this.worldSize,
            t,
            1
        ];
        return (0, $1G0Uw.Yr)(r, r, this._viewProjMatrix), r[2] / r[3];
    }
    getProjectionData(e1) {
        let { overscaledTileID: t, aligned: n, applyTerrainMatrix: r } = e1, i = this._helper.getMercatorTileCoordinates(t), a = t ? this.calculatePosMatrix(t, n, !0) : null, o;
        return o = t?.terrainRttPosMatrix32f && r ? t.terrainRttPosMatrix32f : a || (0, $1G0Uw.Hn)(), {
            mainMatrix: o,
            tileMercatorCoords: i,
            clippingPlane: [
                0,
                0,
                0,
                0
            ],
            projectionTransition: 0,
            fallbackMatrix: o,
            clipAntimeridian: !1
        };
    }
    isLocationOccluded(e1) {
        return !1;
    }
    getPixelScale() {
        return 1;
    }
    getCircleRadiusCorrection() {
        return 1;
    }
    getPitchedTextCorrection(e1, t, n) {
        return 1;
    }
    transformLightDirection(e1) {
        return (0, $1G0Uw.Zr)(e1);
    }
    getRayDirectionFromPixel(e1) {
        throw Error(`Not implemented.`);
    }
    projectTileCoordinates(e1, t, n, r) {
        let i = this.calculatePosMatrix(n), a;
        r == null ? (a = [
            e1,
            t,
            0,
            1
        ], $4324d99ae8520741$var$gs(a, a, i)) : (a = [
            e1,
            t,
            r,
            1
        ], (0, $1G0Uw.Yr)(a, a, i));
        let o = a[3];
        return {
            point: new (0, $1G0Uw.Li)(a[0] / o, a[1] / o),
            signedDistanceFromCamera: o,
            isOccluded: !1
        };
    }
    populateCache(e1) {
        for (let t of e1)this.calculatePosMatrix(t);
    }
    getProjectionDataForCustomLayer(e1 = !0) {
        let t = new (0, $1G0Uw.d)(0, 0, 0, 0, 0), n = this.getProjectionData({
            overscaledTileID: t,
            applyGlobeMatrix: e1
        }), r = (0, $1G0Uw.q)(t, this.worldSize);
        (0, $1G0Uw.wi)(r, this._viewProjMatrix, r);
        let i = [
            (0, $1G0Uw.Lr),
            (0, $1G0Uw.Lr),
            this.worldSize / this._helper.pixelsPerMeter
        ], o = (0, $1G0Uw.Wn)();
        return (0, $1G0Uw.Ai)(o, r, i), {
            ...n,
            tileMercatorCoords: [
                0,
                0,
                1,
                1
            ],
            fallbackMatrix: o,
            mainMatrix: o
        };
    }
    getFastPathSimpleProjectionMatrix(e1) {
        return this.calculatePosMatrix(e1);
    }
};
function $4324d99ae8520741$var$Cc(e1, t) {
    return $4324d99ae8520741$var$yc(e1.index, e1.exaggeration, (e1.near[0] + t * e1.dx) / e1.worldSize, (e1.near[1] + t * e1.dy) / e1.worldSize);
}
function $4324d99ae8520741$var$wc(e1, t) {
    return $4324d99ae8520741$var$bc($4324d99ae8520741$var$Cc(e1, t), e1.near[2] + t * e1.dz);
}
function $4324d99ae8520741$var$Tc() {
    (0, $1G0Uw.Nr)(`Map cannot fit within canvas with the given bounds, padding, and/or offset.`);
}
function $4324d99ae8520741$var$Ec(e1) {
    if (e1.useSlerp) {
        if (e1.k < 1) {
            let t = (0, $1G0Uw.Er)(e1.startEulerAngles.roll, e1.startEulerAngles.pitch, e1.startEulerAngles.bearing), n = (0, $1G0Uw.Er)(e1.endEulerAngles.roll, e1.endEulerAngles.pitch, e1.endEulerAngles.bearing), r = new Float64Array(4);
            (0, $1G0Uw.Kr)(r, t, n, e1.k);
            let i = (0, $1G0Uw.sr)(r);
            e1.tr.setRoll(i.roll), e1.tr.setPitch(i.pitch), e1.tr.setBearing(i.bearing);
        } else e1.tr.setRoll(e1.endEulerAngles.roll), e1.tr.setPitch(e1.endEulerAngles.pitch), e1.tr.setBearing(e1.endEulerAngles.bearing);
    } else e1.tr.setRoll((0, $1G0Uw.un).number(e1.startEulerAngles.roll, e1.endEulerAngles.roll, e1.k)), e1.tr.setPitch((0, $1G0Uw.un).number(e1.startEulerAngles.pitch, e1.endEulerAngles.pitch, e1.k)), e1.tr.setBearing((0, $1G0Uw.un).number(e1.startEulerAngles.bearing, e1.endEulerAngles.bearing, e1.k));
}
function $4324d99ae8520741$var$Dc(t, n, r, i, a) {
    let o = a.padding, s = (0, $1G0Uw.$)(a.worldSize, r.getNorthWest()), c = (0, $1G0Uw.$)(a.worldSize, r.getNorthEast()), l = (0, $1G0Uw.$)(a.worldSize, r.getSouthEast()), u = (0, $1G0Uw.$)(a.worldSize, r.getSouthWest()), d = (0, $1G0Uw.Yn)(-i), f = s.rotate(d), p = c.rotate(d), m = l.rotate(d), h = u.rotate(d), g = new (0, $1G0Uw.Li)(Math.max(f.x, p.x, h.x, m.x), Math.max(f.y, p.y, h.y, m.y)), _ = new (0, $1G0Uw.Li)(Math.min(f.x, p.x, h.x, m.x), Math.min(f.y, p.y, h.y, m.y)), v = g.sub(_), y = a.width - (o.left + o.right + n.left + n.right), x = a.height - (o.top + o.bottom + n.top + n.bottom), S = y / v.x, C = x / v.y;
    if (C < 0 || S < 0) {
        $4324d99ae8520741$var$Tc();
        return;
    }
    let w = Math.min((0, $1G0Uw.Dr)(a.scale * Math.min(S, C)), t.maxZoom), T = (0, $1G0Uw.Li).convert(t.offset), E = (n.left - n.right) / 2, D = (n.top - n.bottom) / 2, O = new (0, $1G0Uw.Li)(E, D).rotate((0, $1G0Uw.Yn)(i)), k = T.add(O).mult(a.scale / (0, $1G0Uw.Fr)(w));
    return {
        center: (0, $1G0Uw.tt)(a.worldSize, s.add(l).div(2).sub(k)),
        zoom: w,
        bearing: i
    };
}
var $4324d99ae8520741$var$Oc = class {
    get useGlobeControls() {
        return !1;
    }
    handlePanInertia(e1, t) {
        let n = e1.mag(), r = Math.abs((0, $1G0Uw.Z)(t));
        return {
            easingOffset: e1.mult(Math.min(r * .75 / n, 1)),
            easingCenter: t.center
        };
    }
    handleMapControlsRollPitchBearingZoom(e1, t) {
        e1.bearingDelta && t.setBearing(t.bearing + e1.bearingDelta), e1.pitchDelta && t.setPitch(t.pitch + e1.pitchDelta), e1.rollDelta && t.setRoll(t.roll + e1.rollDelta), e1.zoomDelta && t.setZoom(t.zoom + e1.zoomDelta);
    }
    handleMapControlsPan(e1, t, n) {
        e1.around.distSqr(t.centerPoint) < .01 || t.setLocationAtPoint(n, e1.around, e1.aroundElevation);
    }
    cameraForBoxAndBearing(e1, t, n, r, i) {
        return $4324d99ae8520741$var$Dc(e1, t, n, r, i);
    }
    handleJumpToCenterZoom(e1, t) {
        let n = t.zoom === void 0 ? e1.zoom : +t.zoom;
        e1.zoom !== n && e1.setZoom(+t.zoom), t.center !== void 0 && e1.setCenter((0, $1G0Uw.lt).convert(t.center));
    }
    handleEaseTo(t, n) {
        let r = t.zoom, i = t.padding, a = {
            roll: t.roll,
            pitch: t.pitch,
            bearing: t.bearing
        }, o = {
            roll: n.roll === void 0 ? t.roll : n.roll,
            pitch: n.pitch === void 0 ? t.pitch : n.pitch,
            bearing: n.bearing === void 0 ? t.bearing : n.bearing
        }, s = n.zoom !== void 0, c = !t.isPaddingEqual(n.padding), l = !1, u = s ? +n.zoom : t.zoom, d = t.centerPoint.add(n.offsetAsPoint), f = t.screenPointToLocation(d), { center: p, zoom: m } = t.applyConstrain((0, $1G0Uw.lt).convert(n.center || f), u ?? r);
        $4324d99ae8520741$var$lc(t, p);
        let h = (0, $1G0Uw.$)(t.worldSize, f), g = (0, $1G0Uw.$)(t.worldSize, p).sub(h), _ = (0, $1G0Uw.Fr)(m - r);
        return l = m !== r, {
            easeFunc: (e1)=>{
                if (l && t.setZoom((0, $1G0Uw.un).number(r, m, e1)), (0, $1G0Uw.Tr)(a, o) || $4324d99ae8520741$var$Ec({
                    startEulerAngles: a,
                    endEulerAngles: o,
                    tr: t,
                    k: e1,
                    useSlerp: a.roll != o.roll
                }), c && (t.interpolatePadding(i, n.padding, e1), d = t.centerPoint.add(n.offsetAsPoint)), n.around) t.setLocationAtPoint(n.around, n.aroundPoint);
                else {
                    let n = (0, $1G0Uw.Fr)(t.zoom - r), i = (m > r ? Math.min(2, _) : Math.max(.5, _)) ** (1 - e1), a = (0, $1G0Uw.tt)(t.worldSize, h.add(g.mult(e1 * i)).mult(n));
                    t.setLocationAtPoint(t.renderWorldCopies ? a.wrap() : a, d);
                }
            },
            isZooming: l,
            elevationCenter: p
        };
    }
    handleFlyTo(t, n) {
        let r = n.zoom !== void 0, i = t.zoom, a = t.applyConstrain((0, $1G0Uw.lt).convert(n.center || n.locationAtOffset), r ? +n.zoom : i), o = a.center, s = a.zoom;
        $4324d99ae8520741$var$lc(t, o);
        let c = t.worldSize, l = (0, $1G0Uw.$)(c, n.locationAtOffset), u = (0, $1G0Uw.$)(c, o).sub(l), d = u.mag(), f = (0, $1G0Uw.Fr)(s - i), p = n.minZoom === void 0 ? t.minZoom : +n.minZoom, m = Math.max(p, t.minZoom), h = Math.min(m, i, s), g = t.applyConstrain(o, h).zoom;
        return {
            easeFunc: (e1, n, r, a)=>{
                t.setZoom(e1 === 1 ? s : i + (0, $1G0Uw.Dr)(n));
                let d = e1 === 1 ? o : (0, $1G0Uw.tt)(c, l.add(u.mult(r)));
                t.setLocationAtPoint(t.renderWorldCopies ? d.wrap() : d, a);
            },
            scaleOfZoom: f,
            targetCenter: o,
            scaleOfMinZoom: (0, $1G0Uw.Fr)(g - i),
            pixelPathLength: d
        };
    }
};
let $4324d99ae8520741$var$kc;
const $4324d99ae8520741$var$Ac = ()=>$4324d99ae8520741$var$kc ||= new (0, $1G0Uw.Qt)({
        type: new (0, $1G0Uw.Zt)((0, $1G0Uw.hn).projection.type, `type`)
    }), $4324d99ae8520741$var$jc = new (0, $1G0Uw.vt)({
    fill: new (0, $1G0Uw._t)(128, 2),
    line: new (0, $1G0Uw._t)(512, 0),
    tile: new (0, $1G0Uw._t)(128, 32),
    stencil: new (0, $1G0Uw._t)(128, 1),
    circle: 3
});
var $4324d99ae8520741$var$Mc = class {
    constructor(){
        this._tileMeshCache = {};
    }
    get name() {
        return `vertical-perspective`;
    }
    get transitionState() {
        return 1;
    }
    get useSubdivision() {
        return !0;
    }
    get shaderVariantName() {
        return `globe`;
    }
    get shaderDefine() {
        return `#define GLOBE`;
    }
    get shaderPreludeCode() {
        return $4324d99ae8520741$var$ic.projectionGlobe;
    }
    get vertexShaderPreludeCode() {
        return $4324d99ae8520741$var$ic.projectionMercator.vertexSource;
    }
    get subdivisionGranularity() {
        return $4324d99ae8520741$var$jc;
    }
    get useGlobeControls() {
        return !0;
    }
    destroy() {}
    _getMeshKey(e1) {
        return `${e1.granularity.toString(36)}_${e1.generateBorders ? `b` : ``}${e1.extendToNorthPole ? `n` : ``}${e1.extendToSouthPole ? `s` : ``}`;
    }
    getMeshFromTileID(e1, t, n, r, i) {
        let a = (i === `stencil` ? $4324d99ae8520741$var$jc.stencil : $4324d99ae8520741$var$jc.tile).getGranularityForZoomLevel(t.z), o = t.y === 0 && r, s = t.y === (1 << t.z) - 1 && r;
        return this._getMesh(e1, {
            granularity: a,
            generateBorders: n,
            extendToNorthPole: o,
            extendToSouthPole: s
        });
    }
    _getMesh(e1, t) {
        let n = this._getMeshKey(t);
        if (n in this._tileMeshCache) return this._tileMeshCache[n];
        let r = $4324d99ae8520741$var$Ka(e1, t);
        return this._tileMeshCache[n] = r, r;
    }
    recalculate(e1) {}
    hasTransition() {
        return !1;
    }
}, $4324d99ae8520741$var$Nc = class extends (0, $1G0Uw.vn) {
    constructor(e1, t){
        super(), this._transitionable = new (0, $1G0Uw.$t)($4324d99ae8520741$var$Ac(), `projection`, t), this.setProjection(e1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new (0, $1G0Uw.en)(0)), this._mercatorProjection = new $4324d99ae8520741$var$sc, this._verticalPerspectiveProjection = new $4324d99ae8520741$var$Mc;
    }
    get transitionState() {
        let e1 = this.properties.get(`type`);
        if (typeof e1 == `string` && e1 === `mercator`) return 0;
        if (typeof e1 == `string` && e1 === `vertical-perspective`) return 1;
        if (e1 instanceof (0, $1G0Uw.dn)) {
            if (e1.from === e1.to) return e1.from === `mercator` ? 0 : 1;
            if (e1.from === `vertical-perspective` && e1.to === `mercator`) return 1 - e1.transition;
            if (e1.from === `mercator` && e1.to === `vertical-perspective`) return e1.transition;
        }
        return 1;
    }
    get useGlobeRendering() {
        return this.transitionState > 0;
    }
    get currentProjection() {
        return this.useGlobeRendering ? this._verticalPerspectiveProjection : this._mercatorProjection;
    }
    get name() {
        return `globe`;
    }
    get useSubdivision() {
        return this.currentProjection.useSubdivision;
    }
    get shaderVariantName() {
        return this.currentProjection.shaderVariantName;
    }
    get shaderDefine() {
        return this.currentProjection.shaderDefine;
    }
    get shaderPreludeCode() {
        return this.currentProjection.shaderPreludeCode;
    }
    get vertexShaderPreludeCode() {
        return this.currentProjection.vertexShaderPreludeCode;
    }
    get subdivisionGranularity() {
        return this.currentProjection.subdivisionGranularity;
    }
    get useGlobeControls() {
        return this.transitionState > 0;
    }
    destroy() {
        this._mercatorProjection.destroy(), this._verticalPerspectiveProjection.destroy();
    }
    getMeshFromTileID(e1, t, n, r, i) {
        return this.currentProjection.getMeshFromTileID(e1, t, n, r, i);
    }
    setProjection(e1) {
        this._transitionable.setValue(`type`, e1?.type || `mercator`);
    }
    updateTransitions(e1) {
        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition() || this.currentProjection.hasTransition();
    }
    recalculate(e1) {
        this.properties = this._transitioning.possiblyEvaluate(e1);
    }
};
function $4324d99ae8520741$var$Pc(e1) {
    let t = $4324d99ae8520741$var$Bc(e1.worldSize, e1.center.lat);
    return 2 * Math.PI * t;
}
function $4324d99ae8520741$var$Fc(e1, t, n) {
    let r = $4324d99ae8520741$var$zc(t), i = $4324d99ae8520741$var$zc(n), a = (0, $1G0Uw.ei)(r, i), o = Math.acos(a), s = $4324d99ae8520741$var$Pc(e1);
    return o / (2 * Math.PI) * s;
}
function $4324d99ae8520741$var$Ic(e1, t) {
    return [
        (0, $1G0Uw.gr)(e1 * Math.PI * 2 + Math.PI, Math.PI * 2),
        2 * Math.atan(Math.exp(Math.PI - t * Math.PI * 2)) - Math.PI * .5
    ];
}
function $4324d99ae8520741$var$Lc(e1, t) {
    let n = Math.cos(t), r = new Float64Array(3);
    return r[0] = Math.sin(e1) * n, r[1] = Math.sin(t), r[2] = Math.cos(e1) * n, r;
}
function $4324d99ae8520741$var$Rc(e1, t, n, r, i) {
    let a = 1 / (1 << i), o = e1 / (0, $1G0Uw.Lr) * a + n * a, s = t / (0, $1G0Uw.Lr) * a + r * a, c = (0, $1G0Uw.gr)(o * Math.PI * 2 + Math.PI, Math.PI * 2), l = 2 * Math.atan(Math.exp(Math.PI - s * Math.PI * 2)) - Math.PI * .5, u = Math.cos(l), d = new Float64Array(3);
    return d[0] = Math.sin(c) * u, d[1] = Math.sin(l), d[2] = Math.cos(c) * u, d;
}
function $4324d99ae8520741$var$zc(e1) {
    return $4324d99ae8520741$var$Lc(e1.lng * Math.PI / 180, e1.lat * Math.PI / 180);
}
function $4324d99ae8520741$var$Bc(e1, t) {
    return e1 / (2 * Math.PI) / Math.cos(t * Math.PI / 180);
}
function $4324d99ae8520741$var$Vc(e1) {
    let t = (0, $1G0Uw.Yr)((0, $1G0Uw.Kn)(), [
        0,
        0,
        0,
        1
    ], e1.modelViewProjectionMatrix);
    return (0, $1G0Uw.Yr)(t, t, e1.inverseProjectionMatrix), [
        t[0] / t[3],
        t[1] / t[3],
        t[2] / t[3]
    ];
}
function $4324d99ae8520741$var$Hc(e1) {
    let t = Math.asin(e1[1]) / Math.PI * 180, n = Math.sqrt(e1[0] * e1[0] + e1[2] * e1[2]);
    if (n > 1e-6) {
        let r = e1[0] / n, i = e1[2] / n, a = Math.acos(i), o = (r > 0 ? a : -a) / Math.PI * 180;
        return new (0, $1G0Uw.lt)((0, $1G0Uw.Pr)(o, -180, 180), t);
    }
    return new (0, $1G0Uw.lt)(0, t);
}
function $4324d99ae8520741$var$Uc(e1, t) {
    return (0, $1G0Uw.Ur)((0, $1G0Uw.Kn)(), -e1.lng, -e1.lat, t);
}
function $4324d99ae8520741$var$Wc(e1) {
    let t = e1[0], n = e1[1], r = e1[2], i = e1[3];
    return {
        lng: -Math.atan2(2 * (i * t + n * r), 1 - 2 * (t * t + n * n)) * 180 / Math.PI,
        lat: -Math.asin((0, $1G0Uw.Bn)(2 * (i * n - r * t), -1, 1)) * 180 / Math.PI,
        bearing: Math.atan2(2 * (i * r + t * n), 1 - 2 * (n * n + r * r)) * 180 / Math.PI
    };
}
const $4324d99ae8520741$var$Gc = Math.PI * .98;
function $4324d99ae8520741$var$Kc(e1, t) {
    let n = e1.cameraPosition, r = (0, $1G0Uw.ni)(n);
    if (r <= 1) return e1.screenPointToLocation(t);
    let i = (0, $1G0Uw.Gn)();
    (0, $1G0Uw.ii)(i, n);
    let a = e1.getRayDirectionFromPixel(t), o = -(0, $1G0Uw.ei)(a, i), s = (0, $1G0Uw.Gn)();
    (0, $1G0Uw.li)(s, a, i, o);
    let c = (0, $1G0Uw.ni)(s);
    if (c < 1e-9) return e1.screenPointToLocation(t);
    let l = Math.atan2(c, o), d = Math.asin(1 / r) * .9;
    if (l < d) return e1.screenPointToLocation(t);
    let f = r * Math.sin(d), p = Math.asin((0, $1G0Uw.Bn)(f, -1, 1)) - d, m = r * Math.cos(d) / Math.sqrt(Math.max(1 - f * f, 1e-12)) - 1, h = $4324d99ae8520741$var$Gc - p, g = l - d, _ = p + m * g * h / (h + m * g), v = (0, $1G0Uw.Gn)();
    (0, $1G0Uw.ci)(v, s, 1 / c);
    let y = (0, $1G0Uw.Gn)();
    return (0, $1G0Uw.ci)(y, i, Math.cos((0, $1G0Uw.Bn)(_, 0, $4324d99ae8520741$var$Gc))), (0, $1G0Uw.li)(y, y, v, Math.sin((0, $1G0Uw.Bn)(_, 0, $4324d99ae8520741$var$Gc))), (0, $1G0Uw.ii)(y, y), $4324d99ae8520741$var$Hc(y);
}
function $4324d99ae8520741$var$qc(e1, t, n, r, i = !0) {
    let a = $4324d99ae8520741$var$Kc(e1, n), o = t;
    if (r) o = $4324d99ae8520741$var$Kc(e1, n.sub(r));
    else if (!e1.isPointOnMapSurface(n)) return;
    let s = $4324d99ae8520741$var$zc(a), c = $4324d99ae8520741$var$zc(o), l = $4324d99ae8520741$var$Uc(e1.center, e1.bearing), d = (0, $1G0Uw.Qr)((0, $1G0Uw.Gn)(), c, s), f = Math.sqrt((0, $1G0Uw.ei)(d, d)), p = Math.acos((0, $1G0Uw.Bn)((0, $1G0Uw.ei)(c, s), -1, 1)) / 2, m = Math.sin(p), h = f ? (0, $1G0Uw.Wr)(d[1] / f * m, -d[0] / f * m, d[2] / f * m, Math.cos(p)) : (0, $1G0Uw.Wr)(0, 0, 0, 1), { lng: g, lat: _, bearing: v } = $4324d99ae8520741$var$Wc((0, $1G0Uw.Gr)((0, $1G0Uw.Kn)(), l, h)), y = e1.center.lat, b = e1.zoom, x = (0, $1G0Uw.Bn)(_, -90, 90), S = i ? $4324d99ae8520741$var$Jc(e1, n, r, g) : g;
    e1.setCenter(new (0, $1G0Uw.lt)((0, $1G0Uw.Pr)(S, -180, 180), x)), i || e1.setBearing(v), e1.setZoom(b + $4324d99ae8520741$var$Qc(y, e1.center.lat));
}
function $4324d99ae8520741$var$Jc(e1, t, n, r) {
    let i = e1.center.lng, a = e1.center.lat, o = a >= 0 ? 90 : -90, s = e1.locationToScreenPoint(new (0, $1G0Uw.lt)(0, o)), c = t.x - s.x, l = t.y - s.y, d = c * c + l * l, f = (0, $1G0Uw.Bn)(1 - ((0, $1G0Uw.Fn) - Math.abs(a)) / 12, 0, 1), p = f * f * (3 - 2 * f), m = (0, $1G0Uw.gr)(r - i + 180, 360) - 180, h = 0;
    if (p > 0 && n) {
        let e1 = (c * n.y - l * n.x) / Math.max(d, 400);
        h = (o > 0 ? 1 : -1) * e1 * 180 / Math.PI;
    }
    return i + (1 - p) * m + p * h;
}
function $4324d99ae8520741$var$Yc(e1) {
    let t = (0, $1G0Uw.Gn)();
    return t[0] = e1[0] * -e1[3], t[1] = e1[1] * -e1[3], t[2] = e1[2] * -e1[3], {
        center: t,
        radius: Math.sqrt(1 - e1[3] * e1[3])
    };
}
function $4324d99ae8520741$var$Xc(e1, t, n) {
    let r = (0, $1G0Uw.Gn)();
    (0, $1G0Uw.ui)(r, n, e1);
    let i = (0, $1G0Uw.Gn)();
    return (0, $1G0Uw.li)(i, e1, r, t / (0, $1G0Uw.ti)(r)), i;
}
function $4324d99ae8520741$var$Zc(e1) {
    return Math.cos(e1 * Math.PI / 180);
}
function $4324d99ae8520741$var$Qc(e1, t) {
    let n = $4324d99ae8520741$var$Zc(e1), r = $4324d99ae8520741$var$Zc(t);
    return (0, $1G0Uw.Dr)(r / n);
}
function $4324d99ae8520741$var$$c(e1, t) {
    return 360 / $4324d99ae8520741$var$Pc({
        worldSize: e1,
        center: {
            lat: t
        }
    });
}
function $4324d99ae8520741$var$el(e1, t) {
    let n = e1.rotate(t.bearingInRadians), r = t.zoom + $4324d99ae8520741$var$Qc(t.center.lat, 0), i = (0, $1G0Uw.mr)(1 / $4324d99ae8520741$var$Zc(t.center.lat), 1 / $4324d99ae8520741$var$Zc(Math.min(Math.abs(t.center.lat), 60)), (0, $1G0Uw.wr)(r, 7, 3, 0, 1)), a = $4324d99ae8520741$var$$c(t.worldSize, t.center.lat);
    return new (0, $1G0Uw.lt)(t.center.lng - n.x * a * i, (0, $1G0Uw.Bn)(t.center.lat + n.y * a, -(0, $1G0Uw.Fn), (0, $1G0Uw.Fn)));
}
function $4324d99ae8520741$var$tl(e1) {
    let t = .5 * e1, n = Math.sin(t), r = Math.cos(t);
    return Math.log(n + r) - Math.log(r - n);
}
function $4324d99ae8520741$var$nl(e1, t, n, r) {
    let i = e1.lat + n * r;
    if (Math.abs(n) > 1) {
        let a = e1.lat + n, o = (Math.sign(a) === Math.sign(e1.lat) ? Math.abs(e1.lat) : -Math.abs(e1.lat)) * Math.PI / 180, s = Math.abs(e1.lat + n) * Math.PI / 180, c = $4324d99ae8520741$var$tl(o + r * (s - o)), l = $4324d99ae8520741$var$tl(o), u = $4324d99ae8520741$var$tl(s), d = (c - l) / (u - l), f = e1.lng + t * d;
        return new (0, $1G0Uw.lt)(f, i);
    }
    {
        let n = e1.lng + t * r;
        return new (0, $1G0Uw.lt)(n, i);
    }
}
function $4324d99ae8520741$var$rl(e1, t, n = 1) {
    let r = (0, $1G0Uw.ei)(e1, t), i = n * n, a = (0, $1G0Uw.Gn)(), o = (0, $1G0Uw.Gn)();
    (0, $1G0Uw.ci)(o, t, r), (0, $1G0Uw.ui)(a, e1, o);
    let s = i - (0, $1G0Uw.ei)(a, a);
    if (s < 0) return null;
    let c = (0, $1G0Uw.ei)(e1, e1) - i, l = -r + (r < 0 ? 1 : -1) * Math.sqrt(s), u = c / l, d = l;
    return {
        tMin: Math.min(u, d),
        tMax: Math.max(u, d)
    };
}
var $4324d99ae8520741$var$il = class {
    constructor(e1){
        this._cachePrevious = new Map, this._cache = new Map, this._hadAnyChanges = !1, this._boundingVolumeFactory = e1;
    }
    swapBuffers() {
        if (!this._hadAnyChanges) return;
        let e1 = this._cachePrevious;
        this._cachePrevious = this._cache, this._cache = e1, this._cache.clear(), this._hadAnyChanges = !1;
    }
    getTileBoundingVolume(e1, t, n, r) {
        let i = `${e1.z}_${e1.x}_${e1.y}_${r?.terrain ? `t` : ``}_${Math.round(n)}`, a = this._cache.get(i);
        if (a) return a;
        let o = this._cachePrevious.get(i);
        if (o) return this._cache.set(i, o), o;
        let s = this._boundingVolumeFactory(e1, t, n, r);
        return this._cache.set(i, s), this._hadAnyChanges = !0, s;
    }
}, $4324d99ae8520741$var$al = class e1 {
    constructor(e1, t, n, r){
        this.min = n, this.max = r, this.points = e1, this.planes = t;
    }
    static fromAabb(t, n) {
        let r = [];
        for(let e1 = 0; e1 < 8; e1++)r.push([
            (e1 >> 0 & 1) == 1 ? n[0] : t[0],
            (e1 >> 1 & 1) == 1 ? n[1] : t[1],
            (e1 >> 2 & 1) == 1 ? n[2] : t[2]
        ]);
        return new e1(r, [
            [
                -1,
                0,
                0,
                n[0]
            ],
            [
                1,
                0,
                0,
                -t[0]
            ],
            [
                0,
                -1,
                0,
                n[1]
            ],
            [
                0,
                1,
                0,
                -t[1]
            ],
            [
                0,
                0,
                -1,
                n[2]
            ],
            [
                0,
                0,
                1,
                -t[2]
            ]
        ], t, n);
    }
    static fromCenterSizeAngles(t, n, r) {
        let i = (0, $1G0Uw.Ur)([], r[0], r[1], r[2]), a = (0, $1G0Uw.mi)([], [
            n[0],
            0,
            0
        ], i), o = (0, $1G0Uw.mi)([], [
            0,
            n[1],
            0
        ], i), s = (0, $1G0Uw.mi)([], [
            0,
            0,
            n[2]
        ], i), c = [
            ...t
        ], l = [
            ...t
        ];
        for(let e1 = 0; e1 < 8; e1++)for(let n = 0; n < 3; n++){
            let r = t[n] + a[n] * ((e1 >> 0 & 1) == 1 ? 1 : -1) + o[n] * ((e1 >> 1 & 1) == 1 ? 1 : -1) + s[n] * ((e1 >> 2 & 1) == 1 ? 1 : -1);
            c[n] = Math.min(c[n], r), l[n] = Math.max(l[n], r);
        }
        let u = [];
        for(let e1 = 0; e1 < 8; e1++){
            let n = [
                ...t
            ];
            (0, $1G0Uw.Xr)(n, n, (0, $1G0Uw.ci)([], a, (e1 >> 0 & 1) == 1 ? 1 : -1)), (0, $1G0Uw.Xr)(n, n, (0, $1G0Uw.ci)([], o, (e1 >> 1 & 1) == 1 ? 1 : -1)), (0, $1G0Uw.Xr)(n, n, (0, $1G0Uw.ci)([], s, (e1 >> 2 & 1) == 1 ? 1 : -1)), u.push(n);
        }
        return new e1(u, [
            [
                ...a,
                -(0, $1G0Uw.ei)(a, u[0])
            ],
            [
                ...o,
                -(0, $1G0Uw.ei)(o, u[0])
            ],
            [
                ...s,
                -(0, $1G0Uw.ei)(s, u[0])
            ],
            [
                -a[0],
                -a[1],
                -a[2],
                -(0, $1G0Uw.ei)(a, u[7])
            ],
            [
                -o[0],
                -o[1],
                -o[2],
                -(0, $1G0Uw.ei)(o, u[7])
            ],
            [
                -s[0],
                -s[1],
                -s[2],
                -(0, $1G0Uw.ei)(s, u[7])
            ]
        ], c, l);
    }
    intersectsFrustum(e1) {
        let t = !0, n = this.points.length, r = this.planes.length, i = e1.planes.length, a = e1.points.length;
        for(let r = 0; r < i; r++){
            let i = e1.planes[r], a = 0;
            for(let e1 = 0; e1 < n; e1++){
                let t = this.points[e1];
                i[0] * t[0] + i[1] * t[1] + i[2] * t[2] + i[3] >= 0 && a++;
            }
            if (a === 0) return 0;
            a < n && (t = !1);
        }
        if (t) return 2;
        for(let t = 0; t < r; t++){
            let n = this.planes[t], r = 0;
            for(let t = 0; t < a; t++){
                let i = e1.points[t];
                n[0] * i[0] + n[1] * i[1] + n[2] * i[2] + n[3] >= 0 && r++;
            }
            if (r === 0) return 0;
        }
        return 1;
    }
    intersectsPlane(e1) {
        let t = this.points.length, n = 0;
        for(let r = 0; r < t; r++){
            let t = this.points[r];
            e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2] + e1[3] >= 0 && n++;
        }
        return n === t ? 2 : n === 0 ? 0 : 1;
    }
};
function $4324d99ae8520741$var$ol(e1, t, n) {
    let r = e1 - t;
    return r < 0 ? -r : Math.max(0, r - n);
}
function $4324d99ae8520741$var$sl(e1, t, n, r, i) {
    let a = e1 - n, o;
    return o = a < 0 ? Math.min(-a, 1 + a - i) : a > i ? Math.min(Math.max(a - i, 0), 1 - a) : 0, Math.max(o, $4324d99ae8520741$var$ol(t, r, i));
}
var $4324d99ae8520741$var$cl = class {
    constructor(){
        this._boundingVolumeCache = new $4324d99ae8520741$var$il(this._computeTileBoundingVolume);
    }
    prepareNextFrame() {
        this._boundingVolumeCache.swapBuffers();
    }
    distanceToTile2d(e1, t, n, r) {
        let i = 1 << n.z, a = 1 / i, o = n.x / i, s = n.y / i, c = .5, l = 2;
        return l = Math.min(l, $4324d99ae8520741$var$sl(e1, t, o, s, a)), l = Math.min(l, $4324d99ae8520741$var$sl(e1, t, o + c, -s - a, a)), l = Math.min(l, $4324d99ae8520741$var$sl(e1, t, o + c, 2 - s - a, a)), l;
    }
    getWrap(e1, t, n) {
        let r = 1 << t.z, i = 1 / r, a = t.x / r, o = $4324d99ae8520741$var$ol(e1.x, a, i), s = $4324d99ae8520741$var$ol(e1.x, a - 1, i), c = $4324d99ae8520741$var$ol(e1.x, a + 1, i), l = Math.min(o, s, c);
        return l === c ? 1 : l === s ? -1 : 0;
    }
    allowVariableZoom(e1, t) {
        return $4324d99ae8520741$var$Eo(e1, t) > 4;
    }
    allowWorldCopies() {
        return !1;
    }
    getTileBoundingVolume(e1, t, n, r) {
        return this._boundingVolumeCache.getTileBoundingVolume(e1, t, n, r);
    }
    _computeTileBoundingVolume(e1, t, n, r) {
        let i = Math.min(0, n), a = Math.max(0, n);
        if (r?.terrain) {
            let n = new (0, $1G0Uw.d)(e1.z, t, e1.z, e1.x, e1.y), o = r.terrain.getMinMaxElevation(n);
            i = o.minElevation ?? i, a = Math.max(o.maxElevation ?? a, a);
        }
        if (i /= (0, $1G0Uw.ut), a /= (0, $1G0Uw.ut), i += 1, a += 1, e1.z <= 0) return $4324d99ae8520741$var$al.fromAabb([
            -a,
            -a,
            -a
        ], [
            a,
            a,
            a
        ]);
        if (e1.z === 1) return $4324d99ae8520741$var$al.fromAabb([
            e1.x === 0 ? -a : 0,
            e1.y === 0 ? 0 : -a,
            -a
        ], [
            e1.x === 0 ? 0 : a,
            e1.y === 0 ? a : 0,
            a
        ]);
        {
            let t = [
                $4324d99ae8520741$var$Rc(0, 0, e1.x, e1.y, e1.z),
                $4324d99ae8520741$var$Rc((0, $1G0Uw.Lr), 0, e1.x, e1.y, e1.z),
                $4324d99ae8520741$var$Rc((0, $1G0Uw.Lr), (0, $1G0Uw.Lr), e1.x, e1.y, e1.z),
                $4324d99ae8520741$var$Rc(0, (0, $1G0Uw.Lr), e1.x, e1.y, e1.z)
            ], n = [];
            for (let e1 of t)n.push((0, $1G0Uw.ci)([], e1, a));
            if (a !== i) for (let e1 of t)n.push((0, $1G0Uw.ci)([], e1, i));
            e1.y === 0 && n.push([
                0,
                1,
                0
            ]), e1.y === (1 << e1.z) - 1 && n.push([
                0,
                -1,
                0
            ]);
            let r = [
                1,
                1,
                1
            ], o = [
                -1,
                -1,
                -1
            ];
            for (let e1 of n)for(let t = 0; t < 3; t++)r[t] = Math.min(r[t], e1[t]), o[t] = Math.max(o[t], e1[t]);
            let c = $4324d99ae8520741$var$Rc((0, $1G0Uw.Lr) / 2, (0, $1G0Uw.Lr) / 2, e1.x, e1.y, e1.z), l = (0, $1G0Uw.Qr)([], [
                0,
                1,
                0
            ], c);
            (0, $1G0Uw.ii)(l, l);
            let u = (0, $1G0Uw.Qr)([], c, l);
            (0, $1G0Uw.ii)(u, u);
            let d = (0, $1G0Uw.Qr)([], t[2], t[1]);
            (0, $1G0Uw.ii)(d, d);
            let f = (0, $1G0Uw.Qr)([], t[0], t[3]);
            (0, $1G0Uw.ii)(f, f), n.push((0, $1G0Uw.ci)([], c, a)), e1.y >= (1 << e1.z) / 2 && n.push((0, $1G0Uw.ci)([], $4324d99ae8520741$var$Rc((0, $1G0Uw.Lr) / 2, 0, e1.x, e1.y, e1.z), a)), e1.y < (1 << e1.z) / 2 && n.push((0, $1G0Uw.ci)([], $4324d99ae8520741$var$Rc((0, $1G0Uw.Lr) / 2, (0, $1G0Uw.Lr), e1.x, e1.y, e1.z), a));
            let p = $4324d99ae8520741$var$ll(c, n), m = $4324d99ae8520741$var$ll(u, n), h = [
                -c[0],
                -c[1],
                -c[2],
                p.max
            ], g = [
                c[0],
                c[1],
                c[2],
                -p.min
            ], _ = [
                -u[0],
                -u[1],
                -u[2],
                m.max
            ], v = [
                u[0],
                u[1],
                u[2],
                -m.min
            ], y = [
                ...d,
                0
            ], b = [
                ...f,
                0
            ], x = [];
            return e1.y === 0 ? x.push((0, $1G0Uw.Ar)(b, y, h), (0, $1G0Uw.Ar)(b, y, g)) : x.push((0, $1G0Uw.Ar)(_, y, h), (0, $1G0Uw.Ar)(_, y, g), (0, $1G0Uw.Ar)(_, b, h), (0, $1G0Uw.Ar)(_, b, g)), e1.y === (1 << e1.z) - 1 ? x.push((0, $1G0Uw.Ar)(b, y, h), (0, $1G0Uw.Ar)(b, y, g)) : x.push((0, $1G0Uw.Ar)(v, y, h), (0, $1G0Uw.Ar)(v, y, g), (0, $1G0Uw.Ar)(v, b, h), (0, $1G0Uw.Ar)(v, b, g)), new $4324d99ae8520741$var$al(x, [
                h,
                g,
                _,
                v,
                y,
                b
            ], r, o);
        }
    }
};
function $4324d99ae8520741$var$ll(e1, t) {
    let n = 1 / 0, r = -1 / 0;
    for (let i of t){
        let t = (0, $1G0Uw.ei)(e1, i);
        n = Math.min(n, t), r = Math.max(r, t);
    }
    return {
        min: n,
        max: r
    };
}
const $4324d99ae8520741$var$ul = 1e-12;
var $4324d99ae8520741$var$dl = class e1 {
    get pixelsToClipSpaceMatrix() {
        return this._helper.pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._helper.clipSpaceToPixelsMatrix;
    }
    get pixelsToGLUnits() {
        return this._helper.pixelsToGLUnits;
    }
    get centerOffset() {
        return this._helper.centerOffset;
    }
    get size() {
        return this._helper.size;
    }
    get rotationMatrix() {
        return this._helper.rotationMatrix;
    }
    get centerPoint() {
        return this._helper.centerPoint;
    }
    get pixelsPerMeter() {
        return this._helper.pixelsPerMeter;
    }
    setMinZoom(e1) {
        this._helper.setMinZoom(e1);
    }
    setMaxZoom(e1) {
        this._helper.setMaxZoom(e1);
    }
    setMinPitch(e1) {
        this._helper.setMinPitch(e1);
    }
    setMaxPitch(e1) {
        this._helper.setMaxPitch(e1);
    }
    setRenderWorldCopies(e1) {
        this._helper.setRenderWorldCopies(e1);
    }
    setBearing(e1) {
        this._helper.setBearing(e1);
    }
    setPitch(e1) {
        this._helper.setPitch(e1);
    }
    setRoll(e1) {
        this._helper.setRoll(e1);
    }
    setFov(e1) {
        this._helper.setFov(e1);
    }
    setZoom(e1) {
        this._helper.setZoom(e1);
    }
    setCenter(e1) {
        this._helper.setCenter(e1);
    }
    setElevation(e1) {
        this._helper.setElevation(e1);
    }
    setMinElevationForCurrentTile(e1) {
        this._helper.setMinElevationForCurrentTile(e1);
    }
    setPadding(e1) {
        this._helper.setPadding(e1);
    }
    interpolatePadding(e1, t, n) {
        this._helper.interpolatePadding(e1, t, n);
    }
    isPaddingEqual(e1) {
        return this._helper.isPaddingEqual(e1);
    }
    resize(e1, t) {
        this._helper.resize(e1, t);
    }
    getMaxBounds() {
        return this._helper.getMaxBounds();
    }
    setMaxBounds(e1) {
        this._helper.setMaxBounds(e1);
    }
    setConstrainOverride(e1) {
        this._helper.setConstrainOverride(e1);
    }
    overrideNearFarZ(e1, t) {
        this._helper.overrideNearFarZ(e1, t);
    }
    clearNearFarZOverride() {
        this._helper.clearNearFarZOverride();
    }
    getCameraQueryGeometry(e1) {
        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
    }
    get tileSize() {
        return this._helper.tileSize;
    }
    get tileZoom() {
        return this._helper.tileZoom;
    }
    get scale() {
        return this._helper.scale;
    }
    get worldSize() {
        return this._helper.worldSize;
    }
    get width() {
        return this._helper.width;
    }
    get height() {
        return this._helper.height;
    }
    get lngRange() {
        return this._helper.lngRange;
    }
    get latRange() {
        return this._helper.latRange;
    }
    get minZoom() {
        return this._helper.minZoom;
    }
    get maxZoom() {
        return this._helper.maxZoom;
    }
    get zoom() {
        return this._helper.zoom;
    }
    get center() {
        return this._helper.center;
    }
    get minPitch() {
        return this._helper.minPitch;
    }
    get maxPitch() {
        return this._helper.maxPitch;
    }
    get pitch() {
        return this._helper.pitch;
    }
    get pitchInRadians() {
        return this._helper.pitchInRadians;
    }
    get roll() {
        return this._helper.roll;
    }
    get rollInRadians() {
        return this._helper.rollInRadians;
    }
    get bearing() {
        return this._helper.bearing;
    }
    get bearingInRadians() {
        return this._helper.bearingInRadians;
    }
    get fov() {
        return this._helper.fov;
    }
    get fovInRadians() {
        return this._helper.fovInRadians;
    }
    get elevation() {
        return this._helper.elevation;
    }
    get minElevationForCurrentTile() {
        return this._helper.minElevationForCurrentTile;
    }
    get padding() {
        return this._helper.padding;
    }
    get unmodified() {
        return this._helper.unmodified;
    }
    get renderWorldCopies() {
        return this._helper.renderWorldCopies;
    }
    get constrainOverride() {
        return this._helper.constrainOverride;
    }
    get nearZ() {
        return this._helper.nearZ;
    }
    get farZ() {
        return this._helper.farZ;
    }
    get autoCalculateNearFarZ() {
        return this._helper.autoCalculateNearFarZ;
    }
    setTransitionState(e1) {}
    constructor(e1){
        this._cachedClippingPlane = (0, $1G0Uw.Kn)(), this._projectionMatrix = (0, $1G0Uw.Un)(), this._globeViewProjMatrix32f = (0, $1G0Uw.Hn)(), this._globeViewProjMatrixF64 = (0, $1G0Uw.Un)(), this._globeViewProjMatrixF64Inverted = (0, $1G0Uw.Un)(), this._globeProjMatrixInverted = (0, $1G0Uw.Un)(), this._cameraPosition = (0, $1G0Uw.Gn)(), this.defaultConstrain = (e1, t)=>{
            let n = (0, $1G0Uw.Bn)(e1.lat, -(0, $1G0Uw.Fn), (0, $1G0Uw.Fn)), r = (0, $1G0Uw.Bn)(+t, this.minZoom + $4324d99ae8520741$var$Qc(0, n), this.maxZoom);
            return {
                center: new (0, $1G0Uw.lt)(e1.lng, n),
                zoom: r
            };
        }, this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new $4324d99ae8520741$var$dc({
            calcMatrices: ()=>this._calcMatrices(),
            defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
        }, e1), this._coveringTilesDetailsProvider = new $4324d99ae8520741$var$cl;
    }
    clone() {
        let t = new e1;
        return t.apply(this, !1), t;
    }
    apply(e1, t) {
        this._helper.apply(e1, t);
    }
    get projectionMatrix() {
        return this._projectionMatrix;
    }
    get modelViewProjectionMatrix() {
        return this._globeViewProjMatrixF64;
    }
    get inverseProjectionMatrix() {
        return this._globeProjMatrixInverted;
    }
    get cameraPosition() {
        let e1 = (0, $1G0Uw.Gn)();
        return e1[0] = this._cameraPosition[0], e1[1] = this._cameraPosition[1], e1[2] = this._cameraPosition[2], e1;
    }
    get cameraToCenterDistance() {
        return this._helper.cameraToCenterDistance;
    }
    getProjectionData(e1) {
        let { overscaledTileID: t, applyGlobeMatrix: n } = e1, r = this._helper.getMercatorTileCoordinates(t);
        return {
            mainMatrix: this._globeViewProjMatrix32f,
            tileMercatorCoords: r,
            clippingPlane: this._cachedClippingPlane,
            projectionTransition: +!!n,
            fallbackMatrix: this._globeViewProjMatrix32f,
            clipAntimeridian: t?.canonical.z === 0
        };
    }
    _computeClippingPlane(e1) {
        let t = this.pitchInRadians, n = this.cameraToCenterDistance / e1, r = Math.sin(t) * n, i = Math.cos(t) * n + 1, a = 1 / Math.sqrt(r * r + i * i) * 1, o = -r, s = i, c = Math.sqrt(o * o + s * s);
        o /= c, s /= c;
        let l = [
            0,
            o,
            s
        ];
        (0, $1G0Uw.si)(l, l, [
            0,
            0,
            0
        ], -this.bearingInRadians), (0, $1G0Uw.ai)(l, l, [
            0,
            0,
            0
        ], -1 * this.center.lat * Math.PI / 180), (0, $1G0Uw.oi)(l, l, [
            0,
            0,
            0
        ], this.center.lng * Math.PI / 180);
        let u = 1 / (0, $1G0Uw.ni)(l);
        return (0, $1G0Uw.ci)(l, l, u), [
            ...l,
            -a * u
        ];
    }
    isLocationOccluded(e1) {
        return !this.isSurfacePointVisible($4324d99ae8520741$var$zc(e1));
    }
    transformLightDirection(e1) {
        let t = this._helper._center.lng * Math.PI / 180, n = this._helper._center.lat * Math.PI / 180, r = Math.cos(n), i = [
            Math.sin(t) * r,
            Math.sin(n),
            Math.cos(t) * r
        ], a = [
            i[2],
            0,
            -i[0]
        ], o = [
            0,
            0,
            0
        ];
        (0, $1G0Uw.Qr)(o, a, i), (0, $1G0Uw.ii)(a, a), (0, $1G0Uw.ii)(o, o);
        let s = [
            a[0] * e1[0] + o[0] * e1[1] + i[0] * e1[2],
            a[1] * e1[0] + o[1] * e1[1] + i[1] * e1[2],
            a[2] * e1[0] + o[2] * e1[1] + i[2] * e1[2]
        ], c = [
            0,
            0,
            0
        ];
        return (0, $1G0Uw.ii)(c, s), c;
    }
    getPixelScale() {
        return 1 / Math.cos(this._helper._center.lat * Math.PI / 180);
    }
    getCircleRadiusCorrection() {
        return Math.cos(this._helper._center.lat * Math.PI / 180);
    }
    getPitchedTextCorrection(e1, t, n) {
        let r = (0, $1G0Uw.et)(e1, t, n.canonical), i = $4324d99ae8520741$var$Ic(r.x, r.y);
        return this.getCircleRadiusCorrection() / Math.cos(i[1]);
    }
    projectTileCoordinates(e1, t, n, r) {
        let i = n.canonical, a = $4324d99ae8520741$var$Rc(e1, t, i.x, i.y, i.z), o = 1 + (r ?? 0) / (0, $1G0Uw.ut), s = a[0] * o, c = a[1] * o, l = a[2] * o, u = [
            s,
            c,
            l,
            1
        ];
        (0, $1G0Uw.Yr)(u, u, this._globeViewProjMatrixF64);
        let d;
        if (o <= 1) {
            let e1 = this._cachedClippingPlane;
            d = e1[0] * a[0] + e1[1] * a[1] + e1[2] * a[2] + e1[3] < 0;
        } else d = this._isLineOfSightBlocked(s, c, l);
        return {
            point: new (0, $1G0Uw.Li)(u[0] / u[3], u[1] / u[3]),
            signedDistanceFromCamera: u[3],
            isOccluded: d
        };
    }
    _isLineOfSightBlocked(e1, t, n) {
        let r = this._cameraPosition, i = e1 - r[0], a = t - r[1], o = n - r[2], s = i * i + a * a + o * o;
        if (s === 0) return !1;
        let c = (0, $1G0Uw.Bn)(-(r[0] * i + r[1] * a + r[2] * o) / s, 0, 1), l = r[0] + c * i, d = r[1] + c * a, f = r[2] + c * o;
        return l * l + d * d + f * f < 1;
    }
    _calcMatrices() {
        let e1 = $4324d99ae8520741$var$Bc(this.worldSize, this.center.lat), t = (0, $1G0Uw.Wn)();
        this._helper.autoCalculateNearFarZ && (this._helper._nearZ = .5, this._helper._farZ = this.cameraToCenterDistance + e1 * 2), (0, $1G0Uw.Ei)(t, this.fovInRadians, this.width / this.height, this._helper._nearZ, this._helper._farZ);
        let n = this.centerOffset;
        t[8] = -n.x * 2 / this._helper._width, t[9] = n.y * 2 / this._helper._height, this._projectionMatrix = (0, $1G0Uw.gi)(t), this._globeProjMatrixInverted = (0, $1G0Uw.Wn)(), (0, $1G0Uw.Ci)(this._globeProjMatrixInverted, t), (0, $1G0Uw.ji)(t, t, [
            0,
            0,
            -this.cameraToCenterDistance
        ]), (0, $1G0Uw.ki)(t, t, this.rollInRadians), (0, $1G0Uw.Di)(t, t, -this.pitchInRadians), (0, $1G0Uw.ki)(t, t, this.bearingInRadians), (0, $1G0Uw.ji)(t, t, [
            0,
            0,
            -e1
        ]);
        let r = (0, $1G0Uw.Gn)();
        r[0] = e1, r[1] = e1, r[2] = e1, (0, $1G0Uw.Di)(t, t, this.center.lat * Math.PI / 180), (0, $1G0Uw.Oi)(t, t, -this.center.lng * Math.PI / 180), (0, $1G0Uw.Ai)(t, t, r), this._globeViewProjMatrixF64 = t, this._globeViewProjMatrix32f = new Float32Array(t), this._globeViewProjMatrixF64Inverted = (0, $1G0Uw.Wn)(), (0, $1G0Uw.Ci)(this._globeViewProjMatrixF64Inverted, t);
        let i = (0, $1G0Uw.Gn)();
        this._cameraPosition = (0, $1G0Uw.Gn)(), this._cameraPosition[2] = this.cameraToCenterDistance / e1, (0, $1G0Uw.si)(this._cameraPosition, this._cameraPosition, i, -this.rollInRadians), (0, $1G0Uw.ai)(this._cameraPosition, this._cameraPosition, i, this.pitchInRadians), (0, $1G0Uw.si)(this._cameraPosition, this._cameraPosition, i, -this.bearingInRadians), (0, $1G0Uw.Xr)(this._cameraPosition, this._cameraPosition, [
            0,
            0,
            1
        ]), (0, $1G0Uw.ai)(this._cameraPosition, this._cameraPosition, i, -this.center.lat * Math.PI / 180), (0, $1G0Uw.oi)(this._cameraPosition, this._cameraPosition, i, this.center.lng * Math.PI / 180), this._cachedClippingPlane = this._computeClippingPlane(e1);
        let o = (0, $1G0Uw.gi)(this._globeViewProjMatrixF64Inverted);
        (0, $1G0Uw.Ai)(o, o, [
            1,
            1,
            -1
        ]), this._cachedFrustum = $4324d99ae8520741$var$_o.fromInvProjectionMatrix(o, 1, 0, this._cachedClippingPlane, !0);
    }
    calculateFogMatrix(e1) {
        (0, $1G0Uw.Nr)(`calculateFogMatrix is not supported on globe projection.`);
        let t = (0, $1G0Uw.Wn)();
        return (0, $1G0Uw.Si)(t), t;
    }
    getVisibleUnwrappedCoordinates(e1) {
        return [
            new (0, $1G0Uw.f)(0, e1)
        ];
    }
    getCameraFrustum() {
        return this._cachedFrustum;
    }
    getClippingPlane() {
        return this._cachedClippingPlane;
    }
    getCoveringTilesDetailsProvider() {
        return this._coveringTilesDetailsProvider;
    }
    recalculateZoomAndCenter(e1) {
        if (e1) {
            (0, $1G0Uw.Nr)(`terrain is not fully supported on vertical perspective projection.`);
            return;
        }
        this._helper.recalculateZoomAndCenter(0);
    }
    maxPitchScaleFactor() {
        return 1;
    }
    getCameraPoint() {
        return this._helper.getCameraPoint();
    }
    getCameraAltitude() {
        return ((0, $1G0Uw.ni)(this._cameraPosition) - 1) * (0, $1G0Uw.ut);
    }
    getCameraLngLat() {
        let e1 = (0, $1G0Uw.Gn)();
        return (0, $1G0Uw.ii)(e1, this._cameraPosition), $4324d99ae8520741$var$Hc(e1);
    }
    lngLatToCameraDepth(e1, t) {
        let n = $4324d99ae8520741$var$zc(e1);
        (0, $1G0Uw.ci)(n, n, 1 + t / (0, $1G0Uw.ut));
        let r = (0, $1G0Uw.Kn)();
        return (0, $1G0Uw.Yr)(r, [
            n[0],
            n[1],
            n[2],
            1
        ], this._globeViewProjMatrixF64), r[2] / r[3];
    }
    populateCache(e1) {}
    getBounds() {
        let e1 = this.width * .5, t = this.height * .5, n = [
            new (0, $1G0Uw.Li)(0, 0),
            new (0, $1G0Uw.Li)(e1, 0),
            new (0, $1G0Uw.Li)(this.width, 0),
            new (0, $1G0Uw.Li)(this.width, t),
            new (0, $1G0Uw.Li)(this.width, this.height),
            new (0, $1G0Uw.Li)(e1, this.height),
            new (0, $1G0Uw.Li)(0, this.height),
            new (0, $1G0Uw.Li)(0, t)
        ], r = [];
        for (let e1 of n)r.push(this.unprojectScreenPoint(e1));
        let i = 0, a = 0, o = 0, s = 0, c = this.center;
        for (let e1 of r){
            let t = (0, $1G0Uw.Xn)(c.lng, e1.lng), n = (0, $1G0Uw.Xn)(c.lat, e1.lat);
            t < a && (a = t), t > i && (i = t), n < s && (s = n), n > o && (o = n);
        }
        let l = [
            c.lng + a,
            c.lat + s,
            c.lng + i,
            c.lat + o
        ];
        return this.isSurfacePointOnScreen([
            0,
            1,
            0
        ]) && (l[3] = 90, l[0] = -180, l[2] = 180), this.isSurfacePointOnScreen([
            0,
            -1,
            0
        ]) && (l[1] = -90, l[0] = -180, l[2] = 180), new $4324d99ae8520741$export$266d2884f61535d3(l);
    }
    calculateCenterFromCameraLngLatAlt(e1, t, n, r) {
        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, n, r);
    }
    calculateCameraOptionsFromTo(e1, t, r, i) {
        let a = (0, $1G0Uw.lt).convert(r), o = $4324d99ae8520741$var$zc((0, $1G0Uw.lt).convert(e1));
        (0, $1G0Uw.ci)(o, o, 1 + t / (0, $1G0Uw.ut));
        let s = $4324d99ae8520741$var$zc(a), c = (0, $1G0Uw.ci)((0, $1G0Uw.Gn)(), s, 1 + i / (0, $1G0Uw.ut)), l = (0, $1G0Uw.di)((0, $1G0Uw.Gn)(), o, s), d = (0, $1G0Uw.ni)(l);
        if (d < $4324d99ae8520741$var$ul || (0, $1G0Uw.$r)(o, c) < $4324d99ae8520741$var$ul) throw Error(`Can't calculate camera options with same From and To`);
        let f = (0, $1G0Uw.Gn)();
        (0, $1G0Uw.oi)(l, l, f, -(0, $1G0Uw.Yn)(a.lng)), (0, $1G0Uw.ai)(l, l, f, (0, $1G0Uw.Yn)(a.lat));
        let p = (0, $1G0Uw.xr)(Math.acos((0, $1G0Uw.Bn)(l[2] / d, -1, 1))), m = Math.hypot(l[0], l[1]) < d * 1e-9 ? this.bearing : (0, $1G0Uw.xr)(Math.atan2(-l[0], -l[1]));
        return {
            center: a,
            elevation: i,
            zoom: (0, $1G0Uw.Dr)(this.cameraToCenterDistance / d / $4324d99ae8520741$var$Bc(this.tileSize, a.lat)),
            pitch: p,
            bearing: m
        };
    }
    setLocationAtPoint(e1, t, n) {
        let r = $4324d99ae8520741$var$zc(this.unprojectScreenPoint(t)), i = $4324d99ae8520741$var$zc(e1), a = (0, $1G0Uw.Gn)();
        (0, $1G0Uw.hi)(a);
        let o = (0, $1G0Uw.Gn)();
        (0, $1G0Uw.oi)(o, r, a, -this.center.lng * Math.PI / 180), (0, $1G0Uw.ai)(o, o, a, this.center.lat * Math.PI / 180);
        let s = i[0] * i[0] + i[2] * i[2], c = o[0] * o[0];
        if (s < c) return;
        let l = Math.sqrt(s - c), d = -l, f = (0, $1G0Uw.In)(i[0], i[2], o[0], l), p = (0, $1G0Uw.In)(i[0], i[2], o[0], d), m = (0, $1G0Uw.Gn)();
        (0, $1G0Uw.oi)(m, i, a, -f);
        let h = (0, $1G0Uw.In)(m[1], m[2], o[1], o[2]), g = (0, $1G0Uw.Gn)();
        (0, $1G0Uw.oi)(g, i, a, -p);
        let _ = (0, $1G0Uw.In)(g[1], g[2], o[1], o[2]), v = Math.PI * .5, y = h >= -v && h <= v, b = _ >= -v && _ <= v, x, S;
        if (y && b) {
            let e1 = this.center.lng * Math.PI / 180, t = this.center.lat * Math.PI / 180, n = (0, $1G0Uw.Zn)(f, e1), r = (0, $1G0Uw.Zn)(h, t), i = (0, $1G0Uw.Zn)(p, e1), a = (0, $1G0Uw.Zn)(_, t);
            n + r < i + a ? (x = f, S = h) : (x = p, S = _);
        } else if (y) x = f, S = h;
        else if (b) x = p, S = _;
        else return;
        let C = x / Math.PI * 180, w = S / Math.PI * 180, T = this.center.lat;
        this.setCenter(new (0, $1G0Uw.lt)(C, (0, $1G0Uw.Bn)(w, -90, 90))), this.setZoom(this.zoom + $4324d99ae8520741$var$Qc(T, this.center.lat));
    }
    locationToScreenPoint(e1, t) {
        let n = $4324d99ae8520741$var$zc(e1);
        if (t) {
            let r = t.getElevationForLngLatZoom(e1, this._helper._tileZoom);
            (0, $1G0Uw.ci)(n, n, 1 + r / (0, $1G0Uw.ut));
        }
        return this._projectSurfacePointToScreen(n);
    }
    _projectSurfacePointToScreen(e1) {
        let t = (0, $1G0Uw.Kn)();
        return (0, $1G0Uw.Yr)(t, [
            ...e1,
            1
        ], this._globeViewProjMatrixF64), t[0] /= t[3], t[1] /= t[3], new (0, $1G0Uw.Li)((t[0] * .5 + .5) * this.width, (-t[1] * .5 + .5) * this.height);
    }
    screenPointToMercatorCoordinate(e1, t) {
        if (t) {
            let n = this.screenTerrainPointToMercatorCoordinate(e1, t);
            if (n) return n;
        }
        return (0, $1G0Uw.nt).fromLngLat(this.unprojectScreenPoint(e1));
    }
    screenTerrainPointToMercatorCoordinate(e1, t) {
        let n = t.getCoverageIndex();
        if (!n) return null;
        let r = this.cameraPosition, i = this.getRayDirectionFromPixel(e1), a = $4324d99ae8520741$var$rl(r, i, 1 + n.maxElevation / (0, $1G0Uw.ut));
        if (!a) return null;
        let o = $4324d99ae8520741$var$rl(r, i, 1 + n.minElevation / (0, $1G0Uw.ut)), s = Math.max(a.tMin, 0), c = o ? o.tMin : a.tMax;
        if (c <= s) return null;
        let l = {
            index: n,
            exaggeration: t.exaggeration,
            origin: r,
            direction: i
        }, u = 0;
        for(let e1 = 0; e1 <= 256; e1++){
            let t = s + (c - s) * e1 / 256;
            if ($4324d99ae8520741$var$pl(l, t)) {
                let { hi: e1 } = $4324d99ae8520741$var$xc(l, $4324d99ae8520741$var$pl, u, t, 1e-12), { sample: n, mercator: r } = $4324d99ae8520741$var$fl(l, e1);
                return new (0, $1G0Uw.nt)(r.x, r.y, n.elevation);
            }
            u = t;
        }
        return null;
    }
    screenPointToLocation(e1, t) {
        return this.screenPointToMercatorCoordinate(e1, t)?.toLngLat();
    }
    screenPointToLocationAtElevation(e1, t) {
        return this.screenPointToLocation(e1);
    }
    isPointOnMapSurface(e1, t) {
        let n = this._cameraPosition;
        return !!$4324d99ae8520741$var$rl(n, this.getRayDirectionFromPixel(e1));
    }
    getRayDirectionFromPixel(e1) {
        let t = (0, $1G0Uw.Kn)();
        t[0] = e1.x / this.width * 2 - 1, t[1] = (e1.y / this.height * 2 - 1) * -1, t[2] = 1, t[3] = 1, (0, $1G0Uw.Yr)(t, t, this._globeViewProjMatrixF64Inverted), t[0] /= t[3], t[1] /= t[3], t[2] /= t[3];
        let n = (0, $1G0Uw.Gn)();
        n[0] = t[0] - this._cameraPosition[0], n[1] = t[1] - this._cameraPosition[1], n[2] = t[2] - this._cameraPosition[2];
        let r = (0, $1G0Uw.Gn)();
        return (0, $1G0Uw.ii)(r, n), r;
    }
    isSurfacePointVisible(e1) {
        let t = this._cachedClippingPlane;
        return t[0] * e1[0] + t[1] * e1[1] + t[2] * e1[2] + t[3] >= 0;
    }
    isSurfacePointOnScreen(e1) {
        if (!this.isSurfacePointVisible(e1)) return !1;
        let t = (0, $1G0Uw.Kn)();
        return (0, $1G0Uw.Yr)(t, [
            ...e1,
            1
        ], this._globeViewProjMatrixF64), t[0] /= t[3], t[1] /= t[3], t[2] /= t[3], t[0] > -1 && t[0] < 1 && t[1] > -1 && t[1] < 1 && t[2] > -1 && t[2] < 1;
    }
    unprojectScreenPoint(e1) {
        let t = this._cameraPosition, n = this.getRayDirectionFromPixel(e1), r = $4324d99ae8520741$var$rl(t, n);
        if (r) {
            let e1 = (0, $1G0Uw.Gn)();
            (0, $1G0Uw.Xr)(e1, t, [
                n[0] * r.tMin,
                n[1] * r.tMin,
                n[2] * r.tMin
            ]);
            let i = (0, $1G0Uw.Gn)();
            return (0, $1G0Uw.ii)(i, e1), $4324d99ae8520741$var$Hc(i);
        }
        let i = this._cachedClippingPlane, a = i[0] * n[0] + i[1] * n[1] + i[2] * n[2], o = -(0, $1G0Uw.br)(i, t) / a, s = (0, $1G0Uw.Gn)();
        if (o > 0) (0, $1G0Uw.Xr)(s, t, [
            n[0] * o,
            n[1] * o,
            n[2] * o
        ]);
        else {
            let e1 = (0, $1G0Uw.Gn)();
            (0, $1G0Uw.Xr)(e1, t, [
                n[0] * 2,
                n[1] * 2,
                n[2] * 2
            ]);
            let r = (0, $1G0Uw.br)(this._cachedClippingPlane, e1);
            (0, $1G0Uw.ui)(s, e1, [
                this._cachedClippingPlane[0] * r,
                this._cachedClippingPlane[1] * r,
                this._cachedClippingPlane[2] * r
            ]);
        }
        let c = $4324d99ae8520741$var$Yc(i);
        return $4324d99ae8520741$var$Hc($4324d99ae8520741$var$Xc(c.center, c.radius, s));
    }
    getProjectionDataForCustomLayer(e1 = !0) {
        let t = this.getProjectionData({
            overscaledTileID: new (0, $1G0Uw.d)(0, 0, 0, 0, 0),
            applyGlobeMatrix: e1
        });
        return t.tileMercatorCoords = [
            0,
            0,
            1,
            1
        ], t;
    }
    getFastPathSimpleProjectionMatrix(e1) {}
};
function $4324d99ae8520741$var$fl(e1, t) {
    let n = (0, $1G0Uw.Gn)();
    (0, $1G0Uw.li)(n, e1.origin, e1.direction, t);
    let r = (0, $1G0Uw.ni)(n), i = (0, $1G0Uw.Gn)();
    (0, $1G0Uw.ci)(i, n, 1 / r);
    let a = $4324d99ae8520741$var$Hc(i), o = (0, $1G0Uw.nt).fromLngLat(a), s = new (0, $1G0Uw.nt)(o.x, (0, $1G0Uw.Bn)(o.y, 0, .999999999)), c = $4324d99ae8520741$var$yc(e1.index, e1.exaggeration, s.x, s.y), l = Math.abs(a.lat) > 85.051129 ? 0 : c.elevation;
    return {
        sample: {
            ...c,
            elevation: l
        },
        radius: r,
        mercator: s
    };
}
function $4324d99ae8520741$var$pl(e1, t) {
    let { sample: n, radius: r } = $4324d99ae8520741$var$fl(e1, t);
    return $4324d99ae8520741$var$bc(n, (r - 1) * (0, $1G0Uw.ut));
}
var $4324d99ae8520741$var$ml = class e1 {
    get pixelsToClipSpaceMatrix() {
        return this._helper.pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._helper.clipSpaceToPixelsMatrix;
    }
    get pixelsToGLUnits() {
        return this._helper.pixelsToGLUnits;
    }
    get centerOffset() {
        return this._helper.centerOffset;
    }
    get size() {
        return this._helper.size;
    }
    get rotationMatrix() {
        return this._helper.rotationMatrix;
    }
    get centerPoint() {
        return this._helper.centerPoint;
    }
    get pixelsPerMeter() {
        return this._helper.pixelsPerMeter;
    }
    setMinZoom(e1) {
        this._helper.setMinZoom(e1);
    }
    setMaxZoom(e1) {
        this._helper.setMaxZoom(e1);
    }
    setMinPitch(e1) {
        this._helper.setMinPitch(e1);
    }
    setMaxPitch(e1) {
        this._helper.setMaxPitch(e1);
    }
    setRenderWorldCopies(e1) {
        this._helper.setRenderWorldCopies(e1);
    }
    setBearing(e1) {
        this._helper.setBearing(e1);
    }
    setPitch(e1) {
        this._helper.setPitch(e1);
    }
    setRoll(e1) {
        this._helper.setRoll(e1);
    }
    setFov(e1) {
        this._helper.setFov(e1);
    }
    setZoom(e1) {
        this._helper.setZoom(e1);
    }
    setCenter(e1) {
        this._helper.setCenter(e1);
    }
    setElevation(e1) {
        this._helper.setElevation(e1);
    }
    setMinElevationForCurrentTile(e1) {
        this._helper.setMinElevationForCurrentTile(e1);
    }
    setPadding(e1) {
        this._helper.setPadding(e1);
    }
    interpolatePadding(e1, t, n) {
        this._helper.interpolatePadding(e1, t, n);
    }
    isPaddingEqual(e1) {
        return this._helper.isPaddingEqual(e1);
    }
    resize(e1, t, n = !0) {
        this._helper.resize(e1, t, n);
    }
    getMaxBounds() {
        return this._helper.getMaxBounds();
    }
    setMaxBounds(e1) {
        this._helper.setMaxBounds(e1);
    }
    setConstrainOverride(e1) {
        this._helper.setConstrainOverride(e1);
    }
    overrideNearFarZ(e1, t) {
        this._helper.overrideNearFarZ(e1, t);
    }
    clearNearFarZOverride() {
        this._helper.clearNearFarZOverride();
    }
    getCameraQueryGeometry(e1) {
        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
    }
    get tileSize() {
        return this._helper.tileSize;
    }
    get tileZoom() {
        return this._helper.tileZoom;
    }
    get scale() {
        return this._helper.scale;
    }
    get worldSize() {
        return this._helper.worldSize;
    }
    get width() {
        return this._helper.width;
    }
    get height() {
        return this._helper.height;
    }
    get lngRange() {
        return this._helper.lngRange;
    }
    get latRange() {
        return this._helper.latRange;
    }
    get minZoom() {
        return this._helper.minZoom;
    }
    get maxZoom() {
        return this._helper.maxZoom;
    }
    get zoom() {
        return this._helper.zoom;
    }
    get center() {
        return this._helper.center;
    }
    get minPitch() {
        return this._helper.minPitch;
    }
    get maxPitch() {
        return this._helper.maxPitch;
    }
    get pitch() {
        return this._helper.pitch;
    }
    get pitchInRadians() {
        return this._helper.pitchInRadians;
    }
    get roll() {
        return this._helper.roll;
    }
    get rollInRadians() {
        return this._helper.rollInRadians;
    }
    get bearing() {
        return this._helper.bearing;
    }
    get bearingInRadians() {
        return this._helper.bearingInRadians;
    }
    get fov() {
        return this._helper.fov;
    }
    get fovInRadians() {
        return this._helper.fovInRadians;
    }
    get elevation() {
        return this._helper.elevation;
    }
    get minElevationForCurrentTile() {
        return this._helper.minElevationForCurrentTile;
    }
    get padding() {
        return this._helper.padding;
    }
    get unmodified() {
        return this._helper.unmodified;
    }
    get renderWorldCopies() {
        return this._helper.renderWorldCopies;
    }
    get cameraToCenterDistance() {
        return this._helper.cameraToCenterDistance;
    }
    get constrainOverride() {
        return this._helper.constrainOverride;
    }
    get nearZ() {
        return this._helper.nearZ;
    }
    get farZ() {
        return this._helper.farZ;
    }
    get autoCalculateNearFarZ() {
        return this._helper.autoCalculateNearFarZ;
    }
    get isGlobeRendering() {
        return this._globeness > 0;
    }
    setTransitionState(e1) {
        this._globeness = e1, this._calcMatrices(), this._verticalPerspectiveTransform.getCoveringTilesDetailsProvider().prepareNextFrame(), this._mercatorTransform.getCoveringTilesDetailsProvider().prepareNextFrame();
    }
    get currentTransform() {
        return this.isGlobeRendering ? this._verticalPerspectiveTransform : this._mercatorTransform;
    }
    constructor(e1){
        this._globeness = 1, this.defaultConstrain = (e1, t)=>this.currentTransform.defaultConstrain(e1, t), this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new $4324d99ae8520741$var$dc({
            calcMatrices: ()=>this._calcMatrices(),
            defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
        }, e1), this._globeness = 1, this._mercatorTransform = new $4324d99ae8520741$var$Sc, this._verticalPerspectiveTransform = new $4324d99ae8520741$var$dl;
    }
    clone() {
        let t = new e1;
        return t._globeness = this._globeness, t.apply(this, !1), t;
    }
    apply(e1, t) {
        this._helper.apply(e1, t), this._mercatorTransform.apply(this, !1), this._verticalPerspectiveTransform.apply(this, !1);
    }
    get projectionMatrix() {
        return this.currentTransform.projectionMatrix;
    }
    get modelViewProjectionMatrix() {
        return this.currentTransform.modelViewProjectionMatrix;
    }
    get inverseProjectionMatrix() {
        return this.currentTransform.inverseProjectionMatrix;
    }
    get cameraPosition() {
        return this.currentTransform.cameraPosition;
    }
    getProjectionData(e1) {
        let t = this._mercatorTransform.getProjectionData(e1), n = this._verticalPerspectiveTransform.getProjectionData(e1);
        return {
            mainMatrix: this.isGlobeRendering ? n.mainMatrix : t.mainMatrix,
            clippingPlane: n.clippingPlane,
            tileMercatorCoords: n.tileMercatorCoords,
            projectionTransition: e1.applyGlobeMatrix ? this._globeness : 0,
            fallbackMatrix: t.fallbackMatrix,
            clipAntimeridian: n.clipAntimeridian
        };
    }
    isLocationOccluded(e1) {
        return this.currentTransform.isLocationOccluded(e1);
    }
    transformLightDirection(e1) {
        return this.currentTransform.transformLightDirection(e1);
    }
    getPixelScale() {
        return (0, $1G0Uw.mr)(this._mercatorTransform.getPixelScale(), this._verticalPerspectiveTransform.getPixelScale(), this._globeness);
    }
    getCircleRadiusCorrection() {
        return (0, $1G0Uw.mr)(this._mercatorTransform.getCircleRadiusCorrection(), this._verticalPerspectiveTransform.getCircleRadiusCorrection(), this._globeness);
    }
    getPitchedTextCorrection(e1, t, n) {
        let r = this._mercatorTransform.getPitchedTextCorrection(e1, t, n), i = this._verticalPerspectiveTransform.getPitchedTextCorrection(e1, t, n);
        return (0, $1G0Uw.mr)(r, i, this._globeness);
    }
    projectTileCoordinates(e1, t, n, r) {
        return this.currentTransform.projectTileCoordinates(e1, t, n, r);
    }
    _calcMatrices() {
        this._helper._width && this._helper._height && (this._verticalPerspectiveTransform.apply(this, !1), this._helper._nearZ = this._verticalPerspectiveTransform.nearZ, this._helper._farZ = this._verticalPerspectiveTransform.farZ, this._mercatorTransform.apply(this, !0, this.isGlobeRendering), this._helper._nearZ = this._mercatorTransform.nearZ, this._helper._farZ = this._mercatorTransform.farZ);
    }
    calculateFogMatrix(e1) {
        return this.currentTransform.calculateFogMatrix(e1);
    }
    getVisibleUnwrappedCoordinates(e1) {
        return this.currentTransform.getVisibleUnwrappedCoordinates(e1);
    }
    getCameraFrustum() {
        return this.currentTransform.getCameraFrustum();
    }
    getClippingPlane() {
        return this.currentTransform.getClippingPlane();
    }
    getCoveringTilesDetailsProvider() {
        return this.currentTransform.getCoveringTilesDetailsProvider();
    }
    recalculateZoomAndCenter(e1) {
        this.currentTransform.recalculateZoomAndCenter(e1);
    }
    maxPitchScaleFactor() {
        return this._mercatorTransform.maxPitchScaleFactor();
    }
    getCameraPoint() {
        return this._helper.getCameraPoint();
    }
    getCameraAltitude() {
        return this.currentTransform.getCameraAltitude();
    }
    getCameraLngLat() {
        return this.currentTransform.getCameraLngLat();
    }
    lngLatToCameraDepth(e1, t) {
        return this.currentTransform.lngLatToCameraDepth(e1, t);
    }
    populateCache(e1) {
        this._mercatorTransform.populateCache(e1), this._verticalPerspectiveTransform.populateCache(e1);
    }
    getBounds() {
        return this.currentTransform.getBounds();
    }
    calculateCenterFromCameraLngLatAlt(e1, t, n, r) {
        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, n, r);
    }
    calculateCameraOptionsFromTo(e1, t, n, r) {
        return this.currentTransform.calculateCameraOptionsFromTo(e1, t, n, r);
    }
    setLocationAtPoint(e1, t, n) {
        if (!this.isGlobeRendering) {
            this._mercatorTransform.setLocationAtPoint(e1, t, n), this.apply(this._mercatorTransform, !1);
            return;
        }
        this._verticalPerspectiveTransform.setLocationAtPoint(e1, t, n), this.apply(this._verticalPerspectiveTransform, !1);
    }
    locationToScreenPoint(e1, t) {
        return this.currentTransform.locationToScreenPoint(e1, t);
    }
    screenPointToMercatorCoordinate(e1, t) {
        return this.currentTransform.screenPointToMercatorCoordinate(e1, t);
    }
    screenTerrainPointToMercatorCoordinate(e1, t) {
        return this.currentTransform.screenTerrainPointToMercatorCoordinate(e1, t);
    }
    screenPointToLocation(e1, t) {
        return this.currentTransform.screenPointToLocation(e1, t);
    }
    screenPointToLocationAtElevation(e1, t) {
        return this.currentTransform.screenPointToLocationAtElevation(e1, t);
    }
    isPointOnMapSurface(e1, t) {
        return this.currentTransform.isPointOnMapSurface(e1, t);
    }
    getRayDirectionFromPixel(e1) {
        return this._verticalPerspectiveTransform.getRayDirectionFromPixel(e1);
    }
    getProjectionDataForCustomLayer(e1 = !0) {
        let t = this._mercatorTransform.getProjectionDataForCustomLayer(e1);
        if (!this.isGlobeRendering) return t;
        let n = this._verticalPerspectiveTransform.getProjectionDataForCustomLayer(e1);
        return n.fallbackMatrix = t.mainMatrix, n.projectionTransition = this._globeness, n;
    }
    getFastPathSimpleProjectionMatrix(e1) {
        return this.currentTransform.getFastPathSimpleProjectionMatrix(e1);
    }
}, $4324d99ae8520741$var$hl = class e1 {
    get useGlobeControls() {
        return !0;
    }
    handlePanInertia(e1, t) {
        let n = $4324d99ae8520741$var$el(e1, t);
        return Math.abs(n.lng - t.center.lng) > 180 && (n.lng = t.center.lng + 179.5 * Math.sign(n.lng - t.center.lng)), {
            easingCenter: n,
            easingOffset: new (0, $1G0Uw.Li)(0, 0)
        };
    }
    handleMapControlsRollPitchBearingZoom(e1, t) {
        let n = e1.around, r = t.screenPointToLocation(n);
        e1.bearingDelta && t.setBearing(t.bearing + e1.bearingDelta), e1.pitchDelta && t.setPitch(t.pitch + e1.pitchDelta), e1.rollDelta && t.setRoll(t.roll + e1.rollDelta);
        let i = t.zoom;
        e1.zoomDelta && t.setZoom(t.zoom + e1.zoomDelta);
        let a = t.zoom - i;
        if (a === 0) return;
        let o = (0, $1G0Uw.Xn)(t.center.lng, r.lng), s = o / (Math.abs(o / 180) + 1), c = (0, $1G0Uw.Xn)(t.center.lat, r.lat), l = t.getRayDirectionFromPixel(n), d = t.cameraPosition, f = (0, $1G0Uw.ei)(d, l) * -1, p = (0, $1G0Uw.Gn)();
        (0, $1G0Uw.Xr)(p, d, [
            l[0] * f,
            l[1] * f,
            l[2] * f
        ]);
        let m = (0, $1G0Uw.ni)(p), h = m - 1, g = Math.exp(-Math.max(h - .3, 0) * .5), _ = (0, $1G0Uw.wr)(m, .95, .999, 0, 1), v = $4324d99ae8520741$var$Bc(t.worldSize, t.center.lat) / Math.min(t.width, t.height), y = (0, $1G0Uw.wr)(v, .9, .5, 1, .25), b = Math.min(g, (0, $1G0Uw.mr)(1, y, _)), x = (1 - (0, $1G0Uw.Fr)(-a)) * b, S = t.center.lat, C = t.zoom, w = new (0, $1G0Uw.lt)(t.center.lng + s * x, (0, $1G0Uw.Bn)(t.center.lat + c * x, -(0, $1G0Uw.Fn), (0, $1G0Uw.Fn)));
        t.setLocationAtPoint(r, n);
        let T = t.center, E = (0, $1G0Uw.wr)(Math.abs(o), 45, 85, 0, 1), D = Math.max(E, _) ** .25, O = (0, $1G0Uw.Xn)(T.lng, w.lng), j = (0, $1G0Uw.Xn)(T.lat, w.lat);
        t.setCenter(new (0, $1G0Uw.lt)(T.lng + O * D, T.lat + j * D).wrap()), t.setZoom(C + $4324d99ae8520741$var$Qc(S, t.center.lat));
    }
    handleMapControlsPan(e1, t, n) {
        e1.panDelta && $4324d99ae8520741$var$qc(t, n, t.isPointOnMapSurface(e1.around) ? e1.around : t.centerPoint, e1.panDelta);
    }
    cameraForBoxAndBearing(t, n, r, i, a) {
        let o = $4324d99ae8520741$var$Dc(t, n, r, i, a), s = n.left / a.width * 2 - 1, c = (a.width - n.right) / a.width * 2 - 1, l = n.top / a.height * -2 + 1, u = (a.height - n.bottom) / a.height * -2 + 1, d = (0, $1G0Uw.Xn)(r.getWest(), r.getEast()) < 0, f = d ? r.getEast() : r.getWest(), p = d ? r.getWest() : r.getEast(), m = Math.max(r.getNorth(), r.getSouth()), h = Math.min(r.getNorth(), r.getSouth()), g = f + (0, $1G0Uw.Xn)(f, p) * .5, _ = m + (0, $1G0Uw.Xn)(m, h) * .5, v = a.clone();
        v.setCenter(o.center), v.setBearing(o.bearing), v.setPitch(0), v.setRoll(0), v.setZoom(o.zoom);
        let y = v.modelViewProjectionMatrix, x = [
            $4324d99ae8520741$var$zc(r.getNorthWest()),
            $4324d99ae8520741$var$zc(r.getNorthEast()),
            $4324d99ae8520741$var$zc(r.getSouthWest()),
            $4324d99ae8520741$var$zc(r.getSouthEast()),
            $4324d99ae8520741$var$zc(new (0, $1G0Uw.lt)(p, _)),
            $4324d99ae8520741$var$zc(new (0, $1G0Uw.lt)(f, _)),
            $4324d99ae8520741$var$zc(new (0, $1G0Uw.lt)(g, m)),
            $4324d99ae8520741$var$zc(new (0, $1G0Uw.lt)(g, h))
        ], S = $4324d99ae8520741$var$zc(o.center), C = 1 / 0;
        for (let t of x)s < 0 && (C = e1.getLesserNonNegativeNonNull(C, e1.solveVectorScale(t, S, y, `x`, s))), c > 0 && (C = e1.getLesserNonNegativeNonNull(C, e1.solveVectorScale(t, S, y, `x`, c))), l > 0 && (C = e1.getLesserNonNegativeNonNull(C, e1.solveVectorScale(t, S, y, `y`, l))), u < 0 && (C = e1.getLesserNonNegativeNonNull(C, e1.solveVectorScale(t, S, y, `y`, u)));
        if (!Number.isFinite(C) || C === 0) {
            $4324d99ae8520741$var$Tc();
            return;
        }
        return o.zoom = Math.min(v.zoom + (0, $1G0Uw.Dr)(C), t.maxZoom), o;
    }
    handleJumpToCenterZoom(e1, t) {
        let n = e1.center.lat, r = e1.applyConstrain(t.center ? (0, $1G0Uw.lt).convert(t.center) : e1.center, e1.zoom).center;
        e1.setCenter(r.wrap());
        let i = t.zoom === void 0 ? e1.zoom + $4324d99ae8520741$var$Qc(n, r.lat) : +t.zoom;
        e1.zoom !== i && e1.setZoom(i);
    }
    handleEaseTo(e1, t) {
        let n = e1.zoom, r = e1.center, i = e1.padding, a = {
            roll: e1.roll,
            pitch: e1.pitch,
            bearing: e1.bearing
        }, o = {
            roll: t.roll === void 0 ? e1.roll : t.roll,
            pitch: t.pitch === void 0 ? e1.pitch : t.pitch,
            bearing: t.bearing === void 0 ? e1.bearing : t.bearing
        }, s = t.zoom !== void 0, c = !e1.isPaddingEqual(t.padding), l = !1, d = t.center ? (0, $1G0Uw.lt).convert(t.center) : r, f = e1.applyConstrain(d, n).center;
        $4324d99ae8520741$var$lc(e1, f);
        let p = e1.clone();
        p.setCenter(f), p.setZoom(s ? +t.zoom : n + $4324d99ae8520741$var$Qc(r.lat, d.lat)), p.setBearing(t.bearing);
        let m = new (0, $1G0Uw.Li)((0, $1G0Uw.Bn)(e1.centerPoint.x + t.offsetAsPoint.x, 0, e1.width), (0, $1G0Uw.Bn)(e1.centerPoint.y + t.offsetAsPoint.y, 0, e1.height));
        p.setLocationAtPoint(f, m);
        let h = (t.offset && t.offsetAsPoint.mag()) > 0 ? p.center : f, g = s ? +t.zoom : n + $4324d99ae8520741$var$Qc(r.lat, h.lat), _ = n + $4324d99ae8520741$var$Qc(r.lat, 0), v = g + $4324d99ae8520741$var$Qc(h.lat, 0), y = (0, $1G0Uw.Xn)(r.lng, h.lng), b = (0, $1G0Uw.Xn)(r.lat, h.lat), x = (0, $1G0Uw.Fr)(v - _);
        return l = g !== n, {
            easeFunc: (n)=>{
                if ((0, $1G0Uw.Tr)(a, o) || $4324d99ae8520741$var$Ec({
                    startEulerAngles: a,
                    endEulerAngles: o,
                    tr: e1,
                    k: n,
                    useSlerp: a.roll != o.roll
                }), c && e1.interpolatePadding(i, t.padding, n), t.around) (0, $1G0Uw.Nr)(`Easing around a point is not supported under globe projection.`), e1.setLocationAtPoint(t.around, t.aroundPoint);
                else {
                    let t = n * (v > _ ? Math.min(2, x) : Math.max(.5, x)) ** (1 - n), i = $4324d99ae8520741$var$nl(r, y, b, t);
                    e1.setCenter(i.wrap());
                }
                if (l) {
                    let t = (0, $1G0Uw.un).number(_, v, n) + $4324d99ae8520741$var$Qc(0, e1.center.lat);
                    e1.setZoom(t);
                }
            },
            isZooming: l,
            elevationCenter: h
        };
    }
    handleFlyTo(e1, t) {
        let n = t.zoom !== void 0, r = e1.center, i = e1.zoom, a = e1.padding, o = !e1.isPaddingEqual(t.padding), s = e1.applyConstrain((0, $1G0Uw.lt).convert(t.center || t.locationAtOffset), i).center, c = n ? +t.zoom : e1.zoom + $4324d99ae8520741$var$Qc(e1.center.lat, s.lat), l = e1.clone();
        l.setCenter(s), l.setZoom(c), l.setBearing(t.bearing);
        let d = new (0, $1G0Uw.Li)((0, $1G0Uw.Bn)(e1.centerPoint.x + t.offsetAsPoint.x, 0, e1.width), (0, $1G0Uw.Bn)(e1.centerPoint.y + t.offsetAsPoint.y, 0, e1.height));
        l.setLocationAtPoint(s, d);
        let f = l.center;
        $4324d99ae8520741$var$lc(e1, f);
        let p = $4324d99ae8520741$var$Fc(e1, r, f), m = i + $4324d99ae8520741$var$Qc(r.lat, 0), h = c + $4324d99ae8520741$var$Qc(f.lat, 0), g = (0, $1G0Uw.Fr)(h - m), _ = typeof t.minZoom == `number` ? +t.minZoom : e1.minZoom, v = Math.max(_, e1.minZoom) + $4324d99ae8520741$var$Qc(f.lat, 0), y = Math.min(v, m, h) + $4324d99ae8520741$var$Qc(0, f.lat), x = e1.applyConstrain(f, y).zoom + $4324d99ae8520741$var$Qc(f.lat, 0), S = (0, $1G0Uw.Fr)(x - m), C = (0, $1G0Uw.Xn)(r.lng, f.lng), w = (0, $1G0Uw.Xn)(r.lat, f.lat);
        return {
            easeFunc: (n, i, s, l)=>{
                let u = $4324d99ae8520741$var$nl(r, C, w, s);
                o && e1.interpolatePadding(a, t.padding, n);
                let d = n === 1 ? f : u;
                e1.setCenter(d.wrap());
                let p = m + (0, $1G0Uw.Dr)(i);
                e1.setZoom(n === 1 ? c : p + $4324d99ae8520741$var$Qc(0, d.lat));
            },
            scaleOfZoom: g,
            targetCenter: f,
            scaleOfMinZoom: S,
            pixelPathLength: p
        };
    }
    static solveVectorScale(e1, t, n, r, i) {
        let a = i, o = r === `x` ? [
            n[0],
            n[4],
            n[8],
            n[12]
        ] : [
            n[1],
            n[5],
            n[9],
            n[13]
        ], s = [
            n[3],
            n[7],
            n[11],
            n[15]
        ], c = e1[0] * o[0] + e1[1] * o[1] + e1[2] * o[2], l = e1[0] * s[0] + e1[1] * s[1] + e1[2] * s[2], u = t[0] * o[0] + t[1] * o[1] + t[2] * o[2], d = t[0] * s[0] + t[1] * s[1] + t[2] * s[2], f = (u + o[3] - a * d - a * s[3]) / (u - c - a * d + a * l);
        return u + a * l === c + a * d || s[3] * (c - u) + o[3] * (d - l) + c * d === u * l ? null : f;
    }
    static getLesserNonNegativeNonNull(e1, t) {
        return t !== null && t >= 0 && t < e1 ? t : e1;
    }
}, $4324d99ae8520741$var$gl = class {
    constructor(e1){
        this._globe = e1, this._mercatorCameraHelper = new $4324d99ae8520741$var$Oc, this._verticalPerspectiveCameraHelper = new $4324d99ae8520741$var$hl;
    }
    get useGlobeControls() {
        return this._globe.useGlobeRendering;
    }
    get currentHelper() {
        return this.useGlobeControls ? this._verticalPerspectiveCameraHelper : this._mercatorCameraHelper;
    }
    handlePanInertia(e1, t) {
        return this.currentHelper.handlePanInertia(e1, t);
    }
    handleMapControlsRollPitchBearingZoom(e1, t) {
        this.currentHelper.handleMapControlsRollPitchBearingZoom(e1, t);
    }
    handleMapControlsPan(e1, t, n) {
        this.currentHelper.handleMapControlsPan(e1, t, n);
    }
    cameraForBoxAndBearing(e1, t, n, r, i) {
        return this.currentHelper.cameraForBoxAndBearing(e1, t, n, r, i);
    }
    handleJumpToCenterZoom(e1, t) {
        this.currentHelper.handleJumpToCenterZoom(e1, t);
    }
    handleEaseTo(e1, t) {
        return this.currentHelper.handleEaseTo(e1, t);
    }
    handleFlyTo(e1, t) {
        return this.currentHelper.handleFlyTo(e1, t);
    }
};
function $4324d99ae8520741$var$_l(e1, t, n) {
    let r = {
        constrainOverride: t
    };
    if (Array.isArray(e1)) {
        let t = new $4324d99ae8520741$var$Nc({
            type: e1
        }, n);
        return {
            projection: t,
            transform: new $4324d99ae8520741$var$ml(r),
            cameraHelper: new $4324d99ae8520741$var$gl(t)
        };
    }
    switch(e1){
        case `mercator`:
            return {
                projection: new $4324d99ae8520741$var$sc,
                transform: new $4324d99ae8520741$var$Sc(r),
                cameraHelper: new $4324d99ae8520741$var$Oc
            };
        case `globe`:
            {
                let e1 = new $4324d99ae8520741$var$Nc({
                    type: [
                        `interpolate`,
                        [
                            `linear`
                        ],
                        [
                            `zoom`
                        ],
                        11,
                        `vertical-perspective`,
                        12,
                        `mercator`
                    ]
                }, {});
                return {
                    projection: e1,
                    transform: new $4324d99ae8520741$var$ml(r),
                    cameraHelper: new $4324d99ae8520741$var$gl(e1)
                };
            }
        case `vertical-perspective`:
            return {
                projection: new $4324d99ae8520741$var$Mc,
                transform: new $4324d99ae8520741$var$dl(r),
                cameraHelper: new $4324d99ae8520741$var$hl
            };
        default:
            return (0, $1G0Uw.Nr)(`Unknown projection name: ${e1}. Falling back to mercator projection.`), {
                projection: new $4324d99ae8520741$var$sc,
                transform: new $4324d99ae8520741$var$Sc(r),
                cameraHelper: new $4324d99ae8520741$var$Oc
            };
    }
}
const $4324d99ae8520741$var$vl = $4324d99ae8520741$var$hi();
var $4324d99ae8520741$export$d9e45bc13d335801 = class extends (0, $1G0Uw.vn) {
    constructor(e1, t = {}){
        super(), this._rtlPluginLoaded = ()=>{
            for(let e1 in this.tileManagers){
                let t = this.tileManagers[e1].getSource().type;
                (t === `vector` || t === `geojson`) && this.tileManagers[e1].reload();
            }
        }, this.map = e1, this.dispatcher = new $4324d99ae8520741$var$ra($4324d99ae8520741$var$ea(), e1._getMapId()), this.dispatcher.registerMessageHandler(`GG`, (e1, t)=>this.getGlyphs(e1, t)), this.dispatcher.registerMessageHandler(`GI`, (e1, t)=>this.getImages(e1, t)), this.dispatcher.registerMessageHandler(`GDA`, (e1, t)=>this.getDashes(e1, t)), this.imageManager = new $4324d99ae8520741$var$bi, this.imageManager.setEventedParent(this), this.imageManager.setMissingImageResolver(e1._missingStyleImageResolver), this.patternAtlas = new $4324d99ae8520741$var$xi(this.imageManager);
        let n = e1._container?.lang || typeof document < `u` && document.documentElement?.lang || void 0;
        this.glyphManager = new $4324d99ae8520741$var$Ii(e1._requestManager, t.localIdeographFontFamily, n), this.lineAtlas = new $4324d99ae8520741$var$Ui(256, 512), this.crossTileSymbolIndex = new $4324d99ae8520741$var$Js, this._setInitialValues(), this._resetUpdates(), this.dispatcher.broadcast(`SR`, (0, $1G0Uw.Cn)()), $4324d99ae8520741$var$fo().on($4324d99ae8520741$var$co, this._rtlPluginLoaded), this.on(`data`, (e1)=>{
            if (e1.dataType !== `source` || e1.sourceDataType !== `metadata`) return;
            let t = this.tileManagers[e1.sourceId];
            if (!t) return;
            let n = t.getSource();
            if (n?.vectorLayerIds) for(let e1 in this._layers){
                let t = this._layers[e1];
                t.source === n.id && this._validateLayer(t);
            }
        });
    }
    _setInitialValues() {
        this._layers = {}, this._order = [], this.tileManagers = {}, this.zoomHistory = new (0, $1G0Uw.tn), this._imagesListDirty = !1, this._globalState = {}, this._serializedLayers = {}, this.stylesheet = null, this.light = null, this.sky = null, this.projection && (this.projection.destroy(), delete this.projection), this._loaded = !1, this._changed = !1, this._updatedLayers = {}, this._updatedSources = {}, this._changedImages = {}, this._glyphsDidChange = !1, this._updatedPaintProps = {}, this._layerOrderChanged = !1, this._symbolPlacementTriggered = !1, this._placedProjectionTransition = void 0, this.crossTileSymbolIndex = new (this.crossTileSymbolIndex?.constructor || Object), this.pauseablePlacement = void 0, this.placement = void 0, this.z = 0;
    }
    setGlobalStateProperty(e1, t) {
        this._checkLoaded();
        let n = t === null ? this.stylesheet.state?.[e1]?.default ?? null : t;
        if ((0, $1G0Uw.qn)(n, this._globalState[e1])) return this;
        this._globalState[e1] = n, this._applyGlobalStateChanges([
            e1
        ]);
    }
    getGlobalState() {
        return this._globalState;
    }
    setGlobalState(e1) {
        this._checkLoaded();
        let t = [];
        for(let n in e1)(0, $1G0Uw.qn)(this._globalState[n], e1[n].default) || (t.push(n), this._globalState[n] = e1[n].default);
        this._applyGlobalStateChanges(t);
    }
    _applyGlobalStateChanges(e1) {
        if (e1.length === 0) return;
        let t = new Set, n = {};
        for (let r of e1){
            n[r] = this._globalState[r];
            for(let e1 in this._layers){
                let n = this._layers[e1], i = n.getLayoutAffectingGlobalStateRefs(), a = n.getPaintAffectingGlobalStateRefs(), o = n.getVisibilityAffectingGlobalStateRefs();
                if (i.has(r) && t.add(n.source), a.has(r)) for (let { name: e1, value: t } of a.get(r))this._updatePaintProperty(n, e1, t);
                o?.has(r) && (n.recalculateVisibility(), this._updateLayer(n));
            }
        }
        this.dispatcher.broadcast(`UGS`, n);
        for(let e1 in this.tileManagers)t.has(e1) && (this._reloadSource(e1), this._changed = !0);
    }
    async loadURL(e1, t = {}, n) {
        this.fire(new $4324d99ae8520741$export$49025a11e3fe5bd0(`dataloading`)), t.validate = typeof t.validate != `boolean` || t.validate, this._loadStyleRequest = new AbortController;
        let r = this._loadStyleRequest;
        try {
            let i = await this.map._requestManager.transformRequest(e1, `Style`);
            (0, $1G0Uw.Nn)(r.signal);
            let a = await (0, $1G0Uw.Sn)(i, r);
            this._loadStyleRequest === r && (this._loadStyleRequest = null), this._load(a.data, t, n);
        } catch (e1) {
            this._loadStyleRequest === r && (this._loadStyleRequest = null), e1 && !r.signal.aborted && this.fire(new (0, $1G0Uw.gn)((0, $1G0Uw.Qn)(e1)));
        }
    }
    loadJSON(e1, t = {}, n) {
        this.fire(new $4324d99ae8520741$export$49025a11e3fe5bd0(`dataloading`)), this._frameRequest = new AbortController, $4324d99ae8520741$var$Rr.frameAsync(this._frameRequest, this.map._ownerWindow).then(()=>{
            this._frameRequest = null, t.validate = t.validate !== !1, this._load(e1, t, n);
        }).catch(()=>{});
    }
    loadEmpty() {
        this.fire(new $4324d99ae8520741$export$49025a11e3fe5bd0(`dataloading`)), this._load($4324d99ae8520741$var$vl, {
            validate: !1
        });
    }
    _load(e1, t, n) {
        let r = t.transformStyle ? t.transformStyle(n, e1) : e1;
        if (!(t.validate && (0, $1G0Uw.sn)(this, r))) {
            r = {
                ...r
            }, this._loaded = !0, this.stylesheet = r;
            for(let e1 in r.sources)this.addSource(e1, r.sources[e1], {
                validate: !1
            });
            r.sprite ? this._loadSprite(r.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(r.glyphs), this.glyphManager.setFontFaces(r[`font-faces`]), this._createLayers(), this.light = new $4324d99ae8520741$var$zi(this.stylesheet.light ?? {}, this._globalState), this._setProjectionInternal(this.stylesheet.projection?.type || `mercator`), this.sky = new $4324d99ae8520741$var$Hi(this.stylesheet.sky, this._globalState), this.map.setTerrain(this.stylesheet.terrain ?? null, {
                validate: !1
            }), this.fire(new $4324d99ae8520741$export$49025a11e3fe5bd0(`data`)), this.fire(new $4324d99ae8520741$export$444e55cd0e2f4f3a);
        }
    }
    _createLayers() {
        let e1 = $4324d99ae8520741$var$ri(this.stylesheet.layers);
        this.setGlobalState(this.stylesheet.state ?? null), this.dispatcher.broadcast(`SL`, e1), this._order = e1.map((e1)=>e1.id), this._layers = {}, this._serializedLayers = null;
        for (let t of e1){
            let e1 = (0, $1G0Uw._)(t, this._globalState);
            if (e1.setEventedParent(this, {
                layer: {
                    id: t.id
                }
            }), this._layers[t.id] = e1, (0, $1G0Uw.Xt)(e1) && this.tileManagers[e1.source]) {
                let n = t.paint?.[`raster-fade-duration`] ?? e1.paint.get(`raster-fade-duration`);
                this.tileManagers[e1.source].setRasterFadeDuration(n);
            }
        }
    }
    async _loadSprite(e1, t = !1, n) {
        this.imageManager.setLoaded(!1);
        let r = new AbortController;
        this._spriteRequest = r;
        let i;
        try {
            let n = await $4324d99ae8520741$var$vi(e1, this.map._requestManager, this.map.getPixelRatio(), r);
            if (!n) return;
            for(let e1 in n){
                let { loaded: r, removed: i } = this.imageManager.setSpriteImages(e1, n[e1]);
                this._markImagesChanged(i), t && this._markImagesChanged(r);
            }
        } catch (e1) {
            i = e1, r.signal.aborted || this.fire(new (0, $1G0Uw.gn)(i));
        } finally{
            this._spriteRequest = null, this.imageManager.setLoaded(!0), t && (this._changed = !0), this.dispatcher.broadcast(`SI`, this.imageManager.listImages()), this.fire(new $4324d99ae8520741$export$49025a11e3fe5bd0(`data`)), n?.(i);
        }
    }
    _unloadSprite() {
        this._markImagesChanged(this.imageManager.removeAllSpriteImages()), this._imagesListDirty = !0, this._changed = !0, this.fire(new $4324d99ae8520741$export$49025a11e3fe5bd0(`data`));
    }
    _validateLayer(e1) {
        let t = this.tileManagers[e1.source];
        if (!t) return;
        let n = e1.sourceLayer;
        if (!n) return;
        let r = t.getSource();
        (r.type === `geojson` || r.vectorLayerIds && !r.vectorLayerIds.includes(n)) && this.fire(new (0, $1G0Uw.gn)(Error(`Source layer "${n}" does not exist on source "${r.id}" as specified by style layer "${e1.id}".`)));
    }
    loaded() {
        if (!this._loaded || Object.keys(this._updatedSources).length) return !1;
        for(let e1 in this.tileManagers)if (!this.tileManagers[e1].loaded()) return !1;
        return this.imageManager.isLoaded();
    }
    _serializeByIds(e1, t = !1) {
        let n = this._serializedAllLayers();
        if (!e1 || e1.length === 0) return Object.values(t ? (0, $1G0Uw.Vn)(n) : n);
        let r = [];
        for (let i of e1)if (n[i]) {
            let e1 = t ? (0, $1G0Uw.Vn)(n[i]) : n[i];
            r.push(e1);
        }
        return r;
    }
    _serializedAllLayers() {
        let e1 = this._serializedLayers;
        if (e1) return e1;
        e1 = this._serializedLayers = {};
        let t = Object.keys(this._layers);
        for (let n of t){
            let t = this._layers[n];
            t.type !== `custom` && (e1[n] = t.serialize());
        }
        return e1;
    }
    hasTransitions() {
        if (this.light?.hasTransition() || this.sky?.hasTransition() || this.projection?.hasTransition()) return !0;
        for(let e1 in this.tileManagers)if (this.tileManagers[e1].hasTransition()) return !0;
        for(let e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
        return !1;
    }
    _checkLoaded() {
        if (!this._loaded) throw Error(`Style is not done loading.`);
    }
    update(e1) {
        if (!this._loaded) return;
        let t = this._changed;
        if (t) {
            this._imagesListDirty &&= (this.dispatcher.broadcast(`SI`, this.imageManager.listImages()), !1);
            let t = Object.keys(this._updatedLayers), n = Object.keys(this._removedLayers);
            (t.length || n.length) && this._updateWorkerLayers(t, n);
            for(let e1 in this._updatedSources){
                let t = this._updatedSources[e1];
                if (t === `reload`) this._reloadSource(e1);
                else if (t === `clear`) this._clearSource(e1);
                else throw Error(`Invalid action ${t}`);
            }
            this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
            for(let t in this._updatedPaintProps)this._layers[t].updateTransitions(e1);
            this._resetUpdates();
        }
        let n = {};
        for(let e1 in this.tileManagers){
            let t = this.tileManagers[e1];
            n[e1] = t.used, t.used = !1;
        }
        let r = this.imageManager.listImages();
        for (let t of this._order){
            let n = this._layers[t];
            n.recalculate(e1, r), !n.isHidden(e1.zoom) && n.source && (this.tileManagers[n.source].used = !0);
        }
        for(let e1 in n){
            let t = this.tileManagers[e1];
            !!n[e1] != !!t.used && t.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
                sourceDataType: `visibility`,
                sourceId: e1
            }));
        }
        this.light.recalculate(e1), this.sky.recalculate(e1), this.projection.recalculate(e1), this.z = e1.zoom, t && this.fire(new $4324d99ae8520741$export$49025a11e3fe5bd0(`data`));
    }
    _updateTilesForChangedImages() {
        let e1 = Object.keys(this._changedImages);
        if (e1.length) {
            for(let t in this.tileManagers)this.tileManagers[t].reloadTilesForDependencies([
                `icons`,
                `patterns`
            ], e1);
            this._changedImages = {};
        }
    }
    _updateTilesForChangedGlyphs() {
        if (this._glyphsDidChange) {
            for(let e1 in this.tileManagers)this.tileManagers[e1].reloadTilesForDependencies([
                `glyphs`
            ], [
                ``
            ]);
            this._glyphsDidChange = !1;
        }
    }
    _updateWorkerLayers(e1, t) {
        this.dispatcher.broadcast(`UL`, {
            layers: this._serializeByIds(e1, !1),
            removedIds: t
        });
    }
    _resetUpdates() {
        this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
    }
    setState(e1, t = {}) {
        this._checkLoaded();
        let n = this.serialize();
        if (e1 = t.transformStyle ? t.transformStyle(n, e1) : e1, (t.validate ?? !0) && (0, $1G0Uw.sn)(this, e1)) return !1;
        e1 = (0, $1G0Uw.Vn)(e1), e1.layers = $4324d99ae8520741$var$ri(e1.layers);
        let r = $4324d99ae8520741$var$mi(n, e1), i = this._getOperationsToPerform(r);
        if (i.unimplemented.length > 0) throw Error(`Unimplemented: ${i.unimplemented.join(`, `)}.`);
        if (i.operations.length === 0) return !1;
        for (let e1 of i.operations)e1();
        return this.stylesheet = e1, this._serializedLayers = null, this.fire(new $4324d99ae8520741$export$444e55cd0e2f4f3a({
            style: this
        })), !0;
    }
    _getOperationsToPerform(e1) {
        let t = [], n = [];
        for (let r of e1)switch(r.command){
            case `setCenter`:
            case `setZoom`:
            case `setBearing`:
            case `setPitch`:
            case `setRoll`:
                continue;
            case `addLayer`:
                t.push(()=>this.addLayer.apply(this, r.args));
                break;
            case `removeLayer`:
                t.push(()=>this.removeLayer.apply(this, r.args));
                break;
            case `setPaintProperty`:
                t.push(()=>this.setPaintProperty.apply(this, r.args));
                break;
            case `setLayoutProperty`:
                t.push(()=>this.setLayoutProperty.apply(this, r.args));
                break;
            case `setFilter`:
                t.push(()=>this.setFilter.apply(this, r.args));
                break;
            case `addSource`:
                t.push(()=>this.addSource.apply(this, r.args));
                break;
            case `removeSource`:
                t.push(()=>this.removeSource.apply(this, r.args));
                break;
            case `setLayerZoomRange`:
                t.push(()=>this.setLayerZoomRange.apply(this, r.args));
                break;
            case `setLight`:
                t.push(()=>this.setLight.apply(this, r.args));
                break;
            case `setGeoJSONSourceData`:
                t.push(()=>this.setGeoJSONSourceData.apply(this, r.args));
                break;
            case `setGlyphs`:
                t.push(()=>this.setGlyphs.apply(this, r.args));
                break;
            case `setFontFaces`:
                t.push(()=>this.setFontFaces.apply(this, r.args));
                break;
            case `setSprite`:
                t.push(()=>this.setSprite.apply(this, r.args));
                break;
            case `setTerrain`:
                t.push(()=>this.map.setTerrain.apply(this, r.args));
                break;
            case `setSky`:
                t.push(()=>this.setSky.apply(this, r.args));
                break;
            case `setProjection`:
                this.setProjection.apply(this, r.args);
                break;
            case `setGlobalState`:
                t.push(()=>this.setGlobalState.apply(this, r.args));
                break;
            case `setTransition`:
                t.push(()=>{});
                break;
            default:
                n.push(r.command);
        }
        return {
            operations: t,
            unimplemented: n
        };
    }
    addImage(e1, t) {
        if (this.getImage(e1)) {
            this.fire(new (0, $1G0Uw.gn)(Error(`An image named "${e1}" already exists.`)));
            return;
        }
        this.imageManager.addImage(e1, t), this._afterImageUpdated(e1);
    }
    updateImage(e1, t) {
        this.imageManager.updateImage(e1, t);
    }
    getImage(e1) {
        return this.imageManager.getImage(e1);
    }
    setMissingImageResolver(e1) {
        this.imageManager.setMissingImageResolver(e1);
    }
    removeImage(e1) {
        if (!this.getImage(e1)) {
            this.fire(new (0, $1G0Uw.gn)(Error(`An image named "${e1}" does not exist.`)));
            return;
        }
        this.imageManager.removeImage(e1), this._afterImageUpdated(e1);
    }
    _markImagesChanged(e1) {
        for (let t of e1)this._changedImages[t] = !0;
    }
    _afterImageUpdated(e1) {
        this._changedImages[e1] = !0, this._imagesListDirty = !0, this._changed = !0, this.fire(new $4324d99ae8520741$export$49025a11e3fe5bd0(`data`));
    }
    listImages() {
        return this._checkLoaded(), this.imageManager.listImages();
    }
    addSource(e1, t, n = {}) {
        if (this._checkLoaded(), this.tileManagers[e1] !== void 0) throw Error(`Source "${e1}" already exists.`);
        if (!t.type) throw Error(`The type property must be defined, but only the following properties were given: ${Object.keys(t).join(`, `)}.`);
        if ((0, $1G0Uw.rn).has(t.type) && this._validate((0, $1G0Uw.on).source, `sources.${e1}`, t, null, n)) return;
        this.map?._collectResourceTiming && (t.collectResourceTiming = !0);
        let r = this.tileManagers[e1] = new $4324d99ae8520741$var$Bo(e1, t, this.dispatcher);
        r.style = this, r.setEventedParent(this, ()=>({
                isSourceLoaded: r.loaded(),
                source: r.serialize(),
                sourceId: e1
            })), r.onAdd(this.map), this._changed = !0;
    }
    removeSource(e1) {
        if (this._checkLoaded(), this.tileManagers[e1] === void 0) throw Error(`There is no source with this ID=${e1}`);
        for(let t in this._layers)if (this._layers[t].source === e1) return this.fire(new (0, $1G0Uw.gn)(Error(`Source "${e1}" cannot be removed while layer "${t}" is using it.`)));
        let t = this.tileManagers[e1];
        delete this.tileManagers[e1], delete this._updatedSources[e1], t.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`data`, {
            sourceDataType: `metadata`,
            sourceId: e1
        })), t.setEventedParent(null), t.onRemove(this.map), this._changed = !0;
    }
    setGeoJSONSourceData(e1, t) {
        if (this._checkLoaded(), this.tileManagers[e1] === void 0) throw Error(`There is no source with this ID=${e1}`);
        let n = this.tileManagers[e1].getSource();
        if (n.type !== `geojson`) throw Error(`geojsonSource.type is ${n.type}, which is !== 'geojson`);
        n.setData(t), this._changed = !0;
    }
    getSource(e1) {
        return this.tileManagers[e1]?.getSource();
    }
    addLayer(e1, t, n = {}) {
        this._checkLoaded();
        let r = e1.id;
        if (this.getLayer(r)) {
            this.fire(new (0, $1G0Uw.gn)(Error(`Layer "${r}" already exists on this map.`)));
            return;
        }
        let i;
        if (e1.type === `custom`) {
            if ((0, $1G0Uw.in)(this, (0, $1G0Uw.y)(e1))) return;
            i = (0, $1G0Uw._)(e1, this._globalState);
        } else {
            if (`source` in e1 && typeof e1.source == `object` && (this.addSource(r, e1.source), e1 = (0, $1G0Uw.Vn)(e1), e1 = (0, $1G0Uw.er)(e1, {
                source: r
            })), this._validate((0, $1G0Uw.on).layer, `layers.${r}`, e1, {
                arrayIndex: -1
            }, n)) return;
            i = (0, $1G0Uw._)(e1, this._globalState), this._validateLayer(i), i.setEventedParent(this, {
                layer: {
                    id: r
                }
            });
        }
        let a = t ? this._order.indexOf(t) : this._order.length;
        if (t && a === -1) {
            this.fire(new (0, $1G0Uw.gn)(Error(`Cannot add layer "${r}" before non-existing layer "${t}".`)));
            return;
        }
        if (this._order.splice(a, 0, r), this._layerOrderChanged = !0, this._layers[r] = i, this._removedLayers[r] && i.source && i.type !== `custom`) {
            let e1 = this._removedLayers[r];
            delete this._removedLayers[r], e1.type === i.type ? (this._updatedSources[i.source] = `reload`, this.tileManagers[i.source].pause()) : this._updatedSources[i.source] = `clear`;
        }
        this._updateLayer(i), i.onAdd && i.onAdd(this.map);
    }
    moveLayer(e1, t) {
        if (this._checkLoaded(), this._changed = !0, !this._layers[e1]) {
            this.fire(new (0, $1G0Uw.gn)(Error(`The layer '${e1}' does not exist in the map's style and cannot be moved.`)));
            return;
        }
        if (e1 === t) return;
        if (t && !this._order.includes(t)) {
            this.fire(new (0, $1G0Uw.gn)(Error(`Cannot move layer "${e1}" before non-existing layer "${t}".`)));
            return;
        }
        let n = this._order.indexOf(e1);
        this._order.splice(n, 1);
        let r = t ? this._order.indexOf(t) : this._order.length;
        this._order.splice(r, 0, e1), this._layerOrderChanged = !0;
    }
    removeLayer(e1) {
        this._checkLoaded();
        let t = this._layers[e1];
        if (!t) {
            this.fire(new (0, $1G0Uw.gn)(Error(`Cannot remove non-existing layer "${e1}".`)));
            return;
        }
        t.setEventedParent(null);
        let n = this._order.indexOf(e1);
        this._order.splice(n, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = t, delete this._layers[e1], this._serializedLayers && delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], t.type === `symbol` && t.source && this.tileManagers[t.source]?.resetMaxContentElevation(), t.onRemove && t.onRemove(this.map);
    }
    getLayer(e1) {
        return this._layers[e1];
    }
    getLayersOrder() {
        return [
            ...this._order
        ];
    }
    hasLayer(e1) {
        return e1 in this._layers;
    }
    setLayerZoomRange(e1, t, n) {
        this._checkLoaded();
        let r = this.getLayer(e1);
        if (!r) {
            this.fire(new (0, $1G0Uw.gn)(Error(`Cannot set the zoom range of non-existing layer "${e1}".`)));
            return;
        }
        (r.minzoom !== t || r.maxzoom !== n) && (t != null && (r.minzoom = t), n != null && (r.maxzoom = n), this._updateLayer(r));
    }
    setFilter(e1, t, n = {}) {
        this._checkLoaded();
        let r = this.getLayer(e1);
        if (!r) {
            this.fire(new (0, $1G0Uw.gn)(Error(`Cannot filter non-existing layer "${e1}".`)));
            return;
        }
        if (!(0, $1G0Uw.qn)(r.filter, t)) {
            if (t == null) {
                r.setFilter(void 0), this._updateLayer(r);
                return;
            }
            this._validate((0, $1G0Uw.on).filter, `layers.${r.id}.filter`, t, null, n) || (r.setFilter((0, $1G0Uw.Vn)(t)), this._updateLayer(r));
        }
    }
    getFilter(e1) {
        return (0, $1G0Uw.Vn)(this.getLayer(e1).filter);
    }
    setLayoutProperty(e1, t, n, r = {}) {
        this._checkLoaded();
        let i = this.getLayer(e1);
        if (!i) {
            this.fire(new (0, $1G0Uw.gn)(Error(`Cannot style non-existing layer "${e1}".`)));
            return;
        }
        (0, $1G0Uw.qn)(i.getLayoutProperty(t), n) || (i.setLayoutProperty(t, n, r), this._updateLayer(i));
    }
    getLayoutProperty(e1, t) {
        let n = this.getLayer(e1);
        if (!n) {
            this.fire(new (0, $1G0Uw.gn)(Error(`Cannot get style of non-existing layer "${e1}".`)));
            return;
        }
        return n.getLayoutProperty(t);
    }
    setPaintProperty(e1, t, n, r = {}) {
        this._checkLoaded();
        let i = this.getLayer(e1);
        if (!i) {
            this.fire(new (0, $1G0Uw.gn)(Error(`Cannot style non-existing layer "${e1}".`)));
            return;
        }
        (0, $1G0Uw.qn)(i.getPaintProperty(t), n) || this._updatePaintProperty(i, t, n, r);
    }
    _updatePaintProperty(e1, t, n, r = {}) {
        e1.setPaintProperty(t, n, r) && this._updateLayer(e1), (0, $1G0Uw.Xt)(e1) && t === `raster-fade-duration` && this.tileManagers[e1.source].setRasterFadeDuration(n), this._changed = !0, this._updatedPaintProps[e1.id] = !0, e1.type === `symbol` && this.triggerSymbolPlacement(), this._serializedLayers = null;
    }
    getPaintProperty(e1, t) {
        return this.getLayer(e1).getPaintProperty(t);
    }
    setFeatureState(e1, t) {
        this._checkLoaded();
        let n = e1.source, r = e1.sourceLayer, i = this.tileManagers[n];
        if (i === void 0) {
            this.fire(new (0, $1G0Uw.gn)(Error(`The source '${n}' does not exist in the map's style.`)));
            return;
        }
        let a = i.getSource().type;
        if (a === `geojson` && r) {
            this.fire(new (0, $1G0Uw.gn)(Error(`GeoJSON sources cannot have a sourceLayer parameter.`)));
            return;
        }
        if (a === `vector` && !r) {
            this.fire(new (0, $1G0Uw.gn)(Error(`The sourceLayer parameter must be provided for vector source types.`)));
            return;
        }
        if (e1.id === void 0) {
            this.fire(new (0, $1G0Uw.gn)(Error(`The feature id parameter must be provided.`)));
            return;
        }
        let o = [
            `__proto__`,
            `constructor`,
            `prototype`
        ];
        if (t && Object.keys(t).some((e1)=>o.includes(e1))) {
            this.fire(new (0, $1G0Uw.gn)(Error(`The feature state should not include one of the following keys: ${o}`)));
            return;
        }
        i.setFeatureState(r, e1.id, t);
    }
    removeFeatureState(e1, t) {
        this._checkLoaded();
        let n = e1.source, r = this.tileManagers[n];
        if (r === void 0) {
            this.fire(new (0, $1G0Uw.gn)(Error(`The source '${n}' does not exist in the map's style.`)));
            return;
        }
        let i = r.getSource().type, a = i === `vector` ? e1.sourceLayer : void 0;
        if (i === `vector` && !a) {
            this.fire(new (0, $1G0Uw.gn)(Error(`The sourceLayer parameter must be provided for vector source types.`)));
            return;
        }
        if (t && typeof e1.id != `string` && typeof e1.id != `number`) {
            this.fire(new (0, $1G0Uw.gn)(Error(`A feature id is required to remove its specific state property.`)));
            return;
        }
        r.removeFeatureState(a, e1.id, t);
    }
    getFeatureState(e1) {
        this._checkLoaded();
        let t = e1.source, n = e1.sourceLayer, r = this.tileManagers[t];
        if (r === void 0) {
            this.fire(new (0, $1G0Uw.gn)(Error(`The source '${t}' does not exist in the map's style.`)));
            return;
        }
        if (r.getSource().type === `vector` && !n) {
            this.fire(new (0, $1G0Uw.gn)(Error(`The sourceLayer parameter must be provided for vector source types.`)));
            return;
        }
        return e1.id === void 0 && this.fire(new (0, $1G0Uw.gn)(Error(`The feature id parameter must be provided.`))), r.getFeatureState(n, e1.id);
    }
    getTransition() {
        return (0, $1G0Uw.er)({
            duration: 300,
            delay: 0
        }, this.stylesheet?.transition);
    }
    serialize() {
        if (!this._loaded) return;
        let e1 = (0, $1G0Uw.hr)(this.tileManagers, (e1)=>e1.serialize()), t = this._serializeByIds(this._order, !0), n = this.map.getTerrain() || void 0, r = this.stylesheet;
        return (0, $1G0Uw.tr)({
            version: r.version,
            name: r.name,
            metadata: r.metadata,
            light: r.light,
            sky: r.sky,
            center: r.center,
            zoom: r.zoom,
            bearing: r.bearing,
            pitch: r.pitch,
            sprite: r.sprite,
            glyphs: r.glyphs,
            "font-faces": r[`font-faces`],
            transition: r.transition,
            projection: r.projection,
            state: r.state,
            sources: e1,
            layers: t,
            terrain: n
        }, (e1)=>e1 !== void 0);
    }
    _updateLayer(e1) {
        this._updatedLayers[e1.id] = !0, e1.source && !this._updatedSources[e1.source] && this.tileManagers[e1.source].getSource().type !== `raster` && (this._updatedSources[e1.source] = `reload`, this.tileManagers[e1.source].pause()), this._serializedLayers = null, this._changed = !0;
    }
    _flattenAndSortRenderedFeatures(e1) {
        let t = (e1)=>this._layers[e1].type === `fill-extrusion`, n = {}, r = [];
        for(let i = this._order.length - 1; i >= 0; i--){
            let a = this._order[i];
            if (t(a)) {
                n[a] = i;
                for (let t of e1){
                    let e1 = t[a];
                    if (e1) for (let t of e1)r.push(t);
                }
            }
        }
        r.sort((e1, t)=>t.intersectionZ - e1.intersectionZ);
        let i = [];
        for(let a = this._order.length - 1; a >= 0; a--){
            let o = this._order[a];
            if (t(o)) for(let e1 = r.length - 1; e1 >= 0; e1--){
                let t = r[e1].feature;
                if (n[t.layer.id] < a) break;
                i.push(t), r.pop();
            }
            else for (let t of e1){
                let e1 = t[o];
                if (e1) for (let t of e1)i.push(t.feature);
            }
        }
        return i;
    }
    queryRenderedFeatures(e1, t, n) {
        t?.filter && this._validate((0, $1G0Uw.on).filter, `queryRenderedFeatures.filter`, t.filter, null, t);
        let r = {};
        if (t?.layers) {
            if (!(Array.isArray(t.layers) || t.layers instanceof Set)) return this.fire(new (0, $1G0Uw.gn)(Error(`parameters.layers must be an Array or a Set of strings`))), [];
            for (let e1 of t.layers){
                let t = this._layers[e1];
                if (!t) return this.fire(new (0, $1G0Uw.gn)(Error(`The layer '${e1}' does not exist in the map's style and cannot be queried for features.`))), [];
                r[t.source] = !0;
            }
        }
        let i = [];
        t.availableImages = this.imageManager.listImages();
        let a = this._serializedAllLayers(), o = t.layers instanceof Set ? t.layers : Array.isArray(t.layers) ? new Set(t.layers) : null, s = {
            ...t,
            layers: o,
            globalState: this._globalState
        };
        for(let o in this.tileManagers)(!t.layers || r[o]) && i.push($4324d99ae8520741$var$ca(this.tileManagers[o], this._layers, a, e1, s, n, this.map.terrain ? (e1, t, n)=>this.map.terrain.getElevation(e1, t, n) : void 0));
        return this.placement && i.push($4324d99ae8520741$var$la(this._layers, a, this.tileManagers, e1, s, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(i);
    }
    querySourceFeatures(e1, t) {
        t?.filter && this._validate((0, $1G0Uw.on).filter, `querySourceFeatures.filter`, t.filter, null, t);
        let n = this.tileManagers[e1];
        return n ? $4324d99ae8520741$var$ua(n, t ? {
            ...t,
            globalState: this._globalState
        } : {
            globalState: this._globalState
        }) : [];
    }
    getLight() {
        return this.light.getLight();
    }
    setLight(e1, t = {}) {
        this._checkLoaded();
        let n = this.light.getLight(), r = !1;
        for(let t in e1)if (!(0, $1G0Uw.qn)(e1[t], n[t])) {
            r = !0;
            break;
        }
        if (!r) return;
        let i = {
            now: $4324d99ae8520741$export$461939dd4422153(),
            transition: (0, $1G0Uw.er)({
                duration: 300,
                delay: 0
            }, this.stylesheet.transition)
        };
        this.light.setLight(e1, t), this.light.updateTransitions(i);
    }
    getProjection() {
        return this.stylesheet?.projection;
    }
    setProjection(e1) {
        this._checkLoaded();
        let t = e1 ?? {
            type: `mercator`
        };
        if (this.stylesheet.projection = e1, this.projection) {
            if (this.projection.name === t.type) return;
            this.projection.destroy(), delete this.projection;
        }
        this._setProjectionInternal(t.type);
    }
    getSky() {
        return this.stylesheet?.sky;
    }
    setSky(e1, t = {}) {
        this._checkLoaded();
        let n = this.getSky(), r = !1;
        if (!e1 && !n) return;
        if (e1 && !n) r = !0;
        else if (!e1 && n) r = !0;
        else for(let t in e1)if (!(0, $1G0Uw.qn)(e1[t], n[t])) {
            r = !0;
            break;
        }
        if (!r) return;
        let i = {
            now: $4324d99ae8520741$export$461939dd4422153(),
            transition: (0, $1G0Uw.er)({
                duration: 300,
                delay: 0
            }, this.stylesheet.transition)
        };
        this.stylesheet.sky = e1, this.sky.setSky(e1, t), this.sky.updateTransitions(i);
    }
    _setProjectionInternal(e1) {
        let t = $4324d99ae8520741$var$_l(e1, this.map._camera?.transform.constrainOverride, this._globalState);
        this.projection = t.projection, this.map.migrateProjection(t.transform, t.cameraHelper);
        for(let e1 in this.tileManagers)this.tileManagers[e1].reload();
    }
    _validate(e1, t, n, r, i = {}) {
        return i.validate !== !1 && (0, $1G0Uw.an)(this, e1, {
            key: t,
            style: this.serialize(),
            value: n,
            ...r
        }, i);
    }
    _remove(e1 = !0) {
        this._frameRequest &&= (this._frameRequest.abort(), null), this._loadStyleRequest &&= (this._loadStyleRequest.abort(), null), this._spriteRequest &&= (this._spriteRequest.abort(), null), $4324d99ae8520741$var$fo().off($4324d99ae8520741$var$co, this._rtlPluginLoaded);
        for(let e1 in this._layers)this._layers[e1].setEventedParent(null);
        for(let e1 in this.tileManagers){
            let t = this.tileManagers[e1];
            t.setEventedParent(null), t.onRemove(this.map);
        }
        this.imageManager.setEventedParent(null), this.setEventedParent(null), e1 && this.dispatcher.broadcast(`RM`, void 0), this.dispatcher.remove(e1);
    }
    _clearSource(e1) {
        this.tileManagers[e1].clearTiles();
    }
    _reloadSource(e1) {
        this.tileManagers[e1].resume(), this.tileManagers[e1].reload();
    }
    _updateSources(e1) {
        for(let t in this.tileManagers)this.tileManagers[t].update(e1, this.map.terrain);
    }
    _generateCollisionBoxes() {
        for(let e1 in this.tileManagers)this._reloadSource(e1);
    }
    triggerSymbolPlacement() {
        this._symbolPlacementTriggered = !0;
    }
    _placementInputsChanged(e1, t, n) {
        let r = this.pauseablePlacement;
        return !r || this._symbolPlacementTriggered || this._placedProjectionTransition !== this.projection?.transitionState || r._showCollisionBoxes !== t || r.placement.collisionGroups.crossSourceCollisions !== n || r.placement.transform.renderWorldCopies !== e1.renderWorldCopies || !(0, $1G0Uw.bi)(r.placement.transform.modelViewProjectionMatrix, e1.modelViewProjectionMatrix);
    }
    _updatePlacement(e1, t, n, r, i = !1) {
        let a = !1, o = !1, s = {};
        for (let t of this._order){
            let n = this._layers[t];
            if (n.type !== `symbol`) continue;
            if (!s[n.source]) {
                let e1 = this.tileManagers[n.source];
                s[n.source] = e1.getRenderableIds(!0).map((t)=>e1.getTileByID(t)).sort((e1, t)=>t.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t.tileID) ? -1 : 1));
            }
            let r = this.crossTileSymbolIndex.addLayer(n, s[n.source], e1.center.lng);
            a ||= r;
        }
        this.crossTileSymbolIndex.pruneUnusedLayers(this._order), i ||= this._layerOrderChanged || n === 0;
        let c = a || this._placementInputsChanged(e1, t, r), l = this.pauseablePlacement?.isDone() && !this.placement.stillRecent($4324d99ae8520741$export$461939dd4422153(), e1.zoom);
        if ((i || !this.pauseablePlacement || l && (c || this.placement.stale)) && (this._symbolPlacementTriggered = !1, this._placedProjectionTransition = this.projection?.transitionState, this.pauseablePlacement = new $4324d99ae8520741$var$Fs(e1, this.map.terrain, this._order, i, t, n, r, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? c && this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, s), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit($4324d99ae8520741$export$461939dd4422153()), o = !0), a && this.pauseablePlacement.placement.setStale()), o || a) for (let e1 of this._order){
            let t = this._layers[e1];
            t.type === `symbol` && this.placement.updateLayerOpacities(t, s[t.source]);
        }
        return !this.pauseablePlacement.isDone() || this.placement.hasTransitions($4324d99ae8520741$export$461939dd4422153());
    }
    _releaseSymbolFadeTiles() {
        for(let e1 in this.tileManagers)this.tileManagers[e1].releaseSymbolFadeTiles();
    }
    async getImages(e1, t) {
        let n = await this.imageManager.getImages(t.icons);
        this._updateTilesForChangedImages();
        let r = this.tileManagers[t.source];
        return r && r.setDependencies(t.tileID.key, t.type, t.icons), n;
    }
    async getGlyphs(e1, t) {
        let n = await this.glyphManager.getGlyphs(t.stacks), r = this.tileManagers[t.source];
        return r && r.setDependencies(t.tileID.key, t.type, [
            ``
        ]), n;
    }
    getGlyphsUrl() {
        return this.stylesheet.glyphs || null;
    }
    setGlyphs(e1, t = {}) {
        this._checkLoaded(), !(e1 && this._validate((0, $1G0Uw.on).glyphs, `glyphs`, e1, null, t)) && (this._changed = !0, this._glyphsDidChange = !0, this.stylesheet.glyphs = e1, this.glyphManager.entries = {}, this.glyphManager.setURL(e1));
    }
    getFontFaces() {
        return this.stylesheet[`font-faces`] || null;
    }
    setFontFaces(e1) {
        this._checkLoaded(), this._changed = !0, this._glyphsDidChange = !0, this.stylesheet[`font-faces`] = e1, this.glyphManager.setFontFaces(e1);
    }
    async getDashes(e1, t) {
        let n = {};
        for (let [e1, r] of Object.entries(t.dashes))n[e1] = this.lineAtlas.getDash(r.dasharray, r.round);
        return n;
    }
    addSprite(e1, t, n = {}, r) {
        this._checkLoaded();
        let i = [
            {
                id: e1,
                url: t
            }
        ], a = [
            ...$4324d99ae8520741$var$gi(this.stylesheet.sprite),
            ...i
        ];
        this._validate((0, $1G0Uw.on).sprite, `sprite`, a, null, n) || (this.stylesheet.sprite = a, this._loadSprite(i, !0, r));
    }
    removeSprite(e1) {
        this._checkLoaded();
        let t = $4324d99ae8520741$var$gi(this.stylesheet.sprite);
        if (!t.find((t)=>t.id === e1)) {
            this.fire(new (0, $1G0Uw.gn)(Error(`Sprite "${e1}" doesn't exists on this map.`)));
            return;
        }
        let n = this.imageManager.removeSpriteImages(e1);
        this._markImagesChanged(n), t.splice(t.findIndex((t)=>t.id === e1), 1), this.stylesheet.sprite = t.length > 0 ? t : void 0, this._imagesListDirty = !0, this._changed = !0, this.fire(new $4324d99ae8520741$export$49025a11e3fe5bd0(`data`));
    }
    getSprite() {
        return $4324d99ae8520741$var$gi(this.stylesheet.sprite);
    }
    setSprite(e1, t = {}, n) {
        this._checkLoaded(), !(e1 && this._validate((0, $1G0Uw.on).sprite, `sprite`, e1, null, t)) && (this.stylesheet.sprite = e1, e1 ? this._loadSprite(e1, !0, n) : (this._unloadSprite(), n && n(null)));
    }
    destroy() {
        this._frameRequest &&= (this._frameRequest.abort(), null), this._loadStyleRequest &&= (this._loadStyleRequest.abort(), null), this._spriteRequest &&= (this._spriteRequest.abort(), null);
        for(let e1 in this.tileManagers){
            let t = this.tileManagers[e1];
            t.setEventedParent(null), t.onRemove(this.map);
        }
        this.tileManagers = {}, this.imageManager && (this.imageManager.setEventedParent(null), this.imageManager.destroy(), this.patternAtlas.destroy()), this.glyphManager && this.glyphManager.destroy();
        for(let e1 in this._layers){
            let t = this._layers[e1];
            t.setEventedParent(null), t.onRemove && t.onRemove(this.map);
        }
        this._setInitialValues(), this.setEventedParent(null), this.dispatcher.unregisterMessageHandler(`GG`), this.dispatcher.unregisterMessageHandler(`GI`), this.dispatcher.unregisterMessageHandler(`GDA`), this.dispatcher.remove(!0), this._listeners = {}, this._oneTimeListeners = {};
    }
};
const $4324d99ae8520741$var$bl = (0, $1G0Uw.Yt)([
    {
        name: `a_pos`,
        type: `Int16`,
        components: 2
    },
    {
        name: `a_texture_pos`,
        type: `Int16`,
        components: 2
    }
]);
var $4324d99ae8520741$var$xl = class {
    constructor(){
        this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
    }
    bind(e1, t, n, r, i, a, o, s, c) {
        this.context = e1;
        let l = this.boundPaintVertexBuffers.length !== r.length;
        for(let e1 = 0; !l && e1 < r.length; e1++)this.boundPaintVertexBuffers[e1] !== r[e1] && (l = !0);
        !this.vao || this.boundProgram !== t || this.boundLayoutVertexBuffer !== n || l || this.boundIndexBuffer !== i || this.boundVertexOffset !== a || this.boundDynamicVertexBuffer !== o || this.boundDynamicVertexBuffer2 !== s || this.boundDynamicVertexBuffer3 !== c ? this.freshBind(t, n, r, i, a, o, s, c) : e1.bindVertexArray.set(this.vao);
    }
    freshBind(e1, t, n, r, i, a, o, s) {
        let c = e1.numAttributes, l = this.context, u = l.gl;
        this.vao && this.destroy(), this.vao = l.createVertexArray(), l.bindVertexArray.set(this.vao), this.boundProgram = e1, this.boundLayoutVertexBuffer = t, this.boundPaintVertexBuffers = n, this.boundIndexBuffer = r, this.boundVertexOffset = i, this.boundDynamicVertexBuffer = a, this.boundDynamicVertexBuffer2 = o, this.boundDynamicVertexBuffer3 = s, t.enableAttributes(u, e1);
        for (let t of n)t.enableAttributes(u, e1);
        a && a.enableAttributes(u, e1), o && o.enableAttributes(u, e1), s && s.enableAttributes(u, e1), t.bind(), t.setVertexAttribPointers(u, e1, i);
        for (let t of n)t.bind(), t.setVertexAttribPointers(u, e1, i);
        a && (a.bind(), a.setVertexAttribPointers(u, e1, i)), r && r.bind(), o && (o.bind(), o.setVertexAttribPointers(u, e1, i)), s && (s.bind(), s.setVertexAttribPointers(u, e1, i)), l.currentNumAttributes = c;
    }
    destroy() {
        this.vao &&= (this.context.deleteVertexArray(this.vao), null);
    }
};
const $4324d99ae8520741$var$Sl = (e1, t)=>({
        u_depth: new (0, $1G0Uw.Mt)(e1, t.u_depth),
        u_terrain: new (0, $1G0Uw.Mt)(e1, t.u_terrain)
    }), $4324d99ae8520741$var$Cl = (e1, t)=>({
        u_texture: new (0, $1G0Uw.Mt)(e1, t.u_texture),
        u_ele_delta: new (0, $1G0Uw.jt)(e1, t.u_ele_delta),
        u_fog_matrix: new (0, $1G0Uw.zt)(e1, t.u_fog_matrix),
        u_fog_color: new (0, $1G0Uw.It)(e1, t.u_fog_color),
        u_fog_ground_blend: new (0, $1G0Uw.jt)(e1, t.u_fog_ground_blend),
        u_fog_ground_blend_opacity: new (0, $1G0Uw.jt)(e1, t.u_fog_ground_blend_opacity),
        u_horizon_color: new (0, $1G0Uw.It)(e1, t.u_horizon_color),
        u_horizon_fog_blend: new (0, $1G0Uw.jt)(e1, t.u_horizon_fog_blend),
        u_is_globe_mode: new (0, $1G0Uw.jt)(e1, t.u_is_globe_mode)
    }), $4324d99ae8520741$var$wl = (e1, t)=>({
        u_ele_delta: new (0, $1G0Uw.jt)(e1, t.u_ele_delta)
    }), $4324d99ae8520741$var$Tl = (e1, t, n, r, i)=>({
        u_texture: 0,
        u_ele_delta: e1,
        u_fog_matrix: t,
        u_fog_color: n ? n.properties.get(`fog-color`) : (0, $1G0Uw.fn).white,
        u_fog_ground_blend: n ? n.properties.get(`fog-ground-blend`) : 1,
        u_fog_ground_blend_opacity: i ? 0 : n ? n.calculateFogBlendOpacity(r) : 0,
        u_horizon_color: n ? n.properties.get(`horizon-color`) : (0, $1G0Uw.fn).white,
        u_horizon_fog_blend: n ? n.properties.get(`horizon-fog-blend`) : 1,
        u_is_globe_mode: +!!i
    }), $4324d99ae8520741$var$El = (e1)=>({
        u_ele_delta: e1
    }), $4324d99ae8520741$var$Dl = {
    ProjectionUBO: 0,
    TerrainUBO: 1,
    FrameUBO: 2
};
function $4324d99ae8520741$var$Ol(e1, t) {
    for (let [n, r] of Object.entries($4324d99ae8520741$var$Dl)){
        let i = e1.getUniformBlockIndex(t, n);
        i !== e1.INVALID_INDEX && e1.uniformBlockBinding(t, i, r);
    }
}
const $4324d99ae8520741$var$kl = {
    float: [
        1,
        1
    ],
    int: [
        1,
        1
    ],
    vec2: [
        2,
        2
    ],
    vec4: [
        4,
        4
    ],
    mat4: [
        16,
        4
    ]
};
function $4324d99ae8520741$var$Al(e1) {
    let t = {}, n = 0;
    for (let { name: r, type: i } of e1){
        let [e1, a] = $4324d99ae8520741$var$kl[i];
        n = Math.ceil(n / a) * a, t[r] = n, n += e1;
    }
    return {
        offsets: t,
        contentWords: n,
        sizeWords: Math.ceil(n / 4) * 4
    };
}
var $4324d99ae8520741$var$jl = class {
    constructor(e1, t, n){
        this.context = e1, this.binding = t, this.contentWords = n.contentWords;
        let r = e1.gl;
        this.buffer = r.createBuffer(), r.bindBuffer(r.UNIFORM_BUFFER, this.buffer), r.bufferData(r.UNIFORM_BUFFER, n.sizeWords * 4, r.DYNAMIC_DRAW), r.bindBufferBase(r.UNIFORM_BUFFER, t, this.buffer), this.uploaded = new Float32Array(n.sizeWords), this.pending = new Float32Array(n.sizeWords), this.uploadedWords = new Uint32Array(this.uploaded.buffer), this.pendingWords = new Uint32Array(this.pending.buffer), this.hasData = !1, this.bindingDirty = !1;
    }
    upload() {
        let e1 = this.context.gl, t = !this.hasData;
        if (!t) {
            let e1 = this.pendingWords, n = this.uploadedWords;
            for(let r = 0; r < this.contentWords; r++)if (e1[r] !== n[r]) {
                t = !0;
                break;
            }
        }
        this.bind(), t && (e1.bindBuffer(e1.UNIFORM_BUFFER, this.buffer), e1.bufferSubData(e1.UNIFORM_BUFFER, 0, this.pending), this.uploaded.set(this.pending), this.hasData = !0);
    }
    bind() {
        if (!this.bindingDirty) return;
        let e1 = this.context.gl;
        e1.bindBufferBase(e1.UNIFORM_BUFFER, this.binding, this.buffer), this.bindingDirty = !1;
    }
    destroy() {
        let e1 = this.context.gl;
        this.buffer && (e1.deleteBuffer(this.buffer), delete this.buffer);
    }
};
const $4324d99ae8520741$var$Ml = $4324d99ae8520741$var$Al([
    {
        name: `u_projection_matrix`,
        type: `mat4`
    },
    {
        name: `u_projection_fallback_matrix`,
        type: `mat4`
    },
    {
        name: `u_projection_tile_mercator_coords`,
        type: `vec4`
    },
    {
        name: `u_projection_clipping_plane`,
        type: `vec4`
    },
    {
        name: `u_projection_transition`,
        type: `float`
    },
    {
        name: `u_projection_clip_antimeridian`,
        type: `int`
    }
]), $4324d99ae8520741$var$Nl = $4324d99ae8520741$var$Ml.offsets;
function $4324d99ae8520741$var$Pl(e1) {
    return new $4324d99ae8520741$var$jl(e1, $4324d99ae8520741$var$Dl.ProjectionUBO, $4324d99ae8520741$var$Ml);
}
function $4324d99ae8520741$var$Fl(e1, t) {
    let n = e1.pending;
    n.set(t.mainMatrix, $4324d99ae8520741$var$Nl.u_projection_matrix), n.set(t.fallbackMatrix, $4324d99ae8520741$var$Nl.u_projection_fallback_matrix), n.set(t.tileMercatorCoords, $4324d99ae8520741$var$Nl.u_projection_tile_mercator_coords), n.set(t.clippingPlane, $4324d99ae8520741$var$Nl.u_projection_clipping_plane), n[$4324d99ae8520741$var$Nl.u_projection_transition] = t.projectionTransition, e1.pendingWords[$4324d99ae8520741$var$Nl.u_projection_clip_antimeridian] = +!!t.clipAntimeridian, e1.upload();
}
const $4324d99ae8520741$var$Il = $4324d99ae8520741$var$Al([
    {
        name: `u_terrain_matrix`,
        type: `mat4`
    },
    {
        name: `u_terrain_unpack`,
        type: `vec4`
    },
    {
        name: `u_terrain_dim`,
        type: `float`
    },
    {
        name: `u_terrain_exaggeration`,
        type: `float`
    }
]), $4324d99ae8520741$var$Ll = $4324d99ae8520741$var$Il.offsets;
function $4324d99ae8520741$var$Rl(e1) {
    return new $4324d99ae8520741$var$jl(e1, $4324d99ae8520741$var$Dl.TerrainUBO, $4324d99ae8520741$var$Il);
}
function $4324d99ae8520741$var$zl(e1, t) {
    let n = e1.pending;
    n.set(t.u_terrain_matrix, $4324d99ae8520741$var$Ll.u_terrain_matrix), n.set(t.u_terrain_unpack, $4324d99ae8520741$var$Ll.u_terrain_unpack), n[$4324d99ae8520741$var$Ll.u_terrain_dim] = t.u_terrain_dim, n[$4324d99ae8520741$var$Ll.u_terrain_exaggeration] = t.u_terrain_exaggeration, e1.upload();
}
function $4324d99ae8520741$var$Bl(e1) {
    let t = [];
    for (let n of e1){
        if (n === null) continue;
        let e1 = n.split(` `);
        t.push(e1.pop());
    }
    return t;
}
function $4324d99ae8520741$var$Vl(e1, t) {
    let n = new Set([
        e1.INT,
        e1.INT_VEC2,
        e1.INT_VEC3,
        e1.INT_VEC4,
        e1.UNSIGNED_INT,
        e1.UNSIGNED_INT_VEC2,
        e1.UNSIGNED_INT_VEC3,
        e1.UNSIGNED_INT_VEC4
    ]), r = new Set, i = e1.getProgramParameter(t, e1.ACTIVE_ATTRIBUTES);
    for(let a = 0; a < i; a++){
        let i = e1.getActiveAttrib(t, a);
        i && n.has(i.type) && r.add(i.name);
    }
    return r;
}
var $4324d99ae8520741$var$Hl = class {
    constructor(e1, t, n, r, i, a, o, s, c = []){
        let l = e1.gl;
        this.program = l.createProgram();
        let u = $4324d99ae8520741$var$Bl(t.staticAttributes), d = n ? n.getBinderAttributes() : [], f = u.concat(d), p = $4324d99ae8520741$var$ic.prelude.staticUniforms ? $4324d99ae8520741$var$Bl($4324d99ae8520741$var$ic.prelude.staticUniforms) : [], m = t.staticUniforms ? $4324d99ae8520741$var$Bl(t.staticUniforms) : [], h = n ? n.getBinderUniforms() : [], g = p.concat(m).concat(h), _ = [];
        for (let e1 of g)_.includes(e1) || _.push(e1);
        let v = n ? n.defines() : [];
        v.unshift(`#version 300 es`), i && v.push(`#define OVERDRAW_INSPECTOR;`), a && v.push(`#define TERRAIN3D;`), s && v.push(s), c && v.push(...c);
        let y = v.concat($4324d99ae8520741$var$ic.prelude.fragmentSource, o.fragmentSource, t.fragmentSource).join(`
`), b = v.concat($4324d99ae8520741$var$ic.prelude.vertexSource, o.vertexSource, t.vertexSource).join(`
`), x = l.createShader(l.FRAGMENT_SHADER);
        if (l.isContextLost()) {
            this.failedToCreate = !0;
            return;
        }
        l.shaderSource(x, y), l.compileShader(x), l.attachShader(this.program, x);
        let S = l.createShader(l.VERTEX_SHADER);
        if (l.isContextLost()) {
            this.failedToCreate = !0;
            return;
        }
        l.shaderSource(S, b), l.compileShader(S), l.attachShader(this.program, S), this.attributes = {};
        let C = {};
        if (this.numAttributes = f.length, l.linkProgram(this.program), !l.getProgramParameter(this.program, l.LINK_STATUS)) {
            if (l.isContextLost()) {
                this.failedToCreate = !0;
                return;
            }
            throw l.getShaderParameter(x, l.COMPILE_STATUS) ? l.getShaderParameter(S, l.COMPILE_STATUS) ? Error(`Program failed to link: ${l.getProgramInfoLog(this.program)}`) : Error(`Could not compile vertex shader: ${l.getShaderInfoLog(S)}`) : Error(`Could not compile fragment shader: ${l.getShaderInfoLog(x)}`);
        }
        $4324d99ae8520741$var$Ol(l, this.program);
        let w = $4324d99ae8520741$var$Vl(l, this.program);
        for (let e1 of f){
            if (!e1) continue;
            let t = l.getAttribLocation(this.program, e1);
            t >= 0 && (this.attributes[e1] = {
                location: t,
                isInteger: w.has(e1)
            });
        }
        l.deleteShader(S), l.deleteShader(x);
        for (let e1 of _)if (e1 && !C[e1]) {
            let t = l.getUniformLocation(this.program, e1);
            t && (C[e1] = t);
        }
        this.fixedUniforms = r(e1, C), this.terrainUniforms = $4324d99ae8520741$var$Sl(e1, C), this.binderUniforms = n ? n.getUniforms(e1, C) : [];
    }
    draw(e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v) {
        let y = e1.gl;
        if (this.failedToCreate) return;
        if (e1.program.set(this.program), e1.projectionUniformBuffer.bind(), e1.terrainUniformBuffer.bind(), e1.frameUniformBuffer.bind(), e1.setDepthMode(n), e1.setStencilMode(r), e1.setColorMode(i), e1.setCullFace(a), s) {
            e1.activeTexture.set(y.TEXTURE2), y.bindTexture(y.TEXTURE_2D, s.depthTexture), e1.activeTexture.set(y.TEXTURE3), y.bindTexture(y.TEXTURE_2D, s.texture);
            for(let e1 in this.terrainUniforms)this.terrainUniforms[e1].set(s[e1]);
            $4324d99ae8520741$var$zl(e1.terrainUniformBuffer, s);
        }
        if (c && $4324d99ae8520741$var$Fl(e1.projectionUniformBuffer, c), o) for(let e1 in this.fixedUniforms)this.fixedUniforms[e1].set(o[e1]);
        h && h.setUniforms(e1, this.binderUniforms, p, {
            zoom: m
        });
        let b = 0;
        switch(t){
            case y.LINES:
                b = 2;
                break;
            case y.TRIANGLES:
                b = 3;
                break;
            case y.LINE_STRIP:
                b = 1;
        }
        for (let n of f.get())n.vaos ||= {}, n.vaos[l] ||= new $4324d99ae8520741$var$xl, n.vaos[l].bind(e1, this, u, h ? h.getPaintVertexBuffers() : [], d, n.vertexOffset, g, _, v), y.drawElements(t, n.primitiveLength * b, y.UNSIGNED_SHORT, n.primitiveOffset * b * 2);
    }
};
function $4324d99ae8520741$var$Ul(e1, t, n) {
    let r = 1 / (0, $1G0Uw.Ir)(n, 1, t.transform.tileZoom), i = 2 ** n.tileID.overscaledZ, a = n.tileSize * 2 ** t.transform.tileZoom / i, o = a * (n.tileID.canonical.x + n.tileID.wrap * i), s = a * n.tileID.canonical.y;
    return {
        u_image: 0,
        u_texsize: n.imageAtlasTexture.size,
        u_scale: [
            r,
            e1.fromScale,
            e1.toScale
        ],
        u_fade: e1.t,
        u_pixel_coord_upper: [
            o >> 16,
            s >> 16
        ],
        u_pixel_coord_lower: [
            o & 65535,
            s & 65535
        ]
    };
}
function $4324d99ae8520741$var$Wl(e1, t, n, r) {
    let i = n.patternAtlas.getPattern(e1.from.toString()), a = n.patternAtlas.getPattern(e1.to.toString()), { width: o, height: s } = n.patternAtlas.getPixelSize(), c = 2 ** r.tileID.overscaledZ, l = r.tileSize * 2 ** n.transform.tileZoom / c, u = l * (r.tileID.canonical.x + r.tileID.wrap * c), d = l * r.tileID.canonical.y;
    return {
        u_image: 0,
        u_pattern_tl_a: i.tl,
        u_pattern_br_a: i.br,
        u_pattern_tl_b: a.tl,
        u_pattern_br_b: a.br,
        u_texsize: [
            o,
            s
        ],
        u_mix: t.t,
        u_pattern_size_a: i.displaySize,
        u_pattern_size_b: a.displaySize,
        u_scale_a: t.fromScale,
        u_scale_b: t.toScale,
        u_tile_units_to_pixels: 1 / (0, $1G0Uw.Ir)(r, 1, n.transform.tileZoom),
        u_pixel_coord_upper: [
            u >> 16,
            d >> 16
        ],
        u_pixel_coord_lower: [
            u & 65535,
            d & 65535
        ]
    };
}
const $4324d99ae8520741$var$Gl = (e1, t)=>({
        u_lightpos: new (0, $1G0Uw.Pt)(e1, t.u_lightpos),
        u_lightpos_globe: new (0, $1G0Uw.Pt)(e1, t.u_lightpos_globe),
        u_lightintensity: new (0, $1G0Uw.jt)(e1, t.u_lightintensity),
        u_lightcolor: new (0, $1G0Uw.Pt)(e1, t.u_lightcolor),
        u_vertical_gradient: new (0, $1G0Uw.jt)(e1, t.u_vertical_gradient),
        u_opacity: new (0, $1G0Uw.jt)(e1, t.u_opacity),
        u_fill_translate: new (0, $1G0Uw.Nt)(e1, t.u_fill_translate)
    }), $4324d99ae8520741$var$Kl = (e1, t)=>({
        u_lightpos: new (0, $1G0Uw.Pt)(e1, t.u_lightpos),
        u_lightpos_globe: new (0, $1G0Uw.Pt)(e1, t.u_lightpos_globe),
        u_lightintensity: new (0, $1G0Uw.jt)(e1, t.u_lightintensity),
        u_lightcolor: new (0, $1G0Uw.Pt)(e1, t.u_lightcolor),
        u_vertical_gradient: new (0, $1G0Uw.jt)(e1, t.u_vertical_gradient),
        u_height_factor: new (0, $1G0Uw.jt)(e1, t.u_height_factor),
        u_opacity: new (0, $1G0Uw.jt)(e1, t.u_opacity),
        u_fill_translate: new (0, $1G0Uw.Nt)(e1, t.u_fill_translate),
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_texsize: new (0, $1G0Uw.Nt)(e1, t.u_texsize),
        u_pixel_coord_upper: new (0, $1G0Uw.Nt)(e1, t.u_pixel_coord_upper),
        u_pixel_coord_lower: new (0, $1G0Uw.Nt)(e1, t.u_pixel_coord_lower),
        u_scale: new (0, $1G0Uw.Pt)(e1, t.u_scale),
        u_fade: new (0, $1G0Uw.jt)(e1, t.u_fade)
    }), $4324d99ae8520741$var$ql = (e1, t, n, r)=>{
    let i = e1.style.light, a = i.getCartesianPosition(), o = (0, $1G0Uw.Mi)();
    i.properties.get(`anchor`) === `viewport` && (0, $1G0Uw.Ni)(o, e1.transform.bearingInRadians), (0, $1G0Uw.fi)(a, a, o);
    let s = e1.transform.transformLightDirection(a), c = i.properties.get(`color`);
    return {
        u_lightpos: a,
        u_lightpos_globe: s,
        u_lightintensity: i.properties.get(`intensity`),
        u_lightcolor: [
            c.r,
            c.g,
            c.b
        ],
        u_vertical_gradient: +t,
        u_opacity: n,
        u_fill_translate: r
    };
}, $4324d99ae8520741$var$Jl = (e1, t, n, r, i, a, o)=>(0, $1G0Uw.er)($4324d99ae8520741$var$ql(e1, t, n, r), $4324d99ae8520741$var$Ul(a, e1, o), {
        u_height_factor: -(2 ** i.overscaledZ) / o.tileSize / 8
    }), $4324d99ae8520741$var$Yl = (e1, t)=>({
        u_fill_translate: new (0, $1G0Uw.Nt)(e1, t.u_fill_translate)
    }), $4324d99ae8520741$var$Xl = (e1, t)=>({
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_texsize: new (0, $1G0Uw.Nt)(e1, t.u_texsize),
        u_pixel_coord_upper: new (0, $1G0Uw.Nt)(e1, t.u_pixel_coord_upper),
        u_pixel_coord_lower: new (0, $1G0Uw.Nt)(e1, t.u_pixel_coord_lower),
        u_scale: new (0, $1G0Uw.Pt)(e1, t.u_scale),
        u_fade: new (0, $1G0Uw.jt)(e1, t.u_fade),
        u_sdf_pattern: new (0, $1G0Uw.Mt)(e1, t.u_sdf_pattern),
        u_fill_translate: new (0, $1G0Uw.Nt)(e1, t.u_fill_translate)
    }), $4324d99ae8520741$var$Zl = (e1, t)=>({
        u_fill_translate: new (0, $1G0Uw.Nt)(e1, t.u_fill_translate)
    }), $4324d99ae8520741$var$Ql = (e1, t)=>({
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_texsize: new (0, $1G0Uw.Nt)(e1, t.u_texsize),
        u_pixel_coord_upper: new (0, $1G0Uw.Nt)(e1, t.u_pixel_coord_upper),
        u_pixel_coord_lower: new (0, $1G0Uw.Nt)(e1, t.u_pixel_coord_lower),
        u_scale: new (0, $1G0Uw.Pt)(e1, t.u_scale),
        u_fade: new (0, $1G0Uw.jt)(e1, t.u_fade),
        u_sdf_pattern: new (0, $1G0Uw.Mt)(e1, t.u_sdf_pattern),
        u_fill_translate: new (0, $1G0Uw.Nt)(e1, t.u_fill_translate)
    }), $4324d99ae8520741$var$$l = (e1, t, n, r, i)=>(0, $1G0Uw.er)($4324d99ae8520741$var$Ul(t, e1, n), {
        u_fill_translate: r,
        u_sdf_pattern: +!!i
    }), $4324d99ae8520741$var$eu = (e1)=>({
        u_fill_translate: e1
    }), $4324d99ae8520741$var$tu = (e1)=>({
        u_fill_translate: e1
    }), $4324d99ae8520741$var$nu = (e1, t, n, r, i)=>$4324d99ae8520741$var$$l(e1, t, n, r, i), $4324d99ae8520741$var$ru = (e1, t)=>({
        u_scale_with_map: new (0, $1G0Uw.Mt)(e1, t.u_scale_with_map),
        u_pitch_with_map: new (0, $1G0Uw.Mt)(e1, t.u_pitch_with_map),
        u_extrude_scale: new (0, $1G0Uw.Nt)(e1, t.u_extrude_scale),
        u_globe_extrude_scale: new (0, $1G0Uw.jt)(e1, t.u_globe_extrude_scale),
        u_translate: new (0, $1G0Uw.Nt)(e1, t.u_translate)
    }), $4324d99ae8520741$var$iu = (e1, t, n, r, i)=>{
    let a = e1.transform, o, s, c = 0;
    if (n.paint.get(`circle-pitch-alignment`) === `map`) {
        let e1 = (0, $1G0Uw.Ir)(t, 1, a.zoom);
        o = !0, s = [
            e1,
            e1
        ], c = e1 / ((0, $1G0Uw.Lr) * 2 ** t.tileID.overscaledZ) * 2 * Math.PI * i;
    } else o = !1, s = a.pixelsToGLUnits;
    return {
        u_scale_with_map: +(n.paint.get(`circle-pitch-scale`) === `map`),
        u_pitch_with_map: +o,
        u_extrude_scale: s,
        u_globe_extrude_scale: c,
        u_translate: r
    };
}, $4324d99ae8520741$var$au = (e1, t)=>({
        u_color: new (0, $1G0Uw.It)(e1, t.u_color),
        u_overlay: new (0, $1G0Uw.Mt)(e1, t.u_overlay),
        u_overlay_scale: new (0, $1G0Uw.jt)(e1, t.u_overlay_scale)
    }), $4324d99ae8520741$var$ou = (e1, t = 1)=>({
        u_color: e1,
        u_overlay: 0,
        u_overlay_scale: t
    }), $4324d99ae8520741$var$su = (e1, t)=>({
        u_extrude_scale: new (0, $1G0Uw.jt)(e1, t.u_extrude_scale),
        u_intensity: new (0, $1G0Uw.jt)(e1, t.u_intensity),
        u_globe_extrude_scale: new (0, $1G0Uw.jt)(e1, t.u_globe_extrude_scale)
    }), $4324d99ae8520741$var$cu = (e1, t)=>({
        u_matrix: new (0, $1G0Uw.zt)(e1, t.u_matrix),
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_color_ramp: new (0, $1G0Uw.Mt)(e1, t.u_color_ramp),
        u_opacity: new (0, $1G0Uw.jt)(e1, t.u_opacity)
    }), $4324d99ae8520741$var$lu = (e1, t, n, r)=>{
    let i = (0, $1G0Uw.Ir)(e1, 1, t) / ((0, $1G0Uw.Lr) * 2 ** e1.tileID.overscaledZ) * 2 * Math.PI * r;
    return {
        u_extrude_scale: (0, $1G0Uw.Ir)(e1, 1, t),
        u_intensity: n,
        u_globe_extrude_scale: i
    };
}, $4324d99ae8520741$var$uu = (e1, t, n, r)=>{
    let i = (0, $1G0Uw.vi)();
    return (0, $1G0Uw.Ti)(i, 0, e1.width, e1.height, 0, 0, 1), {
        u_matrix: i,
        u_image: n,
        u_color_ramp: r,
        u_opacity: t.paint.get(`heatmap-opacity`)
    };
}, $4324d99ae8520741$var$du = (e1, t)=>({
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_latrange: new (0, $1G0Uw.Nt)(e1, t.u_latrange),
        u_exaggeration: new (0, $1G0Uw.jt)(e1, t.u_exaggeration),
        u_altitudes: new (0, $1G0Uw.Rt)(e1, t.u_altitudes),
        u_azimuths: new (0, $1G0Uw.Rt)(e1, t.u_azimuths),
        u_accent: new (0, $1G0Uw.It)(e1, t.u_accent),
        u_method: new (0, $1G0Uw.Mt)(e1, t.u_method),
        u_shadows: new (0, $1G0Uw.Lt)(e1, t.u_shadows),
        u_highlights: new (0, $1G0Uw.Lt)(e1, t.u_highlights)
    }), $4324d99ae8520741$var$fu = (e1, t)=>({
        u_matrix: new (0, $1G0Uw.zt)(e1, t.u_matrix),
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_dimension: new (0, $1G0Uw.Nt)(e1, t.u_dimension),
        u_zoom: new (0, $1G0Uw.jt)(e1, t.u_zoom),
        u_unpack: new (0, $1G0Uw.Ft)(e1, t.u_unpack)
    }), $4324d99ae8520741$var$pu = (e1, t, n)=>{
    let r = n.paint.get(`hillshade-accent-color`), i;
    switch(n.paint.get(`hillshade-method`)){
        case `basic`:
            i = 4;
            break;
        case `combined`:
            i = 1;
            break;
        case `igor`:
            i = 2;
            break;
        case `multidirectional`:
            i = 3;
            break;
        default:
            i = 0;
    }
    let a = n.getIlluminationProperties();
    for(let t = 0; t < a.directionRadians.length; t++)n.paint.get(`hillshade-illumination-anchor`) === `viewport` && (a.directionRadians[t] += e1.transform.bearingInRadians);
    return {
        u_image: 0,
        u_latrange: $4324d99ae8520741$var$hu(e1, t.tileID),
        u_exaggeration: n.paint.get(`hillshade-exaggeration`),
        u_altitudes: a.altitudeRadians,
        u_azimuths: a.directionRadians,
        u_accent: r,
        u_method: i,
        u_highlights: a.highlightColor,
        u_shadows: a.shadowColor
    };
}, $4324d99ae8520741$var$mu = (e1, t)=>{
    let n = t.stride, r = (0, $1G0Uw.vi)();
    return (0, $1G0Uw.Ti)(r, 0, (0, $1G0Uw.Lr), -(0, $1G0Uw.Lr), 0, 0, 1), (0, $1G0Uw.ji)(r, r, [
        0,
        -(0, $1G0Uw.Lr),
        0
    ]), {
        u_matrix: r,
        u_image: 1,
        u_dimension: [
            n,
            n
        ],
        u_zoom: e1.overscaledZ,
        u_unpack: t.getUnpackVector()
    };
};
function $4324d99ae8520741$var$hu(e1, t) {
    let n = 2 ** t.canonical.z, r = t.canonical.y;
    return [
        new (0, $1G0Uw.nt)(0, r / n).toLngLat().lat,
        new (0, $1G0Uw.nt)(0, (r + 1) / n).toLngLat().lat
    ];
}
const $4324d99ae8520741$var$gu = (e1, t)=>({
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_unpack: new (0, $1G0Uw.Ft)(e1, t.u_unpack),
        u_dimension: new (0, $1G0Uw.Nt)(e1, t.u_dimension),
        u_elevation_stops: new (0, $1G0Uw.Mt)(e1, t.u_elevation_stops),
        u_color_stops: new (0, $1G0Uw.Mt)(e1, t.u_color_stops),
        u_color_ramp_size: new (0, $1G0Uw.Mt)(e1, t.u_color_ramp_size),
        u_opacity: new (0, $1G0Uw.jt)(e1, t.u_opacity)
    }), $4324d99ae8520741$var$_u = (e1, t, n = 0)=>({
        u_image: 0,
        u_unpack: t.getUnpackVector(),
        u_dimension: [
            t.stride,
            t.stride
        ],
        u_elevation_stops: 1,
        u_color_stops: 4,
        u_color_ramp_size: n,
        u_opacity: e1.paint.get(`color-relief-opacity`)
    }), $4324d99ae8520741$var$vu = (e1, t)=>({
        u_translation: new (0, $1G0Uw.Nt)(e1, t.u_translation),
        u_ratio: new (0, $1G0Uw.jt)(e1, t.u_ratio)
    }), $4324d99ae8520741$var$yu = (e1, t)=>({
        u_translation: new (0, $1G0Uw.Nt)(e1, t.u_translation),
        u_ratio: new (0, $1G0Uw.jt)(e1, t.u_ratio),
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_image_height: new (0, $1G0Uw.jt)(e1, t.u_image_height)
    }), $4324d99ae8520741$var$bu = (e1, t)=>({
        u_translation: new (0, $1G0Uw.Nt)(e1, t.u_translation),
        u_texsize: new (0, $1G0Uw.Nt)(e1, t.u_texsize),
        u_ratio: new (0, $1G0Uw.jt)(e1, t.u_ratio),
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_scale: new (0, $1G0Uw.Pt)(e1, t.u_scale),
        u_fade: new (0, $1G0Uw.jt)(e1, t.u_fade)
    }), $4324d99ae8520741$var$xu = (e1, t)=>({
        u_translation: new (0, $1G0Uw.Nt)(e1, t.u_translation),
        u_ratio: new (0, $1G0Uw.jt)(e1, t.u_ratio),
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_mix: new (0, $1G0Uw.jt)(e1, t.u_mix),
        u_tileratio: new (0, $1G0Uw.jt)(e1, t.u_tileratio),
        u_crossfade_from: new (0, $1G0Uw.jt)(e1, t.u_crossfade_from),
        u_crossfade_to: new (0, $1G0Uw.jt)(e1, t.u_crossfade_to),
        u_lineatlas_width: new (0, $1G0Uw.jt)(e1, t.u_lineatlas_width),
        u_lineatlas_height: new (0, $1G0Uw.jt)(e1, t.u_lineatlas_height)
    }), $4324d99ae8520741$var$Su = (e1, t)=>({
        u_translation: new (0, $1G0Uw.Nt)(e1, t.u_translation),
        u_ratio: new (0, $1G0Uw.jt)(e1, t.u_ratio),
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_image_height: new (0, $1G0Uw.jt)(e1, t.u_image_height),
        u_tileratio: new (0, $1G0Uw.jt)(e1, t.u_tileratio),
        u_crossfade_from: new (0, $1G0Uw.jt)(e1, t.u_crossfade_from),
        u_crossfade_to: new (0, $1G0Uw.jt)(e1, t.u_crossfade_to),
        u_image_dash: new (0, $1G0Uw.Mt)(e1, t.u_image_dash),
        u_mix: new (0, $1G0Uw.jt)(e1, t.u_mix),
        u_lineatlas_width: new (0, $1G0Uw.jt)(e1, t.u_lineatlas_width),
        u_lineatlas_height: new (0, $1G0Uw.jt)(e1, t.u_lineatlas_height)
    }), $4324d99ae8520741$var$Cu = (e1, t, n, r)=>{
    let i = e1.transform;
    return {
        u_translation: $4324d99ae8520741$var$ku(e1, t, n),
        u_ratio: r / (0, $1G0Uw.Ir)(t, 1, i.zoom)
    };
}, $4324d99ae8520741$var$wu = (e1, t, n, r, i)=>(0, $1G0Uw.er)($4324d99ae8520741$var$Cu(e1, t, n, r), {
        u_image: 0,
        u_image_height: i
    }), $4324d99ae8520741$var$Tu = (e1, t, n, r, i)=>{
    let a = e1.transform, o = $4324d99ae8520741$var$Ou(t, a);
    return {
        u_translation: $4324d99ae8520741$var$ku(e1, t, n),
        u_texsize: t.imageAtlasTexture.size,
        u_ratio: r / (0, $1G0Uw.Ir)(t, 1, a.zoom),
        u_image: 0,
        u_scale: [
            o,
            i.fromScale,
            i.toScale
        ],
        u_fade: i.t
    };
}, $4324d99ae8520741$var$Eu = (e1, t, n, r, i)=>{
    let a = e1.transform, o = $4324d99ae8520741$var$Ou(t, a);
    return (0, $1G0Uw.er)($4324d99ae8520741$var$Cu(e1, t, n, r), {
        u_tileratio: o,
        u_crossfade_from: i.fromScale,
        u_crossfade_to: i.toScale,
        u_image: 0,
        u_mix: i.t,
        u_lineatlas_width: e1.lineAtlas.width,
        u_lineatlas_height: e1.lineAtlas.height
    });
}, $4324d99ae8520741$var$Du = (e1, t, n, r, i, a)=>{
    let o = e1.transform, s = $4324d99ae8520741$var$Ou(t, o);
    return (0, $1G0Uw.er)($4324d99ae8520741$var$Cu(e1, t, n, r), {
        u_image: 0,
        u_image_height: a,
        u_tileratio: s,
        u_crossfade_from: i.fromScale,
        u_crossfade_to: i.toScale,
        u_image_dash: 1,
        u_mix: i.t,
        u_lineatlas_width: e1.lineAtlas.width,
        u_lineatlas_height: e1.lineAtlas.height
    });
};
function $4324d99ae8520741$var$Ou(e1, t) {
    return 1 / (0, $1G0Uw.Ir)(e1, 1, t.tileZoom);
}
function $4324d99ae8520741$var$ku(e1, t, n) {
    return (0, $1G0Uw.jr)(e1.transform, t, n.paint.get(`line-translate`), n.paint.get(`line-translate-anchor`));
}
const $4324d99ae8520741$var$Au = (e1, t)=>({
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_opacity: new (0, $1G0Uw.jt)(e1, t.u_opacity)
    }), $4324d99ae8520741$var$ju = (e1, t)=>({
        u_image: t,
        u_opacity: e1
    }), $4324d99ae8520741$var$Mu = (e1, t)=>({
        u_is_size_zoom_constant: new (0, $1G0Uw.Mt)(e1, t.u_is_size_zoom_constant),
        u_is_size_feature_constant: new (0, $1G0Uw.Mt)(e1, t.u_is_size_feature_constant),
        u_size_t: new (0, $1G0Uw.jt)(e1, t.u_size_t),
        u_size: new (0, $1G0Uw.jt)(e1, t.u_size),
        u_rotate_symbol: new (0, $1G0Uw.Mt)(e1, t.u_rotate_symbol),
        u_label_plane_matrix: new (0, $1G0Uw.zt)(e1, t.u_label_plane_matrix),
        u_coord_matrix: new (0, $1G0Uw.zt)(e1, t.u_coord_matrix),
        u_is_text: new (0, $1G0Uw.Mt)(e1, t.u_is_text),
        u_pitch_with_map: new (0, $1G0Uw.Mt)(e1, t.u_pitch_with_map),
        u_is_along_line: new (0, $1G0Uw.Mt)(e1, t.u_is_along_line),
        u_is_variable_anchor: new (0, $1G0Uw.Mt)(e1, t.u_is_variable_anchor),
        u_texsize: new (0, $1G0Uw.Nt)(e1, t.u_texsize),
        u_texture: new (0, $1G0Uw.Mt)(e1, t.u_texture),
        u_translation: new (0, $1G0Uw.Nt)(e1, t.u_translation),
        u_pitched_scale: new (0, $1G0Uw.jt)(e1, t.u_pitched_scale),
        u_is_offset: new (0, $1G0Uw.Mt)(e1, t.u_is_offset),
        u_height_anchor_ground: new (0, $1G0Uw.Mt)(e1, t.u_height_anchor_ground)
    }), $4324d99ae8520741$var$Nu = (e1, t)=>({
        u_is_size_zoom_constant: new (0, $1G0Uw.Mt)(e1, t.u_is_size_zoom_constant),
        u_is_size_feature_constant: new (0, $1G0Uw.Mt)(e1, t.u_is_size_feature_constant),
        u_size_t: new (0, $1G0Uw.jt)(e1, t.u_size_t),
        u_size: new (0, $1G0Uw.jt)(e1, t.u_size),
        u_rotate_symbol: new (0, $1G0Uw.Mt)(e1, t.u_rotate_symbol),
        u_label_plane_matrix: new (0, $1G0Uw.zt)(e1, t.u_label_plane_matrix),
        u_coord_matrix: new (0, $1G0Uw.zt)(e1, t.u_coord_matrix),
        u_is_text: new (0, $1G0Uw.Mt)(e1, t.u_is_text),
        u_pitch_with_map: new (0, $1G0Uw.Mt)(e1, t.u_pitch_with_map),
        u_is_along_line: new (0, $1G0Uw.Mt)(e1, t.u_is_along_line),
        u_is_variable_anchor: new (0, $1G0Uw.Mt)(e1, t.u_is_variable_anchor),
        u_texsize: new (0, $1G0Uw.Nt)(e1, t.u_texsize),
        u_texture: new (0, $1G0Uw.Mt)(e1, t.u_texture),
        u_gamma_scale: new (0, $1G0Uw.jt)(e1, t.u_gamma_scale),
        u_is_halo: new (0, $1G0Uw.Mt)(e1, t.u_is_halo),
        u_is_plain: new (0, $1G0Uw.Mt)(e1, t.u_is_plain),
        u_translation: new (0, $1G0Uw.Nt)(e1, t.u_translation),
        u_pitched_scale: new (0, $1G0Uw.jt)(e1, t.u_pitched_scale),
        u_is_offset: new (0, $1G0Uw.Mt)(e1, t.u_is_offset),
        u_height_anchor_ground: new (0, $1G0Uw.Mt)(e1, t.u_height_anchor_ground)
    }), $4324d99ae8520741$var$Pu = (e1, t)=>({
        u_is_size_zoom_constant: new (0, $1G0Uw.Mt)(e1, t.u_is_size_zoom_constant),
        u_is_size_feature_constant: new (0, $1G0Uw.Mt)(e1, t.u_is_size_feature_constant),
        u_size_t: new (0, $1G0Uw.jt)(e1, t.u_size_t),
        u_size: new (0, $1G0Uw.jt)(e1, t.u_size),
        u_rotate_symbol: new (0, $1G0Uw.Mt)(e1, t.u_rotate_symbol),
        u_label_plane_matrix: new (0, $1G0Uw.zt)(e1, t.u_label_plane_matrix),
        u_coord_matrix: new (0, $1G0Uw.zt)(e1, t.u_coord_matrix),
        u_is_text: new (0, $1G0Uw.Mt)(e1, t.u_is_text),
        u_pitch_with_map: new (0, $1G0Uw.Mt)(e1, t.u_pitch_with_map),
        u_is_along_line: new (0, $1G0Uw.Mt)(e1, t.u_is_along_line),
        u_is_variable_anchor: new (0, $1G0Uw.Mt)(e1, t.u_is_variable_anchor),
        u_texsize: new (0, $1G0Uw.Nt)(e1, t.u_texsize),
        u_texsize_icon: new (0, $1G0Uw.Nt)(e1, t.u_texsize_icon),
        u_texture: new (0, $1G0Uw.Mt)(e1, t.u_texture),
        u_texture_icon: new (0, $1G0Uw.Mt)(e1, t.u_texture_icon),
        u_gamma_scale: new (0, $1G0Uw.jt)(e1, t.u_gamma_scale),
        u_is_halo: new (0, $1G0Uw.Mt)(e1, t.u_is_halo),
        u_translation: new (0, $1G0Uw.Nt)(e1, t.u_translation),
        u_pitched_scale: new (0, $1G0Uw.jt)(e1, t.u_pitched_scale),
        u_is_offset: new (0, $1G0Uw.Mt)(e1, t.u_is_offset),
        u_height_anchor_ground: new (0, $1G0Uw.Mt)(e1, t.u_height_anchor_ground)
    }), $4324d99ae8520741$var$Fu = (e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m)=>({
        u_is_size_zoom_constant: +(e1 === `constant` || e1 === `source`),
        u_is_size_feature_constant: +(e1 === `constant` || e1 === `camera`),
        u_size_t: t ? t.uSizeT : 0,
        u_size: t ? t.uSize : 0,
        u_rotate_symbol: +n,
        u_label_plane_matrix: s,
        u_coord_matrix: c,
        u_is_text: +u,
        u_pitch_with_map: +r,
        u_is_along_line: i,
        u_is_variable_anchor: a,
        u_texsize: d,
        u_texture: 0,
        u_translation: l,
        u_pitched_scale: f,
        u_is_offset: p,
        u_height_anchor_ground: +m
    }), $4324d99ae8520741$var$Iu = (e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h)=>{
    let g = o.transform;
    return (0, $1G0Uw.er)($4324d99ae8520741$var$Fu(e1, t, n, r, i, a, o, s, c, l, u, d, p, m, h), {
        u_gamma_scale: r ? Math.cos(g.pitch * Math.PI / 180) * g.cameraToCenterDistance : 1,
        u_is_halo: +!!f,
        u_is_plain: 1
    });
}, $4324d99ae8520741$var$Lu = (e1, t, n, r, i, a, o, s, c, l, u, d, f, p, m)=>(0, $1G0Uw.er)($4324d99ae8520741$var$Iu(e1, t, n, r, i, a, o, s, c, l, !0, u, !0, f, p, m), {
        u_texsize_icon: d,
        u_texture_icon: 1
    }), $4324d99ae8520741$var$Ru = (e1, t)=>({
        u_opacity: new (0, $1G0Uw.jt)(e1, t.u_opacity),
        u_color: new (0, $1G0Uw.It)(e1, t.u_color)
    }), $4324d99ae8520741$var$zu = (e1, t)=>({
        u_opacity: new (0, $1G0Uw.jt)(e1, t.u_opacity),
        u_image: new (0, $1G0Uw.Mt)(e1, t.u_image),
        u_pattern_tl_a: new (0, $1G0Uw.Nt)(e1, t.u_pattern_tl_a),
        u_pattern_br_a: new (0, $1G0Uw.Nt)(e1, t.u_pattern_br_a),
        u_pattern_tl_b: new (0, $1G0Uw.Nt)(e1, t.u_pattern_tl_b),
        u_pattern_br_b: new (0, $1G0Uw.Nt)(e1, t.u_pattern_br_b),
        u_texsize: new (0, $1G0Uw.Nt)(e1, t.u_texsize),
        u_mix: new (0, $1G0Uw.jt)(e1, t.u_mix),
        u_pattern_size_a: new (0, $1G0Uw.Nt)(e1, t.u_pattern_size_a),
        u_pattern_size_b: new (0, $1G0Uw.Nt)(e1, t.u_pattern_size_b),
        u_scale_a: new (0, $1G0Uw.jt)(e1, t.u_scale_a),
        u_scale_b: new (0, $1G0Uw.jt)(e1, t.u_scale_b),
        u_pixel_coord_upper: new (0, $1G0Uw.Nt)(e1, t.u_pixel_coord_upper),
        u_pixel_coord_lower: new (0, $1G0Uw.Nt)(e1, t.u_pixel_coord_lower),
        u_tile_units_to_pixels: new (0, $1G0Uw.jt)(e1, t.u_tile_units_to_pixels)
    }), $4324d99ae8520741$var$Bu = (e1, t)=>({
        u_opacity: e1,
        u_color: t
    }), $4324d99ae8520741$var$Vu = (e1, t, n, r, i)=>(0, $1G0Uw.er)($4324d99ae8520741$var$Wl(n, i, t, r), {
        u_opacity: e1
    }), $4324d99ae8520741$var$Hu = (e1, t)=>({
        u_sun_pos: new (0, $1G0Uw.Pt)(e1, t.u_sun_pos),
        u_atmosphere_blend: new (0, $1G0Uw.jt)(e1, t.u_atmosphere_blend),
        u_globe_position: new (0, $1G0Uw.Pt)(e1, t.u_globe_position),
        u_globe_radius: new (0, $1G0Uw.jt)(e1, t.u_globe_radius),
        u_inv_proj_matrix: new (0, $1G0Uw.zt)(e1, t.u_inv_proj_matrix)
    }), $4324d99ae8520741$var$Uu = (e1, t, n, r, i)=>({
        u_sun_pos: e1,
        u_atmosphere_blend: t,
        u_globe_position: n,
        u_globe_radius: r,
        u_inv_proj_matrix: i
    }), $4324d99ae8520741$var$Wu = (e1, t)=>({
        u_sky_color: new (0, $1G0Uw.It)(e1, t.u_sky_color),
        u_horizon_color: new (0, $1G0Uw.It)(e1, t.u_horizon_color),
        u_horizon: new (0, $1G0Uw.Nt)(e1, t.u_horizon),
        u_horizon_normal: new (0, $1G0Uw.Nt)(e1, t.u_horizon_normal),
        u_sky_horizon_blend: new (0, $1G0Uw.jt)(e1, t.u_sky_horizon_blend),
        u_sky_blend: new (0, $1G0Uw.jt)(e1, t.u_sky_blend),
        u_inv_proj_matrix: new (0, $1G0Uw.zt)(e1, t.u_inv_proj_matrix),
        u_globe_position: new (0, $1G0Uw.Pt)(e1, t.u_globe_position),
        u_globe_radius: new (0, $1G0Uw.jt)(e1, t.u_globe_radius)
    }), $4324d99ae8520741$var$Gu = (e1, t, n)=>{
    let r = Math.cos(t.rollInRadians), i = Math.sin(t.rollInRadians), a = (0, $1G0Uw.Z)(t), o = t.getProjectionData({
        overscaledTileID: null,
        applyGlobeMatrix: !0,
        applyTerrainMatrix: !0
    }).projectionTransition;
    return {
        u_sky_color: e1.properties.get(`sky-color`),
        u_horizon_color: e1.properties.get(`horizon-color`),
        u_horizon: [
            (t.width / 2 - a * i) * n,
            (t.height / 2 + a * r) * n
        ],
        u_horizon_normal: [
            -i,
            r
        ],
        u_sky_horizon_blend: e1.properties.get(`sky-horizon-blend`) * t.height / 2 * n,
        u_sky_blend: o,
        u_inv_proj_matrix: t.inverseProjectionMatrix,
        u_globe_position: $4324d99ae8520741$var$Vc(t),
        u_globe_radius: $4324d99ae8520741$var$Bc(t.worldSize, t.center.lat)
    };
}, $4324d99ae8520741$var$Ku = (e1, t)=>({}), $4324d99ae8520741$var$qu = {
    fillExtrusion: $4324d99ae8520741$var$Gl,
    fillExtrusionPattern: $4324d99ae8520741$var$Kl,
    fill: $4324d99ae8520741$var$Yl,
    fillPattern: $4324d99ae8520741$var$Xl,
    fillOutline: $4324d99ae8520741$var$Zl,
    fillOutlinePattern: $4324d99ae8520741$var$Ql,
    circle: $4324d99ae8520741$var$ru,
    collisionBox: $4324d99ae8520741$var$Ku,
    collisionCircle: $4324d99ae8520741$var$Ku,
    debug: $4324d99ae8520741$var$au,
    depth: $4324d99ae8520741$var$Ku,
    clippingMask: $4324d99ae8520741$var$Ku,
    heatmap: $4324d99ae8520741$var$su,
    heatmapTexture: $4324d99ae8520741$var$cu,
    hillshade: $4324d99ae8520741$var$du,
    hillshadePrepare: $4324d99ae8520741$var$fu,
    colorRelief: $4324d99ae8520741$var$gu,
    line: $4324d99ae8520741$var$vu,
    lineGradient: $4324d99ae8520741$var$yu,
    linePattern: $4324d99ae8520741$var$bu,
    lineSDF: $4324d99ae8520741$var$xu,
    lineGradientSDF: $4324d99ae8520741$var$Su,
    layerOpacity: $4324d99ae8520741$var$Au,
    raster: $4324d99ae8520741$var$Ra,
    symbolIcon: $4324d99ae8520741$var$Mu,
    symbolSDF: $4324d99ae8520741$var$Nu,
    symbolTextAndIcon: $4324d99ae8520741$var$Pu,
    background: $4324d99ae8520741$var$Ru,
    backgroundPattern: $4324d99ae8520741$var$zu,
    terrain: $4324d99ae8520741$var$Cl,
    terrainDepth: $4324d99ae8520741$var$wl,
    atmosphere: $4324d99ae8520741$var$Hu,
    sky: $4324d99ae8520741$var$Wu
};
var $4324d99ae8520741$var$Ju = class {
    constructor(e1, t, n){
        this.context = e1;
        let r = e1.gl;
        this.buffer = r.createBuffer(), this.dynamicDraw = !!n, this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), r.bufferData(r.ELEMENT_ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || t.freeBufferAfterUpload();
    }
    bind() {
        this.context.bindElementBuffer.set(this.buffer);
    }
    updateData(e1) {
        let t = this.context.gl;
        if (!this.dynamicDraw) throw Error(`Attempted to update data while not in dynamic mode.`);
        this.context.unbindVAO(), this.bind(), t.bufferSubData(t.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
    }
    destroy() {
        let e1 = this.context.gl;
        this.buffer && (e1.deleteBuffer(this.buffer), delete this.buffer);
    }
};
const $4324d99ae8520741$var$Yu = {
    Int8: `BYTE`,
    Uint8: `UNSIGNED_BYTE`,
    Int16: `SHORT`,
    Uint16: `UNSIGNED_SHORT`,
    Int32: `INT`,
    Uint32: `UNSIGNED_INT`,
    Float32: `FLOAT`
};
var $4324d99ae8520741$var$Xu = class {
    constructor(e1, t, n, r){
        this.length = t.length, this.attributes = n, this.itemSize = t.bytesPerElement, this.dynamicDraw = r, this.context = e1;
        let i = e1.gl;
        this.buffer = i.createBuffer(), e1.bindVertexBuffer.set(this.buffer), i.bufferData(i.ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? i.DYNAMIC_DRAW : i.STATIC_DRAW), this.dynamicDraw || t.freeBufferAfterUpload();
    }
    bind() {
        this.context.bindVertexBuffer.set(this.buffer);
    }
    updateData(e1) {
        if (e1.length !== this.length) throw Error(`Length of new data is ${e1.length}, which doesn't match current length of ${this.length}`);
        let t = this.context.gl;
        this.bind(), t.bufferSubData(t.ARRAY_BUFFER, 0, e1.arrayBuffer);
    }
    enableAttributes(e1, t) {
        for (let n of this.attributes){
            let r = t.attributes[n.name];
            r !== void 0 && e1.enableVertexAttribArray(r.location);
        }
    }
    setVertexAttribPointers(e1, t, n) {
        for (let r of this.attributes){
            let i = t.attributes[r.name];
            if (i !== void 0) {
                let t = r.offset + this.itemSize * (n || 0);
                i.isInteger ? e1.vertexAttribIPointer(i.location, r.components, e1[$4324d99ae8520741$var$Yu[r.type]], this.itemSize, t) : e1.vertexAttribPointer(i.location, r.components, e1[$4324d99ae8520741$var$Yu[r.type]], !1, this.itemSize, t);
            }
        }
    }
    destroy() {
        let e1 = this.context.gl;
        this.buffer && (e1.deleteBuffer(this.buffer), delete this.buffer);
    }
}, $4324d99ae8520741$var$X = class {
    constructor(e1){
        this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
    }
    get() {
        return this.current;
    }
    set(e1) {}
    getDefault() {
        return this.default;
    }
    setDefault() {
        this.set(this.default);
    }
}, $4324d99ae8520741$var$Zu = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return (0, $1G0Uw.fn).transparent;
    }
    set(e1) {
        let t = this.current;
        (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$Qu = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return 1;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$$u = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return 0;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$ed = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return [
            !0,
            !0,
            !0,
            !0
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$td = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return !0;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$nd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return 255;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$rd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return {
            func: this.gl.ALWAYS,
            ref: 0,
            mask: 255
        };
    }
    set(e1) {
        let t = this.current;
        (e1.func !== t.func || e1.ref !== t.ref || e1.mask !== t.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$id = class extends $4324d99ae8520741$var$X {
    getDefault() {
        let e1 = this.gl;
        return [
            e1.KEEP,
            e1.KEEP,
            e1.KEEP
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$ad = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.STENCIL_TEST) : t.disable(t.STENCIL_TEST), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$od = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return [
            0,
            1
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$sd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.DEPTH_TEST) : t.disable(t.DEPTH_TEST), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$cd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return this.gl.LESS;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$ld = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.BLEND) : t.disable(t.BLEND), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$ud = class extends $4324d99ae8520741$var$X {
    getDefault() {
        let e1 = this.gl;
        return [
            e1.ONE,
            e1.ZERO
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || this.dirty) && (this.gl.blendFunc(e1[0], e1[1]), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$dd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return (0, $1G0Uw.fn).transparent;
    }
    set(e1) {
        let t = this.current;
        (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$fd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return this.gl.FUNC_ADD;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.blendEquation(e1), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$pd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.CULL_FACE) : t.disable(t.CULL_FACE), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$md = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return this.gl.BACK;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$hd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return this.gl.CCW;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$gd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$_d = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return this.gl.TEXTURE0;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$vd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        let e1 = this.gl;
        return [
            0,
            0,
            e1.drawingBufferWidth,
            e1.drawingBufferHeight
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$yd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindFramebuffer(t.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$bd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindRenderbuffer(t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$xd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindTexture(t.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$Sd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindBuffer(t.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$Cd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        let t = this.gl;
        t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$wd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return null;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.bindVertexArray(e1), this.current = e1, this.dirty = !1);
    }
}, $4324d99ae8520741$var$Td = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return 4;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.pixelStorei(t.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$Ed = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$Dd = class extends $4324d99ae8520741$var$X {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$Od = class extends $4324d99ae8520741$var$X {
    constructor(e1, t){
        super(e1), this.context = e1, this.parent = t;
    }
    getDefault() {
        return null;
    }
}, $4324d99ae8520741$var$kd = class extends $4324d99ae8520741$var$Od {
    setDirty() {
        this.dirty = !0;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        this.context.bindFramebuffer.set(this.parent);
        let t = this.gl;
        t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$Ad = class extends $4324d99ae8520741$var$Od {
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        this.context.bindFramebuffer.set(this.parent);
        let t = this.gl;
        t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$jd = class extends $4324d99ae8520741$var$Od {
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        this.context.bindFramebuffer.set(this.parent);
        let t = this.gl;
        t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $4324d99ae8520741$var$Md = class {
    constructor(e1, t, n, r, i){
        this.context = e1, this.width = t, this.height = n;
        let a = e1.gl, o = this.framebuffer = a.createFramebuffer();
        if (this.colorAttachment = new $4324d99ae8520741$var$kd(e1, o), r) this.depthAttachment = i ? new $4324d99ae8520741$var$jd(e1, o) : new $4324d99ae8520741$var$Ad(e1, o);
        else if (i) throw Error(`Stencil cannot be set without depth`);
    }
    destroy() {
        let e1 = this.context.gl, t = this.colorAttachment.get();
        if (t && e1.deleteTexture(t), this.depthAttachment) {
            let t = this.depthAttachment.get();
            t && e1.deleteRenderbuffer(t);
        }
        e1.deleteFramebuffer(this.framebuffer);
    }
};
const $4324d99ae8520741$var$Nd = $4324d99ae8520741$var$Al([
    {
        name: `u_units_to_pixels`,
        type: `vec2`
    },
    {
        name: `u_world_size`,
        type: `vec2`
    },
    {
        name: `u_camera_to_center_distance`,
        type: `float`
    },
    {
        name: `u_symbol_fade_change`,
        type: `float`
    },
    {
        name: `u_aspect_ratio`,
        type: `float`
    },
    {
        name: `u_device_pixel_ratio`,
        type: `float`
    },
    {
        name: `u_viewport_size`,
        type: `vec2`
    },
    {
        name: `u_pixel_extrude_scale`,
        type: `vec2`
    },
    {
        name: `u_pitch`,
        type: `float`
    }
]), $4324d99ae8520741$var$Pd = $4324d99ae8520741$var$Nd.offsets;
function $4324d99ae8520741$var$Fd(e1) {
    return new $4324d99ae8520741$var$jl(e1, $4324d99ae8520741$var$Dl.FrameUBO, $4324d99ae8520741$var$Nd);
}
function $4324d99ae8520741$var$Id(e1, t) {
    let n = e1.pending, { transform: r } = t, i = t.context.gl;
    n[$4324d99ae8520741$var$Pd.u_units_to_pixels] = 1 / r.pixelsToGLUnits[0], n[$4324d99ae8520741$var$Pd.u_units_to_pixels + 1] = 1 / r.pixelsToGLUnits[1], n[$4324d99ae8520741$var$Pd.u_world_size] = i.drawingBufferWidth, n[$4324d99ae8520741$var$Pd.u_world_size + 1] = i.drawingBufferHeight, n[$4324d99ae8520741$var$Pd.u_camera_to_center_distance] = r.cameraToCenterDistance, n[$4324d99ae8520741$var$Pd.u_symbol_fade_change] = t.options.fadeDuration ? t.symbolFadeChange : 1, n[$4324d99ae8520741$var$Pd.u_aspect_ratio] = r.width / r.height, n[$4324d99ae8520741$var$Pd.u_device_pixel_ratio] = t.pixelRatio, n[$4324d99ae8520741$var$Pd.u_viewport_size] = r.width, n[$4324d99ae8520741$var$Pd.u_viewport_size + 1] = r.height, n[$4324d99ae8520741$var$Pd.u_pixel_extrude_scale] = 1 / r.width, n[$4324d99ae8520741$var$Pd.u_pixel_extrude_scale + 1] = 1 / r.height, n[$4324d99ae8520741$var$Pd.u_pitch] = r.pitch / 360 * 2 * Math.PI, e1.upload();
}
var $4324d99ae8520741$var$Ld = class {
    constructor(e1, t, n){
        this.blendFunction = e1, this.blendColor = t, this.mask = n;
    }
};
$4324d99ae8520741$var$Ld.Replace = [
    1,
    0
], $4324d99ae8520741$var$Ld.disabled = new $4324d99ae8520741$var$Ld($4324d99ae8520741$var$Ld.Replace, (0, $1G0Uw.fn).transparent, [
    !1,
    !1,
    !1,
    !1
]), $4324d99ae8520741$var$Ld.unblended = new $4324d99ae8520741$var$Ld($4324d99ae8520741$var$Ld.Replace, (0, $1G0Uw.fn).transparent, [
    !0,
    !0,
    !0,
    !0
]), $4324d99ae8520741$var$Ld.alphaBlended = new $4324d99ae8520741$var$Ld([
    1,
    771
], (0, $1G0Uw.fn).transparent, [
    !0,
    !0,
    !0,
    !0
]);
var $4324d99ae8520741$var$Rd = class {
    constructor(e1){
        this.gl = e1, this.clearColor = new $4324d99ae8520741$var$Zu(this), this.clearDepth = new $4324d99ae8520741$var$Qu(this), this.clearStencil = new $4324d99ae8520741$var$$u(this), this.colorMask = new $4324d99ae8520741$var$ed(this), this.depthMask = new $4324d99ae8520741$var$td(this), this.stencilMask = new $4324d99ae8520741$var$nd(this), this.stencilFunc = new $4324d99ae8520741$var$rd(this), this.stencilOp = new $4324d99ae8520741$var$id(this), this.stencilTest = new $4324d99ae8520741$var$ad(this), this.depthRange = new $4324d99ae8520741$var$od(this), this.depthTest = new $4324d99ae8520741$var$sd(this), this.depthFunc = new $4324d99ae8520741$var$cd(this), this.blend = new $4324d99ae8520741$var$ld(this), this.blendFunc = new $4324d99ae8520741$var$ud(this), this.blendColor = new $4324d99ae8520741$var$dd(this), this.blendEquation = new $4324d99ae8520741$var$fd(this), this.cullFace = new $4324d99ae8520741$var$pd(this), this.cullFaceSide = new $4324d99ae8520741$var$md(this), this.frontFace = new $4324d99ae8520741$var$hd(this), this.program = new $4324d99ae8520741$var$gd(this), this.activeTexture = new $4324d99ae8520741$var$_d(this), this.viewport = new $4324d99ae8520741$var$vd(this), this.bindFramebuffer = new $4324d99ae8520741$var$yd(this), this.bindRenderbuffer = new $4324d99ae8520741$var$bd(this), this.bindTexture = new $4324d99ae8520741$var$xd(this), this.bindVertexBuffer = new $4324d99ae8520741$var$Sd(this), this.bindElementBuffer = new $4324d99ae8520741$var$Cd(this), this.bindVertexArray = new $4324d99ae8520741$var$wd(this), this.pixelStoreUnpack = new $4324d99ae8520741$var$Td(this), this.pixelStoreUnpackPremultiplyAlpha = new $4324d99ae8520741$var$Ed(this), this.pixelStoreUnpackFlipY = new $4324d99ae8520741$var$Dd(this), this.extTextureFilterAnisotropic = e1.getExtension(`EXT_texture_filter_anisotropic`), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE), e1.getExtension(`EXT_color_buffer_half_float`), e1.getExtension(`EXT_color_buffer_float`), this.projectionUniformBuffer = $4324d99ae8520741$var$Pl(this), this.terrainUniformBuffer = $4324d99ae8520741$var$Rl(this), this.frameUniformBuffer = $4324d99ae8520741$var$Fd(this);
    }
    setDefault() {
        this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
    }
    setDirty() {
        this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0, this.projectionUniformBuffer.bindingDirty = !0, this.terrainUniformBuffer.bindingDirty = !0, this.frameUniformBuffer.bindingDirty = !0;
    }
    setCustomLayerDefaults() {
        this.unbindVAO(), this.cullFace.setDefault(), this.activeTexture.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
    }
    createIndexBuffer(e1, t) {
        return new $4324d99ae8520741$var$Ju(this, e1, t);
    }
    createVertexBuffer(e1, t, n) {
        return new $4324d99ae8520741$var$Xu(this, e1, t, n);
    }
    createRenderbuffer(e1, t, n) {
        let r = this.gl, i = r.createRenderbuffer();
        return this.bindRenderbuffer.set(i), r.renderbufferStorage(r.RENDERBUFFER, e1, t, n), this.bindRenderbuffer.set(null), i;
    }
    createFramebuffer(e1, t, n, r) {
        return new $4324d99ae8520741$var$Md(this, e1, t, n, r);
    }
    clear({ color: e1, depth: t, stencil: n }) {
        let r = this.gl, i = 0;
        e1 && (i |= r.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set([
            !0,
            !0,
            !0,
            !0
        ])), t !== void 0 && (i |= r.DEPTH_BUFFER_BIT, this.depthRange.set([
            0,
            1
        ]), this.clearDepth.set(t), this.depthMask.set(!0)), n !== void 0 && (i |= r.STENCIL_BUFFER_BIT, this.clearStencil.set(n), this.stencilMask.set(255)), r.clear(i);
    }
    setCullFace(e1) {
        e1.enable === !1 ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
    }
    setDepthMode(e1) {
        e1.func === this.gl.ALWAYS && !e1.mask ? this.depthTest.set(!1) : (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range));
    }
    setStencilMode(e1) {
        e1.test.func === this.gl.ALWAYS && !e1.mask ? this.stencilTest.set(!1) : (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
            e1.fail,
            e1.depthFail,
            e1.pass
        ]), this.stencilFunc.set({
            func: e1.test.func,
            ref: e1.ref,
            mask: e1.test.mask
        }));
    }
    setColorMode(e1) {
        (0, $1G0Uw.qn)(e1.blendFunction, $4324d99ae8520741$var$Ld.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor)), this.colorMask.set(e1.mask);
    }
    createVertexArray() {
        return this.gl.createVertexArray();
    }
    deleteVertexArray(e1) {
        this.gl.deleteVertexArray(e1);
    }
    unbindVAO() {
        this.bindVertexArray.set(null);
    }
}, $4324d99ae8520741$var$Z = class {
    constructor(e1, t, n){
        this.func = e1, this.mask = t, this.range = n;
    }
};
$4324d99ae8520741$var$Z.ReadOnly = !1, $4324d99ae8520741$var$Z.ReadWrite = !0, $4324d99ae8520741$var$Z.disabled = new $4324d99ae8520741$var$Z(519, $4324d99ae8520741$var$Z.ReadOnly, [
    0,
    1
]);
const $4324d99ae8520741$var$zd = 7680;
var $4324d99ae8520741$var$Q = class {
    constructor(e1, t, n, r, i, a){
        this.test = e1, this.ref = t, this.mask = n, this.fail = r, this.depthFail = i, this.pass = a;
    }
};
$4324d99ae8520741$var$Q.disabled = new $4324d99ae8520741$var$Q({
    func: 519,
    mask: 0
}, 0, 0, $4324d99ae8520741$var$zd, $4324d99ae8520741$var$zd, $4324d99ae8520741$var$zd);
const $4324d99ae8520741$var$Bd = 1029, $4324d99ae8520741$var$Vd = 2305;
var $4324d99ae8520741$var$$ = class {
    constructor(e1, t, n){
        this.enable = e1, this.mode = t, this.frontFace = n;
    }
};
$4324d99ae8520741$var$$.disabled = new $4324d99ae8520741$var$$(!1, $4324d99ae8520741$var$Bd, $4324d99ae8520741$var$Vd), $4324d99ae8520741$var$$.backCCW = new $4324d99ae8520741$var$$(!0, $4324d99ae8520741$var$Bd, $4324d99ae8520741$var$Vd), $4324d99ae8520741$var$$.frontCCW = new $4324d99ae8520741$var$$(!0, 1028, $4324d99ae8520741$var$Vd);
let $4324d99ae8520741$var$Hd;
function $4324d99ae8520741$var$Ud(e1, t, n, r, i) {
    let a = e1.context, o = e1.transform, s = a.gl, c = e1.useProgram(`collisionBox`), l = [], u = 0, d = 0;
    for (let f of r){
        let r = t.getTile(f).getBucket(n);
        if (!r) continue;
        let p = i ? r.textCollisionBox : r.iconCollisionBox, m = r.collisionCircleArray;
        m.length > 0 && (l.push({
            circleArray: m,
            circleOffset: d,
            coord: f
        }), u += m.length / 4, d = u), p && c.draw(a, s.LINES, $4324d99ae8520741$var$Z.disabled, $4324d99ae8520741$var$Q.disabled, e1.colorModeForRenderPass(), $4324d99ae8520741$var$$.disabled, null, e1.style.map.terrain?.getTerrainData(f), o.getProjectionData({
            overscaledTileID: f,
            applyGlobeMatrix: !0,
            applyTerrainMatrix: !0
        }), n.id, p.layoutVertexBuffer, p.indexBuffer, p.segments, null, e1.transform.zoom, null, null, p.collisionVertexBuffer);
    }
    if (!i || !l.length) return;
    let p = e1.useProgram(`collisionCircle`), m = new (0, $1G0Uw.Ht);
    m.resize(u * 4), m._trim();
    let h = 0;
    for (let e1 of l)for(let t = 0; t < e1.circleArray.length / 4; t++){
        let n = t * 4, r = e1.circleArray[n + 0], i = e1.circleArray[n + 1], a = e1.circleArray[n + 2], o = e1.circleArray[n + 3];
        m.emplace(h++, r, i, a, o, 0), m.emplace(h++, r, i, a, o, 1), m.emplace(h++, r, i, a, o, 2), m.emplace(h++, r, i, a, o, 3);
    }
    (!$4324d99ae8520741$var$Hd || $4324d99ae8520741$var$Hd.length < u * 2) && ($4324d99ae8520741$var$Hd = $4324d99ae8520741$var$Wd(u));
    let g = a.createIndexBuffer($4324d99ae8520741$var$Hd, !0), _ = a.createVertexBuffer(m, (0, $1G0Uw.U).members, !0);
    for (let t of l)p.draw(a, s.TRIANGLES, $4324d99ae8520741$var$Z.disabled, $4324d99ae8520741$var$Q.disabled, e1.colorModeForRenderPass(), $4324d99ae8520741$var$$.disabled, null, e1.style.map.terrain?.getTerrainData(t.coord), null, n.id, _, g, (0, $1G0Uw.Bt).simpleSegment(0, t.circleOffset * 2, t.circleArray.length, t.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
    _.destroy(), g.destroy();
}
function $4324d99ae8520741$var$Wd(e1) {
    let t = e1 * 2, n = new (0, $1G0Uw.Kt);
    n.resize(t), n._trim();
    for(let e1 = 0; e1 < t; e1++){
        let t = e1 * 6;
        n.uint16[t + 0] = e1 * 4 + 0, n.uint16[t + 1] = e1 * 4 + 1, n.uint16[t + 2] = e1 * 4 + 2, n.uint16[t + 3] = e1 * 4 + 2, n.uint16[t + 4] = e1 * 4 + 3, n.uint16[t + 5] = e1 * 4 + 0;
    }
    return n;
}
const $4324d99ae8520741$var$Gd = (0, $1G0Uw.Si)(new Float32Array(16));
function $4324d99ae8520741$var$Kd(e1, t, n, r, i, a) {
    if (a.currentPass !== `translucent`) return;
    let { isRenderingToTexture: o } = a, s = $4324d99ae8520741$var$Q.disabled, c = e1.colorModeForRenderPass();
    (n._unevaluatedLayout.hasValue(`text-variable-anchor`) || n._unevaluatedLayout.hasValue(`text-variable-anchor-offset`)) && $4324d99ae8520741$var$Jd(r, e1, n, t, n.layout.get(`text-rotation-alignment`), n.layout.get(`text-pitch-alignment`), n.paint.get(`text-translate`), n.paint.get(`text-translate-anchor`), i), n.paint.get(`icon-opacity`).constantOr(1) !== 0 && $4324d99ae8520741$var$Qd(e1, t, n, r, !1, n.paint.get(`icon-translate`), n.paint.get(`icon-translate-anchor`), n.layout.get(`icon-rotation-alignment`).constantOr(`viewport`), n.layout.get(`icon-pitch-alignment`), n.layout.get(`icon-keep-upright`), s, c, o), n.paint.get(`text-opacity`).constantOr(1) !== 0 && $4324d99ae8520741$var$Qd(e1, t, n, r, !0, n.paint.get(`text-translate`), n.paint.get(`text-translate-anchor`), n.layout.get(`text-rotation-alignment`), n.layout.get(`text-pitch-alignment`), n.layout.get(`text-keep-upright`), s, c, o), t.map.showCollisionBoxes && ($4324d99ae8520741$var$Ud(e1, t, n, r, !0), $4324d99ae8520741$var$Ud(e1, t, n, r, !1));
}
function $4324d99ae8520741$var$qd(e1, t, n, r, i, a) {
    let { horizontalAlign: o, verticalAlign: s } = (0, $1G0Uw.M)(e1), c = -(o - .5) * t, l = -(s - .5) * n;
    return new (0, $1G0Uw.Li)((c / i + r[0]) * a, (l / i + r[1]) * a);
}
function $4324d99ae8520741$var$Jd(e1, t, n, r, a, o, s, c, l) {
    let u = t.transform, d = t.style.map.terrain, f = a === `map`, p = o === `map`;
    for (let a of e1){
        let e1 = r.getTile(a), o = e1.getBucket(n);
        if (!o?.text?.segments.get().length) continue;
        let m = o.textSizeData, h = (0, $1G0Uw.A)(m, u.zoom), g = (0, $1G0Uw.Ir)(e1, 1, t.transform.zoom), _ = $4324d99ae8520741$var$Yo(f, t.transform, g), v = n.layout.get(`icon-text-fit`) !== `none` && o.hasIconData();
        if (h) {
            let t = 2 ** (u.zoom - e1.tileID.overscaledZ), r = d ? (e1, t)=>d.getElevation(a, e1, t) : void 0;
            $4324d99ae8520741$var$Xd(o, f, p, l, u, _, t, h, v, (0, $1G0Uw.jr)(u, e1, s, c), a.toUnwrapped(), r, n.layout.get(`symbol-height-anchor`) === `ground`);
        }
    }
}
function $4324d99ae8520741$var$Yd(e1, t, n, r, i, a) {
    let o = t.tileAnchorPoint.add(new (0, $1G0Uw.Li)(t.translation[0], t.translation[1]));
    if (t.pitchWithMap) {
        let e1 = r.mult(a);
        n || (e1 = e1.rotate(-i));
        let s = o.add(e1);
        return $4324d99ae8520741$var$$o(s.x, s.y, t.pitchedLabelPlaneMatrix, $4324d99ae8520741$var$Qo(t, s.x, s.y)).point;
    }
    if (n) {
        let n = $4324d99ae8520741$var$cs(t.tileAnchorPoint.x + 1, t.tileAnchorPoint.y, t).point.sub(e1), i = Math.atan(n.y / n.x) + (n.x < 0 ? Math.PI : 0);
        return e1.add(r.rotate(i));
    }
    return e1.add(r);
}
function $4324d99ae8520741$var$Xd(e1, t, n, r, i, a, o, s, c, l, u, d, f) {
    let m = e1.text.placedSymbolArray, h = e1.text.dynamicLayoutVertexArray, g = e1.icon.dynamicLayoutVertexArray, _ = {};
    h.clear();
    for(let g = 0; g < m.length; g++){
        let v = m.get(g), y = e1.allowVerticalPlacement && !v.placedOrientation, b = !v.hidden && v.crossTileID && !y ? r[v.crossTileID] : null;
        if (!b) $4324d99ae8520741$var$hs(v.numGlyphs, h);
        else {
            let r = new (0, $1G0Uw.Li)(v.anchorX, v.anchorY), m = {
                getElevation: d,
                heightOffset: v.heightOffset,
                heightAnchorGround: f,
                width: i.width,
                height: i.height,
                pitchedLabelPlaneMatrix: a,
                lineVertexArray: null,
                pitchWithMap: n,
                transform: i,
                projectionCache: null,
                tileAnchorPoint: r,
                translation: l,
                unwrappedTileID: u
            }, g = n ? $4324d99ae8520741$var$us(r.x, r.y, m) : $4324d99ae8520741$var$cs(r.x, r.y, m), y = $4324d99ae8520741$var$es(i.cameraToCenterDistance, g.signedDistanceFromCamera), x = (0, $1G0Uw.k)(e1.textSizeData, s, v) * y / 24;
            n && (x *= e1.tilePixelRatio / o);
            let { width: S, height: C, anchor: w, textOffset: T, textBoxScale: E } = b, D = $4324d99ae8520741$var$qd(w, S, C, T, E, x), O = i.getPitchedTextCorrection(r.x + l[0], r.y + l[1], u), k = $4324d99ae8520741$var$Yd(g.point, m, t, D, -i.bearingInRadians, O), A = e1.allowVerticalPlacement && v.placedOrientation === 2 ? Math.PI / 2 : 0;
            for(let e1 = 0; e1 < v.numGlyphs; e1++)(0, $1G0Uw.C)(h, k, A);
            c && v.associatedIconIndex >= 0 && (_[v.associatedIconIndex] = {
                shiftedAnchor: k,
                angle: A
            });
        }
    }
    if (c) {
        g.clear();
        let t = e1.icon.placedSymbolArray;
        for(let e1 = 0; e1 < t.length; e1++){
            let n = t.get(e1);
            if (n.hidden) $4324d99ae8520741$var$hs(n.numGlyphs, g);
            else {
                let t = _[e1];
                if (!t) $4324d99ae8520741$var$hs(n.numGlyphs, g);
                else for(let e1 = 0; e1 < n.numGlyphs; e1++)(0, $1G0Uw.C)(g, t.shiftedAnchor, t.angle);
            }
        }
        e1.icon.dynamicLayoutVertexBuffer.updateData(g);
    }
    e1.text.dynamicLayoutVertexBuffer.updateData(h);
}
function $4324d99ae8520741$var$Zd(e1, t, n) {
    return n.iconsInText && t ? `symbolTextAndIcon` : e1 ? `symbolSDF` : `symbolIcon`;
}
function $4324d99ae8520741$var$Qd(e1, t, n, r, a, o, s, c, l, u, d, p, m) {
    let h = e1.context, g = h.gl, _ = e1.transform, v = c === `map`, y = l === `map`, b = c !== `viewport` && n.layout.get(`symbol-placement`) !== `point`, x = v && !y && !b, S = !n.layout.get(`symbol-sort-key`).isConstant(), C = !1, w = e1.getDepthModeForSublayer(0, $4324d99ae8520741$var$Z.ReadOnly), T = n._unevaluatedLayout.hasValue(`text-variable-anchor`) || n._unevaluatedLayout.hasValue(`text-variable-anchor-offset`), E = [], D = _.getCircleRadiusCorrection();
    for (let c of r){
        let r = t.getTile(c), l = r.getBucket(n);
        if (!l) continue;
        let d = a ? l.text : l.icon;
        if (!d?.segments.get().length || !d.hasVisibleVertices) continue;
        let p = d.programConfigurations.get(n.id), h = a || l.sdfIcons, w = a ? l.textSizeData : l.iconSizeData, O = y || _.pitch !== 0, k = e1.useProgram($4324d99ae8520741$var$Zd(h, a, l), p), A = (0, $1G0Uw.A)(w, _.zoom), j = e1.style.map.terrain?.getTerrainData(c), M, ee = [
            0,
            0
        ], te, ne, re = null, ie;
        if (a) {
            if (te = r.glyphAtlasTexture, ne = g.LINEAR, M = r.glyphAtlasTexture.size, l.iconsInText) {
                ee = r.imageAtlasTexture.size, re = r.imageAtlasTexture;
                let t = w.kind === `composite` || w.kind === `camera`;
                ie = O || e1.options.rotating || e1.options.zooming || t ? g.LINEAR : g.NEAREST;
            }
        } else {
            let t = n.layout.get(`icon-size`).constantOr(0) !== 1 || l.iconsNeedLinear;
            te = r.imageAtlasTexture, ne = h || e1.options.rotating || e1.options.zooming || t || O ? g.LINEAR : g.NEAREST, M = r.imageAtlasTexture.size;
        }
        let ae = (0, $1G0Uw.Ir)(r, 1, e1.transform.zoom), oe = $4324d99ae8520741$var$Yo(v, e1.transform, ae), se = $4324d99ae8520741$var$Xo(y, v, e1.transform, ae), le = (0, $1G0Uw.jr)(_, r, o, s), ue = _.getProjectionData({
            overscaledTileID: c,
            applyGlobeMatrix: !m,
            applyTerrainMatrix: !0
        }), de = T && l.hasTextData(), fe = n.layout.get(`icon-text-fit`) !== `none` && de && l.hasIconData(), pe = n._unevaluatedLayout.hasValue(`icon-offset`), me = n.layout.get(`symbol-height-anchor`) === `ground`;
        if (b) {
            let t = (0, $1G0Uw.vi)();
            $4324d99ae8520741$var$Go(t, oe);
            let r = e1.style.map.terrain ? (t, n)=>e1.style.map.terrain.getElevation(c, t, n) : void 0;
            $4324d99ae8520741$var$ns(l, e1, a, oe, t, y, u, n.layout.get(`text-rotation-alignment`) === `map`, c.toUnwrapped(), _.width, _.height, le, r);
        }
        let he = a && T || fe, ge = y ? oe : e1.transform.clipSpaceToPixelsMatrix, _e = b || he ? $4324d99ae8520741$var$Gd : ge, ve = h && n.paint.get(a ? `text-halo-width` : `icon-halo-width`).constantOr(1) !== 0, N;
        N = h ? l.iconsInText ? $4324d99ae8520741$var$Lu(w.kind, A, x, y, b, he, e1, _e, se, le, M, ee, D, pe, me) : $4324d99ae8520741$var$Iu(w.kind, A, x, y, b, he, e1, _e, se, le, a, M, ve, D, pe, me) : $4324d99ae8520741$var$Fu(w.kind, A, x, y, b, he, e1, _e, se, le, a, M, D, pe, me);
        let ye = {
            program: k,
            buffers: d,
            uniformValues: N,
            projectionData: ue,
            atlasTexture: te,
            atlasTextureIcon: re,
            atlasInterpolation: ne,
            atlasInterpolationIcon: ie,
            isSDF: h,
            hasHalo: ve
        };
        if (S && l.canOverlap) {
            C = !0;
            let e1 = d.segments.get();
            for (let t of e1)E.push({
                segments: new (0, $1G0Uw.Bt)([
                    t
                ]),
                sortKey: t.sortKey,
                state: ye,
                terrainData: j
            });
        } else E.push({
            segments: d.segments,
            sortKey: 0,
            state: ye,
            terrainData: j
        });
    }
    C && E.sort((e1, t)=>e1.sortKey - t.sortKey);
    let O = n.paint.get(a ? `text-halo-width` : `icon-halo-width`).constantOr(null) ?? 1 / 0, k = n.layout.get(`text-letter-spacing`).constantOr(0) * 24 < 0 || O > 1;
    for (let t of E){
        let r = t.state;
        h.activeTexture.set(g.TEXTURE0), r.atlasTexture.bind(r.atlasInterpolation, g.CLAMP_TO_EDGE), r.atlasTextureIcon && (h.activeTexture.set(g.TEXTURE1), r.atlasTextureIcon && r.atlasTextureIcon.bind(r.atlasInterpolationIcon, g.CLAMP_TO_EDGE));
        let i = r.isSDF && r.hasHalo;
        if (i) {
            let i = r.uniformValues;
            i.u_is_halo = 1, k && (i.u_is_plain = 0, $4324d99ae8520741$var$$d(r.buffers, t.segments, n, e1, r.program, w, d, p, i, r.projectionData, t.terrainData), i.u_is_halo = 0, i.u_is_plain = 1);
        }
        $4324d99ae8520741$var$$d(r.buffers, t.segments, n, e1, r.program, w, d, p, r.uniformValues, r.projectionData, t.terrainData), i && !k && (r.uniformValues.u_is_halo = 0);
    }
}
function $4324d99ae8520741$var$$d(e1, t, n, r, i, a, o, s, c, l, u) {
    let d = r.context, f = d.gl;
    i.draw(d, f.TRIANGLES, a, o, s, $4324d99ae8520741$var$$.backCCW, c, u, l, n.id, e1.layoutVertexBuffer, e1.indexBuffer, t, n.paint, r.transform.zoom, e1.programConfigurations.get(n.id), e1.dynamicLayoutVertexBuffer, e1.opacityVertexBuffer);
}
function $4324d99ae8520741$var$ef(e1, t, n, r, i) {
    if (i.currentPass !== `translucent`) return;
    let { isRenderingToTexture: a } = i, o = n.paint.get(`circle-opacity`), s = n.paint.get(`circle-stroke-width`), c = n.paint.get(`circle-stroke-opacity`), l = !n.layout.get(`circle-sort-key`).isConstant();
    if (o.constantOr(1) === 0 && (s.constantOr(1) === 0 || c.constantOr(1) === 0)) return;
    let u = e1.context, d = u.gl, p = e1.transform, m = e1.getDepthModeForSublayer(0, $4324d99ae8520741$var$Z.ReadOnly), h = $4324d99ae8520741$var$Q.disabled, g = e1.colorModeForRenderPass(), _ = [], v = p.getCircleRadiusCorrection();
    for (let i of r){
        let r = t.getTile(i), o = r.getBucket(n);
        if (!o) continue;
        let s = n.paint.get(`circle-translate`), c = n.paint.get(`circle-translate-anchor`), u = (0, $1G0Uw.jr)(p, r, s, c), d = o.programConfigurations.get(n.id), m = e1.useProgram(`circle`, d), h = o.layoutVertexBuffer, g = o.indexBuffer, y = e1.style.map.terrain?.getTerrainData(i), b = {
            programConfiguration: d,
            program: m,
            layoutVertexBuffer: h,
            indexBuffer: g,
            uniformValues: $4324d99ae8520741$var$iu(e1, r, n, u, v),
            terrainData: y,
            projectionData: p.getProjectionData({
                overscaledTileID: i,
                applyGlobeMatrix: !a,
                applyTerrainMatrix: !0
            })
        };
        if (l) {
            let e1 = o.segments.get();
            for (let t of e1)_.push({
                segments: new (0, $1G0Uw.Bt)([
                    t
                ]),
                sortKey: t.sortKey,
                state: b
            });
        } else _.push({
            segments: o.segments,
            sortKey: 0,
            state: b
        });
    }
    l && _.sort((e1, t)=>e1.sortKey - t.sortKey);
    for (let t of _){
        let { programConfiguration: r, program: i, layoutVertexBuffer: a, indexBuffer: o, uniformValues: s, terrainData: c, projectionData: l } = t.state, f = t.segments;
        i.draw(u, d.TRIANGLES, m, h, g, $4324d99ae8520741$var$$.backCCW, s, c, l, n.id, a, o, f, n.paint, e1.transform.zoom, r);
    }
}
function $4324d99ae8520741$var$tf(e1, t, n, r, i) {
    if (n.paint.get(`heatmap-opacity`) === 0) return;
    let a = e1.context, { isRenderingToTexture: o, isRenderingGlobe: s } = i;
    if (e1.style.map.terrain) {
        for (let a of r){
            let r = t.getTile(a);
            t.hasRenderableParent(a) || (i.currentPass === `offscreen` ? $4324d99ae8520741$var$af(e1, r, n, a, s) : i.currentPass === `translucent` && $4324d99ae8520741$var$of(e1, n, a, o, s));
        }
        a.viewport.set([
            0,
            0,
            e1.width,
            e1.height
        ]);
    } else i.currentPass === `offscreen` ? $4324d99ae8520741$var$nf(e1, t, n, r) : i.currentPass === `translucent` && $4324d99ae8520741$var$rf(e1, n);
}
function $4324d99ae8520741$var$nf(e1, t, n, r) {
    let i = e1.context, a = i.gl, o = e1.transform, s = $4324d99ae8520741$var$Q.disabled, c = new $4324d99ae8520741$var$Ld([
        a.ONE,
        a.ONE
    ], (0, $1G0Uw.fn).transparent, [
        !0,
        !0,
        !0,
        !0
    ]);
    $4324d99ae8520741$var$sf(i, e1, n), i.clear({
        color: (0, $1G0Uw.fn).transparent
    });
    for (let l of r){
        if (t.hasRenderableParent(l)) continue;
        let r = t.getTile(l), u = r.getBucket(n);
        if (!u) continue;
        let d = u.programConfigurations.get(n.id), f = e1.useProgram(`heatmap`, d), p = o.getProjectionData({
            overscaledTileID: l,
            applyGlobeMatrix: !0,
            applyTerrainMatrix: !1
        }), m = o.getCircleRadiusCorrection();
        f.draw(i, a.TRIANGLES, $4324d99ae8520741$var$Z.disabled, s, c, $4324d99ae8520741$var$$.backCCW, $4324d99ae8520741$var$lu(r, o.zoom, n.paint.get(`heatmap-intensity`), m), null, p, n.id, u.layoutVertexBuffer, u.indexBuffer, u.segments, n.paint, o.zoom, d);
    }
    i.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
}
function $4324d99ae8520741$var$rf(e1, t) {
    let n = e1.context, r = n.gl;
    n.setColorMode(e1.colorModeForRenderPass());
    let i = t.heatmapFbos.get((0, $1G0Uw.Ct));
    i && (n.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, i.colorAttachment.get()), n.activeTexture.set(r.TEXTURE1), $4324d99ae8520741$var$lf(n, t).bind(r.LINEAR, r.CLAMP_TO_EDGE), e1.useProgram(`heatmapTexture`).draw(n, r.TRIANGLES, $4324d99ae8520741$var$Z.disabled, $4324d99ae8520741$var$Q.disabled, e1.colorModeForRenderPass(), $4324d99ae8520741$var$$.disabled, $4324d99ae8520741$var$uu(e1, t, 0, 1), null, null, t.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, t.paint, e1.transform.zoom));
}
function $4324d99ae8520741$var$af(e1, t, n, r, i) {
    let a = e1.context, o = a.gl, s = $4324d99ae8520741$var$Q.disabled, c = new $4324d99ae8520741$var$Ld([
        o.ONE,
        o.ONE
    ], (0, $1G0Uw.fn).transparent, [
        !0,
        !0,
        !0,
        !0
    ]), l = t.getBucket(n);
    if (!l) return;
    let u = r.key, d = n.heatmapFbos.get(u);
    d || (d = $4324d99ae8520741$var$cf(a, t.tileSize, t.tileSize), n.heatmapFbos.set(u, d)), a.bindFramebuffer.set(d.framebuffer), a.viewport.set([
        0,
        0,
        t.tileSize,
        t.tileSize
    ]), a.clear({
        color: (0, $1G0Uw.fn).transparent
    });
    let f = l.programConfigurations.get(n.id), p = e1.useProgram(`heatmap`, f, !i), m = e1.transform.getProjectionData({
        overscaledTileID: t.tileID,
        applyGlobeMatrix: !0,
        applyTerrainMatrix: !0
    }), h = e1.style.map.terrain.getTerrainData(r);
    p.draw(a, o.TRIANGLES, $4324d99ae8520741$var$Z.disabled, s, c, $4324d99ae8520741$var$$.disabled, $4324d99ae8520741$var$lu(t, e1.transform.zoom, n.paint.get(`heatmap-intensity`), 1), h, m, n.id, l.layoutVertexBuffer, l.indexBuffer, l.segments, n.paint, e1.transform.zoom, f);
}
function $4324d99ae8520741$var$of(e1, t, n, r, i) {
    let a = e1.context, o = a.gl, s = e1.transform;
    a.setColorMode(e1.colorModeForRenderPass());
    let c = $4324d99ae8520741$var$lf(a, t), l = n.key, u = t.heatmapFbos.get(l);
    if (!u) return;
    a.activeTexture.set(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, u.colorAttachment.get()), a.activeTexture.set(o.TEXTURE1), c.bind(o.LINEAR, o.CLAMP_TO_EDGE);
    let d = s.getProjectionData({
        overscaledTileID: n,
        applyTerrainMatrix: i,
        applyGlobeMatrix: !r
    });
    e1.useProgram(`heatmapTexture`).draw(a, o.TRIANGLES, $4324d99ae8520741$var$Z.disabled, $4324d99ae8520741$var$Q.disabled, e1.colorModeForRenderPass(), $4324d99ae8520741$var$$.disabled, $4324d99ae8520741$var$uu(e1, t, 0, 1), null, d, t.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments, t.paint, s.zoom), u.destroy(), t.heatmapFbos.delete(l);
}
function $4324d99ae8520741$var$sf(e1, t, n) {
    let r = e1.gl;
    e1.activeTexture.set(r.TEXTURE1), e1.viewport.set([
        0,
        0,
        t.width / 4,
        t.height / 4
    ]);
    let i = n.heatmapFbos.get((0, $1G0Uw.Ct));
    i ? (r.bindTexture(r.TEXTURE_2D, i.colorAttachment.get()), e1.bindFramebuffer.set(i.framebuffer)) : (i = $4324d99ae8520741$var$cf(e1, t.width / 4, t.height / 4), n.heatmapFbos.set((0, $1G0Uw.Ct), i));
}
function $4324d99ae8520741$var$cf(e1, t, n) {
    let r = e1.gl, i = r.createTexture();
    r.bindTexture(r.TEXTURE_2D, i), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), r.texStorage2D(r.TEXTURE_2D, 1, r.RGBA16F, t, n);
    let a = e1.createFramebuffer(t, n, !1, !1);
    return a.colorAttachment.set(i), a;
}
function $4324d99ae8520741$var$lf(e1, t) {
    return t.colorRampTexture ||= new (0, $1G0Uw.xt)(e1, t.colorRamp, e1.gl.RGBA), t.colorRampTexture;
}
function $4324d99ae8520741$var$uf(e1, t, n, r) {
    let i = e1.context, a = i.bindFramebuffer.get(), o = i.viewport.get(), [, , s, c] = o;
    return $4324d99ae8520741$var$df(e1, s, c), i.viewport.set([
        0,
        0,
        s,
        c
    ]), i.clear({
        color: (0, $1G0Uw.fn).transparent,
        depth: 1,
        stencil: 0
    }), e1.currentStencilSource = void 0, e1.renderTileClippingMasks(t, n, r), {
        compositeTarget: a,
        compositeViewport: o
    };
}
function $4324d99ae8520741$var$df(e1, t, n) {
    let r = e1.context.gl;
    if (!e1.layerOpacityFbo) {
        let i = e1.context.createFramebuffer(t, n, !0, !0), a = r.createTexture();
        r.bindTexture(r.TEXTURE_2D, a), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, t, n, 0, r.RGBA, r.UNSIGNED_BYTE, null), i.colorAttachment.set(a), i.depthAttachment.set(e1.context.createRenderbuffer(r.DEPTH_STENCIL, t, n)), e1.layerOpacityFbo = i, e1.context.bindFramebuffer.set(e1.layerOpacityFbo.framebuffer);
        return;
    }
    if (e1.layerOpacityFbo.width === t && e1.layerOpacityFbo.height === n) {
        e1.context.bindFramebuffer.set(e1.layerOpacityFbo.framebuffer);
        return;
    }
    let i = e1.layerOpacityFbo;
    r.bindTexture(r.TEXTURE_2D, i.colorAttachment.get()), r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, t, n, 0, r.RGBA, r.UNSIGNED_BYTE, null), e1.context.bindRenderbuffer.set(i.depthAttachment.get()), r.renderbufferStorage(r.RENDERBUFFER, r.DEPTH_STENCIL, t, n), e1.context.bindRenderbuffer.set(null), i.width = t, i.height = n, e1.context.bindFramebuffer.set(i.framebuffer);
}
function $4324d99ae8520741$var$ff(e1, t, n, r) {
    let i = e1.context, a = i.gl;
    i.bindFramebuffer.set(n.compositeTarget), i.viewport.set(n.compositeViewport), i.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_2D, e1.layerOpacityFbo.colorAttachment.get()), e1.useProgram(`layerOpacity`).draw(i, a.TRIANGLES, $4324d99ae8520741$var$Z.disabled, $4324d99ae8520741$var$Q.disabled, e1.colorModeForRenderPass(), $4324d99ae8520741$var$$.disabled, $4324d99ae8520741$var$ju(t, 0), null, null, r.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, r.paint, e1.transform.zoom), e1.currentStencilSource = void 0;
}
function $4324d99ae8520741$var$pf(e1, t, n, r, i, a, o, s) {
    let c = 256;
    if (i.stepInterpolant) {
        let r = t.getSource().maxzoom, i = o.canonical.z === r ? Math.ceil(1 << e1.transform.maxZoom - o.canonical.z) : 1, s = a.maxLineLength / (0, $1G0Uw.Lr) * 1024 * i;
        c = (0, $1G0Uw.Bn)((0, $1G0Uw._r)(s), 256, n.maxTextureSize);
    }
    return s.gradient = (0, $1G0Uw.Tt)({
        expression: i.gradientExpression(),
        evaluationKey: `lineProgress`,
        resolution: c,
        image: s.gradient || void 0,
        clips: a.lineClipsArray
    }), s.texture ? s.texture.update(s.gradient) : s.texture = new (0, $1G0Uw.xt)(n, s.gradient, r.RGBA), s.version = i.gradientVersion, s.texture;
}
function $4324d99ae8520741$var$mf(e1, t, n, r, i) {
    e1.activeTexture.set(t.TEXTURE0), n.imageAtlasTexture.bind(t.LINEAR, t.CLAMP_TO_EDGE), r.updatePaintBuffers(i);
}
function $4324d99ae8520741$var$hf(e1, t, n, r, i, a) {
    (i || e1.lineAtlas.dirty) && (t.activeTexture.set(n.TEXTURE0), e1.lineAtlas.bind(t)), r.updatePaintBuffers(a);
}
function $4324d99ae8520741$var$gf(e1, t, n, r, i, a, o) {
    let s = a.gradients[i.id], c = s.texture;
    i.gradientVersion !== s.version && (c = $4324d99ae8520741$var$pf(e1, t, n, r, i, a, o, s)), n.activeTexture.set(r.TEXTURE0), c.bind(i.stepInterpolant ? r.NEAREST : r.LINEAR, r.CLAMP_TO_EDGE);
}
function $4324d99ae8520741$var$_f(e1, t, n, r, i, a, o, s, c) {
    let l = a.gradients[i.id], u = l.texture;
    i.gradientVersion !== l.version && (u = $4324d99ae8520741$var$pf(e1, t, n, r, i, a, o, l)), n.activeTexture.set(r.TEXTURE0), u.bind(i.stepInterpolant ? r.NEAREST : r.LINEAR, r.CLAMP_TO_EDGE), n.activeTexture.set(r.TEXTURE1), e1.lineAtlas.bind(n), s.updatePaintBuffers(c);
}
function $4324d99ae8520741$var$vf(e1, t, n, r, i) {
    if (i.currentPass !== `translucent`) return;
    let a = n.paint.get(`line-opacity`), o = n.paint.get(`line-width`), s = n.paint.get(`line-layer-opacity`);
    if (a.constantOr(1) === 0 || o.constantOr(1) === 0 || s === 0) return;
    let c = !!e1.style.map.terrain;
    if (s < 1) {
        let a = $4324d99ae8520741$var$uf(e1, n, r, c);
        $4324d99ae8520741$var$yf(e1, t, n, r, i, c), $4324d99ae8520741$var$ff(e1, s, a, n);
        return;
    }
    $4324d99ae8520741$var$yf(e1, t, n, r, i, c);
}
function $4324d99ae8520741$var$yf(e1, t, n, r, i, a) {
    let { isRenderingToTexture: o } = i, s = e1.getDepthModeForSublayer(0, $4324d99ae8520741$var$Z.ReadOnly), c = e1.colorModeForRenderPass(), l = n.paint.get(`line-dasharray`), u = l.constantOr(1), d = n.paint.get(`line-pattern`), f = d.constantOr(1), p = n.paint.get(`line-gradient`), m = n.getCrossfadeParameters(), h;
    h = f ? `linePattern` : u && p ? `lineGradientSDF` : u ? `lineSDF` : p ? `lineGradient` : `line`;
    let g = e1.context, _ = g.gl, v = e1.transform, y = !0;
    for (let i of r){
        let r = t.getTile(i);
        if (f && !r.patternsLoaded()) continue;
        let b = r.getBucket(n);
        if (!b) continue;
        let x = b.programConfigurations.get(n.id), S = e1.context.program.get(), C = e1.useProgram(h, x), w = y || C.program !== S, T = a ? e1.getTerrainDataForTile(i, o) : null, E = d.constantOr(null), D = l?.constantOr(null);
        if (E && r.imageAtlas) {
            let e1 = r.imageAtlas, t = e1.patternPositions[E.to.toString()], n = e1.patternPositions[E.from.toString()];
            t && n && x.setConstantPatternPositions(t, n);
        } else if (D) {
            let t = n.layout.get(`line-cap`).constantOr(null) === `round`, r = e1.lineAtlas.getDash(D.to, t), i = e1.lineAtlas.getDash(D.from, t);
            x.setConstantDashPositions(r, i);
        }
        let O = v.getProjectionData({
            overscaledTileID: i,
            applyGlobeMatrix: !o,
            applyTerrainMatrix: !0
        }), k = v.getPixelScale(), A;
        f ? (A = $4324d99ae8520741$var$Tu(e1, r, n, k, m), $4324d99ae8520741$var$mf(g, _, r, x, m)) : u && p ? (A = $4324d99ae8520741$var$Du(e1, r, n, k, m, b.lineClipsArray.length), $4324d99ae8520741$var$_f(e1, t, g, _, n, b, i, x, m)) : u ? (A = $4324d99ae8520741$var$Eu(e1, r, n, k, m), $4324d99ae8520741$var$hf(e1, g, _, x, w, m)) : p ? (A = $4324d99ae8520741$var$wu(e1, r, n, k, b.lineClipsArray.length), $4324d99ae8520741$var$gf(e1, t, g, _, n, b, i)) : A = $4324d99ae8520741$var$Cu(e1, r, n, k);
        let j = e1.stencilModeForClipping(i);
        C.draw(g, _.TRIANGLES, s, j, c, $4324d99ae8520741$var$$.disabled, A, T, O, n.id, b.layoutVertexBuffer, b.indexBuffer, b.segments, n.paint, e1.transform.zoom, x, b.layoutVertexBuffer2), y = !1;
    }
}
function $4324d99ae8520741$var$bf(e1, t, n, r, i) {
    if (!n || !r?.imageAtlas) return;
    let a = r.imageAtlas.patternPositions, o = a[n.to.toString()], s = a[n.from.toString()];
    if (!o && s && (o = s), !s && o && (s = o), !o || !s) {
        let e1 = i.getPaintProperty(t);
        o = a[e1], s = a[e1];
    }
    o && s && e1.setConstantPatternPositions(o, s);
}
function $4324d99ae8520741$var$xf(e1, t, n, r, i) {
    let a = n.paint.get(`fill-color`), o = n.paint.get(`fill-opacity`), s = n.paint.get(`fill-layer-opacity`);
    if (o.constantOr(1) === 0 || s === 0) return;
    if (s < 1) {
        if (i.currentPass !== `translucent`) return;
        let a = $4324d99ae8520741$var$uf(e1, n, r, !!e1.style.map.terrain);
        $4324d99ae8520741$var$Sf(e1, t, n, r, i), $4324d99ae8520741$var$ff(e1, s, a, n);
        return;
    }
    let c = n.paint.get(`fill-pattern`), l = e1.opaquePassEnabledForLayer() && !c.constantOr(1) && a.constantOr((0, $1G0Uw.fn).transparent).a === 1 && o.constantOr(0) === 1;
    if (l && i.currentPass === `opaque`) {
        let { isRenderingToTexture: a } = i, o = e1.colorModeForRenderPass();
        $4324d99ae8520741$var$wf(e1, t, n, r, e1.getDepthModeForSublayer(1, $4324d99ae8520741$var$Z.ReadWrite), o, !1, a);
        return;
    }
    if (l && i.currentPass === `translucent`) {
        $4324d99ae8520741$var$Cf(e1, t, n, r, i);
        return;
    }
    i.currentPass === `translucent` && $4324d99ae8520741$var$Sf(e1, t, n, r, i);
}
function $4324d99ae8520741$var$Sf(e1, t, n, r, i) {
    let { isRenderingToTexture: a } = i, o = e1.colorModeForRenderPass();
    $4324d99ae8520741$var$wf(e1, t, n, r, e1.getDepthModeForSublayer(1, $4324d99ae8520741$var$Z.ReadOnly), o, !1, a), $4324d99ae8520741$var$Cf(e1, t, n, r, i);
}
function $4324d99ae8520741$var$Cf(e1, t, n, r, i) {
    if (!n.paint.get(`fill-antialias`)) return;
    let { isRenderingToTexture: a } = i, o = e1.colorModeForRenderPass();
    $4324d99ae8520741$var$wf(e1, t, n, r, e1.getDepthModeForSublayer(n.getPaintProperty(`fill-outline-color`) ? 2 : 0, $4324d99ae8520741$var$Z.ReadOnly), o, !0, a);
}
function $4324d99ae8520741$var$wf(e1, t, n, r, i, a, o, s) {
    let c = e1.context.gl, l = `fill-pattern`, u = n.paint.get(l), d = u?.constantOr(1), f = n.getCrossfadeParameters(), p, m, h, g, _, v = e1.transform, y = n.paint.get(`fill-translate`), b = n.paint.get(`fill-translate-anchor`);
    o ? (m = d && !n.getPaintProperty(`fill-outline-color`) ? `fillOutlinePattern` : `fillOutline`, p = c.LINES) : (m = d ? `fillPattern` : `fill`, p = c.TRIANGLES);
    let x = u.constantOr(null);
    for (let u of r){
        let r = t.getTile(u);
        if (d && !r.patternsLoaded()) continue;
        let S = r.getBucket(n);
        if (!S) continue;
        let C = S.sdfPatterns[n.id] ?? !1, w = S.programConfigurations.get(n.id), T = e1.useProgram(m, w), E = e1.getTerrainDataForTile(u, s);
        d && (e1.context.activeTexture.set(c.TEXTURE0), r.imageAtlasTexture.bind(c.LINEAR, c.CLAMP_TO_EDGE), w.updatePaintBuffers(f)), $4324d99ae8520741$var$bf(w, l, x, r, n);
        let D = v.getProjectionData({
            overscaledTileID: u,
            applyGlobeMatrix: !s,
            applyTerrainMatrix: !0
        }), O = (0, $1G0Uw.jr)(v, r, y, b);
        o ? (g = S.indexBuffer2, _ = S.segments2, h = m === `fillOutlinePattern` && d ? $4324d99ae8520741$var$nu(e1, f, r, O, C) : $4324d99ae8520741$var$tu(O)) : (g = S.indexBuffer, _ = S.segments, h = d ? $4324d99ae8520741$var$$l(e1, f, r, O, C) : $4324d99ae8520741$var$eu(O));
        let k = e1.stencilModeForClipping(u);
        T.draw(e1.context, p, i, k, a, $4324d99ae8520741$var$$.backCCW, h, E, D, n.id, S.layoutVertexBuffer, g, _, n.paint, e1.transform.zoom, w);
    }
}
function $4324d99ae8520741$var$Tf(e1, t, n, r, i) {
    let a = n.paint.get(`fill-extrusion-opacity`);
    if (a === 0) return;
    let { isRenderingToTexture: o } = i;
    if (i.currentPass === `translucent`) {
        let s = new $4324d99ae8520741$var$Z(e1.context.gl.LEQUAL, $4324d99ae8520741$var$Z.ReadWrite, i.depthRangeFor3D);
        if (a === 1 && !n.paint.get(`fill-extrusion-pattern`).constantOr(1)) {
            let i = e1.colorModeForRenderPass();
            $4324d99ae8520741$var$Ef(e1, t, n, r, s, $4324d99ae8520741$var$Q.disabled, i, o);
        } else $4324d99ae8520741$var$Ef(e1, t, n, r, s, $4324d99ae8520741$var$Q.disabled, $4324d99ae8520741$var$Ld.disabled, o), $4324d99ae8520741$var$Ef(e1, t, n, r, s, e1.stencilModeFor3D(), e1.colorModeForRenderPass(), o);
    }
}
function $4324d99ae8520741$var$Ef(e1, t, n, r, i, a, o, s) {
    let c = e1.context, l = c.gl, u = `fill-extrusion-pattern`, d = n.paint.get(u), f = d.constantOr(1), p = n.getCrossfadeParameters(), m = n.paint.get(`fill-extrusion-opacity`), h = d.constantOr(null), g = e1.transform;
    for (let d of r){
        let r = t.getTile(d), _ = r.getBucket(n);
        if (!_) continue;
        let v = e1.style.map.terrain?.getTerrainData(d), y = _.programConfigurations.get(n.id), b = e1.useProgram(f ? `fillExtrusionPattern` : `fillExtrusion`, y);
        f && (e1.context.activeTexture.set(l.TEXTURE0), r.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), y.updatePaintBuffers(p));
        let x = g.getProjectionData({
            overscaledTileID: d,
            applyGlobeMatrix: !s,
            applyTerrainMatrix: !0
        });
        $4324d99ae8520741$var$bf(y, u, h, r, n);
        let S = (0, $1G0Uw.jr)(g, r, n.paint.get(`fill-extrusion-translate`), n.paint.get(`fill-extrusion-translate-anchor`)), C = n.paint.get(`fill-extrusion-vertical-gradient`), w = f ? $4324d99ae8520741$var$Jl(e1, C, m, S, d, p, r) : $4324d99ae8520741$var$ql(e1, C, m, S);
        b.draw(c, c.gl.TRIANGLES, i, a, o, $4324d99ae8520741$var$$.backCCW, w, v, x, n.id, _.layoutVertexBuffer, _.indexBuffer, _.segments, n.paint, e1.transform.zoom, y, e1.style.map.terrain && _.centroidVertexBuffer);
    }
}
function $4324d99ae8520741$var$Df(e1, t, n, r, i) {
    if (i.currentPass !== `offscreen` && i.currentPass !== `translucent`) return;
    let { isRenderingToTexture: a } = i, o = e1.context, s = e1.style.projection.useSubdivision, c = e1.getDepthModeForSublayer(0, $4324d99ae8520741$var$Z.ReadOnly), l = e1.colorModeForRenderPass();
    if (i.currentPass === `offscreen`) $4324d99ae8520741$var$kf(e1, t, r, n, c, $4324d99ae8520741$var$Q.disabled, l), o.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
    else if (i.currentPass === `translucent`) {
        if (s) {
            let [i, o, s] = e1.stencilConfigForOverlapTwoPass(r);
            $4324d99ae8520741$var$Of(e1, t, n, s, i, c, l, !1, a), $4324d99ae8520741$var$Of(e1, t, n, s, o, c, l, !0, a);
        } else {
            let [i, o] = e1.getStencilConfigForOverlapAndUpdateStencilID(r);
            $4324d99ae8520741$var$Of(e1, t, n, o, i, c, l, !1, a);
        }
    }
}
function $4324d99ae8520741$var$Of(e1, t, n, r, i, a, o, s, c) {
    let l = e1.style.projection, u = e1.context, d = e1.transform, f = u.gl, p = [
        `#define NUM_ILLUMINATION_SOURCES ${n.paint.get(`hillshade-highlight-color`).values.length}`
    ], m = e1.useProgram(`hillshade`, null, !1, p), h = !e1.options.moving;
    for (let p of r){
        let r = t.getTile(p), g = r.fbo;
        if (!g) continue;
        let _ = l.getMeshFromTileID(u, p.canonical, s, !0, `raster`), v = e1.getTerrainDataForTile(p, c);
        u.activeTexture.set(f.TEXTURE0), f.bindTexture(f.TEXTURE_2D, g.colorAttachment.get());
        let y = d.getProjectionData({
            overscaledTileID: p,
            aligned: h,
            applyGlobeMatrix: !c,
            applyTerrainMatrix: !0
        });
        m.draw(u, f.TRIANGLES, a, i[p.overscaledZ], o, $4324d99ae8520741$var$$.backCCW, $4324d99ae8520741$var$pu(e1, r, n), v, y, n.id, _.vertexBuffer, _.indexBuffer, _.segments);
    }
}
function $4324d99ae8520741$var$kf(e1, t, n, r, i, a, o) {
    let s = e1.context, c = s.gl, l = r.paint.get(`resampling`) === `nearest` ? c.NEAREST : c.LINEAR;
    for (let u of n){
        let n = t.getTile(u), d = n.dem;
        if (!d?.data || !n.needsHillshadePrepare) continue;
        let f = d.dim + 2, p = d.stride, m = d.getPixels();
        if (s.activeTexture.set(c.TEXTURE1), s.pixelStoreUnpackPremultiplyAlpha.set(!1), n.demTexture ||= e1.getTileTexture(p), n.demTexture) {
            let e1 = n.demTexture;
            e1.update(m, {
                premultiply: !1
            }), e1.bind(c.NEAREST, c.CLAMP_TO_EDGE);
        } else n.demTexture = new (0, $1G0Uw.xt)(s, m, c.RGBA, {
            premultiply: !1
        }), n.demTexture.bind(c.NEAREST, c.CLAMP_TO_EDGE);
        s.activeTexture.set(c.TEXTURE0);
        let h = n.fbo;
        if (!h) {
            let e1 = new (0, $1G0Uw.xt)(s, {
                width: f,
                height: f,
                data: null
            }, c.RGBA);
            e1.bind(l, c.CLAMP_TO_EDGE), h = n.fbo = s.createFramebuffer(f, f, !0, !1), h.colorAttachment.set(e1.texture);
        }
        s.bindFramebuffer.set(h.framebuffer), s.viewport.set([
            0,
            0,
            f,
            f
        ]), e1.useProgram(`hillshadePrepare`).draw(s, c.TRIANGLES, i, a, o, $4324d99ae8520741$var$$.disabled, $4324d99ae8520741$var$mu(n.tileID, d), null, null, r.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), n.needsHillshadePrepare = !1;
    }
}
function $4324d99ae8520741$var$Af(e1, t, n, r, i) {
    if (i.currentPass !== `translucent` || !r.length) return;
    let { isRenderingToTexture: a } = i, o = e1.style.projection.useSubdivision, s = e1.getDepthModeForSublayer(0, $4324d99ae8520741$var$Z.ReadOnly), c = e1.colorModeForRenderPass();
    if (o) {
        let [i, o, l] = e1.stencilConfigForOverlapTwoPass(r);
        $4324d99ae8520741$var$Mf(e1, t, n, l, i, s, c, !1, a), $4324d99ae8520741$var$Mf(e1, t, n, l, o, s, c, !0, a);
    } else {
        let [i, o] = e1.getStencilConfigForOverlapAndUpdateStencilID(r);
        $4324d99ae8520741$var$Mf(e1, t, n, o, i, s, c, !1, a);
    }
}
let $4324d99ae8520741$var$jf = 0;
function $4324d99ae8520741$var$Mf(e1, t, n, r, i, a, o, s, c) {
    let l = e1.style.projection, u = e1.context, d = e1.transform, f = u.gl, p = e1.useProgram(`colorRelief`), m = !e1.options.moving, h = n.paint.get(`resampling`) === `nearest` ? f.NEAREST : f.LINEAR, g = !0, _ = 0;
    for (let v of r){
        let r = t.getTile(v), y = r.dem;
        if (!y?.data) continue;
        if (g) {
            $4324d99ae8520741$var$jf ||= f.getParameter(f.MAX_TEXTURE_SIZE);
            let e1 = $4324d99ae8520741$var$jf, { elevationTexture: t, colorTexture: r } = n.getColorRampTextures(u, e1, y.getUnpackVector());
            u.activeTexture.set(f.TEXTURE1), t.bind(f.NEAREST, f.CLAMP_TO_EDGE), u.activeTexture.set(f.TEXTURE4), r.bind(f.LINEAR, f.CLAMP_TO_EDGE), g = !1, _ = t.size[0];
        }
        let b = y.stride;
        u.activeTexture.set(f.TEXTURE0), (!r.demTexture || r.needsColorReliefPrepare) && (u.pixelStoreUnpackPremultiplyAlpha.set(!1), r.demTexture ||= e1.getTileTexture(b) ?? new (0, $1G0Uw.xt)(u, {
            width: b,
            height: b,
            data: null
        }, f.RGBA), r.demTexture.update(y.getPixels(), {
            premultiply: !1
        }), r.needsColorReliefPrepare = !1), r.demTexture.bind(h, f.CLAMP_TO_EDGE);
        let x = l.getMeshFromTileID(u, v.canonical, s, !0, `raster`), S = e1.getTerrainDataForTile(v, c), C = d.getProjectionData({
            overscaledTileID: v,
            aligned: m,
            applyGlobeMatrix: !c,
            applyTerrainMatrix: !0
        });
        p.draw(u, f.TRIANGLES, a, i[v.overscaledZ], o, $4324d99ae8520741$var$$.backCCW, $4324d99ae8520741$var$_u(n, r.dem, _), S, C, n.id, x.vertexBuffer, x.indexBuffer, x.segments);
    }
}
const $4324d99ae8520741$var$Nf = [
    new (0, $1G0Uw.Li)(0, 0),
    new (0, $1G0Uw.Li)((0, $1G0Uw.Lr), 0),
    new (0, $1G0Uw.Li)((0, $1G0Uw.Lr), (0, $1G0Uw.Lr)),
    new (0, $1G0Uw.Li)(0, (0, $1G0Uw.Lr))
];
function $4324d99ae8520741$var$Pf(e1, t, n, r, i) {
    if (i.currentPass !== `translucent` || n.paint.get(`raster-opacity`) === 0 || !r.length) return;
    let { isRenderingToTexture: a } = i, o = t.getSource(), s = e1.style.projection.useSubdivision;
    if (o instanceof $4324d99ae8520741$export$280e9a68c3ffd919) $4324d99ae8520741$var$Ff(e1, t, n, r, null, !1, !1, o.tileCoords, o.imageWarp, o.flippedWindingOrder, a, o.getMesh(e1.context, s));
    else if (s) {
        let [i, o, s] = e1.stencilConfigForOverlapTwoPass(r);
        $4324d99ae8520741$var$Ff(e1, t, n, s, i, !1, !0, $4324d99ae8520741$var$Nf, $4324d99ae8520741$var$La, !1, a), $4324d99ae8520741$var$Ff(e1, t, n, s, o, !0, !0, $4324d99ae8520741$var$Nf, $4324d99ae8520741$var$La, !1, a);
    } else {
        let [i, o] = e1.getStencilConfigForOverlapAndUpdateStencilID(r);
        $4324d99ae8520741$var$Ff(e1, t, n, o, i, !1, !0, $4324d99ae8520741$var$Nf, $4324d99ae8520741$var$La, !1, a);
    }
}
function $4324d99ae8520741$var$Ff(e1, t, n, r, i, a, o, s, c, l = !1, u = !1, d = null) {
    let f = r[r.length - 1].overscaledZ, p = e1.context, m = p.gl, h = e1.useProgram(`raster`), g = e1.transform, _ = e1.style.projection, v = e1.colorModeForRenderPass(), y = !e1.options.moving, b = n.paint.get(`raster-opacity`), x = n.paint.get(`resampling`) === `nearest` || n.paint.get(`raster-resampling`) === `nearest` ? m.NEAREST : m.LINEAR, S = n.paint.get(`raster-fade-duration`), C = !!e1.style.map.terrain;
    for (let w of r){
        let r = e1.getDepthModeForSublayer(w.overscaledZ - f, b === 1 ? $4324d99ae8520741$var$Z.ReadWrite : $4324d99ae8520741$var$Z.ReadOnly, m.LESS), T = t.getTile(w);
        p.activeTexture.set(m.TEXTURE0), T.texture.bind(x, m.CLAMP_TO_EDGE, m.LINEAR_MIPMAP_NEAREST), p.activeTexture.set(m.TEXTURE1);
        let { parentTile: E, parentScaleBy: D, parentTopLeft: O, fadeValues: k } = $4324d99ae8520741$var$If(T, t, S, C);
        T.fadeOpacity = k.tileOpacity, E ? (E.fadeOpacity = k.parentTileOpacity, E.texture.bind(x, m.CLAMP_TO_EDGE, m.LINEAR_MIPMAP_NEAREST)) : T.texture.bind(x, m.CLAMP_TO_EDGE, m.LINEAR_MIPMAP_NEAREST), T.texture.useMipmap && p.extTextureFilterAnisotropic && e1.transform.pitch > e1.options.anisotropicFilterPitch && m.texParameterf(m.TEXTURE_2D, p.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, p.extTextureFilterAnisotropicMax);
        let A = e1.getTerrainDataForTile(w, u), j = g.getProjectionData({
            overscaledTileID: w,
            aligned: y,
            applyGlobeMatrix: !u,
            applyTerrainMatrix: !0
        }), M = $4324d99ae8520741$var$za(O, D, k.fadeMix, n, s, c), ee = d ?? _.getMeshFromTileID(p, w.canonical, a, o, `raster`), te = i ? i[w.overscaledZ] : $4324d99ae8520741$var$Q.disabled;
        h.draw(p, m.TRIANGLES, r, te, v, l ? $4324d99ae8520741$var$$.frontCCW : $4324d99ae8520741$var$$.backCCW, M, A, j, n.id, ee.vertexBuffer, ee.indexBuffer, ee.segments);
    }
}
function $4324d99ae8520741$var$If(e1, t, n, r) {
    let i = {
        parentTile: null,
        parentScaleBy: 1,
        parentTopLeft: [
            0,
            0
        ],
        fadeValues: {
            tileOpacity: 1,
            parentTileOpacity: 1,
            fadeMix: {
                opacity: 1,
                mix: 0
            }
        }
    };
    if (n === 0 || r) return i;
    if (e1.fadingParentID) {
        let r = t.getLoadedTile(e1.fadingParentID);
        if (!r) return i;
        let a = 2 ** (r.tileID.overscaledZ - e1.tileID.overscaledZ);
        return {
            parentTile: r,
            parentScaleBy: a,
            parentTopLeft: [
                e1.tileID.canonical.x * a % 1,
                e1.tileID.canonical.y * a % 1
            ],
            fadeValues: $4324d99ae8520741$var$Lf(e1, r, n)
        };
    }
    return e1.selfFading ? {
        parentTile: null,
        parentScaleBy: 1,
        parentTopLeft: [
            0,
            0
        ],
        fadeValues: $4324d99ae8520741$var$Rf(e1, n)
    } : i;
}
function $4324d99ae8520741$var$Lf(e1, t, n) {
    let r = $4324d99ae8520741$export$461939dd4422153(), i = (r - e1.timeAdded) / n, a = (r - t.timeAdded) / n, o = e1.fadingDirection === 1, s = (0, $1G0Uw.Bn)(i, 0, 1), c = (0, $1G0Uw.Bn)(1 - a, 0, 1), l = o ? s : c;
    return {
        tileOpacity: l,
        parentTileOpacity: o ? c : s,
        fadeMix: {
            opacity: 1,
            mix: 1 - l
        }
    };
}
function $4324d99ae8520741$var$Rf(e1, t) {
    let n = ($4324d99ae8520741$export$461939dd4422153() - e1.timeAdded) / t, r = (0, $1G0Uw.Bn)(n, 0, 1);
    return {
        tileOpacity: r,
        fadeMix: {
            opacity: r,
            mix: 0
        }
    };
}
function $4324d99ae8520741$var$zf(e1, t, n, r, i) {
    let a = n.paint.get(`background-color`), o = n.paint.get(`background-opacity`);
    if (o === 0) return;
    let { isRenderingToTexture: s } = i, c = e1.context, l = c.gl, u = e1.style.projection, d = e1.transform, f = d.tileSize, p = n.paint.get(`background-pattern`);
    if (e1.isPatternMissing(p)) return;
    let m = !p && a.a === 1 && o === 1 && e1.opaquePassEnabledForLayer() ? `opaque` : `translucent`;
    if (i.currentPass !== m) return;
    let h = $4324d99ae8520741$var$Q.disabled, g = e1.getDepthModeForSublayer(0, m === `opaque` ? $4324d99ae8520741$var$Z.ReadWrite : $4324d99ae8520741$var$Z.ReadOnly), _ = e1.colorModeForRenderPass(), v = e1.useProgram(p ? `backgroundPattern` : `background`), y = r || $4324d99ae8520741$var$ko(d, {
        tileSize: f,
        terrain: e1.style.map.terrain
    });
    p && (c.activeTexture.set(l.TEXTURE0), e1.patternAtlas.bind(e1.context));
    let b = n.getCrossfadeParameters();
    for (let t of y){
        let r = d.getProjectionData({
            overscaledTileID: t,
            applyGlobeMatrix: !s,
            applyTerrainMatrix: !0
        }), i = p ? $4324d99ae8520741$var$Vu(o, e1, p, {
            tileID: t,
            tileSize: f
        }, b) : $4324d99ae8520741$var$Bu(o, a), m = e1.getTerrainDataForTile(t, s), y = u.getMeshFromTileID(c, t.canonical, !1, !0, `raster`);
        v.draw(c, l.TRIANGLES, g, h, _, $4324d99ae8520741$var$$.backCCW, i, m, r, n.id, y.vertexBuffer, y.indexBuffer, y.segments);
    }
}
const $4324d99ae8520741$var$Bf = new (0, $1G0Uw.fn)(1, 0, 0, 1), $4324d99ae8520741$var$Vf = new (0, $1G0Uw.fn)(0, 1, 0, 1), $4324d99ae8520741$var$Hf = new (0, $1G0Uw.fn)(0, 0, 1, 1), $4324d99ae8520741$var$Uf = new (0, $1G0Uw.fn)(1, 0, 1, 1), $4324d99ae8520741$var$Wf = new (0, $1G0Uw.fn)(0, 1, 1, 1);
function $4324d99ae8520741$var$Gf(e1) {
    let t = e1.transform.padding;
    $4324d99ae8520741$var$qf(e1, e1.transform.height - (t.top || 0), 3, $4324d99ae8520741$var$Bf), $4324d99ae8520741$var$qf(e1, t.bottom || 0, 3, $4324d99ae8520741$var$Vf), $4324d99ae8520741$var$Jf(e1, t.left || 0, 3, $4324d99ae8520741$var$Hf), $4324d99ae8520741$var$Jf(e1, e1.transform.width - (t.right || 0), 3, $4324d99ae8520741$var$Uf);
    let n = e1.transform.centerPoint;
    $4324d99ae8520741$var$Kf(e1, n.x, e1.transform.height - n.y, $4324d99ae8520741$var$Wf);
}
function $4324d99ae8520741$var$Kf(e1, t, n, r) {
    $4324d99ae8520741$var$Yf(e1, t - 1, n - 10, 2, 20, r), $4324d99ae8520741$var$Yf(e1, t - 10, n - 1, 20, 2, r);
}
function $4324d99ae8520741$var$qf(e1, t, n, r) {
    $4324d99ae8520741$var$Yf(e1, 0, t + n / 2, e1.transform.width, n, r);
}
function $4324d99ae8520741$var$Jf(e1, t, n, r) {
    $4324d99ae8520741$var$Yf(e1, t - n / 2, 0, n, e1.transform.height, r);
}
function $4324d99ae8520741$var$Yf(e1, t, n, r, i, a) {
    let o = e1.context, s = o.gl;
    s.enable(s.SCISSOR_TEST), s.scissor(t * e1.pixelRatio, n * e1.pixelRatio, r * e1.pixelRatio, i * e1.pixelRatio), o.clear({
        color: a
    }), s.disable(s.SCISSOR_TEST);
}
function $4324d99ae8520741$var$Xf(e1, t, n) {
    for (let r of n)$4324d99ae8520741$var$Zf(e1, t, r);
}
function $4324d99ae8520741$var$Zf(e1, t, n) {
    let r = e1.context, i = r.gl, a = e1.useProgram(`debug`), o = $4324d99ae8520741$var$Z.disabled, s = $4324d99ae8520741$var$Q.disabled, c = e1.colorModeForRenderPass(), l = `$debug`, u = e1.style.map.terrain?.getTerrainData(n);
    r.activeTexture.set(i.TEXTURE0);
    let d = t.getTileByID(n.key).latestRawTileData?.byteLength || 0, f = Math.floor(d / 1024), p = t.getTile(n).tileSize, m = 512 / Math.min(p, 512) * (n.overscaledZ / e1.transform.zoom) * .5, h = n.canonical.toString();
    n.overscaledZ !== n.canonical.z && (h += ` => ${n.overscaledZ}`), $4324d99ae8520741$var$Qf(e1, `${h} ${f}kB`);
    let g = e1.transform.getProjectionData({
        overscaledTileID: n,
        applyGlobeMatrix: !0,
        applyTerrainMatrix: !0
    });
    a.draw(r, i.TRIANGLES, o, s, $4324d99ae8520741$var$Ld.alphaBlended, $4324d99ae8520741$var$$.disabled, $4324d99ae8520741$var$ou((0, $1G0Uw.fn).transparent, m), null, g, l, e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments), a.draw(r, i.LINE_STRIP, o, s, c, $4324d99ae8520741$var$$.disabled, $4324d99ae8520741$var$ou((0, $1G0Uw.fn).red), u, g, l, e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
}
function $4324d99ae8520741$var$Qf(e1, t) {
    e1.initDebugOverlayCanvas();
    let n = e1.debugOverlayCanvas, r = e1.context.gl, i = e1.debugOverlayCanvas.getContext(`2d`);
    i.clearRect(0, 0, n.width, n.height), i.shadowColor = `white`, i.shadowBlur = 2, i.lineWidth = 1.5, i.strokeStyle = `white`, i.textBaseline = `top`, i.font = `bold 36px Open Sans, sans-serif`, i.fillText(t, 5, 5), i.strokeText(t, 5, 5), e1.debugOverlayTexture.update(n), e1.debugOverlayTexture.bind(r.LINEAR, r.CLAMP_TO_EDGE);
}
function $4324d99ae8520741$var$$f(e1, t) {
    let n = null, r = Object.values(e1._layers).flatMap((n)=>n.source && !n.isHidden(t) ? [
            e1.tileManagers[n.source]
        ] : []), i = r.filter((e1)=>e1.getSource().type === `vector`), a = r.filter((e1)=>e1.getSource().type !== `vector`), o = (e1)=>{
        (!n || n.getSource().maxzoom < e1.getSource().maxzoom) && (n = e1);
    };
    for (let e1 of i)o(e1);
    if (!n) for (let e1 of a)o(e1);
    return n;
}
function $4324d99ae8520741$var$ep(e1, t, n, r) {
    let { isRenderingGlobe: i } = r, a = e1.context, o = n.implementation, s = e1.style.projection, c = e1.transform, l = c.getProjectionDataForCustomLayer(i), u = {
        farZ: c.farZ,
        nearZ: c.nearZ,
        fov: c.fov * Math.PI / 180,
        modelViewProjectionMatrix: c.modelViewProjectionMatrix,
        projectionMatrix: c.projectionMatrix,
        shaderData: {
            variantName: s.shaderVariantName,
            vertexShaderPrelude: `const float PI = 3.141592653589793;\nuniform mat4 u_projection_matrix;\n${s.shaderPreludeCode.vertexSource}`,
            define: s.shaderDefine
        },
        defaultProjectionData: l,
        getProjectionData: (e1)=>c.getProjectionData({
                overscaledTileID: new (0, $1G0Uw.d)(e1.tileID.canonical.z, e1.tileID.wrap ?? 0, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y),
                aligned: e1.aligned,
                applyGlobeMatrix: e1.applyGlobeMatrix,
                applyTerrainMatrix: e1.applyTerrainMatrix
            })
    }, d = o.renderingMode ? o.renderingMode : `2d`;
    if (r.currentPass === `offscreen`) {
        let t = o.prerender;
        t && (e1.setCustomLayerDefaults(), a.setColorMode(e1.colorModeForRenderPass()), t.call(o, a.gl, u), a.setDirty(), e1.setBaseState());
    } else if (r.currentPass === `translucent`) {
        e1.setCustomLayerDefaults(), a.setColorMode(e1.colorModeForRenderPass()), a.setStencilMode($4324d99ae8520741$var$Q.disabled);
        let t = d === `3d` ? e1.getDepthModeFor3D() : e1.getDepthModeForSublayer(0, $4324d99ae8520741$var$Z.ReadOnly);
        a.setDepthMode(t), o.render(a.gl, u), a.setDirty(), e1.setBaseState(), a.bindFramebuffer.set(null);
    }
}
function $4324d99ae8520741$var$tp(e1, t) {
    let n = e1.context, r = n.gl, i = e1.transform, a = $4324d99ae8520741$var$Ld.unblended, o = new $4324d99ae8520741$var$Z(r.LEQUAL, $4324d99ae8520741$var$Z.ReadWrite, [
        0,
        1
    ]), s = t.tileManager.getRenderableTiles(), c = e1.useProgram(`terrainDepth`);
    n.bindFramebuffer.set(t.getFramebuffer().framebuffer), n.viewport.set([
        0,
        0,
        e1.width / devicePixelRatio,
        e1.height / devicePixelRatio
    ]), n.clear({
        color: (0, $1G0Uw.fn).white,
        depth: 1
    });
    for (let e1 of s){
        let s = t.getTerrainMesh(e1.tileID), l = t.getTerrainData(e1.tileID), u = i.getProjectionData({
            overscaledTileID: e1.tileID,
            applyTerrainMatrix: !1,
            applyGlobeMatrix: !0
        }), d = $4324d99ae8520741$var$El(t.getSkirtLength(i.zoom));
        c.draw(n, r.TRIANGLES, o, $4324d99ae8520741$var$Q.disabled, a, $4324d99ae8520741$var$$.backCCW, d, l, u, `terrain`, s.vertexBuffer, s.indexBuffer, s.segments);
    }
    n.bindFramebuffer.set(null), n.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
}
function $4324d99ae8520741$var$np(e1, t, n, r) {
    let { isRenderingGlobe: i } = r, a = e1.context, o = a.gl, s = e1.transform, c = e1.colorModeForRenderPass(), l = e1.getDepthModeFor3D(), u = e1.useProgram(`terrain`);
    a.bindFramebuffer.set(null), a.viewport.set([
        0,
        0,
        e1.width,
        e1.height
    ]);
    for (let r of n){
        let n = t.getTerrainMesh(r.tileID), d = e1.renderToTexture.getTexture(r), f = t.getTerrainData(r.tileID);
        a.activeTexture.set(o.TEXTURE0), d.bind(o.LINEAR, o.CLAMP_TO_EDGE, o.LINEAR_MIPMAP_LINEAR);
        let p = t.getSkirtLength(s.zoom), m = s.calculateFogMatrix(r.tileID.toUnwrapped()), h = $4324d99ae8520741$var$Tl(p, m, e1.style.sky, s.pitch, i), g = s.getProjectionData({
            overscaledTileID: r.tileID,
            applyTerrainMatrix: !1,
            applyGlobeMatrix: !0
        });
        u.draw(a, o.TRIANGLES, l, $4324d99ae8520741$var$Q.disabled, c, $4324d99ae8520741$var$$.backCCW, h, f, g, `terrain`, n.vertexBuffer, n.indexBuffer, n.segments);
    }
}
function $4324d99ae8520741$var$rp(e1, t) {
    if (!t.mesh) {
        let n = new (0, $1G0Uw.Gt);
        n.emplaceBack(-1, -1), n.emplaceBack(1, -1), n.emplaceBack(1, 1), n.emplaceBack(-1, 1);
        let r = new (0, $1G0Uw.Jt);
        r.emplaceBack(0, 1, 2), r.emplaceBack(0, 2, 3), t.mesh = new $4324d99ae8520741$var$Ua(e1.createVertexBuffer(n, $4324d99ae8520741$var$Wa.members), e1.createIndexBuffer(r), (0, $1G0Uw.Bt).simpleSegment(0, 0, n.length, r.length));
    }
    return t.mesh;
}
function $4324d99ae8520741$var$ip(e1, t) {
    let n = e1.context, r = n.gl, i = $4324d99ae8520741$var$Gu(t, e1.transform, e1.pixelRatio), a = new $4324d99ae8520741$var$Z(r.LEQUAL, $4324d99ae8520741$var$Z.ReadWrite, [
        0,
        1
    ]), o = $4324d99ae8520741$var$Q.disabled, s = e1.colorModeForRenderPass(), c = e1.useProgram(`sky`), l = $4324d99ae8520741$var$rp(n, t);
    c.draw(n, r.TRIANGLES, a, o, s, $4324d99ae8520741$var$$.disabled, i, null, void 0, `sky`, l.vertexBuffer, l.indexBuffer, l.segments);
}
function $4324d99ae8520741$var$ap(e1, t) {
    let n = e1.getCartesianPosition();
    (0, $1G0Uw.ri)(n, n);
    let r = (0, $1G0Uw.Si)(new Float64Array(16));
    return e1.properties.get(`anchor`) === `map` && ((0, $1G0Uw.ki)(r, r, t.rollInRadians), (0, $1G0Uw.Di)(r, r, -t.pitchInRadians), (0, $1G0Uw.ki)(r, r, t.bearingInRadians), (0, $1G0Uw.Di)(r, r, t.center.lat * Math.PI / 180), (0, $1G0Uw.Oi)(r, r, -t.center.lng * Math.PI / 180)), (0, $1G0Uw.pi)(n, n, r), n;
}
function $4324d99ae8520741$var$op(e1, t, n) {
    let r = e1.context, i = r.gl, a = e1.useProgram(`atmosphere`), o = new $4324d99ae8520741$var$Z(i.LEQUAL, $4324d99ae8520741$var$Z.ReadOnly, [
        0,
        1
    ]), s = e1.transform, c = $4324d99ae8520741$var$ap(n, e1.transform), l = s.getProjectionData({
        overscaledTileID: null,
        applyGlobeMatrix: !0,
        applyTerrainMatrix: !0
    }), u = t.properties.get(`atmosphere-blend`) * l.projectionTransition;
    if (u === 0) return;
    let d = $4324d99ae8520741$var$Bc(s.worldSize, s.center.lat), f = $4324d99ae8520741$var$Vc(s), p = $4324d99ae8520741$var$Uu(c, u, f, d, s.inverseProjectionMatrix), m = $4324d99ae8520741$var$rp(r, t);
    a.draw(r, i.TRIANGLES, o, $4324d99ae8520741$var$Q.disabled, $4324d99ae8520741$var$Ld.alphaBlended, $4324d99ae8520741$var$$.disabled, p, null, null, `atmosphere`, m.vertexBuffer, m.indexBuffer, m.segments);
}
const $4324d99ae8520741$var$sp = {
    symbol: $4324d99ae8520741$var$Kd,
    circle: $4324d99ae8520741$var$ef,
    heatmap: $4324d99ae8520741$var$tf,
    line: $4324d99ae8520741$var$vf,
    fill: $4324d99ae8520741$var$xf,
    fillExtrusion: $4324d99ae8520741$var$Tf,
    hillshade: $4324d99ae8520741$var$Df,
    colorRelief: $4324d99ae8520741$var$Af,
    raster: $4324d99ae8520741$var$Pf,
    background: $4324d99ae8520741$var$zf,
    sky: $4324d99ae8520741$var$ip,
    atmosphere: $4324d99ae8520741$var$op,
    custom: $4324d99ae8520741$var$ep,
    debug: $4324d99ae8520741$var$Xf,
    debugPadding: $4324d99ae8520741$var$Gf,
    terrainDepth: $4324d99ae8520741$var$tp
};
function $4324d99ae8520741$var$cp(e1, t, n) {
    let r = t?.transitionState ?? 0;
    return {
        currentPass: `offscreen`,
        currentLayer: 0,
        opaquePassCutoff: 1 / 0,
        depthRangeFor3D: [
            0,
            1
        ],
        isRenderingToTexture: !1,
        transform: e1,
        terrain: n,
        projectionTransition: r,
        isRenderingGlobe: r > 0
    };
}
var $4324d99ae8520741$var$lp = class e1 {
    constructor(e1, t){
        this.drawFunctions = $4324d99ae8520741$var$sp, this.context = new $4324d99ae8520741$var$Rd(e1), this.transform = t, this.layerOpacityFbo = null, this._tileTextures = {}, this._rttObjectRecyclePool = [], this._rttSharedFbo = null, this.terrainFacilitator = {
            depthDirty: !0,
            matrix: (0, $1G0Uw.Si)(new Float64Array(16)),
            renderTime: 0
        }, this.setup(), this.numSublayers = $4324d99ae8520741$var$Bo.maxOverzooming + $4324d99ae8520741$var$Bo.maxUnderzooming + 1, this.depthEpsilon = 1 / 2 ** 16, this.crossTileSymbolIndex = new $4324d99ae8520741$var$Js;
    }
    resize(e1, t, n) {
        if (this.width = Math.floor(e1 * n), this.height = Math.floor(t * n), this.pixelRatio = n, this.context.viewport.set([
            0,
            0,
            this.width,
            this.height
        ]), this.style) for (let e1 of this.style._order)this.style._layers[e1].resize();
    }
    setup() {
        let e1 = this.context, t = new (0, $1G0Uw.Gt);
        t.emplaceBack(0, 0), t.emplaceBack((0, $1G0Uw.Lr), 0), t.emplaceBack(0, (0, $1G0Uw.Lr)), t.emplaceBack((0, $1G0Uw.Lr), (0, $1G0Uw.Lr)), this.tileExtentBuffer = e1.createVertexBuffer(t, $4324d99ae8520741$var$Wa.members), this.tileExtentSegments = (0, $1G0Uw.Bt).simpleSegment(0, 0, 4, 2);
        let n = new (0, $1G0Uw.Gt);
        n.emplaceBack(0, 0), n.emplaceBack((0, $1G0Uw.Lr), 0), n.emplaceBack(0, (0, $1G0Uw.Lr)), n.emplaceBack((0, $1G0Uw.Lr), (0, $1G0Uw.Lr)), this.debugBuffer = e1.createVertexBuffer(n, $4324d99ae8520741$var$Wa.members), this.debugSegments = (0, $1G0Uw.Bt).simpleSegment(0, 0, 4, 5);
        let r = new (0, $1G0Uw.qt);
        r.emplaceBack(0, 0, 0, 0), r.emplaceBack((0, $1G0Uw.Lr), 0, (0, $1G0Uw.Lr), 0), r.emplaceBack(0, (0, $1G0Uw.Lr), 0, (0, $1G0Uw.Lr)), r.emplaceBack((0, $1G0Uw.Lr), (0, $1G0Uw.Lr), (0, $1G0Uw.Lr), (0, $1G0Uw.Lr)), this.rasterBoundsBuffer = e1.createVertexBuffer(r, $4324d99ae8520741$var$bl.members), this.rasterBoundsSegments = (0, $1G0Uw.Bt).simpleSegment(0, 0, 4, 2);
        let i = new (0, $1G0Uw.Gt);
        i.emplaceBack(0, 0), i.emplaceBack((0, $1G0Uw.Lr), 0), i.emplaceBack(0, (0, $1G0Uw.Lr)), i.emplaceBack((0, $1G0Uw.Lr), (0, $1G0Uw.Lr)), this.rasterBoundsBufferPosOnly = e1.createVertexBuffer(i, $4324d99ae8520741$var$Wa.members), this.rasterBoundsSegmentsPosOnly = (0, $1G0Uw.Bt).simpleSegment(0, 0, 4, 5);
        let a = new (0, $1G0Uw.Gt);
        a.emplaceBack(0, 0), a.emplaceBack(1, 0), a.emplaceBack(0, 1), a.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(a, $4324d99ae8520741$var$Wa.members), this.viewportSegments = (0, $1G0Uw.Bt).simpleSegment(0, 0, 4, 2);
        let o = new (0, $1G0Uw.Ut);
        o.emplaceBack(0), o.emplaceBack(1), o.emplaceBack(3), o.emplaceBack(2), o.emplaceBack(0), this.tileBorderIndexBuffer = e1.createIndexBuffer(o);
        let s = new (0, $1G0Uw.Jt);
        s.emplaceBack(1, 0, 2), s.emplaceBack(1, 2, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(s);
        let c = this.context.gl;
        this.stencilClearMode = new $4324d99ae8520741$var$Q({
            func: c.ALWAYS,
            mask: 0
        }, 0, 255, c.ZERO, c.ZERO, c.ZERO), this.tileExtentMesh = new $4324d99ae8520741$var$Ua(this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
    }
    clearStencil() {
        let e1 = this.context, t = e1.gl;
        this.nextStencilID = 1, this.currentStencilSource = void 0;
        let n = (0, $1G0Uw.vi)();
        (0, $1G0Uw.Ti)(n, 0, this.width, this.height, 0, 0, 1), (0, $1G0Uw.Ai)(n, n, [
            t.drawingBufferWidth,
            t.drawingBufferHeight,
            0
        ]);
        let r = {
            mainMatrix: n,
            tileMercatorCoords: [
                0,
                0,
                1,
                1
            ],
            clippingPlane: [
                0,
                0,
                0,
                0
            ],
            projectionTransition: 0,
            fallbackMatrix: n,
            clipAntimeridian: !1
        };
        this.useProgram(`clippingMask`, null, !0).draw(e1, t.TRIANGLES, $4324d99ae8520741$var$Z.disabled, this.stencilClearMode, $4324d99ae8520741$var$Ld.disabled, $4324d99ae8520741$var$$.disabled, null, null, r, `$clipping`, this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
    }
    renderTileClippingMasks(e1, t, n) {
        if (this.currentStencilSource === e1.source || !e1.isTileClipped() || !t?.length) return;
        this.currentStencilSource = e1.source, this.nextStencilID + t.length > 256 && this.clearStencil();
        let r = this.context;
        r.setColorMode($4324d99ae8520741$var$Ld.disabled), r.setDepthMode($4324d99ae8520741$var$Z.disabled);
        let i = {};
        for (let e1 of t)i[e1.key] = this.nextStencilID++;
        this.style.projection.useSubdivision && this._renderTileMasks(i, t, n, !0), this._renderTileMasks(i, t, n, !1), this._tileClippingMaskIDs = i;
    }
    _renderTileMasks(e1, t, n, r) {
        let i = this.context, a = i.gl, o = this.style.projection, s = this.transform, c = this.useProgram(`clippingMask`);
        for (let l of t){
            let t = e1[l.key], u = this.getTerrainDataForTile(l, n), d = o.getMeshFromTileID(this.context, l.canonical, r, !0, `stencil`), f = s.getProjectionData({
                overscaledTileID: l,
                applyGlobeMatrix: !n,
                applyTerrainMatrix: !0
            });
            c.draw(i, a.TRIANGLES, $4324d99ae8520741$var$Z.disabled, new $4324d99ae8520741$var$Q({
                func: a.ALWAYS,
                mask: 0
            }, t, 255, a.KEEP, a.KEEP, a.REPLACE), $4324d99ae8520741$var$Ld.disabled, n ? $4324d99ae8520741$var$$.disabled : $4324d99ae8520741$var$$.backCCW, null, u, f, `$clipping`, d.vertexBuffer, d.indexBuffer, d.segments);
        }
    }
    getTerrainDataForTile(e1, t) {
        return t && this.style.projection?.name === `mercator` ? null : this.style.map.terrain?.getTerrainData(e1) || null;
    }
    _renderTilesDepthBuffer() {
        let e1 = this.context, t = e1.gl, n = this.style.projection, r = this.transform, i = this.useProgram(`depth`), a = this.getDepthModeFor3D(), o = $4324d99ae8520741$var$ko(r, {
            tileSize: r.tileSize
        });
        for (let s of o){
            let o = this.style.map.terrain?.getTerrainData(s), c = n.getMeshFromTileID(this.context, s.canonical, !0, !0, `raster`), l = r.getProjectionData({
                overscaledTileID: s,
                applyGlobeMatrix: !0,
                applyTerrainMatrix: !0
            });
            i.draw(e1, t.TRIANGLES, a, $4324d99ae8520741$var$Q.disabled, $4324d99ae8520741$var$Ld.disabled, $4324d99ae8520741$var$$.backCCW, null, o, l, `$clipping`, c.vertexBuffer, c.indexBuffer, c.segments);
        }
    }
    stencilModeFor3D() {
        this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
        let e1 = this.nextStencilID++, t = this.context.gl;
        return new $4324d99ae8520741$var$Q({
            func: t.NOTEQUAL,
            mask: 255
        }, e1, 255, t.KEEP, t.KEEP, t.REPLACE);
    }
    stencilModeForClipping(e1) {
        let t = this.context.gl;
        return new $4324d99ae8520741$var$Q({
            func: t.EQUAL,
            mask: 255
        }, this._tileClippingMaskIDs[e1.key], 0, t.KEEP, t.KEEP, t.REPLACE);
    }
    getStencilConfigForOverlapAndUpdateStencilID(e1) {
        let t = this.context.gl, n = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), r = n[n.length - 1].overscaledZ, i = n[0].overscaledZ - r + 1;
        if (i > 1) {
            this.currentStencilSource = void 0, this.nextStencilID + i > 256 && this.clearStencil();
            let e1 = {};
            for(let n = 0; n < i; n++)e1[n + r] = new $4324d99ae8520741$var$Q({
                func: t.GEQUAL,
                mask: 255
            }, n + this.nextStencilID, 255, t.KEEP, t.KEEP, t.REPLACE);
            return this.nextStencilID += i, [
                e1,
                n
            ];
        }
        return [
            {
                [r]: $4324d99ae8520741$var$Q.disabled
            },
            n
        ];
    }
    stencilConfigForOverlapTwoPass(e1) {
        let t = this.context.gl, n = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), r = n[n.length - 1].overscaledZ, i = n[0].overscaledZ - r + 1;
        if (this.clearStencil(), i > 1) {
            let e1 = {}, a = {};
            for(let n = 0; n < i; n++)e1[n + r] = new $4324d99ae8520741$var$Q({
                func: t.GREATER,
                mask: 255
            }, i + 1 + n, 255, t.KEEP, t.KEEP, t.REPLACE), a[n + r] = new $4324d99ae8520741$var$Q({
                func: t.GREATER,
                mask: 255
            }, 1 + n, 255, t.KEEP, t.KEEP, t.REPLACE);
            return this.nextStencilID = i * 2 + 1, [
                e1,
                a,
                n
            ];
        }
        return this.nextStencilID = 3, [
            {
                [r]: new $4324d99ae8520741$var$Q({
                    func: t.GREATER,
                    mask: 255
                }, 2, 255, t.KEEP, t.KEEP, t.REPLACE)
            },
            {
                [r]: new $4324d99ae8520741$var$Q({
                    func: t.GREATER,
                    mask: 255
                }, 1, 255, t.KEEP, t.KEEP, t.REPLACE)
            },
            n
        ];
    }
    colorModeForRenderPass() {
        let e1 = this.context.gl;
        if (this._showOverdrawInspector) {
            let t = 1 / 8;
            return new $4324d99ae8520741$var$Ld([
                e1.CONSTANT_COLOR,
                e1.ONE
            ], new (0, $1G0Uw.fn)(t, t, t, 0), [
                !0,
                !0,
                !0,
                !0
            ]);
        }
        return this.renderOptions.currentPass === `opaque` ? $4324d99ae8520741$var$Ld.unblended : $4324d99ae8520741$var$Ld.alphaBlended;
    }
    getDepthModeForSublayer(e1, t, n) {
        if (!this.opaquePassEnabledForLayer()) return $4324d99ae8520741$var$Z.disabled;
        let r = 1 - ((1 + this.renderOptions.currentLayer) * this.numSublayers + e1) * this.depthEpsilon;
        return new $4324d99ae8520741$var$Z(n || this.context.gl.LEQUAL, t, [
            r,
            r
        ]);
    }
    getDepthModeFor3D() {
        return new $4324d99ae8520741$var$Z(this.context.gl.LEQUAL, $4324d99ae8520741$var$Z.ReadWrite, this.renderOptions.depthRangeFor3D);
    }
    opaquePassEnabledForLayer() {
        return this.renderOptions.currentLayer < this.renderOptions.opaquePassCutoff;
    }
    render(e1, t) {
        this.style = e1, this.options = t;
        let n = this.renderOptions = $4324d99ae8520741$var$cp(this.transform, e1.projection, e1.map.terrain ?? null);
        this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.patternAtlas = e1.patternAtlas, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange($4324d99ae8520741$export$461939dd4422153()), $4324d99ae8520741$var$Id(this.context.frameUniformBuffer, this), this.imageManager.beginFrame();
        let r = this.style._order, i = this.style.tileManagers, a = {}, o = {}, s = {};
        for(let e1 in i){
            let t = i[e1];
            t.used && t.prepare(this.context), a[e1] = t.getVisibleCoordinates(!1), o[e1] = a[e1].slice().reverse(), s[e1] = t.getVisibleCoordinates(!0).reverse();
        }
        n.opaquePassCutoff = 1 / 0;
        for(let e1 = 0; e1 < r.length; e1++){
            let t = r[e1];
            if (this.style._layers[t].is3D()) {
                n.opaquePassCutoff = e1;
                break;
            }
        }
        this.maybeDrawDepth(), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), n.opaquePassCutoff = 0), n.currentPass = `offscreen`;
        for (let e1 of r){
            let t = this.style._layers[e1];
            if (!t.hasOffscreenPass() || t.isHidden(this.transform.zoom)) continue;
            let r = o[t.source];
            (t.type === `custom` || r.length) && this.renderLayer(this, i[t.source], t, r, n);
        }
        if (this.context.viewport.set([
            0,
            0,
            this.width,
            this.height
        ]), this.context.bindFramebuffer.set(null), this.context.clear({
            color: t.showOverdrawInspector ? (0, $1G0Uw.fn).black : (0, $1G0Uw.fn).transparent,
            depth: 1
        }), this.clearStencil(), this.style.sky && this.drawFunctions.sky(this, this.style.sky), this._showOverdrawInspector = t.showOverdrawInspector, n.depthRangeFor3D = [
            0,
            1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
        ], !this.renderToTexture) for(n.currentPass = `opaque`, n.currentLayer = r.length - 1; n.currentLayer >= 0; n.currentLayer--){
            let e1 = this.style._layers[r[n.currentLayer]];
            if (e1.isHidden(this.transform.zoom)) continue;
            let t = i[e1.source], o = a[e1.source];
            this.renderTileClippingMasks(e1, o, !1), this.renderLayer(this, t, e1, o, n);
        }
        n.currentPass = `translucent`;
        let c = !1;
        for(n.currentLayer = 0; n.currentLayer < r.length; n.currentLayer++){
            let e1 = this.style._layers[r[n.currentLayer]];
            if (e1.isHidden(this.transform.zoom)) continue;
            let t = i[e1.source];
            if (this.renderToTexture?.renderLayer(e1, n)) continue;
            !this.opaquePassEnabledForLayer() && !c && (c = !0, n.isRenderingGlobe && !this.style.map.terrain && this._renderTilesDepthBuffer());
            let l = (e1.type === `symbol` ? s : o)[e1.source];
            this.renderTileClippingMasks(e1, a[e1.source], !!this.renderToTexture), this.renderLayer(this, t, e1, l, n);
        }
        if (n.isRenderingGlobe && this.drawFunctions.atmosphere(this, this.style.sky, this.style.light), this.options.showTileBoundaries) {
            let e1 = $4324d99ae8520741$var$$f(this.style, this.transform.zoom);
            e1 && this.drawFunctions.debug(this, e1, e1.getVisibleCoordinates());
        }
        this.options.showPadding && this.drawFunctions.debugPadding(this), this.context.setDefault();
    }
    markTerrainDepthDirty() {
        this.terrainFacilitator.depthDirty = !0;
    }
    maybeDrawDepth() {
        if (!this.style?.projection || !this.style.map?.terrain) return;
        let e1 = this.terrainFacilitator.matrix, t = this.transform.modelViewProjectionMatrix, n = this.terrainFacilitator.depthDirty;
        n ||= !(0, $1G0Uw.yi)(e1, t), n ||= this.style.map.terrain.tileManager.anyTilesAfterTime(this.terrainFacilitator.renderTime), n && ((0, $1G0Uw._i)(e1, t), this.terrainFacilitator.renderTime = $4324d99ae8520741$export$461939dd4422153(), this.terrainFacilitator.depthDirty = !1, this.drawFunctions.terrainDepth(this, this.style.map.terrain));
    }
    renderLayer(e1, t, n, r, i) {
        if (n.isHidden(this.transform.zoom) || n.type !== `background` && n.type !== `custom` && !(r || []).length) return;
        this.id = n.id;
        let a = this.drawFunctions;
        (0, $1G0Uw.x)(n) ? a.symbol(e1, t, n, r, this.style.placement.variableOffsets, i) : (0, $1G0Uw.Ot)(n) ? a.circle(e1, t, n, r, i) : (0, $1G0Uw.wt)(n) ? a.heatmap(e1, t, n, r, i) : (0, $1G0Uw.W)(n) ? a.line(e1, t, n, r, i) : (0, $1G0Uw.mt)(n) ? a.fill(e1, t, n, r, i) : (0, $1G0Uw.K)(n) ? a.fillExtrusion(e1, t, n, r, i) : (0, $1G0Uw.St)(n) ? a.hillshade(e1, t, n, r, i) : (0, $1G0Uw.yt)(n) ? a.colorRelief(e1, t, n, r, i) : (0, $1G0Uw.Xt)(n) ? a.raster(e1, t, n, r, i) : (0, $1G0Uw.b)(n) ? a.background(e1, t, n, r, i) : (0, $1G0Uw.v)(n) && a.custom(e1, t, n, i);
    }
    static{
        this.MAX_TEXTURE_POOL_SIZE_PER_BUCKET = 50;
    }
    saveTileTexture(t) {
        let n = this._tileTextures[t.size[0]];
        n ? n.length < e1.MAX_TEXTURE_POOL_SIZE_PER_BUCKET ? n.push(t) : t.destroy() : this._tileTextures[t.size[0]] = [
            t
        ];
    }
    getTileTexture(e1) {
        let t = this._tileTextures[e1];
        return t && t.length > 0 ? t.pop() : null;
    }
    acquireRTT(e1) {
        let t = this.context.gl, n = this._rttObjectRecyclePool.pop();
        if (n) return n.size !== e1 && (n.texture.update({
            width: e1,
            height: e1,
            data: null
        }, {
            premultiply: !1,
            useMipmap: !0
        }), n.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE, t.LINEAR_MIPMAP_LINEAR), this.context.extTextureFilterAnisotropic && t.texParameterf(t.TEXTURE_2D, this.context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this.context.extTextureFilterAnisotropicMax), n.size = e1), n;
        let r = new (0, $1G0Uw.xt)(this.context, {
            width: e1,
            height: e1,
            data: null
        }, t.RGBA, {
            premultiply: !1,
            useMipmap: !0
        });
        return r.bind(t.LINEAR, t.CLAMP_TO_EDGE, t.LINEAR_MIPMAP_LINEAR), this.context.extTextureFilterAnisotropic && t.texParameterf(t.TEXTURE_2D, this.context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this.context.extTextureFilterAnisotropicMax), {
            texture: r,
            size: e1
        };
    }
    bindRTT(e1) {
        let t = this.context.gl, n = e1.size;
        if (!this._rttSharedFbo) {
            let e1 = this.context.createFramebuffer(n, n, !0, !0), r = this.context.createRenderbuffer(t.DEPTH_STENCIL, n, n);
            e1.depthAttachment.set(r), this._rttSharedFbo = {
                fbo: e1,
                depthRenderbuffer: r,
                size: n
            };
        }
        this._rttSharedFbo.size !== n && (this.context.bindRenderbuffer.set(this._rttSharedFbo.depthRenderbuffer), t.renderbufferStorage(t.RENDERBUFFER, t.DEPTH_STENCIL, n, n), this.context.bindRenderbuffer.set(null), this._rttSharedFbo.fbo.width = n, this._rttSharedFbo.fbo.height = n, this._rttSharedFbo.size = n), this._rttSharedFbo.fbo.colorAttachment.set(e1.texture.texture), this.context.bindFramebuffer.set(this._rttSharedFbo.fbo.framebuffer);
    }
    releaseRTT(e1) {
        this._rttObjectRecyclePool.push(e1);
    }
    isPatternMissing(e1) {
        if (!e1) return !1;
        if (!e1.from || !e1.to) return !0;
        let t = this.patternAtlas.getPattern(e1.from.toString()), n = this.patternAtlas.getPattern(e1.to.toString());
        return !t || !n;
    }
    useProgram(e1, t, n = !1, r = []) {
        this.cache ||= {};
        let i = !!this.style.map.terrain, a = this.style.projection, o = n ? $4324d99ae8520741$var$ic.projectionMercator : a.shaderPreludeCode, s = n ? $4324d99ae8520741$var$ac : a.shaderDefine, c = `/${n ? $4324d99ae8520741$var$oc : a.shaderVariantName}`, l = t ? t.cacheKey : ``, u = this._showOverdrawInspector ? `/overdraw` : ``, d = i ? `/terrain` : ``, f = r ? `/${r.join(`/`)}` : ``, p = e1 + l + c + u + d + f;
        return this.cache[p] ||= new $4324d99ae8520741$var$Hl(this.context, $4324d99ae8520741$var$ic[e1], t, $4324d99ae8520741$var$qu[e1], this._showOverdrawInspector, i, o, s, r), this.cache[p];
    }
    setCustomLayerDefaults() {
        this.context.setCustomLayerDefaults();
    }
    setBaseState() {
        let e1 = this.context.gl;
        this.context.cullFace.set(!1), this.context.viewport.set([
            0,
            0,
            this.width,
            this.height
        ]), this.context.blendEquation.set(e1.FUNC_ADD);
    }
    initDebugOverlayCanvas() {
        if (this.debugOverlayCanvas == null) {
            this.debugOverlayCanvas = document.createElement(`canvas`), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512;
            let e1 = this.context.gl;
            this.debugOverlayTexture = new (0, $1G0Uw.xt)(this.context, this.debugOverlayCanvas, e1.RGBA);
        }
    }
    destroy() {
        if (this._tileTextures) {
            for(let e1 in this._tileTextures){
                let t = this._tileTextures[e1];
                if (t) for (let e1 of t)e1.destroy();
            }
            this._tileTextures = {};
        }
        for (let e1 of this._rttObjectRecyclePool)e1.texture.destroy();
        if (this._rttObjectRecyclePool = [], this._rttSharedFbo) {
            this._rttSharedFbo.fbo.colorAttachment.set(null), this._rttSharedFbo.fbo.depthAttachment.set(null);
            let e1 = this.context.gl;
            e1.deleteRenderbuffer(this._rttSharedFbo.depthRenderbuffer), e1.deleteFramebuffer(this._rttSharedFbo.fbo.framebuffer), this._rttSharedFbo = null;
        }
        if (this.layerOpacityFbo?.destroy(), this.layerOpacityFbo = null, this.tileExtentBuffer && this.tileExtentBuffer.destroy(), this.debugBuffer && this.debugBuffer.destroy(), this.rasterBoundsBuffer && this.rasterBoundsBuffer.destroy(), this.rasterBoundsBufferPosOnly && this.rasterBoundsBufferPosOnly.destroy(), this.viewportBuffer && this.viewportBuffer.destroy(), this.tileBorderIndexBuffer && this.tileBorderIndexBuffer.destroy(), this.quadTriangleIndexBuffer && this.quadTriangleIndexBuffer.destroy(), this.tileExtentMesh && this.tileExtentMesh.vertexBuffer?.destroy(), this.tileExtentMesh && this.tileExtentMesh.indexBuffer?.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this.context.projectionUniformBuffer.destroy(), this.context.terrainUniformBuffer.destroy(), this.context.frameUniformBuffer.destroy(), this.cache) {
            for(let e1 in this.cache){
                let t = this.cache[e1];
                t?.program && this.context.gl.deleteProgram(t.program);
            }
            this.cache = {};
        }
        this.context && this.context.setDefault();
    }
    overLimit() {
        let { drawingBufferWidth: e1, drawingBufferHeight: t } = this.context.gl;
        return this.width !== e1 || this.height !== t;
    }
}, $4324d99ae8520741$export$68b5dc085315a832 = class extends Error {
    constructor(e1, t){
        super(`WebGL2 is required to display this map. We are sorry, but it seems that your browser does not support WebGL2, a technology for rendering 3D graphics on the web. Read more on https://wiki.openstreetmap.org/wiki/This_map_requires_WebGL`), this.name = `GPUInitializationError`, this.requestedAttributes = e1, this.statusMessage = t?.statusMessage ?? null;
    }
};
function $4324d99ae8520741$var$dp(e1, t) {
    let n = !1, r = null, i, a = ()=>{
        r = null, n &&= (e1(...i), r = setTimeout(a, t), !1);
    };
    return (...e1)=>(n = !0, i = e1, r || a(), r);
}
var $4324d99ae8520741$export$ab85ecd77ce6a5cd = class {
    constructor(e1){
        this._getHashParams = ()=>new URLSearchParams(window.location.hash.replace(`#`, ``)), this._getCurrentHash = ()=>{
            let e1 = this._getHashParams();
            return this._hashName ? (e1.get(this._hashName) || ``).split(`/`) : ([
                ...e1.keys()
            ][0] ?? ``).split(`/`);
        }, this._onHashChange = ()=>{
            let e1 = this._getCurrentHash();
            if (!this._isValidHash(e1)) return !1;
            let t = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(e1[3] || 0) : this._map.getBearing();
            return this._map.jumpTo({
                center: [
                    +e1[2],
                    +e1[1]
                ],
                zoom: +e1[0],
                bearing: t,
                pitch: +(e1[4] || 0)
            }), !0;
        }, this._updateHashUnthrottled = ()=>{
            let e1 = window.location.href.replace(/(#.*)?$/, this.getHashString());
            window.history.replaceState(window.history.state, null, e1);
        }, this._removeHash = ()=>{
            let e1 = this._getHashParams();
            if (this._hashName) e1.delete(this._hashName);
            else {
                let t = Array.from(e1.keys());
                t.length > 0 && e1.delete(t[0]);
            }
            let t = decodeURIComponent(e1.toString()).replace(/=&/g, `&`).replace(/=$/g, ``), n = t ? `#${t}` : ``, r = window.location.href.replace(/(#.+)?$/, n);
            r = r.replace(`&&`, `&`), window.history.replaceState(window.history.state, null, r);
        }, this._updateHash = $4324d99ae8520741$var$dp(this._updateHashUnthrottled, 300), this._hashName = e1 && encodeURIComponent(e1);
    }
    addTo(e1) {
        return this._map = e1, addEventListener(`hashchange`, this._onHashChange, !1), this._map.on(`moveend`, this._updateHash), this;
    }
    remove() {
        return removeEventListener(`hashchange`, this._onHashChange, !1), this._map.off(`moveend`, this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
    }
    getHashString(e1) {
        let t = this._map.getCenter(), n = Math.round(this._map.getZoom() * 100) / 100, r = 10 ** Math.ceil((n * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), i = Math.round(t.lng * r) / r, a = Math.round(t.lat * r) / r, o = this._map.getBearing(), s = this._map.getPitch(), c = ``;
        if (c += e1 ? `/${i}/${a}/${n}` : `${n}/${a}/${i}`, (o || s) && (c += `/${Math.round(o * 10) / 10}`), s && (c += `/${Math.round(s)}`), this._hashName) {
            let e1 = this._getHashParams();
            return e1.set(this._hashName, c), `#${decodeURIComponent(e1.toString()).replace(/=&/g, `&`).replace(/=$/g, ``)}`;
        }
        return `#${c}`;
    }
    _isValidHash(e1) {
        if (e1.length < 3 || e1.some((e1)=>isNaN(+e1))) return !1;
        try {
            new (0, $1G0Uw.lt)(+e1[2], +e1[1]);
        } catch  {
            return !1;
        }
        let t = +e1[0], n = +(e1[3] || 0), r = +(e1[4] || 0);
        return t >= this._map.getMinZoom() && t <= this._map.getMaxZoom() && n >= -180 && n <= 180 && r >= this._map.getMinPitch() && r <= this._map.getMaxPitch();
    }
};
const $4324d99ae8520741$var$pp = {
    linearity: .3,
    easing: (0, $1G0Uw.zn)(0, 0, .3, 1)
}, $4324d99ae8520741$var$mp = (0, $1G0Uw.er)({
    deceleration: 2500,
    maxSpeed: 1400
}, $4324d99ae8520741$var$pp), $4324d99ae8520741$var$hp = (0, $1G0Uw.er)({
    deceleration: 20,
    maxSpeed: 1400
}, $4324d99ae8520741$var$pp), $4324d99ae8520741$var$gp = (0, $1G0Uw.er)({
    deceleration: 1e3,
    maxSpeed: 360
}, $4324d99ae8520741$var$pp), $4324d99ae8520741$var$_p = (0, $1G0Uw.er)({
    deceleration: 1e3,
    maxSpeed: 90
}, $4324d99ae8520741$var$pp), $4324d99ae8520741$var$vp = (0, $1G0Uw.er)({
    deceleration: 1e3,
    maxSpeed: 360
}, $4324d99ae8520741$var$pp);
var $4324d99ae8520741$var$yp = class {
    constructor(e1){
        this._map = e1, this.clear();
    }
    clear() {
        this._inertiaBuffer = [];
    }
    record(e1) {
        this._drainInertiaBuffer(), this._inertiaBuffer.push({
            time: $4324d99ae8520741$export$461939dd4422153(),
            settings: e1
        });
    }
    _drainInertiaBuffer() {
        let e1 = this._inertiaBuffer, t = $4324d99ae8520741$export$461939dd4422153();
        for(; e1.length > 0 && t - e1[0].time > 160;)e1.shift();
    }
    _getVelocityEntries() {
        let e1 = this._inertiaBuffer, t = $4324d99ae8520741$export$461939dd4422153() - 60, n = Math.max(0, e1.length - 2);
        for(; n > 0 && e1[n - 1].time >= t;)n--;
        return e1.slice(n);
    }
    _onMoveEnd(e1) {
        this._drainInertiaBuffer();
        let n = this._getVelocityEntries();
        if (n.length < 2) {
            this.clear();
            return;
        }
        let r = {
            zoom: 0,
            bearing: 0,
            pitch: 0,
            roll: 0,
            pan: new (0, $1G0Uw.Li)(0, 0),
            pinchAround: void 0,
            around: void 0
        };
        for (let { settings: e1 } of n)e1.around && (r.around = e1.around), e1.pinchAround && (r.pinchAround = e1.pinchAround);
        for (let { settings: e1 } of n.slice(1))r.zoom += e1.zoomDelta || 0, r.bearing += e1.bearingDelta || 0, r.pitch += e1.pitchDelta || 0, r.roll += e1.rollDelta || 0, e1.panDelta && r.pan._add(e1.panDelta);
        if (!r.pan.mag() && !r.zoom && !r.bearing && !r.pitch && !r.roll) {
            this.clear();
            return;
        }
        let i = $4324d99ae8520741$export$461939dd4422153() - n[0].time, a = {};
        if (r.pan.mag()) {
            let t = $4324d99ae8520741$var$xp(r.pan.mag(), i, (0, $1G0Uw.er)({}, $4324d99ae8520741$var$mp, e1 || {})), n = r.pan.mult(t.amount / r.pan.mag()), o = this._map._camera.cameraHelper.handlePanInertia(n, this._map._camera.transform);
            a.center = o.easingCenter, a.offset = o.easingOffset, $4324d99ae8520741$var$bp(a, t);
        }
        if (r.zoom) {
            let e1 = $4324d99ae8520741$var$xp(r.zoom, i, $4324d99ae8520741$var$hp);
            a.zoom = (0, $1G0Uw.$n)(this._map.getZoom() + e1.amount, this._map.getZoomSnap(), e1.amount), $4324d99ae8520741$var$bp(a, e1);
        }
        if (r.bearing) {
            let e1 = $4324d99ae8520741$var$xp(r.bearing, i, $4324d99ae8520741$var$gp);
            a.bearing = this._map.getBearing() + (0, $1G0Uw.Bn)(e1.amount, -179, 179), $4324d99ae8520741$var$bp(a, e1);
        }
        if (r.pitch) {
            let e1 = $4324d99ae8520741$var$xp(r.pitch, i, $4324d99ae8520741$var$_p);
            a.pitch = this._map.getPitch() + e1.amount, $4324d99ae8520741$var$bp(a, e1);
        }
        if (r.roll) {
            let e1 = $4324d99ae8520741$var$xp(r.roll, i, $4324d99ae8520741$var$vp);
            a.roll = this._map.getRoll() + (0, $1G0Uw.Bn)(e1.amount, -179, 179), $4324d99ae8520741$var$bp(a, e1);
        }
        if (a.zoom || a.bearing) {
            let e1 = r.pinchAround === void 0 ? r.around : r.pinchAround;
            a.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
        }
        return this.clear(), (0, $1G0Uw.er)(a, {
            noMoveStart: !0
        });
    }
};
function $4324d99ae8520741$var$bp(e1, t) {
    (!e1.duration || e1.duration < t.duration) && (e1.duration = t.duration, e1.easing = t.easing);
}
function $4324d99ae8520741$var$xp(e1, t, n) {
    let { maxSpeed: r, linearity: i, deceleration: a } = n, o = (0, $1G0Uw.Bn)(e1 * i / (t / 1e3), -r, r), s = Math.abs(o) / (a * i);
    return {
        easing: n.easing,
        duration: s * 1e3,
        amount: s / 2 * o
    };
}
var $4324d99ae8520741$var$Sp = class {
    constructor(e1, t){
        this._map = e1, this._clickTolerance = t.clickTolerance;
    }
    reset() {
        delete this._mousedownPos;
    }
    wheel(e1) {
        return this._firePreventable(new $4324d99ae8520741$export$10870e40d23509f(this._map, e1));
    }
    mousedown(e1, t) {
        return this._mousedownPos = t, this._firePreventable(new $4324d99ae8520741$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    mouseup(e1) {
        this._map.fire(new $4324d99ae8520741$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    click(e1, t) {
        this._mousedownPos && this._mousedownPos.dist(t) >= this._clickTolerance || this._map.fire(new $4324d99ae8520741$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    dblclick(e1) {
        return this._firePreventable(new $4324d99ae8520741$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    mouseover(e1) {
        this._map.fire(new $4324d99ae8520741$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    mouseout(e1) {
        this._map.fire(new $4324d99ae8520741$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    touchstart(e1) {
        return this._firePreventable(new $4324d99ae8520741$export$706699378fec3ddd(e1.type, this._map, e1));
    }
    touchmove(e1) {
        this._map.fire(new $4324d99ae8520741$export$706699378fec3ddd(e1.type, this._map, e1));
    }
    touchend(e1) {
        this._map.fire(new $4324d99ae8520741$export$706699378fec3ddd(e1.type, this._map, e1));
    }
    touchcancel(e1) {
        this._map.fire(new $4324d99ae8520741$export$706699378fec3ddd(e1.type, this._map, e1));
    }
    _firePreventable(e1) {
        if (this._map.fire(e1), e1.defaultPrevented) return {};
    }
    isEnabled() {
        return !0;
    }
    isActive() {
        return !1;
    }
    enable() {}
    disable() {}
}, $4324d99ae8520741$var$Cp = class {
    constructor(e1){
        this._map = e1;
    }
    reset() {
        this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
    }
    mousemove(e1) {
        this._map.fire(new $4324d99ae8520741$export$83f023c8e5acf676(e1.type, this._map, e1));
    }
    mousedown() {
        this._delayContextMenu = !0, this._ignoreContextMenu = !1;
    }
    mouseup() {
        this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new $4324d99ae8520741$export$83f023c8e5acf676(`contextmenu`, this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
    }
    contextmenu(e1) {
        this._delayContextMenu ? this._contextMenuEvent = e1 : this._ignoreContextMenu || this._map.fire(new $4324d99ae8520741$export$83f023c8e5acf676(e1.type, this._map, e1)), this._map.listens(`contextmenu`) && e1.preventDefault();
    }
    isEnabled() {
        return !0;
    }
    isActive() {
        return !1;
    }
    enable() {}
    disable() {}
}, $4324d99ae8520741$export$bd01c6f06175f3af = class {
    constructor(e1, t, n){
        this._map = e1, this._tr = n, this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t.clickTolerance || 1, t.boxZoom && typeof t.boxZoom == `object` && (this._boxZoomEnd = t.boxZoom.boxZoomEnd);
    }
    isEnabled() {
        return !!this._enabled;
    }
    isActive() {
        return !!this._active;
    }
    enable() {
        this.isEnabled() || (this._enabled = !0);
    }
    disable() {
        this.isEnabled() && (this._enabled = !1);
    }
    mousedown(e1, t) {
        this.isEnabled() && e1.shiftKey && e1.button === 0 && ($4324d99ae8520741$var$G.disableDrag(), this._startPos = this._lastPos = t, this._active = !0);
    }
    mousemoveWindow(e1, t) {
        if (!this._active) return;
        let n = t;
        if (this._lastPos.equals(n) || !this._box && n.dist(this._startPos) < this._clickTolerance) return;
        let r = this._startPos;
        this._lastPos = n, this._box || (this._box = $4324d99ae8520741$var$G.create(`div`, `maplibregl-boxzoom`, this._container), this._container.classList.add(`maplibregl-crosshair`), this._fireEvent(`boxzoomstart`, e1));
        let i = Math.min(r.x, n.x), a = Math.max(r.x, n.x), o = Math.min(r.y, n.y), s = Math.max(r.y, n.y);
        this._box.style.transform = `translate(${i}px,${o}px)`, this._box.style.width = `${a - i}px`, this._box.style.height = `${s - o}px`;
    }
    mouseupWindow(e1, t) {
        if (!this._active || e1.button !== 0) return;
        let n = this._startPos, r = t;
        if (this.reset(), $4324d99ae8520741$var$G.suppressClick(), n.x === r.x && n.y === r.y) this._fireEvent(`boxzoomcancel`, e1);
        else {
            if (this._map.fire(new $4324d99ae8520741$export$702e4d7a848278fa(`boxzoomend`, {
                originalEvent: e1
            })), this._boxZoomEnd) {
                this._boxZoomEnd(this._map, n, r, e1);
                return;
            }
            return {
                cameraAnimation: (e1)=>e1.fitScreenCoordinates(n, r, this._tr.bearing, {
                        linear: !0
                    })
            };
        }
    }
    keydown(e1) {
        this._active && e1.keyCode === 27 && (this.reset(), this._fireEvent(`boxzoomcancel`, e1));
    }
    reset() {
        this._active = !1, this._container.classList.remove(`maplibregl-crosshair`), this._box &&= (this._box.remove(), null), $4324d99ae8520741$var$G.enableDrag(), delete this._startPos, delete this._lastPos;
    }
    _fireEvent(e1, t) {
        return this._map.fire(new $4324d99ae8520741$export$702e4d7a848278fa(e1, {
            originalEvent: t
        }));
    }
};
function $4324d99ae8520741$var$Tp(e1, t) {
    if (e1.length !== t.length) throw Error(`The number of touches and points are not equal - touches ${e1.length}, points ${t.length}`);
    let n = {};
    for(let r = 0; r < e1.length; r++)n[e1[r].identifier] = t[r];
    return n;
}
function $4324d99ae8520741$var$Ep(e1) {
    let t = new (0, $1G0Uw.Li)(0, 0);
    for (let n of e1)t._add(n);
    return t.div(e1.length);
}
var $4324d99ae8520741$var$Dp = class {
    constructor(e1){
        this.reset(), this.numTouches = e1.numTouches;
    }
    reset() {
        delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
    }
    touchstart(e1, t, n) {
        (this.centroid || n.length > this.numTouches) && (this.aborted = !0), !this.aborted && (this.startTime === void 0 && (this.startTime = e1.timeStamp), n.length === this.numTouches && (this.centroid = $4324d99ae8520741$var$Ep(t), this.touches = $4324d99ae8520741$var$Tp(n, t)));
    }
    touchmove(e1, t, n) {
        if (this.aborted || !this.centroid) return;
        let r = $4324d99ae8520741$var$Tp(n, t);
        for(let e1 in this.touches){
            let t = this.touches[e1], n = r[e1];
            (!n || n.dist(t) > 30) && (this.aborted = !0);
        }
    }
    touchend(e1, t, n) {
        if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), n.length === 0) {
            let e1 = !this.aborted && this.centroid;
            if (this.reset(), e1) return e1;
        }
    }
}, $4324d99ae8520741$var$Op = class {
    constructor(e1){
        this.singleTap = new $4324d99ae8520741$var$Dp(e1), this.numTaps = e1.numTaps, this.reset();
    }
    reset() {
        this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
    }
    touchstart(e1, t, n) {
        this.singleTap.touchstart(e1, t, n);
    }
    touchmove(e1, t, n) {
        this.singleTap.touchmove(e1, t, n);
    }
    touchend(e1, t, n) {
        let r = this.singleTap.touchend(e1, t, n);
        if (r) {
            let t = e1.timeStamp - this.lastTime < 500, n = !this.lastTap || this.lastTap.dist(r) < 30;
            if ((!t || !n) && this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = r, this.count === this.numTaps) return this.reset(), r;
        }
    }
}, $4324d99ae8520741$var$kp = class {
    constructor(e1, t){
        this._tr = t, this._zoomIn = new $4324d99ae8520741$var$Op({
            numTouches: 1,
            numTaps: 2
        }), this._zoomOut = new $4324d99ae8520741$var$Op({
            numTouches: 2,
            numTaps: 1
        }), this.reset();
    }
    reset() {
        this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
    }
    touchstart(e1, t, n) {
        this._zoomIn.touchstart(e1, t, n), this._zoomOut.touchstart(e1, t, n);
    }
    touchmove(e1, t, n) {
        this._zoomIn.touchmove(e1, t, n), this._zoomOut.touchmove(e1, t, n);
    }
    touchend(e1, n, r) {
        let i = this._zoomIn.touchend(e1, n, r), a = this._zoomOut.touchend(e1, n, r), o = this._tr;
        if (i) return this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
            cameraAnimation: (n)=>n.easeTo({
                    duration: 300,
                    zoom: (0, $1G0Uw.$n)(o.zoom + 1, n.getZoomSnap()),
                    around: o.unproject(i)
                }, {
                    originalEvent: e1
                })
        };
        if (a) return this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
            cameraAnimation: (n)=>n.easeTo({
                    duration: 300,
                    zoom: (0, $1G0Uw.$n)(o.zoom - 1, n.getZoomSnap()),
                    around: o.unproject(a)
                }, {
                    originalEvent: e1
                })
        };
    }
    touchcancel() {
        this.reset();
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $4324d99ae8520741$var$Ap = class {
    constructor(e1){
        this._enabled = !!e1.enable, this._moveStateManager = e1.moveStateManager, this._clickTolerance = e1.clickTolerance || 1, this._moveFunction = e1.move, this._activateOnStart = !!e1.activateOnStart, e1.assignEvents(this), this.reset();
    }
    reset(e1) {
        this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(e1);
    }
    _move(...e1) {
        let t = this._moveFunction(...e1);
        if (t.bearingDelta || t.pitchDelta || t.rollDelta || t.around || t.panDelta) return this._active = !0, t;
    }
    dragStart(e1, t) {
        this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(e1) && (this._moveStateManager.startMove(e1), this._lastPoint = Array.isArray(t) ? t[0] : t, this._activateOnStart && this._lastPoint && (this._active = !0));
    }
    dragMove(e1, t) {
        if (!this.isEnabled()) return;
        let n = this._lastPoint;
        if (!n) return;
        if (e1.preventDefault(), !this._moveStateManager.isValidMoveEvent(e1)) {
            this.reset(e1);
            return;
        }
        let r = Array.isArray(t) ? t[0] : t;
        if (!(!this._moved && r.dist(n) < this._clickTolerance)) return this._moved = !0, this._lastPoint = r, this._move(n, r);
    }
    dragEnd(e1) {
        this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(e1) && (this._moved && $4324d99ae8520741$var$G.suppressClick(), this.reset(e1));
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
    getClickTolerance() {
        return this._clickTolerance;
    }
};
const $4324d99ae8520741$var$jp = {
    0: 1,
    2: 2
};
function $4324d99ae8520741$var$Mp(e1, t) {
    let n = $4324d99ae8520741$var$jp[t];
    return e1.buttons === void 0 || (e1.buttons & n) !== n;
}
var $4324d99ae8520741$var$Np = class {
    constructor(e1){
        this._correctEvent = e1.checkCorrectEvent;
    }
    startMove(e1) {
        this._eventButton = e1.button;
    }
    endMove(e1) {
        delete this._eventButton;
    }
    isValidStartEvent(e1) {
        return this._correctEvent(e1);
    }
    isValidMoveEvent(e1) {
        return !$4324d99ae8520741$var$Mp(e1, this._eventButton);
    }
    isValidEndEvent(e1) {
        return e1.button === this._eventButton;
    }
}, $4324d99ae8520741$var$Pp = class {
    constructor(){
        this._firstTouch = void 0;
    }
    _isOneFingerTouch(e1) {
        return e1.targetTouches.length === 1;
    }
    _isSameTouchEvent(e1) {
        return e1.targetTouches[0].identifier === this._firstTouch;
    }
    startMove(e1) {
        this._firstTouch = e1.targetTouches[0].identifier;
    }
    endMove(e1) {
        delete this._firstTouch;
    }
    isValidStartEvent(e1) {
        return this._isOneFingerTouch(e1);
    }
    isValidMoveEvent(e1) {
        return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
    }
    isValidEndEvent(e1) {
        return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
    }
}, $4324d99ae8520741$var$Fp = class {
    constructor(e1 = new $4324d99ae8520741$var$Np({
        checkCorrectEvent: ()=>!0
    }), t = new $4324d99ae8520741$var$Pp){
        this.mouseMoveStateManager = e1, this.oneFingerTouchMoveStateManager = t;
    }
    _executeRelevantHandler(e1, t, n) {
        if (e1 instanceof MouseEvent) return t(e1);
        if (typeof TouchEvent < `u` && e1 instanceof TouchEvent) return n(e1);
    }
    startMove(e1) {
        this._executeRelevantHandler(e1, (e1)=>{
            this.mouseMoveStateManager.startMove(e1);
        }, (e1)=>{
            this.oneFingerTouchMoveStateManager.startMove(e1);
        });
    }
    endMove(e1) {
        this._executeRelevantHandler(e1, (e1)=>{
            this.mouseMoveStateManager.endMove(e1);
        }, (e1)=>{
            this.oneFingerTouchMoveStateManager.endMove(e1);
        });
    }
    isValidStartEvent(e1) {
        return !!this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidStartEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidStartEvent(e1));
    }
    isValidMoveEvent(e1) {
        return !!this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidMoveEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidMoveEvent(e1));
    }
    isValidEndEvent(e1) {
        return !!this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidEndEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidEndEvent(e1));
    }
};
const $4324d99ae8520741$var$Ip = (e1)=>{
    e1.mousedown = e1.dragStart, e1.mousemoveWindow = e1.dragMove, e1.mouseup = e1.dragEnd, e1.contextmenu = (e1)=>{
        e1.preventDefault();
    };
};
function $4324d99ae8520741$var$Lp({ enable: e1, clickTolerance: t }) {
    return new $4324d99ae8520741$var$Ap({
        clickTolerance: t,
        move: (e1, t)=>({
                around: t,
                panDelta: t.sub(e1)
            }),
        activateOnStart: !0,
        moveStateManager: new $4324d99ae8520741$var$Np({
            checkCorrectEvent: (e1)=>e1.button === 0 && !e1.ctrlKey
        }),
        enable: e1,
        assignEvents: $4324d99ae8520741$var$Ip
    });
}
function $4324d99ae8520741$var$Rp({ enable: e1, clickTolerance: t, aroundCenter: n = !0, minPixelCenterThreshold: r = 100, rotateSpeed: i = .8 }, a) {
    return new $4324d99ae8520741$var$Ap({
        clickTolerance: t,
        move: (e1, t)=>{
            let o = a();
            if (n && Math.abs(o.y - e1.y) > r) return {
                bearingDelta: (0, $1G0Uw.ir)(new (0, $1G0Uw.Li)(e1.x, t.y), t, o)
            };
            let s = (t.x - e1.x) * i;
            return n && t.y < o.y && (s = -s), {
                bearingDelta: s
            };
        },
        moveStateManager: new $4324d99ae8520741$var$Np({
            checkCorrectEvent: (e1)=>e1.button === 0 && e1.ctrlKey || e1.button === 2 && !e1.ctrlKey
        }),
        enable: e1,
        assignEvents: $4324d99ae8520741$var$Ip
    });
}
function $4324d99ae8520741$var$zp({ enable: e1, clickTolerance: t, pitchSpeed: n = -0.5 }) {
    return new $4324d99ae8520741$var$Ap({
        clickTolerance: t,
        move: (e1, t)=>({
                pitchDelta: (t.y - e1.y) * n
            }),
        moveStateManager: new $4324d99ae8520741$var$Np({
            checkCorrectEvent: (e1)=>e1.button === 0 && e1.ctrlKey || e1.button === 2
        }),
        enable: e1,
        assignEvents: $4324d99ae8520741$var$Ip
    });
}
function $4324d99ae8520741$var$Bp({ enable: e1, clickTolerance: t, rollDegreesPerPixelMoved: n = .3 }, r) {
    return new $4324d99ae8520741$var$Ap({
        clickTolerance: t,
        move: (e1, t)=>{
            let i = r(), a = (t.x - e1.x) * n;
            return t.y < i.y && (a = -a), {
                rollDelta: a
            };
        },
        moveStateManager: new $4324d99ae8520741$var$Np({
            checkCorrectEvent: (e1)=>e1.button === 2 && e1.ctrlKey
        }),
        enable: e1,
        assignEvents: $4324d99ae8520741$var$Ip
    });
}
var $4324d99ae8520741$var$Vp = class {
    constructor(e1, t){
        this._clickTolerance = e1.clickTolerance || 1, this._map = t, this.reset();
    }
    reset() {
        this._active = !1, this._touches = {}, this._sum = new (0, $1G0Uw.Li)(0, 0);
    }
    _shouldBePrevented(e1) {
        return e1 < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
    }
    touchstart(e1, t, n) {
        return this._calculateTransform(e1, t, n);
    }
    touchmove(e1, t, n) {
        if (this._active) {
            if (this._shouldBePrevented(n.length)) {
                this._map.cooperativeGestures.notifyGestureBlocked(`touch_pan`, e1);
                return;
            }
            return e1.preventDefault(), this._calculateTransform(e1, t, n);
        }
    }
    touchend(e1, t, n) {
        this._calculateTransform(e1, t, n), this._active && this._shouldBePrevented(n.length) && this.reset();
    }
    touchcancel() {
        this.reset();
    }
    _calculateTransform(e1, t, n) {
        n.length > 0 && (this._active = !0);
        let r = $4324d99ae8520741$var$Tp(n, t), i = new (0, $1G0Uw.Li)(0, 0), a = new (0, $1G0Uw.Li)(0, 0), o = 0;
        for(let e1 in r){
            let t = r[e1], n = this._touches[e1];
            n && (i._add(t), a._add(t.sub(n)), o++, r[e1] = t);
        }
        if (this._touches = r, this._shouldBePrevented(o) || !a.mag()) return;
        let s = a.div(o);
        if (this._sum._add(s), !(this._sum.mag() < this._clickTolerance)) return {
            around: i.div(o),
            panDelta: s
        };
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $4324d99ae8520741$var$Hp = class {
    constructor(){
        this.reset();
    }
    reset() {
        this._active = !1, delete this._firstTwoTouches;
    }
    touchstart(e1, t, n) {
        this._firstTwoTouches || n.length < 2 || (this._firstTwoTouches = [
            n[0].identifier,
            n[1].identifier
        ], this._start([
            t[0],
            t[1]
        ]));
    }
    touchmove(e1, t, n) {
        if (!this._firstTwoTouches) return;
        e1.preventDefault();
        let [r, i] = this._firstTwoTouches, a = $4324d99ae8520741$var$Up(n, t, r), o = $4324d99ae8520741$var$Up(n, t, i);
        if (!a || !o) return;
        let s = this._aroundCenter ? null : a.add(o).div(2);
        return this._move([
            a,
            o
        ], s, e1);
    }
    touchend(e1, t, n) {
        if (!this._firstTwoTouches) return;
        let [r, i] = this._firstTwoTouches, a = $4324d99ae8520741$var$Up(n, t, r), o = $4324d99ae8520741$var$Up(n, t, i);
        a && o || (this._active && $4324d99ae8520741$var$G.suppressClick(), this.reset());
    }
    touchcancel() {
        this.reset();
    }
    enable(e1) {
        this._enabled = !0, this._aroundCenter = !!e1 && e1.around === `center`;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return !!this._enabled;
    }
    isActive() {
        return !!this._active;
    }
};
function $4324d99ae8520741$var$Up(e1, t, n) {
    for(let r = 0; r < e1.length; r++)if (e1[r].identifier === n) return t[r];
}
const $4324d99ae8520741$var$Wp = .1;
function $4324d99ae8520741$var$Gp(e1, t) {
    return Math.log(e1 / t) / Math.LN2;
}
var $4324d99ae8520741$export$db37e9f00445aa54 = class extends $4324d99ae8520741$var$Hp {
    constructor(){
        super(), this._zoomRate = 1, this._zoomThreshold = $4324d99ae8520741$var$Wp;
    }
    setZoomRate(e1) {
        this._zoomRate = e1 ?? 1;
    }
    setZoomThreshold(e1) {
        this._zoomThreshold = e1 ?? $4324d99ae8520741$var$Wp;
    }
    reset() {
        super.reset(), delete this._distance, delete this._startDistance;
    }
    _start(e1) {
        this._startDistance = this._distance = e1[0].dist(e1[1]);
    }
    _move(e1, t) {
        let n = this._distance;
        if (this._distance = e1[0].dist(e1[1]), !(!this._active && Math.abs($4324d99ae8520741$var$Gp(this._distance, this._startDistance)) < this._zoomThreshold)) return this._active = !0, {
            zoomDelta: $4324d99ae8520741$var$Gp(this._distance, n) * this._zoomRate,
            pinchAround: t
        };
    }
};
function $4324d99ae8520741$var$qp(e1, t) {
    return e1.angleWith(t) * 180 / Math.PI;
}
var $4324d99ae8520741$export$6966aa20d1b4577f = class extends $4324d99ae8520741$var$Hp {
    reset() {
        super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
    }
    _start(e1) {
        this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
    }
    _move(e1, t, n) {
        let r = this._vector;
        if (this._vector = e1[0].sub(e1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
            bearingDelta: $4324d99ae8520741$var$qp(this._vector, r),
            pinchAround: t
        };
    }
    _isBelowThreshold(e1) {
        this._minDiameter = Math.min(this._minDiameter, e1.mag());
        let t = 25 / (Math.PI * this._minDiameter) * 360, n = $4324d99ae8520741$var$qp(e1, this._startVector);
        return Math.abs(n) < t;
    }
};
function $4324d99ae8520741$var$Yp(e1) {
    return Math.abs(e1.y) > Math.abs(e1.x);
}
var $4324d99ae8520741$export$7ea266bd3010ae2a = class extends $4324d99ae8520741$var$Hp {
    constructor(e1){
        super(), this._currentTouchCount = 0, this._map = e1;
    }
    reset() {
        super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
    }
    touchstart(e1, t, n) {
        super.touchstart(e1, t, n), this._currentTouchCount = n.length;
    }
    _start(e1) {
        this._lastPoints = e1, $4324d99ae8520741$var$Yp(e1[0].sub(e1[1])) && (this._valid = !1);
    }
    _move(e1, t, n) {
        if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
        let r = e1[0].sub(this._lastPoints[0]), i = e1[1].sub(this._lastPoints[1]);
        if (this._valid = this.gestureBeginsVertically(r, i, n.timeStamp), this._valid) return this._lastPoints = e1, this._active = !0, {
            pitchDelta: (r.y + i.y) / 2 * -0.5
        };
    }
    gestureBeginsVertically(e1, t, n) {
        if (this._valid !== void 0) return this._valid;
        let r = e1.mag() >= 2, i = t.mag() >= 2;
        if (!r && !i) return;
        if (!r || !i) return this._firstMove === void 0 && (this._firstMove = n), n - this._firstMove < 100 && void 0;
        let a = e1.y > 0 == t.y > 0;
        return $4324d99ae8520741$var$Yp(e1) && $4324d99ae8520741$var$Yp(t) && a;
    }
};
const $4324d99ae8520741$var$Zp = {
    panStep: 100,
    bearingStep: 15,
    pitchStep: 10
};
var $4324d99ae8520741$export$474b8119f9aaf6a9 = class {
    constructor(e1, t){
        this._tr = t;
        let n = $4324d99ae8520741$var$Zp;
        this._panStep = n.panStep, this._bearingStep = n.bearingStep, this._pitchStep = n.pitchStep, this._rotationDisabled = !1;
    }
    reset() {
        this._active = !1;
    }
    keydown(e1) {
        if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
        let n = 0, r = 0, i = 0, a = 0, o = 0;
        switch(e1.keyCode){
            case 61:
            case 107:
            case 171:
            case 187:
                n = 1;
                break;
            case 189:
            case 109:
            case 173:
                n = -1;
                break;
            case 37:
                e1.shiftKey ? r = -1 : (e1.preventDefault(), a = -1);
                break;
            case 39:
                e1.shiftKey ? r = 1 : (e1.preventDefault(), a = 1);
                break;
            case 38:
                e1.shiftKey ? i = 1 : (e1.preventDefault(), o = -1);
                break;
            case 40:
                e1.shiftKey ? i = -1 : (e1.preventDefault(), o = 1);
                break;
            default:
                return;
        }
        return this._rotationDisabled && (r = 0, i = 0), {
            cameraAnimation: (s)=>{
                let c = this._tr;
                s.easeTo({
                    duration: 300,
                    easeId: `keyboardHandler`,
                    easing: $4324d99ae8520741$var$$p,
                    zoom: n ? (0, $1G0Uw.$n)(c.zoom + n * (e1.shiftKey ? 2 : 1), s.getZoomSnap()) : c.zoom,
                    bearing: c.bearing + r * this._bearingStep,
                    pitch: c.pitch + i * this._pitchStep,
                    offset: [
                        -a * this._panStep,
                        -o * this._panStep
                    ],
                    center: c.center
                }, {
                    originalEvent: e1
                });
            }
        };
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
    disableRotation() {
        this._rotationDisabled = !0;
    }
    enableRotation() {
        this._rotationDisabled = !1;
    }
};
function $4324d99ae8520741$var$$p(e1) {
    return e1 * (2 - e1);
}
const $4324d99ae8520741$var$em = 4.000244140625;
var $4324d99ae8520741$export$fd7a47efd2367414 = class {
    constructor(e1, t, n){
        this._onTimeout = (e1)=>{
            this._type = `wheel`, this._delta -= this._lastValue, this._active || this._start(e1);
        }, this._map = e1, this._tr = n, this._triggerRenderFrame = t, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222;
    }
    setZoomRate(e1) {
        this._defaultZoomRate = e1;
    }
    setWheelZoomRate(e1) {
        this._wheelZoomRate = e1;
    }
    isEnabled() {
        return !!this._enabled;
    }
    isActive() {
        return !!this._active || this._finishTimeout !== void 0;
    }
    isZooming() {
        return !!this._zooming;
    }
    enable(e1) {
        this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && e1.around === `center`);
    }
    disable() {
        this.isEnabled() && (this._enabled = !1);
    }
    _shouldBePrevented(e1) {
        return this._map.cooperativeGestures.isEnabled() ? !(e1.ctrlKey || this._map.cooperativeGestures.isBypassed(e1)) : !1;
    }
    wheel(e1) {
        if (!this.isEnabled()) return;
        if (this._shouldBePrevented(e1)) {
            this._map.cooperativeGestures.notifyGestureBlocked(`wheel_zoom`, e1);
            return;
        }
        let t = e1.deltaMode === WheelEvent.DOM_DELTA_LINE ? e1.deltaY * 40 : e1.deltaY, n = $4324d99ae8520741$export$461939dd4422153(), r = n - (this._lastWheelEventTime || 0);
        this._lastWheelEventTime = n, t !== 0 && t % $4324d99ae8520741$var$em == 0 ? this._type = `wheel` : t !== 0 && Math.abs(t) < 4 ? this._type = `trackpad` : r > 400 ? (this._type = null, this._lastValue = t, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(r * t) < 200 ? `trackpad` : `wheel`, this._timeout && (clearTimeout(this._timeout), this._timeout = null, t += this._lastValue)), e1.shiftKey && t && (t /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= t, this._active || this._start(e1)), e1.preventDefault();
    }
    _start(e1) {
        if (!this._delta) return;
        this._needsRerender = !1, this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
        let t = $4324d99ae8520741$var$G.mousePos(this._map.getCanvas(), e1), n = this._tr;
        this._aroundPoint = this._aroundCenter ? n.transform.locationToScreenPoint((0, $1G0Uw.lt).convert(n.center)) : t, this._needsRerender || (this._needsRerender = !0, this._triggerRenderFrame());
    }
    renderFrame() {
        if (!this._needsRerender || (this._needsRerender = !1, !this.isActive())) return;
        let e1 = this._tr.transform;
        if (typeof this._lastExpectedZoom == `number`) {
            let t = e1.zoom - this._lastExpectedZoom;
            typeof this._startZoom == `number` && (this._startZoom += t), typeof this._targetZoom == `number` && (this._targetZoom += t);
        }
        if (this._delta !== 0) {
            let n = this._type === `wheel` && Math.abs(this._delta) > $4324d99ae8520741$var$em ? this._wheelZoomRate : this._defaultZoomRate, r = 2 / (1 + Math.exp(-Math.abs(this._delta * n)));
            this._delta < 0 && r !== 0 && (r = 1 / r);
            let i = typeof this._targetZoom == `number` ? (0, $1G0Uw.Fr)(this._targetZoom) : e1.scale, a = e1.applyConstrain(e1.getCameraLngLat(), (0, $1G0Uw.Dr)(i * r)).zoom, o = this._map.getZoomSnap();
            if (this._type === `wheel` && o > 0) {
                let n = (0, $1G0Uw.$n)(e1.zoom, o);
                this._targetZoom = (0, $1G0Uw.$n)(a, o, a - n);
            } else this._targetZoom = a;
            this._type === `wheel` && (this._startZoom = e1.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
        }
        let n = typeof this._targetZoom == `number` ? this._targetZoom : e1.zoom, r = this._startZoom, i = this._easing, a = !1, o;
        if (this._type === `wheel` && r && i) {
            let e1 = $4324d99ae8520741$export$461939dd4422153() - this._lastWheelEventTime, t = Math.min((e1 + 5) / 200, 1), s = i(t);
            o = (0, $1G0Uw.un).number(r, n, s), t < 1 ? this._needsRerender = !0 : a = !0;
        } else o = n, a = !0;
        return this._active = !0, a && (this._active = !1, this._finishTimeout = setTimeout(()=>{
            this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._lastExpectedZoom, delete this._finishTimeout;
        }, 200)), this._lastExpectedZoom = o, {
            noInertia: !0,
            needsRenderFrame: !a,
            zoomDelta: o - e1.zoom,
            around: this._aroundPoint,
            originalEvent: this._lastWheelEvent
        };
    }
    _smoothOutEasing(e1) {
        let t = (0, $1G0Uw.Jn);
        if (this._prevEase) {
            let e1 = this._prevEase, n = ($4324d99ae8520741$export$461939dd4422153() - e1.start) / e1.duration, r = e1.easing(n + .01) - e1.easing(n), i = .27 / Math.sqrt(r * r + 1e-4) * .01, a = Math.sqrt(.0729 - i * i);
            t = (0, $1G0Uw.zn)(i, a, .25, 1);
        }
        return this._prevEase = {
            start: $4324d99ae8520741$export$461939dd4422153(),
            duration: e1,
            easing: t
        }, t;
    }
    reset() {
        this._active = !1, this._zooming = !1, delete this._targetZoom, delete this._lastExpectedZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
    }
}, $4324d99ae8520741$export$939799190379133f = class {
    constructor(e1, t){
        this._clickZoom = e1, this._tapZoom = t;
    }
    enable() {
        this._clickZoom.enable(), this._tapZoom.enable();
    }
    disable() {
        this._clickZoom.disable(), this._tapZoom.disable();
    }
    isEnabled() {
        return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
    }
    isActive() {
        return this._clickZoom.isActive() || this._tapZoom.isActive();
    }
}, $4324d99ae8520741$var$rm = class {
    constructor(e1, t){
        this._tr = t, this.reset();
    }
    reset() {
        this._active = !1;
    }
    dblclick(e1, n) {
        return e1.preventDefault(), {
            cameraAnimation: (r)=>{
                r.easeTo({
                    duration: 300,
                    zoom: (0, $1G0Uw.$n)(this._tr.zoom + (e1.shiftKey ? -1 : 1), r.getZoomSnap()),
                    around: this._tr.unproject(n)
                }, {
                    originalEvent: e1
                });
            }
        };
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $4324d99ae8520741$var$im = class {
    constructor(){
        this._tap = new $4324d99ae8520741$var$Op({
            numTouches: 1,
            numTaps: 1
        }), this._zoomRate = 1, this.reset();
    }
    setZoomRate(e1) {
        this._zoomRate = e1 ?? 1;
    }
    reset() {
        this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
    }
    touchstart(e1, t, n) {
        if (!this._swipePoint) {
            if (!this._tapTime) this._tap.touchstart(e1, t, n);
            else {
                let r = t[0], i = e1.timeStamp - this._tapTime < 500, a = this._tapPoint.dist(r) < 30;
                !i || !a ? this.reset() : n.length > 0 && (this._swipePoint = r, this._swipeTouch = n[0].identifier);
            }
        }
    }
    touchmove(e1, t, n) {
        if (!this._tapTime) this._tap.touchmove(e1, t, n);
        else if (this._swipePoint) {
            if (n[0].identifier !== this._swipeTouch) return;
            let r = t[0], i = r.y - this._swipePoint.y;
            return this._swipePoint = r, e1.preventDefault(), this._active = !0, {
                zoomDelta: i / 128 * this._zoomRate
            };
        }
    }
    touchend(e1, t, n) {
        if (this._tapTime) this._swipePoint && n.length === 0 && this.reset();
        else {
            let r = this._tap.touchend(e1, t, n);
            r && (this._tapTime = e1.timeStamp, this._tapPoint = r);
        }
    }
    touchcancel() {
        this.reset();
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $4324d99ae8520741$export$69c4612f5624c3f0 = class {
    constructor(e1, t, n){
        this._el = e1, this._mousePan = t, this._touchPan = n;
    }
    enable(e1) {
        this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add(`maplibregl-touch-drag-pan`);
    }
    disable() {
        this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove(`maplibregl-touch-drag-pan`);
    }
    isEnabled() {
        return this._mousePan.isEnabled() && this._touchPan.isEnabled();
    }
    isActive() {
        return this._mousePan.isActive() || this._touchPan.isActive();
    }
}, $4324d99ae8520741$export$fc9ed7efe29ccb64 = class {
    constructor(e1, t, n, r){
        this._pitchWithRotate = e1.pitchWithRotate, this._rollEnabled = e1.rollEnabled, this._mouseRotate = t, this._mousePitch = n, this._mouseRoll = r;
    }
    enable() {
        this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable(), this._rollEnabled && this._mouseRoll.enable();
    }
    disable() {
        this._mouseRotate.disable(), this._mousePitch.disable(), this._mouseRoll.disable();
    }
    isEnabled() {
        return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled()) && (!this._rollEnabled || this._mouseRoll.isEnabled());
    }
    isActive() {
        return this._mouseRotate.isActive() || this._mousePitch.isActive() || this._mouseRoll.isActive();
    }
}, $4324d99ae8520741$export$69d5f25840cce15f = class {
    constructor(e1, t, n, r){
        this._el = e1, this._touchZoom = t, this._touchRotate = n, this._tapDragZoom = r, this._rotationDisabled = !1, this._enabled = !0;
    }
    enable(e1) {
        this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoom.enable(), this._el.classList.add(`maplibregl-touch-zoom-rotate`);
    }
    disable() {
        this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove(`maplibregl-touch-zoom-rotate`);
    }
    isEnabled() {
        return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
    }
    isActive() {
        return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
    }
    setZoomRate(e1) {
        this._touchZoom.setZoomRate(e1), this._tapDragZoom.setZoomRate(e1);
    }
    setZoomThreshold(e1) {
        this._touchZoom.setZoomThreshold(e1);
    }
    disableRotation() {
        this._rotationDisabled = !0, this._touchRotate.disable();
    }
    enableRotation() {
        this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
    }
}, $4324d99ae8520741$export$eba3588e2069a729 = class {
    constructor(e1, t){
        this._bypassKey = navigator.userAgent.includes(`Mac`) ? `metaKey` : `ctrlKey`, this._map = e1, this._options = t, this._enabled = !1;
    }
    isActive() {
        return !1;
    }
    reset() {}
    _setupUI() {
        if (this._container) return;
        let e1 = this._map.getCanvasContainer();
        e1.classList.add(`maplibregl-cooperative-gestures`), this._container = $4324d99ae8520741$var$G.create(`div`, `maplibregl-cooperative-gesture-screen`, e1);
        let t = this._map._getUIString(`CooperativeGesturesHandler.WindowsHelpText`);
        this._bypassKey === `metaKey` && (t = this._map._getUIString(`CooperativeGesturesHandler.MacHelpText`));
        let n = this._map._getUIString(`CooperativeGesturesHandler.MobileHelpText`), r = document.createElement(`div`);
        r.className = `maplibregl-desktop-message`, r.textContent = t, this._container.appendChild(r);
        let i = document.createElement(`div`);
        i.className = `maplibregl-mobile-message`, i.textContent = n, this._container.appendChild(i), this._container.setAttribute(`aria-hidden`, `true`);
    }
    _destroyUI() {
        this._container && (this._container.remove(), this._map.getCanvasContainer().classList.remove(`maplibregl-cooperative-gestures`)), delete this._container;
    }
    enable() {
        this._setupUI(), this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this._destroyUI();
    }
    isEnabled() {
        return this._enabled;
    }
    isBypassed(e1) {
        return e1[this._bypassKey];
    }
    notifyGestureBlocked(e1, t) {
        this._enabled && (this._map.fire(new $4324d99ae8520741$export$fc21b96c04d10d16(`cooperativegestureprevented`, {
            gestureType: e1,
            originalEvent: t
        })), this._container.classList.add(`maplibregl-show`), setTimeout(()=>{
            this._container.classList.remove(`maplibregl-show`);
        }, 100));
    }
}, $4324d99ae8520741$var$lm = class {
    constructor(e1){
        this._camera = e1;
    }
    get transform() {
        return this._camera._requestedCameraState || this._camera.transform;
    }
    get center() {
        return {
            lng: this.transform.center.lng,
            lat: this.transform.center.lat
        };
    }
    get zoom() {
        return this.transform.zoom;
    }
    get pitch() {
        return this.transform.pitch;
    }
    get bearing() {
        return this.transform.bearing;
    }
    unproject(e1) {
        return this.transform.screenPointToLocation((0, $1G0Uw.Li).convert(e1), this._camera.terrain);
    }
};
const $4324d99ae8520741$var$um = (e1)=>e1.zoom || e1.drag || e1.roll || e1.pitch || e1.rotate;
var $4324d99ae8520741$var$dm = class extends (0, $1G0Uw._n) {
};
function $4324d99ae8520741$var$fm(e1) {
    return e1.panDelta?.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta || e1.rollDelta;
}
var $4324d99ae8520741$var$pm = class {
    get _ownerDocument() {
        return this._el?.ownerDocument || document;
    }
    get _ownerWindow() {
        return this._el?.ownerDocument?.defaultView || window;
    }
    constructor(e1, t, n){
        this._terrainGestureAnchorElevation = null, this.handleWindowEvent = (e1)=>{
            this.handleEvent(e1, `${e1.type}Window`);
        }, this.handleEvent = (e1, t)=>{
            if (e1.type === `blur`) {
                this.stop(!0);
                return;
            }
            this._updatingCamera = !0;
            let n = e1.type === `renderFrame` ? void 0 : e1, r = {
                needsRenderFrame: !1
            }, i = {}, a = {};
            for (let { handlerName: o, handler: s, allowed: c } of this._handlers){
                if (!s.isEnabled()) continue;
                let l;
                if (this._blockedByActive(a, c, o)) s.reset();
                else if (s[t || e1.type]) {
                    if ((0, $1G0Uw.lr)(e1, t || e1.type)) {
                        let n = $4324d99ae8520741$var$G.mousePos(this._map.getCanvas(), e1);
                        l = s[t || e1.type](e1, n);
                    } else if ((0, $1G0Uw.dr)(e1, t || e1.type)) {
                        let n = e1.touches, r = this._getMapTouches(n), i = $4324d99ae8520741$var$G.touchPos(this._map.getCanvas(), r);
                        l = s[t || e1.type](e1, i, r);
                    } else (0, $1G0Uw.fr)(t || e1.type) || (l = s[t || e1.type](e1));
                    this.mergeHandlerResult(r, i, l, o, n), l?.needsRenderFrame && this._triggerRenderFrame();
                }
                (l || s.isActive()) && (a[o] = s);
            }
            let o = {};
            for(let e1 in this._previousActiveHandlers)a[e1] || (o[e1] = n);
            this._previousActiveHandlers = a, (Object.keys(o).length || $4324d99ae8520741$var$fm(r)) && (this._changes.push([
                r,
                i,
                o
            ]), this._triggerRenderFrame()), (Object.keys(a).length || $4324d99ae8520741$var$fm(r)) && this._camera.stop(!0), this._updatingCamera = !1;
            let { cameraAnimation: s } = r;
            s && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], s(this._map));
        }, this._map = e1, this._camera = t, this._transformProvider = new $4324d99ae8520741$var$lm(this._camera), this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new $4324d99ae8520741$var$yp(e1), this._bearingSnap = n.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(n);
        let r = this._el;
        this._listeners = [
            [
                r,
                `touchstart`,
                {
                    passive: !0
                }
            ],
            [
                r,
                `touchmove`,
                {
                    passive: !1
                }
            ],
            [
                r,
                `touchend`,
                void 0
            ],
            [
                r,
                `touchcancel`,
                void 0
            ],
            [
                r,
                `mousedown`,
                void 0
            ],
            [
                r,
                `mousemove`,
                void 0
            ],
            [
                r,
                `mouseup`,
                void 0
            ],
            [
                this._ownerDocument,
                `mousemove`,
                {
                    capture: !0
                }
            ],
            [
                this._ownerDocument,
                `mouseup`,
                void 0
            ],
            [
                r,
                `mouseover`,
                void 0
            ],
            [
                r,
                `mouseout`,
                void 0
            ],
            [
                r,
                `dblclick`,
                void 0
            ],
            [
                r,
                `click`,
                void 0
            ],
            [
                r,
                `keydown`,
                {
                    capture: !1
                }
            ],
            [
                r,
                `keyup`,
                void 0
            ],
            [
                r,
                `wheel`,
                {
                    passive: !1
                }
            ],
            [
                r,
                `contextmenu`,
                void 0
            ],
            [
                this._ownerWindow,
                `blur`,
                void 0
            ]
        ];
        for (let [e1, t, n] of this._listeners)e1.addEventListener(t, e1 === this._ownerDocument ? this.handleWindowEvent : this.handleEvent, n);
    }
    destroy() {
        for (let [e1, t, n] of this._listeners)e1.removeEventListener(t, e1 === this._ownerDocument ? this.handleWindowEvent : this.handleEvent, n);
    }
    _addDefaultHandlers(e1) {
        let t = this._map, n = t.getCanvasContainer();
        this._add(`mapEvent`, new $4324d99ae8520741$var$Sp(t, e1));
        let r = t.boxZoom = new $4324d99ae8520741$export$bd01c6f06175f3af(t, e1, this._transformProvider);
        this._add(`boxZoom`, r), e1.interactive && e1.boxZoom && r.enable();
        let i = t.cooperativeGestures = new $4324d99ae8520741$export$eba3588e2069a729(t, e1.cooperativeGestures);
        this._add(`cooperativeGestures`, i), e1.cooperativeGestures && i.enable();
        let a = new $4324d99ae8520741$var$kp(t, this._transformProvider), o = new $4324d99ae8520741$var$rm(t, this._transformProvider);
        t.doubleClickZoom = new $4324d99ae8520741$export$939799190379133f(o, a), this._add(`tapZoom`, a), this._add(`clickZoom`, o), e1.interactive && e1.doubleClickZoom && t.doubleClickZoom.enable();
        let s = new $4324d99ae8520741$var$im;
        this._add(`tapDragZoom`, s);
        let c = t.touchPitch = new $4324d99ae8520741$export$7ea266bd3010ae2a(t);
        this._add(`touchPitch`, c), e1.interactive && e1.touchPitch && t.touchPitch.enable(e1.touchPitch);
        let l = ()=>t.project(t.getCenter()), u = $4324d99ae8520741$var$Rp(e1, l), d = $4324d99ae8520741$var$zp(e1), f = $4324d99ae8520741$var$Bp(e1, l);
        t.dragRotate = new $4324d99ae8520741$export$fc9ed7efe29ccb64(e1, u, d, f), this._add(`mouseRotate`, u, [
            `mousePitch`
        ]), this._add(`mousePitch`, d, [
            `mouseRotate`,
            `mouseRoll`
        ]), this._add(`mouseRoll`, f, [
            `mousePitch`
        ]), e1.interactive && e1.dragRotate && t.dragRotate.enable();
        let p = $4324d99ae8520741$var$Lp(e1), m = new $4324d99ae8520741$var$Vp(e1, t);
        t.dragPan = new $4324d99ae8520741$export$69c4612f5624c3f0(n, p, m), this._add(`mousePan`, p), this._add(`touchPan`, m, [
            `touchZoom`,
            `touchRotate`
        ]), e1.interactive && e1.dragPan && t.dragPan.enable(e1.dragPan);
        let h = new $4324d99ae8520741$export$6966aa20d1b4577f, g = new $4324d99ae8520741$export$db37e9f00445aa54;
        t.touchZoomRotate = new $4324d99ae8520741$export$69d5f25840cce15f(n, g, h, s), this._add(`touchRotate`, h, [
            `touchPan`,
            `touchZoom`
        ]), this._add(`touchZoom`, g, [
            `touchPan`,
            `touchRotate`
        ]), e1.interactive && e1.touchZoomRotate && t.touchZoomRotate.enable(e1.touchZoomRotate), this._add(`blockableMapEvent`, new $4324d99ae8520741$var$Cp(t));
        let _ = t.scrollZoom = new $4324d99ae8520741$export$fd7a47efd2367414(t, ()=>this._triggerRenderFrame(), this._transformProvider);
        this._add(`scrollZoom`, _, [
            `mousePan`
        ]), e1.interactive && e1.scrollZoom && t.scrollZoom.enable(e1.scrollZoom);
        let v = t.keyboard = new $4324d99ae8520741$export$474b8119f9aaf6a9(t, this._transformProvider);
        this._add(`keyboard`, v), e1.interactive && e1.keyboard && t.keyboard.enable();
    }
    _add(e1, t, n) {
        this._handlers.push({
            handlerName: e1,
            handler: t,
            allowed: n
        }), this._handlersById[e1] = t;
    }
    stop(e1) {
        if (!this._updatingCamera) {
            for (let { handler: e1 } of this._handlers)e1.reset();
            this._inertia.clear(), this._fireEvents({}, {}, e1), this._changes = [];
        }
    }
    isActive() {
        for (let { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
        return !1;
    }
    isZooming() {
        return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
    }
    isRotating() {
        return !!this._eventsInProgress.rotate;
    }
    isMoving() {
        return !!$4324d99ae8520741$var$um(this._eventsInProgress) || this.isZooming();
    }
    _blockedByActive(e1, t, n) {
        for(let r in e1)if (r !== n && !t?.includes(r)) return !0;
        return !1;
    }
    _getMapTouches(e1) {
        let t = [];
        for (let n of e1){
            let e1 = n.target;
            this._el.contains(e1) && t.push(n);
        }
        return t;
    }
    mergeHandlerResult(e1, t, n, r, i) {
        if (!n) return;
        (0, $1G0Uw.er)(e1, n);
        let a = {
            handlerName: r,
            originalEvent: n.originalEvent || i
        };
        n.zoomDelta !== void 0 && (t.zoom = a), n.panDelta !== void 0 && (t.drag = a), n.rollDelta !== void 0 && (t.roll = a), n.pitchDelta !== void 0 && (t.pitch = a), n.bearingDelta !== void 0 && (t.rotate = a);
    }
    _applyChanges() {
        let e1 = {}, t = {}, n = {};
        for (let [r, i, a] of this._changes)r.panDelta && (e1.panDelta = (e1.panDelta || new (0, $1G0Uw.Li)(0, 0))._add(r.panDelta)), r.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + r.pitchDelta), r.rollDelta && (e1.rollDelta = (e1.rollDelta || 0) + r.rollDelta), r.around !== void 0 && (e1.around = r.around), r.pinchAround !== void 0 && (e1.pinchAround = r.pinchAround), r.noInertia && (e1.noInertia = r.noInertia), (0, $1G0Uw.er)(t, i), (0, $1G0Uw.er)(n, a);
        this._updateMapTransform(e1, t, n), this._changes = [];
    }
    _updateMapTransform(e1, t, n) {
        let r = this._map, i = this._camera.getTransformForUpdate(), a = r.terrain;
        if (!$4324d99ae8520741$var$fm(e1) && !(a && this._terrainMovement)) {
            this._fireEvents(t, n, !0);
            return;
        }
        this._camera.stop(!0);
        let { panDelta: o, zoomDelta: s, bearingDelta: c, pitchDelta: l, rollDelta: u } = e1, { around: d, aroundOnSurface: f } = this._resolveAround(e1, a, i), p = a ? this._terrainGestureElevation(a, d, f, i, t) : void 0, m = {
            panDelta: o,
            zoomDelta: s,
            rollDelta: u,
            pitchDelta: l,
            bearingDelta: c,
            around: d,
            aroundElevation: p
        };
        this._camera.cameraHelper.useGlobeControls && !i.isPointOnMapSurface(d) && (d = i.centerPoint);
        let h = this._computePreZoomAroundLoc(i, d, o, p);
        this._handleMapControls({
            terrain: a,
            tr: i,
            deltasForHelper: m,
            preZoomAroundLoc: h,
            combinedEventsInProgress: t,
            panDelta: o
        }), this._camera.applyUpdatedTransform(i), this._map._update(), e1.noInertia || this._inertia.record(e1), this._fireEvents(t, n, !0);
    }
    _resolveAround(e1, t, n) {
        let r = e1.pinchAround === void 0 ? e1.around : e1.pinchAround;
        return r ||= this._camera.transform.centerPoint, t && !n.isPointOnMapSurface(r) ? {
            around: n.centerPoint,
            aroundOnSurface: !1
        } : {
            around: r,
            aroundOnSurface: !0
        };
    }
    _terrainGestureElevation(e1, t, n, r, i) {
        if (!n) return;
        if (!this._terrainMovement && (i.drag || i.zoom)) {
            let n = r.screenTerrainPointToMercatorCoordinate(t, e1);
            this._terrainGestureAnchorElevation = n ? n.z : null;
        }
        if (this._terrainGestureAnchorElevation === null) return;
        let a = this._terrainGestureAnchorElevation;
        if (!(t.distSqr(r.centerPoint) < .01) && !(a - r.elevation >= .9 * (r.getCameraAltitude() - r.elevation))) return a;
    }
    _computePreZoomAroundLoc(e1, t, n, r) {
        if (t.distSqr(e1.centerPoint) < .01) return e1.center;
        let i = n ? t.sub(n) : t;
        return r === void 0 ? e1.screenPointToLocation(i) : e1.screenPointToLocationAtElevation(i, r);
    }
    _handleMapControls({ terrain: e1, tr: t, deltasForHelper: n, preZoomAroundLoc: r, combinedEventsInProgress: i, panDelta: a }) {
        let o = this._camera.cameraHelper;
        if (o.handleMapControlsRollPitchBearingZoom(n, t), !e1) {
            o.handleMapControlsPan(n, t, r);
            return;
        }
        if (o.useGlobeControls) {
            !this._terrainMovement && (i.drag || i.zoom) && (this._terrainMovement = !0, this._camera.elevationFreeze = !0), o.handleMapControlsPan(n, t, r);
            return;
        }
        if (!this._terrainMovement && (i.drag || i.zoom)) {
            this._terrainMovement = !0, this._camera.elevationFreeze = !0, o.handleMapControlsPan(n, t, r);
            return;
        }
        if (n.aroundElevation === void 0 && i.drag && this._terrainMovement && a) {
            t.setCenter(t.screenPointToLocation(t.centerPoint.sub(a)));
            return;
        }
        o.handleMapControlsPan(n, t, r);
    }
    _fireEvents(e1, t, n) {
        let r = $4324d99ae8520741$var$um(this._eventsInProgress), i = $4324d99ae8520741$var$um(e1), a = {};
        for(let t in e1){
            let { originalEvent: n } = e1[t];
            this._eventsInProgress[t] || (a[`${t}start`] = n), this._eventsInProgress[t] = e1[t];
        }
        !r && i && this._fireEvent(`movestart`, i.originalEvent);
        for(let e1 in a)this._fireEvent(e1, a[e1]);
        i && this._fireEvent(`move`, i.originalEvent);
        for(let t in e1){
            let { originalEvent: n } = e1[t];
            this._fireEvent(t, n);
        }
        let o = {}, s;
        for(let e1 in this._eventsInProgress){
            let { handlerName: n, originalEvent: r } = this._eventsInProgress[e1];
            this._handlersById[n].isActive() || (delete this._eventsInProgress[e1], s = t[n] || r, o[`${e1}end`] = s);
        }
        for(let e1 in o)this._fireEvent(e1, o[e1]);
        let c = $4324d99ae8520741$var$um(this._eventsInProgress), l = (r || i) && !c;
        if (l && this._terrainMovement) {
            this._camera.elevationFreeze = !1, this._terrainMovement = !1, this._terrainGestureAnchorElevation = null;
            let e1 = this._camera.getTransformForUpdate();
            this._map.getCenterClampedToGround() && e1.recalculateZoomAndCenter(this._map.terrain), this._camera.applyUpdatedTransform(e1);
        }
        if (n && l) {
            this._updatingCamera = !0;
            let e1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), t = (e1)=>e1 !== 0 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
            e1 && (e1.essential || !$4324d99ae8520741$var$Rr.prefersReducedMotion) ? (t(e1.bearing || this._map.getBearing()) && (e1.bearing = 0), e1.freezeElevation = !0, this._map.easeTo(e1, {
                originalEvent: s
            })) : (this._map.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`moveend`, {
                originalEvent: s
            })), t(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
        }
    }
    _fireEvent(e1, t) {
        this._map.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(e1, t ? {
            originalEvent: t
        } : {}));
    }
    _requestFrame() {
        return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
            delete this._frameId, this.handleEvent(new $4324d99ae8520741$var$dm(`renderFrame`, {
                timeStamp: e1
            })), this._applyChanges();
        });
    }
    _triggerRenderFrame() {
        this._frameId === void 0 && (this._frameId = this._requestFrame());
    }
}, $4324d99ae8520741$var$mm = class extends (0, $1G0Uw.vn) {
    constructor(e1){
        super(), this._renderFrameCallback = ()=>{
            let e1 = Math.min(($4324d99ae8520741$export$461939dd4422153() - this._easeStart) / this._easeOptions.duration, 1);
            this._onEaseFrame(this._easeOptions.easing(e1)), e1 < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
        }, this.transform = new $4324d99ae8520741$var$Sc, this.cameraHelper = new $4324d99ae8520741$var$Oc, e1.minZoom !== void 0 && this.transform.setMinZoom(e1.minZoom), e1.maxZoom !== void 0 && this.transform.setMaxZoom(e1.maxZoom), e1.minPitch !== void 0 && this.transform.setMinPitch(e1.minPitch), e1.maxPitch !== void 0 && this.transform.setMaxPitch(e1.maxPitch), e1.renderWorldCopies !== void 0 && this.transform.setRenderWorldCopies(e1.renderWorldCopies), e1.transformConstrain !== null && this.transform.setConstrainOverride(e1.transformConstrain), this._moving = !1, this._zooming = !1, this._bearingSnap = e1.bearingSnap, this._zoomSnap = e1.zoomSnap, this._requestRenderFrame = e1.requestRenderFrame, this._cancelRenderFrame = e1.cancelRenderFrame, this.terrain = e1.terrain, this._centerClampedToGround = e1.centerClampedToGround ?? !0, this.transformCameraUpdate = e1.transformCameraUpdate ?? null, this._stopHandlers = e1.stopHandlers ?? (()=>{}), this.on(`moveend`, ()=>{
            delete this._requestedCameraState;
        });
    }
    migrateProjection(e1, t) {
        if (e1.apply(this.transform, !0), this.transform = e1, this.cameraHelper = t, this._requestedCameraState) {
            let t = e1.clone();
            t.apply(this._requestedCameraState, !0), this._requestedCameraState = t;
        }
    }
    getCenter() {
        return new (0, $1G0Uw.lt)(this.transform.center.lng, this.transform.center.lat);
    }
    setCenter(e1, t) {
        return this.jumpTo({
            center: e1
        }, t);
    }
    getCenterElevation() {
        return this.transform.elevation;
    }
    setCenterElevation(e1, t) {
        return this.jumpTo({
            elevation: e1
        }, t), this;
    }
    getCenterClampedToGround() {
        return this._centerClampedToGround;
    }
    setCenterClampedToGround(e1) {
        this._centerClampedToGround = e1;
    }
    panBy(e1, t, n) {
        return e1 = (0, $1G0Uw.Li).convert(e1).mult(-1), this.panTo(this.transform.center, (0, $1G0Uw.er)({
            offset: e1
        }, t), n);
    }
    panTo(e1, t, n) {
        return this.easeTo((0, $1G0Uw.er)({
            center: e1
        }, t), n);
    }
    getZoom() {
        return this.transform.zoom;
    }
    setZoom(e1, t) {
        return this.jumpTo({
            zoom: e1
        }, t), this;
    }
    zoomTo(e1, t, n) {
        return this.easeTo((0, $1G0Uw.er)({
            zoom: e1
        }, t), n);
    }
    zoomIn(e1, n) {
        return this.zoomTo((0, $1G0Uw.$n)(this.getZoom() + 1, this._zoomSnap), e1, n), this;
    }
    zoomOut(e1, n) {
        return this.zoomTo((0, $1G0Uw.$n)(this.getZoom() - 1, this._zoomSnap), e1, n), this;
    }
    getVerticalFieldOfView() {
        return this.transform.fov;
    }
    setVerticalFieldOfView(e1, t) {
        return e1 != this.transform.fov && (this.transform.setFov(e1), this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`movestart`, t)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`move`, t)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`moveend`, t))), this;
    }
    getBearing() {
        return this.transform.bearing;
    }
    setZoomSnap(e1) {
        return this._zoomSnap = e1, this;
    }
    getZoomSnap() {
        return this._zoomSnap;
    }
    setBearing(e1, t) {
        return this.jumpTo({
            bearing: e1
        }, t), this;
    }
    getPadding() {
        return this.transform.padding;
    }
    setPadding(e1, t) {
        return this.jumpTo({
            padding: e1
        }, t), this;
    }
    rotateTo(e1, t, n) {
        return this.easeTo((0, $1G0Uw.er)({
            bearing: e1
        }, t), n);
    }
    resetNorth(e1, t) {
        return this.rotateTo(0, (0, $1G0Uw.er)({
            duration: 1e3
        }, e1), t), this;
    }
    resetNorthPitch(e1, t) {
        return this.easeTo((0, $1G0Uw.er)({
            bearing: 0,
            pitch: 0,
            roll: 0,
            duration: 1e3
        }, e1), t), this;
    }
    snapToNorth(e1, t) {
        return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t) : this;
    }
    getPitch() {
        return this.transform.pitch;
    }
    setPitch(e1, t) {
        return this.jumpTo({
            pitch: e1
        }, t), this;
    }
    getRoll() {
        return this.transform.roll;
    }
    setRoll(e1, t) {
        return this.jumpTo({
            roll: e1
        }, t), this;
    }
    cameraForBounds(e1, t) {
        e1 = $4324d99ae8520741$export$266d2884f61535d3.convert(e1).adjustAntiMeridian();
        let n = t?.bearing || 0;
        return this._cameraForBoxAndBearing(e1.getNorthWest(), e1.getSouthEast(), n, t);
    }
    _cameraForBoxAndBearing(e1, n, r, i) {
        let a = {
            top: 0,
            bottom: 0,
            right: 0,
            left: 0
        };
        if (i = (0, $1G0Uw.er)({
            padding: a,
            offset: [
                0,
                0
            ],
            maxZoom: this.transform.maxZoom
        }, i), typeof i.padding == `number`) {
            let e1 = i.padding;
            i.padding = {
                top: e1,
                bottom: e1,
                right: e1,
                left: e1
            };
        }
        let o = (0, $1G0Uw.er)(a, i.padding);
        i.padding = o;
        let s = this.transform, c = new $4324d99ae8520741$export$266d2884f61535d3(e1, n), l = this.cameraHelper.cameraForBoxAndBearing(i, o, c, r, s);
        return l && this._zoomSnap && (l.zoom = (0, $1G0Uw.$n)(l.zoom, this._zoomSnap, -1)), l;
    }
    fitBounds(e1, t, n) {
        return this._fitInternal(this.cameraForBounds(e1, t), t, n);
    }
    fitScreenCoordinates(e1, t, n, r, i) {
        return this._fitInternal(this._cameraForBoxAndBearing(this.transform.screenPointToLocation((0, $1G0Uw.Li).convert(e1)), this.transform.screenPointToLocation((0, $1G0Uw.Li).convert(t)), n, r), r, i);
    }
    _fitInternal(e1, t, n) {
        return e1 ? (t = (0, $1G0Uw.er)(e1, t), delete t.padding, t.linear ? this.easeTo(t, n) : this.flyTo(t, n)) : this;
    }
    jumpTo(e1, n) {
        this.stop(), e1.zoom !== void 0 && this._zoomSnap && (e1.zoom = (0, $1G0Uw.$n)(e1.zoom, this._zoomSnap));
        let r = this.getTransformForUpdate(), i = !1, a = !1, o = !1, s = r.zoom;
        this.terrain && r.setElevation(this.terrain.getElevationForLngLat(e1.center ? (0, $1G0Uw.lt).convert(e1.center) : r.center, r)), this.cameraHelper.handleJumpToCenterZoom(r, e1);
        let c = r.zoom !== s;
        return e1.elevation !== void 0 && r.elevation !== +e1.elevation && r.setElevation(+e1.elevation), e1.bearing !== void 0 && r.bearing !== +e1.bearing && (i = !0, r.setBearing(+e1.bearing)), e1.pitch !== void 0 && r.pitch !== +e1.pitch && (a = !0, r.setPitch(+e1.pitch)), e1.roll !== void 0 && r.roll !== +e1.roll && (o = !0, r.setRoll(+e1.roll)), e1.padding != null && !r.isPaddingEqual(e1.padding) && r.setPadding(e1.padding), this.applyUpdatedTransform(r), this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`movestart`, n)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`move`, n)), c && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`zoomstart`, n)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`zoom`, n)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`zoomend`, n)), i && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`rotatestart`, n)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`rotate`, n)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`rotateend`, n)), a && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`pitchstart`, n)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`pitch`, n)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`pitchend`, n)), o && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`rollstart`, n)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`roll`, n)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`rollend`, n)), this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`moveend`, n));
    }
    calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, n, r, i) {
        let a = this.transform.calculateCenterFromCameraLngLatAlt(e1, t, n, r);
        return {
            center: a.center,
            elevation: a.elevation,
            zoom: a.zoom,
            bearing: n,
            pitch: r,
            roll: i
        };
    }
    easeTo(e1, n) {
        this._stop(!1, e1.easeId), e1 = (0, $1G0Uw.er)({
            offset: [
                0,
                0
            ],
            duration: 500,
            easing: (0, $1G0Uw.Jn)
        }, e1), e1.zoom !== void 0 && this._zoomSnap && (e1.zoom = (0, $1G0Uw.$n)(e1.zoom, this._zoomSnap)), (e1.animate === !1 || !e1.essential && $4324d99ae8520741$var$Rr.prefersReducedMotion) && (e1.duration = 0);
        let r = this.getTransformForUpdate(), i = this.getBearing(), a = r.pitch, o = r.roll, s = e1.bearing === void 0 ? i : this._normalizeBearing(e1.bearing, i), c = e1.pitch === void 0 ? a : +e1.pitch, l = e1.roll === void 0 ? o : this._normalizeBearing(e1.roll, o), u = e1.padding === void 0 ? r.padding : e1.padding, d = (0, $1G0Uw.Li).convert(e1.offset), f, p;
        e1.around && (f = (0, $1G0Uw.lt).convert(e1.around), p = r.locationToScreenPoint(f));
        let m = {
            moving: this._moving,
            zooming: this._zooming,
            rotating: this._rotating,
            pitching: this._pitching,
            rolling: this._rolling
        }, h = this.cameraHelper.handleEaseTo(r, {
            bearing: s,
            pitch: c,
            roll: l,
            padding: u,
            around: f,
            aroundPoint: p,
            offsetAsPoint: d,
            offset: e1.offset,
            zoom: e1.zoom,
            center: e1.center
        });
        return this._rotating ||= i !== s, this._pitching ||= c !== a, this._rolling ||= l !== o, this._padding = !r.isPaddingEqual(u), this._zooming ||= h.isZooming, this._easeId = e1.easeId, this._prepareEase(n, e1.noMoveStart, m), this.terrain && this._prepareElevation(h.elevationCenter), this._ease((t)=>{
            h.easeFunc(t), this.terrain && !e1.freezeElevation && this._updateElevation(t), this.applyUpdatedTransform(r), this._fireMoveEvents(n);
        }, (t)=>{
            this.terrain && e1.freezeElevation && this._finalizeElevation(), this._afterEase(n, t);
        }, e1), this;
    }
    _prepareEase(e1, t, n = {}) {
        this._moving = !0, !t && !n.moving && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`movestart`, e1)), this._zooming && !n.zooming && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`zoomstart`, e1)), this._rotating && !n.rotating && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`rotatestart`, e1)), this._pitching && !n.pitching && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`pitchstart`, e1)), this._rolling && !n.rolling && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`rollstart`, e1));
    }
    _prepareElevation(e1) {
        this._elevationCenter = e1, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLat(e1, this.transform), this.elevationFreeze = !0;
    }
    _updateElevation(e1) {
        (this._elevationStart === void 0 || this._elevationCenter === void 0) && this._prepareElevation(this.transform.center), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom));
        let t = this.terrain.getElevationForLngLat(this._elevationCenter, this.transform);
        if (e1 < 1 && t !== this._elevationTarget) {
            let n = this._elevationTarget - this._elevationStart, r = (t - (n * e1 + this._elevationStart)) / (1 - e1);
            this._elevationStart += e1 * (n - r), this._elevationTarget = t;
        }
        this.transform.setElevation((0, $1G0Uw.un).number(this._elevationStart, this._elevationTarget, e1));
    }
    _finalizeElevation() {
        this.elevationFreeze = !1, this.getCenterClampedToGround() && this.transform.recalculateZoomAndCenter(this.terrain);
    }
    getTransformForUpdate() {
        return !this.transformCameraUpdate && !this.terrain ? this.transform : (this._requestedCameraState ||= this.transform.clone(), this._requestedCameraState);
    }
    _elevateCameraIfInsideTerrain(e1) {
        if (!this.terrain && e1.elevation >= 0 && e1.pitch <= 90) return {};
        let t = e1.getCameraLngLat(), n = e1.getCameraAltitude(), r = this.terrain ? this.terrain.getElevationForLngLatZoom(t, e1.zoom) : 0;
        if (n < r) {
            let n = e1.calculateCameraOptionsFromTo(t, r, e1.center, e1.elevation);
            return {
                pitch: n.pitch,
                zoom: n.zoom
            };
        }
        return {};
    }
    applyUpdatedTransform(e1) {
        let t = [];
        if (t.push((e1)=>this._elevateCameraIfInsideTerrain(e1)), this.transformCameraUpdate && t.push((e1)=>this.transformCameraUpdate(e1)), !t.length) return;
        let n = e1.clone();
        for (let e1 of t){
            let t = n.clone(), { center: r, zoom: i, roll: a, pitch: o, bearing: s, elevation: c } = e1(t);
            r && t.setCenter(r), c !== void 0 && t.setElevation(c), i !== void 0 && t.setZoom(i), a !== void 0 && t.setRoll(a), o !== void 0 && t.setPitch(o), s !== void 0 && t.setBearing(s), n.apply(t, !1);
        }
        this.transform.apply(n, !1);
    }
    _fireMoveEvents(e1) {
        this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`move`, e1)), this._zooming && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`zoom`, e1)), this._rotating && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`rotate`, e1)), this._pitching && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`pitch`, e1)), this._rolling && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`roll`, e1));
    }
    _afterEase(e1, t) {
        if (this._easeId && t && this._easeId === t) return;
        delete this._easeId;
        let n = this._zooming, r = this._rotating, i = this._pitching, a = this._rolling;
        this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._rolling = !1, this._padding = !1, n && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`zoomend`, e1)), r && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`rotateend`, e1)), i && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`pitchend`, e1)), a && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`rollend`, e1)), this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`moveend`, e1));
    }
    flyTo(e1, n) {
        if (!e1.essential && $4324d99ae8520741$var$Rr.prefersReducedMotion) {
            let t = (0, $1G0Uw.yr)(e1, [
                `center`,
                `zoom`,
                `bearing`,
                `pitch`,
                `roll`,
                `elevation`,
                `padding`
            ]);
            return this.jumpTo(t, n);
        }
        this.stop(), e1 = (0, $1G0Uw.er)({
            offset: [
                0,
                0
            ],
            speed: 1.2,
            curve: 1.42,
            easing: (0, $1G0Uw.Jn)
        }, e1), e1.zoom !== void 0 && this._zoomSnap && (e1.zoom = (0, $1G0Uw.$n)(e1.zoom, this._zoomSnap));
        let r = this.getTransformForUpdate(), i = r.bearing, a = r.pitch, o = r.roll, s = r.padding, c = e1.bearing === void 0 ? i : this._normalizeBearing(e1.bearing, i), l = e1.pitch === void 0 ? a : +e1.pitch, u = e1.roll === void 0 ? o : this._normalizeBearing(e1.roll, o), d = e1.padding === void 0 ? r.padding : e1.padding, f = (0, $1G0Uw.Li).convert(e1.offset), p = r.centerPoint.add(f), m = r.screenPointToLocation(p), h = this.cameraHelper.handleFlyTo(r, {
            bearing: c,
            pitch: l,
            roll: u,
            padding: d,
            locationAtOffset: m,
            offsetAsPoint: f,
            center: e1.center,
            minZoom: e1.minZoom,
            zoom: e1.zoom
        }), g = e1.curve, _ = Math.max(r.width, r.height), v = _ / h.scaleOfZoom, y = h.pixelPathLength, b = _ / h.scaleOfMinZoom;
        g = Math.min(g, Math.sqrt(b / y * 2));
        let x = g * g;
        function S(e1) {
            let t = (v * v - _ * _ + (e1 ? -1 : 1) * x * x * y * y) / (2 * (e1 ? v : _) * x * y);
            return Math.log(Math.sqrt(t * t + 1) - t);
        }
        function C(e1) {
            return (Math.exp(e1) - Math.exp(-e1)) / 2;
        }
        function w(e1) {
            return (Math.exp(e1) + Math.exp(-e1)) / 2;
        }
        function T(e1) {
            return C(e1) / w(e1);
        }
        let E = S(!1), D = function(e1) {
            return w(E) / w(E + g * e1);
        }, O = function(e1) {
            return _ * ((w(E) * T(E + g * e1) - C(E)) / x) / y;
        }, k = (S(!0) - E) / g;
        if (Math.abs(y) < 2e-6 || !isFinite(k)) {
            if (Math.abs(_ - v) < 1e-6) return this.easeTo(e1, n);
            let t = v < _ ? -1 : 1;
            k = Math.abs(Math.log(v / _)) / g, O = ()=>0, D = (e1)=>Math.exp(t * g * e1);
        }
        if (e1.duration !== void 0) e1.duration = +e1.duration;
        else {
            let t = e1.screenSpeed === void 0 ? +e1.speed : +e1.screenSpeed / g;
            e1.duration = 1e3 * k / t;
        }
        return e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = i !== c, this._pitching = l !== a, this._rolling = u !== o, this._padding = !r.isPaddingEqual(d), this._prepareEase(n, !1), this.terrain && this._prepareElevation(h.targetCenter), this._ease((t)=>{
            let m = t * k, g = 1 / D(m), _ = O(m);
            this._rotating && r.setBearing((0, $1G0Uw.un).number(i, c, t)), this._pitching && r.setPitch((0, $1G0Uw.un).number(a, l, t)), this._rolling && r.setRoll((0, $1G0Uw.un).number(o, u, t)), this._padding && (r.interpolatePadding(s, d, t), p = r.centerPoint.add(f)), h.easeFunc(t, g, _, p), this.terrain && !e1.freezeElevation && this._updateElevation(t), this.applyUpdatedTransform(r), this._fireMoveEvents(n);
        }, ()=>{
            this.terrain && e1.freezeElevation && this._finalizeElevation(), this._afterEase(n);
        }, e1), this;
    }
    isEasing() {
        return !!this._easeFrameId;
    }
    stop(e1) {
        return this._stop(e1);
    }
    _stop(e1, t) {
        if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
            let e1 = this._onEaseEnd;
            delete this._onEaseEnd, e1.call(this, t);
        }
        return e1 || this._stopHandlers(), this;
    }
    _ease(e1, t, n) {
        n.animate === !1 || n.duration === 0 ? (e1(1), t()) : (this._easeStart = $4324d99ae8520741$export$461939dd4422153(), this._easeOptions = n, this._onEaseFrame = e1, this._onEaseEnd = t, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
    }
    _normalizeBearing(e1, t) {
        e1 = (0, $1G0Uw.Pr)(e1, -180, 180);
        let n = Math.abs(e1 - t);
        return Math.abs(e1 - 360 - t) < n && (e1 -= 360), Math.abs(e1 + 360 - t) < n && (e1 += 360), e1;
    }
    isMoving() {
        return this._moving;
    }
    isZooming() {
        return this._zooming;
    }
    isRotating() {
        return this._rotating;
    }
};
const $4324d99ae8520741$var$hm = {
    compact: !0,
    customAttribution: `<a href="https://maplibre.org/" target="_blank">MapLibre</a>`
};
var $4324d99ae8520741$export$5af5c3cc9905683 = class {
    constructor(e1 = $4324d99ae8520741$var$hm){
        this._toggleAttribution = ()=>{
            this._container.classList.contains(`maplibregl-compact`) && (this._container.classList.contains(`maplibregl-compact-show`) ? (this._container.setAttribute(`open`, ``), this._container.classList.remove(`maplibregl-compact-show`)) : (this._container.classList.add(`maplibregl-compact-show`), this._container.removeAttribute(`open`)));
        }, this._updateData = (e1)=>{
            e1 && (e1.type === `terrain` || e1.dataType === `style` || e1.dataType === `source` && (e1.sourceDataType === `metadata` || e1.sourceDataType === `visibility`)) && this._updateAttributions();
        }, this._updateCompact = ()=>{
            this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? this._compact === !1 ? this._container.setAttribute(`open`, ``) : !this._container.classList.contains(`maplibregl-compact`) && !this._container.classList.contains(`maplibregl-attrib-empty`) && (this._container.setAttribute(`open`, ``), this._container.classList.add(`maplibregl-compact`, `maplibregl-compact-show`)) : (this._container.setAttribute(`open`, ``), this._container.classList.contains(`maplibregl-compact`) && this._container.classList.remove(`maplibregl-compact`, `maplibregl-compact-show`));
        }, this._updateCompactMinimize = ()=>{
            this._container.classList.contains(`maplibregl-compact`) && this._container.classList.contains(`maplibregl-compact-show`) && this._container.classList.remove(`maplibregl-compact-show`);
        }, this.options = e1;
    }
    getDefaultPosition() {
        return `bottom-right`;
    }
    onAdd(e1) {
        return this._map = e1, this._compact = this.options.compact, this._container = $4324d99ae8520741$var$G.create(`details`, `maplibregl-ctrl maplibregl-ctrl-attrib`), this._compactButton = $4324d99ae8520741$var$G.create(`summary`, `maplibregl-ctrl-attrib-button`, this._container), this._compactButton.addEventListener(`click`, this._toggleAttribution), this._setElementTitle(this._compactButton, `ToggleAttribution`), this._innerContainer = $4324d99ae8520741$var$G.create(`div`, `maplibregl-ctrl-attrib-inner`, this._container), this._updateAttributions(), this._updateCompact(), this._map.on(`styledata`, this._updateData), this._map.on(`sourcedata`, this._updateData), this._map.on(`terrain`, this._updateData), this._map.on(`resize`, this._updateCompact), this._map.on(`drag`, this._updateCompactMinimize), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`styledata`, this._updateData), this._map.off(`sourcedata`, this._updateData), this._map.off(`terrain`, this._updateData), this._map.off(`resize`, this._updateCompact), this._map.off(`drag`, this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
    }
    _setElementTitle(e1, t) {
        let n = this._map._getUIString(`AttributionControl.${t}`);
        e1.title = n, e1.setAttribute(`aria-label`, n);
    }
    _updateAttributions() {
        if (!this._map.style) return;
        let e1 = [];
        if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = e1.concat(this.options.customAttribution.map((e1)=>typeof e1 == `string` ? e1 : ``)) : typeof this.options.customAttribution == `string` && e1.push(this.options.customAttribution)), this._map.style.stylesheet) {
            let e1 = this._map.style.stylesheet;
            this.styleOwner = e1.owner, this.styleId = e1.id;
        }
        let t = this._map.style.tileManagers;
        for(let n in t){
            let r = t[n];
            if (r.used || r.usedForTerrain) {
                let t = r.getSource();
                t.attribution && !e1.includes(t.attribution) && e1.push(t.attribution);
            }
        }
        e1 = e1.filter((e1)=>String(e1).trim()), e1.sort((e1, t)=>e1.length - t.length), e1 = e1.filter((t, n)=>{
            for(let r = n + 1; r < e1.length; r++)if (e1[r].includes(t)) return !1;
            return !0;
        });
        let n = e1.join(` | `);
        n !== this._attribHTML && (this._attribHTML = n, e1.length ? (this._innerContainer.innerHTML = $4324d99ae8520741$var$G.sanitize(n), this._container.classList.remove(`maplibregl-attrib-empty`)) : this._container.classList.add(`maplibregl-attrib-empty`), this._updateCompact(), this._editLink = null);
    }
}, $4324d99ae8520741$export$6941d1bdee1234d4 = class {
    constructor(e1 = {}){
        this._updateCompact = ()=>{
            let e1 = this._container.children;
            if (e1.length) {
                let t = e1[0];
                this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? this._compact !== !1 && t.classList.add(`maplibregl-compact`) : t.classList.remove(`maplibregl-compact`);
            }
        }, this.options = e1;
    }
    getDefaultPosition() {
        return `bottom-left`;
    }
    onAdd(e1) {
        this._map = e1, this._compact = this.options?.compact, this._container = $4324d99ae8520741$var$G.create(`div`, `maplibregl-ctrl`);
        let t = $4324d99ae8520741$var$G.create(`a`, `maplibregl-ctrl-logo`);
        return t.target = `_blank`, t.rel = `noopener nofollow`, t.href = `https://maplibre.org/`, t.setAttribute(`aria-label`, this._map._getUIString(`LogoControl.Title`)), t.setAttribute(`rel`, `noopener nofollow`), this._container.appendChild(t), this._container.style.display = `block`, this._map.on(`resize`, this._updateCompact), this._updateCompact(), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`resize`, this._updateCompact), this._map = void 0, this._compact = void 0;
    }
}, $4324d99ae8520741$var$vm = class {
    constructor(){
        this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
    }
    add(e1) {
        let t = ++this._id;
        return this._queue.push({
            callback: e1,
            id: t,
            cancelled: !1
        }), t;
    }
    remove(e1) {
        let t = this._currentlyRunning, n = t ? this._queue.concat(t) : this._queue;
        for (let t of n)if (t.id === e1) {
            t.cancelled = !0;
            return;
        }
    }
    run(e1 = 0) {
        if (this._currentlyRunning) throw Error(`Attempting to run(), but is already running.`);
        let t = this._currentlyRunning = this._queue;
        this._queue = [];
        let n = !1, r;
        for (let i of t)if (!i.cancelled) {
            try {
                i.callback(e1);
            } catch (e1) {
                n || (n = !0, r = e1);
            }
            if (this._cleared) break;
        }
        if (this._cleared = !1, this._currentlyRunning = !1, n) throw r;
    }
    clear() {
        this._currentlyRunning && (this._cleared = !0), this._queue = [];
    }
};
const $4324d99ae8520741$var$ym = [
    `none`,
    `zoom`,
    `sourceTiles`,
    `visibleLayers`,
    `revision`
];
var $4324d99ae8520741$var$bm = class {
    constructor(e1, t, n, r){
        this._tileKeys = e1.map((e1)=>e1.key).sort().join(), this._revision = t, this._zoom = n, this._visibleLayerIds = r;
    }
    difference(e1) {
        return this._revision === e1?._revision ? this._visibleLayerIds === e1._visibleLayerIds ? this._tileKeys === e1._tileKeys ? this._zoom === e1._zoom ? `none` : `zoom` : `sourceTiles` : `visibleLayers` : `revision`;
    }
};
const $4324d99ae8520741$var$xm = {
    background: !0,
    fill: !0,
    line: !0,
    raster: !0,
    hillshade: !0,
    "color-relief": !0
};
var $4324d99ae8520741$var$Sm = class {
    constructor(e1, t){
        this.needsFollowUpFrame = !1, this.painter = e1, this.terrain = t, this.rttSize = t.tileManager.tileSize * t.qualityFactor;
    }
    getTexture(e1) {
        return e1.getRTT(this._stacks.length - 1).texture;
    }
    prepareForRender(e1, t) {
        let n = t !== this._lastPrepareZoom;
        this._lastPrepareZoom = t, this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.tileManager.getRenderableTiles(), this._renderableLayerIds = e1._order.filter((n)=>!e1._layers[n].isHidden(t));
        let r = this._renderableLayerIds.join(), i = new Set;
        for (let t of this._renderableLayerIds){
            let n = e1._layers[t], r = n.source;
            r && $4324d99ae8520741$var$xm[n.type] && i.add(r);
        }
        this._coordsAscending = {}, this._rttFingerprints = {};
        for (let n of i){
            let i = e1.tileManagers[n];
            if (!i) continue;
            this._coordsAscending[n] = {};
            let a = this._coordsAscending[n], o = i.getSource(), s = o instanceof $4324d99ae8520741$export$280e9a68c3ffd919 ? o.terrainTileRanges : null;
            for (let e1 of i.getVisibleCoordinates()){
                let t = this.terrain.tileManager.getTerrainCoords(e1, s);
                for(let e1 in t)a[e1] ||= [], a[e1].push(t[e1]);
            }
            this._rttFingerprints[n] = {};
            let c = this._rttFingerprints[n], l = i.getState().revision;
            for(let e1 in a)c[e1] = new $4324d99ae8520741$var$bm(a[e1], l, t, r);
        }
        this.needsFollowUpFrame = !1;
        let a = n || this.painter.options.moving, o = !1;
        for (let e1 of this._renderableTiles){
            let t = this._textureDifference(e1);
            t !== `none` && (t === `zoom` && a || t === `visibleLayers` && n ? this.needsFollowUpFrame = !0 : t === `zoom` || t === `sourceTiles` ? (o ? this.needsFollowUpFrame = !0 : e1.releaseRTT(this.painter), o = !0) : e1.releaseRTT(this.painter));
        }
    }
    _textureDifference(e1) {
        let t = `none`;
        for(let n in this._rttFingerprints){
            let r = this._rttFingerprints[n][e1.tileID.key];
            if (!r) continue;
            let i = r.difference(e1.rttFingerprint[n]);
            $4324d99ae8520741$var$ym.indexOf(i) > $4324d99ae8520741$var$ym.indexOf(t) && (t = i);
        }
        return t;
    }
    renderLayer(e1, t) {
        if (e1.isHidden(this.painter.transform.zoom)) return !1;
        let n = {
            ...t,
            isRenderingToTexture: !0
        }, r = e1.type, i = this.painter, a = this._renderableLayerIds[this._renderableLayerIds.length - 1] === e1.id;
        if ($4324d99ae8520741$var$xm[r] && ((!this._prevType || !$4324d99ae8520741$var$xm[this._prevType]) && this._stacks.push([]), this._prevType = r, this._stacks[this._stacks.length - 1].push(e1.id), !a)) return !0;
        if ($4324d99ae8520741$var$xm[this._prevType] || $4324d99ae8520741$var$xm[r] && a) {
            this._prevType = r;
            let e1 = this._stacks.length - 1, t = this._stacks[e1] || [];
            for (let r of this._renderableTiles){
                if (this._rttTiles.push(r), r.getRTT(e1)) continue;
                let a = r.acquireRTT(i, e1, this.rttSize);
                i.bindRTT(a), i.context.clear({
                    color: (0, $1G0Uw.fn).transparent,
                    stencil: 0
                }), i.currentStencilSource = void 0;
                for (let e1 of t){
                    let t = i.style._layers[e1], a = t.source ? this._coordsAscending[t.source][r.tileID.key] : [
                        r.tileID
                    ];
                    i.context.viewport.set([
                        0,
                        0,
                        this.rttSize,
                        this.rttSize
                    ]), i.renderTileClippingMasks(t, a, !0), i.renderLayer(i, i.style.tileManagers[t.source], t, a, n), t.source && (r.rttFingerprint[t.source] = this._rttFingerprints[t.source][r.tileID.key]);
                }
                a.texture.generateMipmap();
            }
            return $4324d99ae8520741$var$np(this.painter, this.terrain, this._rttTiles, n), this._rttTiles = [], $4324d99ae8520741$var$xm[r];
        }
        return !1;
    }
};
const $4324d99ae8520741$var$Cm = {
    "AttributionControl.ToggleAttribution": `Toggle attribution`,
    "AttributionControl.MapFeedback": `Map feedback`,
    "FullscreenControl.Enter": `Enter fullscreen`,
    "FullscreenControl.Exit": `Exit fullscreen`,
    "GeolocateControl.FindMyLocation": `Find my location`,
    "GeolocateControl.LocationNotAvailable": `Location not available`,
    "LogoControl.Title": `MapLibre logo`,
    "Map.Title": `Map`,
    "Marker.Title": `Map marker`,
    "NavigationControl.ResetBearing": `Drag to rotate map, click to reset north`,
    "NavigationControl.ZoomIn": `Zoom in`,
    "NavigationControl.ZoomOut": `Zoom out`,
    "Popup.Close": `Close popup`,
    "ScaleControl.Feet": `ft`,
    "ScaleControl.Meters": `m`,
    "ScaleControl.Kilometers": `km`,
    "ScaleControl.Miles": `mi`,
    "ScaleControl.NauticalMiles": `nm`,
    "GlobeControl.Enable": `Enable globe`,
    "GlobeControl.Disable": `Disable globe`,
    "TerrainControl.Enable": `Enable terrain`,
    "TerrainControl.Disable": `Disable terrain`,
    "CooperativeGesturesHandler.WindowsHelpText": `Use Ctrl + scroll to zoom the map`,
    "CooperativeGesturesHandler.MacHelpText": `Use \u{2318} + scroll to zoom the map`,
    "CooperativeGesturesHandler.MobileHelpText": `Use two fingers to move the map`
}, $4324d99ae8520741$var$wm = $4324d99ae8520741$var$Ar, $4324d99ae8520741$var$Tm = {
    hash: !1,
    interactive: !0,
    bearingSnap: 7,
    zoomSnap: 0,
    attributionControl: $4324d99ae8520741$var$hm,
    maplibreLogo: !1,
    refreshExpiredTiles: !0,
    canvasContextAttributes: {
        antialias: !1,
        preserveDrawingBuffer: !1,
        powerPreference: `high-performance`,
        failIfMajorPerformanceCaveat: !1,
        desynchronized: !1,
        contextType: void 0
    },
    scrollZoom: !0,
    minZoom: -2,
    maxZoom: 22,
    minPitch: 0,
    maxPitch: 60,
    boxZoom: !0,
    dragRotate: !0,
    dragPan: !0,
    keyboard: !0,
    doubleClickZoom: !0,
    touchZoomRotate: !0,
    touchPitch: !0,
    cooperativeGestures: !1,
    trackResize: !0,
    center: [
        0,
        0
    ],
    elevation: 0,
    zoom: 0,
    bearing: 0,
    pitch: 0,
    roll: 0,
    renderWorldCopies: !0,
    maxTileCacheSize: null,
    maxTileCacheZoomLevels: (0, $1G0Uw.An).MAX_TILE_CACHE_ZOOM_LEVELS,
    transformRequest: null,
    transformCameraUpdate: null,
    transformConstrain: null,
    fadeDuration: 300,
    crossSourceCollisions: !0,
    clickTolerance: 3,
    localIdeographFontFamily: `sans-serif`,
    pitchWithRotate: !0,
    rollEnabled: !1,
    rotateSpeed: .8,
    pitchSpeed: -0.5,
    reduceMotion: void 0,
    validateStyle: !0,
    maxCanvasSize: [
        4096,
        4096
    ],
    cancelPendingTileRequestsWhileZooming: !0,
    centerClampedToGround: !0,
    terrainSkirtLength: `auto`,
    zoomLevelsToOverscale: 4,
    anisotropicFilterPitch: 20
};
var $4324d99ae8520741$export$a5c7b93649eaf8f8 = class extends (0, $1G0Uw.vn) {
    get _ownerWindow() {
        return this._container?.ownerDocument?.defaultView || window;
    }
    constructor(e1){
        super(), this._idleTriggered = !1, this._crossFadingFactor = 1, this._renderTaskQueue = new $4324d99ae8520741$var$vm, this._controls = [], this._mapId = (0, $1G0Uw.Mr)(), this._styleUrl = null, this._missingStyleImageResolver = null, this._lostContextStyle = {
            style: null,
            images: null
        }, this._contextLost = (e1)=>{
            if (e1.preventDefault(), this._frameRequest &&= (this._frameRequest.abort(), null), this.painter.destroy(), this._lostContextStyle = this._getStyleAndImages(), !this.style) {
                this.fire(new $4324d99ae8520741$export$3238995171e25bd5(`webglcontextlost`, {
                    originalEvent: e1
                }));
                return;
            }
            for (let e1 of Object.values(this.style._layers))if (e1.type === `custom` && console.warn(`Custom layer with id '${e1.id}' cannot be restored after WebGL context loss. You will need to re-add it manually after context restoration.`), e1._listeners) for (let [t] of Object.entries(e1._listeners))console.warn(`Custom layer with id '${e1.id}' had event listeners for event '${t}' which cannot be restored after WebGL context loss. You will need to re-add them manually after context restoration.`);
            this.style.destroy(), this.style = null, this.fire(new $4324d99ae8520741$export$3238995171e25bd5(`webglcontextlost`, {
                originalEvent: e1
            }));
        }, this._contextRestored = (e1)=>{
            if (this._lostContextStyle.style && this.setStyle(this._lostContextStyle.style, {
                diff: !1
            }), this._lostContextStyle.images && this.style) {
                this.style.imageManager.images = this._lostContextStyle.images;
                for(let e1 in this._lostContextStyle.images){
                    let t = this._lostContextStyle.images[e1];
                    t.isWebGLImage && this.style.imageManager.updateImage(e1, t, !1);
                }
            }
            this._lostContextStyle = {
                style: null,
                images: null
            };
            try {
                this._setupPainter();
            } catch (e1) {
                this.fire(new (0, $1G0Uw.gn)(e1));
                return;
            }
            this.resize(), this._update(), this._resizeInternal(), this.fire(new $4324d99ae8520741$export$3238995171e25bd5(`webglcontextrestored`, {
                originalEvent: e1
            }));
        }, this._onMapScroll = (e1)=>{
            if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
        }, this._onWindowOnline = ()=>{
            this._update();
        };
        let t = {
            ...$4324d99ae8520741$var$Tm,
            ...e1,
            canvasContextAttributes: {
                ...$4324d99ae8520741$var$Tm.canvasContextAttributes,
                ...e1.canvasContextAttributes
            }
        };
        if (t.minZoom != null && t.maxZoom != null && t.minZoom > t.maxZoom) throw Error(`maxZoom must be greater than or equal to minZoom`);
        if (t.minPitch != null && t.maxPitch != null && t.minPitch > t.maxPitch) throw Error(`maxPitch must be greater than or equal to minPitch`);
        if (t.minPitch != null && t.minPitch < 0) throw Error(`minPitch must be greater than or equal to 0`);
        if (t.maxPitch != null && t.maxPitch > 180) throw Error(`maxPitch must be less than or equal to 180`);
        this._camera = new $4324d99ae8520741$var$mm({
            minZoom: t.minZoom,
            maxZoom: t.maxZoom,
            minPitch: t.minPitch,
            maxPitch: t.maxPitch,
            bearingSnap: t.bearingSnap,
            zoomSnap: t.zoomSnap,
            renderWorldCopies: t.renderWorldCopies,
            centerClampedToGround: t.centerClampedToGround,
            terrain: this.terrain,
            transformConstrain: t.transformConstrain,
            requestRenderFrame: (e1)=>this._requestRenderFrame(e1),
            cancelRenderFrame: (e1)=>this._cancelRenderFrame(e1),
            transformCameraUpdate: t.transformCameraUpdate,
            stopHandlers: ()=>this._handlers?.stop(!1)
        }), this._camera.setEventedParent(this), this._interactive = t.interactive, this._maxTileCacheSize = t.maxTileCacheSize, this._maxTileCacheZoomLevels = t.maxTileCacheZoomLevels, this._canvasContextAttributes = {
            ...t.canvasContextAttributes
        }, this._trackResize = t.trackResize === !0, this._terrainSkirtLength = t.terrainSkirtLength, this._refreshExpiredTiles = t.refreshExpiredTiles === !0, this._fadeDuration = t.fadeDuration, this._crossSourceCollisions = t.crossSourceCollisions === !0, this._collectResourceTiming = t.collectResourceTiming === !0, this._locale = {
            ...$4324d99ae8520741$var$Cm,
            ...t.locale
        }, this._clickTolerance = t.clickTolerance, this._overridePixelRatio = t.pixelRatio, this._maxCanvasSize = t.maxCanvasSize, this._zoomLevelsToOverscale = t.zoomLevelsToOverscale, this.cancelPendingTileRequestsWhileZooming = t.cancelPendingTileRequestsWhileZooming === !0, this.setAnisotropicFilterPitch(t.anisotropicFilterPitch), t.reduceMotion !== void 0 && ($4324d99ae8520741$var$Rr.prefersReducedMotion = t.reduceMotion), this._requestManager = new $4324d99ae8520741$var$Wr(t.transformRequest), this._container = this._resolveContainer(t.container), t.maxBounds && this.setMaxBounds(t.maxBounds), this._setupContainer();
        try {
            this._setupPainter();
        } catch (e1) {
            throw this._cleanupContainer(), e1;
        }
        this._imageQueueHandle = $4324d99ae8520741$var$Ur.addThrottleControl(()=>this.isMoving()), this.on(`move`, ()=>this._update(!1)), this.on(`moveend`, ()=>this._update(!1)), this.on(`zoom`, ()=>this._update(!0)), this.on(`terrain`, ()=>{
            this.painter.markTerrainDepthDirty(), this._update(!0);
        }), this.once(`idle`, ()=>this._idleTriggered = !0), this._handlers = new $4324d99ae8520741$var$pm(this, this._camera, t), typeof window < `u` && (this._ownerWindow.addEventListener(`online`, this._onWindowOnline, !1), this._setupResizeObserver());
        let n = typeof t.hash == `string` && t.hash || void 0;
        this._hash = t.hash ? new $4324d99ae8520741$export$ab85ecd77ce6a5cd(n).addTo(this) : void 0, this._hash?._onHashChange() || (this.jumpTo({
            center: t.center,
            elevation: t.elevation,
            zoom: t.zoom,
            bearing: t.bearing,
            pitch: t.pitch,
            roll: t.roll
        }), t.bounds && (this.resize(), this.fitBounds(t.bounds, (0, $1G0Uw.er)({}, t.fitBoundsOptions, {
            duration: 0
        }))));
        let r = typeof t.style == `string` || t.style?.projection?.type !== `globe`;
        this.resize(null, r), this._localIdeographFontFamily = t.localIdeographFontFamily, this._validateStyle = t.validateStyle, t.style && this.setStyle(t.style, {
            localIdeographFontFamily: t.localIdeographFontFamily
        }), t.attributionControl && this.addControl(new $4324d99ae8520741$export$5af5c3cc9905683(typeof t.attributionControl == `boolean` ? void 0 : t.attributionControl)), t.maplibreLogo && this.addControl(new $4324d99ae8520741$export$6941d1bdee1234d4, t.logoPosition), this.on(`style.load`, ()=>{
            if (r || this._resizeTransform(), this._camera.transform.unmodified) {
                let e1 = (0, $1G0Uw.yr)(this.style.stylesheet, [
                    `center`,
                    `zoom`,
                    `bearing`,
                    `pitch`,
                    `roll`
                ]);
                this.jumpTo(e1);
            }
        }), this.on(`data`, (e1)=>{
            this._update(e1.dataType === `style`), this.fire(e1.dataType === `style` ? new $4324d99ae8520741$export$49025a11e3fe5bd0(`styledata`, e1) : new $4324d99ae8520741$export$ae09c661b7a299b2(`sourcedata`, e1));
        }), this.on(`dataloading`, (e1)=>{
            this.fire(e1.dataType === `style` ? new $4324d99ae8520741$export$49025a11e3fe5bd0(`styledataloading`, e1) : new $4324d99ae8520741$export$ae09c661b7a299b2(`sourcedataloading`, e1));
        }), this.on(`dataabort`, (e1)=>{
            this.fire(new $4324d99ae8520741$export$ae09c661b7a299b2(`sourcedataabort`, e1));
        });
    }
    _getMapId() {
        return this._mapId;
    }
    setGlobalStateProperty(e1, t) {
        return this.style.setGlobalStateProperty(e1, t), this._update(!0);
    }
    getGlobalState() {
        return this.style.getGlobalState();
    }
    addControl(e1, t) {
        if (t === void 0 && (t = e1.getDefaultPosition ? e1.getDefaultPosition() : `top-right`), !e1?.onAdd) return this.fire(new (0, $1G0Uw.gn)(Error(`Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.`)));
        let n = e1.onAdd(this);
        this._controls.push(e1);
        let r = this._controlPositions[t];
        return t.includes(`bottom`) ? r.insertBefore(n, r.firstChild) : r.appendChild(n), this;
    }
    removeControl(e1) {
        if (!e1?.onRemove) return this.fire(new (0, $1G0Uw.gn)(Error(`Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.`)));
        let t = this._controls.indexOf(e1);
        return t > -1 && this._controls.splice(t, 1), e1.onRemove(this), this;
    }
    hasControl(e1) {
        return this._controls.includes(e1);
    }
    coveringTiles(e1) {
        return $4324d99ae8520741$var$ko(this._camera.transform, e1);
    }
    setTransformCameraUpdate(e1) {
        this._camera.transformCameraUpdate = e1;
    }
    getCenter() {
        return new (0, $1G0Uw.lt)(this._camera.transform.center.lng, this._camera.transform.center.lat);
    }
    setCenter(e1, t) {
        return this._camera.setCenter(e1, t), this;
    }
    getCenterElevation() {
        return this._camera.transform.elevation;
    }
    setCenterElevation(e1, t) {
        return this._camera.setCenterElevation(e1, t), this;
    }
    setCenterClampedToGround(e1) {
        this._camera.setCenterClampedToGround(e1);
    }
    panBy(e1, t, n) {
        return this._camera.panBy(e1, t, n), this;
    }
    panTo(e1, t, n) {
        return this._camera.panTo(e1, t, n), this;
    }
    getZoom() {
        return this._camera.transform.zoom;
    }
    setZoom(e1, t) {
        return this._camera.setZoom(e1, t), this;
    }
    zoomTo(e1, t, n) {
        return this._camera.zoomTo(e1, t, n), this;
    }
    zoomIn(e1, t) {
        return this._camera.zoomIn(e1, t), this;
    }
    zoomOut(e1, t) {
        return this._camera.zoomOut(e1, t), this;
    }
    getVerticalFieldOfView() {
        return this._camera.transform.fov;
    }
    setVerticalFieldOfView(e1, t) {
        return this._camera.setVerticalFieldOfView(e1, t), this;
    }
    getBearing() {
        return this._camera.transform.bearing;
    }
    setBearing(e1, t) {
        return this._camera.setBearing(e1, t), this;
    }
    getZoomSnap() {
        return this._camera.getZoomSnap();
    }
    setZoomSnap(e1) {
        return this._camera.setZoomSnap(e1), this;
    }
    getPadding() {
        return this._camera.transform.padding;
    }
    setPadding(e1, t) {
        return this._camera.setPadding(e1, t), this;
    }
    rotateTo(e1, t, n) {
        return this._camera.rotateTo(e1, t, n), this;
    }
    resetNorth(e1, t) {
        return this._camera.resetNorth(e1, t), this;
    }
    resetNorthPitch(e1, t) {
        return this._camera.resetNorthPitch(e1, t), this;
    }
    snapToNorth(e1, t) {
        return this._camera.snapToNorth(e1, t), this;
    }
    getPitch() {
        return this._camera.transform.pitch;
    }
    setPitch(e1, t) {
        return this._camera.setPitch(e1, t), this;
    }
    getRoll() {
        return this._camera.transform.roll;
    }
    setRoll(e1, t) {
        return this._camera.setRoll(e1, t), this;
    }
    cameraForBounds(e1, t) {
        return this._camera.cameraForBounds(e1, t);
    }
    fitBounds(e1, t, n) {
        return this._camera.fitBounds(e1, t, n), this;
    }
    fitScreenCoordinates(e1, t, n, r, i) {
        return this._camera.fitScreenCoordinates(e1, t, n, r, i), this;
    }
    jumpTo(e1, t) {
        return this._camera.jumpTo(e1, t), this;
    }
    calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, n, r, i) {
        return this._camera.calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, n, r, i);
    }
    easeTo(e1, t) {
        return this._camera.easeTo(e1, t), this;
    }
    flyTo(e1, t) {
        return this._camera.flyTo(e1, t), this;
    }
    stop() {
        return this._camera.stop(), this;
    }
    queryTerrainElevation(e1) {
        return this.terrain ? this.terrain.getElevationForLngLat((0, $1G0Uw.lt).convert(e1), this._camera.transform) : null;
    }
    getCenterClampedToGround() {
        return this._camera.getCenterClampedToGround();
    }
    calculateCameraOptionsFromTo(e1, t, n, r) {
        return r == null && this.terrain && (r = this.terrain.getElevationForLngLat(n, this._camera.transform)), this._camera.transform.calculateCameraOptionsFromTo(e1, t, n, r ?? 0);
    }
    resize(e1, t = !0) {
        if (this._lostContextStyle.style !== null) return this;
        this._resizeInternal(t);
        let n = !this._camera._moving;
        return n && (this.stop(), this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`movestart`, e1)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`move`, e1))), this.fire(new $4324d99ae8520741$export$fc21b96c04d10d16(`resize`, e1)), n && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`moveend`, e1)), this;
    }
    _resizeInternal(e1 = !0) {
        let [t, n] = this._containerDimensions(), r = this._getClampedPixelRatio(t, n);
        if (this._resizeCanvas(t, n, r), this.painter.resize(t, n, r), this.painter.overLimit()) {
            let e1 = this.painter.context.gl;
            this._maxCanvasSize = [
                e1.drawingBufferWidth,
                e1.drawingBufferHeight
            ];
            let r = this._getClampedPixelRatio(t, n);
            this._resizeCanvas(t, n, r), this.painter.resize(t, n, r);
        }
        this._resizeTransform(e1);
    }
    _resizeTransform(e1 = !0) {
        let [t, n] = this._containerDimensions();
        this._camera.transform.resize(t, n, e1), this._camera._requestedCameraState?.resize(t, n, e1);
    }
    _getClampedPixelRatio(e1, t) {
        let { 0: n, 1: r } = this._maxCanvasSize, i = this.getPixelRatio(), a = e1 * i, o = t * i, s = a > n ? n / a : 1, c = o > r ? r / o : 1, l = Math.min(s, c);
        return l < 1 && (0, $1G0Uw.Nr)(`The canvas is larger than maxCanvasSize and is rendered at a lower pixel ratio to fit. Increase maxCanvasSize, within MAX_TEXTURE_SIZE, to render at full resolution.`), l * i;
    }
    getPixelRatio() {
        return this._overridePixelRatio ?? devicePixelRatio;
    }
    setPixelRatio(e1) {
        this._overridePixelRatio = e1, this.resize();
    }
    getBounds() {
        return this._camera.transform.getBounds();
    }
    getMaxBounds() {
        return this._camera.transform.getMaxBounds();
    }
    setMaxBounds(e1) {
        return this._camera.transform.setMaxBounds($4324d99ae8520741$export$266d2884f61535d3.convert(e1)), this._update();
    }
    setMinZoom(e1) {
        if (e1 ??= -2, e1 >= -2 && e1 <= this._camera.transform.maxZoom) {
            let t = this._camera.transform.zoom, n = this._camera.getTransformForUpdate();
            return n.setMinZoom(e1), this._camera.applyUpdatedTransform(n), this._update(), t !== this._camera.transform.zoom && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`zoomstart`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`zoom`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`zoomend`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`movestart`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`move`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`moveend`)), this;
        }
        throw Error(`minZoom must be between -2 and the current maxZoom, inclusive`);
    }
    getMinZoom(e1 = !1) {
        let t = this._camera.transform;
        return e1 ? t.applyConstrain(t.center, t.minZoom).zoom : t.minZoom;
    }
    setMaxZoom(e1) {
        if (e1 ??= 22, e1 >= this._camera.transform.minZoom) {
            let t = this._camera.transform.zoom, n = this._camera.getTransformForUpdate();
            return n.setMaxZoom(e1), this._camera.applyUpdatedTransform(n), this._update(), t !== this._camera.transform.zoom && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`zoomstart`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`zoom`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`zoomend`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`movestart`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`move`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`moveend`)), this;
        }
        throw Error(`maxZoom must be greater than the current minZoom`);
    }
    getMaxZoom() {
        return this._camera.transform.maxZoom;
    }
    setMinPitch(e1) {
        if (e1 ??= 0, e1 < 0) throw Error(`minPitch must be greater than or equal to 0`);
        if (e1 >= 0 && e1 <= this._camera.transform.maxPitch) {
            let t = this._camera.transform.pitch, n = this._camera.getTransformForUpdate();
            return n.setMinPitch(e1), this._camera.applyUpdatedTransform(n), this._update(), t !== this._camera.transform.pitch && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`pitchstart`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`pitch`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`pitchend`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`movestart`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`move`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`moveend`)), this;
        }
        throw Error(`minPitch must be between 0 and the current maxPitch, inclusive`);
    }
    getMinPitch() {
        return this._camera.transform.minPitch;
    }
    setMaxPitch(e1) {
        if (e1 ??= 60, e1 > 180) throw Error(`maxPitch must be less than or equal to 180`);
        if (e1 >= this._camera.transform.minPitch) {
            let t = this._camera.transform.pitch, n = this._camera.getTransformForUpdate();
            return n.setMaxPitch(e1), this._camera.applyUpdatedTransform(n), this._update(), t !== this._camera.transform.pitch && this.fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`pitchstart`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`pitch`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`pitchend`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`movestart`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`move`)).fire(new $4324d99ae8520741$export$534b7a2acb0e16da(`moveend`)), this;
        }
        throw Error(`maxPitch must be greater than the current minPitch`);
    }
    getMaxPitch() {
        return this._camera.transform.maxPitch;
    }
    getAnisotropicFilterPitch() {
        return this._anisotropicFilterPitch;
    }
    setAnisotropicFilterPitch(e1) {
        if (e1 ??= 20, e1 > 180) throw Error(`anisotropicFilterPitch must be less than or equal to 180`);
        if (e1 < 0) throw Error(`anisotropicFilterPitch must be greater than or equal to 0`);
        return this._anisotropicFilterPitch = e1, this._update();
    }
    getRenderWorldCopies() {
        return this._camera.transform.renderWorldCopies;
    }
    setRenderWorldCopies(e1) {
        return this._camera.transform.setRenderWorldCopies(e1), this._update();
    }
    setTransformConstrain(e1) {
        return this._camera.transform.setConstrainOverride(e1), this._update();
    }
    project(e1) {
        return this._camera.transform.locationToScreenPoint((0, $1G0Uw.lt).convert(e1), this.style && this.terrain);
    }
    unproject(e1) {
        return this._camera.transform.screenPointToLocation((0, $1G0Uw.Li).convert(e1), this.terrain);
    }
    isMoving() {
        return this._camera.isMoving() || this._handlers?.isMoving() || !1;
    }
    isZooming() {
        return this._camera.isZooming() || this._handlers?.isZooming() || !1;
    }
    isRotating() {
        return this._camera.isRotating() || this._handlers?.isRotating() || !1;
    }
    _createDelegatedListener(e1, t, n) {
        if (e1 === `mouseenter` || e1 === `mouseover`) {
            let r = !1;
            return {
                layers: t,
                listener: n,
                delegates: {
                    mousemove: (i)=>{
                        let a = t.filter((e1)=>this.getLayer(e1)), o = a.length === 0 ? [] : this.queryRenderedFeatures(i.point, {
                            layers: a
                        });
                        o.length ? r || (r = !0, n.call(this, new $4324d99ae8520741$export$83f023c8e5acf676(e1, this, i.originalEvent, {
                            features: o
                        }))) : r = !1;
                    },
                    mouseout: ()=>{
                        r = !1;
                    }
                }
            };
        }
        if (e1 === `mouseleave` || e1 === `mouseout`) {
            let r = !1;
            return {
                layers: t,
                listener: n,
                delegates: {
                    mousemove: (i)=>{
                        let a = t.filter((e1)=>this.getLayer(e1));
                        (a.length === 0 ? [] : this.queryRenderedFeatures(i.point, {
                            layers: a
                        })).length ? r = !0 : r && (r = !1, n.call(this, new $4324d99ae8520741$export$83f023c8e5acf676(e1, this, i.originalEvent)));
                    },
                    mouseout: (t)=>{
                        r && (r = !1, n.call(this, new $4324d99ae8520741$export$83f023c8e5acf676(e1, this, t.originalEvent)));
                    }
                }
            };
        }
        {
            let r = (e1)=>{
                let r = t.filter((e1)=>this.getLayer(e1)), i = r.length === 0 ? [] : this.queryRenderedFeatures(e1.point, {
                    layers: r
                });
                i.length && (e1.features = i, n.call(this, e1), delete e1.features);
            };
            return {
                layers: t,
                listener: n,
                delegates: {
                    [e1]: r
                }
            };
        }
    }
    _saveDelegatedListener(e1, t) {
        this._delegatedListeners ||= {}, this._delegatedListeners[e1] ||= [], this._delegatedListeners[e1].push(t);
    }
    _removeDelegatedListener(e1, t, n) {
        if (!this._delegatedListeners?.[e1]) return;
        let r = this._delegatedListeners[e1];
        for(let e1 = 0; e1 < r.length; e1++){
            let i = r[e1];
            if (i.listener === n && i.layers.length === t.length && i.layers.every((e1)=>t.includes(e1))) {
                for(let e1 in i.delegates)this.off(e1, i.delegates[e1]);
                r.splice(e1, 1);
                return;
            }
        }
    }
    on(e1, t, n) {
        if (n === void 0) return super.on(e1, t);
        let r = typeof t == `string` ? [
            t
        ] : t, i = this._createDelegatedListener(e1, r, n);
        this._saveDelegatedListener(e1, i);
        for(let e1 in i.delegates)this.on(e1, i.delegates[e1]);
        return {
            unsubscribe: ()=>{
                this._removeDelegatedListener(e1, r, n);
            }
        };
    }
    once(e1, t, n) {
        if (n === void 0) return super.once(e1, t);
        let r = typeof t == `string` ? [
            t
        ] : t, i = this._createDelegatedListener(e1, r, n);
        for(let t in i.delegates){
            let a = i.delegates[t];
            i.delegates[t] = (...t)=>{
                this._removeDelegatedListener(e1, r, n), a(...t);
            };
        }
        this._saveDelegatedListener(e1, i);
        for(let e1 in i.delegates)this.once(e1, i.delegates[e1]);
        return this;
    }
    off(e1, t, n) {
        if (n === void 0) return super.off(e1, t);
        let r = typeof t == `string` ? [
            t
        ] : t;
        return this._removeDelegatedListener(e1, r, n), this;
    }
    queryRenderedFeatures(e1, t) {
        if (!this.style) return [];
        let n, r = e1 instanceof (0, $1G0Uw.Li) || Array.isArray(e1), i = r ? e1 : [
            [
                0,
                0
            ],
            [
                this._camera.transform.width,
                this._camera.transform.height
            ]
        ];
        if (t ||= (r ? {} : e1) || {}, i instanceof (0, $1G0Uw.Li) || typeof i[0] == `number`) n = [
            (0, $1G0Uw.Li).convert(i)
        ];
        else {
            let e1 = (0, $1G0Uw.Li).convert(i[0]), t = (0, $1G0Uw.Li).convert(i[1]);
            n = [
                e1,
                new (0, $1G0Uw.Li)(t.x, e1.y),
                t,
                new (0, $1G0Uw.Li)(e1.x, t.y),
                e1
            ];
        }
        return this.style.queryRenderedFeatures(n, t, this._camera.transform);
    }
    querySourceFeatures(e1, t) {
        return this.style.querySourceFeatures(e1, t);
    }
    setStyle(e1, t) {
        return t = (0, $1G0Uw.er)({}, {
            localIdeographFontFamily: this._localIdeographFontFamily,
            validate: this._validateStyle
        }, t), this._styleUrl = typeof e1 == `string` ? e1 : null, t.diff !== !1 && t.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, t), this) : (this._localIdeographFontFamily = t.localIdeographFontFamily, this._updateStyle(e1, t));
    }
    setTransformRequest(e1) {
        return this._requestManager.setTransformRequest(e1), this;
    }
    _getUIString(e1) {
        let t = this._locale[e1];
        if (t == null) throw Error(`Missing UI string '${e1}'`);
        return t;
    }
    _updateStyle(e1, t) {
        if (this._diffStyleRequest?.abort(), this._diffStyleRequest = null, t.transformStyle && this.style && !this.style._loaded) {
            this.style.once(`style.load`, ()=>this._updateStyle(e1, t));
            return;
        }
        let n = this.style && t.transformStyle ? this.style.serialize() : void 0;
        if (this.style && (this.style.setEventedParent(null), this.style._remove(!e1)), e1) this.style = new $4324d99ae8520741$export$d9e45bc13d335801(this, t || {});
        else return this._frameRequest &&= (this._frameRequest.abort(), null), this.style?.projection?.destroy(), delete this.style, this;
        return this.style.setEventedParent(this, {
            style: this.style
        }), typeof e1 == `string` ? this.style.loadURL(e1, t, n) : this.style.loadJSON(e1, t, n), this;
    }
    _lazyInitEmptyStyle() {
        this.style || (this.style = new $4324d99ae8520741$export$d9e45bc13d335801(this, {}), this.style.setEventedParent(this, {
            style: this.style
        }), this.style.loadEmpty());
    }
    async _diffStyle(e1, t) {
        if (this._diffStyleRequest?.abort(), typeof e1 == `string`) {
            let n = e1;
            this._diffStyleRequest = new AbortController;
            let r = this._diffStyleRequest;
            try {
                let e1 = await this._requestManager.transformRequest(n, `Style`);
                if (r.signal.aborted) {
                    this._diffStyleRequest = null;
                    return;
                }
                let i = await (0, $1G0Uw.Sn)(e1, r);
                this._diffStyleRequest = null, this._updateDiff(i.data, t);
            } catch (e1) {
                this._diffStyleRequest = null, (0, $1G0Uw.Mn)(e1) || this.fire(new (0, $1G0Uw.gn)((0, $1G0Uw.Qn)(e1)));
            }
        } else typeof e1 == `object` && (this._diffStyleRequest = null, this._updateDiff(e1, t));
    }
    _updateDiff(e1, t) {
        try {
            this.style.setState(e1, t) && this._update(!0);
        } catch (n) {
            (0, $1G0Uw.Nr)(`Unable to perform style diff: ${(0, $1G0Uw.Qn)(n).message}.  Rebuilding the style from scratch.`), this._updateStyle(e1, t);
        }
    }
    getStyle() {
        if (this.style) return this.style.serialize();
    }
    getStyleUrl() {
        return this._styleUrl;
    }
    _getStyleAndImages() {
        return this.style ? {
            style: this.style.serialize(),
            images: this.style.imageManager.cloneImages()
        } : {
            style: null,
            images: {}
        };
    }
    isStyleLoaded() {
        if (!this.style) {
            (0, $1G0Uw.Nr)(`There is no style added to the map.`);
            return;
        }
        return this.style.loaded();
    }
    addSource(e1, t) {
        return this._lazyInitEmptyStyle(), this.style.addSource(e1, t), this._update(!0);
    }
    isSourceLoaded(e1) {
        let t = this.style?.tileManagers[e1];
        if (t === void 0) {
            this.fire(new (0, $1G0Uw.gn)(Error(`There is no tile manager with ID '${e1}'`)));
            return;
        }
        return t.loaded();
    }
    setTerrain(e1, t = {}) {
        if (this.style._checkLoaded(), e1 && (0, $1G0Uw.an)(this, (0, $1G0Uw.on).terrain, {
            value: e1
        }, t)) return this;
        if (this._terrainDataCallback && this.style.off(`data`, this._terrainDataCallback), !e1) this.terrain && this.terrain.destroy(), this.terrain = null, this.painter.renderToTexture = null, this._camera.terrain = null, this._camera.transform.setMinElevationForCurrentTile(0), this.getCenterClampedToGround() && this._camera.transform.setElevation(0);
        else {
            let t = this.style.tileManagers[e1.source];
            if (!t) throw Error(`cannot load terrain, because there exists no source with ID: ${e1.source}`);
            this.terrain === null && t.reload();
            for(let t in this.style._layers){
                let n = this.style._layers[t];
                n.type === `hillshade` && n.source === e1.source && (0, $1G0Uw.Nr)(`You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.`), n.type === `color-relief` && n.source === e1.source && (0, $1G0Uw.Nr)(`You are using the same source for a color-relief layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.`);
            }
            this.terrain && this.terrain.destroy(), this.terrain = new $4324d99ae8520741$var$_c(this.painter, t, e1, this._terrainSkirtLength), this.painter.renderToTexture = new $4324d99ae8520741$var$Sm(this.painter, this.terrain), this._camera.terrain = this.terrain, this._camera.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom)), this._camera.transform.setElevation(this.terrain.getElevationForLngLat(this._camera.transform.center, this._camera.transform)), this._terrainDataCallback = (t)=>this._handleTerrainDataEvent(t, e1.source), this.style.on(`data`, this._terrainDataCallback);
        }
        return this.style.triggerSymbolPlacement(), this.fire(new $4324d99ae8520741$export$da1f2ab236a92d66({
            terrain: e1
        })), this;
    }
    _handleTerrainDataEvent(e1, t) {
        if (e1.dataType === `style`) {
            this.terrain.tileManager.releaseAllRTT();
            return;
        }
        let n = e1.sourceId === t;
        if (n && (this.terrain.resetElevationCache(), this.style.triggerSymbolPlacement()), n && e1.tile && this.painter.markTerrainDepthDirty(), n && e1.tile && !this._camera.elevationFreeze && (this._camera.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom)), this.getCenterClampedToGround() && this._camera.transform.setElevation(this.terrain.getElevationForLngLat(this._camera.transform.center, this._camera.transform))), e1.tile) {
            if (e1.source?.type === `image`) {
                this.terrain.tileManager.releaseAllRTT();
                return;
            }
            this.terrain.tileManager.releaseRTT(e1.tile.tileID);
        }
    }
    getTerrain() {
        return this.terrain?.options ?? null;
    }
    areTilesLoaded() {
        let e1 = this.style?.tileManagers;
        for (let t of Object.values(e1))if (!t.areTilesLoaded()) return !1;
        return !0;
    }
    removeSource(e1) {
        return this.style.removeSource(e1), this._update(!0);
    }
    getSource(e1) {
        return this.style?.getSource(e1);
    }
    setSourceTileLodParams(e1, t, n) {
        if (n) {
            let r = this.getSource(n);
            if (!r) throw Error(`There is no source with ID "${n}", cannot set LOD parameters`);
            r.calculateTileZoom = $4324d99ae8520741$var$wo(Math.max(1, e1), Math.max(1, t));
        } else for(let n in this.style.tileManagers)this.style.tileManagers[n].getSource().calculateTileZoom = $4324d99ae8520741$var$wo(Math.max(1, e1), Math.max(1, t));
        return this._update(!0), this;
    }
    refreshTiles(e1, t) {
        let n = this.style.tileManagers[e1];
        if (!n) throw Error(`There is no tile manager with ID "${e1}", cannot refresh tile`);
        t === void 0 ? n.reload(!0) : n.refreshTiles(t.map((e1)=>new (0, $1G0Uw.u)(e1.z, e1.x, e1.y)));
    }
    addImage(e1, t, n = {}) {
        this._lazyInitEmptyStyle();
        let r = this._createStyleImage(t, n);
        return r ? (this.style.addImage(e1, r), r.userImage?.onAdd && r.userImage.onAdd(this, e1), this) : this;
    }
    setMissingStyleImageResolver(e1) {
        return this._missingStyleImageResolver = e1, this.style?.setMissingImageResolver(e1), this;
    }
    _createStyleImage(e1, t = {}) {
        let { pixelRatio: n = 1, sdf: r = !1, stretchX: i, stretchY: a, content: o, textFitWidth: s, textFitHeight: c } = t;
        if (e1 instanceof HTMLImageElement || (0, $1G0Uw.cr)(e1)) {
            let { width: t, height: l, data: u } = $4324d99ae8520741$var$Rr.getImageData(e1);
            return {
                data: new (0, $1G0Uw.Dt)({
                    width: t,
                    height: l
                }, u),
                pixelRatio: n,
                stretchX: i,
                stretchY: a,
                content: o,
                textFitWidth: s,
                textFitHeight: c,
                sdf: r,
                version: 0
            };
        }
        if (e1.width === void 0 || e1.height === void 0) return this.fire(new (0, $1G0Uw.gn)(Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`"))), null;
        {
            let { width: t, height: l, data: u } = e1, d = e1, f = (0, $1G0Uw.I)(d.data);
            return {
                data: f ? new (0, $1G0Uw.Dt)({
                    width: t,
                    height: l
                }) : new (0, $1G0Uw.Dt)({
                    width: t,
                    height: l
                }, new Uint8Array(u)),
                pixelRatio: n,
                stretchX: i,
                stretchY: a,
                content: o,
                textFitWidth: s,
                textFitHeight: c,
                sdf: r,
                version: 0,
                isWebGLImage: f,
                userImage: d
            };
        }
    }
    updateImage(e1, t) {
        let n = this.style.getImage(e1);
        if (!n) return this.fire(new (0, $1G0Uw.gn)(Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
        let { width: r, height: i, data: a } = t instanceof HTMLImageElement || (0, $1G0Uw.cr)(t) ? $4324d99ae8520741$var$Rr.getImageData(t) : t;
        if (r === void 0 || i === void 0) return this.fire(new (0, $1G0Uw.gn)(Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
        if (r !== n.data.width || i !== n.data.height) return this.fire(new (0, $1G0Uw.gn)(Error(`The width and height of the updated image must be that same as the previous version of the image`)));
        if (n.isWebGLImage = (0, $1G0Uw.I)(a), n.isWebGLImage) n.userImage = t;
        else {
            let e1 = !(t instanceof HTMLImageElement || (0, $1G0Uw.cr)(t));
            n.data.replace(a, e1);
        }
        return this.style.updateImage(e1, n), this;
    }
    getImage(e1) {
        return this.style.getImage(e1);
    }
    hasImage(e1) {
        return e1 ? !!this.style.getImage(e1) : (this.fire(new (0, $1G0Uw.gn)(Error(`Missing required image id`))), !1);
    }
    removeImage(e1) {
        this.style.removeImage(e1);
    }
    async loadImage(e1) {
        let t = await $4324d99ae8520741$var$Ur.getImage(await this._requestManager.transformRequest(e1, `Image`), new AbortController);
        if (!t.data) throw Error(`Could not load image ${e1}: the response is empty`);
        return t;
    }
    listImages() {
        return this.style?.listImages() ?? [];
    }
    addLayer(e1, t) {
        return this._lazyInitEmptyStyle(), this.style.addLayer(e1, t), this._update(!0);
    }
    moveLayer(e1, t) {
        return this.style.moveLayer(e1, t), this._update(!0);
    }
    removeLayer(e1) {
        return this.style.removeLayer(e1), this._update(!0);
    }
    getLayer(e1) {
        return this.style?.getLayer(e1);
    }
    getLayersOrder() {
        return this.style?.getLayersOrder() ?? [];
    }
    setLayerZoomRange(e1, t, n) {
        return this.style.setLayerZoomRange(e1, t, n), this._update(!0);
    }
    setFilter(e1, t, n = {}) {
        return this.style?.setFilter(e1, t, n), this._update(!0);
    }
    getFilter(e1) {
        return this.style.getFilter(e1);
    }
    setPaintProperty(e1, t, n, r = {}) {
        return this.style?.setPaintProperty(e1, t, n, r), this._update(!0);
    }
    getPaintProperty(e1, t) {
        return this.style.getPaintProperty(e1, t);
    }
    setLayoutProperty(e1, t, n, r = {}) {
        return this.style.setLayoutProperty(e1, t, n, r), this._update(!0);
    }
    getLayoutProperty(e1, t) {
        return this.style.getLayoutProperty(e1, t);
    }
    setGlyphs(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setGlyphs(e1, t), this._update(!0);
    }
    getGlyphs() {
        return this.style.getGlyphsUrl();
    }
    setFontFaces(e1) {
        return this._lazyInitEmptyStyle(), this.style.setFontFaces(e1), this._update(!0);
    }
    getFontFaces() {
        return this.style.getFontFaces();
    }
    addSprite(e1, t, n = {}) {
        return this._lazyInitEmptyStyle(), this.style.addSprite(e1, t, n, (e1)=>{
            e1 || this._update(!0);
        }), this;
    }
    removeSprite(e1) {
        return this._lazyInitEmptyStyle(), this.style.removeSprite(e1), this._update(!0);
    }
    getSprite() {
        return this.style.getSprite();
    }
    setSprite(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setSprite(e1, t, (e1)=>{
            e1 || this._update(!0);
        }), this;
    }
    setLight(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setLight(e1, t), this._update(!0);
    }
    getLight() {
        return this.style.getLight();
    }
    setSky(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setSky(e1, t), this._update(!0);
    }
    getSky() {
        return this.style.getSky();
    }
    setFeatureState(e1, t) {
        return this.style.setFeatureState(e1, t), this._update();
    }
    removeFeatureState(e1, t) {
        return this.style.removeFeatureState(e1, t), this._update();
    }
    getFeatureState(e1) {
        return this.style.getFeatureState(e1);
    }
    getContainer() {
        return this._container;
    }
    getCanvasContainer() {
        return this._canvasContainer;
    }
    getCanvas() {
        return this._canvas;
    }
    _containerDimensions() {
        let e1 = 0, t = 0;
        return this._container && (e1 = this._container.clientWidth || 400, t = this._container.clientHeight || 300), [
            e1,
            t
        ];
    }
    _shouldHandleInitialResize() {
        if (!this._container?.clientWidth || !this._container.clientHeight) return !1;
        let [e1, t] = this._containerDimensions();
        return e1 !== this._camera.transform.width || t !== this._camera.transform.height;
    }
    _setupResizeObserver() {
        let e1 = !1, t = $4324d99ae8520741$var$dp((e1)=>{
            this._trackResize && !this._removed && (this.resize(e1), this.redraw());
        }, 50), n = this._ownerWindow.ResizeObserver ?? ResizeObserver;
        this._resizeObserver = new n((n)=>{
            !e1 && (e1 = !0, !this._shouldHandleInitialResize()) || t(n);
        }), this._resizeObserver.observe(this._container);
    }
    _resolveContainer(e1) {
        if (typeof e1 == `string`) {
            let t = document.getElementById(e1);
            if (!t) throw Error(`Container '${e1}' not found.`);
            return t;
        }
        if (e1 instanceof HTMLElement || e1 && typeof e1 == `object` && e1.nodeType === 1) return e1;
        throw Error(`Invalid type: 'container' must be a String or HTMLElement.`);
    }
    _setupContainer() {
        let e1 = this._containerDimensions(), t = this._getClampedPixelRatio(e1[0], e1[1]), n = this._container;
        n.classList.add(`maplibregl-map`);
        let r = this._canvasContainer = $4324d99ae8520741$var$G.create(`div`, `maplibregl-canvas-container`, n);
        this._interactive && r.classList.add(`maplibregl-interactive`), this._canvas = $4324d99ae8520741$var$G.create(`canvas`, `maplibregl-canvas`, r), this._canvas.addEventListener(`webglcontextlost`, this._contextLost, !1), this._canvas.addEventListener(`webglcontextrestored`, this._contextRestored, !1), this._canvas.setAttribute(`tabindex`, this._interactive ? `0` : `-1`), this._canvas.setAttribute(`aria-label`, this._getUIString(`Map.Title`)), this._canvas.setAttribute(`role`, `region`), this._resizeCanvas(e1[0], e1[1], t);
        let i = this._controlContainer = $4324d99ae8520741$var$G.create(`div`, `maplibregl-control-container`, n), a = this._controlPositions = {};
        for (let e1 of [
            `top-left`,
            `top-right`,
            `bottom-left`,
            `bottom-right`
        ])a[e1] = $4324d99ae8520741$var$G.create(`div`, `maplibregl-ctrl-${e1} `, i);
        this._container.addEventListener(`scroll`, this._onMapScroll, !1);
    }
    _cleanupContainer() {
        this._canvas.removeEventListener(`webglcontextrestored`, this._contextRestored, !1), this._canvas.removeEventListener(`webglcontextlost`, this._contextLost, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._container.removeEventListener(`scroll`, this._onMapScroll, !1), this._container.classList.remove(`maplibregl-map`);
    }
    _resizeCanvas(e1, t, n) {
        this._canvas.width = Math.floor(n * e1), this._canvas.height = Math.floor(n * t), this._canvas.style.width = `${e1}px`, this._canvas.style.height = `${t}px`;
    }
    _setupPainter() {
        let e1 = {
            ...this._canvasContextAttributes,
            alpha: !0,
            depth: !0,
            stencil: !0,
            premultipliedAlpha: !0
        }, t = null;
        this._canvas.addEventListener(`webglcontextcreationerror`, (e1)=>{
            t = e1;
        }, {
            once: !0
        });
        let n = this._canvas.getContext(`webgl2`, e1);
        if (!n) throw new $4324d99ae8520741$export$68b5dc085315a832(e1, t);
        this.painter = new $4324d99ae8520741$var$lp(n, this._camera.transform);
    }
    migrateProjection(e1, t) {
        this._camera.migrateProjection(e1, t), this.painter.transform = e1, this.fire(new $4324d99ae8520741$export$f966cee55553279({
            newProjection: this.style.projection.name
        }));
    }
    loaded() {
        return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
    }
    _update(e1) {
        return this.style?._loaded ? (this._styleDirty ||= e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
    }
    _requestRenderFrame(e1) {
        return this._update(), this._renderTaskQueue.add(e1);
    }
    _cancelRenderFrame(e1) {
        this._renderTaskQueue.remove(e1);
    }
    _render(e1) {
        let t = this._idleTriggered ? this._fadeDuration : 0, n = this.style.projection?.transitionState > 0;
        if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), this._removed) return;
        let r = !1;
        if (this.style && this._styleDirty) {
            this._styleDirty = !1;
            let e1 = this._camera.transform.zoom, n = $4324d99ae8520741$export$461939dd4422153();
            this.style.zoomHistory.update(e1, n);
            let i = new (0, $1G0Uw.en)(e1, {
                now: n,
                fadeDuration: t,
                zoomHistory: this.style.zoomHistory,
                transition: this.style.getTransition()
            }), a = i.crossFadingFactor();
            (a !== 1 || a !== this._crossFadingFactor) && (r = !0, this._crossFadingFactor = a), this.style.update(i);
        }
        let i = this.style.projection?.transitionState > 0 !== n;
        this._camera.transform.setTransitionState(this.style.projection?.transitionState), this.style && (this._sourcesDirty || i) && (this._sourcesDirty = !1, this.style._updateSources(this._camera.transform)), this.terrain ? (this.terrain.tileManager.update(this._camera.transform, this.terrain) && this.terrain.resetElevationCache(), this._camera.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom)), !this._camera.elevationFreeze && this.getCenterClampedToGround() && this._camera.transform.setElevation(this.terrain.getElevationForLngLat(this._camera.transform.center, this._camera.transform))) : (this._camera.transform.setMinElevationForCurrentTile(0), this.getCenterClampedToGround() && this._camera.transform.setElevation(0)), this._placementDirty = this.style?._updatePlacement(this._camera.transform, this.showCollisionBoxes, t, this._crossSourceCollisions, i), this.painter.render(this.style, {
            showTileBoundaries: this.showTileBoundaries,
            showOverdrawInspector: this._showOverdrawInspector,
            rotating: this.isRotating(),
            zooming: this.isZooming(),
            moving: this.isMoving(),
            fadeDuration: t,
            showPadding: this.showPadding,
            anisotropicFilterPitch: this.getAnisotropicFilterPitch()
        }), this.fire(new $4324d99ae8520741$export$fc21b96c04d10d16(`render`)), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new $4324d99ae8520741$export$fc21b96c04d10d16(`load`))), this.style && (this.style.hasTransitions() || r) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
        let a = this._sourcesDirty || this._styleDirty || this._placementDirty || this.painter.renderToTexture?.needsFollowUpFrame;
        return a || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new $4324d99ae8520741$export$fc21b96c04d10d16(`idle`)), this._loaded && !this._fullyLoaded && !a && (this._fullyLoaded = !0), this;
    }
    redraw() {
        return this.style && (this._frameRequest &&= (this._frameRequest.abort(), null), this._render(0)), this;
    }
    remove() {
        this._hash && this._hash.remove();
        for (let e1 of this._controls)e1.onRemove(this);
        this._controls = [], this._frameRequest &&= (this._frameRequest.abort(), null), this._renderTaskQueue.clear(), this._diffStyleRequest?.abort(), this.painter.destroy(), this._handlers.destroy(), this.setStyle(null), typeof window < `u` && this._ownerWindow.removeEventListener(`online`, this._onWindowOnline, !1), $4324d99ae8520741$var$Ur.removeThrottleControl(this._imageQueueHandle), this._resizeObserver?.disconnect();
        let e1 = this.painter.context.gl.getExtension(`WEBGL_lose_context`);
        e1?.loseContext && e1.loseContext(), this._cleanupContainer(), this._removed = !0, this.fire(new $4324d99ae8520741$export$fc21b96c04d10d16(`remove`));
    }
    triggerRepaint() {
        this.style && !this._frameRequest && (this._frameRequest = new AbortController, $4324d99ae8520741$var$Rr.frame(this._frameRequest, (e1)=>{
            this._frameRequest = null;
            try {
                this._render(e1);
            } catch (e1) {
                if (!(0, $1G0Uw.Mn)(e1)) throw e1;
            }
        }, ()=>{}, this._ownerWindow));
    }
    get showTileBoundaries() {
        return !!this._showTileBoundaries;
    }
    set showTileBoundaries(e1) {
        this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, this._update());
    }
    get showPadding() {
        return !!this._showPadding;
    }
    set showPadding(e1) {
        this._showPadding !== e1 && (this._showPadding = e1, this._update());
    }
    get showCollisionBoxes() {
        return !!this._showCollisionBoxes;
    }
    set showCollisionBoxes(e1) {
        this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 ? this.style._generateCollisionBoxes() : this._update());
    }
    get showOverdrawInspector() {
        return !!this._showOverdrawInspector;
    }
    set showOverdrawInspector(e1) {
        this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
    }
    get repaint() {
        return !!this._repaint;
    }
    set repaint(e1) {
        this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
    }
    get vertices() {
        return !!this._vertices;
    }
    set vertices(e1) {
        this._vertices = e1, this._update();
    }
    get version() {
        return $4324d99ae8520741$var$wm;
    }
    getCameraTargetElevation() {
        return this._camera.transform.elevation;
    }
    getProjection() {
        return this.style.getProjection();
    }
    setProjection(e1) {
        return this._lazyInitEmptyStyle(), this.style.setProjection(e1), this._update(!0);
    }
};
const $4324d99ae8520741$var$Dm = {
    showCompass: !0,
    showZoom: !0,
    visualizePitch: !1,
    visualizeRoll: !0
};
var $4324d99ae8520741$export$49a437922edc1bd9 = class {
    constructor(e1){
        this._updateZoomButtons = ()=>{
            let e1 = this._map.getZoom(), t = e1 === this._map.getMaxZoom(), n = e1 === this._map.getMinZoom(!0);
            this._zoomInButton.disabled = t, this._zoomOutButton.disabled = n, this._zoomInButton.setAttribute(`aria-disabled`, t.toString()), this._zoomOutButton.setAttribute(`aria-disabled`, n.toString());
        }, this._rotateCompassArrow = ()=>{
            let e1 = this._map.getPitch(), t = this._map.getRoll(), n = this._map.getBearing(), r = 1 / Math.cos((0, $1G0Uw.Yn)(e1)) ** .5;
            if (this.options.visualizePitch && this.options.visualizeRoll) {
                this._compassIcon.style.transform = `scale(${r}) rotateZ(${-t}deg) rotateX(${e1}deg) rotateZ(${-n}deg)`;
                return;
            }
            if (this.options.visualizePitch) {
                this._compassIcon.style.transform = `scale(${r}) rotateX(${e1}deg) rotateZ(${-n}deg)`;
                return;
            }
            if (this.options.visualizeRoll) {
                this._compassIcon.style.transform = `rotate(${-n - t}deg)`;
                return;
            }
            this._compassIcon.style.transform = `rotate(${-n}deg)`;
        }, this._setButtonTitle = (e1, t)=>{
            let n = this._map._getUIString(`NavigationControl.${t}`);
            e1.title = n, e1.setAttribute(`aria-label`, n);
        }, this.options = (0, $1G0Uw.er)({}, $4324d99ae8520741$var$Dm, e1), this._container = $4324d99ae8520741$var$G.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._container.addEventListener(`contextmenu`, (e1)=>e1.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton(`maplibregl-ctrl-zoom-in`, (e1)=>this._map.zoomIn({}, {
                originalEvent: e1
            })), $4324d99ae8520741$var$G.create(`span`, `maplibregl-ctrl-icon`, this._zoomInButton).setAttribute(`aria-hidden`, `true`), this._zoomOutButton = this._createButton(`maplibregl-ctrl-zoom-out`, (e1)=>this._map.zoomOut({}, {
                originalEvent: e1
            })), $4324d99ae8520741$var$G.create(`span`, `maplibregl-ctrl-icon`, this._zoomOutButton).setAttribute(`aria-hidden`, `true`)), this.options.showCompass && (this._compass = this._createButton(`maplibregl-ctrl-compass`, (e1)=>{
            this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                originalEvent: e1
            }) : this._map.resetNorth({}, {
                originalEvent: e1
            });
        }), this._compassIcon = $4324d99ae8520741$var$G.create(`span`, `maplibregl-ctrl-icon`, this._compass), this._compassIcon.setAttribute(`aria-hidden`, `true`));
    }
    onAdd(e1) {
        return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, `ZoomIn`), this._setButtonTitle(this._zoomOutButton, `ZoomOut`), this._map.on(`move`, this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, `ResetBearing`), this.options.visualizePitch && this._map.on(`pitch`, this._rotateCompassArrow), this.options.visualizeRoll && this._map.on(`roll`, this._rotateCompassArrow), this._map.on(`rotate`, this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new $4324d99ae8520741$var$km(this._map, this._compass, this.options.visualizePitch)), this._container;
    }
    onRemove() {
        this._container.remove(), this.options.showZoom && this._map.off(`move`, this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off(`pitch`, this._rotateCompassArrow), this.options.visualizeRoll && this._map.off(`roll`, this._rotateCompassArrow), this._map.off(`rotate`, this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
    }
    _createButton(e1, t) {
        let n = $4324d99ae8520741$var$G.create(`button`, e1, this._container);
        return n.type = `button`, n.addEventListener(`click`, t), n;
    }
}, $4324d99ae8520741$var$km = class {
    constructor(e1, t, n = !1){
        this.mousedown = (e1)=>{
            this.startMove(e1, $4324d99ae8520741$var$G.mousePos(this.element, e1)), window.addEventListener(`mousemove`, this.mousemove), window.addEventListener(`mouseup`, this.mouseup);
        }, this.mousemove = (e1)=>{
            this.move(e1, $4324d99ae8520741$var$G.mousePos(this.element, e1));
        }, this.mouseup = (e1)=>{
            this._rotatePitchHandler.dragEnd(e1), this.offTemp();
        }, this.touchstart = (e1)=>{
            e1.targetTouches.length === 1 ? (this._startPos = this._lastPos = $4324d99ae8520741$var$G.touchPos(this.element, e1.targetTouches)[0], this.startMove(e1, this._startPos), window.addEventListener(`touchmove`, this.touchmove, {
                passive: !1
            }), window.addEventListener(`touchend`, this.touchend)) : this.reset();
        }, this.touchmove = (e1)=>{
            e1.targetTouches.length === 1 ? (this._lastPos = $4324d99ae8520741$var$G.touchPos(this.element, e1.targetTouches)[0], this.move(e1, this._lastPos)) : this.reset();
        }, this.touchend = (e1)=>{
            e1.targetTouches.length === 0 && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
        }, this.reset = ()=>{
            this._rotatePitchHandler.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
        }, this._clickTolerance = 10, this.element = t;
        let r = new $4324d99ae8520741$var$Fp;
        this._rotatePitchHandler = new $4324d99ae8520741$var$Ap({
            clickTolerance: 3,
            move: (e1, r)=>{
                let i = t.getBoundingClientRect(), a = new (0, $1G0Uw.Li)((i.bottom - i.top) / 2, (i.right - i.left) / 2);
                return {
                    bearingDelta: (0, $1G0Uw.ir)(new (0, $1G0Uw.Li)(e1.x, r.y), r, a),
                    pitchDelta: n ? (r.y - e1.y) * -0.5 : void 0
                };
            },
            moveStateManager: r,
            enable: !0,
            assignEvents: ()=>{}
        }), this.map = e1, t.addEventListener(`mousedown`, this.mousedown), t.addEventListener(`touchstart`, this.touchstart, {
            passive: !1
        }), t.addEventListener(`touchcancel`, this.reset);
    }
    startMove(e1, t) {
        this._rotatePitchHandler.dragStart(e1, t), $4324d99ae8520741$var$G.disableDrag();
    }
    move(e1, t) {
        let n = this.map, { bearingDelta: r, pitchDelta: i } = this._rotatePitchHandler.dragMove(e1, t) || {};
        r && n.setBearing(n.getBearing() + r), i && n.setPitch(n.getPitch() + i);
    }
    off() {
        let e1 = this.element;
        e1.removeEventListener(`mousedown`, this.mousedown), e1.removeEventListener(`touchstart`, this.touchstart), window.removeEventListener(`touchmove`, this.touchmove), window.removeEventListener(`touchend`, this.touchend), e1.removeEventListener(`touchcancel`, this.reset), this.offTemp();
    }
    offTemp() {
        $4324d99ae8520741$var$G.enableDrag(), window.removeEventListener(`mousemove`, this.mousemove), window.removeEventListener(`mouseup`, this.mouseup), window.removeEventListener(`touchmove`, this.touchmove), window.removeEventListener(`touchend`, this.touchend);
    }
};
let $4324d99ae8520741$var$Am;
async function $4324d99ae8520741$var$jm(e1 = !1) {
    if ($4324d99ae8520741$var$Am !== void 0 && !e1) return $4324d99ae8520741$var$Am;
    if (window.navigator.permissions === void 0) return $4324d99ae8520741$var$Am = !!window.navigator.geolocation, $4324d99ae8520741$var$Am;
    try {
        $4324d99ae8520741$var$Am = (await window.navigator.permissions.query({
            name: `geolocation`
        })).state !== `denied`;
    } catch  {
        $4324d99ae8520741$var$Am = !!window.navigator.geolocation;
    }
    return $4324d99ae8520741$var$Am;
}
function $4324d99ae8520741$var$Mm(e1, t, n, r = !1) {
    if (r || !n.getCoveringTilesDetailsProvider().allowWorldCopies()) return e1?.wrap();
    let i = new (0, $1G0Uw.lt)(e1.lng, e1.lat);
    if (e1 = new (0, $1G0Uw.lt)(e1.lng, e1.lat), t) {
        let r = new (0, $1G0Uw.lt)(e1.lng - 360, e1.lat), i = new (0, $1G0Uw.lt)(e1.lng + 360, e1.lat), a = n.locationToScreenPoint(e1).distSqr(t);
        n.locationToScreenPoint(r).distSqr(t) < a ? e1 = r : n.locationToScreenPoint(i).distSqr(t) < a && (e1 = i);
    }
    for(; Math.abs(e1.lng - n.center.lng) > 180;){
        let t = n.locationToScreenPoint(e1);
        if (t.x >= 0 && t.y >= 0 && t.x <= n.width && t.y <= n.height) break;
        e1.lng > n.center.lng ? e1.lng -= 360 : e1.lng += 360;
    }
    return e1.lng !== i.lng && n.isPointOnMapSurface(n.locationToScreenPoint(e1)) ? e1 : i;
}
const $4324d99ae8520741$var$Nm = {
    center: `translate(-50%,-50%)`,
    top: `translate(-50%,0)`,
    "top-left": `translate(0,0)`,
    "top-right": `translate(-100%,0)`,
    bottom: `translate(-50%,-100%)`,
    "bottom-left": `translate(0,-100%)`,
    "bottom-right": `translate(-100%,-100%)`,
    left: `translate(0,-50%)`,
    right: `translate(-100%,-50%)`
};
function $4324d99ae8520741$var$Pm(e1, t, n) {
    let r = e1.classList;
    for(let e1 in $4324d99ae8520741$var$Nm)r.remove(`maplibregl-${n}-anchor-${e1}`);
    r.add(`maplibregl-${n}-anchor-${t}`);
}
const $4324d99ae8520741$var$Fm = {
    ArrowLeft: [
        -1,
        0
    ],
    ArrowRight: [
        1,
        0
    ],
    ArrowUp: [
        0,
        -1
    ],
    ArrowDown: [
        0,
        1
    ]
}, $4324d99ae8520741$var$Im = `#3FB1CE`;
function $4324d99ae8520741$var$Lm(e1, t, n = []) {
    let r = $4324d99ae8520741$var$G.createNS(`http://www.w3.org/2000/svg`, e1);
    for(let e1 in t)r.setAttributeNS(null, e1, t[e1]);
    for (let e1 of n)r.appendChild(e1);
    return r;
}
let $4324d99ae8520741$var$Rm;
function $4324d99ae8520741$var$zm() {
    return $4324d99ae8520741$var$Rm || ($4324d99ae8520741$var$Rm = $4324d99ae8520741$var$Lm(`svg`, {
        display: `block`,
        height: `41px`,
        width: `27px`,
        viewBox: `0 0 27 41`
    }, [
        $4324d99ae8520741$var$Lm(`g`, {
            "fill-rule": `nonzero`
        }, [
            $4324d99ae8520741$var$Lm(`g`, {
                transform: `translate(3.0, 29.0)`,
                fill: `#000000`
            }, [
                [
                    `10.5`,
                    `5.25002273`
                ],
                [
                    `10.5`,
                    `5.25002273`
                ],
                [
                    `9.5`,
                    `4.77275007`
                ],
                [
                    `8.5`,
                    `4.29549936`
                ],
                [
                    `7.5`,
                    `3.81822308`
                ],
                [
                    `6.5`,
                    `3.34094679`
                ],
                [
                    `5.5`,
                    `2.86367051`
                ],
                [
                    `4.5`,
                    `2.38636864`
                ]
            ].map(([e1, t])=>$4324d99ae8520741$var$Lm(`ellipse`, {
                    opacity: `0.04`,
                    cx: `10.5`,
                    cy: `5.80029008`,
                    rx: e1,
                    ry: t
                }))),
            $4324d99ae8520741$var$Lm(`g`, {
                fill: $4324d99ae8520741$var$Im
            }, [
                $4324d99ae8520741$var$Lm(`path`, {
                    d: `M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z`
                })
            ]),
            $4324d99ae8520741$var$Lm(`g`, {
                opacity: `0.25`,
                fill: `#000000`
            }, [
                $4324d99ae8520741$var$Lm(`path`, {
                    d: `M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z`
                })
            ]),
            $4324d99ae8520741$var$Lm(`g`, {
                transform: `translate(6.0, 7.0)`,
                fill: `#FFFFFF`
            }),
            $4324d99ae8520741$var$Lm(`g`, {
                transform: `translate(8.0, 8.0)`
            }, [
                $4324d99ae8520741$var$Lm(`circle`, {
                    fill: `#000000`,
                    opacity: `0.25`,
                    cx: `5.5`,
                    cy: `5.5`,
                    r: `5.4999962`
                }),
                $4324d99ae8520741$var$Lm(`circle`, {
                    fill: `#FFFFFF`,
                    cx: `5.5`,
                    cy: `5.5`,
                    r: `5.4999962`
                })
            ])
        ])
    ]), $4324d99ae8520741$var$Rm);
}
function $4324d99ae8520741$var$Bm(e1) {
    return e1.firstElementChild.children[1];
}
var $4324d99ae8520741$export$4da46cf7208441a7 = class extends (0, $1G0Uw._n) {
}, $4324d99ae8520741$export$20d8ab55cf6e381 = class extends (0, $1G0Uw._n) {
}, $4324d99ae8520741$export$e98856a975cab58e = class extends (0, $1G0Uw.vn) {
    constructor(e1){
        if (super(), this._onClick = (e1)=>{
            this.fire(new $4324d99ae8520741$export$20d8ab55cf6e381(`click`, {
                originalEvent: e1
            }));
        }, this._onKeyPress = (e1)=>{
            (e1.code === `Space` || e1.code === `Enter`) && this.togglePopup();
        }, this._onKeyDown = (e1)=>{
            if (!this._defaultMarker || !this._draggable || !this._map || !this._lngLat || e1.composedPath()[0] !== this._element || e1.altKey || e1.ctrlKey || e1.metaKey) return;
            let t = $4324d99ae8520741$var$Fm[e1.key];
            if (!t) return;
            e1.preventDefault(), e1.stopPropagation();
            let n = e1.shiftKey ? 10 : 1, r = this._map.project(this._lngLat);
            this.setLngLat(this._map.unproject(new (0, $1G0Uw.Li)(r.x + t[0] * n, r.y + t[1] * n))), this._keyboardDragActive || (this._keyboardDragActive = !0, this.fire(new $4324d99ae8520741$export$4da46cf7208441a7(`dragstart`))), this.fire(new $4324d99ae8520741$export$4da46cf7208441a7(`drag`));
        }, this._onKeyUp = (e1)=>{
            $4324d99ae8520741$var$Fm[e1.key] && this._endKeyboardDrag();
        }, this._onBlur = ()=>{
            this._endKeyboardDrag();
        }, this._onMapClick = (e1)=>{
            let t = e1.originalEvent.target, n = this._element;
            this._popup && (t === n || n.contains(t)) && this.togglePopup();
        }, this._update = (e1)=>{
            if (!this._map) return;
            let t = this._map.loaded() && !this._map.isMoving();
            (e1?.type === `terrain` || e1?.type === `render` && !t) && this._map.once(`render`, this._update), this._lngLat = $4324d99ae8520741$var$Mm(this._lngLat, this._flatPos, this._map._camera.transform), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map._camera.transform.locationToScreenPoint(this._lngLat)._add(this._offset));
            let n = ``;
            this._rotationAlignment === `viewport` || this._rotationAlignment === `auto` ? n = `rotateZ(${this._rotation}deg)` : this._rotationAlignment === `map` && (n = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
            let r = ``;
            this._pitchAlignment === `viewport` || this._pitchAlignment === `auto` ? r = `rotateX(0deg)` : this._pitchAlignment === `map` && (r = `rotateX(${this._map.getPitch()}deg)`), !this._subpixelPositioning && (!e1 || e1.type === `moveend`) && (this._pos = this._pos.round()), this._element.style.transform = `${$4324d99ae8520741$var$Nm[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${r} ${n}`, $4324d99ae8520741$var$Rr.frameAsync(new AbortController, this._map._ownerWindow).then(()=>{
                this._updateOpacity(e1?.type === `moveend`);
            }).catch(()=>{});
        }, this._onMove = (e1)=>{
            if (!this._isDragging) {
                let t = this._clickTolerance || this._map._clickTolerance;
                this._isDragging = e1.point.dist(this._pointerdownPos) >= t;
            }
            this._isDragging && (this._pos = e1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = `none`, this._state === `pending` && (this._state = `active`, this.fire(new $4324d99ae8520741$export$4da46cf7208441a7(`dragstart`))), this.fire(new $4324d99ae8520741$export$4da46cf7208441a7(`drag`)));
        }, this._onUp = ()=>{
            this._element.style.pointerEvents = `auto`, this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off(`mousemove`, this._onMove), this._map.off(`touchmove`, this._onMove), this._state === `active` && this.fire(new $4324d99ae8520741$export$4da46cf7208441a7(`dragend`)), this._state = `inactive`;
        }, this._addDragHandler = (e1)=>{
            this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(this._pos).add(this._offset), this._pointerdownPos = e1.point, this._state = `pending`, this._map.on(`mousemove`, this._onMove), this._map.on(`touchmove`, this._onMove), this._map.once(`mouseup`, this._onUp), this._map.once(`touchend`, this._onUp));
        }, this._anchor = e1?.anchor || `center`, this._color = e1?.color || $4324d99ae8520741$var$Im, this._scale = e1?.scale || 1, this._draggable = e1?.draggable || !1, this._clickTolerance = e1?.clickTolerance || 0, this._subpixelPositioning = e1?.subpixelPositioning || !1, this._isDragging = !1, this._roleManaged = !1, this._tabIndexManaged = !1, this._keyboardDragActive = !1, this._state = `inactive`, this._rotation = e1?.rotation || 0, this._rotationAlignment = e1?.rotationAlignment || `auto`, this._pitchAlignment = e1?.pitchAlignment && e1.pitchAlignment !== `auto` ? e1.pitchAlignment : this._rotationAlignment, this.setOpacity(e1?.opacity, e1?.opacityWhenCovered), e1?.element) this._element = e1.element, this._offset = (0, $1G0Uw.Li).convert(e1?.offset || [
            0,
            0
        ]);
        else {
            this._defaultMarker = !0, this._element = $4324d99ae8520741$var$G.create(`div`);
            let t = $4324d99ae8520741$var$zm().cloneNode(!0);
            t.setAttributeNS(null, `height`, `${41 * this._scale}px`), t.setAttributeNS(null, `width`, `${27 * this._scale}px`), $4324d99ae8520741$var$Bm(t).setAttributeNS(null, `fill`, this._color), this._element.appendChild(t), this._offset = (0, $1G0Uw.Li).convert(e1?.offset || [
                0,
                -14
            ]);
        }
        if (this._element.classList.add(`maplibregl-marker`), this._element.addEventListener(`dragstart`, (e1)=>{
            e1.preventDefault();
        }), this._element.addEventListener(`mousedown`, (e1)=>{
            e1.preventDefault();
        }), $4324d99ae8520741$var$Pm(this._element, this._anchor, `marker`), e1?.className) for (let t of e1.className.split(` `))this._element.classList.add(t);
        this._popup = null;
    }
    addTo(e1) {
        return this.remove(), this._map = e1, this._defaultMarker && !this._element.hasAttribute(`aria-label`) && this._element.setAttribute(`aria-label`, e1._getUIString(`Marker.Title`)), this._updateAccessibilityRole(), e1.getCanvasContainer().appendChild(this._element), e1.on(`move`, this._update), e1.on(`moveend`, this._update), e1.on(`terrain`, this._update), e1.on(`projectiontransition`, this._update), this._element.addEventListener(`click`, this._onClick), this.setDraggable(this._draggable), this._update(), this._map.on(`click`, this._onMapClick), this;
    }
    remove() {
        return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off(`click`, this._onMapClick), this._map.off(`move`, this._update), this._map.off(`moveend`, this._update), this._map.off(`terrain`, this._update), this._map.off(`projectiontransition`, this._update), this._map.off(`mousedown`, this._addDragHandler), this._map.off(`touchstart`, this._addDragHandler), this._map.off(`mouseup`, this._onUp), this._map.off(`touchend`, this._onUp), this._map.off(`mousemove`, this._onMove), this._map.off(`touchmove`, this._onMove), delete this._map), this._element.removeEventListener(`click`, this._onClick), this._element.removeEventListener(`keydown`, this._onKeyDown), this._element.removeEventListener(`keyup`, this._onKeyUp), this._element.removeEventListener(`blur`, this._onBlur), this._element.removeEventListener(`keypress`, this._onKeyPress), this._keyboardDragActive = !1, this._element.remove(), this._popup && this._popup.remove(), this;
    }
    getLngLat() {
        return this._lngLat;
    }
    setLngLat(e1) {
        return this._lngLat = (0, $1G0Uw.lt).convert(e1), this._pos = null, this._update(), this._popup && this._popup.setLngLat(this._lngLat), this;
    }
    getElement() {
        return this._element;
    }
    setPopup(e1) {
        if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener(`keypress`, this._onKeyPress)), e1) {
            if (!(`offset` in e1.options)) {
                let t = 13.5 / Math.SQRT2;
                e1.options.offset = this._defaultMarker ? {
                    top: [
                        0,
                        0
                    ],
                    "top-left": [
                        0,
                        0
                    ],
                    "top-right": [
                        0,
                        0
                    ],
                    bottom: [
                        0,
                        -38.1
                    ],
                    "bottom-left": [
                        t,
                        (24.6 + t) * -1
                    ],
                    "bottom-right": [
                        -t,
                        (24.6 + t) * -1
                    ],
                    left: [
                        13.5,
                        -24.6
                    ],
                    right: [
                        -13.5,
                        -24.6
                    ]
                } : this._offset;
            }
            this._popup = e1, this._element.addEventListener(`keypress`, this._onKeyPress);
        }
        return this._updateTabIndex(), this._updateAccessibilityRole(), this;
    }
    setSubpixelPositioning(e1) {
        return this._subpixelPositioning = e1, this;
    }
    _endKeyboardDrag() {
        this._keyboardDragActive && (this._keyboardDragActive = !1, this.fire(new $4324d99ae8520741$export$4da46cf7208441a7(`dragend`)));
    }
    getPopup() {
        return this._popup;
    }
    togglePopup() {
        let e1 = this._popup;
        if (this._element.style.opacity === this._opacityWhenCovered) return this;
        if (e1) e1.isOpen() ? e1.remove() : (e1.setLngLat(this._lngLat), e1.addTo(this._map));
        else return this;
        return this;
    }
    _updateOpacity(e1 = !1) {
        let { width: t, height: n } = this._map._camera.transform;
        if (!this._pos || this._pos.x < 0 || this._pos.y < 0 || this._pos.x > t || this._pos.y > n) return;
        let r = this._map?.terrain, i = this._map._camera.transform.isLocationOccluded(this._lngLat);
        if (!r || i) {
            let e1 = i ? this._opacityWhenCovered : this._opacity;
            this._element.style.opacity !== e1 && (this._element.style.opacity = e1, this._element.classList.toggle(`maplibregl-marker-covered`, i));
            return;
        }
        if (e1) this._opacityTimeout = null;
        else {
            if (this._opacityTimeout) return;
            this._opacityTimeout = setTimeout(()=>{
                this._opacityTimeout = null;
            }, 100);
        }
        let a = this._map, o = a.terrain.depthAtPoint(this._pos), s = a.terrain.getElevationForLngLat(this._lngLat, a._camera.transform), c = a._camera.transform.lngLatToCameraDepth(this._lngLat, s), l = .006;
        if (c - o < l) {
            this._element.style.opacity = this._opacity, this._element.classList.remove(`maplibregl-marker-covered`);
            return;
        }
        let u = -this._offset.y / a._camera.transform.pixelsPerMeter, d = Math.sin(a.getPitch() * Math.PI / 180) * u, f = a.terrain.depthAtPoint(new (0, $1G0Uw.Li)(this._pos.x, this._pos.y - this._offset.y)), p = a._camera.transform.lngLatToCameraDepth(this._lngLat, s + d) - f > l;
        this._popup?.isOpen() && p && this._popup.remove(), this._element.style.opacity = p ? this._opacityWhenCovered : this._opacity, this._element.classList.toggle(`maplibregl-marker-covered`, p);
    }
    getOffset() {
        return this._offset;
    }
    setOffset(e1) {
        return this._offset = (0, $1G0Uw.Li).convert(e1), this._update(), this;
    }
    addClassName(e1) {
        this._element.classList.add(e1);
    }
    removeClassName(e1) {
        this._element.classList.remove(e1);
    }
    toggleClassName(e1) {
        return this._element.classList.toggle(e1);
    }
    setDraggable(e1) {
        return this._draggable = !!e1, this._element.classList.toggle(`maplibregl-marker-draggable`, this._draggable), this._map && (e1 ? (this._map.on(`mousedown`, this._addDragHandler), this._map.on(`touchstart`, this._addDragHandler)) : (this._map.off(`mousedown`, this._addDragHandler), this._map.off(`touchstart`, this._addDragHandler))), this._defaultMarker && (this._draggable ? (this._element.addEventListener(`keydown`, this._onKeyDown), this._element.addEventListener(`keyup`, this._onKeyUp), this._element.addEventListener(`blur`, this._onBlur)) : (this._element.removeEventListener(`keydown`, this._onKeyDown), this._element.removeEventListener(`keyup`, this._onKeyUp), this._element.removeEventListener(`blur`, this._onBlur), this._endKeyboardDrag())), this._updateTabIndex(), this._updateAccessibilityRole(), this;
    }
    isDraggable() {
        return this._draggable;
    }
    _updateTabIndex() {
        this._popup || this._defaultMarker && this._draggable ? this._element.hasAttribute(`tabindex`) || (this._element.setAttribute(`tabindex`, `0`), this._tabIndexManaged = !0) : this._tabIndexManaged &&= (this._element.getAttribute(`tabindex`) === `0` && this._element.removeAttribute(`tabindex`), !1);
    }
    _updateAccessibilityRole() {
        if (!this._defaultMarker || this._element.hasAttribute(`role`) && !this._roleManaged) return;
        let e1 = this._draggable || this._popup ? `button` : `img`;
        this._element.setAttribute(`role`, e1), this._roleManaged = !0;
    }
    setRotation(e1) {
        return this._rotation = e1 || 0, this._update(), this;
    }
    getRotation() {
        return this._rotation;
    }
    setRotationAlignment(e1) {
        return this._rotationAlignment = e1 || `auto`, this._update(), this;
    }
    getRotationAlignment() {
        return this._rotationAlignment;
    }
    setPitchAlignment(e1) {
        return this._pitchAlignment = e1 && e1 !== `auto` ? e1 : this._rotationAlignment, this._update(), this;
    }
    getPitchAlignment() {
        return this._pitchAlignment;
    }
    setOpacity(e1, t) {
        return (this._opacity === void 0 || e1 === void 0 && t === void 0) && (this._opacity = `1`, this._opacityWhenCovered = `0.2`), e1 !== void 0 && (this._opacity = String(e1)), t !== void 0 && (this._opacityWhenCovered = String(t)), this._map && this._updateOpacity(!0), this;
    }
};
const $4324d99ae8520741$var$Wm = {
    positionOptions: {
        enableHighAccuracy: !1,
        maximumAge: 0,
        timeout: 6e3
    },
    fitBoundsOptions: {
        maxZoom: 15
    },
    trackUserLocation: !1,
    showAccuracyCircle: !0,
    showUserLocation: !0
};
let $4324d99ae8520741$var$Gm = 0, $4324d99ae8520741$var$Km = !1;
var $4324d99ae8520741$export$caf365a3870a7616 = class extends (0, $1G0Uw._n) {
}, $4324d99ae8520741$export$d3cbd8e3df821073 = class extends (0, $1G0Uw._n) {
}, $4324d99ae8520741$export$319ba8bf7a75a42a = class extends (0, $1G0Uw._n) {
}, $4324d99ae8520741$export$15e4ff48f7e9d8e0 = class extends (0, $1G0Uw.vn) {
    constructor(e1){
        super(), this._onSuccess = (e1)=>{
            if (this._map) {
                if (this._isOutOfMapMaxBounds(e1)) {
                    this._setErrorState(), this.fire(new $4324d99ae8520741$export$d3cbd8e3df821073(`outofmaxbounds`, e1)), this._updateMarker(), this._finish();
                    return;
                }
                if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                    case `WAITING_ACTIVE`:
                    case `ACTIVE_LOCK`:
                    case `ACTIVE_ERROR`:
                        this._watchState = `ACTIVE_LOCK`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active-error`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active`);
                        break;
                    case `BACKGROUND`:
                    case `BACKGROUND_ERROR`:
                        this._watchState = `BACKGROUND`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background-error`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-background`);
                        break;
                    default:
                        throw Error(`Unexpected watchState ${this._watchState}`);
                }
                this.options.showUserLocation && this._watchState !== `OFF` && this._updateMarker(e1), (!this.options.trackUserLocation || this._watchState === `ACTIVE_LOCK`) && this._updateCamera(e1), this.options.showUserLocation && this._dotElement.classList.remove(`maplibregl-user-location-dot-stale`), this.fire(new $4324d99ae8520741$export$d3cbd8e3df821073(`geolocate`, e1)), this._finish();
            }
        }, this._updateCamera = (e1)=>{
            let t = new (0, $1G0Uw.lt)(e1.coords.longitude, e1.coords.latitude), n = e1.coords.accuracy, r = this._map.getBearing(), i = (0, $1G0Uw.er)({
                bearing: r
            }, this.options.fitBoundsOptions), a = $4324d99ae8520741$export$266d2884f61535d3.fromLngLat(t, n);
            this._map.fitBounds(a, i, {
                geolocateSource: !0
            });
        }, this._updateMarker = (e1)=>{
            if (e1) {
                let t = new (0, $1G0Uw.lt)(e1.coords.longitude, e1.coords.latitude);
                this._accuracyCircleMarker.setLngLat(t).addTo(this._map), this._userLocationDotMarker.setLngLat(t).addTo(this._map), this._accuracy = e1.coords.accuracy, this._updateCircleRadiusIfNeeded();
            } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
        }, this._onUpdate = ()=>{
            this._updateCircleRadiusIfNeeded();
        }, this._onError = (e1)=>{
            if (this._map) {
                if (e1.code === 1) {
                    this._watchState = `OFF`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active-error`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background-error`), this._geolocateButton.disabled = !0;
                    let e1 = this._map._getUIString(`GeolocateControl.LocationNotAvailable`);
                    this._geolocateButton.title = e1, this._geolocateButton.setAttribute(`aria-label`, e1), this._geolocationWatchID !== void 0 && this._clearWatch();
                } else if (e1.code === 3 && $4324d99ae8520741$var$Km) return;
                else this._setErrorState();
                this._watchState !== `OFF` && this.options.showUserLocation && this._dotElement.classList.add(`maplibregl-user-location-dot-stale`), this.fire(new $4324d99ae8520741$export$319ba8bf7a75a42a(`error`, e1)), this._finish();
            }
        }, this._finish = ()=>{
            this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
        }, this._onMoveStart = (e1)=>{
            if (!this._map) return;
            let t = e1?.[0] instanceof ResizeObserverEntry;
            !e1.geolocateSource && this._watchState === `ACTIVE_LOCK` && !t && !this._map.isZooming() && (this._watchState = `BACKGROUND`, this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-background`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this.fire(new $4324d99ae8520741$export$caf365a3870a7616(`trackuserlocationend`)), this.fire(new $4324d99ae8520741$export$caf365a3870a7616(`userlocationlostfocus`)));
        }, this._setupUI = ()=>{
            this._map && (this._container.addEventListener(`contextmenu`, (e1)=>{
                e1.preventDefault();
            }), this._geolocateButton = $4324d99ae8520741$var$G.create(`button`, `maplibregl-ctrl-geolocate`, this._container), $4324d99ae8520741$var$G.create(`span`, `maplibregl-ctrl-icon`, this._geolocateButton).setAttribute(`aria-hidden`, `true`), this._geolocateButton.type = `button`, this._geolocateButton.disabled = !0);
        }, this._finishSetupUI = (e1)=>{
            if (this._map) {
                if (e1 === !1) {
                    (0, $1G0Uw.Nr)(`Geolocation support is not available so the GeolocateControl will be disabled.`);
                    let e1 = this._map._getUIString(`GeolocateControl.LocationNotAvailable`);
                    this._geolocateButton.disabled = !0, this._geolocateButton.title = e1, this._geolocateButton.setAttribute(`aria-label`, e1);
                } else {
                    let e1 = this._map._getUIString(`GeolocateControl.FindMyLocation`);
                    this._geolocateButton.disabled = !1, this._geolocateButton.title = e1, this._geolocateButton.setAttribute(`aria-label`, e1);
                }
                this.options.trackUserLocation && (this._geolocateButton.setAttribute(`aria-pressed`, `false`), this._watchState = `OFF`), this.options.showUserLocation && (this._dotElement = $4324d99ae8520741$var$G.create(`div`, `maplibregl-user-location-dot`), this._userLocationDotMarker = new $4324d99ae8520741$export$e98856a975cab58e({
                    element: this._dotElement
                }), this._circleElement = $4324d99ae8520741$var$G.create(`div`, `maplibregl-user-location-accuracy-circle`), this._accuracyCircleMarker = new $4324d99ae8520741$export$e98856a975cab58e({
                    element: this._circleElement,
                    pitchAlignment: `map`
                }), this.options.trackUserLocation && (this._watchState = `OFF`), this._map.on(`zoom`, this._onUpdate), this._map.on(`move`, this._onUpdate), this._map.on(`rotate`, this._onUpdate), this._map.on(`pitch`, this._onUpdate)), this._geolocateButton.addEventListener(`click`, ()=>this.trigger()), this._setup = !0, this.options.trackUserLocation && this._map.on(`movestart`, this._onMoveStart);
            }
        }, this.options = (0, $1G0Uw.er)({}, $4324d99ae8520741$var$Wm, e1);
    }
    onAdd(e1) {
        return this._map = e1, this._container = $4324d99ae8520741$var$G.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._setupUI(), $4324d99ae8520741$var$jm().then((e1)=>this._finishSetupUI(e1)), this._container;
    }
    onRemove() {
        this._geolocationWatchID !== void 0 && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off(`movestart`, this._onMoveStart), this._map.off(`zoom`, this._onUpdate), this._map.off(`move`, this._onUpdate), this._map.off(`rotate`, this._onUpdate), this._map.off(`pitch`, this._onUpdate), this._map = void 0, $4324d99ae8520741$var$Gm = 0, $4324d99ae8520741$var$Km = !1;
    }
    _isOutOfMapMaxBounds(e1) {
        let t = this._map.getMaxBounds(), n = e1.coords;
        return t && (n.longitude < t.getWest() || n.longitude > t.getEast() || n.latitude < t.getSouth() || n.latitude > t.getNorth());
    }
    _setErrorState() {
        switch(this._watchState){
            case `WAITING_ACTIVE`:
                this._watchState = `ACTIVE_ERROR`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active-error`);
                break;
            case `ACTIVE_LOCK`:
                this._watchState = `ACTIVE_ERROR`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active-error`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-waiting`);
                break;
            case `BACKGROUND`:
                this._watchState = `BACKGROUND_ERROR`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-background-error`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-waiting`);
                break;
            case `ACTIVE_ERROR`:
            case `BACKGROUND_ERROR`:
                break;
            case `OFF`:
            case void 0:
                break;
            default:
                throw Error(`Unexpected watchState ${this._watchState}`);
        }
    }
    _updateCircleRadiusIfNeeded() {
        let e1 = this._userLocationDotMarker.getLngLat();
        if (!this.options.showUserLocation || !this.options.showAccuracyCircle || !this._accuracy || !e1) return;
        let t = this._map.project(e1), n = this._map.unproject([
            t.x + 100,
            t.y
        ]), r = e1.distanceTo(n) / 100, i = 2 * this._accuracy / r;
        this._circleElement.style.width = `${i.toFixed(2)}px`, this._circleElement.style.height = `${i.toFixed(2)}px`;
    }
    trigger() {
        if (!this._setup) return (0, $1G0Uw.Nr)(`Geolocate control triggered before added to a map`), !1;
        if (this.options.trackUserLocation) {
            switch(this._watchState){
                case `OFF`:
                    this._watchState = `WAITING_ACTIVE`, this.fire(new $4324d99ae8520741$export$caf365a3870a7616(`trackuserlocationstart`));
                    break;
                case `WAITING_ACTIVE`:
                case `ACTIVE_LOCK`:
                case `ACTIVE_ERROR`:
                case `BACKGROUND_ERROR`:
                    $4324d99ae8520741$var$Gm--, $4324d99ae8520741$var$Km = !1, this._watchState = `OFF`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-active-error`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background`), this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background-error`), this.fire(new $4324d99ae8520741$export$caf365a3870a7616(`trackuserlocationend`));
                    break;
                case `BACKGROUND`:
                    this._watchState = `ACTIVE_LOCK`, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-background`), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new $4324d99ae8520741$export$caf365a3870a7616(`trackuserlocationstart`)), this.fire(new $4324d99ae8520741$export$caf365a3870a7616(`userlocationfocus`));
                    break;
                default:
                    throw Error(`Unexpected watchState ${this._watchState}`);
            }
            switch(this._watchState){
                case `WAITING_ACTIVE`:
                    this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active`);
                    break;
                case `ACTIVE_LOCK`:
                    this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-active`);
                    break;
                case `OFF`:
                    break;
                default:
                    throw Error(`Unexpected watchState ${this._watchState}`);
            }
            if (this._watchState === `OFF` && this._geolocationWatchID !== void 0) this._clearWatch();
            else if (this._geolocationWatchID === void 0) {
                this._geolocateButton.classList.add(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.setAttribute(`aria-pressed`, `true`), $4324d99ae8520741$var$Gm++;
                let e1;
                $4324d99ae8520741$var$Gm > 1 ? (e1 = {
                    maximumAge: 6e5,
                    timeout: 0
                }, $4324d99ae8520741$var$Km = !0) : (e1 = this.options.positionOptions, $4324d99ae8520741$var$Km = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e1);
            }
        } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
        return !0;
    }
    _clearWatch() {
        window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove(`maplibregl-ctrl-geolocate-waiting`), this._geolocateButton.setAttribute(`aria-pressed`, `false`), this.options.showUserLocation && this._updateMarker(null);
    }
};
const $4324d99ae8520741$var$Zm = {
    maxWidth: 100,
    unit: `metric`
};
var $4324d99ae8520741$export$1fb16e435eedcce9 = class {
    constructor(e1){
        this._onMove = ()=>{
            $4324d99ae8520741$var$$m(this._map, this._container, this.options);
        }, this.setUnit = (e1)=>{
            this.options.unit = e1, $4324d99ae8520741$var$$m(this._map, this._container, this.options);
        }, this.options = {
            ...$4324d99ae8520741$var$Zm,
            ...e1
        };
    }
    getDefaultPosition() {
        return `bottom-left`;
    }
    onAdd(e1) {
        return this._map = e1, this._container = $4324d99ae8520741$var$G.create(`div`, `maplibregl-ctrl maplibregl-ctrl-scale`, e1.getContainer()), this._map.on(`move`, this._onMove), this._onMove(), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`move`, this._onMove), this._map = void 0;
    }
};
function $4324d99ae8520741$var$$m(e1, t, n) {
    let r = n?.maxWidth || 100, { width: i, height: a } = e1._camera.transform, o = a / 2, s = i / 2, c = e1.unproject([
        s - r / 2,
        o
    ]), l = e1.unproject([
        s + r / 2,
        o
    ]), u = Math.round(e1.project(l).x - e1.project(c).x), d = Math.min(r, u, i), f = c.distanceTo(l);
    if (n?.unit === `imperial`) {
        let n = 3.2808 * f;
        n > 5280 ? $4324d99ae8520741$var$eh(t, d, n / 5280, e1._getUIString(`ScaleControl.Miles`)) : $4324d99ae8520741$var$eh(t, d, n, e1._getUIString(`ScaleControl.Feet`));
    } else n?.unit === `nautical` ? $4324d99ae8520741$var$eh(t, d, f / 1852, e1._getUIString(`ScaleControl.NauticalMiles`)) : f >= 1e3 ? $4324d99ae8520741$var$eh(t, d, f / 1e3, e1._getUIString(`ScaleControl.Kilometers`)) : $4324d99ae8520741$var$eh(t, d, f, e1._getUIString(`ScaleControl.Meters`));
}
function $4324d99ae8520741$var$eh(e1, t, n, r) {
    let i = $4324d99ae8520741$var$nh(n), a = i / n;
    e1.style.width = `${t * a}px`;
    let o = `${i}\u00a0${r}`;
    e1.textContent !== o && (e1.textContent = o);
}
function $4324d99ae8520741$var$th(e1) {
    let t = 10 ** Math.ceil(-Math.log(e1) / Math.LN10);
    return Math.round(e1 * t) / t;
}
function $4324d99ae8520741$var$nh(e1) {
    let t = 10 ** (`${Math.floor(e1)}`.length - 1), n = e1 / t;
    return n = n >= 10 ? 10 : n >= 5 ? 5 : n >= 3 ? 3 : n >= 2 ? 2 : n >= 1 ? 1 : $4324d99ae8520741$var$th(n), t * n;
}
var $4324d99ae8520741$export$a2126d0731cda86b = class extends (0, $1G0Uw._n) {
}, $4324d99ae8520741$export$91e8ffb52c2b32c5 = class extends (0, $1G0Uw.vn) {
    constructor(e1 = {}){
        super(), this._onFullscreenChange = ()=>{
            let e1 = window.document.fullscreenElement || window.document.webkitFullscreenElement;
            for(; e1?.shadowRoot?.fullscreenElement;)e1 = e1.shadowRoot.fullscreenElement;
            e1 === this._container !== this._fullscreen && this._handleFullscreenChange();
        }, this._onClickFullscreen = ()=>{
            this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
        }, this._fullscreen = !1, this._pseudo = e1.pseudo ?? !1, e1?.container && (e1.container instanceof HTMLElement ? this._container = e1.container : (0, $1G0Uw.Nr)(`Full screen control 'container' must be a DOM element.`)), `onfullscreenchange` in document ? this._fullscreenchange = `fullscreenchange` : `onmozfullscreenchange` in document ? this._fullscreenchange = `mozfullscreenchange` : `onwebkitfullscreenchange` in document ? this._fullscreenchange = `webkitfullscreenchange` : `onmsfullscreenchange` in document && (this._fullscreenchange = `MSFullscreenChange`);
    }
    onAdd(e1) {
        return this._map = e1, this._container ||= this._map.getContainer(), this._controlContainer = $4324d99ae8520741$var$G.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._setupUI(), this._controlContainer;
    }
    onRemove() {
        this._controlContainer.remove(), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
    }
    _setupUI() {
        let e1 = this._fullscreenButton = $4324d99ae8520741$var$G.create(`button`, `maplibregl-ctrl-fullscreen`, this._controlContainer);
        $4324d99ae8520741$var$G.create(`span`, `maplibregl-ctrl-icon`, e1).setAttribute(`aria-hidden`, `true`), e1.type = `button`, this._updateTitle(), this._fullscreenButton.addEventListener(`click`, this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
    }
    _updateTitle() {
        let e1 = this._getTitle();
        this._fullscreenButton.setAttribute(`aria-label`, e1), this._fullscreenButton.title = e1;
    }
    _getTitle() {
        return this._map._getUIString(this._isFullscreen() ? `FullscreenControl.Exit` : `FullscreenControl.Enter`);
    }
    _isFullscreen() {
        return this._fullscreen;
    }
    _handleFullscreenChange() {
        this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle(`maplibregl-ctrl-shrink`), this._fullscreenButton.classList.toggle(`maplibregl-ctrl-fullscreen`), this._updateTitle(), this._fullscreen ? (this.fire(new $4324d99ae8520741$export$a2126d0731cda86b(`fullscreenstart`)), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new $4324d99ae8520741$export$a2126d0731cda86b(`fullscreenend`)), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
    }
    _exitFullscreen() {
        this._pseudo ? this._togglePseudoFullScreen() : window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
    }
    _requestFullscreen() {
        this._pseudo ? this._togglePseudoFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
    }
    _togglePseudoFullScreen() {
        this._container.classList.toggle(`maplibregl-pseudo-fullscreen`), this._handleFullscreenChange(), this._map.resize();
    }
}, $4324d99ae8520741$export$cc733900d53f94f9 = class {
    constructor(e1){
        this._toggleTerrain = ()=>{
            this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
        }, this._updateTerrainIcon = ()=>{
            this._terrainButton.classList.remove(`maplibregl-ctrl-terrain`), this._terrainButton.classList.remove(`maplibregl-ctrl-terrain-enabled`), this._map.terrain ? (this._terrainButton.classList.add(`maplibregl-ctrl-terrain-enabled`), this._terrainButton.title = this._map._getUIString(`TerrainControl.Disable`)) : (this._terrainButton.classList.add(`maplibregl-ctrl-terrain`), this._terrainButton.title = this._map._getUIString(`TerrainControl.Enable`));
        }, this.options = e1;
    }
    onAdd(e1) {
        return this._map = e1, this._container = $4324d99ae8520741$var$G.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._terrainButton = $4324d99ae8520741$var$G.create(`button`, `maplibregl-ctrl-terrain`, this._container), $4324d99ae8520741$var$G.create(`span`, `maplibregl-ctrl-icon`, this._terrainButton).setAttribute(`aria-hidden`, `true`), this._terrainButton.type = `button`, this._terrainButton.addEventListener(`click`, this._toggleTerrain), this._updateTerrainIcon(), this._map.on(`terrain`, this._updateTerrainIcon), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`terrain`, this._updateTerrainIcon), this._map = void 0;
    }
}, $4324d99ae8520741$export$9618410ded3c9550 = class {
    constructor(){
        this._toggleProjection = ()=>{
            let e1 = this._map.getProjection()?.type;
            e1 === `mercator` || !e1 ? this._map.setProjection({
                type: `globe`
            }) : this._map.setProjection({
                type: `mercator`
            }), this._updateGlobeIcon();
        }, this._updateGlobeIcon = ()=>{
            this._globeButton.classList.remove(`maplibregl-ctrl-globe`), this._globeButton.classList.remove(`maplibregl-ctrl-globe-enabled`), this._map.getProjection()?.type === `globe` ? (this._globeButton.classList.add(`maplibregl-ctrl-globe-enabled`), this._globeButton.title = this._map._getUIString(`GlobeControl.Disable`)) : (this._globeButton.classList.add(`maplibregl-ctrl-globe`), this._globeButton.title = this._map._getUIString(`GlobeControl.Enable`));
        };
    }
    onAdd(e1) {
        return this._map = e1, this._container = $4324d99ae8520741$var$G.create(`div`, `maplibregl-ctrl maplibregl-ctrl-group`), this._globeButton = $4324d99ae8520741$var$G.create(`button`, `maplibregl-ctrl-globe`, this._container), $4324d99ae8520741$var$G.create(`span`, `maplibregl-ctrl-icon`, this._globeButton).setAttribute(`aria-hidden`, `true`), this._globeButton.type = `button`, this._globeButton.addEventListener(`click`, this._toggleProjection), this._updateGlobeIcon(), this._map.on(`styledata`, this._updateGlobeIcon), this._map.on(`projectiontransition`, this._updateGlobeIcon), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off(`styledata`, this._updateGlobeIcon), this._map.off(`projectiontransition`, this._updateGlobeIcon), this._globeButton.removeEventListener(`click`, this._toggleProjection), this._map = void 0;
    }
};
const $4324d99ae8520741$var$sh = {
    closeButton: !0,
    closeOnClick: !0,
    focusAfterOpen: !0,
    className: ``,
    maxWidth: `240px`,
    subpixelPositioning: !1,
    locationOccludedOpacity: void 0,
    padding: void 0
}, $4324d99ae8520741$var$ch = [
    `a[href]`,
    `[tabindex]:not([tabindex='-1'])`,
    `[contenteditable]:not([contenteditable='false'])`,
    `button:not([disabled])`,
    `input:not([disabled])`,
    `select:not([disabled])`,
    `textarea:not([disabled])`
].join(`, `);
var $4324d99ae8520741$export$c09aca14b6b2f8f0 = class extends (0, $1G0Uw._n) {
}, $4324d99ae8520741$export$129a32eedafa97c5 = class extends (0, $1G0Uw.vn) {
    constructor(e1){
        super(), this._updateOpacity = ()=>{
            this.options.locationOccludedOpacity !== void 0 && (this._map._camera.transform.isLocationOccluded(this.getLngLat()) ? this._container.style.opacity = `${this.options.locationOccludedOpacity}` : this._container.style.opacity = ``);
        }, this.remove = ()=>(this._content && this._content.remove(), this._container && (this._container.remove(), delete this._container), this._map && (this._map.off(`move`, this._update), this._map.off(`move`, this._onClose), this._map.off(`click`, this._onClose), this._map.off(`remove`, this.remove), this._map.off(`terrain`, this._update), this._map.off(`projectiontransition`, this._update), this._map.off(`mousemove`, this._update), this._map.off(`mouseup`, this._update), this._map.off(`drag`, this._update), this._map._canvasContainer.classList.remove(`maplibregl-track-pointer`), delete this._map, this.fire(new $4324d99ae8520741$export$c09aca14b6b2f8f0(`close`))), this), this._update = (e1)=>{
            let t = this._lngLat || this._trackPointer;
            if (!this._map || !t || !this._content) return;
            if (!this._container) {
                if (this._container = $4324d99ae8520741$var$G.create(`div`, `maplibregl-popup`, this._map.getContainer()), this._tip = $4324d99ae8520741$var$G.create(`div`, `maplibregl-popup-tip`, this._container), this._container.appendChild(this._content), this.options.className) for (let e1 of this.options.className.split(` `))this._container.classList.add(e1);
                this._closeButton && this._closeButton.setAttribute(`aria-label`, this._map._getUIString(`Popup.Close`)), this._trackPointer && this._container.classList.add(`maplibregl-popup-track-pointer`);
            }
            this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._lngLat = $4324d99ae8520741$var$Mm(this._lngLat, this._flatPos, this._map._camera.transform, this._trackPointer);
            let n;
            if (e1 && `point` in e1 && e1.point && (n = e1.point), this._trackPointer && !n) return;
            let r = this._flatPos = this._pos = this._trackPointer && n ? n : this._map.project(this._lngLat);
            this._map.terrain && (this._flatPos = this._trackPointer && n ? n : this._map._camera.transform.locationToScreenPoint(this._lngLat));
            let i = this.options.anchor, a = $4324d99ae8520741$var$dh(this.options.offset);
            if (!i) {
                let e1 = this._container.offsetWidth, t = this._container.offsetHeight, n = $4324d99ae8520741$var$fh(this.options.padding), o;
                o = r.y + a.bottom.y < t + n.top ? [
                    `top`
                ] : r.y > this._map._camera.transform.height - t - n.bottom ? [
                    `bottom`
                ] : [], r.x < e1 / 2 + n.left ? o.push(`left`) : r.x > this._map._camera.transform.width - e1 / 2 - n.right && o.push(`right`), i = o.length === 0 ? `bottom` : o.join(`-`);
            }
            let o = r.add(a[i]);
            this.options.subpixelPositioning || (o = o.round()), this._container.style.transform = `${$4324d99ae8520741$var$Nm[i]} translate(${o.x}px,${o.y}px)`, $4324d99ae8520741$var$Pm(this._container, i, `popup`), this._updateOpacity();
        }, this._onClose = ()=>{
            this.remove();
        }, this.options = (0, $1G0Uw.er)(Object.create($4324d99ae8520741$var$sh), e1);
    }
    addTo(e1) {
        return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on(`click`, this._onClose), this.options.closeOnMove && this._map.on(`move`, this._onClose), this._map.on(`remove`, this.remove), this._map.on(`terrain`, this._update), this._map.on(`projectiontransition`, this._update), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on(`mousemove`, this._update), this._map.on(`mouseup`, this._update), this._container && this._container.classList.add(`maplibregl-popup-track-pointer`), this._map._canvasContainer.classList.add(`maplibregl-track-pointer`)) : this._map.on(`move`, this._update), this.fire(new $4324d99ae8520741$export$c09aca14b6b2f8f0(`open`)), this;
    }
    isOpen() {
        return !!this._map;
    }
    getLngLat() {
        return this._lngLat;
    }
    setLngLat(e1) {
        return this._lngLat = (0, $1G0Uw.lt).convert(e1), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on(`move`, this._update), this._map.off(`mousemove`, this._update), this._container && this._container.classList.remove(`maplibregl-popup-track-pointer`), this._map._canvasContainer.classList.remove(`maplibregl-track-pointer`)), this;
    }
    trackPointer() {
        return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off(`move`, this._update), this._map.on(`mousemove`, this._update), this._map.on(`drag`, this._update), this._container && this._container.classList.add(`maplibregl-popup-track-pointer`), this._map._canvasContainer.classList.add(`maplibregl-track-pointer`)), this;
    }
    getElement() {
        return this._container;
    }
    setText(e1) {
        return this.setDOMContent(document.createTextNode(e1));
    }
    setHTML(e1) {
        let t = document.createDocumentFragment(), n = document.createElement(`body`), r;
        for(n.innerHTML = e1; r = n.firstChild, r;)t.appendChild(r);
        return this.setDOMContent(t);
    }
    getMaxWidth() {
        return this._container?.style.maxWidth;
    }
    setMaxWidth(e1) {
        return this.options.maxWidth = e1, this._update(), this;
    }
    setDOMContent(e1) {
        if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
        else this._content = $4324d99ae8520741$var$G.create(`div`, `maplibregl-popup-content`, this._container);
        return this._content.appendChild(e1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
    }
    addClassName(e1) {
        return this._container && this._container.classList.add(e1), this;
    }
    removeClassName(e1) {
        return this._container && this._container.classList.remove(e1), this;
    }
    setOffset(e1) {
        return this.options.offset = e1, this._update(), this;
    }
    toggleClassName(e1) {
        if (this._container) return this._container.classList.toggle(e1);
    }
    setSubpixelPositioning(e1) {
        this.options.subpixelPositioning = e1;
    }
    setPadding(e1) {
        this.options.padding = e1, this._update();
    }
    _createCloseButton() {
        this.options.closeButton && (this._closeButton = $4324d99ae8520741$var$G.create(`button`, `maplibregl-popup-close-button`, this._content), this._closeButton.type = `button`, this._closeButton.innerHTML = `&#215;`, this._closeButton.addEventListener(`click`, this._onClose));
    }
    _focusFirstElement() {
        if (!this.options.focusAfterOpen || !this._container) return;
        let e1 = this._container.querySelector($4324d99ae8520741$var$ch);
        e1 && e1.focus();
    }
};
function $4324d99ae8520741$var$dh(e1) {
    if (!e1) return $4324d99ae8520741$var$dh(new (0, $1G0Uw.Li)(0, 0));
    if (typeof e1 == `number`) {
        let t = Math.round(Math.abs(e1) / Math.SQRT2);
        return {
            center: new (0, $1G0Uw.Li)(0, 0),
            top: new (0, $1G0Uw.Li)(0, e1),
            "top-left": new (0, $1G0Uw.Li)(t, t),
            "top-right": new (0, $1G0Uw.Li)(-t, t),
            bottom: new (0, $1G0Uw.Li)(0, -e1),
            "bottom-left": new (0, $1G0Uw.Li)(t, -t),
            "bottom-right": new (0, $1G0Uw.Li)(-t, -t),
            left: new (0, $1G0Uw.Li)(e1, 0),
            right: new (0, $1G0Uw.Li)(-e1, 0)
        };
    }
    if (e1 instanceof (0, $1G0Uw.Li) || Array.isArray(e1)) {
        let t = (0, $1G0Uw.Li).convert(e1);
        return {
            center: t,
            top: t,
            "top-left": t,
            "top-right": t,
            bottom: t,
            "bottom-left": t,
            "bottom-right": t,
            left: t,
            right: t
        };
    }
    return {
        center: (0, $1G0Uw.Li).convert(e1.center || [
            0,
            0
        ]),
        top: (0, $1G0Uw.Li).convert(e1.top || [
            0,
            0
        ]),
        "top-left": (0, $1G0Uw.Li).convert(e1[`top-left`] || [
            0,
            0
        ]),
        "top-right": (0, $1G0Uw.Li).convert(e1[`top-right`] || [
            0,
            0
        ]),
        bottom: (0, $1G0Uw.Li).convert(e1.bottom || [
            0,
            0
        ]),
        "bottom-left": (0, $1G0Uw.Li).convert(e1[`bottom-left`] || [
            0,
            0
        ]),
        "bottom-right": (0, $1G0Uw.Li).convert(e1[`bottom-right`] || [
            0,
            0
        ]),
        left: (0, $1G0Uw.Li).convert(e1.left || [
            0,
            0
        ]),
        right: (0, $1G0Uw.Li).convert(e1.right || [
            0,
            0
        ])
    };
}
function $4324d99ae8520741$var$fh(e1) {
    return e1 ? {
        top: e1.top ?? 0,
        right: e1.right ?? 0,
        bottom: e1.bottom ?? 0,
        left: e1.left ?? 0
    } : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}
const $4324d99ae8520741$var$ph = $4324d99ae8520741$var$Ar;
function $4324d99ae8520741$export$80220802faa18fec(e1, t) {
    return $4324d99ae8520741$var$fo().setRTLTextPlugin(e1, t);
}
function $4324d99ae8520741$export$c8f205afdabdaef4() {
    return $4324d99ae8520741$var$fo().getRTLTextPluginStatus();
}
function $4324d99ae8520741$export$c506eb22e615ba4a() {
    return $4324d99ae8520741$var$ph;
}
function $4324d99ae8520741$export$33e4148f0a10446f() {
    return $4324d99ae8520741$var$Zi.workerCount;
}
function $4324d99ae8520741$export$ec8b1053ddd7f5bc(e1) {
    $4324d99ae8520741$var$Zi.workerCount = e1;
}
function $4324d99ae8520741$export$8ac2684f98a393b0() {
    return (0, $1G0Uw.An).MAX_PARALLEL_IMAGE_REQUESTS;
}
function $4324d99ae8520741$export$9569597edc1f5cf3(e1) {
    (0, $1G0Uw.An).MAX_PARALLEL_IMAGE_REQUESTS = e1;
}
function $4324d99ae8520741$export$b01b5f33620cab52() {
    return (0, $1G0Uw.An).WORKER_URL;
}
function $4324d99ae8520741$export$f7f2857281fba5f0(e1) {
    (0, $1G0Uw.An).WORKER_URL = e1;
}
async function $4324d99ae8520741$export$9cdc513767f0ece9(e1) {
    await $4324d99ae8520741$export$6f0c702cbe7d6ed8().broadcast(`IS`, e1);
}


//#region src/leaflet-maplibre-gl.mjs
var $93ab012a746d9149$var$L = $8JYDX.default || $8JYDX;
var $93ab012a746d9149$export$791e0dc7bfbc91fb = $93ab012a746d9149$var$L.Layer.extend({
    options: {
        updateInterval: 32,
        padding: .1,
        interactive: false,
        pane: "tilePane"
    },
    initialize: function(options) {
        $93ab012a746d9149$var$L.setOptions(this, options);
        this._throttledUpdate = $93ab012a746d9149$var$L.Util.throttle(this._update, this.options.updateInterval, this);
    },
    onAdd: function(map) {
        if (!this._container) this._initContainer();
        var paneName = this.getPaneName();
        map.getPane(paneName).appendChild(this._container);
        this._initGL();
        this._offset = this._map.containerPointToLayerPoint([
            0,
            0
        ]);
        if (map.options.zoomAnimation) $93ab012a746d9149$var$L.DomEvent.on(map._proxy, $93ab012a746d9149$var$L.DomUtil.TRANSITION_END, this._transitionEnd, this);
    },
    onRemove: function(map) {
        if (this._map._proxy && this._map.options.zoomAnimation) $93ab012a746d9149$var$L.DomEvent.off(this._map._proxy, $93ab012a746d9149$var$L.DomUtil.TRANSITION_END, this._transitionEnd, this);
        var paneName = this.getPaneName();
        map.getPane(paneName).removeChild(this._container);
        this._glMap.remove();
        this._glMap = null;
    },
    getEvents: function() {
        return {
            move: this._throttledUpdate,
            zoomanim: this._animateZoom,
            zoom: this._pinchZoom,
            zoomstart: this._zoomStart,
            zoomend: this._zoomEnd,
            resize: this._resize
        };
    },
    getAttribution: function() {
        if (this.options.attributionControl) return this.options.attributionControl.customAttribution;
        var map = this._glMap;
        if (map && this.options.attributionControl !== false) {
            var style = map.getStyle();
            if (style && style.sources) return Object.keys(style.sources).map(function(sourceId) {
                var source = map.getSource(sourceId);
                return source && typeof source.attribution === "string" ? source.attribution.trim() : null;
            }).filter(Boolean).join(", ");
        }
        return "";
    },
    getMaplibreMap: function() {
        return this._glMap;
    },
    getCanvas: function() {
        return this._glMap.getCanvas();
    },
    getSize: function() {
        return this._map.getSize().multiplyBy(1 + this.options.padding * 2);
    },
    getBounds: function() {
        var halfSize = this.getSize().multiplyBy(.5);
        var center = this._map.latLngToContainerPoint(this._map.getCenter());
        return $93ab012a746d9149$var$L.latLngBounds(this._map.containerPointToLatLng(center.subtract(halfSize)), this._map.containerPointToLatLng(center.add(halfSize)));
    },
    getContainer: function() {
        return this._container;
    },
    getPaneName: function() {
        return this._map.getPane(this.options.pane) ? this.options.pane : "tilePane";
    },
    _roundPoint: function(p) {
        return {
            x: Math.round(p.x),
            y: Math.round(p.y)
        };
    },
    _initContainer: function() {
        var container = this._container = $93ab012a746d9149$var$L.DomUtil.create("div", "leaflet-gl-layer");
        this._resizeContainer();
        var offset = this._map.getSize().multiplyBy(this.options.padding);
        var topLeft = this._map.containerPointToLayerPoint([
            0,
            0
        ]).subtract(offset);
        $93ab012a746d9149$var$L.DomUtil.setPosition(container, this._roundPoint(topLeft));
    },
    _resizeContainer: function() {
        var size = this.getSize();
        this._container.style.width = size.x + "px";
        this._container.style.height = size.y + "px";
    },
    _initGL: function() {
        var center = this._map.getCenter();
        var options = $93ab012a746d9149$var$L.extend({}, this.options, {
            container: this._container,
            center: [
                center.lng,
                center.lat
            ],
            zoom: this._map.getZoom() - 1,
            attributionControl: false
        });
        this._glMap = new $4324d99ae8520741$export$a5c7b93649eaf8f8(options);
        var _map = this._map;
        var _currentAttribution = this.getAttribution();
        var _getAttribution = this.getAttribution.bind(this);
        this._glMap.on("load", function() {
            if (_map && _map.attributionControl) {
                _map.attributionControl.removeAttribution(_currentAttribution);
                _map.attributionControl.addAttribution(_getAttribution());
            }
        });
        if (this._glMap.setTransformConstrain) this._glMap.setTransformConstrain(function(center, zoom) {
            return {
                center: center,
                zoom: zoom
            };
        });
        else {
            var transform = this._glMap.transform;
            var transformProto = Object.getPrototypeOf(transform);
            var latRangeDescriptor = Object.getOwnPropertyDescriptor(transformProto, "latRange");
            if (!latRangeDescriptor || latRangeDescriptor.set || latRangeDescriptor.writable) transform.latRange = null;
            var maxValidLatitudeDescriptor = Object.getOwnPropertyDescriptor(transformProto, "maxValidLatitude");
            if (!maxValidLatitudeDescriptor || maxValidLatitudeDescriptor.set || maxValidLatitudeDescriptor.writable) transform.maxValidLatitude = Infinity;
            if (transform._helper && transform._helper._latRange) transform._helper._latRange = [
                -Infinity,
                Infinity
            ];
        }
        this._transformGL(this._glMap);
        if (this._glMap._canvas.canvas) this._glMap._actualCanvas = this._glMap._canvas.canvas;
        else this._glMap._actualCanvas = this._glMap._canvas;
        var canvas = this._glMap._actualCanvas;
        $93ab012a746d9149$var$L.DomUtil.addClass(canvas, "leaflet-image-layer");
        $93ab012a746d9149$var$L.DomUtil.addClass(canvas, "leaflet-zoom-animated");
        if (this.options.interactive) $93ab012a746d9149$var$L.DomUtil.addClass(canvas, "leaflet-interactive");
        if (this.options.className) $93ab012a746d9149$var$L.DomUtil.addClass(canvas, this.options.className);
    },
    _update: function(e) {
        if (!this._map) return;
        this._offset = this._map.containerPointToLayerPoint([
            0,
            0
        ]);
        if (this._zooming) return;
        var container = this._container, gl = this._glMap, offset = this._map.getSize().multiplyBy(this.options.padding), topLeft = this._map.containerPointToLayerPoint([
            0,
            0
        ]).subtract(offset);
        $93ab012a746d9149$var$L.DomUtil.setPosition(container, this._roundPoint(topLeft));
        this._transformGL(gl);
    },
    _transformGL: function(gl) {
        var center = this._map.getCenter();
        gl.jumpTo({
            center: [
                center.lng,
                center.lat
            ],
            zoom: this._map.getZoom() - 1
        });
    },
    _pinchZoom: function(e) {
        this._glMap.jumpTo({
            zoom: this._map.getZoom() - 1,
            center: this._map.getCenter()
        });
    },
    _animateZoom: function(e) {
        var scale = this._map.getZoomScale(e.zoom);
        var padding = this._map.getSize().multiplyBy(this.options.padding * scale);
        var viewHalf = this.getSize()._divideBy(2);
        var topLeft = this._map.project(e.center, e.zoom)._subtract(viewHalf)._add(this._map._getMapPanePos().add(padding))._round();
        var offset = this._map.project(this._map.getBounds().getNorthWest(), e.zoom)._subtract(topLeft);
        $93ab012a746d9149$var$L.DomUtil.setTransform(this._glMap._actualCanvas, offset.subtract(this._offset), scale);
    },
    _zoomStart: function(e) {
        this._zooming = true;
    },
    _zoomEnd: function() {
        var scale = this._map.getZoomScale(this._map.getZoom());
        $93ab012a746d9149$var$L.DomUtil.setTransform(this._glMap._actualCanvas, null, scale);
        this._zooming = false;
        this._update();
    },
    _transitionEnd: function(e) {
        $93ab012a746d9149$var$L.Util.requestAnimFrame(function() {
            var zoom = this._map.getZoom();
            var center = this._map.getCenter();
            var offset = this._map.latLngToContainerPoint(this._map.getBounds().getNorthWest());
            this._resizeContainer();
            $93ab012a746d9149$var$L.DomUtil.setTransform(this._glMap._actualCanvas, offset, 1);
            this._glMap.once("moveend", $93ab012a746d9149$var$L.Util.bind(function() {
                this._zoomEnd();
            }, this));
            this._glMap.jumpTo({
                center: center,
                zoom: zoom - 1
            });
        }, this);
    },
    _resize: function(e) {
        this._transitionEnd(e);
    }
});
var $93ab012a746d9149$export$2e2bcd8739ae039 = function(options) {
    return new $93ab012a746d9149$export$791e0dc7bfbc91fb(options);
};
if (Object.isExtensible($93ab012a746d9149$var$L)) {
    $93ab012a746d9149$var$L.MaplibreGL = $93ab012a746d9149$export$791e0dc7bfbc91fb;
    $93ab012a746d9149$var$L.maplibreGL = $93ab012a746d9149$export$2e2bcd8739ae039;
}



var $4f7796ffcbd49f9d$exports = {};
$4f7796ffcbd49f9d$exports = import.meta.resolve("5AqNj");


var $c297a607a4ba7d41$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// MapLibre's relative worker discovery cannot survive Parcel bundling.
// Emit the worker (and its imports) as assets shared by every map consumer.
(0, $4324d99ae8520741$export$f7f2857281fba5f0)((0, (/*@__PURE__*/$parcel$interopDefault($4f7796ffcbd49f9d$exports))));
const $c297a607a4ba7d41$export$8f3561b1c2271f18 = (0, $26087237d6669ee9$export$4f432c6de5c4ddb8)(function createTileLayer(_a, context) {
    var { url: url, attribution: attribution } = _a, options = $c297a607a4ba7d41$var$__rest(_a, [
        "url",
        "attribution"
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const maplibreGL = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).maplibreGL;
    const layer = maplibreGL({
        style: url,
        attribution: attribution,
        noWrap: true
    }, (0, $32d90284a15401c8$export$6ee5d263358f5c0e)(options, context));
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const update = (0, $94fa316de2622a09$export$b39104a5f1b9296f);
    update(layer, props, prevProps);
    const { url: url, attribution: attribution } = props;
    if (url != null && url !== prevProps.url) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    layer.getMaplibreMap().setStyle(url);
    if (attribution != null && attribution !== prevProps.attribution) layer.options.attribution = attribution;
});




parcelRequire("acw62");


var $8JYDX = parcelRequire("8JYDX");
const $d1d0d473a1e5e06c$export$7bf46a893731b161 = (0, $26087237d6669ee9$export$5e776dbe3c7d2790)(function createCircleMarker({ center: center, children: _c, ...options }, ctx) {
    const marker = new (0, $8JYDX.CircleMarker)(center, options);
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(marker, (0, $cbd94c399cef41ea$export$9efaf186a2224858)(ctx, {
        overlayContainer: marker
    }));
}, (0, $34ab36e170372dbb$export$1a9cf6eabf8106e));



var $8JYDX = parcelRequire("8JYDX");
const $d30568f206d68912$export$e98856a975cab58e = (0, $26087237d6669ee9$export$8a4d5778bce4c3ac)(function createMarker({ position: position, ...options }, ctx) {
    const marker = new (0, $8JYDX.Marker)(position, options);
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(marker, (0, $cbd94c399cef41ea$export$9efaf186a2224858)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});



var $8JYDX = parcelRequire("8JYDX");
const $5ee04e1ff3099aa1$export$79f3ee03e63e7073 = (0, $26087237d6669ee9$export$5e776dbe3c7d2790)(function createPolyline({ positions: positions, ...options }, ctx) {
    const polyline = new (0, $8JYDX.Polyline)(positions, options);
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(polyline, (0, $cbd94c399cef41ea$export$9efaf186a2224858)(ctx, {
        overlayContainer: polyline
    }));
}, function updatePolyline(layer, props, prevProps) {
    if (props.positions !== prevProps.positions) layer.setLatLngs(props.positions);
});



var $8JYDX = parcelRequire("8JYDX");

var $acw62 = parcelRequire("acw62");
const $41a1beb44c6aafd3$export$129a32eedafa97c5 = (0, $26087237d6669ee9$export$7d18e209be943d7d)(function createPopup(props, context) {
    const popup = new (0, $8JYDX.Popup)(props, context.overlayContainer);
    return (0, $c4349977e33cccc7$export$a080ff44e8067a44)(popup, context);
}, function usePopupLifecycle(element, context, { position: position }, setOpen) {
    (0, $acw62.useEffect)(function addPopup() {
        const { instance: instance } = element;
        function onPopupOpen(event) {
            if (event.popup === instance) {
                instance.update();
                setOpen(true);
            }
        }
        function onPopupClose(event) {
            if (event.popup === instance) setOpen(false);
        }
        context.map.on({
            popupopen: onPopupOpen,
            popupclose: onPopupClose
        });
        if (context.overlayContainer == null) {
            // Attach to a Map
            if (position != null) instance.setLatLng(position);
            instance.openOn(context.map);
        } else // Attach to container component
        context.overlayContainer.bindPopup(instance);
        return function removePopup() {
            context.map.off({
                popupopen: onPopupOpen,
                popupclose: onPopupClose
            });
            context.overlayContainer?.unbindPopup();
            context.map.removeLayer(instance);
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});



var $8JYDX = parcelRequire("8JYDX");
// Meters per degree of latitude (WGS84-ish constant). Fine for a rough bounding-box
// expansion; not meant for precise navigation math.
const $24d0c87b6223a295$var$METERS_PER_DEGREE_LAT = 111320;
const $24d0c87b6223a295$export$1e0f7ae80feb6b6 = {
    hasPositions (tracks) {
        return (tracks || []).some((track)=>$24d0c87b6223a295$export$1e0f7ae80feb6b6.trackGeometry(track).points.length > 0);
    },
    // Order a track's sample indexes by their UTC time. Mirrors the original
    // in-place `toSorted` over the timesUtc array.
    sortedIndexes (track) {
        return (track.timesUtc || []).map((t, i)=>({
                index: typeof i == "number" ? i : parseInt(i),
                time: t
            })).toSorted((a, b)=>a.time - b.time).map((n)=>n.index);
    },
    // Board-time hour for a track timestamp (seconds since 2001-01-01, matching the
    // app's reference epoch). `timezone` is the offset in seconds east of UTC; with
    // the default 0 this is the UTC hour.
    utcHour (t, timezone = 0) {
        return new Date(Date.UTC(2001, 0, 1) + (t + timezone) * 1000).getUTCHours();
    },
    // Popup label for a marker: board time (Bordzeit) as the primary value with UTC
    // alongside, e.g. "14:32 (12:32 UTC)". When `timezone` is 0 board time equals UTC,
    // so only the single time is shown. `time` is seconds since the reference epoch
    // and `timezone` the offset in seconds east of UTC. `format` is `app.format`,
    // passed in so this stays pure/unit-testable. Shared by both marker types so they
    // render identically.
    popupLabel (time, timezone, format) {
        const board = format("timeUtc", time + timezone);
        if (!timezone) return board;
        return `${board} (${format("timeUtc", time)} UTC)`;
    },
    // Walk a track in time order and produce the polyline points plus the marker
    // descriptors (endpoints, hourly ticks, and a single mid-track direction
    // indicator). Pure: no leaflet/JSX, so the geometry can be unit-tested.
    trackGeometry (track, timezone = 0) {
        const points = [];
        const markers = [];
        let lastHour = -1;
        let directionIndicator = false;
        const samples = $24d0c87b6223a295$export$1e0f7ae80feb6b6.sortedIndexes(track).flatMap((i)=>{
            var _a, _b, _c, _d;
            const lat = (_a = track.lats) === null || _a === void 0 ? void 0 : _a[i];
            const lng = (_b = track.lngs) === null || _b === void 0 ? void 0 : _b[i];
            const time = (_c = track.timesUtc) === null || _c === void 0 ? void 0 : _c[i];
            if (lat == null || lng == null || time == null || !Number.isFinite(lat) || !Number.isFinite(lng) || !Number.isFinite(time) || Math.abs(lat) > 90 || Math.abs(lng) > 180 || lat === 0 && lng === 0) return [];
            const heading = (_d = track.headings) === null || _d === void 0 ? void 0 : _d[i];
            return [
                {
                    lat: lat,
                    lng: lng,
                    time: time,
                    heading: heading != null && Number.isFinite(heading) ? heading : 0
                }
            ];
        });
        const length = samples.length;
        for (const [i, { lat: lat, lng: lng, time: t, heading: heading }] of samples.entries()){
            points.push({
                lat: lat,
                lng: lng
            });
            const h = $24d0c87b6223a295$export$1e0f7ae80feb6b6.utcHour(t, timezone);
            if (i == 0 || i == length - 1) markers.push({
                kind: "endpoint",
                lat: lat,
                lng: lng,
                time: t
            });
            else if (h > lastHour) {
                const s = h % 4 == 0 ? 12 : 8;
                markers.push({
                    kind: "hour",
                    lat: lat,
                    lng: lng,
                    time: t,
                    heading: heading,
                    size: s
                });
                lastHour = h;
            }
            if (!directionIndicator && i >= length / 2) {
                directionIndicator = true;
                markers.push({
                    kind: "direction",
                    lat: lat,
                    lng: lng,
                    heading: heading
                });
            }
        }
        return {
            points: points,
            markers: markers
        };
    },
    // Reduce every track's usable points to a min/max lat/lng bounding box.
    // `circles` (e.g. an anchor watch's swing-circle
    // rings) are optionally folded in too, widening the box so a short/just-started
    // track still zooms out to show the full circle instead of collapsing onto its
    // own (possibly single-point) extent.
    computeBounds (tracks, circles) {
        const bounds = [
            [
                undefined,
                undefined
            ],
            [
                undefined,
                undefined
            ]
        ];
        const expand = (lat, lng)=>{
            if (bounds[0][0] === undefined || lat < bounds[0][0]) bounds[0][0] = lat;
            if (bounds[1][0] === undefined || lat > bounds[1][0]) bounds[1][0] = lat;
            if (bounds[0][1] === undefined || lng < bounds[0][1]) bounds[0][1] = lng;
            if (bounds[1][1] === undefined || lng > bounds[1][1]) bounds[1][1] = lng;
        };
        for (const track of tracks || [])for (const { lat: lat, lng: lng } of $24d0c87b6223a295$export$1e0f7ae80feb6b6.trackGeometry(track).points)expand(lat, lng);
        for (const circle of circles || []){
            // Rough meters -> degrees conversion (WGS84-ish constant); precise enough for
            // a bounding-box expansion, not for navigation math.
            const dLat = circle.radius / $24d0c87b6223a295$var$METERS_PER_DEGREE_LAT;
            const dLng = circle.radius / ($24d0c87b6223a295$var$METERS_PER_DEGREE_LAT * Math.cos(circle.lat * Math.PI / 180) || 1);
            expand(circle.lat - dLat, circle.lng - dLng);
            expand(circle.lat + dLat, circle.lng + dLng);
        }
        return bounds;
    }
};
function $24d0c87b6223a295$export$1d5d67f11f2574d3({ track: track, color: color, weight: weight = 6, dashArray: dashArray, timezone: timezone = 0, markers: markers = "full", popupLabel: popupLabel, keyPrefix: keyPrefix = "track" }) {
    const { points: points, markers: descriptors } = $24d0c87b6223a295$export$1e0f7ae80feb6b6.trackGeometry(track, timezone);
    if (points.length == 0) return null;
    const nodes = [];
    if (markers == "full") for (const [dIndex, d] of descriptors.entries()){
        const markerKey = `${keyPrefix}-marker-${dIndex}`;
        if (d.kind == "endpoint") nodes.push((0, $7b02d682eb115277$exports.jsx)((0, $d1d0d473a1e5e06c$export$7bf46a893731b161), {
            center: [
                d.lat,
                d.lng
            ],
            pathOptions: {
                color: "white",
                weight: 2
            },
            radius: 4,
            children: popupLabel && (0, $7b02d682eb115277$exports.jsx)((0, $41a1beb44c6aafd3$export$129a32eedafa97c5), {
                children: popupLabel(d.time)
            })
        }, markerKey));
        else if (d.kind == "hour") {
            const icon = new (0, $8JYDX.DivIcon)({
                html: `<div class="track-line-inner hour-${$24d0c87b6223a295$export$1e0f7ae80feb6b6.utcHour(d.time, timezone)}" style="transform: rotate(${d.heading}deg);"></div>`,
                className: "track-line",
                iconSize: [
                    d.size,
                    d.size
                ],
                iconAnchor: [
                    d.size / 2,
                    1
                ]
            });
            nodes.push((0, $7b02d682eb115277$exports.jsx)((0, $d30568f206d68912$export$e98856a975cab58e), {
                icon: icon,
                position: [
                    d.lat,
                    d.lng
                ],
                children: popupLabel && (0, $7b02d682eb115277$exports.jsx)((0, $41a1beb44c6aafd3$export$129a32eedafa97c5), {
                    children: popupLabel(d.time)
                })
            }, markerKey));
        } else {
            const icon = new (0, $8JYDX.DivIcon)({
                html: `<div class="track-direction-indicator-inner" style="transform: rotate(${d.heading + 180}deg);">
          <svg
            width="8"
            height="8"
            viewBox="0 0 100 100"
            version="1.1"
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 0 L50 100 L100 0 Z" fill="#fff"></path>
          </svg>
        </div>`,
                className: "track-direction-indicator",
                iconSize: [
                    weight,
                    weight
                ],
                iconAnchor: [
                    4,
                    7
                ]
            });
            nodes.push((0, $7b02d682eb115277$exports.jsx)((0, $d30568f206d68912$export$e98856a975cab58e), {
                icon: icon,
                position: [
                    d.lat,
                    d.lng
                ]
            }, markerKey));
        }
    }
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $5ee04e1ff3099aa1$export$79f3ee03e63e7073), {
                pathOptions: {
                    color: color,
                    weight: weight,
                    dashArray: dashArray
                },
                positions: points.map((p)=>new (0, $8JYDX.LatLng)(p.lat, p.lng))
            }, `${keyPrefix}-line`),
            nodes
        ]
    });
}


// Anchor tracks (GPS fixes recorded while an anchor watch is active) are styled
// distinctly from the main passage track -- a different color plus a dashed
// stroke, so both color and line style set them apart (also colorblind-safe).
const $7e01767afef66f8e$var$ANCHOR_TRACK_COLOR = "#8a5a9e";
const $7e01767afef66f8e$var$ANCHOR_TRACK_DASH = "6 6";
// Swing-circle ring colors, matching the app's existing warning/alert design
// tokens (colors.scss --warning / --alert) so the overlay reads consistently
// with the rest of the anchor-alert UI.
const $7e01767afef66f8e$var$WARNING_RING_COLOR = "#e7ac52";
const $7e01767afef66f8e$var$ALARM_RING_COLOR = "#d84532";
function $7e01767afef66f8e$export$600f95652e45663({ fullscreen: fullscreen, noInteraction: noInteraction, tracks: tracks, timezone: timezone, anchorCircles: anchorCircles }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("TrackView");
    const mapRef = (0, $acw62.useRef)(null);
    const lineWidth = 6;
    const tz = timezone !== null && timezone !== void 0 ? timezone : 0;
    const visibleTracks = (0, $acw62.useMemo)(()=>tracks === null || tracks === void 0 ? void 0 : tracks.filter((track)=>(0, $24d0c87b6223a295$export$1e0f7ae80feb6b6).hasPositions([
                track
            ])), [
        tracks
    ]);
    const visibleAnchorCircles = anchorCircles;
    const [layers, bounds] = (0, $acw62.useMemo)(()=>{
        var _a, _b, _c, _d;
        const layers = [];
        if (!(visibleTracks === null || visibleTracks === void 0 ? void 0 : visibleTracks.length)) return [
            layers,
            undefined
        ];
        // Expand the map bounds by the largest ring of each circle too, so a
        // short/just-started anchor track still zooms out to show the full circle.
        const circleBoundsInputs = (visibleAnchorCircles || []).map((c)=>({
                lat: c.lat,
                lng: c.lng,
                radius: Math.max(c.warningRadius, c.alarmRadius)
            }));
        const boundsTuple = (0, $24d0c87b6223a295$export$1e0f7ae80feb6b6).computeBounds(visibleTracks, circleBoundsInputs);
        if (visibleTracks) for (const [trackIndex, track] of visibleTracks.entries()){
            const isAnchor = track.trackType === (0, $74ddf98d45710879$export$a9ec73fef5890395).anchor;
            layers.push((0, $7b02d682eb115277$exports.jsx)((0, $24d0c87b6223a295$export$1d5d67f11f2574d3), {
                keyPrefix: `track-${trackIndex}`,
                track: track,
                color: isAnchor ? $7e01767afef66f8e$var$ANCHOR_TRACK_COLOR : "#5a80a2",
                dashArray: isAnchor ? $7e01767afef66f8e$var$ANCHOR_TRACK_DASH : undefined,
                weight: lineWidth,
                timezone: tz,
                markers: "full",
                popupLabel: (time)=>(0, $24d0c87b6223a295$export$1e0f7ae80feb6b6).popupLabel(time, tz, app.format)
            }, `track-${trackIndex}`));
        }
        for (const [circleIndex, circle] of (visibleAnchorCircles || []).entries()){
            // An ended (historical) watch recedes behind the active one: a dashed,
            // lighter stroke/fill, so multiple same-day watches don't visually compete
            // with the currently active circle.
            const historical = !circle.active;
            const ringOptions = {
                fillOpacity: historical ? 0.02 : 0.05,
                opacity: historical ? 0.5 : 1,
                dashArray: historical ? "4 4" : undefined
            };
            layers.push((0, $7b02d682eb115277$exports.jsx)((0, $e2549461480b0f46$export$c89a927ffc67e6fa), {
                center: [
                    circle.lat,
                    circle.lng
                ],
                radius: circle.warningRadius,
                pathOptions: Object.assign({
                    color: $7e01767afef66f8e$var$WARNING_RING_COLOR
                }, ringOptions)
            }, `anchor-circle-warning-${circleIndex}`));
            layers.push((0, $7b02d682eb115277$exports.jsx)((0, $e2549461480b0f46$export$c89a927ffc67e6fa), {
                center: [
                    circle.lat,
                    circle.lng
                ],
                radius: circle.alarmRadius,
                pathOptions: Object.assign({
                    color: $7e01767afef66f8e$var$ALARM_RING_COLOR
                }, ringOptions)
            }, `anchor-circle-alarm-${circleIndex}`));
        }
        return [
            layers,
            new (0, $8JYDX.LatLngBounds)([
                (_a = boundsTuple[0][0]) !== null && _a !== void 0 ? _a : 0,
                (_b = boundsTuple[0][1]) !== null && _b !== void 0 ? _b : 0
            ], [
                (_c = boundsTuple[1][0]) !== null && _c !== void 0 ? _c : 0,
                (_d = boundsTuple[1][1]) !== null && _d !== void 0 ? _d : 0
            ])
        ];
    }, [
        visibleTracks,
        tz,
        visibleAnchorCircles
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        (_a = mapRef.current) === null || _a === void 0 || _a.invalidateSize();
    }, [
        fullscreen
    ]);
    return bounds ? (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "TrackView",
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $ee011fc978fcb926$export$23f3dfd47374502b), {
            bounds: bounds,
            boundsOptions: {
                maxZoom: 16
            },
            center: bounds.getCenter(),
            ref: mapRef,
            scrollWheelZoom: !noInteraction,
            dragging: !noInteraction,
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $c297a607a4ba7d41$export$8f3561b1c2271f18), {
                    attribution: '\u00A9 <a href="https://openfreemap.org/" target="_blank">OpenFreeMap</a>, \u00A9 <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> \u00A9 <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>',
                    url: app.theme == "light" ? "/map-light.json" : "/map.json"
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $35109d75658c2839$export$f52ee31d61d0b27b), {
                    url: "http://tiles.openseamap.org/seamark/{z}/{x}/{y}.png"
                }),
                layers.length > 0 && layers,
                (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8f3afacbde02c2fb$exports))), {
                    imperial: false,
                    metric: false,
                    nautic: true
                })
            ]
        })
    }) : (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "TrackView-message",
        children: t("no_track")
    });
}






var $acw62 = parcelRequire("acw62");

/**
 * Pure derivations over an `IShip`. Kept free of React/DOM so the engine
 * sort/slice and `engineShortName` lookup can be unit-tested in isolation.
 *
 * `engines` sorts by `number` (missing numbers sort last) and clamps to the
 * ship's `engineCount`; `engineName` resolves a display name for an engine by
 * `id`, else by `nmeaNumber` (preferred) or `number`.
 */ const $22871482fce5b7e5$export$7930c61d9b464618 = {
    isSailingVessel (ship) {
        return ship.vesselType == 2;
    },
    shipData (ship) {
        return ship.shipData || {};
    },
    shipSettings (ship) {
        return ship.shipSettings || {};
    },
    engines (ship) {
        const data = $22871482fce5b7e5$export$7930c61d9b464618.shipData(ship);
        if (data === null || data === void 0 ? void 0 : data.engines) return data.engines.toSorted((a, b)=>{
            return (a.number || 1000) - (b.number || 1000);
        }).slice(0, ship.engineCount);
        return [];
    },
    sails (ship) {
        const data = $22871482fce5b7e5$export$7930c61d9b464618.shipData(ship);
        if (data === null || data === void 0 ? void 0 : data.sails) return data.sails;
        return [];
    },
    engineName (ship, id, engine) {
        if (!id && !engine) return "#1";
        const engines = $22871482fce5b7e5$export$7930c61d9b464618.engines(ship);
        if (engines) {
            const engineData = id ? engines.find((e)=>e.id == id) : engines.find((e)=>e.nmeaNumber != undefined ? e.nmeaNumber == engine : e.number == engine);
            if (engineData && engineData.engineShortName) return engineData.engineShortName;
        }
        return `#${engine}`;
    }
};






var $acw62 = parcelRequire("acw62");






const $198e3b0852fb0b06$export$d343b545ff9410bb = {
    calculate (api, type, shipId, entityId) {
        switch(type){
            case "Cruise":
                return new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(api).cruises.calculate({
                    params: {
                        shipId: shipId,
                        cruiseId: entityId
                    }
                }).call();
            case "Day":
                return new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(api).days.calculate({
                    params: {
                        shipId: shipId,
                        dayId: entityId
                    }
                }).call();
            case "Trip":
                return new (0, $84aa1a3b4df5a78b$export$5e13e029a186945f)(api).trips.calculate({
                    params: {
                        shipId: shipId,
                        tripId: entityId
                    }
                }).call();
        }
    },
    // Per-engine calculation lookup shared by StatsView and Print/CalculationsView: match
    // the calculated engine breakdown by its nmea number and read one numeric field,
    // defaulting to 0 when the engine or field is absent. The two views still build their
    // own engine LISTS (rich app.engines objects here vs. index-based placeholders in
    // Print), so only this find is shared.
    engineValue (calculated, nmeaNumber, field) {
        var _a, _b;
        return ((_b = (_a = calculated === null || calculated === void 0 ? void 0 : calculated.engines) === null || _a === void 0 ? void 0 : _a.find((e)=>e.number == nmeaNumber)) === null || _b === void 0 ? void 0 : _b[field]) || 0;
    }
};
function $198e3b0852fb0b06$export$1e3e8ecfe0e6273a({ calculate: calculate, cruise: cruise, day: day, trip: trip }) {
    var _a, _b, _c;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const type = cruise ? "Cruise" : day ? "Day" : trip ? "Trip" : undefined;
    const t = app.getT("StatsView");
    const [refreshing, setRefreshing] = (0, $acw62.useState)(false);
    const calculated = ((_a = cruise || day || trip) === null || _a === void 0 ? void 0 : _a.calculated) || {
        distance: undefined,
        distanceUnderEngine: undefined,
        distanceUnderSails: undefined,
        duration: undefined,
        durationPaused: undefined,
        durationCruising: undefined,
        durationUnderEngine: undefined,
        durationUnderSails: undefined,
        daysRun: undefined,
        engines: undefined,
        sog: undefined
    };
    const engines = (0, $acw62.useMemo)(()=>{
        const engineInfo = [];
        for (const e of (0, $22871482fce5b7e5$export$7930c61d9b464618).engines(ship))engineInfo.push({
            id: e.id,
            number: e.number,
            nmeaNumber: e.nmeaNumber || e.number,
            name: e.engineShortName || `#${e.number}`
        });
        return engineInfo;
    }, [
        ship
    ]);
    const engineCalculated = (_b = cruise || day || trip) === null || _b === void 0 ? void 0 : _b.calculated;
    // With a single engine the per-engine value IS the total, so showing both rendered
    // every figure twice (#1214). Only break the total down when there is more than one
    // engine — the same rule `Views/Log/nmea.ts` applies to its engine label suffix.
    const engineBreakdown = engines.length > 1;
    const refresh = (0, $acw62.useCallback)(async ()=>{
        var _a;
        // Guard here (not via the native `disabled` attribute) against an overlapping
        // second click: toggling `disabled` on a hovered button suppresses the
        // browser's `mouseleave` event, leaving `:hover` "stuck" once it re-enables.
        if (refreshing) return;
        const entityId = (_a = cruise || day || trip) === null || _a === void 0 ? void 0 : _a.id;
        if (type == undefined || entityId == undefined) return;
        setRefreshing(true);
        await (calculate ? calculate() : $198e3b0852fb0b06$export$d343b545ff9410bb.calculate(app.apiClient, type, ship.id, entityId));
        setRefreshing(false);
    }, [
        ship,
        cruise,
        day,
        trip,
        refreshing,
        type,
        calculate
    ]);
    // Nothing to summarise without an entity. This has to sit BELOW every hook: the same
    // instance can be re-rendered with and without one, and returning early above them
    // changes the hook list between renders, which crashes React (#1267).
    if (!type) return;
    // A v2 (sectioned) row is projected to the flat v1-compat shape at the read boundary
    // once the #936 (tracker #861) read flag is on, so the flat fields below render it transparently and it
    // reports the v1 generation. This placeholder is therefore only reached in the
    // transitional flag-off state, where a v2 payload can't be rendered by the flat fields —
    // show an explicit note rather than silently displaying zeros. (Not localized: dev-only.)
    const calculationVersion = (_c = cruise || day || trip) === null || _c === void 0 ? void 0 : _c.calculationVersion;
    if (calculationVersion != undefined && calculationVersion >= 2) return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
        className: `${type}StatsView`,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
            className: `${type}StatsView-block-placeholder`,
            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: "This calculation can't be displayed yet."
            })
        })
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
        className: `${type}StatsView`,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: `${type}StatsView-block-time`,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("time_total_paused_cruising"),
                            className: "block_field_small_18",
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: app.format("time", calculated.duration),
                                        readOnly: true
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: app.format("time", calculated.durationPaused),
                                        readOnly: true
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: app.format("time", calculated.durationCruising),
                                        readOnly: true
                                    })
                                ]
                            })
                        })
                    }),
                    engineCalculated && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: engineBreakdown ? undefined : "block_field_small_12",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: engineBreakdown ? [
                                    t("duration_under_engine"),
                                    ...engines.map((engine)=>t("duration_under_engine_name", {
                                            name: engine.name
                                        }))
                                ].join(" | ") : t("duration_under_engine"),
                                style: engineBreakdown ? {
                                    maxWidth: `${ship.engineCount * 11}em`
                                } : undefined,
                                children: engineBreakdown ? (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("input", {
                                            value: app.format("time", calculated.durationUnderEngine),
                                            readOnly: true
                                        }),
                                        engines.map((e)=>{
                                            var _a;
                                            return (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                children: [
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: app.format("time", $198e3b0852fb0b06$export$d343b545ff9410bb.engineValue(engineCalculated, e.nmeaNumber, "duration")),
                                                        readOnly: true
                                                    })
                                                ]
                                            }, (_a = e.id) !== null && _a !== void 0 ? _a : e.nmeaNumber);
                                        })
                                    ]
                                }) : (0, $7b02d682eb115277$exports.jsx)("input", {
                                    value: app.format("time", calculated.durationUnderEngine),
                                    readOnly: true
                                })
                            }),
                            !engineBreakdown && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                blank: true
                            })
                        ]
                    }),
                    (0, $22871482fce5b7e5$export$7930c61d9b464618).isSailingVessel(ship) && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block_field_small_12",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("duration_under_sails"),
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    value: app.format("time", calculated.durationUnderSails),
                                    readOnly: true
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                blank: true
                            })
                        ]
                    }),
                    !app.cloudSession() && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "recalculate-button-row",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: `button${refreshing ? " refreshing" : ""}`,
                                onClick: ()=>refresh(),
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Refresh
                                    }),
                                    " ",
                                    t("update")
                                ]
                            })
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: `${type}StatsView-block-distance`,
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block_field_small_12",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("distance_total"),
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    value: app.format("distance", calculated.distance),
                                    readOnly: true
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                blank: true
                            })
                        ]
                    }),
                    engineCalculated && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: engineBreakdown ? undefined : "block_field_small_12",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: engineBreakdown ? [
                                    t("distance_under_engine"),
                                    ...engines.map((engine)=>t("distance_under_engine_name", {
                                            name: engine.name
                                        }))
                                ].join(" | ") : t("distance_under_engine"),
                                style: engineBreakdown ? {
                                    maxWidth: `${ship.engineCount * 14}em`
                                } : undefined,
                                children: engineBreakdown ? (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("input", {
                                            value: app.format("distance", calculated.distanceUnderEngine),
                                            readOnly: true
                                        }),
                                        engines.map((e)=>{
                                            var _a;
                                            return (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                children: [
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        value: app.format("distance", $198e3b0852fb0b06$export$d343b545ff9410bb.engineValue(engineCalculated, e.nmeaNumber, "distance")),
                                                        readOnly: true
                                                    })
                                                ]
                                            }, (_a = e.id) !== null && _a !== void 0 ? _a : e.nmeaNumber);
                                        })
                                    ]
                                }) : (0, $7b02d682eb115277$exports.jsx)("input", {
                                    value: app.format("distance", calculated.distanceUnderEngine),
                                    readOnly: true
                                })
                            }),
                            !engineBreakdown && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                blank: true
                            })
                        ]
                    }),
                    (0, $22871482fce5b7e5$export$7930c61d9b464618).isSailingVessel(ship) && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block_field_small_12",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("distance_under_sails"),
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    value: app.format("distance", calculated.distanceUnderSails),
                                    readOnly: true
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                blank: true
                            })
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: `${type}StatsView-block-averages block_field_small_10`,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block_field_small_10",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("speed"),
                            className: "block_field_small_10",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                value: app.format("speed", calculated.sog),
                                readOnly: true
                            })
                        })
                    }),
                    (day === null || day === void 0 ? void 0 : day.calculated) && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("days_run"),
                            className: "block_field_small_10",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                value: app.format("distance", day.calculated.daysRun),
                                readOnly: true
                            })
                        })
                    })
                ]
            })
        ]
    });
}


function $2ad184317a4db22e$export$9089c227cea0b0ec({ calculated: calculated }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const t = app.getT("StatsView");
    const engines = Array.from({
        length: ship.engineCount
    }, (_, i)=>({
            name: `${i + 1}`,
            nmeaNumber: i + 1
        }));
    // A single engine's value IS the total, so breaking it down printed every figure
    // twice (#1214) — mirror StatsView and only break down two or more engines.
    const engineBreakdown = engines.length > 1;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete calculations type
    const calcAny = calculated;
    const engineCalculated = calcAny.engineCalculated || calcAny;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
        className: "PrintCalculationsView ",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "Block-PrintCalculations block-field-270",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("time_total_paused_cruising"),
                            className: "",
                            children: [
                                app.format("timeh", calculated.duration),
                                " ",
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                " ",
                                app.format("timeh", calculated.durationPaused),
                                " ",
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                " ",
                                app.format("timeh", calculated.durationCruising)
                            ]
                        })
                    }),
                    engineCalculated && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "",
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: engineBreakdown ? [
                                    t("duration_under_engine"),
                                    ...engines.map((engine)=>t("duration_under_engine_name", {
                                            name: engine.name
                                        }))
                                ].join(" | ") : t("duration_under_engine"),
                                style: engineBreakdown ? {
                                    maxWidth: `${ship.engineCount * 12}em`
                                } : undefined,
                                className: "",
                                children: [
                                    app.format("timeh", calculated.durationUnderEngine),
                                    engineBreakdown && engines.map((e)=>{
                                        return (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                            children: [
                                                " ",
                                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                                " ",
                                                app.format("timeh", (0, $198e3b0852fb0b06$export$d343b545ff9410bb).engineValue(engineCalculated, e.nmeaNumber, "duration"))
                                            ]
                                        }, e.nmeaNumber);
                                    })
                                ]
                            }),
                            !engineBreakdown && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                blank: true
                            })
                        ]
                    }),
                    (0, $22871482fce5b7e5$export$7930c61d9b464618).isSailingVessel(ship) && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("duration_under_sails"),
                                children: app.format("timeh", calculated.durationUnderSails)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                blank: true
                            })
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "Block-PrintCalculations block-field-270",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("distance_total"),
                                children: app.format("distance", calculated.distance)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                blank: true
                            })
                        ]
                    }),
                    engineCalculated && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: engineBreakdown ? [
                                    t("distance_under_engine"),
                                    ...engines.map((engine)=>t("distance_under_engine_name", {
                                            name: engine.name
                                        }))
                                ].join(" | ") : t("distance_under_engine"),
                                style: engineBreakdown ? {
                                    maxWidth: `${ship.engineCount * 12}em`
                                } : undefined,
                                children: [
                                    app.format("distance", calculated.distanceUnderEngine),
                                    engineBreakdown && engines.map((e)=>{
                                        return (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                            children: [
                                                " ",
                                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                                " ",
                                                app.format("distance", (0, $198e3b0852fb0b06$export$d343b545ff9410bb).engineValue(engineCalculated, e.nmeaNumber, "distance"))
                                            ]
                                        }, e.nmeaNumber);
                                    })
                                ]
                            }),
                            !engineBreakdown && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                blank: true
                            })
                        ]
                    }),
                    (0, $22871482fce5b7e5$export$7930c61d9b464618).isSailingVessel(ship) && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("distance_under_sails"),
                                children: app.format("distance", calculated.distanceUnderSails)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                blank: true
                            })
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "Block-PrintCalculations block-field-270",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("speed"),
                            className: "",
                            children: app.format("speed", calculated.sog)
                        })
                    }),
                    calcAny.daysRun !== undefined && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("days_run"),
                            className: "",
                            children: app.format("distance", calcAny.daysRun)
                        })
                    })
                ]
            })
        ]
    });
}





function $490e2d2eba18da59$export$68c7cb9b5e30213a({ note: note }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const tn = app.getT("NoteView_note");
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
        className: "print-planning-note",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: tn("planning_date"),
                className: "block-field-150",
                children: note.date
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: tn("planning_title"),
                className: "block-field-300",
                children: note.title
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: tn("planning_note"),
                className: "",
                children: note.note
            })
        ]
    });
}






function $4c7db6be3bb62497$export$62ab9936cf76ba16({ trip: trip }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const _data = (0, $872aa31e93f7b7c8$export$ea13d8db95f96086)();
    const tc = app.getT("PrintView");
    const _t = app.getT("DayEditView");
    const _ts = app.getT("StatsView");
    const calculated = trip.calculated;
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PrintTripListView ",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "print-trip-list-row",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: `${tc("trip")} | ${tc("from_loc")}`,
                        className: "block-field-270",
                        children: [
                            " ",
                            trip.title
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: `${tc("date")} | ${tc("to_loc")}`,
                        className: "block-field-270",
                        children: [
                            " ",
                            app.format("date", trip.startedAt),
                            " - ",
                            app.format("date", trip.completedAt)
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: `${tc("time_total")} | ${tc("distance_total")}`,
                        className: "block-field-120 print-field-text-right",
                        children: [
                            " ",
                            app.format("timeh", calculated === null || calculated === void 0 ? void 0 : calculated.duration)
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "print-trip-list-row-2",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        className: "block-field-270",
                        children: [
                            " ",
                            calculated === null || calculated === void 0 ? void 0 : calculated.startLocation
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        className: "block-field-270",
                        children: [
                            " ",
                            calculated === null || calculated === void 0 ? void 0 : calculated.endLocation
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        className: "block-field-120 print-field-text-right",
                        children: [
                            " ",
                            app.format("distance", calculated === null || calculated === void 0 ? void 0 : calculated.distance)
                        ]
                    })
                ]
            })
        ]
    });
}


function $42220feb3f963f0b$export$3efcb21cd1ec8329({ cruise: cruise }) {
    var _a, _b, _c, _d;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const data = (0, $872aa31e93f7b7c8$export$ea13d8db95f96086)();
    const tc = app.getT("PrintView");
    const tracks = (0, $acw62.useMemo)(()=>{
        if (!data) return [];
        return data.tracks.filter((track)=>track.cruiseId == cruise.id);
    }, [
        data
    ]);
    const tripLists = (0, $acw62.useMemo)(()=>{
        if (!data) return [];
        return data.trips.filter((trip)=>trip.cruiseId == cruise.id).map((trip)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $4c7db6be3bb62497$export$62ab9936cf76ba16), {
                trip: trip
            }, trip.id);
        });
    }, [
        data
    ]);
    const planningNotes = (0, $acw62.useMemo)(()=>{
        return (cruise.notes || []).filter((note)=>note.cruiseId == cruise.id && note.noteType === (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).planning).map((note)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $490e2d2eba18da59$export$68c7cb9b5e30213a), {
                note: note
            }, note.id);
        });
    }, [
        cruise
    ]);
    const _calculated = cruise.calculated;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "PrintCruiseView-block container-boxed",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        children: [
                            tc("cruise"),
                            ": ",
                            cruise.title
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "PrintCruiseView-mainData",
                        children: (0, $7b02d682eb115277$exports.jsxs)("h4", {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "print-text-normal",
                                    children: tc("from_date")
                                }),
                                " ",
                                app.format("date", cruise.startedAt),
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "print-text-normal print-distance-left",
                                    children: tc("until_date")
                                }),
                                " ",
                                app.format("date", cruise.completedAt),
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "print-distance-left",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {})
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "print-text-normal print-distance-left",
                                    children: tc("from_loc")
                                }),
                                " ",
                                ((_a = cruise.calculated) === null || _a === void 0 ? void 0 : _a.startLocation) || "",
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "print-text-normal print-distance-left",
                                    children: tc("to_loc")
                                }),
                                " ",
                                ((_b = cruise.calculated) === null || _b === void 0 ? void 0 : _b.endLocation) || ""
                            ]
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "PrintCruiseView-track",
                        children: (0, $24d0c87b6223a295$export$1e0f7ae80feb6b6).hasPositions(tracks) && (0, $7b02d682eb115277$exports.jsx)((0, $7e01767afef66f8e$export$600f95652e45663), {
                            fullscreen: false,
                            noInteraction: true,
                            tracks: tracks,
                            timezone: (_d = (_c = app.status) === null || _c === void 0 ? void 0 : _c.systemTimezone) !== null && _d !== void 0 ? _d : 0
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "PrintCruiseView-statistics container-boxed-inner",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("h4", {
                                children: tc("cruise_statistics")
                            }),
                            cruise.calculated && (0, $7b02d682eb115277$exports.jsx)((0, $2ad184317a4db22e$export$9089c227cea0b0ec), {
                                calculated: cruise.calculated
                            })
                        ]
                    })
                ]
            }),
            planningNotes.length > 0 && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "PrintPlanningView container-boxed",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("h4", {
                        children: tc("note_planning")
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "PrintPlanningNotesView",
                        children: planningNotes
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "PrintTripListView-block container-boxed",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("h3", {
                        children: tc("trip_list")
                    }),
                    tripLists
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

var $59aa08b9185fbe21$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $59aa08b9185fbe21$export$ff67a10d74459a57(record, saved) {
    if (!saved || saved.id != record.id) return record;
    const savedAt = Date.parse(saved.updatedAt);
    const recordAt = Date.parse(record.updatedAt);
    if (!Number.isFinite(savedAt) || !Number.isFinite(recordAt)) return saved;
    return savedAt >= recordAt ? saved : record;
}
// `AuditLogEdit.previousValue` is a JSON-encoded string (or undefined when the field
// was previously unset). Falls back to the raw string for the rare case it isn't
// valid JSON, rather than throwing.
function $59aa08b9185fbe21$var$decodeValue(value) {
    if (value === undefined) return undefined;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
}
// Computes one entry per `AuditLogEdit`, across every field represented in `edits`.
// `currentValue(field)` supplies the record's own live value for a field's most
// recent edit (there's nothing "newer" recorded for it to diff against). Entries are
// grouped and chronologically ordered per field internally, then the flat result is
// sorted by `editedAt` descending (most recent edit first, regardless of field) --
// the order the Log/Day edit-history UI displays them in.
// `editedAt` alone isn't a reliable chronological order: two separate edits of the
// same field can land with an identical (millisecond) timestamp, e.g. under fast/
// automated saves. `id` is monotonically increasing on insert, so it always breaks
// a tie correctly -- ascending `id` therefore serves as the true chronological order
// whenever `editedAt` compares equal.
function $59aa08b9185fbe21$var$compareChronological(a, b) {
    return a.editedAt.localeCompare(b.editedAt) || a.id - b.id;
}
function $59aa08b9185fbe21$export$a93b69c9d9000d40(edits, currentValue) {
    return $59aa08b9185fbe21$export$54b358b4e0fb8dc9(edits, currentValue).map((_a)=>{
        var { id: _id } = _a, entry = $59aa08b9185fbe21$var$__rest(_a, [
            "id"
        ]);
        return entry;
    });
}
function $59aa08b9185fbe21$export$54b358b4e0fb8dc9(edits, currentValue) {
    var _a;
    const byField = new Map();
    for (const edit of edits){
        const fieldEdits = (_a = byField.get(edit.field)) !== null && _a !== void 0 ? _a : [];
        fieldEdits.push(edit);
        byField.set(edit.field, fieldEdits);
    }
    const entries = [];
    for (const [field, fieldEdits] of byField){
        const sorted = [
            ...fieldEdits
        ].sort($59aa08b9185fbe21$var$compareChronological);
        sorted.forEach((edit, index)=>{
            const next = sorted[index + 1];
            const newValue = next ? $59aa08b9185fbe21$var$decodeValue(next.previousValue) : currentValue(field);
            entries.push({
                field: field,
                previousValue: $59aa08b9185fbe21$var$decodeValue(edit.previousValue),
                newValue: newValue,
                editedAt: edit.editedAt,
                shipUserId: edit.shipUserId,
                editGroupId: edit.editGroupId,
                id: edit.id
            });
        });
    }
    return entries.sort((a, b)=>b.editedAt.localeCompare(a.editedAt) || b.id - a.id);
}
function $59aa08b9185fbe21$export$c19a2b0398da4469(entries) {
    const groups = [];
    const byId = new Map();
    for (const entry of entries){
        let group = byId.get(entry.editGroupId);
        if (!group) {
            group = {
                editGroupId: entry.editGroupId,
                editedAt: entry.editedAt,
                shipUserId: entry.shipUserId,
                fields: []
            };
            byId.set(entry.editGroupId, group);
            groups.push(group);
        }
        const existingField = group.fields.find((f)=>f.field === entry.field);
        if (existingField) existingField.previousValue = entry.previousValue;
        else group.fields.push({
            field: entry.field,
            previousValue: entry.previousValue,
            newValue: entry.newValue
        });
    }
    return groups;
}
function $59aa08b9185fbe21$export$8f329f8d8cd7c652(value) {
    if (value === undefined || value === null) return "\u2013";
    if (Array.isArray(value)) return value.join(", ");
    return String(value);
}












function $b68062e8543a3005$export$fca036eb5668ed1d({ entries: entries, fieldLabel: fieldLabel, fieldFormat: fieldFormat, open: open, className: className }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("EditHistory");
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    if (entries.length < 1 || !open) return null;
    const groups = (0, $59aa08b9185fbe21$export$c19a2b0398da4469)(entries);
    const formatValue = (field, value)=>{
        const entry = fieldFormat === null || fieldFormat === void 0 ? void 0 : fieldFormat[field];
        return entry == undefined ? (0, $59aa08b9185fbe21$export$8f329f8d8cd7c652)(value) : (0, $14a8bda8b42de2c4$export$6d11197b6687e2cb)(entry, value, app.format);
    };
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "EditHistory",
            className
        ]),
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "EditHistory-title",
                children: t("title")
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "EditHistory-table",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "EditHistory-header",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "EditHistory-field bold",
                                children: t("field")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "EditHistory-previous bold",
                                children: t("previous")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "EditHistory-new bold",
                                children: t("new")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "EditHistory-meta bold",
                                children: t("changed")
                            })
                        ]
                    }),
                    groups.map((group)=>{
                        const editor = shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.find((u)=>u.id == group.shipUserId);
                        return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "EditHistory-row",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    className: "EditHistory-field",
                                    children: group.fields.map((f)=>(0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: fieldLabel(f.field)
                                        }, f.field))
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    className: "EditHistory-previous",
                                    children: group.fields.map((f)=>(0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: formatValue(f.field, f.previousValue)
                                        }, f.field))
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    className: "EditHistory-new",
                                    children: group.fields.map((f)=>(0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: formatValue(f.field, f.newValue)
                                        }, f.field))
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    className: "EditHistory-meta",
                                    children: t("entry_meta", {
                                        date: app.format("dateAndTime", group.editedAt),
                                        name: (editor === null || editor === void 0 ? void 0 : editor.name) || (editor === null || editor === void 0 ? void 0 : editor.shortname) || ""
                                    })
                                })
                            ]
                        }, group.editGroupId);
                    })
                ]
            })
        ]
    });
}





// DayView has been decomposed into a Views/Day/ folder. This root file stays as a
// thin composer that re-exports the public API so existing `./DayView` import paths
// (TripView / Focus / NoteView / the Print views and the view tests) keep working
// unchanged.




var $acw62 = parcelRequire("acw62");



// Public surface of the centralized Data layer (#1105 foundation, tracker #665).



const $a039797581f5ab08$export$680160523e6bfa6a = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("Account", {
    fetch: (client, { accountId: accountId })=>{
        if (accountId === undefined) return Promise.reject(new Error("Account fetch requires accountId"));
        return new (0, $6e7887a8bef248ec$export$1fb4852a55678982)(client).session.get({
            params: {}
        }).call().then((response)=>response.session.accountId === accountId ? (0, $73eea1fea92cc6a5$export$79764cf71b00e905)(response) : {
                entities: {
                    Account: [],
                    AccountUser: []
                }
            });
    }
});





const $0423ccb45a4ff0ec$export$a031a406a1b12785 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("AccountSubscriptionPlan", {
    fetch: (client)=>new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(client).account.plans({
            params: {}
        }).call().then((response)=>({
                entities: {
                    AccountSubscriptionPlan: response.plans.map(({ plan: plan })=>plan),
                    AccountSubscriptionPlanFeature: response.plans.flatMap(({ features: features })=>features),
                    AccountSubscriptionPlanPricing: response.plans.flatMap(({ pricing: pricing })=>pricing)
                },
                extras: {
                    stripeKey: response.stripeKey,
                    appAccountToken: response.appAccountToken
                },
                authoritative: {
                    AccountSubscriptionPlan: {},
                    AccountSubscriptionPlanFeature: {},
                    AccountSubscriptionPlanPricing: {}
                }
            }))
});



const $ee4230f63caa5204$export$38dc04fa47a524c7 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("AccountSubscriptionPlanFeature");



const $0b7b442c54670519$export$632258bb375edb45 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("AccountSubscriptionPlanPricing");



const $ca84539de63fd988$export$7e10f2bca77eaeb1 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("AuditLogEdit");





const $77089501411ae7ed$export$3dbb0b2d2178e57f = [
    "calculated",
    "calculatedV2",
    "calculationVersion"
];
function $77089501411ae7ed$export$541d2c535509b7fe(next, previous) {
    if (!previous) return next;
    return Object.assign(Object.assign(Object.assign(Object.assign({}, next), next.calculated === undefined && previous.calculated !== undefined ? {
        calculated: previous.calculated
    } : {}), next.calculatedV2 === undefined && previous.calculatedV2 !== undefined ? {
        calculatedV2: previous.calculatedV2
    } : {}), next.calculationVersion === undefined && previous.calculationVersion !== undefined ? {
        calculationVersion: previous.calculationVersion
    } : {});
}
function $77089501411ae7ed$var$latestCalc(calcs) {
    var _a, _b, _c, _d;
    let best;
    for (const calc of calcs){
        const candidate = calc;
        if (!best || ((_a = candidate.version) !== null && _a !== void 0 ? _a : 0) > ((_b = best.version) !== null && _b !== void 0 ? _b : 0) || ((_c = candidate.version) !== null && _c !== void 0 ? _c : 0) === ((_d = best.version) !== null && _d !== void 0 ? _d : 0) && candidate.id > best.id) best = candidate;
    }
    return best;
}
function $77089501411ae7ed$export$e9e91ba84fceeaa4(sourceType) {
    return {
        calculated: {
            source: "StoredCalculation",
            via: "sourceId",
            where: {
                sourceType: sourceType
            },
            apply: (base, calcs)=>{
                const latest = $77089501411ae7ed$var$latestCalc(calcs);
                return latest && latest.calculated !== undefined ? Object.assign(Object.assign({}, base), {
                    calculated: latest.calculated,
                    calculationVersion: latest.version
                }) : base;
            }
        },
        calculatedV2: {
            source: "StoredCalculation",
            via: "sourceId",
            where: {
                sourceType: sourceType
            },
            apply: (base, calcs)=>{
                const latest = $77089501411ae7ed$var$latestCalc(calcs);
                return latest && latest.calculatedV2 !== undefined ? Object.assign(Object.assign({}, base), {
                    calculatedV2: latest.calculatedV2
                }) : base;
            }
        }
    };
}
const $77089501411ae7ed$export$e76f3b283306e62e = {
    notes: {
        source: "Note",
        via: "dayId",
        with: [
            "attachments"
        ],
        apply: (base, notes)=>Object.assign(Object.assign({}, base), {
                notes: notes
            })
    }
};
const $77089501411ae7ed$export$3e07e926e134f0f2 = {
    notes: {
        source: "Note",
        via: "tripId",
        where: {
            dayId: undefined
        },
        with: [
            "attachments"
        ],
        apply: (base, notes)=>Object.assign(Object.assign({}, base), {
                notes: notes
            })
    }
};
const $77089501411ae7ed$export$542d613cd7bff032 = {
    notes: {
        source: "Note",
        via: "cruiseId",
        where: {
            tripId: undefined,
            dayId: undefined
        },
        with: [
            "attachments"
        ],
        apply: (base, notes)=>Object.assign(Object.assign({}, base), {
                notes: notes
            })
    }
};
const $77089501411ae7ed$export$d99a85b907980a97 = {
    attachments: {
        source: "NoteAttachment",
        via: "noteId",
        apply: (base, attachments)=>Object.assign(Object.assign({}, base), {
                attachments: attachments
            })
    }
};
function $77089501411ae7ed$export$3d0443392257ae11(rows, calculations = [], calculationsV2 = []) {
    return rows.map((row)=>{
        const calculated = calculations.find((result)=>result.id === row.id);
        const calculatedV2 = calculationsV2.find((result)=>result.id === row.id);
        if (!calculated && !calculatedV2) return row;
        return Object.assign(Object.assign(Object.assign({}, row), calculated ? {
            calculated: calculated.values,
            calculationVersion: calculated.version
        } : {}), calculatedV2 ? {
            calculatedV2: calculatedV2.values
        } : {});
    });
}


function $ae46f0fc3022c13d$export$88b555fcfe17b5a(response, previous) {
    return (0, $77089501411ae7ed$export$541d2c535509b7fe)((0, $77089501411ae7ed$export$3d0443392257ae11)([
        response.cruise
    ], response.calculation ? [
        response.calculation
    ] : [], response.calculationV2 ? [
        response.calculationV2
    ] : [])[0], previous);
}
const $ae46f0fc3022c13d$export$b42d235b6ded74c2 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("Cruise", {
    preserveLive: (0, $77089501411ae7ed$export$3dbb0b2d2178e57f),
    fetch: (client, ids)=>{
        const { shipId: shipId, cruiseId: cruiseId } = ids;
        if (shipId === undefined) return Promise.reject(new Error("Cruise fetch requires shipId"));
        if (cruiseId === undefined) return new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(client).cruises.list({
            params: {
                shipId: shipId
            }
        }).call().then((response)=>{
            var _a, _b, _c, _d, _e, _f;
            return {
                entities: {
                    Cruise: (0, $77089501411ae7ed$export$3d0443392257ae11)((_a = response.cruises) !== null && _a !== void 0 ? _a : [], (_b = response.calculations) !== null && _b !== void 0 ? _b : [], (_c = response.calculationsV2) !== null && _c !== void 0 ? _c : []),
                    Note: (_d = response.notes) !== null && _d !== void 0 ? _d : [],
                    NoteAttachment: (_e = response.attachments) !== null && _e !== void 0 ? _e : [],
                    DataRecord: (_f = response.dataRecords) !== null && _f !== void 0 ? _f : []
                },
                authoritative: {
                    Cruise: {
                        shipId: shipId
                    }
                }
            };
        });
        return new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(client).cruises.get({
            params: {
                shipId: shipId,
                cruiseId: cruiseId
            }
        }).call().then((response)=>{
            var _a, _b, _c;
            return {
                entities: {
                    Cruise: [
                        $ae46f0fc3022c13d$export$88b555fcfe17b5a(response)
                    ],
                    Note: (_a = response.notes) !== null && _a !== void 0 ? _a : [],
                    NoteAttachment: (_b = response.attachments) !== null && _b !== void 0 ? _b : [],
                    DataRecord: (_c = response.dataRecords) !== null && _c !== void 0 ? _c : []
                }
            };
        });
    },
    folds: Object.assign(Object.assign({}, (0, $77089501411ae7ed$export$e9e91ba84fceeaa4)((0, $0e9fc80557c7dff1$export$2bc642d888abd6fb).cruise)), (0, $77089501411ae7ed$export$542d613cd7bff032))
});



const $3e80c0a4da1f2168$export$cc07d32d5adf1300 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("DataRecord");






const $69c84bcef5135421$export$a31b1384828b56de = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("Day", {
    sort: (a, b)=>a.day - b.day,
    preserveLive: (0, $77089501411ae7ed$export$3dbb0b2d2178e57f),
    fetch: (client, ids)=>{
        const { shipId: shipId, tripId: tripId } = ids;
        if (shipId === undefined || tripId === undefined) return Promise.reject(new Error("Day fetch requires shipId and tripId"));
        return new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(client).days.list({
            params: {
                shipId: shipId,
                tripId: tripId
            }
        }).call().then((response)=>{
            var _a, _b, _c, _d, _e, _f;
            return {
                entities: {
                    Day: (0, $77089501411ae7ed$export$3d0443392257ae11)((_a = response.days) !== null && _a !== void 0 ? _a : [], (_b = response.calculations) !== null && _b !== void 0 ? _b : [], (_c = response.calculationsV2) !== null && _c !== void 0 ? _c : []),
                    Note: (_d = response.notes) !== null && _d !== void 0 ? _d : [],
                    NoteAttachment: (_e = response.attachments) !== null && _e !== void 0 ? _e : []
                },
                extras: {
                    auditLogEdits: (_f = response.auditLogEdits) !== null && _f !== void 0 ? _f : []
                }
            };
        });
    },
    folds: Object.assign(Object.assign({}, (0, $77089501411ae7ed$export$e9e91ba84fceeaa4)((0, $0e9fc80557c7dff1$export$2bc642d888abd6fb).day)), (0, $77089501411ae7ed$export$e76f3b283306e62e))
});






// The freshest calc for a source: highest version, breaking ties by id. There is
// realistically 0 or 1 row per (sourceId, sourceType), but this stays correct if a
// stale duplicate lingers.
function $078329efd7ae6a01$var$latestCalc(calcs) {
    var _a, _b, _c, _d;
    let best;
    for (const calc of calcs){
        const c = calc;
        if (!best || ((_a = c.version) !== null && _a !== void 0 ? _a : 0) > ((_b = best.version) !== null && _b !== void 0 ? _b : 0) || ((_c = c.version) !== null && _c !== void 0 ? _c : 0) === ((_d = best.version) !== null && _d !== void 0 ? _d : 0) && c.id > best.id) best = c;
    }
    return best;
}
// The two opt-in calc folds Log exposes: both read StoredCalculation rows indexed
// by `sourceId` and narrowed to log-sourced calcs. `calculated` projects the v1
// flat + its version; `calculatedV2` attaches the raw v2 sections. Each returns the
// base log unchanged when the relevant shape is absent (stability).
const $078329efd7ae6a01$var$logCalcFolds = {
    calculated: {
        source: "StoredCalculation",
        via: "sourceId",
        where: {
            sourceType: (0, $0e9fc80557c7dff1$export$2bc642d888abd6fb).log
        },
        apply: (log, calcs)=>{
            const latest = $078329efd7ae6a01$var$latestCalc(calcs);
            return latest && latest.calculated !== undefined ? Object.assign(Object.assign({}, log), {
                calculated: latest.calculated,
                calculationVersion: latest.version
            }) : log;
        }
    },
    calculatedV2: {
        source: "StoredCalculation",
        via: "sourceId",
        where: {
            sourceType: (0, $0e9fc80557c7dff1$export$2bc642d888abd6fb).log
        },
        apply: (log, calcs)=>{
            const latest = $078329efd7ae6a01$var$latestCalc(calcs);
            return latest && latest.calculatedV2 !== undefined ? Object.assign(Object.assign({}, log), {
                calculatedV2: latest.calculatedV2
            }) : log;
        }
    }
};
const $078329efd7ae6a01$export$638eadb65cd3780c = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("Log", {
    sort: (0, $9ee99da17e54efd8$export$5b4310eab721f4c),
    fetch: (client, ids)=>{
        const { shipId: shipId, dayId: dayId } = ids;
        if (shipId === undefined || dayId === undefined) return Promise.reject(new Error("Log fetch requires shipId and dayId"));
        return new (0, $199ead3c99f138be$export$89c3ec6dea3c6061)(client).logs.list({
            params: {
                shipId: shipId,
                dayId: dayId
            }
        }).call().then((r)=>{
            var _a, _b, _c, _d;
            return {
                entities: {
                    Log: (_a = r.logs) !== null && _a !== void 0 ? _a : [],
                    Status: (_b = r.statuses) !== null && _b !== void 0 ? _b : [],
                    // The rich logs.list response already carries calcs in the normalized
                    // `IStoredLogCalculation` shape (real id, sourceId, version, ungated v1
                    // `calculated` + optional v2 sections) — normalize them into their own
                    // StoredCalculation entities so an opt-in fold can stitch them back on.
                    StoredCalculation: (_c = r.calculationsV2) !== null && _c !== void 0 ? _c : []
                },
                extras: {
                    auditLogEdits: (_d = r.auditLogEdits) !== null && _d !== void 0 ? _d : []
                }
            };
        });
    },
    folds: $078329efd7ae6a01$var$logCalcFolds
});




const $e18b83a5ee8329ec$export$d27b5bad63d18e13 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("Note", {
    folds: (0, $77089501411ae7ed$export$d99a85b907980a97)
});




const $8906ba4b0b4ee53e$export$d5d6ba8594f76fb9 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("NoteAttachment", {
    fetch: (client, { shipId: shipId, noteId: noteId })=>{
        if (shipId === undefined || noteId !== 0) return Promise.reject(new Error("Ship attachment fetch requires shipId and noteId 0"));
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(client).ships.attachments({
            params: {
                shipId: shipId
            }
        }).call().then((response)=>({
                entities: {
                    NoteAttachment: response.attachments
                },
                authoritative: {
                    NoteAttachment: {
                        shipId: shipId,
                        noteId: 0
                    }
                }
            }));
    }
});



const $34b74b0c658ff343$export$54a178caf452e4e0 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("Settings", {
    providedBy: "Ship",
    sort: (a, b)=>b.updatedAt.localeCompare(a.updatedAt) || b.id - a.id
});




function $f9705d80e0e6f3f5$var$delegatedUserId(ids) {
    const value = Reflect.get(ids, "userId");
    return typeof value === "number" ? value : undefined;
}
// #1792 (tracker #1652): `ship_users.id` is unique per ship, not per account, so
// one user's cross-ship membership list routinely carries several rows sharing an
// id (confirmed against a real run database: id 7 existed on both ship 6 and ship
// 7). The store keys entities by type + id, so such rows cannot all be represented
// -- writing them collapses the set to whichever landed last, and because the list
// also claims `{ userId }` authority it *replaces* the selected ship's own roster
// with that collapsed set. The selected ship is then left with no roster row for
// the logged-in user, which `AppView`'s access-state effect reads as "no access"
// and evicts the user out of a ship they fully own (seen as
// `companion-connect-sync.spec.ts` bouncing back to `/app/account`).
//
// `DataStore.isCrossShipShipUserCollision` already refuses the same overwrite for
// live broadcasts; this is the fetch-side half of that identity boundary. Only the
// ambiguous rows are withheld, so a list whose ids happen not to collide keeps the
// exact entity/authority behaviour #1642 (tracker #665) designed. Every row --
// withheld or not -- still reaches the ship picker through `extras.membership`,
// which `mergeLiveMembership` matches on shipId as well as id.
function $f9705d80e0e6f3f5$var$membershipWithoutIdCollisions(rows) {
    const collidingIds = new Set();
    const seen = new Map();
    for (const row of rows){
        const previous = seen.get(row.id);
        if (previous !== undefined && previous !== row) collidingIds.add(row.id);
        seen.set(row.id, row);
    }
    return rows.filter((row)=>!collidingIds.has(row.id));
}
const $f9705d80e0e6f3f5$export$d345e7a510ef8c85 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("Ship", {
    fetch: (client, ids)=>{
        const shipId = ids.shipId;
        if (shipId !== undefined) return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(client).ships.get({
            params: {
                shipId: shipId
            }
        }).call().then((r)=>{
            var _a, _b, _c, _d;
            const shipUsers = [
                ...(_a = r.users) !== null && _a !== void 0 ? _a : []
            ];
            if (r.user) {
                const activeIndex = shipUsers.findIndex((user)=>{
                    var _a;
                    return user.id === ((_a = r.user) === null || _a === void 0 ? void 0 : _a.id);
                });
                if (activeIndex === -1) shipUsers.push(r.user);
                else {
                    const hydrated = shipUsers[activeIndex];
                    shipUsers[activeIndex] = Object.assign(Object.assign({}, r.user), {
                        name: r.user.name || hydrated.name,
                        shortname: r.user.shortname || hydrated.shortname
                    });
                }
            }
            return {
                entities: {
                    Ship: r.ship ? [
                        r.ship
                    ] : [],
                    ShipUser: shipUsers,
                    Settings: (_b = r.settings) !== null && _b !== void 0 ? _b : []
                },
                extras: {
                    activeShipUserId: (_c = r.user) === null || _c === void 0 ? void 0 : _c.id,
                    settings: (_d = r.settings) !== null && _d !== void 0 ? _d : [],
                    ship: r.ship,
                    shipUsers: shipUsers
                },
                authoritative: {
                    ShipUser: {
                        shipId: shipId
                    },
                    Settings: {
                        shipId: shipId
                    }
                }
            };
        });
        const userId = $f9705d80e0e6f3f5$var$delegatedUserId(ids);
        if (userId !== undefined) return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(client).ships.list({
            params: {}
        }).call().then((r)=>{
            var _a, _b;
            const membership = (_a = r.users) !== null && _a !== void 0 ? _a : [];
            const storable = $f9705d80e0e6f3f5$var$membershipWithoutIdCollisions(membership);
            const complete = storable.length === membership.length;
            return {
                entities: {
                    Ship: (_b = r.ships) !== null && _b !== void 0 ? _b : [],
                    ShipUser: storable
                },
                // ShipUser ids are only unique inside their account/ship scope. The
                // all-ships response can therefore contain repeated ids, which a
                // type-global entity map cannot preserve. Keep the exact membership
                // rows with the provider query for the ship picker.
                extras: {
                    ownShipId: r.ownShipId,
                    membership: membership
                },
                partial: [
                    "ShipUser"
                ],
                // Authority means "this response is the complete set for this scope".
                // Once a colliding row has been withheld that is no longer true, so
                // claiming it would evict the very rows this response cannot carry --
                // including the selected ship's own roster. Drop the claim instead of
                // asserting something the response can't back up.
                authoritative: complete ? {
                    Ship: {},
                    ShipUser: {
                        userId: userId
                    }
                } : {
                    Ship: {}
                }
            };
        });
        return Promise.reject(new Error("Ship fetch requires shipId or userId"));
    }
});



const $e071eeaf467ba821$export$131ae30c6844c3df = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("ShipUser", {
    providedBy: "Ship"
});



const $0705a19bff547f9a$export$ad0eedbeb93cdf5e = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("Status", {
    providedBy: "Log"
});





// The generation at/above which a stored calc carries v2 sections. Mirrors
// `StoredCalculation.v2CalculationGeneration` in Sources/LogbookModel.
const $ee8daa0aec52e05a$var$v2CalculationGeneration = 2;
// Normalize a raw `StoredCalculation/Log` broadcast (an `IStoredCalculation`: a
// `data` JSON string, no `calculated`) into the stored `IStoredLogCalculation`
// shape the folds read. Version splits the parsed payload into the v1 flat
// (`calculated`) vs v2 sections (`calculatedV2`). Under #1122/#1128 a gen>=2 live
// broadcast already arrives v1-projected (version 1), so the v2 branch is defensive
// plumbing. Guards `data` so deletes (no payload) don't throw and keep their `id`.
function $ee8daa0aec52e05a$var$normalizeStoredCalculation(raw) {
    var _a;
    const r = raw;
    const parsed = r.data ? JSON.parse(r.data) : undefined;
    const version = (_a = r.version) !== null && _a !== void 0 ? _a : 1;
    const aggregateSource = r.sourceType === (0, $0e9fc80557c7dff1$export$2bc642d888abd6fb).cruise || r.sourceType === (0, $0e9fc80557c7dff1$export$2bc642d888abd6fb).day || r.sourceType === (0, $0e9fc80557c7dff1$export$2bc642d888abd6fb).trip;
    return {
        id: r.id,
        sourceId: r.sourceId,
        sourceType: r.sourceType,
        version: version,
        // Day/Trip consumers historically receive the live payload through
        // AppData.applyStoredCalculation, which always updates the compatibility
        // projection and its version. Keep that contract during their read migration.
        calculated: aggregateSource || version < $ee8daa0aec52e05a$var$v2CalculationGeneration ? parsed : undefined,
        calculatedV2: !aggregateSource && version >= $ee8daa0aec52e05a$var$v2CalculationGeneration ? parsed : undefined
    };
}
const $ee8daa0aec52e05a$export$4816c15a7562bba2 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("StoredCalculation", {
    // Each source broadcasts on its own channel. TripView adds day/trip retention
    // (#1612, tracker #665) while preserving the existing log channel.
    live: [
        (0, $1bedde6805bf6e79$export$f55210826850c514).storedCalculationLog,
        (0, $1bedde6805bf6e79$export$f55210826850c514).storedCalculationDay,
        (0, $1bedde6805bf6e79$export$f55210826850c514).storedCalculationTrip,
        (0, $1bedde6805bf6e79$export$f55210826850c514).storedCalculationCruise
    ],
    normalizeLive: $ee8daa0aec52e05a$var$normalizeStoredCalculation
});




const $8e6debfe68cb4ce9$export$91b1e2e2335a9a5 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("Track", {
    fetch: (client, ids)=>{
        const { shipId: shipId, cruiseId: cruiseId, dayId: dayId, tripId: tripId } = ids;
        if (shipId === undefined) return Promise.reject(new Error("Track fetch requires shipId"));
        const request = dayId !== undefined ? new (0, $655725c259161537$export$2f8f7bdb7e386612)(client).tracks.day({
            params: {
                shipId: shipId,
                dayId: dayId
            }
        }).call() : tripId !== undefined ? new (0, $655725c259161537$export$2f8f7bdb7e386612)(client).tracks.trip({
            params: {
                shipId: shipId,
                tripId: tripId
            }
        }).call() : cruiseId !== undefined ? new (0, $655725c259161537$export$2f8f7bdb7e386612)(client).tracks.cruise({
            params: {
                shipId: shipId,
                cruiseId: cruiseId
            }
        }).call() : Promise.reject(new Error("Track fetch requires cruiseId, dayId or tripId"));
        return request.then((r)=>{
            var _a, _b;
            return {
                entities: {
                    Track: (_a = r.tracks) !== null && _a !== void 0 ? _a : []
                },
                // anchorCircles have no id — they're not a persisted schema entity, so they
                // ride the fetch as view-local extras (like logs.list's auditLogEdits).
                extras: {
                    anchorCircles: (_b = r.anchorCircles) !== null && _b !== void 0 ? _b : []
                }
            };
        });
    }
});






function $faf562ea0f6b43ea$export$80b0ae8a211cdcb4(response, previous) {
    return (0, $77089501411ae7ed$export$541d2c535509b7fe)((0, $77089501411ae7ed$export$3d0443392257ae11)([
        response.trip
    ], response.calculation ? [
        response.calculation
    ] : [], response.calculationV2 ? [
        response.calculationV2
    ] : [])[0], previous);
}
const $faf562ea0f6b43ea$export$7228a5bcc5e6fdf8 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("Trip", {
    sort: (a, b)=>a.id - b.id,
    preserveLive: (0, $77089501411ae7ed$export$3dbb0b2d2178e57f),
    fetch: (client, ids)=>{
        const { shipId: shipId, cruiseId: cruiseId } = ids;
        if (shipId === undefined || cruiseId === undefined) return Promise.reject(new Error("Trip fetch requires shipId and cruiseId"));
        return new (0, $84aa1a3b4df5a78b$export$5e13e029a186945f)(client).trips.list({
            params: {
                shipId: shipId,
                cruiseId: cruiseId
            }
        }).call().then((response)=>{
            var _a, _b, _c, _d, _e;
            return {
                entities: {
                    Trip: (0, $77089501411ae7ed$export$3d0443392257ae11)((_a = response.trips) !== null && _a !== void 0 ? _a : [], (_b = response.calculations) !== null && _b !== void 0 ? _b : [], (_c = response.calculationsV2) !== null && _c !== void 0 ? _c : []),
                    Note: (_d = response.notes) !== null && _d !== void 0 ? _d : [],
                    NoteAttachment: (_e = response.attachments) !== null && _e !== void 0 ? _e : []
                }
            };
        });
    },
    folds: Object.assign(Object.assign({}, (0, $77089501411ae7ed$export$e9e91ba84fceeaa4)((0, $0e9fc80557c7dff1$export$2bc642d888abd6fb).trip)), (0, $77089501411ae7ed$export$3e07e926e134f0f2))
});



const $3b2a9d4e85195772$export$6b7c0cfe2d68efd7 = (0, $dce9b2b6397c0cdf$export$4b5127edceda427d)("User");



const $dced7aa321629549$export$ab9f7df4498d2fd5 = {
    Account: (0, $a039797581f5ab08$export$680160523e6bfa6a),
    AccountUser: (0, $23aa8d5aa29fb8fb$export$76325f8e6fcc7483),
    AccountSubscriptionPlan: (0, $0423ccb45a4ff0ec$export$a031a406a1b12785),
    AccountSubscriptionPlanFeature: (0, $ee4230f63caa5204$export$38dc04fa47a524c7),
    AccountSubscriptionPlanPricing: (0, $0b7b442c54670519$export$632258bb375edb45),
    AuditLogEdit: (0, $ca84539de63fd988$export$7e10f2bca77eaeb1),
    Cruise: (0, $ae46f0fc3022c13d$export$b42d235b6ded74c2),
    DataRecord: (0, $3e80c0a4da1f2168$export$cc07d32d5adf1300),
    Day: (0, $69c84bcef5135421$export$a31b1384828b56de),
    Log: (0, $078329efd7ae6a01$export$638eadb65cd3780c),
    Note: (0, $e18b83a5ee8329ec$export$d27b5bad63d18e13),
    NoteAttachment: (0, $8906ba4b0b4ee53e$export$d5d6ba8594f76fb9),
    Settings: (0, $34b74b0c658ff343$export$54a178caf452e4e0),
    Ship: (0, $f9705d80e0e6f3f5$export$d345e7a510ef8c85),
    ShipUser: (0, $e071eeaf467ba821$export$131ae30c6844c3df),
    Status: (0, $0705a19bff547f9a$export$ad0eedbeb93cdf5e),
    StoredCalculation: (0, $ee8daa0aec52e05a$export$4816c15a7562bba2),
    Track: (0, $8e6debfe68cb4ce9$export$91b1e2e2335a9a5),
    Trip: (0, $faf562ea0f6b43ea$export$7228a5bcc5e6fdf8),
    User: (0, $3b2a9d4e85195772$export$6b7c0cfe2d68efd7)
};


// The normalized entity store — the framework-agnostic core of the Data layer.
//
// Every model is kept exactly once by (entityType, id), indexed by its owner-FK
// fields (derived from the schema graph via the connection layer). A single
// centralized merge (`applyLive`) upserts or removes entities; one subscription
// per entity type routes live broadcasts into it, activated by a ref-counted
// retain/release lifecycle; identical concurrent fetches dedupe by key. React
// binds to it through `useSyncExternalStore` (see `useStore.ts`), so re-render
// granularity comes from referentially-stable snapshots: an unrelated entity's
// change never produces a new query array.
//
// #1707 (tracker #1677) extracted that entire generic engine into app-base's
// `data/store` (parameterized by a `DataSchema`, with no knowledge of Logbook's
// generated types or the two id-0 "uncommitted" log channels below). `DataStore`
// here `extends` it: every generic method (`getEntity`, `getQuery`, `retain`,
// `release`, `fetchQuery`, `applyBundle`, the diagnostics reads, …) is inherited
// unchanged, so this file owns only what the generic engine deliberately does
// not — the current/provisional log extension, Logbook's `ApiClient`-typed
// mutation surface, and the merged Logbook diagnostics status (see each
// section's own comment). Two methods are overridden, both with the *same*
// public signature as their base version (`subscribe`, `setDiagnosticTrace`) so
// the override stays a pure addition, not a narrowing; `applyLive`/`mutate` are
// overridden to keep their prior, stricter Logbook-only parameter types
// (`LiveInfo`, `ApiClient`) — see each for why that's safe.

var $8db6d07d03d30085$var$__assign = undefined && undefined.__assign || function() {
    $8db6d07d03d30085$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8db6d07d03d30085$var$__assign.apply(this, arguments);
};
var $8db6d07d03d30085$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8db6d07d03d30085$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8db6d07d03d30085$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $8db6d07d03d30085$export$852b4f83e9213ce8 = "delete";
var $8db6d07d03d30085$export$47a0e4800a1fd7dc = /** @class */ function() {
    function DataStore(deps) {
        var _a, _b, _c, _d;
        this.diagnosticTraceEnabled = false;
        // entities[type][id] = record
        this.entities = new Map();
        // indexes[type][fkField][fkValue] = set of ids
        this.indexes = new Map();
        // monotonic per-type version, bumped whenever any entity of that type changes
        this.typeVersions = new Map();
        // memoized query results keyed by queryKey, tagged with the type version used
        this.queryCache = new Map();
        // memoized folded query results keyed by foldKey (queryKey + fold names)
        this.foldedCache = new Map();
        // memoized per-row projections keyed by foldKey + row id
        this.projectionMemo = new Map();
        this.listeners = new Set();
        this.liveListeners = new Map();
        // ref-counted per-type subscription lifecycle
        this.retainCounts = new Map();
        this.subscriptionIds = new Map();
        // in-flight fetches keyed by fetch key (dedup)
        this.inflight = new Map();
        // Rows touched by a live mutation are newer than any already-started
        // provider response. Identity-scoped stores make this safe to retain for
        // the store lifetime.
        this.liveOwned = new Map();
        // non-entity extras (view-local data riding a fetch) keyed by provider queryKey
        this.extras = new Map();
        this.successfulFetches = new Set();
        this.socket = deps.socket;
        this.apiClient = deps.apiClient;
        this.connections = deps.connections;
        this.edges = (_a = deps.edges) !== null && _a !== void 0 ? _a : [];
        this.supportLog = (_b = deps.supportLog) !== null && _b !== void 0 ? _b : function() {};
        this.traceLog = (_c = deps.traceLog) !== null && _c !== void 0 ? _c : function() {};
        this.debugLog = (_d = deps.debugLog) !== null && _d !== void 0 ? _d : function() {};
        if (deps.seed) for(var _i = 0, _e = Object.entries(deps.seed); _i < _e.length; _i++){
            var _f = _e[_i], type = _f[0], rows = _f[1];
            if (rows && rows.length > 0) this.applyMany(type, rows);
        }
    }
    // ---- reads -------------------------------------------------------------
    DataStore.prototype.setDiagnosticTrace = function(enabled) {
        this.diagnosticTraceEnabled = enabled;
        this.emitTrace({
            event: "trace.changed",
            enabled: enabled
        }, true);
        return enabled;
    };
    DataStore.prototype.getDiagnosticStatus = function() {
        var _this = this;
        var entityCounts = Array.from(this.entities.entries()).filter(function(_a) {
            var rows = _a[1];
            return rows.size > 0;
        }).map(function(_a) {
            var type = _a[0], rows = _a[1];
            return {
                type: type,
                count: rows.size
            };
        }).sort($8db6d07d03d30085$var$compareDiagnosticType);
        var retained = Array.from(this.retainCounts.entries()).map(function(_a) {
            var type = _a[0], count = _a[1];
            return {
                type: type,
                count: count
            };
        }).sort($8db6d07d03d30085$var$compareDiagnosticType);
        var subscriptionTypes = new Set(Array.from(this.retainCounts.keys()));
        for(var _i = 0, _a = Array.from(this.subscriptionIds.keys()); _i < _a.length; _i++){
            var type = _a[_i];
            subscriptionTypes.add(type);
        }
        var subscriptions = Array.from(subscriptionTypes).map(function(type) {
            var _a, _b;
            return {
                type: type,
                active: ((_b = (_a = _this.subscriptionIds.get(type)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0,
                channels: _this.connections[type].live.map(function(token) {
                    return token.type;
                })
            };
        }).sort($8db6d07d03d30085$var$compareDiagnosticType);
        var inFlightFetches = Array.from(this.inflight.values()).map(function(entry) {
            return {
                type: entry.type,
                filter: $8db6d07d03d30085$var$__assign({}, entry.filter)
            };
        }).sort($8db6d07d03d30085$var$compareDiagnosticType);
        return $8db6d07d03d30085$var$immutableSnapshot({
            traceEnabled: this.diagnosticTraceEnabled,
            entityCounts: entityCounts,
            retained: retained,
            subscriptions: subscriptions,
            inFlightFetches: inFlightFetches
        });
    };
    DataStore.prototype.getDiagnosticEntities = function(typeName) {
        var _a, _b;
        var type = this.requireDiagnosticType(typeName);
        var rows = Array.from((_b = (_a = this.entities.get(type)) === null || _a === void 0 ? void 0 : _a.values()) !== null && _b !== void 0 ? _b : []).sort(function(a, b) {
            return a.id - b.id;
        });
        return $8db6d07d03d30085$var$immutableSnapshot(rows);
    };
    DataStore.prototype.getDiagnosticQuery = function(typeName, filter) {
        var type = this.requireDiagnosticType(typeName);
        return $8db6d07d03d30085$var$immutableSnapshot(this.getQuery(type, filter));
    };
    DataStore.prototype.getDiagnosticExtras = function() {
        return $8db6d07d03d30085$var$immutableSnapshot(Object.fromEntries(this.extras));
    };
    DataStore.prototype.getEntity = function(type, id) {
        var _a;
        return (_a = this.entities.get(type)) === null || _a === void 0 ? void 0 : _a.get(id);
    };
    // Query the entities of `type` whose indexed FK fields all equal the
    // filter, sorted by the connection's `sort`. Returns a referentially-stable
    // array: the same reference is returned until this query's slice actually
    // changes. When `folds` names opt-in folds declared on the connection, each
    // row is projected through them (see `getFoldedQuery`); plain callers pass
    // no `folds` and are unaffected.
    DataStore.prototype.getQuery = function(type, filter, folds) {
        if (folds && folds.length > 0) return this.getFoldedQuery(type, filter, folds);
        return this.getPlainQuery(type, filter);
    };
    DataStore.prototype.getPlainQuery = function(type, filter) {
        var _a;
        var key = this.queryKey(type, filter);
        var version = (_a = this.typeVersions.get(type)) !== null && _a !== void 0 ? _a : 0;
        var cached = this.queryCache.get(key);
        if (cached && cached.version === version) return cached.result;
        var result = this.computeQuery(type, filter);
        if (cached && $8db6d07d03d30085$var$shallowEqual(cached.result, result)) {
            // Nothing this query cares about changed: keep the old reference so
            // useSyncExternalStore bails out of a re-render.
            this.queryCache.set(key, {
                version: version,
                result: cached.result
            });
            return cached.result;
        }
        this.queryCache.set(key, {
            version: version,
            result: result
        });
        return result;
    };
    // Resolve a base query and project each row through the named opt-in
    // folds. The result array is referentially stable across changes that
    // don't touch this query's base rows or their fold sources, and each row's
    // projection is stable unless that row or its own fold slices changed.
    DataStore.prototype.getFoldedQuery = function(type, filter, foldNames) {
        var _this = this;
        var base = this.getPlainQuery(type, filter);
        var declared = this.connections[type].folds;
        var folds = foldNames.map(function(name) {
            return declared === null || declared === void 0 ? void 0 : declared[name];
        }).filter(function(fold) {
            return fold !== undefined;
        });
        if (folds.length === 0) return base;
        var foldKey = "".concat(this.queryKey(type, filter), "::").concat($8db6d07d03d30085$var$__spreadArray([], foldNames, true).sort().join("+"));
        var version = this.foldVersionKey(type, folds);
        var cached = this.foldedCache.get(foldKey);
        if (cached && cached.version === version) return cached.result;
        var projected = base.map(function(row) {
            return _this.projectRow(foldKey, row, folds);
        });
        if (cached && $8db6d07d03d30085$var$shallowEqual(cached.result, projected)) {
            this.foldedCache.set(foldKey, {
                version: version,
                result: cached.result
            });
            return cached.result;
        }
        this.foldedCache.set(foldKey, {
            version: version,
            result: projected
        });
        return projected;
    };
    // A composite version over the base type and every fold-source type, so a
    // change to any of them invalidates the folded cache (while an unrelated
    // type's change does not).
    DataStore.prototype.foldVersionKey = function(type, folds) {
        var _a, _b;
        var sources = new Set();
        this.collectFoldSources(folds, sources);
        var key = "".concat((_a = this.typeVersions.get(type)) !== null && _a !== void 0 ? _a : 0);
        for(var _i = 0, _c = Array.from(sources).sort(); _i < _c.length; _i++){
            var source = _c[_i];
            key += "|".concat(source, "=").concat((_b = this.typeVersions.get(source)) !== null && _b !== void 0 ? _b : 0);
        }
        return key;
    };
    DataStore.prototype.collectFoldSources = function(folds, sources) {
        var _loop_1 = function(fold) {
            sources.add(fold.source);
            if (fold.with) {
                var nested_1 = this_1.connections[fold.source].folds;
                var requested = fold.with.map(function(name) {
                    return nested_1 === null || nested_1 === void 0 ? void 0 : nested_1[name];
                }).filter(function(candidate) {
                    return candidate !== undefined;
                });
                this_1.collectFoldSources(requested, sources);
            }
        };
        var this_1 = this;
        for(var _i = 0, folds_1 = folds; _i < folds_1.length; _i++){
            var fold = folds_1[_i];
            _loop_1(fold);
        }
    };
    // Project one base row through the folds, memoized on the row + the ordered
    // source-row references. Filtering can allocate a new, unchanged slice.
    DataStore.prototype.projectRow = function(foldKey, row, folds) {
        var _this = this;
        var slices = folds.map(function(fold) {
            var _a;
            var filter = (_a = {}, _a[fold.via] = row.id, _a);
            var source = fold.with && fold.with.length > 0 ? _this.getFoldedQuery(fold.source, filter, fold.with) : _this.getPlainQuery(fold.source, filter);
            return _this.filterWhere(source, fold.where);
        });
        var memoKey = "".concat(foldKey, "#").concat(row.id);
        var memo = this.projectionMemo.get(memoKey);
        if (memo && memo.row === row && $8db6d07d03d30085$var$sameSlices(memo.slices, slices)) return memo.result;
        var out = row;
        for(var i = 0; i < folds.length; i++)out = folds[i].apply(out, slices[i]);
        this.projectionMemo.set(memoKey, {
            row: row,
            slices: slices,
            result: out
        });
        return out;
    };
    // Narrow a fold's source slice by its `where` clause. Returns the same
    // reference when nothing is excluded; otherwise the projection memo compares
    // the filtered row references rather than the newly allocated array.
    DataStore.prototype.filterWhere = function(slice, where) {
        if (!where) return slice;
        for(var _i = 0, slice_1 = slice; _i < slice_1.length; _i++){
            var row = slice_1[_i];
            if (!$8db6d07d03d30085$var$matchesWhere(row, where)) return slice.filter(function(r) {
                return $8db6d07d03d30085$var$matchesWhere(r, where);
            });
        }
        return slice;
    };
    DataStore.prototype.computeQuery = function(type, filter) {
        var byId = this.entities.get(type);
        if (!byId || byId.size === 0) return $8db6d07d03d30085$var$EMPTY;
        var ids = this.candidateIds(type, filter);
        var rows = [];
        for(var _i = 0, ids_1 = ids; _i < ids_1.length; _i++){
            var id = ids_1[_i];
            var row = byId.get(id);
            if (row && this.matches(row, filter)) rows.push(row);
        }
        var sort = this.connections[type].sort;
        if (sort) rows.sort(sort);
        return rows.length === 0 ? $8db6d07d03d30085$var$EMPTY : rows;
    };
    // Narrow to the ids that can match: intersect the index buckets of the
    // filter fields (smallest first). Falls back to every id of the type when a
    // field is not indexed or no filter is given.
    DataStore.prototype.candidateIds = function(type, filter) {
        var _a, _b, _c;
        var typeIndexes = this.indexes.get(type);
        var buckets = [];
        for(var _i = 0, _d = Object.entries(filter); _i < _d.length; _i++){
            var _e = _d[_i], field = _e[0], value = _e[1];
            if (value === undefined) continue;
            var bucket = (_a = typeIndexes === null || typeIndexes === void 0 ? void 0 : typeIndexes.get(field)) === null || _a === void 0 ? void 0 : _a.get(value);
            if (!bucket) return []; // an indexed filter with no matching bucket -> no rows
            buckets.push(bucket);
        }
        if (buckets.length === 0) return Array.from((_c = (_b = this.entities.get(type)) === null || _b === void 0 ? void 0 : _b.keys()) !== null && _c !== void 0 ? _c : []);
        buckets.sort(function(a, b) {
            return a.size - b.size;
        });
        var smallest = buckets[0], rest = buckets.slice(1);
        var out = [];
        var _loop_2 = function(id) {
            if (rest.every(function(bucket) {
                return bucket.has(id);
            })) out.push(id);
        };
        for(var _f = 0, _g = Array.from(smallest); _f < _g.length; _f++){
            var id = _g[_f];
            _loop_2(id);
        }
        return out;
    };
    DataStore.prototype.matches = function(row, filter) {
        for(var _i = 0, _a = Object.entries(filter); _i < _a.length; _i++){
            var _b = _a[_i], field = _b[0], value = _b[1];
            if (value !== undefined && row[field] !== value) return false;
        }
        return true;
    };
    // ---- deps support --------------------------------------------------
    // The opt-in fold declared on `type` under `name`, or undefined. Used by
    // `./use-deps` to determine which additional entity types a relationship's
    // opted-in folds must keep live.
    DataStore.prototype.getFold = function(type, name) {
        var _a;
        return (_a = this.connections[type].folds) === null || _a === void 0 ? void 0 : _a[name];
    };
    // The FK field on `to` that points back to `from`, resolved from this
    // store's schema edges. Used by `./use-deps` to bind a relationship's query
    // filter from a `deps` declaration's root ids.
    DataStore.prototype.resolveOwnerFk = function(from, to) {
        return (0, $29278580678edd79$export$6d0e606268da942c)(from, to, this.edges);
    };
    // ---- live merge --------------------------------------------------------
    // The one centralized merge. Normalizes a raw broadcast into the stored
    // shape (identity for most entities), then removes it when the event is a
    // delete or its soft-delete field is set; otherwise upserts. Notifies
    // listeners once.
    DataStore.prototype.applyLive = function(type, entity, info) {
        this.applyLiveRaw(type, entity, info);
    };
    DataStore.prototype.applyLiveRaw = function(type, entity, info) {
        var _a;
        var identified = this.normalizeEntity(type, entity);
        var normalize = this.connections[type].normalizeLive;
        var normalized = normalize ? normalize(identified) : identified;
        var preserve = this.connections[type].preserveLive;
        var previous = preserve ? this.peek(type, normalized.id) : undefined;
        var next = normalized;
        if (previous && preserve) for(var _i = 0, preserve_1 = preserve; _i < preserve_1.length; _i++){
            var field = preserve_1[_i];
            if (next[field] === undefined && previous[field] !== undefined) {
                if (next === normalized) next = $8db6d07d03d30085$var$__assign({}, normalized);
                next[field] = previous[field];
            }
        }
        var mutation = {
            type: type,
            entity: next,
            deleted: this.isDelete(type, normalized, info)
        };
        var kind = mutation.deleted ? this.peek(type, mutation.entity.id) ? "removed" : undefined : this.peek(type, mutation.entity.id) ? "updated" : "added";
        for(var _b = 0, _c = Array.from(this.inflight.values()); _b < _c.length; _b++){
            var entry = _c[_b];
            entry.live.push(mutation);
        }
        var applied = this.applyLiveMutation(mutation);
        if (applied) this.notify();
        this.emitLiveResult(type, mutation.entity.id, info, mutation.deleted, applied ? kind : undefined);
        for(var _d = 0, _e = Array.from((_a = this.liveListeners.get(type)) !== null && _a !== void 0 ? _a : []); _d < _e.length; _d++){
            var listener = _e[_d];
            listener();
        }
    };
    DataStore.prototype.normalizeEntity = function(type, entity) {
        var normalize = this.connections[type].normalize;
        if (normalize) return normalize(entity);
        if (typeof entity === "object" && entity !== null && "id" in entity && typeof entity.id === "number") return entity;
        throw new Error("DataStore: ".concat(type, " ingress is missing a numeric id"));
    };
    // Normalize a fetched batch into the store, notifying once.
    DataStore.prototype.applyMany = function(type, rows) {
        for(var _i = 0, rows_1 = rows; _i < rows_1.length; _i++){
            var row = rows_1[_i];
            this.upsert(type, row);
        }
        this.notify();
    };
    // Normalize a side-normalizing fetch bundle: upsert every entity slice
    // across all types, reconcile any authoritative filtered slices, and stash
    // the extras under the provider's query key, notifying exactly once for
    // the whole bundle.
    DataStore.prototype.applyBundle = function(result, extrasKey, live) {
        if (live === void 0) live = [];
        return this.applyBundleInternal(result, extrasKey, live, false);
    };
    DataStore.prototype.applyBundlePreservingLive = function(result) {
        return this.applyBundleInternal(result, undefined, [], true);
    };
    DataStore.prototype.applyBundleInternal = function(result, extrasKey, live, preserveLive) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var slices = (0, $bcf0a4ee4a28a2dd$export$df392344a67abe9b)(result.entities);
        var partial = new Set((_a = result.partial) !== null && _a !== void 0 ? _a : []);
        var affectedTypes = new Set(slices.map(function(_a) {
            var type = _a[0];
            return type;
        }));
        for(var _i = 0, _l = Object.keys((_b = result.authoritative) !== null && _b !== void 0 ? _b : {}); _i < _l.length; _i++){
            var type = _l[_i];
            affectedTypes.add(type);
        }
        var before = new Map();
        var capture = function(type, id) {
            var rows = before.get(type);
            if (!rows) {
                rows = new Map();
                before.set(type, rows);
            }
            if (!rows.has(id)) rows.set(id, _this.peek(type, id));
        };
        for(var _m = 0, slices_1 = slices; _m < slices_1.length; _m++){
            var _o = slices_1[_m], type = _o[0], rows = _o[1];
            for(var _p = 0, rows_2 = rows; _p < rows_2.length; _p++){
                var row = rows_2[_p];
                capture(type, row.id);
            }
        }
        var authoritativeRows = new Map();
        for(var _q = 0, _r = Object.entries((_c = result.authoritative) !== null && _c !== void 0 ? _c : {}); _q < _r.length; _q++){
            var _s = _r[_q], rawType = _s[0], filter = _s[1];
            var type = rawType;
            var rows = this.computeQuery(type, filter);
            authoritativeRows.set(type, rows);
            for(var _t = 0, rows_3 = rows; _t < rows_3.length; _t++){
                var row = rows_3[_t];
                capture(type, row.id);
            }
        }
        for(var _u = 0, live_1 = live; _u < live_1.length; _u++){
            var mutation = live_1[_u];
            if (affectedTypes.has(mutation.type)) capture(mutation.type, mutation.entity.id);
        }
        var _loop_3 = function(rawType) {
            var type = rawType;
            var incoming = new Set(((_f = (_e = slices.find(function(_a) {
                var sliceType = _a[0];
                return sliceType === type;
            })) === null || _e === void 0 ? void 0 : _e[1]) !== null && _f !== void 0 ? _f : []).map(function(row) {
                return row.id;
            }));
            for(var _7 = 0, _8 = (_g = authoritativeRows.get(type)) !== null && _g !== void 0 ? _g : []; _7 < _8.length; _7++){
                var row = _8[_7];
                if (!incoming.has(row.id) && !(preserveLive && ((_h = this_2.liveOwned.get(type)) === null || _h === void 0 ? void 0 : _h.has(row.id)))) this_2.removeEntity(type, row.id);
            }
        };
        var this_2 = this;
        for(var _v = 0, _w = Object.entries((_d = result.authoritative) !== null && _d !== void 0 ? _d : {}); _v < _w.length; _v++){
            var rawType = _w[_v][0];
            _loop_3(rawType);
        }
        for(var _x = 0, slices_2 = slices; _x < slices_2.length; _x++){
            var _y = slices_2[_x], type = _y[0], rows = _y[1];
            for(var _z = 0, rows_4 = rows; _z < rows_4.length; _z++){
                var row = rows_4[_z];
                if (preserveLive && ((_j = this.liveOwned.get(type)) === null || _j === void 0 ? void 0 : _j.has(row.id))) continue;
                if (partial.has(type)) this.upsertPartial(type, row);
                else this.upsert(type, row);
            }
        }
        for(var _0 = 0, live_2 = live; _0 < live_2.length; _0++){
            var mutation = live_2[_0];
            if (affectedTypes.has(mutation.type)) this.applyLiveMutation(mutation);
        }
        if (extrasKey && result.extras) this.extras.set(extrasKey, result.extras);
        var summary = $8db6d07d03d30085$var$diagnosticChangeSummary(this.diagnosticTraceEnabled);
        for(var _1 = 0, _2 = Array.from(before); _1 < _2.length; _1++){
            var _3 = _2[_1], type = _3[0], rows = _3[1];
            for(var _4 = 0, _5 = Array.from(rows); _4 < _5.length; _4++){
                var _6 = _5[_4], id = _6[0], previous = _6[1];
                var current = this.peek(type, id);
                if (previous === current) continue;
                $8db6d07d03d30085$var$addDiagnosticChange(summary, previous === undefined ? "added" : current === undefined ? "removed" : "updated", type, id);
            }
        }
        this.notify();
        if (Object.keys((_k = result.authoritative) !== null && _k !== void 0 ? _k : {}).length > 0) this.emitTraceLazy(function() {
            return {
                event: "reconcile.authoritative",
                changed: $8db6d07d03d30085$var$diagnosticGroups(summary.changed),
                added: $8db6d07d03d30085$var$diagnosticGroups(summary.added),
                updated: $8db6d07d03d30085$var$diagnosticGroups(summary.updated),
                removed: $8db6d07d03d30085$var$diagnosticGroups(summary.removed)
            };
        });
        return summary;
    };
    // ---- mutations (optimistic writes) ------------------------------------
    // Perform one write through the layer: optimistically apply
    // `spec.optimistic`, run the typed REST `spec.request`, then on success
    // reconcile the authoritative response into the store (dropping any
    // `provisional` temp rows — the create temp-id -> real-id remap), or on
    // failure roll the optimistic write back and rethrow. Rollback is guarded:
    // an entity is only reverted while it still equals the record we wrote, so
    // a newer live broadcast that raced in is never clobbered. An offline store
    // (no apiClient) rejects without touching anything.
    DataStore.prototype.mutate = function(spec) {
        return $8db6d07d03d30085$var$__awaiter(this, void 0, Promise, function() {
            var apiClient, operation, preimage, response, bundle, summary_1, error_1, summary_2;
            return $8db6d07d03d30085$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        apiClient = this.apiClient;
                        if (!apiClient) return [
                            2 /*return*/ ,
                            Promise.reject(new Error("DataStore.mutate: no apiClient (offline store)"))
                        ];
                        operation = $8db6d07d03d30085$var$diagnosticMutationOperation(spec.optimistic);
                        this.emitTraceLazy(function() {
                            return {
                                event: "mutation.optimistic",
                                operation: operation,
                                changes: $8db6d07d03d30085$var$diagnosticMutationChanges(spec.optimistic)
                            };
                        });
                        preimage = this.applyOptimistic(spec.optimistic);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            spec.request(apiClient)
                        ];
                    case 2:
                        response = _a.sent();
                        bundle = spec.reconcile ? spec.reconcile(response) : undefined;
                        summary_1 = this.commitReconcile(bundle, spec.provisional);
                        this.emitTraceLazy(function() {
                            return {
                                event: "mutation.reconcile",
                                operation: operation,
                                changed: $8db6d07d03d30085$var$diagnosticGroups(summary_1.changed),
                                added: $8db6d07d03d30085$var$diagnosticGroups(summary_1.added),
                                updated: $8db6d07d03d30085$var$diagnosticGroups(summary_1.updated),
                                removed: $8db6d07d03d30085$var$diagnosticGroups(summary_1.removed)
                            };
                        });
                        this.emitSupport({
                            event: "mutation.success",
                            operation: operation,
                            changedCount: summary_1.changedCount,
                            added: $8db6d07d03d30085$var$diagnosticCountGroups(summary_1.added),
                            updated: $8db6d07d03d30085$var$diagnosticCountGroups(summary_1.updated),
                            removed: $8db6d07d03d30085$var$diagnosticCountGroups(summary_1.removed),
                            removedCount: summary_1.removedCount
                        });
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 3:
                        error_1 = _a.sent();
                        summary_2 = this.rollback(preimage);
                        this.emitTraceLazy(function() {
                            return {
                                event: "mutation.rollback",
                                operation: operation,
                                changed: $8db6d07d03d30085$var$diagnosticGroups(summary_2.changed),
                                added: $8db6d07d03d30085$var$diagnosticGroups(summary_2.added),
                                updated: $8db6d07d03d30085$var$diagnosticGroups(summary_2.updated),
                                removed: $8db6d07d03d30085$var$diagnosticGroups(summary_2.removed)
                            };
                        });
                        this.emitSupport({
                            event: "mutation.failure",
                            operation: operation,
                            error: $8db6d07d03d30085$var$diagnosticError(error_1)
                        });
                        throw error_1;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Apply the optimistic changes, capturing each touched entity's pre-image
    // (and the exact record we wrote) so a later rollback can revert precisely.
    // Notifies once.
    DataStore.prototype.applyOptimistic = function(changes) {
        if (!changes) return [];
        var preimage = [];
        var touched = false;
        for(var _i = 0, _a = (0, $bcf0a4ee4a28a2dd$export$df392344a67abe9b)(changes.upsert); _i < _a.length; _i++){
            var _b = _a[_i], type = _b[0], rows = _b[1];
            for(var _c = 0, rows_5 = rows; _c < rows_5.length; _c++){
                var row = rows_5[_c];
                var t = type;
                preimage.push({
                    type: t,
                    id: row.id,
                    prev: this.peek(t, row.id),
                    wrote: row
                });
                this.upsert(t, row);
                touched = true;
            }
        }
        for(var _d = 0, _e = (0, $bcf0a4ee4a28a2dd$export$7da07ced8fa2b227)(changes.remove); _d < _e.length; _d++){
            var _f = _e[_d], type = _f[0], ids = _f[1];
            for(var _g = 0, ids_2 = ids; _g < ids_2.length; _g++){
                var id = ids_2[_g];
                var t = type;
                preimage.push({
                    type: t,
                    id: id,
                    prev: this.peek(t, id),
                    wrote: undefined
                });
                if (this.removeEntity(t, id)) touched = true;
            }
        }
        if (touched) this.notify();
        return preimage;
    };
    // Upsert the authoritative response entities and drop the provisional temp
    // rows, in one notify. The reconcile bundle is idempotent by id, so it
    // dedupes against both the optimistic write and any broadcast that already
    // landed.
    DataStore.prototype.commitReconcile = function(bundle, provisional) {
        var _this = this;
        var touched = false;
        var before = new Map();
        var capture = function(type, id) {
            var rows = before.get(type);
            if (!rows) {
                rows = new Map();
                before.set(type, rows);
            }
            if (!rows.has(id)) rows.set(id, _this.peek(type, id));
        };
        for(var _i = 0, _a = (0, $bcf0a4ee4a28a2dd$export$df392344a67abe9b)(bundle === null || bundle === void 0 ? void 0 : bundle.entities); _i < _a.length; _i++){
            var _b = _a[_i], type = _b[0], rows = _b[1];
            for(var _c = 0, rows_6 = rows; _c < rows_6.length; _c++){
                var row = rows_6[_c];
                capture(type, row.id);
            }
        }
        for(var _d = 0, _e = (0, $bcf0a4ee4a28a2dd$export$7da07ced8fa2b227)(provisional); _d < _e.length; _d++){
            var _f = _e[_d], type = _f[0], ids = _f[1];
            for(var _g = 0, ids_3 = ids; _g < ids_3.length; _g++){
                var id = ids_3[_g];
                capture(type, id);
            }
        }
        if (bundle) for(var _h = 0, _j = (0, $bcf0a4ee4a28a2dd$export$df392344a67abe9b)(bundle.entities); _h < _j.length; _h++){
            var _k = _j[_h], type = _k[0], rows = _k[1];
            for(var _l = 0, rows_7 = rows; _l < rows_7.length; _l++){
                var row = rows_7[_l];
                this.upsert(type, row);
                touched = true;
            }
        }
        for(var _m = 0, _o = (0, $bcf0a4ee4a28a2dd$export$7da07ced8fa2b227)(provisional); _m < _o.length; _m++){
            var _p = _o[_m], type = _p[0], ids = _p[1];
            for(var _q = 0, ids_4 = ids; _q < ids_4.length; _q++){
                var id = ids_4[_q];
                if (this.removeEntity(type, id)) touched = true;
            }
        }
        var summary = $8db6d07d03d30085$var$diagnosticChangeSummary(this.diagnosticTraceEnabled);
        for(var _r = 0, _s = Array.from(before); _r < _s.length; _r++){
            var _t = _s[_r], type = _t[0], rows = _t[1];
            for(var _u = 0, _v = Array.from(rows); _u < _v.length; _u++){
                var _w = _v[_u], id = _w[0], previous = _w[1];
                var current = this.peek(type, id);
                if (previous === current) continue;
                $8db6d07d03d30085$var$addDiagnosticChange(summary, previous === undefined ? "added" : current === undefined ? "removed" : "updated", type, id);
            }
        }
        if (touched) this.notify();
        return summary;
    };
    // Revert an optimistic write. For each touched entity, only restore its
    // pre-image if the store still holds exactly the record we wrote (or, for
    // an optimistic remove, if it is still absent) — otherwise a newer
    // authoritative broadcast owns it now and must be left in place. Notifies
    // once if anything was reverted.
    DataStore.prototype.rollback = function(preimage) {
        var touched = false;
        var summary = $8db6d07d03d30085$var$diagnosticChangeSummary(this.diagnosticTraceEnabled);
        for(var _i = 0, preimage_1 = preimage; _i < preimage_1.length; _i++){
            var entry = preimage_1[_i];
            var current = this.peek(entry.type, entry.id);
            if (entry.wrote !== undefined) {
                if (current !== entry.wrote) continue; // a newer broadcast replaced our optimistic upsert.
            } else if (current !== undefined) continue; // a newer broadcast re-created what we optimistically removed.
            if (entry.prev !== undefined) {
                var kind = current ? "updated" : "added";
                this.upsert(entry.type, entry.prev);
                $8db6d07d03d30085$var$addDiagnosticChange(summary, kind, entry.type, entry.id);
            } else if (this.removeEntity(entry.type, entry.id)) $8db6d07d03d30085$var$addDiagnosticChange(summary, "removed", entry.type, entry.id);
            touched = true;
        }
        if (touched) this.notify();
        return summary;
    };
    // Read the stored record reference (undefined when absent) without the
    // typed cast `getEntity` applies — used for pre-image capture and the
    // rollback guard.
    DataStore.prototype.peek = function(type, id) {
        var _a;
        return (_a = this.entities.get(type)) === null || _a === void 0 ? void 0 : _a.get(id);
    };
    DataStore.prototype.isDelete = function(type, entity, info) {
        if (info === $8db6d07d03d30085$export$852b4f83e9213ce8) return true;
        var field = this.connections[type].softDelete;
        return field != null && entity[field] != null;
    };
    DataStore.prototype.applyLiveMutation = function(mutation) {
        var owned = this.liveOwned.get(mutation.type);
        if (!owned) {
            owned = new Set();
            this.liveOwned.set(mutation.type, owned);
        }
        owned.add(mutation.entity.id);
        if (mutation.deleted) return this.removeEntity(mutation.type, mutation.entity.id);
        this.upsert(mutation.type, mutation.entity);
        return true;
    };
    DataStore.prototype.upsert = function(type, entity) {
        var record = entity;
        var byId = this.map(this.entities, type);
        var prev = byId.get(entity.id);
        byId.set(entity.id, record);
        for(var _i = 0, _a = this.connections[type].indexes; _i < _a.length; _i++){
            var field = _a[_i];
            var nextVal = $8db6d07d03d30085$var$numeric(record[field]);
            var prevVal = prev ? $8db6d07d03d30085$var$numeric(prev[field]) : undefined;
            if (prev && prevVal === nextVal) continue;
            if (prevVal !== undefined) this.deindex(type, field, prevVal, entity.id);
            if (nextVal !== undefined) this.index(type, field, nextVal, entity.id);
        }
        this.bump(type);
    };
    DataStore.prototype.upsertPartial = function(type, entity) {
        var _a;
        var prev = (_a = this.entities.get(type)) === null || _a === void 0 ? void 0 : _a.get(entity.id);
        if (!prev) {
            this.upsert(type, entity);
            return;
        }
        var patch = Object.fromEntries(Object.entries(entity).filter(function(_a) {
            var value = _a[1];
            return value !== undefined;
        }));
        this.upsert(type, $8db6d07d03d30085$var$__assign($8db6d07d03d30085$var$__assign({}, prev), patch));
    };
    DataStore.prototype.removeEntity = function(type, id) {
        var byId = this.entities.get(type);
        var prev = byId === null || byId === void 0 ? void 0 : byId.get(id);
        if (!byId || !prev) return false;
        byId.delete(id);
        for(var _i = 0, _a = this.connections[type].indexes; _i < _a.length; _i++){
            var field = _a[_i];
            var val = $8db6d07d03d30085$var$numeric(prev[field]);
            if (val !== undefined) this.deindex(type, field, val, id);
        }
        this.bump(type);
        return true;
    };
    DataStore.prototype.index = function(type, field, value, id) {
        var byField = this.map(this.indexes, type);
        var byValue = byField.get(field);
        if (!byValue) {
            byValue = new Map();
            byField.set(field, byValue);
        }
        var set = byValue.get(value);
        if (!set) {
            set = new Set();
            byValue.set(value, set);
        }
        set.add(id);
    };
    DataStore.prototype.deindex = function(type, field, value, id) {
        var _a, _b;
        var set = (_b = (_a = this.indexes.get(type)) === null || _a === void 0 ? void 0 : _a.get(field)) === null || _b === void 0 ? void 0 : _b.get(value);
        if (set) set.delete(id);
    };
    DataStore.prototype.bump = function(type) {
        var _a;
        this.typeVersions.set(type, ((_a = this.typeVersions.get(type)) !== null && _a !== void 0 ? _a : 0) + 1);
    };
    // ---- subscription lifecycle -------------------------------------------
    // Ref-count a consumer of `type`. The first retain subscribes the single
    // live handler per token; the matching last release tears it down.
    DataStore.prototype.retain = function(type) {
        var _this = this;
        var _a;
        var next = ((_a = this.retainCounts.get(type)) !== null && _a !== void 0 ? _a : 0) + 1;
        this.retainCounts.set(type, next);
        this.emitTrace({
            event: "retain.acquire",
            type: type,
            count: next
        });
        if (next > 1) return;
        var socket = this.socket;
        if (!socket) return; // offline store: nothing to subscribe.
        var ids = this.connections[type].live.map(function(token) {
            return socket.subscribe(token.type, function(data, _wireType, eventInfo) {
                return _this.applyLiveRaw(type, data, eventInfo);
            });
        });
        this.subscriptionIds.set(type, ids);
        this.emitSubscription("start", type, this.connections[type].live.map(function(token) {
            return token.type;
        }));
    };
    DataStore.prototype.release = function(type) {
        var _a, _b;
        var current = (_a = this.retainCounts.get(type)) !== null && _a !== void 0 ? _a : 0;
        if (current <= 0) return;
        if (current > 1) {
            this.retainCounts.set(type, current - 1);
            this.emitTrace({
                event: "retain.release",
                type: type,
                count: current - 1
            });
            return;
        }
        this.retainCounts.delete(type);
        this.emitTrace({
            event: "retain.release",
            type: type,
            count: 0
        });
        var socket = this.socket;
        var ids = (_b = this.subscriptionIds.get(type)) !== null && _b !== void 0 ? _b : [];
        var tokens = this.connections[type].live;
        if (socket) ids.forEach(function(id, i) {
            return socket.unsubscribe(tokens[i].type, id);
        });
        if (ids.length > 0) this.emitSubscription("stop", type, tokens.map(function(token) {
            return token.type;
        }));
        this.subscriptionIds.delete(type);
    };
    // ---- fetch dedup -------------------------------------------------------
    // Fetch a query's entities via the connection's typed fetcher, deduplicated
    // by key so concurrent/repeat callers share one in-flight request; the
    // resolved batch is normalized into the store.
    DataStore.prototype.fetchQuery = function(type, ids) {
        return this.fetchQueryIds(type, ids, false);
    };
    // Awaited variant for lifecycle owners whose retry policy depends on the
    // transport failure. It shares the same request and normalization as
    // `fetchQuery`, but preserves rejection instead of absorbing it.
    DataStore.prototype.fetchQueryStrict = function(type, ids) {
        return this.fetchQueryIds(type, ids, true);
    };
    DataStore.prototype.isQueryFetched = function(type, ids) {
        var provider = type;
        while(this.connections[provider].providedBy)provider = this.connections[provider].providedBy;
        return this.successfulFetches.has(this.queryKey(provider, ids));
    };
    // The untyped impl: `providedBy` delegation crosses entity types, so the
    // recursion works in plain `BoundIds` behind the typed entry point above.
    DataStore.prototype.fetchQueryIds = function(type, ids, strict) {
        var _this = this;
        var conn = this.connections[type];
        // This entity rides another's bundle (e.g. a flag riding its widget's
        // bundle): delegate so sibling deps collapse to one request.
        if (conn.providedBy) return this.fetchQueryIds(conn.providedBy, ids, strict);
        var fetch = conn.fetch;
        var apiClient = this.apiClient;
        if (!fetch || !apiClient) return Promise.resolve();
        var key = this.queryKey(type, ids);
        var existing = this.inflight.get(key);
        if (existing) return strict ? existing.strict : existing.tolerant;
        var live = [];
        this.emitTrace({
            event: "fetch.start",
            type: type,
            filter: ids,
            operation: "fetch"
        });
        // `type` is a wide, dynamically-resolved entity here (post `providedBy`
        // delegation), so `Schema["fkFields"]`/`FetchIds` can't be narrowed to a
        // concrete key inside this generic class body the way they can at a
        // caller's typed `fetchQuery<K>` entry point above — the boundary is
        // inherently dynamic, exactly like `useDeps`'s own id binding.
        var strictPromise = fetch(apiClient, ids).then(function(result) {
            var summary = _this.applyBundle(result, key, live);
            _this.successfulFetches.add(key);
            var count = $8db6d07d03d30085$var$diagnosticEntityCount(result.entities);
            _this.emitSupport({
                event: "fetch.success",
                type: type,
                filter: ids,
                count: count,
                results: $8db6d07d03d30085$var$diagnosticEntityGroups(result.entities),
                added: $8db6d07d03d30085$var$diagnosticCountGroups(summary.added),
                updated: $8db6d07d03d30085$var$diagnosticCountGroups(summary.updated),
                removed: $8db6d07d03d30085$var$diagnosticCountGroups(summary.removed),
                removedCount: summary.removedCount
            });
            _this.emitTraceLazy(function() {
                return {
                    event: "fetch.success",
                    type: type,
                    filter: ids,
                    count: count,
                    results: $8db6d07d03d30085$var$diagnosticEntityGroups(result.entities),
                    changed: $8db6d07d03d30085$var$diagnosticGroups(summary.changed),
                    added: $8db6d07d03d30085$var$diagnosticGroups(summary.added),
                    updated: $8db6d07d03d30085$var$diagnosticGroups(summary.updated),
                    removed: $8db6d07d03d30085$var$diagnosticGroups(summary.removed)
                };
            });
        }).catch(function(error) {
            var compactError = $8db6d07d03d30085$var$diagnosticError(error);
            _this.emitSupport({
                event: "fetch.failure",
                type: type,
                filter: ids,
                error: compactError
            });
            _this.emitTrace({
                event: "fetch.failure",
                type: type,
                filter: ids,
                error: compactError
            });
            throw error;
        });
        var tolerantPromise = strictPromise// Absorbed, never rethrown: `useDeps` calls this fire-and-forget from an
        // effect and cannot await it, so a rejection would surface only as an
        // unhandled promise rejection. Leave the store as it was; the next
        // fetch (retry, re-render or live broadcast) recovers it, and `finally`
        // below frees the key so there IS a next fetch rather than a
        // permanently cached failure.
        .catch(function(error) {
            _this.debugLog("store fetch failed", type, $8db6d07d03d30085$var$diagnosticError(error));
        });
        var entry = {
            type: type,
            filter: $8db6d07d03d30085$var$__assign({}, ids),
            strict: strictPromise,
            tolerant: tolerantPromise,
            live: live
        };
        this.inflight.set(key, entry);
        var clear = function() {
            if (_this.inflight.get(key) === entry) _this.inflight.delete(key);
        };
        strictPromise.then(clear, clear);
        return strict ? strictPromise : tolerantPromise;
    };
    // The non-entity extras stashed by a provider's fetch for this query, or a
    // stable empty bag. Referentially stable until a re-fetch replaces it.
    DataStore.prototype.getExtras = function(type, ids) {
        var _a;
        var provider = type;
        while(this.connections[provider].providedBy)provider = this.connections[provider].providedBy;
        return (_a = this.extras.get(this.queryKey(provider, ids))) !== null && _a !== void 0 ? _a : $8db6d07d03d30085$var$EMPTY_EXTRAS;
    };
    // ---- external-store contract ------------------------------------------
    DataStore.prototype.subscribe = function(listener) {
        var _this = this;
        this.listeners.add(listener);
        return function() {
            _this.listeners.delete(listener);
        };
    };
    DataStore.prototype.subscribeLive = function(type, listener) {
        var _this = this;
        var listeners = this.liveListeners.get(type);
        if (!listeners) {
            listeners = new Set();
            this.liveListeners.set(type, listeners);
        }
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
            if (listeners.size === 0) _this.liveListeners.delete(type);
        };
    };
    DataStore.prototype.notify = function() {
        for(var _i = 0, _a = Array.from(this.listeners); _i < _a.length; _i++){
            var listener = _a[_i];
            listener();
        }
    };
    // ---- helpers -----------------------------------------------------------
    DataStore.prototype.requireDiagnosticType = function(type) {
        if (!Object.prototype.hasOwnProperty.call(this.connections, type)) throw new Error("Unknown DataStore entity type \"".concat(type, "\""));
        return type;
    };
    DataStore.prototype.emitSupport = function(event) {
        this.supportLog($8db6d07d03d30085$var$immutableSnapshot(event));
    };
    DataStore.prototype.emitTrace = function(event, force) {
        if (force === void 0) force = false;
        if (this.diagnosticTraceEnabled || force) this.traceLog($8db6d07d03d30085$var$immutableSnapshot(event));
    };
    DataStore.prototype.emitTraceLazy = function(event) {
        if (this.diagnosticTraceEnabled) this.traceLog($8db6d07d03d30085$var$immutableSnapshot(event()));
    };
    DataStore.prototype.emitSubscription = function(operation, type, channels) {
        var event = {
            event: "subscription.".concat(operation),
            type: type,
            channels: channels
        };
        this.emitSupport(event);
        this.emitTrace(event);
    };
    DataStore.prototype.emitLiveResult = function(type, id, operation, deleted, kind) {
        var event = deleted ? "live.delete" : "live.upsert";
        var results = [
            $8db6d07d03d30085$var$diagnosticCountGroup(type, 1)
        ];
        var added = kind === "added" ? results : [];
        var updated = kind === "updated" ? results : [];
        var removed = kind === "removed" ? results : [];
        this.emitSupport({
            event: event,
            operation: operation,
            count: 1,
            results: results,
            added: added,
            updated: updated,
            removed: removed
        });
        this.emitTrace({
            event: event,
            type: type,
            id: id,
            operation: operation,
            count: 1,
            results: results,
            added: added,
            updated: updated,
            removed: removed
        });
    };
    DataStore.prototype.map = function(store, type) {
        var inner = store.get(type);
        if (!inner) {
            inner = new Map();
            store.set(type, inner);
        }
        return inner;
    };
    DataStore.prototype.queryKey = function(type, filter) {
        var parts = Object.entries(filter).filter(function(_a) {
            var v = _a[1];
            return v !== undefined;
        }).sort(function(_a, _b) {
            var a = _a[0];
            var b = _b[0];
            return a < b ? -1 : a > b ? 1 : 0;
        }).map(function(_a) {
            var k = _a[0], v = _a[1];
            return "".concat(k, "=").concat(v);
        });
        return "".concat(type, "|").concat(parts.join("&"));
    };
    return DataStore;
}();
var $8db6d07d03d30085$var$EMPTY = Object.freeze([]);
var $8db6d07d03d30085$var$EMPTY_EXTRAS = Object.freeze({});
function $8db6d07d03d30085$var$compareDiagnosticType(a, b) {
    return a.type.localeCompare(b.type);
}
var $8db6d07d03d30085$var$DIAGNOSTIC_ID_SAMPLE_LIMIT = 20;
function $8db6d07d03d30085$var$addDiagnosticId(groups, type, id, includeIds) {
    var group = groups.get(type);
    if (!group) {
        group = {
            ids: includeIds ? new Set() : undefined,
            count: 0
        };
        groups.set(type, group);
    }
    group.count += 1;
    if (group.ids && !group.ids.has(id) && group.ids.size < $8db6d07d03d30085$var$DIAGNOSTIC_ID_SAMPLE_LIMIT) group.ids.add(id);
}
function $8db6d07d03d30085$var$diagnosticGroups(groups) {
    if (!groups) return [];
    return Array.from(groups.entries()).map(function(_a) {
        var _b, _c, _d;
        var type = _a[0], group = _a[1];
        return {
            type: type,
            ids: Array.from((_b = group.ids) !== null && _b !== void 0 ? _b : []).sort(function(a, b) {
                return a - b;
            }),
            count: group.count,
            omittedCount: group.count - ((_d = (_c = group.ids) === null || _c === void 0 ? void 0 : _c.size) !== null && _d !== void 0 ? _d : 0)
        };
    }).sort($8db6d07d03d30085$var$compareDiagnosticType);
}
function $8db6d07d03d30085$var$diagnosticChangeSummary(traceEnabled) {
    return {
        changedCount: 0,
        addedCount: 0,
        updatedCount: 0,
        removedCount: 0,
        changed: traceEnabled ? new Map() : undefined,
        added: new Map(),
        updated: new Map(),
        removed: new Map()
    };
}
function $8db6d07d03d30085$var$addDiagnosticChange(summary, kind, type, id) {
    summary["".concat(kind, "Count")] += 1;
    if (kind !== "removed") {
        summary.changedCount += 1;
        if (summary.changed) $8db6d07d03d30085$var$addDiagnosticId(summary.changed, type, id, true);
    }
    $8db6d07d03d30085$var$addDiagnosticId(summary[kind], type, id, summary.changed !== undefined);
}
function $8db6d07d03d30085$var$diagnosticCountGroup(type, count) {
    return {
        type: type,
        count: count
    };
}
function $8db6d07d03d30085$var$diagnosticCountGroups(groups) {
    return Array.from(groups.entries()).map(function(_a) {
        var type = _a[0], group = _a[1];
        return $8db6d07d03d30085$var$diagnosticCountGroup(type, group.count);
    }).sort($8db6d07d03d30085$var$compareDiagnosticType);
}
function $8db6d07d03d30085$var$diagnosticEntityGroups(entities) {
    return (0, $bcf0a4ee4a28a2dd$export$df392344a67abe9b)(entities).filter(function(_a) {
        var rows = _a[1];
        return rows.length > 0;
    }).map(function(_a) {
        var type = _a[0], rows = _a[1];
        return $8db6d07d03d30085$var$diagnosticCountGroup(type, rows.length);
    }).sort($8db6d07d03d30085$var$compareDiagnosticType);
}
function $8db6d07d03d30085$var$diagnosticMutationChanges(changes) {
    return $8db6d07d03d30085$var$immutableSnapshot({
        upsert: (0, $bcf0a4ee4a28a2dd$export$df392344a67abe9b)(changes === null || changes === void 0 ? void 0 : changes.upsert).map(function(_a) {
            var type = _a[0], rows = _a[1];
            return $8db6d07d03d30085$var$diagnosticIdGroup(type, rows.map(function(row) {
                return row.id;
            }));
        }).sort($8db6d07d03d30085$var$compareDiagnosticType),
        remove: (0, $bcf0a4ee4a28a2dd$export$7da07ced8fa2b227)(changes === null || changes === void 0 ? void 0 : changes.remove).map(function(_a) {
            var type = _a[0], ids = _a[1];
            return $8db6d07d03d30085$var$diagnosticIdGroup(type, ids);
        }).sort($8db6d07d03d30085$var$compareDiagnosticType)
    });
}
function $8db6d07d03d30085$var$diagnosticIdGroup(type, ids) {
    var unique = Array.from(new Set(ids)).sort(function(a, b) {
        return a - b;
    });
    var sample = unique.slice(0, $8db6d07d03d30085$var$DIAGNOSTIC_ID_SAMPLE_LIMIT);
    return {
        type: type,
        ids: sample,
        count: ids.length,
        omittedCount: ids.length - sample.length
    };
}
function $8db6d07d03d30085$var$diagnosticMutationOperation(changes) {
    var upsert = (0, $bcf0a4ee4a28a2dd$export$df392344a67abe9b)(changes === null || changes === void 0 ? void 0 : changes.upsert).some(function(_a) {
        var rows = _a[1];
        return rows.length > 0;
    });
    var remove = (0, $bcf0a4ee4a28a2dd$export$7da07ced8fa2b227)(changes === null || changes === void 0 ? void 0 : changes.remove).some(function(_a) {
        var ids = _a[1];
        return ids.length > 0;
    });
    if (upsert && remove) return "upsert+remove";
    if (upsert) return "upsert";
    if (remove) return "remove";
    return "none";
}
function $8db6d07d03d30085$var$diagnosticEntityCount(entities) {
    return (0, $bcf0a4ee4a28a2dd$export$df392344a67abe9b)(entities).reduce(function(count, _a) {
        var rows = _a[1];
        return count + rows.length;
    }, 0);
}
function $8db6d07d03d30085$var$diagnosticError(error) {
    if (!error || typeof error !== "object") return {};
    var value = error;
    var compact = {};
    if (typeof value.name === "string") compact.name = value.name;
    var status = typeof value.httpStatus === "number" ? value.httpStatus : typeof value.status === "number" ? value.status : undefined;
    if (status !== undefined) compact.httpStatus = status;
    return $8db6d07d03d30085$var$immutableSnapshot(compact);
}
function $8db6d07d03d30085$var$immutableSnapshot(value) {
    if (Array.isArray(value)) return Object.freeze(value.map(function(entry) {
        return $8db6d07d03d30085$var$immutableSnapshot(entry);
    }));
    if (value && typeof value === "object") {
        var copy = {};
        for(var _i = 0, _a = Object.entries(value); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], entry = _b[1];
            copy[key] = $8db6d07d03d30085$var$immutableSnapshot(entry);
        }
        return Object.freeze(copy);
    }
    return value;
}
function $8db6d07d03d30085$var$numeric(value) {
    return typeof value === "number" ? value : undefined;
}
function $8db6d07d03d30085$var$shallowEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
// Compare each slice's ordered row references, not its array identity.
function $8db6d07d03d30085$var$sameSlices(a, b) {
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; i++){
        if (!$8db6d07d03d30085$var$shallowEqual(a[i], b[i])) return false;
    }
    return true;
}
function $8db6d07d03d30085$var$matchesWhere(row, where) {
    for(var _i = 0, _a = Object.entries(where); _i < _a.length; _i++){
        var _b = _a[_i], field = _b[0], value = _b[1];
        if (row[field] !== value) return false;
    }
    return true;
}







const $e188c40f4bf71e3c$var$logger = (0, $ea493e883ca706d4$export$fe2e61603b61130d)("Store");
const $e188c40f4bf71e3c$var$diagnosticsLogger = (0, $ea493e883ca706d4$export$fe2e61603b61130d)("DataLayer");
function $e188c40f4bf71e3c$var$dataLayerSocket(socket, getShipUser, publishLive) {
    return {
        subscribe (type, callback) {
            return socket.subscribe(type, (data, wireType, info)=>{
                if (type === "ShipUser" && $e188c40f4bf71e3c$var$isCrossShipShipUserCollision(data, getShipUser)) return;
                callback(data, wireType, info);
                publishLive(type.startsWith("StoredCalculation/") ? "StoredCalculation" : type, data, $e188c40f4bf71e3c$var$asLiveInfo(info));
            });
        },
        unsubscribe (type, id) {
            socket.unsubscribe(type, id);
        }
    };
}
function $e188c40f4bf71e3c$var$isCrossShipShipUserCollision(incoming, getShipUser) {
    if (typeof incoming.id !== "number" || typeof incoming.shipId !== "number") return false;
    const existing = getShipUser(incoming.id);
    return existing !== undefined && existing.shipId !== incoming.shipId;
}
// The single narrowing point for the wire's untyped `info`. An unrecognized operation is
// passed through as-is: only `"delete"` changes behavior, and every other value already
// means "upsert" — so a new server-side operation stays forward-compatible.
function $e188c40f4bf71e3c$var$asLiveInfo(info) {
    return info;
}
const $e188c40f4bf71e3c$var$EMPTY_PROVISIONAL = Object.freeze([]);
function $e188c40f4bf71e3c$var$compareDiagnosticType(a, b) {
    return a.type.localeCompare(b.type);
}
// Recursively freezes a plain value tree — the Logbook-side counterpart of the
// generic engine's own (unexported) snapshot freezing, needed here only for
// the diagnostics this file merges in on top of the inherited generic status
// (see `getDiagnosticStatus`) and the uncommitted-log event envelopes below.
function $e188c40f4bf71e3c$var$deepFreeze(value) {
    if (Array.isArray(value)) return Object.freeze(value.map((entry)=>$e188c40f4bf71e3c$var$deepFreeze(entry)));
    if (value && typeof value === "object") {
        const copy = {};
        for (const [key, entry] of Object.entries(value))copy[key] = $e188c40f4bf71e3c$var$deepFreeze(entry);
        return Object.freeze(copy);
    }
    return value;
}
class $e188c40f4bf71e3c$export$47a0e4800a1fd7dc extends (0, $8db6d07d03d30085$export$47a0e4800a1fd7dc) {
    constructor(deps = {}){
        var _a, _b, _c;
        const supportLog = (_a = deps.supportLog) !== null && _a !== void 0 ? _a : (event)=>$e188c40f4bf71e3c$var$diagnosticsLogger.native(event);
        // Trace volume is already explicitly gated by `logbook.dataLayer.trace(true)`.
        // Use the normally visible console stream so enabling it does not also require
        // turning on the browser inspector's hidden "Verbose"/debug level.
        const traceLog = (_b = deps.traceLog) !== null && _b !== void 0 ? _b : (event)=>$e188c40f4bf71e3c$var$diagnosticsLogger.info(event);
        // Late-bound: the wrapped socket below needs to read this store's own state
        // (`getEntity`) to detect a cross-ship `ShipUser` collision, but `this` isn't
        // available until after `super()` runs. `guardShipUserCollisions` only invokes
        // this once a live `ShipUser` broadcast actually arrives -- never during
        // construction itself -- so filling it in immediately after `super()` is safe.
        let getShipUser = ()=>undefined;
        let publishLive = ()=>{};
        const genericDeps = {
            connections: (0, $dce9b2b6397c0cdf$export$7e1fad0eb118a24f)((_c = deps.connections) !== null && _c !== void 0 ? _c : (0, $dced7aa321629549$export$ab9f7df4498d2fd5)),
            edges: (0, $dce9b2b6397c0cdf$export$eda54e0dfd836989).edges,
            socket: deps.socket && $e188c40f4bf71e3c$var$dataLayerSocket(deps.socket, (id)=>getShipUser(id), (type, entity, info)=>publishLive(type, entity, info)),
            apiClient: deps.apiClient,
            seed: deps.seed,
            supportLog: supportLog,
            traceLog: traceLog,
            debugLog: (message, ...values)=>$e188c40f4bf71e3c$var$logger.debug(message, ...values)
        };
        super(genericDeps);
        // The generic engine's own listener set (`subscribe`/`notify`) is private and
        // therefore inaccessible from this subclass; the two uncommitted-log slices
        // below are store state the generic engine has no notion of, so they keep
        // their own listener set and are folded into the same public `subscribe`
        // (override below) — preserving the pre-extraction contract that one
        // subscription observes entity AND uncommitted-log changes alike.
        this.uncommittedListeners = new Set();
        this.dataLiveListeners = new Map();
        this.uncommittedTraceEnabled = false;
        this.provisionalLogsByKey = new Map();
        // Memoized `getProvisionalLogs` snapshot; rebuilt lazily only after a change so an
        // unchanged read keeps the same reference (useSyncExternalStore bails out).
        this.provisionalSnapshot = $e188c40f4bf71e3c$var$EMPTY_PROVISIONAL;
        this.provisionalDirty = false;
        this.currentLogRetain = 0;
        this.provisionalRetain = 0;
        getShipUser = (id)=>this.getEntity("ShipUser", id);
        publishLive = (type, entity, info)=>this.publishLive(type, entity, info);
        this.uncommittedSocket = deps.socket;
        this.logbookApiClient = deps.apiClient;
        this.diagnosticsSupportLog = supportLog;
        this.diagnosticsTraceLog = traceLog;
        if (deps.currentLog) this.applyCurrentLog(deps.currentLog, "update");
        if (deps.provisionalLogs) for (const row of deps.provisionalLogs)this.applyProvisionalLog(row, "update");
    }
    // ---- shared listener set (entity + uncommitted-log changes) -----------
    subscribe(listener) {
        const unsubscribe = super.subscribe(listener);
        this.uncommittedListeners.add(listener);
        return ()=>{
            unsubscribe();
            this.uncommittedListeners.delete(listener);
        };
    }
    notifyUncommitted() {
        for (const listener of this.uncommittedListeners)listener();
    }
    api() {
        if (!this.logbookApiClient) throw new Error("DataStore.api: no apiClient (offline store)");
        return this.logbookApiClient;
    }
    subscribeLiveEvent(type, listener) {
        let listeners = this.dataLiveListeners.get(type);
        if (!listeners) {
            listeners = new Set();
            this.dataLiveListeners.set(type, listeners);
        }
        listeners.add(listener);
        return ()=>{
            listeners === null || listeners === void 0 || listeners.delete(listener);
            if ((listeners === null || listeners === void 0 ? void 0 : listeners.size) === 0) this.dataLiveListeners.delete(type);
        };
    }
    publishLive(type, entity, info) {
        var _a;
        for (const listener of (_a = this.dataLiveListeners.get(type)) !== null && _a !== void 0 ? _a : [])listener(entity, info);
    }
    // ---- typed live ingress / mutation --------------------------------------
    // Narrows `info` back to the closed `LiveInfo` union the generic engine's
    // own `applyLive<K>(type, entity, info: string)` deliberately widens (every
    // other consuming app has its own live vocabulary). Every existing caller
    // already passes a `LiveInfo`-shaped literal, so this is a pure strictness
    // restoration, not a behavior change.
    //
    // Also closes the same `ShipUser` identity-boundary gap the socket wrapper
    // below (`guardShipUserCollisions`) closes for real live broadcasts -- but
    // for a *different* set of callers: this store's own `retain()` subscribes
    // straight to `socket.subscribe(...)` and hands broadcasts to the generic
    // engine's private `applyLiveRaw` directly, never through this overridable
    // `applyLive`, so a guard here alone would never see a real broadcast. It's
    // kept because `store.applyLive(...)` is this codebase's own established
    // pattern for *simulating* a live update from a test (see `Store.test.ts`
    // and friends), so guarding it too keeps that pattern trustworthy.
    applyLive(type, entity, info) {
        if (type === "ShipUser" && this.isCrossShipShipUserCollision(entity)) return;
        super.applyLive(type, entity, info);
    }
    isCrossShipShipUserCollision(incoming) {
        if (typeof incoming.id !== "number" || typeof incoming.shipId !== "number") return false;
        const existing = this.getEntity("ShipUser", incoming.id);
        return existing !== undefined && existing.shipId !== incoming.shipId;
    }
    // Perform one write through the layer: optimistically apply
    // `spec.optimistic`, run the typed REST `spec.request`, then on success
    // reconcile the authoritative response into the store, or on failure roll
    // the optimistic write back and rethrow — all inherited from the generic
    // engine unchanged. This override exists only to keep `MutationSpec.request`
    // typed against Logbook's concrete `ApiClient` (see this file's `MutationSpec`
    // doc comment); a real `ApiClient` value always satisfies the generic
    // engine's own `DataApiClient` structurally, so widening the spec here is
    // exactly the same safe relationship `Connections/Connection.ts#entity()`
    // asserts for a connection's `fetch`.
    async mutate(spec) {
        return super.mutate(spec);
    }
    // ---- diagnostics ---------------------------------------------------------
    reportDiagnosticsAttached() {
        this.diagnosticsSupportLog($e188c40f4bf71e3c$var$deepFreeze({
            event: "store.attached"
        }));
    }
    // Tracks tracing locally too: the generic engine's own trace-enabled flag is
    // private, so the uncommitted-log slice's own trace emission (below) cannot
    // read it directly. `noImplicitOverride`-safe: same signature as the base.
    setDiagnosticTrace(enabled) {
        this.uncommittedTraceEnabled = enabled;
        return super.setDiagnosticTrace(enabled);
    }
    // The generic engine's own status (entity counts, retain/subscription state
    // for schema-entity connections, in-flight fetches) plus this file's own
    // extensions: the Logbook `feature` flag envelope (diagnostics global naming
    // is Logbook policy — see `Diagnostics.ts`) and the two uncommitted-log
    // slices' retain/subscription state, which the generic engine has no notion
    // of at all. Covariant override: same zero-arg signature as the base, a
    // strict superset return type.
    getDiagnosticStatus() {
        const base = super.getDiagnosticStatus();
        const retained = [
            ...base.retained
        ];
        const subscriptions = [
            ...base.subscriptions
        ];
        if (this.currentLogRetain > 0) retained.push({
            type: (0, $1bedde6805bf6e79$export$f55210826850c514).currentLog.type,
            count: this.currentLogRetain
        });
        if (this.provisionalRetain > 0) retained.push({
            type: (0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type,
            count: this.provisionalRetain
        });
        if (this.currentLogRetain > 0 || this.currentLogSubId !== undefined) subscriptions.push({
            type: (0, $1bedde6805bf6e79$export$f55210826850c514).currentLog.type,
            active: this.currentLogSubId !== undefined,
            channels: [
                (0, $1bedde6805bf6e79$export$f55210826850c514).currentLog.type
            ]
        });
        if (this.provisionalRetain > 0 || this.provisionalSubId !== undefined) subscriptions.push({
            type: (0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type,
            active: this.provisionalSubId !== undefined,
            channels: [
                (0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type
            ]
        });
        retained.sort($e188c40f4bf71e3c$var$compareDiagnosticType);
        subscriptions.sort($e188c40f4bf71e3c$var$compareDiagnosticType);
        return $e188c40f4bf71e3c$var$deepFreeze({
            traceEnabled: base.traceEnabled,
            entityCounts: base.entityCounts,
            retained: retained,
            subscriptions: subscriptions,
            inFlightFetches: base.inFlightFetches
        });
    }
    emitUncommittedSupport(event) {
        this.diagnosticsSupportLog($e188c40f4bf71e3c$var$deepFreeze(event));
    }
    emitUncommittedTrace(event) {
        if (this.uncommittedTraceEnabled) this.diagnosticsTraceLog($e188c40f4bf71e3c$var$deepFreeze(event));
    }
    emitUncommittedSubscription(operation, type, channels) {
        const event = {
            event: `subscription.${operation}`,
            type: type,
            channels: channels
        };
        this.emitUncommittedSupport(event);
        this.emitUncommittedTrace(event);
    }
    emitUncommittedLiveResult(type, id, operation, deleted, kind) {
        const event = deleted ? "live.delete" : "live.upsert";
        const results = [
            {
                type: type,
                count: 1
            }
        ];
        const added = kind === "added" ? results : [];
        const updated = kind === "updated" ? results : [];
        const removed = kind === "removed" ? results : [];
        this.emitUncommittedSupport({
            event: event,
            operation: operation,
            count: 1,
            results: results,
            added: added,
            updated: updated,
            removed: removed
        });
        this.emitUncommittedTrace({
            event: event,
            type: type,
            id: id,
            operation: operation,
            count: 1,
            results: results,
            added: added,
            updated: updated,
            removed: removed
        });
    }
    // ---- uncommitted (id-0) log slices ------------------------------------
    // The singleton "now" entry (fed by `Log/Current`), or `undefined`. A stable object
    // reference until it is replaced/cleared.
    getCurrentLog() {
        return this.currentLog;
    }
    // The in-progress provisional auto-logs (fed by `Log/Provisional`), sorted by
    // `timeUtc`. Referentially stable until the set actually changes.
    getProvisionalLogs() {
        if (this.provisionalDirty) {
            this.provisionalSnapshot = this.provisionalLogsByKey.size === 0 ? $e188c40f4bf71e3c$var$EMPTY_PROVISIONAL : Array.from(this.provisionalLogsByKey.values()).sort((a, b)=>a.timeUtc - b.timeUtc);
            this.provisionalDirty = false;
        }
        return this.provisionalSnapshot;
    }
    // Ingest a `Log/Current` broadcast (or seed): replace the singleton, or clear it on a
    // delete. Branded `current` so a shared renderer can tell it apart from a committed log.
    applyCurrentLog(log, info) {
        this.currentLog = info === "delete" ? undefined : (0, $64ef1e949dc20123$export$6ffbf5ab2b061183)(log);
        this.notifyUncommitted();
    }
    // Ingest a `Log/Provisional` broadcast (or seed): upsert by `metadata.provisionalKey`,
    // or remove on a delete. A keyless log is ignored (mirrors `AppData.updateProvisional`).
    applyProvisionalLog(log, info) {
        const key = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed.provisionalKey;
        if (!key) return;
        if (info === "delete") {
            if (!this.provisionalLogsByKey.delete(key)) return;
        } else this.provisionalLogsByKey.set(key, (0, $64ef1e949dc20123$export$77dcd5c071d480a1)(log));
        this.provisionalDirty = true;
        this.notifyUncommitted();
    }
    // Replace the complete provisional set from an authoritative snapshot. Unlike the
    // per-broadcast `applyProvisionalLog`, absence is meaningful here: a key missing from
    // the snapshot was retracted while this client could not observe the live channel.
    replaceProvisionalLogs(logs) {
        if (logs.length === 0 && this.provisionalLogsByKey.size === 0) return;
        this.provisionalLogsByKey.clear();
        for (const log of logs){
            const key = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed.provisionalKey;
            if (key) this.provisionalLogsByKey.set(key, (0, $64ef1e949dc20123$export$77dcd5c071d480a1)(log));
        }
        this.provisionalDirty = true;
        this.notifyUncommitted();
    }
    // Ref-count the `Log/Current` slice: the first retain subscribes its single live
    // handler, the matching last release tears it down.
    retainCurrentLog() {
        this.currentLogRetain += 1;
        this.emitUncommittedTrace({
            event: "retain.acquire",
            type: (0, $1bedde6805bf6e79$export$f55210826850c514).currentLog.type,
            count: this.currentLogRetain
        });
        if (this.currentLogRetain > 1 || !this.uncommittedSocket) return;
        this.currentLogSubId = this.uncommittedSocket.subscribe((0, $1bedde6805bf6e79$export$f55210826850c514).currentLog.type, (data, _wireType, info)=>this.applyCurrentLogLive(data, $e188c40f4bf71e3c$var$asLiveInfo(info)));
        this.emitUncommittedSubscription("start", (0, $1bedde6805bf6e79$export$f55210826850c514).currentLog.type, [
            (0, $1bedde6805bf6e79$export$f55210826850c514).currentLog.type
        ]);
    }
    releaseCurrentLog() {
        if (this.currentLogRetain <= 0) return;
        this.currentLogRetain -= 1;
        this.emitUncommittedTrace({
            event: "retain.release",
            type: (0, $1bedde6805bf6e79$export$f55210826850c514).currentLog.type,
            count: this.currentLogRetain
        });
        if (this.currentLogRetain > 0) return;
        if (this.uncommittedSocket && this.currentLogSubId !== undefined) {
            this.uncommittedSocket.unsubscribe((0, $1bedde6805bf6e79$export$f55210826850c514).currentLog.type, this.currentLogSubId);
            this.emitUncommittedSubscription("stop", (0, $1bedde6805bf6e79$export$f55210826850c514).currentLog.type, [
                (0, $1bedde6805bf6e79$export$f55210826850c514).currentLog.type
            ]);
        }
        this.currentLogSubId = undefined;
    }
    // Ref-count the `Log/Provisional` slice (see `retainCurrentLog`).
    retainProvisionalLogs() {
        this.provisionalRetain += 1;
        this.emitUncommittedTrace({
            event: "retain.acquire",
            type: (0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type,
            count: this.provisionalRetain
        });
        if (this.provisionalRetain > 1 || !this.uncommittedSocket) return;
        this.provisionalSubId = this.uncommittedSocket.subscribe((0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type, (data, _wireType, info)=>this.applyProvisionalLogLive(data, $e188c40f4bf71e3c$var$asLiveInfo(info)));
        this.emitUncommittedSubscription("start", (0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type, [
            (0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type
        ]);
    }
    releaseProvisionalLogs() {
        if (this.provisionalRetain <= 0) return;
        this.provisionalRetain -= 1;
        this.emitUncommittedTrace({
            event: "retain.release",
            type: (0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type,
            count: this.provisionalRetain
        });
        if (this.provisionalRetain > 0) return;
        if (this.uncommittedSocket && this.provisionalSubId !== undefined) {
            this.uncommittedSocket.unsubscribe((0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type, this.provisionalSubId);
            this.emitUncommittedSubscription("stop", (0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type, [
                (0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type
            ]);
        }
        this.provisionalSubId = undefined;
    }
    applyCurrentLogLive(log, info) {
        const existed = this.currentLog !== undefined;
        this.applyCurrentLog(log, info);
        const kind = info === "delete" ? existed ? "removed" : undefined : existed ? "updated" : "added";
        this.emitUncommittedLiveResult((0, $1bedde6805bf6e79$export$f55210826850c514).currentLog.type, log.id, info, info === "delete", kind);
    }
    applyProvisionalLogLive(log, info) {
        const key = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed.provisionalKey;
        if (!key) return;
        const existed = this.provisionalLogsByKey.has(key);
        this.applyProvisionalLog(log, info);
        const kind = info === "delete" ? existed ? "removed" : undefined : existed ? "updated" : "added";
        this.emitUncommittedLiveResult((0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type, log.id, info, info === "delete", kind);
    }
}


// Static dependency declaration: a view colocates what it reads as a `deps(root,
// { key: many(type) | one(type) })` descriptor, decoupled from any fetch endpoint,
// subscription key or merge. `useDeps` (see useDeps.ts) binds it to concrete owner
// ids at runtime. Edges are resolved against the generated schema graph, so the
// FK wiring stays in lockstep with the models.
//
// #1707 (tracker #1677) moved `many`/`one`/`Relationship`/`Deps`/`DepsResult` into
// app-base's generic `data/deps` (parameterized by a bare entity-name union, not
// Logbook's generated `SchemaEntity`); every export below is a thin instantiation
// of its app-base counterpart at `SchemaEntity`/`LogbookSchema`, so every existing
// caller keeps its exact prior name, signature and behavior. `edgeFk` alone keeps
// a Logbook-specific body: it resolves against `logbookEdges` (`Connections/
// Connection.ts`), which already folds the generated schema graph's `kind ===
// "owner"` into the generic engine's own `canonical` flag.
// A to-many relationship: resolves to a sorted array of the related entities.
function $9db39e34b2fb118a$export$14badfee79ea396f(type, opts) {
    if (opts === void 0) opts = {};
    return opts.with ? {
        type: type,
        cardinality: "many",
        with: opts.with
    } : {
        type: type,
        cardinality: "many"
    };
}
function $9db39e34b2fb118a$export$80bf7733f1207381(type, opts) {
    if (opts === void 0) opts = {};
    return opts.with ? {
        type: type,
        cardinality: "one",
        with: opts.with
    } : {
        type: type,
        cardinality: "one"
    };
}
function $9db39e34b2fb118a$export$a23f992de0d45ff0(root, relationships) {
    return {
        root: root,
        relationships: relationships
    };
}




function $a9e25f5507c22ba4$export$a23f992de0d45ff0(root, relationships) {
    return (0, $9db39e34b2fb118a$export$a23f992de0d45ff0)(root, relationships);
}
function $a9e25f5507c22ba4$export$6d0e606268da942c(from, to) {
    return (0, $29278580678edd79$export$6d0e606268da942c)(from, to, (0, $dce9b2b6397c0cdf$export$53ef2968ade38754));
}


// React bindings over the DataStore, built on `useSyncExternalStore` so re-render
// granularity comes from the store's referentially-stable snapshots: a component
// using `useQuery`/`useEntity` re-renders only when its own slice changes. No
// external state library — plain React 19.
//
// #1707 (tracker #1677) moved `useEntity`/`useQuery`/`useExtras`/`required` into
// app-base's generic `data/use-store` (parameterized by a `DataSchema`, built on
// the generic engine's own `DataStore<Schema>`); Logbook's `DataStore` (`./Store`)
// extends that engine, so every wrapper below is a one-line instantiation at
// `LogbookSchema` with no behavior of its own. `useCurrentLog`/`useProvisionalLogs`
// stay here unchanged: the two id-0 "uncommitted" log slices are a Logbook-only
// store extension the generic engine has no notion of (see `Store.ts`).

var $acw62 = parcelRequire("acw62");
// React bindings over the DataStore, built on `useSyncExternalStore` so
// re-render granularity comes from the store's referentially-stable
// snapshots: a component using `useQuery`/`useEntity` re-renders only when
// its own slice changes. No external state library — plain React.

var $acw62 = parcelRequire("acw62");
// A filter value that is not known yet. The store *ignores* an `undefined`
// filter field (it narrows on nothing and returns every row of the type),
// which is the opposite of what a caller scoping a query to a not-yet-loaded
// id wants. `required(id)` marks such a field so the query is blocked —
// returning nothing — until the id resolves.
var $55c0c0d4c269af54$var$MISSING = Symbol("required-missing");
function $55c0c0d4c269af54$export$a7a0278c004aac3f(id) {
    return id !== null && id !== void 0 ? id : $55c0c0d4c269af54$var$MISSING;
}
function $55c0c0d4c269af54$var$isBlocked(filter) {
    for(var _i = 0, _a = Object.values(filter); _i < _a.length; _i++){
        var value = _a[_i];
        if (value === $55c0c0d4c269af54$var$MISSING) return true;
    }
    return false;
}
// Safe once `isBlocked` has ruled out the sentinel: every remaining value is
// a plain id, which is exactly `EntityFilter<Schema, K>` — the shape the
// store's query surface takes.
function $55c0c0d4c269af54$var$asEntityFilter(filter) {
    return filter;
}
// One frozen instance, so a blocked query returns a referentially-stable
// snapshot and `useSyncExternalStore` bails out of re-rendering it.
var $55c0c0d4c269af54$var$EMPTY = Object.freeze([]);
function $55c0c0d4c269af54$export$fab329b658bf30c7(store, type, id) {
    var subscribe = (0, $acw62.useCallback)(function(onChange) {
        return store.subscribe(onChange);
    }, [
        store
    ]);
    return (0, $acw62.useSyncExternalStore)(subscribe, function() {
        return store.getEntity(type, id);
    });
}
function $55c0c0d4c269af54$export$dd0a697e1782aedd(store, type, filter) {
    var subscribe = (0, $acw62.useCallback)(function(onChange) {
        return store.subscribe(onChange);
    }, [
        store
    ]);
    var blocked = $55c0c0d4c269af54$var$isBlocked(filter);
    return (0, $acw62.useSyncExternalStore)(subscribe, function() {
        return blocked ? $55c0c0d4c269af54$var$EMPTY : store.getQuery(type, $55c0c0d4c269af54$var$asEntityFilter(filter));
    });
}
function $55c0c0d4c269af54$export$5d34c0530ef73ac5(store, type, ids) {
    var subscribe = (0, $acw62.useCallback)(function(onChange) {
        return store.subscribe(onChange);
    }, [
        store
    ]);
    return (0, $acw62.useSyncExternalStore)(subscribe, function() {
        return store.getExtras(type, ids);
    });
}


function $b82e6d2a15bbd8b8$export$fab329b658bf30c7(store, type, id) {
    return (0, $55c0c0d4c269af54$export$fab329b658bf30c7)(store, type, id);
}
function $b82e6d2a15bbd8b8$export$dd0a697e1782aedd(store, type, filter) {
    return (0, $55c0c0d4c269af54$export$dd0a697e1782aedd)(store, type, filter);
}
function $b82e6d2a15bbd8b8$export$5d34c0530ef73ac5(store, type, ids) {
    return (0, $55c0c0d4c269af54$export$5d34c0530ef73ac5)(store, type, ids);
}
function $b82e6d2a15bbd8b8$export$419a4240882ffaf9(store, type, listener) {
    (0, $acw62.useEffect)(()=>store.subscribeLiveEvent(type, listener), [
        store,
        type,
        listener
    ]);
}
function $b82e6d2a15bbd8b8$export$e3073a0c9a31c385(store) {
    (0, $acw62.useEffect)(()=>{
        store.retainCurrentLog();
        return ()=>store.releaseCurrentLog();
    }, [
        store
    ]);
    const subscribe = (0, $acw62.useCallback)((onChange)=>store.subscribe(onChange), [
        store
    ]);
    return (0, $acw62.useSyncExternalStore)(subscribe, ()=>store.getCurrentLog());
}
function $b82e6d2a15bbd8b8$export$5e08d2776b44093d(store) {
    (0, $acw62.useEffect)(()=>{
        store.retainProvisionalLogs();
        return ()=>store.releaseProvisionalLogs();
    }, [
        store
    ]);
    const subscribe = (0, $acw62.useCallback)((onChange)=>store.subscribe(onChange), [
        store
    ]);
    return (0, $acw62.useSyncExternalStore)(subscribe, ()=>store.getProvisionalLogs());
}


// Runtime id-binding hook: turns a static `deps(...)` declaration into live data.
// The caller binds only owner ids (e.g. `{ shipId, dayId }`) — no endpoint, sub
// key or merge. For each relationship the hook, for the lifetime of the mount:
//   1. retains its entity type (ref-counted, first retain subscribes the store's
//      single live handler for that type);
//   2. fetches its slice (deduped by key) so it is normalized into the store;
//   3. selects it back out via the store's stable snapshots, so the component
//      re-renders only when that slice changes.
// The relationship's query filter is derived from the schema edge linking the
// declaration's root to the related entity (e.g. Day→Log = `dayId`).
//
// #1707 (tracker #1677) moved this mechanism into app-base's generic
// `data/use-deps` (parameterized by a `DataSchema`, taking its store explicitly);
// this wrapper resolves the ambient store via `useDataStore()` (Logbook's own
// binding, `./Context`) so every existing `useDeps(declaration, ids)` call site
// (no store argument) is unaffected.


var $acw62 = parcelRequire("acw62");



const $22f46a313de5a83a$var$registrations = new WeakMap();
const $22f46a313de5a83a$var$traceStorageKey = "logbook-data-layer-trace";
function $22f46a313de5a83a$export$f8e3d94a9e9700ab(store) {
    store.reportDiagnosticsAttached();
    if ((0, $bf04d690697739ae$export$dda73877cb166cd3)($22f46a313de5a83a$var$traceStorageKey, {
        storage: localStorage
    }) == "1") store.setDiagnosticTrace(true);
    return Object.freeze({
        status: ()=>store.getDiagnosticStatus(),
        entities: (type)=>store.getDiagnosticEntities(type),
        query: (type, filter)=>store.getDiagnosticQuery(type, filter),
        extras: ()=>store.getDiagnosticExtras(),
        trace: (enabled)=>{
            if (enabled) localStorage.setItem($22f46a313de5a83a$var$traceStorageKey, "1");
            else localStorage.removeItem($22f46a313de5a83a$var$traceStorageKey);
            return store.setDiagnosticTrace(enabled);
        }
    });
}
function $22f46a313de5a83a$export$3a1bf10cfe0b8bf7(inspector, target = globalThis) {
    var _a;
    const logbook = (_a = target.logbook) !== null && _a !== void 0 ? _a : {};
    target.logbook = logbook;
    let state = $22f46a313de5a83a$var$registrations.get(target);
    if (!state) {
        state = {
            base: logbook.dataLayer,
            inspectors: []
        };
        $22f46a313de5a83a$var$registrations.set(target, state);
    }
    state.inspectors.push(inspector);
    logbook.dataLayer = inspector;
    return ()=>{
        var _a;
        const index = state.inspectors.lastIndexOf(inspector);
        if (index === -1) return;
        state.inspectors.splice(index, 1);
        const active = (_a = state.inspectors.at(-1)) !== null && _a !== void 0 ? _a : state.base;
        if (active) logbook.dataLayer = active;
        else delete logbook.dataLayer;
        if (state.inspectors.length === 0) $22f46a313de5a83a$var$registrations.delete(target);
    };
}




const $db922aea4424a404$var$dataStoreContext = (0, $5cdac83ab505705b$export$1a6a959df6aea4fa)();
const $db922aea4424a404$export$129055f0840a203c = $db922aea4424a404$var$dataStoreContext.Context;
const $db922aea4424a404$export$26531d8e255edf16 = $db922aea4424a404$var$dataStoreContext.useGet;
function $db922aea4424a404$export$eca4bdafe2d91d15({ store: store, seed: seed, socket: socket, apiClient: apiClient, children: children }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const resolvedSocket = socket !== null && socket !== void 0 ? socket : app === null || app === void 0 ? void 0 : app.socket;
    const resolvedApiClient = apiClient !== null && apiClient !== void 0 ? apiClient : app === null || app === void 0 ? void 0 : app.apiClient;
    // Built once per provider mount (app-scoped). `app.socket`/`app.apiClient` are
    // only read when building the real store (store prop absent), so an injected
    // store needs no AppContext. Deliberately not rebuilt on app re-renders: the
    // store owns its own live/cache state across renders.
    const value = (0, $acw62.useMemo)(()=>store !== null && store !== void 0 ? store : new (0, $e188c40f4bf71e3c$export$47a0e4800a1fd7dc)({
            socket: resolvedSocket,
            apiClient: resolvedApiClient,
            connections: $dced7aa321629549$export$ab9f7df4498d2fd5,
            seed: seed
        }), [
        store,
        resolvedSocket,
        resolvedApiClient
    ]);
    (0, $acw62.useEffect)(()=>{
        const inspector = (0, $22f46a313de5a83a$export$f8e3d94a9e9700ab)(value);
        return (0, $22f46a313de5a83a$export$3a1bf10cfe0b8bf7)(inspector);
    }, [
        value
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($db922aea4424a404$export$129055f0840a203c.Provider, {
        value: value,
        children: children
    });
}


// Runtime id-binding hook: turns a static `deps(...)` declaration into live
// data. The caller passes the store explicitly (see `./context` for a
// consumer's own convenience wrapper binding it implicitly) and binds only
// owner ids (e.g. `{ projectId, workshopId }`) — no endpoint, sub key or
// merge. For each relationship the hook, for the lifetime of the mount:
//   1. retains its entity type (ref-counted, first retain subscribes the
//      store's single live handler for that type);
//   2. fetches its slice (deduped by key) so it is normalized into the store;
//   3. selects it back out via the store's stable snapshots, so the
//      component re-renders only when that slice changes.
// The relationship's query filter is derived from the schema edge linking
// the declaration's root to the related entity (via `store.resolveOwnerFk`).

var $acw62 = parcelRequire("acw62");
// The entity types a set of relationships must keep live: each
// relationship's own type, plus the source type of every fold it opts into
// (so a live broadcast on a fold source flows into the store for a `with:
// [...]` request, but a plain relationship never subscribes to that channel).
function $86dc80c804a8ba71$var$retainedTypes(store, relationships) {
    var types = new Set();
    var retainFoldSources = function(type, names) {
        for(var _i = 0, names_1 = names; _i < names_1.length; _i++){
            var name = names_1[_i];
            var fold = store.getFold(type, name);
            if (!fold) continue;
            types.add(fold.source);
            if (fold.with) retainFoldSources(fold.source, fold.with);
        }
    };
    for(var _i = 0, relationships_1 = relationships; _i < relationships_1.length; _i++){
        var rel = relationships_1[_i];
        types.add(rel.type);
        if (rel.with) retainFoldSources(rel.type, rel.with);
    }
    return Array.from(types);
}
function $86dc80c804a8ba71$export$a37ae8cf05d96586(store, declaration, ids, options) {
    if (options === void 0) options = {};
    var relationships = Object.values(declaration.relationships);
    var retainTypes = $86dc80c804a8ba71$var$retainedTypes(store, relationships);
    var typesKey = retainTypes.slice().sort().join(",");
    var idsKey = $86dc80c804a8ba71$var$stableIdsKey(ids);
    // Subscription lifecycle is keyed by type, so it survives id changes (only
    // the fetch re-runs when ids change, below) and tears down on unmount. Fold
    // sources are retained too, scoped to this request.
    (0, $acw62.useEffect)(function() {
        for(var _i = 0, retainTypes_1 = retainTypes; _i < retainTypes_1.length; _i++){
            var type = retainTypes_1[_i];
            store.retain(type);
        }
        return function() {
            for(var _i = 0, retainTypes_2 = retainTypes; _i < retainTypes_2.length; _i++){
                var type = retainTypes_2[_i];
                store.release(type);
            }
        };
    // retainTypes is derived from the stable module-level declaration;
    // typesKey captures its identity for the dependency array.
    }, [
        store,
        typesKey
    ]);
    // (Re)fetch each relationship whenever the bound ids change.
    (0, $acw62.useEffect)(function() {
        if (options.fetch === false) return;
        for(var _i = 0, relationships_2 = relationships; _i < relationships_2.length; _i++){
            var rel = relationships_2[_i];
            // `Schema` and each relationship's own entity type are both still
            // deferred generic parameters here, so `FetchIds` can't be narrowed the
            // way it can be at a caller's own typed call site — this boundary is
            // inherently dynamic, exactly like the `bound = ids as BoundIds` lookup
            // in `getSnapshot` below.
            store.fetchQuery(rel.type, ids);
        }
    }, [
        store,
        typesKey,
        idsKey,
        options.fetch
    ]);
    // Assemble the selector result, memoized so an unchanged slice keeps the
    // same object reference (useSyncExternalStore bails out of re-rendering).
    var cache = (0, $acw62.useRef)(null);
    var subscribe = (0, $acw62.useCallback)(function(onChange) {
        return store.subscribe(onChange);
    }, [
        store
    ]);
    var getSnapshot = function() {
        var _a;
        var values = {};
        // `resolveOwnerFk` resolves the field name at runtime from the schema
        // graph, so this lookup is inherently dynamic — the typed `DepsIds`
        // contract is enforced at the call site.
        var bound = ids;
        for(var _i = 0, _b = Object.entries(declaration.relationships); _i < _b.length; _i++){
            var _c = _b[_i], key = _c[0], rel = _c[1];
            var fk = store.resolveOwnerFk(declaration.root, rel.type);
            var filter = fk ? (_a = {}, _a[fk] = bound[fk], _a) : {};
            var rows = store.getQuery(rel.type, filter, rel.with);
            values[key] = rel.cardinality === "many" ? rows : rows[0];
        }
        var prev = cache.current;
        if (prev && $86dc80c804a8ba71$var$sameValues(prev.values, values)) return prev.result;
        var result = values;
        cache.current = {
            values: values,
            result: result
        };
        return result;
    };
    return (0, $acw62.useSyncExternalStore)(subscribe, getSnapshot);
}
function $86dc80c804a8ba71$var$stableIdsKey(ids) {
    return Object.entries(ids).filter(function(_a) {
        var v = _a[1];
        return v !== undefined;
    }).sort(function(_a, _b) {
        var a = _a[0];
        var b = _b[0];
        return a < b ? -1 : a > b ? 1 : 0;
    }).map(function(_a) {
        var k = _a[0], v = _a[1];
        return "".concat(k, "=").concat(v);
    }).join("&");
}
function $86dc80c804a8ba71$var$sameValues(a, b) {
    var keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
        var key = keys_1[_i];
        if (a[key] !== b[key]) return false;
    }
    return true;
}


function $e9db94b1c3310c7c$export$a37ae8cf05d96586(declaration, ids, options = {}) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const fetched = Object.values(declaration.relationships).every((relationship)=>store.isQueryFetched(relationship.type, ids));
    return (0, $86dc80c804a8ba71$export$a37ae8cf05d96586)(store, declaration, ids, Object.assign(Object.assign({}, options), {
        fetch: options.fetch !== false && !fetched
    }));
}


// #1707 (tracker #1677) moved this hook into app-base's generic
// `data/use-retained-entities` (parameterized by a `DataSchema`, taking its
// store explicitly); this wrapper resolves the ambient store via
// `useDataStore()` (Logbook's own binding, `./Context`) so every existing
// `useRetainedEntities(types, ...)` call site (no store argument) is
// unaffected.

var $acw62 = parcelRequire("acw62");
function $cf60dedca63e8e80$export$e4edb3e6a3489a79(store, types, active, lifecycleKey) {
    if (active === void 0) active = true;
    var typesKey = types.join(",");
    (0, $acw62.useEffect)(function() {
        if (!active) return;
        var retained = typesKey === "" ? [] : typesKey.split(",");
        for(var _i = 0, retained_1 = retained; _i < retained_1.length; _i++){
            var type = retained_1[_i];
            store.retain(type);
        }
        return function() {
            for(var _i = 0, _a = retained.slice().reverse(); _i < _a.length; _i++){
                var type = _a[_i];
                store.release(type);
            }
        };
    }, [
        store,
        typesKey,
        active,
        lifecycleKey
    ]);
}



function $9690902269ab2924$export$e4edb3e6a3489a79(types, active = true, lifecycleKey) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    (0, $cf60dedca63e8e80$export$e4edb3e6a3489a79)(store, types, active, lifecycleKey);
}


// #1707 (tracker #1677) moved this hook into app-base's generic
// `data/use-query-ready` (parameterized by a `DataSchema`); this wrapper is a
// one-line instantiation at `LogbookSchema` with no behavior of its own.

var $acw62 = parcelRequire("acw62");
function $8ecc10210b240554$var$stableIdsKey(ids) {
    return Object.entries(ids).filter(function(_a) {
        var value = _a[1];
        return value !== undefined;
    }).sort(function(_a, _b) {
        var left = _a[0];
        var right = _b[0];
        return left.localeCompare(right);
    }).map(function(_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    }).join("&");
}
function $8ecc10210b240554$export$c40434fbcbfd3fb6(store, type, ids, shouldFetch, readyWhenSkipped) {
    var idsKey = $8ecc10210b240554$var$stableIdsKey(ids);
    var stableIds = (0, $acw62.useMemo)(function() {
        return ids;
    }, [
        idsKey
    ]);
    var _a = (0, $acw62.useState)(shouldFetch ? false : readyWhenSkipped), ready = _a[0], setReady = _a[1];
    (0, $acw62.useEffect)(function() {
        if (!shouldFetch) {
            setReady(readyWhenSkipped);
            return;
        }
        var active = true;
        setReady(false);
        store.fetchQuery(type, stableIds).then(function() {
            if (active && store.isQueryFetched(type, stableIds)) setReady(true);
        });
        return function() {
            active = false;
        };
    }, [
        store,
        type,
        stableIds,
        shouldFetch,
        readyWhenSkipped
    ]);
    return ready;
}


function $29504a259cf4b663$export$c40434fbcbfd3fb6(store, type, ids, shouldFetch, readyWhenSkipped) {
    const fetched = shouldFetch && store.isQueryFetched(type, ids);
    return (0, $8ecc10210b240554$export$c40434fbcbfd3fb6)(store, type, ids, shouldFetch && !fetched, readyWhenSkipped || fetched);
}


function $5bd541aff0182fa0$export$e9bc97ba61bf8e52(notes) {
    var _a;
    const noteById = new Map();
    const attachmentById = new Map();
    for (const note of notes){
        noteById.set(note.id, note);
        for (const attachment of (_a = note.attachments) !== null && _a !== void 0 ? _a : [])attachmentById.set(attachment.id, attachment);
    }
    return {
        Note: Array.from(noteById.values()),
        NoteAttachment: Array.from(attachmentById.values())
    };
}


// Runtime exhaustiveness guard for the connection layer. Criterion 3 asks the
// hand-written connections to be "exhaustiveness-checked against Schema.ts": the
// mapped-type registry catches a missing entity at compile time, and this guard
// catches the rest at runtime — an owner/index edge whose FK field isn't indexed
// on its target, or a soft-delete declaration that drifts from the models. A
// future `Schema.ts` regen that adds an entity/edge the layer doesn't handle then
// fails loudly instead of silently mis-routing live updates.
//
// #1707 (tracker #1677) moved the actual guard into app-base's generic
// `validateSchema` (parameterized by a `SchemaDescriptor`, not Logbook's
// generated types); `Connections/Connection.ts#validateSchema` delegates to it
// against `logbookSchemaDescriptor`. This module stays as the thin, stably-named
// entry point every existing caller already imports.


function $657914868a973676$export$96eaadda7d51e9d1(registry = (0, $dced7aa321629549$export$ab9f7df4498d2fd5)) {
    (0, $dce9b2b6397c0cdf$export$4741711f07dbb8e7)(registry);
}





function $62b16000854aa787$export$d90ea4047b394c05(response) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const cruises = (0, $77089501411ae7ed$export$3d0443392257ae11)(response.cruises.cruises, response.cruises.calculations, response.cruises.calculationsV2);
    const trips = (0, $77089501411ae7ed$export$3d0443392257ae11)((_b = (_a = response.trips) === null || _a === void 0 ? void 0 : _a.trips) !== null && _b !== void 0 ? _b : [], (_c = response.trips) === null || _c === void 0 ? void 0 : _c.calculations, (_d = response.trips) === null || _d === void 0 ? void 0 : _d.calculationsV2);
    const days = (0, $77089501411ae7ed$export$3d0443392257ae11)((_f = (_e = response.days) === null || _e === void 0 ? void 0 : _e.days) !== null && _f !== void 0 ? _f : [], (_g = response.days) === null || _g === void 0 ? void 0 : _g.calculations, (_h = response.days) === null || _h === void 0 ? void 0 : _h.calculationsV2);
    const notes = $62b16000854aa787$export$9c8e789df238128a(cruises, trips, days, [
        response.cruises,
        response.trips,
        response.days
    ].flatMap((slice)=>{
        var _a;
        return (_a = slice === null || slice === void 0 ? void 0 : slice.notes) !== null && _a !== void 0 ? _a : [];
    }), [
        response.cruises,
        response.trips,
        response.days
    ].flatMap((slice)=>{
        var _a;
        return (_a = slice === null || slice === void 0 ? void 0 : slice.attachments) !== null && _a !== void 0 ? _a : [];
    }));
    return {
        bundle: {
            entities: Object.assign(Object.assign({}, notes), {
                Log: (_k = (_j = response.logs) === null || _j === void 0 ? void 0 : _j.logs) !== null && _k !== void 0 ? _k : [],
                Status: (_l = response.status) !== null && _l !== void 0 ? _l : [],
                StoredCalculation: (_o = (_m = response.logs) === null || _m === void 0 ? void 0 : _m.calculationsV2) !== null && _o !== void 0 ? _o : []
            })
        },
        currentLog: response.currentLog
    };
}
function $62b16000854aa787$export$9c8e789df238128a(cruises, trips, days, notes = [], attachments = []) {
    const nested = (0, $5bd541aff0182fa0$export$e9bc97ba61bf8e52)([
        ...cruises,
        ...trips,
        ...days
    ].flatMap((row)=>{
        var _a;
        return (_a = row.notes) !== null && _a !== void 0 ? _a : [];
    }).concat(notes));
    return {
        Cruise: cruises,
        Trip: trips,
        Day: days,
        Note: nested.Note,
        NoteAttachment: [
            ...new Map([
                ...nested.NoteAttachment,
                ...attachments
            ].map((row)=>[
                    row.id,
                    row
                ])).values()
        ]
    };
}




var $acw62 = parcelRequire("acw62");



function $bf76a3a7a0d207c0$export$7c8f4ae02863d723(store, ids) {
    return {
        updateSettings: (values)=>store.mutate({
                request: (client)=>new (0, $82aa55b43aca7932$export$598162aac93aa171)(client).settings.update({
                        params: ids,
                        body: {
                            data: JSON.stringify(values)
                        }
                    }).call(),
                reconcile: (response)=>({
                        entities: {
                            Settings: response.settings
                        }
                    })
            }),
        updateShipData: (values)=>store.mutate({
                request: (client)=>new (0, $82aa55b43aca7932$export$598162aac93aa171)(client).settings.updateData({
                        params: ids,
                        body: {
                            data: JSON.stringify(values)
                        }
                    }).call(),
                reconcile: (response)=>({
                        entities: {
                            Settings: response.settings
                        }
                    })
            })
    };
}
function $bf76a3a7a0d207c0$export$4bb86e129f694bc0(shipId) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    return (0, $acw62.useMemo)(()=>$bf76a3a7a0d207c0$export$7c8f4ae02863d723(store, {
            shipId: shipId
        }), [
        store,
        shipId
    ]);
}
function $bf76a3a7a0d207c0$export$b0ab3204ac4c15f7(response) {
    const latest = response.settings.at(-1);
    return latest ? (0, $bdd927c6c90fec0d$export$c72f6eaae7b9adff).parse(latest) : undefined;
}



function $47e36f86d10442cb$export$f951b93fb870a692(store, shipId, attachment) {
    return store.mutate({
        request: (client)=>new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(client).ships.import({
                params: {
                    shipId: shipId
                },
                body: {
                    attachment: attachment
                }
            }).call()
    });
}
function $47e36f86d10442cb$export$2ff272b52de798d0(store, values) {
    return store.mutate({
        request: (client)=>new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(client).ships.create({
                params: {},
                body: values
            }).call(),
        reconcile: (response)=>{
            var _a, _b;
            return {
                entities: {
                    Ship: [
                        response.ship
                    ],
                    Settings: (_a = response.settings) !== null && _a !== void 0 ? _a : [],
                    ShipUser: [
                        ...(_b = response.users) !== null && _b !== void 0 ? _b : [],
                        ...response.user ? [
                            response.user
                        ] : []
                    ]
                }
            };
        }
    });
}



var $acw62 = parcelRequire("acw62");

const $17817566f885d8cf$var$requests = new WeakMap();
function $17817566f885d8cf$var$companionRequest(store) {
    const existing = $17817566f885d8cf$var$requests.get(store);
    if (existing) return existing;
    const request = new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(store.api()).ships.companion({
        params: {}
    }).call();
    $17817566f885d8cf$var$requests.set(store, request);
    request.catch(()=>$17817566f885d8cf$var$requests.delete(store));
    return request;
}
function $17817566f885d8cf$export$1bbfe1a1e23d847e(store) {
    const [companion, setCompanion] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        let active = true;
        $17817566f885d8cf$var$companionRequest(store).then((value)=>{
            if (active) setCompanion(value);
        }).catch(console.error);
        return ()=>{
            active = false;
        };
    }, [
        store
    ]);
    return companion;
}



var $acw62 = parcelRequire("acw62");


function $8e9aff077a3eab8f$export$3fce66e5f89ae563(store, shipId, enabled, revision = 0) {
    const [snapshot, setSnapshot] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setSnapshot(undefined);
        if (!enabled) return;
        let active = true;
        let timer;
        const load = async ()=>{
            try {
                const response = await new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(store.api()).ships.companions({
                    params: {
                        shipId: shipId
                    }
                }).call();
                if (active) setSnapshot({
                    store: store,
                    shipId: shipId,
                    revision: revision,
                    state: {
                        status: "loaded",
                        companions: response.companions
                    }
                });
            } catch (error) {
                if (active) {
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Failed to load connected companions", error);
                    setSnapshot({
                        store: store,
                        shipId: shipId,
                        revision: revision,
                        state: {
                            status: "error"
                        }
                    });
                }
            } finally{
                // Schedule after completion so a slow primary never accumulates requests.
                if (active) timer = setTimeout(load, 5000);
            }
        };
        load();
        return ()=>{
            active = false;
            clearTimeout(timer);
        };
    }, [
        store,
        shipId,
        enabled,
        revision
    ]);
    if (!enabled) return undefined;
    return (snapshot === null || snapshot === void 0 ? void 0 : snapshot.store) === store && snapshot.shipId === shipId && snapshot.revision === revision ? snapshot.state : {
        status: "loading"
    };
}






const { Context: $4f881e66fa9c872b$export$877b1757b0922990, useData: $4f881e66fa9c872b$export$16e4b49792d5576d } = (0, $480db5fef2358c2d$export$1f628e93c0b28291)("DayDataView");



var $acw62 = parcelRequire("acw62");




function $d6df2781f38d78e8$export$fd18ff9e1192260c({ isCurrentDay: isCurrentDay, focusEditable: focusEditable, initHighlight: initHighlight }) {
    const [highlight, setHighlight] = (0, $acw62.useState)(initHighlight);
    const [auditLogEdits, setAuditLogEdits] = (0, $acw62.useState)([]);
    const [savedDay, setSavedDay] = (0, $acw62.useState)(undefined);
    const clearHighlight = (0, $acw62.useCallback)(()=>{
        setHighlight(undefined);
    }, []);
    const notifyNewLog = (0, $acw62.useCallback)((log, info)=>{
        if (!isCurrentDay || info == "sync") return;
        const metadata = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed;
        // TODO: Don't highlight automatic entries
        if (!metadata.nmeaAuto && focusEditable) setHighlight(log.id);
    }, [
        isCurrentDay,
        focusEditable
    ]);
    const recordAuditLogEdits = (0, $acw62.useCallback)((edits)=>{
        setAuditLogEdits((previous)=>edits.reduce((acc, edit)=>(0, $5ba8962d09b05c4a$export$b531eccea6f91101).updateData(acc, edit), [
                ...previous
            ]));
    }, []);
    const recordSavedDay = (0, $acw62.useCallback)((day)=>{
        setSavedDay(day);
    }, []);
    return {
        highlight: highlight,
        clearHighlight: clearHighlight,
        notifyNewLog: notifyNewLog,
        auditLogEdits: auditLogEdits,
        setAuditLogEdits: setAuditLogEdits,
        recordAuditLogEdits: recordAuditLogEdits,
        savedDay: savedDay,
        recordSavedDay: recordSavedDay
    };
}
function $d6df2781f38d78e8$export$e2cf6ecfef0047e9(isCurrentDay, seeded) {
    const [provisionalLogs, setProvisionalLogs] = (0, $acw62.useState)({});
    const seededKeys = (0, $acw62.useRef)(new Set());
    // Merged rather than assigned, and keyed identically to the live channel, so this is
    // idempotent and a retraction that has already arrived still wins. Each key is taken at
    // most once: a marker the engine has since RETRACTED is gone from this map for good, and
    // re-adding it because it is "missing" again would resurrect a pause that never happened.
    // Tracked in a ref rather than derived from the state, which cannot tell "not seeded yet"
    // from "seeded and then cleared".
    (0, $acw62.useEffect)(()=>{
        if (!isCurrentDay || !seeded) return;
        const fresh = Object.entries(seeded).filter(([key])=>!seededKeys.current.has(key));
        if (fresh.length < 1) return;
        for (const [key] of fresh)seededKeys.current.add(key);
        setProvisionalLogs((prev)=>Object.assign(Object.assign({}, prev), Object.fromEntries(fresh)));
    }, [
        isCurrentDay,
        seeded
    ]);
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((log, _type, info)=>{
        if (!isCurrentDay) return;
        const key = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed.provisionalKey;
        setProvisionalLogs((prev)=>(0, $5ba8962d09b05c4a$export$b531eccea6f91101).updateProvisional(prev, key, log, info));
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog);
    return provisionalLogs;
}





function $4ed8c43f43401e0f$export$f553f5dbf5db7a15(store, ids) {
    const { shipId: shipId, dayId: dayId, tripId: tripId } = ids;
    return {
        updateLog (logId, values) {
            const current = store.getEntity((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Log, logId);
            const optimistic = current ? {
                upsert: {
                    Log: [
                        Object.assign(Object.assign({}, current), values)
                    ]
                }
            } : undefined;
            return store.mutate({
                optimistic: optimistic,
                request: (client)=>new (0, $199ead3c99f138be$export$89c3ec6dea3c6061)(client).logs.update({
                        params: {
                            shipId: shipId,
                            logId: logId
                        },
                        body: values
                    }).call(),
                reconcile: (r)=>({
                        entities: {
                            Log: [
                                r.log
                            ]
                        }
                    })
            });
        },
        updateLogEngine (logId, engine, on) {
            return store.mutate({
                request: (client)=>new (0, $199ead3c99f138be$export$89c3ec6dea3c6061)(client).logs.updateEngine({
                        params: {
                            shipId: shipId,
                            logId: logId
                        },
                        body: {
                            engine: engine,
                            on: on
                        }
                    }).call()
            });
        },
        updateLogSails (logId, sails) {
            return store.mutate({
                request: (client)=>new (0, $199ead3c99f138be$export$89c3ec6dea3c6061)(client).logs.updateSails({
                        params: {
                            shipId: shipId,
                            logId: logId
                        },
                        body: {
                            sails: sails
                        }
                    }).call()
            });
        },
        updateDay (values) {
            return store.mutate({
                request: (client)=>new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(client).days.update({
                        params: {
                            shipId: shipId,
                            dayId: dayId
                        },
                        body: values
                    }).call(),
                reconcile: (r)=>({
                        entities: {
                            Day: [
                                r.day
                            ]
                        }
                    })
            });
        },
        createDay (values) {
            return store.mutate({
                request: (client)=>new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(client).days.create({
                        params: {
                            shipId: shipId,
                            tripId: tripId
                        },
                        body: values
                    }).call(),
                reconcile: (r)=>({
                        entities: {
                            Day: [
                                r.day
                            ]
                        }
                    })
            });
        },
        calculateDay () {
            return store.mutate({
                request: (client)=>new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(client).days.calculate({
                        params: {
                            shipId: shipId,
                            dayId: dayId
                        }
                    }).call()
            });
        }
    };
}
// Inert DayView writers for harnesses and tests that render a DayView subtree but never
// exercise a write (the real variants provide working writers). Each rejects loudly if
// unexpectedly called, so an accidental save in a read-only fixture surfaces rather than
// silently no-opping.
const $4ed8c43f43401e0f$var$rejectNoop = (name)=>()=>Promise.reject(new Error(`noopDayWriters.${name}: no writer provided (read-only DayView context)`));
const $4ed8c43f43401e0f$export$69e9b5677a213130 = {
    updateLog: $4ed8c43f43401e0f$var$rejectNoop("updateLog"),
    updateLogEngine: $4ed8c43f43401e0f$var$rejectNoop("updateLogEngine"),
    updateLogSails: $4ed8c43f43401e0f$var$rejectNoop("updateLogSails"),
    updateDay: $4ed8c43f43401e0f$var$rejectNoop("updateDay"),
    createDay: $4ed8c43f43401e0f$var$rejectNoop("createDay"),
    calculateDay: $4ed8c43f43401e0f$var$rejectNoop("calculateDay")
};


// A stable empty provisional list for non-current days, so `common.provisional` keeps a
// referentially-stable identity (avoids a needless `useDayDataValue` re-memo per render).
const $b7a41c77d4ceff2b$var$NO_PROVISIONAL = [];
const $b7a41c77d4ceff2b$export$8b51ad2b94d9ce12 = (0, $a9e25f5507c22ba4$export$a23f992de0d45ff0)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Day, {
    logs: (0, $9db39e34b2fb118a$export$14badfee79ea396f)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Log, {
        with: [
            "calculated",
            "calculatedV2"
        ]
    }),
    statuses: (0, $9db39e34b2fb118a$export$14badfee79ea396f)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Status),
    tracks: (0, $9db39e34b2fb118a$export$14badfee79ea396f)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Track)
});
const $b7a41c77d4ceff2b$var$EMPTY_DAY_SLICE = {
    logs: undefined,
    statuses: undefined,
    tracks: undefined,
    anchorCircles: undefined
};
// Build the presentational DayDataViewData from a resolved slice plus the shared
// acquisition state. Identical for both branches, so DayViewUI stays impl-agnostic.
function $b7a41c77d4ceff2b$var$useDayDataValue(slice, common) {
    const { events: events } = common;
    const timelineLogs = (0, $acw62.useMemo)(()=>{
        var _a;
        return (0, $5ba8962d09b05c4a$export$b531eccea6f91101).mergeProvisional((_a = slice.logs) !== null && _a !== void 0 ? _a : [], [
            ...common.provisional
        ]);
    }, [
        slice.logs,
        common.provisional
    ]);
    return {
        logs: slice.logs,
        statuses: slice.statuses,
        tracks: slice.tracks,
        anchorCircles: slice.anchorCircles,
        auditLogEdits: events.auditLogEdits,
        timelineLogs: timelineLogs,
        recordAuditLogEdits: events.recordAuditLogEdits,
        savedDay: events.savedDay,
        recordSavedDay: events.recordSavedDay,
        details: common.details,
        setDetails: common.setDetails,
        selected: common.selected,
        toggleSelected: common.toggleSelected,
        highlight: events.highlight,
        clearHighlight: events.clearHighlight,
        selectedCallback: common.selectedCallback,
        writers: common.writers
    };
}
// Active branch -- mounted only for a selected/current day. Reads the day's slices
// from the centralized store via `useDeps` (the owner-FK `dayId` filter does the
// ownership scoping) and its Log bundle's non-entity extras (`auditLogEdits`) via
// `useExtras`, pushing the latter into the shared events store the way the legacy
// `loadLogs` effect did. `anchorCircles` ride the Track bundle's extras, read via
// `useExtras(store, "Track", ids)` the same way `auditLogEdits` ride the Log bundle.
function $b7a41c77d4ceff2b$var$DayDataActive({ shipId: shipId, dayId: dayId, setAuditLogEdits: setAuditLogEdits, onData: onData }) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    // Annotated with the declaration's own id contract, not `BoundIds`: the wide
    // `Record<string, number | undefined>` would accept any key, and a bare `const ids =
    // {...}` loses the excess-property check once it is passed on as a variable.
    const ids = {
        shipId: shipId,
        dayId: dayId
    };
    const { logs: logs, statuses: statuses, tracks: tracks } = (0, $e9db94b1c3310c7c$export$a37ae8cf05d96586)($b7a41c77d4ceff2b$export$8b51ad2b94d9ce12, ids);
    const logExtras = (0, $b82e6d2a15bbd8b8$export$5d34c0530ef73ac5)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Log, ids);
    const trackExtras = (0, $b82e6d2a15bbd8b8$export$5d34c0530ef73ac5)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Track, ids);
    (0, $acw62.useEffect)(()=>{
        const edits = logExtras.auditLogEdits;
        if (edits) setAuditLogEdits(edits);
    // `logExtras` is referentially stable (a shared empty bag until a fetch replaces
    // it), so this runs once per fetch rather than every render.
    }, [
        logExtras,
        setAuditLogEdits
    ]);
    // `useDeps` returns readonly snapshots; the view-data contract (and its child prop
    // types) are mutable arrays. Cast without copying to preserve referential stability
    // -- consumers never mutate them.
    (0, $acw62.useLayoutEffect)(()=>{
        onData({
            shipId: shipId,
            dayId: dayId,
            slice: {
                logs: logs,
                statuses: statuses,
                tracks: tracks,
                anchorCircles: trackExtras.anchorCircles
            }
        });
    }, [
        shipId,
        dayId,
        logs,
        statuses,
        tracks,
        trackExtras.anchorCircles,
        onData
    ]);
    return null;
}
function $b7a41c77d4ceff2b$export$feddd27a55de72d6({ day: day, focus: focus, initDetails: initDetails, initHighlight: initHighlight, initSelected: initSelected, isCurrentDay: isCurrentDay, children: children }) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const [ship, trip] = [
        (0, $97ac05743b787a86$export$f581995c9f2db6f0)(),
        (0, $97ac05743b787a86$export$e205ea882cbd693e)()
    ];
    const { apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const [details, setDetails] = (0, $acw62.useState)(!day.id && !isCurrentDay || initDetails || false);
    const [selected, setSelected] = (0, $acw62.useState)(isCurrentDay || initSelected || false);
    const [loaded, setLoaded] = (0, $acw62.useState)();
    const isCurrentTrip = trip.trip.completedAt == null;
    const focusEditable = focus && (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).availableCurrentOrAll(apiUser, ship.id, isCurrentTrip);
    const events = (0, $d6df2781f38d78e8$export$fd18ff9e1192260c)({
        isCurrentDay: isCurrentDay || false,
        focusEditable: focusEditable,
        initHighlight: initHighlight
    });
    // Provisional auto-logs live in the centralized `ProvisionalLog` store (retaining its
    // single live `Log/Provisional` subscription), replacing the legacy view-local slice.
    // They belong to whichever day is current, so a non-current day folds in none. The
    // `provisionalLogs` prop (the legacy variant's seed of markers that armed before mount,
    // #1218) is deliberately unused here: `FocusDataView` seeds the store from the very
    // same current-day response, so the store is already the single source for both.
    const storeProvisional = (0, $b82e6d2a15bbd8b8$export$5e08d2776b44093d)(store);
    const provisional = isCurrentDay ? storeProvisional : $b7a41c77d4ceff2b$var$NO_PROVISIONAL;
    const onLiveLog = (0, $acw62.useCallback)((log, info)=>{
        if (log.dayId == day.id) events.notifyNewLog(log, info);
    }, [
        day.id,
        events.notifyNewLog
    ]);
    (0, $b82e6d2a15bbd8b8$export$419a4240882ffaf9)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Log, onLiveLog);
    const toggleSelected = (0, $acw62.useCallback)(()=>setSelected((current)=>!current), []);
    // Tracks load declaratively via `useDeps` once the day is active, so there's no
    // lazy per-tab track load to trigger (unlike the legacy variant's `loadTrack`).
    const selectedCallback = (0, $acw62.useCallback)((_value)=>Promise.resolve(), []);
    // New days need createDay even before their acquisition consumer is mounted.
    const writers = (0, $acw62.useMemo)(()=>(0, $4ed8c43f43401e0f$export$f553f5dbf5db7a15)(store, {
            shipId: ship.id,
            dayId: day.id,
            tripId: day.tripId
        }), [
        store,
        ship.id,
        day.id,
        day.tripId
    ]);
    const common = {
        events: events,
        provisional: provisional,
        details: details,
        setDetails: setDetails,
        selected: selected,
        toggleSelected: toggleSelected,
        selectedCallback: selectedCallback,
        writers: writers
    };
    const active = Boolean(day.id) && (selected || Boolean(isCurrentDay));
    const slice = active && (loaded === null || loaded === void 0 ? void 0 : loaded.shipId) === ship.id && loaded.dayId === day.id ? loaded.slice : $b7a41c77d4ceff2b$var$EMPTY_DAY_SLICE;
    const value = $b7a41c77d4ceff2b$var$useDayDataValue(slice, common);
    // Only the reader is conditional: creating a day must not remount its live editor.
    return (0, $7b02d682eb115277$exports.jsxs)((0, $4f881e66fa9c872b$export$877b1757b0922990).Provider, {
        value: value,
        children: [
            active && (0, $7b02d682eb115277$exports.jsx)($b7a41c77d4ceff2b$var$DayDataActive, {
                shipId: ship.id,
                dayId: day.id,
                setAuditLogEdits: events.setAuditLogEdits,
                onData: setLoaded
            }),
            children
        ]
    });
}




var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");




function $9f9e7bca499fb8dc$export$f97dc4a5a0177256({ closeAction: closeAction, defaultSelection: defaultSelection, callbacks: callbacks, selectedCallback: selectedCallback, tabs: tabs }) {
    var _a;
    const [selected, setSelected] = (0, $acw62.useState)(defaultSelection);
    const setTabSelected = (0, $acw62.useCallback)((value)=>{
        if (selectedCallback) selectedCallback(value);
        setSelected(value);
    }, [
        selectedCallback
    ]);
    (0, $8a8193ceb042f538$export$fc24143eb074d761)(()=>{
        return {
            setSelected: (value)=>{
                setTabSelected(value);
            }
        };
    }, callbacks);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "TabBar",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "TabBar-tabs",
                children: [
                    closeAction && (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                        onClick: closeAction
                    }),
                    tabs.map((tab)=>{
                        if (tab.hide != true) return (0, $7b02d682eb115277$exports.jsx)($9f9e7bca499fb8dc$export$17fdeefb635e9874, Object.assign({}, tab, {
                            setTabSelected: setTabSelected,
                            selected: selected == tab.name
                        }), `tab-${tab.name}`);
                        return;
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "TabBar-content" + (selected && " TabBar-content-" + selected),
                children: (_a = tabs.find((tab)=>tab.name == selected)) === null || _a === void 0 ? void 0 : _a.render()
            })
        ]
    });
}
function $9f9e7bca499fb8dc$export$17fdeefb635e9874({ action: action, active: active, hide: _hide, icon: icon, name: name, render: _render, setTabSelected: setTabSelected, selected: selected, title: title }) {
    const click = (0, $acw62.useCallback)(()=>{
        if (action) action(name);
        else if (setTabSelected) setTabSelected(name);
    }, [
        action,
        setTabSelected
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "TabBar-tab",
            selected && "selected",
            active != false && "active"
        ]),
        onClick: click,
        children: [
            icon && (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                icon: icon
            }),
            title
        ]
    });
}





var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $73a18fbdc66de88f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $73a18fbdc66de88f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $73a18fbdc66de88f$export$d3b8d51a855c78a3(_a) {
    var _this = this;
    var update = _a.update, create = _a.create, isNew = _a.isNew, save = _a.save, validate = _a.validate, onSaveStart = _a.onSaveStart, onSaveError = _a.onSaveError, initSaveError = _a.initSaveError;
    var _b = (0, $51cc312cf1408924$export$f24bdf120ad0e590)(), edited = _b[0], onEdited = _b[1], resetEdited = _b[2];
    var _c = (0, $acw62.useState)(initSaveError), saveError = _c[0], setSaveError = _c[1];
    var saveEdits = (0, $acw62.useCallback)(function(_data, values) {
        return $73a18fbdc66de88f$var$__awaiter(_this, void 0, void 0, function() {
            var operation, result;
            return $73a18fbdc66de88f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        onSaveStart === null || onSaveStart === void 0 || onSaveStart(values);
                        if (!save) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            save(values, {
                                resetEdited: resetEdited
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 2:
                        operation = isNew && create ? create : update;
                        if (!operation) throw new Error("useEditForm requires update, create, or save");
                        return [
                            4 /*yield*/ ,
                            operation(values)
                        ];
                    case 3:
                        result = _a.sent();
                        if (result) resetEdited();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        create,
        isNew,
        onSaveStart,
        resetEdited,
        save,
        update
    ]);
    var handleSaveError = (0, $acw62.useCallback)(function(error) {
        setSaveError(error);
        if (error !== undefined) {
            resetEdited();
            onSaveError === null || onSaveError === void 0 || onSaveError(error);
        }
    }, [
        onSaveError,
        resetEdited
    ]);
    var validateEdits = (0, $acw62.useCallback)(function(_data, values) {
        if (!validate) throw new Error("validateEdits requires validate");
        var valid = validate(values);
        resetEdited();
        return valid;
    }, [
        resetEdited,
        validate
    ]);
    return {
        edited: edited,
        onEdited: onEdited,
        resetEdited: resetEdited,
        saveEdits: saveEdits,
        saveError: saveError,
        onSaveError: handleSaveError,
        validateEdits: validate ? validateEdits : undefined
    };
}



function $58cbd7a8fa422027$export$d3b8d51a855c78a3(options) {
    const revision = (0, $acw62.useRef)(0);
    const { create: create, update: update, save: save, isNew: isNew } = options;
    // Use the shared hook's save seam so an acknowledgement cannot clear newer input.
    const saveCurrent = (0, $acw62.useCallback)(async (values, context)=>{
        const savedRevision = revision.current;
        const resetEdited = ()=>{
            if (revision.current === savedRevision) context.resetEdited();
        };
        if (save) {
            await save(values, {
                resetEdited: resetEdited
            });
            return;
        }
        const operation = isNew && create ? create : update;
        if (!operation) throw new Error("useEditForm requires update, create, or save");
        if (await operation(values)) resetEdited();
    }, [
        create,
        update,
        save,
        isNew
    ]);
    const form = (0, $73a18fbdc66de88f$export$d3b8d51a855c78a3)(Object.assign(Object.assign({}, options), {
        save: saveCurrent,
        onSaveStart: (values)=>{
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("saving", (0, $ea493e883ca706d4$export$9de129cb03ba998c)(values));
        }
    }));
    const onEdited = (0, $acw62.useCallback)((event)=>{
        revision.current += 1;
        form.onEdited(event);
    }, [
        form.onEdited
    ]);
    return Object.assign(Object.assign({}, form), {
        onEdited: onEdited
    });
}





var $acw62 = parcelRequire("acw62");




function $a6db0417d7b66a9b$export$440f3ad447d43e10(type, value) {
    // TODO: Handle instanceof File
    if (!value || typeof value != "string") return null;
    switch(type){
        case "float":
            {
                const decimalPoint = 1.1.toLocaleString(navigator.language).substr(1, 1) || ".";
                const f = decimalPoint == "," ? parseFloat(value.replaceAll(",", ".")) : parseFloat(value);
                return isNaN(f) ? null : f;
            }
        case "int":
            {
                const i = parseInt(value);
                return isNaN(i) ? null : i;
            }
        case "bool":
            return value == "true";
        case "timezone":
            {
                if (value == "UTC") return 0;
                // The label carries an optional `:MM` part ("UTC-9:30"), whose sign follows
                // the hours; parsing only the leading integer used to truncate it to -9 h.
                const parts = /^UTC([+-])(\d+)(?::(\d+))?$/.exec(value.trim());
                if (!parts) return null;
                const magnitude = parseInt(parts[2]) * 3600 + (parts[3] ? parseInt(parts[3]) * 60 : 0);
                return parts[1] == "-" ? -magnitude : magnitude;
            }
        default:
            return value;
    }
}
var $a6db0417d7b66a9b$var$EditGroupSaveState;
(function(EditGroupSaveState) {
    EditGroupSaveState[EditGroupSaveState["noChange"] = 0] = "noChange";
    EditGroupSaveState[EditGroupSaveState["saved"] = 1] = "saved";
    EditGroupSaveState[EditGroupSaveState["saving"] = 2] = "saving";
    EditGroupSaveState[EditGroupSaveState["failed"] = 3] = "failed";
})($a6db0417d7b66a9b$var$EditGroupSaveState || ($a6db0417d7b66a9b$var$EditGroupSaveState = {}));
// Issue #1142 (broader fix): `isFieldEditable`, when given, is consulted once per
// top-level field name -- a field it disallows is skipped entirely, before any
// scalar/array/object-specific reading of `data`, so a currently non-editable field
// can never be resubmitted, even accidentally via a stale or display-rounded
// `readOnly` input value. Nested `fields` (object arrays) are not separately
// gated -- `isFieldEditable` only applies to the top-level fields passed in here.
function $a6db0417d7b66a9b$var$formValues(data, prefix, editableFields, isFieldEditable) {
    const values = {};
    for (const field of editableFields){
        const name = typeof field == "string" ? field : field.name;
        if (isFieldEditable && !isFieldEditable(name)) continue;
        if (typeof field == "string") values[field] = $a6db0417d7b66a9b$export$440f3ad447d43e10("string", data.get(`${prefix}${field}`));
        else if (field.array == true) {
            if (field.type == "object" && field.fields) {
                values[field.name] = [];
                const a = [];
                let i = 0;
                while(data.get(`${prefix}${field.name}[${i}].id`) != undefined){
                    a[i] = $a6db0417d7b66a9b$var$formValues(data, `${prefix}${field.name}[${i}].`, field.fields);
                    i += 1;
                }
                values[field.name] = a;
            } else {
                const a = [];
                let i = 0;
                let v;
                const max = parseInt((data.get(`${prefix}${field.name}.length`) || "-1").toString());
                if (max >= 0) {
                    // An explicit zero-length marker is itself a genuine (empty) value --
                    // e.g. the view intentionally declaring "no entries" -- so it's always
                    // submitted even though the loop below never runs for it.
                    let found = max == 0;
                    for(i = 0; i < max; i += 1){
                        v = data.get(`${prefix}${field.name}[${i}]`);
                        const c = $a6db0417d7b66a9b$export$440f3ad447d43e10(field.type, v);
                        if (c != null) found = true;
                        a[i] = c == null ? field.default : c;
                    }
                    // Issue #1142 (follow-up): `NavigationView` also renders this `.length`
                    // marker whenever an engine is currently on (so a manually-typed rpm can
                    // be submitted), not only when there's real stored data. A freshly
                    // recorded log with an engine switched on but no rpm typed yet still
                    // renders a real (blank) `<input>` for it, which submits an empty
                    // string for every entry -- converting to `null` and falling back to
                    // `field.default` throughout. That produced a fully fabricated array
                    // (e.g. `[-1]`) that is NOT the same value as the true nil stored
                    // value, again rejecting the *entire* save. When nothing was genuinely
                    // entered anywhere in a length-bounded array either, omit it entirely --
                    // same reasoning as the open-ended branch below.
                    if (found) values[field.name] = a;
                } else {
                    while((v = data.get(`${prefix}${field.name}[${i}]`)) != undefined){
                        const c = $a6db0417d7b66a9b$export$440f3ad447d43e10(field.type, v);
                        a[i] = c == null ? field.default : c;
                        i += 1;
                    }
                    // No `.length` field and no indexed entries at all -- the view rendered
                    // nothing for this array field, so leave it out of `values` entirely
                    // instead of defaulting to `[]`. `EditGroup` always submits the whole
                    // form, and a same-value resubmission of an untouched field must never
                    // count as an edit attempt (see the scalar-field handling below) -- but an
                    // empty array is NOT the same value as an absent/nil array server-side, so
                    // submitting `[]` here would register as a spurious "changed" edit
                    // whenever the true stored value is nil (issue #1142: this rejected the
                    // *entire* save -- e.g. an unrelated Comment edit -- for any freshly
                    // recorded log whose `engineRpms` had never been set).
                    if (i > 0) values[field.name] = a;
                }
            }
        } else if (field.type == "object" && field.fields) values[field.name] = $a6db0417d7b66a9b$var$formValues(data, `${prefix}${field.name}.`, field.fields);
        else if (field.name) {
            const v = $a6db0417d7b66a9b$export$440f3ad447d43e10(field.type, data.get(`${prefix}${field.name}`));
            values[field.name] = v == null || v == undefined ? field.default : v;
        }
    }
    return values;
}
const $a6db0417d7b66a9b$export$66cf394dfb34aaef = {
    convertInput: $a6db0417d7b66a9b$export$440f3ad447d43e10,
    formValues: $a6db0417d7b66a9b$var$formValues
};
function $a6db0417d7b66a9b$export$6723bcf3bd3caed8(error) {
    if (error != null && typeof error == "object" && "error" in error && error.error == "editNotAllowed" && "fields" in error && Array.isArray(error.fields) && error.fields.every((f)=>typeof f == "string")) return error.fields;
    return undefined;
}
function $a6db0417d7b66a9b$export$3b04090cc2c1b2d(error, fieldLabels, messages) {
    if (error === undefined) return undefined;
    const fields = $a6db0417d7b66a9b$export$6723bcf3bd3caed8(error);
    if (fields && fields.length > 0) {
        const labels = Array.from(new Set(fields.map((f)=>{
            var _a;
            return (_a = fieldLabels[f]) !== null && _a !== void 0 ? _a : f;
        })));
        return messages.fields(labels.join(", "));
    }
    return messages.generic;
}
function $a6db0417d7b66a9b$export$b048568c3d3852d5({ buttonFirst: buttonFirst, changed: changed, children: children, className: className, editable: editable, editableFields: editableFields, editing: editing, error: error, hideButton: hideButton, isFieldEditable: isFieldEditable, manualSave: manualSave, onCancel: onCancel, onSave: onSave, onSaveError: onSaveError, onValidate: onValidate }) {
    const formRef = (0, $acw62.useRef)(null);
    const [saveState, setSaveState] = (0, $acw62.useState)($a6db0417d7b66a9b$var$EditGroupSaveState.noChange);
    const submit = (0, $acw62.useCallback)(async (e)=>{
        var _a, _b;
        if (e.preventDefault) e.preventDefault();
        const target = formRef.current;
        if (!target) return;
        const data = new FormData(target);
        const values = editableFields ? $a6db0417d7b66a9b$export$66cf394dfb34aaef.formValues(data, "", editableFields, isFieldEditable) : {};
        setSaveState($a6db0417d7b66a9b$var$EditGroupSaveState.saving);
        // Clear any error left over from a previous failed save before this attempt --
        // otherwise a stale "rejected" message could linger through a subsequent retry
        // that hasn't resolved yet (or has since succeeded).
        onSaveError === null || onSaveError === void 0 || onSaveError(undefined);
        try {
            const result = await onSave(data, values);
            if (result == true) (_a = formRef.current) === null || _a === void 0 || _a.reset();
            setSaveState($a6db0417d7b66a9b$var$EditGroupSaveState.saved);
        } catch (saveError) {
            // Revert the whole form on a rejected save. `isFieldEditable` (above) already
            // keeps every currently non-editable field out of `values` on the normal
            // path, and `logs.update`/`days.update` now silently drop any disallowed
            // field rather than rejecting the request (issue #1142), so this only fires
            // for a genuine failure (network, auth, server error, ...) -- not for an
            // edit-permissiveness rejection. Still reset on any failure so the user's
            // on-screen edit never looks "saved" when it wasn't, and so EditGroup's own
            // auto-resubmit effect below doesn't retry the same failing save forever,
            // since nothing else here clears `changed`.
            (_b = formRef.current) === null || _b === void 0 || _b.reset();
            setSaveState($a6db0417d7b66a9b$var$EditGroupSaveState.failed);
            onSaveError === null || onSaveError === void 0 || onSaveError(saveError);
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(saveError);
        }
    }, [
        editableFields,
        formRef,
        isFieldEditable,
        onSave,
        onSaveError
    ]);
    const button = editable && changed && !hideButton && (0, $7b02d682eb115277$exports.jsx)("button", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "EditGroup-save-button",
            manualSave ? "enter" : "refresh"
        ]),
        children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
            icon: manualSave ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Enter : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Refresh
        })
    });
    (0, $acw62.useEffect)(()=>{
        if (changed && saveState != $a6db0417d7b66a9b$var$EditGroupSaveState.saving && !manualSave) submit(new SubmitEvent("submit", {
            submitter: formRef.current
        })).catch((error)=>{
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
        });
        else if (changed && manualSave && onValidate && formRef.current) {
            const data = new FormData(formRef.current);
            const values = editableFields ? $a6db0417d7b66a9b$export$66cf394dfb34aaef.formValues(data, "", editableFields, isFieldEditable) : {};
            onValidate(data, values);
        }
    }, [
        changed,
        formRef,
        saveState,
        manualSave,
        editableFields,
        isFieldEditable
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            `EditGroup`,
            className
        ]),
        children: (0, $7b02d682eb115277$exports.jsxs)("form", {
            ref: formRef,
            onSubmit: submit,
            children: [
                error && (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "block-row",
                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "block-field error-message",
                        children: error
                    })
                }),
                buttonFirst && button,
                children,
                !buttonFirst && button,
                editing != false && onCancel && (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                    onClick: onCancel
                })
            ]
        })
    });
}






var $acw62 = parcelRequire("acw62");

function $e8a41dd33c25a5c0$export$909904bdb4cb4458({ className: className, type: type, defaultValue: defaultValue, name: name, placeholder: placeholder, readOnly: readOnly, disabled: disabled, onChange: onChange, required: required, suggestions: suggestions, id: id }) {
    const [selected, setSelected] = (0, $acw62.useState)(false);
    const [value, setValue] = (0, $acw62.useState)(defaultValue ? defaultValue.toString() : "");
    const inputRef = (0, $acw62.useRef)(null);
    // `AutocompleteInput` is a controlled component (its displayed value comes from
    // this `value` state, not the DOM), so `EditGroup`'s save-rejection handler
    // (issue #529) calling `formRef.current?.reset()` -- which only auto-reverts plain
    // uncontrolled `<input defaultValue>` elements -- has no effect on it by default.
    // Listen for the enclosing form's native `reset` event directly and resync back to
    // `defaultValue` ourselves.
    (0, $acw62.useEffect)(()=>{
        var _a;
        const form = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.form;
        if (!form) return;
        const onReset = ()=>setValue(defaultValue ? defaultValue.toString() : "");
        form.addEventListener("reset", onReset);
        return ()=>form.removeEventListener("reset", onReset);
    }, [
        defaultValue
    ]);
    // `defaultValue` only seeds `value` on mount -- without this, an externally
    // updated value (e.g. a realtime WS broadcast patching the underlying model
    // while this field is mounted, see `Tests/E2E/companion-connect-sync.spec.ts`)
    // is silently dropped. Skip the resync while the field is focused/selected so
    // an in-progress edit isn't clobbered out from under the user.
    (0, $acw62.useEffect)(()=>{
        if (selected) return;
        setValue(defaultValue ? defaultValue.toString() : "");
    }, [
        defaultValue
    ]);
    const onChangeHandler = (0, $acw62.useCallback)((e)=>{
        const value = e.target.value;
        setValue(value);
        if (onChange) onChange(e);
    }, [
        setValue,
        onChange
    ]);
    const onBlur = (0, $acw62.useCallback)(()=>{
        setSelected(false);
    }, [
        setSelected
    ]);
    const onFocus = (0, $acw62.useCallback)(()=>{
        setSelected(true);
    }, [
        setSelected
    ]);
    const input = (0, $7b02d682eb115277$exports.jsx)("input", {
        className: className,
        id: id,
        type: type,
        value: value,
        name: name,
        placeholder: placeholder,
        onBlur: onBlur,
        onChange: onChangeHandler,
        onFocus: onFocus,
        disabled: disabled,
        readOnly: readOnly,
        required: required,
        ref: inputRef
    });
    if (readOnly) return input;
    return (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "AutocompleteInput",
            selected && "selected"
        ]),
        children: [
            suggestions && suggestions.length > 0 && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "AutocompleteInput-options-container",
                children: (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "AutocompleteInput-options",
                    children: suggestions.map((suggestion, index)=>{
                        if (suggestion == value) return;
                        return (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "AutocompleteInput-option",
                            onMouseDown: ()=>{
                                setValue(suggestion);
                                setSelected(false);
                                if (onChange) onChange({
                                    target: {
                                        value: suggestion
                                    }
                                });
                            },
                            children: suggestion
                        }, `suggestion-${index}`);
                    }).filter(Boolean)
                })
            }),
            input
        ]
    });
}
const $e8a41dd33c25a5c0$export$baf105894146f5ab = {
    sanitize (raw, format, decimalPoint) {
        let v = raw.replace(/[^0-9.,]/g, "");
        if (format == "int") v = v.replaceAll(".", "").replaceAll(",", "");
        else if (decimalPoint == ",") {
            v = v.replace(".", "");
            v = v.replaceAll(/(,.*),/g, "$1");
        } else {
            v = v.replace(",", "");
            v = v.replaceAll(/(\..*)\./g, "$1");
        }
        return v;
    },
    signedValue (sanitized, format, sign) {
        if (sanitized == "") return 0;
        const magnitude = format == "int" ? parseInt(sanitized) : parseFloat(sanitized.replace(",", "."));
        return magnitude * (sign == false ? -1 : 1);
    },
    isValid (signedValue, validInputs) {
        return !validInputs || validInputs.indexOf(signedValue) >= 0;
    }
};
function $e8a41dd33c25a5c0$export$6bf0cd3a219bbade({ format: format, className: className, type: type, defaultValue: defaultValue, maxLength: maxLength, name: name, placeholder: placeholder, readOnly: readOnly, disabled: disabled, onChange: onChange, sign: sign, validInputs: validInputs, style: style, unit: unit, id: id }) {
    const decimalPoint = (0, $acw62.useMemo)(()=>1.1.toLocaleString(navigator.language).substr(1, 1), []);
    const formattedDefaultValue = (0, $acw62.useMemo)(()=>decimalPoint == "," && format == "float" && defaultValue && defaultValue.toString().replaceAll(".", ","), [
        decimalPoint,
        defaultValue
    ]);
    const [value, setValue] = (0, $acw62.useState)(formattedDefaultValue || (defaultValue != undefined ? defaultValue.toString() : ""));
    const [focused, setFocused] = (0, $acw62.useState)(false);
    // Same rationale as `AutocompleteInput`'s resync effect above: `defaultValue`
    // only seeds `value` on mount, so an externally updated value is otherwise
    // silently dropped while this field stays mounted. Skip while focused so an
    // in-progress edit isn't clobbered.
    (0, $acw62.useEffect)(()=>{
        if (focused) return;
        setValue(formattedDefaultValue || (defaultValue != undefined ? defaultValue.toString() : ""));
    }, [
        defaultValue,
        formattedDefaultValue
    ]);
    const onChangeHandler = (0, $acw62.useCallback)((e)=>{
        const originalValue = value;
        const newValue = $e8a41dd33c25a5c0$export$baf105894146f5ab.sanitize(e.target.value, format, decimalPoint);
        const signedValue = $e8a41dd33c25a5c0$export$baf105894146f5ab.signedValue(newValue, format, sign);
        if (!$e8a41dd33c25a5c0$export$baf105894146f5ab.isValid(signedValue, validInputs)) {
            setValue(originalValue);
            return;
        }
        setValue(newValue);
        if (onChange) onChange(e);
    }, [
        decimalPoint,
        format,
        setValue,
        value
    ]);
    const onFocus = (0, $acw62.useCallback)(()=>setFocused(true), [
        setFocused
    ]);
    const onBlur = (0, $acw62.useCallback)(()=>setFocused(false), [
        setFocused
    ]);
    // The unit rides along on the field's own value rather than on an extra element,
    // so a unit field occupies exactly one grid cell and cannot wrap away from the
    // number it belongs to. Form submission is unaffected: `EditGroup.convertInput`
    // parses with `parseInt`/`parseFloat`, which stop at the suffix.
    // A degree sign sits tight against the number (`300°`); every other unit is a
    // word-like abbreviation and takes a space (`30 m`).
    const displayValue = unit && !focused && value != "" ? `${value}${unit == "\xb0" ? "" : " "}${unit}` : value;
    const input = (0, $7b02d682eb115277$exports.jsx)("input", {
        className: className,
        id: id,
        type: type,
        inputMode: format == "int" ? "numeric" : format == "float" ? "decimal" : undefined,
        value: displayValue,
        maxLength: maxLength,
        name: name,
        placeholder: placeholder,
        onChange: onChangeHandler,
        onFocus: onFocus,
        onBlur: onBlur,
        style: style,
        disabled: disabled,
        readOnly: readOnly
    });
    return input;
}




var $acw62 = parcelRequire("acw62");



function $d5eb93924f70e37c$export$ef9b1a59e592288f({ button: button, customValue: customValue, emptyText: emptyText, name: name, onSelect: onSelect, options: options, readOnly: readOnly, title: title, value: value, className: className, initOpen: initOpen }) {
    const customValueRef = (0, $acw62.useRef)(null);
    const [selected, setSelected] = (0, $acw62.useState)(initOpen !== null && initOpen !== void 0 ? initOpen : false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const select = (0, $acw62.useCallback)((value)=>{
        onSelect(value);
        setSelected(false);
    }, [
        onSelect
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "Select",
            selected && "selected",
            readOnly && "readOnly",
            className
        ]),
        children: [
            name && (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "hidden",
                name: name,
                value: value
            }),
            !readOnly && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Select-options-container",
                children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "Select-options",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                            onClick: ()=>setSelected(false)
                        }, "close"),
                        options.map((option)=>{
                            if (option) return (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                                    "Select-option",
                                    option.disabled && "disabled",
                                    option.className
                                ]),
                                "data-value": option.value,
                                onClick: ()=>!option.disabled && select(option.value),
                                children: [
                                    option.icon && (typeof option.icon == "string" ? (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                        icon: option.icon
                                    }) : option.icon),
                                    option.title
                                ]
                            }, `option-${option.value}`);
                            return;
                        }),
                        emptyText && options.length < 1 && !customValue && (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "Select-option Select-option-empty disabled",
                            children: emptyText
                        }),
                        customValue && (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "Select-option Select-option-custom",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                    className: "Select-custom-value-button",
                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Enter,
                                    onClick: ()=>{
                                        var _a;
                                        return select((_a = customValueRef.current) === null || _a === void 0 ? void 0 : _a.value);
                                    }
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    className: "Select-custom-value",
                                    placeholder: customValue,
                                    ref: customValueRef
                                })
                            ]
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "button",
                onClick: ()=>!readOnly && setSelected(!selected),
                title: title,
                children: button
            })
        ]
    });
}





function $600b78128ceeb0f6$export$98e9a0bb257361e9(day) {
    return new Date(Date.UTC(2001, 0, 1) + day * 86400000);
}
const $600b78128ceeb0f6$export$6ac9c96d08ad2ff5 = {
    loadLogs (api, shipId, dayId) {
        return new (0, $199ead3c99f138be$export$89c3ec6dea3c6061)(api).logs.list({
            params: {
                shipId: shipId,
                dayId: dayId
            }
        }).call();
    },
    loadDayTrack (api, shipId, dayId) {
        return new (0, $655725c259161537$export$2f8f7bdb7e386612)(api).tracks.day({
            params: {
                shipId: shipId,
                dayId: dayId
            }
        }).call();
    },
    // Saturday/Sunday get a weekend highlight; the 1st of a month gets a month highlight.
    isWeekend (date) {
        return date.getDay() == 0 || date.getDay() == 6;
    },
    monthHighlight (date) {
        return date.getDate() == 1;
    },
    // The detail panel shows when the day is expanded, is the current day, is
    // tomorrow while selected, or is a blank/backfilled day (#1137 -- a day with no
    // Day row yet always opens straight to its detail panel). The timeline shows
    // whenever the detail panel is hidden, additionally on the current day unless
    // the caller hid it, and always for a blank day (so its empty "No logs" strip
    // renders alongside the detail panel rather than the two being exclusive).
    showDetail (details, isCurrentDay, isTomorrow, selected, blank) {
        return blank || details || isCurrentDay || isTomorrow && selected;
    },
    showTimeline (showDetail, isCurrentDay, hideTimeline, blank) {
        return blank || !showDetail || isCurrentDay && !hideTimeline;
    }
};




const $e000d4a262f1f979$export$2f67d0286afccddd = {
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).depth]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).engineRpms]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).heading]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).humidity]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).log]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).pressure]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).stw]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).temperature]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).windDirection]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).windSpeed]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).course]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).sog]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).distance]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).locked,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).comment]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).always,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).currentDirection]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).always,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).currentSpeed]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).always,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).location]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).always,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).seaState]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).always,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).watch]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).always,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).watchComment]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).always,
    [(0, $8cadfca9ff813a6b$export$e1325bf74d86b103).weather]: (0, $8cadfca9ff813a6b$export$19114abfe69433ac).always
};
const $e000d4a262f1f979$export$90fc040215d8b45a = 3600;
function $e000d4a262f1f979$export$64683e60815f436d(field, level, nmeaProtected, withinEditableWindow) {
    if ($e000d4a262f1f979$export$2f67d0286afccddd[field] == (0, $8cadfca9ff813a6b$export$19114abfe69433ac).always) return true;
    if ($e000d4a262f1f979$export$2f67d0286afccddd[field] == (0, $8cadfca9ff813a6b$export$19114abfe69433ac).locked) return false;
    switch(level){
        case (0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).strict:
            return (field == (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).engineRpms || withinEditableWindow) && !nmeaProtected;
        case (0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).extended:
            return !nmeaProtected;
        case (0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).unrestricted:
            return true;
    }
}
function $e000d4a262f1f979$export$4ef718938ed6349c(log, logs) {
    const nmeaAuto = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed.nmeaAuto || false;
    return !logs.some((sibling)=>sibling.id > log.id && ((0, $1746073b9b284418$export$ce30dbb46644d06c).parse(sibling).dataParsed.nmeaAuto || false) == nmeaAuto);
}
function $e000d4a262f1f979$export$847022fe3acc4983(log, logs, now, forceEditable = false) {
    return $e000d4a262f1f979$export$4ef718938ed6349c(log, logs) && (forceEditable || now - log.timeUtc < $e000d4a262f1f979$export$90fc040215d8b45a);
}
function $e000d4a262f1f979$export$e66ccfcb2c570a12(field, log, auditLogEdits) {
    if ($e000d4a262f1f979$export$2f67d0286afccddd[field] != (0, $8cadfca9ff813a6b$export$19114abfe69433ac).nmeaCapable) return false;
    const nmeaFields = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed.nmeaFields || [];
    if (nmeaFields.indexOf(field) < 0) return false;
    return !auditLogEdits.some((edit)=>edit.logId == log.id && edit.field == field);
}
function $e000d4a262f1f979$export$c4d316b0f08548e5(field, log, logs, auditLogEdits, level, now, forceEditable = false) {
    const nmeaProtected = $e000d4a262f1f979$export$e66ccfcb2c570a12(field, log, auditLogEdits);
    const withinEditableWindow = $e000d4a262f1f979$export$847022fe3acc4983(log, logs, now, forceEditable);
    return $e000d4a262f1f979$export$64683e60815f436d(field, level, nmeaProtected, withinEditableWindow);
}
const $e000d4a262f1f979$export$d33a69e2aea49187 = {
    [(0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).strict]: true,
    [(0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).extended]: true,
    [(0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).unrestricted]: false
};
function $e000d4a262f1f979$export$d781a0190b3420e7(level) {
    var _a;
    return (_a = $e000d4a262f1f979$export$d33a69e2aea49187[level]) !== null && _a !== void 0 ? _a : true;
}



function $234930b26df9c152$export$25ebc11b9fac23e1(status, logId) {
    if (status.deletedAt != undefined) return false;
    if (logId <= 0) return status.endLogId == undefined;
    // `startLogId == 0` marks a day-rollover continuation (see `Status.resolveInterval`),
    // which covers every log of the day -- handled by the same comparison.
    return status.startLogId <= logId && (status.endLogId == undefined || logId < status.endLogId);
}
function $234930b26df9c152$export$93a873645497d52c(statuses, logId) {
    return (statuses || []).filter((s)=>$234930b26df9c152$export$25ebc11b9fac23e1(s, logId));
}
function $234930b26df9c152$export$738727f375798cb(statuses, logId, name) {
    let latest;
    for (const status of statuses !== null && statuses !== void 0 ? statuses : []){
        if (name != undefined && status.name != name || !$234930b26df9c152$export$25ebc11b9fac23e1(status, logId)) continue;
        // A real start supersedes a rollover continuation, even when its closing
        // update has not arrived yet. IDs break equal-boundary ties independently of
        // HTTP response or websocket arrival order.
        if (!latest || status.startLogId > latest.startLogId || status.startLogId === latest.startLogId && status.id > latest.id) latest = status;
    }
    return latest;
}
function $234930b26df9c152$export$2baff4ea56c462f4(statuses, logId) {
    return $234930b26df9c152$export$738727f375798cb(statuses === null || statuses === void 0 ? void 0 : statuses.filter((status)=>status.statusType === (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship), logId);
}
function $234930b26df9c152$var$dayShipStatuses(day, statuses) {
    return (statuses !== null && statuses !== void 0 ? statuses : []).filter((status)=>status.shipId === day.shipId && status.dayId === day.id && status.statusType === (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship && status.deletedAt == undefined).sort((a, b)=>a.startLogId - b.startLogId || a.id - b.id);
}
function $234930b26df9c152$export$97f2a12b532d96e3(day, statuses, logs) {
    var _a;
    const shipStatuses = $234930b26df9c152$var$dayShipStatuses(day, statuses);
    const latest = shipStatuses[shipStatuses.length - 1];
    const dayLogs = (logs !== null && logs !== void 0 ? logs : []).filter((log)=>log.shipId === day.shipId && log.dayId === day.id && log.id > 0 && log.discardedAt == undefined);
    const deletedStarts = new Set((statuses !== null && statuses !== void 0 ? statuses : []).filter((status)=>status.shipId === day.shipId && status.dayId === day.id && status.statusType === (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship && status.deletedAt != undefined).map((status)=>status.startLogId));
    const boundary = latest ? Math.max(latest.startLogId, (_a = latest.endLogId) !== null && _a !== void 0 ? _a : latest.startLogId) : 0;
    const explicit = dayLogs.filter((log)=>{
        var _a;
        return log.id >= boundary && log.id > ((_a = latest === null || latest === void 0 ? void 0 : latest.startLogId) !== null && _a !== void 0 ? _a : 0);
    }).filter((log)=>!deletedStarts.has(log.id) || shipStatuses.some((status)=>status.startLogId === log.id)).sort((a, b)=>b.id - a.id).map((0, $1746073b9b284418$export$ce30dbb46644d06c).parse).find((log)=>log.dataParsed.shipStatus != undefined);
    if ((explicit === null || explicit === void 0 ? void 0 : explicit.dataParsed.shipStatus) != undefined) return explicit.dataParsed.shipStatus;
    if (!latest) return (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none;
    if (latest.endLogId == undefined) return latest.value;
    if (latest.endLogId <= latest.startLogId || latest.endLogId <= 0) return (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none;
    const closing = dayLogs.find((log)=>log.id === latest.endLogId);
    if (!closing) return (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none;
    const metadata = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(closing).dataParsed;
    const technical = metadata.type === (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).nmeaConnection && (metadata.nmeaConnection === (0, $c931aad0bd934103$export$c50f5cf960171685).on || metadata.nmeaConnection === (0, $c931aad0bd934103$export$c50f5cf960171685).off) || metadata.type === (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).navigationStatus && metadata.navigationStatus === (0, $c931aad0bd934103$export$c50f5cf960171685).off;
    return technical ? latest.value : (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none;
}
function $234930b26df9c152$export$be23039be03416bb(day, statuses, logs) {
    var _a, _b;
    const shipStatuses = $234930b26df9c152$var$dayShipStatuses(day, statuses);
    const dayStatus = shipStatuses.some((status)=>status.value === (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).inmotion) ? (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).inmotion : (_b = (_a = shipStatuses[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none;
    return {
        dayStatus: dayStatus,
        overnightStatus: dayStatus === (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).inmotion ? $234930b26df9c152$export$97f2a12b532d96e3(day, statuses, logs) : (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none
    };
}
function $234930b26df9c152$export$af703b2ef478551f(status, statuses, logId) {
    if (status.statusType != (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).sails || status.endLogId != logId) return false;
    // A replacement both opens here and is still up afterwards. `endLogId != logId` also
    // excludes `status` itself without relying on object identity.
    return (statuses || []).some((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).sails && s.name == status.name && s.startLogId == logId && s.endLogId != logId);
}
function $234930b26df9c152$export$fe8e26d7a5865a81(statuses, logId) {
    return (statuses || []).filter((s)=>!$234930b26df9c152$export$af703b2ef478551f(s, statuses, logId));
}
function $234930b26df9c152$export$26d0b00d6820c0a(statuses, logId) {
    return (statuses || []).some((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).manualShipStatus && $234930b26df9c152$export$25ebc11b9fac23e1(s, logId));
}
function $234930b26df9c152$export$591cee21f508cff(engineRpms, n, status, thresholds) {
    if (status != undefined) return true;
    const rpm = engineRpms === null || engineRpms === void 0 ? void 0 : engineRpms[n];
    if (rpm == undefined || rpm <= 0) return false;
    return (thresholds === null || thresholds === void 0 ? void 0 : thresholds.engineStop) == undefined || rpm > thresholds.engineStop;
}
function $234930b26df9c152$export$3a4fce362f474d01(statuses, status) {
    if (status == undefined || status.deletedAt != undefined) return undefined;
    const all = (statuses || []).filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).engine && s.deletedAt == undefined && s.shipId == status.shipId && s.dayId == status.dayId && s.item == status.item && s.name == status.name);
    let current = status;
    for(let i = 0; i < all.length; i++){
        if (current.startLogId <= 0) return current;
        const previous = all.find((s)=>s.id != current.id && s.endLogId == current.startLogId);
        if (previous == undefined) return current;
        current = previous;
    }
    return current;
}
function $234930b26df9c152$export$cb487750e5f23d1f(thresholds) {
    if (!(thresholds === null || thresholds === void 0 ? void 0 : thresholds.engineIdleRpmEnabled)) return false;
    return thresholds.engineStop < thresholds.engineStart && thresholds.engineStart < thresholds.engineIdleRpm;
}
function $234930b26df9c152$export$479f26c6e67c2e2f(engineRpms, n, status, thresholds) {
    if (status != undefined) return status.value == (0, $7045b0c2c870ef8a$export$e0db0830eb9f13ff).idle;
    if (!$234930b26df9c152$export$cb487750e5f23d1f(thresholds)) return false;
    const rpm = engineRpms === null || engineRpms === void 0 ? void 0 : engineRpms[n];
    return rpm != undefined && rpm < thresholds.engineIdleRpm;
}


// Live current value for a `DayEditableField`, used by `computeEditHistory` (issue
// #529) to resolve the "new value" of each field's most recent edit -- every field
// maps 1:1 to a `Day` property.
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
function $a95e9f26ea4eb186$var$currentDayFieldValue(day, field) {
    switch(field){
        case "comment":
        case "crew":
        case "endLocation":
        case "passengers":
        case "skipper":
        case "startLocation":
            return day[field];
        default:
            return undefined;
    }
}
const $a95e9f26ea4eb186$export$ae0f322ce9dc73a9 = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    updateDay (api, shipId, dayId, values) {
        return new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(api).days.update({
            params: {
                shipId: shipId,
                dayId: dayId
            },
            body: values
        }).call();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    createDay (api, shipId, tripId, values) {
        return new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(api).days.create({
            params: {
                shipId: shipId,
                tripId: tripId
            },
            body: values
        }).call();
    },
    loadLocationAutocomplete (api, shipId) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.autocomplete({
            params: {
                shipId: shipId,
                field: "location"
            }
        }).call();
    },
    loadDayCommentAutocomplete (api, shipId) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.autocomplete({
            params: {
                shipId: shipId,
                field: "dayComment"
            }
        }).call();
    },
    // #1137: the most recent persisted ("real") day strictly before `day` within the
    // trip's day list -- the source for a blank/backfilled day's carried-forward
    // status. `undefined` when there is no earlier real day (e.g. the trip's very
    // first day has zero logs).
    previousRealDay (days, day) {
        return days.filter((d)=>d.id > 0 && d.day < day.day).sort((a, b)=>b.day - a.day)[0];
    },
    // #1137: the ship's resting status to carry into a blank day -- its most recent
    // preceding real day's last recorded ship status (statuses are stored
    // chronologically), or `.none` if that day itself recorded no ship statuses.
    carriedForwardStatus (shipStatuses) {
        const retained = shipStatuses === null || shipStatuses === void 0 ? void 0 : shipStatuses.filter((status)=>status.deletedAt == undefined);
        const lastStatus = retained === null || retained === void 0 ? void 0 : retained[retained.length - 1];
        return lastStatus ? lastStatus.value : (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none;
    },
    /**
     * Converts an absolute `Date` field from the stored calculation (typegen'd as an
     * ISO8601 string, e.g. `calculated.sunrise`/`.sunset`) into the ship-local clock time
     * — the numeric "seconds since the reference date" value the `"timeUtc"` format
     * expects (issue #67).
     */ sunTimeValue (iso, timezone) {
        if (!iso) return undefined;
        return ((0, $14a8bda8b42de2c4$export$63afb81dba78b33e)(iso).valueOf() - (0, $14a8bda8b42de2c4$export$4334e0aa46d23a16)) / 1000 + timezone;
    },
    // Per-field value formatters for the Day fields that carry a raw shipUserId (issue
    // #529): `skipper`/`crew`/`passengers` resolve to the matching ship user's display
    // name via `ShipUserSelectData.userLabel` -- the exact convention `ShipUserSelect`
    // itself uses -- so `EditHistory`'s previous/new values show a name, not a bare id.
    // `comment`/`startLocation`/`endLocation` have no entry: they're plain text, already
    // correctly shown as-is by `EditHistory`'s generic fallback.
    fieldFormat (shipUsers) {
        const userLabel = (0, $14a8bda8b42de2c4$export$2f84fdd660581d7f)((value)=>typeof value === "number", (id)=>{
            const user = shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.find((u)=>u.id == id);
            return user ? (0, $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a).userLabel(user) : "\u2013";
        });
        const userList = (0, $14a8bda8b42de2c4$export$2f84fdd660581d7f)((value)=>Array.isArray(value), (ids)=>ids.length > 0 ? ids.map((id)=>userLabel(id)).join(", ") : "\u2013");
        return {
            crew: userList,
            passengers: userList,
            skipper: userLabel
        };
    }
};
function $a95e9f26ea4eb186$export$8fd21e5060e97e29({ day: day, editable: editable, isCurrentDay: isCurrentDay, isFirstTripDay: _isFirstTripDay, isTomorrow: isTomorrow, initEditHistoryOpen: initEditHistoryOpen, initSaveError: initSaveError, previousDay: previousDay }) {
    var _a, _b, _c;
    const startLocationId = (0, $acw62.useId)();
    const endLocationId = (0, $acw62.useId)();
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("DayEditView");
    const { auditLogEdits: auditLogEdits, logs: logs, recordAuditLogEdits: recordAuditLogEdits, recordSavedDay: recordSavedDay, statuses: statuses, updateDay: updateDay, createDay: createDay } = (0, $97ac05743b787a86$export$95d65094202e15e7)();
    const { trip: trip, days: days } = (0, $97ac05743b787a86$export$e205ea882cbd693e)();
    const { cruise: cruise } = (0, $97ac05743b787a86$export$135b8b9ecdd62154)();
    const shipView = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    const [autocompleteLocations, setAutocompleteLocations] = (0, $acw62.useState)(undefined);
    const _currentDay = ((_a = app.current) === null || _a === void 0 ? void 0 : _a.day) && day.day == ((_b = app.current) === null || _b === void 0 ? void 0 : _b.day);
    const [autocompleteDayComment, setAutocompleteDayComment] = (0, $acw62.useState)(undefined);
    const cruiseCalculated = cruise === null || cruise === void 0 ? void 0 : cruise.calculated;
    // #1137: a genuinely blank/backfilled day -- no Day row exists, and it's neither
    // today's not-yet-created bootstrap day nor tomorrow's placeholder (both of which
    // also start with `!day.id` but keep today's existing editable behavior). The Day
    // tab is fully read-only for a blank day, stronger than plain `editable={false}`,
    // since `alwaysEditable` would otherwise still let comment/location fields through.
    const blank = !day.id && !isCurrentDay && !isTomorrow;
    const alwaysEditableFields = [
        "comment",
        {
            name: "endLocation",
            type: "string",
            default: ""
        },
        {
            name: "startLocation",
            type: "string",
            default: ""
        }
    ];
    const limitedEditableFields = [
        {
            name: "crew",
            array: true,
            type: "int"
        },
        {
            name: "day",
            type: "int"
        },
        {
            name: "passengers",
            array: true,
            type: "int"
        },
        {
            name: "skipper",
            type: "int"
        }
    ];
    const editableFields = [
        ...alwaysEditableFields,
        ...limitedEditableFields
    ];
    const formEditable = !blank && app.editable && editable && (isCurrentDay || isTomorrow);
    const alwaysEditable = !blank && (app.editable || shipView.shipCloudEditable);
    const { edited: edited, onEdited: onEdited, saveEdits: saveEdits, saveError: saveError, onSaveError: onSaveError } = (0, $58cbd7a8fa422027$export$d3b8d51a855c78a3)({
        isNew: !day.id,
        initSaveError: initSaveError,
        update: async (values)=>{
            const result = await updateDay(values);
            if (result === null || result === void 0 ? void 0 : result.auditLogEdits) recordAuditLogEdits(result.auditLogEdits);
            // Issue #1136: `day` itself is owned above this view and only refreshes on the
            // next live broadcast / full day load, so the response's authoritative row is
            // kept here too -- otherwise the edit history below resolves the field just
            // saved from the pre-edit snapshot. Only read for that resolution; the form's
            // own (uncontrolled) inputs keep what the user typed.
            if (result === null || result === void 0 ? void 0 : result.day) recordSavedDay === null || recordSavedDay === void 0 || recordSavedDay(result.day);
            return result;
        },
        create: (values)=>createDay(values)
    });
    // `DayEditableField`s are all `.always` (`allowsDayFieldEdit` is unconditionally
    // `true` -- Day has no NMEA-capable fields), so `days.update` never actually
    // rejects a field; this only ever surfaces the generic fallback (network/other
    // failures), not a field-specific rejection message.
    const saveErrorText = (0, $acw62.useMemo)(()=>(0, $a6db0417d7b66a9b$export$3b04090cc2c1b2d)(saveError, {}, {
            fields: ()=>t("save_error_generic"),
            generic: t("save_error_generic")
        }), [
        saveError,
        t
    ]);
    // Edit history (issue #529): this day's own `AuditLogEdit` rows (`sourceType ==
    // day`, matched via `sourceId`) out of `DayContext.auditLogEdits` -- a flat list
    // shared with the Log/Status edit-history data, since `AuditLogEdit` isn't
    // `sourceId`-namespaced per record kind on its own.
    const dayAuditLogEdits = (0, $acw62.useMemo)(()=>{
        return auditLogEdits.filter((e)=>e.sourceType == (0, $1e7307a9deb5d870$export$6322af8f4e594d6e).day && e.sourceId == day.id);
    }, [
        auditLogEdits,
        day.id
    ]);
    const editHistory = (0, $acw62.useMemo)(()=>{
        return (0, $59aa08b9185fbe21$export$a93b69c9d9000d40)(dayAuditLogEdits, (field)=>$a95e9f26ea4eb186$var$currentDayFieldValue(day, field));
    }, [
        dayAuditLogEdits,
        day
    ]);
    const lastEditor = (0, $acw62.useMemo)(()=>{
        if (editHistory.length < 1) return undefined;
        return shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.find((u)=>u.id == editHistory[0].shipUserId);
    }, [
        editHistory,
        shipUsers
    ]);
    // Every `DayEditableField` already has its own single-field translation key
    // (unlike Log, which needed 2 new ones) -- just map the field name to its
    // existing snake_case key.
    const fieldLabels = {
        comment: t("comment"),
        crew: t("crew"),
        endLocation: t("end_location"),
        passengers: t("passengers"),
        skipper: t("skipper"),
        startLocation: t("start_location")
    };
    const fieldLabel = (field)=>{
        var _a;
        return (_a = fieldLabels[field]) !== null && _a !== void 0 ? _a : field;
    };
    const editHistoryFieldFormat = (0, $acw62.useMemo)(()=>$a95e9f26ea4eb186$export$ae0f322ce9dc73a9.fieldFormat(shipUsers), [
        shipUsers
    ]);
    // Edit History visibility (issue #1169): a code-level policy, not a ship
    // setting -- `.unrestricted` already discards the field-level protections that
    // give the audit trail its evidentiary value, so the table (but not the "last
    // edited" line itself) is hidden at that level. See `Log/editability.ts`.
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const editPermissivenessLevel = (_c = (0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship).editPermissiveness) !== null && _c !== void 0 ? _c : (0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).strict;
    const editHistoryVisible = (0, $e000d4a262f1f979$export$d781a0190b3420e7)(editPermissivenessLevel);
    const [editHistoryOpen, setEditHistoryOpen] = (0, $acw62.useState)(initEditHistoryOpen !== null && initEditHistoryOpen !== void 0 ? initEditHistoryOpen : false);
    (0, $acw62.useEffect)(()=>{
        const load = async ()=>{
            if (!autocompleteLocations) {
                const locationData = await $a95e9f26ea4eb186$export$ae0f322ce9dc73a9.loadLocationAutocomplete(app.apiClient, day.shipId);
                setAutocompleteLocations((locationData === null || locationData === void 0 ? void 0 : locationData.values) || []);
            }
            if (!autocompleteDayComment) {
                const dayCommentData = await $a95e9f26ea4eb186$export$ae0f322ce9dc73a9.loadDayCommentAutocomplete(app.apiClient, day.shipId);
                setAutocompleteDayComment((dayCommentData === null || dayCommentData === void 0 ? void 0 : dayCommentData.values) || []);
            }
        };
        load().catch(console.error);
    }, [
        day,
        autocompleteLocations,
        autocompleteDayComment
    ]);
    const dayStatusOptions = (0, $acw62.useMemo)(()=>{
        return [];
    }, [
        t
    ]);
    // #1137: a blank day has no logs of its own, so it never has its own statuses --
    // fetch the most recent preceding real day's instead, so the carried-forward
    // status computed below has something to carry forward from.
    const previousRealDay = (0, $acw62.useMemo)(()=>{
        return blank ? $a95e9f26ea4eb186$export$ae0f322ce9dc73a9.previousRealDay(days, day) : undefined;
    }, [
        days,
        day,
        blank
    ]);
    const [previousDayStatuses, setPreviousDayStatuses] = (0, $acw62.useState)(undefined);
    (0, $acw62.useEffect)(()=>{
        if (!previousRealDay) {
            setPreviousDayStatuses(undefined);
            return;
        }
        const load = async ()=>{
            const data = await (0, $600b78128ceeb0f6$export$6ac9c96d08ad2ff5).loadLogs(app.apiClient, previousRealDay.shipId, previousRealDay.id);
            setPreviousDayStatuses(data.statuses);
        };
        load().catch(console.error);
    }, [
        previousRealDay
    ]);
    const shipStatuses = (0, $acw62.useMemo)(()=>{
        const source = blank ? previousDayStatuses : statuses;
        return source === null || source === void 0 ? void 0 : source.filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship && s.deletedAt == undefined);
    }, [
        statuses,
        previousDayStatuses,
        blank,
        day
    ]);
    const statusButton = (0, $acw62.useCallback)((status)=>{
        const statusName = (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[status];
        if (status == (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none) return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: app.t(`LogNavigationView_status_${statusName}`)
        });
        return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                    className: "DayEditView-status-icon",
                    icon: `status-${statusName}`
                }),
                " ",
                app.t(`LogNavigationView_status_${statusName}`)
            ]
        });
    }, []);
    const { dayStatus: dayStatus, overnightStatus: overnightStatus } = (0, $acw62.useMemo)(()=>{
        // #1137: a blank day shows the status carried forward from the closest
        // preceding real day, rather than deriving anything from its own (nonexistent)
        // statuses.
        if (blank) {
            const carried = $a95e9f26ea4eb186$export$ae0f322ce9dc73a9.carriedForwardStatus(shipStatuses);
            return {
                dayStatus: carried,
                overnightStatus: carried
            };
        }
        return (0, $234930b26df9c152$export$be23039be03416bb)(day, statuses, logs);
    }, [
        day,
        statuses,
        shipStatuses,
        logs,
        blank
    ]);
    const dayStatusButton = (0, $acw62.useMemo)(()=>{
        return statusButton(dayStatus);
    }, [
        dayStatus
    ]);
    const overnightStatusButton = (0, $acw62.useMemo)(()=>{
        return statusButton(overnightStatus);
    }, [
        overnightStatus
    ]);
    const crewPriorityIds = (0, $acw62.useMemo)(()=>{
        if (cruiseCalculated) return [
            ...cruiseCalculated.crew || [],
            ...cruiseCalculated.skippers || []
        ];
        return undefined;
    }, [
        cruise
    ]);
    const persistedSkipper = (0, $acw62.useMemo)(()=>{
        return day.skipper || (previousDay === null || previousDay === void 0 ? void 0 : previousDay.skipper);
    }, [
        day,
        previousDay
    ]);
    // The skipper the user has picked in this form but not saved yet. The crew field
    // pins the skipper as a fixed value, and reading only the persisted day left a
    // freshly selected skipper out of the crew list until an unrelated change forced a
    // save (#1213).
    const [selectedSkipper, setSelectedSkipper] = (0, $acw62.useState)(undefined);
    (0, $acw62.useEffect)(()=>{
        setSelectedSkipper(undefined);
    }, [
        persistedSkipper
    ]);
    const skipper = selectedSkipper !== null && selectedSkipper !== void 0 ? selectedSkipper : persistedSkipper;
    const selectSkipper = (0, $acw62.useCallback)((value)=>{
        setSelectedSkipper(typeof value === "number" ? value : undefined);
    }, []);
    const timezone = (0, $acw62.useMemo)(()=>{
        if (isCurrentDay && logs.length < 1 && app.status) return app.status.systemTimezone;
        else if (!isCurrentDay && day.day == 0) return trip.timezone;
        return day.timezone;
    }, [
        day,
        logs,
        trip,
        isCurrentDay,
        app.status
    ]);
    const sunrise = (0, $acw62.useMemo)(()=>{
        var _a;
        return $a95e9f26ea4eb186$export$ae0f322ce9dc73a9.sunTimeValue((_a = day.calculated) === null || _a === void 0 ? void 0 : _a.sunrise, day.timezone);
    }, [
        day
    ]);
    const sunset = (0, $acw62.useMemo)(()=>{
        var _a;
        return $a95e9f26ea4eb186$export$ae0f322ce9dc73a9.sunTimeValue((_a = day.calculated) === null || _a === void 0 ? void 0 : _a.sunset, day.timezone);
    }, [
        day
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
        className: "DayEditView",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "DayStatsView-block-time block",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                    buttonFirst: true,
                    changed: edited,
                    editable: formEditable || alwaysEditable,
                    editableFields: formEditable ? editableFields : alwaysEditableFields,
                    error: saveErrorText,
                    onSave: saveEdits,
                    onSaveError: onSaveError,
                    children: [
                        !day.id && (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "hidden",
                            name: "day",
                            value: day.day
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("status_day"),
                                    className: "block_field_small_12",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                                        button: dayStatusButton,
                                        name: "dayStatus",
                                        value: dayStatus,
                                        options: dayStatusOptions,
                                        readOnly: true,
                                        onSelect: (_value)=>{}
                                    })
                                }),
                                sunrise != undefined && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("sunrise"),
                                    className: "DayEditView-sunrise block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "input",
                                        children: app.format("timeUtc", sunrise)
                                    })
                                }),
                                sunset != undefined && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("sunset"),
                                    className: "DayEditView-sunset block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "input",
                                        children: app.format("timeUtc", sunset)
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("status_overnight"),
                                    className: "block_field_small_12",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                                        button: overnightStatusButton,
                                        name: "dayStatus",
                                        value: dayStatus,
                                        options: dayStatusOptions,
                                        readOnly: true,
                                        onSelect: (_value)=>{}
                                    })
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("start_location"),
                                    labelFor: startLocationId,
                                    children: !formEditable && !alwaysEditable ? (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: startLocationId,
                                        value: (day.startLocation || "").length > 0 ? day.startLocation : previousDay === null || previousDay === void 0 ? void 0 : previousDay.startLocation,
                                        name: "startLocation",
                                        onChange: onEdited,
                                        readOnly: true
                                    }) : (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$909904bdb4cb4458), {
                                        id: startLocationId,
                                        defaultValue: day.startLocation,
                                        name: "startLocation",
                                        onChange: onEdited,
                                        placeholder: previousDay === null || previousDay === void 0 ? void 0 : previousDay.startLocation,
                                        readOnly: false,
                                        suggestions: autocompleteLocations
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("end_location"),
                                    labelFor: endLocationId,
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$909904bdb4cb4458), {
                                        id: endLocationId,
                                        defaultValue: day.endLocation,
                                        name: "endLocation",
                                        onChange: onEdited,
                                        readOnly: !formEditable && !alwaysEditable,
                                        suggestions: autocompleteLocations
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("timezone"),
                                    className: "block_field_small_10 ",
                                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "input",
                                        children: app.format("timezone", timezone)
                                    })
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("skipper"),
                                    className: "block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $d5a725d5c44f3d0f$export$b65e701dc90258f), {
                                        name: "skipper",
                                        defaultValue: persistedSkipper,
                                        onChange: onEdited,
                                        onSelectionChange: selectSkipper,
                                        priorityIds: cruiseCalculated === null || cruiseCalculated === void 0 ? void 0 : cruiseCalculated.skippers,
                                        role: (0, $dc7739d612f0c536$export$1e4ade51a6368243).skipper,
                                        readOnly: !formEditable
                                    }, persistedSkipper)
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("crew"),
                                    className: "crew-select",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $d5a725d5c44f3d0f$export$b65e701dc90258f), {
                                        multi: true,
                                        defaultValue: day.crew || (previousDay === null || previousDay === void 0 ? void 0 : previousDay.crew),
                                        includeValues: skipper ? [
                                            skipper
                                        ] : undefined,
                                        onChange: onEdited,
                                        priorityIds: crewPriorityIds,
                                        role: (0, $dc7739d612f0c536$export$1e4ade51a6368243).crew,
                                        name: "crew",
                                        readOnly: !formEditable
                                    })
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "DayView-passenger-row",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("passengers"),
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $d5a725d5c44f3d0f$export$b65e701dc90258f), {
                                    multi: true,
                                    defaultValue: day.passengers || (previousDay === null || previousDay === void 0 ? void 0 : previousDay.passengers),
                                    onChange: onEdited,
                                    role: (0, $dc7739d612f0c536$export$1e4ade51a6368243).none,
                                    name: "passengers",
                                    readOnly: !formEditable
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("comment"),
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$909904bdb4cb4458), {
                                    defaultValue: day.comment,
                                    name: "comment",
                                    onChange: onEdited,
                                    readOnly: !formEditable && !alwaysEditable,
                                    suggestions: autocompleteDayComment
                                })
                            })
                        })
                    ]
                })
            }),
            editHistory.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "day-details",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        className: "day-details-last-edited",
                        onClick: editHistoryVisible ? ()=>setEditHistoryOpen((open)=>!open) : undefined,
                        children: [
                            lastEditor ? t("details_last_edited_by", {
                                name: lastEditor.name || lastEditor.shortname || ""
                            }) : t("details_last_edited"),
                            editHistoryVisible && (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                icon: editHistoryOpen ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowUp : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowDown
                            })
                        ]
                    })
                })
            }),
            editHistoryVisible && (0, $7b02d682eb115277$exports.jsx)((0, $b68062e8543a3005$export$fca036eb5668ed1d), {
                entries: editHistory,
                fieldLabel: fieldLabel,
                fieldFormat: editHistoryFieldFormat,
                open: editHistoryOpen
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


const $5c760195bdd4d0c9$export$a3e89006741c63fd = {
    nextDetails (details) {
        return !details;
    },
    // which lifecycle callbacks fire when toggling from the given current state
    callbacksToFire (details) {
        return {
            enable: !details,
            disable: details
        };
    }
};
function $5c760195bdd4d0c9$export$1aa7c7ccc1c44ab8({ className: className, onChange: onChange, onDisable: onDisable, onEnable: onEnable }) {
    const [details, setDetails] = (0, $acw62.useState)(false);
    function toggleDetails() {
        const next = $5c760195bdd4d0c9$export$a3e89006741c63fd.nextDetails(details);
        const { enable: enable, disable: disable } = $5c760195bdd4d0c9$export$a3e89006741c63fd.callbacksToFire(details);
        if (onEnable && enable) onEnable();
        if (onDisable && disable) onDisable();
        if (onChange) onChange(next);
        setDetails(next);
    }
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "DetailsToggle",
            className
        ]),
        children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
            className: "button",
            icon: details ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowUp : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowDown,
            onClick: toggleDetails
        })
    });
}






const $6ea8ac9cb3fdf9c8$export$4e1de534ce0e63ca = {
    /** The open (not-yet-ended) ship status, if any. */ shipStatus (statuses) {
        return statuses.filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship).find((s)=>s.endLogId == undefined);
    },
    /** Whether the live current log should extend the day totals (only while moving/drifting on the current day). */ includeCurrentLogInStatus (shipStatus, isCurrentDay) {
        if (!isCurrentDay || !shipStatus) return false;
        return shipStatus.value == (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).inmotion || shipStatus.value == (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).drifting;
    },
    /**
     * Headline distance/duration/sog. Starts from the stored day calculation and,
     * while under way, extends it by the delta between the last committed log and
     * the live current log (both carry a cumulative `distance` odometer).
     */ totals (calculated, logs, currentLog, includeCurrentLog) {
        let distance = (calculated === null || calculated === void 0 ? void 0 : calculated.distance) || 0;
        let duration = (calculated === null || calculated === void 0 ? void 0 : calculated.duration) || 0;
        let sog = (calculated === null || calculated === void 0 ? void 0 : calculated.sog) || 0;
        if (includeCurrentLog && logs && logs.length > 0 && currentLog) {
            const lastLog = logs.slice(-1)[0];
            const extraDistance = currentLog.distance ? currentLog.distance - (lastLog.distance || 0) : 0;
            const extraDuration = currentLog.timeUtc ? currentLog.timeUtc - lastLog.timeUtc : 0;
            distance += extraDistance;
            duration += extraDuration;
            sog = duration > 0 ? distance / duration * 3600 : sog;
        }
        return {
            distance: distance,
            duration: duration,
            sog: sog
        };
    },
    // Per-field value formatters for `DayHeaderTotals` (issue #529 consistency pass):
    // mirrors this view's own `app.format(...)` calls, so distance/duration/sog are
    // always formatted identically wherever these totals are displayed.
    fieldFormat () {
        return {
            distance: "distance",
            duration: "time",
            sog: "speed"
        };
    },
    /**
     * Hour-of-day span for the timeline "active hours" highlight.
     *
     * On the current day the logs (plus the live current log) are loaded and
     * moving, so the span is derived from them. For any other day the logs are
     * lazily loaded only once the day is expanded, so deriving the span from
     * `logs` left a collapsed row pinned to hour 0 until it was opened (issue
     * #476). Those days instead use the pre-calculated motion span already carried
     * by the stored day calculation (`startTime`/`endTime`), which is available
     * whether or not the logs have been fetched and stays consistent on open.
     *
     * `hasRange` is false when no source has an active span, so the caller can hide
     * the highlight entirely (e.g. a day spent in port with no motion).
     */ hourRange (logs, currentLog, calculated, isCurrentDay) {
        if (!isCurrentDay && calculated && calculated.startTime != undefined && calculated.endTime != undefined) return {
            minHour: Math.floor(calculated.startTime / 3600),
            maxHour: Math.floor(calculated.endTime / 3600),
            hasRange: true
        };
        let minHour = undefined;
        let maxHour = undefined;
        const allLogs = logs ? logs.slice() : [];
        if (currentLog) allLogs.push(currentLog);
        for (const log of allLogs){
            const hour = Math.floor(log.time / 3600);
            if (minHour == undefined || hour < minHour) minHour = hour;
            if (maxHour == undefined || hour > maxHour) maxHour = hour;
        }
        return {
            minHour: minHour || 0,
            maxHour: maxHour || 0,
            hasRange: minHour != undefined
        };
    }
};
function $6ea8ac9cb3fdf9c8$export$a4a65d0c2bc34e7f({ advices: advices, currentLog: currentLog, details: _details, isCurrentDay: isCurrentDay, isTomorrow: isTomorrow, isYesterday: isYesterday, logs: logs, selected: selected, setDetails: setDetails, previousDay: previousDay, toggleSelected: toggleSelected }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { day: day, statuses: statuses } = (0, $97ac05743b787a86$export$95d65094202e15e7)();
    const t = app.getT("DayHeaderView");
    const calculated = !isTomorrow ? day.calculated : undefined;
    const date = (0, $acw62.useMemo)(()=>{
        if (day.day <= 1) {
            const date = new Date();
            const now = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
            const today = Math.floor(now.valueOf() - new Date(Date.UTC(2001, 0, 1)).valueOf()) / 86400000;
            if (isCurrentDay) return (0, $600b78128ceeb0f6$export$98e9a0bb257361e9)(today);
            if (isTomorrow) return (0, $600b78128ceeb0f6$export$98e9a0bb257361e9)(today + 1);
        }
        return (0, $600b78128ceeb0f6$export$98e9a0bb257361e9)(day.day);
    }, [
        day,
        isCurrentDay,
        isTomorrow
    ]);
    const shipStatus = (0, $acw62.useMemo)(()=>{
        return $6ea8ac9cb3fdf9c8$export$4e1de534ce0e63ca.shipStatus(statuses);
    }, [
        statuses
    ]);
    const includeCurrentLogInStatus = (0, $acw62.useMemo)(()=>{
        return $6ea8ac9cb3fdf9c8$export$4e1de534ce0e63ca.includeCurrentLogInStatus(shipStatus, isCurrentDay);
    }, [
        shipStatus,
        isCurrentDay
    ]);
    // const timelineStatuses = useMemo(() => {
    //   if (logs || currentLog) {
    //     return shipStatuses.map((s) => {
    //       const startLog = logs.find((l) => l.id == s.startLogId);
    //       const endLog = logs.find((l) => l.id == s.endLogId);
    //       const startHour = startLog.time / 3600;
    //       const endHour = endLog ? (endLog.time / 3600) : (isCurrentDay && currentLog && (currentLog.time / 3600));
    //       return {start: startHour, end: endHour, status: IShipStatus[s.value]};
    //     });
    //   }
    //   return []
    // }, [shipStatuses, isCurrentDay, currentLog]);
    if (currentLog) currentLog.nmeaPending = true;
    const { distance: distance, duration: duration, sog: sog } = $6ea8ac9cb3fdf9c8$export$4e1de534ce0e63ca.totals(calculated, logs, currentLog, includeCurrentLogInStatus);
    const { minHour: minHour, maxHour: maxHour, hasRange: hasRange } = $6ea8ac9cb3fdf9c8$export$4e1de534ce0e63ca.hourRange(logs, currentLog, calculated, isCurrentDay);
    const fieldFormat = (0, $acw62.useMemo)(()=>$6ea8ac9cb3fdf9c8$export$4e1de534ce0e63ca.fieldFormat(), []);
    const moonphaseIcon = (0, $acw62.useMemo)(()=>{
        var _a;
        const m = (_a = day.calculated) === null || _a === void 0 ? void 0 : _a.moonphase;
        const cs = 1 / 29.5;
        if (!m) return null;
        if (m >= 0.0 && m < cs) return (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
            className: "DayView-moonphase",
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).MoonNew
        });
        else if (m >= 0.25 && m < 0.25 + cs) return (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
            className: "DayView-moonphase",
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).MoonWaxing
        });
        else if (m >= 0.5 && m < 0.5 + cs) return (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
            className: "DayView-moonphase",
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).MoonFull
        });
        else if (m >= 0.75 && m < 0.75 + cs) return (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
            className: "DayView-moonphase",
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).MoonWaning
        });
        return null;
    }, [
        day
    ]);
    const startLocation = (0, $acw62.useMemo)(()=>{
        return (day.startLocation || "").length > 0 ? day.startLocation : previousDay === null || previousDay === void 0 ? void 0 : previousDay.startLocation;
    }, [
        previousDay,
        day
    ]);
    const dayMarkers = [
        4,
        8,
        12,
        16,
        20
    ].map((h)=>(0, $7b02d682eb115277$exports.jsx)("div", {
            className: "hour hour-" + h
        }, `hour-${h}`));
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "DayHeaderView",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "DayView-date",
                onClick: isCurrentDay ? undefined : toggleSelected,
                children: (day.day != 0 || isCurrentDay) && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        moonphaseIcon,
                        app.format("dateInYear", date.toISOString())
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "DayView-timeline",
                children: selected && !isCurrentDay && !isTomorrow && day.id ? (0, $7b02d682eb115277$exports.jsx)((0, $5c760195bdd4d0c9$export$1aa7c7ccc1c44ab8), {
                    className: "DayView-toggle",
                    onChange: setDetails
                }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        !isCurrentDay && (!isTomorrow || !selected) && dayMarkers,
                        hasRange && (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "fill",
                            style: {
                                marginTop: `${minHour / 24 * 200}%`,
                                height: `${(maxHour + 1 - minHour) / 24 * 100}%`
                            }
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "DayView-cell DayView-comment",
                onClick: isCurrentDay ? undefined : toggleSelected,
                children: [
                    isCurrentDay && (0, $7b02d682eb115277$exports.jsx)("em", {
                        className: "comment",
                        children: t("today")
                    }),
                    isTomorrow && (0, $7b02d682eb115277$exports.jsx)("em", {
                        className: "comment",
                        children: t("nextDay")
                    }),
                    isYesterday && (0, $7b02d682eb115277$exports.jsx)("em", {
                        className: "comment",
                        children: t("yesterday")
                    }),
                    (startLocation || day.endLocation) && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            startLocation,
                            " \u22EF ",
                            (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: day.endLocation
                            })
                        ]
                    }),
                    day.comment && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " - ",
                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "comment",
                                children: day.comment
                            })
                        ]
                    }),
                    isCurrentDay && advices
                ]
            }),
            !isTomorrow && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "DayView-cell DayView-duration",
                        children: (0, $14a8bda8b42de2c4$export$6d11197b6687e2cb)(fieldFormat.duration, duration, app.format)
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "DayView-cell DayView-speed",
                        children: (0, $14a8bda8b42de2c4$export$6d11197b6687e2cb)(fieldFormat.sog, sog, app.format)
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "DayView-cell DayView-distance",
                        children: (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: (0, $14a8bda8b42de2c4$export$6d11197b6687e2cb)(fieldFormat.distance, distance, app.format)
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "DayView-gap",
                children: selected && !isCurrentDay && (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                    iconClassName: "button",
                    onClick: toggleSelected
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");














var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");





function $e7bc01546cf183b2$export$2cc85109a937009e({ awaitConfirm: awaitConfirm, cancelLabel: cancelLabel, centered: centered, confirmLabel: confirmLabel, confirmDisabled: confirmDisabled, errorMessage: errorMessage, loading: loading, message: message, onCancel: onCancel, onConfirm: onConfirm, style: style, title: title }) {
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const [failed, setFailed] = (0, $acw62.useState)(false);
    const mounted = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>()=>{
            mounted.current = false;
        }, []);
    const confirm = (0, $acw62.useCallback)(async ()=>{
        if (!awaitConfirm) {
            onConfirm();
            return;
        }
        if (busy) return;
        setBusy(true);
        setFailed(false);
        try {
            await onConfirm();
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
            if (mounted.current) setFailed(true);
        } finally{
            if (mounted.current) setBusy(false);
        }
    }, [
        awaitConfirm,
        busy,
        onConfirm
    ]);
    const cancel = (0, $acw62.useCallback)(()=>{
        if (!busy) onCancel();
    }, [
        busy,
        onCancel
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "ConfirmDialog",
            centered && "overlay-centered"
        ]),
        closeBackground: !busy,
        closeCallback: cancel,
        style: style || "warning",
        title: title,
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "Overlay-body",
            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: loading ? (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
                    })
                }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: message
                        }),
                        failed && errorMessage && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "ConfirmDialog-error text-error",
                            children: errorMessage
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            actions: true,
                            children: busy ? (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
                            }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "button",
                                            onClick: ()=>{
                                                cancel();
                                            },
                                            children: cancelLabel
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "button default",
                                            disabled: confirmDisabled,
                                            onClick: ()=>{
                                                confirm();
                                            },
                                            children: confirmLabel
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}







const $509263b967d03828$var$supportedLighting = new Set([
    (0, $3bedadb68df9862e$export$966979137e3fd0b5).none,
    (0, $3bedadb68df9862e$export$966979137e3fd0b5).triColorLights,
    (0, $3bedadb68df9862e$export$966979137e3fd0b5).sailingRunningLights,
    (0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringRunningLights,
    (0, $3bedadb68df9862e$export$966979137e3fd0b5).anchorLight,
    (0, $3bedadb68df9862e$export$966979137e3fd0b5).anchorBall,
    (0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringCone
]);
const $509263b967d03828$export$e91817beb800b68f = {
    supports (lighting) {
        return lighting != undefined && $509263b967d03828$var$supportedLighting.has(lighting);
    }
};
function $509263b967d03828$var$Lamp({ light: light, cx: cx, cy: cy }) {
    const fill = light === "white" ? "currentColor" : `var(--navigation-light-${light})`;
    return (0, $7b02d682eb115277$exports.jsx)("circle", {
        className: "NavigationLightsIcon-lamp",
        cx: cx,
        cy: cy,
        "data-light": light,
        fill: fill,
        r: "8"
    });
}
function $509263b967d03828$export$48a556eded34cd4e({ className: className, lighting: lighting, title: title }) {
    return (0, $7b02d682eb115277$exports.jsxs)("svg", {
        "aria-hidden": title ? undefined : true,
        "aria-label": title,
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "NavigationLightsIcon",
            `NavigationLightsIcon-${(0, $3bedadb68df9862e$export$966979137e3fd0b5)[lighting]}`,
            className
        ]),
        role: title ? "img" : undefined,
        viewBox: "0 0 100 100",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                className: "NavigationLightsIcon-frame",
                d: "M50 8 Q56 8 60 15 L91 72 Q96 82 84 82 H16 Q4 82 9 72 L40 15 Q44 8 50 8 Z",
                fill: "none",
                stroke: "currentColor",
                strokeLinejoin: "round",
                strokeWidth: "5"
            }),
            lighting === (0, $3bedadb68df9862e$export$966979137e3fd0b5).triColorLights && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($509263b967d03828$var$Lamp, {
                        cx: 43,
                        cy: 32,
                        light: "port"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($509263b967d03828$var$Lamp, {
                        cx: 57,
                        cy: 32,
                        light: "starboard"
                    })
                ]
            }),
            (lighting === (0, $3bedadb68df9862e$export$966979137e3fd0b5).sailingRunningLights || lighting === (0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringRunningLights) && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($509263b967d03828$var$Lamp, {
                        cx: 27,
                        cy: 69,
                        light: "port"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($509263b967d03828$var$Lamp, {
                        cx: 73,
                        cy: 69,
                        light: "starboard"
                    })
                ]
            }),
            lighting === (0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringRunningLights && (0, $7b02d682eb115277$exports.jsx)($509263b967d03828$var$Lamp, {
                cx: 50,
                cy: 48,
                light: "white"
            }),
            lighting === (0, $3bedadb68df9862e$export$966979137e3fd0b5).anchorLight && (0, $7b02d682eb115277$exports.jsx)($509263b967d03828$var$Lamp, {
                cx: 50,
                cy: 29,
                light: "white"
            }),
            lighting === (0, $3bedadb68df9862e$export$966979137e3fd0b5).anchorBall && (0, $7b02d682eb115277$exports.jsx)("circle", {
                className: "NavigationLightsIcon-shape",
                cx: 50,
                cy: 48,
                "data-shape": "anchor-ball",
                fill: "currentColor",
                r: 10
            }),
            lighting === (0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringCone && (0, $7b02d682eb115277$exports.jsx)("path", {
                className: "NavigationLightsIcon-shape",
                d: "M38 34 H62 L50 58 Z",
                "data-shape": "motoring-cone",
                fill: "currentColor"
            })
        ]
    });
}




const $dbb4c3fb72c61fd7$export$8bdb0c1c6a098042 = {
    // Whether the engines row should be shown in the dropdown: only when there is
    // no live NMEA engine data, a status callback exists, and at least one engine
    // is configured.
    showEnginesRow (hasNmeaEngineData, engineStatusCallback, engines) {
        return !hasNmeaEngineData && !!engineStatusCallback && !!engines && engines.length > 0;
    },
    // Whether the lighting row should be shown in the dropdown: only when a capture
    // callback exists and there is at least one selectable lighting option.
    showLightingRow (lightingCallback, lightingOptions) {
        return !!lightingCallback && !!lightingOptions && lightingOptions.length > 0;
    },
    // Whether the sails block should be shown: only when a save callback exists and
    // the ship has at least one configured sail. Non-sailing vessels pass no sails,
    // so the block never renders for them.
    showSailsRow (saveSails, sails) {
        return !!saveSails && !!sails && sails.length > 0;
    },
    // The mutually-exclusive group a sail belongs to, mirroring Swift
    // `SailGroup.of(sail:sailType:)`. Resolves first by predefined sail name, then
    // by sail type for custom sails; `undefined` means the sail flies independently.
    sailGroupOf (name, sailType) {
        if (name && Object.values((0, $f07dcbbb3dc0e21a$export$4fa0525679448902)).includes(name)) switch(name){
            case (0, $f07dcbbb3dc0e21a$export$4fa0525679448902).mainsail:
            case (0, $f07dcbbb3dc0e21a$export$4fa0525679448902).trysail:
                return (0, $f07dcbbb3dc0e21a$export$856d661fe7159535).main;
            case (0, $f07dcbbb3dc0e21a$export$4fa0525679448902).genoa:
            case (0, $f07dcbbb3dc0e21a$export$4fa0525679448902).jib:
            case (0, $f07dcbbb3dc0e21a$export$4fa0525679448902).workingJib:
            case (0, $f07dcbbb3dc0e21a$export$4fa0525679448902).stromJib:
            case (0, $f07dcbbb3dc0e21a$export$4fa0525679448902).code0:
                return (0, $f07dcbbb3dc0e21a$export$856d661fe7159535).foresail;
            case (0, $f07dcbbb3dc0e21a$export$4fa0525679448902).spinnaker:
            case (0, $f07dcbbb3dc0e21a$export$4fa0525679448902).gennaker:
            case (0, $f07dcbbb3dc0e21a$export$4fa0525679448902).parasailor:
                return (0, $f07dcbbb3dc0e21a$export$856d661fe7159535).spinnaker;
            case (0, $f07dcbbb3dc0e21a$export$4fa0525679448902).mizzen:
            case (0, $f07dcbbb3dc0e21a$export$4fa0525679448902).mizzenStaysail:
                return (0, $f07dcbbb3dc0e21a$export$856d661fe7159535).mizzen;
        }
        if (sailType && Object.values((0, $f07dcbbb3dc0e21a$export$6451a41b34444a54)).includes(sailType)) switch(sailType){
            case (0, $f07dcbbb3dc0e21a$export$6451a41b34444a54).mast:
                return (0, $f07dcbbb3dc0e21a$export$856d661fe7159535).main;
            case (0, $f07dcbbb3dc0e21a$export$6451a41b34444a54).forestay:
                return (0, $f07dcbbb3dc0e21a$export$856d661fe7159535).foresail;
            case (0, $f07dcbbb3dc0e21a$export$6451a41b34444a54).mizzen:
                return (0, $f07dcbbb3dc0e21a$export$856d661fe7159535).mizzen;
        }
        return undefined;
    },
    // Whether a sail is currently staged active (override or, if none, its base state).
    isStaged (staged, sail) {
        var _a;
        return (_a = staged[sail.id]) !== null && _a !== void 0 ? _a : sail.active;
    },
    // Build the per-group render model. Grouped sails collapse into one entry per
    // ISailGroup (declared order); ungrouped sails each become a standalone entry.
    sailGroups (sails, staged) {
        var _a;
        const byGroup = new Map();
        const ungrouped = [];
        for (const s of sails){
            const g = this.sailGroupOf(s.name, s.sailType);
            if (g === undefined) {
                const active = this.isStaged(staged, s);
                ungrouped.push({
                    key: `custom-${s.id}`,
                    sails: [
                        s
                    ],
                    activeId: active ? s.id : undefined,
                    activeIds: active ? [
                        s.id
                    ] : []
                });
            } else {
                const arr = (_a = byGroup.get(g)) !== null && _a !== void 0 ? _a : [];
                arr.push(s);
                byGroup.set(g, arr);
            }
        }
        const grouped = [];
        for (const g of Object.values((0, $f07dcbbb3dc0e21a$export$856d661fe7159535))){
            const arr = byGroup.get(g);
            if (arr && arr.length > 0) {
                const activeIds = arr.filter((s)=>this.isStaged(staged, s)).map((s)=>s.id);
                grouped.push({
                    key: g,
                    group: g,
                    sails: arr,
                    activeId: activeIds[0],
                    activeIds: activeIds
                });
            }
        }
        return [
            ...grouped,
            ...ungrouped
        ];
    },
    // Turn every listed sail off in the staged state. Used when a group button with
    // one or more active members is pressed: the first press clears the whole group.
    disableSails (staged, sailIds) {
        const next = Object.assign({}, staged);
        for (const id of sailIds)next[id] = false;
        return next;
    },
    // Apply a toggle to the staged state, enforcing group exclusivity: turning a
    // grouped sail on ends every other active sail in the same group.
    toggleSail (sails, staged, sailId, on) {
        const next = Object.assign({}, staged);
        const target = sails.find((s)=>s.id === sailId);
        if (!target) return next;
        if (on) {
            const group = this.sailGroupOf(target.name, target.sailType);
            if (group !== undefined) {
                for (const s of sails)if (s.id !== sailId && this.sailGroupOf(s.name, s.sailType) === group) next[s.id] = false;
            }
            next[sailId] = true;
        } else next[sailId] = false;
        return next;
    },
    // The delta between the current sail plan and the staged one: only sails whose
    // staged active state differs from their base state.
    sailChanges (sails, staged) {
        const changes = [];
        for (const s of sails){
            const now = this.isStaged(staged, s);
            if (now !== s.active) changes.push({
                sail: s.id,
                on: now
            });
        }
        return changes;
    }
};




function $193beb513144bdb6$export$260b3a110a432172(vesselType) {
    const values = Object.values((0, $3bedadb68df9862e$export$966979137e3fd0b5)).filter((value)=>typeof value == "number");
    return vesselType == (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).motor ? values.filter((value)=>value == (0, $3bedadb68df9862e$export$966979137e3fd0b5).none || value == (0, $3bedadb68df9862e$export$966979137e3fd0b5).anchorBall || value == (0, $3bedadb68df9862e$export$966979137e3fd0b5).anchorLight || value == (0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringRunningLights) : values;
}
function $193beb513144bdb6$export$a4ef803d3e256716(lighting, vesselType) {
    const name = vesselType == (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).motor && lighting == (0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringRunningLights ? "navigationLights" : (0, $3bedadb68df9862e$export$966979137e3fd0b5)[lighting];
    return `LogButton_lighting_${name}`;
}
function $193beb513144bdb6$export$a56621d605e7ce89(lighting) {
    switch(lighting){
        case (0, $3bedadb68df9862e$export$966979137e3fd0b5).triColorLights:
            return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).LightingTricolor;
        case (0, $3bedadb68df9862e$export$966979137e3fd0b5).anchorBall:
            return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).LightingAnchorBall;
        case (0, $3bedadb68df9862e$export$966979137e3fd0b5).anchorLight:
            return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).LightingAnchorLight;
        case (0, $3bedadb68df9862e$export$966979137e3fd0b5).sailingRunningLights:
            return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).LightingSailingRunning;
        case (0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringRunningLights:
            return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).LightingMotoringRunning;
        case (0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringCone:
            return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).LightingMotoringCone;
        case (0, $3bedadb68df9862e$export$966979137e3fd0b5).none:
        default:
            return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).LightingNone;
    }
}




var $acw62 = parcelRequire("acw62");




function $5da0c1b78fb6a421$export$ddd6c1443566583b({ sails: sails, saveSails: saveSails, close: close, initSelecting: initSelecting, initStaged: initStaged }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("LogButton");
    const [staged, setStaged] = (0, $acw62.useState)(initStaged !== null && initStaged !== void 0 ? initStaged : {});
    const [selecting, setSelecting] = (0, $acw62.useState)(initSelecting);
    const groups = (0, $acw62.useMemo)(()=>(0, $dbb4c3fb72c61fd7$export$8bdb0c1c6a098042).sailGroups(sails, staged), [
        sails,
        staged
    ]);
    const changes = (0, $acw62.useMemo)(()=>(0, $dbb4c3fb72c61fd7$export$8bdb0c1c6a098042).sailChanges(sails, staged), [
        sails,
        staged
    ]);
    const pick = (0, $acw62.useCallback)((sailId)=>{
        setStaged((s)=>(0, $dbb4c3fb72c61fd7$export$8bdb0c1c6a098042).toggleSail(sails, s, sailId, true));
        setSelecting(undefined);
    }, [
        sails
    ]);
    const onGroupClick = (0, $acw62.useCallback)((g)=>{
        if (g.activeIds.length > 0) {
            setStaged((s)=>(0, $dbb4c3fb72c61fd7$export$8bdb0c1c6a098042).disableSails(s, g.activeIds));
            setSelecting(undefined);
        } else if (g.sails.length === 1) pick(g.sails[0].id);
        else setSelecting((cur)=>cur === g.key ? undefined : g.key);
    }, [
        pick
    ]);
    const confirm = (0, $acw62.useCallback)(()=>{
        if (changes.length > 0) saveSails(changes);
        setStaged({});
        setSelecting(undefined);
        close();
    }, [
        changes,
        saveSails,
        close
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "LogButton-block LogButton-sails-block",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "LogButton-block-label",
                children: t("sails")
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "LogButton-block-buttons",
                children: groups.map((g)=>{
                    var _a;
                    const active = g.activeId ? g.sails.find((s)=>s.id === g.activeId) : undefined;
                    // Check if this sail is staged (clicked but not yet confirmed) vs truly active
                    const isStaged = active && !active.active && staged[active.id] === true;
                    // Active sail -> its own title. Inactive -> the group name only when the
                    // group offers more than one sail, otherwise the single sail's title.
                    const groupName = g.group ? t(`sail_group_${g.group}`) : g.sails[0].title;
                    const label = (_a = active === null || active === void 0 ? void 0 : active.title) !== null && _a !== void 0 ? _a : g.sails.length > 1 ? groupName : g.sails[0].title;
                    return (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "LogButton-sail-container",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                                    "button LogButton-sail-btn",
                                    isStaged ? "staged" : active ? "on" : "off"
                                ]),
                                title: label,
                                onClick: ()=>onGroupClick(g)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "LogButton-sail-name",
                                children: label
                            }),
                            selecting === g.key && (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "LogButton-sail-selector",
                                children: g.sails.map((s)=>(0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button LogButton-sail-option",
                                        title: s.title,
                                        onClick: ()=>pick(s.id),
                                        children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: s.title
                                        })
                                    }, s.id))
                            })
                        ]
                    }, g.key);
                })
            }),
            changes.length > 0 && (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: "button LogButton-sail-confirm",
                onClick: confirm,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Checklist
                    }),
                    " ",
                    t("sails_confirm")
                ]
            })
        ]
    });
}


function $5c7e4f6714165da4$var$lightingChoiceIcon(lighting) {
    return (0, $509263b967d03828$export$e91817beb800b68f).supports(lighting) ? (0, $7b02d682eb115277$exports.jsx)((0, $509263b967d03828$export$48a556eded34cd4e), {
        lighting: lighting
    }) : (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
        icon: (0, $193beb513144bdb6$export$a56621d605e7ce89)(lighting)
    });
}
// Marks the block that begins each row of the wrapping `.LogButton-blocks` grid
// with `LogButton-block-row-start`.
//
// The stylesheet draws a divider on every block EXCEPT a row-starting one. CSS
// cannot express that on its own: `:first-child` only knows document order, so
// once the menu wraps -- and it does, `Menu.scss` caps it at `calc(100vw - 20px)`
// -- every row but the first would get a divider hanging off its left edge.
// Blocks on the same row share an `offsetTop` (they are stretched to equal
// height), so a change in `offsetTop` is exactly where a new row begins.
//
// Returns a ref callback rather than taking a ref, because the blocks live inside
// the `Menu` and only exist once it is open.
function $5c7e4f6714165da4$var$useBlockRowStarts() {
    const [node, setNode] = (0, $acw62.useState)(null);
    const mark = (0, $acw62.useCallback)(()=>{
        if (!node) return;
        let previousTop;
        for (const child of Array.from(node.children)){
            const block = child;
            const top = block.offsetTop;
            block.classList.toggle("LogButton-block-row-start", previousTop === undefined || top !== previousTop);
            previousTop = top;
        }
    }, [
        node
    ]);
    // Re-mark after every render, not just on resize: staging a sail adds the save
    // button and changes a block's height, which can move where the rows break.
    (0, $acw62.useLayoutEffect)(mark);
    (0, $acw62.useLayoutEffect)(()=>{
        if (!node) return;
        const observer = new ResizeObserver(mark);
        observer.observe(node);
        window.addEventListener("resize", mark);
        return ()=>{
            observer.disconnect();
            window.removeEventListener("resize", mark);
        };
    }, [
        node,
        mark
    ]);
    return setNode;
}
function $5c7e4f6714165da4$export$a2d7a90541d38038({ createCallback: createCallback, disabled: disabled, engines: engines, hasNmeaEngineData: hasNmeaEngineData, engineStatusCallback: engineStatusCallback, initConfirmManOverboard: initConfirmManOverboard, initOpen: initOpen, initOpenSubmenu: initOpenSubmenu, initSelectingSailGroup: initSelectingSailGroup, initStagedSails: initStagedSails, lightingCallback: lightingCallback, lightingValue: lightingValue, lightingIcon: lightingIcon, lightingOptions: lightingOptions, label: label, manualStatusActive: manualStatusActive, onSendAlert: onSendAlert, sails: sails, saveSails: saveSails, shipStatusIcon: shipStatusIcon, shipStatusValue: shipStatusValue, statusOptions: statusOptions }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("LogButton");
    const menuCallbacks = (0, $8a8193ceb042f538$export$ba657787b573294a)();
    const blocksRef = $5c7e4f6714165da4$var$useBlockRowStarts();
    const close = (0, $acw62.useCallback)(()=>{
        var _a;
        return (_a = menuCallbacks.current) === null || _a === void 0 ? void 0 : _a.setSelected(false);
    }, [
        menuCallbacks
    ]);
    const [confirmManOverboard, setConfirmManOverboard] = (0, $acw62.useState)(initConfirmManOverboard !== null && initConfirmManOverboard !== void 0 ? initConfirmManOverboard : false);
    // Manual man-overboard trigger (#1028, tracker #976): for when there is no N2K emitter, or it
    // fails. Let a failed request propagate so the confirm dialog stays open and shows
    // the error; only dismiss it once the trigger has actually succeeded.
    const triggerManOverboard = (0, $acw62.useCallback)(async ()=>{
        await new (0, $d4eccb73927932bb$export$4c70e389659ec851)(app.apiClient).alert.manOverboard({
            params: {}
        }).call();
        setConfirmManOverboard(false);
    }, [
        app
    ]);
    // Manual ship-status mode (#511): switch OFF all automatic ship-status changes for
    // a while, so the crew can set the status themselves through the status select
    // above -- for a very slow departure manoeuvre, or while circling in front of a
    // bascule bridge. A real toggle: `manualStatusActive` carries the running mode
    // (derived from the day's open `.manualShipStatus` status by `LogView`), the button
    // renders that state, and pressing it sends the opposite of it. The mode's remaining
    // time and its extend action stay on the UserAdvice button it raises on the current
    // log.
    //
    // No confirmation step, unlike the man-overboard trigger next to it: the mode is
    // harmless, expires by itself (timeout or day change) and is cancellable from that
    // advice too. Fire-and-forget, mirroring the engine/lighting rows, so the menu closes
    // immediately.
    const toggleManualShipStatus = (0, $acw62.useCallback)(()=>{
        new (0, $de4d1766f08a9636$export$c9e2730ca8b48804)(app.apiClient).manualShipStatus.update({
            params: {},
            body: {
                enabled: !manualStatusActive
            }
        }).call().catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).error("manual ship status", err));
        close();
    }, [
        app,
        close,
        manualStatusActive
    ]);
    const showEnginesRow = (0, $acw62.useMemo)(()=>(0, $dbb4c3fb72c61fd7$export$8bdb0c1c6a098042).showEnginesRow(hasNmeaEngineData, engineStatusCallback, engines), [
        hasNmeaEngineData,
        engineStatusCallback,
        engines
    ]);
    const showSailsRow = (0, $acw62.useMemo)(()=>(0, $dbb4c3fb72c61fd7$export$8bdb0c1c6a098042).showSailsRow(saveSails, sails), [
        saveSails,
        sails
    ]);
    const showLightingRow = (0, $acw62.useMemo)(()=>(0, $dbb4c3fb72c61fd7$export$8bdb0c1c6a098042).showLightingRow(lightingCallback, lightingOptions), [
        lightingCallback,
        lightingOptions
    ]);
    const displayedLightingOptions = (0, $acw62.useMemo)(()=>lightingOptions === null || lightingOptions === void 0 ? void 0 : lightingOptions.map((option)=>Object.assign(Object.assign({}, option), {
                icon: $5c7e4f6714165da4$var$lightingChoiceIcon(option.value)
            })), [
        lightingOptions
    ]);
    const handleEngine = (0, $acw62.useCallback)((id, on)=>{
        engineStatusCallback === null || engineStatusCallback === void 0 || engineStatusCallback(id, on);
        close();
    }, [
        engineStatusCallback,
        close
    ]);
    const handleLighting = (0, $acw62.useCallback)((lighting)=>{
        lightingCallback === null || lightingCallback === void 0 || lightingCallback(lighting);
        close();
    }, [
        lightingCallback,
        close
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "LogButton",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "LogButton-split",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("button", {
                        className: "LogButton-main",
                        disabled: disabled,
                        onClick: ()=>{
                            createCallback();
                        },
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                            }),
                            " ",
                            label
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "LogButton-separator"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), {
                        button: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowDown
                        }),
                        buttonClass: "LogButton-arrow",
                        callbacks: menuCallbacks,
                        disabled: disabled,
                        global: true,
                        initOpen: initOpen,
                        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "LogButton-blocks",
                            ref: blocksRef,
                            children: [
                                (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "LogButton-block",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "LogButton-block-label",
                                            children: t("status")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "LogButton-block-buttons",
                                            children: createCallback ? (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                                                button: shipStatusIcon,
                                                name: "status",
                                                value: shipStatusValue,
                                                onSelect: createCallback,
                                                options: statusOptions,
                                                className: "LogButton-status-select",
                                                initOpen: initOpenSubmenu === "status"
                                            }, `status-${shipStatusValue}`) : (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: shipStatusIcon
                                            })
                                        })
                                    ]
                                }),
                                showEnginesRow && (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "LogButton-block",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "LogButton-block-label",
                                            children: t("engines")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "LogButton-block-buttons",
                                            children: engines.map((e)=>{
                                                // off = outline circle, running = filled circle (green), idle = dot-in-ring
                                                // (orange) (#619).
                                                const state = e.on ? e.idle ? "idle" : "on" : "off";
                                                const icon = !e.on ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleLarge : e.idle ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleHalfLarge : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleFilledLarge;
                                                return (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: "LogButton-engine-container",
                                                    children: [
                                                        (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                                                                "button LogButton-engine-btn",
                                                                state
                                                            ]),
                                                            title: app.t(`engine_${e.name}`),
                                                            onClick: ()=>handleEngine(e.id, !e.on),
                                                            children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                                className: `LogView-status-icon engine-${state}`,
                                                                icon: icon
                                                            })
                                                        }),
                                                        e.name && (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "LogButton-engine-name",
                                                            children: e.name
                                                        })
                                                    ]
                                                }, `engine-${e.id}`);
                                            })
                                        })
                                    ]
                                }),
                                showSailsRow && (0, $7b02d682eb115277$exports.jsx)((0, $5da0c1b78fb6a421$export$ddd6c1443566583b), {
                                    sails: sails,
                                    saveSails: saveSails,
                                    close: close,
                                    initSelecting: initSelectingSailGroup,
                                    initStaged: initStagedSails
                                }),
                                showLightingRow && (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "LogButton-block LogButton-block-lighting",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "LogButton-block-label",
                                            children: t("lighting")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "LogButton-block-buttons",
                                            children: (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                                                button: lightingIcon !== null && lightingIcon !== void 0 ? lightingIcon : $5c7e4f6714165da4$var$lightingChoiceIcon(lightingValue),
                                                name: "lighting",
                                                value: lightingValue,
                                                onSelect: handleLighting,
                                                options: displayedLightingOptions,
                                                // Active once a light or day shape is actually shown
                                                // (@almute, #916), so the block reads at a glance -- and
                                                // `ILogLighting.none` (0) does NOT count, since it is a
                                                // recorded value meaning "nothing shown".
                                                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                                                    "LogButton-lighting-select",
                                                    lightingValue != undefined && lightingValue != (0, $3bedadb68df9862e$export$966979137e3fd0b5).none && "active"
                                                ]),
                                                initOpen: initOpenSubmenu === "lighting"
                                            }, `lighting-${lightingValue}`)
                                        })
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "LogButton-block LogButton-manual-status-block",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "LogButton-block-label",
                                            children: t("manual_status")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "LogButton-block-buttons",
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                                                    "button LogButton-manual-status",
                                                    manualStatusActive && "active"
                                                ]),
                                                title: manualStatusActive ? t("manual_status_active") : t("manual_status"),
                                                onClick: toggleManualShipStatus,
                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                    icon: manualStatusActive ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceManualShipStatus : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Toggle
                                                })
                                            })
                                        })
                                    ]
                                }),
                                app.hasFeature("multi-user") && onSendAlert && (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "LogButton-block LogButton-alert-block",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "LogButton-block-label",
                                            children: t("send_alert")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "LogButton-block-buttons",
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button LogButton-send-alert",
                                                title: t("send_alert"),
                                                onClick: ()=>{
                                                    onSendAlert();
                                                    close();
                                                },
                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Alert,
                                                    className: "LogButton-icon"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "LogButton-block LogButton-mob-block",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "LogButton-block-label",
                                            children: t("man_overboard")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "LogButton-block-buttons",
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button LogButton-man-overboard",
                                                title: t("man_overboard"),
                                                onClick: ()=>{
                                                    setConfirmManOverboard(true);
                                                    close();
                                                },
                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceManOverboard
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            confirmManOverboard && (0, $7b02d682eb115277$exports.jsx)((0, $e7bc01546cf183b2$export$2cc85109a937009e), {
                awaitConfirm: true,
                centered: true,
                title: t("man_overboard_confirm_title"),
                message: t("man_overboard_confirm_message"),
                confirmLabel: t("man_overboard_confirm"),
                cancelLabel: t("man_overboard_cancel"),
                errorMessage: t("man_overboard_error"),
                style: "alarm",
                onConfirm: triggerManOverboard,
                onCancel: ()=>setConfirmManOverboard(false)
            })
        ]
    });
}










var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");




// How much of an advice's wording a button shows (#1171). The buttons sit inline on
// the current-log row, where a handful of full labels -- "Alarme de profondeur
// désactivée" -- fill the row on their own. Every advice therefore declares both
// wordings up front and the row picks a format per button; see `Data.ts`.
var $9b0ea27c41d2c665$export$fc21ca3af2776d35;
(function(UserAdviceFormat) {
    // The icon alone. The full wording survives as the button's accessible name.
    UserAdviceFormat["icon"] = "icon";
    // Icon + `shortTitle`: the advice's kind, with the variable parts (timers,
    // active/inactive state) dropped.
    UserAdviceFormat["short"] = "short";
    // Icon + `title`: the full wording, unchanged from before #1171.
    UserAdviceFormat["full"] = "full";
})($9b0ea27c41d2c665$export$fc21ca3af2776d35 || ($9b0ea27c41d2c665$export$fc21ca3af2776d35 = {}));
var $9b0ea27c41d2c665$export$85f867f6e70ad5cb;
(function(UserAdviceLevel) {
    UserAdviceLevel["notice"] = "notice";
    UserAdviceLevel["warning"] = "warning";
    UserAdviceLevel["alarm"] = "alarm";
})($9b0ea27c41d2c665$export$85f867f6e70ad5cb || ($9b0ea27c41d2c665$export$85f867f6e70ad5cb = {}));
var $9b0ea27c41d2c665$export$12d2560880666b0e;
(function(UserAdviceRole) {
    // Switched on and left running: an anchor or depth watch, and (once it lands)
    // navigation lights. Has an on/off state that outlives any single log, so it
    // belongs in the ship toolbar rather than the log row.
    UserAdviceRole["monitor"] = "monitor";
    // Fired by a condition and demanding acknowledgement. Present only while the
    // alert is open.
    UserAdviceRole["alert"] = "alert";
    // A prompt for something the crew may want to record right now, which opens a
    // dialog and is gone once handled.
    UserAdviceRole["action"] = "action";
})($9b0ea27c41d2c665$export$12d2560880666b0e || ($9b0ea27c41d2c665$export$12d2560880666b0e = {}));
var $9b0ea27c41d2c665$export$4eb7917b1c706049;
(function(UserAdvicePlacement) {
    UserAdvicePlacement["log"] = "log";
    UserAdvicePlacement["day"] = "day";
})($9b0ea27c41d2c665$export$4eb7917b1c706049 || ($9b0ea27c41d2c665$export$4eb7917b1c706049 = {}));
var $9b0ea27c41d2c665$export$fcebc600836ef805;
(function(UserAdviceWidth) {
    UserAdviceWidth["desktop"] = "desktop";
    UserAdviceWidth["mobile"] = "mobile";
    UserAdviceWidth["small"] = "small";
})($9b0ea27c41d2c665$export$fcebc600836ef805 || ($9b0ea27c41d2c665$export$fcebc600836ef805 = {}));


const $9347be5f58db4007$var$warningIcons = new Set([
    (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceAnchor,
    (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceAnchorDrift,
    (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceDepth,
    (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceLights,
    (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceLostPosition,
    (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdvicePressure,
    (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceWind
]);
function $9347be5f58db4007$export$6fe4c04796dfe485({ advice: advice, className: _className, format: format, state: state }) {
    var _a, _b;
    const clickCallback = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        state.setSelected(advice.id);
    }, [
        advice,
        state
    ]);
    // Advice feature gates live on each advice class and are applied by
    // getUserAdvices(); every instance rendered here has already passed them.
    // The full wording is always the button's accessible name and tooltip, whatever is
    // actually painted: an icon-only button carrying no label would be unusable with a
    // screen reader, and unreadable to anyone who doesn't recognise the icon.
    const label = advice.props.title;
    const shown = $9347be5f58db4007$var$adviceLabel(advice, format !== null && format !== void 0 ? format : (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).full);
    const className = (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
        "UserAdviceButton",
        "button",
        `UserAdvice-${advice.props.type}`,
        `UserAdvice-${advice.props.level}`,
        `UserAdvice-format-${format !== null && format !== void 0 ? format : (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).full}`
    ]);
    const iconClassName = (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
        advice.props.type === "alert" && "UserAdviceIcon-alert",
        $9347be5f58db4007$var$warningIcons.has(advice.props.icon) && "UserAdviceIcon-warning"
    ]);
    const body = (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            advice.props.navigationLights == undefined ? (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                className: iconClassName,
                icon: advice.props.icon
            }) : (0, $7b02d682eb115277$exports.jsx)((0, $509263b967d03828$export$48a556eded34cd4e), {
                className: "UserAdviceIcon-navigation-lights",
                lighting: advice.props.navigationLights
            }),
            shown != undefined && (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "UserAdviceButton-label",
                children: [
                    " ",
                    shown,
                    advice.props.navigationLights != undefined && " ?"
                ]
            }),
            (_a = advice.props.indicators) === null || _a === void 0 ? void 0 : _a.map((indicator)=>(0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "UserAdviceButton-indicator",
                    children: indicator
                }, indicator)),
            (_b = advice.props.indicatorIcons) === null || _b === void 0 ? void 0 : _b.map((indicator)=>(0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                    className: "UserAdviceButton-indicator-icon",
                    icon: indicator.icon,
                    title: indicator.label
                }, indicator.label))
        ]
    });
    return (0, $7b02d682eb115277$exports.jsx)("button", {
        "aria-label": label,
        className: className,
        onClick: clickCallback,
        title: label,
        children: body
    });
}
// The wording a given format paints. `short` falls back to the full title for an
// advice that declared no short form -- its title is already a bare noun.
function $9347be5f58db4007$var$adviceLabel(advice, format) {
    switch(format){
        case (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).icon:
            return undefined;
        case (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).short:
            return advice.props.shortTitle || advice.props.title;
        case (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).full:
            return advice.props.title;
    }
}
function $9347be5f58db4007$export$b2dedfcffe05aa1a({ children: children, className: className, bodyRef: bodyRef, scrollFooter: scrollFooter }) {
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: bodyRef,
                className: "Overlay-body UserAdviceDialog",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    className: className,
                    children: children
                })
            }),
            scrollFooter
        ]
    });
}



var $94dd0a1374840a0e$export$b067a529c9eafd88;
(function(UserAdviceLocation) {
    UserAdviceLocation["log"] = "log";
    UserAdviceLocation["day"] = "day";
    // The ship toolbar (#916), where the `monitor`-role advices live: things you
    // switch on and leave running, whose state outlives any one log. The log row and
    // day summary are for what needs attention *now*, so a monitor renders here and
    // nowhere else -- an open alert still reaches the row through `AlertAdvice`.
    UserAdviceLocation["toolbar"] = "toolbar";
})($94dd0a1374840a0e$export$b067a529c9eafd88 || ($94dd0a1374840a0e$export$b067a529c9eafd88 = {}));
class $94dd0a1374840a0e$export$7ca5bcfc497210b6 {
    constructor(id, level, props, parent, index = 0, location = $94dd0a1374840a0e$export$b067a529c9eafd88.log){
        this.id = id;
        this.index = index;
        this.level = level;
        this.props = props;
        this.parent = parent;
        this.location = location;
    }
    // Only the button: since #1171 an advice's dialog is NOT rendered beside it but
    // mounted by `UserAdviceOverlayView`, so the row stays a row of buttons and the
    // open dialog has a single host -- the same split the App and Ship hubs use.
    renderButton(state, format) {
        return (0, $7b02d682eb115277$exports.jsx)((0, $9347be5f58db4007$export$6fe4c04796dfe485), {
            advice: this,
            format: format,
            state: state
        });
    }
    // This advice's overlay, as `OverlayView` wants it. `undefined` when the advice
    // can no longer describe itself (e.g. its alert closed while the dialog was open),
    // which the overlay host reads as "nothing to show".
    overlay(app, state) {
        return this.parent.overlay(app, this, state);
    }
}
class $94dd0a1374840a0e$export$ecf796c81688685b {
    constructor(){
        // What job this advice does (#916), so a surface can offer just the advices it
        // is for -- the log row shows alerts and actions, the ship toolbar shows
        // monitors. Every subclass declares its own; `action` is the default because it
        // is the least privileged: a new advice that forgets to say shows up as an
        // ordinary prompt rather than silently claiming a monitor's toolbar slot.
        this.role = (0, $9b0ea27c41d2c665$export$12d2560880666b0e).action;
    }
    getInstances(_app, _location, _currentLog) {
        return [];
    }
    update(_app, _state, _currentLog, _ship) {}
    overlay(_app, _advice, _state) {
        return undefined;
    }
    static status(statuses, type, dayId) {
        return statuses.filter((s)=>s.statusType == type && s.dayId == dayId);
    }
}
function $94dd0a1374840a0e$export$ea1172994c7dcdd5(advice) {
    const candidate = advice;
    return typeof candidate.isActive == "function" && typeof candidate.isAvailable == "function" && typeof candidate.activate == "function" && typeof candidate.deactivate == "function";
}





// Severity ranking. Higher wins the space when the row has more advices than it can
// spell out, so a trailing alarm keeps its wording ahead of leading notices.
const $ddd9949c85d1c9ae$var$levelRank = {
    [(0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).alarm]: 3,
    [(0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).warning]: 2,
    [(0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).notice]: 1
};
// How many advices on one row may carry any wording at all. Past this the row is
// simply too crowded for text to help, so the rest fall back to their icons -- which
// is also the point at which the expand toggle becomes the way to read them.
const $ddd9949c85d1c9ae$var$wordedLimit = 4;
// Only a notice this densely packed still earns its short wording; beyond it, notices
// are the first thing to give up their text since they are the least urgent.
const $ddd9949c85d1c9ae$var$noticeWordedLimit = 2;
const $ddd9949c85d1c9ae$export$5a0a068fd4597226 = {
    // Pick a display format per advice (#1171).
    //
    // Deliberately a pure function of severity, placement, count and breakpoint rather
    // than a measurement of the rendered widths: the row clips on the right and offers
    // an expand toggle, so it never needs to know the true pixel cost -- and staying
    // pure keeps this unit- and golden-testable, and stable across languages (the same
    // row must not reshuffle itself just because French is wordier than English).
    //
    // The ordering rules run highest-reserve first: expanded and the day summary spell
    // everything out, then each advice gets what its severity affords at this width,
    // and finally anything past `wordedLimit` (ranked by severity, ties by position)
    // drops to its icon however urgent it is.
    adviceFormats (advices, width, expanded) {
        if (expanded) return advices.map(()=>(0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).full);
        // The day summary renders its advices on a row of their own rather than sharing
        // the current log's, so nothing there competes for the space.
        if (advices.every((a)=>a.placement == (0, $9b0ea27c41d2c665$export$4eb7917b1c706049).day)) return advices.map(()=>(0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).full);
        const noticeCount = advices.filter((a)=>a.level == (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).notice).length;
        const worded = $ddd9949c85d1c9ae$export$5a0a068fd4597226.wordedIds(advices);
        return advices.map((advice)=>{
            if (advice.placement == (0, $9b0ea27c41d2c665$export$4eb7917b1c706049).day) return (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).full;
            if (!worded.has(advice.id)) return (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).icon;
            return $ddd9949c85d1c9ae$export$5a0a068fd4597226.levelFormat(advice.level, width, noticeCount);
        });
    },
    // The ids allowed to carry wording at all: the `wordedLimit` most severe advices,
    // ties broken by the order they were given, so the row's leading buttons win.
    wordedIds (advices) {
        return new Set(advices.map((advice, index)=>({
                advice: advice,
                index: index
            })).toSorted((a, b)=>$ddd9949c85d1c9ae$var$levelRank[b.advice.level] - $ddd9949c85d1c9ae$var$levelRank[a.advice.level] || a.index - b.index).slice(0, $ddd9949c85d1c9ae$var$wordedLimit).map(({ advice: advice })=>advice.id));
    },
    // What a given severity affords at this width. An alarm is the one advice that
    // still spells itself out on a wide row; a warning settles for its short wording
    // and gives that up on the smallest screens; a notice only gets text on desktop,
    // and only while there are few enough of them to be worth reading.
    levelFormat (level, width, noticeCount) {
        switch(level){
            case (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).alarm:
                return width == (0, $9b0ea27c41d2c665$export$fcebc600836ef805).desktop ? (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).full : (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).short;
            case (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).warning:
                return width == (0, $9b0ea27c41d2c665$export$fcebc600836ef805).small ? (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).icon : (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).short;
            case (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).notice:
                return width == (0, $9b0ea27c41d2c665$export$fcebc600836ef805).desktop && noticeCount <= $ddd9949c85d1c9ae$var$noticeWordedLimit ? (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).short : (0, $9b0ea27c41d2c665$export$fc21ca3af2776d35).icon;
        }
    }
};



function $9f74ca3230272c28$export$60163ac1b08bf25c({ advices: advices, className: className, initExpanded: initExpanded, state: state, width: width }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("UserAdviceRow");
    const [expanded, setExpanded] = (0, $acw62.useState)(initExpanded !== null && initExpanded !== void 0 ? initExpanded : false);
    const toggle = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setExpanded((value)=>!value);
    }, []);
    const formats = (0, $acw62.useMemo)(()=>{
        return (0, $ddd9949c85d1c9ae$export$5a0a068fd4597226).adviceFormats(advices.map((advice)=>({
                id: advice.id,
                level: advice.props.level,
                placement: advice.location == (0, $94dd0a1374840a0e$export$b067a529c9eafd88).day ? (0, $9b0ea27c41d2c665$export$4eb7917b1c706049).day : (0, $9b0ea27c41d2c665$export$4eb7917b1c706049).log
            })), width, expanded);
    }, [
        advices,
        width,
        expanded
    ]);
    if (advices.length == 0) return null;
    // The toggle only earns its own space once something is actually being held back:
    // with every button already at its full wording there is nothing left to expand to.
    const expandable = expanded || formats.some((format)=>format != "full");
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            advices.map((advice, index)=>(0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "UserAdviceRow-advice",
                    children: advice.renderButton(state, formats[index])
                }, advice.id)),
            expandable && (0, $7b02d682eb115277$exports.jsx)("button", {
                "aria-expanded": expanded,
                "aria-label": t(expanded ? "collapse" : "expand"),
                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                    "UserAdviceRow-toggle",
                    "button",
                    className
                ]),
                onClick: toggle,
                title: t(expanded ? "collapse" : "expand"),
                children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                    icon: expanded ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowsLeft : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowsRight
                })
            })
        ]
    });
}
function $9f74ca3230272c28$export$79b7f2448f28877() {
    if (typeof window == "undefined" || !window.matchMedia) return (0, $9b0ea27c41d2c665$export$fcebc600836ef805).desktop;
    if (window.matchMedia("(max-width: 449px)").matches) return (0, $9b0ea27c41d2c665$export$fcebc600836ef805).small;
    if (window.matchMedia("(max-width: 767px)").matches) return (0, $9b0ea27c41d2c665$export$fcebc600836ef805).mobile;
    return (0, $9b0ea27c41d2c665$export$fcebc600836ef805).desktop;
}





var $acw62 = parcelRequire("acw62");



/**
 * Time helpers kept free of React/DOM. `timeUtc` returns the number of seconds
 * since the 2001-01-01 UTC reference epoch (matching the Swift/CoreFoundation
 * `timeIntervalSinceReferenceDate` used server-side).
 */ var $141327c3ea765ec6$var$MILLISECONDS_PER_SECOND = 1000;
function $141327c3ea765ec6$export$35bf80cdff76a270(seconds, referenceDate) {
    return new Date(referenceDate.getTime() + seconds * $141327c3ea765ec6$var$MILLISECONDS_PER_SECOND);
}
function $141327c3ea765ec6$export$1da41b56bef2727a(date, referenceDate) {
    return (date.getTime() - referenceDate.getTime()) / $141327c3ea765ec6$var$MILLISECONDS_PER_SECOND;
}
function $141327c3ea765ec6$export$29d574e6a2fbfaec(options) {
    var _a;
    return $141327c3ea765ec6$export$1da41b56bef2727a(((_a = options.now) !== null && _a !== void 0 ? _a : function() {
        return new Date();
    })(), options.referenceDate);
}


const $ec32d24fbaadaf04$export$680ea196effce5f = {
    timeUtc () {
        return (0, $141327c3ea765ec6$export$29d574e6a2fbfaec)({
            referenceDate: new Date(Date.UTC(2001, 0, 1))
        });
    }
};









var $acw62 = parcelRequire("acw62");

function $00c02b94fd6b341a$export$c6f462c9dfb8e86b({ value: value, predefined: predefined, label: label, customValue: customValue, onSelect: onSelect, name: name, readOnly: readOnly, sort: sort, className: className }) {
    const selectedCustom = (0, $acw62.useMemo)(()=>!!value && predefined.indexOf(value) < 0, [
        value,
        predefined
    ]);
    const options = (0, $acw62.useMemo)(()=>{
        const mapped = predefined.map((v)=>({
                title: label(v),
                value: v
            }));
        const ordered = sort ? mapped.toSorted((a, b)=>a.title.localeCompare(b.title)) : mapped;
        if (selectedCustom && value) ordered.push({
            title: value,
            value: value
        });
        return ordered;
    }, [
        predefined,
        label,
        sort,
        selectedCustom,
        value
    ]);
    const button = selectedCustom && value ? value : label(value);
    return (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
        button: button,
        customValue: customValue,
        name: name,
        value: value,
        onSelect: onSelect,
        options: options,
        readOnly: readOnly,
        className: className
    });
}




const $a73a127a1ab0cf24$export$d0900c0205452cbd = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    saveLog (api, shipId, logId, values) {
        return new (0, $199ead3c99f138be$export$89c3ec6dea3c6061)(api).logs.update({
            params: {
                shipId: shipId,
                logId: logId
            },
            body: values
        }).call();
    },
    // Predefined codes for the `currentDirection`/`seaState` `PredefinedSelect`s below --
    // hoisted here (rather than local consts in the component) so `LogViewData.
    // fieldFormat` (issue #529, in `LogView.tsx`) can resolve the exact same set of
    // codes to their translated label for `EditHistory`, without duplicating (and
    // risking drifting from) this list.
    predefinedDirections: [
        "0",
        "1",
        "2",
        "3"
    ],
    predefinedSeaStates: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10"
    ]
};
function $a73a127a1ab0cf24$export$cd3865c2c717b1cc({ editable: editable, initSaveError: initSaveError, onClick: onClick, recordSavedLog: recordSavedLog }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const [ship, log] = [
        (0, $97ac05743b787a86$export$f581995c9f2db6f0)(),
        (0, $97ac05743b787a86$export$f4f9faa631770428)()
    ];
    const { logs: logs, auditLogEdits: auditLogEdits, recordAuditLogEdits: recordAuditLogEdits, updateLog: updateLog } = (0, $97ac05743b787a86$export$95d65094202e15e7)();
    const ft = app.getT("LogEnvironmentView");
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const [weather, setWeather] = (0, $acw62.useState)(log.weather);
    const [saveError, setSaveError] = (0, $acw62.useState)(initSaveError);
    const editableFields = [
        "currentDirection",
        {
            name: "currentSpeed",
            type: "float"
        },
        {
            name: "humidity",
            type: "float"
        },
        {
            name: "pressure",
            type: "float"
        },
        "seaState",
        {
            name: "temperature",
            type: "float"
        },
        {
            name: "windDirection",
            type: "int"
        },
        {
            name: "windSpeed",
            type: "float"
        },
        {
            name: "weather",
            type: "int"
        }
    ];
    const formEditable = app.editable && editable;
    const selectWeatherOptions = (0, $acw62.useMemo)(()=>Array.from(Array(16).keys()).map((i)=>{
            const n = i + 1;
            return {
                icon: "weather-" + n,
                title: ft("weather_" + n),
                value: n
            };
        }), []);
    // Mirrors the server's `logs.update` field-editability rule (issue #529) — see
    // `Views/Log/editability.ts`. Replaces the old purely-live-NMEA-status check, which
    // didn't account for the ship's `editPermissiveness` level, the editable-age/recency
    // window, or a field already having been manually superseded on this log.
    const level = (_a = (0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship).editPermissiveness) !== null && _a !== void 0 ? _a : (0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).strict;
    const fieldEditable = (0, $acw62.useCallback)((field)=>{
        return formEditable && (0, $e000d4a262f1f979$export$c4d316b0f08548e5)(field, log, logs, auditLogEdits, level, (0, $ec32d24fbaadaf04$export$680ea196effce5f).timeUtc(), app.forceLogEditable);
    }, [
        formEditable,
        log,
        logs,
        auditLogEdits,
        level,
        app.forceLogEditable
    ]);
    // Issue #1142 (broader fix): mirrors every field's own `readOnly` condition below,
    // so `EditGroup` never even attempts to submit a value for a currently
    // non-editable field -- not even its own (possibly stale, display-rounded)
    // `defaultValue`. This is what stops an unrelated edit from ever resubmitting a
    // protected NMEA-capable field's rounded display value and manufacturing a
    // spurious "changed" edit server-side.
    const isFieldEditable = (0, $acw62.useCallback)((field)=>{
        switch(field){
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).windDirection:
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).windSpeed:
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).pressure:
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).temperature:
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).humidity:
                return fieldEditable(field);
            case "currentDirection":
            case "seaState":
                // These two `PredefinedSelect`s are gated by the raw `editable` prop, not
                // `formEditable` -- mirrored here to match their own `readOnly` conditions
                // below exactly.
                return editable;
            default:
                // currentSpeed, weather: `.always`-editable, gated only by `formEditable`
                // (see their own `readOnly` conditions below).
                return formEditable;
        }
    }, [
        fieldEditable,
        formEditable,
        editable
    ]);
    // Field-name -> localized-label map for `saveErrorMessage`: reuses each view's own
    // existing translation keys, including the combined labels these NMEA-capable
    // fields already share on-screen (e.g. `windDirection`/`windSpeed` under
    // `wind_direction_speed`). `currentDirection`/`currentSpeed`/`seaState`/`weather`
    // are `.always` (see `Log/editability.ts`) and can never actually appear in an
    // `EditNotAllowedError`, so they need no entry here.
    const saveErrorFieldLabels = (0, $acw62.useMemo)(()=>({
            windDirection: ft("wind_direction_speed"),
            windSpeed: ft("wind_direction_speed"),
            pressure: ft("pressure"),
            temperature: ft("weather_temp_rel_humidity"),
            humidity: ft("weather_temp_rel_humidity")
        }), [
        ft
    ]);
    const saveErrorText = (0, $acw62.useMemo)(()=>(0, $a6db0417d7b66a9b$export$3b04090cc2c1b2d)(saveError, saveErrorFieldLabels, {
            fields: (labels)=>ft("save_error_fields", {
                    fields: labels
                }),
            generic: ft("save_error_generic")
        }), [
        saveError,
        saveErrorFieldLabels,
        ft
    ]);
    // Wired as EditGroup's `onSaveError` prop -- called with the rejected error on a
    // failed save, and with `undefined` at the start of every new submit attempt (see
    // EditGroup.tsx). A real error also resets `edited`, which is what stops
    // EditGroup's own auto-resubmit effect from silently resubmitting the now-reverted
    // (unchanged) form and clearing this error the instant that resubmit starts (issue
    // #1142). Mirrors useEditForm.ts's handleSaveError.
    const handleSaveError = (0, $acw62.useCallback)((error)=>{
        setSaveError(error);
        if (error !== undefined) resetEdited();
    }, [
        resetEdited
    ]);
    // Current Direction
    const [currentDirection, setCurrentDirection] = (0, $acw62.useState)(log.currentDirection);
    const selectCurrentDirection = (0, $acw62.useCallback)((value)=>{
        setCurrentDirection(value);
        if (onEdited) onEdited();
    }, [
        onEdited
    ]);
    // SeaState
    const [seaState, setSeaState] = (0, $acw62.useState)(log.seaState);
    const selectSeaState = (0, $acw62.useCallback)((value)=>{
        setSeaState(value);
        if (onEdited) onEdited();
    }, [
        onEdited
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const saveEdits = (0, $acw62.useCallback)(async (_data, values)=>{
        const result = await updateLog(log.id, values);
        if (result) {
            if (result.log) recordSavedLog === null || recordSavedLog === void 0 || recordSavedLog(result.log);
            if (result.auditLogEdits) recordAuditLogEdits(result.auditLogEdits);
            resetEdited();
        }
    }, [
        log,
        recordAuditLogEdits,
        recordSavedLog,
        updateLog,
        resetEdited
    ]);
    const selectWeather = (0, $acw62.useCallback)((weather)=>{
        setWeather(weather);
        onEdited();
    }, [
        weather
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: "LogView-environment",
        onClick: onClick,
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
            buttonFirst: true,
            changed: edited,
            editable: formEditable,
            editableFields: editableFields,
            error: saveErrorText,
            isFieldEditable: isFieldEditable,
            onSave: saveEdits,
            onSaveError: handleSaveError,
            children: [
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("wind_direction_speed"),
                            className: "block_field_small_16",
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: app.format("angle", log.windDirection),
                                        name: "windDirection",
                                        onChange: onEdited,
                                        readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).windDirection),
                                        className: "text-centered"
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: app.format("speed", log.windSpeed),
                                        name: "windSpeed",
                                        onChange: onEdited,
                                        readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).windSpeed),
                                        className: "text-centered"
                                    })
                                ]
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("pressure"),
                            className: "block_field_small_10",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                defaultValue: app.format("pressure", log.pressure),
                                name: "pressure",
                                onChange: onEdited,
                                readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).pressure),
                                className: "text-centered"
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("weather_temp_rel_humidity"),
                            className: "block_field_small_16",
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: [
                                    !formEditable ? (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            minWidth: "2em"
                                        },
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: "weather-" + weather
                                        })
                                    }) : (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                                        className: "weather_select",
                                        button: weather ? (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: "weather-" + weather
                                        }) : "\u2205",
                                        value: weather,
                                        name: "weather",
                                        onSelect: selectWeather,
                                        options: selectWeatherOptions,
                                        readOnly: !formEditable,
                                        title: ft("weather_" + weather)
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: app.format("temperature", log.temperature),
                                        name: "temperature",
                                        onChange: onEdited,
                                        readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).temperature),
                                        className: "block_field_small_6 text-centered"
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: app.format("percentage", log.humidity),
                                        name: "humidity",
                                        onChange: onEdited,
                                        readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).humidity),
                                        className: "block_field_small_6 text-centered"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("current_direction_speed"),
                            className: "block_field_small_16",
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                                        className: "currentDirection_select text-centered",
                                        value: currentDirection,
                                        predefined: $a73a127a1ab0cf24$export$d0900c0205452cbd.predefinedDirections,
                                        label: (v)=>ft(`current_direction_${v}`),
                                        customValue: ft("other_direction"),
                                        name: `currentDirection`,
                                        onSelect: selectCurrentDirection,
                                        readOnly: !editable,
                                        sort: true
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: app.format("speed", log.currentSpeed),
                                        name: "currentSpeed",
                                        onChange: onEdited,
                                        readOnly: !formEditable,
                                        className: "text-centered fix-field-height"
                                    })
                                ]
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("seastate"),
                            className: "block_field_small_30",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                                className: "seastate_select",
                                value: seaState,
                                predefined: $a73a127a1ab0cf24$export$d0900c0205452cbd.predefinedSeaStates,
                                label: (v)=>ft(`seastate_${v}`),
                                customValue: ft("other"),
                                name: `seaState`,
                                onSelect: selectSeaState,
                                readOnly: !editable
                            })
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {})
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




const $00eb459a7fe35365$export$fcc386c2095e17ae = {
    normalizeValues (values) {
        return values.map((v)=>typeof v === "object" && v !== null && "value" in v ? v.value : v);
    },
    addValue (current, value) {
        return [
            ...current,
            value
        ];
    },
    removeValue (current, value) {
        return current.filter((v)=>v !== value);
    }
};
function $00eb459a7fe35365$export$1e7dfd31545b5809({ button: button, customValue: customValue, name: name, onSelect: onSelect, options: options, readOnly: readOnly, values: values }) {
    const _customValueRef = (0, $acw62.useRef)(null);
    const [selected, _setSelected] = (0, $acw62.useState)(false);
    const selectedValues = (0, $acw62.useMemo)(()=>$00eb459a7fe35365$export$fcc386c2095e17ae.normalizeValues(values), [
        values
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const selectOption = (0, $acw62.useCallback)((value)=>{
        onSelect($00eb459a7fe35365$export$fcc386c2095e17ae.addValue(selectedValues, value));
    }, [
        selectedValues,
        values,
        onSelect
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const removeOption = (0, $acw62.useCallback)((value)=>{
        onSelect($00eb459a7fe35365$export$fcc386c2095e17ae.removeValue(selectedValues, value));
    }, [
        selectedValues,
        onSelect
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `MultiSelect${selected ? " selected" : ""}${readOnly ? " readOnly" : ""}`,
        children: [
            values.map((value, index)=>{
                if (typeof value === "object" && value !== null && "value" in value) return (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                        "MultiSelect-value",
                        value.className
                    ]),
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "MultiSelect-value-text",
                            children: [
                                value.icon && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: value.icon
                                        }),
                                        " "
                                    ]
                                }),
                                value.title
                            ]
                        }),
                        !readOnly && value.remove != false && (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Trash,
                            onClick: ()=>removeOption(value.value)
                        })
                    ]
                }, `value-${index}`);
                else return (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "MultiSelect-value",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "MultiSelect-value-text",
                            children: value
                        }),
                        !readOnly && (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Trash,
                            onClick: ()=>removeOption(value)
                        })
                    ]
                }, `value-${index}`);
            }),
            !readOnly && (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                button: button,
                customValue: customValue,
                name: name,
                onSelect: selectOption,
                options: options,
                value: undefined
            })
        ]
    });
}










const $2b4c51d286f985e1$export$391f39dba41666e2 = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    saveLog (api, shipId, logId, values) {
        return new (0, $199ead3c99f138be$export$89c3ec6dea3c6061)(api).logs.update({
            params: {
                shipId: shipId,
                logId: logId
            },
            body: values
        }).call();
    },
    loadLogCommentAutocomplete (api, shipId) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.autocomplete({
            params: {
                shipId: shipId,
                field: "logComment"
            }
        }).call();
    },
    updateEngine (api, shipId, logId, engine, on) {
        return new (0, $199ead3c99f138be$export$89c3ec6dea3c6061)(api).logs.updateEngine({
            params: {
                shipId: shipId,
                logId: logId
            },
            body: {
                engine: engine,
                on: on
            }
        }).call();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    updateSails (api, shipId, logId, values) {
        return new (0, $199ead3c99f138be$export$89c3ec6dea3c6061)(api).logs.updateSails({
            params: {
                shipId: shipId,
                logId: logId
            },
            body: {
                sails: values
            }
        }).call();
    },
    // --- Shared log-entry derivations (canonical: the interactive Log view) ---------------
    // Print/LogView references these so the two views cannot drift. The genuinely
    // view-specific bits (sailStatuses point-in-time window, the sailStatusValues editor
    // shape) stay in their own components.
    engineStatuses (statuses) {
        return (statuses || []).filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).engine);
    },
    // Defensively parse the ship-status blob; a malformed status.data is swallowed rather
    // than thrown so a single bad row never blanks the whole view.
    statusData (status) {
        if (status && status.data) try {
            const parsed = (0, $d0f8aae9e6f7e80f$export$96e9906d6d93a972).parse(status);
            if (parsed.statusType === (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship) return parsed.dataParsed;
        } catch (e) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Failed to parse status.data", e);
        }
        return undefined;
    },
    sailName (app, id, reef, sails) {
        const t = app.getT("ShipDataView_sail");
        const sail = sails.find((s)=>s.id == id);
        if (sail && sail.sail) {
            const name = t(sail.sail) || sail.sail;
            if (reef < 1) return name;
            return t("reef", {
                sail: name,
                reef: t(`reef_${reef}`)
            });
        }
        return "";
    },
    // Canonical engine on/off rule (the Log view's): an engine is running if the engine
    // status covering this log entry is open OR its logged rpm is at or above the ship's
    // engine-off threshold -- shared with `LogView`/`Print/LogListView` through
    // `engineRunningAtLog`. The covering check is applied here rather than left to the
    // caller (#506) -- `Print/DaysView` hands over the day's full status list, where a
    // status opened *after* this log used to match.
    engines (ship, log, engineStatuses) {
        const engineInfo = [];
        const thresholds = (0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship).thresholds;
        for (const e of (0, $22871482fce5b7e5$export$7930c61d9b464618).engines(ship)){
            const status = (0, $234930b26df9c152$export$738727f375798cb)(engineStatuses, log.id, e.id);
            if (e.number == undefined && e.nmeaNumber == undefined) continue;
            const n = (0, $2e799dc50d0acd79$export$2ab9a8f9f1186f14)(-1, e.nmeaNumber, e.number);
            const on = (0, $234930b26df9c152$export$591cee21f508cff)(log.engineRpms, n, status, thresholds);
            engineInfo.push({
                id: e.id,
                number: e.number,
                nmeaNumber: e.nmeaNumber != undefined ? e.nmeaNumber : e.number,
                name: e.engineShortName,
                on: on,
                idle: on && (0, $234930b26df9c152$export$479f26c6e67c2e2f)(log.engineRpms, n, status, thresholds)
            });
        }
        return engineInfo;
    },
    // Display name for one engine in a label: its short name, else its NMEA number,
    // else its configured number. Never "#1"-style -- the number is only ever shown
    // next to the translated "Engine" word, which already says what it numbers.
    engineLabelName (engine) {
        return engine.name || `${engine.nmeaNumber != undefined ? engine.nmeaNumber : engine.number}`;
    },
    // Label for the navigation view's engine field.
    //
    // Two or more engines share a single "Engine {name}" so the word is not repeated
    // per engine in a row that is already tight ("Engine Starboard | Portside", not
    // "Engine Starboard | Engine Portside").
    //
    // A single *named* engine keeps "Engine {name}", but a single *unnamed* one drops
    // to the bare "Engine": there is nothing to disambiguate, so "Engine 1" would only
    // add noise. No engines at all yields an empty label rather than a stray word.
    engineLabel (app, engines) {
        const ft = app.getT("LogNavigationView");
        if (engines.length === 0) return "";
        if (engines.length === 1) return engines[0].name ? ft("engine_name", {
            name: engines[0].name
        }) : ft("engine");
        return ft("engine_name", {
            name: engines.map($2b4c51d286f985e1$export$391f39dba41666e2.engineLabelName).join(" | ")
        });
    },
    // Width budget for the engine field, so a one-engine ship does not reserve the
    // room a twin needs. Sized off the ship's configured `engineCount` rather than the
    // rendered engine list, so the field keeps its place while engine data is still
    // loading (or when a configured engine is skipped for having no number at all).
    engineFieldMaxWidth (engineCount) {
        return engineCount === 1 ? "8.6em" : `${engineCount * 9}em`;
    },
    // True wind angle (0-180, symmetric either side of the bow) + point-of-sail category
    // + wind side, derived from heading and true windDirection (both plain ILog fields,
    // no NMEA/live data required). See #68. `undefined` inputs (0 is a valid heading or
    // wind direction, not "missing") yield `undefined`, since there's nothing to derive.
    courseToWind (heading, windDirection) {
        if (heading == undefined || windDirection == undefined) return undefined;
        // Signed shortest turn from heading to wind; positive is to starboard, negative to
        // port (same convention as the course-change side calculation in Log/nmea.ts).
        const signed = (windDirection - heading + 540) % 360 - 180;
        const angle = Math.abs(signed);
        let pointOfSail;
        if (angle < 40) pointOfSail = "noGo";
        else if (angle < 70) pointOfSail = "closeHauled";
        else if (angle < 120) pointOfSail = "beamReach";
        else if (angle < 150) pointOfSail = "broadReach";
        else pointOfSail = "running";
        // Dead ahead (0) or dead astern (180): neither side is meaningful.
        const side = signed == 0 || angle == 180 ? undefined : signed > 0 ? "starboard" : "port";
        return {
            angle: angle,
            pointOfSail: pointOfSail,
            side: side
        };
    }
};
function $2b4c51d286f985e1$export$c0446c7cd14ca404({ editable: editable, initSaveError: initSaveError, onClick: onClick, recordSavedLog: recordSavedLog, status: status, statuses: statuses, updated: _updated }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const [ship, log] = [
        (0, $97ac05743b787a86$export$f581995c9f2db6f0)(),
        (0, $97ac05743b787a86$export$f4f9faa631770428)()
    ];
    const { logs: logs, auditLogEdits: auditLogEdits, recordAuditLogEdits: recordAuditLogEdits, updateLog: updateLog, updateLogEngine: updateLogEngine, updateLogSails: updateLogSails } = (0, $97ac05743b787a86$export$95d65094202e15e7)();
    const ft = app.getT("LogNavigationView");
    const [autocompleteLogComment, setAutocompleteLogComment] = (0, $acw62.useState)(undefined);
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const editableFields = [
        "comment",
        {
            name: "course",
            type: "float"
        },
        {
            name: "depth",
            type: "float"
        },
        {
            name: "distance",
            type: "float"
        },
        {
            array: true,
            default: -1,
            name: "engineRpms",
            type: "int"
        },
        {
            name: "heading",
            type: "int"
        },
        "location",
        {
            name: "log",
            type: "float"
        },
        "sails",
        {
            name: "sog",
            type: "float"
        },
        {
            name: "stw",
            type: "float"
        }
    ];
    const formEditable = app.editable && editable;
    const _enginesEditable = formEditable;
    // Mirrors the server's `logs.update` field-editability rule (issue #529) — see
    // `Views/Log/editability.ts`. Replaces the old purely-live-NMEA-status check, which
    // didn't account for the ship's `editPermissiveness` level, the editable-age/recency
    // window, or a field already having been manually superseded on this log.
    const level = (_a = (0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship).editPermissiveness) !== null && _a !== void 0 ? _a : (0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).strict;
    const fieldEditable = (0, $acw62.useCallback)((field)=>{
        return formEditable && (0, $e000d4a262f1f979$export$c4d316b0f08548e5)(field, log, logs, auditLogEdits, level, (0, $ec32d24fbaadaf04$export$680ea196effce5f).timeUtc(), app.forceLogEditable);
    }, [
        formEditable,
        log,
        logs,
        auditLogEdits,
        level,
        app.forceLogEditable
    ]);
    // Issue #1142 (broader fix): mirrors every field's own `readOnly` condition below,
    // so `EditGroup` never even attempts to submit a value for a currently
    // non-editable field -- not even its own (possibly stale, display-rounded)
    // `defaultValue`. This is what stops an unrelated edit (e.g. Comment) from ever
    // resubmitting a protected NMEA-capable field's rounded display value and
    // manufacturing a spurious "changed" edit server-side.
    const isFieldEditable = (0, $acw62.useCallback)((field)=>{
        switch(field){
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).course:
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).depth:
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).distance:
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).engineRpms:
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).heading:
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).log:
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).sog:
            case (0, $8cadfca9ff813a6b$export$e1325bf74d86b103).stw:
                return fieldEditable(field);
            case "location":
                // `location` is `.always` server-side, so `fieldEditable()` alone would
                // treat it as editable whenever the form is -- but the input below further
                // restricts it to only the log that actually started the current status.
                return formEditable && (status === null || status === void 0 ? void 0 : status.startLogId) == log.id;
            default:
                // comment, sails: `.always`-editable, gated only by `formEditable` (see
                // their own `readOnly` conditions below).
                return formEditable;
        }
    }, [
        fieldEditable,
        formEditable,
        status,
        log
    ]);
    const [saveError, setSaveError] = (0, $acw62.useState)(initSaveError);
    // Field-name -> localized-label map for `saveErrorMessage`. `course`/`sog`/`stw`/
    // `depth`/`heading`/`log`/`engineRpms` are `.nmeaCapable` and can genuinely appear
    // in an `EditNotAllowedError` (issue #1142: course/sog are GPS-derived, tagged the
    // same as NMEA-supplied fields). `distance` is `.locked` (permanently read-only
    // client-side, so a rejection for it should never actually happen) and
    // `comment`/`location` are `.always` -- all three are mapped anyway since their
    // labels already exist and cost nothing extra; `sails` has no field label of its
    // own (falls back to the raw field name if it were ever rejected, which it never
    // is -- sail changes go through a separate route).
    const saveErrorFieldLabels = (0, $acw62.useMemo)(()=>({
            comment: ft("comment"),
            course: ft("course"),
            depth: ft("depth"),
            distance: ft("distance"),
            engineRpms: ft("engine_rpms"),
            heading: ft("heading"),
            location: ft("location"),
            log: ft("log"),
            sog: ft("sog"),
            stw: ft("stw")
        }), [
        ft
    ]);
    const saveErrorText = (0, $acw62.useMemo)(()=>(0, $a6db0417d7b66a9b$export$3b04090cc2c1b2d)(saveError, saveErrorFieldLabels, {
            fields: (labels)=>ft("save_error_fields", {
                    fields: labels
                }),
            generic: ft("save_error_generic")
        }), [
        saveError,
        saveErrorFieldLabels,
        ft
    ]);
    // Wired as EditGroup's `onSaveError` prop -- called with the rejected error on a
    // failed save, and with `undefined` at the start of every new submit attempt (see
    // EditGroup.tsx). A real error also resets `edited`, which is what stops
    // EditGroup's own auto-resubmit effect from silently resubmitting the now-reverted
    // (unchanged) form and clearing this error the instant that resubmit starts (issue
    // #1142). Mirrors useEditForm.ts's handleSaveError.
    const handleSaveError = (0, $acw62.useCallback)((error)=>{
        setSaveError(error);
        if (error !== undefined) resetEdited();
    }, [
        resetEdited
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const saveEdits = (0, $acw62.useCallback)(async (_data, values)=>{
        // Acknowledge only the submitted draft; typing during the request must mark
        // the form dirty again so EditGroup saves it after this request finishes.
        resetEdited();
        const result = await updateLog(log.id, values);
        if (result) {
            if (result.log) recordSavedLog === null || recordSavedLog === void 0 || recordSavedLog(result.log);
            if (result.auditLogEdits) recordAuditLogEdits(result.auditLogEdits);
        }
    }, [
        log,
        recordAuditLogEdits,
        recordSavedLog,
        updateLog,
        resetEdited
    ]);
    (0, $acw62.useEffect)(()=>{
        const load = async ()=>{
            if (autocompleteLogComment) return;
            const logCommentData = await $2b4c51d286f985e1$export$391f39dba41666e2.loadLogCommentAutocomplete(app.apiClient, log.shipId);
            setAutocompleteLogComment((logCommentData === null || logCommentData === void 0 ? void 0 : logCommentData.values) || []);
        };
        load().catch(console.error);
    });
    const courseToWind = (0, $acw62.useMemo)(()=>{
        return $2b4c51d286f985e1$export$391f39dba41666e2.courseToWind(log.heading, log.windDirection);
    }, [
        log.heading,
        log.windDirection
    ]);
    const courseToWindText = (0, $acw62.useMemo)(()=>{
        if (!courseToWind) return "";
        return [
            app.format("angle", courseToWind.angle),
            ft(`point_of_sail_${courseToWind.pointOfSail}`),
            courseToWind.side ? ft(`wind_side_${courseToWind.side}`) : undefined
        ].filter(Boolean).join(" | ");
    }, [
        courseToWind
    ]);
    const engineStatuses = (0, $acw62.useMemo)(()=>{
        return $2b4c51d286f985e1$export$391f39dba41666e2.engineStatuses(statuses);
    }, [
        log,
        statuses
    ]);
    const engines = (0, $acw62.useMemo)(()=>{
        return $2b4c51d286f985e1$export$391f39dba41666e2.engines(ship, log, engineStatuses);
    }, [
        engineStatuses,
        ship,
        log
    ]);
    const maxEngine = (0, $acw62.useMemo)(()=>{
        return engines.map((e)=>e.nmeaNumber || 1).reduce((a, b)=>Math.max(a, b), -Infinity);
    }, [
        engines
    ]);
    const _updateEngine = (0, $acw62.useCallback)(async (engine, on)=>{
        await updateLogEngine(log.id, engine, on);
    }, [
        engines,
        updateLogEngine,
        log
    ]);
    const statusData = (0, $acw62.useMemo)(()=>{
        return $2b4c51d286f985e1$export$391f39dba41666e2.statusData(status);
    }, [
        status
    ]);
    // The day view hands over a *closed* window, so a stage this log replaced is in here
    // too. Reefing keeps the sail up, so that stage is dropped: the field shows one chip for
    // the new stage instead of pairing it with a struck one, and -- because the old value no
    // longer counts as taken -- the reef can be shaken back out on this very log (#1288).
    const sailStatuses = (0, $acw62.useMemo)(()=>{
        return (0, $234930b26df9c152$export$fe8e26d7a5865a81)((statuses || []).filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).sails), log.id);
    }, [
        statuses,
        log
    ]);
    const sailName = (0, $acw62.useCallback)((id, reef, sails)=>{
        return $2b4c51d286f985e1$export$391f39dba41666e2.sailName(app, id, reef, sails);
    }, []);
    const sailStatusValues = (0, $acw62.useMemo)(()=>{
        const sails = (0, $22871482fce5b7e5$export$7930c61d9b464618).sails(ship);
        return sailStatuses.map((status)=>{
            const sail = sails.find((s)=>s.id == status.name);
            if (sail && status.name) return {
                icon: status.startLogId == log.id ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowUp : status.endLogId == log.id ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowDown : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleFilledLarge,
                remove: status.endLogId == undefined || status.startLogId == log.id,
                title: sailName(status.name, status.value, sails),
                value: status.value > 0 ? `${status.name}:${status.value}` : status.name
            };
            return undefined;
        }).filter(Boolean);
    }, [
        log,
        statuses,
        sailStatuses
    ]);
    const sailOptions = (0, $acw62.useMemo)(()=>{
        const sails = (0, $22871482fce5b7e5$export$7930c61d9b464618).sails(ship);
        const sailValues = sailStatuses.map((status)=>status.value > 0 ? `${status.name}:${status.value}` : status.name);
        return sails.flatMap((sail)=>{
            const items = [
                {
                    disabled: sailValues.indexOf(sail.id) >= 0,
                    title: sailName(sail.id, 0, sails),
                    value: sail.id
                }
            ];
            if (sail.reefNo && sail.reefNo > 0) for(let i = 1; i <= sail.reefNo; i++)items.push({
                disabled: sailValues.indexOf(`${sail.id}:${i}`) >= 0,
                title: sailName(sail.id, i, sails),
                value: `${sail.id}:${i}`
            });
            return items;
        });
    }, [
        ship,
        log,
        statuses,
        sailStatuses
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const selectSails = (0, $acw62.useCallback)(async (values)=>{
        await updateLogSails(log.id, values);
    }, [
        ship,
        sailStatuses,
        updateLogSails,
        log
    ]);
    function rpmValue(engine) {
        if (!log.engineRpms || log.engineRpms[engine] == undefined || log.engineRpms[engine] < 1) return "";
        return app.format("rpm", log.engineRpms[engine]);
    }
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: "LogView-navigation",
        onClick: onClick,
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
            buttonFirst: true,
            changed: edited,
            editable: formEditable,
            editableFields: editableFields,
            error: saveErrorText,
            isFieldEditable: isFieldEditable,
            onSave: saveEdits,
            onSaveError: handleSaveError,
            children: [
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("status"),
                            className: "block_field_small_12 nav_status",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                className: "input",
                                children: status && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            className: "ship-status-icon",
                                            icon: `status-${(0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[status.value]}`
                                        }),
                                        ft("status_" + (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[status.value])
                                    ]
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("time"),
                            className: "block_field_small_6",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                defaultValue: app.format("time", log.time),
                                readOnly: true
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("time_utc"),
                            className: "block_field_small_6",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                defaultValue: app.format("timeUtc", log.timeUtc),
                                readOnly: true
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("position"),
                            className: "block_field_small_14",
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: app.format("gps-lat", log.lat),
                                        readOnly: true
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: app.format("gps-lng", log.lng),
                                        readOnly: true
                                    })
                                ]
                            })
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("course"),
                            className: "block_field_small_6",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                defaultValue: app.format("course", log.course),
                                name: "course",
                                onChange: onEdited,
                                readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).course)
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("heading"),
                            className: "block_field_small_6",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                defaultValue: app.format("course", log.heading),
                                name: "heading",
                                onChange: onEdited,
                                readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).heading)
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("sog"),
                            className: "block_field_small_6",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                defaultValue: app.format("speed", log.sog),
                                name: "sog",
                                onChange: onEdited,
                                readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).sog)
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("stw"),
                            className: "block_field_small_6",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                defaultValue: app.format("speed", log.stw),
                                name: "stw",
                                onChange: onEdited,
                                readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).stw)
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("distance"),
                            className: "block_field_small_6",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                defaultValue: app.format("distance", log.distance),
                                name: "distance",
                                onChange: onEdited,
                                readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).distance)
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("log"),
                            className: "block_field_small_8",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                defaultValue: app.format("distance", log.log),
                                name: "log",
                                onChange: onEdited,
                                readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).log)
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("depth"),
                            className: "block_field_small_6",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                defaultValue: app.format("meters", log.depth),
                                name: "depth",
                                onChange: onEdited,
                                readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).depth)
                            })
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: [
                        (0, $22871482fce5b7e5$export$7930c61d9b464618).isSailingVessel(ship) && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("sails"),
                            className: "sail-select",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $00eb459a7fe35365$export$1e7dfd31545b5809), {
                                button: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                }),
                                values: sailStatusValues,
                                onSelect: selectSails,
                                options: sailOptions,
                                readOnly: !formEditable
                            }, sailStatusValues.join("-"))
                        }),
                        (0, $22871482fce5b7e5$export$7930c61d9b464618).isSailingVessel(ship) && courseToWind && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("course_to_wind"),
                            className: "course-to-wind block_field_small_14",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                className: "input",
                                children: courseToWindText
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: $2b4c51d286f985e1$export$391f39dba41666e2.engineLabel(app, engines),
                            style: {
                                maxWidth: $2b4c51d286f985e1$export$391f39dba41666e2.engineFieldMaxWidth(ship.engineCount)
                            },
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: [
                                    (log.engineRpms != undefined || engines.some((engine)=>engine.on)) && (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "hidden",
                                        name: "engineRpms.length",
                                        value: maxEngine + 1
                                    }),
                                    engines.map((engine, i)=>{
                                        var _a, _b;
                                        const n = (0, $2e799dc50d0acd79$export$2ab9a8f9f1186f14)(-1, engine.nmeaNumber, engine.number);
                                        const rpm = rpmValue(n);
                                        let status;
                                        if (engine.on) status = (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                    className: "LogbookIcon-engine LogbookIcon-engine-nav",
                                                    icon: engine.idle ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleHalfLarge : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleFilledLarge
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                    defaultValue: rpm,
                                                    maxLength: 5,
                                                    placeholder: rpm,
                                                    name: `engineRpms[${n}]`,
                                                    onChange: onEdited,
                                                    readOnly: !fieldEditable((0, $8cadfca9ff813a6b$export$e1325bf74d86b103).engineRpms),
                                                    className: "block_field_rpm"
                                                })
                                            ]
                                        });
                                        else status = (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                    className: "LogbookIcon-engine LogbookIcon-engine-nav",
                                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleLarge
                                                }),
                                                log.engineRpms != undefined && (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "hidden",
                                                    name: `engineRpms[${n}]`,
                                                    value: (_a = log.engineRpms[n]) !== null && _a !== void 0 ? _a : -1
                                                })
                                            ]
                                        });
                                        return (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                            children: [
                                                status,
                                                i < ship.engineCount - 1 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {})
                                            ]
                                        }, (_b = engine.id) !== null && _b !== void 0 ? _b : i);
                                    })
                                ]
                            })
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: ft("comment"),
                        className: "",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$909904bdb4cb4458), {
                            defaultValue: log.comment,
                            name: "comment",
                            onChange: onEdited,
                            readOnly: !formEditable,
                            suggestions: autocompleteLogComment
                        })
                    })
                }),
                status && status.value != (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).inmotion && status.value != (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).drifting && (status.startLogId == log.id || statusData && statusData.location && statusData.location != "") && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: ft("location"),
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            defaultValue: statusData === null || statusData === void 0 ? void 0 : statusData.location,
                            name: "location",
                            onChange: onEdited,
                            readOnly: !formEditable || status.startLogId != log.id
                        })
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");






const $47858fdb5fdea477$export$f8fae20589f32a5 = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    saveLog (api, shipId, logId, values) {
        return new (0, $199ead3c99f138be$export$89c3ec6dea3c6061)(api).logs.update({
            params: {
                shipId: shipId,
                logId: logId
            },
            body: values
        }).call();
    }
};
function $47858fdb5fdea477$export$6bc9cfd4addb0bb9({ editable: editable, initSaveError: initSaveError, onClick: onClick, recordSavedLog: recordSavedLog }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const log = (0, $97ac05743b787a86$export$f4f9faa631770428)();
    const { recordAuditLogEdits: recordAuditLogEdits, updateLog: updateLog } = (0, $97ac05743b787a86$export$95d65094202e15e7)();
    const ft = app.getT("LogWatchView");
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const [saveError, setSaveError] = (0, $acw62.useState)(initSaveError);
    const editableFields = [
        "watch",
        "watchComment"
    ];
    const formEditable = app.editable && editable;
    // `watch`/`watchComment` are both `.always` (see `Log/editability.ts`) and can never
    // actually be rejected by `logs.update`'s `EditNotAllowedError`, so there is no
    // field-specific rejection message here -- only the generic fallback, covering
    // network/other failures.
    const saveErrorText = (0, $acw62.useMemo)(()=>(0, $a6db0417d7b66a9b$export$3b04090cc2c1b2d)(saveError, {}, {
            fields: ()=>ft("save_error_generic"),
            generic: ft("save_error_generic")
        }), [
        saveError,
        ft
    ]);
    // Wired as EditGroup's `onSaveError` prop -- called with the rejected error on a
    // failed save, and with `undefined` at the start of every new submit attempt (see
    // EditGroup.tsx). A real error also resets `edited`, which is what stops
    // EditGroup's own auto-resubmit effect from silently resubmitting the now-reverted
    // (unchanged) form and clearing this error the instant that resubmit starts (issue
    // #1142). Mirrors useEditForm.ts's handleSaveError.
    const handleSaveError = (0, $acw62.useCallback)((error)=>{
        setSaveError(error);
        if (error !== undefined) resetEdited();
    }, [
        resetEdited
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const saveEdits = (0, $acw62.useCallback)(async (_data, values)=>{
        const result = await updateLog(log.id, values);
        if (result) {
            if (result.log) recordSavedLog === null || recordSavedLog === void 0 || recordSavedLog(result.log);
            if (result.auditLogEdits) recordAuditLogEdits(result.auditLogEdits);
            resetEdited();
        }
    }, [
        log,
        recordAuditLogEdits,
        recordSavedLog,
        updateLog,
        resetEdited
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: "LogView-watch block",
        onClick: onClick,
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
            buttonFirst: true,
            changed: edited,
            editable: formEditable,
            editableFields: editableFields,
            error: saveErrorText,
            onSave: saveEdits,
            onSaveError: handleSaveError,
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: ft("watch"),
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            defaultValue: log.watch,
                            name: "watch",
                            onChange: onEdited,
                            readOnly: !formEditable
                        })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: ft("watch_comment"),
                        children: (0, $7b02d682eb115277$exports.jsx)("textarea", {
                            defaultValue: log.watchComment,
                            name: "watchComment",
                            onChange: onEdited,
                            rows: 4,
                            readOnly: !formEditable
                        })
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");










const $9733af974dd48a7e$export$f4b3ad3f6735a292 = {
    // Options for the recipients multi-select: the ship crew, optionally restricted
    // to the current day's crew ids, keyed by the (string) user id.
    userOptions (shipUsers, crewIds) {
        return (shipUsers || []).filter((u)=>crewIds == undefined || crewIds.includes(u.id)).map((u)=>({
                title: (0, $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a).userLabel(u),
                value: String(u.id)
            }));
    },
    // Options for the watch-group multi-select, resolved from the day's persisted
    // watch data. Unnamed groups are skipped (they cannot be labelled).
    groupOptions (day) {
        var _a;
        if (!day) return [];
        const groups = ((_a = (0, $50f4daf09d2513a4$export$7a9a31a911eb9a20).parse(day).dataParsed.watch) === null || _a === void 0 ? void 0 : _a.groups) || [];
        return groups.filter((g)=>g.name.trim().length > 0).map((g)=>({
                title: g.name,
                value: g.id
            }));
    },
    // A message alert may be sent only with a non-empty body and at least one
    // recipient (a user or a watch group).
    canSend (message, users, groups) {
        return message.trim().length > 0 && (users.length > 0 || groups.length > 0);
    },
    buildRequest (users, groups, message, severity, loudness) {
        return {
            users: users.map((u)=>parseInt(u, 10)),
            groups: groups,
            message: message.trim(),
            severity: severity,
            loudness: loudness
        };
    }
};
function $9733af974dd48a7e$export$e72c8ad94e332aa0({ onClose: onClose, initUsers: initUsers, initGroups: initGroups, initMessage: initMessage, initSeverity: initSeverity, initLoudness: initLoudness, initBusy: initBusy, initFailed: initFailed }) {
    var _a, _b;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("SendAlertDialog");
    const { day: day } = (0, $97ac05743b787a86$export$95d65094202e15e7)();
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    const userOptions = (0, $acw62.useMemo)(()=>$9733af974dd48a7e$export$f4b3ad3f6735a292.userOptions(shipUsers, day === null || day === void 0 ? void 0 : day.crew), [
        shipUsers,
        day
    ]);
    const groupOptions = (0, $acw62.useMemo)(()=>$9733af974dd48a7e$export$f4b3ad3f6735a292.groupOptions(day), [
        day
    ]);
    const [users, setUsers] = (0, $acw62.useState)(initUsers !== null && initUsers !== void 0 ? initUsers : []);
    const [groups, setGroups] = (0, $acw62.useState)(initGroups !== null && initGroups !== void 0 ? initGroups : []);
    const [message, setMessage] = (0, $acw62.useState)(initMessage !== null && initMessage !== void 0 ? initMessage : "");
    const [severity, setSeverity] = (0, $acw62.useState)(initSeverity !== null && initSeverity !== void 0 ? initSeverity : (0, $ed9e79f0f649608a$export$63ce30087a699ab4).warning);
    const [loudness, setLoudness] = (0, $acw62.useState)(initLoudness !== null && initLoudness !== void 0 ? initLoudness : (0, $62c07736c3fbb91c$export$3258e89f1be8b566).audible);
    const [busy, setBusy] = (0, $acw62.useState)(initBusy !== null && initBusy !== void 0 ? initBusy : false);
    const [failed, setFailed] = (0, $acw62.useState)(initFailed !== null && initFailed !== void 0 ? initFailed : false);
    const severityOptions = (0, $acw62.useMemo)(()=>[
            {
                title: t("severity_warning"),
                value: (0, $ed9e79f0f649608a$export$63ce30087a699ab4).warning
            },
            {
                title: t("severity_alarm"),
                value: (0, $ed9e79f0f649608a$export$63ce30087a699ab4).alarm
            }
        ], [
        app.language
    ]);
    const loudnessOptions = (0, $acw62.useMemo)(()=>[
            {
                title: t("loudness_audible"),
                value: (0, $62c07736c3fbb91c$export$3258e89f1be8b566).audible
            },
            {
                title: t("loudness_notificationOnly"),
                value: (0, $62c07736c3fbb91c$export$3258e89f1be8b566).notificationOnly
            }
        ], [
        app.language
    ]);
    const canSend = (0, $acw62.useMemo)(()=>$9733af974dd48a7e$export$f4b3ad3f6735a292.canSend(message, users, groups), [
        message,
        users,
        groups
    ]);
    const send = (0, $acw62.useCallback)(async ()=>{
        if (!canSend || busy) return;
        setBusy(true);
        setFailed(false);
        try {
            const body = $9733af974dd48a7e$export$f4b3ad3f6735a292.buildRequest(users, groups, message, severity, loudness);
            await new (0, $d4eccb73927932bb$export$4c70e389659ec851)(app.apiClient).alert.message({
                params: {},
                body: body
            }).call();
            onClose();
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("SendAlertDialog send", error);
            setFailed(true);
            setBusy(false);
        }
    }, [
        canSend,
        busy,
        users,
        groups,
        message,
        severity,
        loudness,
        app,
        onClose
    ]);
    const userValues = (0, $acw62.useMemo)(()=>users.map((id)=>{
            var _a;
            return {
                value: id,
                title: ((_a = userOptions.find((o)=>o.value == id)) === null || _a === void 0 ? void 0 : _a.title) || id
            };
        }), [
        users,
        userOptions
    ]);
    const groupValues = (0, $acw62.useMemo)(()=>groups.map((id)=>{
            var _a;
            return {
                value: id,
                title: ((_a = groupOptions.find((o)=>o.value == id)) === null || _a === void 0 ? void 0 : _a.title) || id
            };
        }), [
        groups,
        groupOptions
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        className: "SendAlertDialog",
        closeCallback: onClose,
        title: t("title"),
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "Overlay-body",
            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("users"),
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $00eb459a7fe35365$export$1e7dfd31545b5809), {
                                button: (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: "+"
                                }),
                                name: "users",
                                onSelect: setUsers,
                                options: userOptions,
                                values: userValues
                            })
                        })
                    }),
                    (groupOptions.length > 0 || groups.length > 0) && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("groups"),
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $00eb459a7fe35365$export$1e7dfd31545b5809), {
                                button: (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: "+"
                                }),
                                name: "groups",
                                onSelect: setGroups,
                                options: groupOptions,
                                values: groupValues
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("message"),
                            children: (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                className: "SendAlertDialog-message",
                                name: "message",
                                value: message,
                                onChange: (e)=>setMessage(e.target.value)
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("severity"),
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                                    button: ((_a = severityOptions.find((o)=>o.value == severity)) === null || _a === void 0 ? void 0 : _a.title) || "",
                                    name: "severity",
                                    value: severity,
                                    onSelect: (v)=>setSeverity(v),
                                    options: severityOptions
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("loudness"),
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                                    button: ((_b = loudnessOptions.find((o)=>o.value == loudness)) === null || _b === void 0 ? void 0 : _b.title) || "",
                                    name: "loudness",
                                    value: loudness,
                                    onSelect: (v)=>setLoudness(v),
                                    options: loudnessOptions
                                })
                            })
                        ]
                    }),
                    failed && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "SendAlertDialog-error",
                                children: t("error")
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        actions: true,
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button default",
                                    onClick: onClose,
                                    children: t("cancel")
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button primary",
                                    disabled: !canSend || busy,
                                    onClick: send,
                                    children: t("send")
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}


function $3369ccde6b7b7538$export$8101c6120d78974d({ createCallback: createCallback, focusEditable: focusEditable, engines: engines, hasNmeaEngineData: hasNmeaEngineData, engineStatusCallback: engineStatusCallback, initLogButtonMenuOpen: initLogButtonMenuOpen, initLogButtonSubmenu: initLogButtonSubmenu, lightingCallback: lightingCallback, lightingValue: lightingValue, lightingOptions: lightingOptions, sails: sails, sailChangesCallback: sailChangesCallback, label: label, manualStatusActive: manualStatusActive, shipStatusValue: shipStatusValue, statusOptions: statusOptions }) {
    const [sendAlert, setSendAlert] = (0, $acw62.useState)(false);
    const shipStatusIcon = (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
        className: "LogView-status-icon",
        icon: shipStatusValue == (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleLarge : `status-${(0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[shipStatusValue]}`
    }, `status-icon-${shipStatusValue}`);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "LogView-pre-timeline",
                children: createCallback ? focusEditable ? (0, $7b02d682eb115277$exports.jsx)((0, $5c7e4f6714165da4$export$a2d7a90541d38038), {
                    createCallback: createCallback,
                    disabled: false,
                    engines: engines,
                    hasNmeaEngineData: hasNmeaEngineData,
                    engineStatusCallback: engineStatusCallback,
                    initOpen: initLogButtonMenuOpen,
                    initOpenSubmenu: initLogButtonSubmenu,
                    lightingCallback: lightingCallback,
                    lightingValue: lightingValue,
                    lightingOptions: lightingOptions,
                    label: label,
                    manualStatusActive: manualStatusActive,
                    onSendAlert: ()=>setSendAlert(true),
                    sails: sails,
                    saveSails: sailChangesCallback,
                    shipStatusIcon: shipStatusIcon,
                    shipStatusValue: shipStatusValue,
                    statusOptions: statusOptions
                }) : shipStatusIcon : (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: shipStatusIcon
                })
            }),
            sendAlert && (0, $7b02d682eb115277$exports.jsx)((0, $9733af974dd48a7e$export$e72c8ad94e332aa0), {
                onClose: ()=>setSendAlert(false)
            })
        ]
    });
}








// The three `DayEditableField`s a day-edit log entry can announce, mapped to the
// change type the renderer translates with. Mirrors `Day.rosterEditableFields` in
// `Sources/LogbookApp/DayApi.swift`.
const $bc8031cc1fd7bd6d$var$rosterChangeTypes = {
    crew: (0, $c931aad0bd934103$export$a05a8a0b4c257163).crew,
    passengers: (0, $c931aad0bd934103$export$a05a8a0b4c257163).passengers,
    skipper: (0, $c931aad0bd934103$export$a05a8a0b4c257163).skipper
};
// A roster field's value is either a list of ship-user ids (crew/passengers), a
// single id (skipper), or unset. Normalise all three to a list so one diff covers
// them. Anything else (a malformed/legacy value) contributes nobody rather than
// throwing.
function $bc8031cc1fd7bd6d$var$shipUserIds(value) {
    if (Array.isArray(value)) return value.filter((entry)=>typeof entry === "number");
    return typeof value === "number" ? [
        value
    ] : [];
}
function $bc8031cc1fd7bd6d$export$f80b673804cc0b95(log, day, auditLogEdits) {
    const referencedIds = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed.auditLogEditIds;
    if (!referencedIds || referencedIds.length == 0 || !day || !auditLogEdits) return [];
    const dayEdits = auditLogEdits.filter((edit)=>edit.sourceType == (0, $1e7307a9deb5d870$export$6322af8f4e594d6e).day && edit.sourceId == day.id && $bc8031cc1fd7bd6d$var$rosterChangeTypes[edit.field] != undefined);
    const entries = (0, $59aa08b9185fbe21$export$54b358b4e0fb8dc9)(dayEdits, (field)=>day[field]);
    const changes = [];
    for (const id of referencedIds){
        const entry = entries.find((e)=>e.id == id);
        const type = entry && $bc8031cc1fd7bd6d$var$rosterChangeTypes[entry.field];
        if (!entry || type == undefined) continue;
        const previous = $bc8031cc1fd7bd6d$var$shipUserIds(entry.previousValue);
        const current = $bc8031cc1fd7bd6d$var$shipUserIds(entry.newValue);
        const removals = previous.filter((i)=>!current.includes(i)).map((shipUserId)=>({
                action: (0, $c931aad0bd934103$export$da30b091b7382d5a).remove,
                type: type,
                id: shipUserId
            }));
        const additions = current.filter((i)=>!previous.includes(i)).map((shipUserId)=>({
                action: (0, $c931aad0bd934103$export$da30b091b7382d5a).add,
                type: type,
                id: shipUserId
            }));
        changes.push(...type == (0, $c931aad0bd934103$export$a05a8a0b4c257163).skipper ? [
            ...additions,
            ...removals
        ] : [
            ...removals,
            ...additions
        ]);
    }
    return changes;
}





var $acw62 = parcelRequire("acw62");







function $251f3561e98d3db5$export$3a52cda2c00837c3(app, alert, vesselType) {
    var _a, _b;
    try {
        const data = JSON.parse(alert.data || "{}");
        switch(alert.name){
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).anchorDrift:
                // The drift distance is meters, like every other anchor-watch radius (#1809).
                return app.format("meters", data.distance);
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).depth:
                return app.format("depth", data.depth);
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).lights:
                {
                    const lights = data;
                    const recorded = app.t((0, $193beb513144bdb6$export$a4ef803d3e256716)((_a = lights.recorded) !== null && _a !== void 0 ? _a : (0, $3bedadb68df9862e$export$966979137e3fd0b5).none, vesselType));
                    const recommended = app.t((0, $193beb513144bdb6$export$a4ef803d3e256716)((_b = lights.recommended) !== null && _b !== void 0 ? _b : (0, $3bedadb68df9862e$export$966979137e3fd0b5).none, vesselType));
                    return `${recorded} \u{2192} ${recommended}`;
                }
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).lostPosition:
                return app.t(`LogView_log_alert_lostPosition_${data.reason}`);
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).message:
                return data.message;
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).manOverboard:
                return app.t(`LogView_log_alert_manOverboard_${data.status}`);
            default:
                return undefined;
        }
    } catch (_c) {
        return undefined;
    }
}
function $251f3561e98d3db5$export$8ebcecbecdb22732({ alert: alert, lightingIcons: lightingIcons, vesselType: suppliedVesselType }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const shipContext = (0, $acw62.useContext)((0, $97ac05743b787a86$export$74bc7108ae339b7));
    const vesselType = suppliedVesselType !== null && suppliedVesselType !== void 0 ? suppliedVesselType : (_a = shipContext === null || shipContext === void 0 ? void 0 : shipContext.ship) === null || _a === void 0 ? void 0 : _a.vesselType;
    function Status(name, value) {
        return [
            name,
            value
        ].join("-");
    }
    return (0, $acw62.useMemo)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const data = JSON.parse(alert.data || "{}");
        const anchorDrift = data;
        const depth = data;
        const lostPosition = data;
        const lights = data;
        const message = data;
        const manOverboard = data;
        if (!alert.name) return null;
        switch(Status(alert.name, alert.value)){
            case Status((0, $ed9e79f0f649608a$export$5ebaef48f8647867).message, (0, $ed9e79f0f649608a$export$63ce30087a699ab4).alarm):
            case Status((0, $ed9e79f0f649608a$export$5ebaef48f8647867).message, (0, $ed9e79f0f649608a$export$63ce30087a699ab4).warning):
                return (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "AlertMessage",
                    children: message.message
                });
            case Status((0, $ed9e79f0f649608a$export$5ebaef48f8647867).anchorDrift, (0, $ed9e79f0f649608a$export$63ce30087a699ab4).alarm):
                return (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.alert.anchorDrift.alarm,
                    replace: {
                        distance: app.format("meters", anchorDrift.distance)
                    }
                });
            case Status((0, $ed9e79f0f649608a$export$5ebaef48f8647867).anchorDrift, (0, $ed9e79f0f649608a$export$63ce30087a699ab4).warning):
                return (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.alert.anchorDrift.warning,
                    replace: {
                        distance: app.format("meters", anchorDrift.distance)
                    }
                });
            case Status((0, $ed9e79f0f649608a$export$5ebaef48f8647867).depth, (0, $ed9e79f0f649608a$export$63ce30087a699ab4).alarm):
                return (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.alert.depth.alarm,
                    replace: {
                        depth: app.format("depth", depth.depth)
                    }
                });
            case Status((0, $ed9e79f0f649608a$export$5ebaef48f8647867).depth, (0, $ed9e79f0f649608a$export$63ce30087a699ab4).warning):
                return (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.alert.depth.warning,
                    replace: {
                        depth: app.format("depth", depth.depth)
                    }
                });
            case Status((0, $ed9e79f0f649608a$export$5ebaef48f8647867).lights, (0, $ed9e79f0f649608a$export$63ce30087a699ab4).warning):
                if (lightingIcons) {
                    const values = {
                        recommended: (_a = lights.recommended) !== null && _a !== void 0 ? _a : (0, $3bedadb68df9862e$export$966979137e3fd0b5).none,
                        recorded: (_b = lights.recorded) !== null && _b !== void 0 ? _b : (0, $3bedadb68df9862e$export$966979137e3fd0b5).none
                    };
                    const parts = ((_f = (_e = (_d = (_c = (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).Messages[app.language]) === null || _c === void 0 ? void 0 : _c.alert) === null || _d === void 0 ? void 0 : _d.lights) === null || _e === void 0 ? void 0 : _e.warning) !== null && _f !== void 0 ? _f : "").split(/(\*\*\{(?:recommended|recorded)\}\*\*)/);
                    return (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "LocalizedMessage AlertMessage-lights",
                        children: (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: parts.map((part, index)=>{
                                const name = part.includes("{recommended}") ? "recommended" : part.includes("{recorded}") ? "recorded" : undefined;
                                if (!name) return part;
                                const lighting = values[name];
                                const title = app.t((0, $193beb513144bdb6$export$a4ef803d3e256716)(lighting, vesselType));
                                return (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    className: `AlertMessage-lights-value ${name}`,
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $509263b967d03828$export$48a556eded34cd4e), {
                                            lighting: lighting,
                                            title: title
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: title
                                        })
                                    ]
                                }, index);
                            })
                        })
                    });
                }
                return (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.alert.lights.warning,
                    replace: {
                        recommended: app.t((0, $193beb513144bdb6$export$a4ef803d3e256716)((_g = lights.recommended) !== null && _g !== void 0 ? _g : (0, $3bedadb68df9862e$export$966979137e3fd0b5).none, vesselType)),
                        recorded: app.t((0, $193beb513144bdb6$export$a4ef803d3e256716)((_h = lights.recorded) !== null && _h !== void 0 ? _h : (0, $3bedadb68df9862e$export$966979137e3fd0b5).none, vesselType))
                    }
                });
            case Status((0, $ed9e79f0f649608a$export$5ebaef48f8647867).lostPosition, (0, $ed9e79f0f649608a$export$63ce30087a699ab4).alarm):
                return (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.alert.lostPosition[lostPosition.reason]
                });
            case Status((0, $ed9e79f0f649608a$export$5ebaef48f8647867).lostPosition, (0, $ed9e79f0f649608a$export$63ce30087a699ab4).warning):
                return (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.alert.lostPosition[lostPosition.reason]
                });
            // MOB never opens as a `.warning` — every trigger (device or manual) opens directly
            // at `.alarm` (see MOBConsumer / AppNavigation.triggerManOverboard).
            case Status((0, $ed9e79f0f649608a$export$5ebaef48f8647867).manOverboard, (0, $ed9e79f0f649608a$export$63ce30087a699ab4).alarm):
                return (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.alert.manOverboard[manOverboard.status]
                });
            default:
                return (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        "Unknown ",
                        alert.name
                    ]
                });
        }
    }, [
        alert,
        app,
        app.language,
        lightingIcons,
        vesselType
    ]);
}



// One alert transition, as a log row (#916). Names the alert and what happened to
// it, attributing the crew actions to whoever performed them.
//
// Only the actor is surfaced (@mutle): the entry also carries the skipper and the
// on-watch crew at that moment, but that belongs in the record rather than on the
// row -- it is stored because it cannot be reconstructed once the watch plan moves
// on, not because it needs displaying.
//
// A missing name falls back to the unattributed wording rather than rendering an
// empty clause: an actor who has since left the ship no longer resolves, and losing
// the fact that the alarm was silenced at all would be far worse than losing who
// did it.
function $8f49adaa708c152b$var$alertTransitionComment(entry, status, app, t, shipUsers, vesselType) {
    var _a, _b;
    const alert = t(`alert_${entry.alert}`);
    const name = entry.by != undefined ? (_a = shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.find((u)=>u.id == entry.by)) === null || _a === void 0 ? void 0 : _a.shortname : undefined;
    const transition = name ? t(`alert_${entry.action}_by`, {
        alert: alert,
        name: name
    }) : t(`alert_${entry.action}`, {
        alert: alert
    });
    if (!(status === null || status === void 0 ? void 0 : status.data)) return transition;
    const problem = (0, $251f3561e98d3db5$export$3a52cda2c00837c3)(app, status, vesselType);
    if (entry.alert != (0, $ed9e79f0f649608a$export$5ebaef48f8647867).lights) return problem ? t(`alert_${entry.alert}_detail`, {
        transition: transition,
        problem: problem
    }) : transition;
    try {
        const lights = (0, $d0f8aae9e6f7e80f$export$96e9906d6d93a972).parse(status).dataParsed;
        if (lights.recommended == undefined) return transition;
        const recorded = (_b = lights.recorded) !== null && _b !== void 0 ? _b : (0, $3bedadb68df9862e$export$966979137e3fd0b5).none;
        return t("alert_lights_detail", {
            transition: transition,
            recorded: app.t((0, $193beb513144bdb6$export$a4ef803d3e256716)(recorded, vesselType)),
            recommended: app.t((0, $193beb513144bdb6$export$a4ef803d3e256716)(lights.recommended, vesselType))
        });
    } catch (_c) {
        return transition;
    }
}
function $8f49adaa708c152b$var$pauseStopText(log, pauseStatus, logs, app, t) {
    const statusName = (pauseStatus === null || pauseStatus === void 0 ? void 0 : pauseStatus.value) != undefined ? (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[pauseStatus.value] : undefined;
    const statusText = statusName != undefined && (pauseStatus === null || pauseStatus === void 0 ? void 0 : pauseStatus.value) != (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none && (pauseStatus === null || pauseStatus === void 0 ? void 0 : pauseStatus.value) != (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).inmotion ? t(`status_${statusName}`) : undefined;
    const startLog = pauseStatus && logs.find((l)=>l.id == pauseStatus.startLogId);
    const duration = startLog ? app.format("time", log.timeUtc - startLog.timeUtc) : undefined;
    if (statusText) return duration ? t("pause_stop_status_duration", {
        status: statusText,
        duration: duration
    }) : t("pause_stop_status", {
        status: statusText
    });
    if (duration) return t("pause_stop_duration", {
        duration: duration
    });
    return t("pause_stop");
}
function $8f49adaa708c152b$export$94719616ea7cbe20(log, statuses, ctx) {
    return [
        $8f49adaa708c152b$export$3da413eab583011e(log, statuses, ctx),
        $8f49adaa708c152b$export$86c72d2eb1b98969(log, statuses, ctx),
        log.comment
    ].filter((comment)=>comment).join(" - ");
}
function $8f49adaa708c152b$export$3da413eab583011e(log, statuses, ctx) {
    var _a, _b, _c, _d;
    const { app: app, ship: ship, trip: trip, logs: logs = [] } = ctx;
    const t = app.getT("LogView_log");
    if ((trip === null || trip === void 0 ? void 0 : trip.importedAt) && log.comment) return undefined;
    const metadata = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed;
    const shipStatus = (()=>{
        const shipStatuses = statuses.filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship);
        const status = shipStatuses.find((s)=>log.id > 0 && s.startLogId == log.id && s.endLogId != log.id) || shipStatuses[shipStatuses.length - 1];
        return status;
    })();
    const shipStatusData = (()=>{
        if (shipStatus && shipStatus.data) {
            const parsed = (0, $d0f8aae9e6f7e80f$export$96e9906d6d93a972).parse(shipStatus);
            if (parsed.statusType === (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship) return parsed.dataParsed;
        }
        return undefined;
    })();
    const endStatuses = statuses.filter((s)=>s.endLogId == log.id);
    const startStatuses = statuses.filter((s)=>s.startLogId == log.id);
    const _engineStart = startStatuses.find((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).engine && s.startLogId == log.id);
    // Matched on the engine's own `item` where the entry names one, so a twin whose other
    // engine closes an interval on the same log can't be picked up here (#1819 testing).
    const engineStop = endStatuses.find((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).engine && (metadata.engineNumber == undefined || s.item == metadata.engineNumber));
    const engineSuffix = ship.engineCount > 1 ? "_name" : "";
    switch(metadata.type){
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).engine:
            if (metadata.engineStatus == (0, $c931aad0bd934103$export$c50f5cf960171685).on) {
                // #1819: an engine that comes up below the idle RPM threshold records the run
                // state it started in, so the entry says so instead of a bare "Started engine".
                // Entries recorded before that carry no run state and keep the plain wording.
                const idleStart = metadata.engineRunState == (0, $7045b0c2c870ef8a$export$e0db0830eb9f13ff).idle ? "_idle" : "";
                return t(`engine_start${idleStart}${engineSuffix}`, {
                    name: (0, $22871482fce5b7e5$export$7930c61d9b464618).engineName(ship, metadata.engineName, metadata.engineNumber)
                });
            } else {
                // The engine's run spans every interval that meets end-to-end back to the start
                // (#1819 testing): idle crossings split one run into several, and the interval
                // closing here is only its last segment.
                const runStart = (0, $234930b26df9c152$export$3a4fce362f474d01)((_a = ctx.dayStatuses) !== null && _a !== void 0 ? _a : statuses, engineStop);
                const startLog = logs.find((l)=>runStart && runStart.startLogId > 0 && l.id == runStart.startLogId);
                const engineMessage = metadata.engineStatus == (0, $c931aad0bd934103$export$c50f5cf960171685).missing ? "engine_missing" : "engine_stop";
                const distance = startLog && log.distance != undefined && startLog.distance != undefined ? app.format("distance", log.distance - startLog.distance) : "";
                const duration = startLog && log.timeUtc != undefined && startLog.timeUtc != undefined ? app.format("time", log.timeUtc - startLog.timeUtc) : "";
                // Each key only names what it is given: no start log means no duration and no
                // distance, and a run with no measurable distance still reports its duration.
                // Getting that mapping wrong is what printed a literal "{duration}".
                const detail = !duration ? "" : distance ? "_distance" : "_duration";
                return t(`${engineMessage}${detail}${engineSuffix}`, {
                    name: (0, $22871482fce5b7e5$export$7930c61d9b464618).engineName(ship, metadata.engineName, metadata.engineNumber),
                    duration: duration,
                    distance: distance
                });
            }
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).engineRunState:
            {
                // #1819: a still-running engine crossed the idle RPM threshold. Going into idle
                // is a plain state change; coming back under load names how long it idled,
                // measured over the idle interval that ends at this log (matched on the engine's
                // own `item`, so a second engine's status can't be picked up here).
                const name = (0, $22871482fce5b7e5$export$7930c61d9b464618).engineName(ship, metadata.engineName, metadata.engineNumber);
                if (metadata.engineRunState == (0, $7045b0c2c870ef8a$export$e0db0830eb9f13ff).idle) return t(`engine_idle${engineSuffix}`, {
                    name: name
                });
                const idleStatus = endStatuses.find((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).engine && s.item == metadata.engineNumber);
                const startLog = logs.find((l)=>idleStatus && l.id == idleStatus.startLogId);
                const duration = startLog && log.timeUtc != undefined && startLog.timeUtc != undefined ? app.format("time", log.timeUtc - startLog.timeUtc) : "";
                if (!duration) return t(`engine_load${engineSuffix}`, {
                    name: name
                });
                return t(`engine_load_duration${engineSuffix}`, {
                    name: name,
                    duration: duration
                });
            }
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).interval:
            return t("auto_interval", {
                duration: app.format("time", metadata.intervalDuration)
            });
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).shipStatus:
            if (metadata.shipStatus != undefined) {
                const location = shipStatusData && shipStatusData.location;
                if (location) return t("status_location", {
                    status: t(`status_${(0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[metadata.shipStatus]}`),
                    location: location
                });
                else return t(`status_${(0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[metadata.shipStatus]}`);
            } else return t(`status_${(0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[(0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none]}`);
            break;
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).navigationStatus:
            return t(`navigation_status_${metadata.navigationStatus == (0, $c931aad0bd934103$export$c50f5cf960171685).on ? "start" : "stop"}`);
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).nmeaConnection:
            if (metadata.nmeaConnectionUserInitiated) return t(`nmea_connection_${metadata.nmeaConnection == (0, $c931aad0bd934103$export$c50f5cf960171685).on ? "start" : "user_stop"}`);
            else return t(`nmea_connection_${metadata.nmeaConnection == (0, $c931aad0bd934103$export$c50f5cf960171685).on ? "resume" : "stop"}`);
            break;
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).stop:
            {
                const stopText = metadata.stopLocation ? t("stop_location", {
                    stop: t(`stop_type_${metadata.stopType}`),
                    location: metadata.stopLocation
                }) : t("stop", {
                    stop: t(`stop_type_${metadata.stopType}`)
                });
                // #1219 follow-up: the stop dialog makes the crew pick a ship status (bridge,
                // lock, bunkering, ...), but the stop metadata never carries it -- the choice is
                // written onto the ship status record instead. Resolve it the same way a
                // `shipStatus` entry resolves its own and append it as a second segment, using
                // the separator `LogView` already puts between the parts of a log row.
                //
                // Deriving it here rather than freezing it into the metadata means stops already
                // in the logbook gain the text too, and it follows a status corrected afterwards
                // from the log row's dropdown. `none`/`inmotion` are skipped: a stop resolving to
                // "In motion" is a pre-#1219 entry that never recorded a status, and naming it
                // would read worse than the plain phrase.
                const statusValue = shipStatus === null || shipStatus === void 0 ? void 0 : shipStatus.value;
                const statusText = statusValue != undefined && statusValue != (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none && statusValue != (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).inmotion ? t(`status_${(0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[statusValue]}`) : undefined;
                return [
                    stopText,
                    statusText
                ].filter((s)=>s).join(" - ");
            }
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).courseChange:
            {
                const phase = metadata.nmeaCourseChangePhase;
                if (phase == (0, $c931aad0bd934103$export$d1a2165e37e7311c).begin) return t("course_change_started");
                const prev = metadata.nmeaCourseChangePrevious;
                const next = metadata.nmeaCourseChangeNew;
                const duration = metadata.nmeaCourseChangeDuration;
                // Legacy logs missing the turn components fall back to the generic phrase.
                if (prev == undefined || next == undefined || duration == undefined) return t("course_change");
                // Signed shortest turn in (-180, 180]: positive turns to starboard, negative to port.
                const signed = (next - prev + 540) % 360 - 180;
                const angle = app.format("course", Math.abs(signed));
                const side = t(signed >= 0 ? "course_change_side_starboard" : "course_change_side_port");
                const time = app.format("time", duration);
                if (phase == (0, $c931aad0bd934103$export$d1a2165e37e7311c).active) // Live, still turning: point at the heading the ship is steering towards now.
                return t("course_change_active", {
                    angle: angle,
                    side: side,
                    duration: time,
                    course: app.format("course", next)
                });
                // Settled end summary (phase .end) or a legacy committed log (no phase): reference
                // the course the ship left.
                return t("course_change_end", {
                    angle: angle,
                    side: side,
                    duration: time,
                    course: app.format("course", prev)
                });
            }
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).speedChange:
            {
                if (metadata.speedChange == (0, $c931aad0bd934103$export$656e514f2ad451fa).stop) return t("pause_start");
                const pauseStatus = endStatuses.find((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship);
                return $8f49adaa708c152b$var$pauseStopText(log, pauseStatus, logs, app, t);
            }
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).propulsion:
            // #1227: the crew's answer to the "engine entry missing?" hint. Only the "no
            // engine running" answer is recorded today — a confirmed engine start is written
            // as a real `.engine` entry instead.
            //
            // The hint is offered on every vessel type, so the wording has to suit a motor
            // vessel too: "under sail" is nonsense on a ship with no sails, and the marker
            // only ever records that no engine was running. Gated on `vesselType` and
            // deliberately NOT on the hint's `reason` — a motor vessel leaving a berth
            // reports `castOff`, not `motorVessel` (see `castOffWinsOverMotorVessel`), so a
            // reason-gate would pick the sail wording for most motor-vessel departures.
            if (metadata.propulsion == (0, $c931aad0bd934103$export$c50f5cf960171685).off) return t(ship.vesselType == (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).motor ? "propulsion_off_noSails" : "propulsion_off");
            break;
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).engineMissing:
            // #1227: the primary app instance's provisional "you're underway with no engine
            // recorded" ghost row. It is never a committed entry — the crew's answer replaces
            // it with a real engine or propulsion record.
            //
            if (metadata.engineMissing) return t(`engine_missing_hint_${metadata.engineMissing.reason}`);
            break;
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).dataRecord:
            {
                // #615's N2K-driven generator on/off, folded into the generic `dataRecord`
                // entry (see `LogMetadata.dataRecord(...)`) rather than the legacy
                // `IStatusType.generator` Status lookup (still handled separately below, in
                // `LogNMEAComment`, for the old importer-only path). Reuses the exact same
                // `generator_start`/`generator_stop` translation keys so the rendered text is
                // unchanged for users regardless of which path produced the log. Only the
                // first generator entry is rendered -- today's N2K wiring only ever
                // transitions one instance per log.
                const generatorEntry = (_c = (_b = metadata.dataRecord) === null || _b === void 0 ? void 0 : _b.generator) === null || _c === void 0 ? void 0 : _c[0];
                if (generatorEntry) {
                    const running = generatorEntry.status == (0, $8e1217d38d458c2d$export$709312b2c55da786).starting || generatorEntry.status == (0, $8e1217d38d458c2d$export$709312b2c55da786).running;
                    return t(running ? "generator_start" : "generator_stop", {
                        number: generatorEntry.number
                    });
                }
                break;
            }
        case (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).lighting:
            {
                // #1216: navigation-lights entries used to render with no text at all -- this
                // case was missing, and `LogNMEAComment` bails out on the `nmeaAuto: false`
                // metadata `LogMetadata.lighting(...)` writes, so nothing described them.
                // `StatelessNavigation.record(log:lighting:)` writes both the metadata and a
                // `.lighting` status opening on this log, so fall back to the status when a log
                // carries no value of its own. The recorded signal is named with the same
                // `LogButton_lighting_*` key the lights alert (`UserAdvice/AlertView.tsx`) and
                // the LogButton menu use, keeping all three consistent.
                const lightingStatus = startStatuses.find((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).lighting);
                // `none` is 0, so this has to test against undefined rather than falsiness.
                const lighting = (_d = metadata.lighting) !== null && _d !== void 0 ? _d : lightingStatus === null || lightingStatus === void 0 ? void 0 : lightingStatus.value;
                if (lighting == undefined) break;
                if (lighting == (0, $3bedadb68df9862e$export$966979137e3fd0b5).none) return t("lighting_none");
                return t("lighting", {
                    lighting: app.t((0, $193beb513144bdb6$export$a4ef803d3e256716)(lighting, ship.vesselType))
                });
            }
        default:
            break;
    }
    return undefined;
}
function $8f49adaa708c152b$export$86c72d2eb1b98969(log, statuses, ctx) {
    const { app: app, ship: ship, trip: trip, shipUsers: shipUsers, logs: logs = [] } = ctx;
    const t = app.getT("LogView_log");
    if ((trip === null || trip === void 0 ? void 0 : trip.importedAt) && log.comment) return "";
    const metadata = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed;
    const endStatuses = statuses.filter((s)=>s.endLogId == log.id);
    const startStatuses = statuses.filter((s)=>s.startLogId == log.id);
    const generatorStart = startStatuses.find((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).generator && s.startLogId == log.id);
    const generatorStop = endStatuses.find((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).generator && s.endLogId == log.id);
    const monitorStart = startStatuses.filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).monitor && s.startLogId == log.id);
    const monitorStop = endStatuses.filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).monitor && s.endLogId == log.id);
    const alertStart = startStatuses.filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).alert && s.startLogId == log.id);
    // Every alert transition now writes its own log carrying this metadata (#916), so
    // it describes itself -- including WHICH transition it was, which the status rows
    // could not express: a cleared alert and one that resolved on its own both just
    // close the row, and an alert that was snoozed opens a fresh one that read as a
    // re-trigger. Checked before the status-derived branches below so the entry does
    // not also get described by the row it wrote.
    if (metadata.type == (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).alert && metadata.alert) {
        const status = alertStart.find((s)=>{
            var _a;
            return s.name == ((_a = metadata.alert) === null || _a === void 0 ? void 0 : _a.alert);
        });
        return $8f49adaa708c152b$var$alertTransitionComment(metadata.alert, status, app, t, shipUsers, ship.vesselType);
    }
    if (monitorStart.length > 0) return monitorStart.map((m)=>m.item && t("monitor_start", {
            monitor: t(`monitor_${(0, $3c48bffca65c360b$export$2ff82625ed03cf18)[m.item]}`)
        })).join(", ");
    if (monitorStop.length > 0) return monitorStop.map((m)=>m.item && t("monitor_stop", {
            monitor: t(`monitor_${(0, $3c48bffca65c360b$export$2ff82625ed03cf18)[m.item]}`)
        })).join(", ");
    // Alerts written before #916 carry no metadata of their own, so they are still
    // described from the status row that opened on this log.
    if (alertStart.length > 0) return alertStart.map((s)=>t("alert_start", {
            alert: t(`alert_${s.name}`),
            status: t(`alert_status_${(0, $ed9e79f0f649608a$export$63ce30087a699ab4)[s.value]}`)
        })).join(", ");
    const sailsUp = startStatuses.filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).sails && s.startLogId == log.id);
    // A stage replaced by another stage of the same sail is not a strike -- the sail stayed
    // up and only its reef level changed, so the entry reads "Genua - Reff 2 gesetzt" alone
    // rather than pairing it with "Genua geborgen" (#1288).
    const sailsDown = endStatuses.filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).sails && s.endLogId == log.id && !(0, $234930b26df9c152$export$af703b2ef478551f)(s, statuses, log.id));
    if (sailsUp.length > 0 || sailsDown.length > 0) {
        const t_sail = app.getT("ShipDataView_sail");
        const shipSails = (0, $22871482fce5b7e5$export$7930c61d9b464618).sails(ship);
        const getSailLabel = (name, value)=>{
            if (!name) return "";
            const sail = shipSails.find((s)=>s.id === name);
            if (sail && sail.sail) {
                const sailDisplayName = t_sail(sail.sail) || sail.sail;
                return value > 0 ? t_sail("reef", {
                    sail: sailDisplayName,
                    reef: t_sail(`reef_${value}`)
                }) : sailDisplayName;
            }
            return name;
        };
        const parts = [
            ...sailsUp.map((s)=>t("sail_up", {
                    sail: getSailLabel(s.name, s.value)
                })),
            ...sailsDown.map((s)=>t("sail_down", {
                    sail: getSailLabel(s.name, s.value)
                }))
        ].filter(Boolean);
        if (parts.length > 0) return parts.join(", ");
    }
    if (!metadata.nmeaAuto) {
        // Derived from the day's audit trail when the entry names the rows it announces;
        // the stored snapshot is only read for entries recorded before issue #1285 (and
        // goes away with them once the backfill data transition has run).
        const rosterChanges = (0, $bc8031cc1fd7bd6d$export$f80b673804cc0b95)(log, ctx.day, ctx.auditLogEdits);
        const logChanges = rosterChanges.length > 0 ? rosterChanges : metadata.changes;
        if (logChanges && logChanges.length > 0) {
            const changes = logChanges.map((c)=>{
                const text = [
                    "change",
                    c.action,
                    c.type
                ].join("_");
                switch(c.type){
                    case (0, $c931aad0bd934103$export$a05a8a0b4c257163).crew:
                    case (0, $c931aad0bd934103$export$a05a8a0b4c257163).passengers:
                    case (0, $c931aad0bd934103$export$a05a8a0b4c257163).skipper:
                        {
                            const user = shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.find((u)=>u.id == c.id);
                            const name = (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.shortname);
                            if (name) return t(text, {
                                name: name
                            });
                            break;
                        }
                    default:
                        break;
                }
                return null;
            }).filter(Boolean);
            if (changes.length > 0) return changes.join(", ");
        }
        return "";
    }
    if (generatorStart) return t(`generator_start`, {
        number: generatorStart.item
    });
    if (generatorStop) return t(`generator_stop`, {
        number: generatorStop.item
    });
    if (metadata.nmeaSpeedStartStop != undefined) {
        if (!metadata.nmeaSpeedStartStop) return t("pause_start");
        const pauseStatus = endStatuses.find((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship);
        return $8f49adaa708c152b$var$pauseStopText(log, pauseStatus, logs, app, t);
    }
    if (metadata.nmeaConnectionStartStop != undefined) return t(`nmea_connection_${metadata.nmeaConnectionStartStop ? "resume" : "stop"}`);
    return undefined;
}




var $acw62 = parcelRequire("acw62");




const $5896f7c584c01512$export$63038af0ac96abf1 = {
    cancel (api, key) {
        return new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.cancelProvisional({
            params: {},
            body: {
                key: key
            }
        }).call();
    }
};
function $5896f7c584c01512$export$7097d00e58b0e85b(metadata) {
    if (metadata.type != (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).courseChange && metadata.type != (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).speedChange) return undefined;
    return metadata.provisionalKey || undefined;
}
function $5896f7c584c01512$export$456cc6cac4025cf7({ cancelKey: cancelKey, kind: kind }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("LogView");
    const [confirming, setConfirming] = (0, $acw62.useState)(false);
    const open = (0, $acw62.useCallback)((e)=>{
        // The mobile header toggles row selection on click, so this must not bubble.
        e === null || e === void 0 || e.preventDefault();
        e === null || e === void 0 || e.stopPropagation();
        setConfirming(true);
    }, []);
    // Left to throw on failure: `ConfirmDialog`'s `awaitConfirm` keeps the dialog open and
    // surfaces `errorMessage`, so a failed cancel doesn't silently look like it worked.
    const confirm = (0, $acw62.useCallback)(async ()=>{
        await $5896f7c584c01512$export$63038af0ac96abf1.cancel(app.apiClient, cancelKey);
        setConfirming(false);
    }, [
        app,
        cancelKey
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                className: "ProvisionalCancel",
                onClick: open
            }),
            confirming && (0, $7b02d682eb115277$exports.jsx)((0, $e7bc01546cf183b2$export$2cc85109a937009e), {
                awaitConfirm: true,
                cancelLabel: t("provisional_cancel_keep"),
                confirmLabel: t("provisional_cancel_discard"),
                errorMessage: t("provisional_cancel_error"),
                message: t(`provisional_cancel_message_${kind}`),
                onCancel: ()=>setConfirming(false),
                onConfirm: confirm,
                title: t(`provisional_cancel_title_${kind}`)
            })
        ]
    });
}


function $ef5054b4bf6e9c66$export$b9dc914bb7557ea1(log, field) {
    switch(field){
        case "comment":
        case "course":
        case "currentDirection":
        case "currentSpeed":
        case "depth":
        case "distance":
        case "engineRpms":
        case "heading":
        case "humidity":
        case "log":
        case "pressure":
        case "seaState":
        case "sog":
        case "stw":
        case "temperature":
        case "watch":
        case "watchComment":
        case "weather":
        case "windDirection":
        case "windSpeed":
            return log[field];
        default:
            return undefined;
    }
}
const $ef5054b4bf6e9c66$export$d8c7abcae1e88b5b = {
    fieldFormat (app) {
        const ftEnvironment = app.getT("LogEnvironmentView");
        // Mirrors `PredefinedSelect`'s own display rule (`Components/PredefinedSelect.
        // tsx`): a predefined code renders its translated label, anything else (a
        // free-typed custom value) renders as-is.
        const predefined = (prefix, codes)=>(0, $14a8bda8b42de2c4$export$2f84fdd660581d7f)((value)=>typeof value === "string" || typeof value === "number", (value)=>{
                const code = String(value);
                return codes.indexOf(code) >= 0 ? ftEnvironment(`${prefix}_${code}`) : code;
            });
        return {
            course: "course",
            currentDirection: predefined("current_direction", (0, $a73a127a1ab0cf24$export$d0900c0205452cbd).predefinedDirections),
            currentSpeed: "speed",
            depth: "meters",
            distance: "distance",
            // Sparse array (unset engines are `-1`, matching `LogNavigationView`'s own
            // `rpmValue`) -- one formatted "N rpm" per set engine, comma-joined.
            engineRpms: (0, $14a8bda8b42de2c4$export$2f84fdd660581d7f)((value)=>Array.isArray(value), (rpms)=>{
                const formatted = rpms.filter((v)=>typeof v === "number" && v >= 1).map((v)=>app.format("rpm", v));
                return formatted.length > 0 ? formatted.join(", ") : "\u2013";
            }),
            heading: "course",
            humidity: "percentage",
            log: "distance",
            pressure: "pressure",
            seaState: predefined("seastate", (0, $a73a127a1ab0cf24$export$d0900c0205452cbd).predefinedSeaStates),
            sog: "speed",
            stw: "speed",
            temperature: "temperature",
            weather: (0, $14a8bda8b42de2c4$export$2f84fdd660581d7f)((value)=>typeof value === "string" || typeof value === "number", (value)=>ftEnvironment(`weather_${value}`)),
            windDirection: "angle",
            windSpeed: "speed"
        };
    },
    fieldLabel (app) {
        const navigation = app.getT("LogNavigationView");
        const environment = app.getT("LogEnvironmentView");
        const watch = app.getT("LogWatchView");
        const labels = {
            comment: navigation("comment"),
            course: navigation("course"),
            depth: navigation("depth"),
            distance: navigation("distance"),
            engineRpms: navigation("engine_rpms"),
            heading: navigation("heading"),
            location: navigation("location"),
            log: navigation("log"),
            sog: navigation("sog"),
            stw: navigation("stw"),
            currentDirection: environment("current_direction_speed"),
            currentSpeed: environment("current_direction_speed"),
            humidity: environment("weather_temp_rel_humidity"),
            pressure: environment("pressure"),
            seaState: environment("seastate"),
            temperature: environment("weather_temp_rel_humidity"),
            weather: environment("weather_field"),
            windDirection: environment("wind_direction_speed"),
            windSpeed: environment("wind_direction_speed"),
            watch: watch("watch"),
            watchComment: watch("watch_comment")
        };
        return (field)=>{
            var _a;
            return (_a = labels[field]) !== null && _a !== void 0 ? _a : field;
        };
    }
};
function $ef5054b4bf6e9c66$export$812dc811f41b1756({ advices: advices, adviceState: adviceState, clearHighlight: clearHighlight, createCallback: createCallback, engineStatusCallback: engineStatusCallback, lightingCallback: lightingCallback, sailChangesCallback: sailChangesCallback, initAdvicesExpanded: initAdvicesExpanded, initEditHistoryOpen: initEditHistoryOpen, initLogButtonMenuOpen: initLogButtonMenuOpen, initLogButtonSubmenu: initLogButtonSubmenu, initSelected: initSelected, initTab: initTab, log: log, ref: ref, statuses: statuses }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    const { cruise: _cruise, showLabels: showLabels } = (0, $97ac05743b787a86$export$135b8b9ecdd62154)();
    const [ship, trip] = [
        (0, $97ac05743b787a86$export$f581995c9f2db6f0)(),
        (_a = (0, $97ac05743b787a86$export$e205ea882cbd693e)()) === null || _a === void 0 ? void 0 : _a.trip
    ];
    const { auditLogEdits: auditLogEdits, day: day, focus: focus, isCurrentTrip: isCurrentTrip, logs: logs, statuses: dayStatuses } = (0, $97ac05743b787a86$export$95d65094202e15e7)();
    const t = app.getT("LogView");
    const _ft = app.getT("LogView_form");
    const [selected, setSelected] = (0, $acw62.useState)(false);
    const [isMobile, setIsMobile] = (0, $acw62.useState)(window.matchMedia("(max-width: 767px)").matches);
    // The width tier the advice row lays its buttons out for (#1171). Tracked alongside
    // `isMobile` (which only knows the one breakpoint) because the row distinguishes a
    // third, narrower tier where even a warning gives up its wording.
    const [adviceWidth, setAdviceWidth] = (0, $acw62.useState)(()=>(0, $9f74ca3230272c28$export$79b7f2448f28877)());
    const containerRef = (0, $acw62.useRef)(null);
    const [containerHeight, setContainerHeight] = (0, $acw62.useState)(undefined);
    const adviceOverlayRef = (0, $acw62.useRef)(null);
    const adviceOverlayMobileRef = (0, $acw62.useRef)(null);
    // Rendered once and shared by the mobile and desktop branches below, so the row's
    // expanded state survives a breakpoint change rather than resetting with it.
    const adviceRow = (0, $acw62.useMemo)(()=>{
        if (!advices || !adviceState) return undefined;
        return (0, $7b02d682eb115277$exports.jsx)((0, $9f74ca3230272c28$export$60163ac1b08bf25c), {
            advices: advices,
            initExpanded: initAdvicesExpanded,
            state: adviceState,
            width: adviceWidth
        });
    }, [
        advices,
        adviceState,
        adviceWidth,
        initAdvicesExpanded
    ]);
    (0, $acw62.useEffect)(()=>{
        const mediaQuery = window.matchMedia("(max-width: 767px)");
        const checkMobile = ()=>{
            const matches = window.matchMedia("(max-width: 767px)").matches;
            setIsMobile(matches);
            setAdviceWidth((0, $9f74ca3230272c28$export$79b7f2448f28877)());
        };
        const handleChange = (e)=>{
            setIsMobile(e.matches);
            setAdviceWidth((0, $9f74ca3230272c28$export$79b7f2448f28877)());
        };
        const handleResize = ()=>{
            checkMobile();
        };
        // Listen to matchMedia changes
        mediaQuery.addEventListener("change", handleChange);
        // Listen to window resize (for orientation changes)
        window.addEventListener("resize", handleResize);
        // Listen to orientation changes
        window.addEventListener("orientationchange", checkMobile);
        return ()=>{
            mediaQuery.removeEventListener("change", handleChange);
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("orientationchange", checkMobile);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const updateContainerHeight = ()=>{
            if (selected && containerRef.current) {
                const isTabletOrBelow = window.matchMedia("(max-width: 1023px)").matches;
                const width = window.innerWidth;
                const isTablet = isTabletOrBelow || width <= 1023;
                if (isTablet) // Wait for content to render, then measure
                setTimeout(()=>{
                    if (containerRef.current) {
                        const height = containerRef.current.scrollHeight;
                        setContainerHeight(height);
                    }
                }, 100);
                else setContainerHeight(undefined); // Reset to CSS default for desktop
            }
        };
        updateContainerHeight();
        // Listen to window resize and orientation changes
        window.addEventListener("resize", updateContainerHeight);
        window.addEventListener("orientationchange", updateContainerHeight);
        return ()=>{
            window.removeEventListener("resize", updateContainerHeight);
            window.removeEventListener("orientationchange", updateContainerHeight);
        };
    }, [
        selected
    ]);
    const _calculated = log.calculated;
    const metadata = (0, $acw62.useMemo)(()=>(0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed, [
        log
    ]);
    // Engine-missing ghosts copy a committed departure log but use id 0 to stay outside
    // the committed timeline. Resolve their status chrome against that departure rather
    // than treating them like the live "now" entry.
    const statusLogId = (_c = (_b = metadata.engineMissing) === null || _b === void 0 ? void 0 : _b.sinceLogId) !== null && _c !== void 0 ? _c : log.id;
    // A provisional (in-progress, uncommitted) auto-log is flagged in its metadata. It is
    // NOT the live current entry — it carries none of the current log's chrome (no + Log
    // button, advices or `LogView-current-entry` styling). Instead it gets a shared
    // `LogView-provisional` class and a per-type `LogView-provisional-<type>` class so each
    // kind of provisional entry (course change, …) can be styled distinctly.
    //
    // The live current entry is also broadcast flagged `nmeaAutoPending` (it too is an
    // uncommitted entry), but it keeps its own `LogView-current-entry` chrome and must NOT
    // pick up the provisional styling, so exclude it here.
    const provisional = (metadata.nmeaAutoPending || false) && !(log.nmeaPending || false);
    const provisionalClass = provisional ? ` LogView-provisional LogView-provisional-${metadata.type}` : "";
    const focusEditable = focus && (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).availableCurrentOrAll(apiUser, ship.id, isCurrentTrip);
    // A cancellable provisional entry (#872) offers a cancel button, letting the user drop
    // both the live entry and the navigation state that produced it. Gated on the same
    // edit rights as the current log's advices — deliberately NOT on `editable` below,
    // which requires a committed (`id > 0`) log a provisional entry by definition isn't.
    const cancelKey = (0, $acw62.useMemo)(()=>provisional ? (0, $5896f7c584c01512$export$7097d00e58b0e85b)(metadata) : undefined, [
        provisional,
        metadata
    ]);
    const provisionalCancel = cancelKey != undefined && focusEditable && app.editable ? (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "LogView-provisional-cancel",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $5896f7c584c01512$export$456cc6cac4025cf7), {
            cancelKey: cancelKey,
            kind: metadata.type
        })
    }) : undefined;
    // Whether *any* field on this log could conceivably be edited here at all — i.e. the
    // user has ship-level edit rights, this is the focused tab, and the log is a real
    // (committed) entry. This deliberately does NOT gate on the log's age/recency or
    // whether it's still the most recent of its kind: those restrictions only apply to
    // `.nmeaCapable` fields (issue #529) and are enforced per-field, in each editable
    // field's own `readOnly` via `Views/Log/editability.ts`'s `logFieldEditable` — an
    // `.always` field (e.g. comment) must stay editable at any age. Superseded the old
    // `lastLog`/`app.forceLogEditable`/1-hour heuristic, which used to gate the whole
    // form (and so incorrectly blocked `.always` fields too) — see `logFieldEditable`.
    const editable = (0, $acw62.useMemo)(()=>app.editable && log.id > 0 && focus && focusEditable || false, [
        log,
        focus,
        focusEditable
    ]);
    // Measure advice overlay height and adjust parent row height. Uses
    // `useLayoutEffect` (synchronous, after DOM mutations but before paint)
    // rather than `useEffect` + `setTimeout(fn, 0)`: the previous deferred
    // measurement raced the real macrotask queue, so whether it had run by the
    // time anything (a test, or just a user) observed the DOM was
    // non-deterministic -- causing both a visible flash of the unmeasured
    // 49px row in the browser and flaky golden snapshots in CI. Re-measuring is
    // driven by a `ResizeObserver` on the overlay itself (mirrors `PrintHost.tsx`
    // and `useOverlayScroll.ts`) rather than a `window` resize listener, so it
    // also reacts to the overlay's own content reflowing (e.g. advice text
    // wrapping differently after a font swap) and not just the window resizing.
    (0, $acw62.useLayoutEffect)(()=>{
        // `app.staticLayout` skips this real-browser measurement in the catalog +
        // unit-test (happy-dom) mock app so the golden snapshots stay deterministic
        // (see `IAppState.staticLayout`). Real users + E2E run it.
        if (app.staticLayout || !advices || !createCallback || !focusEditable) return;
        const overlay = isMobile ? adviceOverlayMobileRef.current : adviceOverlayRef.current;
        if (!overlay) return;
        const measureOverlay = ()=>{
            const height = overlay.offsetHeight;
            const parent = overlay.parentElement;
            if (!parent) return;
            if (height > 49) // The overlay is absolutely positioned, so it ignores the row's own
            // padding-bottom (the 4px `.LogView-current-entry` reserves below it at
            // mobile widths, LogView.scss) -- once the overlay wraps past one line
            // that gap has to be added back here, or the last button row ends up
            // flush with the row's bottom edge instead of matching the single-line gap.
            parent.style.minHeight = `${height + (isMobile ? 4 : 0)}px`;
            else parent.style.minHeight = "49px";
        };
        measureOverlay();
        const resizeObserver = new ResizeObserver(measureOverlay);
        resizeObserver.observe(overlay);
        return ()=>resizeObserver.disconnect();
    }, [
        advices,
        createCallback,
        focusEditable,
        isMobile
    ]);
    const engineStatuses = (0, $acw62.useMemo)(()=>{
        return statuses.filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).engine);
    }, [
        statuses,
        log
    ]);
    const sailStatuses = (0, $acw62.useMemo)(()=>{
        return statuses.filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).sails);
    }, [
        statuses,
        log
    ]);
    const engines = (0, $acw62.useMemo)(()=>{
        const engineInfo = [];
        const thresholds = (0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship).thresholds;
        for (const e of (0, $22871482fce5b7e5$export$7930c61d9b464618).engines(ship)){
            const n = (0, $2e799dc50d0acd79$export$2ab9a8f9f1186f14)(-1, e.nmeaNumber, e.number);
            // The covering per-engine status (started at or before this log, not yet closed
            // at it) carries the persisted run state (#619): running vs idle.
            const status = (0, $234930b26df9c152$export$738727f375798cb)(engineStatuses, statusLogId, e.id);
            const on = (0, $234930b26df9c152$export$591cee21f508cff)(log.engineRpms, n, status, thresholds);
            const idle = on && (0, $234930b26df9c152$export$479f26c6e67c2e2f)(log.engineRpms, n, status, thresholds);
            engineInfo.push({
                id: e.id,
                number: e.number,
                name: e.engineShortName,
                on: on,
                idle: idle
            });
        }
        return engineInfo;
    }, [
        engineStatuses,
        ship,
        log,
        statusLogId
    ]);
    const sails = (0, $acw62.useMemo)(()=>{
        const sailInfo = [];
        for (const s of (0, $22871482fce5b7e5$export$7930c61d9b464618).sails(ship)){
            const status = (0, $234930b26df9c152$export$738727f375798cb)(sailStatuses, statusLogId, s.id);
            const active = status != undefined;
            sailInfo.push({
                id: s.id,
                name: s.sail,
                active: active,
                reef: (status === null || status === void 0 ? void 0 : status.value) || 0
            });
        }
        return sailInfo;
    }, [
        sailStatuses,
        ship,
        statusLogId
    ]);
    // Sails offered to the quick sail-plan toggle in the LogButton overlay. Only a
    // sailing vessel with configured sails gets the block; the title falls back to a
    // predefined-sail translation, then the raw custom name.
    const sailButtons = (0, $acw62.useMemo)(()=>{
        if (ship.vesselType != (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).sailing) return [];
        const st = app.getT("ShipDataView");
        return (0, $22871482fce5b7e5$export$7930c61d9b464618).sails(ship).map((s)=>{
            const active = (0, $234930b26df9c152$export$738727f375798cb)(sailStatuses, statusLogId, s.id) != undefined;
            const title = s.sail ? st(`sail_${s.sail}`) || s.sail : s.id;
            return {
                id: s.id,
                name: s.sail,
                sailType: s.sailType,
                title: title,
                active: active
            };
        });
    }, [
        sailStatuses,
        ship,
        statusLogId,
        app.status
    ]);
    const shipStatus = (0, $acw62.useMemo)(()=>{
        return (0, $234930b26df9c152$export$2baff4ea56c462f4)(statuses, statusLogId);
    }, [
        statusLogId,
        statuses
    ]);
    // The manual ship-status mode (#511) in force at this log, so the LogButton's
    // manual-status action can render as on and switch it off again.
    const manualStatusActive = (0, $acw62.useMemo)(()=>(0, $234930b26df9c152$export$26d0b00d6820c0a)(statuses, statusLogId), [
        statuses,
        statusLogId
    ]);
    const lightingStatus = (0, $acw62.useMemo)(()=>{
        // The lighting in force at *this* log, not whatever is currently switched on: for
        // an older entry the open status may well have started after it (#506).
        const lightingStatuses = (0, $234930b26df9c152$export$93a873645497d52c)(statuses.filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).lighting), statusLogId);
        return lightingStatuses[lightingStatuses.length - 1];
    }, [
        statuses,
        statusLogId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (initSelected && !selected) {
            setSelected(true);
            clearHighlight();
        }
    }, [
        initSelected,
        selected
    ]);
    const _debugData = (0, $acw62.useMemo)(()=>{
        return [
            "logId:",
            log.id,
            "dayId:",
            log.dayId,
            "tripId:",
            log.tripId,
            "cruiseId:",
            log.cruiseId
        ].join(" ");
    }, [
        log
    ]);
    const comment = (0, $acw62.useMemo)(()=>{
        const ctx = {
            app: app,
            ship: ship,
            trip: trip,
            shipUsers: shipUsers,
            logs: logs,
            dayStatuses: dayStatuses,
            day: day,
            auditLogEdits: auditLogEdits
        };
        return (0, $8f49adaa708c152b$export$94719616ea7cbe20)(log, statuses, ctx);
    }, [
        log,
        log.comment,
        statuses,
        app,
        ship,
        trip,
        shipUsers,
        logs,
        dayStatuses,
        day,
        auditLogEdits
    ]);
    const labels = (0, $acw62.useMemo)(()=>{
        if (!log.labels || log.labels.length < 1 || !showLabels) return null;
        return (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "LogView-labels",
            children: log.labels.map((label)=>{
                return (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "LogView-label",
                    children: t(`label_${label}`)
                }, `log-label-${label}`);
            })
        });
    }, [
        log
    ]);
    function toggleSelected() {
        setSelected(!selected);
    }
    const shipStatusValue = (0, $acw62.useMemo)(()=>{
        if (shipStatus == undefined) return (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none;
        return shipStatus.value;
    }, [
        shipStatus,
        shipStatus === null || shipStatus === void 0 ? void 0 : shipStatus.value
    ]);
    const sailStatusIcon = (0, $acw62.useMemo)(()=>{
        const activeSails = sails.filter((s)=>s.active);
        if (activeSails.length > 0) return (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
            className: "LogView-status-icon",
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).SailingVesselLarge
        });
        return null;
    }, [
        sails
    ]);
    const engineStatusIcons = (0, $acw62.useMemo)(()=>{
        // Always render icons only — engine toggle buttons have moved to the LogButton overlay.
        // off = outline circle, running = filled circle, idle = dot-in-ring (#619).
        return engines.map((e)=>{
            const state = e.on ? e.idle ? "idle" : "on" : "off";
            const icon = !e.on ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleLarge : e.idle ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleHalfLarge : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleFilledLarge;
            return (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                className: `LogView-status-icon engine-${state}`,
                icon: icon,
                title: app.t(`engine_${e.name}`)
            }, `engine-${e.id}`);
        });
    }, [
        engines,
        app.status
    ]);
    const commentStatusIcons = (0, $acw62.useMemo)(()=>{
        return (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: "LogView-status-icons",
            children: [
                sailStatusIcon && (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "sail-icon",
                    children: sailStatusIcon
                }),
                (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "engine-icons",
                    children: engineStatusIcons
                })
            ]
        });
    }, [
        sailStatusIcon,
        engineStatusIcons
    ]);
    const logCreator = (0, $acw62.useMemo)(()=>{
        return shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.find((u)=>u.id == log.userId);
    }, [
        log.userId,
        shipUsers
    ]);
    // Edit history (issue #529): this log's own `AuditLogEdit` rows, matched via
    // `logId` out of `DayContext.auditLogEdits` (which carries every log's edits for
    // the day). Sorted most-recent-first by `computeEditHistory`, so its first entry
    // is also the log's last edit overall, driving the `.log-details` "last edited by"
    // attribution below.
    const logAuditLogEdits = (0, $acw62.useMemo)(()=>{
        return auditLogEdits.filter((e)=>e.logId == log.id);
    }, [
        auditLogEdits,
        log.id
    ]);
    // Issue #1136: this log as last returned by one of the edit sub-views' own saves.
    // `log` itself comes from the day's `logs` list and only refreshes on the next live
    // broadcast / full day load, so without this the field just saved keeps resolving
    // its "new value" below from the pre-edit snapshot. Handed down to the sub-views
    // (the save happens there, the edit history renders here) and only ever read for
    // that resolution -- their own inputs keep what the user typed.
    const [savedLog, setSavedLog] = (0, $acw62.useState)(undefined);
    const recordSavedLog = (0, $acw62.useCallback)((saved)=>{
        setSavedLog(saved);
    }, []);
    const editHistory = (0, $acw62.useMemo)(()=>{
        const historyLog = (0, $59aa08b9185fbe21$export$ff67a10d74459a57)(log, savedLog);
        return (0, $59aa08b9185fbe21$export$a93b69c9d9000d40)(logAuditLogEdits, (field)=>$ef5054b4bf6e9c66$export$b9dc914bb7557ea1(historyLog, field));
    }, [
        logAuditLogEdits,
        log,
        savedLog
    ]);
    const lastEditor = (0, $acw62.useMemo)(()=>{
        if (editHistory.length < 1) return undefined;
        return shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.find((u)=>u.id == editHistory[0].shipUserId);
    }, [
        editHistory,
        shipUsers
    ]);
    // Edit History visibility (issue #1169): a code-level policy, not a ship
    // setting -- `.unrestricted` already discards the field-level protections that
    // give the audit trail its evidentiary value, so the table (but not the "last
    // edited" line itself) is hidden at that level. See `Log/editability.ts`.
    const editPermissivenessLevel = (_d = (0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship).editPermissiveness) !== null && _d !== void 0 ? _d : (0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).strict;
    // Existing audit history remains visible even when new log editing is disabled.
    const editHistoryVisible = (0, $e000d4a262f1f979$export$d781a0190b3420e7)(editPermissivenessLevel);
    const [editHistoryOpen, setEditHistoryOpen] = (0, $acw62.useState)(initEditHistoryOpen !== null && initEditHistoryOpen !== void 0 ? initEditHistoryOpen : false);
    const editHistoryFieldFormat = (0, $acw62.useMemo)(()=>$ef5054b4bf6e9c66$export$d8c7abcae1e88b5b.fieldFormat(app), [
        app
    ]);
    const fieldLabel = (0, $acw62.useMemo)(()=>$ef5054b4bf6e9c66$export$d8c7abcae1e88b5b.fieldLabel(app), [
        app
    ]);
    const statusOptions = (0, $acw62.useMemo)(()=>Object.entries((0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)).filter((s)=>isNaN(parseInt(s[0]))).map((s)=>{
            const [status, i] = s;
            if (status == "none" || shipStatus && shipStatus.value == i) return undefined;
            return {
                icon: `status-${status}`,
                title: app.t(`LogNavigationView_status_${status}`),
                value: i
            };
        }).filter((n)=>n != undefined), [
        log,
        shipStatus,
        statuses
    ]);
    const lightingValue = (0, $acw62.useMemo)(()=>{
        var _a;
        return (_a = lightingStatus === null || lightingStatus === void 0 ? void 0 : lightingStatus.value) !== null && _a !== void 0 ? _a : (0, $3bedadb68df9862e$export$966979137e3fd0b5).none;
    }, [
        lightingStatus,
        lightingStatus === null || lightingStatus === void 0 ? void 0 : lightingStatus.value
    ]);
    const lightingOptions = (0, $acw62.useMemo)(()=>(0, $193beb513144bdb6$export$260b3a110a432172)(ship.vesselType).filter((value)=>value != lightingValue).map((value)=>({
                icon: (0, $193beb513144bdb6$export$a56621d605e7ce89)(value),
                title: app.t((0, $193beb513144bdb6$export$a4ef803d3e256716)(value, ship.vesselType)),
                value: value
            })), [
        lightingValue,
        ship.vesselType,
        app,
        app.language
    ]);
    const hour = Math.floor(log.time / 3600);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $97ac05743b787a86$export$2d8b280ec4cad22c).Provider, {
        value: log,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $3369ccde6b7b7538$export$8101c6120d78974d), {
                createCallback: createCallback,
                focusEditable: focusEditable || false,
                engines: engines.map((e)=>({
                        id: e.id,
                        name: e.name || "",
                        on: e.on,
                        idle: e.idle
                    })),
                hasNmeaEngineData: (((_g = (_f = (_e = app.status) === null || _e === void 0 ? void 0 : _e.nmea) === null || _f === void 0 ? void 0 : _f.data.engine) === null || _g === void 0 ? void 0 : _g.length) || 0) > 0,
                engineStatusCallback: engineStatusCallback,
                initLogButtonMenuOpen: initLogButtonMenuOpen,
                initLogButtonSubmenu: initLogButtonSubmenu,
                lightingCallback: lightingCallback,
                lightingValue: lightingValue,
                lightingOptions: lightingOptions,
                sails: sailButtons,
                sailChangesCallback: sailChangesCallback,
                label: t("nmea_pending"),
                manualStatusActive: manualStatusActive,
                shipStatusValue: shipStatusValue,
                statusOptions: statusOptions
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "DayView-logs-timeline log",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "hour hour-" + hour
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "fill"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "LogView " + (selected ? "selected" : "not-selected") + (log.nmeaPending ? " LogView-current-entry" : "") + provisionalClass,
                children: [
                    ref && (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "LogView-ref-parent",
                        children: (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "LogView-ref-placeholder",
                            ref: ref
                        })
                    }),
                    !selected && isMobile ? (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "LogView-header LogView-header-mobile",
                        onClick: toggleSelected,
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "LogView-header-row-1",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "LogView-cell LogView-time",
                                        children: app.format("time", log.time)
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "LogView-cell LogView-course",
                                        children: app.format("course", log.course)
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "LogView-cell LogView-speed",
                                        children: app.format("speed", log.sog)
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "LogView-cell LogView-distance",
                                        children: app.format("distance", log.distance)
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "LogView-header-row-2",
                                children: [
                                    commentStatusIcons,
                                    advices && createCallback && focusEditable ? (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "LogView-comment-text"
                                    }) : (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "LogView-comment-text",
                                        children: [
                                            labels,
                                            comment
                                        ]
                                    })
                                ]
                            }),
                            advices && createCallback && focusEditable && (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "LogView-advice-overlay-mobile",
                                ref: adviceOverlayMobileRef,
                                children: adviceRow
                            }),
                            provisionalCancel
                        ]
                    }) : (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "LogView-header LogView-header-normal",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "LogView-cell LogView-time",
                                onClick: toggleSelected,
                                children: app.format("time", log.time)
                            }),
                            advices && createCallback && focusEditable ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "LogView-cell LogView-comment",
                                        onClick: toggleSelected,
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "LogView-comment-content"
                                            }),
                                            commentStatusIcons
                                        ]
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "LogView-advice-overlay",
                                        ref: adviceOverlayRef,
                                        children: adviceRow
                                    })
                                ]
                            }) : (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "LogView-cell LogView-comment",
                                onClick: toggleSelected,
                                children: [
                                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "LogView-comment-content",
                                        children: [
                                            labels,
                                            comment
                                        ]
                                    }),
                                    commentStatusIcons
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "LogView-cell LogView-course",
                                children: app.format("course", log.course)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "LogView-cell LogView-speed",
                                children: app.format("speed", log.sog)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "LogView-cell LogView-distance",
                                children: app.format("distance", log.distance)
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "LogView-gap",
                                children: [
                                    provisionalCancel,
                                    selected && (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "LogView-container-close",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                                            icon: editable ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Enter : undefined,
                                            onClick: toggleSelected
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    selected && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                            ref: containerRef,
                            className: shipStatus && shipStatus.value !== (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).inmotion && shipStatus.value !== (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).drifting ? "LogView-container LogView-container-status-stopped" : "LogView-container",
                            style: containerHeight ? {
                                height: `${containerHeight}px`
                            } : undefined,
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $9f9e7bca499fb8dc$export$f97dc4a5a0177256), {
                                    defaultSelection: initTab || "navigation",
                                    tabs: [
                                        {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Navigation,
                                            name: "navigation",
                                            title: t("tab_navigation"),
                                            render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $2b4c51d286f985e1$export$c0446c7cd14ca404), {
                                                    editable: editable,
                                                    recordSavedLog: recordSavedLog,
                                                    status: shipStatus,
                                                    statuses: statuses,
                                                    updated: log.updatedAt
                                                })
                                        },
                                        {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Environment,
                                            name: "environment",
                                            title: t("tab_environment"),
                                            render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $a73a127a1ab0cf24$export$cd3865c2c717b1cc), {
                                                    editable: editable,
                                                    recordSavedLog: recordSavedLog
                                                })
                                        },
                                        {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Watch,
                                            name: "watch",
                                            title: t("tab_watch"),
                                            render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $47858fdb5fdea477$export$6bc9cfd4addb0bb9), {
                                                    editable: editable,
                                                    recordSavedLog: recordSavedLog
                                                })
                                        }
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                    className: "log-details",
                                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        children: [
                                            logCreator && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                children: t("details_created_by", {
                                                    name: logCreator.name || logCreator.shortname || ""
                                                })
                                            }),
                                            log.updatedAt != log.createdAt && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                children: t("details_updated_at", {
                                                    date: app.format("dateAndTime", log.updatedAt)
                                                })
                                            }),
                                            editHistory.length > 0 && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                className: "log-details-last-edited",
                                                onClick: editHistoryVisible ? ()=>setEditHistoryOpen((open)=>!open) : undefined,
                                                children: [
                                                    lastEditor ? t("details_last_edited_by", {
                                                        name: lastEditor.name || lastEditor.shortname || ""
                                                    }) : t("details_last_edited"),
                                                    editHistoryVisible && (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                        icon: editHistoryOpen ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowUp : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowDown
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                editHistoryVisible && (0, $7b02d682eb115277$exports.jsx)((0, $b68062e8543a3005$export$fca036eb5668ed1d), {
                                    entries: editHistory,
                                    fieldLabel: fieldLabel,
                                    fieldFormat: editHistoryFieldFormat,
                                    open: editHistoryOpen
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}


function $0487b6f1efece6f9$export$65f601bc28eb0ddd({ clearHighlight: clearHighlight, currentLog: currentLog, currentLogView: currentLogView, highlight: highlight, isCurrentDay: isCurrentDay, isTomorrow: isTomorrow, logTabs: logTabs, logs: logs, recordLog: _recordLog, statuses: statuses }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const [_ship, _cruise, _trip, _day] = [
        (0, $97ac05743b787a86$export$f581995c9f2db6f0)(),
        (0, $97ac05743b787a86$export$135b8b9ecdd62154)().cruise,
        (0, $97ac05743b787a86$export$e205ea882cbd693e)(),
        (0, $97ac05743b787a86$export$95d65094202e15e7)().day
    ];
    const preHours = [];
    const postHours = [];
    const logViews = [];
    const logStatuses = (0, $acw62.useCallback)((logId)=>{
        return statuses.filter((s)=>{
            if (logId == 0) return s.endLogId == undefined;
            if (s.endLogId != undefined) return logId >= s.startLogId && logId <= s.endLogId;
            return logId >= s.startLogId;
        });
    }, [
        statuses
    ]);
    if (logs || currentLog) {
        let allLogs = [];
        if (logs) allLogs = logs.slice();
        if (currentLog) {
            currentLog.nmeaPending = true;
            // A real (persisted, id > 0) currentLog should never also appear in `logs` --
            // it should normally be a distinct id-0 sentinel. Guard against a caller handing
            // back the same committed log for both anyway, which would otherwise render the
            // shared id twice: once as a plain LogView, once as currentLogView. id-0 entries
            // are exempt since several distinct provisional/pending logs can share id 0.
            if (currentLog.id > 0) allLogs = allLogs.filter((l)=>l.id !== currentLog.id);
            allLogs.push(currentLog);
        }
        let minHour = undefined;
        let maxHour = undefined;
        let lastHour = -1;
        for(const n in allLogs){
            const i = typeof n == "number" ? n : parseInt(n);
            const log = allLogs[i];
            let hour = Math.floor(log.time / 3600);
            if (hour > 23) hour = 23;
            if (minHour == undefined || hour < minHour) minHour = hour;
            if (maxHour == undefined || hour > maxHour) maxHour = hour;
            const extraClass = [];
            if (hour > lastHour) extraClass.push("first-of-hour");
            if (i == 0) extraClass.push("first-of-day");
            if (i == allLogs.length - 1) extraClass.push("last-of-day");
            // Identity, never position. Including the array index here made the live
            // current-log row (appended last, and carrying the placeholder id 0) change key
            // every time a committed log arrived, so React unmounted and remounted it --
            // destroying anything transient inside. On a live NMEA feed auto-logs commit
            // continuously, so an open `LogButton` menu vanished mid-interaction and a click
            // could land on a button that had already been detached, silently doing nothing.
            //
            // Committed logs have unique ids; provisional entries share id 0 but carry a
            // `provisionalKey`; the live current log is a singleton with neither.
            const provisionalKey = log.id > 0 ? undefined : (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed.provisionalKey;
            const rowKey = log.id !== 0 ? `log-${log.id}` : provisionalKey ? `log-provisional-${provisionalKey}` : "log-current";
            logViews.push((0, $7b02d682eb115277$exports.jsx)("div", {
                className: "DayView-logs-log " + extraClass.join(" "),
                "data-log-id": log.id,
                children: log.nmeaPending && currentLogView ? currentLogView : (0, $7b02d682eb115277$exports.jsx)((0, $ef5054b4bf6e9c66$export$812dc811f41b1756), {
                    clearHighlight: clearHighlight,
                    initSelected: highlight && highlight == log.id,
                    initTab: logTabs === null || logTabs === void 0 ? void 0 : logTabs[log.id],
                    log: log,
                    statuses: logStatuses(log.id)
                })
            }, rowKey));
            lastHour = hour;
        }
        if (!minHour) minHour = 0;
        if (!maxHour) maxHour = 0;
        for(let h = 0; h <= minHour; h++)preHours.push((0, $7b02d682eb115277$exports.jsx)("div", {
            className: "hour hour-" + h
        }, `pre-hour-${h}`));
        for(let j = maxHour + 1; j <= 24; j++)postHours.push((0, $7b02d682eb115277$exports.jsx)("div", {
            className: "hour hour-" + j
        }, `post-hour-${j}`));
    }
    if (logViews.length < 1 && !currentLogView) {
        const emptyKey = isCurrentDay || isTomorrow ? "DayView_logs_empty" : "DayView_logs_empty_past";
        logViews.push((0, $7b02d682eb115277$exports.jsx)("div", {
            className: "DayView-logs-empty",
            children: app.t(emptyKey)
        }, "empty"));
    }
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "DayView-logs" + (logViews.length < 1 ? " empty" : ""),
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "DayView-logs-spacer",
                children: (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "DayView-logs-timeline pre",
                    children: preHours
                })
            }),
            logViews,
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "DayView-logs-spacer",
                children: (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "DayView-logs-timeline post",
                    children: postHours
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");











function $4c21e47ac1ffe512$export$b333bc47487f16a5(crypto) {
    if (crypto.randomUUID) return crypto.randomUUID();
    if (!crypto.getRandomValues) throw new Error("A randomUUID or getRandomValues implementation is required");
    var bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = bytes[6] & 0x0f | 0x40;
    bytes[8] = bytes[8] & 0x3f | 0x80;
    var hex = Array.from(bytes, function(byte) {
        return byte.toString(16).padStart(2, "0");
    }).join("");
    return "".concat(hex.slice(0, 8), "-").concat(hex.slice(8, 12), "-").concat(hex.slice(12, 16), "-").concat(hex.slice(16, 20), "-").concat(hex.slice(20));
}


function $9c0132826a7abb0f$export$dfeddf860e7d8422() {
    return (0, $4c21e47ac1ffe512$export$b333bc47487f16a5)(globalThis.crypto);
}


const $2ece6f66deb87000$export$66b447249f9e573b = {
    saveDay (api, shipId, dayId, values) {
        return new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(api).days.update({
            params: {
                shipId: shipId,
                dayId: dayId
            },
            body: values
        }).call();
    }
};
function $2ece6f66deb87000$export$299a5829ffa20395({ day: day }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const { isCurrentTrip: isCurrentTrip, updateDay: updateDay } = (0, $97ac05743b787a86$export$95d65094202e15e7)();
    const editable = app.editable && (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).availableCurrentOrAll(apiUser, ship.id, isCurrentTrip);
    const t = app.getT("DayWatchView");
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const initialWatchData = (0, $acw62.useMemo)(()=>{
        const data = (0, $50f4daf09d2513a4$export$7a9a31a911eb9a20).parse(day).dataParsed;
        if (data.watch) return data.watch;
        return {
            type: (0, $4ccb8ce47c65bb30$export$6e6224a0a88eefa2).manual,
            groups: [],
            shifts: []
        };
    }, [
        day
    ]);
    const [watchData, setWatchData] = (0, $acw62.useState)(initialWatchData);
    const [watchGroups, setWatchGroups] = (0, $acw62.useState)(initialWatchData.groups || []);
    const [watchShifts, setWatchShifts] = (0, $acw62.useState)(initialWatchData.shifts || []);
    const editableFields = [
        {
            name: "watch",
            type: "object",
            fields: [
                {
                    name: "type",
                    type: "string"
                },
                {
                    name: "groups",
                    type: "object",
                    array: true,
                    fields: [
                        "id",
                        "name",
                        {
                            name: "people",
                            array: true,
                            type: "int"
                        }
                    ]
                },
                {
                    name: "shifts",
                    type: "object",
                    array: true,
                    fields: [
                        "id",
                        {
                            name: "start",
                            type: "int"
                        },
                        {
                            name: "duration",
                            type: "int"
                        },
                        "group"
                    ]
                }
            ]
        }
    ];
    const newId = (0, $9c0132826a7abb0f$export$dfeddf860e7d8422);
    const save = (0, $acw62.useCallback)(async (_data, values)=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("save", (0, $ea493e883ca706d4$export$9de129cb03ba998c)(values));
        const result = await updateDay({
            data: JSON.stringify(values)
        });
        if (result) {
            const day = result.day;
            const data = (0, $50f4daf09d2513a4$export$7a9a31a911eb9a20).parse(day).dataParsed;
            const watch = data.watch;
            if (watch) {
                setWatchData(watch);
                setWatchGroups(watch.groups || []);
                setWatchShifts(watch.shifts || []);
            }
            resetEdited();
        }
    }, [
        updateDay,
        resetEdited
    ]);
    const addMoreWatchShifts = (0, $acw62.useMemo)(()=>{
        if (watchShifts.length < 1) return true;
        const lastShift = watchShifts[watchShifts.length - 1];
        if (lastShift.start + lastShift.duration < 24) return true;
        return false;
    }, [
        watchShifts
    ]);
    const nextWatchShift = (0, $acw62.useCallback)(()=>{
        const lastShift = watchShifts.length > 0 ? watchShifts[watchShifts.length - 1] : undefined;
        if (lastShift) return {
            id: newId(),
            start: lastShift.start + lastShift.duration,
            duration: lastShift.duration,
            group: undefined
        };
        return {
            id: newId(),
            start: 0,
            duration: 4,
            group: undefined
        };
    }, [
        watchShifts
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "DayWatchView",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
            changed: edited,
            editable: editable,
            editableFields: editableFields,
            onSave: save,
            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: t("groups_title")
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "hidden",
                        name: "watch.type",
                        value: watchData.type
                    }),
                    watchGroups.map((group, index)=>{
                        return (0, $7b02d682eb115277$exports.jsx)($2ece6f66deb87000$export$fe80caef93572aba, {
                            crewIds: day.crew || [],
                            editable: editable,
                            group: group,
                            index: index,
                            onEdited: onEdited,
                            showLabels: index === 0
                        }, index);
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                            children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: "button",
                                disabled: !editable,
                                onClick: ()=>{
                                    setWatchGroups([
                                        ...watchGroups,
                                        {
                                            id: newId(),
                                            name: "",
                                            people: []
                                        }
                                    ]);
                                    onEdited();
                                },
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                    }),
                                    " ",
                                    t("add_group")
                                ]
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: t("shifts_title")
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "hidden",
                        name: "watch.shifts.length",
                        value: watchShifts.length
                    }),
                    watchShifts.map((shift, index)=>{
                        return (0, $7b02d682eb115277$exports.jsx)($2ece6f66deb87000$export$300fd8914c611bd7, {
                            editable: editable,
                            shift: shift,
                            index: index,
                            onEdited: onEdited,
                            showLabels: index === 0,
                            watchGroups: watchGroups
                        }, index);
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "button",
                                    disabled: !editable || !addMoreWatchShifts,
                                    onClick: ()=>{
                                        setWatchShifts([
                                            ...watchShifts,
                                            nextWatchShift()
                                        ]);
                                        onEdited();
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                        }),
                                        " ",
                                        t("add_shift")
                                    ]
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "button",
                                    disabled: !editable || watchShifts.length < 1,
                                    onClick: ()=>{
                                        setWatchShifts([]);
                                        onEdited();
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                        }),
                                        " ",
                                        t("reset_shifts")
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function $2ece6f66deb87000$export$fe80caef93572aba({ crewIds: crewIds, editable: editable, group: group, index: index, onEdited: onEdited, showLabels: showLabels = false }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("DayWatchView_groups");
    const namePrefix = `watch.groups[${index}].`;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
        className: "DayWatchView-group",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "hidden",
                name: `${namePrefix}id`,
                defaultValue: group.id
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: showLabels ? t("name") : undefined,
                className: "block_field_small_12",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        defaultValue: group.name,
                        name: `${namePrefix}name`,
                        onChange: onEdited,
                        readOnly: !editable
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: showLabels ? t("people") : undefined,
                children: (0, $7b02d682eb115277$exports.jsx)((0, $d5a725d5c44f3d0f$export$b65e701dc90258f), {
                    defaultValue: group.people,
                    multi: true,
                    onChange: onEdited,
                    restrictIds: crewIds,
                    role: (0, $dc7739d612f0c536$export$1e4ade51a6368243).crew,
                    name: `${namePrefix}people`,
                    readOnly: !editable
                })
            })
        ]
    });
}
function $2ece6f66deb87000$export$300fd8914c611bd7({ editable: editable, shift: shift, index: index, onEdited: onEdited, showLabels: showLabels = false, watchGroups: watchGroups }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("DayWatchView_shifts");
    const namePrefix = `watch.shifts[${index}].`;
    const [watchGroup, setWatchGroup] = (0, $acw62.useState)(shift.group || undefined);
    // Create options for the Select component
    const watchGroupOptions = (0, $acw62.useMemo)(()=>{
        const options = watchGroups.map((group)=>{
            return {
                title: group.name,
                value: group.name
            };
        });
        return options;
    }, [
        watchGroups
    ]);
    const selectWatchGroup = (0, $acw62.useCallback)((value)=>{
        setWatchGroup(value);
        if (onEdited) onEdited();
    }, [
        onEdited
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
        className: "DayShiftsView-group",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "hidden",
                name: `${namePrefix}id`,
                defaultValue: shift.id
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: showLabels ? t("hour") : undefined,
                className: "block_field_small_4",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                        defaultValue: shift.start,
                        name: `${namePrefix}start`,
                        onChange: onEdited,
                        readOnly: !editable,
                        className: "center"
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: showLabels ? t("duration") : undefined,
                className: "block_field_small_8",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                        defaultValue: shift.duration,
                        name: `${namePrefix}duration`,
                        onChange: onEdited,
                        readOnly: !editable,
                        className: "center"
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: showLabels ? t("group") : undefined,
                className: "block_field_small_12",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                    button: watchGroup ? watchGroup : t(`group_${watchGroup}`),
                    name: `${namePrefix}group`,
                    value: watchGroup,
                    onSelect: selectWatchGroup,
                    options: watchGroupOptions,
                    readOnly: !editable
                })
            })
        ]
    });
}







var $acw62 = parcelRequire("acw62");

// Coordinates are rounded to this many decimals before anything consumes them, so the
// markers and the polyline are placed from byte-identical numbers rather than two
// independently rounded values (issue #150).
const $b3f60204cb8798d1$var$PRECISION = 3;
function $b3f60204cb8798d1$var$round(value) {
    const factor = 10 ** $b3f60204cb8798d1$var$PRECISION;
    return Math.round(value * factor) / factor;
}
const $b3f60204cb8798d1$export$804ce8cdc3ef0047 = {
    computeScales (timeseries, valueScale) {
        if (!timeseries) return undefined;
        const sorted = timeseries.map((ts)=>ts.timeUtc).toSorted((a, b)=>a - b);
        const valueSorted = timeseries.map((ts)=>ts.value).toSorted((a, b)=>a - b);
        return {
            scaleX: {
                max: sorted[sorted.length - 1],
                min: sorted[0]
            },
            scaleY: valueScale ? valueScale : {
                max: valueSorted[valueSorted.length - 1],
                min: valueSorted[0]
            },
            text: timeseries.map((t)=>t.text),
            timeUtc: timeseries.map((t)=>t.timeUtc),
            values: timeseries.map((t)=>t.value)
        };
    },
    pointY (ts, value, height) {
        if (!ts) return 0;
        const size = ts.scaleY.max - ts.scaleY.min;
        if (size <= 0) // Every value is identical (and no explicit scale was given): put the flat line
        // through the middle rather than dividing by zero into NaN coordinates.
        return height / 2;
        const vt = value - ts.scaleY.min;
        return height - vt / size * height;
    },
    // The single source of truth for the plotted geometry: both the polyline (via `path`)
    // and the rendered markers read this array, so they cannot drift apart.
    points (ts, height) {
        if (!ts) return [];
        const size = ts.scaleX.max - ts.scaleX.min;
        // Anchored on the smallest timestamp rather than the first one: computeScales keeps
        // the caller's ordering, so the series is not guaranteed to be sorted.
        const x = ts.timeUtc.map((t)=>size > 0 ? $b3f60204cb8798d1$var$round((t - ts.scaleX.min) / size * 100) : 0);
        return ts.values.map((value, i)=>{
            const bandLeft = i === 0 ? 0 : $b3f60204cb8798d1$var$round((x[i - 1] + x[i]) / 2);
            const bandRight = i === x.length - 1 ? 100 : $b3f60204cb8798d1$var$round((x[i] + x[i + 1]) / 2);
            return {
                bandLeft: bandLeft,
                bandWidth: $b3f60204cb8798d1$var$round(bandRight - bandLeft),
                text: ts.text[i],
                timeUtc: ts.timeUtc[i],
                value: value,
                x: x[i],
                y: $b3f60204cb8798d1$var$round($b3f60204cb8798d1$export$804ce8cdc3ef0047.pointY(ts, value, height))
            };
        });
    },
    legend (ts, legend, height) {
        if (!ts) return undefined;
        if (legend && legend.length > 0) return legend.map((l)=>{
            return {
                label: l.label,
                top: $b3f60204cb8798d1$export$804ce8cdc3ef0047.pointY(ts, l.value, height),
                value: l.value || 0
            };
        });
        const numPoints = 5;
        const size = ts.scaleY.max - ts.scaleY.min;
        return Array.from(Array(numPoints).keys()).map((n)=>{
            const s = n * size / (numPoints - 1);
            const value = ts.scaleY.min + s;
            return {
                top: $b3f60204cb8798d1$export$804ce8cdc3ef0047.pointY(ts, value, height),
                value: value || 0
            };
        });
    },
    path (ts, height) {
        if (!ts || ts.values.length <= 1) return "";
        return $b3f60204cb8798d1$export$804ce8cdc3ef0047.points(ts, height).map((p)=>`${p.x.toFixed($b3f60204cb8798d1$var$PRECISION)},${p.y.toFixed($b3f60204cb8798d1$var$PRECISION)}`).join(" ");
    }
};
function $b3f60204cb8798d1$export$614db49f3febe941({ legend: legend, timeseries: timeseries, valueScale: valueScale }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("GraphView");
    const height = 150;
    const ts = (0, $acw62.useMemo)(()=>{
        return $b3f60204cb8798d1$export$804ce8cdc3ef0047.computeScales(timeseries, valueScale);
    }, [
        timeseries
    ]);
    const legendY = (0, $acw62.useMemo)(()=>$b3f60204cb8798d1$export$804ce8cdc3ef0047.legend(ts, legend, height), [
        ts
    ]);
    const points = (0, $acw62.useMemo)(()=>$b3f60204cb8798d1$export$804ce8cdc3ef0047.points(ts, height), [
        ts
    ]);
    const path = (0, $acw62.useMemo)(()=>$b3f60204cb8798d1$export$804ce8cdc3ef0047.path(ts, height), [
        ts
    ]);
    return timeseries && ts && legendY && ts.values.length > 1 ? (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "GraphView-Graph",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "GraphView-Graph-body",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "GraphView-Graph-scale-y",
                        children: legendY.map((l, i)=>{
                            return (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "scale-point",
                                style: {
                                    top: `${l.top}px`
                                },
                                children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "label",
                                    children: l.label || l.value.toFixed(0)
                                })
                            }, `scale-y-${i}`);
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "GraphView-Graph-data",
                        style: {
                            height: `${height}px`
                        },
                        children: [
                            points.map((p, i)=>(0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "data-point",
                                    style: {
                                        left: `${p.x}%`
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "line-y"
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "point-y",
                                            style: {
                                                top: `${p.y}px`
                                            }
                                        })
                                    ]
                                }, `data-point-${i}-${p.timeUtc}`)),
                            (0, $7b02d682eb115277$exports.jsx)("svg", {
                                className: "line",
                                viewBox: "0 0 100 " + height,
                                preserveAspectRatio: "none",
                                children: (0, $7b02d682eb115277$exports.jsx)("polyline", {
                                    className: "graph-line",
                                    fill: "none",
                                    points: path,
                                    stroke: "currentColor",
                                    vectorEffect: "non-scaling-stroke"
                                })
                            }),
                            points.map((p, i)=>(0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "data-point-hover",
                                    style: {
                                        left: `${p.bandLeft}%`,
                                        width: `${p.bandWidth}%`
                                    },
                                    title: `${p.text}`
                                }, `data-point-hover-${i}-${p.timeUtc}`))
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "GraphView-Graph-scale-x",
                children: ts.timeUtc.map((_d, i)=>(0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "t"
                    }, `scale-x-${i}`))
            })
        ]
    }) : (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "GraphView-Graph-no-data",
        children: t("no_data")
    });
}


const $da41652818610294$export$cd9c5a1490ea135d = {
    generate (timeseries, graph) {
        if (!timeseries || !graph) return [];
        return timeseries.data.map((d)=>{
            const value = graph.value(d);
            if (value === undefined || isNaN(value)) return undefined;
            return {
                text: `${(0, $14a8bda8b42de2c4$export$93514d28bd18d75a).dateInYear(d.timeUtc)} ${(0, $14a8bda8b42de2c4$export$93514d28bd18d75a).timeUtc(d.timeUtc)}: ${graph.textValue(d)}`,
                timeUtc: d.timeUtc,
                value: value
            };
        }).filter((t)=>t != undefined);
    }
};
function $da41652818610294$export$6a7fe3ef90e8d566({ timeseries: timeseries }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("GraphView");
    const graphs = {
        pressure: {
            textValue: (d)=>d.pressure ? d.pressure.toFixed(1) : undefined,
            value: (d)=>d.pressure,
            valueScale: {
                max: 1085,
                min: 865
            }
        },
        temperature: {
            textValue: (d)=>d.temperature ? d.temperature.toFixed(0) : undefined,
            value: (d)=>d.temperature
        },
        windDirection: {
            legend: [
                {
                    label: "N",
                    value: 0
                },
                {
                    label: "NE",
                    value: 45
                },
                {
                    label: "E",
                    value: 90
                },
                {
                    label: "SE",
                    value: 135
                },
                {
                    label: "S",
                    value: 180
                },
                {
                    label: "SW",
                    value: 225
                },
                {
                    label: "W",
                    value: 270
                },
                {
                    label: "NW",
                    value: 315
                },
                {
                    label: "N",
                    value: 360
                }
            ],
            textValue: (d)=>d.windDirection ? t("graph_windDirection_unit", {
                    direction: d.windDirection.toFixed(0)
                }) : undefined,
            value: (d)=>d.windDirection,
            valueScale: {
                max: 360,
                min: 0
            }
        },
        windSpeed: {
            textValue: (d)=>d.windSpeed ? d.windSpeed.toFixed(0) : undefined,
            value: (d)=>d.windSpeed
        }
    };
    function gen(g) {
        return $da41652818610294$export$cd9c5a1490ea135d.generate(timeseries, graphs[g]);
    }
    return timeseries ? (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "GraphView",
        children: Object.keys(graphs).map((g)=>{
            return (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "GraphView-Graph-container",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "GraphView-Graph-title",
                        children: t(`graph_${g}`)
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $b3f60204cb8798d1$export$614db49f3febe941), {
                        legend: graphs[g].legend,
                        timeseries: gen(g),
                        valueScale: graphs[g].valueScale
                    })
                ]
            }, `graph-${g}`);
        })
    }) : (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
}


// NoteView has been decomposed into a Views/Note/ folder. This root file stays as a
// thin composer that re-exports the public API so existing `./NoteView` import paths
// (CruiseView / DayView / TripView and the view tests) keep working unchanged.



const $16fdfdea6c651031$var$noteIcons = {
    [(0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).planning]: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).NoteCruisePlan,
    [(0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).journal]: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).NoteJournal,
    [(0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).technical]: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).NoteTechnical,
    [(0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).weather]: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).NoteWeatherReport
};
function $16fdfdea6c651031$export$47454dfb9cf493ea(noteType) {
    return $16fdfdea6c651031$var$noteIcons[noteType] || (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Note;
}
function $16fdfdea6c651031$export$7c2353396e2a8670(parentType, cruise, day, trip) {
    switch(parentType){
        case (0, $d460697aab603bc5$export$5daa50148070bda5).cruise:
            return cruise;
        case (0, $d460697aab603bc5$export$5daa50148070bda5).day:
            return day;
        case (0, $d460697aab603bc5$export$5daa50148070bda5).trip:
            return trip;
        default:
            return undefined;
    }
}
function $16fdfdea6c651031$export$9efb223871c6e7f5(parentType, note) {
    if (!note) return false;
    switch(parentType){
        case (0, $d460697aab603bc5$export$5daa50148070bda5).cruise:
            return note.tripId == undefined && note.dayId == undefined;
        case (0, $d460697aab603bc5$export$5daa50148070bda5).day:
            return note.dayId != undefined;
        case (0, $d460697aab603bc5$export$5daa50148070bda5).trip:
            return note.tripId != undefined && note.dayId == undefined;
        default:
            return false;
    }
}
const $16fdfdea6c651031$export$83024d80cbec28a2 = {
    [(0, $d460697aab603bc5$export$5daa50148070bda5).cruise]: {
        types: [
            (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).planning
        ]
    },
    [(0, $d460697aab603bc5$export$5daa50148070bda5).day]: {
        types: [
            (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).weather,
            (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).journal,
            (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).technical
        ]
    },
    [(0, $d460697aab603bc5$export$5daa50148070bda5).trip]: {
        types: [
            (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).journal,
            (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).technical
        ]
    }
};
function $16fdfdea6c651031$export$ceded59ee1e5da57(parentType) {
    var _a, _b, _c;
    // Read every context unconditionally so the hook call order stays stable
    // regardless of parentType. Branching the `useContext` calls per parentType
    // (as before) changed the hook order across renders, which React flagged with
    // "change in the order of Hooks called by NoteView".
    const cruise = (_a = (0, $97ac05743b787a86$export$135b8b9ecdd62154)()) === null || _a === void 0 ? void 0 : _a.cruise;
    const trip = (_b = (0, $97ac05743b787a86$export$e205ea882cbd693e)()) === null || _b === void 0 ? void 0 : _b.trip;
    const day = (_c = (0, $97ac05743b787a86$export$95d65094202e15e7)()) === null || _c === void 0 ? void 0 : _c.day;
    switch(parentType){
        case (0, $d460697aab603bc5$export$5daa50148070bda5).cruise:
            return [
                cruise,
                undefined,
                undefined
            ];
        case (0, $d460697aab603bc5$export$5daa50148070bda5).day:
            return [
                undefined,
                undefined,
                day
            ];
        case (0, $d460697aab603bc5$export$5daa50148070bda5).trip:
            return [
                undefined,
                trip,
                undefined
            ];
        default:
            return [
                undefined,
                undefined,
                undefined
            ];
    }
}
const $16fdfdea6c651031$export$253d5d448b372de = [
    (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).weather
];
const $16fdfdea6c651031$export$1e7f12a5f31edb19 = [
    (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).journal,
    (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).technical,
    (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).weather
];
const $16fdfdea6c651031$export$d446cd8040ca08c3 = [
    (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).weather,
    (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).planning
];
const $16fdfdea6c651031$export$c50436fcef0bbb60 = [
    (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).planning
];
const $16fdfdea6c651031$export$d123933fb27549c4 = [
    (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).weather
];
const $16fdfdea6c651031$export$8957b8252c394f55 = {
    noteContentFields (noteType) {
        return {
            hasDate: $16fdfdea6c651031$export$d446cd8040ca08c3.indexOf(noteType) >= 0,
            noteIsInput: $16fdfdea6c651031$export$c50436fcef0bbb60.indexOf(noteType) >= 0,
            hasNoteExtra: $16fdfdea6c651031$export$d123933fb27549c4.indexOf(noteType) >= 0
        };
    },
    loadWeatherNoteTitleAutocomplete (api, shipId) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.autocomplete({
            params: {
                shipId: shipId,
                field: "weatherNoteTitle"
            }
        }).call();
    },
    // #1137: creates the Day row a blank/backfilled day's draft note is the first thing
    // to touch -- idempotent server-side (a duplicate create for the same date returns
    // the existing row), so a second note-type tab's own draft save races safely.
    createDay (api, shipId, tripId, day) {
        return new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(api).days.create({
            params: {
                shipId: shipId,
                tripId: tripId
            },
            body: {
                day: day
            }
        }).call();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    saveNote (api, shipId, noteId, values) {
        return new (0, $5ad0742384a42800$export$5cea990fb3a4e5e9)(api).notes.update({
            params: {
                shipId: shipId,
                noteId: noteId
            },
            body: values
        }).call();
    },
    createNote (api, parentType, shipId, parentId, body) {
        const notes = new (0, $5ad0742384a42800$export$5cea990fb3a4e5e9)(api).notes;
        switch(parentType){
            case (0, $d460697aab603bc5$export$5daa50148070bda5).cruise:
                return notes.createForCruise({
                    params: {
                        shipId: shipId,
                        cruiseId: parentId
                    },
                    body: body
                }).call();
            case (0, $d460697aab603bc5$export$5daa50148070bda5).day:
                return notes.createForDay({
                    params: {
                        shipId: shipId,
                        dayId: parentId
                    },
                    body: body
                }).call();
            case (0, $d460697aab603bc5$export$5daa50148070bda5).trip:
                return notes.createForTrip({
                    params: {
                        shipId: shipId,
                        tripId: parentId
                    },
                    body: body
                }).call();
            default:
                throw new Error(`Unknown note parent type: ${parentType}`);
        }
    },
    uploadAttachment (api, shipId, noteId, attachment) {
        return new (0, $5ad0742384a42800$export$5cea990fb3a4e5e9)(api).noteAttachments.create({
            params: {
                shipId: shipId,
                noteId: noteId
            },
            body: {
                attachment: attachment
            }
        }).call();
    }
};




var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");

















var $acw62 = parcelRequire("acw62");





const $86850ed0d32dea3a$export$2c13e988217f85e9 = {
    visibleAttachments (attachments, removedIds) {
        return (attachments || []).filter((a)=>removedIds.indexOf(a.id) < 0);
    },
    removeAttachment (api, shipId, noteId, attachmentId) {
        return new (0, $5ad0742384a42800$export$5cea990fb3a4e5e9)(api).noteAttachments.delete({
            params: {
                shipId: shipId,
                noteId: noteId,
                attachmentId: attachmentId
            }
        }).call();
    },
    attachmentUrl (api, shipId, noteId, attachment, cloudSession) {
        return cloudSession || attachment.useUrl ? attachment.url || "" : new (0, $5ad0742384a42800$export$5cea990fb3a4e5e9)(api).noteAttachments.download({
            params: {
                shipId: shipId,
                noteId: noteId,
                attachmentId: attachment.id
            }
        }).url();
    },
    isImage (attachment) {
        return attachment.contentType.startsWith("image/");
    }
};
function $86850ed0d32dea3a$export$3c97a1029d5daa9c({ attachments: attachments, shipId: shipId, noteId: noteId, editable: editable, cloudSession: cloudSession, removeConfirm: removeConfirm, removeAttachment: removeAttachment }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const [removedIds, setRemovedIds] = (0, $acw62.useState)([]);
    const [pendingRemovalAttachmentId, setPendingRemovalAttachmentId] = (0, $acw62.useState)(undefined);
    const visible = (0, $acw62.useMemo)(()=>$86850ed0d32dea3a$export$2c13e988217f85e9.visibleAttachments(attachments, removedIds), [
        attachments,
        removedIds
    ]);
    const requestRemove = (0, $acw62.useCallback)((attachmentId)=>(event)=>{
            event === null || event === void 0 || event.preventDefault();
            event === null || event === void 0 || event.stopPropagation();
            setPendingRemovalAttachmentId(attachmentId);
        }, []);
    const cancelRemove = (0, $acw62.useCallback)(()=>setPendingRemovalAttachmentId(undefined), []);
    const confirmRemove = (0, $acw62.useCallback)(async ()=>{
        if (pendingRemovalAttachmentId == undefined) return;
        // Let a failed request propagate so the dialog can keep itself open and show the error;
        // only dismiss the dialog once the removal has actually succeeded.
        await (removeAttachment ? removeAttachment(pendingRemovalAttachmentId) : $86850ed0d32dea3a$export$2c13e988217f85e9.removeAttachment(app.apiClient, shipId, noteId, pendingRemovalAttachmentId));
        setRemovedIds((ids)=>[
                ...ids,
                pendingRemovalAttachmentId
            ]);
        setPendingRemovalAttachmentId(undefined);
    }, [
        pendingRemovalAttachmentId,
        shipId,
        noteId,
        app,
        removeAttachment
    ]);
    if (visible.length < 1) return null;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
        className: "NoteView-attachments",
        children: [
            visible.map((a)=>{
                const key = `note-${noteId}-attachment-${a.id}`;
                const url = $86850ed0d32dea3a$export$2c13e988217f85e9.attachmentUrl(app.apiClient, shipId, noteId, a, cloudSession);
                return (0, $7b02d682eb115277$exports.jsxs)("a", {
                    href: url,
                    className: "attachment",
                    target: "_blank",
                    rel: "noreferrer",
                    children: [
                        editable && (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                            className: "attachment-remove",
                            onClick: requestRemove(a.id)
                        }),
                        $86850ed0d32dea3a$export$2c13e988217f85e9.isImage(a) && (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: url
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "attachment-label",
                            children: [
                                a.fileName,
                                ".",
                                a.fileType
                            ]
                        })
                    ]
                }, key);
            }),
            pendingRemovalAttachmentId != undefined && (0, $7b02d682eb115277$exports.jsx)((0, $e7bc01546cf183b2$export$2cc85109a937009e), {
                awaitConfirm: true,
                title: removeConfirm.title,
                message: removeConfirm.message,
                confirmLabel: removeConfirm.confirmLabel,
                cancelLabel: removeConfirm.cancelLabel,
                errorMessage: removeConfirm.errorMessage,
                style: "alarm",
                onConfirm: confirmRemove,
                onCancel: cancelRemove
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");


function $3f05b828a1b5d71d$var$createNoteRequest(api, parentType, shipId, parentId, body) {
    switch(parentType){
        case (0, $d460697aab603bc5$export$5daa50148070bda5).cruise:
            return api.notes.createForCruise({
                params: {
                    shipId: shipId,
                    cruiseId: parentId
                },
                body: body
            }).call();
        case (0, $d460697aab603bc5$export$5daa50148070bda5).day:
            return api.notes.createForDay({
                params: {
                    shipId: shipId,
                    dayId: parentId
                },
                body: body
            }).call();
        case (0, $d460697aab603bc5$export$5daa50148070bda5).trip:
            return api.notes.createForTrip({
                params: {
                    shipId: shipId,
                    tripId: parentId
                },
                body: body
            }).call();
        default:
            return Promise.reject(new Error(`Unknown note parent type: ${parentType}`));
    }
}
function $3f05b828a1b5d71d$export$48eea18949de164b(store, { shipId: shipId }) {
    return {
        createDay: (tripId, day)=>store.mutate({
                request: (client)=>new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(client).days.create({
                        params: {
                            shipId: shipId,
                            tripId: tripId
                        },
                        body: {
                            day: day
                        }
                    }).call(),
                reconcile: (response)=>({
                        entities: {
                            Day: [
                                response.day
                            ]
                        }
                    })
            }),
        createNote: (parentType, parentId, body)=>store.mutate({
                request: (client)=>$3f05b828a1b5d71d$var$createNoteRequest(new (0, $5ad0742384a42800$export$5cea990fb3a4e5e9)(client), parentType, shipId, parentId, body),
                reconcile: (response)=>({
                        entities: {
                            Note: response.note ? [
                                response.note
                            ] : []
                        }
                    })
            }),
        updateNote: (noteId, values)=>store.mutate({
                request: (client)=>new (0, $5ad0742384a42800$export$5cea990fb3a4e5e9)(client).notes.update({
                        params: {
                            shipId: shipId,
                            noteId: noteId
                        },
                        body: values
                    }).call(),
                reconcile: (response)=>({
                        entities: {
                            Note: response.note ? [
                                response.note
                            ] : []
                        }
                    })
            }),
        uploadAttachment: (noteId, attachment)=>store.mutate({
                request: (client)=>new (0, $5ad0742384a42800$export$5cea990fb3a4e5e9)(client).noteAttachments.create({
                        params: {
                            shipId: shipId,
                            noteId: noteId
                        },
                        body: {
                            attachment: attachment
                        }
                    }).call(),
                reconcile: (response)=>({
                        entities: {
                            NoteAttachment: response.attachment ? [
                                response.attachment
                            ] : []
                        }
                    })
            }),
        deleteAttachment: (noteId, attachmentId)=>store.mutate({
                optimistic: {
                    remove: {
                        NoteAttachment: [
                            attachmentId
                        ]
                    }
                },
                request: (client)=>new (0, $5ad0742384a42800$export$5cea990fb3a4e5e9)(client).noteAttachments.delete({
                        params: {
                            shipId: shipId,
                            noteId: noteId,
                            attachmentId: attachmentId
                        }
                    }).call()
            })
    };
}
function $3f05b828a1b5d71d$export$57769684473856e7(shipId) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    return (0, $acw62.useMemo)(()=>$3f05b828a1b5d71d$export$48eea18949de164b(store, {
            shipId: shipId
        }), [
        shipId,
        store
    ]);
}


function $848e949c1e6be720$export$cc2739341428a8da({ editable: editable, isCurrentTrip: isCurrentTrip, note: note, noteType: noteType, parentType: parentType }) {
    var _a, _b, _c;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const contextStore = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const [fallbackStore] = (0, $acw62.useState)(()=>new (0, $e188c40f4bf71e3c$export$47a0e4800a1fd7dc)());
    const store = contextStore !== null && contextStore !== void 0 ? contextStore : fallbackStore;
    const writers = (0, $3f05b828a1b5d71d$export$57769684473856e7)(ship.id);
    (0, $acw62.useState)(()=>{
        var _a;
        if (note) store.applyBundle({
            entities: {
                Note: [
                    note
                ],
                NoteAttachment: (_a = note.attachments) !== null && _a !== void 0 ? _a : []
            }
        });
        return true;
    });
    const storedNote = (0, $b82e6d2a15bbd8b8$export$fab329b658bf30c7)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Note, (_a = note === null || note === void 0 ? void 0 : note.id) !== null && _a !== void 0 ? _a : 0);
    const storedAttachments = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).NoteAttachment, {
        noteId: (0, $55c0c0d4c269af54$export$a7a0278c004aac3f)(note === null || note === void 0 ? void 0 : note.id)
    });
    (0, $9690902269ab2924$export$e4edb3e6a3489a79)([
        (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Note,
        (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).NoteAttachment
    ], note !== undefined, note === null || note === void 0 ? void 0 : note.id);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (note) store.applyBundle({
            entities: {
                Note: [
                    note
                ],
                NoteAttachment: (_a = note.attachments) !== null && _a !== void 0 ? _a : []
            }
        });
    }, [
        note,
        store
    ]);
    const canonicalNote = storedNote ? Object.assign(Object.assign({}, storedNote), {
        attachments: [
            ...storedAttachments
        ]
    }) : note;
    const { apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    const { shipCloudEditable: shipCloudEditable } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const [parentCruise, parentTrip, parentDay] = (0, $16fdfdea6c651031$export$ceded59ee1e5da57)(parentType);
    // Full trip/cruise contexts (with their day/trip lists) read at the top level
    // so `parentInfo` below doesn't call these context hooks inside a useMemo.
    const tripDays = (_b = (0, $97ac05743b787a86$export$e205ea882cbd693e)()) === null || _b === void 0 ? void 0 : _b.days;
    const cruiseTrips = (_c = (0, $97ac05743b787a86$export$135b8b9ecdd62154)()) === null || _c === void 0 ? void 0 : _c.trips;
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const t = app.getT("NoteView");
    const editableFields = [
        "date",
        "note",
        "noteExtra",
        {
            name: "noteType",
            type: "int"
        },
        "title"
    ];
    const contentFields = (0, $16fdfdea6c651031$export$8957b8252c394f55).noteContentFields(noteType);
    const [files, setFiles] = (0, $acw62.useState)([]);
    const [uploadedAttachments, setUploadedAttachments] = (0, $acw62.useState)([]);
    const attachments = (0, $acw62.useMemo)(()=>{
        const persisted = (canonicalNote === null || canonicalNote === void 0 ? void 0 : canonicalNote.attachments) || [];
        const persistedIds = new Set(persisted.map((attachment)=>attachment.id));
        return [
            ...persisted,
            ...uploadedAttachments.filter((attachment)=>!persistedIds.has(attachment.id))
        ];
    }, [
        canonicalNote === null || canonicalNote === void 0 ? void 0 : canonicalNote.attachments,
        uploadedAttachments
    ]);
    const [autocompleteWeatherNoteTitle, setAutocompleteWeatherNoteTitle] = (0, $acw62.useState)(undefined);
    const inputRef = (0, $acw62.useRef)(null);
    const formEditable = (0, $acw62.useMemo)(()=>shipCloudEditable || app.editable && editable != false && (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).availableCurrentOrAll(apiUser, ship.id, isCurrentTrip), []);
    (0, $acw62.useEffect)(()=>{
        const load = async ()=>{
            if (noteType === (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).weather && !autocompleteWeatherNoteTitle) {
                const weatherNoteTitleData = await (0, $16fdfdea6c651031$export$8957b8252c394f55).loadWeatherNoteTitleAutocomplete(app.apiClient, ship.id);
                setAutocompleteWeatherNoteTitle((weatherNoteTitleData === null || weatherNoteTitleData === void 0 ? void 0 : weatherNoteTitleData.values) || []);
            }
        };
        load().catch(console.error);
    }, [
        noteType,
        ship.id,
        autocompleteWeatherNoteTitle
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const saveEdits = (0, $acw62.useCallback)(async (_data, values)=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("saving", (0, $ea493e883ca706d4$export$9de129cb03ba998c)(values));
        if (!canonicalNote) {
            // #1137: an uncreated blank-day draft -- create the Day first (idempotent
            // server-side, so a second note-type tab's own draft save races safely) if it
            // doesn't exist yet, then the note itself, together in this one explicit save.
            let parent = (0, $16fdfdea6c651031$export$7c2353396e2a8670)(parentType, parentCruise, parentDay, parentTrip);
            if (parentType == (0, $d460697aab603bc5$export$5daa50148070bda5).day && parentDay && !parentDay.id) {
                const dayResult = await writers.createDay(parentDay.tripId, parentDay.day);
                parent = dayResult.day;
            }
            if (!parent) return;
            const result = await writers.createNote(parentType, parent.id, values);
            if (result && result.note) resetEdited();
            return;
        }
        const result = await writers.updateNote(canonicalNote.id, values);
        if (result && result.note) // updated
        resetEdited();
    }, [
        canonicalNote,
        parentType,
        parentCruise,
        parentDay,
        parentTrip,
        writers
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const saveAttachments = (0, $acw62.useCallback)(async (_data, _values)=>{
        if (!canonicalNote) return;
        for (const file of files){
            const result = await writers.uploadAttachment(canonicalNote.id, file);
            const attachment = result.attachment;
            if (attachment) setUploadedAttachments((current)=>[
                    ...current.filter((item)=>item.id !== attachment.id),
                    attachment
                ]);
        }
        setFiles([]);
    }, [
        canonicalNote,
        files,
        writers
    ]);
    const handleDrop = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files;
        if (droppedFiles.length > 0) {
            const newFiles = Array.from(droppedFiles);
            setFiles([
                ...files,
                ...newFiles
            ]);
        }
    }, [
        files
    ]);
    const handleSelect = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
        if (event.target.files && event.target.files.length > 0) {
            const newFiles = Array.from(event.target.files);
            setFiles([
                ...files,
                ...newFiles
            ]);
        // event.target.reset();
        }
    }, [
        files
    ]);
    const parentInfo = (0, $acw62.useMemo)(()=>{
        if ((canonicalNote === null || canonicalNote === void 0 ? void 0 : canonicalNote.dayId) != undefined) {
            if (parentType != (0, $d460697aab603bc5$export$5daa50148070bda5).cruise) {
                const day = tripDays === null || tripDays === void 0 ? void 0 : tripDays.find((d)=>d.id == canonicalNote.dayId);
                if (day) return t("note_parent_day", {
                    date: app.format("dateInYear", (0, $600b78128ceeb0f6$export$98e9a0bb257361e9)(day.day).toISOString())
                });
            }
        } else if ((canonicalNote === null || canonicalNote === void 0 ? void 0 : canonicalNote.tripId) != undefined) {
            const trip = cruiseTrips === null || cruiseTrips === void 0 ? void 0 : cruiseTrips.find((t)=>t.id == canonicalNote.tripId);
            if (trip) return t("note_parent_trip", {
                name: trip.title
            });
        }
        return undefined;
    }, [
        canonicalNote,
        parentType,
        tripDays,
        cruiseTrips
    ]);
    const fieldPrefix = (0, $acw62.useMemo)(()=>{
        return `note_${(0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10)[noteType]}`;
    }, [
        noteType
    ]);
    const titleField = (0, $acw62.useMemo)(()=>{
        if (noteType === (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).weather) return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
            label: t(`${fieldPrefix}_title`),
            className: "note-title-field",
            children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$909904bdb4cb4458), {
                defaultValue: canonicalNote === null || canonicalNote === void 0 ? void 0 : canonicalNote.title,
                name: "title",
                onChange: onEdited,
                readOnly: !formEditable,
                suggestions: autocompleteWeatherNoteTitle
            })
        });
        return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
            label: t(`${fieldPrefix}_title`),
            className: "note-title-field",
            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                defaultValue: canonicalNote === null || canonicalNote === void 0 ? void 0 : canonicalNote.title,
                name: "title",
                onChange: onEdited,
                readOnly: !formEditable
            })
        });
    }, [
        canonicalNote,
        formEditable,
        onEdited,
        fieldPrefix,
        noteType,
        autocompleteWeatherNoteTitle
    ]);
    const noteCreator = (0, $acw62.useMemo)(()=>{
        return (canonicalNote === null || canonicalNote === void 0 ? void 0 : canonicalNote.userId) && shipUsers ? shipUsers.find((u)=>u.id == canonicalNote.userId) : undefined;
    }, [
        canonicalNote,
        shipUsers
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "NoteView",
            (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10)[noteType]
        ]),
        children: [
            !(0, $16fdfdea6c651031$export$9efb223871c6e7f5)(parentType, canonicalNote) && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    className: "note-parent-info",
                    children: parentInfo
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                buttonFirst: true,
                changed: edited,
                editable: formEditable,
                editableFields: editableFields,
                manualSave: !canonicalNote,
                onSave: saveEdits,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "hidden",
                        name: "noteType",
                        value: noteType
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: [
                            contentFields.hasDate && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t(`${fieldPrefix}_date`),
                                className: "note-date-field",
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    defaultValue: canonicalNote === null || canonicalNote === void 0 ? void 0 : canonicalNote.date,
                                    name: "date",
                                    onChange: onEdited,
                                    readOnly: !formEditable
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "note-title-field",
                                children: titleField
                            }),
                            contentFields.noteIsInput && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t(`${fieldPrefix}_note`),
                                className: "note-note-field",
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    defaultValue: canonicalNote === null || canonicalNote === void 0 ? void 0 : canonicalNote.note,
                                    name: "note",
                                    onChange: onEdited,
                                    readOnly: !formEditable
                                })
                            })
                        ]
                    }),
                    !contentFields.noteIsInput && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t(`${fieldPrefix}_note`),
                            children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "note-textarea-container",
                                children: (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                    defaultValue: canonicalNote === null || canonicalNote === void 0 ? void 0 : canonicalNote.note,
                                    name: "note",
                                    onChange: onEdited,
                                    readOnly: !formEditable
                                })
                            })
                        })
                    }),
                    contentFields.hasNoteExtra && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "noteextra-textarea-container",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t(`${fieldPrefix}_note_extra`),
                            children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "note-textarea-container",
                                children: (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                    defaultValue: canonicalNote === null || canonicalNote === void 0 ? void 0 : canonicalNote.noteExtra,
                                    name: "noteExtra",
                                    onChange: onEdited,
                                    readOnly: !formEditable
                                })
                            })
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: noteCreator && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    className: "note-creator-info",
                    children: t("note_created_by", {
                        name: noteCreator.name || noteCreator.shortname || ""
                    })
                })
            }),
            formEditable && canonicalNote && (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                buttonFirst: true,
                changed: files.length > 0,
                className: "NoteView-attachment-form",
                editable: true,
                editableFields: [
                    "attachment"
                ],
                onSave: saveAttachments,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "form-field file-field",
                            onDrop: handleDrop,
                            onDragOver: (event)=>event.preventDefault(),
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "attachment",
                                    className: "file-field-label",
                                    onClick: ()=>inputRef.current && inputRef.current.click(),
                                    children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: t("file_field_drag_drop")
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    ref: inputRef,
                                    type: "file",
                                    hidden: true,
                                    multiple: true,
                                    name: "attachment",
                                    onChange: handleSelect
                                })
                            ]
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: files.map((file, index)=>(0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "attachment-item",
                                children: file.name
                            }, index))
                    })
                ]
            }),
            canonicalNote && (0, $7b02d682eb115277$exports.jsx)((0, $86850ed0d32dea3a$export$3c97a1029d5daa9c), {
                attachments: attachments,
                shipId: ship.id,
                noteId: canonicalNote.id,
                editable: formEditable,
                cloudSession: app.cloudSession(),
                removeAttachment: (attachmentId)=>writers.deleteAttachment(canonicalNote.id, attachmentId),
                removeConfirm: {
                    title: t("attachment_remove_title"),
                    message: t("attachment_remove_confirm"),
                    confirmLabel: t("attachment_remove_accept"),
                    cancelLabel: t("attachment_remove_cancel"),
                    errorMessage: t("attachment_remove_error")
                }
            }),
            (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "hr-gray"
            })
        ]
    });
}



function $59a722b1b33d4469$export$2a7d663d787aca05(app, parentType, notes) {
    const t = app.getT("NoteView");
    const config = (0, $16fdfdea6c651031$export$83024d80cbec28a2)[parentType];
    return config.types.map((type)=>{
        const typeName = (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10)[type];
        return {
            icon: (0, $16fdfdea6c651031$export$47454dfb9cf493ea)(type),
            name: `note-${typeName}`,
            title: t(typeName),
            render: ()=>(0, $7b02d682eb115277$exports.jsx)($59a722b1b33d4469$export$a56aa455b2014bd0, {
                    notes: notes.filter((n)=>n.noteType == type),
                    parentType: parentType,
                    noteType: type
                }, `note-${typeName}`)
        };
    });
}
function $59a722b1b33d4469$export$a56aa455b2014bd0({ notes: notes, noteType: noteType, parentType: parentType }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const contextStore = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const [fallbackStore] = (0, $acw62.useState)(()=>new (0, $e188c40f4bf71e3c$export$47a0e4800a1fd7dc)());
    const store = contextStore !== null && contextStore !== void 0 ? contextStore : fallbackStore;
    const writers = (0, $3f05b828a1b5d71d$export$57769684473856e7)(ship.id);
    (0, $acw62.useState)(()=>{
        store.applyBundle({
            entities: (0, $5bd541aff0182fa0$export$e9bc97ba61bf8e52)(notes)
        });
        return true;
    });
    const { apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const { shipCloudEditable: shipCloudEditable } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const t = app.getT("NoteView");
    const [cruise, trip, day] = (0, $16fdfdea6c651031$export$ceded59ee1e5da57)(parentType);
    // Read unconditionally (mirrors GetNoteParent's own rationale) so every note
    // rendered here shares this instance's single current/historical state, keyed off
    // whichever entity most specifically owns it (day's trip / trip / cruise) — matches
    // the server's `isCurrentNote` precedence (LogbookApi/NoteApi.swift).
    const dayIsCurrentTrip = (_a = (0, $97ac05743b787a86$export$95d65094202e15e7)()) === null || _a === void 0 ? void 0 : _a.isCurrentTrip;
    const [autoCreatingNote, setAutoCreatingNote] = (0, $acw62.useState)(0);
    const isCurrentTrip = (0, $acw62.useMemo)(()=>{
        switch(parentType){
            case (0, $d460697aab603bc5$export$5daa50148070bda5).day:
                return dayIsCurrentTrip !== null && dayIsCurrentTrip !== void 0 ? dayIsCurrentTrip : true;
            case (0, $d460697aab603bc5$export$5daa50148070bda5).trip:
                return (trip === null || trip === void 0 ? void 0 : trip.completedAt) == null;
            case (0, $d460697aab603bc5$export$5daa50148070bda5).cruise:
                return (cruise === null || cruise === void 0 ? void 0 : cruise.completedAt) == null;
            default:
                return true;
        }
    }, [
        parentType,
        dayIsCurrentTrip,
        trip,
        cruise
    ]);
    const formEditable = (0, $acw62.useMemo)(()=>shipCloudEditable || app.editable && (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).availableCurrentOrAll(apiUser, ship.id, isCurrentTrip), []);
    const noteParent = (0, $acw62.useMemo)(()=>(0, $16fdfdea6c651031$export$7c2353396e2a8670)(parentType, cruise, day, trip), [
        parentType,
        cruise,
        day,
        trip
    ]);
    const shipNotes = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Note, {
        shipId: ship.id
    });
    (0, $9690902269ab2924$export$e4edb3e6a3489a79)([
        (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Note,
        (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).NoteAttachment
    ], (noteParent === null || noteParent === void 0 ? void 0 : noteParent.id) !== undefined, noteParent === null || noteParent === void 0 ? void 0 : noteParent.id);
    // `NoteTabs` rebuilds the `notes` array on every render, and applying a bundle
    // notifies the store, which re-renders this view -- keying the re-seed on the rows'
    // content rather than on the array's identity stops that feeding back into itself.
    const seedRows = (0, $acw62.useMemo)(()=>(0, $5bd541aff0182fa0$export$e9bc97ba61bf8e52)(notes), [
        notes
    ]);
    const seedSignature = (0, $acw62.useMemo)(()=>JSON.stringify(seedRows), [
        seedRows
    ]);
    const seedRowsRef = (0, $acw62.useRef)(seedRows);
    seedRowsRef.current = seedRows;
    (0, $acw62.useEffect)(()=>{
        store.applyBundle({
            entities: seedRowsRef.current
        });
    }, [
        seedSignature,
        store
    ]);
    const seededNoteIds = (0, $acw62.useMemo)(()=>new Set(notes.map((note)=>note.id)), [
        notes
    ]);
    const storedFoldNotes = shipNotes.filter((note)=>{
        if (seededNoteIds.has(note.id)) return true;
        if ((noteParent === null || noteParent === void 0 ? void 0 : noteParent.id) === undefined) return false;
        switch(parentType){
            case (0, $d460697aab603bc5$export$5daa50148070bda5).cruise:
                return note.cruiseId === noteParent.id && note.tripId == undefined && note.dayId == undefined;
            case (0, $d460697aab603bc5$export$5daa50148070bda5).trip:
                return note.tripId === noteParent.id && note.dayId == undefined;
            case (0, $d460697aab603bc5$export$5daa50148070bda5).day:
                return note.dayId === noteParent.id;
        }
    });
    const canonicalNotes = storedFoldNotes.length > 0 || notes.length === 0 ? storedFoldNotes : notes;
    // #1137: a blank/backfilled day (`!noteParent.id`) has no Day row yet, so it can
    // never have any notes of its own -- render an uncreated draft instead of
    // eagerly auto-creating one (see the effect below and `NoteView`'s
    // `manualSave={!note}`). Only a day parent can ever be blank; trip/cruise notes
    // keep today's eager auto-create unchanged.
    const blank = !(noteParent === null || noteParent === void 0 ? void 0 : noteParent.id);
    const typedNotes = (0, $acw62.useMemo)(()=>canonicalNotes.filter((note)=>note.noteType === noteType), [
        canonicalNotes,
        noteType
    ]);
    const ownedNotes = (0, $acw62.useMemo)(()=>typedNotes.filter((n)=>(0, $16fdfdea6c651031$export$9efb223871c6e7f5)(parentType, n)), [
        typedNotes,
        parentType
    ]);
    const parentNotes = (0, $acw62.useMemo)(()=>typedNotes.filter((n)=>!(0, $16fdfdea6c651031$export$9efb223871c6e7f5)(parentType, n)), [
        typedNotes,
        parentType
    ]);
    const addNewNote = (0, $acw62.useCallback)(async ()=>{
        if (!noteParent) return undefined;
        const result = await writers.createNote(parentType, noteParent.id, {
            note: "",
            noteType: noteType,
            title: ""
        });
        if (result && result.note) return result.note;
        return undefined;
    }, [
        noteParent,
        noteType,
        parentType,
        writers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (blank) // #1137: creation is deferred to the user's explicit save on the draft
        // NoteView rendered below -- never fire just from opening this tab.
        return;
        if (ownedNotes.length < 1 && autoCreatingNote == 0 && (0, $16fdfdea6c651031$export$1e7f12a5f31edb19).indexOf(noteType) >= 0 && formEditable && noteParent) {
            const autoCreate = async ()=>{
                setAutoCreatingNote(1);
                const note = await addNewNote();
                if (note) {
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("created blank note", noteType, note);
                    setAutoCreatingNote(2);
                }
            };
            autoCreate();
        }
    }, [
        ownedNotes,
        autoCreatingNote,
        addNewNote,
        blank,
        formEditable,
        noteParent,
        noteType
    ]);
    if (autoCreatingNote == 1) return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "NotesView",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
    });
    if (blank) return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "NotesView",
        children: formEditable && (0, $7b02d682eb115277$exports.jsx)((0, $848e949c1e6be720$export$cc2739341428a8da), {
            editable: true,
            isCurrentTrip: isCurrentTrip,
            note: undefined,
            noteType: noteType,
            parentType: parentType
        })
    });
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "NotesView",
        children: [
            ownedNotes.map((note)=>(0, $7b02d682eb115277$exports.jsx)((0, $848e949c1e6be720$export$cc2739341428a8da), {
                    editable: true,
                    isCurrentTrip: isCurrentTrip,
                    note: note,
                    noteType: noteType,
                    parentType: parentType
                }, note.id)),
            formEditable && (0, $16fdfdea6c651031$export$253d5d448b372de).indexOf(noteType) < 0 && (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "button",
                onClick: addNewNote,
                children: t("note_add_new")
            }),
            parentNotes.length > 0 && (0, $7b02d682eb115277$exports.jsxs)("details", {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("summary", {
                        children: t("show_notes", {
                            count: parentNotes.length,
                            type: parentType == (0, $d460697aab603bc5$export$5daa50148070bda5).trip ? t("note_parent_type_day") : ""
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                    parentNotes.map((note)=>(0, $7b02d682eb115277$exports.jsx)((0, $848e949c1e6be720$export$cc2739341428a8da), {
                            editable: false,
                            isCurrentTrip: isCurrentTrip,
                            note: note,
                            noteType: noteType,
                            parentType: parentType
                        }, note.id))
                ]
            })
        ]
    });
}












function $ce2c1ce802275219$export$3351327ea8a3ed8({ advices: advices, currentLog: currentLog, currentLogView: currentLogView, day: day, dayChildren: dayChildren, focus: focus, hideTimeline: hideTimeline, initLogTabs: initLogTabs, initTab: initTab, isCurrentDay: isCurrentDay, isTomorrow: isTomorrow, isYesterday: isYesterday, isFirstTripDay: isFirstTripDay, previousDay: previousDay }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const shipView = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const [ship, cruise, trip] = [
        (0, $97ac05743b787a86$export$f581995c9f2db6f0)(),
        (0, $97ac05743b787a86$export$135b8b9ecdd62154)().cruise,
        (0, $97ac05743b787a86$export$e205ea882cbd693e)()
    ];
    const { apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const t = app.getT("DayView");
    const tabBarRef = (0, $8a8193ceb042f538$export$ba657787b573294a)();
    const isCurrentTrip = trip.trip.completedAt == null;
    const focusEditable = focus && (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).availableCurrentOrAll(apiUser, ship.id, isCurrentTrip);
    const calculated = day.calculated;
    const { logs: logs, statuses: statuses, tracks: tracks, anchorCircles: anchorCircles, auditLogEdits: auditLogEdits, timelineLogs: timelineLogs, recordAuditLogEdits: recordAuditLogEdits, savedDay: savedDay, recordSavedDay: recordSavedDay, details: details, setDetails: setDetails, selected: selected, toggleSelected: toggleSelected, highlight: highlight, clearHighlight: clearHighlight, selectedCallback: selectedCallback, writers: writers } = (0, $4f881e66fa9c872b$export$16e4b49792d5576d)();
    const renderedDay = (0, $59aa08b9185fbe21$export$ff67a10d74459a57)(day, savedDay);
    const showDetail = (0, $acw62.useMemo)(()=>{
        return (0, $600b78128ceeb0f6$export$6ac9c96d08ad2ff5).showDetail(details, isCurrentDay || false, isTomorrow || false, selected, !day.id);
    }, [
        details,
        isCurrentDay,
        isTomorrow,
        selected,
        day.id
    ]);
    const showTimeline = (0, $acw62.useMemo)(()=>{
        return (0, $600b78128ceeb0f6$export$6ac9c96d08ad2ff5).showTimeline(showDetail, isCurrentDay || false, hideTimeline || false, !day.id);
    }, [
        showDetail,
        hideTimeline,
        isCurrentDay,
        day.id
    ]);
    const date = (0, $600b78128ceeb0f6$export$98e9a0bb257361e9)(day.day);
    const dayContext = Object.assign({
        day: renderedDay,
        focus: focus || false,
        isCurrentTrip: isCurrentTrip,
        logs: logs || [],
        statuses: statuses || [],
        tracks: tracks || [],
        auditLogEdits: auditLogEdits,
        recordAuditLogEdits: recordAuditLogEdits,
        recordSavedDay: recordSavedDay
    }, writers);
    return (0, $7b02d682eb115277$exports.jsx)((0, $97ac05743b787a86$export$a09925a4bc6c3c0c).Provider, {
        value: dayContext,
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                "DayView",
                selected ? "selected" : "not-selected",
                !day.id && !selected && "blank",
                details && "details",
                isCurrentDay && "current",
                isTomorrow && "tomorrow",
                (0, $600b78128ceeb0f6$export$6ac9c96d08ad2ff5).isWeekend(date) && "highlight-weekend",
                (0, $600b78128ceeb0f6$export$6ac9c96d08ad2ff5).monthHighlight(date) && "highlight-month"
            ]),
            "data-day-id": day.id,
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $6ea8ac9cb3fdf9c8$export$a4a65d0c2bc34e7f), {
                    advices: advices,
                    currentLog: currentLog,
                    details: details,
                    isCurrentDay: isCurrentDay || false,
                    isTomorrow: isTomorrow || false,
                    isYesterday: isYesterday || false,
                    logs: timelineLogs,
                    selected: selected,
                    setDetails: setDetails,
                    previousDay: previousDay,
                    toggleSelected: toggleSelected
                }),
                selected && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        showDetail && (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "DayView-content",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $9f9e7bca499fb8dc$export$f97dc4a5a0177256), {
                                defaultSelection: initTab || "day",
                                callbacks: tabBarRef,
                                tabs: [
                                    {
                                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Day,
                                        name: "day",
                                        title: t("tab_day"),
                                        render: ()=>{
                                            return (0, $7b02d682eb115277$exports.jsx)((0, $a95e9f26ea4eb186$export$8fd21e5060e97e29), {
                                                day: renderedDay,
                                                editable: focusEditable,
                                                isCurrentDay: isCurrentDay,
                                                isFirstTripDay: isFirstTripDay,
                                                isTomorrow: isTomorrow,
                                                previousDay: previousDay
                                            });
                                        }
                                    },
                                    {
                                        hide: !day.id || isTomorrow || !calculated,
                                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Stats,
                                        name: "stats",
                                        title: t("tab_stats"),
                                        render: ()=>{
                                            return (0, $7b02d682eb115277$exports.jsx)((0, $198e3b0852fb0b06$export$1e3e8ecfe0e6273a), {
                                                day: day,
                                                calculate: writers.calculateDay
                                            });
                                        }
                                    },
                                    {
                                        hide: !day.id || isTomorrow,
                                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Track,
                                        name: "track",
                                        title: t("tab_track"),
                                        render: ()=>{
                                            return (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "DayView-track",
                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $7e01767afef66f8e$export$600f95652e45663), {
                                                    fullscreen: false,
                                                    tracks: tracks,
                                                    anchorCircles: anchorCircles,
                                                    timezone: day.timezone
                                                })
                                            });
                                        }
                                    },
                                    {
                                        hide: !day.id || isTomorrow || !calculated || !calculated.weatherTimeseries,
                                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Graph,
                                        name: "weather",
                                        title: t("tab_weather"),
                                        render: ()=>{
                                            return (0, $7b02d682eb115277$exports.jsx)((0, $da41652818610294$export$6a7fe3ef90e8d566), {
                                                timeseries: calculated === null || calculated === void 0 ? void 0 : calculated.weatherTimeseries
                                            });
                                        }
                                    },
                                    ...(0, $59a722b1b33d4469$export$2a7d663d787aca05)(app, (0, $d460697aab603bc5$export$5daa50148070bda5).day, day.notes || []),
                                    {
                                        hide: !day.id,
                                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Watch,
                                        name: "watch",
                                        title: t("tab_watches"),
                                        render: ()=>{
                                            return (0, $7b02d682eb115277$exports.jsx)((0, $2ece6f66deb87000$export$299a5829ffa20395), {
                                                day: day
                                            });
                                        }
                                    },
                                    {
                                        hide: !day.id || isTomorrow,
                                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Print,
                                        name: "print",
                                        title: t("tab_print"),
                                        render: ()=>{
                                            return (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "TripView-print-tab",
                                                children: [
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                        className: "block-row-button-print",
                                                        children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            className: "button",
                                                            onClick: ()=>{
                                                                shipView.setPrinting((0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).days, cruise, trip.trip.id);
                                                            },
                                                            children: [
                                                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Print,
                                                                    className: "icon-large"
                                                                }),
                                                                " ",
                                                                t("print_days")
                                                            ]
                                                        })
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                        className: "block-row-button-print",
                                                        children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                            className: "button",
                                                            onClick: ()=>{
                                                                shipView.setPrinting((0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).days, cruise, trip.trip.id, day.id);
                                                            },
                                                            children: [
                                                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Print,
                                                                    className: "icon-large"
                                                                }),
                                                                " ",
                                                                t("print_day")
                                                            ]
                                                        })
                                                    })
                                                ]
                                            });
                                        }
                                    }
                                ],
                                selectedCallback: selectedCallback
                            })
                        }),
                        dayChildren,
                        showTimeline && (0, $7b02d682eb115277$exports.jsx)((0, $0487b6f1efece6f9$export$65f601bc28eb0ddd), {
                            clearHighlight: clearHighlight,
                            currentLog: currentLog,
                            currentLogView: currentLogView,
                            highlight: highlight,
                            isCurrentDay: isCurrentDay,
                            isTomorrow: isTomorrow,
                            logTabs: initLogTabs,
                            logs: timelineLogs,
                            statuses: statuses || []
                        })
                    ]
                })
            ]
        })
    });
}


var $d2dee9b5e2805e91$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// `DayDataView` is the `useDeps`/store data-acquisition layer: it builds the
// `DayDataViewData` and provides it via `DayDataContext`, so the presentational
// `DayViewUI` never touches acquisition.
const $d2dee9b5e2805e91$var$DayDataViewWithUI = (0, $480db5fef2358c2d$export$ae24a3dd6105e285)({
    acquire: (0, $b7a41c77d4ceff2b$export$feddd27a55de72d6),
    ui: (0, $ce2c1ce802275219$export$3351327ea8a3ed8)
});
function $d2dee9b5e2805e91$export$c1379d67dc104c23(_a) {
    var { children: children } = _a, props = $d2dee9b5e2805e91$var$__rest(_a, [
        "children"
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($d2dee9b5e2805e91$var$DayDataViewWithUI, Object.assign({}, props, {
        dayChildren: children
    }));
}






function $7d963101ed190d21$export$e7429c1b993a4901({ day: day }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const date = (0, $600b78128ceeb0f6$export$98e9a0bb257361e9)(day.day);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "DayView",
            "blank",
            (0, $600b78128ceeb0f6$export$6ac9c96d08ad2ff5).isWeekend(date) && "highlight-weekend",
            (0, $600b78128ceeb0f6$export$6ac9c96d08ad2ff5).monthHighlight(date) && "highlight-month"
        ]),
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "DayHeaderView",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "DayView-date",
                    children: app.format("dateInYear", date.toISOString())
                }),
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "DayView-timeline",
                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "hour hour-12"
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "DayView-cell DayView-comment"
                }),
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "DayView-cell DayView-duration"
                }),
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "DayView-cell DayView-speed"
                }),
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "DayView-cell DayView-distance"
                }),
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "DayView-gap"
                })
            ]
        })
    });
}











var $acw62 = parcelRequire("acw62");









function $9feae3de10db5a39$export$2dc9ce7228c96e69({ status: status, statuses: statuses, log: log, day: day, logs: logs, auditLogEdits: auditLogEdits }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const [ship] = [
        (0, $97ac05743b787a86$export$f581995c9f2db6f0)()
    ];
    const ft = app.getT("LogNavigationView");
    const trip = (_a = (0, $97ac05743b787a86$export$e205ea882cbd693e)()) === null || _a === void 0 ? void 0 : _a.trip;
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    const engineStatuses = (0, $acw62.useMemo)(()=>{
        return (statuses || []).filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).engine);
    }, [
        statuses
    ]);
    const engines = (0, $acw62.useMemo)(()=>{
        const engineInfo = [];
        const thresholds = (0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship).thresholds;
        for (const e of (0, $22871482fce5b7e5$export$7930c61d9b464618).engines(ship)){
            if (!e.number && !e.nmeaNumber) continue;
            const n = e.nmeaNumber || e.number || -1;
            const engineStatus = (0, $234930b26df9c152$export$738727f375798cb)(engineStatuses, log.id, e.id);
            const on = (0, $234930b26df9c152$export$591cee21f508cff)(log.engineRpms, n, engineStatus, thresholds);
            engineInfo.push({
                id: e.id,
                number: e.number,
                nmeaNumber: e.nmeaNumber || e.number,
                name: e.engineShortName,
                on: on,
                idle: on && (0, $234930b26df9c152$export$479f26c6e67c2e2f)(log.engineRpms, n, engineStatus, thresholds)
            });
        }
        return engineInfo;
    }, [
        engineStatuses,
        ship,
        log
    ]);
    const sailStatuses = (0, $acw62.useMemo)(()=>{
        return (0, $234930b26df9c152$export$93a873645497d52c)((statuses || []).filter((s)=>s.statusType === (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).sails), log.id);
    }, [
        statuses,
        log.id
    ]);
    const hasSails = sailStatuses.length > 0;
    const context = {
        app: app,
        ship: ship,
        trip: trip,
        shipUsers: shipUsers,
        logs: logs,
        day: day,
        auditLogEdits: auditLogEdits
    };
    // Lighting entries need their generated description even in the compact layout.
    const comment = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed.type == (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).lighting ? (0, $8f49adaa708c152b$export$94719616ea7cbe20)(log, statuses || [], context) : (0, $8f49adaa708c152b$export$86c72d2eb1b98969)(log, statuses || [], context);
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: "PrintLogListView",
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
            className: "print-log-list-row",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: ft("status"),
                    className: "block-field-90 print-text-bold",
                    children: (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: status && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                    icon: `status-${(0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[status.value]}`
                                }),
                                " ",
                                ft("status_" + (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[status.value])
                            ]
                        })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: ft("time"),
                    className: "block-field-45 print-text-bold",
                    children: app.format("time", log.time)
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: ft("comment"),
                    className: "block-field-300",
                    children: comment
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: ft("sails") + "|" + ft("engine"),
                    className: "block-field-75 text-centered",
                    children: [
                        (0, $22871482fce5b7e5$export$7930c61d9b464618).isSailingVessel(ship) && hasSails && (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).SailingVesselLarge
                                }),
                                " "
                            ]
                        }),
                        engines.map((engine, i)=>{
                            return (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                        icon: !engine.on ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleLarge : engine.idle ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleHalfLarge : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleFilledLarge,
                                        className: "engine-icons"
                                    }),
                                    i < ship.engineCount - 1
                                ]
                            }, i);
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: ft("course"),
                    className: "block-field-60",
                    children: app.format("course", log.course)
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: ft("sog"),
                    className: "block-field-60",
                    children: app.format("speed", log.sog)
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: ft("distance"),
                    className: "block-field-75",
                    children: app.format("distance", log.distance)
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");














function $ea83b69ded1fb637$export$434dd18781be2b60({ status: status, statuses: statuses = [], log: log, logs: logs, day: day, auditLogEdits: auditLogEdits }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const [ship] = [
        (0, $97ac05743b787a86$export$f581995c9f2db6f0)()
    ];
    const trip = (_a = (0, $97ac05743b787a86$export$e205ea882cbd693e)()) === null || _a === void 0 ? void 0 : _a.trip;
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    const printContext = (0, $872aa31e93f7b7c8$export$f3bba5f1f646e703)();
    const includeEdits = (_b = printContext === null || printContext === void 0 ? void 0 : printContext.includeEdits) !== null && _b !== void 0 ? _b : false;
    const ft = app.getT("LogNavigationView");
    const fe = app.getT("LogEnvironmentView");
    const fw = app.getT("LogWatchView");
    const statusData = (0, $acw62.useMemo)(()=>{
        return (0, $2b4c51d286f985e1$export$391f39dba41666e2).statusData(status);
    }, [
        status
    ]);
    const engineStatuses = (0, $acw62.useMemo)(()=>{
        return (0, $2b4c51d286f985e1$export$391f39dba41666e2).engineStatuses(statuses);
    }, [
        statuses
    ]);
    const engines = (0, $acw62.useMemo)(()=>{
        return (0, $2b4c51d286f985e1$export$391f39dba41666e2).engines(ship, log, engineStatuses);
    }, [
        engineStatuses,
        ship,
        log
    ]);
    const courseToWind = (0, $acw62.useMemo)(()=>{
        return (0, $2b4c51d286f985e1$export$391f39dba41666e2).courseToWind(log.heading, log.windDirection);
    }, [
        log.heading,
        log.windDirection
    ]);
    const courseToWindText = (0, $acw62.useMemo)(()=>{
        if (!courseToWind) return "";
        return [
            app.format("angle", courseToWind.angle),
            ft(`point_of_sail_${courseToWind.pointOfSail}`),
            courseToWind.side ? ft(`wind_side_${courseToWind.side}`) : undefined
        ].filter(Boolean).join(" | ");
    }, [
        courseToWind
    ]);
    const comment = (0, $acw62.useMemo)(()=>{
        return (0, $8f49adaa708c152b$export$94719616ea7cbe20)(log, statuses, {
            app: app,
            ship: ship,
            trip: trip,
            shipUsers: shipUsers,
            logs: logs,
            day: day,
            auditLogEdits: auditLogEdits
        });
    }, [
        log,
        statuses,
        app,
        ship,
        trip,
        shipUsers,
        logs,
        day,
        auditLogEdits
    ]);
    const editHistory = (0, $acw62.useMemo)(()=>{
        if (!includeEdits || !auditLogEdits) return [];
        return (0, $59aa08b9185fbe21$export$a93b69c9d9000d40)(auditLogEdits.filter((edit)=>edit.logId == log.id), (field)=>(0, $ef5054b4bf6e9c66$export$b9dc914bb7557ea1)(log, field));
    }, [
        includeEdits,
        auditLogEdits,
        log
    ]);
    const editHistoryFieldFormat = (0, $acw62.useMemo)(()=>(0, $ef5054b4bf6e9c66$export$d8c7abcae1e88b5b).fieldFormat(app), [
        app
    ]);
    const editHistoryFieldLabel = (0, $acw62.useMemo)(()=>(0, $ef5054b4bf6e9c66$export$d8c7abcae1e88b5b).fieldLabel(app), [
        app
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const _seaState = (_e = (_d = (_c = log.seaState) !== null && _c !== void 0 ? _c : log.seastate) !== null && _d !== void 0 ? _d : log.sea_state) !== null && _e !== void 0 ? _e : "";
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const weather = (_h = (_g = (_f = log.weather) !== null && _f !== void 0 ? _f : log.weather_state) !== null && _g !== void 0 ? _g : log.weatherState) !== null && _h !== void 0 ? _h : "";
    const sailStatuses = (0, $acw62.useMemo)(()=>{
        return (0, $234930b26df9c152$export$93a873645497d52c)((statuses || []).filter((s)=>s.statusType === (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).sails), log.id);
    }, [
        statuses,
        log.id
    ]);
    const sailName = (0, $acw62.useCallback)((id, reef, sails)=>{
        return (0, $2b4c51d286f985e1$export$391f39dba41666e2).sailName(app, id, reef, sails);
    }, [
        app
    ]);
    // Derive sail status values from statuses
    const sailStatusValues = (0, $acw62.useMemo)(()=>{
        if (sailStatuses.length === 0) return "";
        const sails = (0, $22871482fce5b7e5$export$7930c61d9b464618).sails(ship);
        return sailStatuses.map((status)=>{
            if (!status.name) return "";
            return sailName(status.name, status.value, sails);
        }).filter(Boolean).join(", ");
    }, [
        sailStatuses,
        ship,
        sailName,
        app
    ]);
    function rpmValue(n) {
        if (!log.engineRpms || log.engineRpms[n] == undefined || log.engineRpms[n] <= 1) return "";
        return log.engineRpms[n].toFixed(0);
    }
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
        className: "PrintLogView",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "LogView-navigation",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("status"),
                                className: "block-field-120 print-text-bold",
                                children: status && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: `status-${(0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[status.value]}`
                                        }),
                                        " ",
                                        ft("status_" + (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[status.value])
                                    ]
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("time"),
                                className: "block-field-45 print-text-bold",
                                children: app.format("time", log.time)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("time_utc"),
                                className: "block-field-45",
                                children: app.format("timeUtc", log.timeUtc)
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("position"),
                                className: "block-field-180",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "print-multi-fields",
                                        children: app.format("gps-lat", log.lat)
                                    }),
                                    " ",
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                    " ",
                                    (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "print-multi-fields",
                                        children: app.format("gps-lng", log.lng)
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("course"),
                                className: "block-field-75",
                                children: app.format("course", log.course)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("heading"),
                                className: "block-field-90",
                                children: app.format("course", log.heading)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("sog"),
                                className: "block-field-75",
                                children: app.format("speed", log.sog)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("stw"),
                                className: "block-field-75",
                                children: app.format("speed", log.stw)
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("distance"),
                                className: "block-field-75",
                                children: app.format("distance", log.distance)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("log"),
                                className: "block-field-90",
                                children: app.format("distance", log.log)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("depth"),
                                className: "block-field-75",
                                children: app.format("meters", log.depth)
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: [
                            (0, $22871482fce5b7e5$export$7930c61d9b464618).isSailingVessel(ship) && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("sails"),
                                className: "block-field-240",
                                children: sailStatusValues
                            }),
                            (0, $22871482fce5b7e5$export$7930c61d9b464618).isSailingVessel(ship) && courseToWind && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: ft("course_to_wind"),
                                className: "course-to-wind block-field-165",
                                children: courseToWindText
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: [
                                    ...engines.map((engine)=>ft("engine_name", {
                                            name: engine.name || `#${engine.number || engine.nmeaNumber}`
                                        }))
                                ].join(" | "),
                                children: engines.map((engine, i)=>{
                                    const n = engine.nmeaNumber || -1;
                                    const rpm = rpmValue(n);
                                    return (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                icon: !engine.on ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleLarge : engine.idle ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleHalfLarge : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleFilledLarge
                                            }),
                                            " ",
                                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "print-multi-fields",
                                                children: rpm
                                            }),
                                            " ",
                                            i < ship.engineCount - 1 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {
                                                className: "print-divider-distance"
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("comment"),
                            className: "",
                            children: comment
                        })
                    }),
                    status && status.value != (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).inmotion && status.value != (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).drifting && status.startLogId == log.id && (statusData === null || statusData === void 0 ? void 0 : statusData.location) && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("location"),
                            children: statusData.location
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "LogView-environment",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: fe("wind_direction_speed"),
                                className: "block-field-150",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "print-multi-fields",
                                        children: [
                                            app.format("angle", log.windDirection),
                                            " "
                                        ]
                                    }),
                                    " ",
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                    " ",
                                    (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "print-multi-fields",
                                        children: app.format("speed", log.windSpeed)
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: fe("pressure"),
                                className: "block-field-120",
                                children: app.format("pressure", log.pressure)
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: fe("weather_temp_rel_humidity"),
                            className: "",
                            children: [
                                (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "print-multi-fields",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: "weather-" + weather
                                        }),
                                        "  ",
                                        fe("weather_" + weather)
                                    ]
                                }),
                                " ",
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                " ",
                                (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "print-multi-fields",
                                    children: [
                                        " ",
                                        app.format("temperature", log.temperature),
                                        " "
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                " ",
                                (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "print-multi-fields",
                                    children: [
                                        " ",
                                        app.format("percentage", log.humidity)
                                    ]
                                })
                            ]
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: fe("current_direction_speed"),
                                className: "block-field-150",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "print-multi-fields",
                                        children: log.currentDirection ? fe(`current_direction_${log.currentDirection}`) || log.currentDirection : ""
                                    }),
                                    " ",
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                    " ",
                                    (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "print-multi-fields",
                                        children: [
                                            " ",
                                            app.format("speed", log.currentSpeed)
                                        ]
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: fe("seastate"),
                                className: "",
                                children: log.seaState ? fe(`seastate_${log.seaState}`) || log.seaState : ""
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: fw("watch"),
                            children: log.watch
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: fw("watch_comment"),
                            children: log.watchComment
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "log-timestamps",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("created"),
                            children: log.createdAt
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "log-timestamps",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: ft("updated"),
                            children: log.updatedAt
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $b68062e8543a3005$export$fca036eb5668ed1d), {
                entries: editHistory,
                fieldLabel: editHistoryFieldLabel,
                fieldFormat: editHistoryFieldFormat,
                open: includeEdits
            })
        ]
    });
}









function $38d489c42abec98d$export$f02f2a6561f79acf({ cruise: _cruise, day: _day, note: note, trip: _trip }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const tc = app.getT("PrintView");
    const tn = app.getT("NoteView_note");
    // Reference the shared note-type -> field mapping so the "weather notes carry a
    // noteExtra field" rule lives once (Note/Context) instead of being re-hard-coded here.
    const contentFields = (0, $16fdfdea6c651031$export$8957b8252c394f55).noteContentFields(note.noteType);
    let noteContent;
    switch(note.noteType){
        case (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).weather:
            noteContent = (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "PrintWeatherView",
                        children: (0, $7b02d682eb115277$exports.jsxs)("h4", {
                            children: [
                                tc(`note_${(0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10)[note.noteType]}`),
                                ": ",
                                note.date,
                                " ",
                                note.title
                            ]
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "print-weather-note",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: tn("weather_note"),
                                className: "block-field-360",
                                children: note.note
                            }),
                            contentFields.hasNoteExtra && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: tn("weather_note_extra"),
                                className: "block-field-360",
                                children: note.noteExtra
                            })
                        ]
                    })
                ]
            });
            break;
        case (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).journal:
        case (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).technical:
            noteContent = (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("h4", {
                        children: [
                            " ",
                            tc(`note_${(0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10)[note.noteType]}`),
                            ": ",
                            note.date,
                            " ",
                            note.title
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "print-note-text ",
                        children: note.note
                    })
                ]
            });
    }
    const attachments = (note.attachments || []).map((a)=>{
        const key = `note-${note.id}-attachment-${a.id}`;
        const _label = (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: "attachment-label",
            children: [
                a.fileName,
                ".",
                a.fileType
            ]
        });
        const image = (0, $86850ed0d32dea3a$export$2c13e988217f85e9).isImage(a);
        const url = (0, $86850ed0d32dea3a$export$2c13e988217f85e9).attachmentUrl(app.apiClient, ship.id, note.id, a, app.cloudSession());
        return (0, $7b02d682eb115277$exports.jsx)("a", {
            href: url,
            className: "attachment",
            target: "_blank",
            rel: "noopener noreferrer",
            children: image && (0, $7b02d682eb115277$exports.jsx)("img", {
                src: url
            })
        }, key);
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: "PrintNoteView ",
        children: [
            noteContent,
            attachments
        ]
    });
}




var $acw62 = parcelRequire("acw62");



function $4c284c00a57ec46c$export$4ed37d7e0d922116({ group: group, index: _index }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    const t = app.getT("DayWatchView_groups");
    const peopleNames = (0, $acw62.useMemo)(()=>{
        if (!group.people || group.people.length === 0 || !shipUsers) return "";
        return group.people.map((id)=>{
            const user = shipUsers.find((u)=>u.id === id);
            return user ? user.name || "" : "";
        }).filter((name)=>name).join(", ");
    }, [
        group.people,
        shipUsers
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
        className: "print-day-watch-groups",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("name"),
                className: "block-field-120",
                children: group.name
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("people"),
                className: "",
                children: peopleNames
            })
        ]
    });
}





function $99f30eb03db22724$export$a9a27cceaa4265de({ shift: shift, index: _index }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("DayWatchView_shifts");
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
        className: "print-day-watch-shifts",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("hour"),
                className: "block-field-90",
                children: shift.start
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("duration"),
                className: "block-field-90",
                children: shift.duration
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("group"),
                className: "block-field-90",
                children: shift.group
            })
        ]
    });
}



// Live current value for a `DayEditableField`, used by `computeEditHistory` to
// resolve the "new value" of each field's most recent edit.
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
function $bb3d4c90fd993ed5$var$currentDayFieldValue(day, field) {
    switch(field){
        case "comment":
        case "crew":
        case "endLocation":
        case "passengers":
        case "skipper":
        case "startLocation":
            return day[field];
        default:
            return undefined;
    }
}
// Per-field value formatters for Day fields (issue #529).
function $bb3d4c90fd993ed5$var$dayFieldFormat(shipUsers) {
    const userLabel = (0, $14a8bda8b42de2c4$export$2f84fdd660581d7f)((value)=>typeof value === "number", (id)=>{
        const user = shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.find((u)=>u.id == id);
        return user ? (0, $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a).userLabel(user) : "\u2013";
    });
    const userList = (0, $14a8bda8b42de2c4$export$2f84fdd660581d7f)((value)=>Array.isArray(value), (ids)=>ids.length > 0 ? ids.map((id)=>userLabel(id)).join(", ") : "\u2013");
    return {
        crew: userList,
        passengers: userList,
        skipper: userLabel
    };
}
function $bb3d4c90fd993ed5$export$f167fc1836a7e73e({ day: day, excludeDetailed: _excludeDetailed }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const context = (0, $872aa31e93f7b7c8$export$f3bba5f1f646e703)();
    const data = (0, $872aa31e93f7b7c8$export$ea13d8db95f96086)();
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    const date = (0, $600b78128ceeb0f6$export$98e9a0bb257361e9)(day.day);
    const t = app.getT("DayEditView");
    const tc = app.getT("PrintView");
    const dayStatuses = (0, $acw62.useMemo)(()=>{
        var _a, _b;
        return (_b = (_a = data === null || data === void 0 ? void 0 : data.statuses) === null || _a === void 0 ? void 0 : _a.filter((s)=>s.shipId === day.shipId && s.dayId === day.id && s.deletedAt == undefined)) !== null && _b !== void 0 ? _b : [];
    }, [
        data === null || data === void 0 ? void 0 : data.statuses,
        day.shipId,
        day.id
    ]);
    const shipStatuses = (0, $acw62.useMemo)(()=>{
        return dayStatuses.filter((s)=>s.statusType == (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship);
    }, [
        dayStatuses
    ]);
    const getUserName = (0, $acw62.useCallback)((userId)=>{
        if (!userId || !shipUsers) return "";
        const user = shipUsers.find((u)=>u.id === userId);
        return user ? `${user.name || ""}` : "";
    }, [
        shipUsers
    ]);
    const getCrewNames = (0, $acw62.useCallback)((crewIds)=>{
        if (!crewIds || crewIds.length === 0 || !shipUsers) return "";
        return crewIds.map((id)=>{
            const user = shipUsers.find((u)=>u.id === id);
            return user ? `${user.name || ""}` : "";
        }).filter((name)=>name).join(", ");
    }, [
        shipUsers
    ]);
    const statusButton = (0, $acw62.useCallback)((status)=>{
        const statusName = (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[status];
        if (status == (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none) return app.t(`LogNavigationView_status_${statusName}`);
        return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                    icon: `status-${statusName}`
                }),
                " ",
                app.t(`LogNavigationView_status_${statusName}`)
            ]
        });
    }, [
        app
    ]);
    const { dayStatus: dayStatus, overnightStatus: overnightStatus } = (0, $acw62.useMemo)(()=>{
        return (0, $234930b26df9c152$export$be23039be03416bb)(day, data === null || data === void 0 ? void 0 : data.statuses, data === null || data === void 0 ? void 0 : data.logs);
    }, [
        day,
        data === null || data === void 0 ? void 0 : data.statuses,
        data === null || data === void 0 ? void 0 : data.logs
    ]);
    const tracks = (0, $acw62.useMemo)(()=>{
        if (!data) return [];
        return data.tracks.filter((track)=>track.dayId == day.id);
    }, [
        data,
        day.id
    ]);
    const weatherNotes = (0, $acw62.useMemo)(()=>{
        return (day.notes || []).filter((note)=>note.dayId == day.id && note.noteType === (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).weather && (note.note || note.noteExtra || note.title || note.date)).map((note)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $38d489c42abec98d$export$f02f2a6561f79acf), {
                day: day,
                note: note
            }, note.id);
        });
    }, [
        day
    ]);
    const journalNotes = (0, $acw62.useMemo)(()=>{
        return (day.notes || []).filter((note)=>note.dayId == day.id && note.noteType === (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).journal && (note.title || note.note)).map((note)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $38d489c42abec98d$export$f02f2a6561f79acf), {
                day: day,
                note: note
            }, note.id);
        });
    }, [
        day
    ]);
    const technicalNotes = (0, $acw62.useMemo)(()=>{
        return (day.notes || []).filter((note)=>note.dayId == day.id && note.noteType === (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).technical && (note.title || note.note)).map((note)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $38d489c42abec98d$export$f02f2a6561f79acf), {
                day: day,
                note: note
            }, note.id);
        });
    }, [
        day
    ]);
    const watchGroups = (0, $acw62.useMemo)(()=>{
        const data = (0, $50f4daf09d2513a4$export$7a9a31a911eb9a20).parse(day).dataParsed;
        if (!data.watch || !data.watch.groups) return [];
        return data.watch.groups.map((group, index)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $4c284c00a57ec46c$export$4ed37d7e0d922116), {
                group: group,
                index: index
            }, group.id);
        });
    }, [
        day
    ]);
    const watchShifts = (0, $acw62.useMemo)(()=>{
        const data = (0, $50f4daf09d2513a4$export$7a9a31a911eb9a20).parse(day).dataParsed;
        if (!data.watch || !data.watch.shifts) return [];
        return data.watch.shifts.map((shift, index)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $99f30eb03db22724$export$a9a27cceaa4265de), {
                shift: shift,
                index: index
            }, shift.start);
        });
    }, [
        day
    ]);
    const logs = (0, $acw62.useMemo)(()=>{
        if (!data) return [];
        return data.logs.filter((log)=>log.dayId == day.id).map((log)=>{
            const status = (0, $234930b26df9c152$export$2baff4ea56c462f4)(shipStatuses, log.id);
            return (0, $7b02d682eb115277$exports.jsx)((0, $ea83b69ded1fb637$export$434dd18781be2b60), {
                log: log,
                logs: data.logs,
                day: day,
                status: status,
                statuses: dayStatuses,
                auditLogEdits: data.auditLogEdits
            }, log.id);
        });
    }, [
        data,
        day.id,
        shipStatuses,
        dayStatuses
    ]);
    const logsLists = (0, $acw62.useMemo)(()=>{
        if (!data) return [];
        return data.logs.filter((log)=>log.dayId == day.id).map((log)=>{
            const status = (0, $234930b26df9c152$export$2baff4ea56c462f4)(shipStatuses, log.id);
            return (0, $7b02d682eb115277$exports.jsx)((0, $9feae3de10db5a39$export$2dc9ce7228c96e69), {
                log: log,
                day: day,
                status: status,
                statuses: dayStatuses,
                logs: data.logs,
                auditLogEdits: data.auditLogEdits
            }, log.id);
        });
    }, [
        data,
        day.id,
        shipStatuses,
        dayStatuses
    ]);
    const includeEdits = (_a = context === null || context === void 0 ? void 0 : context.includeEdits) !== null && _a !== void 0 ? _a : false;
    const dayAuditLogEdits = (0, $acw62.useMemo)(()=>{
        var _a, _b;
        return (_b = (_a = data === null || data === void 0 ? void 0 : data.auditLogEdits) === null || _a === void 0 ? void 0 : _a.filter((e)=>e.sourceType == (0, $1e7307a9deb5d870$export$6322af8f4e594d6e).day && e.sourceId == day.id)) !== null && _b !== void 0 ? _b : [];
    }, [
        data === null || data === void 0 ? void 0 : data.auditLogEdits,
        day.id
    ]);
    const dayEditHistory = (0, $acw62.useMemo)(()=>{
        if (!includeEdits || dayAuditLogEdits.length === 0) return [];
        return (0, $59aa08b9185fbe21$export$a93b69c9d9000d40)(dayAuditLogEdits, (field)=>$bb3d4c90fd993ed5$var$currentDayFieldValue(day, field));
    }, [
        includeEdits,
        dayAuditLogEdits,
        day
    ]);
    const dayEditHistoryFieldFormat = (0, $acw62.useMemo)(()=>$bb3d4c90fd993ed5$var$dayFieldFormat(shipUsers), [
        shipUsers
    ]);
    const dayFieldLabels = {
        comment: t("comment"),
        crew: t("crew"),
        endLocation: t("end_location"),
        passengers: t("passengers"),
        skipper: t("skipper"),
        startLocation: t("start_location")
    };
    const dayFieldLabel = (field)=>{
        var _a;
        return (_a = dayFieldLabels[field]) !== null && _a !== void 0 ? _a : field;
    };
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PrintDayView container-boxed-inner",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: app.format("date", date.toISOString())
            }),
            (0, $7b02d682eb115277$exports.jsxs)("h4", {
                className: "print-text-normal-space-bottom",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "print-text-normal ",
                        children: tc("from_loc")
                    }),
                    " ",
                    day.startLocation,
                    (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "print-text-normal print-distance-left",
                        children: tc("to_loc")
                    }),
                    " ",
                    day.endLocation,
                    (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "print-text-normal",
                        children: t("timezone")
                    }),
                    " ",
                    app.format("timezone", day.timezone),
                    (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "print-distance-left",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {})
                    }),
                    dayStatus !== (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none && (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "print-text-normal print-distance-left",
                        children: [
                            t("status_day"),
                            " : "
                        ]
                    }),
                    dayStatus !== (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none && (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "",
                        children: statusButton(dayStatus)
                    }),
                    overnightStatus !== (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none && (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "print-text-normal print-distance-left",
                        children: [
                            t("status_overnight"),
                            " : "
                        ]
                    }),
                    overnightStatus !== (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).none && (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "",
                        children: statusButton(overnightStatus)
                    })
                ]
            }),
            (context === null || context === void 0 ? void 0 : context.includeDayTrack) && (0, $24d0c87b6223a295$export$1e0f7ae80feb6b6).hasPositions(tracks) && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "PrintDayView-track",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $7e01767afef66f8e$export$600f95652e45663), {
                    fullscreen: false,
                    noInteraction: true,
                    tracks: tracks,
                    timezone: day.timezone
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "PrintDayView-maindata container-boxed-inner",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("h4", {
                        children: tc("day_maindata")
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "PrintDaysDataView ",
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("skipper"),
                                        className: "block-field-210",
                                        children: getUserName(day.skipper)
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("crew"),
                                        className: "block-field-390",
                                        children: getCrewNames(day.crew)
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("passengers"),
                                        className: "",
                                        children: getCrewNames(day.passengers)
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("comment"),
                                    children: day.comment
                                })
                            }),
                            includeEdits && dayEditHistory.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $b68062e8543a3005$export$fca036eb5668ed1d), {
                                    entries: dayEditHistory,
                                    fieldLabel: dayFieldLabel,
                                    fieldFormat: dayEditHistoryFieldFormat,
                                    open: true
                                })
                            })
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "PrintDayView-statistics container-boxed-inner",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("h4", {
                        children: tc("day_statistics")
                    }),
                    day.calculated && (0, $7b02d682eb115277$exports.jsx)((0, $2ad184317a4db22e$export$9089c227cea0b0ec), {
                        calculated: day.calculated
                    })
                ]
            }),
            (context === null || context === void 0 ? void 0 : context.includeDayForecast) && weatherNotes.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "PrintNoteView-day PrintNoteView-weather container-boxed-inner",
                children: weatherNotes
            }),
            (context === null || context === void 0 ? void 0 : context.includeDayJournal) && journalNotes.length > 0 && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "PrintNoteView-day PrintNoteView-journal container-boxed-inner",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("h4", {
                        children: tc("note_journal")
                    }),
                    journalNotes
                ]
            }),
            (context === null || context === void 0 ? void 0 : context.includeDayTechnical) && technicalNotes.length > 0 && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "PrintNoteView-day PrintNoteView-technical container-boxed-inner",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("h4", {
                        children: tc("note_technical")
                    }),
                    technicalNotes
                ]
            }),
            (context === null || context === void 0 ? void 0 : context.includeDayWatchplan) && watchGroups.length > 0 && (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "container-boxed-inner",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "PrintWatchGroupView ",
                        children: watchGroups.length > 0 && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    children: tc("watch_groups")
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                    className: "print-watch-groups-block",
                                    children: watchGroups
                                })
                            ]
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "PrintWatchShiftView",
                        children: watchShifts.length > 0 && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    children: tc("watch_shifts")
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                    className: "print-watch-shifts-block",
                                    children: watchShifts
                                })
                            ]
                        })
                    })
                ]
            }),
            (context === null || context === void 0 ? void 0 : context.includeLogs) && (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    (context === null || context === void 0 ? void 0 : context.includeDayLogListType) == (0, $872aa31e93f7b7c8$export$512aa893c9e7d615).short && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "PrintLogListView-block container-boxed-inner",
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                children: [
                                    tc("log_entries"),
                                    " ",
                                    app.format("date", date.toISOString())
                                ]
                            }),
                            logsLists
                        ]
                    }),
                    (context === null || context === void 0 ? void 0 : context.includeDayLogListType) == (0, $872aa31e93f7b7c8$export$512aa893c9e7d615).details && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "PrintLogView-block container-boxed-inner",
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                children: [
                                    tc("log_entries"),
                                    " ",
                                    app.format("date", date.toISOString())
                                ]
                            }),
                            logs
                        ]
                    })
                ]
            })
        ]
    });
}












var $acw62 = parcelRequire("acw62");





const { Context: $304d95e33ca15961$export$bbbfe1497a5e65d9, useData: $304d95e33ca15961$export$f49a6ec715d07476 } = (0, $480db5fef2358c2d$export$1f628e93c0b28291)("TripDataView");




function $aaf6f2d98ee5cd02$export$375e2eb58a2d7c49(store, ids) {
    return {
        updateTrip: (values)=>{
            const current = store.getEntity("Trip", ids.tripId);
            const optimistic = current ? Object.assign(Object.assign({}, current), values) : undefined;
            return store.mutate({
                optimistic: optimistic ? {
                    upsert: {
                        Trip: [
                            optimistic
                        ]
                    }
                } : undefined,
                request: (client)=>new (0, $84aa1a3b4df5a78b$export$5e13e029a186945f)(client).trips.update({
                        params: ids,
                        body: values
                    }).call(),
                reconcile: (response)=>{
                    const latest = store.getEntity("Trip", ids.tripId);
                    return {
                        entities: {
                            Trip: optimistic && latest !== optimistic ? [] : [
                                (0, $faf562ea0f6b43ea$export$80b0ae8a211cdcb4)(response, latest)
                            ]
                        }
                    };
                }
            });
        },
        calculateTrip: ()=>store.mutate({
                request: (client)=>new (0, $84aa1a3b4df5a78b$export$5e13e029a186945f)(client).trips.calculate({
                        params: ids
                    }).call()
            })
    };
}
const $aaf6f2d98ee5cd02$var$rejectNoop = (name)=>()=>Promise.reject(new Error(`noopTripWriters.${name}: no writer provided (read-only Trip context)`));
const $aaf6f2d98ee5cd02$export$e1c5e1635d551ac1 = {
    updateTrip: $aaf6f2d98ee5cd02$var$rejectNoop("updateTrip"),
    calculateTrip: $aaf6f2d98ee5cd02$var$rejectNoop("calculateTrip")
};



var $acw62 = parcelRequire("acw62");

function $c80a929f5eac5ac1$export$927dafc935d4aea5(seed, subscription, belongsToScope) {
    const [ids, setIds] = (0, $acw62.useState)(()=>seed === undefined ? undefined : new Set(seed.map((row)=>row.id)));
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((row)=>{
        setIds((current)=>{
            if (current === undefined || !belongsToScope(row) || current.has(row.id)) return current;
            const next = new Set(current);
            next.add(row.id);
            return next;
        });
    }, subscription);
    return ids;
}


const $c759e996b5843e7b$var$TripRecordDeps = (0, $a9e25f5507c22ba4$export$a23f992de0d45ff0)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Cruise, {
    trips: (0, $9db39e34b2fb118a$export$14badfee79ea396f)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Trip, {
        with: [
            "calculated",
            "calculatedV2",
            "notes"
        ]
    })
});
const $c759e996b5843e7b$var$TripDayDeps = (0, $a9e25f5507c22ba4$export$a23f992de0d45ff0)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Trip, {
    days: (0, $9db39e34b2fb118a$export$14badfee79ea396f)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Day, {
        with: [
            "calculated",
            "calculatedV2",
            "notes"
        ]
    })
});
const $c759e996b5843e7b$var$TripTrackDeps = (0, $a9e25f5507c22ba4$export$a23f992de0d45ff0)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Trip, {
    tracks: (0, $9db39e34b2fb118a$export$14badfee79ea396f)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Track)
});
function $c759e996b5843e7b$var$nestedRows(trip, days, tracks) {
    var _a;
    const notes = [
        ...(_a = trip.notes) !== null && _a !== void 0 ? _a : [],
        ...days.flatMap((day)=>{
            var _a;
            return (_a = day.notes) !== null && _a !== void 0 ? _a : [];
        })
    ];
    return Object.assign({
        Trip: [
            trip
        ],
        Day: days,
        Track: tracks
    }, (0, $5bd541aff0182fa0$export$e9bc97ba61bf8e52)(notes));
}
function $c759e996b5843e7b$var$TripDataInner({ currentDays: currentDays, initTracks: initTracks, trip: trip, tripChildren: tripChildren, details: details, setDetails: setDetails, children: children, storeBacked: storeBacked }) {
    var _a;
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const tripIds = {
        cruiseId: trip.cruiseId
    };
    const dayIds = {
        shipId: ship.id,
        tripId: trip.id
    };
    const trackIds = {
        shipId: ship.id,
        tripId: trip.id
    };
    const { trips: trips } = (0, $e9db94b1c3310c7c$export$a37ae8cf05d96586)($c759e996b5843e7b$var$TripRecordDeps, tripIds, {
        fetch: false
    });
    const { days: days } = (0, $e9db94b1c3310c7c$export$a37ae8cf05d96586)($c759e996b5843e7b$var$TripDayDeps, dayIds, {
        fetch: !tripChildren && currentDays === undefined
    });
    const { tracks: tracks } = (0, $e9db94b1c3310c7c$export$a37ae8cf05d96586)($c759e996b5843e7b$var$TripTrackDeps, trackIds, {
        fetch: details && initTracks === undefined
    });
    const writers = (0, $acw62.useMemo)(()=>(0, $aaf6f2d98ee5cd02$export$375e2eb58a2d7c49)(store, {
            shipId: ship.id,
            tripId: trip.id
        }), [
        store,
        ship.id,
        trip.id
    ]);
    const seededDayIds = (0, $c80a929f5eac5ac1$export$927dafc935d4aea5)(currentDays, (0, $1bedde6805bf6e79$export$f55210826850c514).Day, (day)=>day.tripId === trip.id);
    const seededTrackIds = (0, $c80a929f5eac5ac1$export$927dafc935d4aea5)(initTracks, (0, $1bedde6805bf6e79$export$f55210826850c514).Track, (track)=>track.tripId === trip.id);
    const daysReady = (0, $29504a259cf4b663$export$c40434fbcbfd3fb6)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Day, dayIds, !tripChildren && currentDays === undefined, currentDays !== undefined);
    const tracksReady = (0, $29504a259cf4b663$export$c40434fbcbfd3fb6)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Track, trackIds, details && initTracks === undefined, initTracks !== undefined);
    // `currentDays` is an authoritative initial slice (Focus/Current): do not widen
    // it with older rows already cached for this trip, but admit subsequent live Days
    // exactly as the legacy local array does.
    const resolvedTrip = (_a = trips.find((candidate)=>candidate.id === trip.id)) !== null && _a !== void 0 ? _a : trip;
    const selectedDays = storeBacked && currentDays ? days.filter((day)=>currentDays.some((current)=>current.id === day.id)) : seededDayIds ? days.filter((day)=>seededDayIds.has(day.id)) : days;
    const selectedTracks = seededTrackIds ? tracks.filter((track)=>seededTrackIds.has(track.id)) : tracks;
    const resolvedDays = tripChildren && currentDays === undefined ? undefined : daysReady ? selectedDays : undefined;
    const resolvedTracks = tracksReady ? selectedTracks : undefined;
    const value = (0, $acw62.useMemo)(()=>({
            trip: resolvedTrip,
            days: resolvedDays,
            tracks: resolvedTracks,
            details: details,
            setDetails: setDetails,
            writers: writers
        }), [
        resolvedTrip,
        resolvedDays,
        resolvedTracks,
        details,
        setDetails,
        writers
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $304d95e33ca15961$export$bbbfe1497a5e65d9).Provider, {
        value: value,
        children: children
    });
}
function $c759e996b5843e7b$export$af66774b607f5f5b(props) {
    var _a, _b;
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const [details, setDetails] = (0, $acw62.useState)(props.initDetails !== undefined ? props.initDetails : props.focus == true);
    // Seed before the selector subtree mounts, so init/current data has no empty first
    // frame and useDeps can suppress the corresponding REST request.
    const seed = $c759e996b5843e7b$var$nestedRows(props.trip, (_a = props.currentDays) !== null && _a !== void 0 ? _a : [], (_b = props.initTracks) !== null && _b !== void 0 ? _b : []);
    const seedRef = (0, $acw62.useRef)(seed);
    seedRef.current = seed;
    const seedRevision = JSON.stringify(seed);
    (0, $acw62.useState)(()=>{
        if (!props.storeBacked) store.applyBundle({
            entities: seed
        });
        return true;
    });
    (0, $acw62.useEffect)(()=>{
        if (!props.storeBacked) store.applyBundle({
            entities: seedRef.current
        });
    }, [
        store,
        seedRevision,
        props.storeBacked
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($c759e996b5843e7b$var$TripDataInner, Object.assign({}, props, {
        details: details,
        setDetails: setDetails,
        children: props.children
    }));
}




var $acw62 = parcelRequire("acw62");




const $12693d787dae247c$export$34cbfcbe4b213343 = {
    loadDays (api, shipId, tripId) {
        return new (0, $1f13b14b44a36115$export$e5256e709c1d1a05)(api).days.list({
            params: {
                shipId: shipId,
                tripId: tripId
            }
        }).call();
    },
    loadTrack (api, shipId, tripId) {
        return new (0, $655725c259161537$export$2f8f7bdb7e386612)(api).tracks.trip({
            params: {
                shipId: shipId,
                tripId: tripId
            }
        }).call();
    },
    // Expand a sparse, ascending day list into a contiguous one by inserting synthetic
    // blank days (id 0) for every missing day between recorded days. Days numbered < 1
    // are skipped. Returns undefined when there are no days yet (still loading).
    fillDayGaps (days, trip) {
        if (!days) return;
        const result = [];
        let last = null;
        for (const day of days){
            if (day.day < 1) continue;
            if (last && last < day.day - 1) for(let d = last + 1; d < day.day; d++)result.push({
                id: 0,
                cruiseId: trip.cruiseId,
                tripId: trip.id,
                accountId: trip.accountId,
                shipId: trip.shipId,
                createdAt: day.createdAt,
                updatedAt: day.updatedAt,
                day: d,
                timezone: day.timezone,
                data: "{}"
            });
            result.push(day);
            last = day.day;
        }
        return result;
    },
    // Start/end passage location for a trip, shared by the interactive TripView header and
    // Print/TripsView. Both read the calculated locations with an empty-string fallback;
    // keeping this in one place stops the two headers from drifting.
    tripLocations (trip) {
        const calculated = trip.calculated;
        return {
            startLocation: (calculated === null || calculated === void 0 ? void 0 : calculated.startLocation) || "",
            endLocation: (calculated === null || calculated === void 0 ? void 0 : calculated.endLocation) || ""
        };
    }
};






function $c1fec144dee5c99f$export$a9698b21fc5ec27f({ children: children, daysWithBlanks: daysWithBlanks }) {
    if (children) return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
    if (!daysWithBlanks) return (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {});
    return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: daysWithBlanks.map((day)=>(0, $7b02d682eb115277$exports.jsx)((0, $d2dee9b5e2805e91$export$c1379d67dc104c23), {
                day: day
            }, `day-${day.id}-${day.day}`))
    });
}













// Thin re-export barrel. TripEditView's implementation moved to Views/Trip/EditView.tsx
// as part of the TripView decomposition (#728). It is kept here so external importers
// (CruiseView, TripView) and the flat data test keep importing from "./TripEditView"
// unchanged.


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $faa88de4f0afd1d0$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == 'symbol' || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, '');
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
$faa88de4f0afd1d0$exports = $faa88de4f0afd1d0$var$debounce;


// src/useBoolean/useBoolean.ts
function $48948c44af5d8a00$export$c32275ecbd12948f(defaultValue = false) {
    if (typeof defaultValue !== "boolean") throw new Error("defaultValue must be `true` or `false`");
    const [value, setValue] = (0, $acw62.useState)(defaultValue);
    const setTrue = (0, $acw62.useCallback)(()=>{
        setValue(true);
    }, []);
    const setFalse = (0, $acw62.useCallback)(()=>{
        setValue(false);
    }, []);
    const toggle = (0, $acw62.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $48948c44af5d8a00$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// src/useEventListener/useEventListener.ts
function $48948c44af5d8a00$export$7080b3e976bc91ab(eventName, handler, element, options) {
    const savedHandler = (0, $acw62.useRef)(handler);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $acw62.useEffect)(()=>{
        const targetElement = (element == null ? void 0 : element.current) ?? window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>{
            savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
// src/useClickAnyWhere/useClickAnyWhere.ts
function $48948c44af5d8a00$export$5139c081cbc6c8bb(handler) {
    $48948c44af5d8a00$export$7080b3e976bc91ab("click", (event)=>{
        handler(event);
    });
}
function $48948c44af5d8a00$export$b2199c37e85de4a7() {
    const [copiedText, setCopiedText] = (0, $acw62.useState)(null);
    const copy = (0, $acw62.useCallback)(async (text)=>{
        if (!(navigator == null ? void 0 : navigator.clipboard)) {
            console.warn("Clipboard not supported");
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    }, []);
    return [
        copiedText,
        copy
    ];
}
function $48948c44af5d8a00$export$70c4067197c60e2d(initialValue) {
    const [count, setCount] = (0, $acw62.useState)(initialValue ?? 0);
    const increment = (0, $acw62.useCallback)(()=>{
        setCount((x)=>x + 1);
    }, []);
    const decrement = (0, $acw62.useCallback)(()=>{
        setCount((x)=>x - 1);
    }, []);
    const reset = (0, $acw62.useCallback)(()=>{
        setCount(initialValue ?? 0);
    }, [
        initialValue
    ]);
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
function $48948c44af5d8a00$export$f4b266cd2aae9cb1(callback, delay) {
    const savedCallback = (0, $acw62.useRef)(callback);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(()=>{
        if (delay === null) return;
        const id = setInterval(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearInterval(id);
        };
    }, [
        delay
    ]);
}
// src/useCountdown/useCountdown.ts
function $48948c44af5d8a00$export$8103f7eb37e19f7b({ countStart: countStart, countStop: countStop = 0, intervalMs: intervalMs = 1e3, isIncrement: isIncrement = false }) {
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = $48948c44af5d8a00$export$70c4067197c60e2d(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = $48948c44af5d8a00$export$c32275ecbd12948f(false);
    const resetCountdown = (0, $acw62.useCallback)(()=>{
        stopCountdown();
        resetCounter();
    }, [
        stopCountdown,
        resetCounter
    ]);
    const countdownCallback = (0, $acw62.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    $48948c44af5d8a00$export$f4b266cd2aae9cb1(countdownCallback, isCountdownRunning ? intervalMs : null);
    return [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
function $48948c44af5d8a00$export$ee5b5d04074a389e(fn) {
    const ref = (0, $acw62.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $acw62.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
    }, [
        ref
    ]);
}
// src/useLocalStorage/useLocalStorage.ts
var $48948c44af5d8a00$var$IS_SERVER = typeof window === "undefined";
function $48948c44af5d8a00$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $acw62.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $acw62.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $acw62.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($48948c44af5d8a00$var$IS_SERVER) return initialValueToUse;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $48948c44af5d8a00$export$ee5b5d04074a389e((value)=>{
        if ($48948c44af5d8a00$var$IS_SERVER) console.warn(`Tried setting localStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.localStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("local-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting localStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $48948c44af5d8a00$export$ee5b5d04074a389e(()=>{
        if ($48948c44af5d8a00$var$IS_SERVER) console.warn(`Tried removing localStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.localStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("local-storage", {
            key: key
        }));
    });
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $acw62.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $48948c44af5d8a00$export$7080b3e976bc91ab("storage", handleStorageChange);
    $48948c44af5d8a00$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
var $48948c44af5d8a00$var$IS_SERVER2 = typeof window === "undefined";
function $48948c44af5d8a00$export$32d5543ab307c01(query, { defaultValue: defaultValue = false, initializeWithValue: initializeWithValue = true } = {}) {
    const getMatches = (query2)=>{
        if ($48948c44af5d8a00$var$IS_SERVER2) return defaultValue;
        return window.matchMedia(query2).matches;
    };
    const [matches, setMatches] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return getMatches(query);
        return defaultValue;
    });
    function handleChange() {
        setMatches(getMatches(query));
    }
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
// src/useDarkMode/useDarkMode.ts
var $48948c44af5d8a00$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
var $48948c44af5d8a00$var$LOCAL_STORAGE_KEY = "usehooks-ts-dark-mode";
function $48948c44af5d8a00$export$4673cbff94e146e2(options = {}) {
    const { defaultValue: defaultValue, localStorageKey: localStorageKey = $48948c44af5d8a00$var$LOCAL_STORAGE_KEY, initializeWithValue: initializeWithValue = true } = options;
    const isDarkOS = $48948c44af5d8a00$export$32d5543ab307c01($48948c44af5d8a00$var$COLOR_SCHEME_QUERY, {
        initializeWithValue: initializeWithValue,
        defaultValue: defaultValue
    });
    const [isDarkMode, setDarkMode] = $48948c44af5d8a00$export$86e2cef2561044ac(localStorageKey, defaultValue ?? isDarkOS ?? false, {
        initializeWithValue: initializeWithValue
    });
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        if (isDarkOS !== isDarkMode) setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>{
            setDarkMode((prev)=>!prev);
        },
        enable: ()=>{
            setDarkMode(true);
        },
        disable: ()=>{
            setDarkMode(false);
        },
        set: (value)=>{
            setDarkMode(value);
        }
    };
}
function $48948c44af5d8a00$export$89e33b3d84d8c331(func) {
    const funcRef = (0, $acw62.useRef)(func);
    funcRef.current = func;
    (0, $acw62.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}
// src/useDebounceCallback/useDebounceCallback.ts
function $48948c44af5d8a00$export$40ae01be0011c1e6(func, delay = 500, options) {
    const debouncedFunc = (0, $acw62.useRef)();
    $48948c44af5d8a00$export$89e33b3d84d8c331(()=>{
        if (debouncedFunc.current) debouncedFunc.current.cancel();
    });
    const debounced = (0, $acw62.useMemo)(()=>{
        const debouncedFuncInstance = (0, (/*@__PURE__*/$parcel$interopDefault($faa88de4f0afd1d0$exports)))(func, delay, options);
        const wrappedFunc = (...args)=>{
            return debouncedFuncInstance(...args);
        };
        wrappedFunc.cancel = ()=>{
            debouncedFuncInstance.cancel();
        };
        wrappedFunc.isPending = ()=>{
            return !!debouncedFunc.current;
        };
        wrappedFunc.flush = ()=>{
            return debouncedFuncInstance.flush();
        };
        return wrappedFunc;
    }, [
        func,
        delay,
        options
    ]);
    (0, $acw62.useEffect)(()=>{
        debouncedFunc.current = (0, (/*@__PURE__*/$parcel$interopDefault($faa88de4f0afd1d0$exports)))(func, delay, options);
    }, [
        func,
        delay,
        options
    ]);
    return debounced;
}
function $48948c44af5d8a00$export$52bae15610182273(initialValue, delay, options) {
    const eq = (options == null ? void 0 : options.equalityFn) ?? ((left, right)=>left === right);
    const unwrappedInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
    const [debouncedValue, setDebouncedValue] = (0, $acw62.useState)(unwrappedInitialValue);
    const previousValueRef = (0, $acw62.useRef)(unwrappedInitialValue);
    const updateDebouncedValue = $48948c44af5d8a00$export$40ae01be0011c1e6(setDebouncedValue, delay, options);
    if (!eq(previousValueRef.current, unwrappedInitialValue)) {
        updateDebouncedValue(unwrappedInitialValue);
        previousValueRef.current = unwrappedInitialValue;
    }
    return [
        debouncedValue,
        updateDebouncedValue
    ];
}
function $48948c44af5d8a00$export$4b208edda918084f(title, options = {}) {
    const { preserveTitleOnUnmount: preserveTitleOnUnmount = true } = options;
    const defaultTitle = (0, $acw62.useRef)(null);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        defaultTitle.current = window.document.title;
    }, []);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        window.document.title = title;
    }, [
        title
    ]);
    $48948c44af5d8a00$export$89e33b3d84d8c331(()=>{
        if (!preserveTitleOnUnmount && defaultTitle.current) window.document.title = defaultTitle.current;
    });
}
function $48948c44af5d8a00$export$ae780daf29e6d456(elementRef) {
    const [value, setValue] = (0, $acw62.useState)(false);
    const handleMouseEnter = ()=>{
        setValue(true);
    };
    const handleMouseLeave = ()=>{
        setValue(false);
    };
    $48948c44af5d8a00$export$7080b3e976bc91ab("mouseenter", handleMouseEnter, elementRef);
    $48948c44af5d8a00$export$7080b3e976bc91ab("mouseleave", handleMouseLeave, elementRef);
    return value;
}
function $48948c44af5d8a00$export$a7395f9832c00176({ threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false, initialIsIntersecting: initialIsIntersecting = false, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = (0, $acw62.useState)(null);
    const [state, setState] = (0, $acw62.useState)(()=>({
            isIntersecting: initialIsIntersecting,
            entry: void 0
        }));
    const callbackRef = (0, $acw62.useRef)();
    callbackRef.current = onChange;
    const frozen = ((_a = state.entry) == null ? void 0 : _a.isIntersecting) && freezeOnceVisible;
    (0, $acw62.useEffect)(()=>{
        if (!ref) return;
        if (!("IntersectionObserver" in window)) return;
        if (frozen) return;
        let unobserve;
        const observer = new IntersectionObserver((entries)=>{
            const thresholds = Array.isArray(observer.thresholds) ? observer.thresholds : [
                observer.thresholds
            ];
            entries.forEach((entry)=>{
                const isIntersecting = entry.isIntersecting && thresholds.some((threshold2)=>entry.intersectionRatio >= threshold2);
                setState({
                    isIntersecting: isIntersecting,
                    entry: entry
                });
                if (callbackRef.current) callbackRef.current(isIntersecting, entry);
                if (isIntersecting && freezeOnceVisible && unobserve) {
                    unobserve();
                    unobserve = void 0;
                }
            });
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen,
        freezeOnceVisible
    ]);
    const prevRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        var _a2;
        if (!ref && ((_a2 = state.entry) == null ? void 0 : _a2.target) && !freezeOnceVisible && !frozen && prevRef.current !== state.entry.target) {
            prevRef.current = state.entry.target;
            setState({
                isIntersecting: initialIsIntersecting,
                entry: void 0
            });
        }
    }, [
        ref,
        state.entry,
        freezeOnceVisible,
        frozen,
        initialIsIntersecting
    ]);
    const result = [
        setRef,
        !!state.isIntersecting,
        state.entry
    ];
    result.ref = result[0];
    result.isIntersecting = result[1];
    result.entry = result[2];
    return result;
}
function $48948c44af5d8a00$export$7c8949515a63d2a1() {
    const [isClient, setClient] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
function $48948c44af5d8a00$export$80c2a3957bcb42ea() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $acw62.useCallback)(()=>isMounted.current, []);
}
function $48948c44af5d8a00$export$86f8f9f08863e403(initialState = /* @__PURE__ */ new Map()) {
    const [map, setMap] = (0, $acw62.useState)(new Map(initialState));
    const actions = {
        set: (0, $acw62.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $acw62.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $acw62.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $acw62.useCallback)(()=>{
            setMap(()=>/* @__PURE__ */ new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
// src/useOnClickOutside/useOnClickOutside.ts
function $48948c44af5d8a00$export$9afc64c180e82dc4(ref, handler, eventType = "mousedown", eventListenerOptions = {}) {
    $48948c44af5d8a00$export$7080b3e976bc91ab(eventType, (event)=>{
        const target = event.target;
        if (!target || !target.isConnected) return;
        const isOutside = Array.isArray(ref) ? ref.filter((r)=>Boolean(r.current)).every((r)=>r.current && !r.current.contains(target)) : ref.current && !ref.current.contains(target);
        if (isOutside) handler(event);
    }, void 0, eventListenerOptions);
}
var $48948c44af5d8a00$var$IS_SERVER3 = typeof window === "undefined";
function $48948c44af5d8a00$export$558ff211cfc1c1fe(key, options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($48948c44af5d8a00$var$IS_SERVER3) initializeWithValue = false;
    const deserializer = (0, $acw62.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return null;
        }
        return parsed;
    }, [
        options
    ]);
    const readValue = (0, $acw62.useCallback)(()=>{
        if ($48948c44af5d8a00$var$IS_SERVER3) return null;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return null;
        }
    }, [
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readValue();
        return void 0;
    });
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $acw62.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $48948c44af5d8a00$export$7080b3e976bc91ab("storage", handleStorageChange);
    $48948c44af5d8a00$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return storedValue;
}
var $48948c44af5d8a00$var$initialSize = {
    width: void 0,
    height: void 0
};
function $48948c44af5d8a00$export$683480f191c0e3ea(options) {
    const { ref: ref, box: box = "content-box" } = options;
    const [{ width: width, height: height }, setSize] = (0, $acw62.useState)($48948c44af5d8a00$var$initialSize);
    const isMounted = $48948c44af5d8a00$export$80c2a3957bcb42ea();
    const previousSize = (0, $acw62.useRef)({
        ...$48948c44af5d8a00$var$initialSize
    });
    const onResize = (0, $acw62.useRef)(void 0);
    onResize.current = options.onResize;
    (0, $acw62.useEffect)(()=>{
        if (!ref.current) return;
        if (typeof window === "undefined" || !("ResizeObserver" in window)) return;
        const observer = new ResizeObserver(([entry])=>{
            const boxProp = box === "border-box" ? "borderBoxSize" : box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
            const newWidth = $48948c44af5d8a00$var$extractSize(entry, boxProp, "inlineSize");
            const newHeight = $48948c44af5d8a00$var$extractSize(entry, boxProp, "blockSize");
            const hasChanged = previousSize.current.width !== newWidth || previousSize.current.height !== newHeight;
            if (hasChanged) {
                const newSize = {
                    width: newWidth,
                    height: newHeight
                };
                previousSize.current.width = newWidth;
                previousSize.current.height = newHeight;
                if (onResize.current) onResize.current(newSize);
                else if (isMounted()) setSize(newSize);
            }
        });
        observer.observe(ref.current, {
            box: box
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        box,
        ref,
        isMounted
    ]);
    return {
        width: width,
        height: height
    };
}
function $48948c44af5d8a00$var$extractSize(entry, box, sizeType) {
    if (!entry[box]) {
        if (box === "contentBoxSize") return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return void 0;
    }
    return Array.isArray(entry[box]) ? entry[box][0][sizeType] : // @ts-ignore Support Firefox's non-standard behavior
    entry[box][sizeType];
}
var $48948c44af5d8a00$var$IS_SERVER4 = typeof window === "undefined";
function $48948c44af5d8a00$export$654d3fb7a8fef387(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($48948c44af5d8a00$var$IS_SERVER4) initializeWithValue = false;
    const readScreen = ()=>{
        if ($48948c44af5d8a00$var$IS_SERVER4) return void 0;
        return window.screen;
    };
    const [screen, setScreen] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readScreen();
        return void 0;
    });
    const debouncedSetScreen = $48948c44af5d8a00$export$40ae01be0011c1e6(setScreen, options.debounceDelay);
    function handleSize() {
        const newScreen = readScreen();
        const setSize = options.debounceDelay ? debouncedSetScreen : setScreen;
        if (newScreen) {
            const { width: width, height: height, availHeight: availHeight, availWidth: availWidth, colorDepth: colorDepth, orientation: orientation, pixelDepth: pixelDepth } = newScreen;
            setSize({
                width: width,
                height: height,
                availHeight: availHeight,
                availWidth: availWidth,
                colorDepth: colorDepth,
                orientation: orientation,
                pixelDepth: pixelDepth
            });
        }
    }
    $48948c44af5d8a00$export$7080b3e976bc91ab("resize", handleSize);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return screen;
}
var $48948c44af5d8a00$var$cachedScriptStatuses = /* @__PURE__ */ new Map();
function $48948c44af5d8a00$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node == null ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $48948c44af5d8a00$export$1d3955b0b5cace9c(src, options) {
    const [status, setStatus] = (0, $acw62.useState)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return $48948c44af5d8a00$var$cachedScriptStatuses.get(src) ?? "loading";
    });
    (0, $acw62.useEffect)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $48948c44af5d8a00$var$cachedScriptStatuses.get(src);
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $48948c44af5d8a00$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            if (options == null ? void 0 : options.id) scriptNode.id = options.id;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode == null || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus(script.status ?? cachedScriptStatus ?? "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $48948c44af5d8a00$var$cachedScriptStatuses.set(src, newStatus);
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options == null ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
                $48948c44af5d8a00$var$cachedScriptStatuses.delete(src);
            }
        };
    }, [
        src,
        options == null ? void 0 : options.shouldPreventLoad,
        options == null ? void 0 : options.removeOnUnmount,
        options == null ? void 0 : options.id
    ]);
    return status;
}
var $48948c44af5d8a00$var$IS_SERVER5 = typeof window === "undefined";
function $48948c44af5d8a00$export$e47ba1b900da5d3b(options = {}) {
    const { autoLock: autoLock = true, lockTarget: lockTarget, widthReflow: widthReflow = true } = options;
    const [isLocked, setIsLocked] = (0, $acw62.useState)(false);
    const target = (0, $acw62.useRef)(null);
    const originalStyle = (0, $acw62.useRef)(null);
    const lock = ()=>{
        if (target.current) {
            const { overflow: overflow, paddingRight: paddingRight } = target.current.style;
            originalStyle.current = {
                overflow: overflow,
                paddingRight: paddingRight
            };
            if (widthReflow) {
                const offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                const currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                const scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = `${scrollbarWidth + currentPaddingRight}px`;
            }
            target.current.style.overflow = "hidden";
            setIsLocked(true);
        }
    };
    const unlock = ()=>{
        if (target.current && originalStyle.current) {
            target.current.style.overflow = originalStyle.current.overflow;
            if (widthReflow) target.current.style.paddingRight = originalStyle.current.paddingRight;
        }
        setIsLocked(false);
    };
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        if ($48948c44af5d8a00$var$IS_SERVER5) return;
        if (lockTarget) target.current = typeof lockTarget === "string" ? document.querySelector(lockTarget) : lockTarget;
        if (!target.current) target.current = document.body;
        if (autoLock) lock();
        return ()=>{
            unlock();
        };
    }, [
        autoLock,
        lockTarget,
        widthReflow
    ]);
    return {
        isLocked: isLocked,
        lock: lock,
        unlock: unlock
    };
}
var $48948c44af5d8a00$var$IS_SERVER6 = typeof window === "undefined";
function $48948c44af5d8a00$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $acw62.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $acw62.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $acw62.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($48948c44af5d8a00$var$IS_SERVER6) return initialValueToUse;
        try {
            const raw = window.sessionStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $48948c44af5d8a00$export$ee5b5d04074a389e((value)=>{
        if ($48948c44af5d8a00$var$IS_SERVER6) console.warn(`Tried setting sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.sessionStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("session-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $48948c44af5d8a00$export$ee5b5d04074a389e(()=>{
        if ($48948c44af5d8a00$var$IS_SERVER6) console.warn(`Tried removing sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.sessionStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("session-storage", {
            key: key
        }));
    });
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $acw62.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $48948c44af5d8a00$export$7080b3e976bc91ab("storage", handleStorageChange);
    $48948c44af5d8a00$export$7080b3e976bc91ab("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
function $48948c44af5d8a00$export$7896576cb7635832(maxStep) {
    const [currentStep, setCurrentStep] = (0, $acw62.useState)(1);
    const canGoToNextStep = currentStep + 1 <= maxStep;
    const canGoToPrevStep = currentStep - 1 > 0;
    const setStep = (0, $acw62.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $acw62.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $acw62.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
// src/useTernaryDarkMode/useTernaryDarkMode.ts
var $48948c44af5d8a00$var$COLOR_SCHEME_QUERY2 = "(prefers-color-scheme: dark)";
var $48948c44af5d8a00$var$LOCAL_STORAGE_KEY2 = "usehooks-ts-ternary-dark-mode";
function $48948c44af5d8a00$export$ec561688e440eda6({ defaultValue: defaultValue = "system", localStorageKey: localStorageKey = $48948c44af5d8a00$var$LOCAL_STORAGE_KEY2, initializeWithValue: initializeWithValue = true } = {}) {
    const isDarkOS = $48948c44af5d8a00$export$32d5543ab307c01($48948c44af5d8a00$var$COLOR_SCHEME_QUERY2, {
        initializeWithValue: initializeWithValue
    });
    const [mode, setMode] = $48948c44af5d8a00$export$86e2cef2561044ac(localStorageKey, defaultValue, {
        initializeWithValue: initializeWithValue
    });
    const isDarkMode = mode === "dark" || mode === "system" && isDarkOS;
    const toggleTernaryDarkMode = ()=>{
        const modes = [
            "light",
            "system",
            "dark"
        ];
        setMode((prevMode)=>{
            const nextIndex = (modes.indexOf(prevMode) + 1) % modes.length;
            return modes[nextIndex];
        });
    };
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: mode,
        setTernaryDarkMode: setMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
function $48948c44af5d8a00$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $acw62.useRef)(callback);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        delay
    ]);
}
function $48948c44af5d8a00$export$cbe85ee05b554577(defaultValue) {
    const [value, setValue] = (0, $acw62.useState)(!!defaultValue);
    const toggle = (0, $acw62.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return [
        value,
        toggle,
        setValue
    ];
}
var $48948c44af5d8a00$var$IS_SERVER7 = typeof window === "undefined";
function $48948c44af5d8a00$export$42c02f33970a2afa(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($48948c44af5d8a00$var$IS_SERVER7) initializeWithValue = false;
    const [windowSize, setWindowSize] = (0, $acw62.useState)(()=>{
        if (initializeWithValue) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        return {
            width: void 0,
            height: void 0
        };
    });
    const debouncedSetWindowSize = $48948c44af5d8a00$export$40ae01be0011c1e6(setWindowSize, options.debounceDelay);
    function handleSize() {
        const setSize = options.debounceDelay ? debouncedSetWindowSize : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }
    $48948c44af5d8a00$export$7080b3e976bc91ab("resize", handleSize);
    $48948c44af5d8a00$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return windowSize;
}















const $d808edb9aa17aa9b$export$9e6173784a63b4a1 = {
    saveTrip (api, shipId, tripId, values) {
        return new (0, $84aa1a3b4df5a78b$export$5e13e029a186945f)(api).trips.update({
            params: {
                shipId: shipId,
                tripId: tripId
            },
            body: values
        }).call();
    },
    startNavigation (api) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.start({
            params: {}
        }).call();
    },
    // `title` is plain text (issue #529 consistency pass) -- the registered "text"
    // format kind, so it gets the shared "–" convention for a missing value but no
    // unit/locale formatting.
    fieldFormat () {
        return {
            title: "text"
        };
    }
};
function $d808edb9aa17aa9b$export$2dd432b547039c59({ completedCallback: completedCallback, cruiseId: _cruiseId, trip: trip }) {
    var _a, _b, _c, _d, _e;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const shipView = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const { writers: writers } = (0, $304d95e33ca15961$export$f49a6ec715d07476)();
    const { subscriptionExpired: subscriptionExpired } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const t = app.getT("TripEditView");
    const { edited: edited, onEdited: onEdited, saveEdits: saveEdits } = (0, $58cbd7a8fa422027$export$d3b8d51a855c78a3)({
        update: writers.updateTrip
    });
    const [status, setStatus] = (0, $acw62.useState)(!!((_a = app.status) === null || _a === void 0 ? void 0 : _a.time));
    const [time, setTime] = (0, $acw62.useState)(((_b = app.status) === null || _b === void 0 ? void 0 : _b.time) ? Date.parse(app.status.time) : new Date().valueOf() - new Date((0, $14a8bda8b42de2c4$export$4334e0aa46d23a16)).valueOf());
    const _calculated = trip.calculated;
    const editableFields = [
        {
            name: "title",
            default: "",
            type: "string"
        }
    ];
    const formEditable = app.editable || shipView.shipCloudEditable;
    const tripNotStarted = (0, $acw62.useMemo)(()=>{
        var _a;
        return formEditable && ((_a = app.status) === null || _a === void 0 ? void 0 : _a.navigation) != true && trip.startedAt == undefined;
    }, [
        app.status,
        formEditable,
        trip
    ]);
    // Use mock status for testing
    // const accountStatus = useMemo(() => IAccountSubscriptionStatus.active, []);
    // const subscriptionExpired = true; // Mock for testing
    const isTrialExpired = (0, $acw62.useMemo)(()=>{
        var _a;
        return ((_a = app.account) === null || _a === void 0 ? void 0 : _a.subscriptionStatus) === (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trialExpired;
    }, [
        (_c = app.account) === null || _c === void 0 ? void 0 : _c.subscriptionStatus
    ]);
    const isDemoNotStarted = (0, $acw62.useMemo)(()=>{
        var _a;
        return ((_a = app.account) === null || _a === void 0 ? void 0 : _a.subscriptionStatus) === (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).inactive;
    }, [
        (_d = app.account) === null || _d === void 0 ? void 0 : _d.subscriptionStatus
    ]);
    const timezone = (0, $acw62.useMemo)(()=>{
        return !trip.startedAt && app.status ? app.status.systemTimezone : trip.timezone;
    }, [
        trip,
        app.status,
        (_e = app.status) === null || _e === void 0 ? void 0 : _e.systemTimezone
    ]);
    const currentTime = (0, $acw62.useMemo)(()=>time / 1000 + (timezone || 0), [
        time,
        trip,
        timezone
    ]);
    const _cancel = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        completedCallback(false);
    }, [
        completedCallback
    ]);
    const startNavigation = (0, $acw62.useCallback)(async (e)=>{
        e.preventDefault();
        const result = await $d808edb9aa17aa9b$export$9e6173784a63b4a1.startNavigation(app.apiClient);
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("start navigation", result != undefined);
        if (result) {
            app.resetStatus();
            app.updateCurrent();
        }
    }, [
        trip
    ]);
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((status, _type)=>{
        if (status.time) {
            setTime(Date.parse(status.time));
            if (!status) setStatus(true);
        }
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).AppStatus);
    (0, $48948c44af5d8a00$export$f4b266cd2aae9cb1)(()=>{
        setTime(new Date().valueOf() - new Date((0, $14a8bda8b42de2c4$export$4334e0aa46d23a16)).valueOf());
    }, status ? null : 5000);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "TripEditView",
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "block-container",
            children: (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "TripStatsView-block-time block",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                    buttonFirst: true,
                    changed: edited,
                    editable: formEditable,
                    editableFields: editableFields,
                    onSave: saveEdits,
                    children: [
                        tripNotStarted && !isTrialExpired && !subscriptionExpired && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "message block_field_small_50",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                    message: (m)=>m.currentView.firstTrip
                                })
                            })
                        }),
                        isTrialExpired && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "message block_field_small_50",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                    message: (m)=>m.subscription.demoEnded
                                })
                            })
                        }),
                        subscriptionExpired && !isTrialExpired && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "message block_field_small_50",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                    message: (m)=>m.subscription.subscriptionExpired
                                })
                            })
                        }),
                        tripNotStarted && !isTrialExpired && !subscriptionExpired && isDemoNotStarted && app.current && app.current.day > 9251 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "message_red block_field_small_50",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                    message: (m)=>m.currentView.demoWillStart
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block-row-one-row",
                            actions: tripNotStarted,
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("title"),
                                    className: "block_field_small_28",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: trip.title,
                                        name: "title",
                                        onChange: onEdited,
                                        readOnly: !formEditable,
                                        maxLength: 40
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("timezone"),
                                    className: "block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "input",
                                        children: app.format("timezone", timezone)
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("current_time"),
                                    className: "block_field_small_8",
                                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "input center",
                                        children: app.format("timeUtc", currentTime)
                                    })
                                }),
                                tripNotStarted && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button default start-trip",
                                        onClick: startNavigation,
                                        disabled: isTrialExpired,
                                        children: t("start")
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}







function $b9fae480020aa8a6$export$dfb85e630bac2771({ trip: trip, initTab: initTab, tabBarRef: tabBarRef, tracks: tracks }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { cruise: cruise } = (0, $97ac05743b787a86$export$135b8b9ecdd62154)();
    const shipView = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const t = app.getT("TripView");
    const calculated = trip.calculated;
    const { writers: writers } = (0, $304d95e33ca15961$export$f49a6ec715d07476)();
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "TripView-details",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $9f9e7bca499fb8dc$export$f97dc4a5a0177256), {
            defaultSelection: initTab || "trip",
            callbacks: tabBarRef,
            tabs: [
                {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Trip,
                    name: "trip",
                    title: t("tab_trip"),
                    render: ()=>{
                        return (0, $7b02d682eb115277$exports.jsx)((0, $d808edb9aa17aa9b$export$2dd432b547039c59), {
                            cruiseId: trip.cruiseId,
                            trip: trip
                        });
                    }
                },
                {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Stats,
                    name: "stats",
                    title: t("tab_stats"),
                    render: ()=>{
                        return (0, $7b02d682eb115277$exports.jsx)((0, $198e3b0852fb0b06$export$1e3e8ecfe0e6273a), {
                            trip: trip,
                            calculate: writers.calculateTrip
                        });
                    }
                },
                {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Track,
                    name: "track",
                    title: t("tab_track"),
                    render: ()=>{
                        return (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "TripView-track",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $7e01767afef66f8e$export$600f95652e45663), {
                                fullscreen: false,
                                tracks: tracks,
                                timezone: trip.timezone
                            })
                        });
                    }
                },
                {
                    hide: !calculated || !calculated.weatherTimeseries,
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Graph,
                    name: "weather",
                    title: t("tab_weather"),
                    render: ()=>{
                        return (0, $7b02d682eb115277$exports.jsx)((0, $da41652818610294$export$6a7fe3ef90e8d566), {
                            timeseries: calculated === null || calculated === void 0 ? void 0 : calculated.weatherTimeseries
                        });
                    }
                },
                ...(0, $59a722b1b33d4469$export$2a7d663d787aca05)(app, (0, $d460697aab603bc5$export$5daa50148070bda5).trip, trip.notes || []),
                {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Print,
                    name: "print",
                    title: t("tab_print"),
                    render: ()=>{
                        return (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "TripView-print-tab",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    className: "block-row-button-print",
                                    children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "button ",
                                        onClick: ()=>{
                                            shipView.setPrinting((0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).trips, cruise);
                                        },
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Print,
                                                className: "icon-large"
                                            }),
                                            " ",
                                            t("print_all")
                                        ]
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    className: "block-row-button-print",
                                    children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "button ",
                                        onClick: ()=>{
                                            shipView.setPrinting((0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).trips, cruise, trip.id);
                                        },
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Print,
                                                className: "icon-large"
                                            }),
                                            " ",
                                            t("print_trip")
                                        ]
                                    })
                                })
                            ]
                        });
                    }
                }
            ]
        })
    });
}





function $0f4222d908f24b35$export$79eda242f95ef81({ trip: trip, details: details, onDetailsChange: onDetailsChange, startLocation: startLocation, endLocation: endLocation }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("TripView");
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "TripView-header" + (details ? " details" : ""),
        "data-trip-id": trip.id,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $5c760195bdd4d0c9$export$1aa7c7ccc1c44ab8), {
                className: "TripView-details-toggle",
                onChange: onDetailsChange
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "TripView-title",
                children: [
                    "\u00BB",
                    trip.title || t("untitled_trip"),
                    "\u00AB"
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "TripView-summary",
                children: [
                    app.format("date", trip.startedAt),
                    (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "TripView-divider",
                                children: "\u2022"
                            }),
                            startLocation
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "TripView-divider",
                        children: "\u2026"
                    }),
                    app.format("date", trip.completedAt),
                    (0, $7b02d682eb115277$exports.jsxs)("strong", {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "TripView-divider",
                                children: "\u2022"
                            }),
                            endLocation
                        ]
                    })
                ]
            })
        ]
    });
}


function $b2fc28d453675e31$export$4d4db584fdf0d2d3({ focus: focus, initTab: initTab, overrideDays: overrideDays, tripChildren: tripChildren }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { trip: trip, days: days, tracks: tracks, details: details, setDetails: setDetails } = (0, $304d95e33ca15961$export$f49a6ec715d07476)();
    const tabBarRef = (0, $8a8193ceb042f538$export$ba657787b573294a)();
    const state = (0, $acw62.useMemo)(()=>({
            trip: trip,
            days: days || overrideDays || []
        }), [
        trip,
        days,
        overrideDays
    ]);
    const { startLocation: startLocation, endLocation: endLocation } = (0, $12693d787dae247c$export$34cbfcbe4b213343).tripLocations(trip);
    const daysWithBlanks = (0, $acw62.useMemo)(()=>(0, $12693d787dae247c$export$34cbfcbe4b213343).fillDayGaps(days, trip), [
        days,
        trip
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $97ac05743b787a86$export$cc476f15536a432b).Provider, {
        value: state,
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "TripView" + (days && days.length == 0 ? " no-days" : "") + (((_a = app.current) === null || _a === void 0 ? void 0 : _a.tripId) && trip.id == app.current.tripId ? " active" : "") + (focus ? " focus" : ""),
            "data-trip-id": trip.id,
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $0f4222d908f24b35$export$79eda242f95ef81), {
                    trip: trip,
                    details: details,
                    onDetailsChange: setDetails,
                    startLocation: startLocation,
                    endLocation: endLocation
                }),
                details && (0, $7b02d682eb115277$exports.jsx)((0, $b9fae480020aa8a6$export$dfb85e630bac2771), {
                    trip: trip,
                    initTab: initTab,
                    tabBarRef: tabBarRef,
                    tracks: tracks
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $c1fec144dee5c99f$export$a9698b21fc5ec27f), {
                    daysWithBlanks: daysWithBlanks,
                    children: tripChildren
                })
            ]
        })
    });
}



var $8b93cdbcae4a2de3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $8b93cdbcae4a2de3$var$TripDataViewWithUI = (0, $480db5fef2358c2d$export$ae24a3dd6105e285)({
    acquire: (0, $c759e996b5843e7b$export$af66774b607f5f5b),
    ui: (0, $b2fc28d453675e31$export$4d4db584fdf0d2d3)
});
function $8b93cdbcae4a2de3$export$62031b35b640577c(_a) {
    var { children: children } = _a, props = $8b93cdbcae4a2de3$var$__rest(_a, [
        "children"
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($8b93cdbcae4a2de3$var$TripDataViewWithUI, Object.assign({}, props, {
        tripChildren: children
    }));
}









function $b9d9999104ea394d$export$f1f196effd6cdce5({ day: day }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const _data = (0, $872aa31e93f7b7c8$export$ea13d8db95f96086)();
    const date = (0, $600b78128ceeb0f6$export$98e9a0bb257361e9)(day.day);
    const tc = app.getT("PrintView");
    const _t = app.getT("DayEditView");
    const ts = app.getT("StatsView");
    const calculated = day.calculated;
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: "PrintDayListView",
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
            className: "print-day-list-row",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: tc("date"),
                    className: "block-field-150 label-left",
                    children: app.format("date", date.toISOString())
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: tc("from_loc"),
                    className: "block-field-225",
                    children: day.startLocation
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: tc("to_loc"),
                    className: "block-field-225",
                    children: day.endLocation
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: ts("time_total"),
                    className: "block-field-90 ",
                    children: app.format("timeh", calculated === null || calculated === void 0 ? void 0 : calculated.duration)
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: ts("distance_total"),
                    className: "block-field-120 print-field-text-right",
                    children: app.format("distance", calculated === null || calculated === void 0 ? void 0 : calculated.distance)
                })
            ]
        })
    });
}










function $79eaac54f61efb4d$export$7b7d4e2ec573a088({ cruise: _cruise, day: day, note: note, trip: trip }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const tc = app.getT("PrintView");
    if (note.noteType !== (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).journal) return null;
    const attachments = (note.attachments || []).map((a)=>{
        const key = `note-${note.id}-attachment-${a.id}`;
        const _label = (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: "attachment-label",
            children: [
                a.fileName,
                ".",
                a.fileType
            ]
        });
        const image = (0, $86850ed0d32dea3a$export$2c13e988217f85e9).isImage(a);
        const url = (0, $86850ed0d32dea3a$export$2c13e988217f85e9).attachmentUrl(app.apiClient, ship.id, note.id, a, app.cloudSession());
        return (0, $7b02d682eb115277$exports.jsx)("a", {
            href: url,
            className: "attachment",
            target: "_blank",
            rel: "noopener noreferrer",
            children: image && (0, $7b02d682eb115277$exports.jsx)("img", {
                src: url
            })
        }, key);
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("h4", {
                children: [
                    note.tripId != undefined && note.dayId == null && trip && ` ${tc("trip")} \u{2013} ${trip.title}`,
                    note.dayId != undefined && day && `${app.format("date", (0, $600b78128ceeb0f6$export$98e9a0bb257361e9)(day.day).toISOString())}`
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("h5", {
                children: note.title
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "print-note-text ",
                children: note.note
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "attachments print-attachments",
                children: attachments
            })
        ]
    });
}










function $fab7cfe98faa0983$export$5c59c8dede30c0d({ cruise: cruise, day: day, note: note, trip: trip }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const tc = app.getT("PrintView");
    if (note.noteType !== (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).technical) return null;
    const attachments = (note.attachments || []).map((a)=>{
        const key = `note-${note.id}-attachment-${a.id}`;
        const _label = (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: "attachment-label",
            children: [
                a.fileName,
                ".",
                a.fileType
            ]
        });
        const image = (0, $86850ed0d32dea3a$export$2c13e988217f85e9).isImage(a);
        const url = (0, $86850ed0d32dea3a$export$2c13e988217f85e9).attachmentUrl(app.apiClient, ship.id, note.id, a, app.cloudSession());
        return (0, $7b02d682eb115277$exports.jsx)("a", {
            href: url,
            className: "attachment",
            target: "_blank",
            rel: "noopener noreferrer",
            children: image && (0, $7b02d682eb115277$exports.jsx)("img", {
                src: url
            })
        }, key);
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("h4", {
                children: [
                    note.cruiseId != null && note.tripId == null && note.dayId == null && cruise && ` ${tc("cruise")} \u{2013} ${cruise.title}`,
                    note.tripId != null && note.dayId == null && trip && ` ${tc("trip")} \u{2013} ${trip.title}`,
                    note.dayId != null && day && `${app.format("date", (0, $600b78128ceeb0f6$export$98e9a0bb257361e9)(day.day).toISOString())}`
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("h5", {
                children: note.title
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "print-note-text ",
                children: note.note
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "print-attachments",
                children: attachments
            })
        ]
    });
}


function $04ba025241b6e795$export$22a82f6258fd0050({ trips: trips }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const context = (0, $872aa31e93f7b7c8$export$f3bba5f1f646e703)();
    const data = (0, $872aa31e93f7b7c8$export$ea13d8db95f96086)();
    const tc = app.getT("PrintView");
    if (!trips || trips.length === 0) return null;
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        children: trips.map((trip)=>{
            const { startLocation: startLocation, endLocation: endLocation } = (0, $12693d787dae247c$export$34cbfcbe4b213343).tripLocations(trip);
            const tracks = data ? data.tracks.filter((track)=>track.tripId == trip.id) : [];
            const tripDaysNotes = data ? (0, $872aa31e93f7b7c8$export$4caba1eb391c1000)(data.days).filter((d)=>d.tripId == trip.id).flatMap((d)=>d.notes || []) : [];
            const allTripNotes = [
                ...trip.notes || [],
                ...tripDaysNotes
            ].filter((note, index, self)=>self.findIndex((n)=>n.id === note.id) === index);
            const notes = (trip.notes || []).filter((note)=>note.tripId == trip.id && note.dayId == null && (note.title || note.note)).map((note)=>{
                return (0, $7b02d682eb115277$exports.jsx)((0, $38d489c42abec98d$export$f02f2a6561f79acf), {
                    trip: trip,
                    note: note
                }, note.id);
            });
            const journalNotes = allTripNotes.filter((note)=>note.tripId == trip.id && note.noteType === (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).journal && (note.title || note.note)).map((note)=>{
                const tripRef = note.tripId ? data === null || data === void 0 ? void 0 : data.trips.find((t)=>t.id === note.tripId) : undefined;
                const day = note.dayId ? data === null || data === void 0 ? void 0 : data.days.find((d)=>d.id === note.dayId) : undefined;
                return (0, $7b02d682eb115277$exports.jsx)((0, $79eaac54f61efb4d$export$7b7d4e2ec573a088), {
                    note: note,
                    trip: tripRef,
                    day: day
                }, note.id);
            });
            const technicalNotes = allTripNotes.filter((note)=>note.tripId == trip.id && note.noteType === (0, $7a517a6ccb68a7e7$export$71c27e2dc62bcf10).technical).map((note)=>{
                const tripRef = note.tripId ? data === null || data === void 0 ? void 0 : data.trips.find((t)=>t.id === note.tripId) : undefined;
                const day = note.dayId ? data === null || data === void 0 ? void 0 : data.days.find((d)=>d.id === note.dayId) : undefined;
                return (0, $7b02d682eb115277$exports.jsx)((0, $fab7cfe98faa0983$export$5c59c8dede30c0d), {
                    note: note,
                    trip: tripRef,
                    day: day
                }, note.id);
            });
            const tripDays = data ? (0, $872aa31e93f7b7c8$export$4caba1eb391c1000)(data.dayLists).filter((d)=>d.tripId == trip.id) : [];
            const dayLists = tripDays.map((day)=>(0, $7b02d682eb115277$exports.jsx)((0, $b9d9999104ea394d$export$f1f196effd6cdce5), {
                    day: day
                }, day.id));
            const dayDetails = tripDays.map((day)=>(0, $7b02d682eb115277$exports.jsx)((0, $bb3d4c90fd993ed5$export$f167fc1836a7e73e), {
                    day: day
                }, day.id));
            return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (context === null || context === void 0 ? void 0 : context.includeTripData) && (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                className: "PrintTripView container-boxed",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                        children: [
                                            tc("trip"),
                                            ": ",
                                            trip.title || "Untitled passage"
                                        ]
                                    }),
                                    (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "print-text-normal",
                                                children: tc("from_date")
                                            }),
                                            " ",
                                            app.format("date", trip.startedAt),
                                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "print-text-normal print-distance-left",
                                                children: tc("until_date")
                                            }),
                                            " ",
                                            app.format("date", trip.completedAt),
                                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "print-distance-left",
                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {})
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "print-text-normal print-distance-left",
                                                children: tc("from_loc")
                                            }),
                                            " ",
                                            startLocation,
                                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "print-text-normal print-distance-left",
                                                children: tc("to_loc")
                                            }),
                                            " ",
                                            endLocation
                                        ]
                                    }),
                                    (0, $24d0c87b6223a295$export$1e0f7ae80feb6b6).hasPositions(tracks) && (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "PrintTripView-track",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $7e01767afef66f8e$export$600f95652e45663), {
                                            fullscreen: false,
                                            noInteraction: true,
                                            tracks: tracks,
                                            timezone: trip.timezone
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "PrintTripView-statistics container-boxed-inner",
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                children: tc("trip_statistics")
                                            }),
                                            trip.calculated && (0, $7b02d682eb115277$exports.jsx)((0, $2ad184317a4db22e$export$9089c227cea0b0ec), {
                                                calculated: trip.calculated
                                            })
                                        ]
                                    }),
                                    notes.length > 0 && (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "PrintNoteView-trips container-boxed-inner",
                                        children: notes
                                    })
                                ]
                            }, trip.id),
                            (context === null || context === void 0 ? void 0 : context.includeTripDayListType) == (0, $872aa31e93f7b7c8$export$20c941d241cbcd74).short && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                className: "PrintDayListView-block container-boxed",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: tc("day_list")
                                    }),
                                    dayLists
                                ]
                            }),
                            (context === null || context === void 0 ? void 0 : context.includeTripDayListType) == (0, $872aa31e93f7b7c8$export$20c941d241cbcd74).details && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                className: "PrintDaysView-block container-boxed",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: tc("day_list")
                                    }),
                                    dayDetails
                                ]
                            })
                        ]
                    }),
                    (context === null || context === void 0 ? void 0 : context.includeJournal) && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "PrintJournalView-block container-boxed",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: tc("list_journal")
                            }),
                            journalNotes
                        ]
                    }),
                    (context === null || context === void 0 ? void 0 : context.includeTechnical) && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "PrintTechnicalView-block container-boxed",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: tc("list_technical")
                            }),
                            technicalNotes
                        ]
                    })
                ]
            });
        })
    });
}


function $dcabf49b79516d7b$export$340b7e322cccb54d({ printMode: printMode, data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("PrintView");
    const kind = (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).contentKind(printMode, data);
    switch(kind){
        case (0, $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1).cruise:
            return (0, $7b02d682eb115277$exports.jsx)((0, $42220feb3f963f0b$export$3efcb21cd1ec8329), {
                cruise: data.cruise
            });
        case (0, $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1).cruiseFailed:
            return (0, $7b02d682eb115277$exports.jsx)("p", {
                children: t("failed_to_load_cruise")
            });
        case (0, $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1).trips:
            return (0, $7b02d682eb115277$exports.jsx)((0, $04ba025241b6e795$export$22a82f6258fd0050), {
                trips: data.trips
            });
        case (0, $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1).tripsFailed:
            return (0, $7b02d682eb115277$exports.jsx)("p", {
                children: t("failed_to_load_trips")
            });
        case (0, $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1).days:
            return (0, $7b02d682eb115277$exports.jsx)("div", {
                children: (0, $872aa31e93f7b7c8$export$4caba1eb391c1000)(data.days).map((d)=>(0, $7b02d682eb115277$exports.jsx)((0, $bb3d4c90fd993ed5$export$f167fc1836a7e73e), {
                        day: d
                    }, d.id))
            });
        case (0, $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1).daysFailed:
            return (0, $7b02d682eb115277$exports.jsx)("p", {
                children: t("failed_to_load_days")
            });
        default:
            return null;
    }
}








function $5811e076e59ecae1$export$e72bc21110846d41({ title: title, visible: visible = true, blockClassName: blockClassName, after: after, children: children }) {
    if (!visible) return null;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
        className: "container-boxed",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: blockClassName,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: title
                        })
                    }),
                    children
                ]
            }),
            after
        ]
    });
}





parcelRequire("acw62");


const $60bb38810c6aeae8$export$fcfb9784b884236b = {
    insuranceType: [
        "liability",
        "hull",
        "accident"
    ],
    fuelType: [
        "diesel",
        "petrol",
        "gas",
        "electricity"
    ],
    engineDriveType: [
        "shaftdrive",
        "saildrive",
        "z_drive",
        "pod_drive",
        "outboard",
        "jet_drive"
    ],
    generatorType: [
        "power_generator",
        "heating",
        "air_conditioning",
        "warm_water",
        "watermaker"
    ],
    steeringType: [
        "bow_thruster",
        "stern_thruster",
        "self_steering",
        "windvane",
        "autopilot"
    ],
    tankType: [
        "fuel",
        "fuel_daytank",
        "water",
        "gray",
        "waste",
        "gas"
    ],
    rigElement: [
        "mast",
        "main_mast",
        "mizzen_mast",
        "forestay",
        "stay",
        "jib_stay",
        "backstay",
        "runner",
        "baby_stay",
        "kicker",
        "vang",
        "winch"
    ],
    sail: [
        "mainsail",
        "genoa",
        "jib",
        "working_jib",
        "strom_jib",
        "spinnaker",
        "gennaker",
        "code0",
        "parasailor",
        "mizzen",
        "mizzen_staysail",
        "try"
    ],
    sailType: [
        "forestay",
        "mast",
        "mizzen"
    ],
    anchorType: [
        "spade",
        "fishermans",
        "plough",
        "danforth",
        "rollerbar"
    ],
    deviceTypes: {
        "nautical": [
            "analogue_compass",
            "gyro_compass",
            "fluxgate_compass",
            "satellite_compass",
            "chart_plotter",
            "gps",
            "ais",
            "radio",
            "antenna",
            "radar",
            "wind_gauge",
            "autopilot",
            "display_instruments",
            "fuel_gauge",
            "battery_controller",
            "hour_meter",
            "tachometer",
            "logger",
            "sounder",
            "air_temperature",
            "barometer",
            "humidity",
            "weather_receiver",
            "nmea_gateway",
            "nmea_motor_adapter"
        ],
        "electric": [
            "battery",
            "inverter",
            "charger",
            "wind_generator",
            "solar_panel"
        ],
        "safety": [
            "fire_extinguisher",
            "liferaft",
            "lifejacket",
            "lifebelt",
            "lifeline",
            "spare_propeller",
            "emergency_tiller",
            "bilge_pump_manual",
            "bilge_pump_electric",
            "shroud_cutter",
            "radar_reflector",
            "first_aid",
            "fire_blanket",
            "dinghy",
            "dinghy_motor",
            "handheld_radio",
            "epirb"
        ]
    }
};
const $60bb38810c6aeae8$export$aa3f292b19006b4b = {
    attachmentUrl (api, shipId, attachment, cloudSession) {
        return cloudSession ? attachment.url || "" : new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.attachmentDownload({
            params: {
                shipId: shipId,
                attachmentId: attachment.id
            }
        }).url();
    },
    uploadAttachment (api, shipId, attachment) {
        return new (0, $5ad0742384a42800$export$5cea990fb3a4e5e9)(api).noteAttachments.create({
            params: {
                shipId: shipId,
                noteId: 0
            },
            body: {
                attachment: attachment
            }
        }).call();
    },
    // --- Shared ship-data derivations (also consumed by the Print ship views) -------------
    // A predefined enum value is localized (`t(prefix + value)`) only when it is one of
    // the known values; free-text values are shown verbatim. Empty/undefined pass through.
    predefinedText (t, list, value, prefix) {
        return value ? list.includes(value) ? t(`${prefix}${value}`) : value : value;
    },
    // Engines render `engineCount` rows; missing entries fall back to a blank placeholder.
    engineAt (shipData, index) {
        var _a;
        return ((_a = shipData === null || shipData === void 0 ? void 0 : shipData.engines) === null || _a === void 0 ? void 0 : _a[index]) || {
            id: `engine-${index}`,
            number: index + 1,
            nmeaNumber: undefined,
            engineShortName: "",
            manufacturer: "",
            model: "",
            serialNumber: "",
            power: undefined,
            powerUnit: undefined,
            fuelType: "",
            driveType: "",
            propellerType: ""
        };
    },
    crewRoleText (tt, role) {
        switch(role){
            case (0, $dc7739d612f0c536$export$1e4ade51a6368243).none:
                return tt("ship_user_crew_role_none");
            case (0, $dc7739d612f0c536$export$1e4ade51a6368243).crew:
                return tt("ship_user_crew_role_crew");
            case (0, $dc7739d612f0c536$export$1e4ade51a6368243).skipper:
                return tt("ship_user_crew_role_skipper");
            case (0, $dc7739d612f0c536$export$1e4ade51a6368243).owner:
                return tt("ship_user_crew_role_owner");
            default:
                return String(role);
        }
    },
    userLevelText (tt, level) {
        switch(level){
            case (0, $dc7739d612f0c536$export$fe876bf720d558fa).none:
                return tt("ship_user_level_none");
            case (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewCurrent:
                return tt("ship_user_level_viewCurrent");
            case (0, $dc7739d612f0c536$export$fe876bf720d558fa).viewAll:
                return tt("ship_user_level_viewAll");
            case (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent:
                return tt("ship_user_level_editCurrent");
            case (0, $dc7739d612f0c536$export$fe876bf720d558fa).editAll:
                return tt("ship_user_level_editAll");
            case (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary:
                return tt("ship_user_level_primary");
            default:
                return String(level);
        }
    },
    // The crew roles a person can actually be given. `owner` is deliberately absent:
    // it is server-assigned to the ship's creator and can never be granted through
    // the API, so offering it would be a dead option (#1215). Single source for the
    // app view, the catalog harness and the catalog registry.
    selectableCrewRoles: [
        (0, $dc7739d612f0c536$export$1e4ade51a6368243).none,
        (0, $dc7739d612f0c536$export$1e4ade51a6368243).crew,
        (0, $dc7739d612f0c536$export$1e4ade51a6368243).skipper
    ],
    crewRoleOptions (tt) {
        return $60bb38810c6aeae8$export$aa3f292b19006b4b.selectableCrewRoles.map((role)=>(0, $7b02d682eb115277$exports.jsx)("option", {
                value: role,
                children: $60bb38810c6aeae8$export$aa3f292b19006b4b.crewRoleText(tt, role)
            }, role));
    },
    userLevelOptions (tt) {
        return Object.values((0, $dc7739d612f0c536$export$fe876bf720d558fa)).filter((level)=>typeof level === "number").map((level)=>(0, $7b02d682eb115277$exports.jsx)("option", {
                value: level,
                children: $60bb38810c6aeae8$export$aa3f292b19006b4b.userLevelText(tt, level)
            }, level));
    },
    // A row that holds an unknown legacy role still needs a matching `<option>`,
    // or its `<select>` would render blank. The known non-selectable `owner` role
    // is rendered read-only by ShipUserEditView (#1543).
    legacyCrewRoleOption (tt, role) {
        if ($60bb38810c6aeae8$export$aa3f292b19006b4b.selectableCrewRoles.includes(role)) return null;
        return (0, $7b02d682eb115277$exports.jsx)("option", {
            value: role,
            children: $60bb38810c6aeae8$export$aa3f292b19006b4b.crewRoleText(tt, role)
        }, role);
    }
};
const $60bb38810c6aeae8$var$shipDataContext = (0, $5cdac83ab505705b$export$1a6a959df6aea4fa)();
const $60bb38810c6aeae8$export$2de6107c322f2209 = $60bb38810c6aeae8$var$shipDataContext.Context;
const $60bb38810c6aeae8$export$ccf74b7adff24162 = $60bb38810c6aeae8$var$shipDataContext.useGet;


const $459260aa0d243e13$export$619fde2cd2cde3f4 = {
    // The `data` prop is either a raw IShipData (identified by the `mmsi` field) or an
    // IShip whose ship data hangs off `.shipData`.
    resolveShipData (data) {
        const shipData = "mmsi" in data ? data : data.shipData;
        const ship = "mmsi" in data ? undefined : data;
        return {
            shipData: shipData,
            ship: ship
        };
    },
    // Active crew, ordered owner → skipper → crew → none, then by name.
    sortShipUsers (users) {
        return users.filter((user)=>user.active !== 0).toSorted((a, b)=>{
            var _a, _b, _c, _d;
            const roleOrder = {
                [(0, $dc7739d612f0c536$export$1e4ade51a6368243).owner]: 0,
                [(0, $dc7739d612f0c536$export$1e4ade51a6368243).skipper]: 1,
                [(0, $dc7739d612f0c536$export$1e4ade51a6368243).crew]: 2,
                [(0, $dc7739d612f0c536$export$1e4ade51a6368243).none]: 3
            };
            const roleDiff = ((_a = roleOrder[a.shipUserCrewRole]) !== null && _a !== void 0 ? _a : 3) - ((_b = roleOrder[b.shipUserCrewRole]) !== null && _b !== void 0 ? _b : 3);
            return roleDiff !== 0 ? roleDiff : ((_c = a.name) !== null && _c !== void 0 ? _c : "").localeCompare((_d = b.name) !== null && _d !== void 0 ? _d : "");
        });
    },
    // Shared derivations, re-exposed from ShipDataViewData so the Print ship views keep
    // referencing them through PrintShipViewData without duplicating the logic.
    predefinedText: (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).predefinedText,
    engineAt: (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).engineAt,
    crewRoleText: (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).crewRoleText,
    userLevelText: (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).userLevelText
};


function $edaf3093202b3ede$export$9a9a5b2c27549037({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: t("general"),
        blockClassName: "PrintShipView-block-left",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("mmsi"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.mmsi
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("callsign"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.callsign
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("home_port"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.homePort
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("flag"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.flag
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("reg_number"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.regNumber
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("hin"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.hin
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("imo"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.imo
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("build_number"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.yachtBuildNumber
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("vessel_type"),
                        className: "block-field-120",
                        children: (shipData === null || shipData === void 0 ? void 0 : shipData.vesselType) === (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).motor ? app.getT("ShipEditView")("type_motor") : (shipData === null || shipData === void 0 ? void 0 : shipData.vesselType) === (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).sailing ? app.getT("ShipEditView")("type_sailing") : shipData === null || shipData === void 0 ? void 0 : shipData.vesselType
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("yachtbuilder"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.yachtYachtBuilder
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("model_name"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.yachtModelName
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("year"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.yachtYearBuild
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("construction"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.yachtConstruction
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("designer"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.yachtDesigner
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("cel"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.cel
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("cel_persons"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.celPersons
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: t("owner")
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("owner_name"),
                        className: "block-field-270",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.ownerName
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("owner_phone"),
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.ownerPhone
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("owner_email"),
                        className: "block-field-270",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.ownerEmail
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("owner_address"),
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.ownerAddress
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("yacht_club"),
                        className: "block-field-270",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.yachtClubName
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("yacht_club_address"),
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.yachtClubAddress
                    })
                ]
            })
        ]
    });
}








function $e1a67de34b03bc6b$export$d008c6edc824e5dd({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData, ship: ship } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: t("dimensions"),
        blockClassName: "PrintShipView-block-left",
        after: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
            className: "PrintShipView-block-image",
            children: ((shipData === null || shipData === void 0 ? void 0 : shipData.shipType) || (ship === null || ship === void 0 ? void 0 : ship.vesselType)) && (0, $7b02d682eb115277$exports.jsx)("img", {
                src: "/ship-" + ((shipData === null || shipData === void 0 ? void 0 : shipData.shipType) || ((ship === null || ship === void 0 ? void 0 : ship.vesselType) === (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).motor ? "motor-boat" : "sailing-sloop")) + ".svg"
            })
        }),
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("height"),
                        className: "block-field-165",
                        children: [
                            (shipData === null || shipData === void 0 ? void 0 : shipData.height) != null ? shipData.height.toLocaleString(navigator.language) : "",
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.heightUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.height) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).length : "")
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("draft"),
                        className: "block-field-165",
                        children: [
                            (shipData === null || shipData === void 0 ? void 0 : shipData.draft) != null ? shipData.draft.toLocaleString(navigator.language) : "",
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.draftUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.draft) != null ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).length : "")
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("beam"),
                        className: "block-field-165",
                        children: [
                            (shipData === null || shipData === void 0 ? void 0 : shipData.beam) != null ? shipData.beam.toLocaleString(navigator.language) : "",
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.beamUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.beam) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).length : "")
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("length_waterline"),
                        className: "block-field-165",
                        children: [
                            (shipData === null || shipData === void 0 ? void 0 : shipData.lengthWaterline) != null ? shipData.lengthWaterline.toLocaleString(navigator.language) : "",
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.lengthWaterlineUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.lengthWaterline) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).length : "")
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("length_hull"),
                        className: "block-field-165",
                        children: [
                            (shipData === null || shipData === void 0 ? void 0 : shipData.lengthHull) != null ? shipData.lengthHull.toLocaleString(navigator.language) : "",
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.lengthHullUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.lengthHull) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).length : "")
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("length"),
                        className: "block-field-165",
                        children: [
                            (shipData === null || shipData === void 0 ? void 0 : shipData.length) != null ? shipData.length.toLocaleString(navigator.language) : "",
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.lengthUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.length) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).length : "")
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("displacement"),
                        className: "block-field-165",
                        children: [
                            (shipData === null || shipData === void 0 ? void 0 : shipData.displacement) != null ? shipData.displacement.toLocaleString(navigator.language) : "",
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.displacementUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.displacement) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).weight : "")
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("keel_weight"),
                        className: "block-field-165",
                        children: [
                            (shipData === null || shipData === void 0 ? void 0 : shipData.keelWeight) != null ? shipData.keelWeight.toLocaleString(navigator.language) : "",
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.keelWeightUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.keelWeight) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).weight : "")
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("keel_weight_percent"),
                        className: "block-field-165",
                        children: [
                            shipData === null || shipData === void 0 ? void 0 : shipData.keelWeightPercent,
                            (shipData === null || shipData === void 0 ? void 0 : shipData.keelWeightPercent) ? " %" : ""
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("hull_material"),
                        className: "block-field-165",
                        children: [
                            shipData === null || shipData === void 0 ? void 0 : shipData.hullMaterial,
                            " "
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("hull_color"),
                        className: "block-field-165",
                        children: [
                            shipData === null || shipData === void 0 ? void 0 : shipData.hullColor,
                            " "
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("keel_material"),
                        className: "block-field-165",
                        children: [
                            shipData === null || shipData === void 0 ? void 0 : shipData.keelMaterial,
                            " "
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("keel_shape"),
                        className: "block-field-165",
                        children: [
                            shipData === null || shipData === void 0 ? void 0 : shipData.keelShape,
                            " "
                        ]
                    })
                ]
            }),
            (shipData === null || shipData === void 0 ? void 0 : shipData.vesselType) === 2 && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("masts_no"),
                        className: "block-field-165",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.masts
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("rig"),
                        className: "block-field-165",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.rig
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("sail_area_total"),
                        className: "block-field-165",
                        children: [
                            shipData === null || shipData === void 0 ? void 0 : shipData.sailAreaTotal,
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.sailAreaTotalUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.sailAreaTotal) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).surface : "")
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    label: t("special_features"),
                    children: shipData === null || shipData === void 0 ? void 0 : shipData.specialFeatures
                })
            })
        ]
    });
}







function $249ac1a75cc55679$export$bb947994bb75e4f6({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    const visible = !!((shipData === null || shipData === void 0 ? void 0 : shipData.insurances) && shipData.insurances.length > 0);
    return (0, $7b02d682eb115277$exports.jsx)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: t("insurances"),
        visible: visible,
        children: (shipData === null || shipData === void 0 ? void 0 : shipData.insurances) && shipData.insurances.length > 0 && shipData.insurances.map((insurance, index)=>(0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-one-row-list",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("insurance_type"),
                        className: "block-field-150",
                        children: insurance.insuranceType ? (0, $60bb38810c6aeae8$export$fcfb9784b884236b).insuranceType.includes(insurance.insuranceType) ? t(`insurance_${insurance.insuranceType}`) : insurance.insuranceType : insurance.insuranceType
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("insurance_company"),
                        className: "block-field-240",
                        children: insurance.insuranceCompany
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("insurance_number"),
                        className: "block-field-240",
                        children: insurance.insuranceNumber
                    })
                ]
            }, insurance.id || index))
    });
}




var $acw62 = parcelRequire("acw62");





function $555c8b10ebf2429d$export$cf56f4f49f3ea71d({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    const context = (0, $acw62.useContext)((0, $97ac05743b787a86$export$b152308473c555d0));
    const includeShipDataType = (context === null || context === void 0 ? void 0 : context.includeShipDataType) || (0, $97ac05743b787a86$export$bf37da5ca7e88dda).short;
    const visible = includeShipDataType === (0, $97ac05743b787a86$export$bf37da5ca7e88dda).details;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: t("inside"),
        visible: visible,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-separated",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("berth_no"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.berthNo
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("berth_single_no"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.berthSingleNo
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("berth_double_no"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.berthDoubleNo
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("berth_extra_no"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.berthExtraNo
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("cabins_no"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.cabinsNo
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("bath_no"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.bathNo
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("saloon"),
                        className: "block-field-180",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.saloon
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("pantry"),
                        className: "block-field-180",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.pantry
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("cabins"),
                        className: "block-field-180",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.cabins
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("cockpit"),
                        className: "block-field-180",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.cockpit
                    })
                ]
            })
        ]
    });
}








function $d05413c467060c44$export$8bad87a3484e2dab({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    return (0, $7b02d682eb115277$exports.jsx)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: t("engines"),
        children: Array.from(Array((shipData === null || shipData === void 0 ? void 0 : shipData.engineCount) || 0).keys()).map((index)=>{
            const engine = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).engineAt(shipData, index);
            return (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-followed-by-block-row",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("engine#"),
                                className: "block-field-45",
                                children: engine.number
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("engine_nmea_number"),
                                className: "block-field-60",
                                children: engine.nmeaNumber
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("engine_short_name"),
                                className: "block-field-120",
                                children: engine.engineShortName
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("manufacturer"),
                                className: "block-field-210",
                                children: engine.manufacturer
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("model"),
                                className: "block-field-180",
                                children: engine.model
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("serial_number"),
                                children: engine.serialNumber
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-last",
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("power"),
                                className: "block-field-120",
                                children: [
                                    engine.power,
                                    " ",
                                    engine.powerUnit || (engine.power ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).power : "")
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("fuel_type"),
                                className: "block-field-120",
                                children: (0, $459260aa0d243e13$export$619fde2cd2cde3f4).predefinedText(t, (0, $60bb38810c6aeae8$export$fcfb9784b884236b).fuelType, engine.fuelType, "fuel_")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("drive_type"),
                                className: "block-field-120",
                                children: (0, $459260aa0d243e13$export$619fde2cd2cde3f4).predefinedText(t, (0, $60bb38810c6aeae8$export$fcfb9784b884236b).engineDriveType, engine.driveType, "engine_")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("propeller_type"),
                                className: "block-field-120",
                                children: engine.propellerType
                            })
                        ]
                    })
                ]
            }, engine.id);
        })
    });
}




var $acw62 = parcelRequire("acw62");






function $df9c3a8f8d176dee$export$a671297cbc1ae026({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    const context = (0, $acw62.useContext)((0, $97ac05743b787a86$export$b152308473c555d0));
    const includeShipDataType = (context === null || context === void 0 ? void 0 : context.includeShipDataType) || (0, $97ac05743b787a86$export$bf37da5ca7e88dda).short;
    const visible = !!(includeShipDataType === (0, $97ac05743b787a86$export$bf37da5ca7e88dda).details && (shipData === null || shipData === void 0 ? void 0 : shipData.generators) && shipData.generators.length > 0);
    return (0, $7b02d682eb115277$exports.jsx)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: t("generators"),
        visible: visible,
        children: (shipData === null || shipData === void 0 ? void 0 : shipData.generators) && shipData.generators.length > 0 && shipData.generators.map((generator, index)=>(0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-followed-by-block-row",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("generator"),
                                className: "block-field-150",
                                children: (0, $459260aa0d243e13$export$619fde2cd2cde3f4).predefinedText(t, (0, $60bb38810c6aeae8$export$fcfb9784b884236b).generatorType, generator.generatorType, "generator_")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("manufacturer"),
                                className: "block-field-210",
                                children: generator.manufacturer
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("model"),
                                className: "block-field-150",
                                children: generator.model
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("serial_number"),
                                className: "block-field-150",
                                children: generator.serialNumber
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("power"),
                                className: "block-field-90",
                                children: [
                                    generator.power,
                                    " ",
                                    generator.powerUnit || (generator.power ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).power : "")
                                ]
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-last",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("fuel_type"),
                                className: "block-field-150",
                                children: generator.fuelType ? (0, $60bb38810c6aeae8$export$fcfb9784b884236b).fuelType.includes(generator.fuelType) ? t(`fuel_${generator.fuelType}`) : generator.fuelType : generator.fuelType
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("comment"),
                                children: generator.comment
                            })
                        ]
                    })
                ]
            }, generator.id || index))
    });
}




var $acw62 = parcelRequire("acw62");






function $4c2a2cf47f23cc81$export$4614a433ad5b4923({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    const context = (0, $acw62.useContext)((0, $97ac05743b787a86$export$b152308473c555d0));
    const includeShipDataType = (context === null || context === void 0 ? void 0 : context.includeShipDataType) || (0, $97ac05743b787a86$export$bf37da5ca7e88dda).short;
    const visible = !!(includeShipDataType === (0, $97ac05743b787a86$export$bf37da5ca7e88dda).details && (shipData === null || shipData === void 0 ? void 0 : shipData.steeringSystems) && shipData.steeringSystems.length > 0);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: t("steering_systems"),
        visible: visible,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-separated",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("steering_system_main"),
                        className: "block-field-210",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.steeringSystem
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("rudder_no"),
                        className: "block-field-120",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.rudderNumber
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("rudder_shape"),
                        className: "block-field-150",
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.rudderShape
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("rudder_drive"),
                        children: shipData === null || shipData === void 0 ? void 0 : shipData.rudderDrive
                    })
                ]
            }),
            (shipData === null || shipData === void 0 ? void 0 : shipData.steeringSystems) && shipData.steeringSystems.length > 0 && shipData.steeringSystems.map((steeringSystem, index)=>(0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-one-row-list",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("steering_type"),
                            className: "block-field-150",
                            children: steeringSystem.steeringType ? (0, $60bb38810c6aeae8$export$fcfb9784b884236b).steeringType.includes(steeringSystem.steeringType) ? t(`steering_${steeringSystem.steeringType}`) : steeringSystem.steeringType : steeringSystem.steeringType
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("manufacturer"),
                            className: "block-field-210",
                            children: steeringSystem.manufacturer
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("model"),
                            className: "block-field-150",
                            children: steeringSystem.model
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("power"),
                            className: "block-field-75",
                            children: [
                                steeringSystem.power,
                                " ",
                                steeringSystem.powerUnit || (steeringSystem.power ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).power : "")
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("comment"),
                            children: steeringSystem.comment
                        })
                    ]
                }, steeringSystem.id || index))
        ]
    });
}




var $acw62 = parcelRequire("acw62");






function $ffc0860ae72afa48$export$f2b55d6eda579802({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    const context = (0, $acw62.useContext)((0, $97ac05743b787a86$export$b152308473c555d0));
    const includeShipDataType = (context === null || context === void 0 ? void 0 : context.includeShipDataType) || (0, $97ac05743b787a86$export$bf37da5ca7e88dda).short;
    const visible = !!(includeShipDataType === (0, $97ac05743b787a86$export$bf37da5ca7e88dda).details && ((shipData === null || shipData === void 0 ? void 0 : shipData.tankFuelNo) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankFuelSize) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankWaterNo) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankWaterSize) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankGrayNo) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankGraySize) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankWasteNo) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankWasteSize) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankGasNo) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankGasSize) || (shipData === null || shipData === void 0 ? void 0 : shipData.tanks) && shipData.tanks.length > 0));
    return (0, $7b02d682eb115277$exports.jsxs)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: t("tanks"),
        visible: visible,
        children: [
            ((shipData === null || shipData === void 0 ? void 0 : shipData.tankFuelNo) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankFuelSize) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankWaterNo) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankWaterSize) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankGrayNo) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankGraySize) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankWasteNo) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankWasteSize) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankGasNo) || (shipData === null || shipData === void 0 ? void 0 : shipData.tankGasSize)) && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-separated tank-overview",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("tank_fuel_no"),
                        className: "block-field-150",
                        children: [
                            shipData === null || shipData === void 0 ? void 0 : shipData.tankFuelNo,
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.tankFuelNo) ? t("tanks_unit") : "",
                            " ",
                            shipData === null || shipData === void 0 ? void 0 : shipData.tankFuelSize,
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.tankFuelSizeUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.tankFuelNo) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).volume : "")
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("tank_water_no"),
                        className: "block-field-150",
                        children: [
                            shipData === null || shipData === void 0 ? void 0 : shipData.tankWaterNo,
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.tankWaterNo) ? t("tanks_unit") : "",
                            shipData === null || shipData === void 0 ? void 0 : shipData.tankWaterSize,
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.tankWaterSizeUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.tankWaterNo) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).volume : "")
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("tank_gray_no"),
                        className: "block-field-150",
                        children: [
                            shipData === null || shipData === void 0 ? void 0 : shipData.tankGrayNo,
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.tankGrayNo) ? t("tanks_unit") : "",
                            shipData === null || shipData === void 0 ? void 0 : shipData.tankGraySize,
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.tankGraySizeUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.tankGrayNo) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).volume : "")
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("tank_waste_no"),
                        className: "block-field-150",
                        children: [
                            shipData === null || shipData === void 0 ? void 0 : shipData.tankWasteNo,
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.tankWasteNo) ? t("tanks_unit") : "",
                            shipData === null || shipData === void 0 ? void 0 : shipData.tankWasteSize,
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.tankWasteSizeUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.tankWasteNo) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).volume : "")
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("tank_gas_no"),
                        className: "block-field-150",
                        children: [
                            shipData === null || shipData === void 0 ? void 0 : shipData.tankGasNo,
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.tankGasNo) ? t("tanks_unit") : "",
                            shipData === null || shipData === void 0 ? void 0 : shipData.tankGasSize,
                            " ",
                            (shipData === null || shipData === void 0 ? void 0 : shipData.tankGasSizeUnit) || ((shipData === null || shipData === void 0 ? void 0 : shipData.tankGasNo) ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).volume : "")
                        ]
                    })
                ]
            }),
            (shipData === null || shipData === void 0 ? void 0 : shipData.tanks) && shipData.tanks.length > 0 && shipData.tanks.map((tank, index)=>(0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-one-row-list tank-details",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("tank"),
                            className: "block-field-120",
                            children: tank.tankType ? (0, $60bb38810c6aeae8$export$fcfb9784b884236b).tankType.includes(tank.tankType) ? t(`tank_${tank.tankType}`) : tank.tankType : tank.tankType
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("size"),
                            className: "block-field-60",
                            children: [
                                tank.capacity,
                                " ",
                                tank.capacityUnit || (tank.capacity ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).volume : "")
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("place_installation"),
                            className: "block-field-240",
                            children: tank.placeInstallation
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("comment"),
                            children: tank.comment
                        })
                    ]
                }, tank.id || index))
        ]
    });
}




var $acw62 = parcelRequire("acw62");






function $dd69a6ccfb32eb0c$export$f99559ee543443de({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    const context = (0, $acw62.useContext)((0, $97ac05743b787a86$export$b152308473c555d0));
    const includeShipDataType = (context === null || context === void 0 ? void 0 : context.includeShipDataType) || (0, $97ac05743b787a86$export$bf37da5ca7e88dda).short;
    const visible = !!(includeShipDataType === (0, $97ac05743b787a86$export$bf37da5ca7e88dda).details && (shipData === null || shipData === void 0 ? void 0 : shipData.rigElements) && shipData.rigElements.length > 0);
    return (0, $7b02d682eb115277$exports.jsx)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: t("mast_rig"),
        visible: visible,
        children: (shipData === null || shipData === void 0 ? void 0 : shipData.rigElements) && shipData.rigElements.map((rigElement, index)=>(0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-followed-by-block-row",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("rig_element"),
                                className: "block-field-150",
                                children: rigElement.rigElement ? (0, $60bb38810c6aeae8$export$fcfb9784b884236b).rigElement.includes(rigElement.rigElement) ? t(`rig_${rigElement.rigElement}`) : rigElement.rigElement : rigElement.rigElement
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("manufacturer"),
                                className: "block-field-210",
                                children: rigElement.manufacturer
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("model"),
                                className: "block-field-150",
                                children: rigElement.model
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("serial_number"),
                                className: "block-field-150",
                                children: rigElement.serialNumber
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("size_height"),
                                className: "block-field-75",
                                children: [
                                    rigElement.size,
                                    " ",
                                    rigElement.sizeUnit || (rigElement.size ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).length : "")
                                ]
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-last",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("place_installation"),
                                className: "block-field-150",
                                children: rigElement.placeInstallation
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("comment"),
                                children: rigElement.comment
                            })
                        ]
                    })
                ]
            }, rigElement.id || index))
    });
}




var $acw62 = parcelRequire("acw62");






function $81844e64f6c0b222$export$f40b0c0514bb85da({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    const context = (0, $acw62.useContext)((0, $97ac05743b787a86$export$b152308473c555d0));
    const includeShipDataType = (context === null || context === void 0 ? void 0 : context.includeShipDataType) || (0, $97ac05743b787a86$export$bf37da5ca7e88dda).short;
    const visible = includeShipDataType === (0, $97ac05743b787a86$export$bf37da5ca7e88dda).details;
    return (0, $7b02d682eb115277$exports.jsx)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: t("sails"),
        visible: visible,
        children: (shipData === null || shipData === void 0 ? void 0 : shipData.sails) && shipData.sails.length > 0 && shipData.sails.map((sail, index)=>(0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-one-row-list",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("sail"),
                        className: "block-field-90",
                        children: sail.sail ? (0, $60bb38810c6aeae8$export$fcfb9784b884236b).sail.includes(sail.sail) ? t(`sail_${sail.sail}`) : sail.sail : sail.sail
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("sail_type"),
                        className: "block-field-90",
                        children: sail.sailType ? (0, $60bb38810c6aeae8$export$fcfb9784b884236b).sailType.includes(sail.sailType) ? t(`sail_${sail.sailType}`) : sail.sailType : sail.sailType
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("sail_reefs_no"),
                        className: "block-field-90",
                        children: sail.reefNo !== undefined ? t(`sail_${sail.reefNo}`) : sail.reefNo
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("sail_size"),
                        className: "block-field-75",
                        children: [
                            sail.size,
                            " ",
                            sail.sizeUnit || (sail.size ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).surface : "")
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("manufacturer"),
                        className: "block-field-210",
                        children: sail.manufacturer
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("comment"),
                        className: "",
                        children: sail.comment
                    })
                ]
            }, sail.id || index))
    });
}




var $acw62 = parcelRequire("acw62");





function $9c5c1c69c9765e96$export$1c49f039725521ee({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    const context = (0, $acw62.useContext)((0, $97ac05743b787a86$export$b152308473c555d0));
    const includeShipDataType = (context === null || context === void 0 ? void 0 : context.includeShipDataType) || (0, $97ac05743b787a86$export$bf37da5ca7e88dda).short;
    if (includeShipDataType !== (0, $97ac05743b787a86$export$bf37da5ca7e88dda).details) return null;
    return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            "electric",
            "nautical",
            "safety"
        ].map((type)=>{
            var _a;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
            const devices = (_a = shipData === null || shipData === void 0 ? void 0 : shipData.devices) === null || _a === void 0 ? void 0 : _a[type];
            if (!devices || devices.length === 0) return null;
            return (0, $7b02d682eb115277$exports.jsx)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
                title: t(`${type}_equipment`),
                children: devices.map((device, index)=>{
                    var _a;
                    return (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "block-row-followed-by-block-row",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("device"),
                                        className: "block-field-150",
                                        children: device.deviceType ? ((_a = (0, $60bb38810c6aeae8$export$fcfb9784b884236b).deviceTypes[type]) === null || _a === void 0 ? void 0 : _a.includes(device.deviceType)) ? t(`device_${type}_${device.deviceType}`) : device.deviceType : device.deviceType
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("manufacturer"),
                                        className: "block-field-210",
                                        children: device.manufacturer
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("model"),
                                        className: "block-field-150",
                                        children: device.model
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("serial_number"),
                                        className: "block-field-120",
                                        children: device.serialNumber
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("date_installation"),
                                        className: "block-field-120",
                                        children: device.dateInstallation
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "block-row-last",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("place_installation"),
                                        className: "block-field-150",
                                        children: device.placeInstallation
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("comment"),
                                        children: device.specialFeatures
                                    })
                                ]
                            })
                        ]
                    }, device.id || index);
                })
            }, type);
        })
    });
}




var $acw62 = parcelRequire("acw62");






function $6a5c04f3ce2b36eb$export$6d42e3c7fe033f9c({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    const context = (0, $acw62.useContext)((0, $97ac05743b787a86$export$b152308473c555d0));
    const includeShipDataType = (context === null || context === void 0 ? void 0 : context.includeShipDataType) || (0, $97ac05743b787a86$export$bf37da5ca7e88dda).short;
    const visible = !!(includeShipDataType === (0, $97ac05743b787a86$export$bf37da5ca7e88dda).details && (shipData === null || shipData === void 0 ? void 0 : shipData.anchors) && shipData.anchors.length > 0);
    return (0, $7b02d682eb115277$exports.jsx)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: t("anchors"),
        visible: visible,
        children: (shipData === null || shipData === void 0 ? void 0 : shipData.anchors) && shipData.anchors.length > 0 && shipData.anchors.map((anchor, index)=>(0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("anchor_type"),
                                className: "block-field-150",
                                children: anchor.anchorType ? (0, $60bb38810c6aeae8$export$fcfb9784b884236b).anchorType.includes(anchor.anchorType) ? t(`anchor_${anchor.anchorType}`) : anchor.anchorType : anchor.anchorType
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("anchor_weight"),
                                className: "block-field-120",
                                children: [
                                    anchor.weight,
                                    " ",
                                    anchor.weightUnit || (anchor.weight ? (0, $1b996d42088c0aac$export$5de13be7a3ac8b6e).weight : "")
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("anchor_location"),
                                className: "block-field-150",
                                children: anchor.placeInstallation ? t(anchor.placeInstallation) : anchor.placeInstallation
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("anchor_chain"),
                                className: "block-field-210",
                                children: anchor.chain
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("anchor_chain_lead"),
                                className: "block-field-150",
                                children: anchor.chainLead
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-last",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("anchor_windlass"),
                                className: "block-field-150",
                                children: anchor.windlass
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("anchor_windless_drive"),
                                className: "block-field-120",
                                children: anchor.windlassDrive
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("anchor_windless_manfacturer"),
                                children: anchor.windlassManufacturer
                            })
                        ]
                    })
                ]
            }, anchor.id || index))
    });
}




var $acw62 = parcelRequire("acw62");





function $919b6ab3c3ad41c6$export$b6a4746332632081({ data: data }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { shipData: shipData } = (0, $459260aa0d243e13$export$619fde2cd2cde3f4).resolveShipData(data);
    const context = (0, $acw62.useContext)((0, $97ac05743b787a86$export$b152308473c555d0));
    const includeShipDataType = (context === null || context === void 0 ? void 0 : context.includeShipDataType) || (0, $97ac05743b787a86$export$bf37da5ca7e88dda).short;
    const visible = !!(includeShipDataType === (0, $97ac05743b787a86$export$bf37da5ca7e88dda).details && (shipData === null || shipData === void 0 ? void 0 : shipData.otherEquipments) && shipData.otherEquipments.length > 0);
    return (0, $7b02d682eb115277$exports.jsx)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: t("other_equipment"),
        visible: visible,
        children: (shipData === null || shipData === void 0 ? void 0 : shipData.otherEquipments) && shipData.otherEquipments.length > 0 && shipData.otherEquipments.map((otherEquipment, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-last",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    className: "block-field-270",
                    children: [
                        otherEquipment.equipment,
                        " "
                    ]
                })
            }, otherEquipment.id || index))
    });
}




var $acw62 = parcelRequire("acw62");





function $34534f3f31b516cf$export$1b6ae9e289398539({ users: users }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const tt = app.getT("ShipSettingsView");
    const context = (0, $acw62.useContext)((0, $97ac05743b787a86$export$b152308473c555d0));
    const includeUserList = (context === null || context === void 0 ? void 0 : context.includeUserList) || false;
    const getCrewRoleText = (role)=>(0, $459260aa0d243e13$export$619fde2cd2cde3f4).crewRoleText(tt, role);
    return (0, $7b02d682eb115277$exports.jsx)((0, $5811e076e59ecae1$export$e72bc21110846d41), {
        title: tt("tab_ship_user"),
        visible: includeUserList,
        blockClassName: "ShipUserPrintView",
        children: (0, $459260aa0d243e13$export$619fde2cd2cde3f4).sortShipUsers(users).map((user, index)=>(0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "ShipUserPrintView-row block-row-no_labels",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: index === 0 ? tt("user_name") : undefined,
                        className: "block-field-210",
                        children: user.name
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: index === 0 ? tt("user_shortname") : undefined,
                        className: "block-field-120",
                        children: user.shortname
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: index === 0 ? tt("user_crew_role") : undefined,
                        className: "block-field-120",
                        children: getCrewRoleText(user.shipUserCrewRole)
                    })
                ]
            }, user.id || index))
    });
}




function $01fb8cb77343d873$export$945e99872bf9d48d({ data: data, users: users }) {
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "PrintShipView",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $edaf3093202b3ede$export$9a9a5b2c27549037), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $e1a67de34b03bc6b$export$d008c6edc824e5dd), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $249ac1a75cc55679$export$bb947994bb75e4f6), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $555c8b10ebf2429d$export$cf56f4f49f3ea71d), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $d05413c467060c44$export$8bad87a3484e2dab), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $df9c3a8f8d176dee$export$a671297cbc1ae026), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $4c2a2cf47f23cc81$export$4614a433ad5b4923), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $ffc0860ae72afa48$export$f2b55d6eda579802), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $dd69a6ccfb32eb0c$export$f99559ee543443de), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $81844e64f6c0b222$export$f40b0c0514bb85da), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $9c5c1c69c9765e96$export$1c49f039725521ee), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $6a5c04f3ce2b36eb$export$6d42e3c7fe033f9c), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $919b6ab3c3ad41c6$export$b6a4746332632081), {
                data: data
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $34534f3f31b516cf$export$1b6ae9e289398539), {
                users: users
            })
        ]
    });
}



function $cd7720537de6f762$export$8d6695a68fe03388(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const shipView = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    const [data, setData] = (0, $acw62.useState)(undefined);
    const [includeTripData, setIncludeTripData] = (0, $acw62.useState)(true);
    const [includeTripDayListType, setIncludeTripDayListType] = (0, $acw62.useState)((0, $872aa31e93f7b7c8$export$20c941d241cbcd74).short);
    const [includeJournal, setIncludeJournal] = (0, $acw62.useState)(false);
    const [includeTechnical, setIncludeTechnical] = (0, $acw62.useState)(false);
    const [includeDayTrack, setIncludeDayTrack] = (0, $acw62.useState)(false);
    const [includeDayForecast, setIncludeDayForecast] = (0, $acw62.useState)(false);
    const [includeDayJournal, setIncludeDayJournal] = (0, $acw62.useState)(false);
    const [includeDayTechnical, setIncludeDayTechnical] = (0, $acw62.useState)(false);
    const [includeDayWatchplan, setIncludeDayWatchplan] = (0, $acw62.useState)(false);
    const [includeLogs, setIncludeLogs] = (0, $acw62.useState)(false);
    const [includeEdits, setIncludeEdits] = (0, $acw62.useState)(false);
    const [includeDayLogListType, setIncludeDayLogListType] = (0, $acw62.useState)((0, $872aa31e93f7b7c8$export$512aa893c9e7d615).short);
    const [includeShipDataType, setIncludeShipDataType] = (0, $acw62.useState)((0, $97ac05743b787a86$export$bf37da5ca7e88dda).short);
    const [includeUserList, setIncludeUserList] = (0, $acw62.useState)(false);
    const _buildData = (0, $acw62.useCallback)(()=>{}, []);
    const load = (0, $acw62.useCallback)(async ()=>{
        var _a;
        switch(shipView.printMode){
            case (0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).cruise:
                {
                    const printCruise = shipView.printRoot;
                    const cruiseId = printCruise.id;
                    const cruise = await (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).loadCruise(app.apiClient, ship.id, cruiseId);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
                    const calculation = cruise.calculation;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
                    let cruiseCalculations = [];
                    if (calculation) cruiseCalculations = [
                        calculation
                    ];
                    const data = {
                        cruise: app.dataWithCalculations([
                            cruise.cruise
                        ], cruiseCalculations, cruise.notes, cruise.attachments, (n)=>n.cruiseId)[0],
                        cruises: [],
                        tracks: [],
                        trips: [],
                        tripLists: [],
                        days: [],
                        dayLists: [],
                        logs: [],
                        logsLists: []
                    };
                    const trips = await (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).loadTrips(app.apiClient, ship.id, cruiseId);
                    if (trips.trips) data.trips = app.dataWithCalculations(trips.trips, trips.calculations, trips.notes, trips.attachments, (n)=>n.tripId).toSorted((a, b)=>a.id - b.id);
                    const tracks = await (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).loadCruiseTrack(app.apiClient, ship.id, cruiseId);
                    if (tracks.tracks) data.tracks = tracks.tracks;
                    setData(data);
                    break;
                }
            case (0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).trips:
                {
                    const printTrips = shipView.printRoot;
                    const tripsCruiseId = printTrips.id;
                    const tripsData = {
                        cruise: undefined,
                        cruises: [],
                        tracks: [],
                        trips: [],
                        tripLists: [],
                        days: [],
                        dayLists: [],
                        logs: [],
                        logsLists: []
                    };
                    const tripsResponse = await (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).loadTrips(app.apiClient, ship.id, tripsCruiseId);
                    if (tripsResponse.trips) {
                        const allTrips = app.dataWithCalculations(tripsResponse.trips, tripsResponse.calculations, tripsResponse.notes, tripsResponse.attachments, (n)=>n.tripId).toSorted((a, b)=>a.id - b.id);
                        tripsData.trips = shipView.printTripId ? allTrips.filter((t)=>t.id === shipView.printTripId) : allTrips;
                    }
                    const tripsTracks = await (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).loadCruiseTrack(app.apiClient, ship.id, tripsCruiseId);
                    if (tripsTracks.tracks) tripsData.tracks = tripsTracks.tracks;
                    let dayLists = [];
                    for (const trip of tripsData.trips){
                        const tripDays = await (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).loadTripDays(app.apiClient, ship.id, trip.id);
                        if (tripDays.days) dayLists = [
                            ...dayLists,
                            ...app.dataWithCalculations((0, $872aa31e93f7b7c8$export$4caba1eb391c1000)(tripDays.days), tripDays.calculations, tripDays.notes, tripDays.attachments, (n)=>n.dayId)
                        ];
                    }
                    tripsData.dayLists = dayLists.toSorted((a, b)=>a.day - b.day);
                    let days = [];
                    let tripsStatuses = [];
                    for (const trip of tripsData.trips){
                        const tripDays = await (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).loadTripDays(app.apiClient, ship.id, trip.id);
                        if (tripDays.days) {
                            const datedDays = (0, $872aa31e93f7b7c8$export$4caba1eb391c1000)(tripDays.days);
                            days = [
                                ...days,
                                ...app.dataWithCalculations(datedDays, tripDays.calculations, tripDays.notes, tripDays.attachments, (n)=>n.dayId)
                            ];
                            // Load statuses for each day
                            for (const day of datedDays){
                                const dayLogs = await (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).loadDayLogs(app.apiClient, ship.id, day.id);
                                if (dayLogs.statuses) tripsStatuses = [
                                    ...tripsStatuses,
                                    ...dayLogs.statuses
                                ];
                            }
                        }
                    }
                    tripsData.days = days.toSorted((a, b)=>a.day - b.day);
                    tripsData.statuses = tripsStatuses;
                    setData(tripsData);
                    break;
                }
            case (0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).days:
                {
                    const printDays = shipView.printRoot;
                    const tripId = (_a = shipView.printTripId) !== null && _a !== void 0 ? _a : printDays.id;
                    const daysData = {
                        cruise: undefined,
                        cruises: [],
                        tracks: [],
                        trips: [],
                        tripLists: [],
                        days: [],
                        dayLists: [],
                        logs: [],
                        logsLists: []
                    };
                    const daysResponse = await (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).loadTripDays(app.apiClient, ship.id, tripId);
                    if (daysResponse.days) {
                        const allDays = app.dataWithCalculations((0, $872aa31e93f7b7c8$export$4caba1eb391c1000)(daysResponse.days), daysResponse.calculations, daysResponse.notes, daysResponse.attachments, (n)=>n.dayId).toSorted((a, b)=>a.day - b.day);
                        daysData.days = shipView.printDayId ? allDays.filter((d)=>d.id === shipView.printDayId) : allDays;
                    }
                    const daysTracks = await (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).loadTripTrack(app.apiClient, ship.id, tripId);
                    if (daysTracks.tracks) daysData.tracks = daysTracks.tracks;
                    let daysLogs = [];
                    let daysStatuses = [];
                    // The day's own edit history rides the logs response (see `logs.list`), and a
                    // day-edit log entry needs it to say who came aboard or left (issue #1285).
                    let daysAuditLogEdits = [];
                    for (const day of daysData.days){
                        const dayLogs = await (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).loadDayLogs(app.apiClient, ship.id, day.id);
                        if (dayLogs.logs) daysLogs = [
                            ...daysLogs,
                            ...app.dataWithCalculations(dayLogs.logs, dayLogs.calculations)
                        ];
                        if (dayLogs.statuses) daysStatuses = [
                            ...daysStatuses,
                            ...dayLogs.statuses
                        ];
                        if (dayLogs.auditLogEdits) daysAuditLogEdits = [
                            ...daysAuditLogEdits,
                            ...dayLogs.auditLogEdits
                        ];
                    }
                    daysData.logs = daysLogs.toSorted((a, b)=>a.time - b.time);
                    daysData.statuses = daysStatuses;
                    daysData.auditLogEdits = daysAuditLogEdits;
                    setData(daysData);
                    break;
                }
            case (0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).ship:
                {
                    const shipAttachmentsResult = await (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).loadShipAttachments(app.apiClient, ship.id);
                    const shipWithAttachments = ship.shipData ? Object.assign(Object.assign({}, ship), {
                        shipData: Object.assign(Object.assign({}, ship.shipData), {
                            attachments: shipAttachmentsResult.attachments || []
                        })
                    }) : ship;
                    const shipData = {
                        cruise: undefined,
                        cruises: [],
                        ship: shipWithAttachments,
                        tracks: [],
                        trips: [],
                        tripLists: [],
                        days: [],
                        dayLists: [],
                        logs: [],
                        logsLists: []
                    };
                    setData(shipData);
                    break;
                }
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        load().catch(console.error);
    }, []);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const content = (0, $acw62.useMemo)(()=>{
        const kind = (0, $872aa31e93f7b7c8$export$2308c06cf1db77db).contentKind(shipView.printMode, data);
        if (kind === (0, $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1).none) return undefined;
        if (kind === (0, $872aa31e93f7b7c8$export$1e9c6262d4b9a8d1).ship) return (0, $7b02d682eb115277$exports.jsx)((0, $01fb8cb77343d873$export$945e99872bf9d48d), {
            data: data.ship || ship,
            users: shipUsers || []
        });
        return (0, $7b02d682eb115277$exports.jsx)((0, $dcabf49b79516d7b$export$340b7e322cccb54d), {
            printMode: shipView.printMode,
            data: data
        });
    }, [
        data,
        shipUsers
    ]);
    const context = {
        data: data,
        includeTripData: includeTripData,
        setIncludeTripData: setIncludeTripData,
        includeTripDayListType: includeTripDayListType,
        setIncludeTripDayListType: setIncludeTripDayListType,
        includeJournal: includeJournal,
        setIncludeJournal: setIncludeJournal,
        includeTechnical: includeTechnical,
        setIncludeTechnical: setIncludeTechnical,
        includeDayTrack: includeDayTrack,
        setIncludeDayTrack: setIncludeDayTrack,
        includeDayForecast: includeDayForecast,
        setIncludeDayForecast: setIncludeDayForecast,
        includeDayJournal: includeDayJournal,
        setIncludeDayJournal: setIncludeDayJournal,
        includeDayTechnical: includeDayTechnical,
        setIncludeDayTechnical: setIncludeDayTechnical,
        includeDayWatchplan: includeDayWatchplan,
        setIncludeDayWatchplan: setIncludeDayWatchplan,
        includeLogs: includeLogs,
        setIncludeLogs: setIncludeLogs,
        includeEdits: includeEdits,
        setIncludeEdits: setIncludeEdits,
        includeDayLogListType: includeDayLogListType,
        setIncludeDayLogListType: setIncludeDayLogListType
    };
    const contextShip = {
        includeShipData: true,
        setIncludeShipData: ()=>{},
        includeShipDataType: includeShipDataType,
        setIncludeShipDataType: setIncludeShipDataType,
        includeUserList: includeUserList,
        setIncludeUserList: setIncludeUserList,
        data: ship
    };
    // Main layout of print
    return (0, $7b02d682eb115277$exports.jsx)((0, $872aa31e93f7b7c8$export$ea540162690f0605).Provider, {
        value: context,
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $97ac05743b787a86$export$b152308473c555d0).Provider, {
            value: contextShip,
            children: [
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "Print-settings no-print",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $ee4e6412241ac623$export$b63d5cacf60be47e), {
                        tripId: shipView.printTripId
                    })
                }),
                (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "print",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $34b30b1a8e331e95$export$678a3d30f85646bd), {}),
                        data && content ? content : (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
                    ]
                })
            ]
        })
    });
}





var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");



var $69cef99f64317d68$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $69cef99f64317d68$export$5a852e45fb1b6e61(_a) {
    var _b;
    var { info: info, title: title, buttonClass: buttonClass } = _a, menuProps = $69cef99f64317d68$var$__rest(_a, [
        "info",
        "title",
        "buttonClass"
    ]);
    const surface = (_b = info.surface) !== null && _b !== void 0 ? _b : "outlined";
    return (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), Object.assign({
        button: (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                    className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                        "ShipView-status-marker",
                        info.class
                    ]),
                    icon: info.icon
                }),
                " ",
                title
            ]
        }),
        buttonClass: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "MenuStatusButton",
            `MenuStatusButton-${surface}`,
            info.class,
            buttonClass
        ])
    }, menuProps));
}






// ShipOverlayContentView moved into Views/Ship/OverlayContentView.tsx. This thin re-export
// barrel keeps the original `./ShipOverlayContentView` import path working for external
// references (e.g. MenuShip/MenuSync/MenuNMEA, FocusView, CruiseCalendarView, and their
// tests, which mock this module) outside the Ship hub.


var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");
function $4be45b24a899ae38$export$5315996935894f9d(deps = []) {
    const [showScrollButton, setShowScrollButton] = (0, $acw62.useState)(false);
    const [isAtBottom, setIsAtBottom] = (0, $acw62.useState)(true);
    const bodyRef = (0, $acw62.useRef)(null);
    const checkScroll = (0, $acw62.useCallback)(()=>{
        const body = bodyRef.current;
        if (!body) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = body;
        const hasScroll = scrollHeight > clientHeight + 5;
        const atBottom = scrollHeight - scrollTop - clientHeight < 10;
        setShowScrollButton(hasScroll && !atBottom);
        setIsAtBottom(atBottom || !hasScroll);
    }, []);
    const handleScrollMore = (0, $acw62.useCallback)(()=>{
        const body = bodyRef.current;
        if (!body) return;
        const scrollAmount = body.clientHeight * 0.75;
        body.scrollBy({
            top: scrollAmount,
            behavior: "smooth"
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(checkScroll, 100);
        const body = bodyRef.current;
        if (!body) return;
        const resizeObserver = new ResizeObserver(checkScroll);
        resizeObserver.observe(body);
        body.addEventListener("scroll", checkScroll);
        return ()=>{
            clearTimeout(timer);
            resizeObserver.disconnect();
            body.removeEventListener("scroll", checkScroll);
        };
    }, [
        checkScroll,
        ...deps
    ]);
    return {
        bodyRef: bodyRef,
        showScrollButton: showScrollButton,
        isAtBottom: isAtBottom,
        handleScrollMore: handleScrollMore
    };
}




function $403f1eee91546a91$export$1beabfbeae7b7782({ isAtBottom: isAtBottom, showScrollButton: showScrollButton, handleScrollMore: handleScrollMore, readMoreLabel: readMoreLabel }) {
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `Overlay-footer ${isAtBottom ? "at-bottom" : ""}`,
        children: showScrollButton && (0, $7b02d682eb115277$exports.jsxs)("button", {
            className: "scroll-more-button",
            onClick: handleScrollMore,
            children: [
                (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: readMoreLabel
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowDown
                })
            ]
        })
    });
}















const $6551127e6af549ec$export$d90d903c24f290e1 = {
    loadNmea (api) {
        return new (0, $ae9d2fa06c9a6333$export$a708238267c47186)(api).nmea.get({
            params: {}
        }).call();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    connectNmea (api, values) {
        return new (0, $ae9d2fa06c9a6333$export$a708238267c47186)(api).nmea.connect({
            params: {},
            body: values
        }).call();
    },
    loadStatus (api) {
        return new (0, $5094ab6cf9038f1f$export$3565eb3d00ca5a74)(api).status.get({
            params: {}
        }).call();
    },
    disconnectNmea (api) {
        return new (0, $ae9d2fa06c9a6333$export$a708238267c47186)(api).nmea.disconnect({
            params: {}
        }).call();
    },
    setNativePressure (api, enabled) {
        const nmea = new (0, $ae9d2fa06c9a6333$export$a708238267c47186)(api).nmea;
        return (enabled ? nmea.enableBaro({
            params: {}
        }) : nmea.disableBaro({
            params: {}
        })).call();
    },
    // #1113: snapshots the app's always-on rolling buffer of raw received NMEA bytes
    // and uploads it as a device debug trace (raw log plus an inline summary of the
    // sentences/PGNs seen) so support can inspect what the instruments actually sent.
    // Nothing to send in the request -- the app holds the bytes already.
    uploadDebugCapture (api) {
        return new (0, $8c52e5243d6ffa2a$export$6f8605d66cd2f9d5)(api).debugNmea.upload({
            params: {}
        }).call();
    },
    // Button label for the current debug-capture status, falling back to the idle
    // label. The button debounces re-clicks by staying disabled and relabelled while
    // an upload is in flight (the same pattern as AboutView's upload-app-data button).
    debugCaptureLabel (status, t) {
        switch(status){
            case "sending":
                return t("capture_sending");
            case "success":
                return t("capture_success");
            case "error":
                return t("capture_error");
            default:
                return t("capture");
        }
    },
    // Mirror of the model-side NavigationThresholds.engineIdleActive ordering
    // (engineStop < engineStart < engineIdleRpm): reject configurations the
    // calculation half would silently ignore. Missing values are skipped so a
    // partially-filled form doesn't error. Returns a translation-key suffix
    // (rendered via t("error_" + key)) or undefined when valid.
    validateEngineRpm (stop, start, idle, idleEnabled) {
        if (stop != null && start != null && stop >= start) return "engine_rpm_order";
        if (idleEnabled && start != null && idle != null && start >= idle) return "engine_idle_rpm";
        return undefined;
    },
    // The status for an instrument entry: the first entry when given an array, and
    // undefined when the entry (or a required attribute) is missing.
    nmeaEntryStatus (entry, attribute) {
        if (!entry) return undefined;
        if (Array.isArray(entry)) entry = entry[0];
        if (!entry) return undefined;
        if (attribute && entry[attribute] == undefined) return undefined;
        return {
            source: entry.source,
            receivedAt: entry.receivedAt
        };
    },
    // Like nmeaEntryStatus but restricted to a specific source: picks the matching
    // entry from an array, or drops a single entry whose source differs.
    nmeaEntryStatusForSource (entry, source, attribute) {
        if (!entry) return undefined;
        if (Array.isArray(entry)) entry = entry.find((e)=>e.source == source);
        else if (entry.source != source) return undefined;
        if (!entry) return undefined;
        if (attribute && entry[attribute] == undefined) return undefined;
        return {
            source: entry.source,
            receivedAt: entry.receivedAt
        };
    },
    // #1027 (tracker #976): the full status-check map for the test-data tab. Each check
    // additively falls back to the corresponding `data.n2k.*` reading when the 0183
    // field is absent, so an N2K-only connection lights up the same checks a 0183
    // one would. `native_gps`/`native_air_pressure`/`water_temperature` stay
    // 0183-only: N2K entries never have `source == .native` (no N2K native-sensor
    // path exists).
    buildStatusChecks (data, engines) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        const status = $6551127e6af549ec$export$d90d903c24f290e1.nmeaEntryStatus;
        const statusForSource = $6551127e6af549ec$export$d90d903c24f290e1.nmeaEntryStatusForSource;
        return Object.assign(Object.assign({
            utc: (_a = status(data === null || data === void 0 ? void 0 : data.navigation, "time")) !== null && _a !== void 0 ? _a : status((_b = data === null || data === void 0 ? void 0 : data.n2k) === null || _b === void 0 ? void 0 : _b.systemTime, "time"),
            navigation_gps: (_c = status(data === null || data === void 0 ? void 0 : data.navigation, "lat")) !== null && _c !== void 0 ? _c : status((_d = data === null || data === void 0 ? void 0 : data.n2k) === null || _d === void 0 ? void 0 : _d.position, "latitude"),
            navigation_course: (_e = status(data === null || data === void 0 ? void 0 : data.heading)) !== null && _e !== void 0 ? _e : status((_f = data === null || data === void 0 ? void 0 : data.n2k) === null || _f === void 0 ? void 0 : _f.heading),
            navigation_sog: (_g = status(data === null || data === void 0 ? void 0 : data.navigation, "sog")) !== null && _g !== void 0 ? _g : status((_h = data === null || data === void 0 ? void 0 : data.n2k) === null || _h === void 0 ? void 0 : _h.courseSpeed, "sog"),
            navigation_log: (_j = status(data === null || data === void 0 ? void 0 : data.log)) !== null && _j !== void 0 ? _j : status((_k = data === null || data === void 0 ? void 0 : data.n2k) === null || _k === void 0 ? void 0 : _k.distanceLog),
            depth: (_l = status(data === null || data === void 0 ? void 0 : data.depth)) !== null && _l !== void 0 ? _l : status((_m = data === null || data === void 0 ? void 0 : data.n2k) === null || _m === void 0 ? void 0 : _m.depth),
            wind: (_o = status(data === null || data === void 0 ? void 0 : data.wind)) !== null && _o !== void 0 ? _o : status((_p = data === null || data === void 0 ? void 0 : data.n2k) === null || _p === void 0 ? void 0 : _p.wind),
            engine: (_q = status(data === null || data === void 0 ? void 0 : data.engine)) !== null && _q !== void 0 ? _q : status((_r = data === null || data === void 0 ? void 0 : data.n2k) === null || _r === void 0 ? void 0 : _r.engine)
        }, Object.fromEntries(engines.map((e)=>{
            var _a, _b, _c, _d;
            const number = e.nmeaNumber != undefined ? e.nmeaNumber : e.number;
            return [
                "engine_" + e.number,
                (_b = (_a = data === null || data === void 0 ? void 0 : data.engine) === null || _a === void 0 ? void 0 : _a.find((eng)=>eng.number == number)) !== null && _b !== void 0 ? _b : (_d = (_c = data === null || data === void 0 ? void 0 : data.n2k) === null || _c === void 0 ? void 0 : _c.engine) === null || _d === void 0 ? void 0 : _d.find((eng)=>eng.instance == number)
            ];
        }))), {
            air_pressure: (_s = status(data === null || data === void 0 ? void 0 : data.weather, "pressure")) !== null && _s !== void 0 ? _s : status((_t = data === null || data === void 0 ? void 0 : data.n2k) === null || _t === void 0 ? void 0 : _t.pressure, "pressure"),
            air_temperature: (_u = status(data === null || data === void 0 ? void 0 : data.weather, "temperature")) !== null && _u !== void 0 ? _u : status((_v = data === null || data === void 0 ? void 0 : data.n2k) === null || _v === void 0 ? void 0 : _v.temperature, "temperature"),
            air_humidity: (_w = status(data === null || data === void 0 ? void 0 : data.weather, "humidity")) !== null && _w !== void 0 ? _w : status((_x = data === null || data === void 0 ? void 0 : data.n2k) === null || _x === void 0 ? void 0 : _x.humidity, "actualHumidity"),
            water_temperature: undefined,
            native_gps: statusForSource(data === null || data === void 0 ? void 0 : data.navigation, (0, $b75415c6faae2236$export$de7878d8063d52cb).native, "lat"),
            native_air_pressure: statusForSource(data === null || data === void 0 ? void 0 : data.weather, (0, $b75415c6faae2236$export$de7878d8063d52cb).native, "pressure")
        });
    },
    // The combined list of engine ids reporting in, 0183 numbers followed by N2K
    // instances (both addressing schemes, shown together for the test-data tab).
    engineIds (data) {
        var _a, _b, _c, _d;
        const nmeaIds = (_b = (_a = data === null || data === void 0 ? void 0 : data.engine) === null || _a === void 0 ? void 0 : _a.map((e)=>e.number)) !== null && _b !== void 0 ? _b : [];
        const n2kIds = ((_d = (_c = data === null || data === void 0 ? void 0 : data.n2k) === null || _c === void 0 ? void 0 : _c.engine) !== null && _d !== void 0 ? _d : []).map((e)=>e.instance).filter((n)=>n !== undefined);
        return [
            ...nmeaIds,
            ...n2kIds
        ];
    }
};
const $6551127e6af549ec$var$nmeaConfigurationContext = (0, $5cdac83ab505705b$export$1a6a959df6aea4fa)();
const $6551127e6af549ec$export$3624befcd3d27f6c = $6551127e6af549ec$var$nmeaConfigurationContext.Context;
const $6551127e6af549ec$export$6668a46e313499d2 = $6551127e6af549ec$var$nmeaConfigurationContext.useGet;


function $6c4a803c66ad99dd$export$f790aaf5ef6faaff() {
    var _a, _b;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("NMEAConfigurationView");
    const { connect: connect, connecting: connecting, connectionType: connectionType, connectionTypes: connectionTypes, selectConnectionType: selectConnectionType, initConnectionTypeOpen: initConnectionTypeOpen, host: host, port: port, device: device, devices: devices, edited: edited, error: error, completedCallback: completedCallback, resetConnection: resetConnection } = (0, $6551127e6af549ec$export$6668a46e313499d2)();
    const editableFields = [
        {
            name: "configuration",
            type: "object",
            fields: [
                "device",
                "host",
                {
                    name: "port",
                    type: "int"
                },
                "type"
            ]
        }
    ];
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
            changed: edited,
            editable: true,
            editableFields: editableFields,
            error: error && t("error_" + error),
            onSave: connect,
            children: [
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("connection_type"),
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                                button: t("connection_type_" + connectionType),
                                name: "configuration.type",
                                onSelect: selectConnectionType,
                                options: connectionTypes,
                                value: connectionType,
                                initOpen: initConnectionTypeOpen
                            })
                        }),
                        connectionType == "tcp" && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("connection_host"),
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: "configuration.host",
                                    defaultValue: host,
                                    required: true
                                })
                            })
                        }),
                        (connectionType == "tcp" || connectionType == "udp") && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("connection_port"),
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: "configuration.port",
                                    defaultValue: port,
                                    required: true
                                })
                            })
                        }),
                        (connectionType == "usb" || connectionType == "bluetooth") && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("connection_device"),
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$909904bdb4cb4458), {
                                    name: "configuration.device",
                                    defaultValue: device,
                                    suggestions: devices,
                                    required: true
                                })
                            })
                        })
                    ]
                }),
                app.hasFeature("gps") && connectionType !== "gps" && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "message-text-bigger",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                        message: (m)=>m.nmeaSettings.connectionTypeNative,
                        replace: {
                            tabName: t("step_native"),
                            type: t("connection_type")
                        }
                    })
                }),
                connectionType === "gps" && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "message-text-bigger",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                        message: (m)=>m.nmeaSettings.connectionTypeNativeWarning
                    })
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-actions block-row-bottom",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button",
                                onClick: completedCallback,
                                children: t("cancel")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button",
                                    onClick: resetConnection,
                                    children: t("reset")
                                }),
                                connecting == true ? (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: t("connecting")
                                }) : (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button default",
                                    type: "submit",
                                    children: ((_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.nmea) === null || _b === void 0 ? void 0 : _b.connected) ? t("reconnect") : t("connect")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }, "connection");
}






function $d473ae5d33ae8570$export$d82b576614c68ddb() {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("NMEAConfigurationView");
    const { nativePressureChecked: nativePressureChecked, setNativePressure: setNativePressure } = (0, $6551127e6af549ec$export$6668a46e313499d2)();
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
            className: "block-row-checkboxes checkbox-text-bigger",
            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("condition_native_pressure"),
                labelAfter: true,
                labelFor: "nativePressureEnabled",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    id: "nativePressureEnabled",
                    type: "checkbox",
                    name: "thresholds.nativePressureEnabled",
                    defaultValue: "",
                    onChange: ()=>{
                        setNativePressure(!nativePressureChecked);
                    },
                    checked: nativePressureChecked
                })
            })
        })
    }, "native");
}




var $acw62 = parcelRequire("acw62");





function $b8fbfd5acbcdb57a$export$f0af34e48c474e1b() {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("NMEAConfigurationView");
    const { statusChecks: statusChecks, status: status, resetConnection: resetConnection, completedCallback: completedCallback } = (0, $6551127e6af549ec$export$6668a46e313499d2)();
    const [captureStatus, setCaptureStatus] = (0, $acw62.useState)("idle");
    // #1113: uploads the last seconds of raw NMEA traffic the app received as a device
    // debug trace, so support can see what the instruments actually sent. Only
    // meaningful for a native session, which is the one holding the connection (hence
    // the `!app.cloudSession()` guard around the button below).
    const uploadDebugCapture = (0, $acw62.useCallback)(async ()=>{
        if (captureStatus === "sending") return;
        setCaptureStatus("sending");
        try {
            await (0, $6551127e6af549ec$export$d90d903c24f290e1).uploadDebugCapture(app.apiClient);
            setCaptureStatus("success");
        } catch (_error) {
            setCaptureStatus("error");
        }
    }, [
        app,
        captureStatus
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "NMEAConfigurationView-checks",
                children: Object.keys(statusChecks).map((key)=>{
                    var _a;
                    const source = (_a = statusChecks[key]) === null || _a === void 0 ? void 0 : _a.source;
                    return (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "block-row",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                className: `status-${key.startsWith("native_") ? source === (0, $b75415c6faae2236$export$de7878d8063d52cb).native ? "nmea" : "error" : source === (0, $b75415c6faae2236$export$de7878d8063d52cb).nmea ? "nmea" : "error"}`,
                                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleFilledLarge
                            }),
                            " ",
                            t("check_" + key)
                        ]
                    }, `data-${key}`);
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "padding-top-large",
                children: t("check_engine_ids", {
                    ids: (0, $6551127e6af549ec$export$d90d903c24f290e1).engineIds(status === null || status === void 0 ? void 0 : status.data).join(", ") || t("check_engine_ids_none")
                })
            }),
            !app.cloudSession() && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "NMEAConfigurationView-capture padding-top-large",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "NMEAConfigurationView-capture-hint",
                                children: t("capture_hint")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "button",
                                    disabled: captureStatus === "sending",
                                    onClick: uploadDebugCapture,
                                    children: (0, $6551127e6af549ec$export$d90d903c24f290e1).debugCaptureLabel(captureStatus, t)
                                })
                            })
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-actions block-row-bottom",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button",
                            onClick: resetConnection,
                            children: t("reset")
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button default",
                            onClick: ()=>completedCallback(),
                            children: t("complete")
                        })
                    })
                ]
            })
        ]
    }, "test_data");
}










function $afcc696a230009c2$export$84f021892496b68d() {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("NMEAConfigurationView");
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const { edited: edited, error: error, updateThresholds: updateThresholds, interval: interval, intervalOptions: intervalOptions, selectIntervalOptions: selectIntervalOptions, courseChecked: courseChecked, setCourseChecked: setCourseChecked, onEdited: onEdited, thresholds: thresholds, engineIdleChecked: engineIdleChecked, setEngineIdleChecked: setEngineIdleChecked, startStopAnchorChecked: startStopAnchorChecked, setStartStopAnchorChecked: setStartStopAnchorChecked } = (0, $6551127e6af549ec$export$6668a46e313499d2)();
    const namePrefix = "thresholds";
    const editableFields = [
        {
            name: "thresholds",
            type: "object",
            fields: [
                {
                    name: "interval",
                    type: "int"
                },
                {
                    name: "stop",
                    type: "float"
                },
                {
                    name: "resume",
                    type: "float"
                },
                {
                    name: "startStopAnchor",
                    type: "bool"
                },
                {
                    name: "anchorResume",
                    type: "float"
                },
                {
                    name: "courseChange",
                    type: "int"
                },
                {
                    name: "courseSpeed",
                    type: "float"
                },
                {
                    name: "engineStart",
                    type: "int"
                },
                {
                    name: "engineStop",
                    type: "int"
                },
                {
                    name: "engineIdleRpm",
                    type: "int"
                },
                {
                    name: "anchorDrift",
                    type: "object",
                    fields: [
                        {
                            name: "warning",
                            type: "float"
                        },
                        {
                            name: "alarm",
                            type: "float"
                        }
                    ]
                },
                {
                    name: "depth",
                    type: "object",
                    fields: [
                        {
                            name: "warning",
                            type: "float"
                        },
                        {
                            name: "alarm",
                            type: "float"
                        }
                    ]
                }
            ]
        }
    ];
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
            changed: edited,
            editable: true,
            editableFields: editableFields,
            error: error && t("error_" + error),
            onSave: updateThresholds,
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-title bold",
                    children: t("condition_entry")
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-no_labels",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("condition_interval"),
                        className: "block_field_small_12 label-left-0",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                            button: t("condition_interval_" + interval),
                            name: `${namePrefix}.interval`,
                            onSelect: selectIntervalOptions,
                            options: intervalOptions,
                            value: interval,
                            className: "select_small_150"
                        })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-no_labels",
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("condition_start"),
                            className: "label-left-0",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "bold18",
                                    children: "> "
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: `${namePrefix}.resume`,
                                    defaultValue: app.format("speed", thresholds === null || thresholds === void 0 ? void 0 : thresholds.resume),
                                    className: "block_field_small_6 center",
                                    onChange: onEdited
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("condition_stop"),
                            className: "label-left-0",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "bold18",
                                    children: "< "
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: `${namePrefix}.stop`,
                                    defaultValue: app.format("speed", thresholds === null || thresholds === void 0 ? void 0 : thresholds.stop),
                                    className: "block_field_small_6 center",
                                    onChange: onEdited
                                })
                            ]
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-checkboxes block-row-top20",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("condition_anchor_start_stop"),
                        labelAfter: true,
                        labelFor: `startStopAnchor`,
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "startStopAnchor",
                            type: "checkbox",
                            name: `${namePrefix}.startStopAnchor`,
                            defaultValue: "",
                            onChange: ()=>{
                                setStartStopAnchorChecked(!startStopAnchorChecked);
                                onEdited();
                            },
                            checked: startStopAnchorChecked
                        })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-gap block-row-tight",
                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("condition_anchor_no_status_change"),
                        className: "label-left-0",
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "bold18",
                                children: [
                                    "< ",
                                    " "
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: `${namePrefix}.anchorResume`,
                                defaultValue: app.format("speed", thresholds === null || thresholds === void 0 ? void 0 : thresholds.anchorResume),
                                className: "block_field_small_6 center",
                                onChange: onEdited,
                                readOnly: !startStopAnchorChecked
                            })
                        ]
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-checkboxes block-row-top20",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("condition_course"),
                        labelAfter: true,
                        labelFor: `courseChangeEnabled`,
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "courseChangeEnabled",
                            type: "checkbox",
                            name: `${namePrefix}.courseChangeEnabled`,
                            defaultValue: "",
                            onChange: ()=>{
                                setCourseChecked(!courseChecked);
                                onEdited();
                            },
                            checked: courseChecked
                        })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-tight",
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("condition_course_change"),
                            className: "label-left-0 block_field_small_12",
                            children: [
                                (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "bold18",
                                    children: [
                                        "> ",
                                        " "
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: `${namePrefix}.courseChange`,
                                    defaultValue: app.format("angle", thresholds === null || thresholds === void 0 ? void 0 : thresholds.courseChange),
                                    className: "block_field_small_6 center",
                                    onChange: onEdited,
                                    readOnly: !courseChecked
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("blank"),
                            className: "block_field_small_4 ",
                            children: (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "bold",
                                children: [
                                    t("and"),
                                    " "
                                ]
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("condition_course_speed"),
                            className: "label-left-0 block_field_small_12",
                            children: [
                                (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "bold18",
                                    children: [
                                        "> ",
                                        " "
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: `${namePrefix}.courseSpeed`,
                                    defaultValue: app.format("speed", thresholds === null || thresholds === void 0 ? void 0 : thresholds.courseSpeed),
                                    className: "block_field_small_6 center",
                                    onChange: onEdited,
                                    readOnly: !courseChecked
                                })
                            ]
                        })
                    ]
                }),
                (0, $22871482fce5b7e5$export$7930c61d9b464618).isSailingVessel(ship) && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block-row-title bold block-row-top20",
                            children: t("condition_engine_detection")
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block-row-no_labels",
                            children: [
                                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("condition_engine_start"),
                                    className: "label-left-0",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "bold18",
                                            children: "> "
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("input", {
                                            name: `${namePrefix}.engineStart`,
                                            defaultValue: app.format("rpm", thresholds === null || thresholds === void 0 ? void 0 : thresholds.engineStart),
                                            className: "block_field_small_6 center",
                                            onChange: onEdited
                                        })
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("condition_engine_stop"),
                                    className: "label-left-0",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "bold18",
                                            children: "< "
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("input", {
                                            name: `${namePrefix}.engineStop`,
                                            defaultValue: app.format("rpm", thresholds === null || thresholds === void 0 ? void 0 : thresholds.engineStop),
                                            className: "block_field_small_6 center",
                                            onChange: onEdited
                                        })
                                    ]
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block-row-checkboxes block-row-top20",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("condition_engine_idle_rpm"),
                                labelAfter: true,
                                labelFor: `engineIdleRpmEnabled`,
                                className: "label-wrap ",
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "engineIdleRpmEnabled",
                                    type: "checkbox",
                                    name: `${namePrefix}.engineIdleRpmEnabled`,
                                    defaultValue: "",
                                    style: {
                                        width: "90%"
                                    },
                                    onChange: ()=>{
                                        setEngineIdleChecked(!engineIdleChecked);
                                        onEdited();
                                    },
                                    checked: engineIdleChecked
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block-row-tight ",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("condition_engine_idle_rpm_value"),
                                className: "label-left-0",
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: `${namePrefix}.engineIdleRpm`,
                                    defaultValue: app.format("rpm", thresholds === null || thresholds === void 0 ? void 0 : thresholds.engineIdleRpm),
                                    className: "block_field_small_8 center",
                                    onChange: onEdited,
                                    readOnly: !engineIdleChecked
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }, "conditions");
}




function $b75ab3936bd2beb7$export$f8b316f44186c411({ banner: banner, initConfiguration: initConfiguration, initConnectionTypeOpen: initConnectionTypeOpen, initTab: initTab }) {
    var _a, _b, _c;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("NMEAConfigurationView");
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const settingsWriters = (0, $bf76a3a7a0d207c0$export$4bb86e129f694bc0)(ship.id);
    const { resetShipOverlay: resetShipOverlay } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const [connecting, setConnecting] = (0, $acw62.useState)(false);
    // "The user asked this view to connect and that request has not been honoured yet."
    // Deliberately separate from `connecting` (which is UI state for the Connecting…
    // label and must clear on a failed attempt) -- see the subscription handler below.
    const awaitingConnection = (0, $acw62.useRef)(false);
    const [connectionType, setConnectionType] = (0, $acw62.useState)("tcp");
    const [courseChecked, setCourseChecked] = (0, $acw62.useState)(false);
    const [engineIdleChecked, setEngineIdleChecked] = (0, $acw62.useState)(false);
    const [startStopAnchorChecked, setStartStopAnchorChecked] = (0, $acw62.useState)(false);
    const [nativePressureChecked, setNativePressureChecked] = (0, $acw62.useState)(false);
    const [device, setDevice] = (0, $acw62.useState)(undefined);
    const [devices, setDevices] = (0, $acw62.useState)([]);
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const [error, setError] = (0, $acw62.useState)((_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.nmea) === null || _b === void 0 ? void 0 : _b.error);
    const [host, setHost] = (0, $acw62.useState)(undefined);
    const tabBarRef = (0, $8a8193ceb042f538$export$ba657787b573294a)();
    const [port, setPort] = (0, $acw62.useState)(undefined);
    const [status, setStatus] = (0, $acw62.useState)((_c = app.status) === null || _c === void 0 ? void 0 : _c.nmea);
    const [thresholds, setThresholds] = (0, $acw62.useState)(undefined);
    const [interval, setInterval] = (0, $acw62.useState)(undefined);
    const completedCallback = (0, $acw62.useCallback)(()=>resetShipOverlay(), []);
    const { bodyRef: bodyRef, showScrollButton: showScrollButton, isAtBottom: isAtBottom, handleScrollMore: handleScrollMore } = (0, $4be45b24a899ae38$export$5315996935894f9d)();
    const connectionTypes = [
        {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Wifi,
            title: t("connection_type_tcp"),
            value: "tcp"
        },
        app.hasFeature("usb") ? {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Usb,
            title: t("connection_type_usb"),
            value: "usb"
        } : undefined,
        app.hasFeature("gps") ? {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Gps,
            title: t("connection_type_gps"),
            value: "gps"
        } : undefined,
        {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Wifi,
            title: t("connection_type_udp"),
            value: "udp"
        },
        undefined
    ].filter(Boolean);
    const intervalOptions = [
        {
            title: "60 min",
            value: 3600
        },
        {
            title: "30 min",
            value: 1800
        }
    ];
    (0, $acw62.useEffect)(()=>{
        const load = async ()=>{
            if (initConfiguration) {
                setConnectionType(initConfiguration.type || "tcp");
                setDevice(initConfiguration.device);
                setHost(initConfiguration.host);
                setPort(initConfiguration.port);
                setDevices(initConfiguration.devices || []);
                return;
            }
            if (edited) return;
            const data = await (0, $6551127e6af549ec$export$d90d903c24f290e1).loadNmea(app.apiClient);
            if (data.configuration) {
                setConnectionType(data.configuration.type || "tcp");
                setDevice(data.configuration.device);
                setHost(data.configuration.host);
                setPort(data.configuration.port);
            }
            setNativePressureChecked(data.nativeBaro || false);
            setDevices(data.devices || []);
        };
        load().catch(console.error);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const load = async ()=>{
            if (!ship) return;
            const settings = await (0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship);
            if (settings.thresholds) {
                setThresholds(settings.thresholds);
                setCourseChecked(settings.thresholds.courseChangeEnabled);
                setEngineIdleChecked(settings.thresholds.engineIdleRpmEnabled);
                setStartStopAnchorChecked(settings.thresholds.startStopAnchor);
                setInterval(settings.thresholds.interval || 3600);
            } else {
                setThresholds({});
                setInterval(3600);
            }
        };
        load().catch(console.error);
    }, [
        ship
    ]);
    const toggleNmeaSetup = (0, $acw62.useCallback)((e)=>{
        if (e && e.preventDefault) e.preventDefault();
        completedCallback();
    }, []);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const connect = (0, $acw62.useCallback)(async (_data, values)=>{
        var _a, _b, _c;
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("saving", (0, $ea493e883ca706d4$export$9de129cb03ba998c)(values));
        awaitingConnection.current = true;
        setConnecting(true);
        setError(undefined);
        await (0, $6551127e6af549ec$export$d90d903c24f290e1).connectNmea(app.apiClient, values);
        let currentStatus = status;
        for(let attempt = 0; awaitingConnection.current && (!(currentStatus === null || currentStatus === void 0 ? void 0 : currentStatus.connected) || Object.keys((_a = currentStatus.data) !== null && _a !== void 0 ? _a : {}).length === 0) && attempt < 100; attempt++){
            currentStatus = (await (0, $6551127e6af549ec$export$d90d903c24f290e1).loadStatus(app.apiClient)).nmea;
            if (!(currentStatus === null || currentStatus === void 0 ? void 0 : currentStatus.connected) || Object.keys((_b = currentStatus.data) !== null && _b !== void 0 ? _b : {}).length === 0) await new Promise((resolve)=>setTimeout(resolve, 200));
        }
        if ((currentStatus === null || currentStatus === void 0 ? void 0 : currentStatus.connected) && awaitingConnection.current) {
            awaitingConnection.current = false;
            setStatus(currentStatus);
            (_c = tabBarRef.current) === null || _c === void 0 || _c.setSelected("test_data");
            setConnecting(false);
        } else if (currentStatus === null || currentStatus === void 0 ? void 0 : currentStatus.error) {
            setError(currentStatus.error);
            setConnecting(false);
        }
    }, [
        connecting,
        status === null || status === void 0 ? void 0 : status.connected,
        tabBarRef
    ]);
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((status, _type)=>{
        var _a, _b, _c, _d, _e;
        if ((_a = status.nmea) === null || _a === void 0 ? void 0 : _a.data) setStatus(status.nmea);
        // Hand over to the test-data tab on `awaitingConnection`, NOT on `connecting`.
        // The two look interchangeable and are not: `connecting` also means "the connect
        // button is replaced by the Connecting… label" (`ConnectionView.tsx`), so it has
        // to be cleared as soon as an attempt reports an error -- while the request the
        // user made is still outstanding, because `LogbookNMEAClient` retries on its own
        // (`connectionFailed` -> `connectPending` -> `connected`, no user action).
        //
        // Clearing both on the error left the successful retry arriving with nothing set,
        // so the view sat on the connection tab with a live, streaming feed and no way to
        // reach the data short of clicking connect again. `awaitingConnection` outlives
        // the failed attempt and is cleared only once it has actually been honoured (or
        // the user resets the connection), which is what makes the retry land.
        if (((_b = status.nmea) === null || _b === void 0 ? void 0 : _b.connected) && awaitingConnection.current) {
            awaitingConnection.current = false;
            (_c = tabBarRef.current) === null || _c === void 0 || _c.setSelected("test_data");
            setConnecting(false);
            setError(undefined);
        }
        if ((_d = status.nmea) === null || _d === void 0 ? void 0 : _d.error) {
            (_e = tabBarRef.current) === null || _e === void 0 || _e.setSelected("connection");
            setError(status.nmea.error);
            setConnecting(false);
        }
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).AppStatus);
    const selectConnectionType = (0, $acw62.useCallback)((type)=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("selectConnectionType", type);
        setConnectionType(type);
    }, [
        connectionType
    ]);
    const selectIntervalOptions = (0, $acw62.useCallback)((type)=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("selectInterval", type);
        setInterval(type);
        onEdited();
    }, []);
    async function resetConnection(e) {
        var _a;
        e.preventDefault();
        await (0, $6551127e6af549ec$export$d90d903c24f290e1).disconnectNmea(app.apiClient);
        // Explicitly dropping the connection also withdraws any outstanding request to be
        // taken to the test-data tab -- otherwise a reconnect the app makes later on its
        // own would still yank the user there, long after they said they didn't want it.
        awaitingConnection.current = false;
        setConnecting(false);
        setStatus(undefined);
        (_a = tabBarRef.current) === null || _a === void 0 || _a.setSelected("connection");
        completedCallback();
    }
    const updateThresholds = (0, $acw62.useCallback)(async (_data, values)=>{
        var _a, _b, _c;
        if (values.thresholds) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
            values.thresholds.courseChangeEnabled = courseChecked;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
            values.thresholds.engineIdleRpmEnabled = engineIdleChecked;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
            values.thresholds.startStopAnchor = startStopAnchorChecked;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
        const t = values.thresholds;
        const validationError = (0, $6551127e6af549ec$export$d90d903c24f290e1).validateEngineRpm((_a = t === null || t === void 0 ? void 0 : t.engineStop) !== null && _a !== void 0 ? _a : thresholds === null || thresholds === void 0 ? void 0 : thresholds.engineStop, (_b = t === null || t === void 0 ? void 0 : t.engineStart) !== null && _b !== void 0 ? _b : thresholds === null || thresholds === void 0 ? void 0 : thresholds.engineStart, (_c = t === null || t === void 0 ? void 0 : t.engineIdleRpm) !== null && _c !== void 0 ? _c : thresholds === null || thresholds === void 0 ? void 0 : thresholds.engineIdleRpm, engineIdleChecked);
        if (validationError) {
            setError(validationError);
            resetEdited();
            return;
        }
        setError(undefined);
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("save", (0, $ea493e883ca706d4$export$9de129cb03ba998c)(values));
        const result = await settingsWriters.updateSettings(values);
        const parsed = (0, $bf76a3a7a0d207c0$export$b0ab3204ac4c15f7)(result);
        if ((parsed === null || parsed === void 0 ? void 0 : parsed.settingType) === (0, $bdd927c6c90fec0d$export$10bc32ab3a8a0f49).ship) setThresholds(parsed.dataParsed.thresholds);
        resetEdited();
    }, [
        courseChecked,
        engineIdleChecked,
        startStopAnchorChecked,
        thresholds,
        ship,
        settingsWriters
    ]);
    const setNativePressure = (0, $acw62.useCallback)(async (enabled)=>{
        await (0, $6551127e6af549ec$export$d90d903c24f290e1).setNativePressure(app.apiClient, enabled);
        setNativePressureChecked(enabled);
    }, [
        app
    ]);
    if (banner) return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "NMEAConfigurationView-banner",
        children: [
            t("banner_text"),
            " ",
            (0, $7b02d682eb115277$exports.jsx)("a", {
                href: "#",
                className: "NMEAConfigurationView-banner-start-setup",
                onClick: toggleNmeaSetup,
                children: t("banner_start_setup")
            })
        ]
    });
    const statusChecks = (0, $6551127e6af549ec$export$d90d903c24f290e1).buildStatusChecks(status === null || status === void 0 ? void 0 : status.data, (0, $22871482fce5b7e5$export$7930c61d9b464618).engines(ship));
    const contextValue = {
        connecting: connecting,
        connectionType: connectionType,
        connectionTypes: connectionTypes,
        selectConnectionType: selectConnectionType,
        initConnectionTypeOpen: initConnectionTypeOpen,
        host: host,
        port: port,
        device: device,
        devices: devices,
        connect: connect,
        resetConnection: resetConnection,
        nativePressureChecked: nativePressureChecked,
        setNativePressure: setNativePressure,
        statusChecks: statusChecks,
        status: status,
        interval: interval,
        intervalOptions: intervalOptions,
        selectIntervalOptions: selectIntervalOptions,
        courseChecked: courseChecked,
        setCourseChecked: setCourseChecked,
        engineIdleChecked: engineIdleChecked,
        setEngineIdleChecked: setEngineIdleChecked,
        startStopAnchorChecked: startStopAnchorChecked,
        setStartStopAnchorChecked: setStartStopAnchorChecked,
        thresholds: thresholds,
        updateThresholds: updateThresholds,
        edited: edited,
        onEdited: onEdited,
        error: error,
        completedCallback: completedCallback
    };
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "NMEAConfigurationView",
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
            closeCallback: completedCallback,
            className: "overlay-max-height",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$fe53879cede8fc3), {
                    closeCallback: toggleNmeaSetup,
                    title: t("title")
                }),
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    ref: bodyRef,
                    className: "Overlay-body",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $6551127e6af549ec$export$3624befcd3d27f6c).Provider, {
                        value: contextValue,
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $9f9e7bca499fb8dc$export$f97dc4a5a0177256), {
                            defaultSelection: initTab !== null && initTab !== void 0 ? initTab : "connection",
                            callbacks: tabBarRef,
                            tabs: [
                                {
                                    name: "connection",
                                    title: t("step_connection"),
                                    render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $6c4a803c66ad99dd$export$f790aaf5ef6faaff), {})
                                },
                                ...app.hasFeature("gps") ? [
                                    {
                                        name: "native",
                                        title: t("step_native"),
                                        render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $d473ae5d33ae8570$export$d82b576614c68ddb), {})
                                    }
                                ] : [],
                                {
                                    name: "test_data",
                                    title: t("step_test_data"),
                                    render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $b8fbfd5acbcdb57a$export$f0af34e48c474e1b), {})
                                },
                                {
                                    name: "conditions",
                                    title: t("step_conditions"),
                                    render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $afcc696a230009c2$export$84f021892496b68d), {})
                                }
                            ]
                        })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $403f1eee91546a91$export$1beabfbeae7b7782), {
                    isAtBottom: isAtBottom,
                    showScrollButton: showScrollButton,
                    handleScrollMore: handleScrollMore,
                    readMoreLabel: t("read_more")
                })
            ]
        })
    });
}



parcelRequire("acw62");



const $74bcfc43c0f9ac90$export$a748595c159845f9 = {
    // Resolve the active overlay definition by name. Throws when a name is given
    // that has no matching definition, and returns undefined when no overlay is
    // selected (empty name).
    resolveOverlay (overlays, overlay) {
        if (overlay && !overlays[overlay]) throw new Error(`OverlayView: Unknown overlay "${overlay}"`);
        return overlay ? overlays[overlay] : undefined;
    }
};
function $74bcfc43c0f9ac90$export$89acdd91182d6c5d({ className: className, overlay: overlay, overlays: overlays, resetOverlay: resetOverlay }) {
    const _app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const o = $74bcfc43c0f9ac90$export$a748595c159845f9.resolveOverlay(overlays, overlay);
    if (!o) return null;
    const content = o.render();
    if (!content) return null;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            className,
            o.className
        ]),
        closeCallback: resetOverlay,
        closeBackground: o.close,
        style: o.style || "default",
        hideClose: !o.close,
        children: [
            o.title && (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$fe53879cede8fc3), {
                title: o.title,
                style: o.style || "default",
                closeCallback: resetOverlay,
                hideClose: !o.close
            }),
            content
        ]
    }, overlay);
}




var $acw62 = parcelRequire("acw62");











function $807e05067c94e8fb$export$746af75b6b2a4bae({ className: className, readMoreLabel: readMoreLabel, deps: deps, children: children }) {
    const { bodyRef: bodyRef, showScrollButton: showScrollButton, isAtBottom: isAtBottom, handleScrollMore: handleScrollMore } = (0, $4be45b24a899ae38$export$5315996935894f9d)(deps);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: bodyRef,
                className: className,
                children: children
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $403f1eee91546a91$export$1beabfbeae7b7782), {
                isAtBottom: isAtBottom,
                showScrollButton: showScrollButton,
                handleScrollMore: handleScrollMore,
                readMoreLabel: readMoreLabel
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");
const $89da9a3ec064ebbf$var$shipViewContext = (0, $5cdac83ab505705b$export$1a6a959df6aea4fa)();
const $89da9a3ec064ebbf$export$32b72d0fbebd240d = $89da9a3ec064ebbf$var$shipViewContext.Context;
const $89da9a3ec064ebbf$export$539e5c02cab90a6e = $89da9a3ec064ebbf$var$shipViewContext.useGet;
const $89da9a3ec064ebbf$export$27928a5984cd9ca8 = ()=>{
    const ctx = (0, $acw62.useContext)($89da9a3ec064ebbf$export$32b72d0fbebd240d);
    return ctx ? ctx.shipUsers : [];
};





var $acw62 = parcelRequire("acw62");


// Tolerant resolution of a persisted unit token to its canonical value, mirroring the Swift
// `UnitType` decode ladder in Sources/LogbookModel/Settings/ShipSettings.swift.
//
// #1331: the Ship SettingsView used to build its `<option value>` list from the generated enums'
// *keys* rather than their values, so any key≠value mismatch persisted a token the model could not
// decode — `unit.pressure` stored `hpa` where the enum's raw value is `hPa`, and the ship's whole
// sync failed. The writer is fixed, but rows written before it are still out there. Because the
// selects are uncontrolled, preselecting the canonical option is enough to repair a row: the next
// save serializes the canonical token.
// Raw values that were renamed, so they match neither a current value nor a current key. Keep in
// sync with `UnitType.legacyRawValues` on the Swift side.
const $ba11ea1c282fce5f$export$f6a94b0d90bfa2a9 = {
    in: "inch",
    liter: "l",
    gallon: "gal",
    kWh: "kw"
};
// Case-folded, with separators and punctuation dropped, so `square_foot`, `Square Foot` and
// `square-foot` all collapse onto the same key.
function $ba11ea1c282fce5f$var$normalize(token) {
    return token.toLowerCase().replace(/[^a-z0-9]/g, "");
}
function $ba11ea1c282fce5f$export$b33d1e35ce55898(value, options, aliases = {}) {
    var _a;
    if (value == undefined) return undefined;
    if (options.includes(value)) return value;
    const normalized = $ba11ea1c282fce5f$var$normalize(value);
    if (normalized.length === 0) return undefined;
    const byOption = options.find((option)=>$ba11ea1c282fce5f$var$normalize(option) === normalized);
    if (byOption != undefined) return byOption;
    const alias = (_a = Object.entries(Object.assign(Object.assign({}, $ba11ea1c282fce5f$export$f6a94b0d90bfa2a9), aliases)).find(([key])=>$ba11ea1c282fce5f$var$normalize(key) === normalized)) === null || _a === void 0 ? void 0 : _a[1];
    return alias != undefined && options.includes(alias) ? alias : undefined;
}
function $ba11ea1c282fce5f$export$1bd226d1200d6a39(value, unitEnum) {
    return $ba11ea1c282fce5f$export$b33d1e35ce55898(value, Object.values(unitEnum), unitEnum);
}






parcelRequire("acw62");

function $7d2c1488f3a42e1e$export$fe00f1c2ba2bd8a3({ label: label, name: name, defaultValue: defaultValue, options: options, onChange: onChange }) {
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
        label: label,
        className: "block_field_small_8",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
            children: (0, $7b02d682eb115277$exports.jsx)("select", {
                className: "select-setting",
                name: name,
                defaultValue: defaultValue,
                onChange: onChange,
                children: options
            })
        })
    });
}


function $4aa07c0ae0c1819e$export$f38c2e306dc3b554({ settings: settings, edited: edited, onEdited: onEdited, onEditEvent: onEditEvent, save: save }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipSettingsView");
    const namePrefix = `unit.`;
    const unit = (0, $acw62.useMemo)(()=>{
        return (settings === null || settings === void 0 ? void 0 : settings.unit) || {};
    }, [
        settings
    ]);
    // Options are built from the enum's **values**, not its keys: the key is only the translation
    // key (`unit_<key>`). Emitting keys is what persisted the undecodable `hpa` in #1331.
    const unitOptions = (0, $acw62.useCallback)((type)=>{
        return Object.entries(type).map(([key, value])=>{
            return (0, $7b02d682eb115277$exports.jsx)("option", {
                value: value,
                children: t(`unit_${key}`)
            }, key);
        });
    }, []);
    const unitDistanceOptions = (0, $acw62.useMemo)(()=>unitOptions((0, $7bbbb4844e018774$export$67282d4eef50b63)), [
        unitOptions
    ]);
    const unitSpeedOptions = (0, $acw62.useMemo)(()=>unitOptions((0, $7bbbb4844e018774$export$ea429959941181e6)), [
        unitOptions
    ]);
    const unitWindOptions = (0, $acw62.useMemo)(()=>unitOptions((0, $7bbbb4844e018774$export$4358b71b4c92dc0d)), [
        unitOptions
    ]);
    const unitCurrentOptions = (0, $acw62.useMemo)(()=>unitOptions((0, $7bbbb4844e018774$export$f3cf4596788fb90f)), [
        unitOptions
    ]);
    const unitTemperaturOptions = (0, $acw62.useMemo)(()=>unitOptions((0, $7bbbb4844e018774$export$ee8ffdd108a6d394)), [
        unitOptions
    ]);
    const unitPressureOptions = (0, $acw62.useMemo)(()=>unitOptions((0, $7bbbb4844e018774$export$d2fec679848e7245)), [
        unitOptions
    ]);
    const unitLengthOptions = (0, $acw62.useMemo)(()=>unitOptions((0, $7bbbb4844e018774$export$4e14a41e7458b586)), [
        unitOptions
    ]);
    const unitSurfaceOptions = (0, $acw62.useMemo)(()=>unitOptions((0, $7bbbb4844e018774$export$9914f13c18a9e8e2)), [
        unitOptions
    ]);
    const unitVolumeOptions = (0, $acw62.useMemo)(()=>unitOptions((0, $7bbbb4844e018774$export$662bb6c25c72292)), [
        unitOptions
    ]);
    const unitWeightOptions = (0, $acw62.useMemo)(()=>unitOptions((0, $7bbbb4844e018774$export$577a7cb5ce16402e)), [
        unitOptions
    ]);
    const unitPowerOptions = (0, $acw62.useMemo)(()=>unitOptions((0, $7bbbb4844e018774$export$b9afc54769e2ce7d)), [
        unitOptions
    ]);
    const [currency, setCurrency] = (0, $acw62.useState)(unit.currency);
    const predefinedCurrencies = (0, $acw62.useMemo)(()=>Object.keys((0, $7bbbb4844e018774$export$a10906fe7aaac3b8)).filter((key)=>typeof key === "string"), []);
    const selectCurrency = (0, $acw62.useCallback)((value)=>{
        setCurrency(value);
        if (onEdited) onEdited();
    }, [
        onEdited
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
        changed: edited,
        editable: true,
        editableFields: [
            {
                name: "unit",
                type: "object",
                fields: [
                    "length",
                    "weight",
                    "speed",
                    "temperature",
                    "volume",
                    "surface",
                    "currency",
                    "distance",
                    "power",
                    "wind",
                    "pressure",
                    "current"
                ]
            }
        ],
        onSave: save,
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
            className: "tab-content",
            children: [
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $7d2c1488f3a42e1e$export$fe00f1c2ba2bd8a3), {
                            label: t("distance"),
                            name: `${namePrefix}distance`,
                            defaultValue: (0, $ba11ea1c282fce5f$export$1bd226d1200d6a39)(unit.distance, (0, $7bbbb4844e018774$export$67282d4eef50b63)),
                            options: unitDistanceOptions,
                            onChange: onEditEvent
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $7d2c1488f3a42e1e$export$fe00f1c2ba2bd8a3), {
                            label: t("length"),
                            name: `${namePrefix}length`,
                            defaultValue: (0, $ba11ea1c282fce5f$export$1bd226d1200d6a39)(unit.length, (0, $7bbbb4844e018774$export$4e14a41e7458b586)),
                            options: unitLengthOptions,
                            onChange: onEditEvent
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $7d2c1488f3a42e1e$export$fe00f1c2ba2bd8a3), {
                            label: t("surface"),
                            name: `${namePrefix}surface`,
                            defaultValue: (0, $ba11ea1c282fce5f$export$1bd226d1200d6a39)(unit.surface, (0, $7bbbb4844e018774$export$9914f13c18a9e8e2)),
                            options: unitSurfaceOptions,
                            onChange: onEditEvent
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $7d2c1488f3a42e1e$export$fe00f1c2ba2bd8a3), {
                            label: t("speed"),
                            name: `${namePrefix}speed`,
                            defaultValue: (0, $ba11ea1c282fce5f$export$1bd226d1200d6a39)(unit.speed, (0, $7bbbb4844e018774$export$ea429959941181e6)),
                            options: unitSpeedOptions,
                            onChange: onEditEvent
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $7d2c1488f3a42e1e$export$fe00f1c2ba2bd8a3), {
                            label: t("wind"),
                            name: `${namePrefix}wind`,
                            defaultValue: (0, $ba11ea1c282fce5f$export$1bd226d1200d6a39)(unit.wind, (0, $7bbbb4844e018774$export$4358b71b4c92dc0d)),
                            options: unitWindOptions,
                            onChange: onEditEvent
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $7d2c1488f3a42e1e$export$fe00f1c2ba2bd8a3), {
                            label: t("current"),
                            name: `${namePrefix}current`,
                            defaultValue: (0, $ba11ea1c282fce5f$export$1bd226d1200d6a39)(unit.current, (0, $7bbbb4844e018774$export$f3cf4596788fb90f)),
                            options: unitCurrentOptions,
                            onChange: onEditEvent
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "distance_bottom",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $7d2c1488f3a42e1e$export$fe00f1c2ba2bd8a3), {
                            label: t("volume"),
                            name: `${namePrefix}volume`,
                            defaultValue: (0, $ba11ea1c282fce5f$export$1bd226d1200d6a39)(unit.volume, (0, $7bbbb4844e018774$export$662bb6c25c72292)),
                            options: unitVolumeOptions,
                            onChange: onEditEvent
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $7d2c1488f3a42e1e$export$fe00f1c2ba2bd8a3), {
                            label: t("weight"),
                            name: `${namePrefix}weight`,
                            defaultValue: (0, $ba11ea1c282fce5f$export$1bd226d1200d6a39)(unit.weight, (0, $7bbbb4844e018774$export$577a7cb5ce16402e)),
                            options: unitWeightOptions,
                            onChange: onEditEvent
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $7d2c1488f3a42e1e$export$fe00f1c2ba2bd8a3), {
                            label: t("temperature"),
                            name: `${namePrefix}temperature`,
                            defaultValue: (0, $ba11ea1c282fce5f$export$1bd226d1200d6a39)(unit.temperature, (0, $7bbbb4844e018774$export$ee8ffdd108a6d394)),
                            options: unitTemperaturOptions,
                            onChange: onEditEvent
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $7d2c1488f3a42e1e$export$fe00f1c2ba2bd8a3), {
                            label: t("pressure"),
                            name: `${namePrefix}pressure`,
                            defaultValue: (0, $ba11ea1c282fce5f$export$1bd226d1200d6a39)(unit.pressure, (0, $7bbbb4844e018774$export$d2fec679848e7245)),
                            options: unitPressureOptions,
                            onChange: onEditEvent
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $7d2c1488f3a42e1e$export$fe00f1c2ba2bd8a3), {
                            label: t("power"),
                            name: `${namePrefix}power`,
                            defaultValue: (0, $ba11ea1c282fce5f$export$1bd226d1200d6a39)(unit.power, (0, $7bbbb4844e018774$export$b9afc54769e2ce7d)),
                            options: unitPowerOptions,
                            onChange: onEditEvent
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("currency"),
                            className: "block_field_small_8",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                                value: currency,
                                predefined: predefinedCurrencies,
                                label: (v)=>t(`unit_${v}`),
                                customValue: t("other"),
                                name: `${namePrefix}currency`,
                                onSelect: selectCurrency
                            })
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");


/**
 * The manual UTC offsets a ship can be set to, in hours east of UTC, ascending.
 *
 * Real-world offsets only, and only the ones relevant to marine navigation: whole
 * hours from -12 to +14 plus the half-hour zones. The quarter-hour zones (Nepal's
 * +5:45, Chatham's +12:45, the Australian +8:45) are deliberately omitted, as is
 * -2:30, which the legacy timezone input used to offer even though no such offset
 * exists.
 *
 * This is the single source of truth for both the ship-settings offset select and
 * the legacy `TimezoneInput`'s accepted values, which used to carry two hardcoded
 * lists that disagreed with each other.
 */ const $e489e317f94a5604$export$cf608442673b00ae = [
    -12,
    -11,
    -10,
    -9.5,
    -9,
    -8,
    -7,
    -6,
    -5,
    -4,
    -3.5,
    -3,
    -2,
    -1,
    0,
    1,
    2,
    3,
    3.5,
    4,
    4.5,
    5,
    5.5,
    6,
    6.5,
    7,
    8,
    9,
    9.5,
    10,
    10.5,
    11,
    12,
    13,
    14
];
const $e489e317f94a5604$export$299100d2d8b072fa = $e489e317f94a5604$export$cf608442673b00ae.map((hours)=>hours * 3600);






parcelRequire("acw62");


function $43e7c9e0370237d7$export$b605456b9cec4c34({ message: message, onClose: onClose, style: style, title: title }) {
    return (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        className: "InfoDialog InfoDialog-scrollable",
        closeBackground: true,
        closeCallback: onClose,
        style: style || "info",
        title: title,
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "Overlay-body InfoDialog-body",
            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "message-text-bigger",
                    children: message
                })
            })
        })
    });
}



function $e71b677f00665e4b$export$c7577dc5f0d67840({ settings: settings, onEdited: onEdited, onEditEvent: onEditEvent }) {
    var _a, _b, _c;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipSettingsView");
    const namePrefix = `unit.`;
    const [time, setTime] = (0, $acw62.useState)(((_a = app.status) === null || _a === void 0 ? void 0 : _a.time) ? Date.parse(app.status.time) : new Date().valueOf() - new Date((0, $14a8bda8b42de2c4$export$4334e0aa46d23a16)).valueOf());
    const [timezoneManualValue, setTimezoneManualValue] = (0, $acw62.useState)(settings === null || settings === void 0 ? void 0 : settings.timezone);
    const [showTimezoneManualInfo, setShowTimezoneManualInfo] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setTimezoneManualValue(settings === null || settings === void 0 ? void 0 : settings.timezone);
    }, [
        settings === null || settings === void 0 ? void 0 : settings.timezone
    ]);
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((status, _type)=>{
        if (status.time) setTime(Date.parse(status.time));
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).AppStatus);
    const currentTime = (0, $acw62.useMemo)(()=>{
        var _a;
        return time / 1000 + (timezoneManualValue != undefined ? timezoneManualValue : ((_a = app.status) === null || _a === void 0 ? void 0 : _a.systemTimezone) || 0);
    }, [
        time,
        app.status,
        timezoneManualValue
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                    className: "block-row-followed-by-block-row ",
                    children: t("timezone_title")
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    className: "message-text-bigger",
                    message: (m)=>m.shipSetting.utc
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-checkboxes timezone-row",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("timezone_manual"),
                        labelAfter: true,
                        labelFor: `TimezoneManual`,
                        className: "block_field_small_16 checkbox-text-bigger timezone-manual-field label-wrap",
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "TimezoneManual",
                            type: "checkbox",
                            name: `${namePrefix}.timezoneManualEnabled`,
                            defaultValue: "",
                            onChange: ()=>{
                                var _a;
                                setTimezoneManualValue(timezoneManualValue == undefined ? ((_a = app.status) === null || _a === void 0 ? void 0 : _a.systemTimezone) || 0 : undefined);
                                onEdited();
                            },
                            checked: timezoneManualValue != undefined
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("timezone"),
                        className: "block_field_small_8 timezone-field",
                        children: timezoneManualValue != undefined ? (0, $7b02d682eb115277$exports.jsx)("select", {
                            name: "timezone",
                            defaultValue: timezoneManualValue != undefined ? timezoneManualValue : ((_b = app.status) === null || _b === void 0 ? void 0 : _b.systemTimezone) || 0,
                            onChange: (e)=>{
                                setTimezoneManualValue(parseInt(e.target.value));
                                onEditEvent(e);
                            },
                            children: (0, $e489e317f94a5604$export$299100d2d8b072fa).map((offset)=>{
                                return (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: offset,
                                    children: app.format("timezone", offset)
                                }, offset);
                            })
                        }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: "timezone",
                                    type: "hidden",
                                    value: undefined
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    value: app.format("timezone", ((_c = app.status) === null || _c === void 0 ? void 0 : _c.systemTimezone) || 0),
                                    readOnly: true,
                                    disabled: true
                                })
                            ]
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("current_time"),
                        className: "block_field_small_8 current-time-field",
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            value: app.format("timeUtc", currentTime),
                            name: "time",
                            className: "center",
                            readOnly: true
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: " ",
                        className: "",
                        children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            className: "button",
                            onClick: ()=>setShowTimezoneManualInfo(true),
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "question-circle",
                                    children: "?"
                                }),
                                "  ",
                                t("more_info")
                            ]
                        })
                    })
                ]
            }),
            showTimezoneManualInfo && (0, $7b02d682eb115277$exports.jsx)((0, $43e7c9e0370237d7$export$b605456b9cec4c34), {
                title: t("timezone_manual"),
                message: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.shipSetting.utc_info
                }),
                onClose: ()=>setShowTimezoneManualInfo(false),
                style: "info"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





function $3b30697235b5f6ce$export$977b6331d44ad90({ settings: settings, onEditEvent: onEditEvent }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipSettingsView");
    const [showLogOffsetInfo, setShowLogOffsetInfo] = (0, $acw62.useState)(false);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                    className: "block-row-followed-by-block-row",
                    children: t("log_offset_title")
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-one-row align-items-end",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("log_offset"),
                        className: "block_field_small_12",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                format: "float",
                                name: "logOffset",
                                defaultValue: (_a = settings === null || settings === void 0 ? void 0 : settings.logOffset) !== null && _a !== void 0 ? _a : "",
                                placeholder: "0",
                                onChange: onEditEvent
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: " ",
                        className: "",
                        children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            className: "button",
                            onClick: ()=>setShowLogOffsetInfo(true),
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "question-circle",
                                    children: "?"
                                }),
                                "  ",
                                t("more_info")
                            ]
                        })
                    })
                ]
            }),
            showLogOffsetInfo && (0, $7b02d682eb115277$exports.jsx)((0, $43e7c9e0370237d7$export$b605456b9cec4c34), {
                title: t("log_offset_title"),
                message: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.shipSetting.log_offset
                }),
                onClose: ()=>setShowLogOffsetInfo(false),
                style: "info"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




function $0cfaa0dd91d62ecf$export$701ea14e3ec19534({ settings: settings, onEdited: onEdited }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipSettingsView");
    const [keepManualRpm, setKeepManualRpm] = (0, $acw62.useState)((_a = settings === null || settings === void 0 ? void 0 : settings.keepManualRpm) !== null && _a !== void 0 ? _a : false);
    const [showRpmInfo, setShowRpmInfo] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        var _a;
        setKeepManualRpm((_a = settings === null || settings === void 0 ? void 0 : settings.keepManualRpm) !== null && _a !== void 0 ? _a : false);
    }, [
        settings === null || settings === void 0 ? void 0 : settings.keepManualRpm
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                    className: "block-row-followed-by-block-row",
                    children: t("rpm_title")
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-checkboxes block-row-one-row",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("rpm_keep_manual"),
                        labelAfter: true,
                        labelFor: "KeepManualRpm",
                        className: "checkbox-text-bigger",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "hidden",
                                name: "keepManualRpm",
                                value: keepManualRpm ? "true" : "false"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: "KeepManualRpm",
                                type: "checkbox",
                                checked: keepManualRpm,
                                onChange: ()=>{
                                    setKeepManualRpm(!keepManualRpm);
                                    onEdited();
                                }
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            className: "button",
                            onClick: ()=>setShowRpmInfo(true),
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "question-circle",
                                    children: "?"
                                }),
                                "  ",
                                t("more_info")
                            ]
                        })
                    })
                ]
            }),
            showRpmInfo && (0, $7b02d682eb115277$exports.jsx)((0, $43e7c9e0370237d7$export$b605456b9cec4c34), {
                title: t("rpm_title"),
                message: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.shipSetting.keep_rpm
                }),
                onClose: ()=>setShowRpmInfo(false),
                style: "info"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





// `""` represents the unset/default state (`EditPermissivenessLevel.default` == `.strict`
// server-side). An explicit `"strict"` value is behaviorally identical, so both normalize to
// the same "Default (strict)" option -- the UI never shows two different-looking selections
// for the same behavior.
function $670e17e51978e876$var$toSelectValue(level) {
    if (level == undefined || level == (0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).strict) return "";
    return level;
}
function $670e17e51978e876$export$5fd691307dbdd2b({ settings: settings, onEdited: onEdited }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipSettingsView");
    const [level, setLevel] = (0, $acw62.useState)($670e17e51978e876$var$toSelectValue(settings === null || settings === void 0 ? void 0 : settings.editPermissiveness));
    const [showInfo, setShowInfo] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setLevel($670e17e51978e876$var$toSelectValue(settings === null || settings === void 0 ? void 0 : settings.editPermissiveness));
    }, [
        settings === null || settings === void 0 ? void 0 : settings.editPermissiveness
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("hr", {}),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                    className: "block-row-followed-by-block-row",
                    children: t("edit_permissiveness_title")
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-checkboxes block-row-one-row",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("edit_permissiveness_level"),
                        labelAfter: false,
                        labelFor: "EditPermissivenessLevel",
                        children: (0, $7b02d682eb115277$exports.jsxs)("select", {
                            id: "EditPermissivenessLevel",
                            name: "editPermissiveness",
                            value: level,
                            onChange: (e)=>{
                                setLevel(e.target.value);
                                onEdited();
                            },
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: "",
                                    children: t("edit_permissiveness_level_default")
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: (0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).extended,
                                    children: t("edit_permissiveness_level_extended")
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: (0, $8cadfca9ff813a6b$export$c686a6b62750a1a2).unrestricted,
                                    children: t("edit_permissiveness_level_unrestricted")
                                })
                            ]
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            className: "button",
                            onClick: ()=>setShowInfo(true),
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "question-circle",
                                    children: "?"
                                }),
                                "  ",
                                t("more_info")
                            ]
                        })
                    })
                ]
            }),
            showInfo && (0, $7b02d682eb115277$exports.jsx)((0, $43e7c9e0370237d7$export$b605456b9cec4c34), {
                title: t("edit_permissiveness_title"),
                message: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.shipSetting.edit_permissiveness
                }),
                onClose: ()=>setShowInfo(false),
                style: "info"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");

function $737a05a2b933141d$var$TableRow({ className: className, data: data }) {
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                    "TableRow",
                    className,
                    data.onClick && "click"
                ]),
                onClick: data.onClick,
                children: [
                    data.data.map((cell, index)=>{
                        var _a;
                        return (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                                "TableCell",
                                (_a = data.cellClassNames) === null || _a === void 0 ? void 0 : _a[index]
                            ]),
                            children: cell !== null && cell !== undefined ? cell.toString() : ""
                        }, "cell" + index);
                    }),
                    data.actions && data.actions.map((action, index)=>(0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "TableCell TableAction",
                            children: action
                        }, "action" + index))
                ]
            }),
            data.content && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "TableRowContent",
                children: data.content
            })
        ]
    });
}
function $737a05a2b933141d$export$54ec01a60f47d33d({ columnWidths: columnWidths, data: data, header: header }) {
    const style = columnWidths ? {
        "--col-widths": columnWidths.join(" ")
    } : undefined;
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Table",
        style: style,
        children: [
            header && (0, $7b02d682eb115277$exports.jsx)($737a05a2b933141d$var$TableRow, {
                className: "TableHeader",
                data: Array.isArray(header) ? {
                    data: header
                } : header
            }, "header"),
            data.map((row, index)=>{
                return (0, $7b02d682eb115277$exports.jsx)($737a05a2b933141d$var$TableRow, {
                    data: row
                }, index);
            })
        ]
    });
}





function $a260b3d1b122b6e2$export$76b2721c783fdcf0({ socketAddress: socketAddress, shipId: shipId }) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const { apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const [revision, setRevision] = (0, $acw62.useState)(0);
    const available = new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(store.api()).ships.companions({
        params: {
            shipId: shipId
        }
    }).available(apiUser);
    const canDisconnect = new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(store.api()).ships.disconnectCompanion({
        params: {
            shipId: shipId,
            companionId: ""
        }
    }).available(apiUser);
    const connections = (0, $8e9aff077a3eab8f$export$3fce66e5f89ae563)(store, shipId, available, revision);
    const disconnect = (0, $acw62.useCallback)(async (companionId)=>{
        await new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(store.api()).ships.disconnectCompanion({
            params: {
                shipId: shipId,
                companionId: companionId
            }
        }).call();
        setRevision((value)=>value + 1);
    }, [
        store,
        shipId
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($a260b3d1b122b6e2$export$bd7d95b20dfe9552, {
        socketAddress: socketAddress,
        connections: connections,
        onDisconnect: canDisconnect ? disconnect : undefined
    }, shipId);
}
function $a260b3d1b122b6e2$export$bd7d95b20dfe9552({ socketAddress: socketAddress, connections: connections, onDisconnect: onDisconnect }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipSettingsView");
    const [selected, setSelected] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (!onDisconnect) setSelected(undefined);
    }, [
        onDisconnect
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "tab-content",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            className: "block_field_full",
                            children: (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: t("socket_text")
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("socket"),
                            className: "block_field_small_16",
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("input", {
                                        value: socketAddress,
                                        readOnly: true
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "button enter",
                                        onClick: ()=>{
                                            if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(socketAddress).catch(console.error);
                                            else {
                                                // Fallback for older browsers or non-secure contexts
                                                const textarea = document.createElement("textarea");
                                                textarea.value = socketAddress;
                                                textarea.style.position = "fixed";
                                                textarea.style.opacity = "0";
                                                document.body.appendChild(textarea);
                                                textarea.select();
                                                try {
                                                    document.execCommand("copy");
                                                } catch (err) {
                                                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Failed to copy:", err);
                                                }
                                                document.body.removeChild(textarea);
                                            }
                                        },
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Copy
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    connections && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("connected_companions"),
                            className: "block_field_full CompanionsView-connections",
                            children: [
                                connections.status === "loading" && (0, $7b02d682eb115277$exports.jsx)("p", {
                                    role: "status",
                                    children: t("companions_loading")
                                }),
                                connections.status === "error" && (0, $7b02d682eb115277$exports.jsx)("p", {
                                    role: "alert",
                                    children: t("companions_error")
                                }),
                                connections.status === "loaded" && (connections.companions.length === 0 ? (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: t("companions_empty")
                                }) : (0, $7b02d682eb115277$exports.jsx)((0, $737a05a2b933141d$export$54ec01a60f47d33d), {
                                    columnWidths: [
                                        "minmax(0, 1fr)",
                                        "minmax(0, 1fr)",
                                        ...onDisconnect ? [
                                            "calc(44px + 2em + 1px)"
                                        ] : []
                                    ],
                                    header: [
                                        t("companion_user"),
                                        t("companion_host"),
                                        ...onDisconnect ? [
                                            ""
                                        ] : []
                                    ],
                                    data: connections.companions.map((companion)=>({
                                            data: [
                                                companion.userName,
                                                companion.host
                                            ],
                                            actions: onDisconnect ? [
                                                (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "button CompanionsView-disconnect",
                                                    "aria-label": t("disconnect_companion_label", {
                                                        user: companion.userName,
                                                        host: companion.host
                                                    }),
                                                    title: t("disconnect_companion_label", {
                                                        user: companion.userName,
                                                        host: companion.host
                                                    }),
                                                    onClick: ()=>setSelected(companion),
                                                    children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        "aria-hidden": "true",
                                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Close
                                                        })
                                                    })
                                                }, "disconnect")
                                            ] : undefined
                                        }))
                                }))
                            ]
                        })
                    })
                ]
            }),
            selected && onDisconnect && (0, $7b02d682eb115277$exports.jsx)((0, $e7bc01546cf183b2$export$2cc85109a937009e), {
                awaitConfirm: true,
                style: "warning CompanionsView-confirm",
                title: t("disconnect_companion_title"),
                message: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: selected.userName
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: selected.host
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: t("disconnect_companion_text")
                        })
                    ]
                }),
                cancelLabel: t("cancel"),
                confirmLabel: t("disconnect_companion"),
                errorMessage: t("disconnect_companion_error"),
                onCancel: ()=>setSelected(undefined),
                onConfirm: async ()=>{
                    await onDisconnect(selected.id);
                    setSelected(undefined);
                }
            })
        ]
    });
}



const $6ea009f8c8359de8$export$db68e43250708aaf = {
    loadCompanion (api) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.companion({
            params: {}
        }).call();
    }
};


function $527628fa319e0112$export$d41a270176b156ce({ ship: ship, initTab: initTab }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const t = app.getT("ShipSettingsView");
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const companion = (0, $17817566f885d8cf$export$1bbfe1a1e23d847e)(store);
    const socketAddress = (companion === null || companion === void 0 ? void 0 : companion.ip) ? `${companion.ip}:${companion.port}` : "unknown";
    const settings = ship.shipSettings;
    const { resetShipOverlay: resetShipOverlay } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const completedCallback = (0, $acw62.useCallback)(()=>resetShipOverlay(), []);
    const onEditEvent = (0, $acw62.useCallback)((_event)=>{
        onEdited();
    }, [
        onEdited
    ]);
    const save = (0, $acw62.useCallback)(async (_data, values)=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("save", (0, $ea493e883ca706d4$export$9de129cb03ba998c)(values));
        await (0, $bf76a3a7a0d207c0$export$7c8f4ae02863d723)(store, {
            shipId: ship.id
        }).updateSettings(values);
        resetEdited();
    }, [
        store,
        ship.id,
        resetEdited
    ]);
    if (settings === undefined) return (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {});
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ShipSettingsView",
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
            closeCallback: completedCallback,
            className: "ShipSettingsView-overlay overlay-max-height",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$fe53879cede8fc3), {
                    closeCallback: completedCallback,
                    title: t("ship_settings")
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $807e05067c94e8fb$export$746af75b6b2a4bae), {
                    className: "Overlay-body",
                    readMoreLabel: t("read_more"),
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $9f9e7bca499fb8dc$export$f97dc4a5a0177256), {
                        defaultSelection: initTab || "units",
                        tabs: [
                            {
                                name: "units",
                                title: t("tab_units"),
                                render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $4aa07c0ae0c1819e$export$f38c2e306dc3b554), {
                                        settings: settings,
                                        edited: edited,
                                        onEdited: onEdited,
                                        onEditEvent: onEditEvent,
                                        save: save
                                    })
                            },
                            {
                                name: "settings",
                                title: t("tab_settings"),
                                render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                                        changed: edited,
                                        editable: true,
                                        editableFields: [
                                            {
                                                name: "timezone",
                                                type: "int",
                                                default: null
                                            },
                                            {
                                                name: "logOffset",
                                                type: "float",
                                                default: null
                                            },
                                            {
                                                name: "keepManualRpm",
                                                type: "bool"
                                            },
                                            {
                                                name: "editPermissiveness",
                                                type: "string",
                                                default: null
                                            }
                                        ],
                                        onSave: save,
                                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                            className: "tab-content block_field_53",
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $e71b677f00665e4b$export$c7577dc5f0d67840), {
                                                    settings: settings,
                                                    onEdited: onEdited,
                                                    onEditEvent: onEditEvent
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $3b30697235b5f6ce$export$977b6331d44ad90), {
                                                    settings: settings,
                                                    onEditEvent: onEditEvent
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $0cfaa0dd91d62ecf$export$701ea14e3ec19534), {
                                                    settings: settings,
                                                    onEdited: onEdited
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $670e17e51978e876$export$5fd691307dbdd2b), {
                                                    settings: settings,
                                                    onEdited: onEdited
                                                })
                                            ]
                                        })
                                    })
                            },
                            {
                                name: "companions",
                                title: t("tab_companions"),
                                render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $a260b3d1b122b6e2$export$76b2721c783fdcf0), {
                                        socketAddress: socketAddress,
                                        shipId: ship.id
                                    })
                            }
                        ]
                    })
                })
            ]
        })
    });
}







// Formats a timestamp for the "which side is more recent" comparison below. The value
// is only ever shown next to its counterpart, so a locale-default rendering is right:
// the user is comparing two of these, not reading an absolute instant.
function $fe35b684f70f88d1$var$formatMoment(value) {
    if (!value) return undefined;
    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? undefined : parsed.toLocaleString();
}
function $fe35b684f70f88d1$export$3f981f72acccae4e({ message: message }) {
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
            className: "error-message",
            children: message
        })
    });
}
function $fe35b684f70f88d1$export$724f75d0699b2486({ status: status, shipName: shipName, error: error, loading: loading, onResetLocal: onResetLocal, onResetCloud: onResetCloud, onCancel: onCancel, t: t }) {
    const claimed = (status === null || status === void 0 ? void 0 : status.claimed) === true;
    const permissionDenied = (status === null || status === void 0 ? void 0 : status.hasPrimaryPermission) === false;
    const available = !loading && !error && status != undefined && !claimed && !permissionDenied;
    const explanation = !loading && !error ? permissionDenied ? t("resync_permission_required") : claimed && (status === null || status === void 0 ? void 0 : status.claimedByThisDevice) ? t("resync_claimed_here") : undefined : undefined;
    const cloudMoment = $fe35b684f70f88d1$var$formatMoment(status === null || status === void 0 ? void 0 : status.cloudUpdatedAt);
    const localMoment = $fe35b684f70f88d1$var$formatMoment(status === null || status === void 0 ? void 0 : status.lastSync);
    return (0, $7b02d682eb115277$exports.jsx)((0, $807e05067c94e8fb$export$746af75b6b2a4bae), {
        className: "Overlay-body Overlay-body-padding message-text-bigger",
        readMoreLabel: t("read_more"),
        deps: [
            status,
            error,
            loading
        ],
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: explanation ? (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: explanation
                    }) : (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                        message: (m)=>available ? m.shipInfo.resync : m.shipInfo.resyncUnavailable,
                        replace: {
                            name: shipName || ""
                        }
                    })
                }),
                error && (0, $7b02d682eb115277$exports.jsx)($fe35b684f70f88d1$export$3f981f72acccae4e, {
                    message: error
                }),
                available && (cloudMoment || localMoment) && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "Resync-recency",
                            children: [
                                localMoment && (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        t("resync_last_sync"),
                                        ": ",
                                        localMoment
                                    ]
                                }),
                                cloudMoment && (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        t("resync_cloud_updated"),
                                        ": ",
                                        cloudMoment
                                    ]
                                })
                            ]
                        })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    actions: true,
                    className: "block-row-one-row",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button",
                                onClick: onResetLocal,
                                disabled: !available || (status === null || status === void 0 ? void 0 : status.hasLocalData) !== true,
                                children: t("resync_reset_local")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button",
                                onClick: onResetCloud,
                                disabled: !available,
                                children: t("resync_reset_cloud")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button default",
                                onClick: onCancel,
                                children: t("resync_cancel")
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function $fe35b684f70f88d1$export$8c4cf3db9b826b3f({ action: action, shipName: shipName, busy: busy, error: error, onBack: onBack, onConfirm: onConfirm, t: t }) {
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Overlay-body Overlay-body-padding message-text-bigger",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                message: (m)=>m.shipInfo[`resync_reset_${action}_confirm`],
                                replace: {
                                    name: shipName || ""
                                }
                            })
                        }),
                        error && (0, $7b02d682eb115277$exports.jsx)($fe35b684f70f88d1$export$3f981f72acccae4e, {
                            message: error
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Overlay-footer",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        actions: true,
                        className: "block-row-one-row",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button",
                                    onClick: onBack,
                                    disabled: busy,
                                    children: t("resync_confirm_cancel")
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button default",
                                    onClick: onConfirm,
                                    disabled: busy,
                                    children: t("resync_confirm_execute")
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}



var $fa2b4d03ad36b057$export$46bf80ad02f0f8c5;
(function(ShipRoutes) {
    ShipRoutes["calendar"] = "calendar";
    ShipRoutes["cruise"] = "cruise";
    ShipRoutes["edit"] = "edit";
    ShipRoutes["focus"] = "focus";
    ShipRoutes["import"] = "import";
    ShipRoutes["print"] = "print";
    ShipRoutes["printCruise"] = "printCruise";
    ShipRoutes["settings"] = "settings";
    ShipRoutes["sync"] = "sync";
    ShipRoutes["unknown"] = "unknown";
    ShipRoutes["userSwitch"] = "userSwitch";
})($fa2b4d03ad36b057$export$46bf80ad02f0f8c5 || ($fa2b4d03ad36b057$export$46bf80ad02f0f8c5 = {}));
const $fa2b4d03ad36b057$export$42a31fd9ca6839ee = {
    [$fa2b4d03ad36b057$export$46bf80ad02f0f8c5.printCruise]: {
        path: [
            "cruises",
            ":cruiseId",
            "print"
        ],
        params: {
            cruiseId: (0, $37879d0e39841979$export$7c42f1177a9c311).number
        }
    },
    [$fa2b4d03ad36b057$export$46bf80ad02f0f8c5.cruise]: {
        path: [
            "cruises",
            ":cruiseId"
        ],
        params: {
            cruiseId: (0, $37879d0e39841979$export$7c42f1177a9c311).number
        }
    },
    [$fa2b4d03ad36b057$export$46bf80ad02f0f8c5.edit]: {
        path: [
            "edit"
        ]
    },
    [$fa2b4d03ad36b057$export$46bf80ad02f0f8c5.print]: {
        path: [
            "print"
        ]
    },
    [$fa2b4d03ad36b057$export$46bf80ad02f0f8c5.focus]: {
        path: [
            "focus"
        ]
    },
    [$fa2b4d03ad36b057$export$46bf80ad02f0f8c5.sync]: {
        path: [
            "sync"
        ]
    },
    [$fa2b4d03ad36b057$export$46bf80ad02f0f8c5.settings]: {
        path: [
            "settings"
        ]
    },
    [$fa2b4d03ad36b057$export$46bf80ad02f0f8c5.userSwitch]: {
        path: [
            "userSwitch"
        ]
    },
    [$fa2b4d03ad36b057$export$46bf80ad02f0f8c5.import]: {
        path: [
            "import"
        ]
    },
    [$fa2b4d03ad36b057$export$46bf80ad02f0f8c5.calendar]: {
        path: [
            ""
        ]
    },
    [$fa2b4d03ad36b057$export$46bf80ad02f0f8c5.unknown]: {
        path: [
            "*"
        ]
    }
};




var $acw62 = parcelRequire("acw62");










const $7c940f40f95a5570$export$f157a5c743b4d49a = "fresh-validation-snapshot";
const $7c940f40f95a5570$export$46ce47382850ee04 = {
    // Eligibility is the currently open Day's crew/skipper roster (both ShipUser ids) --
    // the same roster the day's watch/crew UI already shows. The skipper (if set) is
    // listed first since they're usually the one attributing entries on someone else's
    // behalf.
    async loadEligibleShipUserIds (api) {
        var _a;
        const current = await new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.day({
            params: {}
        }).call();
        const today = (_a = current.days) === null || _a === void 0 ? void 0 : _a.days.find((d)=>d.day == current.day);
        if (!today) return [];
        return [
            ...today.skipper != undefined ? [
                today.skipper
            ] : [],
            ...today.crew || []
        ];
    },
    // Intersects the ship's full crew with today's eligible ids, restricted to active
    // ShipUsers (matches the existing ShipUserSelect convention), sorted by display label.
    eligibleShipUsers (shipUsers, eligibleIds) {
        if (!shipUsers || !eligibleIds) return [];
        return shipUsers.filter((user)=>user.active > 0 && eligibleIds.includes(user.id)).toSorted((a, b)=>(0, $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a).userLabel(a).localeCompare((0, $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a).userLabel(b)));
    }
};
function $7c940f40f95a5570$export$a5b79dddb2da569f() {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    if (!app.hasFeature("multi-user")) return null;
    return (0, $7b02d682eb115277$exports.jsx)($7c940f40f95a5570$var$EnabledUserSwitchView, {});
}
function $7c940f40f95a5570$var$EnabledUserSwitchView() {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("UserSwitchView");
    const { shipUser: realShipUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    const { actingShipUser: actingShipUser, setActingShipUser: setActingShipUser, resetShipOverlay: resetShipOverlay } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const [eligibleIds, setEligibleIds] = (0, $acw62.useState)(undefined);
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        $7c940f40f95a5570$export$46ce47382850ee04.loadEligibleShipUserIds(app.apiClient).then((ids)=>{
            if (!cancelled) setEligibleIds(ids);
        }).catch((error)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).error("UserSwitchView load eligible users", error));
        return ()=>{
            cancelled = true;
        };
    }, []);
    const eligibleUsers = (0, $acw62.useMemo)(()=>$7c940f40f95a5570$export$46ce47382850ee04.eligibleShipUsers(shipUsers, eligibleIds), [
        shipUsers,
        eligibleIds
    ]);
    const selectUser = (user)=>{
        setActingShipUser(user.id == (realShipUser === null || realShipUser === void 0 ? void 0 : realShipUser.id) ? undefined : user);
        resetShipOverlay();
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        className: "UserSwitchView",
        closeCallback: resetShipOverlay,
        title: t("title"),
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "Overlay-body",
            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: [
                    eligibleIds == undefined && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
                    }),
                    eligibleIds != undefined && eligibleUsers.length == 0 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: t("empty")
                    }),
                    eligibleUsers.map((user)=>(0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "button UserSwitchView-user" + ((actingShipUser === null || actingShipUser === void 0 ? void 0 : actingShipUser.id) == user.id ? " active" : ""),
                                onClick: ()=>selectUser(user),
                                children: (0, $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a).userLabel(user)
                            })
                        }, user.id))
                ]
            })
        })
    });
}


const $a5124d8cc1d8d792$export$999dddabbfae17ae = {
    reset (api, action) {
        const ships = new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships;
        switch(action){
            case "cloud":
                return ships.resetCloud({
                    params: {}
                }).call();
            case "local":
                return ships.resetLocal({
                    params: {}
                }).call();
        }
    },
    // Who holds the claim RIGHT NOW, straight from the cloud. Deliberately not read from
    // the ship in `FindShip()`: that is the local mirror, it arrives by sync, and this
    // dialog is only ever open because sync is broken (#1453).
    status (api) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.resyncStatus({
            params: {}
        }).call();
    }
};
var $a5124d8cc1d8d792$export$8db9b17208125660;
(function(ShipViewOverlayContent) {
    ShipViewOverlayContent["none"] = "none";
    ShipViewOverlayContent["importTrips"] = "importTrips";
    ShipViewOverlayContent["nmeaSettings"] = "nmeaSettings";
    ShipViewOverlayContent["resync"] = "resync";
    ShipViewOverlayContent["shipSettings"] = "shipSettings";
    ShipViewOverlayContent["userSwitch"] = "userSwitch";
})($a5124d8cc1d8d792$export$8db9b17208125660 || ($a5124d8cc1d8d792$export$8db9b17208125660 = {}));
/**
 * Body of the resync overlay.
 *
 * A real component rather than an inline `render` callback: `OverlayView` calls each
 * definition's `render()` inline in its own body, so hooks written there would join
 * OverlayView's hook list and change its length whenever the active overlay — or, here,
 * the local confirm step — changes. React answers that with the "Rendered more hooks than
 * during the previous render" crash (#1267), so the state and the scroll hook live in the
 * component that owns them.
 */ function $a5124d8cc1d8d792$var$ShipResyncOverlayBody() {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$678e2592ec050b6e)();
    const { navigateShip: navigateShip, resetShipOverlay: resetShipOverlay } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const t = app.getT("ShipView");
    const [confirmAction, setConfirmAction] = (0, $acw62.useState)(null);
    const [status, setStatus] = (0, $acw62.useState)(undefined);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    // Two separate errors on purpose: "I could not read the claim state" belongs to the
    // landing view, "the reset itself failed" to the confirm step. Sharing one would let
    // the status re-read that follows a failed reset wipe the message explaining it.
    const [statusError, setStatusError] = (0, $acw62.useState)(undefined);
    const [actionError, setActionError] = (0, $acw62.useState)(undefined);
    // Establish who holds the claim when the dialog opens. The mirror this used to gate
    // on (`ship.clientToken == undefined`) is delivered by sync, so in the very state
    // this dialog exists for it can say anything: it left the buttons disabled while the
    // cloud held no claim at all, and enabled for a ship another device had taken.
    const loadStatus = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setStatusError(undefined);
        try {
            setStatus(await $a5124d8cc1d8d792$export$999dddabbfae17ae.status(app.apiClient));
        } catch (failure) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("Failed to read the resync status", failure);
            setStatus(undefined);
            setStatusError(t("resync_status_failed"));
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        loadStatus();
    }, [
        loadStatus
    ]);
    const executeReset = async (action)=>{
        setBusy(true);
        setActionError(undefined);
        try {
            await $a5124d8cc1d8d792$export$999dddabbfae17ae.reset(app.apiClient, action);
        } catch (failure) {
            // #1453: this had no catch at all. `Client.call` rejects on any non-2xx, so a
            // failed reset skipped the overlay reset, the navigation AND the reload, and
            // surfaced nothing -- a dialog indistinguishable from a dead button. A refusal is
            // expected here whenever another device claimed the ship between the status read
            // and the confirm, so it has to be shown rather than swallowed.
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("Failed to reset the ship connection", failure);
            const claimed = (failure === null || failure === void 0 ? void 0 : failure.httpStatus) == 401;
            setActionError(claimed ? t("resync_reset_claimed") : t("resync_reset_failed"));
            setBusy(false);
            // Re-read the claim state so going back shows whatever is now true, rather than
            // the picture the user started from.
            loadStatus();
            return;
        }
        setBusy(false);
        resetShipOverlay();
        navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).sync);
    };
    if (confirmAction) return (0, $7b02d682eb115277$exports.jsx)((0, $fe35b684f70f88d1$export$8c4cf3db9b826b3f), {
        action: confirmAction,
        shipName: ship === null || ship === void 0 ? void 0 : ship.name,
        busy: busy,
        error: actionError,
        onBack: ()=>{
            setActionError(undefined);
            setConfirmAction(null);
        },
        onConfirm: ()=>executeReset(confirmAction),
        t: t
    });
    return (0, $7b02d682eb115277$exports.jsx)((0, $fe35b684f70f88d1$export$724f75d0699b2486), {
        status: status,
        shipName: ship === null || ship === void 0 ? void 0 : ship.name,
        error: statusError,
        loading: loading,
        onResetLocal: ()=>setConfirmAction("local"),
        onResetCloud: ()=>setConfirmAction("cloud"),
        onCancel: resetShipOverlay,
        t: t
    });
}
function $a5124d8cc1d8d792$export$9dfb40fc40d311f5(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$678e2592ec050b6e)();
    const { connected: _connected, loadShips: _loadShips, ships: _ships } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const { navigateShip: _navigateShip, shipOverlay: shipOverlay, shipOverlayOptions: _shipOverlayOptions, resetShipOverlay: resetShipOverlay, setShipOverlay: _setShipOverlay } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const t = app.getT("ShipView");
    const _ta = app.getT("AccountSettingsView");
    return (0, $7b02d682eb115277$exports.jsx)((0, $74bcfc43c0f9ac90$export$89acdd91182d6c5d), {
        overlay: shipOverlay,
        overlays: {
            [$a5124d8cc1d8d792$export$8db9b17208125660.none]: {
                render: ()=>null
            },
            // Outdated?
            [$a5124d8cc1d8d792$export$8db9b17208125660.importTrips]: {
                close: true,
                title: t("import_trips_title"),
                render: ()=>{
                    return (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "Overlay-body",
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                        message: (m)=>m.importTrips.text,
                                        replace: {
                                            name: (ship === null || ship === void 0 ? void 0 : ship.name) || ""
                                        }
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    actions: true,
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button",
                                                onClick: resetShipOverlay,
                                                children: t("import_trips_cancel")
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button default",
                                                onClick: ()=>{
                                                    // TODO: Implement file picker and import logic
                                                    resetShipOverlay();
                                                },
                                                children: t("import_trips_choose")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    });
                }
            },
            [$a5124d8cc1d8d792$export$8db9b17208125660.nmeaSettings]: {
                close: true,
                render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $b75ab3936bd2beb7$export$f8b316f44186c411), {})
            },
            [$a5124d8cc1d8d792$export$8db9b17208125660.resync]: {
                close: true,
                title: t("resync_title"),
                style: "alarm",
                className: "overlay-max-height",
                render: ()=>(0, $7b02d682eb115277$exports.jsx)($a5124d8cc1d8d792$var$ShipResyncOverlayBody, {})
            },
            [$a5124d8cc1d8d792$export$8db9b17208125660.shipSettings]: {
                close: true,
                render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $527628fa319e0112$export$d41a270176b156ce), {
                        ship: ship
                    })
            },
            [$a5124d8cc1d8d792$export$8db9b17208125660.userSwitch]: {
                close: true,
                render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $7c940f40f95a5570$export$a5b79dddb2da569f), {})
            }
        },
        resetOverlay: resetShipOverlay
    });
}




const $1dd76bba86add860$export$becaa744c5b020ee = {
    updateNmea (api, connection) {
        return new (0, $ae9d2fa06c9a6333$export$a708238267c47186)(api).nmea.update({
            params: {},
            body: {
                connection: connection
            }
        }).call();
    }
};
function $1dd76bba86add860$export$c6c6eee486a09ff6({ initOpen: initOpen }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const nmeaUpdateAvailable = new (0, $ae9d2fa06c9a6333$export$a708238267c47186)(app.apiClient).nmea.update({
        params: {},
        body: {}
    }).available(apiUser);
    const { subscriptionExpired: subscriptionExpired } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const { setShipOverlay: setShipOverlay } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const [nmeaStatus, setNmeaStatus] = (0, $acw62.useState)((_a = app.status) === null || _a === void 0 ? void 0 : _a.nmea);
    const t = app.getT("MenuNMEA");
    (0, $acw62.useEffect)(()=>{
        if (app.status && app.status.nmea) setNmeaStatus(app.status.nmea);
    }, [
        app.status
    ]);
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((status, _type)=>{
        if (status.nmea) setNmeaStatus(status.nmea);
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).AppStatus);
    const nmeaConnectionClass = (0, $acw62.useMemo)(()=>{
        if (nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.connected) return "ok";
        else if ((nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.connectionStatus) != (0, $2a692caa93051c23$export$e12d1a3b018307ad).notConfigured) return "neutral";
        return "error";
    }, [
        nmeaStatus
    ]);
    const nmeaRecordingClass = (0, $acw62.useMemo)(()=>{
        if ((nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.connectionStatus) == (0, $2a692caa93051c23$export$e12d1a3b018307ad).notConfigured || !(nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.connected)) return "";
        if ((nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.recordingStatus) == (0, $ecb722ec4ee6c8d2$export$852477b5f0e5324c).recording) return "ok";
        else if ((nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.recordingStatus) == (0, $ecb722ec4ee6c8d2$export$852477b5f0e5324c).paused) return "neutral";
        return "";
    }, [
        nmeaStatus
    ]);
    const nmeaMenuInfo = (0, $acw62.useMemo)(()=>{
        if (app.cloudSession()) return undefined;
        if (nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.connected) {
            if (nmeaStatus.recordingStatus != (0, $ecb722ec4ee6c8d2$export$852477b5f0e5324c).recording) return {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Box,
                class: "ShipView-status-ok",
                surface: "outlined"
            };
            return {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).BoxFilled,
                class: "ShipView-status-ok",
                surface: "filled"
            };
        } else if ((nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.connectionStatus) != (0, $2a692caa93051c23$export$e12d1a3b018307ad).notConfigured) return {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Box,
            class: "ShipView-status-neutral",
            surface: "outlined"
        };
        return {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Box,
            class: "ShipView-status-error",
            surface: "outlined"
        };
    }, [
        nmeaStatus
    ]);
    const nmeaConnectionToggleStatus = (0, $acw62.useMemo)(()=>{
        if ((nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.connectionStatus) == (0, $2a692caa93051c23$export$e12d1a3b018307ad).notConfigured) return (0, $07fea78136a1afdb$export$1ec60d8b994d8569).disabled;
        else if ((nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.connected) && (nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.recordingStatus)) return (0, $07fea78136a1afdb$export$1ec60d8b994d8569).on;
        return (0, $07fea78136a1afdb$export$1ec60d8b994d8569).off;
    }, [
        nmeaStatus
    ]);
    if (app.cloudSession() || !nmeaStatus || !nmeaMenuInfo) return;
    return (0, $7b02d682eb115277$exports.jsx)((0, $69cef99f64317d68$export$5a852e45fb1b6e61), {
        info: nmeaMenuInfo,
        title: t("title"),
        buttonClass: "button",
        disabled: subscriptionExpired,
        global: true,
        initOpen: initOpen,
        items: [
            {
                disabled: !nmeaStatus || nmeaStatus.connectionStatus == (0, $2a692caa93051c23$export$e12d1a3b018307ad).notConfigured,
                id: "nmea-connection",
                onClick: nmeaUpdateAvailable ? async ()=>{
                    const _response = await $1dd76bba86add860$export$becaa744c5b020ee.updateNmea(app.apiClient, !nmeaStatus.connected);
                    return true;
                } : undefined,
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleFilledLarge,
                iconClass: `ShipView-status-${nmeaConnectionClass}`,
                title: t("connection"),
                toggle: nmeaUpdateAvailable ? nmeaConnectionToggleStatus : undefined
            },
            // Option nmea-recording
            {
                disabled: (nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.connectionStatus) == (0, $2a692caa93051c23$export$e12d1a3b018307ad).notConfigured || !(nmeaStatus === null || nmeaStatus === void 0 ? void 0 : nmeaStatus.connected),
                id: "nmea-recording",
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleFilledLarge,
                iconClass: `ShipView-status-${nmeaRecordingClass}`,
                title: t("recording")
            },
            nmeaStatus.lastReceived ? {
                id: "nmea-last-update",
                title: t("last_update", {
                    timestamp: app.format("timeAgoDate", nmeaStatus.lastReceived)
                })
            } : (0, $07fea78136a1afdb$export$5b3c8d457d3cb424),
            ...nmeaUpdateAvailable ? [
                (0, $07fea78136a1afdb$export$2b6ac906eb59b21b),
                // Option nmea-settings
                {
                    id: "nmea-settings",
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Settings,
                    title: t("settings"),
                    onClick: ()=>{
                        setShipOverlay((0, $a5124d8cc1d8d792$export$8db9b17208125660).nmeaSettings);
                        return true;
                    }
                }
            ] : []
        ].filter((item)=>item)
    });
}




var $acw62 = parcelRequire("acw62");













const $5eea699e0696636c$export$fb6cf4be4cb972ef = {
    updateSync (api, enabled) {
        return new (0, $fcacc2feb92f961f$export$a022e2bb09fa7733)(api).sync.update({
            params: {},
            body: {
                enabled: enabled
            }
        }).call();
    }
};
function $5eea699e0696636c$var$InternetStatus() {
    return window.navigator.onLine ? (0, $2a692caa93051c23$export$c1d9595bd9dd489e).connected : (0, $2a692caa93051c23$export$c1d9595bd9dd489e).failed;
}
function $5eea699e0696636c$export$8968444a987e7020({ initOpen: initOpen }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const syncUpdateAvailable = new (0, $fcacc2feb92f961f$export$a022e2bb09fa7733)(app.apiClient).sync.update({
        params: {},
        body: {}
    }).available(apiUser);
    const { setShipOverlay: setShipOverlay } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const { setAppOverlay: setAppOverlay } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const [lastSync, setLastSync] = (0, $acw62.useState)(undefined);
    const [syncStatus, setSyncStatus] = (0, $acw62.useState)((_a = app.status) === null || _a === void 0 ? void 0 : _a.sync);
    const [internetStatus, setInternetStatus] = (0, $acw62.useState)(()=>{
        var _a, _b;
        return app.staticLayout ? (_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.internet) !== null && _b !== void 0 ? _b : $5eea699e0696636c$var$InternetStatus() : $5eea699e0696636c$var$InternetStatus();
    });
    const t = app.getT("MenuSync");
    (0, $acw62.useEffect)(()=>{
        if (app.status && app.status.sync && (!lastSync || !app.status.date || lastSync < app.status.date)) {
            setSyncStatus(app.status.sync);
            setLastSync(app.status.date);
        }
    }, [
        app.status
    ]);
    (0, $acw62.useEffect)(()=>{
        const updateInternetStatus = ()=>{
            setInternetStatus($5eea699e0696636c$var$InternetStatus());
        };
        window.addEventListener("online", updateInternetStatus);
        window.addEventListener("offline", updateInternetStatus);
        return ()=>{
            window.removeEventListener("online", updateInternetStatus);
            window.removeEventListener("offline", updateInternetStatus);
        };
    }, []);
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((status, _type)=>{
        if (status.sync) {
            setSyncStatus(status.sync);
            setLastSync(new Date().getTime());
        }
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).AppStatus);
    const refreshStatus = (0, $acw62.useCallback)(async ()=>{
        try {
            const next = await app.updateStatus();
            if (next.sync) {
                setSyncStatus(next.sync);
                setLastSync(new Date().getTime());
            }
        } catch (error) {
            // Keep the last known status visible; the menu remains usable offline.
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("sync menu status refresh failed", error);
        }
    }, [
        app
    ]);
    const disconnected = (0, $acw62.useMemo)(()=>{
        return (syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.status) == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).disconnected;
    }, [
        syncStatus
    ]);
    // The cloud has stopped accepting this app's session (#1449). Distinct from
    // `disconnected`, which is about a ship claim: nothing here can be fixed by
    // resyncing, only by logging in again.
    const sessionExpired = (0, $acw62.useMemo)(()=>{
        return (syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.status) == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).sessionExpired;
    }, [
        syncStatus
    ]);
    const internetStatusInfo = (0, $acw62.useMemo)(()=>{
        if (app.cloudSession()) return undefined;
        switch(internetStatus){
            case (0, $2a692caa93051c23$export$c1d9595bd9dd489e).connected:
                return {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Cloud,
                    class: "ok"
                };
            default:
                return {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).NoCloud,
                    class: "error"
                };
        }
    }, [
        internetStatus
    ]);
    const syncStatusClass = (0, $acw62.useMemo)(()=>{
        switch(syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.status){
            case (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).current:
                if (internetStatus == (0, $2a692caa93051c23$export$c1d9595bd9dd489e).connected) {
                    if (syncStatus.enabled) return "ok";
                    return "error";
                } else {
                    if (syncStatus.enabled) return "neutral";
                    return "error";
                }
            case (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).disconnected:
                return "error";
            // Red, not the neutral "something is in flight" the default arm would give it:
            // nothing will sync again until the user logs back in (#1449).
            case (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).sessionExpired:
                return "error";
            case (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).inProgress:
            case (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).paused:
            case (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).failed:
                if (internetStatus == (0, $2a692caa93051c23$export$c1d9595bd9dd489e).connected) {
                    if (syncStatus.enabled) return "neutral";
                    return "error";
                } else {
                    if (syncStatus.enabled) return "neutral";
                    return "error";
                }
            default:
                return "neutral";
        }
    }, [
        internetStatus,
        syncStatus
    ]);
    const syncMenuInfo = (0, $acw62.useMemo)(()=>{
        if (internetStatus == (0, $2a692caa93051c23$export$c1d9595bd9dd489e).failed && (syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.enabled)) return {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).NoCloud,
            class: "ShipView-status-neutral",
            surface: "outlined"
        };
        else if ((syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.status) == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).sessionExpired) // Ahead of the `enabled` arms below: sync is still switched on, it just cannot
        // reach the cloud with a session the cloud refuses (#1449).
        return {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).BoxFilled,
            class: "ShipView-status-error",
            surface: "filled"
        };
        else if ((syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.status) == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).disconnected) return {
            icon: internetStatus == (0, $2a692caa93051c23$export$c1d9595bd9dd489e).connected ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).BoxFilled : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).NoCloud,
            class: "ShipView-status-error",
            surface: internetStatus == (0, $2a692caa93051c23$export$c1d9595bd9dd489e).connected ? "filled" : "outlined"
        };
        else if (internetStatus == (0, $2a692caa93051c23$export$c1d9595bd9dd489e).failed && !(syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.enabled)) return {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).NoCloud,
            class: "ShipView-status-error",
            surface: "outlined"
        };
        else if ((syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.enabled) && (syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.status) == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).current) return {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).BoxFilled,
            class: "ShipView-status-ok",
            surface: "filled"
        };
        else if ((syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.enabled) && (syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.status) !== (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).current) return {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).BoxFilled,
            class: "ShipView-status-neutral",
            surface: "filled"
        };
        return {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Box,
            class: "ShipView-status-error",
            surface: "outlined"
        };
    }, [
        internetStatus,
        syncStatus
    ]);
    const syncStatusToggle = (0, $acw62.useMemo)(()=>{
        return (syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.enabled) ? (0, $07fea78136a1afdb$export$1ec60d8b994d8569).on : (0, $07fea78136a1afdb$export$1ec60d8b994d8569).off;
    }, [
        syncStatus
    ]);
    if (app.cloudSession() || !syncStatus) return;
    return (0, $7b02d682eb115277$exports.jsx)((0, $69cef99f64317d68$export$5a852e45fb1b6e61), {
        info: syncMenuInfo,
        title: t("title"),
        buttonClass: "button MenuSync-button",
        global: true,
        initOpen: initOpen,
        onClick: (open)=>{
            if (open) refreshStatus();
        },
        items: [
            // Option internet-status
            // missing the functions which determines the internet status
            !internetStatusInfo ? (0, $07fea78136a1afdb$export$5b3c8d457d3cb424) : {
                id: "internet-status",
                icon: internetStatusInfo.icon,
                iconClass: `ShipView-status-${internetStatusInfo.class}`,
                title: t("internet_status")
            },
            // Option sync-status
            sessionExpired ? {
                // Neither the sync toggle nor a resync can help: the cloud is refusing this
                // app's session, so the only useful action is logging in again (#1449).
                id: "relogin",
                onClick: async ()=>{
                    setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).sessionExpired);
                    return true;
                },
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Refresh,
                iconClass: `ShipView-status-error`,
                title: t("relogin")
            } : disconnected ? {
                id: "resync",
                onClick: syncUpdateAvailable ? async ()=>{
                    setShipOverlay((0, $a5124d8cc1d8d792$export$8db9b17208125660).resync);
                    return true;
                } : undefined,
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Refresh,
                iconClass: `ShipView-status-error`,
                title: t("resync")
            } : {
                // disabled: internetStatus !== ILogbookAppInternetStatus.connected,
                id: "sync-status",
                onClick: syncUpdateAvailable ? async ()=>{
                    const _response = await $5eea699e0696636c$export$fb6cf4be4cb972ef.updateSync(app.apiClient, !(syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.enabled));
                    return true;
                } : undefined,
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleFilledLarge,
                iconClass: `ShipView-status-${syncStatusClass}`,
                title: t("status"),
                toggle: syncUpdateAvailable ? syncStatusToggle : undefined
            }
        ]
    });
}





var $acw62 = parcelRequire("acw62");








const $4e8b2ff48a301b53$var$knownTokens = [
    "ship",
    "type"
];
const $4e8b2ff48a301b53$var$validTypes = [
    "cruise",
    "day",
    "log",
    "note",
    "trip"
];
const $4e8b2ff48a301b53$export$2f3882f18084bdf = "transient-query-projection";
const $4e8b2ff48a301b53$export$c8fec54fd1376413 = {
    search (api, query) {
        return new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(api).account.search({
            params: {},
            body: {
                query: query
            }
        }).call();
    },
    // Normalize a `key:value` split into a `[key, value]` token, clamping to two parts.
    ensureSearchToken (input) {
        let token = input;
        if (input.length > 2) token = input.slice(0, 2);
        return [
            token[0] || "",
            token[1] || ""
        ];
    },
    // A `key:value` fragment is a token only when it has a colon and a known key.
    isValidToken (input) {
        return input.indexOf(":") > 0 && $4e8b2ff48a301b53$var$knownTokens.indexOf(input.split(":", 2)[0].toLowerCase()) >= 0;
    },
    // Split a raw input string into its recognized tokens and the residual free-text
    // query. When no tokens are present the whole string is the query.
    parseInput (value) {
        const tokens = value.split(" ").filter((q)=>$4e8b2ff48a301b53$export$c8fec54fd1376413.isValidToken(q)).map((q)=>$4e8b2ff48a301b53$export$c8fec54fd1376413.ensureSearchToken(q.split(":", 2)));
        const query = tokens.length > 0 ? value.split(" ").filter((q)=>!$4e8b2ff48a301b53$export$c8fec54fd1376413.isValidToken(q)).join(" ") : value;
        return {
            tokens: tokens,
            query: query
        };
    },
    // Human-readable value for a token; `type` values map through the localized label.
    tokenValue (token, t) {
        if (token[0] == "type") {
            if (typeof token[1] == "string" && $4e8b2ff48a301b53$var$validTypes.indexOf(token[1]) >= 0) return t(`type_${token[1]}`);
        }
        return token[1].toString();
    }
};
function $4e8b2ff48a301b53$export$a7f9a17ce88d8bab(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const _ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const t = app.getT("SearchView");
    const inputRef = (0, $acw62.useRef)(null);
    const menuRef = (0, $8a8193ceb042f538$export$ba657787b573294a)();
    const [tokens, setTokens] = (0, $acw62.useState)([]);
    const [query, setQuery] = (0, $acw62.useState)("");
    const [results, setResults] = (0, $acw62.useState)(undefined);
    const [searching, setSearching] = (0, $acw62.useState)();
    const performSearch = (0, $acw62.useCallback)(async (query, tokens)=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("performSearch", query, tokens);
        if (query == "") return;
        const search = [
            ...tokens.map((t)=>`${t[0]}:${t[1]}`),
            query
        ].join(" ");
        if (search == "") return;
        setResults(undefined);
        setSearching(true);
        const result = await $4e8b2ff48a301b53$export$c8fec54fd1376413.search(app.apiClient, query);
        setResults(result);
        setSearching(false);
    }, [
        tokens,
        query
    ]);
    const deleteToken = (0, $acw62.useCallback)((index)=>{
        setTokens(tokens.toSpliced(index, 1));
        performSearch(query, tokens);
    }, [
        tokens
    ]);
    const resetSearch = (0, $acw62.useCallback)(()=>{
        var _a;
        if (query == "" && tokens.length < 1) {
            (_a = menuRef.current) === null || _a === void 0 || _a.setSelected(false);
            return;
        }
        setTokens([]);
        setQuery("");
        setResults(undefined);
        if (inputRef.current) inputRef.current.value = "";
    }, [
        tokens,
        query
    ]);
    const searchKeyDown = (0, $acw62.useCallback)((e)=>{
        if (e.key == "Enter") {
            if (inputRef.current) inputRef.current.blur();
            updateSearch(true);
        } else if (e.key == " ") updateSearch(false);
    }, [
        tokens,
        query
    ]);
    const typeFilter = (0, $acw62.useMemo)(()=>{
        const token = tokens.filter((t)=>t[0] == "type");
        if (token.length > 0) return token[0][1];
        return undefined;
    }, [
        tokens
    ]);
    const setTypeFilter = (0, $acw62.useCallback)((type)=>{
        if (typeof type != "string") return;
        if (!typeFilter) setTokens([
            ...tokens,
            [
                "type",
                type
            ]
        ]);
    }, [
        tokens
    ]);
    const updateSearch = (0, $acw62.useCallback)((perform = true)=>{
        let newQuery = query;
        if (inputRef.current) {
            const value = inputRef.current.value;
            const { tokens: newTokens, query: parsedQuery } = $4e8b2ff48a301b53$export$c8fec54fd1376413.parseInput(value);
            if (newTokens.length > 0) {
                newQuery = parsedQuery;
                inputRef.current.value = newQuery;
                setTokens([
                    ...tokens,
                    ...newTokens
                ]);
            } else newQuery = value;
            setQuery(newQuery);
        }
        if (perform) performSearch(newQuery, tokens);
    }, [
        query,
        tokens
    ]);
    function tokenLabel(token) {
        if ($4e8b2ff48a301b53$var$knownTokens.indexOf(token.toLowerCase())) return t(`token_${token}`);
        return token;
    }
    function tokenValue(token) {
        return $4e8b2ff48a301b53$export$c8fec54fd1376413.tokenValue(token, t);
    }
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "SearchView",
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), {
            button: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Search
            }),
            buttonClass: "button",
            callbacks: menuRef,
            global: true,
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$2ce376c2cc3355c8), {
                    id: "search-query",
                    className: "SearchView-query-menu-item",
                    children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "SearchView-query",
                        children: [
                            tokens.map((t, i)=>{
                                return (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "SearchView-token",
                                    onClick: ()=>deleteToken(i),
                                    children: [
                                        tokenLabel(t[0]),
                                        ": ",
                                        tokenValue(t),
                                        " ",
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Close
                                        })
                                    ]
                                }, `search-token-${t[0]}-${t[1]}`);
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: "search",
                                onBlur: ()=>updateSearch(true),
                                onKeyDown: searchKeyDown,
                                ref: inputRef
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "SearchView-clear",
                                onClick: resetSearch,
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Close
                                })
                            })
                        ]
                    })
                }),
                (searching || results) && (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$dc41ded8bb6141d8), {}, "divider"),
                searching && (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "Menu-item disabled",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
                }),
                results && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: (typeFilter ? [
                        typeFilter
                    ] : Object.keys(results.results).toSorted()).flatMap((k, i)=>{
                        return [
                            (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "Menu-item" + (results.results[k].results.length < 1 ? " disabled" : ""),
                                onClick: ()=>setTypeFilter(k),
                                children: [
                                    t(`type_${k}`),
                                    " results (",
                                    results.results[k].results.length,
                                    ")"
                                ]
                            }, `search-result-header-${k}`),
                            ...results.results[k].results.map((r)=>{
                                return (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "Menu-item",
                                    children: [
                                        k,
                                        " ",
                                        r.id,
                                        " ",
                                        Object.entries(r.matches).map((m)=>`${m[0]}: ${m[1]}`).join(" ")
                                    ]
                                }, `search-result-${k}-${r.id}`);
                            }),
                            ...!typeFilter && i < $4e8b2ff48a301b53$var$validTypes.length - 1 ? [
                                (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$dc41ded8bb6141d8), {}, "divider")
                            ] : []
                        ];
                    })
                })
            ]
        })
    });
}



function $5878af5c58bfa741$export$e6ea0c07cce3c59c({ actions: actions, customMenus: customMenus, monitors: monitors, shipHeader: _shipHeader }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const { navigateApp: navigateApp } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const { focusActive: focusActive, navigateShip: navigateShip } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const t = app.getT("ShipView");
    const shipContainerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const updateHeaderHeight = ()=>{
            if (shipContainerRef.current) document.documentElement.style.setProperty("--ship-header-height", `${shipContainerRef.current.offsetHeight}px`);
        };
        updateHeaderHeight();
        const resizeObserver = new ResizeObserver(updateHeaderHeight);
        if (shipContainerRef.current) resizeObserver.observe(shipContainerRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        ship,
        actions,
        customMenus,
        focusActive,
        monitors
    ]);
    // The Focus button carries navigation state the way NMEA/Sync carry theirs
    // (@almute, #916): always blue, outlined while navigation is stopped and filled
    // while it is running. Distinct from `focusActive`, which is only whether the
    // Focus tab is the one on screen — that stays the `selected` ring.
    const navigationActive = (0, $acw62.useMemo)(()=>{
        var _a;
        return ((_a = app.status) === null || _a === void 0 ? void 0 : _a.navigation) == true;
    }, [
        app.status
    ]);
    const headerInfos = (0, $acw62.useMemo)(()=>{
        if (!ship) return [];
        const shipData = (0, $22871482fce5b7e5$export$7930c61d9b464618).shipData(ship);
        return [
            shipData === null || shipData === void 0 ? void 0 : shipData.callsign,
            shipData === null || shipData === void 0 ? void 0 : shipData.mmsi,
            shipData === null || shipData === void 0 ? void 0 : shipData.yachtModelName
        ].filter(Boolean);
    }, [
        ship
    ]);
    // One list, built once and rendered into both menu blocks. The two are
    // shown/hidden by `AppHeaderView.scss`'s mobile breakpoint rather than by a
    // media query in JS, so both must exist in the DOM -- but their contents were
    // otherwise identical, and keeping two copies of the array meant every addition
    // had to be made twice or silently miss a breakpoint. The monitors are the one
    // thing that genuinely differs, so they take the block's own `collapsed`.
    const menuItems = (0, $acw62.useCallback)((collapsed)=>[
            app.cloudSession() && (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                className: "row-right",
                onClick: ()=>navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings)
            }, "close"),
            monitors && (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: monitors(collapsed)
            }, "monitors"),
            ...(customMenus || []).map((m, i)=>(0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    children: m
                }, `custom-${i}`)),
            actions && actions.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), {
                button: t("menu_action_title"),
                buttonClass: "button",
                global: true,
                items: actions
            }, "action"),
            !app.cloudSession() && (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                    "button",
                    "ShipView-menu-button",
                    navigationActive ? "ShipView-menu-button-filled" : "ShipView-menu-button-outlined",
                    focusActive && "selected"
                ]),
                onClick: ()=>focusActive ? history.back() : navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).focus),
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleLarge
                    }),
                    t("menu_now")
                ]
            }, "now"),
            (0, $7b02d682eb115277$exports.jsx)((0, $1dd76bba86add860$export$c6c6eee486a09ff6), {}, "nmea"),
            (0, $7b02d682eb115277$exports.jsx)((0, $5eea699e0696636c$export$8968444a987e7020), {}, "sync"),
            app.hasFeature("search") && (0, $7b02d682eb115277$exports.jsx)((0, $4e8b2ff48a301b53$export$a7f9a17ce88d8bab), {}, "search")
        ], [
        app,
        actions,
        customMenus,
        monitors,
        focusActive,
        navigateApp,
        navigateShip,
        t
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ShipView-ship-container",
        ref: shipContainerRef,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ShipView-header-fill pre",
                children: (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "content"
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ShipView-header",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ShipView-title",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                icon: (ship === null || ship === void 0 ? void 0 : ship.vesselType) == 2 ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).SailingVessel : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).MotorVessel
                            }),
                            ship && ship.name,
                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "spacer"
                            }),
                            headerInfos.map((item, i)=>(0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "ShipView-ship-info",
                                    children: item
                                }, `ship-info-${i}`)).reduce((acc, x)=>{
                                return !acc ? x : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        acc,
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "spacer"
                                        }),
                                        x
                                    ]
                                });
                            }, (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}))
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ShipView-menus",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ShipView-menus-mobile",
                                children: menuItems(true)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ShipView-menus-desktop",
                                children: menuItems(false)
                            })
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ShipView-header-fill post",
                children: (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "content"
                })
            })
        ]
    });
}






var $acw62 = parcelRequire("acw62");
function $51141e37452020dd$export$66a0ba5751a02e9e({ before: before, count: count, width: width }) {
    const markers = (0, $acw62.useMemo)(()=>{
        const n = count || 12;
        const padding = 24 - width;
        return Array.from(Array(n).keys()).map((i)=>{
            const mi = before ? i : n - i;
            const percentage = mi / n;
            return (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "marker",
                style: {
                    opacity: percentage,
                    marginLeft: `${padding}px`,
                    width: `${width}px`
                }
            }, `marker-${i}`);
        });
    }, [
        before,
        count,
        width
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "TimelineFade",
        children: markers
    });
}



function $f16e30f46f3691ef$export$f626b616da0238a5({ trips: trips }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("CruiseView");
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CruiseView-content",
        children: [
            trips.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $51141e37452020dd$export$66a0ba5751a02e9e), {
                before: true,
                count: 8,
                width: 18
            }),
            trips.map((trip)=>(0, $7b02d682eb115277$exports.jsx)((0, $8b93cdbcae4a2de3$export$62031b35b640577c), {
                    trip: trip
                }, `trip-${trip.id}`)),
            trips.length < 1 && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "empty",
                children: t("empty")
            }),
            trips.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $51141e37452020dd$export$66a0ba5751a02e9e), {
                before: false,
                width: 18
            })
        ]
    });
}



const { Context: $716868446e6e4e7e$export$fd3f5773bb5c0ec4, useData: $716868446e6e4e7e$export$39c7a8525ff47de7 } = (0, $480db5fef2358c2d$export$1f628e93c0b28291)("CruiseDataView");



















const $37cf3cfb5e173f6f$export$3099842798b259 = {
    saveCruise (api, shipId, cruiseId, values) {
        return new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(api).cruises.update({
            params: {
                shipId: shipId,
                cruiseId: cruiseId
            },
            body: values
        }).call();
    },
    // `title` is plain text (issue #529 consistency pass) -- the registered "text"
    // format kind, so it gets the shared "–" convention for a missing value but no
    // unit/locale formatting.
    fieldFormat () {
        return {
            title: "text"
        };
    }
};
function $37cf3cfb5e173f6f$export$f29aab1572886fb0({ cruise: cruise }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const shipView = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const { writers: writers } = (0, $716868446e6e4e7e$export$39c7a8525ff47de7)();
    const t = app.getT("CruiseEditView");
    const editableFields = [
        {
            name: "title",
            default: "",
            type: "string"
        }
    ];
    const formEditable = app.editable || shipView.shipCloudEditable;
    const { edited: edited, onEdited: onEdited, saveEdits: saveEdits } = (0, $58cbd7a8fa422027$export$d3b8d51a855c78a3)({
        update: writers.updateCruise
    });
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "CruiseEditView",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                    buttonFirst: true,
                    changed: edited,
                    editable: formEditable,
                    editableFields: editableFields,
                    onSave: saveEdits,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("title"),
                            className: "block_field_small_30",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                defaultValue: cruise.title,
                                name: "title",
                                onChange: onEdited,
                                readOnly: !formEditable,
                                maxLength: 40
                            })
                        })
                    })
                })
            })
        })
    });
}



function $618ed7431d898110$export$85e406cce5c00918({ cruise: cruise, tracks: tracks, initTab: initTab, tabBarRef: tabBarRef, onPrint: onPrint }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("CruiseView");
    const { writers: writers } = (0, $716868446e6e4e7e$export$39c7a8525ff47de7)();
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "CruiseView-details",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $9f9e7bca499fb8dc$export$f97dc4a5a0177256), {
            defaultSelection: initTab || "cruise",
            callbacks: tabBarRef,
            tabs: [
                {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Cruise,
                    name: "cruise",
                    title: t("tab_cruise"),
                    render: ()=>{
                        return (0, $7b02d682eb115277$exports.jsx)((0, $37cf3cfb5e173f6f$export$f29aab1572886fb0), {
                            cruise: cruise
                        });
                    }
                },
                {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Stats,
                    name: "stats",
                    title: t("tab_stats"),
                    render: ()=>{
                        return (0, $7b02d682eb115277$exports.jsx)((0, $198e3b0852fb0b06$export$1e3e8ecfe0e6273a), {
                            cruise: cruise,
                            calculate: writers.calculateCruise
                        });
                    }
                },
                {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Track,
                    name: "track",
                    title: t("tab_track"),
                    render: ()=>{
                        var _a, _b;
                        return (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "CruiseView-track",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $7e01767afef66f8e$export$600f95652e45663), {
                                fullscreen: false,
                                tracks: tracks,
                                timezone: (_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.systemTimezone) !== null && _b !== void 0 ? _b : 0
                            })
                        });
                    }
                },
                ...(0, $59a722b1b33d4469$export$2a7d663d787aca05)(app, (0, $d460697aab603bc5$export$5daa50148070bda5).cruise, cruise.notes || []),
                {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Print,
                    name: "print",
                    title: t("tab_print"),
                    render: ()=>{
                        return (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "CruiseView-print-tab",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "block-row-button-print",
                                children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "button",
                                    onClick: onPrint,
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Print,
                                            className: "icon-large"
                                        }),
                                        " ",
                                        t("print_cruise")
                                    ]
                                })
                            })
                        });
                    }
                }
            ]
        })
    });
}






function $51457e0a92c769ec$export$25ed6b93b9bfe9fb({ cruise: cruise, onDetailsChange: onDetailsChange, onClose: onClose }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("CruiseView");
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CruiseView-title",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $5c760195bdd4d0c9$export$1aa7c7ccc1c44ab8), {
                onChange: onDetailsChange
            }),
            (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "title",
                children: cruise.title || t("untitled_cruise")
            }),
            " ",
            cruise.startedAt && (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "CruiseView-date-range",
                children: [
                    "(",
                    cruise.startedAt && app.format("date", cruise.startedAt),
                    " - ",
                    cruise.completedAt ? app.format("date", cruise.completedAt) : "",
                    ")"
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                onClick: onClose
            })
        ]
    });
}


function $37b66cfb64811cb0$export$e921efb0a59adee7({ cruiseChildren: cruiseChildren, cruiseId: cruiseId, focus: focus, initDetails: initDetails, initTab: initTab }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const { navigateShip: navigateShip, setPrinting: setPrinting } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const { cruise: cruise, tracks: tracks, trips: trips } = (0, $716868446e6e4e7e$export$39c7a8525ff47de7)();
    const t = app.getT("CruiseView");
    const [details, setDetails] = (0, $acw62.useState)(initDetails || false);
    const [showLabels, setShowLabels] = (0, $acw62.useState)(false);
    const tabBarRef = (0, $8a8193ceb042f538$export$ba657787b573294a)();
    const currentCruise = ((_a = app.current) === null || _a === void 0 ? void 0 : _a.cruiseId) === cruiseId;
    const actions = (0, $acw62.useMemo)(()=>[], [
        cruise,
        ship,
        trips,
        app.current
    ]);
    const shipHeader = (0, $acw62.useMemo)(()=>{
        const ShipHeader = ()=>(0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
        return ShipHeader;
    }, [
        cruise,
        details,
        ship,
        trips
    ]);
    const toggleLabels = (0, $acw62.useCallback)(()=>{
        setShowLabels((current)=>!current);
    }, []);
    const menus = (0, $acw62.useMemo)(()=>{
        if (!app.hasFeature("labels")) return [];
        return [
            (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), {
                button: t("menu_labels"),
                buttonClass: "button",
                global: true,
                items: [
                    {
                        id: "toggle-labels",
                        onClick: toggleLabels,
                        title: t(`menu_toggle_labels_${showLabels ? "on" : "off"}`)
                    }
                ]
            }, "labels")
        ];
    }, [
        app,
        showLabels,
        t,
        toggleLabels
    ]);
    if (!cruise) return (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {});
    const state = {
        cruise: cruise,
        showLabels: showLabels,
        trips: trips || []
    };
    return (0, $7b02d682eb115277$exports.jsxs)((0, $97ac05743b787a86$export$3b6211c622665b21).Provider, {
        value: state,
        children: [
            !cruiseChildren && (0, $7b02d682eb115277$exports.jsx)((0, $5878af5c58bfa741$export$e6ea0c07cce3c59c), {
                actions: actions,
                customMenus: menus,
                shipHeader: shipHeader
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                    "CruiseView",
                    currentCruise && "current",
                    focus && "focus"
                ]),
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $51457e0a92c769ec$export$25ed6b93b9bfe9fb), {
                        cruise: cruise,
                        onDetailsChange: setDetails,
                        onClose: ()=>navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).calendar)
                    }),
                    details && (0, $7b02d682eb115277$exports.jsx)((0, $618ed7431d898110$export$85e406cce5c00918), {
                        cruise: cruise,
                        tracks: tracks,
                        initTab: initTab,
                        tabBarRef: tabBarRef,
                        onPrint: ()=>setPrinting((0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).cruise, cruise)
                    }),
                    cruiseChildren ? cruiseChildren : trips ? (0, $7b02d682eb115277$exports.jsx)((0, $f16e30f46f3691ef$export$f626b616da0238a5), {
                        trips: trips
                    }) : (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







function $555d6d1bbbcdb505$export$69d1db8a0e1550bd(store, ids) {
    return {
        updateCruise: (values)=>{
            const current = store.getEntity("Cruise", ids.cruiseId);
            const optimistic = current ? Object.assign(Object.assign({}, current), values) : undefined;
            return store.mutate({
                optimistic: optimistic ? {
                    upsert: {
                        Cruise: [
                            optimistic
                        ]
                    }
                } : undefined,
                request: (client)=>new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(client).cruises.update({
                        params: ids,
                        body: values
                    }).call(),
                reconcile: (response)=>{
                    const latest = store.getEntity("Cruise", ids.cruiseId);
                    return {
                        entities: {
                            Cruise: optimistic && latest !== optimistic ? [] : [
                                (0, $ae46f0fc3022c13d$export$88b555fcfe17b5a)(response, latest)
                            ]
                        }
                    };
                }
            });
        },
        calculateCruise: ()=>store.mutate({
                request: (client)=>new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(client).cruises.calculate({
                        params: ids
                    }).call()
            })
    };
}
const $555d6d1bbbcdb505$var$rejectNoop = (name)=>()=>Promise.reject(new Error(`noopCruiseWriters.${name}: no writer provided (read-only Cruise context)`));
const $555d6d1bbbcdb505$export$7b487d1e166e0240 = {
    updateCruise: $555d6d1bbbcdb505$var$rejectNoop("updateCruise"),
    calculateCruise: $555d6d1bbbcdb505$var$rejectNoop("calculateCruise")
};



const $7f7a38d85b97078e$var$CruiseRecordDeps = (0, $a9e25f5507c22ba4$export$a23f992de0d45ff0)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Ship, {
    cruises: (0, $9db39e34b2fb118a$export$14badfee79ea396f)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Cruise, {
        with: [
            "calculated",
            "calculatedV2",
            "notes"
        ]
    })
});
const $7f7a38d85b97078e$var$CruiseTripDeps = (0, $a9e25f5507c22ba4$export$a23f992de0d45ff0)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Cruise, {
    trips: (0, $9db39e34b2fb118a$export$14badfee79ea396f)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Trip, {
        with: [
            "calculated",
            "calculatedV2",
            "notes"
        ]
    })
});
const $7f7a38d85b97078e$var$CruiseTrackDeps = (0, $a9e25f5507c22ba4$export$a23f992de0d45ff0)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Cruise, {
    tracks: (0, $9db39e34b2fb118a$export$14badfee79ea396f)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Track)
});
function $7f7a38d85b97078e$var$nestedRows(cruise, trips, tracks) {
    var _a;
    const notes = [
        ...(_a = cruise === null || cruise === void 0 ? void 0 : cruise.notes) !== null && _a !== void 0 ? _a : [],
        ...trips.flatMap((trip)=>{
            var _a;
            return (_a = trip.notes) !== null && _a !== void 0 ? _a : [];
        })
    ];
    return Object.assign({
        Cruise: cruise ? [
            cruise
        ] : [],
        Trip: trips,
        Track: tracks
    }, (0, $5bd541aff0182fa0$export$e9bc97ba61bf8e52)(notes));
}
function $7f7a38d85b97078e$var$CruiseDataInner({ cruiseChildren: cruiseChildren, cruiseId: cruiseId, initialCruise: initialCruise, initTracks: initTracks, initTrips: initTrips, children: children }) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const cruiseIds = {
        shipId: ship.id,
        cruiseId: cruiseId
    };
    const recordIds = {
        shipId: ship.id
    };
    const tripIds = {
        shipId: ship.id,
        cruiseId: cruiseId
    };
    const trackIds = {
        shipId: ship.id,
        cruiseId: cruiseId
    };
    const { cruises: cruises } = (0, $e9db94b1c3310c7c$export$a37ae8cf05d96586)($7f7a38d85b97078e$var$CruiseRecordDeps, recordIds, {
        fetch: false
    });
    const { trips: trips } = (0, $e9db94b1c3310c7c$export$a37ae8cf05d96586)($7f7a38d85b97078e$var$CruiseTripDeps, tripIds, {
        fetch: false
    });
    const { tracks: tracks } = (0, $e9db94b1c3310c7c$export$a37ae8cf05d96586)($7f7a38d85b97078e$var$CruiseTrackDeps, trackIds, {
        fetch: false
    });
    const writers = (0, $acw62.useMemo)(()=>(0, $555d6d1bbbcdb505$export$69d1db8a0e1550bd)(store, {
            shipId: ship.id,
            cruiseId: cruiseId
        }), [
        store,
        ship.id,
        cruiseId
    ]);
    const seededTripIds = (0, $c80a929f5eac5ac1$export$927dafc935d4aea5)(initTrips, (0, $1bedde6805bf6e79$export$f55210826850c514).Trip, (trip)=>trip.cruiseId === cruiseId);
    const seededTrackIds = (0, $c80a929f5eac5ac1$export$927dafc935d4aea5)(initTracks, (0, $1bedde6805bf6e79$export$f55210826850c514).Track, (track)=>track.cruiseId === cruiseId);
    const cruiseReady = (0, $29504a259cf4b663$export$c40434fbcbfd3fb6)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Cruise, cruiseIds, initialCruise === undefined, initialCruise !== undefined);
    const tripsReady = (0, $29504a259cf4b663$export$c40434fbcbfd3fb6)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Trip, tripIds, !cruiseChildren && initTrips === undefined, initTrips !== undefined);
    const tracksReady = (0, $29504a259cf4b663$export$c40434fbcbfd3fb6)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Track, trackIds, initTracks === undefined, initTracks !== undefined);
    const resolvedCruise = cruiseReady ? cruises.find((candidate)=>candidate.id === cruiseId) : undefined;
    const selectedTrips = seededTripIds ? trips.filter((trip)=>seededTripIds.has(trip.id)) : trips;
    const selectedTracks = seededTrackIds ? tracks.filter((track)=>seededTrackIds.has(track.id)) : tracks;
    const resolvedTrips = tripsReady ? selectedTrips : undefined;
    const resolvedTracks = tracksReady ? selectedTracks : undefined;
    const value = (0, $acw62.useMemo)(()=>({
            cruise: resolvedCruise,
            trips: resolvedTrips,
            tracks: resolvedTracks,
            writers: writers
        }), [
        resolvedCruise,
        resolvedTrips,
        resolvedTracks,
        writers
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $716868446e6e4e7e$export$fd3f5773bb5c0ec4).Provider, {
        value: value,
        children: children
    });
}
function $7f7a38d85b97078e$export$bc32b7efeb532bf5(props) {
    var _a, _b;
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const seed = $7f7a38d85b97078e$var$nestedRows(props.initialCruise, (_a = props.initTrips) !== null && _a !== void 0 ? _a : [], (_b = props.initTracks) !== null && _b !== void 0 ? _b : []);
    const seedRef = (0, $acw62.useRef)(seed);
    seedRef.current = seed;
    const seedRevision = JSON.stringify(seed);
    (0, $acw62.useState)(()=>{
        if (!props.storeBacked) store.applyBundle({
            entities: seed
        });
        return true;
    });
    (0, $acw62.useEffect)(()=>{
        if (!props.storeBacked) store.applyBundle({
            entities: seedRef.current
        });
    }, [
        store,
        seedRevision,
        props.storeBacked
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($7f7a38d85b97078e$var$CruiseDataInner, Object.assign({}, props, {
        children: props.children
    }));
}



const $74ca5213c8b5ce63$export$94ed28054b42d910 = {
    loadCruise (api, shipId, cruiseId) {
        return new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(api).cruises.get({
            params: {
                shipId: shipId,
                cruiseId: cruiseId
            }
        }).call();
    },
    loadTrips (api, shipId, cruiseId) {
        return new (0, $84aa1a3b4df5a78b$export$5e13e029a186945f)(api).trips.list({
            params: {
                shipId: shipId,
                cruiseId: cruiseId
            }
        }).call();
    },
    loadTracks (api, shipId, cruiseId) {
        return new (0, $655725c259161537$export$2f8f7bdb7e386612)(api).tracks.cruise({
            params: {
                shipId: shipId,
                cruiseId: cruiseId
            }
        }).call();
    }
};


var $561bc7c82d705725$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $561bc7c82d705725$var$CruiseDataViewWithUI = (0, $480db5fef2358c2d$export$ae24a3dd6105e285)({
    acquire: (0, $7f7a38d85b97078e$export$bc32b7efeb532bf5),
    ui: (0, $37b66cfb64811cb0$export$e921efb0a59adee7)
});
function $561bc7c82d705725$export$18ac525d13abc8df(_a) {
    var { children: children } = _a, props = $561bc7c82d705725$var$__rest(_a, [
        "children"
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($561bc7c82d705725$var$CruiseDataViewWithUI, Object.assign({}, props, {
        cruiseChildren: children
    }));
}




var $acw62 = parcelRequire("acw62");










const $75b9a65df93a7eb1$export$74f99c21288f6416 = {
    loadCruises (api, shipId) {
        return new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(api).cruises.list({
            params: {
                shipId: shipId
            }
        }).call();
    },
    // On a cloud session only cruises that have actually started are shown; locally
    // every cruise is kept. The result is sorted ascending by start date (an undefined
    // start sorts as "now").
    sortCruises (cruises, cloudSession) {
        return (cruises || []).filter((cruise)=>cloudSession ? cruise.startedAt !== undefined : true).toSorted((a, b)=>(a.startedAt ? new Date(Date.parse(a.startedAt)) : new Date()).valueOf() - (b.startedAt ? new Date(Date.parse(b.startedAt)) : new Date()).valueOf());
    },
    // The [minYear, maxYear] span the calendar grid must cover. Empty -> the current
    // year for both ends; an unparseable first start falls back to the max year.
    yearRange (sortedCruises, today) {
        const range = (sortedCruises.length > 0 ? [
            sortedCruises[0].startedAt,
            sortedCruises[sortedCruises.length - 1].completedAt || today
        ] : [
            today,
            today
        ]).map((d)=>new Date(Date.parse(d)).getFullYear());
        if (isNaN(range[0])) range[0] = range[1];
        return range;
    }
};




var $acw62 = parcelRequire("acw62");



function $fadd16f3024fdef0$export$1216c8d57ffbc072({ sortedCruises: sortedCruises, minMaxYears: minMaxYears, selectCruise: selectCruise, onFocus: onFocus }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("CruiseCalendarView");
    const years = (0, $acw62.useMemo)(()=>{
        const now = new Date().valueOf();
        const years = [];
        let n = 0;
        let cruise = sortedCruises[n];
        for(let y = minMaxYears[0]; y <= minMaxYears[1]; y++){
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
            const months = [];
            for(let m = 0; m < 12; m++){
                const monthStart = new Date(Date.UTC(y, m, 1)).valueOf();
                const monthEnd = new Date(Date.UTC(y, m + 1, 1)).valueOf();
                const cruises = [];
                let completed = false;
                while(!completed && cruise)cruise = ((cruise)=>{
                    completed = true;
                    const s = (cruise.startedAt ? new Date(Date.parse(cruise.startedAt)) : new Date()).valueOf();
                    if (s >= monthStart && s < monthEnd) {
                        if (s - monthStart >= 86400) cruises.push((0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "CruiseCalendarView-cruise-spacer"
                        }, `spacer-start-${cruise.id}`));
                        cruises.push((0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                                "CruiseCalendarView-cruise",
                                !cruise.completedAt && "active"
                            ]),
                            "data-cruise-id": cruise.id,
                            onClick: ()=>selectCruise(cruise.id),
                            children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "CruiseCalendarView-cruise-title",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            cruise.title || t("untitled_cruise"),
                                            " (",
                                            cruise.startedAt && app.format("date", cruise.startedAt),
                                            " - ",
                                            cruise.completedAt ? app.format("date", cruise.completedAt) : "",
                                            ")"
                                        ]
                                    }),
                                    !cruise.completedAt && !app.cloudSession() && (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button focus",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            onFocus();
                                        },
                                        children: t("focus")
                                    })
                                ]
                            })
                        }, cruise.id));
                    } else if (s < monthEnd && (cruise.completedAt || monthStart < now)) cruises.push((0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                            "CruiseCalendarView-cruise",
                            !cruise.completedAt && "active"
                        ]),
                        "data-cruise-id": cruise.id,
                        onClick: ()=>selectCruise(cruise.id)
                    }, cruise.id));
                    if (cruise.completedAt) {
                        const e = new Date(Date.parse(cruise.completedAt)).valueOf();
                        if (e <= monthEnd - 86400) cruises.push((0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "CruiseCalendarView-cruise-spacer"
                        }, `spacer-end-${cruise.id}`));
                        if (e >= monthStart && e <= monthEnd) {
                            n++;
                            completed = false;
                            return sortedCruises[n];
                        }
                    }
                    return cruise;
                })(cruise);
                months.push((0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                        "CruiseCalendarView-month",
                        `month-${m + 1}`
                    ]),
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "marker"
                        }),
                        cruises
                    ]
                }, m));
            }
            years.push((0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `CruiseCalendarView-year year-${y}`,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "CruiseCalendarView-year-number-container",
                        children: (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "CruiseCalendarView-year-number",
                            children: y
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "CruiseCalendarView-months-container",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "year-marker"
                            }),
                            months,
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "year-marker"
                            })
                        ]
                    })
                ]
            }, y));
        }
        return years;
    }, [
        sortedCruises,
        minMaxYears
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "CruiseCalendarView",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $51141e37452020dd$export$66a0ba5751a02e9e), {
                before: true,
                width: 20
            }),
            years,
            (0, $7b02d682eb115277$exports.jsx)((0, $51141e37452020dd$export$66a0ba5751a02e9e), {
                before: false,
                width: 20
            })
        ]
    });
}







function $02bc22f75b728dbf$export$da42ecc9c8361f1f() {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const t = app.getT("CruiseCalendarView");
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "empty-ship-message",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                html: true,
                message: (m)=>m.noteText.startShip,
                replace: {
                    name: ship.name
                }
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    actions: true,
                    className: "block-row-one-row",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button default",
                            onClick: ()=>{
                                window.location.href = `logbook://app/ships/${ship.id}/launch`;
                            },
                            children: t("start_ship")
                        })
                    })
                })
            })
        ]
    });
}



function $ec478af36ffc9832$var$CruiseCalendarContent({ cruises: cruises }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { navigateShip: navigateShip } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const selectCruise = (0, $acw62.useCallback)((cruiseId)=>{
        navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).cruise, {
            cruiseId: cruiseId
        });
    }, []);
    const onFocus = (0, $acw62.useCallback)(()=>{
        navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).focus);
    }, []);
    const today = new Date().toISOString();
    const sortedCruises = (0, $acw62.useMemo)(()=>(0, $75b9a65df93a7eb1$export$74f99c21288f6416).sortCruises(cruises ? [
            ...cruises
        ] : undefined, app.cloudSession()), [
        cruises
    ]);
    const minMaxYears = (0, $acw62.useMemo)(()=>(0, $75b9a65df93a7eb1$export$74f99c21288f6416).yearRange(sortedCruises, today), [
        sortedCruises
    ]);
    if (!cruises || cruises.length == 0 && !app.cloudSession()) return (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {});
    if (cruises.length < 1 && app.cloudSession()) return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $5878af5c58bfa741$export$e6ea0c07cce3c59c), {
                actions: []
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $02bc22f75b728dbf$export$da42ecc9c8361f1f), {})
        ]
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $5878af5c58bfa741$export$e6ea0c07cce3c59c), {
                actions: []
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $fadd16f3024fdef0$export$1216c8d57ffbc072), {
                sortedCruises: sortedCruises,
                minMaxYears: minMaxYears,
                selectCruise: selectCruise,
                onFocus: onFocus
            })
        ]
    });
}
function $ec478af36ffc9832$var$useCruiseCalendarAccess() {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const { apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const { navigateShip: navigateShip } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const levelReady = (apiUser === null || apiUser === void 0 ? void 0 : apiUser.shipLevel(ship.id)) !== undefined;
    const available = levelReady && new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(app.apiClient).cruises.list({
        params: {
            shipId: ship.id
        },
        query: {}
    }).available(apiUser);
    (0, $acw62.useEffect)(()=>{
        if (!levelReady || available) return;
        if (!app.cloudSession()) navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).focus);
    }, [
        app,
        available,
        levelReady,
        navigateShip
    ]);
    return available;
}
function $ec478af36ffc9832$export$35e0c46ab5c8b1c0({ initCruises: initCruises }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const { navigateShip: navigateShip } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const available = $ec478af36ffc9832$var$useCruiseCalendarAccess();
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const storedCruises = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Cruise, {
        shipId: ship.id
    });
    const seededIds = (0, $c80a929f5eac5ac1$export$927dafc935d4aea5)(initCruises, (0, $1bedde6805bf6e79$export$f55210826850c514).Cruise, (cruise)=>cruise.shipId === ship.id);
    const ready = (0, $29504a259cf4b663$export$c40434fbcbfd3fb6)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Cruise, {
        shipId: ship.id
    }, available && initCruises === undefined, initCruises !== undefined);
    (0, $9690902269ab2924$export$e4edb3e6a3489a79)([
        (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Cruise,
        (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Note,
        (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).NoteAttachment,
        (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).StoredCalculation
    ], available, ship.id);
    (0, $acw62.useState)(()=>{
        if (initCruises) {
            const notes = initCruises.flatMap((cruise)=>{
                var _a;
                return (_a = cruise.notes) !== null && _a !== void 0 ? _a : [];
            });
            store.applyBundle({
                entities: Object.assign({
                    Cruise: initCruises
                }, (0, $5bd541aff0182fa0$export$e9bc97ba61bf8e52)(notes)),
                authoritative: {
                    Cruise: {
                        shipId: ship.id
                    }
                }
            });
        }
        return true;
    });
    (0, $acw62.useEffect)(()=>{
        if (ready && storedCruises.length === 0 && app.cloudSession()) navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).calendar);
    }, [
        app,
        navigateShip,
        ready,
        storedCruises.length
    ]);
    const cruises = initCruises !== undefined && storedCruises.length === 0 ? initCruises : ready ? seededIds ? storedCruises.filter((cruise)=>seededIds.has(cruise.id)) : storedCruises : undefined;
    return (0, $7b02d682eb115277$exports.jsx)($ec478af36ffc9832$var$CruiseCalendarContent, {
        cruises: cruises
    });
}





var $acw62 = parcelRequire("acw62");




function $2ab786b6093e2589$export$f01e25460fe9193a(store) {
    const live = [];
    const types = [
        "Cruise",
        "Trip",
        "Day",
        "Note",
        "NoteAttachment",
        "StoredCalculation",
        "Log",
        "Status"
    ];
    const releases = types.map((type)=>store.subscribeLiveEvent(type, (row)=>{
            const current = store.getEntity(type, row.id);
            live.push({
                type: type,
                entity: current !== null && current !== void 0 ? current : row,
                deleted: current === undefined
            });
        }));
    const currentLog = store.getCurrentLog();
    return {
        dispose: ()=>releases.forEach((release)=>release()),
        apply: (response, provisionalLogs)=>{
            var _a, _b, _c, _d, _e, _f, _g;
            const normalized = (0, $62b16000854aa787$export$d90ea4047b394c05)(response);
            const entities = normalized.bundle.entities;
            const cruises = new Set((_a = entities.Cruise) === null || _a === void 0 ? void 0 : _a.map((row)=>row.id));
            const trips = new Set((_b = entities.Trip) === null || _b === void 0 ? void 0 : _b.map((row)=>row.id));
            const days = new Set((_c = entities.Day) === null || _c === void 0 ? void 0 : _c.map((row)=>row.id));
            const notes = new Set((_d = entities.Note) === null || _d === void 0 ? void 0 : _d.map((row)=>row.id));
            const attachments = new Set((_e = entities.NoteAttachment) === null || _e === void 0 ? void 0 : _e.map((row)=>row.id));
            const removals = [];
            // current.day returns complete status lists for its returned days. A reconnect
            // must remove offline deletions too; request-local live events replay below.
            if (response.status !== undefined) {
                const statuses = new Set((_f = entities.Status) === null || _f === void 0 ? void 0 : _f.map((row)=>row.id));
                for (const day of (_g = entities.Day) !== null && _g !== void 0 ? _g : []){
                    for (const row of store.getQuery("Status", {
                        shipId: day.shipId,
                        dayId: day.id
                    }))if (!statuses.has(row.id)) removals.push({
                        type: "Status",
                        entity: row,
                        deleted: true
                    });
                }
            }
            // A fresh aggregate projection supersedes old folded calculations. Real live
            // rows racing this request are replayed afterward with their original identity.
            for (const [sourceType, ids] of [
                [
                    (0, $0e9fc80557c7dff1$export$2bc642d888abd6fb).cruise,
                    cruises
                ],
                [
                    (0, $0e9fc80557c7dff1$export$2bc642d888abd6fb).trip,
                    trips
                ],
                [
                    (0, $0e9fc80557c7dff1$export$2bc642d888abd6fb).day,
                    days
                ]
            ])for (const sourceId of ids){
                for (const row of store.getQuery("StoredCalculation", {
                    sourceId: sourceId
                }))if (row.sourceType === sourceType) removals.push({
                    type: "StoredCalculation",
                    entity: row,
                    deleted: true
                });
            }
            const ownedNotes = new Set(notes);
            const cachedNotes = new Map([
                ...[
                    ...cruises
                ].flatMap((cruiseId)=>store.getQuery("Note", {
                        cruiseId: cruiseId
                    })),
                ...[
                    ...trips
                ].flatMap((tripId)=>store.getQuery("Note", {
                        tripId: tripId
                    })),
                ...[
                    ...days
                ].flatMap((dayId)=>store.getQuery("Note", {
                        dayId: dayId
                    }))
            ].map((row)=>[
                    row.id,
                    row
                ]));
            for (const row of cachedNotes.values()){
                const owned = row.dayId !== undefined ? days.has(row.dayId) : row.tripId !== undefined ? trips.has(row.tripId) : row.cruiseId !== undefined && cruises.has(row.cruiseId);
                if (owned) {
                    ownedNotes.add(row.id);
                    if (!notes.has(row.id)) removals.push({
                        type: "Note",
                        entity: row,
                        deleted: true
                    });
                }
            }
            for (const noteId of ownedNotes){
                for (const row of store.getQuery("NoteAttachment", {
                    noteId: noteId
                }))if (!attachments.has(row.id)) removals.push({
                    type: "NoteAttachment",
                    entity: row,
                    deleted: true
                });
            }
            const replay = live.map((mutation)=>{
                var _a;
                if (mutation.deleted || ![
                    "Cruise",
                    "Trip",
                    "Day"
                ].includes(mutation.type)) return mutation;
                // Base-row edits carry no newly computed projection. Their preserveLive
                // fields may predate this request, so use the response's projection here;
                // any genuinely newer calculation has its own replayed StoredCalculation.
                const snapshot = (_a = entities[mutation.type]) === null || _a === void 0 ? void 0 : _a.find((row)=>row.id === mutation.entity.id);
                if (!snapshot) return mutation;
                const row = Object.assign({}, mutation.entity);
                for (const field of (0, $77089501411ae7ed$export$3dbb0b2d2178e57f)){
                    delete row[field];
                    if (snapshot && field in snapshot) row[field] = snapshot[field];
                }
                return Object.assign(Object.assign({}, mutation), {
                    entity: row
                });
            });
            store.applyBundle(normalized.bundle, undefined, [
                ...removals,
                ...replay
            ]);
            if (store.getCurrentLog() === currentLog && normalized.currentLog) store.applyCurrentLog(normalized.currentLog, "update");
            store.replaceProvisionalLogs(provisionalLogs);
        }
    };
}




var $dc5f476a6a7173a6$export$44cc6d18b276943;
(function(FocusViewConfirmationType) {
    FocusViewConfirmationType["cruise"] = "cruise";
    FocusViewConfirmationType["trip"] = "trip";
})($dc5f476a6a7173a6$export$44cc6d18b276943 || ($dc5f476a6a7173a6$export$44cc6d18b276943 = {}));
const $dc5f476a6a7173a6$export$abafb95c9400b65d = {
    loadCurrentDay (api) {
        return new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.day({
            params: {}
        }).call();
    },
    recordLog (api, status) {
        return new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.log({
            params: {},
            body: {
                status: status
            }
        }).call();
    },
    recordEngine (api, engineId, on) {
        return new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.engine({
            params: {},
            body: {
                engine: engineId,
                on: on
            }
        }).call();
    },
    recordLighting (api, lighting) {
        return new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.lighting({
            params: {},
            body: {
                lighting: lighting
            }
        }).call();
    },
    recordSails (api, changes) {
        return new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.sails({
            params: {},
            body: {
                sails: changes
            }
        }).call();
    },
    recordStop (api, values) {
        return new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.stop({
            params: {},
            body: values
        }).call();
    },
    // Whether the account is effectively expired.
    //
    // The loaded day state wins only where its status actually settles the question. A
    // trial status does: the server recomputes it from the trial's own day count, so it
    // is fresher than the account row. `cancelled` does NOT -- it means the subscription
    // will not renew, not that access has ended; that is `nextBillingAt`'s call, and only
    // the account carries it. So `cancelled` (and the equally inconclusive `inactive`)
    // defer to the AppView flag, which is `App/IAP.ts`'s `subscriptionExpired` mirroring
    // the server's `Account.hasExpiredSubscription`.
    //
    // Treating any present status as conclusive meant a lapsed account -- cancelled, past
    // its billing date -- fell through every branch of `subscriptionWarningKey` below and
    // rendered no warning at all (issue #1336). Note `inactive` is 0, so the truthiness
    // check this replaced also mis-read it as "no status loaded"; it now takes the
    // deferring branch deliberately rather than by accident.
    accountSubscriptionExpired (subscriptionStatus, appViewExpired) {
        switch(subscriptionStatus){
            case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trialExpired:
                return true;
            case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trialStarted:
            case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial1DayLeft:
            case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial2DaysLeft:
            case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial3DaysLeft:
            case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial4DaysLeft:
            case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial5DaysLeft:
            case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).active:
                return false;
            default:
                return appViewExpired;
        }
    },
    // Which subscription warning (if any) to raise for the given account state.
    // `undefined` means no warning. The dismissed-today check stays in the component.
    subscriptionWarningKey (accountStatus, nextBillingAt, now, accountSubscriptionExpired) {
        if (accountStatus === (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trialStarted) return "demoStarted";
        else if (accountStatus === (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial3DaysLeft) return "demo2Days";
        else if (accountStatus === (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial2DaysLeft) return "demo1Day";
        else if (accountStatus === (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial1DayLeft) return "demoToday";
        else if (accountStatus === (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trialExpired) return "demoEnded";
        else if (accountStatus === (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).active && nextBillingAt) {
            const daysUntilRenewal = Math.floor((new Date(nextBillingAt).getTime() - now.getTime()) / 86400000);
            if (daysUntilRenewal <= 7 && daysUntilRenewal >= 0) return "sevenDays";
            return undefined;
        } else if (accountSubscriptionExpired) return "subscriptionExpired";
        return undefined;
    },
    // Yesterday's day record within the loaded state (undefined without a trip).
    dayYesterday (state) {
        if (!state || !state.trip) return undefined;
        return state.days.find((d)=>d.day == state.day - 1);
    },
    // Today's day is "active" once it has a real day number and at least one log.
    dayTodayActive (dayToday, logs) {
        return dayToday != undefined && dayToday.day > 0 && logs.find((l)=>l.dayId == dayToday.id) != undefined;
    },
    // Tomorrow's day record (or the pending day-0 placeholder). Only surfaced once
    // today is active, and only within a trip.
    dayTomorrow (state, dayTodayActive) {
        if (!state || !state.trip || !dayTodayActive) return undefined;
        return state.days.find((d)=>d.day == state.day + 1 || d.day == 0);
    },
    // Whether the current-day state needs to be (re)loaded from the API. Reload when
    // nothing is loaded yet, or when the calendar day has genuinely advanced past the
    // loaded day. The comparison is done in the loaded trip's fixed navigation timezone
    // (the same timezone the server used to compute `state.day`), so a non-zero timezone
    // no longer makes the two clocks disagree on every render — that disagreement was the
    // endless reload loop (a burst of `GET /api/ship/current/day` requests). When there is
    // no trip yet, fall back to the App's own system timezone rather than a hardcoded UTC:
    // the server (DayApi.current) falls back to `TimeZone.currentTimezoneOffset` (the App
    // instance's local timezone) in that same case, and a UTC/local mismatch there caused
    // the same endless-reload bug (issue #1151).
    // Accepts any structural `{ day, trip? }` (the full `FocusViewState` or the New
    // variant's lighter `FocusFrameData`, which omits logs/statuses) since only the day
    // number and the trip's fixed navigation timezone matter here.
    shouldLoadCurrentDay (state, now, systemTimezone, lastRequestedDay) {
        var _a, _b;
        if (!state) return true;
        const today = $dc5f476a6a7173a6$export$abafb95c9400b65d.todayDayNumber(now, (_b = (_a = state.trip) === null || _a === void 0 ? void 0 : _a.timezone) !== null && _b !== void 0 ? _b : systemTimezone);
        return state.day !== today && lastRequestedDay !== today;
    },
    // The "day number" for the current calendar day (whole days since the Apple reference
    // date 2001-01-01 UTC), offset by the given timezone (seconds east of UTC). Mirrors the
    // server's `Date.days(timezone:)`. Used to detect when the loaded day is stale.
    todayDayNumber (now, timezone) {
        return Math.floor((now.valueOf() + timezone * 1000 - new Date(Date.UTC(2001, 0, 1)).valueOf()) / 86400000);
    },
    // The day record for the current day: the matching day, else the pending day-0
    // placeholder (renumbered to today), else a freshly synthesized blank day carrying
    // the trip's identifiers. Undefined without a loaded trip.
    dayToday (state, currentLogTimezone) {
        if (!state || !state.trip) return undefined;
        const dayToday = state.days.find((d)=>d.day == state.day);
        if (dayToday) return dayToday;
        const nextDay = state.days.find((d)=>d.day == 0);
        if (nextDay) return Object.assign(Object.assign({}, nextDay), {
            day: state.day
        });
        return {
            id: 0,
            cruiseId: state.trip.cruiseId,
            tripId: state.trip.id,
            accountId: state.trip.accountId,
            shipId: state.trip.shipId,
            createdAt: state.trip.createdAt,
            updatedAt: state.trip.updatedAt,
            day: state.day,
            timezone: currentLogTimezone || state.trip.timezone,
            data: "{}"
        };
    },
    // The carry-over defaults for the next day: crew/passengers/skipper persist and the
    // new day starts where the previous one ended. Undefined without a current day.
    previousDayDefaults (dayToday) {
        if (!dayToday) return undefined;
        return {
            crew: dayToday.crew,
            passengers: dayToday.passengers,
            skipper: dayToday.skipper,
            startLocation: dayToday.endLocation
        };
    }
};



const { Context: $9f0c6a660fcd92b1$export$df823dc205f2b789, useData: $9f0c6a660fcd92b1$export$e9b6e9aba65becb0 } = (0, $480db5fef2358c2d$export$1f628e93c0b28291)("FocusDataView");



var $acw62 = parcelRequire("acw62");









const $4c2e1748c9b2a3ae$var$CruiseDeps = (0, $a9e25f5507c22ba4$export$a23f992de0d45ff0)("Ship", {
    cruises: (0, $9db39e34b2fb118a$export$14badfee79ea396f)("Cruise", {
        with: [
            "calculated",
            "calculatedV2",
            "notes"
        ]
    })
});
const $4c2e1748c9b2a3ae$var$TripDeps = (0, $a9e25f5507c22ba4$export$a23f992de0d45ff0)("Cruise", {
    trips: (0, $9db39e34b2fb118a$export$14badfee79ea396f)("Trip", {
        with: [
            "calculated",
            "calculatedV2",
            "notes"
        ]
    })
});
const $4c2e1748c9b2a3ae$var$DayDeps = (0, $a9e25f5507c22ba4$export$a23f992de0d45ff0)("Trip", {
    days: (0, $9db39e34b2fb118a$export$14badfee79ea396f)("Day", {
        with: [
            "calculated",
            "calculatedV2",
            "notes"
        ]
    })
});
function $4c2e1748c9b2a3ae$export$869a1af65905a438(init, sink) {
    var _a, _b, _c;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { requireUserLevel: requireUserLevel } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const [selection, setSelection] = (0, $acw62.useState)();
    const [loadRevision, setLoadRevision] = (0, $acw62.useState)(0);
    const [provisionalLogs, setProvisionalLogs] = (0, $acw62.useState)({});
    const editable = app.editable && requireUserLevel("editCurrent");
    const sinkRef = (0, $acw62.useRef)(sink);
    sinkRef.current = sink;
    // Retain before the bootstrap settles. Unknown owners use an impossible id rather
    // than an unscoped query; fetch:false still retains the entity and its fold sources.
    const { cruises: cruises } = (0, $e9db94b1c3310c7c$export$a37ae8cf05d96586)($4c2e1748c9b2a3ae$var$CruiseDeps, {
        shipId: ship.id
    }, {
        fetch: false
    });
    const { trips: trips } = (0, $e9db94b1c3310c7c$export$a37ae8cf05d96586)($4c2e1748c9b2a3ae$var$TripDeps, {
        shipId: ship.id,
        cruiseId: (_a = selection === null || selection === void 0 ? void 0 : selection.cruiseId) !== null && _a !== void 0 ? _a : -1
    }, {
        fetch: false
    });
    const { days: days } = (0, $e9db94b1c3310c7c$export$a37ae8cf05d96586)($4c2e1748c9b2a3ae$var$DayDeps, {
        shipId: ship.id,
        tripId: (_b = selection === null || selection === void 0 ? void 0 : selection.tripId) !== null && _b !== void 0 ? _b : -1
    }, {
        fetch: false
    });
    const cruise = cruises.find((row)=>row.id === (selection === null || selection === void 0 ? void 0 : selection.cruiseId) && row.shipId === ship.id);
    const trip = trips.find((row)=>row.id === (selection === null || selection === void 0 ? void 0 : selection.tripId) && row.shipId === ship.id);
    const frame = (0, $acw62.useMemo)(()=>{
        if (!selection || selection.shipId !== ship.id || !cruise) return undefined;
        return {
            cruise: cruise,
            trip: trip,
            day: selection.day,
            firstDay: selection.firstDay,
            days: days.filter((row)=>row.shipId === ship.id && selection.dayIds.includes(row.id)),
            provisionalLogs: provisionalLogs,
            subscriptionStatus: selection.subscriptionStatus
        };
    }, [
        selection,
        ship.id,
        cruise,
        trip,
        days,
        provisionalLogs
    ]);
    const provisionalRef = (0, $acw62.useRef)({});
    const provisionalRevision = (0, $acw62.useRef)(0);
    const provisionalRevisions = (0, $acw62.useRef)({});
    const loadGeneration = (0, $acw62.useRef)(0);
    const lastRequestedDay = (0, $acw62.useRef)(undefined);
    const wasDisconnected = (0, $acw62.useRef)(false);
    const pendingLoad = (0, $acw62.useRef)(false);
    const disposeLoad = (0, $acw62.useRef)(undefined);
    // Admission events received during the HTTP request must survive its older membership.
    const liveDays = (0, $acw62.useRef)(new Map());
    const { initCruise: initCruise, initTrip: initTrip, initDay: initDay, initLogs: initLogs, initStatuses: initStatuses, initCurrentLog: initCurrentLog } = init;
    const initMode = Boolean(initCruise && initTrip && initDay);
    const reload = (0, $acw62.useCallback)((resetStatus)=>{
        var _a;
        (_a = disposeLoad.current) === null || _a === void 0 || _a.call(disposeLoad);
        disposeLoad.current = undefined;
        loadGeneration.current += 1;
        lastRequestedDay.current = undefined;
        pendingLoad.current = false;
        provisionalRef.current = {};
        setProvisionalLogs({});
        setSelection(undefined);
        sinkRef.current.clear();
        setLoadRevision((previous)=>previous + 1);
        if (resetStatus) app.resetStatus();
    }, [
        app
    ]);
    const reset = (0, $acw62.useCallback)(()=>reload(true), [
        reload
    ]);
    const previousStore = (0, $acw62.useRef)(store);
    // Provider transport changes can replace the store without remounting Focus.
    // Selection alone does not mean that the new store has been bootstrapped.
    (0, $acw62.useEffect)(()=>{
        if (previousStore.current !== store) {
            previousStore.current = store;
            if (!initMode) reload(false);
        }
    }, [
        store,
        reload,
        initMode
    ]);
    (0, $5f6ddaa19700549d$export$cb4e378d7d3467ee)((connected)=>{
        if (!connected) wasDisconnected.current = true;
        else if (wasDisconnected.current && !initMode) {
            wasDisconnected.current = false;
            reload(false);
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (initCruise && initTrip && initDay) {
            sinkRef.current.seedFromInit({
                cruise: initCruise,
                trip: initTrip,
                day: initDay,
                logs: initLogs !== null && initLogs !== void 0 ? initLogs : [],
                statuses: initStatuses !== null && initStatuses !== void 0 ? initStatuses : [],
                currentLog: initCurrentLog,
                provisionalLogs: Object.values(provisionalRef.current)
            });
            setSelection({
                shipId: ship.id,
                cruiseId: initCruise.id,
                tripId: initTrip.id,
                dayIds: [
                    initDay.id
                ],
                day: initDay.day,
                firstDay: true,
                subscriptionStatus: (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).inactive
            });
        }
    // Init props are bootstrap data, not a second source that overwrites live rows.
    }, [
        store,
        ship.id,
        initCruise === null || initCruise === void 0 ? void 0 : initCruise.id,
        initTrip === null || initTrip === void 0 ? void 0 : initTrip.id,
        initDay === null || initDay === void 0 ? void 0 : initDay.id,
        loadRevision
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        if (initMode || pendingLoad.current) return;
        const now = new Date();
        const clockState = selection && selection.shipId === ship.id ? {
            day: selection.day,
            trip: trip
        } : undefined;
        if (!(0, $dc5f476a6a7173a6$export$abafb95c9400b65d).shouldLoadCurrentDay(clockState, now, (_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.systemTimezone) !== null && _b !== void 0 ? _b : 0, lastRequestedDay.current)) return;
        pendingLoad.current = true;
        const generation = ++loadGeneration.current;
        const snapshotRevision = provisionalRevision.current;
        liveDays.current = new Map();
        const loadSeed = sinkRef.current.beginLoad();
        disposeLoad.current = loadSeed.dispose;
        const load = async ()=>{
            var _a, _b, _c, _d, _e, _f, _g, _h;
            try {
                const current = await (0, $dc5f476a6a7173a6$export$abafb95c9400b65d).loadCurrentDay(app.apiClient);
                if (generation !== loadGeneration.current) return;
                const responseCruise = current.cruises.cruises.toSorted((a, b)=>a.id - b.id)[0];
                const responseTrip = (_a = current.trips) === null || _a === void 0 ? void 0 : _a.trips.toSorted((a, b)=>a.id - b.id)[0];
                const responseTimezone = (_d = (_b = responseTrip === null || responseTrip === void 0 ? void 0 : responseTrip.timezone) !== null && _b !== void 0 ? _b : (_c = app.status) === null || _c === void 0 ? void 0 : _c.systemTimezone) !== null && _d !== void 0 ? _d : 0;
                lastRequestedDay.current = (0, $dc5f476a6a7173a6$export$abafb95c9400b65d).todayDayNumber(now, responseTimezone);
                const snapshot = {};
                for (const log of (_e = current.provisionalLogs) !== null && _e !== void 0 ? _e : []){
                    const key = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed.provisionalKey;
                    if (key) snapshot[key] = log;
                }
                const reconciled = Object.assign({}, provisionalRef.current);
                for (const key of new Set([
                    ...Object.keys(reconciled),
                    ...Object.keys(snapshot)
                ])){
                    if (((_f = provisionalRevisions.current[key]) !== null && _f !== void 0 ? _f : 0) > snapshotRevision) continue;
                    if (snapshot[key]) reconciled[key] = snapshot[key];
                    else delete reconciled[key];
                }
                provisionalRef.current = reconciled;
                loadSeed.apply(current, Object.values(reconciled));
                setProvisionalLogs(reconciled);
                const dayIds = new Set((_h = (_g = current.days) === null || _g === void 0 ? void 0 : _g.days.map((day)=>day.id)) !== null && _h !== void 0 ? _h : []);
                for (const { row: row, deleted: deleted } of liveDays.current.values()){
                    if (deleted) dayIds.delete(row.id);
                    else if (row.shipId === ship.id && row.tripId === (responseTrip === null || responseTrip === void 0 ? void 0 : responseTrip.id) && (row.day >= current.day - 1 || row.day === 0)) dayIds.add(row.id);
                }
                setSelection(responseCruise ? {
                    shipId: ship.id,
                    cruiseId: responseCruise.id,
                    tripId: responseTrip === null || responseTrip === void 0 ? void 0 : responseTrip.id,
                    dayIds: [
                        ...dayIds
                    ],
                    day: current.day,
                    firstDay: current.firstDay < 1 || current.day === current.firstDay,
                    subscriptionStatus: current.subscriptionStatus
                } : undefined);
            } finally{
                loadSeed.dispose();
                if (generation === loadGeneration.current) {
                    pendingLoad.current = false;
                    disposeLoad.current = undefined;
                }
            }
        };
        load().catch((error)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).error("load current day", error));
    }, [
        frame,
        selection,
        trip,
        initMode,
        loadRevision,
        ship.id,
        (_c = app.status) === null || _c === void 0 ? void 0 : _c.systemTimezone
    ]);
    // Invalidate in-flight work when changing ships or unmounting, including its seed.
    (0, $acw62.useEffect)(()=>()=>{
            var _a;
            (_a = disposeLoad.current) === null || _a === void 0 || _a.call(disposeLoad);
            disposeLoad.current = undefined;
            loadGeneration.current += 1;
            pendingLoad.current = false;
            lastRequestedDay.current = undefined;
        }, [
        ship.id,
        store
    ]);
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((log, _type, info)=>{
        const key = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(log).dataParsed.provisionalKey;
        if (key) {
            provisionalRevision.current += 1;
            provisionalRevisions.current[key] = provisionalRevision.current;
        }
        provisionalRef.current = (0, $5ba8962d09b05c4a$export$b531eccea6f91101).updateProvisional(provisionalRef.current, key, log, info);
        setProvisionalLogs(provisionalRef.current);
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog);
    (0, $b82e6d2a15bbd8b8$export$419a4240882ffaf9)(store, "Cruise", (row, info)=>{
        if (row.shipId === ship.id && info === "create" && row.id !== (selection === null || selection === void 0 ? void 0 : selection.cruiseId) && !initMode) reset();
    });
    (0, $b82e6d2a15bbd8b8$export$419a4240882ffaf9)(store, "Trip", (row, info)=>{
        if (row.shipId === ship.id && info === "create" && row.id !== (selection === null || selection === void 0 ? void 0 : selection.tripId) && !initMode) reset();
    });
    (0, $b82e6d2a15bbd8b8$export$419a4240882ffaf9)(store, "Day", (row, info)=>{
        const deleted = info === "delete" || store.getEntity("Day", row.id) === undefined;
        if (pendingLoad.current) liveDays.current.set(row.id, {
            row: row,
            deleted: deleted
        });
        setSelection((previous)=>{
            if (!previous) return previous;
            if (deleted) return Object.assign(Object.assign({}, previous), {
                dayIds: previous.dayIds.filter((id)=>id !== row.id)
            });
            if (row.shipId !== ship.id || row.tripId !== previous.tripId || row.day < previous.day - 1 && row.day !== 0 || previous.dayIds.includes(row.id)) return previous;
            return Object.assign(Object.assign({}, previous), {
                dayIds: [
                    ...previous.dayIds,
                    row.id
                ]
            });
        });
    });
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((day)=>{
        if (selection && selection.day !== day.day) reset();
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).dayNavigation);
    return {
        frame: frame,
        editable: editable,
        reset: reset
    };
}





var $0c0408fb3426988b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $0c0408fb3426988b$export$50b20b089a7bb9ff(response) {
    var _a;
    return {
        entities: {
            Log: ((_a = response.logs) === null || _a === void 0 ? void 0 : _a.length) ? response.logs : [
                response.log
            ],
            Status: response.statuses
        }
    };
}
// Monotonic negative temp ids for the create-commit's optimistic row, so an in-flight
// `+ Log` never collides with a real (positive) server id or a second pending commit.
// Module-level so it stays unique across writer instances/renders.
let $0c0408fb3426988b$var$tempSeq = 0;
function $0c0408fb3426988b$var$nextTempId() {
    $0c0408fb3426988b$var$tempSeq += 1;
    return -$0c0408fb3426988b$var$tempSeq;
}
// The day an optimistic committed row is scoped to: today's day id, or -- while the frame
// hasn't loaded and today isn't known yet -- the day the current log itself is on. Naming
// the rule keeps the fallback out of an inline `??` at the point of use.
function $0c0408fb3426988b$var$scopeDayId(dayTodayId, current) {
    return dayTodayId !== null && dayTodayId !== void 0 ? dayTodayId : current.dayId;
}
// Drop the client-only `kind` brand so the optimistic row enters the committed `Log`
// entity store as a plain committed log (not a mis-tagged current/provisional one).
function $0c0408fb3426988b$var$committedSnapshot(current, dayTodayId, tempId) {
    const _a = current, { kind: _kind } = _a, base = $0c0408fb3426988b$var$__rest(_a, [
        "kind"
    ]);
    return Object.assign(Object.assign({}, base), {
        id: tempId,
        dayId: $0c0408fb3426988b$var$scopeDayId(dayTodayId, current)
    });
}
function $0c0408fb3426988b$export$6738095aac96f9b6(store, ids) {
    const { dayId: dayId } = ids;
    const commit = (request, current)=>{
        const tempId = $0c0408fb3426988b$var$nextTempId();
        const optimistic = current ? {
            upsert: {
                Log: [
                    $0c0408fb3426988b$var$committedSnapshot(current, dayId, tempId)
                ]
            }
        } : undefined;
        const provisional = current ? {
            Log: [
                tempId
            ]
        } : undefined;
        return store.mutate({
            optimistic: optimistic,
            provisional: provisional,
            request: request,
            reconcile: $0c0408fb3426988b$export$50b20b089a7bb9ff
        }).then(()=>undefined);
    };
    const create = (request)=>{
        // A live row that replaces either reference while the request is pending wins.
        const cruises = new Map(store.getQuery("Cruise", {}).map((row)=>[
                row.id,
                row
            ]));
        const trips = new Map(store.getQuery("Trip", {}).map((row)=>[
                row.id,
                row
            ]));
        return store.mutate({
            request: request,
            reconcile: (response)=>{
                const currentCruise = response.cruise ? store.getEntity("Cruise", response.cruise.id) : undefined;
                const currentTrip = response.trip ? store.getEntity("Trip", response.trip.id) : undefined;
                return {
                    entities: {
                        Cruise: response.cruise && currentCruise === cruises.get(response.cruise.id) ? [
                            (0, $77089501411ae7ed$export$541d2c535509b7fe)(response.cruise, currentCruise)
                        ] : [],
                        Trip: response.trip && currentTrip === trips.get(response.trip.id) ? [
                            (0, $77089501411ae7ed$export$541d2c535509b7fe)(response.trip, currentTrip)
                        ] : []
                    }
                };
            }
        });
    };
    return {
        recordLog: (status)=>commit((client)=>(0, $dc5f476a6a7173a6$export$abafb95c9400b65d).recordLog(client, status), store.getCurrentLog()),
        recordEngine: (engine, on)=>commit((client)=>(0, $dc5f476a6a7173a6$export$abafb95c9400b65d).recordEngine(client, engine, on)),
        recordLighting: (lighting)=>commit((client)=>(0, $dc5f476a6a7173a6$export$abafb95c9400b65d).recordLighting(client, lighting)),
        recordSails: (changes)=>commit((client)=>(0, $dc5f476a6a7173a6$export$abafb95c9400b65d).recordSails(client, changes)),
        recordStop: (values)=>commit((client)=>(0, $dc5f476a6a7173a6$export$abafb95c9400b65d).recordStop(client, values)),
        createCruise: ()=>create((client)=>new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(client).cruises.create({
                    params: {}
                }).call()),
        createTrip: ()=>create((client)=>new (0, $84aa1a3b4df5a78b$export$5e13e029a186945f)(client).trips.create({
                    params: {}
                }).call())
    };
}
// Inert FocusView writers for harnesses/tests that render the focus tree but never
// exercise a write. Each rejects loudly if unexpectedly called, so an accidental record
// in a read-only fixture surfaces rather than silently no-opping.
const $0c0408fb3426988b$var$rejectNoop = (name)=>()=>Promise.reject(new Error(`noopFocusWriters.${name}: no writer provided (read-only FocusView context)`));
const $0c0408fb3426988b$export$c33bd035c3b3933b = {
    recordLog: $0c0408fb3426988b$var$rejectNoop("recordLog"),
    recordEngine: $0c0408fb3426988b$var$rejectNoop("recordEngine"),
    recordLighting: $0c0408fb3426988b$var$rejectNoop("recordLighting"),
    recordSails: $0c0408fb3426988b$var$rejectNoop("recordSails"),
    recordStop: $0c0408fb3426988b$var$rejectNoop("recordStop"),
    createCruise: $0c0408fb3426988b$var$rejectNoop("createCruise"),
    createTrip: $0c0408fb3426988b$var$rejectNoop("createTrip")
};


function $e5c8807c8a6a19ae$export$a665a75f6745b83d({ initCruise: initCruise, initTrip: initTrip, initDay: initDay, initLogs: initLogs, initStatuses: initStatuses, initCurrentLog: initCurrentLog, children: children }) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    // Focus owns these reads even before the nested Day mounts. Retain before the
    // current-day request so its live replay can capture transitions during bootstrap.
    (0, $9690902269ab2924$export$e4edb3e6a3489a79)([
        "Log",
        "Status"
    ]);
    const sink = (0, $acw62.useMemo)(()=>({
            beginLoad: ()=>(0, $2ab786b6093e2589$export$f01e25460fe9193a)(store),
            seedFromInit: (seed)=>{
                store.applyBundlePreservingLive({
                    entities: Object.assign(Object.assign({}, (0, $62b16000854aa787$export$9c8e789df238128a)([
                        seed.cruise
                    ], [
                        seed.trip
                    ], [
                        seed.day
                    ])), {
                        Log: seed.logs,
                        Status: seed.statuses
                    })
                });
                if (seed.currentLog) store.applyCurrentLog(seed.currentLog, "update");
                store.replaceProvisionalLogs(seed.provisionalLogs);
            },
            clear: ()=>store.replaceProvisionalLogs([])
        }), [
        store
    ]);
    const { frame: frame, editable: editable } = (0, $4c2e1748c9b2a3ae$export$869a1af65905a438)({
        initCruise: initCruise,
        initTrip: initTrip,
        initDay: initDay,
        initLogs: initLogs,
        initStatuses: initStatuses,
        initCurrentLog: initCurrentLog
    }, sink);
    const currentLog = (0, $b82e6d2a15bbd8b8$export$e3073a0c9a31c385)(store);
    // Today's day id scopes the store reads below. Derived from the frame + the current
    // log's timezone exactly as the UI derives `dayToday`; it is undefined until the frame
    // loads, so the queries mark it `required` and stay empty until then.
    const dayTodayId = (0, $acw62.useMemo)(()=>{
        var _a;
        return frame ? (_a = (0, $dc5f476a6a7173a6$export$abafb95c9400b65d).dayToday(Object.assign(Object.assign({}, frame), {
            logs: [],
            statuses: []
        }), currentLog === null || currentLog === void 0 ? void 0 : currentLog.timezone)) === null || _a === void 0 ? void 0 : _a.id : undefined;
    }, [
        frame,
        currentLog
    ]);
    const logs = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Log, {
        dayId: (0, $55c0c0d4c269af54$export$a7a0278c004aac3f)(dayTodayId)
    });
    const statuses = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Status, {
        dayId: (0, $55c0c0d4c269af54$export$a7a0278c004aac3f)(dayTodayId)
    });
    const currentState = (0, $acw62.useMemo)(()=>frame ? Object.assign(Object.assign({}, frame), {
            logs: logs,
            statuses: statuses
        }) : undefined, [
        frame,
        logs,
        statuses
    ]);
    const writers = (0, $acw62.useMemo)(()=>(0, $0c0408fb3426988b$export$6738095aac96f9b6)(store, {
            dayId: dayTodayId
        }), [
        store,
        dayTodayId
    ]);
    const value = {
        currentState: currentState,
        currentLog: currentLog,
        editable: editable,
        writers: writers
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $9f0c6a660fcd92b1$export$df823dc205f2b789).Provider, {
        value: value,
        children: children
    });
}




var $acw62 = parcelRequire("acw62");


// The UserAdvice module: the advice classes that decide which buttons the current-log
// row and day summary offer, and the dialogs those buttons open. Split out of
// App/UserAdvice.tsx + the Views/UserAdviceViews.tsx barrel in #1171 so the whole
// feature sits in one directory, the way Components/LogButton and Views/Day do.








// 2001-01-01T00:00:00Z expressed in Unix epoch seconds. Swift's default
// `JSONEncoder` serialises a `Date` as `timeIntervalSinceReferenceDate` (seconds
// since that instant), which is how the persisted `_episode` dates are encoded.
const $0a6b34a62f52e9a7$var$SWIFT_REFERENCE_EPOCH_SECONDS = 978307200;
function $0a6b34a62f52e9a7$export$c49e422b03e52c67(seconds) {
    return (seconds + $0a6b34a62f52e9a7$var$SWIFT_REFERENCE_EPOCH_SECONDS) * 1000;
}
var $0a6b34a62f52e9a7$export$bf367b9fffcba79;
(function(AlertDeliveryAction) {
    AlertDeliveryAction["silent"] = "silent";
    AlertDeliveryAction["notify"] = "notify";
    AlertDeliveryAction["alarm"] = "alarm";
    AlertDeliveryAction["stop"] = "stop";
})($0a6b34a62f52e9a7$export$bf367b9fffcba79 || ($0a6b34a62f52e9a7$export$bf367b9fffcba79 = {}));
function $0a6b34a62f52e9a7$export$47d783af77d2cfa8(p) {
    if (!p.targeted) return $0a6b34a62f52e9a7$export$bf367b9fffcba79.silent;
    if (p.status === (0, $ed9e79f0f649608a$export$63ce30087a699ab4).resolved) return $0a6b34a62f52e9a7$export$bf367b9fffcba79.stop;
    const snoozed = p.snoozeUntilMs != null && p.nowMs < p.snoozeUntilMs;
    if (p.status === (0, $ed9e79f0f649608a$export$63ce30087a699ab4).alarm && p.loudness === (0, $62c07736c3fbb91c$export$3258e89f1be8b566).audible && !p.acknowledged && !snoozed) return $0a6b34a62f52e9a7$export$bf367b9fffcba79.alarm;
    return $0a6b34a62f52e9a7$export$bf367b9fffcba79.notify;
}
function $0a6b34a62f52e9a7$var$decodeEnvelope(data) {
    if (!data) return {};
    try {
        return JSON.parse(data);
    } catch (_a) {
        return {};
    }
}
function $0a6b34a62f52e9a7$export$d1ff0fc84d1e0690(alert, userId, nowMs, isPrimary = false) {
    var _a, _b, _c;
    const env = $0a6b34a62f52e9a7$var$decodeEnvelope(alert.data);
    const delivery = env._delivery;
    const episode = env._episode;
    const targeted = isPrimary ? true : delivery ? delivery.all || userId != null && delivery.users.includes(userId) : true;
    const loudness = (_b = (_a = delivery === null || delivery === void 0 ? void 0 : delivery.loudness) !== null && _a !== void 0 ? _a : episode === null || episode === void 0 ? void 0 : episode.loudness) !== null && _b !== void 0 ? _b : (0, $62c07736c3fbb91c$export$3258e89f1be8b566).audible;
    const status = (_c = episode === null || episode === void 0 ? void 0 : episode.status) !== null && _c !== void 0 ? _c : alert.value;
    const acknowledged = (episode === null || episode === void 0 ? void 0 : episode.acknowledgedBy) != null;
    const snoozeUntilMs = (episode === null || episode === void 0 ? void 0 : episode.snoozeUntil) != null ? $0a6b34a62f52e9a7$export$c49e422b03e52c67(episode.snoozeUntil) : null;
    return $0a6b34a62f52e9a7$export$47d783af77d2cfa8({
        status: status,
        loudness: loudness,
        acknowledged: acknowledged,
        snoozeUntilMs: snoozeUntilMs,
        targeted: targeted,
        nowMs: nowMs
    });
}
class $0a6b34a62f52e9a7$export$2f1995726e8f476a {
    constructor(){
        this.sounding = new Set();
        this.notified = new Set();
        this.receipted = new Set();
    }
    reconcile(alerts, userId, nowMs, describe, isPrimary = false, onReceipt) {
        const open = new Set(alerts.map((a)=>a.id));
        // Silence and forget any alert that is no longer open (cleared / resolved).
        for (const id of Array.from(this.sounding))if (!open.has(id)) {
            (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).stopAlarm(String(id));
            this.sounding.delete(id);
        }
        for (const id of Array.from(this.notified))if (!open.has(id)) this.notified.delete(id);
        for (const id of Array.from(this.receipted))if (!open.has(id)) this.receipted.delete(id);
        for (const alert of alerts){
            const id = alert.id;
            const action = $0a6b34a62f52e9a7$export$d1ff0fc84d1e0690(alert, userId, nowMs, isPrimary);
            switch(action){
                case $0a6b34a62f52e9a7$export$bf367b9fffcba79.alarm:
                    this.notifyOnce(id, describe(alert));
                    if (!this.sounding.has(id)) {
                        (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).playAlarm(String(id));
                        this.sounding.add(id);
                    }
                    // Tell the primary this device delivered the alert locally (over the
                    // LAN) so the cloud never sends a redundant remote push. Only an
                    // audible alarm delivery counts — a quiet notify must not suppress a
                    // later push if the alert escalates. Fire once per open episode.
                    if (onReceipt && !this.receipted.has(id)) {
                        this.receipted.add(id);
                        onReceipt(alert);
                    }
                    break;
                case $0a6b34a62f52e9a7$export$bf367b9fffcba79.notify:
                    this.notifyOnce(id, describe(alert));
                    this.silence(id);
                    break;
                case $0a6b34a62f52e9a7$export$bf367b9fffcba79.stop:
                case $0a6b34a62f52e9a7$export$bf367b9fffcba79.silent:
                    this.silence(id);
                    break;
            }
        }
    }
    /** Stop everything (e.g. when the delivery context tears down). */ reset() {
        for (const id of this.sounding)(0, $413160cb4953a8b8$export$7bbc682b75e8aad4).stopAlarm(String(id));
        this.sounding.clear();
        this.notified.clear();
        this.receipted.clear();
    }
    notifyOnce(id, descriptor) {
        if (this.notified.has(id)) return;
        (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).showNativeNotification(String(id), descriptor.title, descriptor.body);
        this.notified.add(id);
    }
    silence(id) {
        if (this.sounding.has(id)) {
            (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).stopAlarm(String(id));
            this.sounding.delete(id);
        }
    }
}






var $acw62 = parcelRequire("acw62");








const $effa99ba9bf91d44$export$273525e6bbc3c841 = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    log (api, values) {
        return new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.log({
            params: {},
            body: values
        }).call();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    stop (api, values) {
        return new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.stop({
            params: {},
            body: values
        }).call();
    },
    lighting (api, lighting) {
        return new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.lighting({
            params: {},
            body: {
                lighting: lighting
            }
        }).call();
    },
    // The crew's answer to the engine-missing hint (#1227). Deliberately the *only* write
    // path for that hint: the client never composes engine or status writes itself, so two
    // devices answering the same hint cannot race into a contradictory logbook. The primary
    // re-runs the detection before acting and is a no-op once the hint is resolved.
    engineHint (api, values) {
        return new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(api).current.engineHint({
            params: {},
            body: values
        }).call();
    },
    // Enable / disable, reconfigure, or recenter the anchor watch through the
    // dedicated lifecycle route. The swing-circle origin is seeded server-side from
    // the current fix, so the request never carries a position.
    anchorWatch (api, values) {
        return new (0, $282be9ff941c7364$export$d7dfee902fc47737)(api).anchorWatch.update({
            params: {},
            body: values
        }).call();
    },
    // Enable / disable the standalone underway depth watch (#990) through its own
    // lifecycle route. No method/geometry to seed -- unlike the anchor watch, depth
    // alerting always uses the ship-wide default threshold.
    depthWatch (api, values) {
        return new (0, $2c05d4376a8922ad$export$d9fa3cf6dbf05747)(api).depthWatch.update({
            params: {},
            body: values
        }).call();
    },
    // Issue a snooze / acknowledge / clear command against an open alert.
    alertCommand (api, alertName, values) {
        return new (0, $d4eccb73927932bb$export$4c70e389659ec851)(api).alert.update({
            params: {
                alertName: alertName
            },
            body: values
        }).call();
    },
    // Start, extend or end the manual ship-status mode (#511) through its own
    // lifecycle route. `enabled: true` on an already-running mode EXTENDS it -- the
    // server rewrites the open status's `expiresAt` in place -- so the dialog's extend
    // and the LogButton's switch-on are the same request.
    manualShipStatus (api, values) {
        return new (0, $de4d1766f08a9636$export$c9e2730ca8b48804)(api).manualShipStatus.update({
            params: {},
            body: values
        }).call();
    }
};







function $0f24dfcfd0e1e984$export$48ec7d5b25c25f39({ accountUserId: accountUserId, shipUsers: shipUsers, day: day, shipLocalHour: shipLocalHour }) {
    var _a, _b;
    if (accountUserId === undefined || !day) return false;
    const shipUser = shipUsers.find((u)=>u.userId === accountUserId);
    if (!shipUser) return false;
    const skipper = (_a = day.skipper) !== null && _a !== void 0 ? _a : undefined;
    if (skipper !== undefined && skipper === shipUser.id) return true;
    const onWatch = $0f24dfcfd0e1e984$var$watchGroupAtHour($0f24dfcfd0e1e984$var$dayWatch(day), shipLocalHour);
    if ((_b = onWatch === null || onWatch === void 0 ? void 0 : onWatch.people) === null || _b === void 0 ? void 0 : _b.includes(shipUser.id)) return true;
    // #1146: a day with neither a skipper nor a covering watch group has nobody for
    // the gate to defer to, so fall back to the ship permission level rather than
    // leaving the alert permanently unclearable.
    if (skipper === undefined && !onWatch) return shipUser.shipUserLevel >= (0, $dc7739d612f0c536$export$fe876bf720d558fa).editCurrent;
    return false;
}
function $0f24dfcfd0e1e984$export$bd6ef5477cd49e2b({ accountUserId: accountUserId, shipUsers: shipUsers, day: day }) {
    var _a;
    if (accountUserId === undefined || !day || day.skipper === undefined) return false;
    return ((_a = shipUsers.find((u)=>u.userId === accountUserId)) === null || _a === void 0 ? void 0 : _a.id) === day.skipper;
}
function $0f24dfcfd0e1e984$var$dayWatch(day) {
    if (!day.data) return undefined;
    try {
        return JSON.parse(day.data).watch;
    } catch (_a) {
        return undefined;
    }
}
/**
 * The group on watch at `hour`, resolved through the covering shift's `group`
 * reference. Mirrors `DayWatchData.group(atHour:)`, including its treatment of a
 * dangling group reference as "nobody on watch".
 */ function $0f24dfcfd0e1e984$var$watchGroupAtHour(watch, hour) {
    var _a, _b;
    if (!watch) return undefined;
    const shift = (_a = watch.shifts) === null || _a === void 0 ? void 0 : _a.find((s)=>$0f24dfcfd0e1e984$var$shiftCovers(s.start, s.duration, $0f24dfcfd0e1e984$var$normaliseHour(hour)));
    if (!(shift === null || shift === void 0 ? void 0 : shift.group)) return undefined;
    return (_b = watch.groups) === null || _b === void 0 ? void 0 : _b.find((g)=>g.id === shift.group);
}
/** Mirrors `DayWatchShift.covers(hour:)` — wraps past midnight, 24h+ spans all day. */ function $0f24dfcfd0e1e984$var$shiftCovers(start, duration, hour) {
    const from = $0f24dfcfd0e1e984$var$normaliseHour(start);
    const span = Math.max(0, duration);
    if (span >= 24) return true;
    const end = from + span;
    if (end <= 24) return hour >= from && hour < end;
    return hour >= from || hour < end - 24;
}
function $0f24dfcfd0e1e984$var$normaliseHour(hour) {
    return (hour % 24 + 24) % 24;
}
function $0f24dfcfd0e1e984$export$edea66b9267f8947(timezone, now = new Date()) {
    return Math.floor(((now.getTime() / 1000 + timezone) % 86400 + 86400) % 86400 / 3600);
}






function $b38d5adbc9e0d928$export$40fc69da671684d({ advice: _advice, alert: alert, state: state, initFailed: initFailed, initConfirmingClear: initConfirmingClear, canClear: canClear, day: day, isSkipper: isSkipper, hasSkipper: hasSkipper, vesselType: suppliedVesselType }) {
    var _a, _b, _c, _d;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const shipContext = (0, $acw62.useContext)((0, $97ac05743b787a86$export$74bc7108ae339b7));
    const vesselType = suppliedVesselType !== null && suppliedVesselType !== void 0 ? suppliedVesselType : (_a = shipContext === null || shipContext === void 0 ? void 0 : shipContext.ship) === null || _a === void 0 ? void 0 : _a.vesselType;
    const t = app.getT("UserAdviceAlertView");
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    const navigateApp = (_b = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)()) === null || _b === void 0 ? void 0 : _b.navigateApp;
    const { bodyRef: bodyRef, showScrollButton: showScrollButton, isAtBottom: isAtBottom, handleScrollMore: handleScrollMore } = (0, $4be45b24a899ae38$export$5315996935894f9d)();
    const [failed, setFailed] = (0, $acw62.useState)(initFailed !== null && initFailed !== void 0 ? initFailed : false);
    // Always starts unselected, and deliberately remembers nothing across openings:
    // every choice changes the alert's state, so a remembered selection could be
    // committed by a reflexive second click on the submit button.
    const [choice, setChoice] = (0, $acw62.useState)(initConfirmingClear ? (0, $a521756eb7208261$export$196d6ee34f2568f2).clear : undefined);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    // Clearing is the one irreversible choice -- it ends the alert whether or not the
    // situation actually holds -- so it is confirmed before it fires. The prompt
    // replaces this dialog's own content rather than stacking a second overlay on
    // top of it, which would bury the alert the crew is deciding about.
    const [confirmingClear, setConfirmingClear] = (0, $acw62.useState)(initConfirmingClear !== null && initConfirmingClear !== void 0 ? initConfirmingClear : false);
    const lightsData = (0, $acw62.useMemo)(()=>{
        if (alert.name != (0, $ed9e79f0f649608a$export$5ebaef48f8647867).lights) return undefined;
        return JSON.parse(alert.data || "{}");
    }, [
        alert
    ]);
    const closeAlert = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        state.setSelected(undefined);
    }, [
        state
    ]);
    const openSettings = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        // For navigation lights alerts, open the lights reminder settings dialog instead
        // of navigating to ship settings (#1171).
        if (alert.name == (0, $ed9e79f0f649608a$export$5ebaef48f8647867).lights) {
            state.setSelected("lights-toolbar");
            return;
        }
        state.setSelected(undefined);
        if (app.shipId != undefined && navigateApp) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
            shipId: app.shipId,
            shipRoute: (0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).settings
        });
    }, [
        alert.name,
        app.shipId,
        navigateApp,
        state
    ]);
    // Record the recommended lighting straight from the advice card. The capture
    // creates a log + single-active `.lighting` status; the reminder auto-resolves
    // on the next evaluation once the recorded lighting matches. Dismiss the dialog
    // first (like the alert-command controls) so the capture never blocks it.
    const recordRecommended = (0, $acw62.useCallback)(()=>{
        const recommended = lightsData === null || lightsData === void 0 ? void 0 : lightsData.recommended;
        state.setSelected(undefined);
        if (recommended != undefined) try {
            new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(app.apiClient).current.lighting({
                params: {},
                body: {
                    lighting: recommended
                }
            }).call().catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("recordRecommended", err));
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("recordRecommended", err);
        }
    }, [
        app,
        lightsData,
        state
    ]);
    // Snooze / acknowledge / clear an open alert through the shared alert-command
    // route. The command carries the alert's episode id so it addresses exactly this
    // occurrence — alerts that can have several open at once (messages, MOB beacons)
    // would otherwise all be acted on together (#1269). Only dismiss the dialog once
    // the command actually succeeds — e.g. a user without sufficient permission gets
    // a 401, which must stay visible instead of being swallowed behind an
    // optimistically-closed dialog (#1146).
    const command = (0, $acw62.useCallback)(async (action)=>{
        if (!alert.name) return;
        setFailed(false);
        try {
            await (0, $effa99ba9bf91d44$export$273525e6bbc3c841).alertCommand(app.apiClient, alert.name, {
                action: action,
                episodeId: (0, $638a1296f5b66d6a$export$b198979c8e2df9af).episodeKey(alert)
            });
            state.setSelected(undefined);
        } catch (e) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("alert command", e);
            setFailed(true);
        }
    }, [
        app,
        alert,
        state
    ]);
    const perform = (0, $acw62.useCallback)(async (chosen)=>{
        setBusy(true);
        try {
            if (chosen == "record") recordRecommended();
            else await command(chosen);
        } finally{
            setBusy(false);
        }
    }, [
        command,
        recordRecommended
    ]);
    const submit = (0, $acw62.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (choice == undefined || busy) return;
        if (choice == (0, $a521756eb7208261$export$196d6ee34f2568f2).clear) {
            setFailed(false);
            setConfirmingClear(true);
            return;
        }
        await perform(choice);
    }, [
        busy,
        choice,
        perform
    ]);
    const confirmClear = (0, $acw62.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (busy) return;
        await perform((0, $a521756eb7208261$export$196d6ee34f2568f2).clear);
    }, [
        busy,
        perform
    ]);
    // Back to the choices with `clear` still selected, so a mis-click costs one click
    // rather than making the crew re-read the whole list.
    const cancelClear = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setConfirmingClear(false);
    }, []);
    // Only sounding/notifying alerts are actionable; a resolved/notice alert has
    // nothing to acknowledge.
    const actionable = alert.value == (0, $ed9e79f0f649608a$export$63ce30087a699ab4).alarm || alert.value == (0, $ed9e79f0f649608a$export$63ce30087a699ab4).warning;
    // Hidden from the skipper, for whom handing the alert to the skipper is a no-op.
    // Computed here for the same reason as the clear permission: the day's skipper is
    // a ShipUser.id and the session knows an account User.id, and the day can change
    // under the dialog.
    const skipper = (0, $acw62.useMemo)(()=>{
        var _a;
        if (isSkipper !== undefined) return isSkipper;
        if (!day || !shipUsers || shipUsers.length == 0) return false;
        return (0, $0f24dfcfd0e1e984$export$bd6ef5477cd49e2b)({
            accountUserId: (_a = app.user) === null || _a === void 0 ? void 0 : _a.id,
            shipUsers: shipUsers,
            day: day
        });
    }, [
        (_c = app.user) === null || _c === void 0 ? void 0 : _c.id,
        day,
        isSkipper,
        shipUsers
    ]);
    const skipperConfigured = hasSkipper !== null && hasSkipper !== void 0 ? hasSkipper : (day === null || day === void 0 ? void 0 : day.skipper) != undefined;
    const choices = (0, $acw62.useMemo)(()=>{
        const list = [];
        if (lightsData && lightsData.recommended != undefined) list.push("record");
        if (actionable) {
            // Ordered by how far each one commits you: silence it for a few minutes,
            // mark it seen, hand it to the skipper, close it. `clear` is deliberately
            // last -- it is the only choice that ends the alert outright, and the only
            // one that is permission-gated, so it should not sit in the middle of the
            // list where it can be picked by momentum.
            list.push((0, $a521756eb7208261$export$196d6ee34f2568f2).snooze, (0, $a521756eb7208261$export$196d6ee34f2568f2).acknowledge);
            if (skipperConfigured && !skipper) list.push((0, $a521756eb7208261$export$196d6ee34f2568f2).escalate);
            list.push((0, $a521756eb7208261$export$196d6ee34f2568f2).clear);
        }
        return list;
    }, [
        actionable,
        lightsData,
        skipper,
        skipperConfigured
    ]);
    // Only `clear` is permission-gated -- snooze and acknowledge are open to every
    // ship user. The answer depends on the ship-local hour (it changes as the watch
    // rotates), so it is recomputed here rather than delivered with the alert; the
    // rule itself is shared with the server via `Tests/Fixtures/alert-clear-permission.json`.
    //
    // `undefined` means "not known yet" -- no day, or the crew list still loading --
    // and counts as allowed: the server is the enforcer, so guessing "denied" here
    // would block a legitimate user for nothing, while guessing "allowed" costs at
    // worst a rejected command and the error message below.
    const mayClear = (0, $acw62.useMemo)(()=>{
        var _a;
        if (canClear !== undefined) return canClear;
        if (!day || !shipUsers || shipUsers.length == 0 || ((_a = app.user) === null || _a === void 0 ? void 0 : _a.id) == undefined) return undefined;
        return (0, $0f24dfcfd0e1e984$export$48ec7d5b25c25f39)({
            accountUserId: app.user.id,
            shipUsers: shipUsers,
            day: day,
            shipLocalHour: (0, $0f24dfcfd0e1e984$export$edea66b9267f8947)(day.timezone)
        });
    }, [
        (_d = app.user) === null || _d === void 0 ? void 0 : _d.id,
        canClear,
        day,
        shipUsers
    ]);
    const clearDenied = (c)=>c == (0, $a521756eb7208261$export$196d6ee34f2568f2).clear && mayClear === false;
    const choiceLabel = (c)=>{
        var _a;
        return c == "record" ? t("record", {
            lighting: app.t((0, $193beb513144bdb6$export$a4ef803d3e256716)((_a = lightsData === null || lightsData === void 0 ? void 0 : lightsData.recommended) !== null && _a !== void 0 ? _a : (0, $3bedadb68df9862e$export$966979137e3fd0b5).none, vesselType))
        }) : t(c);
    };
    // The confirmation replaces this dialog's content instead of stacking a second
    // overlay: the crew is deciding whether to end *this* alert, so the alert itself
    // stays on screen and the choices step aside until the question is answered.
    if (confirmingClear) return (0, $7b02d682eb115277$exports.jsxs)((0, $9347be5f58db4007$export$b2dedfcffe05aa1a), {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "UserAdviceAlertView",
            "UserAdviceAlertView-confirming"
        ]),
        bodyRef: bodyRef,
        scrollFooter: (0, $7b02d682eb115277$exports.jsx)((0, $403f1eee91546a91$export$1beabfbeae7b7782), {
            isAtBottom: isAtBottom,
            showScrollButton: showScrollButton,
            handleScrollMore: handleScrollMore,
            readMoreLabel: t("read_more")
        }),
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $251f3561e98d3db5$export$8ebcecbecdb22732), {
                    alert: alert,
                    lightingIcons: true,
                    vesselType: vesselType
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-infotext",
                children: (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "UserAdviceAlertView-confirm",
                    children: t("clear_confirm_message")
                })
            }),
            failed && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    children: (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "UserAdviceAlertView-error text-error",
                        children: t("error")
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                actions: true,
                className: "bottom",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button",
                            onClick: cancelClear,
                            children: t("clear_confirm_cancel")
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button default",
                            disabled: busy,
                            onClick: confirmClear,
                            children: t("clear_confirm")
                        })
                    })
                ]
            })
        ]
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $9347be5f58db4007$export$b2dedfcffe05aa1a), {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "UserAdviceAlertView"
        ]),
        bodyRef: bodyRef,
        scrollFooter: (0, $7b02d682eb115277$exports.jsx)((0, $403f1eee91546a91$export$1beabfbeae7b7782), {
            isAtBottom: isAtBottom,
            showScrollButton: showScrollButton,
            handleScrollMore: handleScrollMore,
            readMoreLabel: t("read_more")
        }),
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $251f3561e98d3db5$export$8ebcecbecdb22732), {
                    alert: alert,
                    lightingIcons: true,
                    vesselType: vesselType
                })
            }),
            choices.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    className: "block-row-checkboxes UserAdviceAlertView-choices",
                    children: choices.map((c)=>// Each choice is its own block: the radio and its label on one line,
                        // the explanation beneath. The explanation cannot live inside the
                        // `BlockField` -- `labelAfter` renders the label *after* the children,
                        // so it would end up between the radio and its own label.
                        (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "UserAdviceAlertView-choice",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: choiceLabel(c),
                                    labelAfter: true,
                                    labelFor: `alert-choice-${c}`,
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: `alert-choice-${c}`,
                                        name: "alertChoice",
                                        type: "radio",
                                        value: c,
                                        checked: choice == c,
                                        disabled: clearDenied(c),
                                        onChange: ()=>setChoice(c)
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "UserAdviceAlertView-explanation",
                                    children: t(`explain_${c}`)
                                })
                            ]
                        }, c))
                })
            }),
            mayClear === false && choices.includes((0, $a521756eb7208261$export$196d6ee34f2568f2).clear) && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-infotext",
                children: (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "UserAdviceAlertView-denied",
                    children: t("clear_denied")
                })
            }),
            failed && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    children: (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "UserAdviceAlertView-error text-error",
                        children: t("error")
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                actions: true,
                className: "bottom",
                children: [
                    lightsData && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                            className: "button",
                            onClick: openSettings,
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Settings
                                }),
                                " ",
                                t("settings")
                            ]
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button",
                            onClick: closeAlert,
                            children: t("cancel")
                        })
                    }),
                    choices.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button default",
                            type: "submit",
                            disabled: choice == undefined || busy,
                            onClick: submit,
                            children: choice == undefined ? t("submit_none") : t("submit", {
                                state: t(`state_${choice}`)
                            })
                        })
                    })
                ]
            })
        ]
    });
}
function $b38d5adbc9e0d928$export$9b688ca39e61eb17(app, props) {
    const t = app.getT("UserAdviceAlertView");
    const level = (0, $ed9e79f0f649608a$export$63ce30087a699ab4)[props.alert.value] || "default";
    return {
        close: true,
        className: "overlay-max-height",
        style: level,
        title: t("title", {
            name: t(`alert_${props.alert.name}`),
            level: t(`alert_${level}`)
        }),
        render: ()=>(0, $7b02d682eb115277$exports.jsx)($b38d5adbc9e0d928$export$40fc69da671684d, Object.assign({}, props))
    };
}



class $638a1296f5b66d6a$export$b198979c8e2df9af extends (0, $94dd0a1374840a0e$export$ecf796c81688685b) {
    constructor(){
        super(...arguments);
        this.role = (0, $9b0ea27c41d2c665$export$12d2560880666b0e).alert;
        this.active = false;
        this.alerts = [];
        this.delivery = new (0, $0a6b34a62f52e9a7$export$2f1995726e8f476a)();
        this.alertLevel = {
            [(0, $ed9e79f0f649608a$export$63ce30087a699ab4)[(0, $ed9e79f0f649608a$export$63ce30087a699ab4).alarm]]: 1000,
            [(0, $ed9e79f0f649608a$export$63ce30087a699ab4)[(0, $ed9e79f0f649608a$export$63ce30087a699ab4).warning]]: 500,
            "default": 10
        };
    }
    update(app, state, currentLog, ship) {
        var _a, _b, _c, _d;
        this.active = true;
        this.alerts = [];
        this.vesselType = ship === null || ship === void 0 ? void 0 : ship.vesselType;
        if (!currentLog) {
            this.active = false;
            this.delivery.reset();
            return;
        }
        this.day = (_a = state.days) === null || _a === void 0 ? void 0 : _a.find((d)=>d.id == currentLog.dayId);
        const alertStatuses = (0, $94dd0a1374840a0e$export$ecf796c81688685b).status((_d = (_c = (_b = app.status) === null || _b === void 0 ? void 0 : _b.nmea) === null || _c === void 0 ? void 0 : _c.liveAlerts) !== null && _d !== void 0 ? _d : state.statuses, (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).alert, currentLog.dayId).filter((s)=>s.endLogId == undefined).toSorted((a, b)=>b.id - a.id);
        if (alertStatuses.length < 0) {
            this.active = false;
            return;
        }
        this.alerts = $638a1296f5b66d6a$export$b198979c8e2df9af.byEpisode(alertStatuses);
        this.deliver(app);
    }
    // Collapse the open alert statuses down to one per *episode* (#1269).
    //
    // The server recreates an alert's Status row on every transition and closes the
    // previous one, so a single episode's row id rotates over its life. A device that
    // applies the create but misses or reorders the matching close holds several open
    // rows for one episode -- and one advice button is rendered per open row, so the
    // crew sees the same alert (e.g. "Lost Position") several times over.
    //
    // Grouping by the envelope's episode id (rather than by name) keeps genuinely
    // concurrent episodes -- several messages, several MOB beacons -- as separate
    // advices. Rows written before episode ids existed carry none, so they fall back
    // to the alert name, which is exactly right: every alert was a singleton then.
    // `statuses` arrives newest-first, so the first of each group is the current row.
    static byEpisode(statuses) {
        const seen = new Set();
        return statuses.filter((s)=>{
            const key = $638a1296f5b66d6a$export$b198979c8e2df9af.episodeKey(s);
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
    }
    static episodeKey(alert) {
        var _a;
        try {
            const episode = (_a = JSON.parse(alert.data || "{}")) === null || _a === void 0 ? void 0 : _a._episode;
            if (episode && typeof episode.id == "string" && episode.id.length > 0) return episode.id;
        } catch (e) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("AlertAdvice episodeKey", e);
        }
        return alert.name || "";
    }
    static indicators(app, alert, nowMs = Date.now()) {
        var _a, _b;
        const t = app.getT("UserAdviceAlertView");
        const labels = [];
        const icons = [];
        try {
            const episode = (_a = JSON.parse(alert.data || "{}")) === null || _a === void 0 ? void 0 : _a._episode;
            const snoozeUntilMs = (episode === null || episode === void 0 ? void 0 : episode.snoozeUntil) != null ? (0, $0a6b34a62f52e9a7$export$c49e422b03e52c67)(episode.snoozeUntil) : undefined;
            if (snoozeUntilMs != undefined && nowMs < snoozeUntilMs) labels.push(t("state_snoozed"));
            if ((episode === null || episode === void 0 ? void 0 : episode.acknowledgedBy) != null) labels.push(t("state_acknowledged"));
        } catch (_c) {
        // The delivery decision below has the same safe fallback for legacy rows.
        }
        if ((0, $0a6b34a62f52e9a7$export$d1ff0fc84d1e0690)(alert, (_b = app.user) === null || _b === void 0 ? void 0 : _b.id, nowMs, app.primarySession()) == (0, $0a6b34a62f52e9a7$export$bf367b9fffcba79).alarm) icons.push({
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Sounding,
            label: t("state_audible")
        });
        return {
            labels: labels,
            icons: icons
        };
    }
    // Drive the native delivery bridge (audible alarm + OS notification) from the
    // persisted alert envelope, for the signed-in user only. This is the client
    // mirror of the primary's own delivery so any device — including a plain
    // browser — presents an open alert without a bespoke realtime wire type.
    deliver(app) {
        var _a, _b, _c;
        const t = app.getT("UserAdviceAlertView");
        const describe = (alert)=>{
            const type = alert.name ? t(`alert_${alert.name}`) : t("title");
            const level = t(`alert_${(0, $ed9e79f0f649608a$export$63ce30087a699ab4)[alert.value] || "default"}`);
            let body = level;
            if (alert.name == (0, $ed9e79f0f649608a$export$5ebaef48f8647867).message) try {
                const message = JSON.parse(alert.data || "{}").message;
                if (typeof message == "string" && message.length > 0) body = message;
            } catch (err) {
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("AlertAdvice describe", err);
            }
            return {
                title: t("title", {
                    name: type,
                    level: level
                }),
                body: body
            };
        };
        const now = (_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.nmea) === null || _b === void 0 ? void 0 : _b.liveAlertTime;
        this.delivery.reconcile(this.alerts, (_c = app.user) === null || _c === void 0 ? void 0 : _c.id, now ? Date.parse(now) : Date.now(), describe, app.primarySession(), (alert)=>this.reportReceipt(app, alert));
    }
    // Eagerly (fire-and-forget) tell the primary that this device delivered the
    // alarm locally over the LAN, so the cloud never sends a redundant remote
    // push. The receipt carries the alert's stable episode identity (day + status
    // id); the primary derives the confirming user from the authenticated
    // session. Best-effort with a very small timeout — a lost receipt only risks a
    // (harmless) duplicate push.
    reportReceipt(app, alert) {
        if (!alert.name || alert.id < 0) return;
        new (0, $d4eccb73927932bb$export$4c70e389659ec851)(app.apiClient).alert.receipt({
            params: {
                alertName: alert.name
            },
            body: {
                dayId: alert.dayId,
                statusId: alert.id
            }
        }).call().catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("AlertAdvice receipt", err));
    }
    level(alert) {
        switch(alert.value){
            case (0, $ed9e79f0f649608a$export$63ce30087a699ab4).alarm:
                return (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).alarm;
            case (0, $ed9e79f0f649608a$export$63ce30087a699ab4).warning:
                return (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).warning;
            default:
                return (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).notice;
        }
    }
    // The icon each alert type shows on its button (#1171). Every open alert used to
    // render the same filled dot, so the whole button width went on spelling its name
    // out -- with a per-type icon the name can be shortened away when the row is tight.
    // `test` and any type without an icon of its own fall back to the generic warning
    // triangle rather than going blank.
    static icon(alert) {
        switch(alert.name){
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).anchorDrift:
                return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceAnchorDrift;
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).depth:
                return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceDepth;
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).lights:
                return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceLights;
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).lostPosition:
                return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceLostPosition;
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).manOverboard:
                return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceManOverboard;
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).message:
                return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceMessage;
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).pressure:
                return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdvicePressure;
            case (0, $ed9e79f0f649608a$export$5ebaef48f8647867).wind:
                return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceWind;
            default:
                return (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceTest;
        }
    }
    static navigationLights(alert) {
        if (alert.name != (0, $ed9e79f0f649608a$export$5ebaef48f8647867).lights) return undefined;
        try {
            const recommended = JSON.parse(alert.data || "{}").recommended;
            return (0, $509263b967d03828$export$e91817beb800b68f).supports(recommended) ? recommended : undefined;
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("AlertAdvice navigationLights", err);
            return undefined;
        }
    }
    getInstances(app, location, currentLog) {
        if (!this.active || !currentLog || location != (0, $94dd0a1374840a0e$export$b067a529c9eafd88).log) return [];
        const t = app.getT("UserAdviceAlertView");
        return this.alerts.map((s, i)=>{
            var _a, _b;
            const title = t(`alert_${s.name}`);
            const problem = (0, $251f3561e98d3db5$export$3a52cda2c00837c3)(app, s, this.vesselType);
            const liveTime = (_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.nmea) === null || _b === void 0 ? void 0 : _b.liveAlertTime;
            const indicators = $638a1296f5b66d6a$export$b198979c8e2df9af.indicators(app, s, liveTime ? Date.parse(liveTime) : Date.now());
            return new (0, $94dd0a1374840a0e$export$7ca5bcfc497210b6)(`alert-${s.id}`, this.alertLevel[(0, $ed9e79f0f649608a$export$63ce30087a699ab4)[s.value]] || this.alertLevel["default"], {
                icon: $638a1296f5b66d6a$export$b198979c8e2df9af.icon(s),
                navigationLights: $638a1296f5b66d6a$export$b198979c8e2df9af.navigationLights(s),
                level: this.level(s),
                title: problem ? `${title} ${problem}` : title,
                indicators: indicators.labels,
                indicatorIcons: indicators.icons,
                type: "alert",
                primaryAction: $638a1296f5b66d6a$export$b198979c8e2df9af.primaryAction(app, s, this.vesselType)
            }, this, i, location);
        });
    }
    // @almute's "Lösung 2" (#916): the navigation-lights reminder records the
    // required lighting on a plain click, and its caret opens the dialog with
    // snooze/acknowledge/clear and the full list. Recording needs `.editCurrent`, so
    // the route's own predicate rides along and the button collapses back to the
    // dialog for anyone without it.
    //
    // `recommended` is `nil` exactly in the "ask" case -- a sailing vessel whose
    // engine state is unknown, where the server has nothing to recommend -- so there
    // is nothing to short-cut and the button opens the dialog as before.
    static primaryAction(app, alert, vesselType) {
        if (alert.name != (0, $ed9e79f0f649608a$export$5ebaef48f8647867).lights) return undefined;
        const recommended = JSON.parse(alert.data || "{}").recommended;
        if (recommended == undefined) return undefined;
        const request = new (0, $c6e2761c15be5353$export$a90af23008f0d8fa)(app.apiClient).current.lighting({
            params: {},
            body: {
                lighting: recommended
            }
        });
        return {
            label: app.getT("UserAdviceAlertView")("record", {
                lighting: app.t((0, $193beb513144bdb6$export$a4ef803d3e256716)(recommended, vesselType))
            }),
            available: request.available,
            perform: ()=>{
                try {
                    request.call().catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("recordRecommended", err));
                } catch (err) {
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("recordRecommended", err);
                }
            }
        };
    }
    overlay(app, advice, state) {
        const alert = this.alerts[advice.index];
        if (!alert) return undefined;
        return (0, $b38d5adbc9e0d928$export$9b688ca39e61eb17)(app, {
            advice: advice,
            alert: alert,
            state: state,
            day: this.day,
            vesselType: this.vesselType
        });
    }
}








function $8917a348f5f6cf96$export$9198eba11df387a0(decision) {
    return decision.enabled && decision.active && !decision.blocked;
}
function $8917a348f5f6cf96$export$426450023049da80(options) {
    var current = options.initial;
    return {
        update: function(value) {
            if (value === current) return;
            current = value;
            options.sink(value);
        },
        current: function() {
            return current;
        }
    };
}


// Per-device opt-in for background network keep-alive. Stored locally (never
// synced) like `logbook-companion`, so each crew phone decides for itself whether
// it should stay resident on the LAN to receive the alert fan-out while locked.
const $72a36920d0208fe6$var$KEEP_ALIVE_KEY = "logbook-keepalive";
function $72a36920d0208fe6$export$985948ec1f1a6ec8(inputs) {
    return (0, $8917a348f5f6cf96$export$9198eba11df387a0)({
        enabled: inputs.optedIn,
        active: inputs.watchActive,
        blocked: inputs.isPrimary
    });
}
function $72a36920d0208fe6$export$de2e0b7e4bb172ae() {
    return (0, $2b75519151ca9024$export$3f685a6e8b195eac)($72a36920d0208fe6$var$KEEP_ALIVE_KEY) == "1";
}
function $72a36920d0208fe6$export$58c75c9bce1d4c9(value) {
    if (value) localStorage.setItem($72a36920d0208fe6$var$KEEP_ALIVE_KEY, "1");
    else localStorage.removeItem($72a36920d0208fe6$var$KEEP_ALIVE_KEY);
}
class $72a36920d0208fe6$export$b5ed8f8c619e89d {
    constructor(sink = (0, $413160cb4953a8b8$export$7bbc682b75e8aad4)){
        this.controller = (0, $8917a348f5f6cf96$export$426450023049da80)({
            sink: (active)=>sink.setNetworkKeepAlive(active)
        });
    }
    reconcile(inputs) {
        this.controller.update($72a36920d0208fe6$export$985948ec1f1a6ec8(inputs));
    }
}





var $acw62 = parcelRequire("acw62");




// Why an anchor-watch update was refused, in the terms the dialog explains it.
//
// The anchor watch has two preconditions the user can neither see nor guess from a
// generic failure: it needs a current position to seed the swing-circle origin from,
// and that position has to come from a source precise enough to measure a swing
// circle against. Both used to reach the client as an unnamed 400, so the dialog
// could only offer "please try again" — advice that cannot work, since retrying
// without a fix fails identically. The server names them instead
// (`LogbookApiError.anchorWatchNoPosition` / `.anchorWatchGpsPrecisionTooLow`), and
// this maps those names onto the message shown.
var $55b860127c55eee3$export$5753091321091d26;
(function(AnchorWatchFailure) {
    // Anything the dialog cannot attribute — e.g. a 401 for a user without permission.
    AnchorWatchFailure["generic"] = "generic";
    // No current fix at all: no NMEA position source and no native GPS.
    AnchorWatchFailure["noPosition"] = "noPosition";
    // A fix exists, but its source is below high GPS precision.
    AnchorWatchFailure["gpsPrecision"] = "gpsPrecision";
    // The day has not started (no log recorded), so there is nothing to attach a
    // watch to yet. Configuration edits are stored anyway -- only starting, stopping
    // or recentering is refused -- so the message says so rather than implying the
    // settings were lost (#1809).
    AnchorWatchFailure["noDay"] = "noDay";
})($55b860127c55eee3$export$5753091321091d26 || ($55b860127c55eee3$export$5753091321091d26 = {}));
// Keyed on the error NAME rather than the status: both are 400s, so the status alone
// cannot tell them apart (the same reasoning as the companion connect errors).
const $55b860127c55eee3$var$failures = {
    anchorWatchNoPosition: $55b860127c55eee3$export$5753091321091d26.noPosition,
    anchorWatchGpsPrecisionTooLow: $55b860127c55eee3$export$5753091321091d26.gpsPrecision,
    anchorWatchNoDay: $55b860127c55eee3$export$5753091321091d26.noDay
};
function $55b860127c55eee3$export$27860144bb8dcb1c(error) {
    var _a;
    if (!error || typeof error != "object") return $55b860127c55eee3$export$5753091321091d26.generic;
    const name = error.error;
    return (_a = typeof name == "string" ? $55b860127c55eee3$var$failures[name] : undefined) !== null && _a !== void 0 ? _a : $55b860127c55eee3$export$5753091321091d26.generic;
}









function $74000a71c8a04a87$export$fb4216da1f591b95({ enabled: enabled, name: name, toggleAction: toggleAction }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("Component_ToggleSwitch");
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ToggleSwitch",
        onClick: toggleAction,
        children: [
            !enabled && (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleLarge
            }),
            t(enabled ? "on" : "off"),
            enabled && (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleFilledLarge
            }),
            name && (0, $7b02d682eb115277$exports.jsx)("input", {
                name: name,
                type: "hidden",
                value: enabled ? "1" : ""
            })
        ]
    });
}








// The smallest drift band (meters) a stored configuration can plausibly mean, and
// the reading of one that is smaller. The bands were nautical miles before #1809,
// so a stored 0.1 is a leftover nm value, not a 10 cm swing circle: shown in a
// whole-meter field it reads as `0`, and saving it back would store a zero radius.
// Such a band is treated as unset so the field seeds from the default instead --
// the same rule the server applies in `AnchorDrift.sanitized`.
const $1eb8444550be08db$var$minimumBandMeters = 1;
function $1eb8444550be08db$var$sanitizeBand(meters) {
    return meters != undefined && meters >= $1eb8444550be08db$var$minimumBandMeters ? meters : undefined;
}
// The shipped `NavigationThresholds.anchorDrift` defaults (meters), mirrored here so
// the dialog can show what an unset band actually evaluates against. Reached only
// when the ship's own default is missing or is itself a leftover nautical-mile
// value; without it those fields would be blank, which is precisely the "I cannot
// tell what the defaults are" the metric switch produced.
const $1eb8444550be08db$var$defaultBands = {
    warning: 30,
    alarm: 50
};
// Fill a config's unset warning/alarm bands from a ship-wide `AlertThreshold`
// default (#1198). Every other field of the config (rode / boat length / sector
// bearings) is preserved untouched -- only the two bands have a ship-wide home.
function $1eb8444550be08db$var$seedBands(config, defaults, sanitize = $1eb8444550be08db$var$sanitizeBand, fallback) {
    var _a, _b, _c, _d;
    return Object.assign(Object.assign({}, config !== null && config !== void 0 ? config : {}), {
        warning: (_b = (_a = sanitize(config === null || config === void 0 ? void 0 : config.warning)) !== null && _a !== void 0 ? _a : sanitize(defaults === null || defaults === void 0 ? void 0 : defaults.warning)) !== null && _b !== void 0 ? _b : fallback === null || fallback === void 0 ? void 0 : fallback.warning,
        alarm: (_d = (_c = sanitize(config === null || config === void 0 ? void 0 : config.alarm)) !== null && _c !== void 0 ? _c : sanitize(defaults === null || defaults === void 0 ? void 0 : defaults.alarm)) !== null && _d !== void 0 ? _d : fallback === null || fallback === void 0 ? void 0 : fallback.alarm
    });
}
// The two drift bands, in meters (#1809) -- whole meters are precise enough for a
// swing circle, so every anchor distance is an `int` field.
const $1eb8444550be08db$var$bandFields = [
    {
        name: "warning",
        type: "int"
    },
    {
        name: "alarm",
        type: "int"
    }
];
// The form fields submitted for `method`. Only the active method's substruct is
// rendered, and therefore only it is submitted -- the server keeps the others.
// Anchor depth is independent of the method and always part of the form.
function $1eb8444550be08db$var$editableFieldsFor(method) {
    const methodFields = (()=>{
        switch(method){
            case (0, $3c48bffca65c360b$export$e31825d410fdad81).rodeScope:
                return {
                    name: "rodeScope",
                    type: "object",
                    fields: [
                        {
                            name: "rode",
                            type: "int"
                        },
                        {
                            name: "depth",
                            type: "float"
                        },
                        {
                            name: "boatLength",
                            type: "int"
                        },
                        ...$1eb8444550be08db$var$bandFields
                    ]
                };
            case (0, $3c48bffca65c360b$export$e31825d410fdad81).sector:
                return {
                    name: "sector",
                    type: "object",
                    fields: [
                        {
                            name: "bearingFrom",
                            type: "int"
                        },
                        {
                            name: "bearingTo",
                            type: "int"
                        },
                        ...$1eb8444550be08db$var$bandFields
                    ]
                };
            default:
                return {
                    name: "fixedRadius",
                    type: "object",
                    fields: $1eb8444550be08db$var$bandFields
                };
        }
    })();
    return [
        methodFields,
        {
            name: "depth",
            type: "object",
            fields: [
                {
                    name: "warning",
                    type: "float"
                },
                {
                    name: "alarm",
                    type: "float"
                }
            ]
        }
    ];
}
// A submitted substruct as a config object: `EditGroup` yields `null` for an empty
// field, which has to become an absent key so the server keeps inheriting rather
// than storing a zero.
function $1eb8444550be08db$var$submittedConfig(values, name) {
    var _a;
    const submitted = (_a = values[name]) !== null && _a !== void 0 ? _a : {};
    const config = {};
    for (const [key, value] of Object.entries(submitted))if (typeof value == "number") config[key] = value;
    return config;
}
function $1eb8444550be08db$export$4b2a597f57b8be00({ advice: advice, state: state, initFailed: initFailed, initKeepAlive: initKeepAlive }) {
    var _a, _b;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("UserAdviceAnchorMonitorView");
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const { bodyRef: bodyRef, showScrollButton: showScrollButton, isAtBottom: isAtBottom, handleScrollMore: handleScrollMore } = (0, $4be45b24a899ae38$export$5315996935894f9d)();
    const [edited, onEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const [failed, setFailed] = (0, $acw62.useState)(initFailed === true ? (0, $55b860127c55eee3$export$5753091321091d26).generic : initFailed || undefined);
    const userAdvice = (0, $acw62.useMemo)(()=>advice.parent, [
        advice
    ]);
    const enabled = userAdvice.enabled;
    const config = (0, $acw62.useMemo)(()=>{
        var _a;
        if (!((_a = userAdvice.monitor) === null || _a === void 0 ? void 0 : _a.data)) return undefined;
        try {
            return JSON.parse(userAdvice.monitor.data);
        } catch (e) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("anchor monitor data parse", e);
            return undefined;
        }
    }, [
        userAdvice
    ]);
    // Ship-wide drift / depth defaults (#1198). These thresholds were removed from the
    // NMEA Conditions tab, so this dialog is their only editing surface: a `.primary`
    // user's save is mirrored back into the ship's NavigationThresholds server-side, and
    // an unset per-watch band inherits from them. Seeding the fields from those defaults
    // surfaces the last used values instead of blank inputs over an invisible fallback.
    const thresholds = (0, $acw62.useMemo)(()=>(0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship).thresholds, [
        ship
    ]);
    // One state bag per method so edits to one are retained while another is shown.
    const [method, setMethod] = (0, $acw62.useState)((_a = config === null || config === void 0 ? void 0 : config.method) !== null && _a !== void 0 ? _a : (0, $3c48bffca65c360b$export$e31825d410fdad81).fixedRadius);
    const [fixedRadius, setFixedRadius] = (0, $acw62.useState)($1eb8444550be08db$var$seedBands(config === null || config === void 0 ? void 0 : config.fixedRadius, thresholds === null || thresholds === void 0 ? void 0 : thresholds.anchorDrift, $1eb8444550be08db$var$sanitizeBand, $1eb8444550be08db$var$defaultBands));
    const [rodeScope, setRodeScope] = (0, $acw62.useState)($1eb8444550be08db$var$seedBands(config === null || config === void 0 ? void 0 : config.rodeScope, thresholds === null || thresholds === void 0 ? void 0 : thresholds.anchorDrift, $1eb8444550be08db$var$sanitizeBand, $1eb8444550be08db$var$defaultBands));
    const [sector, setSector] = (0, $acw62.useState)($1eb8444550be08db$var$seedBands(config === null || config === void 0 ? void 0 : config.sector, thresholds === null || thresholds === void 0 ? void 0 : thresholds.anchorDrift, $1eb8444550be08db$var$sanitizeBand, $1eb8444550be08db$var$defaultBands));
    // Depth-below-limit alerting for this watch (#990): on by default, with an
    // optional per-watch warning/alarm override (nil fields inherit the ship default).
    // Independent of `method`, so it is sent on every save regardless of which
    // swing-circle evaluation method is active.
    // Depth bands never changed unit, and a sub-meter depth limit is a legitimate
    // setting, so they seed unsanitised.
    const [depth, setDepth] = (0, $acw62.useState)($1eb8444550be08db$var$seedBands(config === null || config === void 0 ? void 0 : config.depth, (_b = thresholds === null || thresholds === void 0 ? void 0 : thresholds.anchorDepth) !== null && _b !== void 0 ? _b : thresholds === null || thresholds === void 0 ? void 0 : thresholds.depth, (v)=>v));
    // Per-device opt-in to keep this companion alerting in the background while the
    // watch runs. Primary devices already self-keep (NMEA GPS), so the toggle is hidden
    // there. Toggling applies immediately via the advice.
    const [keepAlive, setKeepAlive] = (0, $acw62.useState)(initKeepAlive !== null && initKeepAlive !== void 0 ? initKeepAlive : (0, $72a36920d0208fe6$export$de2e0b7e4bb172ae)());
    const toggleKeepAlive = (0, $acw62.useCallback)(()=>{
        const next = !keepAlive;
        setKeepAlive(next);
        userAdvice.setKeepAlive(app, next);
    }, [
        keepAlive,
        userAdvice,
        app
    ]);
    // The active method's substruct is the only config sent; the server keeps the
    // rest, so no method's settings are lost when switching or saving. Anchor depth
    // is independent of the method and always sent.
    const configBody = (0, $acw62.useCallback)((values)=>{
        const methodBody = (()=>{
            switch(method){
                case (0, $3c48bffca65c360b$export$e31825d410fdad81).rodeScope:
                    return {
                        rodeScope: $1eb8444550be08db$var$submittedConfig(values, "rodeScope")
                    };
                case (0, $3c48bffca65c360b$export$e31825d410fdad81).sector:
                    return {
                        sector: $1eb8444550be08db$var$submittedConfig(values, "sector")
                    };
                default:
                    return {
                        fixedRadius: $1eb8444550be08db$var$submittedConfig(values, "fixedRadius")
                    };
            }
        })();
        return Object.assign({
            method: method,
            depth: $1eb8444550be08db$var$submittedConfig(values, "depth")
        }, methodBody);
    }, [
        method
    ]);
    // Only dismiss the dialog once the update actually succeeds — e.g. a user
    // without sufficient permission gets a 401, which must stay visible instead
    // of being swallowed behind an optimistically-closed dialog (#1146).
    const submit = (0, $acw62.useCallback)(async (body)=>{
        setFailed(undefined);
        try {
            await (0, $effa99ba9bf91d44$export$273525e6bbc3c841).anchorWatch(app.apiClient, body);
            state.setSelected(undefined);
        } catch (e) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("anchor watch update", e);
            setFailed((0, $55b860127c55eee3$export$27860144bb8dcb1c)(e));
        }
    }, [
        app,
        state
    ]);
    // Which button submitted the form. Save / Recenter / Enable all submit the same
    // edited configuration and differ only in what accompanies it, so the pressed
    // button is recorded here and read back in `onSave`.
    const action = (0, $acw62.useRef)("save");
    const onSave = (0, $acw62.useCallback)(async (_data, values)=>{
        const body = configBody(values);
        switch(action.current){
            case "recenter":
                return submit(Object.assign({
                    recenter: true
                }, body));
            case "enable":
                return submit(Object.assign({
                    enabled: true
                }, body));
            default:
                return submit(body);
        }
    }, [
        configBody,
        submit
    ]);
    const submitting = (0, $acw62.useCallback)((next)=>()=>{
            action.current = next;
        }, []);
    // A number input bound to `key` on an immutable config bag. The bag keeps the
    // typed value while another method is shown (the form only carries the fields it
    // renders), and seeds the field when this method comes back.
    function numberField(label, name, obj, key, setObj, options) {
        var _a, _b;
        const value = obj[key];
        const id = `anchor-monitor-${name}`;
        return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
            label: label,
            labelFor: id,
            children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                id: id,
                name: name,
                format: (_a = options === null || options === void 0 ? void 0 : options.format) !== null && _a !== void 0 ? _a : "int",
                unit: (_b = options === null || options === void 0 ? void 0 : options.unit) !== null && _b !== void 0 ? _b : "m",
                className: "block_field_small_12 center",
                defaultValue: value,
                onChange: (e)=>{
                    const parsed = parseFloat(e.target.value);
                    // Functional update: two fields of the same bag can be edited before a
                    // re-render, and a spread of the captured `obj` would drop the first edit.
                    setObj((prev)=>Object.assign(Object.assign({}, prev), {
                            [key]: isNaN(parsed) ? undefined : parsed
                        }));
                    onEdited();
                }
            })
        });
    }
    // Method-specific explanation shown right below the selector, swapping content
    // as the user changes method — a first draft of the copy, to be refined once
    // @almute reviews the wording (round 2).
    function explanation(m) {
        switch(method){
            case (0, $3c48bffca65c360b$export$e31825d410fdad81).rodeScope:
                return m.anchorMonitor.explanation.rodeScope;
            case (0, $3c48bffca65c360b$export$e31825d410fdad81).sector:
                return m.anchorMonitor.explanation.sector;
            default:
                return m.anchorMonitor.explanation.fixedRadius;
        }
    }
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: bodyRef,
                className: "Overlay-body",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    className: "UserAdviceDialog UserAdviceAnchorMonitorView",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block-row-top20",
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "bold",
                                        children: [
                                            t("method"),
                                            ":",
                                            "\u00A0",
                                            "\u00A0"
                                        ]
                                    }),
                                    (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: method,
                                        onChange: (e)=>setMethod(e.target.value),
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: (0, $3c48bffca65c360b$export$e31825d410fdad81).fixedRadius,
                                                children: t("method_fixedRadius")
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: (0, $3c48bffca65c360b$export$e31825d410fdad81).rodeScope,
                                                children: t("method_rodeScope")
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: (0, $3c48bffca65c360b$export$e31825d410fdad81).sector,
                                                children: t("method_sector")
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                className: "UserAdviceAnchorMonitorView-explanation text-bigger",
                                message: explanation
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                            changed: edited,
                            editableFields: $1eb8444550be08db$var$editableFieldsFor(method),
                            manualSave: true,
                            onSave: onSave,
                            children: [
                                method == (0, $3c48bffca65c360b$export$e31825d410fdad81).fixedRadius && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    className: "block-row-gap",
                                    children: [
                                        numberField(t("warning"), "fixedRadius.warning", fixedRadius, "warning", setFixedRadius),
                                        numberField(t("alarm"), "fixedRadius.alarm", fixedRadius, "alarm", setFixedRadius)
                                    ]
                                }),
                                method == (0, $3c48bffca65c360b$export$e31825d410fdad81).rodeScope && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                            children: [
                                                numberField(t("rode"), "rodeScope.rode", rodeScope, "rode", setRodeScope),
                                                numberField(t("depth"), "rodeScope.depth", rodeScope, "depth", setRodeScope, {
                                                    format: "float"
                                                }),
                                                numberField(t("boatLength"), "rodeScope.boatLength", rodeScope, "boatLength", setRodeScope)
                                            ]
                                        }),
                                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                            className: "block-row-gap",
                                            children: [
                                                numberField(t("warning"), "rodeScope.warning", rodeScope, "warning", setRodeScope),
                                                numberField(t("alarm"), "rodeScope.alarm", rodeScope, "alarm", setRodeScope)
                                            ]
                                        })
                                    ]
                                }),
                                method == (0, $3c48bffca65c360b$export$e31825d410fdad81).sector && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                            children: [
                                                numberField(t("bearingFrom"), "sector.bearingFrom", sector, "bearingFrom", setSector, {
                                                    unit: "\u00B0"
                                                }),
                                                numberField(t("bearingTo"), "sector.bearingTo", sector, "bearingTo", setSector, {
                                                    unit: "\u00B0"
                                                })
                                            ]
                                        }),
                                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                            className: "block-row-gap",
                                            children: [
                                                numberField(t("warning"), "sector.warning", sector, "warning", setSector),
                                                numberField(t("alarm"), "sector.alarm", sector, "alarm", setSector)
                                            ]
                                        })
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    className: "block-row-top20",
                                    children: [
                                        numberField(t("depthWarning"), "depth.warning", depth, "warning", setDepth, {
                                            format: "float"
                                        }),
                                        numberField(t("depthAlarm"), "depth.alarm", depth, "alarm", setDepth, {
                                            format: "float"
                                        })
                                    ]
                                }),
                                !app.primarySession() && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $74000a71c8a04a87$export$fb4216da1f591b95), {
                                                enabled: keepAlive,
                                                toggleAction: toggleKeepAlive
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: t("keepAlive")
                                            })
                                        ]
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("hr", {
                                    className: "block-row-top20"
                                }),
                                failed && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "UserAdviceAnchorMonitorView-error text-error",
                                            children: t(failed === (0, $55b860127c55eee3$export$5753091321091d26).generic ? "error" : `error_${failed}`)
                                        })
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    actions: true,
                                    className: "block-row-gap",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button",
                                                type: "button",
                                                onClick: ()=>state.setSelected(undefined),
                                                children: t("cancel")
                                            })
                                        }),
                                        enabled && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button",
                                                type: "submit",
                                                onClick: submitting("recenter"),
                                                children: t("recenter")
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button",
                                                type: "submit",
                                                onClick: submitting("save"),
                                                children: t("save")
                                            })
                                        }),
                                        enabled ? (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button default",
                                                type: "button",
                                                onClick: ()=>submit({
                                                        enabled: false
                                                    }),
                                                children: t("disable")
                                            })
                                        }) : (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button default",
                                                type: "submit",
                                                onClick: submitting("enable"),
                                                children: t("enable")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $403f1eee91546a91$export$1beabfbeae7b7782), {
                isAtBottom: isAtBottom,
                showScrollButton: showScrollButton,
                handleScrollMore: handleScrollMore,
                readMoreLabel: t("read_more")
            })
        ]
    });
}
function $1eb8444550be08db$export$a9c0cd6afd6fdfc6(props) {
    return {
        close: !props.advice.props.hideClose,
        title: props.advice.props.title,
        className: "overlay-max-height",
        render: ()=>(0, $7b02d682eb115277$exports.jsx)($1eb8444550be08db$export$4b2a597f57b8be00, Object.assign({}, props))
    };
}




var $fca41b9e1e736253$export$f4b9b416c370f027;
(function(GPSPrecision) {
    GPSPrecision[GPSPrecision["reduced"] = 1] = "reduced";
    GPSPrecision[GPSPrecision["high"] = 2] = "high";
})($fca41b9e1e736253$export$f4b9b416c370f027 || ($fca41b9e1e736253$export$f4b9b416c370f027 = {}));
function $fca41b9e1e736253$export$6b8c216e45fc2d3(app) {
    var _a, _b;
    switch((_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.nmea.data.navigation) === null || _b === void 0 ? void 0 : _b.source){
        case (0, $b75415c6faae2236$export$de7878d8063d52cb).native:
            return $fca41b9e1e736253$export$f4b9b416c370f027.reduced;
        case (0, $b75415c6faae2236$export$de7878d8063d52cb).nmea:
            return $fca41b9e1e736253$export$f4b9b416c370f027.high;
        default:
            return undefined;
    }
}
function $fca41b9e1e736253$export$62e3526580df8281(app, minimum) {
    const precision = $fca41b9e1e736253$export$6b8c216e45fc2d3(app);
    return precision == undefined || precision >= minimum;
}


class $fba3ed29ef76e70c$export$ff81d08b853665f6 extends (0, $94dd0a1374840a0e$export$ecf796c81688685b) {
    constructor(){
        super(...arguments);
        this.role = (0, $9b0ea27c41d2c665$export$12d2560880666b0e).monitor;
        this.active = false;
        this.enabled = false;
        this.monitor = undefined;
        this.alerts = [];
        this.keepAlive = new (0, $72a36920d0208fe6$export$b5ed8f8c619e89d)();
    }
    update(app, state, currentLog, ship) {
        this.active = false;
        this.enabled = false;
        this.monitor = undefined;
        this.alerts = [];
        if (!currentLog) {
            this.reconcileKeepAlive(app);
            return;
        }
        const monitorStatuses = (0, $94dd0a1374840a0e$export$ecf796c81688685b).status(state.statuses, (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).monitor, currentLog.dayId).filter((s)=>s.item == (0, $3c48bffca65c360b$export$2ff82625ed03cf18).anchor).toSorted((a, b)=>b.id - a.id);
        const activeMonitor = monitorStatuses.find((status)=>status.endLogId == undefined);
        if (activeMonitor) {
            this.monitor = activeMonitor;
            this.enabled = true;
        } else {
            const settings = ship ? (0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship).anchorWatchSettings : undefined;
            if (settings) this.monitor = {
                data: JSON.stringify(settings)
            };
            else if (monitorStatuses[0]) this.monitor = monitorStatuses[0];
        }
        // The watch dialog is always available when GPS precision is sufficient.
        // An already-running watch shows so it can be reviewed / stopped.
        this.active = this.enabled || (0, $fca41b9e1e736253$export$62e3526580df8281)(app, (0, $fca41b9e1e736253$export$f4b9b416c370f027).high);
        const shipStatus = (0, $94dd0a1374840a0e$export$ecf796c81688685b).status(state.statuses, (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship, currentLog.dayId).filter((s)=>s.endLogId == undefined).toSorted((a, b)=>b.id - a.id)[0];
        if (this.active) {
            const depthEnabled = this.enabled && shipStatus != undefined && (shipStatus.value == (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).anchor || shipStatus.value == (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).buoy);
            this.alerts = (0, $94dd0a1374840a0e$export$ecf796c81688685b).status(state.statuses, (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).alert, currentLog.dayId).filter((s)=>s.endLogId == undefined && (s.name == (0, $ed9e79f0f649608a$export$5ebaef48f8647867).anchorDrift || s.name == (0, $ed9e79f0f649608a$export$5ebaef48f8647867).lostPosition || s.name == (0, $ed9e79f0f649608a$export$5ebaef48f8647867).depth && depthEnabled));
        }
        this.reconcileKeepAlive(app);
    }
    // Hold the native background keep-alive on this (opt-in, non-primary) companion
    // while the anchor watch is actually running, so a backgrounded / locked phone keeps
    // receiving the LAN fan-out; release it when the watch stops or the device opts out.
    reconcileKeepAlive(app) {
        this.keepAlive.reconcile({
            watchActive: this.enabled,
            optedIn: (0, $72a36920d0208fe6$export$de2e0b7e4bb172ae)(),
            isPrimary: app.primarySession()
        });
    }
    // Toggle this device's background keep-alive opt-in from the anchor-watch UI, and
    // apply it immediately (rather than waiting for the next advice update).
    setKeepAlive(app, optedIn) {
        (0, $72a36920d0208fe6$export$58c75c9bce1d4c9)(optedIn);
        this.reconcileKeepAlive(app);
    }
    // The monitor-role contract (#916). `enabled` is this watch's own running state
    // and `active` is whether the dialog can be shown at all. The watch can be armed
    // before anchoring; its consumers remain status-gated until anchor/buoy.
    isActive() {
        return this.enabled;
    }
    hasProblem(app) {
        var _a, _b;
        if (!this.enabled) return false;
        const nmea = (_a = app.status) === null || _a === void 0 ? void 0 : _a.nmea;
        const navigation = nmea === null || nmea === void 0 ? void 0 : nmea.data.navigation;
        const position = (_b = nmea === null || nmea === void 0 ? void 0 : nmea.data.n2k) === null || _b === void 0 ? void 0 : _b.position;
        const hasPosition = Number.isFinite(navigation === null || navigation === void 0 ? void 0 : navigation.lat) && Number.isFinite(navigation === null || navigation === void 0 ? void 0 : navigation.lng) || Number.isFinite(position === null || position === void 0 ? void 0 : position.latitude) && Number.isFinite(position === null || position === void 0 ? void 0 : position.longitude);
        // Automatic log writing is independent of position processing during Stopover.
        // The existing watchdog owns freshness, not lastReceived (any sensor traffic).
        return !hasPosition || this.alerts.some((status)=>status.name == (0, $ed9e79f0f649608a$export$5ebaef48f8647867).lostPosition);
    }
    isAvailable() {
        return this.active;
    }
    activate(app) {
        return this.setEnabled(app, true);
    }
    deactivate(app) {
        return this.setEnabled(app, false);
    }
    // Through the dedicated lifecycle route, like the dialog's own submit: the
    // client never composes the monitor status write itself, so two devices toggling
    // the same watch cannot race into contradictory rows.
    async setEnabled(app, enabled) {
        await (0, $effa99ba9bf91d44$export$273525e6bbc3c841).anchorWatch(app.apiClient, {
            enabled: enabled
        });
    }
    getInstances(app, location, currentLog) {
        // Keep settings in the ship toolbar, and show a notice-level reminder in the
        // current-log row while the watch is running. Alert conditions still surface
        // separately through AlertAdvice in their warning/alarm colours.
        //
        // The id stays location-scoped. FocusView keeps a single `selected` id across
        // every location (one FocusViewState per day), so two locations sharing an id
        // would have a click at one satisfy both instances' `state.selected == this.id`
        // check and open both dialogs at once.
        const visible = location == (0, $94dd0a1374840a0e$export$b067a529c9eafd88).toolbar && this.active;
        if (!visible || !currentLog) return [];
        const t = app.getT("UserAdviceAnchorMonitorView");
        return [
            new (0, $94dd0a1374840a0e$export$7ca5bcfc497210b6)(`anchor-${location}`, $fba3ed29ef76e70c$export$ff81d08b853665f6.level, {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceAnchor,
                level: (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).notice,
                shortTitle: t("title_short"),
                title: t(this.enabled ? "title_active" : "title_inactive"),
                type: "anchor"
            }, this, 0, location)
        ];
    }
    overlay(_app, advice, state) {
        return (0, $1eb8444550be08db$export$a9c0cd6afd6fdfc6)({
            advice: advice,
            state: state
        });
    }
}
$fba3ed29ef76e70c$export$ff81d08b853665f6.level = 100;








var $acw62 = parcelRequire("acw62");












// Depth limits read to one decimal (`5.0 m`), the precision they are alerted on and
// the way they have always been shown -- a bare `5` would suggest the field only
// takes whole meters.
function $0ebcb99aaf9370a0$var$depthValue(meters) {
    return meters == undefined ? undefined : meters.toFixed(1);
}
function $0ebcb99aaf9370a0$export$4cea0921a62938d9({ namePrefix: namePrefix = "thresholds", onEdited: onEdited, thresholds: thresholds, compact: compact = true }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("NMEAConfigurationView");
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
        className: compact ? "block-row-no_labels" : undefined,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("condition_depth_warning"),
                className: compact ? "label-left-0" : "block_field_small_12",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                    format: "float",
                    unit: "m",
                    name: `${namePrefix}.depth.warning`,
                    defaultValue: $0ebcb99aaf9370a0$var$depthValue(thresholds === null || thresholds === void 0 ? void 0 : thresholds.warning),
                    className: compact ? "block_field_small_6 center" : "block_field_small_12 center",
                    onChange: onEdited
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("condition_depth_alarm"),
                className: compact ? "label-left-0" : "block_field_small_12",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                    format: "float",
                    unit: "m",
                    name: `${namePrefix}.depth.alarm`,
                    defaultValue: $0ebcb99aaf9370a0$var$depthValue(thresholds === null || thresholds === void 0 ? void 0 : thresholds.alarm),
                    className: compact ? "block_field_small_6 center" : "block_field_small_12 center",
                    onChange: onEdited
                })
            })
        ]
    });
}




const $bb63f5baa9657ee7$var$editableFields = [
    {
        name: "thresholds",
        type: "object",
        fields: [
            {
                name: "depth",
                type: "object",
                fields: [
                    {
                        name: "warning",
                        type: "float"
                    },
                    {
                        name: "alarm",
                        type: "float"
                    }
                ]
            }
        ]
    }
];
function $bb63f5baa9657ee7$export$d938d4f461d19eeb({ advice: advice, state: state, initFailed: initFailed, initSaveFailed: initSaveFailed }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("UserAdviceDepthWatchView");
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const settingsWriters = (0, $bf76a3a7a0d207c0$export$4bb86e129f694bc0)(ship.id);
    const [edited, _onEdited, _resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const [failed, setFailed] = (0, $acw62.useState)(initFailed !== null && initFailed !== void 0 ? initFailed : false);
    const [saveFailed, setSaveFailed] = (0, $acw62.useState)(initSaveFailed !== null && initSaveFailed !== void 0 ? initSaveFailed : false);
    const userAdvice = (0, $acw62.useMemo)(()=>advice.parent, [
        advice
    ]);
    const enabled = userAdvice.enabled;
    const thresholds = (0, $acw62.useMemo)(()=>(0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship).thresholds, [
        ship
    ]);
    // Only dismiss the dialog once the update actually succeeds — e.g. a user
    // without sufficient permission gets a 401, which must stay visible instead
    // of being swallowed behind an optimistically-closed dialog (#1146).
    const submit = (0, $acw62.useCallback)(async (enable)=>{
        setFailed(false);
        try {
            await (0, $effa99ba9bf91d44$export$273525e6bbc3c841).depthWatch(app.apiClient, {
                enabled: enable
            });
            state.setSelected(undefined);
        } catch (e) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("depth watch update", e);
            setFailed(true);
        }
    }, [
        app,
        state
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const saveThresholds = (0, $acw62.useCallback)(async (_data, values)=>{
        var _a;
        setSaveFailed(false);
        await settingsWriters.updateSettings({
            thresholds: Object.assign(Object.assign({}, thresholds), {
                depth: (_a = values.thresholds) === null || _a === void 0 ? void 0 : _a.depth
            })
        });
    }, [
        settingsWriters,
        thresholds
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $9347be5f58db4007$export$b2dedfcffe05aa1a), {
        className: "UserAdviceDepthWatchView",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-infotext block-row-one-row",
                children: t("text")
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                changed: edited,
                editableFields: $bb63f5baa9657ee7$var$editableFields,
                manualSave: true,
                onSave: saveThresholds,
                onSaveError: (error)=>{
                    if (error == undefined) {
                        setSaveFailed(false);
                        return;
                    }
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("depth threshold save", error);
                    setSaveFailed(true);
                },
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $0ebcb99aaf9370a0$export$4cea0921a62938d9), {
                        thresholds: thresholds === null || thresholds === void 0 ? void 0 : thresholds.depth,
                        compact: false,
                        onEdited: _onEdited
                    }),
                    saveFailed && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-top20",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "UserAdviceDepthWatchView-save-error text-error",
                                children: t("save_error")
                            })
                        })
                    }),
                    failed && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-top20",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "UserAdviceDepthWatchView-error text-error",
                                children: t("error")
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        actions: true,
                        className: "block-row-gap",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button",
                                    type: "button",
                                    onClick: ()=>state.setSelected(undefined),
                                    children: t("cancel")
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button",
                                    type: "submit",
                                    children: t("save")
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button default",
                                    type: "button",
                                    onClick: ()=>submit(!enabled),
                                    children: t(enabled ? "disable" : "enable")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $bb63f5baa9657ee7$export$2e185cc1f99d0f0b(props) {
    return {
        close: !props.advice.props.hideClose,
        title: props.advice.props.title,
        render: ()=>(0, $7b02d682eb115277$exports.jsx)($bb63f5baa9657ee7$export$d938d4f461d19eeb, Object.assign({}, props))
    };
}



class $49c5a477485199dc$export$5879c238a0789f40 extends (0, $94dd0a1374840a0e$export$ecf796c81688685b) {
    constructor(){
        super(...arguments);
        this.role = (0, $9b0ea27c41d2c665$export$12d2560880666b0e).monitor;
        this.active = false;
        this.enabled = false;
        this.monitor = undefined;
        this.alerts = [];
    }
    // The standalone underway depth watch (#990): independent of any anchor watch,
    // enabled by its mere presence (no method/threshold config of its own -- the
    // underway default threshold always applies). It is configurable on any active
    // day, but only claims a depth alert while the ship status is `inmotion`.
    update(_app, state, currentLog) {
        this.active = false;
        this.enabled = false;
        this.monitor = undefined;
        this.alerts = [];
        if (!currentLog) return;
        this.active = true;
        const monitorStatus = (0, $94dd0a1374840a0e$export$ecf796c81688685b).status(state.statuses, (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).monitor, currentLog.dayId).filter((s)=>s.item == (0, $3c48bffca65c360b$export$2ff82625ed03cf18).depth).toSorted((a, b)=>b.id - a.id)[0];
        if (monitorStatus && monitorStatus.endLogId == undefined) {
            this.enabled = true;
            this.monitor = monitorStatus;
        }
        const shipStatus = (0, $94dd0a1374840a0e$export$ecf796c81688685b).status(state.statuses, (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship, currentLog.dayId).filter((s)=>s.endLogId == undefined).toSorted((a, b)=>b.id - a.id)[0];
        if (this.enabled && (shipStatus === null || shipStatus === void 0 ? void 0 : shipStatus.value) == (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).inmotion) this.alerts = (0, $94dd0a1374840a0e$export$ecf796c81688685b).status(state.statuses, (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).alert, currentLog.dayId).filter((s)=>s.endLogId == undefined && s.name == (0, $ed9e79f0f649608a$export$5ebaef48f8647867).depth);
    }
    // The monitor-role contract (#916). Unlike the anchor watch, "underway" is not a
    // trackable ship state, so this watch is available on any day with a current log
    // -- which is exactly what `active` already means here.
    isActive() {
        return this.enabled;
    }
    isAvailable() {
        return this.active;
    }
    activate(app) {
        return this.setEnabled(app, true);
    }
    deactivate(app) {
        return this.setEnabled(app, false);
    }
    // Through the dedicated lifecycle route, like the dialog's own submit.
    async setEnabled(app, enabled) {
        await (0, $effa99ba9bf91d44$export$273525e6bbc3c841).depthWatch(app.apiClient, {
            enabled: enabled
        });
    }
    getInstances(app, location, currentLog) {
        // The ship toolbar only (#916) -- same reasoning, and the same
        // location-scoped id, as AnchorMonitorAdvice.getInstances above.
        if (!this.active || !currentLog || location != (0, $94dd0a1374840a0e$export$b067a529c9eafd88).toolbar) return [];
        const t = app.getT("UserAdviceDepthWatchView");
        return [
            new (0, $94dd0a1374840a0e$export$7ca5bcfc497210b6)(`depth-${location}`, $49c5a477485199dc$export$5879c238a0789f40.level, {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceDepth,
                level: (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).notice,
                shortTitle: t("title_short"),
                title: t(this.enabled ? "title_active" : "title_inactive"),
                type: "depth"
            }, this, 0, location)
        ];
    }
    overlay(_app, advice, state) {
        return (0, $bb63f5baa9657ee7$export$2e185cc1f99d0f0b)({
            advice: advice,
            state: state
        });
    }
}
$49c5a477485199dc$export$5879c238a0789f40.level = 90;








var $acw62 = parcelRequire("acw62");








function $5ebf778e276078d0$export$ae7bc46617ed9409({ advice: advice, state: state }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const t = app.getT("UserAdviceEngineMissingView");
    const parent = (0, $acw62.useMemo)(()=>advice.parent, [
        advice
    ]);
    const engines = (0, $acw62.useMemo)(()=>ship ? (0, $22871482fce5b7e5$export$7930c61d9b464618).engines(ship) : [], [
        ship
    ]);
    const severalEngines = engines.length > 1;
    const [selectedEngines, setSelectedEngines] = (0, $acw62.useState)([]);
    const [since, setSince] = (0, $acw62.useState)((0, $00a37f738d2ad7ac$export$113f730d88151ffc).trigger);
    // A motor vessel has no sails, so "no, we're sailing" is nonsense there — but the
    // answer itself must stay available (@mutle decision): the hint is only resolved by an
    // open engine status or an "engine off" marker, so removing it would leave a motor
    // vessel re-broadcasting the ghost every tick with a falsehood as the only way out.
    // Gated on `vesselType`, never on the hint's `reason`: a motor vessel leaving a berth
    // reports `castOff`, so a reason-gate would mislabel most motor-vessel departures.
    const noSails = (ship === null || ship === void 0 ? void 0 : ship.vesselType) == (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).motor;
    const toggleEngine = (0, $acw62.useCallback)((id)=>{
        setSelectedEngines((current)=>current.includes(id) ? current.filter((e)=>e != id) : [
                ...current,
                id
            ]);
    }, []);
    // Nothing is pre-ticked, so an engine is only ever recorded because the crew said so.
    // This restores the one-tap common case (both engines running while manoeuvring)
    // without assuming it.
    const toggleAllEngines = (0, $acw62.useCallback)(()=>{
        setSelectedEngines((current)=>current.length == engines.length ? [] : engines.map((e)=>e.id));
    }, [
        engines
    ]);
    const answer = (0, $acw62.useCallback)(async (value)=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("engine hint", value, since, selectedEngines);
        state.setSelected(undefined);
        await (0, $effa99ba9bf91d44$export$273525e6bbc3c841).engineHint(app.apiClient, {
            answer: value,
            engines: value == (0, $00a37f738d2ad7ac$export$9bea942779b9814b).started && severalEngines ? selectedEngines : undefined,
            since: value == (0, $00a37f738d2ad7ac$export$9bea942779b9814b).started ? since : undefined
        });
    }, [
        app,
        since,
        selectedEngines,
        severalEngines,
        state
    ]);
    // On a multi-engine ship the crew must name at least one engine before confirming.
    const startDisabled = severalEngines && selectedEngines.length == 0;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $9347be5f58db4007$export$b2dedfcffe05aa1a), {
        className: "UserAdviceEngineMissingView",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-infotext",
                children: t(`text_${parent.reason}`)
            }),
            severalEngines && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    className: "block-row-checkboxes",
                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                        children: [
                            engines.map((engine)=>(0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: (0, $22871482fce5b7e5$export$7930c61d9b464618).engineName(ship, engine.id, engine.number),
                                    labelAfter: true,
                                    labelFor: `engineHintEngine-${engine.id}`,
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        checked: selectedEngines.includes(engine.id),
                                        id: `engineHintEngine-${engine.id}`,
                                        name: "engines",
                                        type: "checkbox",
                                        value: engine.id,
                                        onChange: ()=>toggleEngine(engine.id)
                                    })
                                }, engine.id)),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("all_engines"),
                                labelAfter: true,
                                labelFor: "engineHintAllEngines",
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    checked: selectedEngines.length == engines.length,
                                    id: "engineHintAllEngines",
                                    name: "allEngines",
                                    type: "checkbox",
                                    onChange: toggleAllEngines
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    className: "block-row-checkboxes",
                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                        className: "block_field_small_24",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "checkbox-text-bigger",
                                label: t("since_trigger", {
                                    time: app.format("time", parent.since)
                                }),
                                labelAfter: true,
                                labelFor: `engineHintSince-${(0, $00a37f738d2ad7ac$export$113f730d88151ffc).trigger}`,
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    checked: since == (0, $00a37f738d2ad7ac$export$113f730d88151ffc).trigger,
                                    id: `engineHintSince-${(0, $00a37f738d2ad7ac$export$113f730d88151ffc).trigger}`,
                                    name: "since",
                                    type: "radio",
                                    value: (0, $00a37f738d2ad7ac$export$113f730d88151ffc).trigger,
                                    onChange: ()=>setSince((0, $00a37f738d2ad7ac$export$113f730d88151ffc).trigger)
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "checkbox-text-bigger",
                                label: t("since_now"),
                                labelAfter: true,
                                labelFor: `engineHintSince-${(0, $00a37f738d2ad7ac$export$113f730d88151ffc).now}`,
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    checked: since == (0, $00a37f738d2ad7ac$export$113f730d88151ffc).now,
                                    id: `engineHintSince-${(0, $00a37f738d2ad7ac$export$113f730d88151ffc).now}`,
                                    name: "since",
                                    type: "radio",
                                    value: (0, $00a37f738d2ad7ac$export$113f730d88151ffc).now,
                                    onChange: ()=>setSince((0, $00a37f738d2ad7ac$export$113f730d88151ffc).now)
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                actions: true,
                className: "bottom",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button",
                            onClick: ()=>state.setSelected(undefined),
                            children: t("cancel")
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button",
                            onClick: ()=>answer((0, $00a37f738d2ad7ac$export$9bea942779b9814b).sailing),
                            children: t(noSails ? "sailing_noSails" : "sailing")
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button default",
                            disabled: startDisabled,
                            onClick: ()=>answer((0, $00a37f738d2ad7ac$export$9bea942779b9814b).started),
                            children: t("started")
                        })
                    })
                ]
            })
        ]
    });
}
function $5ebf778e276078d0$export$354950ae3ffe45fd(props) {
    return {
        close: !props.advice.props.hideClose,
        title: props.advice.props.title,
        render: ()=>(0, $7b02d682eb115277$exports.jsx)($5ebf778e276078d0$export$ae7bc46617ed9409, Object.assign({}, props))
    };
}


const $b09b5fc1616e92f9$export$e2b8c01da96a4c45 = "engineMissing";
class $b09b5fc1616e92f9$export$a138fee432a731b8 extends (0, $94dd0a1374840a0e$export$ecf796c81688685b) {
    constructor(){
        super(...arguments);
        this.role = (0, $9b0ea27c41d2c665$export$12d2560880666b0e).action;
        this.active = false;
        // The trigger log a confirmed engine start is back-dated to (the departure, the
        // anchor-up, or the motor vessel's first log under way).
        this.sinceLogId = undefined;
        // That log's time, so the dialog can offer "since <time>" as the default anchor.
        this.since = undefined;
        this.reason = undefined;
    }
    update(_app, state, currentLog) {
        var _a;
        this.active = false;
        this.sinceLogId = undefined;
        this.since = undefined;
        this.reason = undefined;
        if (!currentLog) return;
        const hint = (_a = state.provisionalLogs) === null || _a === void 0 ? void 0 : _a[$b09b5fc1616e92f9$export$e2b8c01da96a4c45];
        if (!hint || hint.dayId != currentLog.dayId) return;
        const entry = (0, $1746073b9b284418$export$ce30dbb46644d06c).parse(hint).dataParsed.engineMissing;
        if (!entry) return;
        this.sinceLogId = entry.sinceLogId;
        this.since = hint.time;
        this.reason = entry.reason;
        this.active = true;
    }
    getInstances(app, location, currentLog) {
        // The hint belongs to the live current log, where the crew is actually working --
        // not to the day summary.
        if (!this.active || !currentLog || location != (0, $94dd0a1374840a0e$export$b067a529c9eafd88).log) return [];
        const t = app.getT("UserAdviceEngineMissingView");
        return [
            new (0, $94dd0a1374840a0e$export$7ca5bcfc497210b6)($b09b5fc1616e92f9$export$e2b8c01da96a4c45, $b09b5fc1616e92f9$export$a138fee432a731b8.level, {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).MotorVessel,
                level: (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).notice,
                shortTitle: t("title_short"),
                title: t(`title_${this.reason}`),
                type: "engineMissing"
            }, this, 0, location)
        ];
    }
    overlay(_app, advice, state) {
        return (0, $5ebf778e276078d0$export$354950ae3ffe45fd)({
            advice: advice,
            state: state
        });
    }
}
$b09b5fc1616e92f9$export$a138fee432a731b8.level = 50;










var $acw62 = parcelRequire("acw62");





function $85f1bde35ef4753c$export$9df02d85f6c83f1({ advice: advice, state: state, initFailed: initFailed }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("UserAdviceManualShipStatusView");
    const [failed, setFailed] = (0, $acw62.useState)(initFailed !== null && initFailed !== void 0 ? initFailed : false);
    const userAdvice = (0, $acw62.useMemo)(()=>advice.parent, [
        advice
    ]);
    // Only dismiss the dialog once the update actually succeeds -- e.g. a user without
    // `editCurrent` gets a 401, which must stay visible instead of being swallowed
    // behind an optimistically-closed dialog (#1146).
    const submit = (0, $acw62.useCallback)(async (enabled)=>{
        setFailed(false);
        try {
            await (0, $effa99ba9bf91d44$export$273525e6bbc3c841).manualShipStatus(app.apiClient, {
                enabled: enabled
            });
            state.setSelected(undefined);
        } catch (e) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("manual ship status update", e);
            setFailed(true);
        }
    }, [
        app,
        state
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $9347be5f58db4007$export$b2dedfcffe05aa1a), {
        className: "UserAdviceManualShipStatusView",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-infotext",
                children: t("text")
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-infotext",
                children: t("remaining", {
                    minutes: userAdvice.remainingMinutes(),
                    time: userAdvice.endTime(app)
                })
            }),
            failed && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    children: (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "UserAdviceManualShipStatusView-error text-error",
                        children: t("error")
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                actions: true,
                className: "block-row-no_labels",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button",
                            onClick: ()=>state.setSelected(undefined),
                            children: t("close")
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button",
                            onClick: ()=>submit(false),
                            children: t("cancel")
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button default",
                            onClick: ()=>submit(true),
                            children: t("extend")
                        })
                    })
                ]
            })
        ]
    });
}
function $85f1bde35ef4753c$export$4c1dc4125521ad53(props) {
    return {
        close: !props.advice.props.hideClose,
        title: props.advice.props.title,
        render: ()=>(0, $7b02d682eb115277$exports.jsx)($85f1bde35ef4753c$export$9df02d85f6c83f1, Object.assign({}, props))
    };
}


class $1c12265da4481cc8$export$53aabbf2f7a09853 extends (0, $94dd0a1374840a0e$export$ecf796c81688685b) {
    constructor(){
        super(...arguments);
        this.role = (0, $9b0ea27c41d2c665$export$12d2560880666b0e).action;
        this.active = false;
        this.status = undefined;
        // The mode's expiry, on the app's `timeUtc` epoch (seconds since 2001-01-01 UTC),
        // and the current log's time / timezone offset the button and dialog read it
        // against. All three are only set while `active`.
        this.expiresAtUtc = undefined;
        this.timeUtc = 0;
        this.timezone = 0;
    }
    // The manual ship-status mode (#511): while it runs, navigation makes no automatic
    // ship-status changes at all and the crew sets the status themselves. An OPEN
    // `.manualShipStatus` status IS the on-signal (closing it via `endLogId` the
    // off-signal), so -- unlike the anchor and depth watches, which also offer an
    // "enable" entry point while inactive -- this advice exists ONLY while the mode is
    // actually running. Switching it on lives in the LogButton menu instead, because
    // the mode is a deliberate, occasional action rather than a configurable watch.
    update(_app, state, currentLog) {
        this.active = false;
        this.status = undefined;
        this.expiresAtUtc = undefined;
        this.timeUtc = 0;
        this.timezone = 0;
        if (!currentLog) return;
        const status = (0, $94dd0a1374840a0e$export$ecf796c81688685b).status(state.statuses, (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).manualShipStatus, currentLog.dayId).filter((s)=>s.endLogId == undefined).toSorted((a, b)=>b.id - a.id)[0];
        if (!status) return;
        const expiresAtUtc = $1c12265da4481cc8$export$53aabbf2f7a09853.expiresAtUtc(status);
        // Without a readable expiry there is nothing to show and nothing sensible to
        // extend from, so stay silent rather than render a mode with no clock.
        if (expiresAtUtc == undefined) return;
        this.status = status;
        this.expiresAtUtc = expiresAtUtc;
        this.timeUtc = currentLog.timeUtc;
        this.timezone = currentLog.timezone;
        this.active = true;
    }
    // The payload's `expiresAt` is an absolute ISO date (Swift `Date`), deliberately
    // absolute rather than a remaining duration so a restart mid-mode resumes with the
    // correct clock. Converted here to the `timeUtc` epoch the logs are measured in.
    static expiresAtUtc(status) {
        var _a;
        try {
            const expiresAt = (_a = JSON.parse(status.data || "{}")) === null || _a === void 0 ? void 0 : _a.expiresAt;
            if (!expiresAt) return undefined;
            const ms = new Date(expiresAt).valueOf();
            return isNaN(ms) ? undefined : (ms - (0, $14a8bda8b42de2c4$export$4334e0aa46d23a16)) / 1000;
        } catch (e) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("ManualShipStatusAdvice expiresAtUtc", e);
            return undefined;
        }
    }
    // Measured against the CURRENT LOG's time rather than the wall clock -- the same
    // source StopUserAdvice counts its "Stopped for ..." from, so the value advances
    // with the live log broadcast (which is what re-runs `update`) and needs no timer
    // of its own. Rounded up so a mode with seconds left never reads as "0 minutes",
    // and clamped at 0: expiry belongs to navigation, which closes the status on its
    // own tick, so a lapsed mode keeps rendering here until that arrives.
    remainingMinutes() {
        if (this.expiresAtUtc == undefined) return 0;
        return Math.max(0, Math.ceil((this.expiresAtUtc - this.timeUtc) / 60));
    }
    // The mode's end moment in board time, the way TrackView renders a board clock:
    // the UTC value shifted by the log's own timezone offset.
    endTime(app) {
        if (this.expiresAtUtc == undefined) return "";
        return app.format("timeUtc", this.expiresAtUtc + this.timezone);
    }
    getInstances(app, location, currentLog) {
        // Only on the current log row: the mode gates what navigation records for the
        // live log, so there is nothing to say about it on the day summary.
        if (!this.active || !currentLog || location != (0, $94dd0a1374840a0e$export$b067a529c9eafd88).log) return [];
        const t = app.getT("UserAdviceManualShipStatusView");
        return [
            new (0, $94dd0a1374840a0e$export$7ca5bcfc497210b6)("manual-ship-status", $1c12265da4481cc8$export$53aabbf2f7a09853.level, {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceManualShipStatus,
                level: (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).notice,
                shortTitle: t("title_short"),
                title: t("title_active", {
                    time: this.endTime(app)
                }),
                type: "manual-ship-status"
            }, this, 0, location)
        ];
    }
    overlay(_app, advice, state) {
        return (0, $85f1bde35ef4753c$export$4c1dc4125521ad53)({
            advice: advice,
            state: state
        });
    }
}
$1c12265da4481cc8$export$53aabbf2f7a09853.level = 95;








var $acw62 = parcelRequire("acw62");









function $9bb675836a841582$export$20440df0ea57079b({ advice: advice, state: state, statuses: statuses, fixedShipStatus: fixedShipStatus }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const t = app.getT("UserAdviceStopView");
    const [edited, _onEdited, _resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const editableFields = [
        "endLocation",
        {
            name: "shipStatus",
            type: "int"
        },
        {
            name: "statusId",
            type: "int"
        },
        {
            name: "stopEngines",
            type: "bool"
        },
        "stopType"
    ];
    const initData = state.data || {};
    const [stopType, setStopType] = (0, $acw62.useState)(initData.stopType || (0, $c931aad0bd934103$export$2b2f7f32699a98f9).endOfDay);
    const [shipStatus, setShipStatus] = (0, $acw62.useState)(fixedShipStatus !== null && fixedShipStatus !== void 0 ? fixedShipStatus : initData.shipStatus);
    // Check if there are manual engine entries (no NMEA engine data) and engines are running
    const hasManualEnginesRunning = (0, $acw62.useMemo)(()=>{
        var _a, _b, _c;
        if (!ship || !statuses) return false;
        // Check if NMEA has engine data
        const hasNMEAEngineData = ((_c = (_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.nmea) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.engine) && app.status.nmea.data.engine.length > 0;
        if (hasNMEAEngineData) return false; // If NMEA has engine data, engines are not manual
        // Check if there are any running engine statuses
        const engineStatuses = statuses.filter((s)=>s.statusType === (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).engine && s.endLogId === undefined);
        return engineStatuses.length > 0;
    }, [
        ship,
        statuses,
        app.status
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const save = (0, $acw62.useCallback)(async (_data, values)=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("saving", (0, $ea493e883ca706d4$export$9de129cb03ba998c)(values));
        state.setSelected(undefined);
        if (state.recordStop) await state.recordStop(values);
        else await (0, $effa99ba9bf91d44$export$273525e6bbc3c841).stop(app.apiClient, values);
    }, [
        hasManualEnginesRunning,
        ship,
        state,
        app
    ]);
    const stopUserAdvice = (0, $acw62.useMemo)(()=>advice.parent, [
        advice
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $9347be5f58db4007$export$b2dedfcffe05aa1a), {
        className: "UserAdviceStopView",
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
            changed: edited,
            editableFields: editableFields,
            onSave: save,
            children: [
                stopUserAdvice && stopUserAdvice.statusId && (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "hidden",
                    name: "statusId",
                    value: stopUserAdvice.statusId
                }),
                fixedShipStatus !== undefined && (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "hidden",
                    name: "shipStatus",
                    value: fixedShipStatus
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-infotext",
                    children: t(fixedShipStatus === undefined ? "text" : "text_fixed_status")
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        className: "block-row-checkboxes",
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                            className: "block_field_small_24",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    className: "checkbox-text-bigger",
                                    label: t("end_of_day"),
                                    labelAfter: true,
                                    labelFor: "stopType-endOfDay",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultChecked: stopType === (0, $c931aad0bd934103$export$2b2f7f32699a98f9).endOfDay,
                                        id: "stopType-endOfDay",
                                        name: "stopType",
                                        type: "radio",
                                        className: "",
                                        value: (0, $c931aad0bd934103$export$2b2f7f32699a98f9).endOfDay,
                                        onChange: ()=>setStopType((0, $c931aad0bd934103$export$2b2f7f32699a98f9).endOfDay)
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    className: "checkbox-text-bigger",
                                    label: t("stopover"),
                                    labelAfter: true,
                                    labelFor: "stopType-stopover",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultChecked: stopType === (0, $c931aad0bd934103$export$2b2f7f32699a98f9).stopover,
                                        id: "stopType-stopover",
                                        name: "stopType",
                                        type: "radio",
                                        className: "",
                                        value: (0, $c931aad0bd934103$export$2b2f7f32699a98f9).stopover,
                                        onChange: ()=>setStopType((0, $c931aad0bd934103$export$2b2f7f32699a98f9).stopover)
                                    })
                                })
                            ]
                        })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-one-row",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("end_location"),
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: "endLocation",
                            className: "block_field_small_30",
                            defaultValue: initData.endLocation || ""
                        })
                    })
                }),
                fixedShipStatus === undefined && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            className: "block-row-checkboxes",
                            children: [
                                (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).anchor,
                                (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).buoy,
                                (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).port,
                                (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).drifting
                            ].map((status)=>{
                                return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t(`status_${(0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[status]}`),
                                    labelAfter: true,
                                    labelFor: `shipStatus-${status}`,
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultChecked: status === initData.shipStatus,
                                        id: `shipStatus-${status}`,
                                        name: "shipStatus",
                                        type: "radio",
                                        className: "",
                                        value: status,
                                        onChange: ()=>setShipStatus(status)
                                    })
                                }, status);
                            })
                        }),
                        stopType == (0, $c931aad0bd934103$export$2b2f7f32699a98f9).stopover && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            className: "block-row-checkboxes",
                            children: [
                                (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).lock,
                                (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).bunkering,
                                (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).bridge,
                                (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).waiting
                            ].map((status)=>{
                                return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t(`status_${(0, $58e03ea0c4d227bb$export$a923b2e0216c55ec)[status]}`),
                                    labelAfter: true,
                                    labelFor: `shipStatus-${status}`,
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultChecked: status === initData.shipStatus,
                                        id: `shipStatus-${status}`,
                                        name: "shipStatus",
                                        type: "radio",
                                        className: "",
                                        value: status,
                                        onChange: ()=>setShipStatus(status)
                                    })
                                }, status);
                            })
                        })
                    ]
                }),
                hasManualEnginesRunning && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block-row-top20 text-bigger",
                            children: (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: t("manual_engine_entries")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block-row-infotext",
                            children: t("manual_engine_entries_text")
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block-row-checkboxes",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("stop_engines"),
                                labelAfter: true,
                                labelFor: "stopEngines",
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "stopEngines",
                                    name: "stopEngines",
                                    value: "true",
                                    type: "checkbox"
                                })
                            })
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    actions: true,
                    className: "bottom",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button",
                                onClick: ()=>state.setSelected(undefined),
                                children: t("cancel")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button default",
                                type: "submit",
                                disabled: shipStatus === undefined,
                                children: t("save")
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function $9bb675836a841582$export$a5b3aa415656946e(props) {
    return {
        close: !props.advice.props.hideClose,
        title: props.advice.props.title,
        render: ()=>(0, $7b02d682eb115277$exports.jsx)($9bb675836a841582$export$20440df0ea57079b, Object.assign({}, props))
    };
}


const $f42df09c15c89c7d$export$1cc6aa4fccf95dcb = "speedChangeStop";
class $f42df09c15c89c7d$export$7fecc456ea4c736b extends (0, $94dd0a1374840a0e$export$ecf796c81688685b) {
    constructor(){
        super(...arguments);
        this.role = (0, $9b0ea27c41d2c665$export$12d2560880666b0e).action;
        this.active = false;
        this.started = 0;
        this.statusId = undefined;
        this.fixedShipStatus = undefined;
        // The day's statuses as of the last update, handed to the dialog so it can spot
        // running manual engines without reaching for the day context (#1171).
        this.statuses = [];
    }
    update(_app, state, currentLog) {
        var _a, _b, _c;
        this.active = false;
        this.statusId = undefined;
        this.fixedShipStatus = undefined;
        this.statuses = state.statuses;
        if (!currentLog) return;
        const shipStatus = (0, $94dd0a1374840a0e$export$ecf796c81688685b).status(state.statuses, (0, $d0f8aae9e6f7e80f$export$d03236bd7c374ce6).ship, currentLog.dayId).filter((s)=>s.endLogId == undefined).toSorted((a, b)=>b.id - a.id)[0];
        if (!shipStatus) {
            this.started = 0;
            return;
        }
        const startLog = state.logs.find((log)=>log.id === shipStatus.startLogId);
        const manuallySelectedStopped = [
            (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).anchor,
            (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).buoy,
            (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).port,
            (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).drifting
        ].includes(shipStatus.value) && ((_a = startLog === null || startLog === void 0 ? void 0 : startLog.labels) === null || _a === void 0 ? void 0 : _a.includes("manual"));
        const hasStopHint = startLog && state.logs.some((entry)=>(0, $1746073b9b284418$export$ce30dbb46644d06c).parse(entry).dataParsed.type === (0, $c931aad0bd934103$export$d9de83d1fc77d7c4).stop && (entry.timeUtc > startLog.timeUtc || entry.timeUtc === startLog.timeUtc && entry.id > startLog.id));
        if (manuallySelectedStopped) {
            if (!hasStopHint) {
                this.active = true;
                this.statusId = shipStatus.id;
                this.fixedShipStatus = shipStatus.value;
                this.started = (_b = startLog === null || startLog === void 0 ? void 0 : startLog.timeUtc) !== null && _b !== void 0 ? _b : 0;
            } else this.started = 0;
            return;
        }
        if (shipStatus && shipStatus.value != (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).inmotion && shipStatus.value != (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).drifting) {
            this.started = 0;
            return;
        }
        // While the automatic stop is only pending (#1218) the ship status is still the
        // `.inmotion` one the pause interrupts, so the engine's live marker is the only
        // thing that knows a pause is under way -- and its time is the moment the ship
        // actually stopped, which is what the button's "Stopped for …" has to count from.
        // Prefer it over the local speed/status reading: it is the server's own verdict,
        // reached on `thresholds.stop` rather than a standstill guessed at here.
        const pendingStop = (_c = state.provisionalLogs) === null || _c === void 0 ? void 0 : _c[$f42df09c15c89c7d$export$1cc6aa4fccf95dcb];
        if (pendingStop && pendingStop.dayId == currentLog.dayId) {
            this.statusId = shipStatus.id;
            this.started = pendingStop.timeUtc;
            this.active = true;
            return;
        }
        // No live marker, so the only pause this can be is one that has already committed
        // -- which is precisely what a `.drifting` status is, and whose start log IS the
        // stop entry, so the duration below is measured from the right moment.
        //
        // The ship's live speed is deliberately NOT consulted (#1793). A committed pause is
        // a server-side fact -- the engine opened `.drifting` on its own `thresholds.stop`
        // -- so re-deciding it here against a hardcoded 0.1 kn only took the button away
        // from a ship lying at anchor whose GPS reads a few tenths of a knot, which is what
        // @almute hit ("Ich habe keinen Button gesehen"). It gated nothing else: an
        // `.inmotion` ship without a marker is already turned away just below.
        //
        // An `.inmotion` ship at a standstill with no marker is deliberately NOT offered
        // the stop. Either the engine has not broadcast the marker yet (at most one
        // process interval), or the crew dismissed the pending pause -- and a dismissal
        // means "don't tell me about this pause" until the ship moves again and stops
        // afresh. Activating here would also mis-time the button: the open status is the
        // one under which the ship got *under way*, so a four-hour passage would render as
        // "Stopped for 4:00:12" (the bug the marker above was introduced to fix, #1218).
        if (shipStatus.value != (0, $58e03ea0c4d227bb$export$a923b2e0216c55ec).drifting) {
            this.started = 0;
            return;
        }
        if (startLog) {
            this.statusId = shipStatus.id;
            this.started = startLog.timeUtc;
        } else this.started = 0;
        this.active = true;
    }
    getInstances(app, location, currentLog) {
        if (!this.active || !currentLog || location != (0, $94dd0a1374840a0e$export$b067a529c9eafd88).log) return [];
        const t = app.getT("UserAdviceStopView");
        const duration = currentLog.timeUtc - this.started;
        return [
            new (0, $94dd0a1374840a0e$export$7ca5bcfc497210b6)("stop", $f42df09c15c89c7d$export$7fecc456ea4c736b.level, {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceStop,
                level: (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).notice,
                shortTitle: t("title_short"),
                title: t(this.started ? "title_duration" : "title", {
                    duration: app.format("time", duration)
                }),
                type: "stop"
            }, this, 0, location)
        ];
    }
    overlay(_app, advice, state) {
        return (0, $9bb675836a841582$export$a5b3aa415656946e)({
            advice: advice,
            state: state,
            statuses: this.statuses,
            fixedShipStatus: this.fixedShipStatus
        });
    }
}
$f42df09c15c89c7d$export$7fecc456ea4c736b.level = 10;








var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");





function $9c117c85461d7686$export$fd0137b9e93c7d0({ settings: settings, onEdited: onEdited }) {
    var _a, _b, _c, _d;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipSettingsView");
    const reminderSettings = settings === null || settings === void 0 ? void 0 : settings.lightsReminderSettings;
    const [enabled, setEnabled] = (0, $acw62.useState)((_a = settings === null || settings === void 0 ? void 0 : settings.lightsReminder) !== null && _a !== void 0 ? _a : false);
    const [sailingLights, setSailingLights] = (0, $acw62.useState)((_b = reminderSettings === null || reminderSettings === void 0 ? void 0 : reminderSettings.sailingLights) !== null && _b !== void 0 ? _b : (0, $3bedadb68df9862e$export$caacc4cb23d7ffa3).runningLights);
    const [lead, setLead] = (0, $acw62.useState)((_c = reminderSettings === null || reminderSettings === void 0 ? void 0 : reminderSettings.lead) !== null && _c !== void 0 ? _c : (0, $7bbbb4844e018774$export$42da589e9ff495e5).civil);
    // The motoring cone is optional in many jurisdictions, so it is opted out by
    // default (present in disabledSignals). The checkbox is the inverse: ticked means
    // "remind me", which removes the cone from disabledSignals.
    const [remindMotoringCone, setRemindMotoringCone] = (0, $acw62.useState)(!((_d = reminderSettings === null || reminderSettings === void 0 ? void 0 : reminderSettings.disabledSignals) !== null && _d !== void 0 ? _d : [
        (0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringCone
    ]).includes((0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringCone));
    const [showInfo, setShowInfo] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        var _a;
        setEnabled((_a = settings === null || settings === void 0 ? void 0 : settings.lightsReminder) !== null && _a !== void 0 ? _a : false);
    }, [
        settings === null || settings === void 0 ? void 0 : settings.lightsReminder
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c;
        setSailingLights((_a = reminderSettings === null || reminderSettings === void 0 ? void 0 : reminderSettings.sailingLights) !== null && _a !== void 0 ? _a : (0, $3bedadb68df9862e$export$caacc4cb23d7ffa3).runningLights);
        setLead((_b = reminderSettings === null || reminderSettings === void 0 ? void 0 : reminderSettings.lead) !== null && _b !== void 0 ? _b : (0, $7bbbb4844e018774$export$42da589e9ff495e5).civil);
        setRemindMotoringCone(!((_c = reminderSettings === null || reminderSettings === void 0 ? void 0 : reminderSettings.disabledSignals) !== null && _c !== void 0 ? _c : [
            (0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringCone
        ]).includes((0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringCone));
    }, [
        reminderSettings === null || reminderSettings === void 0 ? void 0 : reminderSettings.sailingLights,
        reminderSettings === null || reminderSettings === void 0 ? void 0 : reminderSettings.lead,
        reminderSettings === null || reminderSettings === void 0 ? void 0 : reminderSettings.disabledSignals
    ]);
    const disabledSignals = remindMotoringCone ? [] : [
        (0, $3bedadb68df9862e$export$966979137e3fd0b5).motoringCone
    ];
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                    className: "block-row-followed-by-block-row",
                    children: t("lights_title")
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-checkboxes block-row-one-row",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("lights_enable"),
                        labelAfter: true,
                        labelFor: "LightsReminder",
                        className: "checkbox-text-bigger",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "hidden",
                                name: "lightsReminder",
                                value: enabled ? "true" : "false"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: "LightsReminder",
                                type: "checkbox",
                                checked: enabled,
                                onChange: ()=>{
                                    setEnabled(!enabled);
                                    onEdited();
                                }
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            className: "button",
                            onClick: ()=>setShowInfo(true),
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "question-circle",
                                    children: "?"
                                }),
                                "  ",
                                t("more_info")
                            ]
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "hidden",
                name: "lightsReminderSettings.sailingLights",
                value: sailingLights
            }),
            (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "hidden",
                name: "lightsReminderSettings.lead",
                value: lead
            }),
            (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "hidden",
                name: "lightsReminderSettings.disabledSignals.length",
                value: disabledSignals.length
            }),
            disabledSignals.map((signal, i)=>(0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "hidden",
                    name: `lightsReminderSettings.disabledSignals[${i}]`,
                    value: signal
                }, `disabled-${i}`)),
            enabled && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-one-row",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("lights_sailing"),
                                className: "block_field_26",
                                children: (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    value: sailingLights,
                                    onChange: (e)=>{
                                        setSailingLights(parseInt(e.target.value));
                                        onEdited();
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: (0, $3bedadb68df9862e$export$caacc4cb23d7ffa3).runningLights,
                                            children: t("lights_sailing_runningLights")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: (0, $3bedadb68df9862e$export$caacc4cb23d7ffa3).triColor,
                                            children: t("lights_sailing_triColor")
                                        })
                                    ]
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("lights_lead"),
                                className: "block_field_26",
                                children: (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    value: lead,
                                    onChange: (e)=>{
                                        setLead(parseInt(e.target.value));
                                        onEdited();
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: (0, $7bbbb4844e018774$export$42da589e9ff495e5).civil,
                                            children: t("lights_lead_civil")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("option", {
                                            value: (0, $7bbbb4844e018774$export$42da589e9ff495e5).official,
                                            children: t("lights_lead_official")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-checkboxes block-row-one-row",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("lights_motoring_cone"),
                            labelAfter: true,
                            labelFor: "LightsMotoringCone",
                            className: "block_field_small_22 checkbox-text-bigger",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                id: "LightsMotoringCone",
                                type: "checkbox",
                                checked: remindMotoringCone,
                                onChange: ()=>{
                                    setRemindMotoringCone(!remindMotoringCone);
                                    onEdited();
                                }
                            })
                        })
                    })
                ]
            }),
            showInfo && (0, $7b02d682eb115277$exports.jsx)((0, $43e7c9e0370237d7$export$b605456b9cec4c34), {
                title: t("lights_title"),
                message: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.shipSetting.lights
                }),
                onClose: ()=>setShowInfo(false),
                style: "info"
            })
        ]
    });
}


const $3c3efc5b8e701512$var$editableFields = [
    {
        name: "lightsReminder",
        type: "bool"
    },
    {
        name: "lightsReminderSettings",
        type: "object",
        fields: [
            {
                name: "sailingLights",
                type: "int",
                default: null
            },
            {
                name: "lead",
                type: "int",
                default: null
            },
            {
                name: "disabledSignals",
                type: "int",
                array: true,
                default: null
            }
        ]
    }
];
function $3c3efc5b8e701512$export$aa5165aa6ba4c05c({ settings: settings, save: save, state: state }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("UserAdviceLightsReminderView");
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const { bodyRef: bodyRef, showScrollButton: showScrollButton, isAtBottom: isAtBottom, handleScrollMore: handleScrollMore } = (0, $4be45b24a899ae38$export$5315996935894f9d)();
    const onSave = (0, $acw62.useCallback)(async (_data, values)=>{
        await save(Object.assign(Object.assign({}, settings), values));
        resetEdited();
    }, [
        resetEdited,
        save,
        settings
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "UserAdviceLightsReminderView",
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
            closeCallback: ()=>state.setSelected(undefined),
            className: "overlay-max-height",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$fe53879cede8fc3), {
                    closeCallback: ()=>state.setSelected(undefined),
                    title: t("title")
                }),
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    ref: bodyRef,
                    className: "Overlay-body",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                        changed: edited,
                        editable: true,
                        editableFields: $3c3efc5b8e701512$var$editableFields,
                        onSave: onSave,
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                            className: "",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $9c117c85461d7686$export$fd0137b9e93c7d0), {
                                settings: settings,
                                onEdited: onEdited
                            })
                        })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $403f1eee91546a91$export$1beabfbeae7b7782), {
                    isAtBottom: isAtBottom,
                    showScrollButton: showScrollButton,
                    handleScrollMore: handleScrollMore,
                    readMoreLabel: t("read_more")
                })
            ]
        })
    });
}
function $3c3efc5b8e701512$export$181d7c3a44f02067(props) {
    return {
        render: ()=>(0, $7b02d682eb115277$exports.jsx)($3c3efc5b8e701512$export$aa5165aa6ba4c05c, Object.assign({}, props))
    };
}


class $2febf87ec74c9de2$export$8115f4d7feda197b extends (0, $94dd0a1374840a0e$export$ecf796c81688685b) {
    constructor(writers){
        super();
        this.writers = writers;
        this.role = (0, $9b0ea27c41d2c665$export$12d2560880666b0e).monitor;
        this.settings = {};
    }
    update(_app, _state, _currentLog, ship) {
        if (ship) this.settings = (0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship);
    }
    isActive() {
        var _a;
        return (_a = this.settings.lightsReminder) !== null && _a !== void 0 ? _a : false;
    }
    isAvailable() {
        return true;
    }
    async activate(_app) {
        await this.save(Object.assign(Object.assign({}, this.settings), {
            lightsReminder: true
        }));
    }
    async deactivate(_app) {
        await this.save(Object.assign(Object.assign({}, this.settings), {
            lightsReminder: false
        }));
    }
    async save(settings) {
        var _a;
        await this.writers.updateSettings({
            lightsReminder: (_a = settings.lightsReminder) !== null && _a !== void 0 ? _a : false,
            lightsReminderSettings: settings.lightsReminderSettings
        });
        this.settings = settings;
    }
    getInstances(app, location) {
        if (location != (0, $94dd0a1374840a0e$export$b067a529c9eafd88).toolbar) return [];
        const t = app.getT("UserAdviceLightsReminderView");
        return [
            new (0, $94dd0a1374840a0e$export$7ca5bcfc497210b6)(`lights-${location}`, 80, {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).AdviceLights,
                level: (0, $9b0ea27c41d2c665$export$85f867f6e70ad5cb).notice,
                title: t(this.isActive() ? "title_active" : "title_inactive"),
                type: "lights"
            }, this, 0, location)
        ];
    }
    overlay(_app, advice, state) {
        return (0, $3c3efc5b8e701512$export$181d7c3a44f02067)({
            advice: advice,
            state: state,
            settings: this.settings,
            save: (settings)=>this.save(settings)
        });
    }
}


function $d3468a341ccd86ee$export$89f5bb725713fc32(app, settingsWriters) {
    return [
        new (0, $638a1296f5b66d6a$export$b198979c8e2df9af)(),
        new (0, $f42df09c15c89c7d$export$7fecc456ea4c736b)(),
        new (0, $b09b5fc1616e92f9$export$a138fee432a731b8)(),
        new (0, $fba3ed29ef76e70c$export$ff81d08b853665f6)(),
        new (0, $49c5a477485199dc$export$5879c238a0789f40)(),
        ...settingsWriters ? [
            new (0, $2febf87ec74c9de2$export$8115f4d7feda197b)(settingsWriters)
        ] : [],
        new (0, $1c12265da4481cc8$export$53aabbf2f7a09853)()
    ].filter((advice)=>advice.feature == undefined || app.hasFeature(advice.feature));
}
function $d3468a341ccd86ee$export$d87663e1151173bc(app, role) {
    return $d3468a341ccd86ee$export$89f5bb725713fc32(app).filter((advice)=>advice.role == role);
}












var $acw62 = parcelRequire("acw62");


const $d1f80c8455d1c371$export$cc9d73738f4bc1e2 = {
    none: "none"
};
function $d1f80c8455d1c371$export$41ae3f4ddc0f7e7c({ advices: advices, state: state }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const overlays = (0, $acw62.useMemo)(()=>{
        const definitions = {
            [$d1f80c8455d1c371$export$cc9d73738f4bc1e2.none]: {
                render: ()=>null
            }
        };
        for (const advice of advices){
            const overlay = advice.overlay(app, state);
            if (overlay) definitions[advice.id] = overlay;
        }
        return definitions;
    }, [
        advices,
        app,
        state
    ]);
    // An advice can vanish while its dialog is open -- the alert clears, the watch
    // stops, the day rolls over -- and `OverlayView` throws on a name it has no
    // definition for. Fall back to `none` so a disappearing advice simply closes its
    // dialog instead of taking the view down with it.
    const selected = state.selected && overlays[state.selected] ? state.selected : $d1f80c8455d1c371$export$cc9d73738f4bc1e2.none;
    return (0, $7b02d682eb115277$exports.jsx)((0, $74bcfc43c0f9ac90$export$89acdd91182d6c5d), {
        className: "UserAdviceOverlay",
        overlay: selected,
        overlays: overlays,
        resetOverlay: ()=>state.setSelected(undefined)
    });
}















var $acw62 = parcelRequire("acw62");






function $eeddd8f3a1b0b342$export$45281bb990d7842a({ advices: advices, app: app, initOpen: initOpen, state: state }) {
    const monitors = (0, $acw62.useMemo)(()=>advices.filter((advice)=>(0, $94dd0a1374840a0e$export$ea1172994c7dcdd5)(advice.parent)), [
        advices
    ]);
    if (monitors.length == 0) return null;
    return (0, $7b02d682eb115277$exports.jsx)($eeddd8f3a1b0b342$var$UserAdviceMonitorMenu, {
        advices: monitors,
        app: app,
        initOpen: initOpen,
        state: state
    });
}
// `monitors` above established the parent implements the contract.
function $eeddd8f3a1b0b342$var$monitorOf(advice) {
    return advice.parent;
}
async function $eeddd8f3a1b0b342$var$switchMonitor(advice, app) {
    const monitor = $eeddd8f3a1b0b342$var$monitorOf(advice);
    try {
        if (monitor.isActive()) await monitor.deactivate(app);
        else await monitor.activate(app);
        return true;
    } catch (err) {
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("UserAdviceMonitorToggle update", err);
        return false;
    }
}
function $eeddd8f3a1b0b342$var$UserAdviceMonitorMenu({ advices: advices, app: app, initOpen: initOpen, state: state }) {
    const [revision, setRevision] = (0, $acw62.useState)(0);
    const [pending, setPending] = (0, $acw62.useState)(new Set());
    const watchActive = advices.some((advice)=>(advice.props.type == "anchor" || advice.props.type == "depth") && $eeddd8f3a1b0b342$var$monitorOf(advice).isActive());
    const watchProblem = advices.some((advice)=>{
        var _a;
        const monitor = $eeddd8f3a1b0b342$var$monitorOf(advice);
        return monitor.isActive() && ((_a = monitor.hasProblem) === null || _a === void 0 ? void 0 : _a.call(monitor, app));
    });
    const t = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)().getT("MenuAlerts");
    const items = (0, $acw62.useMemo)(()=>{
        const result = [];
        advices.forEach((advice)=>{
            // Add divider before navigation lights
            if (advice.props.type == "lights") result.push((0, $07fea78136a1afdb$export$2b6ac906eb59b21b));
            const active = $eeddd8f3a1b0b342$var$monitorOf(advice).isActive();
            const updating = pending.has(advice.id);
            result.push({
                className: [
                    "UserAdviceMonitorMenu-item",
                    "UserAdviceMonitorMenu-settings"
                ],
                icon: advice.props.icon,
                id: advice.id,
                title: advice.props.title,
                onClick: ()=>{
                    state.setSelected(advice.id);
                    return true;
                },
                render: ()=>(0, $7b02d682eb115277$exports.jsx)("button", {
                        "aria-label": advice.props.title,
                        "aria-pressed": active,
                        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                            "UserAdviceMonitorMenu-toggle",
                            active && "active"
                        ]),
                        disabled: updating,
                        type: "button",
                        onClick: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            setPending((value)=>new Set(value).add(advice.id));
                            $eeddd8f3a1b0b342$var$switchMonitor(advice, app).then((changed)=>{
                                if (changed) setRevision((value)=>value + 1);
                            }).finally(()=>{
                                setPending((value)=>{
                                    const next = new Set(value);
                                    next.delete(advice.id);
                                    return next;
                                });
                            });
                        },
                        children: (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "button-style",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                    icon: active ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).On1 : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Off1,
                                    className: "toggle-button-left"
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                    icon: active ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).On2 : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Off2,
                                    className: "toggle-button-right"
                                })
                            ]
                        })
                    })
            });
        });
        return result;
    }, [
        advices,
        app,
        pending,
        revision,
        state
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "UserAdviceMonitorMenu",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), {
            button: (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Alert
                    }),
                    " ",
                    t("title")
                ]
            }),
            buttonClass: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                "UserAdviceMonitorMenu-button",
                "button",
                watchActive && "active",
                watchProblem && "error"
            ]),
            global: true,
            initOpen: initOpen,
            items: items
        })
    });
}


















var $acw62 = parcelRequire("acw62");







const $5719eae83a80f578$export$e7c98d7be8824bd2 = {
    canCreate (api, confirmationType) {
        if (confirmationType === (0, $dc5f476a6a7173a6$export$44cc6d18b276943).cruise) return new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(api).cruises.canCreate({
            params: {}
        }).call();
        return new (0, $84aa1a3b4df5a78b$export$5e13e029a186945f)(api).trips.canCreate({
            params: {}
        }).call();
    },
    create (api, confirmationType) {
        if (confirmationType === (0, $dc5f476a6a7173a6$export$44cc6d18b276943).cruise) return new (0, $2dcee90bb6b8bb26$export$91670ad32f536684)(api).cruises.create({
            params: {}
        }).call();
        return new (0, $84aa1a3b4df5a78b$export$5e13e029a186945f)(api).trips.create({
            params: {}
        }).call();
    }
};
function $5719eae83a80f578$export$b86d933ad3d6b17f({ complete: complete, confirmationType: confirmationType }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("FocusView");
    const { writers: writers } = (0, $9f0c6a660fcd92b1$export$e9b6e9aba65becb0)();
    const [status, setStatus] = (0, $acw62.useState)(undefined);
    (0, $acw62.useEffect)(()=>{
        const load = async ()=>{
            const result = await $5719eae83a80f578$export$e7c98d7be8824bd2.canCreate(app.apiClient, confirmationType);
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("start confirmation for", confirmationType, result === null || result === void 0 ? void 0 : result.status);
            if (result) setStatus(result.status);
        };
        load().catch(console.error);
    }, []);
    const action = (0, $acw62.useCallback)(async ()=>{
        var _a, _b;
        if (status != (0, $fdf69f1b178295ac$export$a06f4ac7b989b94c).allowed) return;
        const result = await (confirmationType === (0, $dc5f476a6a7173a6$export$44cc6d18b276943).cruise ? writers.createCruise() : writers.createTrip());
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("create", confirmationType, (_a = result === null || result === void 0 ? void 0 : result.cruise) === null || _a === void 0 ? void 0 : _a.id, (_b = result === null || result === void 0 ? void 0 : result.trip) === null || _b === void 0 ? void 0 : _b.id);
        if (result && (result.cruise || result.trip)) complete(undefined);
    }, [
        status,
        confirmationType,
        writers
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $e7bc01546cf183b2$export$2cc85109a937009e), {
        title: t(`confirm_${confirmationType}_title`),
        style: status == (0, $fdf69f1b178295ac$export$a06f4ac7b989b94c).allowed ? "default" : "warning",
        loading: !status,
        confirmDisabled: status != (0, $fdf69f1b178295ac$export$a06f4ac7b989b94c).allowed,
        message: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
            message: (m)=>m.currentView.confirmationDialog[confirmationType][status]
        }),
        cancelLabel: t("close"),
        confirmLabel: t("confirm"),
        onCancel: ()=>complete(undefined),
        onConfirm: action
    });
}




var $acw62 = parcelRequire("acw62");






function $06a8925f6cab21b2$export$a6b801c9758e6926({ currentState: currentState }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("FocusView");
    const { subscriptionExpired: subscriptionExpired, navigateApp: navigateApp } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const [warningDismissedDay, setWarningDismissedDay] = (0, $acw62.useState)(undefined);
    if (!app.account || !currentState) return null;
    const accountStatus = currentState.subscriptionStatus;
    const accountSubscriptionExpired = (0, $dc5f476a6a7173a6$export$abafb95c9400b65d).accountSubscriptionExpired(accountStatus, subscriptionExpired);
    // Check if warning was already dismissed today
    const currentDay = currentState.day;
    if (warningDismissedDay === currentDay) return null;
    const warningKey = (0, $dc5f476a6a7173a6$export$abafb95c9400b65d).subscriptionWarningKey(accountStatus, app.account.nextBillingAt, new Date(), accountSubscriptionExpired);
    if (!warningKey) return null;
    const messageKey = warningKey === "sevenDays" ? (m)=>m.subscription["7Days"] : (m)=>m.subscription[warningKey];
    const dismissWarning = ()=>{
        setWarningDismissedDay(currentDay);
    };
    // The subscription/plan view renders in-app for cloud and native iOS (so the
    // StoreKit purchase can run); only a non-iOS native app opens it on the server.
    const viewPlans = ()=>{
        dismissWarning();
        if ((0, $541a350025917a42$export$750abdcba4148280)(app)) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSubscription);
        else app.openServer("account/subscription");
    };
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: "subscription-warning",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-followed-by-block-row",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                        message: messageKey
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                actions: true,
                className: "block-row-last",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button",
                            onClick: dismissWarning,
                            children: t("close")
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button default",
                            onClick: viewPlans,
                            children: t("view_plans")
                        })
                    })
                ]
            })
        ]
    });
}


function $85e283d657b38559$export$e2ead07a5c949cb1({ confirmationType: confirmationType, completeConfirmation: completeConfirmation, shipOverlayActive: shipOverlayActive, currentState: currentState, currentCruise: currentCruise, currentLog: currentLog, currentLogView: currentLogView, dayUserAdvices: dayUserAdvices, navigationStarted: navigationStarted, dayYesterday: dayYesterday, dayToday: dayToday, dayTodayActive: dayTodayActive, dayTomorrow: dayTomorrow, previousDay: previousDay, initCruise: initCruise, initTrip: initTrip, initDay: initDay, initDayTab: initDayTab, initDayTomorrow: initDayTomorrow, initDayTomorrowDetails: initDayTomorrowDetails, initLogHighlight: initLogHighlight, initLogTabs: initLogTabs, initLogs: initLogs, initStatuses: initStatuses }) {
    if (shipOverlayActive) return null;
    if (confirmationType && initTrip && initCruise) {
        // Show TripEditView immediately with init data when starting a trip
        const days = [
            initDay,
            initDayTomorrow
        ].filter(Boolean);
        return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: (0, $7b02d682eb115277$exports.jsxs)((0, $561bc7c82d705725$export$18ac525d13abc8df), {
                cruiseId: initCruise.id,
                initialCruise: initCruise,
                focus: true,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $51141e37452020dd$export$66a0ba5751a02e9e), {
                        before: true,
                        count: 8,
                        width: 18
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $8b93cdbcae4a2de3$export$62031b35b640577c), {
                        trip: initTrip,
                        currentDays: days,
                        focus: true,
                        overrideDays: days,
                        children: [
                            initDay && (()=>{
                                return (0, $7b02d682eb115277$exports.jsx)((0, $d2dee9b5e2805e91$export$c1379d67dc104c23), {
                                    day: initDay,
                                    currentLog: currentLog,
                                    currentLogView: currentLogView,
                                    focus: true,
                                    hideTimeline: !navigationStarted,
                                    isCurrentDay: true,
                                    isFirstTripDay: true,
                                    initDetails: true,
                                    initHighlight: initLogHighlight,
                                    initLogTabs: initLogTabs,
                                    initLogs: initLogs !== undefined ? initLogs : [],
                                    initStatuses: initStatuses || [],
                                    initTab: initDayTab !== null && initDayTab !== void 0 ? initDayTab : "day"
                                });
                            })(),
                            initDayTomorrow && (0, $7b02d682eb115277$exports.jsx)((0, $d2dee9b5e2805e91$export$c1379d67dc104c23), {
                                day: initDayTomorrow,
                                focus: true,
                                isTomorrow: true,
                                initDetails: initDayTomorrowDetails || false,
                                initSelected: initDayTomorrowDetails || false
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $51141e37452020dd$export$66a0ba5751a02e9e), {
                        before: false,
                        width: 18
                    })
                ]
            })
        });
    }
    if (!currentState || !currentCruise || !(currentState === null || currentState === void 0 ? void 0 : currentState.trip)) return (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {});
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            confirmationType && (0, $7b02d682eb115277$exports.jsx)((0, $5719eae83a80f578$export$b86d933ad3d6b17f), {
                complete: completeConfirmation,
                confirmationType: confirmationType
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $561bc7c82d705725$export$18ac525d13abc8df), {
                cruiseId: currentCruise.id,
                initialCruise: currentCruise,
                focus: true,
                storeBacked: true,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $51141e37452020dd$export$66a0ba5751a02e9e), {
                        before: true,
                        count: 8,
                        width: 18
                    }),
                    currentState.trip ? (0, $7b02d682eb115277$exports.jsxs)((0, $8b93cdbcae4a2de3$export$62031b35b640577c), {
                        trip: currentState.trip,
                        currentDays: currentState.days,
                        focus: true,
                        overrideDays: currentState.days,
                        storeBacked: true,
                        children: [
                            dayYesterday && (0, $7b02d682eb115277$exports.jsx)((0, $d2dee9b5e2805e91$export$c1379d67dc104c23), {
                                day: dayYesterday,
                                focus: true,
                                isYesterday: true
                            }),
                            dayToday && (0, $7b02d682eb115277$exports.jsx)((0, $d2dee9b5e2805e91$export$c1379d67dc104c23), {
                                advices: dayUserAdvices,
                                day: dayToday,
                                currentLog: currentLog,
                                currentLogView: currentLogView,
                                focus: true,
                                hideTimeline: !navigationStarted && !dayTodayActive,
                                initLogs: currentState.logs,
                                initStatuses: currentState.statuses,
                                isCurrentDay: true,
                                isFirstTripDay: currentState.firstDay,
                                provisionalLogs: currentState.provisionalLogs,
                                initDetails: initDayTab !== undefined ? true : undefined,
                                initTab: initDayTab
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $06a8925f6cab21b2$export$a6b801c9758e6926), {
                                currentState: currentState
                            }),
                            dayTomorrow && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $d2dee9b5e2805e91$export$c1379d67dc104c23), {
                                    day: dayTomorrow,
                                    focus: true,
                                    isTomorrow: true,
                                    initDetails: initDayTomorrowDetails || false,
                                    initSelected: initDayTomorrowDetails || false,
                                    previousDay: previousDay
                                })
                            })
                        ]
                    }) : (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {}),
                    (0, $7b02d682eb115277$exports.jsx)((0, $51141e37452020dd$export$66a0ba5751a02e9e), {
                        before: false,
                        width: 18
                    })
                ]
            })
        ]
    });
}





function $fab0386bb5d6352e$export$a7b3996133958c6e({ show: show, initConfirmationType: initConfirmationType, initCruise: initCruise, initTrip: initTrip, initDay: initDay, initDayTab: initDayTab, initDayTomorrow: initDayTomorrow, initDayTomorrowDetails: initDayTomorrowDetails, initLogs: initLogs, initLogHighlight: initLogHighlight, initLogTabs: initLogTabs, initLogButtonMenuOpen: initLogButtonMenuOpen, initLogButtonSubmenu: initLogButtonSubmenu, initStatuses: initStatuses, initUserAdvice: initUserAdvice, initUserAdviceData: initUserAdviceData }) {
    var _a, _b;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const settingsWriters = (0, $bf76a3a7a0d207c0$export$4bb86e129f694bc0)(ship.id);
    const t = app.getT("FocusView");
    const { shipOverlay: shipOverlay } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const { currentState: currentState, currentLog: currentLog, editable: editable, writers: writers } = (0, $9f0c6a660fcd92b1$export$e9b6e9aba65becb0)();
    const [confirmationType, setConfirmationType] = (0, $acw62.useState)(initConfirmationType);
    const [focusViewScrolled, setFocusViewScrolled] = (0, $acw62.useState)(false);
    // `none` is the CLOSED state and so the reset target; `initUserAdvice` only seeds
    // which dialog starts open. Passing the seed as the default (as this did) made
    // closing restore it, so a dialog opened by a demo scene or a catalog fixture
    // could not be dismissed -- see `useOverlay`.
    const [userAdvice, _userAdviceOptions, setUserAdvice, resetUserAdvice] = (0, $5788501efbf36a87$export$ea8f71083e90600f)((0, $d1f80c8455d1c371$export$cc9d73738f4bc1e2).none, initUserAdvice);
    const [userAdvices] = (0, $acw62.useState)(()=>(0, $d3468a341ccd86ee$export$89f5bb725713fc32)(app, settingsWriters));
    const currentLogViewRef = (0, $acw62.useRef)(null);
    const navigationStarted = (0, $acw62.useMemo)(()=>{
        var _a;
        return ((_a = app.status) === null || _a === void 0 ? void 0 : _a.navigation) == true;
    }, [
        app.status
    ]);
    const currentCruise = (0, $acw62.useMemo)(()=>currentState === null || currentState === void 0 ? void 0 : currentState.cruise, [
        currentState
    ]);
    const dayToday = (0, $acw62.useMemo)(()=>{
        var _a, _b;
        return (0, $dc5f476a6a7173a6$export$abafb95c9400b65d).dayToday(currentState, (_b = (_a = app.current) === null || _a === void 0 ? void 0 : _a.log) === null || _b === void 0 ? void 0 : _b.timezone);
    }, [
        currentState,
        app.current
    ]);
    const dayTodayActive = (0, $acw62.useMemo)(()=>(0, $dc5f476a6a7173a6$export$abafb95c9400b65d).dayTodayActive(dayToday, (currentState === null || currentState === void 0 ? void 0 : currentState.logs) || []), [
        dayToday,
        currentState === null || currentState === void 0 ? void 0 : currentState.logs
    ]);
    const dayYesterday = (0, $acw62.useMemo)(()=>(0, $dc5f476a6a7173a6$export$abafb95c9400b65d).dayYesterday(currentState), [
        currentState
    ]);
    const dayTomorrow = (0, $acw62.useMemo)(()=>(0, $dc5f476a6a7173a6$export$abafb95c9400b65d).dayTomorrow(currentState, dayTodayActive), [
        currentState,
        dayTodayActive
    ]);
    // The user advices are imperative + carry native side effects (audible alarm, OS
    // notification, keep-alive) inside `update()`, so they cannot run in render. Update them
    // post-commit whenever the current-day state or the live current log changes -- the
    // same three moments the monolith drove `advice.update` (init, load, currentLog
    // broadcast), now unified since both inputs are React state/store-backed. The tick then
    // forces `getInstances` to re-read the freshly-updated advice state (replacing the old
    // `setN` that used to do this alongside the data merge).
    const [adviceTick, setAdviceTick] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (!currentState) return;
        for (const advice of userAdvices)advice.update(app, currentState, currentLog, ship);
        setAdviceTick((tick)=>tick + 1);
    }, [
        app,
        (_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.nmea) === null || _b === void 0 ? void 0 : _b.liveAlerts,
        userAdvices,
        currentState,
        currentLog,
        ship
    ]);
    // Gate each write on `editable` (and a present current state) exactly as the monolith's
    // record callbacks did, then delegate the concrete data update to the writer boundary
    // (the New variant's optimistic store `mutate`, or the Legacy variant's `updateData`
    // merge). The writers themselves stay ungated so a current/provisional log can never be
    // committed by a non-editor.
    const recordLog = (0, $acw62.useCallback)(async (status)=>{
        if (!currentState || !editable) return;
        await writers.recordLog(status);
    }, [
        currentState,
        editable,
        writers
    ]);
    const recordEngine = (0, $acw62.useCallback)(async (engineId, on)=>{
        if (!currentState || !editable) return;
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("engine", engineId, on);
        await writers.recordEngine(engineId, on);
    }, [
        currentState,
        editable,
        writers
    ]);
    const recordLighting = (0, $acw62.useCallback)(async (lighting)=>{
        if (!currentState || !editable) return;
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("lighting", lighting);
        await writers.recordLighting(lighting);
    }, [
        currentState,
        editable,
        writers
    ]);
    const recordSails = (0, $acw62.useCallback)(async (changes)=>{
        if (!currentState || !editable || changes.length == 0) return;
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("sails", changes);
        await writers.recordSails(changes);
    }, [
        currentState,
        editable,
        writers
    ]);
    // The advice buttons still speak in terms of a selected id; `setSelected(undefined)`
    // is the same "close me" the other hubs spell `resetOverlay()`.
    const userAdviceState = (0, $acw62.useMemo)(()=>{
        return {
            selected: userAdvice == (0, $d1f80c8455d1c371$export$cc9d73738f4bc1e2).none ? undefined : userAdvice,
            setSelected: (selected)=>selected == undefined ? resetUserAdvice() : setUserAdvice(selected),
            data: initUserAdviceData,
            recordStop: writers.recordStop
        };
    }, [
        userAdvice,
        setUserAdvice,
        resetUserAdvice,
        initUserAdviceData,
        writers.recordStop
    ]);
    // Handed to LogView as instances rather than rendered nodes (#1171): the row picks a
    // display format per button from their severity, which it can only do knowing what
    // they are. Kept out of `currentLogView` so the overlay host can see them too.
    const logAdvices = (0, $acw62.useMemo)(()=>{
        if (!currentLog) return [];
        return userAdvices.flatMap((a)=>a.getInstances(app, (0, $94dd0a1374840a0e$export$b067a529c9eafd88).log, currentLog)).toSorted((a, b)=>b.level - a.level);
    }, [
        currentLog,
        userAdvices,
        adviceTick
    ]);
    const currentLogView = (0, $acw62.useMemo)(()=>{
        if (!currentLog || !currentState) return undefined;
        const statuses = currentState.statuses.filter((s)=>dayToday && s.dayId == dayToday.id && s.endLogId == undefined);
        return (0, $7b02d682eb115277$exports.jsx)((0, $ef5054b4bf6e9c66$export$812dc811f41b1756), {
            advices: logAdvices,
            adviceState: userAdviceState,
            clearHighlight: ()=>{},
            createCallback: recordLog,
            engineStatusCallback: recordEngine,
            initLogButtonMenuOpen: initLogButtonMenuOpen,
            initLogButtonSubmenu: initLogButtonSubmenu,
            lightingCallback: recordLighting,
            sailChangesCallback: recordSails,
            log: currentLog,
            statuses: statuses,
            ref: currentLogViewRef
        });
    }, [
        currentLog,
        currentState,
        dayToday,
        initLogButtonMenuOpen,
        initLogButtonSubmenu,
        userAdviceState,
        logAdvices,
        recordLog,
        recordEngine,
        recordLighting,
        recordSails
    ]);
    const dayAdvices = (0, $acw62.useMemo)(()=>{
        return userAdvices.flatMap((a)=>a.getInstances(app, (0, $94dd0a1374840a0e$export$b067a529c9eafd88).day, currentLog)).toSorted((a, b)=>a.level - b.level);
    }, [
        currentLog,
        userAdvices,
        adviceTick
    ]);
    // The ship toolbar's monitors (#916). Filtered from the SAME advice objects the
    // effect above keeps updated -- `userAdvicesByRole()` would construct fresh ones
    // that `update()` never runs on, so every toggle would read as inactive forever.
    //
    // The log row and day summary above keep asking every advice, because each one
    // decides for itself where it appears; the monitors answer `toolbar` and nothing
    // else, so they have already left those two.
    const toolbarAdvices = (0, $acw62.useMemo)(()=>{
        return userAdvices.filter((a)=>a.role == (0, $9b0ea27c41d2c665$export$12d2560880666b0e).monitor).flatMap((a)=>a.getInstances(app, (0, $94dd0a1374840a0e$export$b067a529c9eafd88).toolbar, currentLog));
    }, [
        app,
        currentLog,
        userAdvices,
        adviceTick
    ]);
    const monitorToggles = (0, $acw62.useCallback)((collapsed)=>{
        return (0, $7b02d682eb115277$exports.jsx)((0, $eeddd8f3a1b0b342$export$45281bb990d7842a), {
            advices: toolbarAdvices,
            app: app,
            collapsed: collapsed,
            state: userAdviceState
        });
    }, [
        app,
        toolbarAdvices,
        userAdviceState
    ]);
    const dayUserAdvices = (0, $acw62.useMemo)(()=>{
        return dayAdvices.map((advice)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: advice.renderButton(userAdviceState)
            }, advice.id);
        });
    }, [
        dayAdvices,
        userAdviceState
    ]);
    const actions = (0, $acw62.useMemo)(()=>{
        if (!currentState) return [];
        return [
            ...app.editable ? [
                {
                    disabled: false,
                    id: "add-cruise",
                    onClick: async ()=>{
                        setConfirmationType((0, $dc5f476a6a7173a6$export$44cc6d18b276943).cruise);
                        return true;
                    },
                    title: (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                            }),
                            " ",
                            t("actions_add_cruise")
                        ]
                    })
                },
                {
                    disabled: false,
                    id: "add-trip",
                    onClick: async ()=>{
                        setConfirmationType((0, $dc5f476a6a7173a6$export$44cc6d18b276943).trip);
                        return true;
                    },
                    title: (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                            }),
                            " ",
                            t("actions_add_trip")
                        ]
                    })
                }
            ] : []
        ];
    }, [
        currentState,
        app.language
    ]);
    const completeConfirmation = (0, $acw62.useCallback)((type)=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("completeConfirmation", type ? (0, $dc5f476a6a7173a6$export$44cc6d18b276943)[type] : "null");
        setConfirmationType(type);
    }, []);
    const previousDay = (0, $acw62.useMemo)(()=>{
        return (0, $dc5f476a6a7173a6$export$abafb95c9400b65d).previousDayDefaults(dayToday);
    }, [
        dayToday === null || dayToday === void 0 ? void 0 : dayToday.endLocation,
        dayToday === null || dayToday === void 0 ? void 0 : dayToday.crew,
        dayToday === null || dayToday === void 0 ? void 0 : dayToday.passengers,
        dayToday === null || dayToday === void 0 ? void 0 : dayToday.skipper
    ]);
    (0, $acw62.useEffect)(()=>{
        // `app.staticLayout` skips this real-browser scroll-into-view in the catalog +
        // unit-test (happy-dom) mock app so the golden snapshots stay deterministic
        // (see `IAppState.staticLayout`). Real users + E2E run it.
        if (app.staticLayout) return;
        if (currentLogViewRef.current && shipOverlay == (0, $a5124d8cc1d8d792$export$8db9b17208125660).none && show && !focusViewScrolled) {
            currentLogViewRef.current.style.top = "200px";
            setTimeout(()=>{
                if (currentLogViewRef.current) currentLogViewRef.current.scrollIntoView({
                    behavior: "instant",
                    block: "end"
                });
            }, 100);
            setFocusViewScrolled(true);
        } else if (!show) setFocusViewScrolled(false);
    }, [
        currentLogViewRef.current,
        currentLog,
        shipOverlay,
        show,
        focusViewScrolled
    ]);
    if (!show) return null;
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "FocusView",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $d1f80c8455d1c371$export$41ae3f4ddc0f7e7c), {
                advices: [
                    ...logAdvices,
                    ...dayAdvices,
                    ...toolbarAdvices
                ],
                state: userAdviceState
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $5878af5c58bfa741$export$e6ea0c07cce3c59c), {
                actions: actions,
                monitors: monitorToggles
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $85e283d657b38559$export$e2ead07a5c949cb1), {
                confirmationType: confirmationType,
                completeConfirmation: completeConfirmation,
                shipOverlayActive: shipOverlay != (0, $a5124d8cc1d8d792$export$8db9b17208125660).none,
                currentState: currentState,
                currentCruise: currentCruise,
                currentLog: currentLog,
                currentLogView: currentLogView,
                dayUserAdvices: dayUserAdvices,
                navigationStarted: navigationStarted,
                dayYesterday: dayYesterday,
                dayToday: dayToday,
                dayTodayActive: dayTodayActive,
                dayTomorrow: dayTomorrow,
                previousDay: previousDay,
                initCruise: initCruise,
                initTrip: initTrip,
                initDay: initDay,
                initDayTab: initDayTab,
                initDayTomorrow: initDayTomorrow,
                initDayTomorrowDetails: initDayTomorrowDetails,
                initLogHighlight: initLogHighlight,
                initLogTabs: initLogTabs,
                initLogs: initLogs,
                initStatuses: initStatuses
            })
        ]
    });
}




const $f3fe348df41571fb$export$5aeb7b50bb8b32bf = (0, $480db5fef2358c2d$export$ae24a3dd6105e285)({
    acquire: (0, $e5c8807c8a6a19ae$export$a665a75f6745b83d),
    ui: (0, $fab0386bb5d6352e$export$a7b3996133958c6e)
});




var $acw62 = parcelRequire("acw62");










// #1217: matches the `logbook-language` / `logbook-theme` storage-key convention.
const $d8ded05fe18c7937$var$instrumentModesStorageKey = "logbook-instrument-modes";
const $d8ded05fe18c7937$export$99c39583ba3e5ce6 = {
    defaultFieldCallback (e) {
        return e.nmeaType;
    },
    // The entry matching the instrument's current mode, or the instrument's fallback
    // when no mode is set. `field` maps an entry to the value compared against the
    // stored mode; `fallback` picks the default reading (#1217: the wind instrument
    // needs a meaningful default, since the entry order is not significant).
    findMode (modes, instrument, data, field, fallback) {
        if (!data || data.length < 1) return undefined;
        const fieldCallback = field || $d8ded05fe18c7937$export$99c39583ba3e5ce6.defaultFieldCallback;
        const mode = modes[instrument];
        return mode ? data.find((d)=>fieldCallback(d) == mode) : fallback ? fallback(data) : data[0];
    },
    // The nmeaType of the next entry after the current mode, wrapping around the list.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    nextMode (modes, data, instrument, field = "nmeaType") {
        const mode = modes[instrument];
        let i = (mode ? data.findIndex((d)=>d[field] == mode) : 0) + 1;
        if (i >= data.length) i = 0;
        return data[i].nmeaType;
    },
    // Prefer the VTG (course-over-ground) heading, else the first available heading.
    selectHeading (headings) {
        return headings ? headings.find((h)=>h.nmeaType == "VTG") || headings[0] : undefined;
    },
    // #1217: prefer the apparent reading, else the first available one. The wind array
    // comes from a Swift dictionary, so its order carries no meaning -- without this the
    // panel showed an arbitrary reading, routinely labelling apparent wind "True".
    selectWind (winds) {
        if (!winds || winds.length < 1) return undefined;
        return winds.find((w)=>w.reference === (0, $b75415c6faae2236$export$f9ee2074361b96f5).apparent) || winds[0];
    },
    // #1217: the title key for a reading -- apparent wind, true wind as a compass
    // direction, or true wind still measured from the bow.
    windKind (wind) {
        switch(wind.reference){
            case (0, $b75415c6faae2236$export$f9ee2074361b96f5).apparent:
                return "apparent";
            case (0, $b75415c6faae2236$export$f9ee2074361b96f5).trueBoat:
                return "trueRelative";
            case (0, $b75415c6faae2236$export$f9ee2074361b96f5).trueDirection:
                return "true";
        }
    },
    // #1217: a compass direction stays as-is; a bow-relative angle folds to 0-180 with a
    // port/starboard sense, using the same convention as `LogNavigationViewData.courseToWind`.
    // Pure -- the caller localizes the side.
    windAngle (wind) {
        if (wind.reference === (0, $b75415c6faae2236$export$f9ee2074361b96f5).trueDirection) return {
            angle: wind.angle,
            side: undefined,
            compass: true
        };
        const relative = (wind.angle % 360 + 360) % 360;
        const angle = relative > 180 ? 360 - relative : relative;
        const side = angle === 0 || angle === 180 ? undefined : relative > 180 ? "port" : "starboard";
        return {
            angle: angle,
            side: side,
            compass: false
        };
    },
    // #1217: the cycled instrument modes are persisted, so a selected reading survives a
    // reload. Storage is user-editable, so anything unexpected degrades to "no modes".
    parseInstrumentModes (raw) {
        if (!raw) return {};
        try {
            const parsed = JSON.parse(raw);
            if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) return {};
            const modes = {};
            for (const [instrument, mode] of Object.entries(parsed))if (typeof mode === "string") modes[instrument] = mode;
            return modes;
        } catch (_a) {
            return {};
        }
    },
    serializeInstrumentModes (modes) {
        return JSON.stringify(modes);
    },
    // The displayed course of a heading: magnetic when present, else true.
    headingCourse (heading) {
        return heading ? heading.courseMagnetic || heading.courseTrue : undefined;
    },
    // Restrict the engine readouts to the ship's configured engine numbers when known.
    filterEngines (engines, configured) {
        return engines && configured ? engines.filter((e)=>configured.has(e.number)) : engines;
    },
    // The `rpm | rpm` readout, engines sorted by number.
    engineRpmText (engines) {
        return engines.toSorted((a, b)=>a.number - b.number).map((engine)=>`${engine.rpm.toFixed(0)}`).join(" | ");
    },
    // #1027 (tracker #976): N2K fallbacks, used by the render callbacks only when no 0183 reading
    // exists for the instrument. N2K has no VTG/type concept, so these just take the
    // first entry rather than mode-select or sub-type filter.
    n2kHeadingCourse (headings) {
        const h = headings === null || headings === void 0 ? void 0 : headings[0];
        return h ? {
            course: h.heading,
            magnetic: h.headingReference === (0, $c65f9b00cea21320$export$8c43bf3ee56a4ccb).magnetic
        } : undefined;
    },
    // Remap N2K's `instance`/`speed` fields to the 0183 `number`/`rpm` shape so
    // filterEngines/engineRpmText can be reused unchanged.
    n2kEngines (engines) {
        return engines === null || engines === void 0 ? void 0 : engines.map((e)=>{
            var _a;
            return {
                receivedAt: e.receivedAt,
                source: e.source,
                nmeaType: e.nmeaType,
                number: (_a = e.instance) !== null && _a !== void 0 ? _a : 0,
                rpm: e.speed
            };
        });
    },
    // Remap N2K wind entries to the 0183 shape. The N2K reference maps onto the same
    // three-way `INMEAWindReference` the 0183 parser produces (#1217), so both protocols
    // feed identical selection, cycling and formatting.
    n2kWinds (winds) {
        return winds === null || winds === void 0 ? void 0 : winds.map((w)=>{
            const reference = w.reference === (0, $c65f9b00cea21320$export$449e1375fc239f79).trueNorth || w.reference === (0, $c65f9b00cea21320$export$449e1375fc239f79).magneticNorth ? (0, $b75415c6faae2236$export$f9ee2074361b96f5).trueDirection : w.reference === (0, $c65f9b00cea21320$export$449e1375fc239f79).trueBoat || w.reference === (0, $c65f9b00cea21320$export$449e1375fc239f79).trueWater ? (0, $b75415c6faae2236$export$f9ee2074361b96f5).trueBoat : (0, $b75415c6faae2236$export$f9ee2074361b96f5).apparent;
            return {
                receivedAt: w.receivedAt,
                source: w.source,
                nmeaType: w.nmeaType,
                reference: reference,
                priority: reference === (0, $b75415c6faae2236$export$f9ee2074361b96f5).trueDirection,
                relative: reference === (0, $b75415c6faae2236$export$f9ee2074361b96f5).apparent,
                angle: w.angle,
                speed: w.speed
            };
        });
    },
    // #53: general-purpose warning/alarm severity for an instrument reading against a
    // ship-configured threshold. "Lower is worse", mirroring DepthConsumer.swift's
    // comparison direction: at/below `alarm` -> alarm, at/below `warning` -> warning,
    // else no severity.
    severity (value, threshold) {
        if (value === undefined || threshold === undefined) return undefined;
        if (value <= threshold.alarm) return "alarm";
        if (value <= threshold.warning) return "warning";
        return undefined;
    }
};
function $d8ded05fe18c7937$export$16c526368e1f696({ minimized: minimized, setMinimized: setMinimized, connected: connected = true }) {
    var _a, _b;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("InstrumentsView");
    const { ship: ship } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const configuredEngineNumbers = (0, $acw62.useMemo)(()=>{
        if (!ship) return undefined;
        const engines = (0, $22871482fce5b7e5$export$7930c61d9b464618).engines(ship);
        if (!engines || engines.length === 0) return undefined;
        return new Set(engines.map((e, i)=>{
            var _a;
            return (_a = e.number) !== null && _a !== void 0 ? _a : i;
        }));
    }, [
        ship
    ]);
    // #53: depth thresholds only matter (and are only ever read) when the coloring
    // feature is on, mirroring the DepthWatchView precedent for reading ship settings.
    const depthThreshold = (0, $acw62.useMemo)(()=>{
        var _a;
        return ship ? (_a = (0, $22871482fce5b7e5$export$7930c61d9b464618).shipSettings(ship).thresholds) === null || _a === void 0 ? void 0 : _a.depth : undefined;
    }, [
        ship
    ]);
    const [nmeaData, setNmeaData] = (0, $acw62.useState)((_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.nmea) === null || _b === void 0 ? void 0 : _b.data);
    // #1217: the cycled reading per instrument, restored from and written back to local
    // storage so a user's choice survives a reload.
    const [instrumentModes, setInstrumentModes] = (0, $acw62.useState)(()=>$d8ded05fe18c7937$export$99c39583ba3e5ce6.parseInstrumentModes((0, $2b75519151ca9024$export$3f685a6e8b195eac)($d8ded05fe18c7937$var$instrumentModesStorageKey)));
    function cycleInstrument(instrument, entries, field) {
        setInstrumentModes((modes)=>{
            const updated = Object.assign(Object.assign({}, modes), {
                [instrument]: $d8ded05fe18c7937$export$99c39583ba3e5ce6.nextMode(modes, entries, instrument, field)
            });
            localStorage.setItem($d8ded05fe18c7937$var$instrumentModesStorageKey, $d8ded05fe18c7937$export$99c39583ba3e5ce6.serializeInstrumentModes(updated));
            return updated;
        });
    }
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((status, _type)=>{
        var _a;
        if ((_a = status === null || status === void 0 ? void 0 : status.nmea) === null || _a === void 0 ? void 0 : _a.data) setNmeaData(status.nmea.data);
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).AppStatus);
    function toggleMinimized() {
        setMinimized(!minimized);
    }
    const renderInstrument = {
        compass: function(data) {
            var _a;
            const heading = $d8ded05fe18c7937$export$99c39583ba3e5ce6.selectHeading(data.heading);
            const course = $d8ded05fe18c7937$export$99c39583ba3e5ce6.headingCourse(heading);
            const n2kHeading = !heading ? $d8ded05fe18c7937$export$99c39583ba3e5ce6.n2kHeadingCourse((_a = data.n2k) === null || _a === void 0 ? void 0 : _a.heading) : undefined;
            const displayCourse = course !== undefined ? course : n2kHeading === null || n2kHeading === void 0 ? void 0 : n2kHeading.course;
            return {
                content: (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "InstrumentsView-instrument-title",
                            children: heading ? t("compass_title_" + (heading.courseMagnetic ? "magnetic" : "true")) || t("compass_title") : n2kHeading ? t("compass_title_" + (n2kHeading.magnetic ? "magnetic" : "true")) || t("compass_title") : t("compass_title")
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "InstrumentsView-instrument-text",
                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "value",
                                children: displayCourse !== undefined ? (0, $14a8bda8b42de2c4$export$93514d28bd18d75a).course(displayCourse) : "\u2013"
                            })
                        })
                    ]
                })
            };
        },
        course: function(data) {
            var _a, _b;
            const navigation = data.navigation;
            const track = navigation && navigation.track ? navigation.track : (_b = (_a = data.n2k) === null || _a === void 0 ? void 0 : _a.courseSpeed) === null || _b === void 0 ? void 0 : _b.cog;
            return {
                content: (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "InstrumentsView-instrument-title",
                            children: t("course_title")
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "InstrumentsView-instrument-text",
                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "value",
                                children: track ? (0, $14a8bda8b42de2c4$export$93514d28bd18d75a).course(track) : "\u2013"
                            })
                        })
                    ]
                })
            };
        },
        depth: function(data) {
            var _a, _b;
            const depth = $d8ded05fe18c7937$export$99c39583ba3e5ce6.findMode(instrumentModes, "depth", data.depth);
            const n2kDepth = !depth ? (_b = (_a = data.n2k) === null || _a === void 0 ? void 0 : _a.depth) === null || _b === void 0 ? void 0 : _b[0] : undefined;
            const meters = depth ? depth.meters : n2kDepth === null || n2kDepth === void 0 ? void 0 : n2kDepth.depth;
            // #53: unconditional on any active anchor/depth watch — only gated behind the
            // anchor-alerts feature flag and the ship having configured depth thresholds.
            const severity = $d8ded05fe18c7937$export$99c39583ba3e5ce6.severity(meters, depthThreshold);
            return {
                content: (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "InstrumentsView-instrument-title",
                            children: depth ? `${t("depth_title")} - ${t("depth_title_" + depth.type)}` : t("depth_title")
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "InstrumentsView-instrument-text",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "value",
                                    children: meters !== undefined ? meters.toFixed(1) : "\u2013"
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "unit",
                                    children: "m"
                                })
                            ]
                        })
                    ]
                }),
                severity: severity,
                cycle: data.depth ? {
                    entries: data.depth
                } : undefined
            };
        },
        engines: function(data) {
            var _a, _b;
            const engine = (_a = $d8ded05fe18c7937$export$99c39583ba3e5ce6.filterEngines(data.engine, configuredEngineNumbers)) !== null && _a !== void 0 ? _a : $d8ded05fe18c7937$export$99c39583ba3e5ce6.filterEngines($d8ded05fe18c7937$export$99c39583ba3e5ce6.n2kEngines((_b = data.n2k) === null || _b === void 0 ? void 0 : _b.engine), configuredEngineNumbers);
            return {
                content: (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "InstrumentsView-instrument-title",
                            children: engine ? t(engine.length < 2 ? "engine_title_single" : "engine_title_multiple") : t("engine_title_single")
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "InstrumentsView-instrument-text",
                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "value",
                                children: engine ? $d8ded05fe18c7937$export$99c39583ba3e5ce6.engineRpmText(engine) : "\u2013"
                            })
                        })
                    ]
                })
            };
        },
        speed: function(data) {
            var _a, _b;
            const navigation = data.navigation;
            const sog = navigation && navigation.sog !== undefined ? navigation.sog : (_b = (_a = data.n2k) === null || _a === void 0 ? void 0 : _a.courseSpeed) === null || _b === void 0 ? void 0 : _b.sog;
            return {
                content: (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "InstrumentsView-instrument-title",
                            children: t("speed_title")
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "InstrumentsView-instrument-text",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "value",
                                    children: sog !== undefined ? sog.toFixed(1) : "\u2013"
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "unit",
                                    children: "kn"
                                })
                            ]
                        })
                    ]
                })
            };
        },
        wind: function(data) {
            var _a, _b;
            // #1217: cycling keys on `nmeaType`, which now distinguishes all three readings,
            // and the default is the apparent one rather than an arbitrary array position.
            const winds = ((_a = data.wind) === null || _a === void 0 ? void 0 : _a.length) ? data.wind : $d8ded05fe18c7937$export$99c39583ba3e5ce6.n2kWinds((_b = data.n2k) === null || _b === void 0 ? void 0 : _b.wind);
            const wind = $d8ded05fe18c7937$export$99c39583ba3e5ce6.findMode(instrumentModes, "wind", winds, undefined, $d8ded05fe18c7937$export$99c39583ba3e5ce6.selectWind);
            const angle = wind ? $d8ded05fe18c7937$export$99c39583ba3e5ce6.windAngle(wind) : undefined;
            const side = (angle === null || angle === void 0 ? void 0 : angle.side) ? ` ${t("wind_side_" + angle.side)}` : "";
            const bearing = angle ? angle.compass ? (0, $14a8bda8b42de2c4$export$93514d28bd18d75a).course(angle.angle) : `${(0, $14a8bda8b42de2c4$export$93514d28bd18d75a).angle(angle.angle)}${side}` : undefined;
            return {
                content: (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "InstrumentsView-instrument-title",
                            children: wind ? `${t("wind_title")} - ${t("wind_title_" + $d8ded05fe18c7937$export$99c39583ba3e5ce6.windKind(wind))}` : t("wind_title")
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "InstrumentsView-instrument-text",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "value",
                                    children: wind && bearing ? `${bearing} | ${wind.speed.toFixed(1)}` : "\u2013"
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "unit",
                                    children: "kn"
                                })
                            ]
                        })
                    ]
                }),
                cycle: winds ? {
                    entries: winds
                } : undefined
            };
        }
    };
    const instrumentOrder = [
        "compass",
        "depth",
        "course",
        "speed",
        "engines",
        "wind"
    ];
    const _instrumentData = {
        "course": "heading",
        "depth": "depth"
    };
    const instruments = [];
    for (const instrument of instrumentOrder){
        const result = nmeaData && renderInstrument[instrument] && renderInstrument[instrument](nmeaData);
        // #1217: only offer cycling when there is genuinely more than one reading to reach.
        const cycle = (result === null || result === void 0 ? void 0 : result.cycle) && result.cycle.entries.length > 1 ? result.cycle : undefined;
        instruments.push((0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                "InstrumentsView-instrument",
                "instrument-" + instrument,
                cycle && "InstrumentsView-instrument-cycle",
                (result === null || result === void 0 ? void 0 : result.severity) && `InstrumentsView-instrument-${result.severity}`
            ]),
            role: cycle ? "button" : undefined,
            tabIndex: cycle ? 0 : undefined,
            onClick: cycle ? ()=>cycleInstrument(instrument, cycle.entries, cycle.field) : undefined,
            children: result === null || result === void 0 ? void 0 : result.content
        }, instrument));
    }
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "InstrumentsView" + (minimized ? " minimized" : ""),
        children: [
            !connected && (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Alert,
                className: "InstrumentsView-warning",
                title: t("nmea_lost_title")
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                icon: minimized ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowsUp : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowsDown,
                className: "InstrumentsView-minimize",
                onClick: toggleMinimized
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "InstrumentsView-fill pre"
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "InstrumentsView-instruments",
                children: instruments
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "InstrumentsView-fill post"
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");














const $321f7f2ee9eb9eff$var$selectedShipContext = (0, $5cdac83ab505705b$export$1a6a959df6aea4fa)();
const $321f7f2ee9eb9eff$export$bdb528a92b7341d7 = $321f7f2ee9eb9eff$var$selectedShipContext.Context;
const $321f7f2ee9eb9eff$export$e287b9bdb03d0abe = $321f7f2ee9eb9eff$var$selectedShipContext.useGet;
function $321f7f2ee9eb9eff$export$9a45818394e32adc(ship, settings) {
    const result = Object.assign({}, ship);
    const shipSettings = settings === null || settings === void 0 ? void 0 : settings.find((row)=>row.settingType == (0, $bdd927c6c90fec0d$export$10bc32ab3a8a0f49).ship);
    if (shipSettings) {
        const parsed = (0, $bdd927c6c90fec0d$export$c72f6eaae7b9adff).parse(shipSettings);
        if (parsed.settingType == (0, $bdd927c6c90fec0d$export$10bc32ab3a8a0f49).ship) result.shipSettings = parsed.dataParsed;
    }
    const shipData = settings === null || settings === void 0 ? void 0 : settings.find((row)=>row.settingType == (0, $bdd927c6c90fec0d$export$10bc32ab3a8a0f49).shipData);
    if (shipData) {
        const parsed = (0, $bdd927c6c90fec0d$export$c72f6eaae7b9adff).parse(shipData);
        if (parsed.settingType == (0, $bdd927c6c90fec0d$export$10bc32ab3a8a0f49).shipData) result.shipData = parsed.dataParsed;
    }
    return result;
}





var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
function $c84a2e94370d0606$export$27ff714bfa22814a(initial, makeItem) {
    const [items, setItems] = (0, $acw62.useState)(initial);
    const add = (0, $acw62.useCallback)(()=>{
        setItems((prev)=>[
                ...prev,
                makeItem()
            ]);
    }, [
        makeItem
    ]);
    const removeAt = (0, $acw62.useCallback)((index)=>{
        setItems((prev)=>prev.filter((_, i)=>i !== index));
    }, []);
    return {
        items: items,
        setItems: setItems,
        add: add,
        removeAt: removeAt
    };
}















var $acw62 = parcelRequire("acw62");




parcelRequire("acw62");




function $9b7d8429eae2325f$export$d6f68d0fe29f8050({ onClick: onClick }) {
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
        className: "DeleteButton",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Trash,
            className: "icon-delete",
            onClick: onClick
        })
    });
}



parcelRequire("acw62");
function $8641e0c17062666d$export$5b82609d9b3a984b({ namePrefix: namePrefix, id: id, children: children }) {
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "hidden",
                name: `${namePrefix}id`,
                defaultValue: id
            }),
            children
        ]
    });
}


function $668fda0e05396ea5$export$24b1434c0559e42f({ namePrefix: namePrefix, id: id, rowClassName: rowClassName, onRemove: onRemove, children: children }) {
    return (0, $7b02d682eb115277$exports.jsx)((0, $8641e0c17062666d$export$5b82609d9b3a984b), {
        namePrefix: namePrefix,
        id: id,
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
            className: rowClassName,
            children: [
                children,
                onRemove && (0, $7b02d682eb115277$exports.jsx)((0, $9b7d8429eae2325f$export$d6f68d0fe29f8050), {
                    onClick: onRemove
                })
            ]
        })
    });
}


function $b917ef71b14736c4$export$202b066e6c9675a9({ data: data, editable: editable, index: index, onEdited: onEdited, removeInsurance: removeInsurance }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const namePrefix = `insurances[${index}].`;
    // Initialize insuranceType with the value from data, or undefined if not present
    const [insuranceType, setInsuranceType] = (0, $acw62.useState)(data.insuranceType);
    const predefinedTypes = [
        "liability",
        "hull",
        "accident"
    ];
    const selectInsuranceType = (0, $acw62.useCallback)((value)=>{
        setInsuranceType(value);
        if (onEdited) onEdited();
    }, []);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $668fda0e05396ea5$export$24b1434c0559e42f), {
        namePrefix: namePrefix,
        id: data.id,
        rowClassName: "one-row-list",
        onRemove: removeInsurance,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("insurance_type"),
                className: "block_field_small_16",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                    value: insuranceType,
                    predefined: predefinedTypes,
                    label: (v)=>t(`insurance_${v}`),
                    customValue: t("other"),
                    name: `${namePrefix}insuranceType`,
                    onSelect: selectInsuranceType,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("insurance_company"),
                className: "block_field_mobile_full",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}insuranceCompany`,
                    defaultValue: data.insuranceCompany,
                    onChange: onEdited,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("insurance_number"),
                className: "block_field_small_16",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}insuranceNumber`,
                    defaultValue: data.insuranceNumber,
                    onChange: onEdited,
                    readOnly: !editable
                })
            })
        ]
    });
}


function $bfa251d4dafb764a$export$717ca222196c0f47(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { data: data, ship: ship, attachments: attachments, editable: editable, formEditable: formEditable, edited: edited, onEdited: onEdited, save: save, files: files, saveAttachments: saveAttachments, handleDrop: handleDrop, handleSelect: handleSelect, removeAttachment: removeAttachment, inputRef: inputRef, showAttachment: showAttachment, setShowAttachment: setShowAttachment, editInsurance: editInsurance } = (0, $60bb38810c6aeae8$export$ccf74b7adff24162)();
    return (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
        changed: edited,
        editable: editable,
        editableFields: [
            "mmsi",
            "callsign",
            "homePort",
            "flag",
            "regNumber",
            "hin",
            "imo",
            "yachtBuildNumber",
            "yachtYachtBuilder",
            "yachtModelName",
            {
                name: "yachtYearBuild",
                type: "int"
            },
            "yachtConstruction",
            "yachtDesigner",
            "cel",
            "celPersons",
            "ownerName",
            "ownerPhone",
            "ownerEmail",
            "ownerAddress",
            "yachtClubName",
            "yachtClubAddress",
            {
                name: "insurances",
                array: true,
                type: "object",
                fields: [
                    "id",
                    "insuranceType",
                    "insuranceCompany",
                    "insuranceNumber"
                ]
            }
        ],
        onSave: save,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "block_field_50 ship-data-general",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: t("general")
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("mmsi"),
                                        className: "block_field_small_10",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.mmsi,
                                            name: "mmsi",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("callsign"),
                                        className: "block_field_small_10",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.callsign,
                                            name: "callsign",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("home_port"),
                                        className: "block_field_small_14",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.homePort,
                                            name: "homePort",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("flag"),
                                        className: "block_field_small_14",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.flag,
                                            name: "flag",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("reg_number"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.regNumber,
                                            name: "regNumber",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("hin"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.hin,
                                            name: "hin",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("imo"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.imo,
                                            name: "imo",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("build_number"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.yachtBuildNumber,
                                            name: "yachtBuildNumber",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("yachtbuilder"),
                                        className: "block_field_small_22",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.yachtYachtBuilder,
                                            name: "yachtYachtBuilder",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("model_name"),
                                        className: "block_field_small_22",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.yachtModelName,
                                            name: "yachtModelName",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("year"),
                                        className: "block_field_small_6",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.yachtYearBuild,
                                            name: "yachtYearBuild",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("construction"),
                                        className: "block_field_small_14",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.yachtConstruction,
                                            name: "yachtConstruction",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("designer"),
                                        className: "block_field_small_14",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.yachtDesigner,
                                            name: "yachtDesigner",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("cel"),
                                        className: "block_field_small_8",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.cel,
                                            name: "cel",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("cel_persons"),
                                        className: "block_field_small_8",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.celPersons,
                                            name: "celPersons",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "block_field_350 ship-data-photos",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: t("ship_foto")
                                })
                            }),
                            formEditable && (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                                buttonFirst: true,
                                changed: files.length > 0,
                                className: "NoteView-attachment-form",
                                editable: true,
                                editableFields: [
                                    "attachment"
                                ],
                                onSave: saveAttachments,
                                children: [
                                    files.length === 0 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "form-field file-field",
                                            onDrop: handleDrop,
                                            onDragOver: (event)=>event.preventDefault(),
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    htmlFor: "attachment",
                                                    className: "file-field-label",
                                                    onClick: ()=>inputRef.current && inputRef.current.click(),
                                                    children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: t("file_field_drag_drop")
                                                    })
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    ref: inputRef,
                                                    type: "file",
                                                    hidden: true,
                                                    accept: "image/*",
                                                    name: "attachment",
                                                    onChange: handleSelect
                                                })
                                            ]
                                        })
                                    }),
                                    files.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "attachment-item",
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                                                    className: "attachment-remove",
                                                    onClick: removeAttachment
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: URL.createObjectURL(files[0]),
                                                    alt: files[0].name,
                                                    style: {
                                                        maxWidth: "100%",
                                                        maxHeight: "400px"
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            attachments && attachments.length > 0 && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "ship-photos",
                                        children: showAttachment >= attachments.length || app.cloudSession() && !attachments[showAttachment].url ? (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {}) : ((a)=>{
                                            const key = `ship-${ship.id}-attachment-${a.id}`;
                                            const image = a.contentType.startsWith("image/");
                                            const url = (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).attachmentUrl(app.apiClient, ship.id, a, app.cloudSession());
                                            return (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "ship-photo attachment-item",
                                                children: [
                                                    image && (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        src: url,
                                                        alt: a.fileName
                                                    }),
                                                    formEditable && (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                                                        className: "attachment-remove",
                                                        onClick: removeAttachment
                                                    })
                                                ]
                                            }, key);
                                        })(attachments[showAttachment])
                                    }),
                                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        actions: attachments && attachments.length > 1,
                                        className: "row-arrow-buttons",
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("button", {
                                                disabled: showAttachment < 1,
                                                onClick: ()=>setShowAttachment(showAttachment - 1),
                                                className: "arrow-button",
                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowLeft
                                                })
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("button", {
                                                disabled: showAttachment >= attachments.length - 1,
                                                onClick: ()=>setShowAttachment(showAttachment + 1),
                                                className: "arrow-button",
                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).ArrowRight
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: t("owner")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "owner-data",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("owner_name"),
                                    className: "block_field_small_22",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: data.ownerName,
                                        name: "ownerName",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("owner_phone"),
                                    className: "block_field_small_12",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: data.ownerPhone,
                                        name: "ownerPhone",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("owner_email"),
                                    className: "block_field_small_22",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: data.ownerEmail,
                                        name: "ownerEmail",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("owner_address"),
                                className: "block_field_small_600",
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    defaultValue: data.ownerAddress,
                                    name: "ownerAddress",
                                    onChange: onEdited,
                                    readOnly: !editable
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("yacht_club"),
                                    className: "block_field_small_22",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: data.yachtClubName,
                                        name: "yachtClubName",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("yacht_club_address"),
                                    className: "",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: data.yachtClubAddress,
                                        name: "yachtClubAddress",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: t("insurances")
                            })
                        }),
                        editInsurance.items.map((insurance, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $b917ef71b14736c4$export$202b066e6c9675a9), {
                                data: insurance,
                                editable: editable,
                                index: index,
                                onEdited: onEdited,
                                removeInsurance: ()=>{
                                    editInsurance.removeAt(index);
                                    onEdited();
                                }
                            }, insurance.id)),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "button",
                                    disabled: !editable,
                                    onClick: ()=>{
                                        editInsurance.add();
                                        onEdited();
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                        }),
                                        " ",
                                        t("add_insurance")
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}










var $acw62 = parcelRequire("acw62");


// The selectable unit tokens per kind. These are the values persisted into the
// ShipData `*Unit` fields and the keys (via `unit_<token>`) used for translation.
const $dd561d017dad73b6$var$UNIT_OPTIONS = {
    length: [
        "m",
        "cm",
        "inch",
        "foot",
        "yard"
    ],
    surface: [
        "m2",
        "square_foot",
        "square_yard"
    ],
    volume: [
        "l",
        "gal"
    ],
    weight: [
        "kg",
        "pound",
        "tons"
    ],
    power: [
        "kw",
        "hp"
    ]
};
function $dd561d017dad73b6$export$d8a8bf46d230fbdf({ kind: kind, name: name, editable: editable, value: value, onChange: onChange, omit: omit, className: className = "unit-label" }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const units = (0, $acw62.useMemo)(()=>{
        const all = $dd561d017dad73b6$var$UNIT_OPTIONS[kind];
        return omit ? all.filter((unit)=>!omit.includes(unit)) : all;
    }, [
        kind,
        omit
    ]);
    // Deprecated and re-capitalized tokens still present in older persisted rows are shown
    // normalized to their canonical option; because the select is uncontrolled, an untouched select
    // then serializes the canonical value on the next save (client-side lazy migration).
    const selected = (_a = (0, $ba11ea1c282fce5f$export$b33d1e35ce55898)(value, units)) !== null && _a !== void 0 ? _a : value;
    return (0, $7b02d682eb115277$exports.jsx)("select", {
        className: className,
        defaultValue: selected,
        name: name,
        onChange: onChange,
        disabled: !editable,
        children: units.map((unit)=>(0, $7b02d682eb115277$exports.jsx)("option", {
                value: unit,
                children: t(`unit_${unit}`)
            }, unit))
    });
}



function $1df9d73df59e5f82$export$e0e8bec7fcaafb8d(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { data: data, ship: ship, editable: editable, formEditable: formEditable, edited: edited, onEdited: onEdited, save: save, selectedShipType: selectedShipType, setSelectedShipType: setSelectedShipType, shipType: shipType, vesselTypeOptions: vesselTypeOptions } = (0, $60bb38810c6aeae8$export$ccf74b7adff24162)();
    return (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
        changed: edited,
        editable: formEditable,
        editableFields: [
            "shipType",
            "specialFeatures",
            {
                name: "height",
                type: "float"
            },
            "heightUnit",
            {
                name: "draft",
                type: "float"
            },
            "draftUnit",
            {
                name: "beam",
                type: "float"
            },
            "beamUnit",
            {
                name: "lengthWaterline",
                type: "float"
            },
            "lengthWaterlineUnit",
            {
                name: "lengthHull",
                type: "float"
            },
            "lengthHullUnit",
            {
                name: "length",
                type: "float"
            },
            "lengthUnit",
            {
                name: "displacement",
                type: "float"
            },
            "displacementUnit",
            {
                name: "keelWeight",
                type: "float"
            },
            "keelWeightUnit",
            {
                name: "keelWeightPercent",
                type: "float"
            },
            "hullMaterial",
            "hullColor",
            "keelMaterial",
            "keelShape",
            {
                name: "masts",
                type: "int"
            },
            "rig",
            {
                name: "sailAreaTotal",
                type: "float"
            },
            "sailAreaTotalUnit",
            {
                name: "berthNo",
                type: "int"
            },
            {
                name: "berthSingleNo",
                type: "int"
            },
            {
                name: "berthDoubleNo",
                type: "int"
            },
            {
                name: "berthExtraNo",
                type: "int"
            },
            {
                name: "cabinsNo",
                type: "int"
            },
            {
                name: "bathNo",
                type: "int"
            },
            "saloon",
            "pantry",
            "cabins",
            "cockpit"
        ],
        onSave: save,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "ship-data-sketch",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: t("vessel_type")
                                })
                            }),
                            selectedShipType && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    className: "ship_data_sketch_features",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            className: "ship-sketch-column",
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)("select", {
                                                    className: "ShipTypeSelect",
                                                    disabled: !editable,
                                                    name: "shipType",
                                                    value: shipType,
                                                    onChange: (e)=>{
                                                        setSelectedShipType(e.target.value);
                                                        onEdited();
                                                    },
                                                    children: ship.vesselType && vesselTypeOptions[ship.vesselType].map((type)=>(0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: type,
                                                            children: t(`${type}`)
                                                        }, type))
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    className: "ShipSketch",
                                                    src: "/ship-" + shipType + ".svg"
                                                })
                                            ]
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            label: t("special_features"),
                                            children: (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                defaultValue: data.specialFeatures,
                                                name: "specialFeatures",
                                                onChange: onEdited,
                                                rows: 4,
                                                readOnly: !formEditable
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: t("dimensions")
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "ship-data-dimensions",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("height"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                    format: "float",
                                                    className: "unit",
                                                    defaultValue: data.height,
                                                    name: "height",
                                                    onChange: onEdited,
                                                    readOnly: !editable
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                    kind: "length",
                                                    name: "heightUnit",
                                                    value: data.heightUnit,
                                                    editable: editable,
                                                    onChange: onEdited
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("draft"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                    format: "float",
                                                    className: "unit",
                                                    defaultValue: data.draft,
                                                    name: "draft",
                                                    onChange: onEdited,
                                                    readOnly: !editable
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                    kind: "length",
                                                    name: "draftUnit",
                                                    value: data.draftUnit,
                                                    editable: editable,
                                                    onChange: onEdited
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("beam"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                    format: "float",
                                                    className: "unit",
                                                    defaultValue: data.beam,
                                                    name: "beam",
                                                    onChange: onEdited,
                                                    readOnly: !editable
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                    kind: "length",
                                                    name: "beamUnit",
                                                    value: data.beamUnit,
                                                    editable: editable,
                                                    onChange: onEdited
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("length_waterline"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                    format: "float",
                                                    className: "unit",
                                                    defaultValue: data.lengthWaterline,
                                                    name: "lengthWaterline",
                                                    onChange: onEdited,
                                                    readOnly: !editable
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                    kind: "length",
                                                    name: "lengthWaterlineUnit",
                                                    value: data.lengthWaterlineUnit,
                                                    editable: editable,
                                                    onChange: onEdited
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("length_hull"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                    format: "float",
                                                    className: "unit",
                                                    defaultValue: data.lengthHull,
                                                    name: "lengthHull",
                                                    onChange: onEdited,
                                                    readOnly: !editable
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                    kind: "length",
                                                    name: "lengthHullUnit",
                                                    value: data.lengthHullUnit,
                                                    editable: editable,
                                                    onChange: onEdited
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("length"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                    format: "float",
                                                    className: "unit",
                                                    defaultValue: data.length,
                                                    name: "length",
                                                    onChange: onEdited,
                                                    readOnly: !editable
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                    kind: "length",
                                                    name: "lengthUnit",
                                                    value: data.lengthUnit,
                                                    editable: editable,
                                                    onChange: onEdited
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("displacement"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                    format: "float",
                                                    className: "unit",
                                                    defaultValue: data.displacement,
                                                    name: "displacement",
                                                    onChange: onEdited,
                                                    readOnly: !editable
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                    kind: "weight",
                                                    name: "displacementUnit",
                                                    value: data.displacementUnit,
                                                    editable: editable,
                                                    onChange: onEdited
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("keel_weight"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                    format: "float",
                                                    className: "unit",
                                                    defaultValue: data.keelWeight,
                                                    name: "keelWeight",
                                                    onChange: onEdited,
                                                    readOnly: !editable
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                    kind: "weight",
                                                    name: "keelWeightUnit",
                                                    value: data.keelWeightUnit,
                                                    editable: editable,
                                                    onChange: onEdited
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("keel_weight_percent"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.keelWeightPercent,
                                            name: "keelWeightPercent",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("hull_material"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.hullMaterial,
                                            name: "hullMaterial",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("hull_color"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.hullColor,
                                            name: "hullColor",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("keel_material"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.keelMaterial,
                                            name: "keelMaterial",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("keel_shape"),
                                        className: "block_field_small_12",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.keelShape,
                                            name: "keelShape",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    })
                                ]
                            }),
                            (0, $22871482fce5b7e5$export$7930c61d9b464618).isSailingVessel(ship) && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("masts_no"),
                                        className: "block_field_small_8",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                            format: "int",
                                            defaultValue: data.masts,
                                            name: "masts",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("rig"),
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: data.rig,
                                            name: "rig",
                                            onChange: onEdited,
                                            readOnly: !editable
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("sail_area_total"),
                                        className: "block_field_small_10",
                                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                    format: "float",
                                                    className: "unit",
                                                    defaultValue: data.sailAreaTotal,
                                                    name: "sailAreaTotal",
                                                    onChange: onEdited,
                                                    readOnly: !editable
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                    kind: "surface",
                                                    name: "sailAreaTotalUnit",
                                                    value: data.sailAreaTotalUnit,
                                                    editable: editable,
                                                    onChange: onEdited
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: t("inside")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "inside-numbers-row",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("berth_no"),
                                    className: "block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                        format: "int",
                                        defaultValue: data.berthNo,
                                        name: "berthNo",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("berth_single_no"),
                                    className: "block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                        format: "int",
                                        defaultValue: data.berthSingleNo,
                                        name: "berthSingleNo",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("berth_double_no"),
                                    className: "block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                        format: "int",
                                        defaultValue: data.berthDoubleNo,
                                        name: "berthDoubleNo",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("berth_extra_no"),
                                    className: "block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                        format: "int",
                                        defaultValue: data.berthExtraNo,
                                        name: "berthExtraNo",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("cabins_no"),
                                    className: "block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                        format: "int",
                                        defaultValue: data.cabinsNo,
                                        name: "cabinsNo",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("bath_no"),
                                    className: "block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                        format: "int",
                                        defaultValue: data.bathNo,
                                        name: "bathNo",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "living_areas",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("saloon"),
                                    children: (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                        defaultValue: data.saloon,
                                        rows: 4,
                                        name: "saloon",
                                        onChange: onEdited,
                                        readOnly: !formEditable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("pantry"),
                                    children: (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                        defaultValue: data.pantry,
                                        rows: 4,
                                        name: "pantry",
                                        onChange: onEdited,
                                        readOnly: !formEditable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("cabins"),
                                    children: (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                        defaultValue: data.cabins,
                                        rows: 4,
                                        name: "cabins",
                                        onChange: onEdited,
                                        readOnly: !formEditable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("cockpit"),
                                    children: (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                        defaultValue: data.cockpit,
                                        rows: 4,
                                        name: "cockpit",
                                        onChange: onEdited,
                                        readOnly: !formEditable
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}












var $acw62 = parcelRequire("acw62");







function $896c373df2a79389$export$1691f28313e8dab2({ data: data, editable: editable, index: index, onEdited: onEdited }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const namePrefix = `engines[${index}].`;
    // Initialize fuelType with the value from data, or undefined if not present
    const [fuelType, setFuelType] = (0, $acw62.useState)(data.fuelType);
    const predefinedTypes = (0, $60bb38810c6aeae8$export$fcfb9784b884236b).fuelType;
    const selectFuelType = (0, $acw62.useCallback)((value)=>{
        setFuelType(value);
        if (onEdited) onEdited();
    }, []);
    // Initialize driveType with the value from data, or undefined if not present
    const [driveType, setDriveType] = (0, $acw62.useState)(data.driveType);
    const predefinedDrives = (0, $60bb38810c6aeae8$export$fcfb9784b884236b).engineDriveType;
    const selectDriveType = (0, $acw62.useCallback)((value)=>{
        setDriveType(value);
        if (onEdited) onEdited();
    }, []);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $8641e0c17062666d$export$5b82609d9b3a984b), {
        namePrefix: namePrefix,
        id: data.id,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-1 engine-fields-row",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("engine#"),
                        className: "block_field_small_4",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                            format: "int",
                            name: `${namePrefix}number`,
                            defaultValue: data.number,
                            onChange: onEdited,
                            readOnly: true
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("engine_nmea_number"),
                        className: "block_field_small_4",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                            format: "int",
                            name: `${namePrefix}nmeaNumber`,
                            defaultValue: data.nmeaNumber,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("engine_short_name"),
                        className: "block_field_small_12",
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}engineShortName`,
                            defaultValue: data.engineShortName,
                            onChange: onEdited,
                            readOnly: !editable,
                            maxLength: 10
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("manufacturer"),
                        className: "block_field_small_20",
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}manufacturer`,
                            defaultValue: data.manufacturer,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("model"),
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}model`,
                            defaultValue: data.model,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-last engine-fields-row",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("serial_number"),
                        className: "block_field_small_16",
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}serialNumber`,
                            defaultValue: data.serialNumber,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("power"),
                        className: "block_field_small_8",
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                    format: "int",
                                    className: "unit",
                                    name: `${namePrefix}power`,
                                    defaultValue: data.power,
                                    onChange: onEdited,
                                    readOnly: !editable
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                    kind: "power",
                                    name: `${namePrefix}powerUnit`,
                                    value: data.powerUnit,
                                    editable: editable,
                                    onChange: onEdited
                                })
                            ]
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("fuel_type"),
                        className: "block_field_small_10",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                            value: fuelType,
                            predefined: predefinedTypes,
                            label: (v)=>t(`fuel_${v}`),
                            customValue: t("other"),
                            name: `${namePrefix}fuelType`,
                            onSelect: selectFuelType,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("drive_type"),
                        className: "block_field_small_10",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                            value: driveType,
                            predefined: predefinedDrives,
                            label: (v)=>t(`engine_${v}`),
                            customValue: t("other"),
                            name: `${namePrefix}driveType`,
                            onSelect: selectDriveType,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("propeller_type"),
                        className: "block_field_small_14",
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}propellerType`,
                            defaultValue: data.propellerType,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");








function $7e57cb34c76f8cd2$export$ea58250fd3c3f383({ data: data, editable: editable, index: index, onEdited: onEdited, removeGenerator: removeGenerator }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const namePrefix = `generators[${index}].`;
    // Initialize GeneratorType with the value from data, or undefined if not present
    const [generatorType, setGeneratorType] = (0, $acw62.useState)(data.generatorType);
    const predefinedGeneratorTypes = (0, $60bb38810c6aeae8$export$fcfb9784b884236b).generatorType;
    const selectGeneratorType = (0, $acw62.useCallback)((value)=>{
        setGeneratorType(value);
        if (onEdited) onEdited();
    }, []);
    // Initialize fuelType with the value from data, or undefined if not present
    const [fuelType, setFuelType] = (0, $acw62.useState)(data.fuelType);
    const predefinedTypes = [
        "diesel",
        "petrol",
        "gas",
        "electricity"
    ];
    const selectFuelType = (0, $acw62.useCallback)((value)=>{
        setFuelType(value);
        if (onEdited) onEdited();
    }, []);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $8641e0c17062666d$export$5b82609d9b3a984b), {
        namePrefix: namePrefix,
        id: data.id,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-1",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("generator"),
                        className: "block_field_small_18",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                            value: generatorType,
                            predefined: predefinedGeneratorTypes,
                            label: (v)=>t(`generator_${v}`),
                            customValue: t("other"),
                            name: `${namePrefix}generatorType`,
                            onSelect: selectGeneratorType,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("manufacturer"),
                        className: "block_field_small_24",
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}manufacturer`,
                            defaultValue: data.manufacturer,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("model"),
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}model`,
                            defaultValue: data.model,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-last",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("serial_number"),
                        className: "block_field_small_12",
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}serialNumber`,
                            defaultValue: data.serialNumber,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("power"),
                        className: "block_field_small_8",
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                    format: "int",
                                    className: "unit",
                                    name: `${namePrefix}power`,
                                    defaultValue: data.power,
                                    onChange: onEdited,
                                    readOnly: !editable
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                    kind: "power",
                                    name: `${namePrefix}powerUnit`,
                                    value: data.powerUnit,
                                    editable: editable,
                                    onChange: onEdited
                                })
                            ]
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("fuel_type"),
                        className: "block_field_small_12",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                            value: fuelType,
                            predefined: predefinedTypes,
                            label: (v)=>t(`fuel_${v}`),
                            customValue: t("other"),
                            name: `${namePrefix}fuelType`,
                            onSelect: selectFuelType,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("comment"),
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}comment`,
                            defaultValue: data.comment,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $9b7d8429eae2325f$export$d6f68d0fe29f8050), {
                        onClick: removeGenerator
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






function $c1ab53fe316ae7ff$export$20809fe13b9eae37({ data: data, editable: editable, index: index, onEdited: onEdited, removeSteeringSystem: removeSteeringSystem }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const namePrefix = `steeringSystems[${index}].`;
    // Initialize steeringtype with the value from data, or undefined if not present
    const [steeringType, setSteeringType] = (0, $acw62.useState)(data.steeringType);
    const predefinedTypes = [
        "bow_thruster",
        "stern_thruster",
        "self_steering",
        "windvane",
        "autopilot"
    ];
    const selectSteeringType = (0, $acw62.useCallback)((value)=>{
        setSteeringType(value);
        if (onEdited) onEdited();
    }, []);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $668fda0e05396ea5$export$24b1434c0559e42f), {
        namePrefix: namePrefix,
        id: data.id,
        rowClassName: "block-row-last additional-steering-system-fields-row",
        onRemove: removeSteeringSystem,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("steering_type"),
                className: "block_field_small_14",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                    value: steeringType,
                    predefined: predefinedTypes,
                    label: (v)=>t(`steering_${v}`),
                    customValue: t("other"),
                    name: `${namePrefix}steeringType`,
                    onSelect: selectSteeringType,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("manufacturer"),
                className: "block_field_small_18",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}manufacturer`,
                    defaultValue: data.manufacturer,
                    onChange: onEdited,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("model"),
                className: "block_field_small_18",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}model`,
                    defaultValue: data.model,
                    onChange: onEdited,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("power"),
                className: "block_field_small_8",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                            format: "int",
                            className: "unit",
                            name: `${namePrefix}power`,
                            defaultValue: data.power,
                            onChange: onEdited,
                            readOnly: !editable
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                            kind: "power",
                            name: `${namePrefix}powerUnit`,
                            value: data.powerUnit,
                            editable: editable,
                            onChange: onEdited
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("comment"),
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}comment`,
                    defaultValue: data.comment,
                    onChange: onEdited,
                    readOnly: !editable
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






function $05281c3acd7672f3$export$80e3fe1271b22629({ data: data, editable: editable, index: index, onEdited: onEdited, removeTank: removeTank }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const namePrefix = `tanks[${index}].`;
    // Initialize tank with the value from data, or undefined if not present
    const [tank, setTank] = (0, $acw62.useState)(data.tankType);
    const predefinedTanks = [
        "fuel",
        "fuel_daytank",
        "water",
        "gray",
        "waste",
        "gas"
    ];
    const selectTank = (0, $acw62.useCallback)((value)=>{
        setTank(value);
        if (onEdited) onEdited();
    }, []);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $668fda0e05396ea5$export$24b1434c0559e42f), {
        namePrefix: namePrefix,
        id: data.id,
        rowClassName: "one-row-list",
        onRemove: removeTank,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("tank"),
                className: "block_field_small_14",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                    value: tank,
                    predefined: predefinedTanks,
                    label: (v)=>t(`tank_${v}`),
                    customValue: t("other"),
                    name: `${namePrefix}tankType`,
                    onSelect: selectTank,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("size"),
                className: "block_field_small_8",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                            format: "int",
                            className: "unit",
                            name: `${namePrefix}capacity`,
                            defaultValue: data.capacity,
                            onChange: onEdited,
                            readOnly: !editable
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                            kind: "volume",
                            name: `${namePrefix}capacityUnit`,
                            value: data.capacityUnit,
                            editable: editable,
                            onChange: onEdited
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("place_installation"),
                className: "block_field_small_16",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}placeInstallation`,
                    defaultValue: data.placeInstallation,
                    onChange: onEdited,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("comment"),
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}comment`,
                    defaultValue: data.comment,
                    onChange: onEdited,
                    readOnly: !editable
                })
            })
        ]
    });
}


function $444c9877f1d0904a$export$63ec46419089393e(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { data: data, ship: ship, editable: editable, edited: edited, onEdited: onEdited, save: save, editEngine: editEngine, editGenerator: editGenerator, editSteeringSystem: editSteeringSystem, editTank: editTank } = (0, $60bb38810c6aeae8$export$ccf74b7adff24162)();
    return (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
        changed: edited,
        editable: editable,
        editableFields: [
            {
                name: "engines",
                array: true,
                type: "object",
                fields: [
                    "id",
                    {
                        name: "number",
                        type: "int"
                    },
                    {
                        name: "nmeaNumber",
                        type: "int",
                        default: undefined
                    },
                    "engineShortName",
                    "manufacturer",
                    "model",
                    "serialNumber",
                    {
                        name: "power",
                        type: "int"
                    },
                    "powerUnit",
                    "fuelType",
                    "driveType",
                    "propellerType"
                ]
            },
            {
                name: "generators",
                array: true,
                type: "object",
                fields: [
                    "id",
                    "generatorType",
                    "manufacturer",
                    "model",
                    "serialNumber",
                    {
                        name: "power",
                        type: "int"
                    },
                    "powerUnit",
                    "fuelType",
                    "comment"
                ]
            },
            {
                name: "tanks",
                array: true,
                type: "object",
                fields: [
                    "id",
                    "tankType",
                    {
                        name: "capacity",
                        type: "int"
                    },
                    "capacityUnit",
                    "placeInstallation",
                    "comment"
                ]
            },
            {
                name: "steeringSystems",
                array: true,
                type: "object",
                fields: [
                    "id",
                    "steeringType",
                    "manufacturer",
                    "model",
                    {
                        name: "power",
                        type: "int"
                    },
                    "powerUnit",
                    "comment"
                ]
            },
            "steeringSystem",
            {
                name: "rudderNumber",
                type: "int"
            },
            "rudderShape",
            "rudderDrive",
            {
                name: "tankFuelNo",
                type: "int"
            },
            {
                name: "tankWaterNo",
                type: "int"
            },
            {
                name: "tankGrayNo",
                type: "int"
            },
            {
                name: "tankWasteNo",
                type: "int"
            },
            {
                name: "tankGasNo",
                type: "int"
            },
            {
                name: "tankFuelSize",
                type: "int"
            },
            "tankFuelSizeUnit",
            {
                name: "tankWaterSize",
                type: "int"
            },
            "tankWaterSizeUnit",
            {
                name: "tankGraySize",
                type: "int"
            },
            "tankGraySizeUnit",
            {
                name: "tankWasteSize",
                type: "int"
            },
            "tankWasteSizeUnit",
            {
                name: "tankGasSize",
                type: "int"
            },
            "tankGasSizeUnit"
        ],
        onSave: save,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: t("engines")
                            })
                        }),
                        Array.from(Array(ship.engineCount).keys()).map((index)=>{
                            const engine = (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).engineAt({
                                engines: editEngine.items
                            }, index);
                            return (0, $7b02d682eb115277$exports.jsx)((0, $896c373df2a79389$export$1691f28313e8dab2), {
                                data: engine,
                                editable: editable,
                                index: index,
                                onEdited: onEdited
                            }, engine.id);
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: t("generators")
                            })
                        }),
                        editGenerator.items.map((generator, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $7e57cb34c76f8cd2$export$ea58250fd3c3f383), {
                                data: generator,
                                editable: editable,
                                index: index,
                                onEdited: onEdited,
                                removeGenerator: ()=>{
                                    editGenerator.removeAt(index);
                                    onEdited();
                                }
                            }, generator.id)),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "button",
                                    disabled: !editable,
                                    onClick: ()=>{
                                        editGenerator.add();
                                        onEdited();
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                        }),
                                        " ",
                                        t("add_generator")
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: t("steering_systems")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block-row-last main-steering-fields-row",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("steering_system_main"),
                                    className: "block_field_small_16",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: data.steeringSystem,
                                        name: "steeringSystem",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("rudder_no"),
                                    className: "block_field_small_8",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                        format: "int",
                                        defaultValue: data.rudderNumber,
                                        name: "rudderNumber",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("rudder_shape"),
                                    className: "block_field_small_12",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: data.rudderShape,
                                        name: "rudderShape",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("rudder_drive"),
                                    className: "block_field_small_16",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: data.rudderDrive,
                                        name: "rudderDrive",
                                        onChange: onEdited,
                                        readOnly: !editable
                                    })
                                })
                            ]
                        }),
                        editSteeringSystem.items.map((steeringSystem, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $c1ab53fe316ae7ff$export$20809fe13b9eae37), {
                                data: steeringSystem,
                                editable: editable,
                                index: index,
                                onEdited: onEdited,
                                removeSteeringSystem: ()=>{
                                    editSteeringSystem.removeAt(index);
                                    onEdited();
                                }
                            }, steeringSystem.id)),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                className: "button_top_distance",
                                children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "button",
                                    disabled: !editable,
                                    onClick: ()=>{
                                        editSteeringSystem.add();
                                        onEdited();
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                        }),
                                        " ",
                                        t("add_steeringsystem")
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: t("tanks")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "tank-fields-row",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("tank_fuel_no"),
                                    className: "unit block_field_small_16",
                                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                format: "int",
                                                defaultValue: data.tankFuelNo,
                                                name: "tankFuelNo",
                                                onChange: onEdited,
                                                readOnly: !editable,
                                                className: "block_field_small_3"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                format: "int",
                                                className: "unit block_field_small_10",
                                                defaultValue: data.tankFuelSize,
                                                name: "tankFuelSize",
                                                onChange: onEdited,
                                                readOnly: !editable
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                kind: "volume",
                                                name: "tankFuelSizeUnit",
                                                value: data.tankFuelSizeUnit,
                                                editable: editable,
                                                onChange: onEdited,
                                                className: "unit-label block_field_small_3"
                                            })
                                        ]
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("tank_water_no"),
                                    className: "unit block_field_small_16",
                                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                format: "int",
                                                defaultValue: data.tankWaterNo,
                                                name: "tankWaterNo",
                                                onChange: onEdited,
                                                readOnly: !editable,
                                                className: "block_field_small_3"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                format: "int",
                                                className: "unit block_field_small_10",
                                                defaultValue: data.tankWaterSize,
                                                name: "tankWaterSize",
                                                onChange: onEdited,
                                                readOnly: !editable
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                kind: "volume",
                                                name: "tankWaterSizeUnit",
                                                value: data.tankWaterSizeUnit,
                                                editable: editable,
                                                onChange: onEdited,
                                                className: "unit-label block_field_small_3"
                                            })
                                        ]
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("tank_gray_no"),
                                    className: "unit block_field_small_16",
                                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                format: "int",
                                                defaultValue: data.tankGrayNo,
                                                name: "tankGrayNo",
                                                onChange: onEdited,
                                                readOnly: !editable,
                                                className: "block_field_small_3"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                format: "int",
                                                className: "unit block_field_small_10",
                                                defaultValue: data.tankGraySize,
                                                name: "tankGraySize",
                                                onChange: onEdited,
                                                readOnly: !editable
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                kind: "volume",
                                                name: "tankGraySizeUnit",
                                                value: data.tankGraySizeUnit,
                                                editable: editable,
                                                onChange: onEdited,
                                                className: "unit-label block_field_small_3"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block-row-last tank-fields-row",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("tank_waste_no"),
                                    className: "unit block_field_small_16",
                                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                format: "int",
                                                defaultValue: data.tankWasteNo,
                                                name: "tankWasteNo",
                                                onChange: onEdited,
                                                readOnly: !editable,
                                                className: "block_field_small_3"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                format: "int",
                                                className: "unit block_field_small_10",
                                                defaultValue: data.tankWasteSize,
                                                name: "tankWasteSize",
                                                onChange: onEdited,
                                                readOnly: !editable
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                kind: "volume",
                                                name: "tankWasteSizeUnit",
                                                value: data.tankWasteSizeUnit,
                                                editable: editable,
                                                onChange: onEdited,
                                                className: "unit-label block_field_small_3"
                                            })
                                        ]
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("tank_gas_no"),
                                    className: "unit block_field_small_16",
                                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                format: "int",
                                                defaultValue: data.tankGasNo,
                                                name: "tankGasNo",
                                                onChange: onEdited,
                                                readOnly: !editable,
                                                className: "block_field_small_3"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$102e37fb1731abbd), {}),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                                format: "int",
                                                className: "unit block_field_small_10",
                                                defaultValue: data.tankGasSize,
                                                name: "tankGasSize",
                                                onChange: onEdited,
                                                readOnly: !editable
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                                kind: "volume",
                                                name: "tankGasSizeUnit",
                                                value: data.tankGasSizeUnit,
                                                editable: editable,
                                                onChange: onEdited,
                                                className: "unit-label block_field_small_3"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        editTank.items.map((tank, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $05281c3acd7672f3$export$80e3fe1271b22629), {
                                data: tank,
                                editable: editable,
                                index: index,
                                onEdited: onEdited,
                                removeTank: ()=>{
                                    editTank.removeAt(index);
                                    onEdited();
                                }
                            }, tank.id)),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "button",
                                    disabled: !editable,
                                    onClick: ()=>{
                                        editTank.add();
                                        onEdited();
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                        }),
                                        " ",
                                        t("add_tank")
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}










var $acw62 = parcelRequire("acw62");





function $1fb0b47178f70c33$export$763c6727237ebf1d({ data: data, editable: editable, index: index, onEdited: onEdited, removeRig: removeRig }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const namePrefix = `rigElements[${index}].`;
    const [rigElement, setRig] = (0, $acw62.useState)(data.rigElement);
    const predefinedRigs = [
        "mast",
        "main_mast",
        "mizzen_mast",
        "forestay",
        "stay",
        "jib_stay",
        "backstay",
        "runner",
        "baby_stay",
        "kicker",
        "vang",
        "winch"
    ];
    const selectRig = (0, $acw62.useCallback)((value)=>{
        setRig(value);
        if (onEdited) onEdited();
    }, []);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $668fda0e05396ea5$export$24b1434c0559e42f), {
        namePrefix: namePrefix,
        id: data.id,
        rowClassName: "block-row-last rig-element-fields-row",
        onRemove: removeRig,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("rig_element"),
                children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                    value: rigElement,
                    predefined: predefinedRigs,
                    label: (v)=>t(`rig_${v}`),
                    customValue: t("other"),
                    name: `${namePrefix}rigElement`,
                    onSelect: selectRig,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("manufacturer"),
                className: "block_field_small_18",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}manufacturer`,
                    defaultValue: data.manufacturer,
                    onChange: onEdited,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("model"),
                className: "block_field_small_18",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}model`,
                    defaultValue: data.model,
                    onChange: onEdited,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("size_height"),
                className: "block_field_small_10",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("input", {
                            className: "unit",
                            name: `${namePrefix}size`,
                            defaultValue: data.size,
                            onChange: onEdited,
                            readOnly: !editable
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                            kind: "length",
                            name: `${namePrefix}sizeUnit`,
                            value: data.sizeUnit,
                            editable: editable,
                            onChange: onEdited
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("place_installation"),
                className: "block_field_small_12",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}placeInstallation`,
                    defaultValue: data.placeInstallation,
                    onChange: onEdited,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("serial_number"),
                className: "block_field_small_1_3",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}serialNumber`,
                    defaultValue: data.serialNumber,
                    onChange: onEdited,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("comment"),
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}comment`,
                    defaultValue: data.comment,
                    onChange: onEdited,
                    readOnly: !editable
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





function $40a2b58e23fb853b$export$1a10f11017662d66({ data: data, editable: editable, index: index, onEdited: onEdited, removeSail: removeSail }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const namePrefix = `sails[${index}].`;
    // Initialize sail with the value from data, or undefined if not present
    const [sail, setSail] = (0, $acw62.useState)(data.sail);
    const predefinedSails = [
        "mainsail",
        "genoa",
        "jib",
        "working_jib",
        "strom_jib",
        "spinnaker",
        "gennaker",
        "code0",
        "parasailor",
        "mizzen",
        "mizzen_staysail",
        "try"
    ];
    const selectSail = (0, $acw62.useCallback)((value)=>{
        setSail(value);
        if (onEdited) onEdited();
    }, []);
    // Initialize sailType with the value from data, or undefined if not present
    const [sailType, setSailType] = (0, $acw62.useState)(data.sailType);
    const predefinedTypes = [
        "forestay",
        "mast",
        "mizzen"
    ];
    const selectSailType = (0, $acw62.useCallback)((value)=>{
        setSailType(value);
        if (onEdited) onEdited();
    }, []);
    const [reefNo, setReefNo] = (0, $acw62.useState)(data.reefNo || 0);
    const predefinedReefNos = [
        0,
        1,
        2,
        3
    ];
    return (0, $7b02d682eb115277$exports.jsxs)((0, $668fda0e05396ea5$export$24b1434c0559e42f), {
        namePrefix: namePrefix,
        id: data.id,
        rowClassName: "block-row-wrap",
        onRemove: removeSail,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("sail"),
                className: "block_field_small_14",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                    value: sail,
                    predefined: predefinedSails,
                    label: (v)=>t(`sail_${v}`),
                    customValue: t("other"),
                    name: `${namePrefix}sail`,
                    onSelect: selectSail,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("sail_type"),
                className: "block_field_small_12",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                    value: sailType,
                    predefined: predefinedTypes,
                    label: (v)=>t(`sail_${v}`),
                    customValue: t("other"),
                    name: `${namePrefix}sailType`,
                    onSelect: selectSailType,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("sail_reefs_no"),
                className: "block_field_small_8",
                children: (0, $7b02d682eb115277$exports.jsx)("select", {
                    className: "ShipTypeSelect",
                    name: `${namePrefix}reefNo`,
                    value: reefNo,
                    onChange: (e)=>{
                        setReefNo(parseInt(e.target.value));
                        if (onEdited) onEdited();
                    },
                    disabled: !editable,
                    children: predefinedReefNos.map((type)=>(0, $7b02d682eb115277$exports.jsx)("option", {
                            value: type,
                            children: t(`sail_${type}`)
                        }, `reef_${type}`))
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("sail_size"),
                className: "block_field_small_8",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("input", {
                            className: "unit",
                            name: `${namePrefix}size`,
                            defaultValue: data.size,
                            onChange: onEdited,
                            readOnly: !editable
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                            kind: "surface",
                            name: `${namePrefix}sizeUnit`,
                            value: data.sizeUnit,
                            editable: editable,
                            onChange: onEdited
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("manufacturer"),
                className: "block_field_small_14",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}manufacturer`,
                    defaultValue: data.manufacturer,
                    onChange: onEdited,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("comment"),
                className: "block_field_small_30",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}comment`,
                    defaultValue: data.comment,
                    onChange: onEdited,
                    readOnly: !editable
                })
            })
        ]
    });
}


function $790fa7be9d39e80d$export$a0b1e39c3ea4e548(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { editable: editable, formEditable: formEditable, edited: edited, onEdited: onEdited, save: save, editRigElement: editRigElement, editSail: editSail } = (0, $60bb38810c6aeae8$export$ccf74b7adff24162)();
    return (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
        changed: edited,
        editable: formEditable,
        editableFields: [
            {
                name: "rigElements",
                array: true,
                type: "object",
                fields: [
                    "id",
                    "rigElement",
                    "manufacturer",
                    "model",
                    {
                        name: "size",
                        type: "int"
                    },
                    "sizeUnit",
                    "serialNumber",
                    "comment",
                    "placeInstallation"
                ]
            },
            {
                name: "sails",
                array: true,
                type: "object",
                fields: [
                    "id",
                    "sail",
                    "sailType",
                    {
                        name: "reefNo",
                        type: "int"
                    },
                    "manufacturer",
                    {
                        name: "size",
                        type: "int"
                    },
                    "sizeUnit",
                    "comment"
                ]
            }
        ],
        onSave: save,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: t("mast_rig")
                            })
                        }),
                        editRigElement.items.map((rigElement, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $1fb0b47178f70c33$export$763c6727237ebf1d), {
                                data: rigElement,
                                editable: editable,
                                index: index,
                                onEdited: onEdited,
                                removeRig: ()=>{
                                    editRigElement.removeAt(index);
                                    onEdited();
                                }
                            }, rigElement.id)),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                className: "button_top_distance",
                                children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "button",
                                    disabled: !editable,
                                    onClick: ()=>{
                                        editRigElement.add();
                                        onEdited();
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                        }),
                                        " ",
                                        t("add_rig")
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: t("sails")
                            })
                        }),
                        editSail.items.map((sail, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $40a2b58e23fb853b$export$1a10f11017662d66), {
                                data: sail,
                                editable: editable,
                                index: index,
                                onEdited: onEdited,
                                removeSail: ()=>{
                                    editSail.removeAt(index);
                                    onEdited();
                                }
                            }, sail.id)),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                className: "button_top_distance",
                                children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "button",
                                    disabled: !editable,
                                    onClick: ()=>{
                                        editSail.add();
                                        onEdited();
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                        }),
                                        " ",
                                        t("add_sail")
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}










var $acw62 = parcelRequire("acw62");







function $b65a0166dc685ef9$export$f91e850a9eed2440({ data: data, editable: editable, index: index, onEdited: onEdited, removeAnchor: removeAnchor }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const namePrefix = `anchors[${index}].`;
    const predefinedPlaces = [
        "",
        "bow",
        "stern",
        "variable"
    ];
    // Initialize anchorType with the value from data, or undefined if not present
    const [anchorType, setAnchorType] = (0, $acw62.useState)(data.anchorType);
    const selectAnchorType = (0, $acw62.useCallback)((value)=>{
        setAnchorType(value);
        if (onEdited) onEdited();
    }, []);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $8641e0c17062666d$export$5b82609d9b3a984b), {
        namePrefix: namePrefix,
        id: data.id,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-1",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("anchor_type"),
                        className: "block_field_small_16",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                            value: anchorType,
                            predefined: (0, $60bb38810c6aeae8$export$fcfb9784b884236b).anchorType,
                            label: (v)=>t(`anchor_${v}`),
                            customValue: t("other"),
                            name: `${namePrefix}anchorType`,
                            onSelect: selectAnchorType,
                            readOnly: !editable,
                            sort: true
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("anchor_weight"),
                        className: "block_field_small_8",
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    className: "unit",
                                    name: `${namePrefix}weight`,
                                    defaultValue: data.weight,
                                    onChange: onEdited,
                                    readOnly: !editable
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $dd561d017dad73b6$export$d8a8bf46d230fbdf), {
                                    kind: "weight",
                                    name: `${namePrefix}weightUnit`,
                                    value: data.weightUnit,
                                    editable: editable,
                                    onChange: onEdited,
                                    omit: [
                                        "tons"
                                    ]
                                })
                            ]
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("anchor_location"),
                        className: "block_field_small_10",
                        children: (0, $7b02d682eb115277$exports.jsx)("select", {
                            className: "ShipTypeSelect",
                            name: `${namePrefix}placeInstallation`,
                            defaultValue: data.placeInstallation,
                            onChange: onEdited,
                            children: predefinedPlaces.map((type)=>(0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: type,
                                    children: t(`${type}`)
                                }, type))
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("anchor_chain"),
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}chain`,
                            defaultValue: data.chain,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "block-row-last",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("anchor_chain_lead"),
                        className: "block_field_small_16",
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}chainLead`,
                            defaultValue: data.chainLead,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("anchor_windlass"),
                        className: "block_field_small_10",
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}windlass`,
                            defaultValue: data.windlass,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("anchor_windless_drive"),
                        className: "block_field_small_12",
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}windlassDrive`,
                            defaultValue: data.windlassDrive,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: t("anchor_windless_manfacturer"),
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: `${namePrefix}windlassManufacturer`,
                            defaultValue: data.windlassManufacturer,
                            onChange: onEdited,
                            readOnly: !editable
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $9b7d8429eae2325f$export$d6f68d0fe29f8050), {
                        onClick: removeAnchor
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





function $23b8b0be4da3c3c9$export$d4acacb597c5b32b({ data: data, editable: editable, index: index, onEdited: onEdited, removeDevice: removeDevice, devices: devices }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const namePrefix = `devices.${devices}[${index}].`;
    const _state = (0, $60bb38810c6aeae8$export$ccf74b7adff24162)();
    const [deviceType, setDeviceType] = (0, $acw62.useState)(data.deviceType);
    const predefinedTypes = {
        "nautical": [
            "analogue_compass",
            "gyro_compass",
            "fluxgate_compass",
            "satellite_compass",
            "chart_plotter",
            "gps",
            "ais",
            "radio",
            "antenna",
            "radar",
            "wind_gauge",
            "autopilot",
            "display_instruments",
            "fuel_gauge",
            "battery_controller",
            "hour_meter",
            "tachometer",
            "logger",
            "sounder",
            "air_temperature",
            "barometer",
            "humidity",
            "weather_receiver",
            "nmea_gateway",
            "nmea_motor_adapter"
        ].toSorted(),
        "electric": [
            "battery",
            "inverter",
            "charger",
            "wind_generator",
            "solar_panel"
        ].toSorted(),
        "safety": [
            "fire_extinguisher",
            "liferaft",
            "lifejacket",
            "lifebelt",
            "lifeline",
            "spare_propeller",
            "emergency_tiller",
            "bilge_pump_manual",
            "bilge_pump_electric",
            "shroud_cutter",
            "radar_reflector",
            "first_aid",
            "fire_blanket",
            "dinghy",
            "dinghy_motor",
            "handheld_radio",
            "epirb"
        ].toSorted()
    }[devices] || [];
    const selectDeviceType = (0, $acw62.useCallback)((value)=>{
        setDeviceType(value);
        if (onEdited) onEdited();
    }, []);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $668fda0e05396ea5$export$24b1434c0559e42f), {
        namePrefix: namePrefix,
        id: data.id,
        rowClassName: "device-fields-row",
        onRemove: removeDevice,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("device"),
                className: "block_field_small_16",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $00c02b94fd6b341a$export$c6f462c9dfb8e86b), {
                    value: deviceType,
                    predefined: predefinedTypes,
                    label: (v)=>t(`device_${devices}_${v}`),
                    customValue: t("other"),
                    name: `${namePrefix}deviceType`,
                    onSelect: selectDeviceType,
                    readOnly: !editable,
                    sort: true
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("manufacturer"),
                className: "block_field_small_18",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}manufacturer`,
                    onChange: onEdited,
                    defaultValue: data.manufacturer,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("model"),
                className: "block_field_small_18",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}model`,
                    onChange: onEdited,
                    defaultValue: data.model,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("serial_number"),
                className: "block_field_small_18",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}serialNumber`,
                    onChange: onEdited,
                    defaultValue: data.serialNumber,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("date_installation"),
                className: "block_field_small_12",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}dateInstallation`,
                    onChange: onEdited,
                    defaultValue: data.dateInstallation,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("place_installation"),
                className: "block_field_small_22",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}placeInstallation`,
                    onChange: onEdited,
                    defaultValue: data.placeInstallation,
                    readOnly: !editable
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                label: t("special_features"),
                className: "block_field_small_20",
                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                    name: `${namePrefix}specialFeatures`,
                    onChange: onEdited,
                    defaultValue: data.specialFeatures,
                    readOnly: !editable
                })
            })
        ]
    });
}






function $491ad39515735401$export$e8c676e34b47e88d({ data: data, editable: editable, index: index, onEdited: onEdited, removeEquipment: removeEquipment }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const _t = app.getT("ShipDataView");
    const namePrefix = `otherEquipments[${index}].`;
    const formEditable = editable;
    return (0, $7b02d682eb115277$exports.jsx)((0, $668fda0e05396ea5$export$24b1434c0559e42f), {
        namePrefix: namePrefix,
        id: data.id,
        rowClassName: "block-row-last",
        onRemove: removeEquipment,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
            children: (0, $7b02d682eb115277$exports.jsx)("textarea", {
                name: `${namePrefix}equipment`,
                defaultValue: data.equipment,
                rows: 4,
                readOnly: !formEditable,
                onChange: onEdited
            })
        })
    });
}


function $e0638b57342db67a$export$c1bd6f068fbc80a5(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipDataView");
    const { editable: editable, edited: edited, onEdited: onEdited, save: save, deviceTypes: deviceTypes, devices: devices, addDevice: addDevice, removeDevice: removeDevice, editAnchor: editAnchor, editOtherEquipment: editOtherEquipment } = (0, $60bb38810c6aeae8$export$ccf74b7adff24162)();
    return (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
        changed: edited,
        editable: editable,
        editableFields: [
            {
                name: "devices",
                type: "object",
                fields: deviceTypes.map((type)=>{
                    return {
                        name: type,
                        type: "object",
                        array: true,
                        fields: [
                            "id",
                            "deviceType",
                            "manufacturer",
                            "model",
                            "serialNumber",
                            "placeInstallation",
                            "dateInstallation",
                            "specialFeatures"
                        ]
                    };
                })
            },
            {
                name: "anchors",
                type: "object",
                array: true,
                fields: [
                    "id",
                    "anchorType",
                    {
                        name: "weight",
                        type: "int"
                    },
                    "weightUnit",
                    "placeInstallation",
                    "chain",
                    "chainLead",
                    "windlass",
                    "windlassDrive",
                    "windlassManufacturer"
                ]
            },
            {
                name: "otherEquipments",
                type: "object",
                array: true,
                fields: [
                    "id",
                    "equipment"
                ]
            }
        ],
        onSave: save,
        children: [
            deviceTypes.map((type)=>(0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: t(`${type}_equipment`)
                                })
                            }),
                            (devices[type] || []).map((device, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $23b8b0be4da3c3c9$export$d4acacb597c5b32b), {
                                    data: device,
                                    editable: editable,
                                    index: index,
                                    onEdited: onEdited,
                                    removeDevice: ()=>{
                                        removeDevice(type, index);
                                        onEdited();
                                    },
                                    devices: type
                                }, device.id)),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                    children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "button",
                                        disabled: !editable,
                                        onClick: ()=>{
                                            addDevice(type);
                                            onEdited();
                                        },
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                            }),
                                            " ",
                                            t(`${type}_add_device`)
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }, type)),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: t("anchors")
                            })
                        }),
                        editAnchor.items.map((anchor, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $b65a0166dc685ef9$export$f91e850a9eed2440), {
                                data: anchor,
                                editable: editable,
                                index: index,
                                onEdited: onEdited,
                                removeAnchor: ()=>{
                                    editAnchor.removeAt(index);
                                    onEdited();
                                }
                            }, anchor.id)),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "button",
                                    disabled: !editable,
                                    onClick: ()=>{
                                        editAnchor.add();
                                        onEdited();
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                        }),
                                        " ",
                                        t("add_anchor")
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: t("other_equipment")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: t("other_equipment_text")
                        }),
                        editOtherEquipment.items.map((otherEquipment, index)=>(0, $7b02d682eb115277$exports.jsx)((0, $491ad39515735401$export$e8c676e34b47e88d), {
                                data: otherEquipment,
                                editable: editable,
                                index: index,
                                onEdited: onEdited,
                                removeEquipment: ()=>{
                                    editOtherEquipment.removeAt(index);
                                    onEdited();
                                }
                            }, otherEquipment.id)),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: "button",
                                    disabled: !editable,
                                    onClick: ()=>{
                                        editOtherEquipment.add();
                                        onEdited();
                                    },
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                        }),
                                        " ",
                                        t("add_other_equipment")
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");




var $07bb4d3e619ce4e3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// Project a crew update onto the stored row. `userId: null` is a wire sentinel meaning
// "re-issue the invitation" (the route detaches the account), which the stored `IShipUser`
// spells as an absent `userId` — so the optimistic row must carry `undefined`, not the
// `null` that only the request body understands.
function $07bb4d3e619ce4e3$var$optimisticShipUser(current, values) {
    const { userId: userId } = values, rest = $07bb4d3e619ce4e3$var$__rest(values, [
        "userId"
    ]);
    return Object.assign(Object.assign(Object.assign({}, current), rest), {
        userId: userId === undefined ? current.userId : userId !== null && userId !== void 0 ? userId : undefined
    });
}
function $07bb4d3e619ce4e3$export$2553e9561197f729(store, ids) {
    const { shipId: shipId } = ids;
    return {
        createShipUser (values) {
            return store.mutate({
                request: (client)=>new (0, $3901b1e83708ce40$export$2a63ac7615f78125)(client).shipUsers.create({
                        params: {
                            shipId: shipId
                        },
                        body: values
                    }).call(),
                reconcile: (r)=>({
                        entities: {
                            ShipUser: [
                                r.user
                            ]
                        }
                    })
            });
        },
        updateShipUser (userId, values) {
            const current = store.getEntity((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).ShipUser, userId);
            const optimistic = current ? {
                upsert: {
                    ShipUser: [
                        $07bb4d3e619ce4e3$var$optimisticShipUser(current, values)
                    ]
                }
            } : undefined;
            return store.mutate({
                optimistic: optimistic,
                request: (client)=>new (0, $3901b1e83708ce40$export$2a63ac7615f78125)(client).shipUsers.update({
                        params: {
                            shipId: shipId,
                            userId: userId
                        },
                        body: values
                    }).call(),
                reconcile: (r)=>({
                        entities: {
                            ShipUser: [
                                r.user
                            ]
                        }
                    })
            });
        },
        removeShipUser (userId) {
            return store.mutate({
                optimistic: {
                    remove: {
                        ShipUser: [
                            userId
                        ]
                    }
                },
                request: (client)=>new (0, $3901b1e83708ce40$export$2a63ac7615f78125)(client).shipUsers.delete({
                        params: {
                            shipId: shipId,
                            userId: userId
                        }
                    }).call()
            });
        }
    };
}
// Inert crew writers for harnesses/tests that render a crew subtree but never exercise a
// write (the real variants provide working writers). Each rejects loudly if unexpectedly
// called, so an accidental save/delete in a read-only fixture surfaces rather than silently
// no-opping.
const $07bb4d3e619ce4e3$var$rejectNoop = (name)=>()=>Promise.reject(new Error(`noopShipUserWriters.${name}: no writer provided (read-only crew context)`));
const $07bb4d3e619ce4e3$export$5ad138bef1848df9 = {
    createShipUser: $07bb4d3e619ce4e3$var$rejectNoop("createShipUser"),
    updateShipUser: $07bb4d3e619ce4e3$var$rejectNoop("updateShipUser"),
    removeShipUser: $07bb4d3e619ce4e3$var$rejectNoop("removeShipUser")
};


const { Context: $854f161a5f0afed1$export$898f7c6c0dea8370, useData: $854f161a5f0afed1$export$763af51df93cfa0 } = (0, $480db5fef2358c2d$export$1f628e93c0b28291)("ShipDataUsersView");
function $854f161a5f0afed1$export$9c009eba1d6ffad3(shipId) {
    const ctx = (0, $acw62.useContext)($854f161a5f0afed1$export$898f7c6c0dea8370);
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    return (0, $acw62.useMemo)(()=>{
        if (ctx === null || ctx === void 0 ? void 0 : ctx.writers) return ctx.writers;
        return (0, $07bb4d3e619ce4e3$export$2553e9561197f729)(store, {
            shipId: shipId
        });
    }, [
        ctx === null || ctx === void 0 ? void 0 : ctx.writers,
        store,
        shipId
    ]);
}


// Group + sort a crew roster. `undefined` (roster not yet loaded in the Legacy path)
// yields empty groups so callers can gate a `<Loading/>` on `shipUsers === undefined`
// separately from an empty-but-loaded roster.
function $321413a03737d44e$export$ba9d568718ce428d(shipUsers) {
    if (!shipUsers) return {
        sorted: [],
        leveled: [],
        unleveled: []
    };
    const sorted = shipUsers.toSorted((a, b)=>{
        if (b.active !== a.active) return b.active - a.active;
        if (b.shipUserCrewRole !== a.shipUserCrewRole) return b.shipUserCrewRole - a.shipUserCrewRole;
        return (a.name || "").localeCompare(b.name || "");
    });
    const leveled = sorted.filter((user)=>user.shipUserLevel >= 1).sort((a, b)=>{
        if (b.shipUserLevel !== a.shipUserLevel) return b.shipUserLevel - a.shipUserLevel;
        if (b.active !== a.active) return b.active - a.active;
        if (b.shipUserCrewRole !== a.shipUserCrewRole) return b.shipUserCrewRole - a.shipUserCrewRole;
        return (a.name || "").localeCompare(b.name || "");
    });
    const unleveled = sorted.filter((user)=>user.shipUserLevel < 1).sort((a, b)=>{
        if (b.active !== a.active) return b.active - a.active;
        if (b.shipUserCrewRole !== a.shipUserCrewRole) return b.shipUserCrewRole - a.shipUserCrewRole;
        return (a.name || "").localeCompare(b.name || "");
    });
    return {
        sorted: sorted,
        leveled: leveled,
        unleveled: unleveled
    };
}



const $e890bbb35cfa507d$export$94c57bd52e57637e = (0, $a9e25f5507c22ba4$export$a23f992de0d45ff0)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).Ship, {
    users: (0, $9db39e34b2fb118a$export$14badfee79ea396f)((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).ShipUser)
});
function $e890bbb35cfa507d$export$d501c5795cbdf590({ children: children }) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    // Annotated with the declaration's own id contract so the key is checked against its
    // FK fields (a wide `BoundIds` would accept anything).
    const ids = {
        shipId: ship.id
    };
    const { users: users } = (0, $e9db94b1c3310c7c$export$a37ae8cf05d96586)($e890bbb35cfa507d$export$94c57bd52e57637e, ids);
    // `useDeps` returns readonly snapshots; the roster contract is a mutable array. Cast
    // without copying to preserve referential stability -- consumers never mutate it.
    const shipUsers = users;
    const groups = (0, $acw62.useMemo)(()=>(0, $321413a03737d44e$export$ba9d568718ce428d)(shipUsers), [
        shipUsers
    ]);
    const writers = (0, $acw62.useMemo)(()=>(0, $07bb4d3e619ce4e3$export$2553e9561197f729)(store, {
            shipId: ship.id
        }), [
        store,
        ship.id
    ]);
    const value = {
        shipUsers: shipUsers,
        leveledShipUsers: groups.leveled,
        unleveledShipUsers: groups.unleveled,
        writers: writers
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $854f161a5f0afed1$export$898f7c6c0dea8370).Provider, {
        value: value,
        children: children
    });
}







// Barrel for the ShipUser view family. The implementation lives in ./ShipUser/*;
// this root file re-exports the public symbols so existing importers
// (Views/ShipData/UsersView, the ShipDataView test mock, the flat ShipUserView
// tests) keep resolving them from "./ShipUserView" unchanged.

const $41372baf8516d502$export$265c1f26c3ad42a3 = [
    "email",
    "name",
    "shortname",
    {
        name: "shipUserCrewRole",
        type: "int"
    },
    {
        name: "shipUserLevel",
        type: "int"
    }
];
const $41372baf8516d502$export$cba83d6ce876ee3 = {
    updateShipUser (api, shipId, userId, values) {
        return new (0, $3901b1e83708ce40$export$2a63ac7615f78125)(api).shipUsers.update({
            params: {
                shipId: shipId,
                userId: userId
            },
            body: values
        }).call();
    },
    createShipUser (api, shipId, values) {
        return new (0, $3901b1e83708ce40$export$2a63ac7615f78125)(api).shipUsers.create({
            params: {
                shipId: shipId
            },
            body: values
        }).call();
    },
    removeShipUser (api, shipId, userId) {
        return new (0, $3901b1e83708ce40$export$2a63ac7615f78125)(api).shipUsers.delete({
            params: {
                shipId: shipId,
                userId: userId
            }
        }).call();
    }
};




var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");





function $eaa33bfb3b75acac$export$c990e8baeb15ff6b({ user: user }) {
    var _a, _b, _c, _d;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipSettingsView");
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    // Crew writes go through the enclosing UsersView's store-backed optimistic writer
    // boundary, falling back to typed-REST when this edit view renders outside one
    // (standalone catalog/tests). (issue #1186)
    const writers = (0, $854f161a5f0afed1$export$9c009eba1d6ffad3)(ship.id);
    const [edited, markEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const [draft, setDraft] = (0, $acw62.useState)({
        name: (_a = user.name) !== null && _a !== void 0 ? _a : "",
        shortname: (_b = user.shortname) !== null && _b !== void 0 ? _b : ""
    });
    const revision = (0, $acw62.useRef)(0);
    const onEdited = (0, $acw62.useCallback)((event)=>{
        const field = event === null || event === void 0 ? void 0 : event.target.name;
        const value = event === null || event === void 0 ? void 0 : event.target.value;
        setDraft((previous)=>{
            var _a, _b;
            return Object.assign(Object.assign({}, edited ? previous : {
                name: (_a = user.name) !== null && _a !== void 0 ? _a : "",
                shortname: (_b = user.shortname) !== null && _b !== void 0 ? _b : ""
            }), field === "name" || field === "shortname" ? {
                [field]: value !== null && value !== void 0 ? value : ""
            } : {});
        });
        revision.current += 1;
        markEdited();
    }, [
        edited,
        markEdited,
        user.name,
        user.shortname
    ]);
    const updateShipUserActive = (0, $acw62.useCallback)(async (active)=>{
        await writers.updateShipUser(user.id, {
            active: active ? 1 : 0
        });
    }, [
        writers,
        user
    ]);
    const removeShipUser = (0, $acw62.useCallback)(async ()=>{
        await writers.removeShipUser(user.id);
    }, [
        writers,
        user
    ]);
    const updateShipUser = (0, $acw62.useCallback)(async (data, values)=>{
        var _a, _b;
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("updateShipUser", user.id);
        const savingRevision = revision.current;
        // Omit absent levels and unchanged inherited names: neither is a ship override.
        const name = data.get("name");
        const shortname = data.get("shortname");
        const update = Object.assign(Object.assign(Object.assign(Object.assign({}, typeof name === "string" && name !== ((_a = user.name) !== null && _a !== void 0 ? _a : "") ? {
            name: name
        } : {}), typeof shortname === "string" && shortname !== ((_b = user.shortname) !== null && _b !== void 0 ? _b : "") ? {
            shortname: shortname
        } : {}), typeof values.shipUserCrewRole === "number" && values.shipUserCrewRole !== user.shipUserCrewRole ? {
            shipUserCrewRole: values.shipUserCrewRole
        } : {}), typeof values.shipUserLevel === "number" && values.shipUserLevel !== user.shipUserLevel ? {
            shipUserLevel: values.shipUserLevel
        } : {});
        try {
            await writers.updateShipUser(user.id, update);
        } catch (error) {
            resetEdited();
            throw error;
        }
        if (revision.current === savingRevision) resetEdited();
    }, [
        writers,
        user,
        resetEdited
    ]);
    const { name: name, shortname: shortname } = edited ? draft : {
        name: (_c = user.name) !== null && _c !== void 0 ? _c : "",
        shortname: (_d = user.shortname) !== null && _d !== void 0 ? _d : ""
    };
    return {
        app: app,
        t: t,
        edited: edited,
        name: name,
        shortname: shortname,
        onEdited: onEdited,
        updateShipUser: updateShipUser,
        updateShipUserActive: updateShipUserActive,
        removeShipUser: removeShipUser
    };
}




var $acw62 = parcelRequire("acw62");










function $c4084400ee087bd7$export$20a4f19bb357696f({ ship: ship, user: user, editable: editable, shipUserCrewRoleOptions: shipUserCrewRoleOptions, shipUserLevelOptions: shipUserLevelOptions, onClose: onClose, t: t }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    // Route the re-invite (PUT) through the flag-selected writer boundary (falls back to
    // typed-REST when rendered standalone, outside a UsersView provider). (issue #1186)
    const writers = (0, $854f161a5f0afed1$export$9c009eba1d6ffad3)(ship.id);
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const inviteShipUser = (0, $acw62.useCallback)(async (_data, values)=>{
        var _a;
        if (!user) return;
        // The server auto-dispatches PUT to a re-invite when userId is null and an email
        // is supplied (see reinviteShipUser) -- this row's own userId was cleared by a
        // prior deactivate/cascade, so this is always the re-invite path.
        try {
            const result = await writers.updateShipUser(user.id, values);
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("inviteShipUser result", (_a = result.user) === null || _a === void 0 ? void 0 : _a.id);
            if (result.user) {
                resetEdited();
                onClose();
            } else (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("No user returned from API");
        } catch (err) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("inviteShipUser failed", err);
        }
    }, [
        writers,
        user,
        onClose,
        resetEdited
    ]);
    if (!user) return null;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        closeCallback: onClose,
        closeBackground: true,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$fe53879cede8fc3), {
                title: t("user_invite_title"),
                closeCallback: onClose
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                changed: edited,
                editableFields: (0, $41372baf8516d502$export$265c1f26c3ad42a3),
                manualSave: true,
                hideButton: true,
                onSave: inviteShipUser,
                className: "Overlay-body",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("user_name"),
                                className: "block_field_small_22_fix",
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    value: user.name,
                                    readOnly: true
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("user_shortname"),
                                className: "block_field_small_12",
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    value: user.shortname,
                                    readOnly: true
                                })
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("user_crew_role"),
                                className: "block_field_small_10",
                                children: (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    className: "",
                                    defaultValue: user.shipUserCrewRole,
                                    name: "shipUserCrewRole",
                                    onChange: onEdited,
                                    disabled: !editable,
                                    children: [
                                        shipUserCrewRoleOptions,
                                        (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).legacyCrewRoleOption(t, user.shipUserCrewRole)
                                    ]
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("ship_user_level"),
                                className: "block_field_small_22_fix",
                                children: (0, $7b02d682eb115277$exports.jsx)("select", {
                                    className: "",
                                    defaultValue: user.shipUserLevel,
                                    name: "shipUserLevel",
                                    onChange: onEdited,
                                    disabled: !editable,
                                    children: shipUserLevelOptions
                                })
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("user_email"),
                            className: "block_field_small_32",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: "email",
                                onChange: onEdited,
                                required: true
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("language"),
                            className: "block_field_small_32",
                            children: (0, $7b02d682eb115277$exports.jsx)("select", {
                                name: "language",
                                defaultValue: app.language,
                                onChange: onEdited,
                                disabled: !editable,
                                children: Object.keys((0, $0258f51bf6f9f9d6$export$b6fc69901997e05).Languages).map((lang)=>(0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: lang,
                                        children: t(`lang_${lang}`)
                                    }, lang))
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        actions: true,
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {}),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "button",
                                        onClick: onClose,
                                        children: t("cancel")
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button default",
                                        type: "submit",
                                        children: t("user_invite")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, user.id)
        ]
    });
}


function $0f6e198a7d9c2fb8$export$6f92aa7dbf52d548({ editable: editable, shipUserCrewRoleOptions: shipUserCrewRoleOptions, shipUserLevelOptions: shipUserLevelOptions, showLabels: showLabels = false, user: user, ship: ship }) {
    var _a;
    const { app: app, t: t, edited: edited, name: name, shortname: shortname, onEdited: onEdited, updateShipUser: updateShipUser, updateShipUserActive: updateShipUserActive, removeShipUser: removeShipUser } = (0, $eaa33bfb3b75acac$export$c990e8baeb15ff6b)({
        user: user
    });
    const [showInviteOverlay, setShowInviteOverlay] = (0, $acw62.useState)(false);
    const [pendingAction, setPendingAction] = (0, $acw62.useState)(undefined);
    const [crewRole, setCrewRole] = (0, $acw62.useState)(user.shipUserCrewRole);
    const handleCrewRoleChange = (e)=>{
        const newRole = parseInt(e.target.value);
        setCrewRole(newRole);
        onEdited(e);
    };
    const cancelPendingAction = (0, $acw62.useCallback)(()=>setPendingAction(undefined), []);
    const confirmPendingAction = (0, $acw62.useCallback)(async ()=>{
        if (pendingAction === "deactivate") await updateShipUserActive(false);
        else if (pendingAction === "remove") await removeShipUser();
        setPendingAction(undefined);
    }, [
        pendingAction,
        updateShipUserActive,
        removeShipUser
    ]);
    // `status` is a client-only virtual field (@typegen-field): the server never sends it,
    // so any real ship-user loaded from the wire has `status: undefined`. Derive it here
    // instead of trusting the incoming field, so the roster shows a real "Invited" vs
    // "Active" badge.
    const status = user.active > 0 ? (0, $dc7739d612f0c536$export$f6281b7393722b1c).active : (0, $dc7739d612f0c536$export$f6281b7393722b1c).invited;
    const isPrimarySelf = user.shipUserLevel === (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary && user.userId === ((_a = app.user) === null || _a === void 0 ? void 0 : _a.id);
    // #1025 (tracker #827): reactivating a row whose `userId` link was cleared (by a prior manual
    // deactivate or the AccountUser cascade) needs a fresh invite -- it has lost its
    // only path back to a user. A still-pending invite (userId set, not yet accepted)
    // keeps the old direct "Activate" behavior.
    const isOrphaned = user.userId == null;
    // #1025: the DELETE /ships/:shipId/users/:userId route (#978's cancel-invite route,
    // repurposed here as the general "remove" action) is registered server-only --
    // no local/app route exists, mirroring AccountUser management already being
    // gated to app.cloudSession() only. So unlike Deactivate/Activate/Reactivate
    // (which reach the shared shipUserResponse() helper via either target), Remove
    // is only offered on a cloud session.
    const canRemove = app.cloudSession();
    const menuItems = [
        // #331: warn before deactivating any ship-user in this (already leveled-only)
        // list -- deactivating can cascade to clear the linked account's ship access.
        ...user.active > 0 ? [
            {
                id: "user_inactive",
                onClick: ()=>{
                    setPendingAction("deactivate");
                    return true;
                },
                title: t("user_inactive")
            }
        ] : [],
        ...user.active < 1 && !isOrphaned ? [
            {
                id: "user_active",
                onClick: ()=>{
                    updateShipUserActive(true);
                    return true;
                },
                title: t("user_active")
            }
        ] : [],
        ...user.active < 1 && isOrphaned ? [
            {
                id: "user_reactivate",
                onClick: ()=>{
                    setShowInviteOverlay(true);
                    return true;
                },
                title: t("user_reactivate")
            }
        ] : [],
        // #1025: replaces the previously-miswired "opt-out" item (labeled "Remove access" but
        // wired to open InviteUserOverlay for no functional reason) with a real soft-delete,
        // offered regardless of active state (mirrors AccountUser/#979's own "always offers
        // remove" menu) whenever the DELETE route is reachable (see canRemove above).
        ...canRemove ? [
            (0, $07fea78136a1afdb$export$2b6ac906eb59b21b),
            {
                id: "remove_user",
                onClick: ()=>{
                    setPendingAction("remove");
                    return true;
                },
                title: t("remove_user")
            }
        ] : []
    ];
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                changed: edited,
                editableFields: (0, $41372baf8516d502$export$265c1f26c3ad42a3),
                onSave: updateShipUser,
                className: "editgroup_boxed",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "ShipUserEditView-1row",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "block_field_small_22_fix",
                                label: showLabels ? t("user_name") : undefined,
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: "name",
                                    value: name,
                                    onChange: onEdited,
                                    readOnly: !editable,
                                    className: user.active < 1 ? "user_deactivated" : ""
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "block_field_small_12",
                                label: showLabels ? t("user_shortname") : undefined,
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: "shortname",
                                    value: shortname,
                                    onChange: onEdited,
                                    readOnly: !editable,
                                    className: user.active < 1 ? "user_deactivated" : ""
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "block_field_small_10 status_field_desktop",
                                label: showLabels ? t("user_status") : undefined,
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: "user_status",
                                    defaultValue: t(`user_status_${status}`),
                                    readOnly: true,
                                    className: user.active < 1 ? "user_deactivated" : ""
                                })
                            }),
                            !isPrimarySelf && menuItems.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "button_user_options button_user_options_desktop ship_user_options",
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), {
                                    button: "...",
                                    buttonClass: "button",
                                    global: true,
                                    items: menuItems
                                })
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "ShipUserEditView-2row",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "block_field_small_22_fix",
                                label: showLabels ? t("ship_user_level") : undefined,
                                children: isPrimarySelf ? // A primary can never demote themselves — the server rejects it
                                // (shipUserSelfAction), so the field is shown read-only (#1215).
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    className: user.active < 1 ? "user_deactivated" : "",
                                    value: (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).userLevelText(t, user.shipUserLevel),
                                    readOnly: true
                                }) : (0, $7b02d682eb115277$exports.jsx)("select", {
                                    className: user.active < 1 ? "user_deactivated" : "",
                                    defaultValue: user.shipUserLevel,
                                    name: "shipUserLevel",
                                    onChange: onEdited,
                                    disabled: !editable,
                                    children: shipUserLevelOptions
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "block_field_small_12",
                                label: showLabels ? t("user_crew_role") : undefined,
                                children: user.shipUserCrewRole === (0, $dc7739d612f0c536$export$1e4ade51a6368243).owner ? (0, $7b02d682eb115277$exports.jsx)("input", {
                                    className: user.active < 1 ? "user_deactivated" : "",
                                    name: "shipUserCrewRole",
                                    value: (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).crewRoleText(t, user.shipUserCrewRole),
                                    readOnly: true
                                }) : (0, $7b02d682eb115277$exports.jsxs)("select", {
                                    className: user.active < 1 ? "user_deactivated" : "",
                                    value: crewRole,
                                    name: "shipUserCrewRole",
                                    onChange: handleCrewRoleChange,
                                    disabled: !editable,
                                    children: [
                                        shipUserCrewRoleOptions,
                                        (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).legacyCrewRoleOption(t, user.shipUserCrewRole)
                                    ]
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "block_field_small_10 status_field_mobile",
                                label: showLabels ? t("user_status") : undefined,
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: "user_status_mobile",
                                    defaultValue: t(`user_status_${status}`),
                                    readOnly: true,
                                    className: user.active < 1 ? "user_deactivated" : ""
                                })
                            }),
                            !isPrimarySelf && menuItems.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "button_user_options button_user_options_mobile ship_user_options",
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), {
                                    button: "...",
                                    buttonClass: "button",
                                    global: true,
                                    items: menuItems
                                })
                            })
                        ]
                    })
                ]
            }, user.id),
            showInviteOverlay && (0, $7b02d682eb115277$exports.jsx)((0, $c4084400ee087bd7$export$20a4f19bb357696f), {
                ship: ship,
                user: user,
                editable: editable,
                shipUserCrewRoleOptions: shipUserCrewRoleOptions,
                shipUserLevelOptions: shipUserLevelOptions,
                onClose: ()=>setShowInviteOverlay(false),
                t: t
            }),
            pendingAction && (0, $7b02d682eb115277$exports.jsx)((0, $e7bc01546cf183b2$export$2cc85109a937009e), {
                awaitConfirm: true,
                title: t(`user_${pendingAction}_confirm_title`),
                message: t(`user_${pendingAction}_confirm_message`),
                confirmLabel: t(`user_${pendingAction}_confirm_accept`),
                cancelLabel: t(`user_${pendingAction}_confirm_cancel`),
                style: "alarm",
                onConfirm: confirmPendingAction,
                onCancel: cancelPendingAction
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");








function $3a8cdc5494779bac$export$2d279d8ac5679355({ editable: editable, shipUserCrewRoleOptions: shipUserCrewRoleOptions, shipUserLevelOptions: shipUserLevelOptions, showLabels: showLabels = false, user: user, ship: ship }) {
    var _a;
    const { app: app, t: t, edited: edited, name: name, shortname: shortname, onEdited: onEdited, updateShipUser: updateShipUser, updateShipUserActive: updateShipUserActive } = (0, $eaa33bfb3b75acac$export$c990e8baeb15ff6b)({
        user: user
    });
    const [showInviteOverlay, setShowInviteOverlay] = (0, $acw62.useState)(false);
    const _handleInvite = (0, $acw62.useCallback)(async ()=>{
        await updateShipUserActive(false);
        setShowInviteOverlay(false);
    }, [
        updateShipUserActive
    ]);
    const isPrimarySelf = user.shipUserLevel === (0, $dc7739d612f0c536$export$fe876bf720d558fa).primary && user.userId === ((_a = app.user) === null || _a === void 0 ? void 0 : _a.id);
    const menuItems = [
        ...user.active > 0 && !user.userId ? [
            {
                id: "user_inactive",
                onClick: ()=>{
                    updateShipUserActive(false);
                    return true;
                },
                title: t("user_inactive")
            }
        ] : [],
        ...user.active < 1 ? [
            {
                id: "user_active",
                onClick: ()=>{
                    updateShipUserActive(true);
                    return true;
                },
                title: t("user_active")
            }
        ] : []
    ];
    return (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
        changed: edited,
        editableFields: (0, $41372baf8516d502$export$265c1f26c3ad42a3),
        onSave: updateShipUser,
        className: "editgroup_boxed",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "ShipUserEditView-row",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        className: "block_field_small_22_fix",
                        label: showLabels ? t("user_name") : undefined,
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: "name",
                            value: name,
                            onChange: onEdited,
                            readOnly: !editable,
                            className: user.active < 1 ? "user_deactivated" : ""
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        className: "block_field_small_10",
                        label: showLabels ? t("user_shortname") : undefined,
                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                            name: "shortname",
                            value: shortname,
                            onChange: onEdited,
                            readOnly: !editable,
                            className: user.active < 1 ? "user_deactivated" : ""
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        className: "block_field_small_10",
                        label: showLabels ? t("user_crew_role") : undefined,
                        children: (0, $7b02d682eb115277$exports.jsxs)("select", {
                            className: user.active < 1 ? "user_deactivated" : "",
                            defaultValue: user.shipUserCrewRole,
                            name: "shipUserCrewRole",
                            onChange: onEdited,
                            disabled: !editable,
                            children: [
                                shipUserCrewRoleOptions,
                                (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).legacyCrewRoleOption(t, user.shipUserCrewRole)
                            ]
                        })
                    }),
                    !isPrimarySelf && menuItems.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        className: "button_user_options user_options",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), {
                            button: "...",
                            buttonClass: "button",
                            global: true,
                            items: menuItems
                        })
                    })
                ]
            }),
            showInviteOverlay && (0, $7b02d682eb115277$exports.jsx)((0, $c4084400ee087bd7$export$20a4f19bb357696f), {
                ship: ship,
                user: user,
                editable: editable,
                shipUserCrewRoleOptions: shipUserCrewRoleOptions,
                shipUserLevelOptions: shipUserLevelOptions,
                onClose: ()=>setShowInviteOverlay(false),
                t: t
            })
        ]
    }, user.id);
}




var $acw62 = parcelRequire("acw62");







function $f229eed0af343dc5$export$a6f1a78c0dc1fc8({ ship: ship, user: user, editable: editable, shipUserCrewRoleOptions: shipUserCrewRoleOptions, shipUserLevelOptions: shipUserLevelOptions, hideTypeSelection: hideTypeSelection, onClose: onClose, t: t }) {
    // Route the create through the flag-selected writer boundary (falls back to typed-REST when
    // rendered standalone, outside a UsersView provider). (issue #1186)
    const writers = (0, $854f161a5f0afed1$export$9c009eba1d6ffad3)(ship.id);
    const [edited, onEdited, _resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const [userType, setUserType] = (0, $acw62.useState)((user === null || user === void 0 ? void 0 : user.shipUserLevel) || 0);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const createShipUser = (0, $acw62.useCallback)(async (_data, values)=>{
        var _a;
        const result = await writers.createShipUser(values);
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("createShipUser result", (_a = result.user) === null || _a === void 0 ? void 0 : _a.id);
        if (result.user) onClose();
        else (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("No user returned from API");
    }, [
        writers,
        onClose
    ]);
    const handleUserTypeChange = (level)=>{
        setUserType(level);
        // Simulate an event to update the parent state
        onEdited();
    };
    return (0, $7b02d682eb115277$exports.jsxs)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        closeCallback: onClose,
        closeBackground: true,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$fe53879cede8fc3), {
                title: t("add_user"),
                closeCallback: onClose
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Overlay-body",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                    changed: edited,
                    editableFields: (0, $41372baf8516d502$export$265c1f26c3ad42a3),
                    manualSave: true,
                    hideButton: true,
                    onSave: createShipUser,
                    className: "editgroup_boxed",
                    children: [
                        !hideTypeSelection && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("add_user_without_permissions"),
                                        labelAfter: true,
                                        labelFor: `user_type_0`,
                                        className: "bigger",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "radio",
                                            id: "user_type_0",
                                            name: "user_type",
                                            checked: userType === 0,
                                            onChange: ()=>handleUserTypeChange(0)
                                        })
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("add_user_with_permissions"),
                                        labelAfter: true,
                                        labelFor: `user_type_1`,
                                        className: "bigger",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "radio",
                                            id: "user_type_1",
                                            name: "user_type",
                                            checked: userType === 1,
                                            onChange: ()=>handleUserTypeChange(1)
                                        })
                                    })
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("user_name"),
                                    className: "block_field_small_22_fix ",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        name: "name",
                                        onChange: onEdited,
                                        required: true
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("user_shortname"),
                                    className: "block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        name: "shortname",
                                        onChange: onEdited,
                                        maxLength: 10,
                                        required: true
                                    })
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("user_crew_role"),
                                    className: "block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)("select", {
                                        className: "",
                                        name: "shipUserCrewRole",
                                        onChange: onEdited,
                                        children: shipUserCrewRoleOptions
                                    })
                                }),
                                userType === 1 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("ship_user_level"),
                                    className: "block_field_small_22_fix",
                                    children: (0, $7b02d682eb115277$exports.jsx)("select", {
                                        className: "",
                                        name: "shipUserLevel",
                                        defaultValue: user === null || user === void 0 ? void 0 : user.shipUserLevel,
                                        onChange: onEdited,
                                        disabled: !editable,
                                        children: shipUserLevelOptions
                                    })
                                })
                            ]
                        }),
                        userType === 1 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("user_email"),
                                className: "block_field_small_32",
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    name: "email",
                                    onChange: onEdited,
                                    required: true
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            actions: true,
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {}),
                                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "button",
                                            onClick: onClose,
                                            children: t("cancel")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "button default",
                                            type: "submit",
                                            children: userType === 1 ? t("user_invite") : t("save")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, "add-user")
            })
        ]
    });
}






function $0d0b2ae321b43f75$export$447225621ebe5efe(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const ts = app.getT("ShipSettingsView");
    const { ship: ship, shipUserCrewRoleOptions: shipUserCrewRoleOptions, shipUserLevelOptions: shipUserLevelOptions, newUserOverlay: newUserOverlay, setNewUserOverlay: setNewUserOverlay, shipUsersManageable: shipUsersManageable } = (0, $60bb38810c6aeae8$export$ccf74b7adff24162)();
    const { shipUsers: shipUsers, leveledShipUsers: leveledShipUsers, unleveledShipUsers: unleveledShipUsers } = (0, $854f161a5f0afed1$export$763af51df93cfa0)();
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        children: shipUsers == undefined ? (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {}) : (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "centered_block_shipusers",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: `add_user_blockrow block-row-bottom-distance`,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        label: " ",
                        className: "button-at-input-level",
                        children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                            className: "button",
                            onClick: ()=>setNewUserOverlay(true),
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Plus
                                }),
                                " ",
                                ts("user_add_user")
                            ]
                        })
                    })
                }),
                newUserOverlay && (0, $7b02d682eb115277$exports.jsx)((0, $f229eed0af343dc5$export$a6f1a78c0dc1fc8), {
                    ship: ship,
                    editable: shipUsersManageable,
                    hideTypeSelection: !app.hasFeature("multi-user"),
                    shipUserCrewRoleOptions: shipUserCrewRoleOptions,
                    shipUserLevelOptions: shipUserLevelOptions,
                    onClose: ()=>{
                        setNewUserOverlay(false);
                    },
                    t: ts
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: ts("users_with_level")
                            })
                        }),
                        leveledShipUsers.length > 0 && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    className: "ShipUserEditView-header",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "block-field block_field_small_22_fix",
                                            children: ts("user_name")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "block-field block_field_small_10",
                                            children: ts("user_shortname")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "block-field block_field_small_10 status_field_desktop",
                                            children: ts("user_status")
                                        })
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    className: "ShipUserEditView-header ShipUserEditView-2row",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "block-field block_field_small_22_fix",
                                            children: ts("ship_user_level")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "block-field block_field_small_10",
                                            children: ts("user_crew_role")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "block-field block_field_small_10 status_field_mobile",
                                            children: ts("user_status")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "block-field button_top_distance_people",
                                            children: "\u00A0"
                                        })
                                    ]
                                })
                            ]
                        }),
                        leveledShipUsers.map((user)=>(0, $7b02d682eb115277$exports.jsx)((0, $0f6e198a7d9c2fb8$export$6f92aa7dbf52d548), {
                                editable: shipUsersManageable,
                                user: user,
                                shipUserCrewRoleOptions: shipUserCrewRoleOptions,
                                shipUserLevelOptions: shipUserLevelOptions,
                                ship: ship
                            }, user.id)),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "margin-top-large",
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: ts("users_without_level")
                            })
                        }),
                        unleveledShipUsers.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "ShipUserEditView-header",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "block-field block_field_small_22_fix",
                                        children: ts("user_name")
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "block-field block_field_small_10",
                                        children: ts("user_shortname")
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "block-field block_field_small_10",
                                        children: ts("user_crew_role")
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "block-field",
                                        children: "\u00A0"
                                    })
                                ]
                            })
                        }),
                        unleveledShipUsers.map((user)=>(0, $7b02d682eb115277$exports.jsx)((0, $3a8cdc5494779bac$export$2d279d8ac5679355), {
                                editable: shipUsersManageable,
                                user: user,
                                shipUserCrewRoleOptions: shipUserCrewRoleOptions,
                                shipUserLevelOptions: shipUserLevelOptions,
                                ship: ship
                            }, user.id))
                    ]
                })
            ]
        })
    });
}


const $52080f27312e266b$export$cd6dd08fe253caa3 = (0, $480db5fef2358c2d$export$ae24a3dd6105e285)({
    acquire: (0, $e890bbb35cfa507d$export$d501c5795cbdf590),
    ui: (0, $0d0b2ae321b43f75$export$447225621ebe5efe)
});







var $acw62 = parcelRequire("acw62");


function $e22c1b5dec398634$var$upload(api, shipId, attachment) {
    return new (0, $5ad0742384a42800$export$5cea990fb3a4e5e9)(api).noteAttachments.create({
        params: {
            shipId: shipId,
            noteId: 0
        },
        body: {
            attachment: attachment
        }
    }).call();
}
function $e22c1b5dec398634$export$86f0687b13e0c8e3(store, shipId, attachment) {
    return store.mutate({
        request: (client)=>$e22c1b5dec398634$var$upload(client, shipId, attachment),
        reconcile: (response)=>({
                entities: {
                    NoteAttachment: response.attachment ? [
                        response.attachment
                    ] : []
                }
            })
    });
}
function $e22c1b5dec398634$export$427db0f525ff849(shipId) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    return (0, $acw62.useMemo)(()=>(attachment)=>$e22c1b5dec398634$export$86f0687b13e0c8e3(store, shipId, attachment), [
        shipId,
        store
    ]);
}


function $b736cf16f29f538d$export$a51202cfc42ca7b7({ attachments: attachments, data: data, defaultSelection: defaultSelection = "general", ship: ship }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { shipCloudEditable: shipCloudEditable } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const editable = app.editable || shipCloudEditable;
    const t = app.getT("ShipDataView");
    const _ts = app.getT("ShipSettingsView");
    const vesselTypeOptions = {
        [(0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).motor]: [
            "motor-boat",
            "motor-cat",
            "motor-tri",
            "motor-yacht",
            "motor-superyacht"
        ],
        [(0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).sailing]: [
            "sailing-sloop",
            "sailing-classic",
            "sailing-ketch",
            "sailing-longkeeler",
            "sailing-cat",
            "sailing-tri"
        ]
    };
    const [selectedShipType, setSelectedShipType] = (0, $acw62.useState)(data.shipType || ((_a = vesselTypeOptions[ship.vesselType]) === null || _a === void 0 ? void 0 : _a[0]) || "motor-boat");
    const shipType = (0, $acw62.useMemo)(()=>{
        if (ship.vesselType === undefined) return undefined;
        const options = vesselTypeOptions[ship.vesselType] || [];
        return options.find((type)=>type === selectedShipType) || options[0];
    }, [
        ship,
        selectedShipType
    ]);
    const newId = (0, $9c0132826a7abb0f$export$dfeddf860e7d8422);
    const [showAttachment, setShowAttachment] = (0, $acw62.useState)(0);
    const [uploadedAttachments, setUploadedAttachments] = (0, $acw62.useState)([]);
    const displayedAttachments = (0, $acw62.useMemo)(()=>{
        const persisted = attachments || [];
        const persistedIds = new Set(persisted.map((attachment)=>attachment.id));
        return [
            ...persisted,
            ...uploadedAttachments.filter((attachment)=>!persistedIds.has(attachment.id))
        ];
    }, [
        attachments,
        uploadedAttachments
    ]);
    const engineList = (0, $c84a2e94370d0606$export$27ff714bfa22814a)(data.engines || [], ()=>({
            id: newId()
        }));
    const generatorList = (0, $c84a2e94370d0606$export$27ff714bfa22814a)(data.generators || [], ()=>({
            id: newId(),
            generatorType: "",
            manufacturer: "",
            model: "",
            serialNumber: "",
            power: undefined,
            fuelType: "",
            comment: ""
        }));
    const insuranceList = (0, $c84a2e94370d0606$export$27ff714bfa22814a)(data.insurances || [], ()=>({
            id: newId(),
            insuranceType: "",
            insuranceCompany: "",
            insuranceNumber: ""
        }));
    const sailList = (0, $c84a2e94370d0606$export$27ff714bfa22814a)(data.sails || [], ()=>({
            id: newId(),
            sail: "",
            sailType: "",
            size: undefined,
            manufacturer: "",
            comment: ""
        }));
    const tankList = (0, $c84a2e94370d0606$export$27ff714bfa22814a)(data.tanks || [], ()=>({
            id: newId(),
            tankType: "",
            capacity: undefined,
            placeInstallation: "",
            comment: ""
        }));
    const anchorList = (0, $c84a2e94370d0606$export$27ff714bfa22814a)(data.anchors || [], ()=>({
            id: newId(),
            anchorType: "",
            weight: undefined,
            placeInstallation: "",
            chain: "",
            chainLead: "",
            windlass: "",
            windlassDrive: "",
            windlassManufacturer: ""
        }));
    const steeringSystemList = (0, $c84a2e94370d0606$export$27ff714bfa22814a)(data.steeringSystems || [], ()=>({
            id: newId(),
            steeringType: "",
            power: undefined,
            manufacturer: "",
            model: "",
            comment: ""
        }));
    const otherEquipmentList = (0, $c84a2e94370d0606$export$27ff714bfa22814a)(data.otherEquipments || [], ()=>({
            id: newId(),
            equipment: ""
        }));
    const rigElementList = (0, $c84a2e94370d0606$export$27ff714bfa22814a)(data.rigElements || [], ()=>({
            id: newId(),
            rigElement: "",
            manufacturer: "",
            model: "",
            size: undefined,
            serialNumber: "",
            comment: "",
            placeInstallation: ""
        }));
    const formEditable = app.editable;
    const [_addShipUser, _setAddShipUser] = (0, $acw62.useState)(false);
    const [newUserOverlay, , setNewUserOverlay] = (0, $5788501efbf36a87$export$ea8f71083e90600f)(false);
    const { apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const shipUsersManageable = new (0, $3901b1e83708ce40$export$2a63ac7615f78125)(app.apiClient).shipUsers.create({
        params: {
            shipId: ship.id
        },
        body: {}
    }).available(apiUser);
    const settingsWriters = (0, $bf76a3a7a0d207c0$export$4bb86e129f694bc0)(ship.id);
    const uploadShipAttachment = (0, $e22c1b5dec398634$export$427db0f525ff849)(ship.id);
    (0, $acw62.useEffect)(()=>{
        if (data.engines) engineList.setItems(data.engines);
        if (data.generators) generatorList.setItems(data.generators);
        if (data.insurances) insuranceList.setItems(data.insurances);
        if (data.sails) sailList.setItems(data.sails);
        if (data.tanks) tankList.setItems(data.tanks);
        if (data.anchors) anchorList.setItems(data.anchors);
        if (data.steeringSystems) steeringSystemList.setItems(data.steeringSystems);
        if (data.otherEquipments) otherEquipmentList.setItems(data.otherEquipments);
        if (data.rigElements) rigElementList.setItems(data.rigElements);
    }, [
        data
    ]);
    const shipUserCrewRoleOptions = (0, $acw62.useMemo)(()=>{
        const t = app.getT("ShipSettingsView");
        return (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).crewRoleOptions(t);
    }, []);
    const shipUserLevelOptions = (0, $acw62.useMemo)(()=>{
        const t = app.getT("ShipSettingsView");
        return (0, $60bb38810c6aeae8$export$aa3f292b19006b4b).userLevelOptions(t);
    }, []);
    const saveData = (0, $acw62.useCallback)(async (values, namePrefix)=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("save", namePrefix, ship.id);
        await settingsWriters.updateShipData(values);
    }, [
        settingsWriters,
        ship
    ]);
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const save = (0, $acw62.useCallback)(async (_data, values)=>{
        await saveData(values);
        resetEdited();
    }, []);
    // Insert photo upload handling (single image only)
    const [files, setFiles] = (0, $acw62.useState)([]);
    const inputRef = (0, $acw62.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const saveAttachments = (0, $acw62.useCallback)(async (_data, _values)=>{
        let nextImage = displayedAttachments.length;
        for (const file of files){
            const result = await uploadShipAttachment(file);
            const attachment = result.attachment;
            if (attachment) {
                setUploadedAttachments((current)=>[
                        ...current.filter((item)=>item.id !== attachment.id),
                        attachment
                    ]);
                nextImage += 1;
            }
        }
        setFiles([]);
        setShowAttachment(Math.max(0, nextImage - 1));
    }, [
        files,
        displayedAttachments,
        uploadShipAttachment
    ]);
    const handleDrop = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files;
        if (droppedFiles.length > 0) // Only take the first file
        setFiles([
            droppedFiles[0]
        ]);
    }, []);
    const handleSelect = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
        if (event.target.files && event.target.files.length > 0) // Only take the first file
        setFiles([
            event.target.files[0]
        ]);
    }, []);
    const removeAttachment = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
        setFiles([]);
    }, []);
    // Definition for devices
    const deviceTypes = (0, $acw62.useMemo)(()=>[
            "electric",
            "nautical",
            "safety"
        ], []);
    const [devices, setDevices] = (0, $acw62.useState)(data.devices || {});
    const addDevice = (0, $acw62.useCallback)((type)=>{
        const newDevices = Object.assign(Object.assign({}, devices), {
            [type]: [
                ...devices[type] || [],
                {
                    id: newId(),
                    deviceType: ""
                }
            ]
        });
        setDevices(newDevices);
    }, [
        devices,
        setDevices
    ]);
    const removeDevice = (0, $acw62.useCallback)((type, index)=>{
        const newDevices = Object.assign(Object.assign({}, devices), {
            [type]: [
                ...devices[type].filter((_, i)=>i != index)
            ]
        });
        setDevices(newDevices);
    }, [
        devices,
        setDevices
    ]);
    // Set the selctions lists for units
    const state = {
        data: data,
        ship: ship,
        attachments: displayedAttachments,
        editable: editable,
        formEditable: formEditable,
        edited: edited,
        onEdited: onEdited,
        save: save,
        saveData: saveData,
        newId: newId,
        files: files,
        saveAttachments: saveAttachments,
        handleDrop: handleDrop,
        handleSelect: handleSelect,
        removeAttachment: removeAttachment,
        inputRef: inputRef,
        showAttachment: showAttachment,
        setShowAttachment: setShowAttachment,
        editInsurance: insuranceList,
        editGenerator: generatorList,
        editSail: sailList,
        editTank: tankList,
        editAnchor: anchorList,
        editSteeringSystem: steeringSystemList,
        editOtherEquipment: otherEquipmentList,
        editRigElement: rigElementList,
        editEngine: engineList,
        devices: devices,
        deviceTypes: deviceTypes,
        addDevice: addDevice,
        removeDevice: removeDevice,
        selectedShipType: selectedShipType,
        setSelectedShipType: setSelectedShipType,
        shipType: shipType,
        vesselTypeOptions: vesselTypeOptions,
        shipUserCrewRoleOptions: shipUserCrewRoleOptions,
        shipUserLevelOptions: shipUserLevelOptions,
        newUserOverlay: newUserOverlay,
        setNewUserOverlay: setNewUserOverlay,
        shipUsersManageable: shipUsersManageable
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $60bb38810c6aeae8$export$2de6107c322f2209).Provider, {
        value: state,
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "ShipDataView",
            children: (0, $7b02d682eb115277$exports.jsx)((0, $9f9e7bca499fb8dc$export$f97dc4a5a0177256), {
                defaultSelection: defaultSelection,
                tabs: [
                    {
                        name: "general",
                        title: t("tab_general"),
                        render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $bfa251d4dafb764a$export$717ca222196c0f47), {})
                    },
                    {
                        name: "details",
                        title: t("tab_details"),
                        render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $1df9d73df59e5f82$export$e0e8bec7fcaafb8d), {})
                    },
                    {
                        name: "technic",
                        title: t("tab_technic"),
                        render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $444c9877f1d0904a$export$63ec46419089393e), {})
                    },
                    {
                        name: "sailing",
                        hide: !(0, $22871482fce5b7e5$export$7930c61d9b464618).isSailingVessel(ship),
                        title: t("tab_sailing"),
                        render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $790fa7be9d39e80d$export$a0b1e39c3ea4e548), {})
                    },
                    {
                        name: "equipment",
                        title: t("tab_equipment"),
                        render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $e0638b57342db67a$export$c1bd6f068fbc80a5), {})
                    },
                    {
                        name: "tab_ship_users",
                        title: t("tab_ship_user"),
                        hide: !shipUsersManageable,
                        render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $52080f27312e266b$export$cd6dd08fe253caa3), {})
                    }
                ],
                selectedCallback: (_value)=>{
                    resetEdited();
                }
            })
        })
    });
}





var $acw62 = parcelRequire("acw62");


function $f393c9adcfcd2cd9$export$2ae47461d09f2631(shipId) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const attachments = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).NoteAttachment, {
        shipId: (0, $55c0c0d4c269af54$export$a7a0278c004aac3f)(shipId),
        noteId: 0
    });
    const [loaded, setLoaded] = (0, $acw62.useState)(false);
    (0, $9690902269ab2924$export$e4edb3e6a3489a79)([
        (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).NoteAttachment
    ], shipId !== undefined, shipId);
    (0, $acw62.useEffect)(()=>{
        if (shipId === undefined) {
            setLoaded(false);
            return;
        }
        if (store.isQueryFetched((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).NoteAttachment, {
            shipId: shipId,
            noteId: 0
        })) {
            setLoaded(true);
            return;
        }
        store.fetchQuery((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).NoteAttachment, {
            shipId: shipId,
            noteId: 0
        }).then(()=>{
            if (store.isQueryFetched((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).NoteAttachment, {
                shipId: shipId,
                noteId: 0
            })) setLoaded(true);
        });
    }, [
        shipId,
        store
    ]);
    return loaded ? [
        ...attachments
    ] : undefined;
}


const $82532a99618f300b$export$8116776e57a981e2 = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    validate (values) {
        return values.name && values.name.length > 2 && values.vesselType > 0 && values.engineCount > 0 && values.engineCount <= 5;
    }
};
function $82532a99618f300b$export$ba3b838c43b5c410({ cancelEdit: cancelEdit, initShipName: initShipName, initShipType: initShipType, initShipEngines: initShipEngines, initValidInput: initValidInput, ship: ship }) {
    var _a, _b;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const storedShip = (0, $b82e6d2a15bbd8b8$export$fab329b658bf30c7)(store, "Ship", (_a = ship === null || ship === void 0 ? void 0 : ship.id) !== null && _a !== void 0 ? _a : 0);
    const settings = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, "Settings", {
        shipId: ship === null || ship === void 0 ? void 0 : ship.id
    });
    const editShip = (0, $acw62.useMemo)(()=>storedShip ? (0, $321f7f2ee9eb9eff$export$9a45818394e32adc)(storedShip, settings) : ship, [
        storedShip,
        settings,
        ship
    ]);
    const shipData = editShip ? (0, $22871482fce5b7e5$export$7930c61d9b464618).shipData(editShip) : undefined;
    const t = app.getT("ShipEditView");
    const { navigateApp: navigateApp } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const shipView = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const setPrinting = shipView === null || shipView === void 0 ? void 0 : shipView.setPrinting;
    const [type, setType] = (0, $acw62.useState)((editShip === null || editShip === void 0 ? void 0 : editShip.vesselType) || initShipType);
    const [validInput, setValidInput] = (0, $acw62.useState)(initValidInput !== null && initValidInput !== void 0 ? initValidInput : false);
    const shipAttachments = (0, $f393c9adcfcd2cd9$export$2ae47461d09f2631)(editShip === null || editShip === void 0 ? void 0 : editShip.id);
    const editableFields = [
        "name",
        {
            name: "engineCount",
            type: "int"
        },
        {
            name: "vesselType",
            type: "int"
        }
    ];
    const newShip = app.cloudSession() && !editShip;
    const formEditable = app.cloudSession() ? newShip || shipView.shipCloudEditable : app.editable;
    (0, $9690902269ab2924$export$e4edb3e6a3489a79)([
        "Ship",
        "Settings"
    ], ship != undefined, ship === null || ship === void 0 ? void 0 : ship.id);
    (0, $acw62.useEffect)(()=>{
        if (!ship) return;
        if (!store.isQueryFetched("Ship", {
            shipId: ship.id
        })) store.fetchQuery("Ship", {
            shipId: ship.id
        }).catch(console.error);
    }, [
        store,
        ship === null || ship === void 0 ? void 0 : ship.id
    ]);
    const { edited: edited, onEdited: onEdited, saveEdits: saveEdits, validateEdits: validateEdits } = (0, $58cbd7a8fa422027$export$d3b8d51a855c78a3)({
        save: async (values, { resetEdited: resetEdited })=>{
            if (!editShip && app.cloudSession()) {
                const result = await (0, $47e36f86d10442cb$export$2ff272b52de798d0)(store, values);
                navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
                    shipId: result.ship.id
                });
            } else if (editShip) {
                await (0, $bf76a3a7a0d207c0$export$7c8f4ae02863d723)(store, {
                    shipId: editShip.id
                }).updateShipData(values);
                resetEdited();
            }
        },
        validate: (values)=>{
            const valid = $82532a99618f300b$export$8116776e57a981e2.validate(values);
            setValidInput(valid);
            return valid;
        }
    });
    const selectType = (0, $acw62.useCallback)((nextType)=>{
        setType(nextType);
        onEdited();
    }, [
        onEdited
    ]);
    const vesselOptions = [
        {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).MotorVessel,
            title: t("type_motor"),
            value: (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).motor
        },
        {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).SailingVessel,
            title: t("type_sailing"),
            value: (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).sailing
        }
    ];
    const typeButton = (_b = vesselOptions.find((option)=>option.value == type)) === null || _b === void 0 ? void 0 : _b.title;
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ShipEditView block ",
        children: [
            editShip ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ship-edit-header",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: t("title_edit", {
                                    ship: editShip.name
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "header-buttons",
                                children: [
                                    setPrinting && (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        className: "button print-button-desktop",
                                        onClick: ()=>setPrinting((0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).ship),
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Print,
                                                className: "icon-large"
                                            }),
                                            " ",
                                            t("print")
                                        ]
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                                        onClick: cancelEdit
                                    }, "close")
                                ]
                            })
                        ]
                    }),
                    setPrinting && (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "print-button-mobile",
                        children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                            className: "button",
                            onClick: ()=>setPrinting((0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).ship),
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Print,
                                    className: "icon-large"
                                }),
                                " ",
                                t("print")
                            ]
                        })
                    })
                ]
            }) : (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "new-ship-form new-ship-form-top ",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: t("title_new")
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                        message: (message)=>message.noteText.newShip,
                        className: "new-ship-message"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                buttonFirst: true,
                changed: edited,
                editable: formEditable,
                editableFields: editableFields,
                hideButton: true,
                manualSave: newShip,
                onSave: saveEdits,
                onValidate: validateEdits,
                children: newShip ? (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "new-ship-form new-ship-form-bottom",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block_field_small_30",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("name_min"),
                                className: "block_field_small_30",
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    defaultValue: initShipName || (shipData === null || shipData === void 0 ? void 0 : shipData.name),
                                    name: "name",
                                    onChange: onEdited,
                                    readOnly: !formEditable,
                                    required: true
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block_field_small_30",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("type"),
                                    className: "block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                                        button: typeButton || t("choose"),
                                        name: "vesselType",
                                        onSelect: selectType,
                                        options: vesselOptions,
                                        readOnly: false,
                                        value: type
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("engines"),
                                    className: "block_field_small_10",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                        format: "int",
                                        className: "content-right",
                                        defaultValue: (shipData === null || shipData === void 0 ? void 0 : shipData.engineCount) || initShipEngines || "",
                                        name: "engineCount",
                                        onChange: onEdited,
                                        maxLength: 1
                                    })
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            actions: true,
                            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button",
                                        onClick: cancelEdit,
                                        children: t("cancel")
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button default",
                                        disabled: !validInput,
                                        type: "submit",
                                        children: t("create")
                                    })
                                ]
                            })
                        })
                    ]
                }) : (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-one-row",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("name"),
                            className: "block_field_small_30",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                defaultValue: shipData === null || shipData === void 0 ? void 0 : shipData.name,
                                name: "name",
                                onChange: onEdited,
                                readOnly: !formEditable,
                                required: true
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("type"),
                            className: "block_field_small_10",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                                button: typeButton || t("choose"),
                                name: "vesselType",
                                onSelect: selectType,
                                options: vesselOptions,
                                readOnly: true,
                                value: type
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("engines"),
                            className: "block_field_small_10",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $e8a41dd33c25a5c0$export$6bf0cd3a219bbade), {
                                format: "int",
                                className: "content-right",
                                defaultValue: (shipData === null || shipData === void 0 ? void 0 : shipData.engineCount) || "",
                                name: "engineCount",
                                onChange: onEdited,
                                readOnly: true,
                                maxLength: 1
                            })
                        })
                    ]
                })
            }),
            editShip && shipData && (0, $7b02d682eb115277$exports.jsx)((0, $b736cf16f29f538d$export$a51202cfc42ca7b7), {
                attachments: shipAttachments,
                data: shipData,
                ship: editShip
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







function $909943c828a66da4$export$9808f770de4e3553({ ship: ship }) {
    var _a, _b;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const currentShip = (_b = (0, $b82e6d2a15bbd8b8$export$fab329b658bf30c7)(store, "Ship", (_a = ship === null || ship === void 0 ? void 0 : ship.id) !== null && _a !== void 0 ? _a : 0)) !== null && _b !== void 0 ? _b : ship;
    const t = app.getT("ShipImportView");
    const { navigateApp: navigateApp } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const inputRef = (0, $acw62.useRef)(null);
    const [uploading, setUploading] = (0, $acw62.useState)(false);
    (0, $9690902269ab2924$export$e4edb3e6a3489a79)([
        "Ship"
    ], ship != undefined, ship === null || ship === void 0 ? void 0 : ship.id);
    (0, $acw62.useEffect)(()=>{
        if (!ship) return;
        if (!store.isQueryFetched("Ship", {
            shipId: ship.id
        })) store.fetchQuery("Ship", {
            shipId: ship.id
        }).catch(console.error);
    }, [
        store,
        ship === null || ship === void 0 ? void 0 : ship.id
    ]);
    const shipData = (0, $acw62.useMemo)(()=>currentShip ? (0, $3d4dfb4b3a9d38e4$export$7930c61d9b464618).parse(currentShip).dataParsed : undefined, [
        currentShip
    ]);
    const shipImportStatus = shipData === null || shipData === void 0 ? void 0 : shipData.importStatus;
    const uploadFile = (0, $acw62.useCallback)(async (file)=>{
        if (!currentShip) return;
        setUploading(true);
        try {
            const response = await (0, $47e36f86d10442cb$export$f951b93fb870a692)(store, currentShip.id, file);
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("import ship", currentShip.id, response.status);
        } finally{
            setUploading(false);
        }
    }, [
        store,
        currentShip
    ]);
    let content = null;
    if (shipImportStatus && shipImportStatus != (0, $ef756702f3923ebb$export$bd5fd2a78082695e).failed) content = (0, $7b02d682eb115277$exports.jsx)("div", {
        children: (0, $7b02d682eb115277$exports.jsx)("h3", {
            className: "text-centered text-success",
            children: t(`status_${shipImportStatus}`)
        })
    });
    else if (uploading) content = (0, $7b02d682eb115277$exports.jsx)("div", {
        children: (0, $7b02d682eb115277$exports.jsx)("h3", {
            className: "text-centered text-warning",
            children: t("status_uploading")
        })
    });
    else content = (0, $7b02d682eb115277$exports.jsxs)("form", {
        children: [
            shipImportStatus == (0, $ef756702f3923ebb$export$bd5fd2a78082695e).failed && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "import-error",
                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                    className: "text-centered text-error",
                    children: t("status_failed")
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "form-field file-field",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("label", {
                        htmlFor: "attachment",
                        className: "file-field-label",
                        onClick: ()=>{
                            var _a;
                            return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                        },
                        children: (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: t("file_field_drag_drop")
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("input", {
                        ref: inputRef,
                        type: "file",
                        hidden: true,
                        name: "attachment",
                        accept: ".logbook",
                        onChange: (event)=>{
                            var _a;
                            const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
                            if (file) uploadFile(file).catch(console.error);
                        }
                    })
                ]
            })
        ]
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: "ShipImportView",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: currentShip ? t("title_ship", {
                    ship: currentShip.name
                }) : t("title")
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                message: (m)=>m.importTrips.text,
                replace: {
                    name: currentShip === null || currentShip === void 0 ? void 0 : currentShip.name
                },
                className: "text-bigger"
            }),
            content,
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                actions: true,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button",
                            onClick: ()=>navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings),
                            children: t("cancel")
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button default",
                            onClick: ()=>navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
                                    shipId: (currentShip === null || currentShip === void 0 ? void 0 : currentShip.id) || 0
                                }),
                            disabled: shipImportStatus != (0, $ef756702f3923ebb$export$bd5fd2a78082695e).complete,
                            type: "submit",
                            children: t("open")
                        })
                    })
                ]
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");












const $79fc23eacbb78d2d$export$c9ad32416cd3cd83 = {
    // Sync statuses whose dialog reads as an ERROR (red header) rather than as a
    // warning (amber). Deliberately a table and not a condition: the header style
    // is a judgement about how bad a state is, and widening it is a one-line,
    // reviewable edit here (the whole enum is pinned in the tests).
    //
    // Only `selectShipFailed` qualifies today (issue #1290): the ship did not open
    // and the user cannot continue. The remaining statuses are either progress
    // states -- `selectShip` renders the ordinary "selecting the ship" spinner in
    // this very component, and turning THAT red would be worse than the bug -- or
    // degraded-sync states the user can close and keep working through.
    alarmStatuses: [
        (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).selectShipFailed
    ],
    // The `OverlayTitle` style for a status. Shared by both dialogs below so the
    // in-ship overlay and the app-level message can never drift apart again.
    titleStyle (status) {
        return $79fc23eacbb78d2d$export$c9ad32416cd3cd83.alarmStatuses.includes(status) ? "alarm" : "warning";
    },
    // Localized message key: an explicit error takes precedence over the raw status.
    messageKey (status, error) {
        return error && error != "" ? error : status;
    },
    // Which action row ShipSyncStatusMessageView renders for a given status/error.
    messageAction (status, error) {
        switch(status){
            case (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).selectShipFailed:
                return error && error == "limitActiveShipsReached" ? "cloudAccount" : "close";
            case (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).selectShip:
                return "loading";
            default:
                return "close";
        }
    },
    // Statuses that show the spinner instead of a close button in the overlay body.
    //
    // `initialSyncFailed` deliberately is NOT one of them (issue #1247): it used to
    // be, which meant the overlay rendered `<Loading />` for a terminal state and
    // the branch carrying the close button was unreachable — a permanent spinner
    // with no retry and no escape, which is what the customer was left staring at.
    showsLoading (status) {
        return status == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).initialSyncInProgress || status == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).selectShip || status == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).transition;
    },
    // Statuses the user can act on with a manual retry. Only a failed *initial*
    // sync: a failed periodic sync already retries on its own 10s loop.
    showsRetry (status) {
        return status == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).initialSyncFailed;
    },
    // Ask the app to restart a failed initial sync. This only wakes its background
    // sync loop — it does not wait for the cloud — so the request returns straight
    // away even when the cloud is slow. Repeated calls are safe: the app refuses to
    // put a second initial sync in flight while one is running.
    retrySync (api) {
        return new (0, $fcacc2feb92f961f$export$a022e2bb09fa7733)(api).sync.retry({
            params: {}
        }).call();
    },
    // Statuses that mean the sync is settled, so the overlay auto-hides.
    shouldAutoClose (status) {
        return status == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).current || status == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).dataWaiting || status == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).paused;
    }
};
function $79fc23eacbb78d2d$export$cd941086e23aa6b2(_) {
    var _a, _b, _c;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipSyncStatusView");
    const [status, setStatus] = (0, $acw62.useState)((_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.sync) === null || _b === void 0 ? void 0 : _b.status);
    const { navigateShip: navigateShip, shipOverlay: _shipOverlay, resetShipOverlay: resetShipOverlay } = (0, $89da9a3ec064ebbf$export$539e5c02cab90a6e)();
    const initialSyncCompleted = ((_c = app.current) === null || _c === void 0 ? void 0 : _c.initialSyncCompleted) === true;
    const hide = (0, $acw62.useCallback)(()=>{
        resetShipOverlay();
        navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).calendar, undefined, true);
    }, []);
    // Bumped by every status change that is NEWER than a poll already in flight (a retry
    // press, a broadcast). The refresh below reads it before and after awaiting, so a
    // slow read can never overwrite something the user just did -- which would undo the
    // optimistic spinner the retry action deliberately shows.
    const statusGeneration = (0, $acw62.useRef)(0);
    const applyStatus = (0, $acw62.useCallback)((next)=>{
        statusGeneration.current += 1;
        setStatus(next);
    }, []);
    // @mutle's decision: the retry action only *requests* a retry — it wakes the
    // app's background sync loop rather than driving a cloud call the UI has to
    // wait on — but the overlay must reflect it at once instead of sitting on the
    // error until the next status broadcast arrives. If the request itself fails
    // we fall back to the error state, so a rejection can't strand the overlay on
    // the spinner it optimistically switched to.
    const retry = (0, $acw62.useCallback)(async ()=>{
        applyStatus((0, $2a692caa93051c23$export$f38883ffc2a1d5cb).initialSyncInProgress);
        try {
            await $79fc23eacbb78d2d$export$c9ad32416cd3cd83.retrySync(app.apiClient);
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("sync retry request failed", error, (0, $ea493e883ca706d4$export$10369954900e6465));
            applyStatus((0, $2a692caa93051c23$export$f38883ffc2a1d5cb).initialSyncFailed);
        }
    }, [
        app.apiClient,
        applyStatus
    ]);
    // Re-read the authoritative sync status rather than waiting for it to be pushed.
    //
    // This overlay is a blocking modal whose only exit was a live `AppStatus` broadcast --
    // a single event with two ways to be missed. Selecting a ship resets the app instance,
    // so the client's socket is commonly reconnecting exactly when the status flips; and
    // the flip can land between the snapshot `useState` takes at mount and the
    // subscription registering in the effect after it. Either way the app had finished
    // syncing and the user sat on the spinner indefinitely, with nothing to retry --
    // observed with the overlay still up two minutes after the app logged "Initial sync
    // complete", and not one `sync status` line in the browser console.
    //
    // Polling only while a loading state is displayed: re-reading a real status is a
    // readiness check, and it stops the moment the overlay has something to show the user.
    const refreshStatus = (0, $acw62.useCallback)(async ()=>{
        var _a;
        const generation = statusGeneration.current;
        try {
            const latest = await app.updateStatus();
            if (statusGeneration.current !== generation) return;
            if ((_a = latest === null || latest === void 0 ? void 0 : latest.sync) === null || _a === void 0 ? void 0 : _a.status) applyStatus(latest.sync.status);
        } catch (error) {
            // A failed refresh must never replace a real status with an error state: the
            // broadcast path is still live, and the next tick tries again.
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("sync status refresh failed", error, (0, $ea493e883ca706d4$export$10369954900e6465));
        }
    }, [
        app,
        applyStatus
    ]);
    (0, $acw62.useEffect)(()=>{
        refreshStatus();
    }, [
        refreshStatus
    ]);
    (0, $acw62.useEffect)(()=>{
        if (status == undefined || !$79fc23eacbb78d2d$export$c9ad32416cd3cd83.showsLoading(status)) return;
        const timer = setInterval(()=>{
            refreshStatus();
        }, 10000);
        return ()=>clearInterval(timer);
    }, [
        status,
        refreshStatus
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        if (status == undefined && ((_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.sync) === null || _b === void 0 ? void 0 : _b.status)) setStatus(app.status.sync.status);
        if ($79fc23eacbb78d2d$export$c9ad32416cd3cd83.shouldAutoClose(status)) {
            if (initialSyncCompleted) {
                hide();
                return undefined;
            }
            // Sync status can reach `current` before the selected ship's current-data
            // endpoint is readable. Keep the blocking dialog mounted and refresh that
            // data in place; leaving early mounts the calendar against an incomplete
            // app and replaces the useful progress dialog with a generic Loading page.
            let cancelled = false;
            let refreshing = false;
            const finish = async ()=>{
                var _a;
                if (refreshing) return;
                refreshing = true;
                try {
                    await app.updateCurrent();
                } catch (error) {
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("current refresh failed", error, (0, $ea493e883ca706d4$export$10369954900e6465));
                }
                refreshing = false;
                if (!cancelled && ((_a = app.current) === null || _a === void 0 ? void 0 : _a.initialSyncCompleted) == true) hide();
            };
            finish();
            const timer = setInterval(()=>{
                finish();
            }, 1000);
            return ()=>{
                cancelled = true;
                clearInterval(timer);
            };
        }
        return undefined;
    }, [
        status,
        app.status,
        initialSyncCompleted,
        hide
    ]);
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((newStatus, _type)=>{
        var _a;
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("sync status", [
            status,
            newStatus.sync
        ], (0, $ea493e883ca706d4$export$10369954900e6465));
        applyStatus(((_a = newStatus.sync) === null || _a === void 0 ? void 0 : _a.status) || (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).uninitialized);
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).AppStatus);
    if (status == undefined) return;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        className: "ShipSyncStatusView",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$fe53879cede8fc3), {
                style: $79fc23eacbb78d2d$export$c9ad32416cd3cd83.titleStyle(status),
                title: t("title")
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Overlay-body",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                message: (m)=>m.noteText[status],
                                className: "message-text-bigger"
                            })
                        }),
                        $79fc23eacbb78d2d$export$c9ad32416cd3cd83.showsLoading(status) ? (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
                        }) : (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            actions: true,
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: $79fc23eacbb78d2d$export$c9ad32416cd3cd83.showsRetry(status) ? (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button sync-retry-button",
                                        onClick: ()=>retry(),
                                        children: t("retry")
                                    }) : null
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button default",
                                        onClick: ()=>hide(),
                                        children: t("close")
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $79fc23eacbb78d2d$export$8a3b235cd6c6eb92({ error: error, status: status }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipSyncStatusView");
    const { resetAppOverlay: resetAppOverlay } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const hide = (0, $acw62.useCallback)(()=>{
        resetAppOverlay();
    }, []);
    let content = null;
    switch($79fc23eacbb78d2d$export$c9ad32416cd3cd83.messageAction(status, error)){
        case "cloudAccount":
            content = (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                actions: true,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {}),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button default",
                            onClick: async ()=>{
                                if (await app.openServer("account")) resetAppOverlay();
                            },
                            children: app.t("AppOverlayContentView_ship_view_ships_cloud")
                        })
                    })
                ]
            });
            break;
        case "loading":
            content = (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
            });
            break;
        default:
            content = (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                actions: true,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {}),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button default",
                            onClick: ()=>hide(),
                            children: t("close")
                        })
                    })
                ]
            });
            break;
    }
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ShipSyncStatusView",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$fe53879cede8fc3), {
                style: $79fc23eacbb78d2d$export$c9ad32416cd3cd83.titleStyle(status),
                title: t("title")
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Overlay-body",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                message: (m)=>m.noteText[$79fc23eacbb78d2d$export$c9ad32416cd3cd83.messageKey(status, error)],
                                className: "message-text-bigger"
                            })
                        }),
                        content
                    ]
                })
            })
        ]
    });
}







var $acw62 = parcelRequire("acw62");



function $b86a28f5cdc29de0$export$ed12d2a5d2b41b6b({ status: status }) {
    if (!status || !status.blocked && !status.systemFailed && !status.gpsFailed) return null;
    const message = status.blocked ? "paused" : status.systemFailed ? "system" : "gps";
    return (0, $7b02d682eb115277$exports.jsx)($b86a28f5cdc29de0$var$ClockDialog, {
        message: message
    }, message);
}
function $b86a28f5cdc29de0$var$ClockDialog({ message: message }) {
    const t = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)().getT("RecordingClockWarning");
    const [dismissed, setDismissed] = (0, $acw62.useState)(false);
    const button = (0, $acw62.useRef)(null);
    const descriptionId = (0, $acw62.useId)();
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (dismissed) return;
        const previous = document.activeElement;
        (_a = button.current) === null || _a === void 0 || _a.focus();
        return ()=>{
            if (previous instanceof HTMLElement && previous.isConnected) previous.focus();
        };
    }, [
        dismissed
    ]);
    if (dismissed) return null;
    return (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        containerClassName: "RecordingClockWarning-layer",
        className: "RecordingClockWarning overlay-centered",
        style: message === "paused" ? "alarm" : "warning",
        title: t("title"),
        hideClose: true,
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "Overlay-body",
            role: "alertdialog",
            "aria-modal": "true",
            "aria-label": t("title"),
            "aria-describedby": descriptionId,
            onKeyDown: (event)=>{
                var _a;
                if (event.key === "Escape") {
                    event.stopPropagation();
                    setDismissed(true);
                } else if (event.key === "Tab") {
                    event.preventDefault();
                    (_a = button.current) === null || _a === void 0 || _a.focus();
                }
            },
            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                id: descriptionId,
                                children: t(message)
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        actions: true,
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                ref: button,
                                className: "button default",
                                onClick: ()=>setDismissed(true),
                                children: t("acknowledge")
                            })
                        })
                    })
                ]
            })
        })
    });
}


function $3aca0db9652797ac$export$707fe26943050cf1({ route: route, shipId: shipId, users: users, actingShipUser: actingShipUser, setActingShipUser: setActingShipUser }) {
    var _a, _b, _c, _d;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const _t = app.getT("ShipView");
    const ship = (0, $97ac05743b787a86$export$f581995c9f2db6f0)();
    const { requireUserLevel: requireUserLevel } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const { loadShips: _loadShips, navigateApp: navigateApp, selectShip: _selectShip } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const [instrumentsMinized, setInstrumentsMinized] = (0, $acw62.useState)(true);
    const [printMode, setPrintMode] = (0, $acw62.useState)((0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).none);
    const [printRoot, setPrintRoot] = (0, $acw62.useState)(undefined);
    const [printTripId, setPrintTripId] = (0, $acw62.useState)(undefined);
    const [printDayId, setPrintDayId] = (0, $acw62.useState)(undefined);
    const [printReturnRoute, setPrintReturnRoute] = (0, $acw62.useState)((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).calendar);
    const [printReturnParams, setPrintReturnParams] = (0, $acw62.useState)({});
    const [status, setStatus] = (0, $acw62.useState)(app.status);
    (0, $acw62.useEffect)(()=>{
        var _a;
        const channel = (0, $1bedde6805bf6e79$export$8776ac2d8c1066b3)(String(shipId));
        (_a = app.socket) === null || _a === void 0 || _a.subscribeChannel(channel);
        // #1716-class regression: without this cleanup, switching ships (or leaving
        // ShipView entirely) left the previous ship's channel subscribed forever --
        // `app-base`'s channel set only grows, so a user who has ever opened another
        // ship keeps receiving its live broadcasts. Since `ShipUser` ids are only
        // unique within their own ship (`Connections/Ship.ts`), a same-id broadcast
        // from that stale, backgrounded ship can silently overwrite the entity
        // currently serving the ship actually open, corrupting its `shipId` field and
        // (per `AppView.tsx`'s eviction effect, keyed off exactly that field) reading
        // as the acting user's own access having been revoked.
        return ()=>{
            var _a;
            (_a = app.socket) === null || _a === void 0 || _a.unsubscribeChannel(channel);
        };
    }, [
        shipId
    ]);
    const navigateShip = (0, $acw62.useMemo)(()=>{
        return (0, $2472f3c19d716da0$export$55185c17a0fcbe46).navigate((0, $fa2b4d03ad36b057$export$42a31fd9ca6839ee), app.updateRoute, `ships/${shipId}`);
    }, []);
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((status, _type)=>{
        setStatus(status);
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).AppStatus);
    // #1204: a momentary NMEA blip (e.g. a mobile-network drop at sea) must not flicker
    // the instruments panel in and out. Keep it mounted through any transient state
    // (connectPending/connectionFailed/waitingForData/verifyingConnection/connected) —
    // it only unmounts once NMEA has never been configured or was deliberately
    // disconnected. `InstrumentsView` shows its own warning icon when not actually
    // live (`nmeaConnected` below), driven by the real-time `connected` flag.
    const nmeaConnectionStatus = (_a = status === null || status === void 0 ? void 0 : status.nmea) === null || _a === void 0 ? void 0 : _a.connectionStatus;
    const nmeaConfigured = nmeaConnectionStatus !== undefined && nmeaConnectionStatus !== (0, $2a692caa93051c23$export$e12d1a3b018307ad).notConfigured && nmeaConnectionStatus !== (0, $2a692caa93051c23$export$e12d1a3b018307ad).disconnected;
    const nmeaConnected = (_c = (_b = status === null || status === void 0 ? void 0 : status.nmea) === null || _b === void 0 ? void 0 : _b.connected) !== null && _c !== void 0 ? _c : false;
    const [content, shipRouteName, routeParams] = (0, $2472f3c19d716da0$export$9a302a45f65d0572)(route, (0, $fa2b4d03ad36b057$export$42a31fd9ca6839ee), (router)=>{
        router.on((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).printCruise, (params)=>{
            const _cruiseId = params.requireInt("cruiseId");
            return (0, $7b02d682eb115277$exports.jsx)((0, $cd7720537de6f762$export$8d6695a68fe03388), {});
        });
        router.on((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).cruise, (params)=>{
            const cruiseId = params.requireInt("cruiseId");
            return (0, $7b02d682eb115277$exports.jsx)((0, $561bc7c82d705725$export$18ac525d13abc8df), {
                cruiseId: cruiseId
            });
        });
        router.on((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).edit, ()=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $82532a99618f300b$export$ba3b838c43b5c410), {
                cancelEdit: ()=>navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).calendar),
                ship: ship
            }, ship.id);
        });
        router.on((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).print, ()=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $cd7720537de6f762$export$8d6695a68fe03388), {});
        });
        router.on((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).focus, ()=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
        });
        router.on((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).sync, ()=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $79fc23eacbb78d2d$export$cd941086e23aa6b2), {});
        });
        router.on((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).settings, ()=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
        });
        router.on((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).calendar, ()=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {});
        });
        router.on((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).import, ()=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $909943c828a66da4$export$9808f770de4e3553), {
                cancelEdit: ()=>navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).calendar),
                ship: ship
            });
        });
        router.on((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).unknown, ()=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: "Not found"
                })
            });
        });
    });
    const [overlay, overlayOptions, setOverlay, resetOverlay] = (0, $5788501efbf36a87$export$ea8f71083e90600f)((0, $a5124d8cc1d8d792$export$8db9b17208125660).none);
    const state = {
        focusActive: shipRouteName == (0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).focus,
        navigateShip: navigateShip,
        printMode: printMode,
        printRoot: printRoot,
        shipCloudEditable: app.cloudSession() && ship.clientToken == undefined && requireUserLevel("primary"),
        printTripId: printTripId,
        printDayId: printDayId,
        shipOverlay: overlay,
        shipOverlayOptions: overlayOptions || {},
        resetShipOverlay: resetOverlay,
        setShipOverlay: setOverlay,
        setPrinting: (mode, object, tripId, dayId)=>{
            setPrintMode(mode);
            setPrintRoot(object);
            setPrintTripId(tripId);
            setPrintDayId(dayId);
            if (mode != (0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).none) {
                setPrintReturnRoute(shipRouteName);
                setPrintReturnParams(routeParams);
                navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).print);
            } else navigateShip(printReturnRoute, printReturnParams);
        },
        shipRoute: route,
        shipRouteName: shipRouteName,
        shipUsers: users,
        actingShipUser: actingShipUser,
        setActingShipUser: setActingShipUser
    };
    (0, $acw62.useEffect)(()=>{
        var _a;
        const syncStatus = (_a = status === null || status === void 0 ? void 0 : status.sync) === null || _a === void 0 ? void 0 : _a.status;
        const syncSettled = syncStatus == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).current || syncStatus == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).dataWaiting || syncStatus == (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).paused;
        if (!app.cloudSession() && app.current && !app.current.initialSyncCompleted && !syncSettled && shipRouteName != (0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).sync) navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).sync);
        if (shipRouteName == (0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).settings) {
            setOverlay((0, $a5124d8cc1d8d792$export$8db9b17208125660).shipSettings);
            navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).calendar);
        }
        if (shipRouteName == (0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).userSwitch) {
            if (app.hasFeature("multi-user")) setOverlay((0, $a5124d8cc1d8d792$export$8db9b17208125660).userSwitch);
            navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).calendar);
        }
        if (shipRouteName == (0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).unknown && app.shipId) navigateShip((0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).calendar);
        else if (shipRouteName == (0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).unknown && !app.shipId) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
        if (!app.cloudSession() && app.shipId && shipId != app.shipId) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
    }, [
        shipRouteName,
        app.current
    ]);
    if (!ship) return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ShipView",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
    });
    return (0, $7b02d682eb115277$exports.jsx)((0, $89da9a3ec064ebbf$export$32b72d0fbebd240d).Provider, {
        value: state,
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "ShipView",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $a5124d8cc1d8d792$export$9dfb40fc40d311f5), {}),
                !app.cloudSession() && requireUserLevel("viewCurrent") && (0, $7b02d682eb115277$exports.jsx)((0, $b86a28f5cdc29de0$export$ed12d2a5d2b41b6b), {
                    status: (_d = status === null || status === void 0 ? void 0 : status.nmea) === null || _d === void 0 ? void 0 : _d.clock
                }, shipId),
                (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "ShipView-content" + (nmeaConfigured ? " instruments" : "") + (instrumentsMinized ? " instruments-minized" : ""),
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "ShipContentView",
                            children: [
                                !app.cloudSession() && requireUserLevel("viewCurrent") && (0, $7b02d682eb115277$exports.jsx)((0, $f3fe348df41571fb$export$5aeb7b50bb8b32bf), {
                                    show: state.focusActive
                                }),
                                content
                            ]
                        }),
                        nmeaConfigured && (0, $7b02d682eb115277$exports.jsx)((0, $d8ded05fe18c7937$export$16c526368e1f696), {
                            minimized: instrumentsMinized,
                            setMinimized: setInstrumentsMinized,
                            connected: nmeaConnected
                        })
                    ]
                })
            ]
        })
    });
}












const $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a = {
    createShipUser (api, shipId, values) {
        return new (0, $3901b1e83708ce40$export$2a63ac7615f78125)(api).shipUsers.create({
            params: {
                shipId: shipId
            },
            body: values
        }).call();
    },
    initialSelectedUser (defaultValue) {
        return defaultValue && typeof defaultValue === "number" ? defaultValue : undefined;
    },
    initialSelectedUsers (defaultValue) {
        return defaultValue && Array.isArray(defaultValue) ? defaultValue : undefined;
    },
    addSelectedUser (current, value) {
        const users = current || [];
        return users.indexOf(value) < 0 ? [
            ...users,
            value
        ] : users;
    },
    removeSelectedUser (current, value) {
        return (current || []).filter((id)=>id != value);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    buildUserValues (values, role) {
        return Object.assign(Object.assign({}, values), {
            shipUserCrewRole: role !== undefined ? role : 0,
            shipUserLevel: 0
        });
    },
    // Display name for a ship user. Invited/registered users can arrive without a
    // joined `name` (the name lives in the users table); fall back to the shortname
    // rather than rendering "Unknown" (#799 Bug 5).
    userLabel (user) {
        return user.name || user.shortname || "Unknown";
    },
    // Dropdown title: "Name (SHORT)" when both are present, otherwise the best
    // available label.
    userTitle (user) {
        return user.name && user.shortname ? `${user.name} (${user.shortname})` : $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a.userLabel(user);
    },
    // A restriction only restricts when it actually names someone: a day whose crew has
    // not been filled in yet passes an empty list, which must mean "everyone is
    // selectable", not "nobody is" (#1213).
    restriction (restrictIds) {
        return restrictIds && restrictIds.length > 0 ? restrictIds : undefined;
    },
    // The dropdown's option list. Kept out of the component so the filtering and
    // ordering rules are directly testable -- they used to live in a `useMemo` that read
    // `restrictIds` without depending on it, leaving a stale list behind whenever the
    // day's crew changed (#1213).
    userOptions ({ users: users, selectedUsers: selectedUsers, includeValues: includeValues, restrictIds: restrictIds, priorityIds: priorityIds, addUserTitle: addUserTitle }) {
        const restriction = $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a.restriction(restrictIds);
        const isPriority = (value)=>!!priorityIds && priorityIds.indexOf(value) >= 0;
        const userOptions = users.filter((user)=>{
            return user.active > 0 && (!selectedUsers || selectedUsers.indexOf(user.id) < 0) && (!includeValues || includeValues.indexOf(user.id) < 0) && (!restriction || restriction.indexOf(user.id) >= 0);
        }).map((user)=>{
            return {
                title: $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a.userTitle(user),
                value: user.id
            };
        }).toSorted((a, b)=>a.title.localeCompare(b.title));
        return [
            ...addUserTitle ? [
                {
                    title: addUserTitle,
                    value: 0
                }
            ] : [],
            ...userOptions.filter((option)=>isPriority(option.value)),
            ...userOptions.filter((option)=>!isPriority(option.value))
        ];
    }
};
function $d5a725d5c44f3d0f$export$b65e701dc90258f({ defaultValue: defaultValue, dialogOnly: dialogOnly, includeValues: includeValues, initAddShipUser: initAddShipUser, initUserName: initUserName, initUserShortname: initUserShortname, multi: multi, name: name, onChange: onChange, onSelectionChange: onSelectionChange, priorityIds: priorityIds, restrictIds: restrictIds, role: role, readOnly: readOnly }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipUserSelect");
    const { ship: ship, apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const shipUsers = (0, $89da9a3ec064ebbf$export$27928a5984cd9ca8)();
    const [addShipUser, setAddShipUser] = (0, $acw62.useState)(initAddShipUser !== null && initAddShipUser !== void 0 ? initAddShipUser : false);
    const [addNewUser, setAddNewUser] = (0, $acw62.useState)(undefined);
    const [n, setN] = (0, $acw62.useState)(0);
    const [selectedUser, setSelectedUser] = (0, $acw62.useState)($d5a725d5c44f3d0f$export$b5e06c7bf5361a1a.initialSelectedUser(defaultValue));
    const [selectedUsers, setSelectedUsers] = (0, $acw62.useState)($d5a725d5c44f3d0f$export$b5e06c7bf5361a1a.initialSelectedUsers(defaultValue));
    const previousIncludeValues = (0, $acw62.useRef)(includeValues);
    const shipId = (ship === null || ship === void 0 ? void 0 : ship.id) || app.shipId;
    // Creating a ship user always requires .primary server-side (UserApi.shipUsers.create),
    // regardless of the crew role being assigned — hide the "add new user" affordance
    // entirely for a user who can't perform it (permission matrix, #931, tracker #827).
    const canCreateShipUser = new (0, $3901b1e83708ce40$export$2a63ac7615f78125)(app.apiClient).shipUsers.create({
        params: {
            shipId: shipId || 0
        },
        body: {}
    }).available(apiUser);
    const shipUsersForRole = (0, $acw62.useMemo)(()=>{
        return (shipUsers || []).filter((user)=>user.shipUserCrewRole >= role);
    }, [
        shipUsers,
        shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.length,
        role
    ]);
    const user = (0, $acw62.useMemo)(()=>{
        if (!selectedUser) return undefined;
        return shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.find((user)=>user.id == selectedUser);
    }, [
        selectedUser,
        shipUsers
    ]);
    const selectUser = (0, $acw62.useCallback)((value)=>{
        if (value == undefined) return;
        if (value < 1) setAddShipUser(true);
        else {
            if (multi) {
                let users = selectedUsers || [];
                if (users.indexOf(value) < 0) {
                    users = $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a.addSelectedUser(users, value);
                    setSelectedUsers(users);
                }
                if (onSelectionChange) onSelectionChange(users);
            } else {
                setSelectedUser(value);
                if (onSelectionChange) onSelectionChange(value);
            }
            if (onChange) onChange();
        }
    }, [
        multi,
        selectedUsers,
        onChange,
        onSelectionChange
    ]);
    const removeUser = (0, $acw62.useCallback)((value)=>{
        const users = $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a.removeSelectedUser(selectedUsers, value);
        setSelectedUsers(users);
        if (onSelectionChange) onSelectionChange(users);
        if (onChange) onChange();
    }, [
        selectedUsers,
        onChange,
        onSelectionChange
    ]);
    // These props arrive as fresh arrays on every parent render, so effects and
    // memos key off their contents rather than their identity.
    const restrictKey = restrictIds ? restrictIds.join(",") : undefined;
    const priorityKey = priorityIds ? priorityIds.join(",") : undefined;
    const includeKey = includeValues ? includeValues.join(",") : undefined;
    (0, $acw62.useEffect)(()=>{
        const removedValues = (previousIncludeValues.current || []).filter((value)=>!(includeValues === null || includeValues === void 0 ? void 0 : includeValues.includes(value)));
        if (removedValues.length > 0) setSelectedUsers((current)=>removedValues.reduce($d5a725d5c44f3d0f$export$b5e06c7bf5361a1a.addSelectedUser, current));
        previousIncludeValues.current = includeValues;
    }, [
        includeKey
    ]);
    const users = (0, $acw62.useMemo)(()=>{
        if (!shipUsers) return [
            {
                title: t("loading"),
                value: -1,
                disabled: true
            }
        ];
        return $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a.userOptions({
            users: shipUsersForRole,
            selectedUsers: selectedUsers,
            includeValues: includeValues,
            restrictIds: restrictIds,
            priorityIds: priorityIds,
            // Creating a person from a picker that is restricted to an existing list (the
            // watch plan's crew) makes no sense, so the option stays out of it entirely.
            addUserTitle: restrictIds === undefined && canCreateShipUser ? t("add_user") : undefined
        });
    }, [
        shipUsers,
        shipUsersForRole,
        selectedUsers,
        canCreateShipUser,
        restrictKey,
        priorityKey,
        includeKey
    ]);
    (0, $acw62.useEffect)(()=>{
        if (addNewUser && shipUsers && shipUsers.find((u)=>u.id == addNewUser)) {
            selectUser(addNewUser);
            setAddNewUser(undefined);
        } else if (addNewUser) (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("shipuser", "add failed", addNewUser, shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.map((u)=>u.id));
    }, [
        addNewUser,
        shipUsers,
        selectUser,
        n
    ]);
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((user, _type, _info)=>{
        if (!shipUsers || !Array.isArray(shipUsers) || user.shipId != shipId) return;
        if (user.shipId != shipId) return;
        setN((previous)=>previous + 1);
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).ShipUser);
    const [_edited, _onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const createShipUser = (0, $acw62.useCallback)(async (_data, values)=>{
        if (!shipId) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("No shipId available");
            return;
        }
        const userValues = $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a.buildUserValues(values, role);
        try {
            const result = await $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a.createShipUser(app.apiClient, shipId, userValues);
            if (result && result.user) {
                setAddNewUser(result.user.id);
                setAddShipUser(false);
                resetEdited();
            }
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Error creating user:", error);
        }
    }, [
        shipId,
        role,
        selectUser,
        resetEdited,
        shipUsers
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            addShipUser && (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
                className: "ship-user-dialog",
                closeCallback: ()=>setAddShipUser(false),
                title: t("dialog_add_user"),
                children: (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "Overlay-body",
                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("dialog_add_user_name"),
                                        className: "block_field_small_14",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            id: "user-name",
                                            defaultValue: initUserName || "",
                                            required: true
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("dialog_add_user_shortname"),
                                        className: "block_field_small_10",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            id: "user-shortname",
                                            defaultValue: initUserShortname || "",
                                            required: true,
                                            maxLength: 10
                                        })
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                actions: true,
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "button",
                                            onClick: ()=>setAddShipUser(false),
                                            children: t("dialog_cancel")
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "button default",
                                            onClick: ()=>{
                                                const nameInput = document.getElementById("user-name");
                                                const shortnameInput = document.getElementById("user-shortname");
                                                if (nameInput && shortnameInput && nameInput.value && shortnameInput.value) {
                                                    const values = {
                                                        name: nameInput.value,
                                                        shortname: shortnameInput.value
                                                    };
                                                    createShipUser(new FormData(), values);
                                                }
                                            },
                                            children: t("dialog_add_new_user")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            dialogOnly ? null : multi ? (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `MultiSelect${readOnly ? " readOnly" : ""}`,
                children: [
                    Array.from(new Set([
                        ...includeValues || [],
                        ...selectedUsers || []
                    ])).map((userId, i)=>{
                        const user = shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.find((u)=>u.id == userId);
                        if (user) return (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "MultiSelect-value",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "hidden",
                                    name: `${name}[${i}]`,
                                    value: userId
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "MultiSelect-value-text",
                                    children: user.shortname || user.name
                                }),
                                !readOnly && (!includeValues || includeValues.indexOf(userId) < 0) && (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Trash,
                                    onClick: ()=>removeUser(user.id)
                                })
                            ]
                        }, `user-${userId}`);
                        return null;
                    }),
                    !readOnly && (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                        button: (user === null || user === void 0 ? void 0 : user.shortname) || (user === null || user === void 0 ? void 0 : user.name) || t("select_additional_user"),
                        emptyText: t("no_users"),
                        name: name,
                        value: selectedUser,
                        onSelect: selectUser,
                        options: users
                    })
                ]
            }) : (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                button: (user === null || user === void 0 ? void 0 : user.shortname) || (user === null || user === void 0 ? void 0 : user.name) || (readOnly ? "" : t("select_user")),
                emptyText: t("no_users"),
                name: name,
                value: selectedUser,
                onSelect: selectUser,
                options: users,
                readOnly: readOnly
            })
        ]
    });
}






function $4e8b70df2d089e2b$export$b724b0d0aec3eb83({ initOpen: initOpen }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { navigateApp: navigateApp, setAppOverlay: setAppOverlay, actingShipUser: actingShipUser, setActingShipUser: setActingShipUser } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    // The real, authenticated ShipUser for this ship (never the acting override) -- used to
    // name the "return to <name>" item below (#197/#1026 (tracker #827) user switch).
    const { shipUser: shipUser, apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const t = app.getT("MenuAccount");
    const shipId = app.shipId;
    // account.delete() is the same generated permission-matrix predicate that gates the
    // "Remove account" button inside Account Settings > Your Subscription (AccountView.tsx) --
    // surfacing a shortcut directly in the top-level menu makes account deletion reasonably
    // discoverable without requiring users to find that tab first (App Store review
    // guideline 5.1.1(v)).
    const accountDeletable = (0, $acw62.useMemo)(()=>new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(app.apiClient).account.delete({
            params: {}
        }).available(apiUser), [
        app.apiClient,
        apiUser
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), {
        button: app.user ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).User
                }),
                " ",
                app.user.shortname || app.user.name
            ]
        }) : (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {}),
        global: true,
        initOpen: initOpen,
        items: [
            // Account Settings is an account-level feature -- hidden while attributing new
            // entries to another crew member (#197/#1026 user switch).
            ...actingShipUser ? [] : [
                {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Account,
                    id: "account",
                    onClick: ()=>{
                        navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
                        return true;
                    },
                    title: t("account_settings")
                }
            ],
            // Same visibility rule as the "account" item above (account-level, hidden while
            // acting as another crew member), plus cloudSession()/accountDeletable gating
            // mirroring AccountSettingsView.tsx's accountDeletable check. Opens the same
            // removeAccount confirmation overlay used by AccountSettingsAccountView.
            ...actingShipUser || !app.cloudSession() || !accountDeletable ? [] : [
                {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Trash,
                    id: "removeAccount",
                    onClick: ()=>{
                        setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).removeAccount);
                        return true;
                    },
                    title: t("remove_account")
                }
            ],
            {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).User,
                id: "userSettings",
                onClick: ()=>{
                    setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).userSettings);
                    return true;
                },
                title: t("user_settings")
            },
            ...!app.hasFeature("multi-user") || !shipId ? [] : [
                (0, $07fea78136a1afdb$export$2b6ac906eb59b21b),
                {
                    id: "userSwitch",
                    onClick: ()=>{
                        navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
                            shipId: shipId,
                            shipRoute: (0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).userSwitch
                        });
                        return true;
                    },
                    title: t("switch_user")
                }
            ],
            // switcher between cloud and app
            ...!app.cloudSession() ? [
                (0, $07fea78136a1afdb$export$2b6ac906eb59b21b),
                {
                    icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Cloud,
                    id: "openCloud",
                    onClick: ()=>{
                        // openServer resolves the real server host and applies the iOS
                        // inapp=true opt-in itself (see App.tsx) -- calling it directly avoids
                        // hardcoding logbook.yachts and duplicating that platform logic here.
                        app.openServer("");
                        return true;
                    },
                    title: t("open_cloud")
                }
            ] : [
                (0, $07fea78136a1afdb$export$2b6ac906eb59b21b),
                {
                    id: "openAppAccount",
                    onClick: ()=>{
                        // window.open(..., "_blank") for this unregistered custom scheme renders a
                        // blank page inside SFSafariViewController on iPad instead of prompting
                        // "Open in App?" (#384) -- location.href is the pattern that actually
                        // works there, matching EmptyView.tsx's app-launch link.
                        window.location.href = "logbook://app/account";
                        return true;
                    },
                    title: t("account_settings_app")
                }
            ],
            (0, $07fea78136a1afdb$export$2b6ac906eb59b21b),
            // While acting as another ShipUser, the bottom item always jumps back to the real
            // identity/session first -- this is the explicit "jump back to main session" action,
            // it never automatically clears (#197/#1026 user switch). Names the real session's
            // ShipUser rather than a generic "My Account" label, since Account already has a
            // distinct meaning elsewhere in this app.
            actingShipUser ? {
                id: "returnToOwnUser",
                onClick: ()=>{
                    setActingShipUser(undefined);
                    return true;
                },
                title: t("return_to_own_user", {
                    name: (0, $d5a725d5c44f3d0f$export$b5e06c7bf5361a1a).userLabel(shipUser || {})
                })
            } : {
                id: "logout",
                onClick: async ()=>{
                    if (app.primarySession() && app.shipId) setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).logout);
                    else await app.logout();
                    return true;
                },
                title: app.localSession() ? t("close_companion") : t("logout")
            }
        ]
    });
}







function $d17d5ddcc7173784$export$63b04de3a37f9334({ initOpen: initOpen }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("MenuHelp");
    const { setAppOverlay: setAppOverlay } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    return (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), {
        button: t("title"),
        global: true,
        initOpen: initOpen,
        items: [
            {
                id: "documentation",
                onClick: ()=>{
                    window.open(`https://logbook.yachts/site/${app.language}/documentation`, "_blank");
                    return true;
                },
                title: t("documentation")
            },
            {
                id: "demo",
                onClick: ()=>{
                    window.open(`https://logbook.yachts/site/${app.language}/demos`, "_blank");
                    return true;
                },
                title: t("demo")
            },
            {
                id: "support",
                onClick: ()=>{
                    window.open(`https://logbook.yachts/site/${app.language}/support`, "_blank");
                    return true;
                },
                title: t("support")
            },
            {
                id: "qanda",
                onClick: ()=>{
                    window.open(`https://logbook.yachts/site/${app.language}/support#tip`, "_blank");
                    return true;
                },
                title: t("qanda")
            },
            (0, $07fea78136a1afdb$export$2b6ac906eb59b21b),
            {
                id: "changelog",
                onClick: ()=>{
                    setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).changeLog);
                    return true;
                },
                title: t("change_log")
            },
            {
                id: "contact_support",
                onClick: ()=>{
                    window.location.href = "mailto:contact@trimutic.com";
                    return true;
                },
                title: t("contact_support")
            },
            (0, $07fea78136a1afdb$export$2b6ac906eb59b21b),
            {
                id: "about",
                onClick: ()=>{
                    setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).about);
                    return true;
                },
                title: t("about")
            }
        ]
    });
}




var $acw62 = parcelRequire("acw62");








const $c6317c71ac41c34c$export$432084e71a71d1ea = {
    vesselIcon (vesselType) {
        return vesselType == (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).sailing ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).SailingVessel : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).MotorVessel;
    },
    otherShips (ships, currentShipId) {
        return (ships || []).filter((ship)=>ship.id != currentShipId);
    }
};
function $c6317c71ac41c34c$export$d792d5a04aac92bb({ ship: ship, initOpen: initOpen }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("MenuShip");
    const { navigateApp: navigateApp, loadShips: loadShips, setAppOverlay: setAppOverlay, ships: ships, selectShip: selectShip } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const _showNewShip = (0, $acw62.useCallback)(async ()=>{
        if (app.cloudSession()) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).newShip);
        else await app.openServer("ships/new");
    }, []);
    const shipId = (0, $acw62.useMemo)(()=>ship === null || ship === void 0 ? void 0 : ship.id, [
        ship
    ]);
    const shipItems = (0, $acw62.useMemo)(()=>{
        if (!ships) return [
            {
                disabled: true,
                id: "ship-loading",
                title: (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
            }
        ];
        const items = $c6317c71ac41c34c$export$432084e71a71d1ea.otherShips(ships, shipId).map((ship)=>{
            return {
                icon: $c6317c71ac41c34c$export$432084e71a71d1ea.vesselIcon(ship.vesselType),
                id: `ship-${ship.id}`,
                onClick: async ()=>{
                    await selectShip(ship.id);
                    return true;
                },
                title: ship.name
            };
        });
        return items;
    }, [
        shipId,
        ship,
        ships
    ]);
    const shipMenuItems = (0, $acw62.useMemo)(()=>{
        const shipData = {
            icon: $c6317c71ac41c34c$export$432084e71a71d1ea.vesselIcon(ship === null || ship === void 0 ? void 0 : ship.vesselType),
            id: "ship_data",
            onClick: ()=>{
                if (ship) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
                    shipId: ship.id,
                    shipRoute: (0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).edit
                });
                return true;
            },
            title: t("data_name", {
                name: ship === null || ship === void 0 ? void 0 : ship.name
            })
        };
        const shipSettings = {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Settings,
            id: "settings",
            onClick: ()=>{
                if (ship) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
                    shipId: ship.id,
                    shipRoute: (0, $fa2b4d03ad36b057$export$46bf80ad02f0f8c5).settings
                });
                return true;
            },
            title: t("settings_name", {
                name: ship === null || ship === void 0 ? void 0 : ship.name
            })
        };
        const shipClose = {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Close,
            id: "close",
            onClick: async ()=>{
                setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).closeShip);
                return true;
            },
            title: t("close", {
                name: ship === null || ship === void 0 ? void 0 : ship.name
            })
        };
        const shipLogout = {
            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Close,
            id: "logout",
            onClick: async ()=>{
                if (app.primarySession() && app.shipId) setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).logout);
                else await app.logout();
                return true;
            },
            title: t("logout", {
                name: ship === null || ship === void 0 ? void 0 : ship.name
            })
        };
        const shipCloud = {
            id: "cloud",
            onClick: async ()=>{
                if (ship) await app.openServer(`ships/${ship.id}`);
                return true;
            },
            title: t("view_cloud", {
                name: ship === null || ship === void 0 ? void 0 : ship.name
            })
        };
        const _shipsList = {
            id: "list",
            onClick: async ()=>{
                if (app.cloudSession()) loadShips(true);
                navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
            },
            title: t("view_ships")
        };
        const shipsListCloud = {
            id: "cloudList",
            onClick: async ()=>{
                await app.openServer("account");
                return true;
            },
            title: t("view_ships")
        };
        if (app.cloudSession()) return [
            ...shipItems,
            ...ship && ships ? [
                (0, $07fea78136a1afdb$export$2b6ac906eb59b21b),
                shipData
            ] : []
        ].filter(Boolean);
        else return [
            ...ship ? [
                shipData,
                shipSettings,
                (0, $07fea78136a1afdb$export$2b6ac906eb59b21b),
                ...app.primarySession() ? [
                    shipClose,
                    (0, $07fea78136a1afdb$export$2b6ac906eb59b21b)
                ] : [],
                ...app.localSession() ? [
                    shipLogout,
                    (0, $07fea78136a1afdb$export$2b6ac906eb59b21b)
                ] : [],
                shipCloud
            ] : [],
            shipsListCloud
        ].filter(Boolean);
    }, [
        ship,
        shipItems
    ]);
    const shipMenuButton = (0, $acw62.useMemo)(()=>{
        if (ship) return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                    icon: $c6317c71ac41c34c$export$432084e71a71d1ea.vesselIcon(ship.vesselType),
                    className: "ship-icon"
                }),
                " ",
                ship.name,
                " "
            ]
        });
        else return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: t("select")
        });
    }, [
        ship
    ]);
    if (!ship && !app.cloudSession()) return null;
    return (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), {
        button: shipMenuButton,
        global: true,
        initOpen: initOpen,
        items: shipMenuItems,
        onClick: (selected)=>{
            if (selected) loadShips();
        }
    });
}


function $cd8deb4eb028fe97$export$381adc1c98036a68({ ship: ship, hideMenus: hideMenus, hideShipMenu: hideShipMenu }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const [mobileMenuOpen, setMobileMenuOpen] = (0, $acw62.useState)(false);
    const closeMobileMenu = (0, $acw62.useCallback)(()=>setMobileMenuOpen(false), []);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "ShipView-header-container",
            "session-type-" + app.sessionType
        ]),
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ShipView-header-fill pre"
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ShipView-header",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ShipView-title",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ShipView-logo",
                                style: {
                                    background: `url('/icon${app.theme == "light" ? "-black" : app.theme == "night" ? "-red" : ""}.svg') center center no-repeat`
                                }
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "ShipView-title-text",
                                children: [
                                    "LOGBOOK",
                                    app.cloudSession() ? " Cloud" : app.localSession() ? " Companion" : ""
                                ]
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ShipView-menus",
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ShipView-menus-mobile",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "Menu",
                                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "Menu-button",
                                            onClick: ()=>window.location.reload(),
                                            children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Refresh
                                            })
                                        })
                                    }),
                                    !hideMenus && (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "Menu hamburger-menu-button",
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "Menu-button",
                                                onClick: ()=>setMobileMenuOpen(!mobileMenuOpen),
                                                children: "\u2630"
                                            }),
                                            mobileMenuOpen && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "Menu-overlay",
                                                        onClick: ()=>setMobileMenuOpen(false)
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "Menu-items-container",
                                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$9abd1e85c2faf332).Provider, {
                                                            value: closeMobileMenu,
                                                            children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "Menu-items mobile-menu-panel",
                                                                children: [
                                                                    !hideShipMenu && (0, $7b02d682eb115277$exports.jsx)((0, $c6317c71ac41c34c$export$d792d5a04aac92bb), {
                                                                        ship: ship
                                                                    }),
                                                                    !hideShipMenu && (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "Menu-item-divider"
                                                                    }),
                                                                    (0, $7b02d682eb115277$exports.jsx)((0, $4e8b70df2d089e2b$export$b724b0d0aec3eb83), {}),
                                                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "Menu-item-divider"
                                                                    }),
                                                                    (0, $7b02d682eb115277$exports.jsx)((0, $d17d5ddcc7173784$export$63b04de3a37f9334), {})
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "ShipView-menus-desktop",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "Menu",
                                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "Menu-button",
                                            onClick: ()=>window.location.reload(),
                                            children: (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Refresh
                                            })
                                        })
                                    }, "refresh"),
                                    ...!hideMenus ? [
                                        ...!hideShipMenu ? [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $c6317c71ac41c34c$export$d792d5a04aac92bb), {
                                                ship: ship
                                            }, "ship")
                                        ] : [],
                                        (0, $7b02d682eb115277$exports.jsx)((0, $4e8b70df2d089e2b$export$b724b0d0aec3eb83), {}, "account")
                                    ] : [],
                                    (0, $7b02d682eb115277$exports.jsx)((0, $d17d5ddcc7173784$export$63b04de3a37f9334), {}, "help")
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ShipView-header-fill post"
            })
        ]
    });
}







var $acw62 = parcelRequire("acw62");
function $2110bf72a86f956f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2110bf72a86f956f$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $2110bf72a86f956f$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2110bf72a86f956f$var$_typeof(obj);
}
var $2110bf72a86f956f$var$RELEASE_TRAIN = 'clover';
var $2110bf72a86f956f$var$runtimeVersionToUrlVersion = function runtimeVersionToUrlVersion(version) {
    return version === 3 ? 'v3' : version;
};
var $2110bf72a86f956f$var$ORIGIN = 'https://js.stripe.com';
var $2110bf72a86f956f$var$STRIPE_JS_URL = "".concat($2110bf72a86f956f$var$ORIGIN, "/").concat($2110bf72a86f956f$var$RELEASE_TRAIN, "/stripe.js");
var $2110bf72a86f956f$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $2110bf72a86f956f$var$STRIPE_JS_URL_REGEX = /^https:\/\/js\.stripe\.com\/(v3|[a-z]+)\/stripe\.js(\?.*)?$/;
var $2110bf72a86f956f$var$EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var $2110bf72a86f956f$var$isStripeJSURL = function isStripeJSURL(url) {
    return $2110bf72a86f956f$var$V3_URL_REGEX.test(url) || $2110bf72a86f956f$var$STRIPE_JS_URL_REGEX.test(url);
};
var $2110bf72a86f956f$var$findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat($2110bf72a86f956f$var$ORIGIN, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$2110bf72a86f956f$var$isStripeJSURL(script.src)) continue;
        return script;
    }
    return null;
};
var $2110bf72a86f956f$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat($2110bf72a86f956f$var$STRIPE_JS_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var $2110bf72a86f956f$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "8.11.0",
        startTime: startTime
    });
};
var $2110bf72a86f956f$var$stripePromise$1 = null;
var $2110bf72a86f956f$var$onErrorListener = null;
var $2110bf72a86f956f$var$onLoadListener = null;
var $2110bf72a86f956f$var$onError = function onError(reject) {
    return function(cause) {
        reject(new Error('Failed to load Stripe.js', {
            cause: cause
        }));
    };
};
var $2110bf72a86f956f$var$onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error('Stripe.js not available'));
    };
};
var $2110bf72a86f956f$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($2110bf72a86f956f$var$stripePromise$1 !== null) return $2110bf72a86f956f$var$stripePromise$1;
    $2110bf72a86f956f$var$stripePromise$1 = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($2110bf72a86f956f$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $2110bf72a86f956f$var$findScript();
            if (script && params) console.warn($2110bf72a86f956f$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $2110bf72a86f956f$var$injectScript(params);
            else if (script && $2110bf72a86f956f$var$onLoadListener !== null && $2110bf72a86f956f$var$onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener('load', $2110bf72a86f956f$var$onLoadListener);
                script.removeEventListener('error', $2110bf72a86f956f$var$onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = $2110bf72a86f956f$var$injectScript(params);
            }
            $2110bf72a86f956f$var$onLoadListener = $2110bf72a86f956f$var$onLoad(resolve, reject);
            $2110bf72a86f956f$var$onErrorListener = $2110bf72a86f956f$var$onError(reject);
            script.addEventListener('load', $2110bf72a86f956f$var$onLoadListener);
            script.addEventListener('error', $2110bf72a86f956f$var$onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return $2110bf72a86f956f$var$stripePromise$1["catch"](function(error) {
        $2110bf72a86f956f$var$stripePromise$1 = null;
        return Promise.reject(error);
    });
};
var $2110bf72a86f956f$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var pk = args[0];
    if (typeof pk !== 'string') throw new Error("Expected publishable key to be of type string, got type ".concat($2110bf72a86f956f$var$_typeof(pk), " instead."));
    var isTestKey = pk.match(/^pk_test/); // @ts-expect-error this is not publicly typed
    var version = $2110bf72a86f956f$var$runtimeVersionToUrlVersion(maybeStripe.version);
    var expectedVersion = $2110bf72a86f956f$var$RELEASE_TRAIN;
    if (isTestKey && version !== expectedVersion) console.warn("Stripe.js@".concat(version, " was loaded on the page, but @stripe/stripe-js@").concat("8.11.0", " expected Stripe.js@").concat(expectedVersion, ". This may result in unexpected behavior. For more information, see https://docs.stripe.com/sdks/stripejs-versioning"));
    var stripe = maybeStripe.apply(undefined, args);
    $2110bf72a86f956f$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $2110bf72a86f956f$var$stripePromise;
var $2110bf72a86f956f$var$loadCalled = false;
var $2110bf72a86f956f$var$getStripePromise = function getStripePromise() {
    if ($2110bf72a86f956f$var$stripePromise) return $2110bf72a86f956f$var$stripePromise;
    $2110bf72a86f956f$var$stripePromise = $2110bf72a86f956f$var$loadScript(null)["catch"](function(error) {
        // clear cache on error
        $2110bf72a86f956f$var$stripePromise = null;
        return Promise.reject(error);
    });
    return $2110bf72a86f956f$var$stripePromise;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return $2110bf72a86f956f$var$getStripePromise();
})["catch"](function(error) {
    if (!$2110bf72a86f956f$var$loadCalled) console.warn(error);
});
var $2110bf72a86f956f$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $2110bf72a86f956f$var$loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return $2110bf72a86f956f$var$getStripePromise().then(function(maybeStripe) {
        return $2110bf72a86f956f$var$initStripe(maybeStripe, args, startTime);
    });
};




var $7bf3b98cbc00db03$exports = {};

(function(global, factory) {
    factory($7bf3b98cbc00db03$exports, (parcelRequire("acw62")));
})($7bf3b98cbc00db03$exports, function(exports1, React) {
    'use strict';
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
            var info = gen[key](arg);
            var value = info.value;
        } catch (error) {
            reject(error);
            return;
        }
        if (info.done) resolve(value);
        else Promise.resolve(value).then(_next, _throw);
    }
    function _asyncToGenerator(fn) {
        return function() {
            var self = this, args = arguments;
            return new Promise(function(resolve, reject) {
                var gen = fn.apply(self, args);
                function _next(value) {
                    asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                    asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(undefined);
            });
        };
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = 'Invariant Violation';
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === 'object';
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === 'function';
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
    };
    var PLAIN_OBJECT_STR = '[object Object]';
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$1 = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.'; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$1;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$1;
        if (isPromise(raw)) return {
            tag: 'async',
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: 'empty'
        };
        return {
            tag: 'sync',
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: 'react-stripe-js',
            version: "5.6.1"
        });
        stripe.registerAppInfo({
            name: 'react-stripe-js',
            version: "5.6.1",
            url: 'https://stripe.com/docs/stripe-js/react'
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = 'ElementsContext';
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://docs.stripe.com/sdks/stripejs-react?ui=elements#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]); // For a sync stripe instance, initialize into context
        var _React$useState = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                elements: parsed.tag === 'sync' ? parsed.stripe.elements(options) : null
            };
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === 'sync' && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                'clientSecret',
                'fonts'
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, children);
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase('calls useElements()'), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase('mounts <ElementsConsumer>'); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var CheckoutContext = /*#__PURE__*/ React.createContext(null);
    CheckoutContext.displayName = 'CheckoutContext';
    PropTypes.any, PropTypes.shape({
        clientSecret: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.instanceOf(Promise)
        ]).isRequired,
        elementsOptions: PropTypes.object
    }).isRequired;
    var useElementsOrCheckoutContextWithUseCase = function useElementsOrCheckoutContextWithUseCase(useCaseString) {
        var checkout = React.useContext(CheckoutContext);
        var elements = React.useContext(ElementsContext);
        if (checkout) {
            if (elements) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CheckoutProvider> and <Elements> providers."));
            else return checkout;
        } else return parseElementsContext(elements, useCaseString);
    };
    var _excluded = [
        "mode"
    ];
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange, onSavedPaymentMethodRemove = _ref.onSavedPaymentMethodRemove, onSavedPaymentMethodUpdate = _ref.onSavedPaymentMethodUpdate;
            var ctx = useElementsOrCheckoutContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = 'elements' in ctx ? ctx.elements : null;
            var checkoutState = 'checkoutState' in ctx ? ctx.checkoutState : null;
            var checkoutSdk = (checkoutState === null || checkoutState === void 0 ? void 0 : checkoutState.type) === 'success' || (checkoutState === null || checkoutState === void 0 ? void 0 : checkoutState.type) === 'loading' ? checkoutState.sdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null); // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, 'blur', onBlur);
            useAttachEvent(element, 'focus', onFocus);
            useAttachEvent(element, 'escape', onEscape);
            useAttachEvent(element, 'click', onClick);
            useAttachEvent(element, 'loaderror', onLoadError);
            useAttachEvent(element, 'loaderstart', onLoaderStart);
            useAttachEvent(element, 'networkschange', onNetworksChange);
            useAttachEvent(element, 'confirm', onConfirm);
            useAttachEvent(element, 'cancel', onCancel);
            useAttachEvent(element, 'shippingaddresschange', onShippingAddressChange);
            useAttachEvent(element, 'shippingratechange', onShippingRateChange);
            useAttachEvent(element, 'savedpaymentmethodremove', onSavedPaymentMethodRemove);
            useAttachEvent(element, 'savedpaymentmethodupdate', onSavedPaymentMethodUpdate);
            useAttachEvent(element, 'change', onChange);
            var readyCallback;
            if (onReady) {
                if (type === 'expressCheckout') // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, 'ready', readyCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || checkoutSdk)) {
                    var newElement = null;
                    if (checkoutSdk) switch(type){
                        case 'paymentForm':
                            newElement = checkoutSdk.createPaymentFormElement(options);
                            break;
                        case 'payment':
                            newElement = checkoutSdk.createPaymentElement(options);
                            break;
                        case 'address':
                            if ('mode' in options) {
                                var mode = options.mode, restOptions = _objectWithoutProperties(options, _excluded);
                                if (mode === 'shipping') newElement = checkoutSdk.createShippingAddressElement(restOptions);
                                else if (mode === 'billing') newElement = checkoutSdk.createBillingAddressElement(restOptions);
                                else throw new Error("Invalid options.mode. mode must be 'billing' or 'shipping'.");
                            } else throw new Error("You must supply options.mode. mode must be 'billing' or 'shipping'.");
                            break;
                        case 'expressCheckout':
                            newElement = checkoutSdk.createExpressCheckoutElement(options);
                            break;
                        case 'currencySelector':
                            newElement = checkoutSdk.createCurrencySelectorElement();
                            break;
                        case 'taxId':
                            newElement = checkoutSdk.createTaxIdElement(options);
                            break;
                        default:
                            throw new Error("Invalid Element type ".concat(displayName, ". You must use either the <PaymentElement />, <AddressElement options={{mode: 'shipping'}} />, <AddressElement options={{mode: 'billing'}} />, or <ExpressCheckoutElement />."));
                    }
                    else if (elements) newElement = elements.create(type, options);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                checkoutSdk,
                options
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    'paymentRequest'
                ]);
                if (updates && 'update' in elementRef.current) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === 'function') try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {}
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            useElementsOrCheckoutContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            onSavedPaymentMethodRemove: PropTypes.func,
            onSavedPaymentMethodUpdate: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === 'undefined';
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = 'EmbeddedCheckoutProviderContext';
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error('<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>');
        return ctx;
    };
    var INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            }; // For an async stripePromise, store it once resolved
            if (parsed.tag === 'async' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === 'sync' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]); // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.');
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn('Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.');
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.');
            if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.');
            if (prevOptions.onLineItemsChange != null && options.onLineItemsChange !== prevOptions.onLineItemsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onLineItemsChange option after setting it.');
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            } // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    }; // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    var FinancialAccountDisclosure = function FinancialAccountDisclosure(_ref) {
        var rawStripeProp = _ref.stripe, onLoad = _ref.onLoad, onError = _ref.onError, options = _ref.options;
        var businessName = options === null || options === void 0 ? void 0 : options.businessName;
        var learnMoreLink = options === null || options === void 0 ? void 0 : options.learnMoreLink;
        var containerRef = React.useRef(null);
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        var _React$useState = React.useState(parsed.tag === 'sync' ? parsed.stripe : null), _React$useState2 = _slicedToArray(_React$useState, 2), stripeState = _React$useState2[0], setStripeState = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async') parsed.stripePromise.then(function(stripePromise) {
                if (stripePromise && isMounted) setStripeState(stripePromise);
            });
            else if (parsed.tag === 'sync') setStripeState(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on FinancialAccountDisclosure: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(stripeState);
        }, [
            stripeState
        ]);
        React.useEffect(function() {
            var createDisclosure = /*#__PURE__*/ function() {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
                    var _yield$stripeState$cr, disclosureContent, error, container;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!stripeState || !containerRef.current)) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 2:
                                _context.next = 4;
                                return stripeState.createFinancialAccountDisclosure({
                                    businessName: businessName,
                                    learnMoreLink: learnMoreLink
                                });
                            case 4:
                                _yield$stripeState$cr = _context.sent;
                                disclosureContent = _yield$stripeState$cr.htmlElement;
                                error = _yield$stripeState$cr.error;
                                if (error && onError) onError(error);
                                else if (disclosureContent) {
                                    container = containerRef.current;
                                    container.innerHTML = '';
                                    container.appendChild(disclosureContent);
                                    if (onLoad) onLoad();
                                }
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function createDisclosure() {
                    return _ref2.apply(this, arguments);
                };
            }();
            createDisclosure();
        }, [
            stripeState,
            businessName,
            learnMoreLink,
            onLoad,
            onError
        ]);
        return /*#__PURE__*/ React.createElement('div', {
            ref: containerRef
        });
    };
    var IssuingDisclosure = function IssuingDisclosure(_ref) {
        var rawStripeProp = _ref.stripe, onLoad = _ref.onLoad, onError = _ref.onError, options = _ref.options;
        var issuingProgramID = options === null || options === void 0 ? void 0 : options.issuingProgramID;
        var publicCardProgramName = options === null || options === void 0 ? void 0 : options.publicCardProgramName;
        var learnMoreLink = options === null || options === void 0 ? void 0 : options.learnMoreLink;
        var containerRef = React.useRef(null);
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        var _React$useState = React.useState(parsed.tag === 'sync' ? parsed.stripe : null), _React$useState2 = _slicedToArray(_React$useState, 2), stripeState = _React$useState2[0], setStripeState = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async') parsed.stripePromise.then(function(stripePromise) {
                if (stripePromise && isMounted) setStripeState(stripePromise);
            });
            else if (parsed.tag === 'sync') setStripeState(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on IssuingDisclosure: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(stripeState);
        }, [
            stripeState
        ]);
        React.useEffect(function() {
            var createDisclosure = /*#__PURE__*/ function() {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
                    var _yield$stripeState$cr, disclosureContent, error, container;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!stripeState || !containerRef.current)) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 2:
                                _context.next = 4;
                                return stripeState.createIssuingDisclosure({
                                    issuingProgramID: issuingProgramID,
                                    publicCardProgramName: publicCardProgramName,
                                    learnMoreLink: learnMoreLink
                                });
                            case 4:
                                _yield$stripeState$cr = _context.sent;
                                disclosureContent = _yield$stripeState$cr.htmlElement;
                                error = _yield$stripeState$cr.error;
                                if (error && onError) onError(error);
                                else if (disclosureContent) {
                                    container = containerRef.current;
                                    container.innerHTML = '';
                                    container.appendChild(disclosureContent);
                                    if (onLoad) onLoad();
                                }
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function createDisclosure() {
                    return _ref2.apply(this, arguments);
                };
            }();
            createDisclosure();
        }, [
            stripeState,
            issuingProgramID,
            publicCardProgramName,
            learnMoreLink,
            onLoad,
            onError
        ]);
        return /*#__PURE__*/ React.createElement('div', {
            ref: containerRef
        });
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCheckou = useElementsOrCheckoutContextWithUseCase('calls useStripe()'), stripe = _useElementsOrCheckou.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent('auBankAccount', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent('card', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent('cardNumber', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent('cardExpiry', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent('cardCvc', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent('iban', isServer);
    var PaymentElement = createElementComponent('payment', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent('expressCheckout', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent('paymentRequestButton', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent('linkAuthentication', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent('address', isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent('shippingAddress', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent('paymentMethodMessaging', isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var TaxIdElement = createElementComponent('taxId', isServer);
    exports1.AddressElement = AddressElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FinancialAccountDisclosure = FinancialAccountDisclosure;
    exports1.IbanElement = IbanElement;
    exports1.IssuingDisclosure = IssuingDisclosure;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.TaxIdElement = TaxIdElement;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});













var $cf7ac0959066927f$export$4b6b29cad94858db;
(function(AccountViewCurrency) {
    AccountViewCurrency["EUR"] = "EUR";
    AccountViewCurrency["USD"] = "USD";
})($cf7ac0959066927f$export$4b6b29cad94858db || ($cf7ac0959066927f$export$4b6b29cad94858db = {}));




var $acw62 = parcelRequire("acw62");






const $e1f14a732c3f22f3$var$daysUntil = (iso)=>Math.floor((Date.parse(iso).valueOf() - Date.now()) / 86400000);
function $e1f14a732c3f22f3$export$2d86d2220712b394({ active: active, cancelCallback: cancelCallback, canSubscribe: canSubscribe, currency: currency, plan: plan, selectCallback: selectCallback }) {
    var _a, _b;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("AccountView");
    // Apple (IAP) subscriptions can't be cancelled server-side — the Stripe cancel call
    // would silently no-op — so on the cloud/Stripe view an Apple sub gets an info dialog
    // pointing the user at the on-device Manage Subscriptions flow instead.
    const isAppleSubscription = ((_a = app.account) === null || _a === void 0 ? void 0 : _a.paymentSystem) === (0, $7cd0ad1ebf7aa273$export$e22b0e185bbfaf0d).apple;
    const isGiftSubscription = ((_b = app.account) === null || _b === void 0 ? void 0 : _b.paymentSystem) === (0, $7cd0ad1ebf7aa273$export$e22b0e185bbfaf0d).gift;
    const [showAppleCancelInfo, setShowAppleCancelInfo] = (0, $acw62.useState)(false);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                    "AccountView-plan",
                    `AccountView-plan-${plan.plan.name}`,
                    active && "active"
                ]),
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "AccountView-plan-name",
                            children: t(`plan_${plan.plan.name}`)
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                            message: (m)=>m.planDescriptions[plan.plan.name],
                            className: "AccountView-plan-description"
                        })
                    }),
                    plan.features.filter((f)=>f.amount != 0).map((f)=>{
                        var _a, _b;
                        let feature = null;
                        switch(f.feature){
                            case "active_ships":
                            case "active_users":
                            case "active_tenders":
                                feature = (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    className: "AccountView-plan-info",
                                    children: t(`feature_${f.feature}`, {
                                        amount: ((_a = f.amount) !== null && _a !== void 0 ? _a : 0) < 0 ? t("feature_unlimited") : (_b = f.amount) !== null && _b !== void 0 ? _b : 0
                                    })
                                });
                                break;
                            case "support":
                                feature = (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    className: "AccountView-plan-info",
                                    children: t(`feature_support_${f.amount}`)
                                });
                                break;
                            default:
                                return null;
                        }
                        return (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: feature
                        }, f.feature);
                    }),
                    plan.pricing.length == 0 ? (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-no-margin price-row",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            className: "AccountView-plan-price-info",
                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "price free-plan",
                                children: t("price_free")
                            })
                        })
                    }) : (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: !active ? plan.pricing.sort((a, b)=>b.duration - a.duration).map((p)=>{
                            if (p.currency != currency) return;
                            const priceRowClass = plan.plan.name === "captain" ? "captain-price-row" : plan.plan.name === "master_captain" ? "master-captain-price-row" : "block-row-no-margin";
                            return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: priceRowClass,
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            className: "AccountView-plan-price-info",
                                            children: p.duration > 30 ? (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "price block-row-actions",
                                                    children: t(`price_${currency}`, {
                                                        price: Math.floor(p.price / 12 / 100),
                                                        duration: t(`price_duration_30`)
                                                    })
                                                })
                                            }) : (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "price block-row-actions",
                                                children: t(`price_${currency}`, {
                                                    price: Math.floor(p.price / 100),
                                                    duration: t(`price_duration_${p.duration}`)
                                                })
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "AccountView-plan-price-info duration-info block-row-no-margin",
                                        children: t(`duration_${p.duration}`)
                                    }),
                                    p.duration > 30 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "block-row-top0",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            className: "AccountView-plan-price-info",
                                            children: (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "note",
                                                children: [
                                                    "(",
                                                    t(`price_${currency}`, {
                                                        price: Math.floor(p.price / 100),
                                                        duration: t(`price_duration_${p.duration}`)
                                                    }),
                                                    ")"
                                                ]
                                            })
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>selectCallback(p),
                                                className: "button subscribe-button",
                                                disabled: !canSubscribe,
                                                children: t("subscribe")
                                            })
                                        })
                                    })
                                ]
                            });
                        }) : (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                            children: app.account && app.account.subscriptionStatus == (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).cancelled ? app.account.nextBillingAt && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: t("cancelled_ends", {
                                                days: $e1f14a732c3f22f3$var$daysUntil(app.account.nextBillingAt)
                                            })
                                        })
                                    })
                                })
                            }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    app.account && app.account.nextBillingAt && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                    children: t("renews_in", {
                                                        days: $e1f14a732c3f22f3$var$daysUntil(app.account.nextBillingAt)
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    !isGiftSubscription && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        actions: true,
                                        className: "",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: isAppleSubscription ? (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>setShowAppleCancelInfo(true),
                                                className: "button subscribe-button",
                                                children: t("cancel_plan")
                                            }) : (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>cancelCallback(),
                                                className: "button subscribe-button",
                                                disabled: !app.account,
                                                children: t("cancel_plan")
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            showAppleCancelInfo && (0, $7b02d682eb115277$exports.jsx)((0, $43e7c9e0370237d7$export$b605456b9cec4c34), {
                title: t("apple_cancel_info_title"),
                message: t("apple_cancel_info_message"),
                onClose: ()=>setShowAppleCancelInfo(false),
                style: "info"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





const $19c3c116f7347f2b$var$daysUntil = (iso)=>Math.floor((Date.parse(iso).valueOf() - Date.now()) / 86400000);
function $19c3c116f7347f2b$export$811110f515271376({ active: active, cancelCallback: cancelCallback, canSubscribe: _canSubscribe, currency: _currency, plan: plan }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("AccountView");
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "AccountView-plan",
            `AccountView-plan-${plan.plan.name}`,
            active && "active"
        ]),
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "AccountView-plan-name",
                    children: t(`plan_${plan.plan.name}`)
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                    message: (m)=>m.planDescriptions[plan.plan.name],
                    className: "AccountView-plan-description"
                })
            }),
            plan.features.filter((f)=>f.amount != 0).map((f)=>{
                var _a, _b;
                let feature = null;
                switch(f.feature){
                    case "active_ships":
                    case "active_users":
                    case "active_tenders":
                        feature = (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "AccountView-plan-info",
                            children: t(`feature_${f.feature}`, {
                                amount: ((_a = f.amount) !== null && _a !== void 0 ? _a : 0) < 0 ? t("feature_unlimited") : (_b = f.amount) !== null && _b !== void 0 ? _b : 0
                            })
                        });
                        break;
                    case "support":
                        feature = (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "AccountView-plan-info",
                            children: t(`feature_support_${f.amount}`)
                        });
                        break;
                    default:
                        return null;
                }
                return (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    children: feature
                }, f.feature);
            }),
            active && plan.plan.id !== 1 && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: app.account && app.account.subscriptionStatus == (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).cancelled ? app.account.nextBillingAt && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: t("cancelled_ends", {
                                    days: $19c3c116f7347f2b$var$daysUntil(app.account.nextBillingAt)
                                })
                            })
                        })
                    })
                }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        app.account && app.account.nextBillingAt && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: t("renews_in", {
                                            days: $19c3c116f7347f2b$var$daysUntil(app.account.nextBillingAt)
                                        })
                                    })
                                })
                            })
                        }),
                        ((_a = app.account) === null || _a === void 0 ? void 0 : _a.paymentSystem) !== (0, $7cd0ad1ebf7aa273$export$e22b0e185bbfaf0d).gift && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            actions: true,
                            className: "",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>cancelCallback(),
                                    className: "button subscribe-button",
                                    disabled: !app.account,
                                    children: t("cancel_plan")
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");


function $51be703911e28a49$export$e1a7de3b83e5d715(ready) {
    const contextStore = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const [fallbackStore] = (0, $acw62.useState)(()=>new (0, $e188c40f4bf71e3c$export$47a0e4800a1fd7dc)());
    const store = contextStore !== null && contextStore !== void 0 ? contextStore : fallbackStore;
    const plans = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).AccountSubscriptionPlan, {});
    const features = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).AccountSubscriptionPlanFeature, {});
    const pricing = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).AccountSubscriptionPlanPricing, {});
    const extras = (0, $b82e6d2a15bbd8b8$export$5d34c0530ef73ac5)(store, (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).AccountSubscriptionPlan, {});
    const [storeLoaded, setStoreLoaded] = (0, $acw62.useState)(false);
    (0, $9690902269ab2924$export$e4edb3e6a3489a79)([
        (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).AccountSubscriptionPlan,
        (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).AccountSubscriptionPlanFeature,
        (0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).AccountSubscriptionPlanPricing
    ], ready);
    (0, $acw62.useEffect)(()=>{
        if (!ready) return;
        if (store.isQueryFetched((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).AccountSubscriptionPlan, {})) {
            setStoreLoaded(true);
            return;
        }
        store.fetchQuery((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).AccountSubscriptionPlan, {}).then(()=>{
            if (store.isQueryFetched((0, $d020ac6bb9bbb2b1$export$988b2caa0df88d45).AccountSubscriptionPlan, {})) setStoreLoaded(true);
        });
    }, [
        ready,
        store
    ]);
    const storedPlans = (0, $acw62.useMemo)(()=>{
        if (!storeLoaded) return undefined;
        return plans.map((plan)=>({
                plan: plan,
                features: features.filter((feature)=>feature.accountSubscriptionPlanId === plan.id),
                pricing: pricing.filter((price)=>price.accountSubscriptionPlanId === plan.id)
            }));
    }, [
        features,
        plans,
        pricing,
        storeLoaded
    ]);
    return {
        plans: storedPlans,
        stripeKey: typeof extras.stripeKey === "string" ? extras.stripeKey : undefined,
        appAccountToken: typeof extras.appAccountToken === "string" ? extras.appAccountToken : undefined
    };
}


const $6b6c7d4ac7ee2ce4$export$dc8ce566b6375bb1 = {
    completeCheckout (api, sessionId) {
        return new (0, $746245e03b78b773$export$3c7919ca4c48cda4)(api).account.checkoutComplete({
            params: {
                sessionId: sessionId
            }
        }).call();
    },
    loadPlans (api) {
        return new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(api).account.plans({
            params: {}
        }).call();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    checkout (api, values) {
        return new (0, $746245e03b78b773$export$3c7919ca4c48cda4)(api).account.checkout({
            params: {},
            body: values
        }).call();
    },
    cancelPlan (api) {
        return new (0, $746245e03b78b773$export$3c7919ca4c48cda4)(api).account.updatePlan({
            params: {}
        }).call();
    }
};
// Locales with a published Privacy Policy translation at logbook.yachts. Any other app
// language (e.g. fr, which has no translation yet) falls back to English.
const $6b6c7d4ac7ee2ce4$var$privacyPolicyLocales = [
    "en",
    "de"
];
const $6b6c7d4ac7ee2ce4$var$privacyPolicyUrl = (language)=>{
    const locale = $6b6c7d4ac7ee2ce4$var$privacyPolicyLocales.includes(language) ? language : "en";
    return `https://logbook.yachts/site/${locale}/privacy`;
};
// Whole days from now until an ISO date (negative once it is in the past).
const $6b6c7d4ac7ee2ce4$var$daysUntil = (iso)=>Math.floor((Date.parse(iso).valueOf() - Date.now()) / 86400000);
// App Store guideline 3.1.2(c): the billed amount must always be shown in the app's own
// purchase flow, not only in Apple's system StoreKit sheet. If the native iapProductInfo
// fetch fails (offline, or the kind of transient StoreKit catalog issue Apple's review
// hit -- see guideline 2.1(b) in the same rejection), fall back to the flat
// Apple-configured price for the skipper plan (44.99, billed in USD for the US storefront
// and EUR for every other one) rather than silently hiding the price row while leaving
// Subscribe enabled.
//
// Keyed on the App Store *storefront*, never the device language: those disagree
// routinely (a German-language iPad on the US storefront is billed in USD), and the
// storefront is the one Apple bills against. With no storefront reported at all, EUR is
// the right default -- the US is the only storefront this product is priced in USD on.
//
// Note this is deliberately NOT derived from the server's plan pricing: that is the
// Stripe price (EUR 39.00), which is intentionally lower than the Apple one.
const $6b6c7d4ac7ee2ce4$var$iapFallbackPrice = (storefront)=>storefront === "USA" ? "$44.99" : "44.99 \u20AC";
function $6b6c7d4ac7ee2ce4$export$fc14f7024165eccb({ account: account, backAction: backAction, checkoutSessionId: checkoutSessionId }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("AccountView");
    const [currency, setCurrency] = (0, $acw62.useState)((0, $cf7ac0959066927f$export$4b6b29cad94858db).EUR);
    const [checkoutCompleted, setCheckoutCompleted] = (0, $acw62.useState)(false);
    const [checkoutClientSecret, setCheckoutClientSecret] = (0, $acw62.useState)(undefined);
    const [selected, setSelected] = (0, $acw62.useState)(undefined);
    const [iapPrice, setIapPrice] = (0, $acw62.useState)(undefined);
    // The App Store storefront the device is billed against, used to pick the fallback
    // currency when StoreKit could not resolve the price itself.
    const [iapStorefront, setIapStorefront] = (0, $acw62.useState)(undefined);
    // Which Logbook account holds this Apple ID's subscription, when it is not this one.
    // Discovered without prompting (see the entitlement probe below) so the card can
    // explain the situation instead of offering a purchase Apple would refuse.
    const [linkedAccountName, setLinkedAccountName] = (0, $acw62.useState)(undefined);
    // Set while an explicit Restore Purchases is running, and afterwards to the dialog it
    // produced: a confirmation to move the subscription here, or "nothing to restore".
    const [restoring, setRestoring] = (0, $acw62.useState)(false);
    const [restoreDialog, setRestoreDialog] = (0, $acw62.useState)(undefined);
    const catalogReady = checkoutSessionId === undefined || checkoutCompleted;
    const { plans: plans, stripeKey: stripeKey, appAccountToken: appAccountToken } = (0, $51be703911e28a49$export$e1a7de3b83e5d715)(catalogReady);
    // Show the iOS in-app-purchase view: on in the native iOS app; in a cloud/browser
    // session it stays behind the `logbook-inapp` opt-in. Computed inline (not a
    // one-shot useMemo) because `appStyles` is populated asynchronously from the native
    // bridge after mount, so a frozen memo would capture the pre-bridge value.
    const useNonStripeView = (0, $541a350025917a42$export$f79dc7b36c17c0ec)(app);
    // The skipper plan is represented on iOS by the Apple IAP card. It replaces the
    // regular skipper block (to avoid a confusing duplicate), shows Cancel when the
    // account already has an active IAP subscription, and is hidden entirely when the
    // account is on an active Stripe subscription (Stripe is managed on the web only —
    // an in-app IAP purchase must not be offered on top of a Stripe subscription).
    const skipperPlan = (0, $acw62.useMemo)(()=>(plans || []).find((p)=>p.plan.name === "skipper"), [
        plans
    ]);
    // A cancelled subscription whose paid period has ended (or an expired trial) has lost
    // access, so it must be offered re-subscription rather than a stale "access ends in
    // -N days" countdown. Mirrors the server + app access gate (subscriptionExpired).
    const isSubscriptionExpired = (0, $541a350025917a42$export$9e000f2ff091482)(account);
    const hasActiveSubscription = (account.subscriptionStatus === (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).active || account.subscriptionStatus === (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).cancelled) && !isSubscriptionExpired;
    const activeAppleSubscription = hasActiveSubscription && account.paymentSystem === (0, $7cd0ad1ebf7aa273$export$e22b0e185bbfaf0d).apple;
    const activeStripeSubscription = hasActiveSubscription && account.paymentSystem === (0, $7cd0ad1ebf7aa273$export$e22b0e185bbfaf0d).stripe;
    const activeGiftSubscription = hasActiveSubscription && account.paymentSystem === (0, $7cd0ad1ebf7aa273$export$e22b0e185bbfaf0d).gift;
    const showIapCard = useNonStripeView && !activeStripeSubscription && !activeGiftSubscription;
    // On the IAP-only view (native iOS, or the `?inapp=true` browser) only the skipper
    // plan is available as an in-app purchase, so the non-IAP tiers (captain,
    // master_captain) and the free plan are hidden entirely: the App Store forbids
    // advertising paid content/tiers that cannot be bought via In-App Purchase.
    const visiblePlans = (plans || []).filter((plan)=>!useNonStripeView || plan.plan.name === "skipper");
    // App Store guideline 3.1.2(c): the billed amount must be clearly displayed in the
    // app's own purchase flow, not only in the system StoreKit sheet shown later. Fetches
    // StoreKit's already-localized/formatted price eagerly (it's not instant -- a network
    // round-trip to the App Store) so it's ready by the time the user looks at the card;
    // failing/omitted (e.g. offline) leaves iapPrice unset and the render falls back to
    // iapFallbackPrice() -- the row is never hidden, and Subscribe still works either way.
    (0, $acw62.useEffect)(()=>{
        if (!showIapCard) return;
        (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).loadIAPProductInfo().then((info)=>{
            if (!info) return;
            if (info.price) setIapPrice(info.price);
            if (info.storefront) setIapStorefront(info.storefront);
            // Logged so a storefront/price mismatch reported from the field can be diagnosed
            // without a debug build.
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("loadIAPProductInfo", info);
        }).catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("loadIAPProductInfo error", err));
    }, [
        showIapCard
    ]);
    // Apple never sells the same auto-renewing product twice to one Apple ID, so if this
    // Apple ID's subscription is already linked to a different Logbook account, Subscribe
    // here can only ever land the user in a StoreKit sheet that says "you're already
    // subscribed". Probe for that on opening the card — the native side reconciles the
    // entitlements the device already holds without contacting the App Store, so this
    // never triggers a sign-in prompt — and swap the button for an explanation.
    (0, $acw62.useEffect)(()=>{
        if (!showIapCard || activeAppleSubscription) return;
        (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).loadAppStoreEntitlementState().then((result)=>{
            if ((result === null || result === void 0 ? void 0 : result.outcome) === "linkedToAnotherAccount") setLinkedAccountName(result.accountName);
        }).catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("appStoreEntitlementState error", err));
    }, [
        showIapCard,
        activeAppleSubscription
    ]);
    (0, $acw62.useEffect)(()=>{
        const load = async ()=>{
            if (checkoutSessionId && !checkoutCompleted) {
                const response = await $6b6c7d4ac7ee2ce4$export$dc8ce566b6375bb1.completeCheckout(app.apiClient, checkoutSessionId);
                if (response && response.planId) {
                    const planid = response.planId;
                    const account = app.account;
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("Checkout complete");
                    setCheckoutCompleted(true);
                    if (account) app.updateSession(Object.assign(Object.assign({}, account), {
                        accountSubscriptionPlanId: planid,
                        subscriptionStatus: (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).active
                    }));
                } else return;
            }
        };
        load().catch(console.error);
    }, [
        checkoutSessionId,
        checkoutCompleted
    ]);
    const selectCheckoutPlan = (0, $acw62.useCallback)(async (selection)=>{
        if (!checkoutClientSecret) {
            const reponse = await $6b6c7d4ac7ee2ce4$export$dc8ce566b6375bb1.checkout(app.apiClient, {
                currency: currency,
                lang: app.language,
                planId: selection.plan.id,
                planPricingId: selection.pricing.id,
                url: window.location.href
            });
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("checkout response", selection.plan.id, reponse.clientSecret != undefined);
            setCheckoutClientSecret(reponse.clientSecret);
        }
        setSelected(selection);
    }, []);
    const cancelPlan = (0, $acw62.useCallback)(async ()=>{
        const response = await $6b6c7d4ac7ee2ce4$export$dc8ce566b6375bb1.cancelPlan(app.apiClient);
        if (response && response.success) window.location.reload();
    }, []);
    // Start the native StoreKit purchase (buy the skipper IAP product).
    const performIapPurchase = (0, $acw62.useCallback)(()=>{
        (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).performIAP("skipper", appAccountToken);
    }, [
        appAccountToken
    ]);
    // Open the native system Manage Subscriptions sheet. Apple subscriptions can only be
    // cancelled there (not server-side); cancelling emits a DID_CHANGE_RENEWAL_STATUS
    // notification the webhook reflects on the account.
    const manageSubscriptions = (0, $acw62.useCallback)(()=>{
        (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).manageSubscriptions();
    }, []);
    // App Store guideline 3.1.1: users must be able to explicitly initiate a restore —
    // relying only on the automatic entitlement sync on launch is not sufficient. The
    // native side re-fetches the Apple ID's transaction history and re-posts every
    // entitlement to the server, then reports what happened.
    const applySyncResult = (0, $acw62.useCallback)((result)=>{
        switch(result === null || result === void 0 ? void 0 : result.outcome){
            case "activated":
            case "claimed":
                // The account changed server-side; reload so the page reflects it.
                window.location.reload();
                break;
            case "linkedToAnotherAccount":
                // The subscription belongs to another Logbook account. Offer to move it —
                // never silently, since that account loses access.
                setLinkedAccountName(result.accountName);
                setRestoreDialog("claim");
                break;
            default:
                setRestoreDialog("nothing");
                break;
        }
    }, []);
    const restorePurchases = (0, $acw62.useCallback)(async ()=>{
        setRestoring(true);
        try {
            applySyncResult(await (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).restorePurchases());
        } finally{
            setRestoring(false);
        }
    }, [
        applySyncResult
    ]);
    // The user confirmed moving the subscription to this account. Only this path may
    // transfer it; the automatic reconciliation never does.
    const claimSubscription = (0, $acw62.useCallback)(async ()=>{
        const result = await (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).claimAppStoreSubscription();
        setRestoreDialog(undefined);
        applySyncResult(result);
    }, [
        applySyncResult
    ]);
    const _selectCurrency = (0, $acw62.useCallback)((currency)=>{
        if (currency && currency in (0, $cf7ac0959066927f$export$4b6b29cad94858db)) setCurrency(currency);
    }, []);
    const stripePromise = (0, $acw62.useMemo)(()=>stripeKey ? (0, $2110bf72a86f956f$export$de80f7562c3fd6b1)(stripeKey) : null, [
        stripeKey
    ]);
    const [_stripeOptions, checkoutOptions, _paymentOptions, _addressOptions] = (0, $acw62.useMemo)(()=>{
        if (!selected) return [
            {},
            {
                clientSecret: checkoutClientSecret || "",
                elementsOptions: {}
            },
            {},
            {}
        ];
        const elements = {
            mode: "subscription",
            amount: selected.pricing.price,
            currency: selected.pricing.currency.toLowerCase(),
            appearance: {
                theme: app.theme == "light" ? "stripe" : "night"
            }
        };
        const checkout = {
            clientSecret: checkoutClientSecret || ""
        };
        const payment = {
            layout: "accordion",
            business: {
                name: "Trimutic UG (haftungsbeschr\xe4nkt)"
            }
        };
        const address = {
            mode: "billing"
        };
        return [
            elements,
            checkout,
            payment,
            address
        ];
    }, [
        selected
    ]);
    const _price = (0, $acw62.useMemo)(()=>plans && selected && t(`price_${currency}`, {
            price: Math.floor(selected.pricing.price / 100),
            duration: t(`price_duration_${selected.pricing.duration}`)
        }), [
        plans,
        selected,
        currency
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AccountView",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "AccountView-payment",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                        className: "block-row-center",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "block_field_plans_600",
                                children: t(useNonStripeView ? "plans_iPad" : "plans")
                            }),
                            checkoutSessionId && (checkoutCompleted ? (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                message: (m)=>m.subscription.checkoutComplete
                            }) : (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                message: (m)=>m.subscription.checkoutProcessing
                            }))
                        ]
                    }),
                    plans ? (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: selected && !useNonStripeView ? (0, $7b02d682eb115277$exports.jsx)((0, $7bf3b98cbc00db03$exports.EmbeddedCheckoutProvider), {
                            stripe: stripePromise,
                            options: checkoutOptions,
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $7bf3b98cbc00db03$exports.EmbeddedCheckout), {})
                        }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                                    className: "block-row-center block_field_plans_600",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                        message: (m)=>useNonStripeView ? m.subscription.subscriptionMessageiPad : m.subscription.subscriptionMessage,
                                        className: "text-bigger"
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                                    className: `AccountView-plans${useNonStripeView ? " non-stripe-view" : ""}`,
                                    children: visiblePlans.map((plan)=>{
                                        // On iOS the skipper plan is shown as the Apple IAP card: Subscribe, or
                                        // Cancel when the account already has an active IAP subscription. It
                                        // replaces the regular skipper block to avoid a duplicate, and is hidden
                                        // when the account is on an active Stripe subscription (the regular block
                                        // below handles Stripe management in that case).
                                        if (useNonStripeView && plan.plan.name === "skipper" && showIapCard) return [
                                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                                                    "AccountView-plan",
                                                    "AccountView-plan-skipper",
                                                    "AccountView-plan-iap",
                                                    activeAppleSubscription && "active"
                                                ]),
                                                children: [
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                        children: (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                            className: "AccountView-plan-name",
                                                            children: t("plan_skipper")
                                                        })
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                                            message: (m)=>m.planDescriptions.skipper_inApp,
                                                            className: "AccountView-plan-description"
                                                        })
                                                    }),
                                                    skipperPlan && skipperPlan.features.filter((f)=>f.amount != 0).map((f)=>{
                                                        var _a, _b;
                                                        let feature = null;
                                                        switch(f.feature){
                                                            case "active_ships":
                                                            case "active_users":
                                                            case "active_tenders":
                                                                feature = (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                                    className: "AccountView-plan-info",
                                                                    children: t(`feature_${f.feature}`, {
                                                                        amount: ((_a = f.amount) !== null && _a !== void 0 ? _a : 0) < 0 ? t("feature_unlimited") : (_b = f.amount) !== null && _b !== void 0 ? _b : 0
                                                                    })
                                                                });
                                                                break;
                                                            case "support":
                                                                feature = (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                                    className: "AccountView-plan-info",
                                                                    children: t(`feature_support_${f.amount}`)
                                                                });
                                                                break;
                                                            default:
                                                                return null;
                                                        }
                                                        return (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                            children: feature
                                                        }, f.feature);
                                                    }),
                                                    activeAppleSubscription ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            account.subscriptionStatus === (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).cancelled ? account.nextBillingAt && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                                    children: (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            children: t("cancelled_ends", {
                                                                                days: $6b6c7d4ac7ee2ce4$var$daysUntil(account.nextBillingAt)
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            }) : account.nextBillingAt && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                                    children: (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        children: (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                            children: t("renews_in", {
                                                                                days: $6b6c7d4ac7ee2ce4$var$daysUntil(account.nextBillingAt)
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        onClick: ()=>manageSubscriptions(),
                                                                        className: "button subscribe-button",
                                                                        children: t("cancel_plan")
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: [
                                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                                className: "block-row-no-margin price-row",
                                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                                    className: "AccountView-plan-price-info",
                                                                    children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "price block-row-actions",
                                                                        children: t("price_native", {
                                                                            price: iapPrice || $6b6c7d4ac7ee2ce4$var$iapFallbackPrice(iapStorefront),
                                                                            duration: t("price_duration_30")
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                                className: "AccountView-plan-price-info duration-info block-row-no-margin",
                                                                children: t("duration_30_iap")
                                                            }),
                                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                                    children: linkedAccountName ? // Apple will not sell this Apple ID the same
                                                                    // subscription twice, so Subscribe could only open a
                                                                    // StoreKit sheet saying "you're already subscribed".
                                                                    // Explain where the subscription is, and point at
                                                                    // Restore Purchases as the way to move it here.
                                                                    (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "AccountView-plan-linked-elsewhere",
                                                                        children: [
                                                                            t("linked_to_other_account", {
                                                                                account: linkedAccountName
                                                                            }),
                                                                            " ",
                                                                            t("linked_to_other_account_hint")
                                                                        ]
                                                                    }) : (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        onClick: ()=>performIapPurchase(),
                                                                        className: "button subscribe-button",
                                                                        children: t("subscribe_api")
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, "apple-iap-skipper"),
                                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex-break"
                                            }, "flex-break")
                                        ];
                                        return [
                                            useNonStripeView ? (0, $7b02d682eb115277$exports.jsx)((0, $19c3c116f7347f2b$export$811110f515271376), {
                                                active: account.accountSubscriptionPlanId == plan.plan.id && !isSubscriptionExpired,
                                                cancelCallback: cancelPlan,
                                                canSubscribe: account.accountSubscriptionPlanId == 1 || isSubscriptionExpired,
                                                currency: currency,
                                                plan: plan
                                            }, plan.plan.id) : (0, $7b02d682eb115277$exports.jsx)((0, $e1f14a732c3f22f3$export$2d86d2220712b394), {
                                                active: account.accountSubscriptionPlanId == plan.plan.id && !isSubscriptionExpired,
                                                cancelCallback: cancelPlan,
                                                canSubscribe: account.accountSubscriptionPlanId == 1 || isSubscriptionExpired,
                                                currency: currency,
                                                plan: plan,
                                                selectCallback: (pricing)=>selectCheckoutPlan({
                                                        plan: plan.plan,
                                                        pricing: pricing
                                                    })
                                            }, plan.plan.id)
                                        ];
                                    })
                                }),
                                useNonStripeView && // App Store guideline 3.1.2: a functional link to the Terms of Use (EULA)
                                // and Privacy Policy must be shown wherever the native App Store IAP
                                // purchase flow is offered. Apple's own standard EULA is used (registered
                                // in App Store Connect), so it's linked here rather than a custom one; it
                                // has a single canonical URL with no per-language variant, unlike the
                                // Privacy Policy, which is localized to the app language.
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                                    className: "block-row-center AccountView-legal-links",
                                    children: (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-centered",
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "https://www.apple.com/legal/internet-services/itunes/dev/stdeula/",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: t("terms_of_use")
                                            }),
                                            " \xb7 ",
                                            (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: $6b6c7d4ac7ee2ce4$var$privacyPolicyUrl(app.language),
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: t("privacy_policy")
                                            })
                                        ]
                                    })
                                }),
                                useNonStripeView && // App Store guideline 3.1.1: a distinct, user-initiated "Restore" action
                                // is required — automatically restoring on launch is explicitly called out
                                // by Apple as insufficient. Always shown on the IAP view (not just when a
                                // subscription is missing) so it's reachable regardless of account state.
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                                    className: "block-row-center",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        actions: true,
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    restorePurchases().catch((err)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("restorePurchases error", err));
                                                },
                                                className: "button",
                                                disabled: restoring,
                                                children: restoring ? t("restore_purchases_running") : t("restore_purchases")
                                            })
                                        })
                                    })
                                }),
                                restoreDialog === "claim" && // The other account loses access, so this is never done silently: the
                                // user is told exactly which account holds the subscription and must
                                // confirm before it moves.
                                (0, $7b02d682eb115277$exports.jsx)((0, $e7bc01546cf183b2$export$2cc85109a937009e), {
                                    awaitConfirm: true,
                                    cancelLabel: t("restore_claim_cancel"),
                                    confirmLabel: t("restore_claim_confirm"),
                                    message: t("restore_claim_message", {
                                        account: linkedAccountName || "",
                                        current: account.name
                                    }),
                                    onCancel: ()=>setRestoreDialog(undefined),
                                    onConfirm: claimSubscription,
                                    title: t("restore_claim_title")
                                }),
                                restoreDialog === "nothing" && (0, $7b02d682eb115277$exports.jsx)((0, $43e7c9e0370237d7$export$b605456b9cec4c34), {
                                    message: t("restore_nothing_message"),
                                    onClose: ()=>setRestoreDialog(undefined),
                                    title: t("restore_nothing_title")
                                })
                            ]
                        })
                    }) : (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                className: "block-row-center margin-top-large",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    actions: true,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button",
                            onClick: backAction,
                            children: t("cancel")
                        })
                    })
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





// The wire shape of an API error, in one place.
//
// A route handler throws a `LogbookApiError`; app-base's dispatcher runs it through
// `AppBase.Http.Server.errorResponse`, which serialises the `ApiError` conformance in
// `Sources/LogbookApi/Api.swift` as `{error: "<case name>", status: <code>}`. `Client.call`
// catches the resulting `HttpStatusError` and re-throws that body with an added
// `httpStatus` (see App/Client.ts).
//
// Before the move to app-base routing the server was Vapor, whose `ErrorMiddleware`
// wrote `{error: true, reason: "<case name>"}` instead. Call sites that still tested for
// that shape silently stopped recognising every error -- the cause of #1449 and #1820 --
// so the tolerance for it lives here and nowhere else: a caller asks for the reason, not
// for a shape.
function $6ae1228e0cc3b7e8$var$errorBody(error) {
    return error != null && typeof error == "object" ? error : undefined;
}
function $6ae1228e0cc3b7e8$export$3f914597308532a(error) {
    const body = $6ae1228e0cc3b7e8$var$errorBody(error);
    if (!body) return undefined;
    if (typeof body.error == "string" && body.error.length > 0) return body.error;
    if (body.error === true && typeof body.reason == "string" && body.reason.length > 0) return body.reason;
    return undefined;
}
function $6ae1228e0cc3b7e8$export$1df8e09a620b24e0(error) {
    const body = $6ae1228e0cc3b7e8$var$errorBody(error);
    if (!body) return undefined;
    if (typeof body.httpStatus == "number") return body.httpStatus;
    return typeof body.status == "number" ? body.status : undefined;
}
function $6ae1228e0cc3b7e8$export$89d83cc97c52a37(error, reason) {
    return $6ae1228e0cc3b7e8$export$3f914597308532a(error) === reason;
}



















// The flag a companion reconnect adds to its redirect when it cannot reach its primary
// (`companionUnreachable` in `ShipApi.swift`). Mirrors `companion_disconnected`, which
// `AppView` reads the same way.
const $9e9d787f653f3415$var$COMPANION_ERROR_PARAM = "companion_error";
function $9e9d787f653f3415$export$87281bbc304c1dcb() {
    if (typeof window == "undefined") return false;
    const params = new URLSearchParams(window.location.search);
    if (!params.get($9e9d787f653f3415$var$COMPANION_ERROR_PARAM)) return false;
    params.delete($9e9d787f653f3415$var$COMPANION_ERROR_PARAM);
    const query = params.toString();
    window.history.replaceState({}, "", `${window.location.pathname}${query ? `?${query}` : ""}`);
    return true;
}
var $9e9d787f653f3415$export$ebc594a7b972b373;
(function(AccountSettingsEditAccount) {
    AccountSettingsEditAccount[AccountSettingsEditAccount["none"] = 0] = "none";
    AccountSettingsEditAccount[AccountSettingsEditAccount["name"] = 1] = "name";
    AccountSettingsEditAccount[AccountSettingsEditAccount["password"] = 2] = "password";
})($9e9d787f653f3415$export$ebc594a7b972b373 || ($9e9d787f653f3415$export$ebc594a7b972b373 = {}));
const $9e9d787f653f3415$export$8cc84bc7e229cfa5 = {
    loadLocalShips (api) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.local({
            params: {}
        }).call();
    },
    loadAccountUsers (api) {
        return new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(api).account.users({
            params: {}
        }).call();
    },
    loadAccountPlan (api) {
        return new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(api).account.plan({
            params: {}
        }).call();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    updateAccountUser (api, values) {
        return new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(api).account.updateUser({
            params: {},
            body: values
        }).call();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    updatePassword (api, values) {
        return new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(api).account.updatePassword({
            params: {},
            body: values
        }).call();
    },
    accountShips (ships, account) {
        return ships === null || ships === void 0 ? void 0 : ships.filter((s)=>!account || s.accountId == account.id);
    },
    sharedShips (ships, account) {
        return ships === null || ships === void 0 ? void 0 : ships.filter((s)=>account && s.accountId != account.id);
    },
    accountUserLevelText (tt, level) {
        switch(level){
            case (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).disabled:
                return tt("account_user_level_disabled");
            case (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).user:
                return tt("account_user_level_user");
            case (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin:
                return tt("account_user_level_admin");
            default:
                return String(level);
        }
    }
};


function $93dc0b2fce6ab419$export$83ce790aa5ec9ddb({ editAccount: editAccount, setEditAccount: setEditAccount, editAccountError: editAccountError, editAccountAction: editAccountAction, saveAccountUser: saveAccountUser, showPassword: showPassword, setShowPassword: setShowPassword, accountDeletable: accountDeletable }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { setAppOverlay: setAppOverlay } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const t = app.getT("AccountSettingsView");
    const user = app.user || {
        accountId: undefined,
        email: "",
        name: "",
        shortname: ""
    };
    const account = app.account;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: "account-data-block",
        children: [
            editAccountError && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "error",
                        children: t(`error_${editAccountError}`)
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                editableFields: editAccount == (0, $9e9d787f653f3415$export$ebc594a7b972b373).password ? [
                    "oldPassword",
                    "password",
                    "passwordConfirmation"
                ] : [
                    "accountName",
                    "name",
                    "shortname"
                ],
                onSave: saveAccountUser,
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "account-settings-action-buttons",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: editAccount == (0, $9e9d787f653f3415$export$ebc594a7b972b373).none && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button",
                                        onClick: ()=>editAccountAction(),
                                        children: t("edit_account")
                                    })
                                })
                            }),
                            editAccount == (0, $9e9d787f653f3415$export$ebc594a7b972b373).none && app.cloudSession() && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button",
                                    onClick: ()=>setEditAccount((0, $9e9d787f653f3415$export$ebc594a7b972b373).password),
                                    children: t("change_password")
                                })
                            }),
                            app.cloudSession() && accountDeletable && editAccount == (0, $9e9d787f653f3415$export$ebc594a7b972b373).none && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button",
                                    onClick: ()=>setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).removeAccount),
                                    children: t("remove_account")
                                })
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: t(editAccount != (0, $9e9d787f653f3415$export$ebc594a7b972b373).password ? "account_data" : "change_password")
                        })
                    }),
                    editAccount != (0, $9e9d787f653f3415$export$ebc594a7b972b373).password ? (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "account_data_row",
                        children: [
                            account && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("account_name"),
                                    className: "block_field_small_30",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: account.name,
                                        name: "accountName",
                                        readOnly: !editAccount
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("account_login"),
                                    className: "block_field_small_30",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            defaultValue: user.email,
                                            name: "login",
                                            readOnly: true
                                        })
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("customer_name"),
                                    className: "block_field_small_30",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: user.name,
                                        name: "name",
                                        readOnly: !editAccount
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("user_shortname"),
                                    className: "block_field_small_16",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: user.shortname,
                                        name: "shortname",
                                        readOnly: !editAccount,
                                        maxLength: 10
                                    })
                                })
                            })
                        ]
                    }, "account_data") : (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                name: "username",
                                autoComplete: "username",
                                value: user.email,
                                readOnly: true,
                                hidden: true
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("current_password"),
                                    className: "block_field_small_30",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        name: "oldPassword",
                                        type: "password",
                                        autoComplete: "current-password",
                                        required: true
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("new_password"),
                                    className: "block_field_small_30",
                                    children: (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "password-field",
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("input", {
                                                name: "password",
                                                type: showPassword ? "text" : "password",
                                                autoComplete: "new-password",
                                                required: true
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                icon: showPassword ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).EyeOn : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).EyeOff,
                                                className: "password-toggle",
                                                onClick: ()=>setShowPassword(!showPassword)
                                            })
                                        ]
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("confirm_new_password"),
                                    className: "block_field_small_30",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        name: "passwordConfirmation",
                                        type: "password",
                                        autoComplete: "new-password",
                                        required: true
                                    })
                                })
                            })
                        ]
                    }, "password_change"),
                    editAccount != (0, $9e9d787f653f3415$export$ebc594a7b972b373).none && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        actions: true,
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button",
                                    onClick: ()=>setEditAccount((0, $9e9d787f653f3415$export$ebc594a7b972b373).none),
                                    children: t("account_edit_cancel")
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "submit",
                                    className: "button default",
                                    children: t("account_edit_save")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}








// Remaining trial days for a trial subscription status, or null when the account
// is not on a trial (e.g. active, cancelled, expired).
function $4ea50f72f4a404c8$var$trialDaysRemaining(status) {
    switch(status){
        case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial1DayLeft:
            return 1;
        case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial2DaysLeft:
            return 2;
        case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial3DaysLeft:
            return 3;
        case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial4DaysLeft:
            return 4;
        case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trial5DaysLeft:
            return 5;
        case (0, $7cd0ad1ebf7aa273$export$4373e6d4d88fe91e).trialStarted:
            return 5;
        default:
            return null;
    }
}
function $4ea50f72f4a404c8$export$e0e75c068d399d06({ accountPlan: accountPlan, available: available, showPlans: showPlans }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("AccountSettingsView");
    const trialDays = $4ea50f72f4a404c8$var$trialDaysRemaining((_a = app.account) === null || _a === void 0 ? void 0 : _a.subscriptionStatus);
    const isTrial = trialDays !== null;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
        className: "subscription-plan-block",
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "button",
                        onClick: ()=>showPlans(),
                        children: t("plans")
                    })
                })
            }),
            app.cloudSession() && available && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: t("subscription")
                        })
                    }),
                    accountPlan ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "account_data_row",
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("plan"),
                                    className: "block_field_small_12",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: app.t(`AccountView_plan_${accountPlan}`),
                                        name: "plan",
                                        readOnly: true
                                    })
                                })
                            }),
                            isTrial ? (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "account_data_row",
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("trial_days_remaining"),
                                    className: "block_field_small_12",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: t("trial_days_value", {
                                            days: trialDays
                                        }),
                                        name: "trial_days",
                                        readOnly: true
                                    })
                                })
                            }) : app.account && app.account.nextBillingAt && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "account_data_row",
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("valid_until"),
                                    className: "block_field_small_12",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        defaultValue: app.format("date", app.account.nextBillingAt),
                                        name: "valid_until",
                                        readOnly: true
                                    })
                                })
                            })
                        ]
                    }) : (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {})
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");















function $a5af037bef7823fc$export$d634f0615b1d25a9({ row: row, ship: ship, selecting: selecting, selectBlocked: selectBlocked, onOpen: onOpen, onConnect: onConnect }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipSelectView");
    const vesselIcon = ship.vesselType == (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).sailing ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).SailingVessel : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).MotorVessel;
    // "Found on your network" is only ever shown as a POSITIVE: duplicate advertisements
    // for one account+ship are deliberately omitted upstream, so the absence of the badge
    // says nothing about whether the ship is reachable -- and must not claim it isn't.
    const nearbyBadge = row.nearby ? (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "ship-select-nearby",
        title: t("nearby_hint"),
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Wifi,
                className: "icon-nearby"
            }),
            " ",
            t("nearby")
        ]
    }) : null;
    const unavailableReason = (reason)=>{
        switch(reason){
            case (0, $9afa59e734ffa505$export$582094c3bb9d2b97).importInProgress:
                return t("unavailable_import_in_progress");
            case (0, $9afa59e734ffa505$export$582094c3bb9d2b97).noPermission:
                return t("unavailable_no_permission");
            case (0, $9afa59e734ffa505$export$582094c3bb9d2b97).shipOpenHere:
                // Not rendered per row: the list states this once under its header
                // (`AccountSettings/ShipsView`), since it describes the device, not the ship.
                return "";
        }
    };
    if (row.state == (0, $9afa59e734ffa505$export$84cca2ac982a48b2).unavailable) return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
            className: "ship-select-unavailable-field",
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "ship-select-unavailable",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                            icon: vesselIcon
                        }),
                        " ",
                        ship.name
                    ]
                }),
                row.unavailable && (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "ship-select-unavailable-reason",
                    children: unavailableReason(row.unavailable)
                })
            ]
        })
    });
    const companion = row.state == (0, $9afa59e734ffa505$export$84cca2ac982a48b2).openElsewhere;
    const label = selecting ? t("selecting") : ship.name;
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("button", {
                    className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                        "button default",
                        "ship-select-button",
                        // Kept as the companion class name the E2E helpers key off to detect a
                        // ship claimed by another device.
                        companion && "ship-select-button-companion",
                        row.state == (0, $9afa59e734ffa505$export$84cca2ac982a48b2).openHere && "ship-select-button-primary"
                    ]),
                    onClick: ()=>{
                        if (companion) {
                            // Always the same dialog, whether or not the ship was discovered --
                            // `nearby` only decides whether an automatic attempt is worth making.
                            onConnect(ship.id, row.nearby);
                            return;
                        }
                        onOpen(ship.id);
                    },
                    // Only this row's own availability disables it. Previously ANY open ship
                    // disabled EVERY row, which conflated "you have a ship open" with "this ship
                    // can't be used" and made the openHere row unclickable (#1279).
                    disabled: selectBlocked || row.blocked != undefined,
                    children: [
                        companion && (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Companion,
                            className: "icon-companion"
                        }),
                        row.state == (0, $9afa59e734ffa505$export$84cca2ac982a48b2).openHere && (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                            icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).CircleFilledLarge,
                            className: "icon-primary"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                            icon: vesselIcon
                        }),
                        " ",
                        label
                    ]
                }),
                nearbyBadge
            ]
        })
    });
}


function $1c937934313b50c8$export$b33f2d61357a4c9e({ nearbyShipIds: nearbyShipIds, ownShipId: ownShipId, ships: ships, users: users, viewable: viewable }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("ShipSelectView");
    const { selectShip: selectShip, setAppOverlay: setAppOverlay } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    // Which ship's select button is currently mid-request. `selectShip` (AppView.tsx)
    // is async and its POST /api/ship can take a while, so without this the button stays
    // clickable for the whole in-flight request and a fast double click fires two
    // concurrent selects for the same ship, racing the server (see LogbookApp.newInstance).
    const [selectingShipId, setSelectingShipId] = (0, $acw62.useState)(undefined);
    const handleSelect = (0, $acw62.useCallback)(async (shipId)=>{
        if (selectingShipId !== undefined) return;
        setSelectingShipId(shipId);
        try {
            await selectShip(shipId);
        } finally{
            setSelectingShipId(undefined);
        }
    }, [
        selectingShipId,
        selectShip
    ]);
    // Every companion connection goes through the one connect dialog, which starts with
    // a spinner when an automatic route looks available and falls back to manual address
    // entry on failure or timeout. `nearby` only decides whether that automatic attempt
    // is worth making -- it never changes which dialog opens, so a row cannot change
    // meaning between render and click (#1279).
    const handleConnect = (0, $acw62.useCallback)((shipId, nearby)=>{
        setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).shipOpen, {
            shipId: shipId,
            nearby: nearby
        });
    }, [
        setAppOverlay
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ShipSelectView",
        children: ships.map((ship)=>{
            const shipUser = users === null || users === void 0 ? void 0 : users.find((u)=>u.shipId == ship.id);
            const row = (0, $a359a1de1c9c067b$export$27e0267f5c02a571)({
                ship: ship,
                user: shipUser,
                ownShipId: ownShipId,
                nearbyShipIds: nearbyShipIds,
                primaryFeature: app.hasFeature("primary"),
                viewable: viewable
            });
            if (app.cloudSession()) {
                // A cloud session has no local ship, no claim token and no LAN discovery --
                // it only ever offers a read-only view plus the options menu.
                const shipData = (0, $3d4dfb4b3a9d38e4$export$7930c61d9b464618).parse(ship).dataParsed;
                const importInProgress = !!(shipData === null || shipData === void 0 ? void 0 : shipData.importStatus) && shipData.importStatus != (0, $ef756702f3923ebb$export$bd5fd2a78082695e).complete && shipData.importStatus != (0, $ef756702f3923ebb$export$bd5fd2a78082695e).failed;
                return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "ship_name_cloud",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                        icon: ship.vesselType == (0, $3d4dfb4b3a9d38e4$export$2852e62327382ca8).sailing ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).SailingVessel : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).MotorVessel
                                    }),
                                    " ",
                                    ship.name
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button",
                                onClick: ()=>{
                                    handleSelect(ship.id);
                                },
                                disabled: importInProgress || selectingShipId !== undefined,
                                children: selectingShipId === ship.id ? t("selecting") : t("view_logbook")
                            }),
                            app.user && app.user.accountId != undefined && (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
                                    "button",
                                    ship.clientToken && "ship-select-button-blue"
                                ]),
                                onClick: ()=>setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).shipListOptions, {
                                        shipId: ship.id
                                    }),
                                children: t("options")
                            })
                        ]
                    })
                }, ship.id);
            }
            return (0, $7b02d682eb115277$exports.jsx)((0, $a5af037bef7823fc$export$d634f0615b1d25a9), {
                row: row,
                ship: ship,
                selecting: selectingShipId === ship.id,
                selectBlocked: selectingShipId !== undefined,
                onOpen: handleSelect,
                onConnect: handleConnect
            }, ship.id);
        })
    });
}




function $32170478d074c45c$export$96db1b093b0fabbf({ accountShips: accountShips, sharedShips: sharedShips, nearbyShipIds: nearbyShipIds, ships: ships, cancelEdit: cancelEdit, companionReconnect: companionReconnect, companionShipId: companionShipIdOverride, companionDisconnectState: companionDisconnectState }) {
    var _a, _b;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { navigateApp: navigateApp, setAppOverlay: setAppOverlay, resetAppOverlay: resetAppOverlay, membership: membership, ownShipId: ownShipId } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const t = app.getT("AccountSettingsView");
    const connectT = app.getT("AppOverlayContentView");
    const [disconnected, setDisconnected] = (0, $acw62.useState)(false);
    const [disconnecting, setDisconnecting] = (0, $acw62.useState)(false);
    const [disconnectFailed, setDisconnectFailed] = (0, $acw62.useState)(false);
    const cleanupPending = disconnecting || companionDisconnectState === "pending";
    const cleanupFailed = !cleanupPending && (disconnectFailed || companionDisconnectState === "failed");
    const storedCompanionShipId = companionShipIdOverride !== null && companionShipIdOverride !== void 0 ? companionShipIdOverride : (0, $2b75519151ca9024$export$8bf6241f4c41c4e0)("logbook-companion");
    const companionShipId = !disconnected && !app.cloudSession() && !app.localSession() && storedCompanionShipId !== ownShipId ? storedCompanionShipId : undefined;
    const user = app.user || {
        accountId: undefined,
        email: "",
        name: "",
        shortname: ""
    };
    const shipSelected = !app.cloudSession() && !!app.shipId && app.shipId !== companionShipId;
    const currentShip = ships === null || ships === void 0 ? void 0 : ships.find((s)=>s.id === app.shipId);
    const shipName = currentShip ? currentShip.name : "";
    const companionName = (_b = (_a = ships === null || ships === void 0 ? void 0 : ships.find((s)=>s.id === companionShipId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
    const disconnectCompanion = async ()=>{
        if (!companionShipId || cleanupPending) return;
        setDisconnecting(true);
        setDisconnectFailed(false);
        (0, $b5c1808b3220ae33$export$ea47b402c0c5f72f)(companionShipId);
        try {
            await (0, $a359a1de1c9c067b$export$6fdd7e23becf9b95).cancelLocal(app.apiClient, companionShipId);
            (0, $b57fb2219af67c07$export$1fb4852a55678982).clearCompanion(companionShipId);
            if (app.shipId === companionShipId) await app.setShipId(companionShipId, true, true);
            setDisconnected(true);
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("companion disconnect failed", error);
            setDisconnectFailed(true);
        } finally{
            setDisconnecting(false);
        }
    };
    return (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
        className: `ShipContentView-empty-select  main-page-containers ${app.cloudSession() ? "cloud-mode" : "app-mode"}`,
        children: [
            false,
            !app.cloudSession() && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    companionShipId && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "current-ship-block",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    className: "error-message",
                                    children: t("companion_reconnect_notice")
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: companionName
                                })
                            }),
                            cleanupFailed && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    className: "error-message companion-disconnect-error",
                                    children: connectT("connect_logbook_failed", {
                                        name: companionName
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button default ship-select-button",
                                        disabled: cleanupPending,
                                        onClick: ()=>setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).shipOpen, {
                                                shipId: companionShipId,
                                                nearby: (nearbyShipIds === null || nearbyShipIds === void 0 ? void 0 : nearbyShipIds.includes(companionShipId)) === true
                                            }),
                                        children: connectT("connect_logbook")
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button ship-select-button companion-disconnect",
                                        disabled: cleanupPending,
                                        onClick: disconnectCompanion,
                                        children: t("ship_close_companion", {
                                            name: companionName
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    shipSelected && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "current-ship-block",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: t("current_ship", {
                                        name: shipName
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "block-row-top0",
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button default ship-select-button",
                                        onClick: ()=>{
                                            navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
                                                shipId: app.shipId
                                            });
                                        },
                                        children: t("ship_logbook", {
                                            name: shipName.replace(/ /g, "\u00A0")
                                        })
                                    })
                                })
                            }),
                            app.primarySession() && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button default ship-select-button",
                                        onClick: ()=>setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).closeShip, {
                                                shipId: app.shipId
                                            }),
                                        children: t("ship_close_confirm", {
                                            name: shipName
                                        })
                                    })
                                })
                            }),
                            app.localSession() && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button default ship-select-button",
                                        onClick: ()=>app.logout(),
                                        children: t("ship_close_companion", {
                                            name: shipName
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    !shipSelected && !companionShipId && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                children: t("no_current_ship")
                            })
                        })
                    })
                ]
            }),
            !app.localSession() && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "ship-select-block",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: t("select_ship")
                                })
                            }),
                            ownShipId != undefined && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "ship-select-blocked-notice-row",
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    className: "ship-select-blocked-notice",
                                    children: t("ship_open_here_notice")
                                })
                            }),
                            companionReconnect && !companionShipId && !disconnected && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    className: "ship-select-blocked-notice error-message companion-reconnect-notice",
                                    children: t("companion_reconnect_notice")
                                })
                            }),
                            accountShips ? (0, $7b02d682eb115277$exports.jsx)((0, $1c937934313b50c8$export$b33f2d61357a4c9e), {
                                nearbyShipIds: nearbyShipIds,
                                ownShipId: ownShipId,
                                ships: accountShips.filter((s)=>s.id !== companionShipId),
                                users: membership
                            }) : (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {}),
                            sharedShips && sharedShips.length > 0 && app.hasFeature("multi-user") && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            children: t("select_shared_ship")
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)((0, $1c937934313b50c8$export$b33f2d61357a4c9e), {
                                        nearbyShipIds: nearbyShipIds,
                                        ships: sharedShips,
                                        viewable: false
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                        className: "new-ship-block",
                        children: user.accountId != undefined && (app.cloudSession() || app.hasFeature("primary")) && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        children: t("new_ship")
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    className: "block-row-top0",
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "button default ship-select-button",
                                            onClick: ()=>app.cloudSession() ? navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).newShip) : app.openServer("ships/new"),
                                            disabled: shipSelected,
                                            children: t("add_new_ship")
                                        })
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "button ship-select-button",
                                            onClick: ()=>setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).importShip),
                                            children: t("import_ship")
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}













var $acw62 = parcelRequire("acw62");







function $8d08b5b028182825$export$81ea6d714e60b4de(store, ids) {
    const refresh = async ()=>{
        await store.fetchQuery("AccountUser", {
            accountId: ids.accountId
        });
    };
    return {
        async updateAccountUserLevel (userId, accountLevel) {
            const current = store.getEntity("AccountUser", userId);
            const response = await store.mutate({
                optimistic: current ? {
                    upsert: {
                        AccountUser: [
                            Object.assign(Object.assign({}, current), {
                                accountLevel: accountLevel
                            })
                        ]
                    }
                } : undefined,
                request: (client)=>new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(client).account.updateUserLevel({
                        params: {
                            userId: userId
                        },
                        body: {
                            accountLevel: accountLevel
                        }
                    }).call()
            });
            await refresh();
            return response;
        },
        async removeAccountUser (userId) {
            const response = await store.mutate({
                optimistic: {
                    remove: {
                        AccountUser: [
                            userId
                        ]
                    }
                },
                request: (client)=>new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(client).account.removeUser({
                        params: {
                            userId: userId
                        }
                    }).call()
            });
            await refresh();
            return response;
        }
    };
}


// Shared hook for the AccountUser row: the level-select auto-save (via EditGroup's
// onSave) plus the direct deactivate/reactivate/remove menu actions. All four paths
// share one `error` slot (only one action is ever in flight per row) fed by the
// server's `accountUserSelfAction`/`accountUserLastAdmin` guards -- surfaced through
// EditGroup's own `error` prop the same way NMEAConfiguration/ConnectionView does.
const $8832bd5f1c2563a9$var$fallbackError = "account_user_action_failed";
function $8832bd5f1c2563a9$export$82d6afa43874a54({ userInfo: userInfo, onChanged: onChanged, initError: initError }) {
    var _a, _b, _c, _d;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const t = app.getT("AccountSettingsView");
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const [error, setError] = (0, $acw62.useState)(initError);
    const [pendingAction, setPendingAction] = (0, $acw62.useState)(undefined);
    const writers = (0, $8d08b5b028182825$export$81ea6d714e60b4de)(store, {
        accountId: (_d = (_b = (_a = app.account) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : (_c = app.user) === null || _c === void 0 ? void 0 : _c.accountId) !== null && _d !== void 0 ? _d : $8832bd5f1c2563a9$var$missingAccountId()
    });
    const applyLevel = (0, $acw62.useCallback)(async (accountLevel)=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("updateAccountUserLevel", userInfo.user.id, accountLevel);
        setError(undefined);
        try {
            await writers.updateAccountUserLevel(userInfo.user.id, accountLevel);
            onChanged();
        } catch (err) {
            // Named or not, the failure has to reach the row (#1820): the old guard tested a
            // wire shape the server stopped sending, so a rejected action showed nothing.
            setError((0, $6ae1228e0cc3b7e8$export$3f914597308532a)(err) || $8832bd5f1c2563a9$var$fallbackError);
        } finally{
            // EditGroup auto-resubmits for as long as `changed` stays true (see its useEffect),
            // so this must run on failure too -- otherwise a rejected select-driven save retries
            // forever.
            resetEdited();
        }
    }, [
        userInfo,
        onChanged
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const updateAccountUser = (0, $acw62.useCallback)(async (_data, values)=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("updateAccountUser", userInfo.user.id);
        await applyLevel(values.accountLevel);
    }, [
        applyLevel
    ]);
    const remove = (0, $acw62.useCallback)(async ()=>{
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("removeAccountUser", userInfo.user.id);
        setError(undefined);
        try {
            await writers.removeAccountUser(userInfo.user.id);
            onChanged();
        } catch (err) {
            // Named or not, the failure has to reach the row (#1820): the old guard tested a
            // wire shape the server stopped sending, so a rejected action showed nothing.
            setError((0, $6ae1228e0cc3b7e8$export$3f914597308532a)(err) || $8832bd5f1c2563a9$var$fallbackError);
        }
    }, [
        userInfo,
        onChanged
    ]);
    // #1025 (tracker #827): deactivating/removing a member who still has ship access somewhere in the
    // account (the same zero-remaining-ship-access condition the server's AccountUser
    // cascade itself uses -- see `userInfo.hasShipAccess`) warns first via a
    // ConfirmDialog (#200); a member without ship access is unaffected by the cascade,
    // so those actions still fire immediately, matching #979's existing behavior.
    const deactivate = (0, $acw62.useCallback)(()=>{
        if (userInfo.hasShipAccess) setPendingAction("deactivate");
        else applyLevel((0, $0b2bdaa8112b7188$export$103b1fca92a0adba).disabled);
    }, [
        applyLevel,
        userInfo
    ]);
    const reactivate = (0, $acw62.useCallback)(()=>applyLevel((0, $0b2bdaa8112b7188$export$103b1fca92a0adba).user), [
        applyLevel
    ]);
    const requestRemove = (0, $acw62.useCallback)(()=>{
        if (userInfo.hasShipAccess) setPendingAction("remove");
        else remove();
    }, [
        remove,
        userInfo
    ]);
    const cancelPendingAction = (0, $acw62.useCallback)(()=>setPendingAction(undefined), []);
    const confirmPendingAction = (0, $acw62.useCallback)(async ()=>{
        if (pendingAction === "deactivate") await applyLevel((0, $0b2bdaa8112b7188$export$103b1fca92a0adba).disabled);
        else if (pendingAction === "remove") await remove();
        setPendingAction(undefined);
    }, [
        pendingAction,
        applyLevel,
        remove
    ]);
    return {
        app: app,
        t: t,
        edited: edited,
        onEdited: onEdited,
        error: error,
        updateAccountUser: updateAccountUser,
        deactivate: deactivate,
        reactivate: reactivate,
        remove: requestRemove,
        pendingAction: pendingAction,
        cancelPendingAction: cancelPendingAction,
        confirmPendingAction: confirmPendingAction
    };
}
function $8832bd5f1c2563a9$var$missingAccountId() {
    throw new Error("AccountUser mutation requires an active account");
}


function $268bfced59fa04ab$export$c38be53abaf8dd66({ accountUserLevelOptions: accountUserLevelOptions, onChanged: onChanged, userInfo: userInfo, initError: initError }) {
    var _a;
    const { app: app, t: t, edited: edited, onEdited: onEdited, error: error, updateAccountUser: updateAccountUser, deactivate: deactivate, reactivate: reactivate, remove: remove, pendingAction: pendingAction, cancelPendingAction: cancelPendingAction, confirmPendingAction: confirmPendingAction } = (0, $8832bd5f1c2563a9$export$82d6afa43874a54)({
        userInfo: userInfo,
        onChanged: onChanged,
        initError: initError
    });
    const isSelf = userInfo.user.id === ((_a = app.user) === null || _a === void 0 ? void 0 : _a.id);
    const isDisabled = userInfo.level === (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).disabled;
    const deactivatedClass = isDisabled ? "user_deactivated" : "";
    const menuItems = [
        ...!isDisabled ? [
            {
                id: "deactivate_user",
                onClick: ()=>{
                    deactivate();
                    return true;
                },
                title: t("deactivate_user")
            }
        ] : [
            {
                id: "reactivate_user",
                onClick: ()=>{
                    reactivate();
                    return true;
                },
                title: t("reactivate_user")
            }
        ],
        (0, $07fea78136a1afdb$export$2b6ac906eb59b21b),
        {
            id: "remove_user",
            onClick: ()=>{
                remove();
                return true;
            },
            title: t("remove_user")
        }
    ];
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                changed: edited,
                editableFields: [
                    {
                        name: "accountLevel",
                        type: "int"
                    }
                ],
                onSave: updateAccountUser,
                error: error && t("error_" + error),
                className: "editgroup_boxed",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "ShipUserEditView-row",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("user_name"),
                            className: "block_field_small_20",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: "name",
                                defaultValue: userInfo.user.name,
                                readOnly: true,
                                className: deactivatedClass
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("user_email"),
                            className: "block_field_small_20",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: "email",
                                defaultValue: userInfo.user.email,
                                readOnly: true,
                                className: deactivatedClass
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("user_shortname"),
                            className: "block_field_small_8",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: "shortname",
                                defaultValue: userInfo.user.shortname,
                                readOnly: true,
                                className: deactivatedClass
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("account_user_level"),
                            className: "block_field_small_8",
                            children: isSelf || isDisabled ? (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: "accountLevel",
                                value: t(`account_user_level_${(0, $0b2bdaa8112b7188$export$103b1fca92a0adba)[userInfo.level]}`),
                                readOnly: true,
                                className: deactivatedClass
                            }) : // Uncontrolled: the select only exists while `!isDisabled`, so it always
                            // (re)mounts fresh whenever `userInfo.level` last changed via deactivate/
                            // reactivate. A `value=` binding to the (unchanged-by-onChange) prop would
                            // have React snap the DOM back on every render, before EditGroup's effect
                            // gets to read the just-picked value out of FormData.
                            (0, $7b02d682eb115277$exports.jsx)("select", {
                                defaultValue: userInfo.level,
                                name: "accountLevel",
                                onChange: onEdited,
                                children: accountUserLevelOptions
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("user_status"),
                            className: "block_field_small_8",
                            children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                name: "user_status",
                                defaultValue: t(`user_status_${userInfo.status}`),
                                readOnly: true,
                                className: deactivatedClass
                            })
                        }),
                        !isSelf && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            className: "button_user_options user_options",
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $07fea78136a1afdb$export$d9b273488cd8ce6f), {
                                button: "...",
                                buttonClass: "button",
                                global: true,
                                items: menuItems
                            })
                        })
                    ]
                })
            }, userInfo.user.id),
            pendingAction && (0, $7b02d682eb115277$exports.jsx)((0, $e7bc01546cf183b2$export$2cc85109a937009e), {
                awaitConfirm: true,
                title: t(`user_${pendingAction}_confirm_title`),
                message: t(`user_${pendingAction}_confirm_message`),
                confirmLabel: t(`user_${pendingAction}_confirm_accept`),
                cancelLabel: t(`user_${pendingAction}_confirm_cancel`),
                style: "alarm",
                onConfirm: confirmPendingAction,
                onCancel: cancelPendingAction
            })
        ]
    });
}


function $86c5553d8bed38db$export$c94696addbdaa713({ accountUserInfos: accountUserInfos, accountUserLevelOptions: accountUserLevelOptions, onChanged: onChanged }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("AccountSettingsView");
    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
        className: "ShipContentView-empty-select  main-page-containers",
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                        children: t("users_list")
                    })
                }),
                accountUserInfos == undefined ? (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {}) : accountUserInfos.map((userInfo)=>(0, $7b02d682eb115277$exports.jsx)((0, $268bfced59fa04ab$export$c38be53abaf8dd66), {
                        userInfo: userInfo,
                        accountUserLevelOptions: accountUserLevelOptions,
                        onChanged: onChanged
                    }, userInfo.user.id))
            ]
        })
    });
}



var $acw62 = parcelRequire("acw62");

function $dbdd1a292a030083$export$7347b691ca27b025(accountId, enabled, requestVersion) {
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const accountUsers = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, "AccountUser", {
        accountId: accountId
    });
    const users = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, "User", {
        accountId: accountId
    });
    const extras = (0, $b82e6d2a15bbd8b8$export$5d34c0530ef73ac5)(store, "AccountUser", {
        accountId: accountId
    });
    const [loaded, setLoaded] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || accountId === undefined) {
            setLoaded(false);
            return;
        }
        let active = true;
        setLoaded(store.isQueryFetched("AccountUser", {
            accountId: accountId
        }));
        store.fetchQueryStrict("AccountUser", {
            accountId: accountId
        }).then(()=>{
            if (active) setLoaded(true);
        }).catch(console.error);
        return ()=>{
            active = false;
        };
    }, [
        store,
        accountId,
        enabled,
        requestVersion
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || accountId === undefined) return;
        let active = true;
        store.retain("AccountUser");
        store.retain("User");
        const refresh = ()=>{
            store.fetchQueryStrict("AccountUser", {
                accountId: accountId
            }).then(()=>{
                if (active) setLoaded(true);
            }).catch(console.error);
        };
        const unsubscribeAccountUser = store.subscribeLive("AccountUser", refresh);
        const unsubscribeUser = store.subscribeLive("User", refresh);
        return ()=>{
            active = false;
            unsubscribeUser();
            unsubscribeAccountUser();
            store.release("User");
            store.release("AccountUser");
        };
    }, [
        store,
        accountId,
        enabled
    ]);
    return (0, $acw62.useMemo)(()=>{
        var _a;
        if (!enabled || !loaded) return undefined;
        const usersById = new Map(users.map((user)=>[
                user.id,
                user
            ]));
        const infoById = (_a = extras.accountUserInfo) !== null && _a !== void 0 ? _a : {};
        return accountUsers.flatMap((accountUser)=>{
            const user = usersById.get(accountUser.userId);
            const info = infoById[accountUser.userId];
            if (!user || !info) return [];
            return [
                {
                    level: accountUser.accountLevel,
                    status: info.status,
                    hasShipAccess: info.hasShipAccess,
                    user: user
                }
            ];
        });
    }, [
        enabled,
        loaded,
        accountUsers,
        users,
        extras
    ]);
}


function $fd9f921a92bb998b$export$21d8166b98f38a62({ cancelEdit: cancelEdit, ships: ships, companionReconnect: companionReconnectOverride, companionShipId: companionShipId, companionDisconnectState: companionDisconnectState, initTab: initTab }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { apiUser: apiUser } = (0, $97ac05743b787a86$export$251c0204053e076a)();
    const [accountUsersRequestVersion, setAccountUsersRequestVersion] = (0, $acw62.useState)(0);
    const [accountPlan, setAccountPlan] = (0, $acw62.useState)(undefined);
    const [editAccountError, setEditAccountError] = (0, $acw62.useState)(undefined);
    const [editAccount, setEditAccount] = (0, $acw62.useState)((0, $9e9d787f653f3415$export$ebc594a7b972b373).none);
    // Ship ids currently advertised on the LAN. Updated from the local-ship broadcasts,
    // which arrive independently of renders -- so every update is functional and
    // deduplicated. The previous `setLocalShips([...localShips, ship.id])` closed over a
    // stale array, so two broadcasts landing before a re-render lost one, and repeated
    // `create` broadcasts for the same ship appended duplicates. `update` (a re-resolved
    // advertisement) was ignored entirely, so a ship that changed address never appeared.
    const [nearbyShipIds, setNearbyShipIds] = (0, $acw62.useState)(undefined);
    // Whether this device landed here because a stored companion pairing could not be
    // reached. Read once, at the edge, so the views below stay functions of their props
    // and the flag can be rendered from a catalog fixture (#1388).
    const [companionReconnect] = (0, $acw62.useState)(()=>companionReconnectOverride !== null && companionReconnectOverride !== void 0 ? companionReconnectOverride : (0, $9e9d787f653f3415$export$87281bbc304c1dcb)());
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const { loadShips: loadShips, navigateApp: navigateApp } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    // account.plan()/account.delete() are the real predicates behind the subscription
    // info block and the remove-account button — replaces earlier hand-rolled presence
    // checks with the generated permission matrix (#931 Phase G). The subscription
    // TAB itself stays gated on session-type (`user.accountId`/`app.localSession()`)
    // since it also hosts account-name editing, which isn't behind accountLevel().
    const accountPlanAvailable = (0, $acw62.useMemo)(()=>new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(app.apiClient).account.plan({
            params: {}
        }).available(apiUser), [
        app.apiClient,
        apiUser
    ]);
    const accountDeletable = (0, $acw62.useMemo)(()=>new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(app.apiClient).account.delete({
            params: {}
        }).available(apiUser), [
        app.apiClient,
        apiUser
    ]);
    const accountUsersAvailable = (0, $acw62.useMemo)(()=>new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(app.apiClient).account.users({
            params: {}
        }).available(apiUser), [
        app.apiClient,
        apiUser
    ]);
    // The account-level select only ever offers user/admin -- disabled is exclusively
    // reachable through the deactivate/reactivate menu actions on each row, never a
    // dropdown choice (mirrors ShipDataView's shipUserLevelOptions convention).
    const accountUserLevelOptions = (0, $acw62.useMemo)(()=>{
        const tt = app.getT("AccountSettingsView");
        return [
            (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).user,
            (0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin
        ].map((level)=>(0, $7b02d682eb115277$exports.jsx)("option", {
                value: level,
                children: (0, $9e9d787f653f3415$export$8cc84bc7e229cfa5).accountUserLevelText(tt, level)
            }, level));
    }, []);
    const t = app.getT("AccountSettingsView");
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)((ship, _type, info)=>{
        if (info == "create" || info == "update") // `update` is a re-advertised/re-resolved service for a ship already known --
        // idempotent here, but it must still ADD a ship first seen via an update.
        setNearbyShipIds((previous)=>{
            const current = previous || [];
            return current.indexOf(ship.id) >= 0 ? current : [
                ...current,
                ship.id
            ];
        });
        else if (info == "delete") setNearbyShipIds((previous)=>previous === null || previous === void 0 ? void 0 : previous.filter((id)=>id != ship.id));
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).LocalShip);
    const user = app.user || {
        accountId: undefined,
        email: "",
        name: "",
        shortname: ""
    };
    const account = app.account;
    const accountUserInfos = (0, $dbdd1a292a030083$export$7347b691ca27b025)(user.accountId, accountUsersRequestVersion > 0, accountUsersRequestVersion);
    // iOS in-app-purchase mode: on in the native iOS app; in a cloud/browser session
    // it stays behind the `logbook-inapp` opt-in. Computed inline (not a one-shot
    // useMemo) because `appStyles` is populated asynchronously from the native bridge
    // after mount, so a frozen memo would capture the pre-bridge value.
    const inApp = (0, $541a350025917a42$export$f79dc7b36c17c0ec)(app);
    const separateSharedShips = app.hasFeature("multi-user");
    (0, $acw62.useEffect)(()=>{
        if (!ships) loadShips();
        if (!nearbyShipIds && app.hasFeature("bonjour")) {
            const load = async ()=>{
                const response = await (0, $9e9d787f653f3415$export$8cc84bc7e229cfa5).loadLocalShips(app.apiClient);
                if (response && response.ships) setNearbyShipIds(response.ships);
            };
            load().catch(console.error);
        }
    }, [
        ships
    ]);
    // Tab-click load: only fetches once (accountUserInfos is only populated once this
    // tab is opened).
    const loadAccountUsers = (0, $acw62.useCallback)(async ()=>{
        setAccountUsersRequestVersion((version)=>version + 1);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (initTab === "tab_users") loadAccountUsers().catch(console.error);
    }, [
        initTab,
        loadAccountUsers
    ]);
    const loadAccountPlan = (0, $acw62.useCallback)(async ()=>{
        if (accountPlan) return;
        const data = await (0, $9e9d787f653f3415$export$8cc84bc7e229cfa5).loadAccountPlan(app.apiClient);
        if (data.plan) setAccountPlan(data.plan.name);
    }, [
        accountPlan
    ]);
    const tabSelected = (0, $acw62.useCallback)((value)=>{
        if (value == "tab_users") loadAccountUsers();
        if (value == "tab_subscription" && app.cloudSession() && accountPlanAvailable) loadAccountPlan();
    }, [
        accountPlanAvailable
    ]);
    const showPlans = (0, $acw62.useCallback)(()=>{
        // The subscription/plan view renders in-app for cloud and native iOS (so the
        // StoreKit purchase can run); only a non-iOS native app opens it on the server.
        if ((0, $541a350025917a42$export$750abdcba4148280)(app)) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSubscription);
        else app.openServer("account/subscription");
    }, [
        inApp
    ]);
    const editAccountAction = (0, $acw62.useCallback)(()=>{
        if (app.cloudSession()) setEditAccount((0, $9e9d787f653f3415$export$ebc594a7b972b373).name);
        else if (inApp) app.openServer("account?inapp=true");
        else app.openServer("account");
    }, [
        inApp
    ]);
    const accountShips = (0, $acw62.useMemo)(()=>{
        return (0, $9e9d787f653f3415$export$8cc84bc7e229cfa5).accountShips(ships, separateSharedShips ? account : undefined);
    }, [
        ships,
        account,
        separateSharedShips
    ]);
    const sharedShips = (0, $acw62.useMemo)(()=>{
        return (0, $9e9d787f653f3415$export$8cc84bc7e229cfa5).sharedShips(ships, separateSharedShips ? account : undefined);
    }, [
        ships,
        account,
        separateSharedShips
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const saveAccountUser = (0, $acw62.useCallback)(async (_data, values)=>{
        // Never log `values` — this form doubles as the password change form
        // (issue #1273); the action alone is enough of a trail.
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("saveAccountUser", (0, $9e9d787f653f3415$export$ebc594a7b972b373)[editAccount]);
        setEditAccountError(undefined);
        const request = editAccount == (0, $9e9d787f653f3415$export$ebc594a7b972b373).password ? (0, $9e9d787f653f3415$export$8cc84bc7e229cfa5).updatePassword(app.apiClient, values) : (0, $9e9d787f653f3415$export$8cc84bc7e229cfa5).updateAccountUser(app.apiClient, values);
        const requestIdentity = (0, $73eea1fea92cc6a5$export$fc07fe94f5a41790)(app.session, app.sessionType, app.apiClient.target);
        const result = await request.catch((err)=>{
            // Named or not, the failure has to be visible (#1820): the old `err["error"] == true`
            // guard tested a wire shape the server stopped sending, so a wrong current password
            // silently did nothing at all.
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("saveAccountUser failed");
            setEditAccountError((0, $6ae1228e0cc3b7e8$export$3f914597308532a)(err) || "account_update_failed");
            return undefined;
        });
        if (result) {
            app.reconcileSession(result, requestIdentity);
            setEditAccount((0, $9e9d787f653f3415$export$ebc594a7b972b373).none);
        }
    }, [
        editAccount
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AccountSettingsView",
        "data-catalog-ready": initTab === "tab_users" ? accountUserInfos ? "true" : "false" : undefined,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: t("account_settings")
            }),
            !app.hasFeature("primary") && app.primarySession() && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "message block_field_small_50",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                        html: true,
                        message: (m)=>m.noteText.shipsSmartphone
                    })
                })
            }),
            accountShips && accountShips.length === 0 && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                className: "message block_field_small_50",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                            html: true,
                            message: (m)=>m.noteText.firstLogin
                        }),
                        app.cloudSession() && (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                            html: true,
                            message: (m)=>m.noteText.firstLoginCloud
                        })
                    ]
                })
            }),
            !app.cloudSession() && app.shipId && !companionDisconnectState && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $d2ed8a69fa699d6a$export$de65de8213222d10), {
                    onClick: cancelEdit,
                    className: "CloseButton_right"
                }, "close")
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $9f9e7bca499fb8dc$export$f97dc4a5a0177256), {
                defaultSelection: initTab !== null && initTab !== void 0 ? initTab : "tab_ships",
                tabs: [
                    // all ships, new ship, import ship
                    {
                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).SailingVessel,
                        name: "tab_ships",
                        title: t("tab_ships"),
                        render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $32170478d074c45c$export$96db1b093b0fabbf), {
                                ships: ships,
                                accountShips: accountShips,
                                sharedShips: sharedShips,
                                nearbyShipIds: nearbyShipIds,
                                cancelEdit: cancelEdit,
                                companionReconnect: companionReconnect,
                                companionShipId: companionShipId,
                                companionDisconnectState: companionDisconnectState
                            })
                    },
                    // Infos to current account, links to Account on server and Plan on server
                    {
                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).User,
                        hide: user.accountId == undefined || app.localSession(),
                        name: "tab_subscription",
                        title: t("tab_subscription"),
                        render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                                    className: "ShipContentView-empty-select  main-page-containers",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $93dc0b2fce6ab419$export$83ce790aa5ec9ddb), {
                                            editAccount: editAccount,
                                            setEditAccount: setEditAccount,
                                            editAccountError: editAccountError,
                                            editAccountAction: editAccountAction,
                                            saveAccountUser: saveAccountUser,
                                            showPassword: showPassword,
                                            setShowPassword: setShowPassword,
                                            accountDeletable: accountDeletable
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)((0, $4ea50f72f4a404c8$export$e0e75c068d399d06), {
                                            accountPlan: accountPlan,
                                            available: accountPlanAvailable,
                                            showPlans: showPlans
                                        })
                                    ]
                                })
                            })
                    },
                    // List of all users for the account — gated on the viewing user's own
                    // accountLevel via the generated account.users() predicate (same
                    // mechanism as accountPlanAvailable/accountDeletable above), not the
                    // loaded accountUserInfos (which is only fetched once this tab is
                    // opened, so gating on it would be a chicken-and-egg problem).
                    {
                        hide: !app.hasFeature("multi-user") || !app.cloudSession() || user.accountId == undefined || !accountUsersAvailable,
                        icon: (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).Account,
                        name: "tab_users",
                        title: t("tab_users"),
                        render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $86c5553d8bed38db$export$c94696addbdaa713), {
                                accountUserInfos: accountUserInfos,
                                accountUserLevelOptions: accountUserLevelOptions,
                                onChanged: ()=>undefined
                            })
                    }
                ],
                selectedCallback: tabSelected
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");





const $a851516b5cec6212$export$fddb5b91aecdf09b = {
    // Whether a failed request is the app telling us its cloud session died, as opposed
    // to any other 401.
    //
    // Matching on the status alone would be wrong: `PUT /api/ships/:id` answers 401 for
    // "this ship is claimed by another device" (#1453), which a re-login cannot fix and
    // whose real message this prompt would hide. The app raises the distinct
    // `LogbookApiError.sessionExpired` only after verifying with the cloud's
    // `GET /api/session` that the session itself is what died, and that verified verdict
    // -- not the status -- is what this reads.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- error bodies are untyped
    isSessionExpired (error) {
        return (0, $6ae1228e0cc3b7e8$export$89d83cc97c52a37)(error, "sessionExpired");
    }
};
function $a851516b5cec6212$export$cf6dbfc7ff15fd18({ onDismiss: onDismiss, onLogin: onLogin, t: t }) {
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const [loginError, setLoginError] = (0, $acw62.useState)(undefined);
    const submit = (0, $acw62.useCallback)(async (e)=>{
        e.preventDefault();
        const data = new FormData(e.target);
        const email = data.get("email");
        const password = data.get("password");
        setLoading(true);
        setLoginError(undefined);
        try {
            const success = await onLogin(email, password);
            if (success) // `app.setSession` repoints the session but leaves the overlay standing, so
            // without this the red alert survives a SUCCESSFUL login and reads exactly like
            // a refusal. Closing on success is this view's job, the mirror of staying open
            // on a failure below.
            onDismiss();
            else // Deliberately stays open on a failure: closing would drop the user back into
            // an app that still cannot sync, with the prompt gone.
            setLoginError("session_expired_failed");
        } catch (_a) {
            setLoginError("session_expired_failed_request");
        }
        setLoading(false);
    }, [
        onDismiss,
        onLogin
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $807e05067c94e8fb$export$746af75b6b2a4bae), {
        className: "Overlay-body message-text-bigger Overlay-body-padding",
        readMoreLabel: t("read_more"),
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                        html: true,
                        message: (m)=>m.sessionExpired.text
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                (0, $7b02d682eb115277$exports.jsxs)("form", {
                    className: "LoginView-form",
                    onSubmit: submit,
                    children: [
                        loginError && (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "LoginView-error",
                            children: t(loginError)
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("session_expired_email"),
                                labelFor: "session_expired_email_input",
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "session_expired_email_input",
                                    name: "email",
                                    type: "email",
                                    autoComplete: "username"
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                label: t("session_expired_password"),
                                labelFor: "session_expired_password_input",
                                children: (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "password-field",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("input", {
                                            id: "session_expired_password_input",
                                            name: "password",
                                            type: showPassword ? "text" : "password",
                                            autoComplete: "current-password"
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                            icon: showPassword ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).EyeOn : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).EyeOff,
                                            className: "password-toggle",
                                            onClick: ()=>setShowPassword(!showPassword)
                                        })
                                    ]
                                })
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            actions: true,
                            className: "block-row-one-row",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button",
                                        type: "button",
                                        disabled: loading,
                                        onClick: onDismiss,
                                        children: t("session_expired_dismiss")
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button default",
                                        type: "submit",
                                        disabled: loading,
                                        children: loading ? t("session_expired_login_loading") : t("session_expired_login")
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}










var $acw62 = parcelRequire("acw62");



function $ea762d77805bb577$export$9f320a81db2cf000(value) {
    if (typeof value !== "object" || value === null) return false;
    const row = value;
    return typeof row.id === "number" && typeof row.shipId === "number" && typeof row.shipUserLevel === "number";
}
function $ea762d77805bb577$var$sameMembership(left, right) {
    return left.id === right.id && left.accountId === right.accountId && left.shipId === right.shipId && left.userId === right.userId;
}
function $ea762d77805bb577$export$dc4f3d0e7bd6e028(responseMembership, storedMembership) {
    const merged = responseMembership.map((membership)=>{
        var _a;
        return (_a = storedMembership.find((stored)=>$ea762d77805bb577$var$sameMembership(stored, membership))) !== null && _a !== void 0 ? _a : membership;
    });
    for (const stored of storedMembership)if (!merged.some((membership)=>$ea762d77805bb577$var$sameMembership(membership, stored))) merged.push(stored);
    return merged;
}







var $acw62 = parcelRequire("acw62");




function $f880f60c422ec076$export$f776b12bea8e7e0b({ shipId: shipId, loadedShipId: loadedShipId, load: load, onLoaded: onLoaded, onMissing: onMissing }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const [retry, setRetry] = (0, $acw62.useState)({
        shipId: undefined,
        attempt: 0
    });
    const syncWaits = (0, $acw62.useRef)({
        shipId: undefined,
        count: 0
    });
    const attempt = retry.shipId == shipId ? retry.attempt : 0;
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        let retryTimer;
        const run = async ()=>{
            if (shipId == undefined || loadedShipId == shipId) return;
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("loading ship", shipId, attempt);
            try {
                const value = await load(shipId);
                if (cancelled) return;
                if (value == undefined) {
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Ship load returned no ship", shipId);
                    onMissing();
                    return;
                }
                onLoaded(shipId, value);
                syncWaits.current = {
                    shipId: shipId,
                    count: 0
                };
                if (attempt != 0) setRetry({
                    shipId: shipId,
                    attempt: 0
                });
            } catch (error) {
                if (cancelled) return;
                const maxAttempts = 5;
                if ((0, $b57fb2219af67c07$export$1fb4852a55678982).classifyShipLoadFailure(error) == "retry") {
                    const syncStatus = await (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).syncStatus(app);
                    if (cancelled) return;
                    const waitsForSync = (0, $b57fb2219af67c07$export$1fb4852a55678982).shipLoadWaitsForSync(syncStatus);
                    if (syncWaits.current.shipId != shipId) syncWaits.current = {
                        shipId: shipId,
                        count: 0
                    };
                    const budgeted = attempt - syncWaits.current.count;
                    if (waitsForSync) syncWaits.current.count += 1;
                    if (waitsForSync || budgeted + 1 < maxAttempts) {
                        const delay = (0, $b57fb2219af67c07$export$1fb4852a55678982).shipLoadRetryDelay(waitsForSync ? undefined : budgeted);
                        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("ship load failed transiently, retrying", shipId, attempt, waitsForSync, error);
                        retryTimer = window.setTimeout(()=>{
                            if (!cancelled) setRetry({
                                shipId: shipId,
                                attempt: attempt + 1
                            });
                        }, delay);
                        return;
                    }
                }
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Error loading ship:", error);
                onMissing();
            }
        };
        run();
        return ()=>{
            cancelled = true;
            if (retryTimer != undefined) window.clearTimeout(retryTimer);
        };
    }, [
        app,
        attempt,
        load,
        loadedShipId,
        onLoaded,
        onMissing,
        shipId
    ]);
}


function $e207393cbc774ae4$export$3e6ebe6a5d24032c(route) {
    if (route.route[0] != "ships") return undefined;
    const id = Number(route.route[1]);
    return Number.isInteger(id) && id > 0 ? id : undefined;
}


function $60637804bff896f7$var$isShip(value) {
    return typeof value === "object" && value !== null && typeof value.id === "number";
}
function $60637804bff896f7$var$isSettings(value) {
    if (typeof value !== "object" || value === null) return false;
    const row = value;
    return typeof row.id === "number" && typeof row.shipId === "number" && typeof row.settingType === "number";
}
function $60637804bff896f7$export$2dbceeb0f2fb7745({ route: route, children: children }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const routeShipId = (0, $e207393cbc774ae4$export$3e6ebe6a5d24032c)(route);
    const entityId = routeShipId !== null && routeShipId !== void 0 ? routeShipId : 0;
    const rawShip = (0, $b82e6d2a15bbd8b8$export$fab329b658bf30c7)(store, "Ship", entityId);
    const shipUsers = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, "ShipUser", {
        shipId: (0, $55c0c0d4c269af54$export$a7a0278c004aac3f)(routeShipId)
    });
    const settings = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, "Settings", {
        shipId: (0, $55c0c0d4c269af54$export$a7a0278c004aac3f)(routeShipId)
    });
    const extras = (0, $b82e6d2a15bbd8b8$export$5d34c0530ef73ac5)(store, "Ship", {
        shipId: routeShipId
    });
    const responseShip = $60637804bff896f7$var$isShip(extras.ship) ? extras.ship : undefined;
    const responseSettings = (0, $acw62.useMemo)(()=>Array.isArray(extras.settings) ? extras.settings.filter($60637804bff896f7$var$isSettings) : [], [
        extras.settings
    ]);
    const responseShipUsers = (0, $acw62.useMemo)(()=>Array.isArray(extras.shipUsers) ? extras.shipUsers.filter((0, $ea762d77805bb577$export$9f320a81db2cf000)) : [], [
        extras.shipUsers
    ]);
    const mergedShipUsers = (0, $acw62.useMemo)(()=>(0, $ea762d77805bb577$export$dc4f3d0e7bd6e028)(responseShipUsers, shipUsers), [
        responseShipUsers,
        shipUsers
    ]);
    const activeShipUserId = typeof extras.activeShipUserId == "number" ? extras.activeShipUserId : undefined;
    const [storeBackedShipId, setStoreBackedShipId] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (routeShipId != undefined && activeShipUserId != undefined && shipUsers.some((user)=>user.id == activeShipUserId)) setStoreBackedShipId(routeShipId);
    }, [
        activeShipUserId,
        routeShipId,
        shipUsers
    ]);
    const selectedShipUsers = storeBackedShipId == routeShipId ? shipUsers : mergedShipUsers;
    const selectedRawShip = storeBackedShipId == routeShipId ? rawShip : responseShip !== null && responseShip !== void 0 ? responseShip : rawShip;
    const selectedSettings = storeBackedShipId == routeShipId ? settings : responseSettings;
    const shipUser = activeShipUserId == undefined ? undefined : selectedShipUsers.find((user)=>user.id == activeShipUserId);
    const [loadedShipId, setLoadedShipId] = (0, $acw62.useState)();
    const navigateApp = (0, $acw62.useMemo)(()=>(0, $2472f3c19d716da0$export$55185c17a0fcbe46).navigate((0, $16a667a1dff2bda2$export$1661debf77b71e2c), app.updateRoute), [
        app.updateRoute
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        setLoadedShipId(undefined);
        setStoreBackedShipId(undefined);
    }, []);
    (0, $9690902269ab2924$export$e4edb3e6a3489a79)([
        "Ship",
        "ShipUser",
        "Settings"
    ], routeShipId != undefined, routeShipId);
    const load = (0, $acw62.useCallback)(async (shipId)=>{
        var _a;
        await store.fetchQueryStrict("Ship", {
            shipId: shipId
        });
        const exactShip = store.getExtras("Ship", {
            shipId: shipId
        }).ship;
        return (_a = store.getEntity("Ship", shipId)) !== null && _a !== void 0 ? _a : $60637804bff896f7$var$isShip(exactShip) ? exactShip : undefined;
    }, [
        store
    ]);
    const onLoaded = (0, $acw62.useCallback)((shipId)=>{
        setLoadedShipId(shipId);
    }, []);
    const onMissing = (0, $acw62.useCallback)(()=>navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings), [
        navigateApp
    ]);
    (0, $f880f60c422ec076$export$f776b12bea8e7e0b)({
        shipId: routeShipId,
        loadedShipId: loadedShipId,
        load: load,
        onLoaded: onLoaded,
        onMissing: onMissing
    });
    const ship = (0, $acw62.useMemo)(()=>selectedRawShip ? (0, $321f7f2ee9eb9eff$export$9a45818394e32adc)(selectedRawShip, selectedSettings) : undefined, [
        selectedRawShip,
        selectedSettings
    ]);
    const bundleLoaded = loadedShipId == routeShipId && routeShipId != undefined;
    const value = {
        shipId: routeShipId,
        ship: bundleLoaded ? ship : undefined,
        shipUser: bundleLoaded ? shipUser : undefined,
        shipUsers: bundleLoaded ? selectedShipUsers : undefined,
        activeShipUserId: bundleLoaded ? activeShipUserId : undefined,
        bundleLoaded: bundleLoaded,
        reset: reset
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $321f7f2ee9eb9eff$export$bdb528a92b7341d7).Provider, {
        value: value,
        children: children
    });
}



function $c87eb9b047948814$export$71290a8e32a0ba43(UI) {
    return (0, $480db5fef2358c2d$export$ae24a3dd6105e285)({
        acquire: (0, $60637804bff896f7$export$2dbceeb0f2fb7745),
        ui: UI
    });
}





var $acw62 = parcelRequire("acw62");






const $5e6b467dc617edb7$var$allShipsContext = (0, $5cdac83ab505705b$export$1a6a959df6aea4fa)();
const $5e6b467dc617edb7$export$89171ac1bbea8011 = $5e6b467dc617edb7$var$allShipsContext.Context;
const $5e6b467dc617edb7$export$5440d1eb7ba1d35 = $5e6b467dc617edb7$var$allShipsContext.useGet;


function $07caa5b9f63d012e$export$9cc519ab612e8eb({ children: children }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const userId = (_a = app.user) === null || _a === void 0 ? void 0 : _a.id;
    const storedShips = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, "Ship", {});
    const storedMembership = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, "ShipUser", {
        userId: (0, $55c0c0d4c269af54$export$a7a0278c004aac3f)(userId)
    });
    const extras = (0, $b82e6d2a15bbd8b8$export$5d34c0530ef73ac5)(store, "ShipUser", {
        userId: userId
    });
    const [loaded, setLoaded] = (0, $acw62.useState)(false);
    (0, $9690902269ab2924$export$e4edb3e6a3489a79)([
        "Ship",
        "ShipUser"
    ]);
    const load = (0, $acw62.useCallback)(async (force)=>{
        if (loaded && force != true) return;
        if (userId == undefined) return;
        await store.fetchQueryStrict("ShipUser", {
            userId: userId
        });
        setLoaded(true);
    }, [
        loaded,
        store,
        userId
    ]);
    const ships = (0, $acw62.useMemo)(()=>loaded ? [
            ...storedShips
        ] : undefined, [
        loaded,
        storedShips
    ]);
    const membership = (0, $acw62.useMemo)(()=>{
        if (!loaded || !Array.isArray(extras.membership)) return undefined;
        return (0, $ea762d77805bb577$export$dc4f3d0e7bd6e028)(extras.membership.filter((0, $ea762d77805bb577$export$9f320a81db2cf000)), storedMembership);
    }, [
        extras.membership,
        loaded,
        storedMembership
    ]);
    const ownShipId = loaded && typeof extras.ownShipId == "number" ? extras.ownShipId : undefined;
    const value = {
        ships: ships,
        membership: membership,
        ownShipId: ownShipId,
        load: load
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $5e6b467dc617edb7$export$89171ac1bbea8011).Provider, {
        value: value,
        children: children
    });
}



function $1887a87173d544ed$export$605d55a03b3c754a(UI) {
    return (0, $480db5fef2358c2d$export$ae24a3dd6105e285)({
        acquire: (0, $07caa5b9f63d012e$export$9cc519ab612e8eb),
        ui: UI
    });
}


function $9e6448ab8a42c24a$var$AppViewUI({ route: route }) {
    var _a, _b, _c;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const [connected, setConnected] = (0, $acw62.useState)(app.socket && !app.socket.disconnected);
    const selectedShip = (0, $321f7f2ee9eb9eff$export$e287b9bdb03d0abe)();
    const { ship: ship, shipUser: shipUser, shipUsers: shipUsers, reset: resetSelectedShip } = selectedShip;
    const { ships: ships, membership: membership, ownShipId: ownShipId, load: loadShips } = (0, $5e6b467dc617edb7$export$5440d1eb7ba1d35)();
    const [overlay, overlayOptions, setOverlay, resetOverlay] = (0, $5788501efbf36a87$export$ea8f71083e90600f)((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).none);
    // Closing a ship makes a full cloud round trip (see `ShipApi.swift`'s close
    // branch), so the confirm dialog needs to say so and must not be re-submittable
    // meanwhile -- and a failure has to be visible rather than swallowed (#1279).
    const [shipClosing, setShipClosing] = (0, $acw62.useState)(false);
    const [shipCloseFailed, setShipCloseFailed] = (0, $acw62.useState)(false);
    // The HTTP status of a failed close, so the dialog can name the cause instead of
    // blaming the internet whatever happened (#1453).
    const [shipCloseFailedStatus, setShipCloseFailedStatus] = (0, $acw62.useState)(undefined);
    const [companionReturnRequested] = (0, $acw62.useState)(()=>!!new URLSearchParams(window.location.search).get("companion_disconnected"));
    const [companionDisconnectState, setCompanionDisconnectState] = (0, $acw62.useState)(()=>companionReturnRequested ? "pending" : undefined);
    // The ShipUser new attributed entries are written as, when it differs from the real
    // `shipUser` above (#197/#1026 (tracker #827) user switch). See AppViewState.actingShipUser for why
    // this lives here rather than ShipViewContext.
    const [actingShipUserId, setActingShipUserId] = (0, $acw62.useState)(undefined);
    const actingShipUser = (0, $acw62.useMemo)(()=>shipUsers === null || shipUsers === void 0 ? void 0 : shipUsers.find((user)=>user.id == actingShipUserId), [
        actingShipUserId,
        shipUsers
    ]);
    const platform = (0, $acw62.useMemo)(()=>{
        return (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).platform(app.cloudSession(), app.appStyles);
    }, [
        app
    ]);
    const navigateApp = (0, $acw62.useMemo)(()=>{
        return (0, $2472f3c19d716da0$export$55185c17a0fcbe46).navigate((0, $16a667a1dff2bda2$export$1661debf77b71e2c), app.updateRoute);
    }, []);
    const resetState = (0, $acw62.useCallback)(()=>{
        resetSelectedShip();
        // A previous ship's acting ShipUser id is meaningless once a different ship (or none)
        // is open -- clear it along with the rest of the per-ship state (#197/#1026).
        setActingShipUser(undefined);
    }, [
        resetSelectedShip
    ]);
    // Sets which ShipUser new attributed entries (log/note) are written as. Only ever
    // changes attribution -- Client.setActingShipUserId attaches the override as a header
    // on every subsequent API call, validated + re-derived server-side per request
    // (requireActingShipUserId); `apiUser`/`requireUserLevel` below always keep resolving
    // from the real `shipUser`, so the permission ceiling can never be exceeded by picking
    // another ShipUser here (#197/#1026 user switch).
    const setActingShipUser = (0, $acw62.useCallback)((user)=>{
        setActingShipUserId(user === null || user === void 0 ? void 0 : user.id);
        (0, $62b5d19f2b3ee711$export$1f2bb630327ac4b6).setActingShipUserId(user === null || user === void 0 ? void 0 : user.id);
    }, []);
    // Auto-clear: once the current day changes, re-check whether the acting ShipUser is
    // still on that day's crew/skipper roster (the same eligibility rule the picker itself
    // uses) and drop the override if not -- e.g. a new day starts without them aboard.
    (0, $acw62.useEffect)(()=>{
        if (actingShipUserId == undefined) return;
        let cancelled = false;
        (0, $7c940f40f95a5570$export$46ce47382850ee04).loadEligibleShipUserIds(app.apiClient).then((ids)=>{
            if (!cancelled && !ids.includes(actingShipUserId)) setActingShipUser(undefined);
        }).catch((error)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).error("AppView acting ship user auto-clear", error));
        return ()=>{
            cancelled = true;
        };
    }, [
        (_a = app.current) === null || _a === void 0 ? void 0 : _a.dayId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (actingShipUserId != undefined && selectedShip.bundleLoaded && !actingShipUser) setActingShipUser(undefined);
    }, [
        actingShipUser,
        actingShipUserId,
        selectedShip.bundleLoaded,
        setActingShipUser
    ]);
    (0, $acw62.useEffect)(()=>{
        setActingShipUser(undefined);
    }, [
        selectedShip.shipId,
        setActingShipUser
    ]);
    const evictingShipId = (0, $acw62.useRef)(undefined);
    const selectShip = (0, $acw62.useCallback)(async (shipId)=>{
        if (!app.cloudSession()) {
            state.setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).selectShip);
            try {
                await app.setShipId(shipId);
                resetState();
            } catch (e) {
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("Failed to select ship " + shipId);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
                const error = e;
                if ((0, $a851516b5cec6212$export$fddb5b91aecdf09b).isSessionExpired(error)) {
                    // The cloud refused the app's session, verified by the app against
                    // `GET /api/session` before it names it (#1449). A re-login prompt is the only
                    // thing that helps, and the user stays put -- no redirect to account settings,
                    // which is where this used to dump them with an unreadable 500.
                    state.setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).sessionExpired);
                    return;
                }
                // The app serialises `LogbookApiError` as `{error: "<case name>", status}` (see
                // `LogbookApi/Api.swift`); `apiErrorReason` is the single reader of that shape
                // (#1449, #1820). This used to test `error.error == true && error.reason == ...`
                // -- a shape that never occurs -- so the specific "ship limit reached" message
                // could not be shown, and every failure fell into the generic arm below.
                const reason = (0, $6ae1228e0cc3b7e8$export$3f914597308532a)(error);
                if (reason === "limitActiveShipsReached") state.setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).selectShipFailed, {
                    selectShipError: reason
                });
                else state.setAppOverlay((0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).selectShipFailed);
                navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
                return;
            }
            resetOverlay();
        }
        if (evictingShipId.current == shipId) return;
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("redirect to sync");
        if (app.cloudSession()) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
            shipId: shipId
        });
        else navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
            shipId: shipId,
            shipRoute: "sync"
        });
    }, []);
    const resetShip = (0, $acw62.useCallback)(async ()=>{
        if (app.shipId && !app.cloudSession()) {
            setShipCloseFailed(false);
            setShipCloseFailedStatus(undefined);
            setShipClosing(true);
            try {
                await app.setShipId(app.shipId, true);
            } catch (error) {
                // Surface the failure instead of returning silently: the overlay used to
                // stay open with no message at all, which is indistinguishable from a
                // button that does nothing (#1279). The dialog stays open so the user can
                // retry rather than being dropped somewhere with the ship still claimed.
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("Failed to reset ship", app.shipId, error);
                setShipCloseFailedStatus(error === null || error === void 0 ? void 0 : error.httpStatus);
                setShipCloseFailed(true);
                return;
            } finally{
                setShipClosing(false);
            }
            resetState();
            resetOverlay();
            await loadShips(true);
            navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
        }
        if (app.cloudSession()) {
            resetState();
            resetOverlay();
            await loadShips(true);
            navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
        }
    }, [
        app.shipId,
        app.cloudSession,
        app.setShipId,
        loadShips,
        navigateApp,
        resetOverlay,
        resetState
    ]);
    const forceCloseShip = (0, $acw62.useCallback)(async ()=>{
        if (!app.shipId || app.cloudSession()) return;
        setShipCloseFailed(false);
        setShipCloseFailedStatus(undefined);
        setShipClosing(true);
        try {
            await app.forceCloseShip(app.shipId);
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("Failed to force close ship", app.shipId, error);
            setShipCloseFailedStatus(error === null || error === void 0 ? void 0 : error.httpStatus);
            setShipCloseFailed(true);
            return;
        } finally{
            setShipClosing(false);
        }
        resetState();
        resetOverlay();
        await loadShips(true);
        navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
    }, [
        app.shipId,
        app.cloudSession,
        app.forceCloseShip,
        loadShips,
        navigateApp,
        resetOverlay,
        resetState
    ]);
    const deselectShip = (0, $acw62.useCallback)(async (shipId)=>{
        if (app.cloudSession()) {
            await (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).closeShip(app.apiClient, shipId);
            await loadShips(true);
            state.resetAppOverlay();
        }
    }, []);
    const socketSubscription = (0, $acw62.useCallback)(async (status)=>{
        setConnected(status);
        if (connected && status == false) await (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).restartNative();
    }, [
        connected
    ]);
    (0, $5f6ddaa19700549d$export$cb4e378d7d3467ee)(socketSubscription);
    // Shared eviction path for "I have no more effective access to this ship" --
    // used when a ship is explicitly closed (`Subscription.shipClose` below),
    // when a `Subscription.ShipUser` broadcast reveals my own
    // removal/deactivation/downgrade to `none` while paired, and when a
    // `Subscription.Ship` broadcast reveals the ship itself was deleted (#1102).
    // Resets local ship state, then either logs out (local/companion session --
    // there is no "just go back to ship select" for a device-bound session) or
    // navigates to `accountSettings` (cloud session).
    const evictFromShip = async (evictedShipId)=>{
        try {
            await app.setShipId(evictedShipId, true, true);
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Failed to clear selected ship during eviction", error);
        }
        resetState();
        if (app.localSession()) await app.logout();
        else {
            navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
            try {
                await loadShips(true);
            } catch (error) {
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Failed to refresh ships after eviction", error);
            }
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (!selectedShip.bundleLoaded || selectedShip.shipId == undefined) return;
        const noAccess = selectedShip.activeShipUserId != undefined && (!shipUser || shipUser.deletedAt != undefined || shipUser.active < 1 || shipUser.shipUserLevel == (0, $dc7739d612f0c536$export$fe876bf720d558fa).none);
        if (ship && !noAccess) {
            evictingShipId.current = undefined;
            return;
        }
        if (evictingShipId.current == selectedShip.shipId) return;
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("Evicting selected ship after access state changed", selectedShip.shipId, selectedShip.activeShipUserId, ship === null || ship === void 0 ? void 0 : ship.id, shipUser === null || shipUser === void 0 ? void 0 : shipUser.id, shipUser === null || shipUser === void 0 ? void 0 : shipUser.active, shipUser === null || shipUser === void 0 ? void 0 : shipUser.shipUserLevel);
        evictingShipId.current = selectedShip.shipId;
        evictFromShip(selectedShip.shipId).catch((error)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Failed to evict from selected ship", error));
    }, [
        selectedShip.activeShipUserId,
        selectedShip.bundleLoaded,
        selectedShip.shipId,
        ship,
        shipUser
    ]);
    (0, $5f6ddaa19700549d$export$368b4214baeb914c)(async (closedShip, _type)=>{
        if (closedShip.id == shipId || closedShip.id == app.shipId) await evictFromShip(closedShip.id);
    }, (0, $1bedde6805bf6e79$export$f55210826850c514).shipClose);
    const [content, routeName, routeParams] = (0, $2472f3c19d716da0$export$9a302a45f65d0572)(route, (0, $16a667a1dff2bda2$export$1661debf77b71e2c), (router)=>{
        router.on((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).launchShip, (_params)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {
                    page: true
                })
            });
        });
        router.on((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).importShip, (_params)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $909943c828a66da4$export$9808f770de4e3553), {
                cancelEdit: ()=>navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings)
            });
        });
        router.on((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).newShip, (_params)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $82532a99618f300b$export$ba3b838c43b5c410), {
                cancelEdit: ()=>navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings)
            }, "new");
        });
        router.on((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, (params)=>{
            params.requireInt("shipId");
            params.requireRoute("shipRoute");
            return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
        });
        router.on((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSubscriptionComplete, (params)=>{
            const sessionId = params.requireString("sessionId");
            if (app.account) return (0, $7b02d682eb115277$exports.jsx)((0, $6b6c7d4ac7ee2ce4$export$fc14f7024165eccb), {
                account: app.account,
                backAction: ()=>navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings),
                checkoutSessionId: sessionId
            });
            // The account is loaded asynchronously (loadSession); show a loading page until
            // it arrives instead of throwing, so navigating here before the session settles
            // (e.g. right after app launch) doesn't crash the whole app.
            return (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {
                page: true
            });
        });
        router.on((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSubscription, (_params)=>{
            if (!(0, $541a350025917a42$export$750abdcba4148280)(app)) {
                navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
                return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
            }
            if (app.account) return (0, $7b02d682eb115277$exports.jsx)((0, $6b6c7d4ac7ee2ce4$export$fc14f7024165eccb), {
                account: app.account,
                backAction: ()=>navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings)
            });
            // The account is loaded asynchronously (loadSession); show a loading page until
            // it arrives instead of throwing, so navigating here before the session settles
            // (e.g. right after app launch) doesn't crash the whole app.
            return (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {
                page: true
            });
        });
        router.on((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings, (_params)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $fd9f921a92bb998b$export$21d8166b98f38a62), {
                cancelEdit: ()=>{
                    if (!app.cloudSession() && app.shipId) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
                        shipId: app.shipId
                    });
                },
                ships: ships,
                companionDisconnectState: companionDisconnectState
            });
        });
        router.on((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).signup, (_params)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {
                page: true
            });
        });
        router.on((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).launch, (_params)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {
                page: true
            });
        });
        router.on((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).index, (_params)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {
                page: true
            });
        });
        router.on((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).unknown, (_params)=>{
            return (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {
                page: true
            });
        });
    });
    const shipId = (0, $acw62.useMemo)(()=>{
        if (routeName == (0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship) return new (0, $2472f3c19d716da0$export$2f0830dcc7971fd0)(routeParams).requireInt("shipId");
        return undefined;
    }, [
        routeName,
        routeParams
    ]);
    const renderedContent = routeName == (0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship && shipId != undefined ? selectedShip.bundleLoaded && (ship === null || ship === void 0 ? void 0 : ship.id) == shipId ? (0, $7b02d682eb115277$exports.jsx)((0, $3aca0db9652797ac$export$707fe26943050cf1), {
        route: {
            route: new (0, $2472f3c19d716da0$export$2f0830dcc7971fd0)(routeParams).requireRoute("shipRoute")
        },
        shipId: shipId,
        users: shipUsers,
        actingShipUser: actingShipUser,
        setActingShipUser: setActingShipUser
    }, shipId) : (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {
        page: true
    }) : content;
    const localAccountSession = !app.cloudSession() && !app.localSession();
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (!companionReturnRequested || !localAccountSession || !((_a = app.session) === null || _a === void 0 ? void 0 : _a.authorized) || !app.session.id) return;
        let disposed = false;
        const companionShipId = (0, $2b75519151ca9024$export$8bf6241f4c41c4e0)("logbook-companion");
        const finishReturn = ()=>{
            const params = new URLSearchParams(window.location.search);
            params.delete("companion_disconnected");
            const query = params.toString();
            window.history.replaceState({}, "", `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`);
            setCompanionDisconnectState(undefined);
            if (routeName !== (0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
        };
        if (companionShipId == undefined) {
            finishReturn();
            return;
        }
        if (app.session.shipId === companionShipId) {
            localStorage.removeItem("logbook-companion");
            finishReturn();
            return;
        }
        (0, $b5c1808b3220ae33$export$ea47b402c0c5f72f)(companionShipId);
        (async ()=>{
            try {
                await (0, $a359a1de1c9c067b$export$6fdd7e23becf9b95).cancelLocal(app.apiClient, companionShipId);
                if (disposed) return;
                if (app.shipId === companionShipId) await app.setShipId(companionShipId, true, true);
                if (disposed) return;
                (0, $b57fb2219af67c07$export$1fb4852a55678982).clearCompanion(companionShipId);
                finishReturn();
            } catch (error) {
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Failed to disconnect returned companion pairing", error);
                if (!disposed) {
                    setCompanionDisconnectState("failed");
                    if (routeName !== (0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
                }
            }
        })();
        return ()=>{
            disposed = true;
        };
    }, [
        companionReturnRequested,
        localAccountSession,
        (_b = app.session) === null || _b === void 0 ? void 0 : _b.authorized,
        (_c = app.session) === null || _c === void 0 ? void 0 : _c.id
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        // The authenticated return effect owns cleanup and routing for this journey.
        if (companionReturnRequested) return undefined;
        const companionShipId = (0, $2b75519151ca9024$export$8bf6241f4c41c4e0)("logbook-companion");
        const staleCompanionSelection = !app.cloudSession() && !app.localSession() && companionShipId != undefined && app.shipId === companionShipId && ((_a = app.session) === null || _a === void 0 ? void 0 : _a.shipId) !== companionShipId;
        if (staleCompanionSelection) Promise.resolve(app.setShipId(companionShipId, true, true)).catch((error)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Failed to clear incomplete companion selection", error));
        if (routeName == (0, $16a667a1dff2bda2$export$37d3279522fbf5e2).index || routeName == (0, $16a667a1dff2bda2$export$37d3279522fbf5e2).signup) {
            if (!app.cloudSession() && app.shipId && !staleCompanionSelection) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
                shipId: app.shipId
            });
            else navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
        } else if (!app.cloudSession() && routeName == (0, $16a667a1dff2bda2$export$37d3279522fbf5e2).launch) {
            const companionShipId = (0, $2b75519151ca9024$export$8bf6241f4c41c4e0)("logbook-companion");
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("check companion session", companionShipId);
            if (companionShipId) {
                let disposed = false;
                const launchPath = window.location.pathname;
                const isCurrent = ()=>!disposed && window.location.pathname === launchPath && (0, $2b75519151ca9024$export$8bf6241f4c41c4e0)("logbook-companion") === companionShipId;
                (0, $a359a1de1c9c067b$export$6fdd7e23becf9b95).prepareHandoff(app.apiClient, companionShipId).then(({ url: url })=>{
                    if (!url) throw new Error("Companion preparation returned no destination");
                    if (isCurrent()) window.location.assign(url);
                }).catch((error)=>{
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Failed to prepare saved companion connection", error);
                    if (isCurrent()) window.location.assign("/app/account?companion_error=unreachable");
                });
                return ()=>{
                    disposed = true;
                };
            } else if (app.shipId) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
                shipId: app.shipId
            });
            else navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
        } else if (routeName == (0, $16a667a1dff2bda2$export$37d3279522fbf5e2).unknown) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
        return undefined;
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (routeName == (0, $16a667a1dff2bda2$export$37d3279522fbf5e2).launchShip) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("Launching ship", routeParams, (0, $ea493e883ca706d4$export$10369954900e6465));
            const shipId = new (0, $2472f3c19d716da0$export$2f0830dcc7971fd0)(routeParams).requireInt("shipId");
            if (!shipId) {
                navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
                return;
            }
            if (ships == undefined) loadShips();
            else if (shipId == app.shipId) navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
                shipId: shipId,
                shipRoute: "sync"
            });
            else if (app.shipId == undefined) selectShip(shipId);
            else navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSettings);
        }
    }, [
        ships
    ]);
    (0, $acw62.useEffect)(()=>{
        if (app.cloudSession() && routeName != (0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship && ship) resetState();
    }, [
        ship,
        routeName
    ]);
    // The account is loaded once at launch by loadSession; in the native app it comes from
    // the on-device DB and can still be unsynced then, leaving `app.account` undefined. The
    // subscription route is account-gated, so landing there without an account would hang on
    // Loading until a manual reload. Re-fetch the session once when that happens (authorized,
    // non-cloud session) so the view self-heals.
    (0, $acw62.useEffect)(()=>{
        const needsAccount = routeName == (0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSubscription || routeName == (0, $16a667a1dff2bda2$export$37d3279522fbf5e2).accountSubscriptionComplete;
        if (!needsAccount || app.account || app.cloudSession() || !app.session || app.session.authorized != true) return;
        let cancelled = false;
        const requestIdentity = (0, $73eea1fea92cc6a5$export$fc07fe94f5a41790)(app.session, app.sessionType, app.apiClient.target);
        (0, $5ba8962d09b05c4a$export$b531eccea6f91101).loadSession(app.apiClient).then((data)=>{
            if (!cancelled && data) app.reconcileSession(data, requestIdentity);
        }).catch(()=>{});
        return ()=>{
            cancelled = true;
        };
    }, [
        routeName,
        app.account,
        app.session,
        app.sessionType,
        app.apiClient
    ]);
    const requireUserLevel = (0, $acw62.useCallback)((level)=>{
        return (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).requireUserLevel(level, shipUser);
    }, [
        shipUser
    ]);
    const apiUser = (0, $acw62.useMemo)(()=>{
        var _a;
        return (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).apiUser({
            accountId: (_a = app.account) === null || _a === void 0 ? void 0 : _a.id,
            accountUserLevel: app.accountUserLevel,
            shipUser: shipUser,
            membership: membership
        });
    }, [
        app.account,
        app.accountUserLevel,
        shipUser,
        membership
    ]);
    const context = {
        ship: ship,
        shipUser: shipUser,
        requireUserLevel: requireUserLevel,
        apiUser: apiUser
    };
    const state = {
        connected: connected,
        loadShips: loadShips,
        navigateApp: navigateApp,
        route: route,
        routeName: routeName,
        ships: ships,
        ownShipId: ownShipId,
        membership: membership,
        subscriptionExpired: (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).subscriptionExpired(app.account),
        deselectShip: deselectShip,
        selectShip: selectShip,
        resetShip: resetShip,
        forceCloseShip: forceCloseShip,
        shipClosing: shipClosing,
        shipCloseFailed: shipCloseFailed,
        shipCloseFailedStatus: shipCloseFailedStatus,
        appOverlay: overlay,
        appOverlayOptions: overlayOptions || {},
        setAppOverlay: setOverlay,
        resetAppOverlay: resetOverlay,
        actingShipUser: actingShipUser,
        setActingShipUser: setActingShipUser
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $d96ebf18a3a82ea8$export$71e1586407c6a0f3).Provider, {
        value: state,
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "AppView ",
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $d0002a37f25cb62c$export$7b903090de9cebe9), {
                    connected: connected
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $e3ce5d157f267f1e$export$d739bee7a05220bf), {
                    platform: platform,
                    showExternal: false
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $8e32ab04a98d0dca$export$1f4c95990bbc9d13), {}),
                (0, $7b02d682eb115277$exports.jsxs)((0, $97ac05743b787a86$export$74bc7108ae339b7).Provider, {
                    value: context,
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $cd8deb4eb028fe97$export$381adc1c98036a68), {
                            ship: ship
                        }),
                        renderedContent
                    ]
                })
            ]
        })
    });
}
const $9e6448ab8a42c24a$export$3713363bfd8bacdf = (0, $c87eb9b047948814$export$71290a8e32a0ba43)((0, $1887a87173d544ed$export$605d55a03b3c754a)($9e6448ab8a42c24a$var$AppViewUI));




var $acw62 = parcelRequire("acw62");








const $e3e377da0685a737$export$3b437c26facf161d = {
    confirmEmail (api, token) {
        return new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(api).signup.confirmEmail({
            params: {
                token: token
            }
        }).call();
    },
    resetApp (api) {
        return new (0, $5094ab6cf9038f1f$export$3565eb3d00ca5a74)(api).app.reset({
            params: {}
        }).call();
    },
    loadInvitation (api, token) {
        return new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(api).signup.invitation({
            params: {
                token: token
            }
        }).call();
    },
    // Existing-account ship invitation: same response shape as the brand-new-user
    // signup invitation above (an AccountInvitationResponse), just looked up from a
    // pending ShipUser rather than a pending User.
    loadShipInvitation (api, token) {
        return new (0, $3901b1e83708ce40$export$2a63ac7615f78125)(api).shipUsers.invitation({
            params: {
                token: token
            }
        }).call();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    login (api, values) {
        return new (0, $6e7887a8bef248ec$export$1fb4852a55678982)(api).session.create({
            params: {},
            body: values
        }).call();
    },
    handoff (api, state) {
        return new (0, $6e7887a8bef248ec$export$1fb4852a55678982)(api).session.handoff({
            params: {},
            body: {
                state: state
            }
        }).call();
    },
    exchange (api, code, state) {
        return new (0, $6e7887a8bef248ec$export$1fb4852a55678982)(api).session.exchange({
            params: {},
            body: {
                code: code,
                state: state
            }
        }).call();
    },
    forgotPassword (api, values) {
        return new (0, $6e7887a8bef248ec$export$1fb4852a55678982)(api).session.forgotPassword({
            params: {},
            body: values
        }).call();
    },
    resetPassword (api, token, values) {
        return new (0, $6e7887a8bef248ec$export$1fb4852a55678982)(api).session.resetPassword({
            params: {
                token: token
            },
            body: values
        }).call();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    acceptInvitation (api, token, values) {
        return new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(api).signup.acceptInvitation({
            params: {
                token: token
            },
            body: values
        }).call();
    },
    // Attaches the current session's user (and their pending account membership) to
    // the ship they were invited to. Requires an authenticated session; the server
    // checks the invited user matches the session's user (401 otherwise).
    acceptShipInvitation (api, token) {
        return new (0, $3901b1e83708ce40$export$2a63ac7615f78125)(api).shipUsers.acceptInvitation({
            params: {
                token: token
            }
        }).call();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    createAccount (api, values) {
        return new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(api).account.create({
            params: {},
            body: values
        }).call();
    },
    deleteSession (api) {
        return new (0, $6e7887a8bef248ec$export$1fb4852a55678982)(api).session.delete({
            params: {}
        }).call();
    },
    // Signup form validity: name, email and a >=3 char password are required, plus an
    // account name once the server has reported the account already exists.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    validateSignup (values, signupError) {
        return !!(values.name && values.name.length > 0 && values.email && values.email.length > 0 && values.password && values.password.length >= 3 && (signupError != "signupAccountAlreadyExists" || values.accountName && values.accountName.length > 0));
    }
};







function $0763d2bb9c39b379$export$bd72c327b6d4c99b({ resetDialog: resetDialog, setResetDialog: setResetDialog, resetApp: resetApp }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("LoginView");
    return (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$c6fdb837b070b4ff), {
        style: "alarm",
        title: t("reset_app_title"),
        hideClose: resetDialog > 1,
        closeCallback: ()=>setResetDialog(0),
        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
            className: "Overlay-body LoginView-reset-dialog",
            children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                            message: (m)=>resetDialog > 1 ? m.login.resetAppComplete : m.login.resetAppWarning,
                            html: true
                        })
                    }),
                    resetDialog == 1 && (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        actions: true,
                        className: "LoginView-reset-dialog",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button",
                                    onClick: ()=>setResetDialog(0),
                                    children: t("reset_app_cancel")
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button default",
                                    onClick: resetApp,
                                    children: t("reset_app_action")
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");






function $31778daca63357f6$var$NativeWelcomeMessage() {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("LoginView");
    const iOSApp = (0, $fe1fa5963413bede$export$2dffd0b5373a4389).isIOS(app);
    const [attempt, setAttempt] = (0, $acw62.useState)(0);
    const apiClient = app.apiClient;
    const request = (0, $acw62.useMemo)(()=>({
            apiClient: apiClient,
            attempt: attempt
        }), [
        apiClient,
        attempt
    ]);
    const [result, setResult] = (0, $acw62.useState)();
    const current = (result === null || result === void 0 ? void 0 : result.request) === request ? result : undefined;
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (0, $5ba8962d09b05c4a$export$b531eccea6f91101).loadServer(request.apiClient).then((response)=>{
            (0, $f73c59e6f36e52da$export$7e3547f81f4d8512)(response.host, "signup/app", false);
            if (!cancelled) setResult({
                request: request,
                host: response.host
            });
        }).catch((error)=>{
            if (cancelled) return;
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
            setResult({
                request: request,
                failed: true
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        request
    ]);
    const signup = (current === null || current === void 0 ? void 0 : current.host) ? (0, $f73c59e6f36e52da$export$7e3547f81f4d8512)(current.host, "signup/app", iOSApp) : undefined;
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "LoginWelcomeView-signup",
        "aria-busy": !current,
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                message: (m)=>iOSApp ? m.login.welcomeAppiPad : m.login.welcomeApp,
                html: true,
                links: {
                    "logbook:signup": signup
                }
            }),
            (current === null || current === void 0 ? void 0 : current.failed) && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "LoginView-error",
                        role: "alert",
                        children: t("signup_link_unavailable")
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "button default",
                        onClick: ()=>setAttempt((value)=>value + 1),
                        children: t("signup_link_retry")
                    })
                ]
            })
        ]
    });
}
function $31778daca63357f6$export$af371dcb9bc76d53({ message: message, invitationToken: invitationToken, invitationData: invitationData }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("LoginView");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete replacement-values type
    const invitationReplace = invitationData;
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: t("welcome")
            }),
            message == "signup_success" ? (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                message: (m)=>m.login.signupSuccess,
                html: true
            }) : invitationToken && invitationData ? (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                message: (m)=>app.user ? m.login.invitationLoggedIn : m.login.invitation,
                html: true,
                replace: invitationReplace
            }) : // normal login/signup
            app.cloudSession() ? (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                message: (m)=>m.login.welcomeCloud,
                html: true
            }) : (0, $7b02d682eb115277$exports.jsx)($31778daca63357f6$var$NativeWelcomeMessage, {})
        ]
    });
}




var $acw62 = parcelRequire("acw62");





function $7e49ed677a351531$export$e4e16e728e8111a3({ active: active, onActivate: onActivate, edited: edited, onEdited: onEdited, saveEdits: saveEdits, validateEdits: validateEdits, signupError: signupError, showPassword: showPassword, setShowPassword: setShowPassword, validInput: validInput, loading: loading, invitationData: invitationData, invitationToken: invitationToken }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("LoginView");
    const accountNameRef = (0, $acw62.useRef)(null);
    const nameRef = (0, $acw62.useRef)(null);
    const emailRef = (0, $acw62.useRef)(null);
    const passwordRef = (0, $acw62.useRef)(null);
    // Tracks each non-password field as the visitor types it, purely so the box's
    // placeholder (shown while the *other* box is active -- see LoginView, which only
    // ever keeps one box's real <form>/EditGroup mounted) still looks like the fields
    // it's mimicking instead of always rendering blank, and so reactivating restores them
    // into the real inputs. The password is intentionally never captured here: unlike
    // partially-typed text, it has no legitimate reason to be echoed back in a plain,
    // unmasked <div>.
    //
    // Each only ever holds what the visitor themselves typed (never seeded from
    // invitationData): invitationData is fetched asynchronously by LoginView (see the
    // signup-invitation flow), so it can arrive as a *later* prop update on this
    // already-mounted box. Deriving the displayed value at render time (falling back to
    // invitationData only while the visitor hasn't typed anything) means the inputs pick
    // up a late-arriving invitation correctly, the same way the plain
    // `defaultValue={invitationData?.name/email}` expressions they replace did.
    const [accountName, setAccountName] = (0, $acw62.useState)("");
    const [name, setName] = (0, $acw62.useState)("");
    const [email, setEmail] = (0, $acw62.useState)("");
    const displayName = name || invitationData && invitationData.name || "";
    const displayEmail = email || invitationData && invitationData.email || "";
    const accountNameRequired = signupError === "signupAccountAlreadyExists";
    // Remembers which field (if any) the visitor clicked on this box's inactive
    // placeholder -- set by the field-specific handlers below -- so the effect below can
    // focus the corresponding real input once the click also activates this box.
    // `undefined` means the click landed elsewhere in the box (its background, a label,
    // the submit button) rather than on a specific field's placeholder, so the effect
    // falls back to focusing the first empty field instead.
    const pendingFocusFieldRef = (0, $acw62.useRef)(undefined);
    // Tracks whether this box was active on the previous render, so the focus-on-
    // activation effect below only fires on a real inactive -> active transition (a
    // visitor's click) -- never on initial mount, where this box may already start
    // active, and autofocusing on page load with no user interaction would be an
    // unwanted UX regression.
    const wasActiveRef = (0, $acw62.useRef)(active);
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const wasActive = wasActiveRef.current;
        wasActiveRef.current = active;
        if (!active || wasActive) return;
        const target = pendingFocusFieldRef.current;
        pendingFocusFieldRef.current = undefined;
        if (target === "accountName") (_a = accountNameRef.current) === null || _a === void 0 || _a.focus();
        else if (target === "name") (_b = nameRef.current) === null || _b === void 0 || _b.focus();
        else if (target === "email") (_c = emailRef.current) === null || _c === void 0 || _c.focus();
        else if (target === "password") (_d = passwordRef.current) === null || _d === void 0 || _d.focus();
        else if (accountNameRequired && !accountName) // A click elsewhere in the box (not on a specific field): focus the first empty
        // field, in the same top-to-bottom order the fields are laid out. Password is
        // always empty on a fresh activation, since it's never mirrored into the
        // placeholder, so it's the last resort.
        (_e = accountNameRef.current) === null || _e === void 0 || _e.focus();
        else if (!displayName) (_f = nameRef.current) === null || _f === void 0 || _f.focus();
        else if (!displayEmail) (_g = emailRef.current) === null || _g === void 0 || _g.focus();
        else (_h = passwordRef.current) === null || _h === void 0 || _h.focus();
    }, [
        active,
        accountNameRequired,
        accountName,
        displayName,
        displayEmail
    ]);
    const activateField = (field)=>(e)=>{
            e.stopPropagation();
            pendingFocusFieldRef.current = field;
            onActivate();
        };
    // Browser autofill (password managers, saved-form-data, address/email suggestions) can
    // set an input's value without dispatching a React-visible `input`/`change` event, so
    // `onEdited` (wired to onChange below) never fires and the submit button stays disabled
    // even though the fields are visibly filled in. The `:autofill`/`:-webkit-autofill` CSS
    // rule in LoginView.scss triggers a (near-instant, invisible) animation on autofill,
    // which browsers reliably surface as a real `animationstart` DOM event even when
    // `input`/`change` are suppressed -- so treat that the same as an edit.
    //
    // Validate directly off each field's live DOM ref here, rather than relying solely on
    // EditGroup's `changed`-triggered effect to re-read a `FormData` snapshot on a later
    // render: that path can miss or race a just-autofilled value (e.g. autofilling one
    // field right after manually typing the others), leaving the button stuck disabled.
    // Reading the refs directly guarantees every field's current value is picked up,
    // regardless of fill order.
    const handleAutofill = (e)=>{
        var _a, _b, _c, _d, _e;
        if (e.animationName !== "onAutoFillStart") return;
        const values = {
            accountName: ((_a = accountNameRef.current) === null || _a === void 0 ? void 0 : _a.value) || undefined,
            name: ((_b = nameRef.current) === null || _b === void 0 ? void 0 : _b.value) || "",
            email: ((_c = emailRef.current) === null || _c === void 0 ? void 0 : _c.value) || "",
            password: ((_d = passwordRef.current) === null || _d === void 0 ? void 0 : _d.value) || ""
        };
        setAccountName((_e = values.accountName) !== null && _e !== void 0 ? _e : "");
        setName(values.name);
        setEmail(values.email);
        onEdited();
        validateEdits(new FormData(), values);
    };
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "signup",
            !active && "inactive"
        ]),
        onClick: active ? undefined : onActivate,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "text_on_box",
                children: t("signup")
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "signup-block",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: t("signup_email")
                        })
                    }),
                    active ? (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                        changed: edited,
                        editable: true,
                        editableFields: [
                            "accountName",
                            "name",
                            "email",
                            "password"
                        ],
                        manualSave: true,
                        onSave: saveEdits,
                        onValidate: validateEdits,
                        children: [
                            signupError && (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "LoginView-error",
                                children: t(`error_${signupError}`)
                            }),
                            accountNameRequired && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("form_account_name"),
                                    labelFor: "signup_accountName",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        ref: accountNameRef,
                                        id: "signup_accountName",
                                        name: "accountName",
                                        type: "name",
                                        autoComplete: "organization",
                                        onChange: (e)=>{
                                            setAccountName(e.target.value);
                                            onEdited();
                                        },
                                        onAnimationStart: handleAutofill,
                                        defaultValue: accountName
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("form_name"),
                                    labelFor: "signup_name",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        ref: nameRef,
                                        id: "signup_name",
                                        name: "name",
                                        type: "name",
                                        autoComplete: "name",
                                        onChange: (e)=>{
                                            setName(e.target.value);
                                            onEdited();
                                        },
                                        onAnimationStart: handleAutofill,
                                        defaultValue: displayName,
                                        readOnly: !!invitationToken
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("form_email"),
                                    labelFor: "signup_email",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        ref: emailRef,
                                        id: "signup_email",
                                        name: "email",
                                        type: "email",
                                        autoComplete: "email",
                                        onChange: (e)=>{
                                            setEmail(e.target.value);
                                            onEdited();
                                        },
                                        onAnimationStart: handleAutofill,
                                        defaultValue: displayEmail,
                                        readOnly: !!invitationToken
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("form_password"),
                                    labelFor: "signup_password",
                                    children: (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "password-field",
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("input", {
                                                ref: passwordRef,
                                                id: "signup_password",
                                                name: "password",
                                                type: showPassword ? "text" : "password",
                                                autoComplete: "new-password",
                                                onChange: onEdited,
                                                onAnimationStart: handleAutofill
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                icon: showPassword ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).EyeOn : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).EyeOff,
                                                className: "password-toggle",
                                                onClick: ()=>setShowPassword(!showPassword)
                                            })
                                        ]
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "row-right block-row-top0",
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button submit-button",
                                    disabled: !validInput || loading,
                                    type: "submit",
                                    children: t("form_submit_signup")
                                })
                            })
                        ]
                    }) : // Inactive: no real <form>/EditGroup/<input> -- just look-alike placeholders
                    // (see `.input` in Common.scss) so this box can never contribute a second,
                    // real email/password field to the DOM alongside the login box's. Each
                    // placeholder still calls `onActivate` (via `activateField`) when clicked, so
                    // clicking anywhere in the box still activates it -- but stops the click from
                    // bubbling to the outer box's generic handler, so the specific field that was
                    // clicked (not just "the first empty field") gets focused once active.
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "EditGroup",
                        children: [
                            accountNameRequired && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("form_account_name"),
                                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "input",
                                        onClick: activateField("accountName"),
                                        children: accountName
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("form_name"),
                                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "input",
                                        onClick: activateField("name"),
                                        children: displayName
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("form_email"),
                                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "input",
                                        onClick: activateField("email"),
                                        children: displayEmail
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("form_password"),
                                    children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "password-field",
                                        children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "input",
                                            onClick: activateField("password")
                                        })
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "row-right block-row-top0",
                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "button submit-button",
                                    disabled: !validInput || loading,
                                    type: "button",
                                    children: t("form_submit_signup")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}






function $eabd4aed77c95069$export$35dc946c6218e926({ forgotPassword: forgotPassword, loginError: loginError, loading: loading, showPassword: showPassword, setShowPassword: setShowPassword, submitReset: submitReset, submitResetComplete: submitResetComplete, setForgotPassword: setForgotPassword, onEdited: onEdited }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("LoginView");
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "forgot-password",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "text_on_box",
                children: t("forgot_password")
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "forgot-password-block",
                children: forgotPassword == true ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: t("forgot_password_email")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("form", {
                            className: "LoginView-form",
                            onSubmit: submitReset,
                            children: [
                                loginError && (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "LoginView-error",
                                    children: t(`error_${loginError}`)
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("form_email"),
                                        labelFor: "login_email",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            id: "login_email",
                                            name: "email",
                                            type: "email",
                                            autoComplete: app.cloudSession() ? "username" : "off"
                                        })
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    className: "row-right",
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button submit-button",
                                        disabled: loading,
                                        type: "submit",
                                        children: t(loading ? "form_submit_forgot_password_loading" : "form_submit_forgot_password")
                                    })
                                })
                            ]
                        })
                    ]
                }) : forgotPassword == "success" ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: t("forgot_password_email_sent")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "row-right",
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button submit-button",
                                onClick: ()=>setForgotPassword(false),
                                children: t("form_back_to_login")
                            })
                        })
                    ]
                }) : forgotPassword == "complete" ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: t("forgot_password_complete")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "row-right",
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button submit-button",
                                onClick: ()=>setForgotPassword(false),
                                children: t("form_back_to_login")
                            })
                        })
                    ]
                }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: t("forgot_password_new_password")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("form", {
                            className: "LoginView-form",
                            onSubmit: submitResetComplete,
                            children: [
                                loginError && (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "LoginView-error",
                                    children: t(`error_${loginError}`)
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("form_new_password"),
                                        labelFor: "reset_password",
                                        children: (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "password-field",
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    id: "reset_password",
                                                    name: "password",
                                                    type: showPassword ? "text" : "password",
                                                    autoComplete: "off",
                                                    onChange: onEdited
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                    icon: showPassword ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).EyeOn : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).EyeOff,
                                                    className: "password-toggle",
                                                    onClick: ()=>setShowPassword(!showPassword)
                                                })
                                            ]
                                        })
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                        label: t("form_new_password_confirmation"),
                                        labelFor: "reset_password_confirmation",
                                        children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                            id: "reset_password_confirmation",
                                            name: "passwordConfirmation",
                                            type: "password",
                                            autoComplete: "off",
                                            onChange: onEdited
                                        })
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    className: "row-right",
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button submit-button",
                                        disabled: loading,
                                        type: "submit",
                                        children: t(loading ? "form_submit_forgot_password_loading" : "form_submit_forgot_password")
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




function $6312f3e1ca5053de$export$5f7611c3f433baae({ active: active, onActivate: onActivate, loginError: loginError, loading: loading, showPassword: showPassword, setShowPassword: setShowPassword, submit: submit, invitationData: invitationData, setForgotPassword: setForgotPassword, onNativeSignIn: onNativeSignIn }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("LoginView");
    const emailRef = (0, $acw62.useRef)(null);
    const passwordRef = (0, $acw62.useRef)(null);
    // Tracks the email as the visitor types it, purely so the box's placeholder (shown
    // while the *other* box is active -- see LoginView, which only ever keeps one box's
    // real <form> mounted) still looks like the field it's mimicking instead of always
    // rendering blank, and so reactivating restores it into the real input. The password
    // is intentionally never captured here: unlike a partially-typed email, it has no
    // legitimate reason to be echoed back in a plain, unmasked <div>.
    //
    // `email` only ever holds what the visitor themselves typed (never seeded from
    // invitationData): invitationData is fetched asynchronously by LoginView (see the
    // ship-invitation flow), so it can arrive as a *later* prop update on this
    // already-mounted box. Deriving the displayed value at render time (falling back to
    // invitationData only while the visitor hasn't typed anything) means the input picks
    // up a late-arriving invitation email correctly, the same way the plain
    // `defaultValue={invitationData?.email}` expression it replaces did.
    const [email, setEmail] = (0, $acw62.useState)("");
    const displayEmail = email || invitationData && invitationData.email || "";
    // Remembers which field (if any) the visitor clicked on this box's inactive
    // placeholder -- set by the field-specific handlers below -- so the effect below can
    // focus the corresponding real input once the click also activates this box.
    // `undefined` means the click landed elsewhere in the box (its background, a label,
    // the forgot-password link) rather than on a specific field's placeholder, so the
    // effect falls back to focusing the first empty field instead.
    const pendingFocusFieldRef = (0, $acw62.useRef)(undefined);
    // Tracks whether this box was active on the previous render, so the focus-on-
    // activation effect below only fires on a real inactive -> active transition (a
    // visitor's click) -- never on initial mount, where this box may already start
    // active (e.g. the default login box), and autofocusing on page load with no user
    // interaction would be an unwanted UX regression.
    const wasActiveRef = (0, $acw62.useRef)(active);
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c, _d;
        const wasActive = wasActiveRef.current;
        wasActiveRef.current = active;
        if (!active || wasActive) return;
        const target = pendingFocusFieldRef.current;
        pendingFocusFieldRef.current = undefined;
        if (target === "password") (_a = passwordRef.current) === null || _a === void 0 || _a.focus();
        else if (target === "email") (_b = emailRef.current) === null || _b === void 0 || _b.focus();
        else if (displayEmail) // A click elsewhere in the box (not on a specific field): focus the first empty
        // field. Email already has a value (typed earlier, or prefilled from an
        // invitation), so password -- always empty on a fresh activation, since it's
        // never mirrored into the placeholder -- is next.
        (_c = passwordRef.current) === null || _c === void 0 || _c.focus();
        else (_d = emailRef.current) === null || _d === void 0 || _d.focus();
    }, [
        active,
        displayEmail
    ]);
    const activateField = (field)=>(e)=>{
            e.stopPropagation();
            pendingFocusFieldRef.current = field;
            onActivate();
        };
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "login",
            !active && "inactive"
        ]),
        onClick: active ? undefined : onActivate,
        children: [
            app.cloudSession() && (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "text_on_box",
                children: t("login")
            }),
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                className: "login-block",
                children: [
                    onNativeSignIn && (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "LoginView-native-sign-in-alt",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "button default LoginView-native-sign-in-fallback",
                                disabled: loading,
                                onClick: onNativeSignIn,
                                children: t(loading ? "native_sign_in_loading" : "native_sign_in_fallback")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "LoginView-native-sign-in-or",
                                children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: t("native_sign_in_or")
                                })
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: t("login_email")
                        })
                    }),
                    active ? (0, $7b02d682eb115277$exports.jsxs)("form", {
                        className: "LoginView-form",
                        onSubmit: submit,
                        children: [
                            loginError && (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "LoginView-error",
                                children: t(`error_${loginError}`)
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("form_email"),
                                    labelFor: "login_email",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        ref: emailRef,
                                        id: "login_email",
                                        name: "email",
                                        type: "email",
                                        autoComplete: "username",
                                        defaultValue: displayEmail,
                                        onChange: (e)=>setEmail(e.target.value)
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("form_password"),
                                    labelFor: "login_password",
                                    children: (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "password-field",
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("input", {
                                                ref: passwordRef,
                                                id: "login_password",
                                                name: "password",
                                                type: showPassword ? "text" : "password",
                                                autoComplete: "current-password"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $16b96ad8b17ffac4$export$f04a61298a47a40f), {
                                                icon: showPassword ? (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).EyeOn : (0, $16b96ad8b17ffac4$export$4f13f83fd8bb1dac).EyeOff,
                                                className: "password-toggle",
                                                onClick: ()=>setShowPassword(!showPassword)
                                            })
                                        ]
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "row-right login-actions",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "new-pw-button",
                                        children: (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "#",
                                            onClick: ()=>{
                                                if (app.cloudSession()) {
                                                    app.updateRoute("signup/forgot-password");
                                                    setForgotPassword(true);
                                                } else app.openServer("signup/forgot-password");
                                            },
                                            children: t("form_forgot_password")
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button submit-button",
                                        disabled: loading,
                                        type: "submit",
                                        children: t(loading ? "form_submit_login_loading" : "form_submit_login")
                                    })
                                ]
                            })
                        ]
                    }) : // Inactive: no real <form>/<input> -- just a look-alike placeholder (see
                    // `.input` in Common.scss) so this box can never contribute a second, real
                    // email/password field to the DOM alongside the signup box's. Each
                    // placeholder still calls `onActivate` (via `activateField`) when clicked, so
                    // clicking anywhere in the box still activates it -- but stops the click from
                    // bubbling to the outer box's generic handler, so the specific field that was
                    // clicked (not just "the first empty field") gets focused once active.
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "LoginView-form",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("form_email"),
                                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "input",
                                        onClick: activateField("email"),
                                        children: displayEmail
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("form_password"),
                                    children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "password-field",
                                        children: (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "input",
                                            onClick: activateField("password")
                                        })
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                className: "row-right login-actions",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "new-pw-button",
                                        children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: t("form_forgot_password")
                                        })
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button submit-button",
                                        disabled: loading,
                                        type: "button",
                                        children: t(loading ? "form_submit_login_loading" : "form_submit_login")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}





function $f1b73e13faf481fd$export$58103fbed9176086({ loading: loading, acceptInvitation: acceptInvitation, useOtherAccount: useOtherAccount, loginError: loginError }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("LoginView");
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "invitation-actions",
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
            className: "invitation-actions-block",
            children: [
                loginError && (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "LoginView-error",
                    children: t(`error_${loginError}`)
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    actions: true,
                    className: "invitation-buttons",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button",
                                onClick: useOtherAccount,
                                disabled: loading,
                                children: t("invitation_use_other_account")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button default",
                                onClick: acceptInvitation,
                                disabled: loading,
                                children: t("invitation_accept")
                            })
                        })
                    ]
                })
            ]
        })
    });
}





function $9a60354616683514$export$43b216e038aaf69({ language: language, languageButtonText: languageButtonText, languageOptions: languageOptions, handleLanguageChange: handleLanguageChange, setResetDialog: setResetDialog }) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("LoginView");
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "LoginView-footer",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "footer-left",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $d5eb93924f70e37c$export$ef9b1a59e592288f), {
                    className: "language-selector",
                    button: languageButtonText,
                    value: language,
                    onSelect: handleLanguageChange,
                    options: languageOptions,
                    title: t("footer_language")
                })
            }),
            !app.cloudSession() && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "footer-right",
                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "reset-app",
                    onClick: ()=>setResetDialog(1),
                    title: t("footer_reset_app"),
                    children: t("footer_reset_app")
                })
            })
        ]
    });
}


const $7a74efb42bb310da$export$b5336ac4bb95df97 = "native-login";
const $7a74efb42bb310da$export$f0ce3143e4366c8 = "logbook:";
function $7a74efb42bb310da$export$5d9ed0b423a91d7f(search, pageOrigin = window.location.origin) {
    const params = new URLSearchParams(search);
    const state = params.get("state");
    const redirect = params.get("redirect");
    if (!state || !redirect) return undefined;
    try {
        const url = new URL(redirect);
        const browserCallback = url.origin === pageOrigin && url.pathname === "/app/native-login/browser-callback" && url.username === "" && url.password === "" && url.hash === "";
        if (url.protocol !== $7a74efb42bb310da$export$f0ce3143e4366c8 && !browserCallback) return undefined;
        return {
            state: state,
            redirect: url.toString()
        };
    } catch (_a) {
        return undefined;
    }
}
function $7a74efb42bb310da$export$fc706f31b7abf41f(request, code) {
    const callback = new URL(request.redirect);
    callback.searchParams.set("code", code);
    callback.searchParams.set("state", request.state);
    return callback.toString();
}
function $7a74efb42bb310da$export$ff873364aa958b84(url) {
    window.location.href = url;
}


function $63fadd5d69cd6e64$export$1582048ca8384970({ initial: initial }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("LoginView");
    const initialRoute = (0, $acw62.useMemo)(()=>{
        var _a;
        return (_a = initial === null || initial === void 0 ? void 0 : initial.route) !== null && _a !== void 0 ? _a : window.location.pathname.split("/app/", 2)[1];
    }, []);
    const nativeLoginRoute = app.cloudSession() && initialRoute === (0, $7a74efb42bb310da$export$b5336ac4bb95df97);
    const nativeLoginRequest = (0, $acw62.useMemo)(()=>{
        var _a;
        return nativeLoginRoute ? (_a = initial === null || initial === void 0 ? void 0 : initial.nativeLogin) !== null && _a !== void 0 ? _a : (0, $7a74efb42bb310da$export$5d9ed0b423a91d7f)(window.location.search) : undefined;
    }, [
        nativeLoginRoute
    ]);
    const nativeLoginCompleting = (0, $acw62.useRef)(false);
    const nativeSignInStarted = (0, $acw62.useRef)(false);
    const nativeSignInInProgress = (0, $acw62.useRef)(false);
    const nativeSignInMounted = (0, $acw62.useRef)(false);
    const companionHandoffStarted = (0, $acw62.useRef)(false);
    const [companionHandoffFailed, setCompanionHandoffFailed] = (0, $acw62.useState)((_a = initial === null || initial === void 0 ? void 0 : initial.companionHandoffFailed) !== null && _a !== void 0 ? _a : false);
    const companionRoute = (0, $b57fb2219af67c07$export$1fb4852a55678982).isCompanionRoute(`/app/${initialRoute}`);
    const companionHandoffPending = (_b = initial === null || initial === void 0 ? void 0 : initial.companionHandoffPending) !== null && _b !== void 0 ? _b : companionRoute && !companionHandoffFailed;
    const localLoginRequired = !app.cloudSession() && ((_c = initial === null || initial === void 0 ? void 0 : initial.localLoginRequired) !== null && _c !== void 0 ? _c : !(0, $b57fb2219af67c07$export$1fb4852a55678982).isLoopbackHost(window.location.hostname));
    const loginBlocked = localLoginRequired || companionRoute || companionHandoffFailed || companionHandoffPending;
    (0, $acw62.useEffect)(()=>{
        nativeSignInMounted.current = true;
        return ()=>{
            nativeSignInMounted.current = false;
        };
    }, []);
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const [forgotPassword, setForgotPassword] = (0, $acw62.useState)((_d = initial === null || initial === void 0 ? void 0 : initial.forgotPassword) !== null && _d !== void 0 ? _d : false);
    const [invitationData, setInvitationData] = (0, $acw62.useState)(undefined);
    const [invitationToken, setInvitationToken] = (0, $acw62.useState)(undefined);
    const [shipInvitationData, setShipInvitationData] = (0, $acw62.useState)(undefined);
    const [shipInvitationToken, setShipInvitationToken] = (0, $acw62.useState)(undefined);
    const [loading, setLoading] = (0, $acw62.useState)((_e = initial === null || initial === void 0 ? void 0 : initial.nativeSignInPending) !== null && _e !== void 0 ? _e : false);
    const [loginError, setLoginError] = (0, $acw62.useState)(initial === null || initial === void 0 ? void 0 : initial.loginError);
    const [message, setMessage] = (0, $acw62.useState)(initial === null || initial === void 0 ? void 0 : initial.message);
    const [resetDialog, setResetDialog] = (0, $acw62.useState)((_f = initial === null || initial === void 0 ? void 0 : initial.resetDialog) !== null && _f !== void 0 ? _f : 0);
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const [signupError, setSignupError] = (0, $acw62.useState)(initial === null || initial === void 0 ? void 0 : initial.signupError);
    const [validInput, setValidInput] = (0, $acw62.useState)(false);
    const [language, setLanguage] = (0, $acw62.useState)(app.language || "en");
    const [nativeSignInAvailable, setNativeSignInAvailable] = (0, $acw62.useState)((_g = initial === null || initial === void 0 ? void 0 : initial.nativeSignInAvailable) !== null && _g !== void 0 ? _g : (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).hasNativeSignIn);
    // Which of the login/signup boxes has real, mounted <input>s -- see LoginSignInView /
    // LoginSignUpView, which render an inert placeholder instead of a real <form> for
    // whichever box isn't active. Only meaningful when both boxes are shown together
    // (`dualBoxes` below); a lone box is always active regardless of this state.
    const [activeBox, setActiveBox] = (0, $acw62.useState)((_h = initial === null || initial === void 0 ? void 0 : initial.activeBox) !== null && _h !== void 0 ? _h : "login");
    // Native (Safari) sign-in is usable at all: the bridge or the E2E browser transport
    // is present, and this is not a cloud session. The credential form stays on screen
    // alongside it -- the Safari button leads because it is the only path where Password
    // AutoFill works from the app's localhost origin, but typing credentials must remain
    // possible (no saved password, a different account, Safari unavailable).
    const nativeSignInPossible = !app.cloudSession() && nativeSignInAvailable && !loginBlocked;
    // Opening the Safari sheet unprompted is right when the app is starting up, and wrong
    // anywhere else -- notably after a logout, which mounts this view on the in-app route
    // and would otherwise re-open the sheet on someone who just chose to leave it.
    const nativeSignInAutoStart = nativeSignInPossible && (!initialRoute || initialRoute === "launch" || initialRoute === "signup");
    const signupEnabled = (0, $acw62.useMemo)(()=>app.cloudSession() && !forgotPassword && !nativeLoginRoute, [
        app,
        forgotPassword,
        nativeLoginRoute
    ]);
    const signupOnly = (0, $acw62.useMemo)(()=>signupEnabled && (initialRoute == "signup/app" || initialRoute == "signup/beta" || invitationData), [
        signupEnabled,
        invitationData
    ]);
    // An existing-account ship invitation: the invitee already has a password, so force
    // the sign-in box instead of the (brand-new-user) sign-up box, without touching
    // `signupOnly`'s existing behaviour.
    const shipInvitationOnly = (0, $acw62.useMemo)(()=>signupEnabled && !!shipInvitationToken, [
        signupEnabled,
        shipInvitationToken
    ]);
    const _companionRoute = (0, $acw62.useMemo)(()=>initialRoute === null || initialRoute === void 0 ? void 0 : initialRoute.match(/^ships\/(\d+)\/companion\/([^/]+)$/), [
        initialRoute
    ]);
    const showSignupAndLogin = (0, $acw62.useMemo)(()=>signupEnabled && !forgotPassword && !signupOnly, [
        signupEnabled,
        forgotPassword,
        signupOnly
    ]);
    // Both boxes are rendered together (see the `flex_boxes` JSX below) exactly when this
    // is true -- i.e. the only scenario where the single-active-box toggle matters. Every
    // other combination (signup-only, ship-invitation sign-in only, non-cloud sign-in
    // only, forgot-password) shows a single box, which is always active regardless of
    // `activeBox`.
    const dualBoxes = (0, $acw62.useMemo)(()=>signupEnabled && !shipInvitationOnly && showSignupAndLogin, [
        signupEnabled,
        shipInvitationOnly,
        showSignupAndLogin
    ]);
    const activateLogin = (0, $acw62.useCallback)(()=>setActiveBox("login"), []);
    const activateSignup = (0, $acw62.useCallback)(()=>setActiveBox("signup"), []);
    // Coalesces the two invitation flows (brand-new-user signup invite vs. existing-account
    // ship invite) so the shared WelcomeView/SignInView/LoginInvitationView only need to
    // read one pair of values, regardless of which flow is active.
    const activeInvitationToken = (0, $acw62.useMemo)(()=>invitationToken !== null && invitationToken !== void 0 ? invitationToken : shipInvitationToken, [
        invitationToken,
        shipInvitationToken
    ]);
    const activeInvitationData = (0, $acw62.useMemo)(()=>invitationData !== null && invitationData !== void 0 ? invitationData : shipInvitationData, [
        invitationData,
        shipInvitationData
    ]);
    const completeNativeLogin = (0, $acw62.useCallback)(async ()=>{
        if (!nativeLoginRequest || nativeLoginCompleting.current) return;
        nativeLoginCompleting.current = true;
        setLoading(true);
        setLoginError(undefined);
        try {
            const response = await (0, $e3e377da0685a737$export$3b437c26facf161d).handoff(app.apiClient, nativeLoginRequest.state);
            (0, $7a74efb42bb310da$export$ff873364aa958b84)((0, $7a74efb42bb310da$export$fc706f31b7abf41f)(nativeLoginRequest, response.code));
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
            nativeLoginCompleting.current = false;
            setLoginError("native_login_failed");
            setLoading(false);
        }
    }, [
        app.apiClient,
        nativeLoginRequest
    ]);
    const startNativeSignIn = (0, $acw62.useCallback)(async ()=>{
        var _a;
        if (!nativeSignInPossible || nativeSignInInProgress.current) return;
        nativeSignInInProgress.current = true;
        setLoading(true);
        setLoginError(undefined);
        try {
            const response = await (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).startNativeSignIn();
            if (!nativeSignInMounted.current || !response) return;
            if (((_a = response.session) === null || _a === void 0 ? void 0 : _a.authorized) !== true || typeof response.session.id !== "string" || !response.session.id) throw new Error("Native sign-in returned an unauthorized or incomplete session");
            app.setSession(response.session, response.type, response.account, response.user, response.features, response.accountUserLevel);
            app.updateRoute("");
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Native sign-in could not complete", error);
            if (nativeSignInMounted.current) setLoginError("native_login_failed");
        } finally{
            nativeSignInInProgress.current = false;
            if (nativeSignInMounted.current) setLoading(false);
        }
    }, [
        app,
        nativeSignInPossible
    ]);
    const confirmEmail = (0, $acw62.useCallback)(async (token)=>{
        try {
            const response = await (0, $e3e377da0685a737$export$3b437c26facf161d).confirmEmail(app.apiClient, token);
            if (response && response.session && response.session.authorized && response.session.id) {
                app.setSession(response.session, response.type, response.account, response.user, undefined, response.accountUserLevel);
                app.updateRoute("");
            }
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
            setLoginError("confirmation_failed");
        }
    }, []);
    const resetApp = (0, $acw62.useCallback)(async ()=>{
        const request = (0, $e3e377da0685a737$export$3b437c26facf161d).resetApp(app.apiClient);
        setResetDialog(2);
        const response = await request;
        if (response && response.success) {
            window.location.reload();
            setResetDialog(0);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!localLoginRequired || companionRoute || (initial === null || initial === void 0 ? void 0 : initial.localLoginRequired) !== undefined) return;
        const returnUrl = (0, $b57fb2219af67c07$export$1fb4852a55678982).localReturnURL(localStorage.getItem("logbook-session-return"));
        if (returnUrl && new URL(returnUrl).origin !== window.location.origin) window.location.replace(`${returnUrl}?companion_disconnected=1`);
    }, [
        localLoginRequired,
        companionRoute
    ]);
    (0, $acw62.useEffect)(()=>{
        const params = new URLSearchParams(document.location.search);
        const companionHandoffMatch = initialRoute === null || initialRoute === void 0 ? void 0 : initialRoute.match(/^ships\/(\d+)\/companion\/handoff$/);
        const code = params.get("code");
        const state = params.get("state");
        if (companionHandoffMatch) {
            if (companionHandoffStarted.current) return;
            companionHandoffStarted.current = true;
            if (!code || !state) {
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Companion handoff is missing its code or state");
                setCompanionHandoffFailed(true);
                return;
            }
            const shipId = parseInt(companionHandoffMatch[1]);
            (async ()=>{
                try {
                    const response = await (0, $e3e377da0685a737$export$3b437c26facf161d).exchange(app.apiClient, code, state);
                    if (!response.session.authorized || !response.session.id || response.type !== "local") throw new Error("Companion handoff returned an unauthorized session");
                    localStorage.setItem("logbook-session", response.session.id);
                    localStorage.setItem("logbook-ship", shipId.toString());
                    const returnUrl = (0, $b57fb2219af67c07$export$1fb4852a55678982).localReturnURL(params.get("return_to"));
                    localStorage.removeItem("logbook-session-return");
                    if (returnUrl) localStorage.setItem("logbook-session-return", returnUrl);
                    app.updateRoute("ships/" + shipId);
                    window.location.reload();
                } catch (error) {
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
                    setCompanionHandoffFailed(true);
                }
            })();
            return;
        }
        const companionMatch = initialRoute === null || initialRoute === void 0 ? void 0 : initialRoute.match(/^ships\/(\d+)\/companion\/([^/]+)$/);
        if (companionMatch) {
            const shipId = parseInt(companionMatch[1]);
            const session = companionMatch[2];
            localStorage.setItem("logbook-session", session);
            localStorage.setItem("logbook-ship", shipId.toString());
            const returnUrl = (0, $b57fb2219af67c07$export$1fb4852a55678982).localReturnURL(params.get("return_to"));
            localStorage.removeItem("logbook-session-return");
            if (returnUrl) localStorage.setItem("logbook-session-return", returnUrl);
            app.updateRoute("ships/" + shipId);
            window.location.reload();
            return;
        }
        if (localLoginRequired) return;
        const invitationMatch = initialRoute === null || initialRoute === void 0 ? void 0 : initialRoute.match(/^signup\/invitation\/([^/]+)$/);
        if (app.hasFeature("multi-user") && app.cloudSession() && invitationMatch) {
            setInvitationToken(invitationMatch[1]);
            fetchInvitationData(invitationMatch[1]);
            return;
        }
        const shipInvitationMatch = initialRoute === null || initialRoute === void 0 ? void 0 : initialRoute.match(/^ships\/invitation\/([^/]+)$/);
        if (app.hasFeature("multi-user") && app.cloudSession() && shipInvitationMatch) {
            setShipInvitationToken(shipInvitationMatch[1]);
            fetchShipInvitationData(shipInvitationMatch[1]);
            return;
        }
        const confirmationTokenMatch = initialRoute === null || initialRoute === void 0 ? void 0 : initialRoute.match(/^signup\/confirm-email\/([^/]+)$/);
        if (confirmationTokenMatch) {
            confirmEmail(confirmationTokenMatch[1]);
            return;
        }
        const forgotPasswordTokenMatch = initialRoute === null || initialRoute === void 0 ? void 0 : initialRoute.match(/^signup\/forgot-password\/([^/]+)$/);
        if (forgotPasswordTokenMatch) setForgotPassword(forgotPasswordTokenMatch[1]);
        else if (initialRoute == "signup/forgot-password") setForgotPassword(true);
        else if (!signupEnabled && initialRoute != "signup" && !nativeLoginRoute) app.updateRoute("signup");
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (loginBlocked || (initial === null || initial === void 0 ? void 0 : initial.nativeSignInAvailable) !== undefined || app.cloudSession() || (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).hasNativeSignIn()) return;
        let mounted = true;
        (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).nativeSignInAvailable().then((available)=>{
            if (mounted) setNativeSignInAvailable(available);
        });
        return ()=>{
            mounted = false;
        };
    }, [
        app
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (nativeLoginRequest && ((_a = app.session) === null || _a === void 0 ? void 0 : _a.authorized)) completeNativeLogin();
    }, [
        (_j = app.session) === null || _j === void 0 ? void 0 : _j.authorized,
        completeNativeLogin,
        nativeLoginRequest
    ]);
    (0, $acw62.useEffect)(()=>{
        // `Native.hasNativeSignIn()` (not `nativeSignInPossible`): only the real WebKit
        // bridge auto-opens. The E2E browser transport uses `window.open`, which needs a
        // user gesture to survive popup blocking.
        if (nativeSignInAutoStart && (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).hasNativeSignIn() && !nativeSignInStarted.current) {
            nativeSignInStarted.current = true;
            startNativeSignIn();
        }
    }, [
        nativeSignInAutoStart,
        startNativeSignIn
    ]);
    const fetchInvitationData = (0, $acw62.useCallback)(async (token)=>{
        try {
            const response = await (0, $e3e377da0685a737$export$3b437c26facf161d).loadInvitation(app.apiClient, token);
            if (response && response.email) {
                setInvitationData(response);
                setMessage(undefined);
            } else {
                setMessage("invitation_invalid");
                setInvitationToken(undefined);
            }
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
            setMessage("invitation_invalid");
            setInvitationToken(undefined);
        }
    }, []);
    const fetchShipInvitationData = (0, $acw62.useCallback)(async (token)=>{
        try {
            const response = await (0, $e3e377da0685a737$export$3b437c26facf161d).loadShipInvitation(app.apiClient, token);
            if (response && response.email) {
                setShipInvitationData(response);
                setMessage(undefined);
            } else {
                setMessage("invitation_invalid");
                setShipInvitationToken(undefined);
            }
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
            setMessage("invitation_invalid");
            setShipInvitationToken(undefined);
        }
    }, []);
    const submit = (0, $acw62.useCallback)(async (e)=>{
        e.preventDefault();
        const data = new FormData(e.target);
        const email = data.get("email");
        const password = data.get("password");
        setLoading(true);
        setLoginError(undefined);
        try {
            const response = await (0, $e3e377da0685a737$export$3b437c26facf161d).login(app.apiClient, {
                "email": email,
                "password": password,
                "client": app.cloudSession() ? "cloud" : undefined
            });
            if (response && response.session && response.session.authorized && response.session.id) {
                app.setSession(response.session, response.type, response.account, response.user, response.features, response.accountUserLevel);
                if (nativeLoginRequest) {
                    await completeNativeLogin();
                    return;
                }
                // Skip the normal post-login redirect on a ship-invitation route: the invitee
                // still needs to see (and act on) the LoginInvitationView accept UI before
                // navigating away.
                if (!shipInvitationToken) app.updateRoute("");
            } else if (response && response.session && !response.session.authorized) setLoginError("failed");
            setLoading(false);
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
            setLoginError("failed_request");
            setLoading(false);
        }
    }, [
        completeNativeLogin,
        nativeLoginRequest,
        shipInvitationToken
    ]);
    const submitReset = (0, $acw62.useCallback)(async (e)=>{
        e.preventDefault();
        const data = new FormData(e.target);
        const email = data.get("email");
        setLoading(true);
        setLoginError(undefined);
        try {
            const response = await (0, $e3e377da0685a737$export$3b437c26facf161d).forgotPassword(app.apiClient, {
                "email": email
            });
            if (response && response.success == true) setForgotPassword("success");
            else setLoginError("reset_failed");
            setLoading(false);
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
            setLoginError("reset_failed_request");
            setLoading(false);
        }
    }, []);
    const submitResetComplete = (0, $acw62.useCallback)(async (e)=>{
        e.preventDefault();
        const data = new FormData(e.target);
        const password = data.get("password");
        const passwordConfirmation = data.get("passwordConfirmation");
        setLoading(true);
        setLoginError(undefined);
        try {
            const response = await (0, $e3e377da0685a737$export$3b437c26facf161d).resetPassword(app.apiClient, forgotPassword, {
                "password": password,
                "passwordConfirmation": passwordConfirmation
            });
            if (response && response.success == true) setForgotPassword("complete");
            else setLoginError("reset_failed");
            setLoading(false);
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
            setLoginError("reset_failed_request");
            setLoading(false);
        }
    }, [
        forgotPassword
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const saveEdits = (0, $acw62.useCallback)(async (_data, values)=>{
        setLoading(true);
        setSignupError(undefined);
        if (invitationToken) {
            const response = await (0, $e3e377da0685a737$export$3b437c26facf161d).acceptInvitation(app.apiClient, invitationToken, values);
            if (response && response.session && response.session.authorized && response.session.id) {
                app.setSession(response.session, response.type, response.account, response.user, undefined, response.accountUserLevel);
                app.updateRoute("");
            } else if (response && response.session && !response.session.authorized) setLoginError("failed");
        } else {
            // Every rejection ends up here, named or not (#1820). The failure branch used to
            // run only for a wire shape the server stopped sending, so a rejected signup left
            // no message AND no `setLoading(false)` -- the submit button simply died. Reading
            // the reason is now the only thing that depends on the error's shape; clearing the
            // form state is unconditional.
            let response;
            try {
                response = await (0, $e3e377da0685a737$export$3b437c26facf161d).createAccount(app.apiClient, values);
            } catch (error) {
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
                setSignupError((0, $6ae1228e0cc3b7e8$export$3f914597308532a)(error) || "signup_failed");
                // Keeps submit disabled until something is actually changed, so a retry cannot
                // repost the exact request that was just refused.
                setValidInput(false);
                setLoading(false);
                resetEdited();
                return;
            }
            if (response && response.success) setMessage("signup_success");
            setLoading(false);
        }
    }, [
        invitationToken
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
    const validateEdits = (0, $acw62.useCallback)((_data, values)=>{
        const valid = (0, $e3e377da0685a737$export$3b437c26facf161d).validateSignup(values, signupError);
        setValidInput(valid);
        resetEdited();
        return valid;
    }, [
        resetEdited,
        signupError
    ]);
    const languageOptions = (0, $acw62.useMemo)(()=>[
            {
                title: "English",
                value: "en"
            },
            {
                title: "Deutsch",
                value: "de"
            },
            {
                title: "Fran\xe7ais",
                value: "fr"
            }
        ], []);
    const handleLanguageChange = (0, $acw62.useCallback)((newLang)=>{
        setLanguage(newLang);
        app.setLanguage(newLang);
    }, [
        app
    ]);
    const languageButtonText = (0, $acw62.useMemo)(()=>{
        const option = languageOptions.find((opt)=>opt.value === language);
        return (option === null || option === void 0 ? void 0 : option.title) || language.toUpperCase();
    }, [
        language,
        languageOptions
    ]);
    const acceptInvitation = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setLoginError(undefined);
        try {
            if (shipInvitationToken) {
                await (0, $e3e377da0685a737$export$3b437c26facf161d).acceptShipInvitation(app.apiClient, shipInvitationToken);
                app.updateRoute("");
            } else {
                // Pre-existing stub: a brand-new-user signup-invitation link visited while
                // already logged in as a different user has no attach action defined yet
                // (out of scope for this issue -- RootView only forces LoginView to stay
                // mounted for the *ship*-invitation route, so this branch stays as-is).
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("Accepting invitation");
                app.updateRoute("");
            }
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
            setLoginError("invitation_accept_failed");
        }
        setLoading(false);
    }, [
        app,
        invitationData,
        shipInvitationToken
    ]);
    const useOtherAccount = (0, $acw62.useCallback)(async ()=>{
        // Log out current user
        try {
            await (0, $e3e377da0685a737$export$3b437c26facf161d).deleteSession(app.apiClient);
            window.location.reload();
        } catch (error) {
            (0, $ea493e883ca706d4$export$af88d00dbe7f521).error(error);
        }
    }, [
        app
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "LoginView",
            signupEnabled && showSignupAndLogin ? "signup-enabled" : "login-only",
            signupOnly && "signup-only"
        ]),
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "logo",
                children: (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: "https://logbook.yachts",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: app.theme === "light" ? "/logbook-logo-all-black.svg" : "/logbook-logo-all.svg"
                    })
                })
            }),
            resetDialog > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $0763d2bb9c39b379$export$bd72c327b6d4c99b), {
                resetDialog: resetDialog,
                setResetDialog: setResetDialog,
                resetApp: resetApp
            }),
            !nativeLoginRoute && !loginBlocked && (0, $7b02d682eb115277$exports.jsx)((0, $31778daca63357f6$export$af371dcb9bc76d53), {
                message: message,
                invitationToken: activeInvitationToken,
                invitationData: activeInvitationData
            }),
            loginBlocked && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "LoginView-error LoginView-local-login-required",
                role: "status",
                children: t(companionHandoffFailed ? "companion_handoff_failed" : companionHandoffPending ? "companion_handoff_pending" : "local_login_required")
            }),
            nativeLoginRoute && (!nativeLoginRequest || loginError == "native_login_failed") && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "LoginView-error LoginView-native-login-error",
                children: t(`error_${nativeLoginRequest ? "native_login_failed" : "native_login_invalid"}`)
            }),
            !loginBlocked && !message && !(activeInvitationToken && app.user) && (!nativeLoginRoute || !!nativeLoginRequest && !((_k = app.session) === null || _k === void 0 ? void 0 : _k.authorized)) && (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex_boxes",
                children: [
                    signupEnabled && !shipInvitationOnly && (0, $7b02d682eb115277$exports.jsx)((0, $7e49ed677a351531$export$e4e16e728e8111a3), {
                        active: !dualBoxes || activeBox === "signup",
                        onActivate: activateSignup,
                        edited: edited,
                        onEdited: onEdited,
                        saveEdits: saveEdits,
                        validateEdits: validateEdits,
                        signupError: signupError,
                        showPassword: showPassword,
                        setShowPassword: setShowPassword,
                        validInput: validInput,
                        loading: loading,
                        invitationData: invitationData,
                        invitationToken: invitationToken
                    }),
                    forgotPassword && (0, $7b02d682eb115277$exports.jsx)((0, $eabd4aed77c95069$export$35dc946c6218e926), {
                        forgotPassword: forgotPassword,
                        loginError: loginError,
                        loading: loading,
                        showPassword: showPassword,
                        setShowPassword: setShowPassword,
                        submitReset: submitReset,
                        submitResetComplete: submitResetComplete,
                        setForgotPassword: setForgotPassword,
                        onEdited: onEdited
                    }),
                    (!signupEnabled || showSignupAndLogin) && !forgotPassword && (0, $7b02d682eb115277$exports.jsx)((0, $6312f3e1ca5053de$export$5f7611c3f433baae), {
                        active: !dualBoxes || activeBox === "login",
                        onActivate: activateLogin,
                        loginError: loginError,
                        loading: loading,
                        showPassword: showPassword,
                        setShowPassword: setShowPassword,
                        submit: submit,
                        invitationData: activeInvitationData,
                        setForgotPassword: setForgotPassword,
                        onNativeSignIn: nativeSignInPossible ? ()=>void startNativeSignIn() : undefined
                    })
                ]
            }),
            !message && activeInvitationData && app.user && (0, $7b02d682eb115277$exports.jsx)((0, $f1b73e13faf481fd$export$58103fbed9176086), {
                loading: loading,
                acceptInvitation: acceptInvitation,
                useOtherAccount: useOtherAccount,
                loginError: loginError
            }),
            !nativeLoginRoute && !loginBlocked && (0, $7b02d682eb115277$exports.jsx)((0, $9a60354616683514$export$43b216e038aaf69), {
                language: language,
                languageButtonText: languageButtonText,
                languageOptions: languageOptions,
                handleLanguageChange: handleLanguageChange,
                setResetDialog: setResetDialog
            })
        ]
    });
}



function $9bb7a7a0af5482a9$export$e21886a4eef6b29a(_) {
    var _a, _b, _c, _d, _e;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const route = app.getRoute();
    const isShipInvitationPath = ((_a = route.route) === null || _a === void 0 ? void 0 : _a[0]) == "ships" && ((_b = route.route) === null || _b === void 0 ? void 0 : _b[1]) == "invitation";
    // An enabled ship-invitation link must render LoginView even for an authorized
    // session so its already-logged-in accept UI remains reachable.
    const isShipInvitationRoute = app.hasFeature("multi-user") && isShipInvitationPath;
    // Let AppView's ordinary index-route redirect choose the account or current
    // ship instead of interpreting "invitation" as a numeric ship id.
    const appRoute = isShipInvitationPath && !isShipInvitationRoute ? Object.assign(Object.assign({}, route), {
        route: []
    }) : route;
    const isNativeLoginRoute = app.cloudSession() && ((_c = route.route) === null || _c === void 0 ? void 0 : _c.length) == 1 && route.route[0] == "native-login";
    const isCompanionRoute = !app.cloudSession() && (0, $b57fb2219af67c07$export$1fb4852a55678982).isCompanionRoute(`/app/${(_d = route.route) === null || _d === void 0 ? void 0 : _d.join("/")}`);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $2e799dc50d0acd79$export$ce4ab0c55987d1ff)([
            "RootView",
            ...app.appStyles.map((s)=>`app-style-${s}`)
        ]),
        children: ((_e = app.session) === null || _e === void 0 ? void 0 : _e.authorized) && !isShipInvitationRoute && !isNativeLoginRoute && !isCompanionRoute ? (0, $7b02d682eb115277$exports.jsx)((0, $9e6448ab8a42c24a$export$3713363bfd8bacdf), {
            route: appRoute
        }) : (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: (0, $7b02d682eb115277$exports.jsx)((0, $63fadd5d69cd6e64$export$1582048ca8384970), {})
        })
    });
}






var $acw62 = parcelRequire("acw62");




function $66e0648e16241233$export$a30da8c34ad56b33({ session: session, response: response }) {
    var _a, _b;
    const store = (0, $db922aea4424a404$export$26531d8e255edf16)();
    const storedAccount = (0, $b82e6d2a15bbd8b8$export$fab329b658bf30c7)(store, "Account", (_a = session === null || session === void 0 ? void 0 : session.accountId) !== null && _a !== void 0 ? _a : -1);
    const storedAccountUsers = (0, $b82e6d2a15bbd8b8$export$dd0a697e1782aedd)(store, "AccountUser", {
        accountId: (0, $55c0c0d4c269af54$export$a7a0278c004aac3f)(session === null || session === void 0 ? void 0 : session.accountId),
        userId: (0, $55c0c0d4c269af54$export$a7a0278c004aac3f)(session === null || session === void 0 ? void 0 : session.userId)
    });
    (0, $acw62.useLayoutEffect)(()=>{
        if (response) store.applyBundlePreservingLive((0, $73eea1fea92cc6a5$export$79764cf71b00e905)(response));
    }, [
        store,
        response
    ]);
    (0, $9690902269ab2924$export$e4edb3e6a3489a79)([
        "Account",
        "AccountUser"
    ], true);
    return {
        account: storedAccount,
        accountUserLevel: (_b = storedAccountUsers[0]) === null || _b === void 0 ? void 0 : _b.accountLevel
    };
}



const $b1a950ec5f3fb9ad$var$appContext = (0, $736b3300c1bfc0c7$export$63e8bf8ba447cd7a)("AppContext");
const $b1a950ec5f3fb9ad$export$122994dc05ba4308 = $b1a950ec5f3fb9ad$var$appContext.Context;
const $b1a950ec5f3fb9ad$export$56752c5ff04def75 = ()=>(0, $acw62.useContext)($b1a950ec5f3fb9ad$export$122994dc05ba4308);
function $b1a950ec5f3fb9ad$export$86fbec116b87613f({ children: children }) {
    const state = (0, $534676d4dce85d2d$export$9973955de2bf96cf)();
    const target = state.sessionType == (0, $a8c48887e141e972$export$9fd99c4c3c179cff).cloud ? "server" : "app";
    const apiClient = (0, $acw62.useMemo)(()=>(0, $be0017b4bd97ce4b$export$8744222f7aa763e1)(target), [
        target
    ]);
    const identity = (0, $73eea1fea92cc6a5$export$fc07fe94f5a41790)(state.session, state.sessionType, target);
    const sessionIdentityRef = (0, $acw62.useRef)(identity);
    sessionIdentityRef.current = identity;
    const seed = state.accountSessionResponse ? (0, $73eea1fea92cc6a5$export$79764cf71b00e905)(state.accountSessionResponse).entities : undefined;
    return (0, $7b02d682eb115277$exports.jsx)((0, $db922aea4424a404$export$eca4bdafe2d91d15), {
        socket: state.socket,
        apiClient: apiClient,
        seed: seed,
        children: (0, $7b02d682eb115277$exports.jsx)($b1a950ec5f3fb9ad$var$AppContent, {
            state: state,
            apiClient: apiClient,
            sessionIdentityRef: sessionIdentityRef,
            children: children
        })
    }, identity);
}
function $b1a950ec5f3fb9ad$var$AppContent({ state: state, apiClient: apiClient, sessionIdentityRef: sessionIdentityRef, children: children }) {
    const serverOpening = (0, $acw62.useRef)(false);
    const [serverNavigation, setServerNavigation] = (0, $acw62.useState)();
    const { lang: lang, accountSessionResponse: accountSessionResponse, appStyles: appStyles, current: current, features: features, session: session, sessionType: sessionType, shipId: shipId, status: status, socket: socket, theme: theme, user: user, setLang: setLang, setCurrent: setCurrent, setFeatures: setFeatures, setLocation: setLocation, setAccountSessionResponse: setAccountSessionResponse, setSession: setSession, setSessionType: setSessionType, setShipId: setShipId, setStatus: setStatus, setTheme: setTheme, setUser: setUser } = state;
    const { account: account, accountUserLevel: accountUserLevel } = (0, $66e0648e16241233$export$a30da8c34ad56b33)({
        session: session,
        response: accountSessionResponse
    });
    const app = (0, $acw62.useMemo)(()=>({
            account: account,
            accountUserLevel: accountUserLevel,
            apiClient: apiClient,
            appStyles: appStyles,
            current: current,
            editable: sessionType == (0, $a8c48887e141e972$export$9fd99c4c3c179cff).primary || sessionType == (0, $a8c48887e141e972$export$9fd99c4c3c179cff).local,
            session: session,
            sessionType: sessionType,
            shipId: shipId,
            socket: socket,
            status: status,
            theme: theme,
            user: user,
            language: lang,
            t: (text, replace)=>{
                return (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).t(lang, text, replace);
            },
            getT: (prefix)=>{
                return (text, replace)=>{
                    return app.t([
                        prefix,
                        text
                    ].join("_"), replace);
                };
            },
            format: (0, $14a8bda8b42de2c4$export$d9468344d3651243),
            updateData: (data, object, resetFields)=>{
                return (0, $5ba8962d09b05c4a$export$b531eccea6f91101).updateData(data, object, resetFields);
            },
            dataWithCalculations: (data, calculations, notes, attachments, id)=>{
                return (0, $5ba8962d09b05c4a$export$b531eccea6f91101).dataWithCalculations(data, calculations, notes, attachments, id);
            },
            logout: async (deleteSession = true)=>{
                if (deleteSession) await (0, $5ba8962d09b05c4a$export$b531eccea6f91101).deleteSession(app.apiClient);
                (0, $b57fb2219af67c07$export$1fb4852a55678982).clearSession();
                setShipId(undefined);
                setSession({
                    "authorized": false
                });
                setAccountSessionResponse(undefined);
                setUser(undefined);
                const redirect = (0, $b57fb2219af67c07$export$1fb4852a55678982).resolveLogoutRedirect(sessionType === undefined ? undefined : app.localSession());
                if (redirect.action == "reload") window.location.reload();
                else if (redirect.action == "redirect") window.location.href = redirect.url;
            },
            setSession: (session, type, account, user, features, accountUserLevel)=>{
                if (session.authorized) {
                    const { shipId: shipId } = (0, $b57fb2219af67c07$export$1fb4852a55678982).persistSession(socket, session, type);
                    setShipId(shipId);
                    setSessionType(type);
                    setSession(session);
                    if (features) setFeatures(features);
                    setAccountSessionResponse({
                        account: account,
                        session: session,
                        type: type,
                        user: user,
                        features: features,
                        accountUserLevel: accountUserLevel
                    });
                    setUser(user);
                } else app.logout(false);
            },
            reconcileSession: (response, expectedIdentity)=>{
                if (expectedIdentity && sessionIdentityRef.current !== expectedIdentity) return;
                if (!response.session.authorized) {
                    app.logout(false);
                    return;
                }
                const responseTarget = response.type == (0, $a8c48887e141e972$export$9fd99c4c3c179cff).cloud ? "server" : "app";
                const responseIdentity = (0, $73eea1fea92cc6a5$export$fc07fe94f5a41790)(response.session, response.type, responseTarget);
                if (sessionIdentityRef.current !== responseIdentity) return;
                const sameIdentity = (0, $73eea1fea92cc6a5$export$fc07fe94f5a41790)(session, sessionType, app.apiClient.target) === responseIdentity;
                setSessionType(response.type);
                setSession(response.session);
                if (response.features) setFeatures(response.features);
                setAccountSessionResponse(response);
                if (response.user || !sameIdentity) setUser(response.user);
            },
            updateSession: (account, user)=>{
                if (user) setUser(user);
                if (session && sessionType) setAccountSessionResponse({
                    account: account !== null && account !== void 0 ? account : app.account,
                    session: session,
                    type: sessionType,
                    user: user !== null && user !== void 0 ? user : app.user,
                    features: features,
                    accountUserLevel: app.accountUserLevel
                });
            },
            setShipId: async (shipId, close, skipPost)=>{
                if (sessionType == "primary" && skipPost != true) // Let the API error through untouched. This used to rethrow a bare
                // `new Error("Failed to set ship")`, which discarded the body and status both
                // callers route on: `AppView.selectShip` needs the error name (`sessionExpired`
                // opens the re-login prompt, #1449; `limitActiveShipsReached` shows the
                // specific message), and `AppView.resetShip` reports `error.httpStatus` in the
                // close-failed dialog (#1279). Wrapping made every one of those unreachable.
                await (0, $5ba8962d09b05c4a$export$b531eccea6f91101).selectShip(app.apiClient, shipId, close ? true : false);
                setStatus(undefined);
                setCurrent(undefined);
                (0, $b57fb2219af67c07$export$1fb4852a55678982).persistShipId(shipId, close);
                setShipId(close ? undefined : shipId);
            },
            forceCloseShip: async (shipId)=>{
                if (sessionType != "primary") throw new Error("Force close requires a primary session");
                await (0, $5ba8962d09b05c4a$export$b531eccea6f91101).selectShip(app.apiClient, shipId, true, true);
                setStatus(undefined);
                setCurrent(undefined);
                (0, $b57fb2219af67c07$export$1fb4852a55678982).persistShipId(shipId, true);
                setShipId(undefined);
            },
            setLanguage: (language)=>{
                app.language = language;
                setLang(language);
                localStorage.setItem("logbook-language", language);
                document.documentElement.setAttribute("lang", language);
                // In cloud sessions the language is persisted server-side so it follows
                // the user across devices and drives their emails. Fire-and-forget: the
                // local state is already updated above.
                const updateLanguage = new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(app.apiClient).account.updateLanguage({
                    params: {},
                    body: {
                        language: language
                    }
                });
                const apiUser = user ? (0, $d96ebf18a3a82ea8$export$62231c592686b3e3).apiUser({
                    accountId: account === null || account === void 0 ? void 0 : account.id,
                    accountUserLevel: accountUserLevel
                }) : undefined;
                if (sessionType == (0, $a8c48887e141e972$export$9fd99c4c3c179cff).cloud && updateLanguage.available(apiUser)) {
                    const requestIdentity = sessionIdentityRef.current;
                    updateLanguage.call().then((response)=>{
                        if (sessionIdentityRef.current === requestIdentity) app.reconcileSession(response, requestIdentity);
                    }).catch((error)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("failed to persist language", error));
                }
            },
            setTheme: (t)=>{
                // Prevent theme change in cloud session
                if (sessionType == (0, $a8c48887e141e972$export$9fd99c4c3c179cff).cloud) return;
                app.theme = t;
                setTheme(t);
                localStorage.setItem("logbook-theme", t);
                document.documentElement.setAttribute("data-theme", t);
            },
            resetStatus: async ()=>{
                setStatus(undefined);
                // Absorbed, never rethrown: every call site is fire-and-forget (`Focus/Frame.ts`'s
                // reset, `Trip/EditView`'s start, `useAppState`'s callbacks) and runs from a
                // subscription handler or effect that cannot await, so a rejection here becomes an
                // UNHANDLED rejection. Selecting a ship wipes and re-downloads the local DB, and
                // the app answers 503 while that is in flight (#1279) -- exactly when these fire.
                // A best-effort refresh that fails simply leaves the data as it was.
                try {
                    const newStatus = await app.updateStatus();
                    if (newStatus) setStatus(newStatus);
                } catch (error) {
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("status refresh failed", error);
                }
            },
            updateStatus: async ()=>{
                return await (0, $5ba8962d09b05c4a$export$b531eccea6f91101).loadStatus(app.apiClient);
            },
            cloudSession: ()=>sessionType == (0, $a8c48887e141e972$export$9fd99c4c3c179cff).cloud,
            primarySession: ()=>sessionType == (0, $a8c48887e141e972$export$9fd99c4c3c179cff).primary,
            localSession: ()=>sessionType == (0, $a8c48887e141e972$export$9fd99c4c3c179cff).local,
            hasFeature: (feature)=>{
                return (0, $e32f189306d11372$export$10af58e6fc210ef8)(features, feature);
            },
            updateCurrent: async ()=>{
                if (!session || session.authorized != true || sessionType == "cloud" || !shipId) return;
                // Absorbed for the same reason as `resetStatus` above -- fire-and-forget callers,
                // and a 503 is the expected answer mid-reset rather than an error worth surfacing.
                try {
                    const data = await (0, $5ba8962d09b05c4a$export$b531eccea6f91101).loadCurrent(app.apiClient);
                    if (data) {
                        setCurrent(data);
                        app.current = data;
                    }
                } catch (error) {
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("current refresh failed", error);
                }
            },
            getRoute: (customRoot)=>{
                return (0, $2472f3c19d716da0$export$6462bdfc589180f8)(customRoot);
            },
            updateRoute: (path, replace)=>{
                setLocation((0, $2472f3c19d716da0$export$8384939689d442cc)(path, replace));
            },
            openServer: async (path)=>{
                if (app.cloudSession() || serverOpening.current) return false;
                serverOpening.current = true;
                setServerNavigation({
                    path: path,
                    pending: true
                });
                try {
                    const loadURL = async ()=>{
                        const response = await (0, $5ba8962d09b05c4a$export$b531eccea6f91101).loadServer(app.apiClient);
                        return (0, $f73c59e6f36e52da$export$7e3547f81f4d8512)(response.host, path, (0, $fe1fa5963413bede$export$2dffd0b5373a4389).isIOS(app));
                    };
                    if ((0, $413160cb4953a8b8$export$7bbc682b75e8aad4).hasAppleManifest()) await (0, $413160cb4953a8b8$export$7bbc682b75e8aad4).openAppleURL(await loadURL());
                    else if ((0, $fe1fa5963413bede$export$2dffd0b5373a4389).isNativeApp(app)) // Legacy shells intercept this request and return no WindowProxy.
                    // Keep their dispatch path separate from browser popup reservation.
                    window.open(await loadURL(), "_blank");
                    else await (0, $424672e608e19fa2$export$7be7ee3ecebdaec9)(loadURL);
                    setServerNavigation(undefined);
                    return true;
                } catch (error) {
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("Cloud navigation failed", error);
                    setServerNavigation({
                        path: path,
                        pending: false
                    });
                    return false;
                } finally{
                    serverOpening.current = false;
                }
            }
        }), [
        lang,
        account,
        accountUserLevel,
        apiClient,
        appStyles,
        current,
        features,
        session,
        sessionType,
        shipId,
        status,
        theme,
        user
    ]);
    (0, $534676d4dce85d2d$export$d44906bd7696f00d)(app, state);
    return (0, $7b02d682eb115277$exports.jsx)($b1a950ec5f3fb9ad$export$122994dc05ba4308.Provider, {
        value: app,
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                children ? children : session ? (0, $7b02d682eb115277$exports.jsx)((0, $9bb7a7a0af5482a9$export$e21886a4eef6b29a), {}) : (0, $7b02d682eb115277$exports.jsx)((0, $dd0c245c4eefac88$export$669f6ea7d267feaf), {}),
                serverNavigation && (0, $7b02d682eb115277$exports.jsx)((0, $4505d62785317e3b$export$b143682c58b4e0ac), {
                    pending: serverNavigation.pending,
                    t: app.getT("OpenServerDialog"),
                    onClose: ()=>setServerNavigation(undefined),
                    onRetry: ()=>{
                        app.openServer(serverNavigation.path);
                    }
                })
            ]
        })
    });
}
// How the app answers an error that escaped React (#1813).
//
// React 19's #185 ("Maximum update depth exceeded") is thrown from
// `dispatchSetState` — in this app, from a websocket handler — so it never reaches
// a React error boundary; it surfaces on `window.onerror`. Until now that painted
// the static page below, leaving the app dead until the user reloaded by hand,
// even though the condition is transient: React's nested-update counter resets on
// the first commit that lands with an empty queue, so a fresh mount clears it.
//
// So recover, but boundedly, and record the attempts in `sessionStorage` so the
// count survives the reload step and a genuinely broken build can't reload-loop:
//
//   1st error — remount the tree in place (cheap, keeps the socket session).
//   2nd error — reload the page (heavier, but clears all module state).
//   3rd+      — give up and show the error, so a real fault stays visible.
//
// A run of clean minutes clears the count, so two unrelated errors an hour apart
// are not treated as an escalating failure.
const $b1a950ec5f3fb9ad$var$RECOVERY_KEY = "logbook-app-recovery";
const $b1a950ec5f3fb9ad$var$RECOVERY_RESET_MS = 60000;
function $b1a950ec5f3fb9ad$var$recoveryAttempts() {
    var _a;
    try {
        return Number((_a = sessionStorage.getItem($b1a950ec5f3fb9ad$var$RECOVERY_KEY)) !== null && _a !== void 0 ? _a : "0") || 0;
    } catch (_b) {
        // Private-mode Safari can throw on storage access; without a count we can
        // still remount once, we just can't escalate.
        return 0;
    }
}
function $b1a950ec5f3fb9ad$var$recordRecoveryAttempt(attempts) {
    try {
        sessionStorage.setItem($b1a950ec5f3fb9ad$var$RECOVERY_KEY, String(attempts));
    } catch (_a) {
    // Ignore — see `recoveryAttempts`.
    }
}
function $b1a950ec5f3fb9ad$export$faa776fb9650be52() {
    try {
        sessionStorage.removeItem($b1a950ec5f3fb9ad$var$RECOVERY_KEY);
    } catch (_a) {
    // Ignore — see `recoveryAttempts`.
    }
}
function $b1a950ec5f3fb9ad$export$5781ccfc15674bbd(root) {
    // Reaching a render at all means the previous recovery worked; hold the count
    // briefly in case the error recurs immediately, then forget it.
    window.setTimeout($b1a950ec5f3fb9ad$export$faa776fb9650be52, $b1a950ec5f3fb9ad$var$RECOVERY_RESET_MS);
    try {
        root.render((0, $7b02d682eb115277$exports.jsx)($b1a950ec5f3fb9ad$export$86fbec116b87613f, {}));
    } catch (error) {
        $b1a950ec5f3fb9ad$export$a996741116394418(error, root);
    }
}
function $b1a950ec5f3fb9ad$export$a996741116394418(error, root) {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete error type
    const err = error;
    const attempts = $b1a950ec5f3fb9ad$var$recoveryAttempts() + 1;
    $b1a950ec5f3fb9ad$var$recordRecoveryAttempt(attempts);
    if (attempts <= 2) {
        (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("app error, recovering", attempts, (_a = err === null || err === void 0 ? void 0 : err.toString) === null || _a === void 0 ? void 0 : _a.call(err));
        if (attempts == 1) // Remounting gives React a first commit with nothing queued, which is
        // exactly what resets the nested-update counter behind #185.
        root.render((0, $7b02d682eb115277$exports.jsx)($b1a950ec5f3fb9ad$export$86fbec116b87613f, {}));
        else window.location.reload();
        return;
    }
    root.render((0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "AppRenderError",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Application Error"
            }),
            (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "There was an error rendering the application:"
            }),
            (0, $7b02d682eb115277$exports.jsx)("pre", {
                children: err.toString()
            }),
            (0, $7b02d682eb115277$exports.jsxs)("details", {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("summary", {
                        children: "Stack Trace"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("pre", {
                        children: err.stack
                    })
                ]
            })
        ]
    }));
}








var $acw62 = parcelRequire("acw62");







const $b2c8da7ad26b0f2a$var$logger = (0, $ea493e883ca706d4$export$fe2e61603b61130d)("AboutView");
const $b2c8da7ad26b0f2a$export$5f29e20e9c87d01e = {
    // Newest changelog version key (sorted descending), or undefined when empty.
    currentVersion (changeLog) {
        const versions = Object.keys(changeLog || {}).toSorted().toReversed();
        if (versions && versions.length > 0) return versions[0];
        return undefined;
    },
    // Button label for the current upload-app-data status, falling back to the
    // idle label. Debounces re-clicks by keeping the button disabled/relabelled
    // while an upload is already in flight (@mutle's preferred pattern -- see
    // ShipSelectView's "Selecting…" debounce).
    uploadAppDataLabel (status, t) {
        switch(status){
            case "uploading":
                return t("uploadAppDataUploading");
            case "success":
                return t("uploadAppDataSuccess");
            case "error":
                return t("uploadAppDataError");
            default:
                return t("uploadAppData");
        }
    }
};
function $b2c8da7ad26b0f2a$export$1eb1323c9a3751ef(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const { resetAppOverlay: resetAppOverlay } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const [_show, _setShow] = (0, $acw62.useState)(false);
    const [uploadStatus, setUploadStatus] = (0, $acw62.useState)("idle");
    const t = app.getT("AboutView");
    const currentVersion = (0, $acw62.useMemo)(()=>{
        return $b2c8da7ad26b0f2a$export$5f29e20e9c87d01e.currentVersion((0, $0258f51bf6f9f9d6$export$b6fc69901997e05).Messages[app.language].changeLog);
    }, []);
    // Uploads the current ship's local database (if a ship is selected), the
    // shared app-level database, and this shell's capped local log file (issue
    // #405) to the cloud for customer support, via the local app's own API
    // (only meaningful for a native session with a local database -- see the
    // `!app.cloudSession()` guard around the button below). The log isn't
    // scoped to any particular ship, so it's always sent alongside the app
    // database.
    // Sends this device's ship database (when a ship is selected), the shared
    // app-level database, this shell's capped local log file (issue #405) and any
    // crash log to the cloud for customer support, via the local app's own API
    // (only meaningful for a native session with a local database -- see the
    // `!app.cloudSession()` guard around the button below).
    //
    // One request, not one per artifact: the client used to sequence three calls
    // and was observed to stop after the two databases, so support received no
    // log at all. The route now collects every artifact server-side and reports
    // which ones failed, so a partial upload surfaces here instead of silently
    // dropping the rest.
    const uploadAppData = (0, $acw62.useCallback)(async ()=>{
        if (uploadStatus === "uploading") return;
        setUploadStatus("uploading");
        try {
            const api = new (0, $8c52e5243d6ffa2a$export$6f8605d66cd2f9d5)(app.apiClient);
            const result = await api.debugUpload.upload({
                params: {}
            }).call();
            if (!result.success) {
                $b2c8da7ad26b0f2a$var$logger.error("App data upload incomplete", result.failed);
                setUploadStatus("error");
                return;
            }
            setUploadStatus("success");
        } catch (error) {
            $b2c8da7ad26b0f2a$var$logger.error("App data upload failed", error);
            setUploadStatus("error");
        }
    }, [
        app,
        uploadStatus
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $cb0532ed9be7da24$export$fe53879cede8fc3), {
                title: t("title"),
                closeCallback: resetAppOverlay
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                className: "AboutView Overlay-body",
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                    className: "AboutView-content",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-centered",
                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ShipView-logo",
                                style: {
                                    background: `url('/icon${app.theme == "light" ? "-black" : app.theme == "night" ? "-red" : ""}.svg') center center no-repeat`,
                                    display: "inline-block",
                                    width: "64px",
                                    height: "64px",
                                    backgroundSize: "contain"
                                }
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-centered",
                            children: "LOGBOOK"
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-centered",
                            children: [
                                t("version"),
                                ": ",
                                app.t("LogbookApp_version_major"),
                                " ",
                                currentVersion && (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        "(",
                                        currentVersion,
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-centered",
                            children: t("copyright")
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-centered",
                            children: [
                                (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    children: [
                                        t("website"),
                                        ":"
                                    ]
                                }),
                                " ",
                                (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "https://trimutic.com",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "trimutic.com/"
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-centered",
                            children: [
                                (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                    children: [
                                        t("support"),
                                        ":"
                                    ]
                                }),
                                " ",
                                (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "mailto:support@trimutic.com",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "support@trimutic.com"
                                })
                            ]
                        }),
                        !app.cloudSession() && (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-centered AboutView-upload-app-data",
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "button",
                                disabled: uploadStatus == "uploading",
                                onClick: uploadAppData,
                                children: $b2c8da7ad26b0f2a$export$5f29e20e9c87d01e.uploadAppDataLabel(uploadStatus, t)
                            })
                        })
                    ]
                })
            })
        ]
    });
}








const $f60be5928c5dcb14$export$c2a6c85b4777855c = {
    // Which warning the confirm body leads with. Offline outranks a failed sync:
    // without internet the close cannot even be attempted, so saying so is more
    // actionable than warning about data that could not be uploaded (#541).
    message (noInternet, syncFailed) {
        if (noInternet) return (m)=>m.shipClose.internet;
        if (syncFailed) return (m)=>m.shipClose.noSync;
        return (m)=>m.shipClose.text;
    },
    // Which message a FAILED close reports. Previously there was only one, and it
    // blamed the internet unconditionally -- so @almute saw "check your internet
    // connection" with the Sync menu showing the internet green, because the real cause
    // was a stale claim token (#1453). The close no longer fails for that reason at all
    // (see `closeShip`), which is exactly why the remaining causes must not inherit its
    // wording.
    //
    // Deliberately conservative: a cause is named only when it is known. A 400 from the
    // app's own close route says the close did not complete, not why, so it gets a
    // cause-neutral message rather than an invented one.
    closeFailureMessage ({ noInternet: noInternet, httpStatus: httpStatus }) {
        if (noInternet) return "ship_close_failed_offline";
        if (httpStatus != undefined && httpStatus >= 500) return "ship_close_failed_server";
        return "ship_close_failed";
    },
    // Force close is offered only where the normal, cloud-backed close cannot get
    // through: offline up front, or after one has actually failed (#1279).
    forceCloseAvailable (noInternet, shipCloseFailed) {
        return noInternet || shipCloseFailed === true;
    }
};
function $f60be5928c5dcb14$export$3c56b4195ba80816({ shipName: shipName, noInternet: noInternet, syncFailed: syncFailed, shipClosing: shipClosing, shipCloseFailed: shipCloseFailed, shipCloseFailedStatus: shipCloseFailedStatus, onCancel: onCancel, onCloseShip: onCloseShip, onForceCloseShip: onForceCloseShip, t: t }) {
    return (0, $7b02d682eb115277$exports.jsx)((0, $807e05067c94e8fb$export$746af75b6b2a4bae), {
        className: "Overlay-body message-text-bigger Overlay-body-padding",
        readMoreLabel: t("read_more"),
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                        html: true,
                        message: $f60be5928c5dcb14$export$c2a6c85b4777855c.message(noInternet, syncFailed),
                        replace: {
                            name: shipName || ""
                        }
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                        html: true,
                        message: (m)=>m.shipClose.keepOpen
                    })
                }),
                shipCloseFailed && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        className: "error-message",
                        children: t($f60be5928c5dcb14$export$c2a6c85b4777855c.closeFailureMessage({
                            noInternet: noInternet,
                            httpStatus: shipCloseFailedStatus
                        }))
                    })
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    actions: true,
                    className: "block-row-one-row",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button",
                                disabled: shipClosing,
                                onClick: onCancel,
                                children: t("ship_close_confirm_cancel")
                            })
                        }),
                        !noInternet && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button default",
                                disabled: shipClosing,
                                onClick: onCloseShip,
                                children: shipClosing ? t("ship_close_confirm_closing") : t("ship_close_confirm")
                            })
                        }),
                        $f60be5928c5dcb14$export$c2a6c85b4777855c.forceCloseAvailable(noInternet, shipCloseFailed) && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button warning",
                                disabled: shipClosing,
                                onClick: onForceCloseShip,
                                children: t("ship_force_close")
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function $f60be5928c5dcb14$export$59940996e5afad48({ shipName: shipName, shipClosing: shipClosing, onCancel: onCancel, onForceCloseShip: onForceCloseShip, t: t }) {
    return (0, $7b02d682eb115277$exports.jsx)((0, $807e05067c94e8fb$export$746af75b6b2a4bae), {
        className: "Overlay-body message-text-bigger Overlay-body-padding",
        readMoreLabel: t("read_more"),
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                        html: true,
                        message: (m)=>m.shipClose.forceWarning,
                        replace: {
                            name: shipName || ""
                        }
                    })
                }),
                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    actions: true,
                    className: "block-row-one-row",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button",
                                disabled: shipClosing,
                                onClick: onCancel,
                                children: t("ship_close_confirm_cancel")
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button warning",
                                disabled: shipClosing,
                                onClick: onForceCloseShip,
                                children: shipClosing ? t("ship_close_confirm_closing") : t("ship_force_close_confirm")
                            })
                        })
                    ]
                })
            ]
        })
    });
}






// ShipSyncStatusView moved into Views/Ship/SyncStatusView.tsx. This thin re-export barrel
// keeps the original `./ShipSyncStatusView` import path working for external references
// (e.g. AppOverlayContentView.tsx and its test, which mocks this module) outside the Ship hub.





var $acw62 = parcelRequire("acw62");





function $d3716a969dc576ba$export$cebefbf4af82e50c(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("UserSettingsView");
    const [edited, onEdited, resetEdited] = (0, $51cc312cf1408924$export$f24bdf120ad0e590)();
    const [_language, setLanguage] = (0, $acw62.useState)(app.language || "en");
    const [_theme, setTheme] = (0, $acw62.useState)(app.theme || "dark");
    const isCloudSession = app.cloudSession();
    // Set the selections lists for languages
    const languageOptions = (0, $acw62.useCallback)(()=>{
        return Object.keys((0, $0258f51bf6f9f9d6$export$b6fc69901997e05).Languages).map((lang)=>{
            return (0, $7b02d682eb115277$exports.jsx)("option", {
                value: lang,
                children: t(`lang_${lang}`)
            }, lang);
        });
    }, []);
    const themeOptions = (0, $acw62.useCallback)(()=>{
        return [
            "dark",
            "light",
            "night"
        ].map((theme)=>{
            return (0, $7b02d682eb115277$exports.jsx)("option", {
                value: theme,
                children: t(`theme_${theme}`)
            }, theme);
        });
    }, []);
    const onEditEvent = (0, $acw62.useCallback)((_event)=>{
        onEdited();
    }, [
        onEdited
    ]);
    const save = (0, $acw62.useCallback)(async (_data, _values)=>{
        resetEdited();
    }, []);
    const selectLanguage = (0, $acw62.useCallback)((event)=>{
        const lang = event.target.value;
        setLanguage(lang);
        app.setLanguage(lang);
        onEditEvent(event);
    }, []);
    const selectTheme = (0, $acw62.useCallback)((event)=>{
        // Prevent theme change in cloud session
        if (isCloudSession) return;
        const theme = event.target.value;
        setTheme(theme);
        app.setTheme(theme);
        onEditEvent(event);
    }, [
        isCloudSession
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "UserSettingsView",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
            className: "block_field_small_16",
            children: (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                changed: edited,
                editable: true,
                editableFields: [
                    "language",
                    "theme"
                ],
                onSave: save,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("language"),
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: (0, $7b02d682eb115277$exports.jsx)("select", {
                                    className: "select-setting",
                                    name: `language`,
                                    defaultValue: app.language,
                                    onChange: selectLanguage,
                                    children: languageOptions()
                                })
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        className: "block-row-last",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            label: t("theme"),
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$cdb648f0ec854d27), {
                                children: (0, $7b02d682eb115277$exports.jsx)("select", {
                                    className: "select-setting",
                                    name: `theme`,
                                    defaultValue: isCloudSession ? "cloud" : app.theme,
                                    onChange: selectTheme,
                                    disabled: isCloudSession,
                                    children: isCloudSession ? (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "cloud",
                                        children: t("theme_cloud")
                                    }) : themeOptions()
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");











// Copy key per failure reason. A reason without a key would render nothing, so the
// lookup is total over the enum -- the type checker enforces that, which is what keeps
// "the form appeared with no explanation" from coming back (#1388).
const $7285c3e203ae0d97$var$errorKeys = {
    [(0, $9afa59e734ffa505$export$aff75a1270347761).timeout]: "connect_logbook_timeout",
    [(0, $9afa59e734ffa505$export$aff75a1270347761).notDiscovered]: "connect_logbook_not_discovered",
    [(0, $9afa59e734ffa505$export$aff75a1270347761).ambiguous]: "connect_logbook_ambiguous",
    [(0, $9afa59e734ffa505$export$aff75a1270347761).unresolved]: "connect_logbook_unresolved",
    [(0, $9afa59e734ffa505$export$aff75a1270347761).unreachable]: "connect_logbook_unreachable",
    [(0, $9afa59e734ffa505$export$aff75a1270347761).refused]: "connect_logbook_refused",
    [(0, $9afa59e734ffa505$export$aff75a1270347761).notClaimed]: "connect_logbook_not_claimed",
    [(0, $9afa59e734ffa505$export$aff75a1270347761).notAccessible]: "connect_logbook_not_accessible",
    [(0, $9afa59e734ffa505$export$aff75a1270347761).addressInvalid]: "connect_logbook_address_invalid",
    [(0, $9afa59e734ffa505$export$aff75a1270347761).ownDevice]: "connect_logbook_own_device",
    [(0, $9afa59e734ffa505$export$aff75a1270347761).failed]: "connect_logbook_failed"
};
function $7285c3e203ae0d97$export$51354b42b1ef4221({ shipId: shipId, shipName: shipName, nearby: nearby, onCancel: onCancel, onCloseGuard: onCloseGuard, footer: footer, timeoutMs: timeoutMs, handoffTimeoutMs: handoffTimeoutMs = (0, $b5c1808b3220ae33$export$89fd5c26bb5c09a8), handoff: handoff }) {
    var _a;
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("AppOverlayContentView");
    const [state, setState] = (0, $acw62.useState)({
        phase: (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).connecting
    });
    const closeRequest = (0, $acw62.useRef)(undefined);
    // The workflow outlives individual renders, so keep one instance per mounted dialog.
    const connect = (0, $acw62.useMemo)(()=>(0, $b5c1808b3220ae33$export$6b1c01c2c473186f)({
            shipId: shipId,
            resolve: async (id)=>{
                try {
                    const response = await (0, $a359a1de1c9c067b$export$6fdd7e23becf9b95).resolveLocal(app.apiClient, id);
                    return {
                        address: response === null || response === void 0 ? void 0 : response.address,
                        reason: response === null || response === void 0 ? void 0 : response.reason
                    };
                } catch (error) {
                    // A resolve that fails as a REQUEST tells us nothing about the network -- the
                    // route reports a real failure to resolve in its `reason`, not by throwing. The
                    // connect attempt below still reports its own outcome.
                    (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("companion resolve failed", id, error);
                    return undefined;
                }
            },
            connectLocal: (id, address, attempt)=>(0, $a359a1de1c9c067b$export$6fdd7e23becf9b95).connectLocal(app.apiClient, id, address, attempt),
            cancelLocal: (id, attempt)=>(0, $a359a1de1c9c067b$export$6fdd7e23becf9b95).cancelLocal(app.apiClient, id, attempt),
            prepareHandoff: async (id)=>(await (0, $a359a1de1c9c067b$export$6fdd7e23becf9b95).prepareHandoff(app.apiClient, id)).url,
            onSuccess: async (id, destination)=>{
                // The destination's LoginView selects the ship after redeeming the handoff.
                // Until then this origin still owns an account session, not an open logbook.
                if (handoff) handoff(id);
                else {
                    if (!destination) throw new Error("Companion preparation returned no destination");
                    (0, $b57fb2219af67c07$export$1fb4852a55678982).beginCompanion(id);
                    window.location.assign(destination);
                }
            },
            onState: setState,
            timeoutMs: timeoutMs,
            handoffTimeoutMs: handoffTimeoutMs
        }), [
        shipId,
        timeoutMs,
        handoffTimeoutMs,
        handoff
    ]);
    // The reason the dialog fell back, as a sentence. Every reason resolves to copy that
    // says what happened AND what to do about it -- the ship name and the address the
    // attempt used are woven in where they help the user act on it.
    const errorMessage = (0, $acw62.useMemo)(()=>{
        if (!state.error) return undefined;
        return t($7285c3e203ae0d97$var$errorKeys[state.error], {
            name: shipName,
            address: state.address || ""
        });
    }, [
        state.error,
        state.address,
        shipName,
        t
    ]);
    // Start once per dialog. `nearby` is captured at open time on purpose: discovery is
    // volatile, and the flow must not change shape underneath the user mid-attempt.
    (0, $acw62.useEffect)(()=>{
        connect.start({
            nearby: nearby
        }).catch((error)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).error("companion connect failed", error));
        return ()=>{
            connect.dispose().catch((error)=>(0, $ea493e883ca706d4$export$af88d00dbe7f521).error("companion cancellation failed", error));
        };
    }, [
        connect
    ]);
    (0, $acw62.useEffect)(()=>{
        if (state.phase !== (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).success) return;
        const timer = setTimeout(()=>{
            setState((previous)=>({
                    phase: (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).manual,
                    address: previous.address,
                    error: (0, $9afa59e734ffa505$export$aff75a1270347761).unreachable
                }));
        }, handoffTimeoutMs);
        return ()=>clearTimeout(timer);
    }, [
        state.phase,
        handoffTimeoutMs
    ]);
    const prepareClose = (0, $acw62.useCallback)(()=>{
        if (closeRequest.current) return closeRequest.current;
        const request = (async ()=>{
            try {
                await connect.cancel();
                (0, $b57fb2219af67c07$export$1fb4852a55678982).clearCompanion(shipId);
                return true;
            } catch (error) {
                (0, $ea493e883ca706d4$export$af88d00dbe7f521).error("companion cancellation failed", error);
                setState({
                    phase: (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).manual,
                    error: (0, $9afa59e734ffa505$export$aff75a1270347761).failed
                });
                return false;
            }
        })();
        closeRequest.current = request;
        request.finally(()=>{
            if (closeRequest.current === request) closeRequest.current = undefined;
        });
        return request;
    }, [
        connect,
        shipId
    ]);
    (0, $acw62.useEffect)(()=>{
        onCloseGuard === null || onCloseGuard === void 0 || onCloseGuard(prepareClose);
        return ()=>onCloseGuard === null || onCloseGuard === void 0 ? void 0 : onCloseGuard(undefined);
    }, [
        onCloseGuard,
        prepareClose
    ]);
    const cancel = (0, $acw62.useCallback)(async ()=>{
        if (await prepareClose()) onCancel();
    }, [
        prepareClose,
        onCancel
    ]);
    // This device's own build number, reported by its local `/api/status`. Shown so a
    // user (or support) can say which version is actually installed -- the primary's
    // required version is deliberately not fetched, since that would mean another round
    // trip on a path that has just failed.
    const version = (_a = app.status) === null || _a === void 0 ? void 0 : _a.version;
    // Where this platform actually gets its updates. A "download the latest version"
    // link is wrong on iOS and Android, where sideloading isn't possible and the store
    // is the only route; a store instruction is equally useless on desktop, which has
    // no store entry at all.
    const updateAdvice = (0, $acw62.useMemo)(()=>{
        switch((0, $fe1fa5963413bede$export$2dffd0b5373a4389).of(app)){
            case "ios":
                return t("connect_logbook_outdated_appstore");
            case "android":
                return t("connect_logbook_outdated_playstore");
            default:
                return (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: `https://logbook.yachts/site/${app.language}/download`,
                    target: "_blank",
                    rel: "noreferrer",
                    children: t("connect_logbook_outdated_download")
                });
        }
    }, [
        app,
        app.language,
        t
    ]);
    const submit = (0, $acw62.useCallback)(async (_data, values)=>{
        await connect.submit(values.address);
    }, [
        connect
    ]);
    if (state.phase == (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).connecting || state.phase == (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).success) return (0, $7b02d682eb115277$exports.jsx)((0, $807e05067c94e8fb$export$746af75b6b2a4bae), {
        className: "Overlay-body message-text-bigger Overlay-body-padding",
        readMoreLabel: t("read_more"),
        deps: [
            state.phase,
            state.error
        ],
        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "companion-connect-progress",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "Loading",
                            children: t("connect_logbook_connecting", {
                                name: shipName
                            })
                        })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    actions: true,
                    className: "block-row-one-row",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button",
                            onClick: cancel,
                            children: t("cancel")
                        })
                    })
                })
            ]
        })
    });
    // The primary refused this device for running an older build. Deliberately NOT
    // the manual address form: no address changes the outcome, so offering one would
    // invite the user to keep retrying something that cannot work. Show the only
    // remedy there is -- update the app -- routed to wherever this platform actually
    // gets its updates.
    if (state.phase == (0, $9afa59e734ffa505$export$5aa6b8c8000bf93c).outdated) return (0, $7b02d682eb115277$exports.jsxs)((0, $807e05067c94e8fb$export$746af75b6b2a4bae), {
        className: "Overlay-body message-text-bigger Overlay-body-padding",
        readMoreLabel: t("read_more"),
        deps: [
            state.phase,
            state.error
        ],
        children: [
            (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("h4", {
                                children: t("connect_logbook_outdated_title")
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: t("connect_logbook_outdated", {
                                name: shipName
                            })
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: updateAdvice
                        })
                    }),
                    version && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            className: "companion-connect-version",
                            children: t("connect_logbook_outdated_version", {
                                version: version
                            })
                        })
                    }),
                    footer == null && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                        actions: true,
                        className: "block-row-one-row",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button",
                                onClick: cancel,
                                children: t("cancel")
                            })
                        })
                    })
                ]
            }),
            typeof footer === "function" ? footer(cancel) : footer
        ]
    });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $807e05067c94e8fb$export$746af75b6b2a4bae), {
        className: "Overlay-body message-text-bigger Overlay-body-padding",
        readMoreLabel: t("read_more"),
        deps: [
            state.phase,
            state.error
        ],
        children: [
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                        className: "no-distance",
                        message: (m)=>m.noteText.shipOpen,
                        replace: {
                            name: shipName
                        }
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: (0, $7b02d682eb115277$exports.jsxs)((0, $a6db0417d7b66a9b$export$b048568c3d3852d5), {
                    manualSave: true,
                    hideButton: true,
                    onSave: submit,
                    editable: true,
                    editableFields: [
                        "address"
                    ],
                    children: [
                        errorMessage && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                className: "error-message",
                                children: errorMessage
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                            className: "block-row-last",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    label: t("connection_host"),
                                    className: "block_field_small_20",
                                    children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                        name: "address",
                                        required: true,
                                        defaultValue: state.address || ""
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                        className: "button default",
                                        type: "submit",
                                        disabled: state.submitting === true,
                                        children: state.submitting === true ? t("connect_logbook_connecting_short") : t("connect_logbook")
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                    className: "block-row-top20 block-row-0",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                        message: (m)=>m.noteText.shipOpen2,
                        replace: {
                            name: shipName
                        }
                    })
                })
            }),
            typeof footer === "function" ? footer(cancel) : footer
        ]
    });
}



const $8e32ab04a98d0dca$export$ffa55fb4b8d60949 = {
    deleteImport (api, shipId) {
        return new (0, $0e416c62c0063d32$export$eb8488c4912a1dad)(api).ships.deleteImport({
            params: {
                shipId: shipId
            }
        }).call();
    },
    deleteAccount (api) {
        return new (0, $dc589cd4dc573fd3$export$eb6287b13c4e068b)(api).account.delete({
            params: {}
        }).call();
    },
    syncFailed (status) {
        return status === (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).failed || status === (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).disconnected || status === (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).initialSyncFailed || // A dead cloud session is a sync failure like any other as far as every caller of
        // this helper is concerned -- nothing reaches the cloud until it is fixed (#1449).
        status === (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).sessionExpired;
    },
    // Re-login from the expired-session prompt. Deliberately the same call the login
    // route makes, so a session established here is indistinguishable from a normal one;
    // the app then reclaims this device's ship by its `clientToken` and restarts sync.
    //
    // Returns whether it worked WITHOUT touching anything on a failure: `setSession` runs
    // only for an authorized response, so a refused attempt leaves the existing session,
    // ship and claim exactly as they were (#1449).
    async sessionLogin (app, email, password) {
        const response = await (0, $e3e377da0685a737$export$3b437c26facf161d).login(app.apiClient, {
            email: email,
            password: password,
            client: app.cloudSession() ? "cloud" : undefined
        });
        if (response && response.session && response.session.authorized && response.session.id) {
            app.setSession(response.session, response.type, response.account, response.user, response.features, response.accountUserLevel);
            return true;
        }
        return false;
    }
};
var $8e32ab04a98d0dca$export$92ff08af3ab4963b;
(function(AppOverlayContent) {
    AppOverlayContent["none"] = "none";
    AppOverlayContent["about"] = "about";
    AppOverlayContent["changeLog"] = "changeLog";
    AppOverlayContent["closeShip"] = "closeShip";
    AppOverlayContent["connectLogbook"] = "connectLogbook";
    AppOverlayContent["importShip"] = "importShip";
    AppOverlayContent["logout"] = "logout";
    AppOverlayContent["removeAccount"] = "removeAccount";
    AppOverlayContent["selectShip"] = "selectShip";
    AppOverlayContent["selectShipFailed"] = "selectShipFailed";
    AppOverlayContent["sessionExpired"] = "sessionExpired";
    AppOverlayContent["shipListOptions"] = "shipListOptions";
    AppOverlayContent["shipNotClosed"] = "shipNotClosed";
    AppOverlayContent["shipOpen"] = "shipOpen";
    AppOverlayContent["userSettings"] = "userSettings";
})($8e32ab04a98d0dca$export$92ff08af3ab4963b || ($8e32ab04a98d0dca$export$92ff08af3ab4963b = {}));
function $8e32ab04a98d0dca$export$1f4c95990bbc9d13(_) {
    const app = (0, $b1a950ec5f3fb9ad$export$56752c5ff04def75)();
    const t = app.getT("AppOverlayContentView");
    const { appOverlay: appOverlay, appOverlayOptions: appOverlayOptions, connected: connected, deselectShip: deselectShip, forceCloseShip: forceCloseShip, navigateApp: navigateApp, resetShip: resetShip, resetAppOverlay: resetAppOverlay, setAppOverlay: setAppOverlay, ships: ships, shipClosing: shipClosing, shipCloseFailed: shipCloseFailed, shipCloseFailedStatus: shipCloseFailedStatus } = (0, $d96ebf18a3a82ea8$export$2d582a47b5ebbd0b)();
    const overlayShip = (0, $acw62.useMemo)(()=>{
        return ships === null || ships === void 0 ? void 0 : ships.find((s)=>s.id === appOverlayOptions.shipId);
    }, [
        appOverlayOptions,
        ships
    ]);
    const [importResetState, setImportResetState] = (0, $acw62.useState)("idle");
    const [forceCloseConfirm, setForceCloseConfirm] = (0, $acw62.useState)(false);
    const companionCloseGuard = (0, $acw62.useRef)(undefined);
    const overlayGeneration = (0, $acw62.useRef)(0);
    const closingGeneration = (0, $acw62.useRef)(undefined);
    const registerCompanionCloseGuard = (0, $acw62.useCallback)((guard)=>{
        companionCloseGuard.current = guard;
    }, []);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            overlayGeneration.current += 1;
        };
    }, [
        appOverlay,
        appOverlayOptions.shipId
    ]);
    const withCompanionCleanup = (0, $acw62.useCallback)(async (action)=>{
        const guard = appOverlay === $8e32ab04a98d0dca$export$92ff08af3ab4963b.shipOpen ? companionCloseGuard.current : undefined;
        if (!guard) {
            action();
            return;
        }
        const generation = overlayGeneration.current;
        if (closingGeneration.current === generation) return;
        closingGeneration.current = generation;
        try {
            if (await guard() && overlayGeneration.current === generation) action();
        } finally{
            if (closingGeneration.current === generation) closingGeneration.current = undefined;
        }
    }, [
        appOverlay
    ]);
    (0, $acw62.useEffect)(()=>{
        setImportResetState("idle");
        setForceCloseConfirm(false);
    }, [
        appOverlay
    ]);
    const resetImport = (0, $acw62.useCallback)(async ()=>{
        if (!overlayShip) return;
        setImportResetState("resetting");
        await $8e32ab04a98d0dca$export$ffa55fb4b8d60949.deleteImport(app.apiClient, overlayShip.id);
        resetAppOverlay();
    }, [
        overlayShip,
        resetAppOverlay
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $74bcfc43c0f9ac90$export$89acdd91182d6c5d), {
        className: "AppOverlay",
        overlay: appOverlay,
        overlays: {
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.none]: {
                render: ()=>null
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.about]: {
                close: true,
                render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $b2c8da7ad26b0f2a$export$1eb1323c9a3751ef), {})
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.changeLog]: {
                close: true,
                render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $e3ce5d157f267f1e$export$d739bee7a05220bf), {
                        showExternal: true,
                        onCloseExternal: resetAppOverlay
                    })
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.closeShip]: {
                close: true,
                title: t("ship_close_confirm_title"),
                style: "warning",
                className: "overlay-max-height",
                render: ()=>{
                    var _a, _b;
                    const ship = overlayShip || (ships === null || ships === void 0 ? void 0 : ships.find((s)=>s.id === app.shipId));
                    const noInternet = !navigator.onLine;
                    if (forceCloseConfirm) return (0, $7b02d682eb115277$exports.jsx)((0, $f60be5928c5dcb14$export$59940996e5afad48), {
                        shipName: ship === null || ship === void 0 ? void 0 : ship.name,
                        shipClosing: shipClosing,
                        onCancel: ()=>setForceCloseConfirm(false),
                        onForceCloseShip: forceCloseShip,
                        t: t
                    });
                    return (0, $7b02d682eb115277$exports.jsx)((0, $f60be5928c5dcb14$export$3c56b4195ba80816), {
                        shipName: ship === null || ship === void 0 ? void 0 : ship.name,
                        noInternet: noInternet,
                        syncFailed: $8e32ab04a98d0dca$export$ffa55fb4b8d60949.syncFailed((_b = (_a = app.status) === null || _a === void 0 ? void 0 : _a.sync) === null || _b === void 0 ? void 0 : _b.status),
                        shipClosing: shipClosing,
                        shipCloseFailed: shipCloseFailed,
                        shipCloseFailedStatus: shipCloseFailedStatus,
                        onCancel: resetAppOverlay,
                        onCloseShip: resetShip,
                        onForceCloseShip: ()=>setForceCloseConfirm(true),
                        t: t
                    });
                }
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.importShip]: {
                close: true,
                title: t("import_ship_title"),
                className: "overlay-max-height",
                render: ()=>{
                    return (0, $7b02d682eb115277$exports.jsx)((0, $807e05067c94e8fb$export$746af75b6b2a4bae), {
                        className: "Overlay-body Overlay-body-padding message-text-bigger",
                        readMoreLabel: t("read_more"),
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                    message: (m)=>m.importShip.text
                                })
                            })
                        })
                    });
                }
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.logout]: {
                close: true,
                title: t("logout_confirm_title"),
                style: "warning",
                className: "overlay-max-height",
                render: ()=>{
                    const ship = ships === null || ships === void 0 ? void 0 : ships.find((s)=>s.id === app.shipId);
                    const noInternet = !navigator.onLine;
                    const isPrimaryShipOpen = app.primarySession() && app.shipId;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
                    let message = (m)=>m.logout.logoutWithInternet;
                    if (noInternet) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
                    message = (m)=>m.logout.logoutWithoutInternet;
                    return (0, $7b02d682eb115277$exports.jsx)((0, $807e05067c94e8fb$export$746af75b6b2a4bae), {
                        className: "Overlay-body message-text-bigger Overlay-body-padding",
                        readMoreLabel: t("read_more"),
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                        html: true,
                                        message: message,
                                        replace: {
                                            name: (ship === null || ship === void 0 ? void 0 : ship.name) || ""
                                        }
                                    })
                                }),
                                isPrimaryShipOpen && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                            children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                                html: true,
                                                message: (m)=>m.shipClose.keepOpen
                                            })
                                        })
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    actions: true,
                                    className: "block-row-one-row",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button",
                                                onClick: resetAppOverlay,
                                                children: t("logout_confirm_cancel")
                                            })
                                        }),
                                        !noInternet && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button default",
                                                onClick: async ()=>{
                                                    resetAppOverlay();
                                                    await app.logout();
                                                },
                                                children: t("logout_confirm")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    });
                }
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.removeAccount]: {
                close: true,
                title: t("remove_account_confirm_title"),
                render: ()=>{
                    var _a, _b;
                    return (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "Overlay-body",
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                        message: (m)=>m.subscription.removeAccount,
                                        replace: {
                                            account: ((_a = app.account) === null || _a === void 0 ? void 0 : _a.name) || "Untitled",
                                            user: ((_b = app.user) === null || _b === void 0 ? void 0 : _b.name) || "Untitled"
                                        }
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    actions: true,
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button",
                                                onClick: resetAppOverlay,
                                                children: t("remove_account_cancel")
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button default",
                                                onClick: async ()=>{
                                                    const response = await $8e32ab04a98d0dca$export$ffa55fb4b8d60949.deleteAccount(app.apiClient);
                                                    if (response && response.success) {
                                                        resetAppOverlay();
                                                        await app.logout(false);
                                                        window.location.reload();
                                                    }
                                                },
                                                children: t("remove_account_confirm")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    });
                }
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.selectShip]: {
                render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $79fc23eacbb78d2d$export$8a3b235cd6c6eb92), {
                        status: (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).selectShip
                    })
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.selectShipFailed]: {
                render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $79fc23eacbb78d2d$export$8a3b235cd6c6eb92), {
                        status: (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).selectShipFailed,
                        error: appOverlayOptions.selectShipError
                    })
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.sessionExpired]: {
                // `close: true` on purpose -- the prompt is dismissable and destroys nothing, so
                // the user can carry on logging their trip locally while the cloud is out of
                // reach (#1449). "alarm" for the same red treatment the connection error gets.
                close: true,
                title: t("session_expired_title"),
                style: "alarm",
                className: "overlay-max-height",
                render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $a851516b5cec6212$export$cf6dbfc7ff15fd18), {
                        onDismiss: resetAppOverlay,
                        onLogin: (email, password)=>$8e32ab04a98d0dca$export$ffa55fb4b8d60949.sessionLogin(app, email, password),
                        t: t
                    })
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.shipListOptions]: {
                close: true,
                title: t("options_ship", {
                    name: (overlayShip === null || overlayShip === void 0 ? void 0 : overlayShip.name) || ""
                }),
                className: "overlay-max-height",
                render: ()=>{
                    const shipData = overlayShip ? (0, $3d4dfb4b3a9d38e4$export$7930c61d9b464618).parse(overlayShip).dataParsed : undefined;
                    return (0, $7b02d682eb115277$exports.jsx)((0, $807e05067c94e8fb$export$746af75b6b2a4bae), {
                        className: "Overlay-body Overlay-body-padding message-text-bigger",
                        readMoreLabel: t("read_more"),
                        deps: [
                            importResetState
                        ],
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "block-row-0",
                                        children: t("options_ship_title")
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    children: [
                                        t("options_update"),
                                        " ",
                                        (overlayShip === null || overlayShip === void 0 ? void 0 : overlayShip.syncedAt) ? new Date(overlayShip.syncedAt).toLocaleString() : "-"
                                    ]
                                }),
                                app.cloudSession() && overlayShip && overlayShip.clientToken && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "block-row-0",
                                                children: t("disconnect_ship_title")
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                            children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                                message: (m)=>connected ? m.shipInfo.disconnect : m.connection.interrupted,
                                                replace: {
                                                    name: (overlayShip === null || overlayShip === void 0 ? void 0 : overlayShip.name) || ""
                                                }
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                            actions: true,
                                            className: "block-row-one-row",
                                            children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "button ship-deselect-button default",
                                                    onClick: ()=>deselectShip(overlayShip.id),
                                                    disabled: !overlayShip,
                                                    children: t("disconnect_ship")
                                                })
                                            })
                                        })
                                    ]
                                }),
                                app.cloudSession() && overlayShip && overlayShip.clientToken == undefined && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: shipData && shipData.importStatus && shipData.importStatus != (0, $ef756702f3923ebb$export$bd5fd2a78082695e).failed ? (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: shipData.importStatus == (0, $ef756702f3923ebb$export$bd5fd2a78082695e).complete ? (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: importResetState === "confirm" ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                        children: (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                            className: "text-centered text-warning",
                                                            children: t("import_reset_confirm_title")
                                                        })
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                        className: "message-text-bigger",
                                                        children: t("import_reset_confirm_text")
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                        actions: true,
                                                        className: "block-row-one-row",
                                                        children: [
                                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "button",
                                                                    onClick: ()=>setImportResetState("idle"),
                                                                    children: t("import_reset_confirm_no")
                                                                })
                                                            }),
                                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "button default",
                                                                    onClick: resetImport,
                                                                    children: t("import_reset_confirm_yes")
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : importResetState === "resetting" ? (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                    children: (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        className: "text-centered text-warning",
                                                        children: t("import_resetting")
                                                    })
                                                })
                                            }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                        children: (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                            className: "text-centered text-success",
                                                            children: t("import_status_complete", {
                                                                date: app.format("date", shipData.importCompletedAt)
                                                            })
                                                        })
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                        className: "row-right block-row-one-row",
                                                        children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "button default",
                                                            onClick: ()=>setImportResetState("confirm"),
                                                            children: t("import_reset")
                                                        })
                                                    })
                                                ]
                                            })
                                        }) : (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "text-centered text-warning",
                                                children: t("import_status_in_progress", {
                                                    time: app.format("timeAgoDate", shipData.importStartedAt)
                                                })
                                            })
                                        })
                                    }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                children: (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    className: "block-row-0",
                                                    children: t("import_trips")
                                                })
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                className: "message-text-bigger ",
                                                children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                                    message: (m)=>m.importTrips.text,
                                                    replace: {
                                                        name: overlayShip.name
                                                    }
                                                })
                                            }),
                                            (shipData === null || shipData === void 0 ? void 0 : shipData.importStatus) == (0, $ef756702f3923ebb$export$bd5fd2a78082695e).failed && (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                className: "text-error",
                                                children: (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    className: "text-centered",
                                                    children: t("import_status_failed")
                                                })
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                                className: "row-right block-row-one-row",
                                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "button default",
                                                    onClick: ()=>{
                                                        navigateApp((0, $16a667a1dff2bda2$export$37d3279522fbf5e2).ship, {
                                                            shipId: overlayShip.id,
                                                            shipRoute: "import"
                                                        });
                                                        resetAppOverlay();
                                                    },
                                                    children: t("import_trips")
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    });
                }
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.shipOpen]: {
                close: true,
                title: t("ship_open_title", {
                    name: (overlayShip === null || overlayShip === void 0 ? void 0 : overlayShip.name) || ""
                }),
                style: "warning",
                className: "overlay-max-height",
                render: ()=>{
                    // One surface for both companion-connect routes: a spinner while the
                    // automatic (Bonjour) attempt runs, falling back to this same dialog's
                    // manual address form -- with the reason it fell back -- on failure or
                    // timeout. Previously a LAN-discovered ship never reached this dialog at
                    // all and its connect failed silently (#1279).
                    return (0, $7b02d682eb115277$exports.jsx)((0, $7285c3e203ae0d97$export$51354b42b1ef4221), {
                        shipId: (overlayShip === null || overlayShip === void 0 ? void 0 : overlayShip.id) || 0,
                        shipName: (overlayShip === null || overlayShip === void 0 ? void 0 : overlayShip.name) || "",
                        nearby: appOverlayOptions.nearby === true,
                        onCancel: resetAppOverlay,
                        onCloseGuard: registerCompanionCloseGuard,
                        footer: (cancel)=>{
                            var _a;
                            const shipId = overlayShip === null || overlayShip === void 0 ? void 0 : overlayShip.id;
                            const pendingCompanion = shipId !== undefined && !app.cloudSession() && !app.localSession() && ((_a = app.session) === null || _a === void 0 ? void 0 : _a.shipId) !== shipId && (0, $2b75519151ca9024$export$8bf6241f4c41c4e0)("logbook-companion") === shipId;
                            return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                    actions: true,
                                    className: "block-row-one-row",
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button",
                                                onClick: cancel,
                                                children: t("cancel")
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                            children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "button default",
                                                onClick: ()=>{
                                                    if (pendingCompanion) cancel();
                                                    else withCompanionCleanup(()=>setAppOverlay($8e32ab04a98d0dca$export$92ff08af3ab4963b.shipNotClosed, {
                                                            shipId: shipId
                                                        }));
                                                },
                                                children: t("disconnect_logbook")
                                            })
                                        })
                                    ]
                                })
                            });
                        }
                    });
                }
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.shipNotClosed]: {
                close: true,
                title: t("ship_not_closed_title", {
                    name: (overlayShip === null || overlayShip === void 0 ? void 0 : overlayShip.name) || ""
                }),
                style: "alarm",
                className: "overlay-max-height",
                render: ()=>{
                    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "Overlay-body message-text-bigger",
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                    children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        className: "message-text-bigger",
                                        children: (0, $7b02d682eb115277$exports.jsx)((0, $09fff092c765f062$export$4c288ea8cff73213), {
                                            message: (m)=>m.noteText.shipNotClosed,
                                            replace: {
                                                name: (overlayShip === null || overlayShip === void 0 ? void 0 : overlayShip.name) || ""
                                            }
                                        })
                                    })
                                })
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "Overlay-footer",
                                children: (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$d96a8827a60d6b69), {
                                    children: (0, $7b02d682eb115277$exports.jsxs)((0, $667899fc5cd22b1e$export$87a9101957b76b24), {
                                        actions: true,
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "button",
                                                    onClick: resetAppOverlay,
                                                    children: t("cancel")
                                                })
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$e49d898ce5e9f43c), {
                                                children: (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "button defaults",
                                                    onClick: async ()=>{
                                                        if (await app.openServer("account")) resetAppOverlay();
                                                    },
                                                    children: t("ship_view_ships_cloud")
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    });
                }
            },
            [$8e32ab04a98d0dca$export$92ff08af3ab4963b.userSettings]: {
                close: true,
                title: t("user_settings"),
                className: "overlay-narrow",
                render: ()=>{
                    return (0, $7b02d682eb115277$exports.jsx)((0, $667899fc5cd22b1e$export$a4fff7f2f85c4c81), {
                        className: "Overlay-body",
                        children: (0, $7b02d682eb115277$exports.jsx)((0, $d3716a969dc576ba$export$cebefbf4af82e50c), {})
                    });
                }
            }
        },
        resetOverlay: ()=>{
            withCompanionCleanup(resetAppOverlay);
        }
    });
}







class $b7197004aca2ed1c$var$MockClient extends (0, $62b5d19f2b3ee711$export$1f2bb630327ac4b6) {
    constructor(data){
        super();
        this.data = data;
    }
    async call(method, path, body) {
        const routed = $b7197004aca2ed1c$export$e3ee52f50f60f8c1.route(method, path, this.data);
        if (routed !== undefined) return routed;
        // Default: call parent implementation
        return super.call(method, path, body);
    }
    // Replay any seeded provisional logs (`TestData.provisionalLogs`) to each new
    // `Log/Provisional` subscriber. Provisional (in-progress, uncommitted) auto-logs are
    // deliberately NOT part of the normalized data model — a view only ever learns about
    // them over this subscription (see `Views/Day/Events.ts`) — so replaying here is what
    // lets a catalog/demo fixture seed one purely from its `TestData`, exercising the real
    // subscribe -> `AppData.updateProvisional` -> `mergeProvisional` path instead of
    // needing a dedicated view `init*` prop.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- matches the base class's erased overload signature
    subscribe(type, callback) {
        var _a, _b;
        const id = super.subscribe(type, callback);
        if (type === (0, $1bedde6805bf6e79$export$f55210826850c514).provisionalLog.type) for (const log of (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.provisionalLogs) !== null && _b !== void 0 ? _b : [])callback(log, type, "seed");
        return id;
    }
}
const $b7197004aca2ed1c$export$e3ee52f50f60f8c1 = {
    route (method, path, data) {
        var _a, _b, _c, _d, _e, _f, _g;
        // Handle trip/cruise creation check and creation
        if ((method === "GET" || method === "POST") && (path === "ship/trip" || path === "ship/cruise")) {
            const type = path.split("/")[1];
            if (method === "GET") // Check if creation is allowed
            return {
                status: "allowed"
            };
            else // Create trip or cruise - for demo, just return success
            if (type === "trip") {
                const newTrip = (_a = data === null || data === void 0 ? void 0 : data.trips) === null || _a === void 0 ? void 0 : _a[0];
                return {
                    status: "allowed",
                    trip: newTrip
                };
            } else {
                const newCruise = (_b = data === null || data === void 0 ? void 0 : data.cruises) === null || _b === void 0 ? void 0 : _b[0];
                return {
                    status: "allowed",
                    cruise: newCruise
                };
            }
        }
        // Handle current day request for FocusView
        if (method === "GET" && path === "ship/current/day") {
            const cruises = (data === null || data === void 0 ? void 0 : data.cruises) || [];
            const trips = (data === null || data === void 0 ? void 0 : data.trips) || [];
            const days = (data === null || data === void 0 ? void 0 : data.days) || [];
            const logs = (data === null || data === void 0 ? void 0 : data.logs) || [];
            const statuses = (data === null || data === void 0 ? void 0 : data.statuses) || [];
            const notes = (data === null || data === void 0 ? void 0 : data.notes) || [];
            const attachments = (data === null || data === void 0 ? void 0 : data.attachments) || [];
            // Get the latest cruise
            const latestCruise = cruises.length > 0 ? cruises[cruises.length - 1] : undefined;
            // Get the latest trip
            const latestTrip = trips.length > 0 ? trips[trips.length - 1] : undefined;
            // Get the latest day
            const latestDay = days.length > 0 ? days[days.length - 1] : undefined;
            const currentDay = (latestDay === null || latestDay === void 0 ? void 0 : latestDay.day) || 0;
            const firstDay = days.length > 0 ? days[0].day : 0;
            // Create a fake currentLog for demo if we have NMEA data
            // This represents the live/pending log entry with current sensor readings
            let currentLog = undefined;
            if (latestDay && latestTrip) {
                const { time: time, timeUtc: timeUtc, timezone: timezone } = (0, $0ffce56d54de6ef8$export$54a89be6af0881dc)((0, $0ffce56d54de6ef8$export$ed6db8ac961f262d));
                currentLog = {
                    // id 0 marks a pending/unsaved log — the live current log always
                    // carries a data payload (default "{}").
                    id: 0,
                    cruiseId: (latestCruise === null || latestCruise === void 0 ? void 0 : latestCruise.id) || 1,
                    tripId: latestTrip.id,
                    dayId: latestDay.id,
                    accountId: 1,
                    shipId: 1,
                    createdAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                    updatedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                    time: time,
                    timeUtc: timeUtc,
                    timezone: timezone,
                    data: "{}",
                    labels: [
                        "current"
                    ]
                };
            }
            return {
                cruises: {
                    cruises: latestCruise ? [
                        latestCruise
                    ] : [],
                    calculations: [],
                    notes: [],
                    attachments: []
                },
                trips: latestTrip ? {
                    trips: [
                        latestTrip
                    ],
                    calculations: [],
                    notes: [],
                    attachments: []
                } : undefined,
                days: {
                    days: days,
                    calculations: [],
                    notes: notes,
                    attachments: attachments
                },
                logs: {
                    logs: logs,
                    calculations: []
                },
                status: statuses,
                day: currentDay,
                firstDay: firstDay,
                currentLog: currentLog
            };
        }
        // Handle trip days requests that need notes and attachments
        if (method === "GET" && path.includes("/trips/") && path.includes("/days")) {
            const tripIdMatch = path.match(/\/trips\/(\d+)\/days/);
            if (tripIdMatch) {
                const tripId = parseInt(tripIdMatch[1]);
                const days = ((_c = data === null || data === void 0 ? void 0 : data.days) === null || _c === void 0 ? void 0 : _c.filter((d)=>d.tripId === tripId)) || [];
                const notes = ((_d = data === null || data === void 0 ? void 0 : data.notes) === null || _d === void 0 ? void 0 : _d.filter((n)=>n.tripId === tripId)) || [];
                const noteIds = notes.map((n)=>n.id);
                const attachments = ((_e = data === null || data === void 0 ? void 0 : data.attachments) === null || _e === void 0 ? void 0 : _e.filter((a)=>noteIds.includes(a.noteId || 0))) || [];
                return {
                    days: days,
                    notes: notes,
                    attachments: attachments
                };
            }
        }
        // Handle logs requests that need statuses
        if (method === "GET" && path.includes("/logs")) {
            const dayIdMatch = path.match(/\/days\/(\d+)\/logs/);
            if (dayIdMatch) {
                const dayId = parseInt(dayIdMatch[1]);
                const logs = ((_f = data === null || data === void 0 ? void 0 : data.logs) === null || _f === void 0 ? void 0 : _f.filter((l)=>l.dayId === dayId)) || [];
                const statuses = ((_g = data === null || data === void 0 ? void 0 : data.statuses) === null || _g === void 0 ? void 0 : _g.filter((s)=>s.dayId === dayId)) || [];
                return {
                    logs: logs,
                    statuses: statuses
                };
            }
        }
        // Handle track requests
        if (method === "GET" && path.includes("/track")) {
            const tracks = (data === null || data === void 0 ? void 0 : data.tracks) || [];
            return {
                tracks: tracks
            };
        }
        // Not mocked — signal fall-through to the real implementation.
        return undefined;
    }
};
function $b7197004aca2ed1c$export$cb6734f81234dd35(data, language, cloud = false) {
    var _a;
    const t = (text, replace)=>{
        return (0, $0258f51bf6f9f9d6$export$b6fc69901997e05).t(language, text, replace);
    };
    // For blank data (no cruises/trips started), don't set time so FocusView doesn't calculate a current day
    const hasData = data.cruises && data.cruises.length > 0 && data.cruises[0].startedAt;
    return {
        account: undefined,
        apiClient: (0, $be0017b4bd97ce4b$export$8744222f7aa763e1)("app"),
        appStyles: [],
        current: undefined,
        editable: true,
        session: data.session,
        sessionType: data.sessionType || (0, $a8c48887e141e972$export$9fd99c4c3c179cff).primary,
        shipId: (_a = data.ship) === null || _a === void 0 ? void 0 : _a.id,
        socket: new $b7197004aca2ed1c$var$MockClient(data),
        // Provide a mock status with nmea and sync for menu buttons
        status: {
            navigation: false,
            nmea: {
                connected: true,
                data: {},
                connectionStatus: (0, $2a692caa93051c23$export$e12d1a3b018307ad).connected,
                recordingStatus: (0, $ecb722ec4ee6c8d2$export$852477b5f0e5324c).stopped
            },
            server: false,
            sync: {
                enabled: true,
                status: (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).current
            },
            internet: (0, $2a692caa93051c23$export$c1d9595bd9dd489e).connected,
            time: hasData ? new Date().toISOString() : "",
            systemTimezone: 0,
            // Fixed rather than the real build number: catalog/demo output is golden-
            // snapshotted, so a value that changes every release would churn the goldens.
            version: "2026-01-01"
        },
        theme: cloud ? "cloud" : "dark",
        user: {
            id: 1,
            name: "DemoUser"
        },
        language: language,
        t: t,
        getT: (prefix)=>{
            return (text, replace)=>{
                return t([
                    prefix,
                    text
                ].join("_"), replace);
            };
        },
        format: (0, $14a8bda8b42de2c4$export$d9468344d3651243),
        updateData: (data, _object)=>data,
        dataWithCalculations: (data, calculations, notes, attachments, id)=>{
            if (calculations) data = data.map((o)=>{
                const calculated = calculations.find((e)=>e.id == o.id);
                o.calculated = calculated === null || calculated === void 0 ? void 0 : calculated.values;
                return o;
            });
            if (notes && id) data = data.map((o)=>{
                let dataNotes = notes.filter((n)=>{
                    const i = id(n);
                    return i && i == o.id;
                });
                if (attachments) dataNotes = dataNotes.map((n)=>{
                    n.attachments = attachments.filter((a)=>a.noteId == n.id);
                    return n;
                });
                o.notes = dataNotes;
                return o;
            });
            return data;
        },
        logout: (_deleteSession)=>(async function() {
                return;
            })(),
        setSession: (_session, _type, _account, _user, _features)=>{},
        reconcileSession: (_response)=>{},
        updateSession: (_account, _user)=>{},
        setShipId: (_shipId)=>(async function() {
                return;
            })(),
        forceCloseShip: (_shipId)=>(async function() {
                return;
            })(),
        setLanguage: (_lang)=>{},
        setTheme: (_t)=>{},
        resetStatus: ()=>(async function() {
                return;
            })(),
        updateStatus: ()=>(async function() {
                return {
                    navigation: false,
                    nmea: {
                        connected: true,
                        data: {},
                        connectionStatus: (0, $2a692caa93051c23$export$e12d1a3b018307ad).connected,
                        recordingStatus: (0, $ecb722ec4ee6c8d2$export$852477b5f0e5324c).stopped
                    },
                    server: false,
                    sync: {
                        enabled: true,
                        status: (0, $2a692caa93051c23$export$f38883ffc2a1d5cb).current
                    },
                    internet: (0, $2a692caa93051c23$export$c1d9595bd9dd489e).connected,
                    time: "",
                    systemTimezone: 0,
                    version: "2026-01-01"
                };
            })(),
        cloudSession: ()=>cloud,
        primarySession: ()=>!cloud,
        localSession: ()=>false,
        hasFeature: (feature)=>{
            return feature === "nmea" || feature === "sync" || feature === "beta" || feature === "usb";
        },
        updateCurrent: ()=>(async function() {
                return;
            })(),
        updateRoute: (_path, _replace)=>{},
        getRoute (_customRoot) {
            return {
                route: []
            };
        },
        openServer: (_path)=>(async function() {
                return true;
            })()
    };
}
function $b7197004aca2ed1c$export$9972faacf5ecf1d5(data) {
    return {
        connected: true,
        loadShips: (_force)=>(async function() {
                return;
            })(),
        navigateApp: (_name, _params, _replace)=>{
            return true;
        },
        route: {
            route: []
        },
        routeName: "mock",
        ships: data.ships,
        membership: data.shipUsers,
        subscriptionExpired: false,
        deselectShip: (_shipId)=>(async function() {
                return;
            })(),
        selectShip: (_shipId)=>(async function() {
                return;
            })(),
        resetShip: ()=>{},
        forceCloseShip: ()=>{},
        appOverlay: (0, $8e32ab04a98d0dca$export$92ff08af3ab4963b).none,
        appOverlayOptions: {},
        setAppOverlay: (_content, _options)=>{},
        resetAppOverlay: ()=>{},
        actingShipUser: undefined,
        setActingShipUser: (_user)=>{}
    };
}
function $b7197004aca2ed1c$export$717441a7de7fd996(data, focusActive) {
    return {
        navigateShip: (_name, _params, _replace)=>{
            return true;
        },
        shipCloudEditable: false,
        shipOverlay: (0, $a5124d8cc1d8d792$export$8db9b17208125660).none,
        shipOverlayOptions: {},
        resetShipOverlay: ()=>{},
        setShipOverlay: (_content, _options)=>{},
        printMode: (0, $872aa31e93f7b7c8$export$4ce6a4869f034b90).none,
        printRoot: undefined,
        setPrinting: (_mode, _object)=>{},
        shipRoute: {
            route: []
        },
        shipRouteName: "mock",
        focusActive: focusActive !== null && focusActive !== void 0 ? focusActive : false,
        shipUsers: data.shipUsers,
        actingShipUser: undefined,
        setActingShipUser: (_user)=>{}
    };
}













// Full-access `ApiUser` stub mirroring these shared harnesses' previous
// "always true" `requireUserLevel` behavior — fixtures render with the
// highest ship/account levels so every `.available()`-gated affordance
// remains visible by default.
const $5d8bb4f45e89a4a7$var$fullAccessApiUser = {
    shipLevel: (_shipId)=>(0, $dc7739d612f0c536$export$fe876bf720d558fa).primary,
    accountLevel: (_accountId)=>(0, $0b2bdaa8112b7188$export$103b1fca92a0adba).admin
};
function $5d8bb4f45e89a4a7$export$eb5cee0f7f4abf92({ children: children, cloud: cloud, data: data, language: language, hideMenus: hideMenus, hideShipMenu: hideShipMenu, overlay: overlay, updateAppState: updateAppState }) {
    const shipContext = {
        ship: data.ship,
        requireUserLevel: (_level)=>true,
        apiUser: $5d8bb4f45e89a4a7$var$fullAccessApiUser
    };
    const initAppState = (0, $b7197004aca2ed1c$export$cb6734f81234dd35)(data, language, cloud || false);
    const appState = updateAppState ? updateAppState(initAppState) : initAppState;
    // Offline, seed-only store so flag-on data-model variants have a
    // store to read in these mock harnesses (catalog/demo/print), which bypass the
    // app root's DataStoreProvider. Seeded from the same `TestData` the legacy variant
    // reads via its `init*` props, so both flag states render identical data. No
    // socket/apiClient -> nothing is fetched or subscribed; it's purely the seed.
    const dataStore = (0, $acw62.useMemo)(()=>{
        var _a, _b, _c, _d, _e, _f, _g;
        return new (0, $e188c40f4bf71e3c$export$47a0e4800a1fd7dc)({
            seed: {
                Trip: (_a = data.trips) !== null && _a !== void 0 ? _a : [],
                Day: (_b = data.days) !== null && _b !== void 0 ? _b : [],
                Log: (_c = data.logs) !== null && _c !== void 0 ? _c : [],
                Status: (_d = data.statuses) !== null && _d !== void 0 ? _d : [],
                Track: (_e = data.tracks) !== null && _e !== void 0 ? _e : [],
                Note: (_f = data.notes) !== null && _f !== void 0 ? _f : [],
                NoteAttachment: (_g = data.attachments) !== null && _g !== void 0 ? _g : []
            }
        });
    }, [
        data
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "LogbookContentView",
        children: (0, $7b02d682eb115277$exports.jsx)((0, $b1a950ec5f3fb9ad$export$122994dc05ba4308).Provider, {
            value: appState,
            children: (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "RootView",
                children: (0, $7b02d682eb115277$exports.jsx)((0, $d96ebf18a3a82ea8$export$71e1586407c6a0f3).Provider, {
                    value: (0, $b7197004aca2ed1c$export$9972faacf5ecf1d5)(data),
                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "AppView",
                        children: (0, $7b02d682eb115277$exports.jsxs)((0, $97ac05743b787a86$export$74bc7108ae339b7).Provider, {
                            value: shipContext,
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)((0, $cd8deb4eb028fe97$export$381adc1c98036a68), {
                                    ship: data.ship,
                                    hideMenus: hideMenus,
                                    hideShipMenu: hideShipMenu
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)((0, $db922aea4424a404$export$eca4bdafe2d91d15), {
                                    store: dataStore,
                                    children: [
                                        children,
                                        overlay
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}
function $5d8bb4f45e89a4a7$export$b2fb1f046dac12b({ children: children, cloud: cloud, data: data, language: language, focusActive: focusActive, focusInitConfirmationType: focusInitConfirmationType, focusInitCruise: focusInitCruise, focusInitTrip: focusInitTrip, focusInitDay: focusInitDay, focusInitDayTomorrow: focusInitDayTomorrow, focusInitDayTomorrowDetails: focusInitDayTomorrowDetails, focusInitLogs: focusInitLogs, focusInitLogHighlight: focusInitLogHighlight, focusInitLogTabs: focusInitLogTabs, focusInitCurrentLog: focusInitCurrentLog, focusInitStatuses: focusInitStatuses, focusInitUserAdvice: focusInitUserAdvice, focusInitUserAdviceData: focusInitUserAdviceData, instruments: instruments, overlay: overlay, updateAppState: updateAppState }) {
    (0, $ea493e883ca706d4$export$af88d00dbe7f521).debug("=== LOGBOOK_CONTENT_SHIP_VIEW ===", {
        focusInitLogs: focusInitLogs,
        focusInitLogHighlight: focusInitLogHighlight,
        focusInitLogTabs: focusInitLogTabs,
        focusInitCurrentLog: focusInitCurrentLog,
        focusInitStatuses: focusInitStatuses,
        focusInitUserAdvice: focusInitUserAdvice,
        focusInitUserAdviceData: focusInitUserAdviceData
    });
    const shipContext = {
        ship: data.ship,
        requireUserLevel: (_level)=>true,
        apiUser: $5d8bb4f45e89a4a7$var$fullAccessApiUser
    };
    return (0, $7b02d682eb115277$exports.jsx)($5d8bb4f45e89a4a7$export$eb5cee0f7f4abf92, {
        cloud: cloud,
        data: data,
        language: language,
        overlay: overlay,
        updateAppState: updateAppState,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $89da9a3ec064ebbf$export$32b72d0fbebd240d).Provider, {
            value: (0, $b7197004aca2ed1c$export$717441a7de7fd996)(data, focusActive),
            children: (0, $7b02d682eb115277$exports.jsx)((0, $97ac05743b787a86$export$74bc7108ae339b7).Provider, {
                value: shipContext,
                children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "ShipView",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "ShipView-content",
                            children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "ShipContentView",
                                children: [
                                    focusActive ? (0, $7b02d682eb115277$exports.jsx)((0, $f3fe348df41571fb$export$5aeb7b50bb8b32bf), {
                                        show: true,
                                        initConfirmationType: focusInitConfirmationType,
                                        initCruise: focusInitCruise,
                                        initTrip: focusInitTrip,
                                        initDay: focusInitDay,
                                        initDayTomorrow: focusInitDayTomorrow,
                                        initDayTomorrowDetails: focusInitDayTomorrowDetails,
                                        initLogs: focusInitLogs,
                                        initLogHighlight: focusInitLogHighlight,
                                        initLogTabs: focusInitLogTabs,
                                        initCurrentLog: focusInitCurrentLog,
                                        initStatuses: focusInitStatuses,
                                        initUserAdvice: focusInitUserAdvice,
                                        initUserAdviceData: focusInitUserAdviceData
                                    }) : null,
                                    !focusActive && children
                                ]
                            })
                        }),
                        instruments && (0, $7b02d682eb115277$exports.jsx)((0, $d8ded05fe18c7937$export$16c526368e1f696), {
                            minimized: true,
                            setMinimized: ()=>undefined
                        })
                    ]
                })
            })
        })
    });
}















// Helper function to combine days with notes and attachments
function $3bc75fb8da3f6d39$var$combineDaysWithNotes(days, notes, attachments) {
    return days.map((day)=>{
        const dayNotes = notes.filter((n)=>n.dayId == day.id);
        const notesWithAttachments = dayNotes.map((note)=>Object.assign(Object.assign({}, note), {
                attachments: attachments.filter((a)=>a.noteId == note.id)
            }));
        return Object.assign(Object.assign({}, day), {
            notes: notesWithAttachments
        });
    });
}
function $3bc75fb8da3f6d39$export$1799cf72e94b8ac({ frames: frames, onClose: onClose, scene: scene = "concept", initialFrame: initialFrame }) {
    const app = (0, $6f69f4dcc7c84750$export$56752c5ff04def75)();
    const data = (0, $acw62.useMemo)(()=>{
        return (0, $91325a4554765f0c$export$37bdcf3caafe9737)();
    }, []);
    const dataBlank = (0, $acw62.useMemo)(()=>{
        return (0, $0ffce56d54de6ef8$export$b69f506abaf8b7d5)();
    }, []);
    // all demo should shown cruise 9
    const renderCruise = (options)=>{
        var _a, _b, _c, _d;
        const cruiseId = 9;
        const selectedCruise = ((_a = data.cruises) !== null && _a !== void 0 ? _a : []).find((c)=>c.id === cruiseId);
        const trips = ((_b = data.trips) === null || _b === void 0 ? void 0 : _b.filter((t)=>t.cruiseId === cruiseId)) || [];
        return (0, $7b02d682eb115277$exports.jsxs)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
            language: app.language,
            data: data,
            children: [
                (0, $7b02d682eb115277$exports.jsx)((0, $5878af5c58bfa741$export$e6ea0c07cce3c59c), {
                    actions: [],
                    customMenus: [],
                    shipHeader: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                }),
                (0, $7b02d682eb115277$exports.jsx)((0, $561bc7c82d705725$export$18ac525d13abc8df), {
                    cruiseId: cruiseId,
                    initialCruise: selectedCruise,
                    initDetails: (_c = options === null || options === void 0 ? void 0 : options.cruiseDetails) !== null && _c !== void 0 ? _c : false,
                    initTab: options === null || options === void 0 ? void 0 : options.cruiseTab,
                    initTracks: (_d = data.tracks) === null || _d === void 0 ? void 0 : _d.filter((t)=>t.cruiseId == cruiseId),
                    initTrips: trips,
                    children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "CruiseView-content",
                        children: [
                            trips.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $51141e37452020dd$export$66a0ba5751a02e9e), {
                                before: true,
                                count: 8,
                                width: 18
                            }),
                            trips.map((trip)=>{
                                var _a, _b, _c, _d, _e, _f;
                                const tripDays = ((_a = data.days) === null || _a === void 0 ? void 0 : _a.filter((d)=>d.tripId == trip.id)) || [];
                                const tripNotes = ((_b = data.notes) === null || _b === void 0 ? void 0 : _b.filter((n)=>n.tripId == trip.id)) || [];
                                const noteIds = tripNotes.map((n)=>n.id);
                                const tripAttachments = ((_c = data.attachments) === null || _c === void 0 ? void 0 : _c.filter((a)=>noteIds.includes(a.noteId || 0))) || [];
                                const days = $3bc75fb8da3f6d39$var$combineDaysWithNotes(tripDays, tripNotes, tripAttachments);
                                const showDetails = (_d = options === null || options === void 0 ? void 0 : options.tripDetails) === null || _d === void 0 ? void 0 : _d[trip.id];
                                const selectedTab = (_e = options === null || options === void 0 ? void 0 : options.tripTabs) === null || _e === void 0 ? void 0 : _e[trip.id];
                                return (0, $7b02d682eb115277$exports.jsx)((0, $8b93cdbcae4a2de3$export$62031b35b640577c), {
                                    currentDays: days,
                                    trip: trip,
                                    overrideDays: days,
                                    initDetails: showDetails,
                                    initTracks: (_f = data.tracks) === null || _f === void 0 ? void 0 : _f.filter((t)=>t.tripId == trip.id),
                                    initTab: selectedTab,
                                    children: days.map((day)=>{
                                        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                                        const hasDetails = day.startLocation || day.endLocation || day.calculated;
                                        const logs = ((_a = data.logs) === null || _a === void 0 ? void 0 : _a.filter((l)=>l.dayId == day.id)) || [];
                                        const showDayDetails = (_b = options === null || options === void 0 ? void 0 : options.dayDetails) === null || _b === void 0 ? void 0 : _b[day.id];
                                        const selectedDayTab = (_c = options === null || options === void 0 ? void 0 : options.dayTabs) === null || _c === void 0 ? void 0 : _c[day.id];
                                        const highlight = (_e = (_d = options === null || options === void 0 ? void 0 : options.dayHighlight) === null || _d === void 0 ? void 0 : _d[day.id]) !== null && _e !== void 0 ? _e : day.id === 6 && (options === null || options === void 0 ? void 0 : options.logHighlight) ? options.logHighlight : undefined;
                                        const selected = (_f = options === null || options === void 0 ? void 0 : options.daySelected) === null || _f === void 0 ? void 0 : _f[day.id];
                                        const logTabsWithId = (options === null || options === void 0 ? void 0 : options.logHighlight) && ((_g = options === null || options === void 0 ? void 0 : options.logTabs) === null || _g === void 0 ? void 0 : _g[options.logHighlight]) ? {
                                            [options.logHighlight]: options.logTabs[options.logHighlight]
                                        } : options === null || options === void 0 ? void 0 : options.logTabs;
                                        return hasDetails ? (0, $7b02d682eb115277$exports.jsx)((0, $d2dee9b5e2805e91$export$c1379d67dc104c23), {
                                            day: day,
                                            initDetails: showDayDetails,
                                            initTab: selectedDayTab,
                                            initHighlight: highlight,
                                            initSelected: selected,
                                            initLogs: logs.length > 0 ? logs : undefined,
                                            initLogTabs: logTabsWithId,
                                            initStatuses: (_h = data.statuses) === null || _h === void 0 ? void 0 : _h.filter((s)=>s.dayId == day.id),
                                            initTracks: (_j = data.tracks) === null || _j === void 0 ? void 0 : _j.filter((t)=>t.dayId == day.id)
                                        }, day.id) : (0, $7b02d682eb115277$exports.jsx)((0, $7d963101ed190d21$export$e7429c1b993a4901), {
                                            day: day
                                        }, day.id);
                                    })
                                }, trip.id);
                            }),
                            trips.length > 0 && (0, $7b02d682eb115277$exports.jsx)((0, $51141e37452020dd$export$66a0ba5751a02e9e), {
                                before: false,
                                width: 18
                            })
                        ]
                    })
                })
            ]
        });
    };
    // Helper function to render quickstart log entry scenes with common structure
    const renderQuickstartLogScene = (options)=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const cruise = ((_a = dataBlank.cruises) !== null && _a !== void 0 ? _a : []).find((c)=>c.id === 1);
        const currentTime = options.time;
        const currentDay = (0, $91325a4554765f0c$export$d2d39d1adcc883a2)(currentTime);
        const trip = Object.assign(Object.assign({}, ((_b = dataBlank.trips) !== null && _b !== void 0 ? _b : []).find((t)=>t.id === 1)), {
            title: "My first passage",
            startedAt: (options.tripStartTime || currentTime).toISOString()
        });
        // Day with start location and crew
        const dayData = Object.assign(Object.assign(Object.assign({}, ((_c = dataBlank.days) !== null && _c !== void 0 ? _c : []).find((d)=>d.id === 1)), {
            day: currentDay,
            startLocation: "Palma de Mallorca",
            skipper: 1,
            crew: [
                2,
                3,
                4
            ]
        }), options.dayData || {});
        // Tomorrow day (collapsed, all values 0)
        const dayTomorrow = Object.assign(Object.assign(Object.assign({}, ((_d = dataBlank.days) !== null && _d !== void 0 ? _d : []).find((d)=>d.id === 1)), {
            id: 0,
            day: currentDay + 1
        }), options.dayTomorrowData || {});
        // Customize the current log data
        const currentLog = (0, $0ffce56d54de6ef8$export$87cdd402beca8f45)(Object.assign(Object.assign({
            time: currentTime,
            sog: (_e = options.currentLogOptions.sog) !== null && _e !== void 0 ? _e : 0,
            course: (_f = options.currentLogOptions.course) !== null && _f !== void 0 ? _f : 186,
            distance: (_g = options.currentLogOptions.distance) !== null && _g !== void 0 ? _g : 0,
            engineRpms: (_h = options.currentLogOptions.engineRpms) !== null && _h !== void 0 ? _h : [
                0,
                0,
                0
            ]
        }, options.currentLogOptions.dayId !== undefined && {
            dayId: options.currentLogOptions.dayId
        }), options.currentLogOptions.comment !== undefined && {
            comment: options.currentLogOptions.comment
        }));
        // Include skipper and crew
        const shipUsers = (0, $0ffce56d54de6ef8$export$d2be2311c14adaf4)().filter((su)=>[
                1,
                2,
                3,
                4
            ].includes(su.userId));
        // Create motion status if requested
        const statuses = [
            ...options.includeMotionStatus ? [
                {
                    id: 1,
                    cruiseId: 1,
                    tripId: 1,
                    dayId: 1,
                    accountId: 1,
                    shipId: 1,
                    createdAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                    updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                    startLogId: (_j = options.statusStartLogId) !== null && _j !== void 0 ? _j : 3,
                    statusType: 1,
                    value: 0
                }
            ] : [],
            ...options.additionalStatuses || []
        ];
        // Keep previous logs as saved entries
        const dataWithLog = Object.assign(Object.assign({}, dataBlank), {
            trips: [
                trip
            ],
            cruises: [
                cruise
            ],
            days: [
                dayData,
                dayTomorrow
            ],
            users: (_k = dataBlank.users) === null || _k === void 0 ? void 0 : _k.filter((user)=>[
                    1,
                    2,
                    3,
                    4
                ].includes(user.id)),
            shipUsers: shipUsers,
            logs: (0, $0ffce56d54de6ef8$export$30985b286938a5b)(options.logIds, options.logOverrides),
            statuses: statuses
        });
        const appStateFunc = options.appStateUpdater ? (s)=>options.appStateUpdater(s, currentTime) : (s)=>$3bc75fb8da3f6d39$export$67dd33a8de5be2f1(s, currentTime);
        return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
            language: app.language,
            cloud: false,
            data: dataWithLog,
            focusActive: true,
            focusInitConfirmationType: "trip",
            focusInitCruise: cruise,
            focusInitTrip: trip,
            focusInitDay: dayData,
            focusInitDayTomorrow: dayTomorrow,
            focusInitDayTomorrowDetails: options.showTomorrowDetails,
            focusInitLogs: dataWithLog.logs,
            focusInitCurrentLog: currentLog,
            focusInitStatuses: dataWithLog.statuses,
            focusInitLogHighlight: options.logHighlight,
            focusInitLogTabs: options.logTabs,
            focusInitUserAdvice: options.initUserAdvice,
            focusInitUserAdviceData: options.initUserAdviceData,
            updateAppState: appStateFunc,
            children: (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                initCruises: dataWithLog.cruises
            })
        });
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $2af575fa192771dd$export$38af1803e3442a7f), {
        content: {
            // view for start screen (Logos and title of the demo)
            "start": ()=>{
                var _a;
                const ui = ((_a = (0, $c7447bc87504efd0$export$5c05d8d94c8024d2)[app.language]) !== null && _a !== void 0 ? _a : (0, $c7447bc87504efd0$export$5c05d8d94c8024d2).en).ui;
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$eb5cee0f7f4abf92), {
                    language: app.language,
                    data: data,
                    children: (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: ui.start_image,
                        alt: "LOGBOOK Concept",
                        className: "startimage"
                    })
                });
            },
            // view for end screen (buttons)
            "end": ()=>{
                return (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "final-screen",
                    children: (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: "/demo/LOGBOOK.svg",
                        alt: "LOGBOOK",
                        className: "logo"
                    })
                });
            },
            "account": ()=>{
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$eb5cee0f7f4abf92), {
                    language: app.language,
                    data: data,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $fd9f921a92bb998b$export$21d8166b98f38a62), {
                        cancelEdit: ()=>undefined,
                        ships: data.ships
                    })
                });
            },
            // view for overview timeline
            "timeline": ()=>{
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    data: data,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                        initCruises: data.cruises
                    })
                });
            },
            // view for cruise, showing different states of the cruise (details, tabs)
            "cruise": ()=>renderCruise(),
            "cruise-details": ()=>renderCruise({
                    cruiseDetails: true,
                    cruiseTab: "cruise"
                }),
            "cruise-details-stats": ()=>renderCruise({
                    cruiseDetails: true,
                    cruiseTab: "stats"
                }),
            "cruise-details-track": ()=>{
                return (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "demo-track-static",
                    style: {
                        "--track-image": "url(\"/demo/track.png\")"
                    },
                    children: renderCruise({
                        cruiseDetails: true,
                        cruiseTab: "track"
                    })
                });
            },
            // view for trips, showing different states of the trip (details, tabs) trip #1
            "cruise-trip": ()=>renderCruise({
                    tripDetails: {
                        1: true
                    },
                    tripTabs: {
                        1: "trip"
                    }
                }),
            "cruise-stats": ()=>renderCruise({
                    tripDetails: {
                        1: true
                    },
                    tripTabs: {
                        1: "stats"
                    }
                }),
            "cruise-track": ()=>renderCruise({
                    tripDetails: {
                        1: true
                    },
                    tripTabs: {
                        1: "track"
                    }
                }),
            // view for days, showing different states of the day (details, tabs)  day #6
            "day": ()=>renderCruise({
                    dayDetails: {
                        6: false
                    },
                    daySelected: {
                        6: true
                    }
                }),
            "day-day": ()=>renderCruise({
                    dayDetails: {
                        6: true
                    },
                    daySelected: {
                        6: true
                    }
                }),
            "day-stats": ()=>renderCruise({
                    dayDetails: {
                        6: true
                    },
                    dayTabs: {
                        6: "stats"
                    },
                    daySelected: {
                        6: true
                    }
                }),
            "day-journal": ()=>renderCruise({
                    dayDetails: {
                        6: true
                    },
                    dayTabs: {
                        6: "note-journal"
                    },
                    daySelected: {
                        6: true
                    }
                }),
            // view for logs, showing different states of the log (details, tabs)
            "log-navigation": ()=>renderCruise({
                    dayDetails: {
                        6: false
                    },
                    daySelected: {
                        6: true
                    },
                    logHighlight: 23,
                    logTabs: {
                        23: "navigation"
                    }
                }),
            "log-environment": ()=>renderCruise({
                    dayDetails: {
                        6: false
                    },
                    daySelected: {
                        6: true
                    },
                    logHighlight: 23,
                    logTabs: {
                        23: "environment"
                    }
                }),
            // view for a screenshot from /demo/static/
            "screenshot": (frame)=>{
                var _a;
                return (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "screenshot-view",
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$eb5cee0f7f4abf92), {
                        language: app.language,
                        data: data,
                        children: (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: `/demo/${(_a = frame.contentOptions) === null || _a === void 0 ? void 0 : _a.screenshot}`,
                            alt: "Screenshot",
                            className: "screenshot-image"
                        })
                    })
                });
            },
            //  Views for Quickstart
            "start_solo": ()=>{
                var _a;
                const ui = ((_a = (0, $c7447bc87504efd0$export$5c05d8d94c8024d2)[app.language]) !== null && _a !== void 0 ? _a : (0, $c7447bc87504efd0$export$5c05d8d94c8024d2).en).ui;
                return (0, $7b02d682eb115277$exports.jsxs)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    data: data,
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $5878af5c58bfa741$export$e6ea0c07cce3c59c), {
                            actions: [],
                            customMenus: []
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                position: "relative"
                            },
                            children: (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: ui.start_solo_image,
                                alt: "LOGBOOK",
                                className: "startimage"
                            })
                        })
                    ]
                });
            },
            "start_quickstart": ()=>{
                var _a;
                const ui = ((_a = (0, $c7447bc87504efd0$export$5c05d8d94c8024d2)[app.language]) !== null && _a !== void 0 ? _a : (0, $c7447bc87504efd0$export$5c05d8d94c8024d2).en).ui;
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$eb5cee0f7f4abf92), {
                    language: app.language,
                    data: data,
                    hideMenus: true,
                    children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            position: "relative"
                        },
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: ui.start_solo_image,
                                alt: "LOGBOOK",
                                className: "startimage"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "chapter-title",
                                children: ui.quickstartChapter
                            })
                        ]
                    })
                });
            },
            "start_account": ()=>{
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$eb5cee0f7f4abf92), {
                    language: app.language,
                    cloud: true,
                    data: dataBlank,
                    hideShipMenu: true,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $fd9f921a92bb998b$export$21d8166b98f38a62), {
                        cancelEdit: ()=>{},
                        ships: []
                    })
                });
            },
            "create_ship": ()=>{
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$eb5cee0f7f4abf92), {
                    language: app.language,
                    cloud: true,
                    data: dataBlank,
                    hideShipMenu: true,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $82532a99618f300b$export$ba3b838c43b5c410), {
                        cancelEdit: ()=>{}
                    }, "new")
                });
            },
            "create_ship_complete": ()=>{
                var _a;
                const ship = ((_a = dataBlank.ships) !== null && _a !== void 0 ? _a : []).find((s)=>s.id === 1);
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$eb5cee0f7f4abf92), {
                    language: app.language,
                    cloud: true,
                    data: dataBlank,
                    hideShipMenu: true,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $82532a99618f300b$export$ba3b838c43b5c410), {
                        cancelEdit: ()=>{},
                        initShipName: ship.name,
                        initShipType: ship.vesselType,
                        initShipEngines: ship.engineCount,
                        initValidInput: true
                    }, "new")
                });
            },
            "new_ship_selected": ()=>{
                const dataWithoutShipInfo = Object.assign(Object.assign({}, dataBlank), {
                    ship: Object.assign(Object.assign({}, dataBlank.ship), {
                        shipData: Object.assign(Object.assign({}, dataBlank.ship.shipData), {
                            mmsi: "",
                            callsign: "",
                            yachtModelName: ""
                        })
                    })
                });
                return (0, $7b02d682eb115277$exports.jsxs)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: true,
                    data: dataWithoutShipInfo,
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $5878af5c58bfa741$export$e6ea0c07cce3c59c), {
                            actions: [],
                            customMenus: [],
                            shipHeader: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                            initCruises: []
                        })
                    ]
                });
            },
            "new_ship_app": ()=>{
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: false,
                    data: dataBlank,
                    updateAppState: $3bc75fb8da3f6d39$var$appStateNMEANotConfigured,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                        initCruises: dataBlank.cruises
                    })
                });
            },
            "new_ship_nmea": ()=>{
                return (0, $7b02d682eb115277$exports.jsxs)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: false,
                    data: dataBlank,
                    updateAppState: $3bc75fb8da3f6d39$var$appStateNMEANotConfigured,
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $74bcfc43c0f9ac90$export$89acdd91182d6c5d), {
                            overlay: "nmea",
                            overlays: {
                                nmea: {
                                    close: true,
                                    render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $b75ab3936bd2beb7$export$f8b316f44186c411), {
                                            initConfiguration: {
                                                type: "tcp",
                                                host: "192.168.4.1",
                                                port: 10110
                                            }
                                        })
                                }
                            }
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                            initCruises: dataBlank.cruises
                        })
                    ]
                });
            },
            "new_ship_nmea_empty": ()=>{
                return (0, $7b02d682eb115277$exports.jsxs)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: false,
                    data: dataBlank,
                    updateAppState: $3bc75fb8da3f6d39$var$appStateNMEANotConfigured,
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $74bcfc43c0f9ac90$export$89acdd91182d6c5d), {
                            overlay: "nmea",
                            overlays: {
                                nmea: {
                                    close: true,
                                    render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $b75ab3936bd2beb7$export$f8b316f44186c411), {})
                                }
                            }
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                            initCruises: dataBlank.cruises
                        })
                    ]
                });
            },
            "new_ship_nmea_select": ()=>{
                return (0, $7b02d682eb115277$exports.jsxs)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: false,
                    data: dataBlank,
                    updateAppState: $3bc75fb8da3f6d39$var$appStateNMEANotConfigured,
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)((0, $74bcfc43c0f9ac90$export$89acdd91182d6c5d), {
                            overlay: "nmea",
                            overlays: {
                                nmea: {
                                    close: true,
                                    render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $b75ab3936bd2beb7$export$f8b316f44186c411), {
                                            initConnectionTypeOpen: true,
                                            initConfiguration: {
                                                type: "tcp"
                                            }
                                        })
                                }
                            }
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                            initCruises: dataBlank.cruises
                        })
                    ]
                });
            },
            "new_ship_nmea_test": ()=>{
                return (0, $7b02d682eb115277$exports.jsxs)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: false,
                    data: dataBlank,
                    updateAppState: $3bc75fb8da3f6d39$var$appStateNMEATestData,
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("style", {
                            children: `
          .status-nmea, .status-native { color: var(--green) !important; }
          .status-error { color: var(--red) !important; }
        `
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $74bcfc43c0f9ac90$export$89acdd91182d6c5d), {
                            overlay: "nmea",
                            overlays: {
                                nmea: {
                                    close: true,
                                    render: ()=>(0, $7b02d682eb115277$exports.jsx)((0, $b75ab3936bd2beb7$export$f8b316f44186c411), {
                                            initTab: "test_data",
                                            initConfiguration: {
                                                type: "tcp",
                                                host: "192.168.4.1",
                                                port: 10110
                                            }
                                        })
                                }
                            }
                        }),
                        (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                            initCruises: dataBlank.cruises
                        })
                    ]
                });
            },
            "new_ship_ready": ()=>{
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: false,
                    data: dataBlank,
                    updateAppState: $3bc75fb8da3f6d39$var$appStateNMEATestData,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                        initCruises: dataBlank.cruises
                    })
                });
            },
            // here for quickstart-voyage
            "start_quickstart_voyage": ()=>{
                var _a;
                const ui = ((_a = (0, $c7447bc87504efd0$export$5c05d8d94c8024d2)[app.language]) !== null && _a !== void 0 ? _a : (0, $c7447bc87504efd0$export$5c05d8d94c8024d2).en).ui;
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$eb5cee0f7f4abf92), {
                    language: app.language,
                    data: data,
                    hideMenus: true,
                    children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            position: "relative"
                        },
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: ui.start_solo_image,
                                alt: "LOGBOOK",
                                className: "startimage"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "chapter-title",
                                children: ui.quickstartChapter2
                            })
                        ]
                    })
                });
            },
            "focus_start": ()=>{
                var _a, _b, _c;
                const cruise = ((_a = dataBlank.cruises) !== null && _a !== void 0 ? _a : []).find((c)=>c.id === 1);
                const trip = ((_b = dataBlank.trips) !== null && _b !== void 0 ? _b : []).find((t)=>t.id === 1);
                const currentDay = (0, $91325a4554765f0c$export$d2d39d1adcc883a2)((0, $0ffce56d54de6ef8$export$ed6db8ac961f262d));
                const dayData = Object.assign(Object.assign({}, ((_c = dataBlank.days) !== null && _c !== void 0 ? _c : []).find((d)=>d.id === 1)), {
                    day: currentDay
                });
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: false,
                    data: dataBlank,
                    focusActive: true,
                    focusInitConfirmationType: "trip",
                    focusInitCruise: cruise,
                    focusInitTrip: trip,
                    focusInitDay: dayData,
                    updateAppState: $3bc75fb8da3f6d39$var$appStateNMEATestData,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                        initCruises: dataBlank.cruises
                    })
                });
            },
            "trip_name": ()=>{
                var _a, _b, _c;
                const cruise = ((_a = dataBlank.cruises) !== null && _a !== void 0 ? _a : []).find((c)=>c.id === 1);
                const trip = Object.assign(Object.assign({}, ((_b = dataBlank.trips) !== null && _b !== void 0 ? _b : []).find((t)=>t.id === 1)), {
                    title: "My first passage"
                });
                const currentDay = (0, $91325a4554765f0c$export$d2d39d1adcc883a2)((0, $0ffce56d54de6ef8$export$ed6db8ac961f262d));
                const dayData = Object.assign(Object.assign({}, ((_c = dataBlank.days) !== null && _c !== void 0 ? _c : []).find((d)=>d.id === 1)), {
                    day: currentDay
                });
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: false,
                    data: dataBlank,
                    focusActive: true,
                    focusInitConfirmationType: "trip",
                    focusInitCruise: cruise,
                    focusInitTrip: trip,
                    focusInitDay: dayData,
                    updateAppState: $3bc75fb8da3f6d39$var$appStateNMEATestData,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                        initCruises: dataBlank.cruises
                    })
                });
            },
            "trip_started": ()=>{
                var _a, _b, _c;
                const cruise = ((_a = dataBlank.cruises) !== null && _a !== void 0 ? _a : []).find((c)=>c.id === 1);
                const currentTime = (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d);
                const currentDay = (0, $91325a4554765f0c$export$d2d39d1adcc883a2)(currentTime);
                const trip = Object.assign(Object.assign({}, ((_b = dataBlank.trips) !== null && _b !== void 0 ? _b : []).find((t)=>t.id === 1)), {
                    title: "My first passage",
                    startedAt: currentTime.toISOString()
                });
                // Get current log data from QuickStartData (for log row)
                const currentLog = (0, $0ffce56d54de6ef8$export$87cdd402beca8f45)();
                // Today day (expanded, with current day data)
                const dayData = Object.assign(Object.assign({}, ((_c = dataBlank.days) !== null && _c !== void 0 ? _c : []).find((d)=>d.id === 1)), {
                    day: currentDay
                });
                // Keep previous logs as saved entries
                const dataWithLog = Object.assign(Object.assign({}, dataBlank), {
                    trips: [
                        trip
                    ],
                    cruises: [
                        cruise
                    ],
                    days: [
                        dayData
                    ],
                    logs: []
                });
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: false,
                    data: dataWithLog,
                    focusActive: true,
                    focusInitConfirmationType: "trip",
                    focusInitCruise: cruise,
                    focusInitTrip: trip,
                    focusInitDay: dayData,
                    focusInitCurrentLog: currentLog,
                    focusInitStatuses: [],
                    updateAppState: $3bc75fb8da3f6d39$var$appStateNMEAStarted,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                        initCruises: dataWithLog.cruises
                    })
                });
            },
            "day_started": ()=>{
                var _a, _b, _c, _d;
                const cruise = ((_a = dataBlank.cruises) !== null && _a !== void 0 ? _a : []).find((c)=>c.id === 1);
                const currentTime = (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d);
                const currentDay = (0, $91325a4554765f0c$export$d2d39d1adcc883a2)(currentTime);
                const trip = Object.assign(Object.assign({}, ((_b = dataBlank.trips) !== null && _b !== void 0 ? _b : []).find((t)=>t.id === 1)), {
                    title: "My first passage",
                    startedAt: currentTime.toISOString()
                });
                // Day without start location and persons
                const dayData = Object.assign(Object.assign({}, ((_c = dataBlank.days) !== null && _c !== void 0 ? _c : []).find((d)=>d.id === 1)), {
                    day: currentDay
                });
                // Customize the current log data
                const currentLog = (0, $0ffce56d54de6ef8$export$87cdd402beca8f45)({
                    sog: 0,
                    course: 186,
                    distance: 0
                });
                // Select only skipper (user 1)
                const shipUsers = (0, $0ffce56d54de6ef8$export$d2be2311c14adaf4)().filter((su)=>su.userId === 1);
                const dataWithLog = Object.assign(Object.assign({}, dataBlank), {
                    trips: [
                        trip
                    ],
                    cruises: [
                        cruise
                    ],
                    days: [
                        dayData
                    ],
                    users: (_d = dataBlank.users) === null || _d === void 0 ? void 0 : _d.filter((user)=>user.id === 1),
                    shipUsers: shipUsers,
                    logs: []
                });
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: false,
                    data: dataWithLog,
                    focusActive: true,
                    focusInitConfirmationType: "trip",
                    focusInitCruise: cruise,
                    focusInitTrip: trip,
                    focusInitDay: dayData,
                    focusInitLogs: dataWithLog.logs,
                    focusInitCurrentLog: currentLog,
                    focusInitStatuses: [],
                    updateAppState: $3bc75fb8da3f6d39$var$appStateNMEAStarted,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                        initCruises: dataWithLog.cruises
                    })
                });
            },
            "day_data": ()=>{
                var _a, _b, _c, _d;
                const cruise = ((_a = dataBlank.cruises) !== null && _a !== void 0 ? _a : []).find((c)=>c.id === 1);
                const currentTime = (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d);
                const currentDay = (0, $91325a4554765f0c$export$d2d39d1adcc883a2)(currentTime);
                const trip = Object.assign(Object.assign({}, ((_b = dataBlank.trips) !== null && _b !== void 0 ? _b : []).find((t)=>t.id === 1)), {
                    title: "My first passage",
                    startedAt: currentTime.toISOString()
                });
                // Day with start location
                const dayData = Object.assign(Object.assign({}, ((_c = dataBlank.days) !== null && _c !== void 0 ? _c : []).find((d)=>d.id === 1)), {
                    day: currentDay,
                    startLocation: "Palma de Mallorca",
                    skipper: 1
                });
                // Customize the current log data
                const currentLog = (0, $0ffce56d54de6ef8$export$87cdd402beca8f45)({
                    sog: 0,
                    course: 186,
                    distance: 0
                });
                // Select only skipper (user 1)
                const shipUsers = (0, $0ffce56d54de6ef8$export$d2be2311c14adaf4)().filter((su)=>su.userId === 1);
                const dataWithLog = Object.assign(Object.assign({}, dataBlank), {
                    trips: [
                        trip
                    ],
                    cruises: [
                        cruise
                    ],
                    days: [
                        dayData
                    ],
                    users: (_d = dataBlank.users) === null || _d === void 0 ? void 0 : _d.filter((user)=>user.id === 1),
                    shipUsers: shipUsers,
                    logs: []
                });
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: false,
                    data: dataWithLog,
                    focusActive: true,
                    focusInitConfirmationType: "trip",
                    focusInitCruise: cruise,
                    focusInitTrip: trip,
                    focusInitDay: dayData,
                    focusInitLogs: dataWithLog.logs,
                    focusInitCurrentLog: currentLog,
                    focusInitStatuses: [],
                    updateAppState: $3bc75fb8da3f6d39$var$appStateNMEAStarted,
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                        initCruises: dataWithLog.cruises
                    })
                });
            },
            "day_data2": ()=>{
                var _a, _b, _c, _d;
                const cruise = ((_a = dataBlank.cruises) !== null && _a !== void 0 ? _a : []).find((c)=>c.id === 1);
                const currentTime = (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d);
                const currentDay = (0, $91325a4554765f0c$export$d2d39d1adcc883a2)(currentTime);
                const trip = Object.assign(Object.assign({}, ((_b = dataBlank.trips) !== null && _b !== void 0 ? _b : []).find((t)=>t.id === 1)), {
                    title: "My first passage",
                    startedAt: currentTime.toISOString()
                });
                // Day with start location
                const dayData = Object.assign(Object.assign({}, ((_c = dataBlank.days) !== null && _c !== void 0 ? _c : []).find((d)=>d.id === 1)), {
                    day: currentDay,
                    startLocation: "Palma de Mallorca",
                    skipper: 1
                });
                // Customize the current log data
                const currentLog = (0, $0ffce56d54de6ef8$export$87cdd402beca8f45)({
                    sog: 0,
                    course: 186,
                    distance: 0
                });
                // Select only skipper (user 1)
                const shipUsers = (0, $0ffce56d54de6ef8$export$d2be2311c14adaf4)().filter((su)=>su.userId === 1);
                const dataWithLog = Object.assign(Object.assign({}, dataBlank), {
                    trips: [
                        trip
                    ],
                    cruises: [
                        cruise
                    ],
                    days: [
                        dayData
                    ],
                    users: (_d = dataBlank.users) === null || _d === void 0 ? void 0 : _d.filter((user)=>user.id === 1),
                    shipUsers: shipUsers,
                    logs: []
                });
                return (0, $7b02d682eb115277$exports.jsx)((0, $5d8bb4f45e89a4a7$export$b2fb1f046dac12b), {
                    language: app.language,
                    cloud: false,
                    data: dataWithLog,
                    focusActive: true,
                    focusInitConfirmationType: "trip",
                    focusInitCruise: cruise,
                    focusInitTrip: trip,
                    focusInitDay: dayData,
                    focusInitLogs: dataWithLog.logs,
                    focusInitCurrentLog: currentLog,
                    focusInitStatuses: [],
                    updateAppState: $3bc75fb8da3f6d39$var$appStateNMEAStarted,
                    overlay: (0, $7b02d682eb115277$exports.jsx)((0, $d5a725d5c44f3d0f$export$b65e701dc90258f), {
                        dialogOnly: true,
                        initAddShipUser: true,
                        initUserName: "Tom Schmidt",
                        initUserShortname: "Tom",
                        name: "crew",
                        role: (0, $dc7739d612f0c536$export$1e4ade51a6368243).crew
                    }),
                    children: (0, $7b02d682eb115277$exports.jsx)((0, $ec478af36ffc9832$export$35e0c46ab5c8b1c0), {
                        initCruises: dataWithLog.cruises
                    })
                });
            },
            "engine1_on": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)),
                    logIds: [
                        1
                    ],
                    currentLogOptions: {
                        sog: 0,
                        course: 186,
                        distance: 0,
                        engineRpms: [
                            0,
                            1200,
                            0
                        ]
                    },
                    // logHighlight: 1,
                    showTomorrowDetails: false
                }),
            "engine2_on": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)),
                    logIds: [
                        1,
                        2
                    ],
                    currentLogOptions: {
                        sog: 0,
                        course: 186,
                        distance: 0,
                        engineRpms: [
                            0,
                            1200,
                            1200
                        ]
                    }
                }),
            "started": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)),
                    logIds: [
                        1,
                        2,
                        3
                    ],
                    currentLogOptions: {
                        sog: 5.7,
                        course: 186,
                        distance: 0,
                        engineRpms: [
                            0,
                            1200,
                            1200
                        ]
                    },
                    includeMotionStatus: true,
                    statusStartLogId: 3,
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "entry_30min": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 13, 0, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 13, 0, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4
                    ],
                    currentLogOptions: {
                        sog: 5.7,
                        course: 186,
                        distance: 0.4,
                        engineRpms: [
                            0,
                            1200,
                            1200
                        ]
                    },
                    includeMotionStatus: true,
                    statusStartLogId: 3,
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "manualEntry_scene": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4
                    ],
                    currentLogOptions: {
                        sog: 5.7,
                        course: 186,
                        distance: 0.8,
                        engineRpms: [
                            0,
                            1200,
                            1200
                        ],
                        comment: ""
                    },
                    includeMotionStatus: true,
                    statusStartLogId: 3,
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "sail_entry1": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5
                    ],
                    currentLogOptions: {
                        sog: 5.7,
                        course: 186,
                        distance: 0.8,
                        engineRpms: [
                            0,
                            1200,
                            1200
                        ],
                        comment: ""
                    },
                    includeMotionStatus: true,
                    logHighlight: 5,
                    logOverrides: {
                        5: {
                            comment: "",
                            stw: 5.7,
                            heading: 186,
                            log: 25812,
                            depth: 35.6,
                            lat: 39.551,
                            lng: 2.632
                        }
                    },
                    statusStartLogId: 3,
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "sail_entry2": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5
                    ],
                    currentLogOptions: {
                        sog: 5.7,
                        course: 186,
                        distance: 0.8,
                        engineRpms: [
                            0,
                            1200,
                            1200
                        ],
                        comment: ""
                    },
                    includeMotionStatus: true,
                    statusStartLogId: 3,
                    logHighlight: 5,
                    logOverrides: {
                        5: {
                            comment: "",
                            stw: 5.7,
                            heading: 186,
                            log: 25812,
                            depth: 35.6,
                            lat: 39.551,
                            lng: 2.632,
                            data: {
                                nmeaFields: [
                                    "stw",
                                    "heading",
                                    "log",
                                    "depth",
                                    "course",
                                    "sog",
                                    "engineRpms"
                                ]
                            }
                        }
                    },
                    additionalStatuses: [
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)).toISOString(),
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)).toISOString(),
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "entries_engines_off": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7
                    ],
                    currentLogOptions: {
                        sog: 5.7,
                        course: 186,
                        distance: 0.9,
                        engineRpms: [
                            0,
                            0,
                            0
                        ]
                    },
                    includeMotionStatus: true,
                    statusStartLogId: 3,
                    additionalStatuses: [
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "entry_additional_data": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7
                    ],
                    currentLogOptions: {
                        sog: 5.7,
                        course: 186,
                        distance: 0.9,
                        engineRpms: [
                            0,
                            0,
                            0
                        ]
                    },
                    includeMotionStatus: true,
                    statusStartLogId: 3,
                    logHighlight: 7,
                    logTabs: {
                        7: "environment"
                    },
                    logOverrides: {
                        7: {
                            data: {
                                nmeaFields: [
                                    "windDirection",
                                    "windSpeed",
                                    "pressure",
                                    "temperature",
                                    "depth",
                                    "stw",
                                    "heading",
                                    "log",
                                    "course",
                                    "sog",
                                    "engineRpms"
                                ]
                            }
                        }
                    },
                    additionalStatuses: [
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "entry_additional_data2": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 13, 5, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7
                    ],
                    currentLogOptions: {
                        sog: 5.7,
                        course: 186,
                        distance: 0.9,
                        engineRpms: [
                            0,
                            0,
                            0
                        ]
                    },
                    includeMotionStatus: true,
                    statusStartLogId: 3,
                    logHighlight: 7,
                    logTabs: {
                        7: "environment"
                    },
                    logOverrides: {
                        7: {
                            weather: 2,
                            seaState: "2",
                            data: {
                                nmeaFields: [
                                    "windDirection",
                                    "windSpeed",
                                    "pressure",
                                    "temperature",
                                    "depth",
                                    "stw",
                                    "heading",
                                    "log",
                                    "course",
                                    "sog",
                                    "engineRpms"
                                ]
                            }
                        }
                    },
                    additionalStatuses: [
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "course_change": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 13, 16, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 13, 16, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8
                    ],
                    currentLogOptions: {
                        sog: 8.6,
                        course: 126,
                        distance: 2.3,
                        engineRpms: [
                            0,
                            0,
                            0
                        ]
                    },
                    includeMotionStatus: true,
                    statusStartLogId: 3,
                    additionalStatuses: [
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "manual_engine_entry": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 13, 16, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 13, 16, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8
                    ],
                    currentLogOptions: {
                        sog: 8.6,
                        course: 126,
                        distance: 2.3,
                        engineRpms: [
                            0,
                            0,
                            0
                        ]
                    },
                    includeMotionStatus: true,
                    statusStartLogId: 3,
                    additionalStatuses: [
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    appStateUpdater: $3bc75fb8da3f6d39$export$555d361aaac220dd
                }),
            "sailing": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 16, 13, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 16, 13, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17
                    ],
                    currentLogOptions: {
                        sog: 7.1,
                        course: 133,
                        distance: 23.4,
                        engineRpms: [
                            0,
                            1200,
                            1200
                        ]
                    },
                    includeMotionStatus: true,
                    statusStartLogId: 3,
                    additionalStatuses: [
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 15,
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 13,
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "pause": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 16, 20, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 16, 20, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18
                    ],
                    currentLogOptions: {
                        sog: 0,
                        course: 133,
                        distance: 23.7,
                        engineRpms: [
                            0,
                            1200,
                            1200
                        ]
                    },
                    includeMotionStatus: false,
                    additionalStatuses: [
                        {
                            id: 1,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                            endLogId: 18,
                            startLogId: 3,
                            statusType: 1,
                            value: 0
                        },
                        {
                            id: 4,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 16, 13, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 16, 13, 0)).toISOString(),
                            startLogId: 18,
                            statusType: 1,
                            value: 1
                        },
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 16,
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 13,
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "pause_dialog": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 16, 20, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 16, 20, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18
                    ],
                    currentLogOptions: {
                        sog: 0,
                        course: 133,
                        distance: 23.7,
                        engineRpms: [
                            0,
                            1200,
                            1200
                        ]
                    },
                    includeMotionStatus: false,
                    logOverrides: {
                        18: {
                            labels: [
                                "auto"
                            ]
                        }
                    },
                    additionalStatuses: [
                        {
                            id: 1,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                            endLogId: 18,
                            startLogId: 3,
                            statusType: 1,
                            value: 0
                        },
                        {
                            id: 4,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 16, 13, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 16, 13, 0)).toISOString(),
                            startLogId: 18,
                            statusType: 1,
                            value: 1
                        },
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 16,
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 13,
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    initUserAdvice: "stop",
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "pause_set": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 16, 20, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 16, 20, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18
                    ],
                    currentLogOptions: {
                        sog: 0,
                        course: 133,
                        distance: 23.7,
                        engineRpms: [
                            0,
                            1200,
                            1200
                        ]
                    },
                    includeMotionStatus: false,
                    logOverrides: {
                        18: {
                            labels: [
                                "auto"
                            ]
                        }
                    },
                    additionalStatuses: [
                        {
                            id: 1,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                            endLogId: 18,
                            startLogId: 3,
                            statusType: 1,
                            value: 0
                        },
                        {
                            id: 4,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 16, 13, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 16, 13, 0)).toISOString(),
                            startLogId: 18,
                            statusType: 1,
                            value: 1
                        },
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 16,
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 13,
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    initUserAdvice: "stop",
                    initUserAdviceData: {
                        stopType: "endOfDay",
                        endLocation: "Cala Palma",
                        shipStatus: 3
                    },
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "pause_fixed": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 16, 20, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 16, 20, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18
                    ],
                    currentLogOptions: {
                        sog: 0,
                        course: 133,
                        distance: 23.7,
                        engineRpms: [
                            0,
                            1200,
                            1200
                        ]
                    },
                    includeMotionStatus: false,
                    logOverrides: {
                        18: {
                            comment: "Stopped for end of day at Cala Palma"
                        }
                    },
                    additionalStatuses: [
                        {
                            id: 1,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                            endLogId: 18,
                            startLogId: 3,
                            statusType: 1,
                            value: 0
                        },
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 16,
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 13,
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "pause_fixed2": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 16, 20, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 16, 20, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18
                    ],
                    currentLogOptions: {
                        sog: 0,
                        course: 133,
                        distance: 23.7,
                        engineRpms: [
                            0,
                            1200,
                            1200
                        ]
                    },
                    includeMotionStatus: false,
                    logOverrides: {
                        18: {
                            comment: "Stopped for end of day at Cala Palma"
                        }
                    },
                    additionalStatuses: [
                        {
                            id: 1,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                            endLogId: 18,
                            startLogId: 3,
                            statusType: 1,
                            value: 0
                        },
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 16,
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 13,
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    appStateUpdater: $3bc75fb8da3f6d39$export$cc63cd2b17ebe895
                }),
            "engines_off": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 16, 30, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 16, 30, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20
                    ],
                    currentLogOptions: {
                        sog: 0,
                        course: 133,
                        distance: 23.7,
                        engineRpms: [
                            0,
                            0,
                            0
                        ]
                    },
                    includeMotionStatus: false,
                    logOverrides: {
                        18: {
                            comment: "Stopped for end of day at Cala Palma"
                        }
                    },
                    additionalStatuses: [
                        {
                            id: 1,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 55, 0)).toISOString(),
                            endLogId: 18,
                            startLogId: 3,
                            statusType: 1,
                            value: 0
                        },
                        {
                            id: 2,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 16,
                            startLogId: 5,
                            statusType: 4,
                            name: "mainsail",
                            value: 0
                        },
                        {
                            id: 3,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 12, 54, 0)).toISOString(),
                            endLogId: 13,
                            startLogId: 5,
                            statusType: 4,
                            name: "genoa",
                            value: 0
                        }
                    ],
                    appStateUpdater: $3bc75fb8da3f6d39$export$cc63cd2b17ebe895
                }),
            "next_day": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 29, 16, 30, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 16, 30, 0)),
                    logIds: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20
                    ],
                    currentLogOptions: {
                        sog: 0,
                        course: 133,
                        distance: 23.7,
                        engineRpms: [
                            0,
                            0,
                            0
                        ]
                    },
                    includeMotionStatus: false,
                    showTomorrowDetails: true,
                    dayTomorrowData: {
                        startLocation: "Cala Palma",
                        skipper: 1,
                        crew: [
                            2,
                            3,
                            4
                        ]
                    },
                    logOverrides: {
                        18: {
                            comment: "Stopped for end of day at Cala Palma"
                        }
                    },
                    additionalStatuses: [
                        {
                            id: 4,
                            cruiseId: 1,
                            tripId: 1,
                            dayId: 1,
                            accountId: 1,
                            shipId: 1,
                            createdAt: new Date(Date.UTC(2026, 2, 29, 16, 17, 0)).toISOString(),
                            updatedAt: new Date(Date.UTC(2026, 2, 29, 16, 17, 0)).toISOString(),
                            startLogId: 18,
                            statusType: 1,
                            value: 3
                        }
                    ],
                    appStateUpdater: $3bc75fb8da3f6d39$export$cc63cd2b17ebe895
                }),
            "next_day_ready": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 30, 7, 22, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 16, 30, 0)),
                    logIds: [],
                    currentLogOptions: {
                        sog: 0,
                        course: 57,
                        distance: 0,
                        engineRpms: [
                            0,
                            0,
                            0
                        ],
                        dayId: 2
                    },
                    includeMotionStatus: false,
                    dayData: {
                        id: 2,
                        startLocation: "Cala Palma",
                        skipper: 1,
                        crew: [
                            2,
                            3,
                            4
                        ]
                    },
                    additionalStatuses: [],
                    appStateUpdater: $3bc75fb8da3f6d39$export$cc63cd2b17ebe895
                }),
            "next_day_engines": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 30, 7, 25, 30)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 16, 30, 0)),
                    logIds: [
                        21,
                        22
                    ],
                    currentLogOptions: {
                        sog: 0,
                        course: 25,
                        distance: 0,
                        engineRpms: [
                            0,
                            0,
                            0
                        ],
                        dayId: 2
                    },
                    includeMotionStatus: false,
                    dayData: {
                        id: 2,
                        startLocation: "Cala Palma",
                        skipper: 1,
                        crew: [
                            2,
                            3,
                            4
                        ]
                    },
                    logOverrides: {
                        21: {
                            dayId: 2
                        },
                        22: {
                            dayId: 2
                        }
                    },
                    additionalStatuses: [],
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                }),
            "next_day_started": ()=>renderQuickstartLogScene({
                    time: new Date(Date.UTC(2026, 2, 30, 7, 25, 0)),
                    tripStartTime: new Date(Date.UTC(2026, 2, 29, 16, 30, 0)),
                    logIds: [
                        21,
                        22,
                        23
                    ],
                    currentLogOptions: {
                        sog: 0,
                        course: 25,
                        distance: 0,
                        engineRpms: [
                            0,
                            0,
                            0
                        ],
                        dayId: 2
                    },
                    includeMotionStatus: false,
                    dayData: {
                        id: 2,
                        startLocation: "Cala Palma",
                        skipper: 1,
                        crew: [
                            2,
                            3,
                            4
                        ]
                    },
                    logOverrides: {
                        21: {
                            dayId: 2
                        },
                        22: {
                            dayId: 2
                        },
                        23: {
                            dayId: 2,
                            time: new Date(Date.UTC(2026, 2, 30, 7, 25, 0))
                        }
                    },
                    additionalStatuses: [],
                    appStateUpdater: $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c
                })
        },
        frames: frames,
        scene: scene,
        initialFrame: initialFrame,
        onClose: onClose
    });
}
function $3bc75fb8da3f6d39$var$appStateNMEANotConfigured(s) {
    var _a;
    if ((_a = s.status) === null || _a === void 0 ? void 0 : _a.nmea) {
        s.status.nmea.connected = false;
        s.status.nmea.connectionStatus = (0, $2a692caa93051c23$export$e12d1a3b018307ad).notConfigured;
    }
    return s;
}
// this are the data for the NMEA test
function $3bc75fb8da3f6d39$var$appStateNMEATestData(s) {
    var _a;
    if (s.status) {
        s.status.time = (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString();
        s.status.systemTimezone = (0, $0ffce56d54de6ef8$export$83e7587865f4b4e4);
        s.status.navigation = false;
    }
    if ((_a = s.status) === null || _a === void 0 ? void 0 : _a.nmea) {
        s.status.nmea.connected = true;
        s.status.nmea.connectionStatus = (0, $2a692caa93051c23$export$e12d1a3b018307ad).connected;
        s.status.nmea.recordingStatus = (0, $ecb722ec4ee6c8d2$export$852477b5f0e5324c).paused;
        s.status.nmea.data = Object.assign(Object.assign({}, s.status.nmea.data), {
            navigation: {
                nmeaType: "RMC",
                source: 1,
                receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                time: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                lat: 43.5,
                lng: 7.1,
                sog: 0,
                track: 180
            },
            heading: [
                {
                    nmeaType: "VTG",
                    source: 1,
                    receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                    type: "VTG",
                    courseTrue: 180,
                    courseMagnetic: 185,
                    speed: 0
                }
            ],
            depth: [
                {
                    nmeaType: "DBT",
                    source: 1,
                    receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                    type: "DBT",
                    meters: 12.5,
                    feet: 41,
                    fathoms: 6.8
                }
            ],
            wind: [
                {
                    nmeaType: "wind-relative",
                    source: 1,
                    receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                    reference: (0, $b75415c6faae2236$export$f9ee2074361b96f5).apparent,
                    priority: false,
                    relative: true,
                    angle: 45,
                    speed: 8.5
                }
            ],
            engine: [
                {
                    nmeaType: "RPM",
                    source: 1,
                    receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                    number: 1,
                    rpm: 0
                },
                {
                    nmeaType: "RPM",
                    source: 1,
                    receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                    number: 2,
                    rpm: 0
                }
            ]
        });
    }
    return s;
}
// NMEA started with engine data for the demo
// Engines show as running with RPM from NMEA, not manual buttons
function $3bc75fb8da3f6d39$var$appStateNMEAStarted(s) {
    return $3bc75fb8da3f6d39$export$67dd33a8de5be2f1(s, (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d));
}
function $3bc75fb8da3f6d39$export$67dd33a8de5be2f1(s, time) {
    var _a;
    if (s.status) {
        s.status.time = time.toISOString();
        s.status.systemTimezone = (0, $0ffce56d54de6ef8$export$83e7587865f4b4e4);
        s.status.navigation = true;
    }
    if ((_a = s.status) === null || _a === void 0 ? void 0 : _a.nmea) {
        s.status.nmea.connected = true;
        s.status.nmea.connectionStatus = (0, $2a692caa93051c23$export$e12d1a3b018307ad).connected;
        s.status.nmea.recordingStatus = (0, $ecb722ec4ee6c8d2$export$852477b5f0e5324c).paused;
        s.status.nmea.data = {
            navigation: {
                nmeaType: "RMC",
                source: 1,
                receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                time: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                lat: 0,
                lng: 0,
                sog: 0,
                track: 0
            },
            heading: [
                {
                    nmeaType: "VTG",
                    source: 1,
                    receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                    type: "VTG",
                    courseTrue: 180,
                    courseMagnetic: 185,
                    speed: 0
                }
            ],
            depth: [
                {
                    nmeaType: "DBT",
                    source: 1,
                    receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                    type: "DBT",
                    meters: 12.5,
                    feet: 41,
                    fathoms: 6.8
                }
            ],
            wind: [
                {
                    nmeaType: "wind-relative",
                    source: 1,
                    receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                    reference: (0, $b75415c6faae2236$export$f9ee2074361b96f5).apparent,
                    priority: false,
                    angle: 310,
                    relative: true,
                    speed: 15.5
                }
            ],
            weather: {
                nmeaType: "MDA",
                source: 1,
                receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                priority: false,
                pressure: 1013.5,
                temperature: 25,
                humidity: 0
            },
            engine: [
                {
                    nmeaType: "RPM",
                    source: 1,
                    receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                    number: 1,
                    rpm: 850
                },
                {
                    nmeaType: "RPM",
                    source: 1,
                    receivedAt: (0, $0ffce56d54de6ef8$export$ed6db8ac961f262d).toISOString(),
                    number: 2,
                    rpm: 850
                }
            ]
        };
    }
    return s;
}
function $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c(s, time) {
    var _a;
    s = $3bc75fb8da3f6d39$export$67dd33a8de5be2f1(s, time);
    if ((_a = s.status) === null || _a === void 0 ? void 0 : _a.nmea) s.status.nmea.recordingStatus = (0, $ecb722ec4ee6c8d2$export$852477b5f0e5324c).recording;
    // Keep demo logs inside the editable window without faking the clock: the
    // real `Time.timeUtc()` still runs, but `forceLogEditable` bypasses the
    // 1-hour recency check so recording scenes render an editable current log.
    s.forceLogEditable = true;
    return s;
}
function $3bc75fb8da3f6d39$export$555d361aaac220dd(s, time) {
    var _a, _b;
    s = $3bc75fb8da3f6d39$export$5d950e2b79d6fe4c(s, time);
    // Remove engine NMEA data to allow manual engine entry
    if ((_b = (_a = s.status) === null || _a === void 0 ? void 0 : _a.nmea) === null || _b === void 0 ? void 0 : _b.data) delete s.status.nmea.data.engine;
    return s;
}
function $3bc75fb8da3f6d39$export$cc63cd2b17ebe895(s, time) {
    var _a;
    s = $3bc75fb8da3f6d39$export$67dd33a8de5be2f1(s, time);
    if ((_a = s.status) === null || _a === void 0 ? void 0 : _a.nmea) s.status.nmea.recordingStatus = (0, $ecb722ec4ee6c8d2$export$852477b5f0e5324c).stopped;
    // Keep demo logs editable without faking the clock (see appStateNMEARecording).
    s.forceLogEditable = true;
    return s;
}


const $e16b5455f7ee4799$export$ceed233fe8a22535 = [
    {
        animations: [
            "auto-show-overlay"
        ],
        content: "start",
        contentOptions: {
            theme: "dark"
        },
        name: "start1",
        overlayPosition: "hide"
    },
    {
        content: "start",
        name: "start2",
        overlayPosition: "center"
    },
    {
        content: "timeline",
        name: "timelineOverview",
        overlayPosition: "center-right"
    },
    {
        animations: [
            "scroll-up-down"
        ],
        content: "timeline",
        name: "timelineYears",
        overlayPosition: "center-right"
    },
    {
        animations: [
            "scroll-up-down"
        ],
        content: "timeline",
        name: "timelineYears2",
        overlayPosition: "center-right"
    },
    {
        animations: [
            "show-pointer",
            "scroll-to-highlight"
        ],
        content: "timeline",
        highlight: ".CruiseCalendarView-year.year-2024 .CruiseCalendarView-month.month-6 .marker",
        name: "timelineYears3",
        overlayPosition: "center-right"
    },
    {
        animations: [
            "show-pointer"
        ],
        content: "timeline",
        highlight: ".CruiseCalendarView-year.year-2024 .CruiseCalendarView-month.month-4",
        name: "timelineYears4",
        overlayPosition: "center-right"
    },
    {
        action: {
            action: "click",
            selector: ".CruiseCalendarView-cruise[data-cruise-id='9']"
        },
        animations: [
            "show-action-click",
            "scroll-to-highlight"
        ],
        content: "timeline",
        highlight: ".CruiseCalendarView-cruise[data-cruise-id='9']",
        name: "timelineVoyageClick",
        overlayPosition: "center-right"
    },
    {
        animations: [
            "scroll-to-top"
        ],
        highlight: ".CruiseView-title",
        content: "cruise",
        name: "timelineVoyage1",
        overlayPosition: "center-right"
    },
    {
        animations: [
            "scroll-up-down"
        ],
        content: "cruise",
        name: "timelineVoyage2",
        overlayPosition: "center-right"
    },
    {
        action: {
            action: "click",
            selector: ".CruiseView .DetailsToggle"
        },
        animations: [
            "scroll-to-top",
            "show-action-click",
            "scroll-to-highlight"
        ],
        content: "cruise",
        name: "timelineVoyage3",
        overlayPosition: "center-right"
    },
    {
        content: "cruise-details",
        highlight: ".CruiseView-details .TabBar-tab:nth-child(1)",
        name: "timelineVoyage4",
        overlayPosition: "center-right"
    },
    {
        content: "cruise-details-stats",
        highlight: ".CruiseView-details .TabBar-tab:nth-child(2)",
        name: "timelineVoyage5",
        overlayPosition: "center-right"
    },
    {
        content: "cruise-details-track",
        highlight: ".CruiseView-details .TabBar-tab:nth-child(3)",
        name: "timelineVoyage6",
        overlayPosition: "center-right"
    },
    {
        animations: [
            "scroll-to-top",
            "show-pointer"
        ],
        content: "cruise-details-track",
        highlight: ".CruiseView .CloseButton",
        name: "timelineVoyage7",
        overlayPosition: "center-right"
    },
    {
        action: {
            action: "click",
            selector: ".CruiseView .DetailsToggle"
        },
        animations: [
            "scroll-to-top",
            "show-action-click"
        ],
        content: "cruise-details-track",
        name: "timelineVoyage8",
        overlayPosition: "center-right"
    },
    {
        content: "cruise",
        highlight: ".TripView-header[data-trip-id='1']",
        name: "timelineVoyage9",
        overlayPosition: "center-right"
    },
    {
        content: "cruise",
        highlight: ".TripView[data-trip-id='1']",
        name: "timelinePassage1",
        overlayPosition: "center-right"
    },
    {
        action: {
            action: "click",
            selector: ".TripView[data-trip-id='1'] .TripView-details-toggle"
        },
        animations: [
            "show-action-click"
        ],
        content: "cruise-stats",
        highlight: ".TripView-details .TabBar-tab:nth-child(2)",
        name: "timelinePassage2",
        overlayPosition: "center-right"
    },
    {
        action: {
            action: "click",
            selector: ".DayView[data-day-id='6'] .DayView-date"
        },
        animations: [
            "show-action-click"
        ],
        content: "cruise-stats",
        highlight: ".DayView[data-day-id='6']",
        name: "timelinePassage3",
        overlayPosition: "center-right"
    },
    {
        animations: [
            "scroll-highlight-top"
        ],
        content: "day",
        highlight: ".DayView[data-day-id='6'] .DayHeaderView",
        name: "timelineDay1",
        overlayPosition: "center-right"
    },
    {
        animations: [
            "show-pointer"
        ],
        content: "day",
        highlight: ".DayView[data-day-id='6'] .hour-12",
        name: "timelineDay2",
        overlayPosition: "bottom-right"
    },
    {
        action: {
            action: "click",
            selector: ".DayView[data-day-id='6'] .DetailsToggle"
        },
        animations: [
            "show-action-click"
        ],
        content: "day",
        name: "timelineDay3",
        overlayPosition: "center-right"
    },
    {
        animations: [
            "scroll-to-highlight"
        ],
        content: "day-day",
        highlight: ".DayView[data-day-id='6'] .DayView-content .TabBar-tab:nth-child(1)",
        name: "timelineDay4",
        overlayPosition: "bottom-right"
    },
    {
        content: "day-stats",
        highlight: ".DayView[data-day-id='6'] .DayView-content .TabBar-tab:nth-child(2)",
        name: "timelineDay5",
        overlayPosition: "bottom-right"
    },
    {
        content: "day-journal",
        highlight: ".DayView[data-day-id='6'] .DayView-content .TabBar-tab:nth-child(5)",
        name: "timelineDay6",
        overlayPosition: "bottom-right"
    },
    {
        action: {
            action: "click",
            selector: ".DayView[data-day-id='6'] .DetailsToggle"
        },
        animations: [
            "show-action-click"
        ],
        content: "day-journal",
        name: "timelineDay7",
        overlayPosition: "bottom-right"
    },
    {
        content: "day",
        name: "timelineLog1",
        overlayPosition: "bottom-right"
    },
    {
        animations: [
            "scroll-highlight-top-slow"
        ],
        content: "day",
        highlight: ".DayView[data-day-id='6'] .DayView-logs-log[data-log-id='23'] .LogView",
        name: "timelineLog2",
        overlayPosition: "bottom-right"
    },
    {
        action: {
            action: "click",
            selector: ".DayView[data-day-id='6'] .DayView-logs-log[data-log-id='23']"
        },
        animations: [
            "show-action-click"
        ],
        content: "day",
        highlight: ".DayView[data-day-id='6'] .DayView-logs-log[data-log-id='23']  .LogView",
        name: "timelineLog3",
        overlayPosition: "bottom-right"
    },
    {
        animations: [
            "scroll-to-highlight"
        ],
        content: "log-navigation",
        highlight: ".DayView[data-day-id='6'] .DayView-logs-log[data-log-id='23'] .LogView-container .TabBar .TabBar-tabs .TabBar-tab:nth-child(1)",
        name: "timelineLog4",
        overlayPosition: "bottom-right"
    },
    {
        content: "log-environment",
        highlight: ".DayView[data-day-id='6'] .DayView-logs-log[data-log-id='23'] .LogView-container .TabBar .TabBar-tabs .TabBar-tab:nth-child(2)",
        name: "timelineLog5",
        overlayPosition: "bottom-right"
    },
    {
        animations: [
            "fade-out-content"
        ],
        content: "day",
        name: "final1",
        overlayPosition: "center"
    },
    // End screen with buttons to other screencasts
    {
        animations: [
            "fade-in-content"
        ],
        content: "end",
        name: "final2",
        overlayPosition: "bottom-center"
    }
];
function $e16b5455f7ee4799$export$d4aa38fbc46f26b9({ onClose: onClose }) {
    return (0, $7b02d682eb115277$exports.jsx)((0, $3bc75fb8da3f6d39$export$1799cf72e94b8ac), {
        onClose: onClose,
        frames: $e16b5455f7ee4799$export$ceed233fe8a22535
    });
}




const $95a2dee6b4c50110$export$1e096f5ff8d9c4c6 = [
    {
        animations: [
            "auto-show-overlay"
        ],
        content: "start_quickstart",
        contentOptions: {
            theme: "dark"
        },
        name: "start",
        overlayPosition: "hide"
    },
    {
        content: "start_quickstart",
        name: "start",
        overlayPosition: "center"
    },
    {
        content: "start_quickstart",
        contentOptions: {
            theme: "cloud"
        },
        name: "start1",
        overlayPosition: "center"
    },
    {
        content: "start_account",
        contentOptions: {
            theme: "cloud"
        },
        name: "start2",
        overlayPosition: "center"
    },
    {
        content: "start_account",
        name: "start3",
        overlayPosition: "center"
    },
    {
        content: "create_ship",
        contentOptions: {
            theme: "cloud"
        },
        name: "createShip",
        overlayPosition: "bottom-center"
    },
    {
        content: "create_ship_complete",
        name: "createShip2",
        overlayPosition: "bottom-center"
    },
    {
        action: {
            action: "click",
            selector: "a[href^=\"logbook://\"]"
        },
        animations: [
            "show-action-click"
        ],
        content: "new_ship_selected",
        name: "createShip3",
        overlayPosition: "bottom-center"
    },
    {
        content: "new_ship_app",
        contentOptions: {
            theme: "dark"
        },
        name: "createShip4",
        overlayPosition: "bottom-center"
    },
    {
        content: "new_ship_app",
        name: "connectNMEA",
        overlayPosition: "bottom-center"
    },
    {
        content: "new_ship_app",
        name: "connectNMEA2",
        overlayPosition: "bottom-center"
    },
    {
        content: "new_ship_nmea_empty",
        highlight: ".ShipView-menus .Menu-button:has(.ShipView-status-error)",
        name: "connectNMEA3",
        overlayPosition: "bottom-left"
    },
    {
        content: "new_ship_nmea_select",
        name: "connectNMEA4",
        overlayPosition: "bottom-left"
    },
    {
        content: "new_ship_nmea",
        name: "connectNMEA5",
        overlayPosition: "bottom-left"
    },
    {
        action: {
            action: "click",
            selector: ".NMEAConfigurationView button.button.default[type=\"submit\"]"
        },
        animations: [
            "show-action-click"
        ],
        content: "new_ship_nmea",
        name: "connectNMEA6",
        overlayPosition: "bottom-left"
    },
    {
        content: "new_ship_nmea_test",
        name: "connectNMEA7",
        overlayPosition: "bottom-left"
    },
    {
        action: {
            action: "click",
            selector: ".NMEAConfigurationView button.button.default:not([type=\"submit\"])"
        },
        animations: [
            "show-action-click"
        ],
        content: "new_ship_nmea_test",
        name: "connectNMEA8",
        overlayPosition: "bottom-left"
    },
    {
        content: "new_ship_ready",
        name: "connectNMEA9",
        overlayPosition: "bottom-center"
    },
    // End screen with buttons to other screencasts
    {
        animations: [
            "fade-in-content"
        ],
        content: "end",
        name: "final2",
        overlayPosition: "bottom-center"
    }
];
function $95a2dee6b4c50110$export$b5f7a3d397f56f7c({ onClose: onClose }) {
    return (0, $7b02d682eb115277$exports.jsx)((0, $3bc75fb8da3f6d39$export$1799cf72e94b8ac), {
        onClose: onClose,
        scene: "quickstart",
        frames: $95a2dee6b4c50110$export$1e096f5ff8d9c4c6
    });
}




const $54b1ad532779bce8$export$f951c9108061c882 = [
    {
        animations: [
            "auto-show-overlay"
        ],
        content: "start_quickstart_voyage",
        contentOptions: {
            theme: "dark"
        },
        name: "startVoyage",
        overlayPosition: "hide"
    },
    {
        content: "start_quickstart_voyage",
        name: "startVoyage",
        overlayPosition: "center"
    },
    {
        action: {
            action: "click",
            selector: ".ShipView-menus > button:has(.LogbookIcon), button.focus"
        },
        animations: [
            "show-action-click"
        ],
        content: "new_ship_ready",
        name: "startPassage",
        overlayPosition: "bottom-center"
    },
    {
        content: "focus_start",
        highlight: ".CruiseView-title span.title, .TripView-title",
        name: "startPassage2",
        overlayPosition: "top-right"
    },
    {
        content: "focus_start",
        name: "startPassage3",
        overlayPosition: "top-right",
        highlight: ".TripEditView .block_field_small_10"
    },
    {
        action: {
            action: "click",
            selector: ".TripEditView button.start-trip"
        },
        animations: [
            "show-action-click"
        ],
        content: "trip_name",
        name: "startPassage4",
        overlayPosition: "top-right"
    },
    {
        animations: [
            "scroll-to-logrow",
            "show-pointer"
        ],
        content: "day_started",
        highlight: ".LogView-current-entry",
        name: "startPassage5",
        overlayPosition: "top-right"
    },
    {
        action: {
            action: "click",
            selector: ".crew-select .Select > .button"
        },
        animations: [
            "scroll-to-logrow",
            "show-action-click"
        ],
        content: "day_data",
        name: "dayData",
        overlayPosition: "top-right"
    },
    {
        animations: [
            "scroll-to-top"
        ],
        content: "day_data2",
        name: "dayData2",
        overlayPosition: "bottom-right"
    },
    {
        animations: [
            "scroll-to-logrow"
        ],
        content: "engine1_on",
        highlight: "[data-log-id=\"1\"]",
        name: "engine1",
        overlayPosition: "top-center"
    },
    {
        content: "engine2_on",
        highlight: "[data-log-id=\"2\"]",
        name: "engine2",
        overlayPosition: "top-center"
    },
    {
        animations: [
            "scroll-to-logrow"
        ],
        content: "started",
        highlight: ".DayView-logs-log:has(.LogView-current-entry) .status-button",
        name: "departing",
        overlayPosition: "top-center"
    },
    {
        animations: [
            "scroll-to-logrow",
            "show-pointer-up"
        ],
        content: "started",
        highlight: ".ShipView-menus .Menu-button:has(.ShipView-status-ok)",
        name: "departing2",
        overlayPosition: "top-center"
    },
    {
        animations: [
            "scroll-to-logrow"
        ],
        content: "entry_30min",
        highlight: "[data-log-id=\"4\"]",
        name: "logEntries2",
        overlayPosition: "top-center"
    },
    {
        animations: [
            "scroll-to-logrow"
        ],
        content: "manualEntry_scene",
        highlight: ".DayView-logs-log:has(.LogView-current-entry) .LogButton",
        name: "manualEntry",
        overlayPosition: "top-center"
    },
    {
        action: {
            action: "click",
            selector: ".DayView-logs-log:has(.LogView-current-entry) .LogButton .Menu-button"
        },
        animations: [
            "scroll-to-logrow",
            "show-action-click"
        ],
        content: "manualEntry_scene",
        name: "manualEntry1a",
        overlayPosition: "top-center"
    },
    {
        content: "manualEntry_scene",
        highlight: ".LogButton .Menu-items",
        name: "manualEntry1b",
        overlayPosition: "top-center"
    },
    {
        action: {
            action: "click",
            selector: ".LogButton-sails-block .LogButton-sail-container:first-child .LogButton-sail-btn"
        },
        animations: [
            "keep-on-nextday",
            "show-action-click-once"
        ],
        content: "manualEntry_scene",
        name: "sail_entry1",
        overlayPosition: "top-center"
    },
    {
        animations: [
            "keep-on-nextday"
        ],
        content: "manualEntry_scene",
        highlight: ".LogButton-sail-confirm",
        name: "selectSail2",
        overlayPosition: "top-center"
    },
    {
        content: "sail_entry2",
        highlight: ".LogButton-sail-confirm",
        name: "sail_entry3",
        overlayPosition: "top-center"
    },
    {
        content: "entries_engines_off",
        name: "logEntries3",
        overlayPosition: "top-center"
    },
    {
        action: {
            action: "click",
            selector: "[data-log-id=\"7\"]"
        },
        animations: [
            "scroll-to-nextday",
            "show-action-click"
        ],
        content: "entries_engines_off",
        highlight: "[data-log-id=\"7\"]",
        name: "logEntries4",
        overlayPosition: "top-center"
    },
    {
        content: "entry_additional_data",
        name: "logEntries5",
        overlayPosition: "top-center"
    },
    {
        content: "entry_additional_data2",
        name: "logEntries6",
        overlayPosition: "top-center"
    },
    {
        content: "course_change",
        name: "logEntries7",
        highlight: "[data-log-id=\"8\"]",
        overlayPosition: "top-center"
    },
    {
        content: "manual_engine_entry",
        highlight: ".DayView-logs-log:has(.LogView-current-entry) .engine-icons",
        name: "manualEntry3",
        overlayPosition: "top-center"
    },
    {
        content: "manual_engine_entry",
        name: "manualEntry4",
        overlayPosition: "top-center"
    },
    {
        animations: [
            "scroll-to-nextday"
        ],
        content: "sailing",
        name: "logEntries8",
        overlayPosition: "top-center"
    },
    {
        animations: [
            "show-pointer"
        ],
        content: "pause",
        highlight: ".DayView-logs-log:has(.LogView-current-entry) .LogView-header",
        name: "endDay",
        overlayPosition: "top-center"
    },
    {
        content: "pause_dialog",
        name: "endDay2",
        overlayPosition: "bottom-center"
    },
    {
        action: {
            action: "click",
            selector: ".UserAdviceStopView button.default[type=\"submit\"]"
        },
        animations: [
            "show-action-click"
        ],
        content: "pause_set",
        name: "endDay3",
        overlayPosition: "bottom-center"
    },
    {
        content: "pause_fixed",
        highlight: "[data-log-id='18'] .status-button",
        name: "endDay4",
        overlayPosition: "top-center"
    },
    {
        content: "pause_fixed2",
        name: "endDay5",
        overlayPosition: "top-center"
    },
    {
        content: "engines_off",
        name: "endDay6",
        overlayPosition: "top-center"
    },
    {
        content: "engines_off",
        name: "endDay7",
        overlayPosition: "top-center"
    },
    {
        animations: [
            "scroll-to-nextday"
        ],
        content: "next_day",
        name: "nextDay",
        overlayPosition: "top-center"
    },
    {
        content: "next_day_ready",
        name: "nextDay2",
        overlayPosition: "top-right"
    },
    {
        content: "next_day_engines",
        name: "nextDay3",
        overlayPosition: "top-center"
    },
    {
        content: "next_day_started",
        name: "nextDay4",
        overlayPosition: "top-center"
    },
    // End screen with buttons to other screencasts
    {
        animations: [
            "fade-in-content"
        ],
        content: "end",
        name: "final2",
        overlayPosition: "bottom-center"
    }
];
function $54b1ad532779bce8$export$614d75da91cd95d0({ onClose: onClose }) {
    return (0, $7b02d682eb115277$exports.jsx)((0, $3bc75fb8da3f6d39$export$1799cf72e94b8ac), {
        onClose: onClose,
        scene: "quickstart-voyage",
        frames: $54b1ad532779bce8$export$f951c9108061c882
    });
}


var $6f69f4dcc7c84750$var$DemoScenes;
(function(DemoScenes) {
    DemoScenes["concept"] = "concept";
    DemoScenes["quickstart"] = "quickstart";
    DemoScenes["quickstartVoyage"] = "quickstart-voyage";
})($6f69f4dcc7c84750$var$DemoScenes || ($6f69f4dcc7c84750$var$DemoScenes = {}));
const $6f69f4dcc7c84750$export$122994dc05ba4308 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $6f69f4dcc7c84750$export$56752c5ff04def75 = ()=>(0, $acw62.useContext)($6f69f4dcc7c84750$export$122994dc05ba4308);
function $6f69f4dcc7c84750$export$8cb24abd226a6868({ language: language, initialScene: initialScene }) {
    const [scene, setScene] = (0, $acw62.useState)(initialScene || $6f69f4dcc7c84750$var$DemoScenes.concept);
    const app = {
        language: language,
        scene: scene
    };
    const close = (0, $acw62.useCallback)(()=>{
        setScene("");
    }, []);
    let sceneView = null;
    switch(scene){
        case $6f69f4dcc7c84750$var$DemoScenes.concept:
            sceneView = (0, $7b02d682eb115277$exports.jsx)((0, $e16b5455f7ee4799$export$d4aa38fbc46f26b9), {
                onClose: close
            });
            break;
        case $6f69f4dcc7c84750$var$DemoScenes.quickstart:
            sceneView = (0, $7b02d682eb115277$exports.jsx)((0, $95a2dee6b4c50110$export$b5f7a3d397f56f7c), {
                onClose: close
            });
            break;
        case $6f69f4dcc7c84750$var$DemoScenes.quickstartVoyage:
            sceneView = (0, $7b02d682eb115277$exports.jsx)((0, $54b1ad532779bce8$export$614d75da91cd95d0), {
                onClose: close
            });
            break;
        default:
            sceneView = (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    "Scene not found: ",
                    scene
                ]
            });
            break;
    }
    return (0, $7b02d682eb115277$exports.jsx)($6f69f4dcc7c84750$export$122994dc05ba4308.Provider, {
        value: app,
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "DemoApp",
            children: sceneView
        })
    });
}
function $6f69f4dcc7c84750$export$5781ccfc15674bbd(root, language = "en", scene) {
    root.render((0, $7b02d682eb115277$exports.jsx)($6f69f4dcc7c84750$export$8cb24abd226a6868, {
        language: language,
        initialScene: scene
    }));
}


// Pure resolution of the demo launch parameters (initial scene + language) from
// the request URL. Extracted from demo.ts so the URL -> scene mapping can be
// unit-tested without the bootstrap's DOM side effects (see
// Tests/PublicTests/README.md). `demo.ts` passes `window.location` here.
const $afe833bdb9038eee$export$419d76ec9d970f3c = {
    // Initial scene = the last real path segment, ignoring any leading/trailing
    // slashes so a trailing "/" never changes the result. The bare demo base
    // ("/demo", "/demo/") and the site root fall back to the default "concept"
    // scene (the server mounts the demo at "demo/:demo", so "demo" is the base,
    // not a scene). For local development with simple static servers, also
    // supports a `scene` query parameter (e.g., `?scene=quickstart-voyage`).
    scene (pathname, search) {
        // Check query parameter first (for local static server development)
        const sceneParam = new URLSearchParams(search).get("scene");
        if (sceneParam) return sceneParam;
        // Fall back to pathname-based routing
        const segments = pathname.split("/").filter(Boolean);
        const last = segments[segments.length - 1];
        return !last || last === "demo" ? "concept" : last;
    },
    // Language from the `lang` query parameter, defaulting to English.
    language (search) {
        return new URLSearchParams(search).get("lang") || "en";
    },
    resolve (request) {
        return {
            language: $afe833bdb9038eee$export$419d76ec9d970f3c.language(request.search),
            scene: $afe833bdb9038eee$export$419d76ec9d970f3c.scene(request.pathname, request.search)
        };
    }
};



(0, $16b96ad8b17ffac4$export$c85e7476b28a68d3)();
document.documentElement.setAttribute("data-theme", "dark");
const $531beb1b69c1a5a8$var$root = document.getElementById("root");
const { language: $531beb1b69c1a5a8$var$language, scene: $531beb1b69c1a5a8$var$scene } = (0, $afe833bdb9038eee$export$419d76ec9d970f3c).resolve(window.location);
(0, $6f69f4dcc7c84750$export$5781ccfc15674bbd)((0, $7e96a608cb33bf79$exports.createRoot)($531beb1b69c1a5a8$var$root), $531beb1b69c1a5a8$var$language, $531beb1b69c1a5a8$var$scene);


//# sourceMappingURL=demo.1a40c9d8.js.map
